var havana = [
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 65419,
      stop : 71585,
      direction : "+",
      ID : "ENSG00000186092.6",
      gene_id : "ENSG00000186092.6",
      gene_type : "protein_coding",
      gene_name : "OR4F5",
      gene_level : 2,
      hgnc_id : "HGNC:14825",
      havana_gene : "OTTHUMG00000001094.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 450740,
      stop : 451678,
      direction : "-",
      ID : "ENSG00000284733.2",
      gene_id : "ENSG00000284733.2",
      gene_type : "protein_coding",
      gene_name : "OR4F29",
      gene_level : 2,
      hgnc_id : "HGNC:31275",
      havana_gene : "OTTHUMG00000002860.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 685679,
      stop : 686673,
      direction : "-",
      ID : "ENSG00000284662.1",
      gene_id : "ENSG00000284662.1",
      gene_type : "protein_coding",
      gene_name : "OR4F16",
      gene_level : 2,
      hgnc_id : "HGNC:15079",
      havana_gene : "OTTHUMG00000002581.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 923923,
      stop : 944575,
      direction : "+",
      ID : "ENSG00000187634.13",
      gene_id : "ENSG00000187634.13",
      gene_type : "protein_coding",
      gene_name : "SAMD11",
      gene_level : 2,
      hgnc_id : "HGNC:28706",
      havana_gene : "OTTHUMG00000040719.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 944203,
      stop : 959309,
      direction : "-",
      ID : "ENSG00000188976.11",
      gene_id : "ENSG00000188976.11",
      gene_type : "protein_coding",
      gene_name : "NOC2L",
      gene_level : 2,
      hgnc_id : "HGNC:24517",
      havana_gene : "OTTHUMG00000040720.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 960584,
      stop : 965719,
      direction : "+",
      ID : "ENSG00000187961.14",
      gene_id : "ENSG00000187961.14",
      gene_type : "protein_coding",
      gene_name : "KLHL17",
      gene_level : 2,
      hgnc_id : "HGNC:24023",
      havana_gene : "OTTHUMG00000040721.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 966482,
      stop : 975865,
      direction : "+",
      ID : "ENSG00000187583.11",
      gene_id : "ENSG00000187583.11",
      gene_type : "protein_coding",
      gene_name : "PLEKHN1",
      gene_level : 2,
      hgnc_id : "HGNC:25284",
      havana_gene : "OTTHUMG00000040756.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 975204,
      stop : 982093,
      direction : "-",
      ID : "ENSG00000187642.9",
      gene_id : "ENSG00000187642.9",
      gene_type : "protein_coding",
      gene_name : "PERM1",
      gene_level : 2,
      hgnc_id : "HGNC:28208",
      havana_gene : "OTTHUMG00000040757.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 998962,
      stop : 1000172,
      direction : "-",
      ID : "ENSG00000188290.11",
      gene_id : "ENSG00000188290.11",
      gene_type : "protein_coding",
      gene_name : "HES4",
      gene_level : 2,
      hgnc_id : "HGNC:24149",
      havana_gene : "OTTHUMG00000040758.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1001138,
      stop : 1014540,
      direction : "+",
      ID : "ENSG00000187608.10",
      gene_id : "ENSG00000187608.10",
      gene_type : "protein_coding",
      gene_name : "ISG15",
      gene_level : 2,
      hgnc_id : "HGNC:4053",
      havana_gene : "OTTHUMG00000040777.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1020120,
      stop : 1056118,
      direction : "+",
      ID : "ENSG00000188157.15",
      gene_id : "ENSG00000188157.15",
      gene_type : "protein_coding",
      gene_name : "AGRN",
      gene_level : 2,
      hgnc_id : "HGNC:329",
      havana_gene : "OTTHUMG00000040778.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1070967,
      stop : 1074306,
      direction : "-",
      ID : "ENSG00000237330.3",
      gene_id : "ENSG00000237330.3",
      gene_type : "protein_coding",
      gene_name : "RNF223",
      gene_level : 2,
      hgnc_id : "HGNC:40020",
      havana_gene : "OTTHUMG00000185582.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1081818,
      stop : 1116361,
      direction : "-",
      ID : "ENSG00000131591.18",
      gene_id : "ENSG00000131591.18",
      gene_type : "protein_coding",
      gene_name : "C1orf159",
      gene_level : 2,
      hgnc_id : "HGNC:26062",
      havana_gene : "OTTHUMG00000000745.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1173880,
      stop : 1197936,
      direction : "+",
      ID : "ENSG00000162571.14",
      gene_id : "ENSG00000162571.14",
      gene_type : "protein_coding",
      gene_name : "TTLL10",
      gene_level : 2,
      hgnc_id : "HGNC:26693",
      havana_gene : "OTTHUMG00000000851.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1203508,
      stop : 1206592,
      direction : "-",
      ID : "ENSG00000186891.14",
      gene_id : "ENSG00000186891.14",
      gene_type : "protein_coding",
      gene_name : "TNFRSF18",
      gene_level : 2,
      hgnc_id : "HGNC:11914",
      havana_gene : "OTTHUMG00000001414.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1211340,
      stop : 1214153,
      direction : "-",
      ID : "ENSG00000186827.11",
      gene_id : "ENSG00000186827.11",
      gene_type : "protein_coding",
      gene_name : "TNFRSF4",
      gene_level : 2,
      hgnc_id : "HGNC:11918",
      havana_gene : "OTTHUMG00000001415.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1216909,
      stop : 1232067,
      direction : "-",
      ID : "ENSG00000078808.19",
      gene_id : "ENSG00000078808.19",
      gene_type : "protein_coding",
      gene_name : "SDF4",
      gene_level : 2,
      hgnc_id : "HGNC:24188",
      havana_gene : "OTTHUMG00000001812.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1232237,
      stop : 1235041,
      direction : "+",
      ID : "ENSG00000176022.7",
      gene_id : "ENSG00000176022.7",
      gene_type : "protein_coding",
      gene_name : "B3GALT6",
      gene_level : 2,
      hgnc_id : "HGNC:17978",
      havana_gene : "OTTHUMG00000001813.3",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1242446,
      stop : 1246722,
      direction : "-",
      ID : "ENSG00000184163.3",
      gene_id : "ENSG00000184163.3",
      gene_type : "protein_coding",
      gene_name : "C1QTNF12",
      gene_level : 2,
      hgnc_id : "HGNC:32308",
      havana_gene : "OTTHUMG00000001412.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1253909,
      stop : 1273864,
      direction : "-",
      ID : "ENSG00000160087.21",
      gene_id : "ENSG00000160087.21",
      gene_type : "protein_coding",
      gene_name : "UBE2J2",
      gene_level : 2,
      hgnc_id : "HGNC:19268",
      havana_gene : "OTTHUMG00000001911.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1280436,
      stop : 1292029,
      direction : "+",
      ID : "ENSG00000162572.21",
      gene_id : "ENSG00000162572.21",
      gene_type : "protein_coding",
      gene_name : "SCNN1D",
      gene_level : 2,
      hgnc_id : "HGNC:10601",
      havana_gene : "OTTHUMG00000002081.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1292390,
      stop : 1309609,
      direction : "-",
      ID : "ENSG00000131584.19",
      gene_id : "ENSG00000131584.19",
      gene_type : "protein_coding",
      gene_name : "ACAP3",
      gene_level : 2,
      hgnc_id : "HGNC:16754",
      havana_gene : "OTTHUMG00000002235.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1308597,
      stop : 1311677,
      direction : "+",
      ID : "ENSG00000169972.12",
      gene_id : "ENSG00000169972.12",
      gene_type : "protein_coding",
      gene_name : "PUSL1",
      gene_level : 2,
      hgnc_id : "HGNC:26914",
      havana_gene : "OTTHUMG00000003361.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1311585,
      stop : 1324687,
      direction : "-",
      ID : "ENSG00000127054.21",
      gene_id : "ENSG00000127054.21",
      gene_type : "protein_coding",
      gene_name : "INTS11",
      gene_level : 1,
      hgnc_id : "HGNC:26052",
      havana_gene : "OTTHUMG00000003330.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1324756,
      stop : 1328896,
      direction : "+",
      ID : "ENSG00000224051.7",
      gene_id : "ENSG00000224051.7",
      gene_type : "protein_coding",
      gene_name : "CPTP",
      gene_level : 2,
      hgnc_id : "HGNC:28116",
      havana_gene : "OTTHUMG00000003171.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1331280,
      stop : 1335314,
      direction : "+",
      ID : "ENSG00000169962.5",
      gene_id : "ENSG00000169962.5",
      gene_type : "protein_coding",
      gene_name : "TAS1R3",
      gene_level : 2,
      hgnc_id : "HGNC:15661",
      havana_gene : "OTTHUMG00000003071.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1335276,
      stop : 1349418,
      direction : "-",
      ID : "ENSG00000107404.20",
      gene_id : "ENSG00000107404.20",
      gene_type : "protein_coding",
      gene_name : "DVL1",
      gene_level : 2,
      hgnc_id : "HGNC:3084",
      havana_gene : "OTTHUMG00000003069.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1352689,
      stop : 1361777,
      direction : "-",
      ID : "ENSG00000162576.17",
      gene_id : "ENSG00000162576.17",
      gene_type : "protein_coding",
      gene_name : "MXRA8",
      gene_level : 2,
      hgnc_id : "HGNC:7542",
      havana_gene : "OTTHUMG00000002973.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1373730,
      stop : 1375495,
      direction : "-",
      ID : "ENSG00000175756.13",
      gene_id : "ENSG00000175756.13",
      gene_type : "protein_coding",
      gene_name : "AURKAIP1",
      gene_level : 2,
      hgnc_id : "HGNC:24114",
      havana_gene : "OTTHUMG00000001413.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1385711,
      stop : 1399335,
      direction : "-",
      ID : "ENSG00000221978.12",
      gene_id : "ENSG00000221978.12",
      gene_type : "protein_coding",
      gene_name : "CCNL2",
      gene_level : 2,
      hgnc_id : "HGNC:20570",
      havana_gene : "OTTHUMG00000002917.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1401909,
      stop : 1407293,
      direction : "-",
      ID : "ENSG00000242485.6",
      gene_id : "ENSG00000242485.6",
      gene_type : "protein_coding",
      gene_name : "MRPL20",
      gene_level : 1,
      hgnc_id : "HGNC:14478",
      havana_gene : "OTTHUMG00000002916.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1418420,
      stop : 1421769,
      direction : "-",
      ID : "ENSG00000235098.9",
      gene_id : "ENSG00000235098.9",
      gene_type : "protein_coding",
      gene_name : "ANKRD65",
      gene_level : 1,
      hgnc_id : "HGNC:42950",
      havana_gene : "OTTHUMG00000002911.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1426128,
      stop : 1427787,
      direction : "+",
      ID : "ENSG00000205116.3",
      gene_id : "ENSG00000205116.3",
      gene_type : "protein_coding",
      gene_name : "TMEM88B",
      gene_level : 2,
      hgnc_id : "HGNC:37099",
      havana_gene : "OTTHUMG00000153395.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1434861,
      stop : 1442882,
      direction : "+",
      ID : "ENSG00000179403.12",
      gene_id : "ENSG00000179403.12",
      gene_type : "protein_coding",
      gene_name : "VWA1",
      gene_level : 1,
      hgnc_id : "HGNC:30910",
      havana_gene : "OTTHUMG00000002975.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1449689,
      stop : 1470163,
      direction : "+",
      ID : "ENSG00000215915.10",
      gene_id : "ENSG00000215915.10",
      gene_type : "protein_coding",
      gene_name : "ATAD3C",
      gene_level : 2,
      hgnc_id : "HGNC:32151",
      havana_gene : "OTTHUMG00000000531.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1471765,
      stop : 1497848,
      direction : "+",
      ID : "ENSG00000160072.20",
      gene_id : "ENSG00000160072.20",
      gene_type : "protein_coding",
      gene_name : "ATAD3B",
      gene_level : 2,
      hgnc_id : "HGNC:24007",
      havana_gene : "OTTHUMG00000000577.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1512162,
      stop : 1534685,
      direction : "+",
      ID : "ENSG00000197785.14",
      gene_id : "ENSG00000197785.14",
      gene_type : "protein_coding",
      gene_name : "ATAD3A",
      gene_level : 2,
      hgnc_id : "HGNC:25567",
      havana_gene : "OTTHUMG00000000575.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1534778,
      stop : 1540624,
      direction : "-",
      ID : "ENSG00000205090.9",
      gene_id : "ENSG00000205090.9",
      gene_type : "protein_coding",
      gene_name : "TMEM240",
      gene_level : 2,
      hgnc_id : "HGNC:25186",
      havana_gene : "OTTHUMG00000042193.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1541673,
      stop : 1574863,
      direction : "-",
      ID : "ENSG00000160075.12",
      gene_id : "ENSG00000160075.12",
      gene_type : "protein_coding",
      gene_name : "SSU72",
      gene_level : 2,
      hgnc_id : "HGNC:25016",
      havana_gene : "OTTHUMG00000000576.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1598012,
      stop : 1600135,
      direction : "-",
      ID : "ENSG00000228594.4",
      gene_id : "ENSG00000228594.4",
      gene_type : "protein_coding",
      gene_name : "FNDC10",
      gene_level : 2,
      hgnc_id : "HGNC:42951",
      havana_gene : "OTTHUMG00000154864.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1615415,
      stop : 1630610,
      direction : "+",
      ID : "ENSG00000197530.12",
      gene_id : "ENSG00000197530.12",
      gene_type : "protein_coding",
      gene_name : "MIB2",
      gene_level : 1,
      hgnc_id : "HGNC:30577",
      havana_gene : "OTTHUMG00000074647.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1632163,
      stop : 1635263,
      direction : "+",
      ID : "ENSG00000189409.14",
      gene_id : "ENSG00000189409.14",
      gene_type : "protein_coding",
      gene_name : "MMP23B",
      gene_level : 2,
      hgnc_id : "HGNC:7171",
      havana_gene : "OTTHUMG00000074713.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1635225,
      stop : 1659012,
      direction : "-",
      ID : "ENSG00000248333.9",
      gene_id : "ENSG00000248333.9",
      gene_type : "protein_coding",
      gene_name : "CDK11B",
      gene_level : 2,
      hgnc_id : "HGNC:1729",
      havana_gene : "OTTHUMG00000078638.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1659529,
      stop : 1692795,
      direction : "-",
      ID : "ENSG00000189339.12",
      gene_id : "ENSG00000189339.12",
      gene_type : "protein_coding",
      gene_name : "SLC35E2B",
      gene_level : 2,
      hgnc_id : "HGNC:33941",
      havana_gene : "OTTHUMG00000078639.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1702379,
      stop : 1724357,
      direction : "-",
      ID : "ENSG00000008128.23",
      gene_id : "ENSG00000008128.23",
      gene_type : "protein_coding",
      gene_name : "CDK11A",
      gene_level : 2,
      hgnc_id : "HGNC:1730",
      havana_gene : "OTTHUMG00000000703.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1751232,
      stop : 1780457,
      direction : "-",
      ID : "ENSG00000008130.15",
      gene_id : "ENSG00000008130.15",
      gene_type : "protein_coding",
      gene_name : "NADK",
      gene_level : 2,
      hgnc_id : "HGNC:29831",
      havana_gene : "OTTHUMG00000000942.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1785285,
      stop : 1891117,
      direction : "-",
      ID : "ENSG00000078369.18",
      gene_id : "ENSG00000078369.18",
      gene_type : "protein_coding",
      gene_name : "GNB1",
      gene_level : 1,
      hgnc_id : "HGNC:4396",
      havana_gene : "OTTHUMG00000000940.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1915108,
      stop : 1917296,
      direction : "+",
      ID : "ENSG00000169885.10",
      gene_id : "ENSG00000169885.10",
      gene_type : "protein_coding",
      gene_name : "CALML6",
      gene_level : 1,
      hgnc_id : "HGNC:24193",
      havana_gene : "OTTHUMG00000000943.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1917590,
      stop : 1919279,
      direction : "-",
      ID : "ENSG00000178821.13",
      gene_id : "ENSG00000178821.13",
      gene_type : "protein_coding",
      gene_name : "TMEM52",
      gene_level : 2,
      hgnc_id : "HGNC:27916",
      havana_gene : "OTTHUMG00000000944.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 1921951,
      stop : 2003837,
      direction : "-",
      ID : "ENSG00000142609.18",
      gene_id : "ENSG00000142609.18",
      gene_type : "protein_coding",
      gene_name : "CFAP74",
      gene_level : 1,
      hgnc_id : "HGNC:29368",
      havana_gene : "OTTHUMG00000000945.17",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2019329,
      stop : 2030758,
      direction : "+",
      ID : "ENSG00000187730.9",
      gene_id : "ENSG00000187730.9",
      gene_type : "protein_coding",
      gene_name : "GABRD",
      gene_level : 2,
      hgnc_id : "HGNC:4084",
      havana_gene : "OTTHUMG00000041064.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2050411,
      stop : 2185395,
      direction : "+",
      ID : "ENSG00000067606.17",
      gene_id : "ENSG00000067606.17",
      gene_type : "protein_coding",
      gene_name : "PRKCZ",
      gene_level : 1,
      hgnc_id : "HGNC:9412",
      havana_gene : "OTTHUMG00000001238.14",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2184461,
      stop : 2212720,
      direction : "-",
      ID : "ENSG00000162585.17",
      gene_id : "ENSG00000162585.17",
      gene_type : "protein_coding",
      gene_name : "FAAP20",
      gene_level : 2,
      hgnc_id : "HGNC:26428",
      havana_gene : "OTTHUMG00000001404.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2228319,
      stop : 2310213,
      direction : "+",
      ID : "ENSG00000157933.10",
      gene_id : "ENSG00000157933.10",
      gene_type : "protein_coding",
      gene_name : "SKI",
      gene_level : 2,
      hgnc_id : "HGNC:10896",
      havana_gene : "OTTHUMG00000001407.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2321253,
      stop : 2391707,
      direction : "-",
      ID : "ENSG00000116151.14",
      gene_id : "ENSG00000116151.14",
      gene_type : "protein_coding",
      gene_name : "MORN1",
      gene_level : 1,
      hgnc_id : "HGNC:25852",
      havana_gene : "OTTHUMG00000001402.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2391775,
      stop : 2405442,
      direction : "+",
      ID : "ENSG00000157916.20",
      gene_id : "ENSG00000157916.20",
      gene_type : "protein_coding",
      gene_name : "RER1",
      gene_level : 2,
      hgnc_id : "HGNC:30309",
      havana_gene : "OTTHUMG00000001403.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2403964,
      stop : 2413797,
      direction : "-",
      ID : "ENSG00000157911.11",
      gene_id : "ENSG00000157911.11",
      gene_type : "protein_coding",
      gene_name : "PEX10",
      gene_level : 1,
      hgnc_id : "HGNC:8851",
      havana_gene : "OTTHUMG00000001637.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2425980,
      stop : 2505532,
      direction : "+",
      ID : "ENSG00000149527.18",
      gene_id : "ENSG00000149527.18",
      gene_type : "protein_coding",
      gene_name : "PLCH2",
      gene_level : 2,
      hgnc_id : "HGNC:29037",
      havana_gene : "OTTHUMG00000000719.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2508537,
      stop : 2526597,
      direction : "-",
      ID : "ENSG00000157881.16",
      gene_id : "ENSG00000157881.16",
      gene_type : "protein_coding",
      gene_name : "PANK4",
      gene_level : 2,
      hgnc_id : "HGNC:19366",
      havana_gene : "OTTHUMG00000000791.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2528745,
      stop : 2530263,
      direction : "-",
      ID : "ENSG00000197921.6",
      gene_id : "ENSG00000197921.6",
      gene_type : "protein_coding",
      gene_name : "HES5",
      gene_level : 2,
      hgnc_id : "HGNC:19764",
      havana_gene : "OTTHUMG00000000793.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2555639,
      stop : 2565382,
      direction : "+",
      ID : "ENSG00000157873.18",
      gene_id : "ENSG00000157873.18",
      gene_type : "protein_coding",
      gene_name : "TNFRSF14",
      gene_level : 2,
      hgnc_id : "HGNC:11912",
      havana_gene : "OTTHUMG00000000792.18",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2586491,
      stop : 2591469,
      direction : "+",
      ID : "ENSG00000157870.17",
      gene_id : "ENSG00000157870.17",
      gene_type : "protein_coding",
      gene_name : "PRXL2B",
      gene_level : 2,
      hgnc_id : "HGNC:28390",
      havana_gene : "OTTHUMG00000000847.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2590639,
      stop : 2633016,
      direction : "-",
      ID : "ENSG00000142606.16",
      gene_id : "ENSG00000142606.16",
      gene_type : "protein_coding",
      gene_name : "MMEL1",
      gene_level : 2,
      hgnc_id : "HGNC:14668",
      havana_gene : "OTTHUMG00000000846.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 2635976,
      stop : 2801717,
      direction : "-",
      ID : "ENSG00000215912.12",
      gene_id : "ENSG00000215912.12",
      gene_type : "protein_coding",
      gene_name : "TTC34",
      gene_level : 2,
      hgnc_id : "HGNC:34297",
      havana_gene : "OTTHUMG00000000539.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3021467,
      stop : 3022903,
      direction : "+",
      ID : "ENSG00000169717.7",
      gene_id : "ENSG00000169717.7",
      gene_type : "protein_coding",
      gene_name : "ACTRT2",
      gene_level : 2,
      hgnc_id : "HGNC:24026",
      havana_gene : "OTTHUMG00000000562.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3069168,
      stop : 3438621,
      direction : "+",
      ID : "ENSG00000142611.17",
      gene_id : "ENSG00000142611.17",
      gene_type : "protein_coding",
      gene_name : "PRDM16",
      gene_level : 1,
      hgnc_id : "HGNC:14000",
      havana_gene : "OTTHUMG00000000581.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3454665,
      stop : 3481113,
      direction : "+",
      ID : "ENSG00000130762.15",
      gene_id : "ENSG00000130762.15",
      gene_type : "protein_coding",
      gene_name : "ARHGEF16",
      gene_level : 2,
      hgnc_id : "HGNC:15515",
      havana_gene : "OTTHUMG00000000625.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3487951,
      stop : 3611508,
      direction : "-",
      ID : "ENSG00000162591.16",
      gene_id : "ENSG00000162591.16",
      gene_type : "protein_coding",
      gene_name : "MEGF6",
      gene_level : 2,
      hgnc_id : "HGNC:3232",
      havana_gene : "OTTHUMG00000000611.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3625015,
      stop : 3630127,
      direction : "+",
      ID : "ENSG00000158109.15",
      gene_id : "ENSG00000158109.15",
      gene_type : "protein_coding",
      gene_name : "TPRG1L",
      gene_level : 2,
      hgnc_id : "HGNC:27007",
      havana_gene : "OTTHUMG00000000609.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3630767,
      stop : 3652761,
      direction : "-",
      ID : "ENSG00000116213.16",
      gene_id : "ENSG00000116213.16",
      gene_type : "protein_coding",
      gene_name : "WRAP73",
      gene_level : 1,
      hgnc_id : "HGNC:12759",
      havana_gene : "OTTHUMG00000000612.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3652516,
      stop : 3736201,
      direction : "+",
      ID : "ENSG00000078900.15",
      gene_id : "ENSG00000078900.15",
      gene_type : "protein_coding",
      gene_name : "TP73",
      gene_level : 1,
      hgnc_id : "HGNC:12003",
      havana_gene : "OTTHUMG00000000610.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3746460,
      stop : 3771645,
      direction : "+",
      ID : "ENSG00000162592.10",
      gene_id : "ENSG00000162592.10",
      gene_type : "protein_coding",
      gene_name : "CCDC27",
      gene_level : 2,
      hgnc_id : "HGNC:26546",
      havana_gene : "OTTHUMG00000003504.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3772749,
      stop : 3775982,
      direction : "+",
      ID : "ENSG00000235169.11",
      gene_id : "ENSG00000235169.11",
      gene_type : "protein_coding",
      gene_name : "SMIM1",
      gene_level : 1,
      hgnc_id : "HGNC:44204",
      havana_gene : "OTTHUMG00000003505.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3778559,
      stop : 3796498,
      direction : "-",
      ID : "ENSG00000130764.10",
      gene_id : "ENSG00000130764.10",
      gene_type : "protein_coding",
      gene_name : "LRRC47",
      gene_level : 2,
      hgnc_id : "HGNC:29207",
      havana_gene : "OTTHUMG00000003506.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3812086,
      stop : 3857396,
      direction : "-",
      ID : "ENSG00000116198.14",
      gene_id : "ENSG00000116198.14",
      gene_type : "protein_coding",
      gene_name : "CEP104",
      gene_level : 2,
      hgnc_id : "HGNC:24866",
      havana_gene : "OTTHUMG00000003507.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3857267,
      stop : 3885429,
      direction : "+",
      ID : "ENSG00000169598.17",
      gene_id : "ENSG00000169598.17",
      gene_type : "protein_coding",
      gene_name : "DFFB",
      gene_level : 2,
      hgnc_id : "HGNC:2773",
      havana_gene : "OTTHUMG00000003525.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 3889125,
      stop : 3900293,
      direction : "-",
      ID : "ENSG00000198912.12",
      gene_id : "ENSG00000198912.12",
      gene_type : "protein_coding",
      gene_name : "C1orf174",
      gene_level : 2,
      hgnc_id : "HGNC:27915",
      havana_gene : "OTTHUMG00000003739.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 4654609,
      stop : 4792534,
      direction : "+",
      ID : "ENSG00000196581.11",
      gene_id : "ENSG00000196581.11",
      gene_type : "protein_coding",
      gene_name : "AJAP1",
      gene_level : 2,
      hgnc_id : "HGNC:30801",
      havana_gene : "OTTHUMG00000000645.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 5862811,
      stop : 5992473,
      direction : "-",
      ID : "ENSG00000131697.18",
      gene_id : "ENSG00000131697.18",
      gene_type : "protein_coding",
      gene_name : "NPHP4",
      gene_level : 2,
      hgnc_id : "HGNC:19104",
      havana_gene : "OTTHUMG00000000701.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 5990927,
      stop : 6101193,
      direction : "+",
      ID : "ENSG00000069424.15",
      gene_id : "ENSG00000069424.15",
      gene_type : "protein_coding",
      gene_name : "KCNAB2",
      gene_level : 2,
      hgnc_id : "HGNC:6229",
      havana_gene : "OTTHUMG00000000795.17",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6101787,
      stop : 6180321,
      direction : "-",
      ID : "ENSG00000116254.18",
      gene_id : "ENSG00000116254.18",
      gene_type : "protein_coding",
      gene_name : "CHD5",
      gene_level : 2,
      hgnc_id : "HGNC:16816",
      havana_gene : "OTTHUMG00000000952.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6159430,
      stop : 6197757,
      direction : "-",
      ID : "ENSG00000285629.1",
      gene_id : "ENSG00000285629.1",
      gene_type : "protein_coding",
      gene_name : "AL031847.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000000953.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6185020,
      stop : 6209389,
      direction : "-",
      ID : "ENSG00000116251.11",
      gene_id : "ENSG00000116251.11",
      gene_type : "protein_coding",
      gene_name : "RPL22",
      gene_level : 1,
      hgnc_id : "HGNC:10315",
      havana_gene : "OTTHUMG00000193375.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6205475,
      stop : 6221299,
      direction : "+",
      ID : "ENSG00000158286.13",
      gene_id : "ENSG00000158286.13",
      gene_type : "protein_coding",
      gene_name : "RNF207",
      gene_level : 2,
      hgnc_id : "HGNC:32947",
      havana_gene : "OTTHUMG00000001089.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6221193,
      stop : 6235972,
      direction : "-",
      ID : "ENSG00000116237.16",
      gene_id : "ENSG00000116237.16",
      gene_type : "protein_coding",
      gene_name : "ICMT",
      gene_level : 2,
      hgnc_id : "HGNC:5350",
      havana_gene : "OTTHUMG00000001254.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6244179,
      stop : 6245578,
      direction : "+",
      ID : "ENSG00000173673.8",
      gene_id : "ENSG00000173673.8",
      gene_type : "protein_coding",
      gene_name : "HES3",
      gene_level : 2,
      hgnc_id : "HGNC:26226",
      havana_gene : "OTTHUMG00000001271.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6247353,
      stop : 6261098,
      direction : "-",
      ID : "ENSG00000158292.7",
      gene_id : "ENSG00000158292.7",
      gene_type : "protein_coding",
      gene_name : "GPR153",
      gene_level : 2,
      hgnc_id : "HGNC:23618",
      havana_gene : "OTTHUMG00000001272.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6264269,
      stop : 6393767,
      direction : "-",
      ID : "ENSG00000097021.20",
      gene_id : "ENSG00000097021.20",
      gene_type : "protein_coding",
      gene_name : "ACOT7",
      gene_level : 2,
      hgnc_id : "HGNC:24157",
      havana_gene : "OTTHUMG00000001295.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6412418,
      stop : 6424670,
      direction : "-",
      ID : "ENSG00000069812.11",
      gene_id : "ENSG00000069812.11",
      gene_type : "protein_coding",
      gene_name : "HES2",
      gene_level : 2,
      hgnc_id : "HGNC:16005",
      havana_gene : "OTTHUMG00000000752.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6424776,
      stop : 6461367,
      direction : "+",
      ID : "ENSG00000187017.17",
      gene_id : "ENSG00000187017.17",
      gene_type : "protein_coding",
      gene_name : "ESPN",
      gene_level : 2,
      hgnc_id : "HGNC:13281",
      havana_gene : "OTTHUMG00000000753.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6460786,
      stop : 6466175,
      direction : "-",
      ID : "ENSG00000215788.11",
      gene_id : "ENSG00000215788.11",
      gene_type : "protein_coding",
      gene_name : "TNFRSF25",
      gene_level : 2,
      hgnc_id : "HGNC:11910",
      havana_gene : "OTTHUMG00000000831.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6467122,
      stop : 6520074,
      direction : "-",
      ID : "ENSG00000171680.23",
      gene_id : "ENSG00000171680.23",
      gene_type : "protein_coding",
      gene_name : "PLEKHG5",
      gene_level : 2,
      hgnc_id : "HGNC:29105",
      havana_gene : "OTTHUMG00000000905.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6521347,
      stop : 6554513,
      direction : "-",
      ID : "ENSG00000162408.11",
      gene_id : "ENSG00000162408.11",
      gene_type : "protein_coding",
      gene_name : "NOL9",
      gene_level : 2,
      hgnc_id : "HGNC:26265",
      havana_gene : "OTTHUMG00000000904.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6555307,
      stop : 6579755,
      direction : "+",
      ID : "ENSG00000173662.21",
      gene_id : "ENSG00000173662.21",
      gene_type : "protein_coding",
      gene_name : "TAS1R1",
      gene_level : 1,
      hgnc_id : "HGNC:14448",
      havana_gene : "OTTHUMG00000001441.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6579994,
      stop : 6589280,
      direction : "+",
      ID : "ENSG00000204859.13",
      gene_id : "ENSG00000204859.13",
      gene_type : "protein_coding",
      gene_name : "ZBTB48",
      gene_level : 2,
      hgnc_id : "HGNC:4930",
      havana_gene : "OTTHUMG00000001438.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6590724,
      stop : 6614607,
      direction : "-",
      ID : "ENSG00000162413.16",
      gene_id : "ENSG00000162413.16",
      gene_type : "protein_coding",
      gene_name : "KLHL21",
      gene_level : 1,
      hgnc_id : "HGNC:29041",
      havana_gene : "OTTHUMG00000001437.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6613731,
      stop : 6624030,
      direction : "+",
      ID : "ENSG00000116273.6",
      gene_id : "ENSG00000116273.6",
      gene_type : "protein_coding",
      gene_name : "PHF13",
      gene_level : 2,
      hgnc_id : "HGNC:22983",
      havana_gene : "OTTHUMG00000001439.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6624866,
      stop : 6635586,
      direction : "+",
      ID : "ENSG00000041988.15",
      gene_id : "ENSG00000041988.15",
      gene_type : "protein_coding",
      gene_name : "THAP3",
      gene_level : 2,
      hgnc_id : "HGNC:20855",
      havana_gene : "OTTHUMG00000001440.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6634168,
      stop : 6701924,
      direction : "-",
      ID : "ENSG00000007923.16",
      gene_id : "ENSG00000007923.16",
      gene_type : "protein_coding",
      gene_name : "DNAJC11",
      gene_level : 2,
      hgnc_id : "HGNC:25570",
      havana_gene : "OTTHUMG00000001443.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 6785454,
      stop : 7769706,
      direction : "+",
      ID : "ENSG00000171735.19",
      gene_id : "ENSG00000171735.19",
      gene_type : "protein_coding",
      gene_name : "CAMTA1",
      gene_level : 1,
      hgnc_id : "HGNC:18806",
      havana_gene : "OTTHUMG00000001212.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 7771296,
      stop : 7781432,
      direction : "+",
      ID : "ENSG00000049245.13",
      gene_id : "ENSG00000049245.13",
      gene_type : "protein_coding",
      gene_name : "VAMP3",
      gene_level : 1,
      hgnc_id : "HGNC:12644",
      havana_gene : "OTTHUMG00000001225.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 7784320,
      stop : 7845177,
      direction : "+",
      ID : "ENSG00000049246.14",
      gene_id : "ENSG00000049246.14",
      gene_type : "protein_coding",
      gene_name : "PER3",
      gene_level : 1,
      hgnc_id : "HGNC:8847",
      havana_gene : "OTTHUMG00000001216.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 7843083,
      stop : 7853512,
      direction : "-",
      ID : "ENSG00000049247.14",
      gene_id : "ENSG00000049247.14",
      gene_type : "protein_coding",
      gene_name : "UTS2",
      gene_level : 2,
      hgnc_id : "HGNC:12636",
      havana_gene : "OTTHUMG00000001218.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 7915871,
      stop : 7943165,
      direction : "-",
      ID : "ENSG00000049249.9",
      gene_id : "ENSG00000049249.9",
      gene_type : "protein_coding",
      gene_name : "TNFRSF9",
      gene_level : 1,
      hgnc_id : "HGNC:11924",
      havana_gene : "OTTHUMG00000001223.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 7954291,
      stop : 7985505,
      direction : "+",
      ID : "ENSG00000116288.13",
      gene_id : "ENSG00000116288.13",
      gene_type : "protein_coding",
      gene_name : "PARK7",
      gene_level : 1,
      hgnc_id : "HGNC:16369",
      havana_gene : "OTTHUMG00000001210.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 8004404,
      stop : 8026309,
      direction : "-",
      ID : "ENSG00000116285.13",
      gene_id : "ENSG00000116285.13",
      gene_type : "protein_coding",
      gene_name : "ERRFI1",
      gene_level : 1,
      hgnc_id : "HGNC:18185",
      havana_gene : "OTTHUMG00000001221.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 8318114,
      stop : 8344167,
      direction : "+",
      ID : "ENSG00000162426.16",
      gene_id : "ENSG00000162426.16",
      gene_type : "protein_coding",
      gene_name : "SLC45A1",
      gene_level : 2,
      hgnc_id : "HGNC:17939",
      havana_gene : "OTTHUMG00000000503.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 8352397,
      stop : 8848921,
      direction : "-",
      ID : "ENSG00000142599.19",
      gene_id : "ENSG00000142599.19",
      gene_type : "protein_coding",
      gene_name : "RERE",
      gene_level : 1,
      hgnc_id : "HGNC:9965",
      havana_gene : "OTTHUMG00000001765.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 8861000,
      stop : 8879190,
      direction : "-",
      ID : "ENSG00000074800.16",
      gene_id : "ENSG00000074800.16",
      gene_type : "protein_coding",
      gene_name : "ENO1",
      gene_level : 2,
      hgnc_id : "HGNC:3350",
      havana_gene : "OTTHUMG00000001773.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 8945867,
      stop : 8975092,
      direction : "+",
      ID : "ENSG00000131686.15",
      gene_id : "ENSG00000131686.15",
      gene_type : "protein_coding",
      gene_name : "CA6",
      gene_level : 1,
      hgnc_id : "HGNC:1380",
      havana_gene : "OTTHUMG00000001763.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9003300,
      stop : 9026345,
      direction : "-",
      ID : "ENSG00000197241.3",
      gene_id : "ENSG00000197241.3",
      gene_type : "protein_coding",
      gene_name : "SLC2A7",
      gene_level : 2,
      hgnc_id : "HGNC:13445",
      havana_gene : "OTTHUMG00000057499.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9035106,
      stop : 9088478,
      direction : "-",
      ID : "ENSG00000142583.18",
      gene_id : "ENSG00000142583.18",
      gene_type : "protein_coding",
      gene_name : "SLC2A5",
      gene_level : 2,
      hgnc_id : "HGNC:11010",
      havana_gene : "OTTHUMG00000001771.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9100305,
      stop : 9129102,
      direction : "-",
      ID : "ENSG00000180758.12",
      gene_id : "ENSG00000180758.12",
      gene_type : "protein_coding",
      gene_name : "GPR157",
      gene_level : 2,
      hgnc_id : "HGNC:23687",
      havana_gene : "OTTHUMG00000001758.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9234774,
      stop : 9271337,
      direction : "+",
      ID : "ENSG00000049239.13",
      gene_id : "ENSG00000049239.13",
      gene_type : "protein_coding",
      gene_name : "H6PD",
      gene_level : 1,
      hgnc_id : "HGNC:4795",
      havana_gene : "OTTHUMG00000001768.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9292894,
      stop : 9369532,
      direction : "+",
      ID : "ENSG00000171621.14",
      gene_id : "ENSG00000171621.14",
      gene_type : "protein_coding",
      gene_name : "SPSB1",
      gene_level : 2,
      hgnc_id : "HGNC:30628",
      havana_gene : "OTTHUMG00000001279.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9539465,
      stop : 9585173,
      direction : "+",
      ID : "ENSG00000171612.7",
      gene_id : "ENSG00000171612.7",
      gene_type : "protein_coding",
      gene_name : "SLC25A33",
      gene_level : 2,
      hgnc_id : "HGNC:29681",
      havana_gene : "OTTHUMG00000001322.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9588911,
      stop : 9614877,
      direction : "+",
      ID : "ENSG00000188807.13",
      gene_id : "ENSG00000188807.13",
      gene_type : "protein_coding",
      gene_name : "TMEM201",
      gene_level : 2,
      hgnc_id : "HGNC:33719",
      havana_gene : "OTTHUMG00000057457.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9651731,
      stop : 9729114,
      direction : "+",
      ID : "ENSG00000171608.16",
      gene_id : "ENSG00000171608.16",
      gene_type : "protein_coding",
      gene_name : "PIK3CD",
      gene_level : 2,
      hgnc_id : "HGNC:8977",
      havana_gene : "OTTHUMG00000001450.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9728926,
      stop : 9823984,
      direction : "-",
      ID : "ENSG00000171603.18",
      gene_id : "ENSG00000171603.18",
      gene_type : "protein_coding",
      gene_name : "CLSTN1",
      gene_level : 2,
      hgnc_id : "HGNC:17447",
      havana_gene : "OTTHUMG00000001451.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9848276,
      stop : 9910336,
      direction : "-",
      ID : "ENSG00000178585.15",
      gene_id : "ENSG00000178585.15",
      gene_type : "protein_coding",
      gene_name : "CTNNBIP1",
      gene_level : 2,
      hgnc_id : "HGNC:16913",
      havana_gene : "OTTHUMG00000001796.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9922113,
      stop : 9943407,
      direction : "-",
      ID : "ENSG00000162441.12",
      gene_id : "ENSG00000162441.12",
      gene_type : "protein_coding",
      gene_name : "LZIC",
      gene_level : 1,
      hgnc_id : "HGNC:17497",
      havana_gene : "OTTHUMG00000001804.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9943428,
      stop : 9985501,
      direction : "+",
      ID : "ENSG00000173614.14",
      gene_id : "ENSG00000173614.14",
      gene_type : "protein_coding",
      gene_name : "NMNAT1",
      gene_level : 1,
      hgnc_id : "HGNC:17877",
      havana_gene : "OTTHUMG00000001799.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 9997206,
      stop : 10016021,
      direction : "+",
      ID : "ENSG00000162444.12",
      gene_id : "ENSG00000162444.12",
      gene_type : "protein_coding",
      gene_name : "RBP7",
      gene_level : 2,
      hgnc_id : "HGNC:30316",
      havana_gene : "OTTHUMG00000001798.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10032832,
      stop : 10181239,
      direction : "+",
      ID : "ENSG00000130939.20",
      gene_id : "ENSG00000130939.20",
      gene_type : "protein_coding",
      gene_name : "UBE4B",
      gene_level : 2,
      hgnc_id : "HGNC:12500",
      havana_gene : "OTTHUMG00000001797.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10210570,
      stop : 10381603,
      direction : "+",
      ID : "ENSG00000054523.18",
      gene_id : "ENSG00000054523.18",
      gene_type : "protein_coding",
      gene_name : "KIF1B",
      gene_level : 1,
      hgnc_id : "HGNC:16636",
      havana_gene : "OTTHUMG00000001817.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10398592,
      stop : 10420511,
      direction : "+",
      ID : "ENSG00000142657.21",
      gene_id : "ENSG00000142657.21",
      gene_type : "protein_coding",
      gene_name : "PGD",
      gene_level : 2,
      hgnc_id : "HGNC:8891",
      havana_gene : "OTTHUMG00000001905.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10430102,
      stop : 10452153,
      direction : "+",
      ID : "ENSG00000251503.8",
      gene_id : "ENSG00000251503.8",
      gene_type : "protein_coding",
      gene_name : "CENPS-CORT",
      gene_level : 2,
      hgnc_id : "HGNC:38843",
      havana_gene : "OTTHUMG00000162436.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10430433,
      stop : 10442808,
      direction : "+",
      ID : "ENSG00000175279.22",
      gene_id : "ENSG00000175279.22",
      gene_type : "protein_coding",
      gene_name : "CENPS",
      gene_level : 1,
      hgnc_id : "HGNC:23163",
      havana_gene : "OTTHUMG00000059085.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10450031,
      stop : 10451998,
      direction : "+",
      ID : "ENSG00000241563.4",
      gene_id : "ENSG00000241563.4",
      gene_type : "protein_coding",
      gene_name : "CORT",
      gene_level : 2,
      hgnc_id : "HGNC:2257",
      havana_gene : "OTTHUMG00000001906.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10456522,
      stop : 10472529,
      direction : "-",
      ID : "ENSG00000160049.12",
      gene_id : "ENSG00000160049.12",
      gene_type : "protein_coding",
      gene_name : "DFFA",
      gene_level : 2,
      hgnc_id : "HGNC:2772",
      havana_gene : "OTTHUMG00000001909.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10472288,
      stop : 10630758,
      direction : "+",
      ID : "ENSG00000142655.13",
      gene_id : "ENSG00000142655.13",
      gene_type : "protein_coding",
      gene_name : "PEX14",
      gene_level : 2,
      hgnc_id : "HGNC:8856",
      havana_gene : "OTTHUMG00000001908.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10636604,
      stop : 10796650,
      direction : "-",
      ID : "ENSG00000130940.15",
      gene_id : "ENSG00000130940.15",
      gene_type : "protein_coding",
      gene_name : "CASZ1",
      gene_level : 1,
      hgnc_id : "HGNC:26002",
      havana_gene : "OTTHUMG00000002035.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 10946471,
      stop : 10982037,
      direction : "-",
      ID : "ENSG00000175262.14",
      gene_id : "ENSG00000175262.14",
      gene_type : "protein_coding",
      gene_name : "C1orf127",
      gene_level : 1,
      hgnc_id : "HGNC:26730",
      havana_gene : "OTTHUMG00000002032.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11012344,
      stop : 11030528,
      direction : "+",
      ID : "ENSG00000120948.19",
      gene_id : "ENSG00000120948.19",
      gene_type : "protein_coding",
      gene_name : "TARDBP",
      gene_level : 2,
      hgnc_id : "HGNC:11571",
      havana_gene : "OTTHUMG00000185649.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11026523,
      stop : 11047239,
      direction : "-",
      ID : "ENSG00000009724.17",
      gene_id : "ENSG00000009724.17",
      gene_type : "protein_coding",
      gene_name : "MASP2",
      gene_level : 2,
      hgnc_id : "HGNC:6902",
      havana_gene : "OTTHUMG00000002121.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11054584,
      stop : 11060020,
      direction : "-",
      ID : "ENSG00000116649.10",
      gene_id : "ENSG00000116649.10",
      gene_type : "protein_coding",
      gene_name : "SRM",
      gene_level : 1,
      hgnc_id : "HGNC:11296",
      havana_gene : "OTTHUMG00000002119.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11066618,
      stop : 11099869,
      direction : "-",
      ID : "ENSG00000171824.14",
      gene_id : "ENSG00000171824.14",
      gene_type : "protein_coding",
      gene_name : "EXOSC10",
      gene_level : 2,
      hgnc_id : "HGNC:9138",
      havana_gene : "OTTHUMG00000002123.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11106535,
      stop : 11262551,
      direction : "-",
      ID : "ENSG00000198793.13",
      gene_id : "ENSG00000198793.13",
      gene_type : "protein_coding",
      gene_name : "MTOR",
      gene_level : 2,
      hgnc_id : "HGNC:3942",
      havana_gene : "OTTHUMG00000002001.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11189355,
      stop : 11195981,
      direction : "+",
      ID : "ENSG00000171819.5",
      gene_id : "ENSG00000171819.5",
      gene_type : "protein_coding",
      gene_name : "ANGPTL7",
      gene_level : 2,
      hgnc_id : "HGNC:24078",
      havana_gene : "OTTHUMG00000002002.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11273198,
      stop : 11296049,
      direction : "+",
      ID : "ENSG00000120942.14",
      gene_id : "ENSG00000120942.14",
      gene_type : "protein_coding",
      gene_name : "UBIAD1",
      gene_level : 2,
      hgnc_id : "HGNC:30791",
      havana_gene : "OTTHUMG00000002075.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11479155,
      stop : 11537551,
      direction : "+",
      ID : "ENSG00000204624.8",
      gene_id : "ENSG00000204624.8",
      gene_type : "protein_coding",
      gene_name : "DISP3",
      gene_level : 2,
      hgnc_id : "HGNC:29251",
      havana_gene : "OTTHUMG00000002074.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11637018,
      stop : 11655785,
      direction : "-",
      ID : "ENSG00000116661.11",
      gene_id : "ENSG00000116661.11",
      gene_type : "protein_coding",
      gene_name : "FBXO2",
      gene_level : 2,
      hgnc_id : "HGNC:13581",
      havana_gene : "OTTHUMG00000002072.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11654375,
      stop : 11663327,
      direction : "+",
      ID : "ENSG00000132879.14",
      gene_id : "ENSG00000132879.14",
      gene_type : "protein_coding",
      gene_name : "FBXO44",
      gene_level : 2,
      hgnc_id : "HGNC:24847",
      havana_gene : "OTTHUMG00000002071.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11664200,
      stop : 11674354,
      direction : "+",
      ID : "ENSG00000116663.11",
      gene_id : "ENSG00000116663.11",
      gene_type : "protein_coding",
      gene_name : "FBXO6",
      gene_level : 2,
      hgnc_id : "HGNC:13585",
      havana_gene : "OTTHUMG00000002229.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11674480,
      stop : 11691650,
      direction : "-",
      ID : "ENSG00000116670.15",
      gene_id : "ENSG00000116670.15",
      gene_type : "protein_coding",
      gene_name : "MAD2L2",
      gene_level : 2,
      hgnc_id : "HGNC:6764",
      havana_gene : "OTTHUMG00000002231.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11691710,
      stop : 11725857,
      direction : "+",
      ID : "ENSG00000162490.7",
      gene_id : "ENSG00000162490.7",
      gene_type : "protein_coding",
      gene_name : "DRAXIN",
      gene_level : 2,
      hgnc_id : "HGNC:25054",
      havana_gene : "OTTHUMG00000002227.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11736084,
      stop : 11754802,
      direction : "+",
      ID : "ENSG00000177674.16",
      gene_id : "ENSG00000177674.16",
      gene_type : "protein_coding",
      gene_name : "AGTRAP",
      gene_level : 2,
      hgnc_id : "HGNC:13539",
      havana_gene : "OTTHUMG00000002230.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11761787,
      stop : 11789585,
      direction : "+",
      ID : "ENSG00000215910.7",
      gene_id : "ENSG00000215910.7",
      gene_type : "protein_coding",
      gene_name : "C1orf167",
      gene_level : 1,
      hgnc_id : "HGNC:25262",
      havana_gene : "OTTHUMG00000002228.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11785723,
      stop : 11806455,
      direction : "-",
      ID : "ENSG00000177000.13",
      gene_id : "ENSG00000177000.13",
      gene_type : "protein_coding",
      gene_name : "MTHFR",
      gene_level : 2,
      hgnc_id : "HGNC:7436",
      havana_gene : "OTTHUMG00000002277.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11806096,
      stop : 11848079,
      direction : "+",
      ID : "ENSG00000011021.23",
      gene_id : "ENSG00000011021.23",
      gene_type : "protein_coding",
      gene_name : "CLCN6",
      gene_level : 2,
      hgnc_id : "HGNC:2024",
      havana_gene : "OTTHUMG00000002299.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11845709,
      stop : 11848345,
      direction : "-",
      ID : "ENSG00000175206.10",
      gene_id : "ENSG00000175206.10",
      gene_type : "protein_coding",
      gene_name : "NPPA",
      gene_level : 2,
      hgnc_id : "HGNC:7939",
      havana_gene : "OTTHUMG00000002388.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11857464,
      stop : 11858945,
      direction : "-",
      ID : "ENSG00000120937.9",
      gene_id : "ENSG00000120937.9",
      gene_type : "protein_coding",
      gene_name : "NPPB",
      gene_level : 2,
      hgnc_id : "HGNC:7940",
      havana_gene : "OTTHUMG00000002389.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11919591,
      stop : 11926428,
      direction : "-",
      ID : "ENSG00000116685.16",
      gene_id : "ENSG00000116685.16",
      gene_type : "protein_coding",
      gene_name : "KIAA2013",
      gene_level : 2,
      hgnc_id : "HGNC:28513",
      havana_gene : "OTTHUMG00000002391.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11934205,
      stop : 11975538,
      direction : "+",
      ID : "ENSG00000083444.17",
      gene_id : "ENSG00000083444.17",
      gene_type : "protein_coding",
      gene_name : "PLOD1",
      gene_level : 2,
      hgnc_id : "HGNC:9081",
      havana_gene : "OTTHUMG00000002393.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 11980181,
      stop : 12015211,
      direction : "+",
      ID : "ENSG00000116688.18",
      gene_id : "ENSG00000116688.18",
      gene_type : "protein_coding",
      gene_name : "MFN2",
      gene_level : 2,
      hgnc_id : "HGNC:16877",
      havana_gene : "OTTHUMG00000002392.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12019466,
      stop : 12032045,
      direction : "+",
      ID : "ENSG00000116691.11",
      gene_id : "ENSG00000116691.11",
      gene_type : "protein_coding",
      gene_name : "MIIP",
      gene_level : 2,
      hgnc_id : "HGNC:25715",
      havana_gene : "OTTHUMG00000002439.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12063303,
      stop : 12144207,
      direction : "+",
      ID : "ENSG00000120949.15",
      gene_id : "ENSG00000120949.15",
      gene_type : "protein_coding",
      gene_name : "TNFRSF8",
      gene_level : 2,
      hgnc_id : "HGNC:11923",
      havana_gene : "OTTHUMG00000001827.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12166991,
      stop : 12209228,
      direction : "+",
      ID : "ENSG00000028137.19",
      gene_id : "ENSG00000028137.19",
      gene_type : "protein_coding",
      gene_name : "TNFRSF1B",
      gene_level : 2,
      hgnc_id : "HGNC:11917",
      havana_gene : "OTTHUMG00000001829.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12230030,
      stop : 12512047,
      direction : "+",
      ID : "ENSG00000048707.15",
      gene_id : "ENSG00000048707.15",
      gene_type : "protein_coding",
      gene_name : "VPS13D",
      gene_level : 2,
      hgnc_id : "HGNC:23595",
      havana_gene : "OTTHUMG00000013155.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12567910,
      stop : 12618210,
      direction : "-",
      ID : "ENSG00000162496.9",
      gene_id : "ENSG00000162496.9",
      gene_type : "protein_coding",
      gene_name : "DHRS3",
      gene_level : 2,
      hgnc_id : "HGNC:17693",
      havana_gene : "OTTHUMG00000001885.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12644085,
      stop : 12667076,
      direction : "+",
      ID : "ENSG00000204518.3",
      gene_id : "ENSG00000204518.3",
      gene_type : "protein_coding",
      gene_name : "AADACL4",
      gene_level : 2,
      hgnc_id : "HGNC:32038",
      havana_gene : "OTTHUMG00000001889.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12716110,
      stop : 12728760,
      direction : "+",
      ID : "ENSG00000188984.12",
      gene_id : "ENSG00000188984.12",
      gene_type : "protein_coding",
      gene_name : "AADACL3",
      gene_level : 2,
      hgnc_id : "HGNC:32037",
      havana_gene : "OTTHUMG00000001887.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12746200,
      stop : 12763699,
      direction : "+",
      ID : "ENSG00000157330.10",
      gene_id : "ENSG00000157330.10",
      gene_type : "protein_coding",
      gene_name : "C1orf158",
      gene_level : 2,
      hgnc_id : "HGNC:28567",
      havana_gene : "OTTHUMG00000001888.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12773738,
      stop : 12777906,
      direction : "+",
      ID : "ENSG00000116726.5",
      gene_id : "ENSG00000116726.5",
      gene_type : "protein_coding",
      gene_name : "PRAMEF12",
      gene_level : 2,
      hgnc_id : "HGNC:22125",
      havana_gene : "OTTHUMG00000001927.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12791397,
      stop : 12796628,
      direction : "+",
      ID : "ENSG00000116721.9",
      gene_id : "ENSG00000116721.9",
      gene_type : "protein_coding",
      gene_name : "PRAMEF1",
      gene_level : 2,
      hgnc_id : "HGNC:28840",
      havana_gene : "OTTHUMG00000001928.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12824605,
      stop : 12831410,
      direction : "-",
      ID : "ENSG00000239810.3",
      gene_id : "ENSG00000239810.3",
      gene_type : "protein_coding",
      gene_name : "PRAMEF11",
      gene_level : 2,
      hgnc_id : "HGNC:14086",
      havana_gene : "OTTHUMG00000001929.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12847377,
      stop : 12848720,
      direction : "-",
      ID : "ENSG00000179172.10",
      gene_id : "ENSG00000179172.10",
      gene_type : "protein_coding",
      gene_name : "HNRNPCL1",
      gene_level : 2,
      hgnc_id : "HGNC:29295",
      havana_gene : "OTTHUMG00000001931.3",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12857086,
      stop : 12861909,
      direction : "+",
      ID : "ENSG00000120952.4",
      gene_id : "ENSG00000120952.4",
      gene_type : "protein_coding",
      gene_name : "PRAMEF2",
      gene_level : 2,
      hgnc_id : "HGNC:28841",
      havana_gene : "OTTHUMG00000001986.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12879212,
      stop : 12886201,
      direction : "-",
      ID : "ENSG00000243073.4",
      gene_id : "ENSG00000243073.4",
      gene_type : "protein_coding",
      gene_name : "PRAMEF4",
      gene_level : 2,
      hgnc_id : "HGNC:31971",
      havana_gene : "OTTHUMG00000001987.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12892896,
      stop : 12898270,
      direction : "-",
      ID : "ENSG00000187545.5",
      gene_id : "ENSG00000187545.5",
      gene_type : "protein_coding",
      gene_name : "PRAMEF10",
      gene_level : 2,
      hgnc_id : "HGNC:27997",
      havana_gene : "OTTHUMG00000001981.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12916610,
      stop : 12920482,
      direction : "+",
      ID : "ENSG00000204510.5",
      gene_id : "ENSG00000204510.5",
      gene_type : "protein_coding",
      gene_name : "PRAMEF7",
      gene_level : 2,
      hgnc_id : "HGNC:28415",
      havana_gene : "OTTHUMG00000001982.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 12938472,
      stop : 12947580,
      direction : "-",
      ID : "ENSG00000232423.6",
      gene_id : "ENSG00000232423.6",
      gene_type : "protein_coding",
      gene_name : "PRAMEF6",
      gene_level : 2,
      hgnc_id : "HGNC:30583",
      havana_gene : "OTTHUMG00000001984.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13049476,
      stop : 13056575,
      direction : "-",
      ID : "ENSG00000274764.6",
      gene_id : "ENSG00000274764.6",
      gene_type : "protein_coding",
      gene_name : "PRAMEF27",
      gene_level : 2,
      hgnc_id : "HGNC:51234",
      havana_gene : "OTTHUMG00000074727.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13060769,
      stop : 13062878,
      direction : "+",
      ID : "ENSG00000277058.3",
      gene_id : "ENSG00000277058.3",
      gene_type : "protein_coding",
      gene_name : "HNRNPCL3",
      gene_level : 2,
      hgnc_id : "HGNC:51235",
      havana_gene : "OTTHUMG00000189236.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13068677,
      stop : 13077884,
      direction : "+",
      ID : "ENSG00000229571.7",
      gene_id : "ENSG00000229571.7",
      gene_type : "protein_coding",
      gene_name : "PRAMEF25",
      gene_level : 2,
      hgnc_id : "HGNC:49179",
      havana_gene : "OTTHUMG00000074741.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13115488,
      stop : 13116854,
      direction : "-",
      ID : "ENSG00000275774.3",
      gene_id : "ENSG00000275774.3",
      gene_type : "protein_coding",
      gene_name : "HNRNPCL2",
      gene_level : 2,
      hgnc_id : "HGNC:48813",
      havana_gene : "OTTHUMG00000009503.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13148905,
      stop : 13155961,
      direction : "-",
      ID : "ENSG00000280267.4",
      gene_id : "ENSG00000280267.4",
      gene_type : "protein_coding",
      gene_name : "PRAMEF26",
      gene_level : 2,
      hgnc_id : "HGNC:49178",
      havana_gene : "OTTHUMG00000009499.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13163914,
      stop : 13165631,
      direction : "-",
      ID : "ENSG00000179412.11",
      gene_id : "ENSG00000179412.11",
      gene_type : "protein_coding",
      gene_name : "HNRNPCL4",
      gene_level : 2,
      hgnc_id : "HGNC:51333",
      havana_gene : "OTTHUMG00000189238.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13171848,
      stop : 13179459,
      direction : "+",
      ID : "ENSG00000204505.5",
      gene_id : "ENSG00000204505.5",
      gene_type : "protein_coding",
      gene_name : "PRAMEF9",
      gene_level : 2,
      hgnc_id : "HGNC:27996",
      havana_gene : "OTTHUMG00000189239.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13196188,
      stop : 13201409,
      direction : "-",
      ID : "ENSG00000279169.3",
      gene_id : "ENSG00000279169.3",
      gene_type : "protein_coding",
      gene_name : "PRAMEF13",
      gene_level : 2,
      hgnc_id : "HGNC:13262",
      havana_gene : "OTTHUMG00000189240.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13222705,
      stop : 13226106,
      direction : "-",
      ID : "ENSG00000279804.2",
      gene_id : "ENSG00000279804.2",
      gene_type : "protein_coding",
      gene_name : "PRAMEF18",
      gene_level : 2,
      hgnc_id : "HGNC:30693",
      havana_gene : "OTTHUMG00000191961.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13254212,
      stop : 13263314,
      direction : "+",
      ID : "ENSG00000270601.4",
      gene_id : "ENSG00000270601.4",
      gene_type : "protein_coding",
      gene_name : "PRAMEF5",
      gene_level : 2,
      hgnc_id : "HGNC:27995",
      havana_gene : "OTTHUMG00000184604.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13281035,
      stop : 13285174,
      direction : "-",
      ID : "ENSG00000182330.10",
      gene_id : "ENSG00000182330.10",
      gene_type : "protein_coding",
      gene_name : "PRAMEF8",
      gene_level : 2,
      hgnc_id : "HGNC:24074",
      havana_gene : "OTTHUMG00000008037.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13303539,
      stop : 13308907,
      direction : "+",
      ID : "ENSG00000237700.2",
      gene_id : "ENSG00000237700.2",
      gene_type : "protein_coding",
      gene_name : "PRAMEF33",
      gene_level : 2,
      hgnc_id : "HGNC:49193",
      havana_gene : "OTTHUMG00000008036.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13315581,
      stop : 13322598,
      direction : "+",
      ID : "ENSG00000204501.7",
      gene_id : "ENSG00000204501.7",
      gene_type : "protein_coding",
      gene_name : "PRAMEF15",
      gene_level : 2,
      hgnc_id : "HGNC:26764",
      havana_gene : "OTTHUMG00000008035.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13341892,
      stop : 13347134,
      direction : "-",
      ID : "ENSG00000204481.8",
      gene_id : "ENSG00000204481.8",
      gene_type : "protein_coding",
      gene_name : "PRAMEF14",
      gene_level : 2,
      hgnc_id : "HGNC:13576",
      havana_gene : "OTTHUMG00000007916.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13369067,
      stop : 13371900,
      direction : "-",
      ID : "ENSG00000204480.8",
      gene_id : "ENSG00000204480.8",
      gene_type : "protein_coding",
      gene_name : "PRAMEF19",
      gene_level : 2,
      hgnc_id : "HGNC:24908",
      havana_gene : "OTTHUMG00000007919.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13389632,
      stop : 13392629,
      direction : "+",
      ID : "ENSG00000204479.4",
      gene_id : "ENSG00000204479.4",
      gene_type : "protein_coding",
      gene_name : "PRAMEF17",
      gene_level : 2,
      hgnc_id : "HGNC:29485",
      havana_gene : "OTTHUMG00000007909.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13416351,
      stop : 13421328,
      direction : "+",
      ID : "ENSG00000204478.10",
      gene_id : "ENSG00000204478.10",
      gene_type : "protein_coding",
      gene_name : "PRAMEF20",
      gene_level : 2,
      hgnc_id : "HGNC:25224",
      havana_gene : "OTTHUMG00000007911.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13474973,
      stop : 13514003,
      direction : "-",
      ID : "ENSG00000162494.6",
      gene_id : "ENSG00000162494.6",
      gene_type : "protein_coding",
      gene_name : "LRRC38",
      gene_level : 2,
      hgnc_id : "HGNC:27005",
      havana_gene : "OTTHUMG00000007918.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13583465,
      stop : 13617957,
      direction : "+",
      ID : "ENSG00000162493.17",
      gene_id : "ENSG00000162493.17",
      gene_type : "protein_coding",
      gene_name : "PDPN",
      gene_level : 1,
      hgnc_id : "HGNC:29602",
      havana_gene : "OTTHUMG00000007912.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13700198,
      stop : 13825079,
      direction : "+",
      ID : "ENSG00000116731.22",
      gene_id : "ENSG00000116731.22",
      gene_type : "protein_coding",
      gene_name : "PRDM2",
      gene_level : 2,
      hgnc_id : "HGNC:9347",
      havana_gene : "OTTHUMG00000007917.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 13892792,
      stop : 15118043,
      direction : "+",
      ID : "ENSG00000189337.17",
      gene_id : "ENSG00000189337.17",
      gene_type : "protein_coding",
      gene_name : "KAZN",
      gene_level : 2,
      hgnc_id : "HGNC:29173",
      havana_gene : "OTTHUMG00000002042.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15152532,
      stop : 15220478,
      direction : "+",
      ID : "ENSG00000171729.14",
      gene_id : "ENSG00000171729.14",
      gene_type : "protein_coding",
      gene_name : "TMEM51",
      gene_level : 1,
      hgnc_id : "HGNC:25488",
      havana_gene : "OTTHUMG00000002046.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15247272,
      stop : 15400283,
      direction : "+",
      ID : "ENSG00000142621.19",
      gene_id : "ENSG00000142621.19",
      gene_type : "protein_coding",
      gene_name : "FHAD1",
      gene_level : 1,
      hgnc_id : "HGNC:29408",
      havana_gene : "OTTHUMG00000002088.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15409888,
      stop : 15430339,
      direction : "+",
      ID : "ENSG00000142634.13",
      gene_id : "ENSG00000142634.13",
      gene_type : "protein_coding",
      gene_name : "EFHD2",
      gene_level : 2,
      hgnc_id : "HGNC:28670",
      havana_gene : "OTTHUMG00000002254.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15438442,
      stop : 15449242,
      direction : "+",
      ID : "ENSG00000162438.12",
      gene_id : "ENSG00000162438.12",
      gene_type : "protein_coding",
      gene_name : "CTRC",
      gene_level : 2,
      hgnc_id : "HGNC:2523",
      havana_gene : "OTTHUMG00000002255.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15456728,
      stop : 15472091,
      direction : "+",
      ID : "ENSG00000142615.8",
      gene_id : "ENSG00000142615.8",
      gene_type : "protein_coding",
      gene_name : "CELA2A",
      gene_level : 2,
      hgnc_id : "HGNC:24609",
      havana_gene : "OTTHUMG00000002258.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15465909,
      stop : 15491395,
      direction : "+",
      ID : "ENSG00000215704.10",
      gene_id : "ENSG00000215704.10",
      gene_type : "protein_coding",
      gene_name : "CELA2B",
      gene_level : 2,
      hgnc_id : "HGNC:29995",
      havana_gene : "OTTHUMG00000002259.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15490832,
      stop : 15526534,
      direction : "-",
      ID : "ENSG00000132906.18",
      gene_id : "ENSG00000132906.18",
      gene_type : "protein_coding",
      gene_name : "CASP9",
      gene_level : 1,
      hgnc_id : "HGNC:1511",
      havana_gene : "OTTHUMG00000002256.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15526813,
      stop : 15592379,
      direction : "+",
      ID : "ENSG00000116138.13",
      gene_id : "ENSG00000116138.13",
      gene_type : "protein_coding",
      gene_name : "DNAJC16",
      gene_level : 2,
      hgnc_id : "HGNC:29157",
      havana_gene : "OTTHUMG00000002358.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15571699,
      stop : 15585051,
      direction : "-",
      ID : "ENSG00000116771.6",
      gene_id : "ENSG00000116771.6",
      gene_type : "protein_coding",
      gene_name : "AGMAT",
      gene_level : 2,
      hgnc_id : "HGNC:18407",
      havana_gene : "OTTHUMG00000002357.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15617458,
      stop : 15669044,
      direction : "+",
      ID : "ENSG00000197312.12",
      gene_id : "ENSG00000197312.12",
      gene_type : "protein_coding",
      gene_name : "DDI2",
      gene_level : 2,
      hgnc_id : "HGNC:24578",
      havana_gene : "OTTHUMG00000002381.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15659869,
      stop : 15661722,
      direction : "+",
      ID : "ENSG00000215695.1",
      gene_id : "ENSG00000215695.1",
      gene_type : "protein_coding",
      gene_name : "RSC1A1",
      gene_level : 2,
      hgnc_id : "HGNC:10458",
      havana_gene : "OTTHUMG00000067830.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15684320,
      stop : 15734769,
      direction : "+",
      ID : "ENSG00000116786.13",
      gene_id : "ENSG00000116786.13",
      gene_type : "protein_coding",
      gene_name : "PLEKHM2",
      gene_level : 2,
      hgnc_id : "HGNC:29131",
      havana_gene : "OTTHUMG00000003062.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15736258,
      stop : 15741392,
      direction : "+",
      ID : "ENSG00000162461.8",
      gene_id : "ENSG00000162461.8",
      gene_type : "protein_coding",
      gene_name : "SLC25A34",
      gene_level : 2,
      hgnc_id : "HGNC:27653",
      havana_gene : "OTTHUMG00000003063.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15742499,
      stop : 15747982,
      direction : "+",
      ID : "ENSG00000162460.7",
      gene_id : "ENSG00000162460.7",
      gene_type : "protein_coding",
      gene_name : "TMEM82",
      gene_level : 2,
      hgnc_id : "HGNC:32350",
      havana_gene : "OTTHUMG00000003065.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15756607,
      stop : 15786594,
      direction : "+",
      ID : "ENSG00000162458.13",
      gene_id : "ENSG00000162458.13",
      gene_type : "protein_coding",
      gene_name : "FBLIM1",
      gene_level : 2,
      hgnc_id : "HGNC:24686",
      havana_gene : "OTTHUMG00000003079.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15807169,
      stop : 15809348,
      direction : "-",
      ID : "ENSG00000233954.6",
      gene_id : "ENSG00000233954.6",
      gene_type : "protein_coding",
      gene_name : "UQCRHL",
      gene_level : 2,
      hgnc_id : "HGNC:51714",
      havana_gene : "OTTHUMG00000003109.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15836095,
      stop : 15940456,
      direction : "+",
      ID : "ENSG00000065526.12",
      gene_id : "ENSG00000065526.12",
      gene_type : "protein_coding",
      gene_name : "SPEN",
      gene_level : 2,
      hgnc_id : "HGNC:17575",
      havana_gene : "OTTHUMG00000009376.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 15941869,
      stop : 15976132,
      direction : "-",
      ID : "ENSG00000116809.12",
      gene_id : "ENSG00000116809.12",
      gene_type : "protein_coding",
      gene_name : "ZBTB17",
      gene_level : 2,
      hgnc_id : "HGNC:12936",
      havana_gene : "OTTHUMG00000009377.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16004236,
      stop : 16008807,
      direction : "+",
      ID : "ENSG00000183888.4",
      gene_id : "ENSG00000183888.4",
      gene_type : "protein_coding",
      gene_name : "SRARP",
      gene_level : 2,
      hgnc_id : "HGNC:28339",
      havana_gene : "OTTHUMG00000009523.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16014028,
      stop : 16019594,
      direction : "-",
      ID : "ENSG00000173641.18",
      gene_id : "ENSG00000173641.18",
      gene_type : "protein_coding",
      gene_name : "HSPB7",
      gene_level : 1,
      hgnc_id : "HGNC:5249",
      havana_gene : "OTTHUMG00000009531.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16018875,
      stop : 16034050,
      direction : "+",
      ID : "ENSG00000186510.12",
      gene_id : "ENSG00000186510.12",
      gene_type : "protein_coding",
      gene_name : "CLCNKA",
      gene_level : 2,
      hgnc_id : "HGNC:2026",
      havana_gene : "OTTHUMG00000009529.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16043736,
      stop : 16057308,
      direction : "+",
      ID : "ENSG00000184908.18",
      gene_id : "ENSG00000184908.18",
      gene_type : "protein_coding",
      gene_name : "CLCNKB",
      gene_level : 2,
      hgnc_id : "HGNC:2027",
      havana_gene : "OTTHUMG00000009530.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16057769,
      stop : 16073651,
      direction : "-",
      ID : "ENSG00000185519.9",
      gene_id : "ENSG00000185519.9",
      gene_type : "protein_coding",
      gene_name : "FAM131C",
      gene_level : 2,
      hgnc_id : "HGNC:26717",
      havana_gene : "OTTHUMG00000009525.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16124337,
      stop : 16156069,
      direction : "-",
      ID : "ENSG00000142627.13",
      gene_id : "ENSG00000142627.13",
      gene_type : "protein_coding",
      gene_name : "EPHA2",
      gene_level : 2,
      hgnc_id : "HGNC:3386",
      havana_gene : "OTTHUMG00000009527.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16197854,
      stop : 16212652,
      direction : "-",
      ID : "ENSG00000142632.17",
      gene_id : "ENSG00000142632.17",
      gene_type : "protein_coding",
      gene_name : "ARHGEF19",
      gene_level : 2,
      hgnc_id : "HGNC:26604",
      havana_gene : "OTTHUMG00000002219.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16231692,
      stop : 16237183,
      direction : "-",
      ID : "ENSG00000132881.12",
      gene_id : "ENSG00000132881.12",
      gene_type : "protein_coding",
      gene_name : "CPLANE2",
      gene_level : 2,
      hgnc_id : "HGNC:28127",
      havana_gene : "OTTHUMG00000002214.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16246840,
      stop : 16352480,
      direction : "-",
      ID : "ENSG00000037637.11",
      gene_id : "ENSG00000037637.11",
      gene_type : "protein_coding",
      gene_name : "FBXO42",
      gene_level : 2,
      hgnc_id : "HGNC:29249",
      havana_gene : "OTTHUMG00000002218.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16352575,
      stop : 16398145,
      direction : "+",
      ID : "ENSG00000055070.17",
      gene_id : "ENSG00000055070.17",
      gene_type : "protein_coding",
      gene_name : "SZRD1",
      gene_level : 2,
      hgnc_id : "HGNC:30232",
      havana_gene : "OTTHUMG00000002217.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16387117,
      stop : 16437424,
      direction : "-",
      ID : "ENSG00000187144.11",
      gene_id : "ENSG00000187144.11",
      gene_type : "protein_coding",
      gene_name : "SPATA21",
      gene_level : 1,
      hgnc_id : "HGNC:28026",
      havana_gene : "OTTHUMG00000002312.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16440721,
      stop : 16460078,
      direction : "+",
      ID : "ENSG00000157191.20",
      gene_id : "ENSG00000157191.20",
      gene_type : "protein_coding",
      gene_name : "NECAP2",
      gene_level : 1,
      hgnc_id : "HGNC:25528",
      havana_gene : "OTTHUMG00000002313.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16562319,
      stop : 16613562,
      direction : "-",
      ID : "ENSG00000219481.10",
      gene_id : "ENSG00000219481.10",
      gene_type : "protein_coding",
      gene_name : "NBPF1",
      gene_level : 2,
      hgnc_id : "HGNC:26088",
      havana_gene : "OTTHUMG00000002487.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16740273,
      stop : 16972964,
      direction : "+",
      ID : "ENSG00000058453.17",
      gene_id : "ENSG00000058453.17",
      gene_type : "protein_coding",
      gene_name : "CROCC",
      gene_level : 2,
      hgnc_id : "HGNC:21299",
      havana_gene : "OTTHUMG00000002200.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16974502,
      stop : 16980632,
      direction : "-",
      ID : "ENSG00000117122.14",
      gene_id : "ENSG00000117122.14",
      gene_type : "protein_coding",
      gene_name : "MFAP2",
      gene_level : 2,
      hgnc_id : "HGNC:7033",
      havana_gene : "OTTHUMG00000002290.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 16985958,
      stop : 17011928,
      direction : "-",
      ID : "ENSG00000159363.19",
      gene_id : "ENSG00000159363.19",
      gene_type : "protein_coding",
      gene_name : "ATP13A2",
      gene_level : 1,
      hgnc_id : "HGNC:30213",
      havana_gene : "OTTHUMG00000002293.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17005068,
      stop : 17011757,
      direction : "-",
      ID : "ENSG00000288636.1",
      gene_id : "ENSG00000288636.1",
      gene_type : "protein_coding",
      gene_name : "AL049569.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17018722,
      stop : 17054032,
      direction : "-",
      ID : "ENSG00000117118.10",
      gene_id : "ENSG00000117118.10",
      gene_type : "protein_coding",
      gene_name : "SDHB",
      gene_level : 2,
      hgnc_id : "HGNC:10681",
      havana_gene : "OTTHUMG00000002289.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17066761,
      stop : 17119451,
      direction : "-",
      ID : "ENSG00000117115.13",
      gene_id : "ENSG00000117115.13",
      gene_type : "protein_coding",
      gene_name : "PADI2",
      gene_level : 2,
      hgnc_id : "HGNC:18341",
      havana_gene : "OTTHUMG00000002295.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17205128,
      stop : 17246007,
      direction : "+",
      ID : "ENSG00000142623.11",
      gene_id : "ENSG00000142623.11",
      gene_type : "protein_coding",
      gene_name : "PADI1",
      gene_level : 2,
      hgnc_id : "HGNC:18367",
      havana_gene : "OTTHUMG00000002294.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17249098,
      stop : 17284233,
      direction : "+",
      ID : "ENSG00000142619.4",
      gene_id : "ENSG00000142619.4",
      gene_type : "protein_coding",
      gene_name : "PADI3",
      gene_level : 2,
      hgnc_id : "HGNC:18337",
      havana_gene : "OTTHUMG00000002373.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17308195,
      stop : 17364004,
      direction : "+",
      ID : "ENSG00000159339.13",
      gene_id : "ENSG00000159339.13",
      gene_type : "protein_coding",
      gene_name : "PADI4",
      gene_level : 2,
      hgnc_id : "HGNC:18368",
      havana_gene : "OTTHUMG00000002371.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17372196,
      stop : 17401699,
      direction : "+",
      ID : "ENSG00000276747.1",
      gene_id : "ENSG00000276747.1",
      gene_type : "protein_coding",
      gene_name : "PADI6",
      gene_level : 2,
      hgnc_id : "HGNC:20449",
      havana_gene : "OTTHUMG00000002372.7",
      tag : "reference_genome_error"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17406760,
      stop : 17439677,
      direction : "-",
      ID : "ENSG00000179051.14",
      gene_id : "ENSG00000179051.14",
      gene_type : "protein_coding",
      gene_name : "RCC2",
      gene_level : 2,
      hgnc_id : "HGNC:30297",
      havana_gene : "OTTHUMG00000002513.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17539698,
      stop : 17697874,
      direction : "+",
      ID : "ENSG00000074964.17",
      gene_id : "ENSG00000074964.17",
      gene_type : "protein_coding",
      gene_name : "ARHGEF10L",
      gene_level : 2,
      hgnc_id : "HGNC:25540",
      havana_gene : "OTTHUMG00000002514.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 17755333,
      stop : 17827063,
      direction : "+",
      ID : "ENSG00000117148.8",
      gene_id : "ENSG00000117148.8",
      gene_type : "protein_coding",
      gene_name : "ACTL8",
      gene_level : 2,
      hgnc_id : "HGNC:24018",
      havana_gene : "OTTHUMG00000002512.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 18107798,
      stop : 18378483,
      direction : "+",
      ID : "ENSG00000117154.12",
      gene_id : "ENSG00000117154.12",
      gene_type : "protein_coding",
      gene_name : "IGSF21",
      gene_level : 2,
      hgnc_id : "HGNC:28246",
      havana_gene : "OTTHUMG00000002432.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 18480930,
      stop : 18485974,
      direction : "+",
      ID : "ENSG00000179023.9",
      gene_id : "ENSG00000179023.9",
      gene_type : "protein_coding",
      gene_name : "KLHDC7A",
      gene_level : 2,
      hgnc_id : "HGNC:26791",
      havana_gene : "OTTHUMG00000002431.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 18630846,
      stop : 18748866,
      direction : "+",
      ID : "ENSG00000009709.12",
      gene_id : "ENSG00000009709.12",
      gene_type : "protein_coding",
      gene_name : "PAX7",
      gene_level : 2,
      hgnc_id : "HGNC:8621",
      havana_gene : "OTTHUMG00000002433.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 18839599,
      stop : 18859682,
      direction : "-",
      ID : "ENSG00000179002.5",
      gene_id : "ENSG00000179002.5",
      gene_type : "protein_coding",
      gene_name : "TAS1R2",
      gene_level : 1,
      hgnc_id : "HGNC:14905",
      havana_gene : "OTTHUMG00000002442.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 18871430,
      stop : 18902724,
      direction : "-",
      ID : "ENSG00000159423.17",
      gene_id : "ENSG00000159423.17",
      gene_type : "protein_coding",
      gene_name : "ALDH4A1",
      gene_level : 1,
      hgnc_id : "HGNC:406",
      havana_gene : "OTTHUMG00000002443.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 18904280,
      stop : 18956676,
      direction : "-",
      ID : "ENSG00000169991.11",
      gene_id : "ENSG00000169991.11",
      gene_type : "protein_coding",
      gene_name : "IFFO2",
      gene_level : 1,
      hgnc_id : "HGNC:27006",
      havana_gene : "OTTHUMG00000002499.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19074510,
      stop : 19210266,
      direction : "-",
      ID : "ENSG00000127481.15",
      gene_id : "ENSG00000127481.15",
      gene_type : "protein_coding",
      gene_name : "UBR4",
      gene_level : 2,
      hgnc_id : "HGNC:30313",
      havana_gene : "OTTHUMG00000002498.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19215660,
      stop : 19251527,
      direction : "-",
      ID : "ENSG00000127463.15",
      gene_id : "ENSG00000127463.15",
      gene_type : "protein_coding",
      gene_name : "EMC1",
      gene_level : 1,
      hgnc_id : "HGNC:28957",
      havana_gene : "OTTHUMG00000002497.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19251805,
      stop : 19260128,
      direction : "+",
      ID : "ENSG00000053372.5",
      gene_id : "ENSG00000053372.5",
      gene_type : "protein_coding",
      gene_name : "MRTO4",
      gene_level : 2,
      hgnc_id : "HGNC:18477",
      havana_gene : "OTTHUMG00000002496.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19282573,
      stop : 19288770,
      direction : "-",
      ID : "ENSG00000162482.5",
      gene_id : "ENSG00000162482.5",
      gene_type : "protein_coding",
      gene_name : "AKR7A3",
      gene_level : 2,
      hgnc_id : "HGNC:390",
      havana_gene : "OTTHUMG00000002523.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19303965,
      stop : 19312144,
      direction : "-",
      ID : "ENSG00000053371.13",
      gene_id : "ENSG00000053371.13",
      gene_type : "protein_coding",
      gene_name : "AKR7A2",
      gene_level : 2,
      hgnc_id : "HGNC:389",
      havana_gene : "OTTHUMG00000002522.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19312326,
      stop : 19329300,
      direction : "+",
      ID : "ENSG00000040487.13",
      gene_id : "ENSG00000040487.13",
      gene_type : "protein_coding",
      gene_name : "SLC66A1",
      gene_level : 1,
      hgnc_id : "HGNC:26001",
      havana_gene : "OTTHUMG00000002521.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19338775,
      stop : 19485539,
      direction : "-",
      ID : "ENSG00000077549.19",
      gene_id : "ENSG00000077549.19",
      gene_type : "protein_coding",
      gene_name : "CAPZB",
      gene_level : 2,
      hgnc_id : "HGNC:1491",
      havana_gene : "OTTHUMG00000002556.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19484403,
      stop : 19629821,
      direction : "+",
      ID : "ENSG00000173436.15",
      gene_id : "ENSG00000173436.15",
      gene_type : "protein_coding",
      gene_name : "MICOS10",
      gene_level : 2,
      hgnc_id : "HGNC:32068",
      havana_gene : "OTTHUMG00000002712.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19596979,
      stop : 19658456,
      direction : "+",
      ID : "ENSG00000158747.15",
      gene_id : "ENSG00000158747.15",
      gene_type : "protein_coding",
      gene_name : "NBL1",
      gene_level : 1,
      hgnc_id : "HGNC:7650",
      havana_gene : "OTTHUMG00000002700.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19597067,
      stop : 19656927,
      direction : "+",
      ID : "ENSG00000270136.6",
      gene_id : "ENSG00000270136.6",
      gene_type : "protein_coding",
      gene_name : "MICOS10-NBL1",
      gene_level : 2,
      hgnc_id : "HGNC:48338",
      havana_gene : "OTTHUMG00000183956.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19664875,
      stop : 19680966,
      direction : "+",
      ID : "ENSG00000158748.4",
      gene_id : "ENSG00000158748.4",
      gene_type : "protein_coding",
      gene_name : "HTR6",
      gene_level : 2,
      hgnc_id : "HGNC:5301",
      havana_gene : "OTTHUMG00000002713.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19682240,
      stop : 19799945,
      direction : "-",
      ID : "ENSG00000162542.14",
      gene_id : "ENSG00000162542.14",
      gene_type : "protein_coding",
      gene_name : "TMCO4",
      gene_level : 2,
      hgnc_id : "HGNC:27393",
      havana_gene : "OTTHUMG00000002697.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19814029,
      stop : 19815283,
      direction : "-",
      ID : "ENSG00000178828.7",
      gene_id : "ENSG00000178828.7",
      gene_type : "protein_coding",
      gene_name : "RNF186",
      gene_level : 2,
      hgnc_id : "HGNC:25978",
      havana_gene : "OTTHUMG00000002709.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19882395,
      stop : 19912945,
      direction : "+",
      ID : "ENSG00000169914.6",
      gene_id : "ENSG00000169914.6",
      gene_type : "protein_coding",
      gene_name : "OTUD3",
      gene_level : 2,
      hgnc_id : "HGNC:29038",
      havana_gene : "OTTHUMG00000002696.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19920009,
      stop : 19923617,
      direction : "-",
      ID : "ENSG00000188784.4",
      gene_id : "ENSG00000188784.4",
      gene_type : "protein_coding",
      gene_name : "PLA2G2E",
      gene_level : 2,
      hgnc_id : "HGNC:13414",
      havana_gene : "OTTHUMG00000002702.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 19975431,
      stop : 19980416,
      direction : "-",
      ID : "ENSG00000188257.12",
      gene_id : "ENSG00000188257.12",
      gene_type : "protein_coding",
      gene_name : "PLA2G2A",
      gene_level : 2,
      hgnc_id : "HGNC:9031",
      havana_gene : "OTTHUMG00000002699.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20028179,
      stop : 20091911,
      direction : "+",
      ID : "ENSG00000127472.11",
      gene_id : "ENSG00000127472.11",
      gene_type : "protein_coding",
      gene_name : "PLA2G5",
      gene_level : 2,
      hgnc_id : "HGNC:9038",
      havana_gene : "OTTHUMG00000002698.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20111939,
      stop : 20119566,
      direction : "-",
      ID : "ENSG00000117215.15",
      gene_id : "ENSG00000117215.15",
      gene_type : "protein_coding",
      gene_name : "PLA2G2D",
      gene_level : 2,
      hgnc_id : "HGNC:9033",
      havana_gene : "OTTHUMG00000002701.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20139323,
      stop : 20150381,
      direction : "+",
      ID : "ENSG00000158786.5",
      gene_id : "ENSG00000158786.5",
      gene_type : "protein_coding",
      gene_name : "PLA2G2F",
      gene_level : 2,
      hgnc_id : "HGNC:30040",
      havana_gene : "OTTHUMG00000002704.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20161253,
      stop : 20186518,
      direction : "-",
      ID : "ENSG00000187980.7",
      gene_id : "ENSG00000187980.7",
      gene_type : "protein_coding",
      gene_name : "PLA2G2C",
      gene_level : 1,
      hgnc_id : "HGNC:9032",
      havana_gene : "OTTHUMG00000002705.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20186096,
      stop : 20196050,
      direction : "+",
      ID : "ENSG00000162543.6",
      gene_id : "ENSG00000162543.6",
      gene_type : "protein_coding",
      gene_name : "UBXN10",
      gene_level : 2,
      hgnc_id : "HGNC:26354",
      havana_gene : "OTTHUMG00000002708.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20290919,
      stop : 20354894,
      direction : "+",
      ID : "ENSG00000158816.15",
      gene_id : "ENSG00000158816.15",
      gene_type : "protein_coding",
      gene_name : "VWA5B1",
      gene_level : 1,
      hgnc_id : "HGNC:26538",
      havana_gene : "OTTHUMG00000002835.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20482391,
      stop : 20486210,
      direction : "-",
      ID : "ENSG00000162545.6",
      gene_id : "ENSG00000162545.6",
      gene_type : "protein_coding",
      gene_name : "CAMK2N1",
      gene_level : 2,
      hgnc_id : "HGNC:24190",
      havana_gene : "OTTHUMG00000002837.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20499448,
      stop : 20508151,
      direction : "-",
      ID : "ENSG00000090432.7",
      gene_id : "ENSG00000090432.7",
      gene_type : "protein_coding",
      gene_name : "MUL1",
      gene_level : 2,
      hgnc_id : "HGNC:25762",
      havana_gene : "OTTHUMG00000002838.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20552573,
      stop : 20555020,
      direction : "+",
      ID : "ENSG00000183114.8",
      gene_id : "ENSG00000183114.8",
      gene_type : "protein_coding",
      gene_name : "FAM43B",
      gene_level : 2,
      hgnc_id : "HGNC:31791",
      havana_gene : "OTTHUMG00000057491.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20589086,
      stop : 20618903,
      direction : "+",
      ID : "ENSG00000158825.6",
      gene_id : "ENSG00000158825.6",
      gene_type : "protein_coding",
      gene_name : "CDA",
      gene_level : 2,
      hgnc_id : "HGNC:1712",
      havana_gene : "OTTHUMG00000002845.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20633458,
      stop : 20651511,
      direction : "+",
      ID : "ENSG00000158828.8",
      gene_id : "ENSG00000158828.8",
      gene_type : "protein_coding",
      gene_name : "PINK1",
      gene_level : 2,
      hgnc_id : "HGNC:14581",
      havana_gene : "OTTHUMG00000002841.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20651767,
      stop : 20661544,
      direction : "-",
      ID : "ENSG00000244038.11",
      gene_id : "ENSG00000244038.11",
      gene_type : "protein_coding",
      gene_name : "DDOST",
      gene_level : 1,
      hgnc_id : "HGNC:2728",
      havana_gene : "OTTHUMG00000002844.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20664014,
      stop : 20718017,
      direction : "-",
      ID : "ENSG00000117245.13",
      gene_id : "ENSG00000117245.13",
      gene_type : "protein_coding",
      gene_name : "KIF17",
      gene_level : 2,
      hgnc_id : "HGNC:19167",
      havana_gene : "OTTHUMG00000002863.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20719731,
      stop : 20732837,
      direction : "-",
      ID : "ENSG00000189410.12",
      gene_id : "ENSG00000189410.12",
      gene_type : "protein_coding",
      gene_name : "SH2D5",
      gene_level : 2,
      hgnc_id : "HGNC:28819",
      havana_gene : "OTTHUMG00000002620.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20740266,
      stop : 20787323,
      direction : "-",
      ID : "ENSG00000127483.19",
      gene_id : "ENSG00000127483.19",
      gene_type : "protein_coding",
      gene_name : "HP1BP3",
      gene_level : 2,
      hgnc_id : "HGNC:24973",
      havana_gene : "OTTHUMG00000002622.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 20806292,
      stop : 21176888,
      direction : "-",
      ID : "ENSG00000075151.22",
      gene_id : "ENSG00000075151.22",
      gene_type : "protein_coding",
      gene_name : "EIF4G3",
      gene_level : 1,
      hgnc_id : "HGNC:3298",
      havana_gene : "OTTHUMG00000002624.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21217247,
      stop : 21345572,
      direction : "-",
      ID : "ENSG00000117298.16",
      gene_id : "ENSG00000117298.16",
      gene_type : "protein_coding",
      gene_name : "ECE1",
      gene_level : 1,
      hgnc_id : "HGNC:3146",
      havana_gene : "OTTHUMG00000002625.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21440128,
      stop : 21485005,
      direction : "+",
      ID : "ENSG00000142794.19",
      gene_id : "ENSG00000142794.19",
      gene_type : "protein_coding",
      gene_name : "NBPF3",
      gene_level : 2,
      hgnc_id : "HGNC:25076",
      havana_gene : "OTTHUMG00000002944.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21509397,
      stop : 21578410,
      direction : "+",
      ID : "ENSG00000162551.14",
      gene_id : "ENSG00000162551.14",
      gene_type : "protein_coding",
      gene_name : "ALPL",
      gene_level : 2,
      hgnc_id : "HGNC:438",
      havana_gene : "OTTHUMG00000002949.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21596215,
      stop : 21669363,
      direction : "-",
      ID : "ENSG00000076864.19",
      gene_id : "ENSG00000076864.19",
      gene_type : "protein_coding",
      gene_name : "RAP1GAP",
      gene_level : 1,
      hgnc_id : "HGNC:9858",
      havana_gene : "OTTHUMG00000007513.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21678298,
      stop : 21783606,
      direction : "-",
      ID : "ENSG00000090686.16",
      gene_id : "ENSG00000090686.16",
      gene_type : "protein_coding",
      gene_name : "USP48",
      gene_level : 1,
      hgnc_id : "HGNC:18533",
      havana_gene : "OTTHUMG00000007798.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21812265,
      stop : 21825225,
      direction : "+",
      ID : "ENSG00000187942.12",
      gene_id : "ENSG00000187942.12",
      gene_type : "protein_coding",
      gene_name : "LDLRAD2",
      gene_level : 2,
      hgnc_id : "HGNC:32071",
      havana_gene : "OTTHUMG00000002675.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21822244,
      stop : 21937310,
      direction : "-",
      ID : "ENSG00000142798.20",
      gene_id : "ENSG00000142798.20",
      gene_type : "protein_coding",
      gene_name : "HSPG2",
      gene_level : 2,
      hgnc_id : "HGNC:5273",
      havana_gene : "OTTHUMG00000002674.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 21977022,
      stop : 21998642,
      direction : "+",
      ID : "ENSG00000219073.8",
      gene_id : "ENSG00000219073.8",
      gene_type : "protein_coding",
      gene_name : "CELA3B",
      gene_level : 2,
      hgnc_id : "HGNC:15945",
      havana_gene : "OTTHUMG00000002758.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22001657,
      stop : 22012542,
      direction : "+",
      ID : "ENSG00000142789.20",
      gene_id : "ENSG00000142789.20",
      gene_type : "protein_coding",
      gene_name : "CELA3A",
      gene_level : 2,
      hgnc_id : "HGNC:15944",
      havana_gene : "OTTHUMG00000002755.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22025511,
      stop : 22101360,
      direction : "+",
      ID : "ENSG00000070831.17",
      gene_id : "ENSG00000070831.17",
      gene_type : "protein_coding",
      gene_name : "CDC42",
      gene_level : 2,
      hgnc_id : "HGNC:1736",
      havana_gene : "OTTHUMG00000002753.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22117313,
      stop : 22143969,
      direction : "-",
      ID : "ENSG00000162552.15",
      gene_id : "ENSG00000162552.15",
      gene_type : "protein_coding",
      gene_name : "WNT4",
      gene_level : 2,
      hgnc_id : "HGNC:12783",
      havana_gene : "OTTHUMG00000002894.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22428838,
      stop : 22531157,
      direction : "+",
      ID : "ENSG00000184677.18",
      gene_id : "ENSG00000184677.18",
      gene_type : "protein_coding",
      gene_name : "ZBTB40",
      gene_level : 2,
      hgnc_id : "HGNC:29045",
      havana_gene : "OTTHUMG00000002897.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22563489,
      stop : 22603595,
      direction : "+",
      ID : "ENSG00000070886.12",
      gene_id : "ENSG00000070886.12",
      gene_type : "protein_coding",
      gene_name : "EPHA8",
      gene_level : 2,
      hgnc_id : "HGNC:3391",
      havana_gene : "OTTHUMG00000002892.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22636628,
      stop : 22639678,
      direction : "+",
      ID : "ENSG00000173372.17",
      gene_id : "ENSG00000173372.17",
      gene_type : "protein_coding",
      gene_name : "C1QA",
      gene_level : 2,
      hgnc_id : "HGNC:1241",
      havana_gene : "OTTHUMG00000002893.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22643633,
      stop : 22648110,
      direction : "+",
      ID : "ENSG00000159189.12",
      gene_id : "ENSG00000159189.12",
      gene_type : "protein_coding",
      gene_name : "C1QC",
      gene_level : 2,
      hgnc_id : "HGNC:1245",
      havana_gene : "OTTHUMG00000002891.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22652762,
      stop : 22661637,
      direction : "+",
      ID : "ENSG00000173369.17",
      gene_id : "ENSG00000173369.17",
      gene_type : "protein_coding",
      gene_name : "C1QB",
      gene_level : 2,
      hgnc_id : "HGNC:1242",
      havana_gene : "OTTHUMG00000002896.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22710839,
      stop : 22921500,
      direction : "+",
      ID : "ENSG00000133216.17",
      gene_id : "ENSG00000133216.17",
      gene_type : "protein_coding",
      gene_name : "EPHB2",
      gene_level : 2,
      hgnc_id : "HGNC:3393",
      havana_gene : "OTTHUMG00000002881.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 22953043,
      stop : 22965338,
      direction : "-",
      ID : "ENSG00000215906.8",
      gene_id : "ENSG00000215906.8",
      gene_type : "protein_coding",
      gene_name : "LACTBL1",
      gene_level : 1,
      hgnc_id : "HGNC:35445",
      havana_gene : "OTTHUMG00000003228.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23010834,
      stop : 23015852,
      direction : "-",
      ID : "ENSG00000227868.6",
      gene_id : "ENSG00000227868.6",
      gene_type : "protein_coding",
      gene_name : "TEX46",
      gene_level : 1,
      hgnc_id : "HGNC:44651",
      havana_gene : "OTTHUMG00000003226.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23019443,
      stop : 23083689,
      direction : "+",
      ID : "ENSG00000004487.17",
      gene_id : "ENSG00000004487.17",
      gene_type : "protein_coding",
      gene_name : "KDM1A",
      gene_level : 1,
      hgnc_id : "HGNC:29079",
      havana_gene : "OTTHUMG00000003220.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23084023,
      stop : 23177808,
      direction : "-",
      ID : "ENSG00000169641.13",
      gene_id : "ENSG00000169641.13",
      gene_type : "protein_coding",
      gene_name : "LUZP1",
      gene_level : 2,
      hgnc_id : "HGNC:14985",
      havana_gene : "OTTHUMG00000003227.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23191895,
      stop : 23194729,
      direction : "-",
      ID : "ENSG00000179546.4",
      gene_id : "ENSG00000179546.4",
      gene_type : "protein_coding",
      gene_name : "HTR1D",
      gene_level : 2,
      hgnc_id : "HGNC:5289",
      havana_gene : "OTTHUMG00000003235.1",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23303771,
      stop : 23344336,
      direction : "-",
      ID : "ENSG00000125944.21",
      gene_id : "ENSG00000125944.21",
      gene_type : "protein_coding",
      gene_name : "HNRNPR",
      gene_level : 2,
      hgnc_id : "HGNC:5047",
      havana_gene : "OTTHUMG00000003224.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23359448,
      stop : 23369836,
      direction : "-",
      ID : "ENSG00000125945.15",
      gene_id : "ENSG00000125945.15",
      gene_type : "protein_coding",
      gene_name : "ZNF436",
      gene_level : 2,
      hgnc_id : "HGNC:20814",
      havana_gene : "OTTHUMG00000003232.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23380909,
      stop : 23424748,
      direction : "-",
      ID : "ENSG00000204219.11",
      gene_id : "ENSG00000204219.11",
      gene_type : "protein_coding",
      gene_name : "TCEA3",
      gene_level : 2,
      hgnc_id : "HGNC:11615",
      havana_gene : "OTTHUMG00000003233.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23428563,
      stop : 23484568,
      direction : "-",
      ID : "ENSG00000088280.19",
      gene_id : "ENSG00000088280.19",
      gene_type : "protein_coding",
      gene_name : "ASAP3",
      gene_level : 1,
      hgnc_id : "HGNC:14987",
      havana_gene : "OTTHUMG00000003234.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23506438,
      stop : 23531233,
      direction : "-",
      ID : "ENSG00000007968.7",
      gene_id : "ENSG00000007968.7",
      gene_type : "protein_coding",
      gene_name : "E2F2",
      gene_level : 2,
      hgnc_id : "HGNC:3114",
      havana_gene : "OTTHUMG00000003223.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23557926,
      stop : 23559501,
      direction : "-",
      ID : "ENSG00000117318.9",
      gene_id : "ENSG00000117318.9",
      gene_type : "protein_coding",
      gene_name : "ID3",
      gene_level : 2,
      hgnc_id : "HGNC:5362",
      havana_gene : "OTTHUMG00000003229.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23691742,
      stop : 23696835,
      direction : "+",
      ID : "ENSG00000142676.14",
      gene_id : "ENSG00000142676.14",
      gene_type : "protein_coding",
      gene_name : "RPL11",
      gene_level : 2,
      hgnc_id : "HGNC:10301",
      havana_gene : "OTTHUMG00000002926.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23743155,
      stop : 23762059,
      direction : "+",
      ID : "ENSG00000011007.12",
      gene_id : "ENSG00000011007.12",
      gene_type : "protein_coding",
      gene_name : "ELOA",
      gene_level : 2,
      hgnc_id : "HGNC:11620",
      havana_gene : "OTTHUMG00000002957.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23778418,
      stop : 23788232,
      direction : "+",
      ID : "ENSG00000057757.10",
      gene_id : "ENSG00000057757.10",
      gene_type : "protein_coding",
      gene_name : "PITHD1",
      gene_level : 2,
      hgnc_id : "HGNC:25022",
      havana_gene : "OTTHUMG00000002960.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23791145,
      stop : 23795539,
      direction : "+",
      ID : "ENSG00000011009.11",
      gene_id : "ENSG00000011009.11",
      gene_type : "protein_coding",
      gene_name : "LYPLA2",
      gene_level : 2,
      hgnc_id : "HGNC:6738",
      havana_gene : "OTTHUMG00000002961.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23795599,
      stop : 23800781,
      direction : "-",
      ID : "ENSG00000117308.15",
      gene_id : "ENSG00000117308.15",
      gene_type : "protein_coding",
      gene_name : "GALE",
      gene_level : 2,
      hgnc_id : "HGNC:4116",
      havana_gene : "OTTHUMG00000002958.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23801885,
      stop : 23838620,
      direction : "-",
      ID : "ENSG00000117305.15",
      gene_id : "ENSG00000117305.15",
      gene_type : "protein_coding",
      gene_name : "HMGCL",
      gene_level : 1,
      hgnc_id : "HGNC:5005",
      havana_gene : "OTTHUMG00000002963.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23845077,
      stop : 23868290,
      direction : "-",
      ID : "ENSG00000179163.12",
      gene_id : "ENSG00000179163.12",
      gene_type : "protein_coding",
      gene_name : "FUCA1",
      gene_level : 2,
      hgnc_id : "HGNC:4006",
      havana_gene : "OTTHUMG00000002965.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23870515,
      stop : 23913362,
      direction : "-",
      ID : "ENSG00000188822.8",
      gene_id : "ENSG00000188822.8",
      gene_type : "protein_coding",
      gene_name : "CNR2",
      gene_level : 2,
      hgnc_id : "HGNC:2160",
      havana_gene : "OTTHUMG00000013892.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23956839,
      stop : 23963462,
      direction : "+",
      ID : "ENSG00000189266.13",
      gene_id : "ENSG00000189266.13",
      gene_type : "protein_coding",
      gene_name : "PNRC2",
      gene_level : 2,
      hgnc_id : "HGNC:23158",
      havana_gene : "OTTHUMG00000013891.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 23964347,
      stop : 23980927,
      direction : "-",
      ID : "ENSG00000188529.15",
      gene_id : "ENSG00000188529.15",
      gene_type : "protein_coding",
      gene_name : "SRSF10",
      gene_level : 2,
      hgnc_id : "HGNC:16713",
      havana_gene : "OTTHUMG00000013893.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24056035,
      stop : 24112135,
      direction : "-",
      ID : "ENSG00000142661.19",
      gene_id : "ENSG00000142661.19",
      gene_type : "protein_coding",
      gene_name : "MYOM3",
      gene_level : 2,
      hgnc_id : "HGNC:26679",
      havana_gene : "OTTHUMG00000002969.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24119771,
      stop : 24143140,
      direction : "-",
      ID : "ENSG00000142677.4",
      gene_id : "ENSG00000142677.4",
      gene_type : "protein_coding",
      gene_name : "IL22RA1",
      gene_level : 2,
      hgnc_id : "HGNC:13700",
      havana_gene : "OTTHUMG00000003041.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24154168,
      stop : 24187959,
      direction : "-",
      ID : "ENSG00000185436.12",
      gene_id : "ENSG00000185436.12",
      gene_type : "protein_coding",
      gene_name : "IFNLR1",
      gene_level : 2,
      hgnc_id : "HGNC:18584",
      havana_gene : "OTTHUMG00000003036.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24319357,
      stop : 24364482,
      direction : "+",
      ID : "ENSG00000158055.16",
      gene_id : "ENSG00000158055.16",
      gene_type : "protein_coding",
      gene_name : "GRHL3",
      gene_level : 2,
      hgnc_id : "HGNC:25839",
      havana_gene : "OTTHUMG00000003040.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24356999,
      stop : 24416934,
      direction : "-",
      ID : "ENSG00000001460.18",
      gene_id : "ENSG00000001460.18",
      gene_type : "protein_coding",
      gene_name : "STPG1",
      gene_level : 2,
      hgnc_id : "HGNC:28070",
      havana_gene : "OTTHUMG00000003297.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24415802,
      stop : 24472976,
      direction : "+",
      ID : "ENSG00000001461.17",
      gene_id : "ENSG00000001461.17",
      gene_type : "protein_coding",
      gene_name : "NIPAL3",
      gene_level : 2,
      hgnc_id : "HGNC:25233",
      havana_gene : "OTTHUMG00000003299.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24502351,
      stop : 24541040,
      direction : "+",
      ID : "ENSG00000117602.13",
      gene_id : "ENSG00000117602.13",
      gene_type : "protein_coding",
      gene_name : "RCAN3",
      gene_level : 2,
      hgnc_id : "HGNC:3042",
      havana_gene : "OTTHUMG00000003298.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24556087,
      stop : 24609328,
      direction : "+",
      ID : "ENSG00000184454.7",
      gene_id : "ENSG00000184454.7",
      gene_type : "protein_coding",
      gene_name : "NCMAP",
      gene_level : 2,
      hgnc_id : "HGNC:29332",
      havana_gene : "OTTHUMG00000003317.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24631716,
      stop : 24673281,
      direction : "+",
      ID : "ENSG00000133226.17",
      gene_id : "ENSG00000133226.17",
      gene_type : "protein_coding",
      gene_name : "SRRM1",
      gene_level : 2,
      hgnc_id : "HGNC:16638",
      havana_gene : "OTTHUMG00000003320.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24745382,
      stop : 24844321,
      direction : "+",
      ID : "ENSG00000169504.15",
      gene_id : "ENSG00000169504.15",
      gene_type : "protein_coding",
      gene_name : "CLIC4",
      gene_level : 2,
      hgnc_id : "HGNC:13518",
      havana_gene : "OTTHUMG00000003327.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 24899511,
      stop : 24965121,
      direction : "-",
      ID : "ENSG00000020633.19",
      gene_id : "ENSG00000020633.19",
      gene_type : "protein_coding",
      gene_name : "RUNX3",
      gene_level : 2,
      hgnc_id : "HGNC:10473",
      havana_gene : "OTTHUMG00000003316.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25222276,
      stop : 25232502,
      direction : "-",
      ID : "ENSG00000117614.10",
      gene_id : "ENSG00000117614.10",
      gene_type : "protein_coding",
      gene_name : "SYF2",
      gene_level : 2,
      hgnc_id : "HGNC:19824",
      havana_gene : "OTTHUMG00000043610.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25242249,
      stop : 25338213,
      direction : "-",
      ID : "ENSG00000117616.18",
      gene_id : "ENSG00000117616.18",
      gene_type : "protein_coding",
      gene_name : "RSRP1",
      gene_level : 2,
      hgnc_id : "HGNC:25234",
      havana_gene : "OTTHUMG00000043611.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25272393,
      stop : 25330445,
      direction : "+",
      ID : "ENSG00000187010.21",
      gene_id : "ENSG00000187010.21",
      gene_type : "protein_coding",
      gene_name : "RHD",
      gene_level : 2,
      hgnc_id : "HGNC:10009",
      havana_gene : "OTTHUMG00000003476.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25338317,
      stop : 25362361,
      direction : "+",
      ID : "ENSG00000183726.11",
      gene_id : "ENSG00000183726.11",
      gene_type : "protein_coding",
      gene_name : "TMEM50A",
      gene_level : 2,
      hgnc_id : "HGNC:30590",
      havana_gene : "OTTHUMG00000007651.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25362249,
      stop : 25430192,
      direction : "-",
      ID : "ENSG00000188672.19",
      gene_id : "ENSG00000188672.19",
      gene_type : "protein_coding",
      gene_name : "RHCE",
      gene_level : 1,
      hgnc_id : "HGNC:10008",
      havana_gene : "OTTHUMG00000007650.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25430858,
      stop : 25500209,
      direction : "+",
      ID : "ENSG00000204178.11",
      gene_id : "ENSG00000204178.11",
      gene_type : "protein_coding",
      gene_name : "MACO1",
      gene_level : 2,
      hgnc_id : "HGNC:25572",
      havana_gene : "OTTHUMG00000003473.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25543606,
      stop : 25568886,
      direction : "+",
      ID : "ENSG00000157978.12",
      gene_id : "ENSG00000157978.12",
      gene_type : "protein_coding",
      gene_name : "LDLRAP1",
      gene_level : 2,
      hgnc_id : "HGNC:18640",
      havana_gene : "OTTHUMG00000007386.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25616791,
      stop : 25786206,
      direction : "+",
      ID : "ENSG00000117643.15",
      gene_id : "ENSG00000117643.15",
      gene_type : "protein_coding",
      gene_name : "MAN1C1",
      gene_level : 2,
      hgnc_id : "HGNC:19080",
      havana_gene : "OTTHUMG00000004417.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25800176,
      stop : 25818221,
      direction : "+",
      ID : "ENSG00000162430.17",
      gene_id : "ENSG00000162430.17",
      gene_type : "protein_coding",
      gene_name : "SELENON",
      gene_level : 2,
      hgnc_id : "HGNC:15999",
      havana_gene : "OTTHUMG00000007375.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25811470,
      stop : 25823744,
      direction : "+",
      ID : "ENSG00000255054.3",
      gene_id : "ENSG00000255054.3",
      gene_type : "protein_coding",
      gene_name : "AL020996.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167136.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25818640,
      stop : 25832942,
      direction : "+",
      ID : "ENSG00000117640.18",
      gene_id : "ENSG00000117640.18",
      gene_type : "protein_coding",
      gene_name : "MTFR1L",
      gene_level : 1,
      hgnc_id : "HGNC:28836",
      havana_gene : "OTTHUMG00000007377.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25831913,
      stop : 25859458,
      direction : "-",
      ID : "ENSG00000127423.11",
      gene_id : "ENSG00000127423.11",
      gene_type : "protein_coding",
      gene_name : "AUNIP",
      gene_level : 2,
      hgnc_id : "HGNC:28363",
      havana_gene : "OTTHUMG00000007372.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25861484,
      stop : 25875708,
      direction : "-",
      ID : "ENSG00000182749.6",
      gene_id : "ENSG00000182749.6",
      gene_type : "protein_coding",
      gene_name : "PAQR7",
      gene_level : 2,
      hgnc_id : "HGNC:23146",
      havana_gene : "OTTHUMG00000007373.1",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25884181,
      stop : 25906991,
      direction : "-",
      ID : "ENSG00000117632.23",
      gene_id : "ENSG00000117632.23",
      gene_type : "protein_coding",
      gene_name : "STMN1",
      gene_level : 2,
      hgnc_id : "HGNC:6510",
      havana_gene : "OTTHUMG00000007389.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 25959767,
      stop : 25998117,
      direction : "-",
      ID : "ENSG00000158006.14",
      gene_id : "ENSG00000158006.14",
      gene_type : "protein_coding",
      gene_name : "PAFAH2",
      gene_level : 2,
      hgnc_id : "HGNC:8579",
      havana_gene : "OTTHUMG00000007437.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26019884,
      stop : 26036464,
      direction : "+",
      ID : "ENSG00000158008.10",
      gene_id : "ENSG00000158008.10",
      gene_type : "protein_coding",
      gene_name : "EXTL1",
      gene_level : 2,
      hgnc_id : "HGNC:3515",
      havana_gene : "OTTHUMG00000007509.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26037252,
      stop : 26046118,
      direction : "-",
      ID : "ENSG00000158014.15",
      gene_id : "ENSG00000158014.15",
      gene_type : "protein_coding",
      gene_name : "SLC30A2",
      gene_level : 2,
      hgnc_id : "HGNC:11013",
      havana_gene : "OTTHUMG00000007508.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26051301,
      stop : 26068436,
      direction : "-",
      ID : "ENSG00000158022.7",
      gene_id : "ENSG00000158022.7",
      gene_type : "protein_coding",
      gene_name : "TRIM63",
      gene_level : 2,
      hgnc_id : "HGNC:16007",
      havana_gene : "OTTHUMG00000007510.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26111165,
      stop : 26125555,
      direction : "+",
      ID : "ENSG00000175087.10",
      gene_id : "ENSG00000175087.10",
      gene_type : "protein_coding",
      gene_name : "PDIK1L",
      gene_level : 2,
      hgnc_id : "HGNC:18981",
      havana_gene : "OTTHUMG00000007511.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26159079,
      stop : 26163962,
      direction : "+",
      ID : "ENSG00000197245.6",
      gene_id : "ENSG00000197245.6",
      gene_type : "protein_coding",
      gene_name : "FAM110D",
      gene_level : 2,
      hgnc_id : "HGNC:25860",
      havana_gene : "OTTHUMG00000007537.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26164101,
      stop : 26168963,
      direction : "-",
      ID : "ENSG00000282872.2",
      gene_id : "ENSG00000282872.2",
      gene_type : "protein_coding",
      gene_name : "C1orf232",
      gene_level : 2,
      hgnc_id : "HGNC:53426",
      havana_gene : "OTTHUMG00000191595.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26169516,
      stop : 26171831,
      direction : "-",
      ID : "ENSG00000236782.7",
      gene_id : "ENSG00000236782.7",
      gene_type : "protein_coding",
      gene_name : "AL391650.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000007539.4",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26169908,
      stop : 26170873,
      direction : "+",
      ID : "ENSG00000142684.9",
      gene_id : "ENSG00000142684.9",
      gene_type : "protein_coding",
      gene_name : "ZNF593",
      gene_level : 2,
      hgnc_id : "HGNC:30943",
      havana_gene : "OTTHUMG00000007538.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26177484,
      stop : 26189884,
      direction : "+",
      ID : "ENSG00000142675.18",
      gene_id : "ENSG00000142675.18",
      gene_type : "protein_coding",
      gene_name : "CNKSR1",
      gene_level : 2,
      hgnc_id : "HGNC:19700",
      havana_gene : "OTTHUMG00000007541.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26190561,
      stop : 26202968,
      direction : "+",
      ID : "ENSG00000188782.9",
      gene_id : "ENSG00000188782.9",
      gene_type : "protein_coding",
      gene_name : "CATSPER4",
      gene_level : 2,
      hgnc_id : "HGNC:23220",
      havana_gene : "OTTHUMG00000003383.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26234200,
      stop : 26278808,
      direction : "+",
      ID : "ENSG00000130695.16",
      gene_id : "ENSG00000130695.16",
      gene_type : "protein_coding",
      gene_name : "CEP85",
      gene_level : 2,
      hgnc_id : "HGNC:25309",
      havana_gene : "OTTHUMG00000003380.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26280086,
      stop : 26281522,
      direction : "+",
      ID : "ENSG00000142669.15",
      gene_id : "ENSG00000142669.15",
      gene_type : "protein_coding",
      gene_name : "SH3BGRL3",
      gene_level : 2,
      hgnc_id : "HGNC:15568",
      havana_gene : "OTTHUMG00000003381.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26281328,
      stop : 26318363,
      direction : "-",
      ID : "ENSG00000158062.20",
      gene_id : "ENSG00000158062.20",
      gene_type : "protein_coding",
      gene_name : "UBXN11",
      gene_level : 2,
      hgnc_id : "HGNC:30600",
      havana_gene : "OTTHUMG00000003382.13",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26317958,
      stop : 26320523,
      direction : "+",
      ID : "ENSG00000169442.9",
      gene_id : "ENSG00000169442.9",
      gene_type : "protein_coding",
      gene_name : "CD52",
      gene_level : 2,
      hgnc_id : "HGNC:1804",
      havana_gene : "OTTHUMG00000003491.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26321698,
      stop : 26360080,
      direction : "-",
      ID : "ENSG00000176092.17",
      gene_id : "ENSG00000176092.17",
      gene_type : "protein_coding",
      gene_name : "CRYBG2",
      gene_level : 1,
      hgnc_id : "HGNC:17295",
      havana_gene : "OTTHUMG00000003490.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26361634,
      stop : 26374522,
      direction : "-",
      ID : "ENSG00000176083.18",
      gene_id : "ENSG00000176083.18",
      gene_type : "protein_coding",
      gene_name : "ZNF683",
      gene_level : 1,
      hgnc_id : "HGNC:28495",
      havana_gene : "OTTHUMG00000003521.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26410817,
      stop : 26429728,
      direction : "+",
      ID : "ENSG00000131914.11",
      gene_id : "ENSG00000131914.11",
      gene_type : "protein_coding",
      gene_name : "LIN28A",
      gene_level : 2,
      hgnc_id : "HGNC:15986",
      havana_gene : "OTTHUMG00000003550.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26432282,
      stop : 26471306,
      direction : "+",
      ID : "ENSG00000117682.17",
      gene_id : "ENSG00000117682.17",
      gene_type : "protein_coding",
      gene_name : "DHDDS",
      gene_level : 1,
      hgnc_id : "HGNC:20603",
      havana_gene : "OTTHUMG00000003554.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26472440,
      stop : 26476642,
      direction : "+",
      ID : "ENSG00000198830.11",
      gene_id : "ENSG00000198830.11",
      gene_type : "protein_coding",
      gene_name : "HMGN2",
      gene_level : 2,
      hgnc_id : "HGNC:4986",
      havana_gene : "OTTHUMG00000003555.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26529761,
      stop : 26575030,
      direction : "+",
      ID : "ENSG00000117676.14",
      gene_id : "ENSG00000117676.14",
      gene_type : "protein_coding",
      gene_name : "RPS6KA1",
      gene_level : 2,
      hgnc_id : "HGNC:10430",
      havana_gene : "OTTHUMG00000004003.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26693236,
      stop : 26782104,
      direction : "+",
      ID : "ENSG00000117713.20",
      gene_id : "ENSG00000117713.20",
      gene_type : "protein_coding",
      gene_name : "ARID1A",
      gene_level : 1,
      hgnc_id : "HGNC:11110",
      havana_gene : "OTTHUMG00000004004.13",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26787054,
      stop : 26800659,
      direction : "+",
      ID : "ENSG00000060642.11",
      gene_id : "ENSG00000060642.11",
      gene_type : "protein_coding",
      gene_name : "PIGV",
      gene_level : 2,
      hgnc_id : "HGNC:26031",
      havana_gene : "OTTHUMG00000004005.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26826688,
      stop : 26857604,
      direction : "+",
      ID : "ENSG00000204160.12",
      gene_id : "ENSG00000204160.12",
      gene_type : "protein_coding",
      gene_name : "ZDHHC18",
      gene_level : 1,
      hgnc_id : "HGNC:20712",
      havana_gene : "OTTHUMG00000004092.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26863149,
      stop : 26864456,
      direction : "+",
      ID : "ENSG00000175793.12",
      gene_id : "ENSG00000175793.12",
      gene_type : "protein_coding",
      gene_name : "SFN",
      gene_level : 2,
      hgnc_id : "HGNC:10773",
      havana_gene : "OTTHUMG00000004093.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26876132,
      stop : 26890283,
      direction : "-",
      ID : "ENSG00000142751.15",
      gene_id : "ENSG00000142751.15",
      gene_type : "protein_coding",
      gene_name : "GPN2",
      gene_level : 2,
      hgnc_id : "HGNC:25513",
      havana_gene : "OTTHUMG00000004227.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26890488,
      stop : 26900467,
      direction : "-",
      ID : "ENSG00000198746.13",
      gene_id : "ENSG00000198746.13",
      gene_type : "protein_coding",
      gene_name : "GPATCH3",
      gene_level : 2,
      hgnc_id : "HGNC:25720",
      havana_gene : "OTTHUMG00000004229.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26900238,
      stop : 26946871,
      direction : "+",
      ID : "ENSG00000090273.14",
      gene_id : "ENSG00000090273.14",
      gene_type : "protein_coding",
      gene_name : "NUDC",
      gene_level : 1,
      hgnc_id : "HGNC:8045",
      havana_gene : "OTTHUMG00000004226.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26911489,
      stop : 26913975,
      direction : "-",
      ID : "ENSG00000131910.5",
      gene_id : "ENSG00000131910.5",
      gene_type : "protein_coding",
      gene_name : "NR0B2",
      gene_level : 2,
      hgnc_id : "HGNC:7961",
      havana_gene : "OTTHUMG00000004231.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26949562,
      stop : 26960468,
      direction : "-",
      ID : "ENSG00000175707.9",
      gene_id : "ENSG00000175707.9",
      gene_type : "protein_coding",
      gene_name : "KDF1",
      gene_level : 2,
      hgnc_id : "HGNC:26624",
      havana_gene : "OTTHUMG00000004272.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 26993692,
      stop : 27000886,
      direction : "+",
      ID : "ENSG00000253368.4",
      gene_id : "ENSG00000253368.4",
      gene_type : "protein_coding",
      gene_name : "TRNP1",
      gene_level : 2,
      hgnc_id : "HGNC:34348",
      havana_gene : "OTTHUMG00000004277.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27005020,
      stop : 27012850,
      direction : "-",
      ID : "ENSG00000158246.8",
      gene_id : "ENSG00000158246.8",
      gene_type : "protein_coding",
      gene_name : "TENT5B",
      gene_level : 2,
      hgnc_id : "HGNC:28273",
      havana_gene : "OTTHUMG00000004278.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27098809,
      stop : 27166981,
      direction : "-",
      ID : "ENSG00000090020.11",
      gene_id : "ENSG00000090020.11",
      gene_type : "protein_coding",
      gene_name : "SLC9A1",
      gene_level : 2,
      hgnc_id : "HGNC:11071",
      havana_gene : "OTTHUMG00000004271.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27234632,
      stop : 27308636,
      direction : "+",
      ID : "ENSG00000142784.16",
      gene_id : "ENSG00000142784.16",
      gene_type : "protein_coding",
      gene_name : "WDTC1",
      gene_level : 2,
      hgnc_id : "HGNC:29175",
      havana_gene : "OTTHUMG00000004273.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27322145,
      stop : 27336400,
      direction : "+",
      ID : "ENSG00000186501.15",
      gene_id : "ENSG00000186501.15",
      gene_type : "protein_coding",
      gene_name : "TMEM222",
      gene_level : 2,
      hgnc_id : "HGNC:25363",
      havana_gene : "OTTHUMG00000004410.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27342020,
      stop : 27353937,
      direction : "+",
      ID : "ENSG00000142765.18",
      gene_id : "ENSG00000142765.18",
      gene_type : "protein_coding",
      gene_name : "SYTL1",
      gene_level : 2,
      hgnc_id : "HGNC:15584",
      havana_gene : "OTTHUMG00000005770.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27354067,
      stop : 27366961,
      direction : "-",
      ID : "ENSG00000142733.17",
      gene_id : "ENSG00000142733.17",
      gene_type : "protein_coding",
      gene_name : "MAP3K6",
      gene_level : 2,
      hgnc_id : "HGNC:6858",
      havana_gene : "OTTHUMG00000004631.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27369110,
      stop : 27374824,
      direction : "-",
      ID : "ENSG00000142748.13",
      gene_id : "ENSG00000142748.13",
      gene_type : "protein_coding",
      gene_name : "FCN3",
      gene_level : 2,
      hgnc_id : "HGNC:3625",
      havana_gene : "OTTHUMG00000005722.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27379176,
      stop : 27383333,
      direction : "-",
      ID : "ENSG00000174950.11",
      gene_id : "ENSG00000174950.11",
      gene_type : "protein_coding",
      gene_name : "CD164L2",
      gene_level : 2,
      hgnc_id : "HGNC:32043",
      havana_gene : "OTTHUMG00000003395.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27392622,
      stop : 27395814,
      direction : "+",
      ID : "ENSG00000181773.7",
      gene_id : "ENSG00000181773.7",
      gene_type : "protein_coding",
      gene_name : "GPR3",
      gene_level : 2,
      hgnc_id : "HGNC:4484",
      havana_gene : "OTTHUMG00000003397.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27404230,
      stop : 27490167,
      direction : "-",
      ID : "ENSG00000158195.11",
      gene_id : "ENSG00000158195.11",
      gene_type : "protein_coding",
      gene_name : "WASF2",
      gene_level : 2,
      hgnc_id : "HGNC:12733",
      havana_gene : "OTTHUMG00000003393.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27534035,
      stop : 27604431,
      direction : "-",
      ID : "ENSG00000126705.15",
      gene_id : "ENSG00000126705.15",
      gene_type : "protein_coding",
      gene_name : "AHDC1",
      gene_level : 2,
      hgnc_id : "HGNC:25230",
      havana_gene : "OTTHUMG00000003398.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27612064,
      stop : 27635185,
      direction : "-",
      ID : "ENSG00000000938.13",
      gene_id : "ENSG00000000938.13",
      gene_type : "protein_coding",
      gene_name : "FGR",
      gene_level : 2,
      hgnc_id : "HGNC:3697",
      havana_gene : "OTTHUMG00000003516.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27666064,
      stop : 27672212,
      direction : "-",
      ID : "ENSG00000126709.16",
      gene_id : "ENSG00000126709.16",
      gene_type : "protein_coding",
      gene_name : "IFI6",
      gene_level : 2,
      hgnc_id : "HGNC:4054",
      havana_gene : "OTTHUMG00000003518.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27725961,
      stop : 27763116,
      direction : "+",
      ID : "ENSG00000009780.16",
      gene_id : "ENSG00000009780.16",
      gene_type : "protein_coding",
      gene_name : "FAM76A",
      gene_level : 1,
      hgnc_id : "HGNC:28530",
      havana_gene : "OTTHUMG00000003729.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27773219,
      stop : 27824443,
      direction : "+",
      ID : "ENSG00000117758.14",
      gene_id : "ENSG00000117758.14",
      gene_type : "protein_coding",
      gene_name : "STX12",
      gene_level : 2,
      hgnc_id : "HGNC:11430",
      havana_gene : "OTTHUMG00000003730.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27830782,
      stop : 27851676,
      direction : "+",
      ID : "ENSG00000117751.18",
      gene_id : "ENSG00000117751.18",
      gene_type : "protein_coding",
      gene_name : "PPP1R8",
      gene_level : 1,
      hgnc_id : "HGNC:9296",
      havana_gene : "OTTHUMG00000003734.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27872543,
      stop : 27886685,
      direction : "+",
      ID : "ENSG00000130775.16",
      gene_id : "ENSG00000130775.16",
      gene_type : "protein_coding",
      gene_name : "THEMIS2",
      gene_level : 2,
      hgnc_id : "HGNC:16839",
      havana_gene : "OTTHUMG00000003735.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27891524,
      stop : 27914746,
      direction : "-",
      ID : "ENSG00000117748.10",
      gene_id : "ENSG00000117748.10",
      gene_type : "protein_coding",
      gene_name : "RPA2",
      gene_level : 2,
      hgnc_id : "HGNC:10290",
      havana_gene : "OTTHUMG00000003915.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27935000,
      stop : 27959157,
      direction : "+",
      ID : "ENSG00000130768.15",
      gene_id : "ENSG00000130768.15",
      gene_type : "protein_coding",
      gene_name : "SMPDL3B",
      gene_level : 2,
      hgnc_id : "HGNC:21416",
      havana_gene : "OTTHUMG00000003910.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27959588,
      stop : 27968093,
      direction : "+",
      ID : "ENSG00000158156.9",
      gene_id : "ENSG00000158156.9",
      gene_type : "protein_coding",
      gene_name : "XKR8",
      gene_level : 2,
      hgnc_id : "HGNC:25508",
      havana_gene : "OTTHUMG00000003912.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 27970344,
      stop : 28088637,
      direction : "-",
      ID : "ENSG00000158161.16",
      gene_id : "ENSG00000158161.16",
      gene_type : "protein_coding",
      gene_name : "EYA3",
      gene_level : 2,
      hgnc_id : "HGNC:3521",
      havana_gene : "OTTHUMG00000003916.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28147166,
      stop : 28193936,
      direction : "-",
      ID : "ENSG00000169403.12",
      gene_id : "ENSG00000169403.12",
      gene_type : "protein_coding",
      gene_name : "PTAFR",
      gene_level : 2,
      hgnc_id : "HGNC:9582",
      havana_gene : "OTTHUMG00000003953.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28199456,
      stop : 28233029,
      direction : "-",
      ID : "ENSG00000126698.11",
      gene_id : "ENSG00000126698.11",
      gene_type : "protein_coding",
      gene_name : "DNAJC8",
      gene_level : 1,
      hgnc_id : "HGNC:15470",
      havana_gene : "OTTHUMG00000003538.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28236109,
      stop : 28246906,
      direction : "+",
      ID : "ENSG00000130770.18",
      gene_id : "ENSG00000130770.18",
      gene_type : "protein_coding",
      gene_name : "ATP5IF1",
      gene_level : 1,
      hgnc_id : "HGNC:871",
      havana_gene : "OTTHUMG00000003533.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28259518,
      stop : 28282491,
      direction : "+",
      ID : "ENSG00000130766.5",
      gene_id : "ENSG00000130766.5",
      gene_type : "protein_coding",
      gene_name : "SESN2",
      gene_level : 2,
      hgnc_id : "HGNC:20746",
      havana_gene : "OTTHUMG00000003532.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28329002,
      stop : 28335965,
      direction : "+",
      ID : "ENSG00000130772.14",
      gene_id : "ENSG00000130772.14",
      gene_type : "protein_coding",
      gene_name : "MED18",
      gene_level : 2,
      hgnc_id : "HGNC:25944",
      havana_gene : "OTTHUMG00000003537.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28369582,
      stop : 28500364,
      direction : "+",
      ID : "ENSG00000204138.13",
      gene_id : "ENSG00000204138.13",
      gene_type : "protein_coding",
      gene_name : "PHACTR4",
      gene_level : 2,
      hgnc_id : "HGNC:25793",
      havana_gene : "OTTHUMG00000003541.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28505943,
      stop : 28539300,
      direction : "+",
      ID : "ENSG00000180198.16",
      gene_id : "ENSG00000180198.16",
      gene_type : "protein_coding",
      gene_name : "RCC1",
      gene_level : 1,
      hgnc_id : "HGNC:1913",
      havana_gene : "OTTHUMG00000003645.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28553085,
      stop : 28578545,
      direction : "+",
      ID : "ENSG00000180098.9",
      gene_id : "ENSG00000180098.9",
      gene_type : "protein_coding",
      gene_name : "TRNAU1AP",
      gene_level : 2,
      hgnc_id : "HGNC:30813",
      havana_gene : "OTTHUMG00000003653.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28589323,
      stop : 28643085,
      direction : "-",
      ID : "ENSG00000120656.12",
      gene_id : "ENSG00000120656.12",
      gene_type : "protein_coding",
      gene_name : "TAF12",
      gene_level : 2,
      hgnc_id : "HGNC:11545",
      havana_gene : "OTTHUMG00000003655.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28592200,
      stop : 28595449,
      direction : "+",
      ID : "ENSG00000188060.8",
      gene_id : "ENSG00000188060.8",
      gene_type : "protein_coding",
      gene_name : "RAB42",
      gene_level : 2,
      hgnc_id : "HGNC:28702",
      havana_gene : "OTTHUMG00000003656.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28668778,
      stop : 28719353,
      direction : "+",
      ID : "ENSG00000162419.13",
      gene_id : "ENSG00000162419.13",
      gene_type : "protein_coding",
      gene_name : "GMEB1",
      gene_level : 2,
      hgnc_id : "HGNC:4370",
      havana_gene : "OTTHUMG00000003647.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28736621,
      stop : 28769775,
      direction : "+",
      ID : "ENSG00000198492.16",
      gene_id : "ENSG00000198492.16",
      gene_type : "protein_coding",
      gene_name : "YTHDF2",
      gene_level : 1,
      hgnc_id : "HGNC:31675",
      havana_gene : "OTTHUMG00000003648.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28812142,
      stop : 28871267,
      direction : "+",
      ID : "ENSG00000116329.11",
      gene_id : "ENSG00000116329.11",
      gene_type : "protein_coding",
      gene_name : "OPRD1",
      gene_level : 2,
      hgnc_id : "HGNC:8153",
      havana_gene : "OTTHUMG00000003646.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 28887091,
      stop : 29120046,
      direction : "+",
      ID : "ENSG00000159023.22",
      gene_id : "ENSG00000159023.22",
      gene_type : "protein_coding",
      gene_name : "EPB41",
      gene_level : 2,
      hgnc_id : "HGNC:3377",
      havana_gene : "OTTHUMG00000003644.30",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 29119429,
      stop : 29123903,
      direction : "-",
      ID : "ENSG00000253304.2",
      gene_id : "ENSG00000253304.2",
      gene_type : "protein_coding",
      gene_name : "TMEM200B",
      gene_level : 2,
      hgnc_id : "HGNC:33785",
      havana_gene : "OTTHUMG00000003658.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 29147743,
      stop : 29181900,
      direction : "-",
      ID : "ENSG00000116350.17",
      gene_id : "ENSG00000116350.17",
      gene_type : "protein_coding",
      gene_name : "SRSF4",
      gene_level : 2,
      hgnc_id : "HGNC:10786",
      havana_gene : "OTTHUMG00000003663.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 29192657,
      stop : 29230942,
      direction : "-",
      ID : "ENSG00000116353.16",
      gene_id : "ENSG00000116353.16",
      gene_type : "protein_coding",
      gene_name : "MECR",
      gene_level : 2,
      hgnc_id : "HGNC:19691",
      havana_gene : "OTTHUMG00000059082.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 29236516,
      stop : 29326813,
      direction : "+",
      ID : "ENSG00000060656.20",
      gene_id : "ENSG00000060656.20",
      gene_type : "protein_coding",
      gene_name : "PTPRU",
      gene_level : 2,
      hgnc_id : "HGNC:9683",
      havana_gene : "OTTHUMG00000003699.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 30711277,
      stop : 30723585,
      direction : "-",
      ID : "ENSG00000162510.6",
      gene_id : "ENSG00000162510.6",
      gene_type : "protein_coding",
      gene_name : "MATN1",
      gene_level : 2,
      hgnc_id : "HGNC:6907",
      havana_gene : "OTTHUMG00000003705.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 30732469,
      stop : 30757774,
      direction : "-",
      ID : "ENSG00000162511.8",
      gene_id : "ENSG00000162511.8",
      gene_type : "protein_coding",
      gene_name : "LAPTM5",
      gene_level : 2,
      hgnc_id : "HGNC:29612",
      havana_gene : "OTTHUMG00000003707.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 30869466,
      stop : 30908758,
      direction : "-",
      ID : "ENSG00000162512.16",
      gene_id : "ENSG00000162512.16",
      gene_type : "protein_coding",
      gene_name : "SDC3",
      gene_level : 2,
      hgnc_id : "HGNC:10660",
      havana_gene : "OTTHUMG00000043646.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 30931506,
      stop : 31065991,
      direction : "-",
      ID : "ENSG00000134644.16",
      gene_id : "ENSG00000134644.16",
      gene_type : "protein_coding",
      gene_name : "PUM1",
      gene_level : 1,
      hgnc_id : "HGNC:14957",
      havana_gene : "OTTHUMG00000003795.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31179745,
      stop : 31239887,
      direction : "-",
      ID : "ENSG00000084628.10",
      gene_id : "ENSG00000084628.10",
      gene_type : "protein_coding",
      gene_name : "NKAIN1",
      gene_level : 2,
      hgnc_id : "HGNC:25743",
      havana_gene : "OTTHUMG00000003788.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31259568,
      stop : 31296788,
      direction : "-",
      ID : "ENSG00000060688.13",
      gene_id : "ENSG00000060688.13",
      gene_type : "protein_coding",
      gene_name : "SNRNP40",
      gene_level : 2,
      hgnc_id : "HGNC:30857",
      havana_gene : "OTTHUMG00000003790.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31296982,
      stop : 31364953,
      direction : "+",
      ID : "ENSG00000121766.16",
      gene_id : "ENSG00000121766.16",
      gene_type : "protein_coding",
      gene_name : "ZCCHC17",
      gene_level : 2,
      hgnc_id : "HGNC:30246",
      havana_gene : "OTTHUMG00000003791.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31365253,
      stop : 31376850,
      direction : "-",
      ID : "ENSG00000121769.8",
      gene_id : "ENSG00000121769.8",
      gene_type : "protein_coding",
      gene_name : "FABP3",
      gene_level : 2,
      hgnc_id : "HGNC:3557",
      havana_gene : "OTTHUMG00000003797.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31409565,
      stop : 31434680,
      direction : "+",
      ID : "ENSG00000168528.12",
      gene_id : "ENSG00000168528.12",
      gene_type : "protein_coding",
      gene_name : "SERINC2",
      gene_level : 2,
      hgnc_id : "HGNC:23231",
      havana_gene : "OTTHUMG00000003796.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31576485,
      stop : 31587686,
      direction : "+",
      ID : "ENSG00000142910.16",
      gene_id : "ENSG00000142910.16",
      gene_type : "protein_coding",
      gene_name : "TINAGL1",
      gene_level : 2,
      hgnc_id : "HGNC:19168",
      havana_gene : "OTTHUMG00000003884.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31617686,
      stop : 31632518,
      direction : "+",
      ID : "ENSG00000121764.11",
      gene_id : "ENSG00000121764.11",
      gene_type : "protein_coding",
      gene_name : "HCRTR1",
      gene_level : 2,
      hgnc_id : "HGNC:4848",
      havana_gene : "OTTHUMG00000003876.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31629866,
      stop : 31644896,
      direction : "-",
      ID : "ENSG00000162517.13",
      gene_id : "ENSG00000162517.13",
      gene_type : "protein_coding",
      gene_name : "PEF1",
      gene_level : 2,
      hgnc_id : "HGNC:30009",
      havana_gene : "OTTHUMG00000003877.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31652263,
      stop : 31704319,
      direction : "-",
      ID : "ENSG00000084636.18",
      gene_id : "ENSG00000084636.18",
      gene_type : "protein_coding",
      gene_name : "COL16A1",
      gene_level : 2,
      hgnc_id : "HGNC:2193",
      havana_gene : "OTTHUMG00000003883.24",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31727117,
      stop : 31764893,
      direction : "-",
      ID : "ENSG00000121753.13",
      gene_id : "ENSG00000121753.13",
      gene_type : "protein_coding",
      gene_name : "ADGRB2",
      gene_level : 1,
      hgnc_id : "HGNC:944",
      havana_gene : "OTTHUMG00000003885.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31790422,
      stop : 31816051,
      direction : "-",
      ID : "ENSG00000134668.12",
      gene_id : "ENSG00000134668.12",
      gene_type : "protein_coding",
      gene_name : "SPOCD1",
      gene_level : 1,
      hgnc_id : "HGNC:26338",
      havana_gene : "OTTHUMG00000003879.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31906421,
      stop : 31944856,
      direction : "-",
      ID : "ENSG00000184007.22",
      gene_id : "ENSG00000184007.22",
      gene_type : "protein_coding",
      gene_name : "PTP4A2",
      gene_level : 2,
      hgnc_id : "HGNC:9635",
      havana_gene : "OTTHUMG00000003801.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 31919563,
      stop : 31919628,
      direction : "-",
      ID : "ENSG00000288678.1",
      gene_id : "ENSG00000288678.1",
      gene_type : "protein_coding",
      gene_name : "AL136115.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32013868,
      stop : 32060850,
      direction : "+",
      ID : "ENSG00000121774.18",
      gene_id : "ENSG00000121774.18",
      gene_type : "protein_coding",
      gene_name : "KHDRBS1",
      gene_level : 2,
      hgnc_id : "HGNC:18116",
      havana_gene : "OTTHUMG00000003921.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32072031,
      stop : 32102866,
      direction : "+",
      ID : "ENSG00000121775.18",
      gene_id : "ENSG00000121775.18",
      gene_type : "protein_coding",
      gene_name : "TMEM39B",
      gene_level : 2,
      hgnc_id : "HGNC:25510",
      havana_gene : "OTTHUMG00000004020.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32108056,
      stop : 32176563,
      direction : "+",
      ID : "ENSG00000025800.14",
      gene_id : "ENSG00000025800.14",
      gene_type : "protein_coding",
      gene_name : "KPNA6",
      gene_level : 2,
      hgnc_id : "HGNC:6399",
      havana_gene : "OTTHUMG00000004333.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32179675,
      stop : 32198285,
      direction : "+",
      ID : "ENSG00000084652.16",
      gene_id : "ENSG00000084652.16",
      gene_type : "protein_coding",
      gene_name : "TXLNA",
      gene_level : 2,
      hgnc_id : "HGNC:30685",
      havana_gene : "OTTHUMG00000004423.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32200595,
      stop : 32205453,
      direction : "+",
      ID : "ENSG00000160050.16",
      gene_id : "ENSG00000160050.16",
      gene_type : "protein_coding",
      gene_name : "CCDC28B",
      gene_level : 2,
      hgnc_id : "HGNC:28163",
      havana_gene : "OTTHUMG00000005738.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32205671,
      stop : 32208682,
      direction : "+",
      ID : "ENSG00000160051.12",
      gene_id : "ENSG00000160051.12",
      gene_type : "protein_coding",
      gene_name : "IQCC",
      gene_level : 2,
      hgnc_id : "HGNC:25545",
      havana_gene : "OTTHUMG00000005739.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32209094,
      stop : 32216196,
      direction : "+",
      ID : "ENSG00000222046.2",
      gene_id : "ENSG00000222046.2",
      gene_type : "protein_coding",
      gene_name : "DCDC2B",
      gene_level : 2,
      hgnc_id : "HGNC:32576",
      havana_gene : "OTTHUMG00000005741.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32214472,
      stop : 32222359,
      direction : "-",
      ID : "ENSG00000160055.20",
      gene_id : "ENSG00000160055.20",
      gene_type : "protein_coding",
      gene_name : "TMEM234",
      gene_level : 1,
      hgnc_id : "HGNC:28837",
      havana_gene : "OTTHUMG00000005742.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32221077,
      stop : 32245397,
      direction : "+",
      ID : "ENSG00000084623.12",
      gene_id : "ENSG00000084623.12",
      gene_type : "protein_coding",
      gene_name : "EIF3I",
      gene_level : 2,
      hgnc_id : "HGNC:3272",
      havana_gene : "OTTHUMG00000007364.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32247222,
      stop : 32248856,
      direction : "+",
      ID : "ENSG00000183615.6",
      gene_id : "ENSG00000183615.6",
      gene_type : "protein_coding",
      gene_name : "FAM167B",
      gene_level : 2,
      hgnc_id : "HGNC:28133",
      havana_gene : "OTTHUMG00000007462.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32251239,
      stop : 32286165,
      direction : "+",
      ID : "ENSG00000182866.17",
      gene_id : "ENSG00000182866.17",
      gene_type : "protein_coding",
      gene_name : "LCK",
      gene_level : 2,
      hgnc_id : "HGNC:6524",
      havana_gene : "OTTHUMG00000007463.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32292083,
      stop : 32333635,
      direction : "+",
      ID : "ENSG00000116478.12",
      gene_id : "ENSG00000116478.12",
      gene_type : "protein_coding",
      gene_name : "HDAC1",
      gene_level : 1,
      hgnc_id : "HGNC:4852",
      havana_gene : "OTTHUMG00000007529.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32333839,
      stop : 32336233,
      direction : "-",
      ID : "ENSG00000175130.7",
      gene_id : "ENSG00000175130.7",
      gene_type : "protein_coding",
      gene_name : "MARCKSL1",
      gene_level : 2,
      hgnc_id : "HGNC:7142",
      havana_gene : "OTTHUMG00000007589.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32351521,
      stop : 32364312,
      direction : "+",
      ID : "ENSG00000162526.7",
      gene_id : "ENSG00000162526.7",
      gene_type : "protein_coding",
      gene_name : "TSSK3",
      gene_level : 1,
      hgnc_id : "HGNC:15473",
      havana_gene : "OTTHUMG00000007585.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32361270,
      stop : 32364278,
      direction : "-",
      ID : "ENSG00000225828.1",
      gene_id : "ENSG00000225828.1",
      gene_type : "protein_coding",
      gene_name : "FAM229A",
      gene_level : 2,
      hgnc_id : "HGNC:44652",
      havana_gene : "OTTHUMG00000007587.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32364633,
      stop : 32394731,
      direction : "-",
      ID : "ENSG00000160058.19",
      gene_id : "ENSG00000160058.19",
      gene_type : "protein_coding",
      gene_name : "BSDC1",
      gene_level : 1,
      hgnc_id : "HGNC:25501",
      havana_gene : "OTTHUMG00000007588.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32465057,
      stop : 32600792,
      direction : "+",
      ID : "ENSG00000254553.1",
      gene_id : "ENSG00000254553.1",
      gene_type : "protein_coding",
      gene_name : "AL033529.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167086.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32465072,
      stop : 32496686,
      direction : "+",
      ID : "ENSG00000273274.2",
      gene_id : "ENSG00000273274.2",
      gene_type : "protein_coding",
      gene_name : "ZBTB8B",
      gene_level : 2,
      hgnc_id : "HGNC:37057",
      havana_gene : "OTTHUMG00000167087.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32539427,
      stop : 32605941,
      direction : "+",
      ID : "ENSG00000160062.15",
      gene_id : "ENSG00000160062.15",
      gene_type : "protein_coding",
      gene_name : "ZBTB8A",
      gene_level : 2,
      hgnc_id : "HGNC:24172",
      havana_gene : "OTTHUMG00000007855.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32600172,
      stop : 32650903,
      direction : "-",
      ID : "ENSG00000176261.15",
      gene_id : "ENSG00000176261.15",
      gene_type : "protein_coding",
      gene_name : "ZBTB8OS",
      gene_level : 2,
      hgnc_id : "HGNC:24094",
      havana_gene : "OTTHUMG00000007856.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32651142,
      stop : 32686211,
      direction : "+",
      ID : "ENSG00000162521.19",
      gene_id : "ENSG00000162521.19",
      gene_type : "protein_coding",
      gene_name : "RBBP4",
      gene_level : 2,
      hgnc_id : "HGNC:9887",
      havana_gene : "OTTHUMG00000007998.14",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32679906,
      stop : 32703596,
      direction : "-",
      ID : "ENSG00000162520.15",
      gene_id : "ENSG00000162520.15",
      gene_type : "protein_coding",
      gene_name : "SYNC",
      gene_level : 2,
      hgnc_id : "HGNC:28897",
      havana_gene : "OTTHUMG00000008087.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32741830,
      stop : 32774970,
      direction : "+",
      ID : "ENSG00000162522.11",
      gene_id : "ENSG00000162522.11",
      gene_type : "protein_coding",
      gene_name : "KIAA1522",
      gene_level : 1,
      hgnc_id : "HGNC:29301",
      havana_gene : "OTTHUMG00000008088.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32775237,
      stop : 32817380,
      direction : "-",
      ID : "ENSG00000134684.12",
      gene_id : "ENSG00000134684.12",
      gene_type : "protein_coding",
      gene_name : "YARS1",
      gene_level : 2,
      hgnc_id : "HGNC:12840",
      havana_gene : "OTTHUMG00000003933.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32816767,
      stop : 32858875,
      direction : "+",
      ID : "ENSG00000116497.18",
      gene_id : "ENSG00000116497.18",
      gene_type : "protein_coding",
      gene_name : "S100PBP",
      gene_level : 2,
      hgnc_id : "HGNC:25768",
      havana_gene : "OTTHUMG00000003955.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32862268,
      stop : 32872482,
      direction : "-",
      ID : "ENSG00000160097.20",
      gene_id : "ENSG00000160097.20",
      gene_type : "protein_coding",
      gene_name : "FNDC5",
      gene_level : 2,
      hgnc_id : "HGNC:20240",
      havana_gene : "OTTHUMG00000004015.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32885994,
      stop : 32898441,
      direction : "+",
      ID : "ENSG00000121905.10",
      gene_id : "ENSG00000121905.10",
      gene_type : "protein_coding",
      gene_name : "HPCA",
      gene_level : 2,
      hgnc_id : "HGNC:5144",
      havana_gene : "OTTHUMG00000004017.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32894594,
      stop : 32901438,
      direction : "-",
      ID : "ENSG00000121900.19",
      gene_id : "ENSG00000121900.19",
      gene_type : "protein_coding",
      gene_name : "TMEM54",
      gene_level : 2,
      hgnc_id : "HGNC:24143",
      havana_gene : "OTTHUMG00000004016.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 32936445,
      stop : 32964809,
      direction : "-",
      ID : "ENSG00000116514.17",
      gene_id : "ENSG00000116514.17",
      gene_type : "protein_coding",
      gene_name : "RNF19B",
      gene_level : 2,
      hgnc_id : "HGNC:26886",
      havana_gene : "OTTHUMG00000004013.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33007940,
      stop : 33080996,
      direction : "-",
      ID : "ENSG00000004455.17",
      gene_id : "ENSG00000004455.17",
      gene_type : "protein_coding",
      gene_name : "AK2",
      gene_level : 1,
      hgnc_id : "HGNC:362",
      havana_gene : "OTTHUMG00000004131.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33081104,
      stop : 33123492,
      direction : "+",
      ID : "ENSG00000142920.17",
      gene_id : "ENSG00000142920.17",
      gene_type : "protein_coding",
      gene_name : "AZIN2",
      gene_level : 2,
      hgnc_id : "HGNC:29957",
      havana_gene : "OTTHUMG00000004130.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33145399,
      stop : 33182059,
      direction : "-",
      ID : "ENSG00000116525.14",
      gene_id : "ENSG00000116525.14",
      gene_type : "protein_coding",
      gene_name : "TRIM62",
      gene_level : 1,
      hgnc_id : "HGNC:25574",
      havana_gene : "OTTHUMG00000004132.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33256492,
      stop : 33300719,
      direction : "+",
      ID : "ENSG00000160094.15",
      gene_id : "ENSG00000160094.15",
      gene_type : "protein_coding",
      gene_name : "ZNF362",
      gene_level : 2,
      hgnc_id : "HGNC:18079",
      havana_gene : "OTTHUMG00000004124.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33306766,
      stop : 33321098,
      direction : "-",
      ID : "ENSG00000184389.9",
      gene_id : "ENSG00000184389.9",
      gene_type : "protein_coding",
      gene_name : "A3GALT2",
      gene_level : 2,
      hgnc_id : "HGNC:30005",
      havana_gene : "OTTHUMG00000004125.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33323623,
      stop : 33431052,
      direction : "-",
      ID : "ENSG00000134686.18",
      gene_id : "ENSG00000134686.18",
      gene_type : "protein_coding",
      gene_name : "PHC2",
      gene_level : 2,
      hgnc_id : "HGNC:3183",
      havana_gene : "OTTHUMG00000004133.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33472645,
      stop : 33496507,
      direction : "+",
      ID : "ENSG00000121903.14",
      gene_id : "ENSG00000121903.14",
      gene_type : "protein_coding",
      gene_name : "ZSCAN20",
      gene_level : 2,
      hgnc_id : "HGNC:13093",
      havana_gene : "OTTHUMG00000004173.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33513999,
      stop : 34165842,
      direction : "-",
      ID : "ENSG00000121904.17",
      gene_id : "ENSG00000121904.17",
      gene_type : "protein_coding",
      gene_name : "CSMD2",
      gene_level : 2,
      hgnc_id : "HGNC:19290",
      havana_gene : "OTTHUMG00000011135.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 33860475,
      stop : 33864791,
      direction : "+",
      ID : "ENSG00000176256.11",
      gene_id : "ENSG00000176256.11",
      gene_type : "protein_coding",
      gene_name : "HMGB4",
      gene_level : 2,
      hgnc_id : "HGNC:24954",
      havana_gene : "OTTHUMG00000013143.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34166883,
      stop : 34219131,
      direction : "+",
      ID : "ENSG00000142698.15",
      gene_id : "ENSG00000142698.15",
      gene_type : "protein_coding",
      gene_name : "C1orf94",
      gene_level : 2,
      hgnc_id : "HGNC:28250",
      havana_gene : "OTTHUMG00000004012.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34712737,
      stop : 34859755,
      direction : "-",
      ID : "ENSG00000163866.9",
      gene_id : "ENSG00000163866.9",
      gene_type : "protein_coding",
      gene_name : "SMIM12",
      gene_level : 2,
      hgnc_id : "HGNC:25154",
      havana_gene : "OTTHUMG00000004375.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34755047,
      stop : 34758512,
      direction : "+",
      ID : "ENSG00000189280.3",
      gene_id : "ENSG00000189280.3",
      gene_type : "protein_coding",
      gene_name : "GJB5",
      gene_level : 2,
      hgnc_id : "HGNC:4287",
      havana_gene : "OTTHUMG00000004053.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34759740,
      stop : 34762327,
      direction : "+",
      ID : "ENSG00000189433.7",
      gene_id : "ENSG00000189433.7",
      gene_type : "protein_coding",
      gene_name : "GJB4",
      gene_level : 2,
      hgnc_id : "HGNC:4286",
      havana_gene : "OTTHUMG00000004052.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34781214,
      stop : 34786369,
      direction : "+",
      ID : "ENSG00000188910.8",
      gene_id : "ENSG00000188910.8",
      gene_type : "protein_coding",
      gene_name : "GJB3",
      gene_level : 2,
      hgnc_id : "HGNC:4285",
      havana_gene : "OTTHUMG00000004051.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34792999,
      stop : 34795747,
      direction : "+",
      ID : "ENSG00000187513.9",
      gene_id : "ENSG00000187513.9",
      gene_type : "protein_coding",
      gene_name : "GJA4",
      gene_level : 2,
      hgnc_id : "HGNC:4278",
      havana_gene : "OTTHUMG00000004050.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34865436,
      stop : 34929650,
      direction : "-",
      ID : "ENSG00000116544.12",
      gene_id : "ENSG00000116544.12",
      gene_type : "protein_coding",
      gene_name : "DLGAP3",
      gene_level : 2,
      hgnc_id : "HGNC:30368",
      havana_gene : "OTTHUMG00000004049.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34974356,
      stop : 34985313,
      direction : "-",
      ID : "ENSG00000284773.1",
      gene_id : "ENSG00000284773.1",
      gene_type : "protein_coding",
      gene_name : "AC114490.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192527.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34981533,
      stop : 35031741,
      direction : "-",
      ID : "ENSG00000271741.1",
      gene_id : "ENSG00000271741.1",
      gene_type : "protein_coding",
      gene_name : "AC114490.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185379.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34981535,
      stop : 34985353,
      direction : "-",
      ID : "ENSG00000243749.1",
      gene_id : "ENSG00000243749.1",
      gene_type : "protein_coding",
      gene_name : "TMEM35B",
      gene_level : 1,
      hgnc_id : "HGNC:40021",
      havana_gene : "OTTHUMG00000004158.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 34986165,
      stop : 35031945,
      direction : "-",
      ID : "ENSG00000163867.17",
      gene_id : "ENSG00000163867.17",
      gene_type : "protein_coding",
      gene_name : "ZMYM6",
      gene_level : 2,
      hgnc_id : "HGNC:13050",
      havana_gene : "OTTHUMG00000004163.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35032172,
      stop : 35115859,
      direction : "+",
      ID : "ENSG00000197056.11",
      gene_id : "ENSG00000197056.11",
      gene_type : "protein_coding",
      gene_name : "ZMYM1",
      gene_level : 1,
      hgnc_id : "HGNC:26253",
      havana_gene : "OTTHUMG00000004374.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35176378,
      stop : 35193145,
      direction : "-",
      ID : "ENSG00000116560.11",
      gene_id : "ENSG00000116560.11",
      gene_type : "protein_coding",
      gene_name : "SFPQ",
      gene_level : 2,
      hgnc_id : "HGNC:10774",
      havana_gene : "OTTHUMG00000004157.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35268709,
      stop : 35422058,
      direction : "+",
      ID : "ENSG00000146463.12",
      gene_id : "ENSG00000146463.12",
      gene_type : "protein_coding",
      gene_name : "ZMYM4",
      gene_level : 2,
      hgnc_id : "HGNC:13055",
      havana_gene : "OTTHUMG00000004241.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35433492,
      stop : 35557950,
      direction : "-",
      ID : "ENSG00000142687.18",
      gene_id : "ENSG00000142687.18",
      gene_type : "protein_coding",
      gene_name : "KIAA0319L",
      gene_level : 1,
      hgnc_id : "HGNC:30071",
      havana_gene : "OTTHUMG00000004370.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35557473,
      stop : 35567274,
      direction : "+",
      ID : "ENSG00000020129.16",
      gene_id : "ENSG00000020129.16",
      gene_type : "protein_coding",
      gene_name : "NCDN",
      gene_level : 2,
      hgnc_id : "HGNC:17597",
      havana_gene : "OTTHUMG00000059204.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35573314,
      stop : 35595328,
      direction : "+",
      ID : "ENSG00000116819.8",
      gene_id : "ENSG00000116819.8",
      gene_type : "protein_coding",
      gene_name : "TFAP2E",
      gene_level : 2,
      hgnc_id : "HGNC:30774",
      havana_gene : "OTTHUMG00000004388.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35599541,
      stop : 35641526,
      direction : "-",
      ID : "ENSG00000126067.12",
      gene_id : "ENSG00000126067.12",
      gene_type : "protein_coding",
      gene_name : "PSMB2",
      gene_level : 2,
      hgnc_id : "HGNC:9539",
      havana_gene : "OTTHUMG00000004169.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35713877,
      stop : 35718894,
      direction : "-",
      ID : "ENSG00000142686.8",
      gene_id : "ENSG00000142686.8",
      gene_type : "protein_coding",
      gene_name : "C1orf216",
      gene_level : 2,
      hgnc_id : "HGNC:26800",
      havana_gene : "OTTHUMG00000004167.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35720218,
      stop : 35769978,
      direction : "-",
      ID : "ENSG00000092853.14",
      gene_id : "ENSG00000092853.14",
      gene_type : "protein_coding",
      gene_name : "CLSPN",
      gene_level : 2,
      hgnc_id : "HGNC:19715",
      havana_gene : "OTTHUMG00000004168.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35808016,
      stop : 35857890,
      direction : "+",
      ID : "ENSG00000134698.11",
      gene_id : "ENSG00000134698.11",
      gene_type : "protein_coding",
      gene_name : "AGO4",
      gene_level : 2,
      hgnc_id : "HGNC:18424",
      havana_gene : "OTTHUMG00000004243.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35869808,
      stop : 35930532,
      direction : "+",
      ID : "ENSG00000092847.13",
      gene_id : "ENSG00000092847.13",
      gene_type : "protein_coding",
      gene_name : "AGO1",
      gene_level : 2,
      hgnc_id : "HGNC:3262",
      havana_gene : "OTTHUMG00000007381.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 35930718,
      stop : 36072500,
      direction : "+",
      ID : "ENSG00000126070.20",
      gene_id : "ENSG00000126070.20",
      gene_type : "protein_coding",
      gene_name : "AGO3",
      gene_level : 2,
      hgnc_id : "HGNC:18421",
      havana_gene : "OTTHUMG00000184172.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36084094,
      stop : 36088275,
      direction : "+",
      ID : "ENSG00000092850.12",
      gene_id : "ENSG00000092850.12",
      gene_type : "protein_coding",
      gene_name : "TEKT2",
      gene_level : 2,
      hgnc_id : "HGNC:11725",
      havana_gene : "OTTHUMG00000007629.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36088892,
      stop : 36093932,
      direction : "+",
      ID : "ENSG00000116863.11",
      gene_id : "ENSG00000116863.11",
      gene_type : "protein_coding",
      gene_name : "ADPRS",
      gene_level : 2,
      hgnc_id : "HGNC:21304",
      havana_gene : "OTTHUMG00000007628.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36095239,
      stop : 36125222,
      direction : "-",
      ID : "ENSG00000171812.13",
      gene_id : "ENSG00000171812.13",
      gene_type : "protein_coding",
      gene_name : "COL8A2",
      gene_level : 2,
      hgnc_id : "HGNC:2216",
      havana_gene : "OTTHUMG00000007665.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36136570,
      stop : 36156053,
      direction : "-",
      ID : "ENSG00000054116.12",
      gene_id : "ENSG00000054116.12",
      gene_type : "protein_coding",
      gene_name : "TRAPPC3",
      gene_level : 2,
      hgnc_id : "HGNC:19942",
      havana_gene : "OTTHUMG00000007664.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36155579,
      stop : 36180849,
      direction : "+",
      ID : "ENSG00000116871.15",
      gene_id : "ENSG00000116871.15",
      gene_type : "protein_coding",
      gene_name : "MAP7D1",
      gene_level : 1,
      hgnc_id : "HGNC:25514",
      havana_gene : "OTTHUMG00000007714.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36224432,
      stop : 36305357,
      direction : "+",
      ID : "ENSG00000054118.15",
      gene_id : "ENSG00000054118.15",
      gene_type : "protein_coding",
      gene_name : "THRAP3",
      gene_level : 2,
      hgnc_id : "HGNC:22964",
      havana_gene : "OTTHUMG00000007866.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36306368,
      stop : 36329340,
      direction : "+",
      ID : "ENSG00000214193.11",
      gene_id : "ENSG00000214193.11",
      gene_type : "protein_coding",
      gene_name : "SH3D21",
      gene_level : 2,
      hgnc_id : "HGNC:26236",
      havana_gene : "OTTHUMG00000007868.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36322031,
      stop : 36324154,
      direction : "-",
      ID : "ENSG00000142694.6",
      gene_id : "ENSG00000142694.6",
      gene_type : "protein_coding",
      gene_name : "EVA1B",
      gene_level : 2,
      hgnc_id : "HGNC:25558",
      havana_gene : "OTTHUMG00000007867.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36339624,
      stop : 36385924,
      direction : "-",
      ID : "ENSG00000196182.11",
      gene_id : "ENSG00000196182.11",
      gene_type : "protein_coding",
      gene_name : "STK40",
      gene_level : 2,
      hgnc_id : "HGNC:21373",
      havana_gene : "OTTHUMG00000008238.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36391238,
      stop : 36397908,
      direction : "-",
      ID : "ENSG00000181817.6",
      gene_id : "ENSG00000181817.6",
      gene_type : "protein_coding",
      gene_name : "LSM10",
      gene_level : 2,
      hgnc_id : "HGNC:17562",
      havana_gene : "OTTHUMG00000008140.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36415827,
      stop : 36450451,
      direction : "-",
      ID : "ENSG00000116885.18",
      gene_id : "ENSG00000116885.18",
      gene_type : "protein_coding",
      gene_name : "OSCP1",
      gene_level : 1,
      hgnc_id : "HGNC:29971",
      havana_gene : "OTTHUMG00000008139.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36455718,
      stop : 36464384,
      direction : "-",
      ID : "ENSG00000116898.12",
      gene_id : "ENSG00000116898.12",
      gene_type : "protein_coding",
      gene_name : "MRPS15",
      gene_level : 2,
      hgnc_id : "HGNC:14504",
      havana_gene : "OTTHUMG00000008042.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36466043,
      stop : 36483278,
      direction : "-",
      ID : "ENSG00000119535.18",
      gene_id : "ENSG00000119535.18",
      gene_type : "protein_coding",
      gene_name : "CSF3R",
      gene_level : 2,
      hgnc_id : "HGNC:2439",
      havana_gene : "OTTHUMG00000008010.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 36795527,
      stop : 37034515,
      direction : "-",
      ID : "ENSG00000163873.10",
      gene_id : "ENSG00000163873.10",
      gene_type : "protein_coding",
      gene_name : "GRIK3",
      gene_level : 2,
      hgnc_id : "HGNC:4581",
      havana_gene : "OTTHUMG00000004189.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37474580,
      stop : 37484377,
      direction : "+",
      ID : "ENSG00000163874.11",
      gene_id : "ENSG00000163874.11",
      gene_type : "protein_coding",
      gene_name : "ZC3H12A",
      gene_level : 1,
      hgnc_id : "HGNC:26259",
      havana_gene : "OTTHUMG00000004221.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37489993,
      stop : 37514766,
      direction : "-",
      ID : "ENSG00000163875.16",
      gene_id : "ENSG00000163875.16",
      gene_type : "protein_coding",
      gene_name : "MEAF6",
      gene_level : 2,
      hgnc_id : "HGNC:25674",
      havana_gene : "OTTHUMG00000004223.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37534449,
      stop : 37554293,
      direction : "-",
      ID : "ENSG00000163877.11",
      gene_id : "ENSG00000163877.11",
      gene_type : "protein_coding",
      gene_name : "SNIP1",
      gene_level : 2,
      hgnc_id : "HGNC:30587",
      havana_gene : "OTTHUMG00000004225.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37556919,
      stop : 37566857,
      direction : "+",
      ID : "ENSG00000163879.11",
      gene_id : "ENSG00000163879.11",
      gene_type : "protein_coding",
      gene_name : "DNALI1",
      gene_level : 2,
      hgnc_id : "HGNC:14353",
      havana_gene : "OTTHUMG00000004222.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37566816,
      stop : 37595937,
      direction : "-",
      ID : "ENSG00000134697.13",
      gene_id : "ENSG00000134697.13",
      gene_type : "protein_coding",
      gene_name : "GNL2",
      gene_level : 1,
      hgnc_id : "HGNC:29925",
      havana_gene : "OTTHUMG00000004322.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37611350,
      stop : 37634892,
      direction : "-",
      ID : "ENSG00000169218.14",
      gene_id : "ENSG00000169218.14",
      gene_type : "protein_coding",
      gene_name : "RSPO1",
      gene_level : 2,
      hgnc_id : "HGNC:21679",
      havana_gene : "OTTHUMG00000004321.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37681570,
      stop : 37692249,
      direction : "-",
      ID : "ENSG00000116922.14",
      gene_id : "ENSG00000116922.14",
      gene_type : "protein_coding",
      gene_name : "C1orf109",
      gene_level : 2,
      hgnc_id : "HGNC:26039",
      havana_gene : "OTTHUMG00000004323.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37692481,
      stop : 37709719,
      direction : "+",
      ID : "ENSG00000134690.11",
      gene_id : "ENSG00000134690.11",
      gene_type : "protein_coding",
      gene_name : "CDCA8",
      gene_level : 2,
      hgnc_id : "HGNC:14629",
      havana_gene : "OTTHUMG00000004320.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37713880,
      stop : 37765133,
      direction : "-",
      ID : "ENSG00000183317.17",
      gene_id : "ENSG00000183317.17",
      gene_type : "protein_coding",
      gene_name : "EPHA10",
      gene_level : 2,
      hgnc_id : "HGNC:19987",
      havana_gene : "OTTHUMG00000004325.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37793847,
      stop : 37801137,
      direction : "+",
      ID : "ENSG00000185090.15",
      gene_id : "ENSG00000185090.15",
      gene_type : "protein_coding",
      gene_name : "MANEAL",
      gene_level : 2,
      hgnc_id : "HGNC:26452",
      havana_gene : "OTTHUMG00000004317.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37802945,
      stop : 37808208,
      direction : "-",
      ID : "ENSG00000196449.4",
      gene_id : "ENSG00000196449.4",
      gene_type : "protein_coding",
      gene_name : "YRDC",
      gene_level : 2,
      hgnc_id : "HGNC:28905",
      havana_gene : "OTTHUMG00000004318.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37806979,
      stop : 37809454,
      direction : "+",
      ID : "ENSG00000197982.14",
      gene_id : "ENSG00000197982.14",
      gene_type : "protein_coding",
      gene_name : "C1orf122",
      gene_level : 2,
      hgnc_id : "HGNC:24789",
      havana_gene : "OTTHUMG00000004319.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37809574,
      stop : 37859592,
      direction : "-",
      ID : "ENSG00000188786.10",
      gene_id : "ENSG00000188786.10",
      gene_type : "protein_coding",
      gene_name : "MTF1",
      gene_level : 2,
      hgnc_id : "HGNC:7428",
      havana_gene : "OTTHUMG00000004439.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37860697,
      stop : 37947057,
      direction : "-",
      ID : "ENSG00000204084.13",
      gene_id : "ENSG00000204084.13",
      gene_type : "protein_coding",
      gene_name : "INPP5B",
      gene_level : 2,
      hgnc_id : "HGNC:6077",
      havana_gene : "OTTHUMG00000004436.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37956975,
      stop : 37990075,
      direction : "-",
      ID : "ENSG00000183431.12",
      gene_id : "ENSG00000183431.12",
      gene_type : "protein_coding",
      gene_name : "SF3A3",
      gene_level : 2,
      hgnc_id : "HGNC:10767",
      havana_gene : "OTTHUMG00000004438.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 37996770,
      stop : 38005606,
      direction : "-",
      ID : "ENSG00000183386.10",
      gene_id : "ENSG00000183386.10",
      gene_type : "protein_coding",
      gene_name : "FHL3",
      gene_level : 2,
      hgnc_id : "HGNC:3704",
      havana_gene : "OTTHUMG00000004434.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38009258,
      stop : 38024820,
      direction : "+",
      ID : "ENSG00000183520.12",
      gene_id : "ENSG00000183520.12",
      gene_type : "protein_coding",
      gene_name : "UTP11",
      gene_level : 2,
      hgnc_id : "HGNC:24329",
      havana_gene : "OTTHUMG00000004435.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38043829,
      stop : 38046793,
      direction : "-",
      ID : "ENSG00000185668.8",
      gene_id : "ENSG00000185668.8",
      gene_type : "protein_coding",
      gene_name : "POU3F1",
      gene_level : 2,
      hgnc_id : "HGNC:9214",
      havana_gene : "OTTHUMG00000000485.3",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38838198,
      stop : 38859772,
      direction : "-",
      ID : "ENSG00000116954.8",
      gene_id : "ENSG00000116954.8",
      gene_type : "protein_coding",
      gene_name : "RRAGC",
      gene_level : 2,
      hgnc_id : "HGNC:19902",
      havana_gene : "OTTHUMG00000000490.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38862493,
      stop : 38873368,
      direction : "-",
      ID : "ENSG00000214114.9",
      gene_id : "ENSG00000214114.9",
      gene_type : "protein_coding",
      gene_name : "MYCBP",
      gene_level : 2,
      hgnc_id : "HGNC:7554",
      havana_gene : "OTTHUMG00000000484.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38864501,
      stop : 38881617,
      direction : "-",
      ID : "ENSG00000274944.4",
      gene_id : "ENSG00000274944.4",
      gene_type : "protein_coding",
      gene_name : "AL139260.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000187290.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38874069,
      stop : 38881587,
      direction : "-",
      ID : "ENSG00000131233.10",
      gene_id : "ENSG00000131233.10",
      gene_type : "protein_coding",
      gene_name : "GJA9",
      gene_level : 2,
      hgnc_id : "HGNC:19155",
      havana_gene : "OTTHUMG00000000482.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38885807,
      stop : 38941830,
      direction : "-",
      ID : "ENSG00000158315.11",
      gene_id : "ENSG00000158315.11",
      gene_type : "protein_coding",
      gene_name : "RHBDL2",
      gene_level : 2,
      hgnc_id : "HGNC:16083",
      havana_gene : "OTTHUMG00000000487.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 38991276,
      stop : 39006059,
      direction : "+",
      ID : "ENSG00000174574.16",
      gene_id : "ENSG00000174574.16",
      gene_type : "protein_coding",
      gene_name : "AKIRIN1",
      gene_level : 2,
      hgnc_id : "HGNC:25744",
      havana_gene : "OTTHUMG00000007496.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39026318,
      stop : 39034636,
      direction : "+",
      ID : "ENSG00000168653.11",
      gene_id : "ENSG00000168653.11",
      gene_type : "protein_coding",
      gene_name : "NDUFS5",
      gene_level : 2,
      hgnc_id : "HGNC:7712",
      havana_gene : "OTTHUMG00000007497.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39081316,
      stop : 39487177,
      direction : "+",
      ID : "ENSG00000127603.30",
      gene_id : "ENSG00000127603.30",
      gene_type : "protein_coding",
      gene_name : "MACF1",
      gene_level : 1,
      hgnc_id : "HGNC:13664",
      havana_gene : "OTTHUMG00000007754.17",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39491636,
      stop : 39529869,
      direction : "+",
      ID : "ENSG00000183682.8",
      gene_id : "ENSG00000183682.8",
      gene_type : "protein_coding",
      gene_name : "BMP8A",
      gene_level : 2,
      hgnc_id : "HGNC:21650",
      havana_gene : "OTTHUMG00000008394.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39560709,
      stop : 39576790,
      direction : "-",
      ID : "ENSG00000090621.15",
      gene_id : "ENSG00000090621.15",
      gene_type : "protein_coding",
      gene_name : "PABPC4",
      gene_level : 1,
      hgnc_id : "HGNC:8557",
      havana_gene : "OTTHUMG00000009097.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39623435,
      stop : 39639643,
      direction : "-",
      ID : "ENSG00000163909.8",
      gene_id : "ENSG00000163909.8",
      gene_type : "protein_coding",
      gene_name : "HEYL",
      gene_level : 2,
      hgnc_id : "HGNC:4882",
      havana_gene : "OTTHUMG00000000458.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39659121,
      stop : 39672038,
      direction : "-",
      ID : "ENSG00000116981.3",
      gene_id : "ENSG00000116981.3",
      gene_type : "protein_coding",
      gene_name : "NT5C1A",
      gene_level : 2,
      hgnc_id : "HGNC:17819",
      havana_gene : "OTTHUMG00000009244.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39678648,
      stop : 39691485,
      direction : "-",
      ID : "ENSG00000116983.13",
      gene_id : "ENSG00000116983.13",
      gene_type : "protein_coding",
      gene_name : "HPCAL4",
      gene_level : 2,
      hgnc_id : "HGNC:18212",
      havana_gene : "OTTHUMG00000009246.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39692182,
      stop : 39763914,
      direction : "+",
      ID : "ENSG00000084072.17",
      gene_id : "ENSG00000084072.17",
      gene_type : "protein_coding",
      gene_name : "PPIE",
      gene_level : 1,
      hgnc_id : "HGNC:9258",
      havana_gene : "OTTHUMG00000009248.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39757182,
      stop : 39788865,
      direction : "-",
      ID : "ENSG00000116985.12",
      gene_id : "ENSG00000116985.12",
      gene_type : "protein_coding",
      gene_name : "BMP8B",
      gene_level : 2,
      hgnc_id : "HGNC:1075",
      havana_gene : "OTTHUMG00000009247.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39769523,
      stop : 39771348,
      direction : "-",
      ID : "ENSG00000198754.5",
      gene_id : "ENSG00000198754.5",
      gene_type : "protein_coding",
      gene_name : "OXCT2",
      gene_level : 2,
      hgnc_id : "HGNC:18606",
      havana_gene : "OTTHUMG00000009249.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39838110,
      stop : 39883511,
      direction : "-",
      ID : "ENSG00000043514.17",
      gene_id : "ENSG00000043514.17",
      gene_type : "protein_coding",
      gene_name : "TRIT1",
      gene_level : 2,
      hgnc_id : "HGNC:20286",
      havana_gene : "OTTHUMG00000009245.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39895426,
      stop : 39902256,
      direction : "-",
      ID : "ENSG00000116990.11",
      gene_id : "ENSG00000116990.11",
      gene_type : "protein_coding",
      gene_name : "MYCL",
      gene_level : 2,
      hgnc_id : "HGNC:7555",
      havana_gene : "OTTHUMG00000009243.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 39955112,
      stop : 39969968,
      direction : "+",
      ID : "ENSG00000168389.18",
      gene_id : "ENSG00000168389.18",
      gene_type : "protein_coding",
      gene_name : "MFSD2A",
      gene_level : 2,
      hgnc_id : "HGNC:25897",
      havana_gene : "OTTHUMG00000009293.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40040233,
      stop : 40072649,
      direction : "+",
      ID : "ENSG00000131236.18",
      gene_id : "ENSG00000131236.18",
      gene_type : "protein_coding",
      gene_name : "CAP1",
      gene_level : 2,
      hgnc_id : "HGNC:20040",
      havana_gene : "OTTHUMG00000004493.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40072710,
      stop : 40097260,
      direction : "-",
      ID : "ENSG00000131238.18",
      gene_id : "ENSG00000131238.18",
      gene_type : "protein_coding",
      gene_name : "PPT1",
      gene_level : 1,
      hgnc_id : "HGNC:9325",
      havana_gene : "OTTHUMG00000004495.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40161387,
      stop : 40240921,
      direction : "+",
      ID : "ENSG00000117000.9",
      gene_id : "ENSG00000117000.9",
      gene_type : "protein_coding",
      gene_name : "RLF",
      gene_level : 2,
      hgnc_id : "HGNC:10025",
      havana_gene : "OTTHUMG00000005763.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40245947,
      stop : 40251684,
      direction : "+",
      ID : "ENSG00000188800.6",
      gene_id : "ENSG00000188800.6",
      gene_type : "protein_coding",
      gene_name : "TMCO2",
      gene_level : 2,
      hgnc_id : "HGNC:23312",
      havana_gene : "OTTHUMG00000005764.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40258041,
      stop : 40294180,
      direction : "+",
      ID : "ENSG00000084073.10",
      gene_id : "ENSG00000084073.10",
      gene_type : "protein_coding",
      gene_name : "ZMPSTE24",
      gene_level : 2,
      hgnc_id : "HGNC:12877",
      havana_gene : "OTTHUMG00000005762.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40300489,
      stop : 40317813,
      direction : "-",
      ID : "ENSG00000049089.15",
      gene_id : "ENSG00000049089.15",
      gene_type : "protein_coding",
      gene_name : "COL9A2",
      gene_level : 2,
      hgnc_id : "HGNC:2218",
      havana_gene : "OTTHUMG00000005761.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40344850,
      stop : 40423326,
      direction : "+",
      ID : "ENSG00000084070.12",
      gene_id : "ENSG00000084070.12",
      gene_type : "protein_coding",
      gene_name : "SMAP2",
      gene_level : 2,
      hgnc_id : "HGNC:25082",
      havana_gene : "OTTHUMG00000007301.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40450102,
      stop : 40463718,
      direction : "+",
      ID : "ENSG00000187801.15",
      gene_id : "ENSG00000187801.15",
      gene_type : "protein_coding",
      gene_name : "ZFP69B",
      gene_level : 2,
      hgnc_id : "HGNC:28053",
      havana_gene : "OTTHUMG00000007302.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40477290,
      stop : 40496343,
      direction : "+",
      ID : "ENSG00000187815.10",
      gene_id : "ENSG00000187815.10",
      gene_type : "protein_coding",
      gene_name : "ZFP69",
      gene_level : 2,
      hgnc_id : "HGNC:24708",
      havana_gene : "OTTHUMG00000007303.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40508741,
      stop : 40516556,
      direction : "+",
      ID : "ENSG00000164002.11",
      gene_id : "ENSG00000164002.11",
      gene_type : "protein_coding",
      gene_name : "EXO5",
      gene_level : 2,
      hgnc_id : "HGNC:26115",
      havana_gene : "OTTHUMG00000007305.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40531573,
      stop : 40548167,
      direction : "+",
      ID : "ENSG00000117010.17",
      gene_id : "ENSG00000117010.17",
      gene_type : "protein_coding",
      gene_name : "ZNF684",
      gene_level : 2,
      hgnc_id : "HGNC:28418",
      havana_gene : "OTTHUMG00000007359.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40620680,
      stop : 40665682,
      direction : "-",
      ID : "ENSG00000117016.10",
      gene_id : "ENSG00000117016.10",
      gene_type : "protein_coding",
      gene_name : "RIMS3",
      gene_level : 2,
      hgnc_id : "HGNC:21292",
      havana_gene : "OTTHUMG00000007453.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40691648,
      stop : 40771603,
      direction : "+",
      ID : "ENSG00000066136.20",
      gene_id : "ENSG00000066136.20",
      gene_type : "protein_coding",
      gene_name : "NFYC",
      gene_level : 1,
      hgnc_id : "HGNC:7806",
      havana_gene : "OTTHUMG00000007729.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40783787,
      stop : 40840452,
      direction : "+",
      ID : "ENSG00000117013.17",
      gene_id : "ENSG00000117013.17",
      gene_type : "protein_coding",
      gene_name : "KCNQ4",
      gene_level : 2,
      hgnc_id : "HGNC:6298",
      havana_gene : "OTTHUMG00000007730.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40861054,
      stop : 40862363,
      direction : "-",
      ID : "ENSG00000179862.7",
      gene_id : "ENSG00000179862.7",
      gene_type : "protein_coding",
      gene_name : "CITED4",
      gene_level : 2,
      hgnc_id : "HGNC:18696",
      havana_gene : "OTTHUMG00000007728.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 40979688,
      stop : 41012565,
      direction : "+",
      ID : "ENSG00000171793.16",
      gene_id : "ENSG00000171793.16",
      gene_type : "protein_coding",
      gene_name : "CTPS1",
      gene_level : 2,
      hgnc_id : "HGNC:2519",
      havana_gene : "OTTHUMG00000005712.13",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 41015597,
      stop : 41023237,
      direction : "-",
      ID : "ENSG00000171790.15",
      gene_id : "ENSG00000171790.15",
      gene_type : "protein_coding",
      gene_name : "SLFNL1",
      gene_level : 2,
      hgnc_id : "HGNC:26313",
      havana_gene : "OTTHUMG00000005719.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 41027200,
      stop : 41242154,
      direction : "-",
      ID : "ENSG00000010803.16",
      gene_id : "ENSG00000010803.16",
      gene_type : "protein_coding",
      gene_name : "SCMH1",
      gene_level : 2,
      hgnc_id : "HGNC:19003",
      havana_gene : "OTTHUMG00000005720.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 41361922,
      stop : 41383590,
      direction : "+",
      ID : "ENSG00000204060.7",
      gene_id : "ENSG00000204060.7",
      gene_type : "protein_coding",
      gene_name : "FOXO6",
      gene_level : 2,
      hgnc_id : "HGNC:24814",
      havana_gene : "OTTHUMG00000005713.1",
      tag : "reference_genome_error"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 41478775,
      stop : 41484683,
      direction : "-",
      ID : "ENSG00000127129.10",
      gene_id : "ENSG00000127129.10",
      gene_type : "protein_coding",
      gene_name : "EDN2",
      gene_level : 2,
      hgnc_id : "HGNC:3177",
      havana_gene : "OTTHUMG00000006362.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 41506365,
      stop : 42035925,
      direction : "-",
      ID : "ENSG00000127124.16",
      gene_id : "ENSG00000127124.16",
      gene_type : "protein_coding",
      gene_name : "HIVEP3",
      gene_level : 2,
      hgnc_id : "HGNC:13561",
      havana_gene : "OTTHUMG00000192539.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 41585306,
      stop : 41628816,
      direction : "-",
      ID : "ENSG00000284895.1",
      gene_id : "ENSG00000284895.1",
      gene_type : "protein_coding",
      gene_name : "AC119676.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000006361.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42153410,
      stop : 42155820,
      direction : "+",
      ID : "ENSG00000044012.4",
      gene_id : "ENSG00000044012.4",
      gene_type : "protein_coding",
      gene_name : "GUCA2B",
      gene_level : 2,
      hgnc_id : "HGNC:4683",
      havana_gene : "OTTHUMG00000007024.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42162690,
      stop : 42164745,
      direction : "-",
      ID : "ENSG00000197273.4",
      gene_id : "ENSG00000197273.4",
      gene_type : "protein_coding",
      gene_name : "GUCA2A",
      gene_level : 2,
      hgnc_id : "HGNC:4682",
      havana_gene : "OTTHUMG00000007023.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42176539,
      stop : 42335877,
      direction : "-",
      ID : "ENSG00000198815.9",
      gene_id : "ENSG00000198815.9",
      gene_type : "protein_coding",
      gene_name : "FOXJ3",
      gene_level : 1,
      hgnc_id : "HGNC:29178",
      havana_gene : "OTTHUMG00000007026.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42380792,
      stop : 42424232,
      direction : "+",
      ID : "ENSG00000177181.15",
      gene_id : "ENSG00000177181.15",
      gene_type : "protein_coding",
      gene_name : "RIMKLA",
      gene_level : 2,
      hgnc_id : "HGNC:28725",
      havana_gene : "OTTHUMG00000007335.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42430329,
      stop : 42456253,
      direction : "-",
      ID : "ENSG00000066185.13",
      gene_id : "ENSG00000066185.13",
      gene_type : "protein_coding",
      gene_name : "ZMYND12",
      gene_level : 2,
      hgnc_id : "HGNC:21192",
      havana_gene : "OTTHUMG00000007333.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42456117,
      stop : 42473385,
      direction : "+",
      ID : "ENSG00000127125.9",
      gene_id : "ENSG00000127125.9",
      gene_type : "protein_coding",
      gene_name : "PPCS",
      gene_level : 2,
      hgnc_id : "HGNC:25686",
      havana_gene : "OTTHUMG00000007332.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42463221,
      stop : 42657190,
      direction : "+",
      ID : "ENSG00000186409.18",
      gene_id : "ENSG00000186409.18",
      gene_type : "protein_coding",
      gene_name : "CCDC30",
      gene_level : 2,
      hgnc_id : "HGNC:26103",
      havana_gene : "OTTHUMG00000007334.18",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42658335,
      stop : 42676758,
      direction : "+",
      ID : "ENSG00000171960.12",
      gene_id : "ENSG00000171960.12",
      gene_type : "protein_coding",
      gene_name : "PPIH",
      gene_level : 2,
      hgnc_id : "HGNC:14651",
      havana_gene : "OTTHUMG00000007520.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42682418,
      stop : 42703805,
      direction : "+",
      ID : "ENSG00000065978.19",
      gene_id : "ENSG00000065978.19",
      gene_type : "protein_coding",
      gene_name : "YBX1",
      gene_level : 2,
      hgnc_id : "HGNC:8014",
      havana_gene : "OTTHUMG00000007523.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42733093,
      stop : 42740254,
      direction : "-",
      ID : "ENSG00000164007.11",
      gene_id : "ENSG00000164007.11",
      gene_type : "protein_coding",
      gene_name : "CLDN19",
      gene_level : 2,
      hgnc_id : "HGNC:2040",
      havana_gene : "OTTHUMG00000007524.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42746335,
      stop : 42767084,
      direction : "-",
      ID : "ENSG00000117385.16",
      gene_id : "ENSG00000117385.16",
      gene_type : "protein_coding",
      gene_name : "P3H1",
      gene_level : 2,
      hgnc_id : "HGNC:19316",
      havana_gene : "OTTHUMG00000007525.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42767249,
      stop : 42779491,
      direction : "+",
      ID : "ENSG00000164008.16",
      gene_id : "ENSG00000164008.16",
      gene_type : "protein_coding",
      gene_name : "C1orf50",
      gene_level : 1,
      hgnc_id : "HGNC:28795",
      havana_gene : "OTTHUMG00000191873.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42767292,
      stop : 42794493,
      direction : "+",
      ID : "ENSG00000283580.3",
      gene_id : "ENSG00000283580.3",
      gene_type : "protein_coding",
      gene_name : "AC098484.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000007568.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42785007,
      stop : 42816619,
      direction : "+",
      ID : "ENSG00000274386.5",
      gene_id : "ENSG00000274386.5",
      gene_type : "protein_coding",
      gene_name : "TMEM269",
      gene_level : 2,
      hgnc_id : "HGNC:52381",
      havana_gene : "OTTHUMG00000188150.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42807052,
      stop : 42817397,
      direction : "-",
      ID : "ENSG00000177868.12",
      gene_id : "ENSG00000177868.12",
      gene_type : "protein_coding",
      gene_name : "SVBP",
      gene_level : 2,
      hgnc_id : "HGNC:29204",
      havana_gene : "OTTHUMG00000007566.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42817122,
      stop : 42844991,
      direction : "+",
      ID : "ENSG00000164010.15",
      gene_id : "ENSG00000164010.15",
      gene_type : "protein_coding",
      gene_name : "ERMAP",
      gene_level : 2,
      hgnc_id : "HGNC:15743",
      havana_gene : "OTTHUMG00000007619.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42846573,
      stop : 42852477,
      direction : "+",
      ID : "ENSG00000164011.18",
      gene_id : "ENSG00000164011.18",
      gene_type : "protein_coding",
      gene_name : "ZNF691",
      gene_level : 2,
      hgnc_id : "HGNC:28028",
      havana_gene : "OTTHUMG00000007623.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 42925353,
      stop : 42958893,
      direction : "-",
      ID : "ENSG00000117394.24",
      gene_id : "ENSG00000117394.24",
      gene_type : "protein_coding",
      gene_name : "SLC2A1",
      gene_level : 2,
      hgnc_id : "HGNC:11005",
      havana_gene : "OTTHUMG00000007657.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43145153,
      stop : 43156396,
      direction : "+",
      ID : "ENSG00000186973.11",
      gene_id : "ENSG00000186973.11",
      gene_type : "protein_coding",
      gene_name : "FAM183A",
      gene_level : 1,
      hgnc_id : "HGNC:34347",
      havana_gene : "OTTHUMG00000007286.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43164175,
      stop : 43270936,
      direction : "-",
      ID : "ENSG00000117395.13",
      gene_id : "ENSG00000117395.13",
      gene_type : "protein_coding",
      gene_name : "EBNA1BP2",
      gene_level : 2,
      hgnc_id : "HGNC:15531",
      havana_gene : "OTTHUMG00000007284.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43172330,
      stop : 43254358,
      direction : "+",
      ID : "ENSG00000243710.8",
      gene_id : "ENSG00000243710.8",
      gene_type : "protein_coding",
      gene_name : "CFAP57",
      gene_level : 1,
      hgnc_id : "HGNC:26485",
      havana_gene : "OTTHUMG00000007285.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43269983,
      stop : 43274002,
      direction : "+",
      ID : "ENSG00000179178.11",
      gene_id : "ENSG00000179178.11",
      gene_type : "protein_coding",
      gene_name : "TMEM125",
      gene_level : 2,
      hgnc_id : "HGNC:28275",
      havana_gene : "OTTHUMG00000007288.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43281877,
      stop : 43285617,
      direction : "-",
      ID : "ENSG00000253313.6",
      gene_id : "ENSG00000253313.6",
      gene_type : "protein_coding",
      gene_name : "C1orf210",
      gene_level : 2,
      hgnc_id : "HGNC:28755",
      havana_gene : "OTTHUMG00000007289.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43300982,
      stop : 43323108,
      direction : "+",
      ID : "ENSG00000066056.14",
      gene_id : "ENSG00000066056.14",
      gene_type : "protein_coding",
      gene_name : "TIE1",
      gene_level : 2,
      hgnc_id : "HGNC:11809",
      havana_gene : "OTTHUMG00000007282.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43337818,
      stop : 43354466,
      direction : "+",
      ID : "ENSG00000117400.18",
      gene_id : "ENSG00000117400.18",
      gene_type : "protein_coding",
      gene_name : "MPL",
      gene_level : 2,
      hgnc_id : "HGNC:7217",
      havana_gene : "OTTHUMG00000007429.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43358981,
      stop : 43363203,
      direction : "+",
      ID : "ENSG00000117399.14",
      gene_id : "ENSG00000117399.14",
      gene_type : "protein_coding",
      gene_name : "CDC20",
      gene_level : 2,
      hgnc_id : "HGNC:1723",
      havana_gene : "OTTHUMG00000007420.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43363398,
      stop : 43368074,
      direction : "-",
      ID : "ENSG00000066322.15",
      gene_id : "ENSG00000066322.15",
      gene_type : "protein_coding",
      gene_name : "ELOVL1",
      gene_level : 2,
      hgnc_id : "HGNC:14418",
      havana_gene : "OTTHUMG00000007422.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43383917,
      stop : 43389808,
      direction : "-",
      ID : "ENSG00000159479.17",
      gene_id : "ENSG00000159479.17",
      gene_type : "protein_coding",
      gene_name : "MED8",
      gene_level : 1,
      hgnc_id : "HGNC:19971",
      havana_gene : "OTTHUMG00000007421.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43389882,
      stop : 43454247,
      direction : "+",
      ID : "ENSG00000198198.17",
      gene_id : "ENSG00000198198.17",
      gene_type : "protein_coding",
      gene_name : "SZT2",
      gene_level : 2,
      hgnc_id : "HGNC:29040",
      havana_gene : "OTTHUMG00000007423.17",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43450989,
      stop : 43453989,
      direction : "-",
      ID : "ENSG00000178922.18",
      gene_id : "ENSG00000178922.18",
      gene_type : "protein_coding",
      gene_name : "HYI",
      gene_level : 2,
      hgnc_id : "HGNC:26948",
      havana_gene : "OTTHUMG00000007502.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43525187,
      stop : 43623666,
      direction : "+",
      ID : "ENSG00000142949.17",
      gene_id : "ENSG00000142949.17",
      gene_type : "protein_coding",
      gene_name : "PTPRF",
      gene_level : 2,
      hgnc_id : "HGNC:9670",
      havana_gene : "OTTHUMG00000007501.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43650149,
      stop : 43705518,
      direction : "+",
      ID : "ENSG00000066135.13",
      gene_id : "ENSG00000066135.13",
      gene_type : "protein_coding",
      gene_name : "KDM4A",
      gene_level : 2,
      hgnc_id : "HGNC:22978",
      havana_gene : "OTTHUMG00000007560.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43650149,
      stop : 43931014,
      direction : "+",
      ID : "ENSG00000284989.1",
      gene_id : "ENSG00000284989.1",
      gene_type : "protein_coding",
      gene_name : "AL451062.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192482.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43705824,
      stop : 43931165,
      direction : "+",
      ID : "ENSG00000126091.21",
      gene_id : "ENSG00000126091.21",
      gene_type : "protein_coding",
      gene_name : "ST3GAL3",
      gene_level : 1,
      hgnc_id : "HGNC:10866",
      havana_gene : "OTTHUMG00000007561.18",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43933320,
      stop : 43937240,
      direction : "+",
      ID : "ENSG00000117407.17",
      gene_id : "ENSG00000117407.17",
      gene_type : "protein_coding",
      gene_name : "ARTN",
      gene_level : 2,
      hgnc_id : "HGNC:727",
      havana_gene : "OTTHUMG00000007705.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43946950,
      stop : 43968022,
      direction : "+",
      ID : "ENSG00000117408.11",
      gene_id : "ENSG00000117408.11",
      gene_type : "protein_coding",
      gene_name : "IPO13",
      gene_level : 2,
      hgnc_id : "HGNC:16853",
      havana_gene : "OTTHUMG00000008297.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43970000,
      stop : 43973369,
      direction : "+",
      ID : "ENSG00000132768.14",
      gene_id : "ENSG00000132768.14",
      gene_type : "protein_coding",
      gene_name : "DPH2",
      gene_level : 1,
      hgnc_id : "HGNC:3004",
      havana_gene : "OTTHUMG00000008295.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43974487,
      stop : 43978295,
      direction : "+",
      ID : "ENSG00000117410.14",
      gene_id : "ENSG00000117410.14",
      gene_type : "protein_coding",
      gene_name : "ATP6V0B",
      gene_level : 2,
      hgnc_id : "HGNC:861",
      havana_gene : "OTTHUMG00000008298.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43978943,
      stop : 43991170,
      direction : "+",
      ID : "ENSG00000117411.18",
      gene_id : "ENSG00000117411.18",
      gene_type : "protein_coding",
      gene_name : "B4GALT2",
      gene_level : 2,
      hgnc_id : "HGNC:925",
      havana_gene : "OTTHUMG00000008296.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43991359,
      stop : 43996528,
      direction : "+",
      ID : "ENSG00000159214.13",
      gene_id : "ENSG00000159214.13",
      gene_type : "protein_coding",
      gene_name : "CCDC24",
      gene_level : 2,
      hgnc_id : "HGNC:28688",
      havana_gene : "OTTHUMG00000008299.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 43991500,
      stop : 44031467,
      direction : "-",
      ID : "ENSG00000196517.13",
      gene_id : "ENSG00000196517.13",
      gene_type : "protein_coding",
      gene_name : "SLC6A9",
      gene_level : 1,
      hgnc_id : "HGNC:11056",
      havana_gene : "OTTHUMG00000008294.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44118821,
      stop : 44135140,
      direction : "+",
      ID : "ENSG00000171872.5",
      gene_id : "ENSG00000171872.5",
      gene_type : "protein_coding",
      gene_name : "KLF17",
      gene_level : 2,
      hgnc_id : "HGNC:18830",
      havana_gene : "OTTHUMG00000009664.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44137821,
      stop : 44141631,
      direction : "-",
      ID : "ENSG00000283039.1",
      gene_id : "ENSG00000283039.1",
      gene_type : "protein_coding",
      gene_name : "KLF18",
      gene_level : 2,
      hgnc_id : "HGNC:51793",
      havana_gene : "OTTHUMG00000007489.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44213455,
      stop : 44220681,
      direction : "+",
      ID : "ENSG00000178028.14",
      gene_id : "ENSG00000178028.14",
      gene_type : "protein_coding",
      gene_name : "DMAP1",
      gene_level : 2,
      hgnc_id : "HGNC:18291",
      havana_gene : "OTTHUMG00000007577.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44221070,
      stop : 44355260,
      direction : "-",
      ID : "ENSG00000117419.16",
      gene_id : "ENSG00000117419.16",
      gene_type : "protein_coding",
      gene_name : "ERI3",
      gene_level : 2,
      hgnc_id : "HGNC:17276",
      havana_gene : "OTTHUMG00000007637.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44405194,
      stop : 44651724,
      direction : "+",
      ID : "ENSG00000187147.18",
      gene_id : "ENSG00000187147.18",
      gene_type : "protein_coding",
      gene_name : "RNF220",
      gene_level : 2,
      hgnc_id : "HGNC:25552",
      havana_gene : "OTTHUMG00000007697.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44635238,
      stop : 44674481,
      direction : "-",
      ID : "ENSG00000126106.14",
      gene_id : "ENSG00000126106.14",
      gene_type : "protein_coding",
      gene_name : "TMEM53",
      gene_level : 2,
      hgnc_id : "HGNC:26186",
      havana_gene : "OTTHUMG00000007833.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44674692,
      stop : 44725591,
      direction : "+",
      ID : "ENSG00000198520.12",
      gene_id : "ENSG00000198520.12",
      gene_type : "protein_coding",
      gene_name : "ARMH1",
      gene_level : 1,
      hgnc_id : "HGNC:34345",
      havana_gene : "OTTHUMG00000007834.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44739818,
      stop : 44767767,
      direction : "+",
      ID : "ENSG00000142945.13",
      gene_id : "ENSG00000142945.13",
      gene_type : "protein_coding",
      gene_name : "KIF2C",
      gene_level : 2,
      hgnc_id : "HGNC:6393",
      havana_gene : "OTTHUMG00000008416.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44775251,
      stop : 44778779,
      direction : "+",
      ID : "ENSG00000142937.12",
      gene_id : "ENSG00000142937.12",
      gene_type : "protein_coding",
      gene_name : "RPS8",
      gene_level : 2,
      hgnc_id : "HGNC:10441",
      havana_gene : "OTTHUMG00000008494.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44783585,
      stop : 44788170,
      direction : "-",
      ID : "ENSG00000142959.5",
      gene_id : "ENSG00000142959.5",
      gene_type : "protein_coding",
      gene_name : "BEST4",
      gene_level : 2,
      hgnc_id : "HGNC:17106",
      havana_gene : "OTTHUMG00000008488.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44800377,
      stop : 44805990,
      direction : "+",
      ID : "ENSG00000173846.13",
      gene_id : "ENSG00000173846.13",
      gene_type : "protein_coding",
      gene_name : "PLK3",
      gene_level : 2,
      hgnc_id : "HGNC:2154",
      havana_gene : "OTTHUMG00000008491.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44805893,
      stop : 44807351,
      direction : "-",
      ID : "ENSG00000188396.4",
      gene_id : "ENSG00000188396.4",
      gene_type : "protein_coding",
      gene_name : "TCTEX1D4",
      gene_level : 2,
      hgnc_id : "HGNC:32315",
      havana_gene : "OTTHUMG00000008489.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44808482,
      stop : 44815585,
      direction : "+",
      ID : "ENSG00000222009.8",
      gene_id : "ENSG00000222009.8",
      gene_type : "protein_coding",
      gene_name : "BTBD19",
      gene_level : 2,
      hgnc_id : "HGNC:27145",
      havana_gene : "OTTHUMG00000008493.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44819844,
      stop : 44843253,
      direction : "-",
      ID : "ENSG00000117425.14",
      gene_id : "ENSG00000117425.14",
      gene_type : "protein_coding",
      gene_name : "PTCH2",
      gene_level : 2,
      hgnc_id : "HGNC:9586",
      havana_gene : "OTTHUMG00000008490.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 44850522,
      stop : 44986722,
      direction : "-",
      ID : "ENSG00000070785.17",
      gene_id : "ENSG00000070785.17",
      gene_type : "protein_coding",
      gene_name : "EIF2B3",
      gene_level : 2,
      hgnc_id : "HGNC:3259",
      havana_gene : "OTTHUMG00000008585.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45002540,
      stop : 45011324,
      direction : "-",
      ID : "ENSG00000126107.15",
      gene_id : "ENSG00000126107.15",
      gene_type : "protein_coding",
      gene_name : "HECTD3",
      gene_level : 2,
      hgnc_id : "HGNC:26117",
      havana_gene : "OTTHUMG00000008587.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45010950,
      stop : 45015575,
      direction : "+",
      ID : "ENSG00000126088.14",
      gene_id : "ENSG00000126088.14",
      gene_type : "protein_coding",
      gene_name : "UROD",
      gene_level : 2,
      hgnc_id : "HGNC:12591",
      havana_gene : "OTTHUMG00000008949.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45016399,
      stop : 45306209,
      direction : "-",
      ID : "ENSG00000162415.7",
      gene_id : "ENSG00000162415.7",
      gene_type : "protein_coding",
      gene_name : "ZSWIM5",
      gene_level : 2,
      hgnc_id : "HGNC:29299",
      havana_gene : "OTTHUMG00000008950.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45326895,
      stop : 45328679,
      direction : "+",
      ID : "ENSG00000186603.6",
      gene_id : "ENSG00000186603.6",
      gene_type : "protein_coding",
      gene_name : "HPDL",
      gene_level : 2,
      hgnc_id : "HGNC:28242",
      havana_gene : "OTTHUMG00000007681.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45329163,
      stop : 45340893,
      direction : "-",
      ID : "ENSG00000132781.19",
      gene_id : "ENSG00000132781.19",
      gene_type : "protein_coding",
      gene_name : "MUTYH",
      gene_level : 1,
      hgnc_id : "HGNC:7527",
      havana_gene : "OTTHUMG00000007682.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45329262,
      stop : 45491155,
      direction : "-",
      ID : "ENSG00000288208.1",
      gene_id : "ENSG00000288208.1",
      gene_type : "protein_coding",
      gene_name : "AL451136.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000195938.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45340052,
      stop : 45343973,
      direction : "+",
      ID : "ENSG00000132773.12",
      gene_id : "ENSG00000132773.12",
      gene_type : "protein_coding",
      gene_name : "TOE1",
      gene_level : 2,
      hgnc_id : "HGNC:15954",
      havana_gene : "OTTHUMG00000007678.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45343883,
      stop : 45491163,
      direction : "-",
      ID : "ENSG00000070759.17",
      gene_id : "ENSG00000070759.17",
      gene_type : "protein_coding",
      gene_name : "TESK2",
      gene_level : 2,
      hgnc_id : "HGNC:11732",
      havana_gene : "OTTHUMG00000007680.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45493866,
      stop : 45500079,
      direction : "-",
      ID : "ENSG00000280670.3",
      gene_id : "ENSG00000280670.3",
      gene_type : "protein_coding",
      gene_name : "CCDC163",
      gene_level : 2,
      hgnc_id : "HGNC:27003",
      havana_gene : "OTTHUMG00000007741.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45500300,
      stop : 45513382,
      direction : "+",
      ID : "ENSG00000132763.15",
      gene_id : "ENSG00000132763.15",
      gene_type : "protein_coding",
      gene_name : "MMACHC",
      gene_level : 1,
      hgnc_id : "HGNC:24525",
      havana_gene : "OTTHUMG00000007742.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45510914,
      stop : 45542732,
      direction : "-",
      ID : "ENSG00000117450.15",
      gene_id : "ENSG00000117450.15",
      gene_type : "protein_coding",
      gene_name : "PRDX1",
      gene_level : 2,
      hgnc_id : "HGNC:9352",
      havana_gene : "OTTHUMG00000007738.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45550543,
      stop : 45570049,
      direction : "+",
      ID : "ENSG00000117448.14",
      gene_id : "ENSG00000117448.14",
      gene_type : "protein_coding",
      gene_name : "AKR1A1",
      gene_level : 1,
      hgnc_id : "HGNC:380",
      havana_gene : "OTTHUMG00000007740.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45583846,
      stop : 45618904,
      direction : "+",
      ID : "ENSG00000132780.17",
      gene_id : "ENSG00000132780.17",
      gene_type : "protein_coding",
      gene_name : "NASP",
      gene_level : 1,
      hgnc_id : "HGNC:7644",
      havana_gene : "OTTHUMG00000007826.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45620044,
      stop : 45624057,
      direction : "-",
      ID : "ENSG00000159588.15",
      gene_id : "ENSG00000159588.15",
      gene_type : "protein_coding",
      gene_name : "CCDC17",
      gene_level : 2,
      hgnc_id : "HGNC:26574",
      havana_gene : "OTTHUMG00000007822.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45627304,
      stop : 45688113,
      direction : "-",
      ID : "ENSG00000159592.11",
      gene_id : "ENSG00000159592.11",
      gene_type : "protein_coding",
      gene_name : "GPBP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:28843",
      havana_gene : "OTTHUMG00000040990.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45688181,
      stop : 45694436,
      direction : "+",
      ID : "ENSG00000159596.7",
      gene_id : "ENSG00000159596.7",
      gene_type : "protein_coding",
      gene_name : "TMEM69",
      gene_level : 2,
      hgnc_id : "HGNC:28035",
      havana_gene : "OTTHUMG00000040993.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45694324,
      stop : 45750653,
      direction : "-",
      ID : "ENSG00000197429.11",
      gene_id : "ENSG00000197429.11",
      gene_type : "protein_coding",
      gene_name : "IPP",
      gene_level : 2,
      hgnc_id : "HGNC:6108",
      havana_gene : "OTTHUMG00000008004.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 45786987,
      stop : 46036122,
      direction : "+",
      ID : "ENSG00000086015.22",
      gene_id : "ENSG00000086015.22",
      gene_type : "protein_coding",
      gene_name : "MAST2",
      gene_level : 2,
      hgnc_id : "HGNC:19035",
      havana_gene : "OTTHUMG00000008007.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46040140,
      stop : 46133036,
      direction : "-",
      ID : "ENSG00000117461.15",
      gene_id : "ENSG00000117461.15",
      gene_type : "protein_coding",
      gene_name : "PIK3R3",
      gene_level : 2,
      hgnc_id : "HGNC:8981",
      havana_gene : "OTTHUMG00000008096.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46043661,
      stop : 46176488,
      direction : "-",
      ID : "ENSG00000278139.1",
      gene_id : "ENSG00000278139.1",
      gene_type : "protein_coding",
      gene_name : "P3R3URF-PIK3R3",
      gene_level : 2,
      hgnc_id : "HGNC:54999",
      havana_gene : "OTTHUMG00000186753.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46175073,
      stop : 46185962,
      direction : "+",
      ID : "ENSG00000117472.10",
      gene_id : "ENSG00000117472.10",
      gene_type : "protein_coding",
      gene_name : "TSPAN1",
      gene_level : 2,
      hgnc_id : "HGNC:20657",
      havana_gene : "OTTHUMG00000007602.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46175486,
      stop : 46176488,
      direction : "-",
      ID : "ENSG00000250719.2",
      gene_id : "ENSG00000250719.2",
      gene_type : "protein_coding",
      gene_name : "P3R3URF",
      gene_level : 1,
      hgnc_id : "HGNC:53451",
      havana_gene : "OTTHUMG00000007603.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46188682,
      stop : 46220305,
      direction : "-",
      ID : "ENSG00000085998.14",
      gene_id : "ENSG00000085998.14",
      gene_type : "protein_coding",
      gene_name : "POMGNT1",
      gene_level : 2,
      hgnc_id : "HGNC:19139",
      havana_gene : "OTTHUMG00000007604.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46203334,
      stop : 46221256,
      direction : "+",
      ID : "ENSG00000171357.6",
      gene_id : "ENSG00000171357.6",
      gene_type : "protein_coding",
      gene_name : "LURAP1",
      gene_level : 2,
      hgnc_id : "HGNC:32327",
      havana_gene : "OTTHUMG00000007605.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46246461,
      stop : 46278480,
      direction : "+",
      ID : "ENSG00000085999.13",
      gene_id : "ENSG00000085999.13",
      gene_type : "protein_coding",
      gene_name : "RAD54L",
      gene_level : 1,
      hgnc_id : "HGNC:9826",
      havana_gene : "OTTHUMG00000007772.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46261196,
      stop : 46303616,
      direction : "-",
      ID : "ENSG00000132128.17",
      gene_id : "ENSG00000132128.17",
      gene_type : "protein_coding",
      gene_name : "LRRC41",
      gene_level : 2,
      hgnc_id : "HGNC:16917",
      havana_gene : "OTTHUMG00000007810.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46303698,
      stop : 46316776,
      direction : "+",
      ID : "ENSG00000173660.12",
      gene_id : "ENSG00000173660.12",
      gene_type : "protein_coding",
      gene_name : "UQCRH",
      gene_level : 2,
      hgnc_id : "HGNC:12590",
      havana_gene : "OTTHUMG00000007813.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46340177,
      stop : 46365152,
      direction : "+",
      ID : "ENSG00000117481.10",
      gene_id : "ENSG00000117481.10",
      gene_type : "protein_coding",
      gene_name : "NSUN4",
      gene_level : 2,
      hgnc_id : "HGNC:31802",
      havana_gene : "OTTHUMG00000007808.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46394317,
      stop : 46413848,
      direction : "+",
      ID : "ENSG00000117480.16",
      gene_id : "ENSG00000117480.16",
      gene_type : "protein_coding",
      gene_name : "FAAH",
      gene_level : 2,
      hgnc_id : "HGNC:3553",
      havana_gene : "OTTHUMG00000007811.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46489836,
      stop : 46516216,
      direction : "+",
      ID : "ENSG00000197587.11",
      gene_id : "ENSG00000197587.11",
      gene_type : "protein_coding",
      gene_name : "DMBX1",
      gene_level : 2,
      hgnc_id : "HGNC:19026",
      havana_gene : "OTTHUMG00000007982.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46532166,
      stop : 46543969,
      direction : "-",
      ID : "ENSG00000282881.2",
      gene_id : "ENSG00000282881.2",
      gene_type : "protein_coding",
      gene_name : "TMEM275",
      gene_level : 2,
      hgnc_id : "HGNC:53938",
      havana_gene : "OTTHUMG00000191600.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46545641,
      stop : 46551647,
      direction : "-",
      ID : "ENSG00000162456.10",
      gene_id : "ENSG00000162456.10",
      gene_type : "protein_coding",
      gene_name : "KNCN",
      gene_level : 2,
      hgnc_id : "HGNC:26488",
      havana_gene : "OTTHUMG00000007987.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46557407,
      stop : 46616843,
      direction : "-",
      ID : "ENSG00000079277.22",
      gene_id : "ENSG00000079277.22",
      gene_type : "protein_coding",
      gene_name : "MKNK1",
      gene_level : 1,
      hgnc_id : "HGNC:7110",
      havana_gene : "OTTHUMG00000007983.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46607715,
      stop : 46616884,
      direction : "-",
      ID : "ENSG00000142961.15",
      gene_id : "ENSG00000142961.15",
      gene_type : "protein_coding",
      gene_name : "MOB3C",
      gene_level : 2,
      hgnc_id : "HGNC:29800",
      havana_gene : "OTTHUMG00000007989.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46632737,
      stop : 46673867,
      direction : "-",
      ID : "ENSG00000123472.12",
      gene_id : "ENSG00000123472.12",
      gene_type : "protein_coding",
      gene_name : "ATPAF1",
      gene_level : 1,
      hgnc_id : "HGNC:18803",
      havana_gene : "OTTHUMG00000007988.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46668855,
      stop : 46673594,
      direction : "+",
      ID : "ENSG00000186118.9",
      gene_id : "ENSG00000186118.9",
      gene_type : "protein_coding",
      gene_name : "TEX38",
      gene_level : 1,
      hgnc_id : "HGNC:29589",
      havana_gene : "OTTHUMG00000007991.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46674659,
      stop : 46719146,
      direction : "-",
      ID : "ENSG00000159658.15",
      gene_id : "ENSG00000159658.15",
      gene_type : "protein_coding",
      gene_name : "EFCAB14",
      gene_level : 2,
      hgnc_id : "HGNC:29051",
      havana_gene : "OTTHUMG00000007992.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46757838,
      stop : 46819413,
      direction : "+",
      ID : "ENSG00000142973.14",
      gene_id : "ENSG00000142973.14",
      gene_type : "protein_coding",
      gene_name : "CYP4B1",
      gene_level : 1,
      hgnc_id : "HGNC:2644",
      havana_gene : "OTTHUMG00000007984.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 46929177,
      stop : 46941484,
      direction : "-",
      ID : "ENSG00000187048.13",
      gene_id : "ENSG00000187048.13",
      gene_type : "protein_coding",
      gene_name : "CYP4A11",
      gene_level : 2,
      hgnc_id : "HGNC:2642",
      havana_gene : "OTTHUMG00000008020.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47023669,
      stop : 47050751,
      direction : "+",
      ID : "ENSG00000186377.8",
      gene_id : "ENSG00000186377.8",
      gene_type : "protein_coding",
      gene_name : "CYP4X1",
      gene_level : 2,
      hgnc_id : "HGNC:20244",
      havana_gene : "OTTHUMG00000008017.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47067231,
      stop : 47118318,
      direction : "+",
      ID : "ENSG00000186160.5",
      gene_id : "ENSG00000186160.5",
      gene_type : "protein_coding",
      gene_name : "CYP4Z1",
      gene_level : 2,
      hgnc_id : "HGNC:20583",
      havana_gene : "OTTHUMG00000008019.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47137435,
      stop : 47149735,
      direction : "+",
      ID : "ENSG00000162365.12",
      gene_id : "ENSG00000162365.12",
      gene_type : "protein_coding",
      gene_name : "CYP4A22",
      gene_level : 2,
      hgnc_id : "HGNC:20575",
      havana_gene : "OTTHUMG00000007845.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47183582,
      stop : 47191044,
      direction : "-",
      ID : "ENSG00000162366.8",
      gene_id : "ENSG00000162366.8",
      gene_type : "protein_coding",
      gene_name : "PDZK1IP1",
      gene_level : 2,
      hgnc_id : "HGNC:16887",
      havana_gene : "OTTHUMG00000007852.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47216290,
      stop : 47232220,
      direction : "-",
      ID : "ENSG00000162367.11",
      gene_id : "ENSG00000162367.11",
      gene_type : "protein_coding",
      gene_name : "TAL1",
      gene_level : 2,
      hgnc_id : "HGNC:11556",
      havana_gene : "OTTHUMG00000007847.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47250139,
      stop : 47314147,
      direction : "-",
      ID : "ENSG00000123473.16",
      gene_id : "ENSG00000123473.16",
      gene_type : "protein_coding",
      gene_name : "STIL",
      gene_level : 1,
      hgnc_id : "HGNC:10879",
      havana_gene : "OTTHUMG00000007851.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47333797,
      stop : 47378839,
      direction : "+",
      ID : "ENSG00000162368.13",
      gene_id : "ENSG00000162368.13",
      gene_type : "protein_coding",
      gene_name : "CMPK1",
      gene_level : 2,
      hgnc_id : "HGNC:18170",
      havana_gene : "OTTHUMG00000007849.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47416285,
      stop : 47418052,
      direction : "+",
      ID : "ENSG00000186790.6",
      gene_id : "ENSG00000186790.6",
      gene_type : "protein_coding",
      gene_name : "FOXE3",
      gene_level : 2,
      hgnc_id : "HGNC:3808",
      havana_gene : "OTTHUMG00000007954.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47438044,
      stop : 47440691,
      direction : "+",
      ID : "ENSG00000186564.6",
      gene_id : "ENSG00000186564.6",
      gene_type : "protein_coding",
      gene_name : "FOXD2",
      gene_level : 2,
      hgnc_id : "HGNC:3803",
      havana_gene : "OTTHUMG00000007950.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 47760528,
      stop : 47997385,
      direction : "-",
      ID : "ENSG00000269113.4",
      gene_id : "ENSG00000269113.4",
      gene_type : "protein_coding",
      gene_name : "TRABD2B",
      gene_level : 2,
      hgnc_id : "HGNC:44200",
      havana_gene : "OTTHUMG00000007960.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 48222685,
      stop : 48248644,
      direction : "+",
      ID : "ENSG00000117834.13",
      gene_id : "ENSG00000117834.13",
      gene_type : "protein_coding",
      gene_name : "SLC5A9",
      gene_level : 2,
      hgnc_id : "HGNC:22146",
      havana_gene : "OTTHUMG00000007959.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 48295373,
      stop : 48472208,
      direction : "-",
      ID : "ENSG00000132122.12",
      gene_id : "ENSG00000132122.12",
      gene_type : "protein_coding",
      gene_name : "SPATA6",
      gene_level : 2,
      hgnc_id : "HGNC:18309",
      havana_gene : "OTTHUMG00000007794.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 48532854,
      stop : 50023954,
      direction : "-",
      ID : "ENSG00000186094.17",
      gene_id : "ENSG00000186094.17",
      gene_type : "protein_coding",
      gene_name : "AGBL4",
      gene_level : 2,
      hgnc_id : "HGNC:25892",
      havana_gene : "OTTHUMG00000007793.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 48727519,
      stop : 48776969,
      direction : "-",
      ID : "ENSG00000162373.13",
      gene_id : "ENSG00000162373.13",
      gene_type : "protein_coding",
      gene_name : "BEND5",
      gene_level : 2,
      hgnc_id : "HGNC:25668",
      havana_gene : "OTTHUMG00000008153.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 50024029,
      stop : 50203772,
      direction : "+",
      ID : "ENSG00000162374.18",
      gene_id : "ENSG00000162374.18",
      gene_type : "protein_coding",
      gene_name : "ELAVL4",
      gene_level : 2,
      hgnc_id : "HGNC:3315",
      havana_gene : "OTTHUMG00000007877.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 50417550,
      stop : 50423443,
      direction : "-",
      ID : "ENSG00000142700.12",
      gene_id : "ENSG00000142700.12",
      gene_type : "protein_coding",
      gene_name : "DMRTA2",
      gene_level : 2,
      hgnc_id : "HGNC:13908",
      havana_gene : "OTTHUMG00000007884.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 50437028,
      stop : 50960267,
      direction : "-",
      ID : "ENSG00000185104.20",
      gene_id : "ENSG00000185104.20",
      gene_type : "protein_coding",
      gene_name : "FAF1",
      gene_level : 2,
      hgnc_id : "HGNC:3578",
      havana_gene : "OTTHUMG00000007930.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 50960745,
      stop : 50974634,
      direction : "+",
      ID : "ENSG00000123080.12",
      gene_id : "ENSG00000123080.12",
      gene_type : "protein_coding",
      gene_name : "CDKN2C",
      gene_level : 2,
      hgnc_id : "HGNC:1789",
      havana_gene : "OTTHUMG00000008046.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51102221,
      stop : 51148086,
      direction : "+",
      ID : "ENSG00000204006.10",
      gene_id : "ENSG00000204006.10",
      gene_type : "protein_coding",
      gene_name : "C1orf185",
      gene_level : 2,
      hgnc_id : "HGNC:28096",
      havana_gene : "OTTHUMG00000008084.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51236273,
      stop : 51273447,
      direction : "+",
      ID : "ENSG00000123091.5",
      gene_id : "ENSG00000123091.5",
      gene_type : "protein_coding",
      gene_name : "RNF11",
      gene_level : 2,
      hgnc_id : "HGNC:10056",
      havana_gene : "OTTHUMG00000008190.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51287258,
      stop : 51345116,
      direction : "-",
      ID : "ENSG00000085831.16",
      gene_id : "ENSG00000085831.16",
      gene_type : "protein_coding",
      gene_name : "TTC39A",
      gene_level : 2,
      hgnc_id : "HGNC:18657",
      havana_gene : "OTTHUMG00000008193.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51354263,
      stop : 51519266,
      direction : "-",
      ID : "ENSG00000085832.17",
      gene_id : "ENSG00000085832.17",
      gene_type : "protein_coding",
      gene_name : "EPS15",
      gene_level : 1,
      hgnc_id : "HGNC:3419",
      havana_gene : "OTTHUMG00000008192.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51577179,
      stop : 51798427,
      direction : "+",
      ID : "ENSG00000117859.19",
      gene_id : "ENSG00000117859.19",
      gene_type : "protein_coding",
      gene_name : "OSBPL9",
      gene_level : 2,
      hgnc_id : "HGNC:16386",
      havana_gene : "OTTHUMG00000008234.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51789191,
      stop : 51878937,
      direction : "-",
      ID : "ENSG00000078618.22",
      gene_id : "ENSG00000078618.22",
      gene_type : "protein_coding",
      gene_name : "NRDC",
      gene_level : 1,
      hgnc_id : "HGNC:7995",
      havana_gene : "OTTHUMG00000008278.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 51907956,
      stop : 51990700,
      direction : "-",
      ID : "ENSG00000169213.7",
      gene_id : "ENSG00000169213.7",
      gene_type : "protein_coding",
      gene_name : "RAB3B",
      gene_level : 2,
      hgnc_id : "HGNC:9778",
      havana_gene : "OTTHUMG00000008627.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52020131,
      stop : 52055191,
      direction : "-",
      ID : "ENSG00000117862.13",
      gene_id : "ENSG00000117862.13",
      gene_type : "protein_coding",
      gene_name : "TXNDC12",
      gene_level : 2,
      hgnc_id : "HGNC:24626",
      havana_gene : "OTTHUMG00000008629.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52020153,
      stop : 52033350,
      direction : "-",
      ID : "ENSG00000285839.1",
      gene_id : "ENSG00000285839.1",
      gene_type : "protein_coding",
      gene_name : "AL445685.3",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193360.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52032103,
      stop : 52033810,
      direction : "-",
      ID : "ENSG00000198841.4",
      gene_id : "ENSG00000198841.4",
      gene_type : "protein_coding",
      gene_name : "KTI12",
      gene_level : 2,
      hgnc_id : "HGNC:25160",
      havana_gene : "OTTHUMG00000008630.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52056199,
      stop : 52090716,
      direction : "+",
      ID : "ENSG00000134717.18",
      gene_id : "ENSG00000134717.18",
      gene_type : "protein_coding",
      gene_name : "BTF3L4",
      gene_level : 2,
      hgnc_id : "HGNC:30547",
      havana_gene : "OTTHUMG00000008960.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52142089,
      stop : 52348671,
      direction : "+",
      ID : "ENSG00000157077.16",
      gene_id : "ENSG00000157077.16",
      gene_type : "protein_coding",
      gene_name : "ZFYVE9",
      gene_level : 2,
      hgnc_id : "HGNC:6775",
      havana_gene : "OTTHUMG00000008061.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52345723,
      stop : 52366205,
      direction : "-",
      ID : "ENSG00000154222.15",
      gene_id : "ENSG00000154222.15",
      gene_type : "protein_coding",
      gene_name : "CC2D1B",
      gene_level : 2,
      hgnc_id : "HGNC:29386",
      havana_gene : "OTTHUMG00000008102.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52372829,
      stop : 52404423,
      direction : "-",
      ID : "ENSG00000085840.13",
      gene_id : "ENSG00000085840.13",
      gene_type : "protein_coding",
      gene_name : "ORC1",
      gene_level : 2,
      hgnc_id : "HGNC:8487",
      havana_gene : "OTTHUMG00000008104.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52404602,
      stop : 52420836,
      direction : "+",
      ID : "ENSG00000134748.13",
      gene_id : "ENSG00000134748.13",
      gene_type : "protein_coding",
      gene_name : "PRPF38A",
      gene_level : 2,
      hgnc_id : "HGNC:25930",
      havana_gene : "OTTHUMG00000008199.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52408282,
      stop : 52553487,
      direction : "-",
      ID : "ENSG00000134744.14",
      gene_id : "ENSG00000134744.14",
      gene_type : "protein_coding",
      gene_name : "TUT4",
      gene_level : 1,
      hgnc_id : "HGNC:28981",
      havana_gene : "OTTHUMG00000008200.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52602371,
      stop : 52609051,
      direction : "+",
      ID : "ENSG00000116157.6",
      gene_id : "ENSG00000116157.6",
      gene_type : "protein_coding",
      gene_name : "GPX7",
      gene_level : 2,
      hgnc_id : "HGNC:4559",
      havana_gene : "OTTHUMG00000008322.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52633168,
      stop : 52669683,
      direction : "+",
      ID : "ENSG00000182183.15",
      gene_id : "ENSG00000182183.15",
      gene_type : "protein_coding",
      gene_name : "SHISAL2A",
      gene_level : 2,
      hgnc_id : "HGNC:28757",
      havana_gene : "OTTHUMG00000008330.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52684449,
      stop : 52698347,
      direction : "-",
      ID : "ENSG00000162377.6",
      gene_id : "ENSG00000162377.6",
      gene_type : "protein_coding",
      gene_name : "COA7",
      gene_level : 2,
      hgnc_id : "HGNC:25716",
      havana_gene : "OTTHUMG00000008505.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52726453,
      stop : 52827336,
      direction : "+",
      ID : "ENSG00000162378.13",
      gene_id : "ENSG00000162378.13",
      gene_type : "protein_coding",
      gene_name : "ZYG11B",
      gene_level : 2,
      hgnc_id : "HGNC:25820",
      havana_gene : "OTTHUMG00000008938.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52842511,
      stop : 52894998,
      direction : "+",
      ID : "ENSG00000203995.10",
      gene_id : "ENSG00000203995.10",
      gene_type : "protein_coding",
      gene_name : "ZYG11A",
      gene_level : 2,
      hgnc_id : "HGNC:32058",
      havana_gene : "OTTHUMG00000008923.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52895910,
      stop : 52927212,
      direction : "-",
      ID : "ENSG00000121310.17",
      gene_id : "ENSG00000121310.17",
      gene_type : "protein_coding",
      gene_name : "ECHDC2",
      gene_level : 2,
      hgnc_id : "HGNC:23408",
      havana_gene : "OTTHUMG00000008927.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 52927276,
      stop : 53051698,
      direction : "+",
      ID : "ENSG00000116171.19",
      gene_id : "ENSG00000116171.19",
      gene_type : "protein_coding",
      gene_name : "SCP2",
      gene_level : 1,
      hgnc_id : "HGNC:10606",
      havana_gene : "OTTHUMG00000008936.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53062052,
      stop : 53085501,
      direction : "+",
      ID : "ENSG00000174348.14",
      gene_id : "ENSG00000174348.14",
      gene_type : "protein_coding",
      gene_name : "PODN",
      gene_level : 2,
      hgnc_id : "HGNC:23174",
      havana_gene : "OTTHUMG00000008934.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53087179,
      stop : 53142638,
      direction : "-",
      ID : "ENSG00000162383.13",
      gene_id : "ENSG00000162383.13",
      gene_type : "protein_coding",
      gene_name : "SLC1A7",
      gene_level : 2,
      hgnc_id : "HGNC:10945",
      havana_gene : "OTTHUMG00000008937.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53196792,
      stop : 53214197,
      direction : "+",
      ID : "ENSG00000157184.7",
      gene_id : "ENSG00000157184.7",
      gene_type : "protein_coding",
      gene_name : "CPT2",
      gene_level : 2,
      hgnc_id : "HGNC:2330",
      havana_gene : "OTTHUMG00000008942.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53214099,
      stop : 53220634,
      direction : "-",
      ID : "ENSG00000162384.14",
      gene_id : "ENSG00000162384.14",
      gene_type : "protein_coding",
      gene_name : "CZIB",
      gene_level : 2,
      hgnc_id : "HGNC:26059",
      havana_gene : "OTTHUMG00000008940.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53226900,
      stop : 53238518,
      direction : "-",
      ID : "ENSG00000162385.11",
      gene_id : "ENSG00000162385.11",
      gene_type : "protein_coding",
      gene_name : "MAGOH",
      gene_level : 2,
      hgnc_id : "HGNC:6815",
      havana_gene : "OTTHUMG00000008932.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53242364,
      stop : 53328469,
      direction : "-",
      ID : "ENSG00000157193.18",
      gene_id : "ENSG00000157193.18",
      gene_type : "protein_coding",
      gene_name : "LRP8",
      gene_level : 1,
      hgnc_id : "HGNC:6700",
      havana_gene : "OTTHUMG00000008924.46",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53459399,
      stop : 53467488,
      direction : "+",
      ID : "ENSG00000143006.7",
      gene_id : "ENSG00000143006.7",
      gene_type : "protein_coding",
      gene_name : "DMRTB1",
      gene_level : 2,
      hgnc_id : "HGNC:13913",
      havana_gene : "OTTHUMG00000008080.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53506237,
      stop : 53738106,
      direction : "-",
      ID : "ENSG00000174332.5",
      gene_id : "ENSG00000174332.5",
      gene_type : "protein_coding",
      gene_name : "GLIS1",
      gene_level : 2,
      hgnc_id : "HGNC:29525",
      havana_gene : "OTTHUMG00000008079.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53765478,
      stop : 53838463,
      direction : "-",
      ID : "ENSG00000058804.12",
      gene_id : "ENSG00000058804.12",
      gene_type : "protein_coding",
      gene_name : "NDC1",
      gene_level : 2,
      hgnc_id : "HGNC:25525",
      havana_gene : "OTTHUMG00000008073.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53851719,
      stop : 53889798,
      direction : "-",
      ID : "ENSG00000058799.15",
      gene_id : "ENSG00000058799.15",
      gene_type : "protein_coding",
      gene_name : "YIPF1",
      gene_level : 2,
      hgnc_id : "HGNC:25231",
      havana_gene : "OTTHUMG00000008074.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53891239,
      stop : 53911086,
      direction : "+",
      ID : "ENSG00000211452.11",
      gene_id : "ENSG00000211452.11",
      gene_type : "protein_coding",
      gene_name : "DIO1",
      gene_level : 2,
      hgnc_id : "HGNC:2883",
      havana_gene : "OTTHUMG00000008435.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53916574,
      stop : 53945699,
      direction : "-",
      ID : "ENSG00000081870.12",
      gene_id : "ENSG00000081870.12",
      gene_type : "protein_coding",
      gene_name : "HSPB11",
      gene_level : 2,
      hgnc_id : "HGNC:25019",
      havana_gene : "OTTHUMG00000008408.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 53946085,
      stop : 53968168,
      direction : "+",
      ID : "ENSG00000116212.15",
      gene_id : "ENSG00000116212.15",
      gene_type : "protein_coding",
      gene_name : "LRRC42",
      gene_level : 2,
      hgnc_id : "HGNC:28792",
      havana_gene : "OTTHUMG00000008436.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54007298,
      stop : 54018186,
      direction : "-",
      ID : "ENSG00000203985.11",
      gene_id : "ENSG00000203985.11",
      gene_type : "protein_coding",
      gene_name : "LDLRAD1",
      gene_level : 2,
      hgnc_id : "HGNC:32069",
      havana_gene : "OTTHUMG00000008433.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54026681,
      stop : 54053504,
      direction : "-",
      ID : "ENSG00000116209.12",
      gene_id : "ENSG00000116209.12",
      gene_type : "protein_coding",
      gene_name : "TMEM59",
      gene_level : 2,
      hgnc_id : "HGNC:1239",
      havana_gene : "OTTHUMG00000008437.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54053584,
      stop : 54112519,
      direction : "+",
      ID : "ENSG00000116205.14",
      gene_id : "ENSG00000116205.14",
      gene_type : "protein_coding",
      gene_name : "TCEANC2",
      gene_level : 2,
      hgnc_id : "HGNC:26494",
      havana_gene : "OTTHUMG00000008434.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54132686,
      stop : 54200073,
      direction : "-",
      ID : "ENSG00000256407.2",
      gene_id : "ENSG00000256407.2",
      gene_type : "protein_coding",
      gene_name : "AL357673.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168203.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54132968,
      stop : 54153770,
      direction : "-",
      ID : "ENSG00000157211.11",
      gene_id : "ENSG00000157211.11",
      gene_type : "protein_coding",
      gene_name : "CDCP2",
      gene_level : 1,
      hgnc_id : "HGNC:27297",
      havana_gene : "OTTHUMG00000155307.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54169651,
      stop : 54200036,
      direction : "-",
      ID : "ENSG00000215883.10",
      gene_id : "ENSG00000215883.10",
      gene_type : "protein_coding",
      gene_name : "CYB5RL",
      gene_level : 1,
      hgnc_id : "HGNC:32220",
      havana_gene : "OTTHUMG00000008082.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54184041,
      stop : 54225464,
      direction : "+",
      ID : "ENSG00000116221.15",
      gene_id : "ENSG00000116221.15",
      gene_type : "protein_coding",
      gene_name : "MRPL37",
      gene_level : 1,
      hgnc_id : "HGNC:14034",
      havana_gene : "OTTHUMG00000008118.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54225433,
      stop : 54413479,
      direction : "-",
      ID : "ENSG00000157216.16",
      gene_id : "ENSG00000157216.16",
      gene_type : "protein_coding",
      gene_name : "SSBP3",
      gene_level : 2,
      hgnc_id : "HGNC:15674",
      havana_gene : "OTTHUMG00000008264.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54542257,
      stop : 54639192,
      direction : "+",
      ID : "ENSG00000162390.18",
      gene_id : "ENSG00000162390.18",
      gene_type : "protein_coding",
      gene_name : "ACOT11",
      gene_level : 2,
      hgnc_id : "HGNC:18156",
      havana_gene : "OTTHUMG00000009891.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54609181,
      stop : 54623556,
      direction : "-",
      ID : "ENSG00000162391.12",
      gene_id : "ENSG00000162391.12",
      gene_type : "protein_coding",
      gene_name : "FAM151A",
      gene_level : 2,
      hgnc_id : "HGNC:25032",
      havana_gene : "OTTHUMG00000009888.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54641754,
      stop : 54710266,
      direction : "+",
      ID : "ENSG00000184313.20",
      gene_id : "ENSG00000184313.20",
      gene_type : "protein_coding",
      gene_name : "MROH7",
      gene_level : 2,
      hgnc_id : "HGNC:24802",
      havana_gene : "OTTHUMG00000009890.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54641786,
      stop : 54742308,
      direction : "+",
      ID : "ENSG00000271723.5",
      gene_id : "ENSG00000271723.5",
      gene_type : "protein_coding",
      gene_name : "MROH7-TTC4",
      gene_level : 2,
      hgnc_id : "HGNC:49180",
      havana_gene : "OTTHUMG00000185328.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54715861,
      stop : 54742657,
      direction : "+",
      ID : "ENSG00000243725.7",
      gene_id : "ENSG00000243725.7",
      gene_type : "protein_coding",
      gene_name : "TTC4",
      gene_level : 1,
      hgnc_id : "HGNC:12394",
      havana_gene : "OTTHUMG00000009914.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54756898,
      stop : 54764523,
      direction : "-",
      ID : "ENSG00000162396.6",
      gene_id : "ENSG00000162396.6",
      gene_type : "protein_coding",
      gene_name : "PARS2",
      gene_level : 2,
      hgnc_id : "HGNC:30563",
      havana_gene : "OTTHUMG00000009915.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54779712,
      stop : 54801323,
      direction : "-",
      ID : "ENSG00000006555.11",
      gene_id : "ENSG00000006555.11",
      gene_type : "protein_coding",
      gene_name : "TTC22",
      gene_level : 1,
      hgnc_id : "HGNC:26067",
      havana_gene : "OTTHUMG00000009916.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54806063,
      stop : 54842252,
      direction : "+",
      ID : "ENSG00000162398.11",
      gene_id : "ENSG00000162398.11",
      gene_type : "protein_coding",
      gene_name : "LEXM",
      gene_level : 2,
      hgnc_id : "HGNC:26854",
      havana_gene : "OTTHUMG00000009986.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54849627,
      stop : 54887195,
      direction : "-",
      ID : "ENSG00000116133.13",
      gene_id : "ENSG00000116133.13",
      gene_type : "protein_coding",
      gene_name : "DHCR24",
      gene_level : 2,
      hgnc_id : "HGNC:2859",
      havana_gene : "OTTHUMG00000009989.17",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54980628,
      stop : 54992288,
      direction : "+",
      ID : "ENSG00000143001.5",
      gene_id : "ENSG00000143001.5",
      gene_type : "protein_coding",
      gene_name : "TMEM61",
      gene_level : 2,
      hgnc_id : "HGNC:27296",
      havana_gene : "OTTHUMG00000009991.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 54998933,
      stop : 55017172,
      direction : "+",
      ID : "ENSG00000162399.9",
      gene_id : "ENSG00000162399.9",
      gene_type : "protein_coding",
      gene_name : "BSND",
      gene_level : 2,
      hgnc_id : "HGNC:16512",
      havana_gene : "OTTHUMG00000008112.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 55039447,
      stop : 55064852,
      direction : "+",
      ID : "ENSG00000169174.11",
      gene_id : "ENSG00000169174.11",
      gene_type : "protein_coding",
      gene_name : "PCSK9",
      gene_level : 2,
      hgnc_id : "HGNC:20001",
      havana_gene : "OTTHUMG00000008136.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 55066359,
      stop : 55215364,
      direction : "-",
      ID : "ENSG00000162402.14",
      gene_id : "ENSG00000162402.14",
      gene_type : "protein_coding",
      gene_name : "USP24",
      gene_level : 2,
      hgnc_id : "HGNC:12623",
      havana_gene : "OTTHUMG00000008135.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56173433,
      stop : 56524495,
      direction : "-",
      ID : "ENSG00000284686.1",
      gene_id : "ENSG00000284686.1",
      gene_type : "protein_coding",
      gene_name : "AC119674.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192356.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56494761,
      stop : 56645301,
      direction : "-",
      ID : "ENSG00000162407.9",
      gene_id : "ENSG00000162407.9",
      gene_type : "protein_coding",
      gene_name : "PLPP3",
      gene_level : 2,
      hgnc_id : "HGNC:9229",
      havana_gene : "OTTHUMG00000008160.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56645314,
      stop : 56715335,
      direction : "+",
      ID : "ENSG00000162409.11",
      gene_id : "ENSG00000162409.11",
      gene_type : "protein_coding",
      gene_name : "PRKAA2",
      gene_level : 2,
      hgnc_id : "HGNC:9377",
      havana_gene : "OTTHUMG00000008282.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56718789,
      stop : 56819696,
      direction : "-",
      ID : "ENSG00000187889.13",
      gene_id : "ENSG00000187889.13",
      gene_type : "protein_coding",
      gene_name : "FYB2",
      gene_level : 2,
      hgnc_id : "HGNC:27295",
      havana_gene : "OTTHUMG00000008281.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56854797,
      stop : 56918223,
      direction : "+",
      ID : "ENSG00000157131.11",
      gene_id : "ENSG00000157131.11",
      gene_type : "protein_coding",
      gene_name : "C8A",
      gene_level : 2,
      hgnc_id : "HGNC:1352",
      havana_gene : "OTTHUMG00000008306.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56929207,
      stop : 56966140,
      direction : "-",
      ID : "ENSG00000021852.13",
      gene_id : "ENSG00000021852.13",
      gene_type : "protein_coding",
      gene_name : "C8B",
      gene_level : 2,
      hgnc_id : "HGNC:1353",
      havana_gene : "OTTHUMG00000008305.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 56994778,
      stop : 58546734,
      direction : "-",
      ID : "ENSG00000173406.16",
      gene_id : "ENSG00000173406.16",
      gene_type : "protein_coding",
      gene_name : "DAB1",
      gene_level : 2,
      hgnc_id : "HGNC:2661",
      havana_gene : "OTTHUMG00000008391.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 58415384,
      stop : 58546802,
      direction : "-",
      ID : "ENSG00000162600.12",
      gene_id : "ENSG00000162600.12",
      gene_type : "protein_coding",
      gene_name : "OMA1",
      gene_level : 2,
      hgnc_id : "HGNC:29661",
      havana_gene : "OTTHUMG00000010068.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 58575433,
      stop : 58577252,
      direction : "-",
      ID : "ENSG00000184292.7",
      gene_id : "ENSG00000184292.7",
      gene_type : "protein_coding",
      gene_name : "TACSTD2",
      gene_level : 2,
      hgnc_id : "HGNC:11530",
      havana_gene : "OTTHUMG00000010067.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 58643440,
      stop : 58700077,
      direction : "-",
      ID : "ENSG00000162601.11",
      gene_id : "ENSG00000162601.11",
      gene_type : "protein_coding",
      gene_name : "MYSM1",
      gene_level : 2,
      hgnc_id : "HGNC:29401",
      havana_gene : "OTTHUMG00000009533.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 58776845,
      stop : 58784048,
      direction : "-",
      ID : "ENSG00000177606.8",
      gene_id : "ENSG00000177606.8",
      gene_type : "protein_coding",
      gene_name : "JUN",
      gene_level : 2,
      hgnc_id : "HGNC:6204",
      havana_gene : "OTTHUMG00000008376.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 59296638,
      stop : 59810647,
      direction : "+",
      ID : "ENSG00000172456.18",
      gene_id : "ENSG00000172456.18",
      gene_type : "protein_coding",
      gene_name : "FGGY",
      gene_level : 1,
      hgnc_id : "HGNC:25610",
      havana_gene : "OTTHUMG00000008424.16",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 59814786,
      stop : 59876322,
      direction : "+",
      ID : "ENSG00000134709.12",
      gene_id : "ENSG00000134709.12",
      gene_type : "protein_coding",
      gene_name : "HOOK1",
      gene_level : 2,
      hgnc_id : "HGNC:19884",
      havana_gene : "OTTHUMG00000008990.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 59893308,
      stop : 59926773,
      direction : "-",
      ID : "ENSG00000134716.11",
      gene_id : "ENSG00000134716.11",
      gene_type : "protein_coding",
      gene_name : "CYP2J2",
      gene_level : 2,
      hgnc_id : "HGNC:2634",
      havana_gene : "OTTHUMG00000008991.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 59987269,
      stop : 60073770,
      direction : "-",
      ID : "ENSG00000162598.13",
      gene_id : "ENSG00000162598.13",
      gene_type : "protein_coding",
      gene_name : "C1orf87",
      gene_level : 1,
      hgnc_id : "HGNC:28547",
      havana_gene : "OTTHUMG00000008992.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 60865259,
      stop : 61462788,
      direction : "+",
      ID : "ENSG00000162599.17",
      gene_id : "ENSG00000162599.17",
      gene_type : "protein_coding",
      gene_name : "NFIA",
      gene_level : 1,
      hgnc_id : "HGNC:7784",
      havana_gene : "OTTHUMG00000008618.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 61681046,
      stop : 61725423,
      direction : "-",
      ID : "ENSG00000162604.12",
      gene_id : "ENSG00000162604.12",
      gene_type : "protein_coding",
      gene_name : "TM2D1",
      gene_level : 1,
      hgnc_id : "HGNC:24142",
      havana_gene : "OTTHUMG00000008466.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 61742477,
      stop : 62178675,
      direction : "+",
      ID : "ENSG00000132849.21",
      gene_id : "ENSG00000132849.21",
      gene_type : "protein_coding",
      gene_name : "PATJ",
      gene_level : 2,
      hgnc_id : "HGNC:28881",
      havana_gene : "OTTHUMG00000008560.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 62194849,
      stop : 62212328,
      direction : "+",
      ID : "ENSG00000240563.2",
      gene_id : "ENSG00000240563.2",
      gene_type : "protein_coding",
      gene_name : "L1TD1",
      gene_level : 2,
      hgnc_id : "HGNC:25595",
      havana_gene : "OTTHUMG00000008914.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 62236165,
      stop : 62319434,
      direction : "-",
      ID : "ENSG00000132854.19",
      gene_id : "ENSG00000132854.19",
      gene_type : "protein_coding",
      gene_name : "KANK4",
      gene_level : 2,
      hgnc_id : "HGNC:27263",
      havana_gene : "OTTHUMG00000008971.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 62436297,
      stop : 62451804,
      direction : "+",
      ID : "ENSG00000162607.13",
      gene_id : "ENSG00000162607.13",
      gene_type : "protein_coding",
      gene_name : "USP1",
      gene_level : 2,
      hgnc_id : "HGNC:12607",
      havana_gene : "OTTHUMG00000008972.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 62454298,
      stop : 62688386,
      direction : "-",
      ID : "ENSG00000116641.18",
      gene_id : "ENSG00000116641.18",
      gene_type : "protein_coding",
      gene_name : "DOCK7",
      gene_level : 2,
      hgnc_id : "HGNC:19190",
      havana_gene : "OTTHUMG00000013131.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 62597520,
      stop : 62606313,
      direction : "+",
      ID : "ENSG00000132855.5",
      gene_id : "ENSG00000132855.5",
      gene_type : "protein_coding",
      gene_name : "ANGPTL3",
      gene_level : 2,
      hgnc_id : "HGNC:491",
      havana_gene : "OTTHUMG00000009146.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 62784132,
      stop : 62865516,
      direction : "+",
      ID : "ENSG00000125703.15",
      gene_id : "ENSG00000125703.15",
      gene_type : "protein_coding",
      gene_name : "ATG4C",
      gene_level : 2,
      hgnc_id : "HGNC:16040",
      havana_gene : "OTTHUMG00000009142.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 63322567,
      stop : 63325128,
      direction : "+",
      ID : "ENSG00000187140.6",
      gene_id : "ENSG00000187140.6",
      gene_type : "protein_coding",
      gene_name : "FOXD3",
      gene_level : 2,
      hgnc_id : "HGNC:3804",
      havana_gene : "OTTHUMG00000009141.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 63367575,
      stop : 63438553,
      direction : "+",
      ID : "ENSG00000088035.18",
      gene_id : "ENSG00000088035.18",
      gene_type : "protein_coding",
      gene_name : "ALG6",
      gene_level : 2,
      hgnc_id : "HGNC:23157",
      havana_gene : "OTTHUMG00000009140.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 63440770,
      stop : 63593721,
      direction : "-",
      ID : "ENSG00000142856.17",
      gene_id : "ENSG00000142856.17",
      gene_type : "protein_coding",
      gene_name : "ITGB3BP",
      gene_level : 2,
      hgnc_id : "HGNC:6157",
      havana_gene : "OTTHUMG00000013364.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 63523372,
      stop : 63572693,
      direction : "+",
      ID : "ENSG00000203965.13",
      gene_id : "ENSG00000203965.13",
      gene_type : "protein_coding",
      gene_name : "EFCAB7",
      gene_level : 2,
      hgnc_id : "HGNC:29379",
      havana_gene : "OTTHUMG00000008983.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 63593411,
      stop : 63660245,
      direction : "+",
      ID : "ENSG00000079739.17",
      gene_id : "ENSG00000079739.17",
      gene_type : "protein_coding",
      gene_name : "PGM1",
      gene_level : 2,
      hgnc_id : "HGNC:8905",
      havana_gene : "OTTHUMG00000008968.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 63774017,
      stop : 64181498,
      direction : "+",
      ID : "ENSG00000185483.12",
      gene_id : "ENSG00000185483.12",
      gene_type : "protein_coding",
      gene_name : "ROR1",
      gene_level : 2,
      hgnc_id : "HGNC:10256",
      havana_gene : "OTTHUMG00000009022.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 64203627,
      stop : 64267368,
      direction : "+",
      ID : "ENSG00000177414.13",
      gene_id : "ENSG00000177414.13",
      gene_type : "protein_coding",
      gene_name : "UBE2U",
      gene_level : 2,
      hgnc_id : "HGNC:28559",
      havana_gene : "OTTHUMG00000009023.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 64470129,
      stop : 64693058,
      direction : "+",
      ID : "ENSG00000158966.16",
      gene_id : "ENSG00000158966.16",
      gene_type : "protein_coding",
      gene_name : "CACHD1",
      gene_level : 2,
      hgnc_id : "HGNC:29314",
      havana_gene : "OTTHUMG00000009030.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 64745095,
      stop : 64833232,
      direction : "+",
      ID : "ENSG00000162437.14",
      gene_id : "ENSG00000162437.14",
      gene_type : "protein_coding",
      gene_name : "RAVER2",
      gene_level : 2,
      hgnc_id : "HGNC:25577",
      havana_gene : "OTTHUMG00000009102.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 64833229,
      stop : 65067754,
      direction : "-",
      ID : "ENSG00000162434.13",
      gene_id : "ENSG00000162434.13",
      gene_type : "protein_coding",
      gene_name : "JAK1",
      gene_level : 2,
      hgnc_id : "HGNC:6190",
      havana_gene : "OTTHUMG00000009310.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 65147549,
      stop : 65232145,
      direction : "+",
      ID : "ENSG00000162433.15",
      gene_id : "ENSG00000162433.15",
      gene_type : "protein_coding",
      gene_name : "AK4",
      gene_level : 2,
      hgnc_id : "HGNC:363",
      havana_gene : "OTTHUMG00000009033.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 65248219,
      stop : 65415871,
      direction : "+",
      ID : "ENSG00000116675.16",
      gene_id : "ENSG00000116675.16",
      gene_type : "protein_coding",
      gene_name : "DNAJC6",
      gene_level : 2,
      hgnc_id : "HGNC:15469",
      havana_gene : "OTTHUMG00000009066.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 65420587,
      stop : 65436007,
      direction : "+",
      ID : "ENSG00000213625.9",
      gene_id : "ENSG00000213625.9",
      gene_type : "protein_coding",
      gene_name : "LEPROT",
      gene_level : 2,
      hgnc_id : "HGNC:29477",
      havana_gene : "OTTHUMG00000009065.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 65420652,
      stop : 65641559,
      direction : "+",
      ID : "ENSG00000116678.20",
      gene_id : "ENSG00000116678.20",
      gene_type : "protein_coding",
      gene_name : "LEPR",
      gene_level : 2,
      hgnc_id : "HGNC:6554",
      havana_gene : "OTTHUMG00000009115.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 65792514,
      stop : 66374579,
      direction : "+",
      ID : "ENSG00000184588.18",
      gene_id : "ENSG00000184588.18",
      gene_type : "protein_coding",
      gene_name : "PDE4B",
      gene_level : 1,
      hgnc_id : "HGNC:8781",
      havana_gene : "OTTHUMG00000009088.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 66533383,
      stop : 66751139,
      direction : "+",
      ID : "ENSG00000118473.22",
      gene_id : "ENSG00000118473.22",
      gene_type : "protein_coding",
      gene_name : "SGIP1",
      gene_level : 2,
      hgnc_id : "HGNC:25412",
      havana_gene : "OTTHUMG00000009161.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 66752459,
      stop : 66779047,
      direction : "+",
      ID : "ENSG00000152760.10",
      gene_id : "ENSG00000152760.10",
      gene_type : "protein_coding",
      gene_name : "TCTEX1D1",
      gene_level : 2,
      hgnc_id : "HGNC:26882",
      havana_gene : "OTTHUMG00000009162.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 66797741,
      stop : 66801256,
      direction : "-",
      ID : "ENSG00000172410.4",
      gene_id : "ENSG00000172410.4",
      gene_type : "protein_coding",
      gene_name : "INSL5",
      gene_level : 2,
      hgnc_id : "HGNC:6088",
      havana_gene : "OTTHUMG00000009164.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 66812885,
      stop : 66924856,
      direction : "-",
      ID : "ENSG00000152763.17",
      gene_id : "ENSG00000152763.17",
      gene_type : "protein_coding",
      gene_name : "DNAI4",
      gene_level : 1,
      hgnc_id : "HGNC:26252",
      havana_gene : "OTTHUMG00000009165.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 66924895,
      stop : 66988619,
      direction : "+",
      ID : "ENSG00000198160.15",
      gene_id : "ENSG00000198160.15",
      gene_type : "protein_coding",
      gene_name : "MIER1",
      gene_level : 2,
      hgnc_id : "HGNC:29657",
      havana_gene : "OTTHUMG00000009194.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 66999350,
      stop : 67054148,
      direction : "-",
      ID : "ENSG00000116704.8",
      gene_id : "ENSG00000116704.8",
      gene_type : "protein_coding",
      gene_name : "SLC35D1",
      gene_level : 2,
      hgnc_id : "HGNC:20800",
      havana_gene : "OTTHUMG00000009360.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 67092165,
      stop : 67231853,
      direction : "-",
      ID : "ENSG00000203963.11",
      gene_id : "ENSG00000203963.11",
      gene_type : "protein_coding",
      gene_name : "C1orf141",
      gene_level : 2,
      hgnc_id : "HGNC:32044",
      havana_gene : "OTTHUMG00000009406.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 67138907,
      stop : 67259979,
      direction : "+",
      ID : "ENSG00000162594.16",
      gene_id : "ENSG00000162594.16",
      gene_type : "protein_coding",
      gene_name : "IL23R",
      gene_level : 2,
      hgnc_id : "HGNC:19100",
      havana_gene : "OTTHUMG00000009092.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 67307364,
      stop : 67398724,
      direction : "+",
      ID : "ENSG00000081985.13",
      gene_id : "ENSG00000081985.13",
      gene_type : "protein_coding",
      gene_name : "IL12RB2",
      gene_level : 2,
      hgnc_id : "HGNC:5972",
      havana_gene : "OTTHUMG00000009094.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 67407810,
      stop : 67430415,
      direction : "-",
      ID : "ENSG00000142864.15",
      gene_id : "ENSG00000142864.15",
      gene_type : "protein_coding",
      gene_name : "SERBP1",
      gene_level : 2,
      hgnc_id : "HGNC:17860",
      havana_gene : "OTTHUMG00000009372.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 67685201,
      stop : 67688334,
      direction : "+",
      ID : "ENSG00000116717.13",
      gene_id : "ENSG00000116717.13",
      gene_type : "protein_coding",
      gene_name : "GADD45A",
      gene_level : 2,
      hgnc_id : "HGNC:4095",
      havana_gene : "OTTHUMG00000009374.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 67701475,
      stop : 67833467,
      direction : "-",
      ID : "ENSG00000172380.6",
      gene_id : "ENSG00000172380.6",
      gene_type : "protein_coding",
      gene_name : "GNG12",
      gene_level : 2,
      hgnc_id : "HGNC:19663",
      havana_gene : "OTTHUMG00000009545.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 68045886,
      stop : 68051631,
      direction : "-",
      ID : "ENSG00000162595.7",
      gene_id : "ENSG00000162595.7",
      gene_type : "protein_coding",
      gene_name : "DIRAS3",
      gene_level : 2,
      hgnc_id : "HGNC:687",
      havana_gene : "OTTHUMG00000009544.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 68098473,
      stop : 68233120,
      direction : "-",
      ID : "ENSG00000116729.14",
      gene_id : "ENSG00000116729.14",
      gene_type : "protein_coding",
      gene_name : "WLS",
      gene_level : 2,
      hgnc_id : "HGNC:30238",
      havana_gene : "OTTHUMG00000009153.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 68428822,
      stop : 68449954,
      direction : "-",
      ID : "ENSG00000116745.7",
      gene_id : "ENSG00000116745.7",
      gene_type : "protein_coding",
      gene_name : "RPE65",
      gene_level : 2,
      hgnc_id : "HGNC:10294",
      havana_gene : "OTTHUMG00000009208.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 68474152,
      stop : 68497221,
      direction : "-",
      ID : "ENSG00000024526.17",
      gene_id : "ENSG00000024526.17",
      gene_type : "protein_coding",
      gene_name : "DEPDC1",
      gene_level : 2,
      hgnc_id : "HGNC:22949",
      havana_gene : "OTTHUMG00000009212.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 69567922,
      stop : 70151945,
      direction : "+",
      ID : "ENSG00000033122.21",
      gene_id : "ENSG00000033122.21",
      gene_type : "protein_coding",
      gene_name : "LRRC7",
      gene_level : 1,
      hgnc_id : "HGNC:18531",
      havana_gene : "OTTHUMG00000059194.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 70144805,
      stop : 70205579,
      direction : "-",
      ID : "ENSG00000066557.6",
      gene_id : "ENSG00000066557.6",
      gene_type : "protein_coding",
      gene_name : "LRRC40",
      gene_level : 2,
      hgnc_id : "HGNC:26004",
      havana_gene : "OTTHUMG00000009348.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 70205682,
      stop : 70253052,
      direction : "+",
      ID : "ENSG00000116754.13",
      gene_id : "ENSG00000116754.13",
      gene_type : "protein_coding",
      gene_name : "SRSF11",
      gene_level : 2,
      hgnc_id : "HGNC:10782",
      havana_gene : "OTTHUMG00000009342.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 70258999,
      stop : 70354734,
      direction : "-",
      ID : "ENSG00000118454.13",
      gene_id : "ENSG00000118454.13",
      gene_type : "protein_coding",
      gene_name : "ANKRD13C",
      gene_level : 2,
      hgnc_id : "HGNC:25374",
      havana_gene : "OTTHUMG00000009343.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 70411218,
      stop : 70439851,
      direction : "+",
      ID : "ENSG00000116761.12",
      gene_id : "ENSG00000116761.12",
      gene_type : "protein_coding",
      gene_name : "CTH",
      gene_level : 2,
      hgnc_id : "HGNC:2501",
      havana_gene : "OTTHUMG00000009352.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 70852353,
      stop : 71047808,
      direction : "-",
      ID : "ENSG00000050628.20",
      gene_id : "ENSG00000050628.20",
      gene_type : "protein_coding",
      gene_name : "PTGER3",
      gene_level : 2,
      hgnc_id : "HGNC:9595",
      havana_gene : "OTTHUMG00000009399.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 71063291,
      stop : 71081289,
      direction : "-",
      ID : "ENSG00000132485.14",
      gene_id : "ENSG00000132485.14",
      gene_type : "protein_coding",
      gene_name : "ZRANB2",
      gene_level : 2,
      hgnc_id : "HGNC:13058",
      havana_gene : "OTTHUMG00000009660.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 71395943,
      stop : 72282539,
      direction : "-",
      ID : "ENSG00000172260.15",
      gene_id : "ENSG00000172260.15",
      gene_type : "protein_coding",
      gene_name : "NEGR1",
      gene_level : 2,
      hgnc_id : "HGNC:17302",
      havana_gene : "OTTHUMG00000009698.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74026015,
      stop : 74198187,
      direction : "-",
      ID : "ENSG00000162620.16",
      gene_id : "ENSG00000162620.16",
      gene_type : "protein_coding",
      gene_name : "LRRIQ3",
      gene_level : 1,
      hgnc_id : "HGNC:28318",
      havana_gene : "OTTHUMG00000009508.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74198212,
      stop : 74234086,
      direction : "+",
      ID : "ENSG00000254685.7",
      gene_id : "ENSG00000254685.7",
      gene_type : "protein_coding",
      gene_name : "FPGT",
      gene_level : 2,
      hgnc_id : "HGNC:3825",
      havana_gene : "OTTHUMG00000009571.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74198235,
      stop : 74544393,
      direction : "+",
      ID : "ENSG00000259030.8",
      gene_id : "ENSG00000259030.8",
      gene_type : "protein_coding",
      gene_name : "FPGT-TNNI3K",
      gene_level : 1,
      hgnc_id : "HGNC:42952",
      havana_gene : "OTTHUMG00000166281.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74235387,
      stop : 74544428,
      direction : "+",
      ID : "ENSG00000116783.15",
      gene_id : "ENSG00000116783.15",
      gene_type : "protein_coding",
      gene_name : "TNNI3K",
      gene_level : 1,
      hgnc_id : "HGNC:19661",
      havana_gene : "OTTHUMG00000171318.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74469376,
      stop : 74512611,
      direction : "-",
      ID : "ENSG00000162621.7",
      gene_id : "ENSG00000162621.7",
      gene_type : "protein_coding",
      gene_name : "LRRC53",
      gene_level : 1,
      hgnc_id : "HGNC:25255",
      havana_gene : "OTTHUMG00000009621.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74568117,
      stop : 74673792,
      direction : "-",
      ID : "ENSG00000178965.14",
      gene_id : "ENSG00000178965.14",
      gene_type : "protein_coding",
      gene_name : "ERICH3",
      gene_level : 2,
      hgnc_id : "HGNC:25346",
      havana_gene : "OTTHUMG00000009622.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74705482,
      stop : 74733408,
      direction : "-",
      ID : "ENSG00000116791.14",
      gene_id : "ENSG00000116791.14",
      gene_type : "protein_coding",
      gene_name : "CRYZ",
      gene_level : 2,
      hgnc_id : "HGNC:2419",
      havana_gene : "OTTHUMG00000009620.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 74733152,
      stop : 74766678,
      direction : "+",
      ID : "ENSG00000162623.16",
      gene_id : "ENSG00000162623.16",
      gene_type : "protein_coding",
      gene_name : "TYW3",
      gene_level : 2,
      hgnc_id : "HGNC:24757",
      havana_gene : "OTTHUMG00000009641.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 75128434,
      stop : 75161533,
      direction : "+",
      ID : "ENSG00000162624.14",
      gene_id : "ENSG00000162624.14",
      gene_type : "protein_coding",
      gene_name : "LHX8",
      gene_level : 2,
      hgnc_id : "HGNC:28838",
      havana_gene : "OTTHUMG00000009692.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 75202131,
      stop : 75611116,
      direction : "-",
      ID : "ENSG00000137968.16",
      gene_id : "ENSG00000137968.16",
      gene_type : "protein_coding",
      gene_name : "SLC44A5",
      gene_level : 2,
      hgnc_id : "HGNC:28524",
      havana_gene : "OTTHUMG00000009721.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 75724431,
      stop : 75787575,
      direction : "+",
      ID : "ENSG00000117054.15",
      gene_id : "ENSG00000117054.15",
      gene_type : "protein_coding",
      gene_name : "ACADM",
      gene_level : 1,
      hgnc_id : "HGNC:89",
      havana_gene : "OTTHUMG00000009784.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 75786197,
      stop : 75795086,
      direction : "+",
      ID : "ENSG00000137955.16",
      gene_id : "ENSG00000137955.16",
      gene_type : "protein_coding",
      gene_name : "RABGGTB",
      gene_level : 2,
      hgnc_id : "HGNC:9796",
      havana_gene : "OTTHUMG00000009786.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 75796882,
      stop : 75913242,
      direction : "+",
      ID : "ENSG00000057468.7",
      gene_id : "ENSG00000057468.7",
      gene_type : "protein_coding",
      gene_name : "MSH4",
      gene_level : 2,
      hgnc_id : "HGNC:7327",
      havana_gene : "OTTHUMG00000009788.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 75918873,
      stop : 75932404,
      direction : "-",
      ID : "ENSG00000154007.7",
      gene_id : "ENSG00000154007.7",
      gene_type : "protein_coding",
      gene_name : "ASB17",
      gene_level : 2,
      hgnc_id : "HGNC:19769",
      havana_gene : "OTTHUMG00000009787.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 76074746,
      stop : 76634603,
      direction : "+",
      ID : "ENSG00000184005.11",
      gene_id : "ENSG00000184005.11",
      gene_type : "protein_coding",
      gene_name : "ST6GALNAC3",
      gene_level : 2,
      hgnc_id : "HGNC:19343",
      havana_gene : "OTTHUMG00000009615.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 76867480,
      stop : 77067546,
      direction : "+",
      ID : "ENSG00000117069.15",
      gene_id : "ENSG00000117069.15",
      gene_type : "protein_coding",
      gene_name : "ST6GALNAC5",
      gene_level : 1,
      hgnc_id : "HGNC:19342",
      havana_gene : "OTTHUMG00000009687.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77088989,
      stop : 77219430,
      direction : "-",
      ID : "ENSG00000142892.15",
      gene_id : "ENSG00000142892.15",
      gene_type : "protein_coding",
      gene_name : "PIGK",
      gene_level : 2,
      hgnc_id : "HGNC:8965",
      havana_gene : "OTTHUMG00000009686.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77282019,
      stop : 77559966,
      direction : "+",
      ID : "ENSG00000154027.19",
      gene_id : "ENSG00000154027.19",
      gene_type : "protein_coding",
      gene_name : "AK5",
      gene_level : 1,
      hgnc_id : "HGNC:365",
      havana_gene : "OTTHUMG00000009796.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77562416,
      stop : 77683419,
      direction : "-",
      ID : "ENSG00000036549.13",
      gene_id : "ENSG00000036549.13",
      gene_type : "protein_coding",
      gene_name : "ZZZ3",
      gene_level : 1,
      hgnc_id : "HGNC:24523",
      havana_gene : "OTTHUMG00000009652.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77695987,
      stop : 77759852,
      direction : "-",
      ID : "ENSG00000077254.14",
      gene_id : "ENSG00000077254.14",
      gene_type : "protein_coding",
      gene_name : "USP33",
      gene_level : 2,
      hgnc_id : "HGNC:20059",
      havana_gene : "OTTHUMG00000009651.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77779624,
      stop : 77879539,
      direction : "+",
      ID : "ENSG00000180488.15",
      gene_id : "ENSG00000180488.15",
      gene_type : "protein_coding",
      gene_name : "MIGA1",
      gene_level : 1,
      hgnc_id : "HGNC:24741",
      havana_gene : "OTTHUMG00000009766.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77888513,
      stop : 77943895,
      direction : "+",
      ID : "ENSG00000162614.19",
      gene_id : "ENSG00000162614.19",
      gene_type : "protein_coding",
      gene_name : "NEXN",
      gene_level : 2,
      hgnc_id : "HGNC:29557",
      havana_gene : "OTTHUMG00000040533.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77944055,
      stop : 77979110,
      direction : "-",
      ID : "ENSG00000162613.17",
      gene_id : "ENSG00000162613.17",
      gene_type : "protein_coding",
      gene_name : "FUBP1",
      gene_level : 2,
      hgnc_id : "HGNC:4004",
      havana_gene : "OTTHUMG00000040799.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77979175,
      stop : 78017964,
      direction : "+",
      ID : "ENSG00000162616.9",
      gene_id : "ENSG00000162616.9",
      gene_type : "protein_coding",
      gene_name : "DNAJB4",
      gene_level : 2,
      hgnc_id : "HGNC:14886",
      havana_gene : "OTTHUMG00000040905.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 77979542,
      stop : 78138444,
      direction : "+",
      ID : "ENSG00000137960.6",
      gene_id : "ENSG00000137960.6",
      gene_type : "protein_coding",
      gene_name : "GIPC2",
      gene_level : 2,
      hgnc_id : "HGNC:18177",
      havana_gene : "OTTHUMG00000041145.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 78303884,
      stop : 78540701,
      direction : "+",
      ID : "ENSG00000122420.10",
      gene_id : "ENSG00000122420.10",
      gene_type : "protein_coding",
      gene_name : "PTGFR",
      gene_level : 2,
      hgnc_id : "HGNC:9600",
      havana_gene : "OTTHUMG00000009644.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 78619902,
      stop : 78646145,
      direction : "+",
      ID : "ENSG00000137959.17",
      gene_id : "ENSG00000137959.17",
      gene_type : "protein_coding",
      gene_name : "IFI44L",
      gene_level : 2,
      hgnc_id : "HGNC:17817",
      havana_gene : "OTTHUMG00000009724.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 78649796,
      stop : 78664078,
      direction : "+",
      ID : "ENSG00000137965.11",
      gene_id : "ENSG00000137965.11",
      gene_type : "protein_coding",
      gene_name : "IFI44",
      gene_level : 2,
      hgnc_id : "HGNC:16938",
      havana_gene : "OTTHUMG00000009723.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 78889764,
      stop : 79282124,
      direction : "-",
      ID : "ENSG00000162618.15",
      gene_id : "ENSG00000162618.15",
      gene_type : "protein_coding",
      gene_name : "ADGRL4",
      gene_level : 2,
      hgnc_id : "HGNC:20822",
      havana_gene : "OTTHUMG00000009738.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 81306147,
      stop : 81992436,
      direction : "+",
      ID : "ENSG00000117114.20",
      gene_id : "ENSG00000117114.20",
      gene_type : "protein_coding",
      gene_name : "ADGRL2",
      gene_level : 2,
      hgnc_id : "HGNC:18582",
      havana_gene : "OTTHUMG00000009844.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 83865024,
      stop : 83999150,
      direction : "-",
      ID : "ENSG00000137941.17",
      gene_id : "ENSG00000137941.17",
      gene_type : "protein_coding",
      gene_name : "TTLL7",
      gene_level : 2,
      hgnc_id : "HGNC:26242",
      havana_gene : "OTTHUMG00000009932.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84078062,
      stop : 84238498,
      direction : "+",
      ID : "ENSG00000142875.19",
      gene_id : "ENSG00000142875.19",
      gene_type : "protein_coding",
      gene_name : "PRKACB",
      gene_level : 2,
      hgnc_id : "HGNC:9381",
      havana_gene : "OTTHUMG00000009975.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84298366,
      stop : 84389957,
      direction : "+",
      ID : "ENSG00000203943.9",
      gene_id : "ENSG00000203943.9",
      gene_type : "protein_coding",
      gene_name : "SAMD13",
      gene_level : 1,
      hgnc_id : "HGNC:24582",
      havana_gene : "OTTHUMG00000009859.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84398484,
      stop : 84415018,
      direction : "+",
      ID : "ENSG00000137976.8",
      gene_id : "ENSG00000137976.8",
      gene_type : "protein_coding",
      gene_name : "DNASE2B",
      gene_level : 2,
      hgnc_id : "HGNC:28875",
      havana_gene : "OTTHUMG00000009860.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84479259,
      stop : 84498352,
      direction : "+",
      ID : "ENSG00000117133.11",
      gene_id : "ENSG00000117133.11",
      gene_type : "protein_coding",
      gene_name : "RPF1",
      gene_level : 2,
      hgnc_id : "HGNC:30350",
      havana_gene : "OTTHUMG00000009857.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84498325,
      stop : 84506581,
      direction : "-",
      ID : "ENSG00000174021.11",
      gene_id : "ENSG00000174021.11",
      gene_type : "protein_coding",
      gene_name : "GNG5",
      gene_level : 2,
      hgnc_id : "HGNC:4408",
      havana_gene : "OTTHUMG00000009858.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84506300,
      stop : 84566194,
      direction : "+",
      ID : "ENSG00000122432.18",
      gene_id : "ENSG00000122432.18",
      gene_type : "protein_coding",
      gene_name : "SPATA1",
      gene_level : 2,
      hgnc_id : "HGNC:14682",
      havana_gene : "OTTHUMG00000009924.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84549611,
      stop : 84574480,
      direction : "-",
      ID : "ENSG00000117151.13",
      gene_id : "ENSG00000117151.13",
      gene_type : "protein_coding",
      gene_name : "CTBS",
      gene_level : 2,
      hgnc_id : "HGNC:2496",
      havana_gene : "OTTHUMG00000009922.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84643706,
      stop : 84690803,
      direction : "-",
      ID : "ENSG00000117155.17",
      gene_id : "ENSG00000117155.17",
      gene_type : "protein_coding",
      gene_name : "SSX2IP",
      gene_level : 2,
      hgnc_id : "HGNC:16509",
      havana_gene : "OTTHUMG00000009926.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84811602,
      stop : 84893206,
      direction : "-",
      ID : "ENSG00000171517.6",
      gene_id : "ENSG00000171517.6",
      gene_type : "protein_coding",
      gene_name : "LPAR3",
      gene_level : 2,
      hgnc_id : "HGNC:14298",
      havana_gene : "OTTHUMG00000009925.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84925583,
      stop : 84997113,
      direction : "-",
      ID : "ENSG00000153898.13",
      gene_id : "ENSG00000153898.13",
      gene_type : "protein_coding",
      gene_name : "MCOLN2",
      gene_level : 2,
      hgnc_id : "HGNC:13357",
      havana_gene : "OTTHUMG00000009954.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 84999147,
      stop : 85133138,
      direction : "+",
      ID : "ENSG00000162643.13",
      gene_id : "ENSG00000162643.13",
      gene_type : "protein_coding",
      gene_name : "DNAI3",
      gene_level : 2,
      hgnc_id : "HGNC:30711",
      havana_gene : "OTTHUMG00000009953.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85018082,
      stop : 85048500,
      direction : "-",
      ID : "ENSG00000055732.13",
      gene_id : "ENSG00000055732.13",
      gene_type : "protein_coding",
      gene_name : "MCOLN3",
      gene_level : 2,
      hgnc_id : "HGNC:13358",
      havana_gene : "OTTHUMG00000009955.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85156889,
      stop : 85201016,
      direction : "-",
      ID : "ENSG00000097096.9",
      gene_id : "ENSG00000097096.9",
      gene_type : "protein_coding",
      gene_name : "SYDE2",
      gene_level : 2,
      hgnc_id : "HGNC:25841",
      havana_gene : "OTTHUMG00000009956.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85249953,
      stop : 85259672,
      direction : "-",
      ID : "ENSG00000162642.14",
      gene_id : "ENSG00000162642.14",
      gene_type : "protein_coding",
      gene_name : "C1orf52",
      gene_level : 2,
      hgnc_id : "HGNC:24871",
      havana_gene : "OTTHUMG00000009966.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85265776,
      stop : 85276632,
      direction : "-",
      ID : "ENSG00000142867.14",
      gene_id : "ENSG00000142867.14",
      gene_type : "protein_coding",
      gene_name : "BCL10",
      gene_level : 2,
      hgnc_id : "HGNC:989",
      havana_gene : "OTTHUMG00000009965.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85318481,
      stop : 85578363,
      direction : "-",
      ID : "ENSG00000153904.21",
      gene_id : "ENSG00000153904.21",
      gene_type : "protein_coding",
      gene_name : "DDAH1",
      gene_level : 2,
      hgnc_id : "HGNC:2715",
      havana_gene : "OTTHUMG00000191181.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85580761,
      stop : 85584589,
      direction : "+",
      ID : "ENSG00000142871.18",
      gene_id : "ENSG00000142871.18",
      gene_type : "protein_coding",
      gene_name : "CCN1",
      gene_level : 2,
      hgnc_id : "HGNC:2654",
      havana_gene : "OTTHUMG00000010577.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85649417,
      stop : 85708433,
      direction : "-",
      ID : "ENSG00000117174.11",
      gene_id : "ENSG00000117174.11",
      gene_type : "protein_coding",
      gene_name : "ZNHIT6",
      gene_level : 2,
      hgnc_id : "HGNC:26089",
      havana_gene : "OTTHUMG00000010576.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 85729233,
      stop : 86156943,
      direction : "-",
      ID : "ENSG00000171502.15",
      gene_id : "ENSG00000171502.15",
      gene_type : "protein_coding",
      gene_name : "COL24A1",
      gene_level : 2,
      hgnc_id : "HGNC:20821",
      havana_gene : "OTTHUMG00000010629.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86346824,
      stop : 86396342,
      direction : "-",
      ID : "ENSG00000122417.15",
      gene_id : "ENSG00000122417.15",
      gene_type : "protein_coding",
      gene_name : "ODF2L",
      gene_level : 1,
      hgnc_id : "HGNC:29225",
      havana_gene : "OTTHUMG00000010080.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86424171,
      stop : 86456553,
      direction : "+",
      ID : "ENSG00000137975.8",
      gene_id : "ENSG00000137975.8",
      gene_type : "protein_coding",
      gene_name : "CLCA2",
      gene_level : 2,
      hgnc_id : "HGNC:2016",
      havana_gene : "OTTHUMG00000010256.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86468368,
      stop : 86500259,
      direction : "+",
      ID : "ENSG00000016490.16",
      gene_id : "ENSG00000016490.16",
      gene_type : "protein_coding",
      gene_name : "CLCA1",
      gene_level : 2,
      hgnc_id : "HGNC:2015",
      havana_gene : "OTTHUMG00000010254.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86547078,
      stop : 86580754,
      direction : "+",
      ID : "ENSG00000016602.9",
      gene_id : "ENSG00000016602.9",
      gene_type : "protein_coding",
      gene_name : "CLCA4",
      gene_level : 2,
      hgnc_id : "HGNC:2018",
      havana_gene : "OTTHUMG00000010260.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86704570,
      stop : 86748184,
      direction : "+",
      ID : "ENSG00000097033.14",
      gene_id : "ENSG00000097033.14",
      gene_type : "protein_coding",
      gene_name : "SH3GLB1",
      gene_level : 2,
      hgnc_id : "HGNC:10833",
      havana_gene : "OTTHUMG00000010257.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86862445,
      stop : 86914424,
      direction : "-",
      ID : "ENSG00000183291.17",
      gene_id : "ENSG00000183291.17",
      gene_type : "protein_coding",
      gene_name : "SELENOF",
      gene_level : 2,
      hgnc_id : "HGNC:17705",
      havana_gene : "OTTHUMG00000008520.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86914635,
      stop : 87109982,
      direction : "+",
      ID : "ENSG00000153936.17",
      gene_id : "ENSG00000153936.17",
      gene_type : "protein_coding",
      gene_name : "HS2ST1",
      gene_level : 2,
      hgnc_id : "HGNC:5193",
      havana_gene : "OTTHUMG00000010255.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 86993009,
      stop : 87169204,
      direction : "+",
      ID : "ENSG00000267561.2",
      gene_id : "ENSG00000267561.2",
      gene_type : "protein_coding",
      gene_name : "AC093155.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000181764.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 87328880,
      stop : 87348923,
      direction : "+",
      ID : "ENSG00000143013.13",
      gene_id : "ENSG00000143013.13",
      gene_type : "protein_coding",
      gene_name : "LMO4",
      gene_level : 2,
      hgnc_id : "HGNC:6644",
      havana_gene : "OTTHUMG00000010248.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 88684222,
      stop : 88836255,
      direction : "+",
      ID : "ENSG00000065243.20",
      gene_id : "ENSG00000065243.20",
      gene_type : "protein_coding",
      gene_name : "PKN2",
      gene_level : 1,
      hgnc_id : "HGNC:9406",
      havana_gene : "OTTHUMG00000010074.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 88852633,
      stop : 88891944,
      direction : "-",
      ID : "ENSG00000137947.12",
      gene_id : "ENSG00000137947.12",
      gene_type : "protein_coding",
      gene_name : "GTF2B",
      gene_level : 1,
      hgnc_id : "HGNC:4648",
      havana_gene : "OTTHUMG00000010611.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 88935773,
      stop : 88992953,
      direction : "-",
      ID : "ENSG00000137944.18",
      gene_id : "ENSG00000137944.18",
      gene_type : "protein_coding",
      gene_name : "KYAT3",
      gene_level : 2,
      hgnc_id : "HGNC:33238",
      havana_gene : "OTTHUMG00000010617.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 88979456,
      stop : 88992960,
      direction : "-",
      ID : "ENSG00000213516.10",
      gene_id : "ENSG00000213516.10",
      gene_type : "protein_coding",
      gene_name : "RBMXL1",
      gene_level : 2,
      hgnc_id : "HGNC:25073",
      havana_gene : "OTTHUMG00000010661.6",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89006679,
      stop : 89022894,
      direction : "-",
      ID : "ENSG00000117226.12",
      gene_id : "ENSG00000117226.12",
      gene_type : "protein_coding",
      gene_name : "GBP3",
      gene_level : 1,
      hgnc_id : "HGNC:4184",
      havana_gene : "OTTHUMG00000010616.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89051882,
      stop : 89065360,
      direction : "-",
      ID : "ENSG00000117228.11",
      gene_id : "ENSG00000117228.11",
      gene_type : "protein_coding",
      gene_name : "GBP1",
      gene_level : 2,
      hgnc_id : "HGNC:4182",
      havana_gene : "OTTHUMG00000010614.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89106132,
      stop : 89150456,
      direction : "-",
      ID : "ENSG00000162645.13",
      gene_id : "ENSG00000162645.13",
      gene_type : "protein_coding",
      gene_name : "GBP2",
      gene_level : 2,
      hgnc_id : "HGNC:4183",
      havana_gene : "OTTHUMG00000010662.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89131742,
      stop : 89176009,
      direction : "-",
      ID : "ENSG00000213512.3",
      gene_id : "ENSG00000213512.3",
      gene_type : "protein_coding",
      gene_name : "GBP7",
      gene_level : 2,
      hgnc_id : "HGNC:29606",
      havana_gene : "OTTHUMG00000010659.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89181144,
      stop : 89198942,
      direction : "-",
      ID : "ENSG00000162654.9",
      gene_id : "ENSG00000162654.9",
      gene_type : "protein_coding",
      gene_name : "GBP4",
      gene_level : 2,
      hgnc_id : "HGNC:20480",
      havana_gene : "OTTHUMG00000010663.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89258950,
      stop : 89272804,
      direction : "-",
      ID : "ENSG00000154451.14",
      gene_id : "ENSG00000154451.14",
      gene_type : "protein_coding",
      gene_name : "GBP5",
      gene_level : 2,
      hgnc_id : "HGNC:19895",
      havana_gene : "OTTHUMG00000010006.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89364059,
      stop : 89388160,
      direction : "+",
      ID : "ENSG00000183347.15",
      gene_id : "ENSG00000183347.15",
      gene_type : "protein_coding",
      gene_name : "GBP6",
      gene_level : 2,
      hgnc_id : "HGNC:25395",
      havana_gene : "OTTHUMG00000010123.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89524829,
      stop : 89597861,
      direction : "+",
      ID : "ENSG00000197147.15",
      gene_id : "ENSG00000197147.15",
      gene_type : "protein_coding",
      gene_name : "LRRC8B",
      gene_level : 2,
      hgnc_id : "HGNC:30692",
      havana_gene : "OTTHUMG00000010129.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89579592,
      stop : 89579654,
      direction : "+",
      ID : "ENSG00000288629.1",
      gene_id : "ENSG00000288629.1",
      gene_type : "protein_coding",
      gene_name : "AC099569.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89633072,
      stop : 89769903,
      direction : "+",
      ID : "ENSG00000171488.15",
      gene_id : "ENSG00000171488.15",
      gene_type : "protein_coding",
      gene_name : "LRRC8C",
      gene_level : 2,
      hgnc_id : "HGNC:25075",
      havana_gene : "OTTHUMG00000010305.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89633140,
      stop : 89933250,
      direction : "+",
      ID : "ENSG00000271949.1",
      gene_id : "ENSG00000271949.1",
      gene_type : "protein_coding",
      gene_name : "AC093423.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185381.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89821014,
      stop : 89936611,
      direction : "+",
      ID : "ENSG00000171492.14",
      gene_id : "ENSG00000171492.14",
      gene_type : "protein_coding",
      gene_name : "LRRC8D",
      gene_level : 2,
      hgnc_id : "HGNC:16992",
      havana_gene : "OTTHUMG00000010583.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 89995110,
      stop : 90035533,
      direction : "+",
      ID : "ENSG00000162664.17",
      gene_id : "ENSG00000162664.17",
      gene_type : "protein_coding",
      gene_name : "ZNF326",
      gene_level : 1,
      hgnc_id : "HGNC:14104",
      havana_gene : "OTTHUMG00000010675.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 90711539,
      stop : 90717302,
      direction : "-",
      ID : "ENSG00000143032.8",
      gene_id : "ENSG00000143032.8",
      gene_type : "protein_coding",
      gene_name : "BARHL2",
      gene_level : 2,
      hgnc_id : "HGNC:954",
      havana_gene : "OTTHUMG00000010020.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 90915298,
      stop : 91022272,
      direction : "-",
      ID : "ENSG00000122482.21",
      gene_id : "ENSG00000122482.21",
      gene_type : "protein_coding",
      gene_name : "ZNF644",
      gene_level : 2,
      hgnc_id : "HGNC:29222",
      havana_gene : "OTTHUMG00000010078.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 91260766,
      stop : 91404856,
      direction : "-",
      ID : "ENSG00000162669.16",
      gene_id : "ENSG00000162669.16",
      gene_type : "protein_coding",
      gene_name : "HFM1",
      gene_level : 2,
      hgnc_id : "HGNC:20193",
      havana_gene : "OTTHUMG00000010093.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 91500851,
      stop : 91525764,
      direction : "+",
      ID : "ENSG00000097046.13",
      gene_id : "ENSG00000097046.13",
      gene_type : "protein_coding",
      gene_name : "CDC7",
      gene_level : 2,
      hgnc_id : "HGNC:1745",
      havana_gene : "OTTHUMG00000047810.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 91680343,
      stop : 91906335,
      direction : "-",
      ID : "ENSG00000069702.11",
      gene_id : "ENSG00000069702.11",
      gene_type : "protein_coding",
      gene_name : "TGFBR3",
      gene_level : 2,
      hgnc_id : "HGNC:11774",
      havana_gene : "OTTHUMG00000010097.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 91949343,
      stop : 92014426,
      direction : "+",
      ID : "ENSG00000137948.19",
      gene_id : "ENSG00000137948.19",
      gene_type : "protein_coding",
      gene_name : "BRDT",
      gene_level : 2,
      hgnc_id : "HGNC:1105",
      havana_gene : "OTTHUMG00000010113.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92029985,
      stop : 92063538,
      direction : "+",
      ID : "ENSG00000172031.7",
      gene_id : "ENSG00000172031.7",
      gene_type : "protein_coding",
      gene_name : "EPHX4",
      gene_level : 2,
      hgnc_id : "HGNC:23758",
      havana_gene : "OTTHUMG00000010114.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92074533,
      stop : 92075441,
      direction : "-",
      ID : "ENSG00000230667.6",
      gene_id : "ENSG00000230667.6",
      gene_type : "protein_coding",
      gene_name : "SETSIP",
      gene_level : 2,
      hgnc_id : "HGNC:42937",
      havana_gene : "OTTHUMG00000010287.4",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92080305,
      stop : 92184725,
      direction : "+",
      ID : "ENSG00000189195.15",
      gene_id : "ENSG00000189195.15",
      gene_type : "protein_coding",
      gene_name : "BTBD8",
      gene_level : 2,
      hgnc_id : "HGNC:21019",
      havana_gene : "OTTHUMG00000191888.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92217915,
      stop : 92245813,
      direction : "+",
      ID : "ENSG00000203910.9",
      gene_id : "ENSG00000203910.9",
      gene_type : "protein_coding",
      gene_name : "C1orf146",
      gene_level : 2,
      hgnc_id : "HGNC:24032",
      havana_gene : "OTTHUMG00000010285.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92246402,
      stop : 92298987,
      direction : "-",
      ID : "ENSG00000174842.17",
      gene_id : "ENSG00000174842.17",
      gene_type : "protein_coding",
      gene_name : "GLMN",
      gene_level : 2,
      hgnc_id : "HGNC:14373",
      havana_gene : "OTTHUMG00000010283.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92299059,
      stop : 92402056,
      direction : "+",
      ID : "ENSG00000122484.9",
      gene_id : "ENSG00000122484.9",
      gene_type : "protein_coding",
      gene_name : "RPAP2",
      gene_level : 2,
      hgnc_id : "HGNC:25791",
      havana_gene : "OTTHUMG00000010288.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92473043,
      stop : 92486925,
      direction : "-",
      ID : "ENSG00000162676.12",
      gene_id : "ENSG00000162676.12",
      gene_type : "protein_coding",
      gene_name : "GFI1",
      gene_level : 2,
      hgnc_id : "HGNC:4237",
      havana_gene : "OTTHUMG00000010897.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92508696,
      stop : 92792404,
      direction : "-",
      ID : "ENSG00000067208.14",
      gene_id : "ENSG00000067208.14",
      gene_type : "protein_coding",
      gene_name : "EVI5",
      gene_level : 2,
      hgnc_id : "HGNC:3501",
      havana_gene : "OTTHUMG00000010895.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92832013,
      stop : 92841924,
      direction : "+",
      ID : "ENSG00000122406.14",
      gene_id : "ENSG00000122406.14",
      gene_type : "protein_coding",
      gene_name : "RPL5",
      gene_level : 2,
      hgnc_id : "HGNC:10360",
      havana_gene : "OTTHUMG00000010899.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 92832737,
      stop : 92961522,
      direction : "-",
      ID : "ENSG00000154511.12",
      gene_id : "ENSG00000154511.12",
      gene_type : "protein_coding",
      gene_name : "DIPK1A",
      gene_level : 2,
      hgnc_id : "HGNC:32213",
      havana_gene : "OTTHUMG00000010894.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93079235,
      stop : 93139079,
      direction : "+",
      ID : "ENSG00000143033.18",
      gene_id : "ENSG00000143033.18",
      gene_type : "protein_coding",
      gene_name : "MTF2",
      gene_level : 2,
      hgnc_id : "HGNC:29535",
      havana_gene : "OTTHUMG00000010161.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93149742,
      stop : 93180516,
      direction : "-",
      ID : "ENSG00000117500.13",
      gene_id : "ENSG00000117500.13",
      gene_type : "protein_coding",
      gene_name : "TMED5",
      gene_level : 2,
      hgnc_id : "HGNC:24251",
      havana_gene : "OTTHUMG00000010162.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93179919,
      stop : 93278730,
      direction : "+",
      ID : "ENSG00000122483.17",
      gene_id : "ENSG00000122483.17",
      gene_type : "protein_coding",
      gene_name : "CCDC18",
      gene_level : 1,
      hgnc_id : "HGNC:30370",
      havana_gene : "OTTHUMG00000010598.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93345907,
      stop : 93369493,
      direction : "+",
      ID : "ENSG00000117505.13",
      gene_id : "ENSG00000117505.13",
      gene_type : "protein_coding",
      gene_name : "DR1",
      gene_level : 2,
      hgnc_id : "HGNC:3017",
      havana_gene : "OTTHUMG00000010862.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93448118,
      stop : 93554661,
      direction : "+",
      ID : "ENSG00000137942.18",
      gene_id : "ENSG00000137942.18",
      gene_type : "protein_coding",
      gene_name : "FNBP1L",
      gene_level : 2,
      hgnc_id : "HGNC:20851",
      havana_gene : "OTTHUMG00000010863.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93561741,
      stop : 93847150,
      direction : "-",
      ID : "ENSG00000137936.18",
      gene_id : "ENSG00000137936.18",
      gene_type : "protein_coding",
      gene_name : "BCAR3",
      gene_level : 2,
      hgnc_id : "HGNC:973",
      havana_gene : "OTTHUMG00000010301.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93866284,
      stop : 93879918,
      direction : "-",
      ID : "ENSG00000067334.14",
      gene_id : "ENSG00000067334.14",
      gene_type : "protein_coding",
      gene_name : "DNTTIP2",
      gene_level : 2,
      hgnc_id : "HGNC:24013",
      havana_gene : "OTTHUMG00000010268.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93885199,
      stop : 93909456,
      direction : "-",
      ID : "ENSG00000023909.10",
      gene_id : "ENSG00000023909.10",
      gene_type : "protein_coding",
      gene_name : "GCLM",
      gene_level : 2,
      hgnc_id : "HGNC:4312",
      havana_gene : "OTTHUMG00000010562.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 93992834,
      stop : 94121148,
      direction : "-",
      ID : "ENSG00000198691.13",
      gene_id : "ENSG00000198691.13",
      gene_type : "protein_coding",
      gene_name : "ABCA4",
      gene_level : 2,
      hgnc_id : "HGNC:34",
      havana_gene : "OTTHUMG00000010622.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 94148988,
      stop : 94275068,
      direction : "-",
      ID : "ENSG00000137962.13",
      gene_id : "ENSG00000137962.13",
      gene_type : "protein_coding",
      gene_name : "ARHGAP29",
      gene_level : 2,
      hgnc_id : "HGNC:30207",
      havana_gene : "OTTHUMG00000010643.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 94418389,
      stop : 94518666,
      direction : "+",
      ID : "ENSG00000117528.14",
      gene_id : "ENSG00000117528.14",
      gene_type : "protein_coding",
      gene_name : "ABCD3",
      gene_level : 2,
      hgnc_id : "HGNC:67",
      havana_gene : "OTTHUMG00000010717.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 94529173,
      stop : 94541759,
      direction : "-",
      ID : "ENSG00000117525.14",
      gene_id : "ENSG00000117525.14",
      gene_type : "protein_coding",
      gene_name : "F3",
      gene_level : 2,
      hgnc_id : "HGNC:3541",
      havana_gene : "OTTHUMG00000010716.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 94820342,
      stop : 94895246,
      direction : "+",
      ID : "ENSG00000143036.17",
      gene_id : "ENSG00000143036.17",
      gene_type : "protein_coding",
      gene_name : "SLC44A3",
      gene_level : 1,
      hgnc_id : "HGNC:28689",
      havana_gene : "OTTHUMG00000010700.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 94896949,
      stop : 94927223,
      direction : "-",
      ID : "ENSG00000117519.16",
      gene_id : "ENSG00000117519.16",
      gene_type : "protein_coding",
      gene_name : "CNN3",
      gene_level : 2,
      hgnc_id : "HGNC:2157",
      havana_gene : "OTTHUMG00000010783.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 94974405,
      stop : 95072951,
      direction : "-",
      ID : "ENSG00000172339.10",
      gene_id : "ENSG00000172339.10",
      gene_type : "protein_coding",
      gene_name : "ALG14",
      gene_level : 2,
      hgnc_id : "HGNC:28287",
      havana_gene : "OTTHUMG00000010781.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 95117355,
      stop : 95197607,
      direction : "+",
      ID : "ENSG00000152078.10",
      gene_id : "ENSG00000152078.10",
      gene_type : "protein_coding",
      gene_name : "TLCD4",
      gene_level : 2,
      hgnc_id : "HGNC:26477",
      havana_gene : "OTTHUMG00000010847.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 95117923,
      stop : 95247225,
      direction : "+",
      ID : "ENSG00000271092.5",
      gene_id : "ENSG00000271092.5",
      gene_type : "protein_coding",
      gene_name : "TLCD4-RWDD3",
      gene_level : 2,
      hgnc_id : "HGNC:49388",
      havana_gene : "OTTHUMG00000184628.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 95234210,
      stop : 95247225,
      direction : "+",
      ID : "ENSG00000122481.17",
      gene_id : "ENSG00000122481.17",
      gene_type : "protein_coding",
      gene_name : "RWDD3",
      gene_level : 2,
      hgnc_id : "HGNC:21393",
      havana_gene : "OTTHUMG00000010910.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 96721665,
      stop : 96823738,
      direction : "+",
      ID : "ENSG00000117569.19",
      gene_id : "ENSG00000117569.19",
      gene_type : "protein_coding",
      gene_name : "PTBP2",
      gene_level : 2,
      hgnc_id : "HGNC:17662",
      havana_gene : "OTTHUMG00000010685.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 97077743,
      stop : 97995000,
      direction : "-",
      ID : "ENSG00000188641.14",
      gene_id : "ENSG00000188641.14",
      gene_type : "protein_coding",
      gene_name : "DPYD",
      gene_level : 2,
      hgnc_id : "HGNC:3012",
      havana_gene : "OTTHUMG00000039683.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 98661701,
      stop : 98760500,
      direction : "+",
      ID : "ENSG00000162627.17",
      gene_id : "ENSG00000162627.17",
      gene_type : "protein_coding",
      gene_name : "SNX7",
      gene_level : 2,
      hgnc_id : "HGNC:14971",
      havana_gene : "OTTHUMG00000010723.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 98890245,
      stop : 99005032,
      direction : "-",
      ID : "ENSG00000117598.13",
      gene_id : "ENSG00000117598.13",
      gene_type : "protein_coding",
      gene_name : "PLPPR5",
      gene_level : 2,
      hgnc_id : "HGNC:31703",
      havana_gene : "OTTHUMG00000010738.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 99263953,
      stop : 99309590,
      direction : "+",
      ID : "ENSG00000117600.13",
      gene_id : "ENSG00000117600.13",
      gene_type : "protein_coding",
      gene_name : "PLPPR4",
      gene_level : 2,
      hgnc_id : "HGNC:23496",
      havana_gene : "OTTHUMG00000010763.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 99646113,
      stop : 99694541,
      direction : "+",
      ID : "ENSG00000099260.11",
      gene_id : "ENSG00000099260.11",
      gene_type : "protein_coding",
      gene_name : "PALMD",
      gene_level : 2,
      hgnc_id : "HGNC:15846",
      havana_gene : "OTTHUMG00000010764.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 99703970,
      stop : 99766635,
      direction : "-",
      ID : "ENSG00000156869.14",
      gene_id : "ENSG00000156869.14",
      gene_type : "protein_coding",
      gene_name : "FRRS1",
      gene_level : 2,
      hgnc_id : "HGNC:27622",
      havana_gene : "OTTHUMG00000010768.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 99850361,
      stop : 99924023,
      direction : "+",
      ID : "ENSG00000162688.17",
      gene_id : "ENSG00000162688.17",
      gene_type : "protein_coding",
      gene_name : "AGL",
      gene_level : 2,
      hgnc_id : "HGNC:321",
      havana_gene : "OTTHUMG00000010803.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 99969351,
      stop : 100035634,
      direction : "+",
      ID : "ENSG00000117620.15",
      gene_id : "ENSG00000117620.15",
      gene_type : "protein_coding",
      gene_name : "SLC35A3",
      gene_level : 1,
      hgnc_id : "HGNC:11023",
      havana_gene : "OTTHUMG00000010805.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 99970011,
      stop : 100083321,
      direction : "+",
      ID : "ENSG00000283761.1",
      gene_id : "ENSG00000283761.1",
      gene_type : "protein_coding",
      gene_name : "AC118553.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000191982.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100038095,
      stop : 100083377,
      direction : "+",
      ID : "ENSG00000156875.14",
      gene_id : "ENSG00000156875.14",
      gene_type : "protein_coding",
      gene_name : "MFSD14A",
      gene_level : 2,
      hgnc_id : "HGNC:23363",
      havana_gene : "OTTHUMG00000010755.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100083563,
      stop : 100132955,
      direction : "-",
      ID : "ENSG00000156876.10",
      gene_id : "ENSG00000156876.10",
      gene_type : "protein_coding",
      gene_name : "SASS6",
      gene_level : 2,
      hgnc_id : "HGNC:25403",
      havana_gene : "OTTHUMG00000010754.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100133150,
      stop : 100150498,
      direction : "+",
      ID : "ENSG00000122435.10",
      gene_id : "ENSG00000122435.10",
      gene_type : "protein_coding",
      gene_name : "TRMT13",
      gene_level : 2,
      hgnc_id : "HGNC:25502",
      havana_gene : "OTTHUMG00000010841.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100148448,
      stop : 100178273,
      direction : "-",
      ID : "ENSG00000122477.13",
      gene_id : "ENSG00000122477.13",
      gene_type : "protein_coding",
      gene_name : "LRRC39",
      gene_level : 2,
      hgnc_id : "HGNC:28228",
      havana_gene : "OTTHUMG00000010839.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100186919,
      stop : 100249834,
      direction : "-",
      ID : "ENSG00000137992.15",
      gene_id : "ENSG00000137992.15",
      gene_type : "protein_coding",
      gene_name : "DBT",
      gene_level : 2,
      hgnc_id : "HGNC:2698",
      havana_gene : "OTTHUMG00000010921.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100266216,
      stop : 100292769,
      direction : "+",
      ID : "ENSG00000137996.13",
      gene_id : "ENSG00000137996.13",
      gene_type : "protein_coding",
      gene_name : "RTCA",
      gene_level : 2,
      hgnc_id : "HGNC:17981",
      havana_gene : "OTTHUMG00000010920.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100345001,
      stop : 100520277,
      direction : "+",
      ID : "ENSG00000079335.20",
      gene_id : "ENSG00000079335.20",
      gene_type : "protein_coding",
      gene_name : "CDC14A",
      gene_level : 2,
      hgnc_id : "HGNC:1718",
      havana_gene : "OTTHUMG00000010987.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100538139,
      stop : 100542021,
      direction : "+",
      ID : "ENSG00000181656.7",
      gene_id : "ENSG00000181656.7",
      gene_type : "protein_coding",
      gene_name : "GPR88",
      gene_level : 2,
      hgnc_id : "HGNC:4539",
      havana_gene : "OTTHUMG00000010981.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100719742,
      stop : 100739045,
      direction : "+",
      ID : "ENSG00000162692.12",
      gene_id : "ENSG00000162692.12",
      gene_type : "protein_coding",
      gene_name : "VCAM1",
      gene_level : 2,
      hgnc_id : "HGNC:12663",
      havana_gene : "OTTHUMG00000010982.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100872372,
      stop : 100895179,
      direction : "-",
      ID : "ENSG00000162694.14",
      gene_id : "ENSG00000162694.14",
      gene_type : "protein_coding",
      gene_name : "EXTL2",
      gene_level : 2,
      hgnc_id : "HGNC:3516",
      havana_gene : "OTTHUMG00000011814.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100896076,
      stop : 100981757,
      direction : "+",
      ID : "ENSG00000162695.12",
      gene_id : "ENSG00000162695.12",
      gene_type : "protein_coding",
      gene_name : "SLC30A7",
      gene_level : 1,
      hgnc_id : "HGNC:19306",
      havana_gene : "OTTHUMG00000011815.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 100989623,
      stop : 101026088,
      direction : "-",
      ID : "ENSG00000117543.21",
      gene_id : "ENSG00000117543.21",
      gene_type : "protein_coding",
      gene_name : "DPH5",
      gene_level : 2,
      hgnc_id : "HGNC:24270",
      havana_gene : "OTTHUMG00000010829.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 101236865,
      stop : 101243713,
      direction : "+",
      ID : "ENSG00000170989.10",
      gene_id : "ENSG00000170989.10",
      gene_type : "protein_coding",
      gene_name : "S1PR1",
      gene_level : 2,
      hgnc_id : "HGNC:3165",
      havana_gene : "OTTHUMG00000010835.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 101802560,
      stop : 101996926,
      direction : "-",
      ID : "ENSG00000118733.17",
      gene_id : "ENSG00000118733.17",
      gene_type : "protein_coding",
      gene_name : "OLFM3",
      gene_level : 2,
      hgnc_id : "HGNC:17990",
      havana_gene : "OTTHUMG00000010941.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 102876467,
      stop : 103108872,
      direction : "-",
      ID : "ENSG00000060718.22",
      gene_id : "ENSG00000060718.22",
      gene_type : "protein_coding",
      gene_name : "COL11A1",
      gene_level : 2,
      hgnc_id : "HGNC:2186",
      havana_gene : "OTTHUMG00000010872.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 103525691,
      stop : 103555239,
      direction : "+",
      ID : "ENSG00000185946.16",
      gene_id : "ENSG00000185946.16",
      gene_type : "protein_coding",
      gene_name : "RNPC3",
      gene_level : 2,
      hgnc_id : "HGNC:18666",
      havana_gene : "OTTHUMG00000166613.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 103553815,
      stop : 103579534,
      direction : "+",
      ID : "ENSG00000240038.6",
      gene_id : "ENSG00000240038.6",
      gene_type : "protein_coding",
      gene_name : "AMY2B",
      gene_level : 2,
      hgnc_id : "HGNC:478",
      havana_gene : "OTTHUMG00000011024.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 103616811,
      stop : 103625780,
      direction : "+",
      ID : "ENSG00000243480.7",
      gene_id : "ENSG00000243480.7",
      gene_type : "protein_coding",
      gene_name : "AMY2A",
      gene_level : 2,
      hgnc_id : "HGNC:477",
      havana_gene : "OTTHUMG00000011023.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 103655290,
      stop : 103664554,
      direction : "+",
      ID : "ENSG00000237763.9",
      gene_id : "ENSG00000237763.9",
      gene_type : "protein_coding",
      gene_name : "AMY1A",
      gene_level : 2,
      hgnc_id : "HGNC:474",
      havana_gene : "OTTHUMG00000011020.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 103687415,
      stop : 103696680,
      direction : "-",
      ID : "ENSG00000174876.16",
      gene_id : "ENSG00000174876.16",
      gene_type : "protein_coding",
      gene_name : "AMY1B",
      gene_level : 2,
      hgnc_id : "HGNC:475",
      havana_gene : "OTTHUMG00000011021.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 103750406,
      stop : 103758690,
      direction : "+",
      ID : "ENSG00000187733.6",
      gene_id : "ENSG00000187733.6",
      gene_type : "protein_coding",
      gene_name : "AMY1C",
      gene_level : 2,
      hgnc_id : "HGNC:476",
      havana_gene : "OTTHUMG00000011045.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 107056674,
      stop : 107067636,
      direction : "+",
      ID : "ENSG00000198890.9",
      gene_id : "ENSG00000198890.9",
      gene_type : "protein_coding",
      gene_name : "PRMT6",
      gene_level : 2,
      hgnc_id : "HGNC:18241",
      havana_gene : "OTTHUMG00000010964.4",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 107140007,
      stop : 107484923,
      direction : "+",
      ID : "ENSG00000162631.20",
      gene_id : "ENSG00000162631.20",
      gene_type : "protein_coding",
      gene_name : "NTNG1",
      gene_level : 2,
      hgnc_id : "HGNC:23319",
      havana_gene : "OTTHUMG00000010965.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 107571161,
      stop : 107965180,
      direction : "-",
      ID : "ENSG00000134215.16",
      gene_id : "ENSG00000134215.16",
      gene_type : "protein_coding",
      gene_name : "VAV3",
      gene_level : 2,
      hgnc_id : "HGNC:12659",
      havana_gene : "OTTHUMG00000010995.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108134043,
      stop : 108200849,
      direction : "-",
      ID : "ENSG00000085491.17",
      gene_id : "ENSG00000085491.17",
      gene_type : "protein_coding",
      gene_name : "SLC25A24",
      gene_level : 2,
      hgnc_id : "HGNC:20662",
      havana_gene : "OTTHUMG00000011013.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108223341,
      stop : 108244081,
      direction : "-",
      ID : "ENSG00000196427.13",
      gene_id : "ENSG00000196427.13",
      gene_type : "protein_coding",
      gene_name : "NBPF4",
      gene_level : 2,
      hgnc_id : "HGNC:26550",
      havana_gene : "OTTHUMG00000011318.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108450282,
      stop : 108471002,
      direction : "+",
      ID : "ENSG00000186086.18",
      gene_id : "ENSG00000186086.18",
      gene_type : "protein_coding",
      gene_name : "NBPF6",
      gene_level : 2,
      hgnc_id : "HGNC:31988",
      havana_gene : "OTTHUMG00000039830.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108560089,
      stop : 108644900,
      direction : "+",
      ID : "ENSG00000162636.16",
      gene_id : "ENSG00000162636.16",
      gene_type : "protein_coding",
      gene_name : "FAM102B",
      gene_level : 1,
      hgnc_id : "HGNC:27637",
      havana_gene : "OTTHUMG00000010967.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108648290,
      stop : 108661526,
      direction : "-",
      ID : "ENSG00000162639.16",
      gene_id : "ENSG00000162639.16",
      gene_type : "protein_coding",
      gene_name : "HENMT1",
      gene_level : 2,
      hgnc_id : "HGNC:26400",
      havana_gene : "OTTHUMG00000011123.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108692310,
      stop : 108702928,
      direction : "+",
      ID : "ENSG00000134186.12",
      gene_id : "ENSG00000134186.12",
      gene_type : "protein_coding",
      gene_name : "PRPF38B",
      gene_level : 2,
      hgnc_id : "HGNC:25512",
      havana_gene : "OTTHUMG00000010991.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108712908,
      stop : 108742749,
      direction : "+",
      ID : "ENSG00000143107.10",
      gene_id : "ENSG00000143107.10",
      gene_type : "protein_coding",
      gene_name : "FNDC7",
      gene_level : 2,
      hgnc_id : "HGNC:26668",
      havana_gene : "OTTHUMG00000011120.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108746674,
      stop : 108809523,
      direction : "+",
      ID : "ENSG00000116266.11",
      gene_id : "ENSG00000116266.11",
      gene_type : "protein_coding",
      gene_name : "STXBP3",
      gene_level : 2,
      hgnc_id : "HGNC:11446",
      havana_gene : "OTTHUMG00000011122.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108815898,
      stop : 108963484,
      direction : "-",
      ID : "ENSG00000162641.20",
      gene_id : "ENSG00000162641.20",
      gene_type : "protein_coding",
      gene_name : "AKNAD1",
      gene_level : 2,
      hgnc_id : "HGNC:28398",
      havana_gene : "OTTHUMG00000011231.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108875350,
      stop : 108934545,
      direction : "+",
      ID : "ENSG00000121957.15",
      gene_id : "ENSG00000121957.15",
      gene_type : "protein_coding",
      gene_name : "GPSM2",
      gene_level : 2,
      hgnc_id : "HGNC:29501",
      havana_gene : "OTTHUMG00000011730.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108927361,
      stop : 108963504,
      direction : "-",
      ID : "ENSG00000121940.16",
      gene_id : "ENSG00000121940.16",
      gene_type : "protein_coding",
      gene_name : "CLCC1",
      gene_level : 1,
      hgnc_id : "HGNC:29675",
      havana_gene : "OTTHUMG00000011732.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 108970214,
      stop : 109042113,
      direction : "-",
      ID : "ENSG00000085433.16",
      gene_id : "ENSG00000085433.16",
      gene_type : "protein_coding",
      gene_name : "WDR47",
      gene_level : 1,
      hgnc_id : "HGNC:29141",
      havana_gene : "OTTHUMG00000011734.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109062486,
      stop : 109076003,
      direction : "-",
      ID : "ENSG00000197780.10",
      gene_id : "ENSG00000197780.10",
      gene_type : "protein_coding",
      gene_name : "TAF13",
      gene_level : 2,
      hgnc_id : "HGNC:11546",
      havana_gene : "OTTHUMG00000042363.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109090764,
      stop : 109096934,
      direction : "+",
      ID : "ENSG00000215717.7",
      gene_id : "ENSG00000215717.7",
      gene_type : "protein_coding",
      gene_name : "TMEM167B",
      gene_level : 2,
      hgnc_id : "HGNC:30187",
      havana_gene : "OTTHUMG00000042364.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109105951,
      stop : 109113857,
      direction : "-",
      ID : "ENSG00000179902.13",
      gene_id : "ENSG00000179902.13",
      gene_type : "protein_coding",
      gene_name : "C1orf194",
      gene_level : 1,
      hgnc_id : "HGNC:32331",
      havana_gene : "OTTHUMG00000011735.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109113679,
      stop : 109206781,
      direction : "+",
      ID : "ENSG00000116299.17",
      gene_id : "ENSG00000116299.17",
      gene_type : "protein_coding",
      gene_name : "ELAPOR1",
      gene_level : 2,
      hgnc_id : "HGNC:29618",
      havana_gene : "OTTHUMG00000011725.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109213918,
      stop : 109238182,
      direction : "+",
      ID : "ENSG00000031698.13",
      gene_id : "ENSG00000031698.13",
      gene_type : "protein_coding",
      gene_name : "SARS1",
      gene_level : 2,
      hgnc_id : "HGNC:10537",
      havana_gene : "OTTHUMG00000011726.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109249539,
      stop : 109275751,
      direction : "+",
      ID : "ENSG00000143126.8",
      gene_id : "ENSG00000143126.8",
      gene_type : "protein_coding",
      gene_name : "CELSR2",
      gene_level : 2,
      hgnc_id : "HGNC:3231",
      havana_gene : "OTTHUMG00000012003.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109279556,
      stop : 109283186,
      direction : "-",
      ID : "ENSG00000134222.16",
      gene_id : "ENSG00000134222.16",
      gene_type : "protein_coding",
      gene_name : "PSRC1",
      gene_level : 2,
      hgnc_id : "HGNC:24472",
      havana_gene : "OTTHUMG00000012000.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109292365,
      stop : 109307011,
      direction : "-",
      ID : "ENSG00000221986.7",
      gene_id : "ENSG00000221986.7",
      gene_type : "protein_coding",
      gene_name : "MYBPHL",
      gene_level : 2,
      hgnc_id : "HGNC:30434",
      havana_gene : "OTTHUMG00000012002.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109309568,
      stop : 109397918,
      direction : "-",
      ID : "ENSG00000134243.12",
      gene_id : "ENSG00000134243.12",
      gene_type : "protein_coding",
      gene_name : "SORT1",
      gene_level : 2,
      hgnc_id : "HGNC:11186",
      havana_gene : "OTTHUMG00000011999.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109399042,
      stop : 109426448,
      direction : "-",
      ID : "ENSG00000143106.13",
      gene_id : "ENSG00000143106.13",
      gene_type : "protein_coding",
      gene_name : "PSMA5",
      gene_level : 2,
      hgnc_id : "HGNC:9534",
      havana_gene : "OTTHUMG00000012001.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109466546,
      stop : 109482134,
      direction : "+",
      ID : "ENSG00000143028.9",
      gene_id : "ENSG00000143028.9",
      gene_type : "protein_coding",
      gene_name : "SYPL2",
      gene_level : 2,
      hgnc_id : "HGNC:27638",
      havana_gene : "OTTHUMG00000010969.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109483479,
      stop : 109492804,
      direction : "+",
      ID : "ENSG00000162650.16",
      gene_id : "ENSG00000162650.16",
      gene_type : "protein_coding",
      gene_name : "ATXN7L2",
      gene_level : 2,
      hgnc_id : "HGNC:28713",
      havana_gene : "OTTHUMG00000011027.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109494052,
      stop : 109502932,
      direction : "+",
      ID : "ENSG00000174151.15",
      gene_id : "ENSG00000174151.15",
      gene_type : "protein_coding",
      gene_name : "CYB561D1",
      gene_level : 1,
      hgnc_id : "HGNC:26804",
      havana_gene : "OTTHUMG00000011051.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109504178,
      stop : 109509738,
      direction : "-",
      ID : "ENSG00000181754.7",
      gene_id : "ENSG00000181754.7",
      gene_type : "protein_coding",
      gene_name : "AMIGO1",
      gene_level : 2,
      hgnc_id : "HGNC:20824",
      havana_gene : "OTTHUMG00000011653.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109539872,
      stop : 109548406,
      direction : "+",
      ID : "ENSG00000156097.12",
      gene_id : "ENSG00000156097.12",
      gene_type : "protein_coding",
      gene_name : "GPR61",
      gene_level : 1,
      hgnc_id : "HGNC:13300",
      havana_gene : "OTTHUMG00000011633.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109548615,
      stop : 109600195,
      direction : "+",
      ID : "ENSG00000065135.12",
      gene_id : "ENSG00000065135.12",
      gene_type : "protein_coding",
      gene_name : "GNAI3",
      gene_level : 2,
      hgnc_id : "HGNC:4387",
      havana_gene : "OTTHUMG00000189112.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109603091,
      stop : 109619929,
      direction : "-",
      ID : "ENSG00000134183.13",
      gene_id : "ENSG00000134183.13",
      gene_type : "protein_coding",
      gene_name : "GNAT2",
      gene_level : 2,
      hgnc_id : "HGNC:4394",
      havana_gene : "OTTHUMG00000011639.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109616104,
      stop : 109632051,
      direction : "+",
      ID : "ENSG00000116337.20",
      gene_id : "ENSG00000116337.20",
      gene_type : "protein_coding",
      gene_name : "AMPD2",
      gene_level : 1,
      hgnc_id : "HGNC:469",
      havana_gene : "OTTHUMG00000011649.16",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109656099,
      stop : 109674836,
      direction : "+",
      ID : "ENSG00000168765.17",
      gene_id : "ENSG00000168765.17",
      gene_type : "protein_coding",
      gene_name : "GSTM4",
      gene_level : 2,
      hgnc_id : "HGNC:4636",
      havana_gene : "OTTHUMG00000011642.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109668022,
      stop : 109709551,
      direction : "+",
      ID : "ENSG00000213366.13",
      gene_id : "ENSG00000213366.13",
      gene_type : "protein_coding",
      gene_name : "GSTM2",
      gene_level : 2,
      hgnc_id : "HGNC:4634",
      havana_gene : "OTTHUMG00000011638.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109687814,
      stop : 109709039,
      direction : "+",
      ID : "ENSG00000134184.13",
      gene_id : "ENSG00000134184.13",
      gene_type : "protein_coding",
      gene_name : "GSTM1",
      gene_level : 1,
      hgnc_id : "HGNC:4632",
      havana_gene : "OTTHUMG00000011635.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109711780,
      stop : 109775428,
      direction : "+",
      ID : "ENSG00000134201.12",
      gene_id : "ENSG00000134201.12",
      gene_type : "protein_coding",
      gene_name : "GSTM5",
      gene_level : 2,
      hgnc_id : "HGNC:4637",
      havana_gene : "OTTHUMG00000011644.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109733932,
      stop : 109741038,
      direction : "-",
      ID : "ENSG00000134202.11",
      gene_id : "ENSG00000134202.11",
      gene_type : "protein_coding",
      gene_name : "GSTM3",
      gene_level : 2,
      hgnc_id : "HGNC:4635",
      havana_gene : "OTTHUMG00000011640.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109750080,
      stop : 109764027,
      direction : "-",
      ID : "ENSG00000198758.11",
      gene_id : "ENSG00000198758.11",
      gene_type : "protein_coding",
      gene_name : "EPS8L3",
      gene_level : 2,
      hgnc_id : "HGNC:21297",
      havana_gene : "OTTHUMG00000011651.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109910242,
      stop : 109930992,
      direction : "+",
      ID : "ENSG00000184371.14",
      gene_id : "ENSG00000184371.14",
      gene_type : "protein_coding",
      gene_name : "CSF1",
      gene_level : 1,
      hgnc_id : "HGNC:2432",
      havana_gene : "OTTHUMG00000011646.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 109984765,
      stop : 110023742,
      direction : "+",
      ID : "ENSG00000168710.18",
      gene_id : "ENSG00000168710.18",
      gene_type : "protein_coding",
      gene_name : "AHCYL1",
      gene_level : 2,
      hgnc_id : "HGNC:344",
      havana_gene : "OTTHUMG00000011652.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110031577,
      stop : 110074641,
      direction : "+",
      ID : "ENSG00000143093.15",
      gene_id : "ENSG00000143093.15",
      gene_type : "protein_coding",
      gene_name : "STRIP1",
      gene_level : 2,
      hgnc_id : "HGNC:25916",
      havana_gene : "OTTHUMG00000170607.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110059870,
      stop : 110070672,
      direction : "-",
      ID : "ENSG00000156150.9",
      gene_id : "ENSG00000156150.9",
      gene_type : "protein_coding",
      gene_name : "ALX3",
      gene_level : 2,
      hgnc_id : "HGNC:449",
      havana_gene : "OTTHUMG00000011650.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110112443,
      stop : 110113947,
      direction : "+",
      ID : "ENSG00000186150.5",
      gene_id : "ENSG00000186150.5",
      gene_type : "protein_coding",
      gene_name : "UBL4B",
      gene_level : 2,
      hgnc_id : "HGNC:32309",
      havana_gene : "OTTHUMG00000166989.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110150494,
      stop : 110202202,
      direction : "+",
      ID : "ENSG00000197106.7",
      gene_id : "ENSG00000197106.7",
      gene_type : "protein_coding",
      gene_name : "SLC6A17",
      gene_level : 2,
      hgnc_id : "HGNC:31399",
      havana_gene : "OTTHUMG00000011761.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110210314,
      stop : 110283100,
      direction : "+",
      ID : "ENSG00000116396.15",
      gene_id : "ENSG00000116396.15",
      gene_type : "protein_coding",
      gene_name : "KCNC4",
      gene_level : 1,
      hgnc_id : "HGNC:6236",
      havana_gene : "OTTHUMG00000011037.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110338506,
      stop : 110346681,
      direction : "+",
      ID : "ENSG00000162775.17",
      gene_id : "ENSG00000162775.17",
      gene_type : "protein_coding",
      gene_name : "RBM15",
      gene_level : 2,
      hgnc_id : "HGNC:14959",
      havana_gene : "OTTHUMG00000011284.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110362851,
      stop : 110391082,
      direction : "-",
      ID : "ENSG00000168679.18",
      gene_id : "ENSG00000168679.18",
      gene_type : "protein_coding",
      gene_name : "SLC16A4",
      gene_level : 1,
      hgnc_id : "HGNC:10925",
      havana_gene : "OTTHUMG00000011285.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110401249,
      stop : 110407942,
      direction : "-",
      ID : "ENSG00000134248.14",
      gene_id : "ENSG00000134248.14",
      gene_type : "protein_coding",
      gene_name : "LAMTOR5",
      gene_level : 2,
      hgnc_id : "HGNC:17955",
      havana_gene : "OTTHUMG00000011568.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110451149,
      stop : 110457358,
      direction : "+",
      ID : "ENSG00000143125.6",
      gene_id : "ENSG00000143125.6",
      gene_type : "protein_coding",
      gene_name : "PROK1",
      gene_level : 2,
      hgnc_id : "HGNC:18454",
      havana_gene : "OTTHUMG00000011569.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110517217,
      stop : 110519175,
      direction : "-",
      ID : "ENSG00000143105.7",
      gene_id : "ENSG00000143105.7",
      gene_type : "protein_coding",
      gene_name : "KCNA10",
      gene_level : 2,
      hgnc_id : "HGNC:6219",
      havana_gene : "OTTHUMG00000022785.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110519837,
      stop : 110631474,
      direction : "-",
      ID : "ENSG00000177301.16",
      gene_id : "ENSG00000177301.16",
      gene_type : "protein_coding",
      gene_name : "KCNA2",
      gene_level : 1,
      hgnc_id : "HGNC:6220",
      havana_gene : "OTTHUMG00000011567.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110672465,
      stop : 110674940,
      direction : "-",
      ID : "ENSG00000177272.9",
      gene_id : "ENSG00000177272.9",
      gene_type : "protein_coding",
      gene_name : "KCNA3",
      gene_level : 2,
      hgnc_id : "HGNC:6221",
      havana_gene : "OTTHUMG00000034493.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110871188,
      stop : 110899922,
      direction : "+",
      ID : "ENSG00000143119.14",
      gene_id : "ENSG00000143119.14",
      gene_type : "protein_coding",
      gene_name : "CD53",
      gene_level : 2,
      hgnc_id : "HGNC:1686",
      havana_gene : "OTTHUMG00000048020.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 110947190,
      stop : 110963965,
      direction : "-",
      ID : "ENSG00000121931.16",
      gene_id : "ENSG00000121931.16",
      gene_type : "protein_coding",
      gene_name : "LRIF1",
      gene_level : 2,
      hgnc_id : "HGNC:30299",
      havana_gene : "OTTHUMG00000011913.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111117163,
      stop : 111140203,
      direction : "-",
      ID : "ENSG00000156171.15",
      gene_id : "ENSG00000156171.15",
      gene_type : "protein_coding",
      gene_name : "DRAM2",
      gene_level : 2,
      hgnc_id : "HGNC:28769",
      havana_gene : "OTTHUMG00000011911.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111139627,
      stop : 111185104,
      direction : "+",
      ID : "ENSG00000134255.14",
      gene_id : "ENSG00000134255.14",
      gene_type : "protein_coding",
      gene_name : "CEPT1",
      gene_level : 2,
      hgnc_id : "HGNC:24289",
      havana_gene : "OTTHUMG00000012357.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111185969,
      stop : 111204535,
      direction : "-",
      ID : "ENSG00000162777.17",
      gene_id : "ENSG00000162777.17",
      gene_type : "protein_coding",
      gene_name : "DENND2D",
      gene_level : 2,
      hgnc_id : "HGNC:26192",
      havana_gene : "OTTHUMG00000012356.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111200771,
      stop : 111243440,
      direction : "+",
      ID : "ENSG00000064886.14",
      gene_id : "ENSG00000064886.14",
      gene_type : "protein_coding",
      gene_name : "CHI3L2",
      gene_level : 1,
      hgnc_id : "HGNC:1933",
      havana_gene : "OTTHUMG00000012174.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111290851,
      stop : 111320566,
      direction : "+",
      ID : "ENSG00000134216.19",
      gene_id : "ENSG00000134216.19",
      gene_type : "protein_coding",
      gene_name : "CHIA",
      gene_level : 2,
      hgnc_id : "HGNC:17432",
      havana_gene : "OTTHUMG00000011165.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111346600,
      stop : 111353013,
      direction : "+",
      ID : "ENSG00000173947.14",
      gene_id : "ENSG00000173947.14",
      gene_type : "protein_coding",
      gene_name : "PIFO",
      gene_level : 2,
      hgnc_id : "HGNC:27009",
      havana_gene : "OTTHUMG00000011168.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111414319,
      stop : 111427735,
      direction : "-",
      ID : "ENSG00000085465.13",
      gene_id : "ENSG00000085465.13",
      gene_type : "protein_coding",
      gene_name : "OVGP1",
      gene_level : 2,
      hgnc_id : "HGNC:8524",
      havana_gene : "OTTHUMG00000011746.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111439890,
      stop : 111449256,
      direction : "-",
      ID : "ENSG00000116455.14",
      gene_id : "ENSG00000116455.14",
      gene_type : "protein_coding",
      gene_name : "WDR77",
      gene_level : 2,
      hgnc_id : "HGNC:29652",
      havana_gene : "OTTHUMG00000011748.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111448864,
      stop : 111462773,
      direction : "+",
      ID : "ENSG00000116459.11",
      gene_id : "ENSG00000116459.11",
      gene_type : "protein_coding",
      gene_name : "ATP5PB",
      gene_level : 2,
      hgnc_id : "HGNC:840",
      havana_gene : "OTTHUMG00000011745.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111473792,
      stop : 111478512,
      direction : "+",
      ID : "ENSG00000143110.12",
      gene_id : "ENSG00000143110.12",
      gene_type : "protein_coding",
      gene_name : "C1orf162",
      gene_level : 2,
      hgnc_id : "HGNC:28344",
      havana_gene : "OTTHUMG00000011750.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111483348,
      stop : 111563962,
      direction : "-",
      ID : "ENSG00000121933.19",
      gene_id : "ENSG00000121933.19",
      gene_type : "protein_coding",
      gene_name : "TMIGD3",
      gene_level : 1,
      hgnc_id : "HGNC:51375",
      havana_gene : "OTTHUMG00000190810.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111499429,
      stop : 111503633,
      direction : "-",
      ID : "ENSG00000282608.2",
      gene_id : "ENSG00000282608.2",
      gene_type : "protein_coding",
      gene_name : "ADORA3",
      gene_level : 2,
      hgnc_id : "HGNC:268",
      havana_gene : "OTTHUMG00000011957.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111542218,
      stop : 111716691,
      direction : "+",
      ID : "ENSG00000116473.14",
      gene_id : "ENSG00000116473.14",
      gene_type : "protein_coding",
      gene_name : "RAP1A",
      gene_level : 2,
      hgnc_id : "HGNC:9855",
      havana_gene : "OTTHUMG00000011959.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111680630,
      stop : 111755824,
      direction : "-",
      ID : "ENSG00000197852.12",
      gene_id : "ENSG00000197852.12",
      gene_type : "protein_coding",
      gene_name : "INKA2",
      gene_level : 1,
      hgnc_id : "HGNC:28045",
      havana_gene : "OTTHUMG00000011953.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111754832,
      stop : 111775602,
      direction : "+",
      ID : "ENSG00000064703.13",
      gene_id : "ENSG00000064703.13",
      gene_type : "protein_coding",
      gene_name : "DDX20",
      gene_level : 2,
      hgnc_id : "HGNC:2743",
      havana_gene : "OTTHUMG00000011956.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 111770662,
      stop : 111989668,
      direction : "-",
      ID : "ENSG00000171385.10",
      gene_id : "ENSG00000171385.10",
      gene_type : "protein_coding",
      gene_name : "KCND3",
      gene_level : 2,
      hgnc_id : "HGNC:6239",
      havana_gene : "OTTHUMG00000011989.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112396214,
      stop : 112463456,
      direction : "+",
      ID : "ENSG00000143079.15",
      gene_id : "ENSG00000143079.15",
      gene_type : "protein_coding",
      gene_name : "CTTNBP2NL",
      gene_level : 2,
      hgnc_id : "HGNC:25330",
      havana_gene : "OTTHUMG00000011154.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112466541,
      stop : 112530165,
      direction : "+",
      ID : "ENSG00000134245.18",
      gene_id : "ENSG00000134245.18",
      gene_type : "protein_coding",
      gene_name : "WNT2B",
      gene_level : 2,
      hgnc_id : "HGNC:12781",
      havana_gene : "OTTHUMG00000011157.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112523514,
      stop : 112620825,
      direction : "-",
      ID : "ENSG00000007341.19",
      gene_id : "ENSG00000007341.19",
      gene_type : "protein_coding",
      gene_name : "ST7L",
      gene_level : 2,
      hgnc_id : "HGNC:18441",
      havana_gene : "OTTHUMG00000011753.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112619805,
      stop : 112671616,
      direction : "+",
      ID : "ENSG00000116489.13",
      gene_id : "ENSG00000116489.13",
      gene_type : "protein_coding",
      gene_name : "CAPZA1",
      gene_level : 2,
      hgnc_id : "HGNC:1488",
      havana_gene : "OTTHUMG00000011769.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112673141,
      stop : 112700746,
      direction : "+",
      ID : "ENSG00000155363.18",
      gene_id : "ENSG00000155363.18",
      gene_type : "protein_coding",
      gene_name : "MOV10",
      gene_level : 2,
      hgnc_id : "HGNC:7200",
      havana_gene : "OTTHUMG00000011906.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112701127,
      stop : 112707434,
      direction : "-",
      ID : "ENSG00000155366.17",
      gene_id : "ENSG00000155366.17",
      gene_type : "protein_coding",
      gene_name : "RHOC",
      gene_level : 1,
      hgnc_id : "HGNC:669",
      havana_gene : "OTTHUMG00000011905.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112702614,
      stop : 112711433,
      direction : "-",
      ID : "ENSG00000271810.5",
      gene_id : "ENSG00000271810.5",
      gene_type : "protein_coding",
      gene_name : "AL603832.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185387.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112709994,
      stop : 112715477,
      direction : "-",
      ID : "ENSG00000155367.15",
      gene_id : "ENSG00000155367.15",
      gene_type : "protein_coding",
      gene_name : "PPM1J",
      gene_level : 1,
      hgnc_id : "HGNC:20785",
      havana_gene : "OTTHUMG00000012019.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112720419,
      stop : 112727235,
      direction : "+",
      ID : "ENSG00000184599.13",
      gene_id : "ENSG00000184599.13",
      gene_type : "protein_coding",
      gene_name : "TAFA3",
      gene_level : 2,
      hgnc_id : "HGNC:21590",
      havana_gene : "OTTHUMG00000012020.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 112911847,
      stop : 112957593,
      direction : "-",
      ID : "ENSG00000155380.13",
      gene_id : "ENSG00000155380.13",
      gene_type : "protein_coding",
      gene_name : "SLC16A1",
      gene_level : 2,
      hgnc_id : "HGNC:10922",
      havana_gene : "OTTHUMG00000012129.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113073198,
      stop : 113132260,
      direction : "+",
      ID : "ENSG00000198799.12",
      gene_id : "ENSG00000198799.12",
      gene_type : "protein_coding",
      gene_name : "LRIG2",
      gene_level : 2,
      hgnc_id : "HGNC:20889",
      havana_gene : "OTTHUMG00000012133.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113390515,
      stop : 113685923,
      direction : "+",
      ID : "ENSG00000081026.19",
      gene_id : "ENSG00000081026.19",
      gene_type : "protein_coding",
      gene_name : "MAGI3",
      gene_level : 1,
      hgnc_id : "HGNC:29647",
      havana_gene : "OTTHUMG00000011737.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113696831,
      stop : 113759489,
      direction : "-",
      ID : "ENSG00000116793.16",
      gene_id : "ENSG00000116793.16",
      gene_type : "protein_coding",
      gene_name : "PHTF1",
      gene_level : 2,
      hgnc_id : "HGNC:8939",
      havana_gene : "OTTHUMG00000011800.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113761832,
      stop : 113812476,
      direction : "-",
      ID : "ENSG00000081019.13",
      gene_id : "ENSG00000081019.13",
      gene_type : "protein_coding",
      gene_name : "RSBN1",
      gene_level : 2,
      hgnc_id : "HGNC:25642",
      havana_gene : "OTTHUMG00000011938.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113813811,
      stop : 113871753,
      direction : "-",
      ID : "ENSG00000134242.16",
      gene_id : "ENSG00000134242.16",
      gene_type : "protein_coding",
      gene_name : "PTPN22",
      gene_level : 2,
      hgnc_id : "HGNC:9652",
      havana_gene : "OTTHUMG00000011936.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113876816,
      stop : 113887581,
      direction : "-",
      ID : "ENSG00000188761.13",
      gene_id : "ENSG00000188761.13",
      gene_type : "protein_coding",
      gene_name : "BCL2L15",
      gene_level : 1,
      hgnc_id : "HGNC:33624",
      havana_gene : "OTTHUMG00000011940.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113894194,
      stop : 113905201,
      direction : "-",
      ID : "ENSG00000134262.13",
      gene_id : "ENSG00000134262.13",
      gene_type : "protein_coding",
      gene_name : "AP4B1",
      gene_level : 2,
      hgnc_id : "HGNC:572",
      havana_gene : "OTTHUMG00000011943.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113905213,
      stop : 113914086,
      direction : "+",
      ID : "ENSG00000118655.7",
      gene_id : "ENSG00000118655.7",
      gene_type : "protein_coding",
      gene_name : "DCLRE1B",
      gene_level : 2,
      hgnc_id : "HGNC:17641",
      havana_gene : "OTTHUMG00000011937.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113929324,
      stop : 113977869,
      direction : "+",
      ID : "ENSG00000163349.22",
      gene_id : "ENSG00000163349.22",
      gene_type : "protein_coding",
      gene_name : "HIPK1",
      gene_level : 1,
      hgnc_id : "HGNC:19006",
      havana_gene : "OTTHUMG00000011983.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 113979391,
      stop : 114035572,
      direction : "+",
      ID : "ENSG00000116774.12",
      gene_id : "ENSG00000116774.12",
      gene_type : "protein_coding",
      gene_name : "OLFML3",
      gene_level : 2,
      hgnc_id : "HGNC:24956",
      havana_gene : "OTTHUMG00000011980.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114089291,
      stop : 114153880,
      direction : "-",
      ID : "ENSG00000134207.17",
      gene_id : "ENSG00000134207.17",
      gene_type : "protein_coding",
      gene_name : "SYT6",
      gene_level : 2,
      hgnc_id : "HGNC:18638",
      havana_gene : "OTTHUMG00000011755.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114392790,
      stop : 114511203,
      direction : "-",
      ID : "ENSG00000197323.12",
      gene_id : "ENSG00000197323.12",
      gene_type : "protein_coding",
      gene_name : "TRIM33",
      gene_level : 2,
      hgnc_id : "HGNC:16290",
      havana_gene : "OTTHUMG00000011891.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114567557,
      stop : 114581629,
      direction : "-",
      ID : "ENSG00000116752.6",
      gene_id : "ENSG00000116752.6",
      gene_type : "protein_coding",
      gene_name : "BCAS2",
      gene_level : 2,
      hgnc_id : "HGNC:975",
      havana_gene : "OTTHUMG00000011898.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114582848,
      stop : 114670422,
      direction : "-",
      ID : "ENSG00000175984.15",
      gene_id : "ENSG00000175984.15",
      gene_type : "protein_coding",
      gene_name : "DENND2C",
      gene_level : 1,
      hgnc_id : "HGNC:24748",
      havana_gene : "OTTHUMG00000011893.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114673090,
      stop : 114695618,
      direction : "-",
      ID : "ENSG00000116748.21",
      gene_id : "ENSG00000116748.21",
      gene_type : "protein_coding",
      gene_name : "AMPD1",
      gene_level : 1,
      hgnc_id : "HGNC:468",
      havana_gene : "OTTHUMG00000011892.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114704469,
      stop : 114716771,
      direction : "-",
      ID : "ENSG00000213281.5",
      gene_id : "ENSG00000213281.5",
      gene_type : "protein_coding",
      gene_name : "NRAS",
      gene_level : 2,
      hgnc_id : "HGNC:7989",
      havana_gene : "OTTHUMG00000012059.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114716913,
      stop : 114758676,
      direction : "-",
      ID : "ENSG00000009307.16",
      gene_id : "ENSG00000009307.16",
      gene_type : "protein_coding",
      gene_name : "CSDE1",
      gene_level : 1,
      hgnc_id : "HGNC:29905",
      havana_gene : "OTTHUMG00000012060.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114769479,
      stop : 114780685,
      direction : "-",
      ID : "ENSG00000052723.12",
      gene_id : "ENSG00000052723.12",
      gene_type : "protein_coding",
      gene_name : "SIKE1",
      gene_level : 2,
      hgnc_id : "HGNC:26119",
      havana_gene : "OTTHUMG00000012061.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 114854863,
      stop : 114995370,
      direction : "+",
      ID : "ENSG00000198765.12",
      gene_id : "ENSG00000198765.12",
      gene_type : "protein_coding",
      gene_name : "SYCP1",
      gene_level : 2,
      hgnc_id : "HGNC:11487",
      havana_gene : "OTTHUMG00000012057.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115029826,
      stop : 115034302,
      direction : "+",
      ID : "ENSG00000134200.4",
      gene_id : "ENSG00000134200.4",
      gene_type : "protein_coding",
      gene_name : "TSHB",
      gene_level : 2,
      hgnc_id : "HGNC:12372",
      havana_gene : "OTTHUMG00000011881.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115048011,
      stop : 115089503,
      direction : "-",
      ID : "ENSG00000134198.10",
      gene_id : "ENSG00000134198.10",
      gene_type : "protein_coding",
      gene_name : "TSPAN2",
      gene_level : 2,
      hgnc_id : "HGNC:20659",
      havana_gene : "OTTHUMG00000011878.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115285904,
      stop : 115338770,
      direction : "-",
      ID : "ENSG00000134259.6",
      gene_id : "ENSG00000134259.6",
      gene_type : "protein_coding",
      gene_name : "NGF",
      gene_level : 2,
      hgnc_id : "HGNC:7808",
      havana_gene : "OTTHUMG00000011880.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115641970,
      stop : 115698224,
      direction : "+",
      ID : "ENSG00000173218.15",
      gene_id : "ENSG00000173218.15",
      gene_type : "protein_coding",
      gene_name : "VANGL1",
      gene_level : 2,
      hgnc_id : "HGNC:15512",
      havana_gene : "OTTHUMG00000011971.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115700021,
      stop : 115768714,
      direction : "-",
      ID : "ENSG00000118729.12",
      gene_id : "ENSG00000118729.12",
      gene_type : "protein_coding",
      gene_name : "CASQ2",
      gene_level : 2,
      hgnc_id : "HGNC:1513",
      havana_gene : "OTTHUMG00000011970.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115836377,
      stop : 115843917,
      direction : "-",
      ID : "ENSG00000177551.5",
      gene_id : "ENSG00000177551.5",
      gene_type : "protein_coding",
      gene_name : "NHLH2",
      gene_level : 2,
      hgnc_id : "HGNC:7818",
      havana_gene : "OTTHUMG00000011969.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 115976513,
      stop : 116070054,
      direction : "+",
      ID : "ENSG00000163393.13",
      gene_id : "ENSG00000163393.13",
      gene_type : "protein_coding",
      gene_name : "SLC22A15",
      gene_level : 2,
      hgnc_id : "HGNC:20301",
      havana_gene : "OTTHUMG00000012008.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 116111755,
      stop : 116135240,
      direction : "+",
      ID : "ENSG00000173212.4",
      gene_id : "ENSG00000173212.4",
      gene_type : "protein_coding",
      gene_name : "MAB21L3",
      gene_level : 2,
      hgnc_id : "HGNC:26787",
      havana_gene : "OTTHUMG00000012110.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 116372668,
      stop : 116410261,
      direction : "+",
      ID : "ENSG00000163399.16",
      gene_id : "ENSG00000163399.16",
      gene_type : "protein_coding",
      gene_name : "ATP1A1",
      gene_level : 2,
      hgnc_id : "HGNC:799",
      havana_gene : "OTTHUMG00000012109.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 116514534,
      stop : 116571039,
      direction : "-",
      ID : "ENSG00000116815.16",
      gene_id : "ENSG00000116815.16",
      gene_type : "protein_coding",
      gene_name : "CD58",
      gene_level : 2,
      hgnc_id : "HGNC:1688",
      havana_gene : "OTTHUMG00000022749.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 116574399,
      stop : 116667755,
      direction : "-",
      ID : "ENSG00000143061.18",
      gene_id : "ENSG00000143061.18",
      gene_type : "protein_coding",
      gene_name : "IGSF3",
      gene_level : 2,
      hgnc_id : "HGNC:5950",
      havana_gene : "OTTHUMG00000022751.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 116754430,
      stop : 116769229,
      direction : "+",
      ID : "ENSG00000116824.5",
      gene_id : "ENSG00000116824.5",
      gene_type : "protein_coding",
      gene_name : "CD2",
      gene_level : 2,
      hgnc_id : "HGNC:1639",
      havana_gene : "OTTHUMG00000022750.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 116909916,
      stop : 116990353,
      direction : "+",
      ID : "ENSG00000134247.10",
      gene_id : "ENSG00000134247.10",
      gene_type : "protein_coding",
      gene_name : "PTGFRN",
      gene_level : 2,
      hgnc_id : "HGNC:9601",
      havana_gene : "OTTHUMG00000012028.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117001750,
      stop : 117036476,
      direction : "+",
      ID : "ENSG00000134256.12",
      gene_id : "ENSG00000134256.12",
      gene_type : "protein_coding",
      gene_name : "CD101",
      gene_level : 2,
      hgnc_id : "HGNC:5949",
      havana_gene : "OTTHUMG00000012029.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117060326,
      stop : 117107453,
      direction : "+",
      ID : "ENSG00000116830.12",
      gene_id : "ENSG00000116830.12",
      gene_type : "protein_coding",
      gene_name : "TTF2",
      gene_level : 2,
      hgnc_id : "HGNC:12398",
      havana_gene : "OTTHUMG00000012030.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117111060,
      stop : 117122587,
      direction : "-",
      ID : "ENSG00000134253.10",
      gene_id : "ENSG00000134253.10",
      gene_type : "protein_coding",
      gene_name : "TRIM45",
      gene_level : 2,
      hgnc_id : "HGNC:19018",
      havana_gene : "OTTHUMG00000012119.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117143587,
      stop : 117210960,
      direction : "-",
      ID : "ENSG00000134258.17",
      gene_id : "ENSG00000134258.17",
      gene_type : "protein_coding",
      gene_name : "VTCN1",
      gene_level : 2,
      hgnc_id : "HGNC:28873",
      havana_gene : "OTTHUMG00000012118.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117367449,
      stop : 117528872,
      direction : "+",
      ID : "ENSG00000198162.12",
      gene_id : "ENSG00000198162.12",
      gene_type : "protein_coding",
      gene_name : "MAN1A2",
      gene_level : 1,
      hgnc_id : "HGNC:6822",
      havana_gene : "OTTHUMG00000012149.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117606048,
      stop : 117628389,
      direction : "+",
      ID : "ENSG00000183508.5",
      gene_id : "ENSG00000183508.5",
      gene_type : "protein_coding",
      gene_name : "TENT5C",
      gene_level : 2,
      hgnc_id : "HGNC:24712",
      havana_gene : "OTTHUMG00000013703.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117863485,
      stop : 117929621,
      direction : "-",
      ID : "ENSG00000196505.11",
      gene_id : "ENSG00000196505.11",
      gene_type : "protein_coding",
      gene_name : "GDAP2",
      gene_level : 2,
      hgnc_id : "HGNC:18010",
      havana_gene : "OTTHUMG00000012199.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117929720,
      stop : 117966543,
      direction : "+",
      ID : "ENSG00000065183.16",
      gene_id : "ENSG00000065183.16",
      gene_type : "protein_coding",
      gene_name : "WDR3",
      gene_level : 2,
      hgnc_id : "HGNC:12755",
      havana_gene : "OTTHUMG00000012197.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 117953590,
      stop : 118185228,
      direction : "-",
      ID : "ENSG00000155761.14",
      gene_id : "ENSG00000155761.14",
      gene_type : "protein_coding",
      gene_name : "SPAG17",
      gene_level : 2,
      hgnc_id : "HGNC:26620",
      havana_gene : "OTTHUMG00000012198.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 118883046,
      stop : 118989556,
      direction : "-",
      ID : "ENSG00000092607.15",
      gene_id : "ENSG00000092607.15",
      gene_type : "protein_coding",
      gene_name : "TBX15",
      gene_level : 2,
      hgnc_id : "HGNC:11594",
      havana_gene : "OTTHUMG00000012263.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119031216,
      stop : 119140654,
      direction : "-",
      ID : "ENSG00000116874.12",
      gene_id : "ENSG00000116874.12",
      gene_type : "protein_coding",
      gene_name : "WARS2",
      gene_level : 2,
      hgnc_id : "HGNC:12730",
      havana_gene : "OTTHUMG00000012335.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119368779,
      stop : 119394130,
      direction : "+",
      ID : "ENSG00000116882.15",
      gene_id : "ENSG00000116882.15",
      gene_type : "protein_coding",
      gene_name : "HAO2",
      gene_level : 2,
      hgnc_id : "HGNC:4810",
      havana_gene : "OTTHUMG00000012410.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119414931,
      stop : 119423035,
      direction : "+",
      ID : "ENSG00000203859.10",
      gene_id : "ENSG00000203859.10",
      gene_type : "protein_coding",
      gene_name : "HSD3B2",
      gene_level : 2,
      hgnc_id : "HGNC:5218",
      havana_gene : "OTTHUMG00000012526.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119507198,
      stop : 119515054,
      direction : "+",
      ID : "ENSG00000203857.10",
      gene_id : "ENSG00000203857.10",
      gene_type : "protein_coding",
      gene_name : "HSD3B1",
      gene_level : 2,
      hgnc_id : "HGNC:5217",
      havana_gene : "OTTHUMG00000012525.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119619377,
      stop : 119648266,
      direction : "-",
      ID : "ENSG00000143067.5",
      gene_id : "ENSG00000143067.5",
      gene_type : "protein_coding",
      gene_name : "ZNF697",
      gene_level : 2,
      hgnc_id : "HGNC:32034",
      havana_gene : "OTTHUMG00000012962.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119648411,
      stop : 119744218,
      direction : "+",
      ID : "ENSG00000092621.13",
      gene_id : "ENSG00000092621.13",
      gene_type : "protein_coding",
      gene_name : "PHGDH",
      gene_level : 2,
      hgnc_id : "HGNC:8923",
      havana_gene : "OTTHUMG00000012100.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119748002,
      stop : 119768905,
      direction : "-",
      ID : "ENSG00000134240.12",
      gene_id : "ENSG00000134240.12",
      gene_type : "protein_coding",
      gene_name : "HMGCS2",
      gene_level : 2,
      hgnc_id : "HGNC:5008",
      havana_gene : "OTTHUMG00000012101.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119794017,
      stop : 119811580,
      direction : "-",
      ID : "ENSG00000134193.15",
      gene_id : "ENSG00000134193.15",
      gene_type : "protein_coding",
      gene_name : "REG4",
      gene_level : 1,
      hgnc_id : "HGNC:22977",
      havana_gene : "OTTHUMG00000012175.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119893533,
      stop : 119896515,
      direction : "-",
      ID : "ENSG00000134249.7",
      gene_id : "ENSG00000134249.7",
      gene_type : "protein_coding",
      gene_name : "ADAM30",
      gene_level : 2,
      hgnc_id : "HGNC:208",
      havana_gene : "OTTHUMG00000189303.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 119911553,
      stop : 120100779,
      direction : "-",
      ID : "ENSG00000134250.20",
      gene_id : "ENSG00000134250.20",
      gene_type : "protein_coding",
      gene_name : "NOTCH2",
      gene_level : 2,
      hgnc_id : "HGNC:7882",
      havana_gene : "OTTHUMG00000012177.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 120150898,
      stop : 120176520,
      direction : "-",
      ID : "ENSG00000265808.4",
      gene_id : "ENSG00000265808.4",
      gene_type : "protein_coding",
      gene_name : "SEC22B",
      gene_level : 2,
      hgnc_id : "HGNC:10700",
      havana_gene : "OTTHUMG00000185008.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 120723946,
      stop : 120793874,
      direction : "+",
      ID : "ENSG00000286106.1",
      gene_id : "ENSG00000286106.1",
      gene_type : "protein_coding",
      gene_name : "NOTCH2NLR",
      gene_level : 2,
      hgnc_id : "HGNC:53925",
      havana_gene : "OTTHUMG00000193482.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 120723949,
      stop : 120842110,
      direction : "+",
      ID : "ENSG00000273136.7",
      gene_id : "ENSG00000273136.7",
      gene_type : "protein_coding",
      gene_name : "NBPF26",
      gene_level : 2,
      hgnc_id : "HGNC:49571",
      havana_gene : "OTTHUMG00000189374.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 120889746,
      stop : 120890405,
      direction : "+",
      ID : "ENSG00000263353.3",
      gene_id : "ENSG00000263353.3",
      gene_type : "protein_coding",
      gene_name : "PPIAL4A",
      gene_level : 2,
      hgnc_id : "HGNC:24369",
      havana_gene : "OTTHUMG00000185015.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 121087345,
      stop : 121097161,
      direction : "+",
      ID : "ENSG00000198019.13",
      gene_id : "ENSG00000198019.13",
      gene_type : "protein_coding",
      gene_name : "FCGR1B",
      gene_level : 2,
      hgnc_id : "HGNC:3614",
      havana_gene : "OTTHUMG00000040903.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 121167646,
      stop : 121185539,
      direction : "-",
      ID : "ENSG00000188610.12",
      gene_id : "ENSG00000188610.12",
      gene_type : "protein_coding",
      gene_name : "FAM72B",
      gene_level : 2,
      hgnc_id : "HGNC:24805",
      havana_gene : "OTTHUMG00000185025.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 121184811,
      stop : 121392874,
      direction : "+",
      ID : "ENSG00000171943.12",
      gene_id : "ENSG00000171943.12",
      gene_type : "protein_coding",
      gene_name : "SRGAP2C",
      gene_level : 2,
      hgnc_id : "HGNC:30584",
      havana_gene : "OTTHUMG00000041445.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 143894544,
      stop : 143905966,
      direction : "-",
      ID : "ENSG00000273213.3",
      gene_id : "ENSG00000273213.3",
      gene_type : "protein_coding",
      gene_name : "H3-2",
      gene_level : 2,
      hgnc_id : "HGNC:32060",
      havana_gene : "OTTHUMG00000041033.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 143955364,
      stop : 143971965,
      direction : "-",
      ID : "ENSG00000263513.5",
      gene_id : "ENSG00000263513.5",
      gene_type : "protein_coding",
      gene_name : "FAM72C",
      gene_level : 2,
      hgnc_id : "HGNC:30602",
      havana_gene : "OTTHUMG00000041029.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 144372875,
      stop : 144373659,
      direction : "-",
      ID : "ENSG00000271567.1",
      gene_id : "ENSG00000271567.1",
      gene_type : "protein_coding",
      gene_name : "PPIAL4E",
      gene_level : 2,
      hgnc_id : "HGNC:33997",
      havana_gene : "OTTHUMG00000189244.1",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 144421386,
      stop : 144461674,
      direction : "-",
      ID : "ENSG00000266338.6",
      gene_id : "ENSG00000266338.6",
      gene_type : "protein_coding",
      gene_name : "NBPF15",
      gene_level : 2,
      hgnc_id : "HGNC:28791",
      havana_gene : "OTTHUMG00000013634.13",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 144592868,
      stop : 144593652,
      direction : "+",
      ID : "ENSG00000279782.2",
      gene_id : "ENSG00000279782.2",
      gene_type : "protein_coding",
      gene_name : "PPIAL4F",
      gene_level : 2,
      hgnc_id : "HGNC:33999",
      havana_gene : "OTTHUMG00000189245.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 144887265,
      stop : 145095528,
      direction : "-",
      ID : "ENSG00000196369.11",
      gene_id : "ENSG00000196369.11",
      gene_type : "protein_coding",
      gene_name : "SRGAP2B",
      gene_level : 2,
      hgnc_id : "HGNC:35237",
      havana_gene : "OTTHUMG00000041442.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145095974,
      stop : 145112696,
      direction : "+",
      ID : "ENSG00000215784.6",
      gene_id : "ENSG00000215784.6",
      gene_type : "protein_coding",
      gene_name : "FAM72D",
      gene_level : 2,
      hgnc_id : "HGNC:33593",
      havana_gene : "OTTHUMG00000074801.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145241630,
      stop : 145242124,
      direction : "-",
      ID : "ENSG00000256374.2",
      gene_id : "ENSG00000256374.2",
      gene_type : "protein_coding",
      gene_name : "PPIAL4D",
      gene_level : 2,
      hgnc_id : "HGNC:33998",
      havana_gene : "OTTHUMG00000078265.3",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145289900,
      stop : 145405778,
      direction : "-",
      ID : "ENSG00000162825.16",
      gene_id : "ENSG00000162825.16",
      gene_type : "protein_coding",
      gene_name : "NBPF20",
      gene_level : 2,
      hgnc_id : "HGNC:32000",
      havana_gene : "OTTHUMG00000042439.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145607988,
      stop : 145670650,
      direction : "+",
      ID : "ENSG00000117262.19",
      gene_id : "ENSG00000117262.19",
      gene_type : "protein_coding",
      gene_name : "GPR89A",
      gene_level : 2,
      hgnc_id : "HGNC:31984",
      havana_gene : "OTTHUMG00000013738.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145670852,
      stop : 145708148,
      direction : "-",
      ID : "ENSG00000174827.14",
      gene_id : "ENSG00000174827.14",
      gene_type : "protein_coding",
      gene_name : "PDZK1",
      gene_level : 2,
      hgnc_id : "HGNC:8821",
      havana_gene : "OTTHUMG00000013735.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145719471,
      stop : 145739288,
      direction : "+",
      ID : "ENSG00000117281.16",
      gene_id : "ENSG00000117281.16",
      gene_type : "protein_coding",
      gene_name : "CD160",
      gene_level : 2,
      hgnc_id : "HGNC:17013",
      havana_gene : "OTTHUMG00000013749.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145738868,
      stop : 145824095,
      direction : "-",
      ID : "ENSG00000265491.5",
      gene_id : "ENSG00000265491.5",
      gene_type : "protein_coding",
      gene_name : "RNF115",
      gene_level : 2,
      hgnc_id : "HGNC:18154",
      havana_gene : "OTTHUMG00000013758.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145824088,
      stop : 145844402,
      direction : "+",
      ID : "ENSG00000186141.9",
      gene_id : "ENSG00000186141.9",
      gene_type : "protein_coding",
      gene_name : "POLR3C",
      gene_level : 2,
      hgnc_id : "HGNC:30076",
      havana_gene : "OTTHUMG00000013753.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145845630,
      stop : 145848954,
      direction : "+",
      ID : "ENSG00000186364.12",
      gene_id : "ENSG00000186364.12",
      gene_type : "protein_coding",
      gene_name : "NUDT17",
      gene_level : 2,
      hgnc_id : "HGNC:26618",
      havana_gene : "OTTHUMG00000013752.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145848522,
      stop : 145859836,
      direction : "-",
      ID : "ENSG00000131788.16",
      gene_id : "ENSG00000131788.16",
      gene_type : "protein_coding",
      gene_name : "PIAS3",
      gene_level : 2,
      hgnc_id : "HGNC:16861",
      havana_gene : "OTTHUMG00000013750.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145866560,
      stop : 145885866,
      direction : "-",
      ID : "ENSG00000198483.13",
      gene_id : "ENSG00000198483.13",
      gene_type : "protein_coding",
      gene_name : "ANKRD35",
      gene_level : 2,
      hgnc_id : "HGNC:26323",
      havana_gene : "OTTHUMG00000013743.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145891208,
      stop : 145910111,
      direction : "-",
      ID : "ENSG00000143127.13",
      gene_id : "ENSG00000143127.13",
      gene_type : "protein_coding",
      gene_name : "ITGA10",
      gene_level : 2,
      hgnc_id : "HGNC:6135",
      havana_gene : "OTTHUMG00000013751.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145911350,
      stop : 145918717,
      direction : "-",
      ID : "ENSG00000131779.11",
      gene_id : "ENSG00000131779.11",
      gene_type : "protein_coding",
      gene_name : "PEX11B",
      gene_level : 2,
      hgnc_id : "HGNC:8853",
      havana_gene : "OTTHUMG00000013756.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145917714,
      stop : 145927678,
      direction : "-",
      ID : "ENSG00000265241.7",
      gene_id : "ENSG00000265241.7",
      gene_type : "protein_coding",
      gene_name : "RBM8A",
      gene_level : 2,
      hgnc_id : "HGNC:9905",
      havana_gene : "OTTHUMG00000013736.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145927258,
      stop : 145977811,
      direction : "+",
      ID : "ENSG00000280778.1",
      gene_id : "ENSG00000280778.1",
      gene_type : "protein_coding",
      gene_name : "AC243547.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189699.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145933423,
      stop : 145958017,
      direction : "-",
      ID : "ENSG00000271601.4",
      gene_id : "ENSG00000271601.4",
      gene_type : "protein_coding",
      gene_name : "LIX1L",
      gene_level : 2,
      hgnc_id : "HGNC:28715",
      havana_gene : "OTTHUMG00000013741.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145959441,
      stop : 145964575,
      direction : "-",
      ID : "ENSG00000272031.3",
      gene_id : "ENSG00000272031.3",
      gene_type : "protein_coding",
      gene_name : "ANKRD34A",
      gene_level : 2,
      hgnc_id : "HGNC:27639",
      havana_gene : "OTTHUMG00000013740.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145964690,
      stop : 145978848,
      direction : "+",
      ID : "ENSG00000121851.13",
      gene_id : "ENSG00000121851.13",
      gene_type : "protein_coding",
      gene_name : "POLR3GL",
      gene_level : 2,
      hgnc_id : "HGNC:28466",
      havana_gene : "OTTHUMG00000013739.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 145992435,
      stop : 145996579,
      direction : "-",
      ID : "ENSG00000265972.6",
      gene_id : "ENSG00000265972.6",
      gene_type : "protein_coding",
      gene_name : "TXNIP",
      gene_level : 2,
      hgnc_id : "HGNC:16952",
      havana_gene : "OTTHUMG00000013755.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 146017468,
      stop : 146036746,
      direction : "-",
      ID : "ENSG00000168509.20",
      gene_id : "ENSG00000168509.20",
      gene_type : "protein_coding",
      gene_name : "HJV",
      gene_level : 2,
      hgnc_id : "HGNC:4887",
      havana_gene : "OTTHUMG00000013748.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 146064711,
      stop : 146229000,
      direction : "-",
      ID : "ENSG00000271425.9",
      gene_id : "ENSG00000271425.9",
      gene_type : "protein_coding",
      gene_name : "NBPF10",
      gene_level : 2,
      hgnc_id : "HGNC:31992",
      havana_gene : "OTTHUMG00000013757.25",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 146146203,
      stop : 146229026,
      direction : "-",
      ID : "ENSG00000264343.6",
      gene_id : "ENSG00000264343.6",
      gene_type : "protein_coding",
      gene_name : "NOTCH2NLA",
      gene_level : 2,
      hgnc_id : "HGNC:31862",
      havana_gene : "OTTHUMG00000013754.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 146344131,
      stop : 146344790,
      direction : "-",
      ID : "ENSG00000270339.3",
      gene_id : "ENSG00000270339.3",
      gene_type : "protein_coding",
      gene_name : "PPIAL4H",
      gene_level : 2,
      hgnc_id : "HGNC:53889",
      havana_gene : "OTTHUMG00000191983.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 146938744,
      stop : 146996202,
      direction : "+",
      ID : "ENSG00000268043.7",
      gene_id : "ENSG00000268043.7",
      gene_type : "protein_coding",
      gene_name : "NBPF12",
      gene_level : 2,
      hgnc_id : "HGNC:24297",
      havana_gene : "OTTHUMG00000043708.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147155106,
      stop : 147172550,
      direction : "-",
      ID : "ENSG00000131791.8",
      gene_id : "ENSG00000131791.8",
      gene_type : "protein_coding",
      gene_name : "PRKAB2",
      gene_level : 2,
      hgnc_id : "HGNC:9379",
      havana_gene : "OTTHUMG00000014032.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147175351,
      stop : 147243050,
      direction : "-",
      ID : "ENSG00000131781.13",
      gene_id : "ENSG00000131781.13",
      gene_type : "protein_coding",
      gene_name : "FMO5",
      gene_level : 2,
      hgnc_id : "HGNC:3773",
      havana_gene : "OTTHUMG00000014607.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147242654,
      stop : 147295765,
      direction : "+",
      ID : "ENSG00000131778.19",
      gene_id : "ENSG00000131778.19",
      gene_type : "protein_coding",
      gene_name : "CHD1L",
      gene_level : 2,
      hgnc_id : "HGNC:1916",
      havana_gene : "OTTHUMG00000150271.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147541501,
      stop : 147626216,
      direction : "+",
      ID : "ENSG00000116128.11",
      gene_id : "ENSG00000116128.11",
      gene_type : "protein_coding",
      gene_name : "BCL9",
      gene_level : 2,
      hgnc_id : "HGNC:1008",
      havana_gene : "OTTHUMG00000014031.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147611590,
      stop : 147611796,
      direction : "+",
      ID : "ENSG00000288626.1",
      gene_id : "ENSG00000288626.1",
      gene_type : "protein_coding",
      gene_name : "AC242628.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147629652,
      stop : 147670524,
      direction : "-",
      ID : "ENSG00000162836.12",
      gene_id : "ENSG00000162836.12",
      gene_type : "protein_coding",
      gene_name : "ACP6",
      gene_level : 1,
      hgnc_id : "HGNC:29609",
      havana_gene : "OTTHUMG00000014019.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147756199,
      stop : 147773362,
      direction : "-",
      ID : "ENSG00000265107.3",
      gene_id : "ENSG00000265107.3",
      gene_type : "protein_coding",
      gene_name : "GJA5",
      gene_level : 2,
      hgnc_id : "HGNC:4279",
      havana_gene : "OTTHUMG00000014020.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147902795,
      stop : 147909269,
      direction : "+",
      ID : "ENSG00000121634.6",
      gene_id : "ENSG00000121634.6",
      gene_type : "protein_coding",
      gene_name : "GJA8",
      gene_level : 2,
      hgnc_id : "HGNC:4281",
      havana_gene : "OTTHUMG00000024085.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 147928393,
      stop : 147993592,
      direction : "+",
      ID : "ENSG00000188092.15",
      gene_id : "ENSG00000188092.15",
      gene_type : "protein_coding",
      gene_name : "GPR89B",
      gene_level : 2,
      hgnc_id : "HGNC:13840",
      havana_gene : "OTTHUMG00000013452.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 148102046,
      stop : 148152322,
      direction : "-",
      ID : "ENSG00000263956.6",
      gene_id : "ENSG00000263956.6",
      gene_type : "protein_coding",
      gene_name : "NBPF11",
      gene_level : 2,
      hgnc_id : "HGNC:31993",
      havana_gene : "OTTHUMG00000013880.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 148482548,
      stop : 148483302,
      direction : "-",
      ID : "ENSG00000236334.3",
      gene_id : "ENSG00000236334.3",
      gene_type : "protein_coding",
      gene_name : "PPIAL4G",
      gene_level : 2,
      hgnc_id : "HGNC:33996",
      havana_gene : "OTTHUMG00000013629.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 148531385,
      stop : 148679742,
      direction : "-",
      ID : "ENSG00000270629.6",
      gene_id : "ENSG00000270629.6",
      gene_type : "protein_coding",
      gene_name : "NBPF14",
      gene_level : 2,
      hgnc_id : "HGNC:25232",
      havana_gene : "OTTHUMG00000188198.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 148607040,
      stop : 148679779,
      direction : "-",
      ID : "ENSG00000286019.1",
      gene_id : "ENSG00000286019.1",
      gene_type : "protein_coding",
      gene_name : "NOTCH2NLB",
      gene_level : 2,
      hgnc_id : "HGNC:53923",
      havana_gene : "OTTHUMG00000193480.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 148748894,
      stop : 148750099,
      direction : "+",
      ID : "ENSG00000177144.7",
      gene_id : "ENSG00000177144.7",
      gene_type : "protein_coding",
      gene_name : "NUDT4B",
      gene_level : 2,
      hgnc_id : "HGNC:18012",
      havana_gene : "OTTHUMG00000188673.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 148808181,
      stop : 149048286,
      direction : "+",
      ID : "ENSG00000178104.19",
      gene_id : "ENSG00000178104.19",
      gene_type : "protein_coding",
      gene_name : "PDE4DIP",
      gene_level : 1,
      hgnc_id : "HGNC:15580",
      havana_gene : "OTTHUMG00000013846.16",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149054027,
      stop : 149103561,
      direction : "-",
      ID : "ENSG00000269713.7",
      gene_id : "ENSG00000269713.7",
      gene_type : "protein_coding",
      gene_name : "NBPF9",
      gene_level : 2,
      hgnc_id : "HGNC:31991",
      havana_gene : "OTTHUMG00000013845.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149390614,
      stop : 149468030,
      direction : "+",
      ID : "ENSG00000286219.1",
      gene_id : "ENSG00000286219.1",
      gene_type : "protein_coding",
      gene_name : "NOTCH2NLC",
      gene_level : 2,
      hgnc_id : "HGNC:53924",
      havana_gene : "OTTHUMG00000193481.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149390623,
      stop : 149556361,
      direction : "+",
      ID : "ENSG00000286185.1",
      gene_id : "ENSG00000286185.1",
      gene_type : "protein_coding",
      gene_name : "AC242842.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193752.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149475338,
      stop : 149556361,
      direction : "+",
      ID : "ENSG00000271383.7",
      gene_id : "ENSG00000271383.7",
      gene_type : "protein_coding",
      gene_name : "NBPF19",
      gene_level : 2,
      hgnc_id : "HGNC:31999",
      havana_gene : "OTTHUMG00000013900.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149583865,
      stop : 149584464,
      direction : "+",
      ID : "ENSG00000263464.2",
      gene_id : "ENSG00000263464.2",
      gene_type : "protein_coding",
      gene_name : "PPIAL4C",
      gene_level : 2,
      hgnc_id : "HGNC:33995",
      havana_gene : "OTTHUMG00000188675.1",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149782671,
      stop : 149791675,
      direction : "+",
      ID : "ENSG00000150337.14",
      gene_id : "ENSG00000150337.14",
      gene_type : "protein_coding",
      gene_name : "FCGR1A",
      gene_level : 2,
      hgnc_id : "HGNC:3613",
      havana_gene : "OTTHUMG00000012089.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149782689,
      stop : 149812373,
      direction : "-",
      ID : "ENSG00000203814.6",
      gene_id : "ENSG00000203814.6",
      gene_type : "protein_coding",
      gene_name : "H2BC18",
      gene_level : 2,
      hgnc_id : "HGNC:24700",
      havana_gene : "OTTHUMG00000183159.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149813225,
      stop : 149813693,
      direction : "-",
      ID : "ENSG00000183598.4",
      gene_id : "ENSG00000183598.4",
      gene_type : "protein_coding",
      gene_name : "H3C13",
      gene_level : 2,
      hgnc_id : "HGNC:25311",
      havana_gene : "OTTHUMG00000012092.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149832659,
      stop : 149839767,
      direction : "+",
      ID : "ENSG00000270882.2",
      gene_id : "ENSG00000270882.2",
      gene_type : "protein_coding",
      gene_name : "H4C14",
      gene_level : 2,
      hgnc_id : "HGNC:4794",
      havana_gene : "OTTHUMG00000012189.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149839538,
      stop : 149841193,
      direction : "-",
      ID : "ENSG00000203811.1",
      gene_id : "ENSG00000203811.1",
      gene_type : "protein_coding",
      gene_name : "H3C14",
      gene_level : 2,
      hgnc_id : "HGNC:20503",
      havana_gene : "OTTHUMG00000012190.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149842188,
      stop : 149842736,
      direction : "-",
      ID : "ENSG00000203812.2",
      gene_id : "ENSG00000203812.2",
      gene_type : "protein_coding",
      gene_name : "H2AC18",
      gene_level : 2,
      hgnc_id : "HGNC:4736",
      havana_gene : "OTTHUMG00000188678.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149851061,
      stop : 149851624,
      direction : "+",
      ID : "ENSG00000272196.2",
      gene_id : "ENSG00000272196.2",
      gene_type : "protein_coding",
      gene_name : "H2AC19",
      gene_level : 2,
      hgnc_id : "HGNC:29668",
      havana_gene : "OTTHUMG00000012097.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149852619,
      stop : 149854274,
      direction : "+",
      ID : "ENSG00000203852.3",
      gene_id : "ENSG00000203852.3",
      gene_type : "protein_coding",
      gene_name : "H3C15",
      gene_level : 2,
      hgnc_id : "HGNC:20505",
      havana_gene : "OTTHUMG00000012094.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149854045,
      stop : 149861210,
      direction : "-",
      ID : "ENSG00000270276.2",
      gene_id : "ENSG00000270276.2",
      gene_type : "protein_coding",
      gene_name : "H4C15",
      gene_level : 2,
      hgnc_id : "HGNC:29607",
      havana_gene : "OTTHUMG00000188201.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149884459,
      stop : 149886652,
      direction : "-",
      ID : "ENSG00000184678.10",
      gene_id : "ENSG00000184678.10",
      gene_type : "protein_coding",
      gene_name : "H2BC21",
      gene_level : 2,
      hgnc_id : "HGNC:4760",
      havana_gene : "OTTHUMG00000012095.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149886918,
      stop : 149887411,
      direction : "+",
      ID : "ENSG00000184260.6",
      gene_id : "ENSG00000184260.6",
      gene_type : "protein_coding",
      gene_name : "H2AC20",
      gene_level : 2,
      hgnc_id : "HGNC:4738",
      havana_gene : "OTTHUMG00000035825.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149887469,
      stop : 149887965,
      direction : "-",
      ID : "ENSG00000184270.6",
      gene_id : "ENSG00000184270.6",
      gene_type : "protein_coding",
      gene_name : "H2AC21",
      gene_level : 2,
      hgnc_id : "HGNC:20508",
      havana_gene : "OTTHUMG00000012085.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149887890,
      stop : 149900798,
      direction : "+",
      ID : "ENSG00000178096.9",
      gene_id : "ENSG00000178096.9",
      gene_type : "protein_coding",
      gene_name : "BOLA1",
      gene_level : 2,
      hgnc_id : "HGNC:24263",
      havana_gene : "OTTHUMG00000012087.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149903318,
      stop : 149917844,
      direction : "-",
      ID : "ENSG00000159164.10",
      gene_id : "ENSG00000159164.10",
      gene_type : "protein_coding",
      gene_name : "SV2A",
      gene_level : 2,
      hgnc_id : "HGNC:20566",
      havana_gene : "OTTHUMG00000012209.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149923317,
      stop : 149927803,
      direction : "-",
      ID : "ENSG00000143368.10",
      gene_id : "ENSG00000143368.10",
      gene_type : "protein_coding",
      gene_name : "SF3B4",
      gene_level : 2,
      hgnc_id : "HGNC:10771",
      havana_gene : "OTTHUMG00000012208.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149928651,
      stop : 149936879,
      direction : "-",
      ID : "ENSG00000014914.21",
      gene_id : "ENSG00000014914.21",
      gene_type : "protein_coding",
      gene_name : "MTMR11",
      gene_level : 2,
      hgnc_id : "HGNC:24307",
      havana_gene : "OTTHUMG00000012207.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 149937812,
      stop : 150010726,
      direction : "-",
      ID : "ENSG00000264522.6",
      gene_id : "ENSG00000264522.6",
      gene_type : "protein_coding",
      gene_name : "OTUD7B",
      gene_level : 2,
      hgnc_id : "HGNC:16683",
      havana_gene : "OTTHUMG00000012291.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150067279,
      stop : 150145329,
      direction : "+",
      ID : "ENSG00000136631.15",
      gene_id : "ENSG00000136631.15",
      gene_type : "protein_coding",
      gene_name : "VPS45",
      gene_level : 2,
      hgnc_id : "HGNC:14579",
      havana_gene : "OTTHUMG00000012511.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150149183,
      stop : 150164720,
      direction : "+",
      ID : "ENSG00000023902.14",
      gene_id : "ENSG00000023902.14",
      gene_type : "protein_coding",
      gene_name : "PLEKHO1",
      gene_level : 2,
      hgnc_id : "HGNC:24310",
      havana_gene : "OTTHUMG00000012510.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150218417,
      stop : 150236156,
      direction : "-",
      ID : "ENSG00000143401.15",
      gene_id : "ENSG00000143401.15",
      gene_type : "protein_coding",
      gene_name : "ANP32E",
      gene_level : 1,
      hgnc_id : "HGNC:16673",
      havana_gene : "OTTHUMG00000012547.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150257251,
      stop : 150265078,
      direction : "+",
      ID : "ENSG00000118298.12",
      gene_id : "ENSG00000118298.12",
      gene_type : "protein_coding",
      gene_name : "CA14",
      gene_level : 2,
      hgnc_id : "HGNC:1372",
      havana_gene : "OTTHUMG00000012549.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150265399,
      stop : 150269580,
      direction : "-",
      ID : "ENSG00000117362.13",
      gene_id : "ENSG00000117362.13",
      gene_type : "protein_coding",
      gene_name : "APH1A",
      gene_level : 2,
      hgnc_id : "HGNC:29509",
      havana_gene : "OTTHUMG00000012545.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150268200,
      stop : 150280916,
      direction : "+",
      ID : "ENSG00000118292.9",
      gene_id : "ENSG00000118292.9",
      gene_type : "protein_coding",
      gene_name : "C1orf54",
      gene_level : 2,
      hgnc_id : "HGNC:26258",
      havana_gene : "OTTHUMG00000012546.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150282543,
      stop : 150287093,
      direction : "+",
      ID : "ENSG00000159208.16",
      gene_id : "ENSG00000159208.16",
      gene_type : "protein_coding",
      gene_name : "CIART",
      gene_level : 2,
      hgnc_id : "HGNC:25200",
      havana_gene : "OTTHUMG00000012548.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150293861,
      stop : 150308979,
      direction : "+",
      ID : "ENSG00000266472.6",
      gene_id : "ENSG00000266472.6",
      gene_type : "protein_coding",
      gene_name : "MRPS21",
      gene_level : 2,
      hgnc_id : "HGNC:14046",
      havana_gene : "OTTHUMG00000012544.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150321479,
      stop : 150353233,
      direction : "+",
      ID : "ENSG00000117360.13",
      gene_id : "ENSG00000117360.13",
      gene_type : "protein_coding",
      gene_name : "PRPF3",
      gene_level : 2,
      hgnc_id : "HGNC:17348",
      havana_gene : "OTTHUMG00000012807.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150363091,
      stop : 150476566,
      direction : "+",
      ID : "ENSG00000163125.15",
      gene_id : "ENSG00000163125.15",
      gene_type : "protein_coding",
      gene_name : "RPRD2",
      gene_level : 2,
      hgnc_id : "HGNC:29039",
      havana_gene : "OTTHUMG00000012808.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150487364,
      stop : 150507609,
      direction : "+",
      ID : "ENSG00000143374.17",
      gene_id : "ENSG00000143374.17",
      gene_type : "protein_coding",
      gene_name : "TARS2",
      gene_level : 2,
      hgnc_id : "HGNC:30740",
      havana_gene : "OTTHUMG00000012809.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150508062,
      stop : 150513789,
      direction : "+",
      ID : "ENSG00000143369.15",
      gene_id : "ENSG00000143369.15",
      gene_type : "protein_coding",
      gene_name : "ECM1",
      gene_level : 2,
      hgnc_id : "HGNC:3153",
      havana_gene : "OTTHUMG00000012806.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150549369,
      stop : 150560937,
      direction : "+",
      ID : "ENSG00000143382.16",
      gene_id : "ENSG00000143382.16",
      gene_type : "protein_coding",
      gene_name : "ADAMTSL4",
      gene_level : 2,
      hgnc_id : "HGNC:19706",
      havana_gene : "OTTHUMG00000034863.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150560895,
      stop : 150579738,
      direction : "-",
      ID : "ENSG00000143384.14",
      gene_id : "ENSG00000143384.14",
      gene_type : "protein_coding",
      gene_name : "MCL1",
      gene_level : 2,
      hgnc_id : "HGNC:6943",
      havana_gene : "OTTHUMG00000034866.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150600851,
      stop : 150629612,
      direction : "-",
      ID : "ENSG00000143420.19",
      gene_id : "ENSG00000143420.19",
      gene_type : "protein_coding",
      gene_name : "ENSA",
      gene_level : 1,
      hgnc_id : "HGNC:3360",
      havana_gene : "OTTHUMG00000035004.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150646230,
      stop : 150697154,
      direction : "-",
      ID : "ENSG00000143457.11",
      gene_id : "ENSG00000143457.11",
      gene_type : "protein_coding",
      gene_name : "GOLPH3L",
      gene_level : 2,
      hgnc_id : "HGNC:24882",
      havana_gene : "OTTHUMG00000035009.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150698060,
      stop : 150720895,
      direction : "-",
      ID : "ENSG00000143452.16",
      gene_id : "ENSG00000143452.16",
      gene_type : "protein_coding",
      gene_name : "HORMAD1",
      gene_level : 2,
      hgnc_id : "HGNC:25245",
      havana_gene : "OTTHUMG00000035005.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150730079,
      stop : 150765957,
      direction : "-",
      ID : "ENSG00000163131.12",
      gene_id : "ENSG00000163131.12",
      gene_type : "protein_coding",
      gene_name : "CTSS",
      gene_level : 2,
      hgnc_id : "HGNC:2545",
      havana_gene : "OTTHUMG00000035010.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150794880,
      stop : 150809577,
      direction : "-",
      ID : "ENSG00000143387.14",
      gene_id : "ENSG00000143387.14",
      gene_type : "protein_coding",
      gene_name : "CTSK",
      gene_level : 2,
      hgnc_id : "HGNC:2536",
      havana_gene : "OTTHUMG00000035008.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150809713,
      stop : 150876708,
      direction : "-",
      ID : "ENSG00000143437.21",
      gene_id : "ENSG00000143437.21",
      gene_type : "protein_coding",
      gene_name : "ARNT",
      gene_level : 1,
      hgnc_id : "HGNC:700",
      havana_gene : "OTTHUMG00000035011.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150887136,
      stop : 150913292,
      direction : "+",
      ID : "ENSG00000283324.1",
      gene_id : "ENSG00000283324.1",
      gene_type : "protein_coding",
      gene_name : "CTXND2",
      gene_level : 2,
      hgnc_id : "HGNC:53440",
      havana_gene : "OTTHUMG00000191721.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150926263,
      stop : 150964744,
      direction : "+",
      ID : "ENSG00000143379.12",
      gene_id : "ENSG00000143379.12",
      gene_type : "protein_coding",
      gene_name : "SETDB1",
      gene_level : 1,
      hgnc_id : "HGNC:10761",
      havana_gene : "OTTHUMG00000035003.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150960583,
      stop : 150975003,
      direction : "-",
      ID : "ENSG00000143418.20",
      gene_id : "ENSG00000143418.20",
      gene_type : "protein_coding",
      gene_name : "CERS2",
      gene_level : 1,
      hgnc_id : "HGNC:14076",
      havana_gene : "OTTHUMG00000035064.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150982249,
      stop : 150995634,
      direction : "+",
      ID : "ENSG00000143412.10",
      gene_id : "ENSG00000143412.10",
      gene_type : "protein_coding",
      gene_name : "ANXA9",
      gene_level : 2,
      hgnc_id : "HGNC:547",
      havana_gene : "OTTHUMG00000035063.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 150996086,
      stop : 151008375,
      direction : "-",
      ID : "ENSG00000143409.15",
      gene_id : "ENSG00000143409.15",
      gene_type : "protein_coding",
      gene_name : "MINDY1",
      gene_level : 2,
      hgnc_id : "HGNC:25648",
      havana_gene : "OTTHUMG00000035061.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151008420,
      stop : 151035713,
      direction : "+",
      ID : "ENSG00000143363.17",
      gene_id : "ENSG00000143363.17",
      gene_type : "protein_coding",
      gene_name : "PRUNE1",
      gene_level : 2,
      hgnc_id : "HGNC:13420",
      havana_gene : "OTTHUMG00000035062.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151036321,
      stop : 151047720,
      direction : "+",
      ID : "ENSG00000163141.20",
      gene_id : "ENSG00000163141.20",
      gene_type : "protein_coding",
      gene_name : "BNIPL",
      gene_level : 1,
      hgnc_id : "HGNC:16976",
      havana_gene : "OTTHUMG00000035157.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151047751,
      stop : 151051986,
      direction : "+",
      ID : "ENSG00000143443.10",
      gene_id : "ENSG00000143443.10",
      gene_type : "protein_coding",
      gene_name : "C1orf56",
      gene_level : 2,
      hgnc_id : "HGNC:26045",
      havana_gene : "OTTHUMG00000035159.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151050971,
      stop : 151070325,
      direction : "-",
      ID : "ENSG00000197622.13",
      gene_id : "ENSG00000197622.13",
      gene_type : "protein_coding",
      gene_name : "CDC42SE1",
      gene_level : 2,
      hgnc_id : "HGNC:17719",
      havana_gene : "OTTHUMG00000035158.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151060397,
      stop : 151069544,
      direction : "+",
      ID : "ENSG00000213190.4",
      gene_id : "ENSG00000213190.4",
      gene_type : "protein_coding",
      gene_name : "MLLT11",
      gene_level : 2,
      hgnc_id : "HGNC:16997",
      havana_gene : "OTTHUMG00000035160.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151070578,
      stop : 151125542,
      direction : "+",
      ID : "ENSG00000143458.12",
      gene_id : "ENSG00000143458.12",
      gene_type : "protein_coding",
      gene_name : "GABPB2",
      gene_level : 2,
      hgnc_id : "HGNC:28441",
      havana_gene : "OTTHUMG00000012193.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151131685,
      stop : 151146664,
      direction : "-",
      ID : "ENSG00000143434.16",
      gene_id : "ENSG00000143434.16",
      gene_type : "protein_coding",
      gene_name : "SEMA6C",
      gene_level : 2,
      hgnc_id : "HGNC:10740",
      havana_gene : "OTTHUMG00000012261.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151156649,
      stop : 151159749,
      direction : "+",
      ID : "ENSG00000163154.6",
      gene_id : "ENSG00000163154.6",
      gene_type : "protein_coding",
      gene_name : "TNFAIP8L2",
      gene_level : 2,
      hgnc_id : "HGNC:26277",
      havana_gene : "OTTHUMG00000012259.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151156664,
      stop : 151170296,
      direction : "+",
      ID : "ENSG00000163156.12",
      gene_id : "ENSG00000163156.12",
      gene_type : "protein_coding",
      gene_name : "SCNM1",
      gene_level : 2,
      hgnc_id : "HGNC:23136",
      havana_gene : "OTTHUMG00000012258.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151159748,
      stop : 151165948,
      direction : "-",
      ID : "ENSG00000163155.12",
      gene_id : "ENSG00000163155.12",
      gene_type : "protein_coding",
      gene_name : "LYSMD1",
      gene_level : 2,
      hgnc_id : "HGNC:32070",
      havana_gene : "OTTHUMG00000012260.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151169986,
      stop : 151176284,
      direction : "-",
      ID : "ENSG00000163157.15",
      gene_id : "ENSG00000163157.15",
      gene_type : "protein_coding",
      gene_name : "TMOD4",
      gene_level : 1,
      hgnc_id : "HGNC:11874",
      havana_gene : "OTTHUMG00000012350.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151176304,
      stop : 151195321,
      direction : "-",
      ID : "ENSG00000163159.14",
      gene_id : "ENSG00000163159.14",
      gene_type : "protein_coding",
      gene_name : "VPS72",
      gene_level : 1,
      hgnc_id : "HGNC:11644",
      havana_gene : "OTTHUMG00000012345.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151197949,
      stop : 151249536,
      direction : "+",
      ID : "ENSG00000143398.20",
      gene_id : "ENSG00000143398.20",
      gene_type : "protein_coding",
      gene_name : "PIP5K1A",
      gene_level : 1,
      hgnc_id : "HGNC:8994",
      havana_gene : "OTTHUMG00000012351.22",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151254709,
      stop : 151267479,
      direction : "+",
      ID : "ENSG00000159352.16",
      gene_id : "ENSG00000159352.16",
      gene_type : "protein_coding",
      gene_name : "PSMD4",
      gene_level : 1,
      hgnc_id : "HGNC:9561",
      havana_gene : "OTTHUMG00000012349.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151281618,
      stop : 151292176,
      direction : "+",
      ID : "ENSG00000143373.18",
      gene_id : "ENSG00000143373.18",
      gene_type : "protein_coding",
      gene_name : "ZNF687",
      gene_level : 1,
      hgnc_id : "HGNC:29277",
      havana_gene : "OTTHUMG00000012347.13",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151291797,
      stop : 151327715,
      direction : "-",
      ID : "ENSG00000143393.16",
      gene_id : "ENSG00000143393.16",
      gene_type : "protein_coding",
      gene_name : "PI4KB",
      gene_level : 1,
      hgnc_id : "HGNC:8984",
      havana_gene : "OTTHUMG00000012348.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151340640,
      stop : 151347326,
      direction : "-",
      ID : "ENSG00000143390.18",
      gene_id : "ENSG00000143390.18",
      gene_type : "protein_coding",
      gene_name : "RFX5",
      gene_level : 1,
      hgnc_id : "HGNC:9986",
      havana_gene : "OTTHUMG00000012495.24",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151364304,
      stop : 151372707,
      direction : "-",
      ID : "ENSG00000143416.21",
      gene_id : "ENSG00000143416.21",
      gene_type : "protein_coding",
      gene_name : "SELENBP1",
      gene_level : 2,
      hgnc_id : "HGNC:10719",
      havana_gene : "OTTHUMG00000012498.26",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151399560,
      stop : 151401937,
      direction : "+",
      ID : "ENSG00000159377.11",
      gene_id : "ENSG00000159377.11",
      gene_type : "protein_coding",
      gene_name : "PSMB4",
      gene_level : 2,
      hgnc_id : "HGNC:9541",
      havana_gene : "OTTHUMG00000012494.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151402724,
      stop : 151459494,
      direction : "-",
      ID : "ENSG00000143442.22",
      gene_id : "ENSG00000143442.22",
      gene_type : "protein_coding",
      gene_name : "POGZ",
      gene_level : 1,
      hgnc_id : "HGNC:18801",
      havana_gene : "OTTHUMG00000012499.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151510510,
      stop : 151538692,
      direction : "+",
      ID : "ENSG00000143375.15",
      gene_id : "ENSG00000143375.15",
      gene_type : "protein_coding",
      gene_name : "CGN",
      gene_level : 2,
      hgnc_id : "HGNC:17429",
      havana_gene : "OTTHUMG00000012497.16",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151540305,
      stop : 151583583,
      direction : "+",
      ID : "ENSG00000143367.16",
      gene_id : "ENSG00000143367.16",
      gene_type : "protein_coding",
      gene_name : "TUFT1",
      gene_level : 2,
      hgnc_id : "HGNC:12422",
      havana_gene : "OTTHUMG00000012536.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151612006,
      stop : 151699091,
      direction : "+",
      ID : "ENSG00000143376.14",
      gene_id : "ENSG00000143376.14",
      gene_type : "protein_coding",
      gene_name : "SNX27",
      gene_level : 2,
      hgnc_id : "HGNC:20073",
      havana_gene : "OTTHUMG00000013052.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151700058,
      stop : 151716803,
      direction : "-",
      ID : "ENSG00000159409.15",
      gene_id : "ENSG00000159409.15",
      gene_type : "protein_coding",
      gene_name : "CELF3",
      gene_level : 2,
      hgnc_id : "HGNC:11967",
      havana_gene : "OTTHUMG00000013064.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151710433,
      stop : 151729805,
      direction : "+",
      ID : "ENSG00000178796.13",
      gene_id : "ENSG00000178796.13",
      gene_type : "protein_coding",
      gene_name : "RIIAD1",
      gene_level : 1,
      hgnc_id : "HGNC:26686",
      havana_gene : "OTTHUMG00000013055.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151759647,
      stop : 151763496,
      direction : "-",
      ID : "ENSG00000143436.11",
      gene_id : "ENSG00000143436.11",
      gene_type : "protein_coding",
      gene_name : "MRPL9",
      gene_level : 2,
      hgnc_id : "HGNC:14277",
      havana_gene : "OTTHUMG00000013063.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151762899,
      stop : 151771334,
      direction : "+",
      ID : "ENSG00000143450.18",
      gene_id : "ENSG00000143450.18",
      gene_type : "protein_coding",
      gene_name : "OAZ3",
      gene_level : 1,
      hgnc_id : "HGNC:8097",
      havana_gene : "OTTHUMG00000013061.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151770107,
      stop : 151791416,
      direction : "-",
      ID : "ENSG00000182134.16",
      gene_id : "ENSG00000182134.16",
      gene_type : "protein_coding",
      gene_name : "TDRKH",
      gene_level : 1,
      hgnc_id : "HGNC:11713",
      havana_gene : "OTTHUMG00000013062.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151800264,
      stop : 151805419,
      direction : "-",
      ID : "ENSG00000213171.3",
      gene_id : "ENSG00000213171.3",
      gene_type : "protein_coding",
      gene_name : "LINGO4",
      gene_level : 2,
      hgnc_id : "HGNC:31814",
      havana_gene : "OTTHUMG00000013059.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151806071,
      stop : 151831845,
      direction : "-",
      ID : "ENSG00000143365.19",
      gene_id : "ENSG00000143365.19",
      gene_type : "protein_coding",
      gene_name : "RORC",
      gene_level : 2,
      hgnc_id : "HGNC:10260",
      havana_gene : "OTTHUMG00000013053.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151837819,
      stop : 151840557,
      direction : "-",
      ID : "ENSG00000225556.1",
      gene_id : "ENSG00000225556.1",
      gene_type : "protein_coding",
      gene_name : "C2CD4D",
      gene_level : 2,
      hgnc_id : "HGNC:37210",
      havana_gene : "OTTHUMG00000167218.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151847101,
      stop : 151853712,
      direction : "-",
      ID : "ENSG00000196407.12",
      gene_id : "ENSG00000196407.12",
      gene_type : "protein_coding",
      gene_name : "THEM5",
      gene_level : 2,
      hgnc_id : "HGNC:26755",
      havana_gene : "OTTHUMG00000013070.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151870866,
      stop : 151909637,
      direction : "-",
      ID : "ENSG00000159445.13",
      gene_id : "ENSG00000159445.13",
      gene_type : "protein_coding",
      gene_name : "THEM4",
      gene_level : 2,
      hgnc_id : "HGNC:17947",
      havana_gene : "OTTHUMG00000013049.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 151982915,
      stop : 151993859,
      direction : "-",
      ID : "ENSG00000197747.9",
      gene_id : "ENSG00000197747.9",
      gene_type : "protein_coding",
      gene_name : "S100A10",
      gene_level : 2,
      hgnc_id : "HGNC:10487",
      havana_gene : "OTTHUMG00000013068.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152032506,
      stop : 152047907,
      direction : "-",
      ID : "ENSG00000163191.6",
      gene_id : "ENSG00000163191.6",
      gene_type : "protein_coding",
      gene_name : "S100A11",
      gene_level : 2,
      hgnc_id : "HGNC:10488",
      havana_gene : "OTTHUMG00000013069.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152084141,
      stop : 152089064,
      direction : "-",
      ID : "ENSG00000182898.4",
      gene_id : "ENSG00000182898.4",
      gene_type : "protein_coding",
      gene_name : "TCHHL1",
      gene_level : 2,
      hgnc_id : "HGNC:31796",
      havana_gene : "OTTHUMG00000013058.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152106317,
      stop : 152115454,
      direction : "-",
      ID : "ENSG00000159450.12",
      gene_id : "ENSG00000159450.12",
      gene_type : "protein_coding",
      gene_name : "TCHH",
      gene_level : 2,
      hgnc_id : "HGNC:11791",
      havana_gene : "OTTHUMG00000013066.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152153595,
      stop : 152159228,
      direction : "-",
      ID : "ENSG00000215853.3",
      gene_id : "ENSG00000215853.3",
      gene_type : "protein_coding",
      gene_name : "RPTN",
      gene_level : 2,
      hgnc_id : "HGNC:26809",
      havana_gene : "OTTHUMG00000154095.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152212076,
      stop : 152224193,
      direction : "-",
      ID : "ENSG00000197915.7",
      gene_id : "ENSG00000197915.7",
      gene_type : "protein_coding",
      gene_name : "HRNR",
      gene_level : 2,
      hgnc_id : "HGNC:20846",
      havana_gene : "OTTHUMG00000012243.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152302165,
      stop : 152325239,
      direction : "-",
      ID : "ENSG00000143631.11",
      gene_id : "ENSG00000143631.11",
      gene_type : "protein_coding",
      gene_name : "FLG",
      gene_level : 2,
      hgnc_id : "HGNC:3748",
      havana_gene : "OTTHUMG00000012202.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152348735,
      stop : 152360006,
      direction : "-",
      ID : "ENSG00000143520.6",
      gene_id : "ENSG00000143520.6",
      gene_type : "protein_coding",
      gene_name : "FLG2",
      gene_level : 2,
      hgnc_id : "HGNC:33276",
      havana_gene : "OTTHUMG00000012245.15",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152409243,
      stop : 152414263,
      direction : "-",
      ID : "ENSG00000143536.7",
      gene_id : "ENSG00000143536.7",
      gene_type : "protein_coding",
      gene_name : "CRNN",
      gene_level : 2,
      hgnc_id : "HGNC:1230",
      havana_gene : "OTTHUMG00000012383.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152510803,
      stop : 152512177,
      direction : "+",
      ID : "ENSG00000186207.5",
      gene_id : "ENSG00000186207.5",
      gene_type : "protein_coding",
      gene_name : "LCE5A",
      gene_level : 2,
      hgnc_id : "HGNC:16614",
      havana_gene : "OTTHUMG00000014401.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152514482,
      stop : 152516008,
      direction : "+",
      ID : "ENSG00000169509.6",
      gene_id : "ENSG00000169509.6",
      gene_type : "protein_coding",
      gene_name : "CRCT1",
      gene_level : 2,
      hgnc_id : "HGNC:29875",
      havana_gene : "OTTHUMG00000012391.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152565654,
      stop : 152566780,
      direction : "-",
      ID : "ENSG00000185966.4",
      gene_id : "ENSG00000185966.4",
      gene_type : "protein_coding",
      gene_name : "LCE3E",
      gene_level : 2,
      hgnc_id : "HGNC:29463",
      havana_gene : "OTTHUMG00000012393.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152579381,
      stop : 152580516,
      direction : "-",
      ID : "ENSG00000163202.5",
      gene_id : "ENSG00000163202.5",
      gene_type : "protein_coding",
      gene_name : "LCE3D",
      gene_level : 2,
      hgnc_id : "HGNC:16615",
      havana_gene : "OTTHUMG00000012384.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152600662,
      stop : 152601086,
      direction : "+",
      ID : "ENSG00000244057.4",
      gene_id : "ENSG00000244057.4",
      gene_type : "protein_coding",
      gene_name : "LCE3C",
      gene_level : 2,
      hgnc_id : "HGNC:16612",
      havana_gene : "OTTHUMG00000014403.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152613811,
      stop : 152614098,
      direction : "+",
      ID : "ENSG00000187238.5",
      gene_id : "ENSG00000187238.5",
      gene_type : "protein_coding",
      gene_name : "LCE3B",
      gene_level : 2,
      hgnc_id : "HGNC:29462",
      havana_gene : "OTTHUMG00000012395.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152622834,
      stop : 152623103,
      direction : "-",
      ID : "ENSG00000185962.1",
      gene_id : "ENSG00000185962.1",
      gene_type : "protein_coding",
      gene_name : "LCE3A",
      gene_level : 2,
      hgnc_id : "HGNC:29461",
      havana_gene : "OTTHUMG00000012397.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152663380,
      stop : 152664659,
      direction : "+",
      ID : "ENSG00000187223.4",
      gene_id : "ENSG00000187223.4",
      gene_type : "protein_coding",
      gene_name : "LCE2D",
      gene_level : 2,
      hgnc_id : "HGNC:16518",
      havana_gene : "OTTHUMG00000014400.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152675295,
      stop : 152676574,
      direction : "+",
      ID : "ENSG00000187180.3",
      gene_id : "ENSG00000187180.3",
      gene_type : "protein_coding",
      gene_name : "LCE2C",
      gene_level : 2,
      hgnc_id : "HGNC:29460",
      havana_gene : "OTTHUMG00000012389.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152686123,
      stop : 152687397,
      direction : "+",
      ID : "ENSG00000159455.9",
      gene_id : "ENSG00000159455.9",
      gene_type : "protein_coding",
      gene_name : "LCE2B",
      gene_level : 2,
      hgnc_id : "HGNC:16610",
      havana_gene : "OTTHUMG00000012404.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152698345,
      stop : 152699442,
      direction : "+",
      ID : "ENSG00000187173.4",
      gene_id : "ENSG00000187173.4",
      gene_type : "protein_coding",
      gene_name : "LCE2A",
      gene_level : 2,
      hgnc_id : "HGNC:29469",
      havana_gene : "OTTHUMG00000012392.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152708160,
      stop : 152709491,
      direction : "+",
      ID : "ENSG00000187170.5",
      gene_id : "ENSG00000187170.5",
      gene_type : "protein_coding",
      gene_name : "LCE4A",
      gene_level : 2,
      hgnc_id : "HGNC:16613",
      havana_gene : "OTTHUMG00000014394.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152719522,
      stop : 152720470,
      direction : "+",
      ID : "ENSG00000198854.5",
      gene_id : "ENSG00000198854.5",
      gene_type : "protein_coding",
      gene_name : "C1orf68",
      gene_level : 2,
      hgnc_id : "HGNC:29468",
      havana_gene : "OTTHUMG00000012401.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152759561,
      stop : 152762052,
      direction : "+",
      ID : "ENSG00000203786.6",
      gene_id : "ENSG00000203786.6",
      gene_type : "protein_coding",
      gene_name : "KPRP",
      gene_level : 2,
      hgnc_id : "HGNC:31823",
      havana_gene : "OTTHUMG00000012402.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152776372,
      stop : 152776728,
      direction : "+",
      ID : "ENSG00000240386.3",
      gene_id : "ENSG00000240386.3",
      gene_type : "protein_coding",
      gene_name : "LCE1F",
      gene_level : 2,
      hgnc_id : "HGNC:29467",
      havana_gene : "OTTHUMG00000012403.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152786214,
      stop : 152788426,
      direction : "+",
      ID : "ENSG00000186226.9",
      gene_id : "ENSG00000186226.9",
      gene_type : "protein_coding",
      gene_name : "LCE1E",
      gene_level : 2,
      hgnc_id : "HGNC:29466",
      havana_gene : "OTTHUMG00000012405.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152796721,
      stop : 152798181,
      direction : "+",
      ID : "ENSG00000172155.10",
      gene_id : "ENSG00000172155.10",
      gene_type : "protein_coding",
      gene_name : "LCE1D",
      gene_level : 2,
      hgnc_id : "HGNC:29465",
      havana_gene : "OTTHUMG00000012444.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152804835,
      stop : 152806628,
      direction : "-",
      ID : "ENSG00000197084.5",
      gene_id : "ENSG00000197084.5",
      gene_type : "protein_coding",
      gene_name : "LCE1C",
      gene_level : 2,
      hgnc_id : "HGNC:29464",
      havana_gene : "OTTHUMG00000012445.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152811971,
      stop : 152813108,
      direction : "+",
      ID : "ENSG00000196734.9",
      gene_id : "ENSG00000196734.9",
      gene_type : "protein_coding",
      gene_name : "LCE1B",
      gene_level : 2,
      hgnc_id : "HGNC:16611",
      havana_gene : "OTTHUMG00000014402.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152827473,
      stop : 152828097,
      direction : "+",
      ID : "ENSG00000186844.6",
      gene_id : "ENSG00000186844.6",
      gene_type : "protein_coding",
      gene_name : "LCE1A",
      gene_level : 2,
      hgnc_id : "HGNC:29459",
      havana_gene : "OTTHUMG00000012447.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152842856,
      stop : 152843983,
      direction : "+",
      ID : "ENSG00000235942.3",
      gene_id : "ENSG00000235942.3",
      gene_type : "protein_coding",
      gene_name : "LCE6A",
      gene_level : 2,
      hgnc_id : "HGNC:31824",
      havana_gene : "OTTHUMG00000012448.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152859996,
      stop : 152860985,
      direction : "+",
      ID : "ENSG00000285946.1",
      gene_id : "ENSG00000285946.1",
      gene_type : "protein_coding",
      gene_name : "AL162596.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193401.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152878322,
      stop : 152885047,
      direction : "+",
      ID : "ENSG00000163206.6",
      gene_id : "ENSG00000163206.6",
      gene_type : "protein_coding",
      gene_name : "SMCP",
      gene_level : 2,
      hgnc_id : "HGNC:6962",
      havana_gene : "OTTHUMG00000012452.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152908546,
      stop : 152911886,
      direction : "+",
      ID : "ENSG00000163207.7",
      gene_id : "ENSG00000163207.7",
      gene_type : "protein_coding",
      gene_name : "IVL",
      gene_level : 2,
      hgnc_id : "HGNC:6187",
      havana_gene : "OTTHUMG00000012451.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152947154,
      stop : 152949258,
      direction : "+",
      ID : "ENSG00000283227.1",
      gene_id : "ENSG00000283227.1",
      gene_type : "protein_coding",
      gene_name : "SPRR5",
      gene_level : 2,
      hgnc_id : "HGNC:53428",
      havana_gene : "OTTHUMG00000177850.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152970648,
      stop : 152972574,
      direction : "+",
      ID : "ENSG00000184148.4",
      gene_id : "ENSG00000184148.4",
      gene_type : "protein_coding",
      gene_name : "SPRR4",
      gene_level : 2,
      hgnc_id : "HGNC:23173",
      havana_gene : "OTTHUMG00000012450.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 152985231,
      stop : 152985500,
      direction : "+",
      ID : "ENSG00000169474.4",
      gene_id : "ENSG00000169474.4",
      gene_type : "protein_coding",
      gene_name : "SPRR1A",
      gene_level : 2,
      hgnc_id : "HGNC:11259",
      havana_gene : "OTTHUMG00000014404.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153001747,
      stop : 153003856,
      direction : "+",
      ID : "ENSG00000163209.15",
      gene_id : "ENSG00000163209.15",
      gene_type : "protein_coding",
      gene_name : "SPRR3",
      gene_level : 2,
      hgnc_id : "HGNC:11268",
      havana_gene : "OTTHUMG00000013872.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153031203,
      stop : 153032900,
      direction : "+",
      ID : "ENSG00000169469.9",
      gene_id : "ENSG00000169469.9",
      gene_type : "protein_coding",
      gene_name : "SPRR1B",
      gene_level : 2,
      hgnc_id : "HGNC:11260",
      havana_gene : "OTTHUMG00000013869.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153039732,
      stop : 153041931,
      direction : "-",
      ID : "ENSG00000163216.7",
      gene_id : "ENSG00000163216.7",
      gene_type : "protein_coding",
      gene_name : "SPRR2D",
      gene_level : 2,
      hgnc_id : "HGNC:11264",
      havana_gene : "OTTHUMG00000014396.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153056120,
      stop : 153057512,
      direction : "-",
      ID : "ENSG00000241794.2",
      gene_id : "ENSG00000241794.2",
      gene_type : "protein_coding",
      gene_name : "SPRR2A",
      gene_level : 2,
      hgnc_id : "HGNC:11261",
      havana_gene : "OTTHUMG00000014395.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153070224,
      stop : 153070840,
      direction : "-",
      ID : "ENSG00000196805.7",
      gene_id : "ENSG00000196805.7",
      gene_type : "protein_coding",
      gene_name : "SPRR2B",
      gene_level : 2,
      hgnc_id : "HGNC:11262",
      havana_gene : "OTTHUMG00000013863.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153093135,
      stop : 153106184,
      direction : "-",
      ID : "ENSG00000203785.9",
      gene_id : "ENSG00000203785.9",
      gene_type : "protein_coding",
      gene_name : "SPRR2E",
      gene_level : 2,
      hgnc_id : "HGNC:11265",
      havana_gene : "OTTHUMG00000014397.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153112121,
      stop : 153113516,
      direction : "-",
      ID : "ENSG00000244094.2",
      gene_id : "ENSG00000244094.2",
      gene_type : "protein_coding",
      gene_name : "SPRR2F",
      gene_level : 2,
      hgnc_id : "HGNC:11266",
      havana_gene : "OTTHUMG00000014398.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153149582,
      stop : 153150890,
      direction : "-",
      ID : "ENSG00000159516.9",
      gene_id : "ENSG00000159516.9",
      gene_type : "protein_coding",
      gene_name : "SPRR2G",
      gene_level : 2,
      hgnc_id : "HGNC:11267",
      havana_gene : "OTTHUMG00000014399.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153203430,
      stop : 153205120,
      direction : "+",
      ID : "ENSG00000203784.3",
      gene_id : "ENSG00000203784.3",
      gene_type : "protein_coding",
      gene_name : "LELP1",
      gene_level : 2,
      hgnc_id : "HGNC:32046",
      havana_gene : "OTTHUMG00000013935.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153217584,
      stop : 153219310,
      direction : "+",
      ID : "ENSG00000203783.5",
      gene_id : "ENSG00000203783.5",
      gene_type : "protein_coding",
      gene_name : "PRR9",
      gene_level : 2,
      hgnc_id : "HGNC:32057",
      havana_gene : "OTTHUMG00000013936.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153259687,
      stop : 153262124,
      direction : "+",
      ID : "ENSG00000203782.6",
      gene_id : "ENSG00000203782.6",
      gene_type : "protein_coding",
      gene_name : "LORICRIN",
      gene_level : 2,
      hgnc_id : "HGNC:6663",
      havana_gene : "OTTHUMG00000013938.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153297862,
      stop : 153310718,
      direction : "-",
      ID : "ENSG00000159527.3",
      gene_id : "ENSG00000159527.3",
      gene_type : "protein_coding",
      gene_name : "PGLYRP3",
      gene_level : 2,
      hgnc_id : "HGNC:30014",
      havana_gene : "OTTHUMG00000014044.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153330120,
      stop : 153348841,
      direction : "-",
      ID : "ENSG00000163218.15",
      gene_id : "ENSG00000163218.15",
      gene_type : "protein_coding",
      gene_name : "PGLYRP4",
      gene_level : 2,
      hgnc_id : "HGNC:30015",
      havana_gene : "OTTHUMG00000037057.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153357854,
      stop : 153361023,
      direction : "+",
      ID : "ENSG00000163220.11",
      gene_id : "ENSG00000163220.11",
      gene_type : "protein_coding",
      gene_name : "S100A9",
      gene_level : 2,
      hgnc_id : "HGNC:10499",
      havana_gene : "OTTHUMG00000013125.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153373711,
      stop : 153375621,
      direction : "-",
      ID : "ENSG00000163221.9",
      gene_id : "ENSG00000163221.9",
      gene_type : "protein_coding",
      gene_name : "S100A12",
      gene_level : 2,
      hgnc_id : "HGNC:10489",
      havana_gene : "OTTHUMG00000013127.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153390032,
      stop : 153391073,
      direction : "-",
      ID : "ENSG00000143546.10",
      gene_id : "ENSG00000143546.10",
      gene_type : "protein_coding",
      gene_name : "S100A8",
      gene_level : 2,
      hgnc_id : "HGNC:10498",
      havana_gene : "OTTHUMG00000013124.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153416520,
      stop : 153423222,
      direction : "+",
      ID : "ENSG00000184330.12",
      gene_id : "ENSG00000184330.12",
      gene_type : "protein_coding",
      gene_name : "S100A7A",
      gene_level : 2,
      hgnc_id : "HGNC:21657",
      havana_gene : "OTTHUMG00000013122.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153437058,
      stop : 153439949,
      direction : "-",
      ID : "ENSG00000197364.7",
      gene_id : "ENSG00000197364.7",
      gene_type : "protein_coding",
      gene_name : "S100A7L2",
      gene_level : 2,
      hgnc_id : "HGNC:21655",
      havana_gene : "OTTHUMG00000013129.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153457744,
      stop : 153460651,
      direction : "-",
      ID : "ENSG00000143556.9",
      gene_id : "ENSG00000143556.9",
      gene_type : "protein_coding",
      gene_name : "S100A7",
      gene_level : 2,
      hgnc_id : "HGNC:10497",
      havana_gene : "OTTHUMG00000013123.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153534599,
      stop : 153536244,
      direction : "-",
      ID : "ENSG00000197956.10",
      gene_id : "ENSG00000197956.10",
      gene_type : "protein_coding",
      gene_name : "S100A6",
      gene_level : 2,
      hgnc_id : "HGNC:10496",
      havana_gene : "OTTHUMG00000013549.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153537147,
      stop : 153541765,
      direction : "-",
      ID : "ENSG00000196420.7",
      gene_id : "ENSG00000196420.7",
      gene_type : "protein_coding",
      gene_name : "S100A5",
      gene_level : 2,
      hgnc_id : "HGNC:10495",
      havana_gene : "OTTHUMG00000013547.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153543613,
      stop : 153550136,
      direction : "-",
      ID : "ENSG00000196154.12",
      gene_id : "ENSG00000196154.12",
      gene_type : "protein_coding",
      gene_name : "S100A4",
      gene_level : 2,
      hgnc_id : "HGNC:10494",
      havana_gene : "OTTHUMG00000013546.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153547329,
      stop : 153549258,
      direction : "-",
      ID : "ENSG00000188015.10",
      gene_id : "ENSG00000188015.10",
      gene_type : "protein_coding",
      gene_name : "S100A3",
      gene_level : 2,
      hgnc_id : "HGNC:10493",
      havana_gene : "OTTHUMG00000013550.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153561108,
      stop : 153567890,
      direction : "-",
      ID : "ENSG00000196754.13",
      gene_id : "ENSG00000196754.13",
      gene_type : "protein_coding",
      gene_name : "S100A2",
      gene_level : 1,
      hgnc_id : "HGNC:10492",
      havana_gene : "OTTHUMG00000035031.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153606886,
      stop : 153613145,
      direction : "-",
      ID : "ENSG00000188643.11",
      gene_id : "ENSG00000188643.11",
      gene_type : "protein_coding",
      gene_name : "S100A16",
      gene_level : 2,
      hgnc_id : "HGNC:20441",
      havana_gene : "OTTHUMG00000013545.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153614255,
      stop : 153616986,
      direction : "-",
      ID : "ENSG00000189334.9",
      gene_id : "ENSG00000189334.9",
      gene_type : "protein_coding",
      gene_name : "S100A14",
      gene_level : 2,
      hgnc_id : "HGNC:18901",
      havana_gene : "OTTHUMG00000035030.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153618787,
      stop : 153631360,
      direction : "-",
      ID : "ENSG00000189171.14",
      gene_id : "ENSG00000189171.14",
      gene_type : "protein_coding",
      gene_name : "S100A13",
      gene_level : 2,
      hgnc_id : "HGNC:10490",
      havana_gene : "OTTHUMG00000036641.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153627926,
      stop : 153632039,
      direction : "+",
      ID : "ENSG00000160678.12",
      gene_id : "ENSG00000160678.12",
      gene_type : "protein_coding",
      gene_name : "S100A1",
      gene_level : 2,
      hgnc_id : "HGNC:10486",
      havana_gene : "OTTHUMG00000037041.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153633982,
      stop : 153646306,
      direction : "+",
      ID : "ENSG00000160679.13",
      gene_id : "ENSG00000160679.13",
      gene_type : "protein_coding",
      gene_name : "CHTOP",
      gene_level : 2,
      hgnc_id : "HGNC:24511",
      havana_gene : "OTTHUMG00000037052.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153658703,
      stop : 153661852,
      direction : "+",
      ID : "ENSG00000143553.11",
      gene_id : "ENSG00000143553.11",
      gene_type : "protein_coding",
      gene_name : "SNAPIN",
      gene_level : 2,
      hgnc_id : "HGNC:17145",
      havana_gene : "OTTHUMG00000037086.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153661788,
      stop : 153671028,
      direction : "-",
      ID : "ENSG00000143621.17",
      gene_id : "ENSG00000143621.17",
      gene_type : "protein_coding",
      gene_name : "ILF2",
      gene_level : 2,
      hgnc_id : "HGNC:6037",
      havana_gene : "OTTHUMG00000037087.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153678688,
      stop : 153693992,
      direction : "+",
      ID : "ENSG00000169418.10",
      gene_id : "ENSG00000169418.10",
      gene_type : "protein_coding",
      gene_name : "NPR1",
      gene_level : 2,
      hgnc_id : "HGNC:7943",
      havana_gene : "OTTHUMG00000037085.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153728050,
      stop : 153774808,
      direction : "+",
      ID : "ENSG00000143624.14",
      gene_id : "ENSG00000143624.14",
      gene_type : "protein_coding",
      gene_name : "INTS3",
      gene_level : 2,
      hgnc_id : "HGNC:26153",
      havana_gene : "OTTHUMG00000037089.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153774354,
      stop : 153780157,
      direction : "+",
      ID : "ENSG00000143554.14",
      gene_id : "ENSG00000143554.14",
      gene_type : "protein_coding",
      gene_name : "SLC27A3",
      gene_level : 1,
      hgnc_id : "HGNC:10997",
      havana_gene : "OTTHUMG00000037155.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153789030,
      stop : 153923360,
      direction : "-",
      ID : "ENSG00000143614.10",
      gene_id : "ENSG00000143614.10",
      gene_type : "protein_coding",
      gene_name : "GATAD2B",
      gene_level : 2,
      hgnc_id : "HGNC:30778",
      havana_gene : "OTTHUMG00000037162.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153929501,
      stop : 153946718,
      direction : "-",
      ID : "ENSG00000198837.10",
      gene_id : "ENSG00000198837.10",
      gene_type : "protein_coding",
      gene_name : "DENND4B",
      gene_level : 1,
      hgnc_id : "HGNC:29044",
      havana_gene : "OTTHUMG00000037157.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153947669,
      stop : 153958615,
      direction : "-",
      ID : "ENSG00000160741.17",
      gene_id : "ENSG00000160741.17",
      gene_type : "protein_coding",
      gene_name : "CRTC2",
      gene_level : 1,
      hgnc_id : "HGNC:27301",
      havana_gene : "OTTHUMG00000037156.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153959099,
      stop : 153968184,
      direction : "-",
      ID : "ENSG00000143570.19",
      gene_id : "ENSG00000143570.19",
      gene_type : "protein_coding",
      gene_name : "SLC39A1",
      gene_level : 2,
      hgnc_id : "HGNC:12876",
      havana_gene : "OTTHUMG00000037158.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153959151,
      stop : 153975887,
      direction : "-",
      ID : "ENSG00000285779.1",
      gene_id : "ENSG00000285779.1",
      gene_type : "protein_coding",
      gene_name : "AL358472.7",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193417.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153967534,
      stop : 153974361,
      direction : "+",
      ID : "ENSG00000143578.16",
      gene_id : "ENSG00000143578.16",
      gene_type : "protein_coding",
      gene_name : "CREB3L4",
      gene_level : 2,
      hgnc_id : "HGNC:18854",
      havana_gene : "OTTHUMG00000037159.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153974269,
      stop : 153977674,
      direction : "-",
      ID : "ENSG00000143543.15",
      gene_id : "ENSG00000143543.15",
      gene_type : "protein_coding",
      gene_name : "JTB",
      gene_level : 2,
      hgnc_id : "HGNC:6201",
      havana_gene : "OTTHUMG00000036590.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153975850,
      stop : 153986246,
      direction : "-",
      ID : "ENSG00000285641.1",
      gene_id : "ENSG00000285641.1",
      gene_type : "protein_coding",
      gene_name : "AL358472.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193418.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153981617,
      stop : 153986358,
      direction : "-",
      ID : "ENSG00000143545.10",
      gene_id : "ENSG00000143545.10",
      gene_type : "protein_coding",
      gene_name : "RAB13",
      gene_level : 2,
      hgnc_id : "HGNC:9762",
      havana_gene : "OTTHUMG00000036589.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153990762,
      stop : 153992155,
      direction : "+",
      ID : "ENSG00000177954.14",
      gene_id : "ENSG00000177954.14",
      gene_type : "protein_coding",
      gene_name : "RPS27",
      gene_level : 2,
      hgnc_id : "HGNC:10416",
      havana_gene : "OTTHUMG00000036591.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 153992685,
      stop : 154155116,
      direction : "-",
      ID : "ENSG00000143552.9",
      gene_id : "ENSG00000143552.9",
      gene_type : "protein_coding",
      gene_name : "NUP210L",
      gene_level : 2,
      hgnc_id : "HGNC:29915",
      havana_gene : "OTTHUMG00000035852.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154155304,
      stop : 154194648,
      direction : "-",
      ID : "ENSG00000143549.21",
      gene_id : "ENSG00000143549.21",
      gene_type : "protein_coding",
      gene_name : "TPM3",
      gene_level : 2,
      hgnc_id : "HGNC:12012",
      havana_gene : "OTTHUMG00000035853.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154199085,
      stop : 154206333,
      direction : "-",
      ID : "ENSG00000163263.7",
      gene_id : "ENSG00000163263.7",
      gene_type : "protein_coding",
      gene_name : "C1orf189",
      gene_level : 2,
      hgnc_id : "HGNC:32305",
      havana_gene : "OTTHUMG00000035982.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154206696,
      stop : 154220637,
      direction : "-",
      ID : "ENSG00000143612.21",
      gene_id : "ENSG00000143612.21",
      gene_type : "protein_coding",
      gene_name : "C1orf43",
      gene_level : 2,
      hgnc_id : "HGNC:29876",
      havana_gene : "OTTHUMG00000035981.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154220179,
      stop : 154271510,
      direction : "+",
      ID : "ENSG00000143569.19",
      gene_id : "ENSG00000143569.19",
      gene_type : "protein_coding",
      gene_name : "UBAP2L",
      gene_level : 2,
      hgnc_id : "HGNC:29877",
      havana_gene : "OTTHUMG00000035983.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154272589,
      stop : 154275875,
      direction : "+",
      ID : "ENSG00000143575.15",
      gene_id : "ENSG00000143575.15",
      gene_type : "protein_coding",
      gene_name : "HAX1",
      gene_level : 2,
      hgnc_id : "HGNC:16915",
      havana_gene : "OTTHUMG00000035978.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154321090,
      stop : 154325325,
      direction : "+",
      ID : "ENSG00000143595.13",
      gene_id : "ENSG00000143595.13",
      gene_type : "protein_coding",
      gene_name : "AQP10",
      gene_level : 2,
      hgnc_id : "HGNC:16029",
      havana_gene : "OTTHUMG00000035980.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154325525,
      stop : 154351304,
      direction : "+",
      ID : "ENSG00000143515.19",
      gene_id : "ENSG00000143515.19",
      gene_type : "protein_coding",
      gene_name : "ATP8B2",
      gene_level : 2,
      hgnc_id : "HGNC:13534",
      havana_gene : "OTTHUMG00000035979.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154405193,
      stop : 154469450,
      direction : "+",
      ID : "ENSG00000160712.13",
      gene_id : "ENSG00000160712.13",
      gene_type : "protein_coding",
      gene_name : "IL6R",
      gene_level : 2,
      hgnc_id : "HGNC:6019",
      havana_gene : "OTTHUMG00000036073.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154469772,
      stop : 154502412,
      direction : "-",
      ID : "ENSG00000169291.10",
      gene_id : "ENSG00000169291.10",
      gene_type : "protein_coding",
      gene_name : "SHE",
      gene_level : 1,
      hgnc_id : "HGNC:27004",
      havana_gene : "OTTHUMG00000036072.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154502219,
      stop : 154548147,
      direction : "+",
      ID : "ENSG00000163239.12",
      gene_id : "ENSG00000163239.12",
      gene_type : "protein_coding",
      gene_name : "TDRD10",
      gene_level : 2,
      hgnc_id : "HGNC:25316",
      havana_gene : "OTTHUMG00000037264.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154548577,
      stop : 154559028,
      direction : "-",
      ID : "ENSG00000160714.10",
      gene_id : "ENSG00000160714.10",
      gene_type : "protein_coding",
      gene_name : "UBE2Q1",
      gene_level : 2,
      hgnc_id : "HGNC:15698",
      havana_gene : "OTTHUMG00000037265.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154567778,
      stop : 154580013,
      direction : "+",
      ID : "ENSG00000160716.6",
      gene_id : "ENSG00000160716.6",
      gene_type : "protein_coding",
      gene_name : "CHRNB2",
      gene_level : 2,
      hgnc_id : "HGNC:1962",
      havana_gene : "OTTHUMG00000037262.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154581695,
      stop : 154628013,
      direction : "-",
      ID : "ENSG00000160710.18",
      gene_id : "ENSG00000160710.18",
      gene_type : "protein_coding",
      gene_name : "ADAR",
      gene_level : 1,
      hgnc_id : "HGNC:225",
      havana_gene : "OTTHUMG00000037261.16",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154697455,
      stop : 154870281,
      direction : "-",
      ID : "ENSG00000143603.19",
      gene_id : "ENSG00000143603.19",
      gene_type : "protein_coding",
      gene_name : "KCNN3",
      gene_level : 2,
      hgnc_id : "HGNC:6292",
      havana_gene : "OTTHUMG00000037260.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154924740,
      stop : 154936719,
      direction : "-",
      ID : "ENSG00000163344.6",
      gene_id : "ENSG00000163344.6",
      gene_type : "protein_coding",
      gene_name : "PMVK",
      gene_level : 2,
      hgnc_id : "HGNC:9141",
      havana_gene : "OTTHUMG00000037415.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154944076,
      stop : 154956123,
      direction : "-",
      ID : "ENSG00000163346.17",
      gene_id : "ENSG00000163346.17",
      gene_type : "protein_coding",
      gene_name : "PBXIP1",
      gene_level : 2,
      hgnc_id : "HGNC:21199",
      havana_gene : "OTTHUMG00000037369.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154957026,
      stop : 154963853,
      direction : "-",
      ID : "ENSG00000163348.4",
      gene_id : "ENSG00000163348.4",
      gene_type : "protein_coding",
      gene_name : "PYGO2",
      gene_level : 2,
      hgnc_id : "HGNC:30257",
      havana_gene : "OTTHUMG00000037370.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154962298,
      stop : 154974395,
      direction : "-",
      ID : "ENSG00000160691.19",
      gene_id : "ENSG00000160691.19",
      gene_type : "protein_coding",
      gene_name : "SHC1",
      gene_level : 2,
      hgnc_id : "HGNC:10840",
      havana_gene : "OTTHUMG00000037295.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154974653,
      stop : 154979251,
      direction : "+",
      ID : "ENSG00000173207.13",
      gene_id : "ENSG00000173207.13",
      gene_type : "protein_coding",
      gene_name : "CKS1B",
      gene_level : 2,
      hgnc_id : "HGNC:19083",
      havana_gene : "OTTHUMG00000037413.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154983338,
      stop : 154993111,
      direction : "+",
      ID : "ENSG00000160688.19",
      gene_id : "ENSG00000160688.19",
      gene_type : "protein_coding",
      gene_name : "FLAD1",
      gene_level : 2,
      hgnc_id : "HGNC:24671",
      havana_gene : "OTTHUMG00000037416.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 154993586,
      stop : 154994315,
      direction : "+",
      ID : "ENSG00000163352.5",
      gene_id : "ENSG00000163352.5",
      gene_type : "protein_coding",
      gene_name : "LENEP",
      gene_level : 2,
      hgnc_id : "HGNC:14429",
      havana_gene : "OTTHUMG00000037417.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155002630,
      stop : 155018522,
      direction : "+",
      ID : "ENSG00000160685.13",
      gene_id : "ENSG00000160685.13",
      gene_type : "protein_coding",
      gene_name : "ZBTB7B",
      gene_level : 2,
      hgnc_id : "HGNC:18668",
      havana_gene : "OTTHUMG00000037414.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155018520,
      stop : 155033781,
      direction : "-",
      ID : "ENSG00000163354.15",
      gene_id : "ENSG00000163354.15",
      gene_type : "protein_coding",
      gene_name : "DCST2",
      gene_level : 2,
      hgnc_id : "HGNC:26562",
      havana_gene : "OTTHUMG00000037371.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155033824,
      stop : 155050930,
      direction : "+",
      ID : "ENSG00000163357.11",
      gene_id : "ENSG00000163357.11",
      gene_type : "protein_coding",
      gene_name : "DCST1",
      gene_level : 2,
      hgnc_id : "HGNC:26539",
      havana_gene : "OTTHUMG00000041314.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155050566,
      stop : 155062775,
      direction : "+",
      ID : "ENSG00000143537.14",
      gene_id : "ENSG00000143537.14",
      gene_type : "protein_coding",
      gene_name : "ADAM15",
      gene_level : 2,
      hgnc_id : "HGNC:193",
      havana_gene : "OTTHUMG00000013898.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155063737,
      stop : 155069553,
      direction : "+",
      ID : "ENSG00000243364.8",
      gene_id : "ENSG00000243364.8",
      gene_type : "protein_coding",
      gene_name : "EFNA4",
      gene_level : 2,
      hgnc_id : "HGNC:3224",
      havana_gene : "OTTHUMG00000035309.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155063748,
      stop : 155086807,
      direction : "+",
      ID : "ENSG00000251246.1",
      gene_id : "ENSG00000251246.1",
      gene_type : "protein_coding",
      gene_name : "AL691442.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000161134.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155078837,
      stop : 155087538,
      direction : "+",
      ID : "ENSG00000143590.14",
      gene_id : "ENSG00000143590.14",
      gene_type : "protein_coding",
      gene_name : "EFNA3",
      gene_level : 2,
      hgnc_id : "HGNC:3223",
      havana_gene : "OTTHUMG00000035313.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155127876,
      stop : 155134899,
      direction : "+",
      ID : "ENSG00000169242.12",
      gene_id : "ENSG00000169242.12",
      gene_type : "protein_coding",
      gene_name : "EFNA1",
      gene_level : 2,
      hgnc_id : "HGNC:3221",
      havana_gene : "OTTHUMG00000035312.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155135344,
      stop : 155138857,
      direction : "+",
      ID : "ENSG00000169241.19",
      gene_id : "ENSG00000169241.19",
      gene_type : "protein_coding",
      gene_name : "SLC50A1",
      gene_level : 2,
      hgnc_id : "HGNC:30657",
      havana_gene : "OTTHUMG00000035333.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155139891,
      stop : 155140595,
      direction : "-",
      ID : "ENSG00000179085.8",
      gene_id : "ENSG00000179085.8",
      gene_type : "protein_coding",
      gene_name : "DPM3",
      gene_level : 2,
      hgnc_id : "HGNC:3007",
      havana_gene : "OTTHUMG00000035335.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155169408,
      stop : 155173475,
      direction : "-",
      ID : "ENSG00000163463.13",
      gene_id : "ENSG00000163463.13",
      gene_type : "protein_coding",
      gene_name : "KRTCAP2",
      gene_level : 2,
      hgnc_id : "HGNC:28942",
      havana_gene : "OTTHUMG00000013904.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155169409,
      stop : 155187272,
      direction : "-",
      ID : "ENSG00000273088.2",
      gene_id : "ENSG00000273088.2",
      gene_type : "protein_coding",
      gene_name : "AL713999.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185855.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155173787,
      stop : 155184971,
      direction : "+",
      ID : "ENSG00000163462.18",
      gene_id : "ENSG00000163462.18",
      gene_type : "protein_coding",
      gene_name : "TRIM46",
      gene_level : 2,
      hgnc_id : "HGNC:19019",
      havana_gene : "OTTHUMG00000035680.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155185824,
      stop : 155192916,
      direction : "-",
      ID : "ENSG00000185499.16",
      gene_id : "ENSG00000185499.16",
      gene_type : "protein_coding",
      gene_name : "MUC1",
      gene_level : 1,
      hgnc_id : "HGNC:7508",
      havana_gene : "OTTHUMG00000035681.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155195588,
      stop : 155209051,
      direction : "-",
      ID : "ENSG00000169231.13",
      gene_id : "ENSG00000169231.13",
      gene_type : "protein_coding",
      gene_name : "THBS3",
      gene_level : 2,
      hgnc_id : "HGNC:11787",
      havana_gene : "OTTHUMG00000035710.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155208695,
      stop : 155213824,
      direction : "+",
      ID : "ENSG00000173171.15",
      gene_id : "ENSG00000173171.15",
      gene_type : "protein_coding",
      gene_name : "MTX1",
      gene_level : 2,
      hgnc_id : "HGNC:7504",
      havana_gene : "OTTHUMG00000035708.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155234452,
      stop : 155244699,
      direction : "-",
      ID : "ENSG00000177628.16",
      gene_id : "ENSG00000177628.16",
      gene_type : "protein_coding",
      gene_name : "GBA",
      gene_level : 2,
      hgnc_id : "HGNC:4177",
      havana_gene : "OTTHUMG00000035841.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155247205,
      stop : 155255483,
      direction : "-",
      ID : "ENSG00000160767.21",
      gene_id : "ENSG00000160767.21",
      gene_type : "protein_coding",
      gene_name : "FAM189B",
      gene_level : 1,
      hgnc_id : "HGNC:1233",
      havana_gene : "OTTHUMG00000035844.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155255979,
      stop : 155262430,
      direction : "-",
      ID : "ENSG00000116521.11",
      gene_id : "ENSG00000116521.11",
      gene_type : "protein_coding",
      gene_name : "SCAMP3",
      gene_level : 2,
      hgnc_id : "HGNC:10565",
      havana_gene : "OTTHUMG00000035874.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155262868,
      stop : 155278491,
      direction : "-",
      ID : "ENSG00000176444.19",
      gene_id : "ENSG00000176444.19",
      gene_type : "protein_coding",
      gene_name : "CLK2",
      gene_level : 2,
      hgnc_id : "HGNC:2069",
      havana_gene : "OTTHUMG00000035873.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155277463,
      stop : 155289848,
      direction : "+",
      ID : "ENSG00000143630.10",
      gene_id : "ENSG00000143630.10",
      gene_type : "protein_coding",
      gene_name : "HCN3",
      gene_level : 2,
      hgnc_id : "HGNC:19183",
      havana_gene : "OTTHUMG00000035872.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155289293,
      stop : 155301438,
      direction : "-",
      ID : "ENSG00000143627.19",
      gene_id : "ENSG00000143627.19",
      gene_type : "protein_coding",
      gene_name : "PKLR",
      gene_level : 2,
      hgnc_id : "HGNC:9020",
      havana_gene : "OTTHUMG00000035875.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155308748,
      stop : 155320666,
      direction : "+",
      ID : "ENSG00000160752.15",
      gene_id : "ENSG00000160752.15",
      gene_type : "protein_coding",
      gene_name : "FDPS",
      gene_level : 2,
      hgnc_id : "HGNC:3631",
      havana_gene : "OTTHUMG00000013909.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155320894,
      stop : 155331114,
      direction : "+",
      ID : "ENSG00000160753.16",
      gene_id : "ENSG00000160753.16",
      gene_type : "protein_coding",
      gene_name : "RUSC1",
      gene_level : 2,
      hgnc_id : "HGNC:17153",
      havana_gene : "OTTHUMG00000013910.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155335268,
      stop : 155563162,
      direction : "-",
      ID : "ENSG00000116539.14",
      gene_id : "ENSG00000116539.14",
      gene_type : "protein_coding",
      gene_name : "ASH1L",
      gene_level : 2,
      hgnc_id : "HGNC:19088",
      havana_gene : "OTTHUMG00000014011.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155610205,
      stop : 155614951,
      direction : "+",
      ID : "ENSG00000125459.17",
      gene_id : "ENSG00000125459.17",
      gene_type : "protein_coding",
      gene_name : "MSTO1",
      gene_level : 2,
      hgnc_id : "HGNC:29678",
      havana_gene : "OTTHUMG00000014014.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155659443,
      stop : 155689000,
      direction : "-",
      ID : "ENSG00000163374.20",
      gene_id : "ENSG00000163374.20",
      gene_type : "protein_coding",
      gene_name : "YY1AP1",
      gene_level : 1,
      hgnc_id : "HGNC:30935",
      havana_gene : "OTTHUMG00000035437.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155687960,
      stop : 155739010,
      direction : "+",
      ID : "ENSG00000132676.16",
      gene_id : "ENSG00000132676.16",
      gene_type : "protein_coding",
      gene_name : "DAP3",
      gene_level : 2,
      hgnc_id : "HGNC:2673",
      havana_gene : "OTTHUMG00000035439.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155749659,
      stop : 155859400,
      direction : "-",
      ID : "ENSG00000116580.19",
      gene_id : "ENSG00000116580.19",
      gene_type : "protein_coding",
      gene_name : "GON4L",
      gene_level : 2,
      hgnc_id : "HGNC:25973",
      havana_gene : "OTTHUMG00000014106.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155859567,
      stop : 155885199,
      direction : "+",
      ID : "ENSG00000132718.9",
      gene_id : "ENSG00000132718.9",
      gene_type : "protein_coding",
      gene_name : "SYT11",
      gene_level : 2,
      hgnc_id : "HGNC:19239",
      havana_gene : "OTTHUMG00000014105.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155897808,
      stop : 155911404,
      direction : "-",
      ID : "ENSG00000143622.11",
      gene_id : "ENSG00000143622.11",
      gene_type : "protein_coding",
      gene_name : "RIT1",
      gene_level : 2,
      hgnc_id : "HGNC:10023",
      havana_gene : "OTTHUMG00000014104.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155913045,
      stop : 155934413,
      direction : "-",
      ID : "ENSG00000132680.11",
      gene_id : "ENSG00000132680.11",
      gene_type : "protein_coding",
      gene_name : "KHDC4",
      gene_level : 2,
      hgnc_id : "HGNC:29145",
      havana_gene : "OTTHUMG00000014103.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155941638,
      stop : 155943087,
      direction : "+",
      ID : "ENSG00000173080.6",
      gene_id : "ENSG00000173080.6",
      gene_type : "protein_coding",
      gene_name : "RXFP4",
      gene_level : 2,
      hgnc_id : "HGNC:14666",
      havana_gene : "OTTHUMG00000017463.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 155946851,
      stop : 156007070,
      direction : "-",
      ID : "ENSG00000116584.20",
      gene_id : "ENSG00000116584.20",
      gene_type : "protein_coding",
      gene_name : "ARHGEF2",
      gene_level : 2,
      hgnc_id : "HGNC:682",
      havana_gene : "OTTHUMG00000017464.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156009048,
      stop : 156020951,
      direction : "-",
      ID : "ENSG00000163479.14",
      gene_id : "ENSG00000163479.14",
      gene_type : "protein_coding",
      gene_name : "SSR2",
      gene_level : 1,
      hgnc_id : "HGNC:11324",
      havana_gene : "OTTHUMG00000017456.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156035299,
      stop : 156053798,
      direction : "-",
      ID : "ENSG00000160803.8",
      gene_id : "ENSG00000160803.8",
      gene_type : "protein_coding",
      gene_name : "UBQLN4",
      gene_level : 2,
      hgnc_id : "HGNC:1237",
      havana_gene : "OTTHUMG00000017461.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156054782,
      stop : 156058506,
      direction : "+",
      ID : "ENSG00000116586.12",
      gene_id : "ENSG00000116586.12",
      gene_type : "protein_coding",
      gene_name : "LAMTOR2",
      gene_level : 2,
      hgnc_id : "HGNC:29796",
      havana_gene : "OTTHUMG00000017462.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156061160,
      stop : 156070504,
      direction : "+",
      ID : "ENSG00000132698.15",
      gene_id : "ENSG00000132698.15",
      gene_type : "protein_coding",
      gene_name : "RAB25",
      gene_level : 2,
      hgnc_id : "HGNC:18238",
      havana_gene : "OTTHUMG00000017457.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156072013,
      stop : 156082465,
      direction : "-",
      ID : "ENSG00000254726.3",
      gene_id : "ENSG00000254726.3",
      gene_type : "protein_coding",
      gene_name : "MEX3A",
      gene_level : 2,
      hgnc_id : "HGNC:33482",
      havana_gene : "OTTHUMG00000017465.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156082573,
      stop : 156140081,
      direction : "+",
      ID : "ENSG00000160789.23",
      gene_id : "ENSG00000160789.23",
      gene_type : "protein_coding",
      gene_name : "LMNA",
      gene_level : 1,
      hgnc_id : "HGNC:6636",
      havana_gene : "OTTHUMG00000013961.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156147366,
      stop : 156177752,
      direction : "+",
      ID : "ENSG00000196189.13",
      gene_id : "ENSG00000196189.13",
      gene_type : "protein_coding",
      gene_name : "SEMA4A",
      gene_level : 2,
      hgnc_id : "HGNC:10729",
      havana_gene : "OTTHUMG00000014042.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156193932,
      stop : 156212796,
      direction : "+",
      ID : "ENSG00000160785.13",
      gene_id : "ENSG00000160785.13",
      gene_type : "protein_coding",
      gene_name : "SLC25A44",
      gene_level : 2,
      hgnc_id : "HGNC:29036",
      havana_gene : "OTTHUMG00000014816.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156212982,
      stop : 156243332,
      direction : "+",
      ID : "ENSG00000260238.6",
      gene_id : "ENSG00000260238.6",
      gene_type : "protein_coding",
      gene_name : "PMF1-BGLAP",
      gene_level : 2,
      hgnc_id : "HGNC:42953",
      havana_gene : "OTTHUMG00000014817.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156212993,
      stop : 156240042,
      direction : "+",
      ID : "ENSG00000160783.19",
      gene_id : "ENSG00000160783.19",
      gene_type : "protein_coding",
      gene_name : "PMF1",
      gene_level : 1,
      hgnc_id : "HGNC:9112",
      havana_gene : "OTTHUMG00000177123.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156242184,
      stop : 156243317,
      direction : "+",
      ID : "ENSG00000242252.2",
      gene_id : "ENSG00000242252.2",
      gene_type : "protein_coding",
      gene_name : "BGLAP",
      gene_level : 2,
      hgnc_id : "HGNC:1043",
      havana_gene : "OTTHUMG00000014819.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156243320,
      stop : 156248117,
      direction : "-",
      ID : "ENSG00000160781.17",
      gene_id : "ENSG00000160781.17",
      gene_type : "protein_coding",
      gene_name : "PAQR6",
      gene_level : 2,
      hgnc_id : "HGNC:30132",
      havana_gene : "OTTHUMG00000017490.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156249224,
      stop : 156282825,
      direction : "-",
      ID : "ENSG00000198952.8",
      gene_id : "ENSG00000198952.8",
      gene_type : "protein_coding",
      gene_name : "SMG5",
      gene_level : 2,
      hgnc_id : "HGNC:24644",
      havana_gene : "OTTHUMG00000017491.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156282935,
      stop : 156293185,
      direction : "+",
      ID : "ENSG00000163472.19",
      gene_id : "ENSG00000163472.19",
      gene_type : "protein_coding",
      gene_name : "TMEM79",
      gene_level : 2,
      hgnc_id : "HGNC:28196",
      havana_gene : "OTTHUMG00000019788.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156290089,
      stop : 156295689,
      direction : "-",
      ID : "ENSG00000198715.13",
      gene_id : "ENSG00000198715.13",
      gene_type : "protein_coding",
      gene_name : "GLMP",
      gene_level : 2,
      hgnc_id : "HGNC:29436",
      havana_gene : "OTTHUMG00000019789.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156298624,
      stop : 156299307,
      direction : "-",
      ID : "ENSG00000189030.10",
      gene_id : "ENSG00000189030.10",
      gene_type : "protein_coding",
      gene_name : "VHLL",
      gene_level : 2,
      hgnc_id : "HGNC:30666",
      havana_gene : "OTTHUMG00000024058.3",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156308968,
      stop : 156367873,
      direction : "-",
      ID : "ENSG00000163468.15",
      gene_id : "ENSG00000163468.15",
      gene_type : "protein_coding",
      gene_name : "CCT3",
      gene_level : 1,
      hgnc_id : "HGNC:1616",
      havana_gene : "OTTHUMG00000024061.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156337314,
      stop : 156346995,
      direction : "+",
      ID : "ENSG00000163467.12",
      gene_id : "ENSG00000163467.12",
      gene_type : "protein_coding",
      gene_name : "TSACC",
      gene_level : 2,
      hgnc_id : "HGNC:30636",
      havana_gene : "OTTHUMG00000024060.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156369211,
      stop : 156385219,
      direction : "+",
      ID : "ENSG00000132677.13",
      gene_id : "ENSG00000132677.13",
      gene_type : "protein_coding",
      gene_name : "RHBG",
      gene_level : 2,
      hgnc_id : "HGNC:14572",
      havana_gene : "OTTHUMG00000024057.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156463727,
      stop : 156500779,
      direction : "-",
      ID : "ENSG00000116604.18",
      gene_id : "ENSG00000116604.18",
      gene_type : "protein_coding",
      gene_name : "MEF2D",
      gene_level : 2,
      hgnc_id : "HGNC:6997",
      havana_gene : "OTTHUMG00000033095.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156525405,
      stop : 156572604,
      direction : "-",
      ID : "ENSG00000183856.11",
      gene_id : "ENSG00000183856.11",
      gene_type : "protein_coding",
      gene_name : "IQGAP3",
      gene_level : 2,
      hgnc_id : "HGNC:20669",
      havana_gene : "OTTHUMG00000033114.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156579723,
      stop : 156587719,
      direction : "+",
      ID : "ENSG00000187862.13",
      gene_id : "ENSG00000187862.13",
      gene_type : "protein_coding",
      gene_name : "TTC24",
      gene_level : 2,
      hgnc_id : "HGNC:32348",
      havana_gene : "OTTHUMG00000033202.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156591756,
      stop : 156609507,
      direction : "+",
      ID : "ENSG00000163382.13",
      gene_id : "ENSG00000163382.13",
      gene_type : "protein_coding",
      gene_name : "NAXE",
      gene_level : 2,
      hgnc_id : "HGNC:18453",
      havana_gene : "OTTHUMG00000033206.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156594301,
      stop : 156601496,
      direction : "-",
      ID : "ENSG00000160818.17",
      gene_id : "ENSG00000160818.17",
      gene_type : "protein_coding",
      gene_name : "GPATCH4",
      gene_level : 1,
      hgnc_id : "HGNC:25982",
      havana_gene : "OTTHUMG00000033203.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156619331,
      stop : 156625725,
      direction : "+",
      ID : "ENSG00000132702.13",
      gene_id : "ENSG00000132702.13",
      gene_type : "protein_coding",
      gene_name : "HAPLN2",
      gene_level : 2,
      hgnc_id : "HGNC:17410",
      havana_gene : "OTTHUMG00000033205.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156641390,
      stop : 156659532,
      direction : "+",
      ID : "ENSG00000132692.19",
      gene_id : "ENSG00000132692.19",
      gene_type : "protein_coding",
      gene_name : "BCAN",
      gene_level : 2,
      hgnc_id : "HGNC:23059",
      havana_gene : "OTTHUMG00000033322.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156668763,
      stop : 156677407,
      direction : "-",
      ID : "ENSG00000132688.11",
      gene_id : "ENSG00000132688.11",
      gene_type : "protein_coding",
      gene_name : "NES",
      gene_level : 2,
      hgnc_id : "HGNC:7756",
      havana_gene : "OTTHUMG00000034299.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156699606,
      stop : 156705816,
      direction : "-",
      ID : "ENSG00000143320.9",
      gene_id : "ENSG00000143320.9",
      gene_type : "protein_coding",
      gene_name : "CRABP2",
      gene_level : 2,
      hgnc_id : "HGNC:2339",
      havana_gene : "OTTHUMG00000041300.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156721891,
      stop : 156728766,
      direction : "-",
      ID : "ENSG00000143319.17",
      gene_id : "ENSG00000143319.17",
      gene_type : "protein_coding",
      gene_name : "ISG20L2",
      gene_level : 2,
      hgnc_id : "HGNC:25745",
      havana_gene : "OTTHUMG00000041301.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156728442,
      stop : 156736960,
      direction : "+",
      ID : "ENSG00000143303.12",
      gene_id : "ENSG00000143303.12",
      gene_type : "protein_coding",
      gene_name : "RRNAD1",
      gene_level : 1,
      hgnc_id : "HGNC:24273",
      havana_gene : "OTTHUMG00000041302.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156737303,
      stop : 156741590,
      direction : "-",
      ID : "ENSG00000143314.12",
      gene_id : "ENSG00000143314.12",
      gene_type : "protein_coding",
      gene_name : "MRPL24",
      gene_level : 2,
      hgnc_id : "HGNC:14037",
      havana_gene : "OTTHUMG00000041296.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156742109,
      stop : 156766925,
      direction : "-",
      ID : "ENSG00000143321.19",
      gene_id : "ENSG00000143321.19",
      gene_type : "protein_coding",
      gene_name : "HDGF",
      gene_level : 2,
      hgnc_id : "HGNC:4856",
      havana_gene : "OTTHUMG00000041295.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156750610,
      stop : 156800815,
      direction : "+",
      ID : "ENSG00000143294.15",
      gene_id : "ENSG00000143294.15",
      gene_type : "protein_coding",
      gene_name : "PRCC",
      gene_level : 1,
      hgnc_id : "HGNC:9343",
      havana_gene : "OTTHUMG00000041294.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156806243,
      stop : 156816848,
      direction : "-",
      ID : "ENSG00000027869.12",
      gene_id : "ENSG00000027869.12",
      gene_type : "protein_coding",
      gene_name : "SH2D2A",
      gene_level : 2,
      hgnc_id : "HGNC:10821",
      havana_gene : "OTTHUMG00000041305.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156815640,
      stop : 156881850,
      direction : "+",
      ID : "ENSG00000198400.13",
      gene_id : "ENSG00000198400.13",
      gene_type : "protein_coding",
      gene_name : "NTRK1",
      gene_level : 2,
      hgnc_id : "HGNC:8031",
      havana_gene : "OTTHUMG00000041304.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156840063,
      stop : 156859117,
      direction : "-",
      ID : "ENSG00000027644.5",
      gene_id : "ENSG00000027644.5",
      gene_type : "protein_coding",
      gene_name : "INSRR",
      gene_level : 2,
      hgnc_id : "HGNC:6093",
      havana_gene : "OTTHUMG00000041291.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156893698,
      stop : 156916434,
      direction : "+",
      ID : "ENSG00000187800.13",
      gene_id : "ENSG00000187800.13",
      gene_type : "protein_coding",
      gene_name : "PEAR1",
      gene_level : 2,
      hgnc_id : "HGNC:33631",
      havana_gene : "OTTHUMG00000041293.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156920632,
      stop : 156933094,
      direction : "+",
      ID : "ENSG00000160838.14",
      gene_id : "ENSG00000160838.14",
      gene_type : "protein_coding",
      gene_name : "LRRC71",
      gene_level : 2,
      hgnc_id : "HGNC:26556",
      havana_gene : "OTTHUMG00000041298.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 156934840,
      stop : 157045742,
      direction : "-",
      ID : "ENSG00000132694.19",
      gene_id : "ENSG00000132694.19",
      gene_type : "protein_coding",
      gene_name : "ARHGEF11",
      gene_level : 2,
      hgnc_id : "HGNC:14580",
      havana_gene : "OTTHUMG00000041292.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157092043,
      stop : 157112412,
      direction : "-",
      ID : "ENSG00000253831.3",
      gene_id : "ENSG00000253831.3",
      gene_type : "protein_coding",
      gene_name : "ETV3L",
      gene_level : 2,
      hgnc_id : "HGNC:33834",
      havana_gene : "OTTHUMG00000041325.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157121191,
      stop : 157138474,
      direction : "-",
      ID : "ENSG00000117036.12",
      gene_id : "ENSG00000117036.12",
      gene_type : "protein_coding",
      gene_name : "ETV3",
      gene_level : 2,
      hgnc_id : "HGNC:3492",
      havana_gene : "OTTHUMG00000034298.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157513377,
      stop : 157552515,
      direction : "-",
      ID : "ENSG00000143297.19",
      gene_id : "ENSG00000143297.19",
      gene_type : "protein_coding",
      gene_name : "FCRL5",
      gene_level : 2,
      hgnc_id : "HGNC:18508",
      havana_gene : "OTTHUMG00000017481.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157573747,
      stop : 157598085,
      direction : "-",
      ID : "ENSG00000163518.11",
      gene_id : "ENSG00000163518.11",
      gene_type : "protein_coding",
      gene_name : "FCRL4",
      gene_level : 2,
      hgnc_id : "HGNC:18507",
      havana_gene : "OTTHUMG00000035488.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157674321,
      stop : 157700769,
      direction : "-",
      ID : "ENSG00000160856.21",
      gene_id : "ENSG00000160856.21",
      gene_type : "protein_coding",
      gene_name : "FCRL3",
      gene_level : 1,
      hgnc_id : "HGNC:18506",
      havana_gene : "OTTHUMG00000019400.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157745733,
      stop : 157777132,
      direction : "-",
      ID : "ENSG00000132704.16",
      gene_id : "ENSG00000132704.16",
      gene_type : "protein_coding",
      gene_name : "FCRL2",
      gene_level : 2,
      hgnc_id : "HGNC:14875",
      havana_gene : "OTTHUMG00000019399.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157794403,
      stop : 157820120,
      direction : "-",
      ID : "ENSG00000163534.15",
      gene_id : "ENSG00000163534.15",
      gene_type : "protein_coding",
      gene_name : "FCRL1",
      gene_level : 2,
      hgnc_id : "HGNC:18509",
      havana_gene : "OTTHUMG00000019398.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157830911,
      stop : 157898256,
      direction : "-",
      ID : "ENSG00000073754.6",
      gene_id : "ENSG00000073754.6",
      gene_type : "protein_coding",
      gene_name : "CD5L",
      gene_level : 2,
      hgnc_id : "HGNC:1690",
      havana_gene : "OTTHUMG00000022440.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 157993273,
      stop : 158100262,
      direction : "+",
      ID : "ENSG00000183853.18",
      gene_id : "ENSG00000183853.18",
      gene_type : "protein_coding",
      gene_name : "KIRREL1",
      gene_level : 2,
      hgnc_id : "HGNC:15734",
      havana_gene : "OTTHUMG00000022438.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158127287,
      stop : 158128301,
      direction : "-",
      ID : "ENSG00000288460.1",
      gene_id : "ENSG00000288460.1",
      gene_type : "protein_coding",
      gene_name : "SMIM42",
      gene_level : 2,
      hgnc_id : "HGNC:55000",
      havana_gene : "OTTHUMG00000193807.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158178030,
      stop : 158186427,
      direction : "+",
      ID : "ENSG00000158473.8",
      gene_id : "ENSG00000158473.8",
      gene_type : "protein_coding",
      gene_name : "CD1D",
      gene_level : 2,
      hgnc_id : "HGNC:1637",
      havana_gene : "OTTHUMG00000022436.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158254424,
      stop : 158258269,
      direction : "+",
      ID : "ENSG00000158477.7",
      gene_id : "ENSG00000158477.7",
      gene_type : "protein_coding",
      gene_name : "CD1A",
      gene_level : 2,
      hgnc_id : "HGNC:1634",
      havana_gene : "OTTHUMG00000017512.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158289923,
      stop : 158294774,
      direction : "+",
      ID : "ENSG00000158481.13",
      gene_id : "ENSG00000158481.13",
      gene_type : "protein_coding",
      gene_name : "CD1C",
      gene_level : 1,
      hgnc_id : "HGNC:1636",
      havana_gene : "OTTHUMG00000017514.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158327951,
      stop : 158331531,
      direction : "-",
      ID : "ENSG00000158485.11",
      gene_id : "ENSG00000158485.11",
      gene_type : "protein_coding",
      gene_name : "CD1B",
      gene_level : 2,
      hgnc_id : "HGNC:1635",
      havana_gene : "OTTHUMG00000017513.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158353696,
      stop : 158357553,
      direction : "+",
      ID : "ENSG00000158488.16",
      gene_id : "ENSG00000158488.16",
      gene_type : "protein_coding",
      gene_name : "CD1E",
      gene_level : 2,
      hgnc_id : "HGNC:1638",
      havana_gene : "OTTHUMG00000017515.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158398522,
      stop : 158399466,
      direction : "-",
      ID : "ENSG00000186306.1",
      gene_id : "ENSG00000186306.1",
      gene_type : "protein_coding",
      gene_name : "OR10T2",
      gene_level : 2,
      hgnc_id : "HGNC:14816",
      havana_gene : "OTTHUMG00000017521.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158418210,
      stop : 158426237,
      direction : "-",
      ID : "ENSG00000180708.6",
      gene_id : "ENSG00000180708.6",
      gene_type : "protein_coding",
      gene_name : "OR10K2",
      gene_level : 2,
      hgnc_id : "HGNC:14826",
      havana_gene : "OTTHUMG00000019638.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158461574,
      stop : 158470857,
      direction : "+",
      ID : "ENSG00000173285.4",
      gene_id : "ENSG00000173285.4",
      gene_type : "protein_coding",
      gene_name : "OR10K1",
      gene_level : 2,
      hgnc_id : "HGNC:14693",
      havana_gene : "OTTHUMG00000017517.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158472220,
      stop : 158480936,
      direction : "+",
      ID : "ENSG00000198965.4",
      gene_id : "ENSG00000198965.4",
      gene_type : "protein_coding",
      gene_name : "OR10R2",
      gene_level : 2,
      hgnc_id : "HGNC:14820",
      havana_gene : "OTTHUMG00000019632.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158544550,
      stop : 158554405,
      direction : "-",
      ID : "ENSG00000197532.2",
      gene_id : "ENSG00000197532.2",
      gene_type : "protein_coding",
      gene_name : "OR6Y1",
      gene_level : 2,
      hgnc_id : "HGNC:14823",
      havana_gene : "OTTHUMG00000019629.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158560606,
      stop : 158570580,
      direction : "-",
      ID : "ENSG00000186440.2",
      gene_id : "ENSG00000186440.2",
      gene_type : "protein_coding",
      gene_name : "OR6P1",
      gene_level : 2,
      hgnc_id : "HGNC:15036",
      havana_gene : "OTTHUMG00000019633.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158578919,
      stop : 158579899,
      direction : "-",
      ID : "ENSG00000279111.2",
      gene_id : "ENSG00000279111.2",
      gene_type : "protein_coding",
      gene_name : "OR10X1",
      gene_level : 2,
      hgnc_id : "HGNC:14995",
      havana_gene : "OTTHUMG00000019635.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158605268,
      stop : 158612514,
      direction : "+",
      ID : "ENSG00000198967.4",
      gene_id : "ENSG00000198967.4",
      gene_type : "protein_coding",
      gene_name : "OR10Z1",
      gene_level : 2,
      hgnc_id : "HGNC:14996",
      havana_gene : "OTTHUMG00000019637.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158610704,
      stop : 158686715,
      direction : "-",
      ID : "ENSG00000163554.15",
      gene_id : "ENSG00000163554.15",
      gene_type : "protein_coding",
      gene_name : "SPTA1",
      gene_level : 2,
      hgnc_id : "HGNC:11272",
      havana_gene : "OTTHUMG00000019636.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158699678,
      stop : 158700652,
      direction : "-",
      ID : "ENSG00000196171.3",
      gene_id : "ENSG00000196171.3",
      gene_type : "protein_coding",
      gene_name : "OR6K2",
      gene_level : 2,
      hgnc_id : "HGNC:15029",
      havana_gene : "OTTHUMG00000022768.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158716327,
      stop : 158720720,
      direction : "-",
      ID : "ENSG00000203757.2",
      gene_id : "ENSG00000203757.2",
      gene_type : "protein_coding",
      gene_name : "OR6K3",
      gene_level : 2,
      hgnc_id : "HGNC:15030",
      havana_gene : "OTTHUMG00000022770.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158747814,
      stop : 158772195,
      direction : "-",
      ID : "ENSG00000197403.4",
      gene_id : "ENSG00000197403.4",
      gene_type : "protein_coding",
      gene_name : "OR6N1",
      gene_level : 2,
      hgnc_id : "HGNC:15034",
      havana_gene : "OTTHUMG00000022774.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158754720,
      stop : 158755891,
      direction : "+",
      ID : "ENSG00000180433.5",
      gene_id : "ENSG00000180433.5",
      gene_type : "protein_coding",
      gene_name : "OR6K6",
      gene_level : 2,
      hgnc_id : "HGNC:15033",
      havana_gene : "OTTHUMG00000022772.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158774222,
      stop : 158781204,
      direction : "-",
      ID : "ENSG00000188340.2",
      gene_id : "ENSG00000188340.2",
      gene_type : "protein_coding",
      gene_name : "OR6N2",
      gene_level : 2,
      hgnc_id : "HGNC:15035",
      havana_gene : "OTTHUMG00000022775.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158831351,
      stop : 158849506,
      direction : "+",
      ID : "ENSG00000163563.8",
      gene_id : "ENSG00000163563.8",
      gene_type : "protein_coding",
      gene_name : "MNDA",
      gene_level : 2,
      hgnc_id : "HGNC:7183",
      havana_gene : "OTTHUMG00000022776.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158930796,
      stop : 158977059,
      direction : "+",
      ID : "ENSG00000163564.15",
      gene_id : "ENSG00000163564.15",
      gene_type : "protein_coding",
      gene_name : "PYHIN1",
      gene_level : 2,
      hgnc_id : "HGNC:28894",
      havana_gene : "OTTHUMG00000037109.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 158999968,
      stop : 159055155,
      direction : "+",
      ID : "ENSG00000163565.19",
      gene_id : "ENSG00000163565.19",
      gene_type : "protein_coding",
      gene_name : "IFI16",
      gene_level : 2,
      hgnc_id : "HGNC:5395",
      havana_gene : "OTTHUMG00000037108.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159062484,
      stop : 159147096,
      direction : "-",
      ID : "ENSG00000163568.15",
      gene_id : "ENSG00000163568.15",
      gene_type : "protein_coding",
      gene_name : "AIM2",
      gene_level : 2,
      hgnc_id : "HGNC:357",
      havana_gene : "OTTHUMG00000037183.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159171609,
      stop : 159203313,
      direction : "+",
      ID : "ENSG00000162706.13",
      gene_id : "ENSG00000162706.13",
      gene_type : "protein_coding",
      gene_name : "CADM3",
      gene_level : 2,
      hgnc_id : "HGNC:17601",
      havana_gene : "OTTHUMG00000037177.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159203307,
      stop : 159206500,
      direction : "+",
      ID : "ENSG00000213088.12",
      gene_id : "ENSG00000213088.12",
      gene_type : "protein_coding",
      gene_name : "ACKR1",
      gene_level : 2,
      hgnc_id : "HGNC:4035",
      havana_gene : "OTTHUMG00000037182.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159289714,
      stop : 159308224,
      direction : "+",
      ID : "ENSG00000179639.10",
      gene_id : "ENSG00000179639.10",
      gene_type : "protein_coding",
      gene_name : "FCER1A",
      gene_level : 2,
      hgnc_id : "HGNC:3609",
      havana_gene : "OTTHUMG00000037176.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159437845,
      stop : 159443078,
      direction : "+",
      ID : "ENSG00000196184.10",
      gene_id : "ENSG00000196184.10",
      gene_type : "protein_coding",
      gene_name : "OR10J1",
      gene_level : 2,
      hgnc_id : "HGNC:8175",
      havana_gene : "OTTHUMG00000022737.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159535078,
      stop : 159536007,
      direction : "-",
      ID : "ENSG00000184155.8",
      gene_id : "ENSG00000184155.8",
      gene_type : "protein_coding",
      gene_name : "OR10J5",
      gene_level : 2,
      hgnc_id : "HGNC:14993",
      havana_gene : "OTTHUMG00000022738.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159587826,
      stop : 159588865,
      direction : "+",
      ID : "ENSG00000132703.4",
      gene_id : "ENSG00000132703.4",
      gene_type : "protein_coding",
      gene_name : "APCS",
      gene_level : 2,
      hgnc_id : "HGNC:584",
      havana_gene : "OTTHUMG00000022741.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159712289,
      stop : 159714589,
      direction : "-",
      ID : "ENSG00000132693.12",
      gene_id : "ENSG00000132693.12",
      gene_type : "protein_coding",
      gene_name : "CRP",
      gene_level : 2,
      hgnc_id : "HGNC:2367",
      havana_gene : "OTTHUMG00000035344.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159780932,
      stop : 159782543,
      direction : "+",
      ID : "ENSG00000158716.9",
      gene_id : "ENSG00000158716.9",
      gene_type : "protein_coding",
      gene_name : "DUSP23",
      gene_level : 2,
      hgnc_id : "HGNC:21480",
      havana_gene : "OTTHUMG00000022795.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159800511,
      stop : 159816257,
      direction : "+",
      ID : "ENSG00000181036.14",
      gene_id : "ENSG00000181036.14",
      gene_type : "protein_coding",
      gene_name : "FCRL6",
      gene_level : 2,
      hgnc_id : "HGNC:31910",
      havana_gene : "OTTHUMG00000035351.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159826811,
      stop : 159837492,
      direction : "+",
      ID : "ENSG00000158714.11",
      gene_id : "ENSG00000158714.11",
      gene_type : "protein_coding",
      gene_name : "SLAMF8",
      gene_level : 2,
      hgnc_id : "HGNC:21391",
      havana_gene : "OTTHUMG00000035433.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159834474,
      stop : 159873053,
      direction : "-",
      ID : "ENSG00000256029.6",
      gene_id : "ENSG00000256029.6",
      gene_type : "protein_coding",
      gene_name : "AL590560.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000035431.20",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159854316,
      stop : 159862657,
      direction : "-",
      ID : "ENSG00000243284.1",
      gene_id : "ENSG00000243284.1",
      gene_type : "protein_coding",
      gene_name : "VSIG8",
      gene_level : 2,
      hgnc_id : "HGNC:32063",
      havana_gene : "OTTHUMG00000168834.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159872364,
      stop : 159900165,
      direction : "-",
      ID : "ENSG00000213085.10",
      gene_id : "ENSG00000213085.10",
      gene_type : "protein_coding",
      gene_name : "CFAP45",
      gene_level : 2,
      hgnc_id : "HGNC:17229",
      havana_gene : "OTTHUMG00000035432.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159918107,
      stop : 159925507,
      direction : "-",
      ID : "ENSG00000158710.15",
      gene_id : "ENSG00000158710.15",
      gene_type : "protein_coding",
      gene_name : "TAGLN2",
      gene_level : 2,
      hgnc_id : "HGNC:11554",
      havana_gene : "OTTHUMG00000022793.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159927039,
      stop : 159945613,
      direction : "-",
      ID : "ENSG00000085552.17",
      gene_id : "ENSG00000085552.17",
      gene_type : "protein_coding",
      gene_name : "IGSF9",
      gene_level : 2,
      hgnc_id : "HGNC:18132",
      havana_gene : "OTTHUMG00000022794.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159951492,
      stop : 159954237,
      direction : "-",
      ID : "ENSG00000162723.10",
      gene_id : "ENSG00000162723.10",
      gene_type : "protein_coding",
      gene_name : "SLAMF9",
      gene_level : 2,
      hgnc_id : "HGNC:18430",
      havana_gene : "OTTHUMG00000024074.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 159998651,
      stop : 160070160,
      direction : "-",
      ID : "ENSG00000177807.10",
      gene_id : "ENSG00000177807.10",
      gene_type : "protein_coding",
      gene_name : "KCNJ10",
      gene_level : 2,
      hgnc_id : "HGNC:6256",
      havana_gene : "OTTHUMG00000024073.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160024953,
      stop : 160031990,
      direction : "-",
      ID : "ENSG00000143315.8",
      gene_id : "ENSG00000143315.8",
      gene_type : "protein_coding",
      gene_name : "PIGM",
      gene_level : 2,
      hgnc_id : "HGNC:18858",
      havana_gene : "OTTHUMG00000024081.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160081538,
      stop : 160090563,
      direction : "+",
      ID : "ENSG00000162728.5",
      gene_id : "ENSG00000162728.5",
      gene_type : "protein_coding",
      gene_name : "KCNJ9",
      gene_level : 2,
      hgnc_id : "HGNC:6270",
      havana_gene : "OTTHUMG00000024072.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160091340,
      stop : 160098943,
      direction : "-",
      ID : "ENSG00000162729.14",
      gene_id : "ENSG00000162729.14",
      gene_type : "protein_coding",
      gene_name : "IGSF8",
      gene_level : 2,
      hgnc_id : "HGNC:17813",
      havana_gene : "OTTHUMG00000024075.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160115759,
      stop : 160143591,
      direction : "+",
      ID : "ENSG00000018625.15",
      gene_id : "ENSG00000018625.15",
      gene_type : "protein_coding",
      gene_name : "ATP1A2",
      gene_level : 2,
      hgnc_id : "HGNC:800",
      havana_gene : "OTTHUMG00000024080.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160151586,
      stop : 160186980,
      direction : "+",
      ID : "ENSG00000132681.17",
      gene_id : "ENSG00000132681.17",
      gene_type : "protein_coding",
      gene_name : "ATP1A4",
      gene_level : 2,
      hgnc_id : "HGNC:14073",
      havana_gene : "OTTHUMG00000031609.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160190575,
      stop : 160201886,
      direction : "+",
      ID : "ENSG00000143318.13",
      gene_id : "ENSG00000143318.13",
      gene_type : "protein_coding",
      gene_name : "CASQ1",
      gene_level : 2,
      hgnc_id : "HGNC:1512",
      havana_gene : "OTTHUMG00000031607.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160205380,
      stop : 160215376,
      direction : "+",
      ID : "ENSG00000162734.13",
      gene_id : "ENSG00000162734.13",
      gene_type : "protein_coding",
      gene_name : "PEA15",
      gene_level : 2,
      hgnc_id : "HGNC:8822",
      havana_gene : "OTTHUMG00000031605.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160215715,
      stop : 160262549,
      direction : "-",
      ID : "ENSG00000132716.19",
      gene_id : "ENSG00000132716.19",
      gene_type : "protein_coding",
      gene_name : "DCAF8",
      gene_level : 2,
      hgnc_id : "HGNC:24891",
      havana_gene : "OTTHUMG00000031604.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160216800,
      stop : 160285130,
      direction : "-",
      ID : "ENSG00000258465.8",
      gene_id : "ENSG00000258465.8",
      gene_type : "protein_coding",
      gene_name : "AL139011.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171815.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160276807,
      stop : 160286348,
      direction : "-",
      ID : "ENSG00000162735.19",
      gene_id : "ENSG00000162735.19",
      gene_type : "protein_coding",
      gene_name : "PEX19",
      gene_level : 2,
      hgnc_id : "HGNC:9713",
      havana_gene : "OTTHUMG00000033112.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160288594,
      stop : 160343273,
      direction : "-",
      ID : "ENSG00000122218.16",
      gene_id : "ENSG00000122218.16",
      gene_type : "protein_coding",
      gene_name : "COPA",
      gene_level : 2,
      hgnc_id : "HGNC:2230",
      havana_gene : "OTTHUMG00000033111.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160343316,
      stop : 160358952,
      direction : "+",
      ID : "ENSG00000162736.17",
      gene_id : "ENSG00000162736.17",
      gene_type : "protein_coding",
      gene_name : "NCSTN",
      gene_level : 2,
      hgnc_id : "HGNC:17091",
      havana_gene : "OTTHUMG00000033110.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160367071,
      stop : 160372846,
      direction : "+",
      ID : "ENSG00000171786.6",
      gene_id : "ENSG00000171786.6",
      gene_type : "protein_coding",
      gene_name : "NHLH1",
      gene_level : 2,
      hgnc_id : "HGNC:7817",
      havana_gene : "OTTHUMG00000033121.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160400564,
      stop : 160428670,
      direction : "+",
      ID : "ENSG00000162738.6",
      gene_id : "ENSG00000162738.6",
      gene_type : "protein_coding",
      gene_name : "VANGL2",
      gene_level : 2,
      hgnc_id : "HGNC:15511",
      havana_gene : "OTTHUMG00000033122.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160485030,
      stop : 160523262,
      direction : "-",
      ID : "ENSG00000162739.14",
      gene_id : "ENSG00000162739.14",
      gene_type : "protein_coding",
      gene_name : "SLAMF6",
      gene_level : 2,
      hgnc_id : "HGNC:21392",
      havana_gene : "OTTHUMG00000022729.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160541095,
      stop : 160579516,
      direction : "-",
      ID : "ENSG00000066294.15",
      gene_id : "ENSG00000066294.15",
      gene_type : "protein_coding",
      gene_name : "CD84",
      gene_level : 2,
      hgnc_id : "HGNC:1704",
      havana_gene : "OTTHUMG00000022788.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160608106,
      stop : 160647295,
      direction : "-",
      ID : "ENSG00000117090.15",
      gene_id : "ENSG00000117090.15",
      gene_type : "protein_coding",
      gene_name : "SLAMF1",
      gene_level : 2,
      hgnc_id : "HGNC:10903",
      havana_gene : "OTTHUMG00000024006.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160678746,
      stop : 160711831,
      direction : "-",
      ID : "ENSG00000117091.10",
      gene_id : "ENSG00000117091.10",
      gene_type : "protein_coding",
      gene_name : "CD48",
      gene_level : 2,
      hgnc_id : "HGNC:1683",
      havana_gene : "OTTHUMG00000024009.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160739057,
      stop : 160754821,
      direction : "+",
      ID : "ENSG00000026751.17",
      gene_id : "ENSG00000026751.17",
      gene_type : "protein_coding",
      gene_name : "SLAMF7",
      gene_level : 2,
      hgnc_id : "HGNC:21394",
      havana_gene : "OTTHUMG00000024008.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160796074,
      stop : 160828261,
      direction : "+",
      ID : "ENSG00000122224.18",
      gene_id : "ENSG00000122224.18",
      gene_type : "protein_coding",
      gene_name : "LY9",
      gene_level : 2,
      hgnc_id : "HGNC:6730",
      havana_gene : "OTTHUMG00000024007.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160830160,
      stop : 160862887,
      direction : "-",
      ID : "ENSG00000122223.13",
      gene_id : "ENSG00000122223.13",
      gene_type : "protein_coding",
      gene_name : "CD244",
      gene_level : 2,
      hgnc_id : "HGNC:18171",
      havana_gene : "OTTHUMG00000028606.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160876540,
      stop : 160885180,
      direction : "-",
      ID : "ENSG00000179914.5",
      gene_id : "ENSG00000179914.5",
      gene_type : "protein_coding",
      gene_name : "ITLN1",
      gene_level : 2,
      hgnc_id : "HGNC:18259",
      havana_gene : "OTTHUMG00000028604.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160945025,
      stop : 160954809,
      direction : "-",
      ID : "ENSG00000158764.7",
      gene_id : "ENSG00000158764.7",
      gene_type : "protein_coding",
      gene_name : "ITLN2",
      gene_level : 2,
      hgnc_id : "HGNC:20599",
      havana_gene : "OTTHUMG00000028605.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160995211,
      stop : 161021343,
      direction : "-",
      ID : "ENSG00000158769.18",
      gene_id : "ENSG00000158769.18",
      gene_type : "protein_coding",
      gene_name : "F11R",
      gene_level : 1,
      hgnc_id : "HGNC:14685",
      havana_gene : "OTTHUMG00000028602.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 160997957,
      stop : 161038962,
      direction : "-",
      ID : "ENSG00000270149.5",
      gene_id : "ENSG00000270149.5",
      gene_type : "protein_coding",
      gene_name : "AL591806.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183896.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161037631,
      stop : 161038977,
      direction : "-",
      ID : "ENSG00000215845.11",
      gene_id : "ENSG00000215845.11",
      gene_type : "protein_coding",
      gene_name : "TSTD1",
      gene_level : 2,
      hgnc_id : "HGNC:35410",
      havana_gene : "OTTHUMG00000031476.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161039251,
      stop : 161045977,
      direction : "-",
      ID : "ENSG00000158773.14",
      gene_id : "ENSG00000158773.14",
      gene_type : "protein_coding",
      gene_name : "USF1",
      gene_level : 1,
      hgnc_id : "HGNC:12593",
      havana_gene : "OTTHUMG00000031472.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161046946,
      stop : 161069970,
      direction : "-",
      ID : "ENSG00000186517.14",
      gene_id : "ENSG00000186517.14",
      gene_type : "protein_coding",
      gene_name : "ARHGAP30",
      gene_level : 2,
      hgnc_id : "HGNC:27414",
      havana_gene : "OTTHUMG00000031477.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161070998,
      stop : 161089558,
      direction : "-",
      ID : "ENSG00000143217.9",
      gene_id : "ENSG00000143217.9",
      gene_type : "protein_coding",
      gene_name : "NECTIN4",
      gene_level : 2,
      hgnc_id : "HGNC:19688",
      havana_gene : "OTTHUMG00000031475.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161098361,
      stop : 161100346,
      direction : "+",
      ID : "ENSG00000162755.14",
      gene_id : "ENSG00000162755.14",
      gene_type : "protein_coding",
      gene_name : "KLHDC9",
      gene_level : 2,
      hgnc_id : "HGNC:28489",
      havana_gene : "OTTHUMG00000031479.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161100556,
      stop : 161118055,
      direction : "-",
      ID : "ENSG00000143256.5",
      gene_id : "ENSG00000143256.5",
      gene_type : "protein_coding",
      gene_name : "PFDN2",
      gene_level : 2,
      hgnc_id : "HGNC:8867",
      havana_gene : "OTTHUMG00000031481.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161118086,
      stop : 161125445,
      direction : "+",
      ID : "ENSG00000158793.14",
      gene_id : "ENSG00000158793.14",
      gene_type : "protein_coding",
      gene_name : "NIT1",
      gene_level : 2,
      hgnc_id : "HGNC:7828",
      havana_gene : "OTTHUMG00000031473.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161120974,
      stop : 161132688,
      direction : "-",
      ID : "ENSG00000158796.17",
      gene_id : "ENSG00000158796.17",
      gene_type : "protein_coding",
      gene_name : "DEDD",
      gene_level : 2,
      hgnc_id : "HGNC:2755",
      havana_gene : "OTTHUMG00000033104.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161152776,
      stop : 161158856,
      direction : "+",
      ID : "ENSG00000143222.12",
      gene_id : "ENSG00000143222.12",
      gene_type : "protein_coding",
      gene_name : "UFC1",
      gene_level : 2,
      hgnc_id : "HGNC:26941",
      havana_gene : "OTTHUMG00000033155.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161159450,
      stop : 161165723,
      direction : "+",
      ID : "ENSG00000143258.16",
      gene_id : "ENSG00000143258.16",
      gene_type : "protein_coding",
      gene_name : "USP21",
      gene_level : 2,
      hgnc_id : "HGNC:12620",
      havana_gene : "OTTHUMG00000033154.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161166056,
      stop : 161178013,
      direction : "+",
      ID : "ENSG00000143224.18",
      gene_id : "ENSG00000143224.18",
      gene_type : "protein_coding",
      gene_name : "PPOX",
      gene_level : 1,
      hgnc_id : "HGNC:9280",
      havana_gene : "OTTHUMG00000034342.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161171310,
      stop : 161177968,
      direction : "-",
      ID : "ENSG00000158850.15",
      gene_id : "ENSG00000158850.15",
      gene_type : "protein_coding",
      gene_name : "B4GALT3",
      gene_level : 2,
      hgnc_id : "HGNC:926",
      havana_gene : "OTTHUMG00000034348.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161184302,
      stop : 161199054,
      direction : "-",
      ID : "ENSG00000158859.10",
      gene_id : "ENSG00000158859.10",
      gene_type : "protein_coding",
      gene_name : "ADAMTS4",
      gene_level : 2,
      hgnc_id : "HGNC:220",
      havana_gene : "OTTHUMG00000034349.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161197104,
      stop : 161214723,
      direction : "+",
      ID : "ENSG00000158864.13",
      gene_id : "ENSG00000158864.13",
      gene_type : "protein_coding",
      gene_name : "NDUFS2",
      gene_level : 2,
      hgnc_id : "HGNC:7708",
      havana_gene : "OTTHUMG00000034344.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161215234,
      stop : 161220699,
      direction : "+",
      ID : "ENSG00000158869.11",
      gene_id : "ENSG00000158869.11",
      gene_type : "protein_coding",
      gene_name : "FCER1G",
      gene_level : 2,
      hgnc_id : "HGNC:3611",
      havana_gene : "OTTHUMG00000034343.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161222292,
      stop : 161223631,
      direction : "-",
      ID : "ENSG00000158874.11",
      gene_id : "ENSG00000158874.11",
      gene_type : "protein_coding",
      gene_name : "APOA2",
      gene_level : 2,
      hgnc_id : "HGNC:601",
      havana_gene : "OTTHUMG00000034346.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161225939,
      stop : 161230746,
      direction : "+",
      ID : "ENSG00000158882.15",
      gene_id : "ENSG00000158882.15",
      gene_type : "protein_coding",
      gene_name : "TOMM40L",
      gene_level : 2,
      hgnc_id : "HGNC:25756",
      havana_gene : "OTTHUMG00000034345.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161229666,
      stop : 161238244,
      direction : "-",
      ID : "ENSG00000143257.12",
      gene_id : "ENSG00000143257.12",
      gene_type : "protein_coding",
      gene_name : "NR1I3",
      gene_level : 1,
      hgnc_id : "HGNC:7969",
      havana_gene : "OTTHUMG00000034347.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161258745,
      stop : 161285450,
      direction : "+",
      ID : "ENSG00000248485.2",
      gene_id : "ENSG00000248485.2",
      gene_type : "protein_coding",
      gene_name : "PCP4L1",
      gene_level : 2,
      hgnc_id : "HGNC:20448",
      havana_gene : "OTTHUMG00000034340.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161304735,
      stop : 161309968,
      direction : "-",
      ID : "ENSG00000158887.19",
      gene_id : "ENSG00000158887.19",
      gene_type : "protein_coding",
      gene_name : "MPZ",
      gene_level : 2,
      hgnc_id : "HGNC:7225",
      havana_gene : "OTTHUMG00000034341.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161314381,
      stop : 161363206,
      direction : "+",
      ID : "ENSG00000143252.16",
      gene_id : "ENSG00000143252.16",
      gene_type : "protein_coding",
      gene_name : "SDHC",
      gene_level : 2,
      hgnc_id : "HGNC:10682",
      havana_gene : "OTTHUMG00000034468.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161364733,
      stop : 161367876,
      direction : "-",
      ID : "ENSG00000188931.4",
      gene_id : "ENSG00000188931.4",
      gene_type : "protein_coding",
      gene_name : "CFAP126",
      gene_level : 2,
      hgnc_id : "HGNC:32325",
      havana_gene : "OTTHUMG00000034462.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161505430,
      stop : 161524013,
      direction : "+",
      ID : "ENSG00000143226.15",
      gene_id : "ENSG00000143226.15",
      gene_type : "protein_coding",
      gene_name : "FCGR2A",
      gene_level : 2,
      hgnc_id : "HGNC:3616",
      havana_gene : "OTTHUMG00000034469.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161524540,
      stop : 161526894,
      direction : "+",
      ID : "ENSG00000173110.8",
      gene_id : "ENSG00000173110.8",
      gene_type : "protein_coding",
      gene_name : "HSPA6",
      gene_level : 2,
      hgnc_id : "HGNC:5239",
      havana_gene : "OTTHUMG00000034461.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161541759,
      stop : 161550737,
      direction : "-",
      ID : "ENSG00000203747.12",
      gene_id : "ENSG00000203747.12",
      gene_type : "protein_coding",
      gene_name : "FCGR3A",
      gene_level : 2,
      hgnc_id : "HGNC:3619",
      havana_gene : "OTTHUMG00000034466.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161623196,
      stop : 161631963,
      direction : "-",
      ID : "ENSG00000162747.12",
      gene_id : "ENSG00000162747.12",
      gene_type : "protein_coding",
      gene_name : "FCGR3B",
      gene_level : 2,
      hgnc_id : "HGNC:3620",
      havana_gene : "OTTHUMG00000074099.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161663147,
      stop : 161678654,
      direction : "+",
      ID : "ENSG00000072694.21",
      gene_id : "ENSG00000072694.21",
      gene_type : "protein_coding",
      gene_name : "FCGR2B",
      gene_level : 2,
      hgnc_id : "HGNC:3618",
      havana_gene : "OTTHUMG00000034470.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161706972,
      stop : 161714352,
      direction : "+",
      ID : "ENSG00000132185.18",
      gene_id : "ENSG00000132185.18",
      gene_type : "protein_coding",
      gene_name : "FCRLA",
      gene_level : 2,
      hgnc_id : "HGNC:18504",
      havana_gene : "OTTHUMG00000034537.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161721563,
      stop : 161728143,
      direction : "+",
      ID : "ENSG00000162746.14",
      gene_id : "ENSG00000162746.14",
      gene_type : "protein_coding",
      gene_name : "FCRLB",
      gene_level : 2,
      hgnc_id : "HGNC:26431",
      havana_gene : "OTTHUMG00000133629.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161749758,
      stop : 161757238,
      direction : "+",
      ID : "ENSG00000081721.12",
      gene_id : "ENSG00000081721.12",
      gene_type : "protein_coding",
      gene_name : "DUSP12",
      gene_level : 2,
      hgnc_id : "HGNC:3067",
      havana_gene : "OTTHUMG00000034540.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161766298,
      stop : 161977574,
      direction : "+",
      ID : "ENSG00000118217.7",
      gene_id : "ENSG00000118217.7",
      gene_type : "protein_coding",
      gene_name : "ATF6",
      gene_level : 2,
      hgnc_id : "HGNC:791",
      havana_gene : "OTTHUMG00000023961.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 161983192,
      stop : 162023869,
      direction : "-",
      ID : "ENSG00000162745.11",
      gene_id : "ENSG00000162745.11",
      gene_type : "protein_coding",
      gene_name : "OLFML2B",
      gene_level : 1,
      hgnc_id : "HGNC:24558",
      havana_gene : "OTTHUMG00000024047.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162069691,
      stop : 162370475,
      direction : "+",
      ID : "ENSG00000198929.13",
      gene_id : "ENSG00000198929.13",
      gene_type : "protein_coding",
      gene_name : "NOS1AP",
      gene_level : 2,
      hgnc_id : "HGNC:16859",
      havana_gene : "OTTHUMG00000024049.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162365407,
      stop : 162383531,
      direction : "+",
      ID : "ENSG00000254706.3",
      gene_id : "ENSG00000254706.3",
      gene_type : "protein_coding",
      gene_name : "AL512785.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000165223.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162373203,
      stop : 162376854,
      direction : "-",
      ID : "ENSG00000171722.13",
      gene_id : "ENSG00000171722.13",
      gene_type : "protein_coding",
      gene_name : "SPATA46",
      gene_level : 2,
      hgnc_id : "HGNC:27648",
      havana_gene : "OTTHUMG00000031375.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162378841,
      stop : 162386812,
      direction : "+",
      ID : "ENSG00000239887.6",
      gene_id : "ENSG00000239887.6",
      gene_type : "protein_coding",
      gene_name : "C1orf226",
      gene_level : 2,
      hgnc_id : "HGNC:34351",
      havana_gene : "OTTHUMG00000031376.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162395268,
      stop : 162412138,
      direction : "-",
      ID : "ENSG00000198574.6",
      gene_id : "ENSG00000198574.6",
      gene_type : "protein_coding",
      gene_name : "SH2D1B",
      gene_level : 2,
      hgnc_id : "HGNC:30416",
      havana_gene : "OTTHUMG00000031377.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162497251,
      stop : 162529631,
      direction : "+",
      ID : "ENSG00000152332.16",
      gene_id : "ENSG00000152332.16",
      gene_type : "protein_coding",
      gene_name : "UHMK1",
      gene_level : 2,
      hgnc_id : "HGNC:19683",
      havana_gene : "OTTHUMG00000031373.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162561506,
      stop : 162599842,
      direction : "+",
      ID : "ENSG00000117143.13",
      gene_id : "ENSG00000117143.13",
      gene_type : "protein_coding",
      gene_name : "UAP1",
      gene_level : 2,
      hgnc_id : "HGNC:12457",
      havana_gene : "OTTHUMG00000034419.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162631373,
      stop : 162787405,
      direction : "+",
      ID : "ENSG00000162733.19",
      gene_id : "ENSG00000162733.19",
      gene_type : "protein_coding",
      gene_name : "DDR2",
      gene_level : 2,
      hgnc_id : "HGNC:2731",
      havana_gene : "OTTHUMG00000034423.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162790702,
      stop : 162812817,
      direction : "+",
      ID : "ENSG00000132196.15",
      gene_id : "ENSG00000132196.15",
      gene_type : "protein_coding",
      gene_name : "HSD17B7",
      gene_level : 2,
      hgnc_id : "HGNC:5215",
      havana_gene : "OTTHUMG00000034420.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 162824458,
      stop : 162868815,
      direction : "-",
      ID : "ENSG00000185860.13",
      gene_id : "ENSG00000185860.13",
      gene_type : "protein_coding",
      gene_name : "CCDC190",
      gene_level : 2,
      hgnc_id : "HGNC:28736",
      havana_gene : "OTTHUMG00000034421.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 163068775,
      stop : 163076802,
      direction : "+",
      ID : "ENSG00000117152.14",
      gene_id : "ENSG00000117152.14",
      gene_type : "protein_coding",
      gene_name : "RGS4",
      gene_level : 2,
      hgnc_id : "HGNC:10000",
      havana_gene : "OTTHUMG00000034417.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 163111121,
      stop : 163321791,
      direction : "-",
      ID : "ENSG00000143248.13",
      gene_id : "ENSG00000143248.13",
      gene_type : "protein_coding",
      gene_name : "RGS5",
      gene_level : 1,
      hgnc_id : "HGNC:10001",
      havana_gene : "OTTHUMG00000034441.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 163266576,
      stop : 163355764,
      direction : "+",
      ID : "ENSG00000143228.13",
      gene_id : "ENSG00000143228.13",
      gene_type : "protein_coding",
      gene_name : "NUF2",
      gene_level : 1,
      hgnc_id : "HGNC:14621",
      havana_gene : "OTTHUMG00000034275.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 164555584,
      stop : 164899296,
      direction : "+",
      ID : "ENSG00000185630.19",
      gene_id : "ENSG00000185630.19",
      gene_type : "protein_coding",
      gene_name : "PBX1",
      gene_level : 1,
      hgnc_id : "HGNC:8632",
      havana_gene : "OTTHUMG00000034307.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165201867,
      stop : 165356715,
      direction : "-",
      ID : "ENSG00000162761.14",
      gene_id : "ENSG00000162761.14",
      gene_type : "protein_coding",
      gene_name : "LMX1A",
      gene_level : 2,
      hgnc_id : "HGNC:6653",
      havana_gene : "OTTHUMG00000034575.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165400922,
      stop : 165445355,
      direction : "-",
      ID : "ENSG00000143171.13",
      gene_id : "ENSG00000143171.13",
      gene_type : "protein_coding",
      gene_name : "RXRG",
      gene_level : 2,
      hgnc_id : "HGNC:10479",
      havana_gene : "OTTHUMG00000034626.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165544000,
      stop : 165563957,
      direction : "+",
      ID : "ENSG00000162763.4",
      gene_id : "ENSG00000162763.4",
      gene_type : "protein_coding",
      gene_name : "LRRC52",
      gene_level : 2,
      hgnc_id : "HGNC:32156",
      havana_gene : "OTTHUMG00000034625.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165631213,
      stop : 165661796,
      direction : "+",
      ID : "ENSG00000143198.13",
      gene_id : "ENSG00000143198.13",
      gene_type : "protein_coding",
      gene_name : "MGST3",
      gene_level : 2,
      hgnc_id : "HGNC:7064",
      havana_gene : "OTTHUMG00000034627.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165662216,
      stop : 165698863,
      direction : "-",
      ID : "ENSG00000143149.12",
      gene_id : "ENSG00000143149.12",
      gene_type : "protein_coding",
      gene_name : "ALDH9A1",
      gene_level : 2,
      hgnc_id : "HGNC:412",
      havana_gene : "OTTHUMG00000034677.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165724293,
      stop : 165827755,
      direction : "-",
      ID : "ENSG00000143183.18",
      gene_id : "ENSG00000143183.18",
      gene_type : "protein_coding",
      gene_name : "TMCO1",
      gene_level : 1,
      hgnc_id : "HGNC:18188",
      havana_gene : "OTTHUMG00000034672.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 165827614,
      stop : 165911618,
      direction : "+",
      ID : "ENSG00000143179.16",
      gene_id : "ENSG00000143179.16",
      gene_type : "protein_coding",
      gene_name : "UCK2",
      gene_level : 2,
      hgnc_id : "HGNC:12562",
      havana_gene : "OTTHUMG00000040117.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 166057426,
      stop : 166167001,
      direction : "-",
      ID : "ENSG00000188859.7",
      gene_id : "ENSG00000188859.7",
      gene_type : "protein_coding",
      gene_name : "FAM78B",
      gene_level : 2,
      hgnc_id : "HGNC:13495",
      havana_gene : "OTTHUMG00000034705.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 166839447,
      stop : 166856359,
      direction : "+",
      ID : "ENSG00000143157.12",
      gene_id : "ENSG00000143157.12",
      gene_type : "protein_coding",
      gene_name : "POGK",
      gene_level : 2,
      hgnc_id : "HGNC:18800",
      havana_gene : "OTTHUMG00000034325.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 166856510,
      stop : 166876264,
      direction : "-",
      ID : "ENSG00000152382.6",
      gene_id : "ENSG00000152382.6",
      gene_type : "protein_coding",
      gene_name : "TADA1",
      gene_level : 2,
      hgnc_id : "HGNC:30631",
      havana_gene : "OTTHUMG00000034321.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 166895711,
      stop : 166975540,
      direction : "-",
      ID : "ENSG00000143195.13",
      gene_id : "ENSG00000143195.13",
      gene_type : "protein_coding",
      gene_name : "ILDR2",
      gene_level : 1,
      hgnc_id : "HGNC:18131",
      havana_gene : "OTTHUMG00000034320.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 166975582,
      stop : 167022214,
      direction : "+",
      ID : "ENSG00000143194.13",
      gene_id : "ENSG00000143194.13",
      gene_type : "protein_coding",
      gene_name : "MAEL",
      gene_level : 2,
      hgnc_id : "HGNC:25929",
      havana_gene : "OTTHUMG00000034432.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167052836,
      stop : 167166479,
      direction : "-",
      ID : "ENSG00000143167.12",
      gene_id : "ENSG00000143167.12",
      gene_type : "protein_coding",
      gene_name : "GPA33",
      gene_level : 2,
      hgnc_id : "HGNC:4445",
      havana_gene : "OTTHUMG00000034435.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167094075,
      stop : 167129165,
      direction : "+",
      ID : "ENSG00000198842.10",
      gene_id : "ENSG00000198842.10",
      gene_type : "protein_coding",
      gene_name : "STYXL2",
      gene_level : 2,
      hgnc_id : "HGNC:25034",
      havana_gene : "OTTHUMG00000034434.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167220876,
      stop : 167427345,
      direction : "+",
      ID : "ENSG00000143190.23",
      gene_id : "ENSG00000143190.23",
      gene_type : "protein_coding",
      gene_name : "POU2F1",
      gene_level : 1,
      hgnc_id : "HGNC:9212",
      havana_gene : "OTTHUMG00000034436.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167430640,
      stop : 167518610,
      direction : "-",
      ID : "ENSG00000198821.11",
      gene_id : "ENSG00000198821.11",
      gene_type : "protein_coding",
      gene_name : "CD247",
      gene_level : 2,
      hgnc_id : "HGNC:1677",
      havana_gene : "OTTHUMG00000034593.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167529117,
      stop : 167553805,
      direction : "-",
      ID : "ENSG00000143162.9",
      gene_id : "ENSG00000143162.9",
      gene_type : "protein_coding",
      gene_name : "CREG1",
      gene_level : 2,
      hgnc_id : "HGNC:2351",
      havana_gene : "OTTHUMG00000034682.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167630093,
      stop : 167708696,
      direction : "+",
      ID : "ENSG00000198771.11",
      gene_id : "ENSG00000198771.11",
      gene_type : "protein_coding",
      gene_name : "RCSD1",
      gene_level : 2,
      hgnc_id : "HGNC:28310",
      havana_gene : "OTTHUMG00000035318.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167721192,
      stop : 167791919,
      direction : "+",
      ID : "ENSG00000197965.12",
      gene_id : "ENSG00000197965.12",
      gene_type : "protein_coding",
      gene_name : "MPZL1",
      gene_level : 1,
      hgnc_id : "HGNC:7226",
      havana_gene : "OTTHUMG00000034571.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167809386,
      stop : 167914215,
      direction : "-",
      ID : "ENSG00000143199.18",
      gene_id : "ENSG00000143199.18",
      gene_type : "protein_coding",
      gene_name : "ADCY10",
      gene_level : 2,
      hgnc_id : "HGNC:21285",
      havana_gene : "OTTHUMG00000034573.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167916675,
      stop : 167937072,
      direction : "-",
      ID : "ENSG00000143158.11",
      gene_id : "ENSG00000143158.11",
      gene_type : "protein_coding",
      gene_name : "MPC2",
      gene_level : 2,
      hgnc_id : "HGNC:24515",
      havana_gene : "OTTHUMG00000034570.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 167935783,
      stop : 168075843,
      direction : "+",
      ID : "ENSG00000143164.15",
      gene_id : "ENSG00000143164.15",
      gene_type : "protein_coding",
      gene_name : "DCAF6",
      gene_level : 2,
      hgnc_id : "HGNC:30002",
      havana_gene : "OTTHUMG00000034572.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168079543,
      stop : 168137667,
      direction : "-",
      ID : "ENSG00000143147.14",
      gene_id : "ENSG00000143147.14",
      gene_type : "protein_coding",
      gene_name : "GPR161",
      gene_level : 1,
      hgnc_id : "HGNC:23694",
      havana_gene : "OTTHUMG00000034651.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168178962,
      stop : 168202109,
      direction : "+",
      ID : "ENSG00000143155.13",
      gene_id : "ENSG00000143155.13",
      gene_type : "protein_coding",
      gene_name : "TIPRL",
      gene_level : 2,
      hgnc_id : "HGNC:30231",
      havana_gene : "OTTHUMG00000034646.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168225938,
      stop : 168253021,
      direction : "+",
      ID : "ENSG00000213064.10",
      gene_id : "ENSG00000213064.10",
      gene_type : "protein_coding",
      gene_name : "SFT2D2",
      gene_level : 2,
      hgnc_id : "HGNC:25140",
      havana_gene : "OTTHUMG00000034650.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168280877,
      stop : 168314426,
      direction : "+",
      ID : "ENSG00000143178.13",
      gene_id : "ENSG00000143178.13",
      gene_type : "protein_coding",
      gene_name : "TBX19",
      gene_level : 2,
      hgnc_id : "HGNC:11596",
      havana_gene : "OTTHUMG00000034648.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168540768,
      stop : 168543997,
      direction : "-",
      ID : "ENSG00000143185.4",
      gene_id : "ENSG00000143185.4",
      gene_type : "protein_coding",
      gene_name : "XCL2",
      gene_level : 2,
      hgnc_id : "HGNC:10646",
      havana_gene : "OTTHUMG00000034549.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168576605,
      stop : 168582069,
      direction : "+",
      ID : "ENSG00000143184.5",
      gene_id : "ENSG00000143184.5",
      gene_type : "protein_coding",
      gene_name : "XCL1",
      gene_level : 2,
      hgnc_id : "HGNC:10645",
      havana_gene : "OTTHUMG00000034548.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 168695468,
      stop : 168729206,
      direction : "-",
      ID : "ENSG00000143196.5",
      gene_id : "ENSG00000143196.5",
      gene_type : "protein_coding",
      gene_name : "DPT",
      gene_level : 2,
      hgnc_id : "HGNC:3011",
      havana_gene : "OTTHUMG00000034554.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169105697,
      stop : 169132722,
      direction : "+",
      ID : "ENSG00000143153.13",
      gene_id : "ENSG00000143153.13",
      gene_type : "protein_coding",
      gene_name : "ATP1B1",
      gene_level : 2,
      hgnc_id : "HGNC:804",
      havana_gene : "OTTHUMG00000034590.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169132531,
      stop : 169367948,
      direction : "-",
      ID : "ENSG00000143156.14",
      gene_id : "ENSG00000143156.14",
      gene_type : "protein_coding",
      gene_name : "NME7",
      gene_level : 2,
      hgnc_id : "HGNC:20461",
      havana_gene : "OTTHUMG00000034586.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169367970,
      stop : 169396540,
      direction : "+",
      ID : "ENSG00000117475.14",
      gene_id : "ENSG00000117475.14",
      gene_type : "protein_coding",
      gene_name : "BLZF1",
      gene_level : 2,
      hgnc_id : "HGNC:1065",
      havana_gene : "OTTHUMG00000035453.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169394870,
      stop : 169460669,
      direction : "-",
      ID : "ENSG00000117477.12",
      gene_id : "ENSG00000117477.12",
      gene_type : "protein_coding",
      gene_name : "CCDC181",
      gene_level : 2,
      hgnc_id : "HGNC:28051",
      havana_gene : "OTTHUMG00000035448.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169463909,
      stop : 169485944,
      direction : "-",
      ID : "ENSG00000117479.15",
      gene_id : "ENSG00000117479.15",
      gene_type : "protein_coding",
      gene_name : "SLC19A2",
      gene_level : 2,
      hgnc_id : "HGNC:10938",
      havana_gene : "OTTHUMG00000035452.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169511951,
      stop : 169586588,
      direction : "-",
      ID : "ENSG00000198734.12",
      gene_id : "ENSG00000198734.12",
      gene_type : "protein_coding",
      gene_name : "F5",
      gene_level : 1,
      hgnc_id : "HGNC:3542",
      havana_gene : "OTTHUMG00000034595.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169588849,
      stop : 169630193,
      direction : "-",
      ID : "ENSG00000174175.17",
      gene_id : "ENSG00000174175.17",
      gene_type : "protein_coding",
      gene_name : "SELP",
      gene_level : 2,
      hgnc_id : "HGNC:10721",
      havana_gene : "OTTHUMG00000034685.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169662007,
      stop : 169854080,
      direction : "+",
      ID : "ENSG00000000460.17",
      gene_id : "ENSG00000000460.17",
      gene_type : "protein_coding",
      gene_name : "C1orf112",
      gene_level : 2,
      hgnc_id : "HGNC:25565",
      havana_gene : "OTTHUMG00000035821.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169690665,
      stop : 169711702,
      direction : "-",
      ID : "ENSG00000188404.10",
      gene_id : "ENSG00000188404.10",
      gene_type : "protein_coding",
      gene_name : "SELL",
      gene_level : 2,
      hgnc_id : "HGNC:10720",
      havana_gene : "OTTHUMG00000034809.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169722640,
      stop : 169764705,
      direction : "-",
      ID : "ENSG00000007908.16",
      gene_id : "ENSG00000007908.16",
      gene_type : "protein_coding",
      gene_name : "SELE",
      gene_level : 1,
      hgnc_id : "HGNC:10718",
      havana_gene : "OTTHUMG00000034851.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169792529,
      stop : 169794963,
      direction : "-",
      ID : "ENSG00000171806.12",
      gene_id : "ENSG00000171806.12",
      gene_type : "protein_coding",
      gene_name : "METTL18",
      gene_level : 2,
      hgnc_id : "HGNC:28793",
      havana_gene : "OTTHUMG00000035813.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169849631,
      stop : 169894267,
      direction : "-",
      ID : "ENSG00000000457.14",
      gene_id : "ENSG00000000457.14",
      gene_type : "protein_coding",
      gene_name : "SCYL3",
      gene_level : 2,
      hgnc_id : "HGNC:19285",
      havana_gene : "OTTHUMG00000035941.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 169921326,
      stop : 170085208,
      direction : "-",
      ID : "ENSG00000075945.13",
      gene_id : "ENSG00000075945.13",
      gene_type : "protein_coding",
      gene_name : "KIFAP3",
      gene_level : 2,
      hgnc_id : "HGNC:17060",
      havana_gene : "OTTHUMG00000035947.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 170145959,
      stop : 170168866,
      direction : "+",
      ID : "ENSG00000203740.4",
      gene_id : "ENSG00000203740.4",
      gene_type : "protein_coding",
      gene_name : "METTL11B",
      gene_level : 2,
      hgnc_id : "HGNC:31932",
      havana_gene : "OTTHUMG00000035959.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 170532131,
      stop : 170553834,
      direction : "+",
      ID : "ENSG00000120370.13",
      gene_id : "ENSG00000120370.13",
      gene_type : "protein_coding",
      gene_name : "GORAB",
      gene_level : 2,
      hgnc_id : "HGNC:25676",
      havana_gene : "OTTHUMG00000035228.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 170662728,
      stop : 170739421,
      direction : "+",
      ID : "ENSG00000116132.12",
      gene_id : "ENSG00000116132.12",
      gene_type : "protein_coding",
      gene_name : "PRRX1",
      gene_level : 1,
      hgnc_id : "HGNC:9142",
      havana_gene : "OTTHUMG00000035231.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 170935471,
      stop : 171064765,
      direction : "+",
      ID : "ENSG00000117501.14",
      gene_id : "ENSG00000117501.14",
      gene_type : "protein_coding",
      gene_name : "MROH9",
      gene_level : 2,
      hgnc_id : "HGNC:26287",
      havana_gene : "OTTHUMG00000041456.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171090901,
      stop : 171117819,
      direction : "+",
      ID : "ENSG00000007933.13",
      gene_id : "ENSG00000007933.13",
      gene_type : "protein_coding",
      gene_name : "FMO3",
      gene_level : 2,
      hgnc_id : "HGNC:3771",
      havana_gene : "OTTHUMG00000035505.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171185249,
      stop : 171212686,
      direction : "+",
      ID : "ENSG00000094963.14",
      gene_id : "ENSG00000094963.14",
      gene_type : "protein_coding",
      gene_name : "FMO2",
      gene_level : 2,
      hgnc_id : "HGNC:3770",
      havana_gene : "OTTHUMG00000035504.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171248471,
      stop : 171285978,
      direction : "+",
      ID : "ENSG00000010932.17",
      gene_id : "ENSG00000010932.17",
      gene_type : "protein_coding",
      gene_name : "FMO1",
      gene_level : 2,
      hgnc_id : "HGNC:3769",
      havana_gene : "OTTHUMG00000035502.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171314183,
      stop : 171342084,
      direction : "+",
      ID : "ENSG00000076258.10",
      gene_id : "ENSG00000076258.10",
      gene_type : "protein_coding",
      gene_name : "FMO4",
      gene_level : 2,
      hgnc_id : "HGNC:3772",
      havana_gene : "OTTHUMG00000035506.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171485551,
      stop : 171593511,
      direction : "+",
      ID : "ENSG00000117523.16",
      gene_id : "ENSG00000117523.16",
      gene_type : "protein_coding",
      gene_name : "PRRC2C",
      gene_level : 2,
      hgnc_id : "HGNC:24903",
      havana_gene : "OTTHUMG00000034665.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171600621,
      stop : 171638799,
      direction : "+",
      ID : "ENSG00000283683.1",
      gene_id : "ENSG00000283683.1",
      gene_type : "protein_coding",
      gene_name : "MYOCOS",
      gene_level : 2,
      hgnc_id : "HGNC:53429",
      havana_gene : "OTTHUMG00000191791.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171635417,
      stop : 171652688,
      direction : "-",
      ID : "ENSG00000034971.17",
      gene_id : "ENSG00000034971.17",
      gene_type : "protein_coding",
      gene_name : "MYOC",
      gene_level : 2,
      hgnc_id : "HGNC:7610",
      havana_gene : "OTTHUMG00000034789.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171700160,
      stop : 171742074,
      direction : "-",
      ID : "ENSG00000117533.15",
      gene_id : "ENSG00000117533.15",
      gene_type : "protein_coding",
      gene_name : "VAMP4",
      gene_level : 2,
      hgnc_id : "HGNC:12645",
      havana_gene : "OTTHUMG00000034788.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171781660,
      stop : 171814023,
      direction : "+",
      ID : "ENSG00000010165.20",
      gene_id : "ENSG00000010165.20",
      gene_type : "protein_coding",
      gene_name : "EEF1AKNMT",
      gene_level : 2,
      hgnc_id : "HGNC:24248",
      havana_gene : "OTTHUMG00000034912.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 171841498,
      stop : 172418466,
      direction : "+",
      ID : "ENSG00000197959.14",
      gene_id : "ENSG00000197959.14",
      gene_type : "protein_coding",
      gene_name : "DNM3",
      gene_level : 1,
      hgnc_id : "HGNC:29125",
      havana_gene : "OTTHUMG00000034913.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 172370189,
      stop : 172444086,
      direction : "-",
      ID : "ENSG00000135845.10",
      gene_id : "ENSG00000135845.10",
      gene_type : "protein_coding",
      gene_name : "PIGC",
      gene_level : 2,
      hgnc_id : "HGNC:8960",
      havana_gene : "OTTHUMG00000034751.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 172420685,
      stop : 172468831,
      direction : "+",
      ID : "ENSG00000180999.11",
      gene_id : "ENSG00000180999.11",
      gene_type : "protein_coding",
      gene_name : "C1orf105",
      gene_level : 2,
      hgnc_id : "HGNC:29591",
      havana_gene : "OTTHUMG00000034750.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 172532349,
      stop : 172611833,
      direction : "+",
      ID : "ENSG00000094975.14",
      gene_id : "ENSG00000094975.14",
      gene_type : "protein_coding",
      gene_name : "SUCO",
      gene_level : 2,
      hgnc_id : "HGNC:1240",
      havana_gene : "OTTHUMG00000034839.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 172659103,
      stop : 172666876,
      direction : "+",
      ID : "ENSG00000117560.8",
      gene_id : "ENSG00000117560.8",
      gene_type : "protein_coding",
      gene_name : "FASLG",
      gene_level : 2,
      hgnc_id : "HGNC:11936",
      havana_gene : "OTTHUMG00000034841.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173039960,
      stop : 173050963,
      direction : "-",
      ID : "ENSG00000120337.9",
      gene_id : "ENSG00000120337.9",
      gene_type : "protein_coding",
      gene_name : "TNFSF18",
      gene_level : 2,
      hgnc_id : "HGNC:11932",
      havana_gene : "OTTHUMG00000034835.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173183731,
      stop : 173207331,
      direction : "-",
      ID : "ENSG00000117586.11",
      gene_id : "ENSG00000117586.11",
      gene_type : "protein_coding",
      gene_name : "TNFSF4",
      gene_level : 2,
      hgnc_id : "HGNC:11934",
      havana_gene : "OTTHUMG00000034838.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173477330,
      stop : 173488815,
      direction : "+",
      ID : "ENSG00000117592.9",
      gene_id : "ENSG00000117592.9",
      gene_type : "protein_coding",
      gene_name : "PRDX6",
      gene_level : 2,
      hgnc_id : "HGNC:16753",
      havana_gene : "OTTHUMG00000034804.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173500460,
      stop : 173603072,
      direction : "-",
      ID : "ENSG00000162753.13",
      gene_id : "ENSG00000162753.13",
      gene_type : "protein_coding",
      gene_name : "SLC9C2",
      gene_level : 2,
      hgnc_id : "HGNC:28664",
      havana_gene : "OTTHUMG00000034800.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173596060,
      stop : 173669837,
      direction : "-",
      ID : "ENSG00000285777.1",
      gene_id : "ENSG00000285777.1",
      gene_type : "protein_coding",
      gene_name : "AL139142.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193428.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173608336,
      stop : 173669851,
      direction : "-",
      ID : "ENSG00000183831.7",
      gene_id : "ENSG00000183831.7",
      gene_type : "protein_coding",
      gene_name : "ANKRD45",
      gene_level : 2,
      hgnc_id : "HGNC:24786",
      havana_gene : "OTTHUMG00000040546.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173635338,
      stop : 173637130,
      direction : "+",
      ID : "ENSG00000232113.3",
      gene_id : "ENSG00000232113.3",
      gene_type : "protein_coding",
      gene_name : "TEX50",
      gene_level : 2,
      hgnc_id : "HGNC:52382",
      havana_gene : "OTTHUMG00000040547.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173714941,
      stop : 173786692,
      direction : "+",
      ID : "ENSG00000076321.11",
      gene_id : "ENSG00000076321.11",
      gene_type : "protein_coding",
      gene_name : "KLHL20",
      gene_level : 2,
      hgnc_id : "HGNC:25056",
      havana_gene : "OTTHUMG00000040548.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173799550,
      stop : 173824720,
      direction : "-",
      ID : "ENSG00000120334.15",
      gene_id : "ENSG00000120334.15",
      gene_type : "protein_coding",
      gene_name : "CENPL",
      gene_level : 2,
      hgnc_id : "HGNC:17879",
      havana_gene : "OTTHUMG00000034802.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173824653,
      stop : 173858808,
      direction : "+",
      ID : "ENSG00000117593.12",
      gene_id : "ENSG00000117593.12",
      gene_type : "protein_coding",
      gene_name : "DARS2",
      gene_level : 2,
      hgnc_id : "HGNC:25538",
      havana_gene : "OTTHUMG00000034803.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173868082,
      stop : 173903549,
      direction : "+",
      ID : "ENSG00000185278.15",
      gene_id : "ENSG00000185278.15",
      gene_type : "protein_coding",
      gene_name : "ZBTB37",
      gene_level : 2,
      hgnc_id : "HGNC:28365",
      havana_gene : "OTTHUMG00000037274.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173903800,
      stop : 173917327,
      direction : "-",
      ID : "ENSG00000117601.15",
      gene_id : "ENSG00000117601.15",
      gene_type : "protein_coding",
      gene_name : "SERPINC1",
      gene_level : 2,
      hgnc_id : "HGNC:775",
      havana_gene : "OTTHUMG00000037276.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 173931084,
      stop : 174022357,
      direction : "-",
      ID : "ENSG00000135870.12",
      gene_id : "ENSG00000135870.12",
      gene_type : "protein_coding",
      gene_name : "RC3H1",
      gene_level : 2,
      hgnc_id : "HGNC:29434",
      havana_gene : "OTTHUMG00000037275.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 174159410,
      stop : 174995308,
      direction : "+",
      ID : "ENSG00000152061.23",
      gene_id : "ENSG00000152061.23",
      gene_type : "protein_coding",
      gene_name : "RABGAP1L",
      gene_level : 2,
      hgnc_id : "HGNC:24663",
      havana_gene : "OTTHUMG00000034899.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 174447964,
      stop : 174449545,
      direction : "+",
      ID : "ENSG00000203737.5",
      gene_id : "ENSG00000203737.5",
      gene_type : "protein_coding",
      gene_name : "GPR52",
      gene_level : 2,
      hgnc_id : "HGNC:4508",
      havana_gene : "OTTHUMG00000034901.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 174999163,
      stop : 175012027,
      direction : "+",
      ID : "ENSG00000116161.18",
      gene_id : "ENSG00000116161.18",
      gene_type : "protein_coding",
      gene_name : "CACYBP",
      gene_level : 1,
      hgnc_id : "HGNC:30423",
      havana_gene : "OTTHUMG00000034941.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 175010789,
      stop : 175023425,
      direction : "-",
      ID : "ENSG00000120333.4",
      gene_id : "ENSG00000120333.4",
      gene_type : "protein_coding",
      gene_name : "MRPS14",
      gene_level : 2,
      hgnc_id : "HGNC:14049",
      havana_gene : "OTTHUMG00000034878.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 175067833,
      stop : 175148075,
      direction : "+",
      ID : "ENSG00000120332.16",
      gene_id : "ENSG00000120332.16",
      gene_type : "protein_coding",
      gene_name : "TNN",
      gene_level : 2,
      hgnc_id : "HGNC:22942",
      havana_gene : "OTTHUMG00000034882.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 175156986,
      stop : 175192999,
      direction : "-",
      ID : "ENSG00000235750.10",
      gene_id : "ENSG00000235750.10",
      gene_type : "protein_coding",
      gene_name : "KIAA0040",
      gene_level : 2,
      hgnc_id : "HGNC:28950",
      havana_gene : "OTTHUMG00000034880.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 175315194,
      stop : 175743616,
      direction : "-",
      ID : "ENSG00000116147.17",
      gene_id : "ENSG00000116147.17",
      gene_type : "protein_coding",
      gene_name : "TNR",
      gene_level : 2,
      hgnc_id : "HGNC:11953",
      havana_gene : "OTTHUMG00000034876.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 175944831,
      stop : 176207286,
      direction : "-",
      ID : "ENSG00000143207.21",
      gene_id : "ENSG00000143207.21",
      gene_type : "protein_coding",
      gene_name : "COP1",
      gene_level : 2,
      hgnc_id : "HGNC:17440",
      havana_gene : "OTTHUMG00000034986.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 176463171,
      stop : 176845601,
      direction : "+",
      ID : "ENSG00000116183.11",
      gene_id : "ENSG00000116183.11",
      gene_type : "protein_coding",
      gene_name : "PAPPA2",
      gene_level : 2,
      hgnc_id : "HGNC:14615",
      havana_gene : "OTTHUMG00000035025.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 176857302,
      stop : 177164973,
      direction : "-",
      ID : "ENSG00000152092.16",
      gene_id : "ENSG00000152092.16",
      gene_type : "protein_coding",
      gene_name : "ASTN1",
      gene_level : 1,
      hgnc_id : "HGNC:773",
      havana_gene : "OTTHUMG00000035041.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 177170958,
      stop : 177282422,
      direction : "+",
      ID : "ENSG00000198797.7",
      gene_id : "ENSG00000198797.7",
      gene_type : "protein_coding",
      gene_name : "BRINP2",
      gene_level : 2,
      hgnc_id : "HGNC:13746",
      havana_gene : "OTTHUMG00000034953.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 177923956,
      stop : 177984303,
      direction : "-",
      ID : "ENSG00000120341.18",
      gene_id : "ENSG00000120341.18",
      gene_type : "protein_coding",
      gene_name : "SEC16B",
      gene_level : 1,
      hgnc_id : "HGNC:30301",
      havana_gene : "OTTHUMG00000167206.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 178094104,
      stop : 178484147,
      direction : "+",
      ID : "ENSG00000075391.17",
      gene_id : "ENSG00000075391.17",
      gene_type : "protein_coding",
      gene_name : "RASAL2",
      gene_level : 2,
      hgnc_id : "HGNC:9874",
      havana_gene : "OTTHUMG00000035022.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 178479247,
      stop : 178499634,
      direction : "-",
      ID : "ENSG00000188585.9",
      gene_id : "ENSG00000188585.9",
      gene_type : "protein_coding",
      gene_name : "CLEC20A",
      gene_level : 2,
      hgnc_id : "HGNC:34521",
      havana_gene : "OTTHUMG00000035021.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 178513109,
      stop : 178548602,
      direction : "+",
      ID : "ENSG00000240021.10",
      gene_id : "ENSG00000240021.10",
      gene_type : "protein_coding",
      gene_name : "TEX35",
      gene_level : 2,
      hgnc_id : "HGNC:25366",
      havana_gene : "OTTHUMG00000035023.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 178725147,
      stop : 178921841,
      direction : "+",
      ID : "ENSG00000116191.17",
      gene_id : "ENSG00000116191.17",
      gene_type : "protein_coding",
      gene_name : "RALGPS2",
      gene_level : 2,
      hgnc_id : "HGNC:30279",
      havana_gene : "OTTHUMG00000035076.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 178849535,
      stop : 178871077,
      direction : "-",
      ID : "ENSG00000116194.13",
      gene_id : "ENSG00000116194.13",
      gene_type : "protein_coding",
      gene_name : "ANGPTL1",
      gene_level : 2,
      hgnc_id : "HGNC:489",
      havana_gene : "OTTHUMG00000035075.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179025804,
      stop : 179076567,
      direction : "+",
      ID : "ENSG00000116199.12",
      gene_id : "ENSG00000116199.12",
      gene_type : "protein_coding",
      gene_name : "FAM20B",
      gene_level : 2,
      hgnc_id : "HGNC:23017",
      havana_gene : "OTTHUMG00000035073.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179082070,
      stop : 179098023,
      direction : "+",
      ID : "ENSG00000186283.14",
      gene_id : "ENSG00000186283.14",
      gene_type : "protein_coding",
      gene_name : "TOR3A",
      gene_level : 2,
      hgnc_id : "HGNC:11997",
      havana_gene : "OTTHUMG00000035077.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179099330,
      stop : 179229684,
      direction : "-",
      ID : "ENSG00000143322.21",
      gene_id : "ENSG00000143322.21",
      gene_type : "protein_coding",
      gene_name : "ABL2",
      gene_level : 2,
      hgnc_id : "HGNC:77",
      havana_gene : "OTTHUMG00000035199.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179293714,
      stop : 179358680,
      direction : "+",
      ID : "ENSG00000057252.13",
      gene_id : "ENSG00000057252.13",
      gene_type : "protein_coding",
      gene_name : "SOAT1",
      gene_level : 2,
      hgnc_id : "HGNC:11177",
      havana_gene : "OTTHUMG00000035253.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179365720,
      stop : 179554735,
      direction : "+",
      ID : "ENSG00000162779.22",
      gene_id : "ENSG00000162779.22",
      gene_type : "protein_coding",
      gene_name : "AXDND1",
      gene_level : 1,
      hgnc_id : "HGNC:26564",
      havana_gene : "OTTHUMG00000035266.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179550539,
      stop : 179575952,
      direction : "-",
      ID : "ENSG00000116218.13",
      gene_id : "ENSG00000116218.13",
      gene_type : "protein_coding",
      gene_name : "NPHS2",
      gene_level : 2,
      hgnc_id : "HGNC:13394",
      havana_gene : "OTTHUMG00000035252.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179591613,
      stop : 179691272,
      direction : "+",
      ID : "ENSG00000162782.16",
      gene_id : "ENSG00000162782.16",
      gene_type : "protein_coding",
      gene_name : "TDRD5",
      gene_level : 2,
      hgnc_id : "HGNC:20614",
      havana_gene : "OTTHUMG00000035259.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179743163,
      stop : 179816198,
      direction : "+",
      ID : "ENSG00000143340.6",
      gene_id : "ENSG00000143340.6",
      gene_type : "protein_coding",
      gene_name : "FAM163A",
      gene_level : 2,
      hgnc_id : "HGNC:28274",
      havana_gene : "OTTHUMG00000035262.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179839967,
      stop : 179877803,
      direction : "-",
      ID : "ENSG00000169905.13",
      gene_id : "ENSG00000169905.13",
      gene_type : "protein_coding",
      gene_name : "TOR1AIP2",
      gene_level : 2,
      hgnc_id : "HGNC:24055",
      havana_gene : "OTTHUMG00000035265.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179882042,
      stop : 179920077,
      direction : "+",
      ID : "ENSG00000143337.19",
      gene_id : "ENSG00000143337.19",
      gene_type : "protein_coding",
      gene_name : "TOR1AIP1",
      gene_level : 1,
      hgnc_id : "HGNC:29456",
      havana_gene : "OTTHUMG00000035257.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 179954773,
      stop : 180114875,
      direction : "+",
      ID : "ENSG00000135837.16",
      gene_id : "ENSG00000135837.16",
      gene_type : "protein_coding",
      gene_name : "CEP350",
      gene_level : 2,
      hgnc_id : "HGNC:24238",
      havana_gene : "OTTHUMG00000035269.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 180154869,
      stop : 180204030,
      direction : "+",
      ID : "ENSG00000116260.17",
      gene_id : "ENSG00000116260.17",
      gene_type : "protein_coding",
      gene_name : "QSOX1",
      gene_level : 1,
      hgnc_id : "HGNC:9756",
      havana_gene : "OTTHUMG00000035256.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 180230264,
      stop : 180278984,
      direction : "+",
      ID : "ENSG00000121454.6",
      gene_id : "ENSG00000121454.6",
      gene_type : "protein_coding",
      gene_name : "LHX4",
      gene_level : 2,
      hgnc_id : "HGNC:21734",
      havana_gene : "OTTHUMG00000035115.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 180269653,
      stop : 180502954,
      direction : "-",
      ID : "ENSG00000230124.8",
      gene_id : "ENSG00000230124.8",
      gene_type : "protein_coding",
      gene_name : "ACBD6",
      gene_level : 2,
      hgnc_id : "HGNC:23339",
      havana_gene : "OTTHUMG00000035117.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 180632022,
      stop : 180890279,
      direction : "+",
      ID : "ENSG00000143324.14",
      gene_id : "ENSG00000143324.14",
      gene_type : "protein_coding",
      gene_name : "XPR1",
      gene_level : 2,
      hgnc_id : "HGNC:12827",
      havana_gene : "OTTHUMG00000035116.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 180912897,
      stop : 180951614,
      direction : "+",
      ID : "ENSG00000135835.12",
      gene_id : "ENSG00000135835.12",
      gene_type : "protein_coding",
      gene_name : "KIAA1614",
      gene_level : 2,
      hgnc_id : "HGNC:29327",
      havana_gene : "OTTHUMG00000035183.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 180972712,
      stop : 181023121,
      direction : "-",
      ID : "ENSG00000135823.14",
      gene_id : "ENSG00000135823.14",
      gene_type : "protein_coding",
      gene_name : "STX6",
      gene_level : 2,
      hgnc_id : "HGNC:11441",
      havana_gene : "OTTHUMG00000035179.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 181033425,
      stop : 181061938,
      direction : "+",
      ID : "ENSG00000153029.15",
      gene_id : "ENSG00000153029.15",
      gene_type : "protein_coding",
      gene_name : "MR1",
      gene_level : 2,
      hgnc_id : "HGNC:4975",
      havana_gene : "OTTHUMG00000035175.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 181088700,
      stop : 181092900,
      direction : "+",
      ID : "ENSG00000162783.11",
      gene_id : "ENSG00000162783.11",
      gene_type : "protein_coding",
      gene_name : "IER5",
      gene_level : 2,
      hgnc_id : "HGNC:5393",
      havana_gene : "OTTHUMG00000035178.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 181317690,
      stop : 181808084,
      direction : "+",
      ID : "ENSG00000198216.12",
      gene_id : "ENSG00000198216.12",
      gene_type : "protein_coding",
      gene_name : "CACNA1E",
      gene_level : 2,
      hgnc_id : "HGNC:1392",
      havana_gene : "OTTHUMG00000037301.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182054570,
      stop : 182061712,
      direction : "-",
      ID : "ENSG00000179930.6",
      gene_id : "ENSG00000179930.6",
      gene_type : "protein_coding",
      gene_name : "ZNF648",
      gene_level : 1,
      hgnc_id : "HGNC:18190",
      havana_gene : "OTTHUMG00000037302.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182378098,
      stop : 182392206,
      direction : "-",
      ID : "ENSG00000135821.19",
      gene_id : "ENSG00000135821.19",
      gene_type : "protein_coding",
      gene_name : "GLUL",
      gene_level : 2,
      hgnc_id : "HGNC:4341",
      havana_gene : "OTTHUMG00000037407.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182398117,
      stop : 182400667,
      direction : "-",
      ID : "ENSG00000203730.3",
      gene_id : "ENSG00000203730.3",
      gene_type : "protein_coding",
      gene_name : "TEDDM1",
      gene_level : 2,
      hgnc_id : "HGNC:30233",
      havana_gene : "OTTHUMG00000037398.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182409192,
      stop : 182560599,
      direction : "+",
      ID : "ENSG00000121446.20",
      gene_id : "ENSG00000121446.20",
      gene_type : "protein_coding",
      gene_name : "RGSL1",
      gene_level : 2,
      hgnc_id : "HGNC:18636",
      havana_gene : "OTTHUMG00000035217.14",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182573634,
      stop : 182589256,
      direction : "-",
      ID : "ENSG00000135828.11",
      gene_id : "ENSG00000135828.11",
      gene_type : "protein_coding",
      gene_name : "RNASEL",
      gene_level : 2,
      hgnc_id : "HGNC:10050",
      havana_gene : "OTTHUMG00000035213.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182598623,
      stop : 182604389,
      direction : "-",
      ID : "ENSG00000143333.7",
      gene_id : "ENSG00000143333.7",
      gene_type : "protein_coding",
      gene_name : "RGS16",
      gene_level : 2,
      hgnc_id : "HGNC:9997",
      havana_gene : "OTTHUMG00000035212.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182641816,
      stop : 182684576,
      direction : "-",
      ID : "ENSG00000135824.12",
      gene_id : "ENSG00000135824.12",
      gene_type : "protein_coding",
      gene_name : "RGS8",
      gene_level : 2,
      hgnc_id : "HGNC:16810",
      havana_gene : "OTTHUMG00000035219.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182789293,
      stop : 182830384,
      direction : "+",
      ID : "ENSG00000135838.13",
      gene_id : "ENSG00000135838.13",
      gene_type : "protein_coding",
      gene_name : "NPL",
      gene_level : 2,
      hgnc_id : "HGNC:16781",
      havana_gene : "OTTHUMG00000035321.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182839347,
      stop : 182887982,
      direction : "+",
      ID : "ENSG00000135829.17",
      gene_id : "ENSG00000135829.17",
      gene_type : "protein_coding",
      gene_name : "DHX9",
      gene_level : 2,
      hgnc_id : "HGNC:2750",
      havana_gene : "OTTHUMG00000035337.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 182899865,
      stop : 182953525,
      direction : "-",
      ID : "ENSG00000157060.16",
      gene_id : "ENSG00000157060.16",
      gene_type : "protein_coding",
      gene_name : "SHCBP1L",
      gene_level : 2,
      hgnc_id : "HGNC:16788",
      havana_gene : "OTTHUMG00000035419.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183023420,
      stop : 183145592,
      direction : "+",
      ID : "ENSG00000135862.6",
      gene_id : "ENSG00000135862.6",
      gene_type : "protein_coding",
      gene_name : "LAMC1",
      gene_level : 1,
      hgnc_id : "HGNC:6492",
      havana_gene : "OTTHUMG00000035418.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183186238,
      stop : 183245127,
      direction : "+",
      ID : "ENSG00000058085.15",
      gene_id : "ENSG00000058085.15",
      gene_type : "protein_coding",
      gene_name : "LAMC2",
      gene_level : 2,
      hgnc_id : "HGNC:6493",
      havana_gene : "OTTHUMG00000035520.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183248237,
      stop : 183418380,
      direction : "-",
      ID : "ENSG00000157064.11",
      gene_id : "ENSG00000157064.11",
      gene_type : "protein_coding",
      gene_name : "NMNAT2",
      gene_level : 2,
      hgnc_id : "HGNC:16789",
      havana_gene : "OTTHUMG00000035519.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183472216,
      stop : 183598246,
      direction : "+",
      ID : "ENSG00000116698.21",
      gene_id : "ENSG00000116698.21",
      gene_type : "protein_coding",
      gene_name : "SMG7",
      gene_level : 1,
      hgnc_id : "HGNC:16792",
      havana_gene : "OTTHUMG00000035221.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183555562,
      stop : 183590876,
      direction : "-",
      ID : "ENSG00000116701.15",
      gene_id : "ENSG00000116701.15",
      gene_type : "protein_coding",
      gene_name : "NCF2",
      gene_level : 2,
      hgnc_id : "HGNC:7661",
      havana_gene : "OTTHUMG00000035329.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183620846,
      stop : 183635783,
      direction : "-",
      ID : "ENSG00000162704.16",
      gene_id : "ENSG00000162704.16",
      gene_type : "protein_coding",
      gene_name : "ARPC5",
      gene_level : 2,
      hgnc_id : "HGNC:708",
      havana_gene : "OTTHUMG00000035326.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183636085,
      stop : 183928532,
      direction : "+",
      ID : "ENSG00000143344.16",
      gene_id : "ENSG00000143344.16",
      gene_type : "protein_coding",
      gene_name : "RGL1",
      gene_level : 2,
      hgnc_id : "HGNC:30281",
      havana_gene : "OTTHUMG00000035328.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183646275,
      stop : 183653316,
      direction : "-",
      ID : "ENSG00000173627.8",
      gene_id : "ENSG00000173627.8",
      gene_type : "protein_coding",
      gene_name : "APOBEC4",
      gene_level : 2,
      hgnc_id : "HGNC:32152",
      havana_gene : "OTTHUMG00000035459.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 183929854,
      stop : 184037729,
      direction : "-",
      ID : "ENSG00000198756.12",
      gene_id : "ENSG00000198756.12",
      gene_type : "protein_coding",
      gene_name : "COLGALT2",
      gene_level : 2,
      hgnc_id : "HGNC:16790",
      havana_gene : "OTTHUMG00000035460.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 184051651,
      stop : 184123978,
      direction : "+",
      ID : "ENSG00000198860.14",
      gene_id : "ENSG00000198860.14",
      gene_type : "protein_coding",
      gene_name : "TSEN15",
      gene_level : 2,
      hgnc_id : "HGNC:16791",
      havana_gene : "OTTHUMG00000035461.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 184387029,
      stop : 184629019,
      direction : "+",
      ID : "ENSG00000116667.15",
      gene_id : "ENSG00000116667.15",
      gene_type : "protein_coding",
      gene_name : "C1orf21",
      gene_level : 2,
      hgnc_id : "HGNC:15494",
      havana_gene : "OTTHUMG00000035386.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 184690237,
      stop : 184754907,
      direction : "-",
      ID : "ENSG00000116406.19",
      gene_id : "ENSG00000116406.19",
      gene_type : "protein_coding",
      gene_name : "EDEM3",
      gene_level : 2,
      hgnc_id : "HGNC:16787",
      havana_gene : "OTTHUMG00000035387.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 184790724,
      stop : 184974508,
      direction : "-",
      ID : "ENSG00000135842.17",
      gene_id : "ENSG00000135842.17",
      gene_type : "protein_coding",
      gene_name : "NIBAN1",
      gene_level : 2,
      hgnc_id : "HGNC:16784",
      havana_gene : "OTTHUMG00000035388.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 185045526,
      stop : 185102603,
      direction : "+",
      ID : "ENSG00000121481.11",
      gene_id : "ENSG00000121481.11",
      gene_type : "protein_coding",
      gene_name : "RNF2",
      gene_level : 2,
      hgnc_id : "HGNC:10061",
      havana_gene : "OTTHUMG00000035391.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 185118101,
      stop : 185157072,
      direction : "-",
      ID : "ENSG00000121486.12",
      gene_id : "ENSG00000121486.12",
      gene_type : "protein_coding",
      gene_name : "TRMT1L",
      gene_level : 2,
      hgnc_id : "HGNC:16782",
      havana_gene : "OTTHUMG00000035389.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 185157080,
      stop : 185291781,
      direction : "+",
      ID : "ENSG00000116668.13",
      gene_id : "ENSG00000116668.13",
      gene_type : "protein_coding",
      gene_name : "SWT1",
      gene_level : 2,
      hgnc_id : "HGNC:16785",
      havana_gene : "OTTHUMG00000035390.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 185296388,
      stop : 185317273,
      direction : "-",
      ID : "ENSG00000116679.16",
      gene_id : "ENSG00000116679.16",
      gene_type : "protein_coding",
      gene_name : "IVNS1ABP",
      gene_level : 2,
      hgnc_id : "HGNC:16951",
      havana_gene : "OTTHUMG00000035384.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 185734391,
      stop : 186190949,
      direction : "+",
      ID : "ENSG00000143341.12",
      gene_id : "ENSG00000143341.12",
      gene_type : "protein_coding",
      gene_name : "HMCN1",
      gene_level : 2,
      hgnc_id : "HGNC:19194",
      havana_gene : "OTTHUMG00000059337.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 186296279,
      stop : 186314567,
      direction : "+",
      ID : "ENSG00000116690.13",
      gene_id : "ENSG00000116690.13",
      gene_type : "protein_coding",
      gene_name : "PRG4",
      gene_level : 1,
      hgnc_id : "HGNC:9364",
      havana_gene : "OTTHUMG00000035574.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 186311652,
      stop : 186375693,
      direction : "-",
      ID : "ENSG00000047410.14",
      gene_id : "ENSG00000047410.14",
      gene_type : "protein_coding",
      gene_name : "TPR",
      gene_level : 2,
      hgnc_id : "HGNC:12017",
      havana_gene : "OTTHUMG00000035580.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 186375838,
      stop : 186421378,
      direction : "+",
      ID : "ENSG00000157181.16",
      gene_id : "ENSG00000157181.16",
      gene_type : "protein_coding",
      gene_name : "ODR4",
      gene_level : 2,
      hgnc_id : "HGNC:24299",
      havana_gene : "OTTHUMG00000035579.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 186443566,
      stop : 186461114,
      direction : "-",
      ID : "ENSG00000116703.14",
      gene_id : "ENSG00000116703.14",
      gene_type : "protein_coding",
      gene_name : "PDC",
      gene_level : 2,
      hgnc_id : "HGNC:8759",
      havana_gene : "OTTHUMG00000035575.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 186671791,
      stop : 186680922,
      direction : "-",
      ID : "ENSG00000073756.13",
      gene_id : "ENSG00000073756.13",
      gene_type : "protein_coding",
      gene_name : "PTGS2",
      gene_level : 2,
      hgnc_id : "HGNC:9605",
      havana_gene : "OTTHUMG00000035473.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 186828949,
      stop : 186988981,
      direction : "+",
      ID : "ENSG00000116711.10",
      gene_id : "ENSG00000116711.10",
      gene_type : "protein_coding",
      gene_name : "PLA2G4A",
      gene_level : 2,
      hgnc_id : "HGNC:9035",
      havana_gene : "OTTHUMG00000035512.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 190097658,
      stop : 190478404,
      direction : "-",
      ID : "ENSG00000162670.11",
      gene_id : "ENSG00000162670.11",
      gene_type : "protein_coding",
      gene_name : "BRINP3",
      gene_level : 2,
      hgnc_id : "HGNC:22393",
      havana_gene : "OTTHUMG00000035533.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 192158462,
      stop : 192185815,
      direction : "+",
      ID : "ENSG00000150681.10",
      gene_id : "ENSG00000150681.10",
      gene_type : "protein_coding",
      gene_name : "RGS18",
      gene_level : 2,
      hgnc_id : "HGNC:14261",
      havana_gene : "OTTHUMG00000035592.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 192316992,
      stop : 192367285,
      direction : "+",
      ID : "ENSG00000253148.1",
      gene_id : "ENSG00000253148.1",
      gene_type : "protein_coding",
      gene_name : "RGS21",
      gene_level : 2,
      hgnc_id : "HGNC:26839",
      havana_gene : "OTTHUMG00000035594.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 192575763,
      stop : 192580024,
      direction : "+",
      ID : "ENSG00000090104.12",
      gene_id : "ENSG00000090104.12",
      gene_type : "protein_coding",
      gene_name : "RGS1",
      gene_level : 2,
      hgnc_id : "HGNC:9991",
      havana_gene : "OTTHUMG00000035598.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 192636138,
      stop : 192660311,
      direction : "+",
      ID : "ENSG00000127074.15",
      gene_id : "ENSG00000127074.15",
      gene_type : "protein_coding",
      gene_name : "RGS13",
      gene_level : 2,
      hgnc_id : "HGNC:9995",
      havana_gene : "OTTHUMG00000035601.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 192716132,
      stop : 192716653,
      direction : "+",
      ID : "ENSG00000231767.4",
      gene_id : "ENSG00000231767.4",
      gene_type : "protein_coding",
      gene_name : "RPS27AP5",
      gene_level : 2,
      hgnc_id : "HGNC:36867",
      havana_gene : "OTTHUMG00000035593.2",
      tag : "ncRNA_host, retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 192809039,
      stop : 192812275,
      direction : "+",
      ID : "ENSG00000116741.8",
      gene_id : "ENSG00000116741.8",
      gene_type : "protein_coding",
      gene_name : "RGS2",
      gene_level : 2,
      hgnc_id : "HGNC:9998",
      havana_gene : "OTTHUMG00000035600.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 193012250,
      stop : 193060080,
      direction : "-",
      ID : "ENSG00000116750.14",
      gene_id : "ENSG00000116750.14",
      gene_type : "protein_coding",
      gene_name : "UCHL5",
      gene_level : 2,
      hgnc_id : "HGNC:19678",
      havana_gene : "OTTHUMG00000035561.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 193059454,
      stop : 193091777,
      direction : "+",
      ID : "ENSG00000116747.13",
      gene_id : "ENSG00000116747.13",
      gene_type : "protein_coding",
      gene_name : "RO60",
      gene_level : 1,
      hgnc_id : "HGNC:11313",
      havana_gene : "OTTHUMG00000035675.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 193090866,
      stop : 193106114,
      direction : "-",
      ID : "ENSG00000023572.10",
      gene_id : "ENSG00000023572.10",
      gene_type : "protein_coding",
      gene_name : "GLRX2",
      gene_level : 2,
      hgnc_id : "HGNC:16065",
      havana_gene : "OTTHUMG00000035677.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 193121983,
      stop : 193254815,
      direction : "+",
      ID : "ENSG00000134371.14",
      gene_id : "ENSG00000134371.14",
      gene_type : "protein_coding",
      gene_name : "CDC73",
      gene_level : 2,
      hgnc_id : "HGNC:16783",
      havana_gene : "OTTHUMG00000035676.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 193178730,
      stop : 193186613,
      direction : "-",
      ID : "ENSG00000162630.6",
      gene_id : "ENSG00000162630.6",
      gene_type : "protein_coding",
      gene_name : "B3GALT2",
      gene_level : 2,
      hgnc_id : "HGNC:917",
      havana_gene : "OTTHUMG00000035687.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196225779,
      stop : 196609225,
      direction : "-",
      ID : "ENSG00000162687.19",
      gene_id : "ENSG00000162687.19",
      gene_type : "protein_coding",
      gene_name : "KCNT2",
      gene_level : 2,
      hgnc_id : "HGNC:18866",
      havana_gene : "OTTHUMG00000035611.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196652043,
      stop : 196747504,
      direction : "+",
      ID : "ENSG00000000971.16",
      gene_id : "ENSG00000000971.16",
      gene_type : "protein_coding",
      gene_name : "CFH",
      gene_level : 1,
      hgnc_id : "HGNC:4883",
      havana_gene : "OTTHUMG00000035607.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196774813,
      stop : 196795407,
      direction : "+",
      ID : "ENSG00000116785.14",
      gene_id : "ENSG00000116785.14",
      gene_type : "protein_coding",
      gene_name : "CFHR3",
      gene_level : 2,
      hgnc_id : "HGNC:16980",
      havana_gene : "OTTHUMG00000035929.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196819731,
      stop : 196832189,
      direction : "+",
      ID : "ENSG00000244414.7",
      gene_id : "ENSG00000244414.7",
      gene_type : "protein_coding",
      gene_name : "CFHR1",
      gene_level : 2,
      hgnc_id : "HGNC:4888",
      havana_gene : "OTTHUMG00000036276.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196888014,
      stop : 196918713,
      direction : "+",
      ID : "ENSG00000134365.13",
      gene_id : "ENSG00000134365.13",
      gene_type : "protein_coding",
      gene_name : "CFHR4",
      gene_level : 2,
      hgnc_id : "HGNC:16979",
      havana_gene : "OTTHUMG00000036647.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196943738,
      stop : 196959622,
      direction : "+",
      ID : "ENSG00000080910.13",
      gene_id : "ENSG00000080910.13",
      gene_type : "protein_coding",
      gene_name : "CFHR2",
      gene_level : 2,
      hgnc_id : "HGNC:4890",
      havana_gene : "OTTHUMG00000036518.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 196977556,
      stop : 197009678,
      direction : "+",
      ID : "ENSG00000134389.10",
      gene_id : "ENSG00000134389.10",
      gene_type : "protein_coding",
      gene_name : "CFHR5",
      gene_level : 2,
      hgnc_id : "HGNC:24668",
      havana_gene : "OTTHUMG00000036517.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197038741,
      stop : 197067260,
      direction : "-",
      ID : "ENSG00000143278.5",
      gene_id : "ENSG00000143278.5",
      gene_type : "protein_coding",
      gene_name : "F13B",
      gene_level : 2,
      hgnc_id : "HGNC:3534",
      havana_gene : "OTTHUMG00000036519.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197084121,
      stop : 197146694,
      direction : "-",
      ID : "ENSG00000066279.19",
      gene_id : "ENSG00000066279.19",
      gene_type : "protein_coding",
      gene_name : "ASPM",
      gene_level : 2,
      hgnc_id : "HGNC:19048",
      havana_gene : "OTTHUMG00000036277.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197153682,
      stop : 197201293,
      direction : "-",
      ID : "ENSG00000177888.8",
      gene_id : "ENSG00000177888.8",
      gene_type : "protein_coding",
      gene_name : "ZBTB41",
      gene_level : 2,
      hgnc_id : "HGNC:24819",
      havana_gene : "OTTHUMG00000036275.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197268204,
      stop : 197478455,
      direction : "+",
      ID : "ENSG00000134376.17",
      gene_id : "ENSG00000134376.17",
      gene_type : "protein_coding",
      gene_name : "CRB1",
      gene_level : 1,
      hgnc_id : "HGNC:2343",
      havana_gene : "OTTHUMG00000035663.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197504748,
      stop : 197775696,
      direction : "-",
      ID : "ENSG00000213047.13",
      gene_id : "ENSG00000213047.13",
      gene_type : "protein_coding",
      gene_name : "DENND1B",
      gene_level : 2,
      hgnc_id : "HGNC:28404",
      havana_gene : "OTTHUMG00000035653.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197902630,
      stop : 197907367,
      direction : "+",
      ID : "ENSG00000203724.11",
      gene_id : "ENSG00000203724.11",
      gene_type : "protein_coding",
      gene_name : "C1orf53",
      gene_level : 2,
      hgnc_id : "HGNC:30003",
      havana_gene : "OTTHUMG00000035659.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 197911902,
      stop : 197935478,
      direction : "+",
      ID : "ENSG00000143355.16",
      gene_id : "ENSG00000143355.16",
      gene_type : "protein_coding",
      gene_name : "LHX9",
      gene_level : 1,
      hgnc_id : "HGNC:14222",
      havana_gene : "OTTHUMG00000035656.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 198156994,
      stop : 198322420,
      direction : "+",
      ID : "ENSG00000151414.15",
      gene_id : "ENSG00000151414.15",
      gene_type : "protein_coding",
      gene_name : "NEK7",
      gene_level : 1,
      hgnc_id : "HGNC:13386",
      havana_gene : "OTTHUMG00000035658.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 198523222,
      stop : 198540945,
      direction : "-",
      ID : "ENSG00000151418.12",
      gene_id : "ENSG00000151418.12",
      gene_type : "protein_coding",
      gene_name : "ATP6V1G3",
      gene_level : 2,
      hgnc_id : "HGNC:18265",
      havana_gene : "OTTHUMG00000035661.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 198638457,
      stop : 198757476,
      direction : "+",
      ID : "ENSG00000081237.20",
      gene_id : "ENSG00000081237.20",
      gene_type : "protein_coding",
      gene_name : "PTPRC",
      gene_level : 2,
      hgnc_id : "HGNC:9666",
      havana_gene : "OTTHUMG00000035702.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200027614,
      stop : 200177420,
      direction : "+",
      ID : "ENSG00000116833.14",
      gene_id : "ENSG00000116833.14",
      gene_type : "protein_coding",
      gene_name : "NR5A2",
      gene_level : 2,
      hgnc_id : "HGNC:7984",
      havana_gene : "OTTHUMG00000035635.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200404940,
      stop : 200410056,
      direction : "-",
      ID : "ENSG00000162702.8",
      gene_id : "ENSG00000162702.8",
      gene_type : "protein_coding",
      gene_name : "ZNF281",
      gene_level : 2,
      hgnc_id : "HGNC:13075",
      havana_gene : "OTTHUMG00000035724.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200551497,
      stop : 200620751,
      direction : "-",
      ID : "ENSG00000118193.12",
      gene_id : "ENSG00000118193.12",
      gene_type : "protein_coding",
      gene_name : "KIF14",
      gene_level : 2,
      hgnc_id : "HGNC:19181",
      havana_gene : "OTTHUMG00000035723.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200623896,
      stop : 200669907,
      direction : "-",
      ID : "ENSG00000118197.14",
      gene_id : "ENSG00000118197.14",
      gene_type : "protein_coding",
      gene_name : "DDX59",
      gene_level : 1,
      hgnc_id : "HGNC:25360",
      havana_gene : "OTTHUMG00000035725.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200739558,
      stop : 200860704,
      direction : "+",
      ID : "ENSG00000118200.14",
      gene_id : "ENSG00000118200.14",
      gene_type : "protein_coding",
      gene_name : "CAMSAP2",
      gene_level : 2,
      hgnc_id : "HGNC:29188",
      havana_gene : "OTTHUMG00000035740.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200872981,
      stop : 200874178,
      direction : "+",
      ID : "ENSG00000170128.5",
      gene_id : "ENSG00000170128.5",
      gene_type : "protein_coding",
      gene_name : "GPR25",
      gene_level : 2,
      hgnc_id : "HGNC:4480",
      havana_gene : "OTTHUMG00000035788.4",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200891048,
      stop : 200915742,
      direction : "+",
      ID : "ENSG00000163362.11",
      gene_id : "ENSG00000163362.11",
      gene_type : "protein_coding",
      gene_name : "INAVA",
      gene_level : 2,
      hgnc_id : "HGNC:25599",
      havana_gene : "OTTHUMG00000035789.12",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 200969390,
      stop : 201023714,
      direction : "-",
      ID : "ENSG00000116852.15",
      gene_id : "ENSG00000116852.15",
      gene_type : "protein_coding",
      gene_name : "KIF21B",
      gene_level : 2,
      hgnc_id : "HGNC:29442",
      havana_gene : "OTTHUMG00000035787.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201039512,
      stop : 201112451,
      direction : "-",
      ID : "ENSG00000081248.12",
      gene_id : "ENSG00000081248.12",
      gene_type : "protein_coding",
      gene_name : "CACNA1S",
      gene_level : 2,
      hgnc_id : "HGNC:1397",
      havana_gene : "OTTHUMG00000035784.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201113953,
      stop : 201127184,
      direction : "-",
      ID : "ENSG00000232237.3",
      gene_id : "ENSG00000232237.3",
      gene_type : "protein_coding",
      gene_name : "ASCL5",
      gene_level : 2,
      hgnc_id : "HGNC:33169",
      havana_gene : "OTTHUMG00000057661.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201134772,
      stop : 201171574,
      direction : "-",
      ID : "ENSG00000116857.17",
      gene_id : "ENSG00000116857.17",
      gene_type : "protein_coding",
      gene_name : "TMEM9",
      gene_level : 2,
      hgnc_id : "HGNC:18823",
      havana_gene : "OTTHUMG00000035831.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201190824,
      stop : 201228952,
      direction : "+",
      ID : "ENSG00000163395.17",
      gene_id : "ENSG00000163395.17",
      gene_type : "protein_coding",
      gene_name : "IGFN1",
      gene_level : 2,
      hgnc_id : "HGNC:24607",
      havana_gene : "OTTHUMG00000035728.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201283452,
      stop : 201332993,
      direction : "+",
      ID : "ENSG00000081277.13",
      gene_id : "ENSG00000081277.13",
      gene_type : "protein_coding",
      gene_name : "PKP1",
      gene_level : 2,
      hgnc_id : "HGNC:9023",
      havana_gene : "OTTHUMG00000035729.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201359008,
      stop : 201377764,
      direction : "-",
      ID : "ENSG00000118194.20",
      gene_id : "ENSG00000118194.20",
      gene_type : "protein_coding",
      gene_name : "TNNT2",
      gene_level : 2,
      hgnc_id : "HGNC:11949",
      havana_gene : "OTTHUMG00000035733.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201380833,
      stop : 201399915,
      direction : "-",
      ID : "ENSG00000159166.15",
      gene_id : "ENSG00000159166.15",
      gene_type : "protein_coding",
      gene_name : "LAD1",
      gene_level : 2,
      hgnc_id : "HGNC:6472",
      havana_gene : "OTTHUMG00000035737.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201403768,
      stop : 201429866,
      direction : "-",
      ID : "ENSG00000159173.19",
      gene_id : "ENSG00000159173.19",
      gene_type : "protein_coding",
      gene_name : "TNNI1",
      gene_level : 2,
      hgnc_id : "HGNC:11945",
      havana_gene : "OTTHUMG00000035736.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201464278,
      stop : 201469237,
      direction : "-",
      ID : "ENSG00000174307.7",
      gene_id : "ENSG00000174307.7",
      gene_type : "protein_coding",
      gene_name : "PHLDA3",
      gene_level : 2,
      hgnc_id : "HGNC:8934",
      havana_gene : "OTTHUMG00000035767.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201483530,
      stop : 201509456,
      direction : "-",
      ID : "ENSG00000159176.14",
      gene_id : "ENSG00000159176.14",
      gene_type : "protein_coding",
      gene_name : "CSRP1",
      gene_level : 2,
      hgnc_id : "HGNC:2469",
      havana_gene : "OTTHUMG00000035773.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201622885,
      stop : 201826969,
      direction : "+",
      ID : "ENSG00000134369.15",
      gene_id : "ENSG00000134369.15",
      gene_type : "protein_coding",
      gene_name : "NAV1",
      gene_level : 1,
      hgnc_id : "HGNC:15989",
      havana_gene : "OTTHUMG00000035766.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201829149,
      stop : 201884291,
      direction : "+",
      ID : "ENSG00000198700.10",
      gene_id : "ENSG00000198700.10",
      gene_type : "protein_coding",
      gene_name : "IPO9",
      gene_level : 2,
      hgnc_id : "HGNC:19425",
      havana_gene : "OTTHUMG00000035805.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201888680,
      stop : 201892587,
      direction : "+",
      ID : "ENSG00000198892.7",
      gene_id : "ENSG00000198892.7",
      gene_type : "protein_coding",
      gene_name : "SHISA4",
      gene_level : 2,
      hgnc_id : "HGNC:27139",
      havana_gene : "OTTHUMG00000035807.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201896456,
      stop : 201946588,
      direction : "-",
      ID : "ENSG00000163431.13",
      gene_id : "ENSG00000163431.13",
      gene_type : "protein_coding",
      gene_name : "LMOD1",
      gene_level : 2,
      hgnc_id : "HGNC:6647",
      havana_gene : "OTTHUMG00000035802.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201955503,
      stop : 201970664,
      direction : "+",
      ID : "ENSG00000134375.11",
      gene_id : "ENSG00000134375.11",
      gene_type : "protein_coding",
      gene_name : "TIMM17A",
      gene_level : 2,
      hgnc_id : "HGNC:17315",
      havana_gene : "OTTHUMG00000035806.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 201982372,
      stop : 202006147,
      direction : "+",
      ID : "ENSG00000176393.11",
      gene_id : "ENSG00000176393.11",
      gene_type : "protein_coding",
      gene_name : "RNPEP",
      gene_level : 2,
      hgnc_id : "HGNC:10078",
      havana_gene : "OTTHUMG00000035866.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202007945,
      stop : 202017183,
      direction : "+",
      ID : "ENSG00000163435.16",
      gene_id : "ENSG00000163435.16",
      gene_type : "protein_coding",
      gene_name : "ELF3",
      gene_level : 2,
      hgnc_id : "HGNC:3318",
      havana_gene : "OTTHUMG00000035867.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202122917,
      stop : 202133592,
      direction : "+",
      ID : "ENSG00000170075.9",
      gene_id : "ENSG00000170075.9",
      gene_type : "protein_coding",
      gene_name : "GPR37L1",
      gene_level : 2,
      hgnc_id : "HGNC:14923",
      havana_gene : "OTTHUMG00000035924.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202133404,
      stop : 202144743,
      direction : "-",
      ID : "ENSG00000143862.8",
      gene_id : "ENSG00000143862.8",
      gene_type : "protein_coding",
      gene_name : "ARL8A",
      gene_level : 2,
      hgnc_id : "HGNC:25192",
      havana_gene : "OTTHUMG00000035923.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202147013,
      stop : 202161588,
      direction : "-",
      ID : "ENSG00000143851.15",
      gene_id : "ENSG00000143851.15",
      gene_type : "protein_coding",
      gene_name : "PTPN7",
      gene_level : 1,
      hgnc_id : "HGNC:9659",
      havana_gene : "OTTHUMG00000035931.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202193799,
      stop : 202319781,
      direction : "+",
      ID : "ENSG00000133067.18",
      gene_id : "ENSG00000133067.18",
      gene_type : "protein_coding",
      gene_name : "LGR6",
      gene_level : 1,
      hgnc_id : "HGNC:19719",
      havana_gene : "OTTHUMG00000041383.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202331657,
      stop : 202341980,
      direction : "-",
      ID : "ENSG00000077152.11",
      gene_id : "ENSG00000077152.11",
      gene_type : "protein_coding",
      gene_name : "UBE2T",
      gene_level : 2,
      hgnc_id : "HGNC:25009",
      havana_gene : "OTTHUMG00000041392.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202348699,
      stop : 202592706,
      direction : "+",
      ID : "ENSG00000077157.22",
      gene_id : "ENSG00000077157.22",
      gene_type : "protein_coding",
      gene_name : "PPP1R12B",
      gene_level : 1,
      hgnc_id : "HGNC:7619",
      havana_gene : "OTTHUMG00000041393.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202590596,
      stop : 202710454,
      direction : "-",
      ID : "ENSG00000143858.12",
      gene_id : "ENSG00000143858.12",
      gene_type : "protein_coding",
      gene_name : "SYT2",
      gene_level : 2,
      hgnc_id : "HGNC:11510",
      havana_gene : "OTTHUMG00000041388.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202724495,
      stop : 202808487,
      direction : "-",
      ID : "ENSG00000117139.18",
      gene_id : "ENSG00000117139.18",
      gene_type : "protein_coding",
      gene_name : "KDM5B",
      gene_level : 1,
      hgnc_id : "HGNC:18039",
      havana_gene : "OTTHUMG00000041401.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202878282,
      stop : 202889149,
      direction : "-",
      ID : "ENSG00000183155.5",
      gene_id : "ENSG00000183155.5",
      gene_type : "protein_coding",
      gene_name : "RABIF",
      gene_level : 2,
      hgnc_id : "HGNC:9797",
      havana_gene : "OTTHUMG00000041400.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202891116,
      stop : 202928636,
      direction : "-",
      ID : "ENSG00000117153.16",
      gene_id : "ENSG00000117153.16",
      gene_type : "protein_coding",
      gene_name : "KLHL12",
      gene_level : 2,
      hgnc_id : "HGNC:19360",
      havana_gene : "OTTHUMG00000041385.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202940826,
      stop : 202958572,
      direction : "-",
      ID : "ENSG00000159346.13",
      gene_id : "ENSG00000159346.13",
      gene_type : "protein_coding",
      gene_name : "ADIPOR1",
      gene_level : 2,
      hgnc_id : "HGNC:24040",
      havana_gene : "OTTHUMG00000041391.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 202961873,
      stop : 202967275,
      direction : "-",
      ID : "ENSG00000159348.13",
      gene_id : "ENSG00000159348.13",
      gene_type : "protein_coding",
      gene_name : "CYB5R1",
      gene_level : 2,
      hgnc_id : "HGNC:13397",
      havana_gene : "OTTHUMG00000041387.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203007374,
      stop : 203024848,
      direction : "+",
      ID : "ENSG00000163444.12",
      gene_id : "ENSG00000163444.12",
      gene_type : "protein_coding",
      gene_name : "TMEM183A",
      gene_level : 2,
      hgnc_id : "HGNC:20173",
      havana_gene : "OTTHUMG00000042051.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203026498,
      stop : 203078740,
      direction : "+",
      ID : "ENSG00000143847.15",
      gene_id : "ENSG00000143847.15",
      gene_type : "protein_coding",
      gene_name : "PPFIA4",
      gene_level : 1,
      hgnc_id : "HGNC:9248",
      havana_gene : "OTTHUMG00000042123.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203083129,
      stop : 203086012,
      direction : "-",
      ID : "ENSG00000122180.5",
      gene_id : "ENSG00000122180.5",
      gene_type : "protein_coding",
      gene_name : "MYOG",
      gene_level : 2,
      hgnc_id : "HGNC:7612",
      havana_gene : "OTTHUMG00000042127.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203090654,
      stop : 203167405,
      direction : "+",
      ID : "ENSG00000163485.17",
      gene_id : "ENSG00000163485.17",
      gene_type : "protein_coding",
      gene_name : "ADORA1",
      gene_level : 2,
      hgnc_id : "HGNC:262",
      havana_gene : "OTTHUMG00000042125.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203167811,
      stop : 203175826,
      direction : "-",
      ID : "ENSG00000133055.9",
      gene_id : "ENSG00000133055.9",
      gene_type : "protein_coding",
      gene_name : "MYBPH",
      gene_level : 2,
      hgnc_id : "HGNC:7552",
      havana_gene : "OTTHUMG00000042121.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203178931,
      stop : 203186704,
      direction : "-",
      ID : "ENSG00000133048.13",
      gene_id : "ENSG00000133048.13",
      gene_type : "protein_coding",
      gene_name : "CHI3L1",
      gene_level : 2,
      hgnc_id : "HGNC:1932",
      havana_gene : "OTTHUMG00000042122.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203212827,
      stop : 203273641,
      direction : "-",
      ID : "ENSG00000133063.16",
      gene_id : "ENSG00000133063.16",
      gene_type : "protein_coding",
      gene_name : "CHIT1",
      gene_level : 2,
      hgnc_id : "HGNC:1936",
      havana_gene : "OTTHUMG00000042126.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203305491,
      stop : 203309602,
      direction : "+",
      ID : "ENSG00000159388.6",
      gene_id : "ENSG00000159388.6",
      gene_type : "protein_coding",
      gene_name : "BTG2",
      gene_level : 2,
      hgnc_id : "HGNC:1131",
      havana_gene : "OTTHUMG00000035834.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203340628,
      stop : 203351758,
      direction : "-",
      ID : "ENSG00000122176.12",
      gene_id : "ENSG00000122176.12",
      gene_type : "protein_coding",
      gene_name : "FMOD",
      gene_level : 2,
      hgnc_id : "HGNC:3774",
      havana_gene : "OTTHUMG00000035910.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203475806,
      stop : 203491352,
      direction : "+",
      ID : "ENSG00000188783.6",
      gene_id : "ENSG00000188783.6",
      gene_type : "protein_coding",
      gene_name : "PRELP",
      gene_level : 2,
      hgnc_id : "HGNC:9357",
      havana_gene : "OTTHUMG00000035911.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203494153,
      stop : 203508949,
      direction : "+",
      ID : "ENSG00000188770.10",
      gene_id : "ENSG00000188770.10",
      gene_type : "protein_coding",
      gene_name : "OPTC",
      gene_level : 2,
      hgnc_id : "HGNC:8158",
      havana_gene : "OTTHUMG00000036100.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203626787,
      stop : 203744081,
      direction : "+",
      ID : "ENSG00000058668.15",
      gene_id : "ENSG00000058668.15",
      gene_type : "protein_coding",
      gene_name : "ATP2B4",
      gene_level : 2,
      hgnc_id : "HGNC:817",
      havana_gene : "OTTHUMG00000035906.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203765177,
      stop : 203776372,
      direction : "+",
      ID : "ENSG00000122188.13",
      gene_id : "ENSG00000122188.13",
      gene_type : "protein_coding",
      gene_name : "LAX1",
      gene_level : 2,
      hgnc_id : "HGNC:26005",
      havana_gene : "OTTHUMG00000035908.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203795623,
      stop : 203854999,
      direction : "+",
      ID : "ENSG00000058673.17",
      gene_id : "ENSG00000058673.17",
      gene_type : "protein_coding",
      gene_name : "ZC3H11A",
      gene_level : 2,
      hgnc_id : "HGNC:29093",
      havana_gene : "OTTHUMG00000035909.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203795714,
      stop : 203854999,
      direction : "+",
      ID : "ENSG00000257315.3",
      gene_id : "ENSG00000257315.3",
      gene_type : "protein_coding",
      gene_name : "ZBED6",
      gene_level : 2,
      hgnc_id : "HGNC:33273",
      havana_gene : "OTTHUMG00000170422.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203802094,
      stop : 203802192,
      direction : "+",
      ID : "ENSG00000288644.1",
      gene_id : "ENSG00000288644.1",
      gene_type : "protein_coding",
      gene_name : "AC114402.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 203861599,
      stop : 203871152,
      direction : "+",
      ID : "ENSG00000182004.13",
      gene_id : "ENSG00000182004.13",
      gene_type : "protein_coding",
      gene_name : "SNRPE",
      gene_level : 2,
      hgnc_id : "HGNC:11161",
      havana_gene : "OTTHUMG00000035985.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204073115,
      stop : 204127743,
      direction : "+",
      ID : "ENSG00000143842.15",
      gene_id : "ENSG00000143842.15",
      gene_type : "protein_coding",
      gene_name : "SOX13",
      gene_level : 2,
      hgnc_id : "HGNC:11192",
      havana_gene : "OTTHUMG00000036050.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204131062,
      stop : 204152044,
      direction : "-",
      ID : "ENSG00000143845.15",
      gene_id : "ENSG00000143845.15",
      gene_type : "protein_coding",
      gene_name : "ETNK2",
      gene_level : 1,
      hgnc_id : "HGNC:25575",
      havana_gene : "OTTHUMG00000036061.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204154819,
      stop : 204190324,
      direction : "-",
      ID : "ENSG00000143839.15",
      gene_id : "ENSG00000143839.15",
      gene_type : "protein_coding",
      gene_name : "REN",
      gene_level : 2,
      hgnc_id : "HGNC:9958",
      havana_gene : "OTTHUMG00000036059.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204190341,
      stop : 204196491,
      direction : "-",
      ID : "ENSG00000170498.9",
      gene_id : "ENSG00000170498.9",
      gene_type : "protein_coding",
      gene_name : "KISS1",
      gene_level : 2,
      hgnc_id : "HGNC:6341",
      havana_gene : "OTTHUMG00000036060.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204198163,
      stop : 204213988,
      direction : "-",
      ID : "ENSG00000174567.8",
      gene_id : "ENSG00000174567.8",
      gene_type : "protein_coding",
      gene_name : "GOLT1A",
      gene_level : 2,
      hgnc_id : "HGNC:24766",
      havana_gene : "OTTHUMG00000036056.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204218853,
      stop : 204377665,
      direction : "-",
      ID : "ENSG00000143850.16",
      gene_id : "ENSG00000143850.16",
      gene_type : "protein_coding",
      gene_name : "PLEKHA6",
      gene_level : 1,
      hgnc_id : "HGNC:17053",
      havana_gene : "OTTHUMG00000036057.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204403381,
      stop : 204411817,
      direction : "-",
      ID : "ENSG00000158615.9",
      gene_id : "ENSG00000158615.9",
      gene_type : "protein_coding",
      gene_name : "PPP1R15B",
      gene_level : 2,
      hgnc_id : "HGNC:14951",
      havana_gene : "OTTHUMG00000036105.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204422628,
      stop : 204494724,
      direction : "-",
      ID : "ENSG00000133056.13",
      gene_id : "ENSG00000133056.13",
      gene_type : "protein_coding",
      gene_name : "PIK3C2B",
      gene_level : 2,
      hgnc_id : "HGNC:8972",
      havana_gene : "OTTHUMG00000036101.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204516379,
      stop : 204558120,
      direction : "+",
      ID : "ENSG00000198625.13",
      gene_id : "ENSG00000198625.13",
      gene_type : "protein_coding",
      gene_name : "MDM4",
      gene_level : 2,
      hgnc_id : "HGNC:6974",
      havana_gene : "OTTHUMG00000035877.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204617170,
      stop : 204685738,
      direction : "-",
      ID : "ENSG00000170382.12",
      gene_id : "ENSG00000170382.12",
      gene_type : "protein_coding",
      gene_name : "LRRN2",
      gene_level : 2,
      hgnc_id : "HGNC:16914",
      havana_gene : "OTTHUMG00000035989.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 204828651,
      stop : 205022822,
      direction : "+",
      ID : "ENSG00000163531.16",
      gene_id : "ENSG00000163531.16",
      gene_type : "protein_coding",
      gene_name : "NFASC",
      gene_level : 2,
      hgnc_id : "HGNC:29866",
      havana_gene : "OTTHUMG00000151697.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205042937,
      stop : 205078289,
      direction : "+",
      ID : "ENSG00000184144.12",
      gene_id : "ENSG00000184144.12",
      gene_type : "protein_coding",
      gene_name : "CNTN2",
      gene_level : 2,
      hgnc_id : "HGNC:2172",
      havana_gene : "OTTHUMG00000037105.39",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205083129,
      stop : 205084460,
      direction : "-",
      ID : "ENSG00000174529.7",
      gene_id : "ENSG00000174529.7",
      gene_type : "protein_coding",
      gene_name : "TMEM81",
      gene_level : 2,
      hgnc_id : "HGNC:32349",
      havana_gene : "OTTHUMG00000037103.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205086142,
      stop : 205122015,
      direction : "-",
      ID : "ENSG00000117222.14",
      gene_id : "ENSG00000117222.14",
      gene_type : "protein_coding",
      gene_name : "RBBP5",
      gene_level : 2,
      hgnc_id : "HGNC:9888",
      havana_gene : "OTTHUMG00000037104.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205142505,
      stop : 205211702,
      direction : "-",
      ID : "ENSG00000133059.17",
      gene_id : "ENSG00000133059.17",
      gene_type : "protein_coding",
      gene_name : "DSTYK",
      gene_level : 2,
      hgnc_id : "HGNC:29043",
      havana_gene : "OTTHUMG00000037102.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205227946,
      stop : 205285632,
      direction : "+",
      ID : "ENSG00000133069.17",
      gene_id : "ENSG00000133069.17",
      gene_type : "protein_coding",
      gene_name : "TMCC2",
      gene_level : 2,
      hgnc_id : "HGNC:24239",
      havana_gene : "OTTHUMG00000037195.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205302063,
      stop : 205321745,
      direction : "-",
      ID : "ENSG00000163545.11",
      gene_id : "ENSG00000163545.11",
      gene_type : "protein_coding",
      gene_name : "NUAK2",
      gene_level : 2,
      hgnc_id : "HGNC:29558",
      havana_gene : "OTTHUMG00000037196.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205336061,
      stop : 205357090,
      direction : "-",
      ID : "ENSG00000162873.15",
      gene_id : "ENSG00000162873.15",
      gene_type : "protein_coding",
      gene_name : "KLHDC8A",
      gene_level : 2,
      hgnc_id : "HGNC:25573",
      havana_gene : "OTTHUMG00000037199.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205381378,
      stop : 205455954,
      direction : "-",
      ID : "ENSG00000186007.10",
      gene_id : "ENSG00000186007.10",
      gene_type : "protein_coding",
      gene_name : "LEMD1",
      gene_level : 2,
      hgnc_id : "HGNC:18725",
      havana_gene : "OTTHUMG00000193516.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205434885,
      stop : 205457091,
      direction : "-",
      ID : "ENSG00000281406.2",
      gene_id : "ENSG00000281406.2",
      gene_type : "protein_coding",
      gene_name : "BLACAT1",
      gene_level : 2,
      hgnc_id : "HGNC:48597",
      havana_gene : "OTTHUMG00000037201.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205504596,
      stop : 205532793,
      direction : "+",
      ID : "ENSG00000117266.16",
      gene_id : "ENSG00000117266.16",
      gene_type : "protein_coding",
      gene_name : "CDK18",
      gene_level : 1,
      hgnc_id : "HGNC:8751",
      havana_gene : "OTTHUMG00000037203.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205568885,
      stop : 205602918,
      direction : "+",
      ID : "ENSG00000174514.13",
      gene_id : "ENSG00000174514.13",
      gene_type : "protein_coding",
      gene_name : "MFSD4A",
      gene_level : 2,
      hgnc_id : "HGNC:25433",
      havana_gene : "OTTHUMG00000037197.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205597556,
      stop : 205632011,
      direction : "-",
      ID : "ENSG00000158711.14",
      gene_id : "ENSG00000158711.14",
      gene_type : "protein_coding",
      gene_name : "ELK4",
      gene_level : 2,
      hgnc_id : "HGNC:3326",
      havana_gene : "OTTHUMG00000037221.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205657851,
      stop : 205680509,
      direction : "-",
      ID : "ENSG00000158715.6",
      gene_id : "ENSG00000158715.6",
      gene_type : "protein_coding",
      gene_name : "SLC45A3",
      gene_level : 2,
      hgnc_id : "HGNC:8642",
      havana_gene : "OTTHUMG00000037223.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205712822,
      stop : 205750182,
      direction : "-",
      ID : "ENSG00000069275.13",
      gene_id : "ENSG00000069275.13",
      gene_type : "protein_coding",
      gene_name : "NUCKS1",
      gene_level : 2,
      hgnc_id : "HGNC:29923",
      havana_gene : "OTTHUMG00000035996.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205767986,
      stop : 205775482,
      direction : "-",
      ID : "ENSG00000117280.13",
      gene_id : "ENSG00000117280.13",
      gene_type : "protein_coding",
      gene_name : "RAB29",
      gene_level : 2,
      hgnc_id : "HGNC:9789",
      havana_gene : "OTTHUMG00000035998.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205789094,
      stop : 205813748,
      direction : "-",
      ID : "ENSG00000133065.11",
      gene_id : "ENSG00000133065.11",
      gene_type : "protein_coding",
      gene_name : "SLC41A1",
      gene_level : 2,
      hgnc_id : "HGNC:19429",
      havana_gene : "OTTHUMG00000036000.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205828025,
      stop : 205850132,
      direction : "-",
      ID : "ENSG00000162877.13",
      gene_id : "ENSG00000162877.13",
      gene_type : "protein_coding",
      gene_name : "PM20D1",
      gene_level : 1,
      hgnc_id : "HGNC:26518",
      havana_gene : "OTTHUMG00000035999.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205913048,
      stop : 205943460,
      direction : "-",
      ID : "ENSG00000174502.19",
      gene_id : "ENSG00000174502.19",
      gene_type : "protein_coding",
      gene_name : "SLC26A9",
      gene_level : 2,
      hgnc_id : "HGNC:14469",
      havana_gene : "OTTHUMG00000036001.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 205976740,
      stop : 206003461,
      direction : "-",
      ID : "ENSG00000276600.5",
      gene_id : "ENSG00000276600.5",
      gene_type : "protein_coding",
      gene_name : "RAB7B",
      gene_level : 2,
      hgnc_id : "HGNC:30513",
      havana_gene : "OTTHUMG00000189246.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206008535,
      stop : 206023909,
      direction : "-",
      ID : "ENSG00000196188.12",
      gene_id : "ENSG00000196188.12",
      gene_type : "protein_coding",
      gene_name : "CTSE",
      gene_level : 2,
      hgnc_id : "HGNC:2530",
      havana_gene : "OTTHUMG00000036121.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206053173,
      stop : 206102449,
      direction : "+",
      ID : "ENSG00000263961.8",
      gene_id : "ENSG00000263961.8",
      gene_type : "protein_coding",
      gene_name : "RHEX",
      gene_level : 2,
      hgnc_id : "HGNC:25341",
      havana_gene : "OTTHUMG00000192556.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206106936,
      stop : 206117699,
      direction : "-",
      ID : "ENSG00000198049.7",
      gene_id : "ENSG00000198049.7",
      gene_type : "protein_coding",
      gene_name : "AVPR1B",
      gene_level : 2,
      hgnc_id : "HGNC:896",
      havana_gene : "OTTHUMG00000184377.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206186179,
      stop : 206204414,
      direction : "-",
      ID : "ENSG00000196550.11",
      gene_id : "ENSG00000196550.11",
      gene_type : "protein_coding",
      gene_name : "FAM72A",
      gene_level : 2,
      hgnc_id : "HGNC:24044",
      havana_gene : "OTTHUMG00000042552.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206203345,
      stop : 206464443,
      direction : "+",
      ID : "ENSG00000266028.7",
      gene_id : "ENSG00000266028.7",
      gene_type : "protein_coding",
      gene_name : "SRGAP2",
      gene_level : 2,
      hgnc_id : "HGNC:19751",
      havana_gene : "OTTHUMG00000184381.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206470476,
      stop : 206496889,
      direction : "+",
      ID : "ENSG00000263528.8",
      gene_id : "ENSG00000263528.8",
      gene_type : "protein_coding",
      gene_name : "IKBKE",
      gene_level : 2,
      hgnc_id : "HGNC:14552",
      havana_gene : "OTTHUMG00000184613.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206507531,
      stop : 206589448,
      direction : "+",
      ID : "ENSG00000266094.8",
      gene_id : "ENSG00000266094.8",
      gene_type : "protein_coding",
      gene_name : "RASSF5",
      gene_level : 2,
      hgnc_id : "HGNC:17609",
      havana_gene : "OTTHUMG00000184616.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206571292,
      stop : 206612465,
      direction : "-",
      ID : "ENSG00000143486.16",
      gene_id : "ENSG00000143486.16",
      gene_type : "protein_coding",
      gene_name : "EIF2D",
      gene_level : 1,
      hgnc_id : "HGNC:6583",
      havana_gene : "OTTHUMG00000184619.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206635536,
      stop : 206684419,
      direction : "+",
      ID : "ENSG00000143479.17",
      gene_id : "ENSG00000143479.17",
      gene_type : "protein_coding",
      gene_name : "DYRK3",
      gene_level : 2,
      hgnc_id : "HGNC:3094",
      havana_gene : "OTTHUMG00000036339.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206684905,
      stop : 206734281,
      direction : "+",
      ID : "ENSG00000162889.11",
      gene_id : "ENSG00000162889.11",
      gene_type : "protein_coding",
      gene_name : "MAPKAPK2",
      gene_level : 2,
      hgnc_id : "HGNC:6887",
      havana_gene : "OTTHUMG00000036342.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206767602,
      stop : 206774541,
      direction : "-",
      ID : "ENSG00000136634.7",
      gene_id : "ENSG00000136634.7",
      gene_type : "protein_coding",
      gene_name : "IL10",
      gene_level : 2,
      hgnc_id : "HGNC:5962",
      havana_gene : "OTTHUMG00000036386.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206770764,
      stop : 206842979,
      direction : "+",
      ID : "ENSG00000142224.17",
      gene_id : "ENSG00000142224.17",
      gene_type : "protein_coding",
      gene_name : "IL19",
      gene_level : 2,
      hgnc_id : "HGNC:5990",
      havana_gene : "OTTHUMG00000036387.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206865623,
      stop : 206869223,
      direction : "+",
      ID : "ENSG00000162891.11",
      gene_id : "ENSG00000162891.11",
      gene_type : "protein_coding",
      gene_name : "IL20",
      gene_level : 2,
      hgnc_id : "HGNC:6002",
      havana_gene : "OTTHUMG00000036456.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206897443,
      stop : 206904139,
      direction : "+",
      ID : "ENSG00000162892.16",
      gene_id : "ENSG00000162892.16",
      gene_type : "protein_coding",
      gene_name : "IL24",
      gene_level : 2,
      hgnc_id : "HGNC:11346",
      havana_gene : "OTTHUMG00000036459.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206903317,
      stop : 206923247,
      direction : "-",
      ID : "ENSG00000162894.12",
      gene_id : "ENSG00000162894.12",
      gene_type : "protein_coding",
      gene_name : "FCMR",
      gene_level : 2,
      hgnc_id : "HGNC:14315",
      havana_gene : "OTTHUMG00000036457.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206928522,
      stop : 206946466,
      direction : "-",
      ID : "ENSG00000162896.6",
      gene_id : "ENSG00000162896.6",
      gene_type : "protein_coding",
      gene_name : "PIGR",
      gene_level : 2,
      hgnc_id : "HGNC:8968",
      havana_gene : "OTTHUMG00000036581.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 206957965,
      stop : 206970625,
      direction : "-",
      ID : "ENSG00000162897.16",
      gene_id : "ENSG00000162897.16",
      gene_type : "protein_coding",
      gene_name : "FCAMR",
      gene_level : 2,
      hgnc_id : "HGNC:24692",
      havana_gene : "OTTHUMG00000036579.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207018522,
      stop : 207032756,
      direction : "-",
      ID : "ENSG00000182795.13",
      gene_id : "ENSG00000182795.13",
      gene_type : "protein_coding",
      gene_name : "C1orf116",
      gene_level : 1,
      hgnc_id : "HGNC:28667",
      havana_gene : "OTTHUMG00000036580.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207034366,
      stop : 207081024,
      direction : "+",
      ID : "ENSG00000123836.15",
      gene_id : "ENSG00000123836.15",
      gene_type : "protein_coding",
      gene_name : "PFKFB2",
      gene_level : 2,
      hgnc_id : "HGNC:8873",
      havana_gene : "OTTHUMG00000036033.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207043849,
      stop : 207052980,
      direction : "-",
      ID : "ENSG00000180667.11",
      gene_id : "ENSG00000180667.11",
      gene_type : "protein_coding",
      gene_name : "YOD1",
      gene_level : 2,
      hgnc_id : "HGNC:25035",
      havana_gene : "OTTHUMG00000036032.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207088860,
      stop : 207099993,
      direction : "+",
      ID : "ENSG00000123843.13",
      gene_id : "ENSG00000123843.13",
      gene_type : "protein_coding",
      gene_name : "C4BPB",
      gene_level : 2,
      hgnc_id : "HGNC:1328",
      havana_gene : "OTTHUMG00000036035.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207104233,
      stop : 207144972,
      direction : "+",
      ID : "ENSG00000123838.11",
      gene_id : "ENSG00000123838.11",
      gene_type : "protein_coding",
      gene_name : "C4BPA",
      gene_level : 2,
      hgnc_id : "HGNC:1325",
      havana_gene : "OTTHUMG00000036173.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207321532,
      stop : 207386804,
      direction : "+",
      ID : "ENSG00000196352.16",
      gene_id : "ENSG00000196352.16",
      gene_type : "protein_coding",
      gene_name : "CD55",
      gene_level : 1,
      hgnc_id : "HGNC:2665",
      havana_gene : "OTTHUMG00000036255.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207454230,
      stop : 207489895,
      direction : "+",
      ID : "ENSG00000117322.18",
      gene_id : "ENSG00000117322.18",
      gene_type : "protein_coding",
      gene_name : "CR2",
      gene_level : 1,
      hgnc_id : "HGNC:2336",
      havana_gene : "OTTHUMG00000036307.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207496147,
      stop : 207641765,
      direction : "+",
      ID : "ENSG00000203710.12",
      gene_id : "ENSG00000203710.12",
      gene_type : "protein_coding",
      gene_name : "CR1",
      gene_level : 2,
      hgnc_id : "HGNC:2334",
      havana_gene : "OTTHUMG00000036311.17",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207645113,
      stop : 207738416,
      direction : "+",
      ID : "ENSG00000197721.17",
      gene_id : "ENSG00000197721.17",
      gene_type : "protein_coding",
      gene_name : "CR1L",
      gene_level : 2,
      hgnc_id : "HGNC:2335",
      havana_gene : "OTTHUMG00000036354.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207752054,
      stop : 207795513,
      direction : "+",
      ID : "ENSG00000117335.20",
      gene_id : "ENSG00000117335.20",
      gene_type : "protein_coding",
      gene_name : "CD46",
      gene_level : 2,
      hgnc_id : "HGNC:6953",
      havana_gene : "OTTHUMG00000036397.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 207880972,
      stop : 207911402,
      direction : "-",
      ID : "ENSG00000174059.17",
      gene_id : "ENSG00000174059.17",
      gene_type : "protein_coding",
      gene_name : "CD34",
      gene_level : 2,
      hgnc_id : "HGNC:1662",
      havana_gene : "OTTHUMG00000036565.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 208022242,
      stop : 208244384,
      direction : "-",
      ID : "ENSG00000076356.7",
      gene_id : "ENSG00000076356.7",
      gene_type : "protein_coding",
      gene_name : "PLXNA2",
      gene_level : 1,
      hgnc_id : "HGNC:9100",
      havana_gene : "OTTHUMG00000036564.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209583714,
      stop : 209613939,
      direction : "+",
      ID : "ENSG00000008118.10",
      gene_id : "ENSG00000008118.10",
      gene_type : "protein_coding",
      gene_name : "CAMK1G",
      gene_level : 1,
      hgnc_id : "HGNC:14585",
      havana_gene : "OTTHUMG00000036361.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209614870,
      stop : 209652425,
      direction : "-",
      ID : "ENSG00000196878.15",
      gene_id : "ENSG00000196878.15",
      gene_type : "protein_coding",
      gene_name : "LAMB3",
      gene_level : 2,
      hgnc_id : "HGNC:6490",
      havana_gene : "OTTHUMG00000036360.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209675412,
      stop : 209676390,
      direction : "+",
      ID : "ENSG00000123689.6",
      gene_id : "ENSG00000123689.6",
      gene_type : "protein_coding",
      gene_name : "G0S2",
      gene_level : 2,
      hgnc_id : "HGNC:30229",
      havana_gene : "OTTHUMG00000036479.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209686178,
      stop : 209734949,
      direction : "+",
      ID : "ENSG00000117594.10",
      gene_id : "ENSG00000117594.10",
      gene_type : "protein_coding",
      gene_name : "HSD11B1",
      gene_level : 2,
      hgnc_id : "HGNC:5208",
      havana_gene : "OTTHUMG00000036481.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209756032,
      stop : 209782320,
      direction : "+",
      ID : "ENSG00000009790.15",
      gene_id : "ENSG00000009790.15",
      gene_type : "protein_coding",
      gene_name : "TRAF3IP3",
      gene_level : 1,
      hgnc_id : "HGNC:30766",
      havana_gene : "OTTHUMG00000036480.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209779208,
      stop : 209784559,
      direction : "-",
      ID : "ENSG00000162757.4",
      gene_id : "ENSG00000162757.4",
      gene_type : "protein_coding",
      gene_name : "C1orf74",
      gene_level : 2,
      hgnc_id : "HGNC:26319",
      havana_gene : "OTTHUMG00000036483.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209785617,
      stop : 209806175,
      direction : "-",
      ID : "ENSG00000117595.12",
      gene_id : "ENSG00000117595.12",
      gene_type : "protein_coding",
      gene_name : "IRF6",
      gene_level : 2,
      hgnc_id : "HGNC:6121",
      havana_gene : "OTTHUMG00000036521.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209827972,
      stop : 209857565,
      direction : "+",
      ID : "ENSG00000117597.18",
      gene_id : "ENSG00000117597.18",
      gene_type : "protein_coding",
      gene_name : "UTP25",
      gene_level : 2,
      hgnc_id : "HGNC:28440",
      havana_gene : "OTTHUMG00000036654.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 209900923,
      stop : 210171389,
      direction : "+",
      ID : "ENSG00000143469.20",
      gene_id : "ENSG00000143469.20",
      gene_type : "protein_coding",
      gene_name : "SYT14",
      gene_level : 2,
      hgnc_id : "HGNC:23143",
      havana_gene : "OTTHUMG00000036652.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 210232796,
      stop : 210246631,
      direction : "+",
      ID : "ENSG00000082497.12",
      gene_id : "ENSG00000082497.12",
      gene_type : "protein_coding",
      gene_name : "SERTAD4",
      gene_level : 2,
      hgnc_id : "HGNC:25236",
      havana_gene : "OTTHUMG00000036391.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 210328252,
      stop : 210676296,
      direction : "+",
      ID : "ENSG00000054392.13",
      gene_id : "ENSG00000054392.13",
      gene_type : "protein_coding",
      gene_name : "HHAT",
      gene_level : 2,
      hgnc_id : "HGNC:18270",
      havana_gene : "OTTHUMG00000036447.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 210676823,
      stop : 211134165,
      direction : "-",
      ID : "ENSG00000143473.13",
      gene_id : "ENSG00000143473.13",
      gene_type : "protein_coding",
      gene_name : "KCNH1",
      gene_level : 2,
      hgnc_id : "HGNC:6250",
      havana_gene : "OTTHUMG00000036309.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 210858125,
      stop : 211134146,
      direction : "-",
      ID : "ENSG00000284299.1",
      gene_id : "ENSG00000284299.1",
      gene_type : "protein_coding",
      gene_name : "AL590132.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192003.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211082872,
      stop : 211188533,
      direction : "-",
      ID : "ENSG00000283952.1",
      gene_id : "ENSG00000283952.1",
      gene_type : "protein_coding",
      gene_name : "AC092017.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192002.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211258377,
      stop : 211316385,
      direction : "+",
      ID : "ENSG00000117625.14",
      gene_id : "ENSG00000117625.14",
      gene_type : "protein_coding",
      gene_name : "RCOR3",
      gene_level : 1,
      hgnc_id : "HGNC:25594",
      havana_gene : "OTTHUMG00000036996.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211326615,
      stop : 211374946,
      direction : "+",
      ID : "ENSG00000082512.15",
      gene_id : "ENSG00000082512.15",
      gene_type : "protein_coding",
      gene_name : "TRAF5",
      gene_level : 2,
      hgnc_id : "HGNC:12035",
      havana_gene : "OTTHUMG00000036997.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211476522,
      stop : 211492162,
      direction : "-",
      ID : "ENSG00000198570.7",
      gene_id : "ENSG00000198570.7",
      gene_type : "protein_coding",
      gene_name : "RD3",
      gene_level : 2,
      hgnc_id : "HGNC:19689",
      havana_gene : "OTTHUMG00000037002.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211571568,
      stop : 211579161,
      direction : "-",
      ID : "ENSG00000170385.10",
      gene_id : "ENSG00000170385.10",
      gene_type : "protein_coding",
      gene_name : "SLC30A1",
      gene_level : 2,
      hgnc_id : "HGNC:11012",
      havana_gene : "OTTHUMG00000036995.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211658657,
      stop : 211675630,
      direction : "-",
      ID : "ENSG00000117650.13",
      gene_id : "ENSG00000117650.13",
      gene_type : "protein_coding",
      gene_name : "NEK2",
      gene_level : 2,
      hgnc_id : "HGNC:7745",
      havana_gene : "OTTHUMG00000037121.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211743457,
      stop : 211830763,
      direction : "-",
      ID : "ENSG00000123684.13",
      gene_id : "ENSG00000123684.13",
      gene_type : "protein_coding",
      gene_name : "LPGAT1",
      gene_level : 2,
      hgnc_id : "HGNC:28985",
      havana_gene : "OTTHUMG00000037120.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 211940399,
      stop : 212035557,
      direction : "-",
      ID : "ENSG00000143493.13",
      gene_id : "ENSG00000143493.13",
      gene_type : "protein_coding",
      gene_name : "INTS7",
      gene_level : 1,
      hgnc_id : "HGNC:24484",
      havana_gene : "OTTHUMG00000037119.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212035553,
      stop : 212107400,
      direction : "+",
      ID : "ENSG00000143476.18",
      gene_id : "ENSG00000143476.18",
      gene_type : "protein_coding",
      gene_name : "DTL",
      gene_level : 2,
      hgnc_id : "HGNC:30288",
      havana_gene : "OTTHUMG00000037133.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212285410,
      stop : 212361853,
      direction : "+",
      ID : "ENSG00000066027.12",
      gene_id : "ENSG00000066027.12",
      gene_type : "protein_coding",
      gene_name : "PPP2R5A",
      gene_level : 2,
      hgnc_id : "HGNC:9309",
      havana_gene : "OTTHUMG00000036750.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212363928,
      stop : 212414901,
      direction : "-",
      ID : "ENSG00000065600.13",
      gene_id : "ENSG00000065600.13",
      gene_type : "protein_coding",
      gene_name : "PACC1",
      gene_level : 2,
      hgnc_id : "HGNC:25593",
      havana_gene : "OTTHUMG00000036751.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212432920,
      stop : 212446379,
      direction : "+",
      ID : "ENSG00000117691.10",
      gene_id : "ENSG00000117691.10",
      gene_type : "protein_coding",
      gene_name : "NENF",
      gene_level : 2,
      hgnc_id : "HGNC:30384",
      havana_gene : "OTTHUMG00000036744.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212565334,
      stop : 212620777,
      direction : "+",
      ID : "ENSG00000162772.17",
      gene_id : "ENSG00000162772.17",
      gene_type : "protein_coding",
      gene_name : "ATF3",
      gene_level : 2,
      hgnc_id : "HGNC:785",
      havana_gene : "OTTHUMG00000036747.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212624474,
      stop : 212626775,
      direction : "+",
      ID : "ENSG00000162771.8",
      gene_id : "ENSG00000162771.8",
      gene_type : "protein_coding",
      gene_name : "FAM71A",
      gene_level : 2,
      hgnc_id : "HGNC:26541",
      havana_gene : "OTTHUMG00000041084.2",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212686417,
      stop : 212699840,
      direction : "-",
      ID : "ENSG00000123685.9",
      gene_id : "ENSG00000123685.9",
      gene_type : "protein_coding",
      gene_name : "BATF3",
      gene_level : 2,
      hgnc_id : "HGNC:28915",
      havana_gene : "OTTHUMG00000036807.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212726153,
      stop : 212791782,
      direction : "-",
      ID : "ENSG00000117697.15",
      gene_id : "ENSG00000117697.15",
      gene_type : "protein_coding",
      gene_name : "NSL1",
      gene_level : 2,
      hgnc_id : "HGNC:24548",
      havana_gene : "OTTHUMG00000036806.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212791828,
      stop : 212816830,
      direction : "+",
      ID : "ENSG00000203705.11",
      gene_id : "ENSG00000203705.11",
      gene_type : "protein_coding",
      gene_name : "TATDN3",
      gene_level : 1,
      hgnc_id : "HGNC:27010",
      havana_gene : "OTTHUMG00000036805.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212830141,
      stop : 212847649,
      direction : "-",
      ID : "ENSG00000185523.6",
      gene_id : "ENSG00000185523.6",
      gene_type : "protein_coding",
      gene_name : "SPATA45",
      gene_level : 2,
      hgnc_id : "HGNC:33709",
      havana_gene : "OTTHUMG00000036920.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212858275,
      stop : 212899363,
      direction : "+",
      ID : "ENSG00000162769.13",
      gene_id : "ENSG00000162769.13",
      gene_type : "protein_coding",
      gene_name : "FLVCR1",
      gene_level : 1,
      hgnc_id : "HGNC:24682",
      havana_gene : "OTTHUMG00000036924.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212950520,
      stop : 212992037,
      direction : "+",
      ID : "ENSG00000143494.15",
      gene_id : "ENSG00000143494.15",
      gene_type : "protein_coding",
      gene_name : "VASH2",
      gene_level : 2,
      hgnc_id : "HGNC:25723",
      havana_gene : "OTTHUMG00000036925.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 212992182,
      stop : 213015867,
      direction : "-",
      ID : "ENSG00000174606.14",
      gene_id : "ENSG00000174606.14",
      gene_type : "protein_coding",
      gene_name : "ANGEL2",
      gene_level : 2,
      hgnc_id : "HGNC:30534",
      havana_gene : "OTTHUMG00000036927.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 213051233,
      stop : 213274774,
      direction : "+",
      ID : "ENSG00000136643.12",
      gene_id : "ENSG00000136643.12",
      gene_type : "protein_coding",
      gene_name : "RPS6KC1",
      gene_level : 2,
      hgnc_id : "HGNC:10439",
      havana_gene : "OTTHUMG00000036926.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 213983181,
      stop : 214041510,
      direction : "+",
      ID : "ENSG00000117707.16",
      gene_id : "ENSG00000117707.16",
      gene_type : "protein_coding",
      gene_name : "PROX1",
      gene_level : 2,
      hgnc_id : "HGNC:9459",
      havana_gene : "OTTHUMG00000036946.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 214281102,
      stop : 214337131,
      direction : "+",
      ID : "ENSG00000143499.14",
      gene_id : "ENSG00000143499.14",
      gene_type : "protein_coding",
      gene_name : "SMYD2",
      gene_level : 1,
      hgnc_id : "HGNC:20982",
      havana_gene : "OTTHUMG00000037066.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 214348700,
      stop : 214552449,
      direction : "-",
      ID : "ENSG00000152104.12",
      gene_id : "ENSG00000152104.12",
      gene_type : "protein_coding",
      gene_name : "PTPN14",
      gene_level : 1,
      hgnc_id : "HGNC:9647",
      havana_gene : "OTTHUMG00000037039.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 214603195,
      stop : 214664571,
      direction : "+",
      ID : "ENSG00000117724.13",
      gene_id : "ENSG00000117724.13",
      gene_type : "protein_coding",
      gene_name : "CENPF",
      gene_level : 2,
      hgnc_id : "HGNC:1857",
      havana_gene : "OTTHUMG00000036955.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 215005775,
      stop : 215237090,
      direction : "+",
      ID : "ENSG00000082482.14",
      gene_id : "ENSG00000082482.14",
      gene_type : "protein_coding",
      gene_name : "KCNK2",
      gene_level : 1,
      hgnc_id : "HGNC:6277",
      havana_gene : "OTTHUMG00000037017.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 215567304,
      stop : 215621807,
      direction : "+",
      ID : "ENSG00000136636.13",
      gene_id : "ENSG00000136636.13",
      gene_type : "protein_coding",
      gene_name : "KCTD3",
      gene_level : 2,
      hgnc_id : "HGNC:21305",
      havana_gene : "OTTHUMG00000037019.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 215622891,
      stop : 216423448,
      direction : "-",
      ID : "ENSG00000042781.14",
      gene_id : "ENSG00000042781.14",
      gene_type : "protein_coding",
      gene_name : "USH2A",
      gene_level : 2,
      hgnc_id : "HGNC:12601",
      havana_gene : "OTTHUMG00000037079.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 216503246,
      stop : 217137755,
      direction : "-",
      ID : "ENSG00000196482.18",
      gene_id : "ENSG00000196482.18",
      gene_type : "protein_coding",
      gene_name : "ESRRG",
      gene_level : 1,
      hgnc_id : "HGNC:3474",
      havana_gene : "OTTHUMG00000037025.15",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 217426992,
      stop : 217631090,
      direction : "-",
      ID : "ENSG00000092978.11",
      gene_id : "ENSG00000092978.11",
      gene_type : "protein_coding",
      gene_name : "GPATCH2",
      gene_level : 2,
      hgnc_id : "HGNC:25499",
      havana_gene : "OTTHUMG00000000527.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 217631324,
      stop : 217871696,
      direction : "+",
      ID : "ENSG00000162814.11",
      gene_id : "ENSG00000162814.11",
      gene_type : "protein_coding",
      gene_name : "SPATA17",
      gene_level : 2,
      hgnc_id : "HGNC:25184",
      havana_gene : "OTTHUMG00000037875.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 218285293,
      stop : 218337983,
      direction : "+",
      ID : "ENSG00000067533.6",
      gene_id : "ENSG00000067533.6",
      gene_type : "protein_coding",
      gene_name : "RRP15",
      gene_level : 2,
      hgnc_id : "HGNC:24255",
      havana_gene : "OTTHUMG00000039494.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 218345336,
      stop : 218444619,
      direction : "+",
      ID : "ENSG00000092969.12",
      gene_id : "ENSG00000092969.12",
      gene_type : "protein_coding",
      gene_name : "TGFB2",
      gene_level : 2,
      hgnc_id : "HGNC:11768",
      havana_gene : "OTTHUMG00000039521.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 219173869,
      stop : 219212865,
      direction : "+",
      ID : "ENSG00000143353.12",
      gene_id : "ENSG00000143353.12",
      gene_type : "protein_coding",
      gene_name : "LYPLAL1",
      gene_level : 2,
      hgnc_id : "HGNC:20440",
      havana_gene : "OTTHUMG00000037141.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 219608010,
      stop : 219613145,
      direction : "-",
      ID : "ENSG00000215817.7",
      gene_id : "ENSG00000215817.7",
      gene_type : "protein_coding",
      gene_name : "ZC3H11B",
      gene_level : 2,
      hgnc_id : "HGNC:25659",
      havana_gene : "OTTHUMG00000037436.5",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 219685427,
      stop : 219958647,
      direction : "-",
      ID : "ENSG00000196660.11",
      gene_id : "ENSG00000196660.11",
      gene_type : "protein_coding",
      gene_name : "SLC30A10",
      gene_level : 2,
      hgnc_id : "HGNC:25355",
      havana_gene : "OTTHUMG00000037434.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 219968600,
      stop : 220046530,
      direction : "-",
      ID : "ENSG00000136628.18",
      gene_id : "ENSG00000136628.18",
      gene_type : "protein_coding",
      gene_name : "EPRS1",
      gene_level : 2,
      hgnc_id : "HGNC:3418",
      havana_gene : "OTTHUMG00000037433.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220057482,
      stop : 220090462,
      direction : "-",
      ID : "ENSG00000162813.18",
      gene_id : "ENSG00000162813.18",
      gene_type : "protein_coding",
      gene_name : "BPNT1",
      gene_level : 1,
      hgnc_id : "HGNC:1096",
      havana_gene : "OTTHUMG00000037435.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220094132,
      stop : 220148041,
      direction : "+",
      ID : "ENSG00000067704.10",
      gene_id : "ENSG00000067704.10",
      gene_type : "protein_coding",
      gene_name : "IARS2",
      gene_level : 2,
      hgnc_id : "HGNC:29685",
      havana_gene : "OTTHUMG00000037287.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220148293,
      stop : 220272453,
      direction : "-",
      ID : "ENSG00000118873.16",
      gene_id : "ENSG00000118873.16",
      gene_type : "protein_coding",
      gene_name : "RAB3GAP2",
      gene_level : 2,
      hgnc_id : "HGNC:17168",
      havana_gene : "OTTHUMG00000037139.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220528136,
      stop : 220664461,
      direction : "+",
      ID : "ENSG00000116141.17",
      gene_id : "ENSG00000116141.17",
      gene_type : "protein_coding",
      gene_name : "MARK1",
      gene_level : 2,
      hgnc_id : "HGNC:6896",
      havana_gene : "OTTHUMG00000037351.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220690363,
      stop : 220699153,
      direction : "+",
      ID : "ENSG00000162817.7",
      gene_id : "ENSG00000162817.7",
      gene_type : "protein_coding",
      gene_name : "C1orf115",
      gene_level : 2,
      hgnc_id : "HGNC:25873",
      havana_gene : "OTTHUMG00000037361.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220748225,
      stop : 220784815,
      direction : "+",
      ID : "ENSG00000117791.16",
      gene_id : "ENSG00000117791.16",
      gene_type : "protein_coding",
      gene_name : "MTARC2",
      gene_level : 2,
      hgnc_id : "HGNC:26064",
      havana_gene : "OTTHUMG00000037354.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220786913,
      stop : 220819659,
      direction : "+",
      ID : "ENSG00000186205.13",
      gene_id : "ENSG00000186205.13",
      gene_type : "protein_coding",
      gene_name : "MTARC1",
      gene_level : 2,
      hgnc_id : "HGNC:26189",
      havana_gene : "OTTHUMG00000037353.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220786990,
      stop : 220884503,
      direction : "+",
      ID : "ENSG00000286231.1",
      gene_id : "ENSG00000286231.1",
      gene_type : "protein_coding",
      gene_name : "AL445423.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193433.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 220879431,
      stop : 220885059,
      direction : "+",
      ID : "ENSG00000136630.13",
      gene_id : "ENSG00000136630.13",
      gene_type : "protein_coding",
      gene_name : "HLX",
      gene_level : 2,
      hgnc_id : "HGNC:4978",
      havana_gene : "OTTHUMG00000037352.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 221701424,
      stop : 221742089,
      direction : "-",
      ID : "ENSG00000143507.18",
      gene_id : "ENSG00000143507.18",
      gene_type : "protein_coding",
      gene_name : "DUSP10",
      gene_level : 2,
      hgnc_id : "HGNC:3065",
      havana_gene : "OTTHUMG00000037269.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222522258,
      stop : 222548104,
      direction : "-",
      ID : "ENSG00000143512.13",
      gene_id : "ENSG00000143512.13",
      gene_type : "protein_coding",
      gene_name : "HHIPL2",
      gene_level : 2,
      hgnc_id : "HGNC:25842",
      havana_gene : "OTTHUMG00000037545.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222557902,
      stop : 222589933,
      direction : "-",
      ID : "ENSG00000143498.18",
      gene_id : "ENSG00000143498.18",
      gene_type : "protein_coding",
      gene_name : "TAF1A",
      gene_level : 2,
      hgnc_id : "HGNC:11532",
      havana_gene : "OTTHUMG00000037544.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222618097,
      stop : 222668007,
      direction : "+",
      ID : "ENSG00000154305.18",
      gene_id : "ENSG00000154305.18",
      gene_type : "protein_coding",
      gene_name : "MIA3",
      gene_level : 2,
      hgnc_id : "HGNC:24008",
      havana_gene : "OTTHUMG00000037543.8",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222668013,
      stop : 222713210,
      direction : "-",
      ID : "ENSG00000186063.13",
      gene_id : "ENSG00000186063.13",
      gene_type : "protein_coding",
      gene_name : "AIDA",
      gene_level : 2,
      hgnc_id : "HGNC:25761",
      havana_gene : "OTTHUMG00000037653.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222712553,
      stop : 222735196,
      direction : "+",
      ID : "ENSG00000162819.12",
      gene_id : "ENSG00000162819.12",
      gene_type : "protein_coding",
      gene_name : "BROX",
      gene_level : 1,
      hgnc_id : "HGNC:26512",
      havana_gene : "OTTHUMG00000037650.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222737207,
      stop : 222750805,
      direction : "+",
      ID : "ENSG00000197520.10",
      gene_id : "ENSG00000197520.10",
      gene_type : "protein_coding",
      gene_name : "FAM177B",
      gene_level : 2,
      hgnc_id : "HGNC:34395",
      havana_gene : "OTTHUMG00000037766.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 222815022,
      stop : 223005995,
      direction : "+",
      ID : "ENSG00000154309.9",
      gene_id : "ENSG00000154309.9",
      gene_type : "protein_coding",
      gene_name : "DISP1",
      gene_level : 2,
      hgnc_id : "HGNC:19711",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 223109404,
      stop : 223143248,
      direction : "-",
      ID : "ENSG00000187554.14",
      gene_id : "ENSG00000187554.14",
      gene_type : "protein_coding",
      gene_name : "TLR5",
      gene_level : 2,
      hgnc_id : "HGNC:11851",
      havana_gene : "OTTHUMG00000037937.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 223220819,
      stop : 223364233,
      direction : "-",
      ID : "ENSG00000143502.16",
      gene_id : "ENSG00000143502.16",
      gene_type : "protein_coding",
      gene_name : "SUSD4",
      gene_level : 2,
      hgnc_id : "HGNC:25470",
      havana_gene : "OTTHUMG00000037936.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 223393415,
      stop : 223395465,
      direction : "+",
      ID : "ENSG00000178395.7",
      gene_id : "ENSG00000178395.7",
      gene_type : "protein_coding",
      gene_name : "CCDC185",
      gene_level : 2,
      hgnc_id : "HGNC:26654",
      havana_gene : "OTTHUMG00000037987.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 223538007,
      stop : 223665723,
      direction : "-",
      ID : "ENSG00000203697.12",
      gene_id : "ENSG00000203697.12",
      gene_type : "protein_coding",
      gene_name : "CAPN8",
      gene_level : 1,
      hgnc_id : "HGNC:1485",
      havana_gene : "OTTHUMG00000037378.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 223701593,
      stop : 223776018,
      direction : "+",
      ID : "ENSG00000162909.18",
      gene_id : "ENSG00000162909.18",
      gene_type : "protein_coding",
      gene_name : "CAPN2",
      gene_level : 2,
      hgnc_id : "HGNC:1479",
      havana_gene : "OTTHUMG00000037376.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 223779893,
      stop : 223845954,
      direction : "-",
      ID : "ENSG00000143514.17",
      gene_id : "ENSG00000143514.17",
      gene_type : "protein_coding",
      gene_name : "TP53BP2",
      gene_level : 2,
      hgnc_id : "HGNC:12000",
      havana_gene : "OTTHUMG00000037379.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224114111,
      stop : 224162047,
      direction : "+",
      ID : "ENSG00000143756.12",
      gene_id : "ENSG00000143756.12",
      gene_type : "protein_coding",
      gene_name : "FBXO28",
      gene_level : 2,
      hgnc_id : "HGNC:29046",
      havana_gene : "OTTHUMG00000037495.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224175756,
      stop : 224193441,
      direction : "+",
      ID : "ENSG00000143753.13",
      gene_id : "ENSG00000143753.13",
      gene_type : "protein_coding",
      gene_name : "DEGS1",
      gene_level : 2,
      hgnc_id : "HGNC:13709",
      havana_gene : "OTTHUMG00000037496.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224227334,
      stop : 224330189,
      direction : "-",
      ID : "ENSG00000143748.18",
      gene_id : "ENSG00000143748.18",
      gene_type : "protein_coding",
      gene_name : "NVL",
      gene_level : 1,
      hgnc_id : "HGNC:8070",
      havana_gene : "OTTHUMG00000037536.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224356858,
      stop : 224379459,
      direction : "+",
      ID : "ENSG00000143771.12",
      gene_id : "ENSG00000143771.12",
      gene_type : "protein_coding",
      gene_name : "CNIH4",
      gene_level : 2,
      hgnc_id : "HGNC:25013",
      havana_gene : "OTTHUMG00000037635.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224385146,
      stop : 224437033,
      direction : "-",
      ID : "ENSG00000162923.17",
      gene_id : "ENSG00000162923.17",
      gene_type : "protein_coding",
      gene_name : "WDR26",
      gene_level : 1,
      hgnc_id : "HGNC:21208",
      havana_gene : "OTTHUMG00000037636.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224434660,
      stop : 224740554,
      direction : "+",
      ID : "ENSG00000143786.8",
      gene_id : "ENSG00000143786.8",
      gene_type : "protein_coding",
      gene_name : "CNIH3",
      gene_level : 2,
      hgnc_id : "HGNC:26802",
      havana_gene : "OTTHUMG00000037634.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 224896262,
      stop : 225399292,
      direction : "+",
      ID : "ENSG00000185842.15",
      gene_id : "ENSG00000185842.15",
      gene_type : "protein_coding",
      gene_name : "DNAH14",
      gene_level : 1,
      hgnc_id : "HGNC:2945",
      havana_gene : "OTTHUMG00000037447.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225401502,
      stop : 225428925,
      direction : "-",
      ID : "ENSG00000143815.15",
      gene_id : "ENSG00000143815.15",
      gene_type : "protein_coding",
      gene_name : "LBR",
      gene_level : 2,
      hgnc_id : "HGNC:6518",
      havana_gene : "OTTHUMG00000037520.18",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225486835,
      stop : 225653142,
      direction : "-",
      ID : "ENSG00000154380.17",
      gene_id : "ENSG00000154380.17",
      gene_type : "protein_coding",
      gene_name : "ENAH",
      gene_level : 1,
      hgnc_id : "HGNC:18271",
      havana_gene : "OTTHUMG00000037742.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225777813,
      stop : 225790468,
      direction : "+",
      ID : "ENSG00000143742.14",
      gene_id : "ENSG00000143742.14",
      gene_type : "protein_coding",
      gene_name : "SRP9",
      gene_level : 2,
      hgnc_id : "HGNC:11304",
      havana_gene : "OTTHUMG00000037738.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225810124,
      stop : 225845563,
      direction : "+",
      ID : "ENSG00000143819.13",
      gene_id : "ENSG00000143819.13",
      gene_type : "protein_coding",
      gene_name : "EPHX1",
      gene_level : 2,
      hgnc_id : "HGNC:3401",
      havana_gene : "OTTHUMG00000037743.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225845536,
      stop : 225882380,
      direction : "-",
      ID : "ENSG00000196187.12",
      gene_id : "ENSG00000196187.12",
      gene_type : "protein_coding",
      gene_name : "TMEM63A",
      gene_level : 2,
      hgnc_id : "HGNC:29118",
      havana_gene : "OTTHUMG00000037442.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225886282,
      stop : 225911382,
      direction : "-",
      ID : "ENSG00000243709.1",
      gene_id : "ENSG00000243709.1",
      gene_type : "protein_coding",
      gene_name : "LEFTY1",
      gene_level : 2,
      hgnc_id : "HGNC:6552",
      havana_gene : "OTTHUMG00000037443.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225886696,
      stop : 225924278,
      direction : "-",
      ID : "ENSG00000255835.1",
      gene_id : "ENSG00000255835.1",
      gene_type : "protein_coding",
      gene_name : "AL117348.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000168659.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225919877,
      stop : 225924340,
      direction : "-",
      ID : "ENSG00000143811.19",
      gene_id : "ENSG00000143811.19",
      gene_type : "protein_coding",
      gene_name : "PYCR2",
      gene_level : 2,
      hgnc_id : "HGNC:30262",
      havana_gene : "OTTHUMG00000037506.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225936598,
      stop : 225941383,
      direction : "-",
      ID : "ENSG00000143768.13",
      gene_id : "ENSG00000143768.13",
      gene_type : "protein_coding",
      gene_name : "LEFTY2",
      gene_level : 2,
      hgnc_id : "HGNC:3122",
      havana_gene : "OTTHUMG00000037441.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 225982702,
      stop : 225999343,
      direction : "-",
      ID : "ENSG00000143751.10",
      gene_id : "ENSG00000143751.10",
      gene_type : "protein_coding",
      gene_name : "SDE2",
      gene_level : 2,
      hgnc_id : "HGNC:26643",
      havana_gene : "OTTHUMG00000037504.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226061851,
      stop : 226072019,
      direction : "+",
      ID : "ENSG00000163041.13",
      gene_id : "ENSG00000163041.13",
      gene_type : "protein_coding",
      gene_name : "H3-3A",
      gene_level : 2,
      hgnc_id : "HGNC:4764",
      havana_gene : "OTTHUMG00000037507.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226144679,
      stop : 226186741,
      direction : "-",
      ID : "ENSG00000182827.9",
      gene_id : "ENSG00000182827.9",
      gene_type : "protein_coding",
      gene_name : "ACBD3",
      gene_level : 2,
      hgnc_id : "HGNC:15453",
      havana_gene : "OTTHUMG00000037560.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226223618,
      stop : 226227060,
      direction : "+",
      ID : "ENSG00000185155.12",
      gene_id : "ENSG00000185155.12",
      gene_type : "protein_coding",
      gene_name : "MIXL1",
      gene_level : 2,
      hgnc_id : "HGNC:13363",
      havana_gene : "OTTHUMG00000037558.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226231149,
      stop : 226309869,
      direction : "-",
      ID : "ENSG00000183814.16",
      gene_id : "ENSG00000183814.16",
      gene_type : "protein_coding",
      gene_name : "LIN9",
      gene_level : 2,
      hgnc_id : "HGNC:30830",
      havana_gene : "OTTHUMG00000037557.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226360210,
      stop : 226408154,
      direction : "-",
      ID : "ENSG00000143799.14",
      gene_id : "ENSG00000143799.14",
      gene_type : "protein_coding",
      gene_name : "PARP1",
      gene_level : 2,
      hgnc_id : "HGNC:270",
      havana_gene : "OTTHUMG00000037556.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226548764,
      stop : 226609230,
      direction : "+",
      ID : "ENSG00000203685.10",
      gene_id : "ENSG00000203685.10",
      gene_type : "protein_coding",
      gene_name : "STUM",
      gene_level : 2,
      hgnc_id : "HGNC:30491",
      havana_gene : "OTTHUMG00000037583.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226631690,
      stop : 226739323,
      direction : "-",
      ID : "ENSG00000143772.9",
      gene_id : "ENSG00000143772.9",
      gene_type : "protein_coding",
      gene_name : "ITPKB",
      gene_level : 2,
      hgnc_id : "HGNC:6179",
      havana_gene : "OTTHUMG00000037582.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226870184,
      stop : 226927726,
      direction : "+",
      ID : "ENSG00000143801.18",
      gene_id : "ENSG00000143801.18",
      gene_type : "protein_coding",
      gene_name : "PSEN2",
      gene_level : 1,
      hgnc_id : "HGNC:9509",
      havana_gene : "OTTHUMG00000037563.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226870184,
      stop : 226987545,
      direction : "+",
      ID : "ENSG00000288674.1",
      gene_id : "ENSG00000288674.1",
      gene_type : "protein_coding",
      gene_name : "AL391628.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226940286,
      stop : 226987544,
      direction : "+",
      ID : "ENSG00000163050.18",
      gene_id : "ENSG00000163050.18",
      gene_type : "protein_coding",
      gene_name : "COQ8A",
      gene_level : 2,
      hgnc_id : "HGNC:16812",
      havana_gene : "OTTHUMG00000037621.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 226989865,
      stop : 227318474,
      direction : "-",
      ID : "ENSG00000143776.18",
      gene_id : "ENSG00000143776.18",
      gene_type : "protein_coding",
      gene_name : "CDC42BPA",
      gene_level : 2,
      hgnc_id : "HGNC:1737",
      havana_gene : "OTTHUMG00000037618.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 227563543,
      stop : 227677443,
      direction : "+",
      ID : "ENSG00000181450.18",
      gene_id : "ENSG00000181450.18",
      gene_type : "protein_coding",
      gene_name : "ZNF678",
      gene_level : 2,
      hgnc_id : "HGNC:28652",
      havana_gene : "OTTHUMG00000037700.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 227728200,
      stop : 227781826,
      direction : "+",
      ID : "ENSG00000143740.15",
      gene_id : "ENSG00000143740.15",
      gene_type : "protein_coding",
      gene_name : "SNAP47",
      gene_level : 2,
      hgnc_id : "HGNC:30669",
      havana_gene : "OTTHUMG00000037697.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 227730425,
      stop : 227735411,
      direction : "-",
      ID : "ENSG00000081692.13",
      gene_id : "ENSG00000081692.13",
      gene_type : "protein_coding",
      gene_name : "JMJD4",
      gene_level : 2,
      hgnc_id : "HGNC:25724",
      havana_gene : "OTTHUMG00000037698.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 227815693,
      stop : 227846470,
      direction : "+",
      ID : "ENSG00000185888.5",
      gene_id : "ENSG00000185888.5",
      gene_type : "protein_coding",
      gene_name : "PRSS38",
      gene_level : 2,
      hgnc_id : "HGNC:29625",
      havana_gene : "OTTHUMG00000037701.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 227918656,
      stop : 227947932,
      direction : "-",
      ID : "ENSG00000143816.8",
      gene_id : "ENSG00000143816.8",
      gene_type : "protein_coding",
      gene_name : "WNT9A",
      gene_level : 2,
      hgnc_id : "HGNC:12778",
      havana_gene : "OTTHUMG00000037592.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228006998,
      stop : 228061271,
      direction : "+",
      ID : "ENSG00000154342.6",
      gene_id : "ENSG00000154342.6",
      gene_type : "protein_coding",
      gene_name : "WNT3A",
      gene_level : 2,
      hgnc_id : "HGNC:15983",
      havana_gene : "OTTHUMG00000037593.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228082660,
      stop : 228099212,
      direction : "+",
      ID : "ENSG00000143761.16",
      gene_id : "ENSG00000143761.16",
      gene_type : "protein_coding",
      gene_name : "ARF1",
      gene_level : 2,
      hgnc_id : "HGNC:652",
      havana_gene : "OTTHUMG00000037595.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228100726,
      stop : 228105411,
      direction : "-",
      ID : "ENSG00000143793.13",
      gene_id : "ENSG00000143793.13",
      gene_type : "protein_coding",
      gene_name : "C1orf35",
      gene_level : 2,
      hgnc_id : "HGNC:19032",
      havana_gene : "OTTHUMG00000037793.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228106679,
      stop : 228109312,
      direction : "-",
      ID : "ENSG00000162910.19",
      gene_id : "ENSG00000162910.19",
      gene_type : "protein_coding",
      gene_name : "MRPL55",
      gene_level : 2,
      hgnc_id : "HGNC:16686",
      havana_gene : "OTTHUMG00000037965.11",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228139962,
      stop : 228148984,
      direction : "+",
      ID : "ENSG00000143774.17",
      gene_id : "ENSG00000143774.17",
      gene_type : "protein_coding",
      gene_name : "GUK1",
      gene_level : 2,
      hgnc_id : "HGNC:4693",
      havana_gene : "OTTHUMG00000039503.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228149930,
      stop : 228159826,
      direction : "+",
      ID : "ENSG00000198835.4",
      gene_id : "ENSG00000198835.4",
      gene_type : "protein_coding",
      gene_name : "GJC2",
      gene_level : 2,
      hgnc_id : "HGNC:17494",
      havana_gene : "OTTHUMG00000039771.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228165804,
      stop : 228182257,
      direction : "+",
      ID : "ENSG00000181873.13",
      gene_id : "ENSG00000181873.13",
      gene_type : "protein_coding",
      gene_name : "IBA57",
      gene_level : 2,
      hgnc_id : "HGNC:27302",
      havana_gene : "OTTHUMG00000039769.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228208044,
      stop : 228378876,
      direction : "+",
      ID : "ENSG00000154358.23",
      gene_id : "ENSG00000154358.23",
      gene_type : "protein_coding",
      gene_name : "OBSCN",
      gene_level : 1,
      hgnc_id : "HGNC:15719",
      havana_gene : "OTTHUMG00000039772.26",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228393673,
      stop : 228406835,
      direction : "-",
      ID : "ENSG00000154370.16",
      gene_id : "ENSG00000154370.16",
      gene_type : "protein_coding",
      gene_name : "TRIM11",
      gene_level : 2,
      hgnc_id : "HGNC:16281",
      havana_gene : "OTTHUMG00000039773.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228407935,
      stop : 228416861,
      direction : "-",
      ID : "ENSG00000162931.12",
      gene_id : "ENSG00000162931.12",
      gene_type : "protein_coding",
      gene_name : "TRIM17",
      gene_level : 2,
      hgnc_id : "HGNC:13430",
      havana_gene : "OTTHUMG00000039974.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228424845,
      stop : 228425360,
      direction : "-",
      ID : "ENSG00000168148.4",
      gene_id : "ENSG00000168148.4",
      gene_type : "protein_coding",
      gene_name : "H3-4",
      gene_level : 2,
      hgnc_id : "HGNC:4778",
      havana_gene : "OTTHUMG00000040044.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228456979,
      stop : 228457873,
      direction : "-",
      ID : "ENSG00000181218.5",
      gene_id : "ENSG00000181218.5",
      gene_type : "protein_coding",
      gene_name : "H2AW",
      gene_level : 2,
      hgnc_id : "HGNC:20507",
      havana_gene : "OTTHUMG00000040046.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228458107,
      stop : 228460470,
      direction : "+",
      ID : "ENSG00000196890.4",
      gene_id : "ENSG00000196890.4",
      gene_type : "protein_coding",
      gene_name : "H2BU1",
      gene_level : 2,
      hgnc_id : "HGNC:20514",
      havana_gene : "OTTHUMG00000040045.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228487382,
      stop : 228496188,
      direction : "+",
      ID : "ENSG00000168159.14",
      gene_id : "ENSG00000168159.14",
      gene_type : "protein_coding",
      gene_name : "RNF187",
      gene_level : 2,
      hgnc_id : "HGNC:27146",
      havana_gene : "OTTHUMG00000040043.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 228735479,
      stop : 228746664,
      direction : "+",
      ID : "ENSG00000116574.6",
      gene_id : "ENSG00000116574.6",
      gene_type : "protein_coding",
      gene_name : "RHOU",
      gene_level : 2,
      hgnc_id : "HGNC:17794",
      havana_gene : "OTTHUMG00000037919.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229271062,
      stop : 229305894,
      direction : "+",
      ID : "ENSG00000168118.12",
      gene_id : "ENSG00000168118.12",
      gene_type : "protein_coding",
      gene_name : "RAB4A",
      gene_level : 2,
      hgnc_id : "HGNC:9781",
      havana_gene : "OTTHUMG00000037627.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229321011,
      stop : 229343294,
      direction : "-",
      ID : "ENSG00000154429.11",
      gene_id : "ENSG00000154429.11",
      gene_type : "protein_coding",
      gene_name : "CCSAP",
      gene_level : 2,
      hgnc_id : "HGNC:29578",
      havana_gene : "OTTHUMG00000037663.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229431245,
      stop : 229434098,
      direction : "-",
      ID : "ENSG00000143632.14",
      gene_id : "ENSG00000143632.14",
      gene_type : "protein_coding",
      gene_name : "ACTA1",
      gene_level : 2,
      hgnc_id : "HGNC:129",
      havana_gene : "OTTHUMG00000038006.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229440259,
      stop : 229508341,
      direction : "-",
      ID : "ENSG00000069248.12",
      gene_id : "ENSG00000069248.12",
      gene_type : "protein_coding",
      gene_name : "NUP133",
      gene_level : 2,
      hgnc_id : "HGNC:18016",
      havana_gene : "OTTHUMG00000039462.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229516582,
      stop : 229558707,
      direction : "-",
      ID : "ENSG00000135776.5",
      gene_id : "ENSG00000135776.5",
      gene_type : "protein_coding",
      gene_name : "ABCB10",
      gene_level : 2,
      hgnc_id : "HGNC:41",
      havana_gene : "OTTHUMG00000039471.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229593121,
      stop : 229626047,
      direction : "-",
      ID : "ENSG00000135801.10",
      gene_id : "ENSG00000135801.10",
      gene_type : "protein_coding",
      gene_name : "TAF5L",
      gene_level : 2,
      hgnc_id : "HGNC:17304",
      havana_gene : "OTTHUMG00000039463.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 229626247,
      stop : 229660200,
      direction : "+",
      ID : "ENSG00000135763.10",
      gene_id : "ENSG00000135763.10",
      gene_type : "protein_coding",
      gene_name : "URB2",
      gene_level : 2,
      hgnc_id : "HGNC:28967",
      havana_gene : "OTTHUMG00000039464.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230057990,
      stop : 230282122,
      direction : "+",
      ID : "ENSG00000143641.10",
      gene_id : "ENSG00000143641.10",
      gene_type : "protein_coding",
      gene_name : "GALNT2",
      gene_level : 2,
      hgnc_id : "HGNC:4124",
      havana_gene : "OTTHUMG00000037771.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230314490,
      stop : 230426332,
      direction : "-",
      ID : "ENSG00000177614.11",
      gene_id : "ENSG00000177614.11",
      gene_type : "protein_coding",
      gene_name : "PGBD5",
      gene_level : 1,
      hgnc_id : "HGNC:19405",
      havana_gene : "OTTHUMG00000037759.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230642481,
      stop : 230693982,
      direction : "+",
      ID : "ENSG00000135775.14",
      gene_id : "ENSG00000135775.14",
      gene_type : "protein_coding",
      gene_name : "COG2",
      gene_level : 1,
      hgnc_id : "HGNC:6546",
      havana_gene : "OTTHUMG00000037753.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230690776,
      stop : 230745576,
      direction : "-",
      ID : "ENSG00000135744.9",
      gene_id : "ENSG00000135744.9",
      gene_type : "protein_coding",
      gene_name : "AGT",
      gene_level : 2,
      hgnc_id : "HGNC:333",
      havana_gene : "OTTHUMG00000037757.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230747384,
      stop : 230802003,
      direction : "+",
      ID : "ENSG00000135773.13",
      gene_id : "ENSG00000135773.13",
      gene_type : "protein_coding",
      gene_name : "CAPN9",
      gene_level : 2,
      hgnc_id : "HGNC:1486",
      havana_gene : "OTTHUMG00000037779.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230837119,
      stop : 230869589,
      direction : "-",
      ID : "ENSG00000119280.17",
      gene_id : "ENSG00000119280.17",
      gene_type : "protein_coding",
      gene_name : "C1orf198",
      gene_level : 1,
      hgnc_id : "HGNC:25900",
      havana_gene : "OTTHUMG00000037790.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230906243,
      stop : 230978875,
      direction : "-",
      ID : "ENSG00000143643.13",
      gene_id : "ENSG00000143643.13",
      gene_type : "protein_coding",
      gene_name : "TTC13",
      gene_level : 2,
      hgnc_id : "HGNC:26204",
      havana_gene : "OTTHUMG00000037788.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 230978981,
      stop : 231000733,
      direction : "+",
      ID : "ENSG00000173409.14",
      gene_id : "ENSG00000173409.14",
      gene_type : "protein_coding",
      gene_name : "ARV1",
      gene_level : 1,
      hgnc_id : "HGNC:29561",
      havana_gene : "OTTHUMG00000037837.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231018958,
      stop : 231040254,
      direction : "-",
      ID : "ENSG00000182118.8",
      gene_id : "ENSG00000182118.8",
      gene_type : "protein_coding",
      gene_name : "FAM89A",
      gene_level : 2,
      hgnc_id : "HGNC:25057",
      havana_gene : "OTTHUMG00000037960.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231162112,
      stop : 231221556,
      direction : "+",
      ID : "ENSG00000119283.15",
      gene_id : "ENSG00000119283.15",
      gene_type : "protein_coding",
      gene_name : "TRIM67",
      gene_level : 2,
      hgnc_id : "HGNC:31859",
      havana_gene : "OTTHUMG00000037958.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231223763,
      stop : 231241187,
      direction : "-",
      ID : "ENSG00000143633.13",
      gene_id : "ENSG00000143633.13",
      gene_type : "protein_coding",
      gene_name : "C1orf131",
      gene_level : 2,
      hgnc_id : "HGNC:25332",
      havana_gene : "OTTHUMG00000038023.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231241207,
      stop : 231277973,
      direction : "+",
      ID : "ENSG00000116906.13",
      gene_id : "ENSG00000116906.13",
      gene_type : "protein_coding",
      gene_name : "GNPAT",
      gene_level : 2,
      hgnc_id : "HGNC:4416",
      havana_gene : "OTTHUMG00000038024.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231332753,
      stop : 231337852,
      direction : "-",
      ID : "ENSG00000116903.7",
      gene_id : "ENSG00000116903.7",
      gene_type : "protein_coding",
      gene_name : "EXOC8",
      gene_level : 2,
      hgnc_id : "HGNC:24659",
      havana_gene : "OTTHUMG00000038025.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231337104,
      stop : 231355023,
      direction : "+",
      ID : "ENSG00000010072.16",
      gene_id : "ENSG00000010072.16",
      gene_type : "protein_coding",
      gene_name : "SPRTN",
      gene_level : 2,
      hgnc_id : "HGNC:25356",
      havana_gene : "OTTHUMG00000038022.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231363751,
      stop : 231422287,
      direction : "-",
      ID : "ENSG00000135766.9",
      gene_id : "ENSG00000135766.9",
      gene_type : "protein_coding",
      gene_name : "EGLN1",
      gene_level : 2,
      hgnc_id : "HGNC:1232",
      havana_gene : "OTTHUMG00000038027.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231363797,
      stop : 231528603,
      direction : "-",
      ID : "ENSG00000287856.1",
      gene_id : "ENSG00000287856.1",
      gene_type : "protein_coding",
      gene_name : "AL445524.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193819.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231528541,
      stop : 231566524,
      direction : "+",
      ID : "ENSG00000116918.15",
      gene_id : "ENSG00000116918.15",
      gene_type : "protein_coding",
      gene_name : "TSNAX",
      gene_level : 1,
      hgnc_id : "HGNC:12380",
      havana_gene : "OTTHUMG00000039486.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231528653,
      stop : 231819244,
      direction : "+",
      ID : "ENSG00000270106.6",
      gene_id : "ENSG00000270106.6",
      gene_type : "protein_coding",
      gene_name : "TSNAX-DISC1",
      gene_level : 2,
      hgnc_id : "HGNC:49177",
      havana_gene : "OTTHUMG00000183905.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 231626790,
      stop : 232041272,
      direction : "+",
      ID : "ENSG00000162946.23",
      gene_id : "ENSG00000162946.23",
      gene_type : "protein_coding",
      gene_name : "DISC1",
      gene_level : 2,
      hgnc_id : "HGNC:2888",
      havana_gene : "OTTHUMG00000037835.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 232397965,
      stop : 232630571,
      direction : "-",
      ID : "ENSG00000116991.11",
      gene_id : "ENSG00000116991.11",
      gene_type : "protein_coding",
      gene_name : "SIPA1L2",
      gene_level : 2,
      hgnc_id : "HGNC:23800",
      havana_gene : "OTTHUMG00000037820.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 232804892,
      stop : 232808407,
      direction : "+",
      ID : "ENSG00000212916.5",
      gene_id : "ENSG00000212916.5",
      gene_type : "protein_coding",
      gene_name : "MAP10",
      gene_level : 2,
      hgnc_id : "HGNC:29265",
      havana_gene : "OTTHUMG00000037819.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 232950605,
      stop : 232983882,
      direction : "+",
      ID : "ENSG00000135778.12",
      gene_id : "ENSG00000135778.12",
      gene_type : "protein_coding",
      gene_name : "NTPCR",
      gene_level : 1,
      hgnc_id : "HGNC:28204",
      havana_gene : "OTTHUMG00000037822.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 232983435,
      stop : 233295725,
      direction : "-",
      ID : "ENSG00000135749.19",
      gene_id : "ENSG00000135749.19",
      gene_type : "protein_coding",
      gene_name : "PCNX2",
      gene_level : 1,
      hgnc_id : "HGNC:8736",
      havana_gene : "OTTHUMG00000037824.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 233327724,
      stop : 233385148,
      direction : "+",
      ID : "ENSG00000143674.11",
      gene_id : "ENSG00000143674.11",
      gene_type : "protein_coding",
      gene_name : "MAP3K21",
      gene_level : 2,
      hgnc_id : "HGNC:29798",
      havana_gene : "OTTHUMG00000037889.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 233614106,
      stop : 233672514,
      direction : "+",
      ID : "ENSG00000135750.15",
      gene_id : "ENSG00000135750.15",
      gene_type : "protein_coding",
      gene_name : "KCNK1",
      gene_level : 2,
      hgnc_id : "HGNC:6272",
      havana_gene : "OTTHUMG00000037923.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 233904676,
      stop : 234324511,
      direction : "+",
      ID : "ENSG00000183780.13",
      gene_id : "ENSG00000183780.13",
      gene_type : "protein_coding",
      gene_name : "SLC35F3",
      gene_level : 2,
      hgnc_id : "HGNC:23616",
      havana_gene : "OTTHUMG00000037929.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 234373456,
      stop : 234385080,
      direction : "+",
      ID : "ENSG00000168275.16",
      gene_id : "ENSG00000168275.16",
      gene_type : "protein_coding",
      gene_name : "COA6",
      gene_level : 2,
      hgnc_id : "HGNC:18025",
      havana_gene : "OTTHUMG00000037945.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 234391313,
      stop : 234479179,
      direction : "-",
      ID : "ENSG00000059588.10",
      gene_id : "ENSG00000059588.10",
      gene_type : "protein_coding",
      gene_name : "TARBP1",
      gene_level : 2,
      hgnc_id : "HGNC:11568",
      havana_gene : "OTTHUMG00000037947.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 234604269,
      stop : 234610178,
      direction : "-",
      ID : "ENSG00000168264.11",
      gene_id : "ENSG00000168264.11",
      gene_type : "protein_coding",
      gene_name : "IRF2BP2",
      gene_level : 2,
      hgnc_id : "HGNC:21729",
      havana_gene : "OTTHUMG00000037981.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235109341,
      stop : 235128837,
      direction : "-",
      ID : "ENSG00000173726.11",
      gene_id : "ENSG00000173726.11",
      gene_type : "protein_coding",
      gene_name : "TOMM20",
      gene_level : 2,
      hgnc_id : "HGNC:20947",
      havana_gene : "OTTHUMG00000039619.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235131183,
      stop : 235161283,
      direction : "-",
      ID : "ENSG00000188739.15",
      gene_id : "ENSG00000188739.15",
      gene_type : "protein_coding",
      gene_name : "RBM34",
      gene_level : 1,
      hgnc_id : "HGNC:28965",
      havana_gene : "OTTHUMG00000039620.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235131634,
      stop : 235328219,
      direction : "-",
      ID : "ENSG00000054267.22",
      gene_id : "ENSG00000054267.22",
      gene_type : "protein_coding",
      gene_name : "ARID4B",
      gene_level : 2,
      hgnc_id : "HGNC:15550",
      havana_gene : "OTTHUMG00000039621.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235327350,
      stop : 235344532,
      direction : "+",
      ID : "ENSG00000152904.11",
      gene_id : "ENSG00000152904.11",
      gene_type : "protein_coding",
      gene_name : "GGPS1",
      gene_level : 1,
      hgnc_id : "HGNC:4249",
      havana_gene : "OTTHUMG00000037963.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235328570,
      stop : 235448952,
      direction : "+",
      ID : "ENSG00000285053.1",
      gene_id : "ENSG00000285053.1",
      gene_type : "protein_coding",
      gene_name : "TBCE",
      gene_level : 2,
      hgnc_id : "HGNC:11582",
      havana_gene : "OTTHUMG00000192486.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235367360,
      stop : 235452443,
      direction : "+",
      ID : "ENSG00000284770.2",
      gene_id : "ENSG00000284770.2",
      gene_type : "protein_coding",
      gene_name : "TBCE",
      gene_level : 2,
      hgnc_id : "HGNC:11582",
      havana_gene : "OTTHUMG00000039987.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235447190,
      stop : 235504452,
      direction : "-",
      ID : "ENSG00000162885.14",
      gene_id : "ENSG00000162885.14",
      gene_type : "protein_coding",
      gene_name : "B3GALNT2",
      gene_level : 2,
      hgnc_id : "HGNC:28596",
      havana_gene : "OTTHUMG00000040468.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235547685,
      stop : 235650754,
      direction : "-",
      ID : "ENSG00000168243.11",
      gene_id : "ENSG00000168243.11",
      gene_type : "protein_coding",
      gene_name : "GNG4",
      gene_level : 2,
      hgnc_id : "HGNC:4407",
      havana_gene : "OTTHUMG00000040740.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235661041,
      stop : 235883640,
      direction : "-",
      ID : "ENSG00000143669.14",
      gene_id : "ENSG00000143669.14",
      gene_type : "protein_coding",
      gene_name : "LYST",
      gene_level : 1,
      hgnc_id : "HGNC:1968",
      havana_gene : "OTTHUMG00000040527.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 235975830,
      stop : 236065109,
      direction : "-",
      ID : "ENSG00000116962.15",
      gene_id : "ENSG00000116962.15",
      gene_type : "protein_coding",
      gene_name : "NID1",
      gene_level : 2,
      hgnc_id : "HGNC:7821",
      havana_gene : "OTTHUMG00000040071.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236142505,
      stop : 236221865,
      direction : "+",
      ID : "ENSG00000077585.14",
      gene_id : "ENSG00000077585.14",
      gene_type : "protein_coding",
      gene_name : "GPR137B",
      gene_level : 2,
      hgnc_id : "HGNC:11862",
      havana_gene : "OTTHUMG00000037994.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236215101,
      stop : 236281958,
      direction : "-",
      ID : "ENSG00000086619.14",
      gene_id : "ENSG00000086619.14",
      gene_type : "protein_coding",
      gene_name : "ERO1B",
      gene_level : 2,
      hgnc_id : "HGNC:14355",
      havana_gene : "OTTHUMG00000039955.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236348257,
      stop : 236502915,
      direction : "+",
      ID : "ENSG00000186197.15",
      gene_id : "ENSG00000186197.15",
      gene_type : "protein_coding",
      gene_name : "EDARADD",
      gene_level : 2,
      hgnc_id : "HGNC:14341",
      havana_gene : "OTTHUMG00000039954.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236518000,
      stop : 236552981,
      direction : "+",
      ID : "ENSG00000116977.19",
      gene_id : "ENSG00000116977.19",
      gene_type : "protein_coding",
      gene_name : "LGALS8",
      gene_level : 2,
      hgnc_id : "HGNC:6569",
      havana_gene : "OTTHUMG00000039953.10",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236549005,
      stop : 236604516,
      direction : "-",
      ID : "ENSG00000119285.11",
      gene_id : "ENSG00000119285.11",
      gene_type : "protein_coding",
      gene_name : "HEATR1",
      gene_level : 2,
      hgnc_id : "HGNC:25517",
      havana_gene : "OTTHUMG00000040061.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236664141,
      stop : 236764631,
      direction : "+",
      ID : "ENSG00000077522.14",
      gene_id : "ENSG00000077522.14",
      gene_type : "protein_coding",
      gene_name : "ACTN2",
      gene_level : 2,
      hgnc_id : "HGNC:164",
      havana_gene : "OTTHUMG00000040059.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 236795260,
      stop : 236921278,
      direction : "+",
      ID : "ENSG00000116984.15",
      gene_id : "ENSG00000116984.15",
      gene_type : "protein_coding",
      gene_name : "MTR",
      gene_level : 2,
      hgnc_id : "HGNC:7468",
      havana_gene : "OTTHUMG00000040060.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 237004103,
      stop : 237004441,
      direction : "-",
      ID : "ENSG00000244020.3",
      gene_id : "ENSG00000244020.3",
      gene_type : "protein_coding",
      gene_name : "MT1HL1",
      gene_level : 2,
      hgnc_id : "HGNC:31864",
      havana_gene : "OTTHUMG00000040065.5",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 237042184,
      stop : 237833988,
      direction : "+",
      ID : "ENSG00000198626.17",
      gene_id : "ENSG00000198626.17",
      gene_type : "protein_coding",
      gene_name : "RYR2",
      gene_level : 2,
      hgnc_id : "HGNC:10484",
      havana_gene : "OTTHUMG00000039543.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 237877864,
      stop : 237890922,
      direction : "-",
      ID : "ENSG00000116996.9",
      gene_id : "ENSG00000116996.9",
      gene_type : "protein_coding",
      gene_name : "ZP4",
      gene_level : 2,
      hgnc_id : "HGNC:15770",
      havana_gene : "OTTHUMG00000039586.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 237943724,
      stop : 237945275,
      direction : "-",
      ID : "ENSG00000270188.1",
      gene_id : "ENSG00000270188.1",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L11",
      gene_level : 2,
      hgnc_id : "HGNC:37168",
      havana_gene : "OTTHUMG00000184992.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 239386565,
      stop : 239915452,
      direction : "+",
      ID : "ENSG00000133019.12",
      gene_id : "ENSG00000133019.12",
      gene_type : "protein_coding",
      gene_name : "CHRM3",
      gene_level : 2,
      hgnc_id : "HGNC:1952",
      havana_gene : "OTTHUMG00000039649.5",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 240014348,
      stop : 240475187,
      direction : "+",
      ID : "ENSG00000155816.21",
      gene_id : "ENSG00000155816.21",
      gene_type : "protein_coding",
      gene_name : "FMN2",
      gene_level : 2,
      hgnc_id : "HGNC:14074",
      havana_gene : "OTTHUMG00000039883.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 240489573,
      stop : 240612155,
      direction : "-",
      ID : "ENSG00000180875.5",
      gene_id : "ENSG00000180875.5",
      gene_type : "protein_coding",
      gene_name : "GREM2",
      gene_level : 2,
      hgnc_id : "HGNC:17655",
      havana_gene : "OTTHUMG00000039909.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 240775514,
      stop : 241357230,
      direction : "-",
      ID : "ENSG00000182901.17",
      gene_id : "ENSG00000182901.17",
      gene_type : "protein_coding",
      gene_name : "RGS7",
      gene_level : 2,
      hgnc_id : "HGNC:10003",
      havana_gene : "OTTHUMG00000040107.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241497603,
      stop : 241519755,
      direction : "-",
      ID : "ENSG00000091483.7",
      gene_id : "ENSG00000091483.7",
      gene_type : "protein_coding",
      gene_name : "FH",
      gene_level : 2,
      hgnc_id : "HGNC:3700",
      havana_gene : "OTTHUMG00000039597.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241532134,
      stop : 241595642,
      direction : "+",
      ID : "ENSG00000117009.12",
      gene_id : "ENSG00000117009.12",
      gene_type : "protein_coding",
      gene_name : "KMO",
      gene_level : 2,
      hgnc_id : "HGNC:6381",
      havana_gene : "OTTHUMG00000039635.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241590102,
      stop : 241677376,
      direction : "-",
      ID : "ENSG00000054277.14",
      gene_id : "ENSG00000054277.14",
      gene_type : "protein_coding",
      gene_name : "OPN3",
      gene_level : 2,
      hgnc_id : "HGNC:14007",
      havana_gene : "OTTHUMG00000039691.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241628851,
      stop : 241640369,
      direction : "-",
      ID : "ENSG00000203668.3",
      gene_id : "ENSG00000203668.3",
      gene_type : "protein_coding",
      gene_name : "CHML",
      gene_level : 2,
      hgnc_id : "HGNC:1941",
      havana_gene : "OTTHUMG00000039690.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241652278,
      stop : 241802133,
      direction : "+",
      ID : "ENSG00000162843.17",
      gene_id : "ENSG00000162843.17",
      gene_type : "protein_coding",
      gene_name : "WDR64",
      gene_level : 2,
      hgnc_id : "HGNC:26570",
      havana_gene : "OTTHUMG00000039705.13",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241847967,
      stop : 241895148,
      direction : "+",
      ID : "ENSG00000174371.17",
      gene_id : "ENSG00000174371.17",
      gene_type : "protein_coding",
      gene_name : "EXO1",
      gene_level : 1,
      hgnc_id : "HGNC:3511",
      havana_gene : "OTTHUMG00000039965.9",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241957767,
      stop : 241959062,
      direction : "+",
      ID : "ENSG00000196289.7",
      gene_id : "ENSG00000196289.7",
      gene_type : "protein_coding",
      gene_name : "BECN2",
      gene_level : 2,
      hgnc_id : "HGNC:38606",
      havana_gene : "OTTHUMG00000039863.3",
      tag : "retrogene"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 241995490,
      stop : 241999098,
      direction : "-",
      ID : "ENSG00000197769.6",
      gene_id : "ENSG00000197769.6",
      gene_type : "protein_coding",
      gene_name : "MAP1LC3C",
      gene_level : 2,
      hgnc_id : "HGNC:13353",
      havana_gene : "OTTHUMG00000039865.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 242082986,
      stop : 242524697,
      direction : "-",
      ID : "ENSG00000180287.17",
      gene_id : "ENSG00000180287.17",
      gene_type : "protein_coding",
      gene_name : "PLD5",
      gene_level : 2,
      hgnc_id : "HGNC:26879",
      havana_gene : "OTTHUMG00000039867.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 243124428,
      stop : 243255348,
      direction : "-",
      ID : "ENSG00000143702.16",
      gene_id : "ENSG00000143702.16",
      gene_type : "protein_coding",
      gene_name : "CEP170",
      gene_level : 2,
      hgnc_id : "HGNC:28920",
      havana_gene : "OTTHUMG00000039862.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 243256034,
      stop : 243500091,
      direction : "+",
      ID : "ENSG00000054282.16",
      gene_id : "ENSG00000054282.16",
      gene_type : "protein_coding",
      gene_name : "SDCCAG8",
      gene_level : 2,
      hgnc_id : "HGNC:10671",
      havana_gene : "OTTHUMG00000039996.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 243488233,
      stop : 243851079,
      direction : "-",
      ID : "ENSG00000117020.19",
      gene_id : "ENSG00000117020.19",
      gene_type : "protein_coding",
      gene_name : "AKT3",
      gene_level : 2,
      hgnc_id : "HGNC:393",
      havana_gene : "OTTHUMG00000039994.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244048939,
      stop : 244057476,
      direction : "+",
      ID : "ENSG00000179456.10",
      gene_id : "ENSG00000179456.10",
      gene_type : "protein_coding",
      gene_name : "ZBTB18",
      gene_level : 2,
      hgnc_id : "HGNC:13030",
      havana_gene : "OTTHUMG00000040013.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244352635,
      stop : 244389663,
      direction : "+",
      ID : "ENSG00000173728.11",
      gene_id : "ENSG00000173728.11",
      gene_type : "protein_coding",
      gene_name : "C1orf100",
      gene_level : 2,
      hgnc_id : "HGNC:30435",
      havana_gene : "OTTHUMG00000040104.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244408494,
      stop : 244451909,
      direction : "-",
      ID : "ENSG00000035687.10",
      gene_id : "ENSG00000035687.10",
      gene_type : "protein_coding",
      gene_name : "ADSS2",
      gene_level : 2,
      hgnc_id : "HGNC:292",
      havana_gene : "OTTHUMG00000040102.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244454377,
      stop : 244641177,
      direction : "+",
      ID : "ENSG00000179397.18",
      gene_id : "ENSG00000179397.18",
      gene_type : "protein_coding",
      gene_name : "CATSPERE",
      gene_level : 2,
      hgnc_id : "HGNC:28491",
      havana_gene : "OTTHUMG00000040103.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244653103,
      stop : 244709033,
      direction : "+",
      ID : "ENSG00000121644.19",
      gene_id : "ENSG00000121644.19",
      gene_type : "protein_coding",
      gene_name : "DESI2",
      gene_level : 2,
      hgnc_id : "HGNC:24264",
      havana_gene : "OTTHUMG00000040398.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244729898,
      stop : 244730962,
      direction : "-",
      ID : "ENSG00000284188.2",
      gene_id : "ENSG00000284188.2",
      gene_type : "protein_coding",
      gene_name : "AL451007.3",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000191035.4",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244835616,
      stop : 244845057,
      direction : "+",
      ID : "ENSG00000203667.10",
      gene_id : "ENSG00000203667.10",
      gene_type : "protein_coding",
      gene_name : "COX20",
      gene_level : 2,
      hgnc_id : "HGNC:26970",
      havana_gene : "OTTHUMG00000040401.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244840638,
      stop : 244864560,
      direction : "-",
      ID : "ENSG00000153187.20",
      gene_id : "ENSG00000153187.20",
      gene_type : "protein_coding",
      gene_name : "HNRNPU",
      gene_level : 2,
      hgnc_id : "HGNC:5048",
      havana_gene : "OTTHUMG00000040396.17",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 244969705,
      stop : 245127164,
      direction : "+",
      ID : "ENSG00000203666.12",
      gene_id : "ENSG00000203666.12",
      gene_type : "protein_coding",
      gene_name : "EFCAB2",
      gene_level : 1,
      hgnc_id : "HGNC:28166",
      havana_gene : "OTTHUMG00000040474.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 245154985,
      stop : 245709432,
      direction : "+",
      ID : "ENSG00000162849.16",
      gene_id : "ENSG00000162849.16",
      gene_type : "protein_coding",
      gene_name : "KIF26B",
      gene_level : 2,
      hgnc_id : "HGNC:25484",
      havana_gene : "OTTHUMG00000040079.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 245749342,
      stop : 246507312,
      direction : "-",
      ID : "ENSG00000185420.19",
      gene_id : "ENSG00000185420.19",
      gene_type : "protein_coding",
      gene_name : "SMYD3",
      gene_level : 1,
      hgnc_id : "HGNC:15513",
      havana_gene : "OTTHUMG00000040508.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 246540561,
      stop : 246566261,
      direction : "-",
      ID : "ENSG00000162851.8",
      gene_id : "ENSG00000162851.8",
      gene_type : "protein_coding",
      gene_name : "TFB2M",
      gene_level : 2,
      hgnc_id : "HGNC:18559",
      havana_gene : "OTTHUMG00000040091.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 246566444,
      stop : 246668595,
      direction : "+",
      ID : "ENSG00000162852.14",
      gene_id : "ENSG00000162852.14",
      gene_type : "protein_coding",
      gene_name : "CNST",
      gene_level : 2,
      hgnc_id : "HGNC:26486",
      havana_gene : "OTTHUMG00000040090.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 246724409,
      stop : 246768137,
      direction : "+",
      ID : "ENSG00000143653.10",
      gene_id : "ENSG00000143653.10",
      gene_type : "protein_coding",
      gene_name : "SCCPDH",
      gene_level : 2,
      hgnc_id : "HGNC:24275",
      havana_gene : "OTTHUMG00000040221.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 246839098,
      stop : 246931948,
      direction : "-",
      ID : "ENSG00000153207.16",
      gene_id : "ENSG00000153207.16",
      gene_type : "protein_coding",
      gene_name : "AHCTF1",
      gene_level : 1,
      hgnc_id : "HGNC:24618",
      havana_gene : "OTTHUMG00000040706.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 246945547,
      stop : 247008093,
      direction : "-",
      ID : "ENSG00000197472.15",
      gene_id : "ENSG00000197472.15",
      gene_type : "protein_coding",
      gene_name : "ZNF695",
      gene_level : 2,
      hgnc_id : "HGNC:30954",
      havana_gene : "OTTHUMG00000040707.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 246945547,
      stop : 247078811,
      direction : "-",
      ID : "ENSG00000135747.11",
      gene_id : "ENSG00000135747.11",
      gene_type : "protein_coding",
      gene_name : "ZNF670-ZNF695",
      gene_level : 2,
      hgnc_id : "HGNC:49200",
      havana_gene : "OTTHUMG00000187277.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247034637,
      stop : 247078811,
      direction : "-",
      ID : "ENSG00000277462.2",
      gene_id : "ENSG00000277462.2",
      gene_type : "protein_coding",
      gene_name : "ZNF670",
      gene_level : 2,
      hgnc_id : "HGNC:28167",
      havana_gene : "OTTHUMG00000040868.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247099962,
      stop : 247104372,
      direction : "-",
      ID : "ENSG00000188295.15",
      gene_id : "ENSG00000188295.15",
      gene_type : "protein_coding",
      gene_name : "ZNF669",
      gene_level : 2,
      hgnc_id : "HGNC:25736",
      havana_gene : "OTTHUMG00000040869.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247121975,
      stop : 247172016,
      direction : "-",
      ID : "ENSG00000196418.12",
      gene_id : "ENSG00000196418.12",
      gene_type : "protein_coding",
      gene_name : "ZNF124",
      gene_level : 2,
      hgnc_id : "HGNC:12907",
      havana_gene : "OTTHUMG00000041112.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247297412,
      stop : 247331846,
      direction : "-",
      ID : "ENSG00000162714.12",
      gene_id : "ENSG00000162714.12",
      gene_type : "protein_coding",
      gene_name : "ZNF496",
      gene_level : 2,
      hgnc_id : "HGNC:23713",
      havana_gene : "OTTHUMG00000041164.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247416156,
      stop : 247449108,
      direction : "+",
      ID : "ENSG00000162711.18",
      gene_id : "ENSG00000162711.18",
      gene_type : "protein_coding",
      gene_name : "NLRP3",
      gene_level : 2,
      hgnc_id : "HGNC:16400",
      havana_gene : "OTTHUMG00000040647.7",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247449118,
      stop : 247458105,
      direction : "-",
      ID : "ENSG00000177535.8",
      gene_id : "ENSG00000177535.8",
      gene_type : "protein_coding",
      gene_name : "OR2B11",
      gene_level : 2,
      hgnc_id : "HGNC:31249",
      havana_gene : "OTTHUMG00000040572.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247507058,
      stop : 247577690,
      direction : "+",
      ID : "ENSG00000169224.13",
      gene_id : "ENSG00000169224.13",
      gene_type : "protein_coding",
      gene_name : "GCSAML",
      gene_level : 1,
      hgnc_id : "HGNC:29583",
      havana_gene : "OTTHUMG00000040648.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247524677,
      stop : 247536440,
      direction : "-",
      ID : "ENSG00000196242.10",
      gene_id : "ENSG00000196242.10",
      gene_type : "protein_coding",
      gene_name : "OR2C3",
      gene_level : 2,
      hgnc_id : "HGNC:15005",
      havana_gene : "OTTHUMG00000040579.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247588360,
      stop : 247589313,
      direction : "+",
      ID : "ENSG00000177489.1",
      gene_id : "ENSG00000177489.1",
      gene_type : "protein_coding",
      gene_name : "OR2G2",
      gene_level : 2,
      hgnc_id : "HGNC:15007",
      havana_gene : "OTTHUMG00000040575.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247605586,
      stop : 247606515,
      direction : "+",
      ID : "ENSG00000177476.3",
      gene_id : "ENSG00000177476.3",
      gene_type : "protein_coding",
      gene_name : "OR2G3",
      gene_level : 2,
      hgnc_id : "HGNC:15008",
      havana_gene : "OTTHUMG00000040576.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247617143,
      stop : 247622372,
      direction : "+",
      ID : "ENSG00000198452.8",
      gene_id : "ENSG00000198452.8",
      gene_type : "protein_coding",
      gene_name : "OR14L1P",
      gene_level : 2,
      hgnc_id : "HGNC:15023",
      havana_gene : "OTTHUMG00000040577.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247670812,
      stop : 247679739,
      direction : "-",
      ID : "ENSG00000197437.4",
      gene_id : "ENSG00000197437.4",
      gene_type : "protein_coding",
      gene_name : "OR13G1",
      gene_level : 2,
      hgnc_id : "HGNC:14999",
      havana_gene : "OTTHUMG00000040212.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247711436,
      stop : 247716646,
      direction : "-",
      ID : "ENSG00000169214.4",
      gene_id : "ENSG00000169214.4",
      gene_type : "protein_coding",
      gene_name : "OR6F1",
      gene_level : 2,
      hgnc_id : "HGNC:15027",
      havana_gene : "OTTHUMG00000040213.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247711813,
      stop : 247723764,
      direction : "-",
      ID : "ENSG00000239395.2",
      gene_id : "ENSG00000239395.2",
      gene_type : "protein_coding",
      gene_name : "AC118470.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000041416.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247722957,
      stop : 247724043,
      direction : "-",
      ID : "ENSG00000241128.2",
      gene_id : "ENSG00000241128.2",
      gene_type : "protein_coding",
      gene_name : "OR14A2",
      gene_level : 2,
      hgnc_id : "HGNC:15024",
      havana_gene : "OTTHUMG00000040207.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247738615,
      stop : 247739559,
      direction : "+",
      ID : "ENSG00000153230.4",
      gene_id : "ENSG00000153230.4",
      gene_type : "protein_coding",
      gene_name : "OR14K1",
      gene_level : 2,
      hgnc_id : "HGNC:15025",
      havana_gene : "OTTHUMG00000040211.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247754846,
      stop : 247760556,
      direction : "-",
      ID : "ENSG00000221888.4",
      gene_id : "ENSG00000221888.4",
      gene_type : "protein_coding",
      gene_name : "OR1C1",
      gene_level : 2,
      hgnc_id : "HGNC:8182",
      havana_gene : "OTTHUMG00000040198.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247814660,
      stop : 247824119,
      direction : "-",
      ID : "ENSG00000196772.4",
      gene_id : "ENSG00000196772.4",
      gene_type : "protein_coding",
      gene_name : "OR14A16",
      gene_level : 2,
      hgnc_id : "HGNC:15022",
      havana_gene : "OTTHUMG00000040199.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247840928,
      stop : 247841896,
      direction : "-",
      ID : "ENSG00000197591.3",
      gene_id : "ENSG00000197591.3",
      gene_type : "protein_coding",
      gene_name : "OR11L1",
      gene_level : 2,
      hgnc_id : "HGNC:14998",
      havana_gene : "OTTHUMG00000040193.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247857187,
      stop : 247880138,
      direction : "+",
      ID : "ENSG00000162722.9",
      gene_id : "ENSG00000162722.9",
      gene_type : "protein_coding",
      gene_name : "TRIM58",
      gene_level : 2,
      hgnc_id : "HGNC:24150",
      havana_gene : "OTTHUMG00000040203.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247895587,
      stop : 247896531,
      direction : "+",
      ID : "ENSG00000238243.3",
      gene_id : "ENSG00000238243.3",
      gene_type : "protein_coding",
      gene_name : "OR2W3",
      gene_level : 2,
      hgnc_id : "HGNC:15021",
      havana_gene : "OTTHUMG00000040204.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247920252,
      stop : 247923152,
      direction : "+",
      ID : "ENSG00000177462.8",
      gene_id : "ENSG00000177462.8",
      gene_type : "protein_coding",
      gene_name : "OR2T8",
      gene_level : 2,
      hgnc_id : "HGNC:15020",
      havana_gene : "OTTHUMG00000040205.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247924889,
      stop : 247935339,
      direction : "+",
      ID : "ENSG00000177275.4",
      gene_id : "ENSG00000177275.4",
      gene_type : "protein_coding",
      gene_name : "OR2AJ1",
      gene_level : 2,
      hgnc_id : "HGNC:15001",
      havana_gene : "OTTHUMG00000040206.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247948858,
      stop : 247949796,
      direction : "+",
      ID : "ENSG00000279263.1",
      gene_id : "ENSG00000279263.1",
      gene_type : "protein_coding",
      gene_name : "OR2L8",
      gene_level : 2,
      hgnc_id : "HGNC:15014",
      havana_gene : "OTTHUMG00000040196.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 247965233,
      stop : 247966386,
      direction : "+",
      ID : "ENSG00000187080.10",
      gene_id : "ENSG00000187080.10",
      gene_type : "protein_coding",
      gene_name : "OR2AK2",
      gene_level : 2,
      hgnc_id : "HGNC:19569",
      havana_gene : "OTTHUMG00000040201.6",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248013660,
      stop : 248024276,
      direction : "+",
      ID : "ENSG00000197454.2",
      gene_id : "ENSG00000197454.2",
      gene_type : "protein_coding",
      gene_name : "OR2L5",
      gene_level : 2,
      hgnc_id : "HGNC:15011",
      havana_gene : "OTTHUMG00000040194.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248030070,
      stop : 248042305,
      direction : "+",
      ID : "ENSG00000203663.4",
      gene_id : "ENSG00000203663.4",
      gene_type : "protein_coding",
      gene_name : "OR2L2",
      gene_level : 2,
      hgnc_id : "HGNC:8266",
      havana_gene : "OTTHUMG00000040214.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248046836,
      stop : 248063407,
      direction : "+",
      ID : "ENSG00000198128.4",
      gene_id : "ENSG00000198128.4",
      gene_type : "protein_coding",
      gene_name : "OR2L3",
      gene_level : 2,
      hgnc_id : "HGNC:15009",
      havana_gene : "OTTHUMG00000040195.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248095184,
      stop : 248101103,
      direction : "+",
      ID : "ENSG00000196071.5",
      gene_id : "ENSG00000196071.5",
      gene_type : "protein_coding",
      gene_name : "OR2L13",
      gene_level : 2,
      hgnc_id : "HGNC:19578",
      havana_gene : "OTTHUMG00000040446.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248145148,
      stop : 248146086,
      direction : "+",
      ID : "ENSG00000162727.3",
      gene_id : "ENSG00000162727.3",
      gene_type : "protein_coding",
      gene_name : "OR2M5",
      gene_level : 2,
      hgnc_id : "HGNC:19576",
      havana_gene : "OTTHUMG00000040447.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248174821,
      stop : 248181067,
      direction : "+",
      ID : "ENSG00000198601.3",
      gene_id : "ENSG00000198601.3",
      gene_type : "protein_coding",
      gene_name : "OR2M2",
      gene_level : 2,
      hgnc_id : "HGNC:8268",
      havana_gene : "OTTHUMG00000040460.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248197265,
      stop : 248212925,
      direction : "+",
      ID : "ENSG00000228198.3",
      gene_id : "ENSG00000228198.3",
      gene_type : "protein_coding",
      gene_name : "OR2M3",
      gene_level : 2,
      hgnc_id : "HGNC:8269",
      havana_gene : "OTTHUMG00000040459.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248231417,
      stop : 248244679,
      direction : "+",
      ID : "ENSG00000171180.3",
      gene_id : "ENSG00000171180.3",
      gene_type : "protein_coding",
      gene_name : "OR2M4",
      gene_level : 2,
      hgnc_id : "HGNC:8270",
      havana_gene : "OTTHUMG00000040456.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248269917,
      stop : 248277976,
      direction : "-",
      ID : "ENSG00000177212.4",
      gene_id : "ENSG00000177212.4",
      gene_type : "protein_coding",
      gene_name : "OR2T33",
      gene_level : 2,
      hgnc_id : "HGNC:31255",
      havana_gene : "OTTHUMG00000040458.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248290139,
      stop : 248303424,
      direction : "-",
      ID : "ENSG00000177201.2",
      gene_id : "ENSG00000177201.2",
      gene_type : "protein_coding",
      gene_name : "OR2T12",
      gene_level : 2,
      hgnc_id : "HGNC:19592",
      havana_gene : "OTTHUMG00000040457.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248323630,
      stop : 248324568,
      direction : "-",
      ID : "ENSG00000177186.3",
      gene_id : "ENSG00000177186.3",
      gene_type : "protein_coding",
      gene_name : "OR2M7",
      gene_level : 2,
      hgnc_id : "HGNC:19594",
      havana_gene : "OTTHUMG00000040461.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248348775,
      stop : 248349713,
      direction : "+",
      ID : "ENSG00000177174.1",
      gene_id : "ENSG00000177174.1",
      gene_type : "protein_coding",
      gene_name : "OR14C36",
      gene_level : 2,
      hgnc_id : "HGNC:15026",
      havana_gene : "OTTHUMG00000040463.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248361581,
      stop : 248362627,
      direction : "+",
      ID : "ENSG00000196944.4",
      gene_id : "ENSG00000196944.4",
      gene_type : "protein_coding",
      gene_name : "OR2T4",
      gene_level : 2,
      hgnc_id : "HGNC:15016",
      havana_gene : "OTTHUMG00000040453.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248375746,
      stop : 248391811,
      direction : "+",
      ID : "ENSG00000198104.3",
      gene_id : "ENSG00000198104.3",
      gene_type : "protein_coding",
      gene_name : "OR2T6",
      gene_level : 2,
      hgnc_id : "HGNC:15018",
      havana_gene : "OTTHUMG00000040448.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248403048,
      stop : 248408020,
      direction : "+",
      ID : "ENSG00000175143.5",
      gene_id : "ENSG00000175143.5",
      gene_type : "protein_coding",
      gene_name : "OR2T1",
      gene_level : 2,
      hgnc_id : "HGNC:8277",
      havana_gene : "OTTHUMG00000040450.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248445512,
      stop : 248455725,
      direction : "+",
      ID : "ENSG00000196240.5",
      gene_id : "ENSG00000196240.5",
      gene_type : "protein_coding",
      gene_name : "OR2T2",
      gene_level : 2,
      hgnc_id : "HGNC:14725",
      havana_gene : "OTTHUMG00000040480.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248473351,
      stop : 248474307,
      direction : "+",
      ID : "ENSG00000196539.3",
      gene_id : "ENSG00000196539.3",
      gene_type : "protein_coding",
      gene_name : "OR2T3",
      gene_level : 2,
      hgnc_id : "HGNC:14727",
      havana_gene : "OTTHUMG00000040452.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248488589,
      stop : 248491113,
      direction : "+",
      ID : "ENSG00000203661.4",
      gene_id : "ENSG00000203661.4",
      gene_type : "protein_coding",
      gene_name : "OR2T5",
      gene_level : 2,
      hgnc_id : "HGNC:15017",
      havana_gene : "OTTHUMG00000040481.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248508073,
      stop : 248527337,
      direction : "+",
      ID : "ENSG00000188558.6",
      gene_id : "ENSG00000188558.6",
      gene_type : "protein_coding",
      gene_name : "OR2G6",
      gene_level : 2,
      hgnc_id : "HGNC:27019",
      havana_gene : "OTTHUMG00000040462.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248556912,
      stop : 248562772,
      direction : "-",
      ID : "ENSG00000182783.5",
      gene_id : "ENSG00000182783.5",
      gene_type : "protein_coding",
      gene_name : "OR2T29",
      gene_level : 2,
      hgnc_id : "HGNC:31253",
      havana_gene : "OTTHUMG00000040382.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248573801,
      stop : 248574757,
      direction : "-",
      ID : "ENSG00000183310.3",
      gene_id : "ENSG00000183310.3",
      gene_type : "protein_coding",
      gene_name : "OR2T34",
      gene_level : 2,
      hgnc_id : "HGNC:31256",
      havana_gene : "OTTHUMG00000040387.2",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248590487,
      stop : 248597700,
      direction : "-",
      ID : "ENSG00000184022.4",
      gene_id : "ENSG00000184022.4",
      gene_type : "protein_coding",
      gene_name : "OR2T10",
      gene_level : 2,
      hgnc_id : "HGNC:19573",
      havana_gene : "OTTHUMG00000040388.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248623557,
      stop : 248635091,
      direction : "-",
      ID : "ENSG00000279301.4",
      gene_id : "ENSG00000279301.4",
      gene_type : "protein_coding",
      gene_name : "OR2T11",
      gene_level : 2,
      hgnc_id : "HGNC:19574",
      havana_gene : "OTTHUMG00000040384.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248636356,
      stop : 248645278,
      direction : "-",
      ID : "ENSG00000177151.5",
      gene_id : "ENSG00000177151.5",
      gene_type : "protein_coding",
      gene_name : "OR2T35",
      gene_level : 2,
      hgnc_id : "HGNC:31257",
      havana_gene : "OTTHUMG00000040380.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248649838,
      stop : 248655528,
      direction : "-",
      ID : "ENSG00000187701.4",
      gene_id : "ENSG00000187701.4",
      gene_type : "protein_coding",
      gene_name : "OR2T27",
      gene_level : 2,
      hgnc_id : "HGNC:31252",
      havana_gene : "OTTHUMG00000040376.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248681249,
      stop : 248748349,
      direction : "-",
      ID : "ENSG00000286015.1",
      gene_id : "ENSG00000286015.1",
      gene_type : "protein_coding",
      gene_name : "CR589904.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193437.1",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248681322,
      stop : 248682328,
      direction : "-",
      ID : "ENSG00000189181.5",
      gene_id : "ENSG00000189181.5",
      gene_type : "protein_coding",
      gene_name : "OR14I1",
      gene_level : 2,
      hgnc_id : "HGNC:19575",
      havana_gene : "OTTHUMG00000040378.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248739415,
      stop : 248755759,
      direction : "-",
      ID : "ENSG00000259823.6",
      gene_id : "ENSG00000259823.6",
      gene_type : "protein_coding",
      gene_name : "LYPD8",
      gene_level : 2,
      hgnc_id : "HGNC:44208",
      havana_gene : "OTTHUMG00000174833.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248810446,
      stop : 248825915,
      direction : "-",
      ID : "ENSG00000175137.11",
      gene_id : "ENSG00000175137.11",
      gene_type : "protein_coding",
      gene_name : "SH3BP5L",
      gene_level : 2,
      hgnc_id : "HGNC:29360",
      havana_gene : "OTTHUMG00000040389.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248838210,
      stop : 248849517,
      direction : "+",
      ID : "ENSG00000171161.13",
      gene_id : "ENSG00000171161.13",
      gene_type : "protein_coding",
      gene_name : "ZNF672",
      gene_level : 2,
      hgnc_id : "HGNC:26179",
      havana_gene : "OTTHUMG00000040377.4",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248850006,
      stop : 248859144,
      direction : "-",
      ID : "ENSG00000171163.16",
      gene_id : "ENSG00000171163.16",
      gene_type : "protein_coding",
      gene_name : "ZNF692",
      gene_level : 1,
      hgnc_id : "HGNC:26049",
      havana_gene : "OTTHUMG00000040423.3",
      tag : null
    },
    {
      chromosome : 1,
      annotation : "HAVANA",
      type : "gene",
      start : 248906196,
      stop : 248919946,
      direction : "+",
      ID : "ENSG00000185220.12",
      gene_id : "ENSG00000185220.12",
      gene_type : "protein_coding",
      gene_name : "PGBD2",
      gene_level : 2,
      hgnc_id : "HGNC:19399",
      havana_gene : "OTTHUMG00000040424.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46888,
      stop : 74163,
      direction : "-",
      ID : "ENSG00000261456.6",
      gene_id : "ENSG00000261456.6",
      gene_type : "protein_coding",
      gene_name : "TUBB8",
      gene_level : 2,
      hgnc_id : "HGNC:20773",
      havana_gene : "OTTHUMG00000174803.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 134465,
      stop : 254637,
      direction : "+",
      ID : "ENSG00000015171.20",
      gene_id : "ENSG00000015171.20",
      gene_type : "protein_coding",
      gene_name : "ZMYND11",
      gene_level : 2,
      hgnc_id : "HGNC:16966",
      havana_gene : "OTTHUMG00000017526.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 274190,
      stop : 689668,
      direction : "-",
      ID : "ENSG00000151240.17",
      gene_id : "ENSG00000151240.17",
      gene_type : "protein_coding",
      gene_name : "DIP2C",
      gene_level : 2,
      hgnc_id : "HGNC:29150",
      havana_gene : "OTTHUMG00000017532.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 806914,
      stop : 931705,
      direction : "-",
      ID : "ENSG00000107929.15",
      gene_id : "ENSG00000107929.15",
      gene_type : "protein_coding",
      gene_name : "LARP4B",
      gene_level : 2,
      hgnc_id : "HGNC:28987",
      havana_gene : "OTTHUMG00000017534.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 988434,
      stop : 1019932,
      direction : "+",
      ID : "ENSG00000107937.19",
      gene_id : "ENSG00000107937.19",
      gene_type : "protein_coding",
      gene_name : "GTPBP4",
      gene_level : 2,
      hgnc_id : "HGNC:21535",
      havana_gene : "OTTHUMG00000017538.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 1018910,
      stop : 1025859,
      direction : "-",
      ID : "ENSG00000148377.6",
      gene_id : "ENSG00000148377.6",
      gene_type : "protein_coding",
      gene_name : "IDI2",
      gene_level : 2,
      hgnc_id : "HGNC:23487",
      havana_gene : "OTTHUMG00000017537.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 1039152,
      stop : 1049119,
      direction : "-",
      ID : "ENSG00000067064.12",
      gene_id : "ENSG00000067064.12",
      gene_type : "protein_coding",
      gene_name : "IDI1",
      gene_level : 2,
      hgnc_id : "HGNC:5387",
      havana_gene : "OTTHUMG00000017536.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 1049538,
      stop : 1132384,
      direction : "+",
      ID : "ENSG00000047056.16",
      gene_id : "ENSG00000047056.16",
      gene_type : "protein_coding",
      gene_name : "WDR37",
      gene_level : 2,
      hgnc_id : "HGNC:31406",
      havana_gene : "OTTHUMG00000017540.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 1177313,
      stop : 1737525,
      direction : "-",
      ID : "ENSG00000185736.16",
      gene_id : "ENSG00000185736.16",
      gene_type : "protein_coding",
      gene_name : "ADARB2",
      gene_level : 2,
      hgnc_id : "HGNC:227",
      havana_gene : "OTTHUMG00000017543.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 3066333,
      stop : 3137718,
      direction : "+",
      ID : "ENSG00000067057.18",
      gene_id : "ENSG00000067057.18",
      gene_type : "protein_coding",
      gene_name : "PFKP",
      gene_level : 2,
      hgnc_id : "HGNC:8878",
      havana_gene : "OTTHUMG00000017556.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 3137728,
      stop : 3172841,
      direction : "-",
      ID : "ENSG00000107959.17",
      gene_id : "ENSG00000107959.17",
      gene_type : "protein_coding",
      gene_name : "PITRM1",
      gene_level : 2,
      hgnc_id : "HGNC:17663",
      havana_gene : "OTTHUMG00000017557.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 3775996,
      stop : 3785281,
      direction : "-",
      ID : "ENSG00000067082.15",
      gene_id : "ENSG00000067082.15",
      gene_type : "protein_coding",
      gene_name : "KLF6",
      gene_level : 2,
      hgnc_id : "HGNC:2235",
      havana_gene : "OTTHUMG00000017567.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 4786629,
      stop : 4848062,
      direction : "+",
      ID : "ENSG00000165568.18",
      gene_id : "ENSG00000165568.18",
      gene_type : "protein_coding",
      gene_name : "AKR1E2",
      gene_level : 1,
      hgnc_id : "HGNC:23437",
      havana_gene : "OTTHUMG00000017577.12",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 4963253,
      stop : 4983283,
      direction : "+",
      ID : "ENSG00000187134.14",
      gene_id : "ENSG00000187134.14",
      gene_type : "protein_coding",
      gene_name : "AKR1C1",
      gene_level : 2,
      hgnc_id : "HGNC:384",
      havana_gene : "OTTHUMG00000017580.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 4987400,
      stop : 5018031,
      direction : "-",
      ID : "ENSG00000151632.17",
      gene_id : "ENSG00000151632.17",
      gene_type : "protein_coding",
      gene_name : "AKR1C2",
      gene_level : 2,
      hgnc_id : "HGNC:385",
      havana_gene : "OTTHUMG00000017584.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5035354,
      stop : 5107686,
      direction : "+",
      ID : "ENSG00000196139.14",
      gene_id : "ENSG00000196139.14",
      gene_type : "protein_coding",
      gene_name : "AKR1C3",
      gene_level : 2,
      hgnc_id : "HGNC:386",
      havana_gene : "OTTHUMG00000017585.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5154140,
      stop : 5185187,
      direction : "-",
      ID : "ENSG00000264006.8",
      gene_id : "ENSG00000264006.8",
      gene_type : "protein_coding",
      gene_name : "AKR1C8P",
      gene_level : 2,
      hgnc_id : "HGNC:23469",
      havana_gene : "OTTHUMG00000184213.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5195462,
      stop : 5218949,
      direction : "+",
      ID : "ENSG00000198610.11",
      gene_id : "ENSG00000198610.11",
      gene_type : "protein_coding",
      gene_name : "AKR1C4",
      gene_level : 2,
      hgnc_id : "HGNC:387",
      havana_gene : "OTTHUMG00000017591.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5364966,
      stop : 5374692,
      direction : "+",
      ID : "ENSG00000178473.7",
      gene_id : "ENSG00000178473.7",
      gene_type : "protein_coding",
      gene_name : "UCN3",
      gene_level : 2,
      hgnc_id : "HGNC:17781",
      havana_gene : "OTTHUMG00000017594.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5393101,
      stop : 5404828,
      direction : "-",
      ID : "ENSG00000178462.12",
      gene_id : "ENSG00000178462.12",
      gene_type : "protein_coding",
      gene_name : "TUBAL3",
      gene_level : 2,
      hgnc_id : "HGNC:23534",
      havana_gene : "OTTHUMG00000017595.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5412557,
      stop : 5459056,
      direction : "+",
      ID : "ENSG00000173848.19",
      gene_id : "ENSG00000173848.19",
      gene_type : "protein_coding",
      gene_name : "NET1",
      gene_level : 2,
      hgnc_id : "HGNC:14592",
      havana_gene : "OTTHUMG00000017596.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5498697,
      stop : 5499570,
      direction : "-",
      ID : "ENSG00000178372.8",
      gene_id : "ENSG00000178372.8",
      gene_type : "protein_coding",
      gene_name : "CALML5",
      gene_level : 2,
      hgnc_id : "HGNC:18180",
      havana_gene : "OTTHUMG00000017598.2",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5524961,
      stop : 5526771,
      direction : "+",
      ID : "ENSG00000178363.5",
      gene_id : "ENSG00000178363.5",
      gene_type : "protein_coding",
      gene_name : "CALML3",
      gene_level : 2,
      hgnc_id : "HGNC:1452",
      havana_gene : "OTTHUMG00000017597.2",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5638867,
      stop : 5666595,
      direction : "-",
      ID : "ENSG00000196372.13",
      gene_id : "ENSG00000196372.13",
      gene_type : "protein_coding",
      gene_name : "ASB13",
      gene_level : 2,
      hgnc_id : "HGNC:19765",
      havana_gene : "OTTHUMG00000017603.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5684838,
      stop : 5763740,
      direction : "+",
      ID : "ENSG00000108021.20",
      gene_id : "ENSG00000108021.20",
      gene_type : "protein_coding",
      gene_name : "TASOR2",
      gene_level : 1,
      hgnc_id : "HGNC:23484",
      havana_gene : "OTTHUMG00000017605.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5765223,
      stop : 5842132,
      direction : "-",
      ID : "ENSG00000057608.17",
      gene_id : "ENSG00000057608.17",
      gene_type : "protein_coding",
      gene_name : "GDI2",
      gene_level : 1,
      hgnc_id : "HGNC:4227",
      havana_gene : "OTTHUMG00000017607.10",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5861616,
      stop : 5889906,
      direction : "-",
      ID : "ENSG00000134461.16",
      gene_id : "ENSG00000134461.16",
      gene_type : "protein_coding",
      gene_name : "ANKRD16",
      gene_level : 2,
      hgnc_id : "HGNC:23471",
      havana_gene : "OTTHUMG00000017610.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5890203,
      stop : 5937594,
      direction : "+",
      ID : "ENSG00000134452.20",
      gene_id : "ENSG00000134452.20",
      gene_type : "protein_coding",
      gene_name : "FBH1",
      gene_level : 2,
      hgnc_id : "HGNC:13620",
      havana_gene : "OTTHUMG00000017609.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 5943639,
      stop : 5978187,
      direction : "-",
      ID : "ENSG00000134470.21",
      gene_id : "ENSG00000134470.21",
      gene_type : "protein_coding",
      gene_name : "IL15RA",
      gene_level : 1,
      hgnc_id : "HGNC:5978",
      havana_gene : "OTTHUMG00000017612.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 6010689,
      stop : 6062370,
      direction : "-",
      ID : "ENSG00000134460.18",
      gene_id : "ENSG00000134460.18",
      gene_type : "protein_coding",
      gene_name : "IL2RA",
      gene_level : 2,
      hgnc_id : "HGNC:6008",
      havana_gene : "OTTHUMG00000017616.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 6089034,
      stop : 6117457,
      direction : "+",
      ID : "ENSG00000134453.16",
      gene_id : "ENSG00000134453.16",
      gene_type : "protein_coding",
      gene_name : "RBM17",
      gene_level : 2,
      hgnc_id : "HGNC:16944",
      havana_gene : "OTTHUMG00000017618.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 6144934,
      stop : 6254644,
      direction : "+",
      ID : "ENSG00000170525.21",
      gene_id : "ENSG00000170525.21",
      gene_type : "protein_coding",
      gene_name : "PFKFB3",
      gene_level : 2,
      hgnc_id : "HGNC:8874",
      havana_gene : "OTTHUMG00000017621.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 6427143,
      stop : 6580301,
      direction : "-",
      ID : "ENSG00000065675.15",
      gene_id : "ENSG00000065675.15",
      gene_type : "protein_coding",
      gene_name : "PRKCQ",
      gene_level : 2,
      hgnc_id : "HGNC:9410",
      havana_gene : "OTTHUMG00000017623.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 7158624,
      stop : 7411486,
      direction : "-",
      ID : "ENSG00000198879.12",
      gene_id : "ENSG00000198879.12",
      gene_type : "protein_coding",
      gene_name : "SFMBT2",
      gene_level : 2,
      hgnc_id : "HGNC:20256",
      havana_gene : "OTTHUMG00000017630.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 7559270,
      stop : 7666998,
      direction : "-",
      ID : "ENSG00000123243.15",
      gene_id : "ENSG00000123243.15",
      gene_type : "protein_coding",
      gene_name : "ITIH5",
      gene_level : 1,
      hgnc_id : "HGNC:21449",
      havana_gene : "OTTHUMG00000017635.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 7703316,
      stop : 7749520,
      direction : "+",
      ID : "ENSG00000151655.19",
      gene_id : "ENSG00000151655.19",
      gene_type : "protein_coding",
      gene_name : "ITIH2",
      gene_level : 1,
      hgnc_id : "HGNC:6167",
      havana_gene : "OTTHUMG00000017633.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 7750962,
      stop : 7787993,
      direction : "-",
      ID : "ENSG00000151657.12",
      gene_id : "ENSG00000151657.12",
      gene_type : "protein_coding",
      gene_name : "KIN",
      gene_level : 2,
      hgnc_id : "HGNC:6327",
      havana_gene : "OTTHUMG00000017634.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 7788147,
      stop : 7807815,
      direction : "+",
      ID : "ENSG00000165629.20",
      gene_id : "ENSG00000165629.20",
      gene_type : "protein_coding",
      gene_name : "ATP5F1C",
      gene_level : 2,
      hgnc_id : "HGNC:833",
      havana_gene : "OTTHUMG00000017639.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 7818505,
      stop : 8016631,
      direction : "+",
      ID : "ENSG00000165632.8",
      gene_id : "ENSG00000165632.8",
      gene_type : "protein_coding",
      gene_name : "TAF3",
      gene_level : 2,
      hgnc_id : "HGNC:17303",
      havana_gene : "OTTHUMG00000017643.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 8045378,
      stop : 8075198,
      direction : "+",
      ID : "ENSG00000107485.18",
      gene_id : "ENSG00000107485.18",
      gene_type : "protein_coding",
      gene_name : "GATA3",
      gene_level : 2,
      hgnc_id : "HGNC:4172",
      havana_gene : "OTTHUMG00000017640.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 10798397,
      stop : 11336675,
      direction : "+",
      ID : "ENSG00000048740.18",
      gene_id : "ENSG00000048740.18",
      gene_type : "protein_coding",
      gene_name : "CELF2",
      gene_level : 2,
      hgnc_id : "HGNC:2550",
      havana_gene : "OTTHUMG00000017668.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 11453946,
      stop : 11611754,
      direction : "-",
      ID : "ENSG00000148429.14",
      gene_id : "ENSG00000148429.14",
      gene_type : "protein_coding",
      gene_name : "USP6NL",
      gene_level : 2,
      hgnc_id : "HGNC:16858",
      havana_gene : "OTTHUMG00000017672.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 11742366,
      stop : 11764070,
      direction : "+",
      ID : "ENSG00000134463.15",
      gene_id : "ENSG00000134463.15",
      gene_type : "protein_coding",
      gene_name : "ECHDC3",
      gene_level : 2,
      hgnc_id : "HGNC:23489",
      havana_gene : "OTTHUMG00000017675.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 11823339,
      stop : 11872277,
      direction : "+",
      ID : "ENSG00000148426.13",
      gene_id : "ENSG00000148426.13",
      gene_type : "protein_coding",
      gene_name : "PROSER2",
      gene_level : 2,
      hgnc_id : "HGNC:23728",
      havana_gene : "OTTHUMG00000017673.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 11920022,
      stop : 12043170,
      direction : "-",
      ID : "ENSG00000151461.20",
      gene_id : "ENSG00000151461.20",
      gene_type : "protein_coding",
      gene_name : "UPF2",
      gene_level : 2,
      hgnc_id : "HGNC:17854",
      havana_gene : "OTTHUMG00000017678.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 12068954,
      stop : 12123221,
      direction : "+",
      ID : "ENSG00000181192.12",
      gene_id : "ENSG00000181192.12",
      gene_type : "protein_coding",
      gene_name : "DHTKD1",
      gene_level : 2,
      hgnc_id : "HGNC:23537",
      havana_gene : "OTTHUMG00000017677.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 12129637,
      stop : 12169961,
      direction : "+",
      ID : "ENSG00000065665.21",
      gene_id : "ENSG00000065665.21",
      gene_type : "protein_coding",
      gene_name : "SEC61A2",
      gene_level : 2,
      hgnc_id : "HGNC:17702",
      havana_gene : "OTTHUMG00000017679.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 12165330,
      stop : 12196144,
      direction : "-",
      ID : "ENSG00000165609.13",
      gene_id : "ENSG00000165609.13",
      gene_type : "protein_coding",
      gene_name : "NUDT5",
      gene_level : 2,
      hgnc_id : "HGNC:8052",
      havana_gene : "OTTHUMG00000017682.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 12195965,
      stop : 12250589,
      direction : "+",
      ID : "ENSG00000151465.14",
      gene_id : "ENSG00000151465.14",
      gene_type : "protein_coding",
      gene_name : "CDC123",
      gene_level : 2,
      hgnc_id : "HGNC:16827",
      havana_gene : "OTTHUMG00000017680.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 12349547,
      stop : 12835545,
      direction : "+",
      ID : "ENSG00000183049.13",
      gene_id : "ENSG00000183049.13",
      gene_type : "protein_coding",
      gene_name : "CAMK1D",
      gene_level : 2,
      hgnc_id : "HGNC:19341",
      havana_gene : "OTTHUMG00000017683.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 12896625,
      stop : 13099652,
      direction : "-",
      ID : "ENSG00000151468.11",
      gene_id : "ENSG00000151468.11",
      gene_type : "protein_coding",
      gene_name : "CCDC3",
      gene_level : 2,
      hgnc_id : "HGNC:23813",
      havana_gene : "OTTHUMG00000017689.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13099449,
      stop : 13138308,
      direction : "+",
      ID : "ENSG00000123240.17",
      gene_id : "ENSG00000123240.17",
      gene_type : "protein_coding",
      gene_name : "OPTN",
      gene_level : 2,
      hgnc_id : "HGNC:17142",
      havana_gene : "OTTHUMG00000017690.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13161558,
      stop : 13211110,
      direction : "+",
      ID : "ENSG00000065328.17",
      gene_id : "ENSG00000065328.17",
      gene_type : "protein_coding",
      gene_name : "MCM10",
      gene_level : 2,
      hgnc_id : "HGNC:18043",
      havana_gene : "OTTHUMG00000017694.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13221766,
      stop : 13234374,
      direction : "-",
      ID : "ENSG00000165623.10",
      gene_id : "ENSG00000165623.10",
      gene_type : "protein_coding",
      gene_name : "UCMA",
      gene_level : 2,
      hgnc_id : "HGNC:25205",
      havana_gene : "OTTHUMG00000017692.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13277796,
      stop : 13302412,
      direction : "-",
      ID : "ENSG00000107537.14",
      gene_id : "ENSG00000107537.14",
      gene_type : "protein_coding",
      gene_name : "PHYH",
      gene_level : 2,
      hgnc_id : "HGNC:8940",
      havana_gene : "OTTHUMG00000017693.11",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13317428,
      stop : 13348298,
      direction : "-",
      ID : "ENSG00000086475.15",
      gene_id : "ENSG00000086475.15",
      gene_type : "protein_coding",
      gene_name : "SEPHS1",
      gene_level : 2,
      hgnc_id : "HGNC:19685",
      havana_gene : "OTTHUMG00000017696.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13438484,
      stop : 13528974,
      direction : "-",
      ID : "ENSG00000165626.17",
      gene_id : "ENSG00000165626.17",
      gene_type : "protein_coding",
      gene_name : "BEND7",
      gene_level : 2,
      hgnc_id : "HGNC:23514",
      havana_gene : "OTTHUMG00000017699.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13586939,
      stop : 13630859,
      direction : "+",
      ID : "ENSG00000165630.14",
      gene_id : "ENSG00000165630.14",
      gene_type : "protein_coding",
      gene_name : "PRPF18",
      gene_level : 2,
      hgnc_id : "HGNC:17351",
      havana_gene : "OTTHUMG00000017702.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13610047,
      stop : 13655929,
      direction : "+",
      ID : "ENSG00000282246.1",
      gene_id : "ENSG00000282246.1",
      gene_type : "protein_coding",
      gene_name : "AL157392.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000017701.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 13643706,
      stop : 14462142,
      direction : "-",
      ID : "ENSG00000151474.23",
      gene_id : "ENSG00000151474.23",
      gene_type : "protein_coding",
      gene_name : "FRMD4A",
      gene_level : 1,
      hgnc_id : "HGNC:25491",
      havana_gene : "OTTHUMG00000017708.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14518557,
      stop : 14774897,
      direction : "-",
      ID : "ENSG00000065809.14",
      gene_id : "ENSG00000065809.14",
      gene_type : "protein_coding",
      gene_name : "FAM107B",
      gene_level : 2,
      hgnc_id : "HGNC:23726",
      havana_gene : "OTTHUMG00000017709.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14819245,
      stop : 14838575,
      direction : "-",
      ID : "ENSG00000185267.10",
      gene_id : "ENSG00000185267.10",
      gene_type : "protein_coding",
      gene_name : "CDNF",
      gene_level : 2,
      hgnc_id : "HGNC:24913",
      havana_gene : "OTTHUMG00000017713.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14838302,
      stop : 14846999,
      direction : "+",
      ID : "ENSG00000284024.4",
      gene_id : "ENSG00000284024.4",
      gene_type : "protein_coding",
      gene_name : "AC069544.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000017712.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14838306,
      stop : 14871741,
      direction : "+",
      ID : "ENSG00000187522.16",
      gene_id : "ENSG00000187522.16",
      gene_type : "protein_coding",
      gene_name : "HSPA14",
      gene_level : 2,
      hgnc_id : "HGNC:29526",
      havana_gene : "OTTHUMG00000191882.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14878820,
      stop : 14904315,
      direction : "+",
      ID : "ENSG00000152455.16",
      gene_id : "ENSG00000152455.16",
      gene_type : "protein_coding",
      gene_name : "SUV39H2",
      gene_level : 1,
      hgnc_id : "HGNC:17287",
      havana_gene : "OTTHUMG00000017718.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14897359,
      stop : 14954432,
      direction : "-",
      ID : "ENSG00000152457.18",
      gene_id : "ENSG00000152457.18",
      gene_type : "protein_coding",
      gene_name : "DCLRE1C",
      gene_level : 2,
      hgnc_id : "HGNC:17642",
      havana_gene : "OTTHUMG00000017716.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 14959388,
      stop : 14988050,
      direction : "+",
      ID : "ENSG00000197889.10",
      gene_id : "ENSG00000197889.10",
      gene_type : "protein_coding",
      gene_name : "MEIG1",
      gene_level : 2,
      hgnc_id : "HGNC:23429",
      havana_gene : "OTTHUMG00000017717.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15032227,
      stop : 15073853,
      direction : "+",
      ID : "ENSG00000152463.15",
      gene_id : "ENSG00000152463.15",
      gene_type : "protein_coding",
      gene_name : "OLAH",
      gene_level : 2,
      hgnc_id : "HGNC:25625",
      havana_gene : "OTTHUMG00000017724.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15075475,
      stop : 15088776,
      direction : "-",
      ID : "ENSG00000176244.7",
      gene_id : "ENSG00000176244.7",
      gene_type : "protein_coding",
      gene_name : "ACBD7",
      gene_level : 2,
      hgnc_id : "HGNC:17715",
      havana_gene : "OTTHUMG00000017725.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15097180,
      stop : 15139818,
      direction : "+",
      ID : "ENSG00000152464.15",
      gene_id : "ENSG00000152464.15",
      gene_type : "protein_coding",
      gene_name : "RPP38",
      gene_level : 2,
      hgnc_id : "HGNC:30329",
      havana_gene : "OTTHUMG00000017728.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15102584,
      stop : 15168693,
      direction : "-",
      ID : "ENSG00000152465.18",
      gene_id : "ENSG00000152465.18",
      gene_type : "protein_coding",
      gene_name : "NMT2",
      gene_level : 2,
      hgnc_id : "HGNC:7858",
      havana_gene : "OTTHUMG00000017723.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15211643,
      stop : 15371289,
      direction : "-",
      ID : "ENSG00000148468.17",
      gene_id : "ENSG00000148468.17",
      gene_type : "protein_coding",
      gene_name : "FAM171A1",
      gene_level : 2,
      hgnc_id : "HGNC:23522",
      havana_gene : "OTTHUMG00000017732.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15513954,
      stop : 15719922,
      direction : "-",
      ID : "ENSG00000077943.8",
      gene_id : "ENSG00000077943.8",
      gene_type : "protein_coding",
      gene_name : "ITGA8",
      gene_level : 2,
      hgnc_id : "HGNC:6144",
      havana_gene : "OTTHUMG00000017733.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 15778170,
      stop : 15860507,
      direction : "-",
      ID : "ENSG00000148481.14",
      gene_id : "ENSG00000148481.14",
      gene_type : "protein_coding",
      gene_name : "MINDY3",
      gene_level : 2,
      hgnc_id : "HGNC:23578",
      havana_gene : "OTTHUMG00000017734.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 16436943,
      stop : 16513745,
      direction : "+",
      ID : "ENSG00000165983.15",
      gene_id : "ENSG00000165983.15",
      gene_type : "protein_coding",
      gene_name : "PTER",
      gene_level : 2,
      hgnc_id : "HGNC:9590",
      havana_gene : "OTTHUMG00000017737.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 16513734,
      stop : 16521879,
      direction : "-",
      ID : "ENSG00000165985.10",
      gene_id : "ENSG00000165985.10",
      gene_type : "protein_coding",
      gene_name : "C1QL3",
      gene_level : 2,
      hgnc_id : "HGNC:19359",
      havana_gene : "OTTHUMG00000017738.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 16590611,
      stop : 16817463,
      direction : "-",
      ID : "ENSG00000148484.18",
      gene_id : "ENSG00000148484.18",
      gene_type : "protein_coding",
      gene_name : "RSU1",
      gene_level : 2,
      hgnc_id : "HGNC:10464",
      havana_gene : "OTTHUMG00000017740.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 16823966,
      stop : 17129811,
      direction : "-",
      ID : "ENSG00000107611.16",
      gene_id : "ENSG00000107611.16",
      gene_type : "protein_coding",
      gene_name : "CUBN",
      gene_level : 1,
      hgnc_id : "HGNC:2548",
      havana_gene : "OTTHUMG00000017741.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17137336,
      stop : 17202054,
      direction : "-",
      ID : "ENSG00000107614.22",
      gene_id : "ENSG00000107614.22",
      gene_type : "protein_coding",
      gene_name : "TRDMT1",
      gene_level : 1,
      hgnc_id : "HGNC:2977",
      havana_gene : "OTTHUMG00000017745.13",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17228241,
      stop : 17237593,
      direction : "+",
      ID : "ENSG00000026025.16",
      gene_id : "ENSG00000026025.16",
      gene_type : "protein_coding",
      gene_name : "VIM",
      gene_level : 2,
      hgnc_id : "HGNC:12692",
      havana_gene : "OTTHUMG00000017744.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17315421,
      stop : 17454595,
      direction : "-",
      ID : "ENSG00000148488.17",
      gene_id : "ENSG00000148488.17",
      gene_type : "protein_coding",
      gene_name : "ST8SIA6",
      gene_level : 2,
      hgnc_id : "HGNC:23317",
      havana_gene : "OTTHUMG00000017748.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17589032,
      stop : 17617374,
      direction : "-",
      ID : "ENSG00000165996.14",
      gene_id : "ENSG00000165996.14",
      gene_type : "protein_coding",
      gene_name : "HACD1",
      gene_level : 1,
      hgnc_id : "HGNC:9639",
      havana_gene : "OTTHUMG00000017750.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17644151,
      stop : 17716824,
      direction : "+",
      ID : "ENSG00000136738.15",
      gene_id : "ENSG00000136738.15",
      gene_type : "protein_coding",
      gene_name : "STAM",
      gene_level : 2,
      hgnc_id : "HGNC:11357",
      havana_gene : "OTTHUMG00000017749.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17752201,
      stop : 17800868,
      direction : "+",
      ID : "ENSG00000148483.9",
      gene_id : "ENSG00000148483.9",
      gene_type : "protein_coding",
      gene_name : "TMEM236",
      gene_level : 2,
      hgnc_id : "HGNC:23473",
      havana_gene : "OTTHUMG00000017753.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17809348,
      stop : 17911164,
      direction : "+",
      ID : "ENSG00000260314.3",
      gene_id : "ENSG00000260314.3",
      gene_type : "protein_coding",
      gene_name : "MRC1",
      gene_level : 2,
      hgnc_id : "HGNC:7228",
      havana_gene : "OTTHUMG00000174646.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 17951839,
      stop : 18043292,
      direction : "+",
      ID : "ENSG00000148482.12",
      gene_id : "ENSG00000148482.12",
      gene_type : "protein_coding",
      gene_name : "SLC39A12",
      gene_level : 2,
      hgnc_id : "HGNC:20860",
      havana_gene : "OTTHUMG00000017759.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 18140424,
      stop : 18543557,
      direction : "+",
      ID : "ENSG00000165995.22",
      gene_id : "ENSG00000165995.22",
      gene_type : "protein_coding",
      gene_name : "CACNB2",
      gene_level : 2,
      hgnc_id : "HGNC:1402",
      havana_gene : "OTTHUMG00000017764.9",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 18545561,
      stop : 18659285,
      direction : "-",
      ID : "ENSG00000241058.4",
      gene_id : "ENSG00000241058.4",
      gene_type : "protein_coding",
      gene_name : "NSUN6",
      gene_level : 2,
      hgnc_id : "HGNC:23529",
      havana_gene : "OTTHUMG00000017767.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 18659431,
      stop : 18681639,
      direction : "+",
      ID : "ENSG00000165997.5",
      gene_id : "ENSG00000165997.5",
      gene_type : "protein_coding",
      gene_name : "ARL5B",
      gene_level : 2,
      hgnc_id : "HGNC:23052",
      havana_gene : "OTTHUMG00000017765.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 19048801,
      stop : 19790401,
      direction : "+",
      ID : "ENSG00000204740.11",
      gene_id : "ENSG00000204740.11",
      gene_type : "protein_coding",
      gene_name : "MALRD1",
      gene_level : 1,
      hgnc_id : "HGNC:24331",
      havana_gene : "OTTHUMG00000017779.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 19816239,
      stop : 20289856,
      direction : "+",
      ID : "ENSG00000120594.17",
      gene_id : "ENSG00000120594.17",
      gene_type : "protein_coding",
      gene_name : "PLXDC2",
      gene_level : 2,
      hgnc_id : "HGNC:21013",
      havana_gene : "OTTHUMG00000017781.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 20779973,
      stop : 21293011,
      direction : "-",
      ID : "ENSG00000078114.19",
      gene_id : "ENSG00000078114.19",
      gene_type : "protein_coding",
      gene_name : "NEBL",
      gene_level : 2,
      hgnc_id : "HGNC:16932",
      havana_gene : "OTTHUMG00000017786.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 21513475,
      stop : 21526368,
      direction : "-",
      ID : "ENSG00000180592.17",
      gene_id : "ENSG00000180592.17",
      gene_type : "protein_coding",
      gene_name : "SKIDA1",
      gene_level : 2,
      hgnc_id : "HGNC:32697",
      havana_gene : "OTTHUMG00000017797.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 21524646,
      stop : 21743630,
      direction : "+",
      ID : "ENSG00000078403.17",
      gene_id : "ENSG00000078403.17",
      gene_type : "protein_coding",
      gene_name : "MLLT10",
      gene_level : 2,
      hgnc_id : "HGNC:16063",
      havana_gene : "OTTHUMG00000017799.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 21756548,
      stop : 22003769,
      direction : "-",
      ID : "ENSG00000136770.11",
      gene_id : "ENSG00000136770.11",
      gene_type : "protein_coding",
      gene_name : "DNAJC1",
      gene_level : 2,
      hgnc_id : "HGNC:20090",
      havana_gene : "OTTHUMG00000017800.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22208814,
      stop : 22210021,
      direction : "-",
      ID : "ENSG00000223601.2",
      gene_id : "ENSG00000223601.2",
      gene_type : "protein_coding",
      gene_name : "EBLN1",
      gene_level : 2,
      hgnc_id : "HGNC:39430",
      havana_gene : "OTTHUMG00000017801.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22316386,
      stop : 22320306,
      direction : "+",
      ID : "ENSG00000148444.16",
      gene_id : "ENSG00000148444.16",
      gene_type : "protein_coding",
      gene_name : "COMMD3",
      gene_level : 2,
      hgnc_id : "HGNC:23332",
      havana_gene : "OTTHUMG00000017806.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22316388,
      stop : 22329542,
      direction : "+",
      ID : "ENSG00000269897.5",
      gene_id : "ENSG00000269897.5",
      gene_type : "protein_coding",
      gene_name : "COMMD3-BMI1",
      gene_level : 2,
      hgnc_id : "HGNC:48326",
      havana_gene : "OTTHUMG00000184031.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22321099,
      stop : 22331484,
      direction : "+",
      ID : "ENSG00000168283.14",
      gene_id : "ENSG00000168283.14",
      gene_type : "protein_coding",
      gene_name : "BMI1",
      gene_level : 2,
      hgnc_id : "HGNC:1066",
      havana_gene : "OTTHUMG00000017807.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22345445,
      stop : 22454224,
      direction : "+",
      ID : "ENSG00000077327.16",
      gene_id : "ENSG00000077327.16",
      gene_type : "protein_coding",
      gene_name : "SPAG6",
      gene_level : 2,
      hgnc_id : "HGNC:11215",
      havana_gene : "OTTHUMG00000017808.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22534854,
      stop : 22714578,
      direction : "-",
      ID : "ENSG00000150867.14",
      gene_id : "ENSG00000150867.14",
      gene_type : "protein_coding",
      gene_name : "PIP4K2A",
      gene_level : 2,
      hgnc_id : "HGNC:8997",
      havana_gene : "OTTHUMG00000017810.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 22928024,
      stop : 23038523,
      direction : "+",
      ID : "ENSG00000165309.14",
      gene_id : "ENSG00000165309.14",
      gene_type : "protein_coding",
      gene_name : "ARMC3",
      gene_level : 2,
      hgnc_id : "HGNC:30964",
      havana_gene : "OTTHUMG00000017811.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 23095579,
      stop : 23122013,
      direction : "+",
      ID : "ENSG00000148450.13",
      gene_id : "ENSG00000148450.13",
      gene_type : "protein_coding",
      gene_name : "MSRB2",
      gene_level : 2,
      hgnc_id : "HGNC:17061",
      havana_gene : "OTTHUMG00000017812.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 23192312,
      stop : 23194245,
      direction : "+",
      ID : "ENSG00000168267.7",
      gene_id : "ENSG00000168267.7",
      gene_type : "protein_coding",
      gene_name : "PTF1A",
      gene_level : 2,
      hgnc_id : "HGNC:23734",
      havana_gene : "OTTHUMG00000017815.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 23202696,
      stop : 23344845,
      direction : "-",
      ID : "ENSG00000179133.15",
      gene_id : "ENSG00000179133.15",
      gene_type : "protein_coding",
      gene_name : "C10orf67",
      gene_level : 2,
      hgnc_id : "HGNC:28716",
      havana_gene : "OTTHUMG00000017818.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 23439075,
      stop : 23442377,
      direction : "+",
      ID : "ENSG00000165312.7",
      gene_id : "ENSG00000165312.7",
      gene_type : "protein_coding",
      gene_name : "OTUD1",
      gene_level : 2,
      hgnc_id : "HGNC:27346",
      havana_gene : "OTTHUMG00000017819.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 23694746,
      stop : 24547848,
      direction : "+",
      ID : "ENSG00000120549.18",
      gene_id : "ENSG00000120549.18",
      gene_type : "protein_coding",
      gene_name : "KIAA1217",
      gene_level : 1,
      hgnc_id : "HGNC:25428",
      havana_gene : "OTTHUMG00000017824.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 24583609,
      stop : 24723887,
      direction : "-",
      ID : "ENSG00000107863.19",
      gene_id : "ENSG00000107863.19",
      gene_type : "protein_coding",
      gene_name : "ARHGAP21",
      gene_level : 1,
      hgnc_id : "HGNC:23725",
      havana_gene : "OTTHUMG00000017825.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 24848614,
      stop : 24952606,
      direction : "-",
      ID : "ENSG00000099256.19",
      gene_id : "ENSG00000099256.19",
      gene_type : "protein_coding",
      gene_name : "PRTFDC1",
      gene_level : 2,
      hgnc_id : "HGNC:23333",
      havana_gene : "OTTHUMG00000017829.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 24981979,
      stop : 25062279,
      direction : "-",
      ID : "ENSG00000151023.17",
      gene_id : "ENSG00000151023.17",
      gene_type : "protein_coding",
      gene_name : "ENKUR",
      gene_level : 2,
      hgnc_id : "HGNC:28388",
      havana_gene : "OTTHUMG00000017827.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 25016612,
      stop : 25026664,
      direction : "+",
      ID : "ENSG00000185875.13",
      gene_id : "ENSG00000185875.13",
      gene_type : "protein_coding",
      gene_name : "THNSL1",
      gene_level : 2,
      hgnc_id : "HGNC:26160",
      havana_gene : "OTTHUMG00000017828.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 25174802,
      stop : 25602229,
      direction : "+",
      ID : "ENSG00000151025.11",
      gene_id : "ENSG00000151025.11",
      gene_type : "protein_coding",
      gene_name : "GPR158",
      gene_level : 2,
      hgnc_id : "HGNC:23689",
      havana_gene : "OTTHUMG00000017832.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 25934229,
      stop : 26212532,
      direction : "+",
      ID : "ENSG00000095777.17",
      gene_id : "ENSG00000095777.17",
      gene_type : "protein_coding",
      gene_name : "MYO3A",
      gene_level : 2,
      hgnc_id : "HGNC:7601",
      havana_gene : "OTTHUMG00000017837.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 26216665,
      stop : 26304558,
      direction : "+",
      ID : "ENSG00000136750.13",
      gene_id : "ENSG00000136750.13",
      gene_type : "protein_coding",
      gene_name : "GAD2",
      gene_level : 2,
      hgnc_id : "HGNC:4093",
      havana_gene : "OTTHUMG00000017836.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 26438341,
      stop : 26567803,
      direction : "+",
      ID : "ENSG00000077420.16",
      gene_id : "ENSG00000077420.16",
      gene_type : "protein_coding",
      gene_name : "APBB1IP",
      gene_level : 2,
      hgnc_id : "HGNC:17379",
      havana_gene : "OTTHUMG00000017841.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 26697701,
      stop : 26746798,
      direction : "+",
      ID : "ENSG00000148459.16",
      gene_id : "ENSG00000148459.16",
      gene_type : "protein_coding",
      gene_name : "PDSS1",
      gene_level : 2,
      hgnc_id : "HGNC:17759",
      havana_gene : "OTTHUMG00000017844.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 26746593,
      stop : 26861087,
      direction : "-",
      ID : "ENSG00000136754.18",
      gene_id : "ENSG00000136754.18",
      gene_type : "protein_coding",
      gene_name : "ABI1",
      gene_level : 2,
      hgnc_id : "HGNC:11320",
      havana_gene : "OTTHUMG00000017848.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 26973793,
      stop : 27100494,
      direction : "-",
      ID : "ENSG00000107890.17",
      gene_id : "ENSG00000107890.17",
      gene_type : "protein_coding",
      gene_name : "ANKRD26",
      gene_level : 1,
      hgnc_id : "HGNC:29186",
      havana_gene : "OTTHUMG00000017851.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 27110111,
      stop : 27155266,
      direction : "-",
      ID : "ENSG00000136758.19",
      gene_id : "ENSG00000136758.19",
      gene_type : "protein_coding",
      gene_name : "YME1L1",
      gene_level : 1,
      hgnc_id : "HGNC:12843",
      havana_gene : "OTTHUMG00000017853.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 27154824,
      stop : 27187953,
      direction : "+",
      ID : "ENSG00000120539.15",
      gene_id : "ENSG00000120539.15",
      gene_type : "protein_coding",
      gene_name : "MASTL",
      gene_level : 2,
      hgnc_id : "HGNC:19042",
      havana_gene : "OTTHUMG00000017855.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 27168135,
      stop : 27243046,
      direction : "-",
      ID : "ENSG00000107897.20",
      gene_id : "ENSG00000107897.20",
      gene_type : "protein_coding",
      gene_name : "ACBD5",
      gene_level : 2,
      hgnc_id : "HGNC:23338",
      havana_gene : "OTTHUMG00000017854.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 27504174,
      stop : 27542239,
      direction : "+",
      ID : "ENSG00000099246.17",
      gene_id : "ENSG00000099246.17",
      gene_type : "protein_coding",
      gene_name : "RAB18",
      gene_level : 2,
      hgnc_id : "HGNC:14244",
      havana_gene : "OTTHUMG00000017861.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 27672874,
      stop : 27746060,
      direction : "-",
      ID : "ENSG00000150051.14",
      gene_id : "ENSG00000150051.14",
      gene_type : "protein_coding",
      gene_name : "MKX",
      gene_level : 2,
      hgnc_id : "HGNC:23729",
      havana_gene : "OTTHUMG00000017862.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 27775186,
      stop : 27999079,
      direction : "-",
      ID : "ENSG00000169126.16",
      gene_id : "ENSG00000169126.16",
      gene_type : "protein_coding",
      gene_name : "ARMC4",
      gene_level : 2,
      hgnc_id : "HGNC:25583",
      havana_gene : "OTTHUMG00000017867.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 28050993,
      stop : 28334486,
      direction : "-",
      ID : "ENSG00000150054.18",
      gene_id : "ENSG00000150054.18",
      gene_type : "protein_coding",
      gene_name : "MPP7",
      gene_level : 2,
      hgnc_id : "HGNC:26542",
      havana_gene : "OTTHUMG00000017868.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 28532493,
      stop : 28623112,
      direction : "+",
      ID : "ENSG00000095787.24",
      gene_id : "ENSG00000095787.24",
      gene_type : "protein_coding",
      gene_name : "WAC",
      gene_level : 1,
      hgnc_id : "HGNC:17327",
      havana_gene : "OTTHUMG00000017872.11",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 28677510,
      stop : 28682932,
      direction : "+",
      ID : "ENSG00000095739.11",
      gene_id : "ENSG00000095739.11",
      gene_type : "protein_coding",
      gene_name : "BAMBI",
      gene_level : 2,
      hgnc_id : "HGNC:30251",
      havana_gene : "OTTHUMG00000017874.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 29289061,
      stop : 29318328,
      direction : "+",
      ID : "ENSG00000120563.10",
      gene_id : "ENSG00000120563.10",
      gene_type : "protein_coding",
      gene_name : "LYZL1",
      gene_level : 2,
      hgnc_id : "HGNC:30502",
      havana_gene : "OTTHUMG00000017880.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 29457338,
      stop : 29736959,
      direction : "-",
      ID : "ENSG00000197321.15",
      gene_id : "ENSG00000197321.15",
      gene_type : "protein_coding",
      gene_name : "SVIL",
      gene_level : 2,
      hgnc_id : "HGNC:11480",
      havana_gene : "OTTHUMG00000017882.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 30012803,
      stop : 30115494,
      direction : "-",
      ID : "ENSG00000165757.9",
      gene_id : "ENSG00000165757.9",
      gene_type : "protein_coding",
      gene_name : "JCAD",
      gene_level : 2,
      hgnc_id : "HGNC:29283",
      havana_gene : "OTTHUMG00000017885.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 30309801,
      stop : 30374448,
      direction : "-",
      ID : "ENSG00000107951.15",
      gene_id : "ENSG00000107951.15",
      gene_type : "protein_coding",
      gene_name : "MTPAP",
      gene_level : 2,
      hgnc_id : "HGNC:25532",
      havana_gene : "OTTHUMG00000017895.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 30434021,
      stop : 30461833,
      direction : "+",
      ID : "ENSG00000107968.10",
      gene_id : "ENSG00000107968.10",
      gene_type : "protein_coding",
      gene_name : "MAP3K8",
      gene_level : 2,
      hgnc_id : "HGNC:6860",
      havana_gene : "OTTHUMG00000017889.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 30611779,
      stop : 30629762,
      direction : "-",
      ID : "ENSG00000151033.10",
      gene_id : "ENSG00000151033.10",
      gene_type : "protein_coding",
      gene_name : "LYZL2",
      gene_level : 2,
      hgnc_id : "HGNC:29613",
      havana_gene : "OTTHUMG00000017898.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 30820207,
      stop : 31031937,
      direction : "-",
      ID : "ENSG00000183621.15",
      gene_id : "ENSG00000183621.15",
      gene_type : "protein_coding",
      gene_name : "ZNF438",
      gene_level : 2,
      hgnc_id : "HGNC:21029",
      havana_gene : "OTTHUMG00000017904.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 31318495,
      stop : 31529814,
      direction : "+",
      ID : "ENSG00000148516.22",
      gene_id : "ENSG00000148516.22",
      gene_type : "protein_coding",
      gene_name : "ZEB1",
      gene_level : 1,
      hgnc_id : "HGNC:11642",
      havana_gene : "OTTHUMG00000017907.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 31805398,
      stop : 31928876,
      direction : "-",
      ID : "ENSG00000165322.18",
      gene_id : "ENSG00000165322.18",
      gene_type : "protein_coding",
      gene_name : "ARHGAP12",
      gene_level : 2,
      hgnc_id : "HGNC:16348",
      havana_gene : "OTTHUMG00000017911.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 32009015,
      stop : 32056425,
      direction : "-",
      ID : "ENSG00000170759.11",
      gene_id : "ENSG00000170759.11",
      gene_type : "protein_coding",
      gene_name : "KIF5B",
      gene_level : 2,
      hgnc_id : "HGNC:6324",
      havana_gene : "OTTHUMG00000017913.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 32267751,
      stop : 32378798,
      direction : "-",
      ID : "ENSG00000120616.16",
      gene_id : "ENSG00000120616.16",
      gene_type : "protein_coding",
      gene_name : "EPC1",
      gene_level : 2,
      hgnc_id : "HGNC:19876",
      havana_gene : "OTTHUMG00000017925.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 32446140,
      stop : 32882874,
      direction : "+",
      ID : "ENSG00000216937.13",
      gene_id : "ENSG00000216937.13",
      gene_type : "protein_coding",
      gene_name : "CCDC7",
      gene_level : 2,
      hgnc_id : "HGNC:26533",
      havana_gene : "OTTHUMG00000150517.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 32887273,
      stop : 33005792,
      direction : "-",
      ID : "ENSG00000150093.20",
      gene_id : "ENSG00000150093.20",
      gene_type : "protein_coding",
      gene_name : "ITGB1",
      gene_level : 1,
      hgnc_id : "HGNC:6153",
      havana_gene : "OTTHUMG00000017928.11",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 33177492,
      stop : 33336262,
      direction : "-",
      ID : "ENSG00000099250.18",
      gene_id : "ENSG00000099250.18",
      gene_type : "protein_coding",
      gene_name : "NRP1",
      gene_level : 2,
      hgnc_id : "HGNC:8004",
      havana_gene : "OTTHUMG00000019343.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 34109560,
      stop : 34815325,
      direction : "-",
      ID : "ENSG00000148498.16",
      gene_id : "ENSG00000148498.16",
      gene_type : "protein_coding",
      gene_name : "PARD3",
      gene_level : 2,
      hgnc_id : "HGNC:16051",
      havana_gene : "OTTHUMG00000017948.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 35008551,
      stop : 35090642,
      direction : "-",
      ID : "ENSG00000108094.16",
      gene_id : "ENSG00000108094.16",
      gene_type : "protein_coding",
      gene_name : "CUL2",
      gene_level : 2,
      hgnc_id : "HGNC:2552",
      havana_gene : "OTTHUMG00000017950.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 35126791,
      stop : 35212958,
      direction : "+",
      ID : "ENSG00000095794.19",
      gene_id : "ENSG00000095794.19",
      gene_type : "protein_coding",
      gene_name : "CREM",
      gene_level : 1,
      hgnc_id : "HGNC:2352",
      havana_gene : "OTTHUMG00000017953.29",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 35247025,
      stop : 35572669,
      direction : "+",
      ID : "ENSG00000108100.18",
      gene_id : "ENSG00000108100.18",
      gene_type : "protein_coding",
      gene_name : "CCNY",
      gene_level : 1,
      hgnc_id : "HGNC:23354",
      havana_gene : "OTTHUMG00000017955.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 35605341,
      stop : 35608935,
      direction : "+",
      ID : "ENSG00000177291.4",
      gene_id : "ENSG00000177291.4",
      gene_type : "protein_coding",
      gene_name : "GJD4",
      gene_level : 2,
      hgnc_id : "HGNC:23296",
      havana_gene : "OTTHUMG00000017957.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 35638247,
      stop : 35642296,
      direction : "-",
      ID : "ENSG00000177283.8",
      gene_id : "ENSG00000177283.8",
      gene_type : "protein_coding",
      gene_name : "FZD8",
      gene_level : 2,
      hgnc_id : "HGNC:4046",
      havana_gene : "OTTHUMG00000017956.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 37125725,
      stop : 37384111,
      direction : "+",
      ID : "ENSG00000148513.18",
      gene_id : "ENSG00000148513.18",
      gene_type : "protein_coding",
      gene_name : "ANKRD30A",
      gene_level : 2,
      hgnc_id : "HGNC:17234",
      havana_gene : "OTTHUMG00000017968.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 37601440,
      stop : 37602974,
      direction : "-",
      ID : "ENSG00000256892.2",
      gene_id : "ENSG00000256892.2",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L7",
      gene_level : 2,
      hgnc_id : "HGNC:37164",
      havana_gene : "OTTHUMG00000184979.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 37776526,
      stop : 37858106,
      direction : "-",
      ID : "ENSG00000198105.16",
      gene_id : "ENSG00000198105.16",
      gene_type : "protein_coding",
      gene_name : "ZNF248",
      gene_level : 2,
      hgnc_id : "HGNC:13041",
      havana_gene : "OTTHUMG00000017980.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 37949573,
      stop : 37976647,
      direction : "-",
      ID : "ENSG00000175395.16",
      gene_id : "ENSG00000175395.16",
      gene_type : "protein_coding",
      gene_name : "ZNF25",
      gene_level : 2,
      hgnc_id : "HGNC:13043",
      havana_gene : "OTTHUMG00000019344.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 38010650,
      stop : 38065088,
      direction : "+",
      ID : "ENSG00000189180.16",
      gene_id : "ENSG00000189180.16",
      gene_type : "protein_coding",
      gene_name : "ZNF33A",
      gene_level : 1,
      hgnc_id : "HGNC:13096",
      havana_gene : "OTTHUMG00000017983.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 38094334,
      stop : 38150293,
      direction : "+",
      ID : "ENSG00000075407.18",
      gene_id : "ENSG00000075407.18",
      gene_type : "protein_coding",
      gene_name : "ZNF37A",
      gene_level : 2,
      hgnc_id : "HGNC:13102",
      havana_gene : "OTTHUMG00000192066.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 38094368,
      stop : 38360098,
      direction : "+",
      ID : "ENSG00000283930.1",
      gene_id : "ENSG00000283930.1",
      gene_type : "protein_coding",
      gene_name : "PLD5P1",
      gene_level : 2,
      hgnc_id : "HGNC:55072",
      havana_gene : "OTTHUMG00000017990.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 42574185,
      stop : 42638570,
      direction : "-",
      ID : "ENSG00000196693.15",
      gene_id : "ENSG00000196693.15",
      gene_type : "protein_coding",
      gene_name : "ZNF33B",
      gene_level : 2,
      hgnc_id : "HGNC:13097",
      havana_gene : "OTTHUMG00000018014.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 42782795,
      stop : 42834937,
      direction : "+",
      ID : "ENSG00000165733.8",
      gene_id : "ENSG00000165733.8",
      gene_type : "protein_coding",
      gene_name : "BMS1",
      gene_level : 2,
      hgnc_id : "HGNC:23505",
      havana_gene : "OTTHUMG00000018020.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43077064,
      stop : 43130351,
      direction : "+",
      ID : "ENSG00000165731.20",
      gene_id : "ENSG00000165731.20",
      gene_type : "protein_coding",
      gene_name : "RET",
      gene_level : 2,
      hgnc_id : "HGNC:9967",
      havana_gene : "OTTHUMG00000018024.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43138445,
      stop : 43185302,
      direction : "+",
      ID : "ENSG00000169826.8",
      gene_id : "ENSG00000169826.8",
      gene_type : "protein_coding",
      gene_name : "CSGALNACT2",
      gene_level : 2,
      hgnc_id : "HGNC:24292",
      havana_gene : "OTTHUMG00000018023.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43194535,
      stop : 43267065,
      direction : "-",
      ID : "ENSG00000198915.12",
      gene_id : "ENSG00000198915.12",
      gene_type : "protein_coding",
      gene_name : "RASGEF1A",
      gene_level : 2,
      hgnc_id : "HGNC:24246",
      havana_gene : "OTTHUMG00000018025.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43371636,
      stop : 43376335,
      direction : "+",
      ID : "ENSG00000150201.15",
      gene_id : "ENSG00000150201.15",
      gene_type : "protein_coding",
      gene_name : "FXYD4",
      gene_level : 2,
      hgnc_id : "HGNC:4028",
      havana_gene : "OTTHUMG00000018027.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43385617,
      stop : 43409166,
      direction : "-",
      ID : "ENSG00000169813.16",
      gene_id : "ENSG00000169813.16",
      gene_type : "protein_coding",
      gene_name : "HNRNPF",
      gene_level : 2,
      hgnc_id : "HGNC:5039",
      havana_gene : "OTTHUMG00000018029.3",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43436841,
      stop : 43483181,
      direction : "+",
      ID : "ENSG00000243660.11",
      gene_id : "ENSG00000243660.11",
      gene_type : "protein_coding",
      gene_name : "ZNF487",
      gene_level : 1,
      hgnc_id : "HGNC:23488",
      havana_gene : "OTTHUMG00000185507.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43556344,
      stop : 43574618,
      direction : "-",
      ID : "ENSG00000196793.14",
      gene_id : "ENSG00000196793.14",
      gene_type : "protein_coding",
      gene_name : "ZNF239",
      gene_level : 2,
      hgnc_id : "HGNC:13031",
      havana_gene : "OTTHUMG00000018033.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43606419,
      stop : 43617904,
      direction : "+",
      ID : "ENSG00000198298.13",
      gene_id : "ENSG00000198298.13",
      gene_type : "protein_coding",
      gene_name : "ZNF485",
      gene_level : 2,
      hgnc_id : "HGNC:23440",
      havana_gene : "OTTHUMG00000018040.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 43643860,
      stop : 43648881,
      direction : "-",
      ID : "ENSG00000169740.14",
      gene_id : "ENSG00000169740.14",
      gene_type : "protein_coding",
      gene_name : "ZNF32",
      gene_level : 2,
      hgnc_id : "HGNC:13095",
      havana_gene : "OTTHUMG00000018043.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 44370165,
      stop : 44386493,
      direction : "-",
      ID : "ENSG00000107562.16",
      gene_id : "ENSG00000107562.16",
      gene_type : "protein_coding",
      gene_name : "CXCL12",
      gene_level : 1,
      hgnc_id : "HGNC:10672",
      havana_gene : "OTTHUMG00000018054.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 44911316,
      stop : 44937010,
      direction : "+",
      ID : "ENSG00000187783.12",
      gene_id : "ENSG00000187783.12",
      gene_type : "protein_coding",
      gene_name : "TMEM72",
      gene_level : 1,
      hgnc_id : "HGNC:31658",
      havana_gene : "OTTHUMG00000018067.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 44959407,
      stop : 44995891,
      direction : "+",
      ID : "ENSG00000107551.21",
      gene_id : "ENSG00000107551.21",
      gene_type : "protein_coding",
      gene_name : "RASSF4",
      gene_level : 2,
      hgnc_id : "HGNC:20793",
      havana_gene : "OTTHUMG00000018060.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 44970981,
      stop : 44978809,
      direction : "-",
      ID : "ENSG00000165507.9",
      gene_id : "ENSG00000165507.9",
      gene_type : "protein_coding",
      gene_name : "DEPP1",
      gene_level : 2,
      hgnc_id : "HGNC:23355",
      havana_gene : "OTTHUMG00000018063.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45000923,
      stop : 45005326,
      direction : "+",
      ID : "ENSG00000165512.5",
      gene_id : "ENSG00000165512.5",
      gene_type : "protein_coding",
      gene_name : "ZNF22",
      gene_level : 2,
      hgnc_id : "HGNC:13012",
      havana_gene : "OTTHUMG00000018064.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45302298,
      stop : 45315608,
      direction : "-",
      ID : "ENSG00000256574.8",
      gene_id : "ENSG00000256574.8",
      gene_type : "protein_coding",
      gene_name : "OR13A1",
      gene_level : 2,
      hgnc_id : "HGNC:14772",
      havana_gene : "OTTHUMG00000018080.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45374176,
      stop : 45446119,
      direction : "+",
      ID : "ENSG00000012779.11",
      gene_id : "ENSG00000012779.11",
      gene_type : "protein_coding",
      gene_name : "ALOX5",
      gene_level : 2,
      hgnc_id : "HGNC:435",
      havana_gene : "OTTHUMG00000018081.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45454585,
      stop : 45594906,
      direction : "-",
      ID : "ENSG00000165406.16",
      gene_id : "ENSG00000165406.16",
      gene_type : "protein_coding",
      gene_name : "MARCHF8",
      gene_level : 2,
      hgnc_id : "HGNC:23356",
      havana_gene : "OTTHUMG00000019345.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45615500,
      stop : 45672780,
      direction : "-",
      ID : "ENSG00000172671.20",
      gene_id : "ENSG00000172671.20",
      gene_type : "protein_coding",
      gene_name : "ZFAND4",
      gene_level : 1,
      hgnc_id : "HGNC:23504",
      havana_gene : "OTTHUMG00000018085.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45727200,
      stop : 45792964,
      direction : "+",
      ID : "ENSG00000172661.19",
      gene_id : "ENSG00000172661.19",
      gene_type : "protein_coding",
      gene_name : "WASHC2C",
      gene_level : 2,
      hgnc_id : "HGNC:23414",
      havana_gene : "OTTHUMG00000018089.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45825613,
      stop : 45853875,
      direction : "-",
      ID : "ENSG00000188234.14",
      gene_id : "ENSG00000188234.14",
      gene_type : "protein_coding",
      gene_name : "AGAP4",
      gene_level : 2,
      hgnc_id : "HGNC:23459",
      havana_gene : "OTTHUMG00000018088.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 45972489,
      stop : 46003742,
      direction : "+",
      ID : "ENSG00000265354.4",
      gene_id : "ENSG00000265354.4",
      gene_type : "protein_coding",
      gene_name : "TIMM23",
      gene_level : 2,
      hgnc_id : "HGNC:17312",
      havana_gene : "OTTHUMG00000188299.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46005088,
      stop : 46030623,
      direction : "-",
      ID : "ENSG00000266412.6",
      gene_id : "ENSG00000266412.6",
      gene_type : "protein_coding",
      gene_name : "NCOA4",
      gene_level : 2,
      hgnc_id : "HGNC:7671",
      havana_gene : "OTTHUMG00000188314.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46033307,
      stop : 46048180,
      direction : "-",
      ID : "ENSG00000263639.7",
      gene_id : "ENSG00000263639.7",
      gene_type : "protein_coding",
      gene_name : "MSMB",
      gene_level : 2,
      hgnc_id : "HGNC:7372",
      havana_gene : "OTTHUMG00000188315.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46286345,
      stop : 46330207,
      direction : "+",
      ID : "ENSG00000274209.5",
      gene_id : "ENSG00000274209.5",
      gene_type : "protein_coding",
      gene_name : "ANTXRL",
      gene_level : 2,
      hgnc_id : "HGNC:27277",
      havana_gene : "OTTHUMG00000188318.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46375627,
      stop : 46391784,
      direction : "+",
      ID : "ENSG00000264230.9",
      gene_id : "ENSG00000264230.9",
      gene_type : "protein_coding",
      gene_name : "ANXA8L1",
      gene_level : 2,
      hgnc_id : "HGNC:23334",
      havana_gene : "OTTHUMG00000018131.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46461099,
      stop : 46465958,
      direction : "-",
      ID : "ENSG00000204174.8",
      gene_id : "ENSG00000204174.8",
      gene_type : "protein_coding",
      gene_name : "NPY4R",
      gene_level : 2,
      hgnc_id : "HGNC:9329",
      havana_gene : "OTTHUMG00000018108.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46549044,
      stop : 46555530,
      direction : "-",
      ID : "ENSG00000204175.5",
      gene_id : "ENSG00000204175.5",
      gene_type : "protein_coding",
      gene_name : "GPRIN2",
      gene_level : 2,
      hgnc_id : "HGNC:23730",
      havana_gene : "OTTHUMG00000018107.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46578217,
      stop : 46594173,
      direction : "+",
      ID : "ENSG00000204176.14",
      gene_id : "ENSG00000204176.14",
      gene_type : "protein_coding",
      gene_name : "SYT15",
      gene_level : 2,
      hgnc_id : "HGNC:17167",
      havana_gene : "OTTHUMG00000018103.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 46911396,
      stop : 47002488,
      direction : "+",
      ID : "ENSG00000204179.10",
      gene_id : "ENSG00000204179.10",
      gene_type : "protein_coding",
      gene_name : "PTPN20",
      gene_level : 2,
      hgnc_id : "HGNC:23423",
      havana_gene : "OTTHUMG00000018094.10",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47300197,
      stop : 47313577,
      direction : "+",
      ID : "ENSG00000266524.3",
      gene_id : "ENSG00000266524.3",
      gene_type : "protein_coding",
      gene_name : "GDF10",
      gene_level : 2,
      hgnc_id : "HGNC:4215",
      havana_gene : "OTTHUMG00000188319.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47322454,
      stop : 47327588,
      direction : "+",
      ID : "ENSG00000263761.3",
      gene_id : "ENSG00000263761.3",
      gene_type : "protein_coding",
      gene_name : "GDF2",
      gene_level : 2,
      hgnc_id : "HGNC:4217",
      havana_gene : "OTTHUMG00000188320.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47348363,
      stop : 47357881,
      direction : "+",
      ID : "ENSG00000265203.2",
      gene_id : "ENSG00000265203.2",
      gene_type : "protein_coding",
      gene_name : "RBP3",
      gene_level : 2,
      hgnc_id : "HGNC:9921",
      havana_gene : "OTTHUMG00000188321.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47365496,
      stop : 47384293,
      direction : "-",
      ID : "ENSG00000265763.4",
      gene_id : "ENSG00000265763.4",
      gene_type : "protein_coding",
      gene_name : "ZNF488",
      gene_level : 2,
      hgnc_id : "HGNC:23535",
      havana_gene : "OTTHUMG00000188322.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47460162,
      stop : 47484158,
      direction : "-",
      ID : "ENSG00000265190.7",
      gene_id : "ENSG00000265190.7",
      gene_type : "protein_coding",
      gene_name : "ANXA8",
      gene_level : 2,
      hgnc_id : "HGNC:546",
      havana_gene : "OTTHUMG00000188209.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47487219,
      stop : 47491693,
      direction : "-",
      ID : "ENSG00000189090.7",
      gene_id : "ENSG00000189090.7",
      gene_type : "protein_coding",
      gene_name : "FAM25G",
      gene_level : 2,
      hgnc_id : "HGNC:23590",
      havana_gene : "OTTHUMG00000018117.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47501854,
      stop : 47523638,
      direction : "-",
      ID : "ENSG00000204172.12",
      gene_id : "ENSG00000204172.12",
      gene_type : "protein_coding",
      gene_name : "AGAP9",
      gene_level : 2,
      hgnc_id : "HGNC:23463",
      havana_gene : "OTTHUMG00000018115.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47749758,
      stop : 47763592,
      direction : "-",
      ID : "ENSG00000277758.5",
      gene_id : "ENSG00000277758.5",
      gene_type : "protein_coding",
      gene_name : "FO681492.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000189287.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47918739,
      stop : 47923524,
      direction : "+",
      ID : "ENSG00000264717.5",
      gene_id : "ENSG00000264717.5",
      gene_type : "protein_coding",
      gene_name : "NPY4R2",
      gene_level : 2,
      hgnc_id : "HGNC:52383",
      havana_gene : "OTTHUMG00000188323.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 47995322,
      stop : 47999791,
      direction : "-",
      ID : "ENSG00000276430.3",
      gene_id : "ENSG00000276430.3",
      gene_type : "protein_coding",
      gene_name : "FAM25C",
      gene_level : 2,
      hgnc_id : "HGNC:23586",
      havana_gene : "OTTHUMG00000018130.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 48153088,
      stop : 48274696,
      direction : "-",
      ID : "ENSG00000170324.21",
      gene_id : "ENSG00000170324.21",
      gene_type : "protein_coding",
      gene_name : "FRMPD2",
      gene_level : 2,
      hgnc_id : "HGNC:28572",
      havana_gene : "OTTHUMG00000018171.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 48306639,
      stop : 48439360,
      direction : "+",
      ID : "ENSG00000107643.16",
      gene_id : "ENSG00000107643.16",
      gene_type : "protein_coding",
      gene_name : "MAPK8",
      gene_level : 2,
      hgnc_id : "HGNC:6881",
      havana_gene : "OTTHUMG00000018172.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 48446036,
      stop : 48656265,
      direction : "-",
      ID : "ENSG00000128805.15",
      gene_id : "ENSG00000128805.15",
      gene_type : "protein_coding",
      gene_name : "ARHGAP22",
      gene_level : 1,
      hgnc_id : "HGNC:30320",
      havana_gene : "OTTHUMG00000018176.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 48684876,
      stop : 48982956,
      direction : "+",
      ID : "ENSG00000128815.19",
      gene_id : "ENSG00000128815.19",
      gene_type : "protein_coding",
      gene_name : "WDFY4",
      gene_level : 2,
      hgnc_id : "HGNC:29323",
      havana_gene : "OTTHUMG00000018180.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 48909483,
      stop : 48914232,
      direction : "-",
      ID : "ENSG00000165383.11",
      gene_id : "ENSG00000165383.11",
      gene_type : "protein_coding",
      gene_name : "LRRC18",
      gene_level : 2,
      hgnc_id : "HGNC:23199",
      havana_gene : "OTTHUMG00000018182.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49014236,
      stop : 49115522,
      direction : "-",
      ID : "ENSG00000165633.13",
      gene_id : "ENSG00000165633.13",
      gene_type : "protein_coding",
      gene_name : "VSTM4",
      gene_level : 2,
      hgnc_id : "HGNC:26470",
      havana_gene : "OTTHUMG00000018184.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49131154,
      stop : 49134021,
      direction : "-",
      ID : "ENSG00000172538.7",
      gene_id : "ENSG00000172538.7",
      gene_type : "protein_coding",
      gene_name : "FAM170B",
      gene_level : 2,
      hgnc_id : "HGNC:19736",
      havana_gene : "OTTHUMG00000018187.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49154725,
      stop : 49188585,
      direction : "-",
      ID : "ENSG00000204161.14",
      gene_id : "ENSG00000204161.14",
      gene_type : "protein_coding",
      gene_name : "TMEM273",
      gene_level : 2,
      hgnc_id : "HGNC:27274",
      havana_gene : "OTTHUMG00000018188.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49299170,
      stop : 49327492,
      direction : "+",
      ID : "ENSG00000177354.12",
      gene_id : "ENSG00000177354.12",
      gene_type : "protein_coding",
      gene_name : "C10orf71",
      gene_level : 2,
      hgnc_id : "HGNC:26973",
      havana_gene : "OTTHUMG00000018190.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49364066,
      stop : 49396089,
      direction : "-",
      ID : "ENSG00000165606.10",
      gene_id : "ENSG00000165606.10",
      gene_type : "protein_coding",
      gene_name : "DRGX",
      gene_level : 2,
      hgnc_id : "HGNC:21536",
      havana_gene : "OTTHUMG00000018192.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49454168,
      stop : 49539538,
      direction : "-",
      ID : "ENSG00000225830.16",
      gene_id : "ENSG00000225830.16",
      gene_type : "protein_coding",
      gene_name : "ERCC6",
      gene_level : 2,
      hgnc_id : "HGNC:3438",
      havana_gene : "OTTHUMG00000018195.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49609095,
      stop : 49667942,
      direction : "+",
      ID : "ENSG00000070748.19",
      gene_id : "ENSG00000070748.19",
      gene_type : "protein_coding",
      gene_name : "CHAT",
      gene_level : 2,
      hgnc_id : "HGNC:1912",
      havana_gene : "OTTHUMG00000018198.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49610310,
      stop : 49612720,
      direction : "+",
      ID : "ENSG00000187714.7",
      gene_id : "ENSG00000187714.7",
      gene_type : "protein_coding",
      gene_name : "SLC18A3",
      gene_level : 2,
      hgnc_id : "HGNC:10936",
      havana_gene : "OTTHUMG00000018196.2",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49679651,
      stop : 49710261,
      direction : "+",
      ID : "ENSG00000178645.13",
      gene_id : "ENSG00000178645.13",
      gene_type : "protein_coding",
      gene_name : "C10orf53",
      gene_level : 2,
      hgnc_id : "HGNC:27421",
      havana_gene : "OTTHUMG00000018199.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49734641,
      stop : 49762379,
      direction : "-",
      ID : "ENSG00000197444.10",
      gene_id : "ENSG00000197444.10",
      gene_type : "protein_coding",
      gene_name : "OGDHL",
      gene_level : 2,
      hgnc_id : "HGNC:25590",
      havana_gene : "OTTHUMG00000018200.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49818279,
      stop : 49970203,
      direction : "-",
      ID : "ENSG00000227345.9",
      gene_id : "ENSG00000227345.9",
      gene_type : "protein_coding",
      gene_name : "PARG",
      gene_level : 2,
      hgnc_id : "HGNC:8605",
      havana_gene : "OTTHUMG00000018201.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49942049,
      stop : 49974850,
      direction : "+",
      ID : "ENSG00000204152.14",
      gene_id : "ENSG00000204152.14",
      gene_type : "protein_coding",
      gene_name : "TIMM23B",
      gene_level : 2,
      hgnc_id : "HGNC:23581",
      havana_gene : "OTTHUMG00000018213.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49942056,
      stop : 50011654,
      direction : "+",
      ID : "ENSG00000178440.8",
      gene_id : "ENSG00000178440.8",
      gene_type : "protein_coding",
      gene_name : "TIMM23B-AGAP6",
      gene_level : 2,
      hgnc_id : "HGNC:45009",
      havana_gene : "OTTHUMG00000018218.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 49982190,
      stop : 50011654,
      direction : "+",
      ID : "ENSG00000204149.14",
      gene_id : "ENSG00000204149.14",
      gene_type : "protein_coding",
      gene_name : "AGAP6",
      gene_level : 1,
      hgnc_id : "HGNC:23466",
      havana_gene : "OTTHUMG00000018220.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 50067888,
      stop : 50133509,
      direction : "+",
      ID : "ENSG00000099290.17",
      gene_id : "ENSG00000099290.17",
      gene_type : "protein_coding",
      gene_name : "WASHC2A",
      gene_level : 2,
      hgnc_id : "HGNC:23416",
      havana_gene : "OTTHUMG00000018225.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 50182778,
      stop : 50279720,
      direction : "-",
      ID : "ENSG00000188611.16",
      gene_id : "ENSG00000188611.16",
      gene_type : "protein_coding",
      gene_name : "ASAH2",
      gene_level : 2,
      hgnc_id : "HGNC:18860",
      havana_gene : "OTTHUMG00000018223.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 50305586,
      stop : 50625163,
      direction : "-",
      ID : "ENSG00000198964.14",
      gene_id : "ENSG00000198964.14",
      gene_type : "protein_coding",
      gene_name : "SGMS1",
      gene_level : 2,
      hgnc_id : "HGNC:29799",
      havana_gene : "OTTHUMG00000018231.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 50739318,
      stop : 50816495,
      direction : "+",
      ID : "ENSG00000204147.11",
      gene_id : "ENSG00000204147.11",
      gene_type : "protein_coding",
      gene_name : "ASAH2B",
      gene_level : 2,
      hgnc_id : "HGNC:23456",
      havana_gene : "OTTHUMG00000018239.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 50799409,
      stop : 50885675,
      direction : "-",
      ID : "ENSG00000148584.15",
      gene_id : "ENSG00000148584.15",
      gene_type : "protein_coding",
      gene_name : "A1CF",
      gene_level : 2,
      hgnc_id : "HGNC:24086",
      havana_gene : "OTTHUMG00000018240.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 50990888,
      stop : 52298423,
      direction : "+",
      ID : "ENSG00000185532.20",
      gene_id : "ENSG00000185532.20",
      gene_type : "protein_coding",
      gene_name : "PRKG1",
      gene_level : 1,
      hgnc_id : "HGNC:9414",
      havana_gene : "OTTHUMG00000018248.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 51695486,
      stop : 51699595,
      direction : "-",
      ID : "ENSG00000177613.9",
      gene_id : "ENSG00000177613.9",
      gene_type : "protein_coding",
      gene_name : "CSTF2T",
      gene_level : 2,
      hgnc_id : "HGNC:17086",
      havana_gene : "OTTHUMG00000018246.2",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 52314281,
      stop : 52318042,
      direction : "+",
      ID : "ENSG00000107984.10",
      gene_id : "ENSG00000107984.10",
      gene_type : "protein_coding",
      gene_name : "DKK1",
      gene_level : 2,
      hgnc_id : "HGNC:2891",
      havana_gene : "OTTHUMG00000018247.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 52765380,
      stop : 52772784,
      direction : "-",
      ID : "ENSG00000165471.7",
      gene_id : "ENSG00000165471.7",
      gene_type : "protein_coding",
      gene_name : "MBL2",
      gene_level : 2,
      hgnc_id : "HGNC:6922",
      havana_gene : "OTTHUMG00000150270.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 53802771,
      stop : 55627942,
      direction : "-",
      ID : "ENSG00000150275.19",
      gene_id : "ENSG00000150275.19",
      gene_type : "protein_coding",
      gene_name : "PCDH15",
      gene_level : 2,
      hgnc_id : "HGNC:14674",
      havana_gene : "OTTHUMG00000018259.17",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 55599042,
      stop : 55600728,
      direction : "+",
      ID : "ENSG00000249860.4",
      gene_id : "ENSG00000249860.4",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L5",
      gene_level : 2,
      hgnc_id : "HGNC:37162",
      havana_gene : "OTTHUMG00000184965.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 56357227,
      stop : 56361273,
      direction : "-",
      ID : "ENSG00000122952.17",
      gene_id : "ENSG00000122952.17",
      gene_type : "protein_coding",
      gene_name : "ZWINT",
      gene_level : 2,
      hgnc_id : "HGNC:13195",
      havana_gene : "OTTHUMG00000018261.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 58191517,
      stop : 58267894,
      direction : "-",
      ID : "ENSG00000151151.6",
      gene_id : "ENSG00000151151.6",
      gene_type : "protein_coding",
      gene_name : "IPMK",
      gene_level : 2,
      hgnc_id : "HGNC:20739",
      havana_gene : "OTTHUMG00000018268.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 58269162,
      stop : 58289586,
      direction : "+",
      ID : "ENSG00000122873.12",
      gene_id : "ENSG00000122873.12",
      gene_type : "protein_coding",
      gene_name : "CISD1",
      gene_level : 2,
      hgnc_id : "HGNC:30880",
      havana_gene : "OTTHUMG00000018266.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 58334979,
      stop : 58370751,
      direction : "+",
      ID : "ENSG00000072401.15",
      gene_id : "ENSG00000072401.15",
      gene_type : "protein_coding",
      gene_name : "UBE2D1",
      gene_level : 2,
      hgnc_id : "HGNC:12474",
      havana_gene : "OTTHUMG00000018269.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 58385345,
      stop : 58399220,
      direction : "+",
      ID : "ENSG00000108064.11",
      gene_id : "ENSG00000108064.11",
      gene_type : "protein_coding",
      gene_name : "TFAM",
      gene_level : 2,
      hgnc_id : "HGNC:11741",
      havana_gene : "OTTHUMG00000018270.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 58512872,
      stop : 58831435,
      direction : "+",
      ID : "ENSG00000122870.12",
      gene_id : "ENSG00000122870.12",
      gene_type : "protein_coding",
      gene_name : "BICC1",
      gene_level : 2,
      hgnc_id : "HGNC:19351",
      havana_gene : "OTTHUMG00000018271.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 59176643,
      stop : 59247774,
      direction : "+",
      ID : "ENSG00000165443.12",
      gene_id : "ENSG00000165443.12",
      gene_type : "protein_coding",
      gene_name : "PHYHIPL",
      gene_level : 2,
      hgnc_id : "HGNC:29378",
      havana_gene : "OTTHUMG00000018276.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 59246130,
      stop : 59363181,
      direction : "-",
      ID : "ENSG00000148541.13",
      gene_id : "ENSG00000148541.13",
      gene_type : "protein_coding",
      gene_name : "FAM13C",
      gene_level : 1,
      hgnc_id : "HGNC:19371",
      havana_gene : "OTTHUMG00000018277.13",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 59650764,
      stop : 59736002,
      direction : "-",
      ID : "ENSG00000165449.12",
      gene_id : "ENSG00000165449.12",
      gene_type : "protein_coding",
      gene_name : "SLC16A9",
      gene_level : 2,
      hgnc_id : "HGNC:23520",
      havana_gene : "OTTHUMG00000018283.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 59736692,
      stop : 59756041,
      direction : "-",
      ID : "ENSG00000227877.7",
      gene_id : "ENSG00000227877.7",
      gene_type : "protein_coding",
      gene_name : "MRLN",
      gene_level : 2,
      hgnc_id : "HGNC:48649",
      havana_gene : "OTTHUMG00000018282.9",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 59788747,
      stop : 59906556,
      direction : "-",
      ID : "ENSG00000108091.11",
      gene_id : "ENSG00000108091.11",
      gene_type : "protein_coding",
      gene_name : "CCDC6",
      gene_level : 2,
      hgnc_id : "HGNC:18782",
      havana_gene : "OTTHUMG00000018284.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 60026298,
      stop : 60733490,
      direction : "-",
      ID : "ENSG00000151150.22",
      gene_id : "ENSG00000151150.22",
      gene_type : "protein_coding",
      gene_name : "ANK3",
      gene_level : 1,
      hgnc_id : "HGNC:494",
      havana_gene : "OTTHUMG00000018288.16",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 60778331,
      stop : 60794852,
      direction : "+",
      ID : "ENSG00000170312.16",
      gene_id : "ENSG00000170312.16",
      gene_type : "protein_coding",
      gene_name : "CDK1",
      gene_level : 2,
      hgnc_id : "HGNC:1722",
      havana_gene : "OTTHUMG00000018290.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 60869438,
      stop : 61001440,
      direction : "-",
      ID : "ENSG00000072422.17",
      gene_id : "ENSG00000072422.17",
      gene_type : "protein_coding",
      gene_name : "RHOBTB1",
      gene_level : 2,
      hgnc_id : "HGNC:18738",
      havana_gene : "OTTHUMG00000018292.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 61406642,
      stop : 61453381,
      direction : "-",
      ID : "ENSG00000196932.12",
      gene_id : "ENSG00000196932.12",
      gene_type : "protein_coding",
      gene_name : "TMEM26",
      gene_level : 2,
      hgnc_id : "HGNC:28550",
      havana_gene : "OTTHUMG00000018293.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 61662929,
      stop : 61766766,
      direction : "+",
      ID : "ENSG00000183346.9",
      gene_id : "ENSG00000183346.9",
      gene_type : "protein_coding",
      gene_name : "CABCOCO1",
      gene_level : 2,
      hgnc_id : "HGNC:28678",
      havana_gene : "OTTHUMG00000018295.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 61901684,
      stop : 62096944,
      direction : "+",
      ID : "ENSG00000150347.17",
      gene_id : "ENSG00000150347.17",
      gene_type : "protein_coding",
      gene_name : "ARID5B",
      gene_level : 2,
      hgnc_id : "HGNC:17362",
      havana_gene : "OTTHUMG00000018298.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 62183035,
      stop : 62268844,
      direction : "-",
      ID : "ENSG00000182010.11",
      gene_id : "ENSG00000182010.11",
      gene_type : "protein_coding",
      gene_name : "RTKN2",
      gene_level : 2,
      hgnc_id : "HGNC:19364",
      havana_gene : "OTTHUMG00000018299.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 62374192,
      stop : 62480288,
      direction : "+",
      ID : "ENSG00000138311.18",
      gene_id : "ENSG00000138311.18",
      gene_type : "protein_coding",
      gene_name : "ZNF365",
      gene_level : 1,
      hgnc_id : "HGNC:18194",
      havana_gene : "OTTHUMG00000192644.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 62374192,
      stop : 62672011,
      direction : "+",
      ID : "ENSG00000285837.1",
      gene_id : "ENSG00000285837.1",
      gene_type : "protein_coding",
      gene_name : "AC024598.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192645.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 62804720,
      stop : 62808479,
      direction : "+",
      ID : "ENSG00000181915.5",
      gene_id : "ENSG00000181915.5",
      gene_type : "protein_coding",
      gene_name : "ADO",
      gene_level : 2,
      hgnc_id : "HGNC:23506",
      havana_gene : "OTTHUMG00000018306.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 62811996,
      stop : 62919900,
      direction : "-",
      ID : "ENSG00000122877.16",
      gene_id : "ENSG00000122877.16",
      gene_type : "protein_coding",
      gene_name : "EGR2",
      gene_level : 2,
      hgnc_id : "HGNC:3239",
      havana_gene : "OTTHUMG00000018308.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 63133247,
      stop : 63155031,
      direction : "+",
      ID : "ENSG00000148572.16",
      gene_id : "ENSG00000148572.16",
      gene_type : "protein_coding",
      gene_name : "NRBF2",
      gene_level : 2,
      hgnc_id : "HGNC:19692",
      havana_gene : "OTTHUMG00000018309.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 63167221,
      stop : 63521850,
      direction : "-",
      ID : "ENSG00000171988.19",
      gene_id : "ENSG00000171988.19",
      gene_type : "protein_coding",
      gene_name : "JMJD1C",
      gene_level : 1,
      hgnc_id : "HGNC:12313",
      havana_gene : "OTTHUMG00000018311.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 63521401,
      stop : 63625128,
      direction : "+",
      ID : "ENSG00000165476.14",
      gene_id : "ENSG00000165476.14",
      gene_type : "protein_coding",
      gene_name : "REEP3",
      gene_level : 2,
      hgnc_id : "HGNC:23711",
      havana_gene : "OTTHUMG00000018318.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 65912523,
      stop : 67696195,
      direction : "-",
      ID : "ENSG00000183230.17",
      gene_id : "ENSG00000183230.17",
      gene_type : "protein_coding",
      gene_name : "CTNNA3",
      gene_level : 2,
      hgnc_id : "HGNC:2511",
      havana_gene : "OTTHUMG00000018334.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 66926036,
      stop : 67101551,
      direction : "+",
      ID : "ENSG00000198739.11",
      gene_id : "ENSG00000198739.11",
      gene_type : "protein_coding",
      gene_name : "LRRTM3",
      gene_level : 2,
      hgnc_id : "HGNC:19410",
      havana_gene : "OTTHUMG00000018332.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 67796669,
      stop : 67838188,
      direction : "-",
      ID : "ENSG00000108176.15",
      gene_id : "ENSG00000108176.15",
      gene_type : "protein_coding",
      gene_name : "DNAJC12",
      gene_level : 2,
      hgnc_id : "HGNC:28908",
      havana_gene : "OTTHUMG00000018339.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 67884656,
      stop : 67918390,
      direction : "+",
      ID : "ENSG00000096717.12",
      gene_id : "ENSG00000096717.12",
      gene_type : "protein_coding",
      gene_name : "SIRT1",
      gene_level : 2,
      hgnc_id : "HGNC:14929",
      havana_gene : "OTTHUMG00000018340.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 67921899,
      stop : 68075301,
      direction : "-",
      ID : "ENSG00000148634.16",
      gene_id : "ENSG00000148634.16",
      gene_type : "protein_coding",
      gene_name : "HERC4",
      gene_level : 1,
      hgnc_id : "HGNC:24521",
      havana_gene : "OTTHUMG00000018343.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68106117,
      stop : 68212017,
      direction : "+",
      ID : "ENSG00000138347.16",
      gene_id : "ENSG00000138347.16",
      gene_type : "protein_coding",
      gene_name : "MYPN",
      gene_level : 2,
      hgnc_id : "HGNC:23246",
      havana_gene : "OTTHUMG00000018344.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68230595,
      stop : 68232113,
      direction : "-",
      ID : "ENSG00000179774.9",
      gene_id : "ENSG00000179774.9",
      gene_type : "protein_coding",
      gene_name : "ATOH7",
      gene_level : 2,
      hgnc_id : "HGNC:13907",
      havana_gene : "OTTHUMG00000018346.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68282660,
      stop : 68333049,
      direction : "-",
      ID : "ENSG00000108187.16",
      gene_id : "ENSG00000108187.16",
      gene_type : "protein_coding",
      gene_name : "PBLD",
      gene_level : 2,
      hgnc_id : "HGNC:23301",
      havana_gene : "OTTHUMG00000073949.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68331174,
      stop : 68343193,
      direction : "+",
      ID : "ENSG00000096746.18",
      gene_id : "ENSG00000096746.18",
      gene_type : "protein_coding",
      gene_name : "HNRNPH3",
      gene_level : 2,
      hgnc_id : "HGNC:5043",
      havana_gene : "OTTHUMG00000018349.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68341107,
      stop : 68407294,
      direction : "-",
      ID : "ENSG00000204130.14",
      gene_id : "ENSG00000204130.14",
      gene_type : "protein_coding",
      gene_name : "RUFY2",
      gene_level : 2,
      hgnc_id : "HGNC:19761",
      havana_gene : "OTTHUMG00000018353.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68414064,
      stop : 68472121,
      direction : "-",
      ID : "ENSG00000138346.15",
      gene_id : "ENSG00000138346.15",
      gene_type : "protein_coding",
      gene_name : "DNA2",
      gene_level : 2,
      hgnc_id : "HGNC:2939",
      havana_gene : "OTTHUMG00000018352.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68477998,
      stop : 68527523,
      direction : "-",
      ID : "ENSG00000122912.15",
      gene_id : "ENSG00000122912.15",
      gene_type : "protein_coding",
      gene_name : "SLC25A16",
      gene_level : 2,
      hgnc_id : "HGNC:10986",
      havana_gene : "OTTHUMG00000018354.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68560337,
      stop : 68694487,
      direction : "+",
      ID : "ENSG00000138336.9",
      gene_id : "ENSG00000138336.9",
      gene_type : "protein_coding",
      gene_name : "TET1",
      gene_level : 2,
      hgnc_id : "HGNC:29484",
      havana_gene : "OTTHUMG00000018359.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68721012,
      stop : 68792377,
      direction : "+",
      ID : "ENSG00000060339.14",
      gene_id : "ENSG00000060339.14",
      gene_type : "protein_coding",
      gene_name : "CCAR1",
      gene_level : 1,
      hgnc_id : "HGNC:24236",
      havana_gene : "OTTHUMG00000018361.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68827531,
      stop : 68895432,
      direction : "+",
      ID : "ENSG00000165730.16",
      gene_id : "ENSG00000165730.16",
      gene_type : "protein_coding",
      gene_name : "STOX1",
      gene_level : 2,
      hgnc_id : "HGNC:23508",
      havana_gene : "OTTHUMG00000018367.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68901286,
      stop : 68946847,
      direction : "+",
      ID : "ENSG00000107625.14",
      gene_id : "ENSG00000107625.14",
      gene_type : "protein_coding",
      gene_name : "DDX50",
      gene_level : 2,
      hgnc_id : "HGNC:17906",
      havana_gene : "OTTHUMG00000018362.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68956170,
      stop : 68985068,
      direction : "+",
      ID : "ENSG00000165732.13",
      gene_id : "ENSG00000165732.13",
      gene_type : "protein_coding",
      gene_name : "DDX21",
      gene_level : 2,
      hgnc_id : "HGNC:2744",
      havana_gene : "OTTHUMG00000018366.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 68988803,
      stop : 69043544,
      direction : "+",
      ID : "ENSG00000198954.9",
      gene_id : "ENSG00000198954.9",
      gene_type : "protein_coding",
      gene_name : "KIFBP",
      gene_level : 2,
      hgnc_id : "HGNC:23419",
      havana_gene : "OTTHUMG00000018363.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69088103,
      stop : 69104805,
      direction : "+",
      ID : "ENSG00000122862.5",
      gene_id : "ENSG00000122862.5",
      gene_type : "protein_coding",
      gene_name : "SRGN",
      gene_level : 2,
      hgnc_id : "HGNC:9361",
      havana_gene : "OTTHUMG00000018369.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69123512,
      stop : 69174412,
      direction : "+",
      ID : "ENSG00000122958.15",
      gene_id : "ENSG00000122958.15",
      gene_type : "protein_coding",
      gene_name : "VPS26A",
      gene_level : 2,
      hgnc_id : "HGNC:12711",
      havana_gene : "OTTHUMG00000018376.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69180234,
      stop : 69209099,
      direction : "+",
      ID : "ENSG00000156502.14",
      gene_id : "ENSG00000156502.14",
      gene_type : "protein_coding",
      gene_name : "SUPV3L1",
      gene_level : 2,
      hgnc_id : "HGNC:11471",
      havana_gene : "OTTHUMG00000018375.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69220332,
      stop : 69267552,
      direction : "+",
      ID : "ENSG00000156510.13",
      gene_id : "ENSG00000156510.13",
      gene_type : "protein_coding",
      gene_name : "HKDC1",
      gene_level : 2,
      hgnc_id : "HGNC:23302",
      havana_gene : "OTTHUMG00000018371.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69269984,
      stop : 69401884,
      direction : "+",
      ID : "ENSG00000156515.24",
      gene_id : "ENSG00000156515.24",
      gene_type : "protein_coding",
      gene_name : "HK1",
      gene_level : 2,
      hgnc_id : "HGNC:4922",
      havana_gene : "OTTHUMG00000018380.16",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69403903,
      stop : 69416918,
      direction : "-",
      ID : "ENSG00000075073.15",
      gene_id : "ENSG00000075073.15",
      gene_type : "protein_coding",
      gene_name : "TACR2",
      gene_level : 2,
      hgnc_id : "HGNC:11527",
      havana_gene : "OTTHUMG00000018377.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69451465,
      stop : 69507666,
      direction : "+",
      ID : "ENSG00000099282.10",
      gene_id : "ENSG00000099282.10",
      gene_type : "protein_coding",
      gene_name : "TSPAN15",
      gene_level : 1,
      hgnc_id : "HGNC:23298",
      havana_gene : "OTTHUMG00000018381.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69571698,
      stop : 69573422,
      direction : "-",
      ID : "ENSG00000122859.5",
      gene_id : "ENSG00000122859.5",
      gene_type : "protein_coding",
      gene_name : "NEUROG3",
      gene_level : 2,
      hgnc_id : "HGNC:13806",
      havana_gene : "OTTHUMG00000018391.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69630247,
      stop : 69633596,
      direction : "+",
      ID : "ENSG00000171224.9",
      gene_id : "ENSG00000171224.9",
      gene_type : "protein_coding",
      gene_name : "FAM241B",
      gene_level : 2,
      hgnc_id : "HGNC:23519",
      havana_gene : "OTTHUMG00000018383.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 69801880,
      stop : 69964275,
      direction : "+",
      ID : "ENSG00000197467.16",
      gene_id : "ENSG00000197467.16",
      gene_type : "protein_coding",
      gene_name : "COL13A1",
      gene_level : 1,
      hgnc_id : "HGNC:2190",
      havana_gene : "OTTHUMG00000018394.24",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70052544,
      stop : 70112282,
      direction : "+",
      ID : "ENSG00000099284.15",
      gene_id : "ENSG00000099284.15",
      gene_type : "protein_coding",
      gene_name : "MACROH2A2",
      gene_level : 1,
      hgnc_id : "HGNC:14453",
      havana_gene : "OTTHUMG00000018396.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70098223,
      stop : 70132934,
      direction : "-",
      ID : "ENSG00000042286.15",
      gene_id : "ENSG00000042286.15",
      gene_type : "protein_coding",
      gene_name : "AIFM2",
      gene_level : 2,
      hgnc_id : "HGNC:21411",
      havana_gene : "OTTHUMG00000018398.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70137981,
      stop : 70146700,
      direction : "-",
      ID : "ENSG00000156521.14",
      gene_id : "ENSG00000156521.14",
      gene_type : "protein_coding",
      gene_name : "TYSND1",
      gene_level : 2,
      hgnc_id : "HGNC:28531",
      havana_gene : "OTTHUMG00000018397.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70147289,
      stop : 70170523,
      direction : "-",
      ID : "ENSG00000079332.15",
      gene_id : "ENSG00000079332.15",
      gene_type : "protein_coding",
      gene_name : "SAR1A",
      gene_level : 2,
      hgnc_id : "HGNC:10534",
      havana_gene : "OTTHUMG00000018400.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70202835,
      stop : 70233911,
      direction : "-",
      ID : "ENSG00000180817.12",
      gene_id : "ENSG00000180817.12",
      gene_type : "protein_coding",
      gene_name : "PPA1",
      gene_level : 2,
      hgnc_id : "HGNC:9226",
      havana_gene : "OTTHUMG00000018399.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70247329,
      stop : 70284004,
      direction : "-",
      ID : "ENSG00000148734.8",
      gene_id : "ENSG00000148734.8",
      gene_type : "protein_coding",
      gene_name : "NPFFR1",
      gene_level : 2,
      hgnc_id : "HGNC:17425",
      havana_gene : "OTTHUMG00000018404.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70298970,
      stop : 70382650,
      direction : "-",
      ID : "ENSG00000172731.14",
      gene_id : "ENSG00000172731.14",
      gene_type : "protein_coding",
      gene_name : "LRRC20",
      gene_level : 2,
      hgnc_id : "HGNC:23421",
      havana_gene : "OTTHUMG00000018407.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70404145,
      stop : 70428618,
      direction : "+",
      ID : "ENSG00000148730.7",
      gene_id : "ENSG00000148730.7",
      gene_type : "protein_coding",
      gene_name : "EIF4EBP2",
      gene_level : 2,
      hgnc_id : "HGNC:3289",
      havana_gene : "OTTHUMG00000018409.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70431936,
      stop : 70447951,
      direction : "-",
      ID : "ENSG00000156574.10",
      gene_id : "ENSG00000156574.10",
      gene_type : "protein_coding",
      gene_name : "NODAL",
      gene_level : 2,
      hgnc_id : "HGNC:7865",
      havana_gene : "OTTHUMG00000018408.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70478767,
      stop : 70568450,
      direction : "+",
      ID : "ENSG00000107719.9",
      gene_id : "ENSG00000107719.9",
      gene_type : "protein_coding",
      gene_name : "PALD1",
      gene_level : 2,
      hgnc_id : "HGNC:23530",
      havana_gene : "OTTHUMG00000018411.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70597348,
      stop : 70602759,
      direction : "-",
      ID : "ENSG00000180644.8",
      gene_id : "ENSG00000180644.8",
      gene_type : "protein_coding",
      gene_name : "PRF1",
      gene_level : 2,
      hgnc_id : "HGNC:9360",
      havana_gene : "OTTHUMG00000018412.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70672506,
      stop : 70762441,
      direction : "+",
      ID : "ENSG00000138316.11",
      gene_id : "ENSG00000138316.11",
      gene_type : "protein_coding",
      gene_name : "ADAMTS14",
      gene_level : 2,
      hgnc_id : "HGNC:14899",
      havana_gene : "OTTHUMG00000018414.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70771239,
      stop : 70785401,
      direction : "-",
      ID : "ENSG00000166220.12",
      gene_id : "ENSG00000166220.12",
      gene_type : "protein_coding",
      gene_name : "TBATA",
      gene_level : 2,
      hgnc_id : "HGNC:23511",
      havana_gene : "OTTHUMG00000018413.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70815948,
      stop : 70881184,
      direction : "+",
      ID : "ENSG00000166224.17",
      gene_id : "ENSG00000166224.17",
      gene_type : "protein_coding",
      gene_name : "SGPL1",
      gene_level : 2,
      hgnc_id : "HGNC:10817",
      havana_gene : "OTTHUMG00000018421.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 70882280,
      stop : 70888565,
      direction : "-",
      ID : "ENSG00000166228.9",
      gene_id : "ENSG00000166228.9",
      gene_type : "protein_coding",
      gene_name : "PCBD1",
      gene_level : 2,
      hgnc_id : "HGNC:8646",
      havana_gene : "OTTHUMG00000018417.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71212570,
      stop : 71302864,
      direction : "+",
      ID : "ENSG00000107731.12",
      gene_id : "ENSG00000107731.12",
      gene_type : "protein_coding",
      gene_name : "UNC5B",
      gene_level : 2,
      hgnc_id : "HGNC:12568",
      havana_gene : "OTTHUMG00000018422.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71319259,
      stop : 71381423,
      direction : "+",
      ID : "ENSG00000198246.9",
      gene_id : "ENSG00000198246.9",
      gene_type : "protein_coding",
      gene_name : "SLC29A3",
      gene_level : 2,
      hgnc_id : "HGNC:23096",
      havana_gene : "OTTHUMG00000018424.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71396920,
      stop : 71815947,
      direction : "+",
      ID : "ENSG00000107736.22",
      gene_id : "ENSG00000107736.22",
      gene_type : "protein_coding",
      gene_name : "CDH23",
      gene_level : 1,
      hgnc_id : "HGNC:13733",
      havana_gene : "OTTHUMG00000019347.18",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71711701,
      stop : 71737824,
      direction : "-",
      ID : "ENSG00000214688.6",
      gene_id : "ENSG00000214688.6",
      gene_type : "protein_coding",
      gene_name : "C10orf105",
      gene_level : 2,
      hgnc_id : "HGNC:20304",
      havana_gene : "OTTHUMG00000018427.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71747556,
      stop : 71773520,
      direction : "-",
      ID : "ENSG00000107738.20",
      gene_id : "ENSG00000107738.20",
      gene_type : "protein_coding",
      gene_name : "VSIR",
      gene_level : 2,
      hgnc_id : "HGNC:30085",
      havana_gene : "OTTHUMG00000018426.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71816298,
      stop : 71851325,
      direction : "-",
      ID : "ENSG00000197746.14",
      gene_id : "ENSG00000197746.14",
      gene_type : "protein_coding",
      gene_name : "PSAP",
      gene_level : 2,
      hgnc_id : "HGNC:9498",
      havana_gene : "OTTHUMG00000018429.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 71964395,
      stop : 72013558,
      direction : "+",
      ID : "ENSG00000122863.6",
      gene_id : "ENSG00000122863.6",
      gene_type : "protein_coding",
      gene_name : "CHST3",
      gene_level : 2,
      hgnc_id : "HGNC:1971",
      havana_gene : "OTTHUMG00000018431.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72059034,
      stop : 72089032,
      direction : "-",
      ID : "ENSG00000107742.13",
      gene_id : "ENSG00000107742.13",
      gene_type : "protein_coding",
      gene_name : "SPOCK2",
      gene_level : 2,
      hgnc_id : "HGNC:13564",
      havana_gene : "OTTHUMG00000018430.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72096032,
      stop : 72217134,
      direction : "-",
      ID : "ENSG00000138303.18",
      gene_id : "ENSG00000138303.18",
      gene_type : "protein_coding",
      gene_name : "ASCC1",
      gene_level : 1,
      hgnc_id : "HGNC:24268",
      havana_gene : "OTTHUMG00000018434.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72216000,
      stop : 72235860,
      direction : "+",
      ID : "ENSG00000166295.9",
      gene_id : "ENSG00000166295.9",
      gene_type : "protein_coding",
      gene_name : "ANAPC16",
      gene_level : 2,
      hgnc_id : "HGNC:26976",
      havana_gene : "OTTHUMG00000018433.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72273919,
      stop : 72276036,
      direction : "+",
      ID : "ENSG00000168209.6",
      gene_id : "ENSG00000168209.6",
      gene_type : "protein_coding",
      gene_name : "DDIT4",
      gene_level : 2,
      hgnc_id : "HGNC:24944",
      havana_gene : "OTTHUMG00000183961.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72332830,
      stop : 72355149,
      direction : "-",
      ID : "ENSG00000148719.15",
      gene_id : "ENSG00000148719.15",
      gene_type : "protein_coding",
      gene_name : "DNAJB12",
      gene_level : 2,
      hgnc_id : "HGNC:14891",
      havana_gene : "OTTHUMG00000018436.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72367327,
      stop : 72626191,
      direction : "-",
      ID : "ENSG00000107745.19",
      gene_id : "ENSG00000107745.19",
      gene_type : "protein_coding",
      gene_name : "MICU1",
      gene_level : 2,
      hgnc_id : "HGNC:1530",
      havana_gene : "OTTHUMG00000018437.13",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72692131,
      stop : 72887694,
      direction : "+",
      ID : "ENSG00000156026.14",
      gene_id : "ENSG00000156026.14",
      gene_type : "protein_coding",
      gene_name : "MCU",
      gene_level : 2,
      hgnc_id : "HGNC:23526",
      havana_gene : "OTTHUMG00000018443.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72893584,
      stop : 72933036,
      direction : "+",
      ID : "ENSG00000138315.13",
      gene_id : "ENSG00000138315.13",
      gene_type : "protein_coding",
      gene_name : "OIT3",
      gene_level : 2,
      hgnc_id : "HGNC:29953",
      havana_gene : "OTTHUMG00000018444.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 72934762,
      stop : 72954806,
      direction : "-",
      ID : "ENSG00000138308.6",
      gene_id : "ENSG00000138308.6",
      gene_type : "protein_coding",
      gene_name : "PLA2G12B",
      gene_level : 2,
      hgnc_id : "HGNC:18555",
      havana_gene : "OTTHUMG00000018446.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73007217,
      stop : 73096974,
      direction : "-",
      ID : "ENSG00000122884.12",
      gene_id : "ENSG00000122884.12",
      gene_type : "protein_coding",
      gene_name : "P4HA1",
      gene_level : 2,
      hgnc_id : "HGNC:8546",
      havana_gene : "OTTHUMG00000018449.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73110375,
      stop : 73131828,
      direction : "+",
      ID : "ENSG00000166321.14",
      gene_id : "ENSG00000166321.14",
      gene_type : "protein_coding",
      gene_name : "NUDT13",
      gene_level : 2,
      hgnc_id : "HGNC:18827",
      havana_gene : "OTTHUMG00000018453.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73130155,
      stop : 73169055,
      direction : "-",
      ID : "ENSG00000122882.11",
      gene_id : "ENSG00000122882.11",
      gene_type : "protein_coding",
      gene_name : "ECD",
      gene_level : 2,
      hgnc_id : "HGNC:17029",
      havana_gene : "OTTHUMG00000018451.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73168119,
      stop : 73244504,
      direction : "+",
      ID : "ENSG00000138286.15",
      gene_id : "ENSG00000138286.15",
      gene_type : "protein_coding",
      gene_name : "FAM149B1",
      gene_level : 2,
      hgnc_id : "HGNC:29162",
      havana_gene : "OTTHUMG00000067794.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73183362,
      stop : 73247255,
      direction : "-",
      ID : "ENSG00000213551.7",
      gene_id : "ENSG00000213551.7",
      gene_type : "protein_coding",
      gene_name : "DNAJC9",
      gene_level : 2,
      hgnc_id : "HGNC:19123",
      havana_gene : "OTTHUMG00000196006.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73248843,
      stop : 73252693,
      direction : "-",
      ID : "ENSG00000182180.14",
      gene_id : "ENSG00000182180.14",
      gene_type : "protein_coding",
      gene_name : "MRPS16",
      gene_level : 2,
      hgnc_id : "HGNC:14048",
      havana_gene : "OTTHUMG00000018454.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73253759,
      stop : 73358859,
      direction : "-",
      ID : "ENSG00000156042.18",
      gene_id : "ENSG00000156042.18",
      gene_type : "protein_coding",
      gene_name : "CFAP70",
      gene_level : 2,
      hgnc_id : "HGNC:30726",
      havana_gene : "OTTHUMG00000018459.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73375101,
      stop : 73414076,
      direction : "-",
      ID : "ENSG00000138279.16",
      gene_id : "ENSG00000138279.16",
      gene_type : "protein_coding",
      gene_name : "ANXA7",
      gene_level : 2,
      hgnc_id : "HGNC:545",
      havana_gene : "OTTHUMG00000018463.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73423579,
      stop : 73433561,
      direction : "-",
      ID : "ENSG00000166343.10",
      gene_id : "ENSG00000166343.10",
      gene_type : "protein_coding",
      gene_name : "MSS51",
      gene_level : 2,
      hgnc_id : "HGNC:21000",
      havana_gene : "OTTHUMG00000018464.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73436433,
      stop : 73496024,
      direction : "-",
      ID : "ENSG00000107758.16",
      gene_id : "ENSG00000107758.16",
      gene_type : "protein_coding",
      gene_name : "PPP3CB",
      gene_level : 2,
      hgnc_id : "HGNC:9315",
      havana_gene : "OTTHUMG00000018472.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73497538,
      stop : 73625994,
      direction : "-",
      ID : "ENSG00000166348.19",
      gene_id : "ENSG00000166348.19",
      gene_type : "protein_coding",
      gene_name : "USP54",
      gene_level : 2,
      hgnc_id : "HGNC:23513",
      havana_gene : "OTTHUMG00000018469.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73631612,
      stop : 73641474,
      direction : "-",
      ID : "ENSG00000177791.12",
      gene_id : "ENSG00000177791.12",
      gene_type : "protein_coding",
      gene_name : "MYOZ1",
      gene_level : 2,
      hgnc_id : "HGNC:13752",
      havana_gene : "OTTHUMG00000018466.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73644881,
      stop : 73663803,
      direction : "-",
      ID : "ENSG00000166317.12",
      gene_id : "ENSG00000166317.12",
      gene_type : "protein_coding",
      gene_name : "SYNPO2L",
      gene_level : 2,
      hgnc_id : "HGNC:23532",
      havana_gene : "OTTHUMG00000018471.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73674287,
      stop : 73697881,
      direction : "-",
      ID : "ENSG00000172650.14",
      gene_id : "ENSG00000172650.14",
      gene_type : "protein_coding",
      gene_name : "AGAP5",
      gene_level : 2,
      hgnc_id : "HGNC:23467",
      havana_gene : "OTTHUMG00000018473.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73744372,
      stop : 73772161,
      direction : "+",
      ID : "ENSG00000176986.16",
      gene_id : "ENSG00000176986.16",
      gene_type : "protein_coding",
      gene_name : "SEC24C",
      gene_level : 2,
      hgnc_id : "HGNC:10705",
      havana_gene : "OTTHUMG00000018476.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73772276,
      stop : 73780251,
      direction : "+",
      ID : "ENSG00000196968.11",
      gene_id : "ENSG00000196968.11",
      gene_type : "protein_coding",
      gene_name : "FUT11",
      gene_level : 2,
      hgnc_id : "HGNC:19233",
      havana_gene : "OTTHUMG00000018483.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73782047,
      stop : 73783652,
      direction : "+",
      ID : "ENSG00000172586.8",
      gene_id : "ENSG00000172586.8",
      gene_type : "protein_coding",
      gene_name : "CHCHD1",
      gene_level : 2,
      hgnc_id : "HGNC:23518",
      havana_gene : "OTTHUMG00000018475.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73785606,
      stop : 73801797,
      direction : "+",
      ID : "ENSG00000214655.11",
      gene_id : "ENSG00000214655.11",
      gene_type : "protein_coding",
      gene_name : "ZSWIM8",
      gene_level : 2,
      hgnc_id : "HGNC:23528",
      havana_gene : "OTTHUMG00000018486.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73796514,
      stop : 73811651,
      direction : "-",
      ID : "ENSG00000272916.5",
      gene_id : "ENSG00000272916.5",
      gene_type : "protein_coding",
      gene_name : "AC022400.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185992.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73801911,
      stop : 73811798,
      direction : "-",
      ID : "ENSG00000166507.19",
      gene_id : "ENSG00000166507.19",
      gene_type : "protein_coding",
      gene_name : "NDST2",
      gene_level : 2,
      hgnc_id : "HGNC:7681",
      havana_gene : "OTTHUMG00000018489.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73812501,
      stop : 73874591,
      direction : "-",
      ID : "ENSG00000148660.21",
      gene_id : "ENSG00000148660.21",
      gene_type : "protein_coding",
      gene_name : "CAMK2G",
      gene_level : 2,
      hgnc_id : "HGNC:1463",
      havana_gene : "OTTHUMG00000018492.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73909177,
      stop : 73917496,
      direction : "+",
      ID : "ENSG00000122861.16",
      gene_id : "ENSG00000122861.16",
      gene_type : "protein_coding",
      gene_name : "PLAU",
      gene_level : 2,
      hgnc_id : "HGNC:9052",
      havana_gene : "OTTHUMG00000018494.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 73995193,
      stop : 74121363,
      direction : "+",
      ID : "ENSG00000035403.18",
      gene_id : "ENSG00000035403.18",
      gene_type : "protein_coding",
      gene_name : "VCL",
      gene_level : 2,
      hgnc_id : "HGNC:12665",
      havana_gene : "OTTHUMG00000018498.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 74120255,
      stop : 74150842,
      direction : "-",
      ID : "ENSG00000185009.13",
      gene_id : "ENSG00000185009.13",
      gene_type : "protein_coding",
      gene_name : "AP3M1",
      gene_level : 2,
      hgnc_id : "HGNC:569",
      havana_gene : "OTTHUMG00000018497.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 74151202,
      stop : 74709963,
      direction : "+",
      ID : "ENSG00000156110.15",
      gene_id : "ENSG00000156110.15",
      gene_type : "protein_coding",
      gene_name : "ADK",
      gene_level : 2,
      hgnc_id : "HGNC:257",
      havana_gene : "OTTHUMG00000018506.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 74824927,
      stop : 75032624,
      direction : "+",
      ID : "ENSG00000156650.14",
      gene_id : "ENSG00000156650.14",
      gene_type : "protein_coding",
      gene_name : "KAT6B",
      gene_level : 2,
      hgnc_id : "HGNC:17582",
      havana_gene : "OTTHUMG00000018509.9",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75037836,
      stop : 75058514,
      direction : "-",
      ID : "ENSG00000188716.5",
      gene_id : "ENSG00000188716.5",
      gene_type : "protein_coding",
      gene_name : "DUSP29",
      gene_level : 2,
      hgnc_id : "HGNC:23481",
      havana_gene : "OTTHUMG00000018512.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75094432,
      stop : 75109221,
      direction : "-",
      ID : "ENSG00000079393.20",
      gene_id : "ENSG00000079393.20",
      gene_type : "protein_coding",
      gene_name : "DUSP13",
      gene_level : 1,
      hgnc_id : "HGNC:19681",
      havana_gene : "OTTHUMG00000018516.10",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75099586,
      stop : 75182123,
      direction : "+",
      ID : "ENSG00000156671.15",
      gene_id : "ENSG00000156671.15",
      gene_type : "protein_coding",
      gene_name : "SAMD8",
      gene_level : 2,
      hgnc_id : "HGNC:26320",
      havana_gene : "OTTHUMG00000018515.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75210154,
      stop : 75231448,
      direction : "+",
      ID : "ENSG00000165637.13",
      gene_id : "ENSG00000165637.13",
      gene_type : "protein_coding",
      gene_name : "VDAC2",
      gene_level : 2,
      hgnc_id : "HGNC:12672",
      havana_gene : "OTTHUMG00000018517.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75233641,
      stop : 75236030,
      direction : "-",
      ID : "ENSG00000165644.11",
      gene_id : "ENSG00000165644.11",
      gene_type : "protein_coding",
      gene_name : "COMTD1",
      gene_level : 2,
      hgnc_id : "HGNC:26309",
      havana_gene : "OTTHUMG00000018518.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75397830,
      stop : 75401764,
      direction : "-",
      ID : "ENSG00000165655.17",
      gene_id : "ENSG00000165655.17",
      gene_type : "protein_coding",
      gene_name : "ZNF503",
      gene_level : 2,
      hgnc_id : "HGNC:23589",
      havana_gene : "OTTHUMG00000018526.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 75431624,
      stop : 76560168,
      direction : "+",
      ID : "ENSG00000148655.15",
      gene_id : "ENSG00000148655.15",
      gene_type : "protein_coding",
      gene_name : "LRMDA",
      gene_level : 1,
      hgnc_id : "HGNC:23405",
      havana_gene : "OTTHUMG00000018532.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 76869601,
      stop : 77638369,
      direction : "-",
      ID : "ENSG00000156113.24",
      gene_id : "ENSG00000156113.24",
      gene_type : "protein_coding",
      gene_name : "KCNMA1",
      gene_level : 1,
      hgnc_id : "HGNC:6284",
      havana_gene : "OTTHUMG00000018543.33",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 77790791,
      stop : 77926755,
      direction : "-",
      ID : "ENSG00000151208.17",
      gene_id : "ENSG00000151208.17",
      gene_type : "protein_coding",
      gene_name : "DLG5",
      gene_level : 2,
      hgnc_id : "HGNC:2904",
      havana_gene : "OTTHUMG00000018548.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 77969251,
      stop : 78029515,
      direction : "-",
      ID : "ENSG00000148606.13",
      gene_id : "ENSG00000148606.13",
      gene_type : "protein_coding",
      gene_name : "POLR3A",
      gene_level : 2,
      hgnc_id : "HGNC:30074",
      havana_gene : "OTTHUMG00000018550.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 78033760,
      stop : 78056813,
      direction : "+",
      ID : "ENSG00000138326.21",
      gene_id : "ENSG00000138326.21",
      gene_type : "protein_coding",
      gene_name : "RPS24",
      gene_level : 2,
      hgnc_id : "HGNC:10411",
      havana_gene : "OTTHUMG00000018549.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79068966,
      stop : 79316519,
      direction : "+",
      ID : "ENSG00000108175.18",
      gene_id : "ENSG00000108175.18",
      gene_type : "protein_coding",
      gene_name : "ZMIZ1",
      gene_level : 2,
      hgnc_id : "HGNC:16493",
      havana_gene : "OTTHUMG00000018560.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79347469,
      stop : 79355334,
      direction : "+",
      ID : "ENSG00000108179.14",
      gene_id : "ENSG00000108179.14",
      gene_type : "protein_coding",
      gene_name : "PPIF",
      gene_level : 2,
      hgnc_id : "HGNC:9259",
      havana_gene : "OTTHUMG00000018562.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79382325,
      stop : 79445624,
      direction : "-",
      ID : "ENSG00000165424.7",
      gene_id : "ENSG00000165424.7",
      gene_type : "protein_coding",
      gene_name : "ZCCHC24",
      gene_level : 2,
      hgnc_id : "HGNC:26911",
      havana_gene : "OTTHUMG00000018561.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79512533,
      stop : 79516440,
      direction : "+",
      ID : "ENSG00000253626.4",
      gene_id : "ENSG00000253626.4",
      gene_type : "protein_coding",
      gene_name : "EIF5AL1",
      gene_level : 2,
      hgnc_id : "HGNC:17419",
      havana_gene : "OTTHUMG00000018563.5",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79555852,
      stop : 79560407,
      direction : "-",
      ID : "ENSG00000185303.17",
      gene_id : "ENSG00000185303.17",
      gene_type : "protein_coding",
      gene_name : "SFTPA2",
      gene_level : 2,
      hgnc_id : "HGNC:10799",
      havana_gene : "OTTHUMG00000018566.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79610939,
      stop : 79615455,
      direction : "+",
      ID : "ENSG00000122852.15",
      gene_id : "ENSG00000122852.15",
      gene_type : "protein_coding",
      gene_name : "SFTPA1",
      gene_level : 2,
      hgnc_id : "HGNC:10798",
      havana_gene : "OTTHUMG00000018565.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79703227,
      stop : 79714681,
      direction : "+",
      ID : "ENSG00000188199.10",
      gene_id : "ENSG00000188199.10",
      gene_type : "protein_coding",
      gene_name : "NUTM2B",
      gene_level : 2,
      hgnc_id : "HGNC:23445",
      havana_gene : "OTTHUMG00000018572.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79841358,
      stop : 79850878,
      direction : "+",
      ID : "ENSG00000228570.7",
      gene_id : "ENSG00000228570.7",
      gene_type : "protein_coding",
      gene_name : "NUTM2E",
      gene_level : 2,
      hgnc_id : "HGNC:23448",
      havana_gene : "OTTHUMG00000018586.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 79937467,
      stop : 79982614,
      direction : "-",
      ID : "ENSG00000133661.17",
      gene_id : "ENSG00000133661.17",
      gene_type : "protein_coding",
      gene_name : "SFTPD",
      gene_level : 2,
      hgnc_id : "HGNC:10803",
      havana_gene : "OTTHUMG00000018590.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80078646,
      stop : 80092557,
      direction : "+",
      ID : "ENSG00000133678.14",
      gene_id : "ENSG00000133678.14",
      gene_type : "protein_coding",
      gene_name : "TMEM254",
      gene_level : 2,
      hgnc_id : "HGNC:25804",
      havana_gene : "OTTHUMG00000018602.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80131682,
      stop : 80145359,
      direction : "+",
      ID : "ENSG00000189129.14",
      gene_id : "ENSG00000189129.14",
      gene_type : "protein_coding",
      gene_name : "PLAC9",
      gene_level : 2,
      hgnc_id : "HGNC:19255",
      havana_gene : "OTTHUMG00000018596.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80150889,
      stop : 80205572,
      direction : "-",
      ID : "ENSG00000122359.18",
      gene_id : "ENSG00000122359.18",
      gene_type : "protein_coding",
      gene_name : "ANXA11",
      gene_level : 2,
      hgnc_id : "HGNC:535",
      havana_gene : "OTTHUMG00000018604.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80271820,
      stop : 80289658,
      direction : "-",
      ID : "ENSG00000151224.13",
      gene_id : "ENSG00000151224.13",
      gene_type : "protein_coding",
      gene_name : "MAT1A",
      gene_level : 2,
      hgnc_id : "HGNC:6903",
      havana_gene : "OTTHUMG00000018613.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80336105,
      stop : 80356755,
      direction : "-",
      ID : "ENSG00000170788.14",
      gene_id : "ENSG00000170788.14",
      gene_type : "protein_coding",
      gene_name : "DYDC1",
      gene_level : 2,
      hgnc_id : "HGNC:23460",
      havana_gene : "OTTHUMG00000018609.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80344745,
      stop : 80368073,
      direction : "+",
      ID : "ENSG00000133665.13",
      gene_id : "ENSG00000133665.13",
      gene_type : "protein_coding",
      gene_name : "DYDC2",
      gene_level : 2,
      hgnc_id : "HGNC:23468",
      havana_gene : "OTTHUMG00000018610.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80407829,
      stop : 80437115,
      direction : "+",
      ID : "ENSG00000122378.14",
      gene_id : "ENSG00000122378.14",
      gene_type : "protein_coding",
      gene_name : "PRXL2A",
      gene_level : 2,
      hgnc_id : "HGNC:28651",
      havana_gene : "OTTHUMG00000018614.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80454166,
      stop : 80533124,
      direction : "+",
      ID : "ENSG00000108219.15",
      gene_id : "ENSG00000108219.15",
      gene_type : "protein_coding",
      gene_name : "TSPAN14",
      gene_level : 2,
      hgnc_id : "HGNC:23303",
      havana_gene : "OTTHUMG00000018615.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 80537902,
      stop : 80646560,
      direction : "+",
      ID : "ENSG00000178217.14",
      gene_id : "ENSG00000178217.14",
      gene_type : "protein_coding",
      gene_name : "SH2D4B",
      gene_level : 2,
      hgnc_id : "HGNC:31440",
      havana_gene : "OTTHUMG00000018617.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 81875194,
      stop : 82987179,
      direction : "+",
      ID : "ENSG00000185737.13",
      gene_id : "ENSG00000185737.13",
      gene_type : "protein_coding",
      gene_name : "NRG3",
      gene_level : 2,
      hgnc_id : "HGNC:7999",
      havana_gene : "OTTHUMG00000018626.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84139509,
      stop : 84153568,
      direction : "+",
      ID : "ENSG00000165678.21",
      gene_id : "ENSG00000165678.21",
      gene_type : "protein_coding",
      gene_name : "GHITM",
      gene_level : 2,
      hgnc_id : "HGNC:17281",
      havana_gene : "OTTHUMG00000018637.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84173801,
      stop : 84185294,
      direction : "+",
      ID : "ENSG00000188373.5",
      gene_id : "ENSG00000188373.5",
      gene_type : "protein_coding",
      gene_name : "C10orf99",
      gene_level : 2,
      hgnc_id : "HGNC:31428",
      havana_gene : "OTTHUMG00000018635.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84194537,
      stop : 84219621,
      direction : "+",
      ID : "ENSG00000148600.15",
      gene_id : "ENSG00000148600.15",
      gene_type : "protein_coding",
      gene_name : "CDHR1",
      gene_level : 2,
      hgnc_id : "HGNC:14550",
      havana_gene : "OTTHUMG00000018634.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84220571,
      stop : 84225544,
      direction : "-",
      ID : "ENSG00000204033.10",
      gene_id : "ENSG00000204033.10",
      gene_type : "protein_coding",
      gene_name : "LRIT2",
      gene_level : 2,
      hgnc_id : "HGNC:23443",
      havana_gene : "OTTHUMG00000018633.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84230666,
      stop : 84259960,
      direction : "+",
      ID : "ENSG00000148604.15",
      gene_id : "ENSG00000148604.15",
      gene_type : "protein_coding",
      gene_name : "RGR",
      gene_level : 2,
      hgnc_id : "HGNC:9990",
      havana_gene : "OTTHUMG00000018636.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84231520,
      stop : 84241546,
      direction : "-",
      ID : "ENSG00000148602.6",
      gene_id : "ENSG00000148602.6",
      gene_type : "protein_coding",
      gene_name : "LRIT1",
      gene_level : 2,
      hgnc_id : "HGNC:23404",
      havana_gene : "OTTHUMG00000018632.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 84328586,
      stop : 84518521,
      direction : "+",
      ID : "ENSG00000107771.17",
      gene_id : "ENSG00000107771.17",
      gene_type : "protein_coding",
      gene_name : "CCSER2",
      gene_level : 2,
      hgnc_id : "HGNC:29197",
      havana_gene : "OTTHUMG00000018641.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 85599552,
      stop : 86366795,
      direction : "-",
      ID : "ENSG00000182771.19",
      gene_id : "ENSG00000182771.19",
      gene_type : "protein_coding",
      gene_name : "GRID1",
      gene_level : 2,
      hgnc_id : "HGNC:4575",
      havana_gene : "OTTHUMG00000018650.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86435256,
      stop : 86521792,
      direction : "-",
      ID : "ENSG00000062650.20",
      gene_id : "ENSG00000062650.20",
      gene_type : "protein_coding",
      gene_name : "WAPL",
      gene_level : 2,
      hgnc_id : "HGNC:23293",
      havana_gene : "OTTHUMG00000018651.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86654547,
      stop : 86666848,
      direction : "+",
      ID : "ENSG00000122375.12",
      gene_id : "ENSG00000122375.12",
      gene_type : "protein_coding",
      gene_name : "OPN4",
      gene_level : 2,
      hgnc_id : "HGNC:14449",
      havana_gene : "OTTHUMG00000018654.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86668507,
      stop : 86736072,
      direction : "+",
      ID : "ENSG00000122367.20",
      gene_id : "ENSG00000122367.20",
      gene_type : "protein_coding",
      gene_name : "LDB3",
      gene_level : 2,
      hgnc_id : "HGNC:15710",
      havana_gene : "OTTHUMG00000018655.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86756601,
      stop : 86932825,
      direction : "+",
      ID : "ENSG00000107779.14",
      gene_id : "ENSG00000107779.14",
      gene_type : "protein_coding",
      gene_name : "BMPR1A",
      gene_level : 2,
      hgnc_id : "HGNC:1076",
      havana_gene : "OTTHUMG00000018657.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86935540,
      stop : 86969481,
      direction : "-",
      ID : "ENSG00000173269.14",
      gene_id : "ENSG00000173269.14",
      gene_type : "protein_coding",
      gene_name : "MMRN2",
      gene_level : 1,
      hgnc_id : "HGNC:19888",
      havana_gene : "OTTHUMG00000018663.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86958599,
      stop : 86963258,
      direction : "+",
      ID : "ENSG00000173267.14",
      gene_id : "ENSG00000173267.14",
      gene_type : "protein_coding",
      gene_name : "SNCG",
      gene_level : 2,
      hgnc_id : "HGNC:11141",
      havana_gene : "OTTHUMG00000018656.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 86968432,
      stop : 86983934,
      direction : "+",
      ID : "ENSG00000148671.14",
      gene_id : "ENSG00000148671.14",
      gene_type : "protein_coding",
      gene_name : "ADIRF",
      gene_level : 2,
      hgnc_id : "HGNC:24043",
      havana_gene : "OTTHUMG00000018668.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87020294,
      stop : 87024730,
      direction : "+",
      ID : "ENSG00000188100.9",
      gene_id : "ENSG00000188100.9",
      gene_type : "protein_coding",
      gene_name : "FAM25A",
      gene_level : 2,
      hgnc_id : "HGNC:23436",
      havana_gene : "OTTHUMG00000018664.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87050202,
      stop : 87094843,
      direction : "-",
      ID : "ENSG00000148672.9",
      gene_id : "ENSG00000148672.9",
      gene_type : "protein_coding",
      gene_name : "GLUD1",
      gene_level : 2,
      hgnc_id : "HGNC:4335",
      havana_gene : "OTTHUMG00000018666.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87094161,
      stop : 87191465,
      direction : "+",
      ID : "ENSG00000122376.12",
      gene_id : "ENSG00000122376.12",
      gene_type : "protein_coding",
      gene_name : "SHLD2",
      gene_level : 2,
      hgnc_id : "HGNC:28773",
      havana_gene : "OTTHUMG00000018669.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87225448,
      stop : 87236908,
      direction : "+",
      ID : "ENSG00000184923.12",
      gene_id : "ENSG00000184923.12",
      gene_type : "protein_coding",
      gene_name : "NUTM2A",
      gene_level : 2,
      hgnc_id : "HGNC:23438",
      havana_gene : "OTTHUMG00000018670.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87357720,
      stop : 87370695,
      direction : "+",
      ID : "ENSG00000214562.15",
      gene_id : "ENSG00000214562.15",
      gene_type : "protein_coding",
      gene_name : "NUTM2D",
      gene_level : 2,
      hgnc_id : "HGNC:23447",
      havana_gene : "OTTHUMG00000018672.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87504875,
      stop : 87553461,
      direction : "+",
      ID : "ENSG00000107789.16",
      gene_id : "ENSG00000107789.16",
      gene_type : "protein_coding",
      gene_name : "MINPP1",
      gene_level : 2,
      hgnc_id : "HGNC:7102",
      havana_gene : "OTTHUMG00000018678.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87659613,
      stop : 87747705,
      direction : "+",
      ID : "ENSG00000198682.13",
      gene_id : "ENSG00000198682.13",
      gene_type : "protein_coding",
      gene_name : "PAPSS2",
      gene_level : 2,
      hgnc_id : "HGNC:8604",
      havana_gene : "OTTHUMG00000018683.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87751512,
      stop : 87841361,
      direction : "-",
      ID : "ENSG00000138138.14",
      gene_id : "ENSG00000138138.14",
      gene_type : "protein_coding",
      gene_name : "ATAD1",
      gene_level : 2,
      hgnc_id : "HGNC:25903",
      havana_gene : "OTTHUMG00000018685.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87859158,
      stop : 87863533,
      direction : "-",
      ID : "ENSG00000227268.5",
      gene_id : "ENSG00000227268.5",
      gene_type : "protein_coding",
      gene_name : "KLLN",
      gene_level : 2,
      hgnc_id : "HGNC:37212",
      havana_gene : "OTTHUMG00000186455.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 87863625,
      stop : 87971930,
      direction : "+",
      ID : "ENSG00000171862.11",
      gene_id : "ENSG00000171862.11",
      gene_type : "protein_coding",
      gene_name : "PTEN",
      gene_level : 2,
      hgnc_id : "HGNC:9588",
      havana_gene : "OTTHUMG00000018688.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88273864,
      stop : 88584530,
      direction : "-",
      ID : "ENSG00000184719.12",
      gene_id : "ENSG00000184719.12",
      gene_type : "protein_coding",
      gene_name : "RNLS",
      gene_level : 2,
      hgnc_id : "HGNC:25641",
      havana_gene : "OTTHUMG00000018692.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88586753,
      stop : 88606976,
      direction : "+",
      ID : "ENSG00000204022.9",
      gene_id : "ENSG00000204022.9",
      gene_type : "protein_coding",
      gene_name : "LIPJ",
      gene_level : 2,
      hgnc_id : "HGNC:21773",
      havana_gene : "OTTHUMG00000018691.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88664441,
      stop : 88678814,
      direction : "+",
      ID : "ENSG00000182333.15",
      gene_id : "ENSG00000182333.15",
      gene_type : "protein_coding",
      gene_name : "LIPF",
      gene_level : 2,
      hgnc_id : "HGNC:6622",
      havana_gene : "OTTHUMG00000018695.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88724544,
      stop : 88752756,
      direction : "+",
      ID : "ENSG00000204021.4",
      gene_id : "ENSG00000204021.4",
      gene_type : "protein_coding",
      gene_name : "LIPK",
      gene_level : 2,
      hgnc_id : "HGNC:23444",
      havana_gene : "OTTHUMG00000018693.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88759982,
      stop : 88779626,
      direction : "+",
      ID : "ENSG00000204020.6",
      gene_id : "ENSG00000204020.6",
      gene_type : "protein_coding",
      gene_name : "LIPN",
      gene_level : 2,
      hgnc_id : "HGNC:23452",
      havana_gene : "OTTHUMG00000018694.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88802730,
      stop : 88820546,
      direction : "+",
      ID : "ENSG00000173239.14",
      gene_id : "ENSG00000173239.14",
      gene_type : "protein_coding",
      gene_name : "LIPM",
      gene_level : 2,
      hgnc_id : "HGNC:23455",
      havana_gene : "OTTHUMG00000018698.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88819896,
      stop : 88851844,
      direction : "-",
      ID : "ENSG00000152766.6",
      gene_id : "ENSG00000152766.6",
      gene_type : "protein_coding",
      gene_name : "ANKRD22",
      gene_level : 2,
      hgnc_id : "HGNC:28321",
      havana_gene : "OTTHUMG00000018699.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88879734,
      stop : 88975153,
      direction : "+",
      ID : "ENSG00000138134.12",
      gene_id : "ENSG00000138134.12",
      gene_type : "protein_coding",
      gene_name : "STAMBPL1",
      gene_level : 2,
      hgnc_id : "HGNC:24105",
      havana_gene : "OTTHUMG00000018702.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88935074,
      stop : 88991339,
      direction : "-",
      ID : "ENSG00000107796.13",
      gene_id : "ENSG00000107796.13",
      gene_type : "protein_coding",
      gene_name : "ACTA2",
      gene_level : 2,
      hgnc_id : "HGNC:130",
      havana_gene : "OTTHUMG00000018700.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 88990531,
      stop : 89017059,
      direction : "+",
      ID : "ENSG00000026103.22",
      gene_id : "ENSG00000026103.22",
      gene_type : "protein_coding",
      gene_name : "FAS",
      gene_level : 1,
      hgnc_id : "HGNC:11920",
      havana_gene : "OTTHUMG00000018701.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89205629,
      stop : 89207317,
      direction : "-",
      ID : "ENSG00000138135.7",
      gene_id : "ENSG00000138135.7",
      gene_type : "protein_coding",
      gene_name : "CH25H",
      gene_level : 2,
      hgnc_id : "HGNC:1907",
      havana_gene : "OTTHUMG00000018705.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89213569,
      stop : 89414557,
      direction : "-",
      ID : "ENSG00000107798.18",
      gene_id : "ENSG00000107798.18",
      gene_type : "protein_coding",
      gene_name : "LIPA",
      gene_level : 2,
      hgnc_id : "HGNC:6617",
      havana_gene : "OTTHUMG00000018716.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89283694,
      stop : 89309271,
      direction : "+",
      ID : "ENSG00000119922.11",
      gene_id : "ENSG00000119922.11",
      gene_type : "protein_coding",
      gene_name : "IFIT2",
      gene_level : 2,
      hgnc_id : "HGNC:5409",
      havana_gene : "OTTHUMG00000018707.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89327307,
      stop : 89377473,
      direction : "+",
      ID : "ENSG00000119917.15",
      gene_id : "ENSG00000119917.15",
      gene_type : "protein_coding",
      gene_name : "IFIT3",
      gene_level : 2,
      hgnc_id : "HGNC:5411",
      havana_gene : "OTTHUMG00000018708.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89378056,
      stop : 89385205,
      direction : "+",
      ID : "ENSG00000204010.3",
      gene_id : "ENSG00000204010.3",
      gene_type : "protein_coding",
      gene_name : "IFIT1B",
      gene_level : 2,
      hgnc_id : "HGNC:23442",
      havana_gene : "OTTHUMG00000018709.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89392546,
      stop : 89406487,
      direction : "+",
      ID : "ENSG00000185745.10",
      gene_id : "ENSG00000185745.10",
      gene_type : "protein_coding",
      gene_name : "IFIT1",
      gene_level : 2,
      hgnc_id : "HGNC:5407",
      havana_gene : "OTTHUMG00000018712.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89414568,
      stop : 89421605,
      direction : "+",
      ID : "ENSG00000152778.10",
      gene_id : "ENSG00000152778.10",
      gene_type : "protein_coding",
      gene_name : "IFIT5",
      gene_level : 2,
      hgnc_id : "HGNC:13328",
      havana_gene : "OTTHUMG00000018713.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89430299,
      stop : 89556641,
      direction : "-",
      ID : "ENSG00000152779.14",
      gene_id : "ENSG00000152779.14",
      gene_type : "protein_coding",
      gene_name : "SLC16A12",
      gene_level : 2,
      hgnc_id : "HGNC:23094",
      havana_gene : "OTTHUMG00000018714.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89579497,
      stop : 89645572,
      direction : "-",
      ID : "ENSG00000152782.16",
      gene_id : "ENSG00000152782.16",
      gene_type : "protein_coding",
      gene_name : "PANK1",
      gene_level : 2,
      hgnc_id : "HGNC:8598",
      havana_gene : "OTTHUMG00000018718.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 89701590,
      stop : 89774939,
      direction : "+",
      ID : "ENSG00000138182.15",
      gene_id : "ENSG00000138182.15",
      gene_type : "protein_coding",
      gene_name : "KIF20B",
      gene_level : 2,
      hgnc_id : "HGNC:7212",
      havana_gene : "OTTHUMG00000018725.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 90740823,
      stop : 90858039,
      direction : "-",
      ID : "ENSG00000148680.16",
      gene_id : "ENSG00000148680.16",
      gene_type : "protein_coding",
      gene_name : "HTR7",
      gene_level : 2,
      hgnc_id : "HGNC:5302",
      havana_gene : "OTTHUMG00000018732.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 90871952,
      stop : 90908553,
      direction : "+",
      ID : "ENSG00000148688.14",
      gene_id : "ENSG00000148688.14",
      gene_type : "protein_coding",
      gene_name : "RPP30",
      gene_level : 2,
      hgnc_id : "HGNC:17688",
      havana_gene : "OTTHUMG00000018733.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 90912096,
      stop : 90921087,
      direction : "-",
      ID : "ENSG00000148677.7",
      gene_id : "ENSG00000148677.7",
      gene_type : "protein_coding",
      gene_name : "ANKRD1",
      gene_level : 2,
      hgnc_id : "HGNC:15819",
      havana_gene : "OTTHUMG00000018734.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 91163012,
      stop : 91284337,
      direction : "+",
      ID : "ENSG00000180628.15",
      gene_id : "ENSG00000180628.15",
      gene_type : "protein_coding",
      gene_name : "PCGF5",
      gene_level : 2,
      hgnc_id : "HGNC:28264",
      havana_gene : "OTTHUMG00000018740.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 91409280,
      stop : 91514829,
      direction : "+",
      ID : "ENSG00000165338.17",
      gene_id : "ENSG00000165338.17",
      gene_type : "protein_coding",
      gene_name : "HECTD2",
      gene_level : 2,
      hgnc_id : "HGNC:26736",
      havana_gene : "OTTHUMG00000018742.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 91628442,
      stop : 91633071,
      direction : "-",
      ID : "ENSG00000119938.9",
      gene_id : "ENSG00000119938.9",
      gene_type : "protein_coding",
      gene_name : "PPP1R3C",
      gene_level : 2,
      hgnc_id : "HGNC:9293",
      havana_gene : "OTTHUMG00000018745.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 91798426,
      stop : 91865475,
      direction : "+",
      ID : "ENSG00000107854.6",
      gene_id : "ENSG00000107854.6",
      gene_type : "protein_coding",
      gene_name : "TNKS2",
      gene_level : 2,
      hgnc_id : "HGNC:15677",
      havana_gene : "OTTHUMG00000018747.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 91906584,
      stop : 91909486,
      direction : "-",
      ID : "ENSG00000174721.10",
      gene_id : "ENSG00000174721.10",
      gene_type : "protein_coding",
      gene_name : "FGFBP3",
      gene_level : 2,
      hgnc_id : "HGNC:23428",
      havana_gene : "OTTHUMG00000018751.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 91923770,
      stop : 92030325,
      direction : "+",
      ID : "ENSG00000095564.14",
      gene_id : "ENSG00000095564.14",
      gene_type : "protein_coding",
      gene_name : "BTAF1",
      gene_level : 2,
      hgnc_id : "HGNC:17307",
      havana_gene : "OTTHUMG00000018752.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 92046692,
      stop : 92291078,
      direction : "-",
      ID : "ENSG00000107864.15",
      gene_id : "ENSG00000107864.15",
      gene_type : "protein_coding",
      gene_name : "CPEB3",
      gene_level : 2,
      hgnc_id : "HGNC:21746",
      havana_gene : "OTTHUMG00000018756.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 92291167,
      stop : 92353964,
      direction : "+",
      ID : "ENSG00000198060.10",
      gene_id : "ENSG00000198060.10",
      gene_type : "protein_coding",
      gene_name : "MARCHF5",
      gene_level : 2,
      hgnc_id : "HGNC:26025",
      havana_gene : "OTTHUMG00000018757.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 92451684,
      stop : 92574096,
      direction : "-",
      ID : "ENSG00000119912.18",
      gene_id : "ENSG00000119912.18",
      gene_type : "protein_coding",
      gene_name : "IDE",
      gene_level : 2,
      hgnc_id : "HGNC:5381",
      havana_gene : "OTTHUMG00000018759.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 92574105,
      stop : 92655395,
      direction : "+",
      ID : "ENSG00000138160.7",
      gene_id : "ENSG00000138160.7",
      gene_type : "protein_coding",
      gene_name : "KIF11",
      gene_level : 2,
      hgnc_id : "HGNC:6388",
      havana_gene : "OTTHUMG00000018761.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 92689955,
      stop : 92695647,
      direction : "+",
      ID : "ENSG00000152804.11",
      gene_id : "ENSG00000152804.11",
      gene_type : "protein_coding",
      gene_name : "HHEX",
      gene_level : 1,
      hgnc_id : "HGNC:4901",
      havana_gene : "OTTHUMG00000018762.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 92826831,
      stop : 93059493,
      direction : "+",
      ID : "ENSG00000138190.17",
      gene_id : "ENSG00000138190.17",
      gene_type : "protein_coding",
      gene_name : "EXOC6",
      gene_level : 2,
      hgnc_id : "HGNC:23196",
      havana_gene : "OTTHUMG00000018767.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93060798,
      stop : 93069540,
      direction : "+",
      ID : "ENSG00000187553.10",
      gene_id : "ENSG00000187553.10",
      gene_type : "protein_coding",
      gene_name : "CYP26C1",
      gene_level : 2,
      hgnc_id : "HGNC:20577",
      havana_gene : "OTTHUMG00000018766.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93073475,
      stop : 93077885,
      direction : "+",
      ID : "ENSG00000095596.12",
      gene_id : "ENSG00000095596.12",
      gene_type : "protein_coding",
      gene_name : "CYP26A1",
      gene_level : 2,
      hgnc_id : "HGNC:2603",
      havana_gene : "OTTHUMG00000018765.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93306429,
      stop : 93482334,
      direction : "-",
      ID : "ENSG00000138119.17",
      gene_id : "ENSG00000138119.17",
      gene_type : "protein_coding",
      gene_name : "MYOF",
      gene_level : 2,
      hgnc_id : "HGNC:3656",
      havana_gene : "OTTHUMG00000018772.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93496612,
      stop : 93529092,
      direction : "+",
      ID : "ENSG00000138180.16",
      gene_id : "ENSG00000138180.16",
      gene_type : "protein_coding",
      gene_name : "CEP55",
      gene_level : 2,
      hgnc_id : "HGNC:1161",
      havana_gene : "OTTHUMG00000018774.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93566665,
      stop : 93604480,
      direction : "+",
      ID : "ENSG00000186188.11",
      gene_id : "ENSG00000186188.11",
      gene_type : "protein_coding",
      gene_name : "FFAR4",
      gene_level : 2,
      hgnc_id : "HGNC:19061",
      havana_gene : "OTTHUMG00000034409.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93591687,
      stop : 93601744,
      direction : "-",
      ID : "ENSG00000138207.14",
      gene_id : "ENSG00000138207.14",
      gene_type : "protein_coding",
      gene_name : "RBP4",
      gene_level : 2,
      hgnc_id : "HGNC:9922",
      havana_gene : "OTTHUMG00000018773.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93612537,
      stop : 93666010,
      direction : "+",
      ID : "ENSG00000095464.10",
      gene_id : "ENSG00000095464.10",
      gene_type : "protein_coding",
      gene_name : "PDE6C",
      gene_level : 2,
      hgnc_id : "HGNC:8787",
      havana_gene : "OTTHUMG00000018775.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93667883,
      stop : 93702592,
      direction : "-",
      ID : "ENSG00000148690.12",
      gene_id : "ENSG00000148690.12",
      gene_type : "protein_coding",
      gene_name : "FRA10AC1",
      gene_level : 2,
      hgnc_id : "HGNC:1162",
      havana_gene : "OTTHUMG00000018776.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93757840,
      stop : 93806272,
      direction : "+",
      ID : "ENSG00000108231.14",
      gene_id : "ENSG00000108231.14",
      gene_type : "protein_coding",
      gene_name : "LGI1",
      gene_level : 2,
      hgnc_id : "HGNC:6572",
      havana_gene : "OTTHUMG00000018777.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93893973,
      stop : 93956062,
      direction : "+",
      ID : "ENSG00000176273.15",
      gene_id : "ENSG00000176273.15",
      gene_type : "protein_coding",
      gene_name : "SLC35G1",
      gene_level : 2,
      hgnc_id : "HGNC:26607",
      havana_gene : "OTTHUMG00000018779.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 93993931,
      stop : 94332823,
      direction : "+",
      ID : "ENSG00000138193.16",
      gene_id : "ENSG00000138193.16",
      gene_type : "protein_coding",
      gene_name : "PLCE1",
      gene_level : 2,
      hgnc_id : "HGNC:17175",
      havana_gene : "OTTHUMG00000018789.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94333226,
      stop : 94362959,
      direction : "-",
      ID : "ENSG00000173145.11",
      gene_id : "ENSG00000173145.11",
      gene_type : "protein_coding",
      gene_name : "NOC3L",
      gene_level : 2,
      hgnc_id : "HGNC:24034",
      havana_gene : "OTTHUMG00000018788.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94402541,
      stop : 94536332,
      direction : "+",
      ID : "ENSG00000108239.9",
      gene_id : "ENSG00000108239.9",
      gene_type : "protein_coding",
      gene_name : "TBC1D12",
      gene_level : 2,
      hgnc_id : "HGNC:29082",
      havana_gene : "OTTHUMG00000018794.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94501434,
      stop : 94613905,
      direction : "+",
      ID : "ENSG00000119969.15",
      gene_id : "ENSG00000119969.15",
      gene_type : "protein_coding",
      gene_name : "HELLS",
      gene_level : 1,
      hgnc_id : "HGNC:4861",
      havana_gene : "OTTHUMG00000018793.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94683729,
      stop : 94736190,
      direction : "+",
      ID : "ENSG00000108242.13",
      gene_id : "ENSG00000108242.13",
      gene_type : "protein_coding",
      gene_name : "CYP2C18",
      gene_level : 2,
      hgnc_id : "HGNC:2620",
      havana_gene : "OTTHUMG00000018796.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94688154,
      stop : 94853073,
      direction : "+",
      ID : "ENSG00000276490.1",
      gene_id : "ENSG00000276490.1",
      gene_type : "protein_coding",
      gene_name : "AL583836.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000188303.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94762681,
      stop : 94855547,
      direction : "+",
      ID : "ENSG00000165841.11",
      gene_id : "ENSG00000165841.11",
      gene_type : "protein_coding",
      gene_name : "CYP2C19",
      gene_level : 2,
      hgnc_id : "HGNC:2621",
      havana_gene : "OTTHUMG00000018799.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 94938658,
      stop : 94990091,
      direction : "+",
      ID : "ENSG00000138109.11",
      gene_id : "ENSG00000138109.11",
      gene_type : "protein_coding",
      gene_name : "CYP2C9",
      gene_level : 2,
      hgnc_id : "HGNC:2623",
      havana_gene : "OTTHUMG00000018805.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95036772,
      stop : 95069497,
      direction : "-",
      ID : "ENSG00000138115.15",
      gene_id : "ENSG00000138115.15",
      gene_type : "protein_coding",
      gene_name : "CYP2C8",
      gene_level : 2,
      hgnc_id : "HGNC:2622",
      havana_gene : "OTTHUMG00000018804.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95194200,
      stop : 95228928,
      direction : "+",
      ID : "ENSG00000173124.14",
      gene_id : "ENSG00000173124.14",
      gene_type : "protein_coding",
      gene_name : "ACSM6",
      gene_level : 2,
      hgnc_id : "HGNC:31665",
      havana_gene : "OTTHUMG00000018808.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95237572,
      stop : 95291012,
      direction : "-",
      ID : "ENSG00000107438.9",
      gene_id : "ENSG00000107438.9",
      gene_type : "protein_coding",
      gene_name : "PDLIM1",
      gene_level : 2,
      hgnc_id : "HGNC:2067",
      havana_gene : "OTTHUMG00000018810.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95311771,
      stop : 95561414,
      direction : "-",
      ID : "ENSG00000095637.22",
      gene_id : "ENSG00000095637.22",
      gene_type : "protein_coding",
      gene_name : "SORBS1",
      gene_level : 2,
      hgnc_id : "HGNC:14565",
      havana_gene : "OTTHUMG00000018812.10",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95605941,
      stop : 95656711,
      direction : "-",
      ID : "ENSG00000059573.9",
      gene_id : "ENSG00000059573.9",
      gene_type : "protein_coding",
      gene_name : "ALDH18A1",
      gene_level : 2,
      hgnc_id : "HGNC:9722",
      havana_gene : "OTTHUMG00000018815.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95659823,
      stop : 95694143,
      direction : "-",
      ID : "ENSG00000119977.22",
      gene_id : "ENSG00000119977.22",
      gene_type : "protein_coding",
      gene_name : "TCTN3",
      gene_level : 2,
      hgnc_id : "HGNC:24519",
      havana_gene : "OTTHUMG00000018814.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95711779,
      stop : 95877266,
      direction : "+",
      ID : "ENSG00000138185.20",
      gene_id : "ENSG00000138185.20",
      gene_type : "protein_coding",
      gene_name : "ENTPD1",
      gene_level : 2,
      hgnc_id : "HGNC:3363",
      havana_gene : "OTTHUMG00000018818.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95860548,
      stop : 95924844,
      direction : "+",
      ID : "ENSG00000270099.1",
      gene_id : "ENSG00000270099.1",
      gene_type : "protein_coding",
      gene_name : "AL365273.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000184157.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 95907603,
      stop : 96033745,
      direction : "+",
      ID : "ENSG00000188649.15",
      gene_id : "ENSG00000188649.15",
      gene_type : "protein_coding",
      gene_name : "CC2D2B",
      gene_level : 1,
      hgnc_id : "HGNC:31666",
      havana_gene : "OTTHUMG00000191767.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96043394,
      stop : 96060870,
      direction : "+",
      ID : "ENSG00000107443.16",
      gene_id : "ENSG00000107443.16",
      gene_type : "protein_coding",
      gene_name : "CCNJ",
      gene_level : 2,
      hgnc_id : "HGNC:23434",
      havana_gene : "OTTHUMG00000018823.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96129715,
      stop : 96205288,
      direction : "+",
      ID : "ENSG00000177853.14",
      gene_id : "ENSG00000177853.14",
      gene_type : "protein_coding",
      gene_name : "ZNF518A",
      gene_level : 2,
      hgnc_id : "HGNC:29009",
      havana_gene : "OTTHUMG00000018828.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96189171,
      stop : 96271587,
      direction : "-",
      ID : "ENSG00000095585.17",
      gene_id : "ENSG00000095585.17",
      gene_type : "protein_coding",
      gene_name : "BLNK",
      gene_level : 2,
      hgnc_id : "HGNC:14211",
      havana_gene : "OTTHUMG00000018827.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96304409,
      stop : 96338564,
      direction : "+",
      ID : "ENSG00000107447.8",
      gene_id : "ENSG00000107447.8",
      gene_type : "protein_coding",
      gene_name : "DNTT",
      gene_level : 2,
      hgnc_id : "HGNC:2983",
      havana_gene : "OTTHUMG00000018832.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96343221,
      stop : 96359365,
      direction : "-",
      ID : "ENSG00000197430.11",
      gene_id : "ENSG00000197430.11",
      gene_type : "protein_coding",
      gene_name : "OPALIN",
      gene_level : 2,
      hgnc_id : "HGNC:20707",
      havana_gene : "OTTHUMG00000018831.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96364608,
      stop : 96513926,
      direction : "-",
      ID : "ENSG00000095587.9",
      gene_id : "ENSG00000095587.9",
      gene_type : "protein_coding",
      gene_name : "TLL2",
      gene_level : 2,
      hgnc_id : "HGNC:11844",
      havana_gene : "OTTHUMG00000018833.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96518110,
      stop : 96587452,
      direction : "-",
      ID : "ENSG00000077147.16",
      gene_id : "ENSG00000077147.16",
      gene_type : "protein_coding",
      gene_name : "TM9SF3",
      gene_level : 2,
      hgnc_id : "HGNC:21529",
      havana_gene : "OTTHUMG00000018834.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96593315,
      stop : 96720514,
      direction : "-",
      ID : "ENSG00000155629.15",
      gene_id : "ENSG00000155629.15",
      gene_type : "protein_coding",
      gene_name : "PIK3AP1",
      gene_level : 2,
      hgnc_id : "HGNC:30034",
      havana_gene : "OTTHUMG00000018838.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96832254,
      stop : 96995956,
      direction : "+",
      ID : "ENSG00000196233.14",
      gene_id : "ENSG00000196233.14",
      gene_type : "protein_coding",
      gene_name : "LCOR",
      gene_level : 2,
      hgnc_id : "HGNC:29503",
      havana_gene : "OTTHUMG00000018841.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 96998038,
      stop : 97185959,
      direction : "-",
      ID : "ENSG00000187122.17",
      gene_id : "ENSG00000187122.17",
      gene_type : "protein_coding",
      gene_name : "SLIT1",
      gene_level : 2,
      hgnc_id : "HGNC:11085",
      havana_gene : "OTTHUMG00000018843.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97153045,
      stop : 97292637,
      direction : "-",
      ID : "ENSG00000269891.2",
      gene_id : "ENSG00000269891.2",
      gene_type : "protein_coding",
      gene_name : "ARHGAP19-SLIT1",
      gene_level : 2,
      hgnc_id : "HGNC:48348",
      havana_gene : "OTTHUMG00000184018.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97222173,
      stop : 97292673,
      direction : "-",
      ID : "ENSG00000213390.11",
      gene_id : "ENSG00000213390.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP19",
      gene_level : 2,
      hgnc_id : "HGNC:23724",
      havana_gene : "OTTHUMG00000018845.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97319271,
      stop : 97321915,
      direction : "+",
      ID : "ENSG00000165879.9",
      gene_id : "ENSG00000165879.9",
      gene_type : "protein_coding",
      gene_name : "FRAT1",
      gene_level : 2,
      hgnc_id : "HGNC:3944",
      havana_gene : "OTTHUMG00000018848.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97332497,
      stop : 97334729,
      direction : "-",
      ID : "ENSG00000181274.7",
      gene_id : "ENSG00000181274.7",
      gene_type : "protein_coding",
      gene_name : "FRAT2",
      gene_level : 2,
      hgnc_id : "HGNC:16048",
      havana_gene : "OTTHUMG00000018850.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97356358,
      stop : 97426076,
      direction : "-",
      ID : "ENSG00000052749.14",
      gene_id : "ENSG00000052749.14",
      gene_type : "protein_coding",
      gene_name : "RRP12",
      gene_level : 2,
      hgnc_id : "HGNC:29100",
      havana_gene : "OTTHUMG00000018855.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97426191,
      stop : 97433444,
      direction : "+",
      ID : "ENSG00000171314.9",
      gene_id : "ENSG00000171314.9",
      gene_type : "protein_coding",
      gene_name : "PGAM1",
      gene_level : 2,
      hgnc_id : "HGNC:8888",
      havana_gene : "OTTHUMG00000018846.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97435909,
      stop : 97446017,
      direction : "-",
      ID : "ENSG00000171311.13",
      gene_id : "ENSG00000171311.13",
      gene_type : "protein_coding",
      gene_name : "EXOSC1",
      gene_level : 2,
      hgnc_id : "HGNC:17286",
      havana_gene : "OTTHUMG00000018854.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97446170,
      stop : 97457370,
      direction : "+",
      ID : "ENSG00000171307.19",
      gene_id : "ENSG00000171307.19",
      gene_type : "protein_coding",
      gene_name : "ZDHHC16",
      gene_level : 2,
      hgnc_id : "HGNC:20714",
      havana_gene : "OTTHUMG00000018847.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97458324,
      stop : 97498794,
      direction : "-",
      ID : "ENSG00000155229.21",
      gene_id : "ENSG00000155229.21",
      gene_type : "protein_coding",
      gene_name : "MMS19",
      gene_level : 2,
      hgnc_id : "HGNC:13824",
      havana_gene : "OTTHUMG00000018857.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97498924,
      stop : 97571206,
      direction : "+",
      ID : "ENSG00000165886.5",
      gene_id : "ENSG00000165886.5",
      gene_type : "protein_coding",
      gene_name : "UBTD1",
      gene_level : 2,
      hgnc_id : "HGNC:25683",
      havana_gene : "OTTHUMG00000018856.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97572499,
      stop : 97583884,
      direction : "+",
      ID : "ENSG00000165887.12",
      gene_id : "ENSG00000165887.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD2",
      gene_level : 2,
      hgnc_id : "HGNC:495",
      havana_gene : "OTTHUMG00000018860.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97584323,
      stop : 97612802,
      direction : "+",
      ID : "ENSG00000241935.9",
      gene_id : "ENSG00000241935.9",
      gene_type : "protein_coding",
      gene_name : "HOGA1",
      gene_level : 2,
      hgnc_id : "HGNC:25155",
      havana_gene : "OTTHUMG00000018859.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97584374,
      stop : 97673910,
      direction : "+",
      ID : "ENSG00000249967.1",
      gene_id : "ENSG00000249967.1",
      gene_type : "protein_coding",
      gene_name : "AL355315.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162272.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97589721,
      stop : 97590934,
      direction : "+",
      ID : "ENSG00000203942.5",
      gene_id : "ENSG00000203942.5",
      gene_type : "protein_coding",
      gene_name : "C10orf62",
      gene_level : 2,
      hgnc_id : "HGNC:23294",
      havana_gene : "OTTHUMG00000018858.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97614553,
      stop : 97633500,
      direction : "-",
      ID : "ENSG00000171160.18",
      gene_id : "ENSG00000171160.18",
      gene_type : "protein_coding",
      gene_name : "MORN4",
      gene_level : 1,
      hgnc_id : "HGNC:24001",
      havana_gene : "OTTHUMG00000018861.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97640686,
      stop : 97676434,
      direction : "+",
      ID : "ENSG00000155252.13",
      gene_id : "ENSG00000155252.13",
      gene_type : "protein_coding",
      gene_name : "PI4K2A",
      gene_level : 2,
      hgnc_id : "HGNC:30031",
      havana_gene : "OTTHUMG00000018863.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97677424,
      stop : 97687241,
      direction : "-",
      ID : "ENSG00000119986.7",
      gene_id : "ENSG00000119986.7",
      gene_type : "protein_coding",
      gene_name : "AVPI1",
      gene_level : 2,
      hgnc_id : "HGNC:30898",
      havana_gene : "OTTHUMG00000018864.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97713173,
      stop : 97718150,
      direction : "+",
      ID : "ENSG00000155254.13",
      gene_id : "ENSG00000155254.13",
      gene_type : "protein_coding",
      gene_name : "MARVELD1",
      gene_level : 2,
      hgnc_id : "HGNC:28674",
      havana_gene : "OTTHUMG00000018865.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97737121,
      stop : 97760907,
      direction : "+",
      ID : "ENSG00000155256.17",
      gene_id : "ENSG00000155256.17",
      gene_type : "protein_coding",
      gene_name : "ZFYVE27",
      gene_level : 2,
      hgnc_id : "HGNC:26559",
      havana_gene : "OTTHUMG00000018867.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97766751,
      stop : 97771999,
      direction : "-",
      ID : "ENSG00000120057.5",
      gene_id : "ENSG00000120057.5",
      gene_type : "protein_coding",
      gene_name : "SFRP5",
      gene_level : 2,
      hgnc_id : "HGNC:10779",
      havana_gene : "OTTHUMG00000018866.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97849843,
      stop : 97871580,
      direction : "+",
      ID : "ENSG00000155265.11",
      gene_id : "ENSG00000155265.11",
      gene_type : "protein_coding",
      gene_name : "GOLGA7B",
      gene_level : 2,
      hgnc_id : "HGNC:31668",
      havana_gene : "OTTHUMG00000018869.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 97865000,
      stop : 98030828,
      direction : "-",
      ID : "ENSG00000095713.14",
      gene_id : "ENSG00000095713.14",
      gene_type : "protein_coding",
      gene_name : "CRTAC1",
      gene_level : 1,
      hgnc_id : "HGNC:14882",
      havana_gene : "OTTHUMG00000018871.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 98134624,
      stop : 98244897,
      direction : "+",
      ID : "ENSG00000166024.14",
      gene_id : "ENSG00000166024.14",
      gene_type : "protein_coding",
      gene_name : "R3HCC1L",
      gene_level : 2,
      hgnc_id : "HGNC:23512",
      havana_gene : "OTTHUMG00000018873.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 98247690,
      stop : 98268194,
      direction : "-",
      ID : "ENSG00000138131.4",
      gene_id : "ENSG00000138131.4",
      gene_type : "protein_coding",
      gene_name : "LOXL4",
      gene_level : 2,
      hgnc_id : "HGNC:17171",
      havana_gene : "OTTHUMG00000018874.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 98383565,
      stop : 98415182,
      direction : "-",
      ID : "ENSG00000119943.13",
      gene_id : "ENSG00000119943.13",
      gene_type : "protein_coding",
      gene_name : "PYROXD2",
      gene_level : 2,
      hgnc_id : "HGNC:23517",
      havana_gene : "OTTHUMG00000018877.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 98416198,
      stop : 98446935,
      direction : "-",
      ID : "ENSG00000107521.20",
      gene_id : "ENSG00000107521.20",
      gene_type : "protein_coding",
      gene_name : "HPS1",
      gene_level : 2,
      hgnc_id : "HGNC:5163",
      havana_gene : "OTTHUMG00000018876.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 98457077,
      stop : 99235862,
      direction : "-",
      ID : "ENSG00000172987.13",
      gene_id : "ENSG00000172987.13",
      gene_type : "protein_coding",
      gene_name : "HPSE2",
      gene_level : 2,
      hgnc_id : "HGNC:18374",
      havana_gene : "OTTHUMG00000018880.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99329356,
      stop : 99394330,
      direction : "+",
      ID : "ENSG00000119946.11",
      gene_id : "ENSG00000119946.11",
      gene_type : "protein_coding",
      gene_name : "CNNM1",
      gene_level : 2,
      hgnc_id : "HGNC:102",
      havana_gene : "OTTHUMG00000018881.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99396870,
      stop : 99430624,
      direction : "-",
      ID : "ENSG00000120053.12",
      gene_id : "ENSG00000120053.12",
      gene_type : "protein_coding",
      gene_name : "GOT1",
      gene_level : 2,
      hgnc_id : "HGNC:4432",
      havana_gene : "OTTHUMG00000018882.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99532942,
      stop : 99536524,
      direction : "+",
      ID : "ENSG00000119919.11",
      gene_id : "ENSG00000119919.11",
      gene_type : "protein_coding",
      gene_name : "NKX2-3",
      gene_level : 2,
      hgnc_id : "HGNC:7836",
      havana_gene : "OTTHUMG00000018887.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99610522,
      stop : 99620609,
      direction : "-",
      ID : "ENSG00000155287.11",
      gene_id : "ENSG00000155287.11",
      gene_type : "protein_coding",
      gene_name : "SLC25A28",
      gene_level : 2,
      hgnc_id : "HGNC:23472",
      havana_gene : "OTTHUMG00000018886.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99651595,
      stop : 99732112,
      direction : "-",
      ID : "ENSG00000285932.1",
      gene_id : "ENSG00000285932.1",
      gene_type : "protein_coding",
      gene_name : "AL133353.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193345.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99659509,
      stop : 99711241,
      direction : "+",
      ID : "ENSG00000198018.7",
      gene_id : "ENSG00000198018.7",
      gene_type : "protein_coding",
      gene_name : "ENTPD7",
      gene_level : 2,
      hgnc_id : "HGNC:19745",
      havana_gene : "OTTHUMG00000018888.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99702558,
      stop : 99756134,
      direction : "+",
      ID : "ENSG00000119929.13",
      gene_id : "ENSG00000119929.13",
      gene_type : "protein_coding",
      gene_name : "CUTC",
      gene_level : 2,
      hgnc_id : "HGNC:24271",
      havana_gene : "OTTHUMG00000018889.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99710868,
      stop : 99732127,
      direction : "-",
      ID : "ENSG00000014919.13",
      gene_id : "ENSG00000014919.13",
      gene_type : "protein_coding",
      gene_name : "COX15",
      gene_level : 2,
      hgnc_id : "HGNC:2263",
      havana_gene : "OTTHUMG00000018893.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99782640,
      stop : 99852594,
      direction : "+",
      ID : "ENSG00000023839.12",
      gene_id : "ENSG00000023839.12",
      gene_type : "protein_coding",
      gene_name : "ABCC2",
      gene_level : 2,
      hgnc_id : "HGNC:53",
      havana_gene : "OTTHUMG00000018895.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 99875577,
      stop : 100009947,
      direction : "-",
      ID : "ENSG00000107554.17",
      gene_id : "ENSG00000107554.17",
      gene_type : "protein_coding",
      gene_name : "DNMBP",
      gene_level : 2,
      hgnc_id : "HGNC:30373",
      havana_gene : "OTTHUMG00000018897.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100042193,
      stop : 100081869,
      direction : "-",
      ID : "ENSG00000120054.12",
      gene_id : "ENSG00000120054.12",
      gene_type : "protein_coding",
      gene_name : "CPN1",
      gene_level : 2,
      hgnc_id : "HGNC:2312",
      havana_gene : "OTTHUMG00000018896.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100150094,
      stop : 100186033,
      direction : "-",
      ID : "ENSG00000107566.14",
      gene_id : "ENSG00000107566.14",
      gene_type : "protein_coding",
      gene_name : "ERLIN1",
      gene_level : 2,
      hgnc_id : "HGNC:16947",
      havana_gene : "OTTHUMG00000018900.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100188300,
      stop : 100229596,
      direction : "-",
      ID : "ENSG00000213341.11",
      gene_id : "ENSG00000213341.11",
      gene_type : "protein_coding",
      gene_name : "CHUK",
      gene_level : 2,
      hgnc_id : "HGNC:1974",
      havana_gene : "OTTHUMG00000018899.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100232298,
      stop : 100267680,
      direction : "-",
      ID : "ENSG00000095485.18",
      gene_id : "ENSG00000095485.18",
      gene_type : "protein_coding",
      gene_name : "CWF19L1",
      gene_level : 2,
      hgnc_id : "HGNC:25613",
      havana_gene : "OTTHUMG00000018901.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100273280,
      stop : 100286680,
      direction : "-",
      ID : "ENSG00000196072.12",
      gene_id : "ENSG00000196072.12",
      gene_type : "protein_coding",
      gene_name : "BLOC1S2",
      gene_level : 2,
      hgnc_id : "HGNC:20984",
      havana_gene : "OTTHUMG00000018908.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100288149,
      stop : 100330264,
      direction : "-",
      ID : "ENSG00000107593.17",
      gene_id : "ENSG00000107593.17",
      gene_type : "protein_coding",
      gene_name : "PKD2L1",
      gene_level : 2,
      hgnc_id : "HGNC:9011",
      havana_gene : "OTTHUMG00000018910.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100347233,
      stop : 100364826,
      direction : "+",
      ID : "ENSG00000099194.6",
      gene_id : "ENSG00000099194.6",
      gene_type : "protein_coding",
      gene_name : "SCD",
      gene_level : 2,
      hgnc_id : "HGNC:10571",
      havana_gene : "OTTHUMG00000018906.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100463009,
      stop : 100483744,
      direction : "+",
      ID : "ENSG00000075290.8",
      gene_id : "ENSG00000075290.8",
      gene_type : "protein_coding",
      gene_name : "WNT8B",
      gene_level : 2,
      hgnc_id : "HGNC:12789",
      havana_gene : "OTTHUMG00000018912.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100486646,
      stop : 100519864,
      direction : "-",
      ID : "ENSG00000075826.17",
      gene_id : "ENSG00000075826.17",
      gene_type : "protein_coding",
      gene_name : "SEC31B",
      gene_level : 2,
      hgnc_id : "HGNC:23197",
      havana_gene : "OTTHUMG00000019342.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100505628,
      stop : 100529881,
      direction : "-",
      ID : "ENSG00000255339.6",
      gene_id : "ENSG00000255339.6",
      gene_type : "protein_coding",
      gene_name : "AL133352.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000166603.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100523740,
      stop : 100530000,
      direction : "-",
      ID : "ENSG00000166136.16",
      gene_id : "ENSG00000166136.16",
      gene_type : "protein_coding",
      gene_name : "NDUFB8",
      gene_level : 2,
      hgnc_id : "HGNC:7703",
      havana_gene : "OTTHUMG00000019346.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100529072,
      stop : 100559998,
      direction : "+",
      ID : "ENSG00000166135.14",
      gene_id : "ENSG00000166135.14",
      gene_type : "protein_coding",
      gene_name : "HIF1AN",
      gene_level : 2,
      hgnc_id : "HGNC:17113",
      havana_gene : "OTTHUMG00000018911.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100735396,
      stop : 100829944,
      direction : "+",
      ID : "ENSG00000075891.23",
      gene_id : "ENSG00000075891.23",
      gene_type : "protein_coding",
      gene_name : "PAX2",
      gene_level : 2,
      hgnc_id : "HGNC:8616",
      havana_gene : "OTTHUMG00000018913.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100912963,
      stop : 100965134,
      direction : "+",
      ID : "ENSG00000119906.13",
      gene_id : "ENSG00000119906.13",
      gene_type : "protein_coding",
      gene_name : "SLF2",
      gene_level : 2,
      hgnc_id : "HGNC:17814",
      havana_gene : "OTTHUMG00000018919.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100969458,
      stop : 100987515,
      direction : "-",
      ID : "ENSG00000055950.16",
      gene_id : "ENSG00000055950.16",
      gene_type : "protein_coding",
      gene_name : "MRPL43",
      gene_level : 1,
      hgnc_id : "HGNC:14517",
      havana_gene : "OTTHUMG00000018920.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100969518,
      stop : 100985871,
      direction : "+",
      ID : "ENSG00000095539.15",
      gene_id : "ENSG00000095539.15",
      gene_type : "protein_coding",
      gene_name : "SEMA4G",
      gene_level : 2,
      hgnc_id : "HGNC:10735",
      havana_gene : "OTTHUMG00000018922.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100987367,
      stop : 100994403,
      direction : "+",
      ID : "ENSG00000107815.10",
      gene_id : "ENSG00000107815.10",
      gene_type : "protein_coding",
      gene_name : "TWNK",
      gene_level : 2,
      hgnc_id : "HGNC:1160",
      havana_gene : "OTTHUMG00000018917.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 100996618,
      stop : 101007836,
      direction : "+",
      ID : "ENSG00000107816.17",
      gene_id : "ENSG00000107816.17",
      gene_type : "protein_coding",
      gene_name : "LZTS2",
      gene_level : 2,
      hgnc_id : "HGNC:29381",
      havana_gene : "OTTHUMG00000018914.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101007679,
      stop : 101032295,
      direction : "-",
      ID : "ENSG00000186862.20",
      gene_id : "ENSG00000186862.20",
      gene_type : "protein_coding",
      gene_name : "PDZD7",
      gene_level : 2,
      hgnc_id : "HGNC:26257",
      havana_gene : "OTTHUMG00000018916.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101031234,
      stop : 101041244,
      direction : "+",
      ID : "ENSG00000107819.13",
      gene_id : "ENSG00000107819.13",
      gene_type : "protein_coding",
      gene_name : "SFXN3",
      gene_level : 2,
      hgnc_id : "HGNC:16087",
      havana_gene : "OTTHUMG00000018921.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101061989,
      stop : 101068131,
      direction : "+",
      ID : "ENSG00000107821.15",
      gene_id : "ENSG00000107821.15",
      gene_type : "protein_coding",
      gene_name : "KAZALD1",
      gene_level : 2,
      hgnc_id : "HGNC:25460",
      havana_gene : "OTTHUMG00000018918.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101131300,
      stop : 101137789,
      direction : "+",
      ID : "ENSG00000107807.13",
      gene_id : "ENSG00000107807.13",
      gene_type : "protein_coding",
      gene_name : "TLX1",
      gene_level : 1,
      hgnc_id : "HGNC:5056",
      havana_gene : "OTTHUMG00000019341.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101226195,
      stop : 101229794,
      direction : "-",
      ID : "ENSG00000138136.6",
      gene_id : "ENSG00000138136.6",
      gene_type : "protein_coding",
      gene_name : "LBX1",
      gene_level : 2,
      hgnc_id : "HGNC:16960",
      havana_gene : "OTTHUMG00000018927.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101354033,
      stop : 101557321,
      direction : "+",
      ID : "ENSG00000166167.18",
      gene_id : "ENSG00000166167.18",
      gene_type : "protein_coding",
      gene_name : "BTRC",
      gene_level : 2,
      hgnc_id : "HGNC:1144",
      havana_gene : "OTTHUMG00000018932.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101570560,
      stop : 101609662,
      direction : "+",
      ID : "ENSG00000166171.13",
      gene_id : "ENSG00000166171.13",
      gene_type : "protein_coding",
      gene_name : "DPCD",
      gene_level : 2,
      hgnc_id : "HGNC:24542",
      havana_gene : "OTTHUMG00000018934.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101578882,
      stop : 101588270,
      direction : "-",
      ID : "ENSG00000166169.17",
      gene_id : "ENSG00000166169.17",
      gene_type : "protein_coding",
      gene_name : "POLL",
      gene_level : 2,
      hgnc_id : "HGNC:9184",
      havana_gene : "OTTHUMG00000018933.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101610664,
      stop : 101695295,
      direction : "-",
      ID : "ENSG00000107829.15",
      gene_id : "ENSG00000107829.15",
      gene_type : "protein_coding",
      gene_name : "FBXW4",
      gene_level : 2,
      hgnc_id : "HGNC:10847",
      havana_gene : "OTTHUMG00000018938.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101770130,
      stop : 101780369,
      direction : "-",
      ID : "ENSG00000107831.13",
      gene_id : "ENSG00000107831.13",
      gene_type : "protein_coding",
      gene_name : "FGF8",
      gene_level : 2,
      hgnc_id : "HGNC:3686",
      havana_gene : "OTTHUMG00000018940.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101781325,
      stop : 101783413,
      direction : "-",
      ID : "ENSG00000107833.10",
      gene_id : "ENSG00000107833.10",
      gene_type : "protein_coding",
      gene_name : "NPM3",
      gene_level : 2,
      hgnc_id : "HGNC:7931",
      havana_gene : "OTTHUMG00000018942.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101784443,
      stop : 101818465,
      direction : "-",
      ID : "ENSG00000198408.14",
      gene_id : "ENSG00000198408.14",
      gene_type : "protein_coding",
      gene_name : "OGA",
      gene_level : 2,
      hgnc_id : "HGNC:7056",
      havana_gene : "OTTHUMG00000018939.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101825974,
      stop : 101843920,
      direction : "-",
      ID : "ENSG00000120049.20",
      gene_id : "ENSG00000120049.20",
      gene_type : "protein_coding",
      gene_name : "KCNIP2",
      gene_level : 1,
      hgnc_id : "HGNC:15522",
      havana_gene : "OTTHUMG00000018937.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 101845599,
      stop : 102056193,
      direction : "-",
      ID : "ENSG00000120029.13",
      gene_id : "ENSG00000120029.13",
      gene_type : "protein_coding",
      gene_name : "ARMH3",
      gene_level : 2,
      hgnc_id : "HGNC:25788",
      havana_gene : "OTTHUMG00000018943.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102065349,
      stop : 102068036,
      direction : "+",
      ID : "ENSG00000166189.8",
      gene_id : "ENSG00000166189.8",
      gene_type : "protein_coding",
      gene_name : "HPS6",
      gene_level : 2,
      hgnc_id : "HGNC:18817",
      havana_gene : "OTTHUMG00000018945.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102106489,
      stop : 102120368,
      direction : "-",
      ID : "ENSG00000198728.11",
      gene_id : "ENSG00000198728.11",
      gene_type : "protein_coding",
      gene_name : "LDB1",
      gene_level : 2,
      hgnc_id : "HGNC:6532",
      havana_gene : "OTTHUMG00000018950.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102132994,
      stop : 102150333,
      direction : "+",
      ID : "ENSG00000148840.11",
      gene_id : "ENSG00000148840.11",
      gene_type : "protein_coding",
      gene_name : "PPRC1",
      gene_level : 2,
      hgnc_id : "HGNC:30025",
      havana_gene : "OTTHUMG00000018948.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102152176,
      stop : 102163871,
      direction : "+",
      ID : "ENSG00000166197.17",
      gene_id : "ENSG00000166197.17",
      gene_type : "protein_coding",
      gene_name : "NOLC1",
      gene_level : 1,
      hgnc_id : "HGNC:15608",
      havana_gene : "OTTHUMG00000018944.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102226299,
      stop : 102229589,
      direction : "+",
      ID : "ENSG00000119915.5",
      gene_id : "ENSG00000119915.5",
      gene_type : "protein_coding",
      gene_name : "ELOVL3",
      gene_level : 2,
      hgnc_id : "HGNC:18047",
      havana_gene : "OTTHUMG00000018951.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102230186,
      stop : 102241512,
      direction : "-",
      ID : "ENSG00000107859.10",
      gene_id : "ENSG00000107859.10",
      gene_type : "protein_coding",
      gene_name : "PITX3",
      gene_level : 2,
      hgnc_id : "HGNC:9006",
      havana_gene : "OTTHUMG00000018952.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102245371,
      stop : 102382899,
      direction : "+",
      ID : "ENSG00000107862.6",
      gene_id : "ENSG00000107862.6",
      gene_type : "protein_coding",
      gene_name : "GBF1",
      gene_level : 2,
      hgnc_id : "HGNC:4181",
      havana_gene : "OTTHUMG00000018955.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102394110,
      stop : 102402524,
      direction : "+",
      ID : "ENSG00000077150.20",
      gene_id : "ENSG00000077150.20",
      gene_type : "protein_coding",
      gene_name : "NFKB2",
      gene_level : 2,
      hgnc_id : "HGNC:7795",
      havana_gene : "OTTHUMG00000018962.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102402617,
      stop : 102421539,
      direction : "-",
      ID : "ENSG00000059915.17",
      gene_id : "ENSG00000059915.17",
      gene_type : "protein_coding",
      gene_name : "PSD",
      gene_level : 2,
      hgnc_id : "HGNC:9507",
      havana_gene : "OTTHUMG00000018954.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102419189,
      stop : 102423136,
      direction : "+",
      ID : "ENSG00000107872.13",
      gene_id : "ENSG00000107872.13",
      gene_type : "protein_coding",
      gene_name : "FBXL15",
      gene_level : 2,
      hgnc_id : "HGNC:28155",
      havana_gene : "OTTHUMG00000018957.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102423245,
      stop : 102432584,
      direction : "-",
      ID : "ENSG00000107874.11",
      gene_id : "ENSG00000107874.11",
      gene_type : "protein_coding",
      gene_name : "CUEDC2",
      gene_level : 2,
      hgnc_id : "HGNC:28352",
      havana_gene : "OTTHUMG00000018958.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102449837,
      stop : 102451543,
      direction : "-",
      ID : "ENSG00000120055.7",
      gene_id : "ENSG00000120055.7",
      gene_type : "protein_coding",
      gene_name : "C10orf95",
      gene_level : 2,
      hgnc_id : "HGNC:25880",
      havana_gene : "OTTHUMG00000018959.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102461395,
      stop : 102477045,
      direction : "+",
      ID : "ENSG00000138111.14",
      gene_id : "ENSG00000138111.14",
      gene_type : "protein_coding",
      gene_name : "MFSD13A",
      gene_level : 2,
      hgnc_id : "HGNC:26196",
      havana_gene : "OTTHUMG00000018961.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102461881,
      stop : 102502712,
      direction : "-",
      ID : "ENSG00000138107.13",
      gene_id : "ENSG00000138107.13",
      gene_type : "protein_coding",
      gene_name : "ACTR1A",
      gene_level : 2,
      hgnc_id : "HGNC:167",
      havana_gene : "OTTHUMG00000018956.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102503972,
      stop : 102633535,
      direction : "+",
      ID : "ENSG00000107882.12",
      gene_id : "ENSG00000107882.12",
      gene_type : "protein_coding",
      gene_name : "SUFU",
      gene_level : 2,
      hgnc_id : "HGNC:16466",
      havana_gene : "OTTHUMG00000018966.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102644479,
      stop : 102658318,
      direction : "+",
      ID : "ENSG00000171206.15",
      gene_id : "ENSG00000171206.15",
      gene_type : "protein_coding",
      gene_name : "TRIM8",
      gene_level : 1,
      hgnc_id : "HGNC:15579",
      havana_gene : "OTTHUMG00000018964.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102673731,
      stop : 102714397,
      direction : "-",
      ID : "ENSG00000138175.9",
      gene_id : "ENSG00000138175.9",
      gene_type : "protein_coding",
      gene_name : "ARL3",
      gene_level : 2,
      hgnc_id : "HGNC:694",
      havana_gene : "OTTHUMG00000018965.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102714538,
      stop : 102743492,
      direction : "+",
      ID : "ENSG00000156398.13",
      gene_id : "ENSG00000156398.13",
      gene_type : "protein_coding",
      gene_name : "SFXN2",
      gene_level : 1,
      hgnc_id : "HGNC:16086",
      havana_gene : "OTTHUMG00000018967.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102743948,
      stop : 102834516,
      direction : "+",
      ID : "ENSG00000166272.18",
      gene_id : "ENSG00000166272.18",
      gene_type : "protein_coding",
      gene_name : "WBP1L",
      gene_level : 2,
      hgnc_id : "HGNC:23510",
      havana_gene : "OTTHUMG00000018968.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102830531,
      stop : 102837472,
      direction : "-",
      ID : "ENSG00000148795.7",
      gene_id : "ENSG00000148795.7",
      gene_type : "protein_coding",
      gene_name : "CYP17A1",
      gene_level : 2,
      hgnc_id : "HGNC:2593",
      havana_gene : "OTTHUMG00000018969.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102854259,
      stop : 102864961,
      direction : "+",
      ID : "ENSG00000166275.16",
      gene_id : "ENSG00000166275.16",
      gene_type : "protein_coding",
      gene_name : "BORCS7",
      gene_level : 2,
      hgnc_id : "HGNC:23516",
      havana_gene : "OTTHUMG00000018975.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102854272,
      stop : 102901899,
      direction : "+",
      ID : "ENSG00000270316.1",
      gene_id : "ENSG00000270316.1",
      gene_type : "protein_coding",
      gene_name : "BORCS7-ASMT",
      gene_level : 2,
      hgnc_id : "HGNC:49183",
      havana_gene : "OTTHUMG00000184175.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102869470,
      stop : 102901899,
      direction : "+",
      ID : "ENSG00000214435.8",
      gene_id : "ENSG00000214435.8",
      gene_type : "protein_coding",
      gene_name : "AS3MT",
      gene_level : 2,
      hgnc_id : "HGNC:17452",
      havana_gene : "OTTHUMG00000018972.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 102918294,
      stop : 103090222,
      direction : "+",
      ID : "ENSG00000148842.18",
      gene_id : "ENSG00000148842.18",
      gene_type : "protein_coding",
      gene_name : "CNNM2",
      gene_level : 2,
      hgnc_id : "HGNC:103",
      havana_gene : "OTTHUMG00000018976.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103087185,
      stop : 103277605,
      direction : "-",
      ID : "ENSG00000076685.19",
      gene_id : "ENSG00000076685.19",
      gene_type : "protein_coding",
      gene_name : "NT5C2",
      gene_level : 2,
      hgnc_id : "HGNC:8022",
      havana_gene : "OTTHUMG00000018981.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103245887,
      stop : 103248016,
      direction : "+",
      ID : "ENSG00000235376.5",
      gene_id : "ENSG00000235376.5",
      gene_type : "protein_coding",
      gene_name : "RPEL1",
      gene_level : 2,
      hgnc_id : "HGNC:45241",
      havana_gene : "OTTHUMG00000018980.2",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103277138,
      stop : 103290346,
      direction : "+",
      ID : "ENSG00000148798.11",
      gene_id : "ENSG00000148798.11",
      gene_type : "protein_coding",
      gene_name : "INA",
      gene_level : 2,
      hgnc_id : "HGNC:6057",
      havana_gene : "OTTHUMG00000018986.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103302796,
      stop : 103351144,
      direction : "-",
      ID : "ENSG00000156374.16",
      gene_id : "ENSG00000156374.16",
      gene_type : "protein_coding",
      gene_name : "PCGF6",
      gene_level : 2,
      hgnc_id : "HGNC:21156",
      havana_gene : "OTTHUMG00000018982.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103367976,
      stop : 103389065,
      direction : "+",
      ID : "ENSG00000148835.11",
      gene_id : "ENSG00000148835.11",
      gene_type : "protein_coding",
      gene_name : "TAF5",
      gene_level : 2,
      hgnc_id : "HGNC:11539",
      havana_gene : "OTTHUMG00000018985.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103389041,
      stop : 103396492,
      direction : "-",
      ID : "ENSG00000173915.16",
      gene_id : "ENSG00000173915.16",
      gene_type : "protein_coding",
      gene_name : "ATP5MD",
      gene_level : 2,
      hgnc_id : "HGNC:30889",
      havana_gene : "OTTHUMG00000018984.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103396626,
      stop : 103446294,
      direction : "+",
      ID : "ENSG00000148843.15",
      gene_id : "ENSG00000148843.15",
      gene_type : "protein_coding",
      gene_name : "PDCD11",
      gene_level : 2,
      hgnc_id : "HGNC:13408",
      havana_gene : "OTTHUMG00000018988.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103446786,
      stop : 103452402,
      direction : "-",
      ID : "ENSG00000138172.11",
      gene_id : "ENSG00000138172.11",
      gene_type : "protein_coding",
      gene_name : "CALHM2",
      gene_level : 2,
      hgnc_id : "HGNC:23493",
      havana_gene : "OTTHUMG00000018990.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103453240,
      stop : 103458900,
      direction : "-",
      ID : "ENSG00000185933.7",
      gene_id : "ENSG00000185933.7",
      gene_type : "protein_coding",
      gene_name : "CALHM1",
      gene_level : 2,
      hgnc_id : "HGNC:23494",
      havana_gene : "OTTHUMG00000018991.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103472804,
      stop : 103479240,
      direction : "-",
      ID : "ENSG00000183128.7",
      gene_id : "ENSG00000183128.7",
      gene_type : "protein_coding",
      gene_name : "CALHM3",
      gene_level : 2,
      hgnc_id : "HGNC:23458",
      havana_gene : "OTTHUMG00000018989.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103493979,
      stop : 103592552,
      direction : "+",
      ID : "ENSG00000107954.10",
      gene_id : "ENSG00000107954.10",
      gene_type : "protein_coding",
      gene_name : "NEURL1",
      gene_level : 2,
      hgnc_id : "HGNC:7761",
      havana_gene : "OTTHUMG00000018995.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103594027,
      stop : 103855543,
      direction : "-",
      ID : "ENSG00000107957.16",
      gene_id : "ENSG00000107957.16",
      gene_type : "protein_coding",
      gene_name : "SH3PXD2A",
      gene_level : 2,
      hgnc_id : "HGNC:23664",
      havana_gene : "OTTHUMG00000018997.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103877569,
      stop : 103918184,
      direction : "-",
      ID : "ENSG00000107960.11",
      gene_id : "ENSG00000107960.11",
      gene_type : "protein_coding",
      gene_name : "STN1",
      gene_level : 2,
      hgnc_id : "HGNC:26200",
      havana_gene : "OTTHUMG00000018996.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 103967140,
      stop : 104029233,
      direction : "+",
      ID : "ENSG00000065613.15",
      gene_id : "ENSG00000065613.15",
      gene_type : "protein_coding",
      gene_name : "SLK",
      gene_level : 2,
      hgnc_id : "HGNC:11088",
      havana_gene : "OTTHUMG00000018999.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104031286,
      stop : 104085880,
      direction : "-",
      ID : "ENSG00000065618.21",
      gene_id : "ENSG00000065618.21",
      gene_type : "protein_coding",
      gene_name : "COL17A1",
      gene_level : 2,
      hgnc_id : "HGNC:2194",
      havana_gene : "OTTHUMG00000018998.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104122058,
      stop : 104126385,
      direction : "+",
      ID : "ENSG00000156384.15",
      gene_id : "ENSG00000156384.15",
      gene_type : "protein_coding",
      gene_name : "SFR1",
      gene_level : 2,
      hgnc_id : "HGNC:29574",
      havana_gene : "OTTHUMG00000019000.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104129888,
      stop : 104232364,
      direction : "-",
      ID : "ENSG00000197748.13",
      gene_id : "ENSG00000197748.13",
      gene_type : "protein_coding",
      gene_name : "CFAP43",
      gene_level : 2,
      hgnc_id : "HGNC:26684",
      havana_gene : "OTTHUMG00000019002.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104235356,
      stop : 104267459,
      direction : "+",
      ID : "ENSG00000148834.13",
      gene_id : "ENSG00000148834.13",
      gene_type : "protein_coding",
      gene_name : "GSTO1",
      gene_level : 2,
      hgnc_id : "HGNC:13312",
      havana_gene : "OTTHUMG00000019001.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104268873,
      stop : 104304950,
      direction : "+",
      ID : "ENSG00000065621.15",
      gene_id : "ENSG00000065621.15",
      gene_type : "protein_coding",
      gene_name : "GSTO2",
      gene_level : 2,
      hgnc_id : "HGNC:23064",
      havana_gene : "OTTHUMG00000019006.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104309698,
      stop : 104338465,
      direction : "-",
      ID : "ENSG00000148841.17",
      gene_id : "ENSG00000148841.17",
      gene_type : "protein_coding",
      gene_name : "ITPRIP",
      gene_level : 2,
      hgnc_id : "HGNC:29370",
      havana_gene : "OTTHUMG00000184003.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104353833,
      stop : 104455102,
      direction : "+",
      ID : "ENSG00000120051.15",
      gene_id : "ENSG00000120051.15",
      gene_type : "protein_coding",
      gene_name : "CFAP58",
      gene_level : 2,
      hgnc_id : "HGNC:26676",
      havana_gene : "OTTHUMG00000019007.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 104641290,
      stop : 105265242,
      direction : "+",
      ID : "ENSG00000156395.14",
      gene_id : "ENSG00000156395.14",
      gene_type : "protein_coding",
      gene_name : "SORCS3",
      gene_level : 2,
      hgnc_id : "HGNC:16699",
      havana_gene : "OTTHUMG00000019011.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 106573663,
      stop : 107164534,
      direction : "-",
      ID : "ENSG00000108018.15",
      gene_id : "ENSG00000108018.15",
      gene_type : "protein_coding",
      gene_name : "SORCS1",
      gene_level : 2,
      hgnc_id : "HGNC:16697",
      havana_gene : "OTTHUMG00000019018.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 109864766,
      stop : 109923553,
      direction : "-",
      ID : "ENSG00000108039.18",
      gene_id : "ENSG00000108039.18",
      gene_type : "protein_coding",
      gene_name : "XPNPEP1",
      gene_level : 1,
      hgnc_id : "HGNC:12822",
      havana_gene : "OTTHUMG00000019029.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 109996368,
      stop : 110135565,
      direction : "+",
      ID : "ENSG00000148700.15",
      gene_id : "ENSG00000148700.15",
      gene_type : "protein_coding",
      gene_name : "ADD3",
      gene_level : 2,
      hgnc_id : "HGNC:245",
      havana_gene : "OTTHUMG00000019032.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110207605,
      stop : 110287365,
      direction : "+",
      ID : "ENSG00000119950.21",
      gene_id : "ENSG00000119950.21",
      gene_type : "protein_coding",
      gene_name : "MXI1",
      gene_level : 2,
      hgnc_id : "HGNC:7534",
      havana_gene : "OTTHUMG00000019033.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110290730,
      stop : 110304938,
      direction : "-",
      ID : "ENSG00000119953.14",
      gene_id : "ENSG00000119953.14",
      gene_type : "protein_coding",
      gene_name : "SMNDC1",
      gene_level : 2,
      hgnc_id : "HGNC:16900",
      havana_gene : "OTTHUMG00000019036.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110497907,
      stop : 110511533,
      direction : "+",
      ID : "ENSG00000138166.6",
      gene_id : "ENSG00000138166.6",
      gene_type : "protein_coding",
      gene_name : "DUSP5",
      gene_level : 2,
      hgnc_id : "HGNC:3071",
      havana_gene : "OTTHUMG00000019040.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110567695,
      stop : 110606048,
      direction : "+",
      ID : "ENSG00000108055.10",
      gene_id : "ENSG00000108055.10",
      gene_type : "protein_coding",
      gene_name : "SMC3",
      gene_level : 2,
      hgnc_id : "HGNC:2468",
      havana_gene : "OTTHUMG00000019042.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110644336,
      stop : 110839468,
      direction : "+",
      ID : "ENSG00000203867.8",
      gene_id : "ENSG00000203867.8",
      gene_type : "protein_coding",
      gene_name : "RBM20",
      gene_level : 2,
      hgnc_id : "HGNC:27424",
      havana_gene : "OTTHUMG00000019043.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110871795,
      stop : 110900006,
      direction : "+",
      ID : "ENSG00000150593.18",
      gene_id : "ENSG00000150593.18",
      gene_type : "protein_coding",
      gene_name : "PDCD4",
      gene_level : 2,
      hgnc_id : "HGNC:8763",
      havana_gene : "OTTHUMG00000019048.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110898730,
      stop : 110919201,
      direction : "-",
      ID : "ENSG00000214413.9",
      gene_id : "ENSG00000214413.9",
      gene_type : "protein_coding",
      gene_name : "BBIP1",
      gene_level : 2,
      hgnc_id : "HGNC:28093",
      havana_gene : "OTTHUMG00000019046.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 110919593,
      stop : 111013666,
      direction : "+",
      ID : "ENSG00000108061.12",
      gene_id : "ENSG00000108061.12",
      gene_type : "protein_coding",
      gene_name : "SHOC2",
      gene_level : 2,
      hgnc_id : "HGNC:15454",
      havana_gene : "OTTHUMG00000019047.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 111077029,
      stop : 111080907,
      direction : "+",
      ID : "ENSG00000150594.7",
      gene_id : "ENSG00000150594.7",
      gene_type : "protein_coding",
      gene_name : "ADRA2A",
      gene_level : 2,
      hgnc_id : "HGNC:281",
      havana_gene : "OTTHUMG00000019050.3",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 112149865,
      stop : 112215377,
      direction : "-",
      ID : "ENSG00000119927.14",
      gene_id : "ENSG00000119927.14",
      gene_type : "protein_coding",
      gene_name : "GPAM",
      gene_level : 2,
      hgnc_id : "HGNC:24865",
      havana_gene : "OTTHUMG00000019055.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 112283400,
      stop : 112305038,
      direction : "+",
      ID : "ENSG00000119913.6",
      gene_id : "ENSG00000119913.6",
      gene_type : "protein_coding",
      gene_name : "TECTB",
      gene_level : 2,
      hgnc_id : "HGNC:11721",
      havana_gene : "OTTHUMG00000019056.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 112374018,
      stop : 112428380,
      direction : "+",
      ID : "ENSG00000197142.10",
      gene_id : "ENSG00000197142.10",
      gene_type : "protein_coding",
      gene_name : "ACSL5",
      gene_level : 2,
      hgnc_id : "HGNC:16526",
      havana_gene : "OTTHUMG00000019060.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 112424428,
      stop : 112446917,
      direction : "-",
      ID : "ENSG00000023041.11",
      gene_id : "ENSG00000023041.11",
      gene_type : "protein_coding",
      gene_name : "ZDHHC6",
      gene_level : 2,
      hgnc_id : "HGNC:19160",
      havana_gene : "OTTHUMG00000019062.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 112446998,
      stop : 112818744,
      direction : "+",
      ID : "ENSG00000151532.14",
      gene_id : "ENSG00000151532.14",
      gene_type : "protein_coding",
      gene_name : "VTI1A",
      gene_level : 2,
      hgnc_id : "HGNC:17792",
      havana_gene : "OTTHUMG00000019063.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 112950247,
      stop : 113167678,
      direction : "+",
      ID : "ENSG00000148737.17",
      gene_id : "ENSG00000148737.17",
      gene_type : "protein_coding",
      gene_name : "TCF7L2",
      gene_level : 2,
      hgnc_id : "HGNC:11641",
      havana_gene : "OTTHUMG00000019070.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 113550837,
      stop : 113589602,
      direction : "+",
      ID : "ENSG00000148702.15",
      gene_id : "ENSG00000148702.15",
      gene_type : "protein_coding",
      gene_name : "HABP2",
      gene_level : 2,
      hgnc_id : "HGNC:4798",
      havana_gene : "OTTHUMG00000019073.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 113588714,
      stop : 113664070,
      direction : "-",
      ID : "ENSG00000197893.14",
      gene_id : "ENSG00000197893.14",
      gene_type : "protein_coding",
      gene_name : "NRAP",
      gene_level : 2,
      hgnc_id : "HGNC:7988",
      havana_gene : "OTTHUMG00000019072.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 113679162,
      stop : 113730907,
      direction : "+",
      ID : "ENSG00000165806.21",
      gene_id : "ENSG00000165806.21",
      gene_type : "protein_coding",
      gene_name : "CASP7",
      gene_level : 2,
      hgnc_id : "HGNC:1508",
      havana_gene : "OTTHUMG00000019076.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 113751262,
      stop : 113783429,
      direction : "+",
      ID : "ENSG00000148735.15",
      gene_id : "ENSG00000148735.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHS1",
      gene_level : 2,
      hgnc_id : "HGNC:26285",
      havana_gene : "OTTHUMG00000019074.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 113834725,
      stop : 113854383,
      direction : "-",
      ID : "ENSG00000198924.8",
      gene_id : "ENSG00000198924.8",
      gene_type : "protein_coding",
      gene_name : "DCLRE1A",
      gene_level : 2,
      hgnc_id : "HGNC:17660",
      havana_gene : "OTTHUMG00000019077.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 113854661,
      stop : 113917194,
      direction : "+",
      ID : "ENSG00000196865.4",
      gene_id : "ENSG00000196865.4",
      gene_type : "protein_coding",
      gene_name : "NHLRC2",
      gene_level : 2,
      hgnc_id : "HGNC:24731",
      havana_gene : "OTTHUMG00000019078.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114043866,
      stop : 114046904,
      direction : "+",
      ID : "ENSG00000043591.6",
      gene_id : "ENSG00000043591.6",
      gene_type : "protein_coding",
      gene_name : "ADRB1",
      gene_level : 2,
      hgnc_id : "HGNC:285",
      havana_gene : "OTTHUMG00000019079.2",
      tag : "retrogene"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114120862,
      stop : 114174232,
      direction : "-",
      ID : "ENSG00000165813.20",
      gene_id : "ENSG00000165813.20",
      gene_type : "protein_coding",
      gene_name : "CCDC186",
      gene_level : 1,
      hgnc_id : "HGNC:24349",
      havana_gene : "OTTHUMG00000019081.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114179270,
      stop : 114232304,
      direction : "+",
      ID : "ENSG00000095627.9",
      gene_id : "ENSG00000095627.9",
      gene_type : "protein_coding",
      gene_name : "TDRD1",
      gene_level : 2,
      hgnc_id : "HGNC:11712",
      havana_gene : "OTTHUMG00000019083.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114239254,
      stop : 114294489,
      direction : "+",
      ID : "ENSG00000165816.13",
      gene_id : "ENSG00000165816.13",
      gene_type : "protein_coding",
      gene_name : "VWA2",
      gene_level : 2,
      hgnc_id : "HGNC:24709",
      havana_gene : "OTTHUMG00000019082.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114294824,
      stop : 114404756,
      direction : "-",
      ID : "ENSG00000169129.15",
      gene_id : "ENSG00000169129.15",
      gene_type : "protein_coding",
      gene_name : "AFAP1L2",
      gene_level : 2,
      hgnc_id : "HGNC:25901",
      havana_gene : "OTTHUMG00000019086.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114431113,
      stop : 114768061,
      direction : "-",
      ID : "ENSG00000099204.20",
      gene_id : "ENSG00000099204.20",
      gene_type : "protein_coding",
      gene_name : "ABLIM1",
      gene_level : 2,
      hgnc_id : "HGNC:78",
      havana_gene : "OTTHUMG00000019088.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114821744,
      stop : 114899832,
      direction : "+",
      ID : "ENSG00000151553.15",
      gene_id : "ENSG00000151553.15",
      gene_type : "protein_coding",
      gene_name : "FAM160B1",
      gene_level : 2,
      hgnc_id : "HGNC:29320",
      havana_gene : "OTTHUMG00000019092.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 114938195,
      stop : 114977676,
      direction : "+",
      ID : "ENSG00000165832.6",
      gene_id : "ENSG00000165832.6",
      gene_type : "protein_coding",
      gene_name : "TRUB1",
      gene_level : 2,
      hgnc_id : "HGNC:16060",
      havana_gene : "OTTHUMG00000019094.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 115093365,
      stop : 115948999,
      direction : "+",
      ID : "ENSG00000107518.18",
      gene_id : "ENSG00000107518.18",
      gene_type : "protein_coding",
      gene_name : "ATRNL1",
      gene_level : 1,
      hgnc_id : "HGNC:29063",
      havana_gene : "OTTHUMG00000019096.13",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116056925,
      stop : 116273284,
      direction : "-",
      ID : "ENSG00000151892.15",
      gene_id : "ENSG00000151892.15",
      gene_type : "protein_coding",
      gene_name : "GFRA1",
      gene_level : 2,
      hgnc_id : "HGNC:4243",
      havana_gene : "OTTHUMG00000019097.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116324448,
      stop : 116380029,
      direction : "+",
      ID : "ENSG00000182645.6",
      gene_id : "ENSG00000182645.6",
      gene_type : "protein_coding",
      gene_name : "CCDC172",
      gene_level : 2,
      hgnc_id : "HGNC:30524",
      havana_gene : "OTTHUMG00000019098.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116427847,
      stop : 116477957,
      direction : "+",
      ID : "ENSG00000203837.5",
      gene_id : "ENSG00000203837.5",
      gene_type : "protein_coding",
      gene_name : "PNLIPRP3",
      gene_level : 2,
      hgnc_id : "HGNC:23492",
      havana_gene : "OTTHUMG00000019100.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116545931,
      stop : 116567855,
      direction : "+",
      ID : "ENSG00000175535.6",
      gene_id : "ENSG00000175535.6",
      gene_type : "protein_coding",
      gene_name : "PNLIP",
      gene_level : 2,
      hgnc_id : "HGNC:9155",
      havana_gene : "OTTHUMG00000019103.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116590385,
      stop : 116609175,
      direction : "+",
      ID : "ENSG00000187021.15",
      gene_id : "ENSG00000187021.15",
      gene_type : "protein_coding",
      gene_name : "PNLIPRP1",
      gene_level : 2,
      hgnc_id : "HGNC:9156",
      havana_gene : "OTTHUMG00000019109.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116663696,
      stop : 116670264,
      direction : "-",
      ID : "ENSG00000165863.17",
      gene_id : "ENSG00000165863.17",
      gene_type : "protein_coding",
      gene_name : "C10orf82",
      gene_level : 1,
      hgnc_id : "HGNC:28500",
      havana_gene : "OTTHUMG00000019105.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116671192,
      stop : 116850251,
      direction : "-",
      ID : "ENSG00000165868.16",
      gene_id : "ENSG00000165868.16",
      gene_type : "protein_coding",
      gene_name : "HSPA12A",
      gene_level : 2,
      hgnc_id : "HGNC:19022",
      havana_gene : "OTTHUMG00000019107.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116849499,
      stop : 116911788,
      direction : "+",
      ID : "ENSG00000188316.15",
      gene_id : "ENSG00000188316.15",
      gene_type : "protein_coding",
      gene_name : "ENO4",
      gene_level : 1,
      hgnc_id : "HGNC:31670",
      havana_gene : "OTTHUMG00000019113.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 116881477,
      stop : 117126586,
      direction : "-",
      ID : "ENSG00000187164.20",
      gene_id : "ENSG00000187164.20",
      gene_type : "protein_coding",
      gene_name : "SHTN1",
      gene_level : 2,
      hgnc_id : "HGNC:29319",
      havana_gene : "OTTHUMG00000019114.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 117128521,
      stop : 117138301,
      direction : "-",
      ID : "ENSG00000148704.13",
      gene_id : "ENSG00000148704.13",
      gene_type : "protein_coding",
      gene_name : "VAX1",
      gene_level : 2,
      hgnc_id : "HGNC:12660",
      havana_gene : "OTTHUMG00000019117.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 117197489,
      stop : 117210299,
      direction : "+",
      ID : "ENSG00000186795.1",
      gene_id : "ENSG00000186795.1",
      gene_type : "protein_coding",
      gene_name : "KCNK18",
      gene_level : 2,
      hgnc_id : "HGNC:19439",
      havana_gene : "OTTHUMG00000019120.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 117241093,
      stop : 117279430,
      direction : "+",
      ID : "ENSG00000165646.14",
      gene_id : "ENSG00000165646.14",
      gene_type : "protein_coding",
      gene_name : "SLC18A2",
      gene_level : 2,
      hgnc_id : "HGNC:10935",
      havana_gene : "OTTHUMG00000019121.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 117277274,
      stop : 117375440,
      direction : "-",
      ID : "ENSG00000165650.12",
      gene_id : "ENSG00000165650.12",
      gene_type : "protein_coding",
      gene_name : "PDZD8",
      gene_level : 2,
      hgnc_id : "HGNC:26974",
      havana_gene : "OTTHUMG00000019122.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 117542445,
      stop : 117549546,
      direction : "+",
      ID : "ENSG00000170370.12",
      gene_id : "ENSG00000170370.12",
      gene_type : "protein_coding",
      gene_name : "EMX2",
      gene_level : 2,
      hgnc_id : "HGNC:3341",
      havana_gene : "OTTHUMG00000019123.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 118004916,
      stop : 118046941,
      direction : "-",
      ID : "ENSG00000107560.12",
      gene_id : "ENSG00000107560.12",
      gene_type : "protein_coding",
      gene_name : "RAB11FIP2",
      gene_level : 2,
      hgnc_id : "HGNC:29152",
      havana_gene : "OTTHUMG00000019128.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 118297925,
      stop : 118342328,
      direction : "-",
      ID : "ENSG00000165669.14",
      gene_id : "ENSG00000165669.14",
      gene_type : "protein_coding",
      gene_name : "FAM204A",
      gene_level : 2,
      hgnc_id : "HGNC:25794",
      havana_gene : "OTTHUMG00000019131.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 118589997,
      stop : 118595648,
      direction : "-",
      ID : "ENSG00000119973.6",
      gene_id : "ENSG00000119973.6",
      gene_type : "protein_coding",
      gene_name : "PRLHR",
      gene_level : 2,
      hgnc_id : "HGNC:4464",
      havana_gene : "OTTHUMG00000019136.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 118674167,
      stop : 118755249,
      direction : "-",
      ID : "ENSG00000151893.15",
      gene_id : "ENSG00000151893.15",
      gene_type : "protein_coding",
      gene_name : "CACUL1",
      gene_level : 2,
      hgnc_id : "HGNC:23727",
      havana_gene : "OTTHUMG00000019138.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119029714,
      stop : 119033730,
      direction : "+",
      ID : "ENSG00000188613.7",
      gene_id : "ENSG00000188613.7",
      gene_type : "protein_coding",
      gene_name : "NANOS1",
      gene_level : 2,
      hgnc_id : "HGNC:23044",
      havana_gene : "OTTHUMG00000019141.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119033670,
      stop : 119080823,
      direction : "-",
      ID : "ENSG00000107581.13",
      gene_id : "ENSG00000107581.13",
      gene_type : "protein_coding",
      gene_name : "EIF3A",
      gene_level : 2,
      hgnc_id : "HGNC:3271",
      havana_gene : "OTTHUMG00000019144.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119104086,
      stop : 119137984,
      direction : "+",
      ID : "ENSG00000119979.18",
      gene_id : "ENSG00000119979.18",
      gene_type : "protein_coding",
      gene_name : "DENND10",
      gene_level : 2,
      hgnc_id : "HGNC:31793",
      havana_gene : "OTTHUMG00000019143.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119140767,
      stop : 119165714,
      direction : "-",
      ID : "ENSG00000183605.17",
      gene_id : "ENSG00000183605.17",
      gene_type : "protein_coding",
      gene_name : "SFXN4",
      gene_level : 2,
      hgnc_id : "HGNC:16088",
      havana_gene : "OTTHUMG00000019147.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119167720,
      stop : 119178812,
      direction : "-",
      ID : "ENSG00000165672.7",
      gene_id : "ENSG00000165672.7",
      gene_type : "protein_coding",
      gene_name : "PRDX3",
      gene_level : 2,
      hgnc_id : "HGNC:9354",
      havana_gene : "OTTHUMG00000019146.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119207571,
      stop : 119459745,
      direction : "+",
      ID : "ENSG00000198873.12",
      gene_id : "ENSG00000198873.12",
      gene_type : "protein_coding",
      gene_name : "GRK5",
      gene_level : 2,
      hgnc_id : "HGNC:4544",
      havana_gene : "OTTHUMG00000019149.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119499817,
      stop : 119542719,
      direction : "-",
      ID : "ENSG00000148908.15",
      gene_id : "ENSG00000148908.15",
      gene_type : "protein_coding",
      gene_name : "RGS10",
      gene_level : 2,
      hgnc_id : "HGNC:9992",
      havana_gene : "OTTHUMG00000019150.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119571802,
      stop : 119597029,
      direction : "-",
      ID : "ENSG00000151923.18",
      gene_id : "ENSG00000151923.18",
      gene_type : "protein_coding",
      gene_name : "TIAL1",
      gene_level : 2,
      hgnc_id : "HGNC:11804",
      havana_gene : "OTTHUMG00000019156.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119651380,
      stop : 119677819,
      direction : "+",
      ID : "ENSG00000151929.10",
      gene_id : "ENSG00000151929.10",
      gene_type : "protein_coding",
      gene_name : "BAG3",
      gene_level : 2,
      hgnc_id : "HGNC:939",
      havana_gene : "OTTHUMG00000019155.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119726042,
      stop : 119829147,
      direction : "+",
      ID : "ENSG00000198825.15",
      gene_id : "ENSG00000198825.15",
      gene_type : "protein_coding",
      gene_name : "INPP5F",
      gene_level : 2,
      hgnc_id : "HGNC:17054",
      havana_gene : "OTTHUMG00000019158.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119829404,
      stop : 119892556,
      direction : "-",
      ID : "ENSG00000197771.13",
      gene_id : "ENSG00000197771.13",
      gene_type : "protein_coding",
      gene_name : "MCMBP",
      gene_level : 2,
      hgnc_id : "HGNC:25782",
      havana_gene : "OTTHUMG00000019159.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 119892730,
      stop : 119944657,
      direction : "+",
      ID : "ENSG00000107651.14",
      gene_id : "ENSG00000107651.14",
      gene_type : "protein_coding",
      gene_name : "SEC23IP",
      gene_level : 2,
      hgnc_id : "HGNC:17018",
      havana_gene : "OTTHUMG00000019161.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 120457227,
      stop : 120592065,
      direction : "+",
      ID : "ENSG00000203805.11",
      gene_id : "ENSG00000203805.11",
      gene_type : "protein_coding",
      gene_name : "PLPP4",
      gene_level : 2,
      hgnc_id : "HGNC:23531",
      havana_gene : "OTTHUMG00000019168.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 120851305,
      stop : 120909524,
      direction : "+",
      ID : "ENSG00000120008.16",
      gene_id : "ENSG00000120008.16",
      gene_type : "protein_coding",
      gene_name : "WDR11",
      gene_level : 2,
      hgnc_id : "HGNC:13831",
      havana_gene : "OTTHUMG00000019171.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 121478332,
      stop : 121598458,
      direction : "-",
      ID : "ENSG00000066468.23",
      gene_id : "ENSG00000066468.23",
      gene_type : "protein_coding",
      gene_name : "FGFR2",
      gene_level : 1,
      hgnc_id : "HGNC:3689",
      havana_gene : "OTTHUMG00000019175.12",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 121740424,
      stop : 121928492,
      direction : "-",
      ID : "ENSG00000107669.18",
      gene_id : "ENSG00000107669.18",
      gene_type : "protein_coding",
      gene_name : "ATE1",
      gene_level : 2,
      hgnc_id : "HGNC:782",
      havana_gene : "OTTHUMG00000019178.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 121957091,
      stop : 121975217,
      direction : "-",
      ID : "ENSG00000107672.15",
      gene_id : "ENSG00000107672.15",
      gene_type : "protein_coding",
      gene_name : "NSMCE4A",
      gene_level : 2,
      hgnc_id : "HGNC:25935",
      havana_gene : "OTTHUMG00000019180.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 121989163,
      stop : 122254545,
      direction : "+",
      ID : "ENSG00000138162.19",
      gene_id : "ENSG00000138162.19",
      gene_type : "protein_coding",
      gene_name : "TACC2",
      gene_level : 1,
      hgnc_id : "HGNC:11523",
      havana_gene : "OTTHUMG00000019181.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122271296,
      stop : 122338159,
      direction : "+",
      ID : "ENSG00000138152.10",
      gene_id : "ENSG00000138152.10",
      gene_type : "protein_coding",
      gene_name : "BTBD16",
      gene_level : 2,
      hgnc_id : "HGNC:26340",
      havana_gene : "OTTHUMG00000019182.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122374696,
      stop : 122442602,
      direction : "+",
      ID : "ENSG00000107679.14",
      gene_id : "ENSG00000107679.14",
      gene_type : "protein_coding",
      gene_name : "PLEKHA1",
      gene_level : 2,
      hgnc_id : "HGNC:14335",
      havana_gene : "OTTHUMG00000019184.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122454653,
      stop : 122457352,
      direction : "+",
      ID : "ENSG00000254636.1",
      gene_id : "ENSG00000254636.1",
      gene_type : "protein_coding",
      gene_name : "ARMS2",
      gene_level : 2,
      hgnc_id : "HGNC:32685",
      havana_gene : "OTTHUMG00000048232.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122458551,
      stop : 122514907,
      direction : "+",
      ID : "ENSG00000166033.13",
      gene_id : "ENSG00000166033.13",
      gene_type : "protein_coding",
      gene_name : "HTRA1",
      gene_level : 2,
      hgnc_id : "HGNC:9476",
      havana_gene : "OTTHUMG00000019186.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122560665,
      stop : 122643736,
      direction : "+",
      ID : "ENSG00000187908.20",
      gene_id : "ENSG00000187908.20",
      gene_type : "protein_coding",
      gene_name : "DMBT1",
      gene_level : 2,
      hgnc_id : "HGNC:2926",
      havana_gene : "OTTHUMG00000019185.21",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122672850,
      stop : 122679494,
      direction : "+",
      ID : "ENSG00000286135.1",
      gene_id : "ENSG00000286135.1",
      gene_type : "protein_coding",
      gene_name : "AL603764.2",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193460.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122697709,
      stop : 122699846,
      direction : "-",
      ID : "ENSG00000183559.12",
      gene_id : "ENSG00000183559.12",
      gene_type : "protein_coding",
      gene_name : "C10orf120",
      gene_level : 1,
      hgnc_id : "HGNC:25707",
      havana_gene : "OTTHUMG00000019187.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122832158,
      stop : 122846175,
      direction : "-",
      ID : "ENSG00000138161.14",
      gene_id : "ENSG00000138161.14",
      gene_type : "protein_coding",
      gene_name : "CUZD1",
      gene_level : 2,
      hgnc_id : "HGNC:17937",
      havana_gene : "OTTHUMG00000019195.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122832167,
      stop : 122879583,
      direction : "-",
      ID : "ENSG00000286088.1",
      gene_id : "ENSG00000286088.1",
      gene_type : "protein_coding",
      gene_name : "AC073585.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193440.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122849078,
      stop : 122879641,
      direction : "-",
      ID : "ENSG00000213185.7",
      gene_id : "ENSG00000213185.7",
      gene_type : "protein_coding",
      gene_name : "FAM24B",
      gene_level : 2,
      hgnc_id : "HGNC:23475",
      havana_gene : "OTTHUMG00000019194.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122910610,
      stop : 122913111,
      direction : "+",
      ID : "ENSG00000203795.3",
      gene_id : "ENSG00000203795.3",
      gene_type : "protein_coding",
      gene_name : "FAM24A",
      gene_level : 2,
      hgnc_id : "HGNC:23470",
      havana_gene : "OTTHUMG00000019193.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122930901,
      stop : 122954311,
      direction : "-",
      ID : "ENSG00000119965.13",
      gene_id : "ENSG00000119965.13",
      gene_type : "protein_coding",
      gene_name : "C10orf88",
      gene_level : 2,
      hgnc_id : "HGNC:25822",
      havana_gene : "OTTHUMG00000019190.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122954381,
      stop : 122997513,
      direction : "+",
      ID : "ENSG00000179988.15",
      gene_id : "ENSG00000179988.15",
      gene_type : "protein_coding",
      gene_name : "PSTK",
      gene_level : 2,
      hgnc_id : "HGNC:28578",
      havana_gene : "OTTHUMG00000019191.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 122990807,
      stop : 123008812,
      direction : "-",
      ID : "ENSG00000095574.12",
      gene_id : "ENSG00000095574.12",
      gene_type : "protein_coding",
      gene_name : "IKZF5",
      gene_level : 2,
      hgnc_id : "HGNC:14283",
      havana_gene : "OTTHUMG00000019192.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 123008979,
      stop : 123058290,
      direction : "+",
      ID : "ENSG00000196177.13",
      gene_id : "ENSG00000196177.13",
      gene_type : "protein_coding",
      gene_name : "ACADSB",
      gene_level : 1,
      hgnc_id : "HGNC:91",
      havana_gene : "OTTHUMG00000019200.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 123135970,
      stop : 123139423,
      direction : "+",
      ID : "ENSG00000188620.11",
      gene_id : "ENSG00000188620.11",
      gene_type : "protein_coding",
      gene_name : "HMX3",
      gene_level : 2,
      hgnc_id : "HGNC:5019",
      havana_gene : "OTTHUMG00000019199.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 123148136,
      stop : 123150672,
      direction : "+",
      ID : "ENSG00000188816.4",
      gene_id : "ENSG00000188816.4",
      gene_type : "protein_coding",
      gene_name : "HMX2",
      gene_level : 2,
      hgnc_id : "HGNC:5018",
      havana_gene : "OTTHUMG00000019198.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 123154402,
      stop : 123170467,
      direction : "+",
      ID : "ENSG00000154473.18",
      gene_id : "ENSG00000154473.18",
      gene_type : "protein_coding",
      gene_name : "BUB3",
      gene_level : 1,
      hgnc_id : "HGNC:1151",
      havana_gene : "OTTHUMG00000019197.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 123666355,
      stop : 123697399,
      direction : "+",
      ID : "ENSG00000154478.4",
      gene_id : "ENSG00000154478.4",
      gene_type : "protein_coding",
      gene_name : "GPR26",
      gene_level : 2,
      hgnc_id : "HGNC:4481",
      havana_gene : "OTTHUMG00000019204.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 123706207,
      stop : 123940267,
      direction : "-",
      ID : "ENSG00000121898.13",
      gene_id : "ENSG00000121898.13",
      gene_type : "protein_coding",
      gene_name : "CPXM2",
      gene_level : 2,
      hgnc_id : "HGNC:26977",
      havana_gene : "OTTHUMG00000019206.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124007668,
      stop : 124093598,
      direction : "-",
      ID : "ENSG00000182022.18",
      gene_id : "ENSG00000182022.18",
      gene_type : "protein_coding",
      gene_name : "CHST15",
      gene_level : 2,
      hgnc_id : "HGNC:18137",
      havana_gene : "OTTHUMG00000019208.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124397303,
      stop : 124418976,
      direction : "-",
      ID : "ENSG00000065154.12",
      gene_id : "ENSG00000065154.12",
      gene_type : "protein_coding",
      gene_name : "OAT",
      gene_level : 2,
      hgnc_id : "HGNC:8091",
      havana_gene : "OTTHUMG00000019213.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124445243,
      stop : 124450035,
      direction : "-",
      ID : "ENSG00000229544.9",
      gene_id : "ENSG00000229544.9",
      gene_type : "protein_coding",
      gene_name : "NKX1-2",
      gene_level : 2,
      hgnc_id : "HGNC:31652",
      havana_gene : "OTTHUMG00000185174.10",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124461823,
      stop : 124617888,
      direction : "+",
      ID : "ENSG00000107902.14",
      gene_id : "ENSG00000107902.14",
      gene_type : "protein_coding",
      gene_name : "LHPP",
      gene_level : 2,
      hgnc_id : "HGNC:30042",
      havana_gene : "OTTHUMG00000019214.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124617080,
      stop : 124791727,
      direction : "-",
      ID : "ENSG00000258539.1",
      gene_id : "ENSG00000258539.1",
      gene_type : "protein_coding",
      gene_name : "AC068896.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171144.1",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124619292,
      stop : 124744378,
      direction : "-",
      ID : "ENSG00000189319.14",
      gene_id : "ENSG00000189319.14",
      gene_type : "protein_coding",
      gene_name : "FAM53B",
      gene_level : 1,
      hgnc_id : "HGNC:28968",
      havana_gene : "OTTHUMG00000019215.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124748149,
      stop : 124791887,
      direction : "-",
      ID : "ENSG00000203791.15",
      gene_id : "ENSG00000203791.15",
      gene_type : "protein_coding",
      gene_name : "EEF1AKMT2",
      gene_level : 2,
      hgnc_id : "HGNC:33787",
      havana_gene : "OTTHUMG00000019217.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124801819,
      stop : 124836667,
      direction : "+",
      ID : "ENSG00000165660.8",
      gene_id : "ENSG00000165660.8",
      gene_type : "protein_coding",
      gene_name : "ABRAXAS2",
      gene_level : 2,
      hgnc_id : "HGNC:28975",
      havana_gene : "OTTHUMG00000019218.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124942123,
      stop : 124988189,
      direction : "+",
      ID : "ENSG00000019995.6",
      gene_id : "ENSG00000019995.6",
      gene_type : "protein_coding",
      gene_name : "ZRANB1",
      gene_level : 2,
      hgnc_id : "HGNC:18224",
      havana_gene : "OTTHUMG00000019223.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 124984317,
      stop : 125161170,
      direction : "-",
      ID : "ENSG00000175029.17",
      gene_id : "ENSG00000175029.17",
      gene_type : "protein_coding",
      gene_name : "CTBP2",
      gene_level : 2,
      hgnc_id : "HGNC:2495",
      havana_gene : "OTTHUMG00000019224.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125576522,
      stop : 125683163,
      direction : "-",
      ID : "ENSG00000175018.13",
      gene_id : "ENSG00000175018.13",
      gene_type : "protein_coding",
      gene_name : "TEX36",
      gene_level : 1,
      hgnc_id : "HGNC:31653",
      havana_gene : "OTTHUMG00000019229.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125719515,
      stop : 125764143,
      direction : "+",
      ID : "ENSG00000107938.18",
      gene_id : "ENSG00000107938.18",
      gene_type : "protein_coding",
      gene_name : "EDRF1",
      gene_level : 1,
      hgnc_id : "HGNC:24640",
      havana_gene : "OTTHUMG00000019233.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125753580,
      stop : 125775821,
      direction : "-",
      ID : "ENSG00000154485.5",
      gene_id : "ENSG00000154485.5",
      gene_type : "protein_coding",
      gene_name : "MMP21",
      gene_level : 2,
      hgnc_id : "HGNC:14357",
      havana_gene : "OTTHUMG00000019235.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125784980,
      stop : 125823258,
      direction : "-",
      ID : "ENSG00000188690.15",
      gene_id : "ENSG00000188690.15",
      gene_type : "protein_coding",
      gene_name : "UROS",
      gene_level : 2,
      hgnc_id : "HGNC:12592",
      havana_gene : "OTTHUMG00000019236.14",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125823546,
      stop : 125853695,
      direction : "+",
      ID : "ENSG00000107949.17",
      gene_id : "ENSG00000107949.17",
      gene_type : "protein_coding",
      gene_name : "BCCIP",
      gene_level : 2,
      hgnc_id : "HGNC:978",
      havana_gene : "OTTHUMG00000019237.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125836337,
      stop : 125896436,
      direction : "-",
      ID : "ENSG00000089876.12",
      gene_id : "ENSG00000089876.12",
      gene_type : "protein_coding",
      gene_name : "DHX32",
      gene_level : 2,
      hgnc_id : "HGNC:16717",
      havana_gene : "OTTHUMG00000019238.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 125896564,
      stop : 126009592,
      direction : "+",
      ID : "ENSG00000203780.12",
      gene_id : "ENSG00000203780.12",
      gene_type : "protein_coding",
      gene_name : "FANK1",
      gene_level : 2,
      hgnc_id : "HGNC:23527",
      havana_gene : "OTTHUMG00000019241.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 126012381,
      stop : 126388455,
      direction : "-",
      ID : "ENSG00000148848.14",
      gene_id : "ENSG00000148848.14",
      gene_type : "protein_coding",
      gene_name : "ADAM12",
      gene_level : 2,
      hgnc_id : "HGNC:190",
      havana_gene : "OTTHUMG00000019243.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 126424997,
      stop : 126798708,
      direction : "-",
      ID : "ENSG00000154493.19",
      gene_id : "ENSG00000154493.19",
      gene_type : "protein_coding",
      gene_name : "C10orf90",
      gene_level : 1,
      hgnc_id : "HGNC:26563",
      havana_gene : "OTTHUMG00000019245.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 126905409,
      stop : 127452517,
      direction : "+",
      ID : "ENSG00000150760.13",
      gene_id : "ENSG00000150760.13",
      gene_type : "protein_coding",
      gene_name : "DOCK1",
      gene_level : 2,
      hgnc_id : "HGNC:2987",
      havana_gene : "OTTHUMG00000019249.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 127135426,
      stop : 127196591,
      direction : "-",
      ID : "ENSG00000188916.9",
      gene_id : "ENSG00000188916.9",
      gene_type : "protein_coding",
      gene_name : "INSYN2A",
      gene_level : 2,
      hgnc_id : "HGNC:33859",
      havana_gene : "OTTHUMG00000019248.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 127549309,
      stop : 127553540,
      direction : "+",
      ID : "ENSG00000214285.3",
      gene_id : "ENSG00000214285.3",
      gene_type : "protein_coding",
      gene_name : "NPS",
      gene_level : 2,
      hgnc_id : "HGNC:33940",
      havana_gene : "OTTHUMG00000188145.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 127737185,
      stop : 127741183,
      direction : "+",
      ID : "ENSG00000186766.8",
      gene_id : "ENSG00000186766.8",
      gene_type : "protein_coding",
      gene_name : "FOXI2",
      gene_level : 2,
      hgnc_id : "HGNC:32448",
      havana_gene : "OTTHUMG00000019250.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 127877841,
      stop : 127892941,
      direction : "-",
      ID : "ENSG00000180745.5",
      gene_id : "ENSG00000180745.5",
      gene_type : "protein_coding",
      gene_name : "CLRN3",
      gene_level : 2,
      hgnc_id : "HGNC:20795",
      havana_gene : "OTTHUMG00000019253.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 127907103,
      stop : 128085855,
      direction : "+",
      ID : "ENSG00000132334.17",
      gene_id : "ENSG00000132334.17",
      gene_type : "protein_coding",
      gene_name : "PTPRE",
      gene_level : 2,
      hgnc_id : "HGNC:9669",
      havana_gene : "OTTHUMG00000019254.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 128096659,
      stop : 128126423,
      direction : "-",
      ID : "ENSG00000148773.14",
      gene_id : "ENSG00000148773.14",
      gene_type : "protein_coding",
      gene_name : "MKI67",
      gene_level : 2,
      hgnc_id : "HGNC:7107",
      havana_gene : "OTTHUMG00000019255.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 129467190,
      stop : 129770983,
      direction : "+",
      ID : "ENSG00000170430.10",
      gene_id : "ENSG00000170430.10",
      gene_type : "protein_coding",
      gene_name : "MGMT",
      gene_level : 2,
      hgnc_id : "HGNC:7059",
      havana_gene : "OTTHUMG00000019261.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 129835233,
      stop : 129973053,
      direction : "-",
      ID : "ENSG00000108001.15",
      gene_id : "ENSG00000108001.15",
      gene_type : "protein_coding",
      gene_name : "EBF3",
      gene_level : 2,
      hgnc_id : "HGNC:19087",
      havana_gene : "OTTHUMG00000019265.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 130020025,
      stop : 130110830,
      direction : "-",
      ID : "ENSG00000237489.5",
      gene_id : "ENSG00000237489.5",
      gene_type : "protein_coding",
      gene_name : "C10orf143",
      gene_level : 2,
      hgnc_id : "HGNC:48677",
      havana_gene : "OTTHUMG00000019268.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 130136391,
      stop : 130184521,
      direction : "+",
      ID : "ENSG00000108010.12",
      gene_id : "ENSG00000108010.12",
      gene_type : "protein_coding",
      gene_name : "GLRX3",
      gene_level : 2,
      hgnc_id : "HGNC:15987",
      havana_gene : "OTTHUMG00000019267.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 131092391,
      stop : 131311721,
      direction : "-",
      ID : "ENSG00000176769.9",
      gene_id : "ENSG00000176769.9",
      gene_type : "protein_coding",
      gene_name : "TCERG1L",
      gene_level : 2,
      hgnc_id : "HGNC:23533",
      havana_gene : "OTTHUMG00000019276.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 131901008,
      stop : 131959834,
      direction : "+",
      ID : "ENSG00000175470.20",
      gene_id : "ENSG00000175470.20",
      gene_type : "protein_coding",
      gene_name : "PPP2R2D",
      gene_level : 2,
      hgnc_id : "HGNC:23732",
      havana_gene : "OTTHUMG00000019277.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 131966455,
      stop : 131982013,
      direction : "-",
      ID : "ENSG00000176171.11",
      gene_id : "ENSG00000176171.11",
      gene_type : "protein_coding",
      gene_name : "BNIP3",
      gene_level : 2,
      hgnc_id : "HGNC:1084",
      havana_gene : "OTTHUMG00000019278.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132036336,
      stop : 132184858,
      direction : "+",
      ID : "ENSG00000188385.12",
      gene_id : "ENSG00000188385.12",
      gene_type : "protein_coding",
      gene_name : "JAKMIP3",
      gene_level : 2,
      hgnc_id : "HGNC:23523",
      havana_gene : "OTTHUMG00000150167.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132186948,
      stop : 132205759,
      direction : "+",
      ID : "ENSG00000151640.13",
      gene_id : "ENSG00000151640.13",
      gene_type : "protein_coding",
      gene_name : "DPYSL4",
      gene_level : 2,
      hgnc_id : "HGNC:3016",
      havana_gene : "OTTHUMG00000019283.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132207492,
      stop : 132331847,
      direction : "-",
      ID : "ENSG00000165752.17",
      gene_id : "ENSG00000165752.17",
      gene_type : "protein_coding",
      gene_name : "STK32C",
      gene_level : 2,
      hgnc_id : "HGNC:21332",
      havana_gene : "OTTHUMG00000019285.10",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132332154,
      stop : 132381508,
      direction : "+",
      ID : "ENSG00000148814.18",
      gene_id : "ENSG00000148814.18",
      gene_type : "protein_coding",
      gene_name : "LRRC27",
      gene_level : 2,
      hgnc_id : "HGNC:29346",
      havana_gene : "OTTHUMG00000019284.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132397168,
      stop : 132417859,
      direction : "+",
      ID : "ENSG00000171813.14",
      gene_id : "ENSG00000171813.14",
      gene_type : "protein_coding",
      gene_name : "PWWP2B",
      gene_level : 2,
      hgnc_id : "HGNC:25150",
      havana_gene : "OTTHUMG00000019286.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132537787,
      stop : 132783480,
      direction : "+",
      ID : "ENSG00000068383.19",
      gene_id : "ENSG00000068383.19",
      gene_type : "protein_coding",
      gene_name : "INPP5A",
      gene_level : 2,
      hgnc_id : "HGNC:6076",
      havana_gene : "OTTHUMG00000019293.6",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132783179,
      stop : 132786147,
      direction : "-",
      ID : "ENSG00000148826.9",
      gene_id : "ENSG00000148826.9",
      gene_type : "protein_coding",
      gene_name : "NKX6-2",
      gene_level : 2,
      hgnc_id : "HGNC:19321",
      havana_gene : "OTTHUMG00000019294.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 132808392,
      stop : 132942823,
      direction : "-",
      ID : "ENSG00000171811.14",
      gene_id : "ENSG00000171811.14",
      gene_type : "protein_coding",
      gene_name : "CFAP46",
      gene_level : 1,
      hgnc_id : "HGNC:25247",
      havana_gene : "OTTHUMG00000019292.8",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133070929,
      stop : 133131675,
      direction : "+",
      ID : "ENSG00000197177.15",
      gene_id : "ENSG00000197177.15",
      gene_type : "protein_coding",
      gene_name : "ADGRA1",
      gene_level : 1,
      hgnc_id : "HGNC:13838",
      havana_gene : "OTTHUMG00000019304.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133160219,
      stop : 133226412,
      direction : "+",
      ID : "ENSG00000171798.18",
      gene_id : "ENSG00000171798.18",
      gene_type : "protein_coding",
      gene_name : "KNDC1",
      gene_level : 2,
      hgnc_id : "HGNC:29374",
      havana_gene : "OTTHUMG00000019303.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133230217,
      stop : 133231558,
      direction : "+",
      ID : "ENSG00000171794.4",
      gene_id : "ENSG00000171794.4",
      gene_type : "protein_coding",
      gene_name : "UTF1",
      gene_level : 2,
      hgnc_id : "HGNC:12634",
      havana_gene : "OTTHUMG00000019302.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133237855,
      stop : 133241928,
      direction : "+",
      ID : "ENSG00000151650.8",
      gene_id : "ENSG00000151650.8",
      gene_type : "protein_coding",
      gene_name : "VENTX",
      gene_level : 2,
      hgnc_id : "HGNC:13639",
      havana_gene : "OTTHUMG00000019307.5",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133262420,
      stop : 133276868,
      direction : "-",
      ID : "ENSG00000151651.16",
      gene_id : "ENSG00000151651.16",
      gene_type : "protein_coding",
      gene_name : "ADAM8",
      gene_level : 1,
      hgnc_id : "HGNC:215",
      havana_gene : "OTTHUMG00000019309.7",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133278635,
      stop : 133312337,
      direction : "-",
      ID : "ENSG00000130640.14",
      gene_id : "ENSG00000130640.14",
      gene_type : "protein_coding",
      gene_name : "TUBGCP2",
      gene_level : 2,
      hgnc_id : "HGNC:18599",
      havana_gene : "OTTHUMG00000019319.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133308914,
      stop : 133313162,
      direction : "+",
      ID : "ENSG00000198546.15",
      gene_id : "ENSG00000198546.15",
      gene_type : "protein_coding",
      gene_name : "ZNF511",
      gene_level : 2,
      hgnc_id : "HGNC:28445",
      havana_gene : "OTTHUMG00000019317.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133309410,
      stop : 133352529,
      direction : "+",
      ID : "ENSG00000283496.1",
      gene_id : "ENSG00000283496.1",
      gene_type : "protein_coding",
      gene_name : "ZNF511-PRAP1",
      gene_level : 2,
      hgnc_id : "HGNC:38088",
      havana_gene : "OTTHUMG00000191874.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133324072,
      stop : 133336935,
      direction : "-",
      ID : "ENSG00000130643.9",
      gene_id : "ENSG00000130643.9",
      gene_type : "protein_coding",
      gene_name : "CALY",
      gene_level : 2,
      hgnc_id : "HGNC:17938",
      havana_gene : "OTTHUMG00000019310.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133347368,
      stop : 133352683,
      direction : "+",
      ID : "ENSG00000165828.15",
      gene_id : "ENSG00000165828.15",
      gene_type : "protein_coding",
      gene_name : "PRAP1",
      gene_level : 2,
      hgnc_id : "HGNC:23304",
      havana_gene : "OTTHUMG00000019312.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133355158,
      stop : 133358025,
      direction : "-",
      ID : "ENSG00000148803.12",
      gene_id : "ENSG00000148803.12",
      gene_type : "protein_coding",
      gene_name : "FUOM",
      gene_level : 2,
      hgnc_id : "HGNC:24733",
      havana_gene : "OTTHUMG00000019315.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133362485,
      stop : 133373354,
      direction : "-",
      ID : "ENSG00000127884.5",
      gene_id : "ENSG00000127884.5",
      gene_type : "protein_coding",
      gene_name : "ECHS1",
      gene_level : 2,
      hgnc_id : "HGNC:3151",
      havana_gene : "OTTHUMG00000019320.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133379261,
      stop : 133391694,
      direction : "+",
      ID : "ENSG00000148832.16",
      gene_id : "ENSG00000148832.16",
      gene_type : "protein_coding",
      gene_name : "PAOX",
      gene_level : 2,
      hgnc_id : "HGNC:20837",
      havana_gene : "OTTHUMG00000019318.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133380017,
      stop : 133420271,
      direction : "+",
      ID : "ENSG00000254536.2",
      gene_id : "ENSG00000254536.2",
      gene_type : "protein_coding",
      gene_name : "AL360181.3",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000019323.3",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133394094,
      stop : 133422520,
      direction : "+",
      ID : "ENSG00000148824.19",
      gene_id : "ENSG00000148824.19",
      gene_type : "protein_coding",
      gene_name : "MTG1",
      gene_level : 2,
      hgnc_id : "HGNC:32159",
      havana_gene : "OTTHUMG00000166564.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133420666,
      stop : 133424572,
      direction : "-",
      ID : "ENSG00000203772.7",
      gene_id : "ENSG00000203772.7",
      gene_type : "protein_coding",
      gene_name : "SPRN",
      gene_level : 2,
      hgnc_id : "HGNC:16871",
      havana_gene : "OTTHUMG00000019324.2",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133453928,
      stop : 133523558,
      direction : "+",
      ID : "ENSG00000214279.13",
      gene_id : "ENSG00000214279.13",
      gene_type : "protein_coding",
      gene_name : "SCART1",
      gene_level : 2,
      hgnc_id : "HGNC:32411",
      havana_gene : "OTTHUMG00000019326.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133520406,
      stop : 133561220,
      direction : "+",
      ID : "ENSG00000130649.10",
      gene_id : "ENSG00000130649.10",
      gene_type : "protein_coding",
      gene_name : "CYP2E1",
      gene_level : 2,
      hgnc_id : "HGNC:2631",
      havana_gene : "OTTHUMG00000019322.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133553901,
      stop : 133569835,
      direction : "-",
      ID : "ENSG00000171772.17",
      gene_id : "ENSG00000171772.17",
      gene_type : "protein_coding",
      gene_name : "SYCE1",
      gene_level : 2,
      hgnc_id : "HGNC:28852",
      havana_gene : "OTTHUMG00000019321.4",
      tag : null
    },
    {
      chromosome : 10,
      annotation : "HAVANA",
      type : "gene",
      start : 133623895,
      stop : 133626795,
      direction : "-",
      ID : "ENSG00000225899.8",
      gene_id : "ENSG00000225899.8",
      gene_type : "protein_coding",
      gene_name : "FRG2B",
      gene_level : 2,
      hgnc_id : "HGNC:33518",
      havana_gene : "OTTHUMG00000019328.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 167784,
      stop : 207428,
      direction : "-",
      ID : "ENSG00000177951.17",
      gene_id : "ENSG00000177951.17",
      gene_type : "protein_coding",
      gene_name : "BET1L",
      gene_level : 2,
      hgnc_id : "HGNC:19348",
      havana_gene : "OTTHUMG00000119071.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 193078,
      stop : 194575,
      direction : "+",
      ID : "ENSG00000188076.3",
      gene_id : "ENSG00000188076.3",
      gene_type : "protein_coding",
      gene_name : "SCGB1C1",
      gene_level : 2,
      hgnc_id : "HGNC:18394",
      havana_gene : "OTTHUMG00000165539.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 196761,
      stop : 200261,
      direction : "+",
      ID : "ENSG00000177947.14",
      gene_id : "ENSG00000177947.14",
      gene_type : "protein_coding",
      gene_name : "ODF3",
      gene_level : 2,
      hgnc_id : "HGNC:19905",
      havana_gene : "OTTHUMG00000119073.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 207511,
      stop : 215113,
      direction : "+",
      ID : "ENSG00000177963.14",
      gene_id : "ENSG00000177963.14",
      gene_type : "protein_coding",
      gene_name : "RIC8A",
      gene_level : 1,
      hgnc_id : "HGNC:29550",
      havana_gene : "OTTHUMG00000119069.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 215030,
      stop : 236931,
      direction : "-",
      ID : "ENSG00000142082.15",
      gene_id : "ENSG00000142082.15",
      gene_type : "protein_coding",
      gene_name : "SIRT3",
      gene_level : 1,
      hgnc_id : "HGNC:14931",
      havana_gene : "OTTHUMG00000119074.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 236966,
      stop : 252984,
      direction : "+",
      ID : "ENSG00000185627.18",
      gene_id : "ENSG00000185627.18",
      gene_type : "protein_coding",
      gene_name : "PSMD13",
      gene_level : 2,
      hgnc_id : "HGNC:9558",
      havana_gene : "OTTHUMG00000119072.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 278407,
      stop : 285388,
      direction : "+",
      ID : "ENSG00000174885.13",
      gene_id : "ENSG00000174885.13",
      gene_type : "protein_coding",
      gene_name : "NLRP6",
      gene_level : 2,
      hgnc_id : "HGNC:22944",
      havana_gene : "OTTHUMG00000119070.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 289126,
      stop : 296107,
      direction : "+",
      ID : "ENSG00000142102.16",
      gene_id : "ENSG00000142102.16",
      gene_type : "protein_coding",
      gene_name : "PGGHG",
      gene_level : 1,
      hgnc_id : "HGNC:26210",
      havana_gene : "OTTHUMG00000153218.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 298200,
      stop : 299526,
      direction : "-",
      ID : "ENSG00000206013.2",
      gene_id : "ENSG00000206013.2",
      gene_type : "protein_coding",
      gene_name : "IFITM5",
      gene_level : 2,
      hgnc_id : "HGNC:16644",
      havana_gene : "OTTHUMG00000165355.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 303655,
      stop : 309397,
      direction : "+",
      ID : "ENSG00000185201.17",
      gene_id : "ENSG00000185201.17",
      gene_type : "protein_coding",
      gene_name : "IFITM2",
      gene_level : 2,
      hgnc_id : "HGNC:5413",
      havana_gene : "OTTHUMG00000165357.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 308408,
      stop : 315272,
      direction : "+",
      ID : "ENSG00000288681.1",
      gene_id : "ENSG00000288681.1",
      gene_type : "protein_coding",
      gene_name : "AC136475.9",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 310041,
      stop : 315272,
      direction : "+",
      ID : "ENSG00000185885.17",
      gene_id : "ENSG00000185885.17",
      gene_type : "protein_coding",
      gene_name : "IFITM1",
      gene_level : 2,
      hgnc_id : "HGNC:5412",
      havana_gene : "OTTHUMG00000165359.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 319676,
      stop : 329475,
      direction : "-",
      ID : "ENSG00000142089.17",
      gene_id : "ENSG00000142089.17",
      gene_type : "protein_coding",
      gene_name : "IFITM3",
      gene_level : 1,
      hgnc_id : "HGNC:5414",
      havana_gene : "OTTHUMG00000165542.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 369499,
      stop : 382117,
      direction : "+",
      ID : "ENSG00000182272.12",
      gene_id : "ENSG00000182272.12",
      gene_type : "protein_coding",
      gene_name : "B4GALNT4",
      gene_level : 2,
      hgnc_id : "HGNC:26315",
      havana_gene : "OTTHUMG00000119075.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 392614,
      stop : 404908,
      direction : "+",
      ID : "ENSG00000184363.10",
      gene_id : "ENSG00000184363.10",
      gene_type : "protein_coding",
      gene_name : "PKP3",
      gene_level : 2,
      hgnc_id : "HGNC:9025",
      havana_gene : "OTTHUMG00000119068.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 405716,
      stop : 417455,
      direction : "-",
      ID : "ENSG00000185187.13",
      gene_id : "ENSG00000185187.13",
      gene_type : "protein_coding",
      gene_name : "SIGIRR",
      gene_level : 1,
      hgnc_id : "HGNC:30575",
      havana_gene : "OTTHUMG00000165412.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 417933,
      stop : 442011,
      direction : "-",
      ID : "ENSG00000185101.13",
      gene_id : "ENSG00000185101.13",
      gene_type : "protein_coding",
      gene_name : "ANO9",
      gene_level : 2,
      hgnc_id : "HGNC:20679",
      havana_gene : "OTTHUMG00000165446.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 448268,
      stop : 491399,
      direction : "+",
      ID : "ENSG00000174915.12",
      gene_id : "ENSG00000174915.12",
      gene_type : "protein_coding",
      gene_name : "PTDSS2",
      gene_level : 2,
      hgnc_id : "HGNC:15463",
      havana_gene : "OTTHUMG00000119087.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 494512,
      stop : 507300,
      direction : "-",
      ID : "ENSG00000023191.17",
      gene_id : "ENSG00000023191.17",
      gene_type : "protein_coding",
      gene_name : "RNH1",
      gene_level : 2,
      hgnc_id : "HGNC:10074",
      havana_gene : "OTTHUMG00000119086.10",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 532242,
      stop : 537287,
      direction : "-",
      ID : "ENSG00000174775.17",
      gene_id : "ENSG00000174775.17",
      gene_type : "protein_coding",
      gene_name : "HRAS",
      gene_level : 2,
      hgnc_id : "HGNC:5173",
      havana_gene : "OTTHUMG00000131919.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 537527,
      stop : 554912,
      direction : "+",
      ID : "ENSG00000161328.11",
      gene_id : "ENSG00000161328.11",
      gene_type : "protein_coding",
      gene_name : "LRRC56",
      gene_level : 2,
      hgnc_id : "HGNC:25430",
      havana_gene : "OTTHUMG00000132003.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 554850,
      stop : 560738,
      direction : "-",
      ID : "ENSG00000185522.9",
      gene_id : "ENSG00000185522.9",
      gene_type : "protein_coding",
      gene_name : "LMNTD2",
      gene_level : 1,
      hgnc_id : "HGNC:28561",
      havana_gene : "OTTHUMG00000132005.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 560404,
      stop : 564025,
      direction : "+",
      ID : "ENSG00000099849.15",
      gene_id : "ENSG00000099849.15",
      gene_type : "protein_coding",
      gene_name : "RASSF7",
      gene_level : 2,
      hgnc_id : "HGNC:1166",
      havana_gene : "OTTHUMG00000132004.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 576470,
      stop : 612222,
      direction : "+",
      ID : "ENSG00000070047.13",
      gene_id : "ENSG00000070047.13",
      gene_type : "protein_coding",
      gene_name : "PHRF1",
      gene_level : 2,
      hgnc_id : "HGNC:24351",
      havana_gene : "OTTHUMG00000165141.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 612553,
      stop : 615983,
      direction : "-",
      ID : "ENSG00000185507.21",
      gene_id : "ENSG00000185507.21",
      gene_type : "protein_coding",
      gene_name : "IRF7",
      gene_level : 2,
      hgnc_id : "HGNC:6122",
      havana_gene : "OTTHUMG00000132019.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 616577,
      stop : 626078,
      direction : "-",
      ID : "ENSG00000099834.19",
      gene_id : "ENSG00000099834.19",
      gene_type : "protein_coding",
      gene_name : "CDHR5",
      gene_level : 2,
      hgnc_id : "HGNC:7521",
      havana_gene : "OTTHUMG00000132018.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 626309,
      stop : 627181,
      direction : "-",
      ID : "ENSG00000070031.4",
      gene_id : "ENSG00000070031.4",
      gene_type : "protein_coding",
      gene_name : "SCT",
      gene_level : 2,
      hgnc_id : "HGNC:10607",
      havana_gene : "OTTHUMG00000133313.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 637269,
      stop : 640706,
      direction : "+",
      ID : "ENSG00000069696.7",
      gene_id : "ENSG00000069696.7",
      gene_type : "protein_coding",
      gene_name : "DRD4",
      gene_level : 2,
      hgnc_id : "HGNC:3025",
      havana_gene : "OTTHUMG00000133312.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 644233,
      stop : 706715,
      direction : "-",
      ID : "ENSG00000177030.17",
      gene_id : "ENSG00000177030.17",
      gene_type : "protein_coding",
      gene_name : "DEAF1",
      gene_level : 1,
      hgnc_id : "HGNC:14677",
      havana_gene : "OTTHUMG00000165363.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 694438,
      stop : 727727,
      direction : "+",
      ID : "ENSG00000177106.16",
      gene_id : "ENSG00000177106.16",
      gene_type : "protein_coding",
      gene_name : "EPS8L2",
      gene_level : 1,
      hgnc_id : "HGNC:21296",
      havana_gene : "OTTHUMG00000165165.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 695428,
      stop : 705028,
      direction : "+",
      ID : "ENSG00000177042.15",
      gene_id : "ENSG00000177042.15",
      gene_type : "protein_coding",
      gene_name : "TMEM80",
      gene_level : 1,
      hgnc_id : "HGNC:27453",
      havana_gene : "OTTHUMG00000133307.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 747415,
      stop : 765012,
      direction : "+",
      ID : "ENSG00000177156.11",
      gene_id : "ENSG00000177156.11",
      gene_type : "protein_coding",
      gene_name : "TALDO1",
      gene_level : 1,
      hgnc_id : "HGNC:11559",
      havana_gene : "OTTHUMG00000133318.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 767220,
      stop : 777488,
      direction : "-",
      ID : "ENSG00000177225.17",
      gene_id : "ENSG00000177225.17",
      gene_type : "protein_coding",
      gene_name : "GATD1",
      gene_level : 1,
      hgnc_id : "HGNC:26616",
      havana_gene : "OTTHUMG00000133315.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 787115,
      stop : 790113,
      direction : "-",
      ID : "ENSG00000184524.6",
      gene_id : "ENSG00000184524.6",
      gene_type : "protein_coding",
      gene_name : "CEND1",
      gene_level : 2,
      hgnc_id : "HGNC:24153",
      havana_gene : "OTTHUMG00000133308.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 790475,
      stop : 798281,
      direction : "-",
      ID : "ENSG00000177542.11",
      gene_id : "ENSG00000177542.11",
      gene_type : "protein_coding",
      gene_name : "SLC25A22",
      gene_level : 2,
      hgnc_id : "HGNC:19954",
      havana_gene : "OTTHUMG00000133310.12",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 797511,
      stop : 799190,
      direction : "+",
      ID : "ENSG00000288675.1",
      gene_id : "ENSG00000288675.1",
      gene_type : "protein_coding",
      gene_name : "AP006621.6",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000189301.4",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 799179,
      stop : 809753,
      direction : "-",
      ID : "ENSG00000177595.18",
      gene_id : "ENSG00000177595.18",
      gene_type : "protein_coding",
      gene_name : "PIDD1",
      gene_level : 2,
      hgnc_id : "HGNC:16491",
      havana_gene : "OTTHUMG00000133306.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 809965,
      stop : 812880,
      direction : "+",
      ID : "ENSG00000177600.9",
      gene_id : "ENSG00000177600.9",
      gene_type : "protein_coding",
      gene_name : "RPLP2",
      gene_level : 2,
      hgnc_id : "HGNC:10377",
      havana_gene : "OTTHUMG00000133317.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 818914,
      stop : 825573,
      direction : "+",
      ID : "ENSG00000177666.17",
      gene_id : "ENSG00000177666.17",
      gene_type : "protein_coding",
      gene_name : "PNPLA2",
      gene_level : 2,
      hgnc_id : "HGNC:30802",
      havana_gene : "OTTHUMG00000133309.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 826144,
      stop : 831991,
      direction : "+",
      ID : "ENSG00000177685.17",
      gene_id : "ENSG00000177685.17",
      gene_type : "protein_coding",
      gene_name : "CRACR2B",
      gene_level : 2,
      hgnc_id : "HGNC:28703",
      havana_gene : "OTTHUMG00000165267.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 832887,
      stop : 839831,
      direction : "+",
      ID : "ENSG00000177697.19",
      gene_id : "ENSG00000177697.19",
      gene_type : "protein_coding",
      gene_name : "CD151",
      gene_level : 1,
      hgnc_id : "HGNC:1630",
      havana_gene : "OTTHUMG00000133311.10",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 837356,
      stop : 842529,
      direction : "-",
      ID : "ENSG00000177700.6",
      gene_id : "ENSG00000177700.6",
      gene_type : "protein_coding",
      gene_name : "POLR2L",
      gene_level : 2,
      hgnc_id : "HGNC:9199",
      havana_gene : "OTTHUMG00000133316.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 842812,
      stop : 867116,
      direction : "+",
      ID : "ENSG00000214063.11",
      gene_id : "ENSG00000214063.11",
      gene_type : "protein_coding",
      gene_name : "TSPAN4",
      gene_level : 2,
      hgnc_id : "HGNC:11859",
      havana_gene : "OTTHUMG00000133305.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 867859,
      stop : 915058,
      direction : "-",
      ID : "ENSG00000177830.18",
      gene_id : "ENSG00000177830.18",
      gene_type : "protein_coding",
      gene_name : "CHID1",
      gene_level : 2,
      hgnc_id : "HGNC:28474",
      havana_gene : "OTTHUMG00000133314.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 924894,
      stop : 1012245,
      direction : "+",
      ID : "ENSG00000183020.14",
      gene_id : "ENSG00000183020.14",
      gene_type : "protein_coding",
      gene_name : "AP2A2",
      gene_level : 1,
      hgnc_id : "HGNC:562",
      havana_gene : "OTTHUMG00000165627.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1012823,
      stop : 1036718,
      direction : "-",
      ID : "ENSG00000184956.16",
      gene_id : "ENSG00000184956.16",
      gene_type : "protein_coding",
      gene_name : "MUC6",
      gene_level : 2,
      hgnc_id : "HGNC:7517",
      havana_gene : "OTTHUMG00000165140.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1074875,
      stop : 1110511,
      direction : "+",
      ID : "ENSG00000198788.9",
      gene_id : "ENSG00000198788.9",
      gene_type : "protein_coding",
      gene_name : "MUC2",
      gene_level : 2,
      hgnc_id : "HGNC:7512",
      havana_gene : "OTTHUMG00000156800.4",
      tag : "reference_genome_error"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1157953,
      stop : 1201138,
      direction : "+",
      ID : "ENSG00000215182.8",
      gene_id : "ENSG00000215182.8",
      gene_type : "protein_coding",
      gene_name : "MUC5AC",
      gene_level : 1,
      hgnc_id : "HGNC:7515",
      havana_gene : "OTTHUMG00000154270.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1223066,
      stop : 1262172,
      direction : "+",
      ID : "ENSG00000117983.17",
      gene_id : "ENSG00000117983.17",
      gene_type : "protein_coding",
      gene_name : "MUC5B",
      gene_level : 2,
      hgnc_id : "HGNC:7516",
      havana_gene : "OTTHUMG00000166494.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1274371,
      stop : 1309654,
      direction : "-",
      ID : "ENSG00000078902.16",
      gene_id : "ENSG00000078902.16",
      gene_type : "protein_coding",
      gene_name : "TOLLIP",
      gene_level : 1,
      hgnc_id : "HGNC:16476",
      havana_gene : "OTTHUMG00000133333.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1389899,
      stop : 1462689,
      direction : "+",
      ID : "ENSG00000174672.16",
      gene_id : "ENSG00000174672.16",
      gene_type : "protein_coding",
      gene_name : "BRSK2",
      gene_level : 2,
      hgnc_id : "HGNC:11405",
      havana_gene : "OTTHUMG00000167089.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1469457,
      stop : 1501247,
      direction : "-",
      ID : "ENSG00000182208.14",
      gene_id : "ENSG00000182208.14",
      gene_type : "protein_coding",
      gene_name : "MOB2",
      gene_level : 1,
      hgnc_id : "HGNC:24904",
      havana_gene : "OTTHUMG00000165545.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1554051,
      stop : 1572271,
      direction : "-",
      ID : "ENSG00000184545.11",
      gene_id : "ENSG00000184545.11",
      gene_type : "protein_coding",
      gene_name : "DUSP8",
      gene_level : 2,
      hgnc_id : "HGNC:3074",
      havana_gene : "OTTHUMG00000133348.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1584342,
      stop : 1585283,
      direction : "-",
      ID : "ENSG00000205869.2",
      gene_id : "ENSG00000205869.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-1",
      gene_level : 2,
      hgnc_id : "HGNC:23596",
      havana_gene : "OTTHUMG00000057557.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1597177,
      stop : 1598294,
      direction : "-",
      ID : "ENSG00000205867.3",
      gene_id : "ENSG00000205867.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-2",
      gene_level : 2,
      hgnc_id : "HGNC:23597",
      havana_gene : "OTTHUMG00000165547.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1607565,
      stop : 1608463,
      direction : "-",
      ID : "ENSG00000196224.7",
      gene_id : "ENSG00000196224.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-3",
      gene_level : 2,
      hgnc_id : "HGNC:23598",
      havana_gene : "OTTHUMG00000057559.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1620958,
      stop : 1622138,
      direction : "-",
      ID : "ENSG00000241598.5",
      gene_id : "ENSG00000241598.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-4",
      gene_level : 2,
      hgnc_id : "HGNC:23599",
      havana_gene : "OTTHUMG00000057553.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1629775,
      stop : 1630707,
      direction : "+",
      ID : "ENSG00000185940.10",
      gene_id : "ENSG00000185940.10",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-5",
      gene_level : 2,
      hgnc_id : "HGNC:23601",
      havana_gene : "OTTHUMG00000057554.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1697195,
      stop : 1697755,
      direction : "+",
      ID : "ENSG00000205864.1",
      gene_id : "ENSG00000205864.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-6",
      gene_level : 2,
      hgnc_id : "HGNC:23600",
      havana_gene : "OTTHUMG00000043932.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1732406,
      stop : 1750595,
      direction : "-",
      ID : "ENSG00000244242.2",
      gene_id : "ENSG00000244242.2",
      gene_type : "protein_coding",
      gene_name : "IFITM10",
      gene_level : 1,
      hgnc_id : "HGNC:40022",
      havana_gene : "OTTHUMG00000043933.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1734821,
      stop : 1763954,
      direction : "-",
      ID : "ENSG00000250644.3",
      gene_id : "ENSG00000250644.3",
      gene_type : "protein_coding",
      gene_name : "AC068580.4",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000161994.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1752752,
      stop : 1764573,
      direction : "-",
      ID : "ENSG00000117984.15",
      gene_id : "ENSG00000117984.15",
      gene_type : "protein_coding",
      gene_name : "CTSD",
      gene_level : 1,
      hgnc_id : "HGNC:2529",
      havana_gene : "OTTHUMG00000044760.24",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1828307,
      stop : 1837521,
      direction : "+",
      ID : "ENSG00000149043.16",
      gene_id : "ENSG00000149043.16",
      gene_type : "protein_coding",
      gene_name : "SYT8",
      gene_level : 1,
      hgnc_id : "HGNC:19264",
      havana_gene : "OTTHUMG00000009026.15",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1838981,
      stop : 1841680,
      direction : "+",
      ID : "ENSG00000130598.16",
      gene_id : "ENSG00000130598.16",
      gene_type : "protein_coding",
      gene_name : "TNNI2",
      gene_level : 2,
      hgnc_id : "HGNC:11946",
      havana_gene : "OTTHUMG00000012253.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1850904,
      stop : 1892267,
      direction : "+",
      ID : "ENSG00000130592.17",
      gene_id : "ENSG00000130592.17",
      gene_type : "protein_coding",
      gene_name : "LSP1",
      gene_level : 1,
      hgnc_id : "HGNC:6707",
      havana_gene : "OTTHUMG00000012252.24",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1888078,
      stop : 1891895,
      direction : "-",
      ID : "ENSG00000283787.2",
      gene_id : "ENSG00000283787.2",
      gene_type : "protein_coding",
      gene_name : "PRR33",
      gene_level : 2,
      hgnc_id : "HGNC:35118",
      havana_gene : "OTTHUMG00000191981.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1919703,
      stop : 1938706,
      direction : "+",
      ID : "ENSG00000130595.19",
      gene_id : "ENSG00000130595.19",
      gene_type : "protein_coding",
      gene_name : "TNNT3",
      gene_level : 2,
      hgnc_id : "HGNC:11950",
      havana_gene : "OTTHUMG00000012475.29",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 1947278,
      stop : 1984522,
      direction : "+",
      ID : "ENSG00000214026.11",
      gene_id : "ENSG00000214026.11",
      gene_type : "protein_coding",
      gene_name : "MRPL23",
      gene_level : 1,
      hgnc_id : "HGNC:10322",
      havana_gene : "OTTHUMG00000012476.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2129112,
      stop : 2141238,
      direction : "-",
      ID : "ENSG00000167244.21",
      gene_id : "ENSG00000167244.21",
      gene_type : "protein_coding",
      gene_name : "IGF2",
      gene_level : 2,
      hgnc_id : "HGNC:5466",
      havana_gene : "OTTHUMG00000009395.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2129112,
      stop : 2158391,
      direction : "-",
      ID : "ENSG00000284779.2",
      gene_id : "ENSG00000284779.2",
      gene_type : "protein_coding",
      gene_name : "AC132217.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000166213.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2132538,
      stop : 2161209,
      direction : "-",
      ID : "ENSG00000129965.15",
      gene_id : "ENSG00000129965.15",
      gene_type : "protein_coding",
      gene_name : "INS-IGF2",
      gene_level : 2,
      hgnc_id : "HGNC:33527",
      havana_gene : "OTTHUMG00000192523.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2159779,
      stop : 2161221,
      direction : "-",
      ID : "ENSG00000254647.7",
      gene_id : "ENSG00000254647.7",
      gene_type : "protein_coding",
      gene_name : "INS",
      gene_level : 2,
      hgnc_id : "HGNC:6081",
      havana_gene : "OTTHUMG00000009558.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2163929,
      stop : 2171815,
      direction : "-",
      ID : "ENSG00000180176.15",
      gene_id : "ENSG00000180176.15",
      gene_type : "protein_coding",
      gene_name : "TH",
      gene_level : 2,
      hgnc_id : "HGNC:11782",
      havana_gene : "OTTHUMG00000009559.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2268498,
      stop : 2270588,
      direction : "-",
      ID : "ENSG00000183734.5",
      gene_id : "ENSG00000183734.5",
      gene_type : "protein_coding",
      gene_name : "ASCL2",
      gene_level : 2,
      hgnc_id : "HGNC:739",
      havana_gene : "OTTHUMG00000009648.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2295628,
      stop : 2303049,
      direction : "-",
      ID : "ENSG00000110665.12",
      gene_id : "ENSG00000110665.12",
      gene_type : "protein_coding",
      gene_name : "C11orf21",
      gene_level : 1,
      hgnc_id : "HGNC:13231",
      havana_gene : "OTTHUMG00000009759.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2301997,
      stop : 2318204,
      direction : "+",
      ID : "ENSG00000064201.16",
      gene_id : "ENSG00000064201.16",
      gene_type : "protein_coding",
      gene_name : "TSPAN32",
      gene_level : 2,
      hgnc_id : "HGNC:13410",
      havana_gene : "OTTHUMG00000009762.20",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2376177,
      stop : 2397397,
      direction : "+",
      ID : "ENSG00000110651.12",
      gene_id : "ENSG00000110651.12",
      gene_type : "protein_coding",
      gene_name : "CD81",
      gene_level : 1,
      hgnc_id : "HGNC:1701",
      havana_gene : "OTTHUMG00000009892.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2400488,
      stop : 2403878,
      direction : "+",
      ID : "ENSG00000184281.15",
      gene_id : "ENSG00000184281.15",
      gene_type : "protein_coding",
      gene_name : "TSSC4",
      gene_level : 1,
      hgnc_id : "HGNC:12386",
      havana_gene : "OTTHUMG00000009895.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2404515,
      stop : 2423045,
      direction : "-",
      ID : "ENSG00000070985.13",
      gene_id : "ENSG00000070985.13",
      gene_type : "protein_coding",
      gene_name : "TRPM5",
      gene_level : 2,
      hgnc_id : "HGNC:14323",
      havana_gene : "OTTHUMG00000009896.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2444684,
      stop : 2849105,
      direction : "+",
      ID : "ENSG00000053918.18",
      gene_id : "ENSG00000053918.18",
      gene_type : "protein_coding",
      gene_name : "KCNQ1",
      gene_level : 2,
      hgnc_id : "HGNC:6294",
      havana_gene : "OTTHUMG00000009900.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2883213,
      stop : 2885775,
      direction : "-",
      ID : "ENSG00000129757.14",
      gene_id : "ENSG00000129757.14",
      gene_type : "protein_coding",
      gene_name : "CDKN1C",
      gene_level : 1,
      hgnc_id : "HGNC:1786",
      havana_gene : "OTTHUMG00000010040.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2887344,
      stop : 2903575,
      direction : "-",
      ID : "ENSG00000254827.6",
      gene_id : "ENSG00000254827.6",
      gene_type : "protein_coding",
      gene_name : "SLC22A18AS",
      gene_level : 2,
      hgnc_id : "HGNC:10965",
      havana_gene : "OTTHUMG00000010038.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2899721,
      stop : 2925246,
      direction : "+",
      ID : "ENSG00000110628.16",
      gene_id : "ENSG00000110628.16",
      gene_type : "protein_coding",
      gene_name : "SLC22A18",
      gene_level : 2,
      hgnc_id : "HGNC:10964",
      havana_gene : "OTTHUMG00000010037.13",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2928273,
      stop : 2929420,
      direction : "-",
      ID : "ENSG00000181649.8",
      gene_id : "ENSG00000181649.8",
      gene_type : "protein_coding",
      gene_name : "PHLDA2",
      gene_level : 2,
      hgnc_id : "HGNC:12385",
      havana_gene : "OTTHUMG00000010926.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 2944431,
      stop : 2992377,
      direction : "-",
      ID : "ENSG00000205531.13",
      gene_id : "ENSG00000205531.13",
      gene_type : "protein_coding",
      gene_name : "NAP1L4",
      gene_level : 2,
      hgnc_id : "HGNC:7640",
      havana_gene : "OTTHUMG00000011009.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3000922,
      stop : 3057613,
      direction : "-",
      ID : "ENSG00000110619.18",
      gene_id : "ENSG00000110619.18",
      gene_type : "protein_coding",
      gene_name : "CARS1",
      gene_level : 2,
      hgnc_id : "HGNC:1493",
      havana_gene : "OTTHUMG00000010927.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3087107,
      stop : 3166739,
      direction : "-",
      ID : "ENSG00000021762.20",
      gene_id : "ENSG00000021762.20",
      gene_type : "protein_coding",
      gene_name : "OSBPL5",
      gene_level : 2,
      hgnc_id : "HGNC:16392",
      havana_gene : "OTTHUMG00000011702.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3217944,
      stop : 3218813,
      direction : "-",
      ID : "ENSG00000182170.3",
      gene_id : "ENSG00000182170.3",
      gene_type : "protein_coding",
      gene_name : "MRGPRG",
      gene_level : 2,
      hgnc_id : "HGNC:24829",
      havana_gene : "OTTHUMG00000011709.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3225030,
      stop : 3232417,
      direction : "-",
      ID : "ENSG00000184350.11",
      gene_id : "ENSG00000184350.11",
      gene_type : "protein_coding",
      gene_name : "MRGPRE",
      gene_level : 2,
      hgnc_id : "HGNC:30694",
      havana_gene : "OTTHUMG00000011708.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3339261,
      stop : 3379222,
      direction : "-",
      ID : "ENSG00000005801.18",
      gene_id : "ENSG00000005801.18",
      gene_type : "protein_coding",
      gene_name : "ZNF195",
      gene_level : 1,
      hgnc_id : "HGNC:12986",
      havana_gene : "OTTHUMG00000011694.10",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3638512,
      stop : 3642316,
      direction : "-",
      ID : "ENSG00000167311.14",
      gene_id : "ENSG00000167311.14",
      gene_type : "protein_coding",
      gene_name : "ART5",
      gene_level : 1,
      hgnc_id : "HGNC:24049",
      havana_gene : "OTTHUMG00000011842.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3645128,
      stop : 3664416,
      direction : "+",
      ID : "ENSG00000129744.3",
      gene_id : "ENSG00000129744.3",
      gene_type : "protein_coding",
      gene_name : "ART1",
      gene_level : 2,
      hgnc_id : "HGNC:723",
      havana_gene : "OTTHUMG00000011845.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3665587,
      stop : 3671384,
      direction : "-",
      ID : "ENSG00000129749.3",
      gene_id : "ENSG00000129749.3",
      gene_type : "protein_coding",
      gene_name : "CHRNA10",
      gene_level : 1,
      hgnc_id : "HGNC:13800",
      havana_gene : "OTTHUMG00000011844.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3671083,
      stop : 3797792,
      direction : "-",
      ID : "ENSG00000110713.17",
      gene_id : "ENSG00000110713.17",
      gene_type : "protein_coding",
      gene_name : "NUP98",
      gene_level : 1,
      hgnc_id : "HGNC:8068",
      havana_gene : "OTTHUMG00000011846.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3797724,
      stop : 3826371,
      direction : "+",
      ID : "ENSG00000148985.20",
      gene_id : "ENSG00000148985.20",
      gene_type : "protein_coding",
      gene_name : "PGAP2",
      gene_level : 1,
      hgnc_id : "HGNC:17893",
      havana_gene : "OTTHUMG00000012238.15",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3826978,
      stop : 3840959,
      direction : "-",
      ID : "ENSG00000177105.10",
      gene_id : "ENSG00000177105.10",
      gene_type : "protein_coding",
      gene_name : "RHOG",
      gene_level : 2,
      hgnc_id : "HGNC:672",
      havana_gene : "OTTHUMG00000012287.4",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 3854527,
      stop : 4093210,
      direction : "+",
      ID : "ENSG00000167323.12",
      gene_id : "ENSG00000167323.12",
      gene_type : "protein_coding",
      gene_name : "STIM1",
      gene_level : 1,
      hgnc_id : "HGNC:11386",
      havana_gene : "OTTHUMG00000133360.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4094707,
      stop : 4138932,
      direction : "+",
      ID : "ENSG00000167325.15",
      gene_id : "ENSG00000167325.15",
      gene_type : "protein_coding",
      gene_name : "RRM1",
      gene_level : 2,
      hgnc_id : "HGNC:10451",
      havana_gene : "OTTHUMG00000133361.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4233288,
      stop : 4233872,
      direction : "+",
      ID : "ENSG00000284018.1",
      gene_id : "ENSG00000284018.1",
      gene_type : "protein_coding",
      gene_name : "SSU72P5",
      gene_level : 2,
      hgnc_id : "HGNC:43624",
      havana_gene : "OTTHUMG00000165695.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4242056,
      stop : 4242640,
      direction : "-",
      ID : "ENSG00000284306.1",
      gene_id : "ENSG00000284306.1",
      gene_type : "protein_coding",
      gene_name : "SSU72P2",
      gene_level : 2,
      hgnc_id : "HGNC:43621",
      havana_gene : "OTTHUMG00000165696.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4287499,
      stop : 4288083,
      direction : "-",
      ID : "ENSG00000283873.1",
      gene_id : "ENSG00000283873.1",
      gene_type : "protein_coding",
      gene_name : "SSU72P4",
      gene_level : 2,
      hgnc_id : "HGNC:43623",
      havana_gene : "OTTHUMG00000165698.3",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4329865,
      stop : 4330449,
      direction : "+",
      ID : "ENSG00000284546.1",
      gene_id : "ENSG00000284546.1",
      gene_type : "protein_coding",
      gene_name : "SSU72P3",
      gene_level : 2,
      hgnc_id : "HGNC:43622",
      havana_gene : "OTTHUMG00000165699.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4338660,
      stop : 4339244,
      direction : "-",
      ID : "ENSG00000284438.1",
      gene_id : "ENSG00000284438.1",
      gene_type : "protein_coding",
      gene_name : "SSU72P7",
      gene_level : 2,
      hgnc_id : "HGNC:43626",
      havana_gene : "OTTHUMG00000165700.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4367263,
      stop : 4368386,
      direction : "-",
      ID : "ENSG00000221996.6",
      gene_id : "ENSG00000221996.6",
      gene_type : "protein_coding",
      gene_name : "OR52B4",
      gene_level : 2,
      hgnc_id : "HGNC:15209",
      havana_gene : "OTTHUMG00000154222.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4384897,
      stop : 4393702,
      direction : "-",
      ID : "ENSG00000132109.10",
      gene_id : "ENSG00000132109.10",
      gene_type : "protein_coding",
      gene_name : "TRIM21",
      gene_level : 1,
      hgnc_id : "HGNC:11312",
      havana_gene : "OTTHUMG00000165701.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4449295,
      stop : 4450361,
      direction : "+",
      ID : "ENSG00000181963.5",
      gene_id : "ENSG00000181963.5",
      gene_type : "protein_coding",
      gene_name : "OR52K2",
      gene_level : 2,
      hgnc_id : "HGNC:15223",
      havana_gene : "OTTHUMG00000165703.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4482646,
      stop : 4493497,
      direction : "+",
      ID : "ENSG00000196778.3",
      gene_id : "ENSG00000196778.3",
      gene_type : "protein_coding",
      gene_name : "OR52K1",
      gene_level : 2,
      hgnc_id : "HGNC:15222",
      havana_gene : "OTTHUMG00000165705.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4545191,
      stop : 4546144,
      direction : "+",
      ID : "ENSG00000197790.1",
      gene_id : "ENSG00000197790.1",
      gene_type : "protein_coding",
      gene_name : "OR52M1",
      gene_level : 2,
      hgnc_id : "HGNC:15225",
      havana_gene : "OTTHUMG00000165706.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4581743,
      stop : 4593340,
      direction : "+",
      ID : "ENSG00000226288.2",
      gene_id : "ENSG00000226288.2",
      gene_type : "protein_coding",
      gene_name : "OR52I2",
      gene_level : 2,
      hgnc_id : "HGNC:15221",
      havana_gene : "OTTHUMG00000165721.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4593614,
      stop : 4596574,
      direction : "+",
      ID : "ENSG00000232268.6",
      gene_id : "ENSG00000232268.6",
      gene_type : "protein_coding",
      gene_name : "OR52I1",
      gene_level : 2,
      hgnc_id : "HGNC:15220",
      havana_gene : "OTTHUMG00000165722.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4598672,
      stop : 4608231,
      direction : "-",
      ID : "ENSG00000167333.13",
      gene_id : "ENSG00000167333.13",
      gene_type : "protein_coding",
      gene_name : "TRIM68",
      gene_level : 1,
      hgnc_id : "HGNC:21161",
      havana_gene : "OTTHUMG00000165723.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4637477,
      stop : 4643060,
      direction : "+",
      ID : "ENSG00000197428.3",
      gene_id : "ENSG00000197428.3",
      gene_type : "protein_coding",
      gene_name : "OR51D1",
      gene_level : 2,
      hgnc_id : "HGNC:15193",
      havana_gene : "OTTHUMG00000165724.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4643420,
      stop : 4655488,
      direction : "+",
      ID : "ENSG00000180785.10",
      gene_id : "ENSG00000180785.10",
      gene_type : "protein_coding",
      gene_name : "OR51E1",
      gene_level : 1,
      hgnc_id : "HGNC:15194",
      havana_gene : "OTTHUMG00000157024.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4680171,
      stop : 4697854,
      direction : "-",
      ID : "ENSG00000167332.9",
      gene_id : "ENSG00000167332.9",
      gene_type : "protein_coding",
      gene_name : "OR51E2",
      gene_level : 2,
      hgnc_id : "HGNC:15195",
      havana_gene : "OTTHUMG00000133362.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4690423,
      stop : 4697831,
      direction : "-",
      ID : "ENSG00000197674.7",
      gene_id : "ENSG00000197674.7",
      gene_type : "protein_coding",
      gene_name : "OR51C1P",
      gene_level : 2,
      hgnc_id : "HGNC:15191",
      havana_gene : "OTTHUMG00000186285.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4704927,
      stop : 4992429,
      direction : "+",
      ID : "ENSG00000167346.7",
      gene_id : "ENSG00000167346.7",
      gene_type : "protein_coding",
      gene_name : "MMP26",
      gene_level : 2,
      hgnc_id : "HGNC:14249",
      havana_gene : "OTTHUMG00000066442.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4768979,
      stop : 4769938,
      direction : "-",
      ID : "ENSG00000280021.1",
      gene_id : "ENSG00000280021.1",
      gene_type : "protein_coding",
      gene_name : "OR51F1",
      gene_level : 2,
      hgnc_id : "HGNC:15196",
      havana_gene : "OTTHUMG00000066503.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4803433,
      stop : 4804380,
      direction : "-",
      ID : "ENSG00000279270.2",
      gene_id : "ENSG00000279270.2",
      gene_type : "protein_coding",
      gene_name : "OR52R1",
      gene_level : 2,
      hgnc_id : "HGNC:15235",
      havana_gene : "OTTHUMG00000066510.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4821321,
      stop : 4822456,
      direction : "+",
      ID : "ENSG00000176925.8",
      gene_id : "ENSG00000176925.8",
      gene_type : "protein_coding",
      gene_name : "OR51F2",
      gene_level : 2,
      hgnc_id : "HGNC:15197",
      havana_gene : "OTTHUMG00000066508.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4847489,
      stop : 4849238,
      direction : "-",
      ID : "ENSG00000176922.4",
      gene_id : "ENSG00000176922.4",
      gene_type : "protein_coding",
      gene_name : "OR51S1",
      gene_level : 2,
      hgnc_id : "HGNC:15204",
      havana_gene : "OTTHUMG00000066506.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4881819,
      stop : 4882883,
      direction : "+",
      ID : "ENSG00000176900.2",
      gene_id : "ENSG00000176900.2",
      gene_type : "protein_coding",
      gene_name : "OR51T1",
      gene_level : 2,
      hgnc_id : "HGNC:15205",
      havana_gene : "OTTHUMG00000066507.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4903783,
      stop : 4909462,
      direction : "+",
      ID : "ENSG00000176895.9",
      gene_id : "ENSG00000176895.9",
      gene_type : "protein_coding",
      gene_name : "OR51A7",
      gene_level : 2,
      hgnc_id : "HGNC:15188",
      havana_gene : "OTTHUMG00000066502.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4912588,
      stop : 4919350,
      direction : "-",
      ID : "ENSG00000176893.5",
      gene_id : "ENSG00000176893.5",
      gene_type : "protein_coding",
      gene_name : "OR51G2",
      gene_level : 2,
      hgnc_id : "HGNC:15198",
      havana_gene : "OTTHUMG00000066501.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4923374,
      stop : 4924339,
      direction : "-",
      ID : "ENSG00000278870.2",
      gene_id : "ENSG00000278870.2",
      gene_type : "protein_coding",
      gene_name : "OR51G1",
      gene_level : 2,
      hgnc_id : "HGNC:14738",
      havana_gene : "OTTHUMG00000066532.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4942831,
      stop : 4947605,
      direction : "-",
      ID : "ENSG00000205497.4",
      gene_id : "ENSG00000205497.4",
      gene_type : "protein_coding",
      gene_name : "OR51A4",
      gene_level : 2,
      hgnc_id : "HGNC:14795",
      havana_gene : "OTTHUMG00000066614.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4954772,
      stop : 4955713,
      direction : "-",
      ID : "ENSG00000205496.1",
      gene_id : "ENSG00000205496.1",
      gene_type : "protein_coding",
      gene_name : "OR51A2",
      gene_level : 2,
      hgnc_id : "HGNC:14764",
      havana_gene : "OTTHUMG00000066602.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 4994851,
      stop : 5005536,
      direction : "+",
      ID : "ENSG00000176798.3",
      gene_id : "ENSG00000176798.3",
      gene_type : "protein_coding",
      gene_name : "OR51L1",
      gene_level : 2,
      hgnc_id : "HGNC:14759",
      havana_gene : "OTTHUMG00000066605.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5046526,
      stop : 5047461,
      direction : "+",
      ID : "ENSG00000205495.1",
      gene_id : "ENSG00000205495.1",
      gene_type : "protein_coding",
      gene_name : "OR52J3",
      gene_level : 2,
      hgnc_id : "HGNC:14799",
      havana_gene : "OTTHUMG00000066600.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5058650,
      stop : 5059627,
      direction : "-",
      ID : "ENSG00000176787.2",
      gene_id : "ENSG00000176787.2",
      gene_type : "protein_coding",
      gene_name : "OR52E2",
      gene_level : 2,
      hgnc_id : "HGNC:14769",
      havana_gene : "OTTHUMG00000066608.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5128776,
      stop : 5138356,
      direction : "-",
      ID : "ENSG00000171944.2",
      gene_id : "ENSG00000171944.2",
      gene_type : "protein_coding",
      gene_name : "OR52A5",
      gene_level : 2,
      hgnc_id : "HGNC:19580",
      havana_gene : "OTTHUMG00000066616.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5146824,
      stop : 5154757,
      direction : "-",
      ID : "ENSG00000182070.7",
      gene_id : "ENSG00000182070.7",
      gene_type : "protein_coding",
      gene_name : "OR52A1",
      gene_level : 2,
      hgnc_id : "HGNC:8318",
      havana_gene : "OTTHUMG00000066603.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5199735,
      stop : 5200682,
      direction : "-",
      ID : "ENSG00000176742.3",
      gene_id : "ENSG00000176742.3",
      gene_type : "protein_coding",
      gene_name : "OR51V1",
      gene_level : 2,
      hgnc_id : "HGNC:19597",
      havana_gene : "OTTHUMG00000066671.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5225464,
      stop : 5229395,
      direction : "-",
      ID : "ENSG00000244734.4",
      gene_id : "ENSG00000244734.4",
      gene_type : "protein_coding",
      gene_name : "HBB",
      gene_level : 2,
      hgnc_id : "HGNC:4827",
      havana_gene : "OTTHUMG00000066678.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5232678,
      stop : 5243657,
      direction : "-",
      ID : "ENSG00000223609.11",
      gene_id : "ENSG00000223609.11",
      gene_type : "protein_coding",
      gene_name : "HBD",
      gene_level : 1,
      hgnc_id : "HGNC:4829",
      havana_gene : "OTTHUMG00000066674.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5248269,
      stop : 5249857,
      direction : "-",
      ID : "ENSG00000213934.9",
      gene_id : "ENSG00000213934.9",
      gene_type : "protein_coding",
      gene_name : "HBG1",
      gene_level : 2,
      hgnc_id : "HGNC:4831",
      havana_gene : "OTTHUMG00000066681.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5248270,
      stop : 5254783,
      direction : "-",
      ID : "ENSG00000284931.1",
      gene_id : "ENSG00000284931.1",
      gene_type : "protein_coding",
      gene_name : "AC104389.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192488.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5253188,
      stop : 5505605,
      direction : "-",
      ID : "ENSG00000196565.15",
      gene_id : "ENSG00000196565.15",
      gene_type : "protein_coding",
      gene_name : "HBG2",
      gene_level : 2,
      hgnc_id : "HGNC:4832",
      havana_gene : "OTTHUMG00000066673.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5254392,
      stop : 5678434,
      direction : "-",
      ID : "ENSG00000239920.2",
      gene_id : "ENSG00000239920.2",
      gene_type : "protein_coding",
      gene_name : "AC104389.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192501.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5268345,
      stop : 5505652,
      direction : "-",
      ID : "ENSG00000213931.7",
      gene_id : "ENSG00000213931.7",
      gene_type : "protein_coding",
      gene_name : "HBE1",
      gene_level : 2,
      hgnc_id : "HGNC:4830",
      havana_gene : "OTTHUMG00000066675.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5301014,
      stop : 5301946,
      direction : "-",
      ID : "ENSG00000183251.4",
      gene_id : "ENSG00000183251.4",
      gene_type : "protein_coding",
      gene_name : "OR51B4",
      gene_level : 2,
      hgnc_id : "HGNC:14708",
      havana_gene : "OTTHUMG00000066665.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5303444,
      stop : 5505652,
      direction : "-",
      ID : "ENSG00000167355.8",
      gene_id : "ENSG00000167355.8",
      gene_type : "protein_coding",
      gene_name : "OR51B5",
      gene_level : 2,
      hgnc_id : "HGNC:19599",
      havana_gene : "OTTHUMG00000066676.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5323359,
      stop : 5324297,
      direction : "-",
      ID : "ENSG00000279012.2",
      gene_id : "ENSG00000279012.2",
      gene_type : "protein_coding",
      gene_name : "OR51B2",
      gene_level : 2,
      hgnc_id : "HGNC:14703",
      havana_gene : "OTTHUMG00000066682.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5351508,
      stop : 5352446,
      direction : "+",
      ID : "ENSG00000176239.7",
      gene_id : "ENSG00000176239.7",
      gene_type : "protein_coding",
      gene_name : "OR51B6",
      gene_level : 2,
      hgnc_id : "HGNC:19600",
      havana_gene : "OTTHUMG00000066669.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5383812,
      stop : 5393263,
      direction : "+",
      ID : "ENSG00000184698.5",
      gene_id : "ENSG00000184698.5",
      gene_type : "protein_coding",
      gene_name : "OR51M1",
      gene_level : 2,
      hgnc_id : "HGNC:14847",
      havana_gene : "OTTHUMG00000066680.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5422111,
      stop : 5423206,
      direction : "+",
      ID : "ENSG00000167360.6",
      gene_id : "ENSG00000167360.6",
      gene_type : "protein_coding",
      gene_name : "OR51Q1",
      gene_level : 2,
      hgnc_id : "HGNC:14851",
      havana_gene : "OTTHUMG00000066896.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5440570,
      stop : 5441514,
      direction : "-",
      ID : "ENSG00000167359.8",
      gene_id : "ENSG00000167359.8",
      gene_type : "protein_coding",
      gene_name : "OR51I1",
      gene_level : 2,
      hgnc_id : "HGNC:15200",
      havana_gene : "OTTHUMG00000066908.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5449323,
      stop : 5456518,
      direction : "+",
      ID : "ENSG00000187918.5",
      gene_id : "ENSG00000187918.5",
      gene_type : "protein_coding",
      gene_name : "OR51I2",
      gene_level : 2,
      hgnc_id : "HGNC:15201",
      havana_gene : "OTTHUMG00000066902.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5488685,
      stop : 5489749,
      direction : "+",
      ID : "ENSG00000181609.5",
      gene_id : "ENSG00000181609.5",
      gene_type : "protein_coding",
      gene_name : "OR52D1",
      gene_level : 2,
      hgnc_id : "HGNC:15212",
      havana_gene : "OTTHUMG00000066895.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5507300,
      stop : 5509958,
      direction : "-",
      ID : "ENSG00000175520.9",
      gene_id : "ENSG00000175520.9",
      gene_type : "protein_coding",
      gene_name : "UBQLN3",
      gene_level : 2,
      hgnc_id : "HGNC:12510",
      havana_gene : "OTTHUMG00000066886.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5514393,
      stop : 5518431,
      direction : "-",
      ID : "ENSG00000175518.8",
      gene_id : "ENSG00000175518.8",
      gene_type : "protein_coding",
      gene_name : "UBQLNL",
      gene_level : 2,
      hgnc_id : "HGNC:28294",
      havana_gene : "OTTHUMG00000066903.7",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5544489,
      stop : 5548533,
      direction : "-",
      ID : "ENSG00000181616.9",
      gene_id : "ENSG00000181616.9",
      gene_type : "protein_coding",
      gene_name : "OR52H1",
      gene_level : 2,
      hgnc_id : "HGNC:15218",
      havana_gene : "OTTHUMG00000066909.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5580877,
      stop : 5581884,
      direction : "+",
      ID : "ENSG00000187747.2",
      gene_id : "ENSG00000187747.2",
      gene_type : "protein_coding",
      gene_name : "OR52B6",
      gene_level : 2,
      hgnc_id : "HGNC:15211",
      havana_gene : "OTTHUMG00000066906.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5596109,
      stop : 5612958,
      direction : "+",
      ID : "ENSG00000121236.21",
      gene_id : "ENSG00000121236.21",
      gene_type : "protein_coding",
      gene_name : "TRIM6",
      gene_level : 1,
      hgnc_id : "HGNC:16277",
      havana_gene : "OTTHUMG00000150029.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5596725,
      stop : 5644398,
      direction : "+",
      ID : "ENSG00000258588.3",
      gene_id : "ENSG00000258588.3",
      gene_type : "protein_coding",
      gene_name : "TRIM6-TRIM34",
      gene_level : 2,
      hgnc_id : "HGNC:33440",
      havana_gene : "OTTHUMG00000066899.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5619764,
      stop : 5644398,
      direction : "+",
      ID : "ENSG00000258659.7",
      gene_id : "ENSG00000258659.7",
      gene_type : "protein_coding",
      gene_name : "TRIM34",
      gene_level : 2,
      hgnc_id : "HGNC:10063",
      havana_gene : "OTTHUMG00000066892.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5663195,
      stop : 5938619,
      direction : "-",
      ID : "ENSG00000132256.19",
      gene_id : "ENSG00000132256.19",
      gene_type : "protein_coding",
      gene_name : "TRIM5",
      gene_level : 2,
      hgnc_id : "HGNC:16276",
      havana_gene : "OTTHUMG00000066893.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5689697,
      stop : 5737089,
      direction : "+",
      ID : "ENSG00000132274.16",
      gene_id : "ENSG00000132274.16",
      gene_type : "protein_coding",
      gene_name : "TRIM22",
      gene_level : 1,
      hgnc_id : "HGNC:16379",
      havana_gene : "OTTHUMG00000066904.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5736448,
      stop : 5738523,
      direction : "+",
      ID : "ENSG00000181023.8",
      gene_id : "ENSG00000181023.8",
      gene_type : "protein_coding",
      gene_name : "OR56B1",
      gene_level : 2,
      hgnc_id : "HGNC:15245",
      havana_gene : "OTTHUMG00000066891.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5754243,
      stop : 5755905,
      direction : "+",
      ID : "ENSG00000181074.4",
      gene_id : "ENSG00000181074.4",
      gene_type : "protein_coding",
      gene_name : "OR52N4",
      gene_level : 2,
      hgnc_id : "HGNC:15230",
      havana_gene : "OTTHUMG00000066887.55",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5761153,
      stop : 5767465,
      direction : "+",
      ID : "ENSG00000181017.6",
      gene_id : "ENSG00000181017.6",
      gene_type : "protein_coding",
      gene_name : "OR56B2P",
      gene_level : 2,
      hgnc_id : "HGNC:15246",
      havana_gene : "OTTHUMG00000168798.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5776165,
      stop : 5783355,
      direction : "-",
      ID : "ENSG00000181009.5",
      gene_id : "ENSG00000181009.5",
      gene_type : "protein_coding",
      gene_name : "OR52N5",
      gene_level : 2,
      hgnc_id : "HGNC:15231",
      havana_gene : "OTTHUMG00000168799.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5786471,
      stop : 5791265,
      direction : "-",
      ID : "ENSG00000181001.3",
      gene_id : "ENSG00000181001.3",
      gene_type : "protein_coding",
      gene_name : "OR52N1",
      gene_level : 2,
      hgnc_id : "HGNC:14853",
      havana_gene : "OTTHUMG00000168800.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5820314,
      stop : 5821348,
      direction : "+",
      ID : "ENSG00000180988.2",
      gene_id : "ENSG00000180988.2",
      gene_type : "protein_coding",
      gene_name : "OR52N2",
      gene_level : 2,
      hgnc_id : "HGNC:15228",
      havana_gene : "OTTHUMG00000168801.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5840928,
      stop : 5841952,
      direction : "-",
      ID : "ENSG00000205409.3",
      gene_id : "ENSG00000205409.3",
      gene_type : "protein_coding",
      gene_name : "OR52E6",
      gene_level : 2,
      hgnc_id : "HGNC:15215",
      havana_gene : "OTTHUMG00000168802.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5856674,
      stop : 5857734,
      direction : "-",
      ID : "ENSG00000183269.5",
      gene_id : "ENSG00000183269.5",
      gene_type : "protein_coding",
      gene_name : "OR52E8",
      gene_level : 2,
      hgnc_id : "HGNC:15217",
      havana_gene : "OTTHUMG00000168803.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5880629,
      stop : 5887079,
      direction : "+",
      ID : "ENSG00000180974.4",
      gene_id : "ENSG00000180974.4",
      gene_type : "protein_coding",
      gene_name : "OR52E4",
      gene_level : 2,
      hgnc_id : "HGNC:15213",
      havana_gene : "OTTHUMG00000168804.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5893208,
      stop : 5902730,
      direction : "+",
      ID : "ENSG00000277932.2",
      gene_id : "ENSG00000277932.2",
      gene_type : "protein_coding",
      gene_name : "OR52E5",
      gene_level : 2,
      hgnc_id : "HGNC:15214",
      havana_gene : "OTTHUMG00000187075.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5938751,
      stop : 5951347,
      direction : "+",
      ID : "ENSG00000184478.7",
      gene_id : "ENSG00000184478.7",
      gene_type : "protein_coding",
      gene_name : "OR56A3",
      gene_level : 2,
      hgnc_id : "HGNC:14786",
      havana_gene : "OTTHUMG00000165373.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5967177,
      stop : 5968494,
      direction : "-",
      ID : "ENSG00000188691.5",
      gene_id : "ENSG00000188691.5",
      gene_type : "protein_coding",
      gene_name : "OR56A5",
      gene_level : 2,
      hgnc_id : "HGNC:14792",
      havana_gene : "OTTHUMG00000165730.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5985892,
      stop : 5986985,
      direction : "-",
      ID : "ENSG00000183313.4",
      gene_id : "ENSG00000183313.4",
      gene_type : "protein_coding",
      gene_name : "OR52L1",
      gene_level : 2,
      hgnc_id : "HGNC:14785",
      havana_gene : "OTTHUMG00000165374.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 5999445,
      stop : 6006946,
      direction : "-",
      ID : "ENSG00000183389.5",
      gene_id : "ENSG00000183389.5",
      gene_type : "protein_coding",
      gene_name : "OR56A4",
      gene_level : 2,
      hgnc_id : "HGNC:14791",
      havana_gene : "OTTHUMG00000165376.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6019336,
      stop : 6034338,
      direction : "-",
      ID : "ENSG00000180934.7",
      gene_id : "ENSG00000180934.7",
      gene_type : "protein_coding",
      gene_name : "OR56A1",
      gene_level : 2,
      hgnc_id : "HGNC:14781",
      havana_gene : "OTTHUMG00000165377.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6107684,
      stop : 6108835,
      direction : "+",
      ID : "ENSG00000180919.3",
      gene_id : "ENSG00000180919.3",
      gene_type : "protein_coding",
      gene_name : "OR56B4",
      gene_level : 2,
      hgnc_id : "HGNC:15248",
      havana_gene : "OTTHUMG00000165531.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6169330,
      stop : 6170408,
      direction : "-",
      ID : "ENSG00000255307.1",
      gene_id : "ENSG00000255307.1",
      gene_type : "protein_coding",
      gene_name : "OR52B2",
      gene_level : 2,
      hgnc_id : "HGNC:15207",
      havana_gene : "OTTHUMG00000165732.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6199146,
      stop : 6200259,
      direction : "+",
      ID : "ENSG00000175485.2",
      gene_id : "ENSG00000175485.2",
      gene_type : "protein_coding",
      gene_name : "OR52W1",
      gene_level : 2,
      hgnc_id : "HGNC:15239",
      havana_gene : "OTTHUMG00000165378.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6205557,
      stop : 6211135,
      direction : "+",
      ID : "ENSG00000180878.3",
      gene_id : "ENSG00000180878.3",
      gene_type : "protein_coding",
      gene_name : "C11orf42",
      gene_level : 2,
      hgnc_id : "HGNC:28541",
      havana_gene : "OTTHUMG00000133377.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6211345,
      stop : 6234711,
      direction : "-",
      ID : "ENSG00000051009.11",
      gene_id : "ENSG00000051009.11",
      gene_type : "protein_coding",
      gene_name : "FAM160A2",
      gene_level : 2,
      hgnc_id : "HGNC:25378",
      havana_gene : "OTTHUMG00000133379.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6234765,
      stop : 6244479,
      direction : "+",
      ID : "ENSG00000132259.13",
      gene_id : "ENSG00000132259.13",
      gene_type : "protein_coding",
      gene_name : "CNGA4",
      gene_level : 1,
      hgnc_id : "HGNC:2152",
      havana_gene : "OTTHUMG00000165379.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6259806,
      stop : 6272127,
      direction : "+",
      ID : "ENSG00000110148.10",
      gene_id : "ENSG00000110148.10",
      gene_type : "protein_coding",
      gene_name : "CCKBR",
      gene_level : 1,
      hgnc_id : "HGNC:1571",
      havana_gene : "OTTHUMG00000133380.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6318946,
      stop : 6320532,
      direction : "-",
      ID : "ENSG00000170955.10",
      gene_id : "ENSG00000170955.10",
      gene_type : "protein_coding",
      gene_name : "CAVIN3",
      gene_level : 1,
      hgnc_id : "HGNC:9400",
      havana_gene : "OTTHUMG00000133378.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6390440,
      stop : 6394998,
      direction : "+",
      ID : "ENSG00000166311.10",
      gene_id : "ENSG00000166311.10",
      gene_type : "protein_coding",
      gene_name : "SMPD1",
      gene_level : 1,
      hgnc_id : "HGNC:11120",
      havana_gene : "OTTHUMG00000165453.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6395124,
      stop : 6419414,
      direction : "-",
      ID : "ENSG00000166313.19",
      gene_id : "ENSG00000166313.19",
      gene_type : "protein_coding",
      gene_name : "APBB1",
      gene_level : 1,
      hgnc_id : "HGNC:581",
      havana_gene : "OTTHUMG00000165454.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6431049,
      stop : 6442617,
      direction : "-",
      ID : "ENSG00000110169.11",
      gene_id : "ENSG00000110169.11",
      gene_type : "protein_coding",
      gene_name : "HPX",
      gene_level : 1,
      hgnc_id : "HGNC:5171",
      havana_gene : "OTTHUMG00000133399.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6448613,
      stop : 6474459,
      direction : "-",
      ID : "ENSG00000110171.20",
      gene_id : "ENSG00000110171.20",
      gene_type : "protein_coding",
      gene_name : "TRIM3",
      gene_level : 1,
      hgnc_id : "HGNC:10064",
      havana_gene : "OTTHUMG00000133405.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6474683,
      stop : 6481479,
      direction : "-",
      ID : "ENSG00000132254.13",
      gene_id : "ENSG00000132254.13",
      gene_type : "protein_coding",
      gene_name : "ARFIP2",
      gene_level : 2,
      hgnc_id : "HGNC:17160",
      havana_gene : "OTTHUMG00000133406.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6481485,
      stop : 6508978,
      direction : "+",
      ID : "ENSG00000283977.1",
      gene_id : "ENSG00000283977.1",
      gene_type : "protein_coding",
      gene_name : "AC084337.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000133400.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6481501,
      stop : 6484681,
      direction : "+",
      ID : "ENSG00000132286.12",
      gene_id : "ENSG00000132286.12",
      gene_type : "protein_coding",
      gene_name : "TIMM10B",
      gene_level : 2,
      hgnc_id : "HGNC:4022",
      havana_gene : "OTTHUMG00000179826.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6497260,
      stop : 6593758,
      direction : "+",
      ID : "ENSG00000179532.13",
      gene_id : "ENSG00000179532.13",
      gene_type : "protein_coding",
      gene_name : "DNHD1",
      gene_level : 1,
      hgnc_id : "HGNC:26532",
      havana_gene : "OTTHUMG00000133403.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6595072,
      stop : 6603616,
      direction : "-",
      ID : "ENSG00000132275.11",
      gene_id : "ENSG00000132275.11",
      gene_type : "protein_coding",
      gene_name : "RRP8",
      gene_level : 1,
      hgnc_id : "HGNC:29030",
      havana_gene : "OTTHUMG00000165503.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6603708,
      stop : 6610874,
      direction : "+",
      ID : "ENSG00000166333.14",
      gene_id : "ENSG00000166333.14",
      gene_type : "protein_coding",
      gene_name : "ILK",
      gene_level : 1,
      hgnc_id : "HGNC:6040",
      havana_gene : "OTTHUMG00000133407.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6606294,
      stop : 6612539,
      direction : "-",
      ID : "ENSG00000166337.10",
      gene_id : "ENSG00000166337.10",
      gene_type : "protein_coding",
      gene_name : "TAF10",
      gene_level : 2,
      hgnc_id : "HGNC:11543",
      havana_gene : "OTTHUMG00000133402.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6612768,
      stop : 6619448,
      direction : "-",
      ID : "ENSG00000166340.17",
      gene_id : "ENSG00000166340.17",
      gene_type : "protein_coding",
      gene_name : "TPP1",
      gene_level : 2,
      hgnc_id : "HGNC:2073",
      havana_gene : "OTTHUMG00000133404.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6621330,
      stop : 6655809,
      direction : "-",
      ID : "ENSG00000166341.9",
      gene_id : "ENSG00000166341.9",
      gene_type : "protein_coding",
      gene_name : "DCHS1",
      gene_level : 2,
      hgnc_id : "HGNC:13681",
      havana_gene : "OTTHUMG00000133398.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6680385,
      stop : 6683340,
      direction : "-",
      ID : "ENSG00000158042.9",
      gene_id : "ENSG00000158042.9",
      gene_type : "protein_coding",
      gene_name : "MRPL17",
      gene_level : 1,
      hgnc_id : "HGNC:14053",
      havana_gene : "OTTHUMG00000165505.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6765626,
      stop : 6771976,
      direction : "-",
      ID : "ENSG00000188124.3",
      gene_id : "ENSG00000188124.3",
      gene_type : "protein_coding",
      gene_name : "OR2AG2",
      gene_level : 2,
      hgnc_id : "HGNC:15143",
      havana_gene : "OTTHUMG00000165868.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6783020,
      stop : 6791558,
      direction : "+",
      ID : "ENSG00000279486.5",
      gene_id : "ENSG00000279486.5",
      gene_type : "protein_coding",
      gene_name : "OR2AG1",
      gene_level : 2,
      hgnc_id : "HGNC:15142",
      havana_gene : "OTTHUMG00000165735.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6791736,
      stop : 6799689,
      direction : "-",
      ID : "ENSG00000184933.5",
      gene_id : "ENSG00000184933.5",
      gene_type : "protein_coding",
      gene_name : "OR6A2",
      gene_level : 2,
      hgnc_id : "HGNC:15301",
      havana_gene : "OTTHUMG00000165736.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6845652,
      stop : 6846705,
      direction : "+",
      ID : "ENSG00000166363.5",
      gene_id : "ENSG00000166363.5",
      gene_type : "protein_coding",
      gene_name : "OR10A5",
      gene_level : 2,
      hgnc_id : "HGNC:15131",
      havana_gene : "OTTHUMG00000165738.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6863057,
      stop : 6874717,
      direction : "+",
      ID : "ENSG00000170790.5",
      gene_id : "ENSG00000170790.5",
      gene_type : "protein_coding",
      gene_name : "OR10A2",
      gene_level : 2,
      hgnc_id : "HGNC:8161",
      havana_gene : "OTTHUMG00000165739.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6876625,
      stop : 6877619,
      direction : "+",
      ID : "ENSG00000170782.3",
      gene_id : "ENSG00000170782.3",
      gene_type : "protein_coding",
      gene_name : "OR10A4",
      gene_level : 2,
      hgnc_id : "HGNC:15130",
      havana_gene : "OTTHUMG00000165740.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6891490,
      stop : 6892599,
      direction : "-",
      ID : "ENSG00000166368.2",
      gene_id : "ENSG00000166368.2",
      gene_type : "protein_coding",
      gene_name : "OR2D2",
      gene_level : 2,
      hgnc_id : "HGNC:8244",
      havana_gene : "OTTHUMG00000165741.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6920974,
      stop : 6922043,
      direction : "+",
      ID : "ENSG00000178358.4",
      gene_id : "ENSG00000178358.4",
      gene_type : "protein_coding",
      gene_name : "OR2D3",
      gene_level : 2,
      hgnc_id : "HGNC:15146",
      havana_gene : "OTTHUMG00000165742.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6926404,
      stop : 7001004,
      direction : "+",
      ID : "ENSG00000149054.16",
      gene_id : "ENSG00000149054.16",
      gene_type : "protein_coding",
      gene_name : "ZNF215",
      gene_level : 2,
      hgnc_id : "HGNC:13007",
      havana_gene : "OTTHUMG00000165507.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 6997085,
      stop : 7020346,
      direction : "-",
      ID : "ENSG00000149050.10",
      gene_id : "ENSG00000149050.10",
      gene_type : "protein_coding",
      gene_name : "ZNF214",
      gene_level : 2,
      hgnc_id : "HGNC:13006",
      havana_gene : "OTTHUMG00000165618.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7020479,
      stop : 7071526,
      direction : "+",
      ID : "ENSG00000158077.5",
      gene_id : "ENSG00000158077.5",
      gene_type : "protein_coding",
      gene_name : "NLRP14",
      gene_level : 2,
      hgnc_id : "HGNC:22939",
      havana_gene : "OTTHUMG00000165508.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7088998,
      stop : 7091148,
      direction : "+",
      ID : "ENSG00000170748.7",
      gene_id : "ENSG00000170748.7",
      gene_type : "protein_coding",
      gene_name : "RBMXL2",
      gene_level : 2,
      hgnc_id : "HGNC:17886",
      havana_gene : "OTTHUMG00000165509.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7238778,
      stop : 7469043,
      direction : "+",
      ID : "ENSG00000170743.17",
      gene_id : "ENSG00000170743.17",
      gene_type : "protein_coding",
      gene_name : "SYT9",
      gene_level : 2,
      hgnc_id : "HGNC:19265",
      havana_gene : "OTTHUMG00000165499.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7485388,
      stop : 7511377,
      direction : "+",
      ID : "ENSG00000183801.8",
      gene_id : "ENSG00000183801.8",
      gene_type : "protein_coding",
      gene_name : "OLFML1",
      gene_level : 1,
      hgnc_id : "HGNC:24473",
      havana_gene : "OTTHUMG00000165527.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7513298,
      stop : 7657127,
      direction : "+",
      ID : "ENSG00000166387.13",
      gene_id : "ENSG00000166387.13",
      gene_type : "protein_coding",
      gene_name : "PPFIBP2",
      gene_level : 1,
      hgnc_id : "HGNC:9250",
      havana_gene : "OTTHUMG00000165617.10",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7665100,
      stop : 7677222,
      direction : "-",
      ID : "ENSG00000166394.15",
      gene_id : "ENSG00000166394.15",
      gene_type : "protein_coding",
      gene_name : "CYB5R2",
      gene_level : 1,
      hgnc_id : "HGNC:24376",
      havana_gene : "OTTHUMG00000165665.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7689437,
      stop : 7706421,
      direction : "-",
      ID : "ENSG00000183378.12",
      gene_id : "ENSG00000183378.12",
      gene_type : "protein_coding",
      gene_name : "OVCH2",
      gene_level : 2,
      hgnc_id : "HGNC:29970",
      havana_gene : "OTTHUMG00000165418.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7795905,
      stop : 7796973,
      direction : "-",
      ID : "ENSG00000183303.2",
      gene_id : "ENSG00000183303.2",
      gene_type : "protein_coding",
      gene_name : "OR5P2",
      gene_level : 2,
      hgnc_id : "HGNC:14783",
      havana_gene : "OTTHUMG00000165668.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7824818,
      stop : 7830840,
      direction : "-",
      ID : "ENSG00000182334.3",
      gene_id : "ENSG00000182334.3",
      gene_type : "protein_coding",
      gene_name : "OR5P3",
      gene_level : 2,
      hgnc_id : "HGNC:14784",
      havana_gene : "OTTHUMG00000165669.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7924592,
      stop : 7931268,
      direction : "-",
      ID : "ENSG00000279000.3",
      gene_id : "ENSG00000279000.3",
      gene_type : "protein_coding",
      gene_name : "OR10A6",
      gene_level : 2,
      hgnc_id : "HGNC:15132",
      havana_gene : "OTTHUMG00000165671.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7937171,
      stop : 7941708,
      direction : "-",
      ID : "ENSG00000170683.6",
      gene_id : "ENSG00000170683.6",
      gene_type : "protein_coding",
      gene_name : "OR10A3",
      gene_level : 2,
      hgnc_id : "HGNC:8162",
      havana_gene : "OTTHUMG00000165672.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7957537,
      stop : 7965426,
      direction : "-",
      ID : "ENSG00000182261.4",
      gene_id : "ENSG00000182261.4",
      gene_type : "protein_coding",
      gene_name : "NLRP10",
      gene_level : 2,
      hgnc_id : "HGNC:21464",
      havana_gene : "OTTHUMG00000165673.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 7970251,
      stop : 8001862,
      direction : "+",
      ID : "ENSG00000175390.15",
      gene_id : "ENSG00000175390.15",
      gene_type : "protein_coding",
      gene_name : "EIF3F",
      gene_level : 2,
      hgnc_id : "HGNC:3275",
      havana_gene : "OTTHUMG00000165675.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8019244,
      stop : 8106243,
      direction : "+",
      ID : "ENSG00000166402.9",
      gene_id : "ENSG00000166402.9",
      gene_type : "protein_coding",
      gene_name : "TUB",
      gene_level : 2,
      hgnc_id : "HGNC:12406",
      havana_gene : "OTTHUMG00000165690.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8106056,
      stop : 8169055,
      direction : "-",
      ID : "ENSG00000166405.15",
      gene_id : "ENSG00000166405.15",
      gene_type : "protein_coding",
      gene_name : "RIC3",
      gene_level : 1,
      hgnc_id : "HGNC:30338",
      havana_gene : "OTTHUMG00000165694.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8224309,
      stop : 8268716,
      direction : "-",
      ID : "ENSG00000166407.14",
      gene_id : "ENSG00000166407.14",
      gene_type : "protein_coding",
      gene_name : "LMO1",
      gene_level : 2,
      hgnc_id : "HGNC:6641",
      havana_gene : "OTTHUMG00000165833.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8391868,
      stop : 8594289,
      direction : "-",
      ID : "ENSG00000130413.15",
      gene_id : "ENSG00000130413.15",
      gene_type : "protein_coding",
      gene_name : "STK33",
      gene_level : 2,
      hgnc_id : "HGNC:14568",
      havana_gene : "OTTHUMG00000140275.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8612037,
      stop : 8682694,
      direction : "-",
      ID : "ENSG00000166436.16",
      gene_id : "ENSG00000166436.16",
      gene_type : "protein_coding",
      gene_name : "TRIM66",
      gene_level : 1,
      hgnc_id : "HGNC:29005",
      havana_gene : "OTTHUMG00000150481.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8682788,
      stop : 8714759,
      direction : "+",
      ID : "ENSG00000166441.13",
      gene_id : "ENSG00000166441.13",
      gene_type : "protein_coding",
      gene_name : "RPL27A",
      gene_level : 1,
      hgnc_id : "HGNC:10329",
      havana_gene : "OTTHUMG00000165834.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8693351,
      stop : 8910951,
      direction : "-",
      ID : "ENSG00000166444.19",
      gene_id : "ENSG00000166444.19",
      gene_type : "protein_coding",
      gene_name : "DENND2B",
      gene_level : 1,
      hgnc_id : "HGNC:11350",
      havana_gene : "OTTHUMG00000165835.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8911139,
      stop : 8920084,
      direction : "+",
      ID : "ENSG00000166452.12",
      gene_id : "ENSG00000166452.12",
      gene_type : "protein_coding",
      gene_name : "AKIP1",
      gene_level : 2,
      hgnc_id : "HGNC:1170",
      havana_gene : "OTTHUMG00000165653.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8920076,
      stop : 8933006,
      direction : "-",
      ID : "ENSG00000176029.14",
      gene_id : "ENSG00000176029.14",
      gene_type : "protein_coding",
      gene_name : "C11orf16",
      gene_level : 1,
      hgnc_id : "HGNC:1169",
      havana_gene : "OTTHUMG00000165654.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8937579,
      stop : 8938211,
      direction : "-",
      ID : "ENSG00000176009.3",
      gene_id : "ENSG00000176009.3",
      gene_type : "protein_coding",
      gene_name : "ASCL3",
      gene_level : 2,
      hgnc_id : "HGNC:740",
      havana_gene : "OTTHUMG00000165679.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8947202,
      stop : 8965011,
      direction : "-",
      ID : "ENSG00000175348.11",
      gene_id : "ENSG00000175348.11",
      gene_type : "protein_coding",
      gene_name : "TMEM9B",
      gene_level : 1,
      hgnc_id : "HGNC:1168",
      havana_gene : "OTTHUMG00000165676.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 8980576,
      stop : 9004049,
      direction : "-",
      ID : "ENSG00000175352.11",
      gene_id : "ENSG00000175352.11",
      gene_type : "protein_coding",
      gene_name : "NRIP3",
      gene_level : 1,
      hgnc_id : "HGNC:1167",
      havana_gene : "OTTHUMG00000165680.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9019476,
      stop : 9138114,
      direction : "-",
      ID : "ENSG00000175356.14",
      gene_id : "ENSG00000175356.14",
      gene_type : "protein_coding",
      gene_name : "SCUBE2",
      gene_level : 1,
      hgnc_id : "HGNC:30425",
      havana_gene : "OTTHUMG00000163880.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9138825,
      stop : 9265959,
      direction : "-",
      ID : "ENSG00000184014.9",
      gene_id : "ENSG00000184014.9",
      gene_type : "protein_coding",
      gene_name : "DENND5A",
      gene_level : 1,
      hgnc_id : "HGNC:19344",
      havana_gene : "OTTHUMG00000165716.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9280654,
      stop : 9314636,
      direction : "-",
      ID : "ENSG00000166471.11",
      gene_id : "ENSG00000166471.11",
      gene_type : "protein_coding",
      gene_name : "TMEM41B",
      gene_level : 2,
      hgnc_id : "HGNC:28948",
      havana_gene : "OTTHUMG00000165719.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9384652,
      stop : 9448127,
      direction : "+",
      ID : "ENSG00000205339.10",
      gene_id : "ENSG00000205339.10",
      gene_type : "protein_coding",
      gene_name : "IPO7",
      gene_level : 2,
      hgnc_id : "HGNC:9852",
      havana_gene : "OTTHUMG00000165753.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9460319,
      stop : 9528524,
      direction : "+",
      ID : "ENSG00000166478.10",
      gene_id : "ENSG00000166478.10",
      gene_type : "protein_coding",
      gene_name : "ZNF143",
      gene_level : 1,
      hgnc_id : "HGNC:12928",
      havana_gene : "OTTHUMG00000149922.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9573670,
      stop : 9593457,
      direction : "+",
      ID : "ENSG00000166483.12",
      gene_id : "ENSG00000166483.12",
      gene_type : "protein_coding",
      gene_name : "WEE1",
      gene_level : 1,
      hgnc_id : "HGNC:12761",
      havana_gene : "OTTHUMG00000165863.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9664077,
      stop : 9752993,
      direction : "+",
      ID : "ENSG00000133789.15",
      gene_id : "ENSG00000133789.15",
      gene_type : "protein_coding",
      gene_name : "SWAP70",
      gene_level : 1,
      hgnc_id : "HGNC:17070",
      havana_gene : "OTTHUMG00000165865.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 9778667,
      stop : 10294219,
      direction : "-",
      ID : "ENSG00000133812.17",
      gene_id : "ENSG00000133812.17",
      gene_type : "protein_coding",
      gene_name : "SBF2",
      gene_level : 1,
      hgnc_id : "HGNC:2135",
      havana_gene : "OTTHUMG00000165890.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10305073,
      stop : 10307397,
      direction : "+",
      ID : "ENSG00000148926.10",
      gene_id : "ENSG00000148926.10",
      gene_type : "protein_coding",
      gene_name : "ADM",
      gene_level : 2,
      hgnc_id : "HGNC:259",
      havana_gene : "OTTHUMG00000165907.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10308313,
      stop : 10507579,
      direction : "+",
      ID : "ENSG00000133805.15",
      gene_id : "ENSG00000133805.15",
      gene_type : "protein_coding",
      gene_name : "AMPD3",
      gene_level : 1,
      hgnc_id : "HGNC:470",
      havana_gene : "OTTHUMG00000165682.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10507894,
      stop : 10509186,
      direction : "-",
      ID : "ENSG00000255823.5",
      gene_id : "ENSG00000255823.5",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L8",
      gene_level : 2,
      hgnc_id : "HGNC:37165",
      havana_gene : "OTTHUMG00000184980.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10511673,
      stop : 10541230,
      direction : "-",
      ID : "ENSG00000110315.7",
      gene_id : "ENSG00000110315.7",
      gene_type : "protein_coding",
      gene_name : "RNF141",
      gene_level : 2,
      hgnc_id : "HGNC:21159",
      havana_gene : "OTTHUMG00000165712.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10556966,
      stop : 10611689,
      direction : "-",
      ID : "ENSG00000133800.9",
      gene_id : "ENSG00000133800.9",
      gene_type : "protein_coding",
      gene_name : "LYVE1",
      gene_level : 1,
      hgnc_id : "HGNC:14687",
      havana_gene : "OTTHUMG00000165713.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10573091,
      stop : 10693988,
      direction : "-",
      ID : "ENSG00000072952.19",
      gene_id : "ENSG00000072952.19",
      gene_type : "protein_coding",
      gene_name : "IRAG1",
      gene_level : 2,
      hgnc_id : "HGNC:7237",
      havana_gene : "OTTHUMG00000165773.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10751246,
      stop : 10801625,
      direction : "+",
      ID : "ENSG00000198730.9",
      gene_id : "ENSG00000198730.9",
      gene_type : "protein_coding",
      gene_name : "CTR9",
      gene_level : 1,
      hgnc_id : "HGNC:16850",
      havana_gene : "OTTHUMG00000165789.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10797050,
      stop : 10808940,
      direction : "-",
      ID : "ENSG00000110321.19",
      gene_id : "ENSG00000110321.19",
      gene_type : "protein_coding",
      gene_name : "EIF4G2",
      gene_level : 1,
      hgnc_id : "HGNC:3297",
      havana_gene : "OTTHUMG00000165823.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 10812074,
      stop : 10858796,
      direction : "-",
      ID : "ENSG00000236287.8",
      gene_id : "ENSG00000236287.8",
      gene_type : "protein_coding",
      gene_name : "ZBED5",
      gene_level : 1,
      hgnc_id : "HGNC:30803",
      havana_gene : "OTTHUMG00000150341.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 11270877,
      stop : 11622005,
      direction : "-",
      ID : "ENSG00000110328.6",
      gene_id : "ENSG00000110328.6",
      gene_type : "protein_coding",
      gene_name : "GALNT18",
      gene_level : 2,
      hgnc_id : "HGNC:30488",
      havana_gene : "OTTHUMG00000165707.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 11351942,
      stop : 11353250,
      direction : "-",
      ID : "ENSG00000254598.3",
      gene_id : "ENSG00000254598.3",
      gene_type : "protein_coding",
      gene_name : "CSNK2A3",
      gene_level : 2,
      hgnc_id : "HGNC:2458",
      havana_gene : "OTTHUMG00000165708.4",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 11841423,
      stop : 11961887,
      direction : "+",
      ID : "ENSG00000170242.19",
      gene_id : "ENSG00000170242.19",
      gene_type : "protein_coding",
      gene_name : "USP47",
      gene_level : 2,
      hgnc_id : "HGNC:20076",
      havana_gene : "OTTHUMG00000165685.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 11956207,
      stop : 12009769,
      direction : "-",
      ID : "ENSG00000050165.18",
      gene_id : "ENSG00000050165.18",
      gene_type : "protein_coding",
      gene_name : "DKK3",
      gene_level : 1,
      hgnc_id : "HGNC:2893",
      havana_gene : "OTTHUMG00000165709.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 12094008,
      stop : 12359144,
      direction : "+",
      ID : "ENSG00000133816.17",
      gene_id : "ENSG00000133816.17",
      gene_type : "protein_coding",
      gene_name : "MICAL2",
      gene_level : 1,
      hgnc_id : "HGNC:24693",
      havana_gene : "OTTHUMG00000165744.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 12377563,
      stop : 12535356,
      direction : "+",
      ID : "ENSG00000197702.14",
      gene_id : "ENSG00000197702.14",
      gene_type : "protein_coding",
      gene_name : "PARVA",
      gene_level : 2,
      hgnc_id : "HGNC:14652",
      havana_gene : "OTTHUMG00000165778.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 12674421,
      stop : 12944737,
      direction : "+",
      ID : "ENSG00000187079.20",
      gene_id : "ENSG00000187079.20",
      gene_type : "protein_coding",
      gene_name : "TEAD1",
      gene_level : 2,
      hgnc_id : "HGNC:11714",
      havana_gene : "OTTHUMG00000165878.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 13009316,
      stop : 13012119,
      direction : "+",
      ID : "ENSG00000189431.8",
      gene_id : "ENSG00000189431.8",
      gene_type : "protein_coding",
      gene_name : "RASSF10",
      gene_level : 2,
      hgnc_id : "HGNC:33984",
      havana_gene : "OTTHUMG00000166184.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 13276652,
      stop : 13387266,
      direction : "+",
      ID : "ENSG00000133794.20",
      gene_id : "ENSG00000133794.20",
      gene_type : "protein_coding",
      gene_name : "ARNTL",
      gene_level : 2,
      hgnc_id : "HGNC:701",
      havana_gene : "OTTHUMG00000150623.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 13388008,
      stop : 13463297,
      direction : "-",
      ID : "ENSG00000148925.11",
      gene_id : "ENSG00000148925.11",
      gene_type : "protein_coding",
      gene_name : "BTBD10",
      gene_level : 1,
      hgnc_id : "HGNC:21445",
      havana_gene : "OTTHUMG00000165787.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 13492054,
      stop : 13496181,
      direction : "-",
      ID : "ENSG00000152266.7",
      gene_id : "ENSG00000152266.7",
      gene_type : "protein_coding",
      gene_name : "PTH",
      gene_level : 2,
      hgnc_id : "HGNC:9606",
      havana_gene : "OTTHUMG00000165785.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 13668668,
      stop : 13732346,
      direction : "+",
      ID : "ENSG00000197601.13",
      gene_id : "ENSG00000197601.13",
      gene_type : "protein_coding",
      gene_name : "FAR1",
      gene_level : 2,
      hgnc_id : "HGNC:26222",
      havana_gene : "OTTHUMG00000165743.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 13962723,
      stop : 14268133,
      direction : "+",
      ID : "ENSG00000262655.4",
      gene_id : "ENSG00000262655.4",
      gene_type : "protein_coding",
      gene_name : "SPON1",
      gene_level : 2,
      hgnc_id : "HGNC:11252",
      havana_gene : "OTTHUMG00000181576.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14277922,
      stop : 14364506,
      direction : "-",
      ID : "ENSG00000133818.14",
      gene_id : "ENSG00000133818.14",
      gene_type : "protein_coding",
      gene_name : "RRAS2",
      gene_level : 2,
      hgnc_id : "HGNC:17271",
      havana_gene : "OTTHUMG00000165756.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14443440,
      stop : 14500027,
      direction : "-",
      ID : "ENSG00000129083.13",
      gene_id : "ENSG00000129083.13",
      gene_type : "protein_coding",
      gene_name : "COPB1",
      gene_level : 1,
      hgnc_id : "HGNC:2231",
      havana_gene : "OTTHUMG00000165824.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14493783,
      stop : 14520344,
      direction : "-",
      ID : "ENSG00000256206.2",
      gene_id : "ENSG00000256206.2",
      gene_type : "protein_coding",
      gene_name : "AC018523.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168126.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14504874,
      stop : 14643635,
      direction : "-",
      ID : "ENSG00000129084.18",
      gene_id : "ENSG00000129084.18",
      gene_type : "protein_coding",
      gene_name : "PSMA1",
      gene_level : 1,
      hgnc_id : "HGNC:9530",
      havana_gene : "OTTHUMG00000165825.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14643804,
      stop : 14872044,
      direction : "+",
      ID : "ENSG00000152270.9",
      gene_id : "ENSG00000152270.9",
      gene_type : "protein_coding",
      gene_name : "PDE3B",
      gene_level : 1,
      hgnc_id : "HGNC:8779",
      havana_gene : "OTTHUMG00000165898.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14877440,
      stop : 14892231,
      direction : "-",
      ID : "ENSG00000186104.11",
      gene_id : "ENSG00000186104.11",
      gene_type : "protein_coding",
      gene_name : "CYP2R1",
      gene_level : 1,
      hgnc_id : "HGNC:20580",
      havana_gene : "OTTHUMG00000165900.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14904997,
      stop : 15082342,
      direction : "+",
      ID : "ENSG00000175868.14",
      gene_id : "ENSG00000175868.14",
      gene_type : "protein_coding",
      gene_name : "CALCB",
      gene_level : 1,
      hgnc_id : "HGNC:1438",
      havana_gene : "OTTHUMG00000164629.24",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 14966668,
      stop : 14972351,
      direction : "-",
      ID : "ENSG00000110680.13",
      gene_id : "ENSG00000110680.13",
      gene_type : "protein_coding",
      gene_name : "CALCA",
      gene_level : 2,
      hgnc_id : "HGNC:1437",
      havana_gene : "OTTHUMG00000159731.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 15112424,
      stop : 15247208,
      direction : "+",
      ID : "ENSG00000188487.12",
      gene_id : "ENSG00000188487.12",
      gene_type : "protein_coding",
      gene_name : "INSC",
      gene_level : 1,
      hgnc_id : "HGNC:33116",
      havana_gene : "OTTHUMG00000165838.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 15966449,
      stop : 16739591,
      direction : "-",
      ID : "ENSG00000110693.18",
      gene_id : "ENSG00000110693.18",
      gene_type : "protein_coding",
      gene_name : "SOX6",
      gene_level : 2,
      hgnc_id : "HGNC:16421",
      havana_gene : "OTTHUMG00000165876.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 16613132,
      stop : 16758340,
      direction : "+",
      ID : "ENSG00000110696.10",
      gene_id : "ENSG00000110696.10",
      gene_type : "protein_coding",
      gene_name : "C11orf58",
      gene_level : 1,
      hgnc_id : "HGNC:16990",
      havana_gene : "OTTHUMG00000165910.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 16777297,
      stop : 17014414,
      direction : "-",
      ID : "ENSG00000166689.16",
      gene_id : "ENSG00000166689.16",
      gene_type : "protein_coding",
      gene_name : "PLEKHA7",
      gene_level : 1,
      hgnc_id : "HGNC:27049",
      havana_gene : "OTTHUMG00000165954.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17074388,
      stop : 17077715,
      direction : "-",
      ID : "ENSG00000110700.7",
      gene_id : "ENSG00000110700.7",
      gene_type : "protein_coding",
      gene_name : "RPS13",
      gene_level : 2,
      hgnc_id : "HGNC:10386",
      havana_gene : "OTTHUMG00000165988.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17077730,
      stop : 17207983,
      direction : "-",
      ID : "ENSG00000011405.13",
      gene_id : "ENSG00000011405.13",
      gene_type : "protein_coding",
      gene_name : "PIK3C2A",
      gene_level : 2,
      hgnc_id : "HGNC:8971",
      havana_gene : "OTTHUMG00000166036.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17208153,
      stop : 17349980,
      direction : "+",
      ID : "ENSG00000070081.17",
      gene_id : "ENSG00000070081.17",
      gene_type : "protein_coding",
      gene_name : "NUCB2",
      gene_level : 2,
      hgnc_id : "HGNC:8044",
      havana_gene : "OTTHUMG00000166050.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17351800,
      stop : 17377341,
      direction : "+",
      ID : "ENSG00000188211.9",
      gene_id : "ENSG00000188211.9",
      gene_type : "protein_coding",
      gene_name : "NCR3LG1",
      gene_level : 2,
      hgnc_id : "HGNC:42400",
      havana_gene : "OTTHUMG00000165913.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17385248,
      stop : 17389331,
      direction : "-",
      ID : "ENSG00000187486.6",
      gene_id : "ENSG00000187486.6",
      gene_type : "protein_coding",
      gene_name : "KCNJ11",
      gene_level : 2,
      hgnc_id : "HGNC:6257",
      havana_gene : "OTTHUMG00000165914.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17392498,
      stop : 17476879,
      direction : "-",
      ID : "ENSG00000006071.15",
      gene_id : "ENSG00000006071.15",
      gene_type : "protein_coding",
      gene_name : "ABCC8",
      gene_level : 2,
      hgnc_id : "HGNC:59",
      havana_gene : "OTTHUMG00000166316.33",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17493895,
      stop : 17544416,
      direction : "-",
      ID : "ENSG00000006611.17",
      gene_id : "ENSG00000006611.17",
      gene_type : "protein_coding",
      gene_name : "USH1C",
      gene_level : 2,
      hgnc_id : "HGNC:12597",
      havana_gene : "OTTHUMG00000166323.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17547259,
      stop : 17647150,
      direction : "+",
      ID : "ENSG00000188162.12",
      gene_id : "ENSG00000188162.12",
      gene_type : "protein_coding",
      gene_name : "OTOG",
      gene_level : 1,
      hgnc_id : "HGNC:8516",
      havana_gene : "OTTHUMG00000149905.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17719571,
      stop : 17722136,
      direction : "+",
      ID : "ENSG00000129152.4",
      gene_id : "ENSG00000129152.4",
      gene_type : "protein_coding",
      gene_name : "MYOD1",
      gene_level : 2,
      hgnc_id : "HGNC:7611",
      havana_gene : "OTTHUMG00000166358.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17734774,
      stop : 17856804,
      direction : "+",
      ID : "ENSG00000129159.9",
      gene_id : "ENSG00000129159.9",
      gene_type : "protein_coding",
      gene_name : "KCNC1",
      gene_level : 1,
      hgnc_id : "HGNC:6233",
      havana_gene : "OTTHUMG00000166359.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 17788048,
      stop : 18013047,
      direction : "-",
      ID : "ENSG00000129158.11",
      gene_id : "ENSG00000129158.11",
      gene_type : "protein_coding",
      gene_name : "SERGEF",
      gene_level : 1,
      hgnc_id : "HGNC:17499",
      havana_gene : "OTTHUMG00000166420.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18017564,
      stop : 18042426,
      direction : "-",
      ID : "ENSG00000129167.9",
      gene_id : "ENSG00000129167.9",
      gene_type : "protein_coding",
      gene_name : "TPH1",
      gene_level : 2,
      hgnc_id : "HGNC:12008",
      havana_gene : "OTTHUMG00000166421.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18069935,
      stop : 18106087,
      direction : "-",
      ID : "ENSG00000166788.10",
      gene_id : "ENSG00000166788.10",
      gene_type : "protein_coding",
      gene_name : "SAAL1",
      gene_level : 1,
      hgnc_id : "HGNC:25158",
      havana_gene : "OTTHUMG00000166428.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18120955,
      stop : 18138488,
      direction : "+",
      ID : "ENSG00000179826.8",
      gene_id : "ENSG00000179826.8",
      gene_type : "protein_coding",
      gene_name : "MRGPRX3",
      gene_level : 2,
      hgnc_id : "HGNC:17980",
      havana_gene : "OTTHUMG00000166435.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18172837,
      stop : 18174280,
      direction : "+",
      ID : "ENSG00000179817.5",
      gene_id : "ENSG00000179817.5",
      gene_type : "protein_coding",
      gene_name : "MRGPRX4",
      gene_level : 2,
      hgnc_id : "HGNC:17617",
      havana_gene : "OTTHUMG00000166442.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18231355,
      stop : 18236802,
      direction : "-",
      ID : "ENSG00000148965.10",
      gene_id : "ENSG00000148965.10",
      gene_type : "protein_coding",
      gene_name : "SAA4",
      gene_level : 2,
      hgnc_id : "HGNC:10516",
      havana_gene : "OTTHUMG00000166483.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18231423,
      stop : 18248635,
      direction : "-",
      ID : "ENSG00000255071.3",
      gene_id : "ENSG00000255071.3",
      gene_type : "protein_coding",
      gene_name : "SAA2-SAA4",
      gene_level : 2,
      hgnc_id : "HGNC:39550",
      havana_gene : "OTTHUMG00000166482.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18239223,
      stop : 18248668,
      direction : "-",
      ID : "ENSG00000134339.9",
      gene_id : "ENSG00000134339.9",
      gene_type : "protein_coding",
      gene_name : "SAA2",
      gene_level : 1,
      hgnc_id : "HGNC:10514",
      havana_gene : "OTTHUMG00000166484.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18266260,
      stop : 18269977,
      direction : "+",
      ID : "ENSG00000173432.12",
      gene_id : "ENSG00000173432.12",
      gene_type : "protein_coding",
      gene_name : "SAA1",
      gene_level : 2,
      hgnc_id : "HGNC:10513",
      havana_gene : "OTTHUMG00000166147.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18278668,
      stop : 18322198,
      direction : "-",
      ID : "ENSG00000110756.18",
      gene_id : "ENSG00000110756.18",
      gene_type : "protein_coding",
      gene_name : "HPS5",
      gene_level : 1,
      hgnc_id : "HGNC:17022",
      havana_gene : "OTTHUMG00000166612.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18322295,
      stop : 18367045,
      direction : "+",
      ID : "ENSG00000110768.12",
      gene_id : "ENSG00000110768.12",
      gene_type : "protein_coding",
      gene_name : "GTF2H1",
      gene_level : 1,
      hgnc_id : "HGNC:4655",
      havana_gene : "OTTHUMG00000167690.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18394560,
      stop : 18408425,
      direction : "+",
      ID : "ENSG00000134333.14",
      gene_id : "ENSG00000134333.14",
      gene_type : "protein_coding",
      gene_name : "LDHA",
      gene_level : 1,
      hgnc_id : "HGNC:6535",
      havana_gene : "OTTHUMG00000167721.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18412318,
      stop : 18452063,
      direction : "+",
      ID : "ENSG00000166796.12",
      gene_id : "ENSG00000166796.12",
      gene_type : "protein_coding",
      gene_name : "LDHC",
      gene_level : 1,
      hgnc_id : "HGNC:6544",
      havana_gene : "OTTHUMG00000167722.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18455824,
      stop : 18479601,
      direction : "+",
      ID : "ENSG00000166800.10",
      gene_id : "ENSG00000166800.10",
      gene_type : "protein_coding",
      gene_name : "LDHAL6A",
      gene_level : 2,
      hgnc_id : "HGNC:28335",
      havana_gene : "OTTHUMG00000167724.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18468336,
      stop : 18526951,
      direction : "-",
      ID : "ENSG00000074319.13",
      gene_id : "ENSG00000074319.13",
      gene_type : "protein_coding",
      gene_name : "TSG101",
      gene_level : 1,
      hgnc_id : "HGNC:15971",
      havana_gene : "OTTHUMG00000167725.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18529609,
      stop : 18588747,
      direction : "-",
      ID : "ENSG00000151116.17",
      gene_id : "ENSG00000151116.17",
      gene_type : "protein_coding",
      gene_name : "UEVLD",
      gene_level : 1,
      hgnc_id : "HGNC:30866",
      havana_gene : "OTTHUMG00000167729.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18588781,
      stop : 18610255,
      direction : "+",
      ID : "ENSG00000247595.4",
      gene_id : "ENSG00000247595.4",
      gene_type : "protein_coding",
      gene_name : "SPTY2D1OS",
      gene_level : 2,
      hgnc_id : "HGNC:44122",
      havana_gene : "OTTHUMG00000167731.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18606403,
      stop : 18634791,
      direction : "-",
      ID : "ENSG00000179119.15",
      gene_id : "ENSG00000179119.15",
      gene_type : "protein_coding",
      gene_name : "SPTY2D1",
      gene_level : 2,
      hgnc_id : "HGNC:26818",
      havana_gene : "OTTHUMG00000167733.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18693122,
      stop : 18704785,
      direction : "+",
      ID : "ENSG00000151117.9",
      gene_id : "ENSG00000151117.9",
      gene_type : "protein_coding",
      gene_name : "TMEM86A",
      gene_level : 1,
      hgnc_id : "HGNC:26890",
      havana_gene : "OTTHUMG00000167680.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18704312,
      stop : 18726230,
      direction : "-",
      ID : "ENSG00000179057.14",
      gene_id : "ENSG00000179057.14",
      gene_type : "protein_coding",
      gene_name : "IGSF22",
      gene_level : 2,
      hgnc_id : "HGNC:26750",
      havana_gene : "OTTHUMG00000160502.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18727928,
      stop : 18792721,
      direction : "-",
      ID : "ENSG00000110786.18",
      gene_id : "ENSG00000110786.18",
      gene_type : "protein_coding",
      gene_name : "PTPN5",
      gene_level : 2,
      hgnc_id : "HGNC:9657",
      havana_gene : "OTTHUMG00000134304.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 18933813,
      stop : 18939507,
      direction : "-",
      ID : "ENSG00000170255.7",
      gene_id : "ENSG00000170255.7",
      gene_type : "protein_coding",
      gene_name : "MRGPRX1",
      gene_level : 2,
      hgnc_id : "HGNC:17962",
      havana_gene : "OTTHUMG00000162655.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 19054455,
      stop : 19060717,
      direction : "-",
      ID : "ENSG00000183695.3",
      gene_id : "ENSG00000183695.3",
      gene_type : "protein_coding",
      gene_name : "MRGPRX2",
      gene_level : 2,
      hgnc_id : "HGNC:17983",
      havana_gene : "OTTHUMG00000166098.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 19117099,
      stop : 19176422,
      direction : "+",
      ID : "ENSG00000177054.14",
      gene_id : "ENSG00000177054.14",
      gene_type : "protein_coding",
      gene_name : "ZDHHC13",
      gene_level : 1,
      hgnc_id : "HGNC:18413",
      havana_gene : "OTTHUMG00000166099.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 19182030,
      stop : 19210571,
      direction : "-",
      ID : "ENSG00000129170.10",
      gene_id : "ENSG00000129170.10",
      gene_type : "protein_coding",
      gene_name : "CSRP3",
      gene_level : 2,
      hgnc_id : "HGNC:2472",
      havana_gene : "OTTHUMG00000166100.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 19224063,
      stop : 19241620,
      direction : "-",
      ID : "ENSG00000129173.13",
      gene_id : "ENSG00000129173.13",
      gene_type : "protein_coding",
      gene_name : "E2F8",
      gene_level : 1,
      hgnc_id : "HGNC:24727",
      havana_gene : "OTTHUMG00000166102.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 19350724,
      stop : 20121601,
      direction : "+",
      ID : "ENSG00000166833.22",
      gene_id : "ENSG00000166833.22",
      gene_type : "protein_coding",
      gene_name : "NAV2",
      gene_level : 1,
      hgnc_id : "HGNC:15997",
      havana_gene : "OTTHUMG00000151837.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 20156155,
      stop : 20160475,
      direction : "-",
      ID : "ENSG00000109851.7",
      gene_id : "ENSG00000109851.7",
      gene_type : "protein_coding",
      gene_name : "DBX1",
      gene_level : 2,
      hgnc_id : "HGNC:33185",
      havana_gene : "OTTHUMG00000166043.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 20363685,
      stop : 20383782,
      direction : "+",
      ID : "ENSG00000109854.14",
      gene_id : "ENSG00000109854.14",
      gene_type : "protein_coding",
      gene_name : "HTATIP2",
      gene_level : 2,
      hgnc_id : "HGNC:16637",
      havana_gene : "OTTHUMG00000166015.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 20387558,
      stop : 20509338,
      direction : "+",
      ID : "ENSG00000185238.13",
      gene_id : "ENSG00000185238.13",
      gene_type : "protein_coding",
      gene_name : "PRMT3",
      gene_level : 2,
      hgnc_id : "HGNC:30163",
      havana_gene : "OTTHUMG00000166022.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 20599594,
      stop : 20659285,
      direction : "+",
      ID : "ENSG00000165970.12",
      gene_id : "ENSG00000165970.12",
      gene_type : "protein_coding",
      gene_name : "SLC6A5",
      gene_level : 2,
      hgnc_id : "HGNC:11051",
      havana_gene : "OTTHUMG00000166024.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 20669551,
      stop : 21575686,
      direction : "+",
      ID : "ENSG00000165973.19",
      gene_id : "ENSG00000165973.19",
      gene_type : "protein_coding",
      gene_name : "NELL1",
      gene_level : 1,
      hgnc_id : "HGNC:7750",
      havana_gene : "OTTHUMG00000166042.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 21799934,
      stop : 22283357,
      direction : "+",
      ID : "ENSG00000171714.12",
      gene_id : "ENSG00000171714.12",
      gene_type : "protein_coding",
      gene_name : "ANO5",
      gene_level : 2,
      hgnc_id : "HGNC:27337",
      havana_gene : "OTTHUMG00000166051.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 22338381,
      stop : 22379503,
      direction : "+",
      ID : "ENSG00000091664.9",
      gene_id : "ENSG00000091664.9",
      gene_type : "protein_coding",
      gene_name : "SLC17A6",
      gene_level : 2,
      hgnc_id : "HGNC:16703",
      havana_gene : "OTTHUMG00000166063.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 22622533,
      stop : 22625823,
      direction : "-",
      ID : "ENSG00000183161.6",
      gene_id : "ENSG00000183161.6",
      gene_type : "protein_coding",
      gene_name : "FANCF",
      gene_level : 2,
      hgnc_id : "HGNC:3587",
      havana_gene : "OTTHUMG00000166070.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 22625509,
      stop : 22813055,
      direction : "+",
      ID : "ENSG00000148935.11",
      gene_id : "ENSG00000148935.11",
      gene_type : "protein_coding",
      gene_name : "GAS2",
      gene_level : 2,
      hgnc_id : "HGNC:4167",
      havana_gene : "OTTHUMG00000166071.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 22813799,
      stop : 22830299,
      direction : "-",
      ID : "ENSG00000198168.9",
      gene_id : "ENSG00000198168.9",
      gene_type : "protein_coding",
      gene_name : "SVIP",
      gene_level : 2,
      hgnc_id : "HGNC:25238",
      havana_gene : "OTTHUMG00000166072.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 22846922,
      stop : 22860474,
      direction : "-",
      ID : "ENSG00000255359.3",
      gene_id : "ENSG00000255359.3",
      gene_type : "protein_coding",
      gene_name : "CCDC179",
      gene_level : 2,
      hgnc_id : "HGNC:44653",
      havana_gene : "OTTHUMG00000166074.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 24496970,
      stop : 25082638,
      direction : "+",
      ID : "ENSG00000187398.12",
      gene_id : "ENSG00000187398.12",
      gene_type : "protein_coding",
      gene_name : "LUZP2",
      gene_level : 2,
      hgnc_id : "HGNC:23206",
      havana_gene : "OTTHUMG00000166109.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 26188842,
      stop : 26663289,
      direction : "+",
      ID : "ENSG00000134343.14",
      gene_id : "ENSG00000134343.14",
      gene_type : "protein_coding",
      gene_name : "ANO3",
      gene_level : 2,
      hgnc_id : "HGNC:14004",
      havana_gene : "OTTHUMG00000166096.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 26559032,
      stop : 26572263,
      direction : "-",
      ID : "ENSG00000169550.14",
      gene_id : "ENSG00000169550.14",
      gene_type : "protein_coding",
      gene_name : "MUC15",
      gene_level : 2,
      hgnc_id : "HGNC:14956",
      havana_gene : "OTTHUMG00000166112.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 26667020,
      stop : 26723427,
      direction : "-",
      ID : "ENSG00000148942.15",
      gene_id : "ENSG00000148942.15",
      gene_type : "protein_coding",
      gene_name : "SLC5A12",
      gene_level : 2,
      hgnc_id : "HGNC:28750",
      havana_gene : "OTTHUMG00000150706.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 26994112,
      stop : 26997087,
      direction : "+",
      ID : "ENSG00000176971.4",
      gene_id : "ENSG00000176971.4",
      gene_type : "protein_coding",
      gene_name : "FIBIN",
      gene_level : 2,
      hgnc_id : "HGNC:33747",
      havana_gene : "OTTHUMG00000166120.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 27040725,
      stop : 27127809,
      direction : "+",
      ID : "ENSG00000129151.9",
      gene_id : "ENSG00000129151.9",
      gene_type : "protein_coding",
      gene_name : "BBOX1",
      gene_level : 2,
      hgnc_id : "HGNC:964",
      havana_gene : "OTTHUMG00000166121.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 27330827,
      stop : 27363234,
      direction : "-",
      ID : "ENSG00000109881.17",
      gene_id : "ENSG00000109881.17",
      gene_type : "protein_coding",
      gene_name : "CCDC34",
      gene_level : 2,
      hgnc_id : "HGNC:25079",
      havana_gene : "OTTHUMG00000166211.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 27365961,
      stop : 27472790,
      direction : "-",
      ID : "ENSG00000205213.14",
      gene_id : "ENSG00000205213.14",
      gene_type : "protein_coding",
      gene_name : "LGR4",
      gene_level : 1,
      hgnc_id : "HGNC:13299",
      havana_gene : "OTTHUMG00000133508.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 27494418,
      stop : 27506769,
      direction : "-",
      ID : "ENSG00000148943.12",
      gene_id : "ENSG00000148943.12",
      gene_type : "protein_coding",
      gene_name : "LIN7C",
      gene_level : 2,
      hgnc_id : "HGNC:17789",
      havana_gene : "OTTHUMG00000166193.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 27654893,
      stop : 27722058,
      direction : "-",
      ID : "ENSG00000176697.20",
      gene_id : "ENSG00000176697.20",
      gene_type : "protein_coding",
      gene_name : "BDNF",
      gene_level : 2,
      hgnc_id : "HGNC:1033",
      havana_gene : "OTTHUMG00000178797.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 28020619,
      stop : 28108156,
      direction : "-",
      ID : "ENSG00000121621.7",
      gene_id : "ENSG00000121621.7",
      gene_type : "protein_coding",
      gene_name : "KIF18A",
      gene_level : 2,
      hgnc_id : "HGNC:29441",
      havana_gene : "OTTHUMG00000166195.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 28108248,
      stop : 28527041,
      direction : "+",
      ID : "ENSG00000169519.21",
      gene_id : "ENSG00000169519.21",
      gene_type : "protein_coding",
      gene_name : "METTL15",
      gene_level : 2,
      hgnc_id : "HGNC:26606",
      havana_gene : "OTTHUMG00000150448.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 30009730,
      stop : 30017030,
      direction : "-",
      ID : "ENSG00000182255.7",
      gene_id : "ENSG00000182255.7",
      gene_type : "protein_coding",
      gene_name : "KCNA4",
      gene_level : 2,
      hgnc_id : "HGNC:6222",
      havana_gene : "OTTHUMG00000166144.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 30231014,
      stop : 30235261,
      direction : "+",
      ID : "ENSG00000131808.11",
      gene_id : "ENSG00000131808.11",
      gene_type : "protein_coding",
      gene_name : "FSHB",
      gene_level : 2,
      hgnc_id : "HGNC:3964",
      havana_gene : "OTTHUMG00000166146.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 30323104,
      stop : 30338223,
      direction : "+",
      ID : "ENSG00000152219.5",
      gene_id : "ENSG00000152219.5",
      gene_type : "protein_coding",
      gene_name : "ARL14EP",
      gene_level : 1,
      hgnc_id : "HGNC:26798",
      havana_gene : "OTTHUMG00000166154.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 30384493,
      stop : 30586872,
      direction : "-",
      ID : "ENSG00000066382.17",
      gene_id : "ENSG00000066382.17",
      gene_type : "protein_coding",
      gene_name : "MPPED2",
      gene_level : 1,
      hgnc_id : "HGNC:1180",
      havana_gene : "OTTHUMG00000166159.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 30830369,
      stop : 31369810,
      direction : "-",
      ID : "ENSG00000170959.14",
      gene_id : "ENSG00000170959.14",
      gene_type : "protein_coding",
      gene_name : "DCDC1",
      gene_level : 1,
      hgnc_id : "HGNC:20625",
      havana_gene : "OTTHUMG00000150144.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 31369840,
      stop : 31432835,
      direction : "+",
      ID : "ENSG00000170946.15",
      gene_id : "ENSG00000170946.15",
      gene_type : "protein_coding",
      gene_name : "DNAJC24",
      gene_level : 1,
      hgnc_id : "HGNC:26979",
      havana_gene : "OTTHUMG00000133712.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 31432401,
      stop : 31509645,
      direction : "-",
      ID : "ENSG00000148950.11",
      gene_id : "ENSG00000148950.11",
      gene_type : "protein_coding",
      gene_name : "IMMP1L",
      gene_level : 2,
      hgnc_id : "HGNC:26317",
      havana_gene : "OTTHUMG00000166226.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 31509755,
      stop : 31790324,
      direction : "+",
      ID : "ENSG00000109911.19",
      gene_id : "ENSG00000109911.19",
      gene_type : "protein_coding",
      gene_name : "ELP4",
      gene_level : 2,
      hgnc_id : "HGNC:1171",
      havana_gene : "OTTHUMG00000142919.11",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 31784779,
      stop : 31817961,
      direction : "-",
      ID : "ENSG00000007372.24",
      gene_id : "ENSG00000007372.24",
      gene_type : "protein_coding",
      gene_name : "PAX6",
      gene_level : 1,
      hgnc_id : "HGNC:8620",
      havana_gene : "OTTHUMG00000041447.26",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 31812391,
      stop : 32104665,
      direction : "+",
      ID : "ENSG00000285283.1",
      gene_id : "ENSG00000285283.1",
      gene_type : "protein_coding",
      gene_name : "AL035078.4",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192409.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 32091074,
      stop : 32105722,
      direction : "+",
      ID : "ENSG00000049449.10",
      gene_id : "ENSG00000049449.10",
      gene_type : "protein_coding",
      gene_name : "RCN1",
      gene_level : 1,
      hgnc_id : "HGNC:9934",
      havana_gene : "OTTHUMG00000166227.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 32387775,
      stop : 32435564,
      direction : "-",
      ID : "ENSG00000184937.16",
      gene_id : "ENSG00000184937.16",
      gene_type : "protein_coding",
      gene_name : "WT1",
      gene_level : 1,
      hgnc_id : "HGNC:12796",
      havana_gene : "OTTHUMG00000039556.10",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 32583798,
      stop : 32606264,
      direction : "+",
      ID : "ENSG00000149100.13",
      gene_id : "ENSG00000149100.13",
      gene_type : "protein_coding",
      gene_name : "EIF3M",
      gene_level : 1,
      hgnc_id : "HGNC:24460",
      havana_gene : "OTTHUMG00000166258.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 32602246,
      stop : 32794658,
      direction : "-",
      ID : "ENSG00000186714.12",
      gene_id : "ENSG00000186714.12",
      gene_type : "protein_coding",
      gene_name : "CCDC73",
      gene_level : 2,
      hgnc_id : "HGNC:23261",
      havana_gene : "OTTHUMG00000166279.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 32829927,
      stop : 32858120,
      direction : "+",
      ID : "ENSG00000135378.4",
      gene_id : "ENSG00000135378.4",
      gene_type : "protein_coding",
      gene_name : "PRRG4",
      gene_level : 2,
      hgnc_id : "HGNC:30799",
      havana_gene : "OTTHUMG00000166219.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 32892811,
      stop : 32993316,
      direction : "+",
      ID : "ENSG00000060749.16",
      gene_id : "ENSG00000060749.16",
      gene_type : "protein_coding",
      gene_name : "QSER1",
      gene_level : 1,
      hgnc_id : "HGNC:26154",
      havana_gene : "OTTHUMG00000166220.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33015876,
      stop : 33033582,
      direction : "+",
      ID : "ENSG00000121690.11",
      gene_id : "ENSG00000121690.11",
      gene_type : "protein_coding",
      gene_name : "DEPDC7",
      gene_level : 2,
      hgnc_id : "HGNC:29899",
      havana_gene : "OTTHUMG00000166242.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33039417,
      stop : 33105943,
      direction : "+",
      ID : "ENSG00000176148.16",
      gene_id : "ENSG00000176148.16",
      gene_type : "protein_coding",
      gene_name : "TCP11L1",
      gene_level : 1,
      hgnc_id : "HGNC:25655",
      havana_gene : "OTTHUMG00000165303.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33077188,
      stop : 33162371,
      direction : "-",
      ID : "ENSG00000176102.13",
      gene_id : "ENSG00000176102.13",
      gene_type : "protein_coding",
      gene_name : "CSTF3",
      gene_level : 2,
      hgnc_id : "HGNC:2485",
      havana_gene : "OTTHUMG00000166268.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33256672,
      stop : 33357023,
      direction : "+",
      ID : "ENSG00000110422.12",
      gene_id : "ENSG00000110422.12",
      gene_type : "protein_coding",
      gene_name : "HIPK3",
      gene_level : 2,
      hgnc_id : "HGNC:4915",
      havana_gene : "OTTHUMG00000132269.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33376108,
      stop : 33674102,
      direction : "+",
      ID : "ENSG00000110427.17",
      gene_id : "ENSG00000110427.17",
      gene_type : "protein_coding",
      gene_name : "KIAA1549L",
      gene_level : 1,
      hgnc_id : "HGNC:24836",
      havana_gene : "OTTHUMG00000150410.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33698261,
      stop : 33700801,
      direction : "-",
      ID : "ENSG00000205177.6",
      gene_id : "ENSG00000205177.6",
      gene_type : "protein_coding",
      gene_name : "C11orf91",
      gene_level : 2,
      hgnc_id : "HGNC:34444",
      havana_gene : "OTTHUMG00000166320.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33698261,
      stop : 33722467,
      direction : "-",
      ID : "ENSG00000284969.1",
      gene_id : "ENSG00000284969.1",
      gene_type : "protein_coding",
      gene_name : "AL049629.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000166270.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33703010,
      stop : 33736479,
      direction : "-",
      ID : "ENSG00000085063.17",
      gene_id : "ENSG00000085063.17",
      gene_type : "protein_coding",
      gene_name : "CD59",
      gene_level : 1,
      hgnc_id : "HGNC:1689",
      havana_gene : "OTTHUMG00000192410.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33740939,
      stop : 33774543,
      direction : "-",
      ID : "ENSG00000110429.14",
      gene_id : "ENSG00000110429.14",
      gene_type : "protein_coding",
      gene_name : "FBXO3",
      gene_level : 1,
      hgnc_id : "HGNC:13582",
      havana_gene : "OTTHUMG00000166244.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 33858576,
      stop : 33892076,
      direction : "-",
      ID : "ENSG00000135363.12",
      gene_id : "ENSG00000135363.12",
      gene_type : "protein_coding",
      gene_name : "LMO2",
      gene_level : 2,
      hgnc_id : "HGNC:6642",
      havana_gene : "OTTHUMG00000157176.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34051731,
      stop : 34102610,
      direction : "+",
      ID : "ENSG00000135387.21",
      gene_id : "ENSG00000135387.21",
      gene_type : "protein_coding",
      gene_name : "CAPRIN1",
      gene_level : 2,
      hgnc_id : "HGNC:6743",
      havana_gene : "OTTHUMG00000166248.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34105617,
      stop : 34147670,
      direction : "+",
      ID : "ENSG00000135372.9",
      gene_id : "ENSG00000135372.9",
      gene_type : "protein_coding",
      gene_name : "NAT10",
      gene_level : 1,
      hgnc_id : "HGNC:29830",
      havana_gene : "OTTHUMG00000166249.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34150987,
      stop : 34358010,
      direction : "-",
      ID : "ENSG00000166016.6",
      gene_id : "ENSG00000166016.6",
      gene_type : "protein_coding",
      gene_name : "ABTB2",
      gene_level : 2,
      hgnc_id : "HGNC:23842",
      havana_gene : "OTTHUMG00000044382.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34438934,
      stop : 34472060,
      direction : "+",
      ID : "ENSG00000121691.7",
      gene_id : "ENSG00000121691.7",
      gene_type : "protein_coding",
      gene_name : "CAT",
      gene_level : 2,
      hgnc_id : "HGNC:1516",
      havana_gene : "OTTHUMG00000044353.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34478791,
      stop : 34525193,
      direction : "-",
      ID : "ENSG00000135374.11",
      gene_id : "ENSG00000135374.11",
      gene_type : "protein_coding",
      gene_name : "ELF5",
      gene_level : 2,
      hgnc_id : "HGNC:3320",
      havana_gene : "OTTHUMG00000166451.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34621093,
      stop : 34663288,
      direction : "+",
      ID : "ENSG00000135373.13",
      gene_id : "ENSG00000135373.13",
      gene_type : "protein_coding",
      gene_name : "EHF",
      gene_level : 1,
      hgnc_id : "HGNC:3246",
      havana_gene : "OTTHUMG00000166454.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34853094,
      stop : 34916379,
      direction : "-",
      ID : "ENSG00000149089.13",
      gene_id : "ENSG00000149089.13",
      gene_type : "protein_coding",
      gene_name : "APIP",
      gene_level : 2,
      hgnc_id : "HGNC:17581",
      havana_gene : "OTTHUMG00000166455.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 34915829,
      stop : 35020591,
      direction : "+",
      ID : "ENSG00000110435.12",
      gene_id : "ENSG00000110435.12",
      gene_type : "protein_coding",
      gene_name : "PDHX",
      gene_level : 1,
      hgnc_id : "HGNC:21350",
      havana_gene : "OTTHUMG00000166491.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 35138882,
      stop : 35232402,
      direction : "+",
      ID : "ENSG00000026508.20",
      gene_id : "ENSG00000026508.20",
      gene_type : "protein_coding",
      gene_name : "CD44",
      gene_level : 1,
      hgnc_id : "HGNC:1681",
      havana_gene : "OTTHUMG00000044388.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 35251205,
      stop : 35420063,
      direction : "-",
      ID : "ENSG00000110436.13",
      gene_id : "ENSG00000110436.13",
      gene_type : "protein_coding",
      gene_name : "SLC1A2",
      gene_level : 1,
      hgnc_id : "HGNC:10940",
      havana_gene : "OTTHUMG00000044391.14",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 35431823,
      stop : 35530300,
      direction : "-",
      ID : "ENSG00000149090.12",
      gene_id : "ENSG00000149090.12",
      gene_type : "protein_coding",
      gene_name : "PAMR1",
      gene_level : 1,
      hgnc_id : "HGNC:24554",
      havana_gene : "OTTHUMG00000166328.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 35618460,
      stop : 35620865,
      direction : "+",
      ID : "ENSG00000179431.7",
      gene_id : "ENSG00000179431.7",
      gene_type : "protein_coding",
      gene_name : "FJX1",
      gene_level : 2,
      hgnc_id : "HGNC:17166",
      havana_gene : "OTTHUMG00000166310.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 35662775,
      stop : 35818007,
      direction : "+",
      ID : "ENSG00000166326.7",
      gene_id : "ENSG00000166326.7",
      gene_type : "protein_coding",
      gene_name : "TRIM44",
      gene_level : 2,
      hgnc_id : "HGNC:19016",
      havana_gene : "OTTHUMG00000166312.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 35943981,
      stop : 36232136,
      direction : "+",
      ID : "ENSG00000179241.13",
      gene_id : "ENSG00000179241.13",
      gene_type : "protein_coding",
      gene_name : "LDLRAD3",
      gene_level : 2,
      hgnc_id : "HGNC:27046",
      havana_gene : "OTTHUMG00000166313.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 36269284,
      stop : 36289449,
      direction : "-",
      ID : "ENSG00000110442.12",
      gene_id : "ENSG00000110442.12",
      gene_type : "protein_coding",
      gene_name : "COMMD9",
      gene_level : 1,
      hgnc_id : "HGNC:25014",
      havana_gene : "OTTHUMG00000166333.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 36296288,
      stop : 36465204,
      direction : "+",
      ID : "ENSG00000135362.14",
      gene_id : "ENSG00000135362.14",
      gene_type : "protein_coding",
      gene_name : "PRR5L",
      gene_level : 1,
      hgnc_id : "HGNC:25878",
      havana_gene : "OTTHUMG00000166334.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 36483769,
      stop : 36510272,
      direction : "-",
      ID : "ENSG00000175104.15",
      gene_id : "ENSG00000175104.15",
      gene_type : "protein_coding",
      gene_name : "TRAF6",
      gene_level : 2,
      hgnc_id : "HGNC:12036",
      havana_gene : "OTTHUMG00000166391.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 36510709,
      stop : 36593156,
      direction : "+",
      ID : "ENSG00000166349.10",
      gene_id : "ENSG00000166349.10",
      gene_type : "protein_coding",
      gene_name : "RAG1",
      gene_level : 1,
      hgnc_id : "HGNC:9831",
      havana_gene : "OTTHUMG00000166392.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 36575574,
      stop : 36598279,
      direction : "-",
      ID : "ENSG00000175097.8",
      gene_id : "ENSG00000175097.8",
      gene_type : "protein_coding",
      gene_name : "RAG2",
      gene_level : 2,
      hgnc_id : "HGNC:9832",
      havana_gene : "OTTHUMG00000166393.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 36594369,
      stop : 36675695,
      direction : "+",
      ID : "ENSG00000166352.18",
      gene_id : "ENSG00000166352.18",
      gene_type : "protein_coding",
      gene_name : "IFTAP",
      gene_level : 2,
      hgnc_id : "HGNC:25142",
      havana_gene : "OTTHUMG00000166397.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 40114203,
      stop : 41459773,
      direction : "-",
      ID : "ENSG00000148948.8",
      gene_id : "ENSG00000148948.8",
      gene_type : "protein_coding",
      gene_name : "LRRC4C",
      gene_level : 2,
      hgnc_id : "HGNC:29317",
      havana_gene : "OTTHUMG00000166383.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 43311963,
      stop : 43344529,
      direction : "+",
      ID : "ENSG00000166181.13",
      gene_id : "ENSG00000166181.13",
      gene_type : "protein_coding",
      gene_name : "API5",
      gene_level : 2,
      hgnc_id : "HGNC:594",
      havana_gene : "OTTHUMG00000166395.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 43358920,
      stop : 43494933,
      direction : "+",
      ID : "ENSG00000052841.15",
      gene_id : "ENSG00000052841.15",
      gene_type : "protein_coding",
      gene_name : "TTC17",
      gene_level : 2,
      hgnc_id : "HGNC:25596",
      havana_gene : "OTTHUMG00000166398.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 43680680,
      stop : 43856617,
      direction : "+",
      ID : "ENSG00000149084.13",
      gene_id : "ENSG00000149084.13",
      gene_type : "protein_coding",
      gene_name : "HSD17B12",
      gene_level : 1,
      hgnc_id : "HGNC:18646",
      havana_gene : "OTTHUMG00000166403.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 43880811,
      stop : 43920274,
      direction : "+",
      ID : "ENSG00000166199.13",
      gene_id : "ENSG00000166199.13",
      gene_type : "protein_coding",
      gene_name : "ALKBH3",
      gene_level : 2,
      hgnc_id : "HGNC:30141",
      havana_gene : "OTTHUMG00000166417.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 43925342,
      stop : 43943878,
      direction : "+",
      ID : "ENSG00000187479.8",
      gene_id : "ENSG00000187479.8",
      gene_type : "protein_coding",
      gene_name : "C11orf96",
      gene_level : 2,
      hgnc_id : "HGNC:38675",
      havana_gene : "OTTHUMG00000166555.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44047981,
      stop : 44059977,
      direction : "+",
      ID : "ENSG00000205126.2",
      gene_id : "ENSG00000205126.2",
      gene_type : "protein_coding",
      gene_name : "ACCSL",
      gene_level : 2,
      hgnc_id : "HGNC:34391",
      havana_gene : "OTTHUMG00000166426.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44065925,
      stop : 44084237,
      direction : "+",
      ID : "ENSG00000110455.14",
      gene_id : "ENSG00000110455.14",
      gene_type : "protein_coding",
      gene_name : "ACCS",
      gene_level : 2,
      hgnc_id : "HGNC:23989",
      havana_gene : "OTTHUMG00000166427.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44095673,
      stop : 44251962,
      direction : "+",
      ID : "ENSG00000151348.15",
      gene_id : "ENSG00000151348.15",
      gene_type : "protein_coding",
      gene_name : "EXT2",
      gene_level : 2,
      hgnc_id : "HGNC:3513",
      havana_gene : "OTTHUMG00000166498.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44260440,
      stop : 44310139,
      direction : "-",
      ID : "ENSG00000052850.8",
      gene_id : "ENSG00000052850.8",
      gene_type : "protein_coding",
      gene_name : "ALX4",
      gene_level : 2,
      hgnc_id : "HGNC:450",
      havana_gene : "OTTHUMG00000166557.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44564427,
      stop : 44620358,
      direction : "+",
      ID : "ENSG00000085117.12",
      gene_id : "ENSG00000085117.12",
      gene_type : "protein_coding",
      gene_name : "CD82",
      gene_level : 1,
      hgnc_id : "HGNC:6210",
      havana_gene : "OTTHUMG00000166472.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44726465,
      stop : 44932423,
      direction : "+",
      ID : "ENSG00000157570.12",
      gene_id : "ENSG00000157570.12",
      gene_type : "protein_coding",
      gene_name : "TSPAN18",
      gene_level : 1,
      hgnc_id : "HGNC:20660",
      havana_gene : "OTTHUMG00000163883.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 44885903,
      stop : 44951306,
      direction : "-",
      ID : "ENSG00000175274.19",
      gene_id : "ENSG00000175274.19",
      gene_type : "protein_coding",
      gene_name : "TP53I11",
      gene_level : 1,
      hgnc_id : "HGNC:16842",
      havana_gene : "OTTHUMG00000165714.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45095806,
      stop : 45235110,
      direction : "+",
      ID : "ENSG00000019485.13",
      gene_id : "ENSG00000019485.13",
      gene_type : "protein_coding",
      gene_name : "PRDM11",
      gene_level : 1,
      hgnc_id : "HGNC:13996",
      havana_gene : "OTTHUMG00000166478.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45240302,
      stop : 45286341,
      direction : "-",
      ID : "ENSG00000019505.8",
      gene_id : "ENSG00000019505.8",
      gene_type : "protein_coding",
      gene_name : "SYT13",
      gene_level : 2,
      hgnc_id : "HGNC:14962",
      havana_gene : "OTTHUMG00000166504.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45647689,
      stop : 45665622,
      direction : "-",
      ID : "ENSG00000175264.8",
      gene_id : "ENSG00000175264.8",
      gene_type : "protein_coding",
      gene_name : "CHST1",
      gene_level : 2,
      hgnc_id : "HGNC:1969",
      havana_gene : "OTTHUMG00000166513.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45804072,
      stop : 45813016,
      direction : "+",
      ID : "ENSG00000181830.9",
      gene_id : "ENSG00000181830.9",
      gene_type : "protein_coding",
      gene_name : "SLC35C1",
      gene_level : 2,
      hgnc_id : "HGNC:20197",
      havana_gene : "OTTHUMG00000166519.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45847118,
      stop : 45883248,
      direction : "+",
      ID : "ENSG00000121671.12",
      gene_id : "ENSG00000121671.12",
      gene_type : "protein_coding",
      gene_name : "CRY2",
      gene_level : 2,
      hgnc_id : "HGNC:2385",
      havana_gene : "OTTHUMG00000153225.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45885651,
      stop : 45906465,
      direction : "+",
      ID : "ENSG00000121653.11",
      gene_id : "ENSG00000121653.11",
      gene_type : "protein_coding",
      gene_name : "MAPK8IP1",
      gene_level : 1,
      hgnc_id : "HGNC:6882",
      havana_gene : "OTTHUMG00000134324.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45906513,
      stop : 45907272,
      direction : "-",
      ID : "ENSG00000234776.5",
      gene_id : "ENSG00000234776.5",
      gene_type : "protein_coding",
      gene_name : "C11orf94",
      gene_level : 2,
      hgnc_id : "HGNC:37213",
      havana_gene : "OTTHUMG00000167004.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45909663,
      stop : 45918812,
      direction : "-",
      ID : "ENSG00000121680.16",
      gene_id : "ENSG00000121680.16",
      gene_type : "protein_coding",
      gene_name : "PEX16",
      gene_level : 2,
      hgnc_id : "HGNC:8857",
      havana_gene : "OTTHUMG00000167005.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45921621,
      stop : 45929096,
      direction : "+",
      ID : "ENSG00000165905.18",
      gene_id : "ENSG00000165905.18",
      gene_type : "protein_coding",
      gene_name : "LARGE2",
      gene_level : 1,
      hgnc_id : "HGNC:16522",
      havana_gene : "OTTHUMG00000167037.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 45929319,
      stop : 46121454,
      direction : "-",
      ID : "ENSG00000135365.16",
      gene_id : "ENSG00000135365.16",
      gene_type : "protein_coding",
      gene_name : "PHF21A",
      gene_level : 2,
      hgnc_id : "HGNC:24156",
      havana_gene : "OTTHUMG00000167038.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46277662,
      stop : 46321409,
      direction : "+",
      ID : "ENSG00000157613.11",
      gene_id : "ENSG00000157613.11",
      gene_type : "protein_coding",
      gene_name : "CREB3L1",
      gene_level : 1,
      hgnc_id : "HGNC:18856",
      havana_gene : "OTTHUMG00000166423.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46332905,
      stop : 46380554,
      direction : "+",
      ID : "ENSG00000149091.15",
      gene_id : "ENSG00000149091.15",
      gene_type : "protein_coding",
      gene_name : "DGKZ",
      gene_level : 2,
      hgnc_id : "HGNC:2857",
      havana_gene : "OTTHUMG00000166437.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46380756,
      stop : 46383837,
      direction : "+",
      ID : "ENSG00000110492.16",
      gene_id : "ENSG00000110492.16",
      gene_type : "protein_coding",
      gene_name : "MDK",
      gene_level : 2,
      hgnc_id : "HGNC:6972",
      havana_gene : "OTTHUMG00000150315.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46385098,
      stop : 46386608,
      direction : "-",
      ID : "ENSG00000180720.7",
      gene_id : "ENSG00000180720.7",
      gene_type : "protein_coding",
      gene_name : "CHRM4",
      gene_level : 2,
      hgnc_id : "HGNC:1953",
      havana_gene : "OTTHUMG00000154371.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46396414,
      stop : 46594125,
      direction : "-",
      ID : "ENSG00000110497.14",
      gene_id : "ENSG00000110497.14",
      gene_type : "protein_coding",
      gene_name : "AMBRA1",
      gene_level : 1,
      hgnc_id : "HGNC:25990",
      havana_gene : "OTTHUMG00000166500.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46602861,
      stop : 46617909,
      direction : "-",
      ID : "ENSG00000180423.4",
      gene_id : "ENSG00000180423.4",
      gene_type : "protein_coding",
      gene_name : "HARBI1",
      gene_level : 2,
      hgnc_id : "HGNC:26522",
      havana_gene : "OTTHUMG00000166537.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46617527,
      stop : 46674818,
      direction : "+",
      ID : "ENSG00000175224.16",
      gene_id : "ENSG00000175224.16",
      gene_type : "protein_coding",
      gene_name : "ATG13",
      gene_level : 1,
      hgnc_id : "HGNC:29091",
      havana_gene : "OTTHUMG00000166538.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46677080,
      stop : 46700619,
      direction : "-",
      ID : "ENSG00000175220.12",
      gene_id : "ENSG00000175220.12",
      gene_type : "protein_coding",
      gene_name : "ARHGAP1",
      gene_level : 2,
      hgnc_id : "HGNC:673",
      havana_gene : "OTTHUMG00000166567.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46701030,
      stop : 46705912,
      direction : "+",
      ID : "ENSG00000175213.3",
      gene_id : "ENSG00000175213.3",
      gene_type : "protein_coding",
      gene_name : "ZNF408",
      gene_level : 2,
      hgnc_id : "HGNC:20041",
      havana_gene : "OTTHUMG00000166568.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46719196,
      stop : 46739506,
      direction : "+",
      ID : "ENSG00000180210.15",
      gene_id : "ENSG00000180210.15",
      gene_type : "protein_coding",
      gene_name : "F2",
      gene_level : 1,
      hgnc_id : "HGNC:3535",
      havana_gene : "OTTHUMG00000150344.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46743048,
      stop : 46846308,
      direction : "-",
      ID : "ENSG00000175216.15",
      gene_id : "ENSG00000175216.15",
      gene_type : "protein_coding",
      gene_name : "CKAP5",
      gene_level : 1,
      hgnc_id : "HGNC:28959",
      havana_gene : "OTTHUMG00000166599.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46856717,
      stop : 46918642,
      direction : "-",
      ID : "ENSG00000134569.10",
      gene_id : "ENSG00000134569.10",
      gene_type : "protein_coding",
      gene_name : "LRP4",
      gene_level : 2,
      hgnc_id : "HGNC:6696",
      havana_gene : "OTTHUMG00000166700.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 46936689,
      stop : 47164385,
      direction : "+",
      ID : "ENSG00000149179.14",
      gene_id : "ENSG00000149179.14",
      gene_type : "protein_coding",
      gene_name : "C11orf49",
      gene_level : 2,
      hgnc_id : "HGNC:28720",
      havana_gene : "OTTHUMG00000166725.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47164299,
      stop : 47177125,
      direction : "-",
      ID : "ENSG00000149182.15",
      gene_id : "ENSG00000149182.15",
      gene_type : "protein_coding",
      gene_name : "ARFGAP2",
      gene_level : 1,
      hgnc_id : "HGNC:13504",
      havana_gene : "OTTHUMG00000166773.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47177522,
      stop : 47186443,
      direction : "-",
      ID : "ENSG00000165912.16",
      gene_id : "ENSG00000165912.16",
      gene_type : "protein_coding",
      gene_name : "PACSIN3",
      gene_level : 1,
      hgnc_id : "HGNC:8572",
      havana_gene : "OTTHUMG00000166870.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47214465,
      stop : 47239217,
      direction : "+",
      ID : "ENSG00000134574.12",
      gene_id : "ENSG00000134574.12",
      gene_type : "protein_coding",
      gene_name : "DDB2",
      gene_level : 2,
      hgnc_id : "HGNC:2718",
      havana_gene : "OTTHUMG00000187453.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47239302,
      stop : 47248906,
      direction : "-",
      ID : "ENSG00000134575.13",
      gene_id : "ENSG00000134575.13",
      gene_type : "protein_coding",
      gene_name : "ACP2",
      gene_level : 1,
      hgnc_id : "HGNC:123",
      havana_gene : "OTTHUMG00000166949.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47248300,
      stop : 47269033,
      direction : "+",
      ID : "ENSG00000025434.19",
      gene_id : "ENSG00000025434.19",
      gene_type : "protein_coding",
      gene_name : "NR1H3",
      gene_level : 1,
      hgnc_id : "HGNC:7966",
      havana_gene : "OTTHUMG00000150628.11",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47269161,
      stop : 47330031,
      direction : "+",
      ID : "ENSG00000110514.19",
      gene_id : "ENSG00000110514.19",
      gene_type : "protein_coding",
      gene_name : "MADD",
      gene_level : 1,
      hgnc_id : "HGNC:6766",
      havana_gene : "OTTHUMG00000150350.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47331406,
      stop : 47352702,
      direction : "-",
      ID : "ENSG00000134571.11",
      gene_id : "ENSG00000134571.11",
      gene_type : "protein_coding",
      gene_name : "MYBPC3",
      gene_level : 2,
      hgnc_id : "HGNC:7551",
      havana_gene : "OTTHUMG00000166986.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47354860,
      stop : 47378547,
      direction : "-",
      ID : "ENSG00000066336.12",
      gene_id : "ENSG00000066336.12",
      gene_type : "protein_coding",
      gene_name : "SPI1",
      gene_level : 1,
      hgnc_id : "HGNC:11241",
      havana_gene : "OTTHUMG00000150150.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47407132,
      stop : 47416496,
      direction : "+",
      ID : "ENSG00000165915.14",
      gene_id : "ENSG00000165915.14",
      gene_type : "protein_coding",
      gene_name : "SLC39A13",
      gene_level : 1,
      hgnc_id : "HGNC:20859",
      havana_gene : "OTTHUMG00000166890.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47418769,
      stop : 47426473,
      direction : "-",
      ID : "ENSG00000165916.9",
      gene_id : "ENSG00000165916.9",
      gene_type : "protein_coding",
      gene_name : "PSMC3",
      gene_level : 1,
      hgnc_id : "HGNC:9549",
      havana_gene : "OTTHUMG00000167692.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47437764,
      stop : 47449143,
      direction : "-",
      ID : "ENSG00000165917.10",
      gene_id : "ENSG00000165917.10",
      gene_type : "protein_coding",
      gene_name : "RAPSN",
      gene_level : 1,
      hgnc_id : "HGNC:9863",
      havana_gene : "OTTHUMG00000166891.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47465933,
      stop : 47565569,
      direction : "-",
      ID : "ENSG00000149187.18",
      gene_id : "ENSG00000149187.18",
      gene_type : "protein_coding",
      gene_name : "CELF1",
      gene_level : 1,
      hgnc_id : "HGNC:2549",
      havana_gene : "OTTHUMG00000166526.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47565336,
      stop : 47584562,
      direction : "+",
      ID : "ENSG00000213619.11",
      gene_id : "ENSG00000213619.11",
      gene_type : "protein_coding",
      gene_name : "NDUFS3",
      gene_level : 1,
      hgnc_id : "HGNC:7710",
      havana_gene : "OTTHUMG00000166893.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47565430,
      stop : 47573461,
      direction : "+",
      ID : "ENSG00000110536.14",
      gene_id : "ENSG00000110536.14",
      gene_type : "protein_coding",
      gene_name : "PTPMT1",
      gene_level : 2,
      hgnc_id : "HGNC:26965",
      havana_gene : "OTTHUMG00000166892.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47572197,
      stop : 47578976,
      direction : "-",
      ID : "ENSG00000123444.14",
      gene_id : "ENSG00000123444.14",
      gene_type : "protein_coding",
      gene_name : "KBTBD4",
      gene_level : 1,
      hgnc_id : "HGNC:23761",
      havana_gene : "OTTHUMG00000166894.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47586678,
      stop : 47589194,
      direction : "+",
      ID : "ENSG00000196666.6",
      gene_id : "ENSG00000196666.6",
      gene_type : "protein_coding",
      gene_name : "FAM180B",
      gene_level : 2,
      hgnc_id : "HGNC:34451",
      havana_gene : "OTTHUMG00000167871.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47589667,
      stop : 47594411,
      direction : "-",
      ID : "ENSG00000172247.4",
      gene_id : "ENSG00000172247.4",
      gene_type : "protein_coding",
      gene_name : "C1QTNF4",
      gene_level : 2,
      hgnc_id : "HGNC:14346",
      havana_gene : "OTTHUMG00000166895.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47617315,
      stop : 47642607,
      direction : "-",
      ID : "ENSG00000109919.10",
      gene_id : "ENSG00000109919.10",
      gene_type : "protein_coding",
      gene_name : "MTCH2",
      gene_level : 2,
      hgnc_id : "HGNC:17587",
      havana_gene : "OTTHUMG00000166926.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47659591,
      stop : 47715389,
      direction : "-",
      ID : "ENSG00000165923.16",
      gene_id : "ENSG00000165923.16",
      gene_type : "protein_coding",
      gene_name : "AGBL2",
      gene_level : 1,
      hgnc_id : "HGNC:26296",
      havana_gene : "OTTHUMG00000165368.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47716494,
      stop : 47767443,
      direction : "-",
      ID : "ENSG00000109920.13",
      gene_id : "ENSG00000109920.13",
      gene_type : "protein_coding",
      gene_name : "FNBP4",
      gene_level : 1,
      hgnc_id : "HGNC:19752",
      havana_gene : "OTTHUMG00000166533.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47778087,
      stop : 47848555,
      direction : "-",
      ID : "ENSG00000030066.13",
      gene_id : "ENSG00000030066.13",
      gene_type : "protein_coding",
      gene_name : "NUP160",
      gene_level : 2,
      hgnc_id : "HGNC:18017",
      havana_gene : "OTTHUMG00000166534.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 47980558,
      stop : 48170841,
      direction : "+",
      ID : "ENSG00000149177.13",
      gene_id : "ENSG00000149177.13",
      gene_type : "protein_coding",
      gene_name : "PTPRJ",
      gene_level : 1,
      hgnc_id : "HGNC:9673",
      havana_gene : "OTTHUMG00000166573.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48216810,
      stop : 48217739,
      direction : "+",
      ID : "ENSG00000175619.3",
      gene_id : "ENSG00000175619.3",
      gene_type : "protein_coding",
      gene_name : "OR4B1",
      gene_level : 2,
      hgnc_id : "HGNC:8290",
      havana_gene : "OTTHUMG00000166576.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48245056,
      stop : 48246080,
      direction : "+",
      ID : "ENSG00000172208.6",
      gene_id : "ENSG00000172208.6",
      gene_type : "protein_coding",
      gene_name : "OR4X2",
      gene_level : 2,
      hgnc_id : "HGNC:15184",
      havana_gene : "OTTHUMG00000165302.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48263861,
      stop : 48264778,
      direction : "+",
      ID : "ENSG00000176567.1",
      gene_id : "ENSG00000176567.1",
      gene_type : "protein_coding",
      gene_name : "OR4X1",
      gene_level : 2,
      hgnc_id : "HGNC:14854",
      havana_gene : "OTTHUMG00000165301.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48306223,
      stop : 48307152,
      direction : "+",
      ID : "ENSG00000176555.1",
      gene_id : "ENSG00000176555.1",
      gene_type : "protein_coding",
      gene_name : "OR4S1",
      gene_level : 2,
      hgnc_id : "HGNC:14705",
      havana_gene : "OTTHUMG00000166578.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48324920,
      stop : 48328471,
      direction : "+",
      ID : "ENSG00000176547.10",
      gene_id : "ENSG00000176547.10",
      gene_type : "protein_coding",
      gene_name : "OR4C3",
      gene_level : 2,
      hgnc_id : "HGNC:14697",
      havana_gene : "OTTHUMG00000166579.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48365485,
      stop : 48366465,
      direction : "-",
      ID : "ENSG00000176540.3",
      gene_id : "ENSG00000176540.3",
      gene_type : "protein_coding",
      gene_name : "OR4C5",
      gene_level : 2,
      hgnc_id : "HGNC:14702",
      havana_gene : "OTTHUMG00000169462.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48488717,
      stop : 48489780,
      direction : "+",
      ID : "ENSG00000237388.2",
      gene_id : "ENSG00000237388.2",
      gene_type : "protein_coding",
      gene_name : "OR4A47",
      gene_level : 2,
      hgnc_id : "HGNC:31266",
      havana_gene : "OTTHUMG00000166581.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 48975324,
      stop : 48983826,
      direction : "-",
      ID : "ENSG00000220948.5",
      gene_id : "ENSG00000220948.5",
      gene_type : "protein_coding",
      gene_name : "TRIM51GP",
      gene_level : 2,
      hgnc_id : "HGNC:43972",
      havana_gene : "OTTHUMG00000165215.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 49027501,
      stop : 49038451,
      direction : "+",
      ID : "ENSG00000182053.12",
      gene_id : "ENSG00000182053.12",
      gene_type : "protein_coding",
      gene_name : "TRIM49B",
      gene_level : 2,
      hgnc_id : "HGNC:42955",
      havana_gene : "OTTHUMG00000186986.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 49053714,
      stop : 49059112,
      direction : "-",
      ID : "ENSG00000214891.9",
      gene_id : "ENSG00000214891.9",
      gene_type : "protein_coding",
      gene_name : "TRIM64C",
      gene_level : 2,
      hgnc_id : "HGNC:37148",
      havana_gene : "OTTHUMG00000166752.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 49145092,
      stop : 49208638,
      direction : "-",
      ID : "ENSG00000086205.18",
      gene_id : "ENSG00000086205.18",
      gene_type : "protein_coding",
      gene_name : "FOLH1",
      gene_level : 2,
      hgnc_id : "HGNC:3788",
      havana_gene : "OTTHUMG00000166625.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 49952391,
      stop : 49953419,
      direction : "+",
      ID : "ENSG00000258817.1",
      gene_id : "ENSG00000258817.1",
      gene_type : "protein_coding",
      gene_name : "OR4C13",
      gene_level : 2,
      hgnc_id : "HGNC:15169",
      havana_gene : "OTTHUMG00000166686.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 49981473,
      stop : 49982535,
      direction : "-",
      ID : "ENSG00000221954.2",
      gene_id : "ENSG00000221954.2",
      gene_type : "protein_coding",
      gene_name : "OR4C12",
      gene_level : 2,
      hgnc_id : "HGNC:15168",
      havana_gene : "OTTHUMG00000166687.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 54603069,
      stop : 54603998,
      direction : "-",
      ID : "ENSG00000185926.1",
      gene_id : "ENSG00000185926.1",
      gene_type : "protein_coding",
      gene_name : "OR4C46",
      gene_level : 2,
      hgnc_id : "HGNC:31271",
      havana_gene : "OTTHUMG00000166705.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 54706832,
      stop : 54707902,
      direction : "+",
      ID : "ENSG00000221840.4",
      gene_id : "ENSG00000221840.4",
      gene_type : "protein_coding",
      gene_name : "OR4A5",
      gene_level : 2,
      hgnc_id : "HGNC:15162",
      havana_gene : "OTTHUMG00000166764.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55262155,
      stop : 55271114,
      direction : "+",
      ID : "ENSG00000150244.12",
      gene_id : "ENSG00000150244.12",
      gene_type : "protein_coding",
      gene_name : "TRIM48",
      gene_level : 2,
      hgnc_id : "HGNC:19021",
      havana_gene : "OTTHUMG00000157011.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55343151,
      stop : 55344231,
      direction : "+",
      ID : "ENSG00000181961.4",
      gene_id : "ENSG00000181961.4",
      gene_type : "protein_coding",
      gene_name : "OR4A16",
      gene_level : 2,
      hgnc_id : "HGNC:15153",
      havana_gene : "OTTHUMG00000166710.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55367974,
      stop : 55368918,
      direction : "+",
      ID : "ENSG00000181958.5",
      gene_id : "ENSG00000181958.5",
      gene_type : "protein_coding",
      gene_name : "OR4A15",
      gene_level : 2,
      hgnc_id : "HGNC:15152",
      havana_gene : "OTTHUMG00000166711.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55554307,
      stop : 55555419,
      direction : "+",
      ID : "ENSG00000181939.3",
      gene_id : "ENSG00000181939.3",
      gene_type : "protein_coding",
      gene_name : "OR4C15",
      gene_level : 2,
      hgnc_id : "HGNC:15171",
      havana_gene : "OTTHUMG00000166714.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55572128,
      stop : 55573060,
      direction : "+",
      ID : "ENSG00000279514.2",
      gene_id : "ENSG00000279514.2",
      gene_type : "protein_coding",
      gene_name : "OR4C16",
      gene_level : 2,
      hgnc_id : "HGNC:15172",
      havana_gene : "OTTHUMG00000165198.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55602360,
      stop : 55607645,
      direction : "-",
      ID : "ENSG00000172188.6",
      gene_id : "ENSG00000172188.6",
      gene_type : "protein_coding",
      gene_name : "OR4C11",
      gene_level : 2,
      hgnc_id : "HGNC:15167",
      havana_gene : "OTTHUMG00000165290.11",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55635113,
      stop : 55640309,
      direction : "+",
      ID : "ENSG00000181927.4",
      gene_id : "ENSG00000181927.4",
      gene_type : "protein_coding",
      gene_name : "OR4P4",
      gene_level : 2,
      hgnc_id : "HGNC:15180",
      havana_gene : "OTTHUMG00000165300.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55648327,
      stop : 55652854,
      direction : "+",
      ID : "ENSG00000174982.4",
      gene_id : "ENSG00000174982.4",
      gene_type : "protein_coding",
      gene_name : "OR4S2",
      gene_level : 2,
      hgnc_id : "HGNC:15183",
      havana_gene : "OTTHUMG00000166799.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55662201,
      stop : 55666195,
      direction : "+",
      ID : "ENSG00000181903.5",
      gene_id : "ENSG00000181903.5",
      gene_type : "protein_coding",
      gene_name : "OR4C6",
      gene_level : 2,
      hgnc_id : "HGNC:14743",
      havana_gene : "OTTHUMG00000166800.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55723776,
      stop : 55729621,
      direction : "+",
      ID : "ENSG00000186886.8",
      gene_id : "ENSG00000186886.8",
      gene_type : "protein_coding",
      gene_name : "OR5D3P",
      gene_level : 2,
      hgnc_id : "HGNC:8336",
      havana_gene : "OTTHUMG00000166805.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55773438,
      stop : 55774382,
      direction : "+",
      ID : "ENSG00000279761.2",
      gene_id : "ENSG00000279761.2",
      gene_type : "protein_coding",
      gene_name : "OR5D13",
      gene_level : 2,
      hgnc_id : "HGNC:15280",
      havana_gene : "OTTHUMG00000166807.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55795556,
      stop : 55796500,
      direction : "+",
      ID : "ENSG00000186113.1",
      gene_id : "ENSG00000186113.1",
      gene_type : "protein_coding",
      gene_name : "OR5D14",
      gene_level : 2,
      hgnc_id : "HGNC:15281",
      havana_gene : "OTTHUMG00000166809.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55811367,
      stop : 55812476,
      direction : "+",
      ID : "ENSG00000279395.3",
      gene_id : "ENSG00000279395.3",
      gene_type : "protein_coding",
      gene_name : "OR5L1",
      gene_level : 2,
      hgnc_id : "HGNC:8350",
      havana_gene : "OTTHUMG00000166810.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55819607,
      stop : 55820597,
      direction : "+",
      ID : "ENSG00000186119.8",
      gene_id : "ENSG00000186119.8",
      gene_type : "protein_coding",
      gene_name : "OR5D18",
      gene_level : 2,
      hgnc_id : "HGNC:15285",
      havana_gene : "OTTHUMG00000166811.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55827219,
      stop : 55828154,
      direction : "+",
      ID : "ENSG00000205030.1",
      gene_id : "ENSG00000205030.1",
      gene_type : "protein_coding",
      gene_name : "OR5L2",
      gene_level : 2,
      hgnc_id : "HGNC:8351",
      havana_gene : "OTTHUMG00000166812.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55838752,
      stop : 55839738,
      direction : "+",
      ID : "ENSG00000205029.1",
      gene_id : "ENSG00000205029.1",
      gene_type : "protein_coding",
      gene_name : "OR5D16",
      gene_level : 2,
      hgnc_id : "HGNC:15283",
      havana_gene : "OTTHUMG00000154233.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55883297,
      stop : 55891810,
      direction : "+",
      ID : "ENSG00000124900.12",
      gene_id : "ENSG00000124900.12",
      gene_type : "protein_coding",
      gene_name : "TRIM51",
      gene_level : 1,
      hgnc_id : "HGNC:19023",
      havana_gene : "OTTHUMG00000156437.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55913650,
      stop : 55914582,
      direction : "-",
      ID : "ENSG00000187612.1",
      gene_id : "ENSG00000187612.1",
      gene_type : "protein_coding",
      gene_name : "OR5W2",
      gene_level : 2,
      hgnc_id : "HGNC:15299",
      havana_gene : "OTTHUMG00000166818.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55935456,
      stop : 55936400,
      direction : "-",
      ID : "ENSG00000167825.3",
      gene_id : "ENSG00000167825.3",
      gene_type : "protein_coding",
      gene_name : "OR5I1",
      gene_level : 2,
      hgnc_id : "HGNC:8347",
      havana_gene : "OTTHUMG00000166821.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55965755,
      stop : 55969945,
      direction : "-",
      ID : "ENSG00000174970.5",
      gene_id : "ENSG00000174970.5",
      gene_type : "protein_coding",
      gene_name : "OR10AG1",
      gene_level : 2,
      hgnc_id : "HGNC:19607",
      havana_gene : "OTTHUMG00000166824.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 55993681,
      stop : 55994625,
      direction : "-",
      ID : "ENSG00000149133.1",
      gene_id : "ENSG00000149133.1",
      gene_type : "protein_coding",
      gene_name : "OR5F1",
      gene_level : 2,
      hgnc_id : "HGNC:8343",
      havana_gene : "OTTHUMG00000166825.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56027654,
      stop : 56038191,
      direction : "+",
      ID : "ENSG00000181785.3",
      gene_id : "ENSG00000181785.3",
      gene_type : "protein_coding",
      gene_name : "OR5AS1",
      gene_level : 2,
      hgnc_id : "HGNC:15261",
      havana_gene : "OTTHUMG00000166830.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56093277,
      stop : 56094286,
      direction : "+",
      ID : "ENSG00000172154.10",
      gene_id : "ENSG00000172154.10",
      gene_type : "protein_coding",
      gene_name : "OR8I2",
      gene_level : 2,
      hgnc_id : "HGNC:15310",
      havana_gene : "OTTHUMG00000166831.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56103687,
      stop : 56107658,
      direction : "+",
      ID : "ENSG00000181767.3",
      gene_id : "ENSG00000181767.3",
      gene_type : "protein_coding",
      gene_name : "OR8H2",
      gene_level : 2,
      hgnc_id : "HGNC:15308",
      havana_gene : "OTTHUMG00000166832.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56122373,
      stop : 56123311,
      direction : "+",
      ID : "ENSG00000181761.5",
      gene_id : "ENSG00000181761.5",
      gene_type : "protein_coding",
      gene_name : "OR8H3",
      gene_level : 2,
      hgnc_id : "HGNC:15309",
      havana_gene : "OTTHUMG00000166833.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56134721,
      stop : 56140201,
      direction : "-",
      ID : "ENSG00000167822.3",
      gene_id : "ENSG00000167822.3",
      gene_type : "protein_coding",
      gene_name : "OR8J3",
      gene_level : 2,
      hgnc_id : "HGNC:15312",
      havana_gene : "OTTHUMG00000166834.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56159394,
      stop : 56160317,
      direction : "-",
      ID : "ENSG00000181752.3",
      gene_id : "ENSG00000181752.3",
      gene_type : "protein_coding",
      gene_name : "OR8K5",
      gene_level : 2,
      hgnc_id : "HGNC:15315",
      havana_gene : "OTTHUMG00000166820.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56176618,
      stop : 56177556,
      direction : "+",
      ID : "ENSG00000174957.1",
      gene_id : "ENSG00000174957.1",
      gene_type : "protein_coding",
      gene_name : "OR5J2",
      gene_level : 2,
      hgnc_id : "HGNC:19612",
      havana_gene : "OTTHUMG00000166835.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56231282,
      stop : 56234255,
      direction : "-",
      ID : "ENSG00000181718.6",
      gene_id : "ENSG00000181718.6",
      gene_type : "protein_coding",
      gene_name : "OR5T2",
      gene_level : 2,
      hgnc_id : "HGNC:15296",
      havana_gene : "OTTHUMG00000166851.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56252254,
      stop : 56253222,
      direction : "+",
      ID : "ENSG00000172489.7",
      gene_id : "ENSG00000172489.7",
      gene_type : "protein_coding",
      gene_name : "OR5T3",
      gene_level : 2,
      hgnc_id : "HGNC:15297",
      havana_gene : "OTTHUMG00000166852.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56274154,
      stop : 56276819,
      direction : "+",
      ID : "ENSG00000181698.4",
      gene_id : "ENSG00000181698.4",
      gene_type : "protein_coding",
      gene_name : "OR5T1",
      gene_level : 2,
      hgnc_id : "HGNC:14821",
      havana_gene : "OTTHUMG00000166853.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56288462,
      stop : 56292254,
      direction : "-",
      ID : "ENSG00000181693.8",
      gene_id : "ENSG00000181693.8",
      gene_type : "protein_coding",
      gene_name : "OR8H1",
      gene_level : 2,
      hgnc_id : "HGNC:14824",
      havana_gene : "OTTHUMG00000162671.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56315144,
      stop : 56320639,
      direction : "+",
      ID : "ENSG00000280314.3",
      gene_id : "ENSG00000280314.3",
      gene_type : "protein_coding",
      gene_name : "OR8K3",
      gene_level : 2,
      hgnc_id : "HGNC:15313",
      havana_gene : "OTTHUMG00000166855.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56345945,
      stop : 56347031,
      direction : "+",
      ID : "ENSG00000150261.4",
      gene_id : "ENSG00000150261.4",
      gene_type : "protein_coding",
      gene_name : "OR8K1",
      gene_level : 2,
      hgnc_id : "HGNC:14831",
      havana_gene : "OTTHUMG00000166858.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56354291,
      stop : 56361511,
      direction : "+",
      ID : "ENSG00000172487.4",
      gene_id : "ENSG00000172487.4",
      gene_type : "protein_coding",
      gene_name : "OR8J1",
      gene_level : 2,
      hgnc_id : "HGNC:14855",
      havana_gene : "OTTHUMG00000166859.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56375624,
      stop : 56376553,
      direction : "+",
      ID : "ENSG00000172199.1",
      gene_id : "ENSG00000172199.1",
      gene_type : "protein_coding",
      gene_name : "OR8U1",
      gene_level : 2,
      hgnc_id : "HGNC:19611",
      havana_gene : "OTTHUMG00000166860.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56417258,
      stop : 56418232,
      direction : "-",
      ID : "ENSG00000279961.2",
      gene_id : "ENSG00000279961.2",
      gene_type : "protein_coding",
      gene_name : "OR8U3",
      gene_level : 2,
      hgnc_id : "HGNC:14841",
      havana_gene : "OTTHUMG00000154219.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56459221,
      stop : 56473352,
      direction : "-",
      ID : "ENSG00000284732.1",
      gene_id : "ENSG00000284732.1",
      gene_type : "protein_coding",
      gene_name : "AP002512.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192299.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56462469,
      stop : 56463401,
      direction : "-",
      ID : "ENSG00000150269.1",
      gene_id : "ENSG00000150269.1",
      gene_type : "protein_coding",
      gene_name : "OR5M9",
      gene_level : 2,
      hgnc_id : "HGNC:15294",
      havana_gene : "OTTHUMG00000166874.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56469274,
      stop : 56473352,
      direction : "-",
      ID : "ENSG00000174937.5",
      gene_id : "ENSG00000174937.5",
      gene_type : "protein_coding",
      gene_name : "OR5M3",
      gene_level : 2,
      hgnc_id : "HGNC:14806",
      havana_gene : "OTTHUMG00000166875.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56490349,
      stop : 56491395,
      direction : "-",
      ID : "ENSG00000181371.4",
      gene_id : "ENSG00000181371.4",
      gene_type : "protein_coding",
      gene_name : "OR5M8",
      gene_level : 2,
      hgnc_id : "HGNC:14846",
      havana_gene : "OTTHUMG00000166877.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56542262,
      stop : 56543281,
      direction : "-",
      ID : "ENSG00000255223.4",
      gene_id : "ENSG00000255223.4",
      gene_type : "protein_coding",
      gene_name : "OR5M11",
      gene_level : 2,
      hgnc_id : "HGNC:15291",
      havana_gene : "OTTHUMG00000166861.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56576736,
      stop : 56577787,
      direction : "-",
      ID : "ENSG00000254834.4",
      gene_id : "ENSG00000254834.4",
      gene_type : "protein_coding",
      gene_name : "OR5M10",
      gene_level : 2,
      hgnc_id : "HGNC:15290",
      havana_gene : "OTTHUMG00000166862.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56609236,
      stop : 56614874,
      direction : "-",
      ID : "ENSG00000255012.2",
      gene_id : "ENSG00000255012.2",
      gene_type : "protein_coding",
      gene_name : "OR5M1",
      gene_level : 2,
      hgnc_id : "HGNC:8352",
      havana_gene : "OTTHUMG00000166863.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56641466,
      stop : 56642471,
      direction : "-",
      ID : "ENSG00000172464.3",
      gene_id : "ENSG00000172464.3",
      gene_type : "protein_coding",
      gene_name : "OR5AP2",
      gene_level : 2,
      hgnc_id : "HGNC:15258",
      havana_gene : "OTTHUMG00000166865.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56663662,
      stop : 56664687,
      direction : "+",
      ID : "ENSG00000172459.4",
      gene_id : "ENSG00000172459.4",
      gene_type : "protein_coding",
      gene_name : "OR5AR1",
      gene_level : 2,
      hgnc_id : "HGNC:15260",
      havana_gene : "OTTHUMG00000154213.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56699095,
      stop : 56703884,
      direction : "+",
      ID : "ENSG00000174914.3",
      gene_id : "ENSG00000174914.3",
      gene_type : "protein_coding",
      gene_name : "OR9G1",
      gene_level : 2,
      hgnc_id : "HGNC:15319",
      havana_gene : "OTTHUMG00000167112.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56741223,
      stop : 56748697,
      direction : "-",
      ID : "ENSG00000172457.7",
      gene_id : "ENSG00000172457.7",
      gene_type : "protein_coding",
      gene_name : "OR9G4",
      gene_level : 2,
      hgnc_id : "HGNC:15322",
      havana_gene : "OTTHUMG00000166932.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 56988872,
      stop : 56989867,
      direction : "+",
      ID : "ENSG00000181273.2",
      gene_id : "ENSG00000181273.2",
      gene_type : "protein_coding",
      gene_name : "OR5AK2",
      gene_level : 2,
      hgnc_id : "HGNC:15251",
      havana_gene : "OTTHUMG00000167019.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57181747,
      stop : 57191717,
      direction : "+",
      ID : "ENSG00000183908.7",
      gene_id : "ENSG00000183908.7",
      gene_type : "protein_coding",
      gene_name : "LRRC55",
      gene_level : 2,
      hgnc_id : "HGNC:32324",
      havana_gene : "OTTHUMG00000159309.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57233577,
      stop : 57237235,
      direction : "-",
      ID : "ENSG00000134817.11",
      gene_id : "ENSG00000134817.11",
      gene_type : "protein_coding",
      gene_name : "APLNR",
      gene_level : 2,
      hgnc_id : "HGNC:339",
      havana_gene : "OTTHUMG00000167021.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57299638,
      stop : 57324952,
      direction : "-",
      ID : "ENSG00000149115.14",
      gene_id : "ENSG00000149115.14",
      gene_type : "protein_coding",
      gene_name : "TNKS1BP1",
      gene_level : 2,
      hgnc_id : "HGNC:19081",
      havana_gene : "OTTHUMG00000167022.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57325986,
      stop : 57335892,
      direction : "-",
      ID : "ENSG00000149136.9",
      gene_id : "ENSG00000149136.9",
      gene_type : "protein_coding",
      gene_name : "SSRP1",
      gene_level : 1,
      hgnc_id : "HGNC:11327",
      havana_gene : "OTTHUMG00000167024.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57338352,
      stop : 57372396,
      direction : "+",
      ID : "ENSG00000109991.9",
      gene_id : "ENSG00000109991.9",
      gene_type : "protein_coding",
      gene_name : "P2RX3",
      gene_level : 2,
      hgnc_id : "HGNC:8534",
      havana_gene : "OTTHUMG00000167025.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57376769,
      stop : 57381150,
      direction : "-",
      ID : "ENSG00000156575.2",
      gene_id : "ENSG00000156575.2",
      gene_type : "protein_coding",
      gene_name : "PRG3",
      gene_level : 2,
      hgnc_id : "HGNC:9363",
      havana_gene : "OTTHUMG00000167026.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57386780,
      stop : 57390650,
      direction : "-",
      ID : "ENSG00000186652.10",
      gene_id : "ENSG00000186652.10",
      gene_type : "protein_coding",
      gene_name : "PRG2",
      gene_level : 2,
      hgnc_id : "HGNC:9362",
      havana_gene : "OTTHUMG00000167027.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57387365,
      stop : 57424059,
      direction : "-",
      ID : "ENSG00000254979.5",
      gene_id : "ENSG00000254979.5",
      gene_type : "protein_coding",
      gene_name : "AP000781.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167079.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57406954,
      stop : 57427580,
      direction : "-",
      ID : "ENSG00000134802.18",
      gene_id : "ENSG00000134802.18",
      gene_type : "protein_coding",
      gene_name : "SLC43A3",
      gene_level : 2,
      hgnc_id : "HGNC:17466",
      havana_gene : "OTTHUMG00000167113.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57460528,
      stop : 57477534,
      direction : "+",
      ID : "ENSG00000186907.8",
      gene_id : "ENSG00000186907.8",
      gene_type : "protein_coding",
      gene_name : "RTN4RL2",
      gene_level : 1,
      hgnc_id : "HGNC:23053",
      havana_gene : "OTTHUMG00000167028.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57484534,
      stop : 57515780,
      direction : "-",
      ID : "ENSG00000149150.9",
      gene_id : "ENSG00000149150.9",
      gene_type : "protein_coding",
      gene_name : "SLC43A1",
      gene_level : 1,
      hgnc_id : "HGNC:9225",
      havana_gene : "OTTHUMG00000167030.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57528464,
      stop : 57530803,
      direction : "-",
      ID : "ENSG00000134809.9",
      gene_id : "ENSG00000134809.9",
      gene_type : "protein_coding",
      gene_name : "TIMM10",
      gene_level : 2,
      hgnc_id : "HGNC:11814",
      havana_gene : "OTTHUMG00000167039.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57542641,
      stop : 57550274,
      direction : "+",
      ID : "ENSG00000214872.8",
      gene_id : "ENSG00000214872.8",
      gene_type : "protein_coding",
      gene_name : "SMTNL1",
      gene_level : 2,
      hgnc_id : "HGNC:32394",
      havana_gene : "OTTHUMG00000167046.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57551656,
      stop : 57568284,
      direction : "-",
      ID : "ENSG00000156587.16",
      gene_id : "ENSG00000156587.16",
      gene_type : "protein_coding",
      gene_name : "UBE2L6",
      gene_level : 1,
      hgnc_id : "HGNC:12490",
      havana_gene : "OTTHUMG00000167047.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57597387,
      stop : 57619171,
      direction : "+",
      ID : "ENSG00000149131.17",
      gene_id : "ENSG00000149131.17",
      gene_type : "protein_coding",
      gene_name : "SERPING1",
      gene_level : 1,
      hgnc_id : "HGNC:1228",
      havana_gene : "OTTHUMG00000150304.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57645087,
      stop : 57649944,
      direction : "-",
      ID : "ENSG00000166793.13",
      gene_id : "ENSG00000166793.13",
      gene_type : "protein_coding",
      gene_name : "YPEL4",
      gene_level : 2,
      hgnc_id : "HGNC:18328",
      havana_gene : "OTTHUMG00000167138.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57648188,
      stop : 57661865,
      direction : "+",
      ID : "ENSG00000172409.7",
      gene_id : "ENSG00000172409.7",
      gene_type : "protein_coding",
      gene_name : "CLP1",
      gene_level : 1,
      hgnc_id : "HGNC:16999",
      havana_gene : "OTTHUMG00000167146.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57667747,
      stop : 57701182,
      direction : "+",
      ID : "ENSG00000156599.11",
      gene_id : "ENSG00000156599.11",
      gene_type : "protein_coding",
      gene_name : "ZDHHC5",
      gene_level : 1,
      hgnc_id : "HGNC:18472",
      havana_gene : "OTTHUMG00000167198.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57703714,
      stop : 57712323,
      direction : "-",
      ID : "ENSG00000156603.19",
      gene_id : "ENSG00000156603.19",
      gene_type : "protein_coding",
      gene_name : "MED19",
      gene_level : 2,
      hgnc_id : "HGNC:29600",
      havana_gene : "OTTHUMG00000167199.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57712582,
      stop : 57818431,
      direction : "+",
      ID : "ENSG00000288534.1",
      gene_id : "ENSG00000288534.1",
      gene_type : "protein_coding",
      gene_name : "AP001931.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167384.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57712593,
      stop : 57740973,
      direction : "+",
      ID : "ENSG00000213593.10",
      gene_id : "ENSG00000213593.10",
      gene_type : "protein_coding",
      gene_name : "TMX2",
      gene_level : 2,
      hgnc_id : "HGNC:30739",
      havana_gene : "OTTHUMG00000167200.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57741250,
      stop : 57743554,
      direction : "+",
      ID : "ENSG00000211450.10",
      gene_id : "ENSG00000211450.10",
      gene_type : "protein_coding",
      gene_name : "SELENOH",
      gene_level : 2,
      hgnc_id : "HGNC:18251",
      havana_gene : "OTTHUMG00000167202.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57741779,
      stop : 57804771,
      direction : "+",
      ID : "ENSG00000254732.2",
      gene_id : "ENSG00000254732.2",
      gene_type : "protein_coding",
      gene_name : "AP001931.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167374.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57743514,
      stop : 57751781,
      direction : "-",
      ID : "ENSG00000233436.7",
      gene_id : "ENSG00000233436.7",
      gene_type : "protein_coding",
      gene_name : "BTBD18",
      gene_level : 2,
      hgnc_id : "HGNC:37214",
      havana_gene : "OTTHUMG00000167203.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 57753243,
      stop : 57819546,
      direction : "+",
      ID : "ENSG00000198561.15",
      gene_id : "ENSG00000198561.15",
      gene_type : "protein_coding",
      gene_name : "CTNND1",
      gene_level : 1,
      hgnc_id : "HGNC:2515",
      havana_gene : "OTTHUMG00000167272.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58023881,
      stop : 58181616,
      direction : "+",
      ID : "ENSG00000186509.4",
      gene_id : "ENSG00000186509.4",
      gene_type : "protein_coding",
      gene_name : "OR9Q1",
      gene_level : 2,
      hgnc_id : "HGNC:14724",
      havana_gene : "OTTHUMG00000167413.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58030930,
      stop : 58031931,
      direction : "+",
      ID : "ENSG00000279051.4",
      gene_id : "ENSG00000279051.4",
      gene_type : "protein_coding",
      gene_name : "OR6Q1",
      gene_level : 2,
      hgnc_id : "HGNC:15302",
      havana_gene : "OTTHUMG00000168831.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58116742,
      stop : 58125530,
      direction : "-",
      ID : "ENSG00000172377.3",
      gene_id : "ENSG00000172377.3",
      gene_type : "protein_coding",
      gene_name : "OR9I1",
      gene_level : 2,
      hgnc_id : "HGNC:14718",
      havana_gene : "OTTHUMG00000167404.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58189070,
      stop : 58194053,
      direction : "+",
      ID : "ENSG00000186513.3",
      gene_id : "ENSG00000186513.3",
      gene_type : "protein_coding",
      gene_name : "OR9Q2",
      gene_level : 2,
      hgnc_id : "HGNC:15328",
      havana_gene : "OTTHUMG00000167414.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58203202,
      stop : 58204181,
      direction : "-",
      ID : "ENSG00000197887.4",
      gene_id : "ENSG00000197887.4",
      gene_type : "protein_coding",
      gene_name : "OR1S2",
      gene_level : 2,
      hgnc_id : "HGNC:15141",
      havana_gene : "OTTHUMG00000167541.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58212720,
      stop : 58216084,
      direction : "+",
      ID : "ENSG00000280204.3",
      gene_id : "ENSG00000280204.3",
      gene_type : "protein_coding",
      gene_name : "OR1S1",
      gene_level : 2,
      hgnc_id : "HGNC:8227",
      havana_gene : "OTTHUMG00000167463.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58227882,
      stop : 58228918,
      direction : "-",
      ID : "ENSG00000180475.4",
      gene_id : "ENSG00000180475.4",
      gene_type : "protein_coding",
      gene_name : "OR10Q1",
      gene_level : 2,
      hgnc_id : "HGNC:15134",
      havana_gene : "OTTHUMG00000167542.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58266792,
      stop : 58268260,
      direction : "-",
      ID : "ENSG00000172772.3",
      gene_id : "ENSG00000172772.3",
      gene_type : "protein_coding",
      gene_name : "OR10W1",
      gene_level : 2,
      hgnc_id : "HGNC:15139",
      havana_gene : "OTTHUMG00000167462.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58358124,
      stop : 58359069,
      direction : "-",
      ID : "ENSG00000197786.3",
      gene_id : "ENSG00000197786.3",
      gene_type : "protein_coding",
      gene_name : "OR5B17",
      gene_level : 2,
      hgnc_id : "HGNC:15267",
      havana_gene : "OTTHUMG00000167465.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58402464,
      stop : 58406874,
      direction : "-",
      ID : "ENSG00000172769.4",
      gene_id : "ENSG00000172769.4",
      gene_type : "protein_coding",
      gene_name : "OR5B3",
      gene_level : 2,
      hgnc_id : "HGNC:8324",
      havana_gene : "OTTHUMG00000167516.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58421238,
      stop : 58428121,
      direction : "-",
      ID : "ENSG00000172365.4",
      gene_id : "ENSG00000172365.4",
      gene_type : "protein_coding",
      gene_name : "OR5B2",
      gene_level : 2,
      hgnc_id : "HGNC:8323",
      havana_gene : "OTTHUMG00000167517.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58439077,
      stop : 58442758,
      direction : "-",
      ID : "ENSG00000172362.3",
      gene_id : "ENSG00000172362.3",
      gene_type : "protein_coding",
      gene_name : "OR5B12",
      gene_level : 2,
      hgnc_id : "HGNC:15432",
      havana_gene : "OTTHUMG00000167543.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58507175,
      stop : 58508105,
      direction : "-",
      ID : "ENSG00000198283.2",
      gene_id : "ENSG00000198283.2",
      gene_type : "protein_coding",
      gene_name : "OR5B21",
      gene_level : 2,
      hgnc_id : "HGNC:19616",
      havana_gene : "OTTHUMG00000167519.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58526871,
      stop : 58578220,
      direction : "-",
      ID : "ENSG00000110031.13",
      gene_id : "ENSG00000110031.13",
      gene_type : "protein_coding",
      gene_name : "LPXN",
      gene_level : 1,
      hgnc_id : "HGNC:14061",
      havana_gene : "OTTHUMG00000167466.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58579063,
      stop : 58621550,
      direction : "+",
      ID : "ENSG00000186660.15",
      gene_id : "ENSG00000186660.15",
      gene_type : "protein_coding",
      gene_name : "ZFP91",
      gene_level : 2,
      hgnc_id : "HGNC:14983",
      havana_gene : "OTTHUMG00000137391.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58579172,
      stop : 58624639,
      direction : "+",
      ID : "ENSG00000255073.8",
      gene_id : "ENSG00000255073.8",
      gene_type : "protein_coding",
      gene_name : "ZFP91-CNTF",
      gene_level : 2,
      hgnc_id : "HGNC:33441",
      havana_gene : "OTTHUMG00000166280.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58622665,
      stop : 58625733,
      direction : "+",
      ID : "ENSG00000242689.3",
      gene_id : "ENSG00000242689.3",
      gene_type : "protein_coding",
      gene_name : "CNTF",
      gene_level : 2,
      hgnc_id : "HGNC:2169",
      havana_gene : "OTTHUMG00000137476.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58640426,
      stop : 58731974,
      direction : "-",
      ID : "ENSG00000149124.11",
      gene_id : "ENSG00000149124.11",
      gene_type : "protein_coding",
      gene_name : "GLYAT",
      gene_level : 1,
      hgnc_id : "HGNC:13734",
      havana_gene : "OTTHUMG00000167429.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58834065,
      stop : 58904215,
      direction : "-",
      ID : "ENSG00000156689.7",
      gene_id : "ENSG00000156689.7",
      gene_type : "protein_coding",
      gene_name : "GLYATL2",
      gene_level : 2,
      hgnc_id : "HGNC:24178",
      havana_gene : "OTTHUMG00000167432.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 58905398,
      stop : 59043527,
      direction : "+",
      ID : "ENSG00000166840.13",
      gene_id : "ENSG00000166840.13",
      gene_type : "protein_coding",
      gene_name : "GLYATL1",
      gene_level : 2,
      hgnc_id : "HGNC:30519",
      havana_gene : "OTTHUMG00000167221.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59086307,
      stop : 59094786,
      direction : "+",
      ID : "ENSG00000255151.2",
      gene_id : "ENSG00000255151.2",
      gene_type : "protein_coding",
      gene_name : "GLYATL1B",
      gene_level : 2,
      hgnc_id : "HGNC:37865",
      havana_gene : "OTTHUMG00000167278.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59107185,
      stop : 59127412,
      direction : "+",
      ID : "ENSG00000189057.11",
      gene_id : "ENSG00000189057.11",
      gene_type : "protein_coding",
      gene_name : "FAM111B",
      gene_level : 2,
      hgnc_id : "HGNC:24200",
      havana_gene : "OTTHUMG00000167279.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59142748,
      stop : 59155039,
      direction : "+",
      ID : "ENSG00000166801.16",
      gene_id : "ENSG00000166801.16",
      gene_type : "protein_coding",
      gene_name : "FAM111A",
      gene_level : 2,
      hgnc_id : "HGNC:24725",
      havana_gene : "OTTHUMG00000167280.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59171430,
      stop : 59208588,
      direction : "+",
      ID : "ENSG00000110042.8",
      gene_id : "ENSG00000110042.8",
      gene_type : "protein_coding",
      gene_name : "DTX4",
      gene_level : 2,
      hgnc_id : "HGNC:29151",
      havana_gene : "OTTHUMG00000167336.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59208510,
      stop : 59212927,
      direction : "-",
      ID : "ENSG00000197629.6",
      gene_id : "ENSG00000197629.6",
      gene_type : "protein_coding",
      gene_name : "MPEG1",
      gene_level : 2,
      hgnc_id : "HGNC:29619",
      havana_gene : "OTTHUMG00000162676.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59358895,
      stop : 59371714,
      direction : "+",
      ID : "ENSG00000176495.3",
      gene_id : "ENSG00000176495.3",
      gene_type : "protein_coding",
      gene_name : "OR5AN1",
      gene_level : 2,
      hgnc_id : "HGNC:15255",
      havana_gene : "OTTHUMG00000167337.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59416969,
      stop : 59426413,
      direction : "-",
      ID : "ENSG00000172324.6",
      gene_id : "ENSG00000172324.6",
      gene_type : "protein_coding",
      gene_name : "OR5A2",
      gene_level : 2,
      hgnc_id : "HGNC:15249",
      havana_gene : "OTTHUMG00000167419.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59436469,
      stop : 59451380,
      direction : "+",
      ID : "ENSG00000172320.3",
      gene_id : "ENSG00000172320.3",
      gene_type : "protein_coding",
      gene_name : "OR5A1",
      gene_level : 2,
      hgnc_id : "HGNC:8319",
      havana_gene : "OTTHUMG00000167339.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59456938,
      stop : 59457991,
      direction : "+",
      ID : "ENSG00000166884.2",
      gene_id : "ENSG00000166884.2",
      gene_type : "protein_coding",
      gene_name : "OR4D6",
      gene_level : 2,
      hgnc_id : "HGNC:15175",
      havana_gene : "OTTHUMG00000167340.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59473315,
      stop : 59479361,
      direction : "+",
      ID : "ENSG00000254466.2",
      gene_id : "ENSG00000254466.2",
      gene_type : "protein_coding",
      gene_name : "OR4D10",
      gene_level : 2,
      hgnc_id : "HGNC:15173",
      havana_gene : "OTTHUMG00000167341.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59503576,
      stop : 59504511,
      direction : "+",
      ID : "ENSG00000176200.1",
      gene_id : "ENSG00000176200.1",
      gene_type : "protein_coding",
      gene_name : "OR4D11",
      gene_level : 2,
      hgnc_id : "HGNC:15174",
      havana_gene : "OTTHUMG00000167342.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59511368,
      stop : 59520703,
      direction : "+",
      ID : "ENSG00000172742.6",
      gene_id : "ENSG00000172742.6",
      gene_type : "protein_coding",
      gene_name : "OR4D9",
      gene_level : 2,
      hgnc_id : "HGNC:15178",
      havana_gene : "OTTHUMG00000167343.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59574398,
      stop : 59615774,
      direction : "-",
      ID : "ENSG00000110048.12",
      gene_id : "ENSG00000110048.12",
      gene_type : "protein_coding",
      gene_name : "OSBP",
      gene_level : 2,
      hgnc_id : "HGNC:8503",
      havana_gene : "OTTHUMG00000167422.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59636716,
      stop : 59669037,
      direction : "-",
      ID : "ENSG00000166889.14",
      gene_id : "ENSG00000166889.14",
      gene_type : "protein_coding",
      gene_name : "PATL1",
      gene_level : 2,
      hgnc_id : "HGNC:26721",
      havana_gene : "OTTHUMG00000167423.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59712916,
      stop : 59713845,
      direction : "-",
      ID : "ENSG00000172289.3",
      gene_id : "ENSG00000172289.3",
      gene_type : "protein_coding",
      gene_name : "OR10V1",
      gene_level : 2,
      hgnc_id : "HGNC:15136",
      havana_gene : "OTTHUMG00000167406.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59713456,
      stop : 59805882,
      direction : "+",
      ID : "ENSG00000166900.17",
      gene_id : "ENSG00000166900.17",
      gene_type : "protein_coding",
      gene_name : "STX3",
      gene_level : 2,
      hgnc_id : "HGNC:11438",
      havana_gene : "OTTHUMG00000167353.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59806140,
      stop : 59810778,
      direction : "-",
      ID : "ENSG00000166902.5",
      gene_id : "ENSG00000166902.5",
      gene_type : "protein_coding",
      gene_name : "MRPL16",
      gene_level : 2,
      hgnc_id : "HGNC:14476",
      havana_gene : "OTTHUMG00000167410.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59829273,
      stop : 59845499,
      direction : "-",
      ID : "ENSG00000134812.8",
      gene_id : "ENSG00000134812.8",
      gene_type : "protein_coding",
      gene_name : "CBLIF",
      gene_level : 2,
      hgnc_id : "HGNC:4268",
      havana_gene : "OTTHUMG00000167399.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59852800,
      stop : 59866489,
      direction : "-",
      ID : "ENSG00000134827.8",
      gene_id : "ENSG00000134827.8",
      gene_type : "protein_coding",
      gene_name : "TCN1",
      gene_level : 2,
      hgnc_id : "HGNC:11652",
      havana_gene : "OTTHUMG00000167400.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59878809,
      stop : 59896481,
      direction : "+",
      ID : "ENSG00000285231.1",
      gene_id : "ENSG00000285231.1",
      gene_type : "protein_coding",
      gene_name : "OOSP3",
      gene_level : 2,
      hgnc_id : "HGNC:53903",
      havana_gene : "OTTHUMG00000192598.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59938432,
      stop : 59957480,
      direction : "+",
      ID : "ENSG00000284873.1",
      gene_id : "ENSG00000284873.1",
      gene_type : "protein_coding",
      gene_name : "OOSP1",
      gene_level : 2,
      hgnc_id : "HGNC:49233",
      havana_gene : "OTTHUMG00000192599.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59964033,
      stop : 59970146,
      direction : "+",
      ID : "ENSG00000285010.1",
      gene_id : "ENSG00000285010.1",
      gene_type : "protein_coding",
      gene_name : "OOSP4A",
      gene_level : 2,
      hgnc_id : "HGNC:53904",
      havana_gene : "OTTHUMG00000187492.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 59978020,
      stop : 60031077,
      direction : "+",
      ID : "ENSG00000255393.2",
      gene_id : "ENSG00000255393.2",
      gene_type : "protein_coding",
      gene_name : "OOSP4B",
      gene_level : 2,
      hgnc_id : "HGNC:53905",
      havana_gene : "OTTHUMG00000167378.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60040409,
      stop : 60048044,
      direction : "+",
      ID : "ENSG00000149507.7",
      gene_id : "ENSG00000149507.7",
      gene_type : "protein_coding",
      gene_name : "OOSP2",
      gene_level : 2,
      hgnc_id : "HGNC:26699",
      havana_gene : "OTTHUMG00000167379.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60056587,
      stop : 60071115,
      direction : "+",
      ID : "ENSG00000149516.14",
      gene_id : "ENSG00000149516.14",
      gene_type : "protein_coding",
      gene_name : "MS4A3",
      gene_level : 2,
      hgnc_id : "HGNC:7317",
      havana_gene : "OTTHUMG00000167380.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60088261,
      stop : 60098467,
      direction : "+",
      ID : "ENSG00000149534.9",
      gene_id : "ENSG00000149534.9",
      gene_type : "protein_coding",
      gene_name : "MS4A2",
      gene_level : 2,
      hgnc_id : "HGNC:7316",
      havana_gene : "OTTHUMG00000167239.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60172014,
      stop : 60184666,
      direction : "-",
      ID : "ENSG00000110077.14",
      gene_id : "ENSG00000110077.14",
      gene_type : "protein_coding",
      gene_name : "MS4A6A",
      gene_level : 1,
      hgnc_id : "HGNC:13375",
      havana_gene : "OTTHUMG00000167241.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60185657,
      stop : 60318080,
      direction : "+",
      ID : "ENSG00000110079.19",
      gene_id : "ENSG00000110079.19",
      gene_type : "protein_coding",
      gene_name : "MS4A4A",
      gene_level : 2,
      hgnc_id : "HGNC:13371",
      havana_gene : "OTTHUMG00000154949.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60200270,
      stop : 60243137,
      direction : "-",
      ID : "ENSG00000214787.10",
      gene_id : "ENSG00000214787.10",
      gene_type : "protein_coding",
      gene_name : "MS4A4E",
      gene_level : 2,
      hgnc_id : "HGNC:14284",
      havana_gene : "OTTHUMG00000167354.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60334831,
      stop : 60396596,
      direction : "+",
      ID : "ENSG00000166926.8",
      gene_id : "ENSG00000166926.8",
      gene_type : "protein_coding",
      gene_name : "MS4A6E",
      gene_level : 2,
      hgnc_id : "HGNC:14285",
      havana_gene : "OTTHUMG00000167355.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60378485,
      stop : 60395951,
      direction : "+",
      ID : "ENSG00000166927.13",
      gene_id : "ENSG00000166927.13",
      gene_type : "protein_coding",
      gene_name : "MS4A7",
      gene_level : 1,
      hgnc_id : "HGNC:13378",
      havana_gene : "OTTHUMG00000167356.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60378530,
      stop : 60417756,
      direction : "+",
      ID : "ENSG00000166928.11",
      gene_id : "ENSG00000166928.11",
      gene_type : "protein_coding",
      gene_name : "MS4A14",
      gene_level : 2,
      hgnc_id : "HGNC:30706",
      havana_gene : "OTTHUMG00000167357.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60429572,
      stop : 60455214,
      direction : "+",
      ID : "ENSG00000166930.7",
      gene_id : "ENSG00000166930.7",
      gene_type : "protein_coding",
      gene_name : "MS4A5",
      gene_level : 2,
      hgnc_id : "HGNC:13374",
      havana_gene : "OTTHUMG00000167613.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60455846,
      stop : 60470752,
      direction : "+",
      ID : "ENSG00000156738.18",
      gene_id : "ENSG00000156738.18",
      gene_type : "protein_coding",
      gene_name : "MS4A1",
      gene_level : 2,
      hgnc_id : "HGNC:7315",
      havana_gene : "OTTHUMG00000167614.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60492778,
      stop : 60507430,
      direction : "+",
      ID : "ENSG00000071203.9",
      gene_id : "ENSG00000071203.9",
      gene_type : "protein_coding",
      gene_name : "MS4A12",
      gene_level : 2,
      hgnc_id : "HGNC:13370",
      havana_gene : "OTTHUMG00000165364.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60515392,
      stop : 60542721,
      direction : "+",
      ID : "ENSG00000204979.8",
      gene_id : "ENSG00000204979.8",
      gene_type : "protein_coding",
      gene_name : "MS4A13",
      gene_level : 1,
      hgnc_id : "HGNC:16674",
      havana_gene : "OTTHUMG00000167615.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60699585,
      stop : 60715807,
      direction : "+",
      ID : "ENSG00000166959.8",
      gene_id : "ENSG00000166959.8",
      gene_type : "protein_coding",
      gene_name : "MS4A8",
      gene_level : 1,
      hgnc_id : "HGNC:13380",
      havana_gene : "OTTHUMG00000167686.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60729304,
      stop : 60744212,
      direction : "+",
      ID : "ENSG00000214782.7",
      gene_id : "ENSG00000214782.7",
      gene_type : "protein_coding",
      gene_name : "MS4A18",
      gene_level : 1,
      hgnc_id : "HGNC:37636",
      havana_gene : "OTTHUMG00000167687.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60756867,
      stop : 60776733,
      direction : "+",
      ID : "ENSG00000166961.15",
      gene_id : "ENSG00000166961.15",
      gene_type : "protein_coding",
      gene_name : "MS4A15",
      gene_level : 2,
      hgnc_id : "HGNC:28573",
      havana_gene : "OTTHUMG00000167688.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60785333,
      stop : 60801305,
      direction : "+",
      ID : "ENSG00000172689.2",
      gene_id : "ENSG00000172689.2",
      gene_type : "protein_coding",
      gene_name : "MS4A10",
      gene_level : 2,
      hgnc_id : "HGNC:13368",
      havana_gene : "OTTHUMG00000167689.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60842113,
      stop : 60851081,
      direction : "+",
      ID : "ENSG00000110104.13",
      gene_id : "ENSG00000110104.13",
      gene_type : "protein_coding",
      gene_name : "CCDC86",
      gene_level : 2,
      hgnc_id : "HGNC:28359",
      havana_gene : "OTTHUMG00000167706.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60850933,
      stop : 60855950,
      direction : "-",
      ID : "ENSG00000183134.5",
      gene_id : "ENSG00000183134.5",
      gene_type : "protein_coding",
      gene_name : "PTGDR2",
      gene_level : 2,
      hgnc_id : "HGNC:4502",
      havana_gene : "OTTHUMG00000167796.3",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60867562,
      stop : 60875693,
      direction : "+",
      ID : "ENSG00000149506.11",
      gene_id : "ENSG00000149506.11",
      gene_type : "protein_coding",
      gene_name : "ZP1",
      gene_level : 2,
      hgnc_id : "HGNC:13187",
      havana_gene : "OTTHUMG00000167797.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60890547,
      stop : 60906585,
      direction : "-",
      ID : "ENSG00000110107.9",
      gene_id : "ENSG00000110107.9",
      gene_type : "protein_coding",
      gene_name : "PRPF19",
      gene_level : 1,
      hgnc_id : "HGNC:17896",
      havana_gene : "OTTHUMG00000167798.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60914158,
      stop : 60923443,
      direction : "+",
      ID : "ENSG00000110108.10",
      gene_id : "ENSG00000110108.10",
      gene_type : "protein_coding",
      gene_name : "TMEM109",
      gene_level : 2,
      hgnc_id : "HGNC:28771",
      havana_gene : "OTTHUMG00000167801.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60924460,
      stop : 60937159,
      direction : "+",
      ID : "ENSG00000006118.15",
      gene_id : "ENSG00000006118.15",
      gene_type : "protein_coding",
      gene_name : "TMEM132A",
      gene_level : 1,
      hgnc_id : "HGNC:31092",
      havana_gene : "OTTHUMG00000167803.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60937060,
      stop : 60952653,
      direction : "-",
      ID : "ENSG00000110446.12",
      gene_id : "ENSG00000110446.12",
      gene_type : "protein_coding",
      gene_name : "SLC15A3",
      gene_level : 1,
      hgnc_id : "HGNC:18068",
      havana_gene : "OTTHUMG00000167804.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 60971680,
      stop : 61020377,
      direction : "+",
      ID : "ENSG00000013725.14",
      gene_id : "ENSG00000013725.14",
      gene_type : "protein_coding",
      gene_name : "CD6",
      gene_level : 2,
      hgnc_id : "HGNC:1691",
      havana_gene : "OTTHUMG00000167823.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61102489,
      stop : 61127852,
      direction : "+",
      ID : "ENSG00000110448.11",
      gene_id : "ENSG00000110448.11",
      gene_type : "protein_coding",
      gene_name : "CD5",
      gene_level : 2,
      hgnc_id : "HGNC:1685",
      havana_gene : "OTTHUMG00000167825.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61130257,
      stop : 61161615,
      direction : "-",
      ID : "ENSG00000167987.11",
      gene_id : "ENSG00000167987.11",
      gene_type : "protein_coding",
      gene_name : "VPS37C",
      gene_level : 2,
      hgnc_id : "HGNC:26097",
      havana_gene : "OTTHUMG00000167826.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61203307,
      stop : 61213098,
      direction : "+",
      ID : "ENSG00000229859.10",
      gene_id : "ENSG00000229859.10",
      gene_type : "protein_coding",
      gene_name : "PGA3",
      gene_level : 2,
      hgnc_id : "HGNC:8885",
      havana_gene : "OTTHUMG00000168071.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61222349,
      stop : 61231694,
      direction : "+",
      ID : "ENSG00000229183.9",
      gene_id : "ENSG00000229183.9",
      gene_type : "protein_coding",
      gene_name : "PGA4",
      gene_level : 2,
      hgnc_id : "HGNC:8886",
      havana_gene : "OTTHUMG00000168073.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61241175,
      stop : 61251444,
      direction : "+",
      ID : "ENSG00000256713.8",
      gene_id : "ENSG00000256713.8",
      gene_type : "protein_coding",
      gene_name : "PGA5",
      gene_level : 2,
      hgnc_id : "HGNC:8887",
      havana_gene : "OTTHUMG00000168075.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61258286,
      stop : 61295316,
      direction : "-",
      ID : "ENSG00000167992.13",
      gene_id : "ENSG00000167992.13",
      gene_type : "protein_coding",
      gene_name : "VWCE",
      gene_level : 2,
      hgnc_id : "HGNC:26487",
      havana_gene : "OTTHUMG00000168208.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61299451,
      stop : 61342596,
      direction : "-",
      ID : "ENSG00000167986.15",
      gene_id : "ENSG00000167986.15",
      gene_type : "protein_coding",
      gene_name : "DDB1",
      gene_level : 1,
      hgnc_id : "HGNC:2717",
      havana_gene : "OTTHUMG00000168209.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61333220,
      stop : 61353295,
      direction : "+",
      ID : "ENSG00000149476.16",
      gene_id : "ENSG00000149476.16",
      gene_type : "protein_coding",
      gene_name : "TKFC",
      gene_level : 1,
      hgnc_id : "HGNC:24552",
      havana_gene : "OTTHUMG00000168076.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61348754,
      stop : 61362283,
      direction : "-",
      ID : "ENSG00000162144.10",
      gene_id : "ENSG00000162144.10",
      gene_type : "protein_coding",
      gene_name : "CYB561A3",
      gene_level : 1,
      hgnc_id : "HGNC:23014",
      havana_gene : "OTTHUMG00000157187.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61362344,
      stop : 61369509,
      direction : "+",
      ID : "ENSG00000149483.12",
      gene_id : "ENSG00000149483.12",
      gene_type : "protein_coding",
      gene_name : "TMEM138",
      gene_level : 2,
      hgnc_id : "HGNC:26944",
      havana_gene : "OTTHUMG00000168145.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61392360,
      stop : 61398863,
      direction : "+",
      ID : "ENSG00000187049.10",
      gene_id : "ENSG00000187049.10",
      gene_type : "protein_coding",
      gene_name : "TMEM216",
      gene_level : 2,
      hgnc_id : "HGNC:25018",
      havana_gene : "OTTHUMG00000168146.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61402641,
      stop : 61430031,
      direction : "-",
      ID : "ENSG00000149532.16",
      gene_id : "ENSG00000149532.16",
      gene_type : "protein_coding",
      gene_name : "CPSF7",
      gene_level : 1,
      hgnc_id : "HGNC:30098",
      havana_gene : "OTTHUMG00000168198.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61429220,
      stop : 61485822,
      direction : "+",
      ID : "ENSG00000256591.5",
      gene_id : "ENSG00000256591.5",
      gene_type : "protein_coding",
      gene_name : "AP003108.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000168148.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61430042,
      stop : 61446733,
      direction : "+",
      ID : "ENSG00000167985.7",
      gene_id : "ENSG00000167985.7",
      gene_type : "protein_coding",
      gene_name : "SDHAF2",
      gene_level : 1,
      hgnc_id : "HGNC:26034",
      havana_gene : "OTTHUMG00000168279.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61481120,
      stop : 61490931,
      direction : "+",
      ID : "ENSG00000162148.11",
      gene_id : "ENSG00000162148.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R32",
      gene_level : 2,
      hgnc_id : "HGNC:28869",
      havana_gene : "OTTHUMG00000168176.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61508749,
      stop : 61511018,
      direction : "+",
      ID : "ENSG00000204950.4",
      gene_id : "ENSG00000204950.4",
      gene_type : "protein_coding",
      gene_name : "LRRC10B",
      gene_level : 2,
      hgnc_id : "HGNC:37215",
      havana_gene : "OTTHUMG00000168178.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61513714,
      stop : 61581148,
      direction : "-",
      ID : "ENSG00000011347.10",
      gene_id : "ENSG00000011347.10",
      gene_type : "protein_coding",
      gene_name : "SYT7",
      gene_level : 1,
      hgnc_id : "HGNC:11514",
      havana_gene : "OTTHUMG00000168199.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61680391,
      stop : 61747001,
      direction : "+",
      ID : "ENSG00000134780.10",
      gene_id : "ENSG00000134780.10",
      gene_type : "protein_coding",
      gene_name : "DAGLA",
      gene_level : 2,
      hgnc_id : "HGNC:1165",
      havana_gene : "OTTHUMG00000168160.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61752636,
      stop : 61788518,
      direction : "+",
      ID : "ENSG00000124920.14",
      gene_id : "ENSG00000124920.14",
      gene_type : "protein_coding",
      gene_name : "MYRF",
      gene_level : 2,
      hgnc_id : "HGNC:1181",
      havana_gene : "OTTHUMG00000168161.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61768501,
      stop : 61792802,
      direction : "-",
      ID : "ENSG00000134825.16",
      gene_id : "ENSG00000134825.16",
      gene_type : "protein_coding",
      gene_name : "TMEM258",
      gene_level : 1,
      hgnc_id : "HGNC:1164",
      havana_gene : "OTTHUMG00000168172.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61792911,
      stop : 61797238,
      direction : "+",
      ID : "ENSG00000168496.4",
      gene_id : "ENSG00000168496.4",
      gene_type : "protein_coding",
      gene_name : "FEN1",
      gene_level : 1,
      hgnc_id : "HGNC:3650",
      havana_gene : "OTTHUMG00000168162.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61792980,
      stop : 61867354,
      direction : "+",
      ID : "ENSG00000134824.14",
      gene_id : "ENSG00000134824.14",
      gene_type : "protein_coding",
      gene_name : "FADS2",
      gene_level : 1,
      hgnc_id : "HGNC:3575",
      havana_gene : "OTTHUMG00000163794.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61799627,
      stop : 61829318,
      direction : "-",
      ID : "ENSG00000149485.19",
      gene_id : "ENSG00000149485.19",
      gene_type : "protein_coding",
      gene_name : "FADS1",
      gene_level : 1,
      hgnc_id : "HGNC:3574",
      havana_gene : "OTTHUMG00000157155.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61873519,
      stop : 61892051,
      direction : "-",
      ID : "ENSG00000221968.9",
      gene_id : "ENSG00000221968.9",
      gene_type : "protein_coding",
      gene_name : "FADS3",
      gene_level : 1,
      hgnc_id : "HGNC:3576",
      havana_gene : "OTTHUMG00000167500.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61897301,
      stop : 61920269,
      direction : "-",
      ID : "ENSG00000167994.13",
      gene_id : "ENSG00000167994.13",
      gene_type : "protein_coding",
      gene_name : "RAB3IL1",
      gene_level : 1,
      hgnc_id : "HGNC:9780",
      havana_gene : "OTTHUMG00000167524.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61950063,
      stop : 61965515,
      direction : "+",
      ID : "ENSG00000167995.17",
      gene_id : "ENSG00000167995.17",
      gene_type : "protein_coding",
      gene_name : "BEST1",
      gene_level : 1,
      hgnc_id : "HGNC:12703",
      havana_gene : "OTTHUMG00000167469.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 61959718,
      stop : 61967634,
      direction : "-",
      ID : "ENSG00000167996.16",
      gene_id : "ENSG00000167996.16",
      gene_type : "protein_coding",
      gene_name : "FTH1",
      gene_level : 1,
      hgnc_id : "HGNC:3976",
      havana_gene : "OTTHUMG00000166217.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62123998,
      stop : 62153169,
      direction : "+",
      ID : "ENSG00000149503.13",
      gene_id : "ENSG00000149503.13",
      gene_type : "protein_coding",
      gene_name : "INCENP",
      gene_level : 2,
      hgnc_id : "HGNC:6058",
      havana_gene : "OTTHUMG00000167470.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62190216,
      stop : 62193539,
      direction : "+",
      ID : "ENSG00000168515.3",
      gene_id : "ENSG00000168515.3",
      gene_type : "protein_coding",
      gene_name : "SCGB1D1",
      gene_level : 2,
      hgnc_id : "HGNC:18395",
      havana_gene : "OTTHUMG00000167505.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62208673,
      stop : 62213943,
      direction : "+",
      ID : "ENSG00000124939.6",
      gene_id : "ENSG00000124939.6",
      gene_type : "protein_coding",
      gene_name : "SCGB2A1",
      gene_level : 2,
      hgnc_id : "HGNC:7051",
      havana_gene : "OTTHUMG00000167506.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62242239,
      stop : 62244812,
      direction : "+",
      ID : "ENSG00000124935.4",
      gene_id : "ENSG00000124935.4",
      gene_type : "protein_coding",
      gene_name : "SCGB1D2",
      gene_level : 2,
      hgnc_id : "HGNC:18396",
      havana_gene : "OTTHUMG00000167508.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62270158,
      stop : 62273160,
      direction : "+",
      ID : "ENSG00000110484.7",
      gene_id : "ENSG00000110484.7",
      gene_type : "protein_coding",
      gene_name : "SCGB2A2",
      gene_level : 2,
      hgnc_id : "HGNC:7050",
      havana_gene : "OTTHUMG00000167509.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62296281,
      stop : 62299075,
      direction : "-",
      ID : "ENSG00000197745.3",
      gene_id : "ENSG00000197745.3",
      gene_type : "protein_coding",
      gene_name : "SCGB1D4",
      gene_level : 2,
      hgnc_id : "HGNC:31748",
      havana_gene : "OTTHUMG00000167510.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62337448,
      stop : 62393412,
      direction : "+",
      ID : "ENSG00000162174.12",
      gene_id : "ENSG00000162174.12",
      gene_type : "protein_coding",
      gene_name : "ASRGL1",
      gene_level : 2,
      hgnc_id : "HGNC:16448",
      havana_gene : "OTTHUMG00000167513.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62405103,
      stop : 62423195,
      direction : "+",
      ID : "ENSG00000149021.7",
      gene_id : "ENSG00000149021.7",
      gene_type : "protein_coding",
      gene_name : "SCGB1A1",
      gene_level : 1,
      hgnc_id : "HGNC:12523",
      havana_gene : "OTTHUMG00000167526.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62433542,
      stop : 62556235,
      direction : "-",
      ID : "ENSG00000124942.14",
      gene_id : "ENSG00000124942.14",
      gene_type : "protein_coding",
      gene_name : "AHNAK",
      gene_level : 1,
      hgnc_id : "HGNC:347",
      havana_gene : "OTTHUMG00000167558.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62559596,
      stop : 62574086,
      direction : "-",
      ID : "ENSG00000254772.10",
      gene_id : "ENSG00000254772.10",
      gene_type : "protein_coding",
      gene_name : "EEF1G",
      gene_level : 2,
      hgnc_id : "HGNC:3213",
      havana_gene : "OTTHUMG00000167567.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62559603,
      stop : 62591531,
      direction : "-",
      ID : "ENSG00000255508.7",
      gene_id : "ENSG00000255508.7",
      gene_type : "protein_coding",
      gene_name : "AP002990.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000167559.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62575045,
      stop : 62591637,
      direction : "-",
      ID : "ENSG00000149016.16",
      gene_id : "ENSG00000149016.16",
      gene_type : "protein_coding",
      gene_name : "TUT1",
      gene_level : 1,
      hgnc_id : "HGNC:26184",
      havana_gene : "OTTHUMG00000158564.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62593214,
      stop : 62601865,
      direction : "-",
      ID : "ENSG00000149480.7",
      gene_id : "ENSG00000149480.7",
      gene_type : "protein_coding",
      gene_name : "MTA2",
      gene_level : 1,
      hgnc_id : "HGNC:7411",
      havana_gene : "OTTHUMG00000167684.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62602218,
      stop : 62612775,
      direction : "-",
      ID : "ENSG00000149499.12",
      gene_id : "ENSG00000149499.12",
      gene_type : "protein_coding",
      gene_name : "EML3",
      gene_level : 1,
      hgnc_id : "HGNC:26666",
      havana_gene : "OTTHUMG00000149817.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62611722,
      stop : 62615116,
      direction : "+",
      ID : "ENSG00000149489.9",
      gene_id : "ENSG00000149489.9",
      gene_type : "protein_coding",
      gene_name : "ROM1",
      gene_level : 1,
      hgnc_id : "HGNC:10254",
      havana_gene : "OTTHUMG00000167528.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62615296,
      stop : 62622154,
      direction : "-",
      ID : "ENSG00000149541.10",
      gene_id : "ENSG00000149541.10",
      gene_type : "protein_coding",
      gene_name : "B3GAT3",
      gene_level : 1,
      hgnc_id : "HGNC:923",
      havana_gene : "OTTHUMG00000167685.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62624826,
      stop : 62646726,
      direction : "-",
      ID : "ENSG00000089597.18",
      gene_id : "ENSG00000089597.18",
      gene_type : "protein_coding",
      gene_name : "GANAB",
      gene_level : 1,
      hgnc_id : "HGNC:4138",
      havana_gene : "OTTHUMG00000167696.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62646848,
      stop : 62653302,
      direction : "-",
      ID : "ENSG00000185085.2",
      gene_id : "ENSG00000185085.2",
      gene_type : "protein_coding",
      gene_name : "INTS5",
      gene_level : 2,
      hgnc_id : "HGNC:29352",
      havana_gene : "OTTHUMG00000167605.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62649694,
      stop : 62665178,
      direction : "-",
      ID : "ENSG00000255432.1",
      gene_id : "ENSG00000255432.1",
      gene_type : "protein_coding",
      gene_name : "AP001458.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167606.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62662817,
      stop : 62665210,
      direction : "-",
      ID : "ENSG00000278615.5",
      gene_id : "ENSG00000278615.5",
      gene_type : "protein_coding",
      gene_name : "C11orf98",
      gene_level : 2,
      hgnc_id : "HGNC:51238",
      havana_gene : "OTTHUMG00000167588.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62662817,
      stop : 62672255,
      direction : "-",
      ID : "ENSG00000162194.12",
      gene_id : "ENSG00000162194.12",
      gene_type : "protein_coding",
      gene_name : "LBHD1",
      gene_level : 1,
      hgnc_id : "HGNC:28351",
      havana_gene : "OTTHUMG00000187541.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62665309,
      stop : 62668496,
      direction : "+",
      ID : "ENSG00000214756.8",
      gene_id : "ENSG00000214756.8",
      gene_type : "protein_coding",
      gene_name : "CSKMT",
      gene_level : 1,
      hgnc_id : "HGNC:33113",
      havana_gene : "OTTHUMG00000167545.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62670273,
      stop : 62673686,
      direction : "+",
      ID : "ENSG00000204922.5",
      gene_id : "ENSG00000204922.5",
      gene_type : "protein_coding",
      gene_name : "UQCC3",
      gene_level : 2,
      hgnc_id : "HGNC:34399",
      havana_gene : "OTTHUMG00000167546.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62676498,
      stop : 62679117,
      direction : "-",
      ID : "ENSG00000162191.14",
      gene_id : "ENSG00000162191.14",
      gene_type : "protein_coding",
      gene_name : "UBXN1",
      gene_level : 1,
      hgnc_id : "HGNC:18402",
      havana_gene : "OTTHUMG00000167580.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62686406,
      stop : 62689530,
      direction : "-",
      ID : "ENSG00000177363.5",
      gene_id : "ENSG00000177363.5",
      gene_type : "protein_coding",
      gene_name : "LRRN4CL",
      gene_level : 2,
      hgnc_id : "HGNC:33724",
      havana_gene : "OTTHUMG00000167581.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62690275,
      stop : 62709845,
      direction : "-",
      ID : "ENSG00000168000.15",
      gene_id : "ENSG00000168000.15",
      gene_type : "protein_coding",
      gene_name : "BSCL2",
      gene_level : 1,
      hgnc_id : "HGNC:15832",
      havana_gene : "OTTHUMG00000150624.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62690275,
      stop : 62727384,
      direction : "-",
      ID : "ENSG00000234857.2",
      gene_id : "ENSG00000234857.2",
      gene_type : "protein_coding",
      gene_name : "HNRNPUL2-BSCL2",
      gene_level : 2,
      hgnc_id : "HGNC:49189",
      havana_gene : "OTTHUMG00000167772.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62707676,
      stop : 62709201,
      direction : "+",
      ID : "ENSG00000162188.6",
      gene_id : "ENSG00000162188.6",
      gene_type : "protein_coding",
      gene_name : "GNG3",
      gene_level : 2,
      hgnc_id : "HGNC:4405",
      havana_gene : "OTTHUMG00000167560.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62712630,
      stop : 62727457,
      direction : "-",
      ID : "ENSG00000214753.4",
      gene_id : "ENSG00000214753.4",
      gene_type : "protein_coding",
      gene_name : "HNRNPUL2",
      gene_level : 2,
      hgnc_id : "HGNC:25451",
      havana_gene : "OTTHUMG00000167773.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62728069,
      stop : 62740293,
      direction : "+",
      ID : "ENSG00000162222.14",
      gene_id : "ENSG00000162222.14",
      gene_type : "protein_coding",
      gene_name : "TTC9C",
      gene_level : 2,
      hgnc_id : "HGNC:28432",
      havana_gene : "OTTHUMG00000167607.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62748319,
      stop : 62754184,
      direction : "-",
      ID : "ENSG00000185670.9",
      gene_id : "ENSG00000185670.9",
      gene_type : "protein_coding",
      gene_name : "ZBTB3",
      gene_level : 2,
      hgnc_id : "HGNC:22918",
      havana_gene : "OTTHUMG00000167608.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62761565,
      stop : 62766710,
      direction : "+",
      ID : "ENSG00000168002.12",
      gene_id : "ENSG00000168002.12",
      gene_type : "protein_coding",
      gene_name : "POLR2G",
      gene_level : 2,
      hgnc_id : "HGNC:9194",
      havana_gene : "OTTHUMG00000167609.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62771357,
      stop : 62787342,
      direction : "+",
      ID : "ENSG00000162227.8",
      gene_id : "ENSG00000162227.8",
      gene_type : "protein_coding",
      gene_name : "TAF6L",
      gene_level : 2,
      hgnc_id : "HGNC:17305",
      havana_gene : "OTTHUMG00000167610.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62771629,
      stop : 62792006,
      direction : "-",
      ID : "ENSG00000168569.8",
      gene_id : "ENSG00000168569.8",
      gene_type : "protein_coding",
      gene_name : "TMEM223",
      gene_level : 1,
      hgnc_id : "HGNC:28464",
      havana_gene : "OTTHUMG00000167693.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62787402,
      stop : 62790400,
      direction : "+",
      ID : "ENSG00000185475.11",
      gene_id : "ENSG00000185475.11",
      gene_type : "protein_coding",
      gene_name : "TMEM179B",
      gene_level : 1,
      hgnc_id : "HGNC:33744",
      havana_gene : "OTTHUMG00000167611.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62792123,
      stop : 62806302,
      direction : "-",
      ID : "ENSG00000162231.14",
      gene_id : "ENSG00000162231.14",
      gene_type : "protein_coding",
      gene_name : "NXF1",
      gene_level : 1,
      hgnc_id : "HGNC:8071",
      havana_gene : "OTTHUMG00000167612.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62806860,
      stop : 62832051,
      direction : "-",
      ID : "ENSG00000162236.13",
      gene_id : "ENSG00000162236.13",
      gene_type : "protein_coding",
      gene_name : "STX5",
      gene_level : 2,
      hgnc_id : "HGNC:11440",
      havana_gene : "OTTHUMG00000143864.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62832319,
      stop : 62832803,
      direction : "-",
      ID : "ENSG00000283268.1",
      gene_id : "ENSG00000283268.1",
      gene_type : "protein_coding",
      gene_name : "TEX54",
      gene_level : 2,
      hgnc_id : "HGNC:53729",
      havana_gene : "OTTHUMG00000191674.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62832342,
      stop : 62841809,
      direction : "-",
      ID : "ENSG00000133316.16",
      gene_id : "ENSG00000133316.16",
      gene_type : "protein_coding",
      gene_name : "WDR74",
      gene_level : 1,
      hgnc_id : "HGNC:25529",
      havana_gene : "OTTHUMG00000167695.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62856004,
      stop : 62888880,
      direction : "+",
      ID : "ENSG00000168003.18",
      gene_id : "ENSG00000168003.18",
      gene_type : "protein_coding",
      gene_name : "SLC3A2",
      gene_level : 1,
      hgnc_id : "HGNC:11026",
      havana_gene : "OTTHUMG00000074091.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62908679,
      stop : 62921807,
      direction : "-",
      ID : "ENSG00000168539.4",
      gene_id : "ENSG00000168539.4",
      gene_type : "protein_coding",
      gene_name : "CHRM1",
      gene_level : 2,
      hgnc_id : "HGNC:1950",
      havana_gene : "OTTHUMG00000167765.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62936385,
      stop : 62984967,
      direction : "-",
      ID : "ENSG00000197901.12",
      gene_id : "ENSG00000197901.12",
      gene_type : "protein_coding",
      gene_name : "SLC22A6",
      gene_level : 2,
      hgnc_id : "HGNC:10970",
      havana_gene : "OTTHUMG00000167767.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 62989154,
      stop : 63015841,
      direction : "-",
      ID : "ENSG00000149452.16",
      gene_id : "ENSG00000149452.16",
      gene_type : "protein_coding",
      gene_name : "SLC22A8",
      gene_level : 2,
      hgnc_id : "HGNC:10972",
      havana_gene : "OTTHUMG00000167768.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63079940,
      stop : 63144221,
      direction : "-",
      ID : "ENSG00000197658.9",
      gene_id : "ENSG00000197658.9",
      gene_type : "protein_coding",
      gene_name : "SLC22A24",
      gene_level : 1,
      hgnc_id : "HGNC:28542",
      havana_gene : "OTTHUMG00000165372.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63137867,
      stop : 63369718,
      direction : "+",
      ID : "ENSG00000184999.12",
      gene_id : "ENSG00000184999.12",
      gene_type : "protein_coding",
      gene_name : "SLC22A10",
      gene_level : 2,
      hgnc_id : "HGNC:18057",
      havana_gene : "OTTHUMG00000165197.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63163776,
      stop : 63229652,
      direction : "-",
      ID : "ENSG00000196600.12",
      gene_id : "ENSG00000196600.12",
      gene_type : "protein_coding",
      gene_name : "SLC22A25",
      gene_level : 2,
      hgnc_id : "HGNC:32935",
      havana_gene : "OTTHUMG00000165340.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63369785,
      stop : 63410294,
      direction : "+",
      ID : "ENSG00000149742.10",
      gene_id : "ENSG00000149742.10",
      gene_type : "protein_coding",
      gene_name : "SLC22A9",
      gene_level : 2,
      hgnc_id : "HGNC:16261",
      havana_gene : "OTTHUMG00000167805.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63461404,
      stop : 63491194,
      direction : "-",
      ID : "ENSG00000168004.10",
      gene_id : "ENSG00000168004.10",
      gene_type : "protein_coding",
      gene_name : "PLAAT5",
      gene_level : 1,
      hgnc_id : "HGNC:24978",
      havana_gene : "OTTHUMG00000167806.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63506052,
      stop : 63516774,
      direction : "+",
      ID : "ENSG00000133317.16",
      gene_id : "ENSG00000133317.16",
      gene_type : "protein_coding",
      gene_name : "LGALS12",
      gene_level : 2,
      hgnc_id : "HGNC:15788",
      havana_gene : "OTTHUMG00000167807.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63536808,
      stop : 63546462,
      direction : "+",
      ID : "ENSG00000133321.11",
      gene_id : "ENSG00000133321.11",
      gene_type : "protein_coding",
      gene_name : "PLAAT4",
      gene_level : 2,
      hgnc_id : "HGNC:9869",
      havana_gene : "OTTHUMG00000167850.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63552770,
      stop : 63563379,
      direction : "-",
      ID : "ENSG00000133328.4",
      gene_id : "ENSG00000133328.4",
      gene_type : "protein_coding",
      gene_name : "PLAAT2",
      gene_level : 2,
      hgnc_id : "HGNC:17824",
      havana_gene : "OTTHUMG00000167851.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63573195,
      stop : 63616883,
      direction : "-",
      ID : "ENSG00000176485.13",
      gene_id : "ENSG00000176485.13",
      gene_type : "protein_coding",
      gene_name : "PLAAT3",
      gene_level : 2,
      hgnc_id : "HGNC:17825",
      havana_gene : "OTTHUMG00000167852.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63624087,
      stop : 63671921,
      direction : "-",
      ID : "ENSG00000184743.13",
      gene_id : "ENSG00000184743.13",
      gene_type : "protein_coding",
      gene_name : "ATL3",
      gene_level : 1,
      hgnc_id : "HGNC:24526",
      havana_gene : "OTTHUMG00000167854.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63681446,
      stop : 63759891,
      direction : "+",
      ID : "ENSG00000133318.14",
      gene_id : "ENSG00000133318.14",
      gene_type : "protein_coding",
      gene_name : "RTN3",
      gene_level : 1,
      hgnc_id : "HGNC:10469",
      havana_gene : "OTTHUMG00000168056.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63759892,
      stop : 63768775,
      direction : "-",
      ID : "ENSG00000188070.9",
      gene_id : "ENSG00000188070.9",
      gene_type : "protein_coding",
      gene_name : "C11orf95",
      gene_level : 2,
      hgnc_id : "HGNC:28449",
      havana_gene : "OTTHUMG00000167840.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63813456,
      stop : 63827716,
      direction : "+",
      ID : "ENSG00000168005.9",
      gene_id : "ENSG00000168005.9",
      gene_type : "protein_coding",
      gene_name : "SPINDOC",
      gene_level : 2,
      hgnc_id : "HGNC:25115",
      havana_gene : "OTTHUMG00000167746.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63838928,
      stop : 63911020,
      direction : "+",
      ID : "ENSG00000072518.22",
      gene_id : "ENSG00000072518.22",
      gene_type : "protein_coding",
      gene_name : "MARK2",
      gene_level : 1,
      hgnc_id : "HGNC:3332",
      havana_gene : "OTTHUMG00000160504.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63911230,
      stop : 63917164,
      direction : "-",
      ID : "ENSG00000167771.6",
      gene_id : "ENSG00000167771.6",
      gene_type : "protein_coding",
      gene_name : "RCOR2",
      gene_level : 2,
      hgnc_id : "HGNC:27455",
      havana_gene : "OTTHUMG00000150472.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63938959,
      stop : 63957319,
      direction : "+",
      ID : "ENSG00000110583.13",
      gene_id : "ENSG00000110583.13",
      gene_type : "protein_coding",
      gene_name : "NAA40",
      gene_level : 1,
      hgnc_id : "HGNC:25845",
      havana_gene : "OTTHUMG00000167784.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63974620,
      stop : 63976543,
      direction : "+",
      ID : "ENSG00000176340.4",
      gene_id : "ENSG00000176340.4",
      gene_type : "protein_coding",
      gene_name : "COX8A",
      gene_level : 2,
      hgnc_id : "HGNC:2294",
      havana_gene : "OTTHUMG00000167785.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63974620,
      stop : 63988346,
      direction : "+",
      ID : "ENSG00000256100.1",
      gene_id : "ENSG00000256100.1",
      gene_type : "protein_coding",
      gene_name : "AP000721.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167909.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63985853,
      stop : 64001811,
      direction : "+",
      ID : "ENSG00000167770.12",
      gene_id : "ENSG00000167770.12",
      gene_type : "protein_coding",
      gene_name : "OTUB1",
      gene_level : 2,
      hgnc_id : "HGNC:23077",
      havana_gene : "OTTHUMG00000167786.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 63998558,
      stop : 64166113,
      direction : "-",
      ID : "ENSG00000133315.12",
      gene_id : "ENSG00000133315.12",
      gene_type : "protein_coding",
      gene_name : "MACROD1",
      gene_level : 2,
      hgnc_id : "HGNC:29598",
      havana_gene : "OTTHUMG00000167843.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64103188,
      stop : 64119173,
      direction : "+",
      ID : "ENSG00000126500.3",
      gene_id : "ENSG00000126500.3",
      gene_type : "protein_coding",
      gene_name : "FLRT1",
      gene_level : 2,
      hgnc_id : "HGNC:3760",
      havana_gene : "OTTHUMG00000167788.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64185272,
      stop : 64204543,
      direction : "+",
      ID : "ENSG00000168439.17",
      gene_id : "ENSG00000168439.17",
      gene_type : "protein_coding",
      gene_name : "STIP1",
      gene_level : 1,
      hgnc_id : "HGNC:11387",
      havana_gene : "OTTHUMG00000167789.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64206678,
      stop : 64223891,
      direction : "+",
      ID : "ENSG00000149781.13",
      gene_id : "ENSG00000149781.13",
      gene_type : "protein_coding",
      gene_name : "FERMT3",
      gene_level : 1,
      hgnc_id : "HGNC:23151",
      havana_gene : "OTTHUMG00000167790.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64223799,
      stop : 64226254,
      direction : "-",
      ID : "ENSG00000149743.14",
      gene_id : "ENSG00000149743.14",
      gene_type : "protein_coding",
      gene_name : "TRPT1",
      gene_level : 2,
      hgnc_id : "HGNC:20316",
      havana_gene : "OTTHUMG00000167844.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64225941,
      stop : 64230686,
      direction : "+",
      ID : "ENSG00000149761.9",
      gene_id : "ENSG00000149761.9",
      gene_type : "protein_coding",
      gene_name : "NUDT22",
      gene_level : 1,
      hgnc_id : "HGNC:28189",
      havana_gene : "OTTHUMG00000167791.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64230278,
      stop : 64234286,
      direction : "+",
      ID : "ENSG00000110011.13",
      gene_id : "ENSG00000110011.13",
      gene_type : "protein_coding",
      gene_name : "DNAJC4",
      gene_level : 1,
      hgnc_id : "HGNC:5271",
      havana_gene : "OTTHUMG00000167792.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64234584,
      stop : 64239264,
      direction : "+",
      ID : "ENSG00000173511.10",
      gene_id : "ENSG00000173511.10",
      gene_type : "protein_coding",
      gene_name : "VEGFB",
      gene_level : 2,
      hgnc_id : "HGNC:12681",
      havana_gene : "OTTHUMG00000167813.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64241003,
      stop : 64244132,
      direction : "+",
      ID : "ENSG00000173486.14",
      gene_id : "ENSG00000173486.14",
      gene_type : "protein_coding",
      gene_name : "FKBP2",
      gene_level : 2,
      hgnc_id : "HGNC:3718",
      havana_gene : "OTTHUMG00000167814.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64241095,
      stop : 64244132,
      direction : "+",
      ID : "ENSG00000286264.2",
      gene_id : "ENSG00000286264.2",
      gene_type : "protein_coding",
      gene_name : "AP001453.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193518.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64244479,
      stop : 64246943,
      direction : "-",
      ID : "ENSG00000173457.11",
      gene_id : "ENSG00000173457.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R14B",
      gene_level : 1,
      hgnc_id : "HGNC:9057",
      havana_gene : "OTTHUMG00000167846.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64251530,
      stop : 64269150,
      direction : "+",
      ID : "ENSG00000149782.13",
      gene_id : "ENSG00000149782.13",
      gene_type : "protein_coding",
      gene_name : "PLCB3",
      gene_level : 2,
      hgnc_id : "HGNC:9056",
      havana_gene : "OTTHUMG00000167816.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64269830,
      stop : 64284704,
      direction : "-",
      ID : "ENSG00000002330.14",
      gene_id : "ENSG00000002330.14",
      gene_type : "protein_coding",
      gene_name : "BAD",
      gene_level : 1,
      hgnc_id : "HGNC:936",
      havana_gene : "OTTHUMG00000134302.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64270062,
      stop : 64289500,
      direction : "+",
      ID : "ENSG00000173264.15",
      gene_id : "ENSG00000173264.15",
      gene_type : "protein_coding",
      gene_name : "GPR137",
      gene_level : 1,
      hgnc_id : "HGNC:24300",
      havana_gene : "OTTHUMG00000167817.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64291302,
      stop : 64300031,
      direction : "+",
      ID : "ENSG00000182450.13",
      gene_id : "ENSG00000182450.13",
      gene_type : "protein_coding",
      gene_name : "KCNK4",
      gene_level : 2,
      hgnc_id : "HGNC:6279",
      havana_gene : "OTTHUMG00000168006.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64300358,
      stop : 64304770,
      direction : "+",
      ID : "ENSG00000219435.6",
      gene_id : "ENSG00000219435.6",
      gene_type : "protein_coding",
      gene_name : "CATSPERZ",
      gene_level : 2,
      hgnc_id : "HGNC:19231",
      havana_gene : "OTTHUMG00000167820.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64305497,
      stop : 64316743,
      direction : "+",
      ID : "ENSG00000173153.17",
      gene_id : "ENSG00000173153.17",
      gene_type : "protein_coding",
      gene_name : "ESRRA",
      gene_level : 2,
      hgnc_id : "HGNC:3471",
      havana_gene : "OTTHUMG00000150641.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64316460,
      stop : 64317559,
      direction : "-",
      ID : "ENSG00000173113.7",
      gene_id : "ENSG00000173113.7",
      gene_type : "protein_coding",
      gene_name : "TRMT112",
      gene_level : 2,
      hgnc_id : "HGNC:26940",
      havana_gene : "OTTHUMG00000167848.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64318121,
      stop : 64321811,
      direction : "+",
      ID : "ENSG00000126432.14",
      gene_id : "ENSG00000126432.14",
      gene_type : "protein_coding",
      gene_name : "PRDX5",
      gene_level : 2,
      hgnc_id : "HGNC:9355",
      havana_gene : "OTTHUMG00000168805.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64340204,
      stop : 64357534,
      direction : "+",
      ID : "ENSG00000168071.22",
      gene_id : "ENSG00000168071.22",
      gene_type : "protein_coding",
      gene_name : "CCDC88B",
      gene_level : 2,
      hgnc_id : "HGNC:26757",
      havana_gene : "OTTHUMG00000045419.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64359148,
      stop : 64372215,
      direction : "+",
      ID : "ENSG00000162302.13",
      gene_id : "ENSG00000162302.13",
      gene_type : "protein_coding",
      gene_name : "RPS6KA4",
      gene_level : 2,
      hgnc_id : "HGNC:10433",
      havana_gene : "OTTHUMG00000046094.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64555690,
      stop : 64572875,
      direction : "+",
      ID : "ENSG00000168065.16",
      gene_id : "ENSG00000168065.16",
      gene_type : "protein_coding",
      gene_name : "SLC22A11",
      gene_level : 1,
      hgnc_id : "HGNC:18120",
      havana_gene : "OTTHUMG00000045142.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64590641,
      stop : 64602353,
      direction : "+",
      ID : "ENSG00000197891.12",
      gene_id : "ENSG00000197891.12",
      gene_type : "protein_coding",
      gene_name : "SLC22A12",
      gene_level : 1,
      hgnc_id : "HGNC:17989",
      havana_gene : "OTTHUMG00000045213.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64606174,
      stop : 64723197,
      direction : "-",
      ID : "ENSG00000110076.19",
      gene_id : "ENSG00000110076.19",
      gene_type : "protein_coding",
      gene_name : "NRXN2",
      gene_level : 2,
      hgnc_id : "HGNC:8009",
      havana_gene : "OTTHUMG00000045214.19",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64726911,
      stop : 64745456,
      direction : "-",
      ID : "ENSG00000068831.19",
      gene_id : "ENSG00000068831.19",
      gene_type : "protein_coding",
      gene_name : "RASGRP2",
      gene_level : 2,
      hgnc_id : "HGNC:9879",
      havana_gene : "OTTHUMG00000045420.38",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64746389,
      stop : 64759974,
      direction : "-",
      ID : "ENSG00000068976.14",
      gene_id : "ENSG00000068976.14",
      gene_type : "protein_coding",
      gene_name : "PYGM",
      gene_level : 2,
      hgnc_id : "HGNC:9726",
      havana_gene : "OTTHUMG00000066835.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64764606,
      stop : 64778786,
      direction : "-",
      ID : "ENSG00000168066.21",
      gene_id : "ENSG00000168066.21",
      gene_type : "protein_coding",
      gene_name : "SF1",
      gene_level : 1,
      hgnc_id : "HGNC:12950",
      havana_gene : "OTTHUMG00000066833.14",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64784918,
      stop : 64803241,
      direction : "-",
      ID : "ENSG00000168067.12",
      gene_id : "ENSG00000168067.12",
      gene_type : "protein_coding",
      gene_name : "MAP4K2",
      gene_level : 2,
      hgnc_id : "HGNC:6864",
      havana_gene : "OTTHUMG00000045328.38",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64803510,
      stop : 64811294,
      direction : "-",
      ID : "ENSG00000133895.17",
      gene_id : "ENSG00000133895.17",
      gene_type : "protein_coding",
      gene_name : "MEN1",
      gene_level : 1,
      hgnc_id : "HGNC:7010",
      havana_gene : "OTTHUMG00000045366.45",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64823052,
      stop : 64844653,
      direction : "-",
      ID : "ENSG00000171219.9",
      gene_id : "ENSG00000171219.9",
      gene_type : "protein_coding",
      gene_name : "CDC42BPG",
      gene_level : 2,
      hgnc_id : "HGNC:29829",
      havana_gene : "OTTHUMG00000045365.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64851642,
      stop : 64888296,
      direction : "-",
      ID : "ENSG00000110047.18",
      gene_id : "ENSG00000110047.18",
      gene_type : "protein_coding",
      gene_name : "EHD1",
      gene_level : 1,
      hgnc_id : "HGNC:3242",
      havana_gene : "OTTHUMG00000066832.18",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64894546,
      stop : 64917211,
      direction : "-",
      ID : "ENSG00000110046.13",
      gene_id : "ENSG00000110046.13",
      gene_type : "protein_coding",
      gene_name : "ATG2A",
      gene_level : 2,
      hgnc_id : "HGNC:29028",
      havana_gene : "OTTHUMG00000066831.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64917553,
      stop : 64934475,
      direction : "+",
      ID : "ENSG00000068971.14",
      gene_id : "ENSG00000068971.14",
      gene_type : "protein_coding",
      gene_name : "PPP2R5B",
      gene_level : 1,
      hgnc_id : "HGNC:9310",
      havana_gene : "OTTHUMG00000150043.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64934471,
      stop : 64935893,
      direction : "-",
      ID : "ENSG00000149735.7",
      gene_id : "ENSG00000149735.7",
      gene_type : "protein_coding",
      gene_name : "GPHA2",
      gene_level : 2,
      hgnc_id : "HGNC:18054",
      havana_gene : "OTTHUMG00000165631.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64937517,
      stop : 64972108,
      direction : "-",
      ID : "ENSG00000168070.12",
      gene_id : "ENSG00000168070.12",
      gene_type : "protein_coding",
      gene_name : "MAJIN",
      gene_level : 1,
      hgnc_id : "HGNC:27441",
      havana_gene : "OTTHUMG00000165632.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 64987945,
      stop : 64997018,
      direction : "-",
      ID : "ENSG00000168062.10",
      gene_id : "ENSG00000168062.10",
      gene_type : "protein_coding",
      gene_name : "BATF2",
      gene_level : 1,
      hgnc_id : "HGNC:25163",
      havana_gene : "OTTHUMG00000165633.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65014160,
      stop : 65022184,
      direction : "+",
      ID : "ENSG00000213465.8",
      gene_id : "ENSG00000213465.8",
      gene_type : "protein_coding",
      gene_name : "ARL2",
      gene_level : 2,
      hgnc_id : "HGNC:693",
      havana_gene : "OTTHUMG00000165728.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65014182,
      stop : 65040570,
      direction : "+",
      ID : "ENSG00000273003.1",
      gene_id : "ENSG00000273003.1",
      gene_type : "protein_coding",
      gene_name : "ARL2-SNX15",
      gene_level : 2,
      hgnc_id : "HGNC:49197",
      havana_gene : "OTTHUMG00000185851.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65027439,
      stop : 65040572,
      direction : "+",
      ID : "ENSG00000110025.13",
      gene_id : "ENSG00000110025.13",
      gene_type : "protein_coding",
      gene_name : "SNX15",
      gene_level : 1,
      hgnc_id : "HGNC:14978",
      havana_gene : "OTTHUMG00000037387.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65040901,
      stop : 65044828,
      direction : "+",
      ID : "ENSG00000168061.17",
      gene_id : "ENSG00000168061.17",
      gene_type : "protein_coding",
      gene_name : "SAC3D1",
      gene_level : 1,
      hgnc_id : "HGNC:30179",
      havana_gene : "OTTHUMG00000165594.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65044818,
      stop : 65058553,
      direction : "-",
      ID : "ENSG00000168060.16",
      gene_id : "ENSG00000168060.16",
      gene_type : "protein_coding",
      gene_name : "NAALADL1",
      gene_level : 1,
      hgnc_id : "HGNC:23536",
      havana_gene : "OTTHUMG00000165595.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65066300,
      stop : 65084164,
      direction : "-",
      ID : "ENSG00000146670.10",
      gene_id : "ENSG00000146670.10",
      gene_type : "protein_coding",
      gene_name : "CDCA5",
      gene_level : 2,
      hgnc_id : "HGNC:14626",
      havana_gene : "OTTHUMG00000150420.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65084210,
      stop : 65088398,
      direction : "+",
      ID : "ENSG00000162300.13",
      gene_id : "ENSG00000162300.13",
      gene_type : "protein_coding",
      gene_name : "ZFPL1",
      gene_level : 1,
      hgnc_id : "HGNC:12868",
      havana_gene : "OTTHUMG00000165597.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65084979,
      stop : 65089375,
      direction : "-",
      ID : "ENSG00000187066.9",
      gene_id : "ENSG00000187066.9",
      gene_type : "protein_coding",
      gene_name : "TMEM262",
      gene_level : 1,
      hgnc_id : "HGNC:49389",
      havana_gene : "OTTHUMG00000165598.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65089324,
      stop : 65111862,
      direction : "+",
      ID : "ENSG00000149823.9",
      gene_id : "ENSG00000149823.9",
      gene_type : "protein_coding",
      gene_name : "VPS51",
      gene_level : 1,
      hgnc_id : "HGNC:1172",
      havana_gene : "OTTHUMG00000165600.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65111845,
      stop : 65116384,
      direction : "+",
      ID : "ENSG00000149809.17",
      gene_id : "ENSG00000149809.17",
      gene_type : "protein_coding",
      gene_name : "TM7SF2",
      gene_level : 2,
      hgnc_id : "HGNC:11863",
      havana_gene : "OTTHUMG00000165603.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65116403,
      stop : 65117701,
      direction : "-",
      ID : "ENSG00000174276.7",
      gene_id : "ENSG00000174276.7",
      gene_type : "protein_coding",
      gene_name : "ZNHIT2",
      gene_level : 2,
      hgnc_id : "HGNC:1177",
      havana_gene : "OTTHUMG00000165604.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65120630,
      stop : 65122177,
      direction : "-",
      ID : "ENSG00000149806.11",
      gene_id : "ENSG00000149806.11",
      gene_type : "protein_coding",
      gene_name : "FAU",
      gene_level : 2,
      hgnc_id : "HGNC:3597",
      havana_gene : "OTTHUMG00000165606.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65121780,
      stop : 65134532,
      direction : "-",
      ID : "ENSG00000162298.19",
      gene_id : "ENSG00000162298.19",
      gene_type : "protein_coding",
      gene_name : "SYVN1",
      gene_level : 2,
      hgnc_id : "HGNC:20738",
      havana_gene : "OTTHUMG00000165607.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65122183,
      stop : 65127371,
      direction : "+",
      ID : "ENSG00000149792.9",
      gene_id : "ENSG00000149792.9",
      gene_type : "protein_coding",
      gene_name : "MRPL49",
      gene_level : 1,
      hgnc_id : "HGNC:1176",
      havana_gene : "OTTHUMG00000165608.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65170154,
      stop : 65173244,
      direction : "+",
      ID : "ENSG00000204710.2",
      gene_id : "ENSG00000204710.2",
      gene_type : "protein_coding",
      gene_name : "SPDYC",
      gene_level : 2,
      hgnc_id : "HGNC:32681",
      havana_gene : "OTTHUMG00000165611.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65180566,
      stop : 65212006,
      direction : "+",
      ID : "ENSG00000014216.16",
      gene_id : "ENSG00000014216.16",
      gene_type : "protein_coding",
      gene_name : "CAPN1",
      gene_level : 2,
      hgnc_id : "HGNC:1476",
      havana_gene : "OTTHUMG00000165614.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65261920,
      stop : 65305589,
      direction : "+",
      ID : "ENSG00000014138.9",
      gene_id : "ENSG00000014138.9",
      gene_type : "protein_coding",
      gene_name : "POLA2",
      gene_level : 1,
      hgnc_id : "HGNC:30073",
      havana_gene : "OTTHUMG00000193339.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65261928,
      stop : 65326543,
      direction : "+",
      ID : "ENSG00000285816.1",
      gene_id : "ENSG00000285816.1",
      gene_type : "protein_coding",
      gene_name : "AP000944.5",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000165951.6",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65314866,
      stop : 65322417,
      direction : "+",
      ID : "ENSG00000149798.5",
      gene_id : "ENSG00000149798.5",
      gene_type : "protein_coding",
      gene_name : "CDC42EP2",
      gene_level : 2,
      hgnc_id : "HGNC:16263",
      havana_gene : "OTTHUMG00000165958.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65333852,
      stop : 65354262,
      direction : "+",
      ID : "ENSG00000133884.10",
      gene_id : "ENSG00000133884.10",
      gene_type : "protein_coding",
      gene_name : "DPF2",
      gene_level : 1,
      hgnc_id : "HGNC:9964",
      havana_gene : "OTTHUMG00000165985.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65354751,
      stop : 65357613,
      direction : "+",
      ID : "ENSG00000173825.7",
      gene_id : "ENSG00000173825.7",
      gene_type : "protein_coding",
      gene_name : "TIGD3",
      gene_level : 2,
      hgnc_id : "HGNC:18334",
      havana_gene : "OTTHUMG00000165986.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65375192,
      stop : 65383701,
      direction : "-",
      ID : "ENSG00000162241.12",
      gene_id : "ENSG00000162241.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A45",
      gene_level : 2,
      hgnc_id : "HGNC:27442",
      havana_gene : "OTTHUMG00000166255.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65386621,
      stop : 65413525,
      direction : "+",
      ID : "ENSG00000126391.14",
      gene_id : "ENSG00000126391.14",
      gene_type : "protein_coding",
      gene_name : "FRMD8",
      gene_level : 2,
      hgnc_id : "HGNC:25462",
      havana_gene : "OTTHUMG00000166275.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65525077,
      stop : 65538704,
      direction : "+",
      ID : "ENSG00000142186.17",
      gene_id : "ENSG00000142186.17",
      gene_type : "protein_coding",
      gene_name : "SCYL1",
      gene_level : 2,
      hgnc_id : "HGNC:14372",
      havana_gene : "OTTHUMG00000166325.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65538559,
      stop : 65558930,
      direction : "-",
      ID : "ENSG00000168056.17",
      gene_id : "ENSG00000168056.17",
      gene_type : "protein_coding",
      gene_name : "LTBP3",
      gene_level : 1,
      hgnc_id : "HGNC:6716",
      havana_gene : "OTTHUMG00000166575.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65570460,
      stop : 65573942,
      direction : "+",
      ID : "ENSG00000173465.8",
      gene_id : "ENSG00000173465.8",
      gene_type : "protein_coding",
      gene_name : "ZNRD2",
      gene_level : 1,
      hgnc_id : "HGNC:11328",
      havana_gene : "OTTHUMG00000166388.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65572349,
      stop : 65574198,
      direction : "+",
      ID : "ENSG00000176973.8",
      gene_id : "ENSG00000176973.8",
      gene_type : "protein_coding",
      gene_name : "FAM89B",
      gene_level : 2,
      hgnc_id : "HGNC:16708",
      havana_gene : "OTTHUMG00000166499.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65576046,
      stop : 65592650,
      direction : "+",
      ID : "ENSG00000173442.13",
      gene_id : "ENSG00000173442.13",
      gene_type : "protein_coding",
      gene_name : "EHBP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:30682",
      havana_gene : "OTTHUMG00000166520.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65592836,
      stop : 65595996,
      direction : "-",
      ID : "ENSG00000173338.13",
      gene_id : "ENSG00000173338.13",
      gene_type : "protein_coding",
      gene_name : "KCNK7",
      gene_level : 2,
      hgnc_id : "HGNC:6282",
      havana_gene : "OTTHUMG00000166528.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65597756,
      stop : 65615382,
      direction : "-",
      ID : "ENSG00000173327.8",
      gene_id : "ENSG00000173327.8",
      gene_type : "protein_coding",
      gene_name : "MAP3K11",
      gene_level : 1,
      hgnc_id : "HGNC:6850",
      havana_gene : "OTTHUMG00000166529.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65615773,
      stop : 65637439,
      direction : "+",
      ID : "ENSG00000197136.4",
      gene_id : "ENSG00000197136.4",
      gene_type : "protein_coding",
      gene_name : "PCNX3",
      gene_level : 1,
      hgnc_id : "HGNC:18760",
      havana_gene : "OTTHUMG00000166539.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65638101,
      stop : 65650918,
      direction : "+",
      ID : "ENSG00000213445.10",
      gene_id : "ENSG00000213445.10",
      gene_type : "protein_coding",
      gene_name : "SIPA1",
      gene_level : 1,
      hgnc_id : "HGNC:10885",
      havana_gene : "OTTHUMG00000166541.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65653597,
      stop : 65663090,
      direction : "-",
      ID : "ENSG00000173039.19",
      gene_id : "ENSG00000173039.19",
      gene_type : "protein_coding",
      gene_name : "RELA",
      gene_level : 2,
      hgnc_id : "HGNC:9955",
      havana_gene : "OTTHUMG00000166566.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65711996,
      stop : 65719604,
      direction : "+",
      ID : "ENSG00000172977.13",
      gene_id : "ENSG00000172977.13",
      gene_type : "protein_coding",
      gene_name : "KAT5",
      gene_level : 1,
      hgnc_id : "HGNC:5275",
      havana_gene : "OTTHUMG00000166617.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65714005,
      stop : 65720818,
      direction : "-",
      ID : "ENSG00000172922.11",
      gene_id : "ENSG00000172922.11",
      gene_type : "protein_coding",
      gene_name : "RNASEH2C",
      gene_level : 2,
      hgnc_id : "HGNC:24116",
      havana_gene : "OTTHUMG00000166601.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65773898,
      stop : 65780976,
      direction : "-",
      ID : "ENSG00000254470.3",
      gene_id : "ENSG00000254470.3",
      gene_type : "protein_coding",
      gene_name : "AP5B1",
      gene_level : 2,
      hgnc_id : "HGNC:25104",
      havana_gene : "OTTHUMG00000166593.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65787063,
      stop : 65797214,
      direction : "+",
      ID : "ENSG00000172818.10",
      gene_id : "ENSG00000172818.10",
      gene_type : "protein_coding",
      gene_name : "OVOL1",
      gene_level : 2,
      hgnc_id : "HGNC:8525",
      havana_gene : "OTTHUMG00000166600.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65823022,
      stop : 65862026,
      direction : "-",
      ID : "ENSG00000172757.13",
      gene_id : "ENSG00000172757.13",
      gene_type : "protein_coding",
      gene_name : "CFL1",
      gene_level : 1,
      hgnc_id : "HGNC:1874",
      havana_gene : "OTTHUMG00000166602.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65833834,
      stop : 65856896,
      direction : "+",
      ID : "ENSG00000172803.18",
      gene_id : "ENSG00000172803.18",
      gene_type : "protein_coding",
      gene_name : "SNX32",
      gene_level : 1,
      hgnc_id : "HGNC:26423",
      havana_gene : "OTTHUMG00000128491.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65857126,
      stop : 65867653,
      direction : "+",
      ID : "ENSG00000172732.12",
      gene_id : "ENSG00000172732.12",
      gene_type : "protein_coding",
      gene_name : "MUS81",
      gene_level : 1,
      hgnc_id : "HGNC:29814",
      havana_gene : "OTTHUMG00000166633.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65866441,
      stop : 65873592,
      direction : "-",
      ID : "ENSG00000172638.13",
      gene_id : "ENSG00000172638.13",
      gene_type : "protein_coding",
      gene_name : "EFEMP2",
      gene_level : 1,
      hgnc_id : "HGNC:3219",
      havana_gene : "OTTHUMG00000166664.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65879809,
      stop : 65883741,
      direction : "+",
      ID : "ENSG00000172543.9",
      gene_id : "ENSG00000172543.9",
      gene_type : "protein_coding",
      gene_name : "CTSW",
      gene_level : 2,
      hgnc_id : "HGNC:2546",
      havana_gene : "OTTHUMG00000166663.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65883740,
      stop : 65888531,
      direction : "-",
      ID : "ENSG00000172500.13",
      gene_id : "ENSG00000172500.13",
      gene_type : "protein_coding",
      gene_name : "FIBP",
      gene_level : 2,
      hgnc_id : "HGNC:3705",
      havana_gene : "OTTHUMG00000166846.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65890673,
      stop : 65891635,
      direction : "+",
      ID : "ENSG00000175602.4",
      gene_id : "ENSG00000175602.4",
      gene_type : "protein_coding",
      gene_name : "CCDC85B",
      gene_level : 2,
      hgnc_id : "HGNC:24926",
      havana_gene : "OTTHUMG00000166722.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65892049,
      stop : 65900573,
      direction : "-",
      ID : "ENSG00000175592.9",
      gene_id : "ENSG00000175592.9",
      gene_type : "protein_coding",
      gene_name : "FOSL1",
      gene_level : 1,
      hgnc_id : "HGNC:13718",
      havana_gene : "OTTHUMG00000166715.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65916810,
      stop : 65919062,
      direction : "-",
      ID : "ENSG00000175573.7",
      gene_id : "ENSG00000175573.7",
      gene_type : "protein_coding",
      gene_name : "C11orf68",
      gene_level : 2,
      hgnc_id : "HGNC:28801",
      havana_gene : "OTTHUMG00000157153.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65919274,
      stop : 65921563,
      direction : "+",
      ID : "ENSG00000175550.8",
      gene_id : "ENSG00000175550.8",
      gene_type : "protein_coding",
      gene_name : "DRAP1",
      gene_level : 2,
      hgnc_id : "HGNC:3019",
      havana_gene : "OTTHUMG00000166723.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65945445,
      stop : 65959963,
      direction : "+",
      ID : "ENSG00000175513.9",
      gene_id : "ENSG00000175513.9",
      gene_type : "protein_coding",
      gene_name : "TSGA10IP",
      gene_level : 2,
      hgnc_id : "HGNC:26555",
      havana_gene : "OTTHUMG00000166753.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65961728,
      stop : 65980137,
      direction : "+",
      ID : "ENSG00000175467.15",
      gene_id : "ENSG00000175467.15",
      gene_type : "protein_coding",
      gene_name : "SART1",
      gene_level : 2,
      hgnc_id : "HGNC:10538",
      havana_gene : "OTTHUMG00000166771.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 65996545,
      stop : 66002176,
      direction : "-",
      ID : "ENSG00000175376.9",
      gene_id : "ENSG00000175376.9",
      gene_type : "protein_coding",
      gene_name : "EIF1AD",
      gene_level : 1,
      hgnc_id : "HGNC:28147",
      havana_gene : "OTTHUMG00000166671.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66002228,
      stop : 66004149,
      direction : "+",
      ID : "ENSG00000175334.8",
      gene_id : "ENSG00000175334.8",
      gene_type : "protein_coding",
      gene_name : "BANF1",
      gene_level : 2,
      hgnc_id : "HGNC:17397",
      havana_gene : "OTTHUMG00000166749.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66012008,
      stop : 66013505,
      direction : "+",
      ID : "ENSG00000175315.3",
      gene_id : "ENSG00000175315.3",
      gene_type : "protein_coding",
      gene_name : "CST6",
      gene_level : 2,
      hgnc_id : "HGNC:2478",
      havana_gene : "OTTHUMG00000166750.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66016752,
      stop : 66026479,
      direction : "-",
      ID : "ENSG00000175294.6",
      gene_id : "ENSG00000175294.6",
      gene_type : "protein_coding",
      gene_name : "CATSPER1",
      gene_level : 2,
      hgnc_id : "HGNC:17116",
      havana_gene : "OTTHUMG00000166668.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66040765,
      stop : 66049161,
      direction : "-",
      ID : "ENSG00000175229.7",
      gene_id : "ENSG00000175229.7",
      gene_type : "protein_coding",
      gene_name : "GAL3ST3",
      gene_level : 2,
      hgnc_id : "HGNC:24144",
      havana_gene : "OTTHUMG00000166667.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66050729,
      stop : 66069308,
      direction : "+",
      ID : "ENSG00000087365.16",
      gene_id : "ENSG00000087365.16",
      gene_type : "protein_coding",
      gene_name : "SF3B2",
      gene_level : 1,
      hgnc_id : "HGNC:10769",
      havana_gene : "OTTHUMG00000166751.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66070272,
      stop : 66244744,
      direction : "+",
      ID : "ENSG00000175115.13",
      gene_id : "ENSG00000175115.13",
      gene_type : "protein_coding",
      gene_name : "PACS1",
      gene_level : 1,
      hgnc_id : "HGNC:30032",
      havana_gene : "OTTHUMG00000166889.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66257294,
      stop : 66267860,
      direction : "+",
      ID : "ENSG00000174996.12",
      gene_id : "ENSG00000174996.12",
      gene_type : "protein_coding",
      gene_name : "KLC2",
      gene_level : 2,
      hgnc_id : "HGNC:20716",
      havana_gene : "OTTHUMG00000133757.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66268590,
      stop : 66277492,
      direction : "+",
      ID : "ENSG00000174903.16",
      gene_id : "ENSG00000174903.16",
      gene_type : "protein_coding",
      gene_name : "RAB1B",
      gene_level : 2,
      hgnc_id : "HGNC:18370",
      havana_gene : "OTTHUMG00000166916.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66278175,
      stop : 66285301,
      direction : "+",
      ID : "ENSG00000174871.11",
      gene_id : "ENSG00000174871.11",
      gene_type : "protein_coding",
      gene_name : "CNIH2",
      gene_level : 2,
      hgnc_id : "HGNC:28744",
      havana_gene : "OTTHUMG00000166919.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66284580,
      stop : 66289145,
      direction : "-",
      ID : "ENSG00000174851.16",
      gene_id : "ENSG00000174851.16",
      gene_type : "protein_coding",
      gene_name : "YIF1A",
      gene_level : 1,
      hgnc_id : "HGNC:16688",
      havana_gene : "OTTHUMG00000102079.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66291894,
      stop : 66296664,
      direction : "+",
      ID : "ENSG00000179292.5",
      gene_id : "ENSG00000179292.5",
      gene_type : "protein_coding",
      gene_name : "TMEM151A",
      gene_level : 2,
      hgnc_id : "HGNC:28497",
      havana_gene : "OTTHUMG00000166920.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66314494,
      stop : 66317044,
      direction : "-",
      ID : "ENSG00000174807.4",
      gene_id : "ENSG00000174807.4",
      gene_type : "protein_coding",
      gene_name : "CD248",
      gene_level : 2,
      hgnc_id : "HGNC:18219",
      havana_gene : "OTTHUMG00000167073.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66330241,
      stop : 66336840,
      direction : "-",
      ID : "ENSG00000174791.11",
      gene_id : "ENSG00000174791.11",
      gene_type : "protein_coding",
      gene_name : "RIN1",
      gene_level : 1,
      hgnc_id : "HGNC:18749",
      havana_gene : "OTTHUMG00000167085.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66337333,
      stop : 66345125,
      direction : "-",
      ID : "ENSG00000174744.14",
      gene_id : "ENSG00000174744.14",
      gene_type : "protein_coding",
      gene_name : "BRMS1",
      gene_level : 2,
      hgnc_id : "HGNC:17262",
      havana_gene : "OTTHUMG00000167081.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66345374,
      stop : 66347629,
      direction : "-",
      ID : "ENSG00000174684.7",
      gene_id : "ENSG00000174684.7",
      gene_type : "protein_coding",
      gene_name : "B4GAT1",
      gene_level : 2,
      hgnc_id : "HGNC:15685",
      havana_gene : "OTTHUMG00000167082.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66362521,
      stop : 66372214,
      direction : "-",
      ID : "ENSG00000174669.12",
      gene_id : "ENSG00000174669.12",
      gene_type : "protein_coding",
      gene_name : "SLC29A2",
      gene_level : 2,
      hgnc_id : "HGNC:11004",
      havana_gene : "OTTHUMG00000169056.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66421004,
      stop : 66426707,
      direction : "+",
      ID : "ENSG00000174576.10",
      gene_id : "ENSG00000174576.10",
      gene_type : "protein_coding",
      gene_name : "NPAS4",
      gene_level : 2,
      hgnc_id : "HGNC:18983",
      havana_gene : "OTTHUMG00000167045.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66435075,
      stop : 66466738,
      direction : "-",
      ID : "ENSG00000174547.13",
      gene_id : "ENSG00000174547.13",
      gene_type : "protein_coding",
      gene_name : "MRPL11",
      gene_level : 1,
      hgnc_id : "HGNC:14042",
      havana_gene : "OTTHUMG00000167097.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66466327,
      stop : 66477337,
      direction : "+",
      ID : "ENSG00000174516.15",
      gene_id : "ENSG00000174516.15",
      gene_type : "protein_coding",
      gene_name : "PELI3",
      gene_level : 1,
      hgnc_id : "HGNC:30010",
      havana_gene : "OTTHUMG00000167109.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66480013,
      stop : 66509657,
      direction : "+",
      ID : "ENSG00000254986.7",
      gene_id : "ENSG00000254986.7",
      gene_type : "protein_coding",
      gene_name : "DPP3",
      gene_level : 1,
      hgnc_id : "HGNC:3008",
      havana_gene : "OTTHUMG00000167143.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66509079,
      stop : 66533613,
      direction : "+",
      ID : "ENSG00000256349.1",
      gene_id : "ENSG00000256349.1",
      gene_type : "protein_coding",
      gene_name : "AP002748.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167719.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66510606,
      stop : 66533613,
      direction : "+",
      ID : "ENSG00000174483.20",
      gene_id : "ENSG00000174483.20",
      gene_type : "protein_coding",
      gene_name : "BBS1",
      gene_level : 1,
      hgnc_id : "HGNC:966",
      havana_gene : "OTTHUMG00000167110.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66520637,
      stop : 66546235,
      direction : "-",
      ID : "ENSG00000174165.8",
      gene_id : "ENSG00000174165.8",
      gene_type : "protein_coding",
      gene_name : "ZDHHC24",
      gene_level : 1,
      hgnc_id : "HGNC:27387",
      havana_gene : "OTTHUMG00000167096.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66546395,
      stop : 66563334,
      direction : "+",
      ID : "ENSG00000248746.6",
      gene_id : "ENSG00000248746.6",
      gene_type : "protein_coding",
      gene_name : "ACTN3",
      gene_level : 2,
      hgnc_id : "HGNC:165",
      havana_gene : "OTTHUMG00000160815.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66563464,
      stop : 66568879,
      direction : "-",
      ID : "ENSG00000174080.12",
      gene_id : "ENSG00000174080.12",
      gene_type : "protein_coding",
      gene_name : "CTSF",
      gene_level : 2,
      hgnc_id : "HGNC:2531",
      havana_gene : "OTTHUMG00000167090.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66590176,
      stop : 66593063,
      direction : "-",
      ID : "ENSG00000182791.5",
      gene_id : "ENSG00000182791.5",
      gene_type : "protein_coding",
      gene_name : "CCDC87",
      gene_level : 2,
      hgnc_id : "HGNC:25579",
      havana_gene : "OTTHUMG00000167237.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66593153,
      stop : 66606019,
      direction : "+",
      ID : "ENSG00000173992.9",
      gene_id : "ENSG00000173992.9",
      gene_type : "protein_coding",
      gene_name : "CCS",
      gene_level : 2,
      hgnc_id : "HGNC:1613",
      havana_gene : "OTTHUMG00000167238.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66616626,
      stop : 66629934,
      direction : "+",
      ID : "ENSG00000239306.5",
      gene_id : "ENSG00000239306.5",
      gene_type : "protein_coding",
      gene_name : "RBM14",
      gene_level : 1,
      hgnc_id : "HGNC:14219",
      havana_gene : "OTTHUMG00000140380.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66616626,
      stop : 66646469,
      direction : "+",
      ID : "ENSG00000248643.5",
      gene_id : "ENSG00000248643.5",
      gene_type : "protein_coding",
      gene_name : "RBM14-RBM4",
      gene_level : 1,
      hgnc_id : "HGNC:38840",
      havana_gene : "OTTHUMG00000160813.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66638667,
      stop : 66668374,
      direction : "+",
      ID : "ENSG00000173933.21",
      gene_id : "ENSG00000173933.21",
      gene_type : "protein_coding",
      gene_name : "RBM4",
      gene_level : 1,
      hgnc_id : "HGNC:9901",
      havana_gene : "OTTHUMG00000154171.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66664998,
      stop : 66677887,
      direction : "-",
      ID : "ENSG00000173914.12",
      gene_id : "ENSG00000173914.12",
      gene_type : "protein_coding",
      gene_name : "RBM4B",
      gene_level : 1,
      hgnc_id : "HGNC:28842",
      havana_gene : "OTTHUMG00000167243.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66682497,
      stop : 66729226,
      direction : "-",
      ID : "ENSG00000173898.14",
      gene_id : "ENSG00000173898.14",
      gene_type : "protein_coding",
      gene_name : "SPTBN2",
      gene_level : 2,
      hgnc_id : "HGNC:11276",
      havana_gene : "OTTHUMG00000167262.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66744451,
      stop : 66843516,
      direction : "+",
      ID : "ENSG00000173715.18",
      gene_id : "ENSG00000173715.18",
      gene_type : "protein_coding",
      gene_name : "C11orf80",
      gene_level : 1,
      hgnc_id : "HGNC:26197",
      havana_gene : "OTTHUMG00000167164.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66842835,
      stop : 66846552,
      direction : "+",
      ID : "ENSG00000173653.8",
      gene_id : "ENSG00000173653.8",
      gene_type : "protein_coding",
      gene_name : "RCE1",
      gene_level : 2,
      hgnc_id : "HGNC:13721",
      havana_gene : "OTTHUMG00000167098.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66848417,
      stop : 66958386,
      direction : "-",
      ID : "ENSG00000173599.15",
      gene_id : "ENSG00000173599.15",
      gene_type : "protein_coding",
      gene_name : "PC",
      gene_level : 2,
      hgnc_id : "HGNC:8636",
      havana_gene : "OTTHUMG00000167099.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66856647,
      stop : 66860475,
      direction : "+",
      ID : "ENSG00000173621.9",
      gene_id : "ENSG00000173621.9",
      gene_type : "protein_coding",
      gene_name : "LRFN4",
      gene_level : 1,
      hgnc_id : "HGNC:28456",
      havana_gene : "OTTHUMG00000167100.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 66975277,
      stop : 66977004,
      direction : "+",
      ID : "ENSG00000173237.4",
      gene_id : "ENSG00000173237.4",
      gene_type : "protein_coding",
      gene_name : "C11orf86",
      gene_level : 2,
      hgnc_id : "HGNC:34442",
      havana_gene : "OTTHUMG00000153671.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67006778,
      stop : 67050863,
      direction : "+",
      ID : "ENSG00000173227.14",
      gene_id : "ENSG00000173227.14",
      gene_type : "protein_coding",
      gene_name : "SYT12",
      gene_level : 2,
      hgnc_id : "HGNC:18381",
      havana_gene : "OTTHUMG00000167101.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67056847,
      stop : 67072017,
      direction : "+",
      ID : "ENSG00000173156.7",
      gene_id : "ENSG00000173156.7",
      gene_type : "protein_coding",
      gene_name : "RHOD",
      gene_level : 1,
      hgnc_id : "HGNC:670",
      havana_gene : "OTTHUMG00000167102.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67119263,
      stop : 67258082,
      direction : "+",
      ID : "ENSG00000173120.15",
      gene_id : "ENSG00000173120.15",
      gene_type : "protein_coding",
      gene_name : "KDM2A",
      gene_level : 1,
      hgnc_id : "HGNC:13606",
      havana_gene : "OTTHUMG00000167103.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67266473,
      stop : 67286556,
      direction : "+",
      ID : "ENSG00000173020.11",
      gene_id : "ENSG00000173020.11",
      gene_type : "protein_coding",
      gene_name : "GRK2",
      gene_level : 2,
      hgnc_id : "HGNC:289",
      havana_gene : "OTTHUMG00000167104.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67289300,
      stop : 67302485,
      direction : "+",
      ID : "ENSG00000172932.16",
      gene_id : "ENSG00000172932.16",
      gene_type : "protein_coding",
      gene_name : "ANKRD13D",
      gene_level : 2,
      hgnc_id : "HGNC:27880",
      havana_gene : "OTTHUMG00000162929.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67303478,
      stop : 67312607,
      direction : "+",
      ID : "ENSG00000172830.13",
      gene_id : "ENSG00000172830.13",
      gene_type : "protein_coding",
      gene_name : "SSH3",
      gene_level : 2,
      hgnc_id : "HGNC:30581",
      havana_gene : "OTTHUMG00000167105.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67317871,
      stop : 67398410,
      direction : "+",
      ID : "ENSG00000172613.8",
      gene_id : "ENSG00000172613.8",
      gene_type : "protein_coding",
      gene_name : "RAD9A",
      gene_level : 2,
      hgnc_id : "HGNC:9827",
      havana_gene : "OTTHUMG00000167670.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67350772,
      stop : 67356972,
      direction : "-",
      ID : "ENSG00000175482.9",
      gene_id : "ENSG00000175482.9",
      gene_type : "protein_coding",
      gene_name : "POLD4",
      gene_level : 1,
      hgnc_id : "HGNC:14106",
      havana_gene : "OTTHUMG00000167135.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67351572,
      stop : 67373584,
      direction : "-",
      ID : "ENSG00000256514.1",
      gene_id : "ENSG00000256514.1",
      gene_type : "protein_coding",
      gene_name : "AP003419.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167774.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67364168,
      stop : 67374177,
      direction : "-",
      ID : "ENSG00000175505.11",
      gene_id : "ENSG00000175505.11",
      gene_type : "protein_coding",
      gene_name : "CLCF1",
      gene_level : 2,
      hgnc_id : "HGNC:17412",
      havana_gene : "OTTHUMG00000167669.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67398181,
      stop : 67421183,
      direction : "-",
      ID : "ENSG00000172531.16",
      gene_id : "ENSG00000172531.16",
      gene_type : "protein_coding",
      gene_name : "PPP1CA",
      gene_level : 2,
      hgnc_id : "HGNC:9281",
      havana_gene : "OTTHUMG00000167671.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67403915,
      stop : 67410089,
      direction : "+",
      ID : "ENSG00000175463.12",
      gene_id : "ENSG00000175463.12",
      gene_type : "protein_coding",
      gene_name : "TBC1D10C",
      gene_level : 2,
      hgnc_id : "HGNC:24702",
      havana_gene : "OTTHUMG00000167139.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67414968,
      stop : 67425607,
      direction : "+",
      ID : "ENSG00000172508.10",
      gene_id : "ENSG00000172508.10",
      gene_type : "protein_coding",
      gene_name : "CARNS1",
      gene_level : 2,
      hgnc_id : "HGNC:29268",
      havana_gene : "OTTHUMG00000167672.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67428460,
      stop : 67435401,
      direction : "+",
      ID : "ENSG00000175634.15",
      gene_id : "ENSG00000175634.15",
      gene_type : "protein_coding",
      gene_name : "RPS6KB2",
      gene_level : 1,
      hgnc_id : "HGNC:10437",
      havana_gene : "OTTHUMG00000167673.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67435510,
      stop : 67437682,
      direction : "-",
      ID : "ENSG00000213402.3",
      gene_id : "ENSG00000213402.3",
      gene_type : "protein_coding",
      gene_name : "PTPRCAP",
      gene_level : 2,
      hgnc_id : "HGNC:9667",
      havana_gene : "OTTHUMG00000150325.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67435510,
      stop : 67443821,
      direction : "-",
      ID : "ENSG00000172725.14",
      gene_id : "ENSG00000172725.14",
      gene_type : "protein_coding",
      gene_name : "CORO1B",
      gene_level : 2,
      hgnc_id : "HGNC:2253",
      havana_gene : "OTTHUMG00000167775.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67451301,
      stop : 67452729,
      direction : "-",
      ID : "ENSG00000175514.2",
      gene_id : "ENSG00000175514.2",
      gene_type : "protein_coding",
      gene_name : "GPR152",
      gene_level : 2,
      hgnc_id : "HGNC:23622",
      havana_gene : "OTTHUMG00000168032.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67452406,
      stop : 67461752,
      direction : "+",
      ID : "ENSG00000175544.14",
      gene_id : "ENSG00000175544.14",
      gene_type : "protein_coding",
      gene_name : "CABP4",
      gene_level : 1,
      hgnc_id : "HGNC:1386",
      havana_gene : "OTTHUMG00000168033.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67461710,
      stop : 67469272,
      direction : "-",
      ID : "ENSG00000172663.9",
      gene_id : "ENSG00000172663.9",
      gene_type : "protein_coding",
      gene_name : "TMEM134",
      gene_level : 2,
      hgnc_id : "HGNC:26142",
      havana_gene : "OTTHUMG00000168034.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67483026,
      stop : 67491103,
      direction : "+",
      ID : "ENSG00000110711.10",
      gene_id : "ENSG00000110711.10",
      gene_type : "protein_coding",
      gene_name : "AIP",
      gene_level : 1,
      hgnc_id : "HGNC:358",
      havana_gene : "OTTHUMG00000167674.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67491768,
      stop : 67506263,
      direction : "-",
      ID : "ENSG00000110697.13",
      gene_id : "ENSG00000110697.13",
      gene_type : "protein_coding",
      gene_name : "PITPNM1",
      gene_level : 1,
      hgnc_id : "HGNC:9003",
      havana_gene : "OTTHUMG00000167675.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67506497,
      stop : 67508649,
      direction : "-",
      ID : "ENSG00000167797.8",
      gene_id : "ENSG00000167797.8",
      gene_type : "protein_coding",
      gene_name : "CDK2AP2",
      gene_level : 2,
      hgnc_id : "HGNC:30833",
      havana_gene : "OTTHUMG00000167676.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67518912,
      stop : 67524517,
      direction : "-",
      ID : "ENSG00000167791.14",
      gene_id : "ENSG00000167791.14",
      gene_type : "protein_coding",
      gene_name : "CABP2",
      gene_level : 1,
      hgnc_id : "HGNC:1385",
      havana_gene : "OTTHUMG00000168014.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67583742,
      stop : 67586656,
      direction : "+",
      ID : "ENSG00000084207.18",
      gene_id : "ENSG00000084207.18",
      gene_type : "protein_coding",
      gene_name : "GSTP1",
      gene_level : 2,
      hgnc_id : "HGNC:4638",
      havana_gene : "OTTHUMG00000137430.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67605653,
      stop : 67612554,
      direction : "+",
      ID : "ENSG00000167792.13",
      gene_id : "ENSG00000167792.13",
      gene_type : "protein_coding",
      gene_name : "NDUFV1",
      gene_level : 1,
      hgnc_id : "HGNC:7716",
      havana_gene : "OTTHUMG00000166215.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67627938,
      stop : 67629937,
      direction : "-",
      ID : "ENSG00000167799.10",
      gene_id : "ENSG00000167799.10",
      gene_type : "protein_coding",
      gene_name : "NUDT8",
      gene_level : 2,
      hgnc_id : "HGNC:8055",
      havana_gene : "OTTHUMG00000167292.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67631303,
      stop : 67639560,
      direction : "-",
      ID : "ENSG00000167800.9",
      gene_id : "ENSG00000167800.9",
      gene_type : "protein_coding",
      gene_name : "TBX10",
      gene_level : 2,
      hgnc_id : "HGNC:11593",
      havana_gene : "OTTHUMG00000167291.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67642555,
      stop : 67650730,
      direction : "-",
      ID : "ENSG00000132744.8",
      gene_id : "ENSG00000132744.8",
      gene_type : "protein_coding",
      gene_name : "ACY3",
      gene_level : 1,
      hgnc_id : "HGNC:24104",
      havana_gene : "OTTHUMG00000167283.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67662160,
      stop : 67681224,
      direction : "-",
      ID : "ENSG00000132746.15",
      gene_id : "ENSG00000132746.15",
      gene_type : "protein_coding",
      gene_name : "ALDH3B2",
      gene_level : 1,
      hgnc_id : "HGNC:411",
      havana_gene : "OTTHUMG00000167284.14",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 67991100,
      stop : 68004982,
      direction : "-",
      ID : "ENSG00000110057.8",
      gene_id : "ENSG00000110057.8",
      gene_type : "protein_coding",
      gene_name : "UNC93B1",
      gene_level : 1,
      hgnc_id : "HGNC:13481",
      havana_gene : "OTTHUMG00000167472.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68008578,
      stop : 68029282,
      direction : "+",
      ID : "ENSG00000006534.16",
      gene_id : "ENSG00000006534.16",
      gene_type : "protein_coding",
      gene_name : "ALDH3B1",
      gene_level : 2,
      hgnc_id : "HGNC:410",
      havana_gene : "OTTHUMG00000154910.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68030617,
      stop : 68036644,
      direction : "+",
      ID : "ENSG00000110717.13",
      gene_id : "ENSG00000110717.13",
      gene_type : "protein_coding",
      gene_name : "NDUFS8",
      gene_level : 1,
      hgnc_id : "HGNC:7715",
      havana_gene : "OTTHUMG00000167331.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68039025,
      stop : 68050895,
      direction : "+",
      ID : "ENSG00000110719.10",
      gene_id : "ENSG00000110719.10",
      gene_type : "protein_coding",
      gene_name : "TCIRG1",
      gene_level : 1,
      hgnc_id : "HGNC:11647",
      havana_gene : "OTTHUMG00000167358.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68052859,
      stop : 68121444,
      direction : "-",
      ID : "ENSG00000110721.12",
      gene_id : "ENSG00000110721.12",
      gene_type : "protein_coding",
      gene_name : "CHKA",
      gene_level : 1,
      hgnc_id : "HGNC:1937",
      havana_gene : "OTTHUMG00000167424.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68154863,
      stop : 68213828,
      direction : "-",
      ID : "ENSG00000110066.15",
      gene_id : "ENSG00000110066.15",
      gene_type : "protein_coding",
      gene_name : "KMT5B",
      gene_level : 1,
      hgnc_id : "HGNC:24283",
      havana_gene : "OTTHUMG00000150484.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68261338,
      stop : 68272001,
      direction : "-",
      ID : "ENSG00000171067.11",
      gene_id : "ENSG00000171067.11",
      gene_type : "protein_coding",
      gene_name : "C11orf24",
      gene_level : 1,
      hgnc_id : "HGNC:1174",
      havana_gene : "OTTHUMG00000167478.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68312591,
      stop : 68449275,
      direction : "+",
      ID : "ENSG00000162337.12",
      gene_id : "ENSG00000162337.12",
      gene_type : "protein_coding",
      gene_name : "LRP5",
      gene_level : 1,
      hgnc_id : "HGNC:6697",
      havana_gene : "OTTHUMG00000167570.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68460731,
      stop : 68615334,
      direction : "+",
      ID : "ENSG00000110075.15",
      gene_id : "ENSG00000110075.15",
      gene_type : "protein_coding",
      gene_name : "PPP6R3",
      gene_level : 1,
      hgnc_id : "HGNC:1173",
      havana_gene : "OTTHUMG00000167596.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68683779,
      stop : 68691175,
      direction : "+",
      ID : "ENSG00000069482.7",
      gene_id : "ENSG00000069482.7",
      gene_type : "protein_coding",
      gene_name : "GAL",
      gene_level : 2,
      hgnc_id : "HGNC:4114",
      havana_gene : "OTTHUMG00000167890.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68707440,
      stop : 68751520,
      direction : "-",
      ID : "ENSG00000132749.11",
      gene_id : "ENSG00000132749.11",
      gene_type : "protein_coding",
      gene_name : "TESMIN",
      gene_level : 1,
      hgnc_id : "HGNC:7446",
      havana_gene : "OTTHUMG00000167891.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68754620,
      stop : 68844410,
      direction : "-",
      ID : "ENSG00000110090.13",
      gene_id : "ENSG00000110090.13",
      gene_type : "protein_coding",
      gene_name : "CPT1A",
      gene_level : 1,
      hgnc_id : "HGNC:2328",
      havana_gene : "OTTHUMG00000167892.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68891276,
      stop : 68903835,
      direction : "-",
      ID : "ENSG00000197345.13",
      gene_id : "ENSG00000197345.13",
      gene_type : "protein_coding",
      gene_name : "MRPL21",
      gene_level : 2,
      hgnc_id : "HGNC:14479",
      havana_gene : "OTTHUMG00000167893.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68903863,
      stop : 68940602,
      direction : "+",
      ID : "ENSG00000132740.10",
      gene_id : "ENSG00000132740.10",
      gene_type : "protein_coding",
      gene_name : "IGHMBP2",
      gene_level : 1,
      hgnc_id : "HGNC:5542",
      havana_gene : "OTTHUMG00000167894.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 68980021,
      stop : 68980986,
      direction : "-",
      ID : "ENSG00000172938.3",
      gene_id : "ENSG00000172938.3",
      gene_type : "protein_coding",
      gene_name : "MRGPRD",
      gene_level : 2,
      hgnc_id : "HGNC:29626",
      havana_gene : "OTTHUMG00000167896.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69004395,
      stop : 69013382,
      direction : "-",
      ID : "ENSG00000172935.9",
      gene_id : "ENSG00000172935.9",
      gene_type : "protein_coding",
      gene_name : "MRGPRF",
      gene_level : 2,
      hgnc_id : "HGNC:24828",
      havana_gene : "OTTHUMG00000167897.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69048932,
      stop : 69136316,
      direction : "+",
      ID : "ENSG00000162341.18",
      gene_id : "ENSG00000162341.18",
      gene_type : "protein_coding",
      gene_name : "TPCN2",
      gene_level : 1,
      hgnc_id : "HGNC:20820",
      havana_gene : "OTTHUMG00000193817.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69072915,
      stop : 69162440,
      direction : "+",
      ID : "ENSG00000287725.1",
      gene_id : "ENSG00000287725.1",
      gene_type : "protein_coding",
      gene_name : "AP003071.5",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000167898.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69155478,
      stop : 69159752,
      direction : "+",
      ID : "ENSG00000284713.1",
      gene_id : "ENSG00000284713.1",
      gene_type : "protein_coding",
      gene_name : "SMIM38",
      gene_level : 2,
      hgnc_id : "HGNC:54074",
      havana_gene : "OTTHUMG00000172974.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69294151,
      stop : 69367726,
      direction : "+",
      ID : "ENSG00000172927.8",
      gene_id : "ENSG00000172927.8",
      gene_type : "protein_coding",
      gene_name : "MYEOV",
      gene_level : 2,
      hgnc_id : "HGNC:7563",
      havana_gene : "OTTHUMG00000167836.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69641156,
      stop : 69654474,
      direction : "+",
      ID : "ENSG00000110092.4",
      gene_id : "ENSG00000110092.4",
      gene_type : "protein_coding",
      gene_name : "CCND1",
      gene_level : 1,
      hgnc_id : "HGNC:1582",
      havana_gene : "OTTHUMG00000167877.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69653076,
      stop : 69675416,
      direction : "-",
      ID : "ENSG00000149716.13",
      gene_id : "ENSG00000149716.13",
      gene_type : "protein_coding",
      gene_name : "LTO1",
      gene_level : 1,
      hgnc_id : "HGNC:17589",
      havana_gene : "OTTHUMG00000167885.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69698238,
      stop : 69704022,
      direction : "-",
      ID : "ENSG00000162344.4",
      gene_id : "ENSG00000162344.4",
      gene_type : "protein_coding",
      gene_name : "FGF19",
      gene_level : 2,
      hgnc_id : "HGNC:3675",
      havana_gene : "OTTHUMG00000167886.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69771022,
      stop : 69775341,
      direction : "-",
      ID : "ENSG00000075388.4",
      gene_id : "ENSG00000075388.4",
      gene_type : "protein_coding",
      gene_name : "FGF4",
      gene_level : 2,
      hgnc_id : "HGNC:3682",
      havana_gene : "OTTHUMG00000167887.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 69809968,
      stop : 69819416,
      direction : "-",
      ID : "ENSG00000186895.4",
      gene_id : "ENSG00000186895.4",
      gene_type : "protein_coding",
      gene_name : "FGF3",
      gene_level : 2,
      hgnc_id : "HGNC:3681",
      havana_gene : "OTTHUMG00000167888.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 70078302,
      stop : 70189528,
      direction : "+",
      ID : "ENSG00000131620.17",
      gene_id : "ENSG00000131620.17",
      gene_type : "protein_coding",
      gene_name : "ANO1",
      gene_level : 1,
      hgnc_id : "HGNC:21625",
      havana_gene : "OTTHUMG00000167204.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 70203296,
      stop : 70207390,
      direction : "+",
      ID : "ENSG00000168040.5",
      gene_id : "ENSG00000168040.5",
      gene_type : "protein_coding",
      gene_name : "FADD",
      gene_level : 2,
      hgnc_id : "HGNC:3573",
      havana_gene : "OTTHUMG00000167264.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 70270690,
      stop : 70385312,
      direction : "+",
      ID : "ENSG00000131626.19",
      gene_id : "ENSG00000131626.19",
      gene_type : "protein_coding",
      gene_name : "PPFIA1",
      gene_level : 1,
      hgnc_id : "HGNC:9245",
      havana_gene : "OTTHUMG00000167266.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 70398404,
      stop : 70436584,
      direction : "+",
      ID : "ENSG00000085733.16",
      gene_id : "ENSG00000085733.16",
      gene_type : "protein_coding",
      gene_name : "CTTN",
      gene_level : 1,
      hgnc_id : "HGNC:3338",
      havana_gene : "OTTHUMG00000134307.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 70467854,
      stop : 71252577,
      direction : "-",
      ID : "ENSG00000162105.20",
      gene_id : "ENSG00000162105.20",
      gene_type : "protein_coding",
      gene_name : "SHANK2",
      gene_level : 1,
      hgnc_id : "HGNC:14295",
      havana_gene : "OTTHUMG00000154615.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71428193,
      stop : 71452868,
      direction : "-",
      ID : "ENSG00000172893.16",
      gene_id : "ENSG00000172893.16",
      gene_type : "protein_coding",
      gene_name : "DHCR7",
      gene_level : 1,
      hgnc_id : "HGNC:2860",
      havana_gene : "OTTHUMG00000167346.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71453109,
      stop : 71524107,
      direction : "+",
      ID : "ENSG00000172890.13",
      gene_id : "ENSG00000172890.13",
      gene_type : "protein_coding",
      gene_name : "NADSYN1",
      gene_level : 2,
      hgnc_id : "HGNC:29832",
      havana_gene : "OTTHUMG00000167375.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71527267,
      stop : 71528669,
      direction : "+",
      ID : "ENSG00000244411.4",
      gene_id : "ENSG00000244411.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-7",
      gene_level : 2,
      hgnc_id : "HGNC:23602",
      havana_gene : "OTTHUMG00000057570.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71538025,
      stop : 71539209,
      direction : "+",
      ID : "ENSG00000241233.4",
      gene_id : "ENSG00000241233.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-8",
      gene_level : 2,
      hgnc_id : "HGNC:23603",
      havana_gene : "OTTHUMG00000057571.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71548420,
      stop : 71549608,
      direction : "+",
      ID : "ENSG00000254997.4",
      gene_id : "ENSG00000254997.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-9",
      gene_level : 2,
      hgnc_id : "HGNC:23604",
      havana_gene : "OTTHUMG00000167263.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71565563,
      stop : 71566735,
      direction : "+",
      ID : "ENSG00000204572.10",
      gene_id : "ENSG00000204572.10",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-10",
      gene_level : 2,
      hgnc_id : "HGNC:23605",
      havana_gene : "OTTHUMG00000057585.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71579714,
      stop : 71603353,
      direction : "-",
      ID : "ENSG00000204571.6",
      gene_id : "ENSG00000204571.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP5-11",
      gene_level : 2,
      hgnc_id : "HGNC:23606",
      havana_gene : "OTTHUMG00000057586.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71814045,
      stop : 71821548,
      direction : "-",
      ID : "ENSG00000214534.5",
      gene_id : "ENSG00000214534.5",
      gene_type : "protein_coding",
      gene_name : "ZNF705E",
      gene_level : 2,
      hgnc_id : "HGNC:33203",
      havana_gene : "OTTHUMG00000167482.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71833200,
      stop : 71837710,
      direction : "+",
      ID : "ENSG00000184276.3",
      gene_id : "ENSG00000184276.3",
      gene_type : "protein_coding",
      gene_name : "DEFB108B",
      gene_level : 2,
      hgnc_id : "HGNC:29966",
      havana_gene : "OTTHUMG00000167533.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71865504,
      stop : 71928665,
      direction : "-",
      ID : "ENSG00000254469.8",
      gene_id : "ENSG00000254469.8",
      gene_type : "protein_coding",
      gene_name : "AP002495.1",
      gene_level : 1,
      hgnc_id : "havana_gene=OTTHUMG00000167535.5",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71878453,
      stop : 71884561,
      direction : "+",
      ID : "ENSG00000225805.4",
      gene_id : "ENSG00000225805.4",
      gene_type : "protein_coding",
      gene_name : "DEFB131B",
      gene_level : 2,
      hgnc_id : "HGNC:38058",
      havana_gene : "OTTHUMG00000167536.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71929018,
      stop : 71997597,
      direction : "+",
      ID : "ENSG00000137522.18",
      gene_id : "ENSG00000137522.18",
      gene_type : "protein_coding",
      gene_name : "RNF121",
      gene_level : 1,
      hgnc_id : "HGNC:21070",
      havana_gene : "OTTHUMG00000157023.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 71998613,
      stop : 72005715,
      direction : "+",
      ID : "ENSG00000137496.18",
      gene_id : "ENSG00000137496.18",
      gene_type : "protein_coding",
      gene_name : "IL18BP",
      gene_level : 2,
      hgnc_id : "HGNC:5987",
      havana_gene : "OTTHUMG00000133713.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72002864,
      stop : 72080693,
      direction : "-",
      ID : "ENSG00000137497.18",
      gene_id : "ENSG00000137497.18",
      gene_type : "protein_coding",
      gene_name : "NUMA1",
      gene_level : 2,
      hgnc_id : "HGNC:8059",
      havana_gene : "OTTHUMG00000167697.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72080331,
      stop : 72110782,
      direction : "+",
      ID : "ENSG00000284922.2",
      gene_id : "ENSG00000284922.2",
      gene_type : "protein_coding",
      gene_name : "AP000812.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192561.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72080337,
      stop : 72096895,
      direction : "+",
      ID : "ENSG00000184154.15",
      gene_id : "ENSG00000184154.15",
      gene_type : "protein_coding",
      gene_name : "LRTOMT",
      gene_level : 1,
      hgnc_id : "HGNC:25033",
      havana_gene : "OTTHUMG00000154887.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72085895,
      stop : 72103297,
      direction : "-",
      ID : "ENSG00000149357.10",
      gene_id : "ENSG00000149357.10",
      gene_type : "protein_coding",
      gene_name : "LAMTOR1",
      gene_level : 1,
      hgnc_id : "HGNC:26068",
      havana_gene : "OTTHUMG00000167869.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72105924,
      stop : 72109329,
      direction : "+",
      ID : "ENSG00000284844.1",
      gene_id : "ENSG00000284844.1",
      gene_type : "protein_coding",
      gene_name : "AP000812.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192562.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72106378,
      stop : 72112780,
      direction : "-",
      ID : "ENSG00000110200.8",
      gene_id : "ENSG00000110200.8",
      gene_type : "protein_coding",
      gene_name : "ANAPC15",
      gene_level : 2,
      hgnc_id : "HGNC:24531",
      havana_gene : "OTTHUMG00000167865.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72114869,
      stop : 72139892,
      direction : "+",
      ID : "ENSG00000110203.9",
      gene_id : "ENSG00000110203.9",
      gene_type : "protein_coding",
      gene_name : "FOLR3",
      gene_level : 2,
      hgnc_id : "HGNC:3795",
      havana_gene : "OTTHUMG00000167870.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72189558,
      stop : 72196323,
      direction : "+",
      ID : "ENSG00000110195.14",
      gene_id : "ENSG00000110195.14",
      gene_type : "protein_coding",
      gene_name : "FOLR1",
      gene_level : 2,
      hgnc_id : "HGNC:3791",
      havana_gene : "OTTHUMG00000167876.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72216601,
      stop : 72221950,
      direction : "+",
      ID : "ENSG00000165457.14",
      gene_id : "ENSG00000165457.14",
      gene_type : "protein_coding",
      gene_name : "FOLR2",
      gene_level : 1,
      hgnc_id : "HGNC:3793",
      havana_gene : "OTTHUMG00000150394.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72223701,
      stop : 72239147,
      direction : "+",
      ID : "ENSG00000165458.14",
      gene_id : "ENSG00000165458.14",
      gene_type : "protein_coding",
      gene_name : "INPPL1",
      gene_level : 1,
      hgnc_id : "HGNC:6080",
      havana_gene : "OTTHUMG00000167879.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72239077,
      stop : 72245664,
      direction : "-",
      ID : "ENSG00000165462.5",
      gene_id : "ENSG00000165462.5",
      gene_type : "protein_coding",
      gene_name : "PHOX2A",
      gene_level : 2,
      hgnc_id : "HGNC:691",
      havana_gene : "OTTHUMG00000167899.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72285495,
      stop : 72434680,
      direction : "-",
      ID : "ENSG00000162129.14",
      gene_id : "ENSG00000162129.14",
      gene_type : "protein_coding",
      gene_name : "CLPB",
      gene_level : 2,
      hgnc_id : "HGNC:30664",
      havana_gene : "OTTHUMG00000167902.11",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72576141,
      stop : 72674591,
      direction : "-",
      ID : "ENSG00000186642.16",
      gene_id : "ENSG00000186642.16",
      gene_type : "protein_coding",
      gene_name : "PDE2A",
      gene_level : 2,
      hgnc_id : "HGNC:8777",
      havana_gene : "OTTHUMG00000102045.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72685069,
      stop : 72793599,
      direction : "-",
      ID : "ENSG00000186635.15",
      gene_id : "ENSG00000186635.15",
      gene_type : "protein_coding",
      gene_name : "ARAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16925",
      havana_gene : "OTTHUMG00000157102.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72754729,
      stop : 72794047,
      direction : "-",
      ID : "ENSG00000214530.10",
      gene_id : "ENSG00000214530.10",
      gene_type : "protein_coding",
      gene_name : "STARD10",
      gene_level : 1,
      hgnc_id : "HGNC:10666",
      havana_gene : "OTTHUMG00000192625.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72814406,
      stop : 72843674,
      direction : "+",
      ID : "ENSG00000168010.11",
      gene_id : "ENSG00000168010.11",
      gene_type : "protein_coding",
      gene_name : "ATG16L2",
      gene_level : 1,
      hgnc_id : "HGNC:25464",
      havana_gene : "OTTHUMG00000167961.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 72836745,
      stop : 73142318,
      direction : "-",
      ID : "ENSG00000137478.15",
      gene_id : "ENSG00000137478.15",
      gene_type : "protein_coding",
      gene_name : "FCHSD2",
      gene_level : 1,
      hgnc_id : "HGNC:29114",
      havana_gene : "OTTHUMG00000153082.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73218281,
      stop : 73242427,
      direction : "+",
      ID : "ENSG00000175591.12",
      gene_id : "ENSG00000175591.12",
      gene_type : "protein_coding",
      gene_name : "P2RY2",
      gene_level : 2,
      hgnc_id : "HGNC:8541",
      havana_gene : "OTTHUMG00000167966.1",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73264498,
      stop : 73305103,
      direction : "+",
      ID : "ENSG00000171631.16",
      gene_id : "ENSG00000171631.16",
      gene_type : "protein_coding",
      gene_name : "P2RY6",
      gene_level : 2,
      hgnc_id : "HGNC:8543",
      havana_gene : "OTTHUMG00000167969.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73308276,
      stop : 73369388,
      direction : "+",
      ID : "ENSG00000110237.5",
      gene_id : "ENSG00000110237.5",
      gene_type : "protein_coding",
      gene_name : "ARHGEF17",
      gene_level : 2,
      hgnc_id : "HGNC:21726",
      havana_gene : "OTTHUMG00000167971.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73376399,
      stop : 73397474,
      direction : "+",
      ID : "ENSG00000054967.13",
      gene_id : "ENSG00000054967.13",
      gene_type : "protein_coding",
      gene_name : "RELT",
      gene_level : 2,
      hgnc_id : "HGNC:13764",
      havana_gene : "OTTHUMG00000167973.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73400487,
      stop : 73598189,
      direction : "-",
      ID : "ENSG00000054965.11",
      gene_id : "ENSG00000054965.11",
      gene_type : "protein_coding",
      gene_name : "FAM168A",
      gene_level : 2,
      hgnc_id : "HGNC:28999",
      havana_gene : "OTTHUMG00000167995.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73646178,
      stop : 73662819,
      direction : "+",
      ID : "ENSG00000021300.14",
      gene_id : "ENSG00000021300.14",
      gene_type : "protein_coding",
      gene_name : "PLEKHB1",
      gene_level : 2,
      hgnc_id : "HGNC:19079",
      havana_gene : "OTTHUMG00000168030.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73675638,
      stop : 73761137,
      direction : "-",
      ID : "ENSG00000175582.20",
      gene_id : "ENSG00000175582.20",
      gene_type : "protein_coding",
      gene_name : "RAB6A",
      gene_level : 2,
      hgnc_id : "HGNC:9786",
      havana_gene : "OTTHUMG00000134308.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73787872,
      stop : 73865133,
      direction : "+",
      ID : "ENSG00000175581.14",
      gene_id : "ENSG00000175581.14",
      gene_type : "protein_coding",
      gene_name : "MRPL48",
      gene_level : 1,
      hgnc_id : "HGNC:16653",
      havana_gene : "OTTHUMG00000168048.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73872667,
      stop : 73876901,
      direction : "-",
      ID : "ENSG00000181924.7",
      gene_id : "ENSG00000181924.7",
      gene_type : "protein_coding",
      gene_name : "COA4",
      gene_level : 1,
      hgnc_id : "HGNC:24604",
      havana_gene : "OTTHUMG00000168061.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73876699,
      stop : 73931114,
      direction : "+",
      ID : "ENSG00000175575.13",
      gene_id : "ENSG00000175575.13",
      gene_type : "protein_coding",
      gene_name : "PAAF1",
      gene_level : 1,
      hgnc_id : "HGNC:25687",
      havana_gene : "OTTHUMG00000168062.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73951026,
      stop : 73970366,
      direction : "+",
      ID : "ENSG00000187726.9",
      gene_id : "ENSG00000187726.9",
      gene_type : "protein_coding",
      gene_name : "DNAJB13",
      gene_level : 2,
      hgnc_id : "HGNC:30718",
      havana_gene : "OTTHUMG00000168093.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 73974672,
      stop : 73982843,
      direction : "-",
      ID : "ENSG00000175567.11",
      gene_id : "ENSG00000175567.11",
      gene_type : "protein_coding",
      gene_name : "UCP2",
      gene_level : 1,
      hgnc_id : "HGNC:12518",
      havana_gene : "OTTHUMG00000168095.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74000277,
      stop : 74009085,
      direction : "-",
      ID : "ENSG00000175564.13",
      gene_id : "ENSG00000175564.13",
      gene_type : "protein_coding",
      gene_name : "UCP3",
      gene_level : 2,
      hgnc_id : "HGNC:12519",
      havana_gene : "OTTHUMG00000168109.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74012718,
      stop : 74171210,
      direction : "-",
      ID : "ENSG00000168014.18",
      gene_id : "ENSG00000168014.18",
      gene_type : "protein_coding",
      gene_name : "C2CD3",
      gene_level : 1,
      hgnc_id : "HGNC:24564",
      havana_gene : "OTTHUMG00000168110.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74171267,
      stop : 74254703,
      direction : "+",
      ID : "ENSG00000214517.10",
      gene_id : "ENSG00000214517.10",
      gene_type : "protein_coding",
      gene_name : "PPME1",
      gene_level : 1,
      hgnc_id : "HGNC:30178",
      havana_gene : "OTTHUMG00000168115.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74235801,
      stop : 74311640,
      direction : "-",
      ID : "ENSG00000149380.12",
      gene_id : "ENSG00000149380.12",
      gene_type : "protein_coding",
      gene_name : "P4HA3",
      gene_level : 1,
      hgnc_id : "HGNC:30135",
      havana_gene : "OTTHUMG00000165254.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74330316,
      stop : 74398433,
      direction : "-",
      ID : "ENSG00000165434.8",
      gene_id : "ENSG00000165434.8",
      gene_type : "protein_coding",
      gene_name : "PGM2L1",
      gene_level : 2,
      hgnc_id : "HGNC:20898",
      havana_gene : "OTTHUMG00000168132.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74454841,
      stop : 74467729,
      direction : "-",
      ID : "ENSG00000175538.11",
      gene_id : "ENSG00000175538.11",
      gene_type : "protein_coding",
      gene_name : "KCNE3",
      gene_level : 2,
      hgnc_id : "HGNC:6243",
      havana_gene : "OTTHUMG00000165641.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74490519,
      stop : 74493724,
      direction : "-",
      ID : "ENSG00000175536.7",
      gene_id : "ENSG00000175536.7",
      gene_type : "protein_coding",
      gene_name : "LIPT2",
      gene_level : 1,
      hgnc_id : "HGNC:37216",
      havana_gene : "OTTHUMG00000165646.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74493851,
      stop : 74669117,
      direction : "+",
      ID : "ENSG00000077514.9",
      gene_id : "ENSG00000077514.9",
      gene_type : "protein_coding",
      gene_name : "POLD3",
      gene_level : 1,
      hgnc_id : "HGNC:20932",
      havana_gene : "OTTHUMG00000165621.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74696429,
      stop : 74731426,
      direction : "-",
      ID : "ENSG00000054938.16",
      gene_id : "ENSG00000054938.16",
      gene_type : "protein_coding",
      gene_name : "CHRDL2",
      gene_level : 1,
      hgnc_id : "HGNC:24168",
      havana_gene : "OTTHUMG00000165623.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74748849,
      stop : 74842413,
      direction : "+",
      ID : "ENSG00000166439.6",
      gene_id : "ENSG00000166439.6",
      gene_type : "protein_coding",
      gene_name : "RNF169",
      gene_level : 2,
      hgnc_id : "HGNC:26961",
      havana_gene : "OTTHUMG00000165516.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74807739,
      stop : 74949200,
      direction : "-",
      ID : "ENSG00000166435.15",
      gene_id : "ENSG00000166435.15",
      gene_type : "protein_coding",
      gene_name : "XRRA1",
      gene_level : 1,
      hgnc_id : "HGNC:18868",
      havana_gene : "OTTHUMG00000165515.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74949247,
      stop : 74979033,
      direction : "+",
      ID : "ENSG00000118363.12",
      gene_id : "ENSG00000118363.12",
      gene_type : "protein_coding",
      gene_name : "SPCS2",
      gene_level : 2,
      hgnc_id : "HGNC:28962",
      havana_gene : "OTTHUMG00000165517.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 74988279,
      stop : 75018893,
      direction : "+",
      ID : "ENSG00000162139.10",
      gene_id : "ENSG00000162139.10",
      gene_type : "protein_coding",
      gene_name : "NEU3",
      gene_level : 1,
      hgnc_id : "HGNC:7760",
      havana_gene : "OTTHUMG00000165518.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75081753,
      stop : 75096876,
      direction : "-",
      ID : "ENSG00000171561.4",
      gene_id : "ENSG00000171561.4",
      gene_type : "protein_coding",
      gene_name : "OR2AT4",
      gene_level : 2,
      hgnc_id : "HGNC:19620",
      havana_gene : "OTTHUMG00000165370.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75100563,
      stop : 75206549,
      direction : "+",
      ID : "ENSG00000137491.15",
      gene_id : "ENSG00000137491.15",
      gene_type : "protein_coding",
      gene_name : "SLCO2B1",
      gene_level : 1,
      hgnc_id : "HGNC:10962",
      havana_gene : "OTTHUMG00000165420.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75240774,
      stop : 75243704,
      direction : "+",
      ID : "ENSG00000261594.4",
      gene_id : "ENSG00000261594.4",
      gene_type : "protein_coding",
      gene_name : "TPBGL",
      gene_level : 2,
      hgnc_id : "HGNC:44159",
      havana_gene : "OTTHUMG00000165441.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75260122,
      stop : 75351705,
      direction : "-",
      ID : "ENSG00000137486.17",
      gene_id : "ENSG00000137486.17",
      gene_type : "protein_coding",
      gene_name : "ARRB1",
      gene_level : 1,
      hgnc_id : "HGNC:711",
      havana_gene : "OTTHUMG00000165444.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75399515,
      stop : 75422280,
      direction : "+",
      ID : "ENSG00000149273.15",
      gene_id : "ENSG00000149273.15",
      gene_type : "protein_coding",
      gene_name : "RPS3",
      gene_level : 1,
      hgnc_id : "HGNC:10420",
      havana_gene : "OTTHUMG00000165448.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75422394,
      stop : 75433203,
      direction : "-",
      ID : "ENSG00000149243.16",
      gene_id : "ENSG00000149243.16",
      gene_type : "protein_coding",
      gene_name : "KLHL35",
      gene_level : 2,
      hgnc_id : "HGNC:26597",
      havana_gene : "OTTHUMG00000133573.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75434640,
      stop : 75525941,
      direction : "-",
      ID : "ENSG00000158555.15",
      gene_id : "ENSG00000158555.15",
      gene_type : "protein_coding",
      gene_name : "GDPD5",
      gene_level : 1,
      hgnc_id : "HGNC:28804",
      havana_gene : "OTTHUMG00000165484.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75562056,
      stop : 75572783,
      direction : "+",
      ID : "ENSG00000149257.16",
      gene_id : "ENSG00000149257.16",
      gene_type : "protein_coding",
      gene_name : "SERPINH1",
      gene_level : 2,
      hgnc_id : "HGNC:1546",
      havana_gene : "OTTHUMG00000165362.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75586918,
      stop : 75669038,
      direction : "-",
      ID : "ENSG00000171533.12",
      gene_id : "ENSG00000171533.12",
      gene_type : "protein_coding",
      gene_name : "MAP6",
      gene_level : 1,
      hgnc_id : "HGNC:6868",
      havana_gene : "OTTHUMG00000165343.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75717838,
      stop : 75732958,
      direction : "+",
      ID : "ENSG00000166391.15",
      gene_id : "ENSG00000166391.15",
      gene_type : "protein_coding",
      gene_name : "MOGAT2",
      gene_level : 2,
      hgnc_id : "HGNC:23248",
      havana_gene : "OTTHUMG00000165341.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75759512,
      stop : 75801535,
      direction : "+",
      ID : "ENSG00000062282.15",
      gene_id : "ENSG00000062282.15",
      gene_type : "protein_coding",
      gene_name : "DGAT2",
      gene_level : 1,
      hgnc_id : "HGNC:16940",
      havana_gene : "OTTHUMG00000165338.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 75815210,
      stop : 76144232,
      direction : "+",
      ID : "ENSG00000198382.9",
      gene_id : "ENSG00000198382.9",
      gene_type : "protein_coding",
      gene_name : "UVRAG",
      gene_level : 1,
      hgnc_id : "HGNC:12640",
      havana_gene : "OTTHUMG00000165319.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76186325,
      stop : 76210736,
      direction : "-",
      ID : "ENSG00000085741.13",
      gene_id : "ENSG00000085741.13",
      gene_type : "protein_coding",
      gene_name : "WNT11",
      gene_level : 2,
      hgnc_id : "HGNC:12776",
      havana_gene : "OTTHUMG00000165264.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76349956,
      stop : 76381132,
      direction : "-",
      ID : "ENSG00000137492.8",
      gene_id : "ENSG00000137492.8",
      gene_type : "protein_coding",
      gene_name : "THAP12",
      gene_level : 2,
      hgnc_id : "HGNC:9440",
      havana_gene : "OTTHUMG00000165280.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76381303,
      stop : 76414619,
      direction : "+",
      ID : "ENSG00000179240.13",
      gene_id : "ENSG00000179240.13",
      gene_type : "protein_coding",
      gene_name : "GVQW3",
      gene_level : 1,
      hgnc_id : "HGNC:51239",
      havana_gene : "OTTHUMG00000165281.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76444923,
      stop : 76553025,
      direction : "+",
      ID : "ENSG00000158636.16",
      gene_id : "ENSG00000158636.16",
      gene_type : "protein_coding",
      gene_name : "EMSY",
      gene_level : 1,
      hgnc_id : "HGNC:18071",
      havana_gene : "OTTHUMG00000165282.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76657524,
      stop : 76670747,
      direction : "-",
      ID : "ENSG00000137507.11",
      gene_id : "ENSG00000137507.11",
      gene_type : "protein_coding",
      gene_name : "LRRC32",
      gene_level : 1,
      hgnc_id : "HGNC:4161",
      havana_gene : "OTTHUMG00000133687.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76782251,
      stop : 76798153,
      direction : "+",
      ID : "ENSG00000182704.8",
      gene_id : "ENSG00000182704.8",
      gene_type : "protein_coding",
      gene_name : "TSKU",
      gene_level : 2,
      hgnc_id : "HGNC:28850",
      havana_gene : "OTTHUMG00000165238.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 76860859,
      stop : 77026797,
      direction : "+",
      ID : "ENSG00000078124.13",
      gene_id : "ENSG00000078124.13",
      gene_type : "protein_coding",
      gene_name : "ACER3",
      gene_level : 2,
      hgnc_id : "HGNC:16066",
      havana_gene : "OTTHUMG00000165225.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77034398,
      stop : 77041973,
      direction : "+",
      ID : "ENSG00000198488.10",
      gene_id : "ENSG00000198488.10",
      gene_type : "protein_coding",
      gene_name : "B3GNT6",
      gene_level : 2,
      hgnc_id : "HGNC:24141",
      havana_gene : "OTTHUMG00000181633.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77066961,
      stop : 77126155,
      direction : "+",
      ID : "ENSG00000149260.18",
      gene_id : "ENSG00000149260.18",
      gene_type : "protein_coding",
      gene_name : "CAPN5",
      gene_level : 1,
      hgnc_id : "HGNC:1482",
      havana_gene : "OTTHUMG00000165192.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77102840,
      stop : 77103331,
      direction : "+",
      ID : "ENSG00000254550.1",
      gene_id : "ENSG00000254550.1",
      gene_type : "protein_coding",
      gene_name : "OMP",
      gene_level : 2,
      hgnc_id : "HGNC:8136",
      havana_gene : "OTTHUMG00000165193.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77128246,
      stop : 77215241,
      direction : "+",
      ID : "ENSG00000137474.22",
      gene_id : "ENSG00000137474.22",
      gene_type : "protein_coding",
      gene_name : "MYO7A",
      gene_level : 1,
      hgnc_id : "HGNC:7606",
      havana_gene : "OTTHUMG00000152822.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77216558,
      stop : 77301687,
      direction : "-",
      ID : "ENSG00000178795.9",
      gene_id : "ENSG00000178795.9",
      gene_type : "protein_coding",
      gene_name : "GDPD4",
      gene_level : 2,
      hgnc_id : "HGNC:24849",
      havana_gene : "OTTHUMG00000165136.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77322017,
      stop : 77474635,
      direction : "-",
      ID : "ENSG00000149269.10",
      gene_id : "ENSG00000149269.10",
      gene_type : "protein_coding",
      gene_name : "PAK1",
      gene_level : 1,
      hgnc_id : "HGNC:8590",
      havana_gene : "OTTHUMG00000165138.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77514936,
      stop : 77637794,
      direction : "-",
      ID : "ENSG00000074201.9",
      gene_id : "ENSG00000074201.9",
      gene_type : "protein_coding",
      gene_name : "CLNS1A",
      gene_level : 2,
      hgnc_id : "HGNC:2080",
      havana_gene : "OTTHUMG00000165143.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77589391,
      stop : 77610356,
      direction : "+",
      ID : "ENSG00000178301.4",
      gene_id : "ENSG00000178301.4",
      gene_type : "protein_coding",
      gene_name : "AQP11",
      gene_level : 2,
      hgnc_id : "HGNC:19940",
      havana_gene : "OTTHUMG00000165194.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77659996,
      stop : 77821017,
      direction : "-",
      ID : "ENSG00000048649.13",
      gene_id : "ENSG00000048649.13",
      gene_type : "protein_coding",
      gene_name : "RSF1",
      gene_level : 1,
      hgnc_id : "HGNC:18118",
      havana_gene : "OTTHUMG00000150433.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77821109,
      stop : 77918432,
      direction : "+",
      ID : "ENSG00000087884.14",
      gene_id : "ENSG00000087884.14",
      gene_type : "protein_coding",
      gene_name : "AAMDC",
      gene_level : 1,
      hgnc_id : "HGNC:30205",
      havana_gene : "OTTHUMG00000166651.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 77878720,
      stop : 77994671,
      direction : "-",
      ID : "ENSG00000149262.17",
      gene_id : "ENSG00000149262.17",
      gene_type : "protein_coding",
      gene_name : "INTS4",
      gene_level : 2,
      hgnc_id : "HGNC:25048",
      havana_gene : "OTTHUMG00000166629.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78015715,
      stop : 78046191,
      direction : "-",
      ID : "ENSG00000151364.17",
      gene_id : "ENSG00000151364.17",
      gene_type : "protein_coding",
      gene_name : "KCTD14",
      gene_level : 1,
      hgnc_id : "HGNC:23295",
      havana_gene : "OTTHUMG00000150224.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78016971,
      stop : 78079865,
      direction : "-",
      ID : "ENSG00000259112.2",
      gene_id : "ENSG00000259112.2",
      gene_type : "protein_coding",
      gene_name : "NDUFC2-KCTD14",
      gene_level : 2,
      hgnc_id : "HGNC:42956",
      havana_gene : "OTTHUMG00000171802.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78063861,
      stop : 78068351,
      direction : "+",
      ID : "ENSG00000151365.2",
      gene_id : "ENSG00000151365.2",
      gene_type : "protein_coding",
      gene_name : "THRSP",
      gene_level : 2,
      hgnc_id : "HGNC:11800",
      havana_gene : "OTTHUMG00000166632.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78068297,
      stop : 78079862,
      direction : "-",
      ID : "ENSG00000151366.13",
      gene_id : "ENSG00000151366.13",
      gene_type : "protein_coding",
      gene_name : "NDUFC2",
      gene_level : 2,
      hgnc_id : "HGNC:7706",
      havana_gene : "OTTHUMG00000166614.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78095244,
      stop : 78139660,
      direction : "-",
      ID : "ENSG00000159063.14",
      gene_id : "ENSG00000159063.14",
      gene_type : "protein_coding",
      gene_name : "ALG8",
      gene_level : 1,
      hgnc_id : "HGNC:23161",
      havana_gene : "OTTHUMG00000166594.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78171249,
      stop : 78188626,
      direction : "-",
      ID : "ENSG00000188997.8",
      gene_id : "ENSG00000188997.8",
      gene_type : "protein_coding",
      gene_name : "KCTD21",
      gene_level : 2,
      hgnc_id : "HGNC:27452",
      havana_gene : "OTTHUMG00000166497.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78188812,
      stop : 78215232,
      direction : "+",
      ID : "ENSG00000118369.13",
      gene_id : "ENSG00000118369.13",
      gene_type : "protein_coding",
      gene_name : "USP35",
      gene_level : 2,
      hgnc_id : "HGNC:20061",
      havana_gene : "OTTHUMG00000166492.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78215293,
      stop : 78418348,
      direction : "-",
      ID : "ENSG00000033327.13",
      gene_id : "ENSG00000033327.13",
      gene_type : "protein_coding",
      gene_name : "GAB2",
      gene_level : 1,
      hgnc_id : "HGNC:14458",
      havana_gene : "OTTHUMG00000166673.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78435968,
      stop : 78574874,
      direction : "-",
      ID : "ENSG00000137513.10",
      gene_id : "ENSG00000137513.10",
      gene_type : "protein_coding",
      gene_name : "NARS2",
      gene_level : 1,
      hgnc_id : "HGNC:26274",
      havana_gene : "OTTHUMG00000166702.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 78652829,
      stop : 79441030,
      direction : "-",
      ID : "ENSG00000149256.16",
      gene_id : "ENSG00000149256.16",
      gene_type : "protein_coding",
      gene_name : "TENM4",
      gene_level : 1,
      hgnc_id : "HGNC:29945",
      havana_gene : "OTTHUMG00000166770.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 82729940,
      stop : 82733864,
      direction : "-",
      ID : "ENSG00000182103.5",
      gene_id : "ENSG00000182103.5",
      gene_type : "protein_coding",
      gene_name : "FAM181B",
      gene_level : 2,
      hgnc_id : "HGNC:28512",
      havana_gene : "OTTHUMG00000166869.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 82822936,
      stop : 82970584,
      direction : "-",
      ID : "ENSG00000137509.12",
      gene_id : "ENSG00000137509.12",
      gene_type : "protein_coding",
      gene_name : "PRCP",
      gene_level : 1,
      hgnc_id : "HGNC:9344",
      havana_gene : "OTTHUMG00000166899.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 82899975,
      stop : 82958277,
      direction : "+",
      ID : "ENSG00000165490.13",
      gene_id : "ENSG00000165490.13",
      gene_type : "protein_coding",
      gene_name : "DDIAS",
      gene_level : 2,
      hgnc_id : "HGNC:26351",
      havana_gene : "OTTHUMG00000166929.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 82973133,
      stop : 83071923,
      direction : "-",
      ID : "ENSG00000137502.10",
      gene_id : "ENSG00000137502.10",
      gene_type : "protein_coding",
      gene_name : "RAB30",
      gene_level : 1,
      hgnc_id : "HGNC:9770",
      havana_gene : "OTTHUMG00000166973.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 83156988,
      stop : 83187451,
      direction : "+",
      ID : "ENSG00000165494.11",
      gene_id : "ENSG00000165494.11",
      gene_type : "protein_coding",
      gene_name : "PCF11",
      gene_level : 1,
      hgnc_id : "HGNC:30097",
      havana_gene : "OTTHUMG00000167031.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 83193712,
      stop : 83260694,
      direction : "+",
      ID : "ENSG00000137494.14",
      gene_id : "ENSG00000137494.14",
      gene_type : "protein_coding",
      gene_name : "ANKRD42",
      gene_level : 1,
      hgnc_id : "HGNC:26752",
      havana_gene : "OTTHUMG00000167075.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 83259097,
      stop : 83286407,
      direction : "-",
      ID : "ENSG00000137500.9",
      gene_id : "ENSG00000137500.9",
      gene_type : "protein_coding",
      gene_name : "CCDC90B",
      gene_level : 2,
      hgnc_id : "HGNC:28108",
      havana_gene : "OTTHUMG00000167078.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 83455012,
      stop : 85627922,
      direction : "-",
      ID : "ENSG00000150672.18",
      gene_id : "ENSG00000150672.18",
      gene_type : "protein_coding",
      gene_name : "DLG2",
      gene_level : 1,
      hgnc_id : "HGNC:2901",
      havana_gene : "OTTHUMG00000134309.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85628573,
      stop : 85636539,
      direction : "+",
      ID : "ENSG00000171204.13",
      gene_id : "ENSG00000171204.13",
      gene_type : "protein_coding",
      gene_name : "TMEM126B",
      gene_level : 2,
      hgnc_id : "HGNC:30883",
      havana_gene : "OTTHUMG00000166974.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85647967,
      stop : 85656547,
      direction : "+",
      ID : "ENSG00000171202.7",
      gene_id : "ENSG00000171202.7",
      gene_type : "protein_coding",
      gene_name : "TMEM126A",
      gene_level : 2,
      hgnc_id : "HGNC:25382",
      havana_gene : "OTTHUMG00000166975.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85657990,
      stop : 85682908,
      direction : "-",
      ID : "ENSG00000137504.14",
      gene_id : "ENSG00000137504.14",
      gene_type : "protein_coding",
      gene_name : "CREBZF",
      gene_level : 2,
      hgnc_id : "HGNC:24905",
      havana_gene : "OTTHUMG00000133648.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85683848,
      stop : 85686195,
      direction : "-",
      ID : "ENSG00000179071.5",
      gene_id : "ENSG00000179071.5",
      gene_type : "protein_coding",
      gene_name : "CCDC89",
      gene_level : 2,
      hgnc_id : "HGNC:26762",
      havana_gene : "OTTHUMG00000166976.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85694224,
      stop : 85811159,
      direction : "-",
      ID : "ENSG00000137501.17",
      gene_id : "ENSG00000137501.17",
      gene_type : "protein_coding",
      gene_name : "SYTL2",
      gene_level : 1,
      hgnc_id : "HGNC:15585",
      havana_gene : "OTTHUMG00000166977.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85855101,
      stop : 85920021,
      direction : "+",
      ID : "ENSG00000150676.13",
      gene_id : "ENSG00000150676.13",
      gene_type : "protein_coding",
      gene_name : "CCDC83",
      gene_level : 2,
      hgnc_id : "HGNC:28535",
      havana_gene : "OTTHUMG00000166978.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 85957175,
      stop : 86069882,
      direction : "-",
      ID : "ENSG00000073921.18",
      gene_id : "ENSG00000073921.18",
      gene_type : "protein_coding",
      gene_name : "PICALM",
      gene_level : 1,
      hgnc_id : "HGNC:15514",
      havana_gene : "OTTHUMG00000166981.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 86244753,
      stop : 86278813,
      direction : "+",
      ID : "ENSG00000074266.22",
      gene_id : "ENSG00000074266.22",
      gene_type : "protein_coding",
      gene_name : "EED",
      gene_level : 1,
      hgnc_id : "HGNC:3188",
      havana_gene : "OTTHUMG00000167209.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 86302211,
      stop : 86345943,
      direction : "+",
      ID : "ENSG00000149196.16",
      gene_id : "ENSG00000149196.16",
      gene_type : "protein_coding",
      gene_name : "HIKESHI",
      gene_level : 2,
      hgnc_id : "HGNC:26938",
      havana_gene : "OTTHUMG00000167212.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 86374736,
      stop : 86423109,
      direction : "+",
      ID : "ENSG00000149201.10",
      gene_id : "ENSG00000149201.10",
      gene_type : "protein_coding",
      gene_name : "CCDC81",
      gene_level : 2,
      hgnc_id : "HGNC:26281",
      havana_gene : "OTTHUMG00000167213.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 86441108,
      stop : 86672636,
      direction : "-",
      ID : "ENSG00000151376.18",
      gene_id : "ENSG00000151376.18",
      gene_type : "protein_coding",
      gene_name : "ME3",
      gene_level : 2,
      hgnc_id : "HGNC:6985",
      havana_gene : "OTTHUMG00000167217.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 86791059,
      stop : 86952910,
      direction : "+",
      ID : "ENSG00000150687.12",
      gene_id : "ENSG00000150687.12",
      gene_type : "protein_coding",
      gene_name : "PRSS23",
      gene_level : 2,
      hgnc_id : "HGNC:14370",
      havana_gene : "OTTHUMG00000167226.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 86945679,
      stop : 86955395,
      direction : "-",
      ID : "ENSG00000174804.4",
      gene_id : "ENSG00000174804.4",
      gene_type : "protein_coding",
      gene_name : "FZD4",
      gene_level : 2,
      hgnc_id : "HGNC:4042",
      havana_gene : "OTTHUMG00000167231.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 87037844,
      stop : 87328824,
      direction : "+",
      ID : "ENSG00000166575.17",
      gene_id : "ENSG00000166575.17",
      gene_type : "protein_coding",
      gene_name : "TMEM135",
      gene_level : 2,
      hgnc_id : "HGNC:26167",
      havana_gene : "OTTHUMG00000167248.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 88113251,
      stop : 88175443,
      direction : "-",
      ID : "ENSG00000123892.12",
      gene_id : "ENSG00000123892.12",
      gene_type : "protein_coding",
      gene_name : "RAB38",
      gene_level : 1,
      hgnc_id : "HGNC:9776",
      havana_gene : "OTTHUMG00000167288.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 88265069,
      stop : 88359684,
      direction : "-",
      ID : "ENSG00000109861.17",
      gene_id : "ENSG00000109861.17",
      gene_type : "protein_coding",
      gene_name : "CTSC",
      gene_level : 2,
      hgnc_id : "HGNC:2528",
      havana_gene : "OTTHUMG00000167290.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 88504576,
      stop : 89065945,
      direction : "-",
      ID : "ENSG00000168959.14",
      gene_id : "ENSG00000168959.14",
      gene_type : "protein_coding",
      gene_name : "GRM5",
      gene_level : 2,
      hgnc_id : "HGNC:4597",
      havana_gene : "OTTHUMG00000134306.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89177875,
      stop : 89295759,
      direction : "+",
      ID : "ENSG00000077498.9",
      gene_id : "ENSG00000077498.9",
      gene_type : "protein_coding",
      gene_name : "TYR",
      gene_level : 2,
      hgnc_id : "HGNC:12442",
      havana_gene : "OTTHUMG00000167294.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89324353,
      stop : 89498187,
      direction : "-",
      ID : "ENSG00000086991.13",
      gene_id : "ENSG00000086991.13",
      gene_type : "protein_coding",
      gene_name : "NOX4",
      gene_level : 2,
      hgnc_id : "HGNC:7891",
      havana_gene : "OTTHUMG00000167298.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89710299,
      stop : 89717872,
      direction : "+",
      ID : "ENSG00000214414.9",
      gene_id : "ENSG00000214414.9",
      gene_type : "protein_coding",
      gene_name : "TRIM77",
      gene_level : 2,
      hgnc_id : "HGNC:34228",
      havana_gene : "OTTHUMG00000167624.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89797655,
      stop : 89808575,
      direction : "-",
      ID : "ENSG00000168930.13",
      gene_id : "ENSG00000168930.13",
      gene_type : "protein_coding",
      gene_name : "TRIM49",
      gene_level : 2,
      hgnc_id : "HGNC:13431",
      havana_gene : "OTTHUMG00000167634.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89869282,
      stop : 89876017,
      direction : "-",
      ID : "ENSG00000189253.7",
      gene_id : "ENSG00000189253.7",
      gene_type : "protein_coding",
      gene_name : "TRIM64B",
      gene_level : 2,
      hgnc_id : "HGNC:37147",
      havana_gene : "OTTHUMG00000167638.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89911111,
      stop : 89921767,
      direction : "-",
      ID : "ENSG00000223417.8",
      gene_id : "ENSG00000223417.8",
      gene_type : "protein_coding",
      gene_name : "TRIM49D1",
      gene_level : 2,
      hgnc_id : "HGNC:43973",
      havana_gene : "OTTHUMG00000167643.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89924064,
      stop : 89933063,
      direction : "+",
      ID : "ENSG00000233802.8",
      gene_id : "ENSG00000233802.8",
      gene_type : "protein_coding",
      gene_name : "TRIM49D2",
      gene_level : 2,
      hgnc_id : "HGNC:37217",
      havana_gene : "OTTHUMG00000167644.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 89968502,
      stop : 89974072,
      direction : "+",
      ID : "ENSG00000204450.8",
      gene_id : "ENSG00000204450.8",
      gene_type : "protein_coding",
      gene_name : "TRIM64",
      gene_level : 2,
      hgnc_id : "HGNC:14663",
      havana_gene : "OTTHUMG00000167648.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 90031106,
      stop : 90042025,
      direction : "+",
      ID : "ENSG00000204449.3",
      gene_id : "ENSG00000204449.3",
      gene_type : "protein_coding",
      gene_name : "TRIM49C",
      gene_level : 2,
      hgnc_id : "HGNC:38877",
      havana_gene : "OTTHUMG00000167653.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 90085950,
      stop : 90087131,
      direction : "+",
      ID : "ENSG00000255009.4",
      gene_id : "ENSG00000255009.4",
      gene_type : "protein_coding",
      gene_name : "UBTFL1",
      gene_level : 2,
      hgnc_id : "HGNC:14533",
      havana_gene : "OTTHUMG00000155291.5",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 90131515,
      stop : 90192894,
      direction : "+",
      ID : "ENSG00000077616.11",
      gene_id : "ENSG00000077616.11",
      gene_type : "protein_coding",
      gene_name : "NAALAD2",
      gene_level : 1,
      hgnc_id : "HGNC:14526",
      havana_gene : "OTTHUMG00000166368.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 90200429,
      stop : 90223077,
      direction : "-",
      ID : "ENSG00000110172.12",
      gene_id : "ENSG00000110172.12",
      gene_type : "protein_coding",
      gene_name : "CHORDC1",
      gene_level : 2,
      hgnc_id : "HGNC:14525",
      havana_gene : "OTTHUMG00000167305.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 92224818,
      stop : 92896473,
      direction : "+",
      ID : "ENSG00000165323.16",
      gene_id : "ENSG00000165323.16",
      gene_type : "protein_coding",
      gene_name : "FAT3",
      gene_level : 2,
      hgnc_id : "HGNC:23112",
      havana_gene : "OTTHUMG00000154468.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 92969651,
      stop : 92985066,
      direction : "+",
      ID : "ENSG00000134640.3",
      gene_id : "ENSG00000134640.3",
      gene_type : "protein_coding",
      gene_name : "MTNR1B",
      gene_level : 1,
      hgnc_id : "HGNC:7464",
      havana_gene : "OTTHUMG00000167364.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93144174,
      stop : 93197991,
      direction : "-",
      ID : "ENSG00000180773.15",
      gene_id : "ENSG00000180773.15",
      gene_type : "protein_coding",
      gene_name : "SLC36A4",
      gene_level : 1,
      hgnc_id : "HGNC:19660",
      havana_gene : "OTTHUMG00000167368.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93329971,
      stop : 93438487,
      direction : "+",
      ID : "ENSG00000165325.15",
      gene_id : "ENSG00000165325.15",
      gene_type : "protein_coding",
      gene_name : "DEUP1",
      gene_level : 1,
      hgnc_id : "HGNC:26344",
      havana_gene : "OTTHUMG00000167441.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93478472,
      stop : 93543391,
      direction : "-",
      ID : "ENSG00000166002.7",
      gene_id : "ENSG00000166002.7",
      gene_type : "protein_coding",
      gene_name : "SMCO4",
      gene_level : 2,
      hgnc_id : "HGNC:24810",
      havana_gene : "OTTHUMG00000167442.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93661682,
      stop : 93730358,
      direction : "+",
      ID : "ENSG00000166004.15",
      gene_id : "ENSG00000166004.15",
      gene_type : "protein_coding",
      gene_name : "CEP295",
      gene_level : 1,
      hgnc_id : "HGNC:29366",
      havana_gene : "OTTHUMG00000167449.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93729948,
      stop : 93784391,
      direction : "-",
      ID : "ENSG00000166012.17",
      gene_id : "ENSG00000166012.17",
      gene_type : "protein_coding",
      gene_name : "TAF1D",
      gene_level : 2,
      hgnc_id : "HGNC:28759",
      havana_gene : "OTTHUMG00000167451.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93741591,
      stop : 93764749,
      direction : "+",
      ID : "ENSG00000182919.15",
      gene_id : "ENSG00000182919.15",
      gene_type : "protein_coding",
      gene_name : "C11orf54",
      gene_level : 2,
      hgnc_id : "HGNC:30204",
      havana_gene : "OTTHUMG00000167452.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93741664,
      stop : 93812378,
      direction : "+",
      ID : "ENSG00000284057.1",
      gene_id : "ENSG00000284057.1",
      gene_type : "protein_coding",
      gene_name : "AP001273.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191958.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93784227,
      stop : 93814963,
      direction : "+",
      ID : "ENSG00000042429.12",
      gene_id : "ENSG00000042429.12",
      gene_type : "protein_coding",
      gene_name : "MED17",
      gene_level : 1,
      hgnc_id : "HGNC:2375",
      havana_gene : "OTTHUMG00000167497.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 93818232,
      stop : 93850618,
      direction : "-",
      ID : "ENSG00000214376.6",
      gene_id : "ENSG00000214376.6",
      gene_type : "protein_coding",
      gene_name : "VSTM5",
      gene_level : 2,
      hgnc_id : "HGNC:34443",
      havana_gene : "OTTHUMG00000154159.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94021354,
      stop : 94114208,
      direction : "+",
      ID : "ENSG00000181333.12",
      gene_id : "ENSG00000181333.12",
      gene_type : "protein_coding",
      gene_name : "HEPHL1",
      gene_level : 2,
      hgnc_id : "HGNC:30477",
      havana_gene : "OTTHUMG00000167751.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94128841,
      stop : 94181968,
      direction : "+",
      ID : "ENSG00000110218.9",
      gene_id : "ENSG00000110218.9",
      gene_type : "protein_coding",
      gene_name : "PANX1",
      gene_level : 2,
      hgnc_id : "HGNC:8599",
      havana_gene : "OTTHUMG00000167757.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94305592,
      stop : 94307721,
      direction : "+",
      ID : "ENSG00000183560.9",
      gene_id : "ENSG00000183560.9",
      gene_type : "protein_coding",
      gene_name : "IZUMO1R",
      gene_level : 1,
      hgnc_id : "HGNC:32565",
      havana_gene : "OTTHUMG00000167776.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94377316,
      stop : 94401419,
      direction : "-",
      ID : "ENSG00000123901.9",
      gene_id : "ENSG00000123901.9",
      gene_type : "protein_coding",
      gene_name : "GPR83",
      gene_level : 1,
      hgnc_id : "HGNC:4523",
      havana_gene : "OTTHUMG00000167779.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94415570,
      stop : 94493885,
      direction : "-",
      ID : "ENSG00000020922.13",
      gene_id : "ENSG00000020922.13",
      gene_type : "protein_coding",
      gene_name : "MRE11",
      gene_level : 2,
      hgnc_id : "HGNC:7230",
      havana_gene : "OTTHUMG00000167780.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94493979,
      stop : 94499578,
      direction : "+",
      ID : "ENSG00000168876.9",
      gene_id : "ENSG00000168876.9",
      gene_type : "protein_coding",
      gene_name : "ANKRD49",
      gene_level : 1,
      hgnc_id : "HGNC:25970",
      havana_gene : "OTTHUMG00000167793.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94512461,
      stop : 94532123,
      direction : "+",
      ID : "ENSG00000257057.3",
      gene_id : "ENSG00000257057.3",
      gene_type : "protein_coding",
      gene_name : "C11orf97",
      gene_level : 2,
      hgnc_id : "HGNC:49544",
      havana_gene : "OTTHUMG00000167794.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94543840,
      stop : 94549898,
      direction : "+",
      ID : "ENSG00000196371.3",
      gene_id : "ENSG00000196371.3",
      gene_type : "protein_coding",
      gene_name : "FUT4",
      gene_level : 2,
      hgnc_id : "HGNC:4015",
      havana_gene : "OTTHUMG00000167795.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94543840,
      stop : 94621421,
      direction : "+",
      ID : "ENSG00000134627.12",
      gene_id : "ENSG00000134627.12",
      gene_type : "protein_coding",
      gene_name : "PIWIL4",
      gene_level : 2,
      hgnc_id : "HGNC:18444",
      havana_gene : "OTTHUMG00000167811.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94706431,
      stop : 94876748,
      direction : "+",
      ID : "ENSG00000166025.18",
      gene_id : "ENSG00000166025.18",
      gene_type : "protein_coding",
      gene_name : "AMOTL1",
      gene_level : 1,
      hgnc_id : "HGNC:17811",
      havana_gene : "OTTHUMG00000167828.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94962620,
      stop : 94973586,
      direction : "-",
      ID : "ENSG00000150316.12",
      gene_id : "ENSG00000150316.12",
      gene_type : "protein_coding",
      gene_name : "CWC15",
      gene_level : 2,
      hgnc_id : "HGNC:26939",
      havana_gene : "OTTHUMG00000181616.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 94973709,
      stop : 94999519,
      direction : "+",
      ID : "ENSG00000186280.7",
      gene_id : "ENSG00000186280.7",
      gene_type : "protein_coding",
      gene_name : "KDM4D",
      gene_level : 2,
      hgnc_id : "HGNC:25498",
      havana_gene : "OTTHUMG00000167838.5",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95025258,
      stop : 95027596,
      direction : "+",
      ID : "ENSG00000235268.2",
      gene_id : "ENSG00000235268.2",
      gene_type : "protein_coding",
      gene_name : "KDM4E",
      gene_level : 2,
      hgnc_id : "HGNC:37098",
      havana_gene : "OTTHUMG00000167858.1",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95049422,
      stop : 95051338,
      direction : "+",
      ID : "ENSG00000255855.2",
      gene_id : "ENSG00000255855.2",
      gene_type : "protein_coding",
      gene_name : "KDM4F",
      gene_level : 2,
      hgnc_id : "HGNC:52413",
      havana_gene : "OTTHUMG00000167862.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95066919,
      stop : 95071225,
      direction : "+",
      ID : "ENSG00000263465.5",
      gene_id : "ENSG00000263465.5",
      gene_type : "protein_coding",
      gene_name : "SRSF8",
      gene_level : 2,
      hgnc_id : "HGNC:16988",
      havana_gene : "OTTHUMG00000188534.3",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95089846,
      stop : 95132645,
      direction : "+",
      ID : "ENSG00000149218.5",
      gene_id : "ENSG00000149218.5",
      gene_type : "protein_coding",
      gene_name : "ENDOD1",
      gene_level : 2,
      hgnc_id : "HGNC:29129",
      havana_gene : "OTTHUMG00000167835.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95165513,
      stop : 95232541,
      direction : "-",
      ID : "ENSG00000149212.12",
      gene_id : "ENSG00000149212.12",
      gene_type : "protein_coding",
      gene_name : "SESN3",
      gene_level : 1,
      hgnc_id : "HGNC:23060",
      havana_gene : "OTTHUMG00000167829.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95768953,
      stop : 95790409,
      direction : "-",
      ID : "ENSG00000077458.13",
      gene_id : "ENSG00000077458.13",
      gene_type : "protein_coding",
      gene_name : "FAM76B",
      gene_level : 2,
      hgnc_id : "HGNC:28492",
      havana_gene : "OTTHUMG00000167739.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95789965,
      stop : 95832693,
      direction : "+",
      ID : "ENSG00000166037.11",
      gene_id : "ENSG00000166037.11",
      gene_type : "protein_coding",
      gene_name : "CEP57",
      gene_level : 1,
      hgnc_id : "HGNC:30794",
      havana_gene : "OTTHUMG00000167740.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95821766,
      stop : 95925315,
      direction : "-",
      ID : "ENSG00000087053.20",
      gene_id : "ENSG00000087053.20",
      gene_type : "protein_coding",
      gene_name : "MTMR2",
      gene_level : 2,
      hgnc_id : "HGNC:7450",
      havana_gene : "OTTHUMG00000153837.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 95976598,
      stop : 96343195,
      direction : "-",
      ID : "ENSG00000184384.14",
      gene_id : "ENSG00000184384.14",
      gene_type : "protein_coding",
      gene_name : "MAML2",
      gene_level : 2,
      hgnc_id : "HGNC:16259",
      havana_gene : "OTTHUMG00000167677.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 96349241,
      stop : 96389956,
      direction : "-",
      ID : "ENSG00000149231.16",
      gene_id : "ENSG00000149231.16",
      gene_type : "protein_coding",
      gene_name : "CCDC82",
      gene_level : 2,
      hgnc_id : "HGNC:26282",
      havana_gene : "OTTHUMG00000167678.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 96389989,
      stop : 96507574,
      direction : "+",
      ID : "ENSG00000183340.7",
      gene_id : "ENSG00000183340.7",
      gene_type : "protein_coding",
      gene_name : "JRKL",
      gene_level : 2,
      hgnc_id : "HGNC:6200",
      havana_gene : "OTTHUMG00000154950.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 99020949,
      stop : 100358885,
      direction : "+",
      ID : "ENSG00000149972.11",
      gene_id : "ENSG00000149972.11",
      gene_type : "protein_coding",
      gene_name : "CNTN5",
      gene_level : 2,
      hgnc_id : "HGNC:2175",
      havana_gene : "OTTHUMG00000167579.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 100687288,
      stop : 100993941,
      direction : "+",
      ID : "ENSG00000165895.19",
      gene_id : "ENSG00000165895.19",
      gene_type : "protein_coding",
      gene_name : "ARHGAP42",
      gene_level : 2,
      hgnc_id : "HGNC:26545",
      havana_gene : "OTTHUMG00000167530.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 101029624,
      stop : 101129813,
      direction : "-",
      ID : "ENSG00000082175.15",
      gene_id : "ENSG00000082175.15",
      gene_type : "protein_coding",
      gene_name : "PGR",
      gene_level : 2,
      hgnc_id : "HGNC:8910",
      havana_gene : "OTTHUMG00000167531.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 101451564,
      stop : 101872562,
      direction : "-",
      ID : "ENSG00000137672.13",
      gene_id : "ENSG00000137672.13",
      gene_type : "protein_coding",
      gene_name : "TRPC6",
      gene_level : 1,
      hgnc_id : "HGNC:12338",
      havana_gene : "OTTHUMG00000167483.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 101890674,
      stop : 101916522,
      direction : "-",
      ID : "ENSG00000187151.7",
      gene_id : "ENSG00000187151.7",
      gene_type : "protein_coding",
      gene_name : "ANGPTL5",
      gene_level : 2,
      hgnc_id : "HGNC:19705",
      havana_gene : "OTTHUMG00000167318.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 101915010,
      stop : 102001062,
      direction : "+",
      ID : "ENSG00000110318.15",
      gene_id : "ENSG00000110318.15",
      gene_type : "protein_coding",
      gene_name : "CEP126",
      gene_level : 2,
      hgnc_id : "HGNC:29264",
      havana_gene : "OTTHUMG00000167319.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102047437,
      stop : 102084554,
      direction : "+",
      ID : "ENSG00000137691.13",
      gene_id : "ENSG00000137691.13",
      gene_type : "protein_coding",
      gene_name : "CFAP300",
      gene_level : 1,
      hgnc_id : "HGNC:28188",
      havana_gene : "OTTHUMG00000167320.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102110447,
      stop : 102233424,
      direction : "+",
      ID : "ENSG00000137693.14",
      gene_id : "ENSG00000137693.14",
      gene_type : "protein_coding",
      gene_name : "YAP1",
      gene_level : 1,
      hgnc_id : "HGNC:16262",
      havana_gene : "OTTHUMG00000167322.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102317450,
      stop : 102339403,
      direction : "+",
      ID : "ENSG00000023445.16",
      gene_id : "ENSG00000023445.16",
      gene_type : "protein_coding",
      gene_name : "BIRC3",
      gene_level : 1,
      hgnc_id : "HGNC:591",
      havana_gene : "OTTHUMG00000167324.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102347211,
      stop : 102378670,
      direction : "+",
      ID : "ENSG00000110330.8",
      gene_id : "ENSG00000110330.8",
      gene_type : "protein_coding",
      gene_name : "BIRC2",
      gene_level : 1,
      hgnc_id : "HGNC:590",
      havana_gene : "OTTHUMG00000167325.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102396332,
      stop : 102470384,
      direction : "-",
      ID : "ENSG00000152558.15",
      gene_id : "ENSG00000152558.15",
      gene_type : "protein_coding",
      gene_name : "TMEM123",
      gene_level : 2,
      hgnc_id : "HGNC:30138",
      havana_gene : "OTTHUMG00000167326.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102520508,
      stop : 102530750,
      direction : "-",
      ID : "ENSG00000137673.9",
      gene_id : "ENSG00000137673.9",
      gene_type : "protein_coding",
      gene_name : "MMP7",
      gene_level : 2,
      hgnc_id : "HGNC:7174",
      havana_gene : "OTTHUMG00000048193.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102576832,
      stop : 102625332,
      direction : "-",
      ID : "ENSG00000137674.4",
      gene_id : "ENSG00000137674.4",
      gene_type : "protein_coding",
      gene_name : "MMP20",
      gene_level : 2,
      hgnc_id : "HGNC:7167",
      havana_gene : "OTTHUMG00000168081.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102691487,
      stop : 102705769,
      direction : "-",
      ID : "ENSG00000137675.5",
      gene_id : "ENSG00000137675.5",
      gene_type : "protein_coding",
      gene_name : "MMP27",
      gene_level : 2,
      hgnc_id : "HGNC:14250",
      havana_gene : "OTTHUMG00000168099.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102711796,
      stop : 102727050,
      direction : "-",
      ID : "ENSG00000118113.12",
      gene_id : "ENSG00000118113.12",
      gene_type : "protein_coding",
      gene_name : "MMP8",
      gene_level : 1,
      hgnc_id : "HGNC:7175",
      havana_gene : "OTTHUMG00000167587.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102770502,
      stop : 102780628,
      direction : "-",
      ID : "ENSG00000166670.10",
      gene_id : "ENSG00000166670.10",
      gene_type : "protein_coding",
      gene_name : "MMP10",
      gene_level : 2,
      hgnc_id : "HGNC:7156",
      havana_gene : "OTTHUMG00000168083.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102789401,
      stop : 102798160,
      direction : "-",
      ID : "ENSG00000196611.6",
      gene_id : "ENSG00000196611.6",
      gene_type : "protein_coding",
      gene_name : "MMP1",
      gene_level : 2,
      hgnc_id : "HGNC:7155",
      havana_gene : "OTTHUMG00000048192.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102835801,
      stop : 102843609,
      direction : "-",
      ID : "ENSG00000149968.12",
      gene_id : "ENSG00000149968.12",
      gene_type : "protein_coding",
      gene_name : "MMP3",
      gene_level : 2,
      hgnc_id : "HGNC:7173",
      havana_gene : "OTTHUMG00000048254.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102862736,
      stop : 102874982,
      direction : "-",
      ID : "ENSG00000262406.3",
      gene_id : "ENSG00000262406.3",
      gene_type : "protein_coding",
      gene_name : "MMP12",
      gene_level : 2,
      hgnc_id : "HGNC:7158",
      havana_gene : "OTTHUMG00000165848.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 102942995,
      stop : 102955732,
      direction : "-",
      ID : "ENSG00000137745.12",
      gene_id : "ENSG00000137745.12",
      gene_type : "protein_coding",
      gene_name : "MMP13",
      gene_level : 1,
      hgnc_id : "HGNC:7159",
      havana_gene : "OTTHUMG00000165850.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 103050686,
      stop : 103092194,
      direction : "-",
      ID : "ENSG00000137692.12",
      gene_id : "ENSG00000137692.12",
      gene_type : "protein_coding",
      gene_name : "DCUN1D5",
      gene_level : 1,
      hgnc_id : "HGNC:28409",
      havana_gene : "OTTHUMG00000165822.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 103109410,
      stop : 103479863,
      direction : "+",
      ID : "ENSG00000187240.16",
      gene_id : "ENSG00000187240.16",
      gene_type : "protein_coding",
      gene_name : "DYNC2H1",
      gene_level : 2,
      hgnc_id : "HGNC:2962",
      havana_gene : "OTTHUMG00000165941.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 103907189,
      stop : 104164379,
      direction : "-",
      ID : "ENSG00000170962.13",
      gene_id : "ENSG00000170962.13",
      gene_type : "protein_coding",
      gene_name : "PDGFD",
      gene_level : 2,
      hgnc_id : "HGNC:30620",
      havana_gene : "OTTHUMG00000165953.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 104036640,
      stop : 104039196,
      direction : "+",
      ID : "ENSG00000170967.5",
      gene_id : "ENSG00000170967.5",
      gene_type : "protein_coding",
      gene_name : "DDI1",
      gene_level : 2,
      hgnc_id : "HGNC:18961",
      havana_gene : "OTTHUMG00000165990.2",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 104942866,
      stop : 104969366,
      direction : "-",
      ID : "ENSG00000196954.14",
      gene_id : "ENSG00000196954.14",
      gene_type : "protein_coding",
      gene_name : "CASP4",
      gene_level : 1,
      hgnc_id : "HGNC:1505",
      havana_gene : "OTTHUMG00000166078.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 104994235,
      stop : 105023168,
      direction : "-",
      ID : "ENSG00000137757.11",
      gene_id : "ENSG00000137757.11",
      gene_type : "protein_coding",
      gene_name : "CASP5",
      gene_level : 2,
      hgnc_id : "HGNC:1506",
      havana_gene : "OTTHUMG00000048073.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 105025443,
      stop : 105035250,
      direction : "-",
      ID : "ENSG00000137752.24",
      gene_id : "ENSG00000137752.24",
      gene_type : "protein_coding",
      gene_name : "CASP1",
      gene_level : 1,
      hgnc_id : "HGNC:1499",
      havana_gene : "OTTHUMG00000048072.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 105137714,
      stop : 105531697,
      direction : "-",
      ID : "ENSG00000255501.3",
      gene_id : "ENSG00000255501.3",
      gene_type : "protein_coding",
      gene_name : "CARD18",
      gene_level : 2,
      hgnc_id : "HGNC:28861",
      havana_gene : "OTTHUMG00000166165.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 105609994,
      stop : 105982092,
      direction : "+",
      ID : "ENSG00000152578.13",
      gene_id : "ENSG00000152578.13",
      gene_type : "protein_coding",
      gene_name : "GRIA4",
      gene_level : 2,
      hgnc_id : "HGNC:4574",
      havana_gene : "OTTHUMG00000166236.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 105995623,
      stop : 106022403,
      direction : "-",
      ID : "ENSG00000170903.11",
      gene_id : "ENSG00000170903.11",
      gene_type : "protein_coding",
      gene_name : "MSANTD4",
      gene_level : 1,
      hgnc_id : "HGNC:29383",
      havana_gene : "OTTHUMG00000166240.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 106051098,
      stop : 106077459,
      direction : "-",
      ID : "ENSG00000182359.15",
      gene_id : "ENSG00000182359.15",
      gene_type : "protein_coding",
      gene_name : "KBTBD3",
      gene_level : 1,
      hgnc_id : "HGNC:22934",
      havana_gene : "OTTHUMG00000166251.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 106075501,
      stop : 106098699,
      direction : "+",
      ID : "ENSG00000149313.11",
      gene_id : "ENSG00000149313.11",
      gene_type : "protein_coding",
      gene_name : "AASDHPPT",
      gene_level : 2,
      hgnc_id : "HGNC:14235",
      havana_gene : "OTTHUMG00000166253.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 106674019,
      stop : 107018476,
      direction : "-",
      ID : "ENSG00000152402.11",
      gene_id : "ENSG00000152402.11",
      gene_type : "protein_coding",
      gene_name : "GUCY1A2",
      gene_level : 2,
      hgnc_id : "HGNC:4684",
      havana_gene : "OTTHUMG00000166296.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 107326345,
      stop : 107457844,
      direction : "-",
      ID : "ENSG00000152404.15",
      gene_id : "ENSG00000152404.15",
      gene_type : "protein_coding",
      gene_name : "CWF19L2",
      gene_level : 2,
      hgnc_id : "HGNC:26508",
      havana_gene : "OTTHUMG00000152975.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 107502727,
      stop : 107565742,
      direction : "-",
      ID : "ENSG00000137760.15",
      gene_id : "ENSG00000137760.15",
      gene_type : "protein_coding",
      gene_name : "ALKBH8",
      gene_level : 2,
      hgnc_id : "HGNC:25189",
      havana_gene : "OTTHUMG00000157008.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 107591091,
      stop : 107666779,
      direction : "+",
      ID : "ENSG00000110675.13",
      gene_id : "ENSG00000110675.13",
      gene_type : "protein_coding",
      gene_name : "ELMOD1",
      gene_level : 1,
      hgnc_id : "HGNC:25334",
      havana_gene : "OTTHUMG00000166361.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 107707378,
      stop : 107719693,
      direction : "-",
      ID : "ENSG00000170290.4",
      gene_id : "ENSG00000170290.4",
      gene_type : "protein_coding",
      gene_name : "SLN",
      gene_level : 2,
      hgnc_id : "HGNC:11089",
      havana_gene : "OTTHUMG00000166364.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 107790991,
      stop : 107928293,
      direction : "-",
      ID : "ENSG00000110660.15",
      gene_id : "ENSG00000110660.15",
      gene_type : "protein_coding",
      gene_name : "SLC35F2",
      gene_level : 2,
      hgnc_id : "HGNC:23615",
      havana_gene : "OTTHUMG00000166366.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 107928448,
      stop : 107963482,
      direction : "+",
      ID : "ENSG00000179331.3",
      gene_id : "ENSG00000179331.3",
      gene_type : "protein_coding",
      gene_name : "RAB39A",
      gene_level : 2,
      hgnc_id : "HGNC:16521",
      havana_gene : "OTTHUMG00000166367.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108008898,
      stop : 108107761,
      direction : "+",
      ID : "ENSG00000166266.14",
      gene_id : "ENSG00000166266.14",
      gene_type : "protein_coding",
      gene_name : "CUL5",
      gene_level : 1,
      hgnc_id : "HGNC:2556",
      havana_gene : "OTTHUMG00000166369.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108116695,
      stop : 108147603,
      direction : "+",
      ID : "ENSG00000075239.14",
      gene_id : "ENSG00000075239.14",
      gene_type : "protein_coding",
      gene_name : "ACAT1",
      gene_level : 1,
      hgnc_id : "HGNC:93",
      havana_gene : "OTTHUMG00000166381.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108157215,
      stop : 108222638,
      direction : "-",
      ID : "ENSG00000149308.17",
      gene_id : "ENSG00000149308.17",
      gene_type : "protein_coding",
      gene_name : "NPAT",
      gene_level : 2,
      hgnc_id : "HGNC:7896",
      havana_gene : "OTTHUMG00000166385.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108222832,
      stop : 108369102,
      direction : "+",
      ID : "ENSG00000149311.19",
      gene_id : "ENSG00000149311.19",
      gene_type : "protein_coding",
      gene_name : "ATM",
      gene_level : 1,
      hgnc_id : "HGNC:795",
      havana_gene : "OTTHUMG00000166480.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108308519,
      stop : 108467531,
      direction : "-",
      ID : "ENSG00000166323.13",
      gene_id : "ENSG00000166323.13",
      gene_type : "protein_coding",
      gene_name : "C11orf65",
      gene_level : 1,
      hgnc_id : "HGNC:28519",
      havana_gene : "OTTHUMG00000166489.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108472112,
      stop : 108498384,
      direction : "-",
      ID : "ENSG00000178202.13",
      gene_id : "ENSG00000178202.13",
      gene_type : "protein_coding",
      gene_name : "POGLUT3",
      gene_level : 1,
      hgnc_id : "HGNC:28496",
      havana_gene : "OTTHUMG00000166535.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108505435,
      stop : 108593768,
      direction : "-",
      ID : "ENSG00000110723.12",
      gene_id : "ENSG00000110723.12",
      gene_type : "protein_coding",
      gene_name : "EXPH5",
      gene_level : 1,
      hgnc_id : "HGNC:30578",
      havana_gene : "OTTHUMG00000166536.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 108665069,
      stop : 108940927,
      direction : "+",
      ID : "ENSG00000178105.11",
      gene_id : "ENSG00000178105.11",
      gene_type : "protein_coding",
      gene_name : "DDX10",
      gene_level : 1,
      hgnc_id : "HGNC:2735",
      havana_gene : "OTTHUMG00000166540.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 109422190,
      stop : 109429167,
      direction : "+",
      ID : "ENSG00000185742.7",
      gene_id : "ENSG00000185742.7",
      gene_type : "protein_coding",
      gene_name : "C11orf87",
      gene_level : 2,
      hgnc_id : "HGNC:33788",
      havana_gene : "OTTHUMG00000166559.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 109864295,
      stop : 110296712,
      direction : "-",
      ID : "ENSG00000137710.17",
      gene_id : "ENSG00000137710.17",
      gene_type : "protein_coding",
      gene_name : "RDX",
      gene_level : 1,
      hgnc_id : "HGNC:9944",
      havana_gene : "OTTHUMG00000166574.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 110093392,
      stop : 110171841,
      direction : "+",
      ID : "ENSG00000149289.11",
      gene_id : "ENSG00000149289.11",
      gene_type : "protein_coding",
      gene_name : "ZC3H12C",
      gene_level : 1,
      hgnc_id : "HGNC:29362",
      havana_gene : "OTTHUMG00000166572.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 110429948,
      stop : 110464884,
      direction : "+",
      ID : "ENSG00000137714.3",
      gene_id : "ENSG00000137714.3",
      gene_type : "protein_coding",
      gene_name : "FDX1",
      gene_level : 2,
      hgnc_id : "HGNC:3638",
      havana_gene : "OTTHUMG00000166589.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 110577042,
      stop : 110713189,
      direction : "-",
      ID : "ENSG00000137727.12",
      gene_id : "ENSG00000137727.12",
      gene_type : "protein_coding",
      gene_name : "ARHGAP20",
      gene_level : 1,
      hgnc_id : "HGNC:18357",
      havana_gene : "OTTHUMG00000166590.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111245726,
      stop : 111286401,
      direction : "+",
      ID : "ENSG00000150750.8",
      gene_id : "ENSG00000150750.8",
      gene_type : "protein_coding",
      gene_name : "C11orf53",
      gene_level : 2,
      hgnc_id : "HGNC:30527",
      havana_gene : "OTTHUMG00000166656.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111298555,
      stop : 111308735,
      direction : "+",
      ID : "ENSG00000214290.8",
      gene_id : "ENSG00000214290.8",
      gene_type : "protein_coding",
      gene_name : "COLCA2",
      gene_level : 2,
      hgnc_id : "HGNC:26978",
      havana_gene : "OTTHUMG00000166657.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111352255,
      stop : 111455630,
      direction : "-",
      ID : "ENSG00000110777.12",
      gene_id : "ENSG00000110777.12",
      gene_type : "protein_coding",
      gene_name : "POU2AF1",
      gene_level : 1,
      hgnc_id : "HGNC:9211",
      havana_gene : "OTTHUMG00000166659.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111467526,
      stop : 111512354,
      direction : "-",
      ID : "ENSG00000137707.13",
      gene_id : "ENSG00000137707.13",
      gene_type : "protein_coding",
      gene_name : "BTG4",
      gene_level : 2,
      hgnc_id : "HGNC:13862",
      havana_gene : "OTTHUMG00000166718.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111514785,
      stop : 111537031,
      direction : "+",
      ID : "ENSG00000183644.13",
      gene_id : "ENSG00000183644.13",
      gene_type : "protein_coding",
      gene_name : "HOATZ",
      gene_level : 2,
      hgnc_id : "HGNC:25061",
      havana_gene : "OTTHUMG00000166720.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111540280,
      stop : 111561745,
      direction : "+",
      ID : "ENSG00000204381.12",
      gene_id : "ENSG00000204381.12",
      gene_type : "protein_coding",
      gene_name : "LAYN",
      gene_level : 2,
      hgnc_id : "HGNC:29471",
      havana_gene : "OTTHUMG00000166721.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111602449,
      stop : 111730855,
      direction : "+",
      ID : "ENSG00000170145.5",
      gene_id : "ENSG00000170145.5",
      gene_type : "protein_coding",
      gene_name : "SIK2",
      gene_level : 1,
      hgnc_id : "HGNC:21680",
      havana_gene : "OTTHUMG00000150644.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111726908,
      stop : 111766389,
      direction : "-",
      ID : "ENSG00000137713.16",
      gene_id : "ENSG00000137713.16",
      gene_type : "protein_coding",
      gene_name : "PPP2R1B",
      gene_level : 1,
      hgnc_id : "HGNC:9303",
      havana_gene : "OTTHUMG00000166741.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111782195,
      stop : 111871581,
      direction : "-",
      ID : "ENSG00000086848.15",
      gene_id : "ENSG00000086848.15",
      gene_type : "protein_coding",
      gene_name : "ALG9",
      gene_level : 1,
      hgnc_id : "HGNC:15672",
      havana_gene : "OTTHUMG00000166819.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111786286,
      stop : 111879425,
      direction : "-",
      ID : "ENSG00000258529.5",
      gene_id : "ENSG00000258529.5",
      gene_type : "protein_coding",
      gene_name : "AP001781.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171433.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111874056,
      stop : 111881243,
      direction : "-",
      ID : "ENSG00000255561.7",
      gene_id : "ENSG00000255561.7",
      gene_type : "protein_coding",
      gene_name : "FDXACB1",
      gene_level : 1,
      hgnc_id : "HGNC:25110",
      havana_gene : "OTTHUMG00000166795.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111878935,
      stop : 111885975,
      direction : "+",
      ID : "ENSG00000137720.8",
      gene_id : "ENSG00000137720.8",
      gene_type : "protein_coding",
      gene_name : "C11orf1",
      gene_level : 1,
      hgnc_id : "HGNC:1163",
      havana_gene : "OTTHUMG00000166884.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111908564,
      stop : 111923722,
      direction : "-",
      ID : "ENSG00000109846.9",
      gene_id : "ENSG00000109846.9",
      gene_type : "protein_coding",
      gene_name : "CRYAB",
      gene_level : 1,
      hgnc_id : "HGNC:2389",
      havana_gene : "OTTHUMG00000166885.12",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111912734,
      stop : 111914093,
      direction : "+",
      ID : "ENSG00000170276.6",
      gene_id : "ENSG00000170276.6",
      gene_type : "protein_coding",
      gene_name : "HSPB2",
      gene_level : 2,
      hgnc_id : "HGNC:5247",
      havana_gene : "OTTHUMG00000166886.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111912736,
      stop : 111926871,
      direction : "+",
      ID : "ENSG00000254445.1",
      gene_id : "ENSG00000254445.1",
      gene_type : "protein_coding",
      gene_name : "HSPB2-C11orf52",
      gene_level : 2,
      hgnc_id : "HGNC:41996",
      havana_gene : "OTTHUMG00000166887.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111918032,
      stop : 111926871,
      direction : "+",
      ID : "ENSG00000149300.10",
      gene_id : "ENSG00000149300.10",
      gene_type : "protein_coding",
      gene_name : "C11orf52",
      gene_level : 2,
      hgnc_id : "HGNC:30531",
      havana_gene : "OTTHUMG00000166888.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 111927144,
      stop : 112022653,
      direction : "+",
      ID : "ENSG00000150764.14",
      gene_id : "ENSG00000150764.14",
      gene_type : "protein_coding",
      gene_name : "DIXDC1",
      gene_level : 2,
      hgnc_id : "HGNC:23695",
      havana_gene : "OTTHUMG00000166912.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112025408,
      stop : 112064404,
      direction : "+",
      ID : "ENSG00000150768.17",
      gene_id : "ENSG00000150768.17",
      gene_type : "protein_coding",
      gene_name : "DLAT",
      gene_level : 1,
      hgnc_id : "HGNC:2896",
      havana_gene : "OTTHUMG00000133751.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112063218,
      stop : 112074274,
      direction : "-",
      ID : "ENSG00000150773.12",
      gene_id : "ENSG00000150773.12",
      gene_type : "protein_coding",
      gene_name : "PIH1D2",
      gene_level : 2,
      hgnc_id : "HGNC:25210",
      havana_gene : "OTTHUMG00000166925.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112074086,
      stop : 112085150,
      direction : "+",
      ID : "ENSG00000150776.18",
      gene_id : "ENSG00000150776.18",
      gene_type : "protein_coding",
      gene_name : "NKAPD1",
      gene_level : 1,
      hgnc_id : "HGNC:25569",
      havana_gene : "OTTHUMG00000150213.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112084800,
      stop : 112086798,
      direction : "-",
      ID : "ENSG00000150779.12",
      gene_id : "ENSG00000150779.12",
      gene_type : "protein_coding",
      gene_name : "TIMM8B",
      gene_level : 2,
      hgnc_id : "HGNC:11818",
      havana_gene : "OTTHUMG00000162261.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112086824,
      stop : 112120016,
      direction : "+",
      ID : "ENSG00000204370.13",
      gene_id : "ENSG00000204370.13",
      gene_type : "protein_coding",
      gene_name : "SDHD",
      gene_level : 1,
      hgnc_id : "HGNC:10683",
      havana_gene : "OTTHUMG00000166997.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112086903,
      stop : 112193805,
      direction : "+",
      ID : "ENSG00000255292.9",
      gene_id : "ENSG00000255292.9",
      gene_type : "protein_coding",
      gene_name : "AP002884.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112143253,
      stop : 112164096,
      direction : "-",
      ID : "ENSG00000150782.12",
      gene_id : "ENSG00000150782.12",
      gene_type : "protein_coding",
      gene_name : "IL18",
      gene_level : 1,
      hgnc_id : "HGNC:5986",
      havana_gene : "OTTHUMG00000167006.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112167372,
      stop : 112172556,
      direction : "+",
      ID : "ENSG00000150783.10",
      gene_id : "ENSG00000150783.10",
      gene_type : "protein_coding",
      gene_name : "TEX12",
      gene_level : 2,
      hgnc_id : "HGNC:11734",
      havana_gene : "OTTHUMG00000167008.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112175510,
      stop : 112224699,
      direction : "+",
      ID : "ENSG00000197580.13",
      gene_id : "ENSG00000197580.13",
      gene_type : "protein_coding",
      gene_name : "BCO2",
      gene_level : 1,
      hgnc_id : "HGNC:18503",
      havana_gene : "OTTHUMG00000167155.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112226367,
      stop : 112269955,
      direction : "+",
      ID : "ENSG00000150787.8",
      gene_id : "ENSG00000150787.8",
      gene_type : "protein_coding",
      gene_name : "PTS",
      gene_level : 2,
      hgnc_id : "HGNC:9689",
      havana_gene : "OTTHUMG00000167167.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112248153,
      stop : 112260860,
      direction : "-",
      ID : "ENSG00000188771.5",
      gene_id : "ENSG00000188771.5",
      gene_type : "protein_coding",
      gene_name : "PLET1",
      gene_level : 2,
      hgnc_id : "HGNC:30053",
      havana_gene : "OTTHUMG00000167189.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 112961247,
      stop : 113278436,
      direction : "+",
      ID : "ENSG00000149294.17",
      gene_id : "ENSG00000149294.17",
      gene_type : "protein_coding",
      gene_name : "NCAM1",
      gene_level : 1,
      hgnc_id : "HGNC:7656",
      havana_gene : "OTTHUMG00000167196.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113314579,
      stop : 113383544,
      direction : "+",
      ID : "ENSG00000149292.17",
      gene_id : "ENSG00000149292.17",
      gene_type : "protein_coding",
      gene_name : "TTC12",
      gene_level : 2,
      hgnc_id : "HGNC:23700",
      havana_gene : "OTTHUMG00000142832.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113387779,
      stop : 113400416,
      direction : "+",
      ID : "ENSG00000170209.5",
      gene_id : "ENSG00000170209.5",
      gene_type : "protein_coding",
      gene_name : "ANKK1",
      gene_level : 2,
      hgnc_id : "HGNC:21027",
      havana_gene : "OTTHUMG00000167715.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113409605,
      stop : 113475691,
      direction : "-",
      ID : "ENSG00000149295.14",
      gene_id : "ENSG00000149295.14",
      gene_type : "protein_coding",
      gene_name : "DRD2",
      gene_level : 2,
      hgnc_id : "HGNC:3023",
      havana_gene : "OTTHUMG00000167717.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113687547,
      stop : 113706373,
      direction : "-",
      ID : "ENSG00000166682.13",
      gene_id : "ENSG00000166682.13",
      gene_type : "protein_coding",
      gene_name : "TMPRSS5",
      gene_level : 1,
      hgnc_id : "HGNC:14908",
      havana_gene : "OTTHUMG00000168186.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113733187,
      stop : 113773735,
      direction : "-",
      ID : "ENSG00000086827.9",
      gene_id : "ENSG00000086827.9",
      gene_type : "protein_coding",
      gene_name : "ZW10",
      gene_level : 2,
      hgnc_id : "HGNC:13194",
      havana_gene : "OTTHUMG00000168190.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113779747,
      stop : 113780500,
      direction : "+",
      ID : "ENSG00000228607.2",
      gene_id : "ENSG00000228607.2",
      gene_type : "protein_coding",
      gene_name : "CLDN25",
      gene_level : 2,
      hgnc_id : "HGNC:37218",
      havana_gene : "OTTHUMG00000168193.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113797874,
      stop : 113875570,
      direction : "-",
      ID : "ENSG00000048028.11",
      gene_id : "ENSG00000048028.11",
      gene_type : "protein_coding",
      gene_name : "USP28",
      gene_level : 1,
      hgnc_id : "HGNC:12625",
      havana_gene : "OTTHUMG00000168205.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113904677,
      stop : 113949078,
      direction : "+",
      ID : "ENSG00000149305.7",
      gene_id : "ENSG00000149305.7",
      gene_type : "protein_coding",
      gene_name : "HTR3B",
      gene_level : 1,
      hgnc_id : "HGNC:5298",
      havana_gene : "OTTHUMG00000168210.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 113974881,
      stop : 113990313,
      direction : "+",
      ID : "ENSG00000166736.11",
      gene_id : "ENSG00000166736.11",
      gene_type : "protein_coding",
      gene_name : "HTR3A",
      gene_level : 2,
      hgnc_id : "HGNC:5297",
      havana_gene : "OTTHUMG00000160494.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114059711,
      stop : 114256765,
      direction : "+",
      ID : "ENSG00000109906.14",
      gene_id : "ENSG00000109906.14",
      gene_type : "protein_coding",
      gene_name : "ZBTB16",
      gene_level : 2,
      hgnc_id : "HGNC:12930",
      havana_gene : "OTTHUMG00000168243.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114257787,
      stop : 114313536,
      direction : "+",
      ID : "ENSG00000166741.8",
      gene_id : "ENSG00000166741.8",
      gene_type : "protein_coding",
      gene_name : "NNMT",
      gene_level : 2,
      hgnc_id : "HGNC:7861",
      havana_gene : "OTTHUMG00000168245.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114391443,
      stop : 114400511,
      direction : "-",
      ID : "ENSG00000180425.11",
      gene_id : "ENSG00000180425.11",
      gene_type : "protein_coding",
      gene_name : "C11orf71",
      gene_level : 2,
      hgnc_id : "HGNC:25937",
      havana_gene : "OTTHUMG00000168247.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114400030,
      stop : 114414203,
      direction : "+",
      ID : "ENSG00000076053.12",
      gene_id : "ENSG00000076053.12",
      gene_type : "protein_coding",
      gene_name : "RBM7",
      gene_level : 2,
      hgnc_id : "HGNC:9904",
      havana_gene : "OTTHUMG00000168270.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114400682,
      stop : 114443932,
      direction : "+",
      ID : "ENSG00000255663.1",
      gene_id : "ENSG00000255663.1",
      gene_type : "protein_coding",
      gene_name : "AP002373.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168263.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114439435,
      stop : 114450279,
      direction : "+",
      ID : "ENSG00000076043.11",
      gene_id : "ENSG00000076043.11",
      gene_type : "protein_coding",
      gene_name : "REXO2",
      gene_level : 1,
      hgnc_id : "HGNC:17851",
      havana_gene : "OTTHUMG00000168271.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114521645,
      stop : 114559895,
      direction : "-",
      ID : "ENSG00000095110.8",
      gene_id : "ENSG00000095110.8",
      gene_type : "protein_coding",
      gene_name : "NXPE1",
      gene_level : 2,
      hgnc_id : "HGNC:28527",
      havana_gene : "OTTHUMG00000168284.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114570591,
      stop : 114595786,
      direction : "-",
      ID : "ENSG00000137634.10",
      gene_id : "ENSG00000137634.10",
      gene_type : "protein_coding",
      gene_name : "NXPE4",
      gene_level : 2,
      hgnc_id : "HGNC:23117",
      havana_gene : "OTTHUMG00000168291.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 114678527,
      stop : 114707069,
      direction : "+",
      ID : "ENSG00000204361.10",
      gene_id : "ENSG00000204361.10",
      gene_type : "protein_coding",
      gene_name : "NXPE2",
      gene_level : 2,
      hgnc_id : "HGNC:26331",
      havana_gene : "OTTHUMG00000168293.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 115169218,
      stop : 115504957,
      direction : "-",
      ID : "ENSG00000182985.18",
      gene_id : "ENSG00000182985.18",
      gene_type : "protein_coding",
      gene_name : "CADM1",
      gene_level : 1,
      hgnc_id : "HGNC:5951",
      havana_gene : "OTTHUMG00000168202.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116748170,
      stop : 116772987,
      direction : "-",
      ID : "ENSG00000137656.12",
      gene_id : "ENSG00000137656.12",
      gene_type : "protein_coding",
      gene_name : "BUD13",
      gene_level : 1,
      hgnc_id : "HGNC:28199",
      havana_gene : "OTTHUMG00000045136.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116773799,
      stop : 116788039,
      direction : "-",
      ID : "ENSG00000109917.11",
      gene_id : "ENSG00000109917.11",
      gene_type : "protein_coding",
      gene_name : "ZPR1",
      gene_level : 2,
      hgnc_id : "HGNC:13051",
      havana_gene : "OTTHUMG00000046114.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116789367,
      stop : 116792420,
      direction : "-",
      ID : "ENSG00000110243.12",
      gene_id : "ENSG00000110243.12",
      gene_type : "protein_coding",
      gene_name : "APOA5",
      gene_level : 2,
      hgnc_id : "HGNC:17288",
      havana_gene : "OTTHUMG00000046116.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116820700,
      stop : 116823304,
      direction : "-",
      ID : "ENSG00000110244.7",
      gene_id : "ENSG00000110244.7",
      gene_type : "protein_coding",
      gene_name : "APOA4",
      gene_level : 2,
      hgnc_id : "HGNC:602",
      havana_gene : "OTTHUMG00000046110.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116829706,
      stop : 116833072,
      direction : "+",
      ID : "ENSG00000110245.12",
      gene_id : "ENSG00000110245.12",
      gene_type : "protein_coding",
      gene_name : "APOC3",
      gene_level : 2,
      hgnc_id : "HGNC:610",
      havana_gene : "OTTHUMG00000046115.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116835751,
      stop : 116837622,
      direction : "-",
      ID : "ENSG00000118137.10",
      gene_id : "ENSG00000118137.10",
      gene_type : "protein_coding",
      gene_name : "APOA1",
      gene_level : 1,
      hgnc_id : "HGNC:600",
      havana_gene : "OTTHUMG00000046112.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 116843402,
      stop : 117098437,
      direction : "-",
      ID : "ENSG00000160584.16",
      gene_id : "ENSG00000160584.16",
      gene_type : "protein_coding",
      gene_name : "SIK3",
      gene_level : 1,
      hgnc_id : "HGNC:29165",
      havana_gene : "OTTHUMG00000066628.12",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117144284,
      stop : 117176894,
      direction : "+",
      ID : "ENSG00000168092.14",
      gene_id : "ENSG00000168092.14",
      gene_type : "protein_coding",
      gene_name : "PAFAH1B2",
      gene_level : 1,
      hgnc_id : "HGNC:8575",
      havana_gene : "OTTHUMG00000167064.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117178736,
      stop : 117197445,
      direction : "+",
      ID : "ENSG00000149577.16",
      gene_id : "ENSG00000149577.16",
      gene_type : "protein_coding",
      gene_name : "SIDT2",
      gene_level : 1,
      hgnc_id : "HGNC:24272",
      havana_gene : "OTTHUMG00000167065.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117199370,
      stop : 117207464,
      direction : "+",
      ID : "ENSG00000149591.17",
      gene_id : "ENSG00000149591.17",
      gene_type : "protein_coding",
      gene_name : "TAGLN",
      gene_level : 2,
      hgnc_id : "HGNC:11553",
      havana_gene : "OTTHUMG00000167067.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117204337,
      stop : 117232525,
      direction : "-",
      ID : "ENSG00000160613.14",
      gene_id : "ENSG00000160613.14",
      gene_type : "protein_coding",
      gene_name : "PCSK7",
      gene_level : 2,
      hgnc_id : "HGNC:8748",
      havana_gene : "OTTHUMG00000165640.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117232625,
      stop : 117286454,
      direction : "+",
      ID : "ENSG00000167257.11",
      gene_id : "ENSG00000167257.11",
      gene_type : "protein_coding",
      gene_name : "RNF214",
      gene_level : 2,
      hgnc_id : "HGNC:25335",
      havana_gene : "OTTHUMG00000167069.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117285207,
      stop : 117316259,
      direction : "-",
      ID : "ENSG00000186318.17",
      gene_id : "ENSG00000186318.17",
      gene_type : "protein_coding",
      gene_name : "BACE1",
      gene_level : 2,
      hgnc_id : "HGNC:933",
      havana_gene : "OTTHUMG00000160636.11",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117314557,
      stop : 117413266,
      direction : "+",
      ID : "ENSG00000110274.16",
      gene_id : "ENSG00000110274.16",
      gene_type : "protein_coding",
      gene_name : "CEP164",
      gene_level : 1,
      hgnc_id : "HGNC:29182",
      havana_gene : "OTTHUMG00000167070.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117427772,
      stop : 117817525,
      direction : "-",
      ID : "ENSG00000177103.15",
      gene_id : "ENSG00000177103.15",
      gene_type : "protein_coding",
      gene_name : "DSCAML1",
      gene_level : 2,
      hgnc_id : "HGNC:14656",
      havana_gene : "OTTHUMG00000167071.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117800844,
      stop : 117828698,
      direction : "-",
      ID : "ENSG00000137731.14",
      gene_id : "ENSG00000137731.14",
      gene_type : "protein_coding",
      gene_name : "FXYD2",
      gene_level : 2,
      hgnc_id : "HGNC:4026",
      havana_gene : "OTTHUMG00000166990.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117820163,
      stop : 117876667,
      direction : "-",
      ID : "ENSG00000255245.4",
      gene_id : "ENSG00000255245.4",
      gene_type : "protein_coding",
      gene_name : "FXYD6-FXYD2",
      gene_level : 2,
      hgnc_id : "HGNC:39978",
      havana_gene : "OTTHUMG00000166496.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117836976,
      stop : 117877486,
      direction : "-",
      ID : "ENSG00000137726.17",
      gene_id : "ENSG00000137726.17",
      gene_type : "protein_coding",
      gene_name : "FXYD6",
      gene_level : 2,
      hgnc_id : "HGNC:4030",
      havana_gene : "OTTHUMG00000166991.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117900641,
      stop : 117929459,
      direction : "-",
      ID : "ENSG00000137747.16",
      gene_id : "ENSG00000137747.16",
      gene_type : "protein_coding",
      gene_name : "TMPRSS13",
      gene_level : 1,
      hgnc_id : "HGNC:29808",
      havana_gene : "OTTHUMG00000166992.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 117986370,
      stop : 118003037,
      direction : "+",
      ID : "ENSG00000110324.11",
      gene_id : "ENSG00000110324.11",
      gene_type : "protein_coding",
      gene_name : "IL10RA",
      gene_level : 2,
      hgnc_id : "HGNC:5964",
      havana_gene : "OTTHUMG00000166523.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118003634,
      stop : 118088299,
      direction : "-",
      ID : "ENSG00000255274.9",
      gene_id : "ENSG00000255274.9",
      gene_type : "protein_coding",
      gene_name : "SMIM35",
      gene_level : 2,
      hgnc_id : "HGNC:44179",
      havana_gene : "OTTHUMG00000166993.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118077012,
      stop : 118121890,
      direction : "+",
      ID : "ENSG00000137648.19",
      gene_id : "ENSG00000137648.19",
      gene_type : "protein_coding",
      gene_name : "TMPRSS4",
      gene_level : 1,
      hgnc_id : "HGNC:11878",
      havana_gene : "OTTHUMG00000164122.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118133377,
      stop : 118152888,
      direction : "-",
      ID : "ENSG00000177098.9",
      gene_id : "ENSG00000177098.9",
      gene_type : "protein_coding",
      gene_name : "SCN4B",
      gene_level : 2,
      hgnc_id : "HGNC:10592",
      havana_gene : "OTTHUMG00000166994.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118162806,
      stop : 118176639,
      direction : "-",
      ID : "ENSG00000149575.9",
      gene_id : "ENSG00000149575.9",
      gene_type : "protein_coding",
      gene_name : "SCN2B",
      gene_level : 2,
      hgnc_id : "HGNC:10589",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118193725,
      stop : 118225094,
      direction : "-",
      ID : "ENSG00000160593.19",
      gene_id : "ENSG00000160593.19",
      gene_type : "protein_coding",
      gene_name : "JAML",
      gene_level : 1,
      hgnc_id : "HGNC:19084",
      havana_gene : "OTTHUMG00000166965.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118226690,
      stop : 118252365,
      direction : "-",
      ID : "ENSG00000160588.10",
      gene_id : "ENSG00000160588.10",
      gene_type : "protein_coding",
      gene_name : "MPZL3",
      gene_level : 1,
      hgnc_id : "HGNC:27279",
      havana_gene : "OTTHUMG00000166966.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118253416,
      stop : 118264536,
      direction : "-",
      ID : "ENSG00000149573.9",
      gene_id : "ENSG00000149573.9",
      gene_type : "protein_coding",
      gene_name : "MPZL2",
      gene_level : 2,
      hgnc_id : "HGNC:3496",
      havana_gene : "OTTHUMG00000166967.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118304730,
      stop : 118316175,
      direction : "+",
      ID : "ENSG00000198851.10",
      gene_id : "ENSG00000198851.10",
      gene_type : "protein_coding",
      gene_name : "CD3E",
      gene_level : 2,
      hgnc_id : "HGNC:1674",
      havana_gene : "OTTHUMG00000166968.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118339075,
      stop : 118342705,
      direction : "-",
      ID : "ENSG00000167286.10",
      gene_id : "ENSG00000167286.10",
      gene_type : "protein_coding",
      gene_name : "CD3D",
      gene_level : 1,
      hgnc_id : "HGNC:1673",
      havana_gene : "OTTHUMG00000166970.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118344344,
      stop : 118355161,
      direction : "+",
      ID : "ENSG00000160654.11",
      gene_id : "ENSG00000160654.11",
      gene_type : "protein_coding",
      gene_name : "CD3G",
      gene_level : 2,
      hgnc_id : "HGNC:1675",
      havana_gene : "OTTHUMG00000166971.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118359600,
      stop : 118399211,
      direction : "+",
      ID : "ENSG00000110344.10",
      gene_id : "ENSG00000110344.10",
      gene_type : "protein_coding",
      gene_name : "UBE4A",
      gene_level : 2,
      hgnc_id : "HGNC:12499",
      havana_gene : "OTTHUMG00000168100.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118401602,
      stop : 118482737,
      direction : "+",
      ID : "ENSG00000285827.1",
      gene_id : "ENSG00000285827.1",
      gene_type : "protein_coding",
      gene_name : "AP001267.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192648.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118401606,
      stop : 118431496,
      direction : "+",
      ID : "ENSG00000167283.8",
      gene_id : "ENSG00000167283.8",
      gene_type : "protein_coding",
      gene_name : "ATP5MG",
      gene_level : 1,
      hgnc_id : "HGNC:14247",
      havana_gene : "OTTHUMG00000166336.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118436490,
      stop : 118526832,
      direction : "+",
      ID : "ENSG00000118058.23",
      gene_id : "ENSG00000118058.23",
      gene_type : "protein_coding",
      gene_name : "KMT2A",
      gene_level : 1,
      hgnc_id : "HGNC:7132",
      havana_gene : "OTTHUMG00000166337.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118527472,
      stop : 118531197,
      direction : "+",
      ID : "ENSG00000172425.12",
      gene_id : "ENSG00000172425.12",
      gene_type : "protein_coding",
      gene_name : "TTC36",
      gene_level : 2,
      hgnc_id : "HGNC:33708",
      havana_gene : "OTTHUMG00000166338.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118531041,
      stop : 118547280,
      direction : "+",
      ID : "ENSG00000149582.16",
      gene_id : "ENSG00000149582.16",
      gene_type : "protein_coding",
      gene_name : "TMEM25",
      gene_level : 1,
      hgnc_id : "HGNC:25890",
      havana_gene : "OTTHUMG00000166339.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118544528,
      stop : 118572970,
      direction : "-",
      ID : "ENSG00000118096.10",
      gene_id : "ENSG00000118096.10",
      gene_type : "protein_coding",
      gene_name : "IFT46",
      gene_level : 2,
      hgnc_id : "HGNC:26146",
      havana_gene : "OTTHUMG00000166408.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118572390,
      stop : 118603033,
      direction : "+",
      ID : "ENSG00000095139.14",
      gene_id : "ENSG00000095139.14",
      gene_type : "protein_coding",
      gene_name : "ARCN1",
      gene_level : 1,
      hgnc_id : "HGNC:649",
      havana_gene : "OTTHUMG00000166340.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118606440,
      stop : 118658031,
      direction : "+",
      ID : "ENSG00000019144.19",
      gene_id : "ENSG00000019144.19",
      gene_type : "protein_coding",
      gene_name : "PHLDB1",
      gene_level : 2,
      hgnc_id : "HGNC:23697",
      havana_gene : "OTTHUMG00000166341.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118657316,
      stop : 118679690,
      direction : "-",
      ID : "ENSG00000118094.12",
      gene_id : "ENSG00000118094.12",
      gene_type : "protein_coding",
      gene_name : "TREH",
      gene_level : 1,
      hgnc_id : "HGNC:12266",
      havana_gene : "OTTHUMG00000166409.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118747763,
      stop : 118791164,
      direction : "-",
      ID : "ENSG00000110367.13",
      gene_id : "ENSG00000110367.13",
      gene_type : "protein_coding",
      gene_name : "DDX6",
      gene_level : 1,
      hgnc_id : "HGNC:2747",
      havana_gene : "OTTHUMG00000166411.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118883892,
      stop : 118897787,
      direction : "+",
      ID : "ENSG00000160683.5",
      gene_id : "ENSG00000160683.5",
      gene_type : "protein_coding",
      gene_name : "CXCR5",
      gene_level : 2,
      hgnc_id : "HGNC:1060",
      havana_gene : "OTTHUMG00000166345.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118893875,
      stop : 118925608,
      direction : "-",
      ID : "ENSG00000186174.12",
      gene_id : "ENSG00000186174.12",
      gene_type : "protein_coding",
      gene_name : "BCL9L",
      gene_level : 1,
      hgnc_id : "HGNC:23688",
      havana_gene : "OTTHUMG00000166414.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118925164,
      stop : 118958559,
      direction : "+",
      ID : "ENSG00000110375.3",
      gene_id : "ENSG00000110375.3",
      gene_type : "protein_coding",
      gene_name : "UPK2",
      gene_level : 2,
      hgnc_id : "HGNC:12579",
      havana_gene : "OTTHUMG00000166346.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118971712,
      stop : 118981287,
      direction : "+",
      ID : "ENSG00000176302.13",
      gene_id : "ENSG00000176302.13",
      gene_type : "protein_coding",
      gene_name : "FOXR1",
      gene_level : 1,
      hgnc_id : "HGNC:29980",
      havana_gene : "OTTHUMG00000166347.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 118998138,
      stop : 119015793,
      direction : "+",
      ID : "ENSG00000186166.9",
      gene_id : "ENSG00000186166.9",
      gene_type : "protein_coding",
      gene_name : "CENATAC",
      gene_level : 2,
      hgnc_id : "HGNC:30460",
      havana_gene : "OTTHUMG00000166348.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119015712,
      stop : 119018691,
      direction : "-",
      ID : "ENSG00000118181.11",
      gene_id : "ENSG00000118181.11",
      gene_type : "protein_coding",
      gene_name : "RPS25",
      gene_level : 2,
      hgnc_id : "HGNC:10413",
      havana_gene : "OTTHUMG00000166350.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119018763,
      stop : 119025454,
      direction : "+",
      ID : "ENSG00000196655.12",
      gene_id : "ENSG00000196655.12",
      gene_type : "protein_coding",
      gene_name : "TRAPPC4",
      gene_level : 1,
      hgnc_id : "HGNC:19943",
      havana_gene : "OTTHUMG00000166351.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119024114,
      stop : 119030906,
      direction : "-",
      ID : "ENSG00000137700.18",
      gene_id : "ENSG00000137700.18",
      gene_type : "protein_coding",
      gene_name : "SLC37A4",
      gene_level : 2,
      hgnc_id : "HGNC:4061",
      havana_gene : "OTTHUMG00000166352.5",
      tag : "reference_genome_error"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119044188,
      stop : 119057227,
      direction : "-",
      ID : "ENSG00000149428.19",
      gene_id : "ENSG00000149428.19",
      gene_type : "protein_coding",
      gene_name : "HYOU1",
      gene_level : 1,
      hgnc_id : "HGNC:16931",
      havana_gene : "OTTHUMG00000166354.11",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119067818,
      stop : 119081972,
      direction : "+",
      ID : "ENSG00000160695.15",
      gene_id : "ENSG00000160695.15",
      gene_type : "protein_coding",
      gene_name : "VPS11",
      gene_level : 2,
      hgnc_id : "HGNC:14583",
      havana_gene : "OTTHUMG00000166355.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119084866,
      stop : 119093549,
      direction : "+",
      ID : "ENSG00000256269.10",
      gene_id : "ENSG00000256269.10",
      gene_type : "protein_coding",
      gene_name : "HMBS",
      gene_level : 2,
      hgnc_id : "HGNC:4982",
      havana_gene : "OTTHUMG00000168295.13",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119093854,
      stop : 119095467,
      direction : "-",
      ID : "ENSG00000188486.3",
      gene_id : "ENSG00000188486.3",
      gene_type : "protein_coding",
      gene_name : "H2AX",
      gene_level : 2,
      hgnc_id : "HGNC:4739",
      havana_gene : "OTTHUMG00000166196.4",
      tag : "retrogene"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119096503,
      stop : 119108331,
      direction : "-",
      ID : "ENSG00000172269.19",
      gene_id : "ENSG00000172269.19",
      gene_type : "protein_coding",
      gene_name : "DPAGT1",
      gene_level : 2,
      hgnc_id : "HGNC:2995",
      havana_gene : "OTTHUMG00000153533.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119102198,
      stop : 119118544,
      direction : "+",
      ID : "ENSG00000172375.14",
      gene_id : "ENSG00000172375.14",
      gene_type : "protein_coding",
      gene_name : "C2CD2L",
      gene_level : 1,
      hgnc_id : "HGNC:29000",
      havana_gene : "OTTHUMG00000166167.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119121580,
      stop : 119136059,
      direction : "+",
      ID : "ENSG00000172273.13",
      gene_id : "ENSG00000172273.13",
      gene_type : "protein_coding",
      gene_name : "HINFP",
      gene_level : 1,
      hgnc_id : "HGNC:17850",
      havana_gene : "OTTHUMG00000166168.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119149052,
      stop : 119162653,
      direction : "+",
      ID : "ENSG00000172350.10",
      gene_id : "ENSG00000172350.10",
      gene_type : "protein_coding",
      gene_name : "ABCG4",
      gene_level : 1,
      hgnc_id : "HGNC:13884",
      havana_gene : "OTTHUMG00000166169.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119166568,
      stop : 119184016,
      direction : "+",
      ID : "ENSG00000160703.16",
      gene_id : "ENSG00000160703.16",
      gene_type : "protein_coding",
      gene_name : "NLRX1",
      gene_level : 2,
      hgnc_id : "HGNC:29890",
      havana_gene : "OTTHUMG00000154476.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119185457,
      stop : 119190223,
      direction : "+",
      ID : "ENSG00000172367.16",
      gene_id : "ENSG00000172367.16",
      gene_type : "protein_coding",
      gene_name : "PDZD3",
      gene_level : 1,
      hgnc_id : "HGNC:19891",
      havana_gene : "OTTHUMG00000166224.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119189638,
      stop : 119196769,
      direction : "-",
      ID : "ENSG00000248712.7",
      gene_id : "ENSG00000248712.7",
      gene_type : "protein_coding",
      gene_name : "CCDC153",
      gene_level : 2,
      hgnc_id : "HGNC:27446",
      havana_gene : "OTTHUMG00000156903.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119206298,
      stop : 119313926,
      direction : "+",
      ID : "ENSG00000110395.7",
      gene_id : "ENSG00000110395.7",
      gene_type : "protein_coding",
      gene_name : "CBL",
      gene_level : 2,
      hgnc_id : "HGNC:1541",
      havana_gene : "OTTHUMG00000166170.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119308529,
      stop : 119321521,
      direction : "-",
      ID : "ENSG00000076706.17",
      gene_id : "ENSG00000076706.17",
      gene_type : "protein_coding",
      gene_name : "MCAM",
      gene_level : 2,
      hgnc_id : "HGNC:6934",
      havana_gene : "OTTHUMG00000166197.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119334527,
      stop : 119337309,
      direction : "+",
      ID : "ENSG00000173456.5",
      gene_id : "ENSG00000173456.5",
      gene_type : "protein_coding",
      gene_name : "RNF26",
      gene_level : 2,
      hgnc_id : "HGNC:14646",
      havana_gene : "OTTHUMG00000166171.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119338942,
      stop : 119340940,
      direction : "-",
      ID : "ENSG00000223953.6",
      gene_id : "ENSG00000223953.6",
      gene_type : "protein_coding",
      gene_name : "C1QTNF5",
      gene_level : 2,
      hgnc_id : "HGNC:14344",
      havana_gene : "OTTHUMG00000166198.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119338942,
      stop : 119346705,
      direction : "-",
      ID : "ENSG00000235718.9",
      gene_id : "ENSG00000235718.9",
      gene_type : "protein_coding",
      gene_name : "MFRP",
      gene_level : 2,
      hgnc_id : "HGNC:18121",
      havana_gene : "OTTHUMG00000166199.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119355215,
      stop : 119381711,
      direction : "-",
      ID : "ENSG00000036672.16",
      gene_id : "ENSG00000036672.16",
      gene_type : "protein_coding",
      gene_name : "USP2",
      gene_level : 1,
      hgnc_id : "HGNC:12618",
      havana_gene : "OTTHUMG00000166200.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119415476,
      stop : 119424985,
      direction : "-",
      ID : "ENSG00000154096.14",
      gene_id : "ENSG00000154096.14",
      gene_type : "protein_coding",
      gene_name : "THY1",
      gene_level : 1,
      hgnc_id : "HGNC:11801",
      havana_gene : "OTTHUMG00000166202.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 119623408,
      stop : 119729200,
      direction : "-",
      ID : "ENSG00000110400.11",
      gene_id : "ENSG00000110400.11",
      gene_type : "protein_coding",
      gene_name : "NECTIN1",
      gene_level : 1,
      hgnc_id : "HGNC:9706",
      havana_gene : "OTTHUMG00000166177.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 120111286,
      stop : 120185529,
      direction : "-",
      ID : "ENSG00000137699.17",
      gene_id : "ENSG00000137699.17",
      gene_type : "protein_coding",
      gene_name : "TRIM29",
      gene_level : 1,
      hgnc_id : "HGNC:17274",
      havana_gene : "OTTHUMG00000140377.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 120211032,
      stop : 120230334,
      direction : "+",
      ID : "ENSG00000184232.9",
      gene_id : "ENSG00000184232.9",
      gene_type : "protein_coding",
      gene_name : "OAF",
      gene_level : 2,
      hgnc_id : "HGNC:28752",
      havana_gene : "OTTHUMG00000166139.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 120236640,
      stop : 120319945,
      direction : "+",
      ID : "ENSG00000137709.10",
      gene_id : "ENSG00000137709.10",
      gene_type : "protein_coding",
      gene_name : "POU2F3",
      gene_level : 2,
      hgnc_id : "HGNC:19864",
      havana_gene : "OTTHUMG00000166140.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 120325296,
      stop : 120333686,
      direction : "+",
      ID : "ENSG00000181264.9",
      gene_id : "ENSG00000181264.9",
      gene_type : "protein_coding",
      gene_name : "TLCD5",
      gene_level : 2,
      hgnc_id : "HGNC:28280",
      havana_gene : "OTTHUMG00000166142.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 120336413,
      stop : 120489937,
      direction : "+",
      ID : "ENSG00000196914.9",
      gene_id : "ENSG00000196914.9",
      gene_type : "protein_coding",
      gene_name : "ARHGEF12",
      gene_level : 2,
      hgnc_id : "HGNC:14193",
      havana_gene : "OTTHUMG00000166143.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 120511746,
      stop : 120988906,
      direction : "+",
      ID : "ENSG00000149403.13",
      gene_id : "ENSG00000149403.13",
      gene_type : "protein_coding",
      gene_name : "GRIK4",
      gene_level : 2,
      hgnc_id : "HGNC:4582",
      havana_gene : "OTTHUMG00000048255.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 121024072,
      stop : 121090775,
      direction : "+",
      ID : "ENSG00000154114.12",
      gene_id : "ENSG00000154114.12",
      gene_type : "protein_coding",
      gene_name : "TBCEL",
      gene_level : 1,
      hgnc_id : "HGNC:28115",
      havana_gene : "OTTHUMG00000166061.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 121024125,
      stop : 121113108,
      direction : "+",
      ID : "ENSG00000285509.1",
      gene_id : "ENSG00000285509.1",
      gene_type : "protein_coding",
      gene_name : "TBCEL-TECTA",
      gene_level : 2,
      hgnc_id : "HGNC:54857",
      havana_gene : "OTTHUMG00000192615.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 121101243,
      stop : 121191490,
      direction : "+",
      ID : "ENSG00000109927.11",
      gene_id : "ENSG00000109927.11",
      gene_type : "protein_coding",
      gene_name : "TECTA",
      gene_level : 1,
      hgnc_id : "HGNC:11720",
      havana_gene : "OTTHUMG00000149908.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 121292681,
      stop : 121313410,
      direction : "+",
      ID : "ENSG00000109929.10",
      gene_id : "ENSG00000109929.10",
      gene_type : "protein_coding",
      gene_name : "SC5D",
      gene_level : 1,
      hgnc_id : "HGNC:10547",
      havana_gene : "OTTHUMG00000166068.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 121452314,
      stop : 121633763,
      direction : "+",
      ID : "ENSG00000137642.13",
      gene_id : "ENSG00000137642.13",
      gene_type : "protein_coding",
      gene_name : "SORL1",
      gene_level : 1,
      hgnc_id : "HGNC:11185",
      havana_gene : "OTTHUMG00000166057.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 122115340,
      stop : 122116215,
      direction : "-",
      ID : "ENSG00000259571.2",
      gene_id : "ENSG00000259571.2",
      gene_type : "protein_coding",
      gene_name : "BLID",
      gene_level : 2,
      hgnc_id : "HGNC:33495",
      havana_gene : "OTTHUMG00000166060.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 122655722,
      stop : 122814473,
      direction : "+",
      ID : "ENSG00000154127.10",
      gene_id : "ENSG00000154127.10",
      gene_type : "protein_coding",
      gene_name : "UBASH3B",
      gene_level : 2,
      hgnc_id : "HGNC:29884",
      havana_gene : "OTTHUMG00000166025.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 122838500,
      stop : 122872643,
      direction : "+",
      ID : "ENSG00000109943.9",
      gene_id : "ENSG00000109943.9",
      gene_type : "protein_coding",
      gene_name : "CRTAM",
      gene_level : 2,
      hgnc_id : "HGNC:24313",
      havana_gene : "OTTHUMG00000166026.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 122882683,
      stop : 122963862,
      direction : "+",
      ID : "ENSG00000109944.11",
      gene_id : "ENSG00000109944.11",
      gene_type : "protein_coding",
      gene_name : "JHY",
      gene_level : 2,
      hgnc_id : "HGNC:26288",
      havana_gene : "OTTHUMG00000166027.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 122977570,
      stop : 122981834,
      direction : "-",
      ID : "ENSG00000188909.5",
      gene_id : "ENSG00000188909.5",
      gene_type : "protein_coding",
      gene_name : "BSX",
      gene_level : 2,
      hgnc_id : "HGNC:20450",
      havana_gene : "OTTHUMG00000150247.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123057489,
      stop : 123063230,
      direction : "-",
      ID : "ENSG00000109971.14",
      gene_id : "ENSG00000109971.14",
      gene_type : "protein_coding",
      gene_name : "HSPA8",
      gene_level : 1,
      hgnc_id : "HGNC:5241",
      havana_gene : "OTTHUMG00000166030.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123069872,
      stop : 123195248,
      direction : "-",
      ID : "ENSG00000166250.12",
      gene_id : "ENSG00000166250.12",
      gene_type : "protein_coding",
      gene_name : "CLMP",
      gene_level : 1,
      hgnc_id : "HGNC:24039",
      havana_gene : "OTTHUMG00000166031.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123358428,
      stop : 123627774,
      direction : "+",
      ID : "ENSG00000023171.18",
      gene_id : "ENSG00000023171.18",
      gene_type : "protein_coding",
      gene_name : "GRAMD1B",
      gene_level : 2,
      hgnc_id : "HGNC:29214",
      havana_gene : "OTTHUMG00000166004.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123629187,
      stop : 123655244,
      direction : "-",
      ID : "ENSG00000166257.10",
      gene_id : "ENSG00000166257.10",
      gene_type : "protein_coding",
      gene_name : "SCN3B",
      gene_level : 1,
      hgnc_id : "HGNC:20665",
      havana_gene : "OTTHUMG00000166006.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123723914,
      stop : 123741675,
      direction : "-",
      ID : "ENSG00000166261.11",
      gene_id : "ENSG00000166261.11",
      gene_type : "protein_coding",
      gene_name : "ZNF202",
      gene_level : 1,
      hgnc_id : "HGNC:12994",
      havana_gene : "OTTHUMG00000166008.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123753488,
      stop : 123754545,
      direction : "-",
      ID : "ENSG00000221931.2",
      gene_id : "ENSG00000221931.2",
      gene_type : "protein_coding",
      gene_name : "OR6X1",
      gene_level : 2,
      hgnc_id : "HGNC:14737",
      havana_gene : "OTTHUMG00000166011.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123805335,
      stop : 123806387,
      direction : "-",
      ID : "ENSG00000196099.4",
      gene_id : "ENSG00000196099.4",
      gene_type : "protein_coding",
      gene_name : "OR6M1",
      gene_level : 2,
      hgnc_id : "HGNC:14711",
      havana_gene : "OTTHUMG00000166012.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123882920,
      stop : 123885670,
      direction : "-",
      ID : "ENSG00000204300.7",
      gene_id : "ENSG00000204300.7",
      gene_type : "protein_coding",
      gene_name : "TMEM225",
      gene_level : 1,
      hgnc_id : "HGNC:32390",
      havana_gene : "OTTHUMG00000165959.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123902167,
      stop : 123909229,
      direction : "+",
      ID : "ENSG00000181518.4",
      gene_id : "ENSG00000181518.4",
      gene_type : "protein_coding",
      gene_name : "OR8D4",
      gene_level : 2,
      hgnc_id : "HGNC:14840",
      havana_gene : "OTTHUMG00000165960.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123939543,
      stop : 123940637,
      direction : "+",
      ID : "ENSG00000171014.2",
      gene_id : "ENSG00000171014.2",
      gene_type : "protein_coding",
      gene_name : "OR4D5",
      gene_level : 2,
      hgnc_id : "HGNC:14852",
      havana_gene : "OTTHUMG00000165961.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123942785,
      stop : 123943873,
      direction : "-",
      ID : "ENSG00000181499.2",
      gene_id : "ENSG00000181499.2",
      gene_type : "protein_coding",
      gene_name : "OR6T1",
      gene_level : 2,
      hgnc_id : "HGNC:14848",
      havana_gene : "OTTHUMG00000165962.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123976661,
      stop : 123977781,
      direction : "-",
      ID : "ENSG00000196248.5",
      gene_id : "ENSG00000196248.5",
      gene_type : "protein_coding",
      gene_name : "OR10S1",
      gene_level : 2,
      hgnc_id : "HGNC:14807",
      havana_gene : "OTTHUMG00000165963.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 123994163,
      stop : 123995161,
      direction : "-",
      ID : "ENSG00000198674.3",
      gene_id : "ENSG00000198674.3",
      gene_type : "protein_coding",
      gene_name : "OR10G6",
      gene_level : 2,
      hgnc_id : "HGNC:14836",
      havana_gene : "OTTHUMG00000165964.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124012997,
      stop : 124018732,
      direction : "+",
      ID : "ENSG00000254737.2",
      gene_id : "ENSG00000254737.2",
      gene_type : "protein_coding",
      gene_name : "OR10G4",
      gene_level : 2,
      hgnc_id : "HGNC:14809",
      havana_gene : "OTTHUMG00000165966.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124023013,
      stop : 124023948,
      direction : "+",
      ID : "ENSG00000236981.1",
      gene_id : "ENSG00000236981.1",
      gene_type : "protein_coding",
      gene_name : "OR10G9",
      gene_level : 2,
      hgnc_id : "HGNC:15129",
      havana_gene : "OTTHUMG00000165967.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124026798,
      stop : 124030634,
      direction : "+",
      ID : "ENSG00000234560.5",
      gene_id : "ENSG00000234560.5",
      gene_type : "protein_coding",
      gene_name : "OR10G8",
      gene_level : 2,
      hgnc_id : "HGNC:14845",
      havana_gene : "OTTHUMG00000165968.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124036013,
      stop : 124041325,
      direction : "-",
      ID : "ENSG00000182634.9",
      gene_id : "ENSG00000182634.9",
      gene_type : "protein_coding",
      gene_name : "OR10G7",
      gene_level : 2,
      hgnc_id : "HGNC:14842",
      havana_gene : "OTTHUMG00000165969.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124115404,
      stop : 124147721,
      direction : "+",
      ID : "ENSG00000110002.16",
      gene_id : "ENSG00000110002.16",
      gene_type : "protein_coding",
      gene_name : "VWA5A",
      gene_level : 1,
      hgnc_id : "HGNC:6658",
      havana_gene : "OTTHUMG00000165971.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124183219,
      stop : 124188780,
      direction : "+",
      ID : "ENSG00000197309.4",
      gene_id : "ENSG00000197309.4",
      gene_type : "protein_coding",
      gene_name : "OR10D3",
      gene_level : 2,
      hgnc_id : "HGNC:8168",
      havana_gene : "OTTHUMG00000165166.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124241095,
      stop : 124254364,
      direction : "+",
      ID : "ENSG00000197849.6",
      gene_id : "ENSG00000197849.6",
      gene_type : "protein_coding",
      gene_name : "OR8G1",
      gene_level : 2,
      hgnc_id : "HGNC:8484",
      havana_gene : "OTTHUMG00000189223.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124256376,
      stop : 124266218,
      direction : "+",
      ID : "ENSG00000255298.4",
      gene_id : "ENSG00000255298.4",
      gene_type : "protein_coding",
      gene_name : "OR8G5",
      gene_level : 2,
      hgnc_id : "HGNC:19622",
      havana_gene : "OTTHUMG00000186059.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124302831,
      stop : 124315099,
      direction : "-",
      ID : "ENSG00000196341.3",
      gene_id : "ENSG00000196341.3",
      gene_type : "protein_coding",
      gene_name : "OR8D1",
      gene_level : 2,
      hgnc_id : "HGNC:8481",
      havana_gene : "OTTHUMG00000165977.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124319238,
      stop : 124320288,
      direction : "-",
      ID : "ENSG00000279116.2",
      gene_id : "ENSG00000279116.2",
      gene_type : "protein_coding",
      gene_name : "OR8D2",
      gene_level : 2,
      hgnc_id : "HGNC:8482",
      havana_gene : "OTTHUMG00000165978.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124382394,
      stop : 124384499,
      direction : "-",
      ID : "ENSG00000284680.2",
      gene_id : "ENSG00000284680.2",
      gene_type : "protein_coding",
      gene_name : "OR8B2",
      gene_level : 2,
      hgnc_id : "HGNC:8471",
      havana_gene : "OTTHUMG00000165982.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124395534,
      stop : 124399024,
      direction : "-",
      ID : "ENSG00000284609.1",
      gene_id : "ENSG00000284609.1",
      gene_type : "protein_coding",
      gene_name : "OR8B3",
      gene_level : 2,
      hgnc_id : "HGNC:8472",
      havana_gene : "OTTHUMG00000165983.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124423904,
      stop : 124424893,
      direction : "-",
      ID : "ENSG00000280090.2",
      gene_id : "ENSG00000280090.2",
      gene_type : "protein_coding",
      gene_name : "OR8B4",
      gene_level : 2,
      hgnc_id : "HGNC:8473",
      havana_gene : "OTTHUMG00000165916.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124437445,
      stop : 124445696,
      direction : "-",
      ID : "ENSG00000197125.3",
      gene_id : "ENSG00000197125.3",
      gene_type : "protein_coding",
      gene_name : "OR8B8",
      gene_level : 2,
      hgnc_id : "HGNC:8477",
      havana_gene : "OTTHUMG00000165917.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124539635,
      stop : 124545333,
      direction : "-",
      ID : "ENSG00000170953.3",
      gene_id : "ENSG00000170953.3",
      gene_type : "protein_coding",
      gene_name : "OR8B12",
      gene_level : 2,
      hgnc_id : "HGNC:15307",
      havana_gene : "OTTHUMG00000165922.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124566660,
      stop : 124582942,
      direction : "+",
      ID : "ENSG00000196119.8",
      gene_id : "ENSG00000196119.8",
      gene_type : "protein_coding",
      gene_name : "OR8A1",
      gene_level : 2,
      hgnc_id : "HGNC:8469",
      havana_gene : "OTTHUMG00000165923.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124611428,
      stop : 124620356,
      direction : "+",
      ID : "ENSG00000154143.3",
      gene_id : "ENSG00000154143.3",
      gene_type : "protein_coding",
      gene_name : "PANX3",
      gene_level : 2,
      hgnc_id : "HGNC:20573",
      havana_gene : "OTTHUMG00000165925.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124622836,
      stop : 124635926,
      direction : "+",
      ID : "ENSG00000154144.13",
      gene_id : "ENSG00000154144.13",
      gene_type : "protein_coding",
      gene_name : "TBRG1",
      gene_level : 1,
      hgnc_id : "HGNC:29551",
      havana_gene : "OTTHUMG00000153024.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124633113,
      stop : 124695707,
      direction : "-",
      ID : "ENSG00000110013.13",
      gene_id : "ENSG00000110013.13",
      gene_type : "protein_coding",
      gene_name : "SIAE",
      gene_level : 2,
      hgnc_id : "HGNC:18187",
      havana_gene : "OTTHUMG00000165926.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124673844,
      stop : 124697518,
      direction : "+",
      ID : "ENSG00000064199.7",
      gene_id : "ENSG00000064199.7",
      gene_type : "protein_coding",
      gene_name : "SPA17",
      gene_level : 2,
      hgnc_id : "HGNC:11210",
      havana_gene : "OTTHUMG00000165927.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124739942,
      stop : 124747210,
      direction : "+",
      ID : "ENSG00000154146.13",
      gene_id : "ENSG00000154146.13",
      gene_type : "protein_coding",
      gene_name : "NRGN",
      gene_level : 2,
      hgnc_id : "HGNC:8000",
      havana_gene : "OTTHUMG00000165928.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124747474,
      stop : 124752255,
      direction : "-",
      ID : "ENSG00000019102.12",
      gene_id : "ENSG00000019102.12",
      gene_type : "protein_coding",
      gene_name : "VSIG2",
      gene_level : 2,
      hgnc_id : "HGNC:17149",
      havana_gene : "OTTHUMG00000150357.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124752583,
      stop : 124762290,
      direction : "-",
      ID : "ENSG00000149564.12",
      gene_id : "ENSG00000149564.12",
      gene_type : "protein_coding",
      gene_name : "ESAM",
      gene_level : 1,
      hgnc_id : "HGNC:17474",
      havana_gene : "OTTHUMG00000151986.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124766498,
      stop : 124800706,
      direction : "-",
      ID : "ENSG00000120458.13",
      gene_id : "ENSG00000120458.13",
      gene_type : "protein_coding",
      gene_name : "MSANTD2",
      gene_level : 1,
      hgnc_id : "HGNC:26266",
      havana_gene : "OTTHUMG00000165931.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124865432,
      stop : 124881471,
      direction : "+",
      ID : "ENSG00000154134.15",
      gene_id : "ENSG00000154134.15",
      gene_type : "protein_coding",
      gene_name : "ROBO3",
      gene_level : 1,
      hgnc_id : "HGNC:13433",
      havana_gene : "OTTHUMG00000165934.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124883691,
      stop : 124898500,
      direction : "-",
      ID : "ENSG00000154133.15",
      gene_id : "ENSG00000154133.15",
      gene_type : "protein_coding",
      gene_name : "ROBO4",
      gene_level : 2,
      hgnc_id : "HGNC:17985",
      havana_gene : "OTTHUMG00000165936.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124919205,
      stop : 124936412,
      direction : "-",
      ID : "ENSG00000165478.7",
      gene_id : "ENSG00000165478.7",
      gene_type : "protein_coding",
      gene_name : "HEPACAM",
      gene_level : 2,
      hgnc_id : "HGNC:26361",
      havana_gene : "OTTHUMG00000165938.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124919244,
      stop : 124920677,
      direction : "+",
      ID : "ENSG00000221932.6",
      gene_id : "ENSG00000221932.6",
      gene_type : "protein_coding",
      gene_name : "HEPN1",
      gene_level : 2,
      hgnc_id : "HGNC:34400",
      havana_gene : "OTTHUMG00000165939.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 124954121,
      stop : 125041489,
      direction : "+",
      ID : "ENSG00000149548.15",
      gene_id : "ENSG00000149548.15",
      gene_type : "protein_coding",
      gene_name : "CCDC15",
      gene_level : 1,
      hgnc_id : "HGNC:25798",
      havana_gene : "OTTHUMG00000165940.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125063302,
      stop : 125090516,
      direction : "+",
      ID : "ENSG00000134955.12",
      gene_id : "ENSG00000134955.12",
      gene_type : "protein_coding",
      gene_name : "SLC37A2",
      gene_level : 2,
      hgnc_id : "HGNC:20644",
      havana_gene : "OTTHUMG00000165879.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125096545,
      stop : 125111763,
      direction : "-",
      ID : "ENSG00000150433.9",
      gene_id : "ENSG00000150433.9",
      gene_type : "protein_coding",
      gene_name : "TMEM218",
      gene_level : 1,
      hgnc_id : "HGNC:27344",
      havana_gene : "OTTHUMG00000165880.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125164687,
      stop : 125433389,
      direction : "+",
      ID : "ENSG00000165495.16",
      gene_id : "ENSG00000165495.16",
      gene_type : "protein_coding",
      gene_name : "PKNOX2",
      gene_level : 2,
      hgnc_id : "HGNC:16714",
      havana_gene : "OTTHUMG00000165884.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125442881,
      stop : 125592568,
      direction : "-",
      ID : "ENSG00000149557.14",
      gene_id : "ENSG00000149557.14",
      gene_type : "protein_coding",
      gene_name : "FEZ1",
      gene_level : 1,
      hgnc_id : "HGNC:3659",
      havana_gene : "OTTHUMG00000165886.8",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125569280,
      stop : 125584684,
      direction : "+",
      ID : "ENSG00000149547.15",
      gene_id : "ENSG00000149547.15",
      gene_type : "protein_coding",
      gene_name : "EI24",
      gene_level : 1,
      hgnc_id : "HGNC:13276",
      havana_gene : "OTTHUMG00000165851.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125591712,
      stop : 125625215,
      direction : "+",
      ID : "ENSG00000134910.14",
      gene_id : "ENSG00000134910.14",
      gene_type : "protein_coding",
      gene_name : "STT3A",
      gene_level : 1,
      hgnc_id : "HGNC:6172",
      havana_gene : "OTTHUMG00000165852.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125625665,
      stop : 125676255,
      direction : "+",
      ID : "ENSG00000149554.13",
      gene_id : "ENSG00000149554.13",
      gene_type : "protein_coding",
      gene_name : "CHEK1",
      gene_level : 2,
      hgnc_id : "HGNC:1925",
      havana_gene : "OTTHUMG00000165853.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125671522,
      stop : 125680874,
      direction : "-",
      ID : "ENSG00000134940.14",
      gene_id : "ENSG00000134940.14",
      gene_type : "protein_coding",
      gene_name : "ACRV1",
      gene_level : 2,
      hgnc_id : "HGNC:127",
      havana_gene : "OTTHUMG00000165854.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125746279,
      stop : 125749867,
      direction : "+",
      ID : "ENSG00000171053.10",
      gene_id : "ENSG00000171053.10",
      gene_type : "protein_coding",
      gene_name : "PATE1",
      gene_level : 2,
      hgnc_id : "HGNC:24664",
      havana_gene : "OTTHUMG00000165855.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125776113,
      stop : 125778828,
      direction : "-",
      ID : "ENSG00000196844.9",
      gene_id : "ENSG00000196844.9",
      gene_type : "protein_coding",
      gene_name : "PATE2",
      gene_level : 2,
      hgnc_id : "HGNC:32249",
      havana_gene : "OTTHUMG00000165856.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125788127,
      stop : 125791600,
      direction : "+",
      ID : "ENSG00000236027.3",
      gene_id : "ENSG00000236027.3",
      gene_type : "protein_coding",
      gene_name : "PATE3",
      gene_level : 2,
      hgnc_id : "HGNC:35426",
      havana_gene : "OTTHUMG00000165857.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125833316,
      stop : 125840072,
      direction : "+",
      ID : "ENSG00000237353.7",
      gene_id : "ENSG00000237353.7",
      gene_type : "protein_coding",
      gene_name : "PATE4",
      gene_level : 1,
      hgnc_id : "HGNC:35427",
      havana_gene : "OTTHUMG00000165235.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125883614,
      stop : 125900646,
      direction : "+",
      ID : "ENSG00000198331.11",
      gene_id : "ENSG00000198331.11",
      gene_type : "protein_coding",
      gene_name : "HYLS1",
      gene_level : 2,
      hgnc_id : "HGNC:26558",
      havana_gene : "OTTHUMG00000165858.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125893485,
      stop : 125903221,
      direction : "-",
      ID : "ENSG00000110060.9",
      gene_id : "ENSG00000110060.9",
      gene_type : "protein_coding",
      gene_name : "PUS3",
      gene_level : 2,
      hgnc_id : "HGNC:25461",
      havana_gene : "OTTHUMG00000165870.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125903348,
      stop : 125943702,
      direction : "+",
      ID : "ENSG00000109832.14",
      gene_id : "ENSG00000109832.14",
      gene_type : "protein_coding",
      gene_name : "DDX25",
      gene_level : 1,
      hgnc_id : "HGNC:18698",
      havana_gene : "OTTHUMG00000165859.9",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125946056,
      stop : 125958647,
      direction : "+",
      ID : "ENSG00000283703.2",
      gene_id : "ENSG00000283703.2",
      gene_type : "protein_coding",
      gene_name : "VSIG10L2",
      gene_level : 2,
      hgnc_id : "HGNC:27879",
      havana_gene : "OTTHUMG00000165861.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 125955796,
      stop : 126063335,
      direction : "-",
      ID : "ENSG00000064309.15",
      gene_id : "ENSG00000064309.15",
      gene_type : "protein_coding",
      gene_name : "CDON",
      gene_level : 2,
      hgnc_id : "HGNC:17104",
      havana_gene : "OTTHUMG00000165862.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126202096,
      stop : 126211692,
      direction : "-",
      ID : "ENSG00000165526.9",
      gene_id : "ENSG00000165526.9",
      gene_type : "protein_coding",
      gene_name : "RPUSD4",
      gene_level : 2,
      hgnc_id : "HGNC:25898",
      havana_gene : "OTTHUMG00000165815.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126211724,
      stop : 126262984,
      direction : "+",
      ID : "ENSG00000197798.9",
      gene_id : "ENSG00000197798.9",
      gene_type : "protein_coding",
      gene_name : "FAM118B",
      gene_level : 1,
      hgnc_id : "HGNC:26110",
      havana_gene : "OTTHUMG00000165817.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126262938,
      stop : 126269144,
      direction : "-",
      ID : "ENSG00000182934.12",
      gene_id : "ENSG00000182934.12",
      gene_type : "protein_coding",
      gene_name : "SRPRA",
      gene_level : 1,
      hgnc_id : "HGNC:11307",
      havana_gene : "OTTHUMG00000165826.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126269055,
      stop : 126278131,
      direction : "+",
      ID : "ENSG00000110074.11",
      gene_id : "ENSG00000110074.11",
      gene_type : "protein_coding",
      gene_name : "FOXRED1",
      gene_level : 2,
      hgnc_id : "HGNC:26927",
      havana_gene : "OTTHUMG00000165827.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126283065,
      stop : 126298845,
      direction : "+",
      ID : "ENSG00000150455.14",
      gene_id : "ENSG00000150455.14",
      gene_type : "protein_coding",
      gene_name : "TIRAP",
      gene_level : 1,
      hgnc_id : "HGNC:17192",
      havana_gene : "OTTHUMG00000140373.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126304060,
      stop : 126350005,
      direction : "+",
      ID : "ENSG00000110063.10",
      gene_id : "ENSG00000110063.10",
      gene_type : "protein_coding",
      gene_name : "DCPS",
      gene_level : 2,
      hgnc_id : "HGNC:29812",
      havana_gene : "OTTHUMG00000165829.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126355640,
      stop : 126440344,
      direction : "+",
      ID : "ENSG00000110080.20",
      gene_id : "ENSG00000110080.20",
      gene_type : "protein_coding",
      gene_name : "ST3GAL4",
      gene_level : 1,
      hgnc_id : "HGNC:10864",
      havana_gene : "OTTHUMG00000165830.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 126423358,
      stop : 127003460,
      direction : "-",
      ID : "ENSG00000149571.12",
      gene_id : "ENSG00000149571.12",
      gene_type : "protein_coding",
      gene_name : "KIRREL3",
      gene_level : 2,
      hgnc_id : "HGNC:23204",
      havana_gene : "OTTHUMG00000165831.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128458761,
      stop : 128587558,
      direction : "-",
      ID : "ENSG00000134954.14",
      gene_id : "ENSG00000134954.14",
      gene_type : "protein_coding",
      gene_name : "ETS1",
      gene_level : 1,
      hgnc_id : "HGNC:3488",
      havana_gene : "OTTHUMG00000165799.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128686535,
      stop : 128813267,
      direction : "+",
      ID : "ENSG00000151702.17",
      gene_id : "ENSG00000151702.17",
      gene_type : "protein_coding",
      gene_name : "FLI1",
      gene_level : 1,
      hgnc_id : "HGNC:3749",
      havana_gene : "OTTHUMG00000165792.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128836315,
      stop : 128867373,
      direction : "-",
      ID : "ENSG00000151704.16",
      gene_id : "ENSG00000151704.16",
      gene_type : "protein_coding",
      gene_name : "KCNJ1",
      gene_level : 1,
      hgnc_id : "HGNC:6255",
      havana_gene : "OTTHUMG00000048247.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128891356,
      stop : 128921163,
      direction : "+",
      ID : "ENSG00000120457.12",
      gene_id : "ENSG00000120457.12",
      gene_type : "protein_coding",
      gene_name : "KCNJ5",
      gene_level : 1,
      hgnc_id : "HGNC:6266",
      havana_gene : "OTTHUMG00000165795.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128899565,
      stop : 128906035,
      direction : "-",
      ID : "ENSG00000174370.11",
      gene_id : "ENSG00000174370.11",
      gene_type : "protein_coding",
      gene_name : "C11orf45",
      gene_level : 1,
      hgnc_id : "HGNC:28584",
      havana_gene : "OTTHUMG00000165796.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128934731,
      stop : 128943399,
      direction : "-",
      ID : "ENSG00000120471.16",
      gene_id : "ENSG00000120471.16",
      gene_type : "protein_coding",
      gene_name : "TP53AIP1",
      gene_level : 2,
      hgnc_id : "HGNC:29984",
      havana_gene : "OTTHUMG00000165797.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 128965060,
      stop : 129279324,
      direction : "-",
      ID : "ENSG00000134909.18",
      gene_id : "ENSG00000134909.18",
      gene_type : "protein_coding",
      gene_name : "ARHGAP32",
      gene_level : 1,
      hgnc_id : "HGNC:17399",
      havana_gene : "OTTHUMG00000165774.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 129375848,
      stop : 129452279,
      direction : "+",
      ID : "ENSG00000043039.7",
      gene_id : "ENSG00000043039.7",
      gene_type : "protein_coding",
      gene_name : "BARX2",
      gene_level : 2,
      hgnc_id : "HGNC:956",
      havana_gene : "OTTHUMG00000165776.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 129815848,
      stop : 129860003,
      direction : "+",
      ID : "ENSG00000151715.8",
      gene_id : "ENSG00000151715.8",
      gene_type : "protein_coding",
      gene_name : "TMEM45B",
      gene_level : 1,
      hgnc_id : "HGNC:25194",
      havana_gene : "OTTHUMG00000165760.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 129863636,
      stop : 129895590,
      direction : "-",
      ID : "ENSG00000170322.14",
      gene_id : "ENSG00000170322.14",
      gene_type : "protein_coding",
      gene_name : "NFRKB",
      gene_level : 2,
      hgnc_id : "HGNC:7802",
      havana_gene : "OTTHUMG00000165761.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 129899706,
      stop : 130002835,
      direction : "-",
      ID : "ENSG00000170325.16",
      gene_id : "ENSG00000170325.16",
      gene_type : "protein_coding",
      gene_name : "PRDM10",
      gene_level : 1,
      hgnc_id : "HGNC:13995",
      havana_gene : "OTTHUMG00000165762.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 130068147,
      stop : 130144811,
      direction : "+",
      ID : "ENSG00000084234.18",
      gene_id : "ENSG00000084234.18",
      gene_type : "protein_coding",
      gene_name : "APLP2",
      gene_level : 1,
      hgnc_id : "HGNC:598",
      havana_gene : "OTTHUMG00000165767.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 130159782,
      stop : 130210362,
      direction : "+",
      ID : "ENSG00000149418.11",
      gene_id : "ENSG00000149418.11",
      gene_type : "protein_coding",
      gene_name : "ST14",
      gene_level : 2,
      hgnc_id : "HGNC:11344",
      havana_gene : "OTTHUMG00000165768.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 130226677,
      stop : 130314917,
      direction : "-",
      ID : "ENSG00000196323.14",
      gene_id : "ENSG00000196323.14",
      gene_type : "protein_coding",
      gene_name : "ZBTB44",
      gene_level : 1,
      hgnc_id : "HGNC:25001",
      havana_gene : "OTTHUMG00000165769.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 130404923,
      stop : 130428609,
      direction : "-",
      ID : "ENSG00000134917.10",
      gene_id : "ENSG00000134917.10",
      gene_type : "protein_coding",
      gene_name : "ADAMTS8",
      gene_level : 2,
      hgnc_id : "HGNC:224",
      havana_gene : "OTTHUMG00000165656.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 130448974,
      stop : 130476641,
      direction : "+",
      ID : "ENSG00000166106.3",
      gene_id : "ENSG00000166106.3",
      gene_type : "protein_coding",
      gene_name : "ADAMTS15",
      gene_level : 2,
      hgnc_id : "HGNC:16305",
      havana_gene : "OTTHUMG00000165657.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 130866250,
      stop : 130916479,
      direction : "-",
      ID : "ENSG00000120451.11",
      gene_id : "ENSG00000120451.11",
      gene_type : "protein_coding",
      gene_name : "SNX19",
      gene_level : 2,
      hgnc_id : "HGNC:21532",
      havana_gene : "OTTHUMG00000165663.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 131370478,
      stop : 132336822,
      direction : "+",
      ID : "ENSG00000182667.14",
      gene_id : "ENSG00000182667.14",
      gene_type : "protein_coding",
      gene_name : "NTM",
      gene_level : 1,
      hgnc_id : "HGNC:17941",
      havana_gene : "OTTHUMG00000066364.16",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 132414977,
      stop : 133532519,
      direction : "-",
      ID : "ENSG00000183715.13",
      gene_id : "ENSG00000183715.13",
      gene_type : "protein_coding",
      gene_name : "OPCML",
      gene_level : 2,
      hgnc_id : "HGNC:8143",
      havana_gene : "OTTHUMG00000163658.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 133840631,
      stop : 133845538,
      direction : "-",
      ID : "ENSG00000166118.8",
      gene_id : "ENSG00000166118.8",
      gene_type : "protein_coding",
      gene_name : "SPATA19",
      gene_level : 2,
      hgnc_id : "HGNC:30614",
      havana_gene : "OTTHUMG00000167120.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 133896438,
      stop : 133956968,
      direction : "-",
      ID : "ENSG00000080854.16",
      gene_id : "ENSG00000080854.16",
      gene_type : "protein_coding",
      gene_name : "IGSF9B",
      gene_level : 1,
      hgnc_id : "HGNC:32326",
      havana_gene : "OTTHUMG00000167124.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134069071,
      stop : 134152001,
      direction : "+",
      ID : "ENSG00000166086.13",
      gene_id : "ENSG00000166086.13",
      gene_type : "protein_coding",
      gene_name : "JAM3",
      gene_level : 1,
      hgnc_id : "HGNC:15532",
      havana_gene : "OTTHUMG00000167130.7",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134150113,
      stop : 134225454,
      direction : "-",
      ID : "ENSG00000151503.13",
      gene_id : "ENSG00000151503.13",
      gene_type : "protein_coding",
      gene_name : "NCAPD3",
      gene_level : 1,
      hgnc_id : "HGNC:28952",
      havana_gene : "OTTHUMG00000167172.6",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134224671,
      stop : 134247788,
      direction : "+",
      ID : "ENSG00000151502.11",
      gene_id : "ENSG00000151502.11",
      gene_type : "protein_coding",
      gene_name : "VPS26B",
      gene_level : 2,
      hgnc_id : "HGNC:28119",
      havana_gene : "OTTHUMG00000167175.5",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134248279,
      stop : 134253370,
      direction : "-",
      ID : "ENSG00000151500.15",
      gene_id : "ENSG00000151500.15",
      gene_type : "protein_coding",
      gene_name : "THYN1",
      gene_level : 2,
      hgnc_id : "HGNC:29560",
      havana_gene : "OTTHUMG00000167176.2",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134253548,
      stop : 134265855,
      direction : "+",
      ID : "ENSG00000151498.12",
      gene_id : "ENSG00000151498.12",
      gene_type : "protein_coding",
      gene_name : "ACAD8",
      gene_level : 2,
      hgnc_id : "HGNC:87",
      havana_gene : "OTTHUMG00000167177.1",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134274245,
      stop : 134319564,
      direction : "+",
      ID : "ENSG00000166105.16",
      gene_id : "ENSG00000166105.16",
      gene_type : "protein_coding",
      gene_name : "GLB1L3",
      gene_level : 2,
      hgnc_id : "HGNC:25147",
      havana_gene : "OTTHUMG00000133524.4",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134331874,
      stop : 134378341,
      direction : "+",
      ID : "ENSG00000149328.15",
      gene_id : "ENSG00000149328.15",
      gene_type : "protein_coding",
      gene_name : "GLB1L2",
      gene_level : 2,
      hgnc_id : "HGNC:25129",
      havana_gene : "OTTHUMG00000167179.3",
      tag : null
    },
    {
      chromosome : 11,
      annotation : "HAVANA",
      type : "gene",
      start : 134378504,
      stop : 134412242,
      direction : "-",
      ID : "ENSG00000109956.13",
      gene_id : "ENSG00000109956.13",
      gene_type : "protein_coding",
      gene_name : "B3GAT1",
      gene_level : 2,
      hgnc_id : "HGNC:921",
      havana_gene : "OTTHUMG00000167180.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66767,
      stop : 178455,
      direction : "+",
      ID : "ENSG00000120645.12",
      gene_id : "ENSG00000120645.12",
      gene_type : "protein_coding",
      gene_name : "IQSEC3",
      gene_level : 1,
      hgnc_id : "HGNC:29193",
      havana_gene : "OTTHUMG00000167975.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 190077,
      stop : 214570,
      direction : "-",
      ID : "ENSG00000111181.12",
      gene_id : "ENSG00000111181.12",
      gene_type : "protein_coding",
      gene_name : "SLC6A12",
      gene_level : 2,
      hgnc_id : "HGNC:11045",
      havana_gene : "OTTHUMG00000090309.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 220621,
      stop : 262873,
      direction : "-",
      ID : "ENSG00000010379.16",
      gene_id : "ENSG00000010379.16",
      gene_type : "protein_coding",
      gene_name : "SLC6A13",
      gene_level : 2,
      hgnc_id : "HGNC:11046",
      havana_gene : "OTTHUMG00000168053.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 280057,
      stop : 389320,
      direction : "-",
      ID : "ENSG00000073614.13",
      gene_id : "ENSG00000073614.13",
      gene_type : "protein_coding",
      gene_name : "KDM5A",
      gene_level : 2,
      hgnc_id : "HGNC:9886",
      havana_gene : "OTTHUMG00000168055.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 389273,
      stop : 442642,
      direction : "+",
      ID : "ENSG00000120647.10",
      gene_id : "ENSG00000120647.10",
      gene_type : "protein_coding",
      gene_name : "CCDC77",
      gene_level : 1,
      hgnc_id : "HGNC:28203",
      havana_gene : "OTTHUMG00000129214.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 459939,
      stop : 563509,
      direction : "+",
      ID : "ENSG00000139044.12",
      gene_id : "ENSG00000139044.12",
      gene_type : "protein_coding",
      gene_name : "B4GALNT3",
      gene_level : 1,
      hgnc_id : "HGNC:24137",
      havana_gene : "OTTHUMG00000129283.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 564296,
      stop : 663779,
      direction : "-",
      ID : "ENSG00000171840.12",
      gene_id : "ENSG00000171840.12",
      gene_type : "protein_coding",
      gene_name : "NINJ2",
      gene_level : 2,
      hgnc_id : "HGNC:7825",
      havana_gene : "OTTHUMG00000090311.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 752579,
      stop : 911452,
      direction : "+",
      ID : "ENSG00000060237.19",
      gene_id : "ENSG00000060237.19",
      gene_type : "protein_coding",
      gene_name : "WNK1",
      gene_level : 1,
      hgnc_id : "HGNC:14540",
      havana_gene : "OTTHUMG00000090321.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 911736,
      stop : 990053,
      direction : "-",
      ID : "ENSG00000002016.18",
      gene_id : "ENSG00000002016.18",
      gene_type : "protein_coding",
      gene_name : "RAD52",
      gene_level : 2,
      hgnc_id : "HGNC:9824",
      havana_gene : "OTTHUMG00000090361.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 990509,
      stop : 1495933,
      direction : "+",
      ID : "ENSG00000082805.20",
      gene_id : "ENSG00000082805.20",
      gene_type : "protein_coding",
      gene_name : "ERC1",
      gene_level : 1,
      hgnc_id : "HGNC:17072",
      havana_gene : "OTTHUMG00000130138.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1529891,
      stop : 1647212,
      direction : "+",
      ID : "ENSG00000111186.13",
      gene_id : "ENSG00000111186.13",
      gene_type : "protein_coding",
      gene_name : "WNT5B",
      gene_level : 1,
      hgnc_id : "HGNC:16265",
      havana_gene : "OTTHUMG00000090375.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1565993,
      stop : 1594581,
      direction : "-",
      ID : "ENSG00000171823.7",
      gene_id : "ENSG00000171823.7",
      gene_type : "protein_coding",
      gene_name : "FBXL14",
      gene_level : 2,
      hgnc_id : "HGNC:28624",
      havana_gene : "OTTHUMG00000090369.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1688574,
      stop : 1788674,
      direction : "+",
      ID : "ENSG00000006831.10",
      gene_id : "ENSG00000006831.10",
      gene_type : "protein_coding",
      gene_name : "ADIPOR2",
      gene_level : 1,
      hgnc_id : "HGNC:24041",
      havana_gene : "OTTHUMG00000130139.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1791963,
      stop : 1918666,
      direction : "-",
      ID : "ENSG00000151062.15",
      gene_id : "ENSG00000151062.15",
      gene_type : "protein_coding",
      gene_name : "CACNA2D4",
      gene_level : 2,
      hgnc_id : "HGNC:20202",
      havana_gene : "OTTHUMG00000168111.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1820267,
      stop : 1836753,
      direction : "+",
      ID : "ENSG00000166159.11",
      gene_id : "ENSG00000166159.11",
      gene_type : "protein_coding",
      gene_name : "LRTM2",
      gene_level : 2,
      hgnc_id : "HGNC:32443",
      havana_gene : "OTTHUMG00000168088.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1946053,
      stop : 2004535,
      direction : "-",
      ID : "ENSG00000151065.14",
      gene_id : "ENSG00000151065.14",
      gene_type : "protein_coding",
      gene_name : "DCP1B",
      gene_level : 1,
      hgnc_id : "HGNC:24451",
      havana_gene : "OTTHUMG00000168113.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 1970786,
      stop : 2697950,
      direction : "+",
      ID : "ENSG00000151067.22",
      gene_id : "ENSG00000151067.22",
      gene_type : "protein_coding",
      gene_name : "CACNA1C",
      gene_level : 2,
      hgnc_id : "HGNC:1390",
      havana_gene : "OTTHUMG00000150243.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2794970,
      stop : 2805423,
      direction : "+",
      ID : "ENSG00000004478.8",
      gene_id : "ENSG00000004478.8",
      gene_type : "protein_coding",
      gene_name : "FKBP4",
      gene_level : 2,
      hgnc_id : "HGNC:3720",
      havana_gene : "OTTHUMG00000090429.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2812622,
      stop : 2859791,
      direction : "+",
      ID : "ENSG00000111203.13",
      gene_id : "ENSG00000111203.13",
      gene_type : "protein_coding",
      gene_name : "ITFG2",
      gene_level : 2,
      hgnc_id : "HGNC:30879",
      havana_gene : "OTTHUMG00000130617.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2825348,
      stop : 2835544,
      direction : "-",
      ID : "ENSG00000053702.15",
      gene_id : "ENSG00000053702.15",
      gene_type : "protein_coding",
      gene_name : "NRIP2",
      gene_level : 2,
      hgnc_id : "HGNC:23078",
      havana_gene : "OTTHUMG00000130616.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2849046,
      stop : 2857039,
      direction : "-",
      ID : "ENSG00000283297.2",
      gene_id : "ENSG00000283297.2",
      gene_type : "protein_coding",
      gene_name : "TEX52",
      gene_level : 2,
      hgnc_id : "HGNC:53643",
      havana_gene : "OTTHUMG00000191716.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2857680,
      stop : 2877174,
      direction : "-",
      ID : "ENSG00000111206.13",
      gene_id : "ENSG00000111206.13",
      gene_type : "protein_coding",
      gene_name : "FOXM1",
      gene_level : 2,
      hgnc_id : "HGNC:3818",
      havana_gene : "OTTHUMG00000168118.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2876258,
      stop : 2889524,
      direction : "+",
      ID : "ENSG00000171792.11",
      gene_id : "ENSG00000171792.11",
      gene_type : "protein_coding",
      gene_name : "RHNO1",
      gene_level : 1,
      hgnc_id : "HGNC:28206",
      havana_gene : "OTTHUMG00000158557.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2877223,
      stop : 2941138,
      direction : "+",
      ID : "ENSG00000078246.17",
      gene_id : "ENSG00000078246.17",
      gene_type : "protein_coding",
      gene_name : "TULP3",
      gene_level : 1,
      hgnc_id : "HGNC:12425",
      havana_gene : "OTTHUMG00000168152.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 2959330,
      stop : 3040676,
      direction : "+",
      ID : "ENSG00000197905.10",
      gene_id : "ENSG00000197905.10",
      gene_type : "protein_coding",
      gene_name : "TEAD4",
      gene_level : 2,
      hgnc_id : "HGNC:11717",
      havana_gene : "OTTHUMG00000168153.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 3077355,
      stop : 3286564,
      direction : "+",
      ID : "ENSG00000011105.14",
      gene_id : "ENSG00000011105.14",
      gene_type : "protein_coding",
      gene_name : "TSPAN9",
      gene_level : 2,
      hgnc_id : "HGNC:21640",
      havana_gene : "OTTHUMG00000150333.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 3381349,
      stop : 3593973,
      direction : "+",
      ID : "ENSG00000111218.12",
      gene_id : "ENSG00000111218.12",
      gene_type : "protein_coding",
      gene_name : "PRMT8",
      gene_level : 2,
      hgnc_id : "HGNC:5188",
      havana_gene : "OTTHUMG00000128493.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 3606633,
      stop : 3764819,
      direction : "-",
      ID : "ENSG00000130038.10",
      gene_id : "ENSG00000130038.10",
      gene_type : "protein_coding",
      gene_name : "CRACR2A",
      gene_level : 2,
      hgnc_id : "HGNC:28657",
      havana_gene : "OTTHUMG00000168185.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 3791047,
      stop : 3873448,
      direction : "-",
      ID : "ENSG00000111224.14",
      gene_id : "ENSG00000111224.14",
      gene_type : "protein_coding",
      gene_name : "PARP11",
      gene_level : 2,
      hgnc_id : "HGNC:1186",
      havana_gene : "OTTHUMG00000156442.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4269771,
      stop : 4305353,
      direction : "+",
      ID : "ENSG00000118971.9",
      gene_id : "ENSG00000118971.9",
      gene_type : "protein_coding",
      gene_name : "CCND2",
      gene_level : 1,
      hgnc_id : "HGNC:1583",
      havana_gene : "OTTHUMG00000168123.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4273762,
      stop : 4405490,
      direction : "+",
      ID : "ENSG00000285901.2",
      gene_id : "ENSG00000285901.2",
      gene_type : "protein_coding",
      gene_name : "AC008012.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193358.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4307763,
      stop : 4360028,
      direction : "+",
      ID : "ENSG00000078237.7",
      gene_id : "ENSG00000078237.7",
      gene_type : "protein_coding",
      gene_name : "TIGAR",
      gene_level : 2,
      hgnc_id : "HGNC:1185",
      havana_gene : "OTTHUMG00000168124.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4368227,
      stop : 4379712,
      direction : "-",
      ID : "ENSG00000118972.3",
      gene_id : "ENSG00000118972.3",
      gene_type : "protein_coding",
      gene_name : "FGF23",
      gene_level : 2,
      hgnc_id : "HGNC:3680",
      havana_gene : "OTTHUMG00000168241.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4428155,
      stop : 4445614,
      direction : "-",
      ID : "ENSG00000111241.2",
      gene_id : "ENSG00000111241.2",
      gene_type : "protein_coding",
      gene_name : "FGF6",
      gene_level : 1,
      hgnc_id : "HGNC:3684",
      havana_gene : "OTTHUMG00000168242.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4487735,
      stop : 4538508,
      direction : "-",
      ID : "ENSG00000047621.12",
      gene_id : "ENSG00000047621.12",
      gene_type : "protein_coding",
      gene_name : "C12orf4",
      gene_level : 2,
      hgnc_id : "HGNC:1184",
      havana_gene : "OTTHUMG00000168258.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4538798,
      stop : 4560047,
      direction : "+",
      ID : "ENSG00000111247.15",
      gene_id : "ENSG00000111247.15",
      gene_type : "protein_coding",
      gene_name : "RAD51AP1",
      gene_level : 1,
      hgnc_id : "HGNC:16956",
      havana_gene : "OTTHUMG00000168125.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4562204,
      stop : 4615302,
      direction : "+",
      ID : "ENSG00000010219.13",
      gene_id : "ENSG00000010219.13",
      gene_type : "protein_coding",
      gene_name : "DYRK4",
      gene_level : 2,
      hgnc_id : "HGNC:3095",
      havana_gene : "OTTHUMG00000168204.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4604944,
      stop : 4662643,
      direction : "+",
      ID : "ENSG00000272921.1",
      gene_id : "ENSG00000272921.1",
      gene_type : "protein_coding",
      gene_name : "AC005832.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186348.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4615508,
      stop : 4649051,
      direction : "-",
      ID : "ENSG00000111254.8",
      gene_id : "ENSG00000111254.8",
      gene_type : "protein_coding",
      gene_name : "AKAP3",
      gene_level : 1,
      hgnc_id : "HGNC:373",
      havana_gene : "OTTHUMG00000168226.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4649095,
      stop : 4694317,
      direction : "+",
      ID : "ENSG00000139180.11",
      gene_id : "ENSG00000139180.11",
      gene_type : "protein_coding",
      gene_name : "NDUFA9",
      gene_level : 1,
      hgnc_id : "HGNC:7693",
      havana_gene : "OTTHUMG00000168224.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4649101,
      stop : 4774184,
      direction : "+",
      ID : "ENSG00000255639.3",
      gene_id : "ENSG00000255639.3",
      gene_type : "protein_coding",
      gene_name : "AC005833.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168352.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4720400,
      stop : 4851927,
      direction : "+",
      ID : "ENSG00000130035.9",
      gene_id : "ENSG00000130035.9",
      gene_type : "protein_coding",
      gene_name : "GALNT8",
      gene_level : 1,
      hgnc_id : "HGNC:4130",
      havana_gene : "OTTHUMG00000166188.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4809176,
      stop : 4813412,
      direction : "+",
      ID : "ENSG00000151079.7",
      gene_id : "ENSG00000151079.7",
      gene_type : "protein_coding",
      gene_name : "KCNA6",
      gene_level : 2,
      hgnc_id : "HGNC:6225",
      havana_gene : "OTTHUMG00000168225.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 4909905,
      stop : 4918256,
      direction : "+",
      ID : "ENSG00000111262.6",
      gene_id : "ENSG00000111262.6",
      gene_type : "protein_coding",
      gene_name : "KCNA1",
      gene_level : 2,
      hgnc_id : "HGNC:6218",
      havana_gene : "OTTHUMG00000044398.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 5043879,
      stop : 5046788,
      direction : "+",
      ID : "ENSG00000130037.5",
      gene_id : "ENSG00000130037.5",
      gene_type : "protein_coding",
      gene_name : "KCNA5",
      gene_level : 2,
      hgnc_id : "HGNC:6224",
      havana_gene : "OTTHUMG00000168232.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 5432108,
      stop : 5521536,
      direction : "+",
      ID : "ENSG00000185652.12",
      gene_id : "ENSG00000185652.12",
      gene_type : "protein_coding",
      gene_name : "NTF3",
      gene_level : 1,
      hgnc_id : "HGNC:8023",
      havana_gene : "OTTHUMG00000168649.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 5531869,
      stop : 5946232,
      direction : "-",
      ID : "ENSG00000047617.15",
      gene_id : "ENSG00000047617.15",
      gene_type : "protein_coding",
      gene_name : "ANO2",
      gene_level : 1,
      hgnc_id : "HGNC:1183",
      havana_gene : "OTTHUMG00000168264.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 5948877,
      stop : 6124770,
      direction : "-",
      ID : "ENSG00000110799.14",
      gene_id : "ENSG00000110799.14",
      gene_type : "protein_coding",
      gene_name : "VWF",
      gene_level : 2,
      hgnc_id : "HGNC:12726",
      havana_gene : "OTTHUMG00000168265.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6199715,
      stop : 6238271,
      direction : "+",
      ID : "ENSG00000010278.15",
      gene_id : "ENSG00000010278.15",
      gene_type : "protein_coding",
      gene_name : "CD9",
      gene_level : 1,
      hgnc_id : "HGNC:1709",
      havana_gene : "OTTHUMG00000044400.14",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6310436,
      stop : 6328506,
      direction : "+",
      ID : "ENSG00000008323.15",
      gene_id : "ENSG00000008323.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHG6",
      gene_level : 2,
      hgnc_id : "HGNC:25562",
      havana_gene : "OTTHUMG00000168266.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6328757,
      stop : 6342114,
      direction : "-",
      ID : "ENSG00000067182.8",
      gene_id : "ENSG00000067182.8",
      gene_type : "protein_coding",
      gene_name : "TNFRSF1A",
      gene_level : 1,
      hgnc_id : "HGNC:11916",
      havana_gene : "OTTHUMG00000168267.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6346843,
      stop : 6377730,
      direction : "-",
      ID : "ENSG00000111319.13",
      gene_id : "ENSG00000111319.13",
      gene_type : "protein_coding",
      gene_name : "SCNN1A",
      gene_level : 1,
      hgnc_id : "HGNC:10599",
      havana_gene : "OTTHUMG00000168268.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6375045,
      stop : 6391571,
      direction : "+",
      ID : "ENSG00000111321.11",
      gene_id : "ENSG00000111321.11",
      gene_type : "protein_coding",
      gene_name : "LTBR",
      gene_level : 1,
      hgnc_id : "HGNC:6718",
      havana_gene : "OTTHUMG00000168356.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6444955,
      stop : 6451718,
      direction : "+",
      ID : "ENSG00000139193.4",
      gene_id : "ENSG00000139193.4",
      gene_type : "protein_coding",
      gene_name : "CD27",
      gene_level : 2,
      hgnc_id : "HGNC:11922",
      havana_gene : "OTTHUMG00000168316.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6451690,
      stop : 6466517,
      direction : "+",
      ID : "ENSG00000139192.12",
      gene_id : "ENSG00000139192.12",
      gene_type : "protein_coding",
      gene_name : "TAPBPL",
      gene_level : 1,
      hgnc_id : "HGNC:30683",
      havana_gene : "OTTHUMG00000168317.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6462237,
      stop : 6470677,
      direction : "-",
      ID : "ENSG00000139190.17",
      gene_id : "ENSG00000139190.17",
      gene_type : "protein_coding",
      gene_name : "VAMP1",
      gene_level : 1,
      hgnc_id : "HGNC:12642",
      havana_gene : "OTTHUMG00000168269.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6491886,
      stop : 6493841,
      direction : "-",
      ID : "ENSG00000111639.8",
      gene_id : "ENSG00000111639.8",
      gene_type : "protein_coding",
      gene_name : "MRPL51",
      gene_level : 1,
      hgnc_id : "HGNC:14044",
      havana_gene : "OTTHUMG00000168512.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6493356,
      stop : 6531955,
      direction : "+",
      ID : "ENSG00000010292.13",
      gene_id : "ENSG00000010292.13",
      gene_type : "protein_coding",
      gene_name : "NCAPD2",
      gene_level : 1,
      hgnc_id : "HGNC:24305",
      havana_gene : "OTTHUMG00000168513.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6534512,
      stop : 6538374,
      direction : "+",
      ID : "ENSG00000111640.15",
      gene_id : "ENSG00000111640.15",
      gene_type : "protein_coding",
      gene_name : "GAPDH",
      gene_level : 2,
      hgnc_id : "HGNC:4141",
      havana_gene : "OTTHUMG00000137379.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6538961,
      stop : 6556073,
      direction : "-",
      ID : "ENSG00000010295.20",
      gene_id : "ENSG00000010295.20",
      gene_type : "protein_coding",
      gene_name : "IFFO1",
      gene_level : 2,
      hgnc_id : "HGNC:24970",
      havana_gene : "OTTHUMG00000141264.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6556863,
      stop : 6568691,
      direction : "-",
      ID : "ENSG00000111641.12",
      gene_id : "ENSG00000111641.12",
      gene_type : "protein_coding",
      gene_name : "NOP2",
      gene_level : 1,
      hgnc_id : "HGNC:7867",
      havana_gene : "OTTHUMG00000169163.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6556886,
      stop : 6607367,
      direction : "-",
      ID : "ENSG00000285238.2",
      gene_id : "ENSG00000285238.2",
      gene_type : "protein_coding",
      gene_name : "AC006064.6",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192596.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6570082,
      stop : 6614524,
      direction : "-",
      ID : "ENSG00000111642.16",
      gene_id : "ENSG00000111642.16",
      gene_type : "protein_coding",
      gene_name : "CHD4",
      gene_level : 2,
      hgnc_id : "HGNC:1919",
      havana_gene : "OTTHUMG00000169164.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6618835,
      stop : 6635960,
      direction : "-",
      ID : "ENSG00000184574.10",
      gene_id : "ENSG00000184574.10",
      gene_type : "protein_coding",
      gene_name : "LPAR5",
      gene_level : 2,
      hgnc_id : "HGNC:13307",
      havana_gene : "OTTHUMG00000168713.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6638075,
      stop : 6647433,
      direction : "-",
      ID : "ENSG00000111644.8",
      gene_id : "ENSG00000111644.8",
      gene_type : "protein_coding",
      gene_name : "ACRBP",
      gene_level : 1,
      hgnc_id : "HGNC:17195",
      havana_gene : "OTTHUMG00000168715.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6650301,
      stop : 6663142,
      direction : "-",
      ID : "ENSG00000111653.20",
      gene_id : "ENSG00000111653.20",
      gene_type : "protein_coding",
      gene_name : "ING4",
      gene_level : 2,
      hgnc_id : "HGNC:19423",
      havana_gene : "OTTHUMG00000141274.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6666477,
      stop : 6689572,
      direction : "-",
      ID : "ENSG00000126746.17",
      gene_id : "ENSG00000126746.17",
      gene_type : "protein_coding",
      gene_name : "ZNF384",
      gene_level : 1,
      hgnc_id : "HGNC:11955",
      havana_gene : "OTTHUMG00000168716.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6693791,
      stop : 6700815,
      direction : "-",
      ID : "ENSG00000139200.14",
      gene_id : "ENSG00000139200.14",
      gene_type : "protein_coding",
      gene_name : "PIANP",
      gene_level : 2,
      hgnc_id : "HGNC:25338",
      havana_gene : "OTTHUMG00000168664.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6724014,
      stop : 6731875,
      direction : "+",
      ID : "ENSG00000111652.10",
      gene_id : "ENSG00000111652.10",
      gene_type : "protein_coding",
      gene_name : "COPS7A",
      gene_level : 1,
      hgnc_id : "HGNC:16758",
      havana_gene : "OTTHUMG00000169182.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6747996,
      stop : 6767475,
      direction : "-",
      ID : "ENSG00000089693.11",
      gene_id : "ENSG00000089693.11",
      gene_type : "protein_coding",
      gene_name : "MLF2",
      gene_level : 2,
      hgnc_id : "HGNC:7126",
      havana_gene : "OTTHUMG00000168717.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6765516,
      stop : 6770952,
      direction : "+",
      ID : "ENSG00000159335.18",
      gene_id : "ENSG00000159335.18",
      gene_type : "protein_coding",
      gene_name : "PTMS",
      gene_level : 2,
      hgnc_id : "HGNC:9629",
      havana_gene : "OTTHUMG00000169196.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6772512,
      stop : 6778455,
      direction : "+",
      ID : "ENSG00000089692.9",
      gene_id : "ENSG00000089692.9",
      gene_type : "protein_coding",
      gene_name : "LAG3",
      gene_level : 2,
      hgnc_id : "HGNC:6476",
      havana_gene : "OTTHUMG00000169197.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6786858,
      stop : 6820799,
      direction : "+",
      ID : "ENSG00000010610.10",
      gene_id : "ENSG00000010610.10",
      gene_type : "protein_coding",
      gene_name : "CD4",
      gene_level : 1,
      hgnc_id : "HGNC:1678",
      havana_gene : "OTTHUMG00000168514.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6821624,
      stop : 6829972,
      direction : "+",
      ID : "ENSG00000250510.8",
      gene_id : "ENSG00000250510.8",
      gene_type : "protein_coding",
      gene_name : "GPR162",
      gene_level : 1,
      hgnc_id : "HGNC:16693",
      havana_gene : "OTTHUMG00000168368.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6828407,
      stop : 6839847,
      direction : "+",
      ID : "ENSG00000110811.20",
      gene_id : "ENSG00000110811.20",
      gene_type : "protein_coding",
      gene_name : "P3H3",
      gene_level : 2,
      hgnc_id : "HGNC:19318",
      havana_gene : "OTTHUMG00000168516.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6839954,
      stop : 6847393,
      direction : "+",
      ID : "ENSG00000111664.11",
      gene_id : "ENSG00000111664.11",
      gene_type : "protein_coding",
      gene_name : "GNB3",
      gene_level : 2,
      hgnc_id : "HGNC:4400",
      havana_gene : "OTTHUMG00000168517.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6844793,
      stop : 6851292,
      direction : "-",
      ID : "ENSG00000111665.12",
      gene_id : "ENSG00000111665.12",
      gene_type : "protein_coding",
      gene_name : "CDCA3",
      gene_level : 1,
      hgnc_id : "HGNC:14624",
      havana_gene : "OTTHUMG00000169014.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6852148,
      stop : 6866632,
      direction : "+",
      ID : "ENSG00000111667.14",
      gene_id : "ENSG00000111667.14",
      gene_type : "protein_coding",
      gene_name : "USP5",
      gene_level : 2,
      hgnc_id : "HGNC:12628",
      havana_gene : "OTTHUMG00000169233.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6867119,
      stop : 6870948,
      direction : "+",
      ID : "ENSG00000111669.15",
      gene_id : "ENSG00000111669.15",
      gene_type : "protein_coding",
      gene_name : "TPI1",
      gene_level : 2,
      hgnc_id : "HGNC:12009",
      havana_gene : "OTTHUMG00000133767.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6870935,
      stop : 6889358,
      direction : "-",
      ID : "ENSG00000111671.10",
      gene_id : "ENSG00000111671.10",
      gene_type : "protein_coding",
      gene_name : "SPSB2",
      gene_level : 2,
      hgnc_id : "HGNC:29522",
      havana_gene : "OTTHUMG00000156665.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6873569,
      stop : 6914241,
      direction : "+",
      ID : "ENSG00000010626.15",
      gene_id : "ENSG00000010626.15",
      gene_type : "protein_coding",
      gene_name : "LRRC23",
      gene_level : 1,
      hgnc_id : "HGNC:19138",
      havana_gene : "OTTHUMG00000156668.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6913745,
      stop : 6923698,
      direction : "+",
      ID : "ENSG00000111674.9",
      gene_id : "ENSG00000111674.9",
      gene_type : "protein_coding",
      gene_name : "ENO2",
      gene_level : 1,
      hgnc_id : "HGNC:3353",
      havana_gene : "OTTHUMG00000168967.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6924463,
      stop : 6942321,
      direction : "+",
      ID : "ENSG00000111676.15",
      gene_id : "ENSG00000111676.15",
      gene_type : "protein_coding",
      gene_name : "ATN1",
      gene_level : 2,
      hgnc_id : "HGNC:3033",
      havana_gene : "OTTHUMG00000169015.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6942978,
      stop : 6946003,
      direction : "+",
      ID : "ENSG00000111678.11",
      gene_id : "ENSG00000111678.11",
      gene_type : "protein_coding",
      gene_name : "C12orf57",
      gene_level : 1,
      hgnc_id : "HGNC:29521",
      havana_gene : "OTTHUMG00000169017.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6946468,
      stop : 6961316,
      direction : "+",
      ID : "ENSG00000111679.17",
      gene_id : "ENSG00000111679.17",
      gene_type : "protein_coding",
      gene_name : "PTPN6",
      gene_level : 1,
      hgnc_id : "HGNC:9658",
      havana_gene : "OTTHUMG00000168518.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6965327,
      stop : 6970780,
      direction : "-",
      ID : "ENSG00000215021.10",
      gene_id : "ENSG00000215021.10",
      gene_type : "protein_coding",
      gene_name : "PHB2",
      gene_level : 1,
      hgnc_id : "HGNC:30306",
      havana_gene : "OTTHUMG00000168519.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6970913,
      stop : 6997428,
      direction : "+",
      ID : "ENSG00000126749.16",
      gene_id : "ENSG00000126749.16",
      gene_type : "protein_coding",
      gene_name : "EMG1",
      gene_level : 2,
      hgnc_id : "HGNC:16912",
      havana_gene : "OTTHUMG00000188247.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6976185,
      stop : 7018477,
      direction : "-",
      ID : "ENSG00000111684.11",
      gene_id : "ENSG00000111684.11",
      gene_type : "protein_coding",
      gene_name : "LPCAT3",
      gene_level : 2,
      hgnc_id : "HGNC:30244",
      havana_gene : "OTTHUMG00000168970.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 6988259,
      stop : 7071032,
      direction : "+",
      ID : "ENSG00000182326.15",
      gene_id : "ENSG00000182326.15",
      gene_type : "protein_coding",
      gene_name : "C1S",
      gene_level : 1,
      hgnc_id : "HGNC:1247",
      havana_gene : "OTTHUMG00000150305.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7080214,
      stop : 7092540,
      direction : "-",
      ID : "ENSG00000159403.18",
      gene_id : "ENSG00000159403.18",
      gene_type : "protein_coding",
      gene_name : "C1R",
      gene_level : 1,
      hgnc_id : "HGNC:1246",
      havana_gene : "OTTHUMG00000168149.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7089587,
      stop : 7109238,
      direction : "-",
      ID : "ENSG00000139178.11",
      gene_id : "ENSG00000139178.11",
      gene_type : "protein_coding",
      gene_name : "C1RL",
      gene_level : 1,
      hgnc_id : "HGNC:21265",
      havana_gene : "OTTHUMG00000168144.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7115736,
      stop : 7128889,
      direction : "-",
      ID : "ENSG00000139194.8",
      gene_id : "ENSG00000139194.8",
      gene_type : "protein_coding",
      gene_name : "RBP5",
      gene_level : 2,
      hgnc_id : "HGNC:15847",
      havana_gene : "OTTHUMG00000168165.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7129698,
      stop : 7158945,
      direction : "+",
      ID : "ENSG00000139182.15",
      gene_id : "ENSG00000139182.15",
      gene_type : "protein_coding",
      gene_name : "CLSTN3",
      gene_level : 1,
      hgnc_id : "HGNC:18371",
      havana_gene : "OTTHUMG00000168167.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7188685,
      stop : 7218574,
      direction : "+",
      ID : "ENSG00000139197.11",
      gene_id : "ENSG00000139197.11",
      gene_type : "protein_coding",
      gene_name : "PEX5",
      gene_level : 2,
      hgnc_id : "HGNC:9719",
      havana_gene : "OTTHUMG00000168175.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7304284,
      stop : 7328724,
      direction : "+",
      ID : "ENSG00000215009.5",
      gene_id : "ENSG00000215009.5",
      gene_type : "protein_coding",
      gene_name : "ACSM4",
      gene_level : 1,
      hgnc_id : "HGNC:32016",
      havana_gene : "OTTHUMG00000154975.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7346685,
      stop : 7479897,
      direction : "-",
      ID : "ENSG00000177675.9",
      gene_id : "ENSG00000177675.9",
      gene_type : "protein_coding",
      gene_name : "CD163L1",
      gene_level : 1,
      hgnc_id : "HGNC:30375",
      havana_gene : "OTTHUMG00000168325.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7470811,
      stop : 7503893,
      direction : "-",
      ID : "ENSG00000177575.13",
      gene_id : "ENSG00000177575.13",
      gene_type : "protein_coding",
      gene_name : "CD163",
      gene_level : 1,
      hgnc_id : "HGNC:1631",
      havana_gene : "OTTHUMG00000168353.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7649400,
      stop : 7665908,
      direction : "-",
      ID : "ENSG00000111701.7",
      gene_id : "ENSG00000111701.7",
      gene_type : "protein_coding",
      gene_name : "APOBEC1",
      gene_level : 2,
      hgnc_id : "HGNC:604",
      havana_gene : "OTTHUMG00000141288.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7689784,
      stop : 7695775,
      direction : "-",
      ID : "ENSG00000184344.4",
      gene_id : "ENSG00000184344.4",
      gene_type : "protein_coding",
      gene_name : "GDF3",
      gene_level : 2,
      hgnc_id : "HGNC:4218",
      havana_gene : "OTTHUMG00000168433.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7711433,
      stop : 7717559,
      direction : "+",
      ID : "ENSG00000187569.3",
      gene_id : "ENSG00000187569.3",
      gene_type : "protein_coding",
      gene_name : "DPPA3",
      gene_level : 2,
      hgnc_id : "HGNC:19199",
      havana_gene : "OTTHUMG00000168434.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7729383,
      stop : 7751605,
      direction : "-",
      ID : "ENSG00000198178.11",
      gene_id : "ENSG00000198178.11",
      gene_type : "protein_coding",
      gene_name : "CLEC4C",
      gene_level : 1,
      hgnc_id : "HGNC:13258",
      havana_gene : "OTTHUMG00000168441.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7765216,
      stop : 7774121,
      direction : "+",
      ID : "ENSG00000205857.2",
      gene_id : "ENSG00000205857.2",
      gene_type : "protein_coding",
      gene_name : "NANOGNB",
      gene_level : 2,
      hgnc_id : "HGNC:24958",
      havana_gene : "OTTHUMG00000165107.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7787794,
      stop : 7799146,
      direction : "+",
      ID : "ENSG00000111704.11",
      gene_id : "ENSG00000111704.11",
      gene_type : "protein_coding",
      gene_name : "NANOG",
      gene_level : 2,
      hgnc_id : "HGNC:20857",
      havana_gene : "OTTHUMG00000166019.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7812512,
      stop : 7891148,
      direction : "-",
      ID : "ENSG00000173262.12",
      gene_id : "ENSG00000173262.12",
      gene_type : "protein_coding",
      gene_name : "SLC2A14",
      gene_level : 1,
      hgnc_id : "HGNC:18301",
      havana_gene : "OTTHUMG00000168463.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 7919230,
      stop : 7936187,
      direction : "-",
      ID : "ENSG00000059804.16",
      gene_id : "ENSG00000059804.16",
      gene_type : "protein_coding",
      gene_name : "SLC2A3",
      gene_level : 2,
      hgnc_id : "HGNC:11007",
      havana_gene : "OTTHUMG00000133685.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8032716,
      stop : 8055517,
      direction : "+",
      ID : "ENSG00000065970.9",
      gene_id : "ENSG00000065970.9",
      gene_type : "protein_coding",
      gene_name : "FOXJ2",
      gene_level : 2,
      hgnc_id : "HGNC:24818",
      havana_gene : "OTTHUMG00000168526.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8056844,
      stop : 8066359,
      direction : "-",
      ID : "ENSG00000171860.5",
      gene_id : "ENSG00000171860.5",
      gene_type : "protein_coding",
      gene_name : "C3AR1",
      gene_level : 2,
      hgnc_id : "HGNC:1319",
      havana_gene : "OTTHUMG00000168569.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8076939,
      stop : 8097881,
      direction : "+",
      ID : "ENSG00000089818.18",
      gene_id : "ENSG00000089818.18",
      gene_type : "protein_coding",
      gene_name : "NECAP1",
      gene_level : 1,
      hgnc_id : "HGNC:24539",
      havana_gene : "OTTHUMG00000168568.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8123617,
      stop : 8138607,
      direction : "+",
      ID : "ENSG00000111729.15",
      gene_id : "ENSG00000111729.15",
      gene_type : "protein_coding",
      gene_name : "CLEC4A",
      gene_level : 1,
      hgnc_id : "HGNC:13257",
      havana_gene : "OTTHUMG00000168571.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8138140,
      stop : 8175320,
      direction : "+",
      ID : "ENSG00000284393.1",
      gene_id : "ENSG00000284393.1",
      gene_type : "protein_coding",
      gene_name : "AC092111.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192211.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8157034,
      stop : 8188537,
      direction : "+",
      ID : "ENSG00000196946.10",
      gene_id : "ENSG00000196946.10",
      gene_type : "protein_coding",
      gene_name : "ZNF705A",
      gene_level : 2,
      hgnc_id : "HGNC:32281",
      havana_gene : "OTTHUMG00000168635.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8221260,
      stop : 8227618,
      direction : "-",
      ID : "ENSG00000171847.11",
      gene_id : "ENSG00000171847.11",
      gene_type : "protein_coding",
      gene_name : "FAM90A1",
      gene_level : 2,
      hgnc_id : "HGNC:25526",
      havana_gene : "OTTHUMG00000168641.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8455962,
      stop : 8478330,
      direction : "+",
      ID : "ENSG00000205846.4",
      gene_id : "ENSG00000205846.4",
      gene_type : "protein_coding",
      gene_name : "CLEC6A",
      gene_level : 2,
      hgnc_id : "HGNC:14556",
      havana_gene : "OTTHUMG00000168672.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8509475,
      stop : 8522366,
      direction : "+",
      ID : "ENSG00000166527.8",
      gene_id : "ENSG00000166527.8",
      gene_type : "protein_coding",
      gene_name : "CLEC4D",
      gene_level : 2,
      hgnc_id : "HGNC:14554",
      havana_gene : "OTTHUMG00000168674.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8533305,
      stop : 8540905,
      direction : "-",
      ID : "ENSG00000166523.8",
      gene_id : "ENSG00000166523.8",
      gene_type : "protein_coding",
      gene_name : "CLEC4E",
      gene_level : 1,
      hgnc_id : "HGNC:14555",
      havana_gene : "OTTHUMG00000168675.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8602170,
      stop : 8612867,
      direction : "-",
      ID : "ENSG00000111732.11",
      gene_id : "ENSG00000111732.11",
      gene_type : "protein_coding",
      gene_name : "AICDA",
      gene_level : 2,
      hgnc_id : "HGNC:13203",
      havana_gene : "OTTHUMG00000168676.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8637346,
      stop : 8662888,
      direction : "-",
      ID : "ENSG00000197614.11",
      gene_id : "ENSG00000197614.11",
      gene_type : "protein_coding",
      gene_name : "MFAP5",
      gene_level : 1,
      hgnc_id : "HGNC:29673",
      havana_gene : "OTTHUMG00000168703.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8681600,
      stop : 8783095,
      direction : "+",
      ID : "ENSG00000166532.16",
      gene_id : "ENSG00000166532.16",
      gene_type : "protein_coding",
      gene_name : "RIMKLB",
      gene_level : 2,
      hgnc_id : "HGNC:29228",
      havana_gene : "OTTHUMG00000168197.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8822621,
      stop : 8887001,
      direction : "+",
      ID : "ENSG00000166535.20",
      gene_id : "ENSG00000166535.20",
      gene_type : "protein_coding",
      gene_name : "A2ML1",
      gene_level : 2,
      hgnc_id : "HGNC:23336",
      havana_gene : "OTTHUMG00000128499.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8913896,
      stop : 8941467,
      direction : "+",
      ID : "ENSG00000111752.11",
      gene_id : "ENSG00000111752.11",
      gene_type : "protein_coding",
      gene_name : "PHC1",
      gene_level : 2,
      hgnc_id : "HGNC:3182",
      havana_gene : "OTTHUMG00000168275.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8940361,
      stop : 8949761,
      direction : "-",
      ID : "ENSG00000003056.8",
      gene_id : "ENSG00000003056.8",
      gene_type : "protein_coding",
      gene_name : "M6PR",
      gene_level : 1,
      hgnc_id : "HGNC:6752",
      havana_gene : "OTTHUMG00000168276.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 8950044,
      stop : 9010760,
      direction : "+",
      ID : "ENSG00000139187.10",
      gene_id : "ENSG00000139187.10",
      gene_type : "protein_coding",
      gene_name : "KLRG1",
      gene_level : 2,
      hgnc_id : "HGNC:6380",
      havana_gene : "OTTHUMG00000168277.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9067664,
      stop : 9116229,
      direction : "-",
      ID : "ENSG00000175899.15",
      gene_id : "ENSG00000175899.15",
      gene_type : "protein_coding",
      gene_name : "A2M",
      gene_level : 2,
      hgnc_id : "HGNC:7",
      havana_gene : "OTTHUMG00000150267.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9148840,
      stop : 9208395,
      direction : "-",
      ID : "ENSG00000126838.10",
      gene_id : "ENSG00000126838.10",
      gene_type : "protein_coding",
      gene_name : "PZP",
      gene_level : 2,
      hgnc_id : "HGNC:9750",
      havana_gene : "OTTHUMG00000154915.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9594551,
      stop : 9607916,
      direction : "-",
      ID : "ENSG00000111796.4",
      gene_id : "ENSG00000111796.4",
      gene_type : "protein_coding",
      gene_name : "KLRB1",
      gene_level : 2,
      hgnc_id : "HGNC:6373",
      havana_gene : "OTTHUMG00000168581.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9664969,
      stop : 9699553,
      direction : "+",
      ID : "ENSG00000069493.15",
      gene_id : "ENSG00000069493.15",
      gene_type : "protein_coding",
      gene_name : "CLEC2D",
      gene_level : 1,
      hgnc_id : "HGNC:14351",
      havana_gene : "OTTHUMG00000168369.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9715860,
      stop : 9733299,
      direction : "-",
      ID : "ENSG00000184293.7",
      gene_id : "ENSG00000184293.7",
      gene_type : "protein_coding",
      gene_name : "CLECL1",
      gene_level : 1,
      hgnc_id : "HGNC:24462",
      havana_gene : "OTTHUMG00000168459.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9752486,
      stop : 9760901,
      direction : "-",
      ID : "ENSG00000110848.8",
      gene_id : "ENSG00000110848.8",
      gene_type : "protein_coding",
      gene_name : "CD69",
      gene_level : 2,
      hgnc_id : "HGNC:1694",
      havana_gene : "OTTHUMG00000168481.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9827481,
      stop : 9845007,
      direction : "+",
      ID : "ENSG00000150045.12",
      gene_id : "ENSG00000150045.12",
      gene_type : "protein_coding",
      gene_name : "KLRF1",
      gene_level : 1,
      hgnc_id : "HGNC:13342",
      havana_gene : "OTTHUMG00000168391.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9852369,
      stop : 9869386,
      direction : "-",
      ID : "ENSG00000110852.5",
      gene_id : "ENSG00000110852.5",
      gene_type : "protein_coding",
      gene_name : "CLEC2B",
      gene_level : 2,
      hgnc_id : "HGNC:2053",
      havana_gene : "OTTHUMG00000168483.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9881489,
      stop : 9895833,
      direction : "+",
      ID : "ENSG00000256797.1",
      gene_id : "ENSG00000256797.1",
      gene_type : "protein_coding",
      gene_name : "KLRF2",
      gene_level : 2,
      hgnc_id : "HGNC:37646",
      havana_gene : "OTTHUMG00000187141.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9898673,
      stop : 9932370,
      direction : "-",
      ID : "ENSG00000188393.9",
      gene_id : "ENSG00000188393.9",
      gene_type : "protein_coding",
      gene_name : "CLEC2A",
      gene_level : 1,
      hgnc_id : "HGNC:24191",
      havana_gene : "OTTHUMG00000140393.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9951316,
      stop : 9995694,
      direction : "+",
      ID : "ENSG00000172322.14",
      gene_id : "ENSG00000172322.14",
      gene_type : "protein_coding",
      gene_name : "CLEC12A",
      gene_level : 2,
      hgnc_id : "HGNC:31713",
      havana_gene : "OTTHUMG00000168396.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 9985642,
      stop : 10013424,
      direction : "-",
      ID : "ENSG00000165682.14",
      gene_id : "ENSG00000165682.14",
      gene_type : "protein_coding",
      gene_name : "CLEC1B",
      gene_level : 1,
      hgnc_id : "HGNC:24356",
      havana_gene : "OTTHUMG00000168502.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10010627,
      stop : 10018796,
      direction : "+",
      ID : "ENSG00000256660.6",
      gene_id : "ENSG00000256660.6",
      gene_type : "protein_coding",
      gene_name : "CLEC12B",
      gene_level : 2,
      hgnc_id : "HGNC:31966",
      havana_gene : "OTTHUMG00000168397.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10030678,
      stop : 10066031,
      direction : "+",
      ID : "ENSG00000197992.7",
      gene_id : "ENSG00000197992.7",
      gene_type : "protein_coding",
      gene_name : "CLEC9A",
      gene_level : 1,
      hgnc_id : "HGNC:26705",
      havana_gene : "OTTHUMG00000168398.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10069554,
      stop : 10111627,
      direction : "-",
      ID : "ENSG00000150048.10",
      gene_id : "ENSG00000150048.10",
      gene_type : "protein_coding",
      gene_name : "CLEC1A",
      gene_level : 1,
      hgnc_id : "HGNC:24355",
      havana_gene : "OTTHUMG00000168504.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10116777,
      stop : 10130258,
      direction : "-",
      ID : "ENSG00000172243.18",
      gene_id : "ENSG00000172243.18",
      gene_type : "protein_coding",
      gene_name : "CLEC7A",
      gene_level : 2,
      hgnc_id : "HGNC:14558",
      havana_gene : "OTTHUMG00000133597.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10158301,
      stop : 10172138,
      direction : "-",
      ID : "ENSG00000173391.9",
      gene_id : "ENSG00000173391.9",
      gene_type : "protein_coding",
      gene_name : "OLR1",
      gene_level : 1,
      hgnc_id : "HGNC:8133",
      havana_gene : "OTTHUMG00000168527.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10170542,
      stop : 10191801,
      direction : "+",
      ID : "ENSG00000165685.8",
      gene_id : "ENSG00000165685.8",
      gene_type : "protein_coding",
      gene_name : "TMEM52B",
      gene_level : 2,
      hgnc_id : "HGNC:26438",
      havana_gene : "OTTHUMG00000168410.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10212458,
      stop : 10223128,
      direction : "+",
      ID : "ENSG00000139112.11",
      gene_id : "ENSG00000139112.11",
      gene_type : "protein_coding",
      gene_name : "GABARAPL1",
      gene_level : 2,
      hgnc_id : "HGNC:4068",
      havana_gene : "OTTHUMG00000168411.10",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10226058,
      stop : 10329608,
      direction : "+",
      ID : "ENSG00000134539.17",
      gene_id : "ENSG00000134539.17",
      gene_type : "protein_coding",
      gene_name : "KLRD1",
      gene_level : 2,
      hgnc_id : "HGNC:6378",
      havana_gene : "OTTHUMG00000168419.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10372353,
      stop : 10391874,
      direction : "-",
      ID : "ENSG00000213809.9",
      gene_id : "ENSG00000213809.9",
      gene_type : "protein_coding",
      gene_name : "KLRK1",
      gene_level : 2,
      hgnc_id : "HGNC:18788",
      havana_gene : "OTTHUMG00000168574.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10372353,
      stop : 10410146,
      direction : "-",
      ID : "ENSG00000255819.7",
      gene_id : "ENSG00000255819.7",
      gene_type : "protein_coding",
      gene_name : "KLRC4-KLRK1",
      gene_level : 2,
      hgnc_id : "HGNC:48357",
      havana_gene : "OTTHUMG00000168531.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10407382,
      stop : 10409757,
      direction : "-",
      ID : "ENSG00000183542.5",
      gene_id : "ENSG00000183542.5",
      gene_type : "protein_coding",
      gene_name : "KLRC4",
      gene_level : 2,
      hgnc_id : "HGNC:6377",
      havana_gene : "OTTHUMG00000168575.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10412312,
      stop : 10436001,
      direction : "-",
      ID : "ENSG00000255641.1",
      gene_id : "ENSG00000255641.1",
      gene_type : "protein_coding",
      gene_name : "AC068775.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168576.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10412315,
      stop : 10420595,
      direction : "-",
      ID : "ENSG00000205810.9",
      gene_id : "ENSG00000205810.9",
      gene_type : "protein_coding",
      gene_name : "KLRC3",
      gene_level : 2,
      hgnc_id : "HGNC:6376",
      havana_gene : "OTTHUMG00000167149.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10426854,
      stop : 10442300,
      direction : "-",
      ID : "ENSG00000205809.10",
      gene_id : "ENSG00000205809.10",
      gene_type : "protein_coding",
      gene_name : "KLRC2",
      gene_level : 2,
      hgnc_id : "HGNC:6375",
      havana_gene : "OTTHUMG00000168532.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10442264,
      stop : 10454685,
      direction : "-",
      ID : "ENSG00000134545.14",
      gene_id : "ENSG00000134545.14",
      gene_type : "protein_coding",
      gene_name : "KLRC1",
      gene_level : 1,
      hgnc_id : "HGNC:6374",
      havana_gene : "OTTHUMG00000168584.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10505602,
      stop : 10523135,
      direction : "+",
      ID : "ENSG00000180574.3",
      gene_id : "ENSG00000180574.3",
      gene_type : "protein_coding",
      gene_name : "EIF2S3B",
      gene_level : 1,
      hgnc_id : "HGNC:43863",
      havana_gene : "OTTHUMG00000168585.3",
      tag : "retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10604193,
      stop : 10613609,
      direction : "-",
      ID : "ENSG00000111196.10",
      gene_id : "ENSG00000111196.10",
      gene_type : "protein_coding",
      gene_name : "MAGOHB",
      gene_level : 2,
      hgnc_id : "HGNC:25504",
      havana_gene : "OTTHUMG00000168407.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10618923,
      stop : 10674318,
      direction : "-",
      ID : "ENSG00000060140.9",
      gene_id : "ENSG00000060140.9",
      gene_type : "protein_coding",
      gene_name : "STYK1",
      gene_level : 2,
      hgnc_id : "HGNC:18889",
      havana_gene : "OTTHUMG00000168408.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10699089,
      stop : 10723323,
      direction : "-",
      ID : "ENSG00000060138.13",
      gene_id : "ENSG00000060138.13",
      gene_type : "protein_coding",
      gene_name : "YBX3",
      gene_level : 2,
      hgnc_id : "HGNC:2428",
      havana_gene : "OTTHUMG00000168409.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10801532,
      stop : 10802627,
      direction : "-",
      ID : "ENSG00000121377.2",
      gene_id : "ENSG00000121377.2",
      gene_type : "protein_coding",
      gene_name : "TAS2R7",
      gene_level : 2,
      hgnc_id : "HGNC:14913",
      havana_gene : "OTTHUMG00000168505.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10806051,
      stop : 10807286,
      direction : "-",
      ID : "ENSG00000121314.3",
      gene_id : "ENSG00000121314.3",
      gene_type : "protein_coding",
      gene_name : "TAS2R8",
      gene_level : 2,
      hgnc_id : "HGNC:14915",
      havana_gene : "OTTHUMG00000168506.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10809094,
      stop : 10810168,
      direction : "-",
      ID : "ENSG00000121381.4",
      gene_id : "ENSG00000121381.4",
      gene_type : "protein_coding",
      gene_name : "TAS2R9",
      gene_level : 2,
      hgnc_id : "HGNC:14917",
      havana_gene : "OTTHUMG00000168507.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10824960,
      stop : 11171608,
      direction : "-",
      ID : "ENSG00000231887.7",
      gene_id : "ENSG00000231887.7",
      gene_type : "protein_coding",
      gene_name : "PRH1",
      gene_level : 2,
      hgnc_id : "HGNC:9366",
      havana_gene : "OTTHUMG00000186774.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10825317,
      stop : 10826358,
      direction : "-",
      ID : "ENSG00000121318.2",
      gene_id : "ENSG00000121318.2",
      gene_type : "protein_coding",
      gene_name : "TAS2R10",
      gene_level : 2,
      hgnc_id : "HGNC:14918",
      havana_gene : "OTTHUMG00000168508.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10845849,
      stop : 10849475,
      direction : "-",
      ID : "ENSG00000111215.12",
      gene_id : "ENSG00000111215.12",
      gene_type : "protein_coding",
      gene_name : "PRR4",
      gene_level : 2,
      hgnc_id : "HGNC:18020",
      havana_gene : "OTTHUMG00000192575.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10845849,
      stop : 11171600,
      direction : "-",
      ID : "ENSG00000275778.2",
      gene_id : "ENSG00000275778.2",
      gene_type : "protein_coding",
      gene_name : "AC018630.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186775.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10907926,
      stop : 10909562,
      direction : "-",
      ID : "ENSG00000212128.2",
      gene_id : "ENSG00000212128.2",
      gene_type : "protein_coding",
      gene_name : "TAS2R13",
      gene_level : 2,
      hgnc_id : "HGNC:14919",
      havana_gene : "OTTHUMG00000168555.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10929236,
      stop : 10934845,
      direction : "+",
      ID : "ENSG00000134551.13",
      gene_id : "ENSG00000134551.13",
      gene_type : "protein_coding",
      gene_name : "PRH2",
      gene_level : 2,
      hgnc_id : "HGNC:9367",
      havana_gene : "OTTHUMG00000168556.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10937408,
      stop : 11171573,
      direction : "-",
      ID : "ENSG00000212127.6",
      gene_id : "ENSG00000212127.6",
      gene_type : "protein_coding",
      gene_name : "TAS2R14",
      gene_level : 2,
      hgnc_id : "HGNC:14920",
      havana_gene : "OTTHUMG00000162720.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10985913,
      stop : 10986912,
      direction : "-",
      ID : "ENSG00000212126.3",
      gene_id : "ENSG00000212126.3",
      gene_type : "protein_coding",
      gene_name : "TAS2R50",
      gene_level : 2,
      hgnc_id : "HGNC:18882",
      havana_gene : "OTTHUMG00000162719.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 10996495,
      stop : 10997875,
      direction : "-",
      ID : "ENSG00000255837.1",
      gene_id : "ENSG00000255837.1",
      gene_type : "protein_coding",
      gene_name : "TAS2R20",
      gene_level : 2,
      hgnc_id : "HGNC:19109",
      havana_gene : "OTTHUMG00000162695.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11021619,
      stop : 11022620,
      direction : "-",
      ID : "ENSG00000212124.2",
      gene_id : "ENSG00000212124.2",
      gene_type : "protein_coding",
      gene_name : "TAS2R19",
      gene_level : 2,
      hgnc_id : "HGNC:19108",
      havana_gene : "OTTHUMG00000162687.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11030387,
      stop : 11031407,
      direction : "-",
      ID : "ENSG00000256436.1",
      gene_id : "ENSG00000256436.1",
      gene_type : "protein_coding",
      gene_name : "TAS2R31",
      gene_level : 2,
      hgnc_id : "HGNC:19113",
      havana_gene : "OTTHUMG00000168558.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11061365,
      stop : 11062294,
      direction : "-",
      ID : "ENSG00000226761.3",
      gene_id : "ENSG00000226761.3",
      gene_type : "protein_coding",
      gene_name : "TAS2R46",
      gene_level : 2,
      hgnc_id : "HGNC:18877",
      havana_gene : "OTTHUMG00000165351.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11091287,
      stop : 11092313,
      direction : "-",
      ID : "ENSG00000255374.3",
      gene_id : "ENSG00000255374.3",
      gene_type : "protein_coding",
      gene_name : "TAS2R43",
      gene_level : 2,
      hgnc_id : "HGNC:18875",
      havana_gene : "OTTHUMG00000165352.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11132958,
      stop : 11134644,
      direction : "-",
      ID : "ENSG00000256188.3",
      gene_id : "ENSG00000256188.3",
      gene_type : "protein_coding",
      gene_name : "TAS2R30",
      gene_level : 2,
      hgnc_id : "HGNC:19112",
      havana_gene : "OTTHUMG00000168562.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11171194,
      stop : 11176016,
      direction : "+",
      ID : "ENSG00000256537.5",
      gene_id : "ENSG00000256537.5",
      gene_type : "protein_coding",
      gene_name : "SMIM10L1",
      gene_level : 2,
      hgnc_id : "HGNC:49847",
      havana_gene : "OTTHUMG00000168565.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11185993,
      stop : 11186937,
      direction : "-",
      ID : "ENSG00000186136.1",
      gene_id : "ENSG00000186136.1",
      gene_type : "protein_coding",
      gene_name : "TAS2R42",
      gene_level : 2,
      hgnc_id : "HGNC:18888",
      havana_gene : "OTTHUMG00000168567.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11265924,
      stop : 11269805,
      direction : "-",
      ID : "ENSG00000197870.12",
      gene_id : "ENSG00000197870.12",
      gene_type : "protein_coding",
      gene_name : "PRB3",
      gene_level : 2,
      hgnc_id : "HGNC:9339",
      havana_gene : "OTTHUMG00000169065.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11307077,
      stop : 11310436,
      direction : "-",
      ID : "ENSG00000230657.8",
      gene_id : "ENSG00000230657.8",
      gene_type : "protein_coding",
      gene_name : "PRB4",
      gene_level : 2,
      hgnc_id : "HGNC:9340",
      havana_gene : "OTTHUMG00000169116.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11351823,
      stop : 11395566,
      direction : "-",
      ID : "ENSG00000251655.6",
      gene_id : "ENSG00000251655.6",
      gene_type : "protein_coding",
      gene_name : "PRB1",
      gene_level : 2,
      hgnc_id : "HGNC:9337",
      havana_gene : "OTTHUMG00000157263.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11391540,
      stop : 11501041,
      direction : "-",
      ID : "ENSG00000121335.12",
      gene_id : "ENSG00000121335.12",
      gene_type : "protein_coding",
      gene_name : "PRB2",
      gene_level : 2,
      hgnc_id : "HGNC:9338",
      havana_gene : "OTTHUMG00000156975.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 11649674,
      stop : 11895377,
      direction : "+",
      ID : "ENSG00000139083.11",
      gene_id : "ENSG00000139083.11",
      gene_type : "protein_coding",
      gene_name : "ETV6",
      gene_level : 1,
      hgnc_id : "HGNC:3495",
      havana_gene : "OTTHUMG00000168538.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12049844,
      stop : 12211084,
      direction : "+",
      ID : "ENSG00000121380.12",
      gene_id : "ENSG00000121380.12",
      gene_type : "protein_coding",
      gene_name : "BCL2L14",
      gene_level : 1,
      hgnc_id : "HGNC:16657",
      havana_gene : "OTTHUMG00000159528.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12116025,
      stop : 12267044,
      direction : "-",
      ID : "ENSG00000070018.9",
      gene_id : "ENSG00000070018.9",
      gene_type : "protein_coding",
      gene_name : "LRP6",
      gene_level : 1,
      hgnc_id : "HGNC:6698",
      havana_gene : "OTTHUMG00000168540.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12326056,
      stop : 12350242,
      direction : "-",
      ID : "ENSG00000111261.14",
      gene_id : "ENSG00000111261.14",
      gene_type : "protein_coding",
      gene_name : "MANSC1",
      gene_level : 2,
      hgnc_id : "HGNC:25505",
      havana_gene : "OTTHUMG00000168541.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12357078,
      stop : 12471233,
      direction : "+",
      ID : "ENSG00000165714.11",
      gene_id : "ENSG00000165714.11",
      gene_type : "protein_coding",
      gene_name : "BORCS5",
      gene_level : 2,
      hgnc_id : "HGNC:17950",
      havana_gene : "OTTHUMG00000168542.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12473282,
      stop : 12562863,
      direction : "-",
      ID : "ENSG00000111266.9",
      gene_id : "ENSG00000111266.9",
      gene_type : "protein_coding",
      gene_name : "DUSP16",
      gene_level : 2,
      hgnc_id : "HGNC:17909",
      havana_gene : "OTTHUMG00000168582.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12611827,
      stop : 12645108,
      direction : "+",
      ID : "ENSG00000111269.3",
      gene_id : "ENSG00000111269.3",
      gene_type : "protein_coding",
      gene_name : "CREBL2",
      gene_level : 2,
      hgnc_id : "HGNC:2350",
      havana_gene : "OTTHUMG00000168704.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12660890,
      stop : 12696207,
      direction : "-",
      ID : "ENSG00000183150.8",
      gene_id : "ENSG00000183150.8",
      gene_type : "protein_coding",
      gene_name : "GPR19",
      gene_level : 2,
      hgnc_id : "HGNC:4473",
      havana_gene : "OTTHUMG00000168705.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12715058,
      stop : 12722369,
      direction : "+",
      ID : "ENSG00000111276.11",
      gene_id : "ENSG00000111276.11",
      gene_type : "protein_coding",
      gene_name : "CDKN1B",
      gene_level : 1,
      hgnc_id : "HGNC:1785",
      havana_gene : "OTTHUMG00000149914.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12725917,
      stop : 12829975,
      direction : "+",
      ID : "ENSG00000178878.13",
      gene_id : "ENSG00000178878.13",
      gene_type : "protein_coding",
      gene_name : "APOLD1",
      gene_level : 2,
      hgnc_id : "HGNC:25268",
      havana_gene : "OTTHUMG00000153561.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12813316,
      stop : 12829981,
      direction : "+",
      ID : "ENSG00000213782.7",
      gene_id : "ENSG00000213782.7",
      gene_type : "protein_coding",
      gene_name : "DDX47",
      gene_level : 2,
      hgnc_id : "HGNC:18682",
      havana_gene : "OTTHUMG00000168709.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12891559,
      stop : 12917937,
      direction : "+",
      ID : "ENSG00000013588.9",
      gene_id : "ENSG00000013588.9",
      gene_type : "protein_coding",
      gene_name : "GPRC5A",
      gene_level : 2,
      hgnc_id : "HGNC:9836",
      havana_gene : "OTTHUMG00000168710.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12940775,
      stop : 12952147,
      direction : "-",
      ID : "ENSG00000111291.8",
      gene_id : "ENSG00000111291.8",
      gene_type : "protein_coding",
      gene_name : "GPRC5D",
      gene_level : 2,
      hgnc_id : "HGNC:13310",
      havana_gene : "OTTHUMG00000168711.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 12974870,
      stop : 13000265,
      direction : "-",
      ID : "ENSG00000013583.10",
      gene_id : "ENSG00000013583.10",
      gene_type : "protein_coding",
      gene_name : "HEBP1",
      gene_level : 1,
      hgnc_id : "HGNC:17176",
      havana_gene : "OTTHUMG00000168771.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 13044381,
      stop : 13142521,
      direction : "+",
      ID : "ENSG00000084444.14",
      gene_id : "ENSG00000084444.14",
      gene_type : "protein_coding",
      gene_name : "FAM234B",
      gene_level : 2,
      hgnc_id : "HGNC:29288",
      havana_gene : "OTTHUMG00000168774.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 13083532,
      stop : 13103683,
      direction : "-",
      ID : "ENSG00000111305.19",
      gene_id : "ENSG00000111305.19",
      gene_type : "protein_coding",
      gene_name : "GSG1",
      gene_level : 2,
      hgnc_id : "HGNC:19716",
      havana_gene : "OTTHUMG00000150148.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 13196723,
      stop : 13219941,
      direction : "+",
      ID : "ENSG00000134531.10",
      gene_id : "ENSG00000134531.10",
      gene_type : "protein_coding",
      gene_name : "EMP1",
      gene_level : 1,
      hgnc_id : "HGNC:3333",
      havana_gene : "OTTHUMG00000168775.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 13437942,
      stop : 13982002,
      direction : "-",
      ID : "ENSG00000273079.7",
      gene_id : "ENSG00000273079.7",
      gene_type : "protein_coding",
      gene_name : "GRIN2B",
      gene_level : 2,
      hgnc_id : "HGNC:4586",
      havana_gene : "OTTHUMG00000137373.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14365632,
      stop : 14502935,
      direction : "+",
      ID : "ENSG00000171681.12",
      gene_id : "ENSG00000171681.12",
      gene_type : "protein_coding",
      gene_name : "ATF7IP",
      gene_level : 1,
      hgnc_id : "HGNC:20092",
      havana_gene : "OTTHUMG00000168656.14",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14503661,
      stop : 14567883,
      direction : "-",
      ID : "ENSG00000121316.11",
      gene_id : "ENSG00000121316.11",
      gene_type : "protein_coding",
      gene_name : "PLBD1",
      gene_level : 1,
      hgnc_id : "HGNC:26215",
      havana_gene : "OTTHUMG00000168821.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14612632,
      stop : 14696599,
      direction : "-",
      ID : "ENSG00000070019.5",
      gene_id : "ENSG00000070019.5",
      gene_type : "protein_coding",
      gene_name : "GUCY2C",
      gene_level : 2,
      hgnc_id : "HGNC:4688",
      havana_gene : "OTTHUMG00000168732.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14767999,
      stop : 14771131,
      direction : "-",
      ID : "ENSG00000197837.3",
      gene_id : "ENSG00000197837.3",
      gene_type : "protein_coding",
      gene_name : "H4-16",
      gene_level : 1,
      hgnc_id : "HGNC:20510",
      havana_gene : "OTTHUMG00000168735.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14774383,
      stop : 14778002,
      direction : "+",
      ID : "ENSG00000246705.4",
      gene_id : "ENSG00000246705.4",
      gene_type : "protein_coding",
      gene_name : "H2AJ",
      gene_level : 2,
      hgnc_id : "HGNC:14456",
      havana_gene : "OTTHUMG00000168736.2",
      tag : "retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14784582,
      stop : 14803486,
      direction : "-",
      ID : "ENSG00000084463.8",
      gene_id : "ENSG00000084463.8",
      gene_type : "protein_coding",
      gene_name : "WBP11",
      gene_level : 2,
      hgnc_id : "HGNC:16461",
      havana_gene : "OTTHUMG00000168737.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14803666,
      stop : 14906586,
      direction : "+",
      ID : "ENSG00000182993.5",
      gene_id : "ENSG00000182993.5",
      gene_type : "protein_coding",
      gene_name : "C12orf60",
      gene_level : 2,
      hgnc_id : "HGNC:28726",
      havana_gene : "OTTHUMG00000167473.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14804650,
      stop : 14814182,
      direction : "-",
      ID : "ENSG00000179256.2",
      gene_id : "ENSG00000179256.2",
      gene_type : "protein_coding",
      gene_name : "SMCO3",
      gene_level : 2,
      hgnc_id : "HGNC:34401",
      havana_gene : "OTTHUMG00000167474.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14825569,
      stop : 14843526,
      direction : "-",
      ID : "ENSG00000111339.12",
      gene_id : "ENSG00000111339.12",
      gene_type : "protein_coding",
      gene_name : "ART4",
      gene_level : 2,
      hgnc_id : "HGNC:726",
      havana_gene : "OTTHUMG00000168738.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14880864,
      stop : 14885857,
      direction : "-",
      ID : "ENSG00000111341.10",
      gene_id : "ENSG00000111341.10",
      gene_type : "protein_coding",
      gene_name : "MGP",
      gene_level : 1,
      hgnc_id : "HGNC:7060",
      havana_gene : "OTTHUMG00000168740.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14914039,
      stop : 14938537,
      direction : "-",
      ID : "ENSG00000139055.7",
      gene_id : "ENSG00000139055.7",
      gene_type : "protein_coding",
      gene_name : "ERP27",
      gene_level : 1,
      hgnc_id : "HGNC:26495",
      havana_gene : "OTTHUMG00000168741.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14942031,
      stop : 14961728,
      direction : "-",
      ID : "ENSG00000111348.9",
      gene_id : "ENSG00000111348.9",
      gene_type : "protein_coding",
      gene_name : "ARHGDIB",
      gene_level : 2,
      hgnc_id : "HGNC:679",
      havana_gene : "OTTHUMG00000168742.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 14973042,
      stop : 14981865,
      direction : "+",
      ID : "ENSG00000139053.3",
      gene_id : "ENSG00000139053.3",
      gene_type : "protein_coding",
      gene_name : "PDE6H",
      gene_level : 2,
      hgnc_id : "HGNC:8790",
      havana_gene : "OTTHUMG00000168743.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 15107783,
      stop : 15348675,
      direction : "-",
      ID : "ENSG00000134533.6",
      gene_id : "ENSG00000134533.6",
      gene_type : "protein_coding",
      gene_name : "RERG",
      gene_level : 1,
      hgnc_id : "HGNC:15980",
      havana_gene : "OTTHUMG00000168745.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 15322257,
      stop : 15602175,
      direction : "+",
      ID : "ENSG00000151490.15",
      gene_id : "ENSG00000151490.15",
      gene_type : "protein_coding",
      gene_name : "PTPRO",
      gene_level : 1,
      hgnc_id : "HGNC:9678",
      havana_gene : "OTTHUMG00000168786.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 15620134,
      stop : 15882329,
      direction : "-",
      ID : "ENSG00000151491.14",
      gene_id : "ENSG00000151491.14",
      gene_type : "protein_coding",
      gene_name : "EPS8",
      gene_level : 1,
      hgnc_id : "HGNC:3420",
      havana_gene : "OTTHUMG00000168787.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 15882387,
      stop : 15903478,
      direction : "+",
      ID : "ENSG00000023734.11",
      gene_id : "ENSG00000023734.11",
      gene_type : "protein_coding",
      gene_name : "STRAP",
      gene_level : 1,
      hgnc_id : "HGNC:30796",
      havana_gene : "OTTHUMG00000168791.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 15911302,
      stop : 16037381,
      direction : "+",
      ID : "ENSG00000023697.13",
      gene_id : "ENSG00000023697.13",
      gene_type : "protein_coding",
      gene_name : "DERA",
      gene_level : 2,
      hgnc_id : "HGNC:24269",
      havana_gene : "OTTHUMG00000165537.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 16188485,
      stop : 16277685,
      direction : "-",
      ID : "ENSG00000188991.3",
      gene_id : "ENSG00000188991.3",
      gene_type : "protein_coding",
      gene_name : "SLC15A5",
      gene_level : 1,
      hgnc_id : "HGNC:33455",
      havana_gene : "OTTHUMG00000168793.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 16347142,
      stop : 16609259,
      direction : "+",
      ID : "ENSG00000008394.13",
      gene_id : "ENSG00000008394.13",
      gene_type : "protein_coding",
      gene_name : "MGST1",
      gene_level : 1,
      hgnc_id : "HGNC:7061",
      havana_gene : "OTTHUMG00000168816.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 16548372,
      stop : 16610594,
      direction : "-",
      ID : "ENSG00000048540.15",
      gene_id : "ENSG00000048540.15",
      gene_type : "protein_coding",
      gene_name : "LMO3",
      gene_level : 1,
      hgnc_id : "HGNC:6643",
      havana_gene : "OTTHUMG00000168837.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 18080869,
      stop : 18320107,
      direction : "-",
      ID : "ENSG00000111404.7",
      gene_id : "ENSG00000111404.7",
      gene_type : "protein_coding",
      gene_name : "RERGL",
      gene_level : 2,
      hgnc_id : "HGNC:26213",
      havana_gene : "OTTHUMG00000168820.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 18242961,
      stop : 18648416,
      direction : "+",
      ID : "ENSG00000139144.11",
      gene_id : "ENSG00000139144.11",
      gene_type : "protein_coding",
      gene_name : "PIK3C2G",
      gene_level : 1,
      hgnc_id : "HGNC:8973",
      havana_gene : "OTTHUMG00000168841.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 18683169,
      stop : 18738100,
      direction : "-",
      ID : "ENSG00000139151.16",
      gene_id : "ENSG00000139151.16",
      gene_type : "protein_coding",
      gene_name : "PLCZ1",
      gene_level : 1,
      hgnc_id : "HGNC:19218",
      havana_gene : "OTTHUMG00000168937.13",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 18738119,
      stop : 18739188,
      direction : "+",
      ID : "ENSG00000177938.5",
      gene_id : "ENSG00000177938.5",
      gene_type : "protein_coding",
      gene_name : "CAPZA3",
      gene_level : 2,
      hgnc_id : "HGNC:24205",
      havana_gene : "OTTHUMG00000169001.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 19129733,
      stop : 19376400,
      direction : "+",
      ID : "ENSG00000052126.15",
      gene_id : "ENSG00000052126.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHA5",
      gene_level : 1,
      hgnc_id : "HGNC:30036",
      havana_gene : "OTTHUMG00000167921.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 19404045,
      stop : 19720801,
      direction : "+",
      ID : "ENSG00000139154.16",
      gene_id : "ENSG00000139154.16",
      gene_type : "protein_coding",
      gene_name : "AEBP2",
      gene_level : 2,
      hgnc_id : "HGNC:24051",
      havana_gene : "OTTHUMG00000168906.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 20368537,
      stop : 20688583,
      direction : "+",
      ID : "ENSG00000172572.7",
      gene_id : "ENSG00000172572.7",
      gene_type : "protein_coding",
      gene_name : "PDE3A",
      gene_level : 2,
      hgnc_id : "HGNC:8778",
      havana_gene : "OTTHUMG00000168962.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 20695332,
      stop : 20753386,
      direction : "+",
      ID : "ENSG00000139155.9",
      gene_id : "ENSG00000139155.9",
      gene_type : "protein_coding",
      gene_name : "SLCO1C1",
      gene_level : 2,
      hgnc_id : "HGNC:13819",
      havana_gene : "OTTHUMG00000168966.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 20810702,
      stop : 20916911,
      direction : "+",
      ID : "ENSG00000111700.13",
      gene_id : "ENSG00000111700.13",
      gene_type : "protein_coding",
      gene_name : "SLCO1B3",
      gene_level : 2,
      hgnc_id : "HGNC:10961",
      havana_gene : "OTTHUMG00000169011.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 20815674,
      stop : 21090245,
      direction : "+",
      ID : "ENSG00000257046.5",
      gene_id : "ENSG00000257046.5",
      gene_type : "protein_coding",
      gene_name : "SLCO1B3-SLCO1B7",
      gene_level : 2,
      hgnc_id : "HGNC:54403",
      havana_gene : "OTTHUMG00000169018.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21047179,
      stop : 21176895,
      direction : "+",
      ID : "ENSG00000257062.6",
      gene_id : "ENSG00000257062.6",
      gene_type : "protein_coding",
      gene_name : "AC022335.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000169046.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21131194,
      stop : 21239796,
      direction : "+",
      ID : "ENSG00000134538.3",
      gene_id : "ENSG00000134538.3",
      gene_type : "protein_coding",
      gene_name : "SLCO1B1",
      gene_level : 2,
      hgnc_id : "HGNC:10959",
      havana_gene : "OTTHUMG00000169047.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21264600,
      stop : 21419594,
      direction : "-",
      ID : "ENSG00000084453.16",
      gene_id : "ENSG00000084453.16",
      gene_type : "protein_coding",
      gene_name : "SLCO1A2",
      gene_level : 1,
      hgnc_id : "HGNC:10956",
      havana_gene : "OTTHUMG00000156259.10",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21354959,
      stop : 21379980,
      direction : "+",
      ID : "ENSG00000121351.8",
      gene_id : "ENSG00000121351.8",
      gene_type : "protein_coding",
      gene_name : "IAPP",
      gene_level : 1,
      hgnc_id : "HGNC:5329",
      havana_gene : "OTTHUMG00000169128.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21437615,
      stop : 21471250,
      direction : "+",
      ID : "ENSG00000121350.16",
      gene_id : "ENSG00000121350.16",
      gene_type : "protein_coding",
      gene_name : "PYROXD1",
      gene_level : 1,
      hgnc_id : "HGNC:26162",
      havana_gene : "OTTHUMG00000169129.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21468910,
      stop : 21501669,
      direction : "-",
      ID : "ENSG00000004700.16",
      gene_id : "ENSG00000004700.16",
      gene_type : "protein_coding",
      gene_name : "RECQL",
      gene_level : 2,
      hgnc_id : "HGNC:9948",
      havana_gene : "OTTHUMG00000169131.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21501781,
      stop : 21518408,
      direction : "+",
      ID : "ENSG00000111711.10",
      gene_id : "ENSG00000111711.10",
      gene_type : "protein_coding",
      gene_name : "GOLT1B",
      gene_level : 1,
      hgnc_id : "HGNC:20175",
      havana_gene : "OTTHUMG00000169133.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21526296,
      stop : 21541249,
      direction : "+",
      ID : "ENSG00000134548.11",
      gene_id : "ENSG00000134548.11",
      gene_type : "protein_coding",
      gene_name : "SPX",
      gene_level : 2,
      hgnc_id : "HGNC:28139",
      havana_gene : "OTTHUMG00000169134.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21536107,
      stop : 21604847,
      direction : "-",
      ID : "ENSG00000111713.3",
      gene_id : "ENSG00000111713.3",
      gene_type : "protein_coding",
      gene_name : "GYS2",
      gene_level : 2,
      hgnc_id : "HGNC:4707",
      havana_gene : "OTTHUMG00000169135.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21536203,
      stop : 21657798,
      direction : "-",
      ID : "ENSG00000285854.1",
      gene_id : "ENSG00000285854.1",
      gene_type : "protein_coding",
      gene_name : "AC010197.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193384.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21635342,
      stop : 21757857,
      direction : "-",
      ID : "ENSG00000111716.14",
      gene_id : "ENSG00000111716.14",
      gene_type : "protein_coding",
      gene_name : "LDHB",
      gene_level : 2,
      hgnc_id : "HGNC:6541",
      havana_gene : "OTTHUMG00000133760.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21764955,
      stop : 21775600,
      direction : "-",
      ID : "ENSG00000121361.5",
      gene_id : "ENSG00000121361.5",
      gene_type : "protein_coding",
      gene_name : "KCNJ8",
      gene_level : 2,
      hgnc_id : "HGNC:6269",
      havana_gene : "OTTHUMG00000169093.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 21797389,
      stop : 21942529,
      direction : "-",
      ID : "ENSG00000069431.12",
      gene_id : "ENSG00000069431.12",
      gene_type : "protein_coding",
      gene_name : "ABCC9",
      gene_level : 2,
      hgnc_id : "HGNC:60",
      havana_gene : "OTTHUMG00000169094.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 22046218,
      stop : 22065674,
      direction : "+",
      ID : "ENSG00000111726.13",
      gene_id : "ENSG00000111726.13",
      gene_type : "protein_coding",
      gene_name : "CMAS",
      gene_level : 2,
      hgnc_id : "HGNC:18290",
      havana_gene : "OTTHUMG00000169097.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 22063773,
      stop : 22437041,
      direction : "-",
      ID : "ENSG00000111728.11",
      gene_id : "ENSG00000111728.11",
      gene_type : "protein_coding",
      gene_name : "ST8SIA1",
      gene_level : 1,
      hgnc_id : "HGNC:10869",
      havana_gene : "OTTHUMG00000169098.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 22448583,
      stop : 22544546,
      direction : "-",
      ID : "ENSG00000111731.12",
      gene_id : "ENSG00000111731.12",
      gene_type : "protein_coding",
      gene_name : "C2CD5",
      gene_level : 2,
      hgnc_id : "HGNC:29062",
      havana_gene : "OTTHUMG00000169100.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 22625075,
      stop : 22690665,
      direction : "+",
      ID : "ENSG00000139163.16",
      gene_id : "ENSG00000139163.16",
      gene_type : "protein_coding",
      gene_name : "ETNK1",
      gene_level : 1,
      hgnc_id : "HGNC:24649",
      havana_gene : "OTTHUMG00000169008.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 23529504,
      stop : 24562544,
      direction : "-",
      ID : "ENSG00000134532.19",
      gene_id : "ENSG00000134532.19",
      gene_type : "protein_coding",
      gene_name : "SOX5",
      gene_level : 2,
      hgnc_id : "HGNC:11201",
      havana_gene : "OTTHUMG00000169026.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 24810024,
      stop : 24949101,
      direction : "-",
      ID : "ENSG00000060982.15",
      gene_id : "ENSG00000060982.15",
      gene_type : "protein_coding",
      gene_name : "BCAT1",
      gene_level : 2,
      hgnc_id : "HGNC:976",
      havana_gene : "OTTHUMG00000169053.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 25004342,
      stop : 25108334,
      direction : "+",
      ID : "ENSG00000118308.15",
      gene_id : "ENSG00000118308.15",
      gene_type : "protein_coding",
      gene_name : "IRAG2",
      gene_level : 1,
      hgnc_id : "HGNC:6690",
      havana_gene : "OTTHUMG00000170192.26",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 25108289,
      stop : 25195162,
      direction : "-",
      ID : "ENSG00000118307.20",
      gene_id : "ENSG00000118307.20",
      gene_type : "protein_coding",
      gene_name : "CFAP94",
      gene_level : 2,
      hgnc_id : "HGNC:29599",
      havana_gene : "OTTHUMG00000150195.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 25195216,
      stop : 25209645,
      direction : "+",
      ID : "ENSG00000205707.11",
      gene_id : "ENSG00000205707.11",
      gene_type : "protein_coding",
      gene_name : "ETFRF1",
      gene_level : 1,
      hgnc_id : "HGNC:27052",
      havana_gene : "OTTHUMG00000171190.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 25205246,
      stop : 25250936,
      direction : "-",
      ID : "ENSG00000133703.13",
      gene_id : "ENSG00000133703.13",
      gene_type : "protein_coding",
      gene_name : "KRAS",
      gene_level : 2,
      hgnc_id : "HGNC:6407",
      havana_gene : "OTTHUMG00000171193.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 25409307,
      stop : 25648579,
      direction : "-",
      ID : "ENSG00000152936.10",
      gene_id : "ENSG00000152936.10",
      gene_type : "protein_coding",
      gene_name : "LMNTD1",
      gene_level : 1,
      hgnc_id : "HGNC:26683",
      havana_gene : "OTTHUMG00000169052.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 25959029,
      stop : 26079892,
      direction : "+",
      ID : "ENSG00000123094.15",
      gene_id : "ENSG00000123094.15",
      gene_type : "protein_coding",
      gene_name : "RASSF8",
      gene_level : 2,
      hgnc_id : "HGNC:13232",
      havana_gene : "OTTHUMG00000169087.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 26120030,
      stop : 26125037,
      direction : "-",
      ID : "ENSG00000123095.6",
      gene_id : "ENSG00000123095.6",
      gene_type : "protein_coding",
      gene_name : "BHLHE41",
      gene_level : 2,
      hgnc_id : "HGNC:16617",
      havana_gene : "OTTHUMG00000169174.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 26121991,
      stop : 26299290,
      direction : "+",
      ID : "ENSG00000123096.12",
      gene_id : "ENSG00000123096.12",
      gene_type : "protein_coding",
      gene_name : "SSPN",
      gene_level : 2,
      hgnc_id : "HGNC:11322",
      havana_gene : "OTTHUMG00000169167.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 26335352,
      stop : 26833194,
      direction : "-",
      ID : "ENSG00000123104.12",
      gene_id : "ENSG00000123104.12",
      gene_type : "protein_coding",
      gene_name : "ITPR2",
      gene_level : 2,
      hgnc_id : "HGNC:6181",
      havana_gene : "OTTHUMG00000169181.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 26905181,
      stop : 26938326,
      direction : "-",
      ID : "ENSG00000064102.15",
      gene_id : "ENSG00000064102.15",
      gene_type : "protein_coding",
      gene_name : "INTS13",
      gene_level : 1,
      hgnc_id : "HGNC:20174",
      havana_gene : "OTTHUMG00000169193.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 26938470,
      stop : 26966650,
      direction : "+",
      ID : "ENSG00000111790.14",
      gene_id : "ENSG00000111790.14",
      gene_type : "protein_coding",
      gene_name : "FGFR1OP2",
      gene_level : 1,
      hgnc_id : "HGNC:23098",
      havana_gene : "OTTHUMG00000169231.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 26971579,
      stop : 27014434,
      direction : "-",
      ID : "ENSG00000064115.11",
      gene_id : "ENSG00000064115.11",
      gene_type : "protein_coding",
      gene_name : "TM7SF3",
      gene_level : 2,
      hgnc_id : "HGNC:23049",
      havana_gene : "OTTHUMG00000169243.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27022546,
      stop : 27066343,
      direction : "+",
      ID : "ENSG00000152944.9",
      gene_id : "ENSG00000152944.9",
      gene_type : "protein_coding",
      gene_name : "MED21",
      gene_level : 2,
      hgnc_id : "HGNC:11473",
      havana_gene : "OTTHUMG00000169276.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27081057,
      stop : 27082578,
      direction : "-",
      ID : "ENSG00000214700.6",
      gene_id : "ENSG00000214700.6",
      gene_type : "protein_coding",
      gene_name : "C12orf71",
      gene_level : 2,
      hgnc_id : "HGNC:34452",
      havana_gene : "OTTHUMG00000169274.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27243968,
      stop : 27325959,
      direction : "+",
      ID : "ENSG00000211455.8",
      gene_id : "ENSG00000211455.8",
      gene_type : "protein_coding",
      gene_name : "STK38L",
      gene_level : 2,
      hgnc_id : "HGNC:17848",
      havana_gene : "OTTHUMG00000169284.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27332854,
      stop : 27425289,
      direction : "+",
      ID : "ENSG00000029153.14",
      gene_id : "ENSG00000029153.14",
      gene_type : "protein_coding",
      gene_name : "ARNTL2",
      gene_level : 1,
      hgnc_id : "HGNC:18984",
      havana_gene : "OTTHUMG00000169257.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27466810,
      stop : 27502185,
      direction : "+",
      ID : "ENSG00000165935.9",
      gene_id : "ENSG00000165935.9",
      gene_type : "protein_coding",
      gene_name : "SMCO2",
      gene_level : 2,
      hgnc_id : "HGNC:34448",
      havana_gene : "OTTHUMG00000169205.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27523431,
      stop : 27695564,
      direction : "+",
      ID : "ENSG00000110841.14",
      gene_id : "ENSG00000110841.14",
      gene_type : "protein_coding",
      gene_name : "PPFIBP1",
      gene_level : 2,
      hgnc_id : "HGNC:9249",
      havana_gene : "OTTHUMG00000169207.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27696447,
      stop : 27697596,
      direction : "+",
      ID : "ENSG00000174236.4",
      gene_id : "ENSG00000174236.4",
      gene_type : "protein_coding",
      gene_name : "REP15",
      gene_level : 2,
      hgnc_id : "HGNC:33748",
      havana_gene : "OTTHUMG00000169212.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27710822,
      stop : 27756295,
      direction : "+",
      ID : "ENSG00000061794.13",
      gene_id : "ENSG00000061794.13",
      gene_type : "protein_coding",
      gene_name : "MRPS35",
      gene_level : 2,
      hgnc_id : "HGNC:16635",
      havana_gene : "OTTHUMG00000169215.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27762427,
      stop : 27780236,
      direction : "-",
      ID : "ENSG00000205693.4",
      gene_id : "ENSG00000205693.4",
      gene_type : "protein_coding",
      gene_name : "MANSC4",
      gene_level : 1,
      hgnc_id : "HGNC:40023",
      havana_gene : "OTTHUMG00000169216.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27780048,
      stop : 27803040,
      direction : "+",
      ID : "ENSG00000087448.11",
      gene_id : "ENSG00000087448.11",
      gene_type : "protein_coding",
      gene_name : "KLHL42",
      gene_level : 2,
      hgnc_id : "HGNC:29252",
      havana_gene : "OTTHUMG00000169217.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 27958084,
      stop : 27972733,
      direction : "-",
      ID : "ENSG00000087494.16",
      gene_id : "ENSG00000087494.16",
      gene_type : "protein_coding",
      gene_name : "PTHLH",
      gene_level : 2,
      hgnc_id : "HGNC:9607",
      havana_gene : "OTTHUMG00000169221.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 28133249,
      stop : 28581511,
      direction : "+",
      ID : "ENSG00000123106.10",
      gene_id : "ENSG00000123106.10",
      gene_type : "protein_coding",
      gene_name : "CCDC91",
      gene_level : 2,
      hgnc_id : "HGNC:24855",
      havana_gene : "OTTHUMG00000169141.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 29149103,
      stop : 29340980,
      direction : "+",
      ID : "ENSG00000064763.11",
      gene_id : "ENSG00000064763.11",
      gene_type : "protein_coding",
      gene_name : "FAR2",
      gene_level : 1,
      hgnc_id : "HGNC:25531",
      havana_gene : "OTTHUMG00000169320.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 29337352,
      stop : 29381189,
      direction : "-",
      ID : "ENSG00000087502.18",
      gene_id : "ENSG00000087502.18",
      gene_type : "protein_coding",
      gene_name : "ERGIC2",
      gene_level : 2,
      hgnc_id : "HGNC:30208",
      havana_gene : "OTTHUMG00000169322.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 29412474,
      stop : 29497686,
      direction : "-",
      ID : "ENSG00000187950.8",
      gene_id : "ENSG00000187950.8",
      gene_type : "protein_coding",
      gene_name : "OVCH1",
      gene_level : 1,
      hgnc_id : "HGNC:23080",
      havana_gene : "OTTHUMG00000167741.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 29500840,
      stop : 29784759,
      direction : "-",
      ID : "ENSG00000133687.16",
      gene_id : "ENSG00000133687.16",
      gene_type : "protein_coding",
      gene_name : "TMTC1",
      gene_level : 2,
      hgnc_id : "HGNC:24099",
      havana_gene : "OTTHUMG00000169324.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 30628988,
      stop : 30695869,
      direction : "-",
      ID : "ENSG00000133704.10",
      gene_id : "ENSG00000133704.10",
      gene_type : "protein_coding",
      gene_name : "IPO8",
      gene_level : 1,
      hgnc_id : "HGNC:9853",
      havana_gene : "OTTHUMG00000169172.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 30709552,
      stop : 30754951,
      direction : "-",
      ID : "ENSG00000110888.17",
      gene_id : "ENSG00000110888.17",
      gene_type : "protein_coding",
      gene_name : "CAPRIN2",
      gene_level : 1,
      hgnc_id : "HGNC:21259",
      havana_gene : "OTTHUMG00000169185.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 30926428,
      stop : 30996602,
      direction : "+",
      ID : "ENSG00000110900.16",
      gene_id : "ENSG00000110900.16",
      gene_type : "protein_coding",
      gene_name : "TSPAN11",
      gene_level : 2,
      hgnc_id : "HGNC:30795",
      havana_gene : "OTTHUMG00000168484.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31073860,
      stop : 31104799,
      direction : "+",
      ID : "ENSG00000013573.17",
      gene_id : "ENSG00000013573.17",
      gene_type : "protein_coding",
      gene_name : "DDX11",
      gene_level : 2,
      hgnc_id : "HGNC:2736",
      havana_gene : "OTTHUMG00000168435.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31280584,
      stop : 31327058,
      direction : "-",
      ID : "ENSG00000139146.14",
      gene_id : "ENSG00000139146.14",
      gene_type : "protein_coding",
      gene_name : "SINHCAF",
      gene_level : 2,
      hgnc_id : "HGNC:30702",
      havana_gene : "OTTHUMG00000168586.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31382226,
      stop : 31591136,
      direction : "-",
      ID : "ENSG00000170456.16",
      gene_id : "ENSG00000170456.16",
      gene_type : "protein_coding",
      gene_name : "DENND5B",
      gene_level : 2,
      hgnc_id : "HGNC:28338",
      havana_gene : "OTTHUMG00000169034.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31647160,
      stop : 31673114,
      direction : "+",
      ID : "ENSG00000139160.13",
      gene_id : "ENSG00000139160.13",
      gene_type : "protein_coding",
      gene_name : "ETFBKMT",
      gene_level : 1,
      hgnc_id : "HGNC:28739",
      havana_gene : "OTTHUMG00000169085.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31671142,
      stop : 31729121,
      direction : "-",
      ID : "ENSG00000151743.11",
      gene_id : "ENSG00000151743.11",
      gene_type : "protein_coding",
      gene_name : "AMN1",
      gene_level : 1,
      hgnc_id : "HGNC:27281",
      havana_gene : "OTTHUMG00000169192.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31791185,
      stop : 31792298,
      direction : "-",
      ID : "ENSG00000188375.5",
      gene_id : "ENSG00000188375.5",
      gene_type : "protein_coding",
      gene_name : "H3-5",
      gene_level : 2,
      hgnc_id : "HGNC:33164",
      havana_gene : "OTTHUMG00000157811.2",
      tag : "retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 31959370,
      stop : 31993107,
      direction : "+",
      ID : "ENSG00000174718.12",
      gene_id : "ENSG00000174718.12",
      gene_type : "protein_coding",
      gene_name : "RESF1",
      gene_level : 2,
      hgnc_id : "HGNC:25559",
      havana_gene : "OTTHUMG00000128501.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 32106835,
      stop : 32383633,
      direction : "+",
      ID : "ENSG00000151746.15",
      gene_id : "ENSG00000151746.15",
      gene_type : "protein_coding",
      gene_name : "BICD1",
      gene_level : 1,
      hgnc_id : "HGNC:1049",
      havana_gene : "OTTHUMG00000169307.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 32399558,
      stop : 32646050,
      direction : "+",
      ID : "ENSG00000139132.15",
      gene_id : "ENSG00000139132.15",
      gene_type : "protein_coding",
      gene_name : "FGD4",
      gene_level : 1,
      hgnc_id : "HGNC:19125",
      havana_gene : "OTTHUMG00000137374.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 32679200,
      stop : 32745650,
      direction : "+",
      ID : "ENSG00000087470.19",
      gene_id : "ENSG00000087470.19",
      gene_type : "protein_coding",
      gene_name : "DNM1L",
      gene_level : 2,
      hgnc_id : "HGNC:2973",
      havana_gene : "OTTHUMG00000169451.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 32727490,
      stop : 32755897,
      direction : "-",
      ID : "ENSG00000139131.13",
      gene_id : "ENSG00000139131.13",
      gene_type : "protein_coding",
      gene_name : "YARS2",
      gene_level : 2,
      hgnc_id : "HGNC:24249",
      havana_gene : "OTTHUMG00000169454.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 32790755,
      stop : 32896777,
      direction : "-",
      ID : "ENSG00000057294.15",
      gene_id : "ENSG00000057294.15",
      gene_type : "protein_coding",
      gene_name : "PKP2",
      gene_level : 2,
      hgnc_id : "HGNC:9024",
      havana_gene : "OTTHUMG00000169500.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 33374238,
      stop : 33439819,
      direction : "-",
      ID : "ENSG00000110975.8",
      gene_id : "ENSG00000110975.8",
      gene_type : "protein_coding",
      gene_name : "SYT10",
      gene_level : 2,
      hgnc_id : "HGNC:19266",
      havana_gene : "OTTHUMG00000169269.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 34022468,
      stop : 34029694,
      direction : "+",
      ID : "ENSG00000139133.7",
      gene_id : "ENSG00000139133.7",
      gene_type : "protein_coding",
      gene_name : "ALG10",
      gene_level : 2,
      hgnc_id : "HGNC:23162",
      havana_gene : "OTTHUMG00000169285.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 38316762,
      stop : 38329721,
      direction : "+",
      ID : "ENSG00000175548.9",
      gene_id : "ENSG00000175548.9",
      gene_type : "protein_coding",
      gene_name : "ALG10B",
      gene_level : 2,
      hgnc_id : "HGNC:31088",
      havana_gene : "OTTHUMG00000169298.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 38646822,
      stop : 38907430,
      direction : "-",
      ID : "ENSG00000139117.14",
      gene_id : "ENSG00000139117.14",
      gene_type : "protein_coding",
      gene_name : "CPNE8",
      gene_level : 2,
      hgnc_id : "HGNC:23498",
      havana_gene : "OTTHUMG00000169396.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 39293228,
      stop : 39443390,
      direction : "-",
      ID : "ENSG00000139116.19",
      gene_id : "ENSG00000139116.19",
      gene_type : "protein_coding",
      gene_name : "KIF21A",
      gene_level : 2,
      hgnc_id : "HGNC:19349",
      havana_gene : "OTTHUMG00000169335.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 39550033,
      stop : 39619803,
      direction : "-",
      ID : "ENSG00000173208.4",
      gene_id : "ENSG00000173208.4",
      gene_type : "protein_coding",
      gene_name : "ABCD2",
      gene_level : 2,
      hgnc_id : "HGNC:66",
      havana_gene : "OTTHUMG00000169337.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 39626167,
      stop : 39908300,
      direction : "+",
      ID : "ENSG00000180116.15",
      gene_id : "ENSG00000180116.15",
      gene_type : "protein_coding",
      gene_name : "C12orf40",
      gene_level : 2,
      hgnc_id : "HGNC:26846",
      havana_gene : "OTTHUMG00000133567.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 39755025,
      stop : 40106089,
      direction : "-",
      ID : "ENSG00000151229.13",
      gene_id : "ENSG00000151229.13",
      gene_type : "protein_coding",
      gene_name : "SLC2A13",
      gene_level : 2,
      hgnc_id : "HGNC:15956",
      havana_gene : "OTTHUMG00000059743.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 40196744,
      stop : 40369285,
      direction : "+",
      ID : "ENSG00000188906.17",
      gene_id : "ENSG00000188906.17",
      gene_type : "protein_coding",
      gene_name : "LRRK2",
      gene_level : 1,
      hgnc_id : "HGNC:18618",
      havana_gene : "OTTHUMG00000059742.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 40393395,
      stop : 40570832,
      direction : "+",
      ID : "ENSG00000205592.15",
      gene_id : "ENSG00000205592.15",
      gene_type : "protein_coding",
      gene_name : "MUC19",
      gene_level : 1,
      hgnc_id : "HGNC:14362",
      havana_gene : "OTTHUMG00000060732.36",
      tag : "reference_genome_error"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 40692439,
      stop : 41072415,
      direction : "+",
      ID : "ENSG00000018236.15",
      gene_id : "ENSG00000018236.15",
      gene_type : "protein_coding",
      gene_name : "CNTN1",
      gene_level : 2,
      hgnc_id : "HGNC:2171",
      havana_gene : "OTTHUMG00000169362.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 41188320,
      stop : 41574745,
      direction : "+",
      ID : "ENSG00000165966.16",
      gene_id : "ENSG00000165966.16",
      gene_type : "protein_coding",
      gene_name : "PDZRN4",
      gene_level : 2,
      hgnc_id : "HGNC:30552",
      havana_gene : "OTTHUMG00000169364.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 42081845,
      stop : 42144874,
      direction : "-",
      ID : "ENSG00000151233.11",
      gene_id : "ENSG00000151233.11",
      gene_type : "protein_coding",
      gene_name : "GXYLT1",
      gene_level : 2,
      hgnc_id : "HGNC:27482",
      havana_gene : "OTTHUMG00000169379.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 42157104,
      stop : 42238349,
      direction : "-",
      ID : "ENSG00000015153.15",
      gene_id : "ENSG00000015153.15",
      gene_type : "protein_coding",
      gene_name : "YAF2",
      gene_level : 2,
      hgnc_id : "HGNC:17363",
      havana_gene : "OTTHUMG00000169380.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 42238447,
      stop : 42459715,
      direction : "+",
      ID : "ENSG00000134283.18",
      gene_id : "ENSG00000134283.18",
      gene_type : "protein_coding",
      gene_name : "PPHLN1",
      gene_level : 1,
      hgnc_id : "HGNC:19369",
      havana_gene : "OTTHUMG00000169440.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 42312086,
      stop : 42326257,
      direction : "-",
      ID : "ENSG00000139168.9",
      gene_id : "ENSG00000139168.9",
      gene_type : "protein_coding",
      gene_name : "ZCRB1",
      gene_level : 2,
      hgnc_id : "HGNC:29620",
      havana_gene : "OTTHUMG00000169382.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 42456757,
      stop : 42590355,
      direction : "-",
      ID : "ENSG00000139174.12",
      gene_id : "ENSG00000139174.12",
      gene_type : "protein_coding",
      gene_name : "PRICKLE1",
      gene_level : 2,
      hgnc_id : "HGNC:17019",
      havana_gene : "OTTHUMG00000169443.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 43353866,
      stop : 43552203,
      direction : "-",
      ID : "ENSG00000173157.17",
      gene_id : "ENSG00000173157.17",
      gene_type : "protein_coding",
      gene_name : "ADAMTS20",
      gene_level : 1,
      hgnc_id : "HGNC:17178",
      havana_gene : "OTTHUMG00000169353.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 43718992,
      stop : 43758793,
      direction : "-",
      ID : "ENSG00000129317.15",
      gene_id : "ENSG00000129317.15",
      gene_type : "protein_coding",
      gene_name : "PUS7L",
      gene_level : 2,
      hgnc_id : "HGNC:25276",
      havana_gene : "OTTHUMG00000169423.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 43758944,
      stop : 43789543,
      direction : "+",
      ID : "ENSG00000198001.14",
      gene_id : "ENSG00000198001.14",
      gene_type : "protein_coding",
      gene_name : "IRAK4",
      gene_level : 2,
      hgnc_id : "HGNC:17967",
      havana_gene : "OTTHUMG00000169425.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 43793723,
      stop : 43806328,
      direction : "-",
      ID : "ENSG00000151239.14",
      gene_id : "ENSG00000151239.14",
      gene_type : "protein_coding",
      gene_name : "TWF1",
      gene_level : 2,
      hgnc_id : "HGNC:9620",
      havana_gene : "OTTHUMG00000169426.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 43835967,
      stop : 44389762,
      direction : "+",
      ID : "ENSG00000139173.10",
      gene_id : "ENSG00000139173.10",
      gene_type : "protein_coding",
      gene_name : "TMEM117",
      gene_level : 2,
      hgnc_id : "HGNC:25308",
      havana_gene : "OTTHUMG00000169427.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 44508275,
      stop : 44921848,
      direction : "-",
      ID : "ENSG00000184613.11",
      gene_id : "ENSG00000184613.11",
      gene_type : "protein_coding",
      gene_name : "NELL2",
      gene_level : 2,
      hgnc_id : "HGNC:7751",
      havana_gene : "OTTHUMG00000169464.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 45014672,
      stop : 45051099,
      direction : "-",
      ID : "ENSG00000185610.6",
      gene_id : "ENSG00000185610.6",
      gene_type : "protein_coding",
      gene_name : "DBX2",
      gene_level : 2,
      hgnc_id : "HGNC:33186",
      havana_gene : "OTTHUMG00000169559.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 45215987,
      stop : 45482280,
      direction : "+",
      ID : "ENSG00000177119.17",
      gene_id : "ENSG00000177119.17",
      gene_type : "protein_coding",
      gene_name : "ANO6",
      gene_level : 2,
      hgnc_id : "HGNC:25240",
      havana_gene : "OTTHUMG00000169564.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 45729706,
      stop : 45908040,
      direction : "+",
      ID : "ENSG00000189079.17",
      gene_id : "ENSG00000189079.17",
      gene_type : "protein_coding",
      gene_name : "ARID2",
      gene_level : 2,
      hgnc_id : "HGNC:18037",
      havana_gene : "OTTHUMG00000150487.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 45919131,
      stop : 45992120,
      direction : "-",
      ID : "ENSG00000139218.18",
      gene_id : "ENSG00000139218.18",
      gene_type : "protein_coding",
      gene_name : "SCAF11",
      gene_level : 1,
      hgnc_id : "HGNC:10784",
      havana_gene : "OTTHUMG00000149930.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 46183063,
      stop : 46270017,
      direction : "-",
      ID : "ENSG00000111371.16",
      gene_id : "ENSG00000111371.16",
      gene_type : "protein_coding",
      gene_name : "SLC38A1",
      gene_level : 1,
      hgnc_id : "HGNC:13447",
      havana_gene : "OTTHUMG00000169470.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 46358188,
      stop : 46372773,
      direction : "-",
      ID : "ENSG00000134294.14",
      gene_id : "ENSG00000134294.14",
      gene_type : "protein_coding",
      gene_name : "SLC38A2",
      gene_level : 2,
      hgnc_id : "HGNC:13448",
      havana_gene : "OTTHUMG00000169471.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 46764761,
      stop : 46832408,
      direction : "-",
      ID : "ENSG00000139209.16",
      gene_id : "ENSG00000139209.16",
      gene_type : "protein_coding",
      gene_name : "SLC38A4",
      gene_level : 1,
      hgnc_id : "HGNC:14679",
      havana_gene : "OTTHUMG00000169518.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47075707,
      stop : 47079959,
      direction : "-",
      ID : "ENSG00000139211.7",
      gene_id : "ENSG00000139211.7",
      gene_type : "protein_coding",
      gene_name : "AMIGO2",
      gene_level : 2,
      hgnc_id : "HGNC:24073",
      havana_gene : "OTTHUMG00000169616.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47079603,
      stop : 47236662,
      direction : "+",
      ID : "ENSG00000179715.13",
      gene_id : "ENSG00000179715.13",
      gene_type : "protein_coding",
      gene_name : "PCED1B",
      gene_level : 2,
      hgnc_id : "HGNC:28255",
      havana_gene : "OTTHUMG00000169617.4",
      tag : "ncRNA_host, retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47661249,
      stop : 47706030,
      direction : "-",
      ID : "ENSG00000005175.10",
      gene_id : "ENSG00000005175.10",
      gene_type : "protein_coding",
      gene_name : "RPAP3",
      gene_level : 2,
      hgnc_id : "HGNC:26151",
      havana_gene : "OTTHUMG00000169668.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47709734,
      stop : 47725567,
      direction : "-",
      ID : "ENSG00000111405.9",
      gene_id : "ENSG00000111405.9",
      gene_type : "protein_coding",
      gene_name : "ENDOU",
      gene_level : 1,
      hgnc_id : "HGNC:14369",
      havana_gene : "OTTHUMG00000169670.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47734363,
      stop : 47771040,
      direction : "-",
      ID : "ENSG00000079337.16",
      gene_id : "ENSG00000079337.16",
      gene_type : "protein_coding",
      gene_name : "RAPGEF3",
      gene_level : 1,
      hgnc_id : "HGNC:16629",
      havana_gene : "OTTHUMG00000133667.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47753916,
      stop : 47782751,
      direction : "+",
      ID : "ENSG00000211584.14",
      gene_id : "ENSG00000211584.14",
      gene_type : "protein_coding",
      gene_name : "SLC48A1",
      gene_level : 2,
      hgnc_id : "HGNC:26035",
      havana_gene : "OTTHUMG00000156983.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47782722,
      stop : 47833132,
      direction : "-",
      ID : "ENSG00000061273.18",
      gene_id : "ENSG00000061273.18",
      gene_type : "protein_coding",
      gene_name : "HDAC7",
      gene_level : 2,
      hgnc_id : "HGNC:14067",
      havana_gene : "OTTHUMG00000152968.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47841537,
      stop : 47943048,
      direction : "-",
      ID : "ENSG00000111424.12",
      gene_id : "ENSG00000111424.12",
      gene_type : "protein_coding",
      gene_name : "VDR",
      gene_level : 1,
      hgnc_id : "HGNC:12679",
      havana_gene : "OTTHUMG00000169890.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47963569,
      stop : 47968878,
      direction : "+",
      ID : "ENSG00000134291.12",
      gene_id : "ENSG00000134291.12",
      gene_type : "protein_coding",
      gene_name : "TMEM106C",
      gene_level : 1,
      hgnc_id : "HGNC:28775",
      havana_gene : "OTTHUMG00000169892.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 47972967,
      stop : 48004554,
      direction : "-",
      ID : "ENSG00000139219.19",
      gene_id : "ENSG00000139219.19",
      gene_type : "protein_coding",
      gene_name : "COL2A1",
      gene_level : 2,
      hgnc_id : "HGNC:2200",
      havana_gene : "OTTHUMG00000149896.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48042897,
      stop : 48106079,
      direction : "-",
      ID : "ENSG00000079387.14",
      gene_id : "ENSG00000079387.14",
      gene_type : "protein_coding",
      gene_name : "SENP1",
      gene_level : 2,
      hgnc_id : "HGNC:17927",
      havana_gene : "OTTHUMG00000169896.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48105139,
      stop : 48146404,
      direction : "+",
      ID : "ENSG00000152556.17",
      gene_id : "ENSG00000152556.17",
      gene_type : "protein_coding",
      gene_name : "PFKM",
      gene_level : 1,
      hgnc_id : "HGNC:8877",
      havana_gene : "OTTHUMG00000169898.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48147789,
      stop : 48181213,
      direction : "-",
      ID : "ENSG00000177981.11",
      gene_id : "ENSG00000177981.11",
      gene_type : "protein_coding",
      gene_name : "ASB8",
      gene_level : 1,
      hgnc_id : "HGNC:17183",
      havana_gene : "OTTHUMG00000167834.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48183644,
      stop : 48185926,
      direction : "+",
      ID : "ENSG00000177875.5",
      gene_id : "ENSG00000177875.5",
      gene_type : "protein_coding",
      gene_name : "CCDC184",
      gene_level : 2,
      hgnc_id : "HGNC:33749",
      havana_gene : "OTTHUMG00000169902.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48202083,
      stop : 48203387,
      direction : "-",
      ID : "ENSG00000172640.3",
      gene_id : "ENSG00000172640.3",
      gene_type : "protein_coding",
      gene_name : "OR10AD1",
      gene_level : 2,
      hgnc_id : "HGNC:14819",
      havana_gene : "OTTHUMG00000168027.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48328980,
      stop : 48330279,
      direction : "+",
      ID : "ENSG00000187166.1",
      gene_id : "ENSG00000187166.1",
      gene_type : "protein_coding",
      gene_name : "H1-7",
      gene_level : 2,
      hgnc_id : "HGNC:24893",
      havana_gene : "OTTHUMG00000169904.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48337180,
      stop : 48351414,
      direction : "-",
      ID : "ENSG00000167528.13",
      gene_id : "ENSG00000167528.13",
      gene_type : "protein_coding",
      gene_name : "ZNF641",
      gene_level : 2,
      hgnc_id : "HGNC:31834",
      havana_gene : "OTTHUMG00000169906.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48472559,
      stop : 48473622,
      direction : "+",
      ID : "ENSG00000139223.4",
      gene_id : "ENSG00000139223.4",
      gene_type : "protein_coding",
      gene_name : "ANP32D",
      gene_level : 2,
      hgnc_id : "HGNC:16676",
      havana_gene : "OTTHUMG00000162681.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48482498,
      stop : 48496524,
      direction : "+",
      ID : "ENSG00000177627.11",
      gene_id : "ENSG00000177627.11",
      gene_type : "protein_coding",
      gene_name : "C12orf54",
      gene_level : 2,
      hgnc_id : "HGNC:28553",
      havana_gene : "OTTHUMG00000170019.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48525632,
      stop : 48528103,
      direction : "+",
      ID : "ENSG00000284723.1",
      gene_id : "ENSG00000284723.1",
      gene_type : "protein_coding",
      gene_name : "OR8S1",
      gene_level : 2,
      hgnc_id : "HGNC:19628",
      havana_gene : "OTTHUMG00000170021.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48559882,
      stop : 48562956,
      direction : "+",
      ID : "ENSG00000198678.5",
      gene_id : "ENSG00000198678.5",
      gene_type : "protein_coding",
      gene_name : "OR5BS1P",
      gene_level : 2,
      hgnc_id : "HGNC:19627",
      havana_gene : "OTTHUMG00000170390.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48567684,
      stop : 48570066,
      direction : "-",
      ID : "ENSG00000167531.6",
      gene_id : "ENSG00000167531.6",
      gene_type : "protein_coding",
      gene_name : "LALBA",
      gene_level : 2,
      hgnc_id : "HGNC:6480",
      havana_gene : "OTTHUMG00000170391.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48653211,
      stop : 48682238,
      direction : "-",
      ID : "ENSG00000139620.13",
      gene_id : "ENSG00000139620.13",
      gene_type : "protein_coding",
      gene_name : "KANSL2",
      gene_level : 1,
      hgnc_id : "HGNC:26024",
      havana_gene : "OTTHUMG00000170392.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48688458,
      stop : 48716998,
      direction : "-",
      ID : "ENSG00000129315.11",
      gene_id : "ENSG00000129315.11",
      gene_type : "protein_coding",
      gene_name : "CCNT1",
      gene_level : 2,
      hgnc_id : "HGNC:1599",
      havana_gene : "OTTHUMG00000170393.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48727435,
      stop : 48765790,
      direction : "+",
      ID : "ENSG00000257987.6",
      gene_id : "ENSG00000257987.6",
      gene_type : "protein_coding",
      gene_name : "TEX49",
      gene_level : 2,
      hgnc_id : "HGNC:48628",
      havana_gene : "OTTHUMG00000170394.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48766194,
      stop : 48789089,
      direction : "-",
      ID : "ENSG00000174233.12",
      gene_id : "ENSG00000174233.12",
      gene_type : "protein_coding",
      gene_name : "ADCY6",
      gene_level : 2,
      hgnc_id : "HGNC:237",
      havana_gene : "OTTHUMG00000170396.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48813794,
      stop : 48828941,
      direction : "+",
      ID : "ENSG00000167535.8",
      gene_id : "ENSG00000167535.8",
      gene_type : "protein_coding",
      gene_name : "CACNB3",
      gene_level : 1,
      hgnc_id : "HGNC:1403",
      havana_gene : "OTTHUMG00000170398.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48829756,
      stop : 48852842,
      direction : "-",
      ID : "ENSG00000174243.10",
      gene_id : "ENSG00000174243.10",
      gene_type : "protein_coding",
      gene_name : "DDX23",
      gene_level : 2,
      hgnc_id : "HGNC:17347",
      havana_gene : "OTTHUMG00000170399.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48857145,
      stop : 48865870,
      direction : "-",
      ID : "ENSG00000172602.11",
      gene_id : "ENSG00000172602.11",
      gene_type : "protein_coding",
      gene_name : "RND1",
      gene_level : 2,
      hgnc_id : "HGNC:18314",
      havana_gene : "OTTHUMG00000170400.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48903503,
      stop : 48957365,
      direction : "-",
      ID : "ENSG00000272822.2",
      gene_id : "ENSG00000272822.2",
      gene_type : "protein_coding",
      gene_name : "AC073610.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186497.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48904110,
      stop : 48931840,
      direction : "+",
      ID : "ENSG00000139537.11",
      gene_id : "ENSG00000139537.11",
      gene_type : "protein_coding",
      gene_name : "CCDC65",
      gene_level : 2,
      hgnc_id : "HGNC:29937",
      havana_gene : "OTTHUMG00000170401.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48921518,
      stop : 48926474,
      direction : "-",
      ID : "ENSG00000134285.11",
      gene_id : "ENSG00000134285.11",
      gene_type : "protein_coding",
      gene_name : "FKBP11",
      gene_level : 1,
      hgnc_id : "HGNC:18624",
      havana_gene : "OTTHUMG00000170402.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48935723,
      stop : 48957487,
      direction : "-",
      ID : "ENSG00000134287.10",
      gene_id : "ENSG00000134287.10",
      gene_type : "protein_coding",
      gene_name : "ARF3",
      gene_level : 1,
      hgnc_id : "HGNC:654",
      havana_gene : "OTTHUMG00000168080.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48965340,
      stop : 48971735,
      direction : "-",
      ID : "ENSG00000169884.14",
      gene_id : "ENSG00000169884.14",
      gene_type : "protein_coding",
      gene_name : "WNT10B",
      gene_level : 2,
      hgnc_id : "HGNC:12775",
      havana_gene : "OTTHUMG00000150734.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48978322,
      stop : 48982620,
      direction : "+",
      ID : "ENSG00000125084.12",
      gene_id : "ENSG00000125084.12",
      gene_type : "protein_coding",
      gene_name : "WNT1",
      gene_level : 2,
      hgnc_id : "HGNC:12774",
      havana_gene : "OTTHUMG00000170403.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 48995149,
      stop : 48999375,
      direction : "-",
      ID : "ENSG00000181418.8",
      gene_id : "ENSG00000181418.8",
      gene_type : "protein_coding",
      gene_name : "DDN",
      gene_level : 2,
      hgnc_id : "HGNC:24458",
      havana_gene : "OTTHUMG00000156183.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49002274,
      stop : 49018807,
      direction : "-",
      ID : "ENSG00000181929.13",
      gene_id : "ENSG00000181929.13",
      gene_type : "protein_coding",
      gene_name : "PRKAG1",
      gene_level : 1,
      hgnc_id : "HGNC:9385",
      havana_gene : "OTTHUMG00000170406.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49018978,
      stop : 49060794,
      direction : "-",
      ID : "ENSG00000167548.16",
      gene_id : "ENSG00000167548.16",
      gene_type : "protein_coding",
      gene_name : "KMT2D",
      gene_level : 1,
      hgnc_id : "HGNC:7133",
      havana_gene : "OTTHUMG00000166524.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49064676,
      stop : 49070025,
      direction : "-",
      ID : "ENSG00000167550.11",
      gene_id : "ENSG00000167550.11",
      gene_type : "protein_coding",
      gene_name : "RHEBL1",
      gene_level : 2,
      hgnc_id : "HGNC:21166",
      havana_gene : "OTTHUMG00000170407.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49086656,
      stop : 49094801,
      direction : "-",
      ID : "ENSG00000139549.4",
      gene_id : "ENSG00000139549.4",
      gene_type : "protein_coding",
      gene_name : "DHH",
      gene_level : 2,
      hgnc_id : "HGNC:2865",
      havana_gene : "OTTHUMG00000170408.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49097136,
      stop : 49110900,
      direction : "-",
      ID : "ENSG00000139636.16",
      gene_id : "ENSG00000139636.16",
      gene_type : "protein_coding",
      gene_name : "LMBR1L",
      gene_level : 1,
      hgnc_id : "HGNC:18268",
      havana_gene : "OTTHUMG00000150511.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49127782,
      stop : 49131397,
      direction : "-",
      ID : "ENSG00000123416.15",
      gene_id : "ENSG00000123416.15",
      gene_type : "protein_coding",
      gene_name : "TUBA1B",
      gene_level : 1,
      hgnc_id : "HGNC:18809",
      havana_gene : "OTTHUMG00000170410.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49184686,
      stop : 49189080,
      direction : "-",
      ID : "ENSG00000167552.15",
      gene_id : "ENSG00000167552.15",
      gene_type : "protein_coding",
      gene_name : "TUBA1A",
      gene_level : 1,
      hgnc_id : "HGNC:20766",
      havana_gene : "OTTHUMG00000169511.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49188736,
      stop : 49274600,
      direction : "+",
      ID : "ENSG00000167553.16",
      gene_id : "ENSG00000167553.16",
      gene_type : "protein_coding",
      gene_name : "TUBA1C",
      gene_level : 2,
      hgnc_id : "HGNC:20768",
      havana_gene : "OTTHUMG00000169497.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49293252,
      stop : 49298686,
      direction : "+",
      ID : "ENSG00000135406.14",
      gene_id : "ENSG00000135406.14",
      gene_type : "protein_coding",
      gene_name : "PRPH",
      gene_level : 1,
      hgnc_id : "HGNC:9461",
      havana_gene : "OTTHUMG00000167140.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49323236,
      stop : 49331731,
      direction : "+",
      ID : "ENSG00000135451.13",
      gene_id : "ENSG00000135451.13",
      gene_type : "protein_coding",
      gene_name : "TROAP",
      gene_level : 2,
      hgnc_id : "HGNC:12327",
      havana_gene : "OTTHUMG00000169486.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49332409,
      stop : 49337188,
      direction : "-",
      ID : "ENSG00000186897.5",
      gene_id : "ENSG00000186897.5",
      gene_type : "protein_coding",
      gene_name : "C1QL4",
      gene_level : 2,
      hgnc_id : "HGNC:31416",
      havana_gene : "OTTHUMG00000169515.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49346888,
      stop : 49357546,
      direction : "+",
      ID : "ENSG00000178401.16",
      gene_id : "ENSG00000178401.16",
      gene_type : "protein_coding",
      gene_name : "DNAJC22",
      gene_level : 2,
      hgnc_id : "HGNC:25802",
      havana_gene : "OTTHUMG00000169487.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49366584,
      stop : 49527425,
      direction : "+",
      ID : "ENSG00000123352.18",
      gene_id : "ENSG00000123352.18",
      gene_type : "protein_coding",
      gene_name : "SPATS2",
      gene_level : 1,
      hgnc_id : "HGNC:18650",
      havana_gene : "OTTHUMG00000169419.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49539030,
      stop : 49558337,
      direction : "+",
      ID : "ENSG00000135519.8",
      gene_id : "ENSG00000135519.8",
      gene_type : "protein_coding",
      gene_name : "KCNH3",
      gene_level : 2,
      hgnc_id : "HGNC:6252",
      havana_gene : "OTTHUMG00000169517.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49556544,
      stop : 49568145,
      direction : "-",
      ID : "ENSG00000187778.14",
      gene_id : "ENSG00000187778.14",
      gene_type : "protein_coding",
      gene_name : "MCRS1",
      gene_level : 1,
      hgnc_id : "HGNC:6960",
      havana_gene : "OTTHUMG00000169620.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49568218,
      stop : 49644666,
      direction : "+",
      ID : "ENSG00000110844.14",
      gene_id : "ENSG00000110844.14",
      gene_type : "protein_coding",
      gene_name : "PRPF40B",
      gene_level : 2,
      hgnc_id : "HGNC:25031",
      havana_gene : "OTTHUMG00000169568.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49582885,
      stop : 49605639,
      direction : "-",
      ID : "ENSG00000135436.8",
      gene_id : "ENSG00000135436.8",
      gene_type : "protein_coding",
      gene_name : "FAM186B",
      gene_level : 2,
      hgnc_id : "HGNC:25296",
      havana_gene : "OTTHUMG00000167427.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49636499,
      stop : 49708165,
      direction : "-",
      ID : "ENSG00000161791.14",
      gene_id : "ENSG00000161791.14",
      gene_type : "protein_coding",
      gene_name : "FMNL3",
      gene_level : 2,
      hgnc_id : "HGNC:23698",
      havana_gene : "OTTHUMG00000169651.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49707725,
      stop : 49764934,
      direction : "+",
      ID : "ENSG00000139644.13",
      gene_id : "ENSG00000139644.13",
      gene_type : "protein_coding",
      gene_name : "TMBIM6",
      gene_level : 2,
      hgnc_id : "HGNC:11723",
      havana_gene : "OTTHUMG00000169652.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49791146,
      stop : 49828750,
      direction : "-",
      ID : "ENSG00000167566.17",
      gene_id : "ENSG00000167566.17",
      gene_type : "protein_coding",
      gene_name : "NCKAP5L",
      gene_level : 2,
      hgnc_id : "HGNC:29321",
      havana_gene : "OTTHUMG00000156969.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49836043,
      stop : 49843106,
      direction : "-",
      ID : "ENSG00000186666.6",
      gene_id : "ENSG00000186666.6",
      gene_type : "protein_coding",
      gene_name : "BCDIN3D",
      gene_level : 1,
      hgnc_id : "HGNC:27050",
      havana_gene : "OTTHUMG00000169807.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49866896,
      stop : 49904217,
      direction : "-",
      ID : "ENSG00000135472.9",
      gene_id : "ENSG00000135472.9",
      gene_type : "protein_coding",
      gene_name : "FAIM2",
      gene_level : 2,
      hgnc_id : "HGNC:17067",
      havana_gene : "OTTHUMG00000169808.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49950737,
      stop : 49958878,
      direction : "+",
      ID : "ENSG00000167580.8",
      gene_id : "ENSG00000167580.8",
      gene_type : "protein_coding",
      gene_name : "AQP2",
      gene_level : 2,
      hgnc_id : "HGNC:634",
      havana_gene : "OTTHUMG00000169709.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49961872,
      stop : 49965682,
      direction : "+",
      ID : "ENSG00000161798.7",
      gene_id : "ENSG00000161798.7",
      gene_type : "protein_coding",
      gene_name : "AQP5",
      gene_level : 2,
      hgnc_id : "HGNC:638",
      havana_gene : "OTTHUMG00000169710.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49967194,
      stop : 49977139,
      direction : "+",
      ID : "ENSG00000086159.13",
      gene_id : "ENSG00000086159.13",
      gene_type : "protein_coding",
      gene_name : "AQP6",
      gene_level : 1,
      hgnc_id : "HGNC:639",
      havana_gene : "OTTHUMG00000133548.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 49976923,
      stop : 50033136,
      direction : "-",
      ID : "ENSG00000161800.13",
      gene_id : "ENSG00000161800.13",
      gene_type : "protein_coding",
      gene_name : "RACGAP1",
      gene_level : 1,
      hgnc_id : "HGNC:9804",
      havana_gene : "OTTHUMG00000169811.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50057548,
      stop : 50083611,
      direction : "+",
      ID : "ENSG00000110881.12",
      gene_id : "ENSG00000110881.12",
      gene_type : "protein_coding",
      gene_name : "ASIC1",
      gene_level : 1,
      hgnc_id : "HGNC:100",
      havana_gene : "OTTHUMG00000169812.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50085200,
      stop : 50100707,
      direction : "+",
      ID : "ENSG00000066117.15",
      gene_id : "ENSG00000066117.15",
      gene_type : "protein_coding",
      gene_name : "SMARCD1",
      gene_level : 1,
      hgnc_id : "HGNC:11106",
      havana_gene : "OTTHUMG00000150194.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50103982,
      stop : 50111313,
      direction : "+",
      ID : "ENSG00000167588.13",
      gene_id : "ENSG00000167588.13",
      gene_type : "protein_coding",
      gene_name : "GPD1",
      gene_level : 2,
      hgnc_id : "HGNC:4455",
      havana_gene : "OTTHUMG00000169813.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50112082,
      stop : 50120457,
      direction : "+",
      ID : "ENSG00000178449.9",
      gene_id : "ENSG00000178449.9",
      gene_type : "protein_coding",
      gene_name : "COX14",
      gene_level : 2,
      hgnc_id : "HGNC:28216",
      havana_gene : "OTTHUMG00000185635.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50129289,
      stop : 50167533,
      direction : "-",
      ID : "ENSG00000139624.14",
      gene_id : "ENSG00000139624.14",
      gene_type : "protein_coding",
      gene_name : "CERS5",
      gene_level : 1,
      hgnc_id : "HGNC:23749",
      havana_gene : "OTTHUMG00000169819.11",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50175788,
      stop : 50283546,
      direction : "-",
      ID : "ENSG00000050405.13",
      gene_id : "ENSG00000050405.13",
      gene_type : "protein_coding",
      gene_name : "LIMA1",
      gene_level : 2,
      hgnc_id : "HGNC:24636",
      havana_gene : "OTTHUMG00000169852.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50326230,
      stop : 50396622,
      direction : "-",
      ID : "ENSG00000185958.10",
      gene_id : "ENSG00000185958.10",
      gene_type : "protein_coding",
      gene_name : "FAM186A",
      gene_level : 2,
      hgnc_id : "HGNC:26980",
      havana_gene : "OTTHUMG00000167889.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50392383,
      stop : 50480004,
      direction : "+",
      ID : "ENSG00000161813.22",
      gene_id : "ENSG00000161813.22",
      gene_type : "protein_coding",
      gene_name : "LARP4",
      gene_level : 1,
      hgnc_id : "HGNC:24320",
      havana_gene : "OTTHUMG00000163724.14",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50504985,
      stop : 50748657,
      direction : "+",
      ID : "ENSG00000066084.13",
      gene_id : "ENSG00000066084.13",
      gene_type : "protein_coding",
      gene_name : "DIP2B",
      gene_level : 2,
      hgnc_id : "HGNC:29284",
      havana_gene : "OTTHUMG00000169475.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50763710,
      stop : 50821162,
      direction : "+",
      ID : "ENSG00000123268.9",
      gene_id : "ENSG00000123268.9",
      gene_type : "protein_coding",
      gene_name : "ATF1",
      gene_level : 2,
      hgnc_id : "HGNC:783",
      havana_gene : "OTTHUMG00000169482.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50842920,
      stop : 50887884,
      direction : "+",
      ID : "ENSG00000186452.11",
      gene_id : "ENSG00000186452.11",
      gene_type : "protein_coding",
      gene_name : "TMPRSS12",
      gene_level : 2,
      hgnc_id : "HGNC:28779",
      havana_gene : "OTTHUMG00000169483.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50923472,
      stop : 50932510,
      direction : "+",
      ID : "ENSG00000185432.12",
      gene_id : "ENSG00000185432.12",
      gene_type : "protein_coding",
      gene_name : "METTL7A",
      gene_level : 2,
      hgnc_id : "HGNC:24550",
      havana_gene : "OTTHUMG00000169484.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50953922,
      stop : 50970506,
      direction : "+",
      ID : "ENSG00000214511.3",
      gene_id : "ENSG00000214511.3",
      gene_type : "protein_coding",
      gene_name : "HIGD1C",
      gene_level : 2,
      hgnc_id : "HGNC:28044",
      havana_gene : "OTTHUMG00000169488.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 50979401,
      stop : 51028566,
      direction : "-",
      ID : "ENSG00000110911.17",
      gene_id : "ENSG00000110911.17",
      gene_type : "protein_coding",
      gene_name : "SLC11A2",
      gene_level : 1,
      hgnc_id : "HGNC:10908",
      havana_gene : "OTTHUMG00000169493.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51047962,
      stop : 51060424,
      direction : "+",
      ID : "ENSG00000050426.16",
      gene_id : "ENSG00000050426.16",
      gene_type : "protein_coding",
      gene_name : "LETMD1",
      gene_level : 1,
      hgnc_id : "HGNC:24241",
      havana_gene : "OTTHUMG00000169538.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51061205,
      stop : 51083664,
      direction : "-",
      ID : "ENSG00000110925.7",
      gene_id : "ENSG00000110925.7",
      gene_type : "protein_coding",
      gene_name : "CSRNP2",
      gene_level : 1,
      hgnc_id : "HGNC:16006",
      havana_gene : "OTTHUMG00000169578.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51093656,
      stop : 51173135,
      direction : "-",
      ID : "ENSG00000135457.10",
      gene_id : "ENSG00000135457.10",
      gene_type : "protein_coding",
      gene_name : "TFCP2",
      gene_level : 2,
      hgnc_id : "HGNC:11748",
      havana_gene : "OTTHUMG00000169621.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51186936,
      stop : 51217708,
      direction : "-",
      ID : "ENSG00000184271.17",
      gene_id : "ENSG00000184271.17",
      gene_type : "protein_coding",
      gene_name : "POU6F1",
      gene_level : 2,
      hgnc_id : "HGNC:9224",
      havana_gene : "OTTHUMG00000169622.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51238724,
      stop : 51271362,
      direction : "+",
      ID : "ENSG00000183283.16",
      gene_id : "ENSG00000183283.16",
      gene_type : "protein_coding",
      gene_name : "DAZAP2",
      gene_level : 2,
      hgnc_id : "HGNC:2684",
      havana_gene : "OTTHUMG00000169649.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51244558,
      stop : 51270415,
      direction : "-",
      ID : "ENSG00000170545.17",
      gene_id : "ENSG00000170545.17",
      gene_type : "protein_coding",
      gene_name : "SMAGP",
      gene_level : 2,
      hgnc_id : "HGNC:26918",
      havana_gene : "OTTHUMG00000185196.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51281038,
      stop : 51324668,
      direction : "-",
      ID : "ENSG00000110934.13",
      gene_id : "ENSG00000110934.13",
      gene_type : "protein_coding",
      gene_name : "BIN2",
      gene_level : 1,
      hgnc_id : "HGNC:1053",
      havana_gene : "OTTHUMG00000185197.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51328442,
      stop : 51346679,
      direction : "-",
      ID : "ENSG00000139610.2",
      gene_id : "ENSG00000139610.2",
      gene_type : "protein_coding",
      gene_name : "CELA1",
      gene_level : 2,
      hgnc_id : "HGNC:3308",
      havana_gene : "OTTHUMG00000167523.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51351247,
      stop : 51392867,
      direction : "-",
      ID : "ENSG00000139629.16",
      gene_id : "ENSG00000139629.16",
      gene_type : "protein_coding",
      gene_name : "GALNT6",
      gene_level : 2,
      hgnc_id : "HGNC:4128",
      havana_gene : "OTTHUMG00000185181.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51391317,
      stop : 51515763,
      direction : "+",
      ID : "ENSG00000050438.17",
      gene_id : "ENSG00000050438.17",
      gene_type : "protein_coding",
      gene_name : "SLC4A8",
      gene_level : 2,
      hgnc_id : "HGNC:11034",
      havana_gene : "OTTHUMG00000169489.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51590266,
      stop : 51812864,
      direction : "+",
      ID : "ENSG00000196876.18",
      gene_id : "ENSG00000196876.18",
      gene_type : "protein_coding",
      gene_name : "SCN8A",
      gene_level : 1,
      hgnc_id : "HGNC:10596",
      havana_gene : "OTTHUMG00000169490.14",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51813940,
      stop : 51814926,
      direction : "-",
      ID : "ENSG00000284730.1",
      gene_id : "ENSG00000284730.1",
      gene_type : "protein_coding",
      gene_name : "TMDD1",
      gene_level : 2,
      hgnc_id : "HGNC:53646",
      havana_gene : "OTTHUMG00000192217.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51817899,
      stop : 51848718,
      direction : "-",
      ID : "ENSG00000261308.4",
      gene_id : "ENSG00000261308.4",
      gene_type : "protein_coding",
      gene_name : "FIGNL2",
      gene_level : 2,
      hgnc_id : "HGNC:13287",
      havana_gene : "OTTHUMG00000175693.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51888009,
      stop : 51891727,
      direction : "+",
      ID : "ENSG00000167612.13",
      gene_id : "ENSG00000167612.13",
      gene_type : "protein_coding",
      gene_name : "ANKRD33",
      gene_level : 1,
      hgnc_id : "HGNC:13788",
      havana_gene : "OTTHUMG00000169506.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51906908,
      stop : 51923361,
      direction : "+",
      ID : "ENSG00000139567.13",
      gene_id : "ENSG00000139567.13",
      gene_type : "protein_coding",
      gene_name : "ACVRL1",
      gene_level : 1,
      hgnc_id : "HGNC:175",
      havana_gene : "OTTHUMG00000169507.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 51951699,
      stop : 51997078,
      direction : "+",
      ID : "ENSG00000135503.13",
      gene_id : "ENSG00000135503.13",
      gene_type : "protein_coding",
      gene_name : "ACVR1B",
      gene_level : 1,
      hgnc_id : "HGNC:172",
      havana_gene : "OTTHUMG00000167920.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52006946,
      stop : 52015889,
      direction : "+",
      ID : "ENSG00000161835.11",
      gene_id : "ENSG00000161835.11",
      gene_type : "protein_coding",
      gene_name : "TAMALIN",
      gene_level : 2,
      hgnc_id : "HGNC:18707",
      havana_gene : "OTTHUMG00000169595.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52022832,
      stop : 52059507,
      direction : "+",
      ID : "ENSG00000123358.20",
      gene_id : "ENSG00000123358.20",
      gene_type : "protein_coding",
      gene_name : "NR4A1",
      gene_level : 1,
      hgnc_id : "HGNC:7980",
      havana_gene : "OTTHUMG00000150393.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52069246,
      stop : 52077494,
      direction : "+",
      ID : "ENSG00000123395.14",
      gene_id : "ENSG00000123395.14",
      gene_type : "protein_coding",
      gene_name : "ATG101",
      gene_level : 2,
      hgnc_id : "HGNC:25679",
      havana_gene : "OTTHUMG00000169611.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52079704,
      stop : 52108255,
      direction : "+",
      ID : "ENSG00000284791.2",
      gene_id : "ENSG00000284791.2",
      gene_type : "protein_coding",
      gene_name : "SMIM41",
      gene_level : 2,
      hgnc_id : "HGNC:54075",
      havana_gene : "OTTHUMG00000169615.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52168996,
      stop : 52192014,
      direction : "-",
      ID : "ENSG00000167767.14",
      gene_id : "ENSG00000167767.14",
      gene_type : "protein_coding",
      gene_name : "KRT80",
      gene_level : 2,
      hgnc_id : "HGNC:27056",
      havana_gene : "OTTHUMG00000150193.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52232520,
      stop : 52252186,
      direction : "+",
      ID : "ENSG00000135480.16",
      gene_id : "ENSG00000135480.16",
      gene_type : "protein_coding",
      gene_name : "KRT7",
      gene_level : 1,
      hgnc_id : "HGNC:6445",
      havana_gene : "OTTHUMG00000169580.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52249300,
      stop : 52309163,
      direction : "+",
      ID : "ENSG00000170442.12",
      gene_id : "ENSG00000170442.12",
      gene_type : "protein_coding",
      gene_name : "KRT86",
      gene_level : 2,
      hgnc_id : "HGNC:6463",
      havana_gene : "OTTHUMG00000184153.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52285913,
      stop : 52291534,
      direction : "-",
      ID : "ENSG00000205426.10",
      gene_id : "ENSG00000205426.10",
      gene_type : "protein_coding",
      gene_name : "KRT81",
      gene_level : 2,
      hgnc_id : "HGNC:6458",
      havana_gene : "OTTHUMG00000167574.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52314301,
      stop : 52321398,
      direction : "-",
      ID : "ENSG00000170523.3",
      gene_id : "ENSG00000170523.3",
      gene_type : "protein_coding",
      gene_name : "KRT83",
      gene_level : 2,
      hgnc_id : "HGNC:6460",
      havana_gene : "OTTHUMG00000169632.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52360006,
      stop : 52367481,
      direction : "-",
      ID : "ENSG00000135443.8",
      gene_id : "ENSG00000135443.8",
      gene_type : "protein_coding",
      gene_name : "KRT85",
      gene_level : 2,
      hgnc_id : "HGNC:6462",
      havana_gene : "OTTHUMG00000169633.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52377812,
      stop : 52385652,
      direction : "-",
      ID : "ENSG00000161849.3",
      gene_id : "ENSG00000161849.3",
      gene_type : "protein_coding",
      gene_name : "KRT84",
      gene_level : 2,
      hgnc_id : "HGNC:6461",
      havana_gene : "OTTHUMG00000169634.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52393931,
      stop : 52406335,
      direction : "-",
      ID : "ENSG00000161850.3",
      gene_id : "ENSG00000161850.3",
      gene_type : "protein_coding",
      gene_name : "KRT82",
      gene_level : 2,
      hgnc_id : "HGNC:6459",
      havana_gene : "OTTHUMG00000169636.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52424070,
      stop : 52434371,
      direction : "-",
      ID : "ENSG00000170454.6",
      gene_id : "ENSG00000170454.6",
      gene_type : "protein_coding",
      gene_name : "KRT75",
      gene_level : 2,
      hgnc_id : "HGNC:24431",
      havana_gene : "OTTHUMG00000169592.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52446651,
      stop : 52452146,
      direction : "-",
      ID : "ENSG00000185479.6",
      gene_id : "ENSG00000185479.6",
      gene_type : "protein_coding",
      gene_name : "KRT6B",
      gene_level : 2,
      hgnc_id : "HGNC:6444",
      havana_gene : "OTTHUMG00000169593.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52468516,
      stop : 52473805,
      direction : "-",
      ID : "ENSG00000170465.10",
      gene_id : "ENSG00000170465.10",
      gene_type : "protein_coding",
      gene_name : "KRT6C",
      gene_level : 2,
      hgnc_id : "HGNC:20406",
      havana_gene : "OTTHUMG00000169596.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52487176,
      stop : 52493257,
      direction : "-",
      ID : "ENSG00000205420.11",
      gene_id : "ENSG00000205420.11",
      gene_type : "protein_coding",
      gene_name : "KRT6A",
      gene_level : 2,
      hgnc_id : "HGNC:6443",
      havana_gene : "OTTHUMG00000169597.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52514575,
      stop : 52520530,
      direction : "-",
      ID : "ENSG00000186081.12",
      gene_id : "ENSG00000186081.12",
      gene_type : "protein_coding",
      gene_name : "KRT5",
      gene_level : 2,
      hgnc_id : "HGNC:6442",
      havana_gene : "OTTHUMG00000169657.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52543909,
      stop : 52553145,
      direction : "-",
      ID : "ENSG00000139648.7",
      gene_id : "ENSG00000139648.7",
      gene_type : "protein_coding",
      gene_name : "KRT71",
      gene_level : 2,
      hgnc_id : "HGNC:28927",
      havana_gene : "OTTHUMG00000167831.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52565782,
      stop : 52573843,
      direction : "-",
      ID : "ENSG00000170484.10",
      gene_id : "ENSG00000170484.10",
      gene_type : "protein_coding",
      gene_name : "KRT74",
      gene_level : 2,
      hgnc_id : "HGNC:28929",
      havana_gene : "OTTHUMG00000169658.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52585589,
      stop : 52601538,
      direction : "-",
      ID : "ENSG00000170486.11",
      gene_id : "ENSG00000170486.11",
      gene_type : "protein_coding",
      gene_name : "KRT72",
      gene_level : 2,
      hgnc_id : "HGNC:28932",
      havana_gene : "OTTHUMG00000169744.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52607570,
      stop : 52618559,
      direction : "-",
      ID : "ENSG00000186049.8",
      gene_id : "ENSG00000186049.8",
      gene_type : "protein_coding",
      gene_name : "KRT73",
      gene_level : 2,
      hgnc_id : "HGNC:28928",
      havana_gene : "OTTHUMG00000169746.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52644558,
      stop : 52652211,
      direction : "-",
      ID : "ENSG00000172867.4",
      gene_id : "ENSG00000172867.4",
      gene_type : "protein_coding",
      gene_name : "KRT2",
      gene_level : 2,
      hgnc_id : "HGNC:6439",
      havana_gene : "OTTHUMG00000169748.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52674736,
      stop : 52680407,
      direction : "-",
      ID : "ENSG00000167768.4",
      gene_id : "ENSG00000167768.4",
      gene_type : "protein_coding",
      gene_name : "KRT1",
      gene_level : 2,
      hgnc_id : "HGNC:6412",
      havana_gene : "OTTHUMG00000169749.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52689626,
      stop : 52703524,
      direction : "-",
      ID : "ENSG00000189182.10",
      gene_id : "ENSG00000189182.10",
      gene_type : "protein_coding",
      gene_name : "KRT77",
      gene_level : 2,
      hgnc_id : "HGNC:20411",
      havana_gene : "OTTHUMG00000169450.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52768155,
      stop : 52777345,
      direction : "-",
      ID : "ENSG00000185069.2",
      gene_id : "ENSG00000185069.2",
      gene_type : "protein_coding",
      gene_name : "KRT76",
      gene_level : 2,
      hgnc_id : "HGNC:24430",
      havana_gene : "OTTHUMG00000169797.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52789685,
      stop : 52796117,
      direction : "-",
      ID : "ENSG00000186442.7",
      gene_id : "ENSG00000186442.7",
      gene_type : "protein_coding",
      gene_name : "KRT3",
      gene_level : 2,
      hgnc_id : "HGNC:6440",
      havana_gene : "OTTHUMG00000169799.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52806549,
      stop : 52814116,
      direction : "-",
      ID : "ENSG00000170477.13",
      gene_id : "ENSG00000170477.13",
      gene_type : "protein_coding",
      gene_name : "KRT4",
      gene_level : 2,
      hgnc_id : "HGNC:6441",
      havana_gene : "OTTHUMG00000169800.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52821408,
      stop : 52834311,
      direction : "-",
      ID : "ENSG00000185640.6",
      gene_id : "ENSG00000185640.6",
      gene_type : "protein_coding",
      gene_name : "KRT79",
      gene_level : 2,
      hgnc_id : "HGNC:28930",
      havana_gene : "OTTHUMG00000169878.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52837804,
      stop : 52849092,
      direction : "-",
      ID : "ENSG00000170423.13",
      gene_id : "ENSG00000170423.13",
      gene_type : "protein_coding",
      gene_name : "KRT78",
      gene_level : 2,
      hgnc_id : "HGNC:28926",
      havana_gene : "OTTHUMG00000169880.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52897187,
      stop : 52949954,
      direction : "-",
      ID : "ENSG00000170421.12",
      gene_id : "ENSG00000170421.12",
      gene_type : "protein_coding",
      gene_name : "KRT8",
      gene_level : 1,
      hgnc_id : "HGNC:6446",
      havana_gene : "OTTHUMG00000169881.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 52948871,
      stop : 52952906,
      direction : "+",
      ID : "ENSG00000111057.11",
      gene_id : "ENSG00000111057.11",
      gene_type : "protein_coding",
      gene_name : "KRT18",
      gene_level : 2,
      hgnc_id : "HGNC:6430",
      havana_gene : "OTTHUMG00000169882.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53006282,
      stop : 53042215,
      direction : "+",
      ID : "ENSG00000063046.18",
      gene_id : "ENSG00000063046.18",
      gene_type : "protein_coding",
      gene_name : "EIF4B",
      gene_level : 1,
      hgnc_id : "HGNC:3285",
      havana_gene : "OTTHUMG00000169570.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53046969,
      stop : 53064379,
      direction : "+",
      ID : "ENSG00000111077.18",
      gene_id : "ENSG00000111077.18",
      gene_type : "protein_coding",
      gene_name : "TNS2",
      gene_level : 1,
      hgnc_id : "HGNC:19737",
      havana_gene : "OTTHUMG00000169730.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53064316,
      stop : 53079404,
      direction : "-",
      ID : "ENSG00000167778.9",
      gene_id : "ENSG00000167778.9",
      gene_type : "protein_coding",
      gene_name : "SPRYD3",
      gene_level : 1,
      hgnc_id : "HGNC:25920",
      havana_gene : "OTTHUMG00000170101.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53097436,
      stop : 53102345,
      direction : "+",
      ID : "ENSG00000167779.9",
      gene_id : "ENSG00000167779.9",
      gene_type : "protein_coding",
      gene_name : "IGFBP6",
      gene_level : 1,
      hgnc_id : "HGNC:5475",
      havana_gene : "OTTHUMG00000169773.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53103486,
      stop : 53124535,
      direction : "+",
      ID : "ENSG00000167780.12",
      gene_id : "ENSG00000167780.12",
      gene_type : "protein_coding",
      gene_name : "SOAT2",
      gene_level : 1,
      hgnc_id : "HGNC:11178",
      havana_gene : "OTTHUMG00000169774.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53157663,
      stop : 53180925,
      direction : "-",
      ID : "ENSG00000139631.19",
      gene_id : "ENSG00000139631.19",
      gene_type : "protein_coding",
      gene_name : "CSAD",
      gene_level : 1,
      hgnc_id : "HGNC:18966",
      havana_gene : "OTTHUMG00000048076.12",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53180704,
      stop : 53195142,
      direction : "+",
      ID : "ENSG00000139651.11",
      gene_id : "ENSG00000139651.11",
      gene_type : "protein_coding",
      gene_name : "ZNF740",
      gene_level : 1,
      hgnc_id : "HGNC:27465",
      havana_gene : "OTTHUMG00000170027.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53191323,
      stop : 53207282,
      direction : "-",
      ID : "ENSG00000139626.16",
      gene_id : "ENSG00000139626.16",
      gene_type : "protein_coding",
      gene_name : "ITGB7",
      gene_level : 1,
      hgnc_id : "HGNC:6162",
      havana_gene : "OTTHUMG00000169775.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53210567,
      stop : 53232980,
      direction : "-",
      ID : "ENSG00000172819.17",
      gene_id : "ENSG00000172819.17",
      gene_type : "protein_coding",
      gene_name : "RARG",
      gene_level : 2,
      hgnc_id : "HGNC:9866",
      havana_gene : "OTTHUMG00000048077.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53241889,
      stop : 53242723,
      direction : "+",
      ID : "ENSG00000283536.2",
      gene_id : "ENSG00000283536.2",
      gene_type : "protein_coding",
      gene_name : "AC021072.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000191815.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53251251,
      stop : 53254406,
      direction : "+",
      ID : "ENSG00000182544.9",
      gene_id : "ENSG00000182544.9",
      gene_type : "protein_coding",
      gene_name : "MFSD5",
      gene_level : 2,
      hgnc_id : "HGNC:28156",
      havana_gene : "OTTHUMG00000170028.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53268299,
      stop : 53293638,
      direction : "+",
      ID : "ENSG00000135476.12",
      gene_id : "ENSG00000135476.12",
      gene_type : "protein_coding",
      gene_name : "ESPL1",
      gene_level : 2,
      hgnc_id : "HGNC:16856",
      havana_gene : "OTTHUMG00000169674.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53295291,
      stop : 53299452,
      direction : "+",
      ID : "ENSG00000123349.15",
      gene_id : "ENSG00000123349.15",
      gene_type : "protein_coding",
      gene_name : "PFDN5",
      gene_level : 1,
      hgnc_id : "HGNC:8869",
      havana_gene : "OTTHUMG00000169675.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53299695,
      stop : 53307177,
      direction : "+",
      ID : "ENSG00000139637.14",
      gene_id : "ENSG00000139637.14",
      gene_type : "protein_coding",
      gene_name : "MYG1",
      gene_level : 1,
      hgnc_id : "HGNC:17590",
      havana_gene : "OTTHUMG00000170030.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53307456,
      stop : 53324864,
      direction : "-",
      ID : "ENSG00000094914.14",
      gene_id : "ENSG00000094914.14",
      gene_type : "protein_coding",
      gene_name : "AAAS",
      gene_level : 1,
      hgnc_id : "HGNC:13666",
      havana_gene : "OTTHUMG00000169729.12",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53326575,
      stop : 53345315,
      direction : "-",
      ID : "ENSG00000170374.6",
      gene_id : "ENSG00000170374.6",
      gene_type : "protein_coding",
      gene_name : "SP7",
      gene_level : 1,
      hgnc_id : "HGNC:17321",
      havana_gene : "OTTHUMG00000170031.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53380176,
      stop : 53416446,
      direction : "+",
      ID : "ENSG00000185591.10",
      gene_id : "ENSG00000185591.10",
      gene_type : "protein_coding",
      gene_name : "SP1",
      gene_level : 1,
      hgnc_id : "HGNC:11205",
      havana_gene : "OTTHUMG00000170047.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53423855,
      stop : 53431672,
      direction : "+",
      ID : "ENSG00000135409.11",
      gene_id : "ENSG00000135409.11",
      gene_type : "protein_coding",
      gene_name : "AMHR2",
      gene_level : 1,
      hgnc_id : "HGNC:465",
      havana_gene : "OTTHUMG00000170048.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53441678,
      stop : 53446645,
      direction : "+",
      ID : "ENSG00000205352.11",
      gene_id : "ENSG00000205352.11",
      gene_type : "protein_coding",
      gene_name : "PRR13",
      gene_level : 2,
      hgnc_id : "HGNC:24528",
      havana_gene : "OTTHUMG00000170049.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53452102,
      stop : 53481162,
      direction : "+",
      ID : "ENSG00000197111.16",
      gene_id : "ENSG00000197111.16",
      gene_type : "protein_coding",
      gene_name : "PCBP2",
      gene_level : 1,
      hgnc_id : "HGNC:8648",
      havana_gene : "OTTHUMG00000169439.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53479669,
      stop : 53500063,
      direction : "-",
      ID : "ENSG00000139625.13",
      gene_id : "ENSG00000139625.13",
      gene_type : "protein_coding",
      gene_name : "MAP3K12",
      gene_level : 1,
      hgnc_id : "HGNC:6851",
      havana_gene : "OTTHUMG00000169854.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53500921,
      stop : 53506431,
      direction : "+",
      ID : "ENSG00000139546.11",
      gene_id : "ENSG00000139546.11",
      gene_type : "protein_coding",
      gene_name : "TARBP2",
      gene_level : 1,
      hgnc_id : "HGNC:11569",
      havana_gene : "OTTHUMG00000169855.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53506688,
      stop : 53625979,
      direction : "-",
      ID : "ENSG00000267281.2",
      gene_id : "ENSG00000267281.2",
      gene_type : "protein_coding",
      gene_name : "ATF7-NPFF",
      gene_level : 2,
      hgnc_id : "HGNC:55073",
      havana_gene : "OTTHUMG00000182349.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53506690,
      stop : 53507638,
      direction : "-",
      ID : "ENSG00000139574.8",
      gene_id : "ENSG00000139574.8",
      gene_type : "protein_coding",
      gene_name : "NPFF",
      gene_level : 2,
      hgnc_id : "HGNC:7901",
      havana_gene : "OTTHUMG00000169856.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53507856,
      stop : 53626410,
      direction : "-",
      ID : "ENSG00000170653.19",
      gene_id : "ENSG00000170653.19",
      gene_type : "protein_coding",
      gene_name : "ATF7",
      gene_level : 2,
      hgnc_id : "HGNC:792",
      havana_gene : "OTTHUMG00000169776.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53632726,
      stop : 53677408,
      direction : "-",
      ID : "ENSG00000135390.21",
      gene_id : "ENSG00000135390.21",
      gene_type : "protein_coding",
      gene_name : "ATP5MC2",
      gene_level : 1,
      hgnc_id : "HGNC:842",
      havana_gene : "OTTHUMG00000133442.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53708517,
      stop : 53727745,
      direction : "-",
      ID : "ENSG00000012822.16",
      gene_id : "ENSG00000012822.16",
      gene_type : "protein_coding",
      gene_name : "CALCOCO1",
      gene_level : 1,
      hgnc_id : "HGNC:29306",
      havana_gene : "OTTHUMG00000170095.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53938831,
      stop : 53946544,
      direction : "+",
      ID : "ENSG00000123364.5",
      gene_id : "ENSG00000123364.5",
      gene_type : "protein_coding",
      gene_name : "HOXC13",
      gene_level : 2,
      hgnc_id : "HGNC:5125",
      havana_gene : "OTTHUMG00000160008.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53954903,
      stop : 53958956,
      direction : "+",
      ID : "ENSG00000123407.4",
      gene_id : "ENSG00000123407.4",
      gene_type : "protein_coding",
      gene_name : "HOXC12",
      gene_level : 2,
      hgnc_id : "HGNC:5124",
      havana_gene : "OTTHUMG00000160010.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53973126,
      stop : 53977643,
      direction : "+",
      ID : "ENSG00000123388.4",
      gene_id : "ENSG00000123388.4",
      gene_type : "protein_coding",
      gene_name : "HOXC11",
      gene_level : 1,
      hgnc_id : "HGNC:5123",
      havana_gene : "OTTHUMG00000160011.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53985065,
      stop : 53990279,
      direction : "+",
      ID : "ENSG00000180818.5",
      gene_id : "ENSG00000180818.5",
      gene_type : "protein_coding",
      gene_name : "HOXC10",
      gene_level : 1,
      hgnc_id : "HGNC:5122",
      havana_gene : "OTTHUMG00000160031.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53985845,
      stop : 54034888,
      direction : "+",
      ID : "ENSG00000273049.1",
      gene_id : "ENSG00000273049.1",
      gene_type : "protein_coding",
      gene_name : "AC012531.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000186015.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53990624,
      stop : 54030823,
      direction : "+",
      ID : "ENSG00000197757.8",
      gene_id : "ENSG00000197757.8",
      gene_type : "protein_coding",
      gene_name : "HOXC6",
      gene_level : 2,
      hgnc_id : "HGNC:5128",
      havana_gene : "OTTHUMG00000160027.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 53994895,
      stop : 54003337,
      direction : "+",
      ID : "ENSG00000180806.5",
      gene_id : "ENSG00000180806.5",
      gene_type : "protein_coding",
      gene_name : "HOXC9",
      gene_level : 2,
      hgnc_id : "HGNC:5130",
      havana_gene : "OTTHUMG00000160033.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54008985,
      stop : 54012769,
      direction : "+",
      ID : "ENSG00000037965.6",
      gene_id : "ENSG00000037965.6",
      gene_type : "protein_coding",
      gene_name : "HOXC8",
      gene_level : 2,
      hgnc_id : "HGNC:5129",
      havana_gene : "OTTHUMG00000160032.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54016931,
      stop : 54056030,
      direction : "+",
      ID : "ENSG00000198353.8",
      gene_id : "ENSG00000198353.8",
      gene_type : "protein_coding",
      gene_name : "HOXC4",
      gene_level : 1,
      hgnc_id : "HGNC:5126",
      havana_gene : "OTTHUMG00000160036.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54033050,
      stop : 54035361,
      direction : "+",
      ID : "ENSG00000172789.4",
      gene_id : "ENSG00000172789.4",
      gene_type : "protein_coding",
      gene_name : "HOXC5",
      gene_level : 1,
      hgnc_id : "HGNC:5127",
      havana_gene : "OTTHUMG00000160028.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54121277,
      stop : 54189008,
      direction : "-",
      ID : "ENSG00000123415.15",
      gene_id : "ENSG00000123415.15",
      gene_type : "protein_coding",
      gene_name : "SMUG1",
      gene_level : 1,
      hgnc_id : "HGNC:17148",
      havana_gene : "OTTHUMG00000160068.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54230942,
      stop : 54280133,
      direction : "-",
      ID : "ENSG00000094916.16",
      gene_id : "ENSG00000094916.16",
      gene_type : "protein_coding",
      gene_name : "CBX5",
      gene_level : 1,
      hgnc_id : "HGNC:1555",
      havana_gene : "OTTHUMG00000169700.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54280193,
      stop : 54287088,
      direction : "+",
      ID : "ENSG00000135486.19",
      gene_id : "ENSG00000135486.19",
      gene_type : "protein_coding",
      gene_name : "HNRNPA1",
      gene_level : 2,
      hgnc_id : "HGNC:5031",
      havana_gene : "OTTHUMG00000169702.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54292111,
      stop : 54301015,
      direction : "-",
      ID : "ENSG00000123405.14",
      gene_id : "ENSG00000123405.14",
      gene_type : "protein_coding",
      gene_name : "NFE2",
      gene_level : 2,
      hgnc_id : "HGNC:7780",
      havana_gene : "OTTHUMG00000169761.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54301202,
      stop : 54351846,
      direction : "+",
      ID : "ENSG00000111481.10",
      gene_id : "ENSG00000111481.10",
      gene_type : "protein_coding",
      gene_name : "COPZ1",
      gene_level : 2,
      hgnc_id : "HGNC:2243",
      havana_gene : "OTTHUMG00000169762.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54362445,
      stop : 54364487,
      direction : "-",
      ID : "ENSG00000139572.4",
      gene_id : "ENSG00000139572.4",
      gene_type : "protein_coding",
      gene_name : "GPR84",
      gene_level : 2,
      hgnc_id : "HGNC:4535",
      havana_gene : "OTTHUMG00000169839.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54369133,
      stop : 54391298,
      direction : "-",
      ID : "ENSG00000161642.18",
      gene_id : "ENSG00000161642.18",
      gene_type : "protein_coding",
      gene_name : "ZNF385A",
      gene_level : 2,
      hgnc_id : "HGNC:17521",
      havana_gene : "OTTHUMG00000169840.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54395261,
      stop : 54419266,
      direction : "-",
      ID : "ENSG00000161638.11",
      gene_id : "ENSG00000161638.11",
      gene_type : "protein_coding",
      gene_name : "ITGA5",
      gene_level : 2,
      hgnc_id : "HGNC:6141",
      havana_gene : "OTTHUMG00000169841.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54455950,
      stop : 54473602,
      direction : "-",
      ID : "ENSG00000170627.11",
      gene_id : "ENSG00000170627.11",
      gene_type : "protein_coding",
      gene_name : "GTSF1",
      gene_level : 2,
      hgnc_id : "HGNC:26565",
      havana_gene : "OTTHUMG00000169842.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54497752,
      stop : 54548243,
      direction : "+",
      ID : "ENSG00000123338.13",
      gene_id : "ENSG00000123338.13",
      gene_type : "protein_coding",
      gene_name : "NCKAP1L",
      gene_level : 2,
      hgnc_id : "HGNC:4862",
      havana_gene : "OTTHUMG00000169843.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54549601,
      stop : 54579239,
      direction : "+",
      ID : "ENSG00000123360.12",
      gene_id : "ENSG00000123360.12",
      gene_type : "protein_coding",
      gene_name : "PDE1B",
      gene_level : 1,
      hgnc_id : "HGNC:8775",
      havana_gene : "OTTHUMG00000169844.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54575387,
      stop : 54588659,
      direction : "-",
      ID : "ENSG00000135447.17",
      gene_id : "ENSG00000135447.17",
      gene_type : "protein_coding",
      gene_name : "PPP1R1A",
      gene_level : 2,
      hgnc_id : "HGNC:9286",
      havana_gene : "OTTHUMG00000169934.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54630811,
      stop : 54634895,
      direction : "-",
      ID : "ENSG00000135413.9",
      gene_id : "ENSG00000135413.9",
      gene_type : "protein_coding",
      gene_name : "LACRT",
      gene_level : 2,
      hgnc_id : "HGNC:16430",
      havana_gene : "OTTHUMG00000169936.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54644589,
      stop : 54648493,
      direction : "-",
      ID : "ENSG00000161634.12",
      gene_id : "ENSG00000161634.12",
      gene_type : "protein_coding",
      gene_name : "DCD",
      gene_level : 2,
      hgnc_id : "HGNC:14669",
      havana_gene : "OTTHUMG00000169937.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54830518,
      stop : 54896008,
      direction : "+",
      ID : "ENSG00000172551.11",
      gene_id : "ENSG00000172551.11",
      gene_type : "protein_coding",
      gene_name : "MUCL1",
      gene_level : 2,
      hgnc_id : "HGNC:30588",
      havana_gene : "OTTHUMG00000169815.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 54948015,
      stop : 54984762,
      direction : "-",
      ID : "ENSG00000135426.16",
      gene_id : "ENSG00000135426.16",
      gene_type : "protein_coding",
      gene_name : "TESPA1",
      gene_level : 1,
      hgnc_id : "HGNC:29109",
      havana_gene : "OTTHUMG00000165407.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55019974,
      stop : 55030017,
      direction : "+",
      ID : "ENSG00000123307.4",
      gene_id : "ENSG00000123307.4",
      gene_type : "protein_coding",
      gene_name : "NEUROD4",
      gene_level : 2,
      hgnc_id : "HGNC:13802",
      havana_gene : "OTTHUMG00000169826.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55126406,
      stop : 55132750,
      direction : "+",
      ID : "ENSG00000170605.6",
      gene_id : "ENSG00000170605.6",
      gene_type : "protein_coding",
      gene_name : "OR9K2",
      gene_level : 2,
      hgnc_id : "HGNC:15339",
      havana_gene : "OTTHUMG00000169827.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55221025,
      stop : 55221975,
      direction : "+",
      ID : "ENSG00000179919.3",
      gene_id : "ENSG00000179919.3",
      gene_type : "protein_coding",
      gene_name : "OR10A7",
      gene_level : 2,
      hgnc_id : "HGNC:15329",
      havana_gene : "OTTHUMG00000169860.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55247198,
      stop : 55248302,
      direction : "+",
      ID : "ENSG00000197706.3",
      gene_id : "ENSG00000197706.3",
      gene_type : "protein_coding",
      gene_name : "OR6C74",
      gene_level : 2,
      hgnc_id : "HGNC:31303",
      havana_gene : "OTTHUMG00000165162.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55293988,
      stop : 55296569,
      direction : "-",
      ID : "ENSG00000188324.4",
      gene_id : "ENSG00000188324.4",
      gene_type : "protein_coding",
      gene_name : "OR6C6",
      gene_level : 2,
      hgnc_id : "HGNC:31293",
      havana_gene : "OTTHUMG00000168101.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55314343,
      stop : 55322364,
      direction : "+",
      ID : "ENSG00000205330.4",
      gene_id : "ENSG00000205330.4",
      gene_type : "protein_coding",
      gene_name : "OR6C1",
      gene_level : 2,
      hgnc_id : "HGNC:8355",
      havana_gene : "OTTHUMG00000168102.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55330043,
      stop : 55332687,
      direction : "+",
      ID : "ENSG00000205329.2",
      gene_id : "ENSG00000205329.2",
      gene_type : "protein_coding",
      gene_name : "OR6C3",
      gene_level : 2,
      hgnc_id : "HGNC:15437",
      havana_gene : "OTTHUMG00000169861.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55362975,
      stop : 55369279,
      direction : "+",
      ID : "ENSG00000187857.4",
      gene_id : "ENSG00000187857.4",
      gene_type : "protein_coding",
      gene_name : "OR6C75",
      gene_level : 2,
      hgnc_id : "HGNC:31304",
      havana_gene : "OTTHUMG00000169886.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55400430,
      stop : 55401505,
      direction : "+",
      ID : "ENSG00000205328.2",
      gene_id : "ENSG00000205328.2",
      gene_type : "protein_coding",
      gene_name : "OR6C65",
      gene_level : 2,
      hgnc_id : "HGNC:31295",
      havana_gene : "OTTHUMG00000169955.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55426254,
      stop : 55427192,
      direction : "+",
      ID : "ENSG00000185821.3",
      gene_id : "ENSG00000185821.3",
      gene_type : "protein_coding",
      gene_name : "OR6C76",
      gene_level : 2,
      hgnc_id : "HGNC:31305",
      havana_gene : "OTTHUMG00000169956.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55444069,
      stop : 55453347,
      direction : "+",
      ID : "ENSG00000179695.3",
      gene_id : "ENSG00000179695.3",
      gene_type : "protein_coding",
      gene_name : "OR6C2",
      gene_level : 2,
      hgnc_id : "HGNC:15436",
      havana_gene : "OTTHUMG00000169957.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55469200,
      stop : 55470138,
      direction : "-",
      ID : "ENSG00000184954.4",
      gene_id : "ENSG00000184954.4",
      gene_type : "protein_coding",
      gene_name : "OR6C70",
      gene_level : 2,
      hgnc_id : "HGNC:31299",
      havana_gene : "OTTHUMG00000171127.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55492378,
      stop : 55493316,
      direction : "+",
      ID : "ENSG00000205327.3",
      gene_id : "ENSG00000205327.3",
      gene_type : "protein_coding",
      gene_name : "OR6C68",
      gene_level : 2,
      hgnc_id : "HGNC:31297",
      havana_gene : "OTTHUMG00000169958.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55549602,
      stop : 55555832,
      direction : "+",
      ID : "ENSG00000179626.4",
      gene_id : "ENSG00000179626.4",
      gene_type : "protein_coding",
      gene_name : "OR6C4",
      gene_level : 2,
      hgnc_id : "HGNC:19632",
      havana_gene : "OTTHUMG00000169959.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55572468,
      stop : 55575612,
      direction : "+",
      ID : "ENSG00000179615.3",
      gene_id : "ENSG00000179615.3",
      gene_type : "protein_coding",
      gene_name : "OR2AP1",
      gene_level : 2,
      hgnc_id : "HGNC:15335",
      havana_gene : "OTTHUMG00000169960.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55636860,
      stop : 55637854,
      direction : "+",
      ID : "ENSG00000175398.2",
      gene_id : "ENSG00000175398.2",
      gene_type : "protein_coding",
      gene_name : "OR10P1",
      gene_level : 2,
      hgnc_id : "HGNC:15378",
      havana_gene : "OTTHUMG00000169961.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55681678,
      stop : 55684611,
      direction : "+",
      ID : "ENSG00000170439.7",
      gene_id : "ENSG00000170439.7",
      gene_type : "protein_coding",
      gene_name : "METTL7B",
      gene_level : 2,
      hgnc_id : "HGNC:28276",
      havana_gene : "OTTHUMG00000152665.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55684568,
      stop : 55716043,
      direction : "-",
      ID : "ENSG00000135424.18",
      gene_id : "ENSG00000135424.18",
      gene_type : "protein_coding",
      gene_name : "ITGA7",
      gene_level : 2,
      hgnc_id : "HGNC:6143",
      havana_gene : "OTTHUMG00000170699.17",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55716036,
      stop : 55724703,
      direction : "+",
      ID : "ENSG00000258311.5",
      gene_id : "ENSG00000258311.5",
      gene_type : "protein_coding",
      gene_name : "AC009779.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170130.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55716037,
      stop : 55720087,
      direction : "+",
      ID : "ENSG00000135441.7",
      gene_id : "ENSG00000135441.7",
      gene_type : "protein_coding",
      gene_name : "BLOC1S1",
      gene_level : 2,
      hgnc_id : "HGNC:4200",
      havana_gene : "OTTHUMG00000169962.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55720367,
      stop : 55724705,
      direction : "+",
      ID : "ENSG00000135437.10",
      gene_id : "ENSG00000135437.10",
      gene_type : "protein_coding",
      gene_name : "RDH5",
      gene_level : 1,
      hgnc_id : "HGNC:9940",
      havana_gene : "OTTHUMG00000170126.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55725323,
      stop : 55729707,
      direction : "-",
      ID : "ENSG00000135404.12",
      gene_id : "ENSG00000135404.12",
      gene_type : "protein_coding",
      gene_name : "CD63",
      gene_level : 1,
      hgnc_id : "HGNC:1692",
      havana_gene : "OTTHUMG00000170454.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55743122,
      stop : 55757264,
      direction : "+",
      ID : "ENSG00000135414.10",
      gene_id : "ENSG00000135414.10",
      gene_type : "protein_coding",
      gene_name : "GDF11",
      gene_level : 2,
      hgnc_id : "HGNC:4216",
      havana_gene : "OTTHUMG00000170188.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55752463,
      stop : 55817724,
      direction : "-",
      ID : "ENSG00000205323.9",
      gene_id : "ENSG00000205323.9",
      gene_type : "protein_coding",
      gene_name : "SARNP",
      gene_level : 2,
      hgnc_id : "HGNC:24432",
      havana_gene : "OTTHUMG00000170441.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55757275,
      stop : 55827546,
      direction : "-",
      ID : "ENSG00000257390.5",
      gene_id : "ENSG00000257390.5",
      gene_type : "protein_coding",
      gene_name : "AC023055.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170449.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55818041,
      stop : 55821879,
      direction : "+",
      ID : "ENSG00000123353.10",
      gene_id : "ENSG00000123353.10",
      gene_type : "protein_coding",
      gene_name : "ORMDL2",
      gene_level : 1,
      hgnc_id : "HGNC:16037",
      havana_gene : "OTTHUMG00000170202.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55820960,
      stop : 55830824,
      direction : "-",
      ID : "ENSG00000135392.19",
      gene_id : "ENSG00000135392.19",
      gene_type : "protein_coding",
      gene_name : "DNAJC14",
      gene_level : 2,
      hgnc_id : "HGNC:24581",
      havana_gene : "OTTHUMG00000170427.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55835433,
      stop : 55842966,
      direction : "-",
      ID : "ENSG00000123342.16",
      gene_id : "ENSG00000123342.16",
      gene_type : "protein_coding",
      gene_name : "MMP19",
      gene_level : 1,
      hgnc_id : "HGNC:7165",
      havana_gene : "OTTHUMG00000170216.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55901413,
      stop : 55932618,
      direction : "-",
      ID : "ENSG00000170473.17",
      gene_id : "ENSG00000170473.17",
      gene_type : "protein_coding",
      gene_name : "PYM1",
      gene_level : 2,
      hgnc_id : "HGNC:30258",
      havana_gene : "OTTHUMG00000170220.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55927319,
      stop : 55954027,
      direction : "+",
      ID : "ENSG00000065357.20",
      gene_id : "ENSG00000065357.20",
      gene_type : "protein_coding",
      gene_name : "DGKA",
      gene_level : 2,
      hgnc_id : "HGNC:2849",
      havana_gene : "OTTHUMG00000170109.14",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55954105,
      stop : 55973317,
      direction : "-",
      ID : "ENSG00000185664.15",
      gene_id : "ENSG00000185664.15",
      gene_type : "protein_coding",
      gene_name : "PMEL",
      gene_level : 1,
      hgnc_id : "HGNC:10880",
      havana_gene : "OTTHUMG00000170573.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55966781,
      stop : 55972789,
      direction : "+",
      ID : "ENSG00000123374.11",
      gene_id : "ENSG00000123374.11",
      gene_type : "protein_coding",
      gene_name : "CDK2",
      gene_level : 1,
      hgnc_id : "HGNC:1771",
      havana_gene : "OTTHUMG00000170575.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55973913,
      stop : 55996683,
      direction : "+",
      ID : "ENSG00000111540.16",
      gene_id : "ENSG00000111540.16",
      gene_type : "protein_coding",
      gene_name : "RAB5B",
      gene_level : 1,
      hgnc_id : "HGNC:9784",
      havana_gene : "OTTHUMG00000169682.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 55997180,
      stop : 56006641,
      direction : "+",
      ID : "ENSG00000139531.13",
      gene_id : "ENSG00000139531.13",
      gene_type : "protein_coding",
      gene_name : "SUOX",
      gene_level : 2,
      hgnc_id : "HGNC:11460",
      havana_gene : "OTTHUMG00000128503.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56007659,
      stop : 56038435,
      direction : "+",
      ID : "ENSG00000123411.15",
      gene_id : "ENSG00000123411.15",
      gene_type : "protein_coding",
      gene_name : "IKZF4",
      gene_level : 1,
      hgnc_id : "HGNC:13179",
      havana_gene : "OTTHUMG00000170132.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56041351,
      stop : 56044697,
      direction : "+",
      ID : "ENSG00000197728.11",
      gene_id : "ENSG00000197728.11",
      gene_type : "protein_coding",
      gene_name : "RPS26",
      gene_level : 2,
      hgnc_id : "HGNC:10414",
      havana_gene : "OTTHUMG00000170139.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56076799,
      stop : 56103505,
      direction : "+",
      ID : "ENSG00000065361.16",
      gene_id : "ENSG00000065361.16",
      gene_type : "protein_coding",
      gene_name : "ERBB3",
      gene_level : 2,
      hgnc_id : "HGNC:3431",
      havana_gene : "OTTHUMG00000170140.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56101331,
      stop : 56109289,
      direction : "+",
      ID : "ENSG00000257411.2",
      gene_id : "ENSG00000257411.2",
      gene_type : "protein_coding",
      gene_name : "AC034102.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170152.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56104537,
      stop : 56113910,
      direction : "+",
      ID : "ENSG00000170515.14",
      gene_id : "ENSG00000170515.14",
      gene_type : "protein_coding",
      gene_name : "PA2G4",
      gene_level : 1,
      hgnc_id : "HGNC:8550",
      havana_gene : "OTTHUMG00000170173.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56116590,
      stop : 56117967,
      direction : "+",
      ID : "ENSG00000229117.9",
      gene_id : "ENSG00000229117.9",
      gene_type : "protein_coding",
      gene_name : "RPL41",
      gene_level : 2,
      hgnc_id : "HGNC:10354",
      havana_gene : "OTTHUMG00000170183.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56118250,
      stop : 56144674,
      direction : "+",
      ID : "ENSG00000139641.13",
      gene_id : "ENSG00000139641.13",
      gene_type : "protein_coding",
      gene_name : "ESYT1",
      gene_level : 2,
      hgnc_id : "HGNC:29534",
      havana_gene : "OTTHUMG00000170197.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56118260,
      stop : 56127514,
      direction : "+",
      ID : "ENSG00000135482.7",
      gene_id : "ENSG00000135482.7",
      gene_type : "protein_coding",
      gene_name : "ZC3H10",
      gene_level : 2,
      hgnc_id : "HGNC:25893",
      havana_gene : "OTTHUMG00000170184.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56152256,
      stop : 56159647,
      direction : "+",
      ID : "ENSG00000196465.10",
      gene_id : "ENSG00000196465.10",
      gene_type : "protein_coding",
      gene_name : "MYL6B",
      gene_level : 2,
      hgnc_id : "HGNC:29823",
      havana_gene : "OTTHUMG00000170199.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56158346,
      stop : 56163496,
      direction : "+",
      ID : "ENSG00000092841.19",
      gene_id : "ENSG00000092841.19",
      gene_type : "protein_coding",
      gene_name : "MYL6",
      gene_level : 2,
      hgnc_id : "HGNC:7587",
      havana_gene : "OTTHUMG00000170200.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56162359,
      stop : 56189567,
      direction : "-",
      ID : "ENSG00000139613.12",
      gene_id : "ENSG00000139613.12",
      gene_type : "protein_coding",
      gene_name : "SMARCC2",
      gene_level : 2,
      hgnc_id : "HGNC:11105",
      havana_gene : "OTTHUMG00000170288.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56202179,
      stop : 56221933,
      direction : "-",
      ID : "ENSG00000181852.18",
      gene_id : "ENSG00000181852.18",
      gene_type : "protein_coding",
      gene_name : "RNF41",
      gene_level : 2,
      hgnc_id : "HGNC:18401",
      havana_gene : "OTTHUMG00000170328.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56222015,
      stop : 56229854,
      direction : "+",
      ID : "ENSG00000139579.13",
      gene_id : "ENSG00000139579.13",
      gene_type : "protein_coding",
      gene_name : "NABP2",
      gene_level : 2,
      hgnc_id : "HGNC:28412",
      havana_gene : "OTTHUMG00000152527.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56230049,
      stop : 56237846,
      direction : "+",
      ID : "ENSG00000139540.12",
      gene_id : "ENSG00000139540.12",
      gene_type : "protein_coding",
      gene_name : "SLC39A5",
      gene_level : 1,
      hgnc_id : "HGNC:20502",
      havana_gene : "OTTHUMG00000156962.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56237807,
      stop : 56258384,
      direction : "-",
      ID : "ENSG00000139645.11",
      gene_id : "ENSG00000139645.11",
      gene_type : "protein_coding",
      gene_name : "ANKRD52",
      gene_level : 2,
      hgnc_id : "HGNC:26614",
      havana_gene : "OTTHUMG00000170329.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56266890,
      stop : 56270966,
      direction : "+",
      ID : "ENSG00000135469.14",
      gene_id : "ENSG00000135469.14",
      gene_type : "protein_coding",
      gene_name : "COQ10A",
      gene_level : 2,
      hgnc_id : "HGNC:26515",
      havana_gene : "OTTHUMG00000170283.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56271699,
      stop : 56300391,
      direction : "-",
      ID : "ENSG00000062485.19",
      gene_id : "ENSG00000062485.19",
      gene_type : "protein_coding",
      gene_name : "CS",
      gene_level : 1,
      hgnc_id : "HGNC:2422",
      havana_gene : "OTTHUMG00000170344.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56285916,
      stop : 56316059,
      direction : "-",
      ID : "ENSG00000144785.8",
      gene_id : "ENSG00000144785.8",
      gene_type : "protein_coding",
      gene_name : "AC073896.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170347.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56309842,
      stop : 56316119,
      direction : "-",
      ID : "ENSG00000257727.6",
      gene_id : "ENSG00000257727.6",
      gene_type : "protein_coding",
      gene_name : "CNPY2",
      gene_level : 2,
      hgnc_id : "HGNC:13529",
      havana_gene : "OTTHUMG00000170330.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56316223,
      stop : 56334053,
      direction : "-",
      ID : "ENSG00000135473.15",
      gene_id : "ENSG00000135473.15",
      gene_type : "protein_coding",
      gene_name : "PAN2",
      gene_level : 1,
      hgnc_id : "HGNC:20074",
      havana_gene : "OTTHUMG00000170412.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56334174,
      stop : 56340410,
      direction : "+",
      ID : "ENSG00000110944.9",
      gene_id : "ENSG00000110944.9",
      gene_type : "protein_coding",
      gene_name : "IL23A",
      gene_level : 2,
      hgnc_id : "HGNC:15488",
      havana_gene : "OTTHUMG00000187402.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56341597,
      stop : 56360167,
      direction : "-",
      ID : "ENSG00000170581.14",
      gene_id : "ENSG00000170581.14",
      gene_type : "protein_coding",
      gene_name : "STAT2",
      gene_level : 1,
      hgnc_id : "HGNC:11363",
      havana_gene : "OTTHUMG00000170760.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56360568,
      stop : 56362857,
      direction : "-",
      ID : "ENSG00000175336.10",
      gene_id : "ENSG00000175336.10",
      gene_type : "protein_coding",
      gene_name : "APOF",
      gene_level : 2,
      hgnc_id : "HGNC:615",
      havana_gene : "OTTHUMG00000170715.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56416363,
      stop : 56449426,
      direction : "-",
      ID : "ENSG00000111602.12",
      gene_id : "ENSG00000111602.12",
      gene_type : "protein_coding",
      gene_name : "TIMELESS",
      gene_level : 2,
      hgnc_id : "HGNC:11813",
      havana_gene : "OTTHUMG00000170600.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56449502,
      stop : 56469166,
      direction : "-",
      ID : "ENSG00000135517.9",
      gene_id : "ENSG00000135517.9",
      gene_type : "protein_coding",
      gene_name : "MIP",
      gene_level : 2,
      hgnc_id : "HGNC:7103",
      havana_gene : "OTTHUMG00000170571.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56449700,
      stop : 56488170,
      direction : "-",
      ID : "ENSG00000285528.1",
      gene_id : "ENSG00000285528.1",
      gene_type : "protein_coding",
      gene_name : "AC097104.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193403.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56468578,
      stop : 56479708,
      direction : "+",
      ID : "ENSG00000176422.14",
      gene_id : "ENSG00000176422.14",
      gene_type : "protein_coding",
      gene_name : "SPRYD4",
      gene_level : 2,
      hgnc_id : "HGNC:27468",
      havana_gene : "OTTHUMG00000187405.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56470944,
      stop : 56488414,
      direction : "-",
      ID : "ENSG00000135423.13",
      gene_id : "ENSG00000135423.13",
      gene_type : "protein_coding",
      gene_name : "GLS2",
      gene_level : 2,
      hgnc_id : "HGNC:29570",
      havana_gene : "OTTHUMG00000140379.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56521820,
      stop : 56596193,
      direction : "+",
      ID : "ENSG00000076067.13",
      gene_id : "ENSG00000076067.13",
      gene_type : "protein_coding",
      gene_name : "RBMS2",
      gene_level : 2,
      hgnc_id : "HGNC:9909",
      havana_gene : "OTTHUMG00000170488.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56595596,
      stop : 56636816,
      direction : "-",
      ID : "ENSG00000076108.12",
      gene_id : "ENSG00000076108.12",
      gene_type : "protein_coding",
      gene_name : "BAZ2A",
      gene_level : 1,
      hgnc_id : "HGNC:962",
      havana_gene : "OTTHUMG00000170332.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56638175,
      stop : 56645984,
      direction : "-",
      ID : "ENSG00000110955.9",
      gene_id : "ENSG00000110955.9",
      gene_type : "protein_coding",
      gene_name : "ATP5F1B",
      gene_level : 1,
      hgnc_id : "HGNC:830",
      havana_gene : "OTTHUMG00000170291.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56663341,
      stop : 56688408,
      direction : "-",
      ID : "ENSG00000110958.16",
      gene_id : "ENSG00000110958.16",
      gene_type : "protein_coding",
      gene_name : "PTGES3",
      gene_level : 2,
      hgnc_id : "HGNC:16049",
      havana_gene : "OTTHUMG00000170217.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56712305,
      stop : 56731628,
      direction : "-",
      ID : "ENSG00000196531.14",
      gene_id : "ENSG00000196531.14",
      gene_type : "protein_coding",
      gene_name : "NACA",
      gene_level : 2,
      hgnc_id : "HGNC:7629",
      havana_gene : "OTTHUMG00000170033.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56714612,
      stop : 56741535,
      direction : "-",
      ID : "ENSG00000285625.1",
      gene_id : "ENSG00000285625.1",
      gene_type : "protein_coding",
      gene_name : "AC117378.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193415.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56731296,
      stop : 56752374,
      direction : "-",
      ID : "ENSG00000198056.15",
      gene_id : "ENSG00000198056.15",
      gene_type : "protein_coding",
      gene_name : "PRIM1",
      gene_level : 1,
      hgnc_id : "HGNC:9369",
      havana_gene : "OTTHUMG00000170034.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56752161,
      stop : 56787790,
      direction : "+",
      ID : "ENSG00000025423.11",
      gene_id : "ENSG00000025423.11",
      gene_type : "protein_coding",
      gene_name : "HSD17B6",
      gene_level : 1,
      hgnc_id : "HGNC:23316",
      havana_gene : "OTTHUMG00000170854.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56923133,
      stop : 56934408,
      direction : "-",
      ID : "ENSG00000170426.2",
      gene_id : "ENSG00000170426.2",
      gene_type : "protein_coding",
      gene_name : "SDR9C7",
      gene_level : 2,
      hgnc_id : "HGNC:29958",
      havana_gene : "OTTHUMG00000171004.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56951431,
      stop : 56959374,
      direction : "-",
      ID : "ENSG00000139547.8",
      gene_id : "ENSG00000139547.8",
      gene_type : "protein_coding",
      gene_name : "RDH16",
      gene_level : 2,
      hgnc_id : "HGNC:29674",
      havana_gene : "OTTHUMG00000170895.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56994492,
      stop : 56998447,
      direction : "+",
      ID : "ENSG00000166856.3",
      gene_id : "ENSG00000166856.3",
      gene_type : "protein_coding",
      gene_name : "GPR182",
      gene_level : 2,
      hgnc_id : "HGNC:13708",
      havana_gene : "OTTHUMG00000171005.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 56998836,
      stop : 57006546,
      direction : "-",
      ID : "ENSG00000166860.3",
      gene_id : "ENSG00000166860.3",
      gene_type : "protein_coding",
      gene_name : "ZBTB39",
      gene_level : 2,
      hgnc_id : "HGNC:29014",
      havana_gene : "OTTHUMG00000171007.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57010000,
      stop : 57028883,
      direction : "-",
      ID : "ENSG00000166863.13",
      gene_id : "ENSG00000166863.13",
      gene_type : "protein_coding",
      gene_name : "TAC3",
      gene_level : 2,
      hgnc_id : "HGNC:11521",
      havana_gene : "OTTHUMG00000156958.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57028517,
      stop : 57051198,
      direction : "-",
      ID : "ENSG00000166866.13",
      gene_id : "ENSG00000166866.13",
      gene_type : "protein_coding",
      gene_name : "MYO1A",
      gene_level : 2,
      hgnc_id : "HGNC:7595",
      havana_gene : "OTTHUMG00000149899.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57055643,
      stop : 57088063,
      direction : "-",
      ID : "ENSG00000166881.10",
      gene_id : "ENSG00000166881.10",
      gene_type : "protein_coding",
      gene_name : "NEMP1",
      gene_level : 2,
      hgnc_id : "HGNC:29001",
      havana_gene : "OTTHUMG00000171021.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57089043,
      stop : 57095476,
      direction : "+",
      ID : "ENSG00000166886.13",
      gene_id : "ENSG00000166886.13",
      gene_type : "protein_coding",
      gene_name : "NAB2",
      gene_level : 2,
      hgnc_id : "HGNC:7627",
      havana_gene : "OTTHUMG00000171192.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57095408,
      stop : 57132139,
      direction : "-",
      ID : "ENSG00000166888.12",
      gene_id : "ENSG00000166888.12",
      gene_type : "protein_coding",
      gene_name : "STAT6",
      gene_level : 1,
      hgnc_id : "HGNC:11368",
      havana_gene : "OTTHUMG00000171194.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57128483,
      stop : 57213361,
      direction : "+",
      ID : "ENSG00000123384.14",
      gene_id : "ENSG00000123384.14",
      gene_type : "protein_coding",
      gene_name : "LRP1",
      gene_level : 1,
      hgnc_id : "HGNC:6692",
      havana_gene : "OTTHUMG00000044412.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57216794,
      stop : 57226449,
      direction : "+",
      ID : "ENSG00000182379.10",
      gene_id : "ENSG00000182379.10",
      gene_type : "protein_coding",
      gene_name : "NXPH4",
      gene_level : 1,
      hgnc_id : "HGNC:8078",
      havana_gene : "OTTHUMG00000171241.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57229573,
      stop : 57234935,
      direction : "+",
      ID : "ENSG00000182199.11",
      gene_id : "ENSG00000182199.11",
      gene_type : "protein_coding",
      gene_name : "SHMT2",
      gene_level : 1,
      hgnc_id : "HGNC:10852",
      havana_gene : "OTTHUMG00000171246.15",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57234903,
      stop : 57240715,
      direction : "-",
      ID : "ENSG00000185633.10",
      gene_id : "ENSG00000185633.10",
      gene_type : "protein_coding",
      gene_name : "NDUFA4L2",
      gene_level : 2,
      hgnc_id : "HGNC:29836",
      havana_gene : "OTTHUMG00000171275.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57243453,
      stop : 57251188,
      direction : "-",
      ID : "ENSG00000185482.8",
      gene_id : "ENSG00000185482.8",
      gene_type : "protein_coding",
      gene_name : "STAC3",
      gene_level : 2,
      hgnc_id : "HGNC:28423",
      havana_gene : "OTTHUMG00000171271.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57249609,
      stop : 57296484,
      direction : "-",
      ID : "ENSG00000258830.1",
      gene_id : "ENSG00000258830.1",
      gene_type : "protein_coding",
      gene_name : "AC137834.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171276.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57253762,
      stop : 57431005,
      direction : "-",
      ID : "ENSG00000179912.20",
      gene_id : "ENSG00000179912.20",
      gene_type : "protein_coding",
      gene_name : "R3HDM2",
      gene_level : 1,
      hgnc_id : "HGNC:29167",
      havana_gene : "OTTHUMG00000171568.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57434784,
      stop : 57452062,
      direction : "+",
      ID : "ENSG00000175189.4",
      gene_id : "ENSG00000175189.4",
      gene_type : "protein_coding",
      gene_name : "INHBC",
      gene_level : 2,
      hgnc_id : "HGNC:6068",
      havana_gene : "OTTHUMG00000169994.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57452323,
      stop : 57459280,
      direction : "+",
      ID : "ENSG00000139269.3",
      gene_id : "ENSG00000139269.3",
      gene_type : "protein_coding",
      gene_name : "INHBE",
      gene_level : 2,
      hgnc_id : "HGNC:24029",
      havana_gene : "OTTHUMG00000169995.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57459785,
      stop : 57472268,
      direction : "+",
      ID : "ENSG00000111087.10",
      gene_id : "ENSG00000111087.10",
      gene_type : "protein_coding",
      gene_name : "GLI1",
      gene_level : 2,
      hgnc_id : "HGNC:4317",
      havana_gene : "OTTHUMG00000167332.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57472264,
      stop : 57488814,
      direction : "-",
      ID : "ENSG00000123329.20",
      gene_id : "ENSG00000123329.20",
      gene_type : "protein_coding",
      gene_name : "ARHGAP9",
      gene_level : 1,
      hgnc_id : "HGNC:14130",
      havana_gene : "OTTHUMG00000150147.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57475445,
      stop : 57517569,
      direction : "+",
      ID : "ENSG00000166986.15",
      gene_id : "ENSG00000166986.15",
      gene_type : "protein_coding",
      gene_name : "MARS1",
      gene_level : 1,
      hgnc_id : "HGNC:6898",
      havana_gene : "OTTHUMG00000169996.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57516588,
      stop : 57521737,
      direction : "-",
      ID : "ENSG00000175197.12",
      gene_id : "ENSG00000175197.12",
      gene_type : "protein_coding",
      gene_name : "DDIT3",
      gene_level : 2,
      hgnc_id : "HGNC:2726",
      havana_gene : "OTTHUMG00000170046.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57517712,
      stop : 57520480,
      direction : "-",
      ID : "ENSG00000285133.1",
      gene_id : "ENSG00000285133.1",
      gene_type : "protein_coding",
      gene_name : "AC022506.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192619.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57520710,
      stop : 57530148,
      direction : "+",
      ID : "ENSG00000166987.15",
      gene_id : "ENSG00000166987.15",
      gene_type : "protein_coding",
      gene_name : "MBD6",
      gene_level : 2,
      hgnc_id : "HGNC:20445",
      havana_gene : "OTTHUMG00000170099.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57529633,
      stop : 57547224,
      direction : "-",
      ID : "ENSG00000175203.17",
      gene_id : "ENSG00000175203.17",
      gene_type : "protein_coding",
      gene_name : "DCTN2",
      gene_level : 1,
      hgnc_id : "HGNC:2712",
      havana_gene : "OTTHUMG00000170124.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57546026,
      stop : 57586633,
      direction : "+",
      ID : "ENSG00000155980.13",
      gene_id : "ENSG00000155980.13",
      gene_type : "protein_coding",
      gene_name : "KIF5A",
      gene_level : 2,
      hgnc_id : "HGNC:6323",
      havana_gene : "OTTHUMG00000170143.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57591174,
      stop : 57603418,
      direction : "+",
      ID : "ENSG00000166908.18",
      gene_id : "ENSG00000166908.18",
      gene_type : "protein_coding",
      gene_name : "PIP4K2C",
      gene_level : 1,
      hgnc_id : "HGNC:23786",
      havana_gene : "OTTHUMG00000170144.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57604622,
      stop : 57609804,
      direction : "+",
      ID : "ENSG00000178498.16",
      gene_id : "ENSG00000178498.16",
      gene_type : "protein_coding",
      gene_name : "DTX3",
      gene_level : 2,
      hgnc_id : "HGNC:24457",
      havana_gene : "OTTHUMG00000170189.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57610180,
      stop : 57617245,
      direction : "+",
      ID : "ENSG00000240771.8",
      gene_id : "ENSG00000240771.8",
      gene_type : "protein_coding",
      gene_name : "ARHGEF25",
      gene_level : 2,
      hgnc_id : "HGNC:30275",
      havana_gene : "OTTHUMG00000152516.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57615280,
      stop : 57626125,
      direction : "+",
      ID : "ENSG00000287908.1",
      gene_id : "ENSG00000287908.1",
      gene_type : "protein_coding",
      gene_name : "AC025165.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193795.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57623409,
      stop : 57633239,
      direction : "-",
      ID : "ENSG00000135454.14",
      gene_id : "ENSG00000135454.14",
      gene_type : "protein_coding",
      gene_name : "B4GALNT1",
      gene_level : 1,
      hgnc_id : "HGNC:4117",
      havana_gene : "OTTHUMG00000170190.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57693955,
      stop : 57721557,
      direction : "+",
      ID : "ENSG00000135506.16",
      gene_id : "ENSG00000135506.16",
      gene_type : "protein_coding",
      gene_name : "OS9",
      gene_level : 1,
      hgnc_id : "HGNC:16994",
      havana_gene : "OTTHUMG00000170284.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57723761,
      stop : 57742157,
      direction : "-",
      ID : "ENSG00000135439.11",
      gene_id : "ENSG00000135439.11",
      gene_type : "protein_coding",
      gene_name : "AGAP2",
      gene_level : 2,
      hgnc_id : "HGNC:16921",
      havana_gene : "OTTHUMG00000170285.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57738013,
      stop : 57750219,
      direction : "+",
      ID : "ENSG00000135452.10",
      gene_id : "ENSG00000135452.10",
      gene_type : "protein_coding",
      gene_name : "TSPAN31",
      gene_level : 1,
      hgnc_id : "HGNC:10539",
      havana_gene : "OTTHUMG00000170381.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57747727,
      stop : 57756013,
      direction : "-",
      ID : "ENSG00000135446.17",
      gene_id : "ENSG00000135446.17",
      gene_type : "protein_coding",
      gene_name : "CDK4",
      gene_level : 1,
      hgnc_id : "HGNC:1773",
      havana_gene : "OTTHUMG00000170382.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57755103,
      stop : 57760411,
      direction : "+",
      ID : "ENSG00000139266.6",
      gene_id : "ENSG00000139266.6",
      gene_type : "protein_coding",
      gene_name : "MARCHF9",
      gene_level : 2,
      hgnc_id : "HGNC:25139",
      havana_gene : "OTTHUMG00000170456.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57762334,
      stop : 57768986,
      direction : "-",
      ID : "ENSG00000111012.10",
      gene_id : "ENSG00000111012.10",
      gene_type : "protein_coding",
      gene_name : "CYP27B1",
      gene_level : 2,
      hgnc_id : "HGNC:2606",
      havana_gene : "OTTHUMG00000170457.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57768471,
      stop : 57772119,
      direction : "-",
      ID : "ENSG00000037897.17",
      gene_id : "ENSG00000037897.17",
      gene_type : "protein_coding",
      gene_name : "METTL1",
      gene_level : 2,
      hgnc_id : "HGNC:7030",
      havana_gene : "OTTHUMG00000150143.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57771492,
      stop : 57782541,
      direction : "+",
      ID : "ENSG00000123427.17",
      gene_id : "ENSG00000123427.17",
      gene_type : "protein_coding",
      gene_name : "EEF1AKMT3",
      gene_level : 1,
      hgnc_id : "HGNC:24936",
      havana_gene : "OTTHUMG00000170459.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57772660,
      stop : 57797554,
      direction : "+",
      ID : "ENSG00000257921.6",
      gene_id : "ENSG00000257921.6",
      gene_type : "protein_coding",
      gene_name : "AC025165.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170460.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57782761,
      stop : 57808071,
      direction : "+",
      ID : "ENSG00000123297.20",
      gene_id : "ENSG00000123297.20",
      gene_type : "protein_coding",
      gene_name : "TSFM",
      gene_level : 1,
      hgnc_id : "HGNC:12367",
      havana_gene : "OTTHUMG00000153042.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57797376,
      stop : 57818704,
      direction : "-",
      ID : "ENSG00000135407.10",
      gene_id : "ENSG00000135407.10",
      gene_type : "protein_coding",
      gene_name : "AVIL",
      gene_level : 2,
      hgnc_id : "HGNC:14188",
      havana_gene : "OTTHUMG00000170461.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57819927,
      stop : 57846729,
      direction : "-",
      ID : "ENSG00000175215.11",
      gene_id : "ENSG00000175215.11",
      gene_type : "protein_coding",
      gene_name : "CTDSP2",
      gene_level : 1,
      hgnc_id : "HGNC:17077",
      havana_gene : "OTTHUMG00000170483.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 57906039,
      stop : 57959148,
      direction : "+",
      ID : "ENSG00000166896.9",
      gene_id : "ENSG00000166896.9",
      gene_type : "protein_coding",
      gene_name : "ATP23",
      gene_level : 2,
      hgnc_id : "HGNC:29452",
      havana_gene : "OTTHUMG00000170493.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 58872149,
      stop : 58920504,
      direction : "-",
      ID : "ENSG00000139263.12",
      gene_id : "ENSG00000139263.12",
      gene_type : "protein_coding",
      gene_name : "LRIG3",
      gene_level : 2,
      hgnc_id : "HGNC:30991",
      havana_gene : "OTTHUMG00000169940.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 59596029,
      stop : 59789855,
      direction : "+",
      ID : "ENSG00000118596.12",
      gene_id : "ENSG00000118596.12",
      gene_type : "protein_coding",
      gene_name : "SLC16A7",
      gene_level : 1,
      hgnc_id : "HGNC:10928",
      havana_gene : "OTTHUMG00000169923.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 61708259,
      stop : 62279150,
      direction : "-",
      ID : "ENSG00000198673.10",
      gene_id : "ENSG00000198673.10",
      gene_type : "protein_coding",
      gene_name : "TAFA2",
      gene_level : 1,
      hgnc_id : "HGNC:21589",
      havana_gene : "OTTHUMG00000170207.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 62260338,
      stop : 62417431,
      direction : "+",
      ID : "ENSG00000135655.16",
      gene_id : "ENSG00000135655.16",
      gene_type : "protein_coding",
      gene_name : "USP15",
      gene_level : 1,
      hgnc_id : "HGNC:12613",
      havana_gene : "OTTHUMG00000170186.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 62466817,
      stop : 62600476,
      direction : "+",
      ID : "ENSG00000061987.16",
      gene_id : "ENSG00000061987.16",
      gene_type : "protein_coding",
      gene_name : "MON2",
      gene_level : 1,
      hgnc_id : "HGNC:29177",
      havana_gene : "OTTHUMG00000169992.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 62643994,
      stop : 62935150,
      direction : "-",
      ID : "ENSG00000111110.12",
      gene_id : "ENSG00000111110.12",
      gene_type : "protein_coding",
      gene_name : "PPM1H",
      gene_level : 2,
      hgnc_id : "HGNC:18583",
      havana_gene : "OTTHUMG00000169990.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 63142759,
      stop : 63151201,
      direction : "-",
      ID : "ENSG00000166148.4",
      gene_id : "ENSG00000166148.4",
      gene_type : "protein_coding",
      gene_name : "AVPR1A",
      gene_level : 1,
      hgnc_id : "HGNC:895",
      havana_gene : "OTTHUMG00000169980.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 63558913,
      stop : 63668939,
      direction : "-",
      ID : "ENSG00000177990.12",
      gene_id : "ENSG00000177990.12",
      gene_type : "protein_coding",
      gene_name : "DPY19L2",
      gene_level : 2,
      hgnc_id : "HGNC:19414",
      havana_gene : "OTTHUMG00000168712.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 63779842,
      stop : 63809562,
      direction : "+",
      ID : "ENSG00000118600.12",
      gene_id : "ENSG00000118600.12",
      gene_type : "protein_coding",
      gene_name : "RXYLT1",
      gene_level : 1,
      hgnc_id : "HGNC:13530",
      havana_gene : "OTTHUMG00000168730.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 63844700,
      stop : 64162217,
      direction : "+",
      ID : "ENSG00000196935.9",
      gene_id : "ENSG00000196935.9",
      gene_type : "protein_coding",
      gene_name : "SRGAP1",
      gene_level : 2,
      hgnc_id : "HGNC:17382",
      havana_gene : "OTTHUMG00000168750.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64186316,
      stop : 64222296,
      direction : "-",
      ID : "ENSG00000174206.13",
      gene_id : "ENSG00000174206.13",
      gene_type : "protein_coding",
      gene_name : "C12orf66",
      gene_level : 1,
      hgnc_id : "HGNC:26517",
      havana_gene : "OTTHUMG00000168763.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64264762,
      stop : 64390758,
      direction : "-",
      ID : "ENSG00000185306.13",
      gene_id : "ENSG00000185306.13",
      gene_type : "protein_coding",
      gene_name : "C12orf56",
      gene_level : 1,
      hgnc_id : "HGNC:26967",
      havana_gene : "OTTHUMG00000168782.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64404392,
      stop : 64451125,
      direction : "+",
      ID : "ENSG00000184575.12",
      gene_id : "ENSG00000184575.12",
      gene_type : "protein_coding",
      gene_name : "XPOT",
      gene_level : 2,
      hgnc_id : "HGNC:12826",
      havana_gene : "OTTHUMG00000168794.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64452090,
      stop : 64502114,
      direction : "+",
      ID : "ENSG00000183735.11",
      gene_id : "ENSG00000183735.11",
      gene_type : "protein_coding",
      gene_name : "TBK1",
      gene_level : 2,
      hgnc_id : "HGNC:11584",
      havana_gene : "OTTHUMG00000168796.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64507001,
      stop : 64697564,
      direction : "+",
      ID : "ENSG00000153179.13",
      gene_id : "ENSG00000153179.13",
      gene_type : "protein_coding",
      gene_name : "RASSF3",
      gene_level : 2,
      hgnc_id : "HGNC:14271",
      havana_gene : "OTTHUMG00000168812.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64713445,
      stop : 64759431,
      direction : "-",
      ID : "ENSG00000135677.11",
      gene_id : "ENSG00000135677.11",
      gene_type : "protein_coding",
      gene_name : "GNS",
      gene_level : 1,
      hgnc_id : "HGNC:4422",
      havana_gene : "OTTHUMG00000168819.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64759484,
      stop : 64881033,
      direction : "+",
      ID : "ENSG00000111490.15",
      gene_id : "ENSG00000111490.15",
      gene_type : "protein_coding",
      gene_name : "TBC1D30",
      gene_level : 2,
      hgnc_id : "HGNC:29164",
      havana_gene : "OTTHUMG00000168824.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 64759496,
      stop : 64977509,
      direction : "+",
      ID : "ENSG00000288591.1",
      gene_id : "ENSG00000288591.1",
      gene_type : "protein_coding",
      gene_name : "AC078815.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000196010.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 65050626,
      stop : 65121305,
      direction : "-",
      ID : "ENSG00000156076.10",
      gene_id : "ENSG00000156076.10",
      gene_type : "protein_coding",
      gene_name : "WIF1",
      gene_level : 2,
      hgnc_id : "HGNC:18081",
      havana_gene : "OTTHUMG00000168832.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 65169583,
      stop : 65248355,
      direction : "+",
      ID : "ENSG00000174106.3",
      gene_id : "ENSG00000174106.3",
      gene_type : "protein_coding",
      gene_name : "LEMD3",
      gene_level : 2,
      hgnc_id : "HGNC:28887",
      havana_gene : "OTTHUMG00000168840.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 65278643,
      stop : 65491430,
      direction : "+",
      ID : "ENSG00000174099.12",
      gene_id : "ENSG00000174099.12",
      gene_type : "protein_coding",
      gene_name : "MSRB3",
      gene_level : 1,
      hgnc_id : "HGNC:27375",
      havana_gene : "OTTHUMG00000168866.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 65824460,
      stop : 65966291,
      direction : "+",
      ID : "ENSG00000149948.14",
      gene_id : "ENSG00000149948.14",
      gene_type : "protein_coding",
      gene_name : "HMGA2",
      gene_level : 2,
      hgnc_id : "HGNC:5009",
      havana_gene : "OTTHUMG00000168936.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66116555,
      stop : 66130750,
      direction : "-",
      ID : "ENSG00000139233.7",
      gene_id : "ENSG00000139233.7",
      gene_type : "protein_coding",
      gene_name : "LLPH",
      gene_level : 2,
      hgnc_id : "HGNC:28229",
      havana_gene : "OTTHUMG00000168959.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66123917,
      stop : 66169985,
      direction : "-",
      ID : "ENSG00000228144.2",
      gene_id : "ENSG00000228144.2",
      gene_type : "protein_coding",
      gene_name : "AC078927.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168972.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66135846,
      stop : 66170072,
      direction : "-",
      ID : "ENSG00000155957.18",
      gene_id : "ENSG00000155957.18",
      gene_type : "protein_coding",
      gene_name : "TMBIM4",
      gene_level : 1,
      hgnc_id : "HGNC:24257",
      havana_gene : "OTTHUMG00000168973.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66189195,
      stop : 66254622,
      direction : "+",
      ID : "ENSG00000090376.11",
      gene_id : "ENSG00000090376.11",
      gene_type : "protein_coding",
      gene_name : "IRAK3",
      gene_level : 2,
      hgnc_id : "HGNC:17020",
      havana_gene : "OTTHUMG00000169002.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66302493,
      stop : 66343643,
      direction : "+",
      ID : "ENSG00000127311.10",
      gene_id : "ENSG00000127311.10",
      gene_type : "protein_coding",
      gene_name : "HELB",
      gene_level : 2,
      hgnc_id : "HGNC:17196",
      havana_gene : "OTTHUMG00000169006.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 66347431,
      stop : 67069162,
      direction : "-",
      ID : "ENSG00000155974.13",
      gene_id : "ENSG00000155974.13",
      gene_type : "protein_coding",
      gene_name : "GRIP1",
      gene_level : 1,
      hgnc_id : "HGNC:18708",
      havana_gene : "OTTHUMG00000169019.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 67269358,
      stop : 67319953,
      direction : "+",
      ID : "ENSG00000111530.13",
      gene_id : "ENSG00000111530.13",
      gene_type : "protein_coding",
      gene_name : "CAND1",
      gene_level : 1,
      hgnc_id : "HGNC:30688",
      havana_gene : "OTTHUMG00000169060.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 67648338,
      stop : 67665406,
      direction : "+",
      ID : "ENSG00000127334.11",
      gene_id : "ENSG00000127334.11",
      gene_type : "protein_coding",
      gene_name : "DYRK2",
      gene_level : 2,
      hgnc_id : "HGNC:3093",
      havana_gene : "OTTHUMG00000169089.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68154768,
      stop : 68159740,
      direction : "-",
      ID : "ENSG00000111537.5",
      gene_id : "ENSG00000111537.5",
      gene_type : "protein_coding",
      gene_name : "IFNG",
      gene_level : 2,
      hgnc_id : "HGNC:5438",
      havana_gene : "OTTHUMG00000169113.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68201349,
      stop : 68225810,
      direction : "-",
      ID : "ENSG00000111536.5",
      gene_id : "ENSG00000111536.5",
      gene_type : "protein_coding",
      gene_name : "IL26",
      gene_level : 2,
      hgnc_id : "HGNC:17119",
      havana_gene : "OTTHUMG00000169114.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68248242,
      stop : 68253604,
      direction : "-",
      ID : "ENSG00000127318.11",
      gene_id : "ENSG00000127318.11",
      gene_type : "protein_coding",
      gene_name : "IL22",
      gene_level : 2,
      hgnc_id : "HGNC:14900",
      havana_gene : "OTTHUMG00000169119.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68272443,
      stop : 68332381,
      direction : "-",
      ID : "ENSG00000111554.14",
      gene_id : "ENSG00000111554.14",
      gene_type : "protein_coding",
      gene_name : "MDM1",
      gene_level : 1,
      hgnc_id : "HGNC:29917",
      havana_gene : "OTTHUMG00000169136.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68610855,
      stop : 68671901,
      direction : "+",
      ID : "ENSG00000127314.18",
      gene_id : "ENSG00000127314.18",
      gene_type : "protein_coding",
      gene_name : "RAP1B",
      gene_level : 2,
      hgnc_id : "HGNC:9857",
      havana_gene : "OTTHUMG00000133660.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68686951,
      stop : 68745809,
      direction : "+",
      ID : "ENSG00000111581.10",
      gene_id : "ENSG00000111581.10",
      gene_type : "protein_coding",
      gene_name : "NUP107",
      gene_level : 1,
      hgnc_id : "HGNC:29914",
      havana_gene : "OTTHUMG00000169265.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68746125,
      stop : 68793964,
      direction : "+",
      ID : "ENSG00000175782.11",
      gene_id : "ENSG00000175782.11",
      gene_type : "protein_coding",
      gene_name : "SLC35E3",
      gene_level : 1,
      hgnc_id : "HGNC:20864",
      havana_gene : "OTTHUMG00000169282.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68808177,
      stop : 68850686,
      direction : "+",
      ID : "ENSG00000135679.25",
      gene_id : "ENSG00000135679.25",
      gene_type : "protein_coding",
      gene_name : "MDM2",
      gene_level : 1,
      hgnc_id : "HGNC:6973",
      havana_gene : "OTTHUMG00000142827.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 68842197,
      stop : 68971570,
      direction : "-",
      ID : "ENSG00000135678.12",
      gene_id : "ENSG00000135678.12",
      gene_type : "protein_coding",
      gene_name : "CPM",
      gene_level : 2,
      hgnc_id : "HGNC:2311",
      havana_gene : "OTTHUMG00000169300.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69239569,
      stop : 69274358,
      direction : "+",
      ID : "ENSG00000111605.18",
      gene_id : "ENSG00000111605.18",
      gene_type : "protein_coding",
      gene_name : "CPSF6",
      gene_level : 2,
      hgnc_id : "HGNC:13871",
      havana_gene : "OTTHUMG00000169340.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69348381,
      stop : 69354234,
      direction : "+",
      ID : "ENSG00000090382.7",
      gene_id : "ENSG00000090382.7",
      gene_type : "protein_coding",
      gene_name : "LYZ",
      gene_level : 1,
      hgnc_id : "HGNC:6740",
      havana_gene : "OTTHUMG00000169342.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69359710,
      stop : 69390870,
      direction : "+",
      ID : "ENSG00000127337.7",
      gene_id : "ENSG00000127337.7",
      gene_type : "protein_coding",
      gene_name : "YEATS4",
      gene_level : 1,
      hgnc_id : "HGNC:24859",
      havana_gene : "OTTHUMG00000169358.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69470349,
      stop : 69579793,
      direction : "+",
      ID : "ENSG00000166225.9",
      gene_id : "ENSG00000166225.9",
      gene_type : "protein_coding",
      gene_name : "FRS2",
      gene_level : 1,
      hgnc_id : "HGNC:16971",
      havana_gene : "OTTHUMG00000169373.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69585426,
      stop : 69601570,
      direction : "+",
      ID : "ENSG00000166226.13",
      gene_id : "ENSG00000166226.13",
      gene_type : "protein_coding",
      gene_name : "CCT2",
      gene_level : 2,
      hgnc_id : "HGNC:1615",
      havana_gene : "OTTHUMG00000169383.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69608564,
      stop : 69610907,
      direction : "-",
      ID : "ENSG00000198812.5",
      gene_id : "ENSG00000198812.5",
      gene_type : "protein_coding",
      gene_name : "LRRC10",
      gene_level : 2,
      hgnc_id : "HGNC:20264",
      havana_gene : "OTTHUMG00000169384.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69643360,
      stop : 69699476,
      direction : "-",
      ID : "ENSG00000127325.19",
      gene_id : "ENSG00000127325.19",
      gene_type : "protein_coding",
      gene_name : "BEST3",
      gene_level : 1,
      hgnc_id : "HGNC:17105",
      havana_gene : "OTTHUMG00000149919.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69738860,
      stop : 69823204,
      direction : "+",
      ID : "ENSG00000127328.22",
      gene_id : "ENSG00000127328.22",
      gene_type : "protein_coding",
      gene_name : "RAB3IP",
      gene_level : 2,
      hgnc_id : "HGNC:16508",
      havana_gene : "OTTHUMG00000169437.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69801669,
      stop : 69855363,
      direction : "+",
      ID : "ENSG00000258052.1",
      gene_id : "ENSG00000258052.1",
      gene_type : "protein_coding",
      gene_name : "AC025263.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000141317.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 69825227,
      stop : 69959097,
      direction : "+",
      ID : "ENSG00000166268.11",
      gene_id : "ENSG00000166268.11",
      gene_type : "protein_coding",
      gene_name : "MYRFL",
      gene_level : 2,
      hgnc_id : "HGNC:26316",
      havana_gene : "OTTHUMG00000169438.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 70243002,
      stop : 70354993,
      direction : "+",
      ID : "ENSG00000111596.14",
      gene_id : "ENSG00000111596.14",
      gene_type : "protein_coding",
      gene_name : "CNOT2",
      gene_level : 1,
      hgnc_id : "HGNC:7878",
      havana_gene : "OTTHUMG00000169481.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 70366290,
      stop : 70434292,
      direction : "+",
      ID : "ENSG00000135643.5",
      gene_id : "ENSG00000135643.5",
      gene_type : "protein_coding",
      gene_name : "KCNMB4",
      gene_level : 2,
      hgnc_id : "HGNC:6289",
      havana_gene : "OTTHUMG00000167586.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 70515870,
      stop : 70637440,
      direction : "-",
      ID : "ENSG00000127329.16",
      gene_id : "ENSG00000127329.16",
      gene_type : "protein_coding",
      gene_name : "PTPRB",
      gene_level : 1,
      hgnc_id : "HGNC:9665",
      havana_gene : "OTTHUMG00000169499.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 70638073,
      stop : 70920738,
      direction : "-",
      ID : "ENSG00000153233.13",
      gene_id : "ENSG00000153233.13",
      gene_type : "protein_coding",
      gene_name : "PTPRR",
      gene_level : 1,
      hgnc_id : "HGNC:9680",
      havana_gene : "OTTHUMG00000169502.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71125085,
      stop : 71441898,
      direction : "-",
      ID : "ENSG00000127324.9",
      gene_id : "ENSG00000127324.9",
      gene_type : "protein_coding",
      gene_name : "TSPAN8",
      gene_level : 2,
      hgnc_id : "HGNC:11855",
      havana_gene : "OTTHUMG00000169542.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71439798,
      stop : 71586310,
      direction : "+",
      ID : "ENSG00000139292.13",
      gene_id : "ENSG00000139292.13",
      gene_type : "protein_coding",
      gene_name : "LGR5",
      gene_level : 2,
      hgnc_id : "HGNC:4504",
      havana_gene : "OTTHUMG00000169543.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71609599,
      stop : 71667725,
      direction : "-",
      ID : "ENSG00000133858.17",
      gene_id : "ENSG00000133858.17",
      gene_type : "protein_coding",
      gene_name : "ZFC3H1",
      gene_level : 1,
      hgnc_id : "HGNC:28328",
      havana_gene : "OTTHUMG00000169545.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71664301,
      stop : 71680644,
      direction : "+",
      ID : "ENSG00000173451.7",
      gene_id : "ENSG00000173451.7",
      gene_type : "protein_coding",
      gene_name : "THAP2",
      gene_level : 1,
      hgnc_id : "HGNC:20854",
      havana_gene : "OTTHUMG00000169556.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71674204,
      stop : 71698968,
      direction : "+",
      ID : "ENSG00000258064.1",
      gene_id : "ENSG00000258064.1",
      gene_type : "protein_coding",
      gene_name : "AC073612.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000169557.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71686082,
      stop : 71705047,
      direction : "+",
      ID : "ENSG00000139291.14",
      gene_id : "ENSG00000139291.14",
      gene_type : "protein_coding",
      gene_name : "TMEM19",
      gene_level : 2,
      hgnc_id : "HGNC:25605",
      havana_gene : "OTTHUMG00000169558.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71754863,
      stop : 71800286,
      direction : "+",
      ID : "ENSG00000080371.6",
      gene_id : "ENSG00000080371.6",
      gene_type : "protein_coding",
      gene_name : "RAB21",
      gene_level : 2,
      hgnc_id : "HGNC:18263",
      havana_gene : "OTTHUMG00000169572.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71839707,
      stop : 71927248,
      direction : "+",
      ID : "ENSG00000121749.16",
      gene_id : "ENSG00000121749.16",
      gene_type : "protein_coding",
      gene_name : "TBC1D15",
      gene_level : 2,
      hgnc_id : "HGNC:25694",
      havana_gene : "OTTHUMG00000158553.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 71938845,
      stop : 72186618,
      direction : "+",
      ID : "ENSG00000139287.13",
      gene_id : "ENSG00000139287.13",
      gene_type : "protein_coding",
      gene_name : "TPH2",
      gene_level : 2,
      hgnc_id : "HGNC:20692",
      havana_gene : "OTTHUMG00000169677.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 72087266,
      stop : 72670758,
      direction : "+",
      ID : "ENSG00000072657.9",
      gene_id : "ENSG00000072657.9",
      gene_type : "protein_coding",
      gene_name : "TRHDE",
      gene_level : 2,
      hgnc_id : "HGNC:30748",
      havana_gene : "OTTHUMG00000169642.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 74537835,
      stop : 74545430,
      direction : "+",
      ID : "ENSG00000253719.4",
      gene_id : "ENSG00000253719.4",
      gene_type : "protein_coding",
      gene_name : "ATXN7L3B",
      gene_level : 2,
      hgnc_id : "HGNC:37931",
      havana_gene : "OTTHUMG00000163936.3",
      tag : "retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 75040077,
      stop : 75209839,
      direction : "-",
      ID : "ENSG00000166006.14",
      gene_id : "ENSG00000166006.14",
      gene_type : "protein_coding",
      gene_name : "KCNC2",
      gene_level : 1,
      hgnc_id : "HGNC:6234",
      havana_gene : "OTTHUMG00000169717.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 75275979,
      stop : 75390928,
      direction : "-",
      ID : "ENSG00000180881.19",
      gene_id : "ENSG00000180881.19",
      gene_type : "protein_coding",
      gene_name : "CAPS2",
      gene_level : 1,
      hgnc_id : "HGNC:16471",
      havana_gene : "OTTHUMG00000152787.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 75334670,
      stop : 75370560,
      direction : "+",
      ID : "ENSG00000173401.10",
      gene_id : "ENSG00000173401.10",
      gene_type : "protein_coding",
      gene_name : "GLIPR1L1",
      gene_level : 2,
      hgnc_id : "HGNC:28392",
      havana_gene : "OTTHUMG00000169755.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 75391089,
      stop : 75432688,
      direction : "+",
      ID : "ENSG00000180481.11",
      gene_id : "ENSG00000180481.11",
      gene_type : "protein_coding",
      gene_name : "GLIPR1L2",
      gene_level : 2,
      hgnc_id : "HGNC:28592",
      havana_gene : "OTTHUMG00000169756.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 75480753,
      stop : 75503863,
      direction : "+",
      ID : "ENSG00000139278.10",
      gene_id : "ENSG00000139278.10",
      gene_type : "protein_coding",
      gene_name : "GLIPR1",
      gene_level : 1,
      hgnc_id : "HGNC:17001",
      havana_gene : "OTTHUMG00000169757.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 75490863,
      stop : 75511636,
      direction : "-",
      ID : "ENSG00000111615.14",
      gene_id : "ENSG00000111615.14",
      gene_type : "protein_coding",
      gene_name : "KRR1",
      gene_level : 2,
      hgnc_id : "HGNC:5176",
      havana_gene : "OTTHUMG00000169759.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 76025447,
      stop : 76031776,
      direction : "-",
      ID : "ENSG00000139289.14",
      gene_id : "ENSG00000139289.14",
      gene_type : "protein_coding",
      gene_name : "PHLDA1",
      gene_level : 2,
      hgnc_id : "HGNC:8933",
      havana_gene : "OTTHUMG00000169783.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 76036585,
      stop : 76084735,
      direction : "-",
      ID : "ENSG00000187109.15",
      gene_id : "ENSG00000187109.15",
      gene_type : "protein_coding",
      gene_name : "NAP1L1",
      gene_level : 1,
      hgnc_id : "HGNC:7637",
      havana_gene : "OTTHUMG00000169786.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 76344474,
      stop : 76348415,
      direction : "-",
      ID : "ENSG00000179941.9",
      gene_id : "ENSG00000179941.9",
      gene_type : "protein_coding",
      gene_name : "BBS10",
      gene_level : 2,
      hgnc_id : "HGNC:26291",
      havana_gene : "OTTHUMG00000147352.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 76351797,
      stop : 76559809,
      direction : "-",
      ID : "ENSG00000091039.17",
      gene_id : "ENSG00000091039.17",
      gene_type : "protein_coding",
      gene_name : "OSBPL8",
      gene_level : 2,
      hgnc_id : "HGNC:16396",
      havana_gene : "OTTHUMG00000169876.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 76764103,
      stop : 76853696,
      direction : "+",
      ID : "ENSG00000186908.15",
      gene_id : "ENSG00000186908.15",
      gene_type : "protein_coding",
      gene_name : "ZDHHC17",
      gene_level : 2,
      hgnc_id : "HGNC:18412",
      havana_gene : "OTTHUMG00000169917.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 76858709,
      stop : 76879023,
      direction : "-",
      ID : "ENSG00000175183.10",
      gene_id : "ENSG00000175183.10",
      gene_type : "protein_coding",
      gene_name : "CSRP2",
      gene_level : 1,
      hgnc_id : "HGNC:2470",
      havana_gene : "OTTHUMG00000169919.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 77021248,
      stop : 77065569,
      direction : "-",
      ID : "ENSG00000165891.16",
      gene_id : "ENSG00000165891.16",
      gene_type : "protein_coding",
      gene_name : "E2F7",
      gene_level : 2,
      hgnc_id : "HGNC:23820",
      havana_gene : "OTTHUMG00000169969.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 77324641,
      stop : 78213010,
      direction : "+",
      ID : "ENSG00000067798.16",
      gene_id : "ENSG00000067798.16",
      gene_type : "protein_coding",
      gene_name : "NAV3",
      gene_level : 1,
      hgnc_id : "HGNC:15998",
      havana_gene : "OTTHUMG00000170001.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 78863993,
      stop : 79452008,
      direction : "+",
      ID : "ENSG00000067715.14",
      gene_id : "ENSG00000067715.14",
      gene_type : "protein_coding",
      gene_name : "SYT1",
      gene_level : 2,
      hgnc_id : "HGNC:11509",
      havana_gene : "OTTHUMG00000134326.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 79574979,
      stop : 79690964,
      direction : "-",
      ID : "ENSG00000177425.11",
      gene_id : "ENSG00000177425.11",
      gene_type : "protein_coding",
      gene_name : "PAWR",
      gene_level : 1,
      hgnc_id : "HGNC:8614",
      havana_gene : "OTTHUMG00000170080.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 79773563,
      stop : 79935460,
      direction : "-",
      ID : "ENSG00000058272.19",
      gene_id : "ENSG00000058272.19",
      gene_type : "protein_coding",
      gene_name : "PPP1R12A",
      gene_level : 1,
      hgnc_id : "HGNC:7618",
      havana_gene : "OTTHUMG00000170100.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 80099537,
      stop : 80380880,
      direction : "+",
      ID : "ENSG00000165899.12",
      gene_id : "ENSG00000165899.12",
      gene_type : "protein_coding",
      gene_name : "OTOGL",
      gene_level : 1,
      hgnc_id : "HGNC:26901",
      havana_gene : "OTTHUMG00000150509.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 80402178,
      stop : 80680273,
      direction : "+",
      ID : "ENSG00000139304.16",
      gene_id : "ENSG00000139304.16",
      gene_type : "protein_coding",
      gene_name : "PTPRQ",
      gene_level : 1,
      hgnc_id : "HGNC:9679",
      havana_gene : "OTTHUMG00000170171.10",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 80707634,
      stop : 80709474,
      direction : "+",
      ID : "ENSG00000111046.4",
      gene_id : "ENSG00000111046.4",
      gene_type : "protein_coding",
      gene_name : "MYF6",
      gene_level : 2,
      hgnc_id : "HGNC:7566",
      havana_gene : "OTTHUMG00000170165.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 80716912,
      stop : 80719671,
      direction : "+",
      ID : "ENSG00000111049.4",
      gene_id : "ENSG00000111049.4",
      gene_type : "protein_coding",
      gene_name : "MYF5",
      gene_level : 2,
      hgnc_id : "HGNC:7565",
      havana_gene : "OTTHUMG00000170166.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 80792520,
      stop : 80937934,
      direction : "-",
      ID : "ENSG00000111052.8",
      gene_id : "ENSG00000111052.8",
      gene_type : "protein_coding",
      gene_name : "LIN7A",
      gene_level : 1,
      hgnc_id : "HGNC:17787",
      havana_gene : "OTTHUMG00000170168.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 80936414,
      stop : 81261210,
      direction : "+",
      ID : "ENSG00000111058.8",
      gene_id : "ENSG00000111058.8",
      gene_type : "protein_coding",
      gene_name : "ACSS3",
      gene_level : 2,
      hgnc_id : "HGNC:24723",
      havana_gene : "OTTHUMG00000170179.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 81257975,
      stop : 81759553,
      direction : "-",
      ID : "ENSG00000139220.17",
      gene_id : "ENSG00000139220.17",
      gene_type : "protein_coding",
      gene_name : "PPFIA2",
      gene_level : 2,
      hgnc_id : "HGNC:9246",
      havana_gene : "OTTHUMG00000170181.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 82223681,
      stop : 82358805,
      direction : "-",
      ID : "ENSG00000133773.12",
      gene_id : "ENSG00000133773.12",
      gene_type : "protein_coding",
      gene_name : "CCDC59",
      gene_level : 2,
      hgnc_id : "HGNC:25005",
      havana_gene : "OTTHUMG00000170251.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 82358528,
      stop : 82479239,
      direction : "+",
      ID : "ENSG00000127720.8",
      gene_id : "ENSG00000127720.8",
      gene_type : "protein_coding",
      gene_name : "METTL25",
      gene_level : 1,
      hgnc_id : "HGNC:26228",
      havana_gene : "OTTHUMG00000170252.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 82686880,
      stop : 83134870,
      direction : "+",
      ID : "ENSG00000179104.9",
      gene_id : "ENSG00000179104.9",
      gene_type : "protein_coding",
      gene_name : "TMTC2",
      gene_level : 2,
      hgnc_id : "HGNC:25440",
      havana_gene : "OTTHUMG00000169736.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 84859491,
      stop : 84913629,
      direction : "-",
      ID : "ENSG00000072041.18",
      gene_id : "ENSG00000072041.18",
      gene_type : "protein_coding",
      gene_name : "SLC6A15",
      gene_level : 1,
      hgnc_id : "HGNC:13621",
      havana_gene : "OTTHUMG00000169742.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 85014311,
      stop : 85036277,
      direction : "-",
      ID : "ENSG00000231738.11",
      gene_id : "ENSG00000231738.11",
      gene_type : "protein_coding",
      gene_name : "TSPAN19",
      gene_level : 1,
      hgnc_id : "HGNC:31886",
      havana_gene : "OTTHUMG00000166181.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 85036314,
      stop : 85264457,
      direction : "+",
      ID : "ENSG00000133640.20",
      gene_id : "ENSG00000133640.20",
      gene_type : "protein_coding",
      gene_name : "LRRIQ1",
      gene_level : 1,
      hgnc_id : "HGNC:25708",
      havana_gene : "OTTHUMG00000166185.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 85280220,
      stop : 85301784,
      direction : "+",
      ID : "ENSG00000180318.4",
      gene_id : "ENSG00000180318.4",
      gene_type : "protein_coding",
      gene_name : "ALX1",
      gene_level : 2,
      hgnc_id : "HGNC:1494",
      havana_gene : "OTTHUMG00000169820.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 85800703,
      stop : 85836409,
      direction : "-",
      ID : "ENSG00000198774.5",
      gene_id : "ENSG00000198774.5",
      gene_type : "protein_coding",
      gene_name : "RASSF9",
      gene_level : 2,
      hgnc_id : "HGNC:15739",
      havana_gene : "OTTHUMG00000169831.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 85874295,
      stop : 85882992,
      direction : "+",
      ID : "ENSG00000133636.11",
      gene_id : "ENSG00000133636.11",
      gene_type : "protein_coding",
      gene_name : "NTS",
      gene_level : 2,
      hgnc_id : "HGNC:8038",
      havana_gene : "OTTHUMG00000169832.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 85955666,
      stop : 86838904,
      direction : "-",
      ID : "ENSG00000182050.13",
      gene_id : "ENSG00000182050.13",
      gene_type : "protein_coding",
      gene_name : "MGAT4C",
      gene_level : 2,
      hgnc_id : "HGNC:30871",
      havana_gene : "OTTHUMG00000169846.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 87980035,
      stop : 88034037,
      direction : "-",
      ID : "ENSG00000165805.10",
      gene_id : "ENSG00000165805.10",
      gene_type : "protein_coding",
      gene_name : "C12orf50",
      gene_level : 2,
      hgnc_id : "HGNC:26665",
      havana_gene : "OTTHUMG00000169869.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 88033846,
      stop : 88050160,
      direction : "+",
      ID : "ENSG00000133641.18",
      gene_id : "ENSG00000133641.18",
      gene_type : "protein_coding",
      gene_name : "C12orf29",
      gene_level : 2,
      hgnc_id : "HGNC:25322",
      havana_gene : "OTTHUMG00000169870.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 88049016,
      stop : 88142099,
      direction : "-",
      ID : "ENSG00000198707.17",
      gene_id : "ENSG00000198707.17",
      gene_type : "protein_coding",
      gene_name : "CEP290",
      gene_level : 2,
      hgnc_id : "HGNC:29021",
      havana_gene : "OTTHUMG00000169871.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 88142296,
      stop : 88199887,
      direction : "+",
      ID : "ENSG00000139324.12",
      gene_id : "ENSG00000139324.12",
      gene_type : "protein_coding",
      gene_name : "TMTC3",
      gene_level : 1,
      hgnc_id : "HGNC:26899",
      havana_gene : "OTTHUMG00000169887.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 88492793,
      stop : 88580851,
      direction : "-",
      ID : "ENSG00000049130.16",
      gene_id : "ENSG00000049130.16",
      gene_type : "protein_coding",
      gene_name : "KITLG",
      gene_level : 2,
      hgnc_id : "HGNC:6343",
      havana_gene : "OTTHUMG00000169888.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 89347235,
      stop : 89352501,
      direction : "-",
      ID : "ENSG00000139318.8",
      gene_id : "ENSG00000139318.8",
      gene_type : "protein_coding",
      gene_name : "DUSP6",
      gene_level : 2,
      hgnc_id : "HGNC:3072",
      havana_gene : "OTTHUMG00000169912.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 89419718,
      stop : 89526047,
      direction : "-",
      ID : "ENSG00000139323.14",
      gene_id : "ENSG00000139323.14",
      gene_type : "protein_coding",
      gene_name : "POC1B",
      gene_level : 2,
      hgnc_id : "HGNC:30836",
      havana_gene : "OTTHUMG00000169944.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 89519408,
      stop : 89526262,
      direction : "-",
      ID : "ENSG00000259075.6",
      gene_id : "ENSG00000259075.6",
      gene_type : "protein_coding",
      gene_name : "POC1B-GALNT4",
      gene_level : 2,
      hgnc_id : "HGNC:42957",
      havana_gene : "OTTHUMG00000171333.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 89519412,
      stop : 89524796,
      direction : "-",
      ID : "ENSG00000257594.4",
      gene_id : "ENSG00000257594.4",
      gene_type : "protein_coding",
      gene_name : "GALNT4",
      gene_level : 2,
      hgnc_id : "HGNC:4126",
      havana_gene : "OTTHUMG00000166292.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 89588049,
      stop : 89709300,
      direction : "-",
      ID : "ENSG00000070961.16",
      gene_id : "ENSG00000070961.16",
      gene_type : "protein_coding",
      gene_name : "ATP2B1",
      gene_level : 2,
      hgnc_id : "HGNC:814",
      havana_gene : "OTTHUMG00000169946.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 90905622,
      stop : 90955176,
      direction : "-",
      ID : "ENSG00000197651.4",
      gene_id : "ENSG00000197651.4",
      gene_type : "protein_coding",
      gene_name : "CCER1",
      gene_level : 2,
      hgnc_id : "HGNC:28373",
      havana_gene : "OTTHUMG00000170070.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 90963682,
      stop : 91005026,
      direction : "-",
      ID : "ENSG00000083782.8",
      gene_id : "ENSG00000083782.8",
      gene_type : "protein_coding",
      gene_name : "EPYC",
      gene_level : 2,
      hgnc_id : "HGNC:3053",
      havana_gene : "OTTHUMG00000170072.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 91050491,
      stop : 91058024,
      direction : "-",
      ID : "ENSG00000139330.6",
      gene_id : "ENSG00000139330.6",
      gene_type : "protein_coding",
      gene_name : "KERA",
      gene_level : 2,
      hgnc_id : "HGNC:6309",
      havana_gene : "OTTHUMG00000170073.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 91102629,
      stop : 91111494,
      direction : "-",
      ID : "ENSG00000139329.5",
      gene_id : "ENSG00000139329.5",
      gene_type : "protein_coding",
      gene_name : "LUM",
      gene_level : 2,
      hgnc_id : "HGNC:6724",
      havana_gene : "OTTHUMG00000170074.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 91140484,
      stop : 91183217,
      direction : "-",
      ID : "ENSG00000011465.18",
      gene_id : "ENSG00000011465.18",
      gene_type : "protein_coding",
      gene_name : "DCN",
      gene_level : 1,
      hgnc_id : "HGNC:2705",
      havana_gene : "OTTHUMG00000169998.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 92140278,
      stop : 92145846,
      direction : "-",
      ID : "ENSG00000133639.6",
      gene_id : "ENSG00000133639.6",
      gene_type : "protein_coding",
      gene_name : "BTG1",
      gene_level : 2,
      hgnc_id : "HGNC:1130",
      havana_gene : "OTTHUMG00000170092.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 92702843,
      stop : 92772455,
      direction : "+",
      ID : "ENSG00000187510.10",
      gene_id : "ENSG00000187510.10",
      gene_type : "protein_coding",
      gene_name : "PLEKHG7",
      gene_level : 1,
      hgnc_id : "HGNC:33829",
      havana_gene : "OTTHUMG00000170106.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 92770637,
      stop : 92929331,
      direction : "-",
      ID : "ENSG00000102189.17",
      gene_id : "ENSG00000102189.17",
      gene_type : "protein_coding",
      gene_name : "EEA1",
      gene_level : 2,
      hgnc_id : "HGNC:3185",
      havana_gene : "OTTHUMG00000170110.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 93377883,
      stop : 93408146,
      direction : "+",
      ID : "ENSG00000173598.14",
      gene_id : "ENSG00000173598.14",
      gene_type : "protein_coding",
      gene_name : "NUDT4",
      gene_level : 2,
      hgnc_id : "HGNC:8051",
      havana_gene : "OTTHUMG00000170155.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 93405673,
      stop : 93441947,
      direction : "-",
      ID : "ENSG00000177889.10",
      gene_id : "ENSG00000177889.10",
      gene_type : "protein_coding",
      gene_name : "UBE2N",
      gene_level : 1,
      hgnc_id : "HGNC:12492",
      havana_gene : "OTTHUMG00000170156.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 93467514,
      stop : 93516214,
      direction : "+",
      ID : "ENSG00000198015.14",
      gene_id : "ENSG00000198015.14",
      gene_type : "protein_coding",
      gene_name : "MRPL42",
      gene_level : 1,
      hgnc_id : "HGNC:14493",
      havana_gene : "OTTHUMG00000170157.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 93569814,
      stop : 93583487,
      direction : "+",
      ID : "ENSG00000120833.14",
      gene_id : "ENSG00000120833.14",
      gene_type : "protein_coding",
      gene_name : "SOCS2",
      gene_level : 1,
      hgnc_id : "HGNC:19382",
      havana_gene : "OTTHUMG00000170160.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 93677375,
      stop : 93894840,
      direction : "+",
      ID : "ENSG00000169372.13",
      gene_id : "ENSG00000169372.13",
      gene_type : "protein_coding",
      gene_name : "CRADD",
      gene_level : 1,
      hgnc_id : "HGNC:2340",
      havana_gene : "OTTHUMG00000170322.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 94148577,
      stop : 94307675,
      direction : "+",
      ID : "ENSG00000136040.9",
      gene_id : "ENSG00000136040.9",
      gene_type : "protein_coding",
      gene_name : "PLXNC1",
      gene_level : 1,
      hgnc_id : "HGNC:9106",
      havana_gene : "OTTHUMG00000170235.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 94306449,
      stop : 94459988,
      direction : "-",
      ID : "ENSG00000173588.15",
      gene_id : "ENSG00000173588.15",
      gene_type : "protein_coding",
      gene_name : "CEP83",
      gene_level : 1,
      hgnc_id : "HGNC:17966",
      havana_gene : "OTTHUMG00000170242.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 94567122,
      stop : 94650557,
      direction : "-",
      ID : "ENSG00000057704.13",
      gene_id : "ENSG00000057704.13",
      gene_type : "protein_coding",
      gene_name : "TMCC3",
      gene_level : 1,
      hgnc_id : "HGNC:29199",
      havana_gene : "OTTHUMG00000170225.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 94897055,
      stop : 95003748,
      direction : "-",
      ID : "ENSG00000184752.13",
      gene_id : "ENSG00000184752.13",
      gene_type : "protein_coding",
      gene_name : "NDUFA12",
      gene_level : 1,
      hgnc_id : "HGNC:23987",
      havana_gene : "OTTHUMG00000170098.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95020229,
      stop : 95073628,
      direction : "-",
      ID : "ENSG00000120798.17",
      gene_id : "ENSG00000120798.17",
      gene_type : "protein_coding",
      gene_name : "NR2C1",
      gene_level : 1,
      hgnc_id : "HGNC:7971",
      havana_gene : "OTTHUMG00000170131.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95076749,
      stop : 95217482,
      direction : "-",
      ID : "ENSG00000180263.14",
      gene_id : "ENSG00000180263.14",
      gene_type : "protein_coding",
      gene_name : "FGD6",
      gene_level : 2,
      hgnc_id : "HGNC:21740",
      havana_gene : "OTTHUMG00000170133.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95217746,
      stop : 95302799,
      direction : "+",
      ID : "ENSG00000028203.18",
      gene_id : "ENSG00000028203.18",
      gene_type : "protein_coding",
      gene_name : "VEZT",
      gene_level : 2,
      hgnc_id : "HGNC:18258",
      havana_gene : "OTTHUMG00000170182.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95473520,
      stop : 95515839,
      direction : "+",
      ID : "ENSG00000111142.14",
      gene_id : "ENSG00000111142.14",
      gene_type : "protein_coding",
      gene_name : "METAP2",
      gene_level : 1,
      hgnc_id : "HGNC:16672",
      havana_gene : "OTTHUMG00000170280.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95516560,
      stop : 95551476,
      direction : "-",
      ID : "ENSG00000136014.12",
      gene_id : "ENSG00000136014.12",
      gene_type : "protein_coding",
      gene_name : "USP44",
      gene_level : 1,
      hgnc_id : "HGNC:20064",
      havana_gene : "OTTHUMG00000170281.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95657807,
      stop : 95791189,
      direction : "-",
      ID : "ENSG00000074527.13",
      gene_id : "ENSG00000074527.13",
      gene_type : "protein_coding",
      gene_name : "NTN4",
      gene_level : 1,
      hgnc_id : "HGNC:13658",
      havana_gene : "OTTHUMG00000170290.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95858928,
      stop : 95903828,
      direction : "+",
      ID : "ENSG00000139343.10",
      gene_id : "ENSG00000139343.10",
      gene_type : "protein_coding",
      gene_name : "SNRPF",
      gene_level : 2,
      hgnc_id : "HGNC:11162",
      havana_gene : "OTTHUMG00000170351.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95867048,
      stop : 95942635,
      direction : "-",
      ID : "ENSG00000165972.13",
      gene_id : "ENSG00000165972.13",
      gene_type : "protein_coding",
      gene_name : "CCDC38",
      gene_level : 2,
      hgnc_id : "HGNC:26843",
      havana_gene : "OTTHUMG00000170352.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95943331,
      stop : 95968720,
      direction : "+",
      ID : "ENSG00000139344.8",
      gene_id : "ENSG00000139344.8",
      gene_type : "protein_coding",
      gene_name : "AMDHD1",
      gene_level : 2,
      hgnc_id : "HGNC:28577",
      havana_gene : "OTTHUMG00000170353.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 95972662,
      stop : 95996365,
      direction : "-",
      ID : "ENSG00000084110.11",
      gene_id : "ENSG00000084110.11",
      gene_type : "protein_coding",
      gene_name : "HAL",
      gene_level : 1,
      hgnc_id : "HGNC:4806",
      havana_gene : "OTTHUMG00000170354.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 96000753,
      stop : 96043520,
      direction : "-",
      ID : "ENSG00000111144.10",
      gene_id : "ENSG00000111144.10",
      gene_type : "protein_coding",
      gene_name : "LTA4H",
      gene_level : 2,
      hgnc_id : "HGNC:6710",
      havana_gene : "OTTHUMG00000170355.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 96194375,
      stop : 96269824,
      direction : "+",
      ID : "ENSG00000111145.8",
      gene_id : "ENSG00000111145.8",
      gene_type : "protein_coding",
      gene_name : "ELK3",
      gene_level : 2,
      hgnc_id : "HGNC:3325",
      havana_gene : "OTTHUMG00000170364.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 96278261,
      stop : 96400480,
      direction : "-",
      ID : "ENSG00000059758.8",
      gene_id : "ENSG00000059758.8",
      gene_type : "protein_coding",
      gene_name : "CDK17",
      gene_level : 2,
      hgnc_id : "HGNC:8750",
      havana_gene : "OTTHUMG00000170375.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 96489571,
      stop : 96875555,
      direction : "+",
      ID : "ENSG00000188596.11",
      gene_id : "ENSG00000188596.11",
      gene_type : "protein_coding",
      gene_name : "CFAP54",
      gene_level : 1,
      hgnc_id : "HGNC:26456",
      havana_gene : "OTTHUMG00000167566.10",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 96907224,
      stop : 96953780,
      direction : "+",
      ID : "ENSG00000139350.12",
      gene_id : "ENSG00000139350.12",
      gene_type : "protein_coding",
      gene_name : "NEDD1",
      gene_level : 2,
      hgnc_id : "HGNC:7723",
      havana_gene : "OTTHUMG00000170604.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 98515579,
      stop : 98550351,
      direction : "+",
      ID : "ENSG00000120802.14",
      gene_id : "ENSG00000120802.14",
      gene_type : "protein_coding",
      gene_name : "TMPO",
      gene_level : 1,
      hgnc_id : "HGNC:11875",
      havana_gene : "OTTHUMG00000170210.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 98593591,
      stop : 98606379,
      direction : "+",
      ID : "ENSG00000075415.14",
      gene_id : "ENSG00000075415.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A3",
      gene_level : 2,
      hgnc_id : "HGNC:10989",
      havana_gene : "OTTHUMG00000170212.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 98613405,
      stop : 98645113,
      direction : "-",
      ID : "ENSG00000166130.15",
      gene_id : "ENSG00000166130.15",
      gene_type : "protein_coding",
      gene_name : "IKBIP",
      gene_level : 2,
      hgnc_id : "HGNC:26430",
      havana_gene : "OTTHUMG00000170213.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 98645290,
      stop : 98735433,
      direction : "+",
      ID : "ENSG00000120868.14",
      gene_id : "ENSG00000120868.14",
      gene_type : "protein_coding",
      gene_name : "APAF1",
      gene_level : 2,
      hgnc_id : "HGNC:576",
      havana_gene : "OTTHUMG00000170214.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 98726457,
      stop : 99984654,
      direction : "-",
      ID : "ENSG00000185046.18",
      gene_id : "ENSG00000185046.18",
      gene_type : "protein_coding",
      gene_name : "ANKS1B",
      gene_level : 1,
      hgnc_id : "HGNC:24600",
      havana_gene : "OTTHUMG00000170308.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 99647753,
      stop : 99650114,
      direction : "+",
      ID : "ENSG00000180219.2",
      gene_id : "ENSG00000180219.2",
      gene_type : "protein_coding",
      gene_name : "FAM71C",
      gene_level : 2,
      hgnc_id : "HGNC:28594",
      havana_gene : "OTTHUMG00000170311.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100028455,
      stop : 100142874,
      direction : "-",
      ID : "ENSG00000111647.13",
      gene_id : "ENSG00000111647.13",
      gene_type : "protein_coding",
      gene_name : "UHRF1BP1L",
      gene_level : 2,
      hgnc_id : "HGNC:29102",
      havana_gene : "OTTHUMG00000170195.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100199122,
      stop : 100241865,
      direction : "+",
      ID : "ENSG00000075089.10",
      gene_id : "ENSG00000075089.10",
      gene_type : "protein_coding",
      gene_name : "ACTR6",
      gene_level : 2,
      hgnc_id : "HGNC:24025",
      havana_gene : "OTTHUMG00000170245.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100203669,
      stop : 100267079,
      direction : "-",
      ID : "ENSG00000166153.16",
      gene_id : "ENSG00000166153.16",
      gene_type : "protein_coding",
      gene_name : "DEPDC4",
      gene_level : 2,
      hgnc_id : "HGNC:22952",
      havana_gene : "OTTHUMG00000170318.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100267140,
      stop : 100341715,
      direction : "+",
      ID : "ENSG00000136021.19",
      gene_id : "ENSG00000136021.19",
      gene_type : "protein_coding",
      gene_name : "SCYL2",
      gene_level : 2,
      hgnc_id : "HGNC:19286",
      havana_gene : "OTTHUMG00000170319.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100357074,
      stop : 100422055,
      direction : "+",
      ID : "ENSG00000179520.11",
      gene_id : "ENSG00000179520.11",
      gene_type : "protein_coding",
      gene_name : "SLC17A8",
      gene_level : 2,
      hgnc_id : "HGNC:20151",
      havana_gene : "OTTHUMG00000170358.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100473708,
      stop : 100564414,
      direction : "+",
      ID : "ENSG00000012504.15",
      gene_id : "ENSG00000012504.15",
      gene_type : "protein_coding",
      gene_name : "NR1H4",
      gene_level : 1,
      hgnc_id : "HGNC:7967",
      havana_gene : "OTTHUMG00000170359.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100573683,
      stop : 100628288,
      direction : "+",
      ID : "ENSG00000139354.11",
      gene_id : "ENSG00000139354.11",
      gene_type : "protein_coding",
      gene_name : "GAS2L3",
      gene_level : 1,
      hgnc_id : "HGNC:27475",
      havana_gene : "OTTHUMG00000170439.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 100717526,
      stop : 101128641,
      direction : "+",
      ID : "ENSG00000151572.18",
      gene_id : "ENSG00000151572.18",
      gene_type : "protein_coding",
      gene_name : "ANO4",
      gene_level : 2,
      hgnc_id : "HGNC:23837",
      havana_gene : "OTTHUMG00000170465.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101155493,
      stop : 101210238,
      direction : "-",
      ID : "ENSG00000256870.3",
      gene_id : "ENSG00000256870.3",
      gene_type : "protein_coding",
      gene_name : "SLC5A8",
      gene_level : 2,
      hgnc_id : "HGNC:19119",
      havana_gene : "OTTHUMG00000170499.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101280105,
      stop : 101386618,
      direction : "+",
      ID : "ENSG00000120800.5",
      gene_id : "ENSG00000120800.5",
      gene_type : "protein_coding",
      gene_name : "UTP20",
      gene_level : 2,
      hgnc_id : "HGNC:17897",
      havana_gene : "OTTHUMG00000170270.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101393116,
      stop : 101407772,
      direction : "-",
      ID : "ENSG00000120805.14",
      gene_id : "ENSG00000120805.14",
      gene_type : "protein_coding",
      gene_name : "ARL1",
      gene_level : 1,
      hgnc_id : "HGNC:692",
      havana_gene : "OTTHUMG00000170271.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101475336,
      stop : 101486997,
      direction : "+",
      ID : "ENSG00000166211.8",
      gene_id : "ENSG00000166211.8",
      gene_type : "protein_coding",
      gene_name : "SPIC",
      gene_level : 2,
      hgnc_id : "HGNC:29549",
      havana_gene : "OTTHUMG00000170273.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101568353,
      stop : 101686028,
      direction : "+",
      ID : "ENSG00000196091.15",
      gene_id : "ENSG00000196091.15",
      gene_type : "protein_coding",
      gene_name : "MYBPC1",
      gene_level : 1,
      hgnc_id : "HGNC:7549",
      havana_gene : "OTTHUMG00000170274.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101696947,
      stop : 101744140,
      direction : "+",
      ID : "ENSG00000111666.11",
      gene_id : "ENSG00000111666.11",
      gene_type : "protein_coding",
      gene_name : "CHPT1",
      gene_level : 1,
      hgnc_id : "HGNC:17852",
      havana_gene : "OTTHUMG00000170443.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101728648,
      stop : 101739472,
      direction : "-",
      ID : "ENSG00000139351.15",
      gene_id : "ENSG00000139351.15",
      gene_type : "protein_coding",
      gene_name : "SYCP3",
      gene_level : 2,
      hgnc_id : "HGNC:18130",
      havana_gene : "OTTHUMG00000150132.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101745499,
      stop : 101830959,
      direction : "-",
      ID : "ENSG00000111670.16",
      gene_id : "ENSG00000111670.16",
      gene_type : "protein_coding",
      gene_name : "GNPTAB",
      gene_level : 2,
      hgnc_id : "HGNC:29670",
      havana_gene : "OTTHUMG00000170444.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 101877580,
      stop : 102012130,
      direction : "+",
      ID : "ENSG00000136048.14",
      gene_id : "ENSG00000136048.14",
      gene_type : "protein_coding",
      gene_name : "DRAM1",
      gene_level : 1,
      hgnc_id : "HGNC:25645",
      havana_gene : "OTTHUMG00000170447.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102012840,
      stop : 102062149,
      direction : "-",
      ID : "ENSG00000120860.11",
      gene_id : "ENSG00000120860.11",
      gene_type : "protein_coding",
      gene_name : "WASHC3",
      gene_level : 2,
      hgnc_id : "HGNC:24256",
      havana_gene : "OTTHUMG00000168187.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102073103,
      stop : 102120120,
      direction : "-",
      ID : "ENSG00000075188.9",
      gene_id : "ENSG00000075188.9",
      gene_type : "protein_coding",
      gene_name : "NUP37",
      gene_level : 2,
      hgnc_id : "HGNC:29929",
      havana_gene : "OTTHUMG00000170478.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102120183,
      stop : 102197520,
      direction : "+",
      ID : "ENSG00000185480.12",
      gene_id : "ENSG00000185480.12",
      gene_type : "protein_coding",
      gene_name : "PARPBP",
      gene_level : 1,
      hgnc_id : "HGNC:26074",
      havana_gene : "OTTHUMG00000167923.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102196459,
      stop : 102197833,
      direction : "-",
      ID : "ENSG00000183395.5",
      gene_id : "ENSG00000183395.5",
      gene_type : "protein_coding",
      gene_name : "PMCH",
      gene_level : 2,
      hgnc_id : "HGNC:9109",
      havana_gene : "OTTHUMG00000170479.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102395874,
      stop : 102481744,
      direction : "-",
      ID : "ENSG00000017427.17",
      gene_id : "ENSG00000017427.17",
      gene_type : "protein_coding",
      gene_name : "IGF1",
      gene_level : 1,
      hgnc_id : "HGNC:5464",
      havana_gene : "OTTHUMG00000149910.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102836889,
      stop : 102958410,
      direction : "-",
      ID : "ENSG00000171759.10",
      gene_id : "ENSG00000171759.10",
      gene_type : "protein_coding",
      gene_name : "PAH",
      gene_level : 1,
      hgnc_id : "HGNC:8582",
      havana_gene : "OTTHUMG00000169966.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 102957674,
      stop : 102960513,
      direction : "+",
      ID : "ENSG00000139352.4",
      gene_id : "ENSG00000139352.4",
      gene_type : "protein_coding",
      gene_name : "ASCL1",
      gene_level : 2,
      hgnc_id : "HGNC:738",
      havana_gene : "OTTHUMG00000169967.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103237591,
      stop : 103495978,
      direction : "-",
      ID : "ENSG00000179088.15",
      gene_id : "ENSG00000179088.15",
      gene_type : "protein_coding",
      gene_name : "C12orf42",
      gene_level : 2,
      hgnc_id : "HGNC:24729",
      havana_gene : "OTTHUMG00000169988.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103587273,
      stop : 103766719,
      direction : "+",
      ID : "ENSG00000136011.15",
      gene_id : "ENSG00000136011.15",
      gene_type : "protein_coding",
      gene_name : "STAB2",
      gene_level : 2,
      hgnc_id : "HGNC:18629",
      havana_gene : "OTTHUMG00000170056.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103770453,
      stop : 103841234,
      direction : "-",
      ID : "ENSG00000111696.12",
      gene_id : "ENSG00000111696.12",
      gene_type : "protein_coding",
      gene_name : "NT5DC3",
      gene_level : 2,
      hgnc_id : "HGNC:30826",
      havana_gene : "OTTHUMG00000157017.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103930107,
      stop : 103953931,
      direction : "+",
      ID : "ENSG00000166598.16",
      gene_id : "ENSG00000166598.16",
      gene_type : "protein_coding",
      gene_name : "HSP90B1",
      gene_level : 1,
      hgnc_id : "HGNC:12028",
      havana_gene : "OTTHUMG00000170118.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103940763,
      stop : 103965708,
      direction : "-",
      ID : "ENSG00000204954.10",
      gene_id : "ENSG00000204954.10",
      gene_type : "protein_coding",
      gene_name : "C12orf73",
      gene_level : 2,
      hgnc_id : "HGNC:34450",
      havana_gene : "OTTHUMG00000170119.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103965822,
      stop : 103988874,
      direction : "+",
      ID : "ENSG00000139372.15",
      gene_id : "ENSG00000139372.15",
      gene_type : "protein_coding",
      gene_name : "TDG",
      gene_level : 1,
      hgnc_id : "HGNC:11700",
      havana_gene : "OTTHUMG00000168418.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 103988987,
      stop : 104064183,
      direction : "-",
      ID : "ENSG00000120820.13",
      gene_id : "ENSG00000120820.13",
      gene_type : "protein_coding",
      gene_name : "GLT8D2",
      gene_level : 1,
      hgnc_id : "HGNC:24890",
      havana_gene : "OTTHUMG00000170120.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104064531,
      stop : 104106524,
      direction : "+",
      ID : "ENSG00000111727.12",
      gene_id : "ENSG00000111727.12",
      gene_type : "protein_coding",
      gene_name : "HCFC2",
      gene_level : 1,
      hgnc_id : "HGNC:24972",
      havana_gene : "OTTHUMG00000170175.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104117086,
      stop : 104138241,
      direction : "-",
      ID : "ENSG00000120837.8",
      gene_id : "ENSG00000120837.8",
      gene_type : "protein_coding",
      gene_name : "NFYB",
      gene_level : 2,
      hgnc_id : "HGNC:7805",
      havana_gene : "OTTHUMG00000170176.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104215779,
      stop : 104350307,
      direction : "+",
      ID : "ENSG00000198431.16",
      gene_id : "ENSG00000198431.16",
      gene_type : "protein_coding",
      gene_name : "TXNRD1",
      gene_level : 1,
      hgnc_id : "HGNC:12437",
      havana_gene : "OTTHUMG00000166481.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104303739,
      stop : 104305205,
      direction : "+",
      ID : "ENSG00000255150.2",
      gene_id : "ENSG00000255150.2",
      gene_type : "protein_coding",
      gene_name : "EID3",
      gene_level : 2,
      hgnc_id : "HGNC:32961",
      havana_gene : "OTTHUMG00000165912.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104455295,
      stop : 104762014,
      direction : "+",
      ID : "ENSG00000171310.11",
      gene_id : "ENSG00000171310.11",
      gene_type : "protein_coding",
      gene_name : "CHST11",
      gene_level : 2,
      hgnc_id : "HGNC:17422",
      havana_gene : "OTTHUMG00000169803.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104802553,
      stop : 104958744,
      direction : "-",
      ID : "ENSG00000136052.9",
      gene_id : "ENSG00000136052.9",
      gene_type : "protein_coding",
      gene_name : "SLC41A2",
      gene_level : 2,
      hgnc_id : "HGNC:31045",
      havana_gene : "OTTHUMG00000156965.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 104986316,
      stop : 105074197,
      direction : "+",
      ID : "ENSG00000151131.11",
      gene_id : "ENSG00000151131.11",
      gene_type : "protein_coding",
      gene_name : "C12orf45",
      gene_level : 1,
      hgnc_id : "HGNC:28628",
      havana_gene : "OTTHUMG00000169822.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 105019784,
      stop : 105107643,
      direction : "-",
      ID : "ENSG00000136010.14",
      gene_id : "ENSG00000136010.14",
      gene_type : "protein_coding",
      gene_name : "ALDH1L2",
      gene_level : 2,
      hgnc_id : "HGNC:26777",
      havana_gene : "OTTHUMG00000169823.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 105107324,
      stop : 105169130,
      direction : "+",
      ID : "ENSG00000136051.15",
      gene_id : "ENSG00000136051.15",
      gene_type : "protein_coding",
      gene_name : "WASHC4",
      gene_level : 2,
      hgnc_id : "HGNC:29174",
      havana_gene : "OTTHUMG00000169838.12",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 105173297,
      stop : 105236203,
      direction : "-",
      ID : "ENSG00000136044.12",
      gene_id : "ENSG00000136044.12",
      gene_type : "protein_coding",
      gene_name : "APPL2",
      gene_level : 1,
      hgnc_id : "HGNC:18242",
      havana_gene : "OTTHUMG00000169853.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 105235290,
      stop : 105396097,
      direction : "+",
      ID : "ENSG00000235162.9",
      gene_id : "ENSG00000235162.9",
      gene_type : "protein_coding",
      gene_name : "C12orf75",
      gene_level : 2,
      hgnc_id : "HGNC:35164",
      havana_gene : "OTTHUMG00000150129.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106063345,
      stop : 106138954,
      direction : "-",
      ID : "ENSG00000074590.14",
      gene_id : "ENSG00000074590.14",
      gene_type : "protein_coding",
      gene_name : "NUAK1",
      gene_level : 1,
      hgnc_id : "HGNC:14311",
      havana_gene : "OTTHUMG00000169763.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106237881,
      stop : 106304279,
      direction : "-",
      ID : "ENSG00000136026.14",
      gene_id : "ENSG00000136026.14",
      gene_type : "protein_coding",
      gene_name : "CKAP4",
      gene_level : 1,
      hgnc_id : "HGNC:16991",
      havana_gene : "OTTHUMG00000170085.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106301929,
      stop : 106347003,
      direction : "+",
      ID : "ENSG00000166046.11",
      gene_id : "ENSG00000166046.11",
      gene_type : "protein_coding",
      gene_name : "TCP11L2",
      gene_level : 1,
      hgnc_id : "HGNC:28627",
      havana_gene : "OTTHUMG00000170087.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106357748,
      stop : 106510198,
      direction : "+",
      ID : "ENSG00000013503.10",
      gene_id : "ENSG00000013503.10",
      gene_type : "protein_coding",
      gene_name : "POLR3B",
      gene_level : 2,
      hgnc_id : "HGNC:30348",
      havana_gene : "OTTHUMG00000170077.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106583004,
      stop : 106762803,
      direction : "+",
      ID : "ENSG00000111783.13",
      gene_id : "ENSG00000111783.13",
      gene_type : "protein_coding",
      gene_name : "RFX4",
      gene_level : 2,
      hgnc_id : "HGNC:9985",
      havana_gene : "OTTHUMG00000169173.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106774621,
      stop : 106889316,
      direction : "+",
      ID : "ENSG00000111785.21",
      gene_id : "ENSG00000111785.21",
      gene_type : "protein_coding",
      gene_name : "RIC8B",
      gene_level : 1,
      hgnc_id : "HGNC:25555",
      havana_gene : "OTTHUMG00000144188.10",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106955719,
      stop : 106978778,
      direction : "+",
      ID : "ENSG00000151135.10",
      gene_id : "ENSG00000151135.10",
      gene_type : "protein_coding",
      gene_name : "TMEM263",
      gene_level : 1,
      hgnc_id : "HGNC:28281",
      havana_gene : "OTTHUMG00000170014.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106977277,
      stop : 106987160,
      direction : "-",
      ID : "ENSG00000120832.10",
      gene_id : "ENSG00000120832.10",
      gene_type : "protein_coding",
      gene_name : "MTERF2",
      gene_level : 1,
      hgnc_id : "HGNC:30779",
      havana_gene : "OTTHUMG00000170007.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 106991364,
      stop : 107093549,
      direction : "-",
      ID : "ENSG00000008405.12",
      gene_id : "ENSG00000008405.12",
      gene_type : "protein_coding",
      gene_name : "CRY1",
      gene_level : 1,
      hgnc_id : "HGNC:2384",
      havana_gene : "OTTHUMG00000170005.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 107318421,
      stop : 107659642,
      direction : "+",
      ID : "ENSG00000151136.15",
      gene_id : "ENSG00000151136.15",
      gene_type : "protein_coding",
      gene_name : "BTBD11",
      gene_level : 2,
      hgnc_id : "HGNC:23844",
      havana_gene : "OTTHUMG00000150413.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 107685799,
      stop : 107713162,
      direction : "+",
      ID : "ENSG00000136045.12",
      gene_id : "ENSG00000136045.12",
      gene_type : "protein_coding",
      gene_name : "PWP1",
      gene_level : 1,
      hgnc_id : "HGNC:17015",
      havana_gene : "OTTHUMG00000169913.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 107732871,
      stop : 107761272,
      direction : "-",
      ID : "ENSG00000110851.12",
      gene_id : "ENSG00000110851.12",
      gene_type : "protein_coding",
      gene_name : "PRDM4",
      gene_level : 1,
      hgnc_id : "HGNC:9348",
      havana_gene : "OTTHUMG00000169914.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 107774385,
      stop : 107776644,
      direction : "+",
      ID : "ENSG00000187855.5",
      gene_id : "ENSG00000187855.5",
      gene_type : "protein_coding",
      gene_name : "ASCL4",
      gene_level : 2,
      hgnc_id : "HGNC:24311",
      havana_gene : "OTTHUMG00000156964.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108129288,
      stop : 108250537,
      direction : "+",
      ID : "ENSG00000075035.10",
      gene_id : "ENSG00000075035.10",
      gene_type : "protein_coding",
      gene_name : "WSCD2",
      gene_level : 1,
      hgnc_id : "HGNC:29117",
      havana_gene : "OTTHUMG00000169579.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108288044,
      stop : 108339317,
      direction : "-",
      ID : "ENSG00000174600.14",
      gene_id : "ENSG00000174600.14",
      gene_type : "protein_coding",
      gene_name : "CMKLR1",
      gene_level : 2,
      hgnc_id : "HGNC:2121",
      havana_gene : "OTTHUMG00000169576.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108515277,
      stop : 108525837,
      direction : "+",
      ID : "ENSG00000198855.7",
      gene_id : "ENSG00000198855.7",
      gene_type : "protein_coding",
      gene_name : "FICD",
      gene_level : 1,
      hgnc_id : "HGNC:18416",
      havana_gene : "OTTHUMG00000169569.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108522214,
      stop : 108561400,
      direction : "-",
      ID : "ENSG00000075856.12",
      gene_id : "ENSG00000075856.12",
      gene_type : "protein_coding",
      gene_name : "SART3",
      gene_level : 1,
      hgnc_id : "HGNC:16860",
      havana_gene : "OTTHUMG00000169449.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108562582,
      stop : 108569368,
      direction : "+",
      ID : "ENSG00000136003.16",
      gene_id : "ENSG00000136003.16",
      gene_type : "protein_coding",
      gene_name : "ISCU",
      gene_level : 1,
      hgnc_id : "HGNC:29882",
      havana_gene : "OTTHUMG00000168420.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108589851,
      stop : 108598320,
      direction : "-",
      ID : "ENSG00000183160.9",
      gene_id : "ENSG00000183160.9",
      gene_type : "protein_coding",
      gene_name : "TMEM119",
      gene_level : 2,
      hgnc_id : "HGNC:27884",
      havana_gene : "OTTHUMG00000169410.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108621895,
      stop : 108633894,
      direction : "-",
      ID : "ENSG00000110876.10",
      gene_id : "ENSG00000110876.10",
      gene_type : "protein_coding",
      gene_name : "SELPLG",
      gene_level : 1,
      hgnc_id : "HGNC:10722",
      havana_gene : "OTTHUMG00000169411.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108645109,
      stop : 108731526,
      direction : "-",
      ID : "ENSG00000110880.11",
      gene_id : "ENSG00000110880.11",
      gene_type : "protein_coding",
      gene_name : "CORO1C",
      gene_level : 2,
      hgnc_id : "HGNC:2254",
      havana_gene : "OTTHUMG00000169381.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108778191,
      stop : 108857590,
      direction : "-",
      ID : "ENSG00000084112.15",
      gene_id : "ENSG00000084112.15",
      gene_type : "protein_coding",
      gene_name : "SSH1",
      gene_level : 2,
      hgnc_id : "HGNC:30579",
      havana_gene : "OTTHUMG00000169371.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108858932,
      stop : 108901043,
      direction : "+",
      ID : "ENSG00000110887.8",
      gene_id : "ENSG00000110887.8",
      gene_type : "protein_coding",
      gene_name : "DAO",
      gene_level : 1,
      hgnc_id : "HGNC:2671",
      havana_gene : "OTTHUMG00000169360.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 108907741,
      stop : 109021068,
      direction : "-",
      ID : "ENSG00000166111.10",
      gene_id : "ENSG00000166111.10",
      gene_type : "protein_coding",
      gene_name : "SVOP",
      gene_level : 2,
      hgnc_id : "HGNC:25417",
      havana_gene : "OTTHUMG00000169432.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109023089,
      stop : 109088023,
      direction : "+",
      ID : "ENSG00000135093.13",
      gene_id : "ENSG00000135093.13",
      gene_type : "protein_coding",
      gene_name : "USP30",
      gene_level : 1,
      hgnc_id : "HGNC:20065",
      havana_gene : "OTTHUMG00000133613.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109088188,
      stop : 109093631,
      direction : "-",
      ID : "ENSG00000189046.11",
      gene_id : "ENSG00000189046.11",
      gene_type : "protein_coding",
      gene_name : "ALKBH2",
      gene_level : 1,
      hgnc_id : "HGNC:32487",
      havana_gene : "OTTHUMG00000169246.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109097597,
      stop : 109110992,
      direction : "+",
      ID : "ENSG00000076248.11",
      gene_id : "ENSG00000076248.11",
      gene_type : "protein_coding",
      gene_name : "UNG",
      gene_level : 2,
      hgnc_id : "HGNC:12572",
      havana_gene : "OTTHUMG00000169247.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109116595,
      stop : 109268226,
      direction : "+",
      ID : "ENSG00000076555.15",
      gene_id : "ENSG00000076555.15",
      gene_type : "protein_coding",
      gene_name : "ACACB",
      gene_level : 2,
      hgnc_id : "HGNC:85",
      havana_gene : "OTTHUMG00000169250.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109277978,
      stop : 109309284,
      direction : "-",
      ID : "ENSG00000139445.18",
      gene_id : "ENSG00000139445.18",
      gene_type : "protein_coding",
      gene_name : "FOXN4",
      gene_level : 2,
      hgnc_id : "HGNC:21399",
      havana_gene : "OTTHUMG00000152868.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109347903,
      stop : 109455523,
      direction : "+",
      ID : "ENSG00000174527.10",
      gene_id : "ENSG00000174527.10",
      gene_type : "protein_coding",
      gene_name : "MYO1H",
      gene_level : 1,
      hgnc_id : "HGNC:13879",
      havana_gene : "OTTHUMG00000169252.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109448655,
      stop : 109477359,
      direction : "-",
      ID : "ENSG00000110906.13",
      gene_id : "ENSG00000110906.13",
      gene_type : "protein_coding",
      gene_name : "KCTD10",
      gene_level : 1,
      hgnc_id : "HGNC:23236",
      havana_gene : "OTTHUMG00000169253.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109477402,
      stop : 109536705,
      direction : "+",
      ID : "ENSG00000151148.14",
      gene_id : "ENSG00000151148.14",
      gene_type : "protein_coding",
      gene_name : "UBE3B",
      gene_level : 2,
      hgnc_id : "HGNC:13478",
      havana_gene : "OTTHUMG00000169254.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109553715,
      stop : 109573580,
      direction : "-",
      ID : "ENSG00000139428.12",
      gene_id : "ENSG00000139428.12",
      gene_type : "protein_coding",
      gene_name : "MMAB",
      gene_level : 2,
      hgnc_id : "HGNC:19331",
      havana_gene : "OTTHUMG00000169255.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109573255,
      stop : 109598125,
      direction : "+",
      ID : "ENSG00000110921.14",
      gene_id : "ENSG00000110921.14",
      gene_type : "protein_coding",
      gene_name : "MVK",
      gene_level : 2,
      hgnc_id : "HGNC:7530",
      havana_gene : "OTTHUMG00000169256.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109713825,
      stop : 109770495,
      direction : "+",
      ID : "ENSG00000139438.6",
      gene_id : "ENSG00000139438.6",
      gene_type : "protein_coding",
      gene_name : "FAM222A",
      gene_level : 2,
      hgnc_id : "HGNC:25915",
      havana_gene : "OTTHUMG00000169260.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109783087,
      stop : 109833406,
      direction : "-",
      ID : "ENSG00000111199.12",
      gene_id : "ENSG00000111199.12",
      gene_type : "protein_coding",
      gene_name : "TRPV4",
      gene_level : 2,
      hgnc_id : "HGNC:18083",
      havana_gene : "OTTHUMG00000169277.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109850945,
      stop : 109880541,
      direction : "-",
      ID : "ENSG00000139433.11",
      gene_id : "ENSG00000139433.11",
      gene_type : "protein_coding",
      gene_name : "GLTP",
      gene_level : 2,
      hgnc_id : "HGNC:24867",
      havana_gene : "OTTHUMG00000169278.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109900264,
      stop : 109983841,
      direction : "+",
      ID : "ENSG00000139437.18",
      gene_id : "ENSG00000139437.18",
      gene_type : "protein_coding",
      gene_name : "TCHP",
      gene_level : 2,
      hgnc_id : "HGNC:28135",
      havana_gene : "OTTHUMG00000169281.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109929802,
      stop : 109996389,
      direction : "-",
      ID : "ENSG00000139436.21",
      gene_id : "ENSG00000139436.21",
      gene_type : "protein_coding",
      gene_name : "GIT2",
      gene_level : 1,
      hgnc_id : "HGNC:4273",
      havana_gene : "OTTHUMG00000169313.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 109999186,
      stop : 110039763,
      direction : "+",
      ID : "ENSG00000076513.17",
      gene_id : "ENSG00000076513.17",
      gene_type : "protein_coding",
      gene_name : "ANKRD13A",
      gene_level : 1,
      hgnc_id : "HGNC:21268",
      havana_gene : "OTTHUMG00000169314.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110027028,
      stop : 110073634,
      direction : "-",
      ID : "ENSG00000174456.15",
      gene_id : "ENSG00000174456.15",
      gene_type : "protein_coding",
      gene_name : "C12orf76",
      gene_level : 1,
      hgnc_id : "HGNC:33790",
      havana_gene : "OTTHUMG00000193487.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110124335,
      stop : 110218793,
      direction : "+",
      ID : "ENSG00000122970.16",
      gene_id : "ENSG00000122970.16",
      gene_type : "protein_coding",
      gene_name : "IFT81",
      gene_level : 2,
      hgnc_id : "HGNC:14313",
      havana_gene : "OTTHUMG00000169326.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110280756,
      stop : 110351093,
      direction : "+",
      ID : "ENSG00000174437.17",
      gene_id : "ENSG00000174437.17",
      gene_type : "protein_coding",
      gene_name : "ATP2A2",
      gene_level : 1,
      hgnc_id : "HGNC:812",
      havana_gene : "OTTHUMG00000169327.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110372900,
      stop : 110403730,
      direction : "-",
      ID : "ENSG00000196510.13",
      gene_id : "ENSG00000196510.13",
      gene_type : "protein_coding",
      gene_name : "ANAPC7",
      gene_level : 1,
      hgnc_id : "HGNC:17380",
      havana_gene : "OTTHUMG00000157009.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110434823,
      stop : 110450422,
      direction : "-",
      ID : "ENSG00000111229.16",
      gene_id : "ENSG00000111229.16",
      gene_type : "protein_coding",
      gene_name : "ARPC3",
      gene_level : 2,
      hgnc_id : "HGNC:706",
      havana_gene : "OTTHUMG00000134333.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110452486,
      stop : 110469268,
      direction : "-",
      ID : "ENSG00000111231.9",
      gene_id : "ENSG00000111231.9",
      gene_type : "protein_coding",
      gene_name : "GPN3",
      gene_level : 1,
      hgnc_id : "HGNC:30186",
      havana_gene : "OTTHUMG00000169524.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110468415,
      stop : 110490385,
      direction : "+",
      ID : "ENSG00000204856.12",
      gene_id : "ENSG00000204856.12",
      gene_type : "protein_coding",
      gene_name : "FAM216A",
      gene_level : 2,
      hgnc_id : "HGNC:30180",
      havana_gene : "OTTHUMG00000169526.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110491083,
      stop : 110502111,
      direction : "-",
      ID : "ENSG00000111237.19",
      gene_id : "ENSG00000111237.19",
      gene_type : "protein_coding",
      gene_name : "VPS29",
      gene_level : 1,
      hgnc_id : "HGNC:14340",
      havana_gene : "OTTHUMG00000169527.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110501655,
      stop : 110533556,
      direction : "+",
      ID : "ENSG00000151164.19",
      gene_id : "ENSG00000151164.19",
      gene_type : "protein_coding",
      gene_name : "RAD9B",
      gene_level : 1,
      hgnc_id : "HGNC:21700",
      havana_gene : "OTTHUMG00000152952.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110533245,
      stop : 110583318,
      direction : "-",
      ID : "ENSG00000196850.6",
      gene_id : "ENSG00000196850.6",
      gene_type : "protein_coding",
      gene_name : "PPTC7",
      gene_level : 2,
      hgnc_id : "HGNC:30695",
      havana_gene : "OTTHUMG00000169529.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110614027,
      stop : 110663431,
      direction : "+",
      ID : "ENSG00000204852.17",
      gene_id : "ENSG00000204852.17",
      gene_type : "protein_coding",
      gene_name : "TCTN1",
      gene_level : 1,
      hgnc_id : "HGNC:26113",
      havana_gene : "OTTHUMG00000150051.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110627841,
      stop : 110704950,
      direction : "-",
      ID : "ENSG00000122986.14",
      gene_id : "ENSG00000122986.14",
      gene_type : "protein_coding",
      gene_name : "HVCN1",
      gene_level : 1,
      hgnc_id : "HGNC:28240",
      havana_gene : "OTTHUMG00000169530.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110719680,
      stop : 110742939,
      direction : "-",
      ID : "ENSG00000186298.12",
      gene_id : "ENSG00000186298.12",
      gene_type : "protein_coding",
      gene_name : "PPP1CC",
      gene_level : 2,
      hgnc_id : "HGNC:9283",
      havana_gene : "OTTHUMG00000169531.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110846769,
      stop : 110907535,
      direction : "+",
      ID : "ENSG00000173093.13",
      gene_id : "ENSG00000173093.13",
      gene_type : "protein_coding",
      gene_name : "CCDC63",
      gene_level : 1,
      hgnc_id : "HGNC:26669",
      havana_gene : "OTTHUMG00000169534.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 110910819,
      stop : 110921443,
      direction : "-",
      ID : "ENSG00000111245.17",
      gene_id : "ENSG00000111245.17",
      gene_type : "protein_coding",
      gene_name : "MYL2",
      gene_level : 2,
      hgnc_id : "HGNC:7583",
      havana_gene : "OTTHUMG00000169535.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111034165,
      stop : 111350554,
      direction : "+",
      ID : "ENSG00000111249.14",
      gene_id : "ENSG00000111249.14",
      gene_type : "protein_coding",
      gene_name : "CUX2",
      gene_level : 2,
      hgnc_id : "HGNC:19347",
      havana_gene : "OTTHUMG00000169546.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111360651,
      stop : 111369121,
      direction : "-",
      ID : "ENSG00000198324.13",
      gene_id : "ENSG00000198324.13",
      gene_type : "protein_coding",
      gene_name : "PHETA1",
      gene_level : 2,
      hgnc_id : "HGNC:26509",
      havana_gene : "OTTHUMG00000169547.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111405923,
      stop : 111451623,
      direction : "+",
      ID : "ENSG00000111252.11",
      gene_id : "ENSG00000111252.11",
      gene_type : "protein_coding",
      gene_name : "SH2B3",
      gene_level : 1,
      hgnc_id : "HGNC:29605",
      havana_gene : "OTTHUMG00000169550.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111443485,
      stop : 111599676,
      direction : "-",
      ID : "ENSG00000204842.18",
      gene_id : "ENSG00000204842.18",
      gene_type : "protein_coding",
      gene_name : "ATXN2",
      gene_level : 1,
      hgnc_id : "HGNC:10555",
      havana_gene : "OTTHUMG00000133475.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111642146,
      stop : 111685956,
      direction : "-",
      ID : "ENSG00000089234.16",
      gene_id : "ENSG00000089234.16",
      gene_type : "protein_coding",
      gene_name : "BRAP",
      gene_level : 1,
      hgnc_id : "HGNC:1099",
      havana_gene : "OTTHUMG00000169600.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111686053,
      stop : 111757107,
      direction : "+",
      ID : "ENSG00000111271.15",
      gene_id : "ENSG00000111271.15",
      gene_type : "protein_coding",
      gene_name : "ACAD10",
      gene_level : 1,
      hgnc_id : "HGNC:21597",
      havana_gene : "OTTHUMG00000169602.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111753890,
      stop : 111791418,
      direction : "+",
      ID : "ENSG00000257767.3",
      gene_id : "ENSG00000257767.3",
      gene_type : "protein_coding",
      gene_name : "AC002996.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162267.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111766887,
      stop : 111817532,
      direction : "+",
      ID : "ENSG00000111275.13",
      gene_id : "ENSG00000111275.13",
      gene_type : "protein_coding",
      gene_name : "ALDH2",
      gene_level : 2,
      hgnc_id : "HGNC:404",
      havana_gene : "OTTHUMG00000169603.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111842228,
      stop : 111902222,
      direction : "+",
      ID : "ENSG00000089022.14",
      gene_id : "ENSG00000089022.14",
      gene_type : "protein_coding",
      gene_name : "MAPKAPK5",
      gene_level : 2,
      hgnc_id : "HGNC:6889",
      havana_gene : "OTTHUMG00000169605.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 111931282,
      stop : 112013185,
      direction : "-",
      ID : "ENSG00000198270.13",
      gene_id : "ENSG00000198270.13",
      gene_type : "protein_coding",
      gene_name : "TMEM116",
      gene_level : 1,
      hgnc_id : "HGNC:25084",
      havana_gene : "OTTHUMG00000169606.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112013348,
      stop : 112023449,
      direction : "+",
      ID : "ENSG00000089248.7",
      gene_id : "ENSG00000089248.7",
      gene_type : "protein_coding",
      gene_name : "ERP29",
      gene_level : 1,
      hgnc_id : "HGNC:13799",
      havana_gene : "OTTHUMG00000169637.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112026689,
      stop : 112108796,
      direction : "-",
      ID : "ENSG00000111300.10",
      gene_id : "ENSG00000111300.10",
      gene_type : "protein_coding",
      gene_name : "NAA25",
      gene_level : 2,
      hgnc_id : "HGNC:25783",
      havana_gene : "OTTHUMG00000169638.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112125538,
      stop : 112153604,
      direction : "+",
      ID : "ENSG00000135148.12",
      gene_id : "ENSG00000135148.12",
      gene_type : "protein_coding",
      gene_name : "TRAFD1",
      gene_level : 1,
      hgnc_id : "HGNC:24808",
      havana_gene : "OTTHUMG00000169640.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112160188,
      stop : 112382439,
      direction : "-",
      ID : "ENSG00000173064.13",
      gene_id : "ENSG00000173064.13",
      gene_type : "protein_coding",
      gene_name : "HECTD4",
      gene_level : 1,
      hgnc_id : "HGNC:26611",
      havana_gene : "OTTHUMG00000150719.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112405189,
      stop : 112418838,
      direction : "-",
      ID : "ENSG00000089009.16",
      gene_id : "ENSG00000089009.16",
      gene_type : "protein_coding",
      gene_name : "RPL6",
      gene_level : 2,
      hgnc_id : "HGNC:10362",
      havana_gene : "OTTHUMG00000169685.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112418351,
      stop : 112509918,
      direction : "+",
      ID : "ENSG00000179295.18",
      gene_id : "ENSG00000179295.18",
      gene_type : "protein_coding",
      gene_name : "PTPN11",
      gene_level : 2,
      hgnc_id : "HGNC:9644",
      havana_gene : "OTTHUMG00000134334.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112570380,
      stop : 112898881,
      direction : "+",
      ID : "ENSG00000089169.15",
      gene_id : "ENSG00000089169.15",
      gene_type : "protein_coding",
      gene_name : "RPH3A",
      gene_level : 1,
      hgnc_id : "HGNC:17056",
      havana_gene : "OTTHUMG00000169713.15",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112905856,
      stop : 112933219,
      direction : "+",
      ID : "ENSG00000089127.15",
      gene_id : "ENSG00000089127.15",
      gene_type : "protein_coding",
      gene_name : "OAS1",
      gene_level : 1,
      hgnc_id : "HGNC:8086",
      havana_gene : "OTTHUMG00000169792.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112938051,
      stop : 112976460,
      direction : "+",
      ID : "ENSG00000111331.14",
      gene_id : "ENSG00000111331.14",
      gene_type : "protein_coding",
      gene_name : "OAS3",
      gene_level : 2,
      hgnc_id : "HGNC:8088",
      havana_gene : "OTTHUMG00000169795.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 112978395,
      stop : 113011723,
      direction : "+",
      ID : "ENSG00000111335.14",
      gene_id : "ENSG00000111335.14",
      gene_type : "protein_coding",
      gene_name : "OAS2",
      gene_level : 2,
      hgnc_id : "HGNC:8087",
      havana_gene : "OTTHUMG00000169802.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113056709,
      stop : 113098028,
      direction : "+",
      ID : "ENSG00000135144.7",
      gene_id : "ENSG00000135144.7",
      gene_type : "protein_coding",
      gene_name : "DTX1",
      gene_level : 2,
      hgnc_id : "HGNC:3060",
      havana_gene : "OTTHUMG00000169610.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113098819,
      stop : 113136239,
      direction : "-",
      ID : "ENSG00000111344.11",
      gene_id : "ENSG00000111344.11",
      gene_type : "protein_coding",
      gene_name : "RASAL1",
      gene_level : 1,
      hgnc_id : "HGNC:9873",
      havana_gene : "OTTHUMG00000169705.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113149858,
      stop : 113159276,
      direction : "+",
      ID : "ENSG00000186710.11",
      gene_id : "ENSG00000186710.11",
      gene_type : "protein_coding",
      gene_name : "CFAP73",
      gene_level : 1,
      hgnc_id : "HGNC:37100",
      havana_gene : "OTTHUMG00000169655.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113157173,
      stop : 113185479,
      direction : "-",
      ID : "ENSG00000123064.13",
      gene_id : "ENSG00000123064.13",
      gene_type : "protein_coding",
      gene_name : "DDX54",
      gene_level : 1,
      hgnc_id : "HGNC:20084",
      havana_gene : "OTTHUMG00000169676.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113185526,
      stop : 113192368,
      direction : "+",
      ID : "ENSG00000139405.16",
      gene_id : "ENSG00000139405.16",
      gene_type : "protein_coding",
      gene_name : "RITA1",
      gene_level : 2,
      hgnc_id : "HGNC:25925",
      havana_gene : "OTTHUMG00000169643.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113195441,
      stop : 113221094,
      direction : "-",
      ID : "ENSG00000166578.10",
      gene_id : "ENSG00000166578.10",
      gene_type : "protein_coding",
      gene_name : "IQCD",
      gene_level : 2,
      hgnc_id : "HGNC:25168",
      havana_gene : "OTTHUMG00000169659.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113221050,
      stop : 113298585,
      direction : "+",
      ID : "ENSG00000186815.13",
      gene_id : "ENSG00000186815.13",
      gene_type : "protein_coding",
      gene_name : "TPCN1",
      gene_level : 1,
      hgnc_id : "HGNC:18182",
      havana_gene : "OTTHUMG00000169625.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113298759,
      stop : 113359493,
      direction : "-",
      ID : "ENSG00000089060.12",
      gene_id : "ENSG00000089060.12",
      gene_type : "protein_coding",
      gene_name : "SLC8B1",
      gene_level : 2,
      hgnc_id : "HGNC:26175",
      havana_gene : "OTTHUMG00000169566.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113358566,
      stop : 113391629,
      direction : "+",
      ID : "ENSG00000151176.8",
      gene_id : "ENSG00000151176.8",
      gene_type : "protein_coding",
      gene_name : "PLBD2",
      gene_level : 1,
      hgnc_id : "HGNC:27283",
      havana_gene : "OTTHUMG00000169567.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113392445,
      stop : 113426301,
      direction : "-",
      ID : "ENSG00000135094.11",
      gene_id : "ENSG00000135094.11",
      gene_type : "protein_coding",
      gene_name : "SDS",
      gene_level : 2,
      hgnc_id : "HGNC:10691",
      havana_gene : "OTTHUMG00000169554.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113422380,
      stop : 113438276,
      direction : "+",
      ID : "ENSG00000139410.15",
      gene_id : "ENSG00000139410.15",
      gene_type : "protein_coding",
      gene_name : "SDSL",
      gene_level : 2,
      hgnc_id : "HGNC:30404",
      havana_gene : "OTTHUMG00000169551.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113462033,
      stop : 113472280,
      direction : "-",
      ID : "ENSG00000089116.4",
      gene_id : "ENSG00000089116.4",
      gene_type : "protein_coding",
      gene_name : "LHX5",
      gene_level : 2,
      hgnc_id : "HGNC:14216",
      havana_gene : "OTTHUMG00000169552.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 113816738,
      stop : 113966325,
      direction : "-",
      ID : "ENSG00000122965.11",
      gene_id : "ENSG00000122965.11",
      gene_type : "protein_coding",
      gene_name : "RBM19",
      gene_level : 2,
      hgnc_id : "HGNC:29098",
      havana_gene : "OTTHUMG00000169646.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 114353911,
      stop : 114408442,
      direction : "-",
      ID : "ENSG00000089225.20",
      gene_id : "ENSG00000089225.20",
      gene_type : "protein_coding",
      gene_name : "TBX5",
      gene_level : 1,
      hgnc_id : "HGNC:11604",
      havana_gene : "OTTHUMG00000166191.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 114670255,
      stop : 114684175,
      direction : "-",
      ID : "ENSG00000135111.16",
      gene_id : "ENSG00000135111.16",
      gene_type : "protein_coding",
      gene_name : "TBX3",
      gene_level : 2,
      hgnc_id : "HGNC:11602",
      havana_gene : "OTTHUMG00000169586.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 115957905,
      stop : 116277693,
      direction : "-",
      ID : "ENSG00000123066.9",
      gene_id : "ENSG00000123066.9",
      gene_type : "protein_coding",
      gene_name : "MED13L",
      gene_level : 1,
      hgnc_id : "HGNC:22962",
      havana_gene : "OTTHUMG00000169404.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 116548105,
      stop : 116576606,
      direction : "+",
      ID : "ENSG00000258102.5",
      gene_id : "ENSG00000258102.5",
      gene_type : "protein_coding",
      gene_name : "MAP1LC3B2",
      gene_level : 2,
      hgnc_id : "HGNC:34390",
      havana_gene : "OTTHUMG00000171525.4",
      tag : "retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 116710171,
      stop : 116738070,
      direction : "-",
      ID : "ENSG00000111412.6",
      gene_id : "ENSG00000111412.6",
      gene_type : "protein_coding",
      gene_name : "SPRING1",
      gene_level : 2,
      hgnc_id : "HGNC:26128",
      havana_gene : "OTTHUMG00000169392.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 116738178,
      stop : 116853631,
      direction : "+",
      ID : "ENSG00000135119.15",
      gene_id : "ENSG00000135119.15",
      gene_type : "protein_coding",
      gene_name : "RNFT2",
      gene_level : 2,
      hgnc_id : "HGNC:25905",
      havana_gene : "OTTHUMG00000150882.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 116856144,
      stop : 116881441,
      direction : "-",
      ID : "ENSG00000135116.9",
      gene_id : "ENSG00000135116.9",
      gene_type : "protein_coding",
      gene_name : "HRK",
      gene_level : 2,
      hgnc_id : "HGNC:5185",
      havana_gene : "OTTHUMG00000169328.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 116910950,
      stop : 117031148,
      direction : "+",
      ID : "ENSG00000174989.13",
      gene_id : "ENSG00000174989.13",
      gene_type : "protein_coding",
      gene_name : "FBXW8",
      gene_level : 2,
      hgnc_id : "HGNC:13597",
      havana_gene : "OTTHUMG00000169329.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 117038923,
      stop : 117099479,
      direction : "-",
      ID : "ENSG00000088992.18",
      gene_id : "ENSG00000088992.18",
      gene_type : "protein_coding",
      gene_name : "TESC",
      gene_level : 1,
      hgnc_id : "HGNC:26065",
      havana_gene : "OTTHUMG00000144168.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 117141991,
      stop : 117190471,
      direction : "-",
      ID : "ENSG00000135108.15",
      gene_id : "ENSG00000135108.15",
      gene_type : "protein_coding",
      gene_name : "FBXO21",
      gene_level : 1,
      hgnc_id : "HGNC:13592",
      havana_gene : "OTTHUMG00000169495.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 117208142,
      stop : 117452170,
      direction : "-",
      ID : "ENSG00000089250.19",
      gene_id : "ENSG00000089250.19",
      gene_type : "protein_coding",
      gene_name : "NOS1",
      gene_level : 1,
      hgnc_id : "HGNC:7872",
      havana_gene : "OTTHUMG00000137376.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 117453012,
      stop : 117968990,
      direction : "-",
      ID : "ENSG00000171435.14",
      gene_id : "ENSG00000171435.14",
      gene_type : "protein_coding",
      gene_name : "KSR2",
      gene_level : 2,
      hgnc_id : "HGNC:18610",
      havana_gene : "OTTHUMG00000169020.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118013588,
      stop : 118033130,
      direction : "+",
      ID : "ENSG00000111445.14",
      gene_id : "ENSG00000111445.14",
      gene_type : "protein_coding",
      gene_name : "RFC5",
      gene_level : 2,
      hgnc_id : "HGNC:9973",
      havana_gene : "OTTHUMG00000156438.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118032687,
      stop : 118062430,
      direction : "-",
      ID : "ENSG00000176871.9",
      gene_id : "ENSG00000176871.9",
      gene_type : "protein_coding",
      gene_name : "WSB2",
      gene_level : 1,
      hgnc_id : "HGNC:19222",
      havana_gene : "OTTHUMG00000168885.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118063593,
      stop : 118136026,
      direction : "-",
      ID : "ENSG00000176834.14",
      gene_id : "ENSG00000176834.14",
      gene_type : "protein_coding",
      gene_name : "VSIG10",
      gene_level : 1,
      hgnc_id : "HGNC:26078",
      havana_gene : "OTTHUMG00000168835.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118136124,
      stop : 118145584,
      direction : "+",
      ID : "ENSG00000089220.5",
      gene_id : "ENSG00000089220.5",
      gene_type : "protein_coding",
      gene_name : "PEBP1",
      gene_level : 2,
      hgnc_id : "HGNC:8630",
      havana_gene : "OTTHUMG00000168860.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118149801,
      stop : 118372907,
      direction : "-",
      ID : "ENSG00000135090.14",
      gene_id : "ENSG00000135090.14",
      gene_type : "protein_coding",
      gene_name : "TAOK3",
      gene_level : 1,
      hgnc_id : "HGNC:18133",
      havana_gene : "OTTHUMG00000168875.11",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118376555,
      stop : 118418033,
      direction : "+",
      ID : "ENSG00000111707.12",
      gene_id : "ENSG00000111707.12",
      gene_type : "protein_coding",
      gene_name : "SUDS3",
      gene_level : 2,
      hgnc_id : "HGNC:29545",
      havana_gene : "OTTHUMG00000168884.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 118981541,
      stop : 119163051,
      direction : "+",
      ID : "ENSG00000139767.10",
      gene_id : "ENSG00000139767.10",
      gene_type : "protein_coding",
      gene_name : "SRRM4",
      gene_level : 2,
      hgnc_id : "HGNC:29389",
      havana_gene : "OTTHUMG00000168928.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 119171555,
      stop : 119224855,
      direction : "+",
      ID : "ENSG00000152137.8",
      gene_id : "ENSG00000152137.8",
      gene_type : "protein_coding",
      gene_name : "HSPB8",
      gene_level : 1,
      hgnc_id : "HGNC:30171",
      havana_gene : "OTTHUMG00000168932.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 119334712,
      stop : 119541040,
      direction : "+",
      ID : "ENSG00000183273.7",
      gene_id : "ENSG00000183273.7",
      gene_type : "protein_coding",
      gene_name : "CCDC60",
      gene_level : 2,
      hgnc_id : "HGNC:28610",
      havana_gene : "OTTHUMG00000168943.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 119593774,
      stop : 119643075,
      direction : "+",
      ID : "ENSG00000224982.4",
      gene_id : "ENSG00000224982.4",
      gene_type : "protein_coding",
      gene_name : "TMEM233",
      gene_level : 2,
      hgnc_id : "HGNC:37219",
      havana_gene : "OTTHUMG00000168944.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 119667864,
      stop : 119681624,
      direction : "+",
      ID : "ENSG00000111725.11",
      gene_id : "ENSG00000111725.11",
      gene_type : "protein_coding",
      gene_name : "PRKAB1",
      gene_level : 1,
      hgnc_id : "HGNC:9378",
      havana_gene : "OTTHUMG00000168954.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 119685791,
      stop : 119877320,
      direction : "-",
      ID : "ENSG00000122966.17",
      gene_id : "ENSG00000122966.17",
      gene_type : "protein_coding",
      gene_name : "CIT",
      gene_level : 1,
      hgnc_id : "HGNC:1985",
      havana_gene : "OTTHUMG00000134325.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 119989869,
      stop : 120094494,
      direction : "+",
      ID : "ENSG00000135127.11",
      gene_id : "ENSG00000135127.11",
      gene_type : "protein_coding",
      gene_name : "BICDL1",
      gene_level : 1,
      hgnc_id : "HGNC:28095",
      havana_gene : "OTTHUMG00000169311.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120095099,
      stop : 120117502,
      direction : "-",
      ID : "ENSG00000111737.12",
      gene_id : "ENSG00000111737.12",
      gene_type : "protein_coding",
      gene_name : "RAB35",
      gene_level : 2,
      hgnc_id : "HGNC:9774",
      havana_gene : "OTTHUMG00000169159.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120127202,
      stop : 120194715,
      direction : "-",
      ID : "ENSG00000089154.11",
      gene_id : "ENSG00000089154.11",
      gene_type : "protein_coding",
      gene_name : "GCN1",
      gene_level : 2,
      hgnc_id : "HGNC:4199",
      havana_gene : "OTTHUMG00000169338.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120196699,
      stop : 120201235,
      direction : "-",
      ID : "ENSG00000089157.16",
      gene_id : "ENSG00000089157.16",
      gene_type : "protein_coding",
      gene_name : "RPLP0",
      gene_level : 1,
      hgnc_id : "HGNC:10371",
      havana_gene : "OTTHUMG00000169317.10",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120210439,
      stop : 120265771,
      direction : "-",
      ID : "ENSG00000089159.17",
      gene_id : "ENSG00000089159.17",
      gene_type : "protein_coding",
      gene_name : "PXN",
      gene_level : 1,
      hgnc_id : "HGNC:9718",
      havana_gene : "OTTHUMG00000169169.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120302316,
      stop : 120313249,
      direction : "+",
      ID : "ENSG00000089163.4",
      gene_id : "ENSG00000089163.4",
      gene_type : "protein_coding",
      gene_name : "SIRT4",
      gene_level : 2,
      hgnc_id : "HGNC:14932",
      havana_gene : "OTTHUMG00000169028.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120322115,
      stop : 120327779,
      direction : "-",
      ID : "ENSG00000170890.14",
      gene_id : "ENSG00000170890.14",
      gene_type : "protein_coding",
      gene_name : "PLA2G1B",
      gene_level : 1,
      hgnc_id : "HGNC:9030",
      havana_gene : "OTTHUMG00000169343.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120341330,
      stop : 120369164,
      direction : "-",
      ID : "ENSG00000135097.7",
      gene_id : "ENSG00000135097.7",
      gene_type : "protein_coding",
      gene_name : "MSI1",
      gene_level : 2,
      hgnc_id : "HGNC:7330",
      havana_gene : "OTTHUMG00000169344.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120438090,
      stop : 120440737,
      direction : "+",
      ID : "ENSG00000111775.3",
      gene_id : "ENSG00000111775.3",
      gene_type : "protein_coding",
      gene_name : "COX6A1",
      gene_level : 2,
      hgnc_id : "HGNC:2277",
      havana_gene : "OTTHUMG00000047791.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120438198,
      stop : 120460006,
      direction : "+",
      ID : "ENSG00000111780.8",
      gene_id : "ENSG00000111780.8",
      gene_type : "protein_coding",
      gene_name : "AL021546.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000169346.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120443964,
      stop : 120446384,
      direction : "-",
      ID : "ENSG00000170855.4",
      gene_id : "ENSG00000170855.4",
      gene_type : "protein_coding",
      gene_name : "TRIAP1",
      gene_level : 1,
      hgnc_id : "HGNC:26937",
      havana_gene : "OTTHUMG00000047787.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120446444,
      stop : 120463749,
      direction : "+",
      ID : "ENSG00000257218.6",
      gene_id : "ENSG00000257218.6",
      gene_type : "protein_coding",
      gene_name : "GATC",
      gene_level : 2,
      hgnc_id : "HGNC:25068",
      havana_gene : "OTTHUMG00000047788.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120461672,
      stop : 120469748,
      direction : "-",
      ID : "ENSG00000111786.9",
      gene_id : "ENSG00000111786.9",
      gene_type : "protein_coding",
      gene_name : "SRSF9",
      gene_level : 2,
      hgnc_id : "HGNC:10791",
      havana_gene : "OTTHUMG00000047790.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120469850,
      stop : 120498493,
      direction : "+",
      ID : "ENSG00000088986.11",
      gene_id : "ENSG00000088986.11",
      gene_type : "protein_coding",
      gene_name : "DYNLL1",
      gene_level : 2,
      hgnc_id : "HGNC:15476",
      havana_gene : "OTTHUMG00000169368.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120503279,
      stop : 120534434,
      direction : "-",
      ID : "ENSG00000110871.15",
      gene_id : "ENSG00000110871.15",
      gene_type : "protein_coding",
      gene_name : "COQ5",
      gene_level : 1,
      hgnc_id : "HGNC:28722",
      havana_gene : "OTTHUMG00000169375.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120533480,
      stop : 120577588,
      direction : "+",
      ID : "ENSG00000022840.16",
      gene_id : "ENSG00000022840.16",
      gene_type : "protein_coding",
      gene_name : "RNF10",
      gene_level : 1,
      hgnc_id : "HGNC:10055",
      havana_gene : "OTTHUMG00000168999.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120534697,
      stop : 120534957,
      direction : "+",
      ID : "ENSG00000288623.1",
      gene_id : "ENSG00000288623.1",
      gene_type : "protein_coding",
      gene_name : "AC063943.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120578764,
      stop : 120581402,
      direction : "-",
      ID : "ENSG00000167272.11",
      gene_id : "ENSG00000167272.11",
      gene_type : "protein_coding",
      gene_name : "POP5",
      gene_level : 2,
      hgnc_id : "HGNC:17689",
      havana_gene : "OTTHUMG00000169023.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120640552,
      stop : 120667324,
      direction : "+",
      ID : "ENSG00000157782.9",
      gene_id : "ENSG00000157782.9",
      gene_type : "protein_coding",
      gene_name : "CABP1",
      gene_level : 2,
      hgnc_id : "HGNC:1384",
      havana_gene : "OTTHUMG00000156794.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120687149,
      stop : 120701859,
      direction : "+",
      ID : "ENSG00000110917.8",
      gene_id : "ENSG00000110917.8",
      gene_type : "protein_coding",
      gene_name : "MLEC",
      gene_level : 1,
      hgnc_id : "HGNC:28973",
      havana_gene : "OTTHUMG00000169187.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120710458,
      stop : 120723640,
      direction : "+",
      ID : "ENSG00000175970.11",
      gene_id : "ENSG00000175970.11",
      gene_type : "protein_coding",
      gene_name : "UNC119B",
      gene_level : 2,
      hgnc_id : "HGNC:16488",
      havana_gene : "OTTHUMG00000169201.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120725774,
      stop : 120740008,
      direction : "+",
      ID : "ENSG00000122971.9",
      gene_id : "ENSG00000122971.9",
      gene_type : "protein_coding",
      gene_name : "ACADS",
      gene_level : 2,
      hgnc_id : "HGNC:90",
      havana_gene : "OTTHUMG00000169203.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120762510,
      stop : 120904358,
      direction : "-",
      ID : "ENSG00000157837.16",
      gene_id : "ENSG00000157837.16",
      gene_type : "protein_coding",
      gene_name : "SPPL3",
      gene_level : 1,
      hgnc_id : "HGNC:30424",
      havana_gene : "OTTHUMG00000169232.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 120978543,
      stop : 121002512,
      direction : "+",
      ID : "ENSG00000135100.18",
      gene_id : "ENSG00000135100.18",
      gene_type : "protein_coding",
      gene_name : "HNF1A",
      gene_level : 2,
      hgnc_id : "HGNC:11621",
      havana_gene : "OTTHUMG00000151015.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121000486,
      stop : 121016502,
      direction : "-",
      ID : "ENSG00000157895.11",
      gene_id : "ENSG00000157895.11",
      gene_type : "protein_coding",
      gene_name : "C12orf43",
      gene_level : 2,
      hgnc_id : "HGNC:25719",
      havana_gene : "OTTHUMG00000169150.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121017763,
      stop : 121039242,
      direction : "-",
      ID : "ENSG00000135114.13",
      gene_id : "ENSG00000135114.13",
      gene_type : "protein_coding",
      gene_name : "OASL",
      gene_level : 1,
      hgnc_id : "HGNC:8090",
      havana_gene : "OTTHUMG00000154981.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121132819,
      stop : 121188032,
      direction : "+",
      ID : "ENSG00000089041.17",
      gene_id : "ENSG00000089041.17",
      gene_type : "protein_coding",
      gene_name : "P2RX7",
      gene_level : 2,
      hgnc_id : "HGNC:8537",
      havana_gene : "OTTHUMG00000169153.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121209861,
      stop : 121234106,
      direction : "+",
      ID : "ENSG00000135124.15",
      gene_id : "ENSG00000135124.15",
      gene_type : "protein_coding",
      gene_name : "P2RX4",
      gene_level : 1,
      hgnc_id : "HGNC:8535",
      havana_gene : "OTTHUMG00000169155.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121237675,
      stop : 121298308,
      direction : "-",
      ID : "ENSG00000110931.19",
      gene_id : "ENSG00000110931.19",
      gene_type : "protein_coding",
      gene_name : "CAMKK2",
      gene_level : 2,
      hgnc_id : "HGNC:1470",
      havana_gene : "OTTHUMG00000169156.8",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121308245,
      stop : 121399896,
      direction : "-",
      ID : "ENSG00000089053.13",
      gene_id : "ENSG00000089053.13",
      gene_type : "protein_coding",
      gene_name : "ANAPC5",
      gene_level : 1,
      hgnc_id : "HGNC:15713",
      havana_gene : "OTTHUMG00000169157.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121400041,
      stop : 121430623,
      direction : "+",
      ID : "ENSG00000170633.16",
      gene_id : "ENSG00000170633.16",
      gene_type : "protein_coding",
      gene_name : "RNF34",
      gene_level : 1,
      hgnc_id : "HGNC:17297",
      havana_gene : "OTTHUMG00000171524.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121429096,
      stop : 121581023,
      direction : "-",
      ID : "ENSG00000089094.19",
      gene_id : "ENSG00000089094.19",
      gene_type : "protein_coding",
      gene_name : "KDM2B",
      gene_level : 1,
      hgnc_id : "HGNC:13610",
      havana_gene : "OTTHUMG00000169071.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121626550,
      stop : 121642677,
      direction : "+",
      ID : "ENSG00000276045.3",
      gene_id : "ENSG00000276045.3",
      gene_type : "protein_coding",
      gene_name : "ORAI1",
      gene_level : 2,
      hgnc_id : "HGNC:25896",
      havana_gene : "OTTHUMG00000169073.3",
      tag : "reference_genome_error"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121648742,
      stop : 121672631,
      direction : "-",
      ID : "ENSG00000139714.12",
      gene_id : "ENSG00000139714.12",
      gene_type : "protein_coding",
      gene_name : "MORN3",
      gene_level : 2,
      hgnc_id : "HGNC:29807",
      havana_gene : "OTTHUMG00000169075.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121712752,
      stop : 121783001,
      direction : "+",
      ID : "ENSG00000188735.13",
      gene_id : "ENSG00000188735.13",
      gene_type : "protein_coding",
      gene_name : "TMEM120B",
      gene_level : 2,
      hgnc_id : "HGNC:32008",
      havana_gene : "OTTHUMG00000169076.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121777754,
      stop : 121803403,
      direction : "-",
      ID : "ENSG00000139725.8",
      gene_id : "ENSG00000139725.8",
      gene_type : "protein_coding",
      gene_name : "RHOF",
      gene_level : 2,
      hgnc_id : "HGNC:15703",
      havana_gene : "OTTHUMG00000169077.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121804009,
      stop : 121832656,
      direction : "+",
      ID : "ENSG00000139718.11",
      gene_id : "ENSG00000139718.11",
      gene_type : "protein_coding",
      gene_name : "SETD1B",
      gene_level : 2,
      hgnc_id : "HGNC:29187",
      havana_gene : "OTTHUMG00000169080.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121839527,
      stop : 121863596,
      direction : "-",
      ID : "ENSG00000158104.11",
      gene_id : "ENSG00000158104.11",
      gene_type : "protein_coding",
      gene_name : "HPD",
      gene_level : 2,
      hgnc_id : "HGNC:5147",
      havana_gene : "OTTHUMG00000169081.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121888732,
      stop : 121918297,
      direction : "+",
      ID : "ENSG00000110801.14",
      gene_id : "ENSG00000110801.14",
      gene_type : "protein_coding",
      gene_name : "PSMD9",
      gene_level : 1,
      hgnc_id : "HGNC:9567",
      havana_gene : "OTTHUMG00000168945.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121888809,
      stop : 121921470,
      direction : "+",
      ID : "ENSG00000256950.2",
      gene_id : "ENSG00000256950.2",
      gene_type : "protein_coding",
      gene_name : "AC069503.2",
      gene_level : 1,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000168946.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 121918592,
      stop : 122003927,
      direction : "+",
      ID : "ENSG00000158023.10",
      gene_id : "ENSG00000158023.10",
      gene_type : "protein_coding",
      gene_name : "CFAP251",
      gene_level : 1,
      hgnc_id : "HGNC:28506",
      havana_gene : "OTTHUMG00000168948.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122019422,
      stop : 122062044,
      direction : "+",
      ID : "ENSG00000110987.9",
      gene_id : "ENSG00000110987.9",
      gene_type : "protein_coding",
      gene_name : "BCL7A",
      gene_level : 1,
      hgnc_id : "HGNC:1004",
      havana_gene : "OTTHUMG00000168951.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122078756,
      stop : 122147344,
      direction : "+",
      ID : "ENSG00000175727.14",
      gene_id : "ENSG00000175727.14",
      gene_type : "protein_coding",
      gene_name : "MLXIP",
      gene_level : 1,
      hgnc_id : "HGNC:17055",
      havana_gene : "OTTHUMG00000168953.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122167738,
      stop : 122203471,
      direction : "+",
      ID : "ENSG00000158113.13",
      gene_id : "ENSG00000158113.13",
      gene_type : "protein_coding",
      gene_name : "LRRC43",
      gene_level : 2,
      hgnc_id : "HGNC:28562",
      havana_gene : "OTTHUMG00000168915.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122172029,
      stop : 122174221,
      direction : "-",
      ID : "ENSG00000204671.2",
      gene_id : "ENSG00000204671.2",
      gene_type : "protein_coding",
      gene_name : "IL31",
      gene_level : 2,
      hgnc_id : "HGNC:19372",
      havana_gene : "OTTHUMG00000168916.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122203681,
      stop : 122208952,
      direction : "+",
      ID : "ENSG00000176383.9",
      gene_id : "ENSG00000176383.9",
      gene_type : "protein_coding",
      gene_name : "B3GNT4",
      gene_level : 2,
      hgnc_id : "HGNC:15683",
      havana_gene : "OTTHUMG00000168917.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122207662,
      stop : 122227534,
      direction : "-",
      ID : "ENSG00000284934.2",
      gene_id : "ENSG00000284934.2",
      gene_type : "protein_coding",
      gene_name : "AC048338.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192412.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122207663,
      stop : 122227456,
      direction : "-",
      ID : "ENSG00000184047.20",
      gene_id : "ENSG00000184047.20",
      gene_type : "protein_coding",
      gene_name : "DIABLO",
      gene_level : 1,
      hgnc_id : "HGNC:21528",
      havana_gene : "",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122207779,
      stop : 122266423,
      direction : "-",
      ID : "ENSG00000256861.1",
      gene_id : "ENSG00000256861.1",
      gene_type : "protein_coding",
      gene_name : "AC048338.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192536.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122229564,
      stop : 122266494,
      direction : "-",
      ID : "ENSG00000139719.11",
      gene_id : "ENSG00000139719.11",
      gene_type : "protein_coding",
      gene_name : "VPS33A",
      gene_level : 1,
      hgnc_id : "HGNC:18179",
      havana_gene : "OTTHUMG00000168920.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122271432,
      stop : 122422669,
      direction : "-",
      ID : "ENSG00000130779.22",
      gene_id : "ENSG00000130779.22",
      gene_type : "protein_coding",
      gene_name : "CLIP1",
      gene_level : 1,
      hgnc_id : "HGNC:10461",
      havana_gene : "OTTHUMG00000168922.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122471599,
      stop : 122501073,
      direction : "-",
      ID : "ENSG00000033030.15",
      gene_id : "ENSG00000033030.15",
      gene_type : "protein_coding",
      gene_name : "ZCCHC8",
      gene_level : 2,
      hgnc_id : "HGNC:25265",
      havana_gene : "OTTHUMG00000168878.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122503454,
      stop : 122527000,
      direction : "-",
      ID : "ENSG00000111011.18",
      gene_id : "ENSG00000111011.18",
      gene_type : "protein_coding",
      gene_name : "RSRC2",
      gene_level : 1,
      hgnc_id : "HGNC:30559",
      havana_gene : "OTTHUMG00000167572.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122527246,
      stop : 122626396,
      direction : "+",
      ID : "ENSG00000184445.12",
      gene_id : "ENSG00000184445.12",
      gene_type : "protein_coding",
      gene_name : "KNTC1",
      gene_level : 1,
      hgnc_id : "HGNC:17255",
      havana_gene : "OTTHUMG00000168861.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122701293,
      stop : 122703357,
      direction : "-",
      ID : "ENSG00000182782.8",
      gene_id : "ENSG00000182782.8",
      gene_type : "protein_coding",
      gene_name : "HCAR2",
      gene_level : 2,
      hgnc_id : "HGNC:24827",
      havana_gene : "OTTHUMG00000162722.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122714756,
      stop : 122716811,
      direction : "-",
      ID : "ENSG00000255398.3",
      gene_id : "ENSG00000255398.3",
      gene_type : "protein_coding",
      gene_name : "HCAR3",
      gene_level : 2,
      hgnc_id : "HGNC:16824",
      havana_gene : "OTTHUMG00000166034.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122726076,
      stop : 122730844,
      direction : "-",
      ID : "ENSG00000196917.6",
      gene_id : "ENSG00000196917.6",
      gene_type : "protein_coding",
      gene_name : "HCAR1",
      gene_level : 2,
      hgnc_id : "HGNC:4532",
      havana_gene : "OTTHUMG00000168863.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122752824,
      stop : 122771064,
      direction : "+",
      ID : "ENSG00000139726.11",
      gene_id : "ENSG00000139726.11",
      gene_type : "protein_coding",
      gene_name : "DENR",
      gene_level : 2,
      hgnc_id : "HGNC:2769",
      havana_gene : "OTTHUMG00000168844.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122774526,
      stop : 122827528,
      direction : "+",
      ID : "ENSG00000130783.14",
      gene_id : "ENSG00000130783.14",
      gene_type : "protein_coding",
      gene_name : "CCDC62",
      gene_level : 2,
      hgnc_id : "HGNC:30723",
      havana_gene : "OTTHUMG00000168764.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122834453,
      stop : 122862961,
      direction : "+",
      ID : "ENSG00000130787.14",
      gene_id : "ENSG00000130787.14",
      gene_type : "protein_coding",
      gene_name : "HIP1R",
      gene_level : 2,
      hgnc_id : "HGNC:18415",
      havana_gene : "OTTHUMG00000168765.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122865330,
      stop : 122896127,
      direction : "-",
      ID : "ENSG00000139722.7",
      gene_id : "ENSG00000139722.7",
      gene_type : "protein_coding",
      gene_name : "VPS37B",
      gene_level : 2,
      hgnc_id : "HGNC:25754",
      havana_gene : "OTTHUMG00000168767.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122920951,
      stop : 122981649,
      direction : "-",
      ID : "ENSG00000150967.18",
      gene_id : "ENSG00000150967.18",
      gene_type : "protein_coding",
      gene_name : "ABCB9",
      gene_level : 1,
      hgnc_id : "HGNC:50",
      havana_gene : "OTTHUMG00000168769.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122974580,
      stop : 122980043,
      direction : "+",
      ID : "ENSG00000111325.16",
      gene_id : "ENSG00000111325.16",
      gene_type : "protein_coding",
      gene_name : "OGFOD2",
      gene_level : 1,
      hgnc_id : "HGNC:25823",
      havana_gene : "OTTHUMG00000168778.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122980060,
      stop : 122982913,
      direction : "+",
      ID : "ENSG00000182196.13",
      gene_id : "ENSG00000182196.13",
      gene_type : "protein_coding",
      gene_name : "ARL6IP4",
      gene_level : 2,
      hgnc_id : "HGNC:18076",
      havana_gene : "OTTHUMG00000168779.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 122983480,
      stop : 123150015,
      direction : "-",
      ID : "ENSG00000090975.13",
      gene_id : "ENSG00000090975.13",
      gene_type : "protein_coding",
      gene_name : "PITPNM2",
      gene_level : 2,
      hgnc_id : "HGNC:21044",
      havana_gene : "OTTHUMG00000168845.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123152320,
      stop : 123244014,
      direction : "-",
      ID : "ENSG00000051825.15",
      gene_id : "ENSG00000051825.15",
      gene_type : "protein_coding",
      gene_name : "MPHOSPH9",
      gene_level : 1,
      hgnc_id : "HGNC:7215",
      havana_gene : "OTTHUMG00000168849.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123233385,
      stop : 123258079,
      direction : "+",
      ID : "ENSG00000130921.9",
      gene_id : "ENSG00000130921.9",
      gene_type : "protein_coding",
      gene_name : "C12orf65",
      gene_level : 2,
      hgnc_id : "HGNC:26784",
      havana_gene : "OTTHUMG00000168852.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123250112,
      stop : 123272334,
      direction : "-",
      ID : "ENSG00000111328.7",
      gene_id : "ENSG00000111328.7",
      gene_type : "protein_coding",
      gene_name : "CDK2AP1",
      gene_level : 1,
      hgnc_id : "HGNC:14002",
      havana_gene : "OTTHUMG00000168854.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123289109,
      stop : 123364847,
      direction : "-",
      ID : "ENSG00000139697.14",
      gene_id : "ENSG00000139697.14",
      gene_type : "protein_coding",
      gene_name : "SBNO1",
      gene_level : 2,
      hgnc_id : "HGNC:22973",
      havana_gene : "OTTHUMG00000183988.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123383773,
      stop : 123409353,
      direction : "+",
      ID : "ENSG00000183955.13",
      gene_id : "ENSG00000183955.13",
      gene_type : "protein_coding",
      gene_name : "KMT5A",
      gene_level : 1,
      hgnc_id : "HGNC:29489",
      havana_gene : "OTTHUMG00000150477.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123415039,
      stop : 123436684,
      direction : "-",
      ID : "ENSG00000150977.11",
      gene_id : "ENSG00000150977.11",
      gene_type : "protein_coding",
      gene_name : "RILPL2",
      gene_level : 2,
      hgnc_id : "HGNC:28787",
      havana_gene : "OTTHUMG00000187294.1",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123458088,
      stop : 123473154,
      direction : "+",
      ID : "ENSG00000184209.15",
      gene_id : "ENSG00000184209.15",
      gene_type : "protein_coding",
      gene_name : "SNRNP35",
      gene_level : 1,
      hgnc_id : "HGNC:30852",
      havana_gene : "OTTHUMG00000167584.4",
      tag : "retrogene"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123470054,
      stop : 123533719,
      direction : "-",
      ID : "ENSG00000188026.13",
      gene_id : "ENSG00000188026.13",
      gene_type : "protein_coding",
      gene_name : "RILPL1",
      gene_level : 1,
      hgnc_id : "HGNC:26814",
      havana_gene : "OTTHUMG00000168686.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123584533,
      stop : 123598582,
      direction : "+",
      ID : "ENSG00000086598.11",
      gene_id : "ENSG00000086598.11",
      gene_type : "protein_coding",
      gene_name : "TMED2",
      gene_level : 2,
      hgnc_id : "HGNC:16996",
      havana_gene : "OTTHUMG00000168694.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123602077,
      stop : 123620943,
      direction : "+",
      ID : "ENSG00000111364.16",
      gene_id : "ENSG00000111364.16",
      gene_type : "protein_coding",
      gene_name : "DDX55",
      gene_level : 2,
      hgnc_id : "HGNC:20085",
      havana_gene : "OTTHUMG00000168695.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123620406,
      stop : 123633766,
      direction : "-",
      ID : "ENSG00000111361.13",
      gene_id : "ENSG00000111361.13",
      gene_type : "protein_coding",
      gene_name : "EIF2B1",
      gene_level : 1,
      hgnc_id : "HGNC:3257",
      havana_gene : "OTTHUMG00000168696.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123633739,
      stop : 123662604,
      direction : "+",
      ID : "ENSG00000111358.14",
      gene_id : "ENSG00000111358.14",
      gene_type : "protein_coding",
      gene_name : "GTF2H3",
      gene_level : 2,
      hgnc_id : "HGNC:4657",
      havana_gene : "OTTHUMG00000168697.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123671110,
      stop : 123708399,
      direction : "+",
      ID : "ENSG00000168778.13",
      gene_id : "ENSG00000168778.13",
      gene_type : "protein_coding",
      gene_name : "TCTN2",
      gene_level : 2,
      hgnc_id : "HGNC:25774",
      havana_gene : "OTTHUMG00000168700.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123712353,
      stop : 123761755,
      direction : "+",
      ID : "ENSG00000185344.15",
      gene_id : "ENSG00000185344.15",
      gene_type : "protein_coding",
      gene_name : "ATP6V0A2",
      gene_level : 2,
      hgnc_id : "HGNC:18481",
      havana_gene : "OTTHUMG00000168723.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123762188,
      stop : 123935720,
      direction : "+",
      ID : "ENSG00000197653.16",
      gene_id : "ENSG00000197653.16",
      gene_type : "protein_coding",
      gene_name : "DNAH10",
      gene_level : 1,
      hgnc_id : "HGNC:2941",
      havana_gene : "OTTHUMG00000154477.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123918660,
      stop : 123972831,
      direction : "-",
      ID : "ENSG00000119242.9",
      gene_id : "ENSG00000119242.9",
      gene_type : "protein_coding",
      gene_name : "CCDC92",
      gene_level : 1,
      hgnc_id : "HGNC:29563",
      havana_gene : "OTTHUMG00000168725.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123971845,
      stop : 124015439,
      direction : "+",
      ID : "ENSG00000179195.16",
      gene_id : "ENSG00000179195.16",
      gene_type : "protein_coding",
      gene_name : "ZNF664",
      gene_level : 2,
      hgnc_id : "HGNC:25406",
      havana_gene : "OTTHUMG00000168596.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 123973241,
      stop : 124316024,
      direction : "+",
      ID : "ENSG00000178882.15",
      gene_id : "ENSG00000178882.15",
      gene_type : "protein_coding",
      gene_name : "RFLNA",
      gene_level : 2,
      hgnc_id : "HGNC:27051",
      havana_gene : "OTTHUMG00000168609.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 124324415,
      stop : 124567589,
      direction : "-",
      ID : "ENSG00000196498.13",
      gene_id : "ENSG00000196498.13",
      gene_type : "protein_coding",
      gene_name : "NCOR2",
      gene_level : 1,
      hgnc_id : "HGNC:7673",
      havana_gene : "OTTHUMG00000150455.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 124776856,
      stop : 124882668,
      direction : "-",
      ID : "ENSG00000073060.17",
      gene_id : "ENSG00000073060.17",
      gene_type : "protein_coding",
      gene_name : "SCARB1",
      gene_level : 2,
      hgnc_id : "HGNC:1664",
      havana_gene : "OTTHUMG00000168544.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 124911604,
      stop : 124917368,
      direction : "-",
      ID : "ENSG00000150991.15",
      gene_id : "ENSG00000150991.15",
      gene_type : "protein_coding",
      gene_name : "UBC",
      gene_level : 1,
      hgnc_id : "HGNC:12468",
      havana_gene : "OTTHUMG00000044421.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 124946825,
      stop : 124989131,
      direction : "-",
      ID : "ENSG00000150990.9",
      gene_id : "ENSG00000150990.9",
      gene_type : "protein_coding",
      gene_name : "DHX37",
      gene_level : 2,
      hgnc_id : "HGNC:17210",
      havana_gene : "OTTHUMG00000168547.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 124993645,
      stop : 125031231,
      direction : "+",
      ID : "ENSG00000184992.13",
      gene_id : "ENSG00000184992.13",
      gene_type : "protein_coding",
      gene_name : "BRI3BP",
      gene_level : 2,
      hgnc_id : "HGNC:14251",
      havana_gene : "OTTHUMG00000168548.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 125065434,
      stop : 125143333,
      direction : "+",
      ID : "ENSG00000081760.17",
      gene_id : "ENSG00000081760.17",
      gene_type : "protein_coding",
      gene_name : "AACS",
      gene_level : 1,
      hgnc_id : "HGNC:21298",
      havana_gene : "OTTHUMG00000168550.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 125186836,
      stop : 125662377,
      direction : "+",
      ID : "ENSG00000139364.10",
      gene_id : "ENSG00000139364.10",
      gene_type : "protein_coding",
      gene_name : "TMEM132B",
      gene_level : 2,
      hgnc_id : "HGNC:29397",
      havana_gene : "OTTHUMG00000168520.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 128267403,
      stop : 128707915,
      direction : "+",
      ID : "ENSG00000181234.9",
      gene_id : "ENSG00000181234.9",
      gene_type : "protein_coding",
      gene_name : "TMEM132C",
      gene_level : 2,
      hgnc_id : "HGNC:25436",
      havana_gene : "OTTHUMG00000163736.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 128793194,
      stop : 128823958,
      direction : "-",
      ID : "ENSG00000139370.12",
      gene_id : "ENSG00000139370.12",
      gene_type : "protein_coding",
      gene_name : "SLC15A4",
      gene_level : 1,
      hgnc_id : "HGNC:23090",
      havana_gene : "OTTHUMG00000168415.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 128853427,
      stop : 128984968,
      direction : "+",
      ID : "ENSG00000151948.12",
      gene_id : "ENSG00000151948.12",
      gene_type : "protein_coding",
      gene_name : "GLT1D1",
      gene_level : 2,
      hgnc_id : "HGNC:26483",
      havana_gene : "OTTHUMG00000168437.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 129071725,
      stop : 129904025,
      direction : "-",
      ID : "ENSG00000151952.16",
      gene_id : "ENSG00000151952.16",
      gene_type : "protein_coding",
      gene_name : "TMEM132D",
      gene_level : 2,
      hgnc_id : "HGNC:29411",
      havana_gene : "OTTHUMG00000168400.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 130162459,
      stop : 130165740,
      direction : "+",
      ID : "ENSG00000111432.4",
      gene_id : "ENSG00000111432.4",
      gene_type : "protein_coding",
      gene_name : "FZD10",
      gene_level : 2,
      hgnc_id : "HGNC:4039",
      havana_gene : "OTTHUMG00000168380.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 130337887,
      stop : 130372637,
      direction : "+",
      ID : "ENSG00000125207.7",
      gene_id : "ENSG00000125207.7",
      gene_type : "protein_coding",
      gene_name : "PIWIL1",
      gene_level : 1,
      hgnc_id : "HGNC:9007",
      havana_gene : "OTTHUMG00000168382.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 130396137,
      stop : 130716281,
      direction : "-",
      ID : "ENSG00000060709.15",
      gene_id : "ENSG00000060709.15",
      gene_type : "protein_coding",
      gene_name : "RIMBP2",
      gene_level : 1,
      hgnc_id : "HGNC:30339",
      havana_gene : "OTTHUMG00000168385.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 130789600,
      stop : 130839266,
      direction : "-",
      ID : "ENSG00000111450.14",
      gene_id : "ENSG00000111450.14",
      gene_type : "protein_coding",
      gene_name : "STX2",
      gene_level : 2,
      hgnc_id : "HGNC:3403",
      havana_gene : "OTTHUMG00000168365.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 130872037,
      stop : 130877678,
      direction : "+",
      ID : "ENSG00000132341.12",
      gene_id : "ENSG00000132341.12",
      gene_type : "protein_coding",
      gene_name : "RAN",
      gene_level : 2,
      hgnc_id : "HGNC:9846",
      havana_gene : "OTTHUMG00000134328.9",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 130953907,
      stop : 131141469,
      direction : "+",
      ID : "ENSG00000111452.13",
      gene_id : "ENSG00000111452.13",
      gene_type : "protein_coding",
      gene_name : "ADGRD1",
      gene_level : 1,
      hgnc_id : "HGNC:19893",
      havana_gene : "OTTHUMG00000168339.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 131711081,
      stop : 131799738,
      direction : "+",
      ID : "ENSG00000061936.10",
      gene_id : "ENSG00000061936.10",
      gene_type : "protein_coding",
      gene_name : "SFSWAP",
      gene_level : 1,
      hgnc_id : "HGNC:10790",
      havana_gene : "OTTHUMG00000168319.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 131828393,
      stop : 131851783,
      direction : "+",
      ID : "ENSG00000198598.7",
      gene_id : "ENSG00000198598.7",
      gene_type : "protein_coding",
      gene_name : "MMP17",
      gene_level : 2,
      hgnc_id : "HGNC:7163",
      havana_gene : "OTTHUMG00000168050.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 131894622,
      stop : 131923150,
      direction : "+",
      ID : "ENSG00000177169.10",
      gene_id : "ENSG00000177169.10",
      gene_type : "protein_coding",
      gene_name : "ULK1",
      gene_level : 2,
      hgnc_id : "HGNC:12558",
      havana_gene : "OTTHUMG00000168052.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 131929200,
      stop : 131945896,
      direction : "+",
      ID : "ENSG00000177192.14",
      gene_id : "ENSG00000177192.14",
      gene_type : "protein_coding",
      gene_name : "PUS1",
      gene_level : 1,
      hgnc_id : "HGNC:15508",
      havana_gene : "OTTHUMG00000128507.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 131949942,
      stop : 132080460,
      direction : "+",
      ID : "ENSG00000183495.14",
      gene_id : "ENSG00000183495.14",
      gene_type : "protein_coding",
      gene_name : "EP400",
      gene_level : 2,
      hgnc_id : "HGNC:11958",
      havana_gene : "OTTHUMG00000187346.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132136594,
      stop : 132144319,
      direction : "-",
      ID : "ENSG00000185163.10",
      gene_id : "ENSG00000185163.10",
      gene_type : "protein_coding",
      gene_name : "DDX51",
      gene_level : 2,
      hgnc_id : "HGNC:20082",
      havana_gene : "OTTHUMG00000168254.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132144457,
      stop : 132152473,
      direction : "+",
      ID : "ENSG00000184967.7",
      gene_id : "ENSG00000184967.7",
      gene_type : "protein_coding",
      gene_name : "NOC4L",
      gene_level : 1,
      hgnc_id : "HGNC:28461",
      havana_gene : "OTTHUMG00000168260.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132196372,
      stop : 132329589,
      direction : "-",
      ID : "ENSG00000182870.13",
      gene_id : "ENSG00000182870.13",
      gene_type : "protein_coding",
      gene_name : "GALNT9",
      gene_level : 2,
      hgnc_id : "HGNC:4131",
      havana_gene : "OTTHUMG00000168256.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132489551,
      stop : 132585188,
      direction : "+",
      ID : "ENSG00000112787.14",
      gene_id : "ENSG00000112787.14",
      gene_type : "protein_coding",
      gene_name : "FBRSL1",
      gene_level : 2,
      hgnc_id : "HGNC:29308",
      havana_gene : "OTTHUMG00000167991.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132603150,
      stop : 132610582,
      direction : "-",
      ID : "ENSG00000204583.10",
      gene_id : "ENSG00000204583.10",
      gene_type : "protein_coding",
      gene_name : "LRCOL1",
      gene_level : 2,
      hgnc_id : "HGNC:44160",
      havana_gene : "OTTHUMG00000168043.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132618776,
      stop : 132622388,
      direction : "+",
      ID : "ENSG00000187848.15",
      gene_id : "ENSG00000187848.15",
      gene_type : "protein_coding",
      gene_name : "P2RX2",
      gene_level : 2,
      hgnc_id : "HGNC:15459",
      havana_gene : "OTTHUMG00000168018.5",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132623753,
      stop : 132687376,
      direction : "-",
      ID : "ENSG00000177084.18",
      gene_id : "ENSG00000177084.18",
      gene_type : "protein_coding",
      gene_name : "POLE",
      gene_level : 1,
      hgnc_id : "HGNC:9177",
      havana_gene : "OTTHUMG00000168045.7",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132687587,
      stop : 132704985,
      direction : "+",
      ID : "ENSG00000176894.10",
      gene_id : "ENSG00000176894.10",
      gene_type : "protein_coding",
      gene_name : "PXMP2",
      gene_level : 1,
      hgnc_id : "HGNC:9716",
      havana_gene : "OTTHUMG00000168019.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132710819,
      stop : 132722734,
      direction : "+",
      ID : "ENSG00000247077.7",
      gene_id : "ENSG00000247077.7",
      gene_type : "protein_coding",
      gene_name : "PGAM5",
      gene_level : 1,
      hgnc_id : "HGNC:28763",
      havana_gene : "OTTHUMG00000168021.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132725503,
      stop : 132761832,
      direction : "-",
      ID : "ENSG00000176915.15",
      gene_id : "ENSG00000176915.15",
      gene_type : "protein_coding",
      gene_name : "ANKLE2",
      gene_level : 1,
      hgnc_id : "HGNC:29101",
      havana_gene : "OTTHUMG00000168046.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132768914,
      stop : 132829078,
      direction : "-",
      ID : "ENSG00000090615.15",
      gene_id : "ENSG00000090615.15",
      gene_type : "protein_coding",
      gene_name : "GOLGA3",
      gene_level : 2,
      hgnc_id : "HGNC:4426",
      havana_gene : "OTTHUMG00000168023.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132822187,
      stop : 132956304,
      direction : "-",
      ID : "ENSG00000072609.18",
      gene_id : "ENSG00000072609.18",
      gene_type : "protein_coding",
      gene_name : "CHFR",
      gene_level : 1,
      hgnc_id : "HGNC:20455",
      havana_gene : "OTTHUMG00000167930.21",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132918306,
      stop : 132956306,
      direction : "-",
      ID : "ENSG00000196458.11",
      gene_id : "ENSG00000196458.11",
      gene_type : "protein_coding",
      gene_name : "ZNF605",
      gene_level : 2,
      hgnc_id : "HGNC:28068",
      havana_gene : "OTTHUMG00000167934.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 132986365,
      stop : 133032952,
      direction : "+",
      ID : "ENSG00000198393.8",
      gene_id : "ENSG00000198393.8",
      gene_type : "protein_coding",
      gene_name : "ZNF26",
      gene_level : 1,
      hgnc_id : "HGNC:13053",
      havana_gene : "OTTHUMG00000167936.13",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133037292,
      stop : 133063304,
      direction : "+",
      ID : "ENSG00000198040.11",
      gene_id : "ENSG00000198040.11",
      gene_type : "protein_coding",
      gene_name : "ZNF84",
      gene_level : 1,
      hgnc_id : "HGNC:13159",
      havana_gene : "OTTHUMG00000167939.6",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133080474,
      stop : 133107526,
      direction : "+",
      ID : "ENSG00000196387.10",
      gene_id : "ENSG00000196387.10",
      gene_type : "protein_coding",
      gene_name : "ZNF140",
      gene_level : 1,
      hgnc_id : "HGNC:12925",
      havana_gene : "OTTHUMG00000167942.3",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133104779,
      stop : 133130274,
      direction : "-",
      ID : "ENSG00000214029.6",
      gene_id : "ENSG00000214029.6",
      gene_type : "protein_coding",
      gene_name : "ZNF891",
      gene_level : 2,
      hgnc_id : "HGNC:38709",
      havana_gene : "OTTHUMG00000167943.4",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133130575,
      stop : 133159465,
      direction : "+",
      ID : "ENSG00000256223.6",
      gene_id : "ENSG00000256223.6",
      gene_type : "protein_coding",
      gene_name : "ZNF10",
      gene_level : 1,
      hgnc_id : "HGNC:12879",
      havana_gene : "OTTHUMG00000167944.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133130984,
      stop : 133202369,
      direction : "+",
      ID : "ENSG00000256825.4",
      gene_id : "ENSG00000256825.4",
      gene_type : "protein_coding",
      gene_name : "AC026786.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167945.2",
      tag : null
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133181409,
      stop : 133214832,
      direction : "+",
      ID : "ENSG00000090612.22",
      gene_id : "ENSG00000090612.22",
      gene_type : "protein_coding",
      gene_name : "ZNF268",
      gene_level : 2,
      hgnc_id : "HGNC:13061",
      havana_gene : "OTTHUMG00000167946.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 12,
      annotation : "HAVANA",
      type : "gene",
      start : 133218312,
      stop : 133235877,
      direction : "-",
      ID : "ENSG00000227059.7",
      gene_id : "ENSG00000227059.7",
      gene_type : "protein_coding",
      gene_name : "ANHX",
      gene_level : 1,
      hgnc_id : "HGNC:40024",
      havana_gene : "OTTHUMG00000167949.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 19173772,
      stop : 19181824,
      direction : "-",
      ID : "ENSG00000198033.12",
      gene_id : "ENSG00000198033.12",
      gene_type : "protein_coding",
      gene_name : "TUBA3C",
      gene_level : 2,
      hgnc_id : "HGNC:12408",
      havana_gene : "OTTHUMG00000016481.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 19422877,
      stop : 19536762,
      direction : "-",
      ID : "ENSG00000132958.17",
      gene_id : "ENSG00000132958.17",
      gene_type : "protein_coding",
      gene_name : "TPTE2",
      gene_level : 2,
      hgnc_id : "HGNC:17299",
      havana_gene : "OTTHUMG00000016493.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 19633659,
      stop : 19673441,
      direction : "+",
      ID : "ENSG00000196199.14",
      gene_id : "ENSG00000196199.14",
      gene_type : "protein_coding",
      gene_name : "MPHOSPH8",
      gene_level : 2,
      hgnc_id : "HGNC:29810",
      havana_gene : "OTTHUMG00000016498.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 19674752,
      stop : 19783019,
      direction : "-",
      ID : "ENSG00000121390.19",
      gene_id : "ENSG00000121390.19",
      gene_type : "protein_coding",
      gene_name : "PSPC1",
      gene_level : 2,
      hgnc_id : "HGNC:20320",
      havana_gene : "OTTHUMG00000016502.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 19823482,
      stop : 19863649,
      direction : "-",
      ID : "ENSG00000132950.19",
      gene_id : "ENSG00000132950.19",
      gene_type : "protein_coding",
      gene_name : "ZMYM5",
      gene_level : 2,
      hgnc_id : "HGNC:13029",
      havana_gene : "OTTHUMG00000016504.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 19958677,
      stop : 20091829,
      direction : "+",
      ID : "ENSG00000121741.17",
      gene_id : "ENSG00000121741.17",
      gene_type : "protein_coding",
      gene_name : "ZMYM2",
      gene_level : 1,
      hgnc_id : "HGNC:12989",
      havana_gene : "OTTHUMG00000016507.9",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20138255,
      stop : 20161052,
      direction : "-",
      ID : "ENSG00000121743.4",
      gene_id : "ENSG00000121743.4",
      gene_type : "protein_coding",
      gene_name : "GJA3",
      gene_level : 2,
      hgnc_id : "HGNC:4277",
      havana_gene : "OTTHUMG00000016510.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20187463,
      stop : 20192938,
      direction : "-",
      ID : "ENSG00000165474.8",
      gene_id : "ENSG00000165474.8",
      gene_type : "protein_coding",
      gene_name : "GJB2",
      gene_level : 2,
      hgnc_id : "HGNC:4284",
      havana_gene : "OTTHUMG00000016513.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20221962,
      stop : 20232365,
      direction : "-",
      ID : "ENSG00000121742.19",
      gene_id : "ENSG00000121742.19",
      gene_type : "protein_coding",
      gene_name : "GJB6",
      gene_level : 2,
      hgnc_id : "HGNC:4288",
      havana_gene : "OTTHUMG00000016515.12",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20403666,
      stop : 20525873,
      direction : "-",
      ID : "ENSG00000165475.15",
      gene_id : "ENSG00000165475.15",
      gene_type : "protein_coding",
      gene_name : "CRYL1",
      gene_level : 2,
      hgnc_id : "HGNC:18246",
      havana_gene : "OTTHUMG00000016516.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20567138,
      stop : 20691444,
      direction : "+",
      ID : "ENSG00000032742.18",
      gene_id : "ENSG00000032742.18",
      gene_type : "protein_coding",
      gene_name : "IFT88",
      gene_level : 2,
      hgnc_id : "HGNC:20606",
      havana_gene : "OTTHUMG00000016517.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20702127,
      stop : 20723098,
      direction : "+",
      ID : "ENSG00000172458.4",
      gene_id : "ENSG00000172458.4",
      gene_type : "protein_coding",
      gene_name : "IL17D",
      gene_level : 2,
      hgnc_id : "HGNC:5984",
      havana_gene : "OTTHUMG00000016521.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20728731,
      stop : 20773961,
      direction : "-",
      ID : "ENSG00000150456.11",
      gene_id : "ENSG00000150456.11",
      gene_type : "protein_coding",
      gene_name : "EEF1AKMT1",
      gene_level : 2,
      hgnc_id : "HGNC:27351",
      havana_gene : "OTTHUMG00000016519.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20777329,
      stop : 20903048,
      direction : "-",
      ID : "ENSG00000132953.17",
      gene_id : "ENSG00000132953.17",
      gene_type : "protein_coding",
      gene_name : "XPO4",
      gene_level : 2,
      hgnc_id : "HGNC:17796",
      havana_gene : "OTTHUMG00000016528.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 20973036,
      stop : 21061586,
      direction : "-",
      ID : "ENSG00000150457.9",
      gene_id : "ENSG00000150457.9",
      gene_type : "protein_coding",
      gene_name : "LATS2",
      gene_level : 2,
      hgnc_id : "HGNC:6515",
      havana_gene : "OTTHUMG00000016531.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 21140514,
      stop : 21149084,
      direction : "+",
      ID : "ENSG00000150459.12",
      gene_id : "ENSG00000150459.12",
      gene_type : "protein_coding",
      gene_name : "SAP18",
      gene_level : 1,
      hgnc_id : "HGNC:10530",
      havana_gene : "OTTHUMG00000016535.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 21153595,
      stop : 21176552,
      direction : "-",
      ID : "ENSG00000165480.16",
      gene_id : "ENSG00000165480.16",
      gene_type : "protein_coding",
      gene_name : "SKA3",
      gene_level : 1,
      hgnc_id : "HGNC:20262",
      havana_gene : "OTTHUMG00000016539.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 21176658,
      stop : 21179084,
      direction : "+",
      ID : "ENSG00000173141.5",
      gene_id : "ENSG00000173141.5",
      gene_type : "protein_coding",
      gene_name : "MRPL57",
      gene_level : 2,
      hgnc_id : "HGNC:14514",
      havana_gene : "OTTHUMG00000016532.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 21372571,
      stop : 21459370,
      direction : "-",
      ID : "ENSG00000180776.16",
      gene_id : "ENSG00000180776.16",
      gene_type : "protein_coding",
      gene_name : "ZDHHC20",
      gene_level : 2,
      hgnc_id : "HGNC:20749",
      havana_gene : "OTTHUMG00000017410.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 21492691,
      stop : 21604181,
      direction : "-",
      ID : "ENSG00000165487.14",
      gene_id : "ENSG00000165487.14",
      gene_type : "protein_coding",
      gene_name : "MICU2",
      gene_level : 2,
      hgnc_id : "HGNC:31830",
      havana_gene : "OTTHUMG00000067414.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 21671073,
      stop : 21704498,
      direction : "+",
      ID : "ENSG00000102678.7",
      gene_id : "ENSG00000102678.7",
      gene_type : "protein_coding",
      gene_name : "FGF9",
      gene_level : 2,
      hgnc_id : "HGNC:3687",
      havana_gene : "OTTHUMG00000017412.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23180979,
      stop : 23325162,
      direction : "+",
      ID : "ENSG00000102683.8",
      gene_id : "ENSG00000102683.8",
      gene_type : "protein_coding",
      gene_name : "SGCG",
      gene_level : 2,
      hgnc_id : "HGNC:10809",
      havana_gene : "OTTHUMG00000016563.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23328826,
      stop : 23433740,
      direction : "-",
      ID : "ENSG00000151835.16",
      gene_id : "ENSG00000151835.16",
      gene_type : "protein_coding",
      gene_name : "SACS",
      gene_level : 1,
      hgnc_id : "HGNC:10519",
      havana_gene : "OTTHUMG00000016562.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23570370,
      stop : 23676104,
      direction : "+",
      ID : "ENSG00000127863.16",
      gene_id : "ENSG00000127863.16",
      gene_type : "protein_coding",
      gene_name : "TNFRSF19",
      gene_level : 2,
      hgnc_id : "HGNC:11915",
      havana_gene : "OTTHUMG00000016568.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23730189,
      stop : 23889400,
      direction : "-",
      ID : "ENSG00000027001.10",
      gene_id : "ENSG00000027001.10",
      gene_type : "protein_coding",
      gene_name : "MIPEP",
      gene_level : 2,
      hgnc_id : "HGNC:7104",
      havana_gene : "OTTHUMG00000016573.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23891099,
      stop : 23897502,
      direction : "-",
      ID : "ENSG00000205863.11",
      gene_id : "ENSG00000205863.11",
      gene_type : "protein_coding",
      gene_name : "C1QTNF9B",
      gene_level : 2,
      hgnc_id : "HGNC:34072",
      havana_gene : "OTTHUMG00000016570.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23979700,
      stop : 24321031,
      direction : "+",
      ID : "ENSG00000273167.1",
      gene_id : "ENSG00000273167.1",
      gene_type : "protein_coding",
      gene_name : "AL359736.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000186016.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 23979805,
      stop : 24307074,
      direction : "+",
      ID : "ENSG00000182957.16",
      gene_id : "ENSG00000182957.16",
      gene_type : "protein_coding",
      gene_name : "SPATA13",
      gene_level : 1,
      hgnc_id : "HGNC:23222",
      havana_gene : "OTTHUMG00000016578.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 24307166,
      stop : 24322535,
      direction : "+",
      ID : "ENSG00000240654.6",
      gene_id : "ENSG00000240654.6",
      gene_type : "protein_coding",
      gene_name : "C1QTNF9",
      gene_level : 2,
      hgnc_id : "HGNC:28732",
      havana_gene : "OTTHUMG00000016576.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 24420931,
      stop : 24512778,
      direction : "-",
      ID : "ENSG00000102699.6",
      gene_id : "ENSG00000102699.6",
      gene_type : "protein_coding",
      gene_name : "PARP4",
      gene_level : 2,
      hgnc_id : "HGNC:271",
      havana_gene : "OTTHUMG00000016582.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 24680408,
      stop : 24712472,
      direction : "+",
      ID : "ENSG00000075673.12",
      gene_id : "ENSG00000075673.12",
      gene_type : "protein_coding",
      gene_name : "ATP12A",
      gene_level : 2,
      hgnc_id : "HGNC:13816",
      havana_gene : "OTTHUMG00000016588.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 24764169,
      stop : 24879921,
      direction : "+",
      ID : "ENSG00000132972.19",
      gene_id : "ENSG00000132972.19",
      gene_type : "protein_coding",
      gene_name : "RNF17",
      gene_level : 1,
      hgnc_id : "HGNC:10060",
      havana_gene : "OTTHUMG00000016589.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 24882279,
      stop : 24922889,
      direction : "-",
      ID : "ENSG00000151849.16",
      gene_id : "ENSG00000151849.16",
      gene_type : "protein_coding",
      gene_name : "CENPJ",
      gene_level : 2,
      hgnc_id : "HGNC:17272",
      havana_gene : "OTTHUMG00000016595.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 25096136,
      stop : 25099254,
      direction : "+",
      ID : "ENSG00000151846.9",
      gene_id : "ENSG00000151846.9",
      gene_type : "protein_coding",
      gene_name : "PABPC3",
      gene_level : 2,
      hgnc_id : "HGNC:8556",
      havana_gene : "OTTHUMG00000016601.5",
      tag : "retrogene"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 25161679,
      stop : 25172288,
      direction : "-",
      ID : "ENSG00000165566.13",
      gene_id : "ENSG00000165566.13",
      gene_type : "protein_coding",
      gene_name : "AMER2",
      gene_level : 2,
      hgnc_id : "HGNC:26360",
      havana_gene : "OTTHUMG00000016602.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 25246222,
      stop : 25287488,
      direction : "-",
      ID : "ENSG00000139505.12",
      gene_id : "ENSG00000139505.12",
      gene_type : "protein_coding",
      gene_name : "MTMR6",
      gene_level : 2,
      hgnc_id : "HGNC:7453",
      havana_gene : "OTTHUMG00000016606.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 25301556,
      stop : 25349800,
      direction : "+",
      ID : "ENSG00000139496.16",
      gene_id : "ENSG00000139496.16",
      gene_type : "protein_coding",
      gene_name : "NUP58",
      gene_level : 2,
      hgnc_id : "HGNC:20261",
      havana_gene : "OTTHUMG00000016608.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 25371974,
      stop : 26025851,
      direction : "+",
      ID : "ENSG00000132932.18",
      gene_id : "ENSG00000132932.18",
      gene_type : "protein_coding",
      gene_name : "ATP8A2",
      gene_level : 2,
      hgnc_id : "HGNC:13533",
      havana_gene : "OTTHUMG00000016611.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 26044597,
      stop : 26052016,
      direction : "-",
      ID : "ENSG00000180730.5",
      gene_id : "ENSG00000180730.5",
      gene_type : "protein_coding",
      gene_name : "SHISA2",
      gene_level : 2,
      hgnc_id : "HGNC:20366",
      havana_gene : "OTTHUMG00000016612.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 26132115,
      stop : 26222314,
      direction : "-",
      ID : "ENSG00000127870.17",
      gene_id : "ENSG00000127870.17",
      gene_type : "protein_coding",
      gene_name : "RNF6",
      gene_level : 2,
      hgnc_id : "HGNC:10069",
      havana_gene : "OTTHUMG00000016614.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 26254104,
      stop : 26405238,
      direction : "+",
      ID : "ENSG00000132964.12",
      gene_id : "ENSG00000132964.12",
      gene_type : "protein_coding",
      gene_name : "CDK8",
      gene_level : 2,
      hgnc_id : "HGNC:1779",
      havana_gene : "OTTHUMG00000016617.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 26557683,
      stop : 26688948,
      direction : "+",
      ID : "ENSG00000132970.14",
      gene_id : "ENSG00000132970.14",
      gene_type : "protein_coding",
      gene_name : "WASF3",
      gene_level : 2,
      hgnc_id : "HGNC:12734",
      havana_gene : "OTTHUMG00000016621.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 26755200,
      stop : 26760786,
      direction : "-",
      ID : "ENSG00000132975.8",
      gene_id : "ENSG00000132975.8",
      gene_type : "protein_coding",
      gene_name : "GPR12",
      gene_level : 2,
      hgnc_id : "HGNC:4466",
      havana_gene : "OTTHUMG00000016620.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27066156,
      stop : 27171811,
      direction : "-",
      ID : "ENSG00000152484.14",
      gene_id : "ENSG00000152484.14",
      gene_type : "protein_coding",
      gene_name : "USP12",
      gene_level : 2,
      hgnc_id : "HGNC:20485",
      havana_gene : "OTTHUMG00000016626.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27251309,
      stop : 27256691,
      direction : "+",
      ID : "ENSG00000122026.10",
      gene_id : "ENSG00000122026.10",
      gene_type : "protein_coding",
      gene_name : "RPL21",
      gene_level : 2,
      hgnc_id : "HGNC:10313",
      havana_gene : "OTTHUMG00000016630.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27270830,
      stop : 27275192,
      direction : "+",
      ID : "ENSG00000122035.7",
      gene_id : "ENSG00000122035.7",
      gene_type : "protein_coding",
      gene_name : "RASL11A",
      gene_level : 2,
      hgnc_id : "HGNC:23802",
      havana_gene : "OTTHUMG00000016627.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27424619,
      stop : 27435823,
      direction : "+",
      ID : "ENSG00000122034.17",
      gene_id : "ENSG00000122034.17",
      gene_type : "protein_coding",
      gene_name : "GTF3A",
      gene_level : 2,
      hgnc_id : "HGNC:4662",
      havana_gene : "OTTHUMG00000016632.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27435643,
      stop : 27450591,
      direction : "-",
      ID : "ENSG00000122033.15",
      gene_id : "ENSG00000122033.15",
      gene_type : "protein_coding",
      gene_name : "MTIF3",
      gene_level : 2,
      hgnc_id : "HGNC:29788",
      havana_gene : "OTTHUMG00000016633.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27545913,
      stop : 27620529,
      direction : "-",
      ID : "ENSG00000139517.9",
      gene_id : "ENSG00000139517.9",
      gene_type : "protein_coding",
      gene_name : "LNX2",
      gene_level : 2,
      hgnc_id : "HGNC:20421",
      havana_gene : "OTTHUMG00000016634.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27620742,
      stop : 27744237,
      direction : "+",
      ID : "ENSG00000186184.19",
      gene_id : "ENSG00000186184.19",
      gene_type : "protein_coding",
      gene_name : "POLR1D",
      gene_level : 2,
      hgnc_id : "HGNC:20422",
      havana_gene : "OTTHUMG00000016635.10",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27792483,
      stop : 27794768,
      direction : "+",
      ID : "ENSG00000169840.5",
      gene_id : "ENSG00000169840.5",
      gene_type : "protein_coding",
      gene_name : "GSX1",
      gene_level : 2,
      hgnc_id : "HGNC:20374",
      havana_gene : "OTTHUMG00000016637.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27920000,
      stop : 27926313,
      direction : "+",
      ID : "ENSG00000139515.6",
      gene_id : "ENSG00000139515.6",
      gene_type : "protein_coding",
      gene_name : "PDX1",
      gene_level : 2,
      hgnc_id : "HGNC:6107",
      havana_gene : "OTTHUMG00000016638.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27960918,
      stop : 27969315,
      direction : "-",
      ID : "ENSG00000165556.10",
      gene_id : "ENSG00000165556.10",
      gene_type : "protein_coding",
      gene_name : "CDX2",
      gene_level : 2,
      hgnc_id : "HGNC:1806",
      havana_gene : "OTTHUMG00000016640.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 27977717,
      stop : 27988693,
      direction : "-",
      ID : "ENSG00000183463.6",
      gene_id : "ENSG00000183463.6",
      gene_type : "protein_coding",
      gene_name : "URAD",
      gene_level : 2,
      hgnc_id : "HGNC:17785",
      havana_gene : "OTTHUMG00000186217.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 28003274,
      stop : 28100592,
      direction : "-",
      ID : "ENSG00000122025.15",
      gene_id : "ENSG00000122025.15",
      gene_type : "protein_coding",
      gene_name : "FLT3",
      gene_level : 2,
      hgnc_id : "HGNC:3765",
      havana_gene : "OTTHUMG00000016646.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 28138506,
      stop : 28295335,
      direction : "+",
      ID : "ENSG00000152520.14",
      gene_id : "ENSG00000152520.14",
      gene_type : "protein_coding",
      gene_name : "PAN3",
      gene_level : 1,
      hgnc_id : "HGNC:29991",
      havana_gene : "OTTHUMG00000016645.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 28300346,
      stop : 28495145,
      direction : "-",
      ID : "ENSG00000102755.12",
      gene_id : "ENSG00000102755.12",
      gene_type : "protein_coding",
      gene_name : "FLT1",
      gene_level : 2,
      hgnc_id : "HGNC:3763",
      havana_gene : "OTTHUMG00000016648.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 28659104,
      stop : 28678959,
      direction : "+",
      ID : "ENSG00000132963.8",
      gene_id : "ENSG00000132963.8",
      gene_type : "protein_coding",
      gene_name : "POMP",
      gene_level : 2,
      hgnc_id : "HGNC:20330",
      havana_gene : "OTTHUMG00000016652.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 28700064,
      stop : 28718970,
      direction : "-",
      ID : "ENSG00000139508.15",
      gene_id : "ENSG00000139508.15",
      gene_type : "protein_coding",
      gene_name : "SLC46A3",
      gene_level : 1,
      hgnc_id : "HGNC:27501",
      havana_gene : "OTTHUMG00000016650.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 28820339,
      stop : 29505947,
      direction : "+",
      ID : "ENSG00000132938.22",
      gene_id : "ENSG00000132938.22",
      gene_type : "protein_coding",
      gene_name : "MTUS2",
      gene_level : 2,
      hgnc_id : "HGNC:20595",
      havana_gene : "OTTHUMG00000016657.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 29509414,
      stop : 29595688,
      direction : "-",
      ID : "ENSG00000139514.13",
      gene_id : "ENSG00000139514.13",
      gene_type : "protein_coding",
      gene_name : "SLC7A1",
      gene_level : 2,
      hgnc_id : "HGNC:11057",
      havana_gene : "OTTHUMG00000016658.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 29764371,
      stop : 29850617,
      direction : "-",
      ID : "ENSG00000122042.10",
      gene_id : "ENSG00000122042.10",
      gene_type : "protein_coding",
      gene_name : "UBL3",
      gene_level : 2,
      hgnc_id : "HGNC:12504",
      havana_gene : "OTTHUMG00000016661.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30202630,
      stop : 30307551,
      direction : "-",
      ID : "ENSG00000102781.14",
      gene_id : "ENSG00000102781.14",
      gene_type : "protein_coding",
      gene_name : "KATNAL1",
      gene_level : 2,
      hgnc_id : "HGNC:28361",
      havana_gene : "OTTHUMG00000016665.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30422488,
      stop : 30429758,
      direction : "+",
      ID : "ENSG00000236444.5",
      gene_id : "ENSG00000236444.5",
      gene_type : "protein_coding",
      gene_name : "UBE2L5",
      gene_level : 2,
      hgnc_id : "HGNC:13477",
      havana_gene : "OTTHUMG00000016669.4",
      tag : "retrogene"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30456704,
      stop : 30617597,
      direction : "-",
      ID : "ENSG00000189403.15",
      gene_id : "ENSG00000189403.15",
      gene_type : "protein_coding",
      gene_name : "HMGB1",
      gene_level : 2,
      hgnc_id : "HGNC:4983",
      havana_gene : "OTTHUMG00000016670.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30617693,
      stop : 30660770,
      direction : "+",
      ID : "ENSG00000132952.12",
      gene_id : "ENSG00000132952.12",
      gene_type : "protein_coding",
      gene_name : "USPL1",
      gene_level : 2,
      hgnc_id : "HGNC:20294",
      havana_gene : "OTTHUMG00000016675.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30713478,
      stop : 30764426,
      direction : "+",
      ID : "ENSG00000132965.10",
      gene_id : "ENSG00000132965.10",
      gene_type : "protein_coding",
      gene_name : "ALOX5AP",
      gene_level : 2,
      hgnc_id : "HGNC:436",
      havana_gene : "OTTHUMG00000016677.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30906271,
      stop : 30925572,
      direction : "+",
      ID : "ENSG00000102802.10",
      gene_id : "ENSG00000102802.10",
      gene_type : "protein_coding",
      gene_name : "MEDAG",
      gene_level : 1,
      hgnc_id : "HGNC:25926",
      havana_gene : "OTTHUMG00000016679.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 30932656,
      stop : 30975500,
      direction : "+",
      ID : "ENSG00000175664.10",
      gene_id : "ENSG00000175664.10",
      gene_type : "protein_coding",
      gene_name : "TEX26",
      gene_level : 1,
      hgnc_id : "HGNC:28622",
      havana_gene : "OTTHUMG00000016682.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 31134973,
      stop : 31162388,
      direction : "-",
      ID : "ENSG00000120694.20",
      gene_id : "ENSG00000120694.20",
      gene_type : "protein_coding",
      gene_name : "HSPH1",
      gene_level : 1,
      hgnc_id : "HGNC:16969",
      havana_gene : "OTTHUMG00000016685.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 31199975,
      stop : 31332276,
      direction : "+",
      ID : "ENSG00000187676.8",
      gene_id : "ENSG00000187676.8",
      gene_type : "protein_coding",
      gene_name : "B3GLCT",
      gene_level : 2,
      hgnc_id : "HGNC:20207",
      havana_gene : "OTTHUMG00000016688.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 31739526,
      stop : 31803389,
      direction : "+",
      ID : "ENSG00000133105.8",
      gene_id : "ENSG00000133105.8",
      gene_type : "protein_coding",
      gene_name : "RXFP2",
      gene_level : 2,
      hgnc_id : "HGNC:17318",
      havana_gene : "OTTHUMG00000016690.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 31846713,
      stop : 32299125,
      direction : "+",
      ID : "ENSG00000073910.23",
      gene_id : "ENSG00000073910.23",
      gene_type : "protein_coding",
      gene_name : "FRY",
      gene_level : 2,
      hgnc_id : "HGNC:20367",
      havana_gene : "OTTHUMG00000016696.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 32303699,
      stop : 32315363,
      direction : "-",
      ID : "ENSG00000189167.12",
      gene_id : "ENSG00000189167.12",
      gene_type : "protein_coding",
      gene_name : "ZAR1L",
      gene_level : 2,
      hgnc_id : "HGNC:37116",
      havana_gene : "OTTHUMG00000016694.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 32315086,
      stop : 32400268,
      direction : "+",
      ID : "ENSG00000139618.17",
      gene_id : "ENSG00000139618.17",
      gene_type : "protein_coding",
      gene_name : "BRCA2",
      gene_level : 2,
      hgnc_id : "HGNC:1101",
      havana_gene : "OTTHUMG00000017411.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 32400723,
      stop : 32428311,
      direction : "-",
      ID : "ENSG00000139597.18",
      gene_id : "ENSG00000139597.18",
      gene_type : "protein_coding",
      gene_name : "N4BP2L1",
      gene_level : 1,
      hgnc_id : "HGNC:25037",
      havana_gene : "OTTHUMG00000016697.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 32432417,
      stop : 32538885,
      direction : "-",
      ID : "ENSG00000244754.9",
      gene_id : "ENSG00000244754.9",
      gene_type : "protein_coding",
      gene_name : "N4BP2L2",
      gene_level : 2,
      hgnc_id : "HGNC:26916",
      havana_gene : "OTTHUMG00000016700.22",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 32586452,
      stop : 32778019,
      direction : "+",
      ID : "ENSG00000083642.19",
      gene_id : "ENSG00000083642.19",
      gene_type : "protein_coding",
      gene_name : "PDS5B",
      gene_level : 2,
      hgnc_id : "HGNC:20418",
      havana_gene : "OTTHUMG00000016704.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 33016423,
      stop : 33066143,
      direction : "+",
      ID : "ENSG00000133116.8",
      gene_id : "ENSG00000133116.8",
      gene_type : "protein_coding",
      gene_name : "KL",
      gene_level : 2,
      hgnc_id : "HGNC:6344",
      havana_gene : "OTTHUMG00000017408.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 33103137,
      stop : 33350630,
      direction : "-",
      ID : "ENSG00000133121.21",
      gene_id : "ENSG00000133121.21",
      gene_type : "protein_coding",
      gene_name : "STARD13",
      gene_level : 2,
      hgnc_id : "HGNC:19164",
      havana_gene : "OTTHUMG00000016708.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 33818069,
      stop : 33966558,
      direction : "+",
      ID : "ENSG00000133119.13",
      gene_id : "ENSG00000133119.13",
      gene_type : "protein_coding",
      gene_name : "RFC3",
      gene_level : 2,
      hgnc_id : "HGNC:9971",
      havana_gene : "OTTHUMG00000016715.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 34942270,
      stop : 35673022,
      direction : "+",
      ID : "ENSG00000172915.19",
      gene_id : "ENSG00000172915.19",
      gene_type : "protein_coding",
      gene_name : "NBEA",
      gene_level : 2,
      hgnc_id : "HGNC:7648",
      havana_gene : "OTTHUMG00000016724.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 35473789,
      stop : 35476689,
      direction : "-",
      ID : "ENSG00000180660.8",
      gene_id : "ENSG00000180660.8",
      gene_type : "protein_coding",
      gene_name : "MAB21L1",
      gene_level : 2,
      hgnc_id : "HGNC:6757",
      havana_gene : "OTTHUMG00000016723.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 35768652,
      stop : 36131382,
      direction : "-",
      ID : "ENSG00000133083.15",
      gene_id : "ENSG00000133083.15",
      gene_type : "protein_coding",
      gene_name : "DCLK1",
      gene_level : 2,
      hgnc_id : "HGNC:2700",
      havana_gene : "OTTHUMG00000016729.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36168217,
      stop : 36214588,
      direction : "-",
      ID : "ENSG00000120669.16",
      gene_id : "ENSG00000120669.16",
      gene_type : "protein_coding",
      gene_name : "SOHLH2",
      gene_level : 1,
      hgnc_id : "HGNC:26026",
      havana_gene : "OTTHUMG00000016728.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36168794,
      stop : 36297842,
      direction : "-",
      ID : "ENSG00000250709.1",
      gene_id : "ENSG00000250709.1",
      gene_type : "protein_coding",
      gene_name : "CCDC169-SOHLH2",
      gene_level : 2,
      hgnc_id : "HGNC:38866",
      havana_gene : "OTTHUMG00000162258.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36222008,
      stop : 36297840,
      direction : "-",
      ID : "ENSG00000242715.8",
      gene_id : "ENSG00000242715.8",
      gene_type : "protein_coding",
      gene_name : "CCDC169",
      gene_level : 2,
      hgnc_id : "HGNC:34361",
      havana_gene : "OTTHUMG00000016731.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36301638,
      stop : 36370180,
      direction : "-",
      ID : "ENSG00000133104.14",
      gene_id : "ENSG00000133104.14",
      gene_type : "protein_coding",
      gene_name : "SPART",
      gene_level : 2,
      hgnc_id : "HGNC:18514",
      havana_gene : "OTTHUMG00000016730.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36431520,
      stop : 36442870,
      direction : "+",
      ID : "ENSG00000133101.10",
      gene_id : "ENSG00000133101.10",
      gene_type : "protein_coding",
      gene_name : "CCNA1",
      gene_level : 2,
      hgnc_id : "HGNC:1577",
      havana_gene : "OTTHUMG00000016733.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36674020,
      stop : 36697839,
      direction : "+",
      ID : "ENSG00000180440.4",
      gene_id : "ENSG00000180440.4",
      gene_type : "protein_coding",
      gene_name : "SERTM1",
      gene_level : 2,
      hgnc_id : "HGNC:33792",
      havana_gene : "OTTHUMG00000016735.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36819222,
      stop : 36829104,
      direction : "+",
      ID : "ENSG00000133111.4",
      gene_id : "ENSG00000133111.4",
      gene_type : "protein_coding",
      gene_name : "RFXAP",
      gene_level : 2,
      hgnc_id : "HGNC:9988",
      havana_gene : "OTTHUMG00000016738.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36844831,
      stop : 36920765,
      direction : "-",
      ID : "ENSG00000120693.14",
      gene_id : "ENSG00000120693.14",
      gene_type : "protein_coding",
      gene_name : "SMAD9",
      gene_level : 2,
      hgnc_id : "HGNC:6774",
      havana_gene : "OTTHUMG00000016740.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36949738,
      stop : 37000763,
      direction : "-",
      ID : "ENSG00000120697.10",
      gene_id : "ENSG00000120697.10",
      gene_type : "protein_coding",
      gene_name : "ALG5",
      gene_level : 2,
      hgnc_id : "HGNC:20266",
      havana_gene : "OTTHUMG00000016741.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 36998816,
      stop : 37009614,
      direction : "+",
      ID : "ENSG00000120699.13",
      gene_id : "ENSG00000120699.13",
      gene_type : "protein_coding",
      gene_name : "EXOSC8",
      gene_level : 2,
      hgnc_id : "HGNC:17035",
      havana_gene : "OTTHUMG00000016742.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 37009312,
      stop : 37059713,
      direction : "-",
      ID : "ENSG00000102710.20",
      gene_id : "ENSG00000102710.20",
      gene_type : "protein_coding",
      gene_name : "SUPT20H",
      gene_level : 2,
      hgnc_id : "HGNC:20596",
      havana_gene : "OTTHUMG00000016747.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 37103259,
      stop : 37105664,
      direction : "-",
      ID : "ENSG00000180138.7",
      gene_id : "ENSG00000180138.7",
      gene_type : "protein_coding",
      gene_name : "CSNK1A1L",
      gene_level : 2,
      hgnc_id : "HGNC:20289",
      havana_gene : "OTTHUMG00000016748.1",
      tag : "retrogene"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 37562583,
      stop : 37598844,
      direction : "-",
      ID : "ENSG00000133110.15",
      gene_id : "ENSG00000133110.15",
      gene_type : "protein_coding",
      gene_name : "POSTN",
      gene_level : 2,
      hgnc_id : "HGNC:16953",
      havana_gene : "OTTHUMG00000016751.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 37632063,
      stop : 37869802,
      direction : "-",
      ID : "ENSG00000133107.15",
      gene_id : "ENSG00000133107.15",
      gene_type : "protein_coding",
      gene_name : "TRPC4",
      gene_level : 2,
      hgnc_id : "HGNC:12336",
      havana_gene : "OTTHUMG00000016752.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 38349849,
      stop : 38363619,
      direction : "+",
      ID : "ENSG00000120686.12",
      gene_id : "ENSG00000120686.12",
      gene_type : "protein_coding",
      gene_name : "UFM1",
      gene_level : 2,
      hgnc_id : "HGNC:20597",
      havana_gene : "OTTHUMG00000017409.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 38687077,
      stop : 38887131,
      direction : "+",
      ID : "ENSG00000150893.11",
      gene_id : "ENSG00000150893.11",
      gene_type : "protein_coding",
      gene_name : "FREM2",
      gene_level : 2,
      hgnc_id : "HGNC:25396",
      havana_gene : "OTTHUMG00000016759.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 38965925,
      stop : 38990859,
      direction : "-",
      ID : "ENSG00000133115.12",
      gene_id : "ENSG00000133115.12",
      gene_type : "protein_coding",
      gene_name : "STOML3",
      gene_level : 2,
      hgnc_id : "HGNC:19420",
      havana_gene : "OTTHUMG00000016763.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 39009865,
      stop : 39038089,
      direction : "-",
      ID : "ENSG00000120685.20",
      gene_id : "ENSG00000120685.20",
      gene_type : "protein_coding",
      gene_name : "PROSER1",
      gene_level : 2,
      hgnc_id : "HGNC:20291",
      havana_gene : "OTTHUMG00000016764.9",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 39038306,
      stop : 39050109,
      direction : "+",
      ID : "ENSG00000188811.14",
      gene_id : "ENSG00000188811.14",
      gene_type : "protein_coding",
      gene_name : "NHLRC3",
      gene_level : 1,
      hgnc_id : "HGNC:33751",
      havana_gene : "OTTHUMG00000016765.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 39209116,
      stop : 39603528,
      direction : "-",
      ID : "ENSG00000183722.9",
      gene_id : "ENSG00000183722.9",
      gene_type : "protein_coding",
      gene_name : "LHFPL6",
      gene_level : 2,
      hgnc_id : "HGNC:6586",
      havana_gene : "OTTHUMG00000016767.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 39655627,
      stop : 39791665,
      direction : "+",
      ID : "ENSG00000133103.17",
      gene_id : "ENSG00000133103.17",
      gene_type : "protein_coding",
      gene_name : "COG6",
      gene_level : 2,
      hgnc_id : "HGNC:18621",
      havana_gene : "OTTHUMG00000016768.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 40555667,
      stop : 40666641,
      direction : "-",
      ID : "ENSG00000150907.10",
      gene_id : "ENSG00000150907.10",
      gene_type : "protein_coding",
      gene_name : "FOXO1",
      gene_level : 2,
      hgnc_id : "HGNC:3819",
      havana_gene : "OTTHUMG00000016775.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 40729128,
      stop : 40771190,
      direction : "-",
      ID : "ENSG00000102738.8",
      gene_id : "ENSG00000102738.8",
      gene_type : "protein_coding",
      gene_name : "MRPS31",
      gene_level : 2,
      hgnc_id : "HGNC:16632",
      havana_gene : "OTTHUMG00000016777.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 40789412,
      stop : 40812460,
      direction : "+",
      ID : "ENSG00000102743.15",
      gene_id : "ENSG00000102743.15",
      gene_type : "protein_coding",
      gene_name : "SLC25A15",
      gene_level : 2,
      hgnc_id : "HGNC:10985",
      havana_gene : "OTTHUMG00000016776.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 40931924,
      stop : 41061440,
      direction : "-",
      ID : "ENSG00000120690.16",
      gene_id : "ENSG00000120690.16",
      gene_type : "protein_coding",
      gene_name : "ELF1",
      gene_level : 2,
      hgnc_id : "HGNC:3316",
      havana_gene : "OTTHUMG00000016783.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41061509,
      stop : 41084006,
      direction : "+",
      ID : "ENSG00000120688.9",
      gene_id : "ENSG00000120688.9",
      gene_type : "protein_coding",
      gene_name : "WBP4",
      gene_level : 2,
      hgnc_id : "HGNC:12739",
      havana_gene : "OTTHUMG00000016784.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41127569,
      stop : 41132802,
      direction : "-",
      ID : "ENSG00000165572.8",
      gene_id : "ENSG00000165572.8",
      gene_type : "protein_coding",
      gene_name : "KBTBD6",
      gene_level : 2,
      hgnc_id : "HGNC:25340",
      havana_gene : "OTTHUMG00000016786.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41189834,
      stop : 41194569,
      direction : "-",
      ID : "ENSG00000120696.9",
      gene_id : "ENSG00000120696.9",
      gene_type : "protein_coding",
      gene_name : "KBTBD7",
      gene_level : 2,
      hgnc_id : "HGNC:25266",
      havana_gene : "OTTHUMG00000016789.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41216369,
      stop : 41263577,
      direction : "-",
      ID : "ENSG00000120662.16",
      gene_id : "ENSG00000120662.16",
      gene_type : "protein_coding",
      gene_name : "MTRF1",
      gene_level : 2,
      hgnc_id : "HGNC:7469",
      havana_gene : "OTTHUMG00000016790.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41311267,
      stop : 41377030,
      direction : "+",
      ID : "ENSG00000172766.19",
      gene_id : "ENSG00000172766.19",
      gene_type : "protein_coding",
      gene_name : "NAA16",
      gene_level : 2,
      hgnc_id : "HGNC:26164",
      havana_gene : "OTTHUMG00000016791.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41457550,
      stop : 41470871,
      direction : "+",
      ID : "ENSG00000102760.13",
      gene_id : "ENSG00000102760.13",
      gene_type : "protein_coding",
      gene_name : "RGCC",
      gene_level : 2,
      hgnc_id : "HGNC:20369",
      havana_gene : "OTTHUMG00000016796.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 41566835,
      stop : 41961120,
      direction : "-",
      ID : "ENSG00000102763.18",
      gene_id : "ENSG00000102763.18",
      gene_type : "protein_coding",
      gene_name : "VWA8",
      gene_level : 2,
      hgnc_id : "HGNC:29071",
      havana_gene : "OTTHUMG00000016799.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 42040036,
      stop : 42256578,
      direction : "+",
      ID : "ENSG00000102780.17",
      gene_id : "ENSG00000102780.17",
      gene_type : "protein_coding",
      gene_name : "DGKH",
      gene_level : 2,
      hgnc_id : "HGNC:2854",
      havana_gene : "OTTHUMG00000016804.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 42272152,
      stop : 42323261,
      direction : "+",
      ID : "ENSG00000023516.9",
      gene_id : "ENSG00000023516.9",
      gene_type : "protein_coding",
      gene_name : "AKAP11",
      gene_level : 2,
      hgnc_id : "HGNC:369",
      havana_gene : "OTTHUMG00000016805.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 42562736,
      stop : 42608013,
      direction : "+",
      ID : "ENSG00000120659.15",
      gene_id : "ENSG00000120659.15",
      gene_type : "protein_coding",
      gene_name : "TNFSF11",
      gene_level : 2,
      hgnc_id : "HGNC:11926",
      havana_gene : "OTTHUMG00000016807.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 42781550,
      stop : 42791549,
      direction : "+",
      ID : "ENSG00000179813.7",
      gene_id : "ENSG00000179813.7",
      gene_type : "protein_coding",
      gene_name : "FAM216B",
      gene_level : 2,
      hgnc_id : "HGNC:26883",
      havana_gene : "OTTHUMG00000016809.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 42886388,
      stop : 42992271,
      direction : "-",
      ID : "ENSG00000133106.15",
      gene_id : "ENSG00000133106.15",
      gene_type : "protein_coding",
      gene_name : "EPSTI1",
      gene_level : 2,
      hgnc_id : "HGNC:16465",
      havana_gene : "OTTHUMG00000016814.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 43023203,
      stop : 43114213,
      direction : "+",
      ID : "ENSG00000120675.6",
      gene_id : "ENSG00000120675.6",
      gene_type : "protein_coding",
      gene_name : "DNAJC15",
      gene_level : 2,
      hgnc_id : "HGNC:20325",
      havana_gene : "OTTHUMG00000016813.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 43213518,
      stop : 43786908,
      direction : "-",
      ID : "ENSG00000120658.13",
      gene_id : "ENSG00000120658.13",
      gene_type : "protein_coding",
      gene_name : "ENOX1",
      gene_level : 2,
      hgnc_id : "HGNC:25474",
      havana_gene : "OTTHUMG00000016818.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 43823909,
      stop : 43879740,
      direction : "-",
      ID : "ENSG00000151773.13",
      gene_id : "ENSG00000151773.13",
      gene_type : "protein_coding",
      gene_name : "CCDC122",
      gene_level : 2,
      hgnc_id : "HGNC:26478",
      havana_gene : "OTTHUMG00000017413.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 43879284,
      stop : 43893932,
      direction : "+",
      ID : "ENSG00000179630.11",
      gene_id : "ENSG00000179630.11",
      gene_type : "protein_coding",
      gene_name : "LACC1",
      gene_level : 2,
      hgnc_id : "HGNC:26789",
      havana_gene : "OTTHUMG00000016826.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 43883800,
      stop : 44028526,
      direction : "+",
      ID : "ENSG00000281883.1",
      gene_id : "ENSG00000281883.1",
      gene_type : "protein_coding",
      gene_name : "AL512506.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189707.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 44143150,
      stop : 44161257,
      direction : "-",
      ID : "ENSG00000139656.7",
      gene_id : "ENSG00000139656.7",
      gene_type : "protein_coding",
      gene_name : "SMIM2",
      gene_level : 2,
      hgnc_id : "HGNC:28776",
      havana_gene : "OTTHUMG00000016831.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 44373665,
      stop : 44397714,
      direction : "+",
      ID : "ENSG00000151778.11",
      gene_id : "ENSG00000151778.11",
      gene_type : "protein_coding",
      gene_name : "SERP2",
      gene_level : 2,
      hgnc_id : "HGNC:20607",
      havana_gene : "OTTHUMG00000016833.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 44432143,
      stop : 44577147,
      direction : "-",
      ID : "ENSG00000102804.15",
      gene_id : "ENSG00000102804.15",
      gene_type : "protein_coding",
      gene_name : "TSC22D1",
      gene_level : 2,
      hgnc_id : "HGNC:16826",
      havana_gene : "OTTHUMG00000016838.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 44939249,
      stop : 44989471,
      direction : "-",
      ID : "ENSG00000083635.8",
      gene_id : "ENSG00000083635.8",
      gene_type : "protein_coding",
      gene_name : "NUFIP1",
      gene_level : 2,
      hgnc_id : "HGNC:8057",
      havana_gene : "OTTHUMG00000016842.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 44989529,
      stop : 45037669,
      direction : "+",
      ID : "ENSG00000133114.18",
      gene_id : "ENSG00000133114.18",
      gene_type : "protein_coding",
      gene_name : "GPALPP1",
      gene_level : 1,
      hgnc_id : "HGNC:20298",
      havana_gene : "OTTHUMG00000016841.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45120510,
      stop : 45284893,
      direction : "+",
      ID : "ENSG00000188342.12",
      gene_id : "ENSG00000188342.12",
      gene_type : "protein_coding",
      gene_name : "GTF2F2",
      gene_level : 2,
      hgnc_id : "HGNC:4653",
      havana_gene : "OTTHUMG00000016849.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45192853,
      stop : 45194717,
      direction : "-",
      ID : "ENSG00000180332.6",
      gene_id : "ENSG00000180332.6",
      gene_type : "protein_coding",
      gene_name : "KCTD4",
      gene_level : 2,
      hgnc_id : "HGNC:23227",
      havana_gene : "OTTHUMG00000016844.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45333471,
      stop : 45341284,
      direction : "-",
      ID : "ENSG00000133112.17",
      gene_id : "ENSG00000133112.17",
      gene_type : "protein_coding",
      gene_name : "TPT1",
      gene_level : 1,
      hgnc_id : "HGNC:12022",
      havana_gene : "OTTHUMG00000016845.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45393316,
      stop : 45418455,
      direction : "-",
      ID : "ENSG00000174032.17",
      gene_id : "ENSG00000174032.17",
      gene_type : "protein_coding",
      gene_name : "SLC25A30",
      gene_level : 1,
      hgnc_id : "HGNC:27371",
      havana_gene : "OTTHUMG00000016853.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45464898,
      stop : 45536701,
      direction : "+",
      ID : "ENSG00000136152.15",
      gene_id : "ENSG00000136152.15",
      gene_type : "protein_coding",
      gene_name : "COG3",
      gene_level : 2,
      hgnc_id : "HGNC:18619",
      havana_gene : "OTTHUMG00000016855.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45534522,
      stop : 45615739,
      direction : "-",
      ID : "ENSG00000165837.12",
      gene_id : "ENSG00000165837.12",
      gene_type : "protein_coding",
      gene_name : "ERICH6B",
      gene_level : 2,
      hgnc_id : "HGNC:26523",
      havana_gene : "OTTHUMG00000016856.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45702320,
      stop : 45714559,
      direction : "+",
      ID : "ENSG00000174015.10",
      gene_id : "ENSG00000174015.10",
      gene_type : "protein_coding",
      gene_name : "CBY2",
      gene_level : 1,
      hgnc_id : "HGNC:30720",
      havana_gene : "OTTHUMG00000016861.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45777242,
      stop : 45851753,
      direction : "-",
      ID : "ENSG00000215475.5",
      gene_id : "ENSG00000215475.5",
      gene_type : "protein_coding",
      gene_name : "SIAH3",
      gene_level : 2,
      hgnc_id : "HGNC:30553",
      havana_gene : "OTTHUMG00000016862.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 45954465,
      stop : 46052759,
      direction : "-",
      ID : "ENSG00000123200.17",
      gene_id : "ENSG00000123200.17",
      gene_type : "protein_coding",
      gene_name : "ZC3H13",
      gene_level : 2,
      hgnc_id : "HGNC:20368",
      havana_gene : "OTTHUMG00000016863.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46053186,
      stop : 46105033,
      direction : "-",
      ID : "ENSG00000080618.17",
      gene_id : "ENSG00000080618.17",
      gene_type : "protein_coding",
      gene_name : "CPB2",
      gene_level : 2,
      hgnc_id : "HGNC:2300",
      havana_gene : "OTTHUMG00000016867.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46125920,
      stop : 46211871,
      direction : "-",
      ID : "ENSG00000136167.15",
      gene_id : "ENSG00000136167.15",
      gene_type : "protein_coding",
      gene_name : "LCP1",
      gene_level : 2,
      hgnc_id : "HGNC:6528",
      havana_gene : "OTTHUMG00000016864.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46211940,
      stop : 46277366,
      direction : "+",
      ID : "ENSG00000173988.13",
      gene_id : "ENSG00000173988.13",
      gene_type : "protein_coding",
      gene_name : "LRRC63",
      gene_level : 1,
      hgnc_id : "HGNC:34296",
      havana_gene : "OTTHUMG00000016866.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46334681,
      stop : 46438190,
      direction : "-",
      ID : "ENSG00000102445.20",
      gene_id : "ENSG00000102445.20",
      gene_type : "protein_coding",
      gene_name : "RUBCNL",
      gene_level : 1,
      hgnc_id : "HGNC:20420",
      havana_gene : "OTTHUMG00000016868.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46553168,
      stop : 46753040,
      direction : "+",
      ID : "ENSG00000136141.15",
      gene_id : "ENSG00000136141.15",
      gene_type : "protein_coding",
      gene_name : "LRCH1",
      gene_level : 1,
      hgnc_id : "HGNC:20309",
      havana_gene : "OTTHUMG00000016877.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46771256,
      stop : 46797420,
      direction : "-",
      ID : "ENSG00000139684.15",
      gene_id : "ENSG00000139684.15",
      gene_type : "protein_coding",
      gene_name : "ESD",
      gene_level : 1,
      hgnc_id : "HGNC:3465",
      havana_gene : "OTTHUMG00000016878.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 46831546,
      stop : 46897076,
      direction : "-",
      ID : "ENSG00000102468.11",
      gene_id : "ENSG00000102468.11",
      gene_type : "protein_coding",
      gene_name : "HTR2A",
      gene_level : 2,
      hgnc_id : "HGNC:5293",
      havana_gene : "OTTHUMG00000016881.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 47745736,
      stop : 48037968,
      direction : "-",
      ID : "ENSG00000136143.16",
      gene_id : "ENSG00000136143.16",
      gene_type : "protein_coding",
      gene_name : "SUCLA2",
      gene_level : 2,
      hgnc_id : "HGNC:11448",
      havana_gene : "OTTHUMG00000016889.14",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48037726,
      stop : 48047221,
      direction : "+",
      ID : "ENSG00000136159.4",
      gene_id : "ENSG00000136159.4",
      gene_type : "protein_coding",
      gene_name : "NUDT15",
      gene_level : 2,
      hgnc_id : "HGNC:23063",
      havana_gene : "OTTHUMG00000016890.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48053323,
      stop : 48095131,
      direction : "-",
      ID : "ENSG00000136146.15",
      gene_id : "ENSG00000136146.15",
      gene_type : "protein_coding",
      gene_name : "MED4",
      gene_level : 1,
      hgnc_id : "HGNC:17903",
      havana_gene : "OTTHUMG00000016891.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48232612,
      stop : 48270357,
      direction : "+",
      ID : "ENSG00000136156.15",
      gene_id : "ENSG00000136156.15",
      gene_type : "protein_coding",
      gene_name : "ITM2B",
      gene_level : 1,
      hgnc_id : "HGNC:6174",
      havana_gene : "OTTHUMG00000016894.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48303744,
      stop : 48599436,
      direction : "+",
      ID : "ENSG00000139687.16",
      gene_id : "ENSG00000139687.16",
      gene_type : "protein_coding",
      gene_name : "RB1",
      gene_level : 1,
      hgnc_id : "HGNC:9884",
      havana_gene : "OTTHUMG00000016900.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48389567,
      stop : 48444704,
      direction : "-",
      ID : "ENSG00000139679.16",
      gene_id : "ENSG00000139679.16",
      gene_type : "protein_coding",
      gene_name : "LPAR6",
      gene_level : 1,
      hgnc_id : "HGNC:15520",
      havana_gene : "OTTHUMG00000016895.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48488963,
      stop : 48533256,
      direction : "-",
      ID : "ENSG00000136161.13",
      gene_id : "ENSG00000136161.13",
      gene_type : "protein_coding",
      gene_name : "RCBTB2",
      gene_level : 2,
      hgnc_id : "HGNC:1914",
      havana_gene : "OTTHUMG00000016902.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48653711,
      stop : 48711226,
      direction : "+",
      ID : "ENSG00000152207.7",
      gene_id : "ENSG00000152207.7",
      gene_type : "protein_coding",
      gene_name : "CYSLTR2",
      gene_level : 2,
      hgnc_id : "HGNC:18274",
      havana_gene : "OTTHUMG00000016906.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 48975912,
      stop : 49209779,
      direction : "+",
      ID : "ENSG00000102531.16",
      gene_id : "ENSG00000102531.16",
      gene_type : "protein_coding",
      gene_name : "FNDC3A",
      gene_level : 2,
      hgnc_id : "HGNC:20296",
      havana_gene : "OTTHUMG00000016911.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49220338,
      stop : 49222377,
      direction : "+",
      ID : "ENSG00000102539.5",
      gene_id : "ENSG00000102539.5",
      gene_type : "protein_coding",
      gene_name : "MLNR",
      gene_level : 2,
      hgnc_id : "HGNC:4495",
      havana_gene : "OTTHUMG00000016909.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49247925,
      stop : 49293485,
      direction : "+",
      ID : "ENSG00000102543.14",
      gene_id : "ENSG00000102543.14",
      gene_type : "protein_coding",
      gene_name : "CDADC1",
      gene_level : 2,
      hgnc_id : "HGNC:20299",
      havana_gene : "OTTHUMG00000016913.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49308650,
      stop : 49444064,
      direction : "-",
      ID : "ENSG00000102547.19",
      gene_id : "ENSG00000102547.19",
      gene_type : "protein_coding",
      gene_name : "CAB39L",
      gene_level : 2,
      hgnc_id : "HGNC:20290",
      havana_gene : "OTTHUMG00000016914.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49444374,
      stop : 49495003,
      direction : "+",
      ID : "ENSG00000136169.16",
      gene_id : "ENSG00000136169.16",
      gene_type : "protein_coding",
      gene_name : "SETDB2",
      gene_level : 2,
      hgnc_id : "HGNC:20263",
      havana_gene : "OTTHUMG00000016918.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49495610,
      stop : 49528981,
      direction : "+",
      ID : "ENSG00000136147.18",
      gene_id : "ENSG00000136147.18",
      gene_type : "protein_coding",
      gene_name : "PHF11",
      gene_level : 1,
      hgnc_id : "HGNC:17024",
      havana_gene : "OTTHUMG00000016916.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49531946,
      stop : 49585558,
      direction : "-",
      ID : "ENSG00000136144.12",
      gene_id : "ENSG00000136144.12",
      gene_type : "protein_coding",
      gene_name : "RCBTB1",
      gene_level : 2,
      hgnc_id : "HGNC:18243",
      havana_gene : "OTTHUMG00000016915.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49628507,
      stop : 49633872,
      direction : "+",
      ID : "ENSG00000152213.4",
      gene_id : "ENSG00000152213.4",
      gene_type : "protein_coding",
      gene_name : "ARL11",
      gene_level : 2,
      hgnc_id : "HGNC:24046",
      havana_gene : "OTTHUMG00000016919.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49660674,
      stop : 49691486,
      direction : "-",
      ID : "ENSG00000123179.14",
      gene_id : "ENSG00000123179.14",
      gene_type : "protein_coding",
      gene_name : "EBPL",
      gene_level : 2,
      hgnc_id : "HGNC:18061",
      havana_gene : "OTTHUMG00000016920.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49699320,
      stop : 49792682,
      direction : "-",
      ID : "ENSG00000102753.10",
      gene_id : "ENSG00000102753.10",
      gene_type : "protein_coding",
      gene_name : "KPNA3",
      gene_level : 2,
      hgnc_id : "HGNC:6396",
      havana_gene : "OTTHUMG00000016922.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49912702,
      stop : 49936490,
      direction : "-",
      ID : "ENSG00000123178.15",
      gene_id : "ENSG00000123178.15",
      gene_type : "protein_coding",
      gene_name : "SPRYD7",
      gene_level : 2,
      hgnc_id : "HGNC:14297",
      havana_gene : "OTTHUMG00000016924.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 49995888,
      stop : 50020481,
      direction : "+",
      ID : "ENSG00000204977.10",
      gene_id : "ENSG00000204977.10",
      gene_type : "protein_coding",
      gene_name : "TRIM13",
      gene_level : 2,
      hgnc_id : "HGNC:9976",
      havana_gene : "OTTHUMG00000016926.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 50015254,
      stop : 50020922,
      direction : "+",
      ID : "ENSG00000198553.9",
      gene_id : "ENSG00000198553.9",
      gene_type : "protein_coding",
      gene_name : "KCNRG",
      gene_level : 2,
      hgnc_id : "HGNC:18893",
      havana_gene : "OTTHUMG00000140140.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 50519364,
      stop : 50843939,
      direction : "-",
      ID : "ENSG00000186047.11",
      gene_id : "ENSG00000186047.11",
      gene_type : "protein_coding",
      gene_name : "DLEU7",
      gene_level : 2,
      hgnc_id : "HGNC:17567",
      havana_gene : "OTTHUMG00000016936.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 50909747,
      stop : 51024120,
      direction : "+",
      ID : "ENSG00000136104.21",
      gene_id : "ENSG00000136104.21",
      gene_type : "protein_coding",
      gene_name : "RNASEH2B",
      gene_level : 2,
      hgnc_id : "HGNC:25671",
      havana_gene : "OTTHUMG00000016937.16",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51082119,
      stop : 51200252,
      direction : "-",
      ID : "ENSG00000226792.7",
      gene_id : "ENSG00000226792.7",
      gene_type : "protein_coding",
      gene_name : "C13orf42",
      gene_level : 1,
      hgnc_id : "HGNC:42693",
      havana_gene : "OTTHUMG00000153575.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51222334,
      stop : 51284239,
      direction : "+",
      ID : "ENSG00000150510.17",
      gene_id : "ENSG00000150510.17",
      gene_type : "protein_coding",
      gene_name : "FAM124A",
      gene_level : 2,
      hgnc_id : "HGNC:26413",
      havana_gene : "OTTHUMG00000016942.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51335773,
      stop : 51364735,
      direction : "+",
      ID : "ENSG00000253309.7",
      gene_id : "ENSG00000253309.7",
      gene_type : "protein_coding",
      gene_name : "SERPINE3",
      gene_level : 2,
      hgnc_id : "HGNC:24774",
      havana_gene : "OTTHUMG00000016943.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51354077,
      stop : 51454264,
      direction : "-",
      ID : "ENSG00000102786.15",
      gene_id : "ENSG00000102786.15",
      gene_type : "protein_coding",
      gene_name : "INTS6",
      gene_level : 1,
      hgnc_id : "HGNC:14879",
      havana_gene : "OTTHUMG00000016945.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51584455,
      stop : 51767709,
      direction : "+",
      ID : "ENSG00000139668.9",
      gene_id : "ENSG00000139668.9",
      gene_type : "protein_coding",
      gene_name : "WDFY2",
      gene_level : 2,
      hgnc_id : "HGNC:20482",
      havana_gene : "OTTHUMG00000017407.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51763951,
      stop : 51845159,
      direction : "-",
      ID : "ENSG00000285444.1",
      gene_id : "ENSG00000285444.1",
      gene_type : "protein_coding",
      gene_name : "AL162377.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192524.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51767993,
      stop : 51804162,
      direction : "-",
      ID : "ENSG00000102796.11",
      gene_id : "ENSG00000102796.11",
      gene_type : "protein_coding",
      gene_name : "DHRS12",
      gene_level : 2,
      hgnc_id : "HGNC:25832",
      havana_gene : "OTTHUMG00000016952.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51813347,
      stop : 51845177,
      direction : "-",
      ID : "ENSG00000281106.4",
      gene_id : "ENSG00000281106.4",
      gene_type : "protein_coding",
      gene_name : "TMEM272",
      gene_level : 2,
      hgnc_id : "HGNC:26737",
      havana_gene : "OTTHUMG00000189519.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51861969,
      stop : 51866232,
      direction : "+",
      ID : "ENSG00000123171.8",
      gene_id : "ENSG00000123171.8",
      gene_type : "protein_coding",
      gene_name : "CCDC70",
      gene_level : 2,
      hgnc_id : "HGNC:25303",
      havana_gene : "OTTHUMG00000016950.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 51930436,
      stop : 52012125,
      direction : "-",
      ID : "ENSG00000123191.16",
      gene_id : "ENSG00000123191.16",
      gene_type : "protein_coding",
      gene_name : "ATP7B",
      gene_level : 2,
      hgnc_id : "HGNC:870",
      havana_gene : "OTTHUMG00000017406.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52012391,
      stop : 52079232,
      direction : "+",
      ID : "ENSG00000253710.5",
      gene_id : "ENSG00000253710.5",
      gene_type : "protein_coding",
      gene_name : "ALG11",
      gene_level : 2,
      hgnc_id : "HGNC:32456",
      havana_gene : "OTTHUMG00000016959.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52024691,
      stop : 52033600,
      direction : "+",
      ID : "ENSG00000253797.2",
      gene_id : "ENSG00000253797.2",
      gene_type : "protein_coding",
      gene_name : "UTP14C",
      gene_level : 2,
      hgnc_id : "HGNC:20321",
      havana_gene : "OTTHUMG00000164353.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52033611,
      stop : 52129092,
      direction : "-",
      ID : "ENSG00000197168.13",
      gene_id : "ENSG00000197168.13",
      gene_type : "protein_coding",
      gene_name : "NEK5",
      gene_level : 2,
      hgnc_id : "HGNC:7748",
      havana_gene : "OTTHUMG00000016957.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52132639,
      stop : 52159861,
      direction : "-",
      ID : "ENSG00000136098.17",
      gene_id : "ENSG00000136098.17",
      gene_type : "protein_coding",
      gene_name : "NEK3",
      gene_level : 1,
      hgnc_id : "HGNC:7746",
      havana_gene : "OTTHUMG00000016958.10",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52377167,
      stop : 52416373,
      direction : "-",
      ID : "ENSG00000136114.17",
      gene_id : "ENSG00000136114.17",
      gene_type : "protein_coding",
      gene_name : "THSD1",
      gene_level : 2,
      hgnc_id : "HGNC:17754",
      havana_gene : "OTTHUMG00000016963.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52412602,
      stop : 52450634,
      direction : "-",
      ID : "ENSG00000136100.14",
      gene_id : "ENSG00000136100.14",
      gene_type : "protein_coding",
      gene_name : "VPS36",
      gene_level : 2,
      hgnc_id : "HGNC:20312",
      havana_gene : "OTTHUMG00000016964.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52455429,
      stop : 52476628,
      direction : "+",
      ID : "ENSG00000136108.15",
      gene_id : "ENSG00000136108.15",
      gene_type : "protein_coding",
      gene_name : "CKAP2",
      gene_level : 1,
      hgnc_id : "HGNC:1990",
      havana_gene : "OTTHUMG00000016967.9",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52642425,
      stop : 52643796,
      direction : "+",
      ID : "ENSG00000139675.12",
      gene_id : "ENSG00000139675.12",
      gene_type : "protein_coding",
      gene_name : "HNRNPA1L2",
      gene_level : 2,
      hgnc_id : "HGNC:27067",
      havana_gene : "OTTHUMG00000016972.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52652709,
      stop : 52700909,
      direction : "+",
      ID : "ENSG00000165416.15",
      gene_id : "ENSG00000165416.15",
      gene_type : "protein_coding",
      gene_name : "SUGT1",
      gene_level : 2,
      hgnc_id : "HGNC:16987",
      havana_gene : "OTTHUMG00000016977.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52703264,
      stop : 52739820,
      direction : "-",
      ID : "ENSG00000136110.13",
      gene_id : "ENSG00000136110.13",
      gene_type : "protein_coding",
      gene_name : "CNMD",
      gene_level : 2,
      hgnc_id : "HGNC:17005",
      havana_gene : "OTTHUMG00000016980.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 52842889,
      stop : 52848641,
      direction : "-",
      ID : "ENSG00000136099.13",
      gene_id : "ENSG00000136099.13",
      gene_type : "protein_coding",
      gene_name : "PCDH8",
      gene_level : 2,
      hgnc_id : "HGNC:8660",
      havana_gene : "OTTHUMG00000016979.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 53028813,
      stop : 53052057,
      direction : "+",
      ID : "ENSG00000102837.7",
      gene_id : "ENSG00000102837.7",
      gene_type : "protein_coding",
      gene_name : "OLFM4",
      gene_level : 2,
      hgnc_id : "HGNC:17190",
      havana_gene : "OTTHUMG00000016981.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 57140918,
      stop : 57143939,
      direction : "+",
      ID : "ENSG00000204919.1",
      gene_id : "ENSG00000204919.1",
      gene_type : "protein_coding",
      gene_name : "PRR20A",
      gene_level : 2,
      hgnc_id : "HGNC:24754",
      havana_gene : "OTTHUMG00000160602.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 57140918,
      stop : 57157082,
      direction : "+",
      ID : "ENSG00000229665.8",
      gene_id : "ENSG00000229665.8",
      gene_type : "protein_coding",
      gene_name : "PRR20C",
      gene_level : 2,
      hgnc_id : "HGNC:37221",
      havana_gene : "OTTHUMG00000184244.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 57147488,
      stop : 57150509,
      direction : "+",
      ID : "ENSG00000204918.3",
      gene_id : "ENSG00000204918.3",
      gene_type : "protein_coding",
      gene_name : "PRR20B",
      gene_level : 2,
      hgnc_id : "HGNC:37220",
      havana_gene : "OTTHUMG00000184243.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 57160632,
      stop : 57163653,
      direction : "+",
      ID : "ENSG00000227151.4",
      gene_id : "ENSG00000227151.4",
      gene_type : "protein_coding",
      gene_name : "PRR20D",
      gene_level : 2,
      hgnc_id : "HGNC:37222",
      havana_gene : "OTTHUMG00000184245.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 57167197,
      stop : 57170218,
      direction : "+",
      ID : "ENSG00000234278.3",
      gene_id : "ENSG00000234278.3",
      gene_type : "protein_coding",
      gene_name : "PRR20E",
      gene_level : 2,
      hgnc_id : "HGNC:37223",
      havana_gene : "OTTHUMG00000184246.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 57631744,
      stop : 57729311,
      direction : "+",
      ID : "ENSG00000118946.12",
      gene_id : "ENSG00000118946.12",
      gene_type : "protein_coding",
      gene_name : "PCDH17",
      gene_level : 2,
      hgnc_id : "HGNC:14267",
      havana_gene : "OTTHUMG00000016992.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 59665583,
      stop : 60163928,
      direction : "-",
      ID : "ENSG00000139734.19",
      gene_id : "ENSG00000139734.19",
      gene_type : "protein_coding",
      gene_name : "DIAPH3",
      gene_level : 2,
      hgnc_id : "HGNC:15480",
      havana_gene : "OTTHUMG00000017004.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 60396457,
      stop : 60573878,
      direction : "+",
      ID : "ENSG00000083544.16",
      gene_id : "ENSG00000083544.16",
      gene_type : "protein_coding",
      gene_name : "TDRD3",
      gene_level : 2,
      hgnc_id : "HGNC:20612",
      havana_gene : "OTTHUMG00000017007.10",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 61409685,
      stop : 61415522,
      direction : "-",
      ID : "ENSG00000280165.1",
      gene_id : "ENSG00000280165.1",
      gene_type : "protein_coding",
      gene_name : "PCDH20",
      gene_level : 2,
      hgnc_id : "HGNC:14257",
      havana_gene : "OTTHUMG00000017012.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 61409858,
      stop : 61427849,
      direction : "-",
      ID : "ENSG00000197991.11",
      gene_id : "ENSG00000197991.11",
      gene_type : "protein_coding",
      gene_name : "AL592490.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189120.1",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 63746741,
      stop : 63751080,
      direction : "+",
      ID : "ENSG00000237378.3",
      gene_id : "ENSG00000237378.3",
      gene_type : "protein_coding",
      gene_name : "AL445989.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000017023.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 63832361,
      stop : 63833531,
      direction : "-",
      ID : "ENSG00000285566.1",
      gene_id : "ENSG00000285566.1",
      gene_type : "protein_coding",
      gene_name : "AL445238.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193370.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 66302834,
      stop : 67230445,
      direction : "-",
      ID : "ENSG00000184226.15",
      gene_id : "ENSG00000184226.15",
      gene_type : "protein_coding",
      gene_name : "PCDH9",
      gene_level : 2,
      hgnc_id : "HGNC:8661",
      havana_gene : "OTTHUMG00000017040.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 69700594,
      stop : 70108493,
      direction : "-",
      ID : "ENSG00000150361.12",
      gene_id : "ENSG00000150361.12",
      gene_type : "protein_coding",
      gene_name : "KLHL1",
      gene_level : 2,
      hgnc_id : "HGNC:6352",
      havana_gene : "OTTHUMG00000017056.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 71437966,
      stop : 71867204,
      direction : "-",
      ID : "ENSG00000276644.5",
      gene_id : "ENSG00000276644.5",
      gene_type : "protein_coding",
      gene_name : "DACH1",
      gene_level : 2,
      hgnc_id : "HGNC:2663",
      havana_gene : "OTTHUMG00000017063.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 72708367,
      stop : 72727629,
      direction : "-",
      ID : "ENSG00000204899.6",
      gene_id : "ENSG00000204899.6",
      gene_type : "protein_coding",
      gene_name : "MZT1",
      gene_level : 2,
      hgnc_id : "HGNC:33830",
      havana_gene : "OTTHUMG00000017069.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 72727749,
      stop : 72756198,
      direction : "+",
      ID : "ENSG00000136122.18",
      gene_id : "ENSG00000136122.18",
      gene_type : "protein_coding",
      gene_name : "BORA",
      gene_level : 2,
      hgnc_id : "HGNC:24724",
      havana_gene : "OTTHUMG00000017068.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 72752169,
      stop : 72782096,
      direction : "-",
      ID : "ENSG00000083520.15",
      gene_id : "ENSG00000083520.15",
      gene_type : "protein_coding",
      gene_name : "DIS3",
      gene_level : 1,
      hgnc_id : "HGNC:20604",
      havana_gene : "OTTHUMG00000017070.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 72782133,
      stop : 73016461,
      direction : "+",
      ID : "ENSG00000083535.16",
      gene_id : "ENSG00000083535.16",
      gene_type : "protein_coding",
      gene_name : "PIBF1",
      gene_level : 2,
      hgnc_id : "HGNC:23352",
      havana_gene : "OTTHUMG00000017071.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 73054976,
      stop : 73077541,
      direction : "+",
      ID : "ENSG00000102554.14",
      gene_id : "ENSG00000102554.14",
      gene_type : "protein_coding",
      gene_name : "KLF5",
      gene_level : 2,
      hgnc_id : "HGNC:6349",
      havana_gene : "OTTHUMG00000017074.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 73686089,
      stop : 73995056,
      direction : "-",
      ID : "ENSG00000118922.17",
      gene_id : "ENSG00000118922.17",
      gene_type : "protein_coding",
      gene_name : "KLF12",
      gene_level : 2,
      hgnc_id : "HGNC:6346",
      havana_gene : "OTTHUMG00000017078.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 75283503,
      stop : 75482169,
      direction : "-",
      ID : "ENSG00000136111.14",
      gene_id : "ENSG00000136111.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D4",
      gene_level : 2,
      hgnc_id : "HGNC:19165",
      havana_gene : "OTTHUMG00000017088.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 75525219,
      stop : 75549439,
      direction : "-",
      ID : "ENSG00000188243.13",
      gene_id : "ENSG00000188243.13",
      gene_type : "protein_coding",
      gene_name : "COMMD6",
      gene_level : 1,
      hgnc_id : "HGNC:24015",
      havana_gene : "OTTHUMG00000017089.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 75549480,
      stop : 75606020,
      direction : "+",
      ID : "ENSG00000118939.18",
      gene_id : "ENSG00000118939.18",
      gene_type : "protein_coding",
      gene_name : "UCHL3",
      gene_level : 1,
      hgnc_id : "HGNC:12515",
      havana_gene : "OTTHUMG00000017090.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 75620434,
      stop : 75859870,
      direction : "+",
      ID : "ENSG00000136153.20",
      gene_id : "ENSG00000136153.20",
      gene_type : "protein_coding",
      gene_name : "LMO7",
      gene_level : 1,
      hgnc_id : "HGNC:6646",
      havana_gene : "OTTHUMG00000017093.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 76880175,
      stop : 76886405,
      direction : "-",
      ID : "ENSG00000178695.6",
      gene_id : "ENSG00000178695.6",
      gene_type : "protein_coding",
      gene_name : "KCTD12",
      gene_level : 2,
      hgnc_id : "HGNC:14678",
      havana_gene : "OTTHUMG00000017096.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 76948511,
      stop : 76958638,
      direction : "+",
      ID : "ENSG00000102794.10",
      gene_id : "ENSG00000102794.10",
      gene_type : "protein_coding",
      gene_name : "ACOD1",
      gene_level : 2,
      hgnc_id : "HGNC:33904",
      havana_gene : "OTTHUMG00000017098.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 76990660,
      stop : 77019143,
      direction : "+",
      ID : "ENSG00000102805.16",
      gene_id : "ENSG00000102805.16",
      gene_type : "protein_coding",
      gene_name : "CLN5",
      gene_level : 2,
      hgnc_id : "HGNC:2076",
      havana_gene : "OTTHUMG00000017100.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 76992078,
      stop : 77129589,
      direction : "+",
      ID : "ENSG00000283208.2",
      gene_id : "ENSG00000283208.2",
      gene_type : "protein_coding",
      gene_name : "AC001226.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191724.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 76992598,
      stop : 77027195,
      direction : "-",
      ID : "ENSG00000005812.11",
      gene_id : "ENSG00000005812.11",
      gene_type : "protein_coding",
      gene_name : "FBXL3",
      gene_level : 1,
      hgnc_id : "HGNC:13599",
      havana_gene : "OTTHUMG00000017099.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 77044657,
      stop : 77327094,
      direction : "-",
      ID : "ENSG00000005810.18",
      gene_id : "ENSG00000005810.18",
      gene_type : "protein_coding",
      gene_name : "MYCBP2",
      gene_level : 2,
      hgnc_id : "HGNC:23386",
      havana_gene : "OTTHUMG00000017105.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 77535674,
      stop : 77645263,
      direction : "+",
      ID : "ENSG00000136155.17",
      gene_id : "ENSG00000136155.17",
      gene_type : "protein_coding",
      gene_name : "SCEL",
      gene_level : 2,
      hgnc_id : "HGNC:10573",
      havana_gene : "OTTHUMG00000017107.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 77697687,
      stop : 77764242,
      direction : "+",
      ID : "ENSG00000139737.22",
      gene_id : "ENSG00000139737.22",
      gene_type : "protein_coding",
      gene_name : "SLAIN1",
      gene_level : 1,
      hgnc_id : "HGNC:26387",
      havana_gene : "OTTHUMG00000017110.12",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 77895481,
      stop : 77975529,
      direction : "-",
      ID : "ENSG00000136160.17",
      gene_id : "ENSG00000136160.17",
      gene_type : "protein_coding",
      gene_name : "EDNRB",
      gene_level : 1,
      hgnc_id : "HGNC:3180",
      havana_gene : "OTTHUMG00000017111.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 78598362,
      stop : 78603552,
      direction : "-",
      ID : "ENSG00000152192.8",
      gene_id : "ENSG00000152192.8",
      gene_type : "protein_coding",
      gene_name : "POU4F1",
      gene_level : 2,
      hgnc_id : "HGNC:9218",
      havana_gene : "OTTHUMG00000017119.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 78614289,
      stop : 78659155,
      direction : "-",
      ID : "ENSG00000152193.8",
      gene_id : "ENSG00000152193.8",
      gene_type : "protein_coding",
      gene_name : "OBI1",
      gene_level : 2,
      hgnc_id : "HGNC:20308",
      havana_gene : "OTTHUMG00000017122.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 79311824,
      stop : 79406477,
      direction : "-",
      ID : "ENSG00000139746.16",
      gene_id : "ENSG00000139746.16",
      gene_type : "protein_coding",
      gene_name : "RBM26",
      gene_level : 1,
      hgnc_id : "HGNC:20327",
      havana_gene : "OTTHUMG00000017133.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 79481124,
      stop : 79556075,
      direction : "+",
      ID : "ENSG00000102471.14",
      gene_id : "ENSG00000102471.14",
      gene_type : "protein_coding",
      gene_name : "NDFIP2",
      gene_level : 1,
      hgnc_id : "HGNC:18537",
      havana_gene : "OTTHUMG00000017136.9",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 80335976,
      stop : 80341126,
      direction : "-",
      ID : "ENSG00000136158.12",
      gene_id : "ENSG00000136158.12",
      gene_type : "protein_coding",
      gene_name : "SPRY2",
      gene_level : 2,
      hgnc_id : "HGNC:11270",
      havana_gene : "OTTHUMG00000017140.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 83877205,
      stop : 83882474,
      direction : "-",
      ID : "ENSG00000178235.8",
      gene_id : "ENSG00000178235.8",
      gene_type : "protein_coding",
      gene_name : "SLITRK1",
      gene_level : 2,
      hgnc_id : "HGNC:20297",
      havana_gene : "OTTHUMG00000017149.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 85792790,
      stop : 85806683,
      direction : "-",
      ID : "ENSG00000184564.11",
      gene_id : "ENSG00000184564.11",
      gene_type : "protein_coding",
      gene_name : "SLITRK6",
      gene_level : 2,
      hgnc_id : "HGNC:23503",
      havana_gene : "OTTHUMG00000017157.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 87672615,
      stop : 87696272,
      direction : "+",
      ID : "ENSG00000165300.7",
      gene_id : "ENSG00000165300.7",
      gene_type : "protein_coding",
      gene_name : "SLITRK5",
      gene_level : 2,
      hgnc_id : "HGNC:20295",
      havana_gene : "OTTHUMG00000017167.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 91398621,
      stop : 92873682,
      direction : "+",
      ID : "ENSG00000179399.15",
      gene_id : "ENSG00000179399.15",
      gene_type : "protein_coding",
      gene_name : "GPC5",
      gene_level : 2,
      hgnc_id : "HGNC:4453",
      havana_gene : "OTTHUMG00000017200.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 93226807,
      stop : 94408020,
      direction : "+",
      ID : "ENSG00000183098.11",
      gene_id : "ENSG00000183098.11",
      gene_type : "protein_coding",
      gene_name : "GPC6",
      gene_level : 2,
      hgnc_id : "HGNC:4454",
      havana_gene : "OTTHUMG00000017205.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 94436811,
      stop : 94479682,
      direction : "-",
      ID : "ENSG00000080166.16",
      gene_id : "ENSG00000080166.16",
      gene_type : "protein_coding",
      gene_name : "DCT",
      gene_level : 2,
      hgnc_id : "HGNC:2709",
      havana_gene : "OTTHUMG00000017206.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 94574054,
      stop : 94596242,
      direction : "-",
      ID : "ENSG00000088451.11",
      gene_id : "ENSG00000088451.11",
      gene_type : "protein_coding",
      gene_name : "TGDS",
      gene_level : 2,
      hgnc_id : "HGNC:20324",
      havana_gene : "OTTHUMG00000046308.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 94601857,
      stop : 94634661,
      direction : "+",
      ID : "ENSG00000152749.8",
      gene_id : "ENSG00000152749.8",
      gene_type : "protein_coding",
      gene_name : "GPR180",
      gene_level : 2,
      hgnc_id : "HGNC:28899",
      havana_gene : "OTTHUMG00000017207.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 94709622,
      stop : 94712545,
      direction : "-",
      ID : "ENSG00000125285.6",
      gene_id : "ENSG00000125285.6",
      gene_type : "protein_coding",
      gene_name : "SOX21",
      gene_level : 2,
      hgnc_id : "HGNC:11197",
      havana_gene : "OTTHUMG00000017209.5",
      tag : "retrogene"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 95019835,
      stop : 95301475,
      direction : "-",
      ID : "ENSG00000125257.16",
      gene_id : "ENSG00000125257.16",
      gene_type : "protein_coding",
      gene_name : "ABCC4",
      gene_level : 2,
      hgnc_id : "HGNC:55",
      havana_gene : "OTTHUMG00000017216.11",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 95433604,
      stop : 95579759,
      direction : "+",
      ID : "ENSG00000134873.10",
      gene_id : "ENSG00000134873.10",
      gene_type : "protein_coding",
      gene_name : "CLDN10",
      gene_level : 2,
      hgnc_id : "HGNC:2033",
      havana_gene : "OTTHUMG00000017217.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 95578202,
      stop : 95644706,
      direction : "-",
      ID : "ENSG00000134874.18",
      gene_id : "ENSG00000134874.18",
      gene_type : "protein_coding",
      gene_name : "DZIP1",
      gene_level : 2,
      hgnc_id : "HGNC:20908",
      havana_gene : "OTTHUMG00000017224.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 95677139,
      stop : 95794988,
      direction : "+",
      ID : "ENSG00000102580.15",
      gene_id : "ENSG00000102580.15",
      gene_type : "protein_coding",
      gene_name : "DNAJC3",
      gene_level : 1,
      hgnc_id : "HGNC:9439",
      havana_gene : "OTTHUMG00000017227.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 95801580,
      stop : 96053482,
      direction : "-",
      ID : "ENSG00000102595.20",
      gene_id : "ENSG00000102595.20",
      gene_type : "protein_coding",
      gene_name : "UGGT2",
      gene_level : 2,
      hgnc_id : "HGNC:15664",
      havana_gene : "OTTHUMG00000017230.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 96090107,
      stop : 96839562,
      direction : "+",
      ID : "ENSG00000185352.9",
      gene_id : "ENSG00000185352.9",
      gene_type : "protein_coding",
      gene_name : "HS6ST3",
      gene_level : 2,
      hgnc_id : "HGNC:19134",
      havana_gene : "OTTHUMG00000017232.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 96985719,
      stop : 96994730,
      direction : "-",
      ID : "ENSG00000165621.8",
      gene_id : "ENSG00000165621.8",
      gene_type : "protein_coding",
      gene_name : "OXGR1",
      gene_level : 2,
      hgnc_id : "HGNC:4531",
      havana_gene : "OTTHUMG00000017236.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 97221434,
      stop : 97394120,
      direction : "+",
      ID : "ENSG00000139793.19",
      gene_id : "ENSG00000139793.19",
      gene_type : "protein_coding",
      gene_name : "MBNL2",
      gene_level : 2,
      hgnc_id : "HGNC:16746",
      havana_gene : "OTTHUMG00000017239.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 97434169,
      stop : 97469128,
      direction : "+",
      ID : "ENSG00000125249.7",
      gene_id : "ENSG00000125249.7",
      gene_type : "protein_coding",
      gene_name : "RAP2A",
      gene_level : 2,
      hgnc_id : "HGNC:9861",
      havana_gene : "OTTHUMG00000017240.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 97953658,
      stop : 98024296,
      direction : "+",
      ID : "ENSG00000065150.21",
      gene_id : "ENSG00000065150.21",
      gene_type : "protein_coding",
      gene_name : "IPO5",
      gene_level : 1,
      hgnc_id : "HGNC:6402",
      havana_gene : "OTTHUMG00000017244.9",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 98142562,
      stop : 98455176,
      direction : "+",
      ID : "ENSG00000152767.17",
      gene_id : "ENSG00000152767.17",
      gene_type : "protein_coding",
      gene_name : "FARP1",
      gene_level : 2,
      hgnc_id : "HGNC:3591",
      havana_gene : "OTTHUMG00000017248.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 98175785,
      stop : 98177269,
      direction : "-",
      ID : "ENSG00000139797.8",
      gene_id : "ENSG00000139797.8",
      gene_type : "protein_coding",
      gene_name : "RNF113B",
      gene_level : 2,
      hgnc_id : "HGNC:17267",
      havana_gene : "OTTHUMG00000017245.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 98445185,
      stop : 98577940,
      direction : "-",
      ID : "ENSG00000102572.15",
      gene_id : "ENSG00000102572.15",
      gene_type : "protein_coding",
      gene_name : "STK24",
      gene_level : 1,
      hgnc_id : "HGNC:11403",
      havana_gene : "OTTHUMG00000017250.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 98683801,
      stop : 98752672,
      direction : "-",
      ID : "ENSG00000088386.17",
      gene_id : "ENSG00000088386.17",
      gene_type : "protein_coding",
      gene_name : "SLC15A1",
      gene_level : 2,
      hgnc_id : "HGNC:10920",
      havana_gene : "OTTHUMG00000017255.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 98793429,
      stop : 99086625,
      direction : "-",
      ID : "ENSG00000088387.19",
      gene_id : "ENSG00000088387.19",
      gene_type : "protein_coding",
      gene_name : "DOCK9",
      gene_level : 2,
      hgnc_id : "HGNC:14132",
      havana_gene : "OTTHUMG00000017260.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99200774,
      stop : 99386504,
      direction : "+",
      ID : "ENSG00000134882.16",
      gene_id : "ENSG00000134882.16",
      gene_type : "protein_coding",
      gene_name : "UBAC2",
      gene_level : 2,
      hgnc_id : "HGNC:20486",
      havana_gene : "OTTHUMG00000017267.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99254732,
      stop : 99261744,
      direction : "-",
      ID : "ENSG00000125245.14",
      gene_id : "ENSG00000125245.14",
      gene_type : "protein_coding",
      gene_name : "GPR18",
      gene_level : 2,
      hgnc_id : "HGNC:4472",
      havana_gene : "OTTHUMG00000017266.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99294539,
      stop : 99307399,
      direction : "-",
      ID : "ENSG00000169508.7",
      gene_id : "ENSG00000169508.7",
      gene_type : "protein_coding",
      gene_name : "GPR183",
      gene_level : 2,
      hgnc_id : "HGNC:3128",
      havana_gene : "OTTHUMG00000017263.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99446311,
      stop : 99564048,
      direction : "+",
      ID : "ENSG00000125304.10",
      gene_id : "ENSG00000125304.10",
      gene_type : "protein_coding",
      gene_name : "TM9SF2",
      gene_level : 2,
      hgnc_id : "HGNC:11865",
      havana_gene : "OTTHUMG00000017272.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99606669,
      stop : 99897134,
      direction : "+",
      ID : "ENSG00000125246.15",
      gene_id : "ENSG00000125246.15",
      gene_type : "protein_coding",
      gene_name : "CLYBL",
      gene_level : 2,
      hgnc_id : "HGNC:18355",
      havana_gene : "OTTHUMG00000017278.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99962964,
      stop : 99971909,
      direction : "-",
      ID : "ENSG00000139800.8",
      gene_id : "ENSG00000139800.8",
      gene_type : "protein_coding",
      gene_name : "ZIC5",
      gene_level : 1,
      hgnc_id : "HGNC:20322",
      havana_gene : "OTTHUMG00000017280.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 99981784,
      stop : 99986765,
      direction : "+",
      ID : "ENSG00000043355.12",
      gene_id : "ENSG00000043355.12",
      gene_type : "protein_coding",
      gene_name : "ZIC2",
      gene_level : 2,
      hgnc_id : "HGNC:12873",
      havana_gene : "OTTHUMG00000017279.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 100089015,
      stop : 100530437,
      direction : "+",
      ID : "ENSG00000175198.17",
      gene_id : "ENSG00000175198.17",
      gene_type : "protein_coding",
      gene_name : "PCCA",
      gene_level : 2,
      hgnc_id : "HGNC:8653",
      havana_gene : "OTTHUMG00000017284.13",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 100530164,
      stop : 100589528,
      direction : "-",
      ID : "ENSG00000134864.10",
      gene_id : "ENSG00000134864.10",
      gene_type : "protein_coding",
      gene_name : "GGACT",
      gene_level : 2,
      hgnc_id : "HGNC:25100",
      havana_gene : "OTTHUMG00000017291.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 100603625,
      stop : 100675093,
      direction : "-",
      ID : "ENSG00000125247.16",
      gene_id : "ENSG00000125247.16",
      gene_type : "protein_coding",
      gene_name : "TMTC4",
      gene_level : 1,
      hgnc_id : "HGNC:25904",
      havana_gene : "OTTHUMG00000017289.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 101053776,
      stop : 101416508,
      direction : "-",
      ID : "ENSG00000102452.18",
      gene_id : "ENSG00000102452.18",
      gene_type : "protein_coding",
      gene_name : "NALCN",
      gene_level : 2,
      hgnc_id : "HGNC:19082",
      havana_gene : "OTTHUMG00000017295.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 101452593,
      stop : 101720856,
      direction : "+",
      ID : "ENSG00000198542.14",
      gene_id : "ENSG00000198542.14",
      gene_type : "protein_coding",
      gene_name : "ITGBL1",
      gene_level : 2,
      hgnc_id : "HGNC:6164",
      havana_gene : "OTTHUMG00000017296.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 101710804,
      stop : 102402457,
      direction : "-",
      ID : "ENSG00000102466.16",
      gene_id : "ENSG00000102466.16",
      gene_type : "protein_coding",
      gene_name : "FGF14",
      gene_level : 2,
      hgnc_id : "HGNC:3671",
      havana_gene : "OTTHUMG00000017303.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102596986,
      stop : 102679958,
      direction : "+",
      ID : "ENSG00000134900.12",
      gene_id : "ENSG00000134900.12",
      gene_type : "protein_coding",
      gene_name : "TPP2",
      gene_level : 2,
      hgnc_id : "HGNC:12016",
      havana_gene : "OTTHUMG00000017305.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102685744,
      stop : 102694504,
      direction : "-",
      ID : "ENSG00000139780.7",
      gene_id : "ENSG00000139780.7",
      gene_type : "protein_coding",
      gene_name : "METTL21C",
      gene_level : 2,
      hgnc_id : "HGNC:33717",
      havana_gene : "OTTHUMG00000017304.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102729367,
      stop : 102759072,
      direction : "-",
      ID : "ENSG00000175820.4",
      gene_id : "ENSG00000175820.4",
      gene_type : "protein_coding",
      gene_name : "CCDC168",
      gene_level : 2,
      hgnc_id : "HGNC:26851",
      havana_gene : "OTTHUMG00000187287.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102765888,
      stop : 102773811,
      direction : "-",
      ID : "ENSG00000151287.17",
      gene_id : "ENSG00000151287.17",
      gene_type : "protein_coding",
      gene_name : "TEX30",
      gene_level : 2,
      hgnc_id : "HGNC:25188",
      havana_gene : "OTTHUMG00000017306.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102784281,
      stop : 102798976,
      direction : "-",
      ID : "ENSG00000134901.13",
      gene_id : "ENSG00000134901.13",
      gene_type : "protein_coding",
      gene_name : "POGLUT2",
      gene_level : 2,
      hgnc_id : "HGNC:19350",
      havana_gene : "OTTHUMG00000017307.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102799110,
      stop : 102875994,
      direction : "+",
      ID : "ENSG00000270181.3",
      gene_id : "ENSG00000270181.3",
      gene_type : "protein_coding",
      gene_name : "BIVM-ERCC5",
      gene_level : 1,
      hgnc_id : "HGNC:43690",
      havana_gene : "OTTHUMG00000184166.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102799119,
      stop : 102841533,
      direction : "+",
      ID : "ENSG00000134897.14",
      gene_id : "ENSG00000134897.14",
      gene_type : "protein_coding",
      gene_name : "BIVM",
      gene_level : 2,
      hgnc_id : "HGNC:16034",
      havana_gene : "OTTHUMG00000017309.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 102845831,
      stop : 102875995,
      direction : "+",
      ID : "ENSG00000134899.23",
      gene_id : "ENSG00000134899.23",
      gene_type : "protein_coding",
      gene_name : "ERCC5",
      gene_level : 2,
      hgnc_id : "HGNC:3437",
      havana_gene : "OTTHUMG00000017310.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 103043998,
      stop : 103066417,
      direction : "-",
      ID : "ENSG00000125255.7",
      gene_id : "ENSG00000125255.7",
      gene_type : "protein_coding",
      gene_name : "SLC10A2",
      gene_level : 2,
      hgnc_id : "HGNC:10906",
      havana_gene : "OTTHUMG00000017313.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 105465867,
      stop : 105491034,
      direction : "+",
      ID : "ENSG00000182346.21",
      gene_id : "ENSG00000182346.21",
      gene_type : "protein_coding",
      gene_name : "DAOA",
      gene_level : 2,
      hgnc_id : "HGNC:21191",
      havana_gene : "OTTHUMG00000041333.10",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 106489745,
      stop : 106535662,
      direction : "-",
      ID : "ENSG00000125266.8",
      gene_id : "ENSG00000125266.8",
      gene_type : "protein_coding",
      gene_name : "EFNB2",
      gene_level : 2,
      hgnc_id : "HGNC:3227",
      havana_gene : "OTTHUMG00000017324.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 106541673,
      stop : 106568137,
      direction : "-",
      ID : "ENSG00000134884.15",
      gene_id : "ENSG00000134884.15",
      gene_type : "protein_coding",
      gene_name : "ARGLU1",
      gene_level : 2,
      hgnc_id : "HGNC:25482",
      havana_gene : "OTTHUMG00000017321.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 107163510,
      stop : 107867496,
      direction : "-",
      ID : "ENSG00000204442.4",
      gene_id : "ENSG00000204442.4",
      gene_type : "protein_coding",
      gene_name : "FAM155A",
      gene_level : 2,
      hgnc_id : "HGNC:33877",
      havana_gene : "OTTHUMG00000017326.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 108207439,
      stop : 108218368,
      direction : "-",
      ID : "ENSG00000174405.14",
      gene_id : "ENSG00000174405.14",
      gene_type : "protein_coding",
      gene_name : "LIG4",
      gene_level : 2,
      hgnc_id : "HGNC:6601",
      havana_gene : "OTTHUMG00000017328.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 108218392,
      stop : 108234243,
      direction : "+",
      ID : "ENSG00000139826.6",
      gene_id : "ENSG00000139826.6",
      gene_type : "protein_coding",
      gene_name : "ABHD13",
      gene_level : 2,
      hgnc_id : "HGNC:20293",
      havana_gene : "OTTHUMG00000017330.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 108251240,
      stop : 108308484,
      direction : "+",
      ID : "ENSG00000102524.12",
      gene_id : "ENSG00000102524.12",
      gene_type : "protein_coding",
      gene_name : "TNFSF13B",
      gene_level : 2,
      hgnc_id : "HGNC:11929",
      havana_gene : "OTTHUMG00000017329.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 108596152,
      stop : 109208005,
      direction : "+",
      ID : "ENSG00000041515.16",
      gene_id : "ENSG00000041515.16",
      gene_type : "protein_coding",
      gene_name : "MYO16",
      gene_level : 2,
      hgnc_id : "HGNC:29822",
      havana_gene : "OTTHUMG00000017333.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 109752695,
      stop : 109786583,
      direction : "-",
      ID : "ENSG00000185950.9",
      gene_id : "ENSG00000185950.9",
      gene_type : "protein_coding",
      gene_name : "IRS2",
      gene_level : 2,
      hgnc_id : "HGNC:6126",
      havana_gene : "OTTHUMG00000017338.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110148963,
      stop : 110307157,
      direction : "-",
      ID : "ENSG00000187498.16",
      gene_id : "ENSG00000187498.16",
      gene_type : "protein_coding",
      gene_name : "COL4A1",
      gene_level : 2,
      hgnc_id : "HGNC:2202",
      havana_gene : "OTTHUMG00000017342.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110305812,
      stop : 110513209,
      direction : "+",
      ID : "ENSG00000134871.19",
      gene_id : "ENSG00000134871.19",
      gene_type : "protein_coding",
      gene_name : "COL4A2",
      gene_level : 1,
      hgnc_id : "HGNC:2203",
      havana_gene : "OTTHUMG00000017344.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110523066,
      stop : 110561722,
      direction : "-",
      ID : "ENSG00000139832.5",
      gene_id : "ENSG00000139832.5",
      gene_type : "protein_coding",
      gene_name : "RAB20",
      gene_level : 2,
      hgnc_id : "HGNC:18260",
      havana_gene : "OTTHUMG00000017343.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110615545,
      stop : 110639996,
      direction : "+",
      ID : "ENSG00000213995.12",
      gene_id : "ENSG00000213995.12",
      gene_type : "protein_coding",
      gene_name : "NAXD",
      gene_level : 2,
      hgnc_id : "HGNC:25576",
      havana_gene : "OTTHUMG00000017345.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110641412,
      stop : 110713603,
      direction : "-",
      ID : "ENSG00000134905.17",
      gene_id : "ENSG00000134905.17",
      gene_type : "protein_coding",
      gene_name : "CARS2",
      gene_level : 1,
      hgnc_id : "HGNC:25695",
      havana_gene : "OTTHUMG00000017347.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110712736,
      stop : 110723339,
      direction : "+",
      ID : "ENSG00000153487.13",
      gene_id : "ENSG00000153487.13",
      gene_type : "protein_coding",
      gene_name : "ING1",
      gene_level : 2,
      hgnc_id : "HGNC:6062",
      havana_gene : "OTTHUMG00000017346.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 110878540,
      stop : 110915069,
      direction : "-",
      ID : "ENSG00000088448.14",
      gene_id : "ENSG00000088448.14",
      gene_type : "protein_coding",
      gene_name : "ANKRD10",
      gene_level : 1,
      hgnc_id : "HGNC:20265",
      havana_gene : "OTTHUMG00000017349.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 111114559,
      stop : 111305737,
      direction : "+",
      ID : "ENSG00000102606.18",
      gene_id : "ENSG00000102606.18",
      gene_type : "protein_coding",
      gene_name : "ARHGEF7",
      gene_level : 2,
      hgnc_id : "HGNC:15607",
      havana_gene : "OTTHUMG00000017357.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 111316184,
      stop : 111344249,
      direction : "+",
      ID : "ENSG00000153495.11",
      gene_id : "ENSG00000153495.11",
      gene_type : "protein_coding",
      gene_name : "TEX29",
      gene_level : 2,
      hgnc_id : "HGNC:20370",
      havana_gene : "OTTHUMG00000017358.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 112067149,
      stop : 112071706,
      direction : "+",
      ID : "ENSG00000182968.5",
      gene_id : "ENSG00000182968.5",
      gene_type : "protein_coding",
      gene_name : "SOX1",
      gene_level : 2,
      hgnc_id : "HGNC:11189",
      havana_gene : "OTTHUMG00000017362.4",
      tag : "retrogene"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 112376355,
      stop : 112434689,
      direction : "+",
      ID : "ENSG00000153498.12",
      gene_id : "ENSG00000153498.12",
      gene_type : "protein_coding",
      gene_name : "SPACA7",
      gene_level : 1,
      hgnc_id : "HGNC:29575",
      havana_gene : "OTTHUMG00000017365.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 112485011,
      stop : 112588205,
      direction : "-",
      ID : "ENSG00000126216.15",
      gene_id : "ENSG00000126216.15",
      gene_type : "protein_coding",
      gene_name : "TUBGCP3",
      gene_level : 2,
      hgnc_id : "HGNC:18598",
      havana_gene : "OTTHUMG00000017367.8",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 112690329,
      stop : 112887168,
      direction : "+",
      ID : "ENSG00000068650.18",
      gene_id : "ENSG00000068650.18",
      gene_type : "protein_coding",
      gene_name : "ATP11A",
      gene_level : 2,
      hgnc_id : "HGNC:13552",
      havana_gene : "OTTHUMG00000017371.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 112894378,
      stop : 113099742,
      direction : "+",
      ID : "ENSG00000126217.21",
      gene_id : "ENSG00000126217.21",
      gene_type : "protein_coding",
      gene_name : "MCF2L",
      gene_level : 1,
      hgnc_id : "HGNC:14576",
      havana_gene : "OTTHUMG00000017377.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113105788,
      stop : 113120685,
      direction : "+",
      ID : "ENSG00000057593.14",
      gene_id : "ENSG00000057593.14",
      gene_type : "protein_coding",
      gene_name : "F7",
      gene_level : 2,
      hgnc_id : "HGNC:3544",
      havana_gene : "OTTHUMG00000017373.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113122799,
      stop : 113149529,
      direction : "+",
      ID : "ENSG00000126218.12",
      gene_id : "ENSG00000126218.12",
      gene_type : "protein_coding",
      gene_name : "F10",
      gene_level : 1,
      hgnc_id : "HGNC:3528",
      havana_gene : "OTTHUMG00000017374.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113158648,
      stop : 113172386,
      direction : "+",
      ID : "ENSG00000126231.15",
      gene_id : "ENSG00000126231.15",
      gene_type : "protein_coding",
      gene_name : "PROZ",
      gene_level : 2,
      hgnc_id : "HGNC:9460",
      havana_gene : "OTTHUMG00000017376.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113177536,
      stop : 113208715,
      direction : "-",
      ID : "ENSG00000126226.22",
      gene_id : "ENSG00000126226.22",
      gene_type : "protein_coding",
      gene_name : "PCID2",
      gene_level : 2,
      hgnc_id : "HGNC:25653",
      havana_gene : "OTTHUMG00000017385.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113208193,
      stop : 113267108,
      direction : "+",
      ID : "ENSG00000139842.15",
      gene_id : "ENSG00000139842.15",
      gene_type : "protein_coding",
      gene_name : "CUL4A",
      gene_level : 2,
      hgnc_id : "HGNC:2554",
      havana_gene : "OTTHUMG00000017384.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113297239,
      stop : 113323672,
      direction : "+",
      ID : "ENSG00000185896.11",
      gene_id : "ENSG00000185896.11",
      gene_type : "protein_coding",
      gene_name : "LAMP1",
      gene_level : 2,
      hgnc_id : "HGNC:6499",
      havana_gene : "OTTHUMG00000017380.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113324163,
      stop : 113364148,
      direction : "-",
      ID : "ENSG00000139835.14",
      gene_id : "ENSG00000139835.14",
      gene_type : "protein_coding",
      gene_name : "GRTP1",
      gene_level : 1,
      hgnc_id : "HGNC:20310",
      havana_gene : "OTTHUMG00000017381.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113399610,
      stop : 113453524,
      direction : "-",
      ID : "ENSG00000153531.13",
      gene_id : "ENSG00000153531.13",
      gene_type : "protein_coding",
      gene_name : "ADPRHL1",
      gene_level : 2,
      hgnc_id : "HGNC:21303",
      havana_gene : "OTTHUMG00000017386.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113455819,
      stop : 113490951,
      direction : "-",
      ID : "ENSG00000150401.15",
      gene_id : "ENSG00000150401.15",
      gene_type : "protein_coding",
      gene_name : "DCUN1D2",
      gene_level : 2,
      hgnc_id : "HGNC:20328",
      havana_gene : "OTTHUMG00000017390.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113491021,
      stop : 113554590,
      direction : "+",
      ID : "ENSG00000150403.18",
      gene_id : "ENSG00000150403.18",
      gene_type : "protein_coding",
      gene_name : "TMCO3",
      gene_level : 2,
      hgnc_id : "HGNC:20329",
      havana_gene : "OTTHUMG00000017389.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113584721,
      stop : 113641473,
      direction : "+",
      ID : "ENSG00000198176.13",
      gene_id : "ENSG00000198176.13",
      gene_type : "protein_coding",
      gene_name : "TFDP1",
      gene_level : 2,
      hgnc_id : "HGNC:11749",
      havana_gene : "OTTHUMG00000017388.7",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113648804,
      stop : 113658198,
      direction : "-",
      ID : "ENSG00000186009.5",
      gene_id : "ENSG00000186009.5",
      gene_type : "protein_coding",
      gene_name : "ATP4B",
      gene_level : 2,
      hgnc_id : "HGNC:820",
      havana_gene : "OTTHUMG00000140234.4",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113667219,
      stop : 113737736,
      direction : "+",
      ID : "ENSG00000185974.7",
      gene_id : "ENSG00000185974.7",
      gene_type : "protein_coding",
      gene_name : "GRK1",
      gene_level : 2,
      hgnc_id : "HGNC:10013",
      havana_gene : "OTTHUMG00000185528.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113759226,
      stop : 113816995,
      direction : "+",
      ID : "ENSG00000184497.13",
      gene_id : "ENSG00000184497.13",
      gene_type : "protein_coding",
      gene_name : "TMEM255B",
      gene_level : 1,
      hgnc_id : "HGNC:28297",
      havana_gene : "OTTHUMG00000017398.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113820549,
      stop : 113864076,
      direction : "-",
      ID : "ENSG00000183087.15",
      gene_id : "ENSG00000183087.15",
      gene_type : "protein_coding",
      gene_name : "GAS6",
      gene_level : 2,
      hgnc_id : "HGNC:4168",
      havana_gene : "OTTHUMG00000017395.5",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113953705,
      stop : 113974076,
      direction : "-",
      ID : "ENSG00000283199.3",
      gene_id : "ENSG00000283199.3",
      gene_type : "protein_coding",
      gene_name : "C13orf46",
      gene_level : 2,
      hgnc_id : "HGNC:53786",
      havana_gene : "OTTHUMG00000191740.3",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 113977783,
      stop : 114132623,
      direction : "-",
      ID : "ENSG00000185989.11",
      gene_id : "ENSG00000185989.11",
      gene_type : "protein_coding",
      gene_name : "RASA3",
      gene_level : 2,
      hgnc_id : "HGNC:20331",
      havana_gene : "OTTHUMG00000017399.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 114154691,
      stop : 114223084,
      direction : "+",
      ID : "ENSG00000283361.2",
      gene_id : "ENSG00000283361.2",
      gene_type : "protein_coding",
      gene_name : "CFAP97D2",
      gene_level : 2,
      hgnc_id : "HGNC:53789",
      havana_gene : "OTTHUMG00000191665.2",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 114234887,
      stop : 114272723,
      direction : "+",
      ID : "ENSG00000130177.16",
      gene_id : "ENSG00000130177.16",
      gene_type : "protein_coding",
      gene_name : "CDC16",
      gene_level : 2,
      hgnc_id : "HGNC:1720",
      havana_gene : "OTTHUMG00000017402.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 114281601,
      stop : 114305817,
      direction : "+",
      ID : "ENSG00000169062.15",
      gene_id : "ENSG00000169062.15",
      gene_type : "protein_coding",
      gene_name : "UPF3A",
      gene_level : 2,
      hgnc_id : "HGNC:20332",
      havana_gene : "OTTHUMG00000017403.6",
      tag : null
    },
    {
      chromosome : 13,
      annotation : "HAVANA",
      type : "gene",
      start : 114314482,
      stop : 114337626,
      direction : "+",
      ID : "ENSG00000198824.7",
      gene_id : "ENSG00000198824.7",
      gene_type : "protein_coding",
      gene_name : "CHAMP1",
      gene_level : 2,
      hgnc_id : "HGNC:20311",
      havana_gene : "OTTHUMG00000017404.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 18601045,
      stop : 18602129,
      direction : "+",
      ID : "ENSG00000257115.1",
      gene_id : "ENSG00000257115.1",
      gene_type : "protein_coding",
      gene_name : "OR11H12",
      gene_level : 2,
      hgnc_id : "HGNC:30738",
      havana_gene : "OTTHUMG00000170298.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 18967434,
      stop : 19003752,
      direction : "+",
      ID : "ENSG00000222036.8",
      gene_id : "ENSG00000222036.8",
      gene_type : "protein_coding",
      gene_name : "POTEM",
      gene_level : 2,
      hgnc_id : "HGNC:37096",
      havana_gene : "OTTHUMG00000170340.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19402486,
      stop : 19434341,
      direction : "-",
      ID : "ENSG00000187537.13",
      gene_id : "ENSG00000187537.13",
      gene_type : "protein_coding",
      gene_name : "POTEG",
      gene_level : 2,
      hgnc_id : "HGNC:33896",
      havana_gene : "OTTHUMG00000170518.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19712904,
      stop : 19714332,
      direction : "-",
      ID : "ENSG00000258453.3",
      gene_id : "ENSG00000258453.3",
      gene_type : "protein_coding",
      gene_name : "OR11H2",
      gene_level : 2,
      hgnc_id : "HGNC:14716",
      havana_gene : "OTTHUMG00000170597.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19719015,
      stop : 19830253,
      direction : "+",
      ID : "ENSG00000176294.6",
      gene_id : "ENSG00000176294.6",
      gene_type : "protein_coding",
      gene_name : "OR4N2",
      gene_level : 2,
      hgnc_id : "HGNC:14742",
      havana_gene : "OTTHUMG00000170614.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19743571,
      stop : 19749469,
      direction : "+",
      ID : "ENSG00000182652.4",
      gene_id : "ENSG00000182652.4",
      gene_type : "protein_coding",
      gene_name : "OR4Q3",
      gene_level : 2,
      hgnc_id : "HGNC:15426",
      havana_gene : "OTTHUMG00000170612.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19773504,
      stop : 19783696,
      direction : "+",
      ID : "ENSG00000176299.5",
      gene_id : "ENSG00000176299.5",
      gene_type : "protein_coding",
      gene_name : "OR4M1",
      gene_level : 2,
      hgnc_id : "HGNC:14735",
      havana_gene : "OTTHUMG00000170599.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19875142,
      stop : 19883932,
      direction : "+",
      ID : "ENSG00000165762.3",
      gene_id : "ENSG00000165762.3",
      gene_type : "protein_coding",
      gene_name : "OR4K2",
      gene_level : 2,
      hgnc_id : "HGNC:14728",
      havana_gene : "OTTHUMG00000170624.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19920582,
      stop : 19921659,
      direction : "+",
      ID : "ENSG00000176281.4",
      gene_id : "ENSG00000176281.4",
      gene_type : "protein_coding",
      gene_name : "OR4K5",
      gene_level : 2,
      hgnc_id : "HGNC:14745",
      havana_gene : "OTTHUMG00000170627.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19930917,
      stop : 19936757,
      direction : "+",
      ID : "ENSG00000155249.5",
      gene_id : "ENSG00000155249.5",
      gene_type : "protein_coding",
      gene_name : "OR4K1",
      gene_level : 2,
      hgnc_id : "HGNC:14726",
      havana_gene : "OTTHUMG00000170633.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 19975444,
      stop : 19976659,
      direction : "+",
      ID : "ENSG00000169488.6",
      gene_id : "ENSG00000169488.6",
      gene_type : "protein_coding",
      gene_name : "OR4K15",
      gene_level : 2,
      hgnc_id : "HGNC:15353",
      havana_gene : "OTTHUMG00000170635.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20014143,
      stop : 20019307,
      direction : "-",
      ID : "ENSG00000169484.4",
      gene_id : "ENSG00000169484.4",
      gene_type : "protein_coding",
      gene_name : "OR4K14",
      gene_level : 2,
      hgnc_id : "HGNC:15352",
      havana_gene : "OTTHUMG00000170780.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20029399,
      stop : 20036038,
      direction : "-",
      ID : "ENSG00000176253.4",
      gene_id : "ENSG00000176253.4",
      gene_type : "protein_coding",
      gene_name : "OR4K13",
      gene_level : 2,
      hgnc_id : "HGNC:15351",
      havana_gene : "OTTHUMG00000170781.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20060045,
      stop : 20060983,
      direction : "+",
      ID : "ENSG00000176246.1",
      gene_id : "ENSG00000176246.1",
      gene_type : "protein_coding",
      gene_name : "OR4L1",
      gene_level : 2,
      hgnc_id : "HGNC:15356",
      havana_gene : "OTTHUMG00000169492.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20110739,
      stop : 20122199,
      direction : "+",
      ID : "ENSG00000176230.7",
      gene_id : "ENSG00000176230.7",
      gene_type : "protein_coding",
      gene_name : "OR4K17",
      gene_level : 2,
      hgnc_id : "HGNC:15355",
      havana_gene : "OTTHUMG00000170783.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20138820,
      stop : 20145471,
      direction : "+",
      ID : "ENSG00000184394.2",
      gene_id : "ENSG00000184394.2",
      gene_type : "protein_coding",
      gene_name : "OR4N5",
      gene_level : 2,
      hgnc_id : "HGNC:15358",
      havana_gene : "OTTHUMG00000170784.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20190894,
      stop : 20201075,
      direction : "+",
      ID : "ENSG00000196832.4",
      gene_id : "ENSG00000196832.4",
      gene_type : "protein_coding",
      gene_name : "OR11G2",
      gene_level : 2,
      hgnc_id : "HGNC:15346",
      havana_gene : "OTTHUMG00000167700.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20223710,
      stop : 20224702,
      direction : "+",
      ID : "ENSG00000176219.3",
      gene_id : "ENSG00000176219.3",
      gene_type : "protein_coding",
      gene_name : "OR11H6",
      gene_level : 2,
      hgnc_id : "HGNC:15349",
      havana_gene : "OTTHUMG00000170850.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20239286,
      stop : 20244349,
      direction : "+",
      ID : "ENSG00000176198.3",
      gene_id : "ENSG00000176198.3",
      gene_type : "protein_coding",
      gene_name : "OR11H4",
      gene_level : 2,
      hgnc_id : "HGNC:15347",
      havana_gene : "OTTHUMG00000170852.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20256558,
      stop : 20305960,
      direction : "-",
      ID : "ENSG00000136319.12",
      gene_id : "ENSG00000136319.12",
      gene_type : "protein_coding",
      gene_name : "TTC5",
      gene_level : 1,
      hgnc_id : "HGNC:19274",
      havana_gene : "OTTHUMG00000029506.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20311368,
      stop : 20333312,
      direction : "-",
      ID : "ENSG00000100814.18",
      gene_id : "ENSG00000100814.18",
      gene_type : "protein_coding",
      gene_name : "CCNB1IP1",
      gene_level : 1,
      hgnc_id : "HGNC:19437",
      havana_gene : "OTTHUMG00000029509.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20343615,
      stop : 20357904,
      direction : "+",
      ID : "ENSG00000129484.14",
      gene_id : "ENSG00000129484.14",
      gene_type : "protein_coding",
      gene_name : "PARP2",
      gene_level : 1,
      hgnc_id : "HGNC:272",
      havana_gene : "OTTHUMG00000166106.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20365667,
      stop : 20413501,
      direction : "-",
      ID : "ENSG00000129566.13",
      gene_id : "ENSG00000129566.13",
      gene_type : "protein_coding",
      gene_name : "TEP1",
      gene_level : 1,
      hgnc_id : "HGNC:11726",
      havana_gene : "OTTHUMG00000029515.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20425852,
      stop : 20436166,
      direction : "-",
      ID : "ENSG00000185271.9",
      gene_id : "ENSG00000185271.9",
      gene_type : "protein_coding",
      gene_name : "KLHL33",
      gene_level : 2,
      hgnc_id : "HGNC:31952",
      havana_gene : "OTTHUMG00000170982.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20446401,
      stop : 20455089,
      direction : "-",
      ID : "ENSG00000092094.11",
      gene_id : "ENSG00000092094.11",
      gene_type : "protein_coding",
      gene_name : "OSGEP",
      gene_level : 1,
      hgnc_id : "HGNC:18028",
      havana_gene : "OTTHUMG00000029543.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20455191,
      stop : 20457772,
      direction : "+",
      ID : "ENSG00000100823.12",
      gene_id : "ENSG00000100823.12",
      gene_type : "protein_coding",
      gene_name : "APEX1",
      gene_level : 1,
      hgnc_id : "HGNC:587",
      havana_gene : "OTTHUMG00000029544.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20457681,
      stop : 20461465,
      direction : "-",
      ID : "ENSG00000165782.11",
      gene_id : "ENSG00000165782.11",
      gene_type : "protein_coding",
      gene_name : "PIP4P1",
      gene_level : 1,
      hgnc_id : "HGNC:19299",
      havana_gene : "OTTHUMG00000029545.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20468954,
      stop : 20477089,
      direction : "+",
      ID : "ENSG00000198805.12",
      gene_id : "ENSG00000198805.12",
      gene_type : "protein_coding",
      gene_name : "PNP",
      gene_level : 1,
      hgnc_id : "HGNC:7892",
      havana_gene : "OTTHUMG00000029546.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20505537,
      stop : 20511169,
      direction : "+",
      ID : "ENSG00000182545.6",
      gene_id : "ENSG00000182545.6",
      gene_type : "protein_coding",
      gene_name : "RNASE10",
      gene_level : 2,
      hgnc_id : "HGNC:19275",
      havana_gene : "OTTHUMG00000170986.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20556093,
      stop : 20560931,
      direction : "-",
      ID : "ENSG00000188655.10",
      gene_id : "ENSG00000188655.10",
      gene_type : "protein_coding",
      gene_name : "RNASE9",
      gene_level : 2,
      hgnc_id : "HGNC:20673",
      havana_gene : "OTTHUMG00000170989.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20582892,
      stop : 20609795,
      direction : "-",
      ID : "ENSG00000259060.7",
      gene_id : "ENSG00000259060.7",
      gene_type : "protein_coding",
      gene_name : "AL163195.3",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186017.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20583559,
      stop : 20609884,
      direction : "-",
      ID : "ENSG00000173464.14",
      gene_id : "ENSG00000173464.14",
      gene_type : "protein_coding",
      gene_name : "RNASE11",
      gene_level : 2,
      hgnc_id : "HGNC:19269",
      havana_gene : "OTTHUMG00000170990.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20590193,
      stop : 20590823,
      direction : "-",
      ID : "ENSG00000258436.1",
      gene_id : "ENSG00000258436.1",
      gene_type : "protein_coding",
      gene_name : "RNASE12",
      gene_level : 2,
      hgnc_id : "HGNC:24211",
      havana_gene : "OTTHUMG00000170991.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20640696,
      stop : 20641691,
      direction : "-",
      ID : "ENSG00000181803.3",
      gene_id : "ENSG00000181803.3",
      gene_type : "protein_coding",
      gene_name : "OR6S1",
      gene_level : 2,
      hgnc_id : "HGNC:15363",
      havana_gene : "OTTHUMG00000171010.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20684177,
      stop : 20698971,
      direction : "+",
      ID : "ENSG00000214274.10",
      gene_id : "ENSG00000214274.10",
      gene_type : "protein_coding",
      gene_name : "ANG",
      gene_level : 1,
      hgnc_id : "HGNC:483",
      havana_gene : "OTTHUMG00000029576.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20684560,
      stop : 20701216,
      direction : "+",
      ID : "ENSG00000258818.4",
      gene_id : "ENSG00000258818.4",
      gene_type : "protein_coding",
      gene_name : "RNASE4",
      gene_level : 2,
      hgnc_id : "HGNC:10047",
      havana_gene : "OTTHUMG00000029575.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20684587,
      stop : 20700576,
      direction : "+",
      ID : "ENSG00000259171.1",
      gene_id : "ENSG00000259171.1",
      gene_type : "protein_coding",
      gene_name : "AL163636.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000187519.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20745887,
      stop : 20748380,
      direction : "+",
      ID : "ENSG00000181562.5",
      gene_id : "ENSG00000181562.5",
      gene_type : "protein_coding",
      gene_name : "EDDM3A",
      gene_level : 2,
      hgnc_id : "HGNC:16978",
      havana_gene : "OTTHUMG00000029581.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20768404,
      stop : 20770948,
      direction : "+",
      ID : "ENSG00000181552.4",
      gene_id : "ENSG00000181552.4",
      gene_type : "protein_coding",
      gene_name : "EDDM3B",
      gene_level : 2,
      hgnc_id : "HGNC:19223",
      havana_gene : "OTTHUMG00000029583.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20781268,
      stop : 20782467,
      direction : "+",
      ID : "ENSG00000169413.3",
      gene_id : "ENSG00000169413.3",
      gene_type : "protein_coding",
      gene_name : "RNASE6",
      gene_level : 2,
      hgnc_id : "HGNC:10048",
      havana_gene : "OTTHUMG00000029585.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20801228,
      stop : 20802855,
      direction : "-",
      ID : "ENSG00000129538.14",
      gene_id : "ENSG00000129538.14",
      gene_type : "protein_coding",
      gene_name : "RNASE1",
      gene_level : 2,
      hgnc_id : "HGNC:10044",
      havana_gene : "OTTHUMG00000029603.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20891399,
      stop : 20892348,
      direction : "+",
      ID : "ENSG00000169397.3",
      gene_id : "ENSG00000169397.3",
      gene_type : "protein_coding",
      gene_name : "RNASE3",
      gene_level : 2,
      hgnc_id : "HGNC:10046",
      havana_gene : "OTTHUMG00000029604.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20955487,
      stop : 20956436,
      direction : "+",
      ID : "ENSG00000169385.3",
      gene_id : "ENSG00000169385.3",
      gene_type : "protein_coding",
      gene_name : "RNASE2",
      gene_level : 2,
      hgnc_id : "HGNC:10045",
      havana_gene : "OTTHUMG00000029607.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20989973,
      stop : 20997035,
      direction : "+",
      ID : "ENSG00000165792.18",
      gene_id : "ENSG00000165792.18",
      gene_type : "protein_coding",
      gene_name : "METTL17",
      gene_level : 1,
      hgnc_id : "HGNC:19280",
      havana_gene : "OTTHUMG00000029610.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 20999255,
      stop : 21001871,
      direction : "+",
      ID : "ENSG00000165794.10",
      gene_id : "ENSG00000165794.10",
      gene_type : "protein_coding",
      gene_name : "SLC39A2",
      gene_level : 2,
      hgnc_id : "HGNC:17127",
      havana_gene : "OTTHUMG00000029616.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21016763,
      stop : 21070872,
      direction : "-",
      ID : "ENSG00000165795.23",
      gene_id : "ENSG00000165795.23",
      gene_type : "protein_coding",
      gene_name : "NDRG2",
      gene_level : 1,
      hgnc_id : "HGNC:14460",
      havana_gene : "OTTHUMG00000029619.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21024109,
      stop : 21036276,
      direction : "+",
      ID : "ENSG00000179636.15",
      gene_id : "ENSG00000179636.15",
      gene_type : "protein_coding",
      gene_name : "TPPP2",
      gene_level : 1,
      hgnc_id : "HGNC:19293",
      havana_gene : "OTTHUMG00000171071.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21032818,
      stop : 21034807,
      direction : "-",
      ID : "ENSG00000206150.4",
      gene_id : "ENSG00000206150.4",
      gene_type : "protein_coding",
      gene_name : "RNASE13",
      gene_level : 2,
      hgnc_id : "HGNC:25285",
      havana_gene : "OTTHUMG00000171110.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21042316,
      stop : 21044234,
      direction : "+",
      ID : "ENSG00000165799.5",
      gene_id : "ENSG00000165799.5",
      gene_type : "protein_coding",
      gene_name : "RNASE7",
      gene_level : 2,
      hgnc_id : "HGNC:19278",
      havana_gene : "OTTHUMG00000171358.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21057822,
      stop : 21058455,
      direction : "+",
      ID : "ENSG00000173431.2",
      gene_id : "ENSG00000173431.2",
      gene_type : "protein_coding",
      gene_name : "RNASE8",
      gene_level : 2,
      hgnc_id : "HGNC:19277",
      havana_gene : "OTTHUMG00000029645.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21070273,
      stop : 21090248,
      direction : "+",
      ID : "ENSG00000165801.10",
      gene_id : "ENSG00000165801.10",
      gene_type : "protein_coding",
      gene_name : "ARHGEF40",
      gene_level : 2,
      hgnc_id : "HGNC:25516",
      havana_gene : "OTTHUMG00000171359.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21090077,
      stop : 21104722,
      direction : "-",
      ID : "ENSG00000165804.16",
      gene_id : "ENSG00000165804.16",
      gene_type : "protein_coding",
      gene_name : "ZNF219",
      gene_level : 2,
      hgnc_id : "HGNC:13011",
      havana_gene : "OTTHUMG00000029647.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21098811,
      stop : 21103724,
      direction : "+",
      ID : "ENSG00000232070.9",
      gene_id : "ENSG00000232070.9",
      gene_type : "protein_coding",
      gene_name : "TMEM253",
      gene_level : 1,
      hgnc_id : "HGNC:32545",
      havana_gene : "OTTHUMG00000171361.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21148370,
      stop : 21159060,
      direction : "-",
      ID : "ENSG00000169327.5",
      gene_id : "ENSG00000169327.5",
      gene_type : "protein_coding",
      gene_name : "OR5AU1",
      gene_level : 2,
      hgnc_id : "HGNC:15362",
      havana_gene : "OTTHUMG00000170753.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21209136,
      stop : 21269494,
      direction : "-",
      ID : "ENSG00000092199.18",
      gene_id : "ENSG00000092199.18",
      gene_type : "protein_coding",
      gene_name : "HNRNPC",
      gene_level : 2,
      hgnc_id : "HGNC:5035",
      havana_gene : "OTTHUMG00000170757.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21280083,
      stop : 21351301,
      direction : "+",
      ID : "ENSG00000092200.13",
      gene_id : "ENSG00000092200.13",
      gene_type : "protein_coding",
      gene_name : "RPGRIP1",
      gene_level : 1,
      hgnc_id : "HGNC:13436",
      havana_gene : "OTTHUMG00000170758.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21351476,
      stop : 21384019,
      direction : "-",
      ID : "ENSG00000092201.10",
      gene_id : "ENSG00000092201.10",
      gene_type : "protein_coding",
      gene_name : "SUPT16H",
      gene_level : 2,
      hgnc_id : "HGNC:11465",
      havana_gene : "OTTHUMG00000029685.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21385194,
      stop : 21456126,
      direction : "-",
      ID : "ENSG00000100888.15",
      gene_id : "ENSG00000100888.15",
      gene_type : "protein_coding",
      gene_name : "CHD8",
      gene_level : 1,
      hgnc_id : "HGNC:20153",
      havana_gene : "OTTHUMG00000170759.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21459020,
      stop : 21476960,
      direction : "-",
      ID : "ENSG00000129472.15",
      gene_id : "ENSG00000129472.15",
      gene_type : "protein_coding",
      gene_name : "RAB2B",
      gene_level : 2,
      hgnc_id : "HGNC:20246",
      havana_gene : "OTTHUMG00000029693.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21476597,
      stop : 21499175,
      direction : "+",
      ID : "ENSG00000092203.15",
      gene_id : "ENSG00000092203.15",
      gene_type : "protein_coding",
      gene_name : "TOX4",
      gene_level : 1,
      hgnc_id : "HGNC:20161",
      havana_gene : "OTTHUMG00000150278.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21498133,
      stop : 21511342,
      direction : "-",
      ID : "ENSG00000165819.12",
      gene_id : "ENSG00000165819.12",
      gene_type : "protein_coding",
      gene_name : "METTL3",
      gene_level : 1,
      hgnc_id : "HGNC:17563",
      havana_gene : "OTTHUMG00000168825.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21521080,
      stop : 21537216,
      direction : "-",
      ID : "ENSG00000165821.12",
      gene_id : "ENSG00000165821.12",
      gene_type : "protein_coding",
      gene_name : "SALL2",
      gene_level : 1,
      hgnc_id : "HGNC:10526",
      havana_gene : "OTTHUMG00000168826.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21568520,
      stop : 21580076,
      direction : "-",
      ID : "ENSG00000169208.3",
      gene_id : "ENSG00000169208.3",
      gene_type : "protein_coding",
      gene_name : "OR10G3",
      gene_level : 2,
      hgnc_id : "HGNC:8171",
      havana_gene : "OTTHUMG00000168886.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21633836,
      stop : 21634940,
      direction : "-",
      ID : "ENSG00000255582.1",
      gene_id : "ENSG00000255582.1",
      gene_type : "protein_coding",
      gene_name : "OR10G2",
      gene_level : 2,
      hgnc_id : "HGNC:8170",
      havana_gene : "OTTHUMG00000168890.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21653835,
      stop : 21667642,
      direction : "+",
      ID : "ENSG00000221977.2",
      gene_id : "ENSG00000221977.2",
      gene_type : "protein_coding",
      gene_name : "OR4E2",
      gene_level : 2,
      hgnc_id : "HGNC:8297",
      havana_gene : "OTTHUMG00000168979.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 21667940,
      stop : 21673818,
      direction : "-",
      ID : "ENSG00000276240.2",
      gene_id : "ENSG00000276240.2",
      gene_type : "protein_coding",
      gene_name : "OR4E1",
      gene_level : 2,
      hgnc_id : "HGNC:8296",
      havana_gene : "OTTHUMG00000188249.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22564907,
      stop : 22589224,
      direction : "-",
      ID : "ENSG00000129562.11",
      gene_id : "ENSG00000129562.11",
      gene_type : "protein_coding",
      gene_name : "DAD1",
      gene_level : 1,
      hgnc_id : "HGNC:2664",
      havana_gene : "OTTHUMG00000028685.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22598237,
      stop : 22613215,
      direction : "+",
      ID : "ENSG00000100439.10",
      gene_id : "ENSG00000100439.10",
      gene_type : "protein_coding",
      gene_name : "ABHD4",
      gene_level : 1,
      hgnc_id : "HGNC:20154",
      havana_gene : "OTTHUMG00000028686.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22630929,
      stop : 22644352,
      direction : "-",
      ID : "ENSG00000255804.2",
      gene_id : "ENSG00000255804.2",
      gene_type : "protein_coding",
      gene_name : "OR6J1",
      gene_level : 2,
      hgnc_id : "HGNC:14707",
      havana_gene : "OTTHUMG00000168897.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22766522,
      stop : 22773042,
      direction : "+",
      ID : "ENSG00000155463.14",
      gene_id : "ENSG00000155463.14",
      gene_type : "protein_coding",
      gene_name : "OXA1L",
      gene_level : 1,
      hgnc_id : "HGNC:8526",
      havana_gene : "OTTHUMG00000028691.11",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22773222,
      stop : 22829820,
      direction : "-",
      ID : "ENSG00000155465.20",
      gene_id : "ENSG00000155465.20",
      gene_type : "protein_coding",
      gene_name : "SLC7A7",
      gene_level : 1,
      hgnc_id : "HGNC:11065",
      havana_gene : "OTTHUMG00000028692.14",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22829879,
      stop : 22835037,
      direction : "+",
      ID : "ENSG00000172590.18",
      gene_id : "ENSG00000172590.18",
      gene_type : "protein_coding",
      gene_name : "MRPL52",
      gene_level : 1,
      hgnc_id : "HGNC:16655",
      havana_gene : "OTTHUMG00000028703.11",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22836560,
      stop : 22849041,
      direction : "+",
      ID : "ENSG00000157227.14",
      gene_id : "ENSG00000157227.14",
      gene_type : "protein_coding",
      gene_name : "MMP14",
      gene_level : 1,
      hgnc_id : "HGNC:7160",
      havana_gene : "OTTHUMG00000028704.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22871740,
      stop : 22881713,
      direction : "+",
      ID : "ENSG00000197324.9",
      gene_id : "ENSG00000197324.9",
      gene_type : "protein_coding",
      gene_name : "LRP10",
      gene_level : 2,
      hgnc_id : "HGNC:14553",
      havana_gene : "OTTHUMG00000028705.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22883222,
      stop : 22887678,
      direction : "+",
      ID : "ENSG00000139890.10",
      gene_id : "ENSG00000139890.10",
      gene_type : "protein_coding",
      gene_name : "REM2",
      gene_level : 1,
      hgnc_id : "HGNC:20248",
      havana_gene : "OTTHUMG00000170277.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22893204,
      stop : 22919182,
      direction : "-",
      ID : "ENSG00000100461.18",
      gene_id : "ENSG00000100461.18",
      gene_type : "protein_coding",
      gene_name : "RBM23",
      gene_level : 1,
      hgnc_id : "HGNC:20155",
      havana_gene : "OTTHUMG00000171467.10",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22920525,
      stop : 22929408,
      direction : "-",
      ID : "ENSG00000100462.16",
      gene_id : "ENSG00000100462.16",
      gene_type : "protein_coding",
      gene_name : "PRMT5",
      gene_level : 1,
      hgnc_id : "HGNC:10894",
      havana_gene : "OTTHUMG00000028709.11",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22946228,
      stop : 22957161,
      direction : "-",
      ID : "ENSG00000092036.19",
      gene_id : "ENSG00000092036.19",
      gene_type : "protein_coding",
      gene_name : "HAUS4",
      gene_level : 2,
      hgnc_id : "HGNC:20163",
      havana_gene : "OTTHUMG00000028710.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22946270,
      stop : 22982258,
      direction : "-",
      ID : "ENSG00000259132.1",
      gene_id : "ENSG00000259132.1",
      gene_type : "protein_coding",
      gene_name : "AL132780.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000171458.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22971177,
      stop : 22982551,
      direction : "-",
      ID : "ENSG00000129474.16",
      gene_id : "ENSG00000129474.16",
      gene_type : "protein_coding",
      gene_name : "AJUBA",
      gene_level : 1,
      hgnc_id : "HGNC:20250",
      havana_gene : "OTTHUMG00000028711.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 22985894,
      stop : 23010166,
      direction : "-",
      ID : "ENSG00000100802.15",
      gene_id : "ENSG00000100802.15",
      gene_type : "protein_coding",
      gene_name : "C14orf93",
      gene_level : 1,
      hgnc_id : "HGNC:20162",
      havana_gene : "OTTHUMG00000028712.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23016543,
      stop : 23035230,
      direction : "-",
      ID : "ENSG00000100804.19",
      gene_id : "ENSG00000100804.19",
      gene_type : "protein_coding",
      gene_name : "PSMB5",
      gene_level : 1,
      hgnc_id : "HGNC:9542",
      havana_gene : "OTTHUMG00000028713.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23042212,
      stop : 23044060,
      direction : "+",
      ID : "ENSG00000222028.5",
      gene_id : "ENSG00000222028.5",
      gene_type : "protein_coding",
      gene_name : "PSMB11",
      gene_level : 2,
      hgnc_id : "HGNC:31963",
      havana_gene : "OTTHUMG00000170279.3",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23047062,
      stop : 23057538,
      direction : "-",
      ID : "ENSG00000139880.19",
      gene_id : "ENSG00000139880.19",
      gene_type : "protein_coding",
      gene_name : "CDH24",
      gene_level : 2,
      hgnc_id : "HGNC:14265",
      havana_gene : "OTTHUMG00000028715.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23058564,
      stop : 23095614,
      direction : "-",
      ID : "ENSG00000100813.14",
      gene_id : "ENSG00000100813.14",
      gene_type : "protein_coding",
      gene_name : "ACIN1",
      gene_level : 2,
      hgnc_id : "HGNC:17066",
      havana_gene : "OTTHUMG00000028716.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23095505,
      stop : 23100456,
      direction : "+",
      ID : "ENSG00000179933.6",
      gene_id : "ENSG00000179933.6",
      gene_type : "protein_coding",
      gene_name : "C14orf119",
      gene_level : 2,
      hgnc_id : "HGNC:20270",
      havana_gene : "OTTHUMG00000028717.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23099062,
      stop : 23104989,
      direction : "-",
      ID : "ENSG00000283654.3",
      gene_id : "ENSG00000283654.3",
      gene_type : "protein_coding",
      gene_name : "LMLN2",
      gene_level : 2,
      hgnc_id : "HGNC:53647",
      havana_gene : "OTTHUMG00000191651.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23117306,
      stop : 23119255,
      direction : "-",
      ID : "ENSG00000092067.6",
      gene_id : "ENSG00000092067.6",
      gene_type : "protein_coding",
      gene_name : "CEBPE",
      gene_level : 2,
      hgnc_id : "HGNC:1836",
      havana_gene : "OTTHUMG00000028719.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23125295,
      stop : 23183674,
      direction : "-",
      ID : "ENSG00000092068.20",
      gene_id : "ENSG00000092068.20",
      gene_type : "protein_coding",
      gene_name : "SLC7A8",
      gene_level : 1,
      hgnc_id : "HGNC:11066",
      havana_gene : "OTTHUMG00000028720.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23185316,
      stop : 23273477,
      direction : "+",
      ID : "ENSG00000215277.8",
      gene_id : "ENSG00000215277.8",
      gene_type : "protein_coding",
      gene_name : "RNF212B",
      gene_level : 1,
      hgnc_id : "HGNC:20438",
      havana_gene : "OTTHUMG00000149918.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23272422,
      stop : 23299447,
      direction : "-",
      ID : "ENSG00000215271.9",
      gene_id : "ENSG00000215271.9",
      gene_type : "protein_coding",
      gene_name : "HOMEZ",
      gene_level : 2,
      hgnc_id : "HGNC:20164",
      havana_gene : "OTTHUMG00000172122.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23295652,
      stop : 23302859,
      direction : "-",
      ID : "ENSG00000235194.9",
      gene_id : "ENSG00000235194.9",
      gene_type : "protein_coding",
      gene_name : "PPP1R3E",
      gene_level : 2,
      hgnc_id : "HGNC:14943",
      havana_gene : "OTTHUMG00000172116.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23298790,
      stop : 23311751,
      direction : "+",
      ID : "ENSG00000129473.11",
      gene_id : "ENSG00000129473.11",
      gene_type : "protein_coding",
      gene_name : "BCL2L2",
      gene_level : 2,
      hgnc_id : "HGNC:995",
      havana_gene : "OTTHUMG00000028738.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23306833,
      stop : 23326175,
      direction : "+",
      ID : "ENSG00000258643.6",
      gene_id : "ENSG00000258643.6",
      gene_type : "protein_coding",
      gene_name : "BCL2L2-PABPN1",
      gene_level : 1,
      hgnc_id : "HGNC:42959",
      havana_gene : "OTTHUMG00000171498.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23321289,
      stop : 23326185,
      direction : "+",
      ID : "ENSG00000100836.10",
      gene_id : "ENSG00000100836.10",
      gene_type : "protein_coding",
      gene_name : "PABPN1",
      gene_level : 2,
      hgnc_id : "HGNC:8565",
      havana_gene : "OTTHUMG00000028739.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23346306,
      stop : 23352912,
      direction : "-",
      ID : "ENSG00000092096.18",
      gene_id : "ENSG00000092096.18",
      gene_type : "protein_coding",
      gene_name : "SLC22A17",
      gene_level : 2,
      hgnc_id : "HGNC:23095",
      havana_gene : "OTTHUMG00000028740.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23356403,
      stop : 23365752,
      direction : "-",
      ID : "ENSG00000100842.13",
      gene_id : "ENSG00000100842.13",
      gene_type : "protein_coding",
      gene_name : "EFS",
      gene_level : 2,
      hgnc_id : "HGNC:16898",
      havana_gene : "OTTHUMG00000028741.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23372809,
      stop : 23376403,
      direction : "+",
      ID : "ENSG00000166090.8",
      gene_id : "ENSG00000166090.8",
      gene_type : "protein_coding",
      gene_name : "IL25",
      gene_level : 2,
      hgnc_id : "HGNC:13765",
      havana_gene : "OTTHUMG00000028749.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23376773,
      stop : 23379772,
      direction : "+",
      ID : "ENSG00000166091.21",
      gene_id : "ENSG00000166091.21",
      gene_type : "protein_coding",
      gene_name : "CMTM5",
      gene_level : 2,
      hgnc_id : "HGNC:19176",
      havana_gene : "OTTHUMG00000028751.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23381982,
      stop : 23408273,
      direction : "-",
      ID : "ENSG00000197616.13",
      gene_id : "ENSG00000197616.13",
      gene_type : "protein_coding",
      gene_name : "MYH6",
      gene_level : 2,
      hgnc_id : "HGNC:7576",
      havana_gene : "OTTHUMG00000028753.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23412740,
      stop : 23435660,
      direction : "-",
      ID : "ENSG00000092054.13",
      gene_id : "ENSG00000092054.13",
      gene_type : "protein_coding",
      gene_name : "MYH7",
      gene_level : 2,
      hgnc_id : "HGNC:7577",
      havana_gene : "OTTHUMG00000028755.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23469689,
      stop : 23509862,
      direction : "+",
      ID : "ENSG00000129460.16",
      gene_id : "ENSG00000129460.16",
      gene_type : "protein_coding",
      gene_name : "NGDN",
      gene_level : 1,
      hgnc_id : "HGNC:20271",
      havana_gene : "OTTHUMG00000171501.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23520857,
      stop : 23556192,
      direction : "-",
      ID : "ENSG00000136367.14",
      gene_id : "ENSG00000136367.14",
      gene_type : "protein_coding",
      gene_name : "ZFHX2",
      gene_level : 1,
      hgnc_id : "HGNC:20152",
      havana_gene : "OTTHUMG00000156894.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23555988,
      stop : 23560271,
      direction : "+",
      ID : "ENSG00000259431.6",
      gene_id : "ENSG00000259431.6",
      gene_type : "protein_coding",
      gene_name : "THTPA",
      gene_level : 2,
      hgnc_id : "HGNC:18987",
      havana_gene : "OTTHUMG00000172558.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23559565,
      stop : 23568070,
      direction : "-",
      ID : "ENSG00000213983.12",
      gene_id : "ENSG00000213983.12",
      gene_type : "protein_coding",
      gene_name : "AP1G2",
      gene_level : 2,
      hgnc_id : "HGNC:556",
      havana_gene : "OTTHUMG00000028760.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23568035,
      stop : 23578790,
      direction : "-",
      ID : "ENSG00000092051.17",
      gene_id : "ENSG00000092051.17",
      gene_type : "protein_coding",
      gene_name : "JPH4",
      gene_level : 1,
      hgnc_id : "HGNC:20156",
      havana_gene : "OTTHUMG00000028769.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23630115,
      stop : 23645639,
      direction : "+",
      ID : "ENSG00000100867.15",
      gene_id : "ENSG00000100867.15",
      gene_type : "protein_coding",
      gene_name : "DHRS2",
      gene_level : 2,
      hgnc_id : "HGNC:18349",
      havana_gene : "OTTHUMG00000028771.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23953734,
      stop : 23969279,
      direction : "+",
      ID : "ENSG00000157326.19",
      gene_id : "ENSG00000157326.19",
      gene_type : "protein_coding",
      gene_name : "DHRS4",
      gene_level : 2,
      hgnc_id : "HGNC:16985",
      havana_gene : "OTTHUMG00000028777.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 23969874,
      stop : 24006408,
      direction : "+",
      ID : "ENSG00000187630.17",
      gene_id : "ENSG00000187630.17",
      gene_type : "protein_coding",
      gene_name : "DHRS4L2",
      gene_level : 2,
      hgnc_id : "HGNC:19731",
      havana_gene : "OTTHUMG00000028778.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24052009,
      stop : 24069729,
      direction : "+",
      ID : "ENSG00000186648.15",
      gene_id : "ENSG00000186648.15",
      gene_type : "protein_coding",
      gene_name : "CARMIL3",
      gene_level : 2,
      hgnc_id : "HGNC:20272",
      havana_gene : "OTTHUMG00000172023.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24070837,
      stop : 24078100,
      direction : "+",
      ID : "ENSG00000100884.9",
      gene_id : "ENSG00000100884.9",
      gene_type : "protein_coding",
      gene_name : "CPNE6",
      gene_level : 2,
      hgnc_id : "HGNC:2319",
      havana_gene : "OTTHUMG00000028781.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24078662,
      stop : 24115010,
      direction : "-",
      ID : "ENSG00000129535.13",
      gene_id : "ENSG00000129535.13",
      gene_type : "protein_coding",
      gene_name : "NRL",
      gene_level : 2,
      hgnc_id : "HGNC:8002",
      havana_gene : "OTTHUMG00000028789.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24094053,
      stop : 24110598,
      direction : "+",
      ID : "ENSG00000100889.12",
      gene_id : "ENSG00000100889.12",
      gene_type : "protein_coding",
      gene_name : "PCK2",
      gene_level : 1,
      hgnc_id : "HGNC:8725",
      havana_gene : "OTTHUMG00000028791.10",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24114195,
      stop : 24125242,
      direction : "+",
      ID : "ENSG00000100897.18",
      gene_id : "ENSG00000100897.18",
      gene_type : "protein_coding",
      gene_name : "DCAF11",
      gene_level : 1,
      hgnc_id : "HGNC:20258",
      havana_gene : "OTTHUMG00000028793.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24120956,
      stop : 24131829,
      direction : "+",
      ID : "ENSG00000259371.2",
      gene_id : "ENSG00000259371.2",
      gene_type : "protein_coding",
      gene_name : "AL136295.3",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172021.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24130659,
      stop : 24132849,
      direction : "+",
      ID : "ENSG00000139914.7",
      gene_id : "ENSG00000139914.7",
      gene_type : "protein_coding",
      gene_name : "FITM1",
      gene_level : 2,
      hgnc_id : "HGNC:33714",
      havana_gene : "OTTHUMG00000133476.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24136163,
      stop : 24138967,
      direction : "+",
      ID : "ENSG00000092010.15",
      gene_id : "ENSG00000092010.15",
      gene_type : "protein_coding",
      gene_name : "PSME1",
      gene_level : 2,
      hgnc_id : "HGNC:9568",
      havana_gene : "OTTHUMG00000028795.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24138959,
      stop : 24141591,
      direction : "-",
      ID : "ENSG00000100908.14",
      gene_id : "ENSG00000100908.14",
      gene_type : "protein_coding",
      gene_name : "EMC9",
      gene_level : 1,
      hgnc_id : "HGNC:20273",
      havana_gene : "OTTHUMG00000028796.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24143362,
      stop : 24147570,
      direction : "-",
      ID : "ENSG00000100911.16",
      gene_id : "ENSG00000100911.16",
      gene_type : "protein_coding",
      gene_name : "PSME2",
      gene_level : 2,
      hgnc_id : "HGNC:9569",
      havana_gene : "OTTHUMG00000028797.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24146683,
      stop : 24160660,
      direction : "+",
      ID : "ENSG00000092098.17",
      gene_id : "ENSG00000092098.17",
      gene_type : "protein_coding",
      gene_name : "RNF31",
      gene_level : 1,
      hgnc_id : "HGNC:16031",
      havana_gene : "OTTHUMG00000028798.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24147548,
      stop : 24166452,
      direction : "+",
      ID : "ENSG00000259529.2",
      gene_id : "ENSG00000259529.2",
      gene_type : "protein_coding",
      gene_name : "AL136295.5",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000171951.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24161265,
      stop : 24166565,
      direction : "+",
      ID : "ENSG00000213928.9",
      gene_id : "ENSG00000213928.9",
      gene_type : "protein_coding",
      gene_name : "IRF9",
      gene_level : 1,
      hgnc_id : "HGNC:6131",
      havana_gene : "OTTHUMG00000028799.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24171853,
      stop : 24180257,
      direction : "+",
      ID : "ENSG00000100918.13",
      gene_id : "ENSG00000100918.13",
      gene_type : "protein_coding",
      gene_name : "REC8",
      gene_level : 2,
      hgnc_id : "HGNC:16879",
      havana_gene : "OTTHUMG00000171916.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24180219,
      stop : 24188869,
      direction : "-",
      ID : "ENSG00000196497.17",
      gene_id : "ENSG00000196497.17",
      gene_type : "protein_coding",
      gene_name : "IPO4",
      gene_level : 2,
      hgnc_id : "HGNC:19426",
      havana_gene : "OTTHUMG00000028801.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24180395,
      stop : 24190416,
      direction : "-",
      ID : "ENSG00000259522.3",
      gene_id : "ENSG00000259522.3",
      gene_type : "protein_coding",
      gene_name : "AL136295.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170680.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24189149,
      stop : 24195687,
      direction : "-",
      ID : "ENSG00000100926.15",
      gene_id : "ENSG00000100926.15",
      gene_type : "protein_coding",
      gene_name : "TM9SF1",
      gene_level : 1,
      hgnc_id : "HGNC:11864",
      havana_gene : "OTTHUMG00000029322.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24189157,
      stop : 24213473,
      direction : "-",
      ID : "ENSG00000254692.1",
      gene_id : "ENSG00000254692.1",
      gene_type : "protein_coding",
      gene_name : "AL136295.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167035.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24205696,
      stop : 24208362,
      direction : "+",
      ID : "ENSG00000139908.15",
      gene_id : "ENSG00000139908.15",
      gene_type : "protein_coding",
      gene_name : "TSSK4",
      gene_level : 1,
      hgnc_id : "HGNC:19825",
      havana_gene : "OTTHUMG00000029323.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24209615,
      stop : 24213830,
      direction : "-",
      ID : "ENSG00000254505.11",
      gene_id : "ENSG00000254505.11",
      gene_type : "protein_coding",
      gene_name : "CHMP4A",
      gene_level : 1,
      hgnc_id : "HGNC:20274",
      havana_gene : "OTTHUMG00000167036.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24213943,
      stop : 24216070,
      direction : "-",
      ID : "ENSG00000213920.9",
      gene_id : "ENSG00000213920.9",
      gene_type : "protein_coding",
      gene_name : "MDP1",
      gene_level : 2,
      hgnc_id : "HGNC:28781",
      havana_gene : "OTTHUMG00000133477.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24213955,
      stop : 24232352,
      direction : "-",
      ID : "ENSG00000255526.6",
      gene_id : "ENSG00000255526.6",
      gene_type : "protein_coding",
      gene_name : "NEDD8-MDP1",
      gene_level : 2,
      hgnc_id : "HGNC:39551",
      havana_gene : "OTTHUMG00000167107.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24216857,
      stop : 24232367,
      direction : "-",
      ID : "ENSG00000129559.13",
      gene_id : "ENSG00000129559.13",
      gene_type : "protein_coding",
      gene_name : "NEDD8",
      gene_level : 2,
      hgnc_id : "HGNC:7732",
      havana_gene : "OTTHUMG00000029325.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24232422,
      stop : 24239242,
      direction : "+",
      ID : "ENSG00000100938.18",
      gene_id : "ENSG00000100938.18",
      gene_type : "protein_coding",
      gene_name : "GMPR2",
      gene_level : 1,
      hgnc_id : "HGNC:4377",
      havana_gene : "OTTHUMG00000171912.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24239643,
      stop : 24242674,
      direction : "-",
      ID : "ENSG00000092330.18",
      gene_id : "ENSG00000092330.18",
      gene_type : "protein_coding",
      gene_name : "TINF2",
      gene_level : 1,
      hgnc_id : "HGNC:11824",
      havana_gene : "OTTHUMG00000171849.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24249114,
      stop : 24264432,
      direction : "-",
      ID : "ENSG00000092295.12",
      gene_id : "ENSG00000092295.12",
      gene_type : "protein_coding",
      gene_name : "TGM1",
      gene_level : 2,
      hgnc_id : "HGNC:11777",
      havana_gene : "OTTHUMG00000029329.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24265538,
      stop : 24271611,
      direction : "-",
      ID : "ENSG00000100949.15",
      gene_id : "ENSG00000100949.15",
      gene_type : "protein_coding",
      gene_name : "RABGGTA",
      gene_level : 1,
      hgnc_id : "HGNC:9795",
      havana_gene : "OTTHUMG00000171838.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24290598,
      stop : 24299780,
      direction : "-",
      ID : "ENSG00000157379.14",
      gene_id : "ENSG00000157379.14",
      gene_type : "protein_coding",
      gene_name : "DHRS1",
      gene_level : 2,
      hgnc_id : "HGNC:16445",
      havana_gene : "OTTHUMG00000029333.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24299850,
      stop : 24309124,
      direction : "+",
      ID : "ENSG00000196943.14",
      gene_id : "ENSG00000196943.14",
      gene_type : "protein_coding",
      gene_name : "NOP9",
      gene_level : 2,
      hgnc_id : "HGNC:19826",
      havana_gene : "OTTHUMG00000029342.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24305096,
      stop : 24311430,
      direction : "-",
      ID : "ENSG00000136305.11",
      gene_id : "ENSG00000136305.11",
      gene_type : "protein_coding",
      gene_name : "CIDEB",
      gene_level : 1,
      hgnc_id : "HGNC:1977",
      havana_gene : "OTTHUMG00000171555.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24305734,
      stop : 24312053,
      direction : "+",
      ID : "ENSG00000213906.10",
      gene_id : "ENSG00000213906.10",
      gene_type : "protein_coding",
      gene_name : "LTB4R2",
      gene_level : 2,
      hgnc_id : "HGNC:19260",
      havana_gene : "OTTHUMG00000186500.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24311450,
      stop : 24318036,
      direction : "+",
      ID : "ENSG00000213903.9",
      gene_id : "ENSG00000213903.9",
      gene_type : "protein_coding",
      gene_name : "LTB4R",
      gene_level : 2,
      hgnc_id : "HGNC:6713",
      havana_gene : "OTTHUMG00000029346.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24318349,
      stop : 24335093,
      direction : "-",
      ID : "ENSG00000129467.14",
      gene_id : "ENSG00000129467.14",
      gene_type : "protein_coding",
      gene_name : "ADCY4",
      gene_level : 2,
      hgnc_id : "HGNC:235",
      havana_gene : "OTTHUMG00000029347.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24336025,
      stop : 24340022,
      direction : "-",
      ID : "ENSG00000129465.16",
      gene_id : "ENSG00000129465.16",
      gene_type : "protein_coding",
      gene_name : "RIPK3",
      gene_level : 2,
      hgnc_id : "HGNC:10021",
      havana_gene : "OTTHUMG00000029349.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24365673,
      stop : 24379604,
      direction : "+",
      ID : "ENSG00000100968.14",
      gene_id : "ENSG00000100968.14",
      gene_type : "protein_coding",
      gene_name : "NFATC4",
      gene_level : 2,
      hgnc_id : "HGNC:7778",
      havana_gene : "OTTHUMG00000029351.13",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24399003,
      stop : 24419283,
      direction : "+",
      ID : "ENSG00000205978.6",
      gene_id : "ENSG00000205978.6",
      gene_type : "protein_coding",
      gene_name : "NYNRIN",
      gene_level : 2,
      hgnc_id : "HGNC:20165",
      havana_gene : "OTTHUMG00000171314.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24426545,
      stop : 24430954,
      direction : "-",
      ID : "ENSG00000139899.11",
      gene_id : "ENSG00000139899.11",
      gene_type : "protein_coding",
      gene_name : "CBLN3",
      gene_level : 1,
      hgnc_id : "HGNC:20146",
      havana_gene : "OTTHUMG00000171315.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24429286,
      stop : 24441843,
      direction : "+",
      ID : "ENSG00000100441.10",
      gene_id : "ENSG00000100441.10",
      gene_type : "protein_coding",
      gene_name : "KHNYN",
      gene_level : 1,
      hgnc_id : "HGNC:20166",
      havana_gene : "OTTHUMG00000171312.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24439766,
      stop : 24442905,
      direction : "-",
      ID : "ENSG00000100445.17",
      gene_id : "ENSG00000100445.17",
      gene_type : "protein_coding",
      gene_name : "SDR39U1",
      gene_level : 1,
      hgnc_id : "HGNC:20275",
      havana_gene : "OTTHUMG00000171316.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24505353,
      stop : 24508265,
      direction : "-",
      ID : "ENSG00000092009.10",
      gene_id : "ENSG00000092009.10",
      gene_type : "protein_coding",
      gene_name : "CMA1",
      gene_level : 1,
      hgnc_id : "HGNC:2097",
      havana_gene : "OTTHUMG00000140181.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24573518,
      stop : 24576250,
      direction : "-",
      ID : "ENSG00000100448.4",
      gene_id : "ENSG00000100448.4",
      gene_type : "protein_coding",
      gene_name : "CTSG",
      gene_level : 2,
      hgnc_id : "HGNC:2532",
      havana_gene : "OTTHUMG00000140182.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24606480,
      stop : 24609699,
      direction : "-",
      ID : "ENSG00000100450.13",
      gene_id : "ENSG00000100450.13",
      gene_type : "protein_coding",
      gene_name : "GZMH",
      gene_level : 1,
      hgnc_id : "HGNC:4710",
      havana_gene : "OTTHUMG00000140185.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24630954,
      stop : 24634267,
      direction : "-",
      ID : "ENSG00000100453.13",
      gene_id : "ENSG00000100453.13",
      gene_type : "protein_coding",
      gene_name : "GZMB",
      gene_level : 1,
      hgnc_id : "HGNC:4709",
      havana_gene : "OTTHUMG00000029369.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 24809656,
      stop : 25050297,
      direction : "-",
      ID : "ENSG00000168952.15",
      gene_id : "ENSG00000168952.15",
      gene_type : "protein_coding",
      gene_name : "STXBP6",
      gene_level : 2,
      hgnc_id : "HGNC:19666",
      havana_gene : "OTTHUMG00000140186.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 26443090,
      stop : 26598033,
      direction : "-",
      ID : "ENSG00000139910.20",
      gene_id : "ENSG00000139910.20",
      gene_type : "protein_coding",
      gene_name : "NOVA1",
      gene_level : 1,
      hgnc_id : "HGNC:7886",
      havana_gene : "OTTHUMG00000029385.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 28766787,
      stop : 28770277,
      direction : "+",
      ID : "ENSG00000176165.12",
      gene_id : "ENSG00000176165.12",
      gene_type : "protein_coding",
      gene_name : "FOXG1",
      gene_level : 2,
      hgnc_id : "HGNC:3811",
      havana_gene : "OTTHUMG00000196007.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 29576479,
      stop : 30191898,
      direction : "-",
      ID : "ENSG00000184304.16",
      gene_id : "ENSG00000184304.16",
      gene_type : "protein_coding",
      gene_name : "PRKD1",
      gene_level : 2,
      hgnc_id : "HGNC:9407",
      havana_gene : "OTTHUMG00000140203.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 30559158,
      stop : 30620064,
      direction : "+",
      ID : "ENSG00000092140.16",
      gene_id : "ENSG00000092140.16",
      gene_type : "protein_coding",
      gene_name : "G2E3",
      gene_level : 2,
      hgnc_id : "HGNC:20338",
      havana_gene : "OTTHUMG00000140204.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 30622291,
      stop : 30737694,
      direction : "+",
      ID : "ENSG00000092108.22",
      gene_id : "ENSG00000092108.22",
      gene_type : "protein_coding",
      gene_name : "SCFD1",
      gene_level : 1,
      hgnc_id : "HGNC:20726",
      havana_gene : "OTTHUMG00000029420.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 30874514,
      stop : 30895065,
      direction : "+",
      ID : "ENSG00000100473.18",
      gene_id : "ENSG00000100473.18",
      gene_type : "protein_coding",
      gene_name : "COCH",
      gene_level : 1,
      hgnc_id : "HGNC:2180",
      havana_gene : "OTTHUMG00000029432.10",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 30893799,
      stop : 31026401,
      direction : "-",
      ID : "ENSG00000196792.12",
      gene_id : "ENSG00000196792.12",
      gene_type : "protein_coding",
      gene_name : "STRN3",
      gene_level : 1,
      hgnc_id : "HGNC:15720",
      havana_gene : "OTTHUMG00000140201.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31025106,
      stop : 31130996,
      direction : "+",
      ID : "ENSG00000100478.15",
      gene_id : "ENSG00000100478.15",
      gene_type : "protein_coding",
      gene_name : "AP4S1",
      gene_level : 2,
      hgnc_id : "HGNC:575",
      havana_gene : "OTTHUMG00000140202.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31100112,
      stop : 31207804,
      direction : "-",
      ID : "ENSG00000092148.13",
      gene_id : "ENSG00000092148.13",
      gene_type : "protein_coding",
      gene_name : "HECTD1",
      gene_level : 1,
      hgnc_id : "HGNC:20157",
      havana_gene : "OTTHUMG00000170670.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31291788,
      stop : 31420550,
      direction : "-",
      ID : "ENSG00000129493.15",
      gene_id : "ENSG00000129493.15",
      gene_type : "protein_coding",
      gene_name : "HEATR5A",
      gene_level : 1,
      hgnc_id : "HGNC:20276",
      havana_gene : "OTTHUMG00000169043.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31334312,
      stop : 31457441,
      direction : "-",
      ID : "ENSG00000203546.7",
      gene_id : "ENSG00000203546.7",
      gene_type : "protein_coding",
      gene_name : "AL139353.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000169042.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31446036,
      stop : 31457506,
      direction : "-",
      ID : "ENSG00000129480.13",
      gene_id : "ENSG00000129480.13",
      gene_type : "protein_coding",
      gene_name : "DTD2",
      gene_level : 2,
      hgnc_id : "HGNC:20277",
      havana_gene : "OTTHUMG00000140205.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31482875,
      stop : 31488039,
      direction : "-",
      ID : "ENSG00000214943.5",
      gene_id : "ENSG00000214943.5",
      gene_type : "protein_coding",
      gene_name : "GPR33",
      gene_level : 2,
      hgnc_id : "HGNC:4489",
      havana_gene : "OTTHUMG00000154921.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 31489956,
      stop : 31861224,
      direction : "+",
      ID : "ENSG00000151413.17",
      gene_id : "ENSG00000151413.17",
      gene_type : "protein_coding",
      gene_name : "NUBPL",
      gene_level : 1,
      hgnc_id : "HGNC:20278",
      havana_gene : "OTTHUMG00000170521.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 32076114,
      stop : 32159728,
      direction : "+",
      ID : "ENSG00000100852.13",
      gene_id : "ENSG00000100852.13",
      gene_type : "protein_coding",
      gene_name : "ARHGAP5",
      gene_level : 2,
      hgnc_id : "HGNC:675",
      havana_gene : "OTTHUMG00000170589.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 32329298,
      stop : 32837684,
      direction : "+",
      ID : "ENSG00000151320.11",
      gene_id : "ENSG00000151320.11",
      gene_type : "protein_coding",
      gene_name : "AKAP6",
      gene_level : 1,
      hgnc_id : "HGNC:376",
      havana_gene : "OTTHUMG00000140207.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 32934396,
      stop : 33820863,
      direction : "+",
      ID : "ENSG00000151322.20",
      gene_id : "ENSG00000151322.20",
      gene_type : "protein_coding",
      gene_name : "NPAS3",
      gene_level : 1,
      hgnc_id : "HGNC:19311",
      havana_gene : "OTTHUMG00000140215.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 33924227,
      stop : 34462774,
      direction : "-",
      ID : "ENSG00000129521.15",
      gene_id : "ENSG00000129521.15",
      gene_type : "protein_coding",
      gene_name : "EGLN3",
      gene_level : 1,
      hgnc_id : "HGNC:14661",
      havana_gene : "OTTHUMG00000029498.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 34432788,
      stop : 34462240,
      direction : "-",
      ID : "ENSG00000165389.7",
      gene_id : "ENSG00000165389.7",
      gene_type : "protein_coding",
      gene_name : "SPTSSA",
      gene_level : 2,
      hgnc_id : "HGNC:20361",
      havana_gene : "OTTHUMG00000140212.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 34515938,
      stop : 34539711,
      direction : "-",
      ID : "ENSG00000129518.9",
      gene_id : "ENSG00000129518.9",
      gene_type : "protein_coding",
      gene_name : "EAPP",
      gene_level : 2,
      hgnc_id : "HGNC:19312",
      havana_gene : "OTTHUMG00000170621.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 34561093,
      stop : 34630160,
      direction : "-",
      ID : "ENSG00000129515.20",
      gene_id : "ENSG00000129515.20",
      gene_type : "protein_coding",
      gene_name : "SNX6",
      gene_level : 1,
      hgnc_id : "HGNC:14970",
      havana_gene : "OTTHUMG00000140213.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 34709113,
      stop : 34714823,
      direction : "-",
      ID : "ENSG00000165410.15",
      gene_id : "ENSG00000165410.15",
      gene_type : "protein_coding",
      gene_name : "CFL2",
      gene_level : 1,
      hgnc_id : "HGNC:1875",
      havana_gene : "OTTHUMG00000029536.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 34752731,
      stop : 34875647,
      direction : "-",
      ID : "ENSG00000198604.11",
      gene_id : "ENSG00000198604.11",
      gene_type : "protein_coding",
      gene_name : "BAZ1A",
      gene_level : 2,
      hgnc_id : "HGNC:960",
      havana_gene : "OTTHUMG00000140216.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 34981957,
      stop : 35029686,
      direction : "+",
      ID : "ENSG00000100883.13",
      gene_id : "ENSG00000100883.13",
      gene_type : "protein_coding",
      gene_name : "SRP54",
      gene_level : 2,
      hgnc_id : "HGNC:11301",
      havana_gene : "OTTHUMG00000140214.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35044907,
      stop : 35113130,
      direction : "+",
      ID : "ENSG00000151327.13",
      gene_id : "ENSG00000151327.13",
      gene_type : "protein_coding",
      gene_name : "FAM177A1",
      gene_level : 2,
      hgnc_id : "HGNC:19829",
      havana_gene : "OTTHUMG00000140217.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35085467,
      stop : 35122517,
      direction : "-",
      ID : "ENSG00000092020.11",
      gene_id : "ENSG00000092020.11",
      gene_type : "protein_coding",
      gene_name : "PPP2R3C",
      gene_level : 2,
      hgnc_id : "HGNC:17485",
      havana_gene : "OTTHUMG00000140224.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35121846,
      stop : 35277622,
      direction : "+",
      ID : "ENSG00000100890.16",
      gene_id : "ENSG00000100890.16",
      gene_type : "protein_coding",
      gene_name : "PRORP",
      gene_level : 1,
      hgnc_id : "HGNC:19958",
      havana_gene : "OTTHUMG00000170997.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35122549,
      stop : 35317474,
      direction : "+",
      ID : "ENSG00000258790.1",
      gene_id : "ENSG00000258790.1",
      gene_type : "protein_coding",
      gene_name : "AL121594.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171025.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35278633,
      stop : 35317493,
      direction : "+",
      ID : "ENSG00000100902.11",
      gene_id : "ENSG00000100902.11",
      gene_type : "protein_coding",
      gene_name : "PSMA6",
      gene_level : 2,
      hgnc_id : "HGNC:9535",
      havana_gene : "OTTHUMG00000140221.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35401513,
      stop : 35404749,
      direction : "-",
      ID : "ENSG00000100906.11",
      gene_id : "ENSG00000100906.11",
      gene_type : "protein_coding",
      gene_name : "NFKBIA",
      gene_level : 1,
      hgnc_id : "HGNC:7797",
      havana_gene : "OTTHUMG00000140220.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35534164,
      stop : 35537054,
      direction : "+",
      ID : "ENSG00000168348.4",
      gene_id : "ENSG00000168348.4",
      gene_type : "protein_coding",
      gene_name : "INSM2",
      gene_level : 2,
      hgnc_id : "HGNC:17539",
      havana_gene : "OTTHUMG00000140223.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35538352,
      stop : 35809304,
      direction : "-",
      ID : "ENSG00000174373.17",
      gene_id : "ENSG00000174373.17",
      gene_type : "protein_coding",
      gene_name : "RALGAPA1",
      gene_level : 1,
      hgnc_id : "HGNC:17770",
      havana_gene : "OTTHUMG00000170619.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 35826338,
      stop : 35932325,
      direction : "+",
      ID : "ENSG00000100916.14",
      gene_id : "ENSG00000100916.14",
      gene_type : "protein_coding",
      gene_name : "BRMS1L",
      gene_level : 2,
      hgnc_id : "HGNC:20512",
      havana_gene : "OTTHUMG00000170559.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 36298564,
      stop : 36320637,
      direction : "-",
      ID : "ENSG00000151332.19",
      gene_id : "ENSG00000151332.19",
      gene_type : "protein_coding",
      gene_name : "MBIP",
      gene_level : 1,
      hgnc_id : "HGNC:20427",
      havana_gene : "OTTHUMG00000140222.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 36473207,
      stop : 36521149,
      direction : "-",
      ID : "ENSG00000257520.2",
      gene_id : "ENSG00000257520.2",
      gene_type : "protein_coding",
      gene_name : "SFTA3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 36516392,
      stop : 36521149,
      direction : "-",
      ID : "ENSG00000136352.19",
      gene_id : "ENSG00000136352.19",
      gene_type : "protein_coding",
      gene_name : "NKX2-1",
      gene_level : 2,
      hgnc_id : "HGNC:11825",
      havana_gene : "OTTHUMG00000140225.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 36580004,
      stop : 36582614,
      direction : "-",
      ID : "ENSG00000136327.7",
      gene_id : "ENSG00000136327.7",
      gene_type : "protein_coding",
      gene_name : "NKX2-8",
      gene_level : 2,
      hgnc_id : "HGNC:16364",
      havana_gene : "OTTHUMG00000028772.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 36657568,
      stop : 36679362,
      direction : "+",
      ID : "ENSG00000198807.13",
      gene_id : "ENSG00000198807.13",
      gene_type : "protein_coding",
      gene_name : "PAX9",
      gene_level : 2,
      hgnc_id : "HGNC:8623",
      havana_gene : "OTTHUMG00000140251.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 36677921,
      stop : 37172606,
      direction : "-",
      ID : "ENSG00000183032.12",
      gene_id : "ENSG00000183032.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A21",
      gene_level : 2,
      hgnc_id : "HGNC:14411",
      havana_gene : "OTTHUMG00000140250.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 37197913,
      stop : 37552361,
      direction : "+",
      ID : "ENSG00000151338.18",
      gene_id : "ENSG00000151338.18",
      gene_type : "protein_coding",
      gene_name : "MIPOL1",
      gene_level : 1,
      hgnc_id : "HGNC:21460",
      havana_gene : "OTTHUMG00000140252.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 37589552,
      stop : 37596059,
      direction : "-",
      ID : "ENSG00000129514.8",
      gene_id : "ENSG00000129514.8",
      gene_type : "protein_coding",
      gene_name : "FOXA1",
      gene_level : 2,
      hgnc_id : "HGNC:5021",
      havana_gene : "OTTHUMG00000140253.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 37595847,
      stop : 38041442,
      direction : "+",
      ID : "ENSG00000139865.16",
      gene_id : "ENSG00000139865.16",
      gene_type : "protein_coding",
      gene_name : "TTC6",
      gene_level : 1,
      hgnc_id : "HGNC:19739",
      havana_gene : "OTTHUMG00000157369.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 38207904,
      stop : 38213067,
      direction : "+",
      ID : "ENSG00000139874.6",
      gene_id : "ENSG00000139874.6",
      gene_type : "protein_coding",
      gene_name : "SSTR1",
      gene_level : 2,
      hgnc_id : "HGNC:11330",
      havana_gene : "OTTHUMG00000140249.4",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 38254000,
      stop : 38256093,
      direction : "-",
      ID : "ENSG00000176435.7",
      gene_id : "ENSG00000176435.7",
      gene_type : "protein_coding",
      gene_name : "CLEC14A",
      gene_level : 2,
      hgnc_id : "HGNC:19832",
      havana_gene : "OTTHUMG00000140248.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 39031919,
      stop : 39109646,
      direction : "-",
      ID : "ENSG00000100934.15",
      gene_id : "ENSG00000100934.15",
      gene_type : "protein_coding",
      gene_name : "SEC23A",
      gene_level : 1,
      hgnc_id : "HGNC:10701",
      havana_gene : "OTTHUMG00000028812.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 39114223,
      stop : 39136973,
      direction : "+",
      ID : "ENSG00000092208.18",
      gene_id : "ENSG00000092208.18",
      gene_type : "protein_coding",
      gene_name : "GEMIN2",
      gene_level : 2,
      hgnc_id : "HGNC:10884",
      havana_gene : "OTTHUMG00000028816.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 39147811,
      stop : 39170532,
      direction : "-",
      ID : "ENSG00000182400.15",
      gene_id : "ENSG00000182400.15",
      gene_type : "protein_coding",
      gene_name : "TRAPPC6B",
      gene_level : 1,
      hgnc_id : "HGNC:23066",
      havana_gene : "OTTHUMG00000140259.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 39175183,
      stop : 39183220,
      direction : "+",
      ID : "ENSG00000100941.9",
      gene_id : "ENSG00000100941.9",
      gene_type : "protein_coding",
      gene_name : "PNN",
      gene_level : 2,
      hgnc_id : "HGNC:9162",
      havana_gene : "OTTHUMG00000028821.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 39230231,
      stop : 39388513,
      direction : "+",
      ID : "ENSG00000150527.17",
      gene_id : "ENSG00000150527.17",
      gene_type : "protein_coding",
      gene_name : "MIA2",
      gene_level : 2,
      hgnc_id : "HGNC:18432",
      havana_gene : "OTTHUMG00000028831.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 39397669,
      stop : 39432500,
      direction : "-",
      ID : "ENSG00000165355.7",
      gene_id : "ENSG00000165355.7",
      gene_type : "protein_coding",
      gene_name : "FBXO33",
      gene_level : 2,
      hgnc_id : "HGNC:19833",
      havana_gene : "OTTHUMG00000140257.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 41606876,
      stop : 41904549,
      direction : "+",
      ID : "ENSG00000165379.14",
      gene_id : "ENSG00000165379.14",
      gene_type : "protein_coding",
      gene_name : "LRFN5",
      gene_level : 2,
      hgnc_id : "HGNC:20360",
      havana_gene : "OTTHUMG00000140261.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 44504149,
      stop : 44507283,
      direction : "-",
      ID : "ENSG00000189139.6",
      gene_id : "ENSG00000189139.6",
      gene_type : "protein_coding",
      gene_name : "FSCB",
      gene_level : 2,
      hgnc_id : "HGNC:20494",
      havana_gene : "OTTHUMG00000140262.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 44897275,
      stop : 44907257,
      direction : "+",
      ID : "ENSG00000179476.8",
      gene_id : "ENSG00000179476.8",
      gene_type : "protein_coding",
      gene_name : "C14orf28",
      gene_level : 1,
      hgnc_id : "HGNC:19834",
      havana_gene : "OTTHUMG00000170722.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 44924324,
      stop : 45042322,
      direction : "-",
      ID : "ENSG00000179454.14",
      gene_id : "ENSG00000179454.14",
      gene_type : "protein_coding",
      gene_name : "KLHL28",
      gene_level : 1,
      hgnc_id : "HGNC:19741",
      havana_gene : "OTTHUMG00000140263.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 44962190,
      stop : 45074431,
      direction : "+",
      ID : "ENSG00000198718.13",
      gene_id : "ENSG00000198718.13",
      gene_type : "protein_coding",
      gene_name : "TOGARAM1",
      gene_level : 1,
      hgnc_id : "HGNC:19959",
      havana_gene : "OTTHUMG00000140264.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 45084107,
      stop : 45116282,
      direction : "+",
      ID : "ENSG00000185246.18",
      gene_id : "ENSG00000185246.18",
      gene_type : "protein_coding",
      gene_name : "PRPF39",
      gene_level : 2,
      hgnc_id : "HGNC:20314",
      havana_gene : "OTTHUMG00000140265.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 45115599,
      stop : 45135319,
      direction : "-",
      ID : "ENSG00000100442.11",
      gene_id : "ENSG00000100442.11",
      gene_type : "protein_coding",
      gene_name : "FKBP3",
      gene_level : 2,
      hgnc_id : "HGNC:3719",
      havana_gene : "OTTHUMG00000140267.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 45135930,
      stop : 45200890,
      direction : "+",
      ID : "ENSG00000187790.11",
      gene_id : "ENSG00000187790.11",
      gene_type : "protein_coding",
      gene_name : "FANCM",
      gene_level : 1,
      hgnc_id : "HGNC:23168",
      havana_gene : "OTTHUMG00000170807.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 45203190,
      stop : 45253540,
      direction : "-",
      ID : "ENSG00000129534.14",
      gene_id : "ENSG00000129534.14",
      gene_type : "protein_coding",
      gene_name : "MIS18BP1",
      gene_level : 2,
      hgnc_id : "HGNC:20190",
      havana_gene : "OTTHUMG00000140266.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 46651010,
      stop : 46651781,
      direction : "-",
      ID : "ENSG00000165496.5",
      gene_id : "ENSG00000165496.5",
      gene_type : "protein_coding",
      gene_name : "RPL10L",
      gene_level : 2,
      hgnc_id : "HGNC:17976",
      havana_gene : "OTTHUMG00000157869.3",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 46839629,
      stop : 47675605,
      direction : "-",
      ID : "ENSG00000139915.21",
      gene_id : "ENSG00000139915.21",
      gene_type : "protein_coding",
      gene_name : "MDGA2",
      gene_level : 2,
      hgnc_id : "HGNC:19835",
      havana_gene : "OTTHUMG00000029429.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49570984,
      stop : 49599164,
      direction : "-",
      ID : "ENSG00000213741.11",
      gene_id : "ENSG00000213741.11",
      gene_type : "protein_coding",
      gene_name : "RPS29",
      gene_level : 1,
      hgnc_id : "HGNC:10419",
      havana_gene : "OTTHUMG00000140272.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49598761,
      stop : 49614672,
      direction : "+",
      ID : "ENSG00000165501.17",
      gene_id : "ENSG00000165501.17",
      gene_type : "protein_coding",
      gene_name : "LRR1",
      gene_level : 1,
      hgnc_id : "HGNC:19742",
      havana_gene : "OTTHUMG00000140273.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49618530,
      stop : 49620626,
      direction : "-",
      ID : "ENSG00000165502.7",
      gene_id : "ENSG00000165502.7",
      gene_type : "protein_coding",
      gene_name : "RPL36AL",
      gene_level : 2,
      hgnc_id : "HGNC:10346",
      havana_gene : "OTTHUMG00000152330.3",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49620799,
      stop : 49623481,
      direction : "+",
      ID : "ENSG00000168282.6",
      gene_id : "ENSG00000168282.6",
      gene_type : "protein_coding",
      gene_name : "MGAT2",
      gene_level : 2,
      hgnc_id : "HGNC:7045",
      havana_gene : "OTTHUMG00000140271.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49625174,
      stop : 49635244,
      direction : "-",
      ID : "ENSG00000165506.15",
      gene_id : "ENSG00000165506.15",
      gene_type : "protein_coding",
      gene_name : "DNAAF2",
      gene_level : 2,
      hgnc_id : "HGNC:20188",
      havana_gene : "OTTHUMG00000152331.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49643555,
      stop : 49688422,
      direction : "-",
      ID : "ENSG00000100479.13",
      gene_id : "ENSG00000100479.13",
      gene_type : "protein_coding",
      gene_name : "POLE2",
      gene_level : 2,
      hgnc_id : "HGNC:9178",
      havana_gene : "OTTHUMG00000170813.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49693105,
      stop : 49753150,
      direction : "+",
      ID : "ENSG00000197776.8",
      gene_id : "ENSG00000197776.8",
      gene_type : "protein_coding",
      gene_name : "KLHDC1",
      gene_level : 2,
      hgnc_id : "HGNC:19836",
      havana_gene : "OTTHUMG00000140295.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49768130,
      stop : 49786385,
      direction : "+",
      ID : "ENSG00000165516.11",
      gene_id : "ENSG00000165516.11",
      gene_type : "protein_coding",
      gene_name : "KLHDC2",
      gene_level : 1,
      hgnc_id : "HGNC:20231",
      havana_gene : "OTTHUMG00000140288.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49782083,
      stop : 49852821,
      direction : "-",
      ID : "ENSG00000165525.18",
      gene_id : "ENSG00000165525.18",
      gene_type : "protein_coding",
      gene_name : "NEMF",
      gene_level : 2,
      hgnc_id : "HGNC:10663",
      havana_gene : "OTTHUMG00000170857.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 49893082,
      stop : 49897054,
      direction : "+",
      ID : "ENSG00000165527.7",
      gene_id : "ENSG00000165527.7",
      gene_type : "protein_coding",
      gene_name : "ARF6",
      gene_level : 2,
      hgnc_id : "HGNC:659",
      havana_gene : "OTTHUMG00000140296.3",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50108632,
      stop : 50116600,
      direction : "-",
      ID : "ENSG00000100483.14",
      gene_id : "ENSG00000100483.14",
      gene_type : "protein_coding",
      gene_name : "VCPKMT",
      gene_level : 2,
      hgnc_id : "HGNC:20352",
      havana_gene : "OTTHUMG00000029531.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50117130,
      stop : 50231578,
      direction : "-",
      ID : "ENSG00000100485.12",
      gene_id : "ENSG00000100485.12",
      gene_type : "protein_coding",
      gene_name : "SOS2",
      gene_level : 1,
      hgnc_id : "HGNC:11188",
      havana_gene : "OTTHUMG00000140292.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50237563,
      stop : 50312229,
      direction : "-",
      ID : "ENSG00000087299.12",
      gene_id : "ENSG00000087299.12",
      gene_type : "protein_coding",
      gene_name : "L2HGDH",
      gene_level : 1,
      hgnc_id : "HGNC:20499",
      havana_gene : "OTTHUMG00000140289.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50312324,
      stop : 50335558,
      direction : "+",
      ID : "ENSG00000125375.17",
      gene_id : "ENSG00000125375.17",
      gene_type : "protein_coding",
      gene_name : "DMAC2L",
      gene_level : 2,
      hgnc_id : "HGNC:18799",
      havana_gene : "OTTHUMG00000170866.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50326265,
      stop : 50416461,
      direction : "-",
      ID : "ENSG00000100490.10",
      gene_id : "ENSG00000100490.10",
      gene_type : "protein_coding",
      gene_name : "CDKL1",
      gene_level : 1,
      hgnc_id : "HGNC:1781",
      havana_gene : "OTTHUMG00000140290.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50418501,
      stop : 50561126,
      direction : "-",
      ID : "ENSG00000012983.11",
      gene_id : "ENSG00000012983.11",
      gene_type : "protein_coding",
      gene_name : "MAP4K5",
      gene_level : 2,
      hgnc_id : "HGNC:6867",
      havana_gene : "OTTHUMG00000170888.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50532509,
      stop : 50634017,
      direction : "+",
      ID : "ENSG00000198513.13",
      gene_id : "ENSG00000198513.13",
      gene_type : "protein_coding",
      gene_name : "ATL1",
      gene_level : 2,
      hgnc_id : "HGNC:11231",
      havana_gene : "OTTHUMG00000140297.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50632058,
      stop : 50668306,
      direction : "-",
      ID : "ENSG00000151748.15",
      gene_id : "ENSG00000151748.15",
      gene_type : "protein_coding",
      gene_name : "SAV1",
      gene_level : 1,
      hgnc_id : "HGNC:17795",
      havana_gene : "OTTHUMG00000140293.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50719763,
      stop : 50831162,
      direction : "-",
      ID : "ENSG00000100503.26",
      gene_id : "ENSG00000100503.26",
      gene_type : "protein_coding",
      gene_name : "NIN",
      gene_level : 2,
      hgnc_id : "HGNC:14906",
      havana_gene : "OTTHUMG00000029569.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50857891,
      stop : 50944483,
      direction : "-",
      ID : "ENSG00000100504.17",
      gene_id : "ENSG00000100504.17",
      gene_type : "protein_coding",
      gene_name : "PYGL",
      gene_level : 1,
      hgnc_id : "HGNC:9725",
      havana_gene : "OTTHUMG00000166596.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50872053,
      stop : 50904970,
      direction : "+",
      ID : "ENSG00000131969.15",
      gene_id : "ENSG00000131969.15",
      gene_type : "protein_coding",
      gene_name : "ABHD12B",
      gene_level : 2,
      hgnc_id : "HGNC:19837",
      havana_gene : "OTTHUMG00000140286.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 50975262,
      stop : 51096061,
      direction : "-",
      ID : "ENSG00000100505.13",
      gene_id : "ENSG00000100505.13",
      gene_type : "protein_coding",
      gene_name : "TRIM9",
      gene_level : 1,
      hgnc_id : "HGNC:16288",
      havana_gene : "OTTHUMG00000140291.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 51240162,
      stop : 51257655,
      direction : "+",
      ID : "ENSG00000139921.13",
      gene_id : "ENSG00000139921.13",
      gene_type : "protein_coding",
      gene_name : "TMX1",
      gene_level : 2,
      hgnc_id : "HGNC:15487",
      havana_gene : "OTTHUMG00000171003.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 51489100,
      stop : 51730727,
      direction : "+",
      ID : "ENSG00000139926.16",
      gene_id : "ENSG00000139926.16",
      gene_type : "protein_coding",
      gene_name : "FRMD6",
      gene_level : 1,
      hgnc_id : "HGNC:19839",
      havana_gene : "OTTHUMG00000140294.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 51826195,
      stop : 51979342,
      direction : "+",
      ID : "ENSG00000186469.8",
      gene_id : "ENSG00000186469.8",
      gene_type : "protein_coding",
      gene_name : "GNG2",
      gene_level : 2,
      hgnc_id : "HGNC:4404",
      havana_gene : "OTTHUMG00000171083.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 51989514,
      stop : 52010694,
      direction : "+",
      ID : "ENSG00000087302.9",
      gene_id : "ENSG00000087302.9",
      gene_type : "protein_coding",
      gene_name : "RTRAF",
      gene_level : 2,
      hgnc_id : "HGNC:23169",
      havana_gene : "OTTHUMG00000152332.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52004803,
      stop : 52069228,
      direction : "-",
      ID : "ENSG00000087303.18",
      gene_id : "ENSG00000087303.18",
      gene_type : "protein_coding",
      gene_name : "NID2",
      gene_level : 2,
      hgnc_id : "HGNC:13389",
      havana_gene : "OTTHUMG00000140298.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52267698,
      stop : 52276724,
      direction : "+",
      ID : "ENSG00000168229.4",
      gene_id : "ENSG00000168229.4",
      gene_type : "protein_coding",
      gene_name : "PTGDR",
      gene_level : 1,
      hgnc_id : "HGNC:9591",
      havana_gene : "OTTHUMG00000140299.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52314305,
      stop : 52328598,
      direction : "+",
      ID : "ENSG00000125384.7",
      gene_id : "ENSG00000125384.7",
      gene_type : "protein_coding",
      gene_name : "PTGER2",
      gene_level : 2,
      hgnc_id : "HGNC:9594",
      havana_gene : "OTTHUMG00000140300.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52430596,
      stop : 52552522,
      direction : "-",
      ID : "ENSG00000087301.9",
      gene_id : "ENSG00000087301.9",
      gene_type : "protein_coding",
      gene_name : "TXNDC16",
      gene_level : 2,
      hgnc_id : "HGNC:19965",
      havana_gene : "OTTHUMG00000171103.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52552836,
      stop : 52637713,
      direction : "+",
      ID : "ENSG00000180998.12",
      gene_id : "ENSG00000180998.12",
      gene_type : "protein_coding",
      gene_name : "GPR137C",
      gene_level : 2,
      hgnc_id : "HGNC:25445",
      havana_gene : "OTTHUMG00000171104.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52639915,
      stop : 52695900,
      direction : "-",
      ID : "ENSG00000197930.13",
      gene_id : "ENSG00000197930.13",
      gene_type : "protein_coding",
      gene_name : "ERO1A",
      gene_level : 2,
      hgnc_id : "HGNC:13280",
      havana_gene : "OTTHUMG00000140301.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52707178,
      stop : 52728590,
      direction : "+",
      ID : "ENSG00000100519.12",
      gene_id : "ENSG00000100519.12",
      gene_type : "protein_coding",
      gene_name : "PSMC6",
      gene_level : 2,
      hgnc_id : "HGNC:9553",
      havana_gene : "OTTHUMG00000152333.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52730166,
      stop : 52774989,
      direction : "+",
      ID : "ENSG00000198252.12",
      gene_id : "ENSG00000198252.12",
      gene_type : "protein_coding",
      gene_name : "STYX",
      gene_level : 2,
      hgnc_id : "HGNC:11447",
      havana_gene : "OTTHUMG00000140306.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52775193,
      stop : 52791668,
      direction : "-",
      ID : "ENSG00000100522.10",
      gene_id : "ENSG00000100522.10",
      gene_type : "protein_coding",
      gene_name : "GNPNAT1",
      gene_level : 1,
      hgnc_id : "HGNC:19980",
      havana_gene : "OTTHUMG00000152334.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 52857268,
      stop : 52952435,
      direction : "-",
      ID : "ENSG00000073712.15",
      gene_id : "ENSG00000073712.15",
      gene_type : "protein_coding",
      gene_name : "FERMT2",
      gene_level : 1,
      hgnc_id : "HGNC:15767",
      havana_gene : "OTTHUMG00000140309.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 53036745,
      stop : 53153323,
      direction : "-",
      ID : "ENSG00000100523.16",
      gene_id : "ENSG00000100523.16",
      gene_type : "protein_coding",
      gene_name : "DDHD1",
      gene_level : 1,
      hgnc_id : "HGNC:19714",
      havana_gene : "OTTHUMG00000140305.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 53949736,
      stop : 53958761,
      direction : "-",
      ID : "ENSG00000125378.16",
      gene_id : "ENSG00000125378.16",
      gene_type : "protein_coding",
      gene_name : "BMP4",
      gene_level : 1,
      hgnc_id : "HGNC:1071",
      havana_gene : "OTTHUMG00000140303.5",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54396849,
      stop : 54420218,
      direction : "+",
      ID : "ENSG00000100526.20",
      gene_id : "ENSG00000100526.20",
      gene_type : "protein_coding",
      gene_name : "CDKN3",
      gene_level : 1,
      hgnc_id : "HGNC:1791",
      havana_gene : "OTTHUMG00000140302.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54423561,
      stop : 54441391,
      direction : "-",
      ID : "ENSG00000100528.12",
      gene_id : "ENSG00000100528.12",
      gene_type : "protein_coding",
      gene_name : "CNIH1",
      gene_level : 1,
      hgnc_id : "HGNC:19431",
      havana_gene : "OTTHUMG00000152335.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54474484,
      stop : 54489026,
      direction : "-",
      ID : "ENSG00000197045.13",
      gene_id : "ENSG00000197045.13",
      gene_type : "protein_coding",
      gene_name : "GMFB",
      gene_level : 2,
      hgnc_id : "HGNC:4373",
      havana_gene : "OTTHUMG00000140307.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54509812,
      stop : 54539292,
      direction : "+",
      ID : "ENSG00000100532.13",
      gene_id : "ENSG00000100532.13",
      gene_type : "protein_coding",
      gene_name : "CGRRF1",
      gene_level : 2,
      hgnc_id : "HGNC:15528",
      havana_gene : "OTTHUMG00000140308.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54566117,
      stop : 54793315,
      direction : "+",
      ID : "ENSG00000020577.14",
      gene_id : "ENSG00000020577.14",
      gene_type : "protein_coding",
      gene_name : "SAMD4A",
      gene_level : 1,
      hgnc_id : "HGNC:23023",
      havana_gene : "OTTHUMG00000170999.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54842008,
      stop : 54902826,
      direction : "-",
      ID : "ENSG00000131979.20",
      gene_id : "ENSG00000131979.20",
      gene_type : "protein_coding",
      gene_name : "GCH1",
      gene_level : 1,
      hgnc_id : "HGNC:4193",
      havana_gene : "OTTHUMG00000029754.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 54938949,
      stop : 55027105,
      direction : "-",
      ID : "ENSG00000198554.12",
      gene_id : "ENSG00000198554.12",
      gene_type : "protein_coding",
      gene_name : "WDHD1",
      gene_level : 2,
      hgnc_id : "HGNC:23170",
      havana_gene : "OTTHUMG00000140304.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55027230,
      stop : 55049489,
      direction : "+",
      ID : "ENSG00000180008.9",
      gene_id : "ENSG00000180008.9",
      gene_type : "protein_coding",
      gene_name : "SOCS4",
      gene_level : 1,
      hgnc_id : "HGNC:19392",
      havana_gene : "OTTHUMG00000140311.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55051647,
      stop : 55070194,
      direction : "+",
      ID : "ENSG00000168175.15",
      gene_id : "ENSG00000168175.15",
      gene_type : "protein_coding",
      gene_name : "MAPK1IP1L",
      gene_level : 1,
      hgnc_id : "HGNC:19840",
      havana_gene : "OTTHUMG00000171029.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55124110,
      stop : 55145423,
      direction : "+",
      ID : "ENSG00000131981.16",
      gene_id : "ENSG00000131981.16",
      gene_type : "protein_coding",
      gene_name : "LGALS3",
      gene_level : 1,
      hgnc_id : "HGNC:6563",
      havana_gene : "OTTHUMG00000171030.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55148112,
      stop : 55191608,
      direction : "-",
      ID : "ENSG00000126787.13",
      gene_id : "ENSG00000126787.13",
      gene_type : "protein_coding",
      gene_name : "DLGAP5",
      gene_level : 1,
      hgnc_id : "HGNC:16864",
      havana_gene : "OTTHUMG00000140310.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55271344,
      stop : 55370053,
      direction : "+",
      ID : "ENSG00000178974.11",
      gene_id : "ENSG00000178974.11",
      gene_type : "protein_coding",
      gene_name : "FBXO34",
      gene_level : 2,
      hgnc_id : "HGNC:20201",
      havana_gene : "OTTHUMG00000171033.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55366391,
      stop : 55411830,
      direction : "-",
      ID : "ENSG00000126775.9",
      gene_id : "ENSG00000126775.9",
      gene_type : "protein_coding",
      gene_name : "ATG14",
      gene_level : 2,
      hgnc_id : "HGNC:19962",
      havana_gene : "OTTHUMG00000172129.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55413541,
      stop : 55456726,
      direction : "-",
      ID : "ENSG00000182521.5",
      gene_id : "ENSG00000182521.5",
      gene_type : "protein_coding",
      gene_name : "TBPL2",
      gene_level : 2,
      hgnc_id : "HGNC:19841",
      havana_gene : "OTTHUMG00000140313.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 55559072,
      stop : 55701526,
      direction : "+",
      ID : "ENSG00000126777.18",
      gene_id : "ENSG00000126777.18",
      gene_type : "protein_coding",
      gene_name : "KTN1",
      gene_level : 1,
      hgnc_id : "HGNC:6467",
      havana_gene : "OTTHUMG00000140312.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 56117814,
      stop : 56301524,
      direction : "+",
      ID : "ENSG00000139946.10",
      gene_id : "ENSG00000139946.10",
      gene_type : "protein_coding",
      gene_name : "PELI2",
      gene_level : 2,
      hgnc_id : "HGNC:8828",
      havana_gene : "OTTHUMG00000152336.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 56488354,
      stop : 56650606,
      direction : "+",
      ID : "ENSG00000070269.14",
      gene_id : "ENSG00000070269.14",
      gene_type : "protein_coding",
      gene_name : "TMEM260",
      gene_level : 1,
      hgnc_id : "HGNC:20185",
      havana_gene : "OTTHUMG00000152337.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 56799905,
      stop : 56816693,
      direction : "-",
      ID : "ENSG00000165588.18",
      gene_id : "ENSG00000165588.18",
      gene_type : "protein_coding",
      gene_name : "OTX2",
      gene_level : 2,
      hgnc_id : "HGNC:8522",
      havana_gene : "OTTHUMG00000152338.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 57200507,
      stop : 57268905,
      direction : "-",
      ID : "ENSG00000070367.16",
      gene_id : "ENSG00000070367.16",
      gene_type : "protein_coding",
      gene_name : "EXOC5",
      gene_level : 1,
      hgnc_id : "HGNC:10696",
      havana_gene : "OTTHUMG00000171309.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 57268924,
      stop : 57298742,
      direction : "+",
      ID : "ENSG00000053770.12",
      gene_id : "ENSG00000053770.12",
      gene_type : "protein_coding",
      gene_name : "AP5M1",
      gene_level : 1,
      hgnc_id : "HGNC:20192",
      havana_gene : "OTTHUMG00000140318.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 57390544,
      stop : 57415906,
      direction : "+",
      ID : "ENSG00000139977.14",
      gene_id : "ENSG00000139977.14",
      gene_type : "protein_coding",
      gene_name : "NAA30",
      gene_level : 1,
      hgnc_id : "HGNC:19844",
      havana_gene : "OTTHUMG00000171311.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 57469300,
      stop : 57493867,
      direction : "-",
      ID : "ENSG00000100557.10",
      gene_id : "ENSG00000100557.10",
      gene_type : "protein_coding",
      gene_name : "CCDC198",
      gene_level : 1,
      hgnc_id : "HGNC:20189",
      havana_gene : "OTTHUMG00000140317.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 57563920,
      stop : 57982194,
      direction : "-",
      ID : "ENSG00000151812.15",
      gene_id : "ENSG00000151812.15",
      gene_type : "protein_coding",
      gene_name : "SLC35F4",
      gene_level : 1,
      hgnc_id : "HGNC:19845",
      havana_gene : "OTTHUMG00000171317.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 57999735,
      stop : 58298139,
      direction : "-",
      ID : "ENSG00000139971.15",
      gene_id : "ENSG00000139971.15",
      gene_type : "protein_coding",
      gene_name : "ARMH4",
      gene_level : 1,
      hgnc_id : "HGNC:19846",
      havana_gene : "OTTHUMG00000171173.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58200080,
      stop : 58235636,
      direction : "+",
      ID : "ENSG00000131966.14",
      gene_id : "ENSG00000131966.14",
      gene_type : "protein_coding",
      gene_name : "ACTR10",
      gene_level : 2,
      hgnc_id : "HGNC:17372",
      havana_gene : "OTTHUMG00000171049.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58244843,
      stop : 58272012,
      direction : "+",
      ID : "ENSG00000100567.13",
      gene_id : "ENSG00000100567.13",
      gene_type : "protein_coding",
      gene_name : "PSMA3",
      gene_level : 2,
      hgnc_id : "HGNC:9532",
      havana_gene : "OTTHUMG00000140319.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58298504,
      stop : 58373887,
      direction : "+",
      ID : "ENSG00000032219.19",
      gene_id : "ENSG00000032219.19",
      gene_type : "protein_coding",
      gene_name : "ARID4A",
      gene_level : 1,
      hgnc_id : "HGNC:9885",
      havana_gene : "OTTHUMG00000140320.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58395928,
      stop : 58408702,
      direction : "+",
      ID : "ENSG00000196860.8",
      gene_id : "ENSG00000196860.8",
      gene_type : "protein_coding",
      gene_name : "TOMM20L",
      gene_level : 2,
      hgnc_id : "HGNC:33752",
      havana_gene : "OTTHUMG00000140323.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58408495,
      stop : 58427531,
      direction : "-",
      ID : "ENSG00000100575.14",
      gene_id : "ENSG00000100575.14",
      gene_type : "protein_coding",
      gene_name : "TIMM9",
      gene_level : 1,
      hgnc_id : "HGNC:11819",
      havana_gene : "OTTHUMG00000140322.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58427385,
      stop : 58551297,
      direction : "+",
      ID : "ENSG00000100578.18",
      gene_id : "ENSG00000100578.18",
      gene_type : "protein_coding",
      gene_name : "KIAA0586",
      gene_level : 1,
      hgnc_id : "HGNC:19960",
      havana_gene : "OTTHUMG00000171141.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 58633967,
      stop : 58648321,
      direction : "+",
      ID : "ENSG00000165617.15",
      gene_id : "ENSG00000165617.15",
      gene_type : "protein_coding",
      gene_name : "DACT1",
      gene_level : 1,
      hgnc_id : "HGNC:17748",
      havana_gene : "OTTHUMG00000140324.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59188646,
      stop : 59371405,
      direction : "+",
      ID : "ENSG00000100592.16",
      gene_id : "ENSG00000100592.16",
      gene_type : "protein_coding",
      gene_name : "DAAM1",
      gene_level : 2,
      hgnc_id : "HGNC:18142",
      havana_gene : "OTTHUMG00000140326.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59429022,
      stop : 59465342,
      direction : "-",
      ID : "ENSG00000181619.11",
      gene_id : "ENSG00000181619.11",
      gene_type : "protein_coding",
      gene_name : "GPR135",
      gene_level : 2,
      hgnc_id : "HGNC:19991",
      havana_gene : "OTTHUMG00000140325.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59460363,
      stop : 59484408,
      direction : "-",
      ID : "ENSG00000126790.12",
      gene_id : "ENSG00000126790.12",
      gene_type : "protein_coding",
      gene_name : "L3HYPDH",
      gene_level : 1,
      hgnc_id : "HGNC:20488",
      havana_gene : "OTTHUMG00000028941.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59484443,
      stop : 59505410,
      direction : "+",
      ID : "ENSG00000050130.18",
      gene_id : "ENSG00000050130.18",
      gene_type : "protein_coding",
      gene_name : "JKAMP",
      gene_level : 2,
      hgnc_id : "HGNC:20184",
      havana_gene : "OTTHUMG00000171054.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59504539,
      stop : 59576812,
      direction : "-",
      ID : "ENSG00000151838.12",
      gene_id : "ENSG00000151838.12",
      gene_type : "protein_coding",
      gene_name : "CCDC175",
      gene_level : 2,
      hgnc_id : "HGNC:19847",
      havana_gene : "OTTHUMG00000171096.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59595976,
      stop : 59870776,
      direction : "-",
      ID : "ENSG00000139970.17",
      gene_id : "ENSG00000139970.17",
      gene_type : "protein_coding",
      gene_name : "RTN1",
      gene_level : 1,
      hgnc_id : "HGNC:10467",
      havana_gene : "OTTHUMG00000028947.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 59919713,
      stop : 60063559,
      direction : "+",
      ID : "ENSG00000131951.11",
      gene_id : "ENSG00000131951.11",
      gene_type : "protein_coding",
      gene_name : "LRRC9",
      gene_level : 2,
      hgnc_id : "HGNC:19848",
      havana_gene : "OTTHUMG00000028948.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60091911,
      stop : 60169133,
      direction : "+",
      ID : "ENSG00000126773.13",
      gene_id : "ENSG00000126773.13",
      gene_type : "protein_coding",
      gene_name : "PCNX4",
      gene_level : 2,
      hgnc_id : "HGNC:20349",
      havana_gene : "OTTHUMG00000150361.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60144119,
      stop : 60169856,
      direction : "-",
      ID : "ENSG00000100612.14",
      gene_id : "ENSG00000100612.14",
      gene_type : "protein_coding",
      gene_name : "DHRS7",
      gene_level : 1,
      hgnc_id : "HGNC:21524",
      havana_gene : "OTTHUMG00000140331.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60245752,
      stop : 60299087,
      direction : "+",
      ID : "ENSG00000100614.18",
      gene_id : "ENSG00000100614.18",
      gene_type : "protein_coding",
      gene_name : "PPM1A",
      gene_level : 1,
      hgnc_id : "HGNC:9275",
      havana_gene : "OTTHUMG00000140333.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60396469,
      stop : 60515543,
      direction : "-",
      ID : "ENSG00000179008.9",
      gene_id : "ENSG00000179008.9",
      gene_type : "protein_coding",
      gene_name : "C14orf39",
      gene_level : 2,
      hgnc_id : "HGNC:19849",
      havana_gene : "OTTHUMG00000140332.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60509146,
      stop : 60512850,
      direction : "+",
      ID : "ENSG00000184302.7",
      gene_id : "ENSG00000184302.7",
      gene_type : "protein_coding",
      gene_name : "SIX6",
      gene_level : 2,
      hgnc_id : "HGNC:10892",
      havana_gene : "OTTHUMG00000152339.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60643421,
      stop : 60658259,
      direction : "-",
      ID : "ENSG00000126778.12",
      gene_id : "ENSG00000126778.12",
      gene_type : "protein_coding",
      gene_name : "SIX1",
      gene_level : 1,
      hgnc_id : "HGNC:10887",
      havana_gene : "OTTHUMG00000140334.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60709539,
      stop : 60724351,
      direction : "-",
      ID : "ENSG00000100625.9",
      gene_id : "ENSG00000100625.9",
      gene_type : "protein_coding",
      gene_name : "SIX4",
      gene_level : 1,
      hgnc_id : "HGNC:10890",
      havana_gene : "OTTHUMG00000028996.10",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60734742,
      stop : 60969965,
      direction : "+",
      ID : "ENSG00000020426.11",
      gene_id : "ENSG00000020426.11",
      gene_type : "protein_coding",
      gene_name : "MNAT1",
      gene_level : 1,
      hgnc_id : "HGNC:7181",
      havana_gene : "OTTHUMG00000152340.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60971441,
      stop : 60981170,
      direction : "-",
      ID : "ENSG00000126814.7",
      gene_id : "ENSG00000126814.7",
      gene_type : "protein_coding",
      gene_name : "TRMT5",
      gene_level : 1,
      hgnc_id : "HGNC:23141",
      havana_gene : "OTTHUMG00000171294.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 60981114,
      stop : 61083733,
      direction : "+",
      ID : "ENSG00000139974.16",
      gene_id : "ENSG00000139974.16",
      gene_type : "protein_coding",
      gene_name : "SLC38A6",
      gene_level : 2,
      hgnc_id : "HGNC:19863",
      havana_gene : "OTTHUMG00000140335.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 61187559,
      stop : 61550976,
      direction : "+",
      ID : "ENSG00000027075.15",
      gene_id : "ENSG00000027075.15",
      gene_type : "protein_coding",
      gene_name : "PRKCH",
      gene_level : 1,
      hgnc_id : "HGNC:9403",
      havana_gene : "OTTHUMG00000152341.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 61277370,
      stop : 61281761,
      direction : "-",
      ID : "ENSG00000182107.7",
      gene_id : "ENSG00000182107.7",
      gene_type : "protein_coding",
      gene_name : "TMEM30B",
      gene_level : 2,
      hgnc_id : "HGNC:27254",
      havana_gene : "OTTHUMG00000171426.2",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 61529128,
      stop : 61657964,
      direction : "+",
      ID : "ENSG00000258989.1",
      gene_id : "ENSG00000258989.1",
      gene_type : "protein_coding",
      gene_name : "AL355916.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171533.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 61695513,
      stop : 61748259,
      direction : "+",
      ID : "ENSG00000100644.17",
      gene_id : "ENSG00000100644.17",
      gene_type : "protein_coding",
      gene_name : "HIF1A",
      gene_level : 1,
      hgnc_id : "HGNC:4910",
      havana_gene : "OTTHUMG00000140344.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 61762420,
      stop : 61796428,
      direction : "+",
      ID : "ENSG00000023608.5",
      gene_id : "ENSG00000023608.5",
      gene_type : "protein_coding",
      gene_name : "SNAPC1",
      gene_level : 2,
      hgnc_id : "HGNC:11134",
      havana_gene : "OTTHUMG00000140343.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 61811974,
      stop : 62112550,
      direction : "+",
      ID : "ENSG00000139973.16",
      gene_id : "ENSG00000139973.16",
      gene_type : "protein_coding",
      gene_name : "SYT16",
      gene_level : 1,
      hgnc_id : "HGNC:23142",
      havana_gene : "OTTHUMG00000171106.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 62699464,
      stop : 63102037,
      direction : "-",
      ID : "ENSG00000140015.20",
      gene_id : "ENSG00000140015.20",
      gene_type : "protein_coding",
      gene_name : "KCNH5",
      gene_level : 2,
      hgnc_id : "HGNC:6254",
      havana_gene : "OTTHUMG00000029041.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 63204114,
      stop : 63293508,
      direction : "+",
      ID : "ENSG00000126785.13",
      gene_id : "ENSG00000126785.13",
      gene_type : "protein_coding",
      gene_name : "RHOJ",
      gene_level : 2,
      hgnc_id : "HGNC:688",
      havana_gene : "OTTHUMG00000140342.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 63312835,
      stop : 63318935,
      direction : "-",
      ID : "ENSG00000179600.4",
      gene_id : "ENSG00000179600.4",
      gene_type : "protein_coding",
      gene_name : "GPHB5",
      gene_level : 2,
      hgnc_id : "HGNC:18055",
      havana_gene : "OTTHUMG00000168678.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 63371364,
      stop : 63543377,
      direction : "-",
      ID : "ENSG00000154001.14",
      gene_id : "ENSG00000154001.14",
      gene_type : "protein_coding",
      gene_name : "PPP2R5E",
      gene_level : 1,
      hgnc_id : "HGNC:9313",
      havana_gene : "OTTHUMG00000140341.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 63597039,
      stop : 63641871,
      direction : "-",
      ID : "ENSG00000140006.12",
      gene_id : "ENSG00000140006.12",
      gene_type : "protein_coding",
      gene_name : "WDR89",
      gene_level : 2,
      hgnc_id : "HGNC:20489",
      havana_gene : "OTTHUMG00000140340.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 63684216,
      stop : 63728065,
      direction : "-",
      ID : "ENSG00000126821.8",
      gene_id : "ENSG00000126821.8",
      gene_type : "protein_coding",
      gene_name : "SGPP1",
      gene_level : 2,
      hgnc_id : "HGNC:17720",
      havana_gene : "OTTHUMG00000029080.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 63761899,
      stop : 64226433,
      direction : "+",
      ID : "ENSG00000054654.19",
      gene_id : "ENSG00000054654.19",
      gene_type : "protein_coding",
      gene_name : "SYNE2",
      gene_level : 1,
      hgnc_id : "HGNC:17084",
      havana_gene : "OTTHUMG00000140349.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64084232,
      stop : 64338112,
      direction : "-",
      ID : "ENSG00000140009.19",
      gene_id : "ENSG00000140009.19",
      gene_type : "protein_coding",
      gene_name : "ESR2",
      gene_level : 1,
      hgnc_id : "HGNC:3468",
      havana_gene : "OTTHUMG00000141306.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64388031,
      stop : 64463457,
      direction : "+",
      ID : "ENSG00000100714.17",
      gene_id : "ENSG00000100714.17",
      gene_type : "protein_coding",
      gene_name : "MTHFD1",
      gene_level : 1,
      hgnc_id : "HGNC:7432",
      havana_gene : "OTTHUMG00000141309.15",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64449106,
      stop : 64505213,
      direction : "-",
      ID : "ENSG00000089775.12",
      gene_id : "ENSG00000089775.12",
      gene_type : "protein_coding",
      gene_name : "ZBTB25",
      gene_level : 1,
      hgnc_id : "HGNC:13112",
      havana_gene : "OTTHUMG00000141310.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64465499,
      stop : 64474503,
      direction : "+",
      ID : "ENSG00000179841.8",
      gene_id : "ENSG00000179841.8",
      gene_type : "protein_coding",
      gene_name : "AKAP5",
      gene_level : 2,
      hgnc_id : "HGNC:375",
      havana_gene : "OTTHUMG00000029634.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64503712,
      stop : 64533690,
      direction : "+",
      ID : "ENSG00000126804.13",
      gene_id : "ENSG00000126804.13",
      gene_type : "protein_coding",
      gene_name : "ZBTB1",
      gene_level : 2,
      hgnc_id : "HGNC:20259",
      havana_gene : "OTTHUMG00000171147.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64535905,
      stop : 64546173,
      direction : "+",
      ID : "ENSG00000126803.9",
      gene_id : "ENSG00000126803.9",
      gene_type : "protein_coding",
      gene_name : "HSPA2",
      gene_level : 2,
      hgnc_id : "HGNC:5235",
      havana_gene : "OTTHUMG00000141311.4",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64549920,
      stop : 64589381,
      direction : "+",
      ID : "ENSG00000165807.8",
      gene_id : "ENSG00000165807.8",
      gene_type : "protein_coding",
      gene_name : "PPP1R36",
      gene_level : 2,
      hgnc_id : "HGNC:20097",
      havana_gene : "OTTHUMG00000141316.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64704102,
      stop : 64750249,
      direction : "+",
      ID : "ENSG00000126822.17",
      gene_id : "ENSG00000126822.17",
      gene_type : "protein_coding",
      gene_name : "PLEKHG3",
      gene_level : 1,
      hgnc_id : "HGNC:20364",
      havana_gene : "OTTHUMG00000029671.12",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64746283,
      stop : 64879907,
      direction : "-",
      ID : "ENSG00000070182.21",
      gene_id : "ENSG00000070182.21",
      gene_type : "protein_coding",
      gene_name : "SPTB",
      gene_level : 1,
      hgnc_id : "HGNC:11274",
      havana_gene : "OTTHUMG00000171550.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64914361,
      stop : 64944591,
      direction : "+",
      ID : "ENSG00000258289.9",
      gene_id : "ENSG00000258289.9",
      gene_type : "protein_coding",
      gene_name : "CHURC1",
      gene_level : 1,
      hgnc_id : "HGNC:20099",
      havana_gene : "OTTHUMG00000170218.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64914485,
      stop : 65061803,
      direction : "+",
      ID : "ENSG00000125954.12",
      gene_id : "ENSG00000125954.12",
      gene_type : "protein_coding",
      gene_name : "CHURC1-FNTB",
      gene_level : 2,
      hgnc_id : "HGNC:42960",
      havana_gene : "OTTHUMG00000170219.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64939152,
      stop : 64942905,
      direction : "-",
      ID : "ENSG00000176153.12",
      gene_id : "ENSG00000176153.12",
      gene_type : "protein_coding",
      gene_name : "GPX2",
      gene_level : 2,
      hgnc_id : "HGNC:4554",
      havana_gene : "OTTHUMG00000171677.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64945814,
      stop : 64973226,
      direction : "-",
      ID : "ENSG00000139998.16",
      gene_id : "ENSG00000139998.16",
      gene_type : "protein_coding",
      gene_name : "RAB15",
      gene_level : 2,
      hgnc_id : "HGNC:20150",
      havana_gene : "OTTHUMG00000142810.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 64986895,
      stop : 65062652,
      direction : "+",
      ID : "ENSG00000257365.8",
      gene_id : "ENSG00000257365.8",
      gene_type : "protein_coding",
      gene_name : "FNTB",
      gene_level : 1,
      hgnc_id : "HGNC:3785",
      havana_gene : "OTTHUMG00000142811.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 65006174,
      stop : 65102695,
      direction : "-",
      ID : "ENSG00000125952.20",
      gene_id : "ENSG00000125952.20",
      gene_type : "protein_coding",
      gene_name : "MAX",
      gene_level : 1,
      hgnc_id : "HGNC:6913",
      havana_gene : "OTTHUMG00000142809.12",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 65410592,
      stop : 65744121,
      direction : "+",
      ID : "ENSG00000033170.17",
      gene_id : "ENSG00000033170.17",
      gene_type : "protein_coding",
      gene_name : "FUT8",
      gene_level : 1,
      hgnc_id : "HGNC:4019",
      havana_gene : "OTTHUMG00000142818.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 66411704,
      stop : 66498677,
      direction : "+",
      ID : "ENSG00000196553.15",
      gene_id : "ENSG00000196553.15",
      gene_type : "protein_coding",
      gene_name : "CCDC196",
      gene_level : 2,
      hgnc_id : "HGNC:20100",
      havana_gene : "OTTHUMG00000029779.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 66507407,
      stop : 67181803,
      direction : "+",
      ID : "ENSG00000171723.16",
      gene_id : "ENSG00000171723.16",
      gene_type : "protein_coding",
      gene_name : "GPHN",
      gene_level : 2,
      hgnc_id : "HGNC:15465",
      havana_gene : "OTTHUMG00000029785.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67189393,
      stop : 67228550,
      direction : "+",
      ID : "ENSG00000172717.16",
      gene_id : "ENSG00000172717.16",
      gene_type : "protein_coding",
      gene_name : "FAM71D",
      gene_level : 1,
      hgnc_id : "HGNC:20101",
      havana_gene : "OTTHUMG00000142819.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67240713,
      stop : 67336061,
      direction : "+",
      ID : "ENSG00000072415.10",
      gene_id : "ENSG00000072415.10",
      gene_type : "protein_coding",
      gene_name : "MPP5",
      gene_level : 2,
      hgnc_id : "HGNC:18669",
      havana_gene : "OTTHUMG00000171243.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67294371,
      stop : 67360265,
      direction : "-",
      ID : "ENSG00000100554.12",
      gene_id : "ENSG00000100554.12",
      gene_type : "protein_coding",
      gene_name : "ATP6V1D",
      gene_level : 1,
      hgnc_id : "HGNC:13527",
      havana_gene : "OTTHUMG00000171244.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67360328,
      stop : 67386516,
      direction : "+",
      ID : "ENSG00000134001.15",
      gene_id : "ENSG00000134001.15",
      gene_type : "protein_coding",
      gene_name : "EIF2S1",
      gene_level : 2,
      hgnc_id : "HGNC:3265",
      havana_gene : "OTTHUMG00000029800.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67386984,
      stop : 67412167,
      direction : "-",
      ID : "ENSG00000100558.9",
      gene_id : "ENSG00000100558.9",
      gene_type : "protein_coding",
      gene_name : "PLEK2",
      gene_level : 1,
      hgnc_id : "HGNC:19238",
      havana_gene : "OTTHUMG00000171247.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67447084,
      stop : 67533739,
      direction : "-",
      ID : "ENSG00000198133.8",
      gene_id : "ENSG00000198133.8",
      gene_type : "protein_coding",
      gene_name : "TMEM229B",
      gene_level : 2,
      hgnc_id : "HGNC:20130",
      havana_gene : "OTTHUMG00000171270.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67533290,
      stop : 67589612,
      direction : "+",
      ID : "ENSG00000054690.14",
      gene_id : "ENSG00000054690.14",
      gene_type : "protein_coding",
      gene_name : "PLEKHH1",
      gene_level : 2,
      hgnc_id : "HGNC:17733",
      havana_gene : "OTTHUMG00000171272.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67581955,
      stop : 67600286,
      direction : "-",
      ID : "ENSG00000100564.9",
      gene_id : "ENSG00000100564.9",
      gene_type : "protein_coding",
      gene_name : "PIGH",
      gene_level : 1,
      hgnc_id : "HGNC:8964",
      havana_gene : "OTTHUMG00000171806.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67619920,
      stop : 67651708,
      direction : "+",
      ID : "ENSG00000081181.8",
      gene_id : "ENSG00000081181.8",
      gene_type : "protein_coding",
      gene_name : "ARG2",
      gene_level : 2,
      hgnc_id : "HGNC:664",
      havana_gene : "OTTHUMG00000171807.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67647085,
      stop : 67674820,
      direction : "-",
      ID : "ENSG00000100568.11",
      gene_id : "ENSG00000100568.11",
      gene_type : "protein_coding",
      gene_name : "VTI1B",
      gene_level : 1,
      hgnc_id : "HGNC:17793",
      havana_gene : "OTTHUMG00000171251.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67659820,
      stop : 67690367,
      direction : "-",
      ID : "ENSG00000258466.5",
      gene_id : "ENSG00000258466.5",
      gene_type : "protein_coding",
      gene_name : "AL049779.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171262.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67676800,
      stop : 67695793,
      direction : "-",
      ID : "ENSG00000072042.13",
      gene_id : "ENSG00000072042.13",
      gene_type : "protein_coding",
      gene_name : "RDH11",
      gene_level : 1,
      hgnc_id : "HGNC:17964",
      havana_gene : "OTTHUMG00000171196.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67701886,
      stop : 67734451,
      direction : "+",
      ID : "ENSG00000139988.10",
      gene_id : "ENSG00000139988.10",
      gene_type : "protein_coding",
      gene_name : "RDH12",
      gene_level : 2,
      hgnc_id : "HGNC:19977",
      havana_gene : "OTTHUMG00000170032.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67727374,
      stop : 67816590,
      direction : "-",
      ID : "ENSG00000072121.17",
      gene_id : "ENSG00000072121.17",
      gene_type : "protein_coding",
      gene_name : "ZFYVE26",
      gene_level : 2,
      hgnc_id : "HGNC:20761",
      havana_gene : "OTTHUMG00000171274.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 67819779,
      stop : 68730218,
      direction : "+",
      ID : "ENSG00000182185.18",
      gene_id : "ENSG00000182185.18",
      gene_type : "protein_coding",
      gene_name : "RAD51B",
      gene_level : 1,
      hgnc_id : "HGNC:9822",
      havana_gene : "OTTHUMG00000157530.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 68787660,
      stop : 68796253,
      direction : "-",
      ID : "ENSG00000185650.10",
      gene_id : "ENSG00000185650.10",
      gene_type : "protein_coding",
      gene_name : "ZFP36L1",
      gene_level : 1,
      hgnc_id : "HGNC:1107",
      havana_gene : "OTTHUMG00000171385.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 68874128,
      stop : 68979440,
      direction : "-",
      ID : "ENSG00000072110.15",
      gene_id : "ENSG00000072110.15",
      gene_type : "protein_coding",
      gene_name : "ACTN1",
      gene_level : 1,
      hgnc_id : "HGNC:163",
      havana_gene : "OTTHUMG00000171386.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69050881,
      stop : 69153150,
      direction : "-",
      ID : "ENSG00000139990.18",
      gene_id : "ENSG00000139990.18",
      gene_type : "protein_coding",
      gene_name : "DCAF5",
      gene_level : 1,
      hgnc_id : "HGNC:20224",
      havana_gene : "OTTHUMG00000171699.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69191511,
      stop : 69244020,
      direction : "+",
      ID : "ENSG00000081177.18",
      gene_id : "ENSG00000081177.18",
      gene_type : "protein_coding",
      gene_name : "EXD2",
      gene_level : 1,
      hgnc_id : "HGNC:20217",
      havana_gene : "OTTHUMG00000154496.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69259277,
      stop : 69357033,
      direction : "+",
      ID : "ENSG00000100626.17",
      gene_id : "ENSG00000100626.17",
      gene_type : "protein_coding",
      gene_name : "GALNT16",
      gene_level : 2,
      hgnc_id : "HGNC:23233",
      havana_gene : "OTTHUMG00000171231.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69380128,
      stop : 69398299,
      direction : "-",
      ID : "ENSG00000100632.11",
      gene_id : "ENSG00000100632.11",
      gene_type : "protein_coding",
      gene_name : "ERH",
      gene_level : 2,
      hgnc_id : "HGNC:3447",
      havana_gene : "OTTHUMG00000171323.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69398015,
      stop : 69462390,
      direction : "+",
      ID : "ENSG00000029364.12",
      gene_id : "ENSG00000029364.12",
      gene_type : "protein_coding",
      gene_name : "SLC39A9",
      gene_level : 1,
      hgnc_id : "HGNC:20182",
      havana_gene : "OTTHUMG00000171232.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69484692,
      stop : 69531551,
      direction : "+",
      ID : "ENSG00000175985.10",
      gene_id : "ENSG00000175985.10",
      gene_type : "protein_coding",
      gene_name : "PLEKHD1",
      gene_level : 2,
      hgnc_id : "HGNC:20148",
      havana_gene : "OTTHUMG00000171233.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69569799,
      stop : 69574871,
      direction : "-",
      ID : "ENSG00000267909.3",
      gene_id : "ENSG00000267909.3",
      gene_type : "protein_coding",
      gene_name : "CCDC177",
      gene_level : 2,
      hgnc_id : "HGNC:23243",
      havana_gene : "OTTHUMG00000187379.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69611596,
      stop : 69715144,
      direction : "+",
      ID : "ENSG00000100647.8",
      gene_id : "ENSG00000100647.8",
      gene_type : "protein_coding",
      gene_name : "SUSD6",
      gene_level : 2,
      hgnc_id : "HGNC:19956",
      havana_gene : "OTTHUMG00000171234.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69726900,
      stop : 69772005,
      direction : "+",
      ID : "ENSG00000100650.16",
      gene_id : "ENSG00000100650.16",
      gene_type : "protein_coding",
      gene_name : "SRSF5",
      gene_level : 1,
      hgnc_id : "HGNC:10787",
      havana_gene : "OTTHUMG00000171235.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69775416,
      stop : 69797241,
      direction : "-",
      ID : "ENSG00000100652.5",
      gene_id : "ENSG00000100652.5",
      gene_type : "protein_coding",
      gene_name : "SLC10A1",
      gene_level : 2,
      hgnc_id : "HGNC:10905",
      havana_gene : "OTTHUMG00000171236.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 69854131,
      stop : 70032366,
      direction : "+",
      ID : "ENSG00000198732.11",
      gene_id : "ENSG00000198732.11",
      gene_type : "protein_coding",
      gene_name : "SMOC1",
      gene_level : 2,
      hgnc_id : "HGNC:20318",
      havana_gene : "OTTHUMG00000171237.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70044215,
      stop : 70189070,
      direction : "-",
      ID : "ENSG00000100678.19",
      gene_id : "ENSG00000100678.19",
      gene_type : "protein_coding",
      gene_name : "SLC8A3",
      gene_level : 1,
      hgnc_id : "HGNC:11070",
      havana_gene : "OTTHUMG00000152342.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70325081,
      stop : 70416984,
      direction : "-",
      ID : "ENSG00000133983.16",
      gene_id : "ENSG00000133983.16",
      gene_type : "protein_coding",
      gene_name : "COX16",
      gene_level : 2,
      hgnc_id : "HGNC:20213",
      havana_gene : "OTTHUMG00000171238.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70326064,
      stop : 70417074,
      direction : "-",
      ID : "ENSG00000258644.6",
      gene_id : "ENSG00000258644.6",
      gene_type : "protein_coding",
      gene_name : "SYNJ2BP-COX16",
      gene_level : 2,
      hgnc_id : "HGNC:48350",
      havana_gene : "OTTHUMG00000171239.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70366499,
      stop : 70417090,
      direction : "-",
      ID : "ENSG00000213463.5",
      gene_id : "ENSG00000213463.5",
      gene_type : "protein_coding",
      gene_name : "SYNJ2BP",
      gene_level : 2,
      hgnc_id : "HGNC:18955",
      havana_gene : "OTTHUMG00000171240.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70417107,
      stop : 70460427,
      direction : "+",
      ID : "ENSG00000139985.8",
      gene_id : "ENSG00000139985.8",
      gene_type : "protein_coding",
      gene_name : "ADAM21",
      gene_level : 2,
      hgnc_id : "HGNC:200",
      havana_gene : "OTTHUMG00000171328.4",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70522358,
      stop : 70535015,
      direction : "-",
      ID : "ENSG00000134007.5",
      gene_id : "ENSG00000134007.5",
      gene_type : "protein_coding",
      gene_name : "ADAM20",
      gene_level : 2,
      hgnc_id : "HGNC:199",
      havana_gene : "OTTHUMG00000167548.4",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70581257,
      stop : 70600690,
      direction : "-",
      ID : "ENSG00000133997.12",
      gene_id : "ENSG00000133997.12",
      gene_type : "protein_coding",
      gene_name : "MED6",
      gene_level : 1,
      hgnc_id : "HGNC:19970",
      havana_gene : "OTTHUMG00000171252.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70641916,
      stop : 70675366,
      direction : "+",
      ID : "ENSG00000133985.3",
      gene_id : "ENSG00000133985.3",
      gene_type : "protein_coding",
      gene_name : "TTC9",
      gene_level : 2,
      hgnc_id : "HGNC:20267",
      havana_gene : "OTTHUMG00000172133.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70722526,
      stop : 70809534,
      direction : "-",
      ID : "ENSG00000006432.16",
      gene_id : "ENSG00000006432.16",
      gene_type : "protein_coding",
      gene_name : "MAP3K9",
      gene_level : 1,
      hgnc_id : "HGNC:6861",
      havana_gene : "OTTHUMG00000171249.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 70907405,
      stop : 71115382,
      direction : "+",
      ID : "ENSG00000100731.16",
      gene_id : "ENSG00000100731.16",
      gene_type : "protein_coding",
      gene_name : "PCNX1",
      gene_level : 2,
      hgnc_id : "HGNC:19740",
      havana_gene : "OTTHUMG00000171242.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 71320449,
      stop : 71741229,
      direction : "+",
      ID : "ENSG00000197555.9",
      gene_id : "ENSG00000197555.9",
      gene_type : "protein_coding",
      gene_name : "SIPA1L1",
      gene_level : 1,
      hgnc_id : "HGNC:20284",
      havana_gene : "OTTHUMG00000171282.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 71932429,
      stop : 72566530,
      direction : "+",
      ID : "ENSG00000182732.18",
      gene_id : "ENSG00000182732.18",
      gene_type : "protein_coding",
      gene_name : "RGS6",
      gene_level : 1,
      hgnc_id : "HGNC:10002",
      havana_gene : "OTTHUMG00000171340.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 72619296,
      stop : 72894116,
      direction : "-",
      ID : "ENSG00000205683.11",
      gene_id : "ENSG00000205683.11",
      gene_type : "protein_coding",
      gene_name : "DPF3",
      gene_level : 1,
      hgnc_id : "HGNC:17427",
      havana_gene : "OTTHUMG00000171364.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 72926377,
      stop : 72959703,
      direction : "+",
      ID : "ENSG00000119599.17",
      gene_id : "ENSG00000119599.17",
      gene_type : "protein_coding",
      gene_name : "DCAF4",
      gene_level : 1,
      hgnc_id : "HGNC:20229",
      havana_gene : "OTTHUMG00000160542.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 72969451,
      stop : 73027131,
      direction : "-",
      ID : "ENSG00000165861.14",
      gene_id : "ENSG00000165861.14",
      gene_type : "protein_coding",
      gene_name : "ZFYVE1",
      gene_level : 2,
      hgnc_id : "HGNC:13180",
      havana_gene : "OTTHUMG00000171365.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73058532,
      stop : 73123899,
      direction : "+",
      ID : "ENSG00000119707.14",
      gene_id : "ENSG00000119707.14",
      gene_type : "protein_coding",
      gene_name : "RBM25",
      gene_level : 2,
      hgnc_id : "HGNC:23244",
      havana_gene : "OTTHUMG00000167540.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73136418,
      stop : 73223691,
      direction : "+",
      ID : "ENSG00000080815.19",
      gene_id : "ENSG00000080815.19",
      gene_type : "protein_coding",
      gene_name : "PSEN1",
      gene_level : 1,
      hgnc_id : "HGNC:9508",
      havana_gene : "OTTHUMG00000141279.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73237497,
      stop : 73274640,
      direction : "+",
      ID : "ENSG00000100767.17",
      gene_id : "ENSG00000100767.17",
      gene_type : "protein_coding",
      gene_name : "PAPLN",
      gene_level : 2,
      hgnc_id : "HGNC:19262",
      havana_gene : "OTTHUMG00000171366.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73275107,
      stop : 73458617,
      direction : "-",
      ID : "ENSG00000133961.20",
      gene_id : "ENSG00000133961.20",
      gene_type : "protein_coding",
      gene_name : "NUMB",
      gene_level : 2,
      hgnc_id : "HGNC:8060",
      havana_gene : "OTTHUMG00000171436.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73478484,
      stop : 73558947,
      direction : "-",
      ID : "ENSG00000187105.9",
      gene_id : "ENSG00000187105.9",
      gene_type : "protein_coding",
      gene_name : "HEATR4",
      gene_level : 2,
      hgnc_id : "HGNC:16761",
      havana_gene : "OTTHUMG00000171602.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73490933,
      stop : 73493394,
      direction : "+",
      ID : "ENSG00000170468.8",
      gene_id : "ENSG00000170468.8",
      gene_type : "protein_coding",
      gene_name : "RIOX1",
      gene_level : 2,
      hgnc_id : "HGNC:20968",
      havana_gene : "OTTHUMG00000166530.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73537143,
      stop : 73543796,
      direction : "+",
      ID : "ENSG00000184227.8",
      gene_id : "ENSG00000184227.8",
      gene_type : "protein_coding",
      gene_name : "ACOT1",
      gene_level : 2,
      hgnc_id : "HGNC:33128",
      havana_gene : "OTTHUMG00000171607.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73567620,
      stop : 73575658,
      direction : "+",
      ID : "ENSG00000119673.15",
      gene_id : "ENSG00000119673.15",
      gene_type : "protein_coding",
      gene_name : "ACOT2",
      gene_level : 1,
      hgnc_id : "HGNC:18431",
      havana_gene : "OTTHUMG00000171608.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73591873,
      stop : 73595766,
      direction : "+",
      ID : "ENSG00000177465.5",
      gene_id : "ENSG00000177465.5",
      gene_type : "protein_coding",
      gene_name : "ACOT4",
      gene_level : 2,
      hgnc_id : "HGNC:19748",
      havana_gene : "OTTHUMG00000169485.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73610945,
      stop : 73619888,
      direction : "+",
      ID : "ENSG00000205669.4",
      gene_id : "ENSG00000205669.4",
      gene_type : "protein_coding",
      gene_name : "ACOT6",
      gene_level : 2,
      hgnc_id : "HGNC:33159",
      havana_gene : "OTTHUMG00000171609.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73644875,
      stop : 73703732,
      direction : "+",
      ID : "ENSG00000119661.15",
      gene_id : "ENSG00000119661.15",
      gene_type : "protein_coding",
      gene_name : "DNAL1",
      gene_level : 2,
      hgnc_id : "HGNC:23247",
      havana_gene : "OTTHUMG00000171642.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73711783,
      stop : 73714384,
      direction : "-",
      ID : "ENSG00000176903.5",
      gene_id : "ENSG00000176903.5",
      gene_type : "protein_coding",
      gene_name : "PNMA1",
      gene_level : 2,
      hgnc_id : "HGNC:9158",
      havana_gene : "OTTHUMG00000169183.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73715122,
      stop : 73790285,
      direction : "-",
      ID : "ENSG00000156030.13",
      gene_id : "ENSG00000156030.13",
      gene_type : "protein_coding",
      gene_name : "MIDEAS",
      gene_level : 1,
      hgnc_id : "HGNC:19853",
      havana_gene : "OTTHUMG00000150359.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73851844,
      stop : 73886827,
      direction : "+",
      ID : "ENSG00000140043.11",
      gene_id : "ENSG00000140043.11",
      gene_type : "protein_coding",
      gene_name : "PTGR2",
      gene_level : 2,
      hgnc_id : "HGNC:20149",
      havana_gene : "OTTHUMG00000171255.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73851971,
      stop : 73932278,
      direction : "+",
      ID : "ENSG00000258653.3",
      gene_id : "ENSG00000258653.3",
      gene_type : "protein_coding",
      gene_name : "AC005520.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171256.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73886617,
      stop : 73932521,
      direction : "+",
      ID : "ENSG00000119725.20",
      gene_id : "ENSG00000119725.20",
      gene_type : "protein_coding",
      gene_name : "ZNF410",
      gene_level : 1,
      hgnc_id : "HGNC:20144",
      havana_gene : "OTTHUMG00000171257.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73931501,
      stop : 73950414,
      direction : "-",
      ID : "ENSG00000156050.10",
      gene_id : "ENSG00000156050.10",
      gene_type : "protein_coding",
      gene_name : "FAM161B",
      gene_level : 2,
      hgnc_id : "HGNC:19854",
      havana_gene : "OTTHUMG00000171259.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73949926,
      stop : 73963670,
      direction : "+",
      ID : "ENSG00000119723.17",
      gene_id : "ENSG00000119723.17",
      gene_type : "protein_coding",
      gene_name : "COQ6",
      gene_level : 1,
      hgnc_id : "HGNC:20233",
      havana_gene : "OTTHUMG00000171260.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 73958010,
      stop : 74019399,
      direction : "-",
      ID : "ENSG00000187097.13",
      gene_id : "ENSG00000187097.13",
      gene_type : "protein_coding",
      gene_name : "ENTPD5",
      gene_level : 1,
      hgnc_id : "HGNC:3367",
      havana_gene : "OTTHUMG00000171201.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74019349,
      stop : 74082863,
      direction : "+",
      ID : "ENSG00000119636.16",
      gene_id : "ENSG00000119636.16",
      gene_type : "protein_coding",
      gene_name : "BBOF1",
      gene_level : 2,
      hgnc_id : "HGNC:19855",
      havana_gene : "OTTHUMG00000171202.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74056847,
      stop : 74084492,
      direction : "-",
      ID : "ENSG00000119711.13",
      gene_id : "ENSG00000119711.13",
      gene_type : "protein_coding",
      gene_name : "ALDH6A1",
      gene_level : 2,
      hgnc_id : "HGNC:7179",
      havana_gene : "OTTHUMG00000171203.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74084796,
      stop : 74201235,
      direction : "+",
      ID : "ENSG00000205659.11",
      gene_id : "ENSG00000205659.11",
      gene_type : "protein_coding",
      gene_name : "LIN52",
      gene_level : 2,
      hgnc_id : "HGNC:19856",
      havana_gene : "OTTHUMG00000171204.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74239449,
      stop : 74262738,
      direction : "+",
      ID : "ENSG00000119614.3",
      gene_id : "ENSG00000119614.3",
      gene_type : "protein_coding",
      gene_name : "VSX2",
      gene_level : 2,
      hgnc_id : "HGNC:1975",
      havana_gene : "OTTHUMG00000171206.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74285269,
      stop : 74303055,
      direction : "-",
      ID : "ENSG00000119688.21",
      gene_id : "ENSG00000119688.21",
      gene_type : "protein_coding",
      gene_name : "ABCD4",
      gene_level : 2,
      hgnc_id : "HGNC:68",
      havana_gene : "OTTHUMG00000171207.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74303069,
      stop : 74360008,
      direction : "+",
      ID : "ENSG00000133980.5",
      gene_id : "ENSG00000133980.5",
      gene_type : "protein_coding",
      gene_name : "VRTN",
      gene_level : 2,
      hgnc_id : "HGNC:20223",
      havana_gene : "OTTHUMG00000171208.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74405894,
      stop : 74426210,
      direction : "-",
      ID : "ENSG00000183379.9",
      gene_id : "ENSG00000183379.9",
      gene_type : "protein_coding",
      gene_name : "SYNDIG1L",
      gene_level : 2,
      hgnc_id : "HGNC:32388",
      havana_gene : "OTTHUMG00000171210.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74476192,
      stop : 74494177,
      direction : "-",
      ID : "ENSG00000119655.11",
      gene_id : "ENSG00000119655.11",
      gene_type : "protein_coding",
      gene_name : "NPC2",
      gene_level : 1,
      hgnc_id : "HGNC:14537",
      havana_gene : "OTTHUMG00000171212.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74493756,
      stop : 74497106,
      direction : "+",
      ID : "ENSG00000165898.14",
      gene_id : "ENSG00000165898.14",
      gene_type : "protein_coding",
      gene_name : "ISCA2",
      gene_level : 1,
      hgnc_id : "HGNC:19857",
      havana_gene : "OTTHUMG00000171214.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74498183,
      stop : 74612378,
      direction : "-",
      ID : "ENSG00000119681.12",
      gene_id : "ENSG00000119681.12",
      gene_type : "protein_coding",
      gene_name : "LTBP2",
      gene_level : 1,
      hgnc_id : "HGNC:6715",
      havana_gene : "OTTHUMG00000171476.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74653437,
      stop : 74713117,
      direction : "-",
      ID : "ENSG00000119682.18",
      gene_id : "ENSG00000119682.18",
      gene_type : "protein_coding",
      gene_name : "AREL1",
      gene_level : 1,
      hgnc_id : "HGNC:20363",
      havana_gene : "OTTHUMG00000154499.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74713144,
      stop : 74738620,
      direction : "+",
      ID : "ENSG00000119616.11",
      gene_id : "ENSG00000119616.11",
      gene_type : "protein_coding",
      gene_name : "FCF1",
      gene_level : 2,
      hgnc_id : "HGNC:20220",
      havana_gene : "OTTHUMG00000171480.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74763316,
      stop : 74859435,
      direction : "+",
      ID : "ENSG00000119596.18",
      gene_id : "ENSG00000119596.18",
      gene_type : "protein_coding",
      gene_name : "YLPM1",
      gene_level : 1,
      hgnc_id : "HGNC:17798",
      havana_gene : "OTTHUMG00000172503.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74852871,
      stop : 74876154,
      direction : "-",
      ID : "ENSG00000119608.14",
      gene_id : "ENSG00000119608.14",
      gene_type : "protein_coding",
      gene_name : "PROX2",
      gene_level : 1,
      hgnc_id : "HGNC:26715",
      havana_gene : "OTTHUMG00000171481.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74881891,
      stop : 74903743,
      direction : "+",
      ID : "ENSG00000119689.15",
      gene_id : "ENSG00000119689.15",
      gene_type : "protein_coding",
      gene_name : "DLST",
      gene_level : 2,
      hgnc_id : "HGNC:2911",
      havana_gene : "OTTHUMG00000171483.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74903951,
      stop : 74923302,
      direction : "-",
      ID : "ENSG00000198208.12",
      gene_id : "ENSG00000198208.12",
      gene_type : "protein_coding",
      gene_name : "RPS6KL1",
      gene_level : 1,
      hgnc_id : "HGNC:20222",
      havana_gene : "OTTHUMG00000171484.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 74941834,
      stop : 74955626,
      direction : "-",
      ID : "ENSG00000119630.14",
      gene_id : "ENSG00000119630.14",
      gene_type : "protein_coding",
      gene_name : "PGF",
      gene_level : 2,
      hgnc_id : "HGNC:8893",
      havana_gene : "OTTHUMG00000171496.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75002921,
      stop : 75012366,
      direction : "+",
      ID : "ENSG00000119718.11",
      gene_id : "ENSG00000119718.11",
      gene_type : "protein_coding",
      gene_name : "EIF2B2",
      gene_level : 1,
      hgnc_id : "HGNC:3258",
      havana_gene : "OTTHUMG00000171764.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75013769,
      stop : 75051532,
      direction : "-",
      ID : "ENSG00000119684.16",
      gene_id : "ENSG00000119684.16",
      gene_type : "protein_coding",
      gene_name : "MLH3",
      gene_level : 1,
      hgnc_id : "HGNC:7128",
      havana_gene : "OTTHUMG00000171766.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75053237,
      stop : 75069483,
      direction : "-",
      ID : "ENSG00000119640.9",
      gene_id : "ENSG00000119640.9",
      gene_type : "protein_coding",
      gene_name : "ACYP1",
      gene_level : 1,
      hgnc_id : "HGNC:179",
      havana_gene : "OTTHUMG00000171767.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75064109,
      stop : 75119502,
      direction : "+",
      ID : "ENSG00000119703.15",
      gene_id : "ENSG00000119703.15",
      gene_type : "protein_coding",
      gene_name : "ZC2HC1C",
      gene_level : 1,
      hgnc_id : "HGNC:20354",
      havana_gene : "OTTHUMG00000167439.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75079353,
      stop : 75127344,
      direction : "-",
      ID : "ENSG00000119638.14",
      gene_id : "ENSG00000119638.14",
      gene_type : "protein_coding",
      gene_name : "NEK9",
      gene_level : 1,
      hgnc_id : "HGNC:18591",
      havana_gene : "OTTHUMG00000171768.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75131469,
      stop : 75176612,
      direction : "-",
      ID : "ENSG00000170348.9",
      gene_id : "ENSG00000170348.9",
      gene_type : "protein_coding",
      gene_name : "TMED10",
      gene_level : 2,
      hgnc_id : "HGNC:16998",
      havana_gene : "OTTHUMG00000171771.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75278826,
      stop : 75282230,
      direction : "+",
      ID : "ENSG00000170345.10",
      gene_id : "ENSG00000170345.10",
      gene_type : "protein_coding",
      gene_name : "FOS",
      gene_level : 1,
      hgnc_id : "HGNC:3796",
      havana_gene : "OTTHUMG00000171774.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75427716,
      stop : 75474111,
      direction : "+",
      ID : "ENSG00000140044.13",
      gene_id : "ENSG00000140044.13",
      gene_type : "protein_coding",
      gene_name : "JDP2",
      gene_level : 2,
      hgnc_id : "HGNC:17546",
      havana_gene : "OTTHUMG00000171869.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75522455,
      stop : 75546993,
      direction : "+",
      ID : "ENSG00000156127.8",
      gene_id : "ENSG00000156127.8",
      gene_type : "protein_coding",
      gene_name : "BATF",
      gene_level : 2,
      hgnc_id : "HGNC:958",
      havana_gene : "OTTHUMG00000171486.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75578620,
      stop : 75663214,
      direction : "+",
      ID : "ENSG00000119686.10",
      gene_id : "ENSG00000119686.10",
      gene_type : "protein_coding",
      gene_name : "FLVCR2",
      gene_level : 1,
      hgnc_id : "HGNC:20105",
      havana_gene : "OTTHUMG00000171487.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75633625,
      stop : 75955079,
      direction : "+",
      ID : "ENSG00000119685.20",
      gene_id : "ENSG00000119685.20",
      gene_type : "protein_coding",
      gene_name : "TTLL5",
      gene_level : 1,
      hgnc_id : "HGNC:19963",
      havana_gene : "OTTHUMG00000171611.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75649791,
      stop : 75660876,
      direction : "-",
      ID : "ENSG00000133935.7",
      gene_id : "ENSG00000133935.7",
      gene_type : "protein_coding",
      gene_name : "ERG28",
      gene_level : 2,
      hgnc_id : "HGNC:1187",
      havana_gene : "OTTHUMG00000171488.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75902136,
      stop : 76084585,
      direction : "+",
      ID : "ENSG00000119650.13",
      gene_id : "ENSG00000119650.13",
      gene_type : "protein_coding",
      gene_name : "IFT43",
      gene_level : 2,
      hgnc_id : "HGNC:29669",
      havana_gene : "OTTHUMG00000171613.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 75958097,
      stop : 75983011,
      direction : "-",
      ID : "ENSG00000119699.8",
      gene_id : "ENSG00000119699.8",
      gene_type : "protein_coding",
      gene_name : "TGFB3",
      gene_level : 1,
      hgnc_id : "HGNC:11769",
      havana_gene : "OTTHUMG00000171489.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 76151916,
      stop : 76254342,
      direction : "+",
      ID : "ENSG00000089916.18",
      gene_id : "ENSG00000089916.18",
      gene_type : "protein_coding",
      gene_name : "GPATCH2L",
      gene_level : 1,
      hgnc_id : "HGNC:20210",
      havana_gene : "OTTHUMG00000171490.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 76310712,
      stop : 76501837,
      direction : "+",
      ID : "ENSG00000119715.15",
      gene_id : "ENSG00000119715.15",
      gene_type : "protein_coding",
      gene_name : "ESRRB",
      gene_level : 2,
      hgnc_id : "HGNC:3473",
      havana_gene : "OTTHUMG00000160457.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 76761468,
      stop : 76783015,
      direction : "+",
      ID : "ENSG00000071246.11",
      gene_id : "ENSG00000071246.11",
      gene_type : "protein_coding",
      gene_name : "VASH1",
      gene_level : 2,
      hgnc_id : "HGNC:19964",
      havana_gene : "OTTHUMG00000171493.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 76786009,
      stop : 76826246,
      direction : "-",
      ID : "ENSG00000013523.11",
      gene_id : "ENSG00000013523.11",
      gene_type : "protein_coding",
      gene_name : "ANGEL1",
      gene_level : 1,
      hgnc_id : "HGNC:19961",
      havana_gene : "OTTHUMG00000171494.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 76826372,
      stop : 76870302,
      direction : "+",
      ID : "ENSG00000100565.15",
      gene_id : "ENSG00000100565.15",
      gene_type : "protein_coding",
      gene_name : "LRRC74A",
      gene_level : 2,
      hgnc_id : "HGNC:23346",
      havana_gene : "OTTHUMG00000150153.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77024543,
      stop : 77028708,
      direction : "-",
      ID : "ENSG00000119669.5",
      gene_id : "ENSG00000119669.5",
      gene_type : "protein_coding",
      gene_name : "IRF2BPL",
      gene_level : 2,
      hgnc_id : "HGNC:14282",
      havana_gene : "OTTHUMG00000171578.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77098126,
      stop : 77117287,
      direction : "+",
      ID : "ENSG00000198894.8",
      gene_id : "ENSG00000198894.8",
      gene_type : "protein_coding",
      gene_name : "CIPC",
      gene_level : 1,
      hgnc_id : "HGNC:20365",
      havana_gene : "OTTHUMG00000171573.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77098311,
      stop : 77225462,
      direction : "+",
      ID : "ENSG00000259164.1",
      gene_id : "ENSG00000259164.1",
      gene_type : "protein_coding",
      gene_name : "AC007375.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171574.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77116568,
      stop : 77259495,
      direction : "+",
      ID : "ENSG00000165548.11",
      gene_id : "ENSG00000165548.11",
      gene_type : "protein_coding",
      gene_name : "TMEM63C",
      gene_level : 2,
      hgnc_id : "HGNC:23787",
      havana_gene : "OTTHUMG00000171557.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77131270,
      stop : 77142734,
      direction : "-",
      ID : "ENSG00000177108.5",
      gene_id : "ENSG00000177108.5",
      gene_type : "protein_coding",
      gene_name : "ZDHHC22",
      gene_level : 2,
      hgnc_id : "HGNC:20106",
      havana_gene : "OTTHUMG00000171575.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77265483,
      stop : 77271312,
      direction : "-",
      ID : "ENSG00000165553.4",
      gene_id : "ENSG00000165553.4",
      gene_type : "protein_coding",
      gene_name : "NGB",
      gene_level : 2,
      hgnc_id : "HGNC:14077",
      havana_gene : "OTTHUMG00000171558.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77274956,
      stop : 77320883,
      direction : "-",
      ID : "ENSG00000009830.12",
      gene_id : "ENSG00000009830.12",
      gene_type : "protein_coding",
      gene_name : "POMT2",
      gene_level : 1,
      hgnc_id : "HGNC:19743",
      havana_gene : "OTTHUMG00000171556.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77320996,
      stop : 77331597,
      direction : "+",
      ID : "ENSG00000100577.19",
      gene_id : "ENSG00000100577.19",
      gene_type : "protein_coding",
      gene_name : "GSTZ1",
      gene_level : 1,
      hgnc_id : "HGNC:4643",
      havana_gene : "OTTHUMG00000171551.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77335029,
      stop : 77377094,
      direction : "-",
      ID : "ENSG00000100580.8",
      gene_id : "ENSG00000100580.8",
      gene_type : "protein_coding",
      gene_name : "TMED8",
      gene_level : 2,
      hgnc_id : "HGNC:18633",
      havana_gene : "OTTHUMG00000171552.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77376689,
      stop : 77391497,
      direction : "+",
      ID : "ENSG00000100583.4",
      gene_id : "ENSG00000100583.4",
      gene_type : "protein_coding",
      gene_name : "SAMD15",
      gene_level : 2,
      hgnc_id : "HGNC:18631",
      havana_gene : "OTTHUMG00000167428.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77394021,
      stop : 77423517,
      direction : "-",
      ID : "ENSG00000165555.9",
      gene_id : "ENSG00000165555.9",
      gene_type : "protein_coding",
      gene_name : "NOXRED1",
      gene_level : 2,
      hgnc_id : "HGNC:20487",
      havana_gene : "OTTHUMG00000171554.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77426675,
      stop : 77457952,
      direction : "-",
      ID : "ENSG00000151445.16",
      gene_id : "ENSG00000151445.16",
      gene_type : "protein_coding",
      gene_name : "VIPAS39",
      gene_level : 2,
      hgnc_id : "HGNC:20347",
      havana_gene : "OTTHUMG00000171538.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77457870,
      stop : 77469472,
      direction : "+",
      ID : "ENSG00000100591.8",
      gene_id : "ENSG00000100591.8",
      gene_type : "protein_coding",
      gene_name : "AHSA1",
      gene_level : 1,
      hgnc_id : "HGNC:1189",
      havana_gene : "OTTHUMG00000171539.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77474394,
      stop : 77498816,
      direction : "-",
      ID : "ENSG00000100593.18",
      gene_id : "ENSG00000100593.18",
      gene_type : "protein_coding",
      gene_name : "ISM2",
      gene_level : 2,
      hgnc_id : "HGNC:23176",
      havana_gene : "OTTHUMG00000158563.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77505997,
      stop : 77616637,
      direction : "-",
      ID : "ENSG00000100596.7",
      gene_id : "ENSG00000100596.7",
      gene_type : "protein_coding",
      gene_name : "SPTLC2",
      gene_level : 1,
      hgnc_id : "HGNC:11278",
      havana_gene : "OTTHUMG00000171540.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77672404,
      stop : 77708023,
      direction : "-",
      ID : "ENSG00000100601.10",
      gene_id : "ENSG00000100601.10",
      gene_type : "protein_coding",
      gene_name : "ALKBH1",
      gene_level : 2,
      hgnc_id : "HGNC:17911",
      havana_gene : "OTTHUMG00000171542.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77708071,
      stop : 77761104,
      direction : "+",
      ID : "ENSG00000119705.10",
      gene_id : "ENSG00000119705.10",
      gene_type : "protein_coding",
      gene_name : "SLIRP",
      gene_level : 1,
      hgnc_id : "HGNC:20495",
      havana_gene : "OTTHUMG00000171526.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77717599,
      stop : 77761207,
      direction : "-",
      ID : "ENSG00000100603.14",
      gene_id : "ENSG00000100603.14",
      gene_type : "protein_coding",
      gene_name : "SNW1",
      gene_level : 2,
      hgnc_id : "HGNC:16696",
      havana_gene : "OTTHUMG00000171527.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 77800109,
      stop : 77935014,
      direction : "+",
      ID : "ENSG00000063761.16",
      gene_id : "ENSG00000063761.16",
      gene_type : "protein_coding",
      gene_name : "ADCK1",
      gene_level : 1,
      hgnc_id : "HGNC:19038",
      havana_gene : "OTTHUMG00000171520.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 78170373,
      stop : 79868291,
      direction : "+",
      ID : "ENSG00000021645.20",
      gene_id : "ENSG00000021645.20",
      gene_type : "protein_coding",
      gene_name : "NRXN3",
      gene_level : 2,
      hgnc_id : "HGNC:8010",
      havana_gene : "OTTHUMG00000171502.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 80197526,
      stop : 80387757,
      direction : "-",
      ID : "ENSG00000211448.13",
      gene_id : "ENSG00000211448.13",
      gene_type : "protein_coding",
      gene_name : "DIO2",
      gene_level : 2,
      hgnc_id : "HGNC:2884",
      havana_gene : "OTTHUMG00000171443.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 80476983,
      stop : 80959517,
      direction : "-",
      ID : "ENSG00000100629.17",
      gene_id : "ENSG00000100629.17",
      gene_type : "protein_coding",
      gene_name : "CEP128",
      gene_level : 1,
      hgnc_id : "HGNC:20359",
      havana_gene : "OTTHUMG00000171442.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 80954989,
      stop : 81146306,
      direction : "+",
      ID : "ENSG00000165409.18",
      gene_id : "ENSG00000165409.18",
      gene_type : "protein_coding",
      gene_name : "TSHR",
      gene_level : 2,
      hgnc_id : "HGNC:12373",
      havana_gene : "OTTHUMG00000171429.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 81175452,
      stop : 81221377,
      direction : "-",
      ID : "ENSG00000165417.12",
      gene_id : "ENSG00000165417.12",
      gene_type : "protein_coding",
      gene_name : "GTF2A1",
      gene_level : 2,
      hgnc_id : "HGNC:4646",
      havana_gene : "OTTHUMG00000171414.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 81260656,
      stop : 81436465,
      direction : "-",
      ID : "ENSG00000140022.13",
      gene_id : "ENSG00000140022.13",
      gene_type : "protein_coding",
      gene_name : "STON2",
      gene_level : 1,
      hgnc_id : "HGNC:30652",
      havana_gene : "OTTHUMG00000171416.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 81471547,
      stop : 81533853,
      direction : "-",
      ID : "ENSG00000071537.14",
      gene_id : "ENSG00000071537.14",
      gene_type : "protein_coding",
      gene_name : "SEL1L",
      gene_level : 2,
      hgnc_id : "HGNC:10717",
      havana_gene : "OTTHUMG00000171419.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 85530144,
      stop : 85654428,
      direction : "+",
      ID : "ENSG00000185070.11",
      gene_id : "ENSG00000185070.11",
      gene_type : "protein_coding",
      gene_name : "FLRT2",
      gene_level : 1,
      hgnc_id : "HGNC:3761",
      havana_gene : "OTTHUMG00000171372.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 87837820,
      stop : 87993665,
      direction : "-",
      ID : "ENSG00000054983.17",
      gene_id : "ENSG00000054983.17",
      gene_type : "protein_coding",
      gene_name : "GALC",
      gene_level : 2,
      hgnc_id : "HGNC:4115",
      havana_gene : "OTTHUMG00000028646.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88005135,
      stop : 88014811,
      direction : "+",
      ID : "ENSG00000140030.6",
      gene_id : "ENSG00000140030.6",
      gene_type : "protein_coding",
      gene_name : "GPR65",
      gene_level : 2,
      hgnc_id : "HGNC:4517",
      havana_gene : "OTTHUMG00000028648.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88180103,
      stop : 88326907,
      direction : "-",
      ID : "ENSG00000100433.16",
      gene_id : "ENSG00000100433.16",
      gene_type : "protein_coding",
      gene_name : "KCNK10",
      gene_level : 2,
      hgnc_id : "HGNC:6273",
      havana_gene : "OTTHUMG00000170743.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88384924,
      stop : 88470350,
      direction : "+",
      ID : "ENSG00000042317.17",
      gene_id : "ENSG00000042317.17",
      gene_type : "protein_coding",
      gene_name : "SPATA7",
      gene_level : 1,
      hgnc_id : "HGNC:20423",
      havana_gene : "OTTHUMG00000170744.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88465778,
      stop : 88555007,
      direction : "-",
      ID : "ENSG00000070778.13",
      gene_id : "ENSG00000070778.13",
      gene_type : "protein_coding",
      gene_name : "PTPN21",
      gene_level : 1,
      hgnc_id : "HGNC:9651",
      havana_gene : "OTTHUMG00000170766.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88562970,
      stop : 88627596,
      direction : "+",
      ID : "ENSG00000100722.20",
      gene_id : "ENSG00000100722.20",
      gene_type : "protein_coding",
      gene_name : "ZC3H14",
      gene_level : 1,
      hgnc_id : "HGNC:20509",
      havana_gene : "OTTHUMG00000170803.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88612431,
      stop : 88792752,
      direction : "-",
      ID : "ENSG00000165521.15",
      gene_id : "ENSG00000165521.15",
      gene_type : "protein_coding",
      gene_name : "EML5",
      gene_level : 1,
      hgnc_id : "HGNC:18197",
      havana_gene : "OTTHUMG00000170811.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 88824153,
      stop : 88881078,
      direction : "+",
      ID : "ENSG00000165533.19",
      gene_id : "ENSG00000165533.19",
      gene_type : "protein_coding",
      gene_name : "TTC8",
      gene_level : 1,
      hgnc_id : "HGNC:20087",
      havana_gene : "OTTHUMG00000170884.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 89124871,
      stop : 89619149,
      direction : "-",
      ID : "ENSG00000053254.16",
      gene_id : "ENSG00000053254.16",
      gene_type : "protein_coding",
      gene_name : "FOXN3",
      gene_level : 1,
      hgnc_id : "HGNC:1928",
      havana_gene : "OTTHUMG00000170898.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 89794669,
      stop : 89954777,
      direction : "-",
      ID : "ENSG00000140025.16",
      gene_id : "ENSG00000140025.16",
      gene_type : "protein_coding",
      gene_name : "EFCAB11",
      gene_level : 2,
      hgnc_id : "HGNC:20357",
      havana_gene : "OTTHUMG00000148671.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 89954939,
      stop : 90044764,
      direction : "+",
      ID : "ENSG00000042088.14",
      gene_id : "ENSG00000042088.14",
      gene_type : "protein_coding",
      gene_name : "TDP1",
      gene_level : 2,
      hgnc_id : "HGNC:18884",
      havana_gene : "OTTHUMG00000171016.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 90061994,
      stop : 90185853,
      direction : "+",
      ID : "ENSG00000152315.5",
      gene_id : "ENSG00000152315.5",
      gene_type : "protein_coding",
      gene_name : "KCNK13",
      gene_level : 2,
      hgnc_id : "HGNC:6275",
      havana_gene : "OTTHUMG00000171017.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 90256527,
      stop : 90275429,
      direction : "+",
      ID : "ENSG00000100764.14",
      gene_id : "ENSG00000100764.14",
      gene_type : "protein_coding",
      gene_name : "PSMC1",
      gene_level : 2,
      hgnc_id : "HGNC:9547",
      havana_gene : "OTTHUMG00000171019.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 90267860,
      stop : 90331969,
      direction : "-",
      ID : "ENSG00000119720.18",
      gene_id : "ENSG00000119720.18",
      gene_type : "protein_coding",
      gene_name : "NRDE2",
      gene_level : 2,
      hgnc_id : "HGNC:20186",
      havana_gene : "OTTHUMG00000171020.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 90396502,
      stop : 90408268,
      direction : "+",
      ID : "ENSG00000198668.13",
      gene_id : "ENSG00000198668.13",
      gene_type : "protein_coding",
      gene_name : "CALM1",
      gene_level : 1,
      hgnc_id : "HGNC:1442",
      havana_gene : "OTTHUMG00000171044.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 90524564,
      stop : 90816479,
      direction : "-",
      ID : "ENSG00000165914.15",
      gene_id : "ENSG00000165914.15",
      gene_type : "protein_coding",
      gene_name : "TTC7B",
      gene_level : 1,
      hgnc_id : "HGNC:19858",
      havana_gene : "OTTHUMG00000171047.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 90847861,
      stop : 91060641,
      direction : "-",
      ID : "ENSG00000100784.12",
      gene_id : "ENSG00000100784.12",
      gene_type : "protein_coding",
      gene_name : "RPS6KA5",
      gene_level : 1,
      hgnc_id : "HGNC:10434",
      havana_gene : "OTTHUMG00000171055.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91060333,
      stop : 91225632,
      direction : "+",
      ID : "ENSG00000133943.21",
      gene_id : "ENSG00000133943.21",
      gene_type : "protein_coding",
      gene_name : "DGLUCY",
      gene_level : 1,
      hgnc_id : "HGNC:20498",
      havana_gene : "OTTHUMG00000164980.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91232532,
      stop : 91253925,
      direction : "-",
      ID : "ENSG00000119714.11",
      gene_id : "ENSG00000119714.11",
      gene_type : "protein_coding",
      gene_name : "GPR68",
      gene_level : 2,
      hgnc_id : "HGNC:4519",
      havana_gene : "OTTHUMG00000167590.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91271323,
      stop : 91417844,
      direction : "-",
      ID : "ENSG00000015133.19",
      gene_id : "ENSG00000015133.19",
      gene_type : "protein_coding",
      gene_name : "CCDC88C",
      gene_level : 1,
      hgnc_id : "HGNC:19967",
      havana_gene : "OTTHUMG00000171099.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91457508,
      stop : 91510554,
      direction : "-",
      ID : "ENSG00000100796.18",
      gene_id : "ENSG00000100796.18",
      gene_type : "protein_coding",
      gene_name : "PPP4R3A",
      gene_level : 2,
      hgnc_id : "HGNC:20219",
      havana_gene : "OTTHUMG00000171102.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91580696,
      stop : 91780707,
      direction : "-",
      ID : "ENSG00000133962.8",
      gene_id : "ENSG00000133962.8",
      gene_type : "protein_coding",
      gene_name : "CATSPERB",
      gene_level : 2,
      hgnc_id : "HGNC:20500",
      havana_gene : "OTTHUMG00000171118.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91779746,
      stop : 91867536,
      direction : "-",
      ID : "ENSG00000165929.13",
      gene_id : "ENSG00000165929.13",
      gene_type : "protein_coding",
      gene_name : "TC2N",
      gene_level : 1,
      hgnc_id : "HGNC:19859",
      havana_gene : "OTTHUMG00000171121.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91869411,
      stop : 91947987,
      direction : "-",
      ID : "ENSG00000140092.15",
      gene_id : "ENSG00000140092.15",
      gene_type : "protein_coding",
      gene_name : "FBLN5",
      gene_level : 1,
      hgnc_id : "HGNC:3602",
      havana_gene : "OTTHUMG00000171122.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 91965991,
      stop : 92040896,
      direction : "-",
      ID : "ENSG00000100815.12",
      gene_id : "ENSG00000100815.12",
      gene_type : "protein_coding",
      gene_name : "TRIP11",
      gene_level : 2,
      hgnc_id : "HGNC:12305",
      havana_gene : "OTTHUMG00000171128.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92044496,
      stop : 92106621,
      direction : "-",
      ID : "ENSG00000066427.24",
      gene_id : "ENSG00000066427.24",
      gene_type : "protein_coding",
      gene_name : "ATXN3",
      gene_level : 1,
      hgnc_id : "HGNC:7106",
      havana_gene : "OTTHUMG00000162212.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92116122,
      stop : 92121917,
      direction : "-",
      ID : "ENSG00000183648.11",
      gene_id : "ENSG00000183648.11",
      gene_type : "protein_coding",
      gene_name : "NDUFB1",
      gene_level : 2,
      hgnc_id : "HGNC:7695",
      havana_gene : "OTTHUMG00000171180.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92121969,
      stop : 92172145,
      direction : "+",
      ID : "ENSG00000165934.13",
      gene_id : "ENSG00000165934.13",
      gene_type : "protein_coding",
      gene_name : "CPSF2",
      gene_level : 1,
      hgnc_id : "HGNC:2325",
      havana_gene : "OTTHUMG00000171181.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92322581,
      stop : 92501481,
      direction : "+",
      ID : "ENSG00000140090.18",
      gene_id : "ENSG00000140090.18",
      gene_type : "protein_coding",
      gene_name : "SLC24A4",
      gene_level : 1,
      hgnc_id : "HGNC:10978",
      havana_gene : "OTTHUMG00000167589.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92513781,
      stop : 92688994,
      direction : "+",
      ID : "ENSG00000100599.16",
      gene_id : "ENSG00000100599.16",
      gene_type : "protein_coding",
      gene_name : "RIN3",
      gene_level : 2,
      hgnc_id : "HGNC:18751",
      havana_gene : "OTTHUMG00000171198.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92703807,
      stop : 92748679,
      direction : "-",
      ID : "ENSG00000100600.15",
      gene_id : "ENSG00000100600.15",
      gene_type : "protein_coding",
      gene_name : "LGMN",
      gene_level : 1,
      hgnc_id : "HGNC:9472",
      havana_gene : "OTTHUMG00000171199.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92794305,
      stop : 92839947,
      direction : "+",
      ID : "ENSG00000066455.13",
      gene_id : "ENSG00000066455.13",
      gene_type : "protein_coding",
      gene_name : "GOLGA5",
      gene_level : 2,
      hgnc_id : "HGNC:4428",
      havana_gene : "OTTHUMG00000171217.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92923150,
      stop : 92935285,
      direction : "+",
      ID : "ENSG00000100604.13",
      gene_id : "ENSG00000100604.13",
      gene_type : "protein_coding",
      gene_name : "CHGA",
      gene_level : 1,
      hgnc_id : "HGNC:1929",
      havana_gene : "OTTHUMG00000171225.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 92936914,
      stop : 93116320,
      direction : "-",
      ID : "ENSG00000100605.17",
      gene_id : "ENSG00000100605.17",
      gene_type : "protein_coding",
      gene_name : "ITPK1",
      gene_level : 2,
      hgnc_id : "HGNC:6177",
      havana_gene : "OTTHUMG00000171226.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93182199,
      stop : 93184923,
      direction : "-",
      ID : "ENSG00000165943.5",
      gene_id : "ENSG00000165943.5",
      gene_type : "protein_coding",
      gene_name : "MOAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16658",
      havana_gene : "OTTHUMG00000169184.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93184951,
      stop : 93188463,
      direction : "+",
      ID : "ENSG00000153485.6",
      gene_id : "ENSG00000153485.6",
      gene_type : "protein_coding",
      gene_name : "TMEM251",
      gene_level : 2,
      hgnc_id : "HGNC:20218",
      havana_gene : "OTTHUMG00000171265.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93184973,
      stop : 93218586,
      direction : "+",
      ID : "ENSG00000259066.5",
      gene_id : "ENSG00000259066.5",
      gene_type : "protein_coding",
      gene_name : "AL110118.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171266.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93202894,
      stop : 93207065,
      direction : "-",
      ID : "ENSG00000170270.5",
      gene_id : "ENSG00000170270.5",
      gene_type : "protein_coding",
      gene_name : "GON7",
      gene_level : 2,
      hgnc_id : "HGNC:20356",
      havana_gene : "OTTHUMG00000171267.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93207241,
      stop : 93229215,
      direction : "+",
      ID : "ENSG00000012963.15",
      gene_id : "ENSG00000012963.15",
      gene_type : "protein_coding",
      gene_name : "UBR7",
      gene_level : 2,
      hgnc_id : "HGNC:20344",
      havana_gene : "OTTHUMG00000171268.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93237550,
      stop : 93333092,
      direction : "-",
      ID : "ENSG00000011114.15",
      gene_id : "ENSG00000011114.15",
      gene_type : "protein_coding",
      gene_name : "BTBD7",
      gene_level : 2,
      hgnc_id : "HGNC:18269",
      havana_gene : "OTTHUMG00000171269.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93333219,
      stop : 93707876,
      direction : "+",
      ID : "ENSG00000133958.13",
      gene_id : "ENSG00000133958.13",
      gene_type : "protein_coding",
      gene_name : "UNC79",
      gene_level : 2,
      hgnc_id : "HGNC:19966",
      havana_gene : "OTTHUMG00000029783.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93347182,
      stop : 93348356,
      direction : "+",
      ID : "ENSG00000187581.3",
      gene_id : "ENSG00000187581.3",
      gene_type : "protein_coding",
      gene_name : "COX8C",
      gene_level : 2,
      hgnc_id : "HGNC:24382",
      havana_gene : "OTTHUMG00000171279.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93718298,
      stop : 93788485,
      direction : "-",
      ID : "ENSG00000175785.13",
      gene_id : "ENSG00000175785.13",
      gene_type : "protein_coding",
      gene_name : "PRIMA1",
      gene_level : 2,
      hgnc_id : "HGNC:18319",
      havana_gene : "OTTHUMG00000141313.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93918894,
      stop : 93929608,
      direction : "+",
      ID : "ENSG00000140067.6",
      gene_id : "ENSG00000140067.6",
      gene_type : "protein_coding",
      gene_name : "FAM181A",
      gene_level : 2,
      hgnc_id : "HGNC:20491",
      havana_gene : "OTTHUMG00000171297.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93934166,
      stop : 93976739,
      direction : "-",
      ID : "ENSG00000100628.12",
      gene_id : "ENSG00000100628.12",
      gene_type : "protein_coding",
      gene_name : "ASB2",
      gene_level : 1,
      hgnc_id : "HGNC:16012",
      havana_gene : "OTTHUMG00000171298.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 93987225,
      stop : 94008863,
      direction : "+",
      ID : "ENSG00000175699.15",
      gene_id : "ENSG00000175699.15",
      gene_type : "protein_coding",
      gene_name : "CCDC197",
      gene_level : 2,
      hgnc_id : "HGNC:19860",
      havana_gene : "OTTHUMG00000156974.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94026340,
      stop : 94048930,
      direction : "+",
      ID : "ENSG00000089723.10",
      gene_id : "ENSG00000089723.10",
      gene_type : "protein_coding",
      gene_name : "OTUB2",
      gene_level : 2,
      hgnc_id : "HGNC:20351",
      havana_gene : "OTTHUMG00000171300.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94048287,
      stop : 94081212,
      direction : "-",
      ID : "ENSG00000089737.17",
      gene_id : "ENSG00000089737.17",
      gene_type : "protein_coding",
      gene_name : "DDX24",
      gene_level : 1,
      hgnc_id : "HGNC:13266",
      havana_gene : "OTTHUMG00000171301.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94081301,
      stop : 94103846,
      direction : "+",
      ID : "ENSG00000165948.11",
      gene_id : "ENSG00000165948.11",
      gene_type : "protein_coding",
      gene_name : "IFI27L1",
      gene_level : 1,
      hgnc_id : "HGNC:19754",
      havana_gene : "OTTHUMG00000171302.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94104836,
      stop : 94116698,
      direction : "+",
      ID : "ENSG00000165949.12",
      gene_id : "ENSG00000165949.12",
      gene_type : "protein_coding",
      gene_name : "IFI27",
      gene_level : 1,
      hgnc_id : "HGNC:5397",
      havana_gene : "OTTHUMG00000171303.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94127779,
      stop : 94130253,
      direction : "-",
      ID : "ENSG00000119632.4",
      gene_id : "ENSG00000119632.4",
      gene_type : "protein_coding",
      gene_name : "IFI27L2",
      gene_level : 2,
      hgnc_id : "HGNC:19753",
      havana_gene : "OTTHUMG00000171313.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94146128,
      stop : 94279734,
      direction : "+",
      ID : "ENSG00000119698.12",
      gene_id : "ENSG00000119698.12",
      gene_type : "protein_coding",
      gene_name : "PPP4R4",
      gene_level : 1,
      hgnc_id : "HGNC:23788",
      havana_gene : "OTTHUMG00000171344.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94280460,
      stop : 94293268,
      direction : "-",
      ID : "ENSG00000140093.10",
      gene_id : "ENSG00000140093.10",
      gene_type : "protein_coding",
      gene_name : "SERPINA10",
      gene_level : 2,
      hgnc_id : "HGNC:15996",
      havana_gene : "OTTHUMG00000171345.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94304248,
      stop : 94323389,
      direction : "-",
      ID : "ENSG00000170099.6",
      gene_id : "ENSG00000170099.6",
      gene_type : "protein_coding",
      gene_name : "SERPINA6",
      gene_level : 2,
      hgnc_id : "HGNC:1540",
      havana_gene : "OTTHUMG00000171346.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94376747,
      stop : 94390693,
      direction : "-",
      ID : "ENSG00000197249.14",
      gene_id : "ENSG00000197249.14",
      gene_type : "protein_coding",
      gene_name : "SERPINA1",
      gene_level : 1,
      hgnc_id : "HGNC:8941",
      havana_gene : "OTTHUMG00000150355.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94442464,
      stop : 94452800,
      direction : "-",
      ID : "ENSG00000186910.4",
      gene_id : "ENSG00000186910.4",
      gene_type : "protein_coding",
      gene_name : "SERPINA11",
      gene_level : 2,
      hgnc_id : "HGNC:19193",
      havana_gene : "OTTHUMG00000171348.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94462717,
      stop : 94479689,
      direction : "-",
      ID : "ENSG00000170054.16",
      gene_id : "ENSG00000170054.16",
      gene_type : "protein_coding",
      gene_name : "SERPINA9",
      gene_level : 2,
      hgnc_id : "HGNC:15995",
      havana_gene : "OTTHUMG00000167710.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94487274,
      stop : 94517844,
      direction : "-",
      ID : "ENSG00000165953.10",
      gene_id : "ENSG00000165953.10",
      gene_type : "protein_coding",
      gene_name : "SERPINA12",
      gene_level : 2,
      hgnc_id : "HGNC:18359",
      havana_gene : "OTTHUMG00000171349.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94561442,
      stop : 94569913,
      direction : "+",
      ID : "ENSG00000100665.12",
      gene_id : "ENSG00000100665.12",
      gene_type : "protein_coding",
      gene_name : "SERPINA4",
      gene_level : 2,
      hgnc_id : "HGNC:8948",
      havana_gene : "OTTHUMG00000170859.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94561442,
      stop : 94593118,
      direction : "+",
      ID : "ENSG00000188488.14",
      gene_id : "ENSG00000188488.14",
      gene_type : "protein_coding",
      gene_name : "SERPINA5",
      gene_level : 2,
      hgnc_id : "HGNC:8723",
      havana_gene : "OTTHUMG00000170860.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94592058,
      stop : 94624646,
      direction : "+",
      ID : "ENSG00000273259.3",
      gene_id : "ENSG00000273259.3",
      gene_type : "protein_coding",
      gene_name : "AL049839.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186018.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94612384,
      stop : 94624055,
      direction : "+",
      ID : "ENSG00000196136.18",
      gene_id : "ENSG00000196136.18",
      gene_type : "protein_coding",
      gene_name : "SERPINA3",
      gene_level : 2,
      hgnc_id : "HGNC:16",
      havana_gene : "OTTHUMG00000029851.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 94768223,
      stop : 94770113,
      direction : "-",
      ID : "ENSG00000133937.5",
      gene_id : "ENSG00000133937.5",
      gene_type : "protein_coding",
      gene_name : "GSC",
      gene_level : 2,
      hgnc_id : "HGNC:4612",
      havana_gene : "OTTHUMG00000170864.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95086228,
      stop : 95158010,
      direction : "-",
      ID : "ENSG00000100697.15",
      gene_id : "ENSG00000100697.15",
      gene_type : "protein_coding",
      gene_name : "DICER1",
      gene_level : 1,
      hgnc_id : "HGNC:17098",
      havana_gene : "OTTHUMG00000166134.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95181940,
      stop : 95319908,
      direction : "-",
      ID : "ENSG00000165959.12",
      gene_id : "ENSG00000165959.12",
      gene_type : "protein_coding",
      gene_name : "CLMN",
      gene_level : 2,
      hgnc_id : "HGNC:19972",
      havana_gene : "OTTHUMG00000171629.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95407266,
      stop : 95475836,
      direction : "-",
      ID : "ENSG00000176438.12",
      gene_id : "ENSG00000176438.12",
      gene_type : "protein_coding",
      gene_name : "SYNE3",
      gene_level : 2,
      hgnc_id : "HGNC:19861",
      havana_gene : "OTTHUMG00000171632.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95533503,
      stop : 95544724,
      direction : "+",
      ID : "ENSG00000182512.5",
      gene_id : "ENSG00000182512.5",
      gene_type : "protein_coding",
      gene_name : "GLRX5",
      gene_level : 2,
      hgnc_id : "HGNC:20134",
      havana_gene : "OTTHUMG00000171636.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95686426,
      stop : 95692628,
      direction : "+",
      ID : "ENSG00000213231.13",
      gene_id : "ENSG00000213231.13",
      gene_type : "protein_coding",
      gene_name : "TCL1B",
      gene_level : 2,
      hgnc_id : "HGNC:11649",
      havana_gene : "OTTHUMG00000028912.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95709947,
      stop : 95714196,
      direction : "-",
      ID : "ENSG00000100721.11",
      gene_id : "ENSG00000100721.11",
      gene_type : "protein_coding",
      gene_name : "TCL1A",
      gene_level : 2,
      hgnc_id : "HGNC:11648",
      havana_gene : "OTTHUMG00000171390.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 95876392,
      stop : 95925663,
      direction : "+",
      ID : "ENSG00000250366.3",
      gene_id : "ENSG00000250366.3",
      gene_type : "protein_coding",
      gene_name : "TUNAR",
      gene_level : 2,
      hgnc_id : "HGNC:44088",
      havana_gene : "OTTHUMG00000171392.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96039362,
      stop : 96093971,
      direction : "+",
      ID : "ENSG00000227051.7",
      gene_id : "ENSG00000227051.7",
      gene_type : "protein_coding",
      gene_name : "C14orf132",
      gene_level : 1,
      hgnc_id : "HGNC:20346",
      havana_gene : "OTTHUMG00000171393.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96204679,
      stop : 96244166,
      direction : "+",
      ID : "ENSG00000168398.7",
      gene_id : "ENSG00000168398.7",
      gene_type : "protein_coding",
      gene_name : "BDKRB2",
      gene_level : 2,
      hgnc_id : "HGNC:1030",
      havana_gene : "OTTHUMG00000171408.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96204844,
      stop : 96263929,
      direction : "+",
      ID : "ENSG00000258691.1",
      gene_id : "ENSG00000258691.1",
      gene_type : "protein_coding",
      gene_name : "AL355102.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171409.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96256210,
      stop : 96268967,
      direction : "+",
      ID : "ENSG00000100739.11",
      gene_id : "ENSG00000100739.11",
      gene_type : "protein_coding",
      gene_name : "BDKRB1",
      gene_level : 2,
      hgnc_id : "HGNC:1029",
      havana_gene : "OTTHUMG00000171412.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96279195,
      stop : 96363341,
      direction : "-",
      ID : "ENSG00000066739.12",
      gene_id : "ENSG00000066739.12",
      gene_type : "protein_coding",
      gene_name : "ATG2B",
      gene_level : 1,
      hgnc_id : "HGNC:20187",
      havana_gene : "OTTHUMG00000149933.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96363452,
      stop : 96387288,
      direction : "+",
      ID : "ENSG00000100744.15",
      gene_id : "ENSG00000100744.15",
      gene_type : "protein_coding",
      gene_name : "GSKIP",
      gene_level : 2,
      hgnc_id : "HGNC:20343",
      havana_gene : "OTTHUMG00000171420.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96392128,
      stop : 96489427,
      direction : "+",
      ID : "ENSG00000140057.9",
      gene_id : "ENSG00000140057.9",
      gene_type : "protein_coding",
      gene_name : "AK7",
      gene_level : 2,
      hgnc_id : "HGNC:20091",
      havana_gene : "OTTHUMG00000171421.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96501433,
      stop : 96567111,
      direction : "+",
      ID : "ENSG00000090060.18",
      gene_id : "ENSG00000090060.18",
      gene_type : "protein_coding",
      gene_name : "PAPOLA",
      gene_level : 1,
      hgnc_id : "HGNC:14981",
      havana_gene : "OTTHUMG00000171441.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 96797304,
      stop : 96954846,
      direction : "+",
      ID : "ENSG00000100749.9",
      gene_id : "ENSG00000100749.9",
      gene_type : "protein_coding",
      gene_name : "VRK1",
      gene_level : 2,
      hgnc_id : "HGNC:12718",
      havana_gene : "OTTHUMG00000171459.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99169287,
      stop : 99272197,
      direction : "-",
      ID : "ENSG00000127152.18",
      gene_id : "ENSG00000127152.18",
      gene_type : "protein_coding",
      gene_name : "BCL11B",
      gene_level : 2,
      hgnc_id : "HGNC:13222",
      havana_gene : "OTTHUMG00000028967.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99397748,
      stop : 99480889,
      direction : "-",
      ID : "ENSG00000183576.13",
      gene_id : "ENSG00000183576.13",
      gene_type : "protein_coding",
      gene_name : "SETD3",
      gene_level : 2,
      hgnc_id : "HGNC:20493",
      havana_gene : "OTTHUMG00000028970.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99481169,
      stop : 99535044,
      direction : "+",
      ID : "ENSG00000090061.17",
      gene_id : "ENSG00000090061.17",
      gene_type : "protein_coding",
      gene_name : "CCNK",
      gene_level : 2,
      hgnc_id : "HGNC:1596",
      havana_gene : "OTTHUMG00000171495.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99500190,
      stop : 99604207,
      direction : "-",
      ID : "ENSG00000205476.9",
      gene_id : "ENSG00000205476.9",
      gene_type : "protein_coding",
      gene_name : "CCDC85C",
      gene_level : 2,
      hgnc_id : "HGNC:35459",
      havana_gene : "OTTHUMG00000171506.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99645129,
      stop : 99680569,
      direction : "+",
      ID : "ENSG00000182218.10",
      gene_id : "ENSG00000182218.10",
      gene_type : "protein_coding",
      gene_name : "HHIPL1",
      gene_level : 2,
      hgnc_id : "HGNC:19710",
      havana_gene : "OTTHUMG00000171509.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99684298,
      stop : 99727301,
      direction : "+",
      ID : "ENSG00000036530.9",
      gene_id : "ENSG00000036530.9",
      gene_type : "protein_coding",
      gene_name : "CYP46A1",
      gene_level : 1,
      hgnc_id : "HGNC:2641",
      havana_gene : "OTTHUMG00000171510.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99737693,
      stop : 99942060,
      direction : "+",
      ID : "ENSG00000066629.18",
      gene_id : "ENSG00000066629.18",
      gene_type : "protein_coding",
      gene_name : "EML1",
      gene_level : 1,
      hgnc_id : "HGNC:3330",
      havana_gene : "OTTHUMG00000171529.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 99971449,
      stop : 100144236,
      direction : "+",
      ID : "ENSG00000196405.13",
      gene_id : "ENSG00000196405.13",
      gene_type : "protein_coding",
      gene_name : "EVL",
      gene_level : 1,
      hgnc_id : "HGNC:20234",
      havana_gene : "OTTHUMG00000171530.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100143957,
      stop : 100159645,
      direction : "-",
      ID : "ENSG00000168350.8",
      gene_id : "ENSG00000168350.8",
      gene_type : "protein_coding",
      gene_name : "DEGS2",
      gene_level : 1,
      hgnc_id : "HGNC:20113",
      havana_gene : "OTTHUMG00000171537.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100238298,
      stop : 100282788,
      direction : "+",
      ID : "ENSG00000100811.14",
      gene_id : "ENSG00000100811.14",
      gene_type : "protein_coding",
      gene_name : "YY1",
      gene_level : 1,
      hgnc_id : "HGNC:12856",
      havana_gene : "OTTHUMG00000150479.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100291116,
      stop : 100306547,
      direction : "-",
      ID : "ENSG00000197119.13",
      gene_id : "ENSG00000197119.13",
      gene_type : "protein_coding",
      gene_name : "SLC25A29",
      gene_level : 1,
      hgnc_id : "HGNC:20116",
      havana_gene : "OTTHUMG00000171569.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100323339,
      stop : 100330421,
      direction : "+",
      ID : "ENSG00000140107.12",
      gene_id : "ENSG00000140107.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A47",
      gene_level : 2,
      hgnc_id : "HGNC:20115",
      havana_gene : "OTTHUMG00000171571.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100333790,
      stop : 100376805,
      direction : "-",
      ID : "ENSG00000140105.18",
      gene_id : "ENSG00000140105.18",
      gene_type : "protein_coding",
      gene_name : "WARS1",
      gene_level : 1,
      hgnc_id : "HGNC:12729",
      havana_gene : "OTTHUMG00000171572.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100376418,
      stop : 100530303,
      direction : "+",
      ID : "ENSG00000176473.13",
      gene_id : "ENSG00000176473.13",
      gene_type : "protein_coding",
      gene_name : "WDR25",
      gene_level : 2,
      hgnc_id : "HGNC:21064",
      havana_gene : "OTTHUMG00000171585.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100537147,
      stop : 100587413,
      direction : "-",
      ID : "ENSG00000183092.16",
      gene_id : "ENSG00000183092.16",
      gene_type : "protein_coding",
      gene_name : "BEGAIN",
      gene_level : 2,
      hgnc_id : "HGNC:24163",
      havana_gene : "OTTHUMG00000171589.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100725705,
      stop : 100738224,
      direction : "+",
      ID : "ENSG00000185559.16",
      gene_id : "ENSG00000185559.16",
      gene_type : "protein_coding",
      gene_name : "DLK1",
      gene_level : 2,
      hgnc_id : "HGNC:2907",
      havana_gene : "OTTHUMG00000171600.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 100879753,
      stop : 100903722,
      direction : "-",
      ID : "ENSG00000254656.3",
      gene_id : "ENSG00000254656.3",
      gene_type : "protein_coding",
      gene_name : "RTL1",
      gene_level : 2,
      hgnc_id : "HGNC:14665",
      havana_gene : "OTTHUMG00000167573.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 101561351,
      stop : 101563452,
      direction : "+",
      ID : "ENSG00000197406.7",
      gene_id : "ENSG00000197406.7",
      gene_type : "protein_coding",
      gene_name : "DIO3",
      gene_level : 2,
      hgnc_id : "HGNC:2885",
      havana_gene : "OTTHUMG00000160681.4",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 101761798,
      stop : 101927989,
      direction : "+",
      ID : "ENSG00000078304.19",
      gene_id : "ENSG00000078304.19",
      gene_type : "protein_coding",
      gene_name : "PPP2R5C",
      gene_level : 1,
      hgnc_id : "HGNC:9311",
      havana_gene : "OTTHUMG00000171597.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 101964573,
      stop : 102056443,
      direction : "+",
      ID : "ENSG00000197102.13",
      gene_id : "ENSG00000197102.13",
      gene_type : "protein_coding",
      gene_name : "DYNC1H1",
      gene_level : 1,
      hgnc_id : "HGNC:2961",
      havana_gene : "OTTHUMG00000171644.11",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102080742,
      stop : 102139699,
      direction : "-",
      ID : "ENSG00000080824.19",
      gene_id : "ENSG00000080824.19",
      gene_type : "protein_coding",
      gene_name : "HSP90AA1",
      gene_level : 2,
      hgnc_id : "HGNC:5253",
      havana_gene : "OTTHUMG00000171752.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102139503,
      stop : 102224847,
      direction : "+",
      ID : "ENSG00000140153.18",
      gene_id : "ENSG00000140153.18",
      gene_type : "protein_coding",
      gene_name : "WDR20",
      gene_level : 1,
      hgnc_id : "HGNC:19667",
      havana_gene : "OTTHUMG00000171753.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102224500,
      stop : 102305190,
      direction : "-",
      ID : "ENSG00000080823.23",
      gene_id : "ENSG00000080823.23",
      gene_type : "protein_coding",
      gene_name : "MOK",
      gene_level : 1,
      hgnc_id : "HGNC:9833",
      havana_gene : "OTTHUMG00000164896.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102317377,
      stop : 102342702,
      direction : "+",
      ID : "ENSG00000022976.16",
      gene_id : "ENSG00000022976.16",
      gene_type : "protein_coding",
      gene_name : "ZNF839",
      gene_level : 1,
      hgnc_id : "HGNC:20345",
      havana_gene : "OTTHUMG00000171864.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102341102,
      stop : 102362916,
      direction : "-",
      ID : "ENSG00000100865.15",
      gene_id : "ENSG00000100865.15",
      gene_type : "protein_coding",
      gene_name : "CINP",
      gene_level : 2,
      hgnc_id : "HGNC:23789",
      havana_gene : "OTTHUMG00000171775.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102362941,
      stop : 102502477,
      direction : "+",
      ID : "ENSG00000196663.16",
      gene_id : "ENSG00000196663.16",
      gene_type : "protein_coding",
      gene_name : "TECPR2",
      gene_level : 2,
      hgnc_id : "HGNC:19957",
      havana_gene : "OTTHUMG00000171776.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102501767,
      stop : 102509799,
      direction : "-",
      ID : "ENSG00000156381.9",
      gene_id : "ENSG00000156381.9",
      gene_type : "protein_coding",
      gene_name : "ANKRD9",
      gene_level : 2,
      hgnc_id : "HGNC:20096",
      havana_gene : "OTTHUMG00000171777.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102592649,
      stop : 102730561,
      direction : "+",
      ID : "ENSG00000089902.10",
      gene_id : "ENSG00000089902.10",
      gene_type : "protein_coding",
      gene_name : "RCOR1",
      gene_level : 2,
      hgnc_id : "HGNC:17441",
      havana_gene : "OTTHUMG00000171778.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102777449,
      stop : 102911500,
      direction : "+",
      ID : "ENSG00000131323.16",
      gene_id : "ENSG00000131323.16",
      gene_type : "protein_coding",
      gene_name : "TRAF3",
      gene_level : 1,
      hgnc_id : "HGNC:12033",
      havana_gene : "OTTHUMG00000171902.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102922663,
      stop : 102933596,
      direction : "+",
      ID : "ENSG00000166126.11",
      gene_id : "ENSG00000166126.11",
      gene_type : "protein_coding",
      gene_name : "AMN",
      gene_level : 2,
      hgnc_id : "HGNC:14604",
      havana_gene : "OTTHUMG00000171897.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 102932380,
      stop : 103057549,
      direction : "-",
      ID : "ENSG00000198752.11",
      gene_id : "ENSG00000198752.11",
      gene_type : "protein_coding",
      gene_name : "CDC42BPB",
      gene_level : 1,
      hgnc_id : "HGNC:1738",
      havana_gene : "OTTHUMG00000171898.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103084210,
      stop : 103090027,
      direction : "+",
      ID : "ENSG00000283071.1",
      gene_id : "ENSG00000283071.1",
      gene_type : "protein_coding",
      gene_name : "LBHD2",
      gene_level : 2,
      hgnc_id : "HGNC:52384",
      havana_gene : "OTTHUMG00000191553.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103100144,
      stop : 103110559,
      direction : "+",
      ID : "ENSG00000205436.7",
      gene_id : "ENSG00000205436.7",
      gene_type : "protein_coding",
      gene_name : "EXOC3L4",
      gene_level : 2,
      hgnc_id : "HGNC:20120",
      havana_gene : "OTTHUMG00000171888.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103121476,
      stop : 103137439,
      direction : "+",
      ID : "ENSG00000185215.11",
      gene_id : "ENSG00000185215.11",
      gene_type : "protein_coding",
      gene_name : "TNFAIP2",
      gene_level : 2,
      hgnc_id : "HGNC:11895",
      havana_gene : "OTTHUMG00000171890.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103333544,
      stop : 103345025,
      direction : "+",
      ID : "ENSG00000100664.11",
      gene_id : "ENSG00000100664.11",
      gene_type : "protein_coding",
      gene_name : "EIF5",
      gene_level : 1,
      hgnc_id : "HGNC:3299",
      havana_gene : "OTTHUMG00000171839.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103385377,
      stop : 103503831,
      direction : "+",
      ID : "ENSG00000075413.19",
      gene_id : "ENSG00000075413.19",
      gene_type : "protein_coding",
      gene_name : "MARK3",
      gene_level : 1,
      hgnc_id : "HGNC:6897",
      havana_gene : "OTTHUMG00000171789.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103519667,
      stop : 103522833,
      direction : "-",
      ID : "ENSG00000166165.13",
      gene_id : "ENSG00000166165.13",
      gene_type : "protein_coding",
      gene_name : "CKB",
      gene_level : 2,
      hgnc_id : "HGNC:1991",
      havana_gene : "OTTHUMG00000171786.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103529196,
      stop : 103537073,
      direction : "+",
      ID : "ENSG00000166166.13",
      gene_id : "ENSG00000166166.13",
      gene_type : "protein_coding",
      gene_name : "TRMT61A",
      gene_level : 2,
      hgnc_id : "HGNC:23790",
      havana_gene : "OTTHUMG00000171762.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103556545,
      stop : 103562657,
      direction : "-",
      ID : "ENSG00000166170.11",
      gene_id : "ENSG00000166170.11",
      gene_type : "protein_coding",
      gene_name : "BAG5",
      gene_level : 2,
      hgnc_id : "HGNC:941",
      havana_gene : "OTTHUMG00000171763.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103561896,
      stop : 103714249,
      direction : "+",
      ID : "ENSG00000126214.21",
      gene_id : "ENSG00000126214.21",
      gene_type : "protein_coding",
      gene_name : "KLC1",
      gene_level : 1,
      hgnc_id : "HGNC:6387",
      havana_gene : "OTTHUMG00000169227.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103562960,
      stop : 103607523,
      direction : "+",
      ID : "ENSG00000256053.9",
      gene_id : "ENSG00000256053.9",
      gene_type : "protein_coding",
      gene_name : "COA8",
      gene_level : 1,
      hgnc_id : "HGNC:20492",
      havana_gene : "OTTHUMG00000153929.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103562962,
      stop : 103685924,
      direction : "+",
      ID : "ENSG00000256500.6",
      gene_id : "ENSG00000256500.6",
      gene_type : "protein_coding",
      gene_name : "AL139300.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000169226.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103697609,
      stop : 103715504,
      direction : "-",
      ID : "ENSG00000126215.14",
      gene_id : "ENSG00000126215.14",
      gene_type : "protein_coding",
      gene_name : "XRCC3",
      gene_level : 2,
      hgnc_id : "HGNC:12830",
      havana_gene : "OTTHUMG00000169228.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103715730,
      stop : 103733668,
      direction : "+",
      ID : "ENSG00000100711.14",
      gene_id : "ENSG00000100711.14",
      gene_type : "protein_coding",
      gene_name : "ZFYVE21",
      gene_level : 2,
      hgnc_id : "HGNC:20760",
      havana_gene : "OTTHUMG00000171651.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103733195,
      stop : 103847575,
      direction : "-",
      ID : "ENSG00000088808.18",
      gene_id : "ENSG00000088808.18",
      gene_type : "protein_coding",
      gene_name : "PPP1R13B",
      gene_level : 1,
      hgnc_id : "HGNC:14950",
      havana_gene : "OTTHUMG00000171647.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103912288,
      stop : 103928269,
      direction : "-",
      ID : "ENSG00000156411.10",
      gene_id : "ENSG00000156411.10",
      gene_type : "protein_coding",
      gene_name : "ATP5MPL",
      gene_level : 2,
      hgnc_id : "HGNC:1188",
      havana_gene : "OTTHUMG00000171601.1",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103928456,
      stop : 104052667,
      direction : "+",
      ID : "ENSG00000156414.19",
      gene_id : "ENSG00000156414.19",
      gene_type : "protein_coding",
      gene_name : "TDRD9",
      gene_level : 2,
      hgnc_id : "HGNC:20122",
      havana_gene : "OTTHUMG00000152876.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 103940426,
      stop : 103942561,
      direction : "-",
      ID : "ENSG00000227729.5",
      gene_id : "ENSG00000227729.5",
      gene_type : "protein_coding",
      gene_name : "RD3L",
      gene_level : 1,
      hgnc_id : "HGNC:40912",
      havana_gene : "OTTHUMG00000152877.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104085686,
      stop : 104115582,
      direction : "+",
      ID : "ENSG00000166183.16",
      gene_id : "ENSG00000166183.16",
      gene_type : "protein_coding",
      gene_name : "ASPG",
      gene_level : 2,
      hgnc_id : "HGNC:20123",
      havana_gene : "OTTHUMG00000170045.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104138723,
      stop : 104180894,
      direction : "+",
      ID : "ENSG00000066735.14",
      gene_id : "ENSG00000066735.14",
      gene_type : "protein_coding",
      gene_name : "KIF26A",
      gene_level : 2,
      hgnc_id : "HGNC:20226",
      havana_gene : "OTTHUMG00000154986.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104474678,
      stop : 104605647,
      direction : "-",
      ID : "ENSG00000258986.7",
      gene_id : "ENSG00000258986.7",
      gene_type : "protein_coding",
      gene_name : "TMEM179",
      gene_level : 1,
      hgnc_id : "HGNC:20137",
      havana_gene : "OTTHUMG00000170829.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104579764,
      stop : 104590515,
      direction : "+",
      ID : "ENSG00000184601.11",
      gene_id : "ENSG00000184601.11",
      gene_type : "protein_coding",
      gene_name : "C14orf180",
      gene_level : 2,
      hgnc_id : "HGNC:33795",
      havana_gene : "OTTHUMG00000029806.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104681146,
      stop : 104722535,
      direction : "+",
      ID : "ENSG00000203485.14",
      gene_id : "ENSG00000203485.14",
      gene_type : "protein_coding",
      gene_name : "INF2",
      gene_level : 1,
      hgnc_id : "HGNC:23791",
      havana_gene : "OTTHUMG00000029811.11",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104724229,
      stop : 104747325,
      direction : "+",
      ID : "ENSG00000185100.11",
      gene_id : "ENSG00000185100.11",
      gene_type : "protein_coding",
      gene_name : "ADSS1",
      gene_level : 1,
      hgnc_id : "HGNC:20093",
      havana_gene : "OTTHUMG00000170818.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104753147,
      stop : 104768494,
      direction : "+",
      ID : "ENSG00000184990.13",
      gene_id : "ENSG00000184990.13",
      gene_type : "protein_coding",
      gene_name : "SIVA1",
      gene_level : 2,
      hgnc_id : "HGNC:17712",
      havana_gene : "OTTHUMG00000170819.4",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104769349,
      stop : 104795751,
      direction : "-",
      ID : "ENSG00000142208.17",
      gene_id : "ENSG00000142208.17",
      gene_type : "protein_coding",
      gene_name : "AKT1",
      gene_level : 1,
      hgnc_id : "HGNC:391",
      havana_gene : "OTTHUMG00000170795.7",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104800596,
      stop : 104804712,
      direction : "+",
      ID : "ENSG00000179627.10",
      gene_id : "ENSG00000179627.10",
      gene_type : "protein_coding",
      gene_name : "ZBTB42",
      gene_level : 2,
      hgnc_id : "HGNC:32550",
      havana_gene : "OTTHUMG00000170790.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104865268,
      stop : 104896770,
      direction : "+",
      ID : "ENSG00000099814.16",
      gene_id : "ENSG00000099814.16",
      gene_type : "protein_coding",
      gene_name : "CEP170B",
      gene_level : 2,
      hgnc_id : "HGNC:20362",
      havana_gene : "OTTHUMG00000170763.3",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104924713,
      stop : 104937761,
      direction : "+",
      ID : "ENSG00000166428.14",
      gene_id : "ENSG00000166428.14",
      gene_type : "protein_coding",
      gene_name : "PLD4",
      gene_level : 2,
      hgnc_id : "HGNC:23792",
      havana_gene : "OTTHUMG00000144167.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104937244,
      stop : 104978374,
      direction : "-",
      ID : "ENSG00000185567.7",
      gene_id : "ENSG00000185567.7",
      gene_type : "protein_coding",
      gene_name : "AHNAK2",
      gene_level : 1,
      hgnc_id : "HGNC:20125",
      havana_gene : "OTTHUMG00000170765.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 104985775,
      stop : 105010482,
      direction : "+",
      ID : "ENSG00000140104.14",
      gene_id : "ENSG00000140104.14",
      gene_type : "protein_coding",
      gene_name : "CLBA1",
      gene_level : 2,
      hgnc_id : "HGNC:20126",
      havana_gene : "OTTHUMG00000170474.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105009573,
      stop : 105021083,
      direction : "-",
      ID : "ENSG00000170779.11",
      gene_id : "ENSG00000170779.11",
      gene_type : "protein_coding",
      gene_name : "CDCA4",
      gene_level : 2,
      hgnc_id : "HGNC:14625",
      havana_gene : "OTTHUMG00000170767.2",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105049395,
      stop : 105065445,
      direction : "-",
      ID : "ENSG00000183484.12",
      gene_id : "ENSG00000183484.12",
      gene_type : "protein_coding",
      gene_name : "GPR132",
      gene_level : 1,
      hgnc_id : "HGNC:17482",
      havana_gene : "OTTHUMG00000140173.6",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105140982,
      stop : 105168824,
      direction : "-",
      ID : "ENSG00000184916.9",
      gene_id : "ENSG00000184916.9",
      gene_type : "protein_coding",
      gene_name : "JAG2",
      gene_level : 2,
      hgnc_id : "HGNC:6189",
      havana_gene : "OTTHUMG00000140172.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105172938,
      stop : 105181323,
      direction : "-",
      ID : "ENSG00000183828.15",
      gene_id : "ENSG00000183828.15",
      gene_type : "protein_coding",
      gene_name : "NUDT14",
      gene_level : 2,
      hgnc_id : "HGNC:20141",
      havana_gene : "OTTHUMG00000170372.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105209286,
      stop : 105315589,
      direction : "-",
      ID : "ENSG00000185024.17",
      gene_id : "ENSG00000185024.17",
      gene_type : "protein_coding",
      gene_name : "BRF1",
      gene_level : 2,
      hgnc_id : "HGNC:11551",
      havana_gene : "OTTHUMG00000029884.9",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105248490,
      stop : 105251093,
      direction : "+",
      ID : "ENSG00000184887.13",
      gene_id : "ENSG00000184887.13",
      gene_type : "protein_coding",
      gene_name : "BTBD6",
      gene_level : 2,
      hgnc_id : "HGNC:19897",
      havana_gene : "OTTHUMG00000029887.6",
      tag : "retrogene"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105300563,
      stop : 105398147,
      direction : "+",
      ID : "ENSG00000179364.14",
      gene_id : "ENSG00000179364.14",
      gene_type : "protein_coding",
      gene_name : "PACS2",
      gene_level : 1,
      hgnc_id : "HGNC:23794",
      havana_gene : "OTTHUMG00000170450.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105398538,
      stop : 105450106,
      direction : "+",
      ID : "ENSG00000226174.7",
      gene_id : "ENSG00000226174.7",
      gene_type : "protein_coding",
      gene_name : "TEX22",
      gene_level : 2,
      hgnc_id : "HGNC:40026",
      havana_gene : "OTTHUMG00000156137.35",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105419820,
      stop : 105470729,
      direction : "+",
      ID : "ENSG00000182979.18",
      gene_id : "ENSG00000182979.18",
      gene_type : "protein_coding",
      gene_name : "MTA1",
      gene_level : 2,
      hgnc_id : "HGNC:7410",
      havana_gene : "OTTHUMG00000150362.38",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105472962,
      stop : 105480162,
      direction : "+",
      ID : "ENSG00000182809.11",
      gene_id : "ENSG00000182809.11",
      gene_type : "protein_coding",
      gene_name : "CRIP2",
      gene_level : 1,
      hgnc_id : "HGNC:2361",
      havana_gene : "OTTHUMG00000029906.5",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105486317,
      stop : 105488947,
      direction : "+",
      ID : "ENSG00000213145.10",
      gene_id : "ENSG00000213145.10",
      gene_type : "protein_coding",
      gene_name : "CRIP1",
      gene_level : 2,
      hgnc_id : "HGNC:2360",
      havana_gene : "OTTHUMG00000029908.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105487199,
      stop : 105492267,
      direction : "+",
      ID : "ENSG00000257341.5",
      gene_id : "ENSG00000257341.5",
      gene_type : "protein_coding",
      gene_name : "AL928654.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000029910.8",
      tag : null
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105489855,
      stop : 105499575,
      direction : "+",
      ID : "ENSG00000185347.18",
      gene_id : "ENSG00000185347.18",
      gene_type : "protein_coding",
      gene_name : "TEDC1",
      gene_level : 1,
      hgnc_id : "HGNC:20127",
      havana_gene : "OTTHUMG00000170426.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 14,
      annotation : "HAVANA",
      type : "gene",
      start : 105526583,
      stop : 105530202,
      direction : "+",
      ID : "ENSG00000184986.11",
      gene_id : "ENSG00000184986.11",
      gene_type : "protein_coding",
      gene_name : "TMEM121",
      gene_level : 2,
      hgnc_id : "HGNC:20511",
      havana_gene : "OTTHUMG00000029912.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 20531856,
      stop : 20541800,
      direction : "-",
      ID : "ENSG00000277322.1",
      gene_id : "ENSG00000277322.1",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L6",
      gene_level : 2,
      hgnc_id : "HGNC:37225",
      havana_gene : "OTTHUMG00000171663.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 20835372,
      stop : 20866314,
      direction : "-",
      ID : "ENSG00000230031.10",
      gene_id : "ENSG00000230031.10",
      gene_type : "protein_coding",
      gene_name : "POTEB2",
      gene_level : 2,
      hgnc_id : "HGNC:48327",
      havana_gene : "OTTHUMG00000185829.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 21405401,
      stop : 21440499,
      direction : "-",
      ID : "ENSG00000278522.5",
      gene_id : "ENSG00000278522.5",
      gene_type : "protein_coding",
      gene_name : "POTEB3",
      gene_level : 2,
      hgnc_id : "HGNC:51240",
      havana_gene : "OTTHUMG00000189222.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 21552795,
      stop : 21653276,
      direction : "+",
      ID : "ENSG00000280709.2",
      gene_id : "ENSG00000280709.2",
      gene_type : "protein_coding",
      gene_name : "LINC02203",
      gene_level : 2,
      hgnc_id : "HGNC:53069",
      havana_gene : "OTTHUMG00000192385.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 21637909,
      stop : 21638992,
      direction : "+",
      ID : "ENSG00000182974.3",
      gene_id : "ENSG00000182974.3",
      gene_type : "protein_coding",
      gene_name : "OR4M2B",
      gene_level : 2,
      hgnc_id : "HGNC:55109",
      havana_gene : "OTTHUMG00000189317.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 21651844,
      stop : 21652968,
      direction : "+",
      ID : "ENSG00000279408.3",
      gene_id : "ENSG00000279408.3",
      gene_type : "protein_coding",
      gene_name : "OR4N4C",
      gene_level : 2,
      hgnc_id : "HGNC:55110",
      havana_gene : "OTTHUMG00000190198.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 21846329,
      stop : 21877735,
      direction : "-",
      ID : "ENSG00000233917.9",
      gene_id : "ENSG00000233917.9",
      gene_type : "protein_coding",
      gene_name : "POTEB",
      gene_level : 2,
      hgnc_id : "HGNC:33734",
      havana_gene : "OTTHUMG00000171734.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22015233,
      stop : 22095857,
      direction : "+",
      ID : "ENSG00000285472.1",
      gene_id : "ENSG00000285472.1",
      gene_type : "protein_coding",
      gene_name : "AC134980.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192386.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22070241,
      stop : 22083221,
      direction : "+",
      ID : "ENSG00000274102.2",
      gene_id : "ENSG00000274102.2",
      gene_type : "protein_coding",
      gene_name : "OR4M2",
      gene_level : 2,
      hgnc_id : "HGNC:15373",
      havana_gene : "OTTHUMG00000171738.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22094522,
      stop : 22095472,
      direction : "+",
      ID : "ENSG00000183706.5",
      gene_id : "ENSG00000183706.5",
      gene_type : "protein_coding",
      gene_name : "OR4N4",
      gene_level : 2,
      hgnc_id : "HGNC:15375",
      havana_gene : "OTTHUMG00000171739.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22458903,
      stop : 22469230,
      direction : "+",
      ID : "ENSG00000277865.4",
      gene_id : "ENSG00000277865.4",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L22",
      gene_level : 2,
      hgnc_id : "HGNC:50289",
      havana_gene : "OTTHUMG00000171883.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22773063,
      stop : 22829789,
      direction : "+",
      ID : "ENSG00000170113.16",
      gene_id : "ENSG00000170113.16",
      gene_type : "protein_coding",
      gene_name : "NIPA1",
      gene_level : 2,
      hgnc_id : "HGNC:17043",
      havana_gene : "OTTHUMG00000129099.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22838644,
      stop : 22869362,
      direction : "+",
      ID : "ENSG00000140157.16",
      gene_id : "ENSG00000140157.16",
      gene_type : "protein_coding",
      gene_name : "NIPA2",
      gene_level : 2,
      hgnc_id : "HGNC:17044",
      havana_gene : "OTTHUMG00000129101.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22867052,
      stop : 22981063,
      direction : "-",
      ID : "ENSG00000273749.5",
      gene_id : "ENSG00000273749.5",
      gene_type : "protein_coding",
      gene_name : "CYFIP1",
      gene_level : 2,
      hgnc_id : "HGNC:13759",
      havana_gene : "OTTHUMG00000129100.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 22983192,
      stop : 23039572,
      direction : "-",
      ID : "ENSG00000275835.5",
      gene_id : "ENSG00000275835.5",
      gene_type : "protein_coding",
      gene_name : "TUBGCP5",
      gene_level : 2,
      hgnc_id : "HGNC:18600",
      havana_gene : "OTTHUMG00000188371.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 23127066,
      stop : 23136822,
      direction : "-",
      ID : "ENSG00000273976.2",
      gene_id : "ENSG00000273976.2",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L1",
      gene_level : 2,
      hgnc_id : "HGNC:37444",
      havana_gene : "OTTHUMG00000171928.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 23354748,
      stop : 23367231,
      direction : "+",
      ID : "ENSG00000261739.2",
      gene_id : "ENSG00000261739.2",
      gene_type : "protein_coding",
      gene_name : "GOLGA8S",
      gene_level : 2,
      hgnc_id : "HGNC:44409",
      havana_gene : "OTTHUMG00000176415.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 23439038,
      stop : 23447243,
      direction : "-",
      ID : "ENSG00000174450.12",
      gene_id : "ENSG00000174450.12",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L2",
      gene_level : 2,
      hgnc_id : "HGNC:26695",
      havana_gene : "OTTHUMG00000176417.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 23565674,
      stop : 23630075,
      direction : "+",
      ID : "ENSG00000179455.10",
      gene_id : "ENSG00000179455.10",
      gene_type : "protein_coding",
      gene_name : "MKRN3",
      gene_level : 1,
      hgnc_id : "HGNC:7114",
      havana_gene : "OTTHUMG00000129160.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 23643549,
      stop : 23647867,
      direction : "-",
      ID : "ENSG00000254585.5",
      gene_id : "ENSG00000254585.5",
      gene_type : "protein_coding",
      gene_name : "MAGEL2",
      gene_level : 2,
      hgnc_id : "HGNC:6814",
      havana_gene : "OTTHUMG00000167582.6",
      tag : "retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 23685400,
      stop : 23687305,
      direction : "-",
      ID : "ENSG00000182636.8",
      gene_id : "ENSG00000182636.8",
      gene_type : "protein_coding",
      gene_name : "NDN",
      gene_level : 2,
      hgnc_id : "HGNC:7675",
      havana_gene : "OTTHUMG00000129161.4",
      tag : "retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 24675775,
      stop : 24683393,
      direction : "+",
      ID : "ENSG00000185823.5",
      gene_id : "ENSG00000185823.5",
      gene_type : "protein_coding",
      gene_name : "NPAP1",
      gene_level : 2,
      hgnc_id : "HGNC:1190",
      havana_gene : "OTTHUMG00000129179.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 24823637,
      stop : 24978723,
      direction : "+",
      ID : "ENSG00000128739.23",
      gene_id : "ENSG00000128739.23",
      gene_type : "protein_coding",
      gene_name : "SNRPN",
      gene_level : 1,
      hgnc_id : "HGNC:11164",
      havana_gene : "OTTHUMG00000129180.46",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 24954986,
      stop : 24977850,
      direction : "+",
      ID : "ENSG00000273173.5",
      gene_id : "ENSG00000273173.5",
      gene_type : "protein_coding",
      gene_name : "SNURF",
      gene_level : 2,
      hgnc_id : "HGNC:11171",
      havana_gene : "OTTHUMG00000186421.34",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 24955034,
      stop : 25000276,
      direction : "+",
      ID : "ENSG00000214265.11",
      gene_id : "ENSG00000214265.11",
      gene_type : "protein_coding",
      gene_name : "AC124312.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000129181.11",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 25333728,
      stop : 25439051,
      direction : "-",
      ID : "ENSG00000114062.22",
      gene_id : "ENSG00000114062.22",
      gene_type : "protein_coding",
      gene_name : "UBE3A",
      gene_level : 1,
      hgnc_id : "HGNC:12496",
      havana_gene : "OTTHUMG00000171548.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 25677271,
      stop : 25865184,
      direction : "-",
      ID : "ENSG00000206190.12",
      gene_id : "ENSG00000206190.12",
      gene_type : "protein_coding",
      gene_name : "ATP10A",
      gene_level : 1,
      hgnc_id : "HGNC:13542",
      havana_gene : "OTTHUMG00000171703.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 26543546,
      stop : 26939539,
      direction : "-",
      ID : "ENSG00000166206.15",
      gene_id : "ENSG00000166206.15",
      gene_type : "protein_coding",
      gene_name : "GABRB3",
      gene_level : 2,
      hgnc_id : "HGNC:4083",
      havana_gene : "OTTHUMG00000129231.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 26866911,
      stop : 26949208,
      direction : "+",
      ID : "ENSG00000186297.12",
      gene_id : "ENSG00000186297.12",
      gene_type : "protein_coding",
      gene_name : "GABRA5",
      gene_level : 2,
      hgnc_id : "HGNC:4079",
      havana_gene : "OTTHUMG00000171824.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 26971181,
      stop : 27541984,
      direction : "+",
      ID : "ENSG00000182256.13",
      gene_id : "ENSG00000182256.13",
      gene_type : "protein_coding",
      gene_name : "GABRG3",
      gene_level : 1,
      hgnc_id : "HGNC:4088",
      havana_gene : "OTTHUMG00000044462.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 27754875,
      stop : 28099315,
      direction : "-",
      ID : "ENSG00000104044.16",
      gene_id : "ENSG00000104044.16",
      gene_type : "protein_coding",
      gene_name : "OCA2",
      gene_level : 1,
      hgnc_id : "HGNC:8101",
      havana_gene : "OTTHUMG00000128871.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 28111040,
      stop : 28322179,
      direction : "-",
      ID : "ENSG00000128731.18",
      gene_id : "ENSG00000128731.18",
      gene_type : "protein_coding",
      gene_name : "HERC2",
      gene_level : 1,
      hgnc_id : "HGNC:4868",
      havana_gene : "OTTHUMG00000129251.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 28378621,
      stop : 28392018,
      direction : "+",
      ID : "ENSG00000153684.15",
      gene_id : "ENSG00000153684.15",
      gene_type : "protein_coding",
      gene_name : "GOLGA8F",
      gene_level : 2,
      hgnc_id : "HGNC:32378",
      havana_gene : "OTTHUMG00000167129.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 28519611,
      stop : 28533014,
      direction : "-",
      ID : "ENSG00000183629.13",
      gene_id : "ENSG00000183629.13",
      gene_type : "protein_coding",
      gene_name : "GOLGA8G",
      gene_level : 2,
      hgnc_id : "HGNC:25328",
      havana_gene : "OTTHUMG00000167134.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 28701954,
      stop : 28738384,
      direction : "-",
      ID : "ENSG00000188626.6",
      gene_id : "ENSG00000188626.6",
      gene_type : "protein_coding",
      gene_name : "GOLGA8M",
      gene_level : 2,
      hgnc_id : "HGNC:44404",
      havana_gene : "OTTHUMG00000176338.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 28841833,
      stop : 28848675,
      direction : "-",
      ID : "ENSG00000261649.6",
      gene_id : "ENSG00000261649.6",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L7",
      gene_level : 2,
      hgnc_id : "HGNC:37442",
      havana_gene : "OTTHUMG00000176345.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 28884483,
      stop : 29118315,
      direction : "+",
      ID : "ENSG00000034053.14",
      gene_id : "ENSG00000034053.14",
      gene_type : "protein_coding",
      gene_name : "APBA2",
      gene_level : 2,
      hgnc_id : "HGNC:579",
      havana_gene : "OTTHUMG00000129255.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 29120254,
      stop : 29570723,
      direction : "-",
      ID : "ENSG00000104059.4",
      gene_id : "ENSG00000104059.4",
      gene_type : "protein_coding",
      gene_name : "FAM189A1",
      gene_level : 2,
      hgnc_id : "HGNC:29075",
      havana_gene : "OTTHUMG00000172185.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 29264989,
      stop : 29269822,
      direction : "-",
      ID : "ENSG00000185115.6",
      gene_id : "ENSG00000185115.6",
      gene_type : "protein_coding",
      gene_name : "NSMCE3",
      gene_level : 2,
      hgnc_id : "HGNC:7677",
      havana_gene : "OTTHUMG00000129261.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 29699367,
      stop : 29968915,
      direction : "-",
      ID : "ENSG00000104067.17",
      gene_id : "ENSG00000104067.17",
      gene_type : "protein_coding",
      gene_name : "TJP1",
      gene_level : 1,
      hgnc_id : "HGNC:11827",
      havana_gene : "OTTHUMG00000137397.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30083053,
      stop : 30093499,
      direction : "+",
      ID : "ENSG00000179938.12",
      gene_id : "ENSG00000179938.12",
      gene_type : "protein_coding",
      gene_name : "GOLGA8J",
      gene_level : 2,
      hgnc_id : "HGNC:38650",
      havana_gene : "OTTHUMG00000175635.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30135149,
      stop : 30145567,
      direction : "+",
      ID : "ENSG00000261247.1",
      gene_id : "ENSG00000261247.1",
      gene_type : "protein_coding",
      gene_name : "GOLGA8T",
      gene_level : 2,
      hgnc_id : "HGNC:44410",
      havana_gene : "OTTHUMG00000175638.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30360566,
      stop : 30393849,
      direction : "-",
      ID : "ENSG00000166664.14",
      gene_id : "ENSG00000166664.14",
      gene_type : "protein_coding",
      gene_name : "CHRFAM7A",
      gene_level : 2,
      hgnc_id : "HGNC:15781",
      havana_gene : "OTTHUMG00000175645.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30403740,
      stop : 30414162,
      direction : "-",
      ID : "ENSG00000186399.10",
      gene_id : "ENSG00000186399.10",
      gene_type : "protein_coding",
      gene_name : "GOLGA8R",
      gene_level : 2,
      hgnc_id : "HGNC:44407",
      havana_gene : "OTTHUMG00000175646.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30552078,
      stop : 30562501,
      direction : "+",
      ID : "ENSG00000178115.11",
      gene_id : "ENSG00000178115.11",
      gene_type : "protein_coding",
      gene_name : "GOLGA8Q",
      gene_level : 2,
      hgnc_id : "HGNC:44408",
      havana_gene : "OTTHUMG00000175651.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30604126,
      stop : 30614561,
      direction : "+",
      ID : "ENSG00000261794.1",
      gene_id : "ENSG00000261794.1",
      gene_type : "protein_coding",
      gene_name : "GOLGA8H",
      gene_level : 2,
      hgnc_id : "HGNC:37443",
      havana_gene : "OTTHUMG00000175654.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30624494,
      stop : 30649529,
      direction : "+",
      ID : "ENSG00000285077.2",
      gene_id : "ENSG00000285077.2",
      gene_type : "protein_coding",
      gene_name : "ARHGAP11B",
      gene_level : 2,
      hgnc_id : "HGNC:15782",
      havana_gene : "OTTHUMG00000192491.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30624548,
      stop : 30685606,
      direction : "+",
      ID : "ENSG00000284906.2",
      gene_id : "ENSG00000284906.2",
      gene_type : "protein_coding",
      gene_name : "AC091057.5",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192512.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30890559,
      stop : 30943108,
      direction : "+",
      ID : "ENSG00000198690.10",
      gene_id : "ENSG00000198690.10",
      gene_type : "protein_coding",
      gene_name : "FAN1",
      gene_level : 1,
      hgnc_id : "HGNC:29170",
      havana_gene : "OTTHUMG00000175661.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 30938941,
      stop : 30991628,
      direction : "-",
      ID : "ENSG00000166912.17",
      gene_id : "ENSG00000166912.17",
      gene_type : "protein_coding",
      gene_name : "MTMR10",
      gene_level : 1,
      hgnc_id : "HGNC:25999",
      havana_gene : "OTTHUMG00000175662.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 31001061,
      stop : 31161273,
      direction : "-",
      ID : "ENSG00000134160.14",
      gene_id : "ENSG00000134160.14",
      gene_type : "protein_coding",
      gene_name : "TRPM1",
      gene_level : 1,
      hgnc_id : "HGNC:7146",
      havana_gene : "OTTHUMG00000129267.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 31326835,
      stop : 31435665,
      direction : "+",
      ID : "ENSG00000169926.11",
      gene_id : "ENSG00000169926.11",
      gene_type : "protein_coding",
      gene_name : "KLF13",
      gene_level : 1,
      hgnc_id : "HGNC:13672",
      havana_gene : "OTTHUMG00000172224.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 31475398,
      stop : 31870789,
      direction : "-",
      ID : "ENSG00000169918.10",
      gene_id : "ENSG00000169918.10",
      gene_type : "protein_coding",
      gene_name : "OTUD7A",
      gene_level : 2,
      hgnc_id : "HGNC:20718",
      havana_gene : "OTTHUMG00000129275.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 31923438,
      stop : 32173018,
      direction : "+",
      ID : "ENSG00000175344.19",
      gene_id : "ENSG00000175344.19",
      gene_type : "protein_coding",
      gene_name : "CHRNA7",
      gene_level : 2,
      hgnc_id : "HGNC:1960",
      havana_gene : "OTTHUMG00000129285.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32392782,
      stop : 32403292,
      direction : "-",
      ID : "ENSG00000249931.4",
      gene_id : "ENSG00000249931.4",
      gene_type : "protein_coding",
      gene_name : "GOLGA8K",
      gene_level : 2,
      hgnc_id : "HGNC:38652",
      havana_gene : "OTTHUMG00000175395.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32441914,
      stop : 32455634,
      direction : "-",
      ID : "ENSG00000206127.11",
      gene_id : "ENSG00000206127.11",
      gene_type : "protein_coding",
      gene_name : "GOLGA8O",
      gene_level : 2,
      hgnc_id : "HGNC:44406",
      havana_gene : "OTTHUMG00000162878.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32593456,
      stop : 32607310,
      direction : "+",
      ID : "ENSG00000232653.8",
      gene_id : "ENSG00000232653.8",
      gene_type : "protein_coding",
      gene_name : "GOLGA8N",
      gene_level : 2,
      hgnc_id : "HGNC:44405",
      havana_gene : "OTTHUMG00000175401.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32615144,
      stop : 32639941,
      direction : "+",
      ID : "ENSG00000198826.11",
      gene_id : "ENSG00000198826.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP11A",
      gene_level : 1,
      hgnc_id : "HGNC:15783",
      havana_gene : "OTTHUMG00000129289.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32641676,
      stop : 32697098,
      direction : "+",
      ID : "ENSG00000166922.8",
      gene_id : "ENSG00000166922.8",
      gene_type : "protein_coding",
      gene_name : "SCG5",
      gene_level : 1,
      hgnc_id : "HGNC:10816",
      havana_gene : "OTTHUMG00000159447.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32718004,
      stop : 32745106,
      direction : "+",
      ID : "ENSG00000166923.12",
      gene_id : "ENSG00000166923.12",
      gene_type : "protein_coding",
      gene_name : "GREM1",
      gene_level : 2,
      hgnc_id : "HGNC:2001",
      havana_gene : "OTTHUMG00000129319.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 32765544,
      stop : 33194714,
      direction : "-",
      ID : "ENSG00000248905.10",
      gene_id : "ENSG00000248905.10",
      gene_type : "protein_coding",
      gene_name : "FMN1",
      gene_level : 1,
      hgnc_id : "HGNC:3768",
      havana_gene : "OTTHUMG00000172201.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 33310962,
      stop : 33866121,
      direction : "+",
      ID : "ENSG00000198838.14",
      gene_id : "ENSG00000198838.14",
      gene_type : "protein_coding",
      gene_name : "RYR3",
      gene_level : 2,
      hgnc_id : "HGNC:10485",
      havana_gene : "OTTHUMG00000172253.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 33858782,
      stop : 34075155,
      direction : "-",
      ID : "ENSG00000169857.9",
      gene_id : "ENSG00000169857.9",
      gene_type : "protein_coding",
      gene_name : "AVEN",
      gene_level : 2,
      hgnc_id : "HGNC:13509",
      havana_gene : "OTTHUMG00000129371.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 33968497,
      stop : 34067458,
      direction : "+",
      ID : "ENSG00000184984.10",
      gene_id : "ENSG00000184984.10",
      gene_type : "protein_coding",
      gene_name : "CHRM5",
      gene_level : 2,
      hgnc_id : "HGNC:1954",
      havana_gene : "OTTHUMG00000129369.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34084017,
      stop : 34101862,
      direction : "-",
      ID : "ENSG00000134153.10",
      gene_id : "ENSG00000134153.10",
      gene_type : "protein_coding",
      gene_name : "EMC7",
      gene_level : 1,
      hgnc_id : "HGNC:24301",
      havana_gene : "OTTHUMG00000129367.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34102083,
      stop : 34108686,
      direction : "+",
      ID : "ENSG00000182405.6",
      gene_id : "ENSG00000182405.6",
      gene_type : "protein_coding",
      gene_name : "PGBD4",
      gene_level : 1,
      hgnc_id : "HGNC:19401",
      havana_gene : "OTTHUMG00000129370.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34140674,
      stop : 34210096,
      direction : "-",
      ID : "ENSG00000134152.11",
      gene_id : "ENSG00000134152.11",
      gene_type : "protein_coding",
      gene_name : "KATNBL1",
      gene_level : 1,
      hgnc_id : "HGNC:26199",
      havana_gene : "OTTHUMG00000129368.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34225013,
      stop : 34230156,
      direction : "+",
      ID : "ENSG00000128463.13",
      gene_id : "ENSG00000128463.13",
      gene_type : "protein_coding",
      gene_name : "EMC4",
      gene_level : 1,
      hgnc_id : "HGNC:28032",
      havana_gene : "OTTHUMG00000129411.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34229784,
      stop : 34338060,
      direction : "-",
      ID : "ENSG00000140199.13",
      gene_id : "ENSG00000140199.13",
      gene_type : "protein_coding",
      gene_name : "SLC12A6",
      gene_level : 1,
      hgnc_id : "HGNC:10914",
      havana_gene : "OTTHUMG00000129441.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34341719,
      stop : 34343136,
      direction : "-",
      ID : "ENSG00000182117.6",
      gene_id : "ENSG00000182117.6",
      gene_type : "protein_coding",
      gene_name : "NOP10",
      gene_level : 1,
      hgnc_id : "HGNC:14378",
      havana_gene : "OTTHUMG00000129440.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34343315,
      stop : 34357737,
      direction : "+",
      ID : "ENSG00000184507.16",
      gene_id : "ENSG00000184507.16",
      gene_type : "protein_coding",
      gene_name : "NUTM1",
      gene_level : 1,
      hgnc_id : "HGNC:29919",
      havana_gene : "OTTHUMG00000172348.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34358633,
      stop : 34367196,
      direction : "-",
      ID : "ENSG00000176454.14",
      gene_id : "ENSG00000176454.14",
      gene_type : "protein_coding",
      gene_name : "LPCAT4",
      gene_level : 1,
      hgnc_id : "HGNC:30059",
      havana_gene : "OTTHUMG00000172349.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34379068,
      stop : 34437466,
      direction : "-",
      ID : "ENSG00000175265.17",
      gene_id : "ENSG00000175265.17",
      gene_type : "protein_coding",
      gene_name : "GOLGA8A",
      gene_level : 2,
      hgnc_id : "HGNC:31972",
      havana_gene : "OTTHUMG00000129447.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34525207,
      stop : 34588503,
      direction : "-",
      ID : "ENSG00000215252.11",
      gene_id : "ENSG00000215252.11",
      gene_type : "protein_coding",
      gene_name : "GOLGA8B",
      gene_level : 2,
      hgnc_id : "HGNC:31973",
      havana_gene : "OTTHUMG00000129549.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34751032,
      stop : 34754998,
      direction : "-",
      ID : "ENSG00000159248.5",
      gene_id : "ENSG00000159248.5",
      gene_type : "protein_coding",
      gene_name : "GJD2",
      gene_level : 2,
      hgnc_id : "HGNC:19154",
      havana_gene : "OTTHUMG00000129674.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34790230,
      stop : 34795549,
      direction : "-",
      ID : "ENSG00000159251.8",
      gene_id : "ENSG00000159251.8",
      gene_type : "protein_coding",
      gene_name : "ACTC1",
      gene_level : 2,
      hgnc_id : "HGNC:143",
      havana_gene : "OTTHUMG00000129675.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34851782,
      stop : 34969742,
      direction : "-",
      ID : "ENSG00000021776.11",
      gene_id : "ENSG00000021776.11",
      gene_type : "protein_coding",
      gene_name : "AQR",
      gene_level : 2,
      hgnc_id : "HGNC:29513",
      havana_gene : "OTTHUMG00000172257.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 34978341,
      stop : 34988287,
      direction : "-",
      ID : "ENSG00000198146.4",
      gene_id : "ENSG00000198146.4",
      gene_type : "protein_coding",
      gene_name : "ZNF770",
      gene_level : 2,
      hgnc_id : "HGNC:26061",
      havana_gene : "OTTHUMG00000129689.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 35083410,
      stop : 35085295,
      direction : "-",
      ID : "ENSG00000255192.6",
      gene_id : "ENSG00000255192.6",
      gene_type : "protein_coding",
      gene_name : "NANOGP8",
      gene_level : 2,
      hgnc_id : "HGNC:23106",
      havana_gene : "OTTHUMG00000166041.6",
      tag : "retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 35217345,
      stop : 35546193,
      direction : "-",
      ID : "ENSG00000134146.12",
      gene_id : "ENSG00000134146.12",
      gene_type : "protein_coding",
      gene_name : "DPH6",
      gene_level : 2,
      hgnc_id : "HGNC:30543",
      havana_gene : "OTTHUMG00000129759.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 36579626,
      stop : 36810248,
      direction : "+",
      ID : "ENSG00000186073.14",
      gene_id : "ENSG00000186073.14",
      gene_type : "protein_coding",
      gene_name : "CDIN1",
      gene_level : 1,
      hgnc_id : "HGNC:26929",
      havana_gene : "OTTHUMG00000172659.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 36889204,
      stop : 37101299,
      direction : "-",
      ID : "ENSG00000134138.20",
      gene_id : "ENSG00000134138.20",
      gene_type : "protein_coding",
      gene_name : "MEIS2",
      gene_level : 1,
      hgnc_id : "HGNC:7001",
      havana_gene : "OTTHUMG00000129781.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 37921939,
      stop : 37967724,
      direction : "+",
      ID : "ENSG00000166069.13",
      gene_id : "ENSG00000166069.13",
      gene_type : "protein_coding",
      gene_name : "TMCO5A",
      gene_level : 2,
      hgnc_id : "HGNC:28558",
      havana_gene : "OTTHUMG00000129787.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 38252836,
      stop : 38357249,
      direction : "+",
      ID : "ENSG00000166068.13",
      gene_id : "ENSG00000166068.13",
      gene_type : "protein_coding",
      gene_name : "SPRED1",
      gene_level : 2,
      hgnc_id : "HGNC:20249",
      havana_gene : "OTTHUMG00000172377.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 38454127,
      stop : 38487710,
      direction : "+",
      ID : "ENSG00000171262.11",
      gene_id : "ENSG00000171262.11",
      gene_type : "protein_coding",
      gene_name : "FAM98B",
      gene_level : 2,
      hgnc_id : "HGNC:26773",
      havana_gene : "OTTHUMG00000129831.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 38488103,
      stop : 38565575,
      direction : "-",
      ID : "ENSG00000172575.12",
      gene_id : "ENSG00000172575.12",
      gene_type : "protein_coding",
      gene_name : "RASGRP1",
      gene_level : 1,
      hgnc_id : "HGNC:9878",
      havana_gene : "OTTHUMG00000172379.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 39581079,
      stop : 39599466,
      direction : "+",
      ID : "ENSG00000137801.11",
      gene_id : "ENSG00000137801.11",
      gene_type : "protein_coding",
      gene_name : "THBS1",
      gene_level : 2,
      hgnc_id : "HGNC:11785",
      havana_gene : "OTTHUMG00000133665.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 39588357,
      stop : 39782841,
      direction : "-",
      ID : "ENSG00000150667.8",
      gene_id : "ENSG00000150667.8",
      gene_type : "protein_coding",
      gene_name : "FSIP1",
      gene_level : 2,
      hgnc_id : "HGNC:21674",
      havana_gene : "OTTHUMG00000172456.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 39799008,
      stop : 39920266,
      direction : "-",
      ID : "ENSG00000166073.11",
      gene_id : "ENSG00000166073.11",
      gene_type : "protein_coding",
      gene_name : "GPR176",
      gene_level : 2,
      hgnc_id : "HGNC:32370",
      havana_gene : "OTTHUMG00000129873.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 39934115,
      stop : 40035591,
      direction : "+",
      ID : "ENSG00000128829.12",
      gene_id : "ENSG00000128829.12",
      gene_type : "protein_coding",
      gene_name : "EIF2AK4",
      gene_level : 1,
      hgnc_id : "HGNC:19687",
      havana_gene : "OTTHUMG00000172403.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40035690,
      stop : 40039181,
      direction : "-",
      ID : "ENSG00000140319.11",
      gene_id : "ENSG00000140319.11",
      gene_type : "protein_coding",
      gene_name : "SRP14",
      gene_level : 2,
      hgnc_id : "HGNC:11299",
      havana_gene : "OTTHUMG00000172391.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40087890,
      stop : 40108892,
      direction : "-",
      ID : "ENSG00000104081.14",
      gene_id : "ENSG00000104081.14",
      gene_type : "protein_coding",
      gene_name : "BMF",
      gene_level : 2,
      hgnc_id : "HGNC:24132",
      havana_gene : "OTTHUMG00000129875.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40161023,
      stop : 40221123,
      direction : "+",
      ID : "ENSG00000156970.13",
      gene_id : "ENSG00000156970.13",
      gene_type : "protein_coding",
      gene_name : "BUB1B",
      gene_level : 2,
      hgnc_id : "HGNC:1149",
      havana_gene : "OTTHUMG00000129877.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40217428,
      stop : 40277487,
      direction : "+",
      ID : "ENSG00000137843.12",
      gene_id : "ENSG00000137843.12",
      gene_type : "protein_coding",
      gene_name : "PAK6",
      gene_level : 1,
      hgnc_id : "HGNC:16061",
      havana_gene : "OTTHUMG00000129921.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40218500,
      stop : 40264890,
      direction : "+",
      ID : "ENSG00000259288.7",
      gene_id : "ENSG00000259288.7",
      gene_type : "protein_coding",
      gene_name : "BUB1B-PAK6",
      gene_level : 2,
      hgnc_id : "HGNC:52276",
      havana_gene : "OTTHUMG00000172398.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40278176,
      stop : 40307935,
      direction : "-",
      ID : "ENSG00000137841.12",
      gene_id : "ENSG00000137841.12",
      gene_type : "protein_coding",
      gene_name : "PLCB2",
      gene_level : 1,
      hgnc_id : "HGNC:9055",
      havana_gene : "OTTHUMG00000172412.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40281444,
      stop : 40282586,
      direction : "-",
      ID : "ENSG00000230778.1",
      gene_id : "ENSG00000230778.1",
      gene_type : "protein_coding",
      gene_name : "ANKRD63",
      gene_level : 2,
      hgnc_id : "HGNC:40027",
      havana_gene : "OTTHUMG00000176892.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40323692,
      stop : 40326715,
      direction : "+",
      ID : "ENSG00000259330.3",
      gene_id : "ENSG00000259330.3",
      gene_type : "protein_coding",
      gene_name : "INAFM2",
      gene_level : 2,
      hgnc_id : "HGNC:35165",
      havana_gene : "OTTHUMG00000172415.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40331452,
      stop : 40340967,
      direction : "-",
      ID : "ENSG00000188549.12",
      gene_id : "ENSG00000188549.12",
      gene_type : "protein_coding",
      gene_name : "CCDC9B",
      gene_level : 2,
      hgnc_id : "HGNC:33488",
      havana_gene : "OTTHUMG00000129981.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40351033,
      stop : 40356434,
      direction : "+",
      ID : "ENSG00000233041.8",
      gene_id : "ENSG00000233041.8",
      gene_type : "protein_coding",
      gene_name : "PHGR1",
      gene_level : 2,
      hgnc_id : "HGNC:37226",
      havana_gene : "OTTHUMG00000172416.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40358219,
      stop : 40378621,
      direction : "+",
      ID : "ENSG00000140323.6",
      gene_id : "ENSG00000140323.6",
      gene_type : "protein_coding",
      gene_name : "DISP2",
      gene_level : 2,
      hgnc_id : "HGNC:19712",
      havana_gene : "OTTHUMG00000129983.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40382721,
      stop : 40394246,
      direction : "+",
      ID : "ENSG00000128944.13",
      gene_id : "ENSG00000128944.13",
      gene_type : "protein_coding",
      gene_name : "KNSTRN",
      gene_level : 2,
      hgnc_id : "HGNC:30767",
      havana_gene : "OTTHUMG00000172454.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40405485,
      stop : 40435947,
      direction : "+",
      ID : "ENSG00000128928.10",
      gene_id : "ENSG00000128928.10",
      gene_type : "protein_coding",
      gene_name : "IVD",
      gene_level : 1,
      hgnc_id : "HGNC:6186",
      havana_gene : "OTTHUMG00000129984.10",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40439721,
      stop : 40468236,
      direction : "+",
      ID : "ENSG00000140320.12",
      gene_id : "ENSG00000140320.12",
      gene_type : "protein_coding",
      gene_name : "BAHD1",
      gene_level : 2,
      hgnc_id : "HGNC:29153",
      havana_gene : "OTTHUMG00000129982.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40470984,
      stop : 40473158,
      direction : "+",
      ID : "ENSG00000169105.8",
      gene_id : "ENSG00000169105.8",
      gene_type : "protein_coding",
      gene_name : "CHST14",
      gene_level : 2,
      hgnc_id : "HGNC:24464",
      havana_gene : "OTTHUMG00000129985.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40528683,
      stop : 40565057,
      direction : "-",
      ID : "ENSG00000128891.16",
      gene_id : "ENSG00000128891.16",
      gene_type : "protein_coding",
      gene_name : "CCDC32",
      gene_level : 1,
      hgnc_id : "HGNC:28295",
      havana_gene : "OTTHUMG00000129993.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40569299,
      stop : 40574949,
      direction : "+",
      ID : "ENSG00000166133.18",
      gene_id : "ENSG00000166133.18",
      gene_type : "protein_coding",
      gene_name : "RPUSD2",
      gene_level : 1,
      hgnc_id : "HGNC:24180",
      havana_gene : "OTTHUMG00000130031.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40594020,
      stop : 40664342,
      direction : "+",
      ID : "ENSG00000137812.20",
      gene_id : "ENSG00000137812.20",
      gene_type : "protein_coding",
      gene_name : "KNL1",
      gene_level : 2,
      hgnc_id : "HGNC:24054",
      havana_gene : "OTTHUMG00000166532.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40694774,
      stop : 40732340,
      direction : "+",
      ID : "ENSG00000051180.17",
      gene_id : "ENSG00000051180.17",
      gene_type : "protein_coding",
      gene_name : "RAD51",
      gene_level : 1,
      hgnc_id : "HGNC:9817",
      havana_gene : "OTTHUMG00000130067.10",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40735884,
      stop : 40755851,
      direction : "-",
      ID : "ENSG00000137824.16",
      gene_id : "ENSG00000137824.16",
      gene_type : "protein_coding",
      gene_name : "RMDN3",
      gene_level : 1,
      hgnc_id : "HGNC:25550",
      havana_gene : "OTTHUMG00000130066.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40764068,
      stop : 40767708,
      direction : "+",
      ID : "ENSG00000137880.6",
      gene_id : "ENSG00000137880.6",
      gene_type : "protein_coding",
      gene_name : "GCHFR",
      gene_level : 1,
      hgnc_id : "HGNC:4194",
      havana_gene : "OTTHUMG00000130069.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40765161,
      stop : 40807478,
      direction : "-",
      ID : "ENSG00000104129.10",
      gene_id : "ENSG00000104129.10",
      gene_type : "protein_coding",
      gene_name : "DNAJC17",
      gene_level : 2,
      hgnc_id : "HGNC:25556",
      havana_gene : "OTTHUMG00000130065.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40769980,
      stop : 40772449,
      direction : "+",
      ID : "ENSG00000188277.10",
      gene_id : "ENSG00000188277.10",
      gene_type : "protein_coding",
      gene_name : "C15orf62",
      gene_level : 2,
      hgnc_id : "HGNC:34489",
      havana_gene : "OTTHUMG00000172536.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40807086,
      stop : 40815084,
      direction : "+",
      ID : "ENSG00000166140.17",
      gene_id : "ENSG00000166140.17",
      gene_type : "protein_coding",
      gene_name : "ZFYVE19",
      gene_level : 1,
      hgnc_id : "HGNC:20758",
      havana_gene : "OTTHUMG00000172537.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40815451,
      stop : 40828709,
      direction : "-",
      ID : "ENSG00000166143.10",
      gene_id : "ENSG00000166143.10",
      gene_type : "protein_coding",
      gene_name : "PPP1R14D",
      gene_level : 2,
      hgnc_id : "HGNC:14953",
      havana_gene : "OTTHUMG00000130064.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40844018,
      stop : 40858207,
      direction : "+",
      ID : "ENSG00000166145.14",
      gene_id : "ENSG00000166145.14",
      gene_type : "protein_coding",
      gene_name : "SPINT1",
      gene_level : 1,
      hgnc_id : "HGNC:11246",
      havana_gene : "OTTHUMG00000130068.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40872214,
      stop : 40874234,
      direction : "-",
      ID : "ENSG00000104140.7",
      gene_id : "ENSG00000104140.7",
      gene_type : "protein_coding",
      gene_name : "RHOV",
      gene_level : 2,
      hgnc_id : "HGNC:18313",
      havana_gene : "OTTHUMG00000130134.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40894450,
      stop : 40903975,
      direction : "+",
      ID : "ENSG00000104142.11",
      gene_id : "ENSG00000104142.11",
      gene_type : "protein_coding",
      gene_name : "VPS18",
      gene_level : 1,
      hgnc_id : "HGNC:15972",
      havana_gene : "OTTHUMG00000130135.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40929340,
      stop : 40939073,
      direction : "+",
      ID : "ENSG00000128917.8",
      gene_id : "ENSG00000128917.8",
      gene_type : "protein_coding",
      gene_name : "DLL4",
      gene_level : 2,
      hgnc_id : "HGNC:2910",
      havana_gene : "OTTHUMG00000172511.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40952962,
      stop : 40956512,
      direction : "+",
      ID : "ENSG00000128965.13",
      gene_id : "ENSG00000128965.13",
      gene_type : "protein_coding",
      gene_name : "CHAC1",
      gene_level : 2,
      hgnc_id : "HGNC:28680",
      havana_gene : "OTTHUMG00000130208.11",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 40978880,
      stop : 41116280,
      direction : "-",
      ID : "ENSG00000128908.17",
      gene_id : "ENSG00000128908.17",
      gene_type : "protein_coding",
      gene_name : "INO80",
      gene_level : 2,
      hgnc_id : "HGNC:26956",
      havana_gene : "OTTHUMG00000130209.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41182725,
      stop : 41230757,
      direction : "-",
      ID : "ENSG00000178997.12",
      gene_id : "ENSG00000178997.12",
      gene_type : "protein_coding",
      gene_name : "EXD1",
      gene_level : 2,
      hgnc_id : "HGNC:28507",
      havana_gene : "OTTHUMG00000130232.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41230839,
      stop : 41281887,
      direction : "+",
      ID : "ENSG00000187446.12",
      gene_id : "ENSG00000187446.12",
      gene_type : "protein_coding",
      gene_name : "CHP1",
      gene_level : 2,
      hgnc_id : "HGNC:17433",
      havana_gene : "OTTHUMG00000130233.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41284007,
      stop : 41380996,
      direction : "+",
      ID : "ENSG00000285920.2",
      gene_id : "ENSG00000285920.2",
      gene_type : "protein_coding",
      gene_name : "AC087721.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172588.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41309273,
      stop : 41332591,
      direction : "-",
      ID : "ENSG00000104147.9",
      gene_id : "ENSG00000104147.9",
      gene_type : "protein_coding",
      gene_name : "OIP5",
      gene_level : 2,
      hgnc_id : "HGNC:20300",
      havana_gene : "OTTHUMG00000130251.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41320794,
      stop : 41381050,
      direction : "+",
      ID : "ENSG00000137804.14",
      gene_id : "ENSG00000137804.14",
      gene_type : "protein_coding",
      gene_name : "NUSAP1",
      gene_level : 1,
      hgnc_id : "HGNC:18538",
      havana_gene : "OTTHUMG00000193352.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41387218,
      stop : 41409403,
      direction : "-",
      ID : "ENSG00000137806.10",
      gene_id : "ENSG00000137806.10",
      gene_type : "protein_coding",
      gene_name : "NDUFAF1",
      gene_level : 2,
      hgnc_id : "HGNC:18828",
      havana_gene : "OTTHUMG00000130340.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41408408,
      stop : 41483563,
      direction : "+",
      ID : "ENSG00000137815.14",
      gene_id : "ENSG00000137815.14",
      gene_type : "protein_coding",
      gene_name : "RTF1",
      gene_level : 2,
      hgnc_id : "HGNC:28996",
      havana_gene : "OTTHUMG00000133744.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41493393,
      stop : 41503551,
      direction : "+",
      ID : "ENSG00000137825.11",
      gene_id : "ENSG00000137825.11",
      gene_type : "protein_coding",
      gene_name : "ITPKA",
      gene_level : 2,
      hgnc_id : "HGNC:6178",
      havana_gene : "OTTHUMG00000130343.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41503637,
      stop : 41513887,
      direction : "-",
      ID : "ENSG00000062524.16",
      gene_id : "ENSG00000062524.16",
      gene_type : "protein_coding",
      gene_name : "LTK",
      gene_level : 1,
      hgnc_id : "HGNC:6721",
      havana_gene : "OTTHUMG00000130339.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41517176,
      stop : 41544269,
      direction : "-",
      ID : "ENSG00000103932.12",
      gene_id : "ENSG00000103932.12",
      gene_type : "protein_coding",
      gene_name : "RPAP1",
      gene_level : 1,
      hgnc_id : "HGNC:24567",
      havana_gene : "OTTHUMG00000130342.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41557675,
      stop : 41583589,
      direction : "+",
      ID : "ENSG00000092445.12",
      gene_id : "ENSG00000092445.12",
      gene_type : "protein_coding",
      gene_name : "TYRO3",
      gene_level : 2,
      hgnc_id : "HGNC:12446",
      havana_gene : "OTTHUMG00000130341.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41621224,
      stop : 41773081,
      direction : "+",
      ID : "ENSG00000174197.16",
      gene_id : "ENSG00000174197.16",
      gene_type : "protein_coding",
      gene_name : "MGA",
      gene_level : 1,
      hgnc_id : "HGNC:14010",
      havana_gene : "OTTHUMG00000172719.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41774434,
      stop : 41827855,
      direction : "+",
      ID : "ENSG00000137802.14",
      gene_id : "ENSG00000137802.14",
      gene_type : "protein_coding",
      gene_name : "MAPKBP1",
      gene_level : 2,
      hgnc_id : "HGNC:29536",
      havana_gene : "OTTHUMG00000160227.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41828092,
      stop : 41837581,
      direction : "+",
      ID : "ENSG00000243789.11",
      gene_id : "ENSG00000243789.11",
      gene_type : "protein_coding",
      gene_name : "JMJD7",
      gene_level : 1,
      hgnc_id : "HGNC:34397",
      havana_gene : "OTTHUMG00000156810.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41828095,
      stop : 41848155,
      direction : "+",
      ID : "ENSG00000168970.22",
      gene_id : "ENSG00000168970.22",
      gene_type : "protein_coding",
      gene_name : "JMJD7-PLA2G4B",
      gene_level : 1,
      hgnc_id : "HGNC:34449",
      havana_gene : "OTTHUMG00000044442.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41837775,
      stop : 41848147,
      direction : "+",
      ID : "ENSG00000243708.11",
      gene_id : "ENSG00000243708.11",
      gene_type : "protein_coding",
      gene_name : "PLA2G4B",
      gene_level : 2,
      hgnc_id : "HGNC:9036",
      havana_gene : "OTTHUMG00000156809.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41848146,
      stop : 41894053,
      direction : "-",
      ID : "ENSG00000137877.10",
      gene_id : "ENSG00000137877.10",
      gene_type : "protein_coding",
      gene_name : "SPTBN5",
      gene_level : 2,
      hgnc_id : "HGNC:15680",
      havana_gene : "OTTHUMG00000172720.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41895933,
      stop : 41972557,
      direction : "-",
      ID : "ENSG00000103966.11",
      gene_id : "ENSG00000103966.11",
      gene_type : "protein_coding",
      gene_name : "EHD4",
      gene_level : 2,
      hgnc_id : "HGNC:3245",
      havana_gene : "OTTHUMG00000130370.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 41981582,
      stop : 42051190,
      direction : "-",
      ID : "ENSG00000188089.13",
      gene_id : "ENSG00000188089.13",
      gene_type : "protein_coding",
      gene_name : "PLA2G4E",
      gene_level : 2,
      hgnc_id : "HGNC:24791",
      havana_gene : "OTTHUMG00000130371.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42067009,
      stop : 42094562,
      direction : "-",
      ID : "ENSG00000159337.7",
      gene_id : "ENSG00000159337.7",
      gene_type : "protein_coding",
      gene_name : "PLA2G4D",
      gene_level : 2,
      hgnc_id : "HGNC:30038",
      havana_gene : "OTTHUMG00000172587.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42139034,
      stop : 42156636,
      direction : "-",
      ID : "ENSG00000168907.13",
      gene_id : "ENSG00000168907.13",
      gene_type : "protein_coding",
      gene_name : "PLA2G4F",
      gene_level : 2,
      hgnc_id : "HGNC:27396",
      havana_gene : "OTTHUMG00000172782.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42158701,
      stop : 42208307,
      direction : "-",
      ID : "ENSG00000166887.16",
      gene_id : "ENSG00000166887.16",
      gene_type : "protein_coding",
      gene_name : "VPS39",
      gene_level : 2,
      hgnc_id : "HGNC:20593",
      havana_gene : "OTTHUMG00000130467.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42210447,
      stop : 42273584,
      direction : "-",
      ID : "ENSG00000103978.16",
      gene_id : "ENSG00000103978.16",
      gene_type : "protein_coding",
      gene_name : "TMEM87A",
      gene_level : 1,
      hgnc_id : "HGNC:24522",
      havana_gene : "OTTHUMG00000172783.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42273233,
      stop : 42356935,
      direction : "+",
      ID : "ENSG00000214013.9",
      gene_id : "ENSG00000214013.9",
      gene_type : "protein_coding",
      gene_name : "GANC",
      gene_level : 1,
      hgnc_id : "HGNC:4139",
      havana_gene : "OTTHUMG00000130487.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42348103,
      stop : 42412317,
      direction : "+",
      ID : "ENSG00000258461.5",
      gene_id : "ENSG00000258461.5",
      gene_type : "protein_coding",
      gene_name : "AC012651.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171261.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42359498,
      stop : 42412949,
      direction : "+",
      ID : "ENSG00000092529.25",
      gene_id : "ENSG00000092529.25",
      gene_type : "protein_coding",
      gene_name : "CAPN3",
      gene_level : 1,
      hgnc_id : "HGNC:1480",
      havana_gene : "OTTHUMG00000130619.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42412823,
      stop : 42491141,
      direction : "-",
      ID : "ENSG00000103994.18",
      gene_id : "ENSG00000103994.18",
      gene_type : "protein_coding",
      gene_name : "ZNF106",
      gene_level : 1,
      hgnc_id : "HGNC:12886",
      havana_gene : "OTTHUMG00000173244.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42491233,
      stop : 42545356,
      direction : "+",
      ID : "ENSG00000092531.10",
      gene_id : "ENSG00000092531.10",
      gene_type : "protein_coding",
      gene_name : "SNAP23",
      gene_level : 1,
      hgnc_id : "HGNC:11131",
      havana_gene : "OTTHUMG00000130625.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42497395,
      stop : 42548786,
      direction : "-",
      ID : "ENSG00000285942.1",
      gene_id : "ENSG00000285942.1",
      gene_type : "protein_coding",
      gene_name : "AC018362.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000130679.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42537820,
      stop : 42548802,
      direction : "-",
      ID : "ENSG00000180979.10",
      gene_id : "ENSG00000180979.10",
      gene_type : "protein_coding",
      gene_name : "LRRC57",
      gene_level : 2,
      hgnc_id : "HGNC:26719",
      havana_gene : "OTTHUMG00000193354.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42548828,
      stop : 42569994,
      direction : "+",
      ID : "ENSG00000137814.12",
      gene_id : "ENSG00000137814.12",
      gene_type : "protein_coding",
      gene_name : "HAUS2",
      gene_level : 2,
      hgnc_id : "HGNC:25530",
      havana_gene : "OTTHUMG00000130678.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42575606,
      stop : 42720998,
      direction : "+",
      ID : "ENSG00000159433.12",
      gene_id : "ENSG00000159433.12",
      gene_type : "protein_coding",
      gene_name : "STARD9",
      gene_level : 2,
      hgnc_id : "HGNC:19162",
      havana_gene : "OTTHUMG00000175799.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42723544,
      stop : 42737128,
      direction : "-",
      ID : "ENSG00000140326.13",
      gene_id : "ENSG00000140326.13",
      gene_type : "protein_coding",
      gene_name : "CDAN1",
      gene_level : 2,
      hgnc_id : "HGNC:1713",
      havana_gene : "OTTHUMG00000175801.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42738730,
      stop : 42920809,
      direction : "-",
      ID : "ENSG00000128881.17",
      gene_id : "ENSG00000128881.17",
      gene_type : "protein_coding",
      gene_name : "TTBK2",
      gene_level : 1,
      hgnc_id : "HGNC:19141",
      havana_gene : "OTTHUMG00000175802.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 42942897,
      stop : 43106113,
      direction : "-",
      ID : "ENSG00000159459.12",
      gene_id : "ENSG00000159459.12",
      gene_type : "protein_coding",
      gene_name : "UBR1",
      gene_level : 2,
      hgnc_id : "HGNC:16808",
      havana_gene : "OTTHUMG00000130702.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43123279,
      stop : 43185144,
      direction : "+",
      ID : "ENSG00000137842.7",
      gene_id : "ENSG00000137842.7",
      gene_type : "protein_coding",
      gene_name : "TMEM62",
      gene_level : 1,
      hgnc_id : "HGNC:26269",
      havana_gene : "OTTHUMG00000176485.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43185118,
      stop : 43197177,
      direction : "+",
      ID : "ENSG00000166946.14",
      gene_id : "ENSG00000166946.14",
      gene_type : "protein_coding",
      gene_name : "CCNDBP1",
      gene_level : 2,
      hgnc_id : "HGNC:1587",
      havana_gene : "OTTHUMG00000130703.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43197227,
      stop : 43221018,
      direction : "-",
      ID : "ENSG00000166947.15",
      gene_id : "ENSG00000166947.15",
      gene_type : "protein_coding",
      gene_name : "EPB42",
      gene_level : 2,
      hgnc_id : "HGNC:3381",
      havana_gene : "OTTHUMG00000130701.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43232590,
      stop : 43266928,
      direction : "-",
      ID : "ENSG00000104055.16",
      gene_id : "ENSG00000104055.16",
      gene_type : "protein_coding",
      gene_name : "TGM5",
      gene_level : 2,
      hgnc_id : "HGNC:11781",
      havana_gene : "OTTHUMG00000176488.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43276271,
      stop : 43302255,
      direction : "-",
      ID : "ENSG00000159495.8",
      gene_id : "ENSG00000159495.8",
      gene_type : "protein_coding",
      gene_name : "TGM7",
      gene_level : 2,
      hgnc_id : "HGNC:30790",
      havana_gene : "OTTHUMG00000176547.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43323649,
      stop : 43330582,
      direction : "-",
      ID : "ENSG00000168806.8",
      gene_id : "ENSG00000168806.8",
      gene_type : "protein_coding",
      gene_name : "LCMT2",
      gene_level : 1,
      hgnc_id : "HGNC:17558",
      havana_gene : "OTTHUMG00000130705.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43330672,
      stop : 43354569,
      direction : "+",
      ID : "ENSG00000168803.16",
      gene_id : "ENSG00000168803.16",
      gene_type : "protein_coding",
      gene_name : "ADAL",
      gene_level : 2,
      hgnc_id : "HGNC:31853",
      havana_gene : "OTTHUMG00000176646.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43358172,
      stop : 43371025,
      direction : "-",
      ID : "ENSG00000140265.12",
      gene_id : "ENSG00000140265.12",
      gene_type : "protein_coding",
      gene_name : "ZSCAN29",
      gene_level : 2,
      hgnc_id : "HGNC:26673",
      havana_gene : "OTTHUMG00000130767.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43369221,
      stop : 43409771,
      direction : "+",
      ID : "ENSG00000137822.13",
      gene_id : "ENSG00000137822.13",
      gene_type : "protein_coding",
      gene_name : "TUBGCP4",
      gene_level : 1,
      hgnc_id : "HGNC:16691",
      havana_gene : "OTTHUMG00000176647.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43403061,
      stop : 43510728,
      direction : "-",
      ID : "ENSG00000067369.14",
      gene_id : "ENSG00000067369.14",
      gene_type : "protein_coding",
      gene_name : "TP53BP1",
      gene_level : 1,
      hgnc_id : "HGNC:11999",
      havana_gene : "OTTHUMG00000059757.15",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43510958,
      stop : 43531620,
      direction : "+",
      ID : "ENSG00000166963.13",
      gene_id : "ENSG00000166963.13",
      gene_type : "protein_coding",
      gene_name : "MAP1A",
      gene_level : 1,
      hgnc_id : "HGNC:6835",
      havana_gene : "OTTHUMG00000059756.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43533462,
      stop : 43590253,
      direction : "-",
      ID : "ENSG00000168781.22",
      gene_id : "ENSG00000168781.22",
      gene_type : "protein_coding",
      gene_name : "PPIP5K1",
      gene_level : 1,
      hgnc_id : "HGNC:29023",
      havana_gene : "OTTHUMG00000059758.19",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43593054,
      stop : 43604901,
      direction : "+",
      ID : "ENSG00000237289.10",
      gene_id : "ENSG00000237289.10",
      gene_type : "protein_coding",
      gene_name : "CKMT1B",
      gene_level : 2,
      hgnc_id : "HGNC:1995",
      havana_gene : "OTTHUMG00000059900.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43599563,
      stop : 43618800,
      direction : "-",
      ID : "ENSG00000242866.10",
      gene_id : "ENSG00000242866.10",
      gene_type : "protein_coding",
      gene_name : "STRC",
      gene_level : 2,
      hgnc_id : "HGNC:16035",
      havana_gene : "OTTHUMG00000059899.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43614208,
      stop : 43632283,
      direction : "-",
      ID : "ENSG00000284772.1",
      gene_id : "ENSG00000284772.1",
      gene_type : "protein_coding",
      gene_name : "AC011330.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192609.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43628503,
      stop : 43668118,
      direction : "-",
      ID : "ENSG00000166762.19",
      gene_id : "ENSG00000166762.19",
      gene_type : "protein_coding",
      gene_name : "CATSPER2",
      gene_level : 2,
      hgnc_id : "HGNC:18810",
      havana_gene : "OTTHUMG00000059902.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43692886,
      stop : 43699222,
      direction : "+",
      ID : "ENSG00000223572.10",
      gene_id : "ENSG00000223572.10",
      gene_type : "protein_coding",
      gene_name : "CKMT1A",
      gene_level : 2,
      hgnc_id : "HGNC:31736",
      havana_gene : "OTTHUMG00000059898.16",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43746410,
      stop : 43773278,
      direction : "+",
      ID : "ENSG00000167004.13",
      gene_id : "ENSG00000167004.13",
      gene_type : "protein_coding",
      gene_name : "PDIA3",
      gene_level : 2,
      hgnc_id : "HGNC:4606",
      havana_gene : "OTTHUMG00000044444.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43772605,
      stop : 43777315,
      direction : "-",
      ID : "ENSG00000128886.12",
      gene_id : "ENSG00000128886.12",
      gene_type : "protein_coding",
      gene_name : "ELL3",
      gene_level : 2,
      hgnc_id : "HGNC:23113",
      havana_gene : "OTTHUMG00000059936.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43772617,
      stop : 43799133,
      direction : "-",
      ID : "ENSG00000262560.1",
      gene_id : "ENSG00000262560.1",
      gene_type : "protein_coding",
      gene_name : "AC018512.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000177927.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43777087,
      stop : 43804427,
      direction : "+",
      ID : "ENSG00000140264.21",
      gene_id : "ENSG00000140264.21",
      gene_type : "protein_coding",
      gene_name : "SERF2",
      gene_level : 1,
      hgnc_id : "HGNC:10757",
      havana_gene : "OTTHUMG00000059935.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43794162,
      stop : 43800221,
      direction : "-",
      ID : "ENSG00000184716.13",
      gene_id : "ENSG00000184716.13",
      gene_type : "protein_coding",
      gene_name : "SERINC4",
      gene_level : 1,
      hgnc_id : "HGNC:32237",
      havana_gene : "OTTHUMG00000060144.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43796142,
      stop : 43804427,
      direction : "+",
      ID : "ENSG00000242028.8",
      gene_id : "ENSG00000242028.8",
      gene_type : "protein_coding",
      gene_name : "HYPK",
      gene_level : 2,
      hgnc_id : "HGNC:18418",
      havana_gene : "OTTHUMG00000060146.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43804492,
      stop : 43824690,
      direction : "-",
      ID : "ENSG00000140259.7",
      gene_id : "ENSG00000140259.7",
      gene_type : "protein_coding",
      gene_name : "MFAP1",
      gene_level : 2,
      hgnc_id : "HGNC:7032",
      havana_gene : "OTTHUMG00000060145.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43826980,
      stop : 43868412,
      direction : "+",
      ID : "ENSG00000092470.12",
      gene_id : "ENSG00000092470.12",
      gene_type : "protein_coding",
      gene_name : "WDR76",
      gene_level : 1,
      hgnc_id : "HGNC:25773",
      havana_gene : "OTTHUMG00000060143.12",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 43870761,
      stop : 44195271,
      direction : "-",
      ID : "ENSG00000171877.21",
      gene_id : "ENSG00000171877.21",
      gene_type : "protein_coding",
      gene_name : "FRMD5",
      gene_level : 1,
      hgnc_id : "HGNC:28214",
      havana_gene : "OTTHUMG00000060475.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44288719,
      stop : 44415758,
      direction : "+",
      ID : "ENSG00000166734.20",
      gene_id : "ENSG00000166734.20",
      gene_type : "protein_coding",
      gene_name : "GOLM2",
      gene_level : 1,
      hgnc_id : "HGNC:24892",
      havana_gene : "OTTHUMG00000131133.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44427622,
      stop : 44529038,
      direction : "+",
      ID : "ENSG00000137770.14",
      gene_id : "ENSG00000137770.14",
      gene_type : "protein_coding",
      gene_name : "CTDSPL2",
      gene_level : 2,
      hgnc_id : "HGNC:26936",
      havana_gene : "OTTHUMG00000131159.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44537125,
      stop : 44563029,
      direction : "+",
      ID : "ENSG00000104131.13",
      gene_id : "ENSG00000104131.13",
      gene_type : "protein_coding",
      gene_name : "EIF3J",
      gene_level : 1,
      hgnc_id : "HGNC:3270",
      havana_gene : "OTTHUMG00000131158.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44562696,
      stop : 44663678,
      direction : "-",
      ID : "ENSG00000104133.15",
      gene_id : "ENSG00000104133.15",
      gene_type : "protein_coding",
      gene_name : "SPG11",
      gene_level : 1,
      hgnc_id : "HGNC:11226",
      havana_gene : "OTTHUMG00000131199.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44665732,
      stop : 44711316,
      direction : "-",
      ID : "ENSG00000229474.7",
      gene_id : "ENSG00000229474.7",
      gene_type : "protein_coding",
      gene_name : "PATL2",
      gene_level : 1,
      hgnc_id : "HGNC:33630",
      havana_gene : "OTTHUMG00000171932.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44711487,
      stop : 44718851,
      direction : "+",
      ID : "ENSG00000166710.21",
      gene_id : "ENSG00000166710.21",
      gene_type : "protein_coding",
      gene_name : "B2M",
      gene_level : 2,
      hgnc_id : "HGNC:914",
      havana_gene : "OTTHUMG00000131247.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44728988,
      stop : 44767829,
      direction : "+",
      ID : "ENSG00000185880.13",
      gene_id : "ENSG00000185880.13",
      gene_type : "protein_coding",
      gene_name : "TRIM69",
      gene_level : 1,
      hgnc_id : "HGNC:17857",
      havana_gene : "OTTHUMG00000131246.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 44956687,
      stop : 44979229,
      direction : "+",
      ID : "ENSG00000167014.11",
      gene_id : "ENSG00000167014.11",
      gene_type : "protein_coding",
      gene_name : "TERB2",
      gene_level : 2,
      hgnc_id : "HGNC:28520",
      havana_gene : "OTTHUMG00000131264.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45023147,
      stop : 45077185,
      direction : "+",
      ID : "ENSG00000140263.15",
      gene_id : "ENSG00000140263.15",
      gene_type : "protein_coding",
      gene_name : "SORD",
      gene_level : 2,
      hgnc_id : "HGNC:11184",
      havana_gene : "OTTHUMG00000131265.12",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45092650,
      stop : 45114172,
      direction : "-",
      ID : "ENSG00000140279.13",
      gene_id : "ENSG00000140279.13",
      gene_type : "protein_coding",
      gene_name : "DUOX2",
      gene_level : 2,
      hgnc_id : "HGNC:13273",
      havana_gene : "OTTHUMG00000131355.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45114326,
      stop : 45118421,
      direction : "+",
      ID : "ENSG00000140274.14",
      gene_id : "ENSG00000140274.14",
      gene_type : "protein_coding",
      gene_name : "DUOXA2",
      gene_level : 2,
      hgnc_id : "HGNC:32698",
      havana_gene : "OTTHUMG00000131354.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45117367,
      stop : 45129938,
      direction : "-",
      ID : "ENSG00000140254.12",
      gene_id : "ENSG00000140254.12",
      gene_type : "protein_coding",
      gene_name : "DUOXA1",
      gene_level : 2,
      hgnc_id : "HGNC:26507",
      havana_gene : "OTTHUMG00000131352.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45129933,
      stop : 45165576,
      direction : "+",
      ID : "ENSG00000137857.17",
      gene_id : "ENSG00000137857.17",
      gene_type : "protein_coding",
      gene_name : "DUOX1",
      gene_level : 2,
      hgnc_id : "HGNC:3062",
      havana_gene : "OTTHUMG00000171987.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45167214,
      stop : 45201175,
      direction : "-",
      ID : "ENSG00000138606.19",
      gene_id : "ENSG00000138606.19",
      gene_type : "protein_coding",
      gene_name : "SHF",
      gene_level : 1,
      hgnc_id : "HGNC:25116",
      havana_gene : "OTTHUMG00000131353.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45252234,
      stop : 45277846,
      direction : "+",
      ID : "ENSG00000137860.12",
      gene_id : "ENSG00000137860.12",
      gene_type : "protein_coding",
      gene_name : "SLC28A2",
      gene_level : 2,
      hgnc_id : "HGNC:11002",
      havana_gene : "OTTHUMG00000131426.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45361124,
      stop : 45402327,
      direction : "-",
      ID : "ENSG00000171766.17",
      gene_id : "ENSG00000171766.17",
      gene_type : "protein_coding",
      gene_name : "GATM",
      gene_level : 2,
      hgnc_id : "HGNC:4175",
      havana_gene : "OTTHUMG00000131427.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45402336,
      stop : 45421415,
      direction : "+",
      ID : "ENSG00000171763.20",
      gene_id : "ENSG00000171763.20",
      gene_type : "protein_coding",
      gene_name : "SPATA5L1",
      gene_level : 1,
      hgnc_id : "HGNC:28762",
      havana_gene : "OTTHUMG00000131425.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45430579,
      stop : 45448761,
      direction : "+",
      ID : "ENSG00000166920.13",
      gene_id : "ENSG00000166920.13",
      gene_type : "protein_coding",
      gene_name : "C15orf48",
      gene_level : 2,
      hgnc_id : "HGNC:29898",
      havana_gene : "OTTHUMG00000131424.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45479606,
      stop : 45522755,
      direction : "-",
      ID : "ENSG00000104154.7",
      gene_id : "ENSG00000104154.7",
      gene_type : "protein_coding",
      gene_name : "SLC30A4",
      gene_level : 1,
      hgnc_id : "HGNC:11015",
      havana_gene : "OTTHUMG00000131439.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45587214,
      stop : 45615945,
      direction : "+",
      ID : "ENSG00000104164.12",
      gene_id : "ENSG00000104164.12",
      gene_type : "protein_coding",
      gene_name : "BLOC1S6",
      gene_level : 1,
      hgnc_id : "HGNC:8549",
      havana_gene : "OTTHUMG00000131477.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45587351,
      stop : 45676314,
      direction : "+",
      ID : "ENSG00000260170.1",
      gene_id : "ENSG00000260170.1",
      gene_type : "protein_coding",
      gene_name : "AC090527.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000172725.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 45631148,
      stop : 45691281,
      direction : "+",
      ID : "ENSG00000137767.14",
      gene_id : "ENSG00000137767.14",
      gene_type : "protein_coding",
      gene_name : "SQOR",
      gene_level : 2,
      hgnc_id : "HGNC:20390",
      havana_gene : "OTTHUMG00000131476.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 47184101,
      stop : 47774228,
      direction : "+",
      ID : "ENSG00000137872.17",
      gene_id : "ENSG00000137872.17",
      gene_type : "protein_coding",
      gene_name : "SEMA6D",
      gene_level : 2,
      hgnc_id : "HGNC:16770",
      havana_gene : "OTTHUMG00000172110.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48120990,
      stop : 48142672,
      direction : "+",
      ID : "ENSG00000188467.11",
      gene_id : "ENSG00000188467.11",
      gene_type : "protein_coding",
      gene_name : "SLC24A5",
      gene_level : 2,
      hgnc_id : "HGNC:20611",
      havana_gene : "OTTHUMG00000131494.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48134632,
      stop : 48178353,
      direction : "-",
      ID : "ENSG00000104177.18",
      gene_id : "ENSG00000104177.18",
      gene_type : "protein_coding",
      gene_name : "MYEF2",
      gene_level : 2,
      hgnc_id : "HGNC:17940",
      havana_gene : "OTTHUMG00000172120.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48178122,
      stop : 48203758,
      direction : "+",
      ID : "ENSG00000233932.6",
      gene_id : "ENSG00000233932.6",
      gene_type : "protein_coding",
      gene_name : "CTXN2",
      gene_level : 2,
      hgnc_id : "HGNC:31109",
      havana_gene : "OTTHUMG00000172152.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48178438,
      stop : 48304078,
      direction : "+",
      ID : "ENSG00000074803.20",
      gene_id : "ENSG00000074803.20",
      gene_type : "protein_coding",
      gene_name : "SLC12A1",
      gene_level : 1,
      hgnc_id : "HGNC:10910",
      havana_gene : "OTTHUMG00000131495.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48331011,
      stop : 48343373,
      direction : "+",
      ID : "ENSG00000128951.14",
      gene_id : "ENSG00000128951.14",
      gene_type : "protein_coding",
      gene_name : "DUT",
      gene_level : 1,
      hgnc_id : "HGNC:3078",
      havana_gene : "OTTHUMG00000172155.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48408313,
      stop : 48645721,
      direction : "-",
      ID : "ENSG00000166147.14",
      gene_id : "ENSG00000166147.14",
      gene_type : "protein_coding",
      gene_name : "FBN1",
      gene_level : 1,
      hgnc_id : "HGNC:3603",
      havana_gene : "OTTHUMG00000172218.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48712928,
      stop : 48811146,
      direction : "-",
      ID : "ENSG00000103995.14",
      gene_id : "ENSG00000103995.14",
      gene_type : "protein_coding",
      gene_name : "CEP152",
      gene_level : 1,
      hgnc_id : "HGNC:29298",
      havana_gene : "OTTHUMG00000172219.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48823741,
      stop : 48963919,
      direction : "-",
      ID : "ENSG00000185634.12",
      gene_id : "ENSG00000185634.12",
      gene_type : "protein_coding",
      gene_name : "SHC4",
      gene_level : 2,
      hgnc_id : "HGNC:16743",
      havana_gene : "OTTHUMG00000131513.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48878134,
      stop : 48880173,
      direction : "+",
      ID : "ENSG00000255302.5",
      gene_id : "ENSG00000255302.5",
      gene_type : "protein_coding",
      gene_name : "EID1",
      gene_level : 1,
      hgnc_id : "HGNC:1191",
      havana_gene : "OTTHUMG00000165911.3",
      tag : "retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 48988476,
      stop : 49046447,
      direction : "-",
      ID : "ENSG00000138593.9",
      gene_id : "ENSG00000138593.9",
      gene_type : "protein_coding",
      gene_name : "SECISBP2L",
      gene_level : 1,
      hgnc_id : "HGNC:28997",
      havana_gene : "OTTHUMG00000172194.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 49106068,
      stop : 49155661,
      direction : "-",
      ID : "ENSG00000166200.15",
      gene_id : "ENSG00000166200.15",
      gene_type : "protein_coding",
      gene_name : "COPS2",
      gene_level : 2,
      hgnc_id : "HGNC:30747",
      havana_gene : "OTTHUMG00000172324.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 49155656,
      stop : 49367869,
      direction : "+",
      ID : "ENSG00000156958.15",
      gene_id : "ENSG00000156958.15",
      gene_type : "protein_coding",
      gene_name : "GALK2",
      gene_level : 1,
      hgnc_id : "HGNC:4119",
      havana_gene : "OTTHUMG00000172325.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 49326962,
      stop : 49620929,
      direction : "-",
      ID : "ENSG00000166262.16",
      gene_id : "ENSG00000166262.16",
      gene_type : "protein_coding",
      gene_name : "FAM227B",
      gene_level : 1,
      hgnc_id : "HGNC:26543",
      havana_gene : "OTTHUMG00000172328.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 49423237,
      stop : 49488775,
      direction : "+",
      ID : "ENSG00000140285.12",
      gene_id : "ENSG00000140285.12",
      gene_type : "protein_coding",
      gene_name : "FGF7",
      gene_level : 1,
      hgnc_id : "HGNC:3685",
      havana_gene : "OTTHUMG00000131517.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 49621037,
      stop : 49656232,
      direction : "+",
      ID : "ENSG00000104047.15",
      gene_id : "ENSG00000104047.15",
      gene_type : "protein_coding",
      gene_name : "DTWD1",
      gene_level : 2,
      hgnc_id : "HGNC:30926",
      havana_gene : "OTTHUMG00000131567.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 49858238,
      stop : 50182817,
      direction : "-",
      ID : "ENSG00000104043.15",
      gene_id : "ENSG00000104043.15",
      gene_type : "protein_coding",
      gene_name : "ATP8B4",
      gene_level : 2,
      hgnc_id : "HGNC:13536",
      havana_gene : "OTTHUMG00000172368.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50182196,
      stop : 50236385,
      direction : "+",
      ID : "ENSG00000140284.11",
      gene_id : "ENSG00000140284.11",
      gene_type : "protein_coding",
      gene_name : "SLC27A2",
      gene_level : 1,
      hgnc_id : "HGNC:10996",
      havana_gene : "OTTHUMG00000131643.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50241947,
      stop : 50265965,
      direction : "-",
      ID : "ENSG00000140287.11",
      gene_id : "ENSG00000140287.11",
      gene_type : "protein_coding",
      gene_name : "HDC",
      gene_level : 2,
      hgnc_id : "HGNC:4855",
      havana_gene : "OTTHUMG00000131644.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50275389,
      stop : 50355408,
      direction : "-",
      ID : "ENSG00000104064.18",
      gene_id : "ENSG00000104064.18",
      gene_type : "protein_coding",
      gene_name : "GABPB1",
      gene_level : 1,
      hgnc_id : "HGNC:4074",
      havana_gene : "OTTHUMG00000131642.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50424380,
      stop : 50514421,
      direction : "+",
      ID : "ENSG00000138592.14",
      gene_id : "ENSG00000138592.14",
      gene_type : "protein_coding",
      gene_name : "USP8",
      gene_level : 1,
      hgnc_id : "HGNC:12631",
      havana_gene : "OTTHUMG00000131645.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50494018,
      stop : 50546708,
      direction : "-",
      ID : "ENSG00000170236.16",
      gene_id : "ENSG00000170236.16",
      gene_type : "protein_coding",
      gene_name : "USP50",
      gene_level : 2,
      hgnc_id : "HGNC:20079",
      havana_gene : "OTTHUMG00000167591.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50552473,
      stop : 50686797,
      direction : "-",
      ID : "ENSG00000092439.16",
      gene_id : "ENSG00000092439.16",
      gene_type : "protein_coding",
      gene_name : "TRPM7",
      gene_level : 1,
      hgnc_id : "HGNC:17994",
      havana_gene : "OTTHUMG00000172449.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50648802,
      stop : 50686717,
      direction : "-",
      ID : "ENSG00000288645.1",
      gene_id : "ENSG00000288645.1",
      gene_type : "protein_coding",
      gene_name : "AC084756.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50702266,
      stop : 50765709,
      direction : "-",
      ID : "ENSG00000138600.10",
      gene_id : "ENSG00000138600.10",
      gene_type : "protein_coding",
      gene_name : "SPPL2A",
      gene_level : 2,
      hgnc_id : "HGNC:30227",
      havana_gene : "OTTHUMG00000131647.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 50908672,
      stop : 51005895,
      direction : "+",
      ID : "ENSG00000081014.11",
      gene_id : "ENSG00000081014.11",
      gene_type : "protein_coding",
      gene_name : "AP4E1",
      gene_level : 1,
      hgnc_id : "HGNC:573",
      havana_gene : "OTTHUMG00000172458.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51056598,
      stop : 51105276,
      direction : "-",
      ID : "ENSG00000183578.8",
      gene_id : "ENSG00000183578.8",
      gene_type : "protein_coding",
      gene_name : "TNFAIP8L3",
      gene_level : 2,
      hgnc_id : "HGNC:20620",
      havana_gene : "OTTHUMG00000172460.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51208057,
      stop : 51338601,
      direction : "-",
      ID : "ENSG00000137869.15",
      gene_id : "ENSG00000137869.15",
      gene_type : "protein_coding",
      gene_name : "CYP19A1",
      gene_level : 1,
      hgnc_id : "HGNC:2594",
      havana_gene : "OTTHUMG00000131747.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51341655,
      stop : 51408005,
      direction : "+",
      ID : "ENSG00000186417.14",
      gene_id : "ENSG00000186417.14",
      gene_type : "protein_coding",
      gene_name : "GLDN",
      gene_level : 2,
      hgnc_id : "HGNC:29514",
      havana_gene : "OTTHUMG00000131746.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51447711,
      stop : 51622833,
      direction : "-",
      ID : "ENSG00000104093.14",
      gene_id : "ENSG00000104093.14",
      gene_type : "protein_coding",
      gene_name : "DMXL2",
      gene_level : 1,
      hgnc_id : "HGNC:2938",
      havana_gene : "OTTHUMG00000131749.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51681492,
      stop : 51721026,
      direction : "+",
      ID : "ENSG00000104112.9",
      gene_id : "ENSG00000104112.9",
      gene_type : "protein_coding",
      gene_name : "SCG3",
      gene_level : 2,
      hgnc_id : "HGNC:13707",
      havana_gene : "OTTHUMG00000131748.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51723011,
      stop : 51751585,
      direction : "-",
      ID : "ENSG00000140280.14",
      gene_id : "ENSG00000140280.14",
      gene_type : "protein_coding",
      gene_name : "LYSMD2",
      gene_level : 1,
      hgnc_id : "HGNC:28571",
      havana_gene : "OTTHUMG00000131804.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51751597,
      stop : 51816363,
      direction : "+",
      ID : "ENSG00000128872.10",
      gene_id : "ENSG00000128872.10",
      gene_type : "protein_coding",
      gene_name : "TMOD2",
      gene_level : 2,
      hgnc_id : "HGNC:11872",
      havana_gene : "OTTHUMG00000131805.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51829628,
      stop : 51947295,
      direction : "+",
      ID : "ENSG00000138594.14",
      gene_id : "ENSG00000138594.14",
      gene_type : "protein_coding",
      gene_name : "TMOD3",
      gene_level : 1,
      hgnc_id : "HGNC:11873",
      havana_gene : "OTTHUMG00000131803.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51938025,
      stop : 51971778,
      direction : "-",
      ID : "ENSG00000166477.13",
      gene_id : "ENSG00000166477.13",
      gene_type : "protein_coding",
      gene_name : "LEO1",
      gene_level : 2,
      hgnc_id : "HGNC:30401",
      havana_gene : "OTTHUMG00000131843.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 51952106,
      stop : 52067375,
      direction : "+",
      ID : "ENSG00000069956.13",
      gene_id : "ENSG00000069956.13",
      gene_type : "protein_coding",
      gene_name : "MAPK6",
      gene_level : 1,
      hgnc_id : "HGNC:6879",
      havana_gene : "OTTHUMG00000131891.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52109263,
      stop : 52112775,
      direction : "-",
      ID : "ENSG00000137875.4",
      gene_id : "ENSG00000137875.4",
      gene_type : "protein_coding",
      gene_name : "BCL2L10",
      gene_level : 1,
      hgnc_id : "HGNC:993",
      havana_gene : "OTTHUMG00000131893.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52115100,
      stop : 52191392,
      direction : "-",
      ID : "ENSG00000069966.19",
      gene_id : "ENSG00000069966.19",
      gene_type : "protein_coding",
      gene_name : "GNB5",
      gene_level : 1,
      hgnc_id : "HGNC:4401",
      havana_gene : "OTTHUMG00000131892.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52192322,
      stop : 52295804,
      direction : "-",
      ID : "ENSG00000128833.13",
      gene_id : "ENSG00000128833.13",
      gene_type : "protein_coding",
      gene_name : "MYO5C",
      gene_level : 2,
      hgnc_id : "HGNC:7604",
      havana_gene : "OTTHUMG00000172630.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52307283,
      stop : 52529050,
      direction : "-",
      ID : "ENSG00000197535.15",
      gene_id : "ENSG00000197535.15",
      gene_type : "protein_coding",
      gene_name : "MYO5A",
      gene_level : 2,
      hgnc_id : "HGNC:7602",
      havana_gene : "OTTHUMG00000137383.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52547045,
      stop : 52569883,
      direction : "-",
      ID : "ENSG00000128989.11",
      gene_id : "ENSG00000128989.11",
      gene_type : "protein_coding",
      gene_name : "ARPP19",
      gene_level : 1,
      hgnc_id : "HGNC:16967",
      havana_gene : "OTTHUMG00000172677.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52581317,
      stop : 52709817,
      direction : "-",
      ID : "ENSG00000047346.12",
      gene_id : "ENSG00000047346.12",
      gene_type : "protein_coding",
      gene_name : "FAM214A",
      gene_level : 1,
      hgnc_id : "HGNC:25609",
      havana_gene : "OTTHUMG00000172688.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 52755053,
      stop : 52791078,
      direction : "-",
      ID : "ENSG00000169856.9",
      gene_id : "ENSG00000169856.9",
      gene_type : "protein_coding",
      gene_name : "ONECUT1",
      gene_level : 1,
      hgnc_id : "HGNC:8138",
      havana_gene : "OTTHUMG00000131899.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 53513741,
      stop : 53762878,
      direction : "-",
      ID : "ENSG00000166415.15",
      gene_id : "ENSG00000166415.15",
      gene_type : "protein_coding",
      gene_name : "WDR72",
      gene_level : 1,
      hgnc_id : "HGNC:26790",
      havana_gene : "OTTHUMG00000131939.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 53978201,
      stop : 54633414,
      direction : "+",
      ID : "ENSG00000137766.17",
      gene_id : "ENSG00000137766.17",
      gene_type : "protein_coding",
      gene_name : "UNC13C",
      gene_level : 1,
      hgnc_id : "HGNC:23149",
      havana_gene : "OTTHUMG00000172542.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55180806,
      stop : 55197049,
      direction : "-",
      ID : "ENSG00000137876.11",
      gene_id : "ENSG00000137876.11",
      gene_type : "protein_coding",
      gene_name : "RSL24D1",
      gene_level : 2,
      hgnc_id : "HGNC:18479",
      havana_gene : "OTTHUMG00000131957.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55202966,
      stop : 55319113,
      direction : "-",
      ID : "ENSG00000069974.16",
      gene_id : "ENSG00000069974.16",
      gene_type : "protein_coding",
      gene_name : "RAB27A",
      gene_level : 2,
      hgnc_id : "HGNC:9766",
      havana_gene : "OTTHUMG00000131959.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55317184,
      stop : 55319161,
      direction : "-",
      ID : "ENSG00000225973.4",
      gene_id : "ENSG00000225973.4",
      gene_type : "protein_coding",
      gene_name : "PIGBOS1",
      gene_level : 2,
      hgnc_id : "HGNC:50696",
      havana_gene : "OTTHUMG00000172653.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55318960,
      stop : 55355648,
      direction : "+",
      ID : "ENSG00000069943.10",
      gene_id : "ENSG00000069943.10",
      gene_type : "protein_coding",
      gene_name : "PIGB",
      gene_level : 1,
      hgnc_id : "HGNC:8959",
      havana_gene : "OTTHUMG00000172654.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55340032,
      stop : 55408510,
      direction : "-",
      ID : "ENSG00000260916.8",
      gene_id : "ENSG00000260916.8",
      gene_type : "protein_coding",
      gene_name : "CCPG1",
      gene_level : 1,
      hgnc_id : "HGNC:24227",
      havana_gene : "OTTHUMG00000172678.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55408495,
      stop : 55418798,
      direction : "+",
      ID : "ENSG00000261652.3",
      gene_id : "ENSG00000261652.3",
      gene_type : "protein_coding",
      gene_name : "C15orf65",
      gene_level : 2,
      hgnc_id : "HGNC:44654",
      havana_gene : "OTTHUMG00000172679.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55410525,
      stop : 55508234,
      direction : "-",
      ID : "ENSG00000256061.7",
      gene_id : "ENSG00000256061.7",
      gene_type : "protein_coding",
      gene_name : "DNAAF4",
      gene_level : 2,
      hgnc_id : "HGNC:21493",
      havana_gene : "OTTHUMG00000132008.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55538884,
      stop : 55588947,
      direction : "-",
      ID : "ENSG00000171016.13",
      gene_id : "ENSG00000171016.13",
      gene_type : "protein_coding",
      gene_name : "PYGO1",
      gene_level : 2,
      hgnc_id : "HGNC:30256",
      havana_gene : "OTTHUMG00000132009.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55611544,
      stop : 55743152,
      direction : "-",
      ID : "ENSG00000166450.13",
      gene_id : "ENSG00000166450.13",
      gene_type : "protein_coding",
      gene_name : "PRTG",
      gene_level : 1,
      hgnc_id : "HGNC:26373",
      havana_gene : "OTTHUMG00000172591.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 55826922,
      stop : 55993660,
      direction : "-",
      ID : "ENSG00000069869.17",
      gene_id : "ENSG00000069869.17",
      gene_type : "protein_coding",
      gene_name : "NEDD4",
      gene_level : 1,
      hgnc_id : "HGNC:7727",
      havana_gene : "OTTHUMG00000132015.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 56087280,
      stop : 56245082,
      direction : "-",
      ID : "ENSG00000181827.15",
      gene_id : "ENSG00000181827.15",
      gene_type : "protein_coding",
      gene_name : "RFX7",
      gene_level : 2,
      hgnc_id : "HGNC:25777",
      havana_gene : "OTTHUMG00000172508.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 56244009,
      stop : 56445997,
      direction : "+",
      ID : "ENSG00000151575.14",
      gene_id : "ENSG00000151575.14",
      gene_type : "protein_coding",
      gene_name : "TEX9",
      gene_level : 1,
      hgnc_id : "HGNC:29585",
      havana_gene : "OTTHUMG00000132035.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 56421544,
      stop : 56465137,
      direction : "-",
      ID : "ENSG00000138587.6",
      gene_id : "ENSG00000138587.6",
      gene_type : "protein_coding",
      gene_name : "MNS1",
      gene_level : 2,
      hgnc_id : "HGNC:29636",
      havana_gene : "OTTHUMG00000132034.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 56630176,
      stop : 56734086,
      direction : "-",
      ID : "ENSG00000137871.21",
      gene_id : "ENSG00000137871.21",
      gene_type : "protein_coding",
      gene_name : "ZNF280D",
      gene_level : 1,
      hgnc_id : "HGNC:25953",
      havana_gene : "OTTHUMG00000172509.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 56652488,
      stop : 56918571,
      direction : "-",
      ID : "ENSG00000285253.1",
      gene_id : "ENSG00000285253.1",
      gene_type : "protein_coding",
      gene_name : "AC090517.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192443.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 56918623,
      stop : 57299281,
      direction : "+",
      ID : "ENSG00000140262.18",
      gene_id : "ENSG00000140262.18",
      gene_type : "protein_coding",
      gene_name : "TCF12",
      gene_level : 1,
      hgnc_id : "HGNC:11623",
      havana_gene : "OTTHUMG00000132047.13",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 57375967,
      stop : 57550717,
      direction : "+",
      ID : "ENSG00000128849.11",
      gene_id : "ENSG00000128849.11",
      gene_type : "protein_coding",
      gene_name : "CGNL1",
      gene_level : 2,
      hgnc_id : "HGNC:25931",
      havana_gene : "OTTHUMG00000166485.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 57591904,
      stop : 57685364,
      direction : "+",
      ID : "ENSG00000263155.6",
      gene_id : "ENSG00000263155.6",
      gene_type : "protein_coding",
      gene_name : "MYZAP",
      gene_level : 2,
      hgnc_id : "HGNC:43444",
      havana_gene : "OTTHUMG00000132453.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 57591908,
      stop : 57714745,
      direction : "+",
      ID : "ENSG00000137878.17",
      gene_id : "ENSG00000137878.17",
      gene_type : "protein_coding",
      gene_name : "GCOM1",
      gene_level : 2,
      hgnc_id : "HGNC:26424",
      havana_gene : "OTTHUMG00000176411.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 57706695,
      stop : 57782762,
      direction : "+",
      ID : "ENSG00000255529.9",
      gene_id : "ENSG00000255529.9",
      gene_type : "protein_coding",
      gene_name : "POLR2M",
      gene_level : 2,
      hgnc_id : "HGNC:14862",
      havana_gene : "OTTHUMG00000166486.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 57953424,
      stop : 58497866,
      direction : "-",
      ID : "ENSG00000128918.15",
      gene_id : "ENSG00000128918.15",
      gene_type : "protein_coding",
      gene_name : "ALDH1A2",
      gene_level : 2,
      hgnc_id : "HGNC:15472",
      havana_gene : "OTTHUMG00000132624.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 58138169,
      stop : 58185911,
      direction : "+",
      ID : "ENSG00000103569.10",
      gene_id : "ENSG00000103569.10",
      gene_type : "protein_coding",
      gene_name : "AQP9",
      gene_level : 1,
      hgnc_id : "HGNC:643",
      havana_gene : "OTTHUMG00000132631.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 58410569,
      stop : 58569844,
      direction : "+",
      ID : "ENSG00000166035.11",
      gene_id : "ENSG00000166035.11",
      gene_type : "protein_coding",
      gene_name : "LIPC",
      gene_level : 1,
      hgnc_id : "HGNC:6619",
      havana_gene : "OTTHUMG00000132632.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 58588809,
      stop : 58749791,
      direction : "-",
      ID : "ENSG00000137845.15",
      gene_id : "ENSG00000137845.15",
      gene_type : "protein_coding",
      gene_name : "ADAM10",
      gene_level : 1,
      hgnc_id : "HGNC:188",
      havana_gene : "OTTHUMG00000132633.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 58771192,
      stop : 58861900,
      direction : "+",
      ID : "ENSG00000128923.11",
      gene_id : "ENSG00000128923.11",
      gene_type : "protein_coding",
      gene_name : "MINDY2",
      gene_level : 2,
      hgnc_id : "HGNC:26954",
      havana_gene : "OTTHUMG00000171983.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 58865175,
      stop : 59097419,
      direction : "+",
      ID : "ENSG00000157450.16",
      gene_id : "ENSG00000157450.16",
      gene_type : "protein_coding",
      gene_name : "RNF111",
      gene_level : 1,
      hgnc_id : "HGNC:17384",
      havana_gene : "OTTHUMG00000132716.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 58879050,
      stop : 58933679,
      direction : "-",
      ID : "ENSG00000137776.17",
      gene_id : "ENSG00000137776.17",
      gene_type : "protein_coding",
      gene_name : "SLTM",
      gene_level : 2,
      hgnc_id : "HGNC:20709",
      havana_gene : "OTTHUMG00000074033.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59105126,
      stop : 59125045,
      direction : "+",
      ID : "ENSG00000157456.8",
      gene_id : "ENSG00000157456.8",
      gene_type : "protein_coding",
      gene_name : "CCNB2",
      gene_level : 1,
      hgnc_id : "HGNC:1580",
      havana_gene : "OTTHUMG00000132715.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59132434,
      stop : 59372871,
      direction : "-",
      ID : "ENSG00000157483.9",
      gene_id : "ENSG00000157483.9",
      gene_type : "protein_coding",
      gene_name : "MYO1E",
      gene_level : 1,
      hgnc_id : "HGNC:7599",
      havana_gene : "OTTHUMG00000171944.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59206843,
      stop : 59208588,
      direction : "+",
      ID : "ENSG00000171989.6",
      gene_id : "ENSG00000171989.6",
      gene_type : "protein_coding",
      gene_name : "LDHAL6B",
      gene_level : 2,
      hgnc_id : "HGNC:21481",
      havana_gene : "OTTHUMG00000132714.2",
      tag : "retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59372693,
      stop : 59523555,
      direction : "+",
      ID : "ENSG00000157470.12",
      gene_id : "ENSG00000157470.12",
      gene_type : "protein_coding",
      gene_name : "FAM81A",
      gene_level : 1,
      hgnc_id : "HGNC:28379",
      havana_gene : "OTTHUMG00000171915.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59594875,
      stop : 59640239,
      direction : "+",
      ID : "ENSG00000140297.13",
      gene_id : "ENSG00000140297.13",
      gene_type : "protein_coding",
      gene_name : "GCNT3",
      gene_level : 1,
      hgnc_id : "HGNC:4205",
      havana_gene : "OTTHUMG00000132726.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59638062,
      stop : 59657541,
      direction : "-",
      ID : "ENSG00000140307.11",
      gene_id : "ENSG00000140307.11",
      gene_type : "protein_coding",
      gene_name : "GTF2A2",
      gene_level : 1,
      hgnc_id : "HGNC:4647",
      havana_gene : "OTTHUMG00000132725.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 59659146,
      stop : 59689534,
      direction : "-",
      ID : "ENSG00000140299.13",
      gene_id : "ENSG00000140299.13",
      gene_type : "protein_coding",
      gene_name : "BNIP2",
      gene_level : 2,
      hgnc_id : "HGNC:1083",
      havana_gene : "OTTHUMG00000132727.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 60004234,
      stop : 60061730,
      direction : "+",
      ID : "ENSG00000171956.7",
      gene_id : "ENSG00000171956.7",
      gene_type : "protein_coding",
      gene_name : "FOXB1",
      gene_level : 1,
      hgnc_id : "HGNC:3799",
      havana_gene : "OTTHUMG00000172011.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 60347134,
      stop : 60402883,
      direction : "-",
      ID : "ENSG00000182718.18",
      gene_id : "ENSG00000182718.18",
      gene_type : "protein_coding",
      gene_name : "ANXA2",
      gene_level : 1,
      hgnc_id : "HGNC:537",
      havana_gene : "OTTHUMG00000132763.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 60419609,
      stop : 60479160,
      direction : "-",
      ID : "ENSG00000128915.12",
      gene_id : "ENSG00000128915.12",
      gene_type : "protein_coding",
      gene_name : "ICE2",
      gene_level : 2,
      hgnc_id : "HGNC:29885",
      havana_gene : "OTTHUMG00000132764.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 60488284,
      stop : 61229302,
      direction : "-",
      ID : "ENSG00000069667.16",
      gene_id : "ENSG00000069667.16",
      gene_type : "protein_coding",
      gene_name : "RORA",
      gene_level : 1,
      hgnc_id : "HGNC:10258",
      havana_gene : "OTTHUMG00000132769.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 61852389,
      stop : 62060473,
      direction : "-",
      ID : "ENSG00000129003.19",
      gene_id : "ENSG00000129003.19",
      gene_type : "protein_coding",
      gene_name : "VPS13C",
      gene_level : 2,
      hgnc_id : "HGNC:23594",
      havana_gene : "OTTHUMG00000132801.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 62066977,
      stop : 62070917,
      direction : "+",
      ID : "ENSG00000198535.5",
      gene_id : "ENSG00000198535.5",
      gene_type : "protein_coding",
      gene_name : "C2CD4A",
      gene_level : 2,
      hgnc_id : "HGNC:33627",
      havana_gene : "OTTHUMG00000171942.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 62163535,
      stop : 62165285,
      direction : "-",
      ID : "ENSG00000205502.4",
      gene_id : "ENSG00000205502.4",
      gene_type : "protein_coding",
      gene_name : "C2CD4B",
      gene_level : 2,
      hgnc_id : "HGNC:33628",
      havana_gene : "OTTHUMG00000171959.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 62390526,
      stop : 62844631,
      direction : "+",
      ID : "ENSG00000171914.16",
      gene_id : "ENSG00000171914.16",
      gene_type : "protein_coding",
      gene_name : "TLN2",
      gene_level : 1,
      hgnc_id : "HGNC:15447",
      havana_gene : "OTTHUMG00000133679.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63042632,
      stop : 63071915,
      direction : "+",
      ID : "ENSG00000140416.23",
      gene_id : "ENSG00000140416.23",
      gene_type : "protein_coding",
      gene_name : "TPM1",
      gene_level : 2,
      hgnc_id : "HGNC:12010",
      havana_gene : "OTTHUMG00000132803.19",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63121833,
      stop : 63142061,
      direction : "+",
      ID : "ENSG00000103642.12",
      gene_id : "ENSG00000103642.12",
      gene_type : "protein_coding",
      gene_name : "LACTB",
      gene_level : 2,
      hgnc_id : "HGNC:16468",
      havana_gene : "OTTHUMG00000132807.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63125872,
      stop : 63158021,
      direction : "-",
      ID : "ENSG00000185088.14",
      gene_id : "ENSG00000185088.14",
      gene_type : "protein_coding",
      gene_name : "RPS27L",
      gene_level : 1,
      hgnc_id : "HGNC:18476",
      havana_gene : "OTTHUMG00000155301.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63189560,
      stop : 63267776,
      direction : "+",
      ID : "ENSG00000166128.13",
      gene_id : "ENSG00000166128.13",
      gene_type : "protein_coding",
      gene_name : "RAB8B",
      gene_level : 2,
      hgnc_id : "HGNC:30273",
      havana_gene : "OTTHUMG00000132862.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63276018,
      stop : 63309126,
      direction : "+",
      ID : "ENSG00000138613.14",
      gene_id : "ENSG00000138613.14",
      gene_type : "protein_coding",
      gene_name : "APH1B",
      gene_level : 1,
      hgnc_id : "HGNC:24080",
      havana_gene : "OTTHUMG00000132863.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63321378,
      stop : 63381846,
      direction : "-",
      ID : "ENSG00000074410.14",
      gene_id : "ENSG00000074410.14",
      gene_type : "protein_coding",
      gene_name : "CA12",
      gene_level : 2,
      hgnc_id : "HGNC:1371",
      havana_gene : "OTTHUMG00000132881.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63504511,
      stop : 63594640,
      direction : "+",
      ID : "ENSG00000140455.17",
      gene_id : "ENSG00000140455.17",
      gene_type : "protein_coding",
      gene_name : "USP3",
      gene_level : 1,
      hgnc_id : "HGNC:12626",
      havana_gene : "OTTHUMG00000172309.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63597353,
      stop : 63602428,
      direction : "+",
      ID : "ENSG00000197361.8",
      gene_id : "ENSG00000197361.8",
      gene_type : "protein_coding",
      gene_name : "FBXL22",
      gene_level : 2,
      hgnc_id : "HGNC:27537",
      havana_gene : "OTTHUMG00000132905.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63608618,
      stop : 63833948,
      direction : "-",
      ID : "ENSG00000103657.14",
      gene_id : "ENSG00000103657.14",
      gene_type : "protein_coding",
      gene_name : "HERC1",
      gene_level : 1,
      hgnc_id : "HGNC:4867",
      havana_gene : "OTTHUMG00000172433.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 63907036,
      stop : 64072033,
      direction : "-",
      ID : "ENSG00000035664.11",
      gene_id : "ENSG00000035664.11",
      gene_type : "protein_coding",
      gene_name : "DAPK2",
      gene_level : 2,
      hgnc_id : "HGNC:2675",
      havana_gene : "OTTHUMG00000132947.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64072565,
      stop : 64093857,
      direction : "-",
      ID : "ENSG00000166797.11",
      gene_id : "ENSG00000166797.11",
      gene_type : "protein_coding",
      gene_name : "CIAO2A",
      gene_level : 2,
      hgnc_id : "HGNC:26235",
      havana_gene : "OTTHUMG00000132961.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64094123,
      stop : 64146090,
      direction : "+",
      ID : "ENSG00000028528.15",
      gene_id : "ENSG00000028528.15",
      gene_type : "protein_coding",
      gene_name : "SNX1",
      gene_level : 2,
      hgnc_id : "HGNC:11172",
      havana_gene : "OTTHUMG00000172436.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64151715,
      stop : 64157481,
      direction : "+",
      ID : "ENSG00000157734.14",
      gene_id : "ENSG00000157734.14",
      gene_type : "protein_coding",
      gene_name : "SNX22",
      gene_level : 2,
      hgnc_id : "HGNC:16315",
      havana_gene : "OTTHUMG00000132965.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64155740,
      stop : 64163134,
      direction : "-",
      ID : "ENSG00000166794.6",
      gene_id : "ENSG00000166794.6",
      gene_type : "protein_coding",
      gene_name : "PPIB",
      gene_level : 2,
      hgnc_id : "HGNC:9255",
      havana_gene : "OTTHUMG00000133018.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64165525,
      stop : 64356173,
      direction : "-",
      ID : "ENSG00000169118.18",
      gene_id : "ENSG00000169118.18",
      gene_type : "protein_coding",
      gene_name : "CSNK1G1",
      gene_level : 2,
      hgnc_id : "HGNC:2454",
      havana_gene : "OTTHUMG00000133019.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64181180,
      stop : 64381440,
      direction : "-",
      ID : "ENSG00000259316.12",
      gene_id : "ENSG00000259316.12",
      gene_type : "protein_coding",
      gene_name : "AC087632.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172470.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64364304,
      stop : 64387687,
      direction : "-",
      ID : "ENSG00000166803.14",
      gene_id : "ENSG00000166803.14",
      gene_type : "protein_coding",
      gene_name : "PCLAF",
      gene_level : 1,
      hgnc_id : "HGNC:28961",
      havana_gene : "OTTHUMG00000133017.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64387748,
      stop : 64455303,
      direction : "+",
      ID : "ENSG00000103671.10",
      gene_id : "ENSG00000103671.10",
      gene_type : "protein_coding",
      gene_name : "TRIP4",
      gene_level : 2,
      hgnc_id : "HGNC:12310",
      havana_gene : "OTTHUMG00000133033.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64460742,
      stop : 64686068,
      direction : "+",
      ID : "ENSG00000180357.9",
      gene_id : "ENSG00000180357.9",
      gene_type : "protein_coding",
      gene_name : "ZNF609",
      gene_level : 2,
      hgnc_id : "HGNC:29003",
      havana_gene : "OTTHUMG00000172370.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64687573,
      stop : 64703281,
      direction : "-",
      ID : "ENSG00000180304.14",
      gene_id : "ENSG00000180304.14",
      gene_type : "protein_coding",
      gene_name : "OAZ2",
      gene_level : 1,
      hgnc_id : "HGNC:8096",
      havana_gene : "OTTHUMG00000172473.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64739891,
      stop : 64775589,
      direction : "-",
      ID : "ENSG00000166831.9",
      gene_id : "ENSG00000166831.9",
      gene_type : "protein_coding",
      gene_name : "RBPMS2",
      gene_level : 2,
      hgnc_id : "HGNC:19098",
      havana_gene : "OTTHUMG00000172423.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64815632,
      stop : 64825668,
      direction : "-",
      ID : "ENSG00000140451.13",
      gene_id : "ENSG00000140451.13",
      gene_type : "protein_coding",
      gene_name : "PIF1",
      gene_level : 2,
      hgnc_id : "HGNC:26220",
      havana_gene : "OTTHUMG00000132974.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64841883,
      stop : 64868002,
      direction : "+",
      ID : "ENSG00000241839.10",
      gene_id : "ENSG00000241839.10",
      gene_type : "protein_coding",
      gene_name : "PLEKHO2",
      gene_level : 2,
      hgnc_id : "HGNC:30026",
      havana_gene : "OTTHUMG00000133050.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64841883,
      stop : 64930920,
      direction : "+",
      ID : "ENSG00000249240.2",
      gene_id : "ENSG00000249240.2",
      gene_type : "protein_coding",
      gene_name : "AC069368.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000161678.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64911902,
      stop : 64958691,
      direction : "+",
      ID : "ENSG00000166839.17",
      gene_id : "ENSG00000166839.17",
      gene_type : "protein_coding",
      gene_name : "ANKDD1A",
      gene_level : 2,
      hgnc_id : "HGNC:28002",
      havana_gene : "OTTHUMG00000133051.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 64963022,
      stop : 64990310,
      direction : "-",
      ID : "ENSG00000090487.11",
      gene_id : "ENSG00000090487.11",
      gene_type : "protein_coding",
      gene_name : "SPG21",
      gene_level : 1,
      hgnc_id : "HGNC:20373",
      havana_gene : "OTTHUMG00000133098.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65001512,
      stop : 65029639,
      direction : "-",
      ID : "ENSG00000103707.10",
      gene_id : "ENSG00000103707.10",
      gene_type : "protein_coding",
      gene_name : "MTFMT",
      gene_level : 1,
      hgnc_id : "HGNC:29666",
      havana_gene : "OTTHUMG00000172371.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65045387,
      stop : 65053397,
      direction : "+",
      ID : "ENSG00000186198.4",
      gene_id : "ENSG00000186198.4",
      gene_type : "protein_coding",
      gene_name : "SLC51B",
      gene_level : 2,
      hgnc_id : "HGNC:29956",
      havana_gene : "OTTHUMG00000133116.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65053337,
      stop : 65076690,
      direction : "-",
      ID : "ENSG00000103710.11",
      gene_id : "ENSG00000103710.11",
      gene_type : "protein_coding",
      gene_name : "RASL12",
      gene_level : 2,
      hgnc_id : "HGNC:30289",
      havana_gene : "OTTHUMG00000133115.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65076746,
      stop : 65079948,
      direction : "+",
      ID : "ENSG00000234438.5",
      gene_id : "ENSG00000234438.5",
      gene_type : "protein_coding",
      gene_name : "KBTBD13",
      gene_level : 2,
      hgnc_id : "HGNC:37227",
      havana_gene : "OTTHUMG00000172424.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65092760,
      stop : 65115200,
      direction : "-",
      ID : "ENSG00000246922.9",
      gene_id : "ENSG00000246922.9",
      gene_type : "protein_coding",
      gene_name : "UBAP1L",
      gene_level : 2,
      hgnc_id : "HGNC:40028",
      havana_gene : "OTTHUMG00000172425.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65117379,
      stop : 65133808,
      direction : "-",
      ID : "ENSG00000090470.15",
      gene_id : "ENSG00000090470.15",
      gene_type : "protein_coding",
      gene_name : "PDCD7",
      gene_level : 1,
      hgnc_id : "HGNC:8767",
      havana_gene : "OTTHUMG00000133117.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65148219,
      stop : 65185342,
      direction : "-",
      ID : "ENSG00000166855.9",
      gene_id : "ENSG00000166855.9",
      gene_type : "protein_coding",
      gene_name : "CLPX",
      gene_level : 1,
      hgnc_id : "HGNC:2088",
      havana_gene : "OTTHUMG00000133139.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65194760,
      stop : 65211473,
      direction : "-",
      ID : "ENSG00000138615.6",
      gene_id : "ENSG00000138615.6",
      gene_type : "protein_coding",
      gene_name : "CILP",
      gene_level : 2,
      hgnc_id : "HGNC:1980",
      havana_gene : "OTTHUMG00000133140.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65234460,
      stop : 65300618,
      direction : "-",
      ID : "ENSG00000138617.16",
      gene_id : "ENSG00000138617.16",
      gene_type : "protein_coding",
      gene_name : "PARP16",
      gene_level : 1,
      hgnc_id : "HGNC:26040",
      havana_gene : "OTTHUMG00000133138.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65327127,
      stop : 65378002,
      direction : "-",
      ID : "ENSG00000174498.14",
      gene_id : "ENSG00000174498.14",
      gene_type : "protein_coding",
      gene_name : "IGDCC3",
      gene_level : 1,
      hgnc_id : "HGNC:9700",
      havana_gene : "OTTHUMG00000133137.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65381484,
      stop : 65422947,
      direction : "-",
      ID : "ENSG00000103742.12",
      gene_id : "ENSG00000103742.12",
      gene_type : "protein_coding",
      gene_name : "IGDCC4",
      gene_level : 1,
      hgnc_id : "HGNC:13770",
      havana_gene : "OTTHUMG00000133136.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65442463,
      stop : 65517704,
      direction : "-",
      ID : "ENSG00000074603.19",
      gene_id : "ENSG00000074603.19",
      gene_type : "protein_coding",
      gene_name : "DPP8",
      gene_level : 1,
      hgnc_id : "HGNC:16490",
      havana_gene : "OTTHUMG00000133150.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65530418,
      stop : 65578349,
      direction : "+",
      ID : "ENSG00000074696.13",
      gene_id : "ENSG00000074696.13",
      gene_type : "protein_coding",
      gene_name : "HACD3",
      gene_level : 1,
      hgnc_id : "HGNC:24175",
      havana_gene : "OTTHUMG00000172658.10",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65578753,
      stop : 65611289,
      direction : "-",
      ID : "ENSG00000138614.15",
      gene_id : "ENSG00000138614.15",
      gene_type : "protein_coding",
      gene_name : "INTS14",
      gene_level : 1,
      hgnc_id : "HGNC:25372",
      havana_gene : "OTTHUMG00000133159.12",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65611366,
      stop : 65660995,
      direction : "+",
      ID : "ENSG00000074621.14",
      gene_id : "ENSG00000074621.14",
      gene_type : "protein_coding",
      gene_name : "SLC24A1",
      gene_level : 1,
      hgnc_id : "HGNC:10975",
      havana_gene : "OTTHUMG00000167960.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65658046,
      stop : 65792293,
      direction : "-",
      ID : "ENSG00000174485.16",
      gene_id : "ENSG00000174485.16",
      gene_type : "protein_coding",
      gene_name : "DENND4A",
      gene_level : 1,
      hgnc_id : "HGNC:24321",
      havana_gene : "OTTHUMG00000172635.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65726054,
      stop : 65891989,
      direction : "+",
      ID : "ENSG00000103769.10",
      gene_id : "ENSG00000103769.10",
      gene_type : "protein_coding",
      gene_name : "RAB11A",
      gene_level : 1,
      hgnc_id : "HGNC:9760",
      havana_gene : "OTTHUMG00000133162.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 65895079,
      stop : 66253747,
      direction : "-",
      ID : "ENSG00000157890.17",
      gene_id : "ENSG00000157890.17",
      gene_type : "protein_coding",
      gene_name : "MEGF11",
      gene_level : 2,
      hgnc_id : "HGNC:29635",
      havana_gene : "OTTHUMG00000133175.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66293217,
      stop : 66333898,
      direction : "+",
      ID : "ENSG00000166938.13",
      gene_id : "ENSG00000166938.13",
      gene_type : "protein_coding",
      gene_name : "DIS3L",
      gene_level : 1,
      hgnc_id : "HGNC:28698",
      havana_gene : "OTTHUMG00000133181.10",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66336191,
      stop : 66386746,
      direction : "-",
      ID : "ENSG00000075131.10",
      gene_id : "ENSG00000075131.10",
      gene_type : "protein_coding",
      gene_name : "TIPIN",
      gene_level : 2,
      hgnc_id : "HGNC:30750",
      havana_gene : "OTTHUMG00000133188.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66386837,
      stop : 66491544,
      direction : "+",
      ID : "ENSG00000169032.10",
      gene_id : "ENSG00000169032.10",
      gene_type : "protein_coding",
      gene_name : "MAP2K1",
      gene_level : 1,
      hgnc_id : "HGNC:6840",
      havana_gene : "OTTHUMG00000133196.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66490135,
      stop : 66497780,
      direction : "-",
      ID : "ENSG00000174446.13",
      gene_id : "ENSG00000174446.13",
      gene_type : "protein_coding",
      gene_name : "SNAPC5",
      gene_level : 1,
      hgnc_id : "HGNC:15484",
      havana_gene : "OTTHUMG00000133195.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66498015,
      stop : 66524532,
      direction : "-",
      ID : "ENSG00000174444.15",
      gene_id : "ENSG00000174444.15",
      gene_type : "protein_coding",
      gene_name : "RPL4",
      gene_level : 1,
      hgnc_id : "HGNC:10353",
      havana_gene : "OTTHUMG00000133193.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66504959,
      stop : 66550130,
      direction : "+",
      ID : "ENSG00000174442.12",
      gene_id : "ENSG00000174442.12",
      gene_type : "protein_coding",
      gene_name : "ZWILCH",
      gene_level : 2,
      hgnc_id : "HGNC:25468",
      havana_gene : "OTTHUMG00000133194.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66547179,
      stop : 66565979,
      direction : "-",
      ID : "ENSG00000188501.11",
      gene_id : "ENSG00000188501.11",
      gene_type : "protein_coding",
      gene_name : "LCTL",
      gene_level : 2,
      hgnc_id : "HGNC:15583",
      havana_gene : "OTTHUMG00000133207.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 66702236,
      stop : 66782849,
      direction : "+",
      ID : "ENSG00000137834.15",
      gene_id : "ENSG00000137834.15",
      gene_type : "protein_coding",
      gene_name : "SMAD6",
      gene_level : 2,
      hgnc_id : "HGNC:6772",
      havana_gene : "OTTHUMG00000133218.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 67063763,
      stop : 67195173,
      direction : "+",
      ID : "ENSG00000166949.17",
      gene_id : "ENSG00000166949.17",
      gene_type : "protein_coding",
      gene_name : "SMAD3",
      gene_level : 1,
      hgnc_id : "HGNC:6769",
      havana_gene : "OTTHUMG00000133230.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 67200667,
      stop : 67255195,
      direction : "-",
      ID : "ENSG00000103591.13",
      gene_id : "ENSG00000103591.13",
      gene_type : "protein_coding",
      gene_name : "AAGAB",
      gene_level : 1,
      hgnc_id : "HGNC:25662",
      havana_gene : "OTTHUMG00000172246.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 67254786,
      stop : 67502260,
      direction : "+",
      ID : "ENSG00000103599.20",
      gene_id : "ENSG00000103599.20",
      gene_type : "protein_coding",
      gene_name : "IQCH",
      gene_level : 1,
      hgnc_id : "HGNC:25721",
      havana_gene : "OTTHUMG00000133231.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 67521131,
      stop : 67530146,
      direction : "+",
      ID : "ENSG00000189227.6",
      gene_id : "ENSG00000189227.6",
      gene_type : "protein_coding",
      gene_name : "C15orf61",
      gene_level : 1,
      hgnc_id : "HGNC:34453",
      havana_gene : "OTTHUMG00000172248.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 67542703,
      stop : 67807117,
      direction : "+",
      ID : "ENSG00000137764.20",
      gene_id : "ENSG00000137764.20",
      gene_type : "protein_coding",
      gene_name : "MAP2K5",
      gene_level : 1,
      hgnc_id : "HGNC:6845",
      havana_gene : "OTTHUMG00000133264.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 67819704,
      stop : 67834582,
      direction : "+",
      ID : "ENSG00000188779.12",
      gene_id : "ENSG00000188779.12",
      gene_type : "protein_coding",
      gene_name : "SKOR1",
      gene_level : 2,
      hgnc_id : "HGNC:21326",
      havana_gene : "OTTHUMG00000170878.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68054309,
      stop : 68198603,
      direction : "+",
      ID : "ENSG00000033800.14",
      gene_id : "ENSG00000033800.14",
      gene_type : "protein_coding",
      gene_name : "PIAS1",
      gene_level : 2,
      hgnc_id : "HGNC:2752",
      havana_gene : "OTTHUMG00000172645.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68184032,
      stop : 68229718,
      direction : "-",
      ID : "ENSG00000260007.3",
      gene_id : "ENSG00000260007.3",
      gene_type : "protein_coding",
      gene_name : "AC107871.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172656.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68190705,
      stop : 68206079,
      direction : "-",
      ID : "ENSG00000129007.15",
      gene_id : "ENSG00000129007.15",
      gene_type : "protein_coding",
      gene_name : "CALML4",
      gene_level : 1,
      hgnc_id : "HGNC:18445",
      havana_gene : "OTTHUMG00000133287.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68206992,
      stop : 68257211,
      direction : "-",
      ID : "ENSG00000128973.13",
      gene_id : "ENSG00000128973.13",
      gene_type : "protein_coding",
      gene_name : "CLN6",
      gene_level : 2,
      hgnc_id : "HGNC:2077",
      havana_gene : "OTTHUMG00000133286.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68277745,
      stop : 68295862,
      direction : "+",
      ID : "ENSG00000169018.6",
      gene_id : "ENSG00000169018.6",
      gene_type : "protein_coding",
      gene_name : "FEM1B",
      gene_level : 1,
      hgnc_id : "HGNC:3649",
      havana_gene : "OTTHUMG00000133285.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68296532,
      stop : 68432163,
      direction : "-",
      ID : "ENSG00000137809.17",
      gene_id : "ENSG00000137809.17",
      gene_type : "protein_coding",
      gene_name : "ITGA11",
      gene_level : 2,
      hgnc_id : "HGNC:6136",
      havana_gene : "OTTHUMG00000172657.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68578993,
      stop : 68727806,
      direction : "+",
      ID : "ENSG00000103647.13",
      gene_id : "ENSG00000103647.13",
      gene_type : "protein_coding",
      gene_name : "CORO2B",
      gene_level : 2,
      hgnc_id : "HGNC:2256",
      havana_gene : "OTTHUMG00000133288.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68778535,
      stop : 68820897,
      direction : "-",
      ID : "ENSG00000140350.15",
      gene_id : "ENSG00000140350.15",
      gene_type : "protein_coding",
      gene_name : "ANP32A",
      gene_level : 1,
      hgnc_id : "HGNC:13233",
      havana_gene : "OTTHUMG00000154502.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68818221,
      stop : 68946811,
      direction : "+",
      ID : "ENSG00000258484.4",
      gene_id : "ENSG00000258484.4",
      gene_type : "protein_coding",
      gene_name : "SPESP1",
      gene_level : 2,
      hgnc_id : "HGNC:15570",
      havana_gene : "OTTHUMG00000133321.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 68930525,
      stop : 69062762,
      direction : "+",
      ID : "ENSG00000255346.10",
      gene_id : "ENSG00000255346.10",
      gene_type : "protein_coding",
      gene_name : "NOX5",
      gene_level : 1,
      hgnc_id : "HGNC:14874",
      havana_gene : "OTTHUMG00000133320.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 69160584,
      stop : 69272217,
      direction : "+",
      ID : "ENSG00000138604.10",
      gene_id : "ENSG00000138604.10",
      gene_type : "protein_coding",
      gene_name : "GLCE",
      gene_level : 2,
      hgnc_id : "HGNC:17855",
      havana_gene : "OTTHUMG00000172084.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 69298912,
      stop : 69407780,
      direction : "+",
      ID : "ENSG00000137819.14",
      gene_id : "ENSG00000137819.14",
      gene_type : "protein_coding",
      gene_name : "PAQR5",
      gene_level : 2,
      hgnc_id : "HGNC:29645",
      havana_gene : "OTTHUMG00000133322.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 69414246,
      stop : 69448427,
      direction : "+",
      ID : "ENSG00000137807.16",
      gene_id : "ENSG00000137807.16",
      gene_type : "protein_coding",
      gene_name : "KIF23",
      gene_level : 1,
      hgnc_id : "HGNC:6392",
      havana_gene : "OTTHUMG00000172062.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 69452814,
      stop : 69456205,
      direction : "+",
      ID : "ENSG00000137818.12",
      gene_id : "ENSG00000137818.12",
      gene_type : "protein_coding",
      gene_name : "RPLP1",
      gene_level : 2,
      hgnc_id : "HGNC:10372",
      havana_gene : "OTTHUMG00000172087.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 70047790,
      stop : 70098176,
      direction : "-",
      ID : "ENSG00000140332.17",
      gene_id : "ENSG00000140332.17",
      gene_type : "protein_coding",
      gene_name : "TLE3",
      gene_level : 2,
      hgnc_id : "HGNC:11839",
      havana_gene : "OTTHUMG00000172121.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 70654554,
      stop : 70763558,
      direction : "-",
      ID : "ENSG00000137831.15",
      gene_id : "ENSG00000137831.15",
      gene_type : "protein_coding",
      gene_name : "UACA",
      gene_level : 2,
      hgnc_id : "HGNC:15947",
      havana_gene : "OTTHUMG00000133363.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 70829130,
      stop : 70854157,
      direction : "-",
      ID : "ENSG00000166173.11",
      gene_id : "ENSG00000166173.11",
      gene_type : "protein_coding",
      gene_name : "LARP6",
      gene_level : 1,
      hgnc_id : "HGNC:24012",
      havana_gene : "OTTHUMG00000172179.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 70853239,
      stop : 71053658,
      direction : "+",
      ID : "ENSG00000137821.12",
      gene_id : "ENSG00000137821.12",
      gene_type : "protein_coding",
      gene_name : "LRRC49",
      gene_level : 1,
      hgnc_id : "HGNC:25965",
      havana_gene : "OTTHUMG00000172182.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 70881342,
      stop : 70892433,
      direction : "-",
      ID : "ENSG00000129028.9",
      gene_id : "ENSG00000129028.9",
      gene_type : "protein_coding",
      gene_name : "THAP10",
      gene_level : 2,
      hgnc_id : "HGNC:23193",
      havana_gene : "OTTHUMG00000133388.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 71096952,
      stop : 71783383,
      direction : "+",
      ID : "ENSG00000187720.14",
      gene_id : "ENSG00000187720.14",
      gene_type : "protein_coding",
      gene_name : "THSD4",
      gene_level : 2,
      hgnc_id : "HGNC:25835",
      havana_gene : "OTTHUMG00000133389.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 71792638,
      stop : 71818259,
      direction : "+",
      ID : "ENSG00000278570.5",
      gene_id : "ENSG00000278570.5",
      gene_type : "protein_coding",
      gene_name : "NR2E3",
      gene_level : 2,
      hgnc_id : "HGNC:7974",
      havana_gene : "OTTHUMG00000172841.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 71822291,
      stop : 72118577,
      direction : "-",
      ID : "ENSG00000066933.16",
      gene_id : "ENSG00000066933.16",
      gene_type : "protein_coding",
      gene_name : "MYO9A",
      gene_level : 1,
      hgnc_id : "HGNC:7608",
      havana_gene : "OTTHUMG00000133440.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72114258,
      stop : 72143692,
      direction : "+",
      ID : "ENSG00000166192.15",
      gene_id : "ENSG00000166192.15",
      gene_type : "protein_coding",
      gene_name : "SENP8",
      gene_level : 2,
      hgnc_id : "HGNC:22992",
      havana_gene : "OTTHUMG00000133441.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72159806,
      stop : 72197787,
      direction : "-",
      ID : "ENSG00000175318.12",
      gene_id : "ENSG00000175318.12",
      gene_type : "protein_coding",
      gene_name : "GRAMD2A",
      gene_level : 1,
      hgnc_id : "HGNC:27287",
      havana_gene : "OTTHUMG00000172708.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72199029,
      stop : 72231822,
      direction : "-",
      ID : "ENSG00000067225.19",
      gene_id : "ENSG00000067225.19",
      gene_type : "protein_coding",
      gene_name : "PKM",
      gene_level : 1,
      hgnc_id : "HGNC:9021",
      havana_gene : "OTTHUMG00000172709.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72241181,
      stop : 72272999,
      direction : "-",
      ID : "ENSG00000137817.17",
      gene_id : "ENSG00000137817.17",
      gene_type : "protein_coding",
      gene_name : "PARP6",
      gene_level : 2,
      hgnc_id : "HGNC:26921",
      havana_gene : "OTTHUMG00000133443.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72266746,
      stop : 72319946,
      direction : "-",
      ID : "ENSG00000273025.1",
      gene_id : "ENSG00000273025.1",
      gene_type : "protein_coding",
      gene_name : "AC009690.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000133444.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72284727,
      stop : 72320157,
      direction : "-",
      ID : "ENSG00000140488.16",
      gene_id : "ENSG00000140488.16",
      gene_type : "protein_coding",
      gene_name : "CELF6",
      gene_level : 1,
      hgnc_id : "HGNC:14059",
      havana_gene : "OTTHUMG00000186423.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72284727,
      stop : 72375981,
      direction : "-",
      ID : "ENSG00000260729.1",
      gene_id : "ENSG00000260729.1",
      gene_type : "protein_coding",
      gene_name : "AC009690.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172710.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72340924,
      stop : 72376420,
      direction : "-",
      ID : "ENSG00000213614.10",
      gene_id : "ENSG00000213614.10",
      gene_type : "protein_coding",
      gene_name : "HEXA",
      gene_level : 1,
      hgnc_id : "HGNC:4878",
      havana_gene : "OTTHUMG00000133445.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72398302,
      stop : 72408367,
      direction : "+",
      ID : "ENSG00000187806.9",
      gene_id : "ENSG00000187806.9",
      gene_type : "protein_coding",
      gene_name : "TMEM202",
      gene_level : 1,
      hgnc_id : "HGNC:33733",
      havana_gene : "OTTHUMG00000172716.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72474330,
      stop : 72602987,
      direction : "+",
      ID : "ENSG00000166233.15",
      gene_id : "ENSG00000166233.15",
      gene_type : "protein_coding",
      gene_name : "ARIH1",
      gene_level : 2,
      hgnc_id : "HGNC:689",
      havana_gene : "OTTHUMG00000133474.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72654738,
      stop : 72666394,
      direction : "+",
      ID : "ENSG00000215186.6",
      gene_id : "ENSG00000215186.6",
      gene_type : "protein_coding",
      gene_name : "GOLGA6B",
      gene_level : 2,
      hgnc_id : "HGNC:32205",
      havana_gene : "OTTHUMG00000133511.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72675798,
      stop : 72686182,
      direction : "-",
      ID : "ENSG00000175202.6",
      gene_id : "ENSG00000175202.6",
      gene_type : "protein_coding",
      gene_name : "HIGD2B",
      gene_level : 2,
      hgnc_id : "HGNC:26984",
      havana_gene : "OTTHUMG00000172776.5",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72686179,
      stop : 72738475,
      direction : "+",
      ID : "ENSG00000140463.14",
      gene_id : "ENSG00000140463.14",
      gene_type : "protein_coding",
      gene_name : "BBS4",
      gene_level : 2,
      hgnc_id : "HGNC:969",
      havana_gene : "OTTHUMG00000133510.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 72751369,
      stop : 72785846,
      direction : "-",
      ID : "ENSG00000159322.17",
      gene_id : "ENSG00000159322.17",
      gene_type : "protein_coding",
      gene_name : "ADPGK",
      gene_level : 1,
      hgnc_id : "HGNC:25250",
      havana_gene : "OTTHUMG00000172777.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73051710,
      stop : 73305205,
      direction : "+",
      ID : "ENSG00000067141.17",
      gene_id : "ENSG00000067141.17",
      gene_type : "protein_coding",
      gene_name : "NEO1",
      gene_level : 1,
      hgnc_id : "HGNC:7754",
      havana_gene : "OTTHUMG00000133509.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73319859,
      stop : 73368958,
      direction : "-",
      ID : "ENSG00000138622.4",
      gene_id : "ENSG00000138622.4",
      gene_type : "protein_coding",
      gene_name : "HCN4",
      gene_level : 2,
      hgnc_id : "HGNC:16882",
      havana_gene : "OTTHUMG00000137563.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73443164,
      stop : 73560013,
      direction : "+",
      ID : "ENSG00000183324.11",
      gene_id : "ENSG00000183324.11",
      gene_type : "protein_coding",
      gene_name : "REC114",
      gene_level : 2,
      hgnc_id : "HGNC:25065",
      havana_gene : "OTTHUMG00000172549.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73560014,
      stop : 73634134,
      direction : "-",
      ID : "ENSG00000156642.17",
      gene_id : "ENSG00000156642.17",
      gene_type : "protein_coding",
      gene_name : "NPTN",
      gene_level : 2,
      hgnc_id : "HGNC:17867",
      havana_gene : "OTTHUMG00000137586.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73683966,
      stop : 73714514,
      direction : "+",
      ID : "ENSG00000103855.18",
      gene_id : "ENSG00000103855.18",
      gene_type : "protein_coding",
      gene_name : "CD276",
      gene_level : 1,
      hgnc_id : "HGNC:19137",
      havana_gene : "OTTHUMG00000137585.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73735458,
      stop : 73753351,
      direction : "-",
      ID : "ENSG00000205363.7",
      gene_id : "ENSG00000205363.7",
      gene_type : "protein_coding",
      gene_name : "INSYN1",
      gene_level : 1,
      hgnc_id : "HGNC:33753",
      havana_gene : "OTTHUMG00000172556.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73873564,
      stop : 73889214,
      direction : "+",
      ID : "ENSG00000167139.9",
      gene_id : "ENSG00000167139.9",
      gene_type : "protein_coding",
      gene_name : "TBC1D21",
      gene_level : 1,
      hgnc_id : "HGNC:28536",
      havana_gene : "OTTHUMG00000137594.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73925989,
      stop : 73952137,
      direction : "+",
      ID : "ENSG00000129038.16",
      gene_id : "ENSG00000129038.16",
      gene_type : "protein_coding",
      gene_name : "LOXL1",
      gene_level : 2,
      hgnc_id : "HGNC:6665",
      havana_gene : "OTTHUMG00000137595.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73978926,
      stop : 73994622,
      direction : "-",
      ID : "ENSG00000067221.14",
      gene_id : "ENSG00000067221.14",
      gene_type : "protein_coding",
      gene_name : "STOML1",
      gene_level : 1,
      hgnc_id : "HGNC:14560",
      havana_gene : "OTTHUMG00000137608.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 73994673,
      stop : 74047827,
      direction : "+",
      ID : "ENSG00000140464.20",
      gene_id : "ENSG00000140464.20",
      gene_type : "protein_coding",
      gene_name : "PML",
      gene_level : 2,
      hgnc_id : "HGNC:9113",
      havana_gene : "OTTHUMG00000137607.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74069857,
      stop : 74082550,
      direction : "-",
      ID : "ENSG00000159289.6",
      gene_id : "ENSG00000159289.6",
      gene_type : "protein_coding",
      gene_name : "GOLGA6A",
      gene_level : 2,
      hgnc_id : "HGNC:13567",
      havana_gene : "OTTHUMG00000173035.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74100311,
      stop : 74138540,
      direction : "+",
      ID : "ENSG00000167178.16",
      gene_id : "ENSG00000167178.16",
      gene_type : "protein_coding",
      gene_name : "ISLR2",
      gene_level : 2,
      hgnc_id : "HGNC:29286",
      havana_gene : "OTTHUMG00000137624.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74173710,
      stop : 74176872,
      direction : "+",
      ID : "ENSG00000129009.13",
      gene_id : "ENSG00000129009.13",
      gene_type : "protein_coding",
      gene_name : "ISLR",
      gene_level : 2,
      hgnc_id : "HGNC:6133",
      havana_gene : "OTTHUMG00000137623.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74179466,
      stop : 74212267,
      direction : "-",
      ID : "ENSG00000137868.19",
      gene_id : "ENSG00000137868.19",
      gene_type : "protein_coding",
      gene_name : "STRA6",
      gene_level : 2,
      hgnc_id : "HGNC:30650",
      havana_gene : "OTTHUMG00000138998.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74202705,
      stop : 74336472,
      direction : "+",
      ID : "ENSG00000140481.15",
      gene_id : "ENSG00000140481.15",
      gene_type : "protein_coding",
      gene_name : "CCDC33",
      gene_level : 2,
      hgnc_id : "HGNC:26552",
      havana_gene : "OTTHUMG00000172621.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74337759,
      stop : 74367646,
      direction : "-",
      ID : "ENSG00000140459.18",
      gene_id : "ENSG00000140459.18",
      gene_type : "protein_coding",
      gene_name : "CYP11A1",
      gene_level : 1,
      hgnc_id : "HGNC:2590",
      havana_gene : "OTTHUMG00000150716.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74409289,
      stop : 74433958,
      direction : "-",
      ID : "ENSG00000138623.10",
      gene_id : "ENSG00000138623.10",
      gene_type : "protein_coding",
      gene_name : "SEMA7A",
      gene_level : 2,
      hgnc_id : "HGNC:10741",
      havana_gene : "OTTHUMG00000139000.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74445977,
      stop : 74461182,
      direction : "-",
      ID : "ENSG00000138629.16",
      gene_id : "ENSG00000138629.16",
      gene_type : "protein_coding",
      gene_name : "UBL7",
      gene_level : 1,
      hgnc_id : "HGNC:28221",
      havana_gene : "OTTHUMG00000139001.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74541206,
      stop : 74598131,
      direction : "+",
      ID : "ENSG00000179361.18",
      gene_id : "ENSG00000179361.18",
      gene_type : "protein_coding",
      gene_name : "ARID3B",
      gene_level : 1,
      hgnc_id : "HGNC:14350",
      havana_gene : "OTTHUMG00000141321.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74598500,
      stop : 74645414,
      direction : "+",
      ID : "ENSG00000179335.19",
      gene_id : "ENSG00000179335.19",
      gene_type : "protein_coding",
      gene_name : "CLK3",
      gene_level : 1,
      hgnc_id : "HGNC:2071",
      havana_gene : "OTTHUMG00000141320.13",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74630558,
      stop : 74696292,
      direction : "-",
      ID : "ENSG00000179151.13",
      gene_id : "ENSG00000179151.13",
      gene_type : "protein_coding",
      gene_name : "EDC3",
      gene_level : 2,
      hgnc_id : "HGNC:26114",
      havana_gene : "OTTHUMG00000142815.12",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74719542,
      stop : 74725536,
      direction : "-",
      ID : "ENSG00000140465.14",
      gene_id : "ENSG00000140465.14",
      gene_type : "protein_coding",
      gene_name : "CYP1A1",
      gene_level : 1,
      hgnc_id : "HGNC:2595",
      havana_gene : "OTTHUMG00000142812.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74748845,
      stop : 74756607,
      direction : "+",
      ID : "ENSG00000140505.7",
      gene_id : "ENSG00000140505.7",
      gene_type : "protein_coding",
      gene_name : "CYP1A2",
      gene_level : 2,
      hgnc_id : "HGNC:2596",
      havana_gene : "OTTHUMG00000172901.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74782057,
      stop : 74803198,
      direction : "+",
      ID : "ENSG00000103653.16",
      gene_id : "ENSG00000103653.16",
      gene_type : "protein_coding",
      gene_name : "CSK",
      gene_level : 2,
      hgnc_id : "HGNC:2444",
      havana_gene : "OTTHUMG00000142814.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74812716,
      stop : 74825757,
      direction : "+",
      ID : "ENSG00000140506.17",
      gene_id : "ENSG00000140506.17",
      gene_type : "protein_coding",
      gene_name : "LMAN1L",
      gene_level : 1,
      hgnc_id : "HGNC:6632",
      havana_gene : "OTTHUMG00000142813.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74826627,
      stop : 74831802,
      direction : "+",
      ID : "ENSG00000213578.6",
      gene_id : "ENSG00000213578.6",
      gene_type : "protein_coding",
      gene_name : "CPLX3",
      gene_level : 2,
      hgnc_id : "HGNC:27652",
      havana_gene : "OTTHUMG00000142816.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74836118,
      stop : 74843346,
      direction : "-",
      ID : "ENSG00000140474.14",
      gene_id : "ENSG00000140474.14",
      gene_type : "protein_coding",
      gene_name : "ULK3",
      gene_level : 2,
      hgnc_id : "HGNC:19703",
      havana_gene : "OTTHUMG00000173020.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74843730,
      stop : 74873365,
      direction : "-",
      ID : "ENSG00000140497.16",
      gene_id : "ENSG00000140497.16",
      gene_type : "protein_coding",
      gene_name : "SCAMP2",
      gene_level : 1,
      hgnc_id : "HGNC:10564",
      havana_gene : "OTTHUMG00000142817.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74890005,
      stop : 74902219,
      direction : "+",
      ID : "ENSG00000178802.18",
      gene_id : "ENSG00000178802.18",
      gene_type : "protein_coding",
      gene_name : "MPI",
      gene_level : 1,
      hgnc_id : "HGNC:7216",
      havana_gene : "OTTHUMG00000142826.10",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74899992,
      stop : 74906883,
      direction : "-",
      ID : "ENSG00000178761.15",
      gene_id : "ENSG00000178761.15",
      gene_type : "protein_coding",
      gene_name : "FAM219B",
      gene_level : 2,
      hgnc_id : "HGNC:24695",
      havana_gene : "OTTHUMG00000172715.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74919791,
      stop : 74938083,
      direction : "-",
      ID : "ENSG00000178741.12",
      gene_id : "ENSG00000178741.12",
      gene_type : "protein_coding",
      gene_name : "COX5A",
      gene_level : 1,
      hgnc_id : "HGNC:2267",
      havana_gene : "OTTHUMG00000142825.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74954418,
      stop : 74956772,
      direction : "-",
      ID : "ENSG00000178718.7",
      gene_id : "ENSG00000178718.7",
      gene_type : "protein_coding",
      gene_name : "RPP25",
      gene_level : 2,
      hgnc_id : "HGNC:30361",
      havana_gene : "OTTHUMG00000142822.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 74957219,
      stop : 75021495,
      direction : "+",
      ID : "ENSG00000198794.12",
      gene_id : "ENSG00000198794.12",
      gene_type : "protein_coding",
      gene_name : "SCAMP5",
      gene_level : 2,
      hgnc_id : "HGNC:30386",
      havana_gene : "OTTHUMG00000172704.11",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75023586,
      stop : 75117462,
      direction : "+",
      ID : "ENSG00000138621.12",
      gene_id : "ENSG00000138621.12",
      gene_type : "protein_coding",
      gene_name : "PPCDC",
      gene_level : 1,
      hgnc_id : "HGNC:28107",
      havana_gene : "OTTHUMG00000142824.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75195643,
      stop : 75212169,
      direction : "+",
      ID : "ENSG00000167173.19",
      gene_id : "ENSG00000167173.19",
      gene_type : "protein_coding",
      gene_name : "C15orf39",
      gene_level : 2,
      hgnc_id : "HGNC:24497",
      havana_gene : "OTTHUMG00000142820.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75258599,
      stop : 75270199,
      direction : "+",
      ID : "ENSG00000167195.7",
      gene_id : "ENSG00000167195.7",
      gene_type : "protein_coding",
      gene_name : "GOLGA6C",
      gene_level : 2,
      hgnc_id : "HGNC:32206",
      havana_gene : "OTTHUMG00000172671.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75282835,
      stop : 75295807,
      direction : "+",
      ID : "ENSG00000140478.15",
      gene_id : "ENSG00000140478.15",
      gene_type : "protein_coding",
      gene_name : "GOLGA6D",
      gene_level : 2,
      hgnc_id : "HGNC:32204",
      havana_gene : "OTTHUMG00000172672.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75336020,
      stop : 75343224,
      direction : "+",
      ID : "ENSG00000140365.16",
      gene_id : "ENSG00000140365.16",
      gene_type : "protein_coding",
      gene_name : "COMMD4",
      gene_level : 2,
      hgnc_id : "HGNC:26027",
      havana_gene : "OTTHUMG00000142823.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75346955,
      stop : 75357115,
      direction : "+",
      ID : "ENSG00000140398.14",
      gene_id : "ENSG00000140398.14",
      gene_type : "protein_coding",
      gene_name : "NEIL1",
      gene_level : 2,
      hgnc_id : "HGNC:18448",
      havana_gene : "OTTHUMG00000142821.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75355207,
      stop : 75368612,
      direction : "-",
      ID : "ENSG00000140400.17",
      gene_id : "ENSG00000140400.17",
      gene_type : "protein_coding",
      gene_name : "MAN2C1",
      gene_level : 1,
      hgnc_id : "HGNC:6827",
      havana_gene : "OTTHUMG00000172698.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75369379,
      stop : 75455842,
      direction : "-",
      ID : "ENSG00000169375.16",
      gene_id : "ENSG00000169375.16",
      gene_type : "protein_coding",
      gene_name : "SIN3A",
      gene_level : 2,
      hgnc_id : "HGNC:19353",
      havana_gene : "OTTHUMG00000142834.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75463251,
      stop : 75579315,
      direction : "-",
      ID : "ENSG00000169410.10",
      gene_id : "ENSG00000169410.10",
      gene_type : "protein_coding",
      gene_name : "PTPN9",
      gene_level : 2,
      hgnc_id : "HGNC:9661",
      havana_gene : "OTTHUMG00000142838.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75598083,
      stop : 75626469,
      direction : "-",
      ID : "ENSG00000169371.14",
      gene_id : "ENSG00000169371.14",
      gene_type : "protein_coding",
      gene_name : "SNUPN",
      gene_level : 2,
      hgnc_id : "HGNC:14245",
      havana_gene : "OTTHUMG00000142833.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75639085,
      stop : 75648706,
      direction : "-",
      ID : "ENSG00000177971.8",
      gene_id : "ENSG00000177971.8",
      gene_type : "protein_coding",
      gene_name : "IMP3",
      gene_level : 2,
      hgnc_id : "HGNC:14497",
      havana_gene : "OTTHUMG00000142840.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75647912,
      stop : 75662301,
      direction : "+",
      ID : "ENSG00000173548.9",
      gene_id : "ENSG00000173548.9",
      gene_type : "protein_coding",
      gene_name : "SNX33",
      gene_level : 2,
      hgnc_id : "HGNC:28468",
      havana_gene : "OTTHUMG00000142835.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75674322,
      stop : 75712848,
      direction : "-",
      ID : "ENSG00000173546.7",
      gene_id : "ENSG00000173546.7",
      gene_type : "protein_coding",
      gene_name : "CSPG4",
      gene_level : 2,
      hgnc_id : "HGNC:2466",
      havana_gene : "OTTHUMG00000142836.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75724041,
      stop : 75727688,
      direction : "+",
      ID : "ENSG00000182950.3",
      gene_id : "ENSG00000182950.3",
      gene_type : "protein_coding",
      gene_name : "ODF3L1",
      gene_level : 2,
      hgnc_id : "HGNC:28735",
      havana_gene : "OTTHUMG00000142837.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75843307,
      stop : 75901078,
      direction : "+",
      ID : "ENSG00000140367.12",
      gene_id : "ENSG00000140367.12",
      gene_type : "protein_coding",
      gene_name : "UBE2Q2",
      gene_level : 2,
      hgnc_id : "HGNC:19248",
      havana_gene : "OTTHUMG00000142839.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75903876,
      stop : 75942511,
      direction : "+",
      ID : "ENSG00000167196.14",
      gene_id : "ENSG00000167196.14",
      gene_type : "protein_coding",
      gene_name : "FBXO22",
      gene_level : 1,
      hgnc_id : "HGNC:13593",
      havana_gene : "OTTHUMG00000142841.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 75935969,
      stop : 76059795,
      direction : "-",
      ID : "ENSG00000169752.17",
      gene_id : "ENSG00000169752.17",
      gene_type : "protein_coding",
      gene_name : "NRG4",
      gene_level : 2,
      hgnc_id : "HGNC:29862",
      havana_gene : "OTTHUMG00000142917.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 76059958,
      stop : 76229121,
      direction : "+",
      ID : "ENSG00000169758.13",
      gene_id : "ENSG00000169758.13",
      gene_type : "protein_coding",
      gene_name : "TMEM266",
      gene_level : 1,
      hgnc_id : "HGNC:26763",
      havana_gene : "OTTHUMG00000142918.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 76215353,
      stop : 76311472,
      direction : "-",
      ID : "ENSG00000140374.16",
      gene_id : "ENSG00000140374.16",
      gene_type : "protein_coding",
      gene_name : "ETFA",
      gene_level : 1,
      hgnc_id : "HGNC:3481",
      havana_gene : "OTTHUMG00000172586.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 76336773,
      stop : 76342475,
      direction : "+",
      ID : "ENSG00000159556.10",
      gene_id : "ENSG00000159556.10",
      gene_type : "protein_coding",
      gene_name : "ISL2",
      gene_level : 2,
      hgnc_id : "HGNC:18524",
      havana_gene : "OTTHUMG00000143723.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 76347904,
      stop : 76905444,
      direction : "-",
      ID : "ENSG00000140386.13",
      gene_id : "ENSG00000140386.13",
      gene_type : "protein_coding",
      gene_name : "SCAPER",
      gene_level : 1,
      hgnc_id : "HGNC:13081",
      havana_gene : "OTTHUMG00000172655.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 76931738,
      stop : 76954393,
      direction : "+",
      ID : "ENSG00000117906.14",
      gene_id : "ENSG00000117906.14",
      gene_type : "protein_coding",
      gene_name : "RCN2",
      gene_level : 2,
      hgnc_id : "HGNC:9935",
      havana_gene : "OTTHUMG00000143730.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 76993359,
      stop : 77037475,
      direction : "+",
      ID : "ENSG00000140368.13",
      gene_id : "ENSG00000140368.13",
      gene_type : "protein_coding",
      gene_name : "PSTPIP1",
      gene_level : 1,
      hgnc_id : "HGNC:9580",
      havana_gene : "OTTHUMG00000172594.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 77041404,
      stop : 77083984,
      direction : "-",
      ID : "ENSG00000140391.15",
      gene_id : "ENSG00000140391.15",
      gene_type : "protein_coding",
      gene_name : "TSPAN3",
      gene_level : 1,
      hgnc_id : "HGNC:17752",
      havana_gene : "OTTHUMG00000143728.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 77100656,
      stop : 77420144,
      direction : "-",
      ID : "ENSG00000173517.10",
      gene_id : "ENSG00000173517.10",
      gene_type : "protein_coding",
      gene_name : "PEAK1",
      gene_level : 1,
      hgnc_id : "HGNC:29431",
      havana_gene : "OTTHUMG00000172618.11",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 77420412,
      stop : 77485607,
      direction : "+",
      ID : "ENSG00000140382.15",
      gene_id : "ENSG00000140382.15",
      gene_type : "protein_coding",
      gene_name : "HMG20A",
      gene_level : 1,
      hgnc_id : "HGNC:5001",
      havana_gene : "OTTHUMG00000143729.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 77613027,
      stop : 77820900,
      direction : "-",
      ID : "ENSG00000169783.13",
      gene_id : "ENSG00000169783.13",
      gene_type : "protein_coding",
      gene_name : "LINGO1",
      gene_level : 1,
      hgnc_id : "HGNC:21205",
      havana_gene : "OTTHUMG00000172629.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 77984036,
      stop : 78077724,
      direction : "-",
      ID : "ENSG00000167202.11",
      gene_id : "ENSG00000167202.11",
      gene_type : "protein_coding",
      gene_name : "TBC1D2B",
      gene_level : 1,
      hgnc_id : "HGNC:29183",
      havana_gene : "OTTHUMG00000152885.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78077808,
      stop : 78104909,
      direction : "+",
      ID : "ENSG00000183476.12",
      gene_id : "ENSG00000183476.12",
      gene_type : "protein_coding",
      gene_name : "SH2D7",
      gene_level : 1,
      hgnc_id : "HGNC:34549",
      havana_gene : "OTTHUMG00000154271.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78104606,
      stop : 78131535,
      direction : "-",
      ID : "ENSG00000136425.14",
      gene_id : "ENSG00000136425.14",
      gene_type : "protein_coding",
      gene_name : "CIB2",
      gene_level : 2,
      hgnc_id : "HGNC:24579",
      havana_gene : "OTTHUMG00000143731.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78131498,
      stop : 78171945,
      direction : "+",
      ID : "ENSG00000166411.14",
      gene_id : "ENSG00000166411.14",
      gene_type : "protein_coding",
      gene_name : "IDH3A",
      gene_level : 2,
      hgnc_id : "HGNC:5384",
      havana_gene : "OTTHUMG00000143732.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78167468,
      stop : 78245688,
      direction : "-",
      ID : "ENSG00000103740.10",
      gene_id : "ENSG00000103740.10",
      gene_type : "protein_coding",
      gene_name : "ACSBG1",
      gene_level : 1,
      hgnc_id : "HGNC:29567",
      havana_gene : "OTTHUMG00000143734.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78264086,
      stop : 78282196,
      direction : "+",
      ID : "ENSG00000140403.12",
      gene_id : "ENSG00000140403.12",
      gene_type : "protein_coding",
      gene_name : "DNAJA4",
      gene_level : 1,
      hgnc_id : "HGNC:14885",
      havana_gene : "OTTHUMG00000143733.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78277835,
      stop : 78299703,
      direction : "-",
      ID : "ENSG00000140395.9",
      gene_id : "ENSG00000140395.9",
      gene_type : "protein_coding",
      gene_name : "WDR61",
      gene_level : 1,
      hgnc_id : "HGNC:30300",
      havana_gene : "OTTHUMG00000143735.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78340353,
      stop : 78348225,
      direction : "+",
      ID : "ENSG00000166426.8",
      gene_id : "ENSG00000166426.8",
      gene_type : "protein_coding",
      gene_name : "CRABP1",
      gene_level : 1,
      hgnc_id : "HGNC:2338",
      havana_gene : "OTTHUMG00000143862.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78437431,
      stop : 78501453,
      direction : "+",
      ID : "ENSG00000136381.13",
      gene_id : "ENSG00000136381.13",
      gene_type : "protein_coding",
      gene_name : "IREB2",
      gene_level : 2,
      hgnc_id : "HGNC:6115",
      havana_gene : "OTTHUMG00000143861.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78507564,
      stop : 78537372,
      direction : "+",
      ID : "ENSG00000188266.14",
      gene_id : "ENSG00000188266.14",
      gene_type : "protein_coding",
      gene_name : "HYKK",
      gene_level : 2,
      hgnc_id : "HGNC:34403",
      havana_gene : "OTTHUMG00000177204.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78540405,
      stop : 78552417,
      direction : "+",
      ID : "ENSG00000041357.16",
      gene_id : "ENSG00000041357.16",
      gene_type : "protein_coding",
      gene_name : "PSMA4",
      gene_level : 1,
      hgnc_id : "HGNC:9533",
      havana_gene : "OTTHUMG00000143859.11",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78565520,
      stop : 78595269,
      direction : "+",
      ID : "ENSG00000169684.13",
      gene_id : "ENSG00000169684.13",
      gene_type : "protein_coding",
      gene_name : "CHRNA5",
      gene_level : 1,
      hgnc_id : "HGNC:1959",
      havana_gene : "OTTHUMG00000143858.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78593052,
      stop : 78621295,
      direction : "-",
      ID : "ENSG00000080644.16",
      gene_id : "ENSG00000080644.16",
      gene_type : "protein_coding",
      gene_name : "CHRNA3",
      gene_level : 1,
      hgnc_id : "HGNC:1957",
      havana_gene : "OTTHUMG00000143863.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78624111,
      stop : 78727754,
      direction : "-",
      ID : "ENSG00000117971.12",
      gene_id : "ENSG00000117971.12",
      gene_type : "protein_coding",
      gene_name : "CHRNB4",
      gene_level : 1,
      hgnc_id : "HGNC:1964",
      havana_gene : "OTTHUMG00000143860.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78759206,
      stop : 78811464,
      direction : "-",
      ID : "ENSG00000136378.15",
      gene_id : "ENSG00000136378.15",
      gene_type : "protein_coding",
      gene_name : "ADAMTS7",
      gene_level : 2,
      hgnc_id : "HGNC:223",
      havana_gene : "OTTHUMG00000172907.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78810487,
      stop : 78898139,
      direction : "+",
      ID : "ENSG00000185787.15",
      gene_id : "ENSG00000185787.15",
      gene_type : "protein_coding",
      gene_name : "MORF4L1",
      gene_level : 1,
      hgnc_id : "HGNC:16989",
      havana_gene : "OTTHUMG00000143865.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78921058,
      stop : 78949574,
      direction : "-",
      ID : "ENSG00000103811.18",
      gene_id : "ENSG00000103811.18",
      gene_type : "protein_coding",
      gene_name : "CTSH",
      gene_level : 2,
      hgnc_id : "HGNC:2535",
      havana_gene : "OTTHUMG00000144171.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 78959906,
      stop : 79090780,
      direction : "-",
      ID : "ENSG00000058335.16",
      gene_id : "ENSG00000058335.16",
      gene_type : "protein_coding",
      gene_name : "RASGRF1",
      gene_level : 1,
      hgnc_id : "HGNC:9875",
      havana_gene : "OTTHUMG00000144172.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79293285,
      stop : 79298235,
      direction : "+",
      ID : "ENSG00000235711.4",
      gene_id : "ENSG00000235711.4",
      gene_type : "protein_coding",
      gene_name : "ANKRD34C",
      gene_level : 2,
      hgnc_id : "HGNC:33888",
      havana_gene : "OTTHUMG00000172072.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79311112,
      stop : 79427432,
      direction : "+",
      ID : "ENSG00000166557.14",
      gene_id : "ENSG00000166557.14",
      gene_type : "protein_coding",
      gene_name : "TMED3",
      gene_level : 1,
      hgnc_id : "HGNC:28889",
      havana_gene : "OTTHUMG00000144170.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79432336,
      stop : 79472304,
      direction : "+",
      ID : "ENSG00000169330.9",
      gene_id : "ENSG00000169330.9",
      gene_type : "protein_coding",
      gene_name : "MINAR1",
      gene_level : 2,
      hgnc_id : "HGNC:29172",
      havana_gene : "OTTHUMG00000172073.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79833585,
      stop : 79897379,
      direction : "-",
      ID : "ENSG00000136371.11",
      gene_id : "ENSG00000136371.11",
      gene_type : "protein_coding",
      gene_name : "MTHFS",
      gene_level : 1,
      hgnc_id : "HGNC:7437",
      havana_gene : "OTTHUMG00000144174.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79845150,
      stop : 79923754,
      direction : "-",
      ID : "ENSG00000259332.3",
      gene_id : "ENSG00000259332.3",
      gene_type : "protein_coding",
      gene_name : "ST20-MTHFS",
      gene_level : 2,
      hgnc_id : "HGNC:44655",
      havana_gene : "OTTHUMG00000172077.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79898840,
      stop : 79923702,
      direction : "-",
      ID : "ENSG00000180953.11",
      gene_id : "ENSG00000180953.11",
      gene_type : "protein_coding",
      gene_name : "ST20",
      gene_level : 2,
      hgnc_id : "HGNC:33520",
      havana_gene : "OTTHUMG00000172078.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 79960892,
      stop : 79971196,
      direction : "-",
      ID : "ENSG00000140379.9",
      gene_id : "ENSG00000140379.9",
      gene_type : "protein_coding",
      gene_name : "BCL2A1",
      gene_level : 2,
      hgnc_id : "HGNC:991",
      havana_gene : "OTTHUMG00000144173.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80059568,
      stop : 80138393,
      direction : "+",
      ID : "ENSG00000086666.19",
      gene_id : "ENSG00000086666.19",
      gene_type : "protein_coding",
      gene_name : "ZFAND6",
      gene_level : 1,
      hgnc_id : "HGNC:30164",
      havana_gene : "OTTHUMG00000144169.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80152490,
      stop : 80186946,
      direction : "+",
      ID : "ENSG00000103876.13",
      gene_id : "ENSG00000103876.13",
      gene_type : "protein_coding",
      gene_name : "FAH",
      gene_level : 2,
      hgnc_id : "HGNC:3579",
      havana_gene : "OTTHUMG00000144187.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80195481,
      stop : 80252213,
      direction : "-",
      ID : "ENSG00000259417.3",
      gene_id : "ENSG00000259417.3",
      gene_type : "protein_coding",
      gene_name : "CTXND1",
      gene_level : 2,
      hgnc_id : "HGNC:50507",
      havana_gene : "OTTHUMG00000172080.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80404350,
      stop : 80597933,
      direction : "+",
      ID : "ENSG00000172379.21",
      gene_id : "ENSG00000172379.21",
      gene_type : "protein_coding",
      gene_name : "ARNT2",
      gene_level : 1,
      hgnc_id : "HGNC:16876",
      havana_gene : "OTTHUMG00000165478.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80679684,
      stop : 80755621,
      direction : "+",
      ID : "ENSG00000136379.12",
      gene_id : "ENSG00000136379.12",
      gene_type : "protein_coding",
      gene_name : "ABHD17C",
      gene_level : 2,
      hgnc_id : "HGNC:26925",
      havana_gene : "OTTHUMG00000172282.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80779343,
      stop : 80951776,
      direction : "+",
      ID : "ENSG00000103888.17",
      gene_id : "ENSG00000103888.17",
      gene_type : "protein_coding",
      gene_name : "CEMIP",
      gene_level : 2,
      hgnc_id : "HGNC:29213",
      havana_gene : "OTTHUMG00000144184.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 80946289,
      stop : 80989828,
      direction : "-",
      ID : "ENSG00000117899.11",
      gene_id : "ENSG00000117899.11",
      gene_type : "protein_coding",
      gene_name : "MESD",
      gene_level : 1,
      hgnc_id : "HGNC:13520",
      havana_gene : "OTTHUMG00000172288.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 81000923,
      stop : 81005788,
      direction : "+",
      ID : "ENSG00000140406.4",
      gene_id : "ENSG00000140406.4",
      gene_type : "protein_coding",
      gene_name : "TLNRD1",
      gene_level : 2,
      hgnc_id : "HGNC:13519",
      havana_gene : "OTTHUMG00000144185.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 81002142,
      stop : 81002279,
      direction : "+",
      ID : "ENSG00000288625.1",
      gene_id : "ENSG00000288625.1",
      gene_type : "protein_coding",
      gene_name : "AC068870.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 81007033,
      stop : 81149179,
      direction : "+",
      ID : "ENSG00000156206.14",
      gene_id : "ENSG00000156206.14",
      gene_type : "protein_coding",
      gene_name : "CFAP161",
      gene_level : 1,
      hgnc_id : "HGNC:26782",
      havana_gene : "OTTHUMG00000172263.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 81159575,
      stop : 81314058,
      direction : "+",
      ID : "ENSG00000172349.17",
      gene_id : "ENSG00000172349.17",
      gene_type : "protein_coding",
      gene_name : "IL16",
      gene_level : 1,
      hgnc_id : "HGNC:5980",
      havana_gene : "OTTHUMG00000144186.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 81309053,
      stop : 81324183,
      direction : "-",
      ID : "ENSG00000172345.14",
      gene_id : "ENSG00000172345.14",
      gene_type : "protein_coding",
      gene_name : "STARD5",
      gene_level : 2,
      hgnc_id : "HGNC:18065",
      havana_gene : "OTTHUMG00000147342.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 81331088,
      stop : 81374213,
      direction : "-",
      ID : "ENSG00000188869.13",
      gene_id : "ENSG00000188869.13",
      gene_type : "protein_coding",
      gene_name : "TMC3",
      gene_level : 1,
      hgnc_id : "HGNC:22995",
      havana_gene : "OTTHUMG00000172314.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82041778,
      stop : 82046119,
      direction : "-",
      ID : "ENSG00000183496.6",
      gene_id : "ENSG00000183496.6",
      gene_type : "protein_coding",
      gene_name : "MEX3B",
      gene_level : 2,
      hgnc_id : "HGNC:25297",
      havana_gene : "OTTHUMG00000147356.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82130233,
      stop : 82262734,
      direction : "-",
      ID : "ENSG00000140598.15",
      gene_id : "ENSG00000140598.15",
      gene_type : "protein_coding",
      gene_name : "EFL1",
      gene_level : 2,
      hgnc_id : "HGNC:25789",
      havana_gene : "OTTHUMG00000172573.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82262810,
      stop : 82284930,
      direction : "+",
      ID : "ENSG00000188659.9",
      gene_id : "ENSG00000188659.9",
      gene_type : "protein_coding",
      gene_name : "SAXO2",
      gene_level : 1,
      hgnc_id : "HGNC:33727",
      havana_gene : "OTTHUMG00000172646.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82339993,
      stop : 82349475,
      direction : "-",
      ID : "ENSG00000278662.5",
      gene_id : "ENSG00000278662.5",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L10",
      gene_level : 2,
      hgnc_id : "HGNC:37228",
      havana_gene : "OTTHUMG00000172580.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82430018,
      stop : 82439153,
      direction : "+",
      ID : "ENSG00000197978.9",
      gene_id : "ENSG00000197978.9",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L9",
      gene_level : 2,
      hgnc_id : "HGNC:37229",
      havana_gene : "OTTHUMG00000170547.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82536750,
      stop : 82540459,
      direction : "-",
      ID : "ENSG00000182774.13",
      gene_id : "ENSG00000182774.13",
      gene_type : "protein_coding",
      gene_name : "RPS17",
      gene_level : 2,
      hgnc_id : "HGNC:10397",
      havana_gene : "OTTHUMG00000147355.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82536788,
      stop : 82573194,
      direction : "-",
      ID : "ENSG00000260836.2",
      gene_id : "ENSG00000260836.2",
      gene_type : "protein_coding",
      gene_name : "AC245033.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172875.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82543201,
      stop : 82648861,
      direction : "-",
      ID : "ENSG00000214575.9",
      gene_id : "ENSG00000214575.9",
      gene_type : "protein_coding",
      gene_name : "CPEB1",
      gene_level : 1,
      hgnc_id : "HGNC:21744",
      havana_gene : "OTTHUMG00000172877.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82659281,
      stop : 82710112,
      direction : "-",
      ID : "ENSG00000103723.17",
      gene_id : "ENSG00000103723.17",
      gene_type : "protein_coding",
      gene_name : "AP3B2",
      gene_level : 1,
      hgnc_id : "HGNC:567",
      havana_gene : "OTTHUMG00000168009.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82755362,
      stop : 82806070,
      direction : "-",
      ID : "ENSG00000186628.12",
      gene_id : "ENSG00000186628.12",
      gene_type : "protein_coding",
      gene_name : "FSD2",
      gene_level : 1,
      hgnc_id : "HGNC:18024",
      havana_gene : "OTTHUMG00000172400.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82809628,
      stop : 82836108,
      direction : "+",
      ID : "ENSG00000156232.7",
      gene_id : "ENSG00000156232.7",
      gene_type : "protein_coding",
      gene_name : "WHAMM",
      gene_level : 2,
      hgnc_id : "HGNC:30493",
      havana_gene : "OTTHUMG00000172422.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82836946,
      stop : 82986153,
      direction : "-",
      ID : "ENSG00000103942.13",
      gene_id : "ENSG00000103942.13",
      gene_type : "protein_coding",
      gene_name : "HOMER2",
      gene_level : 1,
      hgnc_id : "HGNC:17513",
      havana_gene : "OTTHUMG00000172462.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82986210,
      stop : 82991057,
      direction : "+",
      ID : "ENSG00000169612.4",
      gene_id : "ENSG00000169612.4",
      gene_type : "protein_coding",
      gene_name : "RAMAC",
      gene_level : 2,
      hgnc_id : "HGNC:31022",
      havana_gene : "OTTHUMG00000147357.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 82988441,
      stop : 83011641,
      direction : "-",
      ID : "ENSG00000169609.14",
      gene_id : "ENSG00000169609.14",
      gene_type : "protein_coding",
      gene_name : "C15orf40",
      gene_level : 1,
      hgnc_id : "HGNC:28443",
      havana_gene : "OTTHUMG00000160473.11",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 83016423,
      stop : 83067252,
      direction : "-",
      ID : "ENSG00000064726.10",
      gene_id : "ENSG00000064726.10",
      gene_type : "protein_coding",
      gene_name : "BTBD1",
      gene_level : 2,
      hgnc_id : "HGNC:1120",
      havana_gene : "OTTHUMG00000147364.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 83107572,
      stop : 83144854,
      direction : "+",
      ID : "ENSG00000136404.16",
      gene_id : "ENSG00000136404.16",
      gene_type : "protein_coding",
      gene_name : "TM6SF1",
      gene_level : 1,
      hgnc_id : "HGNC:11860",
      havana_gene : "OTTHUMG00000147365.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 83112738,
      stop : 83207823,
      direction : "-",
      ID : "ENSG00000166503.9",
      gene_id : "ENSG00000166503.9",
      gene_type : "protein_coding",
      gene_name : "HDGFL3",
      gene_level : 2,
      hgnc_id : "HGNC:24937",
      havana_gene : "OTTHUMG00000172685.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 83255903,
      stop : 83284714,
      direction : "-",
      ID : "ENSG00000169594.13",
      gene_id : "ENSG00000169594.13",
      gene_type : "protein_coding",
      gene_name : "BNC1",
      gene_level : 1,
      hgnc_id : "HGNC:1081",
      havana_gene : "OTTHUMG00000147362.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 83447228,
      stop : 83618743,
      direction : "+",
      ID : "ENSG00000140600.17",
      gene_id : "ENSG00000140600.17",
      gene_type : "protein_coding",
      gene_name : "SH3GL3",
      gene_level : 2,
      hgnc_id : "HGNC:10832",
      havana_gene : "OTTHUMG00000147361.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 83654088,
      stop : 84039842,
      direction : "+",
      ID : "ENSG00000156218.13",
      gene_id : "ENSG00000156218.13",
      gene_type : "protein_coding",
      gene_name : "ADAMTSL3",
      gene_level : 2,
      hgnc_id : "HGNC:14633",
      havana_gene : "OTTHUMG00000147363.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84235773,
      stop : 84245368,
      direction : "+",
      ID : "ENSG00000184206.12",
      gene_id : "ENSG00000184206.12",
      gene_type : "protein_coding",
      gene_name : "GOLGA6L4",
      gene_level : 2,
      hgnc_id : "HGNC:27256",
      havana_gene : "OTTHUMG00000163050.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84600986,
      stop : 84627796,
      direction : "+",
      ID : "ENSG00000176371.14",
      gene_id : "ENSG00000176371.14",
      gene_type : "protein_coding",
      gene_name : "ZSCAN2",
      gene_level : 1,
      hgnc_id : "HGNC:20994",
      havana_gene : "OTTHUMG00000074027.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84639285,
      stop : 84654343,
      direction : "-",
      ID : "ENSG00000177082.13",
      gene_id : "ENSG00000177082.13",
      gene_type : "protein_coding",
      gene_name : "WDR73",
      gene_level : 2,
      hgnc_id : "HGNC:25928",
      havana_gene : "OTTHUMG00000172375.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84655129,
      stop : 84658563,
      direction : "-",
      ID : "ENSG00000197696.10",
      gene_id : "ENSG00000197696.10",
      gene_type : "protein_coding",
      gene_name : "NMB",
      gene_level : 2,
      hgnc_id : "HGNC:7842",
      havana_gene : "OTTHUMG00000148666.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84669538,
      stop : 84716460,
      direction : "-",
      ID : "ENSG00000140612.14",
      gene_id : "ENSG00000140612.14",
      gene_type : "protein_coding",
      gene_name : "SEC11A",
      gene_level : 1,
      hgnc_id : "HGNC:17718",
      havana_gene : "OTTHUMG00000172489.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84748592,
      stop : 84806445,
      direction : "+",
      ID : "ENSG00000166716.10",
      gene_id : "ENSG00000166716.10",
      gene_type : "protein_coding",
      gene_name : "ZNF592",
      gene_level : 2,
      hgnc_id : "HGNC:28986",
      havana_gene : "OTTHUMG00000172490.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84817356,
      stop : 84873479,
      direction : "+",
      ID : "ENSG00000136383.7",
      gene_id : "ENSG00000136383.7",
      gene_type : "protein_coding",
      gene_name : "ALPK3",
      gene_level : 2,
      hgnc_id : "HGNC:17574",
      havana_gene : "OTTHUMG00000148667.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84884654,
      stop : 84945798,
      direction : "+",
      ID : "ENSG00000156222.12",
      gene_id : "ENSG00000156222.12",
      gene_type : "protein_coding",
      gene_name : "SLC28A1",
      gene_level : 2,
      hgnc_id : "HGNC:11001",
      havana_gene : "OTTHUMG00000148668.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 84980440,
      stop : 85139145,
      direction : "+",
      ID : "ENSG00000073417.15",
      gene_id : "ENSG00000073417.15",
      gene_type : "protein_coding",
      gene_name : "PDE8A",
      gene_level : 2,
      hgnc_id : "HGNC:8793",
      havana_gene : "OTTHUMG00000148670.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 85380571,
      stop : 85749358,
      direction : "+",
      ID : "ENSG00000170776.22",
      gene_id : "ENSG00000170776.22",
      gene_type : "protein_coding",
      gene_name : "AKAP13",
      gene_level : 1,
      hgnc_id : "HGNC:371",
      havana_gene : "OTTHUMG00000172205.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 85759326,
      stop : 85794925,
      direction : "-",
      ID : "ENSG00000183655.13",
      gene_id : "ENSG00000183655.13",
      gene_type : "protein_coding",
      gene_name : "KLHL25",
      gene_level : 2,
      hgnc_id : "HGNC:25732",
      havana_gene : "OTTHUMG00000148672.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 86079871,
      stop : 87049169,
      direction : "+",
      ID : "ENSG00000273540.5",
      gene_id : "ENSG00000273540.5",
      gene_type : "protein_coding",
      gene_name : "AGBL1",
      gene_level : 2,
      hgnc_id : "HGNC:26504",
      havana_gene : "OTTHUMG00000149978.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 87859751,
      stop : 88256768,
      direction : "-",
      ID : "ENSG00000140538.16",
      gene_id : "ENSG00000140538.16",
      gene_type : "protein_coding",
      gene_name : "NTRK3",
      gene_level : 1,
      hgnc_id : "HGNC:8033",
      havana_gene : "OTTHUMG00000148677.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88459477,
      stop : 88467390,
      direction : "-",
      ID : "ENSG00000259494.2",
      gene_id : "ENSG00000259494.2",
      gene_type : "protein_coding",
      gene_name : "MRPL46",
      gene_level : 1,
      hgnc_id : "HGNC:1192",
      havana_gene : "OTTHUMG00000148683.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88459501,
      stop : 88546585,
      direction : "-",
      ID : "ENSG00000173867.10",
      gene_id : "ENSG00000173867.10",
      gene_type : "protein_coding",
      gene_name : "AC013489.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185776.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88467453,
      stop : 88480776,
      direction : "+",
      ID : "ENSG00000181991.16",
      gene_id : "ENSG00000181991.16",
      gene_type : "protein_coding",
      gene_name : "MRPS11",
      gene_level : 2,
      hgnc_id : "HGNC:14050",
      havana_gene : "OTTHUMG00000148678.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88494440,
      stop : 88546681,
      direction : "-",
      ID : "ENSG00000140543.15",
      gene_id : "ENSG00000140543.15",
      gene_type : "protein_coding",
      gene_name : "DET1",
      gene_level : 2,
      hgnc_id : "HGNC:25477",
      havana_gene : "OTTHUMG00000171851.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88621337,
      stop : 88632281,
      direction : "+",
      ID : "ENSG00000181026.15",
      gene_id : "ENSG00000181026.15",
      gene_type : "protein_coding",
      gene_name : "AEN",
      gene_level : 2,
      hgnc_id : "HGNC:25722",
      havana_gene : "OTTHUMG00000148681.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88635670,
      stop : 88656483,
      direction : "+",
      ID : "ENSG00000172183.16",
      gene_id : "ENSG00000172183.16",
      gene_type : "protein_coding",
      gene_name : "ISG20",
      gene_level : 1,
      hgnc_id : "HGNC:6130",
      havana_gene : "OTTHUMG00000148679.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88803436,
      stop : 88875353,
      direction : "+",
      ID : "ENSG00000157766.19",
      gene_id : "ENSG00000157766.19",
      gene_type : "protein_coding",
      gene_name : "ACAN",
      gene_level : 1,
      hgnc_id : "HGNC:319",
      havana_gene : "OTTHUMG00000171989.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88877294,
      stop : 88895597,
      direction : "-",
      ID : "ENSG00000140511.12",
      gene_id : "ENSG00000140511.12",
      gene_type : "protein_coding",
      gene_name : "HAPLN3",
      gene_level : 1,
      hgnc_id : "HGNC:21446",
      havana_gene : "OTTHUMG00000148680.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 88898683,
      stop : 88913381,
      direction : "-",
      ID : "ENSG00000140545.15",
      gene_id : "ENSG00000140545.15",
      gene_type : "protein_coding",
      gene_name : "MFGE8",
      gene_level : 1,
      hgnc_id : "HGNC:7036",
      havana_gene : "OTTHUMG00000148682.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89087459,
      stop : 89202355,
      direction : "+",
      ID : "ENSG00000140526.18",
      gene_id : "ENSG00000140526.18",
      gene_type : "protein_coding",
      gene_name : "ABHD2",
      gene_level : 2,
      hgnc_id : "HGNC:18717",
      havana_gene : "OTTHUMG00000148684.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89209869,
      stop : 89221614,
      direction : "-",
      ID : "ENSG00000140522.12",
      gene_id : "ENSG00000140522.12",
      gene_type : "protein_coding",
      gene_name : "RLBP1",
      gene_level : 2,
      hgnc_id : "HGNC:10024",
      havana_gene : "OTTHUMG00000172884.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89243945,
      stop : 89317261,
      direction : "+",
      ID : "ENSG00000140525.19",
      gene_id : "ENSG00000140525.19",
      gene_type : "protein_coding",
      gene_name : "FANCI",
      gene_level : 1,
      hgnc_id : "HGNC:25568",
      havana_gene : "OTTHUMG00000132993.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89305198,
      stop : 89334861,
      direction : "-",
      ID : "ENSG00000140521.17",
      gene_id : "ENSG00000140521.17",
      gene_type : "protein_coding",
      gene_name : "POLG",
      gene_level : 2,
      hgnc_id : "HGNC:9179",
      havana_gene : "OTTHUMG00000149646.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89471398,
      stop : 89496589,
      direction : "-",
      ID : "ENSG00000140519.14",
      gene_id : "ENSG00000140519.14",
      gene_type : "protein_coding",
      gene_name : "RHCG",
      gene_level : 2,
      hgnc_id : "HGNC:18140",
      havana_gene : "OTTHUMG00000149647.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89575469,
      stop : 89631056,
      direction : "+",
      ID : "ENSG00000140534.14",
      gene_id : "ENSG00000140534.14",
      gene_type : "protein_coding",
      gene_name : "TICRR",
      gene_level : 1,
      hgnc_id : "HGNC:28704",
      havana_gene : "OTTHUMG00000149648.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89608789,
      stop : 89655467,
      direction : "-",
      ID : "ENSG00000166813.16",
      gene_id : "ENSG00000166813.16",
      gene_type : "protein_coding",
      gene_name : "KIF7",
      gene_level : 2,
      hgnc_id : "HGNC:30497",
      havana_gene : "OTTHUMG00000157177.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89664367,
      stop : 89679427,
      direction : "-",
      ID : "ENSG00000166819.12",
      gene_id : "ENSG00000166819.12",
      gene_type : "protein_coding",
      gene_name : "PLIN1",
      gene_level : 2,
      hgnc_id : "HGNC:9076",
      havana_gene : "OTTHUMG00000149813.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89677764,
      stop : 89690783,
      direction : "-",
      ID : "ENSG00000166821.9",
      gene_id : "ENSG00000166821.9",
      gene_type : "protein_coding",
      gene_name : "PEX11A",
      gene_level : 1,
      hgnc_id : "HGNC:8852",
      havana_gene : "OTTHUMG00000149809.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89690811,
      stop : 89743638,
      direction : "+",
      ID : "ENSG00000140527.15",
      gene_id : "ENSG00000140527.15",
      gene_type : "protein_coding",
      gene_name : "WDR93",
      gene_level : 2,
      hgnc_id : "HGNC:26924",
      havana_gene : "OTTHUMG00000172007.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89748661,
      stop : 89751310,
      direction : "-",
      ID : "ENSG00000166823.5",
      gene_id : "ENSG00000166823.5",
      gene_type : "protein_coding",
      gene_name : "MESP1",
      gene_level : 2,
      hgnc_id : "HGNC:29658",
      havana_gene : "OTTHUMG00000149810.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89760591,
      stop : 89778754,
      direction : "+",
      ID : "ENSG00000188095.6",
      gene_id : "ENSG00000188095.6",
      gene_type : "protein_coding",
      gene_name : "MESP2",
      gene_level : 2,
      hgnc_id : "HGNC:29659",
      havana_gene : "OTTHUMG00000172016.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89784895,
      stop : 89815401,
      direction : "-",
      ID : "ENSG00000166825.15",
      gene_id : "ENSG00000166825.15",
      gene_type : "protein_coding",
      gene_name : "ANPEP",
      gene_level : 2,
      hgnc_id : "HGNC:500",
      havana_gene : "OTTHUMG00000149814.9",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89830599,
      stop : 89894638,
      direction : "-",
      ID : "ENSG00000157823.17",
      gene_id : "ENSG00000157823.17",
      gene_type : "protein_coding",
      gene_name : "AP3S2",
      gene_level : 2,
      hgnc_id : "HGNC:571",
      havana_gene : "OTTHUMG00000149811.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89834308,
      stop : 89912882,
      direction : "-",
      ID : "ENSG00000250021.7",
      gene_id : "ENSG00000250021.7",
      gene_type : "protein_coding",
      gene_name : "ARPIN-AP3S2",
      gene_level : 1,
      hgnc_id : "HGNC:38824",
      havana_gene : "OTTHUMG00000162161.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 89895006,
      stop : 89912952,
      direction : "-",
      ID : "ENSG00000242498.8",
      gene_id : "ENSG00000242498.8",
      gene_type : "protein_coding",
      gene_name : "ARPIN",
      gene_level : 1,
      hgnc_id : "HGNC:28782",
      havana_gene : "OTTHUMG00000154515.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90001324,
      stop : 90082206,
      direction : "+",
      ID : "ENSG00000140548.10",
      gene_id : "ENSG00000140548.10",
      gene_type : "protein_coding",
      gene_name : "ZNF710",
      gene_level : 2,
      hgnc_id : "HGNC:25352",
      havana_gene : "OTTHUMG00000149812.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90083045,
      stop : 90102477,
      direction : "-",
      ID : "ENSG00000182054.10",
      gene_id : "ENSG00000182054.10",
      gene_type : "protein_coding",
      gene_name : "IDH2",
      gene_level : 1,
      hgnc_id : "HGNC:5383",
      havana_gene : "OTTHUMG00000149815.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90160604,
      stop : 90229679,
      direction : "+",
      ID : "ENSG00000185033.14",
      gene_id : "ENSG00000185033.14",
      gene_type : "protein_coding",
      gene_name : "SEMA4B",
      gene_level : 1,
      hgnc_id : "HGNC:10730",
      havana_gene : "OTTHUMG00000172096.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90229975,
      stop : 90234047,
      direction : "-",
      ID : "ENSG00000185043.12",
      gene_id : "ENSG00000185043.12",
      gene_type : "protein_coding",
      gene_name : "CIB1",
      gene_level : 2,
      hgnc_id : "HGNC:16920",
      havana_gene : "OTTHUMG00000149808.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90233808,
      stop : 90245811,
      direction : "+",
      ID : "ENSG00000183208.12",
      gene_id : "ENSG00000183208.12",
      gene_type : "protein_coding",
      gene_name : "GDPGP1",
      gene_level : 2,
      hgnc_id : "HGNC:34360",
      havana_gene : "OTTHUMG00000172128.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90234200,
      stop : 90265462,
      direction : "+",
      ID : "ENSG00000284626.1",
      gene_id : "ENSG00000284626.1",
      gene_type : "protein_coding",
      gene_name : "AC091167.7",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192216.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90249530,
      stop : 90265482,
      direction : "+",
      ID : "ENSG00000213471.10",
      gene_id : "ENSG00000213471.10",
      gene_type : "protein_coding",
      gene_name : "TTLL13P",
      gene_level : 2,
      hgnc_id : "HGNC:32484",
      havana_gene : "OTTHUMG00000177210.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90249556,
      stop : 90272208,
      direction : "+",
      ID : "ENSG00000261147.1",
      gene_id : "ENSG00000261147.1",
      gene_type : "protein_coding",
      gene_name : "AC091167.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177211.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90265659,
      stop : 90275778,
      direction : "+",
      ID : "ENSG00000182768.9",
      gene_id : "ENSG00000182768.9",
      gene_type : "protein_coding",
      gene_name : "NGRN",
      gene_level : 2,
      hgnc_id : "HGNC:18077",
      havana_gene : "OTTHUMG00000149807.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90266317,
      stop : 90314499,
      direction : "+",
      ID : "ENSG00000275674.1",
      gene_id : "ENSG00000275674.1",
      gene_type : "protein_coding",
      gene_name : "AC091167.6",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000189108.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90352284,
      stop : 90369146,
      direction : "+",
      ID : "ENSG00000196391.11",
      gene_id : "ENSG00000196391.11",
      gene_type : "protein_coding",
      gene_name : "ZNF774",
      gene_level : 1,
      hgnc_id : "HGNC:33108",
      havana_gene : "OTTHUMG00000172359.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90388242,
      stop : 90502239,
      direction : "+",
      ID : "ENSG00000140575.13",
      gene_id : "ENSG00000140575.13",
      gene_type : "protein_coding",
      gene_name : "IQGAP1",
      gene_level : 2,
      hgnc_id : "HGNC:6110",
      havana_gene : "OTTHUMG00000149832.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90529923,
      stop : 90645345,
      direction : "+",
      ID : "ENSG00000140577.16",
      gene_id : "ENSG00000140577.16",
      gene_type : "protein_coding",
      gene_name : "CRTC3",
      gene_level : 1,
      hgnc_id : "HGNC:26148",
      havana_gene : "OTTHUMG00000172295.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90717346,
      stop : 90816166,
      direction : "+",
      ID : "ENSG00000197299.13",
      gene_id : "ENSG00000197299.13",
      gene_type : "protein_coding",
      gene_name : "BLM",
      gene_level : 1,
      hgnc_id : "HGNC:1058",
      havana_gene : "OTTHUMG00000149834.7",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90868588,
      stop : 90883564,
      direction : "+",
      ID : "ENSG00000140564.13",
      gene_id : "ENSG00000140564.13",
      gene_type : "protein_coding",
      gene_name : "FURIN",
      gene_level : 2,
      hgnc_id : "HGNC:8568",
      havana_gene : "OTTHUMG00000149831.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90883695,
      stop : 90895776,
      direction : "+",
      ID : "ENSG00000182511.12",
      gene_id : "ENSG00000182511.12",
      gene_type : "protein_coding",
      gene_name : "FES",
      gene_level : 2,
      hgnc_id : "HGNC:3657",
      havana_gene : "OTTHUMG00000044456.8",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90902218,
      stop : 90922584,
      direction : "+",
      ID : "ENSG00000196547.15",
      gene_id : "ENSG00000196547.15",
      gene_type : "protein_coding",
      gene_name : "MAN2A2",
      gene_level : 1,
      hgnc_id : "HGNC:6825",
      havana_gene : "OTTHUMG00000172385.15",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90929968,
      stop : 90935196,
      direction : "-",
      ID : "ENSG00000184508.12",
      gene_id : "ENSG00000184508.12",
      gene_type : "protein_coding",
      gene_name : "HDDC3",
      gene_level : 2,
      hgnc_id : "HGNC:30522",
      havana_gene : "OTTHUMG00000141260.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90930180,
      stop : 90954093,
      direction : "+",
      ID : "ENSG00000140553.18",
      gene_id : "ENSG00000140553.18",
      gene_type : "protein_coding",
      gene_name : "UNC45A",
      gene_level : 2,
      hgnc_id : "HGNC:30594",
      havana_gene : "OTTHUMG00000141261.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90954870,
      stop : 90963125,
      direction : "+",
      ID : "ENSG00000166965.12",
      gene_id : "ENSG00000166965.12",
      gene_type : "protein_coding",
      gene_name : "RCCD1",
      gene_level : 1,
      hgnc_id : "HGNC:30457",
      havana_gene : "OTTHUMG00000171684.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90966040,
      stop : 90995629,
      direction : "-",
      ID : "ENSG00000198901.14",
      gene_id : "ENSG00000198901.14",
      gene_type : "protein_coding",
      gene_name : "PRC1",
      gene_level : 1,
      hgnc_id : "HGNC:9341",
      havana_gene : "OTTHUMG00000171685.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90966190,
      stop : 91022566,
      direction : "-",
      ID : "ENSG00000284946.1",
      gene_id : "ENSG00000284946.1",
      gene_type : "protein_coding",
      gene_name : "AC068831.6",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192506.1",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 90998673,
      stop : 91022603,
      direction : "-",
      ID : "ENSG00000184056.15",
      gene_id : "ENSG00000184056.15",
      gene_type : "protein_coding",
      gene_name : "VPS33B",
      gene_level : 2,
      hgnc_id : "HGNC:12712",
      havana_gene : "OTTHUMG00000149835.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 91099950,
      stop : 91302565,
      direction : "+",
      ID : "ENSG00000185518.12",
      gene_id : "ENSG00000185518.12",
      gene_type : "protein_coding",
      gene_name : "SV2B",
      gene_level : 2,
      hgnc_id : "HGNC:16874",
      havana_gene : "OTTHUMG00000149833.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 91853708,
      stop : 92172435,
      direction : "+",
      ID : "ENSG00000176463.14",
      gene_id : "ENSG00000176463.14",
      gene_type : "protein_coding",
      gene_name : "SLCO3A1",
      gene_level : 1,
      hgnc_id : "HGNC:10952",
      havana_gene : "OTTHUMG00000149846.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 92393881,
      stop : 92468728,
      direction : "+",
      ID : "ENSG00000140557.12",
      gene_id : "ENSG00000140557.12",
      gene_type : "protein_coding",
      gene_name : "ST8SIA2",
      gene_level : 2,
      hgnc_id : "HGNC:10870",
      havana_gene : "OTTHUMG00000149843.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 92617448,
      stop : 92809884,
      direction : "-",
      ID : "ENSG00000185442.13",
      gene_id : "ENSG00000185442.13",
      gene_type : "protein_coding",
      gene_name : "FAM174B",
      gene_level : 2,
      hgnc_id : "HGNC:34339",
      havana_gene : "OTTHUMG00000171744.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 92883413,
      stop : 92949230,
      direction : "+",
      ID : "ENSG00000279765.3",
      gene_id : "ENSG00000279765.3",
      gene_type : "protein_coding",
      gene_name : "AC013394.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000189505.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 92900189,
      stop : 93027996,
      direction : "+",
      ID : "ENSG00000173575.22",
      gene_id : "ENSG00000173575.22",
      gene_type : "protein_coding",
      gene_name : "CHD2",
      gene_level : 1,
      hgnc_id : "HGNC:1917",
      havana_gene : "OTTHUMG00000185958.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 93035273,
      stop : 93089204,
      direction : "-",
      ID : "ENSG00000182175.14",
      gene_id : "ENSG00000182175.14",
      gene_type : "protein_coding",
      gene_name : "RGMA",
      gene_level : 1,
      hgnc_id : "HGNC:30308",
      havana_gene : "OTTHUMG00000171781.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 94231538,
      stop : 94483952,
      direction : "+",
      ID : "ENSG00000140563.15",
      gene_id : "ENSG00000140563.15",
      gene_type : "protein_coding",
      gene_name : "MCTP2",
      gene_level : 2,
      hgnc_id : "HGNC:25636",
      havana_gene : "OTTHUMG00000171751.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 96325938,
      stop : 96340263,
      direction : "+",
      ID : "ENSG00000185551.15",
      gene_id : "ENSG00000185551.15",
      gene_type : "protein_coding",
      gene_name : "NR2F2",
      gene_level : 2,
      hgnc_id : "HGNC:7976",
      havana_gene : "OTTHUMG00000149848.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 97960703,
      stop : 97973833,
      direction : "+",
      ID : "ENSG00000140450.9",
      gene_id : "ENSG00000140450.9",
      gene_type : "protein_coding",
      gene_name : "ARRDC4",
      gene_level : 2,
      hgnc_id : "HGNC:28087",
      havana_gene : "OTTHUMG00000149849.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 98648539,
      stop : 98964530,
      direction : "+",
      ID : "ENSG00000140443.15",
      gene_id : "ENSG00000140443.15",
      gene_type : "protein_coding",
      gene_name : "IGF1R",
      gene_level : 1,
      hgnc_id : "HGNC:5465",
      havana_gene : "OTTHUMG00000149851.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 98968229,
      stop : 99007792,
      direction : "-",
      ID : "ENSG00000183571.11",
      gene_id : "ENSG00000183571.11",
      gene_type : "protein_coding",
      gene_name : "PGPEP1L",
      gene_level : 1,
      hgnc_id : "HGNC:27080",
      havana_gene : "OTTHUMG00000171896.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 99098217,
      stop : 99135593,
      direction : "+",
      ID : "ENSG00000182253.15",
      gene_id : "ENSG00000182253.15",
      gene_type : "protein_coding",
      gene_name : "SYNM",
      gene_level : 1,
      hgnc_id : "HGNC:24466",
      havana_gene : "OTTHUMG00000171887.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 99136323,
      stop : 99251223,
      direction : "-",
      ID : "ENSG00000103852.13",
      gene_id : "ENSG00000103852.13",
      gene_type : "protein_coding",
      gene_name : "TTC23",
      gene_level : 2,
      hgnc_id : "HGNC:25730",
      havana_gene : "OTTHUMG00000147344.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 99251362,
      stop : 99390729,
      direction : "+",
      ID : "ENSG00000168904.15",
      gene_id : "ENSG00000168904.15",
      gene_type : "protein_coding",
      gene_name : "LRRC28",
      gene_level : 1,
      hgnc_id : "HGNC:28355",
      havana_gene : "OTTHUMG00000149854.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 99565417,
      stop : 99716466,
      direction : "+",
      ID : "ENSG00000068305.17",
      gene_id : "ENSG00000068305.17",
      gene_type : "protein_coding",
      gene_name : "MEF2A",
      gene_level : 2,
      hgnc_id : "HGNC:6993",
      havana_gene : "OTTHUMG00000171937.3",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 99715697,
      stop : 99733561,
      direction : "-",
      ID : "ENSG00000183060.15",
      gene_id : "ENSG00000183060.15",
      gene_type : "protein_coding",
      gene_name : "LYSMD4",
      gene_level : 2,
      hgnc_id : "HGNC:26571",
      havana_gene : "OTTHUMG00000149853.5",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 99971437,
      stop : 100342005,
      direction : "-",
      ID : "ENSG00000140470.15",
      gene_id : "ENSG00000140470.15",
      gene_type : "protein_coding",
      gene_name : "ADAMTS17",
      gene_level : 1,
      hgnc_id : "HGNC:17109",
      havana_gene : "OTTHUMG00000149867.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 100400395,
      stop : 100544995,
      direction : "-",
      ID : "ENSG00000154227.14",
      gene_id : "ENSG00000154227.14",
      gene_type : "protein_coding",
      gene_name : "CERS3",
      gene_level : 1,
      hgnc_id : "HGNC:23752",
      havana_gene : "OTTHUMG00000172568.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 100559369,
      stop : 100603230,
      direction : "-",
      ID : "ENSG00000140471.17",
      gene_id : "ENSG00000140471.17",
      gene_type : "protein_coding",
      gene_name : "LINS1",
      gene_level : 1,
      hgnc_id : "HGNC:30922",
      havana_gene : "OTTHUMG00000149865.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 100602589,
      stop : 100651701,
      direction : "+",
      ID : "ENSG00000183475.13",
      gene_id : "ENSG00000183475.13",
      gene_type : "protein_coding",
      gene_name : "ASB7",
      gene_level : 2,
      hgnc_id : "HGNC:17182",
      havana_gene : "OTTHUMG00000149868.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 100877714,
      stop : 100916626,
      direction : "+",
      ID : "ENSG00000184254.17",
      gene_id : "ENSG00000184254.17",
      gene_type : "protein_coding",
      gene_name : "ALDH1A3",
      gene_level : 2,
      hgnc_id : "HGNC:409",
      havana_gene : "OTTHUMG00000186439.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 100919327,
      stop : 101078257,
      direction : "+",
      ID : "ENSG00000154237.13",
      gene_id : "ENSG00000154237.13",
      gene_type : "protein_coding",
      gene_name : "LRRK1",
      gene_level : 2,
      hgnc_id : "HGNC:18608",
      havana_gene : "OTTHUMG00000165514.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101175727,
      stop : 101252048,
      direction : "-",
      ID : "ENSG00000131873.7",
      gene_id : "ENSG00000131873.7",
      gene_type : "protein_coding",
      gene_name : "CHSY1",
      gene_level : 1,
      hgnc_id : "HGNC:17198",
      havana_gene : "OTTHUMG00000149873.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101270817,
      stop : 101277500,
      direction : "-",
      ID : "ENSG00000131871.15",
      gene_id : "ENSG00000131871.15",
      gene_type : "protein_coding",
      gene_name : "SELENOS",
      gene_level : 2,
      hgnc_id : "HGNC:30396",
      havana_gene : "OTTHUMG00000166441.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101281510,
      stop : 101295282,
      direction : "-",
      ID : "ENSG00000131876.17",
      gene_id : "ENSG00000131876.17",
      gene_type : "protein_coding",
      gene_name : "SNRPA1",
      gene_level : 2,
      hgnc_id : "HGNC:11152",
      havana_gene : "OTTHUMG00000149871.4",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101289784,
      stop : 101525202,
      direction : "-",
      ID : "ENSG00000140479.18",
      gene_id : "ENSG00000140479.18",
      gene_type : "protein_coding",
      gene_name : "PCSK6",
      gene_level : 1,
      hgnc_id : "HGNC:8569",
      havana_gene : "OTTHUMG00000172097.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101621444,
      stop : 101652391,
      direction : "-",
      ID : "ENSG00000184277.13",
      gene_id : "ENSG00000184277.13",
      gene_type : "protein_coding",
      gene_name : "TM2D3",
      gene_level : 1,
      hgnc_id : "HGNC:24128",
      havana_gene : "OTTHUMG00000149872.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101653596,
      stop : 101724473,
      direction : "-",
      ID : "ENSG00000185418.16",
      gene_id : "ENSG00000185418.16",
      gene_type : "protein_coding",
      gene_name : "TARS3",
      gene_level : 2,
      hgnc_id : "HGNC:24728",
      havana_gene : "OTTHUMG00000149869.6",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101803509,
      stop : 101806887,
      direction : "+",
      ID : "ENSG00000184140.6",
      gene_id : "ENSG00000184140.6",
      gene_type : "protein_coding",
      gene_name : "OR4F6",
      gene_level : 2,
      hgnc_id : "HGNC:15372",
      havana_gene : "OTTHUMG00000172267.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101812202,
      stop : 101820197,
      direction : "+",
      ID : "ENSG00000182854.8",
      gene_id : "ENSG00000182854.8",
      gene_type : "protein_coding",
      gene_name : "OR4F15",
      gene_level : 2,
      hgnc_id : "HGNC:15078",
      havana_gene : "OTTHUMG00000172268.2",
      tag : null
    },
    {
      chromosome : 15,
      annotation : "HAVANA",
      type : "gene",
      start : 101922042,
      stop : 101923113,
      direction : "-",
      ID : "ENSG00000177693.4",
      gene_id : "ENSG00000177693.4",
      gene_type : "protein_coding",
      gene_name : "OR4F4",
      gene_level : 2,
      hgnc_id : "HGNC:8301",
      havana_gene : "OTTHUMG00000172272.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46407,
      stop : 53608,
      direction : "-",
      ID : "ENSG00000161980.6",
      gene_id : "ENSG00000161980.6",
      gene_type : "protein_coding",
      gene_name : "POLR3K",
      gene_level : 2,
      hgnc_id : "HGNC:14121",
      havana_gene : "OTTHUMG00000060722.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53828,
      stop : 57669,
      direction : "+",
      ID : "ENSG00000161981.11",
      gene_id : "ENSG00000161981.11",
      gene_type : "protein_coding",
      gene_name : "SNRNP25",
      gene_level : 2,
      hgnc_id : "HGNC:14161",
      havana_gene : "OTTHUMG00000060720.11",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58059,
      stop : 76355,
      direction : "-",
      ID : "ENSG00000007384.15",
      gene_id : "ENSG00000007384.15",
      gene_type : "protein_coding",
      gene_name : "RHBDF1",
      gene_level : 1,
      hgnc_id : "HGNC:20561",
      havana_gene : "OTTHUMG00000060719.15",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 77007,
      stop : 85851,
      direction : "+",
      ID : "ENSG00000103152.12",
      gene_id : "ENSG00000103152.12",
      gene_type : "protein_coding",
      gene_name : "MPG",
      gene_level : 2,
      hgnc_id : "HGNC:7211",
      havana_gene : "OTTHUMG00000047887.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84271,
      stop : 138677,
      direction : "-",
      ID : "ENSG00000103148.17",
      gene_id : "ENSG00000103148.17",
      gene_type : "protein_coding",
      gene_name : "NPRL3",
      gene_level : 1,
      hgnc_id : "HGNC:14124",
      havana_gene : "OTTHUMG00000047792.20",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 142728,
      stop : 154503,
      direction : "+",
      ID : "ENSG00000130656.6",
      gene_id : "ENSG00000130656.6",
      gene_type : "protein_coding",
      gene_name : "HBZ",
      gene_level : 2,
      hgnc_id : "HGNC:4835",
      havana_gene : "OTTHUMG00000059928.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 153892,
      stop : 166764,
      direction : "+",
      ID : "ENSG00000206177.7",
      gene_id : "ENSG00000206177.7",
      gene_type : "protein_coding",
      gene_name : "HBM",
      gene_level : 2,
      hgnc_id : "HGNC:4826",
      havana_gene : "OTTHUMG00000059926.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 172876,
      stop : 173710,
      direction : "+",
      ID : "ENSG00000188536.13",
      gene_id : "ENSG00000188536.13",
      gene_type : "protein_coding",
      gene_name : "HBA2",
      gene_level : 2,
      hgnc_id : "HGNC:4824",
      havana_gene : "OTTHUMG00000059924.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 176680,
      stop : 177522,
      direction : "+",
      ID : "ENSG00000206172.8",
      gene_id : "ENSG00000206172.8",
      gene_type : "protein_coding",
      gene_name : "HBA1",
      gene_level : 2,
      hgnc_id : "HGNC:4823",
      havana_gene : "OTTHUMG00000060138.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 180459,
      stop : 181179,
      direction : "+",
      ID : "ENSG00000086506.3",
      gene_id : "ENSG00000086506.3",
      gene_type : "protein_coding",
      gene_name : "HBQ1",
      gene_level : 2,
      hgnc_id : "HGNC:4833",
      havana_gene : "OTTHUMG00000060727.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 188969,
      stop : 229463,
      direction : "-",
      ID : "ENSG00000007392.17",
      gene_id : "ENSG00000007392.17",
      gene_type : "protein_coding",
      gene_name : "LUC7L",
      gene_level : 1,
      hgnc_id : "HGNC:6723",
      havana_gene : "OTTHUMG00000060730.12",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 234521,
      stop : 272183,
      direction : "+",
      ID : "ENSG00000167930.17",
      gene_id : "ENSG00000167930.17",
      gene_type : "protein_coding",
      gene_name : "FAM234A",
      gene_level : 1,
      hgnc_id : "HGNC:14163",
      havana_gene : "OTTHUMG00000060728.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 268301,
      stop : 275980,
      direction : "-",
      ID : "ENSG00000076344.16",
      gene_id : "ENSG00000076344.16",
      gene_type : "protein_coding",
      gene_name : "RGS11",
      gene_level : 2,
      hgnc_id : "HGNC:9993",
      havana_gene : "OTTHUMG00000064893.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 280450,
      stop : 283010,
      direction : "+",
      ID : "ENSG00000242173.10",
      gene_id : "ENSG00000242173.10",
      gene_type : "protein_coding",
      gene_name : "ARHGDIG",
      gene_level : 1,
      hgnc_id : "HGNC:680",
      havana_gene : "OTTHUMG00000064892.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 283164,
      stop : 287215,
      direction : "+",
      ID : "ENSG00000185615.16",
      gene_id : "ENSG00000185615.16",
      gene_type : "protein_coding",
      gene_name : "PDIA2",
      gene_level : 2,
      hgnc_id : "HGNC:14180",
      havana_gene : "OTTHUMG00000064891.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 287440,
      stop : 352723,
      direction : "-",
      ID : "ENSG00000103126.15",
      gene_id : "ENSG00000103126.15",
      gene_type : "protein_coding",
      gene_name : "AXIN1",
      gene_level : 1,
      hgnc_id : "HGNC:903",
      havana_gene : "OTTHUMG00000064930.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 366969,
      stop : 371289,
      direction : "-",
      ID : "ENSG00000086504.17",
      gene_id : "ENSG00000086504.17",
      gene_type : "protein_coding",
      gene_name : "MRPL28",
      gene_level : 2,
      hgnc_id : "HGNC:14484",
      havana_gene : "OTTHUMG00000047994.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 370788,
      stop : 387113,
      direction : "-",
      ID : "ENSG00000129925.11",
      gene_id : "ENSG00000129925.11",
      gene_type : "protein_coding",
      gene_name : "PGAP6",
      gene_level : 1,
      hgnc_id : "HGNC:17205",
      havana_gene : "OTTHUMG00000047996.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 396725,
      stop : 410367,
      direction : "+",
      ID : "ENSG00000103202.13",
      gene_id : "ENSG00000103202.13",
      gene_type : "protein_coding",
      gene_name : "NME4",
      gene_level : 1,
      hgnc_id : "HGNC:7852",
      havana_gene : "OTTHUMG00000047995.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 401858,
      stop : 412487,
      direction : "+",
      ID : "ENSG00000242612.7",
      gene_id : "ENSG00000242612.7",
      gene_type : "protein_coding",
      gene_name : "DECR2",
      gene_level : 2,
      hgnc_id : "HGNC:2754",
      havana_gene : "OTTHUMG00000047846.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 425649,
      stop : 523011,
      direction : "+",
      ID : "ENSG00000090565.17",
      gene_id : "ENSG00000090565.17",
      gene_type : "protein_coding",
      gene_name : "RAB11FIP3",
      gene_level : 1,
      hgnc_id : "HGNC:17224",
      havana_gene : "OTTHUMG00000047843.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 527712,
      stop : 554636,
      direction : "+",
      ID : "ENSG00000103326.12",
      gene_id : "ENSG00000103326.12",
      gene_type : "protein_coding",
      gene_name : "CAPN15",
      gene_level : 2,
      hgnc_id : "HGNC:11182",
      havana_gene : "OTTHUMG00000119059.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 560394,
      stop : 565529,
      direction : "+",
      ID : "ENSG00000161992.6",
      gene_id : "ENSG00000161992.6",
      gene_type : "protein_coding",
      gene_name : "PRR35",
      gene_level : 1,
      hgnc_id : "HGNC:14139",
      havana_gene : "OTTHUMG00000154104.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 566995,
      stop : 584109,
      direction : "+",
      ID : "ENSG00000007541.17",
      gene_id : "ENSG00000007541.17",
      gene_type : "protein_coding",
      gene_name : "PIGQ",
      gene_level : 2,
      hgnc_id : "HGNC:14135",
      havana_gene : "OTTHUMG00000168047.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 567005,
      stop : 569495,
      direction : "+",
      ID : "ENSG00000257108.2",
      gene_id : "ENSG00000257108.2",
      gene_type : "protein_coding",
      gene_name : "NHLRC4",
      gene_level : 2,
      hgnc_id : "HGNC:26700",
      havana_gene : "OTTHUMG00000047857.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 589357,
      stop : 629272,
      direction : "+",
      ID : "ENSG00000197562.10",
      gene_id : "ENSG00000197562.10",
      gene_type : "protein_coding",
      gene_name : "RAB40C",
      gene_level : 2,
      hgnc_id : "HGNC:18285",
      havana_gene : "OTTHUMG00000047854.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 629239,
      stop : 634117,
      direction : "+",
      ID : "ENSG00000127578.7",
      gene_id : "ENSG00000127578.7",
      gene_type : "protein_coding",
      gene_name : "WFIKKN1",
      gene_level : 2,
      hgnc_id : "HGNC:30912",
      havana_gene : "OTTHUMG00000090359.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 634427,
      stop : 636366,
      direction : "-",
      ID : "ENSG00000130731.16",
      gene_id : "ENSG00000130731.16",
      gene_type : "protein_coding",
      gene_name : "METTL26",
      gene_level : 2,
      hgnc_id : "HGNC:14141",
      havana_gene : "OTTHUMG00000047855.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 636817,
      stop : 648474,
      direction : "+",
      ID : "ENSG00000172366.20",
      gene_id : "ENSG00000172366.20",
      gene_type : "protein_coding",
      gene_name : "MCRIP2",
      gene_level : 2,
      hgnc_id : "HGNC:14142",
      havana_gene : "OTTHUMG00000048042.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 649311,
      stop : 667833,
      direction : "+",
      ID : "ENSG00000161996.19",
      gene_id : "ENSG00000161996.19",
      gene_type : "protein_coding",
      gene_name : "WDR90",
      gene_level : 1,
      hgnc_id : "HGNC:26960",
      havana_gene : "OTTHUMG00000048040.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 668105,
      stop : 674174,
      direction : "+",
      ID : "ENSG00000140983.14",
      gene_id : "ENSG00000140983.14",
      gene_type : "protein_coding",
      gene_name : "RHOT2",
      gene_level : 2,
      hgnc_id : "HGNC:21169",
      havana_gene : "OTTHUMG00000121139.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 675671,
      stop : 678268,
      direction : "+",
      ID : "ENSG00000103269.14",
      gene_id : "ENSG00000103269.14",
      gene_type : "protein_coding",
      gene_name : "RHBDL1",
      gene_level : 1,
      hgnc_id : "HGNC:10007",
      havana_gene : "OTTHUMG00000121141.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 680224,
      stop : 682870,
      direction : "+",
      ID : "ENSG00000103266.11",
      gene_id : "ENSG00000103266.11",
      gene_type : "protein_coding",
      gene_name : "STUB1",
      gene_level : 2,
      hgnc_id : "HGNC:11427",
      havana_gene : "OTTHUMG00000121140.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 681670,
      stop : 684528,
      direction : "-",
      ID : "ENSG00000161999.13",
      gene_id : "ENSG00000161999.13",
      gene_type : "protein_coding",
      gene_name : "JMJD8",
      gene_level : 2,
      hgnc_id : "HGNC:14148",
      havana_gene : "OTTHUMG00000172950.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 684622,
      stop : 690444,
      direction : "-",
      ID : "ENSG00000127580.17",
      gene_id : "ENSG00000127580.17",
      gene_type : "protein_coding",
      gene_name : "WDR24",
      gene_level : 2,
      hgnc_id : "HGNC:20852",
      havana_gene : "OTTHUMG00000090421.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 692498,
      stop : 705808,
      direction : "-",
      ID : "ENSG00000127585.12",
      gene_id : "ENSG00000127585.12",
      gene_type : "protein_coding",
      gene_name : "FBXL16",
      gene_level : 2,
      hgnc_id : "HGNC:14150",
      havana_gene : "OTTHUMG00000090420.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 715118,
      stop : 719655,
      direction : "+",
      ID : "ENSG00000103260.9",
      gene_id : "ENSG00000103260.9",
      gene_type : "protein_coding",
      gene_name : "METRN",
      gene_level : 2,
      hgnc_id : "HGNC:14151",
      havana_gene : "OTTHUMG00000047851.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 720581,
      stop : 722590,
      direction : "+",
      ID : "ENSG00000103254.10",
      gene_id : "ENSG00000103254.10",
      gene_type : "protein_coding",
      gene_name : "ANTKMT",
      gene_level : 2,
      hgnc_id : "HGNC:14152",
      havana_gene : "OTTHUMG00000121177.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 722582,
      stop : 726954,
      direction : "-",
      ID : "ENSG00000162004.18",
      gene_id : "ENSG00000162004.18",
      gene_type : "protein_coding",
      gene_name : "CCDC78",
      gene_level : 2,
      hgnc_id : "HGNC:14153",
      havana_gene : "OTTHUMG00000121176.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 726936,
      stop : 735525,
      direction : "+",
      ID : "ENSG00000103253.19",
      gene_id : "ENSG00000103253.19",
      gene_type : "protein_coding",
      gene_name : "HAGHL",
      gene_level : 1,
      hgnc_id : "HGNC:14177",
      havana_gene : "OTTHUMG00000170560.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 729760,
      stop : 741329,
      direction : "-",
      ID : "ENSG00000103245.14",
      gene_id : "ENSG00000103245.14",
      gene_type : "protein_coding",
      gene_name : "CIAO3",
      gene_level : 1,
      hgnc_id : "HGNC:14179",
      havana_gene : "OTTHUMG00000122093.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 760734,
      stop : 768865,
      direction : "+",
      ID : "ENSG00000102854.16",
      gene_id : "ENSG00000102854.16",
      gene_type : "protein_coding",
      gene_name : "MSLN",
      gene_level : 2,
      hgnc_id : "HGNC:7371",
      havana_gene : "OTTHUMG00000047992.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 769428,
      stop : 783370,
      direction : "-",
      ID : "ENSG00000162006.9",
      gene_id : "ENSG00000162006.9",
      gene_type : "protein_coding",
      gene_name : "MSLNL",
      gene_level : 2,
      hgnc_id : "HGNC:14170",
      havana_gene : "OTTHUMG00000168780.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 784974,
      stop : 788397,
      direction : "-",
      ID : "ENSG00000007376.8",
      gene_id : "ENSG00000007376.8",
      gene_type : "protein_coding",
      gene_name : "RPUSD1",
      gene_level : 2,
      hgnc_id : "HGNC:14173",
      havana_gene : "OTTHUMG00000047840.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 788046,
      stop : 800737,
      direction : "+",
      ID : "ENSG00000127586.17",
      gene_id : "ENSG00000127586.17",
      gene_type : "protein_coding",
      gene_name : "CHTF18",
      gene_level : 2,
      hgnc_id : "HGNC:18435",
      havana_gene : "OTTHUMG00000047838.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 798041,
      stop : 800734,
      direction : "-",
      ID : "ENSG00000127588.5",
      gene_id : "ENSG00000127588.5",
      gene_type : "protein_coding",
      gene_name : "GNG13",
      gene_level : 2,
      hgnc_id : "HGNC:14131",
      havana_gene : "OTTHUMG00000047839.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 853634,
      stop : 981318,
      direction : "-",
      ID : "ENSG00000103227.19",
      gene_id : "ENSG00000103227.19",
      gene_type : "protein_coding",
      gene_name : "LMF1",
      gene_level : 1,
      hgnc_id : "HGNC:14154",
      havana_gene : "OTTHUMG00000047848.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 981770,
      stop : 986979,
      direction : "+",
      ID : "ENSG00000005513.10",
      gene_id : "ENSG00000005513.10",
      gene_type : "protein_coding",
      gene_name : "SOX8",
      gene_level : 2,
      hgnc_id : "HGNC:11203",
      havana_gene : "OTTHUMG00000122101.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1078781,
      stop : 1080142,
      direction : "+",
      ID : "ENSG00000162009.8",
      gene_id : "ENSG00000162009.8",
      gene_type : "protein_coding",
      gene_name : "SSTR5",
      gene_level : 2,
      hgnc_id : "HGNC:11334",
      havana_gene : "OTTHUMG00000047842.5",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1088226,
      stop : 1096244,
      direction : "-",
      ID : "ENSG00000184471.8",
      gene_id : "ENSG00000184471.8",
      gene_type : "protein_coding",
      gene_name : "C1QTNF8",
      gene_level : 2,
      hgnc_id : "HGNC:31374",
      havana_gene : "OTTHUMG00000167756.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1153106,
      stop : 1221771,
      direction : "+",
      ID : "ENSG00000196557.13",
      gene_id : "ENSG00000196557.13",
      gene_type : "protein_coding",
      gene_name : "CACNA1H",
      gene_level : 1,
      hgnc_id : "HGNC:1395",
      havana_gene : "OTTHUMG00000172992.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1221651,
      stop : 1225257,
      direction : "-",
      ID : "ENSG00000116176.6",
      gene_id : "ENSG00000116176.6",
      gene_type : "protein_coding",
      gene_name : "TPSG1",
      gene_level : 2,
      hgnc_id : "HGNC:14134",
      havana_gene : "OTTHUMG00000090466.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1227272,
      stop : 1230184,
      direction : "-",
      ID : "ENSG00000197253.13",
      gene_id : "ENSG00000197253.13",
      gene_type : "protein_coding",
      gene_name : "TPSB2",
      gene_level : 2,
      hgnc_id : "HGNC:14120",
      havana_gene : "OTTHUMG00000155926.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1240379,
      stop : 1242554,
      direction : "+",
      ID : "ENSG00000172236.18",
      gene_id : "ENSG00000172236.18",
      gene_type : "protein_coding",
      gene_name : "TPSAB1",
      gene_level : 2,
      hgnc_id : "HGNC:12019",
      havana_gene : "OTTHUMG00000090467.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1256059,
      stop : 1259008,
      direction : "+",
      ID : "ENSG00000095917.14",
      gene_id : "ENSG00000095917.14",
      gene_type : "protein_coding",
      gene_name : "TPSD1",
      gene_level : 1,
      hgnc_id : "HGNC:14118",
      havana_gene : "OTTHUMG00000128511.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1308880,
      stop : 1327018,
      direction : "+",
      ID : "ENSG00000103275.21",
      gene_id : "ENSG00000103275.21",
      gene_type : "protein_coding",
      gene_name : "UBE2I",
      gene_level : 2,
      hgnc_id : "HGNC:12485",
      havana_gene : "OTTHUMG00000186701.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1333638,
      stop : 1349441,
      direction : "+",
      ID : "ENSG00000007516.14",
      gene_id : "ENSG00000007516.14",
      gene_type : "protein_coding",
      gene_name : "BAIAP3",
      gene_level : 1,
      hgnc_id : "HGNC:948",
      havana_gene : "OTTHUMG00000047833.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1349240,
      stop : 1351878,
      direction : "-",
      ID : "ENSG00000007520.4",
      gene_id : "ENSG00000007520.4",
      gene_type : "protein_coding",
      gene_name : "TSR3",
      gene_level : 2,
      hgnc_id : "HGNC:14175",
      havana_gene : "OTTHUMG00000047834.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1351931,
      stop : 1364113,
      direction : "+",
      ID : "ENSG00000090581.10",
      gene_id : "ENSG00000090581.10",
      gene_type : "protein_coding",
      gene_name : "GNPTG",
      gene_level : 2,
      hgnc_id : "HGNC:23026",
      havana_gene : "OTTHUMG00000047835.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1363205,
      stop : 1414751,
      direction : "-",
      ID : "ENSG00000059145.19",
      gene_id : "ENSG00000059145.19",
      gene_type : "protein_coding",
      gene_name : "UNKL",
      gene_level : 1,
      hgnc_id : "HGNC:14184",
      havana_gene : "OTTHUMG00000128553.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1419752,
      stop : 1420756,
      direction : "-",
      ID : "ENSG00000174109.5",
      gene_id : "ENSG00000174109.5",
      gene_type : "protein_coding",
      gene_name : "C16orf91",
      gene_level : 2,
      hgnc_id : "HGNC:27558",
      havana_gene : "OTTHUMG00000192232.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1431078,
      stop : 1434441,
      direction : "+",
      ID : "ENSG00000284395.2",
      gene_id : "ENSG00000284395.2",
      gene_type : "protein_coding",
      gene_name : "PERCC1",
      gene_level : 2,
      hgnc_id : "HGNC:52293",
      havana_gene : "OTTHUMG00000176551.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1434383,
      stop : 1444556,
      direction : "-",
      ID : "ENSG00000197599.12",
      gene_id : "ENSG00000197599.12",
      gene_type : "protein_coding",
      gene_name : "CCDC154",
      gene_level : 2,
      hgnc_id : "HGNC:34454",
      havana_gene : "OTTHUMG00000154097.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1444934,
      stop : 1475084,
      direction : "-",
      ID : "ENSG00000103249.18",
      gene_id : "ENSG00000103249.18",
      gene_type : "protein_coding",
      gene_name : "CLCN7",
      gene_level : 1,
      hgnc_id : "HGNC:2025",
      havana_gene : "OTTHUMG00000044467.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1485886,
      stop : 1488981,
      direction : "-",
      ID : "ENSG00000251692.8",
      gene_id : "ENSG00000251692.8",
      gene_type : "protein_coding",
      gene_name : "PTX4",
      gene_level : 1,
      hgnc_id : "HGNC:14171",
      havana_gene : "OTTHUMG00000044470.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1493344,
      stop : 1510457,
      direction : "+",
      ID : "ENSG00000100726.15",
      gene_id : "ENSG00000100726.15",
      gene_type : "protein_coding",
      gene_name : "TELO2",
      gene_level : 2,
      hgnc_id : "HGNC:29099",
      havana_gene : "OTTHUMG00000044471.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1510427,
      stop : 1612072,
      direction : "-",
      ID : "ENSG00000187535.14",
      gene_id : "ENSG00000187535.14",
      gene_type : "protein_coding",
      gene_name : "IFT140",
      gene_level : 1,
      hgnc_id : "HGNC:29077",
      havana_gene : "OTTHUMG00000128585.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1528688,
      stop : 1555580,
      direction : "+",
      ID : "ENSG00000131634.14",
      gene_id : "ENSG00000131634.14",
      gene_type : "protein_coding",
      gene_name : "TMEM204",
      gene_level : 2,
      hgnc_id : "HGNC:14158",
      havana_gene : "OTTHUMG00000176585.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1612337,
      stop : 1677908,
      direction : "+",
      ID : "ENSG00000007545.16",
      gene_id : "ENSG00000007545.16",
      gene_type : "protein_coding",
      gene_name : "CRAMP1",
      gene_level : 2,
      hgnc_id : "HGNC:14122",
      havana_gene : "OTTHUMG00000074087.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1632259,
      stop : 1686715,
      direction : "+",
      ID : "ENSG00000261732.1",
      gene_id : "ENSG00000261732.1",
      gene_type : "protein_coding",
      gene_name : "AL031708.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176609.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1678256,
      stop : 1702280,
      direction : "+",
      ID : "ENSG00000206053.13",
      gene_id : "ENSG00000206053.13",
      gene_type : "protein_coding",
      gene_name : "JPT2",
      gene_level : 1,
      hgnc_id : "HGNC:14137",
      havana_gene : "OTTHUMG00000047859.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1706183,
      stop : 1770351,
      direction : "+",
      ID : "ENSG00000138834.14",
      gene_id : "ENSG00000138834.14",
      gene_type : "protein_coding",
      gene_name : "MAPK8IP3",
      gene_level : 2,
      hgnc_id : "HGNC:6884",
      havana_gene : "OTTHUMG00000128637.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1770286,
      stop : 1771730,
      direction : "-",
      ID : "ENSG00000103024.7",
      gene_id : "ENSG00000103024.7",
      gene_type : "protein_coding",
      gene_name : "NME3",
      gene_level : 2,
      hgnc_id : "HGNC:7851",
      havana_gene : "OTTHUMG00000128635.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1771890,
      stop : 1773150,
      direction : "-",
      ID : "ENSG00000074071.15",
      gene_id : "ENSG00000074071.15",
      gene_type : "protein_coding",
      gene_name : "MRPS34",
      gene_level : 2,
      hgnc_id : "HGNC:16618",
      havana_gene : "OTTHUMG00000128636.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1772810,
      stop : 1781708,
      direction : "+",
      ID : "ENSG00000197774.13",
      gene_id : "ENSG00000197774.13",
      gene_type : "protein_coding",
      gene_name : "EME2",
      gene_level : 2,
      hgnc_id : "HGNC:27289",
      havana_gene : "OTTHUMG00000176706.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1776712,
      stop : 1793700,
      direction : "-",
      ID : "ENSG00000162032.16",
      gene_id : "ENSG00000162032.16",
      gene_type : "protein_coding",
      gene_name : "SPSB3",
      gene_level : 2,
      hgnc_id : "HGNC:30629",
      havana_gene : "OTTHUMG00000176746.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1782932,
      stop : 1789186,
      direction : "+",
      ID : "ENSG00000095906.17",
      gene_id : "ENSG00000095906.17",
      gene_type : "protein_coding",
      gene_name : "NUBP2",
      gene_level : 1,
      hgnc_id : "HGNC:8042",
      havana_gene : "OTTHUMG00000128639.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1790413,
      stop : 1794971,
      direction : "-",
      ID : "ENSG00000099769.6",
      gene_id : "ENSG00000099769.6",
      gene_type : "protein_coding",
      gene_name : "IGFALS",
      gene_level : 1,
      hgnc_id : "HGNC:5468",
      havana_gene : "OTTHUMG00000128638.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1795620,
      stop : 1827157,
      direction : "-",
      ID : "ENSG00000063854.13",
      gene_id : "ENSG00000063854.13",
      gene_type : "protein_coding",
      gene_name : "HAGH",
      gene_level : 1,
      hgnc_id : "HGNC:4805",
      havana_gene : "OTTHUMG00000128662.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1826941,
      stop : 1840207,
      direction : "+",
      ID : "ENSG00000180185.11",
      gene_id : "ENSG00000180185.11",
      gene_type : "protein_coding",
      gene_name : "FAHD1",
      gene_level : 2,
      hgnc_id : "HGNC:14169",
      havana_gene : "OTTHUMG00000128663.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1833986,
      stop : 1884294,
      direction : "-",
      ID : "ENSG00000162039.17",
      gene_id : "ENSG00000162039.17",
      gene_type : "protein_coding",
      gene_name : "MEIOB",
      gene_level : 1,
      hgnc_id : "HGNC:28569",
      havana_gene : "OTTHUMG00000128683.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1911475,
      stop : 1918415,
      direction : "-",
      ID : "ENSG00000162040.7",
      gene_id : "ENSG00000162040.7",
      gene_type : "protein_coding",
      gene_name : "HS3ST6",
      gene_level : 2,
      hgnc_id : "HGNC:14178",
      havana_gene : "OTTHUMG00000047860.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1938229,
      stop : 1943293,
      direction : "-",
      ID : "ENSG00000198736.12",
      gene_id : "ENSG00000198736.12",
      gene_type : "protein_coding",
      gene_name : "MSRB1",
      gene_level : 1,
      hgnc_id : "HGNC:14133",
      havana_gene : "OTTHUMG00000129143.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1943974,
      stop : 1957606,
      direction : "-",
      ID : "ENSG00000140986.8",
      gene_id : "ENSG00000140986.8",
      gene_type : "protein_coding",
      gene_name : "RPL3L",
      gene_level : 2,
      hgnc_id : "HGNC:10351",
      havana_gene : "OTTHUMG00000128685.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1959538,
      stop : 1961975,
      direction : "+",
      ID : "ENSG00000140990.15",
      gene_id : "ENSG00000140990.15",
      gene_type : "protein_coding",
      gene_name : "NDUFB10",
      gene_level : 1,
      hgnc_id : "HGNC:7696",
      havana_gene : "OTTHUMG00000128709.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1962058,
      stop : 1964841,
      direction : "-",
      ID : "ENSG00000140988.16",
      gene_id : "ENSG00000140988.16",
      gene_type : "protein_coding",
      gene_name : "RPS2",
      gene_level : 2,
      hgnc_id : "HGNC:10404",
      havana_gene : "OTTHUMG00000128708.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1966823,
      stop : 1968975,
      direction : "+",
      ID : "ENSG00000179580.10",
      gene_id : "ENSG00000179580.10",
      gene_type : "protein_coding",
      gene_name : "RNF151",
      gene_level : 1,
      hgnc_id : "HGNC:23235",
      havana_gene : "OTTHUMG00000176852.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1972053,
      stop : 1982929,
      direction : "+",
      ID : "ENSG00000183751.15",
      gene_id : "ENSG00000183751.15",
      gene_type : "protein_coding",
      gene_name : "TBL3",
      gene_level : 2,
      hgnc_id : "HGNC:11587",
      havana_gene : "OTTHUMG00000128710.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1978917,
      stop : 1984192,
      direction : "-",
      ID : "ENSG00000196408.12",
      gene_id : "ENSG00000196408.12",
      gene_type : "protein_coding",
      gene_name : "NOXO1",
      gene_level : 2,
      hgnc_id : "HGNC:19404",
      havana_gene : "OTTHUMG00000128707.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1984193,
      stop : 1987749,
      direction : "+",
      ID : "ENSG00000127554.13",
      gene_id : "ENSG00000127554.13",
      gene_type : "protein_coding",
      gene_name : "GFER",
      gene_level : 2,
      hgnc_id : "HGNC:4236",
      havana_gene : "OTTHUMG00000176896.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1989660,
      stop : 1994275,
      direction : "+",
      ID : "ENSG00000127561.15",
      gene_id : "ENSG00000127561.15",
      gene_type : "protein_coding",
      gene_name : "SYNGR3",
      gene_level : 2,
      hgnc_id : "HGNC:11501",
      havana_gene : "OTTHUMG00000128711.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 1997654,
      stop : 2009821,
      direction : "-",
      ID : "ENSG00000167962.14",
      gene_id : "ENSG00000167962.14",
      gene_type : "protein_coding",
      gene_name : "ZNF598",
      gene_level : 2,
      hgnc_id : "HGNC:28079",
      havana_gene : "OTTHUMG00000176955.7",
      tag : "reference_genome_error"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2009926,
      stop : 2020755,
      direction : "+",
      ID : "ENSG00000183971.10",
      gene_id : "ENSG00000183971.10",
      gene_type : "protein_coding",
      gene_name : "NPW",
      gene_level : 2,
      hgnc_id : "HGNC:30509",
      havana_gene : "OTTHUMG00000176914.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2025356,
      stop : 2039026,
      direction : "+",
      ID : "ENSG00000065054.14",
      gene_id : "ENSG00000065054.14",
      gene_type : "protein_coding",
      gene_name : "SLC9A3R2",
      gene_level : 1,
      hgnc_id : "HGNC:11076",
      havana_gene : "OTTHUMG00000176956.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2039815,
      stop : 2047866,
      direction : "-",
      ID : "ENSG00000065057.9",
      gene_id : "ENSG00000065057.9",
      gene_type : "protein_coding",
      gene_name : "NTHL1",
      gene_level : 1,
      hgnc_id : "HGNC:8028",
      havana_gene : "OTTHUMG00000128744.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2047967,
      stop : 2089491,
      direction : "+",
      ID : "ENSG00000103197.18",
      gene_id : "ENSG00000103197.18",
      gene_type : "protein_coding",
      gene_name : "TSC2",
      gene_level : 1,
      hgnc_id : "HGNC:12363",
      havana_gene : "OTTHUMG00000128745.22",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2088708,
      stop : 2135898,
      direction : "-",
      ID : "ENSG00000008710.20",
      gene_id : "ENSG00000008710.20",
      gene_type : "protein_coding",
      gene_name : "PKD1",
      gene_level : 1,
      hgnc_id : "HGNC:9008",
      havana_gene : "OTTHUMG00000155795.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2140803,
      stop : 2154165,
      direction : "+",
      ID : "ENSG00000167964.13",
      gene_id : "ENSG00000167964.13",
      gene_type : "protein_coding",
      gene_name : "RAB26",
      gene_level : 1,
      hgnc_id : "HGNC:14259",
      havana_gene : "OTTHUMG00000128829.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2155698,
      stop : 2178129,
      direction : "+",
      ID : "ENSG00000131653.13",
      gene_id : "ENSG00000131653.13",
      gene_type : "protein_coding",
      gene_name : "TRAF7",
      gene_level : 2,
      hgnc_id : "HGNC:20456",
      havana_gene : "OTTHUMG00000128826.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2177180,
      stop : 2196605,
      direction : "-",
      ID : "ENSG00000167971.16",
      gene_id : "ENSG00000167971.16",
      gene_type : "protein_coding",
      gene_name : "CASKIN1",
      gene_level : 2,
      hgnc_id : "HGNC:20879",
      havana_gene : "OTTHUMG00000177045.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2204248,
      stop : 2209453,
      direction : "+",
      ID : "ENSG00000167965.18",
      gene_id : "ENSG00000167965.18",
      gene_type : "protein_coding",
      gene_name : "MLST8",
      gene_level : 2,
      hgnc_id : "HGNC:24825",
      havana_gene : "OTTHUMG00000128827.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2209253,
      stop : 2211950,
      direction : "-",
      ID : "ENSG00000182685.7",
      gene_id : "ENSG00000182685.7",
      gene_type : "protein_coding",
      gene_name : "BRICD5",
      gene_level : 2,
      hgnc_id : "HGNC:28309",
      havana_gene : "OTTHUMG00000128831.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2211593,
      stop : 2214840,
      direction : "-",
      ID : "ENSG00000184207.9",
      gene_id : "ENSG00000184207.9",
      gene_type : "protein_coding",
      gene_name : "PGP",
      gene_level : 2,
      hgnc_id : "HGNC:8909",
      havana_gene : "OTTHUMG00000177047.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2223580,
      stop : 2235742,
      direction : "+",
      ID : "ENSG00000167967.16",
      gene_id : "ENSG00000167967.16",
      gene_type : "protein_coding",
      gene_name : "E4F1",
      gene_level : 2,
      hgnc_id : "HGNC:3121",
      havana_gene : "OTTHUMG00000177084.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2235816,
      stop : 2238711,
      direction : "+",
      ID : "ENSG00000167968.13",
      gene_id : "ENSG00000167968.13",
      gene_type : "protein_coding",
      gene_name : "DNASE1L2",
      gene_level : 2,
      hgnc_id : "HGNC:2958",
      havana_gene : "OTTHUMG00000177086.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2239402,
      stop : 2252300,
      direction : "-",
      ID : "ENSG00000167969.13",
      gene_id : "ENSG00000167969.13",
      gene_type : "protein_coding",
      gene_name : "ECI1",
      gene_level : 2,
      hgnc_id : "HGNC:2703",
      havana_gene : "OTTHUMG00000128830.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2253116,
      stop : 2268397,
      direction : "-",
      ID : "ENSG00000205937.12",
      gene_id : "ENSG00000205937.12",
      gene_type : "protein_coding",
      gene_name : "RNPS1",
      gene_level : 2,
      hgnc_id : "HGNC:10080",
      havana_gene : "OTTHUMG00000128828.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2275881,
      stop : 2340746,
      direction : "-",
      ID : "ENSG00000167972.14",
      gene_id : "ENSG00000167972.14",
      gene_type : "protein_coding",
      gene_name : "ABCA3",
      gene_level : 1,
      hgnc_id : "HGNC:33",
      havana_gene : "OTTHUMG00000128845.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2429394,
      stop : 2458854,
      direction : "+",
      ID : "ENSG00000162063.13",
      gene_id : "ENSG00000162063.13",
      gene_type : "protein_coding",
      gene_name : "CCNF",
      gene_level : 2,
      hgnc_id : "HGNC:1591",
      havana_gene : "OTTHUMG00000128858.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2460086,
      stop : 2464963,
      direction : "+",
      ID : "ENSG00000162062.15",
      gene_id : "ENSG00000162062.15",
      gene_type : "protein_coding",
      gene_name : "TEDC2",
      gene_level : 2,
      hgnc_id : "HGNC:25849",
      havana_gene : "OTTHUMG00000128859.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2471297,
      stop : 2474145,
      direction : "+",
      ID : "ENSG00000162068.2",
      gene_id : "ENSG00000162068.2",
      gene_type : "protein_coding",
      gene_name : "NTN3",
      gene_level : 2,
      hgnc_id : "HGNC:8030",
      havana_gene : "OTTHUMG00000128867.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2475051,
      stop : 2509560,
      direction : "+",
      ID : "ENSG00000162065.14",
      gene_id : "ENSG00000162065.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D24",
      gene_level : 2,
      hgnc_id : "HGNC:29203",
      havana_gene : "OTTHUMG00000177150.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2496032,
      stop : 2520218,
      direction : "+",
      ID : "ENSG00000260272.1",
      gene_id : "ENSG00000260272.1",
      gene_type : "protein_coding",
      gene_name : "AC093525.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177152.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2513952,
      stop : 2520218,
      direction : "+",
      ID : "ENSG00000185883.12",
      gene_id : "ENSG00000185883.12",
      gene_type : "protein_coding",
      gene_name : "ATP6V0C",
      gene_level : 2,
      hgnc_id : "HGNC:855",
      havana_gene : "OTTHUMG00000128865.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2513965,
      stop : 2527955,
      direction : "+",
      ID : "ENSG00000259784.1",
      gene_id : "ENSG00000259784.1",
      gene_type : "protein_coding",
      gene_name : "AC093525.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177153.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2520357,
      stop : 2531422,
      direction : "+",
      ID : "ENSG00000162066.16",
      gene_id : "ENSG00000162066.16",
      gene_type : "protein_coding",
      gene_name : "AMDHD2",
      gene_level : 1,
      hgnc_id : "HGNC:24262",
      havana_gene : "OTTHUMG00000128866.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2530035,
      stop : 2531417,
      direction : "-",
      ID : "ENSG00000205923.3",
      gene_id : "ENSG00000205923.3",
      gene_type : "protein_coding",
      gene_name : "CEMP1",
      gene_level : 2,
      hgnc_id : "HGNC:32553",
      havana_gene : "OTTHUMG00000177160.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2537979,
      stop : 2603188,
      direction : "+",
      ID : "ENSG00000140992.19",
      gene_id : "ENSG00000140992.19",
      gene_type : "protein_coding",
      gene_name : "PDPK1",
      gene_level : 1,
      hgnc_id : "HGNC:8816",
      havana_gene : "OTTHUMG00000128874.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2682523,
      stop : 2709030,
      direction : "+",
      ID : "ENSG00000167977.9",
      gene_id : "ENSG00000167977.9",
      gene_type : "protein_coding",
      gene_name : "KCTD5",
      gene_level : 2,
      hgnc_id : "HGNC:21423",
      havana_gene : "OTTHUMG00000128930.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2712419,
      stop : 2720551,
      direction : "-",
      ID : "ENSG00000172382.10",
      gene_id : "ENSG00000172382.10",
      gene_type : "protein_coding",
      gene_name : "PRSS27",
      gene_level : 2,
      hgnc_id : "HGNC:15475",
      havana_gene : "OTTHUMG00000128929.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2752626,
      stop : 2772538,
      direction : "+",
      ID : "ENSG00000167978.17",
      gene_id : "ENSG00000167978.17",
      gene_type : "protein_coding",
      gene_name : "SRRM2",
      gene_level : 1,
      hgnc_id : "HGNC:16639",
      havana_gene : "OTTHUMG00000177358.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2771414,
      stop : 2777280,
      direction : "-",
      ID : "ENSG00000103363.15",
      gene_id : "ENSG00000103363.15",
      gene_type : "protein_coding",
      gene_name : "ELOB",
      gene_level : 2,
      hgnc_id : "HGNC:11619",
      havana_gene : "OTTHUMG00000154125.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2783953,
      stop : 2787948,
      direction : "-",
      ID : "ENSG00000103355.13",
      gene_id : "ENSG00000103355.13",
      gene_type : "protein_coding",
      gene_name : "PRSS33",
      gene_level : 2,
      hgnc_id : "HGNC:30405",
      havana_gene : "OTTHUMG00000177360.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2798470,
      stop : 2805304,
      direction : "+",
      ID : "ENSG00000215148.11",
      gene_id : "ENSG00000215148.11",
      gene_type : "protein_coding",
      gene_name : "PRSS41",
      gene_level : 2,
      hgnc_id : "HGNC:30715",
      havana_gene : "OTTHUMG00000128932.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2817180,
      stop : 2826304,
      direction : "+",
      ID : "ENSG00000007038.11",
      gene_id : "ENSG00000007038.11",
      gene_type : "protein_coding",
      gene_name : "PRSS21",
      gene_level : 2,
      hgnc_id : "HGNC:9485",
      havana_gene : "OTTHUMG00000128931.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2830169,
      stop : 2839585,
      direction : "+",
      ID : "ENSG00000162078.11",
      gene_id : "ENSG00000162078.11",
      gene_type : "protein_coding",
      gene_name : "ZG16B",
      gene_level : 1,
      hgnc_id : "HGNC:30456",
      havana_gene : "OTTHUMG00000128933.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2852730,
      stop : 2858170,
      direction : "-",
      ID : "ENSG00000005001.10",
      gene_id : "ENSG00000005001.10",
      gene_type : "protein_coding",
      gene_name : "PRSS22",
      gene_level : 1,
      hgnc_id : "HGNC:14368",
      havana_gene : "OTTHUMG00000128961.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2883213,
      stop : 2899382,
      direction : "+",
      ID : "ENSG00000162076.13",
      gene_id : "ENSG00000162076.13",
      gene_type : "protein_coding",
      gene_name : "FLYWCH2",
      gene_level : 2,
      hgnc_id : "HGNC:25178",
      havana_gene : "OTTHUMG00000128962.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2911931,
      stop : 2951208,
      direction : "+",
      ID : "ENSG00000059122.17",
      gene_id : "ENSG00000059122.17",
      gene_type : "protein_coding",
      gene_name : "FLYWCH1",
      gene_level : 1,
      hgnc_id : "HGNC:25404",
      havana_gene : "OTTHUMG00000177364.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2964216,
      stop : 2968383,
      direction : "+",
      ID : "ENSG00000131650.14",
      gene_id : "ENSG00000131650.14",
      gene_type : "protein_coding",
      gene_name : "KREMEN2",
      gene_level : 2,
      hgnc_id : "HGNC:18797",
      havana_gene : "OTTHUMG00000128976.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2968024,
      stop : 2980479,
      direction : "-",
      ID : "ENSG00000127564.17",
      gene_id : "ENSG00000127564.17",
      gene_type : "protein_coding",
      gene_name : "PKMYT1",
      gene_level : 1,
      hgnc_id : "HGNC:29650",
      havana_gene : "OTTHUMG00000128975.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2969270,
      stop : 2973484,
      direction : "+",
      ID : "ENSG00000162073.14",
      gene_id : "ENSG00000162073.14",
      gene_type : "protein_coding",
      gene_name : "PAQR4",
      gene_level : 1,
      hgnc_id : "HGNC:26386",
      havana_gene : "OTTHUMG00000128977.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 2988256,
      stop : 3002016,
      direction : "+",
      ID : "ENSG00000262152.7",
      gene_id : "ENSG00000262152.7",
      gene_type : "protein_coding",
      gene_name : "LINC00514",
      gene_level : 2,
      hgnc_id : "HGNC:27549",
      havana_gene : "OTTHUMG00000177448.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3012923,
      stop : 3014505,
      direction : "+",
      ID : "ENSG00000213937.4",
      gene_id : "ENSG00000213937.4",
      gene_type : "protein_coding",
      gene_name : "CLDN9",
      gene_level : 2,
      hgnc_id : "HGNC:2051",
      havana_gene : "OTTHUMG00000129000.2",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3014712,
      stop : 3020071,
      direction : "-",
      ID : "ENSG00000184697.7",
      gene_id : "ENSG00000184697.7",
      gene_type : "protein_coding",
      gene_name : "CLDN6",
      gene_level : 2,
      hgnc_id : "HGNC:2048",
      havana_gene : "OTTHUMG00000128999.4",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3018445,
      stop : 3022383,
      direction : "+",
      ID : "ENSG00000006327.14",
      gene_id : "ENSG00000006327.14",
      gene_type : "protein_coding",
      gene_name : "TNFRSF12A",
      gene_level : 2,
      hgnc_id : "HGNC:18152",
      havana_gene : "OTTHUMG00000129001.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3022625,
      stop : 3024286,
      direction : "-",
      ID : "ENSG00000103145.11",
      gene_id : "ENSG00000103145.11",
      gene_type : "protein_coding",
      gene_name : "HCFC1R1",
      gene_level : 1,
      hgnc_id : "HGNC:21198",
      havana_gene : "OTTHUMG00000177450.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3024027,
      stop : 3027755,
      direction : "+",
      ID : "ENSG00000131652.14",
      gene_id : "ENSG00000131652.14",
      gene_type : "protein_coding",
      gene_name : "THOC6",
      gene_level : 2,
      hgnc_id : "HGNC:28369",
      havana_gene : "OTTHUMG00000177451.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3027682,
      stop : 3036944,
      direction : "-",
      ID : "ENSG00000162069.16",
      gene_id : "ENSG00000162069.16",
      gene_type : "protein_coding",
      gene_name : "BICDL2",
      gene_level : 2,
      hgnc_id : "HGNC:33584",
      havana_gene : "OTTHUMG00000177452.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3046062,
      stop : 3060726,
      direction : "+",
      ID : "ENSG00000008516.18",
      gene_id : "ENSG00000008516.18",
      gene_type : "protein_coding",
      gene_name : "MMP25",
      gene_level : 2,
      hgnc_id : "HGNC:14246",
      havana_gene : "OTTHUMG00000177475.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3065297,
      stop : 3082192,
      direction : "+",
      ID : "ENSG00000008517.18",
      gene_id : "ENSG00000008517.18",
      gene_type : "protein_coding",
      gene_name : "IL32",
      gene_level : 2,
      hgnc_id : "HGNC:16830",
      havana_gene : "OTTHUMG00000167498.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3088890,
      stop : 3099295,
      direction : "-",
      ID : "ENSG00000130182.8",
      gene_id : "ENSG00000130182.8",
      gene_type : "protein_coding",
      gene_name : "ZSCAN10",
      gene_level : 2,
      hgnc_id : "HGNC:12997",
      havana_gene : "OTTHUMG00000177478.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3112560,
      stop : 3120517,
      direction : "+",
      ID : "ENSG00000122386.11",
      gene_id : "ENSG00000122386.11",
      gene_type : "protein_coding",
      gene_name : "ZNF205",
      gene_level : 1,
      hgnc_id : "HGNC:12996",
      havana_gene : "OTTHUMG00000148676.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3129777,
      stop : 3142804,
      direction : "+",
      ID : "ENSG00000085644.14",
      gene_id : "ENSG00000085644.14",
      gene_type : "protein_coding",
      gene_name : "ZNF213",
      gene_level : 1,
      hgnc_id : "HGNC:13005",
      havana_gene : "OTTHUMG00000177519.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3204247,
      stop : 3205188,
      direction : "+",
      ID : "ENSG00000168124.2",
      gene_id : "ENSG00000168124.2",
      gene_type : "protein_coding",
      gene_name : "OR1F1",
      gene_level : 2,
      hgnc_id : "HGNC:8194",
      havana_gene : "OTTHUMG00000133153.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3222325,
      stop : 3236221,
      direction : "-",
      ID : "ENSG00000010539.12",
      gene_id : "ENSG00000010539.12",
      gene_type : "protein_coding",
      gene_name : "ZNF200",
      gene_level : 2,
      hgnc_id : "HGNC:12993",
      havana_gene : "OTTHUMG00000129317.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3242027,
      stop : 3256633,
      direction : "-",
      ID : "ENSG00000103313.13",
      gene_id : "ENSG00000103313.13",
      gene_type : "protein_coding",
      gene_name : "MEFV",
      gene_level : 1,
      hgnc_id : "HGNC:6998",
      havana_gene : "OTTHUMG00000129324.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3263800,
      stop : 3301401,
      direction : "+",
      ID : "ENSG00000006194.10",
      gene_id : "ENSG00000006194.10",
      gene_type : "protein_coding",
      gene_name : "ZNF263",
      gene_level : 1,
      hgnc_id : "HGNC:13056",
      havana_gene : "OTTHUMG00000129323.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3298808,
      stop : 3305729,
      direction : "-",
      ID : "ENSG00000140993.11",
      gene_id : "ENSG00000140993.11",
      gene_type : "protein_coding",
      gene_name : "TIGD7",
      gene_level : 1,
      hgnc_id : "HGNC:18331",
      havana_gene : "OTTHUMG00000129325.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3305406,
      stop : 3318852,
      direction : "+",
      ID : "ENSG00000162086.16",
      gene_id : "ENSG00000162086.16",
      gene_type : "protein_coding",
      gene_name : "ZNF75A",
      gene_level : 1,
      hgnc_id : "HGNC:13146",
      havana_gene : "OTTHUMG00000129356.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3355889,
      stop : 3357306,
      direction : "+",
      ID : "ENSG00000168158.4",
      gene_id : "ENSG00000168158.4",
      gene_type : "protein_coding",
      gene_name : "OR2C1",
      gene_level : 2,
      hgnc_id : "HGNC:8242",
      havana_gene : "OTTHUMG00000090505.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3365099,
      stop : 3479550,
      direction : "+",
      ID : "ENSG00000285329.1",
      gene_id : "ENSG00000285329.1",
      gene_type : "protein_coding",
      gene_name : "AC025283.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177580.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3370979,
      stop : 3372668,
      direction : "-",
      ID : "ENSG00000232196.4",
      gene_id : "ENSG00000232196.4",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L4",
      gene_level : 2,
      hgnc_id : "HGNC:37161",
      havana_gene : "OTTHUMG00000184964.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3382081,
      stop : 3401065,
      direction : "-",
      ID : "ENSG00000140987.20",
      gene_id : "ENSG00000140987.20",
      gene_type : "protein_coding",
      gene_name : "ZSCAN32",
      gene_level : 1,
      hgnc_id : "HGNC:20812",
      havana_gene : "OTTHUMG00000129357.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3401215,
      stop : 3409364,
      direction : "+",
      ID : "ENSG00000103343.13",
      gene_id : "ENSG00000103343.13",
      gene_type : "protein_coding",
      gene_name : "ZNF174",
      gene_level : 2,
      hgnc_id : "HGNC:12963",
      havana_gene : "OTTHUMG00000129358.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3432414,
      stop : 3443504,
      direction : "-",
      ID : "ENSG00000167981.7",
      gene_id : "ENSG00000167981.7",
      gene_type : "protein_coding",
      gene_name : "ZNF597",
      gene_level : 2,
      hgnc_id : "HGNC:26573",
      havana_gene : "OTTHUMG00000129359.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3443649,
      stop : 3486953,
      direction : "+",
      ID : "ENSG00000122390.19",
      gene_id : "ENSG00000122390.19",
      gene_type : "protein_coding",
      gene_name : "NAA60",
      gene_level : 1,
      hgnc_id : "HGNC:25875",
      havana_gene : "OTTHUMG00000150268.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3493484,
      stop : 3495489,
      direction : "-",
      ID : "ENSG00000215131.11",
      gene_id : "ENSG00000215131.11",
      gene_type : "protein_coding",
      gene_name : "C16orf90",
      gene_level : 1,
      hgnc_id : "HGNC:34455",
      havana_gene : "OTTHUMG00000154627.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3500976,
      stop : 3539048,
      direction : "+",
      ID : "ENSG00000103351.13",
      gene_id : "ENSG00000103351.13",
      gene_type : "protein_coding",
      gene_name : "CLUAP1",
      gene_level : 2,
      hgnc_id : "HGNC:19009",
      havana_gene : "OTTHUMG00000177581.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3539033,
      stop : 3577403,
      direction : "-",
      ID : "ENSG00000167984.18",
      gene_id : "ENSG00000167984.18",
      gene_type : "protein_coding",
      gene_name : "NLRC3",
      gene_level : 2,
      hgnc_id : "HGNC:29889",
      havana_gene : "OTTHUMG00000177561.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3581181,
      stop : 3611606,
      direction : "-",
      ID : "ENSG00000188827.11",
      gene_id : "ENSG00000188827.11",
      gene_type : "protein_coding",
      gene_name : "SLX4",
      gene_level : 2,
      hgnc_id : "HGNC:23845",
      havana_gene : "OTTHUMG00000074089.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3611728,
      stop : 3680143,
      direction : "+",
      ID : "ENSG00000213918.10",
      gene_id : "ENSG00000213918.10",
      gene_type : "protein_coding",
      gene_name : "DNASE1",
      gene_level : 2,
      hgnc_id : "HGNC:2956",
      havana_gene : "OTTHUMG00000129426.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3651639,
      stop : 3717553,
      direction : "-",
      ID : "ENSG00000126602.11",
      gene_id : "ENSG00000126602.11",
      gene_type : "protein_coding",
      gene_name : "TRAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16264",
      havana_gene : "OTTHUMG00000129427.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3725054,
      stop : 3880713,
      direction : "-",
      ID : "ENSG00000005339.15",
      gene_id : "ENSG00000005339.15",
      gene_type : "protein_coding",
      gene_name : "CREBBP",
      gene_level : 1,
      hgnc_id : "HGNC:2348",
      havana_gene : "OTTHUMG00000129431.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 3953387,
      stop : 4116442,
      direction : "-",
      ID : "ENSG00000162104.10",
      gene_id : "ENSG00000162104.10",
      gene_type : "protein_coding",
      gene_name : "ADCY9",
      gene_level : 2,
      hgnc_id : "HGNC:240",
      havana_gene : "OTTHUMG00000177612.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4189374,
      stop : 4242080,
      direction : "-",
      ID : "ENSG00000185739.13",
      gene_id : "ENSG00000185739.13",
      gene_type : "protein_coding",
      gene_name : "SRL",
      gene_level : 2,
      hgnc_id : "HGNC:11295",
      havana_gene : "OTTHUMG00000177617.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4257186,
      stop : 4273075,
      direction : "-",
      ID : "ENSG00000090447.12",
      gene_id : "ENSG00000090447.12",
      gene_type : "protein_coding",
      gene_name : "TFAP4",
      gene_level : 1,
      hgnc_id : "HGNC:11745",
      havana_gene : "OTTHUMG00000129435.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4314761,
      stop : 4339597,
      direction : "+",
      ID : "ENSG00000126603.9",
      gene_id : "ENSG00000126603.9",
      gene_type : "protein_coding",
      gene_name : "GLIS2",
      gene_level : 2,
      hgnc_id : "HGNC:29450",
      havana_gene : "OTTHUMG00000129467.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4331549,
      stop : 4355607,
      direction : "-",
      ID : "ENSG00000217930.8",
      gene_id : "ENSG00000217930.8",
      gene_type : "protein_coding",
      gene_name : "PAM16",
      gene_level : 1,
      hgnc_id : "HGNC:29679",
      havana_gene : "OTTHUMG00000129466.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4340251,
      stop : 4420494,
      direction : "-",
      ID : "ENSG00000103426.12",
      gene_id : "ENSG00000103426.12",
      gene_type : "protein_coding",
      gene_name : "CORO7-PAM16",
      gene_level : 2,
      hgnc_id : "HGNC:44424",
      havana_gene : "OTTHUMG00000177664.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4354542,
      stop : 4425705,
      direction : "-",
      ID : "ENSG00000262246.6",
      gene_id : "ENSG00000262246.6",
      gene_type : "protein_coding",
      gene_name : "CORO7",
      gene_level : 1,
      hgnc_id : "HGNC:26161",
      havana_gene : "OTTHUMG00000129465.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4371848,
      stop : 4383538,
      direction : "+",
      ID : "ENSG00000168140.5",
      gene_id : "ENSG00000168140.5",
      gene_type : "protein_coding",
      gene_name : "VASN",
      gene_level : 2,
      hgnc_id : "HGNC:18517",
      havana_gene : "OTTHUMG00000129469.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4425805,
      stop : 4456775,
      direction : "+",
      ID : "ENSG00000103423.14",
      gene_id : "ENSG00000103423.14",
      gene_type : "protein_coding",
      gene_name : "DNAJA3",
      gene_level : 1,
      hgnc_id : "HGNC:11808",
      havana_gene : "OTTHUMG00000129470.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4461691,
      stop : 4495763,
      direction : "-",
      ID : "ENSG00000153406.14",
      gene_id : "ENSG00000153406.14",
      gene_type : "protein_coding",
      gene_name : "NMRAL1",
      gene_level : 1,
      hgnc_id : "HGNC:24987",
      havana_gene : "OTTHUMG00000129468.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4474690,
      stop : 4510347,
      direction : "+",
      ID : "ENSG00000103415.12",
      gene_id : "ENSG00000103415.12",
      gene_type : "protein_coding",
      gene_name : "HMOX2",
      gene_level : 2,
      hgnc_id : "HGNC:5014",
      havana_gene : "OTTHUMG00000129473.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4510669,
      stop : 4538828,
      direction : "-",
      ID : "ENSG00000089486.17",
      gene_id : "ENSG00000089486.17",
      gene_type : "protein_coding",
      gene_name : "CDIP1",
      gene_level : 1,
      hgnc_id : "HGNC:13234",
      havana_gene : "OTTHUMG00000177172.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4556490,
      stop : 4600714,
      direction : "+",
      ID : "ENSG00000205832.7",
      gene_id : "ENSG00000205832.7",
      gene_type : "protein_coding",
      gene_name : "C16orf96",
      gene_level : 2,
      hgnc_id : "HGNC:40031",
      havana_gene : "OTTHUMG00000176519.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4608883,
      stop : 4615027,
      direction : "-",
      ID : "ENSG00000153443.13",
      gene_id : "ENSG00000153443.13",
      gene_type : "protein_coding",
      gene_name : "UBALD1",
      gene_level : 1,
      hgnc_id : "HGNC:29576",
      havana_gene : "OTTHUMG00000129472.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4616493,
      stop : 4690974,
      direction : "+",
      ID : "ENSG00000102858.13",
      gene_id : "ENSG00000102858.13",
      gene_type : "protein_coding",
      gene_name : "MGRN1",
      gene_level : 1,
      hgnc_id : "HGNC:20254",
      havana_gene : "OTTHUMG00000176436.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4693694,
      stop : 4695859,
      direction : "+",
      ID : "ENSG00000168101.14",
      gene_id : "ENSG00000168101.14",
      gene_type : "protein_coding",
      gene_name : "NUDT16L1",
      gene_level : 1,
      hgnc_id : "HGNC:28154",
      havana_gene : "OTTHUMG00000129471.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4696510,
      stop : 4734378,
      direction : "-",
      ID : "ENSG00000168096.15",
      gene_id : "ENSG00000168096.15",
      gene_type : "protein_coding",
      gene_name : "ANKS3",
      gene_level : 1,
      hgnc_id : "HGNC:29422",
      havana_gene : "OTTHUMG00000129478.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4734344,
      stop : 4749396,
      direction : "+",
      ID : "ENSG00000166246.14",
      gene_id : "ENSG00000166246.14",
      gene_type : "protein_coding",
      gene_name : "C16orf71",
      gene_level : 1,
      hgnc_id : "HGNC:25081",
      havana_gene : "OTTHUMG00000129480.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4748239,
      stop : 4767624,
      direction : "-",
      ID : "ENSG00000103199.14",
      gene_id : "ENSG00000103199.14",
      gene_type : "protein_coding",
      gene_name : "ZNF500",
      gene_level : 1,
      hgnc_id : "HGNC:23716",
      havana_gene : "OTTHUMG00000176543.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4777606,
      stop : 4788398,
      direction : "-",
      ID : "ENSG00000140623.14",
      gene_id : "ENSG00000140623.14",
      gene_type : "protein_coding",
      gene_name : "SEPTIN12",
      gene_level : 2,
      hgnc_id : "HGNC:26348",
      havana_gene : "OTTHUMG00000129481.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4788397,
      stop : 4796491,
      direction : "+",
      ID : "ENSG00000267795.6",
      gene_id : "ENSG00000267795.6",
      gene_type : "protein_coding",
      gene_name : "SMIM22",
      gene_level : 2,
      hgnc_id : "HGNC:48329",
      havana_gene : "OTTHUMG00000177849.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4796968,
      stop : 4802880,
      direction : "-",
      ID : "ENSG00000067836.13",
      gene_id : "ENSG00000067836.13",
      gene_type : "protein_coding",
      gene_name : "ROGDI",
      gene_level : 1,
      hgnc_id : "HGNC:29478",
      havana_gene : "OTTHUMG00000193363.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4803203,
      stop : 4847288,
      direction : "-",
      ID : "ENSG00000140632.17",
      gene_id : "ENSG00000140632.17",
      gene_type : "protein_coding",
      gene_name : "GLYR1",
      gene_level : 2,
      hgnc_id : "HGNC:24434",
      havana_gene : "OTTHUMG00000129530.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4846665,
      stop : 4882401,
      direction : "+",
      ID : "ENSG00000118900.15",
      gene_id : "ENSG00000118900.15",
      gene_type : "protein_coding",
      gene_name : "UBN1",
      gene_level : 1,
      hgnc_id : "HGNC:12506",
      havana_gene : "OTTHUMG00000129531.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4882507,
      stop : 4960741,
      direction : "-",
      ID : "ENSG00000118898.16",
      gene_id : "ENSG00000118898.16",
      gene_type : "protein_coding",
      gene_name : "PPL",
      gene_level : 2,
      hgnc_id : "HGNC:9273",
      havana_gene : "OTTHUMG00000129528.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 4958330,
      stop : 5019157,
      direction : "+",
      ID : "ENSG00000103184.12",
      gene_id : "ENSG00000103184.12",
      gene_type : "protein_coding",
      gene_name : "SEC14L5",
      gene_level : 2,
      hgnc_id : "HGNC:29032",
      havana_gene : "OTTHUMG00000176942.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 5024844,
      stop : 5034141,
      direction : "-",
      ID : "ENSG00000103174.13",
      gene_id : "ENSG00000103174.13",
      gene_type : "protein_coding",
      gene_name : "NAGPA",
      gene_level : 1,
      hgnc_id : "HGNC:17378",
      havana_gene : "OTTHUMG00000090515.10",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 5033923,
      stop : 5087379,
      direction : "+",
      ID : "ENSG00000033011.13",
      gene_id : "ENSG00000033011.13",
      gene_type : "protein_coding",
      gene_name : "ALG1",
      gene_level : 1,
      hgnc_id : "HGNC:18294",
      havana_gene : "OTTHUMG00000129529.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 5044122,
      stop : 5066110,
      direction : "-",
      ID : "ENSG00000153446.16",
      gene_id : "ENSG00000153446.16",
      gene_type : "protein_coding",
      gene_name : "C16orf89",
      gene_level : 1,
      hgnc_id : "HGNC:28687",
      havana_gene : "OTTHUMG00000159314.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 5084284,
      stop : 5097795,
      direction : "-",
      ID : "ENSG00000118894.15",
      gene_id : "ENSG00000118894.15",
      gene_type : "protein_coding",
      gene_name : "EEF2KMT",
      gene_level : 2,
      hgnc_id : "HGNC:32221",
      havana_gene : "OTTHUMG00000129527.11",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 5239802,
      stop : 7713340,
      direction : "+",
      ID : "ENSG00000078328.22",
      gene_id : "ENSG00000078328.22",
      gene_type : "protein_coding",
      gene_name : "RBFOX1",
      gene_level : 1,
      hgnc_id : "HGNC:18222",
      havana_gene : "OTTHUMG00000129551.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8537605,
      stop : 8590193,
      direction : "-",
      ID : "ENSG00000232258.6",
      gene_id : "ENSG00000232258.6",
      gene_type : "protein_coding",
      gene_name : "TMEM114",
      gene_level : 2,
      hgnc_id : "HGNC:33227",
      havana_gene : "OTTHUMG00000172868.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8621683,
      stop : 8649654,
      direction : "+",
      ID : "ENSG00000067365.15",
      gene_id : "ENSG00000067365.15",
      gene_type : "protein_coding",
      gene_name : "METTL22",
      gene_level : 1,
      hgnc_id : "HGNC:28368",
      havana_gene : "OTTHUMG00000129694.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8674596,
      stop : 8784575,
      direction : "+",
      ID : "ENSG00000183044.12",
      gene_id : "ENSG00000183044.12",
      gene_type : "protein_coding",
      gene_name : "ABAT",
      gene_level : 1,
      hgnc_id : "HGNC:23",
      havana_gene : "OTTHUMG00000048201.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8780384,
      stop : 8797642,
      direction : "-",
      ID : "ENSG00000184857.8",
      gene_id : "ENSG00000184857.8",
      gene_type : "protein_coding",
      gene_name : "TMEM186",
      gene_level : 2,
      hgnc_id : "HGNC:24530",
      havana_gene : "OTTHUMG00000129696.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8788823,
      stop : 8849325,
      direction : "+",
      ID : "ENSG00000140650.12",
      gene_id : "ENSG00000140650.12",
      gene_type : "protein_coding",
      gene_name : "PMM2",
      gene_level : 1,
      hgnc_id : "HGNC:9115",
      havana_gene : "OTTHUMG00000129697.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8852942,
      stop : 8869012,
      direction : "-",
      ID : "ENSG00000153048.11",
      gene_id : "ENSG00000153048.11",
      gene_type : "protein_coding",
      gene_name : "CARHSP1",
      gene_level : 1,
      hgnc_id : "HGNC:17150",
      havana_gene : "OTTHUMG00000129695.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8881634,
      stop : 8885351,
      direction : "+",
      ID : "ENSG00000283516.1",
      gene_id : "ENSG00000283516.1",
      gene_type : "protein_coding",
      gene_name : "LITAFD",
      gene_level : 2,
      hgnc_id : "HGNC:53927",
      havana_gene : "OTTHUMG00000176581.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 8892097,
      stop : 8975328,
      direction : "-",
      ID : "ENSG00000187555.16",
      gene_id : "ENSG00000187555.16",
      gene_type : "protein_coding",
      gene_name : "USP7",
      gene_level : 2,
      hgnc_id : "HGNC:12630",
      havana_gene : "OTTHUMG00000176903.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 9091644,
      stop : 9121635,
      direction : "+",
      ID : "ENSG00000182831.12",
      gene_id : "ENSG00000182831.12",
      gene_type : "protein_coding",
      gene_name : "C16orf72",
      gene_level : 2,
      hgnc_id : "HGNC:30103",
      havana_gene : "OTTHUMG00000178147.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 9753404,
      stop : 10182928,
      direction : "-",
      ID : "ENSG00000183454.18",
      gene_id : "ENSG00000183454.18",
      gene_type : "protein_coding",
      gene_name : "GRIN2A",
      gene_level : 2,
      hgnc_id : "HGNC:4585",
      havana_gene : "OTTHUMG00000129721.10",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10326434,
      stop : 10483638,
      direction : "+",
      ID : "ENSG00000166669.13",
      gene_id : "ENSG00000166669.13",
      gene_type : "protein_coding",
      gene_name : "ATF7IP2",
      gene_level : 1,
      hgnc_id : "HGNC:20397",
      havana_gene : "OTTHUMG00000129749.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10528422,
      stop : 10580632,
      direction : "-",
      ID : "ENSG00000213853.10",
      gene_id : "ENSG00000213853.10",
      gene_type : "protein_coding",
      gene_name : "EMP2",
      gene_level : 1,
      hgnc_id : "HGNC:3334",
      havana_gene : "OTTHUMG00000129752.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10627501,
      stop : 10694930,
      direction : "-",
      ID : "ENSG00000153060.8",
      gene_id : "ENSG00000153060.8",
      gene_type : "protein_coding",
      gene_name : "TEKT5",
      gene_level : 2,
      hgnc_id : "HGNC:26554",
      havana_gene : "OTTHUMG00000129750.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10743786,
      stop : 10769351,
      direction : "+",
      ID : "ENSG00000103274.11",
      gene_id : "ENSG00000103274.11",
      gene_type : "protein_coding",
      gene_name : "NUBP1",
      gene_level : 2,
      hgnc_id : "HGNC:8041",
      havana_gene : "OTTHUMG00000129751.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10760919,
      stop : 10818794,
      direction : "-",
      ID : "ENSG00000166676.17",
      gene_id : "ENSG00000166676.17",
      gene_type : "protein_coding",
      gene_name : "TVP23A",
      gene_level : 2,
      hgnc_id : "HGNC:20398",
      havana_gene : "OTTHUMG00000177389.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10866222,
      stop : 10943021,
      direction : "+",
      ID : "ENSG00000179583.20",
      gene_id : "ENSG00000179583.20",
      gene_type : "protein_coding",
      gene_name : "CIITA",
      gene_level : 2,
      hgnc_id : "HGNC:7067",
      havana_gene : "OTTHUMG00000129753.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10928891,
      stop : 10942468,
      direction : "-",
      ID : "ENSG00000182108.11",
      gene_id : "ENSG00000182108.11",
      gene_type : "protein_coding",
      gene_name : "DEXI",
      gene_level : 2,
      hgnc_id : "HGNC:13267",
      havana_gene : "OTTHUMG00000129785.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 10944564,
      stop : 11182186,
      direction : "+",
      ID : "ENSG00000038532.16",
      gene_id : "ENSG00000038532.16",
      gene_type : "protein_coding",
      gene_name : "CLEC16A",
      gene_level : 1,
      hgnc_id : "HGNC:29013",
      havana_gene : "OTTHUMG00000152915.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11249619,
      stop : 11381662,
      direction : "+",
      ID : "ENSG00000175643.10",
      gene_id : "ENSG00000175643.10",
      gene_type : "protein_coding",
      gene_name : "RMI2",
      gene_level : 2,
      hgnc_id : "HGNC:28349",
      havana_gene : "OTTHUMG00000129793.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11254408,
      stop : 11256204,
      direction : "-",
      ID : "ENSG00000185338.6",
      gene_id : "ENSG00000185338.6",
      gene_type : "protein_coding",
      gene_name : "SOCS1",
      gene_level : 2,
      hgnc_id : "HGNC:19383",
      havana_gene : "OTTHUMG00000129792.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11267748,
      stop : 11269533,
      direction : "-",
      ID : "ENSG00000178279.4",
      gene_id : "ENSG00000178279.4",
      gene_type : "protein_coding",
      gene_name : "TNP2",
      gene_level : 2,
      hgnc_id : "HGNC:11952",
      havana_gene : "OTTHUMG00000172315.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11273199,
      stop : 11273629,
      direction : "-",
      ID : "ENSG00000178257.4",
      gene_id : "ENSG00000178257.4",
      gene_type : "protein_coding",
      gene_name : "PRM3",
      gene_level : 2,
      hgnc_id : "HGNC:13732",
      havana_gene : "OTTHUMG00000172316.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11275639,
      stop : 11276480,
      direction : "-",
      ID : "ENSG00000122304.11",
      gene_id : "ENSG00000122304.11",
      gene_type : "protein_coding",
      gene_name : "PRM2",
      gene_level : 2,
      hgnc_id : "HGNC:9448",
      havana_gene : "OTTHUMG00000172317.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11280841,
      stop : 11281330,
      direction : "-",
      ID : "ENSG00000175646.4",
      gene_id : "ENSG00000175646.4",
      gene_type : "protein_coding",
      gene_name : "PRM1",
      gene_level : 2,
      hgnc_id : "HGNC:9447",
      havana_gene : "OTTHUMG00000090521.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11359845,
      stop : 11527245,
      direction : "-",
      ID : "ENSG00000188897.9",
      gene_id : "ENSG00000188897.9",
      gene_type : "protein_coding",
      gene_name : "AC099489.1",
      gene_level : 1,
      hgnc_id : "havana_gene=OTTHUMG00000178167.5",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11547722,
      stop : 11636381,
      direction : "-",
      ID : "ENSG00000189067.14",
      gene_id : "ENSG00000189067.14",
      gene_type : "protein_coding",
      gene_name : "LITAF",
      gene_level : 1,
      hgnc_id : "HGNC:16841",
      havana_gene : "OTTHUMG00000177415.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11668455,
      stop : 11679152,
      direction : "+",
      ID : "ENSG00000184602.6",
      gene_id : "ENSG00000184602.6",
      gene_type : "protein_coding",
      gene_name : "SNN",
      gene_level : 2,
      hgnc_id : "HGNC:11149",
      havana_gene : "OTTHUMG00000090535.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11679083,
      stop : 11742857,
      direction : "-",
      ID : "ENSG00000153066.13",
      gene_id : "ENSG00000153066.13",
      gene_type : "protein_coding",
      gene_name : "TXNDC11",
      gene_level : 2,
      hgnc_id : "HGNC:28030",
      havana_gene : "OTTHUMG00000177467.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11750586,
      stop : 11797258,
      direction : "-",
      ID : "ENSG00000122299.12",
      gene_id : "ENSG00000122299.12",
      gene_type : "protein_coding",
      gene_name : "ZC3H7A",
      gene_level : 1,
      hgnc_id : "HGNC:30959",
      havana_gene : "OTTHUMG00000129825.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11833850,
      stop : 11851580,
      direction : "-",
      ID : "ENSG00000171490.13",
      gene_id : "ENSG00000171490.13",
      gene_type : "protein_coding",
      gene_name : "RSL1D1",
      gene_level : 1,
      hgnc_id : "HGNC:24534",
      havana_gene : "OTTHUMG00000129824.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11868128,
      stop : 11916082,
      direction : "-",
      ID : "ENSG00000103342.13",
      gene_id : "ENSG00000103342.13",
      gene_type : "protein_coding",
      gene_name : "GSPT1",
      gene_level : 2,
      hgnc_id : "HGNC:4621",
      havana_gene : "OTTHUMG00000172956.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11927259,
      stop : 11976643,
      direction : "-",
      ID : "ENSG00000234719.9",
      gene_id : "ENSG00000234719.9",
      gene_type : "protein_coding",
      gene_name : "NPIPB2",
      gene_level : 2,
      hgnc_id : "HGNC:37451",
      havana_gene : "OTTHUMG00000166261.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11965210,
      stop : 11968068,
      direction : "+",
      ID : "ENSG00000048462.11",
      gene_id : "ENSG00000048462.11",
      gene_type : "protein_coding",
      gene_name : "TNFRSF17",
      gene_level : 1,
      hgnc_id : "HGNC:11913",
      havana_gene : "OTTHUMG00000129826.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 11976734,
      stop : 12574287,
      direction : "+",
      ID : "ENSG00000048471.14",
      gene_id : "ENSG00000048471.14",
      gene_type : "protein_coding",
      gene_name : "SNX29",
      gene_level : 1,
      hgnc_id : "HGNC:30542",
      havana_gene : "OTTHUMG00000129827.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 12659799,
      stop : 12803887,
      direction : "-",
      ID : "ENSG00000103381.12",
      gene_id : "ENSG00000103381.12",
      gene_type : "protein_coding",
      gene_name : "CPPED1",
      gene_level : 2,
      hgnc_id : "HGNC:25632",
      havana_gene : "OTTHUMG00000167711.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 12901598,
      stop : 13240416,
      direction : "+",
      ID : "ENSG00000237515.9",
      gene_id : "ENSG00000237515.9",
      gene_type : "protein_coding",
      gene_name : "SHISA9",
      gene_level : 2,
      hgnc_id : "HGNC:37231",
      havana_gene : "OTTHUMG00000154258.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 13920154,
      stop : 13952348,
      direction : "+",
      ID : "ENSG00000175595.15",
      gene_id : "ENSG00000175595.15",
      gene_type : "protein_coding",
      gene_name : "ERCC4",
      gene_level : 2,
      hgnc_id : "HGNC:3436",
      havana_gene : "OTTHUMG00000048194.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14071319,
      stop : 14266773,
      direction : "+",
      ID : "ENSG00000186260.17",
      gene_id : "ENSG00000186260.17",
      gene_type : "protein_coding",
      gene_name : "MRTFB",
      gene_level : 1,
      hgnc_id : "HGNC:29819",
      havana_gene : "OTTHUMG00000177379.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14435700,
      stop : 14632728,
      direction : "-",
      ID : "ENSG00000140694.17",
      gene_id : "ENSG00000140694.17",
      gene_type : "protein_coding",
      gene_name : "PARN",
      gene_level : 2,
      hgnc_id : "HGNC:8609",
      havana_gene : "OTTHUMG00000173199.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14632931,
      stop : 14669236,
      direction : "+",
      ID : "ENSG00000103429.11",
      gene_id : "ENSG00000103429.11",
      gene_type : "protein_coding",
      gene_name : "BFAR",
      gene_level : 1,
      hgnc_id : "HGNC:17613",
      havana_gene : "OTTHUMG00000129848.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14672548,
      stop : 14694308,
      direction : "-",
      ID : "ENSG00000069764.10",
      gene_id : "ENSG00000069764.10",
      gene_type : "protein_coding",
      gene_name : "PLA2G10",
      gene_level : 2,
      hgnc_id : "HGNC:9029",
      havana_gene : "OTTHUMG00000048069.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14708944,
      stop : 14726338,
      direction : "+",
      ID : "ENSG00000224712.12",
      gene_id : "ENSG00000224712.12",
      gene_type : "protein_coding",
      gene_name : "NPIPA3",
      gene_level : 2,
      hgnc_id : "HGNC:41978",
      havana_gene : "OTTHUMG00000166262.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14748066,
      stop : 14765413,
      direction : "+",
      ID : "ENSG00000254852.8",
      gene_id : "ENSG00000254852.8",
      gene_type : "protein_coding",
      gene_name : "NPIPA2",
      gene_level : 2,
      hgnc_id : "HGNC:41979",
      havana_gene : "OTTHUMG00000166264.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14833721,
      stop : 14896157,
      direction : "+",
      ID : "ENSG00000103512.15",
      gene_id : "ENSG00000103512.15",
      gene_type : "protein_coding",
      gene_name : "NOMO1",
      gene_level : 2,
      hgnc_id : "HGNC:30060",
      havana_gene : "OTTHUMG00000090541.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14922802,
      stop : 14952060,
      direction : "+",
      ID : "ENSG00000183426.17",
      gene_id : "ENSG00000183426.17",
      gene_type : "protein_coding",
      gene_name : "NPIPA1",
      gene_level : 2,
      hgnc_id : "HGNC:7909",
      havana_gene : "OTTHUMG00000090663.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 14974591,
      stop : 15139339,
      direction : "+",
      ID : "ENSG00000179889.19",
      gene_id : "ENSG00000179889.19",
      gene_type : "protein_coding",
      gene_name : "PDXDC1",
      gene_level : 1,
      hgnc_id : "HGNC:28995",
      havana_gene : "OTTHUMG00000166304.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15037854,
      stop : 15056079,
      direction : "-",
      ID : "ENSG00000157045.9",
      gene_id : "ENSG00000157045.9",
      gene_type : "protein_coding",
      gene_name : "NTAN1",
      gene_level : 2,
      hgnc_id : "HGNC:29909",
      havana_gene : "OTTHUMG00000129849.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15060033,
      stop : 15094311,
      direction : "-",
      ID : "ENSG00000085721.13",
      gene_id : "ENSG00000085721.13",
      gene_type : "protein_coding",
      gene_name : "RRN3",
      gene_level : 2,
      hgnc_id : "HGNC:30346",
      havana_gene : "OTTHUMG00000129847.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15363628,
      stop : 15381047,
      direction : "-",
      ID : "ENSG00000183793.14",
      gene_id : "ENSG00000183793.14",
      gene_type : "protein_coding",
      gene_name : "NPIPA5",
      gene_level : 2,
      hgnc_id : "HGNC:41980",
      havana_gene : "OTTHUMG00000166305.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15395754,
      stop : 15413271,
      direction : "+",
      ID : "ENSG00000156968.9",
      gene_id : "ENSG00000156968.9",
      gene_type : "protein_coding",
      gene_name : "MPV17L",
      gene_level : 2,
      hgnc_id : "HGNC:26827",
      havana_gene : "OTTHUMG00000129882.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15395754,
      stop : 15515348,
      direction : "+",
      ID : "ENSG00000261130.5",
      gene_id : "ENSG00000261130.5",
      gene_type : "protein_coding",
      gene_name : "AC140504.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000173205.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15434475,
      stop : 15625028,
      direction : "+",
      ID : "ENSG00000166780.11",
      gene_id : "ENSG00000166780.11",
      gene_type : "protein_coding",
      gene_name : "BMERB1",
      gene_level : 1,
      hgnc_id : "HGNC:19213",
      havana_gene : "OTTHUMG00000129883.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15594387,
      stop : 15643154,
      direction : "-",
      ID : "ENSG00000166783.22",
      gene_id : "ENSG00000166783.22",
      gene_type : "protein_coding",
      gene_name : "MARF1",
      gene_level : 1,
      hgnc_id : "HGNC:29562",
      havana_gene : "OTTHUMG00000129884.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15643267,
      stop : 15734691,
      direction : "+",
      ID : "ENSG00000072864.16",
      gene_id : "ENSG00000072864.16",
      gene_type : "protein_coding",
      gene_name : "NDE1",
      gene_level : 1,
      hgnc_id : "HGNC:17619",
      havana_gene : "OTTHUMG00000129885.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15703135,
      stop : 15857028,
      direction : "-",
      ID : "ENSG00000133392.18",
      gene_id : "ENSG00000133392.18",
      gene_type : "protein_coding",
      gene_name : "MYH11",
      gene_level : 1,
      hgnc_id : "HGNC:7569",
      havana_gene : "OTTHUMG00000129935.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15865719,
      stop : 15888625,
      direction : "-",
      ID : "ENSG00000133393.13",
      gene_id : "ENSG00000133393.13",
      gene_type : "protein_coding",
      gene_name : "CEP20",
      gene_level : 2,
      hgnc_id : "HGNC:26435",
      havana_gene : "OTTHUMG00000129923.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 15949138,
      stop : 16143257,
      direction : "+",
      ID : "ENSG00000103222.20",
      gene_id : "ENSG00000103222.20",
      gene_type : "protein_coding",
      gene_name : "ABCC1",
      gene_level : 2,
      hgnc_id : "HGNC:51",
      havana_gene : "OTTHUMG00000048267.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 16149565,
      stop : 16223522,
      direction : "-",
      ID : "ENSG00000091262.16",
      gene_id : "ENSG00000091262.16",
      gene_type : "protein_coding",
      gene_name : "ABCC6",
      gene_level : 2,
      hgnc_id : "HGNC:57",
      havana_gene : "OTTHUMG00000129967.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 16232506,
      stop : 16300806,
      direction : "+",
      ID : "ENSG00000103226.19",
      gene_id : "ENSG00000103226.19",
      gene_type : "protein_coding",
      gene_name : "NOMO3",
      gene_level : 2,
      hgnc_id : "HGNC:25242",
      havana_gene : "OTTHUMG00000177317.23",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 16317444,
      stop : 16350590,
      direction : "+",
      ID : "ENSG00000183889.12",
      gene_id : "ENSG00000183889.12",
      gene_type : "protein_coding",
      gene_name : "AC138969.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000133624.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 16379055,
      stop : 16393954,
      direction : "+",
      ID : "ENSG00000214967.5",
      gene_id : "ENSG00000214967.5",
      gene_type : "protein_coding",
      gene_name : "NPIPA7",
      gene_level : 2,
      hgnc_id : "HGNC:41982",
      havana_gene : "OTTHUMG00000166307.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 17101769,
      stop : 17470960,
      direction : "-",
      ID : "ENSG00000103489.12",
      gene_id : "ENSG00000103489.12",
      gene_type : "protein_coding",
      gene_name : "XYLT1",
      gene_level : 2,
      hgnc_id : "HGNC:15516",
      havana_gene : "OTTHUMG00000129975.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18317942,
      stop : 18336736,
      direction : "-",
      ID : "ENSG00000214940.8",
      gene_id : "ENSG00000214940.8",
      gene_type : "protein_coding",
      gene_name : "NPIPA8",
      gene_level : 2,
      hgnc_id : "HGNC:41983",
      havana_gene : "OTTHUMG00000166284.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18358086,
      stop : 18379331,
      direction : "-",
      ID : "ENSG00000233024.7",
      gene_id : "ENSG00000233024.7",
      gene_type : "protein_coding",
      gene_name : "NPIPA9",
      gene_level : 2,
      hgnc_id : "HGNC:41984",
      havana_gene : "OTTHUMG00000166286.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18417325,
      stop : 18562211,
      direction : "-",
      ID : "ENSG00000185164.14",
      gene_id : "ENSG00000185164.14",
      gene_type : "protein_coding",
      gene_name : "NOMO2",
      gene_level : 2,
      hgnc_id : "HGNC:22652",
      havana_gene : "OTTHUMG00000131366.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18781295,
      stop : 18790383,
      direction : "-",
      ID : "ENSG00000134419.15",
      gene_id : "ENSG00000134419.15",
      gene_type : "protein_coding",
      gene_name : "RPS15A",
      gene_level : 1,
      hgnc_id : "HGNC:10389",
      havana_gene : "OTTHUMG00000131365.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18788063,
      stop : 18801519,
      direction : "-",
      ID : "ENSG00000260342.2",
      gene_id : "ENSG00000260342.2",
      gene_type : "protein_coding",
      gene_name : "AC138811.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177194.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18791669,
      stop : 18801572,
      direction : "-",
      ID : "ENSG00000170540.15",
      gene_id : "ENSG00000170540.15",
      gene_type : "protein_coding",
      gene_name : "ARL6IP1",
      gene_level : 1,
      hgnc_id : "HGNC:697",
      havana_gene : "OTTHUMG00000131367.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18804860,
      stop : 18926408,
      direction : "-",
      ID : "ENSG00000157106.17",
      gene_id : "ENSG00000157106.17",
      gene_type : "protein_coding",
      gene_name : "SMG1",
      gene_level : 2,
      hgnc_id : "HGNC:30045",
      havana_gene : "OTTHUMG00000166900.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 18983934,
      stop : 19063942,
      direction : "+",
      ID : "ENSG00000170537.13",
      gene_id : "ENSG00000170537.13",
      gene_type : "protein_coding",
      gene_name : "TMC7",
      gene_level : 2,
      hgnc_id : "HGNC:23000",
      havana_gene : "OTTHUMG00000131456.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19067614,
      stop : 19080095,
      direction : "+",
      ID : "ENSG00000167186.11",
      gene_id : "ENSG00000167186.11",
      gene_type : "protein_coding",
      gene_name : "COQ7",
      gene_level : 1,
      hgnc_id : "HGNC:2244",
      havana_gene : "OTTHUMG00000131455.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19113932,
      stop : 19121629,
      direction : "+",
      ID : "ENSG00000205730.7",
      gene_id : "ENSG00000205730.7",
      gene_type : "protein_coding",
      gene_name : "ITPRIPL2",
      gene_level : 2,
      hgnc_id : "HGNC:27257",
      havana_gene : "OTTHUMG00000177199.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19167971,
      stop : 19268332,
      direction : "+",
      ID : "ENSG00000103528.17",
      gene_id : "ENSG00000103528.17",
      gene_type : "protein_coding",
      gene_name : "SYT17",
      gene_level : 1,
      hgnc_id : "HGNC:24119",
      havana_gene : "OTTHUMG00000131461.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19285731,
      stop : 19322145,
      direction : "+",
      ID : "ENSG00000261210.8",
      gene_id : "ENSG00000261210.8",
      gene_type : "protein_coding",
      gene_name : "CLEC19A",
      gene_level : 1,
      hgnc_id : "HGNC:34522",
      havana_gene : "OTTHUMG00000177218.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19410496,
      stop : 19499113,
      direction : "+",
      ID : "ENSG00000103534.17",
      gene_id : "ENSG00000103534.17",
      gene_type : "protein_coding",
      gene_name : "TMC5",
      gene_level : 1,
      hgnc_id : "HGNC:22999",
      havana_gene : "OTTHUMG00000131458.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19501693,
      stop : 19522123,
      direction : "-",
      ID : "ENSG00000006007.12",
      gene_id : "ENSG00000006007.12",
      gene_type : "protein_coding",
      gene_name : "GDE1",
      gene_level : 2,
      hgnc_id : "HGNC:29644",
      havana_gene : "OTTHUMG00000131454.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19523811,
      stop : 19553408,
      direction : "+",
      ID : "ENSG00000103540.16",
      gene_id : "ENSG00000103540.16",
      gene_type : "protein_coding",
      gene_name : "CCP110",
      gene_level : 1,
      hgnc_id : "HGNC:24342",
      havana_gene : "OTTHUMG00000131459.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19555240,
      stop : 19706793,
      direction : "+",
      ID : "ENSG00000103544.15",
      gene_id : "ENSG00000103544.15",
      gene_type : "protein_coding",
      gene_name : "VPS35L",
      gene_level : 1,
      hgnc_id : "HGNC:24641",
      havana_gene : "OTTHUMG00000167925.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19701937,
      stop : 19718235,
      direction : "-",
      ID : "ENSG00000103550.14",
      gene_id : "ENSG00000103550.14",
      gene_type : "protein_coding",
      gene_name : "KNOP1",
      gene_level : 2,
      hgnc_id : "HGNC:34404",
      havana_gene : "OTTHUMG00000177249.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19716456,
      stop : 19858467,
      direction : "+",
      ID : "ENSG00000174628.16",
      gene_id : "ENSG00000174628.16",
      gene_type : "protein_coding",
      gene_name : "IQCK",
      gene_level : 2,
      hgnc_id : "HGNC:28556",
      havana_gene : "OTTHUMG00000131453.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 19856691,
      stop : 19886167,
      direction : "-",
      ID : "ENSG00000167191.12",
      gene_id : "ENSG00000167191.12",
      gene_type : "protein_coding",
      gene_name : "GPRC5B",
      gene_level : 2,
      hgnc_id : "HGNC:13308",
      havana_gene : "OTTHUMG00000131460.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20028239,
      stop : 20073890,
      direction : "-",
      ID : "ENSG00000180269.8",
      gene_id : "ENSG00000180269.8",
      gene_type : "protein_coding",
      gene_name : "GPR139",
      gene_level : 2,
      hgnc_id : "HGNC:19995",
      havana_gene : "OTTHUMG00000177690.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20309574,
      stop : 20327808,
      direction : "-",
      ID : "ENSG00000169347.17",
      gene_id : "ENSG00000169347.17",
      gene_type : "protein_coding",
      gene_name : "GP2",
      gene_level : 2,
      hgnc_id : "HGNC:4441",
      havana_gene : "OTTHUMG00000131489.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20333051,
      stop : 20356301,
      direction : "-",
      ID : "ENSG00000169344.16",
      gene_id : "ENSG00000169344.16",
      gene_type : "protein_coding",
      gene_name : "UMOD",
      gene_level : 1,
      hgnc_id : "HGNC:12559",
      havana_gene : "OTTHUMG00000131488.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20359175,
      stop : 20404737,
      direction : "-",
      ID : "ENSG00000169340.10",
      gene_id : "ENSG00000169340.10",
      gene_type : "protein_coding",
      gene_name : "PDILT",
      gene_level : 2,
      hgnc_id : "HGNC:27338",
      havana_gene : "OTTHUMG00000131487.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20409534,
      stop : 20441336,
      direction : "+",
      ID : "ENSG00000183549.10",
      gene_id : "ENSG00000183549.10",
      gene_type : "protein_coding",
      gene_name : "ACSM5",
      gene_level : 2,
      hgnc_id : "HGNC:26060",
      havana_gene : "OTTHUMG00000131551.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20451461,
      stop : 20487669,
      direction : "+",
      ID : "ENSG00000183747.12",
      gene_id : "ENSG00000183747.12",
      gene_type : "protein_coding",
      gene_name : "ACSM2A",
      gene_level : 2,
      hgnc_id : "HGNC:32017",
      havana_gene : "OTTHUMG00000177401.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20536226,
      stop : 20576427,
      direction : "-",
      ID : "ENSG00000066813.14",
      gene_id : "ENSG00000066813.14",
      gene_type : "protein_coding",
      gene_name : "ACSM2B",
      gene_level : 2,
      hgnc_id : "HGNC:30931",
      havana_gene : "OTTHUMG00000131555.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20610243,
      stop : 20797581,
      direction : "+",
      ID : "ENSG00000005187.12",
      gene_id : "ENSG00000005187.12",
      gene_type : "protein_coding",
      gene_name : "ACSM3",
      gene_level : 1,
      hgnc_id : "HGNC:10522",
      havana_gene : "OTTHUMG00000131552.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20623237,
      stop : 20698890,
      direction : "-",
      ID : "ENSG00000166743.9",
      gene_id : "ENSG00000166743.9",
      gene_type : "protein_coding",
      gene_name : "ACSM1",
      gene_level : 2,
      hgnc_id : "HGNC:18049",
      havana_gene : "OTTHUMG00000131550.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20702816,
      stop : 20742084,
      direction : "-",
      ID : "ENSG00000066654.14",
      gene_id : "ENSG00000066654.14",
      gene_type : "protein_coding",
      gene_name : "THUMPD1",
      gene_level : 2,
      hgnc_id : "HGNC:23807",
      havana_gene : "OTTHUMG00000131558.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20780193,
      stop : 20900349,
      direction : "-",
      ID : "ENSG00000196678.14",
      gene_id : "ENSG00000196678.14",
      gene_type : "protein_coding",
      gene_name : "ERI2",
      gene_level : 2,
      hgnc_id : "HGNC:30541",
      havana_gene : "OTTHUMG00000131557.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20806429,
      stop : 20849665,
      direction : "+",
      ID : "ENSG00000005189.20",
      gene_id : "ENSG00000005189.20",
      gene_type : "protein_coding",
      gene_name : "REXO5",
      gene_level : 1,
      hgnc_id : "HGNC:24661",
      havana_gene : "OTTHUMG00000131556.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20854925,
      stop : 20900358,
      direction : "-",
      ID : "ENSG00000188215.10",
      gene_id : "ENSG00000188215.10",
      gene_type : "protein_coding",
      gene_name : "DCUN1D3",
      gene_level : 2,
      hgnc_id : "HGNC:28734",
      havana_gene : "OTTHUMG00000131553.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20899868,
      stop : 20925006,
      direction : "+",
      ID : "ENSG00000102897.10",
      gene_id : "ENSG00000102897.10",
      gene_type : "protein_coding",
      gene_name : "LYRM1",
      gene_level : 1,
      hgnc_id : "HGNC:25074",
      havana_gene : "OTTHUMG00000131554.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 20933111,
      stop : 21159441,
      direction : "-",
      ID : "ENSG00000158486.13",
      gene_id : "ENSG00000158486.13",
      gene_type : "protein_coding",
      gene_name : "DNAH3",
      gene_level : 2,
      hgnc_id : "HGNC:2949",
      havana_gene : "OTTHUMG00000090677.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21158377,
      stop : 21180616,
      direction : "+",
      ID : "ENSG00000011638.11",
      gene_id : "ENSG00000011638.11",
      gene_type : "protein_coding",
      gene_name : "TMEM159",
      gene_level : 1,
      hgnc_id : "HGNC:30136",
      havana_gene : "OTTHUMG00000131559.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21197450,
      stop : 21214510,
      direction : "-",
      ID : "ENSG00000103310.11",
      gene_id : "ENSG00000103310.11",
      gene_type : "protein_coding",
      gene_name : "ZP2",
      gene_level : 2,
      hgnc_id : "HGNC:13188",
      havana_gene : "OTTHUMG00000090681.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21233699,
      stop : 21253850,
      direction : "+",
      ID : "ENSG00000175311.7",
      gene_id : "ENSG00000175311.7",
      gene_type : "protein_coding",
      gene_name : "ANKS4B",
      gene_level : 2,
      hgnc_id : "HGNC:26795",
      havana_gene : "OTTHUMG00000177371.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21238874,
      stop : 21303083,
      direction : "-",
      ID : "ENSG00000103316.12",
      gene_id : "ENSG00000103316.12",
      gene_type : "protein_coding",
      gene_name : "CRYM",
      gene_level : 2,
      hgnc_id : "HGNC:2418",
      havana_gene : "OTTHUMG00000090707.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21402237,
      stop : 21448567,
      direction : "-",
      ID : "ENSG00000169246.16",
      gene_id : "ENSG00000169246.16",
      gene_type : "protein_coding",
      gene_name : "NPIPB3",
      gene_level : 2,
      hgnc_id : "HGNC:28989",
      havana_gene : "OTTHUMG00000163506.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21597218,
      stop : 21657473,
      direction : "+",
      ID : "ENSG00000197006.14",
      gene_id : "ENSG00000197006.14",
      gene_type : "protein_coding",
      gene_name : "METTL9",
      gene_level : 1,
      hgnc_id : "HGNC:24586",
      havana_gene : "OTTHUMG00000131584.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21639550,
      stop : 21652608,
      direction : "-",
      ID : "ENSG00000140749.9",
      gene_id : "ENSG00000140749.9",
      gene_type : "protein_coding",
      gene_name : "IGSF6",
      gene_level : 1,
      hgnc_id : "HGNC:5953",
      havana_gene : "OTTHUMG00000090709.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21663968,
      stop : 21761935,
      direction : "+",
      ID : "ENSG00000155719.18",
      gene_id : "ENSG00000155719.18",
      gene_type : "protein_coding",
      gene_name : "OTOA",
      gene_level : 2,
      hgnc_id : "HGNC:16378",
      havana_gene : "OTTHUMG00000090721.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21834569,
      stop : 21880827,
      direction : "-",
      ID : "ENSG00000185864.16",
      gene_id : "ENSG00000185864.16",
      gene_type : "protein_coding",
      gene_name : "NPIPB4",
      gene_level : 2,
      hgnc_id : "HGNC:41985",
      havana_gene : "OTTHUMG00000163555.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21953288,
      stop : 21983660,
      direction : "+",
      ID : "ENSG00000140740.11",
      gene_id : "ENSG00000140740.11",
      gene_type : "protein_coding",
      gene_name : "UQCRC2",
      gene_level : 1,
      hgnc_id : "HGNC:12586",
      havana_gene : "OTTHUMG00000131585.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 21983865,
      stop : 22001116,
      direction : "-",
      ID : "ENSG00000155714.14",
      gene_id : "ENSG00000155714.14",
      gene_type : "protein_coding",
      gene_name : "PDZD9",
      gene_level : 2,
      hgnc_id : "HGNC:28740",
      havana_gene : "OTTHUMG00000131586.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22007638,
      stop : 22087534,
      direction : "+",
      ID : "ENSG00000185716.12",
      gene_id : "ENSG00000185716.12",
      gene_type : "protein_coding",
      gene_name : "MOSMO",
      gene_level : 2,
      hgnc_id : "HGNC:27087",
      havana_gene : "OTTHUMG00000131587.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22092538,
      stop : 22156964,
      direction : "+",
      ID : "ENSG00000175267.15",
      gene_id : "ENSG00000175267.15",
      gene_type : "protein_coding",
      gene_name : "VWA3A",
      gene_level : 2,
      hgnc_id : "HGNC:27088",
      havana_gene : "OTTHUMG00000175461.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22165583,
      stop : 22191754,
      direction : "+",
      ID : "ENSG00000183921.7",
      gene_id : "ENSG00000183921.7",
      gene_type : "protein_coding",
      gene_name : "SDR42E2",
      gene_level : 1,
      hgnc_id : "HGNC:35414",
      havana_gene : "OTTHUMG00000183976.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22206278,
      stop : 22288738,
      direction : "+",
      ID : "ENSG00000103319.12",
      gene_id : "ENSG00000103319.12",
      gene_type : "protein_coding",
      gene_name : "EEF2K",
      gene_level : 2,
      hgnc_id : "HGNC:24615",
      havana_gene : "OTTHUMG00000094771.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22297375,
      stop : 22335101,
      direction : "+",
      ID : "ENSG00000058600.16",
      gene_id : "ENSG00000058600.16",
      gene_type : "protein_coding",
      gene_name : "POLR3E",
      gene_level : 2,
      hgnc_id : "HGNC:30347",
      havana_gene : "OTTHUMG00000094779.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22345936,
      stop : 22437165,
      direction : "-",
      ID : "ENSG00000140743.8",
      gene_id : "ENSG00000140743.8",
      gene_type : "protein_coding",
      gene_name : "CDR2",
      gene_level : 2,
      hgnc_id : "HGNC:1799",
      havana_gene : "OTTHUMG00000175463.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22479121,
      stop : 22536521,
      direction : "+",
      ID : "ENSG00000243716.10",
      gene_id : "ENSG00000243716.10",
      gene_type : "protein_coding",
      gene_name : "NPIPB5",
      gene_level : 2,
      hgnc_id : "HGNC:37233",
      havana_gene : "OTTHUMG00000163573.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 22814162,
      stop : 22916338,
      direction : "+",
      ID : "ENSG00000122254.7",
      gene_id : "ENSG00000122254.7",
      gene_type : "protein_coding",
      gene_name : "HS3ST2",
      gene_level : 2,
      hgnc_id : "HGNC:5195",
      havana_gene : "OTTHUMG00000094785.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23061406,
      stop : 23149270,
      direction : "-",
      ID : "ENSG00000103404.14",
      gene_id : "ENSG00000103404.14",
      gene_type : "protein_coding",
      gene_name : "USP31",
      gene_level : 1,
      hgnc_id : "HGNC:20060",
      havana_gene : "OTTHUMG00000094793.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23182745,
      stop : 23216883,
      direction : "+",
      ID : "ENSG00000166828.3",
      gene_id : "ENSG00000166828.3",
      gene_type : "protein_coding",
      gene_name : "SCNN1G",
      gene_level : 2,
      hgnc_id : "HGNC:10602",
      havana_gene : "OTTHUMG00000131609.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23278231,
      stop : 23381294,
      direction : "+",
      ID : "ENSG00000168447.11",
      gene_id : "ENSG00000168447.11",
      gene_type : "protein_coding",
      gene_name : "SCNN1B",
      gene_level : 1,
      hgnc_id : "HGNC:10600",
      havana_gene : "OTTHUMG00000131608.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23388493,
      stop : 23453189,
      direction : "-",
      ID : "ENSG00000168434.13",
      gene_id : "ENSG00000168434.13",
      gene_type : "protein_coding",
      gene_name : "COG7",
      gene_level : 2,
      hgnc_id : "HGNC:18622",
      havana_gene : "OTTHUMG00000094807.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23463542,
      stop : 23521995,
      direction : "-",
      ID : "ENSG00000103365.15",
      gene_id : "ENSG00000103365.15",
      gene_type : "protein_coding",
      gene_name : "GGA2",
      gene_level : 1,
      hgnc_id : "HGNC:16064",
      havana_gene : "OTTHUMG00000096957.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23520754,
      stop : 23557731,
      direction : "-",
      ID : "ENSG00000103356.18",
      gene_id : "ENSG00000103356.18",
      gene_type : "protein_coding",
      gene_name : "EARS2",
      gene_level : 1,
      hgnc_id : "HGNC:29419",
      havana_gene : "OTTHUMG00000177018.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23557721,
      stop : 23574389,
      direction : "+",
      ID : "ENSG00000103353.16",
      gene_id : "ENSG00000103353.16",
      gene_type : "protein_coding",
      gene_name : "UBFD1",
      gene_level : 1,
      hgnc_id : "HGNC:30565",
      havana_gene : "OTTHUMG00000128855.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23581014,
      stop : 23596316,
      direction : "-",
      ID : "ENSG00000004779.10",
      gene_id : "ENSG00000004779.10",
      gene_type : "protein_coding",
      gene_name : "NDUFAB1",
      gene_level : 1,
      hgnc_id : "HGNC:7694",
      havana_gene : "OTTHUMG00000096985.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23603160,
      stop : 23641310,
      direction : "-",
      ID : "ENSG00000083093.10",
      gene_id : "ENSG00000083093.10",
      gene_type : "protein_coding",
      gene_name : "PALB2",
      gene_level : 1,
      hgnc_id : "HGNC:26144",
      havana_gene : "OTTHUMG00000177097.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23641466,
      stop : 23677472,
      direction : "+",
      ID : "ENSG00000166847.10",
      gene_id : "ENSG00000166847.10",
      gene_type : "protein_coding",
      gene_name : "DCTN5",
      gene_level : 1,
      hgnc_id : "HGNC:24594",
      havana_gene : "OTTHUMG00000131610.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23677656,
      stop : 23690367,
      direction : "+",
      ID : "ENSG00000166851.15",
      gene_id : "ENSG00000166851.15",
      gene_type : "protein_coding",
      gene_name : "PLK1",
      gene_level : 2,
      hgnc_id : "HGNC:9077",
      havana_gene : "OTTHUMG00000096984.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23690310,
      stop : 23713226,
      direction : "-",
      ID : "ENSG00000134398.15",
      gene_id : "ENSG00000134398.15",
      gene_type : "protein_coding",
      gene_name : "ERN2",
      gene_level : 1,
      hgnc_id : "HGNC:16942",
      havana_gene : "OTTHUMG00000177020.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23755026,
      stop : 23758935,
      direction : "+",
      ID : "ENSG00000166869.3",
      gene_id : "ENSG00000166869.3",
      gene_type : "protein_coding",
      gene_name : "CHP2",
      gene_level : 2,
      hgnc_id : "HGNC:24927",
      havana_gene : "OTTHUMG00000131611.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 23835983,
      stop : 24220611,
      direction : "+",
      ID : "ENSG00000166501.14",
      gene_id : "ENSG00000166501.14",
      gene_type : "protein_coding",
      gene_name : "PRKCB",
      gene_level : 1,
      hgnc_id : "HGNC:9395",
      havana_gene : "OTTHUMG00000131615.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 24256335,
      stop : 24362412,
      direction : "+",
      ID : "ENSG00000006116.4",
      gene_id : "ENSG00000006116.4",
      gene_type : "protein_coding",
      gene_name : "CACNG3",
      gene_level : 2,
      hgnc_id : "HGNC:1407",
      havana_gene : "OTTHUMG00000131651.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 24537693,
      stop : 24572863,
      direction : "+",
      ID : "ENSG00000122257.20",
      gene_id : "ENSG00000122257.20",
      gene_type : "protein_coding",
      gene_name : "RBBP6",
      gene_level : 2,
      hgnc_id : "HGNC:9889",
      havana_gene : "OTTHUMG00000096991.11",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 24610209,
      stop : 24827632,
      direction : "+",
      ID : "ENSG00000090905.19",
      gene_id : "ENSG00000090905.19",
      gene_type : "protein_coding",
      gene_name : "TNRC6A",
      gene_level : 1,
      hgnc_id : "HGNC:11969",
      havana_gene : "OTTHUMG00000096999.12",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 24845841,
      stop : 24911628,
      direction : "+",
      ID : "ENSG00000158865.12",
      gene_id : "ENSG00000158865.12",
      gene_type : "protein_coding",
      gene_name : "SLC5A11",
      gene_level : 2,
      hgnc_id : "HGNC:23091",
      havana_gene : "OTTHUMG00000097003.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 24919389,
      stop : 25015666,
      direction : "-",
      ID : "ENSG00000140750.17",
      gene_id : "ENSG00000140750.17",
      gene_type : "protein_coding",
      gene_name : "ARHGAP17",
      gene_level : 2,
      hgnc_id : "HGNC:18239",
      havana_gene : "OTTHUMG00000177372.11",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 25111731,
      stop : 25178231,
      direction : "+",
      ID : "ENSG00000205629.12",
      gene_id : "ENSG00000205629.12",
      gene_type : "protein_coding",
      gene_name : "LCMT1",
      gene_level : 1,
      hgnc_id : "HGNC:17557",
      havana_gene : "OTTHUMG00000177182.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 25215731,
      stop : 25228932,
      direction : "+",
      ID : "ENSG00000103375.11",
      gene_id : "ENSG00000103375.11",
      gene_type : "protein_coding",
      gene_name : "AQP8",
      gene_level : 2,
      hgnc_id : "HGNC:642",
      havana_gene : "OTTHUMG00000097013.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 25236001,
      stop : 25257845,
      direction : "-",
      ID : "ENSG00000155592.16",
      gene_id : "ENSG00000155592.16",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN2",
      gene_level : 2,
      hgnc_id : "HGNC:25677",
      havana_gene : "OTTHUMG00000177180.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 25691959,
      stop : 26137685,
      direction : "+",
      ID : "ENSG00000182601.7",
      gene_id : "ENSG00000182601.7",
      gene_type : "protein_coding",
      gene_name : "HS3ST4",
      gene_level : 2,
      hgnc_id : "HGNC:5200",
      havana_gene : "OTTHUMG00000059978.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27066927,
      stop : 27069166,
      direction : "+",
      ID : "ENSG00000234186.5",
      gene_id : "ENSG00000234186.5",
      gene_type : "protein_coding",
      gene_name : "C16orf82",
      gene_level : 2,
      hgnc_id : "HGNC:30755",
      havana_gene : "OTTHUMG00000161986.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27203508,
      stop : 27221768,
      direction : "+",
      ID : "ENSG00000155666.12",
      gene_id : "ENSG00000155666.12",
      gene_type : "protein_coding",
      gene_name : "KDM8",
      gene_level : 1,
      hgnc_id : "HGNC:25840",
      havana_gene : "OTTHUMG00000131677.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27224994,
      stop : 27268772,
      direction : "-",
      ID : "ENSG00000169189.17",
      gene_id : "ENSG00000169189.17",
      gene_type : "protein_coding",
      gene_name : "NSMCE1",
      gene_level : 1,
      hgnc_id : "HGNC:29897",
      havana_gene : "OTTHUMG00000131674.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27313668,
      stop : 27364778,
      direction : "+",
      ID : "ENSG00000077238.14",
      gene_id : "ENSG00000077238.14",
      gene_type : "protein_coding",
      gene_name : "IL4R",
      gene_level : 1,
      hgnc_id : "HGNC:6015",
      havana_gene : "OTTHUMG00000097015.12",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27402174,
      stop : 27452042,
      direction : "+",
      ID : "ENSG00000103522.16",
      gene_id : "ENSG00000103522.16",
      gene_type : "protein_coding",
      gene_name : "IL21R",
      gene_level : 2,
      hgnc_id : "HGNC:6006",
      havana_gene : "OTTHUMG00000131675.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27459555,
      stop : 27549913,
      direction : "-",
      ID : "ENSG00000077235.18",
      gene_id : "ENSG00000077235.18",
      gene_type : "protein_coding",
      gene_name : "GTF3C1",
      gene_level : 1,
      hgnc_id : "HGNC:4664",
      havana_gene : "OTTHUMG00000176805.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27550133,
      stop : 27780369,
      direction : "+",
      ID : "ENSG00000047578.13",
      gene_id : "ENSG00000047578.13",
      gene_type : "protein_coding",
      gene_name : "KATNIP",
      gene_level : 2,
      hgnc_id : "HGNC:29068",
      havana_gene : "OTTHUMG00000176780.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 27787528,
      stop : 28063714,
      direction : "-",
      ID : "ENSG00000169181.13",
      gene_id : "ENSG00000169181.13",
      gene_type : "protein_coding",
      gene_name : "GSG1L",
      gene_level : 2,
      hgnc_id : "HGNC:28283",
      havana_gene : "OTTHUMG00000131676.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28097976,
      stop : 28211965,
      direction : "-",
      ID : "ENSG00000169180.12",
      gene_id : "ENSG00000169180.12",
      gene_type : "protein_coding",
      gene_name : "XPO6",
      gene_level : 1,
      hgnc_id : "HGNC:19733",
      havana_gene : "OTTHUMG00000176782.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28259246,
      stop : 28323849,
      direction : "+",
      ID : "ENSG00000188322.8",
      gene_id : "ENSG00000188322.8",
      gene_type : "protein_coding",
      gene_name : "SBK1",
      gene_level : 1,
      hgnc_id : "HGNC:17699",
      havana_gene : "OTTHUMG00000166066.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28342555,
      stop : 28363508,
      direction : "-",
      ID : "ENSG00000198156.10",
      gene_id : "ENSG00000198156.10",
      gene_type : "protein_coding",
      gene_name : "NPIPB6",
      gene_level : 2,
      hgnc_id : "HGNC:37454",
      havana_gene : "OTTHUMG00000166319.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28379579,
      stop : 28403841,
      direction : "-",
      ID : "ENSG00000205609.13",
      gene_id : "ENSG00000205609.13",
      gene_type : "protein_coding",
      gene_name : "EIF3CL",
      gene_level : 2,
      hgnc_id : "HGNC:26347",
      havana_gene : "OTTHUMG00000097025.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28456371,
      stop : 28492098,
      direction : "-",
      ID : "ENSG00000261832.6",
      gene_id : "ENSG00000261832.6",
      gene_type : "protein_coding",
      gene_name : "AC138894.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000175737.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28456372,
      stop : 28471175,
      direction : "-",
      ID : "ENSG00000233232.7",
      gene_id : "ENSG00000233232.7",
      gene_type : "protein_coding",
      gene_name : "NPIPB7",
      gene_level : 2,
      hgnc_id : "HGNC:33832",
      havana_gene : "OTTHUMG00000156915.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28474111,
      stop : 28495575,
      direction : "-",
      ID : "ENSG00000188603.22",
      gene_id : "ENSG00000188603.22",
      gene_type : "protein_coding",
      gene_name : "CLN3",
      gene_level : 2,
      hgnc_id : "HGNC:2074",
      havana_gene : "OTTHUMG00000097024.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28494643,
      stop : 28498970,
      direction : "+",
      ID : "ENSG00000184730.11",
      gene_id : "ENSG00000184730.11",
      gene_type : "protein_coding",
      gene_name : "APOBR",
      gene_level : 2,
      hgnc_id : "HGNC:24087",
      havana_gene : "OTTHUMG00000172705.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28499362,
      stop : 28512051,
      direction : "-",
      ID : "ENSG00000197272.2",
      gene_id : "ENSG00000197272.2",
      gene_type : "protein_coding",
      gene_name : "IL27",
      gene_level : 1,
      hgnc_id : "HGNC:19157",
      havana_gene : "OTTHUMG00000097023.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28532708,
      stop : 28539008,
      direction : "-",
      ID : "ENSG00000176046.9",
      gene_id : "ENSG00000176046.9",
      gene_type : "protein_coding",
      gene_name : "NUPR1",
      gene_level : 1,
      hgnc_id : "HGNC:29990",
      havana_gene : "OTTHUMG00000131764.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28537040,
      stop : 28623555,
      direction : "-",
      ID : "ENSG00000288656.1",
      gene_id : "ENSG00000288656.1",
      gene_type : "protein_coding",
      gene_name : "AC020765.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28553915,
      stop : 28591790,
      direction : "+",
      ID : "ENSG00000176476.9",
      gene_id : "ENSG00000176476.9",
      gene_type : "protein_coding",
      gene_name : "SGF29",
      gene_level : 2,
      hgnc_id : "HGNC:25156",
      havana_gene : "OTTHUMG00000131763.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28591943,
      stop : 28597050,
      direction : "-",
      ID : "ENSG00000197165.11",
      gene_id : "ENSG00000197165.11",
      gene_type : "protein_coding",
      gene_name : "SULT1A2",
      gene_level : 1,
      hgnc_id : "HGNC:11454",
      havana_gene : "OTTHUMG00000048082.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28603944,
      stop : 28623625,
      direction : "-",
      ID : "ENSG00000196502.12",
      gene_id : "ENSG00000196502.12",
      gene_type : "protein_coding",
      gene_name : "SULT1A1",
      gene_level : 2,
      hgnc_id : "HGNC:11453",
      havana_gene : "OTTHUMG00000131765.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28637654,
      stop : 28658682,
      direction : "+",
      ID : "ENSG00000255524.7",
      gene_id : "ENSG00000255524.7",
      gene_type : "protein_coding",
      gene_name : "NPIPB8",
      gene_level : 1,
      hgnc_id : "HGNC:37490",
      havana_gene : "OTTHUMG00000166386.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28688558,
      stop : 28735727,
      direction : "+",
      ID : "ENSG00000184110.15",
      gene_id : "ENSG00000184110.15",
      gene_type : "protein_coding",
      gene_name : "EIF3C",
      gene_level : 2,
      hgnc_id : "HGNC:3279",
      havana_gene : "OTTHUMG00000099443.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28751787,
      stop : 28772807,
      direction : "+",
      ID : "ENSG00000196993.8",
      gene_id : "ENSG00000196993.8",
      gene_type : "protein_coding",
      gene_name : "NPIPB9",
      gene_level : 2,
      hgnc_id : "HGNC:41987",
      havana_gene : "OTTHUMG00000170452.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28823035,
      stop : 28837237,
      direction : "+",
      ID : "ENSG00000168488.18",
      gene_id : "ENSG00000168488.18",
      gene_type : "protein_coding",
      gene_name : "ATXN2L",
      gene_level : 1,
      hgnc_id : "HGNC:31326",
      havana_gene : "OTTHUMG00000097038.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28842411,
      stop : 28846348,
      direction : "-",
      ID : "ENSG00000178952.11",
      gene_id : "ENSG00000178952.11",
      gene_type : "protein_coding",
      gene_name : "TUFM",
      gene_level : 2,
      hgnc_id : "HGNC:12420",
      havana_gene : "OTTHUMG00000097039.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28846600,
      stop : 28874212,
      direction : "+",
      ID : "ENSG00000178188.14",
      gene_id : "ENSG00000178188.14",
      gene_type : "protein_coding",
      gene_name : "SH2B1",
      gene_level : 1,
      hgnc_id : "HGNC:30417",
      havana_gene : "OTTHUMG00000176590.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28878405,
      stop : 28904466,
      direction : "+",
      ID : "ENSG00000196296.14",
      gene_id : "ENSG00000196296.14",
      gene_type : "protein_coding",
      gene_name : "ATP2A1",
      gene_level : 2,
      hgnc_id : "HGNC:811",
      havana_gene : "OTTHUMG00000131760.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28904421,
      stop : 28936526,
      direction : "-",
      ID : "ENSG00000177548.13",
      gene_id : "ENSG00000177548.13",
      gene_type : "protein_coding",
      gene_name : "RABEP2",
      gene_level : 1,
      hgnc_id : "HGNC:24817",
      havana_gene : "OTTHUMG00000176593.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28931965,
      stop : 28939342,
      direction : "+",
      ID : "ENSG00000177455.15",
      gene_id : "ENSG00000177455.15",
      gene_type : "protein_coding",
      gene_name : "CD19",
      gene_level : 2,
      hgnc_id : "HGNC:1633",
      havana_gene : "OTTHUMG00000097049.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28950807,
      stop : 28967097,
      direction : "+",
      ID : "ENSG00000176953.12",
      gene_id : "ENSG00000176953.12",
      gene_type : "protein_coding",
      gene_name : "NFATC2IP",
      gene_level : 2,
      hgnc_id : "HGNC:25906",
      havana_gene : "OTTHUMG00000097763.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28974221,
      stop : 28984548,
      direction : "+",
      ID : "ENSG00000169682.18",
      gene_id : "ENSG00000169682.18",
      gene_type : "protein_coding",
      gene_name : "SPNS1",
      gene_level : 1,
      hgnc_id : "HGNC:30621",
      havana_gene : "OTTHUMG00000131762.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 28984826,
      stop : 28990784,
      direction : "+",
      ID : "ENSG00000213658.12",
      gene_id : "ENSG00000213658.12",
      gene_type : "protein_coding",
      gene_name : "LAT",
      gene_level : 1,
      hgnc_id : "HGNC:18874",
      havana_gene : "OTTHUMG00000131761.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29381354,
      stop : 29404029,
      direction : "-",
      ID : "ENSG00000254206.5",
      gene_id : "ENSG00000254206.5",
      gene_type : "protein_coding",
      gene_name : "NPIPB11",
      gene_level : 2,
      hgnc_id : "HGNC:37453",
      havana_gene : "OTTHUMG00000170467.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29443056,
      stop : 29454964,
      direction : "-",
      ID : "ENSG00000183336.8",
      gene_id : "ENSG00000183336.8",
      gene_type : "protein_coding",
      gene_name : "BOLA2",
      gene_level : 2,
      hgnc_id : "HGNC:29488",
      havana_gene : "OTTHUMG00000176757.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29443230,
      stop : 29454651,
      direction : "-",
      ID : "ENSG00000261740.6",
      gene_id : "ENSG00000261740.6",
      gene_type : "protein_coding",
      gene_name : "BOLA2-SMG1P6",
      gene_level : 2,
      hgnc_id : "HGNC:53563",
      havana_gene : "OTTHUMG00000176715.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29454501,
      stop : 29458219,
      direction : "+",
      ID : "ENSG00000181625.17",
      gene_id : "ENSG00000181625.17",
      gene_type : "protein_coding",
      gene_name : "SLX1B",
      gene_level : 2,
      hgnc_id : "HGNC:28748",
      havana_gene : "OTTHUMG00000132110.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29459913,
      stop : 29464966,
      direction : "+",
      ID : "ENSG00000213648.11",
      gene_id : "ENSG00000213648.11",
      gene_type : "protein_coding",
      gene_name : "SULT1A4",
      gene_level : 2,
      hgnc_id : "HGNC:30004",
      havana_gene : "OTTHUMG00000170468.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29483642,
      stop : 29505999,
      direction : "-",
      ID : "ENSG00000169203.16",
      gene_id : "ENSG00000169203.16",
      gene_type : "protein_coding",
      gene_name : "NPIPB12",
      gene_level : 2,
      hgnc_id : "HGNC:37491",
      havana_gene : "OTTHUMG00000163547.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29662979,
      stop : 29670876,
      direction : "+",
      ID : "ENSG00000197471.12",
      gene_id : "ENSG00000197471.12",
      gene_type : "protein_coding",
      gene_name : "SPN",
      gene_level : 2,
      hgnc_id : "HGNC:11249",
      havana_gene : "OTTHUMG00000097765.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29663279,
      stop : 29698699,
      direction : "+",
      ID : "ENSG00000103485.19",
      gene_id : "ENSG00000103485.19",
      gene_type : "protein_coding",
      gene_name : "QPRT",
      gene_level : 1,
      hgnc_id : "HGNC:9755",
      havana_gene : "OTTHUMG00000097770.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29742463,
      stop : 29745990,
      direction : "-",
      ID : "ENSG00000185905.4",
      gene_id : "ENSG00000185905.4",
      gene_type : "protein_coding",
      gene_name : "C16orf54",
      gene_level : 2,
      hgnc_id : "HGNC:26649",
      havana_gene : "OTTHUMG00000132116.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29778256,
      stop : 29782973,
      direction : "+",
      ID : "ENSG00000174992.8",
      gene_id : "ENSG00000174992.8",
      gene_type : "protein_coding",
      gene_name : "ZG16",
      gene_level : 2,
      hgnc_id : "HGNC:30961",
      havana_gene : "OTTHUMG00000177139.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29790719,
      stop : 29805384,
      direction : "+",
      ID : "ENSG00000079616.13",
      gene_id : "ENSG00000079616.13",
      gene_type : "protein_coding",
      gene_name : "KIF22",
      gene_level : 1,
      hgnc_id : "HGNC:6391",
      havana_gene : "OTTHUMG00000097771.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29806106,
      stop : 29811164,
      direction : "+",
      ID : "ENSG00000103495.14",
      gene_id : "ENSG00000103495.14",
      gene_type : "protein_coding",
      gene_name : "MAZ",
      gene_level : 2,
      hgnc_id : "HGNC:6914",
      havana_gene : "OTTHUMG00000190393.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29811382,
      stop : 29815892,
      direction : "+",
      ID : "ENSG00000167371.21",
      gene_id : "ENSG00000167371.21",
      gene_type : "protein_coding",
      gene_name : "PRRT2",
      gene_level : 2,
      hgnc_id : "HGNC:30500",
      havana_gene : "OTTHUMG00000177142.66",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29812261,
      stop : 29820092,
      direction : "+",
      ID : "ENSG00000280893.1",
      gene_id : "ENSG00000280893.1",
      gene_type : "protein_coding",
      gene_name : "AC009133.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189724.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29816152,
      stop : 29822489,
      direction : "+",
      ID : "ENSG00000280789.2",
      gene_id : "ENSG00000280789.2",
      gene_type : "protein_coding",
      gene_name : "PAGR1",
      gene_level : 2,
      hgnc_id : "HGNC:28707",
      havana_gene : "OTTHUMG00000177143.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29817239,
      stop : 29830627,
      direction : "+",
      ID : "ENSG00000281348.1",
      gene_id : "ENSG00000281348.1",
      gene_type : "protein_coding",
      gene_name : "AC120114.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178205.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29820394,
      stop : 29848039,
      direction : "+",
      ID : "ENSG00000013364.19",
      gene_id : "ENSG00000013364.19",
      gene_type : "protein_coding",
      gene_name : "MVP",
      gene_level : 2,
      hgnc_id : "HGNC:7531",
      havana_gene : "OTTHUMG00000048227.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29858357,
      stop : 29863414,
      direction : "-",
      ID : "ENSG00000103502.14",
      gene_id : "ENSG00000103502.14",
      gene_type : "protein_coding",
      gene_name : "CDIPT",
      gene_level : 1,
      hgnc_id : "HGNC:1769",
      havana_gene : "OTTHUMG00000177144.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29871159,
      stop : 29899547,
      direction : "-",
      ID : "ENSG00000174938.14",
      gene_id : "ENSG00000174938.14",
      gene_type : "protein_coding",
      gene_name : "SEZ6L2",
      gene_level : 1,
      hgnc_id : "HGNC:30844",
      havana_gene : "OTTHUMG00000132112.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29900375,
      stop : 29919864,
      direction : "+",
      ID : "ENSG00000174939.11",
      gene_id : "ENSG00000174939.11",
      gene_type : "protein_coding",
      gene_name : "ASPHD1",
      gene_level : 1,
      hgnc_id : "HGNC:27380",
      havana_gene : "OTTHUMG00000132121.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29905012,
      stop : 29926236,
      direction : "-",
      ID : "ENSG00000174943.11",
      gene_id : "ENSG00000174943.11",
      gene_type : "protein_coding",
      gene_name : "KCTD13",
      gene_level : 1,
      hgnc_id : "HGNC:22234",
      havana_gene : "OTTHUMG00000132120.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29940885,
      stop : 29973050,
      direction : "+",
      ID : "ENSG00000149932.17",
      gene_id : "ENSG00000149932.17",
      gene_type : "protein_coding",
      gene_name : "TMEM219",
      gene_level : 1,
      hgnc_id : "HGNC:25201",
      havana_gene : "OTTHUMG00000177105.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29973868,
      stop : 29992261,
      direction : "+",
      ID : "ENSG00000149930.18",
      gene_id : "ENSG00000149930.18",
      gene_type : "protein_coding",
      gene_name : "TAOK2",
      gene_level : 2,
      hgnc_id : "HGNC:16835",
      havana_gene : "OTTHUMG00000132111.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29992330,
      stop : 29996074,
      direction : "-",
      ID : "ENSG00000149929.16",
      gene_id : "ENSG00000149929.16",
      gene_type : "protein_coding",
      gene_name : "HIRIP3",
      gene_level : 1,
      hgnc_id : "HGNC:4917",
      havana_gene : "OTTHUMG00000132118.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 29995715,
      stop : 30005793,
      direction : "+",
      ID : "ENSG00000169592.15",
      gene_id : "ENSG00000169592.15",
      gene_type : "protein_coding",
      gene_name : "INO80E",
      gene_level : 2,
      hgnc_id : "HGNC:26905",
      havana_gene : "OTTHUMG00000132114.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30005514,
      stop : 30023270,
      direction : "-",
      ID : "ENSG00000149927.18",
      gene_id : "ENSG00000149927.18",
      gene_type : "protein_coding",
      gene_name : "DOC2A",
      gene_level : 2,
      hgnc_id : "HGNC:2985",
      havana_gene : "OTTHUMG00000132109.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30023198,
      stop : 30027736,
      direction : "+",
      ID : "ENSG00000167194.8",
      gene_id : "ENSG00000167194.8",
      gene_type : "protein_coding",
      gene_name : "C16orf92",
      gene_level : 2,
      hgnc_id : "HGNC:26346",
      havana_gene : "OTTHUMG00000177107.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30024427,
      stop : 30052978,
      direction : "-",
      ID : "ENSG00000149926.13",
      gene_id : "ENSG00000149926.13",
      gene_type : "protein_coding",
      gene_name : "TLCD3B",
      gene_level : 1,
      hgnc_id : "HGNC:25295",
      havana_gene : "OTTHUMG00000132105.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30053090,
      stop : 30070420,
      direction : "+",
      ID : "ENSG00000285043.2",
      gene_id : "ENSG00000285043.2",
      gene_type : "protein_coding",
      gene_name : "AC093512.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192461.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30064164,
      stop : 30070457,
      direction : "+",
      ID : "ENSG00000149925.22",
      gene_id : "ENSG00000149925.22",
      gene_type : "protein_coding",
      gene_name : "ALDOA",
      gene_level : 1,
      hgnc_id : "HGNC:414",
      havana_gene : "OTTHUMG00000132107.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30075978,
      stop : 30085376,
      direction : "+",
      ID : "ENSG00000149923.14",
      gene_id : "ENSG00000149923.14",
      gene_type : "protein_coding",
      gene_name : "PPP4C",
      gene_level : 2,
      hgnc_id : "HGNC:9319",
      havana_gene : "OTTHUMG00000132113.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30085793,
      stop : 30091924,
      direction : "-",
      ID : "ENSG00000149922.11",
      gene_id : "ENSG00000149922.11",
      gene_type : "protein_coding",
      gene_name : "TBX6",
      gene_level : 2,
      hgnc_id : "HGNC:11605",
      havana_gene : "OTTHUMG00000132115.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30092314,
      stop : 30096915,
      direction : "-",
      ID : "ENSG00000090238.12",
      gene_id : "ENSG00000090238.12",
      gene_type : "protein_coding",
      gene_name : "YPEL3",
      gene_level : 2,
      hgnc_id : "HGNC:18327",
      havana_gene : "OTTHUMG00000176853.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30104810,
      stop : 30113537,
      direction : "-",
      ID : "ENSG00000102886.15",
      gene_id : "ENSG00000102886.15",
      gene_type : "protein_coding",
      gene_name : "GDPD3",
      gene_level : 2,
      hgnc_id : "HGNC:28638",
      havana_gene : "OTTHUMG00000132106.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30114105,
      stop : 30123506,
      direction : "-",
      ID : "ENSG00000102882.12",
      gene_id : "ENSG00000102882.12",
      gene_type : "protein_coding",
      gene_name : "MAPK3",
      gene_level : 1,
      hgnc_id : "HGNC:6877",
      havana_gene : "OTTHUMG00000132149.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30182827,
      stop : 30189076,
      direction : "+",
      ID : "ENSG00000102879.16",
      gene_id : "ENSG00000102879.16",
      gene_type : "protein_coding",
      gene_name : "CORO1A",
      gene_level : 1,
      hgnc_id : "HGNC:2252",
      havana_gene : "OTTHUMG00000132148.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30192932,
      stop : 30194306,
      direction : "-",
      ID : "ENSG00000169627.9",
      gene_id : "ENSG00000169627.9",
      gene_type : "protein_coding",
      gene_name : "BOLA2B",
      gene_level : 2,
      hgnc_id : "HGNC:32479",
      havana_gene : "OTTHUMG00000176858.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30193875,
      stop : 30197561,
      direction : "+",
      ID : "ENSG00000132207.18",
      gene_id : "ENSG00000132207.18",
      gene_type : "protein_coding",
      gene_name : "SLX1A",
      gene_level : 2,
      hgnc_id : "HGNC:20922",
      havana_gene : "OTTHUMG00000176859.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30199228,
      stop : 30204310,
      direction : "+",
      ID : "ENSG00000261052.6",
      gene_id : "ENSG00000261052.6",
      gene_type : "protein_coding",
      gene_name : "SULT1A3",
      gene_level : 2,
      hgnc_id : "HGNC:11455",
      havana_gene : "OTTHUMG00000048083.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30222937,
      stop : 30254510,
      direction : "-",
      ID : "ENSG00000198064.13",
      gene_id : "ENSG00000198064.13",
      gene_type : "protein_coding",
      gene_name : "NPIPB13",
      gene_level : 2,
      hgnc_id : "HGNC:41989",
      havana_gene : "OTTHUMG00000163556.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30350773,
      stop : 30355308,
      direction : "-",
      ID : "ENSG00000169217.9",
      gene_id : "ENSG00000169217.9",
      gene_type : "protein_coding",
      gene_name : "CD2BP2",
      gene_level : 2,
      hgnc_id : "HGNC:1656",
      havana_gene : "OTTHUMG00000132397.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30357102,
      stop : 30370494,
      direction : "-",
      ID : "ENSG00000169221.14",
      gene_id : "ENSG00000169221.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D10B",
      gene_level : 2,
      hgnc_id : "HGNC:24510",
      havana_gene : "OTTHUMG00000132396.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30370934,
      stop : 30377991,
      direction : "+",
      ID : "ENSG00000180209.12",
      gene_id : "ENSG00000180209.12",
      gene_type : "protein_coding",
      gene_name : "MYLPF",
      gene_level : 2,
      hgnc_id : "HGNC:29824",
      havana_gene : "OTTHUMG00000132399.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30378106,
      stop : 30400108,
      direction : "+",
      ID : "ENSG00000180035.13",
      gene_id : "ENSG00000180035.13",
      gene_type : "protein_coding",
      gene_name : "ZNF48",
      gene_level : 2,
      hgnc_id : "HGNC:13114",
      havana_gene : "OTTHUMG00000048195.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30378133,
      stop : 30395991,
      direction : "-",
      ID : "ENSG00000180096.12",
      gene_id : "ENSG00000180096.12",
      gene_type : "protein_coding",
      gene_name : "SEPTIN1",
      gene_level : 2,
      hgnc_id : "HGNC:2879",
      havana_gene : "OTTHUMG00000176984.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30407414,
      stop : 30431108,
      direction : "+",
      ID : "ENSG00000179965.12",
      gene_id : "ENSG00000179965.12",
      gene_type : "protein_coding",
      gene_name : "ZNF771",
      gene_level : 1,
      hgnc_id : "HGNC:29653",
      havana_gene : "OTTHUMG00000176985.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30423615,
      stop : 30430030,
      direction : "-",
      ID : "ENSG00000179958.10",
      gene_id : "ENSG00000179958.10",
      gene_type : "protein_coding",
      gene_name : "DCTPP1",
      gene_level : 1,
      hgnc_id : "HGNC:28777",
      havana_gene : "OTTHUMG00000132416.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30443631,
      stop : 30445874,
      direction : "-",
      ID : "ENSG00000179918.19",
      gene_id : "ENSG00000179918.19",
      gene_type : "protein_coding",
      gene_name : "SEPHS2",
      gene_level : 2,
      hgnc_id : "HGNC:19686",
      havana_gene : "OTTHUMG00000176988.12",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30472658,
      stop : 30523567,
      direction : "+",
      ID : "ENSG00000005844.19",
      gene_id : "ENSG00000005844.19",
      gene_type : "protein_coding",
      gene_name : "ITGAL",
      gene_level : 1,
      hgnc_id : "HGNC:6148",
      havana_gene : "OTTHUMG00000176964.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30524004,
      stop : 30526821,
      direction : "-",
      ID : "ENSG00000169957.10",
      gene_id : "ENSG00000169957.10",
      gene_type : "protein_coding",
      gene_name : "ZNF768",
      gene_level : 2,
      hgnc_id : "HGNC:26273",
      havana_gene : "OTTHUMG00000132392.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30525923,
      stop : 30534852,
      direction : "-",
      ID : "ENSG00000261459.1",
      gene_id : "ENSG00000261459.1",
      gene_type : "protein_coding",
      gene_name : "AC002310.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176944.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30530367,
      stop : 30535347,
      direction : "-",
      ID : "ENSG00000169955.7",
      gene_id : "ENSG00000169955.7",
      gene_type : "protein_coding",
      gene_name : "ZNF747",
      gene_level : 2,
      hgnc_id : "HGNC:28350",
      havana_gene : "OTTHUMG00000132401.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30553764,
      stop : 30558374,
      direction : "-",
      ID : "ENSG00000169951.10",
      gene_id : "ENSG00000169951.10",
      gene_type : "protein_coding",
      gene_name : "ZNF764",
      gene_level : 2,
      hgnc_id : "HGNC:28200",
      havana_gene : "OTTHUMG00000132406.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30569672,
      stop : 30572734,
      direction : "-",
      ID : "ENSG00000229809.9",
      gene_id : "ENSG00000229809.9",
      gene_type : "protein_coding",
      gene_name : "ZNF688",
      gene_level : 2,
      hgnc_id : "HGNC:30489",
      havana_gene : "OTTHUMG00000132408.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30573740,
      stop : 30585769,
      direction : "-",
      ID : "ENSG00000197162.10",
      gene_id : "ENSG00000197162.10",
      gene_type : "protein_coding",
      gene_name : "ZNF785",
      gene_level : 2,
      hgnc_id : "HGNC:26496",
      havana_gene : "OTTHUMG00000176950.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30602558,
      stop : 30624012,
      direction : "-",
      ID : "ENSG00000156853.13",
      gene_id : "ENSG00000156853.13",
      gene_type : "protein_coding",
      gene_name : "ZNF689",
      gene_level : 2,
      hgnc_id : "HGNC:25173",
      havana_gene : "OTTHUMG00000132415.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30650717,
      stop : 30656413,
      direction : "+",
      ID : "ENSG00000156858.12",
      gene_id : "ENSG00000156858.12",
      gene_type : "protein_coding",
      gene_name : "PRR14",
      gene_level : 1,
      hgnc_id : "HGNC:28458",
      havana_gene : "OTTHUMG00000132414.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30658431,
      stop : 30670810,
      direction : "+",
      ID : "ENSG00000156860.16",
      gene_id : "ENSG00000156860.16",
      gene_type : "protein_coding",
      gene_name : "FBRS",
      gene_level : 2,
      hgnc_id : "HGNC:20442",
      havana_gene : "OTTHUMG00000132390.12",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30698209,
      stop : 30741409,
      direction : "+",
      ID : "ENSG00000080603.17",
      gene_id : "ENSG00000080603.17",
      gene_type : "protein_coding",
      gene_name : "SRCAP",
      gene_level : 2,
      hgnc_id : "HGNC:16974",
      havana_gene : "OTTHUMG00000132393.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30704067,
      stop : 30745169,
      direction : "+",
      ID : "ENSG00000282034.1",
      gene_id : "ENSG00000282034.1",
      gene_type : "protein_coding",
      gene_name : "AC106886.5",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000191413.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30740642,
      stop : 30745196,
      direction : "+",
      ID : "ENSG00000281991.2",
      gene_id : "ENSG00000281991.2",
      gene_type : "protein_coding",
      gene_name : "TMEM265",
      gene_level : 2,
      hgnc_id : "HGNC:51241",
      havana_gene : "OTTHUMG00000191414.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30748293,
      stop : 30761176,
      direction : "+",
      ID : "ENSG00000156873.16",
      gene_id : "ENSG00000156873.16",
      gene_type : "protein_coding",
      gene_name : "PHKG2",
      gene_level : 1,
      hgnc_id : "HGNC:8931",
      havana_gene : "OTTHUMG00000132400.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30757423,
      stop : 30762221,
      direction : "-",
      ID : "ENSG00000196118.12",
      gene_id : "ENSG00000196118.12",
      gene_type : "protein_coding",
      gene_name : "CCDC189",
      gene_level : 2,
      hgnc_id : "HGNC:28078",
      havana_gene : "OTTHUMG00000167926.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30761745,
      stop : 30776307,
      direction : "+",
      ID : "ENSG00000103549.22",
      gene_id : "ENSG00000103549.22",
      gene_type : "protein_coding",
      gene_name : "RNF40",
      gene_level : 1,
      hgnc_id : "HGNC:16867",
      havana_gene : "OTTHUMG00000132394.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30778456,
      stop : 30787205,
      direction : "-",
      ID : "ENSG00000102870.6",
      gene_id : "ENSG00000102870.6",
      gene_type : "protein_coding",
      gene_name : "ZNF629",
      gene_level : 2,
      hgnc_id : "HGNC:29008",
      havana_gene : "OTTHUMG00000176905.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30833626,
      stop : 30894302,
      direction : "-",
      ID : "ENSG00000099385.12",
      gene_id : "ENSG00000099385.12",
      gene_type : "protein_coding",
      gene_name : "BCL7C",
      gene_level : 2,
      hgnc_id : "HGNC:1006",
      havana_gene : "OTTHUMG00000177719.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30896614,
      stop : 30903547,
      direction : "+",
      ID : "ENSG00000150281.7",
      gene_id : "ENSG00000150281.7",
      gene_type : "protein_coding",
      gene_name : "CTF1",
      gene_level : 2,
      hgnc_id : "HGNC:2499",
      havana_gene : "OTTHUMG00000132413.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30923055,
      stop : 30948783,
      direction : "+",
      ID : "ENSG00000099364.18",
      gene_id : "ENSG00000099364.18",
      gene_type : "protein_coding",
      gene_name : "FBXL19",
      gene_level : 1,
      hgnc_id : "HGNC:25300",
      havana_gene : "OTTHUMG00000132403.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30949068,
      stop : 30956461,
      direction : "+",
      ID : "ENSG00000175938.7",
      gene_id : "ENSG00000175938.7",
      gene_type : "protein_coding",
      gene_name : "ORAI3",
      gene_level : 1,
      hgnc_id : "HGNC:28185",
      havana_gene : "OTTHUMG00000176768.50",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30957754,
      stop : 30984664,
      direction : "+",
      ID : "ENSG00000099381.18",
      gene_id : "ENSG00000099381.18",
      gene_type : "protein_coding",
      gene_name : "SETD1A",
      gene_level : 2,
      hgnc_id : "HGNC:29010",
      havana_gene : "OTTHUMG00000150474.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30985207,
      stop : 30989147,
      direction : "+",
      ID : "ENSG00000099377.14",
      gene_id : "ENSG00000099377.14",
      gene_type : "protein_coding",
      gene_name : "HSD3B7",
      gene_level : 2,
      hgnc_id : "HGNC:18324",
      havana_gene : "OTTHUMG00000132417.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 30989256,
      stop : 31010638,
      direction : "-",
      ID : "ENSG00000099365.11",
      gene_id : "ENSG00000099365.11",
      gene_type : "protein_coding",
      gene_name : "STX1B",
      gene_level : 2,
      hgnc_id : "HGNC:18539",
      havana_gene : "OTTHUMG00000132391.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31032889,
      stop : 31042975,
      direction : "+",
      ID : "ENSG00000103496.15",
      gene_id : "ENSG00000103496.15",
      gene_type : "protein_coding",
      gene_name : "STX4",
      gene_level : 1,
      hgnc_id : "HGNC:11439",
      havana_gene : "OTTHUMG00000132404.13",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31060843,
      stop : 31074240,
      direction : "-",
      ID : "ENSG00000167394.13",
      gene_id : "ENSG00000167394.13",
      gene_type : "protein_coding",
      gene_name : "ZNF668",
      gene_level : 2,
      hgnc_id : "HGNC:25821",
      havana_gene : "OTTHUMG00000047357.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31074422,
      stop : 31084196,
      direction : "+",
      ID : "ENSG00000167395.10",
      gene_id : "ENSG00000167395.10",
      gene_type : "protein_coding",
      gene_name : "ZNF646",
      gene_level : 2,
      hgnc_id : "HGNC:29004",
      havana_gene : "OTTHUMG00000047355.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31083425,
      stop : 31089628,
      direction : "-",
      ID : "ENSG00000151006.7",
      gene_id : "ENSG00000151006.7",
      gene_type : "protein_coding",
      gene_name : "PRSS53",
      gene_level : 2,
      hgnc_id : "HGNC:34407",
      havana_gene : "OTTHUMG00000047358.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31083439,
      stop : 31094956,
      direction : "-",
      ID : "ENSG00000255439.6",
      gene_id : "ENSG00000255439.6",
      gene_type : "protein_coding",
      gene_name : "AC135050.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000166077.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31090842,
      stop : 31095980,
      direction : "-",
      ID : "ENSG00000167397.15",
      gene_id : "ENSG00000167397.15",
      gene_type : "protein_coding",
      gene_name : "VKORC1",
      gene_level : 1,
      hgnc_id : "HGNC:23663",
      havana_gene : "OTTHUMG00000047408.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31106107,
      stop : 31112791,
      direction : "+",
      ID : "ENSG00000103507.14",
      gene_id : "ENSG00000103507.14",
      gene_type : "protein_coding",
      gene_name : "BCKDK",
      gene_level : 1,
      hgnc_id : "HGNC:16902",
      havana_gene : "OTTHUMG00000047356.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31114489,
      stop : 31131393,
      direction : "+",
      ID : "ENSG00000103510.20",
      gene_id : "ENSG00000103510.20",
      gene_type : "protein_coding",
      gene_name : "KAT8",
      gene_level : 1,
      hgnc_id : "HGNC:17933",
      havana_gene : "OTTHUMG00000132410.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31131433,
      stop : 31135727,
      direction : "-",
      ID : "ENSG00000052344.16",
      gene_id : "ENSG00000052344.16",
      gene_type : "protein_coding",
      gene_name : "PRSS8",
      gene_level : 1,
      hgnc_id : "HGNC:9491",
      havana_gene : "OTTHUMG00000176750.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31138926,
      stop : 31150083,
      direction : "-",
      ID : "ENSG00000178226.11",
      gene_id : "ENSG00000178226.11",
      gene_type : "protein_coding",
      gene_name : "PRSS36",
      gene_level : 2,
      hgnc_id : "HGNC:26906",
      havana_gene : "OTTHUMG00000176751.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31180138,
      stop : 31191605,
      direction : "+",
      ID : "ENSG00000089280.19",
      gene_id : "ENSG00000089280.19",
      gene_type : "protein_coding",
      gene_name : "FUS",
      gene_level : 2,
      hgnc_id : "HGNC:4010",
      havana_gene : "OTTHUMG00000132395.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31201486,
      stop : 31203450,
      direction : "-",
      ID : "ENSG00000103490.14",
      gene_id : "ENSG00000103490.14",
      gene_type : "protein_coding",
      gene_name : "PYCARD",
      gene_level : 2,
      hgnc_id : "HGNC:16608",
      havana_gene : "OTTHUMG00000176753.33",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31214091,
      stop : 31231537,
      direction : "+",
      ID : "ENSG00000177238.14",
      gene_id : "ENSG00000177238.14",
      gene_type : "protein_coding",
      gene_name : "TRIM72",
      gene_level : 2,
      hgnc_id : "HGNC:32671",
      havana_gene : "OTTHUMG00000176754.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31215962,
      stop : 31217135,
      direction : "-",
      ID : "ENSG00000169900.8",
      gene_id : "ENSG00000169900.8",
      gene_type : "protein_coding",
      gene_name : "PYDC1",
      gene_level : 2,
      hgnc_id : "HGNC:30261",
      havana_gene : "OTTHUMG00000132407.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31259967,
      stop : 31332892,
      direction : "+",
      ID : "ENSG00000169896.18",
      gene_id : "ENSG00000169896.18",
      gene_type : "protein_coding",
      gene_name : "ITGAM",
      gene_level : 1,
      hgnc_id : "HGNC:6149",
      havana_gene : "OTTHUMG00000176612.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31355134,
      stop : 31382999,
      direction : "+",
      ID : "ENSG00000140678.17",
      gene_id : "ENSG00000140678.17",
      gene_type : "protein_coding",
      gene_name : "ITGAX",
      gene_level : 2,
      hgnc_id : "HGNC:6152",
      havana_gene : "OTTHUMG00000132465.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31393335,
      stop : 31426505,
      direction : "+",
      ID : "ENSG00000156886.12",
      gene_id : "ENSG00000156886.12",
      gene_type : "protein_coding",
      gene_name : "ITGAD",
      gene_level : 2,
      hgnc_id : "HGNC:6146",
      havana_gene : "OTTHUMG00000176614.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31427731,
      stop : 31428360,
      direction : "-",
      ID : "ENSG00000156885.6",
      gene_id : "ENSG00000156885.6",
      gene_type : "protein_coding",
      gene_name : "COX6A2",
      gene_level : 2,
      hgnc_id : "HGNC:2279",
      havana_gene : "OTTHUMG00000132463.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31432593,
      stop : 31443160,
      direction : "-",
      ID : "ENSG00000176723.10",
      gene_id : "ENSG00000176723.10",
      gene_type : "protein_coding",
      gene_name : "ZNF843",
      gene_level : 2,
      hgnc_id : "HGNC:28710",
      havana_gene : "OTTHUMG00000176616.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31458080,
      stop : 31467166,
      direction : "+",
      ID : "ENSG00000140691.18",
      gene_id : "ENSG00000140691.18",
      gene_type : "protein_coding",
      gene_name : "ARMC5",
      gene_level : 1,
      hgnc_id : "HGNC:25781",
      havana_gene : "OTTHUMG00000176618.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31471585,
      stop : 31477960,
      direction : "+",
      ID : "ENSG00000140682.19",
      gene_id : "ENSG00000140682.19",
      gene_type : "protein_coding",
      gene_name : "TGFB1I1",
      gene_level : 2,
      hgnc_id : "HGNC:11767",
      havana_gene : "OTTHUMG00000132467.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31483002,
      stop : 31490860,
      direction : "+",
      ID : "ENSG00000140675.13",
      gene_id : "ENSG00000140675.13",
      gene_type : "protein_coding",
      gene_name : "SLC5A2",
      gene_level : 2,
      hgnc_id : "HGNC:11037",
      havana_gene : "OTTHUMG00000176620.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31489471,
      stop : 31509309,
      direction : "-",
      ID : "ENSG00000140688.17",
      gene_id : "ENSG00000140688.17",
      gene_type : "protein_coding",
      gene_name : "RUSF1",
      gene_level : 1,
      hgnc_id : "HGNC:25848",
      havana_gene : "OTTHUMG00000132466.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31527900,
      stop : 31528803,
      direction : "+",
      ID : "ENSG00000169877.10",
      gene_id : "ENSG00000169877.10",
      gene_type : "protein_coding",
      gene_name : "AHSP",
      gene_level : 2,
      hgnc_id : "HGNC:18075",
      havana_gene : "OTTHUMG00000132461.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31713229,
      stop : 31794869,
      direction : "+",
      ID : "ENSG00000197302.10",
      gene_id : "ENSG00000197302.10",
      gene_type : "protein_coding",
      gene_name : "ZNF720",
      gene_level : 2,
      hgnc_id : "HGNC:26987",
      havana_gene : "OTTHUMG00000167515.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 31873807,
      stop : 31917357,
      direction : "+",
      ID : "ENSG00000185947.15",
      gene_id : "ENSG00000185947.15",
      gene_type : "protein_coding",
      gene_name : "ZNF267",
      gene_level : 2,
      hgnc_id : "HGNC:13060",
      havana_gene : "OTTHUMG00000176535.18",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 32252719,
      stop : 32255922,
      direction : "+",
      ID : "ENSG00000205456.11",
      gene_id : "ENSG00000205456.11",
      gene_type : "protein_coding",
      gene_name : "TP53TG3D",
      gene_level : 1,
      hgnc_id : "HGNC:44657",
      havana_gene : "OTTHUMG00000132469.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 32673528,
      stop : 32676732,
      direction : "-",
      ID : "ENSG00000183632.14",
      gene_id : "ENSG00000183632.14",
      gene_type : "protein_coding",
      gene_name : "TP53TG3",
      gene_level : 2,
      hgnc_id : "HGNC:30759",
      havana_gene : "OTTHUMG00000176507.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 33193659,
      stop : 33196858,
      direction : "+",
      ID : "ENSG00000205457.11",
      gene_id : "ENSG00000205457.11",
      gene_type : "protein_coding",
      gene_name : "TP53TG3C",
      gene_level : 2,
      hgnc_id : "HGNC:42962",
      havana_gene : "OTTHUMG00000176458.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 33303739,
      stop : 33306935,
      direction : "+",
      ID : "ENSG00000275034.2",
      gene_id : "ENSG00000275034.2",
      gene_type : "protein_coding",
      gene_name : "TP53TG3E",
      gene_level : 2,
      hgnc_id : "HGNC:51816",
      havana_gene : "OTTHUMG00000189337.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 33360274,
      stop : 33363478,
      direction : "+",
      ID : "ENSG00000261509.6",
      gene_id : "ENSG00000261509.6",
      gene_type : "protein_coding",
      gene_name : "TP53TG3B",
      gene_level : 2,
      hgnc_id : "HGNC:37202",
      havana_gene : "OTTHUMG00000176461.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 33459045,
      stop : 33462249,
      direction : "+",
      ID : "ENSG00000278848.2",
      gene_id : "ENSG00000278848.2",
      gene_type : "protein_coding",
      gene_name : "TP53TG3F",
      gene_level : 2,
      hgnc_id : "HGNC:51817",
      havana_gene : "OTTHUMG00000189349.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 33844784,
      stop : 33845229,
      direction : "-",
      ID : "ENSG00000259680.5",
      gene_id : "ENSG00000259680.5",
      gene_type : "protein_coding",
      gene_name : "IGHV3OR16-17",
      gene_level : 2,
      hgnc_id : "HGNC:55105",
      havana_gene : "OTTHUMG00000176363.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46578591,
      stop : 46621379,
      direction : "-",
      ID : "ENSG00000171241.9",
      gene_id : "ENSG00000171241.9",
      gene_type : "protein_coding",
      gene_name : "SHCBP1",
      gene_level : 1,
      hgnc_id : "HGNC:29547",
      havana_gene : "OTTHUMG00000132540.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46656132,
      stop : 46689518,
      direction : "-",
      ID : "ENSG00000069329.18",
      gene_id : "ENSG00000069329.18",
      gene_type : "protein_coding",
      gene_name : "VPS35",
      gene_level : 1,
      hgnc_id : "HGNC:13487",
      havana_gene : "OTTHUMG00000132542.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46689643,
      stop : 46698394,
      direction : "+",
      ID : "ENSG00000091651.9",
      gene_id : "ENSG00000091651.9",
      gene_type : "protein_coding",
      gene_name : "ORC6",
      gene_level : 2,
      hgnc_id : "HGNC:17151",
      havana_gene : "OTTHUMG00000132539.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46702282,
      stop : 46790407,
      direction : "-",
      ID : "ENSG00000140795.13",
      gene_id : "ENSG00000140795.13",
      gene_type : "protein_coding",
      gene_name : "MYLK3",
      gene_level : 1,
      hgnc_id : "HGNC:29826",
      havana_gene : "OTTHUMG00000132543.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46796603,
      stop : 46831180,
      direction : "-",
      ID : "ENSG00000155330.10",
      gene_id : "ENSG00000155330.10",
      gene_type : "protein_coding",
      gene_name : "C16orf87",
      gene_level : 1,
      hgnc_id : "HGNC:33754",
      havana_gene : "OTTHUMG00000132538.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46884362,
      stop : 46931289,
      direction : "+",
      ID : "ENSG00000166123.14",
      gene_id : "ENSG00000166123.14",
      gene_type : "protein_coding",
      gene_name : "GPT2",
      gene_level : 2,
      hgnc_id : "HGNC:18062",
      havana_gene : "OTTHUMG00000132541.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 46955362,
      stop : 46973674,
      direction : "-",
      ID : "ENSG00000069345.12",
      gene_id : "ENSG00000069345.12",
      gene_type : "protein_coding",
      gene_name : "DNAJA2",
      gene_level : 2,
      hgnc_id : "HGNC:14884",
      havana_gene : "OTTHUMG00000133104.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 47077703,
      stop : 47143945,
      direction : "-",
      ID : "ENSG00000171208.10",
      gene_id : "ENSG00000171208.10",
      gene_type : "protein_coding",
      gene_name : "NETO2",
      gene_level : 1,
      hgnc_id : "HGNC:14644",
      havana_gene : "OTTHUMG00000133101.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 47154387,
      stop : 47464149,
      direction : "-",
      ID : "ENSG00000129636.13",
      gene_id : "ENSG00000129636.13",
      gene_type : "protein_coding",
      gene_name : "ITFG1",
      gene_level : 1,
      hgnc_id : "HGNC:30697",
      havana_gene : "OTTHUMG00000133103.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 47461123,
      stop : 47701523,
      direction : "+",
      ID : "ENSG00000102893.16",
      gene_id : "ENSG00000102893.16",
      gene_type : "protein_coding",
      gene_name : "PHKB",
      gene_level : 1,
      hgnc_id : "HGNC:8927",
      havana_gene : "OTTHUMG00000133102.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 48081006,
      stop : 48156018,
      direction : "-",
      ID : "ENSG00000140798.16",
      gene_id : "ENSG00000140798.16",
      gene_type : "protein_coding",
      gene_name : "ABCC12",
      gene_level : 2,
      hgnc_id : "HGNC:14640",
      havana_gene : "OTTHUMG00000133143.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 48165773,
      stop : 48247568,
      direction : "-",
      ID : "ENSG00000121270.16",
      gene_id : "ENSG00000121270.16",
      gene_type : "protein_coding",
      gene_name : "ABCC11",
      gene_level : 2,
      hgnc_id : "HGNC:14639",
      havana_gene : "OTTHUMG00000133146.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 48244300,
      stop : 48363122,
      direction : "+",
      ID : "ENSG00000102910.14",
      gene_id : "ENSG00000102910.14",
      gene_type : "protein_coding",
      gene_name : "LONP2",
      gene_level : 1,
      hgnc_id : "HGNC:20598",
      havana_gene : "OTTHUMG00000133144.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 48356364,
      stop : 48448402,
      direction : "-",
      ID : "ENSG00000196470.12",
      gene_id : "ENSG00000196470.12",
      gene_type : "protein_coding",
      gene_name : "SIAH1",
      gene_level : 1,
      hgnc_id : "HGNC:10857",
      havana_gene : "OTTHUMG00000175417.16",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 48538726,
      stop : 48620148,
      direction : "-",
      ID : "ENSG00000102921.8",
      gene_id : "ENSG00000102921.8",
      gene_type : "protein_coding",
      gene_name : "N4BP1",
      gene_level : 2,
      hgnc_id : "HGNC:29850",
      havana_gene : "OTTHUMG00000175421.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 49277917,
      stop : 49281838,
      direction : "-",
      ID : "ENSG00000102924.12",
      gene_id : "ENSG00000102924.12",
      gene_type : "protein_coding",
      gene_name : "CBLN1",
      gene_level : 2,
      hgnc_id : "HGNC:1543",
      havana_gene : "OTTHUMG00000133148.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 49373804,
      stop : 49399431,
      direction : "+",
      ID : "ENSG00000166152.4",
      gene_id : "ENSG00000166152.4",
      gene_type : "protein_coding",
      gene_name : "C16orf78",
      gene_level : 2,
      hgnc_id : "HGNC:28479",
      havana_gene : "OTTHUMG00000133149.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 49487524,
      stop : 49857919,
      direction : "-",
      ID : "ENSG00000102935.12",
      gene_id : "ENSG00000102935.12",
      gene_type : "protein_coding",
      gene_name : "ZNF423",
      gene_level : 2,
      hgnc_id : "HGNC:16762",
      havana_gene : "OTTHUMG00000173491.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50024410,
      stop : 50037088,
      direction : "+",
      ID : "ENSG00000205423.12",
      gene_id : "ENSG00000205423.12",
      gene_type : "protein_coding",
      gene_name : "CNEP1R1",
      gene_level : 2,
      hgnc_id : "HGNC:26759",
      havana_gene : "OTTHUMG00000173447.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50065970,
      stop : 50107272,
      direction : "+",
      ID : "ENSG00000155393.13",
      gene_id : "ENSG00000155393.13",
      gene_type : "protein_coding",
      gene_name : "HEATR3",
      gene_level : 2,
      hgnc_id : "HGNC:26087",
      havana_gene : "OTTHUMG00000133174.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50152911,
      stop : 50235310,
      direction : "+",
      ID : "ENSG00000121274.14",
      gene_id : "ENSG00000121274.14",
      gene_type : "protein_coding",
      gene_name : "TENT4B",
      gene_level : 1,
      hgnc_id : "HGNC:30758",
      havana_gene : "OTTHUMG00000173452.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50246137,
      stop : 50318135,
      direction : "+",
      ID : "ENSG00000121281.13",
      gene_id : "ENSG00000121281.13",
      gene_type : "protein_coding",
      gene_name : "ADCY7",
      gene_level : 2,
      hgnc_id : "HGNC:238",
      havana_gene : "OTTHUMG00000133172.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50313487,
      stop : 50368988,
      direction : "-",
      ID : "ENSG00000166164.16",
      gene_id : "ENSG00000166164.16",
      gene_type : "protein_coding",
      gene_name : "BRD7",
      gene_level : 2,
      hgnc_id : "HGNC:14310",
      havana_gene : "OTTHUMG00000133170.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50548396,
      stop : 50649249,
      direction : "+",
      ID : "ENSG00000140807.7",
      gene_id : "ENSG00000140807.7",
      gene_type : "protein_coding",
      gene_name : "NKD1",
      gene_level : 2,
      hgnc_id : "HGNC:17045",
      havana_gene : "OTTHUMG00000133169.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50666300,
      stop : 50681353,
      direction : "-",
      ID : "ENSG00000167208.15",
      gene_id : "ENSG00000167208.15",
      gene_type : "protein_coding",
      gene_name : "SNX20",
      gene_level : 2,
      hgnc_id : "HGNC:30390",
      havana_gene : "OTTHUMG00000133173.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50693588,
      stop : 50734041,
      direction : "+",
      ID : "ENSG00000167207.14",
      gene_id : "ENSG00000167207.14",
      gene_type : "protein_coding",
      gene_name : "NOD2",
      gene_level : 2,
      hgnc_id : "HGNC:5331",
      havana_gene : "OTTHUMG00000133171.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 50742050,
      stop : 50801935,
      direction : "+",
      ID : "ENSG00000083799.18",
      gene_id : "ENSG00000083799.18",
      gene_type : "protein_coding",
      gene_name : "CYLD",
      gene_level : 1,
      hgnc_id : "HGNC:2584",
      havana_gene : "OTTHUMG00000173404.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 51135975,
      stop : 51151367,
      direction : "-",
      ID : "ENSG00000103449.12",
      gene_id : "ENSG00000103449.12",
      gene_type : "protein_coding",
      gene_name : "SALL1",
      gene_level : 1,
      hgnc_id : "HGNC:10524",
      havana_gene : "OTTHUMG00000133176.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 51553436,
      stop : 51647132,
      direction : "+",
      ID : "ENSG00000224578.5",
      gene_id : "ENSG00000224578.5",
      gene_type : "protein_coding",
      gene_name : "HNRNPA1P48",
      gene_level : 2,
      hgnc_id : "HGNC:48778",
      havana_gene : "OTTHUMG00000173250.2",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 52436417,
      stop : 52547802,
      direction : "-",
      ID : "ENSG00000103460.17",
      gene_id : "ENSG00000103460.17",
      gene_type : "protein_coding",
      gene_name : "TOX3",
      gene_level : 2,
      hgnc_id : "HGNC:11972",
      havana_gene : "OTTHUMG00000173222.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53035690,
      stop : 53052873,
      direction : "-",
      ID : "ENSG00000277639.2",
      gene_id : "ENSG00000277639.2",
      gene_type : "protein_coding",
      gene_name : "AC007906.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000173186.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53055033,
      stop : 53329150,
      direction : "+",
      ID : "ENSG00000177200.17",
      gene_id : "ENSG00000177200.17",
      gene_type : "protein_coding",
      gene_name : "CHD9",
      gene_level : 1,
      hgnc_id : "HGNC:25701",
      havana_gene : "OTTHUMG00000173188.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53433977,
      stop : 53491648,
      direction : "+",
      ID : "ENSG00000103479.17",
      gene_id : "ENSG00000103479.17",
      gene_type : "protein_coding",
      gene_name : "RBL2",
      gene_level : 1,
      hgnc_id : "HGNC:9894",
      havana_gene : "OTTHUMG00000133198.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53491040,
      stop : 53504411,
      direction : "-",
      ID : "ENSG00000166971.17",
      gene_id : "ENSG00000166971.17",
      gene_type : "protein_coding",
      gene_name : "AKTIP",
      gene_level : 1,
      hgnc_id : "HGNC:16710",
      havana_gene : "OTTHUMG00000133199.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53598153,
      stop : 53703938,
      direction : "-",
      ID : "ENSG00000103494.16",
      gene_id : "ENSG00000103494.16",
      gene_type : "protein_coding",
      gene_name : "RPGRIP1L",
      gene_level : 1,
      hgnc_id : "HGNC:29168",
      havana_gene : "OTTHUMG00000173125.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 53701692,
      stop : 54158512,
      direction : "+",
      ID : "ENSG00000140718.21",
      gene_id : "ENSG00000140718.21",
      gene_type : "protein_coding",
      gene_name : "FTO",
      gene_level : 2,
      hgnc_id : "HGNC:24678",
      havana_gene : "OTTHUMG00000158780.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 54283304,
      stop : 54286787,
      direction : "-",
      ID : "ENSG00000177508.12",
      gene_id : "ENSG00000177508.12",
      gene_type : "protein_coding",
      gene_name : "IRX3",
      gene_level : 2,
      hgnc_id : "HGNC:14360",
      havana_gene : "OTTHUMG00000133200.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 54930865,
      stop : 54934485,
      direction : "+",
      ID : "ENSG00000176842.15",
      gene_id : "ENSG00000176842.15",
      gene_type : "protein_coding",
      gene_name : "IRX5",
      gene_level : 1,
      hgnc_id : "HGNC:14361",
      havana_gene : "OTTHUMG00000133201.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55324203,
      stop : 55330756,
      direction : "+",
      ID : "ENSG00000159387.8",
      gene_id : "ENSG00000159387.8",
      gene_type : "protein_coding",
      gene_name : "IRX6",
      gene_level : 2,
      hgnc_id : "HGNC:14675",
      havana_gene : "OTTHUMG00000172239.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55389700,
      stop : 55506691,
      direction : "+",
      ID : "ENSG00000087245.13",
      gene_id : "ENSG00000087245.13",
      gene_type : "protein_coding",
      gene_name : "MMP2",
      gene_level : 1,
      hgnc_id : "HGNC:7166",
      havana_gene : "OTTHUMG00000133202.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55509072,
      stop : 55586666,
      direction : "+",
      ID : "ENSG00000087253.13",
      gene_id : "ENSG00000087253.13",
      gene_type : "protein_coding",
      gene_name : "LPCAT2",
      gene_level : 2,
      hgnc_id : "HGNC:26032",
      havana_gene : "OTTHUMG00000133238.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55566684,
      stop : 55567687,
      direction : "+",
      ID : "ENSG00000256812.2",
      gene_id : "ENSG00000256812.2",
      gene_type : "protein_coding",
      gene_name : "CAPNS2",
      gene_level : 2,
      hgnc_id : "HGNC:16371",
      havana_gene : "OTTHUMG00000167812.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55655604,
      stop : 55706192,
      direction : "+",
      ID : "ENSG00000103546.18",
      gene_id : "ENSG00000103546.18",
      gene_type : "protein_coding",
      gene_name : "SLC6A2",
      gene_level : 2,
      hgnc_id : "HGNC:11048",
      havana_gene : "OTTHUMG00000133208.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55802851,
      stop : 55833337,
      direction : "-",
      ID : "ENSG00000198848.13",
      gene_id : "ENSG00000198848.13",
      gene_type : "protein_coding",
      gene_name : "CES1",
      gene_level : 1,
      hgnc_id : "HGNC:1863",
      havana_gene : "OTTHUMG00000176718.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 55846154,
      stop : 55956031,
      direction : "-",
      ID : "ENSG00000159398.16",
      gene_id : "ENSG00000159398.16",
      gene_type : "protein_coding",
      gene_name : "CES5A",
      gene_level : 2,
      hgnc_id : "HGNC:26459",
      havana_gene : "OTTHUMG00000133236.12",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56191390,
      stop : 56357444,
      direction : "+",
      ID : "ENSG00000087258.16",
      gene_id : "ENSG00000087258.16",
      gene_type : "protein_coding",
      gene_name : "GNAO1",
      gene_level : 1,
      hgnc_id : "HGNC:4389",
      havana_gene : "OTTHUMG00000133241.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56361452,
      stop : 56425545,
      direction : "-",
      ID : "ENSG00000159461.15",
      gene_id : "ENSG00000159461.15",
      gene_type : "protein_coding",
      gene_name : "AMFR",
      gene_level : 2,
      hgnc_id : "HGNC:463",
      havana_gene : "OTTHUMG00000133239.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56429133,
      stop : 56452199,
      direction : "-",
      ID : "ENSG00000167005.14",
      gene_id : "ENSG00000167005.14",
      gene_type : "protein_coding",
      gene_name : "NUDT21",
      gene_level : 1,
      hgnc_id : "HGNC:13870",
      havana_gene : "OTTHUMG00000133240.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56451521,
      stop : 56479104,
      direction : "+",
      ID : "ENSG00000087263.17",
      gene_id : "ENSG00000087263.17",
      gene_type : "protein_coding",
      gene_name : "OGFOD1",
      gene_level : 2,
      hgnc_id : "HGNC:25585",
      havana_gene : "OTTHUMG00000133237.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56466836,
      stop : 56520087,
      direction : "-",
      ID : "ENSG00000125124.13",
      gene_id : "ENSG00000125124.13",
      gene_type : "protein_coding",
      gene_name : "BBS2",
      gene_level : 1,
      hgnc_id : "HGNC:967",
      havana_gene : "OTTHUMG00000176943.10",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56565073,
      stop : 56568957,
      direction : "+",
      ID : "ENSG00000102891.4",
      gene_id : "ENSG00000102891.4",
      gene_type : "protein_coding",
      gene_name : "MT4",
      gene_level : 2,
      hgnc_id : "HGNC:18705",
      havana_gene : "OTTHUMG00000176863.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56589074,
      stop : 56591088,
      direction : "+",
      ID : "ENSG00000087250.9",
      gene_id : "ENSG00000087250.9",
      gene_type : "protein_coding",
      gene_name : "MT3",
      gene_level : 2,
      hgnc_id : "HGNC:7408",
      havana_gene : "OTTHUMG00000133282.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56608584,
      stop : 56609497,
      direction : "+",
      ID : "ENSG00000125148.7",
      gene_id : "ENSG00000125148.7",
      gene_type : "protein_coding",
      gene_name : "MT2A",
      gene_level : 2,
      hgnc_id : "HGNC:7406",
      havana_gene : "OTTHUMG00000133281.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56625475,
      stop : 56627112,
      direction : "+",
      ID : "ENSG00000169715.15",
      gene_id : "ENSG00000169715.15",
      gene_type : "protein_coding",
      gene_name : "MT1E",
      gene_level : 2,
      hgnc_id : "HGNC:7397",
      havana_gene : "OTTHUMG00000133014.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56632659,
      stop : 56633981,
      direction : "+",
      ID : "ENSG00000205364.4",
      gene_id : "ENSG00000205364.4",
      gene_type : "protein_coding",
      gene_name : "MT1M",
      gene_level : 2,
      hgnc_id : "HGNC:14296",
      havana_gene : "OTTHUMG00000176938.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56638666,
      stop : 56640087,
      direction : "+",
      ID : "ENSG00000205362.11",
      gene_id : "ENSG00000205362.11",
      gene_type : "protein_coding",
      gene_name : "MT1A",
      gene_level : 2,
      hgnc_id : "HGNC:7393",
      havana_gene : "OTTHUMG00000176919.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56651886,
      stop : 56653204,
      direction : "+",
      ID : "ENSG00000169688.11",
      gene_id : "ENSG00000169688.11",
      gene_type : "protein_coding",
      gene_name : "MT1B",
      gene_level : 2,
      hgnc_id : "HGNC:7394",
      havana_gene : "OTTHUMG00000133277.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56657731,
      stop : 56660698,
      direction : "+",
      ID : "ENSG00000198417.7",
      gene_id : "ENSG00000198417.7",
      gene_type : "protein_coding",
      gene_name : "MT1F",
      gene_level : 2,
      hgnc_id : "HGNC:7398",
      havana_gene : "OTTHUMG00000176838.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56666730,
      stop : 56668065,
      direction : "-",
      ID : "ENSG00000125144.14",
      gene_id : "ENSG00000125144.14",
      gene_type : "protein_coding",
      gene_name : "MT1G",
      gene_level : 1,
      hgnc_id : "HGNC:7399",
      havana_gene : "OTTHUMG00000133275.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56669814,
      stop : 56671129,
      direction : "+",
      ID : "ENSG00000205358.4",
      gene_id : "ENSG00000205358.4",
      gene_type : "protein_coding",
      gene_name : "MT1H",
      gene_level : 2,
      hgnc_id : "HGNC:7400",
      havana_gene : "OTTHUMG00000133283.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56682470,
      stop : 56684196,
      direction : "+",
      ID : "ENSG00000187193.9",
      gene_id : "ENSG00000187193.9",
      gene_type : "protein_coding",
      gene_name : "MT1X",
      gene_level : 2,
      hgnc_id : "HGNC:7405",
      havana_gene : "OTTHUMG00000133280.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56730118,
      stop : 56850286,
      direction : "+",
      ID : "ENSG00000102900.13",
      gene_id : "ENSG00000102900.13",
      gene_type : "protein_coding",
      gene_name : "NUP93",
      gene_level : 1,
      hgnc_id : "HGNC:28958",
      havana_gene : "OTTHUMG00000133278.13",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56865207,
      stop : 56915850,
      direction : "+",
      ID : "ENSG00000070915.10",
      gene_id : "ENSG00000070915.10",
      gene_type : "protein_coding",
      gene_name : "SLC12A3",
      gene_level : 1,
      hgnc_id : "HGNC:10912",
      havana_gene : "OTTHUMG00000133284.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56932142,
      stop : 56944864,
      direction : "+",
      ID : "ENSG00000051108.15",
      gene_id : "ENSG00000051108.15",
      gene_type : "protein_coding",
      gene_name : "HERPUD1",
      gene_level : 1,
      hgnc_id : "HGNC:13744",
      havana_gene : "OTTHUMG00000133276.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56961923,
      stop : 56983845,
      direction : "+",
      ID : "ENSG00000087237.12",
      gene_id : "ENSG00000087237.12",
      gene_type : "protein_coding",
      gene_name : "CETP",
      gene_level : 1,
      hgnc_id : "HGNC:1869",
      havana_gene : "OTTHUMG00000133279.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 56989485,
      stop : 57083531,
      direction : "+",
      ID : "ENSG00000140853.16",
      gene_id : "ENSG00000140853.16",
      gene_type : "protein_coding",
      gene_name : "NLRC5",
      gene_level : 2,
      hgnc_id : "HGNC:29933",
      havana_gene : "OTTHUMG00000133470.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57092583,
      stop : 57148369,
      direction : "+",
      ID : "ENSG00000140848.17",
      gene_id : "ENSG00000140848.17",
      gene_type : "protein_coding",
      gene_name : "CPNE2",
      gene_level : 2,
      hgnc_id : "HGNC:2315",
      havana_gene : "OTTHUMG00000133471.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57152466,
      stop : 57186116,
      direction : "-",
      ID : "ENSG00000172775.17",
      gene_id : "ENSG00000172775.17",
      gene_type : "protein_coding",
      gene_name : "PSME3IP1",
      gene_level : 1,
      hgnc_id : "HGNC:29856",
      havana_gene : "OTTHUMG00000176660.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57186137,
      stop : 57240469,
      direction : "+",
      ID : "ENSG00000159579.14",
      gene_id : "ENSG00000159579.14",
      gene_type : "protein_coding",
      gene_name : "RSPRY1",
      gene_level : 1,
      hgnc_id : "HGNC:29420",
      havana_gene : "OTTHUMG00000133462.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57245259,
      stop : 57253635,
      direction : "+",
      ID : "ENSG00000102931.8",
      gene_id : "ENSG00000102931.8",
      gene_type : "protein_coding",
      gene_name : "ARL2BP",
      gene_level : 1,
      hgnc_id : "HGNC:17146",
      havana_gene : "OTTHUMG00000133459.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57248547,
      stop : 57284672,
      direction : "-",
      ID : "ENSG00000102934.10",
      gene_id : "ENSG00000102934.10",
      gene_type : "protein_coding",
      gene_name : "PLLP",
      gene_level : 1,
      hgnc_id : "HGNC:18553",
      havana_gene : "OTTHUMG00000133465.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57358783,
      stop : 57366189,
      direction : "+",
      ID : "ENSG00000102962.5",
      gene_id : "ENSG00000102962.5",
      gene_type : "protein_coding",
      gene_name : "CCL22",
      gene_level : 2,
      hgnc_id : "HGNC:10621",
      havana_gene : "OTTHUMG00000133454.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57372477,
      stop : 57385044,
      direction : "+",
      ID : "ENSG00000006210.7",
      gene_id : "ENSG00000006210.7",
      gene_type : "protein_coding",
      gene_name : "CX3CL1",
      gene_level : 1,
      hgnc_id : "HGNC:10647",
      havana_gene : "OTTHUMG00000133469.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57404767,
      stop : 57416063,
      direction : "+",
      ID : "ENSG00000102970.11",
      gene_id : "ENSG00000102970.11",
      gene_type : "protein_coding",
      gene_name : "CCL17",
      gene_level : 2,
      hgnc_id : "HGNC:10615",
      havana_gene : "OTTHUMG00000133468.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57428187,
      stop : 57447420,
      direction : "-",
      ID : "ENSG00000005194.15",
      gene_id : "ENSG00000005194.15",
      gene_type : "protein_coding",
      gene_name : "CIAPIN1",
      gene_level : 1,
      hgnc_id : "HGNC:28050",
      havana_gene : "OTTHUMG00000133457.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57447425,
      stop : 57461270,
      direction : "+",
      ID : "ENSG00000088682.14",
      gene_id : "ENSG00000088682.14",
      gene_type : "protein_coding",
      gene_name : "COQ9",
      gene_level : 1,
      hgnc_id : "HGNC:25302",
      havana_gene : "OTTHUMG00000176582.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57462660,
      stop : 57472009,
      direction : "+",
      ID : "ENSG00000102978.13",
      gene_id : "ENSG00000102978.13",
      gene_type : "protein_coding",
      gene_name : "POLR2C",
      gene_level : 2,
      hgnc_id : "HGNC:9189",
      havana_gene : "OTTHUMG00000133464.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57471922,
      stop : 57487327,
      direction : "-",
      ID : "ENSG00000125170.11",
      gene_id : "ENSG00000125170.11",
      gene_type : "protein_coding",
      gene_name : "DOK4",
      gene_level : 2,
      hgnc_id : "HGNC:19868",
      havana_gene : "OTTHUMG00000133460.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57512181,
      stop : 57536571,
      direction : "-",
      ID : "ENSG00000135736.6",
      gene_id : "ENSG00000135736.6",
      gene_type : "protein_coding",
      gene_name : "CCDC102A",
      gene_level : 2,
      hgnc_id : "HGNC:28097",
      havana_gene : "OTTHUMG00000133472.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57542643,
      stop : 57591681,
      direction : "+",
      ID : "ENSG00000159618.16",
      gene_id : "ENSG00000159618.16",
      gene_type : "protein_coding",
      gene_name : "ADGRG5",
      gene_level : 2,
      hgnc_id : "HGNC:19010",
      havana_gene : "OTTHUMG00000133461.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57610652,
      stop : 57665580,
      direction : "+",
      ID : "ENSG00000205336.14",
      gene_id : "ENSG00000205336.14",
      gene_type : "protein_coding",
      gene_name : "ADGRG1",
      gene_level : 1,
      hgnc_id : "HGNC:4512",
      havana_gene : "OTTHUMG00000176742.24",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57668277,
      stop : 57689378,
      direction : "+",
      ID : "ENSG00000182885.17",
      gene_id : "ENSG00000182885.17",
      gene_type : "protein_coding",
      gene_name : "ADGRG3",
      gene_level : 2,
      hgnc_id : "HGNC:13728",
      havana_gene : "OTTHUMG00000133458.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57694793,
      stop : 57731805,
      direction : "+",
      ID : "ENSG00000159625.15",
      gene_id : "ENSG00000159625.15",
      gene_type : "protein_coding",
      gene_name : "DRC7",
      gene_level : 1,
      hgnc_id : "HGNC:25289",
      havana_gene : "OTTHUMG00000133473.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57735739,
      stop : 57757244,
      direction : "+",
      ID : "ENSG00000140854.13",
      gene_id : "ENSG00000140854.13",
      gene_type : "protein_coding",
      gene_name : "KATNB1",
      gene_level : 2,
      hgnc_id : "HGNC:6217",
      havana_gene : "OTTHUMG00000133467.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57758217,
      stop : 57863053,
      direction : "-",
      ID : "ENSG00000140859.16",
      gene_id : "ENSG00000140859.16",
      gene_type : "protein_coding",
      gene_name : "KIFC3",
      gene_level : 1,
      hgnc_id : "HGNC:6326",
      havana_gene : "OTTHUMG00000133455.20",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57882340,
      stop : 57971128,
      direction : "-",
      ID : "ENSG00000070729.14",
      gene_id : "ENSG00000070729.14",
      gene_type : "protein_coding",
      gene_name : "CNGB1",
      gene_level : 2,
      hgnc_id : "HGNC:2151",
      havana_gene : "OTTHUMG00000154810.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57976435,
      stop : 57988116,
      direction : "+",
      ID : "ENSG00000159648.12",
      gene_id : "ENSG00000159648.12",
      gene_type : "protein_coding",
      gene_name : "TEPP",
      gene_level : 2,
      hgnc_id : "HGNC:33745",
      havana_gene : "OTTHUMG00000133463.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57994676,
      stop : 58000672,
      direction : "-",
      ID : "ENSG00000166188.3",
      gene_id : "ENSG00000166188.3",
      gene_type : "protein_coding",
      gene_name : "ZNF319",
      gene_level : 2,
      hgnc_id : "HGNC:13644",
      havana_gene : "OTTHUMG00000175512.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 57999546,
      stop : 58021618,
      direction : "+",
      ID : "ENSG00000103005.12",
      gene_id : "ENSG00000103005.12",
      gene_type : "protein_coding",
      gene_name : "USB1",
      gene_level : 1,
      hgnc_id : "HGNC:25792",
      havana_gene : "OTTHUMG00000133456.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58025754,
      stop : 58046901,
      direction : "+",
      ID : "ENSG00000102996.5",
      gene_id : "ENSG00000102996.5",
      gene_type : "protein_coding",
      gene_name : "MMP15",
      gene_level : 2,
      hgnc_id : "HGNC:7161",
      havana_gene : "OTTHUMG00000133466.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58113592,
      stop : 58129381,
      direction : "-",
      ID : "ENSG00000070761.8",
      gene_id : "ENSG00000070761.8",
      gene_type : "protein_coding",
      gene_name : "CFAP20",
      gene_level : 1,
      hgnc_id : "HGNC:29523",
      havana_gene : "OTTHUMG00000133490.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58157907,
      stop : 58198106,
      direction : "-",
      ID : "ENSG00000070770.10",
      gene_id : "ENSG00000070770.10",
      gene_type : "protein_coding",
      gene_name : "CSNK2A2",
      gene_level : 2,
      hgnc_id : "HGNC:2459",
      havana_gene : "OTTHUMG00000133488.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58231157,
      stop : 58283836,
      direction : "+",
      ID : "ENSG00000103021.9",
      gene_id : "ENSG00000103021.9",
      gene_type : "protein_coding",
      gene_name : "CCDC113",
      gene_level : 1,
      hgnc_id : "HGNC:25002",
      havana_gene : "OTTHUMG00000133489.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58279997,
      stop : 58295047,
      direction : "-",
      ID : "ENSG00000103023.12",
      gene_id : "ENSG00000103023.12",
      gene_type : "protein_coding",
      gene_name : "PRSS54",
      gene_level : 2,
      hgnc_id : "HGNC:26336",
      havana_gene : "OTTHUMG00000173231.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58295080,
      stop : 58406147,
      direction : "+",
      ID : "ENSG00000181938.14",
      gene_id : "ENSG00000181938.14",
      gene_type : "protein_coding",
      gene_name : "GINS3",
      gene_level : 1,
      hgnc_id : "HGNC:25851",
      havana_gene : "OTTHUMG00000133486.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58462846,
      stop : 58513628,
      direction : "+",
      ID : "ENSG00000103034.14",
      gene_id : "ENSG00000103034.14",
      gene_type : "protein_coding",
      gene_name : "NDRG4",
      gene_level : 1,
      hgnc_id : "HGNC:14466",
      havana_gene : "OTTHUMG00000133485.18",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58515479,
      stop : 58523842,
      direction : "+",
      ID : "ENSG00000103037.12",
      gene_id : "ENSG00000103037.12",
      gene_type : "protein_coding",
      gene_name : "SETD6",
      gene_level : 1,
      hgnc_id : "HGNC:26116",
      havana_gene : "OTTHUMG00000150276.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58519951,
      stop : 58629885,
      direction : "-",
      ID : "ENSG00000125107.19",
      gene_id : "ENSG00000125107.19",
      gene_type : "protein_coding",
      gene_name : "CNOT1",
      gene_level : 1,
      hgnc_id : "HGNC:7877",
      havana_gene : "OTTHUMG00000133487.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58665109,
      stop : 58684770,
      direction : "-",
      ID : "ENSG00000103042.9",
      gene_id : "ENSG00000103042.9",
      gene_type : "protein_coding",
      gene_name : "SLC38A7",
      gene_level : 1,
      hgnc_id : "HGNC:25582",
      havana_gene : "OTTHUMG00000133491.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 58707131,
      stop : 58734342,
      direction : "-",
      ID : "ENSG00000125166.13",
      gene_id : "ENSG00000125166.13",
      gene_type : "protein_coding",
      gene_name : "GOT2",
      gene_level : 2,
      hgnc_id : "HGNC:4433",
      havana_gene : "OTTHUMG00000133769.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 61647242,
      stop : 62037035,
      direction : "-",
      ID : "ENSG00000150394.14",
      gene_id : "ENSG00000150394.14",
      gene_type : "protein_coding",
      gene_name : "CDH8",
      gene_level : 1,
      hgnc_id : "HGNC:1767",
      havana_gene : "OTTHUMG00000137493.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 64943753,
      stop : 65126112,
      direction : "-",
      ID : "ENSG00000140937.14",
      gene_id : "ENSG00000140937.14",
      gene_type : "protein_coding",
      gene_name : "CDH11",
      gene_level : 1,
      hgnc_id : "HGNC:1750",
      havana_gene : "OTTHUMG00000137494.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66366622,
      stop : 66404784,
      direction : "+",
      ID : "ENSG00000179776.19",
      gene_id : "ENSG00000179776.19",
      gene_type : "protein_coding",
      gene_name : "CDH5",
      gene_level : 1,
      hgnc_id : "HGNC:1764",
      havana_gene : "OTTHUMG00000137495.12",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66427295,
      stop : 66493529,
      direction : "+",
      ID : "ENSG00000166546.14",
      gene_id : "ENSG00000166546.14",
      gene_type : "protein_coding",
      gene_name : "BEAN1",
      gene_level : 1,
      hgnc_id : "HGNC:24160",
      havana_gene : "OTTHUMG00000173370.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66469812,
      stop : 66517312,
      direction : "-",
      ID : "ENSG00000260851.7",
      gene_id : "ENSG00000260851.7",
      gene_type : "protein_coding",
      gene_name : "AC010542.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176745.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66508003,
      stop : 66552544,
      direction : "-",
      ID : "ENSG00000166548.17",
      gene_id : "ENSG00000166548.17",
      gene_type : "protein_coding",
      gene_name : "TK2",
      gene_level : 2,
      hgnc_id : "HGNC:11831",
      havana_gene : "OTTHUMG00000137499.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66552563,
      stop : 66566251,
      direction : "+",
      ID : "ENSG00000217555.13",
      gene_id : "ENSG00000217555.13",
      gene_type : "protein_coding",
      gene_name : "CKLF",
      gene_level : 2,
      hgnc_id : "HGNC:13253",
      havana_gene : "OTTHUMG00000137504.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66552587,
      stop : 66579135,
      direction : "+",
      ID : "ENSG00000254788.7",
      gene_id : "ENSG00000254788.7",
      gene_type : "protein_coding",
      gene_name : "CKLF-CMTM1",
      gene_level : 1,
      hgnc_id : "HGNC:39977",
      havana_gene : "OTTHUMG00000167106.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66566393,
      stop : 66579137,
      direction : "+",
      ID : "ENSG00000089505.18",
      gene_id : "ENSG00000089505.18",
      gene_type : "protein_coding",
      gene_name : "CMTM1",
      gene_level : 1,
      hgnc_id : "HGNC:19172",
      havana_gene : "OTTHUMG00000137502.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66579448,
      stop : 66588275,
      direction : "+",
      ID : "ENSG00000140932.10",
      gene_id : "ENSG00000140932.10",
      gene_type : "protein_coding",
      gene_name : "CMTM2",
      gene_level : 2,
      hgnc_id : "HGNC:19173",
      havana_gene : "OTTHUMG00000137501.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66603874,
      stop : 66613892,
      direction : "+",
      ID : "ENSG00000140931.20",
      gene_id : "ENSG00000140931.20",
      gene_type : "protein_coding",
      gene_name : "CMTM3",
      gene_level : 1,
      hgnc_id : "HGNC:19174",
      havana_gene : "OTTHUMG00000137503.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66614750,
      stop : 66696743,
      direction : "-",
      ID : "ENSG00000183723.13",
      gene_id : "ENSG00000183723.13",
      gene_type : "protein_coding",
      gene_name : "CMTM4",
      gene_level : 2,
      hgnc_id : "HGNC:19175",
      havana_gene : "OTTHUMG00000137500.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66720893,
      stop : 66751609,
      direction : "-",
      ID : "ENSG00000135720.13",
      gene_id : "ENSG00000135720.13",
      gene_type : "protein_coding",
      gene_name : "DYNC1LI2",
      gene_level : 1,
      hgnc_id : "HGNC:2966",
      havana_gene : "OTTHUMG00000137523.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66754640,
      stop : 66801620,
      direction : "-",
      ID : "ENSG00000249961.10",
      gene_id : "ENSG00000249961.10",
      gene_type : "protein_coding",
      gene_name : "TERB1",
      gene_level : 2,
      hgnc_id : "HGNC:26675",
      havana_gene : "OTTHUMG00000133562.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66802875,
      stop : 66873256,
      direction : "-",
      ID : "ENSG00000159593.15",
      gene_id : "ENSG00000159593.15",
      gene_type : "protein_coding",
      gene_name : "NAE1",
      gene_level : 1,
      hgnc_id : "HGNC:621",
      havana_gene : "OTTHUMG00000137513.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66844414,
      stop : 66854153,
      direction : "+",
      ID : "ENSG00000168748.14",
      gene_id : "ENSG00000168748.14",
      gene_type : "protein_coding",
      gene_name : "CA7",
      gene_level : 2,
      hgnc_id : "HGNC:1381",
      havana_gene : "OTTHUMG00000137524.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66878589,
      stop : 66895754,
      direction : "+",
      ID : "ENSG00000172840.7",
      gene_id : "ENSG00000172840.7",
      gene_type : "protein_coding",
      gene_name : "PDP2",
      gene_level : 2,
      hgnc_id : "HGNC:30263",
      havana_gene : "OTTHUMG00000137512.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66908122,
      stop : 66918917,
      direction : "-",
      ID : "ENSG00000166589.13",
      gene_id : "ENSG00000166589.13",
      gene_type : "protein_coding",
      gene_name : "CDH16",
      gene_level : 1,
      hgnc_id : "HGNC:1755",
      havana_gene : "OTTHUMG00000137518.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66921679,
      stop : 66925536,
      direction : "-",
      ID : "ENSG00000166592.12",
      gene_id : "ENSG00000166592.12",
      gene_type : "protein_coding",
      gene_name : "RRAD",
      gene_level : 2,
      hgnc_id : "HGNC:10446",
      havana_gene : "OTTHUMG00000137511.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66932065,
      stop : 66934423,
      direction : "-",
      ID : "ENSG00000166595.12",
      gene_id : "ENSG00000166595.12",
      gene_type : "protein_coding",
      gene_name : "CIAO2B",
      gene_level : 2,
      hgnc_id : "HGNC:24261",
      havana_gene : "OTTHUMG00000175408.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66934444,
      stop : 66945096,
      direction : "+",
      ID : "ENSG00000172831.14",
      gene_id : "ENSG00000172831.14",
      gene_type : "protein_coding",
      gene_name : "CES2",
      gene_level : 2,
      hgnc_id : "HGNC:1864",
      havana_gene : "OTTHUMG00000137517.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66961245,
      stop : 66975149,
      direction : "+",
      ID : "ENSG00000172828.13",
      gene_id : "ENSG00000172828.13",
      gene_type : "protein_coding",
      gene_name : "CES3",
      gene_level : 1,
      hgnc_id : "HGNC:1865",
      havana_gene : "OTTHUMG00000137525.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 66988589,
      stop : 67009758,
      direction : "+",
      ID : "ENSG00000172824.16",
      gene_id : "ENSG00000172824.16",
      gene_type : "protein_coding",
      gene_name : "CES4A",
      gene_level : 2,
      hgnc_id : "HGNC:26741",
      havana_gene : "OTTHUMG00000167866.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67028984,
      stop : 67101058,
      direction : "+",
      ID : "ENSG00000067955.15",
      gene_id : "ENSG00000067955.15",
      gene_type : "protein_coding",
      gene_name : "CBFB",
      gene_level : 1,
      hgnc_id : "HGNC:1539",
      havana_gene : "OTTHUMG00000137520.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67109941,
      stop : 67148544,
      direction : "+",
      ID : "ENSG00000125149.12",
      gene_id : "ENSG00000125149.12",
      gene_type : "protein_coding",
      gene_name : "C16orf70",
      gene_level : 2,
      hgnc_id : "HGNC:29564",
      havana_gene : "OTTHUMG00000137510.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67148104,
      stop : 67150998,
      direction : "-",
      ID : "ENSG00000237172.4",
      gene_id : "ENSG00000237172.4",
      gene_type : "protein_coding",
      gene_name : "B3GNT9",
      gene_level : 2,
      hgnc_id : "HGNC:28714",
      havana_gene : "OTTHUMG00000173315.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67154185,
      stop : 67159909,
      direction : "-",
      ID : "ENSG00000102871.16",
      gene_id : "ENSG00000102871.16",
      gene_type : "protein_coding",
      gene_name : "TRADD",
      gene_level : 2,
      hgnc_id : "HGNC:12030",
      havana_gene : "OTTHUMG00000137519.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67159932,
      stop : 67164570,
      direction : "+",
      ID : "ENSG00000135722.9",
      gene_id : "ENSG00000135722.9",
      gene_type : "protein_coding",
      gene_name : "FBXL8",
      gene_level : 1,
      hgnc_id : "HGNC:17875",
      havana_gene : "OTTHUMG00000137514.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67163385,
      stop : 67165815,
      direction : "+",
      ID : "ENSG00000265690.7",
      gene_id : "ENSG00000265690.7",
      gene_type : "protein_coding",
      gene_name : "AC074143.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000163737.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67164681,
      stop : 67169945,
      direction : "+",
      ID : "ENSG00000102878.17",
      gene_id : "ENSG00000102878.17",
      gene_type : "protein_coding",
      gene_name : "HSF4",
      gene_level : 1,
      hgnc_id : "HGNC:5227",
      havana_gene : "OTTHUMG00000178325.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67170154,
      stop : 67175735,
      direction : "+",
      ID : "ENSG00000140939.14",
      gene_id : "ENSG00000140939.14",
      gene_type : "protein_coding",
      gene_name : "NOL3",
      gene_level : 1,
      hgnc_id : "HGNC:7869",
      havana_gene : "OTTHUMG00000173316.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67175599,
      stop : 67184040,
      direction : "-",
      ID : "ENSG00000196123.13",
      gene_id : "ENSG00000196123.13",
      gene_type : "protein_coding",
      gene_name : "KIAA0895L",
      gene_level : 2,
      hgnc_id : "HGNC:34408",
      havana_gene : "OTTHUMG00000172891.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67184379,
      stop : 67190185,
      direction : "-",
      ID : "ENSG00000179044.16",
      gene_id : "ENSG00000179044.16",
      gene_type : "protein_coding",
      gene_name : "EXOC3L1",
      gene_level : 1,
      hgnc_id : "HGNC:27540",
      havana_gene : "OTTHUMG00000137508.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67192155,
      stop : 67198918,
      direction : "+",
      ID : "ENSG00000205250.9",
      gene_id : "ENSG00000205250.9",
      gene_type : "protein_coding",
      gene_name : "E2F4",
      gene_level : 2,
      hgnc_id : "HGNC:3118",
      havana_gene : "OTTHUMG00000172975.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67199111,
      stop : 67204029,
      direction : "+",
      ID : "ENSG00000102890.16",
      gene_id : "ENSG00000102890.16",
      gene_type : "protein_coding",
      gene_name : "ELMO3",
      gene_level : 1,
      hgnc_id : "HGNC:17289",
      havana_gene : "OTTHUMG00000133570.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67227103,
      stop : 67229278,
      direction : "+",
      ID : "ENSG00000168701.19",
      gene_id : "ENSG00000168701.19",
      gene_type : "protein_coding",
      gene_name : "TMEM208",
      gene_level : 1,
      hgnc_id : "HGNC:25015",
      havana_gene : "OTTHUMG00000173064.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67229387,
      stop : 67247481,
      direction : "-",
      ID : "ENSG00000135723.14",
      gene_id : "ENSG00000135723.14",
      gene_type : "protein_coding",
      gene_name : "FHOD1",
      gene_level : 2,
      hgnc_id : "HGNC:17905",
      havana_gene : "OTTHUMG00000137521.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67237683,
      stop : 67272191,
      direction : "+",
      ID : "ENSG00000135740.17",
      gene_id : "ENSG00000135740.17",
      gene_type : "protein_coding",
      gene_name : "SLC9A5",
      gene_level : 1,
      hgnc_id : "HGNC:11078",
      havana_gene : "OTTHUMG00000172935.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67277510,
      stop : 67289499,
      direction : "+",
      ID : "ENSG00000196155.13",
      gene_id : "ENSG00000196155.13",
      gene_type : "protein_coding",
      gene_name : "PLEKHG4",
      gene_level : 1,
      hgnc_id : "HGNC:24501",
      havana_gene : "OTTHUMG00000172936.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67289428,
      stop : 67326760,
      direction : "-",
      ID : "ENSG00000168676.11",
      gene_id : "ENSG00000168676.11",
      gene_type : "protein_coding",
      gene_name : "KCTD19",
      gene_level : 1,
      hgnc_id : "HGNC:24753",
      havana_gene : "OTTHUMG00000173075.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67326798,
      stop : 67385204,
      direction : "+",
      ID : "ENSG00000159708.18",
      gene_id : "ENSG00000159708.18",
      gene_type : "protein_coding",
      gene_name : "LRRC36",
      gene_level : 1,
      hgnc_id : "HGNC:25615",
      havana_gene : "OTTHUMG00000173030.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67389809,
      stop : 67393518,
      direction : "-",
      ID : "ENSG00000159713.11",
      gene_id : "ENSG00000159713.11",
      gene_type : "protein_coding",
      gene_name : "TPPP3",
      gene_level : 2,
      hgnc_id : "HGNC:24162",
      havana_gene : "OTTHUMG00000137516.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67394152,
      stop : 67416833,
      direction : "-",
      ID : "ENSG00000159714.12",
      gene_id : "ENSG00000159714.12",
      gene_type : "protein_coding",
      gene_name : "ZDHHC1",
      gene_level : 2,
      hgnc_id : "HGNC:17916",
      havana_gene : "OTTHUMG00000137522.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67430652,
      stop : 67437553,
      direction : "+",
      ID : "ENSG00000176387.7",
      gene_id : "ENSG00000176387.7",
      gene_type : "protein_coding",
      gene_name : "HSD11B2",
      gene_level : 1,
      hgnc_id : "HGNC:5209",
      havana_gene : "OTTHUMG00000137507.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67438014,
      stop : 67481181,
      direction : "-",
      ID : "ENSG00000159720.12",
      gene_id : "ENSG00000159720.12",
      gene_type : "protein_coding",
      gene_name : "ATP6V0D1",
      gene_level : 1,
      hgnc_id : "HGNC:13724",
      havana_gene : "OTTHUMG00000137515.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67482571,
      stop : 67483547,
      direction : "-",
      ID : "ENSG00000159723.5",
      gene_id : "ENSG00000159723.5",
      gene_type : "protein_coding",
      gene_name : "AGRP",
      gene_level : 2,
      hgnc_id : "HGNC:330",
      havana_gene : "OTTHUMG00000137509.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67518418,
      stop : 67546788,
      direction : "+",
      ID : "ENSG00000039523.20",
      gene_id : "ENSG00000039523.20",
      gene_type : "protein_coding",
      gene_name : "RIPOR1",
      gene_level : 1,
      hgnc_id : "HGNC:25836",
      havana_gene : "OTTHUMG00000137536.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67562467,
      stop : 67639177,
      direction : "+",
      ID : "ENSG00000102974.16",
      gene_id : "ENSG00000102974.16",
      gene_type : "protein_coding",
      gene_name : "CTCF",
      gene_level : 2,
      hgnc_id : "HGNC:13723",
      havana_gene : "OTTHUMG00000137539.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67644988,
      stop : 67657569,
      direction : "+",
      ID : "ENSG00000159753.14",
      gene_id : "ENSG00000159753.14",
      gene_type : "protein_coding",
      gene_name : "CARMIL2",
      gene_level : 2,
      hgnc_id : "HGNC:27089",
      havana_gene : "OTTHUMG00000184043.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67657512,
      stop : 67660815,
      direction : "-",
      ID : "ENSG00000102977.17",
      gene_id : "ENSG00000102977.17",
      gene_type : "protein_coding",
      gene_name : "ACD",
      gene_level : 2,
      hgnc_id : "HGNC:25070",
      havana_gene : "OTTHUMG00000137547.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67660946,
      stop : 67662774,
      direction : "+",
      ID : "ENSG00000102981.10",
      gene_id : "ENSG00000102981.10",
      gene_type : "protein_coding",
      gene_name : "PARD6A",
      gene_level : 2,
      hgnc_id : "HGNC:15943",
      havana_gene : "OTTHUMG00000137534.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67662945,
      stop : 67667265,
      direction : "-",
      ID : "ENSG00000124074.12",
      gene_id : "ENSG00000124074.12",
      gene_type : "protein_coding",
      gene_name : "ENKD1",
      gene_level : 1,
      hgnc_id : "HGNC:25246",
      havana_gene : "OTTHUMG00000137550.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67666814,
      stop : 67668757,
      direction : "+",
      ID : "ENSG00000159761.15",
      gene_id : "ENSG00000159761.15",
      gene_type : "protein_coding",
      gene_name : "C16orf86",
      gene_level : 2,
      hgnc_id : "HGNC:33755",
      havana_gene : "OTTHUMG00000150527.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67674531,
      stop : 67719339,
      direction : "-",
      ID : "ENSG00000141098.13",
      gene_id : "ENSG00000141098.13",
      gene_type : "protein_coding",
      gene_name : "GFOD2",
      gene_level : 2,
      hgnc_id : "HGNC:28159",
      havana_gene : "OTTHUMG00000137537.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67723070,
      stop : 67806652,
      direction : "-",
      ID : "ENSG00000141084.11",
      gene_id : "ENSG00000141084.11",
      gene_type : "protein_coding",
      gene_name : "RANBP10",
      gene_level : 2,
      hgnc_id : "HGNC:29285",
      havana_gene : "OTTHUMG00000184044.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67806765,
      stop : 67832148,
      direction : "+",
      ID : "ENSG00000102904.15",
      gene_id : "ENSG00000102904.15",
      gene_type : "protein_coding",
      gene_name : "TSNAXIP1",
      gene_level : 1,
      hgnc_id : "HGNC:18586",
      havana_gene : "OTTHUMG00000137545.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67828157,
      stop : 67847811,
      direction : "-",
      ID : "ENSG00000102901.13",
      gene_id : "ENSG00000102901.13",
      gene_type : "protein_coding",
      gene_name : "CENPT",
      gene_level : 1,
      hgnc_id : "HGNC:25787",
      havana_gene : "OTTHUMG00000173071.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67842320,
      stop : 67844195,
      direction : "+",
      ID : "ENSG00000168286.3",
      gene_id : "ENSG00000168286.3",
      gene_type : "protein_coding",
      gene_name : "THAP11",
      gene_level : 2,
      hgnc_id : "HGNC:23194",
      havana_gene : "OTTHUMG00000137546.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67846923,
      stop : 67872567,
      direction : "+",
      ID : "ENSG00000102898.12",
      gene_id : "ENSG00000102898.12",
      gene_type : "protein_coding",
      gene_name : "NUTF2",
      gene_level : 2,
      hgnc_id : "HGNC:13722",
      havana_gene : "OTTHUMG00000137540.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67873052,
      stop : 67884499,
      direction : "+",
      ID : "ENSG00000038358.15",
      gene_id : "ENSG00000038358.15",
      gene_type : "protein_coding",
      gene_name : "EDC4",
      gene_level : 2,
      hgnc_id : "HGNC:17157",
      havana_gene : "OTTHUMG00000137543.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67884885,
      stop : 67888855,
      direction : "+",
      ID : "ENSG00000188038.8",
      gene_id : "ENSG00000188038.8",
      gene_type : "protein_coding",
      gene_name : "NRN1L",
      gene_level : 2,
      hgnc_id : "HGNC:29811",
      havana_gene : "OTTHUMG00000137541.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67893254,
      stop : 67929676,
      direction : "+",
      ID : "ENSG00000159792.10",
      gene_id : "ENSG00000159792.10",
      gene_type : "protein_coding",
      gene_name : "PSKH1",
      gene_level : 2,
      hgnc_id : "HGNC:9529",
      havana_gene : "OTTHUMG00000137548.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67927640,
      stop : 67932365,
      direction : "-",
      ID : "ENSG00000141086.18",
      gene_id : "ENSG00000141086.18",
      gene_type : "protein_coding",
      gene_name : "CTRL",
      gene_level : 2,
      hgnc_id : "HGNC:2524",
      havana_gene : "OTTHUMG00000137552.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67929614,
      stop : 67936017,
      direction : "-",
      ID : "ENSG00000261884.2",
      gene_id : "ENSG00000261884.2",
      gene_type : "protein_coding",
      gene_name : "AC040162.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177516.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67934506,
      stop : 67936864,
      direction : "-",
      ID : "ENSG00000205220.12",
      gene_id : "ENSG00000205220.12",
      gene_type : "protein_coding",
      gene_name : "PSMB10",
      gene_level : 2,
      hgnc_id : "HGNC:9538",
      havana_gene : "OTTHUMG00000137553.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67939750,
      stop : 67944131,
      direction : "-",
      ID : "ENSG00000213398.8",
      gene_id : "ENSG00000213398.8",
      gene_type : "protein_coding",
      gene_name : "LCAT",
      gene_level : 1,
      hgnc_id : "HGNC:6522",
      havana_gene : "OTTHUMG00000137551.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67943474,
      stop : 67969601,
      direction : "-",
      ID : "ENSG00000124067.17",
      gene_id : "ENSG00000124067.17",
      gene_type : "protein_coding",
      gene_name : "SLC12A4",
      gene_level : 1,
      hgnc_id : "HGNC:10913",
      havana_gene : "OTTHUMG00000137535.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67975663,
      stop : 67980549,
      direction : "-",
      ID : "ENSG00000141096.6",
      gene_id : "ENSG00000141096.6",
      gene_type : "protein_coding",
      gene_name : "DPEP3",
      gene_level : 2,
      hgnc_id : "HGNC:23029",
      havana_gene : "OTTHUMG00000137544.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67987394,
      stop : 68000586,
      direction : "-",
      ID : "ENSG00000167261.14",
      gene_id : "ENSG00000167261.14",
      gene_type : "protein_coding",
      gene_name : "DPEP2",
      gene_level : 1,
      hgnc_id : "HGNC:23028",
      havana_gene : "OTTHUMG00000137542.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 67987746,
      stop : 68079320,
      direction : "+",
      ID : "ENSG00000167264.18",
      gene_id : "ENSG00000167264.18",
      gene_type : "protein_coding",
      gene_name : "DUS2",
      gene_level : 2,
      hgnc_id : "HGNC:26014",
      havana_gene : "OTTHUMG00000137538.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68013436,
      stop : 68015911,
      direction : "-",
      ID : "ENSG00000263201.1",
      gene_id : "ENSG00000263201.1",
      gene_type : "protein_coding",
      gene_name : "DPEP2NB",
      gene_level : 2,
      hgnc_id : "HGNC:52385",
      havana_gene : "OTTHUMG00000177460.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68020916,
      stop : 68023232,
      direction : "-",
      ID : "ENSG00000182810.7",
      gene_id : "ENSG00000182810.7",
      gene_type : "protein_coding",
      gene_name : "DDX28",
      gene_level : 2,
      hgnc_id : "HGNC:17330",
      havana_gene : "OTTHUMG00000137549.1",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68084751,
      stop : 68229259,
      direction : "+",
      ID : "ENSG00000072736.19",
      gene_id : "ENSG00000072736.19",
      gene_type : "protein_coding",
      gene_name : "NFATC3",
      gene_level : 1,
      hgnc_id : "HGNC:7777",
      havana_gene : "OTTHUMG00000137555.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68229033,
      stop : 68238102,
      direction : "-",
      ID : "ENSG00000103067.14",
      gene_id : "ENSG00000103067.14",
      gene_type : "protein_coding",
      gene_name : "ESRP2",
      gene_level : 2,
      hgnc_id : "HGNC:26152",
      havana_gene : "OTTHUMG00000137557.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68245304,
      stop : 68261058,
      direction : "+",
      ID : "ENSG00000103066.13",
      gene_id : "ENSG00000103066.13",
      gene_type : "protein_coding",
      gene_name : "PLA2G15",
      gene_level : 1,
      hgnc_id : "HGNC:17163",
      havana_gene : "OTTHUMG00000137554.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68264516,
      stop : 68301823,
      direction : "+",
      ID : "ENSG00000103064.15",
      gene_id : "ENSG00000103064.15",
      gene_type : "protein_coding",
      gene_name : "SLC7A6",
      gene_level : 2,
      hgnc_id : "HGNC:11064",
      havana_gene : "OTTHUMG00000176544.14",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68284503,
      stop : 68310946,
      direction : "-",
      ID : "ENSG00000103061.13",
      gene_id : "ENSG00000103061.13",
      gene_type : "protein_coding",
      gene_name : "SLC7A6OS",
      gene_level : 2,
      hgnc_id : "HGNC:25807",
      havana_gene : "OTTHUMG00000137558.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68310974,
      stop : 68358584,
      direction : "+",
      ID : "ENSG00000132600.17",
      gene_id : "ENSG00000132600.17",
      gene_type : "protein_coding",
      gene_name : "PRMT7",
      gene_level : 1,
      hgnc_id : "HGNC:25557",
      havana_gene : "OTTHUMG00000137556.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68358327,
      stop : 68448508,
      direction : "-",
      ID : "ENSG00000103056.12",
      gene_id : "ENSG00000103056.12",
      gene_type : "protein_coding",
      gene_name : "SMPD3",
      gene_level : 1,
      hgnc_id : "HGNC:14240",
      havana_gene : "OTTHUMG00000137559.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68530090,
      stop : 68576072,
      direction : "+",
      ID : "ENSG00000184939.16",
      gene_id : "ENSG00000184939.16",
      gene_type : "protein_coding",
      gene_name : "ZFP90",
      gene_level : 1,
      hgnc_id : "HGNC:23329",
      havana_gene : "OTTHUMG00000177312.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68636189,
      stop : 68727468,
      direction : "+",
      ID : "ENSG00000062038.15",
      gene_id : "ENSG00000062038.15",
      gene_type : "protein_coding",
      gene_name : "CDH3",
      gene_level : 2,
      hgnc_id : "HGNC:1762",
      havana_gene : "OTTHUMG00000137560.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68737292,
      stop : 68835537,
      direction : "+",
      ID : "ENSG00000039068.20",
      gene_id : "ENSG00000039068.20",
      gene_type : "protein_coding",
      gene_name : "CDH1",
      gene_level : 2,
      hgnc_id : "HGNC:1748",
      havana_gene : "OTTHUMG00000137561.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 68843531,
      stop : 69085182,
      direction : "+",
      ID : "ENSG00000103047.8",
      gene_id : "ENSG00000103047.8",
      gene_type : "protein_coding",
      gene_name : "TANGO6",
      gene_level : 1,
      hgnc_id : "HGNC:25749",
      havana_gene : "OTTHUMG00000176743.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69105653,
      stop : 69118719,
      direction : "+",
      ID : "ENSG00000103044.11",
      gene_id : "ENSG00000103044.11",
      gene_type : "protein_coding",
      gene_name : "HAS3",
      gene_level : 2,
      hgnc_id : "HGNC:4820",
      havana_gene : "OTTHUMG00000137562.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69118010,
      stop : 69132151,
      direction : "-",
      ID : "ENSG00000286140.1",
      gene_id : "ENSG00000286140.1",
      gene_type : "protein_coding",
      gene_name : "DERPC",
      gene_level : 2,
      hgnc_id : "HGNC:54084",
      havana_gene : "OTTHUMG00000193738.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69118010,
      stop : 69132588,
      direction : "-",
      ID : "ENSG00000168802.14",
      gene_id : "ENSG00000168802.14",
      gene_type : "protein_coding",
      gene_name : "CHTF8",
      gene_level : 1,
      hgnc_id : "HGNC:24353",
      havana_gene : "OTTHUMG00000163909.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69131291,
      stop : 69231130,
      direction : "+",
      ID : "ENSG00000141076.18",
      gene_id : "ENSG00000141076.18",
      gene_type : "protein_coding",
      gene_name : "UTP4",
      gene_level : 1,
      hgnc_id : "HGNC:1983",
      havana_gene : "OTTHUMG00000137570.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69187129,
      stop : 69309052,
      direction : "+",
      ID : "ENSG00000168807.16",
      gene_id : "ENSG00000168807.16",
      gene_type : "protein_coding",
      gene_name : "SNTB2",
      gene_level : 1,
      hgnc_id : "HGNC:11169",
      havana_gene : "OTTHUMG00000137567.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69299682,
      stop : 69322700,
      direction : "+",
      ID : "ENSG00000260914.3",
      gene_id : "ENSG00000260914.3",
      gene_type : "protein_coding",
      gene_name : "AC026464.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186022.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69311350,
      stop : 69326939,
      direction : "+",
      ID : "ENSG00000132612.16",
      gene_id : "ENSG00000132612.16",
      gene_type : "protein_coding",
      gene_name : "VPS4A",
      gene_level : 1,
      hgnc_id : "HGNC:13488",
      havana_gene : "OTTHUMG00000175589.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69320140,
      stop : 69339583,
      direction : "-",
      ID : "ENSG00000213380.16",
      gene_id : "ENSG00000213380.16",
      gene_type : "protein_coding",
      gene_name : "COG8",
      gene_level : 2,
      hgnc_id : "HGNC:18623",
      havana_gene : "OTTHUMG00000154277.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69326913,
      stop : 69330588,
      direction : "-",
      ID : "ENSG00000258429.2",
      gene_id : "ENSG00000258429.2",
      gene_type : "protein_coding",
      gene_name : "PDF",
      gene_level : 2,
      hgnc_id : "HGNC:30012",
      havana_gene : "OTTHUMG00000171336.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69328644,
      stop : 69334871,
      direction : "-",
      ID : "ENSG00000272617.3",
      gene_id : "ENSG00000272617.3",
      gene_type : "protein_coding",
      gene_name : "AC026464.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186023.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69335091,
      stop : 69356306,
      direction : "-",
      ID : "ENSG00000260371.1",
      gene_id : "ENSG00000260371.1",
      gene_type : "protein_coding",
      gene_name : "AC026464.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176072.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69335276,
      stop : 69351730,
      direction : "-",
      ID : "ENSG00000259900.5",
      gene_id : "ENSG00000259900.5",
      gene_type : "protein_coding",
      gene_name : "AC026464.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000175592.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69337996,
      stop : 69343106,
      direction : "+",
      ID : "ENSG00000132603.15",
      gene_id : "ENSG00000132603.15",
      gene_type : "protein_coding",
      gene_name : "NIP7",
      gene_level : 2,
      hgnc_id : "HGNC:24328",
      havana_gene : "OTTHUMG00000137568.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69343250,
      stop : 69351786,
      direction : "-",
      ID : "ENSG00000157315.5",
      gene_id : "ENSG00000157315.5",
      gene_type : "protein_coding",
      gene_name : "TMED6",
      gene_level : 2,
      hgnc_id : "HGNC:28331",
      havana_gene : "OTTHUMG00000137571.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69355567,
      stop : 69408571,
      direction : "-",
      ID : "ENSG00000132604.11",
      gene_id : "ENSG00000132604.11",
      gene_type : "protein_coding",
      gene_name : "TERF2",
      gene_level : 1,
      hgnc_id : "HGNC:11729",
      havana_gene : "OTTHUMG00000137566.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69424619,
      stop : 69466264,
      direction : "+",
      ID : "ENSG00000103018.17",
      gene_id : "ENSG00000103018.17",
      gene_type : "protein_coding",
      gene_name : "CYB5B",
      gene_level : 2,
      hgnc_id : "HGNC:24374",
      havana_gene : "OTTHUMG00000133020.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69565094,
      stop : 69704666,
      direction : "+",
      ID : "ENSG00000102908.22",
      gene_id : "ENSG00000102908.22",
      gene_type : "protein_coding",
      gene_name : "NFAT5",
      gene_level : 2,
      hgnc_id : "HGNC:7774",
      havana_gene : "OTTHUMG00000137572.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69706996,
      stop : 69726668,
      direction : "-",
      ID : "ENSG00000181019.13",
      gene_id : "ENSG00000181019.13",
      gene_type : "protein_coding",
      gene_name : "NQO1",
      gene_level : 1,
      hgnc_id : "HGNC:2874",
      havana_gene : "OTTHUMG00000137575.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69741871,
      stop : 69754926,
      direction : "-",
      ID : "ENSG00000141101.13",
      gene_id : "ENSG00000141101.13",
      gene_type : "protein_coding",
      gene_name : "NOB1",
      gene_level : 2,
      hgnc_id : "HGNC:29540",
      havana_gene : "OTTHUMG00000137576.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69762328,
      stop : 69941741,
      direction : "+",
      ID : "ENSG00000198373.13",
      gene_id : "ENSG00000198373.13",
      gene_type : "protein_coding",
      gene_name : "WWP2",
      gene_level : 2,
      hgnc_id : "HGNC:16804",
      havana_gene : "OTTHUMG00000137573.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 69950705,
      stop : 69964452,
      direction : "+",
      ID : "ENSG00000157322.17",
      gene_id : "ENSG00000157322.17",
      gene_type : "protein_coding",
      gene_name : "CLEC18A",
      gene_level : 2,
      hgnc_id : "HGNC:30388",
      havana_gene : "OTTHUMG00000137574.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70114332,
      stop : 70162537,
      direction : "+",
      ID : "ENSG00000090857.14",
      gene_id : "ENSG00000090857.14",
      gene_type : "protein_coding",
      gene_name : "PDPR",
      gene_level : 2,
      hgnc_id : "HGNC:30264",
      havana_gene : "OTTHUMG00000176963.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70173322,
      stop : 70187361,
      direction : "+",
      ID : "ENSG00000157335.21",
      gene_id : "ENSG00000157335.21",
      gene_type : "protein_coding",
      gene_name : "CLEC18C",
      gene_level : 2,
      hgnc_id : "HGNC:28538",
      havana_gene : "OTTHUMG00000176982.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70246778,
      stop : 70251940,
      direction : "-",
      ID : "ENSG00000223496.3",
      gene_id : "ENSG00000223496.3",
      gene_type : "protein_coding",
      gene_name : "EXOSC6",
      gene_level : 2,
      hgnc_id : "HGNC:19055",
      havana_gene : "OTTHUMG00000137578.2",
      tag : "retrogene"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70251983,
      stop : 70289707,
      direction : "-",
      ID : "ENSG00000090861.17",
      gene_id : "ENSG00000090861.17",
      gene_type : "protein_coding",
      gene_name : "AARS1",
      gene_level : 1,
      hgnc_id : "HGNC:20",
      havana_gene : "OTTHUMG00000177042.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70289663,
      stop : 70335305,
      direction : "+",
      ID : "ENSG00000157349.17",
      gene_id : "ENSG00000157349.17",
      gene_type : "protein_coding",
      gene_name : "DDX19B",
      gene_level : 2,
      hgnc_id : "HGNC:2742",
      havana_gene : "OTTHUMG00000137577.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70299194,
      stop : 70372582,
      direction : "+",
      ID : "ENSG00000260537.2",
      gene_id : "ENSG00000260537.2",
      gene_type : "protein_coding",
      gene_name : "AC012184.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177063.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70346861,
      stop : 70373383,
      direction : "+",
      ID : "ENSG00000168872.17",
      gene_id : "ENSG00000168872.17",
      gene_type : "protein_coding",
      gene_name : "DDX19A",
      gene_level : 1,
      hgnc_id : "HGNC:25628",
      havana_gene : "OTTHUMG00000137579.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70375977,
      stop : 70439237,
      direction : "-",
      ID : "ENSG00000157350.13",
      gene_id : "ENSG00000157350.13",
      gene_type : "protein_coding",
      gene_name : "ST3GAL2",
      gene_level : 2,
      hgnc_id : "HGNC:10863",
      havana_gene : "OTTHUMG00000137580.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70454595,
      stop : 70480274,
      direction : "+",
      ID : "ENSG00000157353.17",
      gene_id : "ENSG00000157353.17",
      gene_type : "protein_coding",
      gene_name : "FCSK",
      gene_level : 1,
      hgnc_id : "HGNC:29500",
      havana_gene : "OTTHUMG00000074085.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70480568,
      stop : 70523560,
      direction : "-",
      ID : "ENSG00000103051.20",
      gene_id : "ENSG00000103051.20",
      gene_type : "protein_coding",
      gene_name : "COG4",
      gene_level : 2,
      hgnc_id : "HGNC:18620",
      havana_gene : "OTTHUMG00000128515.11",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70523791,
      stop : 70577670,
      direction : "+",
      ID : "ENSG00000189091.13",
      gene_id : "ENSG00000189091.13",
      gene_type : "protein_coding",
      gene_name : "SF3B3",
      gene_level : 1,
      hgnc_id : "HGNC:10770",
      havana_gene : "OTTHUMG00000137582.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70579895,
      stop : 70660682,
      direction : "+",
      ID : "ENSG00000157368.11",
      gene_id : "ENSG00000157368.11",
      gene_type : "protein_coding",
      gene_name : "IL34",
      gene_level : 1,
      hgnc_id : "HGNC:28529",
      havana_gene : "OTTHUMG00000137581.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70661204,
      stop : 70686053,
      direction : "-",
      ID : "ENSG00000132613.15",
      gene_id : "ENSG00000132613.15",
      gene_type : "protein_coding",
      gene_name : "MTSS2",
      gene_level : 1,
      hgnc_id : "HGNC:25094",
      havana_gene : "OTTHUMG00000177023.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70687439,
      stop : 70801160,
      direction : "-",
      ID : "ENSG00000103043.15",
      gene_id : "ENSG00000103043.15",
      gene_type : "protein_coding",
      gene_name : "VAC14",
      gene_level : 1,
      hgnc_id : "HGNC:25507",
      havana_gene : "OTTHUMG00000137583.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 70802084,
      stop : 71230722,
      direction : "-",
      ID : "ENSG00000157423.18",
      gene_id : "ENSG00000157423.18",
      gene_type : "protein_coding",
      gene_name : "HYDIN",
      gene_level : 1,
      hgnc_id : "HGNC:19368",
      havana_gene : "OTTHUMG00000137584.14",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71281389,
      stop : 71289715,
      direction : "-",
      ID : "ENSG00000180917.18",
      gene_id : "ENSG00000180917.18",
      gene_type : "protein_coding",
      gene_name : "CMTR2",
      gene_level : 2,
      hgnc_id : "HGNC:25635",
      havana_gene : "OTTHUMG00000137587.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71358713,
      stop : 71390436,
      direction : "+",
      ID : "ENSG00000172137.19",
      gene_id : "ENSG00000172137.19",
      gene_type : "protein_coding",
      gene_name : "CALB2",
      gene_level : 2,
      hgnc_id : "HGNC:1435",
      havana_gene : "OTTHUMG00000137589.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71429980,
      stop : 71442054,
      direction : "-",
      ID : "ENSG00000260734.6",
      gene_id : "ENSG00000260734.6",
      gene_type : "protein_coding",
      gene_name : "TLE7",
      gene_level : 2,
      hgnc_id : "HGNC:53648",
      havana_gene : "OTTHUMG00000176796.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71447597,
      stop : 71463095,
      direction : "-",
      ID : "ENSG00000167377.18",
      gene_id : "ENSG00000167377.18",
      gene_type : "protein_coding",
      gene_name : "ZNF23",
      gene_level : 2,
      hgnc_id : "HGNC:13023",
      havana_gene : "OTTHUMG00000176797.40",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71447600,
      stop : 71489311,
      direction : "-",
      ID : "ENSG00000261611.6",
      gene_id : "ENSG00000261611.6",
      gene_type : "protein_coding",
      gene_name : "AC010547.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000137588.41",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71464555,
      stop : 71565089,
      direction : "-",
      ID : "ENSG00000157429.16",
      gene_id : "ENSG00000157429.16",
      gene_type : "protein_coding",
      gene_name : "ZNF19",
      gene_level : 1,
      hgnc_id : "HGNC:12981",
      havana_gene : "OTTHUMG00000137593.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71525233,
      stop : 71538748,
      direction : "+",
      ID : "ENSG00000140835.10",
      gene_id : "ENSG00000140835.10",
      gene_type : "protein_coding",
      gene_name : "CHST4",
      gene_level : 2,
      hgnc_id : "HGNC:1972",
      havana_gene : "OTTHUMG00000137592.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71565660,
      stop : 71577092,
      direction : "-",
      ID : "ENSG00000198650.11",
      gene_id : "ENSG00000198650.11",
      gene_type : "protein_coding",
      gene_name : "TAT",
      gene_level : 2,
      hgnc_id : "HGNC:11573",
      havana_gene : "OTTHUMG00000137590.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71626161,
      stop : 71642114,
      direction : "+",
      ID : "ENSG00000140832.10",
      gene_id : "ENSG00000140832.10",
      gene_type : "protein_coding",
      gene_name : "MARVELD3",
      gene_level : 2,
      hgnc_id : "HGNC:30525",
      havana_gene : "OTTHUMG00000137591.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71637835,
      stop : 71724701,
      direction : "-",
      ID : "ENSG00000040199.18",
      gene_id : "ENSG00000040199.18",
      gene_type : "protein_coding",
      gene_name : "PHLPP2",
      gene_level : 1,
      hgnc_id : "HGNC:29149",
      havana_gene : "OTTHUMG00000176867.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71729000,
      stop : 71809201,
      direction : "-",
      ID : "ENSG00000166747.13",
      gene_id : "ENSG00000166747.13",
      gene_type : "protein_coding",
      gene_name : "AP1G1",
      gene_level : 1,
      hgnc_id : "HGNC:555",
      havana_gene : "OTTHUMG00000176871.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71845976,
      stop : 71885268,
      direction : "+",
      ID : "ENSG00000224470.8",
      gene_id : "ENSG00000224470.8",
      gene_type : "protein_coding",
      gene_name : "ATXN1L",
      gene_level : 2,
      hgnc_id : "HGNC:33279",
      havana_gene : "OTTHUMG00000176872.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71845996,
      stop : 71931199,
      direction : "+",
      ID : "ENSG00000182149.21",
      gene_id : "ENSG00000182149.21",
      gene_type : "protein_coding",
      gene_name : "IST1",
      gene_level : 1,
      hgnc_id : "HGNC:28977",
      havana_gene : "OTTHUMG00000137597.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71859680,
      stop : 71895336,
      direction : "-",
      ID : "ENSG00000102984.15",
      gene_id : "ENSG00000102984.15",
      gene_type : "protein_coding",
      gene_name : "ZNF821",
      gene_level : 2,
      hgnc_id : "HGNC:28043",
      havana_gene : "OTTHUMG00000176874.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 71929538,
      stop : 71999978,
      direction : "-",
      ID : "ENSG00000277481.1",
      gene_id : "ENSG00000277481.1",
      gene_type : "protein_coding",
      gene_name : "PKD1L3",
      gene_level : 2,
      hgnc_id : "HGNC:21716",
      havana_gene : "OTTHUMG00000166114.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72008588,
      stop : 72027664,
      direction : "+",
      ID : "ENSG00000102967.12",
      gene_id : "ENSG00000102967.12",
      gene_type : "protein_coding",
      gene_name : "DHODH",
      gene_level : 1,
      hgnc_id : "HGNC:2867",
      havana_gene : "OTTHUMG00000178093.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72044289,
      stop : 72094431,
      direction : "-",
      ID : "ENSG00000140830.9",
      gene_id : "ENSG00000140830.9",
      gene_type : "protein_coding",
      gene_name : "TXNL4B",
      gene_level : 2,
      hgnc_id : "HGNC:26041",
      havana_gene : "OTTHUMG00000173453.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72054505,
      stop : 72061055,
      direction : "+",
      ID : "ENSG00000257017.9",
      gene_id : "ENSG00000257017.9",
      gene_type : "protein_coding",
      gene_name : "HP",
      gene_level : 2,
      hgnc_id : "HGNC:5141",
      havana_gene : "OTTHUMG00000173009.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72063148,
      stop : 72077246,
      direction : "+",
      ID : "ENSG00000261701.8",
      gene_id : "ENSG00000261701.8",
      gene_type : "protein_coding",
      gene_name : "HPR",
      gene_level : 2,
      hgnc_id : "HGNC:5156",
      havana_gene : "OTTHUMG00000173010.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72093613,
      stop : 72112912,
      direction : "+",
      ID : "ENSG00000140829.12",
      gene_id : "ENSG00000140829.12",
      gene_type : "protein_coding",
      gene_name : "DHX38",
      gene_level : 2,
      hgnc_id : "HGNC:17211",
      havana_gene : "OTTHUMG00000137596.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72112157,
      stop : 72176878,
      direction : "-",
      ID : "ENSG00000118557.16",
      gene_id : "ENSG00000118557.16",
      gene_type : "protein_coding",
      gene_name : "PMFBP1",
      gene_level : 1,
      hgnc_id : "HGNC:17728",
      havana_gene : "OTTHUMG00000167827.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 72782885,
      stop : 73891871,
      direction : "-",
      ID : "ENSG00000140836.17",
      gene_id : "ENSG00000140836.17",
      gene_type : "protein_coding",
      gene_name : "ZFHX3",
      gene_level : 2,
      hgnc_id : "HGNC:777",
      havana_gene : "OTTHUMG00000137599.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74296814,
      stop : 74306288,
      direction : "+",
      ID : "ENSG00000103035.11",
      gene_id : "ENSG00000103035.11",
      gene_type : "protein_coding",
      gene_name : "PSMD7",
      gene_level : 2,
      hgnc_id : "HGNC:9565",
      havana_gene : "OTTHUMG00000137601.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74377878,
      stop : 74392080,
      direction : "+",
      ID : "ENSG00000196436.8",
      gene_id : "ENSG00000196436.8",
      gene_type : "protein_coding",
      gene_name : "NPIPB15",
      gene_level : 1,
      hgnc_id : "HGNC:34409",
      havana_gene : "OTTHUMG00000156916.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74408270,
      stop : 74421953,
      direction : "-",
      ID : "ENSG00000140839.11",
      gene_id : "ENSG00000140839.11",
      gene_type : "protein_coding",
      gene_name : "CLEC18B",
      gene_level : 2,
      hgnc_id : "HGNC:33849",
      havana_gene : "OTTHUMG00000176998.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74447427,
      stop : 74607144,
      direction : "-",
      ID : "ENSG00000090863.12",
      gene_id : "ENSG00000090863.12",
      gene_type : "protein_coding",
      gene_name : "GLG1",
      gene_level : 2,
      hgnc_id : "HGNC:4316",
      havana_gene : "OTTHUMG00000177174.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74621399,
      stop : 74666877,
      direction : "-",
      ID : "ENSG00000168411.14",
      gene_id : "ENSG00000168411.14",
      gene_type : "protein_coding",
      gene_name : "RFWD3",
      gene_level : 2,
      hgnc_id : "HGNC:25539",
      havana_gene : "OTTHUMG00000177368.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74671855,
      stop : 74700960,
      direction : "-",
      ID : "ENSG00000168404.13",
      gene_id : "ENSG00000168404.13",
      gene_type : "protein_coding",
      gene_name : "MLKL",
      gene_level : 1,
      hgnc_id : "HGNC:26617",
      havana_gene : "OTTHUMG00000177356.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74712955,
      stop : 74774831,
      direction : "-",
      ID : "ENSG00000103089.9",
      gene_id : "ENSG00000103089.9",
      gene_type : "protein_coding",
      gene_name : "FA2H",
      gene_level : 2,
      hgnc_id : "HGNC:21197",
      havana_gene : "OTTHUMG00000137603.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74871362,
      stop : 75000173,
      direction : "-",
      ID : "ENSG00000103091.15",
      gene_id : "ENSG00000103091.15",
      gene_type : "protein_coding",
      gene_name : "WDR59",
      gene_level : 2,
      hgnc_id : "HGNC:25706",
      havana_gene : "OTTHUMG00000170831.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 74999024,
      stop : 75110994,
      direction : "+",
      ID : "ENSG00000186187.12",
      gene_id : "ENSG00000186187.12",
      gene_type : "protein_coding",
      gene_name : "ZNRF1",
      gene_level : 1,
      hgnc_id : "HGNC:18452",
      havana_gene : "OTTHUMG00000137606.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75111860,
      stop : 75116780,
      direction : "-",
      ID : "ENSG00000166816.15",
      gene_id : "ENSG00000166816.15",
      gene_type : "protein_coding",
      gene_name : "LDHD",
      gene_level : 2,
      hgnc_id : "HGNC:19708",
      havana_gene : "OTTHUMG00000137605.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75148494,
      stop : 75172236,
      direction : "+",
      ID : "ENSG00000184517.12",
      gene_id : "ENSG00000184517.12",
      gene_type : "protein_coding",
      gene_name : "ZFP1",
      gene_level : 2,
      hgnc_id : "HGNC:23328",
      havana_gene : "OTTHUMG00000137602.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75204103,
      stop : 75207161,
      direction : "-",
      ID : "ENSG00000168928.13",
      gene_id : "ENSG00000168928.13",
      gene_type : "protein_coding",
      gene_name : "CTRB2",
      gene_level : 2,
      hgnc_id : "HGNC:2522",
      havana_gene : "OTTHUMG00000159271.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75218988,
      stop : 75226338,
      direction : "+",
      ID : "ENSG00000168925.12",
      gene_id : "ENSG00000168925.12",
      gene_type : "protein_coding",
      gene_name : "CTRB1",
      gene_level : 2,
      hgnc_id : "HGNC:2521",
      havana_gene : "OTTHUMG00000159272.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75228181,
      stop : 75268053,
      direction : "-",
      ID : "ENSG00000050820.17",
      gene_id : "ENSG00000050820.17",
      gene_type : "protein_coding",
      gene_name : "BCAR1",
      gene_level : 1,
      hgnc_id : "HGNC:971",
      havana_gene : "OTTHUMG00000137604.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75293698,
      stop : 75433503,
      direction : "-",
      ID : "ENSG00000153774.9",
      gene_id : "ENSG00000153774.9",
      gene_type : "protein_coding",
      gene_name : "CFDP1",
      gene_level : 1,
      hgnc_id : "HGNC:1873",
      havana_gene : "OTTHUMG00000137615.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75412684,
      stop : 75464706,
      direction : "-",
      ID : "ENSG00000261717.5",
      gene_id : "ENSG00000261717.5",
      gene_type : "protein_coding",
      gene_name : "AC009163.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177067.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75443054,
      stop : 75465497,
      direction : "-",
      ID : "ENSG00000166822.13",
      gene_id : "ENSG00000166822.13",
      gene_type : "protein_coding",
      gene_name : "TMEM170A",
      gene_level : 1,
      hgnc_id : "HGNC:29577",
      havana_gene : "OTTHUMG00000137614.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75472052,
      stop : 75495445,
      direction : "-",
      ID : "ENSG00000183196.10",
      gene_id : "ENSG00000183196.10",
      gene_type : "protein_coding",
      gene_name : "CHST6",
      gene_level : 2,
      hgnc_id : "HGNC:6938",
      havana_gene : "OTTHUMG00000137612.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75528532,
      stop : 75545428,
      direction : "-",
      ID : "ENSG00000260092.1",
      gene_id : "ENSG00000260092.1",
      gene_type : "protein_coding",
      gene_name : "AC009163.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177131.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75528535,
      stop : 75535247,
      direction : "-",
      ID : "ENSG00000135702.14",
      gene_id : "ENSG00000135702.14",
      gene_type : "protein_coding",
      gene_name : "CHST5",
      gene_level : 2,
      hgnc_id : "HGNC:1973",
      havana_gene : "OTTHUMG00000137610.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75536741,
      stop : 75556268,
      direction : "-",
      ID : "ENSG00000205084.11",
      gene_id : "ENSG00000205084.11",
      gene_type : "protein_coding",
      gene_name : "TMEM231",
      gene_level : 2,
      hgnc_id : "HGNC:37234",
      havana_gene : "OTTHUMG00000177132.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75566375,
      stop : 75577881,
      direction : "+",
      ID : "ENSG00000034713.8",
      gene_id : "ENSG00000034713.8",
      gene_type : "protein_coding",
      gene_name : "GABARAPL2",
      gene_level : 2,
      hgnc_id : "HGNC:13291",
      havana_gene : "OTTHUMG00000137613.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75596868,
      stop : 75623300,
      direction : "-",
      ID : "ENSG00000065457.11",
      gene_id : "ENSG00000065457.11",
      gene_type : "protein_coding",
      gene_name : "ADAT1",
      gene_level : 2,
      hgnc_id : "HGNC:228",
      havana_gene : "OTTHUMG00000137611.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75627474,
      stop : 75648643,
      direction : "-",
      ID : "ENSG00000065427.15",
      gene_id : "ENSG00000065427.15",
      gene_type : "protein_coding",
      gene_name : "KARS1",
      gene_level : 2,
      hgnc_id : "HGNC:6215",
      havana_gene : "OTTHUMG00000137609.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75647773,
      stop : 75761872,
      direction : "+",
      ID : "ENSG00000166848.7",
      gene_id : "ENSG00000166848.7",
      gene_type : "protein_coding",
      gene_name : "TERF2IP",
      gene_level : 1,
      hgnc_id : "HGNC:19246",
      havana_gene : "OTTHUMG00000177136.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75660227,
      stop : 75677009,
      direction : "-",
      ID : "ENSG00000284484.1",
      gene_id : "ENSG00000284484.1",
      gene_type : "protein_coding",
      gene_name : "AC025287.4",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000191919.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75693893,
      stop : 75701461,
      direction : "-",
      ID : "ENSG00000282757.4",
      gene_id : "ENSG00000282757.4",
      gene_type : "protein_coding",
      gene_name : "DUXB",
      gene_level : 2,
      hgnc_id : "HGNC:33345",
      havana_gene : "OTTHUMG00000191435.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 75714131,
      stop : 75726490,
      direction : "-",
      ID : "ENSG00000283755.2",
      gene_id : "ENSG00000283755.2",
      gene_type : "protein_coding",
      gene_name : "CPHXL",
      gene_level : 2,
      hgnc_id : "HGNC:51815",
      havana_gene : "OTTHUMG00000191920.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 76277278,
      stop : 76560757,
      direction : "+",
      ID : "ENSG00000152910.19",
      gene_id : "ENSG00000152910.19",
      gene_type : "protein_coding",
      gene_name : "CNTNAP4",
      gene_level : 2,
      hgnc_id : "HGNC:18747",
      havana_gene : "OTTHUMG00000137617.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 76277288,
      stop : 76819624,
      direction : "+",
      ID : "ENSG00000287694.1",
      gene_id : "ENSG00000287694.1",
      gene_type : "protein_coding",
      gene_name : "AC106741.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000173061.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 77190835,
      stop : 77202398,
      direction : "+",
      ID : "ENSG00000103111.15",
      gene_id : "ENSG00000103111.15",
      gene_type : "protein_coding",
      gene_name : "MON1B",
      gene_level : 1,
      hgnc_id : "HGNC:25020",
      havana_gene : "OTTHUMG00000137618.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 77199408,
      stop : 77213215,
      direction : "+",
      ID : "ENSG00000205078.6",
      gene_id : "ENSG00000205078.6",
      gene_type : "protein_coding",
      gene_name : "SYCE1L",
      gene_level : 2,
      hgnc_id : "HGNC:37236",
      havana_gene : "OTTHUMG00000176809.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 77247813,
      stop : 77435034,
      direction : "-",
      ID : "ENSG00000140873.16",
      gene_id : "ENSG00000140873.16",
      gene_type : "protein_coding",
      gene_name : "ADAMTS18",
      gene_level : 2,
      hgnc_id : "HGNC:17110",
      havana_gene : "OTTHUMG00000137619.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 77722492,
      stop : 77742260,
      direction : "+",
      ID : "ENSG00000140876.11",
      gene_id : "ENSG00000140876.11",
      gene_type : "protein_coding",
      gene_name : "NUDT7",
      gene_level : 1,
      hgnc_id : "HGNC:8054",
      havana_gene : "OTTHUMG00000176808.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 77788564,
      stop : 77980107,
      direction : "+",
      ID : "ENSG00000171724.3",
      gene_id : "ENSG00000171724.3",
      gene_type : "protein_coding",
      gene_name : "VAT1L",
      gene_level : 2,
      hgnc_id : "HGNC:29315",
      havana_gene : "OTTHUMG00000176845.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 78022515,
      stop : 78066761,
      direction : "+",
      ID : "ENSG00000166509.12",
      gene_id : "ENSG00000166509.12",
      gene_type : "protein_coding",
      gene_name : "CLEC3A",
      gene_level : 2,
      hgnc_id : "HGNC:2052",
      havana_gene : "OTTHUMG00000137620.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 78099430,
      stop : 79212667,
      direction : "+",
      ID : "ENSG00000186153.17",
      gene_id : "ENSG00000186153.17",
      gene_type : "protein_coding",
      gene_name : "WWOX",
      gene_level : 1,
      hgnc_id : "HGNC:12799",
      havana_gene : "OTTHUMG00000176851.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 79585843,
      stop : 79600737,
      direction : "-",
      ID : "ENSG00000178573.7",
      gene_id : "ENSG00000178573.7",
      gene_type : "protein_coding",
      gene_name : "MAF",
      gene_level : 2,
      hgnc_id : "HGNC:6776",
      havana_gene : "OTTHUMG00000137621.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 80540734,
      stop : 80550811,
      direction : "+",
      ID : "ENSG00000168589.15",
      gene_id : "ENSG00000168589.15",
      gene_type : "protein_coding",
      gene_name : "DYNLRB2",
      gene_level : 1,
      hgnc_id : "HGNC:15467",
      havana_gene : "OTTHUMG00000137622.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 80597907,
      stop : 80804598,
      direction : "-",
      ID : "ENSG00000166446.15",
      gene_id : "ENSG00000166446.15",
      gene_type : "protein_coding",
      gene_name : "CDYL2",
      gene_level : 1,
      hgnc_id : "HGNC:23030",
      havana_gene : "OTTHUMG00000177004.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 80828736,
      stop : 81006894,
      direction : "-",
      ID : "ENSG00000286221.1",
      gene_id : "ENSG00000286221.1",
      gene_type : "protein_coding",
      gene_name : "AC009070.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193462.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 80966448,
      stop : 81020270,
      direction : "-",
      ID : "ENSG00000103121.9",
      gene_id : "ENSG00000103121.9",
      gene_type : "protein_coding",
      gene_name : "CMC2",
      gene_level : 1,
      hgnc_id : "HGNC:24447",
      havana_gene : "OTTHUMG00000137625.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81006552,
      stop : 81033114,
      direction : "+",
      ID : "ENSG00000166451.14",
      gene_id : "ENSG00000166451.14",
      gene_type : "protein_coding",
      gene_name : "CENPN",
      gene_level : 2,
      hgnc_id : "HGNC:30873",
      havana_gene : "OTTHUMG00000137628.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81022316,
      stop : 81096284,
      direction : "-",
      ID : "ENSG00000284512.1",
      gene_id : "ENSG00000284512.1",
      gene_type : "protein_coding",
      gene_name : "AC092718.7",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192005.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81035842,
      stop : 81047350,
      direction : "+",
      ID : "ENSG00000166454.10",
      gene_id : "ENSG00000166454.10",
      gene_type : "protein_coding",
      gene_name : "ATMIN",
      gene_level : 1,
      hgnc_id : "HGNC:29034",
      havana_gene : "OTTHUMG00000176469.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81053497,
      stop : 81077267,
      direction : "-",
      ID : "ENSG00000166455.14",
      gene_id : "ENSG00000166455.14",
      gene_type : "protein_coding",
      gene_name : "C16orf46",
      gene_level : 2,
      hgnc_id : "HGNC:26525",
      havana_gene : "OTTHUMG00000137629.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81053587,
      stop : 81096296,
      direction : "-",
      ID : "ENSG00000260643.2",
      gene_id : "ENSG00000260643.2",
      gene_type : "protein_coding",
      gene_name : "AC092718.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176470.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81081945,
      stop : 81096395,
      direction : "-",
      ID : "ENSG00000140905.11",
      gene_id : "ENSG00000140905.11",
      gene_type : "protein_coding",
      gene_name : "GCSH",
      gene_level : 2,
      hgnc_id : "HGNC:4208",
      havana_gene : "OTTHUMG00000137626.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81238689,
      stop : 81291142,
      direction : "+",
      ID : "ENSG00000135697.10",
      gene_id : "ENSG00000135697.10",
      gene_type : "protein_coding",
      gene_name : "BCO1",
      gene_level : 2,
      hgnc_id : "HGNC:13815",
      havana_gene : "OTTHUMG00000137630.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81314944,
      stop : 81390809,
      direction : "+",
      ID : "ENSG00000261609.8",
      gene_id : "ENSG00000261609.8",
      gene_type : "protein_coding",
      gene_name : "GAN",
      gene_level : 2,
      hgnc_id : "HGNC:4137",
      havana_gene : "OTTHUMG00000137627.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81444808,
      stop : 81711762,
      direction : "+",
      ID : "ENSG00000153815.17",
      gene_id : "ENSG00000153815.17",
      gene_type : "protein_coding",
      gene_name : "CMIP",
      gene_level : 1,
      hgnc_id : "HGNC:24319",
      havana_gene : "OTTHUMG00000176520.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81739097,
      stop : 81962685,
      direction : "+",
      ID : "ENSG00000197943.10",
      gene_id : "ENSG00000197943.10",
      gene_type : "protein_coding",
      gene_name : "PLCG2",
      gene_level : 1,
      hgnc_id : "HGNC:9066",
      havana_gene : "OTTHUMG00000176532.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 81988855,
      stop : 82011481,
      direction : "-",
      ID : "ENSG00000184860.10",
      gene_id : "ENSG00000184860.10",
      gene_type : "protein_coding",
      gene_name : "SDR42E1",
      gene_level : 1,
      hgnc_id : "HGNC:29834",
      havana_gene : "OTTHUMG00000166148.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 82035004,
      stop : 82098534,
      direction : "+",
      ID : "ENSG00000086696.11",
      gene_id : "ENSG00000086696.11",
      gene_type : "protein_coding",
      gene_name : "HSD17B2",
      gene_level : 2,
      hgnc_id : "HGNC:5211",
      havana_gene : "OTTHUMG00000137631.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 82147798,
      stop : 82170224,
      direction : "-",
      ID : "ENSG00000135698.10",
      gene_id : "ENSG00000135698.10",
      gene_type : "protein_coding",
      gene_name : "MPHOSPH6",
      gene_level : 1,
      hgnc_id : "HGNC:7214",
      havana_gene : "OTTHUMG00000137632.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 82626965,
      stop : 83800640,
      direction : "+",
      ID : "ENSG00000140945.17",
      gene_id : "ENSG00000140945.17",
      gene_type : "protein_coding",
      gene_name : "CDH13",
      gene_level : 1,
      hgnc_id : "HGNC:1753",
      havana_gene : "OTTHUMG00000176635.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 83807978,
      stop : 83819737,
      direction : "+",
      ID : "ENSG00000230989.7",
      gene_id : "ENSG00000230989.7",
      gene_type : "protein_coding",
      gene_name : "HSBP1",
      gene_level : 2,
      hgnc_id : "HGNC:5203",
      havana_gene : "OTTHUMG00000176653.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 83899115,
      stop : 83951445,
      direction : "+",
      ID : "ENSG00000103150.7",
      gene_id : "ENSG00000103150.7",
      gene_type : "protein_coding",
      gene_name : "MLYCD",
      gene_level : 2,
      hgnc_id : "HGNC:7150",
      havana_gene : "OTTHUMG00000176654.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 83931311,
      stop : 83966332,
      direction : "+",
      ID : "ENSG00000140961.14",
      gene_id : "ENSG00000140961.14",
      gene_type : "protein_coding",
      gene_name : "OSGIN1",
      gene_level : 1,
      hgnc_id : "HGNC:30093",
      havana_gene : "OTTHUMG00000137640.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 83968244,
      stop : 84002776,
      direction : "+",
      ID : "ENSG00000103154.10",
      gene_id : "ENSG00000103154.10",
      gene_type : "protein_coding",
      gene_name : "NECAB2",
      gene_level : 2,
      hgnc_id : "HGNC:23746",
      havana_gene : "OTTHUMG00000137636.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84009667,
      stop : 84042795,
      direction : "-",
      ID : "ENSG00000166558.11",
      gene_id : "ENSG00000166558.11",
      gene_type : "protein_coding",
      gene_name : "SLC38A8",
      gene_level : 1,
      hgnc_id : "HGNC:32434",
      havana_gene : "OTTHUMG00000176588.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84053761,
      stop : 84116942,
      direction : "-",
      ID : "ENSG00000140943.17",
      gene_id : "ENSG00000140943.17",
      gene_type : "protein_coding",
      gene_name : "MBTPS1",
      gene_level : 2,
      hgnc_id : "HGNC:15456",
      havana_gene : "OTTHUMG00000137639.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84122141,
      stop : 84145192,
      direction : "-",
      ID : "ENSG00000103160.12",
      gene_id : "ENSG00000103160.12",
      gene_type : "protein_coding",
      gene_name : "HSDL1",
      gene_level : 2,
      hgnc_id : "HGNC:16475",
      havana_gene : "OTTHUMG00000137635.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84145287,
      stop : 84178767,
      direction : "+",
      ID : "ENSG00000154099.18",
      gene_id : "ENSG00000154099.18",
      gene_type : "protein_coding",
      gene_name : "DNAAF1",
      gene_level : 1,
      hgnc_id : "HGNC:30539",
      havana_gene : "OTTHUMG00000128517.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84177847,
      stop : 84187070,
      direction : "-",
      ID : "ENSG00000103168.17",
      gene_id : "ENSG00000103168.17",
      gene_type : "protein_coding",
      gene_name : "TAF1C",
      gene_level : 2,
      hgnc_id : "HGNC:11534",
      havana_gene : "OTTHUMG00000176665.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84191138,
      stop : 84197168,
      direction : "+",
      ID : "ENSG00000140955.11",
      gene_id : "ENSG00000140955.11",
      gene_type : "protein_coding",
      gene_name : "ADAD2",
      gene_level : 1,
      hgnc_id : "HGNC:30714",
      havana_gene : "OTTHUMG00000137637.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84218667,
      stop : 84239750,
      direction : "-",
      ID : "ENSG00000168418.7",
      gene_id : "ENSG00000168418.7",
      gene_type : "protein_coding",
      gene_name : "KCNG4",
      gene_level : 2,
      hgnc_id : "HGNC:19697",
      havana_gene : "OTTHUMG00000137638.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84294846,
      stop : 84329844,
      direction : "+",
      ID : "ENSG00000103175.11",
      gene_id : "ENSG00000103175.11",
      gene_type : "protein_coding",
      gene_name : "WFDC1",
      gene_level : 2,
      hgnc_id : "HGNC:15466",
      havana_gene : "OTTHUMG00000137641.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84368527,
      stop : 84464187,
      direction : "+",
      ID : "ENSG00000064270.13",
      gene_id : "ENSG00000064270.13",
      gene_type : "protein_coding",
      gene_name : "ATP2C2",
      gene_level : 1,
      hgnc_id : "HGNC:29103",
      havana_gene : "OTTHUMG00000176737.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84476355,
      stop : 84554033,
      direction : "-",
      ID : "ENSG00000140950.16",
      gene_id : "ENSG00000140950.16",
      gene_type : "protein_coding",
      gene_name : "MEAK7",
      gene_level : 2,
      hgnc_id : "HGNC:29325",
      havana_gene : "OTTHUMG00000176739.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84565596,
      stop : 84618078,
      direction : "-",
      ID : "ENSG00000103187.8",
      gene_id : "ENSG00000103187.8",
      gene_type : "protein_coding",
      gene_name : "COTL1",
      gene_level : 2,
      hgnc_id : "HGNC:18304",
      havana_gene : "OTTHUMG00000137634.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84648511,
      stop : 84667686,
      direction : "+",
      ID : "ENSG00000135686.13",
      gene_id : "ENSG00000135686.13",
      gene_type : "protein_coding",
      gene_name : "KLHL36",
      gene_level : 2,
      hgnc_id : "HGNC:17844",
      havana_gene : "OTTHUMG00000137642.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84699986,
      stop : 84779922,
      direction : "+",
      ID : "ENSG00000103194.16",
      gene_id : "ENSG00000103194.16",
      gene_type : "protein_coding",
      gene_name : "USP10",
      gene_level : 2,
      hgnc_id : "HGNC:12608",
      havana_gene : "OTTHUMG00000176770.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84819985,
      stop : 84920768,
      direction : "+",
      ID : "ENSG00000103196.12",
      gene_id : "ENSG00000103196.12",
      gene_type : "protein_coding",
      gene_name : "CRISPLD2",
      gene_level : 1,
      hgnc_id : "HGNC:25248",
      havana_gene : "OTTHUMG00000137644.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 84974175,
      stop : 85011535,
      direction : "-",
      ID : "ENSG00000153786.13",
      gene_id : "ENSG00000153786.13",
      gene_type : "protein_coding",
      gene_name : "ZDHHC7",
      gene_level : 2,
      hgnc_id : "HGNC:18459",
      havana_gene : "OTTHUMG00000137645.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85027751,
      stop : 85094230,
      direction : "+",
      ID : "ENSG00000135709.12",
      gene_id : "ENSG00000135709.12",
      gene_type : "protein_coding",
      gene_name : "KIAA0513",
      gene_level : 2,
      hgnc_id : "HGNC:29058",
      havana_gene : "OTTHUMG00000176597.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85098358,
      stop : 85112472,
      direction : "-",
      ID : "ENSG00000153789.13",
      gene_id : "ENSG00000153789.13",
      gene_type : "protein_coding",
      gene_name : "CIBAR2",
      gene_level : 2,
      hgnc_id : "HGNC:24781",
      havana_gene : "OTTHUMG00000187060.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85169525,
      stop : 85676204,
      direction : "+",
      ID : "ENSG00000131149.19",
      gene_id : "ENSG00000131149.19",
      gene_type : "protein_coding",
      gene_name : "GSE1",
      gene_level : 2,
      hgnc_id : "HGNC:28979",
      havana_gene : "OTTHUMG00000137650.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85676198,
      stop : 85690073,
      direction : "-",
      ID : "ENSG00000131153.9",
      gene_id : "ENSG00000131153.9",
      gene_type : "protein_coding",
      gene_name : "GINS2",
      gene_level : 1,
      hgnc_id : "HGNC:24575",
      havana_gene : "OTTHUMG00000137646.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85690084,
      stop : 85751129,
      direction : "-",
      ID : "ENSG00000154102.11",
      gene_id : "ENSG00000154102.11",
      gene_type : "protein_coding",
      gene_name : "C16orf74",
      gene_level : 1,
      hgnc_id : "HGNC:23362",
      havana_gene : "OTTHUMG00000183875.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85771758,
      stop : 85799608,
      direction : "-",
      ID : "ENSG00000131148.9",
      gene_id : "ENSG00000131148.9",
      gene_type : "protein_coding",
      gene_name : "EMC8",
      gene_level : 2,
      hgnc_id : "HGNC:7864",
      havana_gene : "OTTHUMG00000137647.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85798633,
      stop : 85807068,
      direction : "+",
      ID : "ENSG00000131143.10",
      gene_id : "ENSG00000131143.10",
      gene_type : "protein_coding",
      gene_name : "COX4I1",
      gene_level : 1,
      hgnc_id : "HGNC:2265",
      havana_gene : "OTTHUMG00000137649.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 85899162,
      stop : 85922606,
      direction : "+",
      ID : "ENSG00000140968.11",
      gene_id : "ENSG00000140968.11",
      gene_type : "protein_coding",
      gene_name : "IRF8",
      gene_level : 2,
      hgnc_id : "HGNC:5358",
      havana_gene : "OTTHUMG00000137648.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 86510527,
      stop : 86515422,
      direction : "+",
      ID : "ENSG00000103241.7",
      gene_id : "ENSG00000103241.7",
      gene_type : "protein_coding",
      gene_name : "FOXF1",
      gene_level : 1,
      hgnc_id : "HGNC:3809",
      havana_gene : "OTTHUMG00000137651.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 86530178,
      stop : 86555235,
      direction : "-",
      ID : "ENSG00000103248.19",
      gene_id : "ENSG00000103248.19",
      gene_type : "protein_coding",
      gene_name : "MTHFSD",
      gene_level : 1,
      hgnc_id : "HGNC:25778",
      havana_gene : "OTTHUMG00000176480.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 86566829,
      stop : 86569728,
      direction : "+",
      ID : "ENSG00000176692.8",
      gene_id : "ENSG00000176692.8",
      gene_type : "protein_coding",
      gene_name : "FOXC2",
      gene_level : 2,
      hgnc_id : "HGNC:3801",
      havana_gene : "OTTHUMG00000137652.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 86576368,
      stop : 86583478,
      direction : "+",
      ID : "ENSG00000176678.6",
      gene_id : "ENSG00000176678.6",
      gene_type : "protein_coding",
      gene_name : "FOXL1",
      gene_level : 2,
      hgnc_id : "HGNC:3817",
      havana_gene : "OTTHUMG00000137653.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87083562,
      stop : 87317420,
      direction : "-",
      ID : "ENSG00000260456.7",
      gene_id : "ENSG00000260456.7",
      gene_type : "protein_coding",
      gene_name : "C16orf95",
      gene_level : 2,
      hgnc_id : "HGNC:40033",
      havana_gene : "OTTHUMG00000175680.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87302876,
      stop : 87334273,
      direction : "-",
      ID : "ENSG00000131152.4",
      gene_id : "ENSG00000131152.4",
      gene_type : "protein_coding",
      gene_name : "AC010531.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000175684.1",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87326987,
      stop : 87392142,
      direction : "-",
      ID : "ENSG00000103264.18",
      gene_id : "ENSG00000103264.18",
      gene_type : "protein_coding",
      gene_name : "FBXO31",
      gene_level : 1,
      hgnc_id : "HGNC:16510",
      havana_gene : "OTTHUMG00000175685.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87383953,
      stop : 87404779,
      direction : "+",
      ID : "ENSG00000140941.14",
      gene_id : "ENSG00000140941.14",
      gene_type : "protein_coding",
      gene_name : "MAP1LC3B",
      gene_level : 2,
      hgnc_id : "HGNC:13352",
      havana_gene : "OTTHUMG00000137654.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87406246,
      stop : 87493024,
      direction : "-",
      ID : "ENSG00000140948.13",
      gene_id : "ENSG00000140948.13",
      gene_type : "protein_coding",
      gene_name : "ZCCHC14",
      gene_level : 2,
      hgnc_id : "HGNC:24134",
      havana_gene : "OTTHUMG00000137655.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87601835,
      stop : 87698156,
      direction : "+",
      ID : "ENSG00000154118.13",
      gene_id : "ENSG00000154118.13",
      gene_type : "protein_coding",
      gene_name : "JPH3",
      gene_level : 1,
      hgnc_id : "HGNC:14203",
      havana_gene : "OTTHUMG00000137656.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87696485,
      stop : 87765992,
      direction : "-",
      ID : "ENSG00000104731.14",
      gene_id : "ENSG00000104731.14",
      gene_type : "protein_coding",
      gene_name : "KLHDC4",
      gene_level : 2,
      hgnc_id : "HGNC:25272",
      havana_gene : "OTTHUMG00000137657.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87830023,
      stop : 87869507,
      direction : "-",
      ID : "ENSG00000103257.9",
      gene_id : "ENSG00000103257.9",
      gene_type : "protein_coding",
      gene_name : "SLC7A5",
      gene_level : 2,
      hgnc_id : "HGNC:11063",
      havana_gene : "OTTHUMG00000137658.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87881546,
      stop : 87936580,
      direction : "-",
      ID : "ENSG00000174990.8",
      gene_id : "ENSG00000174990.8",
      gene_type : "protein_coding",
      gene_name : "CA5A",
      gene_level : 2,
      hgnc_id : "HGNC:1377",
      havana_gene : "OTTHUMG00000137677.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 87949244,
      stop : 88077318,
      direction : "+",
      ID : "ENSG00000172530.20",
      gene_id : "ENSG00000172530.20",
      gene_type : "protein_coding",
      gene_name : "BANP",
      gene_level : 2,
      hgnc_id : "HGNC:13450",
      havana_gene : "OTTHUMG00000137678.9",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88382959,
      stop : 88440757,
      direction : "+",
      ID : "ENSG00000225614.4",
      gene_id : "ENSG00000225614.4",
      gene_type : "protein_coding",
      gene_name : "ZNF469",
      gene_level : 2,
      hgnc_id : "HGNC:23216",
      havana_gene : "OTTHUMG00000173151.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88453280,
      stop : 88537031,
      direction : "+",
      ID : "ENSG00000179588.9",
      gene_id : "ENSG00000179588.9",
      gene_type : "protein_coding",
      gene_name : "ZFPM1",
      gene_level : 2,
      hgnc_id : "HGNC:19762",
      havana_gene : "OTTHUMG00000173152.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88570403,
      stop : 88631964,
      direction : "+",
      ID : "ENSG00000158545.16",
      gene_id : "ENSG00000158545.16",
      gene_type : "protein_coding",
      gene_name : "ZC3H18",
      gene_level : 1,
      hgnc_id : "HGNC:25091",
      havana_gene : "OTTHUMG00000137679.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88638572,
      stop : 88640468,
      direction : "+",
      ID : "ENSG00000124391.5",
      gene_id : "ENSG00000124391.5",
      gene_type : "protein_coding",
      gene_name : "IL17C",
      gene_level : 2,
      hgnc_id : "HGNC:5983",
      havana_gene : "OTTHUMG00000173241.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88643289,
      stop : 88651054,
      direction : "-",
      ID : "ENSG00000051523.11",
      gene_id : "ENSG00000051523.11",
      gene_type : "protein_coding",
      gene_name : "CYBA",
      gene_level : 1,
      hgnc_id : "HGNC:2577",
      havana_gene : "OTTHUMG00000173320.5",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88651935,
      stop : 88663161,
      direction : "-",
      ID : "ENSG00000167508.12",
      gene_id : "ENSG00000167508.12",
      gene_type : "protein_coding",
      gene_name : "MVD",
      gene_level : 1,
      hgnc_id : "HGNC:7529",
      havana_gene : "OTTHUMG00000137865.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88677688,
      stop : 88686507,
      direction : "-",
      ID : "ENSG00000185669.6",
      gene_id : "ENSG00000185669.6",
      gene_type : "protein_coding",
      gene_name : "SNAI3",
      gene_level : 2,
      hgnc_id : "HGNC:18411",
      havana_gene : "OTTHUMG00000173243.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88696499,
      stop : 88706408,
      direction : "-",
      ID : "ENSG00000158717.11",
      gene_id : "ENSG00000158717.11",
      gene_type : "protein_coding",
      gene_name : "RNF166",
      gene_level : 2,
      hgnc_id : "HGNC:28856",
      havana_gene : "OTTHUMG00000137863.8",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88706483,
      stop : 88715396,
      direction : "+",
      ID : "ENSG00000174177.13",
      gene_id : "ENSG00000174177.13",
      gene_type : "protein_coding",
      gene_name : "CTU2",
      gene_level : 2,
      hgnc_id : "HGNC:28005",
      havana_gene : "OTTHUMG00000173417.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88715338,
      stop : 88785220,
      direction : "-",
      ID : "ENSG00000103335.22",
      gene_id : "ENSG00000103335.22",
      gene_type : "protein_coding",
      gene_name : "PIEZO1",
      gene_level : 1,
      hgnc_id : "HGNC:28993",
      havana_gene : "OTTHUMG00000156776.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88803789,
      stop : 88809258,
      direction : "+",
      ID : "ENSG00000167513.9",
      gene_id : "ENSG00000167513.9",
      gene_type : "protein_coding",
      gene_name : "CDT1",
      gene_level : 2,
      hgnc_id : "HGNC:24576",
      havana_gene : "OTTHUMG00000173467.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88809339,
      stop : 88811937,
      direction : "-",
      ID : "ENSG00000198931.11",
      gene_id : "ENSG00000198931.11",
      gene_type : "protein_coding",
      gene_name : "APRT",
      gene_level : 2,
      hgnc_id : "HGNC:626",
      havana_gene : "OTTHUMG00000175454.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88813734,
      stop : 88856970,
      direction : "-",
      ID : "ENSG00000141012.13",
      gene_id : "ENSG00000141012.13",
      gene_type : "protein_coding",
      gene_name : "GALNS",
      gene_level : 1,
      hgnc_id : "HGNC:4122",
      havana_gene : "OTTHUMG00000137862.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88856220,
      stop : 88862686,
      direction : "+",
      ID : "ENSG00000167515.10",
      gene_id : "ENSG00000167515.10",
      gene_type : "protein_coding",
      gene_name : "TRAPPC2L",
      gene_level : 1,
      hgnc_id : "HGNC:30887",
      havana_gene : "OTTHUMG00000137861.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88863333,
      stop : 88866660,
      direction : "-",
      ID : "ENSG00000205022.9",
      gene_id : "ENSG00000205022.9",
      gene_type : "protein_coding",
      gene_name : "PABPN1L",
      gene_level : 2,
      hgnc_id : "HGNC:37237",
      havana_gene : "OTTHUMG00000170127.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 88874858,
      stop : 88977207,
      direction : "-",
      ID : "ENSG00000129993.15",
      gene_id : "ENSG00000129993.15",
      gene_type : "protein_coding",
      gene_name : "CBFA2T3",
      gene_level : 2,
      hgnc_id : "HGNC:1537",
      havana_gene : "OTTHUMG00000137864.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89088375,
      stop : 89164121,
      direction : "+",
      ID : "ENSG00000176715.17",
      gene_id : "ENSG00000176715.17",
      gene_type : "protein_coding",
      gene_name : "ACSF3",
      gene_level : 1,
      hgnc_id : "HGNC:27288",
      havana_gene : "OTTHUMG00000138044.16",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89171748,
      stop : 89195492,
      direction : "+",
      ID : "ENSG00000129910.8",
      gene_id : "ENSG00000129910.8",
      gene_type : "protein_coding",
      gene_name : "CDH15",
      gene_level : 2,
      hgnc_id : "HGNC:1754",
      havana_gene : "OTTHUMG00000138045.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89195761,
      stop : 89201651,
      direction : "-",
      ID : "ENSG00000259803.7",
      gene_id : "ENSG00000259803.7",
      gene_type : "protein_coding",
      gene_name : "SLC22A31",
      gene_level : 2,
      hgnc_id : "HGNC:27091",
      havana_gene : "OTTHUMG00000175615.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89217703,
      stop : 89237141,
      direction : "+",
      ID : "ENSG00000170100.14",
      gene_id : "ENSG00000170100.14",
      gene_type : "protein_coding",
      gene_name : "ZNF778",
      gene_level : 2,
      hgnc_id : "HGNC:26479",
      havana_gene : "OTTHUMG00000175526.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89267630,
      stop : 89490561,
      direction : "-",
      ID : "ENSG00000167522.16",
      gene_id : "ENSG00000167522.16",
      gene_type : "protein_coding",
      gene_name : "ANKRD11",
      gene_level : 1,
      hgnc_id : "HGNC:21316",
      havana_gene : "OTTHUMG00000175548.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89490719,
      stop : 89557766,
      direction : "+",
      ID : "ENSG00000197912.16",
      gene_id : "ENSG00000197912.16",
      gene_type : "protein_coding",
      gene_name : "SPG7",
      gene_level : 1,
      hgnc_id : "HGNC:11237",
      havana_gene : "OTTHUMG00000138046.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89560677,
      stop : 89564542,
      direction : "+",
      ID : "ENSG00000167526.14",
      gene_id : "ENSG00000167526.14",
      gene_type : "protein_coding",
      gene_name : "RPL13",
      gene_level : 1,
      hgnc_id : "HGNC:10303",
      havana_gene : "OTTHUMG00000133770.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89575758,
      stop : 89597246,
      direction : "+",
      ID : "ENSG00000178773.15",
      gene_id : "ENSG00000178773.15",
      gene_type : "protein_coding",
      gene_name : "CPNE7",
      gene_level : 1,
      hgnc_id : "HGNC:2320",
      havana_gene : "OTTHUMG00000138051.6",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89613308,
      stop : 89638456,
      direction : "+",
      ID : "ENSG00000015413.9",
      gene_id : "ENSG00000015413.9",
      gene_type : "protein_coding",
      gene_name : "DPEP1",
      gene_level : 2,
      hgnc_id : "HGNC:3002",
      havana_gene : "OTTHUMG00000138052.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89640816,
      stop : 89657738,
      direction : "-",
      ID : "ENSG00000131165.16",
      gene_id : "ENSG00000131165.16",
      gene_type : "protein_coding",
      gene_name : "CHMP1A",
      gene_level : 1,
      hgnc_id : "HGNC:8740",
      havana_gene : "OTTHUMG00000169521.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89657740,
      stop : 89671272,
      direction : "+",
      ID : "ENSG00000167523.14",
      gene_id : "ENSG00000167523.14",
      gene_type : "protein_coding",
      gene_name : "SPATA33",
      gene_level : 1,
      hgnc_id : "HGNC:26463",
      havana_gene : "OTTHUMG00000138048.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89680737,
      stop : 89696354,
      direction : "+",
      ID : "ENSG00000185324.22",
      gene_id : "ENSG00000185324.22",
      gene_type : "protein_coding",
      gene_name : "CDK10",
      gene_level : 1,
      hgnc_id : "HGNC:1770",
      havana_gene : "OTTHUMG00000138049.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89696357,
      stop : 89701705,
      direction : "-",
      ID : "ENSG00000158792.16",
      gene_id : "ENSG00000158792.16",
      gene_type : "protein_coding",
      gene_name : "SPATA2L",
      gene_level : 2,
      hgnc_id : "HGNC:28393",
      havana_gene : "OTTHUMG00000138047.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89707134,
      stop : 89720898,
      direction : "-",
      ID : "ENSG00000075399.14",
      gene_id : "ENSG00000075399.14",
      gene_type : "protein_coding",
      gene_name : "VPS9D1",
      gene_level : 2,
      hgnc_id : "HGNC:13526",
      havana_gene : "OTTHUMG00000173219.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89720400,
      stop : 89740925,
      direction : "+",
      ID : "ENSG00000158805.12",
      gene_id : "ENSG00000158805.12",
      gene_type : "protein_coding",
      gene_name : "ZNF276",
      gene_level : 2,
      hgnc_id : "HGNC:23330",
      havana_gene : "OTTHUMG00000138050.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89737549,
      stop : 89816657,
      direction : "-",
      ID : "ENSG00000187741.15",
      gene_id : "ENSG00000187741.15",
      gene_type : "protein_coding",
      gene_name : "FANCA",
      gene_level : 2,
      hgnc_id : "HGNC:3582",
      havana_gene : "OTTHUMG00000173049.7",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89818179,
      stop : 89871319,
      direction : "+",
      ID : "ENSG00000204991.11",
      gene_id : "ENSG00000204991.11",
      gene_type : "protein_coding",
      gene_name : "SPIRE2",
      gene_level : 2,
      hgnc_id : "HGNC:30623",
      havana_gene : "OTTHUMG00000173039.3",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89873570,
      stop : 89913627,
      direction : "+",
      ID : "ENSG00000141002.20",
      gene_id : "ENSG00000141002.20",
      gene_type : "protein_coding",
      gene_name : "TCF25",
      gene_level : 1,
      hgnc_id : "HGNC:29181",
      havana_gene : "OTTHUMG00000138986.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89912119,
      stop : 89920973,
      direction : "+",
      ID : "ENSG00000258839.4",
      gene_id : "ENSG00000258839.4",
      gene_type : "protein_coding",
      gene_name : "MC1R",
      gene_level : 2,
      hgnc_id : "HGNC:6929",
      havana_gene : "OTTHUMG00000171163.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89919165,
      stop : 89936092,
      direction : "+",
      ID : "ENSG00000198211.8",
      gene_id : "ENSG00000198211.8",
      gene_type : "protein_coding",
      gene_name : "AC092143.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171162.2",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89921392,
      stop : 89938761,
      direction : "+",
      ID : "ENSG00000258947.8",
      gene_id : "ENSG00000258947.8",
      gene_type : "protein_coding",
      gene_name : "TUBB3",
      gene_level : 1,
      hgnc_id : "HGNC:20772",
      havana_gene : "OTTHUMG00000138985.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 89948697,
      stop : 89968060,
      direction : "+",
      ID : "ENSG00000140995.17",
      gene_id : "ENSG00000140995.17",
      gene_type : "protein_coding",
      gene_name : "DEF8",
      gene_level : 2,
      hgnc_id : "HGNC:25969",
      havana_gene : "OTTHUMG00000138989.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 90004871,
      stop : 90019890,
      direction : "-",
      ID : "ENSG00000003249.15",
      gene_id : "ENSG00000003249.15",
      gene_type : "protein_coding",
      gene_name : "DBNDD1",
      gene_level : 2,
      hgnc_id : "HGNC:28455",
      havana_gene : "OTTHUMG00000138984.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 90019629,
      stop : 90044975,
      direction : "+",
      ID : "ENSG00000141013.17",
      gene_id : "ENSG00000141013.17",
      gene_type : "protein_coding",
      gene_name : "GAS8",
      gene_level : 2,
      hgnc_id : "HGNC:4166",
      havana_gene : "OTTHUMG00000138988.4",
      tag : null
    },
    {
      chromosome : 16,
      annotation : "HAVANA",
      type : "gene",
      start : 90056566,
      stop : 90092072,
      direction : "-",
      ID : "ENSG00000126856.16",
      gene_id : "ENSG00000126856.16",
      gene_type : "protein_coding",
      gene_name : "PRDM7",
      gene_level : 2,
      hgnc_id : "HGNC:9351",
      havana_gene : "OTTHUMG00000138990.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 137569,
      stop : 139067,
      direction : "+",
      ID : "ENSG00000268320.4",
      gene_id : "ENSG00000268320.4",
      gene_type : "protein_coding",
      gene_name : "SCGB1C2",
      gene_level : 2,
      hgnc_id : "HGNC:51242",
      havana_gene : "OTTHUMG00000189257.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 142789,
      stop : 181650,
      direction : "-",
      ID : "ENSG00000272636.4",
      gene_id : "ENSG00000272636.4",
      gene_type : "protein_coding",
      gene_name : "DOC2B",
      gene_level : 2,
      hgnc_id : "HGNC:2986",
      havana_gene : "OTTHUMG00000154415.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 212389,
      stop : 386254,
      direction : "-",
      ID : "ENSG00000181031.16",
      gene_id : "ENSG00000181031.16",
      gene_type : "protein_coding",
      gene_name : "RPH3AL",
      gene_level : 1,
      hgnc_id : "HGNC:10296",
      havana_gene : "OTTHUMG00000090273.11",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 410325,
      stop : 431062,
      direction : "+",
      ID : "ENSG00000187624.9",
      gene_id : "ENSG00000187624.9",
      gene_type : "protein_coding",
      gene_name : "C17orf97",
      gene_level : 1,
      hgnc_id : "HGNC:33800",
      havana_gene : "OTTHUMG00000132479.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 439978,
      stop : 445939,
      direction : "-",
      ID : "ENSG00000183688.4",
      gene_id : "ENSG00000183688.4",
      gene_type : "protein_coding",
      gene_name : "RFLNB",
      gene_level : 2,
      hgnc_id : "HGNC:28705",
      havana_gene : "OTTHUMG00000132483.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 508503,
      stop : 721717,
      direction : "-",
      ID : "ENSG00000141252.21",
      gene_id : "ENSG00000141252.21",
      gene_type : "protein_coding",
      gene_name : "VPS53",
      gene_level : 1,
      hgnc_id : "HGNC:25608",
      havana_gene : "OTTHUMG00000177441.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 732412,
      stop : 742968,
      direction : "+",
      ID : "ENSG00000167695.15",
      gene_id : "ENSG00000167695.15",
      gene_type : "protein_coding",
      gene_name : "TLCD3A",
      gene_level : 1,
      hgnc_id : "HGNC:29646",
      havana_gene : "OTTHUMG00000177491.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 744421,
      stop : 753999,
      direction : "-",
      ID : "ENSG00000179409.11",
      gene_id : "ENSG00000179409.11",
      gene_type : "protein_coding",
      gene_name : "GEMIN4",
      gene_level : 1,
      hgnc_id : "HGNC:15717",
      havana_gene : "OTTHUMG00000177495.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 757097,
      stop : 783390,
      direction : "-",
      ID : "ENSG00000167699.13",
      gene_id : "ENSG00000167699.13",
      gene_type : "protein_coding",
      gene_name : "GLOD4",
      gene_level : 2,
      hgnc_id : "HGNC:14111",
      havana_gene : "OTTHUMG00000177497.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 782353,
      stop : 792509,
      direction : "+",
      ID : "ENSG00000171861.11",
      gene_id : "ENSG00000171861.11",
      gene_type : "protein_coding",
      gene_name : "MRM3",
      gene_level : 2,
      hgnc_id : "HGNC:18485",
      havana_gene : "OTTHUMG00000090285.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 799310,
      stop : 979776,
      direction : "-",
      ID : "ENSG00000167693.17",
      gene_id : "ENSG00000167693.17",
      gene_type : "protein_coding",
      gene_name : "NXN",
      gene_level : 2,
      hgnc_id : "HGNC:18008",
      havana_gene : "OTTHUMG00000090307.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 997129,
      stop : 1003671,
      direction : "+",
      ID : "ENSG00000177370.5",
      gene_id : "ENSG00000177370.5",
      gene_type : "protein_coding",
      gene_name : "TIMM22",
      gene_level : 2,
      hgnc_id : "HGNC:17317",
      havana_gene : "OTTHUMG00000180175.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1003518,
      stop : 1229738,
      direction : "-",
      ID : "ENSG00000159842.15",
      gene_id : "ENSG00000159842.15",
      gene_type : "protein_coding",
      gene_name : "ABR",
      gene_level : 1,
      hgnc_id : "HGNC:81",
      havana_gene : "OTTHUMG00000090313.18",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1270444,
      stop : 1271815,
      direction : "+",
      ID : "ENSG00000205899.4",
      gene_id : "ENSG00000205899.4",
      gene_type : "protein_coding",
      gene_name : "BHLHA9",
      gene_level : 2,
      hgnc_id : "HGNC:35126",
      havana_gene : "OTTHUMG00000132192.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1279662,
      stop : 1300978,
      direction : "+",
      ID : "ENSG00000184811.4",
      gene_id : "ENSG00000184811.4",
      gene_type : "protein_coding",
      gene_name : "TRARG1",
      gene_level : 2,
      hgnc_id : "HGNC:29592",
      havana_gene : "OTTHUMG00000132196.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1344275,
      stop : 1400222,
      direction : "-",
      ID : "ENSG00000108953.17",
      gene_id : "ENSG00000108953.17",
      gene_type : "protein_coding",
      gene_name : "YWHAE",
      gene_level : 1,
      hgnc_id : "HGNC:12851",
      havana_gene : "OTTHUMG00000134316.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1420689,
      stop : 1463162,
      direction : "-",
      ID : "ENSG00000167193.8",
      gene_id : "ENSG00000167193.8",
      gene_type : "protein_coding",
      gene_name : "CRK",
      gene_level : 2,
      hgnc_id : "HGNC:2362",
      havana_gene : "OTTHUMG00000090317.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1464186,
      stop : 1492686,
      direction : "-",
      ID : "ENSG00000197879.17",
      gene_id : "ENSG00000197879.17",
      gene_type : "protein_coding",
      gene_name : "MYO1C",
      gene_level : 2,
      hgnc_id : "HGNC:7597",
      havana_gene : "OTTHUMG00000090323.17",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1494577,
      stop : 1516742,
      direction : "-",
      ID : "ENSG00000132376.20",
      gene_id : "ENSG00000132376.20",
      gene_type : "protein_coding",
      gene_name : "INPP5K",
      gene_level : 2,
      hgnc_id : "HGNC:33882",
      havana_gene : "OTTHUMG00000150648.16",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1517718,
      stop : 1562792,
      direction : "-",
      ID : "ENSG00000174238.15",
      gene_id : "ENSG00000174238.15",
      gene_type : "protein_coding",
      gene_name : "PITPNA",
      gene_level : 2,
      hgnc_id : "HGNC:9001",
      havana_gene : "OTTHUMG00000177779.11",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1569268,
      stop : 1628886,
      direction : "-",
      ID : "ENSG00000167703.15",
      gene_id : "ENSG00000167703.15",
      gene_type : "protein_coding",
      gene_name : "SLC43A2",
      gene_level : 1,
      hgnc_id : "HGNC:23087",
      havana_gene : "OTTHUMG00000090345.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1633858,
      stop : 1645744,
      direction : "-",
      ID : "ENSG00000074660.16",
      gene_id : "ENSG00000074660.16",
      gene_type : "protein_coding",
      gene_name : "SCARF1",
      gene_level : 2,
      hgnc_id : "HGNC:16820",
      havana_gene : "OTTHUMG00000090555.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1646145,
      stop : 1649866,
      direction : "-",
      ID : "ENSG00000167705.12",
      gene_id : "ENSG00000167705.12",
      gene_type : "protein_coding",
      gene_name : "RILP",
      gene_level : 2,
      hgnc_id : "HGNC:30266",
      havana_gene : "OTTHUMG00000090554.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1650629,
      stop : 1684867,
      direction : "-",
      ID : "ENSG00000174231.17",
      gene_id : "ENSG00000174231.17",
      gene_type : "protein_coding",
      gene_name : "PRPF8",
      gene_level : 1,
      hgnc_id : "HGNC:17340",
      havana_gene : "OTTHUMG00000090553.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1702816,
      stop : 1710377,
      direction : "-",
      ID : "ENSG00000185561.10",
      gene_id : "ENSG00000185561.10",
      gene_type : "protein_coding",
      gene_name : "TLCD2",
      gene_level : 1,
      hgnc_id : "HGNC:33522",
      havana_gene : "OTTHUMG00000132477.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1716523,
      stop : 1738599,
      direction : "+",
      ID : "ENSG00000167716.19",
      gene_id : "ENSG00000167716.19",
      gene_type : "protein_coding",
      gene_name : "WDR81",
      gene_level : 1,
      hgnc_id : "HGNC:26600",
      havana_gene : "OTTHUMG00000153941.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1742836,
      stop : 1755265,
      direction : "+",
      ID : "ENSG00000167711.14",
      gene_id : "ENSG00000167711.14",
      gene_type : "protein_coding",
      gene_name : "SERPINF2",
      gene_level : 1,
      hgnc_id : "HGNC:9075",
      havana_gene : "OTTHUMG00000090552.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1762029,
      stop : 1777565,
      direction : "+",
      ID : "ENSG00000132386.11",
      gene_id : "ENSG00000132386.11",
      gene_type : "protein_coding",
      gene_name : "SERPINF1",
      gene_level : 1,
      hgnc_id : "HGNC:8824",
      havana_gene : "OTTHUMG00000090571.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1779485,
      stop : 1830634,
      direction : "-",
      ID : "ENSG00000186532.12",
      gene_id : "ENSG00000186532.12",
      gene_type : "protein_coding",
      gene_name : "SMYD4",
      gene_level : 2,
      hgnc_id : "HGNC:21067",
      havana_gene : "OTTHUMG00000090570.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1829702,
      stop : 1900082,
      direction : "+",
      ID : "ENSG00000132383.12",
      gene_id : "ENSG00000132383.12",
      gene_type : "protein_coding",
      gene_name : "RPA1",
      gene_level : 1,
      hgnc_id : "HGNC:10289",
      havana_gene : "OTTHUMG00000090579.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 1934677,
      stop : 2025334,
      direction : "-",
      ID : "ENSG00000185924.7",
      gene_id : "ENSG00000185924.7",
      gene_type : "protein_coding",
      gene_name : "RTN4RL1",
      gene_level : 2,
      hgnc_id : "HGNC:21329",
      havana_gene : "OTTHUMG00000180184.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2030137,
      stop : 2043898,
      direction : "+",
      ID : "ENSG00000108963.19",
      gene_id : "ENSG00000108963.19",
      gene_type : "protein_coding",
      gene_name : "DPH1",
      gene_level : 2,
      hgnc_id : "HGNC:3003",
      havana_gene : "OTTHUMG00000177724.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2042022,
      stop : 2043425,
      direction : "+",
      ID : "ENSG00000262664.3",
      gene_id : "ENSG00000262664.3",
      gene_type : "protein_coding",
      gene_name : "OVCA2",
      gene_level : 2,
      hgnc_id : "HGNC:24203",
      havana_gene : "OTTHUMG00000132471.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2054154,
      stop : 2063241,
      direction : "+",
      ID : "ENSG00000177374.13",
      gene_id : "ENSG00000177374.13",
      gene_type : "protein_coding",
      gene_name : "HIC1",
      gene_level : 2,
      hgnc_id : "HGNC:4909",
      havana_gene : "OTTHUMG00000177635.11",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2059839,
      stop : 2303785,
      direction : "-",
      ID : "ENSG00000070366.14",
      gene_id : "ENSG00000070366.14",
      gene_type : "protein_coding",
      gene_name : "SMG6",
      gene_level : 1,
      hgnc_id : "HGNC:17809",
      havana_gene : "OTTHUMG00000177578.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2303383,
      stop : 2325260,
      direction : "+",
      ID : "ENSG00000167720.13",
      gene_id : "ENSG00000167720.13",
      gene_type : "protein_coding",
      gene_name : "SRR",
      gene_level : 2,
      hgnc_id : "HGNC:14398",
      havana_gene : "OTTHUMG00000090583.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2322396,
      stop : 2336657,
      direction : "-",
      ID : "ENSG00000167721.11",
      gene_id : "ENSG00000167721.11",
      gene_type : "protein_coding",
      gene_name : "TSR1",
      gene_level : 2,
      hgnc_id : "HGNC:25542",
      havana_gene : "OTTHUMG00000177636.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2337498,
      stop : 2381058,
      direction : "+",
      ID : "ENSG00000141258.13",
      gene_id : "ENSG00000141258.13",
      gene_type : "protein_coding",
      gene_name : "SGSM2",
      gene_level : 1,
      hgnc_id : "HGNC:29026",
      havana_gene : "OTTHUMG00000177637.12",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2384073,
      stop : 2401104,
      direction : "-",
      ID : "ENSG00000070444.15",
      gene_id : "ENSG00000070444.15",
      gene_type : "protein_coding",
      gene_name : "MNT",
      gene_level : 1,
      hgnc_id : "HGNC:7188",
      havana_gene : "OTTHUMG00000090603.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2405562,
      stop : 2511891,
      direction : "-",
      ID : "ENSG00000127804.13",
      gene_id : "ENSG00000127804.13",
      gene_type : "protein_coding",
      gene_name : "METTL16",
      gene_level : 1,
      hgnc_id : "HGNC:28484",
      havana_gene : "OTTHUMG00000177564.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2593210,
      stop : 2685615,
      direction : "+",
      ID : "ENSG00000007168.14",
      gene_id : "ENSG00000007168.14",
      gene_type : "protein_coding",
      gene_name : "PAFAH1B1",
      gene_level : 2,
      hgnc_id : "HGNC:8574",
      havana_gene : "OTTHUMG00000177574.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2689386,
      stop : 2712663,
      direction : "-",
      ID : "ENSG00000132361.18",
      gene_id : "ENSG00000132361.18",
      gene_type : "protein_coding",
      gene_name : "CLUH",
      gene_level : 2,
      hgnc_id : "HGNC:29094",
      havana_gene : "OTTHUMG00000177575.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 2755705,
      stop : 3037741,
      direction : "+",
      ID : "ENSG00000132359.15",
      gene_id : "ENSG00000132359.15",
      gene_type : "protein_coding",
      gene_name : "RAP1GAP2",
      gene_level : 1,
      hgnc_id : "HGNC:29176",
      havana_gene : "OTTHUMG00000177642.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3062669,
      stop : 3063607,
      direction : "-",
      ID : "ENSG00000262628.1",
      gene_id : "ENSG00000262628.1",
      gene_type : "protein_coding",
      gene_name : "OR1D5",
      gene_level : 2,
      hgnc_id : "HGNC:8186",
      havana_gene : "OTTHUMG00000177676.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3088484,
      stop : 3104422,
      direction : "-",
      ID : "ENSG00000184166.2",
      gene_id : "ENSG00000184166.2",
      gene_type : "protein_coding",
      gene_name : "OR1D2",
      gene_level : 2,
      hgnc_id : "HGNC:8183",
      havana_gene : "OTTHUMG00000090619.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3126584,
      stop : 3127581,
      direction : "-",
      ID : "ENSG00000183024.3",
      gene_id : "ENSG00000183024.3",
      gene_type : "protein_coding",
      gene_name : "OR1G1",
      gene_level : 2,
      hgnc_id : "HGNC:8204",
      havana_gene : "OTTHUMG00000090618.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3197519,
      stop : 3198448,
      direction : "+",
      ID : "ENSG00000172150.4",
      gene_id : "ENSG00000172150.4",
      gene_type : "protein_coding",
      gene_name : "OR1A2",
      gene_level : 2,
      hgnc_id : "HGNC:8180",
      havana_gene : "OTTHUMG00000090638.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3207539,
      stop : 3218896,
      direction : "+",
      ID : "ENSG00000172146.3",
      gene_id : "ENSG00000172146.3",
      gene_type : "protein_coding",
      gene_name : "OR1A1",
      gene_level : 2,
      hgnc_id : "HGNC:8179",
      havana_gene : "OTTHUMG00000090637.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3276942,
      stop : 3386317,
      direction : "-",
      ID : "ENSG00000221882.3",
      gene_id : "ENSG00000221882.3",
      gene_type : "protein_coding",
      gene_name : "OR3A2",
      gene_level : 2,
      hgnc_id : "HGNC:8283",
      havana_gene : "OTTHUMG00000177667.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3291017,
      stop : 3298360,
      direction : "-",
      ID : "ENSG00000180090.5",
      gene_id : "ENSG00000180090.5",
      gene_type : "protein_coding",
      gene_name : "OR3A1",
      gene_level : 2,
      hgnc_id : "HGNC:8282",
      havana_gene : "OTTHUMG00000090642.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3385930,
      stop : 3386874,
      direction : "+",
      ID : "ENSG00000180042.5",
      gene_id : "ENSG00000180042.5",
      gene_type : "protein_coding",
      gene_name : "OR1R1P",
      gene_level : 2,
      hgnc_id : "HGNC:8226",
      havana_gene : "OTTHUMG00000177732.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3397104,
      stop : 3398410,
      direction : "-",
      ID : "ENSG00000180016.2",
      gene_id : "ENSG00000180016.2",
      gene_type : "protein_coding",
      gene_name : "OR1E1",
      gene_level : 2,
      hgnc_id : "HGNC:8189",
      havana_gene : "OTTHUMG00000090643.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3411370,
      stop : 3424070,
      direction : "+",
      ID : "ENSG00000159961.2",
      gene_id : "ENSG00000159961.2",
      gene_type : "protein_coding",
      gene_name : "OR3A3",
      gene_level : 2,
      hgnc_id : "HGNC:8284",
      havana_gene : "OTTHUMG00000090649.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3432870,
      stop : 3433841,
      direction : "-",
      ID : "ENSG00000127780.3",
      gene_id : "ENSG00000127780.3",
      gene_type : "protein_coding",
      gene_name : "OR1E2",
      gene_level : 2,
      hgnc_id : "HGNC:8190",
      havana_gene : "OTTHUMG00000090651.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3440019,
      stop : 3513852,
      direction : "-",
      ID : "ENSG00000141255.13",
      gene_id : "ENSG00000141255.13",
      gene_type : "protein_coding",
      gene_name : "SPATA22",
      gene_level : 1,
      hgnc_id : "HGNC:30705",
      havana_gene : "OTTHUMG00000177609.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3472374,
      stop : 3503405,
      direction : "+",
      ID : "ENSG00000108381.11",
      gene_id : "ENSG00000108381.11",
      gene_type : "protein_coding",
      gene_name : "ASPA",
      gene_level : 2,
      hgnc_id : "HGNC:756",
      havana_gene : "OTTHUMG00000090655.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3510502,
      stop : 3557812,
      direction : "-",
      ID : "ENSG00000167723.15",
      gene_id : "ENSG00000167723.15",
      gene_type : "protein_coding",
      gene_name : "TRPV3",
      gene_level : 2,
      hgnc_id : "HGNC:18084",
      havana_gene : "OTTHUMG00000090695.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3565444,
      stop : 3609411,
      direction : "-",
      ID : "ENSG00000196689.12",
      gene_id : "ENSG00000196689.12",
      gene_type : "protein_coding",
      gene_name : "TRPV1",
      gene_level : 1,
      hgnc_id : "HGNC:12716",
      havana_gene : "OTTHUMG00000177649.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3585149,
      stop : 3636249,
      direction : "-",
      ID : "ENSG00000262304.2",
      gene_id : "ENSG00000262304.2",
      gene_type : "protein_coding",
      gene_name : "AC027796.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000177650.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3608240,
      stop : 3636250,
      direction : "-",
      ID : "ENSG00000197417.9",
      gene_id : "ENSG00000197417.9",
      gene_type : "protein_coding",
      gene_name : "SHPK",
      gene_level : 2,
      hgnc_id : "HGNC:1492",
      havana_gene : "OTTHUMG00000090694.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3636459,
      stop : 3663103,
      direction : "+",
      ID : "ENSG00000040531.16",
      gene_id : "ENSG00000040531.16",
      gene_type : "protein_coding",
      gene_name : "CTNS",
      gene_level : 1,
      hgnc_id : "HGNC:2518",
      havana_gene : "OTTHUMG00000090693.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3662895,
      stop : 3668679,
      direction : "-",
      ID : "ENSG00000213977.8",
      gene_id : "ENSG00000213977.8",
      gene_type : "protein_coding",
      gene_name : "TAX1BP3",
      gene_level : 2,
      hgnc_id : "HGNC:30684",
      havana_gene : "OTTHUMG00000090701.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3663063,
      stop : 3696194,
      direction : "-",
      ID : "ENSG00000257950.3",
      gene_id : "ENSG00000257950.3",
      gene_type : "protein_coding",
      gene_name : "P2RX5-TAX1BP3",
      gene_level : 2,
      hgnc_id : "HGNC:49191",
      havana_gene : "OTTHUMG00000169623.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3668812,
      stop : 3669668,
      direction : "+",
      ID : "ENSG00000127774.7",
      gene_id : "ENSG00000127774.7",
      gene_type : "protein_coding",
      gene_name : "EMC6",
      gene_level : 2,
      hgnc_id : "HGNC:28430",
      havana_gene : "OTTHUMG00000180187.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3672199,
      stop : 3696240,
      direction : "-",
      ID : "ENSG00000083454.22",
      gene_id : "ENSG00000083454.22",
      gene_type : "protein_coding",
      gene_name : "P2RX5",
      gene_level : 2,
      hgnc_id : "HGNC:8536",
      havana_gene : "OTTHUMG00000090700.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3714628,
      stop : 3801188,
      direction : "-",
      ID : "ENSG00000083457.12",
      gene_id : "ENSG00000083457.12",
      gene_type : "protein_coding",
      gene_name : "ITGAE",
      gene_level : 1,
      hgnc_id : "HGNC:6147",
      havana_gene : "OTTHUMG00000177634.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3723903,
      stop : 3726699,
      direction : "+",
      ID : "ENSG00000177602.5",
      gene_id : "ENSG00000177602.5",
      gene_type : "protein_coding",
      gene_name : "HASPIN",
      gene_level : 2,
      hgnc_id : "HGNC:19682",
      havana_gene : "OTTHUMG00000090703.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3802158,
      stop : 3846246,
      direction : "-",
      ID : "ENSG00000074356.17",
      gene_id : "ENSG00000074356.17",
      gene_type : "protein_coding",
      gene_name : "NCBP3",
      gene_level : 1,
      hgnc_id : "HGNC:24612",
      havana_gene : "OTTHUMG00000177672.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3860315,
      stop : 3894891,
      direction : "-",
      ID : "ENSG00000004660.15",
      gene_id : "ENSG00000004660.15",
      gene_type : "protein_coding",
      gene_name : "CAMKK1",
      gene_level : 2,
      hgnc_id : "HGNC:1469",
      havana_gene : "OTTHUMG00000090725.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3896592,
      stop : 3916476,
      direction : "-",
      ID : "ENSG00000108405.4",
      gene_id : "ENSG00000108405.4",
      gene_type : "protein_coding",
      gene_name : "P2RX1",
      gene_level : 2,
      hgnc_id : "HGNC:8533",
      havana_gene : "OTTHUMG00000177673.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 3923870,
      stop : 3964464,
      direction : "-",
      ID : "ENSG00000074370.18",
      gene_id : "ENSG00000074370.18",
      gene_type : "protein_coding",
      gene_name : "ATP2A3",
      gene_level : 2,
      hgnc_id : "HGNC:813",
      havana_gene : "OTTHUMG00000177674.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4004445,
      stop : 4143030,
      direction : "-",
      ID : "ENSG00000074755.15",
      gene_id : "ENSG00000074755.15",
      gene_type : "protein_coding",
      gene_name : "ZZEF1",
      gene_level : 2,
      hgnc_id : "HGNC:29027",
      havana_gene : "OTTHUMG00000090741.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4143168,
      stop : 4187310,
      direction : "+",
      ID : "ENSG00000167740.10",
      gene_id : "ENSG00000167740.10",
      gene_type : "protein_coding",
      gene_name : "CYB5D2",
      gene_level : 2,
      hgnc_id : "HGNC:28471",
      havana_gene : "OTTHUMG00000177726.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4163821,
      stop : 4263995,
      direction : "-",
      ID : "ENSG00000185722.18",
      gene_id : "ENSG00000185722.18",
      gene_type : "protein_coding",
      gene_name : "ANKFY1",
      gene_level : 1,
      hgnc_id : "HGNC:20763",
      havana_gene : "OTTHUMG00000177727.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4269259,
      stop : 4366628,
      direction : "-",
      ID : "ENSG00000132388.12",
      gene_id : "ENSG00000132388.12",
      gene_type : "protein_coding",
      gene_name : "UBE2G1",
      gene_level : 1,
      hgnc_id : "HGNC:12482",
      havana_gene : "OTTHUMG00000177826.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4433940,
      stop : 4488208,
      direction : "+",
      ID : "ENSG00000182557.8",
      gene_id : "ENSG00000182557.8",
      gene_type : "protein_coding",
      gene_name : "SPNS3",
      gene_level : 2,
      hgnc_id : "HGNC:28433",
      havana_gene : "OTTHUMG00000177737.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4498881,
      stop : 4539035,
      direction : "+",
      ID : "ENSG00000183018.9",
      gene_id : "ENSG00000183018.9",
      gene_type : "protein_coding",
      gene_name : "SPNS2",
      gene_level : 2,
      hgnc_id : "HGNC:26992",
      havana_gene : "OTTHUMG00000177739.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4538897,
      stop : 4555386,
      direction : "-",
      ID : "ENSG00000132382.15",
      gene_id : "ENSG00000132382.15",
      gene_type : "protein_coding",
      gene_name : "MYBBP1A",
      gene_level : 2,
      hgnc_id : "HGNC:7546",
      havana_gene : "OTTHUMG00000090747.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4556927,
      stop : 4560818,
      direction : "-",
      ID : "ENSG00000167741.11",
      gene_id : "ENSG00000167741.11",
      gene_type : "protein_coding",
      gene_name : "GGT6",
      gene_level : 2,
      hgnc_id : "HGNC:26891",
      havana_gene : "OTTHUMG00000177827.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4583999,
      stop : 4608319,
      direction : "+",
      ID : "ENSG00000188176.12",
      gene_id : "ENSG00000188176.12",
      gene_type : "protein_coding",
      gene_name : "SMTNL2",
      gene_level : 2,
      hgnc_id : "HGNC:24764",
      havana_gene : "OTTHUMG00000132938.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4630919,
      stop : 4642294,
      direction : "-",
      ID : "ENSG00000161905.13",
      gene_id : "ENSG00000161905.13",
      gene_type : "protein_coding",
      gene_name : "ALOX15",
      gene_level : 2,
      hgnc_id : "HGNC:433",
      havana_gene : "OTTHUMG00000090746.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4669774,
      stop : 4704337,
      direction : "-",
      ID : "ENSG00000141456.16",
      gene_id : "ENSG00000141456.16",
      gene_type : "protein_coding",
      gene_name : "PELP1",
      gene_level : 2,
      hgnc_id : "HGNC:30134",
      havana_gene : "OTTHUMG00000177831.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4710596,
      stop : 4721499,
      direction : "+",
      ID : "ENSG00000141480.18",
      gene_id : "ENSG00000141480.18",
      gene_type : "protein_coding",
      gene_name : "ARRB2",
      gene_level : 2,
      hgnc_id : "HGNC:712",
      havana_gene : "OTTHUMG00000090759.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4731428,
      stop : 4733608,
      direction : "+",
      ID : "ENSG00000161920.11",
      gene_id : "ENSG00000161920.11",
      gene_type : "protein_coding",
      gene_name : "MED11",
      gene_level : 1,
      hgnc_id : "HGNC:32687",
      havana_gene : "OTTHUMG00000177896.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4733533,
      stop : 4739928,
      direction : "-",
      ID : "ENSG00000161921.17",
      gene_id : "ENSG00000161921.17",
      gene_type : "protein_coding",
      gene_name : "CXCL16",
      gene_level : 2,
      hgnc_id : "HGNC:16642",
      havana_gene : "OTTHUMG00000090761.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4739833,
      stop : 4746119,
      direction : "+",
      ID : "ENSG00000141497.14",
      gene_id : "ENSG00000141497.14",
      gene_type : "protein_coding",
      gene_name : "ZMYND15",
      gene_level : 2,
      hgnc_id : "HGNC:20997",
      havana_gene : "OTTHUMG00000090760.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4771884,
      stop : 4783213,
      direction : "+",
      ID : "ENSG00000142484.7",
      gene_id : "ENSG00000142484.7",
      gene_type : "protein_coding",
      gene_name : "TM4SF5",
      gene_level : 2,
      hgnc_id : "HGNC:11857",
      havana_gene : "OTTHUMG00000090776.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4785285,
      stop : 4786433,
      direction : "-",
      ID : "ENSG00000182853.12",
      gene_id : "ENSG00000182853.12",
      gene_type : "protein_coding",
      gene_name : "VMO1",
      gene_level : 2,
      hgnc_id : "HGNC:30387",
      havana_gene : "OTTHUMG00000177898.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4788964,
      stop : 4790589,
      direction : "+",
      ID : "ENSG00000182327.8",
      gene_id : "ENSG00000182327.8",
      gene_type : "protein_coding",
      gene_name : "GLTPD2",
      gene_level : 2,
      hgnc_id : "HGNC:33756",
      havana_gene : "OTTHUMG00000177929.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4796144,
      stop : 4798502,
      direction : "+",
      ID : "ENSG00000142507.10",
      gene_id : "ENSG00000142507.10",
      gene_type : "protein_coding",
      gene_name : "PSMB6",
      gene_level : 2,
      hgnc_id : "HGNC:9543",
      havana_gene : "OTTHUMG00000090777.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4801159,
      stop : 4807013,
      direction : "-",
      ID : "ENSG00000262165.2",
      gene_id : "ENSG00000262165.2",
      gene_type : "protein_coding",
      gene_name : "AC233723.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000177931.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4807152,
      stop : 4823434,
      direction : "+",
      ID : "ENSG00000129219.14",
      gene_id : "ENSG00000129219.14",
      gene_type : "protein_coding",
      gene_name : "PLD2",
      gene_level : 1,
      hgnc_id : "HGNC:9068",
      havana_gene : "OTTHUMG00000090779.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4833340,
      stop : 4898061,
      direction : "+",
      ID : "ENSG00000141503.17",
      gene_id : "ENSG00000141503.17",
      gene_type : "protein_coding",
      gene_name : "MINK1",
      gene_level : 2,
      hgnc_id : "HGNC:17565",
      havana_gene : "OTTHUMG00000177932.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4897771,
      stop : 4934438,
      direction : "-",
      ID : "ENSG00000108556.10",
      gene_id : "ENSG00000108556.10",
      gene_type : "protein_coding",
      gene_name : "CHRNE",
      gene_level : 2,
      hgnc_id : "HGNC:1966",
      havana_gene : "OTTHUMG00000090778.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4899418,
      stop : 4902934,
      direction : "+",
      ID : "ENSG00000205710.4",
      gene_id : "ENSG00000205710.4",
      gene_type : "protein_coding",
      gene_name : "C17orf107",
      gene_level : 2,
      hgnc_id : "HGNC:37238",
      havana_gene : "OTTHUMG00000164838.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4932277,
      stop : 4935023,
      direction : "+",
      ID : "ENSG00000185245.8",
      gene_id : "ENSG00000185245.8",
      gene_type : "protein_coding",
      gene_name : "GP1BA",
      gene_level : 2,
      hgnc_id : "HGNC:4439",
      havana_gene : "OTTHUMG00000177946.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4937130,
      stop : 4940053,
      direction : "-",
      ID : "ENSG00000108528.14",
      gene_id : "ENSG00000108528.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A11",
      gene_level : 2,
      hgnc_id : "HGNC:10981",
      havana_gene : "OTTHUMG00000099395.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4940008,
      stop : 4945222,
      direction : "+",
      ID : "ENSG00000108523.16",
      gene_id : "ENSG00000108523.16",
      gene_type : "protein_coding",
      gene_name : "RNF167",
      gene_level : 1,
      hgnc_id : "HGNC:24544",
      havana_gene : "OTTHUMG00000099397.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4945652,
      stop : 4949061,
      direction : "-",
      ID : "ENSG00000108518.8",
      gene_id : "ENSG00000108518.8",
      gene_type : "protein_coding",
      gene_name : "PFN1",
      gene_level : 2,
      hgnc_id : "HGNC:8881",
      havana_gene : "OTTHUMG00000099396.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4948092,
      stop : 4957131,
      direction : "+",
      ID : "ENSG00000108515.18",
      gene_id : "ENSG00000108515.18",
      gene_type : "protein_coding",
      gene_name : "ENO3",
      gene_level : 1,
      hgnc_id : "HGNC:3354",
      havana_gene : "OTTHUMG00000099394.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4959226,
      stop : 4967817,
      direction : "-",
      ID : "ENSG00000091640.8",
      gene_id : "ENSG00000091640.8",
      gene_type : "protein_coding",
      gene_name : "SPAG7",
      gene_level : 1,
      hgnc_id : "HGNC:11216",
      havana_gene : "OTTHUMG00000177733.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4967992,
      stop : 4987675,
      direction : "-",
      ID : "ENSG00000108509.21",
      gene_id : "ENSG00000108509.21",
      gene_type : "protein_coding",
      gene_name : "CAMTA2",
      gene_level : 1,
      hgnc_id : "HGNC:18807",
      havana_gene : "OTTHUMG00000099417.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4988130,
      stop : 4997610,
      direction : "-",
      ID : "ENSG00000196388.8",
      gene_id : "ENSG00000196388.8",
      gene_type : "protein_coding",
      gene_name : "INCA1",
      gene_level : 2,
      hgnc_id : "HGNC:32224",
      havana_gene : "OTTHUMG00000177768.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 4997950,
      stop : 5028401,
      direction : "+",
      ID : "ENSG00000129250.12",
      gene_id : "ENSG00000129250.12",
      gene_type : "protein_coding",
      gene_name : "KIF1C",
      gene_level : 2,
      hgnc_id : "HGNC:6317",
      havana_gene : "OTTHUMG00000099451.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5032600,
      stop : 5052009,
      direction : "-",
      ID : "ENSG00000132517.15",
      gene_id : "ENSG00000132517.15",
      gene_type : "protein_coding",
      gene_name : "SLC52A1",
      gene_level : 1,
      hgnc_id : "HGNC:30225",
      havana_gene : "OTTHUMG00000099448.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5078467,
      stop : 5096374,
      direction : "+",
      ID : "ENSG00000180787.6",
      gene_id : "ENSG00000180787.6",
      gene_type : "protein_coding",
      gene_name : "ZFP3",
      gene_level : 2,
      hgnc_id : "HGNC:12861",
      havana_gene : "OTTHUMG00000177799.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5105541,
      stop : 5123116,
      direction : "-",
      ID : "ENSG00000167840.13",
      gene_id : "ENSG00000167840.13",
      gene_type : "protein_coding",
      gene_name : "ZNF232",
      gene_level : 2,
      hgnc_id : "HGNC:13026",
      havana_gene : "OTTHUMG00000099450.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5116032,
      stop : 5175034,
      direction : "+",
      ID : "ENSG00000129204.17",
      gene_id : "ENSG00000129204.17",
      gene_type : "protein_coding",
      gene_name : "USP6",
      gene_level : 2,
      hgnc_id : "HGNC:12629",
      havana_gene : "OTTHUMG00000099449.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5179535,
      stop : 5191868,
      direction : "-",
      ID : "ENSG00000180626.10",
      gene_id : "ENSG00000180626.10",
      gene_type : "protein_coding",
      gene_name : "ZNF594",
      gene_level : 2,
      hgnc_id : "HGNC:29392",
      havana_gene : "OTTHUMG00000132059.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5208920,
      stop : 5234860,
      direction : "-",
      ID : "ENSG00000161929.15",
      gene_id : "ENSG00000161929.15",
      gene_type : "protein_coding",
      gene_name : "SCIMP",
      gene_level : 2,
      hgnc_id : "HGNC:33504",
      havana_gene : "OTTHUMG00000132914.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5282265,
      stop : 5386340,
      direction : "+",
      ID : "ENSG00000029725.17",
      gene_id : "ENSG00000029725.17",
      gene_type : "protein_coding",
      gene_name : "RABEP1",
      gene_level : 1,
      hgnc_id : "HGNC:17677",
      havana_gene : "OTTHUMG00000177870.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5360963,
      stop : 5419676,
      direction : "-",
      ID : "ENSG00000108559.12",
      gene_id : "ENSG00000108559.12",
      gene_type : "protein_coding",
      gene_name : "NUP88",
      gene_level : 1,
      hgnc_id : "HGNC:8067",
      havana_gene : "OTTHUMG00000099453.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5419641,
      stop : 5432877,
      direction : "+",
      ID : "ENSG00000129197.15",
      gene_id : "ENSG00000129197.15",
      gene_type : "protein_coding",
      gene_name : "RPAIN",
      gene_level : 2,
      hgnc_id : "HGNC:28641",
      havana_gene : "OTTHUMG00000177872.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5432777,
      stop : 5448830,
      direction : "-",
      ID : "ENSG00000108561.8",
      gene_id : "ENSG00000108561.8",
      gene_type : "protein_coding",
      gene_name : "C1QBP",
      gene_level : 1,
      hgnc_id : "HGNC:1243",
      havana_gene : "OTTHUMG00000177875.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5440917,
      stop : 5468982,
      direction : "-",
      ID : "ENSG00000005100.13",
      gene_id : "ENSG00000005100.13",
      gene_type : "protein_coding",
      gene_name : "DHX33",
      gene_level : 1,
      hgnc_id : "HGNC:16718",
      havana_gene : "OTTHUMG00000102041.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5471254,
      stop : 5486811,
      direction : "-",
      ID : "ENSG00000072849.11",
      gene_id : "ENSG00000072849.11",
      gene_type : "protein_coding",
      gene_name : "DERL2",
      gene_level : 2,
      hgnc_id : "HGNC:17943",
      havana_gene : "OTTHUMG00000102040.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5486285,
      stop : 5490814,
      direction : "+",
      ID : "ENSG00000167842.16",
      gene_id : "ENSG00000167842.16",
      gene_type : "protein_coding",
      gene_name : "MIS12",
      gene_level : 2,
      hgnc_id : "HGNC:24967",
      havana_gene : "OTTHUMG00000102042.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5499427,
      stop : 5501006,
      direction : "-",
      ID : "ENSG00000286190.2",
      gene_id : "ENSG00000286190.2",
      gene_type : "protein_coding",
      gene_name : "AC055839.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193519.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5499427,
      stop : 5619424,
      direction : "-",
      ID : "ENSG00000091592.16",
      gene_id : "ENSG00000091592.16",
      gene_type : "protein_coding",
      gene_name : "NLRP1",
      gene_level : 2,
      hgnc_id : "HGNC:14374",
      havana_gene : "OTTHUMG00000132419.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 5772926,
      stop : 6080792,
      direction : "+",
      ID : "ENSG00000285471.1",
      gene_id : "ENSG00000285471.1",
      gene_type : "protein_coding",
      gene_name : "AC007846.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192452.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6057807,
      stop : 6124427,
      direction : "+",
      ID : "ENSG00000179314.14",
      gene_id : "ENSG00000179314.14",
      gene_type : "protein_coding",
      gene_name : "WSCD1",
      gene_level : 2,
      hgnc_id : "HGNC:29060",
      havana_gene : "OTTHUMG00000177794.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6393693,
      stop : 6435199,
      direction : "-",
      ID : "ENSG00000129221.16",
      gene_id : "ENSG00000129221.16",
      gene_type : "protein_coding",
      gene_name : "AIPL1",
      gene_level : 2,
      hgnc_id : "HGNC:359",
      havana_gene : "OTTHUMG00000102043.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6444441,
      stop : 6451469,
      direction : "+",
      ID : "ENSG00000129195.16",
      gene_id : "ENSG00000129195.16",
      gene_type : "protein_coding",
      gene_name : "PIMREG",
      gene_level : 1,
      hgnc_id : "HGNC:25483",
      havana_gene : "OTTHUMG00000177832.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6451263,
      stop : 6556555,
      direction : "-",
      ID : "ENSG00000091622.16",
      gene_id : "ENSG00000091622.16",
      gene_type : "protein_coding",
      gene_name : "PITPNM3",
      gene_level : 1,
      hgnc_id : "HGNC:21043",
      havana_gene : "OTTHUMG00000102039.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6578147,
      stop : 6640711,
      direction : "-",
      ID : "ENSG00000198920.11",
      gene_id : "ENSG00000198920.11",
      gene_type : "protein_coding",
      gene_name : "KIAA0753",
      gene_level : 2,
      hgnc_id : "HGNC:29110",
      havana_gene : "OTTHUMG00000177928.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6628619,
      stop : 6640456,
      direction : "-",
      ID : "ENSG00000282936.2",
      gene_id : "ENSG00000282936.2",
      gene_type : "protein_coding",
      gene_name : "AC004706.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191541.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6640985,
      stop : 6644541,
      direction : "+",
      ID : "ENSG00000129235.11",
      gene_id : "ENSG00000129235.11",
      gene_type : "protein_coding",
      gene_name : "TXNDC17",
      gene_level : 1,
      hgnc_id : "HGNC:28218",
      havana_gene : "OTTHUMG00000102053.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6643311,
      stop : 6651634,
      direction : "-",
      ID : "ENSG00000108590.11",
      gene_id : "ENSG00000108590.11",
      gene_type : "protein_coding",
      gene_name : "MED31",
      gene_level : 1,
      hgnc_id : "HGNC:24260",
      havana_gene : "OTTHUMG00000102051.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6651762,
      stop : 6693202,
      direction : "+",
      ID : "ENSG00000256806.6",
      gene_id : "ENSG00000256806.6",
      gene_type : "protein_coding",
      gene_name : "C17orf100",
      gene_level : 2,
      hgnc_id : "HGNC:34494",
      havana_gene : "OTTHUMG00000188340.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6684719,
      stop : 6713377,
      direction : "-",
      ID : "ENSG00000141485.17",
      gene_id : "ENSG00000141485.17",
      gene_type : "protein_coding",
      gene_name : "SLC13A5",
      gene_level : 1,
      hgnc_id : "HGNC:23089",
      havana_gene : "OTTHUMG00000102052.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6755447,
      stop : 6775647,
      direction : "+",
      ID : "ENSG00000132530.17",
      gene_id : "ENSG00000132530.17",
      gene_type : "protein_coding",
      gene_name : "XAF1",
      gene_level : 1,
      hgnc_id : "HGNC:30932",
      havana_gene : "OTTHUMG00000177908.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6776215,
      stop : 6797101,
      direction : "+",
      ID : "ENSG00000177294.7",
      gene_id : "ENSG00000177294.7",
      gene_type : "protein_coding",
      gene_name : "FBXO39",
      gene_level : 2,
      hgnc_id : "HGNC:28565",
      havana_gene : "OTTHUMG00000102062.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6789133,
      stop : 6831761,
      direction : "-",
      ID : "ENSG00000167858.13",
      gene_id : "ENSG00000167858.13",
      gene_type : "protein_coding",
      gene_name : "TEKT1",
      gene_level : 1,
      hgnc_id : "HGNC:15534",
      havana_gene : "OTTHUMG00000102063.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 6996049,
      stop : 7010754,
      direction : "+",
      ID : "ENSG00000108839.12",
      gene_id : "ENSG00000108839.12",
      gene_type : "protein_coding",
      gene_name : "ALOX12",
      gene_level : 2,
      hgnc_id : "HGNC:429",
      havana_gene : "OTTHUMG00000102088.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7012417,
      stop : 7014532,
      direction : "+",
      ID : "ENSG00000219200.12",
      gene_id : "ENSG00000219200.12",
      gene_type : "protein_coding",
      gene_name : "RNASEK",
      gene_level : 1,
      hgnc_id : "HGNC:33911",
      havana_gene : "OTTHUMG00000170145.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7012635,
      stop : 7017520,
      direction : "+",
      ID : "ENSG00000161939.19",
      gene_id : "ENSG00000161939.19",
      gene_type : "protein_coding",
      gene_name : "RNASEK-C17orf49",
      gene_level : 2,
      hgnc_id : "HGNC:44419",
      havana_gene : "OTTHUMG00000170146.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7014495,
      stop : 7017525,
      direction : "+",
      ID : "ENSG00000258315.5",
      gene_id : "ENSG00000258315.5",
      gene_type : "protein_coding",
      gene_name : "C17orf49",
      gene_level : 2,
      hgnc_id : "HGNC:28737",
      havana_gene : "OTTHUMG00000170147.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7023050,
      stop : 7030290,
      direction : "+",
      ID : "ENSG00000161940.11",
      gene_id : "ENSG00000161940.11",
      gene_type : "protein_coding",
      gene_name : "BCL6B",
      gene_level : 2,
      hgnc_id : "HGNC:1002",
      havana_gene : "OTTHUMG00000177882.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7036015,
      stop : 7040117,
      direction : "+",
      ID : "ENSG00000174327.7",
      gene_id : "ENSG00000174327.7",
      gene_type : "protein_coding",
      gene_name : "SLC16A13",
      gene_level : 2,
      hgnc_id : "HGNC:31037",
      havana_gene : "OTTHUMG00000102089.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7041621,
      stop : 7044092,
      direction : "-",
      ID : "ENSG00000174326.14",
      gene_id : "ENSG00000174326.14",
      gene_type : "protein_coding",
      gene_name : "SLC16A11",
      gene_level : 2,
      hgnc_id : "HGNC:23093",
      havana_gene : "OTTHUMG00000102087.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7074537,
      stop : 7080307,
      direction : "-",
      ID : "ENSG00000132514.14",
      gene_id : "ENSG00000132514.14",
      gene_type : "protein_coding",
      gene_name : "CLEC10A",
      gene_level : 1,
      hgnc_id : "HGNC:16916",
      havana_gene : "OTTHUMG00000177939.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7101322,
      stop : 7115700,
      direction : "-",
      ID : "ENSG00000161944.16",
      gene_id : "ENSG00000161944.16",
      gene_type : "protein_coding",
      gene_name : "ASGR2",
      gene_level : 2,
      hgnc_id : "HGNC:743",
      havana_gene : "OTTHUMG00000102158.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7173431,
      stop : 7179564,
      direction : "-",
      ID : "ENSG00000141505.12",
      gene_id : "ENSG00000141505.12",
      gene_type : "protein_coding",
      gene_name : "ASGR1",
      gene_level : 2,
      hgnc_id : "HGNC:742",
      havana_gene : "OTTHUMG00000102159.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7187187,
      stop : 7219841,
      direction : "-",
      ID : "ENSG00000132535.21",
      gene_id : "ENSG00000132535.21",
      gene_type : "protein_coding",
      gene_name : "DLG4",
      gene_level : 1,
      hgnc_id : "HGNC:2903",
      havana_gene : "OTTHUMG00000134327.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7217125,
      stop : 7225266,
      direction : "+",
      ID : "ENSG00000072778.20",
      gene_id : "ENSG00000072778.20",
      gene_type : "protein_coding",
      gene_name : "ACADVL",
      gene_level : 2,
      hgnc_id : "HGNC:92",
      havana_gene : "OTTHUMG00000102157.25",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7225342,
      stop : 7234517,
      direction : "-",
      ID : "ENSG00000004975.12",
      gene_id : "ENSG00000004975.12",
      gene_type : "protein_coding",
      gene_name : "DVL2",
      gene_level : 2,
      hgnc_id : "HGNC:3086",
      havana_gene : "OTTHUMG00000102155.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7235029,
      stop : 7239722,
      direction : "-",
      ID : "ENSG00000040633.13",
      gene_id : "ENSG00000040633.13",
      gene_type : "protein_coding",
      gene_name : "PHF23",
      gene_level : 1,
      hgnc_id : "HGNC:28428",
      havana_gene : "OTTHUMG00000177972.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7240008,
      stop : 7242449,
      direction : "-",
      ID : "ENSG00000170296.10",
      gene_id : "ENSG00000170296.10",
      gene_type : "protein_coding",
      gene_name : "GABARAP",
      gene_level : 2,
      hgnc_id : "HGNC:4067",
      havana_gene : "OTTHUMG00000102156.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7240427,
      stop : 7244635,
      direction : "-",
      ID : "ENSG00000262526.2",
      gene_id : "ENSG00000262526.2",
      gene_type : "protein_coding",
      gene_name : "AC120057.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178096.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7243591,
      stop : 7252491,
      direction : "-",
      ID : "ENSG00000175826.12",
      gene_id : "ENSG00000175826.12",
      gene_type : "protein_coding",
      gene_name : "CTDNEP1",
      gene_level : 2,
      hgnc_id : "HGNC:19085",
      havana_gene : "OTTHUMG00000102180.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7246829,
      stop : 7262089,
      direction : "-",
      ID : "ENSG00000262302.1",
      gene_id : "ENSG00000262302.1",
      gene_type : "protein_coding",
      gene_name : "AC003688.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178008.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7251416,
      stop : 7259940,
      direction : "+",
      ID : "ENSG00000170291.15",
      gene_id : "ENSG00000170291.15",
      gene_type : "protein_coding",
      gene_name : "ELP5",
      gene_level : 1,
      hgnc_id : "HGNC:30617",
      havana_gene : "OTTHUMG00000177974.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7259903,
      stop : 7263983,
      direction : "-",
      ID : "ENSG00000181885.18",
      gene_id : "ENSG00000181885.18",
      gene_type : "protein_coding",
      gene_name : "CLDN7",
      gene_level : 1,
      hgnc_id : "HGNC:2049",
      havana_gene : "OTTHUMG00000178005.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7281718,
      stop : 7288257,
      direction : "+",
      ID : "ENSG00000181856.15",
      gene_id : "ENSG00000181856.15",
      gene_type : "protein_coding",
      gene_name : "SLC2A4",
      gene_level : 2,
      hgnc_id : "HGNC:11009",
      havana_gene : "OTTHUMG00000102181.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7288263,
      stop : 7294639,
      direction : "-",
      ID : "ENSG00000006047.13",
      gene_id : "ENSG00000006047.13",
      gene_type : "protein_coding",
      gene_name : "YBX2",
      gene_level : 2,
      hgnc_id : "HGNC:17948",
      havana_gene : "OTTHUMG00000177992.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7306999,
      stop : 7312463,
      direction : "+",
      ID : "ENSG00000132507.18",
      gene_id : "ENSG00000132507.18",
      gene_type : "protein_coding",
      gene_name : "EIF5A",
      gene_level : 2,
      hgnc_id : "HGNC:3300",
      havana_gene : "OTTHUMG00000102197.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7311324,
      stop : 7315564,
      direction : "-",
      ID : "ENSG00000132522.16",
      gene_id : "ENSG00000132522.16",
      gene_type : "protein_coding",
      gene_name : "GPS2",
      gene_level : 2,
      hgnc_id : "HGNC:4550",
      havana_gene : "OTTHUMG00000102198.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7312661,
      stop : 7319174,
      direction : "-",
      ID : "ENSG00000261915.6",
      gene_id : "ENSG00000261915.6",
      gene_type : "protein_coding",
      gene_name : "AC026954.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178134.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7315628,
      stop : 7329393,
      direction : "-",
      ID : "ENSG00000215041.10",
      gene_id : "ENSG00000215041.10",
      gene_type : "protein_coding",
      gene_name : "NEURL4",
      gene_level : 2,
      hgnc_id : "HGNC:34410",
      havana_gene : "OTTHUMG00000132319.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7336529,
      stop : 7351477,
      direction : "+",
      ID : "ENSG00000072818.12",
      gene_id : "ENSG00000072818.12",
      gene_type : "protein_coding",
      gene_name : "ACAP1",
      gene_level : 1,
      hgnc_id : "HGNC:16467",
      havana_gene : "OTTHUMG00000102199.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7351889,
      stop : 7354944,
      direction : "+",
      ID : "ENSG00000213859.8",
      gene_id : "ENSG00000213859.8",
      gene_type : "protein_coding",
      gene_name : "KCTD11",
      gene_level : 2,
      hgnc_id : "HGNC:21302",
      havana_gene : "OTTHUMG00000132061.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7355123,
      stop : 7357219,
      direction : "+",
      ID : "ENSG00000182896.13",
      gene_id : "ENSG00000182896.13",
      gene_type : "protein_coding",
      gene_name : "TMEM95",
      gene_level : 2,
      hgnc_id : "HGNC:27898",
      havana_gene : "OTTHUMG00000132899.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7380534,
      stop : 7389774,
      direction : "+",
      ID : "ENSG00000174292.12",
      gene_id : "ENSG00000174292.12",
      gene_type : "protein_coding",
      gene_name : "TNK1",
      gene_level : 2,
      hgnc_id : "HGNC:11940",
      havana_gene : "OTTHUMG00000178174.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7389727,
      stop : 7394842,
      direction : "-",
      ID : "ENSG00000187838.17",
      gene_id : "ENSG00000187838.17",
      gene_type : "protein_coding",
      gene_name : "PLSCR3",
      gene_level : 1,
      hgnc_id : "HGNC:16495",
      havana_gene : "OTTHUMG00000178169.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7389734,
      stop : 7404097,
      direction : "-",
      ID : "ENSG00000262481.5",
      gene_id : "ENSG00000262481.5",
      gene_type : "protein_coding",
      gene_name : "TMEM256-PLSCR3",
      gene_level : 2,
      hgnc_id : "HGNC:49186",
      havana_gene : "OTTHUMG00000178150.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7402975,
      stop : 7404097,
      direction : "-",
      ID : "ENSG00000205544.4",
      gene_id : "ENSG00000205544.4",
      gene_type : "protein_coding",
      gene_name : "TMEM256",
      gene_level : 2,
      hgnc_id : "HGNC:28618",
      havana_gene : "OTTHUMG00000132900.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7404874,
      stop : 7419860,
      direction : "+",
      ID : "ENSG00000169992.10",
      gene_id : "ENSG00000169992.10",
      gene_type : "protein_coding",
      gene_name : "NLGN2",
      gene_level : 1,
      hgnc_id : "HGNC:14290",
      havana_gene : "OTTHUMG00000108138.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7420324,
      stop : 7421632,
      direction : "+",
      ID : "ENSG00000181323.8",
      gene_id : "ENSG00000181323.8",
      gene_type : "protein_coding",
      gene_name : "SPEM1",
      gene_level : 2,
      hgnc_id : "HGNC:32429",
      havana_gene : "OTTHUMG00000178189.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7425616,
      stop : 7427568,
      direction : "+",
      ID : "ENSG00000184560.8",
      gene_id : "ENSG00000184560.8",
      gene_type : "protein_coding",
      gene_name : "SPEM2",
      gene_level : 2,
      hgnc_id : "HGNC:27315",
      havana_gene : "OTTHUMG00000178190.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7428857,
      stop : 7432820,
      direction : "+",
      ID : "ENSG00000283439.4",
      gene_id : "ENSG00000283439.4",
      gene_type : "protein_coding",
      gene_name : "SPEM3",
      gene_level : 2,
      hgnc_id : "HGNC:53651",
      havana_gene : "OTTHUMG00000191681.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7428861,
      stop : 7436278,
      direction : "+",
      ID : "ENSG00000286007.1",
      gene_id : "ENSG00000286007.1",
      gene_type : "protein_coding",
      gene_name : "AC113189.9",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193509.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7435435,
      stop : 7437679,
      direction : "+",
      ID : "ENSG00000181284.3",
      gene_id : "ENSG00000181284.3",
      gene_type : "protein_coding",
      gene_name : "TMEM102",
      gene_level : 2,
      hgnc_id : "HGNC:26722",
      havana_gene : "OTTHUMG00000132901.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7438273,
      stop : 7444937,
      direction : "+",
      ID : "ENSG00000161958.11",
      gene_id : "ENSG00000161958.11",
      gene_type : "protein_coding",
      gene_name : "FGF11",
      gene_level : 2,
      hgnc_id : "HGNC:3667",
      havana_gene : "OTTHUMG00000108136.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7445061,
      stop : 7457710,
      direction : "+",
      ID : "ENSG00000170175.11",
      gene_id : "ENSG00000170175.11",
      gene_type : "protein_coding",
      gene_name : "CHRNB1",
      gene_level : 1,
      hgnc_id : "HGNC:1961",
      havana_gene : "OTTHUMG00000108139.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7459366,
      stop : 7484263,
      direction : "-",
      ID : "ENSG00000174282.12",
      gene_id : "ENSG00000174282.12",
      gene_type : "protein_coding",
      gene_name : "ZBTB4",
      gene_level : 2,
      hgnc_id : "HGNC:23847",
      havana_gene : "OTTHUMG00000108137.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7481332,
      stop : 7483496,
      direction : "+",
      ID : "ENSG00000259224.2",
      gene_id : "ENSG00000259224.2",
      gene_type : "protein_coding",
      gene_name : "SLC35G6",
      gene_level : 2,
      hgnc_id : "HGNC:31351",
      havana_gene : "OTTHUMG00000187017.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7484366,
      stop : 7514616,
      direction : "+",
      ID : "ENSG00000181222.19",
      gene_id : "ENSG00000181222.19",
      gene_type : "protein_coding",
      gene_name : "POLR2A",
      gene_level : 2,
      hgnc_id : "HGNC:9187",
      havana_gene : "",
      tag : "reference_genome_error"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7549058,
      stop : 7557890,
      direction : "+",
      ID : "ENSG00000239697.11",
      gene_id : "ENSG00000239697.11",
      gene_type : "protein_coding",
      gene_name : "TNFSF12",
      gene_level : 2,
      hgnc_id : "HGNC:11927",
      havana_gene : "OTTHUMG00000108148.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7549099,
      stop : 7561601,
      direction : "+",
      ID : "ENSG00000248871.1",
      gene_id : "ENSG00000248871.1",
      gene_type : "protein_coding",
      gene_name : "TNFSF12-TNFSF13",
      gene_level : 2,
      hgnc_id : "HGNC:33537",
      havana_gene : "OTTHUMG00000161573.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7558292,
      stop : 7561608,
      direction : "+",
      ID : "ENSG00000161955.16",
      gene_id : "ENSG00000161955.16",
      gene_type : "protein_coding",
      gene_name : "TNFSF13",
      gene_level : 2,
      hgnc_id : "HGNC:11928",
      havana_gene : "OTTHUMG00000108145.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7561919,
      stop : 7571969,
      direction : "+",
      ID : "ENSG00000161956.13",
      gene_id : "ENSG00000161956.13",
      gene_type : "protein_coding",
      gene_name : "SENP3",
      gene_level : 1,
      hgnc_id : "HGNC:17862",
      havana_gene : "OTTHUMG00000178333.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7563287,
      stop : 7578715,
      direction : "+",
      ID : "ENSG00000277957.1",
      gene_id : "ENSG00000277957.1",
      gene_type : "protein_coding",
      gene_name : "SENP3-EIF4A1",
      gene_level : 2,
      hgnc_id : "HGNC:49182",
      havana_gene : "OTTHUMG00000178334.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7572824,
      stop : 7579006,
      direction : "+",
      ID : "ENSG00000161960.16",
      gene_id : "ENSG00000161960.16",
      gene_type : "protein_coding",
      gene_name : "EIF4A1",
      gene_level : 2,
      hgnc_id : "HGNC:3282",
      havana_gene : "OTTHUMG00000108149.16",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7579491,
      stop : 7582111,
      direction : "+",
      ID : "ENSG00000129226.14",
      gene_id : "ENSG00000129226.14",
      gene_type : "protein_coding",
      gene_name : "CD68",
      gene_level : 2,
      hgnc_id : "HGNC:1693",
      havana_gene : "OTTHUMG00000108146.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7583529,
      stop : 7592789,
      direction : "+",
      ID : "ENSG00000129255.16",
      gene_id : "ENSG00000129255.16",
      gene_type : "protein_coding",
      gene_name : "MPDU1",
      gene_level : 1,
      hgnc_id : "HGNC:7207",
      havana_gene : "OTTHUMG00000108147.11",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7588178,
      stop : 7590094,
      direction : "-",
      ID : "ENSG00000129194.8",
      gene_id : "ENSG00000129194.8",
      gene_type : "protein_coding",
      gene_name : "SOX15",
      gene_level : 2,
      hgnc_id : "HGNC:11196",
      havana_gene : "OTTHUMG00000178146.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7591230,
      stop : 7614897,
      direction : "-",
      ID : "ENSG00000129245.12",
      gene_id : "ENSG00000129245.12",
      gene_type : "protein_coding",
      gene_name : "FXR2",
      gene_level : 1,
      hgnc_id : "HGNC:4024",
      havana_gene : "OTTHUMG00000178237.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7613946,
      stop : 7633382,
      direction : "+",
      ID : "ENSG00000129214.15",
      gene_id : "ENSG00000129214.15",
      gene_type : "protein_coding",
      gene_name : "SHBG",
      gene_level : 2,
      hgnc_id : "HGNC:10839",
      havana_gene : "OTTHUMG00000108153.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7626234,
      stop : 7627876,
      direction : "-",
      ID : "ENSG00000141504.12",
      gene_id : "ENSG00000141504.12",
      gene_type : "protein_coding",
      gene_name : "SAT2",
      gene_level : 2,
      hgnc_id : "HGNC:23160",
      havana_gene : "OTTHUMG00000108152.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7646627,
      stop : 7657770,
      direction : "+",
      ID : "ENSG00000129244.9",
      gene_id : "ENSG00000129244.9",
      gene_type : "protein_coding",
      gene_name : "ATP1B2",
      gene_level : 2,
      hgnc_id : "HGNC:805",
      havana_gene : "OTTHUMG00000178018.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7661779,
      stop : 7687538,
      direction : "-",
      ID : "ENSG00000141510.18",
      gene_id : "ENSG00000141510.18",
      gene_type : "protein_coding",
      gene_name : "TP53",
      gene_level : 2,
      hgnc_id : "HGNC:11998",
      havana_gene : "OTTHUMG00000162125.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7686071,
      stop : 7703502,
      direction : "+",
      ID : "ENSG00000141499.17",
      gene_id : "ENSG00000141499.17",
      gene_type : "protein_coding",
      gene_name : "WRAP53",
      gene_level : 1,
      hgnc_id : "HGNC:25522",
      havana_gene : "OTTHUMG00000134323.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7705202,
      stop : 7711372,
      direction : "+",
      ID : "ENSG00000108947.5",
      gene_id : "ENSG00000108947.5",
      gene_type : "protein_coding",
      gene_name : "EFNB3",
      gene_level : 2,
      hgnc_id : "HGNC:3228",
      havana_gene : "OTTHUMG00000108161.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7717354,
      stop : 7833744,
      direction : "+",
      ID : "ENSG00000183914.14",
      gene_id : "ENSG00000183914.14",
      gene_type : "protein_coding",
      gene_name : "DNAH2",
      gene_level : 1,
      hgnc_id : "HGNC:2948",
      havana_gene : "OTTHUMG00000178020.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7834217,
      stop : 7854796,
      direction : "+",
      ID : "ENSG00000132510.11",
      gene_id : "ENSG00000132510.11",
      gene_type : "protein_coding",
      gene_name : "KDM6B",
      gene_level : 1,
      hgnc_id : "HGNC:29012",
      havana_gene : "OTTHUMG00000178021.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7855066,
      stop : 7856099,
      direction : "+",
      ID : "ENSG00000167874.7",
      gene_id : "ENSG00000167874.7",
      gene_type : "protein_coding",
      gene_name : "TMEM88",
      gene_level : 1,
      hgnc_id : "HGNC:32371",
      havana_gene : "OTTHUMG00000178022.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7856685,
      stop : 7885238,
      direction : "-",
      ID : "ENSG00000183011.13",
      gene_id : "ENSG00000183011.13",
      gene_type : "protein_coding",
      gene_name : "NAA38",
      gene_level : 1,
      hgnc_id : "HGNC:28212",
      havana_gene : "OTTHUMG00000178023.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7857746,
      stop : 7862282,
      direction : "+",
      ID : "ENSG00000182224.12",
      gene_id : "ENSG00000182224.12",
      gene_type : "protein_coding",
      gene_name : "CYB5D1",
      gene_level : 2,
      hgnc_id : "HGNC:26516",
      havana_gene : "OTTHUMG00000178175.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7884796,
      stop : 7912760,
      direction : "+",
      ID : "ENSG00000170004.17",
      gene_id : "ENSG00000170004.17",
      gene_type : "protein_coding",
      gene_name : "CHD3",
      gene_level : 1,
      hgnc_id : "HGNC:1918",
      havana_gene : "OTTHUMG00000150427.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7913339,
      stop : 7916289,
      direction : "-",
      ID : "ENSG00000179859.10",
      gene_id : "ENSG00000179859.10",
      gene_type : "protein_coding",
      gene_name : "RNF227",
      gene_level : 2,
      hgnc_id : "HGNC:27571",
      havana_gene : "OTTHUMG00000132873.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7921859,
      stop : 7929803,
      direction : "-",
      ID : "ENSG00000170049.9",
      gene_id : "ENSG00000170049.9",
      gene_type : "protein_coding",
      gene_name : "KCNAB3",
      gene_level : 2,
      hgnc_id : "HGNC:6230",
      havana_gene : "OTTHUMG00000108170.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7925931,
      stop : 7930622,
      direction : "-",
      ID : "ENSG00000262730.1",
      gene_id : "ENSG00000262730.1",
      gene_type : "protein_coding",
      gene_name : "AC104581.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178177.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7930345,
      stop : 7932123,
      direction : "-",
      ID : "ENSG00000170043.12",
      gene_id : "ENSG00000170043.12",
      gene_type : "protein_coding",
      gene_name : "TRAPPC1",
      gene_level : 2,
      hgnc_id : "HGNC:19894",
      havana_gene : "OTTHUMG00000108171.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 7932101,
      stop : 7949920,
      direction : "+",
      ID : "ENSG00000170037.14",
      gene_id : "ENSG00000170037.14",
      gene_type : "protein_coding",
      gene_name : "CNTROB",
      gene_level : 2,
      hgnc_id : "HGNC:29616",
      havana_gene : "OTTHUMG00000172932.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8002615,
      stop : 8020342,
      direction : "+",
      ID : "ENSG00000132518.7",
      gene_id : "ENSG00000132518.7",
      gene_type : "protein_coding",
      gene_name : "GUCY2D",
      gene_level : 2,
      hgnc_id : "HGNC:4689",
      havana_gene : "OTTHUMG00000108169.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8039034,
      stop : 8049134,
      direction : "+",
      ID : "ENSG00000179593.16",
      gene_id : "ENSG00000179593.16",
      gene_type : "protein_coding",
      gene_name : "ALOX15B",
      gene_level : 1,
      hgnc_id : "HGNC:434",
      havana_gene : "OTTHUMG00000108181.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8072636,
      stop : 8087716,
      direction : "-",
      ID : "ENSG00000179477.11",
      gene_id : "ENSG00000179477.11",
      gene_type : "protein_coding",
      gene_name : "ALOX12B",
      gene_level : 2,
      hgnc_id : "HGNC:430",
      havana_gene : "OTTHUMG00000108180.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8095900,
      stop : 8119047,
      direction : "-",
      ID : "ENSG00000179148.10",
      gene_id : "ENSG00000179148.10",
      gene_type : "protein_coding",
      gene_name : "ALOXE3",
      gene_level : 2,
      hgnc_id : "HGNC:13743",
      havana_gene : "OTTHUMG00000108179.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8120592,
      stop : 8124106,
      direction : "-",
      ID : "ENSG00000179111.9",
      gene_id : "ENSG00000179111.9",
      gene_type : "protein_coding",
      gene_name : "HES7",
      gene_level : 2,
      hgnc_id : "HGNC:15977",
      havana_gene : "OTTHUMG00000178316.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8140472,
      stop : 8156506,
      direction : "-",
      ID : "ENSG00000179094.16",
      gene_id : "ENSG00000179094.16",
      gene_type : "protein_coding",
      gene_name : "PER1",
      gene_level : 1,
      hgnc_id : "HGNC:8845",
      havana_gene : "OTTHUMG00000178317.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8150816,
      stop : 8162975,
      direction : "-",
      ID : "ENSG00000263620.1",
      gene_id : "ENSG00000263620.1",
      gene_type : "protein_coding",
      gene_name : "AC129492.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178326.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8159149,
      stop : 8163546,
      direction : "-",
      ID : "ENSG00000220205.9",
      gene_id : "ENSG00000220205.9",
      gene_type : "protein_coding",
      gene_name : "VAMP2",
      gene_level : 2,
      hgnc_id : "HGNC:12643",
      havana_gene : "OTTHUMG00000150254.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8172457,
      stop : 8176399,
      direction : "-",
      ID : "ENSG00000179029.15",
      gene_id : "ENSG00000179029.15",
      gene_type : "protein_coding",
      gene_name : "TMEM107",
      gene_level : 1,
      hgnc_id : "HGNC:28128",
      havana_gene : "OTTHUMG00000166276.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8188345,
      stop : 8190180,
      direction : "-",
      ID : "ENSG00000196544.8",
      gene_id : "ENSG00000196544.8",
      gene_type : "protein_coding",
      gene_name : "BORCS6",
      gene_level : 2,
      hgnc_id : "HGNC:25939",
      havana_gene : "OTTHUMG00000153930.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8204733,
      stop : 8210600,
      direction : "-",
      ID : "ENSG00000178999.13",
      gene_id : "ENSG00000178999.13",
      gene_type : "protein_coding",
      gene_name : "AURKB",
      gene_level : 1,
      hgnc_id : "HGNC:11390",
      havana_gene : "OTTHUMG00000108189.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8224815,
      stop : 8248056,
      direction : "-",
      ID : "ENSG00000178971.16",
      gene_id : "ENSG00000178971.16",
      gene_type : "protein_coding",
      gene_name : "CTC1",
      gene_level : 1,
      hgnc_id : "HGNC:26169",
      havana_gene : "OTTHUMG00000178443.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8247618,
      stop : 8270491,
      direction : "+",
      ID : "ENSG00000178921.14",
      gene_id : "ENSG00000178921.14",
      gene_type : "protein_coding",
      gene_name : "PFAS",
      gene_level : 2,
      hgnc_id : "HGNC:8863",
      havana_gene : "OTTHUMG00000108188.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8287763,
      stop : 8295400,
      direction : "-",
      ID : "ENSG00000125434.11",
      gene_id : "ENSG00000125434.11",
      gene_type : "protein_coding",
      gene_name : "SLC25A35",
      gene_level : 2,
      hgnc_id : "HGNC:31921",
      havana_gene : "OTTHUMG00000178480.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8288654,
      stop : 8290092,
      direction : "+",
      ID : "ENSG00000108961.14",
      gene_id : "ENSG00000108961.14",
      gene_type : "protein_coding",
      gene_name : "RANGRF",
      gene_level : 2,
      hgnc_id : "HGNC:17679",
      havana_gene : "OTTHUMG00000178473.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8310241,
      stop : 8322514,
      direction : "+",
      ID : "ENSG00000198844.12",
      gene_id : "ENSG00000198844.12",
      gene_type : "protein_coding",
      gene_name : "ARHGEF15",
      gene_level : 2,
      hgnc_id : "HGNC:15590",
      havana_gene : "OTTHUMG00000108187.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8339840,
      stop : 8346048,
      direction : "+",
      ID : "ENSG00000184650.11",
      gene_id : "ENSG00000184650.11",
      gene_type : "protein_coding",
      gene_name : "ODF4",
      gene_level : 1,
      hgnc_id : "HGNC:19056",
      havana_gene : "OTTHUMG00000108190.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8356902,
      stop : 8376704,
      direction : "-",
      ID : "ENSG00000184619.8",
      gene_id : "ENSG00000184619.8",
      gene_type : "protein_coding",
      gene_name : "KRBA2",
      gene_level : 1,
      hgnc_id : "HGNC:26989",
      havana_gene : "OTTHUMG00000132864.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8368638,
      stop : 8383187,
      direction : "-",
      ID : "ENSG00000263809.1",
      gene_id : "ENSG00000263809.1",
      gene_type : "protein_coding",
      gene_name : "AC135178.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178564.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8377516,
      stop : 8383213,
      direction : "-",
      ID : "ENSG00000161970.15",
      gene_id : "ENSG00000161970.15",
      gene_type : "protein_coding",
      gene_name : "RPL26",
      gene_level : 1,
      hgnc_id : "HGNC:10327",
      havana_gene : "OTTHUMG00000108191.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8390704,
      stop : 8397826,
      direction : "-",
      ID : "ENSG00000189051.5",
      gene_id : "ENSG00000189051.5",
      gene_type : "protein_coding",
      gene_name : "RNF222",
      gene_level : 2,
      hgnc_id : "HGNC:34517",
      havana_gene : "OTTHUMG00000132049.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8413131,
      stop : 8490411,
      direction : "+",
      ID : "ENSG00000166579.16",
      gene_id : "ENSG00000166579.16",
      gene_type : "protein_coding",
      gene_name : "NDEL1",
      gene_level : 1,
      hgnc_id : "HGNC:17620",
      havana_gene : "OTTHUMG00000108193.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8474207,
      stop : 8630761,
      direction : "-",
      ID : "ENSG00000133026.13",
      gene_id : "ENSG00000133026.13",
      gene_type : "protein_coding",
      gene_name : "MYH10",
      gene_level : 2,
      hgnc_id : "HGNC:7568",
      havana_gene : "OTTHUMG00000108195.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8729935,
      stop : 8745219,
      direction : "-",
      ID : "ENSG00000161973.11",
      gene_id : "ENSG00000161973.11",
      gene_type : "protein_coding",
      gene_name : "CCDC42",
      gene_level : 2,
      hgnc_id : "HGNC:26528",
      havana_gene : "OTTHUMG00000178565.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8753106,
      stop : 8758559,
      direction : "-",
      ID : "ENSG00000183318.11",
      gene_id : "ENSG00000183318.11",
      gene_type : "protein_coding",
      gene_name : "SPDYE4",
      gene_level : 2,
      hgnc_id : "HGNC:35463",
      havana_gene : "OTTHUMG00000178566.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8797110,
      stop : 8799365,
      direction : "-",
      ID : "ENSG00000185156.6",
      gene_id : "ENSG00000185156.6",
      gene_type : "protein_coding",
      gene_name : "MFSD6L",
      gene_level : 2,
      hgnc_id : "HGNC:26656",
      havana_gene : "OTTHUMG00000178584.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8802722,
      stop : 8867677,
      direction : "-",
      ID : "ENSG00000276231.5",
      gene_id : "ENSG00000276231.5",
      gene_type : "protein_coding",
      gene_name : "PIK3R6",
      gene_level : 2,
      hgnc_id : "HGNC:27101",
      havana_gene : "OTTHUMG00000132861.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 8878911,
      stop : 8965712,
      direction : "-",
      ID : "ENSG00000141506.14",
      gene_id : "ENSG00000141506.14",
      gene_type : "protein_coding",
      gene_name : "PIK3R5",
      gene_level : 2,
      hgnc_id : "HGNC:30035",
      havana_gene : "OTTHUMG00000108197.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9021510,
      stop : 9244000,
      direction : "+",
      ID : "ENSG00000065320.9",
      gene_id : "ENSG00000065320.9",
      gene_type : "protein_coding",
      gene_name : "NTN1",
      gene_level : 2,
      hgnc_id : "HGNC:8029",
      havana_gene : "OTTHUMG00000130257.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9250471,
      stop : 9576591,
      direction : "-",
      ID : "ENSG00000170310.15",
      gene_id : "ENSG00000170310.15",
      gene_type : "protein_coding",
      gene_name : "STX8",
      gene_level : 1,
      hgnc_id : "HGNC:11443",
      havana_gene : "OTTHUMG00000177844.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9576627,
      stop : 9643447,
      direction : "+",
      ID : "ENSG00000166596.15",
      gene_id : "ENSG00000166596.15",
      gene_type : "protein_coding",
      gene_name : "CFAP52",
      gene_level : 1,
      hgnc_id : "HGNC:16053",
      havana_gene : "OTTHUMG00000150149.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9644698,
      stop : 9729687,
      direction : "+",
      ID : "ENSG00000154914.17",
      gene_id : "ENSG00000154914.17",
      gene_type : "protein_coding",
      gene_name : "USP43",
      gene_level : 1,
      hgnc_id : "HGNC:20072",
      havana_gene : "OTTHUMG00000177942.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9771434,
      stop : 9791592,
      direction : "-",
      ID : "ENSG00000184544.12",
      gene_id : "ENSG00000184544.12",
      gene_type : "protein_coding",
      gene_name : "DHRS7C",
      gene_level : 1,
      hgnc_id : "HGNC:32423",
      havana_gene : "OTTHUMG00000177944.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9802386,
      stop : 9822071,
      direction : "-",
      ID : "ENSG00000214978.7",
      gene_id : "ENSG00000214978.7",
      gene_type : "protein_coding",
      gene_name : "GSG1L2",
      gene_level : 1,
      hgnc_id : "HGNC:51826",
      havana_gene : "OTTHUMG00000178429.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9822206,
      stop : 9892099,
      direction : "+",
      ID : "ENSG00000065325.13",
      gene_id : "ENSG00000065325.13",
      gene_type : "protein_coding",
      gene_name : "GLP2R",
      gene_level : 2,
      hgnc_id : "HGNC:4325",
      havana_gene : "OTTHUMG00000130269.12",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9896320,
      stop : 9905271,
      direction : "-",
      ID : "ENSG00000109047.8",
      gene_id : "ENSG00000109047.8",
      gene_type : "protein_coding",
      gene_name : "RCVRN",
      gene_level : 2,
      hgnc_id : "HGNC:9937",
      havana_gene : "OTTHUMG00000130268.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 9910606,
      stop : 10198606,
      direction : "-",
      ID : "ENSG00000007237.19",
      gene_id : "ENSG00000007237.19",
      gene_type : "protein_coding",
      gene_name : "GAS7",
      gene_level : 2,
      hgnc_id : "HGNC:4169",
      havana_gene : "OTTHUMG00000177945.15",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10300865,
      stop : 10373130,
      direction : "-",
      ID : "ENSG00000006788.14",
      gene_id : "ENSG00000006788.14",
      gene_type : "protein_coding",
      gene_name : "MYH13",
      gene_level : 2,
      hgnc_id : "HGNC:7571",
      havana_gene : "OTTHUMG00000177987.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10390322,
      stop : 10421950,
      direction : "-",
      ID : "ENSG00000133020.4",
      gene_id : "ENSG00000133020.4",
      gene_type : "protein_coding",
      gene_name : "MYH8",
      gene_level : 2,
      hgnc_id : "HGNC:7578",
      havana_gene : "OTTHUMG00000130361.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10443290,
      stop : 10469559,
      direction : "-",
      ID : "ENSG00000264424.1",
      gene_id : "ENSG00000264424.1",
      gene_type : "protein_coding",
      gene_name : "MYH4",
      gene_level : 2,
      hgnc_id : "HGNC:7574",
      havana_gene : "OTTHUMG00000130365.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10492307,
      stop : 10518542,
      direction : "-",
      ID : "ENSG00000109061.10",
      gene_id : "ENSG00000109061.10",
      gene_type : "protein_coding",
      gene_name : "MYH1",
      gene_level : 2,
      hgnc_id : "HGNC:7567",
      havana_gene : "OTTHUMG00000130362.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10521148,
      stop : 10549700,
      direction : "-",
      ID : "ENSG00000125414.19",
      gene_id : "ENSG00000125414.19",
      gene_type : "protein_coding",
      gene_name : "MYH2",
      gene_level : 1,
      hgnc_id : "HGNC:7572",
      havana_gene : "OTTHUMG00000130363.60",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10628526,
      stop : 10657309,
      direction : "-",
      ID : "ENSG00000109063.15",
      gene_id : "ENSG00000109063.15",
      gene_type : "protein_coding",
      gene_name : "MYH3",
      gene_level : 2,
      hgnc_id : "HGNC:7573",
      havana_gene : "OTTHUMG00000130367.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10672474,
      stop : 10698375,
      direction : "-",
      ID : "ENSG00000133028.12",
      gene_id : "ENSG00000133028.12",
      gene_type : "protein_coding",
      gene_name : "SCO1",
      gene_level : 1,
      hgnc_id : "HGNC:10603",
      havana_gene : "OTTHUMG00000130364.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10697594,
      stop : 10711558,
      direction : "+",
      ID : "ENSG00000170222.12",
      gene_id : "ENSG00000170222.12",
      gene_type : "protein_coding",
      gene_name : "ADPRM",
      gene_level : 2,
      hgnc_id : "HGNC:30925",
      havana_gene : "OTTHUMG00000130366.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10699015,
      stop : 10730023,
      direction : "-",
      ID : "ENSG00000187824.9",
      gene_id : "ENSG00000187824.9",
      gene_type : "protein_coding",
      gene_name : "TMEM220",
      gene_level : 1,
      hgnc_id : "HGNC:33757",
      havana_gene : "OTTHUMG00000178043.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10794913,
      stop : 10804099,
      direction : "-",
      ID : "ENSG00000263429.3",
      gene_id : "ENSG00000263429.3",
      gene_type : "protein_coding",
      gene_name : "TMEM238L",
      gene_level : 1,
      hgnc_id : "HGNC:44356",
      havana_gene : "OTTHUMG00000132847.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 10822470,
      stop : 10838087,
      direction : "-",
      ID : "ENSG00000233670.7",
      gene_id : "ENSG00000233670.7",
      gene_type : "protein_coding",
      gene_name : "PIRT",
      gene_level : 2,
      hgnc_id : "HGNC:37239",
      havana_gene : "OTTHUMG00000178234.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 11241213,
      stop : 11564063,
      direction : "+",
      ID : "ENSG00000188803.15",
      gene_id : "ENSG00000188803.15",
      gene_type : "protein_coding",
      gene_name : "SHISA6",
      gene_level : 2,
      hgnc_id : "HGNC:34491",
      havana_gene : "OTTHUMG00000154121.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 11598470,
      stop : 11969748,
      direction : "+",
      ID : "ENSG00000007174.18",
      gene_id : "ENSG00000007174.18",
      gene_type : "protein_coding",
      gene_name : "DNAH9",
      gene_level : 1,
      hgnc_id : "HGNC:2953",
      havana_gene : "OTTHUMG00000130383.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 11977439,
      stop : 11997475,
      direction : "-",
      ID : "ENSG00000154957.14",
      gene_id : "ENSG00000154957.14",
      gene_type : "protein_coding",
      gene_name : "ZNF18",
      gene_level : 1,
      hgnc_id : "HGNC:12969",
      havana_gene : "OTTHUMG00000178307.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 12020829,
      stop : 12143830,
      direction : "+",
      ID : "ENSG00000065559.15",
      gene_id : "ENSG00000065559.15",
      gene_type : "protein_coding",
      gene_name : "MAP2K4",
      gene_level : 1,
      hgnc_id : "HGNC:6844",
      havana_gene : "OTTHUMG00000178267.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 12665890,
      stop : 12768949,
      direction : "+",
      ID : "ENSG00000141052.18",
      gene_id : "ENSG00000141052.18",
      gene_type : "protein_coding",
      gene_name : "MYOCD",
      gene_level : 2,
      hgnc_id : "HGNC:16067",
      havana_gene : "OTTHUMG00000058767.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 12789498,
      stop : 12991643,
      direction : "+",
      ID : "ENSG00000006740.17",
      gene_id : "ENSG00000006740.17",
      gene_type : "protein_coding",
      gene_name : "ARHGAP44",
      gene_level : 1,
      hgnc_id : "HGNC:29096",
      havana_gene : "OTTHUMG00000058765.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 12991612,
      stop : 13018065,
      direction : "-",
      ID : "ENSG00000006744.19",
      gene_id : "ENSG00000006744.19",
      gene_type : "protein_coding",
      gene_name : "ELAC2",
      gene_level : 1,
      hgnc_id : "HGNC:14198",
      havana_gene : "OTTHUMG00000058764.16",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 13494032,
      stop : 13601929,
      direction : "-",
      ID : "ENSG00000153976.3",
      gene_id : "ENSG00000153976.3",
      gene_type : "protein_coding",
      gene_name : "HS3ST3A1",
      gene_level : 2,
      hgnc_id : "HGNC:5196",
      havana_gene : "OTTHUMG00000058768.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 14069490,
      stop : 14231736,
      direction : "+",
      ID : "ENSG00000006695.12",
      gene_id : "ENSG00000006695.12",
      gene_type : "protein_coding",
      gene_name : "COX10",
      gene_level : 2,
      hgnc_id : "HGNC:2260",
      havana_gene : "OTTHUMG00000058814.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 14235673,
      stop : 14236862,
      direction : "-",
      ID : "ENSG00000223510.7",
      gene_id : "ENSG00000223510.7",
      gene_type : "protein_coding",
      gene_name : "CDRT15",
      gene_level : 1,
      hgnc_id : "HGNC:14395",
      havana_gene : "OTTHUMG00000179686.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 14301081,
      stop : 14349404,
      direction : "+",
      ID : "ENSG00000125430.9",
      gene_id : "ENSG00000125430.9",
      gene_type : "protein_coding",
      gene_name : "HS3ST3B1",
      gene_level : 2,
      hgnc_id : "HGNC:5198",
      havana_gene : "OTTHUMG00000058810.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15229773,
      stop : 15272292,
      direction : "-",
      ID : "ENSG00000109099.16",
      gene_id : "ENSG00000109099.16",
      gene_type : "protein_coding",
      gene_name : "PMP22",
      gene_level : 1,
      hgnc_id : "HGNC:9118",
      havana_gene : "OTTHUMG00000058960.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15303811,
      stop : 15341632,
      direction : "-",
      ID : "ENSG00000125409.13",
      gene_id : "ENSG00000125409.13",
      gene_type : "protein_coding",
      gene_name : "TEKT3",
      gene_level : 1,
      hgnc_id : "HGNC:14293",
      havana_gene : "OTTHUMG00000058965.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15436015,
      stop : 15503608,
      direction : "-",
      ID : "ENSG00000239704.11",
      gene_id : "ENSG00000239704.11",
      gene_type : "protein_coding",
      gene_name : "CDRT4",
      gene_level : 2,
      hgnc_id : "HGNC:14383",
      havana_gene : "OTTHUMG00000059070.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15436021,
      stop : 15563561,
      direction : "-",
      ID : "ENSG00000259024.6",
      gene_id : "ENSG00000259024.6",
      gene_type : "protein_coding",
      gene_name : "TVP23C-CDRT4",
      gene_level : 2,
      hgnc_id : "HGNC:42961",
      havana_gene : "OTTHUMG00000165004.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15502264,
      stop : 15563595,
      direction : "-",
      ID : "ENSG00000175106.17",
      gene_id : "ENSG00000175106.17",
      gene_type : "protein_coding",
      gene_name : "TVP23C",
      gene_level : 1,
      hgnc_id : "HGNC:30453",
      havana_gene : "OTTHUMG00000171461.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15565483,
      stop : 15619704,
      direction : "-",
      ID : "ENSG00000241322.11",
      gene_id : "ENSG00000241322.11",
      gene_type : "protein_coding",
      gene_name : "CDRT1",
      gene_level : 1,
      hgnc_id : "HGNC:14379",
      havana_gene : "OTTHUMG00000059074.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15571491,
      stop : 15651653,
      direction : "-",
      ID : "ENSG00000251537.4",
      gene_id : "ENSG00000251537.4",
      gene_type : "protein_coding",
      gene_name : "AC005324.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160985.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15627960,
      stop : 15684311,
      direction : "-",
      ID : "ENSG00000221926.13",
      gene_id : "ENSG00000221926.13",
      gene_type : "protein_coding",
      gene_name : "TRIM16",
      gene_level : 1,
      hgnc_id : "HGNC:17241",
      havana_gene : "OTTHUMG00000059067.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15699577,
      stop : 15720787,
      direction : "+",
      ID : "ENSG00000187607.16",
      gene_id : "ENSG00000187607.16",
      gene_type : "protein_coding",
      gene_name : "ZNF286A",
      gene_level : 2,
      hgnc_id : "HGNC:13501",
      havana_gene : "OTTHUMG00000166448.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15699692,
      stop : 15744778,
      direction : "+",
      ID : "ENSG00000255104.8",
      gene_id : "ENSG00000255104.8",
      gene_type : "protein_coding",
      gene_name : "AC005324.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000059066.14",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15732247,
      stop : 15749192,
      direction : "+",
      ID : "ENSG00000214946.14",
      gene_id : "ENSG00000214946.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D26",
      gene_level : 2,
      hgnc_id : "HGNC:28745",
      havana_gene : "OTTHUMG00000059071.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15944917,
      stop : 15975746,
      direction : "+",
      ID : "ENSG00000170425.3",
      gene_id : "ENSG00000170425.3",
      gene_type : "protein_coding",
      gene_name : "ADORA2B",
      gene_level : 2,
      hgnc_id : "HGNC:264",
      havana_gene : "OTTHUMG00000059140.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15976560,
      stop : 15999717,
      direction : "-",
      ID : "ENSG00000214941.8",
      gene_id : "ENSG00000214941.8",
      gene_type : "protein_coding",
      gene_name : "ZSWIM7",
      gene_level : 1,
      hgnc_id : "HGNC:26993",
      havana_gene : "OTTHUMG00000059308.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 15999784,
      stop : 16045015,
      direction : "+",
      ID : "ENSG00000011295.16",
      gene_id : "ENSG00000011295.16",
      gene_type : "protein_coding",
      gene_name : "TTC19",
      gene_level : 1,
      hgnc_id : "HGNC:26006",
      havana_gene : "OTTHUMG00000059306.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16029157,
      stop : 16218185,
      direction : "-",
      ID : "ENSG00000141027.21",
      gene_id : "ENSG00000141027.21",
      gene_type : "protein_coding",
      gene_name : "NCOR1",
      gene_level : 1,
      hgnc_id : "HGNC:7672",
      havana_gene : "OTTHUMG00000059309.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16217191,
      stop : 16351797,
      direction : "+",
      ID : "ENSG00000108474.17",
      gene_id : "ENSG00000108474.17",
      gene_type : "protein_coding",
      gene_name : "PIGL",
      gene_level : 1,
      hgnc_id : "HGNC:8966",
      havana_gene : "OTTHUMG00000059346.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16342534,
      stop : 16353656,
      direction : "-",
      ID : "ENSG00000166582.10",
      gene_id : "ENSG00000166582.10",
      gene_type : "protein_coding",
      gene_name : "CENPV",
      gene_level : 2,
      hgnc_id : "HGNC:29920",
      havana_gene : "OTTHUMG00000059345.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16380798,
      stop : 16382745,
      direction : "+",
      ID : "ENSG00000170315.14",
      gene_id : "ENSG00000170315.14",
      gene_type : "protein_coding",
      gene_name : "UBB",
      gene_level : 1,
      hgnc_id : "HGNC:12463",
      havana_gene : "OTTHUMG00000058987.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16415571,
      stop : 16437003,
      direction : "+",
      ID : "ENSG00000187688.15",
      gene_id : "ENSG00000187688.15",
      gene_type : "protein_coding",
      gene_name : "TRPV2",
      gene_level : 1,
      hgnc_id : "HGNC:18082",
      havana_gene : "OTTHUMG00000058989.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16441577,
      stop : 16492193,
      direction : "-",
      ID : "ENSG00000181350.12",
      gene_id : "ENSG00000181350.12",
      gene_type : "protein_coding",
      gene_name : "LRRC75A",
      gene_level : 1,
      hgnc_id : "HGNC:32403",
      havana_gene : "OTTHUMG00000058988.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16546954,
      stop : 16569204,
      direction : "-",
      ID : "ENSG00000141040.15",
      gene_id : "ENSG00000141040.15",
      gene_type : "protein_coding",
      gene_name : "ZNF287",
      gene_level : 1,
      hgnc_id : "HGNC:13502",
      havana_gene : "OTTHUMG00000058993.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16620734,
      stop : 16653856,
      direction : "-",
      ID : "ENSG00000197566.10",
      gene_id : "ENSG00000197566.10",
      gene_type : "protein_coding",
      gene_name : "ZNF624",
      gene_level : 2,
      hgnc_id : "HGNC:29254",
      havana_gene : "OTTHUMG00000058996.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16689537,
      stop : 16777881,
      direction : "+",
      ID : "ENSG00000170160.17",
      gene_id : "ENSG00000170160.17",
      gene_type : "protein_coding",
      gene_name : "CCDC144A",
      gene_level : 2,
      hgnc_id : "HGNC:29072",
      havana_gene : "OTTHUMG00000059178.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16690261,
      stop : 16804453,
      direction : "+",
      ID : "ENSG00000266302.6",
      gene_id : "ENSG00000266302.6",
      gene_type : "protein_coding",
      gene_name : "AC098850.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000179236.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 16929816,
      stop : 16972118,
      direction : "-",
      ID : "ENSG00000240505.9",
      gene_id : "ENSG00000240505.9",
      gene_type : "protein_coding",
      gene_name : "TNFRSF13B",
      gene_level : 1,
      hgnc_id : "HGNC:18153",
      havana_gene : "OTTHUMG00000059262.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17042457,
      stop : 17217679,
      direction : "+",
      ID : "ENSG00000133030.22",
      gene_id : "ENSG00000133030.22",
      gene_type : "protein_coding",
      gene_name : "MPRIP",
      gene_level : 1,
      hgnc_id : "HGNC:30321",
      havana_gene : "OTTHUMG00000059276.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17200995,
      stop : 17206333,
      direction : "-",
      ID : "ENSG00000179598.6",
      gene_id : "ENSG00000179598.6",
      gene_type : "protein_coding",
      gene_name : "PLD6",
      gene_level : 2,
      hgnc_id : "HGNC:30447",
      havana_gene : "OTTHUMG00000059278.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17202649,
      stop : 17237185,
      direction : "-",
      ID : "ENSG00000264187.1",
      gene_id : "ENSG00000264187.1",
      gene_type : "protein_coding",
      gene_name : "AC055811.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179185.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17212212,
      stop : 17237188,
      direction : "-",
      ID : "ENSG00000154803.13",
      gene_id : "ENSG00000154803.13",
      gene_type : "protein_coding",
      gene_name : "FLCN",
      gene_level : 2,
      hgnc_id : "HGNC:27310",
      havana_gene : "OTTHUMG00000059275.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17246616,
      stop : 17281273,
      direction : "-",
      ID : "ENSG00000141030.13",
      gene_id : "ENSG00000141030.13",
      gene_type : "protein_coding",
      gene_name : "COPS3",
      gene_level : 1,
      hgnc_id : "HGNC:2239",
      havana_gene : "OTTHUMG00000059281.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17303335,
      stop : 17347663,
      direction : "+",
      ID : "ENSG00000205309.14",
      gene_id : "ENSG00000205309.14",
      gene_type : "protein_coding",
      gene_name : "NT5M",
      gene_level : 2,
      hgnc_id : "HGNC:15769",
      havana_gene : "OTTHUMG00000059277.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17476994,
      stop : 17493221,
      direction : "+",
      ID : "ENSG00000141026.6",
      gene_id : "ENSG00000141026.6",
      gene_type : "protein_coding",
      gene_name : "MED9",
      gene_level : 2,
      hgnc_id : "HGNC:25487",
      havana_gene : "OTTHUMG00000059293.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17494437,
      stop : 17496395,
      direction : "-",
      ID : "ENSG00000108551.5",
      gene_id : "ENSG00000108551.5",
      gene_type : "protein_coding",
      gene_name : "RASD1",
      gene_level : 1,
      hgnc_id : "HGNC:15828",
      havana_gene : "OTTHUMG00000059292.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17505563,
      stop : 17591708,
      direction : "-",
      ID : "ENSG00000133027.18",
      gene_id : "ENSG00000133027.18",
      gene_type : "protein_coding",
      gene_name : "PEMT",
      gene_level : 2,
      hgnc_id : "HGNC:8830",
      havana_gene : "OTTHUMG00000059290.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17681458,
      stop : 17811453,
      direction : "+",
      ID : "ENSG00000108557.19",
      gene_id : "ENSG00000108557.19",
      gene_type : "protein_coding",
      gene_name : "RAI1",
      gene_level : 2,
      hgnc_id : "HGNC:9834",
      havana_gene : "OTTHUMG00000059314.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17810399,
      stop : 17837011,
      direction : "-",
      ID : "ENSG00000072310.17",
      gene_id : "ENSG00000072310.17",
      gene_type : "protein_coding",
      gene_name : "SREBF1",
      gene_level : 2,
      hgnc_id : "HGNC:11289",
      havana_gene : "OTTHUMG00000059313.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17843511,
      stop : 17972422,
      direction : "-",
      ID : "ENSG00000175662.18",
      gene_id : "ENSG00000175662.18",
      gene_type : "protein_coding",
      gene_name : "TOM1L2",
      gene_level : 1,
      hgnc_id : "HGNC:11984",
      havana_gene : "OTTHUMG00000059353.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17972813,
      stop : 18016889,
      direction : "+",
      ID : "ENSG00000171962.18",
      gene_id : "ENSG00000171962.18",
      gene_type : "protein_coding",
      gene_name : "DRC3",
      gene_level : 1,
      hgnc_id : "HGNC:25384",
      havana_gene : "OTTHUMG00000059355.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 17977409,
      stop : 18039209,
      direction : "-",
      ID : "ENSG00000171953.16",
      gene_id : "ENSG00000171953.16",
      gene_type : "protein_coding",
      gene_name : "ATPAF2",
      gene_level : 2,
      hgnc_id : "HGNC:18802",
      havana_gene : "OTTHUMG00000059354.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18039408,
      stop : 18068405,
      direction : "+",
      ID : "ENSG00000141034.10",
      gene_id : "ENSG00000141034.10",
      gene_type : "protein_coding",
      gene_name : "GID4",
      gene_level : 2,
      hgnc_id : "HGNC:28453",
      havana_gene : "OTTHUMG00000059398.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18087892,
      stop : 18107970,
      direction : "+",
      ID : "ENSG00000108591.10",
      gene_id : "ENSG00000108591.10",
      gene_type : "protein_coding",
      gene_name : "DRG2",
      gene_level : 1,
      hgnc_id : "HGNC:3030",
      havana_gene : "OTTHUMG00000059399.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18108706,
      stop : 18179802,
      direction : "+",
      ID : "ENSG00000091536.19",
      gene_id : "ENSG00000091536.19",
      gene_type : "protein_coding",
      gene_name : "MYO15A",
      gene_level : 1,
      hgnc_id : "HGNC:7594",
      havana_gene : "OTTHUMG00000059390.14",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18183078,
      stop : 18209954,
      direction : "+",
      ID : "ENSG00000091542.9",
      gene_id : "ENSG00000091542.9",
      gene_type : "protein_coding",
      gene_name : "ALKBH5",
      gene_level : 1,
      hgnc_id : "HGNC:25996",
      havana_gene : "OTTHUMG00000059397.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18225635,
      stop : 18244875,
      direction : "+",
      ID : "ENSG00000131899.11",
      gene_id : "ENSG00000131899.11",
      gene_type : "protein_coding",
      gene_name : "LLGL1",
      gene_level : 2,
      hgnc_id : "HGNC:6628",
      havana_gene : "OTTHUMG00000059396.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18244815,
      stop : 18258738,
      direction : "-",
      ID : "ENSG00000177731.16",
      gene_id : "ENSG00000177731.16",
      gene_type : "protein_coding",
      gene_name : "FLII",
      gene_level : 2,
      hgnc_id : "HGNC:3750",
      havana_gene : "OTTHUMG00000059389.11",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18260597,
      stop : 18266552,
      direction : "+",
      ID : "ENSG00000177427.13",
      gene_id : "ENSG00000177427.13",
      gene_type : "protein_coding",
      gene_name : "MIEF2",
      gene_level : 1,
      hgnc_id : "HGNC:17920",
      havana_gene : "OTTHUMG00000059392.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18271428,
      stop : 18315007,
      direction : "-",
      ID : "ENSG00000177302.15",
      gene_id : "ENSG00000177302.15",
      gene_type : "protein_coding",
      gene_name : "TOP3A",
      gene_level : 2,
      hgnc_id : "HGNC:11992",
      havana_gene : "OTTHUMG00000059391.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18315293,
      stop : 18328056,
      direction : "+",
      ID : "ENSG00000176994.11",
      gene_id : "ENSG00000176994.11",
      gene_type : "protein_coding",
      gene_name : "SMCR8",
      gene_level : 2,
      hgnc_id : "HGNC:17921",
      havana_gene : "OTTHUMG00000059394.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18327860,
      stop : 18363563,
      direction : "-",
      ID : "ENSG00000176974.20",
      gene_id : "ENSG00000176974.20",
      gene_type : "protein_coding",
      gene_name : "SHMT1",
      gene_level : 2,
      hgnc_id : "HGNC:10850",
      havana_gene : "OTTHUMG00000059094.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18377778,
      stop : 18389647,
      direction : "+",
      ID : "ENSG00000214860.5",
      gene_id : "ENSG00000214860.5",
      gene_type : "protein_coding",
      gene_name : "EVPLL",
      gene_level : 1,
      hgnc_id : "HGNC:35236",
      havana_gene : "OTTHUMG00000059095.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18476737,
      stop : 18494945,
      direction : "+",
      ID : "ENSG00000171916.17",
      gene_id : "ENSG00000171916.17",
      gene_type : "protein_coding",
      gene_name : "LGALS9C",
      gene_level : 2,
      hgnc_id : "HGNC:33874",
      havana_gene : "OTTHUMG00000059251.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18634247,
      stop : 18644427,
      direction : "-",
      ID : "ENSG00000189375.12",
      gene_id : "ENSG00000189375.12",
      gene_type : "protein_coding",
      gene_name : "TBC1D28",
      gene_level : 2,
      hgnc_id : "HGNC:26858",
      havana_gene : "OTTHUMG00000059054.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18667629,
      stop : 18682314,
      direction : "-",
      ID : "ENSG00000240445.6",
      gene_id : "ENSG00000240445.6",
      gene_type : "protein_coding",
      gene_name : "FOXO3B",
      gene_level : 2,
      hgnc_id : "HGNC:3822",
      havana_gene : "OTTHUMG00000059047.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18744026,
      stop : 18779349,
      direction : "+",
      ID : "ENSG00000171931.13",
      gene_id : "ENSG00000171931.13",
      gene_type : "protein_coding",
      gene_name : "FBXW10",
      gene_level : 2,
      hgnc_id : "HGNC:1211",
      havana_gene : "OTTHUMG00000059048.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18781111,
      stop : 18806714,
      direction : "+",
      ID : "ENSG00000171928.14",
      gene_id : "ENSG00000171928.14",
      gene_type : "protein_coding",
      gene_name : "TVP23B",
      gene_level : 2,
      hgnc_id : "HGNC:20399",
      havana_gene : "OTTHUMG00000059052.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18840085,
      stop : 18931287,
      direction : "+",
      ID : "ENSG00000141127.15",
      gene_id : "ENSG00000141127.15",
      gene_type : "protein_coding",
      gene_name : "PRPSAP2",
      gene_level : 1,
      hgnc_id : "HGNC:9467",
      havana_gene : "OTTHUMG00000059406.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18950345,
      stop : 19022595,
      direction : "+",
      ID : "ENSG00000154025.16",
      gene_id : "ENSG00000154025.16",
      gene_type : "protein_coding",
      gene_name : "SLC5A10",
      gene_level : 2,
      hgnc_id : "HGNC:23155",
      havana_gene : "OTTHUMG00000178143.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 18968789,
      stop : 19004764,
      direction : "-",
      ID : "ENSG00000188522.15",
      gene_id : "ENSG00000188522.15",
      gene_type : "protein_coding",
      gene_name : "FAM83G",
      gene_level : 2,
      hgnc_id : "HGNC:32554",
      havana_gene : "OTTHUMG00000059411.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19020656,
      stop : 19047011,
      direction : "-",
      ID : "ENSG00000154016.14",
      gene_id : "ENSG00000154016.14",
      gene_type : "protein_coding",
      gene_name : "GRAP",
      gene_level : 1,
      hgnc_id : "HGNC:4562",
      havana_gene : "OTTHUMG00000059436.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19127535,
      stop : 19159187,
      direction : "+",
      ID : "ENSG00000189152.11",
      gene_id : "ENSG00000189152.11",
      gene_type : "protein_coding",
      gene_name : "GRAPL",
      gene_level : 1,
      hgnc_id : "HGNC:37240",
      havana_gene : "OTTHUMG00000059435.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19215615,
      stop : 19336715,
      direction : "+",
      ID : "ENSG00000072134.15",
      gene_id : "ENSG00000072134.15",
      gene_type : "protein_coding",
      gene_name : "EPN2",
      gene_level : 1,
      hgnc_id : "HGNC:18639",
      havana_gene : "OTTHUMG00000187034.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19334308,
      stop : 19378193,
      direction : "-",
      ID : "ENSG00000108641.19",
      gene_id : "ENSG00000108641.19",
      gene_type : "protein_coding",
      gene_name : "B9D1",
      gene_level : 2,
      hgnc_id : "HGNC:24123",
      havana_gene : "OTTHUMG00000059586.17",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19377721,
      stop : 19383544,
      direction : "+",
      ID : "ENSG00000166484.20",
      gene_id : "ENSG00000166484.20",
      gene_type : "protein_coding",
      gene_name : "MAPK7",
      gene_level : 2,
      hgnc_id : "HGNC:6880",
      havana_gene : "OTTHUMG00000059587.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19383442,
      stop : 19387190,
      direction : "-",
      ID : "ENSG00000166482.12",
      gene_id : "ENSG00000166482.12",
      gene_type : "protein_coding",
      gene_name : "MFAP4",
      gene_level : 2,
      hgnc_id : "HGNC:7035",
      havana_gene : "OTTHUMG00000059585.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19411125,
      stop : 19417276,
      direction : "+",
      ID : "ENSG00000128482.16",
      gene_id : "ENSG00000128482.16",
      gene_type : "protein_coding",
      gene_name : "RNF112",
      gene_level : 2,
      hgnc_id : "HGNC:12968",
      havana_gene : "OTTHUMG00000059601.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19495385,
      stop : 19579034,
      direction : "+",
      ID : "ENSG00000142494.13",
      gene_id : "ENSG00000142494.13",
      gene_type : "protein_coding",
      gene_name : "SLC47A1",
      gene_level : 1,
      hgnc_id : "HGNC:25588",
      havana_gene : "OTTHUMG00000059466.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19648136,
      stop : 19685760,
      direction : "+",
      ID : "ENSG00000072210.19",
      gene_id : "ENSG00000072210.19",
      gene_type : "protein_coding",
      gene_name : "ALDH3A2",
      gene_level : 1,
      hgnc_id : "HGNC:403",
      havana_gene : "OTTHUMG00000059471.22",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19678288,
      stop : 19718979,
      direction : "-",
      ID : "ENSG00000180638.19",
      gene_id : "ENSG00000180638.19",
      gene_type : "protein_coding",
      gene_name : "SLC47A2",
      gene_level : 2,
      hgnc_id : "HGNC:26439",
      havana_gene : "OTTHUMG00000059464.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19737984,
      stop : 19748943,
      direction : "-",
      ID : "ENSG00000108602.18",
      gene_id : "ENSG00000108602.18",
      gene_type : "protein_coding",
      gene_name : "ALDH3A1",
      gene_level : 2,
      hgnc_id : "HGNC:405",
      havana_gene : "OTTHUMG00000059469.12",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19770829,
      stop : 19867936,
      direction : "-",
      ID : "ENSG00000083290.20",
      gene_id : "ENSG00000083290.20",
      gene_type : "protein_coding",
      gene_name : "ULK2",
      gene_level : 1,
      hgnc_id : "HGNC:13480",
      havana_gene : "OTTHUMG00000059511.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 19904302,
      stop : 19978343,
      direction : "-",
      ID : "ENSG00000108599.15",
      gene_id : "ENSG00000108599.15",
      gene_type : "protein_coding",
      gene_name : "AKAP10",
      gene_level : 1,
      hgnc_id : "HGNC:368",
      havana_gene : "OTTHUMG00000059515.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 20008865,
      stop : 20319026,
      direction : "+",
      ID : "ENSG00000128487.18",
      gene_id : "ENSG00000128487.18",
      gene_type : "protein_coding",
      gene_name : "SPECC1",
      gene_level : 1,
      hgnc_id : "HGNC:30615",
      havana_gene : "OTTHUMG00000179808.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 20449395,
      stop : 20467539,
      direction : "-",
      ID : "ENSG00000170298.15",
      gene_id : "ENSG00000170298.15",
      gene_type : "protein_coding",
      gene_name : "LGALS9B",
      gene_level : 2,
      hgnc_id : "HGNC:24842",
      havana_gene : "OTTHUMG00000130730.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 20579724,
      stop : 20580911,
      direction : "+",
      ID : "ENSG00000214819.2",
      gene_id : "ENSG00000214819.2",
      gene_type : "protein_coding",
      gene_name : "CDRT15L2",
      gene_level : 2,
      hgnc_id : "HGNC:34075",
      havana_gene : "OTTHUMG00000059557.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 20999596,
      stop : 21043760,
      direction : "-",
      ID : "ENSG00000124422.12",
      gene_id : "ENSG00000124422.12",
      gene_type : "protein_coding",
      gene_name : "USP22",
      gene_level : 1,
      hgnc_id : "HGNC:12621",
      havana_gene : "OTTHUMG00000133621.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 21123364,
      stop : 21193265,
      direction : "+",
      ID : "ENSG00000109016.17",
      gene_id : "ENSG00000109016.17",
      gene_type : "protein_coding",
      gene_name : "DHRS7B",
      gene_level : 1,
      hgnc_id : "HGNC:24547",
      havana_gene : "OTTHUMG00000178944.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 21197954,
      stop : 21214176,
      direction : "-",
      ID : "ENSG00000178307.10",
      gene_id : "ENSG00000178307.10",
      gene_type : "protein_coding",
      gene_name : "TMEM11",
      gene_level : 2,
      hgnc_id : "HGNC:16823",
      havana_gene : "OTTHUMG00000178971.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 21238870,
      stop : 21253410,
      direction : "-",
      ID : "ENSG00000274180.1",
      gene_id : "ENSG00000274180.1",
      gene_type : "protein_coding",
      gene_name : "NATD1",
      gene_level : 2,
      hgnc_id : "HGNC:30770",
      havana_gene : "OTTHUMG00000130764.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 21284672,
      stop : 21315232,
      direction : "+",
      ID : "ENSG00000034152.19",
      gene_id : "ENSG00000034152.19",
      gene_type : "protein_coding",
      gene_name : "MAP2K3",
      gene_level : 1,
      hgnc_id : "HGNC:6843",
      havana_gene : "OTTHUMG00000134322.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 21376357,
      stop : 21419870,
      direction : "+",
      ID : "ENSG00000184185.10",
      gene_id : "ENSG00000184185.10",
      gene_type : "protein_coding",
      gene_name : "KCNJ12",
      gene_level : 2,
      hgnc_id : "HGNC:6258",
      havana_gene : "OTTHUMG00000132039.4",
      tag : "retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 21692523,
      stop : 21704612,
      direction : "+",
      ID : "ENSG00000260458.3",
      gene_id : "ENSG00000260458.3",
      gene_type : "protein_coding",
      gene_name : "KCNJ18",
      gene_level : 2,
      hgnc_id : "HGNC:39080",
      havana_gene : "OTTHUMG00000175863.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 22523415,
      stop : 22524663,
      direction : "+",
      ID : "ENSG00000256618.3",
      gene_id : "ENSG00000256618.3",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L1",
      gene_level : 2,
      hgnc_id : "HGNC:37155",
      havana_gene : "OTTHUMG00000179068.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27294076,
      stop : 27315926,
      direction : "+",
      ID : "ENSG00000109046.15",
      gene_id : "ENSG00000109046.15",
      gene_type : "protein_coding",
      gene_name : "WSB1",
      gene_level : 1,
      hgnc_id : "HGNC:19221",
      havana_gene : "OTTHUMG00000132293.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27456470,
      stop : 27626438,
      direction : "+",
      ID : "ENSG00000141068.14",
      gene_id : "ENSG00000141068.14",
      gene_type : "protein_coding",
      gene_name : "KSR1",
      gene_level : 1,
      hgnc_id : "HGNC:6465",
      havana_gene : "OTTHUMG00000132051.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27623364,
      stop : 27640777,
      direction : "+",
      ID : "ENSG00000266728.5",
      gene_id : "ENSG00000266728.5",
      gene_type : "protein_coding",
      gene_name : "AC015688.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000132437.24",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27629798,
      stop : 27649560,
      direction : "+",
      ID : "ENSG00000168961.17",
      gene_id : "ENSG00000168961.17",
      gene_type : "protein_coding",
      gene_name : "LGALS9",
      gene_level : 1,
      hgnc_id : "HGNC:6570",
      havana_gene : "OTTHUMG00000179831.21",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27756766,
      stop : 27800529,
      direction : "-",
      ID : "ENSG00000007171.18",
      gene_id : "ENSG00000007171.18",
      gene_type : "protein_coding",
      gene_name : "NOS2",
      gene_level : 2,
      hgnc_id : "HGNC:7873",
      havana_gene : "OTTHUMG00000132445.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27798806,
      stop : 27893365,
      direction : "-",
      ID : "ENSG00000266202.1",
      gene_id : "ENSG00000266202.1",
      gene_type : "protein_coding",
      gene_name : "AC005697.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179275.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 27878314,
      stop : 27894752,
      direction : "-",
      ID : "ENSG00000232859.10",
      gene_id : "ENSG00000232859.10",
      gene_type : "protein_coding",
      gene_name : "LYRM9",
      gene_level : 1,
      hgnc_id : "HGNC:27314",
      havana_gene : "OTTHUMG00000132829.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28041737,
      stop : 28196381,
      direction : "+",
      ID : "ENSG00000087095.13",
      gene_id : "ENSG00000087095.13",
      gene_type : "protein_coding",
      gene_name : "NLK",
      gene_level : 2,
      hgnc_id : "HGNC:29858",
      havana_gene : "OTTHUMG00000132451.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28319200,
      stop : 28328685,
      direction : "+",
      ID : "ENSG00000109084.14",
      gene_id : "ENSG00000109084.14",
      gene_type : "protein_coding",
      gene_name : "TMEM97",
      gene_level : 1,
      hgnc_id : "HGNC:28106",
      havana_gene : "OTTHUMG00000132497.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28328325,
      stop : 28335489,
      direction : "-",
      ID : "ENSG00000109083.14",
      gene_id : "ENSG00000109083.14",
      gene_type : "protein_coding",
      gene_name : "IFT20",
      gene_level : 1,
      hgnc_id : "HGNC:30989",
      havana_gene : "OTTHUMG00000179412.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28335602,
      stop : 28347009,
      direction : "+",
      ID : "ENSG00000109079.10",
      gene_id : "ENSG00000109079.10",
      gene_type : "protein_coding",
      gene_name : "TNFAIP1",
      gene_level : 1,
      hgnc_id : "HGNC:11894",
      havana_gene : "OTTHUMG00000132501.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28346633,
      stop : 28357527,
      direction : "-",
      ID : "ENSG00000004142.12",
      gene_id : "ENSG00000004142.12",
      gene_type : "protein_coding",
      gene_name : "POLDIP2",
      gene_level : 2,
      hgnc_id : "HGNC:23781",
      havana_gene : "OTTHUMG00000132065.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28357642,
      stop : 28363683,
      direction : "+",
      ID : "ENSG00000244045.13",
      gene_id : "ENSG00000244045.13",
      gene_type : "protein_coding",
      gene_name : "TMEM199",
      gene_level : 1,
      hgnc_id : "HGNC:18085",
      havana_gene : "OTTHUMG00000132498.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28364268,
      stop : 28365244,
      direction : "-",
      ID : "ENSG00000274529.5",
      gene_id : "ENSG00000274529.5",
      gene_type : "protein_coding",
      gene_name : "SEBOX",
      gene_level : 2,
      hgnc_id : "HGNC:32942",
      havana_gene : "OTTHUMG00000171160.47",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28364288,
      stop : 28368012,
      direction : "-",
      ID : "ENSG00000273171.1",
      gene_id : "ENSG00000273171.1",
      gene_type : "protein_coding",
      gene_name : "AC002094.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171457.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28364356,
      stop : 28404049,
      direction : "+",
      ID : "ENSG00000004139.14",
      gene_id : "ENSG00000004139.14",
      gene_type : "protein_coding",
      gene_name : "SARM1",
      gene_level : 1,
      hgnc_id : "HGNC:17074",
      havana_gene : "OTTHUMG00000132499.47",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28367284,
      stop : 28373091,
      direction : "-",
      ID : "ENSG00000109072.14",
      gene_id : "ENSG00000109072.14",
      gene_type : "protein_coding",
      gene_name : "VTN",
      gene_level : 2,
      hgnc_id : "HGNC:12724",
      havana_gene : "OTTHUMG00000132500.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28394642,
      stop : 28407197,
      direction : "-",
      ID : "ENSG00000076351.13",
      gene_id : "ENSG00000076351.13",
      gene_type : "protein_coding",
      gene_name : "SLC46A1",
      gene_level : 1,
      hgnc_id : "HGNC:30521",
      havana_gene : "OTTHUMG00000179415.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28455752,
      stop : 28614185,
      direction : "-",
      ID : "ENSG00000258472.9",
      gene_id : "ENSG00000258472.9",
      gene_type : "protein_coding",
      gene_name : "AC005726.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171061.34",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28473293,
      stop : 28497781,
      direction : "+",
      ID : "ENSG00000007216.15",
      gene_id : "ENSG00000007216.15",
      gene_type : "protein_coding",
      gene_name : "SLC13A2",
      gene_level : 2,
      hgnc_id : "HGNC:10917",
      havana_gene : "OTTHUMG00000132523.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28506243,
      stop : 28538900,
      direction : "+",
      ID : "ENSG00000109101.8",
      gene_id : "ENSG00000109101.8",
      gene_type : "protein_coding",
      gene_name : "FOXN1",
      gene_level : 2,
      hgnc_id : "HGNC:12765",
      havana_gene : "OTTHUMG00000132603.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28546708,
      stop : 28552631,
      direction : "-",
      ID : "ENSG00000109103.12",
      gene_id : "ENSG00000109103.12",
      gene_type : "protein_coding",
      gene_name : "UNC119",
      gene_level : 2,
      hgnc_id : "HGNC:12565",
      havana_gene : "OTTHUMG00000132606.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28553383,
      stop : 28571794,
      direction : "-",
      ID : "ENSG00000087111.21",
      gene_id : "ENSG00000087111.21",
      gene_type : "protein_coding",
      gene_name : "PIGS",
      gene_level : 2,
      hgnc_id : "HGNC:14937",
      havana_gene : "OTTHUMG00000132604.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28573115,
      stop : 28576948,
      direction : "-",
      ID : "ENSG00000109107.14",
      gene_id : "ENSG00000109107.14",
      gene_type : "protein_coding",
      gene_name : "ALDOC",
      gene_level : 1,
      hgnc_id : "HGNC:418",
      havana_gene : "OTTHUMG00000132605.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28577565,
      stop : 28599025,
      direction : "-",
      ID : "ENSG00000076382.17",
      gene_id : "ENSG00000076382.17",
      gene_type : "protein_coding",
      gene_name : "SPAG5",
      gene_level : 2,
      hgnc_id : "HGNC:13452",
      havana_gene : "OTTHUMG00000166586.27",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28601827,
      stop : 28614197,
      direction : "-",
      ID : "ENSG00000167524.16",
      gene_id : "ENSG00000167524.16",
      gene_type : "protein_coding",
      gene_name : "RSKR",
      gene_level : 2,
      hgnc_id : "HGNC:26314",
      havana_gene : "OTTHUMG00000179342.34",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28614446,
      stop : 28645454,
      direction : "-",
      ID : "ENSG00000007202.15",
      gene_id : "ENSG00000007202.15",
      gene_type : "protein_coding",
      gene_name : "KIAA0100",
      gene_level : 1,
      hgnc_id : "HGNC:28960",
      havana_gene : "OTTHUMG00000166587.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28648346,
      stop : 28662189,
      direction : "-",
      ID : "ENSG00000132581.10",
      gene_id : "ENSG00000132581.10",
      gene_type : "protein_coding",
      gene_name : "SDF2",
      gene_level : 2,
      hgnc_id : "HGNC:10675",
      havana_gene : "OTTHUMG00000132681.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28662198,
      stop : 28702679,
      direction : "+",
      ID : "ENSG00000109111.15",
      gene_id : "ENSG00000109111.15",
      gene_type : "protein_coding",
      gene_name : "SUPT6H",
      gene_level : 2,
      hgnc_id : "HGNC:11470",
      havana_gene : "OTTHUMG00000179449.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28703197,
      stop : 28711854,
      direction : "-",
      ID : "ENSG00000167525.14",
      gene_id : "ENSG00000167525.14",
      gene_type : "protein_coding",
      gene_name : "PROCA1",
      gene_level : 2,
      hgnc_id : "HGNC:28600",
      havana_gene : "OTTHUMG00000132682.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28714281,
      stop : 28718429,
      direction : "-",
      ID : "ENSG00000109113.20",
      gene_id : "ENSG00000109113.20",
      gene_type : "protein_coding",
      gene_name : "RAB34",
      gene_level : 2,
      hgnc_id : "HGNC:16519",
      havana_gene : "OTTHUMG00000132680.15",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28719985,
      stop : 28724359,
      direction : "+",
      ID : "ENSG00000198242.14",
      gene_id : "ENSG00000198242.14",
      gene_type : "protein_coding",
      gene_name : "RPL23A",
      gene_level : 1,
      hgnc_id : "HGNC:10317",
      havana_gene : "OTTHUMG00000132684.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28724348,
      stop : 28727935,
      direction : "-",
      ID : "ENSG00000160606.11",
      gene_id : "ENSG00000160606.11",
      gene_type : "protein_coding",
      gene_name : "TLCD1",
      gene_level : 2,
      hgnc_id : "HGNC:25177",
      havana_gene : "OTTHUMG00000132683.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28725897,
      stop : 28743455,
      direction : "+",
      ID : "ENSG00000160602.14",
      gene_id : "ENSG00000160602.14",
      gene_type : "protein_coding",
      gene_name : "NEK8",
      gene_level : 1,
      hgnc_id : "HGNC:13387",
      havana_gene : "OTTHUMG00000179454.38",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28744005,
      stop : 28750956,
      direction : "+",
      ID : "ENSG00000076604.15",
      gene_id : "ENSG00000076604.15",
      gene_type : "protein_coding",
      gene_name : "TRAF4",
      gene_level : 1,
      hgnc_id : "HGNC:12034",
      havana_gene : "OTTHUMG00000132677.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28755978,
      stop : 28855232,
      direction : "-",
      ID : "ENSG00000173065.13",
      gene_id : "ENSG00000173065.13",
      gene_type : "protein_coding",
      gene_name : "FAM222B",
      gene_level : 2,
      hgnc_id : "HGNC:25563",
      havana_gene : "OTTHUMG00000179495.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28855010,
      stop : 28861061,
      direction : "+",
      ID : "ENSG00000132591.12",
      gene_id : "ENSG00000132591.12",
      gene_type : "protein_coding",
      gene_name : "ERAL1",
      gene_level : 1,
      hgnc_id : "HGNC:3424",
      havana_gene : "OTTHUMG00000132675.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28879335,
      stop : 28897733,
      direction : "-",
      ID : "ENSG00000132589.16",
      gene_id : "ENSG00000132589.16",
      gene_type : "protein_coding",
      gene_name : "FLOT2",
      gene_level : 2,
      hgnc_id : "HGNC:3758",
      havana_gene : "OTTHUMG00000132674.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28897781,
      stop : 28903079,
      direction : "-",
      ID : "ENSG00000167536.14",
      gene_id : "ENSG00000167536.14",
      gene_type : "protein_coding",
      gene_name : "DHRS13",
      gene_level : 2,
      hgnc_id : "HGNC:28326",
      havana_gene : "OTTHUMG00000132678.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28905250,
      stop : 28951771,
      direction : "-",
      ID : "ENSG00000109118.14",
      gene_id : "ENSG00000109118.14",
      gene_type : "protein_coding",
      gene_name : "PHF12",
      gene_level : 2,
      hgnc_id : "HGNC:20816",
      havana_gene : "OTTHUMG00000132676.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28950513,
      stop : 29057216,
      direction : "+",
      ID : "ENSG00000179761.12",
      gene_id : "ENSG00000179761.12",
      gene_type : "protein_coding",
      gene_name : "PIPOX",
      gene_level : 2,
      hgnc_id : "HGNC:17804",
      havana_gene : "OTTHUMG00000132679.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 28954901,
      stop : 29006440,
      direction : "-",
      ID : "ENSG00000063015.20",
      gene_id : "ENSG00000063015.20",
      gene_type : "protein_coding",
      gene_name : "SEZ6",
      gene_level : 1,
      hgnc_id : "HGNC:15955",
      havana_gene : "OTTHUMG00000168010.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29071122,
      stop : 29180398,
      direction : "-",
      ID : "ENSG00000196535.17",
      gene_id : "ENSG00000196535.17",
      gene_type : "protein_coding",
      gene_name : "MYO18A",
      gene_level : 1,
      hgnc_id : "HGNC:31104",
      havana_gene : "OTTHUMG00000166360.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29073521,
      stop : 29078857,
      direction : "-",
      ID : "ENSG00000221995.5",
      gene_id : "ENSG00000221995.5",
      gene_type : "protein_coding",
      gene_name : "TIAF1",
      gene_level : 2,
      hgnc_id : "HGNC:11803",
      havana_gene : "OTTHUMG00000163268.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29246859,
      stop : 29254494,
      direction : "+",
      ID : "ENSG00000108255.8",
      gene_id : "ENSG00000108255.8",
      gene_type : "protein_coding",
      gene_name : "CRYBA1",
      gene_level : 2,
      hgnc_id : "HGNC:2394",
      havana_gene : "OTTHUMG00000132729.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29255839,
      stop : 29294148,
      direction : "-",
      ID : "ENSG00000108256.9",
      gene_id : "ENSG00000108256.9",
      gene_type : "protein_coding",
      gene_name : "NUFIP2",
      gene_level : 2,
      hgnc_id : "HGNC:17634",
      havana_gene : "OTTHUMG00000179547.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29390363,
      stop : 29551903,
      direction : "+",
      ID : "ENSG00000160551.12",
      gene_id : "ENSG00000160551.12",
      gene_type : "protein_coding",
      gene_name : "TAOK1",
      gene_level : 2,
      hgnc_id : "HGNC:29259",
      havana_gene : "OTTHUMG00000179718.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29560547,
      stop : 29567037,
      direction : "-",
      ID : "ENSG00000168792.5",
      gene_id : "ENSG00000168792.5",
      gene_type : "protein_coding",
      gene_name : "ABHD15",
      gene_level : 2,
      hgnc_id : "HGNC:26971",
      havana_gene : "OTTHUMG00000179721.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29566052,
      stop : 29573157,
      direction : "+",
      ID : "ENSG00000167543.16",
      gene_id : "ENSG00000167543.16",
      gene_type : "protein_coding",
      gene_name : "TP53I13",
      gene_level : 1,
      hgnc_id : "HGNC:25102",
      havana_gene : "OTTHUMG00000179723.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29573475,
      stop : 29594054,
      direction : "-",
      ID : "ENSG00000108262.16",
      gene_id : "ENSG00000108262.16",
      gene_type : "protein_coding",
      gene_name : "GIT1",
      gene_level : 1,
      hgnc_id : "HGNC:4272",
      havana_gene : "OTTHUMG00000132730.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29589769,
      stop : 29614761,
      direction : "+",
      ID : "ENSG00000198720.13",
      gene_id : "ENSG00000198720.13",
      gene_type : "protein_coding",
      gene_name : "ANKRD13B",
      gene_level : 2,
      hgnc_id : "HGNC:26363",
      havana_gene : "OTTHUMG00000132731.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29614756,
      stop : 29622907,
      direction : "-",
      ID : "ENSG00000167549.18",
      gene_id : "ENSG00000167549.18",
      gene_type : "protein_coding",
      gene_name : "CORO6",
      gene_level : 1,
      hgnc_id : "HGNC:21356",
      havana_gene : "OTTHUMG00000132732.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29625938,
      stop : 29930276,
      direction : "-",
      ID : "ENSG00000141298.19",
      gene_id : "ENSG00000141298.19",
      gene_type : "protein_coding",
      gene_name : "SSH2",
      gene_level : 2,
      hgnc_id : "HGNC:30580",
      havana_gene : "OTTHUMG00000132752.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 29929200,
      stop : 30108452,
      direction : "+",
      ID : "ENSG00000176927.15",
      gene_id : "ENSG00000176927.15",
      gene_type : "protein_coding",
      gene_name : "EFCAB5",
      gene_level : 1,
      hgnc_id : "HGNC:24801",
      havana_gene : "OTTHUMG00000179743.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30115521,
      stop : 30186475,
      direction : "+",
      ID : "ENSG00000126653.18",
      gene_id : "ENSG00000126653.18",
      gene_type : "protein_coding",
      gene_name : "NSRP1",
      gene_level : 2,
      hgnc_id : "HGNC:25305",
      havana_gene : "OTTHUMG00000132754.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30194319,
      stop : 30236002,
      direction : "-",
      ID : "ENSG00000108576.10",
      gene_id : "ENSG00000108576.10",
      gene_type : "protein_coding",
      gene_name : "SLC6A4",
      gene_level : 2,
      hgnc_id : "HGNC:11050",
      havana_gene : "OTTHUMG00000132751.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30248203,
      stop : 30292056,
      direction : "-",
      ID : "ENSG00000108578.15",
      gene_id : "ENSG00000108578.15",
      gene_type : "protein_coding",
      gene_name : "BLMH",
      gene_level : 2,
      hgnc_id : "HGNC:1059",
      havana_gene : "OTTHUMG00000179756.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30316333,
      stop : 30334059,
      direction : "-",
      ID : "ENSG00000182271.13",
      gene_id : "ENSG00000182271.13",
      gene_type : "protein_coding",
      gene_name : "TMIGD1",
      gene_level : 2,
      hgnc_id : "HGNC:32431",
      havana_gene : "OTTHUMG00000179757.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30378927,
      stop : 30469989,
      direction : "+",
      ID : "ENSG00000108582.12",
      gene_id : "ENSG00000108582.12",
      gene_type : "protein_coding",
      gene_name : "CPD",
      gene_level : 2,
      hgnc_id : "HGNC:2301",
      havana_gene : "OTTHUMG00000132797.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30477362,
      stop : 30527592,
      direction : "+",
      ID : "ENSG00000108587.16",
      gene_id : "ENSG00000108587.16",
      gene_type : "protein_coding",
      gene_name : "GOSR1",
      gene_level : 2,
      hgnc_id : "HGNC:4430",
      havana_gene : "OTTHUMG00000132796.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30769388,
      stop : 30824692,
      direction : "-",
      ID : "ENSG00000176390.12",
      gene_id : "ENSG00000176390.12",
      gene_type : "protein_coding",
      gene_name : "CRLF3",
      gene_level : 1,
      hgnc_id : "HGNC:17177",
      havana_gene : "OTTHUMG00000179005.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30831966,
      stop : 30895869,
      direction : "+",
      ID : "ENSG00000176208.9",
      gene_id : "ENSG00000176208.9",
      gene_type : "protein_coding",
      gene_name : "ATAD5",
      gene_level : 2,
      hgnc_id : "HGNC:25752",
      havana_gene : "OTTHUMG00000132794.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30897336,
      stop : 30906238,
      direction : "-",
      ID : "ENSG00000172171.11",
      gene_id : "ENSG00000172171.11",
      gene_type : "protein_coding",
      gene_name : "TEFM",
      gene_level : 2,
      hgnc_id : "HGNC:26223",
      havana_gene : "OTTHUMG00000179029.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30906344,
      stop : 30959322,
      direction : "+",
      ID : "ENSG00000184060.11",
      gene_id : "ENSG00000184060.11",
      gene_type : "protein_coding",
      gene_name : "ADAP2",
      gene_level : 1,
      hgnc_id : "HGNC:16487",
      havana_gene : "OTTHUMG00000132868.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 30970984,
      stop : 30999911,
      direction : "+",
      ID : "ENSG00000181481.14",
      gene_id : "ENSG00000181481.14",
      gene_type : "protein_coding",
      gene_name : "RNF135",
      gene_level : 1,
      hgnc_id : "HGNC:21158",
      havana_gene : "OTTHUMG00000132867.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31094927,
      stop : 31382116,
      direction : "+",
      ID : "ENSG00000196712.18",
      gene_id : "ENSG00000196712.18",
      gene_type : "protein_coding",
      gene_name : "NF1",
      gene_level : 2,
      hgnc_id : "HGNC:7765",
      havana_gene : "OTTHUMG00000132871.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31272013,
      stop : 31297539,
      direction : "-",
      ID : "ENSG00000126861.5",
      gene_id : "ENSG00000126861.5",
      gene_type : "protein_coding",
      gene_name : "OMG",
      gene_level : 1,
      hgnc_id : "HGNC:8135",
      havana_gene : "OTTHUMG00000132870.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31303770,
      stop : 31314105,
      direction : "-",
      ID : "ENSG00000185862.7",
      gene_id : "ENSG00000185862.7",
      gene_type : "protein_coding",
      gene_name : "EVI2B",
      gene_level : 2,
      hgnc_id : "HGNC:3500",
      havana_gene : "OTTHUMG00000132869.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31305213,
      stop : 31318831,
      direction : "-",
      ID : "ENSG00000265118.5",
      gene_id : "ENSG00000265118.5",
      gene_type : "protein_coding",
      gene_name : "AC134669.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179278.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31316410,
      stop : 31321749,
      direction : "-",
      ID : "ENSG00000126860.12",
      gene_id : "ENSG00000126860.12",
      gene_type : "protein_coding",
      gene_name : "EVI2A",
      gene_level : 2,
      hgnc_id : "HGNC:3499",
      havana_gene : "OTTHUMG00000159306.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31391675,
      stop : 31538211,
      direction : "+",
      ID : "ENSG00000131242.18",
      gene_id : "ENSG00000131242.18",
      gene_type : "protein_coding",
      gene_name : "RAB11FIP4",
      gene_level : 1,
      hgnc_id : "HGNC:30267",
      havana_gene : "OTTHUMG00000132787.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31851871,
      stop : 31859291,
      direction : "-",
      ID : "ENSG00000172301.11",
      gene_id : "ENSG00000172301.11",
      gene_type : "protein_coding",
      gene_name : "COPRS",
      gene_level : 2,
      hgnc_id : "HGNC:28848",
      havana_gene : "OTTHUMG00000132812.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31860904,
      stop : 31901708,
      direction : "-",
      ID : "ENSG00000108651.10",
      gene_id : "ENSG00000108651.10",
      gene_type : "protein_coding",
      gene_name : "UTP6",
      gene_level : 1,
      hgnc_id : "HGNC:18279",
      havana_gene : "OTTHUMG00000132815.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 31937007,
      stop : 32001038,
      direction : "+",
      ID : "ENSG00000178691.11",
      gene_id : "ENSG00000178691.11",
      gene_type : "protein_coding",
      gene_name : "SUZ12",
      gene_level : 2,
      hgnc_id : "HGNC:17101",
      havana_gene : "OTTHUMG00000132813.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32007872,
      stop : 32053504,
      direction : "+",
      ID : "ENSG00000185158.12",
      gene_id : "ENSG00000185158.12",
      gene_type : "protein_coding",
      gene_name : "LRRC37B",
      gene_level : 1,
      hgnc_id : "HGNC:29070",
      havana_gene : "OTTHUMG00000132785.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32142454,
      stop : 32253374,
      direction : "+",
      ID : "ENSG00000126858.19",
      gene_id : "ENSG00000126858.19",
      gene_type : "protein_coding",
      gene_name : "RHOT1",
      gene_level : 2,
      hgnc_id : "HGNC:21168",
      havana_gene : "OTTHUMG00000179564.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32265832,
      stop : 32324659,
      direction : "+",
      ID : "ENSG00000141314.13",
      gene_id : "ENSG00000141314.13",
      gene_type : "protein_coding",
      gene_name : "RHBDL3",
      gene_level : 1,
      hgnc_id : "HGNC:16502",
      havana_gene : "OTTHUMG00000179568.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32324565,
      stop : 32350023,
      direction : "-",
      ID : "ENSG00000108666.10",
      gene_id : "ENSG00000108666.10",
      gene_type : "protein_coding",
      gene_name : "C17orf75",
      gene_level : 1,
      hgnc_id : "HGNC:30173",
      havana_gene : "OTTHUMG00000179585.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32350132,
      stop : 32381885,
      direction : "+",
      ID : "ENSG00000010244.19",
      gene_id : "ENSG00000010244.19",
      gene_type : "protein_coding",
      gene_name : "ZNF207",
      gene_level : 1,
      hgnc_id : "HGNC:12998",
      havana_gene : "OTTHUMG00000132810.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32444379,
      stop : 32483319,
      direction : "+",
      ID : "ENSG00000108671.11",
      gene_id : "ENSG00000108671.11",
      gene_type : "protein_coding",
      gene_name : "PSMD11",
      gene_level : 1,
      hgnc_id : "HGNC:9556",
      havana_gene : "OTTHUMG00000132811.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32486993,
      stop : 32491253,
      direction : "+",
      ID : "ENSG00000176749.9",
      gene_id : "ENSG00000176749.9",
      gene_type : "protein_coding",
      gene_name : "CDK5R1",
      gene_level : 2,
      hgnc_id : "HGNC:1775",
      havana_gene : "OTTHUMG00000132814.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32492522,
      stop : 32877177,
      direction : "-",
      ID : "ENSG00000176658.17",
      gene_id : "ENSG00000176658.17",
      gene_type : "protein_coding",
      gene_name : "MYO1D",
      gene_level : 1,
      hgnc_id : "HGNC:7598",
      havana_gene : "OTTHUMG00000179636.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32927910,
      stop : 32945106,
      direction : "+",
      ID : "ENSG00000006042.12",
      gene_id : "ENSG00000006042.12",
      gene_type : "protein_coding",
      gene_name : "TMEM98",
      gene_level : 2,
      hgnc_id : "HGNC:24529",
      havana_gene : "OTTHUMG00000132882.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 32970376,
      stop : 32997877,
      direction : "+",
      ID : "ENSG00000141316.13",
      gene_id : "ENSG00000141316.13",
      gene_type : "protein_coding",
      gene_name : "SPACA3",
      gene_level : 1,
      hgnc_id : "HGNC:16260",
      havana_gene : "OTTHUMG00000132886.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 33013087,
      stop : 34174964,
      direction : "-",
      ID : "ENSG00000108684.15",
      gene_id : "ENSG00000108684.15",
      gene_type : "protein_coding",
      gene_name : "ASIC2",
      gene_level : 2,
      hgnc_id : "HGNC:99",
      havana_gene : "OTTHUMG00000132885.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34255218,
      stop : 34257203,
      direction : "+",
      ID : "ENSG00000108691.9",
      gene_id : "ENSG00000108691.9",
      gene_type : "protein_coding",
      gene_name : "CCL2",
      gene_level : 2,
      hgnc_id : "HGNC:10618",
      havana_gene : "OTTHUMG00000132887.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34270221,
      stop : 34272242,
      direction : "+",
      ID : "ENSG00000108688.11",
      gene_id : "ENSG00000108688.11",
      gene_type : "protein_coding",
      gene_name : "CCL7",
      gene_level : 2,
      hgnc_id : "HGNC:10634",
      havana_gene : "OTTHUMG00000132889.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34285742,
      stop : 34288334,
      direction : "+",
      ID : "ENSG00000172156.4",
      gene_id : "ENSG00000172156.4",
      gene_type : "protein_coding",
      gene_name : "CCL11",
      gene_level : 2,
      hgnc_id : "HGNC:10610",
      havana_gene : "OTTHUMG00000132884.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34319435,
      stop : 34321402,
      direction : "+",
      ID : "ENSG00000108700.5",
      gene_id : "ENSG00000108700.5",
      gene_type : "protein_coding",
      gene_name : "CCL8",
      gene_level : 2,
      hgnc_id : "HGNC:10635",
      havana_gene : "OTTHUMG00000132883.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34356480,
      stop : 34358610,
      direction : "+",
      ID : "ENSG00000181374.8",
      gene_id : "ENSG00000181374.8",
      gene_type : "protein_coding",
      gene_name : "CCL13",
      gene_level : 1,
      hgnc_id : "HGNC:10611",
      havana_gene : "OTTHUMG00000132890.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34360328,
      stop : 34363233,
      direction : "-",
      ID : "ENSG00000108702.4",
      gene_id : "ENSG00000108702.4",
      gene_type : "protein_coding",
      gene_name : "CCL1",
      gene_level : 2,
      hgnc_id : "HGNC:10609",
      havana_gene : "OTTHUMG00000132888.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34579487,
      stop : 34639318,
      direction : "+",
      ID : "ENSG00000181291.8",
      gene_id : "ENSG00000181291.8",
      gene_type : "protein_coding",
      gene_name : "TMEM132E",
      gene_level : 2,
      hgnc_id : "HGNC:26991",
      havana_gene : "OTTHUMG00000132927.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34927859,
      stop : 34981078,
      direction : "-",
      ID : "ENSG00000132141.14",
      gene_id : "ENSG00000132141.14",
      gene_type : "protein_coding",
      gene_name : "CCT6B",
      gene_level : 2,
      hgnc_id : "HGNC:1621",
      havana_gene : "OTTHUMG00000179770.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34961540,
      stop : 34963777,
      direction : "+",
      ID : "ENSG00000198783.6",
      gene_id : "ENSG00000198783.6",
      gene_type : "protein_coding",
      gene_name : "ZNF830",
      gene_level : 2,
      hgnc_id : "HGNC:28291",
      havana_gene : "OTTHUMG00000179771.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 34980512,
      stop : 35009743,
      direction : "+",
      ID : "ENSG00000005156.12",
      gene_id : "ENSG00000005156.12",
      gene_type : "protein_coding",
      gene_name : "LIG3",
      gene_level : 1,
      hgnc_id : "HGNC:6600",
      havana_gene : "OTTHUMG00000128519.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35005990,
      stop : 35089319,
      direction : "-",
      ID : "ENSG00000092871.17",
      gene_id : "ENSG00000092871.17",
      gene_type : "protein_coding",
      gene_name : "RFFL",
      gene_level : 1,
      hgnc_id : "HGNC:24821",
      havana_gene : "OTTHUMG00000132933.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35011349,
      stop : 35121493,
      direction : "-",
      ID : "ENSG00000267618.5",
      gene_id : "ENSG00000267618.5",
      gene_type : "protein_coding",
      gene_name : "AC004223.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000179827.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35092221,
      stop : 35121522,
      direction : "-",
      ID : "ENSG00000185379.21",
      gene_id : "ENSG00000185379.21",
      gene_type : "protein_coding",
      gene_name : "RAD51D",
      gene_level : 2,
      hgnc_id : "HGNC:9823",
      havana_gene : "OTTHUMG00000132930.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35121615,
      stop : 35130732,
      direction : "+",
      ID : "ENSG00000073598.6",
      gene_id : "ENSG00000073598.6",
      gene_type : "protein_coding",
      gene_name : "FNDC8",
      gene_level : 2,
      hgnc_id : "HGNC:25286",
      havana_gene : "OTTHUMG00000132932.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35128730,
      stop : 35142304,
      direction : "-",
      ID : "ENSG00000073536.18",
      gene_id : "ENSG00000073536.18",
      gene_type : "protein_coding",
      gene_name : "NLE1",
      gene_level : 2,
      hgnc_id : "HGNC:19889",
      havana_gene : "OTTHUMG00000132928.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35147817,
      stop : 35189345,
      direction : "+",
      ID : "ENSG00000141161.12",
      gene_id : "ENSG00000141161.12",
      gene_type : "protein_coding",
      gene_name : "UNC45B",
      gene_level : 2,
      hgnc_id : "HGNC:14304",
      havana_gene : "OTTHUMG00000132931.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35192520,
      stop : 35194523,
      direction : "-",
      ID : "ENSG00000164729.7",
      gene_id : "ENSG00000164729.7",
      gene_type : "protein_coding",
      gene_name : "SLC35G3",
      gene_level : 2,
      hgnc_id : "HGNC:26848",
      havana_gene : "OTTHUMG00000132929.2",
      tag : "retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35243071,
      stop : 35273655,
      direction : "+",
      ID : "ENSG00000166750.10",
      gene_id : "ENSG00000166750.10",
      gene_type : "protein_coding",
      gene_name : "SLFN5",
      gene_level : 1,
      hgnc_id : "HGNC:28286",
      havana_gene : "OTTHUMG00000179858.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35350305,
      stop : 35373701,
      direction : "-",
      ID : "ENSG00000172716.16",
      gene_id : "ENSG00000172716.16",
      gene_type : "protein_coding",
      gene_name : "SLFN11",
      gene_level : 2,
      hgnc_id : "HGNC:26633",
      havana_gene : "OTTHUMG00000132948.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35410922,
      stop : 35433283,
      direction : "-",
      ID : "ENSG00000172123.13",
      gene_id : "ENSG00000172123.13",
      gene_type : "protein_coding",
      gene_name : "SLFN12",
      gene_level : 1,
      hgnc_id : "HGNC:25500",
      havana_gene : "OTTHUMG00000132952.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35435096,
      stop : 35448837,
      direction : "-",
      ID : "ENSG00000154760.14",
      gene_id : "ENSG00000154760.14",
      gene_type : "protein_coding",
      gene_name : "SLFN13",
      gene_level : 2,
      hgnc_id : "HGNC:26481",
      havana_gene : "OTTHUMG00000165108.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35464249,
      stop : 35487857,
      direction : "-",
      ID : "ENSG00000205045.11",
      gene_id : "ENSG00000205045.11",
      gene_type : "protein_coding",
      gene_name : "SLFN12L",
      gene_level : 2,
      hgnc_id : "HGNC:33920",
      havana_gene : "OTTHUMG00000193506.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35543985,
      stop : 35560819,
      direction : "-",
      ID : "ENSG00000236320.4",
      gene_id : "ENSG00000236320.4",
      gene_type : "protein_coding",
      gene_name : "SLFN14",
      gene_level : 2,
      hgnc_id : "HGNC:32689",
      havana_gene : "OTTHUMG00000179912.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35574795,
      stop : 35578863,
      direction : "-",
      ID : "ENSG00000108733.11",
      gene_id : "ENSG00000108733.11",
      gene_type : "protein_coding",
      gene_name : "PEX12",
      gene_level : 2,
      hgnc_id : "HGNC:8854",
      havana_gene : "OTTHUMG00000132951.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35578046,
      stop : 35726413,
      direction : "+",
      ID : "ENSG00000006125.18",
      gene_id : "ENSG00000006125.18",
      gene_type : "protein_coding",
      gene_name : "AP2B1",
      gene_level : 1,
      hgnc_id : "HGNC:563",
      havana_gene : "OTTHUMG00000179924.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35713791,
      stop : 35864615,
      direction : "+",
      ID : "ENSG00000270647.6",
      gene_id : "ENSG00000270647.6",
      gene_type : "protein_coding",
      gene_name : "TAF15",
      gene_level : 2,
      hgnc_id : "HGNC:11547",
      havana_gene : "OTTHUMG00000188384.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35731639,
      stop : 35743521,
      direction : "+",
      ID : "ENSG00000270885.2",
      gene_id : "ENSG00000270885.2",
      gene_type : "protein_coding",
      gene_name : "RASL10B",
      gene_level : 2,
      hgnc_id : "HGNC:30295",
      havana_gene : "OTTHUMG00000188385.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35744511,
      stop : 35753239,
      direction : "-",
      ID : "ENSG00000270765.6",
      gene_id : "ENSG00000270765.6",
      gene_type : "protein_coding",
      gene_name : "GAS2L2",
      gene_level : 2,
      hgnc_id : "HGNC:24846",
      havana_gene : "OTTHUMG00000188386.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35756249,
      stop : 35795707,
      direction : "-",
      ID : "ENSG00000271447.6",
      gene_id : "ENSG00000271447.6",
      gene_type : "protein_coding",
      gene_name : "MMP28",
      gene_level : 2,
      hgnc_id : "HGNC:14366",
      havana_gene : "OTTHUMG00000188387.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35760887,
      stop : 35765079,
      direction : "+",
      ID : "ENSG00000270806.2",
      gene_id : "ENSG00000270806.2",
      gene_type : "protein_coding",
      gene_name : "C17orf50",
      gene_level : 2,
      hgnc_id : "HGNC:29581",
      havana_gene : "OTTHUMG00000188389.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35854946,
      stop : 35868891,
      direction : "-",
      ID : "ENSG00000270379.6",
      gene_id : "ENSG00000270379.6",
      gene_type : "protein_coding",
      gene_name : "HEATR9",
      gene_level : 2,
      hgnc_id : "HGNC:26548",
      havana_gene : "OTTHUMG00000188393.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35871491,
      stop : 35880793,
      direction : "-",
      ID : "ENSG00000271503.6",
      gene_id : "ENSG00000271503.6",
      gene_type : "protein_coding",
      gene_name : "CCL5",
      gene_level : 2,
      hgnc_id : "HGNC:10632",
      havana_gene : "OTTHUMG00000188396.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35918066,
      stop : 35930773,
      direction : "-",
      ID : "ENSG00000278023.7",
      gene_id : "ENSG00000278023.7",
      gene_type : "protein_coding",
      gene_name : "RDM1",
      gene_level : 2,
      hgnc_id : "HGNC:19950",
      havana_gene : "OTTHUMG00000188399.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35934518,
      stop : 35943713,
      direction : "-",
      ID : "ENSG00000275722.5",
      gene_id : "ENSG00000275722.5",
      gene_type : "protein_coding",
      gene_name : "LYZL6",
      gene_level : 2,
      hgnc_id : "HGNC:29614",
      havana_gene : "OTTHUMG00000188400.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35976493,
      stop : 35981497,
      direction : "-",
      ID : "ENSG00000275152.5",
      gene_id : "ENSG00000275152.5",
      gene_type : "protein_coding",
      gene_name : "CCL16",
      gene_level : 2,
      hgnc_id : "HGNC:10614",
      havana_gene : "OTTHUMG00000188402.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35983288,
      stop : 35987004,
      direction : "-",
      ID : "ENSG00000276409.5",
      gene_id : "ENSG00000276409.5",
      gene_type : "protein_coding",
      gene_name : "CCL14",
      gene_level : 2,
      hgnc_id : "HGNC:10612",
      havana_gene : "OTTHUMG00000188403.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35983656,
      stop : 36001621,
      direction : "-",
      ID : "ENSG00000275688.4",
      gene_id : "ENSG00000275688.4",
      gene_type : "protein_coding",
      gene_name : "CCL15-CCL14",
      gene_level : 2,
      hgnc_id : "HGNC:44436",
      havana_gene : "OTTHUMG00000188405.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 35996440,
      stop : 36001553,
      direction : "-",
      ID : "ENSG00000275718.2",
      gene_id : "ENSG00000275718.2",
      gene_type : "protein_coding",
      gene_name : "CCL15",
      gene_level : 2,
      hgnc_id : "HGNC:10613",
      havana_gene : "OTTHUMG00000188406.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36013056,
      stop : 36017972,
      direction : "-",
      ID : "ENSG00000274736.5",
      gene_id : "ENSG00000274736.5",
      gene_type : "protein_coding",
      gene_name : "CCL23",
      gene_level : 2,
      hgnc_id : "HGNC:10622",
      havana_gene : "OTTHUMG00000188409.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36064272,
      stop : 36072032,
      direction : "+",
      ID : "ENSG00000275385.2",
      gene_id : "ENSG00000275385.2",
      gene_type : "protein_coding",
      gene_name : "CCL18",
      gene_level : 2,
      hgnc_id : "HGNC:10616",
      havana_gene : "OTTHUMG00000188410.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36088256,
      stop : 36090169,
      direction : "-",
      ID : "ENSG00000277632.2",
      gene_id : "ENSG00000277632.2",
      gene_type : "protein_coding",
      gene_name : "CCL3",
      gene_level : 2,
      hgnc_id : "HGNC:10627",
      havana_gene : "OTTHUMG00000188413.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36103827,
      stop : 36105621,
      direction : "+",
      ID : "ENSG00000275302.2",
      gene_id : "ENSG00000275302.2",
      gene_type : "protein_coding",
      gene_name : "CCL4",
      gene_level : 2,
      hgnc_id : "HGNC:10630",
      havana_gene : "OTTHUMG00000188414.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36165681,
      stop : 36176636,
      direction : "-",
      ID : "ENSG00000274808.5",
      gene_id : "ENSG00000274808.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3B",
      gene_level : 2,
      hgnc_id : "HGNC:27011",
      havana_gene : "OTTHUMG00000188417.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36194869,
      stop : 36196758,
      direction : "-",
      ID : "ENSG00000276085.1",
      gene_id : "ENSG00000276085.1",
      gene_type : "protein_coding",
      gene_name : "CCL3L3",
      gene_level : 2,
      hgnc_id : "HGNC:30554",
      havana_gene : "OTTHUMG00000188419.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36210924,
      stop : 36212878,
      direction : "+",
      ID : "ENSG00000276070.5",
      gene_id : "ENSG00000276070.5",
      gene_type : "protein_coding",
      gene_name : "CCL4L2",
      gene_level : 2,
      hgnc_id : "HGNC:24066",
      havana_gene : "OTTHUMG00000188420.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36253456,
      stop : 36264553,
      direction : "-",
      ID : "ENSG00000274933.5",
      gene_id : "ENSG00000274933.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3I",
      gene_level : 2,
      hgnc_id : "HGNC:32709",
      havana_gene : "OTTHUMG00000188424.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36323884,
      stop : 36334759,
      direction : "+",
      ID : "ENSG00000260287.4",
      gene_id : "ENSG00000260287.4",
      gene_type : "protein_coding",
      gene_name : "TBC1D3G",
      gene_level : 2,
      hgnc_id : "HGNC:29860",
      havana_gene : "OTTHUMG00000188426.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36377531,
      stop : 36388423,
      direction : "-",
      ID : "ENSG00000274226.5",
      gene_id : "ENSG00000274226.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3H",
      gene_level : 2,
      hgnc_id : "HGNC:30708",
      havana_gene : "OTTHUMG00000188427.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36428618,
      stop : 36439566,
      direction : "-",
      ID : "ENSG00000275954.5",
      gene_id : "ENSG00000275954.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3F",
      gene_level : 2,
      hgnc_id : "HGNC:18257",
      havana_gene : "OTTHUMG00000188428.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36486629,
      stop : 36499310,
      direction : "+",
      ID : "ENSG00000273611.5",
      gene_id : "ENSG00000273611.5",
      gene_type : "protein_coding",
      gene_name : "ZNHIT3",
      gene_level : 2,
      hgnc_id : "HGNC:12309",
      havana_gene : "OTTHUMG00000188436.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36495636,
      stop : 36543435,
      direction : "-",
      ID : "ENSG00000278259.5",
      gene_id : "ENSG00000278259.5",
      gene_type : "protein_coding",
      gene_name : "MYO19",
      gene_level : 2,
      hgnc_id : "HGNC:26234",
      havana_gene : "OTTHUMG00000188437.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36534987,
      stop : 36539310,
      direction : "+",
      ID : "ENSG00000277161.2",
      gene_id : "ENSG00000277161.2",
      gene_type : "protein_coding",
      gene_name : "PIGW",
      gene_level : 2,
      hgnc_id : "HGNC:23213",
      havana_gene : "OTTHUMG00000188438.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36544912,
      stop : 36589848,
      direction : "+",
      ID : "ENSG00000278311.5",
      gene_id : "ENSG00000278311.5",
      gene_type : "protein_coding",
      gene_name : "GGNBP2",
      gene_level : 2,
      hgnc_id : "HGNC:19357",
      havana_gene : "OTTHUMG00000193344.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36591879,
      stop : 36600804,
      direction : "+",
      ID : "ENSG00000278535.5",
      gene_id : "ENSG00000278535.5",
      gene_type : "protein_coding",
      gene_name : "DHRS11",
      gene_level : 2,
      hgnc_id : "HGNC:28639",
      havana_gene : "OTTHUMG00000188442.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36601583,
      stop : 36608964,
      direction : "+",
      ID : "ENSG00000278619.5",
      gene_id : "ENSG00000278619.5",
      gene_type : "protein_coding",
      gene_name : "MRM1",
      gene_level : 2,
      hgnc_id : "HGNC:26202",
      havana_gene : "OTTHUMG00000188443.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36936785,
      stop : 36944612,
      direction : "+",
      ID : "ENSG00000273706.5",
      gene_id : "ENSG00000273706.5",
      gene_type : "protein_coding",
      gene_name : "LHX1",
      gene_level : 2,
      hgnc_id : "HGNC:6593",
      havana_gene : "OTTHUMG00000188456.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 36948925,
      stop : 37056871,
      direction : "+",
      ID : "ENSG00000275700.6",
      gene_id : "ENSG00000275700.6",
      gene_type : "protein_coding",
      gene_name : "AATF",
      gene_level : 2,
      hgnc_id : "HGNC:19235",
      havana_gene : "OTTHUMG00000188458.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37084992,
      stop : 37406836,
      direction : "-",
      ID : "ENSG00000278540.5",
      gene_id : "ENSG00000278540.5",
      gene_type : "protein_coding",
      gene_name : "ACACA",
      gene_level : 2,
      hgnc_id : "HGNC:84",
      havana_gene : "OTTHUMG00000188463.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37375985,
      stop : 37392708,
      direction : "+",
      ID : "ENSG00000278505.5",
      gene_id : "ENSG00000278505.5",
      gene_type : "protein_coding",
      gene_name : "C17orf78",
      gene_level : 2,
      hgnc_id : "HGNC:26831",
      havana_gene : "OTTHUMG00000188467.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37406886,
      stop : 37479725,
      direction : "+",
      ID : "ENSG00000276234.5",
      gene_id : "ENSG00000276234.5",
      gene_type : "protein_coding",
      gene_name : "TADA2A",
      gene_level : 2,
      hgnc_id : "HGNC:11531",
      havana_gene : "OTTHUMG00000188469.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37489891,
      stop : 37513501,
      direction : "+",
      ID : "ENSG00000276023.5",
      gene_id : "ENSG00000276023.5",
      gene_type : "protein_coding",
      gene_name : "DUSP14",
      gene_level : 2,
      hgnc_id : "HGNC:17007",
      havana_gene : "OTTHUMG00000188472.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37514807,
      stop : 37609472,
      direction : "-",
      ID : "ENSG00000275066.5",
      gene_id : "ENSG00000275066.5",
      gene_type : "protein_coding",
      gene_name : "SYNRG",
      gene_level : 2,
      hgnc_id : "HGNC:557",
      havana_gene : "OTTHUMG00000188473.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37609739,
      stop : 37643446,
      direction : "-",
      ID : "ENSG00000278053.5",
      gene_id : "ENSG00000278053.5",
      gene_type : "protein_coding",
      gene_name : "DDX52",
      gene_level : 2,
      hgnc_id : "HGNC:20038",
      havana_gene : "OTTHUMG00000188475.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37686431,
      stop : 37745105,
      direction : "-",
      ID : "ENSG00000275410.5",
      gene_id : "ENSG00000275410.5",
      gene_type : "protein_coding",
      gene_name : "HNF1B",
      gene_level : 2,
      hgnc_id : "HGNC:11630",
      havana_gene : "OTTHUMG00000188478.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37924415,
      stop : 37935365,
      direction : "+",
      ID : "ENSG00000273513.1",
      gene_id : "ENSG00000273513.1",
      gene_type : "protein_coding",
      gene_name : "TBC1D3K",
      gene_level : 2,
      hgnc_id : "HGNC:51245",
      havana_gene : "OTTHUMG00000188481.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 37977972,
      stop : 37989048,
      direction : "-",
      ID : "ENSG00000274512.5",
      gene_id : "ENSG00000274512.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3L",
      gene_level : 2,
      hgnc_id : "HGNC:51246",
      havana_gene : "OTTHUMG00000188482.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38003976,
      stop : 38014902,
      direction : "+",
      ID : "ENSG00000274419.6",
      gene_id : "ENSG00000274419.6",
      gene_type : "protein_coding",
      gene_name : "TBC1D3D",
      gene_level : 2,
      hgnc_id : "HGNC:28944",
      havana_gene : "OTTHUMG00000188483.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38057693,
      stop : 38068592,
      direction : "-",
      ID : "ENSG00000278299.5",
      gene_id : "ENSG00000278299.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3C",
      gene_level : 2,
      hgnc_id : "HGNC:24889",
      havana_gene : "OTTHUMG00000188484.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38127951,
      stop : 38138862,
      direction : "+",
      ID : "ENSG00000278599.5",
      gene_id : "ENSG00000278599.5",
      gene_type : "protein_coding",
      gene_name : "TBC1D3E",
      gene_level : 2,
      hgnc_id : "HGNC:27071",
      havana_gene : "OTTHUMG00000188486.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38181659,
      stop : 38192541,
      direction : "-",
      ID : "ENSG00000274611.3",
      gene_id : "ENSG00000274611.3",
      gene_type : "protein_coding",
      gene_name : "TBC1D3",
      gene_level : 2,
      hgnc_id : "HGNC:19031",
      havana_gene : "OTTHUMG00000188487.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38297023,
      stop : 38323217,
      direction : "+",
      ID : "ENSG00000278845.5",
      gene_id : "ENSG00000278845.5",
      gene_type : "protein_coding",
      gene_name : "MRPL45",
      gene_level : 2,
      hgnc_id : "HGNC:16651",
      havana_gene : "OTTHUMG00000188489.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38324571,
      stop : 38343956,
      direction : "-",
      ID : "ENSG00000277399.5",
      gene_id : "ENSG00000277399.5",
      gene_type : "protein_coding",
      gene_name : "GPR179",
      gene_level : 2,
      hgnc_id : "HGNC:31371",
      havana_gene : "OTTHUMG00000188545.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38351844,
      stop : 38405593,
      direction : "+",
      ID : "ENSG00000274211.6",
      gene_id : "ENSG00000274211.6",
      gene_type : "protein_coding",
      gene_name : "SOCS7",
      gene_level : 2,
      hgnc_id : "HGNC:29846",
      havana_gene : "OTTHUMG00000188546.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38419280,
      stop : 38512385,
      direction : "+",
      ID : "ENSG00000275832.5",
      gene_id : "ENSG00000275832.5",
      gene_type : "protein_coding",
      gene_name : "ARHGAP23",
      gene_level : 2,
      hgnc_id : "HGNC:29293",
      havana_gene : "OTTHUMG00000188547.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38530031,
      stop : 38605952,
      direction : "-",
      ID : "ENSG00000277363.5",
      gene_id : "ENSG00000277363.5",
      gene_type : "protein_coding",
      gene_name : "SRCIN1",
      gene_level : 2,
      hgnc_id : "HGNC:29506",
      havana_gene : "OTTHUMG00000188493.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38671703,
      stop : 38674957,
      direction : "-",
      ID : "ENSG00000273604.2",
      gene_id : "ENSG00000273604.2",
      gene_type : "protein_coding",
      gene_name : "EPOP",
      gene_level : 2,
      hgnc_id : "HGNC:34493",
      havana_gene : "OTTHUMG00000188495.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38705273,
      stop : 38729795,
      direction : "+",
      ID : "ENSG00000275023.5",
      gene_id : "ENSG00000275023.5",
      gene_type : "protein_coding",
      gene_name : "MLLT6",
      gene_level : 2,
      hgnc_id : "HGNC:7138",
      havana_gene : "OTTHUMG00000188498.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38730341,
      stop : 38735605,
      direction : "+",
      ID : "ENSG00000277972.2",
      gene_id : "ENSG00000277972.2",
      gene_type : "protein_coding",
      gene_name : "CISD3",
      gene_level : 2,
      hgnc_id : "HGNC:27578",
      havana_gene : "OTTHUMG00000188500.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38733898,
      stop : 38749817,
      direction : "-",
      ID : "ENSG00000277258.5",
      gene_id : "ENSG00000277258.5",
      gene_type : "protein_coding",
      gene_name : "PCGF2",
      gene_level : 2,
      hgnc_id : "HGNC:12929",
      havana_gene : "OTTHUMG00000188501.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38752741,
      stop : 38764225,
      direction : "+",
      ID : "ENSG00000277791.5",
      gene_id : "ENSG00000277791.5",
      gene_type : "protein_coding",
      gene_name : "PSMB3",
      gene_level : 2,
      hgnc_id : "HGNC:9540",
      havana_gene : "OTTHUMG00000188503.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38765691,
      stop : 38800126,
      direction : "-",
      ID : "ENSG00000276293.5",
      gene_id : "ENSG00000276293.5",
      gene_type : "protein_coding",
      gene_name : "PIP4K2B",
      gene_level : 2,
      hgnc_id : "HGNC:8998",
      havana_gene : "OTTHUMG00000188504.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38800441,
      stop : 38825355,
      direction : "-",
      ID : "ENSG00000273559.5",
      gene_id : "ENSG00000273559.5",
      gene_type : "protein_coding",
      gene_name : "CWC25",
      gene_level : 2,
      hgnc_id : "HGNC:25989",
      havana_gene : "OTTHUMG00000188505.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38835086,
      stop : 38841438,
      direction : "-",
      ID : "ENSG00000275489.2",
      gene_id : "ENSG00000275489.2",
      gene_type : "protein_coding",
      gene_name : "C17orf98",
      gene_level : 2,
      hgnc_id : "HGNC:34492",
      havana_gene : "OTTHUMG00000188506.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38847860,
      stop : 38853764,
      direction : "-",
      ID : "ENSG00000125691.14",
      gene_id : "ENSG00000125691.14",
      gene_type : "protein_coding",
      gene_name : "RPL23",
      gene_level : 2,
      hgnc_id : "HGNC:10316",
      havana_gene : "OTTHUMG00000133118.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38869859,
      stop : 38921770,
      direction : "+",
      ID : "ENSG00000002834.18",
      gene_id : "ENSG00000002834.18",
      gene_type : "protein_coding",
      gene_name : "LASP1",
      gene_level : 1,
      hgnc_id : "HGNC:6513",
      havana_gene : "OTTHUMG00000133182.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38925168,
      stop : 38929384,
      direction : "+",
      ID : "ENSG00000263874.2",
      gene_id : "ENSG00000263874.2",
      gene_type : "protein_coding",
      gene_name : "LINC00672",
      gene_level : 2,
      hgnc_id : "HGNC:44353",
      havana_gene : "OTTHUMG00000178440.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 38936432,
      stop : 38967403,
      direction : "-",
      ID : "ENSG00000204952.3",
      gene_id : "ENSG00000204952.3",
      gene_type : "protein_coding",
      gene_name : "FBXO47",
      gene_level : 2,
      hgnc_id : "HGNC:31969",
      havana_gene : "OTTHUMG00000178945.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39063313,
      stop : 39154394,
      direction : "-",
      ID : "ENSG00000161381.14",
      gene_id : "ENSG00000161381.14",
      gene_type : "protein_coding",
      gene_name : "PLXDC1",
      gene_level : 1,
      hgnc_id : "HGNC:20945",
      havana_gene : "OTTHUMG00000133183.15",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39156894,
      stop : 39167484,
      direction : "-",
      ID : "ENSG00000141748.13",
      gene_id : "ENSG00000141748.13",
      gene_type : "protein_coding",
      gene_name : "ARL5C",
      gene_level : 2,
      hgnc_id : "HGNC:31111",
      havana_gene : "OTTHUMG00000179048.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39173453,
      stop : 39197703,
      direction : "-",
      ID : "ENSG00000067191.16",
      gene_id : "ENSG00000067191.16",
      gene_type : "protein_coding",
      gene_name : "CACNB1",
      gene_level : 2,
      hgnc_id : "HGNC:1401",
      havana_gene : "OTTHUMG00000133217.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39200283,
      stop : 39204840,
      direction : "+",
      ID : "ENSG00000108298.12",
      gene_id : "ENSG00000108298.12",
      gene_type : "protein_coding",
      gene_name : "RPL19",
      gene_level : 1,
      hgnc_id : "HGNC:10312",
      havana_gene : "OTTHUMG00000178979.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39210541,
      stop : 39225945,
      direction : "-",
      ID : "ENSG00000141750.7",
      gene_id : "ENSG00000141750.7",
      gene_type : "protein_coding",
      gene_name : "STAC2",
      gene_level : 2,
      hgnc_id : "HGNC:23990",
      havana_gene : "OTTHUMG00000179039.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39252663,
      stop : 39402523,
      direction : "-",
      ID : "ENSG00000108306.13",
      gene_id : "ENSG00000108306.13",
      gene_type : "protein_coding",
      gene_name : "FBXL20",
      gene_level : 2,
      hgnc_id : "HGNC:24679",
      havana_gene : "OTTHUMG00000179002.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39404285,
      stop : 39451272,
      direction : "-",
      ID : "ENSG00000125686.12",
      gene_id : "ENSG00000125686.12",
      gene_type : "protein_coding",
      gene_name : "MED1",
      gene_level : 1,
      hgnc_id : "HGNC:9234",
      havana_gene : "OTTHUMG00000133216.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39461486,
      stop : 39564907,
      direction : "+",
      ID : "ENSG00000167258.15",
      gene_id : "ENSG00000167258.15",
      gene_type : "protein_coding",
      gene_name : "CDK12",
      gene_level : 1,
      hgnc_id : "HGNC:24224",
      havana_gene : "OTTHUMG00000133214.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39603536,
      stop : 39609777,
      direction : "-",
      ID : "ENSG00000171532.5",
      gene_id : "ENSG00000171532.5",
      gene_type : "protein_coding",
      gene_name : "NEUROD2",
      gene_level : 2,
      hgnc_id : "HGNC:7763",
      havana_gene : "OTTHUMG00000133211.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39626740,
      stop : 39636626,
      direction : "+",
      ID : "ENSG00000131771.14",
      gene_id : "ENSG00000131771.14",
      gene_type : "protein_coding",
      gene_name : "PPP1R1B",
      gene_level : 2,
      hgnc_id : "HGNC:9287",
      havana_gene : "OTTHUMG00000133210.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39637090,
      stop : 39664201,
      direction : "+",
      ID : "ENSG00000131748.16",
      gene_id : "ENSG00000131748.16",
      gene_type : "protein_coding",
      gene_name : "STARD3",
      gene_level : 1,
      hgnc_id : "HGNC:17579",
      havana_gene : "OTTHUMG00000133213.13",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39665349,
      stop : 39666554,
      direction : "+",
      ID : "ENSG00000173991.6",
      gene_id : "ENSG00000173991.6",
      gene_type : "protein_coding",
      gene_name : "TCAP",
      gene_level : 2,
      hgnc_id : "HGNC:11610",
      havana_gene : "OTTHUMG00000133215.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39667981,
      stop : 39670475,
      direction : "+",
      ID : "ENSG00000141744.4",
      gene_id : "ENSG00000141744.4",
      gene_type : "protein_coding",
      gene_name : "PNMT",
      gene_level : 1,
      hgnc_id : "HGNC:9160",
      havana_gene : "OTTHUMG00000133209.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39671122,
      stop : 39696797,
      direction : "-",
      ID : "ENSG00000161395.14",
      gene_id : "ENSG00000161395.14",
      gene_type : "protein_coding",
      gene_name : "PGAP3",
      gene_level : 1,
      hgnc_id : "HGNC:23719",
      havana_gene : "OTTHUMG00000179110.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39687914,
      stop : 39730426,
      direction : "+",
      ID : "ENSG00000141736.14",
      gene_id : "ENSG00000141736.14",
      gene_type : "protein_coding",
      gene_name : "ERBB2",
      gene_level : 1,
      hgnc_id : "HGNC:3430",
      havana_gene : "OTTHUMG00000179300.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39728496,
      stop : 39730532,
      direction : "-",
      ID : "ENSG00000141741.12",
      gene_id : "ENSG00000141741.12",
      gene_type : "protein_coding",
      gene_name : "MIEN1",
      gene_level : 2,
      hgnc_id : "HGNC:28230",
      havana_gene : "OTTHUMG00000133252.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39737927,
      stop : 39747291,
      direction : "+",
      ID : "ENSG00000141738.14",
      gene_id : "ENSG00000141738.14",
      gene_type : "protein_coding",
      gene_name : "GRB7",
      gene_level : 2,
      hgnc_id : "HGNC:4567",
      havana_gene : "OTTHUMG00000133253.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39757718,
      stop : 39864312,
      direction : "-",
      ID : "ENSG00000161405.17",
      gene_id : "ENSG00000161405.17",
      gene_type : "protein_coding",
      gene_name : "IKZF3",
      gene_level : 2,
      hgnc_id : "HGNC:13178",
      havana_gene : "OTTHUMG00000133250.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39868202,
      stop : 39877896,
      direction : "+",
      ID : "ENSG00000186075.13",
      gene_id : "ENSG00000186075.13",
      gene_type : "protein_coding",
      gene_name : "ZPBP2",
      gene_level : 1,
      hgnc_id : "HGNC:20678",
      havana_gene : "OTTHUMG00000133022.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39904595,
      stop : 39919854,
      direction : "-",
      ID : "ENSG00000073605.18",
      gene_id : "ENSG00000073605.18",
      gene_type : "protein_coding",
      gene_name : "GSDMB",
      gene_level : 2,
      hgnc_id : "HGNC:23690",
      havana_gene : "OTTHUMG00000133248.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39921041,
      stop : 39927601,
      direction : "-",
      ID : "ENSG00000172057.10",
      gene_id : "ENSG00000172057.10",
      gene_type : "protein_coding",
      gene_name : "ORMDL3",
      gene_level : 1,
      hgnc_id : "HGNC:16038",
      havana_gene : "OTTHUMG00000133249.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39941474,
      stop : 39944734,
      direction : "+",
      ID : "ENSG00000204913.6",
      gene_id : "ENSG00000204913.6",
      gene_type : "protein_coding",
      gene_name : "LRRC3C",
      gene_level : 2,
      hgnc_id : "HGNC:40034",
      havana_gene : "OTTHUMG00000179521.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39953263,
      stop : 39977768,
      direction : "+",
      ID : "ENSG00000167914.12",
      gene_id : "ENSG00000167914.12",
      gene_type : "protein_coding",
      gene_name : "GSDMA",
      gene_level : 2,
      hgnc_id : "HGNC:13311",
      havana_gene : "OTTHUMG00000179522.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 39980807,
      stop : 39997959,
      direction : "+",
      ID : "ENSG00000108344.15",
      gene_id : "ENSG00000108344.15",
      gene_type : "protein_coding",
      gene_name : "PSMD3",
      gene_level : 2,
      hgnc_id : "HGNC:9560",
      havana_gene : "OTTHUMG00000133251.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40015361,
      stop : 40017813,
      direction : "+",
      ID : "ENSG00000108342.13",
      gene_id : "ENSG00000108342.13",
      gene_type : "protein_coding",
      gene_name : "CSF3",
      gene_level : 2,
      hgnc_id : "HGNC:2438",
      havana_gene : "OTTHUMG00000133247.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40019097,
      stop : 40061215,
      direction : "-",
      ID : "ENSG00000008838.20",
      gene_id : "ENSG00000008838.20",
      gene_type : "protein_coding",
      gene_name : "MED24",
      gene_level : 1,
      hgnc_id : "HGNC:22963",
      havana_gene : "OTTHUMG00000133329.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40058290,
      stop : 40093867,
      direction : "+",
      ID : "ENSG00000126351.13",
      gene_id : "ENSG00000126351.13",
      gene_type : "protein_coding",
      gene_name : "THRA",
      gene_level : 2,
      hgnc_id : "HGNC:11796",
      havana_gene : "OTTHUMG00000133332.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40092793,
      stop : 40100589,
      direction : "-",
      ID : "ENSG00000126368.6",
      gene_id : "ENSG00000126368.6",
      gene_type : "protein_coding",
      gene_name : "NR1D1",
      gene_level : 2,
      hgnc_id : "HGNC:7962",
      havana_gene : "OTTHUMG00000133327.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40121971,
      stop : 40136917,
      direction : "+",
      ID : "ENSG00000188895.12",
      gene_id : "ENSG00000188895.12",
      gene_type : "protein_coding",
      gene_name : "MSL1",
      gene_level : 1,
      hgnc_id : "HGNC:27905",
      havana_gene : "OTTHUMG00000179629.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40140318,
      stop : 40172171,
      direction : "+",
      ID : "ENSG00000108349.17",
      gene_id : "ENSG00000108349.17",
      gene_type : "protein_coding",
      gene_name : "CASC3",
      gene_level : 2,
      hgnc_id : "HGNC:17040",
      havana_gene : "OTTHUMG00000133323.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40177010,
      stop : 40195656,
      direction : "+",
      ID : "ENSG00000108352.13",
      gene_id : "ENSG00000108352.13",
      gene_type : "protein_coding",
      gene_name : "RAPGEFL1",
      gene_level : 1,
      hgnc_id : "HGNC:17428",
      havana_gene : "OTTHUMG00000133325.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40219304,
      stop : 40284136,
      direction : "+",
      ID : "ENSG00000171475.14",
      gene_id : "ENSG00000171475.14",
      gene_type : "protein_coding",
      gene_name : "WIPF2",
      gene_level : 2,
      hgnc_id : "HGNC:30923",
      havana_gene : "OTTHUMG00000133331.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40287879,
      stop : 40304657,
      direction : "+",
      ID : "ENSG00000094804.12",
      gene_id : "ENSG00000094804.12",
      gene_type : "protein_coding",
      gene_name : "CDC6",
      gene_level : 2,
      hgnc_id : "HGNC:1744",
      havana_gene : "OTTHUMG00000133324.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40309180,
      stop : 40357643,
      direction : "+",
      ID : "ENSG00000131759.18",
      gene_id : "ENSG00000131759.18",
      gene_type : "protein_coding",
      gene_name : "RARA",
      gene_level : 1,
      hgnc_id : "HGNC:9864",
      havana_gene : "OTTHUMG00000133328.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40360652,
      stop : 40364737,
      direction : "-",
      ID : "ENSG00000183153.7",
      gene_id : "ENSG00000183153.7",
      gene_type : "protein_coding",
      gene_name : "GJD3",
      gene_level : 2,
      hgnc_id : "HGNC:19147",
      havana_gene : "OTTHUMG00000179634.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40388525,
      stop : 40417896,
      direction : "-",
      ID : "ENSG00000131747.15",
      gene_id : "ENSG00000131747.15",
      gene_type : "protein_coding",
      gene_name : "TOP2A",
      gene_level : 1,
      hgnc_id : "HGNC:11989",
      havana_gene : "OTTHUMG00000155008.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40443450,
      stop : 40457725,
      direction : "+",
      ID : "ENSG00000141753.7",
      gene_id : "ENSG00000141753.7",
      gene_type : "protein_coding",
      gene_name : "IGFBP4",
      gene_level : 2,
      hgnc_id : "HGNC:5473",
      havana_gene : "OTTHUMG00000133326.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40475828,
      stop : 40501623,
      direction : "-",
      ID : "ENSG00000131746.13",
      gene_id : "ENSG00000131746.13",
      gene_type : "protein_coding",
      gene_name : "TNS4",
      gene_level : 2,
      hgnc_id : "HGNC:24352",
      havana_gene : "OTTHUMG00000133330.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40553769,
      stop : 40565472,
      direction : "-",
      ID : "ENSG00000126353.3",
      gene_id : "ENSG00000126353.3",
      gene_type : "protein_coding",
      gene_name : "CCR7",
      gene_level : 2,
      hgnc_id : "HGNC:1608",
      havana_gene : "OTTHUMG00000133375.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40624962,
      stop : 40648654,
      direction : "-",
      ID : "ENSG00000073584.20",
      gene_id : "ENSG00000073584.20",
      gene_type : "protein_coding",
      gene_name : "SMARCE1",
      gene_level : 2,
      hgnc_id : "HGNC:11109",
      havana_gene : "OTTHUMG00000133367.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40627356,
      stop : 40665141,
      direction : "-",
      ID : "ENSG00000264058.2",
      gene_id : "ENSG00000264058.2",
      gene_type : "protein_coding",
      gene_name : "AC073508.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179656.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40654665,
      stop : 40665181,
      direction : "-",
      ID : "ENSG00000213424.9",
      gene_id : "ENSG00000213424.9",
      gene_type : "protein_coding",
      gene_name : "KRT222",
      gene_level : 2,
      hgnc_id : "HGNC:28695",
      havana_gene : "OTTHUMG00000133374.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40697991,
      stop : 40703752,
      direction : "-",
      ID : "ENSG00000167916.5",
      gene_id : "ENSG00000167916.5",
      gene_type : "protein_coding",
      gene_name : "KRT24",
      gene_level : 2,
      hgnc_id : "HGNC:18527",
      havana_gene : "OTTHUMG00000133372.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40748021,
      stop : 40755331,
      direction : "-",
      ID : "ENSG00000204897.7",
      gene_id : "ENSG00000204897.7",
      gene_type : "protein_coding",
      gene_name : "KRT25",
      gene_level : 2,
      hgnc_id : "HGNC:30839",
      havana_gene : "OTTHUMG00000133373.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40766238,
      stop : 40772162,
      direction : "-",
      ID : "ENSG00000186393.5",
      gene_id : "ENSG00000186393.5",
      gene_type : "protein_coding",
      gene_name : "KRT26",
      gene_level : 2,
      hgnc_id : "HGNC:30840",
      havana_gene : "OTTHUMG00000133370.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40776808,
      stop : 40782550,
      direction : "-",
      ID : "ENSG00000171446.7",
      gene_id : "ENSG00000171446.7",
      gene_type : "protein_coding",
      gene_name : "KRT27",
      gene_level : 2,
      hgnc_id : "HGNC:30841",
      havana_gene : "OTTHUMG00000133371.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40792196,
      stop : 40799959,
      direction : "-",
      ID : "ENSG00000173908.9",
      gene_id : "ENSG00000173908.9",
      gene_type : "protein_coding",
      gene_name : "KRT28",
      gene_level : 2,
      hgnc_id : "HGNC:30842",
      havana_gene : "OTTHUMG00000133365.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40818117,
      stop : 40822614,
      direction : "-",
      ID : "ENSG00000186395.9",
      gene_id : "ENSG00000186395.9",
      gene_type : "protein_coding",
      gene_name : "KRT10",
      gene_level : 2,
      hgnc_id : "HGNC:6413",
      havana_gene : "OTTHUMG00000133368.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40861303,
      stop : 40867223,
      direction : "-",
      ID : "ENSG00000187242.6",
      gene_id : "ENSG00000187242.6",
      gene_type : "protein_coding",
      gene_name : "KRT12",
      gene_level : 2,
      hgnc_id : "HGNC:6414",
      havana_gene : "OTTHUMG00000133369.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40875889,
      stop : 40885242,
      direction : "-",
      ID : "ENSG00000171431.4",
      gene_id : "ENSG00000171431.4",
      gene_type : "protein_coding",
      gene_name : "KRT20",
      gene_level : 2,
      hgnc_id : "HGNC:20412",
      havana_gene : "OTTHUMG00000133366.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40922700,
      stop : 40937646,
      direction : "-",
      ID : "ENSG00000108244.17",
      gene_id : "ENSG00000108244.17",
      gene_type : "protein_coding",
      gene_name : "KRT23",
      gene_level : 2,
      hgnc_id : "HGNC:6438",
      havana_gene : "OTTHUMG00000133376.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40958417,
      stop : 40966948,
      direction : "-",
      ID : "ENSG00000196859.8",
      gene_id : "ENSG00000196859.8",
      gene_type : "protein_coding",
      gene_name : "KRT39",
      gene_level : 2,
      hgnc_id : "HGNC:32971",
      havana_gene : "OTTHUMG00000133424.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40977716,
      stop : 40987135,
      direction : "-",
      ID : "ENSG00000204889.10",
      gene_id : "ENSG00000204889.10",
      gene_type : "protein_coding",
      gene_name : "KRT40",
      gene_level : 2,
      hgnc_id : "HGNC:26707",
      havana_gene : "OTTHUMG00000133596.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40993430,
      stop : 40994164,
      direction : "-",
      ID : "ENSG00000212899.3",
      gene_id : "ENSG00000212899.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP3-3",
      gene_level : 2,
      hgnc_id : "HGNC:18890",
      havana_gene : "OTTHUMG00000133591.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 40999193,
      stop : 40999906,
      direction : "-",
      ID : "ENSG00000212900.3",
      gene_id : "ENSG00000212900.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP3-2",
      gene_level : 2,
      hgnc_id : "HGNC:16779",
      havana_gene : "OTTHUMG00000133581.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41008521,
      stop : 41019324,
      direction : "-",
      ID : "ENSG00000212901.4",
      gene_id : "ENSG00000212901.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP3-1",
      gene_level : 2,
      hgnc_id : "HGNC:16778",
      havana_gene : "OTTHUMG00000133595.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41026026,
      stop : 41027208,
      direction : "-",
      ID : "ENSG00000221852.5",
      gene_id : "ENSG00000221852.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP1-5",
      gene_level : 2,
      hgnc_id : "HGNC:16777",
      havana_gene : "OTTHUMG00000133587.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41029697,
      stop : 41030104,
      direction : "-",
      ID : "ENSG00000204887.4",
      gene_id : "ENSG00000204887.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP1-4",
      gene_level : 2,
      hgnc_id : "HGNC:18904",
      havana_gene : "OTTHUMG00000133631.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41033884,
      stop : 41034874,
      direction : "-",
      ID : "ENSG00000221880.4",
      gene_id : "ENSG00000221880.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP1-3",
      gene_level : 2,
      hgnc_id : "HGNC:16771",
      havana_gene : "OTTHUMG00000133583.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41040541,
      stop : 41041450,
      direction : "-",
      ID : "ENSG00000188581.9",
      gene_id : "ENSG00000188581.9",
      gene_type : "protein_coding",
      gene_name : "KRTAP1-1",
      gene_level : 2,
      hgnc_id : "HGNC:16772",
      havana_gene : "OTTHUMG00000133592.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41046541,
      stop : 41047316,
      direction : "-",
      ID : "ENSG00000212725.3",
      gene_id : "ENSG00000212725.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP2-1",
      gene_level : 2,
      hgnc_id : "HGNC:16775",
      havana_gene : "OTTHUMG00000171405.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41054498,
      stop : 41055230,
      direction : "-",
      ID : "ENSG00000214518.3",
      gene_id : "ENSG00000214518.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP2-2",
      gene_level : 2,
      hgnc_id : "HGNC:18905",
      havana_gene : "OTTHUMG00000133593.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41059240,
      stop : 41060114,
      direction : "-",
      ID : "ENSG00000212724.3",
      gene_id : "ENSG00000212724.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP2-3",
      gene_level : 2,
      hgnc_id : "HGNC:18906",
      havana_gene : "OTTHUMG00000133655.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41065116,
      stop : 41065879,
      direction : "-",
      ID : "ENSG00000213417.3",
      gene_id : "ENSG00000213417.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP2-4",
      gene_level : 2,
      hgnc_id : "HGNC:18891",
      havana_gene : "OTTHUMG00000133594.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41084150,
      stop : 41085141,
      direction : "+",
      ID : "ENSG00000240871.5",
      gene_id : "ENSG00000240871.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-7",
      gene_level : 2,
      hgnc_id : "HGNC:18898",
      havana_gene : "OTTHUMG00000133582.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41096981,
      stop : 41098142,
      direction : "-",
      ID : "ENSG00000204880.8",
      gene_id : "ENSG00000204880.8",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-8",
      gene_level : 2,
      hgnc_id : "HGNC:17230",
      havana_gene : "OTTHUMG00000133580.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41101502,
      stop : 41102209,
      direction : "-",
      ID : "ENSG00000241241.1",
      gene_id : "ENSG00000241241.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-16",
      gene_level : 2,
      hgnc_id : "HGNC:18921",
      havana_gene : "OTTHUMG00000133590.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41105332,
      stop : 41106488,
      direction : "+",
      ID : "ENSG00000212722.7",
      gene_id : "ENSG00000212722.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-9",
      gene_level : 2,
      hgnc_id : "HGNC:18910",
      havana_gene : "OTTHUMG00000133584.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41117181,
      stop : 41118373,
      direction : "-",
      ID : "ENSG00000212721.4",
      gene_id : "ENSG00000212721.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-11",
      gene_level : 2,
      hgnc_id : "HGNC:18911",
      havana_gene : "OTTHUMG00000133586.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41123091,
      stop : 41124182,
      direction : "-",
      ID : "ENSG00000213416.4",
      gene_id : "ENSG00000213416.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-12",
      gene_level : 2,
      hgnc_id : "HGNC:16776",
      havana_gene : "OTTHUMG00000133632.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41139433,
      stop : 41140487,
      direction : "-",
      ID : "ENSG00000198090.3",
      gene_id : "ENSG00000198090.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-6",
      gene_level : 2,
      hgnc_id : "HGNC:18909",
      havana_gene : "OTTHUMG00000133634.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41148924,
      stop : 41149825,
      direction : "-",
      ID : "ENSG00000198271.5",
      gene_id : "ENSG00000198271.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-5",
      gene_level : 2,
      hgnc_id : "HGNC:18899",
      havana_gene : "OTTHUMG00000133638.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41159649,
      stop : 41160748,
      direction : "-",
      ID : "ENSG00000171396.12",
      gene_id : "ENSG00000171396.12",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-4",
      gene_level : 2,
      hgnc_id : "HGNC:16928",
      havana_gene : "OTTHUMG00000133428.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41167231,
      stop : 41168221,
      direction : "-",
      ID : "ENSG00000196156.5",
      gene_id : "ENSG00000196156.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-3",
      gene_level : 2,
      hgnc_id : "HGNC:18908",
      havana_gene : "OTTHUMG00000133639.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41177446,
      stop : 41178221,
      direction : "-",
      ID : "ENSG00000244537.3",
      gene_id : "ENSG00000244537.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-2",
      gene_level : 2,
      hgnc_id : "HGNC:18900",
      havana_gene : "OTTHUMG00000133437.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41184102,
      stop : 41185342,
      direction : "-",
      ID : "ENSG00000198443.6",
      gene_id : "ENSG00000198443.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP4-1",
      gene_level : 2,
      hgnc_id : "HGNC:18907",
      havana_gene : "OTTHUMG00000132081.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41189887,
      stop : 41190639,
      direction : "+",
      ID : "ENSG00000240542.4",
      gene_id : "ENSG00000240542.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-1",
      gene_level : 2,
      hgnc_id : "HGNC:18912",
      havana_gene : "OTTHUMG00000133636.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41226648,
      stop : 41227652,
      direction : "+",
      ID : "ENSG00000239886.5",
      gene_id : "ENSG00000239886.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-2",
      gene_level : 2,
      hgnc_id : "HGNC:16926",
      havana_gene : "OTTHUMG00000133609.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41232449,
      stop : 41233454,
      direction : "+",
      ID : "ENSG00000204873.5",
      gene_id : "ENSG00000204873.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-3",
      gene_level : 2,
      hgnc_id : "HGNC:16927",
      havana_gene : "OTTHUMG00000133427.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41237999,
      stop : 41239004,
      direction : "+",
      ID : "ENSG00000187272.7",
      gene_id : "ENSG00000187272.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-8",
      gene_level : 2,
      hgnc_id : "HGNC:17231",
      havana_gene : "OTTHUMG00000133604.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41249687,
      stop : 41250653,
      direction : "+",
      ID : "ENSG00000241595.2",
      gene_id : "ENSG00000241595.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-4",
      gene_level : 2,
      hgnc_id : "HGNC:18902",
      havana_gene : "OTTHUMG00000133438.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41255384,
      stop : 41256364,
      direction : "+",
      ID : "ENSG00000198083.9",
      gene_id : "ENSG00000198083.9",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-9",
      gene_level : 2,
      hgnc_id : "HGNC:16773",
      havana_gene : "OTTHUMG00000133602.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41265339,
      stop : 41266641,
      direction : "+",
      ID : "ENSG00000212659.1",
      gene_id : "ENSG00000212659.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-6",
      gene_level : 2,
      hgnc_id : "HGNC:18914",
      havana_gene : "OTTHUMG00000133600.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41275659,
      stop : 41276697,
      direction : "+",
      ID : "ENSG00000180386.7",
      gene_id : "ENSG00000180386.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP9-7",
      gene_level : 2,
      hgnc_id : "HGNC:18915",
      havana_gene : "OTTHUMG00000133605.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41301826,
      stop : 41302851,
      direction : "-",
      ID : "ENSG00000212658.1",
      gene_id : "ENSG00000212658.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP29-1",
      gene_level : 2,
      hgnc_id : "HGNC:34211",
      havana_gene : "OTTHUMG00000133662.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41307700,
      stop : 41309253,
      direction : "-",
      ID : "ENSG00000212657.1",
      gene_id : "ENSG00000212657.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP16-1",
      gene_level : 2,
      hgnc_id : "HGNC:18916",
      havana_gene : "OTTHUMG00000133640.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41314912,
      stop : 41315710,
      direction : "-",
      ID : "ENSG00000186860.5",
      gene_id : "ENSG00000186860.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP17-1",
      gene_level : 2,
      hgnc_id : "HGNC:18917",
      havana_gene : "OTTHUMG00000133433.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41346092,
      stop : 41350828,
      direction : "-",
      ID : "ENSG00000006059.4",
      gene_id : "ENSG00000006059.4",
      gene_type : "protein_coding",
      gene_name : "KRT33A",
      gene_level : 2,
      hgnc_id : "HGNC:6450",
      havana_gene : "OTTHUMG00000133432.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41363498,
      stop : 41369813,
      direction : "-",
      ID : "ENSG00000131738.11",
      gene_id : "ENSG00000131738.11",
      gene_type : "protein_coding",
      gene_name : "KRT33B",
      gene_level : 2,
      hgnc_id : "HGNC:6451",
      havana_gene : "OTTHUMG00000133429.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41377650,
      stop : 41382403,
      direction : "-",
      ID : "ENSG00000131737.6",
      gene_id : "ENSG00000131737.6",
      gene_type : "protein_coding",
      gene_name : "KRT34",
      gene_level : 2,
      hgnc_id : "HGNC:6452",
      havana_gene : "OTTHUMG00000133436.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41393721,
      stop : 41397608,
      direction : "-",
      ID : "ENSG00000094796.5",
      gene_id : "ENSG00000094796.5",
      gene_type : "protein_coding",
      gene_name : "KRT31",
      gene_level : 2,
      hgnc_id : "HGNC:6448",
      havana_gene : "OTTHUMG00000133423.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41420547,
      stop : 41424585,
      direction : "-",
      ID : "ENSG00000108417.4",
      gene_id : "ENSG00000108417.4",
      gene_type : "protein_coding",
      gene_name : "KRT37",
      gene_level : 2,
      hgnc_id : "HGNC:6455",
      havana_gene : "OTTHUMG00000133606.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41436154,
      stop : 41440983,
      direction : "-",
      ID : "ENSG00000171360.4",
      gene_id : "ENSG00000171360.4",
      gene_type : "protein_coding",
      gene_name : "KRT38",
      gene_level : 2,
      hgnc_id : "HGNC:6456",
      havana_gene : "OTTHUMG00000133439.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41459513,
      stop : 41467386,
      direction : "-",
      ID : "ENSG00000108759.4",
      gene_id : "ENSG00000108759.4",
      gene_type : "protein_coding",
      gene_name : "KRT32",
      gene_level : 2,
      hgnc_id : "HGNC:6449",
      havana_gene : "OTTHUMG00000133430.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41476689,
      stop : 41481140,
      direction : "-",
      ID : "ENSG00000197079.8",
      gene_id : "ENSG00000197079.8",
      gene_type : "protein_coding",
      gene_name : "KRT35",
      gene_level : 2,
      hgnc_id : "HGNC:6453",
      havana_gene : "OTTHUMG00000133425.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41486136,
      stop : 41492546,
      direction : "-",
      ID : "ENSG00000126337.13",
      gene_id : "ENSG00000126337.13",
      gene_type : "protein_coding",
      gene_name : "KRT36",
      gene_level : 2,
      hgnc_id : "HGNC:6454",
      havana_gene : "OTTHUMG00000133431.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41500981,
      stop : 41505705,
      direction : "-",
      ID : "ENSG00000171401.15",
      gene_id : "ENSG00000171401.15",
      gene_type : "protein_coding",
      gene_name : "KRT13",
      gene_level : 2,
      hgnc_id : "HGNC:6415",
      havana_gene : "OTTHUMG00000133434.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41513745,
      stop : 41522529,
      direction : "-",
      ID : "ENSG00000171346.16",
      gene_id : "ENSG00000171346.16",
      gene_type : "protein_coding",
      gene_name : "KRT15",
      gene_level : 1,
      hgnc_id : "HGNC:6421",
      havana_gene : "OTTHUMG00000133435.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41523617,
      stop : 41528308,
      direction : "-",
      ID : "ENSG00000171345.13",
      gene_id : "ENSG00000171345.13",
      gene_type : "protein_coding",
      gene_name : "KRT19",
      gene_level : 1,
      hgnc_id : "HGNC:6436",
      havana_gene : "OTTHUMG00000133422.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41565836,
      stop : 41572059,
      direction : "-",
      ID : "ENSG00000171403.10",
      gene_id : "ENSG00000171403.10",
      gene_type : "protein_coding",
      gene_name : "KRT9",
      gene_level : 2,
      hgnc_id : "HGNC:6447",
      havana_gene : "OTTHUMG00000133599.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41582279,
      stop : 41586895,
      direction : "-",
      ID : "ENSG00000186847.6",
      gene_id : "ENSG00000186847.6",
      gene_type : "protein_coding",
      gene_name : "KRT14",
      gene_level : 2,
      hgnc_id : "HGNC:6416",
      havana_gene : "OTTHUMG00000133426.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41609778,
      stop : 41615899,
      direction : "-",
      ID : "ENSG00000186832.9",
      gene_id : "ENSG00000186832.9",
      gene_type : "protein_coding",
      gene_name : "KRT16",
      gene_level : 2,
      hgnc_id : "HGNC:6423",
      havana_gene : "OTTHUMG00000133495.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41619442,
      stop : 41624842,
      direction : "-",
      ID : "ENSG00000128422.17",
      gene_id : "ENSG00000128422.17",
      gene_type : "protein_coding",
      gene_name : "KRT17",
      gene_level : 2,
      hgnc_id : "HGNC:6427",
      havana_gene : "OTTHUMG00000133505.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41688885,
      stop : 41692668,
      direction : "+",
      ID : "ENSG00000173812.11",
      gene_id : "ENSG00000173812.11",
      gene_type : "protein_coding",
      gene_name : "EIF1",
      gene_level : 2,
      hgnc_id : "HGNC:3249",
      havana_gene : "OTTHUMG00000133492.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41712331,
      stop : 41715969,
      direction : "+",
      ID : "ENSG00000184502.4",
      gene_id : "ENSG00000184502.4",
      gene_type : "protein_coding",
      gene_name : "GAST",
      gene_level : 2,
      hgnc_id : "HGNC:4164",
      havana_gene : "OTTHUMG00000133496.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41717742,
      stop : 41734644,
      direction : "-",
      ID : "ENSG00000173805.16",
      gene_id : "ENSG00000173805.16",
      gene_type : "protein_coding",
      gene_name : "HAP1",
      gene_level : 2,
      hgnc_id : "HGNC:4812",
      havana_gene : "OTTHUMG00000133498.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41754604,
      stop : 41786931,
      direction : "-",
      ID : "ENSG00000173801.17",
      gene_id : "ENSG00000173801.17",
      gene_type : "protein_coding",
      gene_name : "JUP",
      gene_level : 2,
      hgnc_id : "HGNC:6207",
      havana_gene : "OTTHUMG00000133494.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41801947,
      stop : 41812604,
      direction : "-",
      ID : "ENSG00000141696.13",
      gene_id : "ENSG00000141696.13",
      gene_type : "protein_coding",
      gene_name : "P3H4",
      gene_level : 1,
      hgnc_id : "HGNC:16946",
      havana_gene : "OTTHUMG00000133501.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41812680,
      stop : 41823213,
      direction : "+",
      ID : "ENSG00000141756.19",
      gene_id : "ENSG00000141756.19",
      gene_type : "protein_coding",
      gene_name : "FKBP10",
      gene_level : 1,
      hgnc_id : "HGNC:18169",
      havana_gene : "OTTHUMG00000133497.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41825057,
      stop : 41836260,
      direction : "-",
      ID : "ENSG00000141698.17",
      gene_id : "ENSG00000141698.17",
      gene_type : "protein_coding",
      gene_name : "NT5C3B",
      gene_level : 1,
      hgnc_id : "HGNC:28300",
      havana_gene : "OTTHUMG00000133499.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41835685,
      stop : 41848384,
      direction : "+",
      ID : "ENSG00000161594.7",
      gene_id : "ENSG00000161594.7",
      gene_type : "protein_coding",
      gene_name : "KLHL10",
      gene_level : 2,
      hgnc_id : "HGNC:18829",
      havana_gene : "OTTHUMG00000152510.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41848518,
      stop : 41865423,
      direction : "-",
      ID : "ENSG00000178502.6",
      gene_id : "ENSG00000178502.6",
      gene_type : "protein_coding",
      gene_name : "KLHL11",
      gene_level : 2,
      hgnc_id : "HGNC:19008",
      havana_gene : "OTTHUMG00000133506.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41866917,
      stop : 41930542,
      direction : "-",
      ID : "ENSG00000131473.17",
      gene_id : "ENSG00000131473.17",
      gene_type : "protein_coding",
      gene_name : "ACLY",
      gene_level : 2,
      hgnc_id : "HGNC:115",
      havana_gene : "OTTHUMG00000133507.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41930617,
      stop : 41966503,
      direction : "+",
      ID : "ENSG00000204815.10",
      gene_id : "ENSG00000204815.10",
      gene_type : "protein_coding",
      gene_name : "TTC25",
      gene_level : 2,
      hgnc_id : "HGNC:25280",
      havana_gene : "OTTHUMG00000175837.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41966763,
      stop : 41977740,
      direction : "+",
      ID : "ENSG00000173786.17",
      gene_id : "ENSG00000173786.17",
      gene_type : "protein_coding",
      gene_name : "CNP",
      gene_level : 1,
      hgnc_id : "HGNC:2158",
      havana_gene : "OTTHUMG00000133502.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 41976421,
      stop : 42021376,
      direction : "-",
      ID : "ENSG00000168259.17",
      gene_id : "ENSG00000168259.17",
      gene_type : "protein_coding",
      gene_name : "DNAJC7",
      gene_level : 2,
      hgnc_id : "HGNC:12392",
      havana_gene : "OTTHUMG00000180862.13",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42011382,
      stop : 42025644,
      direction : "+",
      ID : "ENSG00000168256.18",
      gene_id : "ENSG00000168256.18",
      gene_type : "protein_coding",
      gene_name : "NKIRAS2",
      gene_level : 1,
      hgnc_id : "HGNC:17898",
      havana_gene : "OTTHUMG00000133503.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42025576,
      stop : 42098479,
      direction : "-",
      ID : "ENSG00000187595.16",
      gene_id : "ENSG00000187595.16",
      gene_type : "protein_coding",
      gene_name : "ZNF385C",
      gene_level : 1,
      hgnc_id : "HGNC:33722",
      havana_gene : "OTTHUMG00000132073.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42038232,
      stop : 42050601,
      direction : "-",
      ID : "ENSG00000267221.3",
      gene_id : "ENSG00000267221.3",
      gene_type : "protein_coding",
      gene_name : "C17orf113",
      gene_level : 2,
      hgnc_id : "HGNC:53437",
      havana_gene : "OTTHUMG00000180103.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42101404,
      stop : 42112714,
      direction : "-",
      ID : "ENSG00000108771.13",
      gene_id : "ENSG00000108771.13",
      gene_type : "protein_coding",
      gene_name : "DHX58",
      gene_level : 2,
      hgnc_id : "HGNC:29517",
      havana_gene : "OTTHUMG00000133493.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42113111,
      stop : 42121367,
      direction : "-",
      ID : "ENSG00000108773.11",
      gene_id : "ENSG00000108773.11",
      gene_type : "protein_coding",
      gene_name : "KAT2A",
      gene_level : 2,
      hgnc_id : "HGNC:4201",
      havana_gene : "OTTHUMG00000133504.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42119674,
      stop : 42154916,
      direction : "-",
      ID : "ENSG00000267261.5",
      gene_id : "ENSG00000267261.5",
      gene_type : "protein_coding",
      gene_name : "AC099811.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180104.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42122804,
      stop : 42123352,
      direction : "+",
      ID : "ENSG00000260325.2",
      gene_id : "ENSG00000260325.2",
      gene_type : "protein_coding",
      gene_name : "HSPB9",
      gene_level : 2,
      hgnc_id : "HGNC:30589",
      havana_gene : "OTTHUMG00000133500.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42124978,
      stop : 42155044,
      direction : "-",
      ID : "ENSG00000108774.15",
      gene_id : "ENSG00000108774.15",
      gene_type : "protein_coding",
      gene_name : "RAB5C",
      gene_level : 1,
      hgnc_id : "HGNC:9785",
      havana_gene : "OTTHUMG00000169703.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42156891,
      stop : 42181142,
      direction : "-",
      ID : "ENSG00000089558.9",
      gene_id : "ENSG00000089558.9",
      gene_type : "protein_coding",
      gene_name : "KCNH4",
      gene_level : 2,
      hgnc_id : "HGNC:6253",
      havana_gene : "OTTHUMG00000180106.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42184060,
      stop : 42185452,
      direction : "-",
      ID : "ENSG00000161610.1",
      gene_id : "ENSG00000161610.1",
      gene_type : "protein_coding",
      gene_name : "HCRT",
      gene_level : 2,
      hgnc_id : "HGNC:4847",
      havana_gene : "OTTHUMG00000180107.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42188799,
      stop : 42194532,
      direction : "-",
      ID : "ENSG00000167925.16",
      gene_id : "ENSG00000167925.16",
      gene_type : "protein_coding",
      gene_name : "GHDC",
      gene_level : 1,
      hgnc_id : "HGNC:24438",
      havana_gene : "OTTHUMG00000180108.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42199177,
      stop : 42276707,
      direction : "-",
      ID : "ENSG00000173757.10",
      gene_id : "ENSG00000173757.10",
      gene_type : "protein_coding",
      gene_name : "STAT5B",
      gene_level : 2,
      hgnc_id : "HGNC:11367",
      havana_gene : "OTTHUMG00000150724.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42287547,
      stop : 42311943,
      direction : "+",
      ID : "ENSG00000126561.18",
      gene_id : "ENSG00000126561.18",
      gene_type : "protein_coding",
      gene_name : "STAT5A",
      gene_level : 1,
      hgnc_id : "HGNC:11366",
      havana_gene : "OTTHUMG00000150725.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42313324,
      stop : 42388540,
      direction : "-",
      ID : "ENSG00000168610.16",
      gene_id : "ENSG00000168610.16",
      gene_type : "protein_coding",
      gene_name : "STAT3",
      gene_level : 1,
      hgnc_id : "HGNC:11364",
      havana_gene : "OTTHUMG00000150645.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42402449,
      stop : 42423256,
      direction : "-",
      ID : "ENSG00000177469.13",
      gene_id : "ENSG00000177469.13",
      gene_type : "protein_coding",
      gene_name : "CAVIN1",
      gene_level : 2,
      hgnc_id : "HGNC:9688",
      havana_gene : "OTTHUMG00000180137.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42458844,
      stop : 42522582,
      direction : "+",
      ID : "ENSG00000033627.17",
      gene_id : "ENSG00000033627.17",
      gene_type : "protein_coding",
      gene_name : "ATP6V0A1",
      gene_level : 1,
      hgnc_id : "HGNC:865",
      havana_gene : "OTTHUMG00000180238.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42536241,
      stop : 42544449,
      direction : "+",
      ID : "ENSG00000108784.10",
      gene_id : "ENSG00000108784.10",
      gene_type : "protein_coding",
      gene_name : "NAGLU",
      gene_level : 1,
      hgnc_id : "HGNC:7632",
      havana_gene : "OTTHUMG00000180240.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42552922,
      stop : 42555214,
      direction : "+",
      ID : "ENSG00000108786.11",
      gene_id : "ENSG00000108786.11",
      gene_type : "protein_coding",
      gene_name : "HSD17B1",
      gene_level : 2,
      hgnc_id : "HGNC:5210",
      havana_gene : "OTTHUMG00000180243.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42561467,
      stop : 42566277,
      direction : "+",
      ID : "ENSG00000068120.15",
      gene_id : "ENSG00000068120.15",
      gene_type : "protein_coding",
      gene_name : "COASY",
      gene_level : 2,
      hgnc_id : "HGNC:29932",
      havana_gene : "OTTHUMG00000180245.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42567072,
      stop : 42573239,
      direction : "+",
      ID : "ENSG00000108788.12",
      gene_id : "ENSG00000108788.12",
      gene_type : "protein_coding",
      gene_name : "MLX",
      gene_level : 2,
      hgnc_id : "HGNC:11645",
      havana_gene : "OTTHUMG00000180246.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42572310,
      stop : 42577831,
      direction : "-",
      ID : "ENSG00000131470.15",
      gene_id : "ENSG00000131470.15",
      gene_type : "protein_coding",
      gene_name : "PSMC3IP",
      gene_level : 2,
      hgnc_id : "HGNC:17928",
      havana_gene : "OTTHUMG00000180247.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42579513,
      stop : 42610623,
      direction : "-",
      ID : "ENSG00000141699.11",
      gene_id : "ENSG00000141699.11",
      gene_type : "protein_coding",
      gene_name : "RETREG3",
      gene_level : 1,
      hgnc_id : "HGNC:27258",
      havana_gene : "OTTHUMG00000180275.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42609641,
      stop : 42615238,
      direction : "+",
      ID : "ENSG00000131462.9",
      gene_id : "ENSG00000131462.9",
      gene_type : "protein_coding",
      gene_name : "TUBG1",
      gene_level : 1,
      hgnc_id : "HGNC:12417",
      havana_gene : "OTTHUMG00000180277.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42659284,
      stop : 42667006,
      direction : "+",
      ID : "ENSG00000037042.9",
      gene_id : "ENSG00000037042.9",
      gene_type : "protein_coding",
      gene_name : "TUBG2",
      gene_level : 2,
      hgnc_id : "HGNC:12419",
      havana_gene : "OTTHUMG00000180640.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42667914,
      stop : 42676994,
      direction : "-",
      ID : "ENSG00000068137.15",
      gene_id : "ENSG00000068137.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHH3",
      gene_level : 1,
      hgnc_id : "HGNC:26105",
      havana_gene : "OTTHUMG00000180641.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42678889,
      stop : 42683917,
      direction : "-",
      ID : "ENSG00000184451.5",
      gene_id : "ENSG00000184451.5",
      gene_type : "protein_coding",
      gene_name : "CCR10",
      gene_level : 1,
      hgnc_id : "HGNC:4474",
      havana_gene : "OTTHUMG00000132301.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42682531,
      stop : 42699993,
      direction : "+",
      ID : "ENSG00000108797.12",
      gene_id : "ENSG00000108797.12",
      gene_type : "protein_coding",
      gene_name : "CNTNAP1",
      gene_level : 2,
      hgnc_id : "HGNC:8011",
      havana_gene : "OTTHUMG00000180643.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42700275,
      stop : 42745049,
      direction : "-",
      ID : "ENSG00000108799.13",
      gene_id : "ENSG00000108799.13",
      gene_type : "protein_coding",
      gene_name : "EZH1",
      gene_level : 1,
      hgnc_id : "HGNC:3526",
      havana_gene : "OTTHUMG00000180645.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42758447,
      stop : 42763041,
      direction : "+",
      ID : "ENSG00000131477.11",
      gene_id : "ENSG00000131477.11",
      gene_type : "protein_coding",
      gene_name : "RAMP2",
      gene_level : 1,
      hgnc_id : "HGNC:9844",
      havana_gene : "OTTHUMG00000180648.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42773449,
      stop : 42779599,
      direction : "+",
      ID : "ENSG00000131475.7",
      gene_id : "ENSG00000131475.7",
      gene_type : "protein_coding",
      gene_name : "VPS25",
      gene_level : 2,
      hgnc_id : "HGNC:28122",
      havana_gene : "OTTHUMG00000180649.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42780610,
      stop : 42797066,
      direction : "+",
      ID : "ENSG00000126562.17",
      gene_id : "ENSG00000126562.17",
      gene_type : "protein_coding",
      gene_name : "WNK4",
      gene_level : 2,
      hgnc_id : "HGNC:14544",
      havana_gene : "OTTHUMG00000180650.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42795147,
      stop : 42798704,
      direction : "-",
      ID : "ENSG00000183978.8",
      gene_id : "ENSG00000183978.8",
      gene_type : "protein_coding",
      gene_name : "COA3",
      gene_level : 2,
      hgnc_id : "HGNC:24990",
      havana_gene : "OTTHUMG00000180651.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42798800,
      stop : 42811587,
      direction : "+",
      ID : "ENSG00000176563.10",
      gene_id : "ENSG00000176563.10",
      gene_type : "protein_coding",
      gene_name : "CNTD1",
      gene_level : 1,
      hgnc_id : "HGNC:26847",
      havana_gene : "OTTHUMG00000180652.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42810134,
      stop : 42833350,
      direction : "-",
      ID : "ENSG00000126581.13",
      gene_id : "ENSG00000126581.13",
      gene_type : "protein_coding",
      gene_name : "BECN1",
      gene_level : 1,
      hgnc_id : "HGNC:1034",
      havana_gene : "OTTHUMG00000180653.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42824385,
      stop : 42843760,
      direction : "+",
      ID : "ENSG00000131467.11",
      gene_id : "ENSG00000131467.11",
      gene_type : "protein_coding",
      gene_name : "PSME3",
      gene_level : 1,
      hgnc_id : "HGNC:9570",
      havana_gene : "OTTHUMG00000180654.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42844580,
      stop : 42850707,
      direction : "+",
      ID : "ENSG00000131480.9",
      gene_id : "ENSG00000131480.9",
      gene_type : "protein_coding",
      gene_name : "AOC2",
      gene_level : 2,
      hgnc_id : "HGNC:549",
      havana_gene : "OTTHUMG00000180655.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42851184,
      stop : 42858130,
      direction : "+",
      ID : "ENSG00000131471.7",
      gene_id : "ENSG00000131471.7",
      gene_type : "protein_coding",
      gene_name : "AOC3",
      gene_level : 1,
      hgnc_id : "HGNC:550",
      havana_gene : "OTTHUMG00000180656.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42900797,
      stop : 42914438,
      direction : "+",
      ID : "ENSG00000131482.10",
      gene_id : "ENSG00000131482.10",
      gene_type : "protein_coding",
      gene_name : "G6PC",
      gene_level : 1,
      hgnc_id : "HGNC:4056",
      havana_gene : "OTTHUMG00000180657.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42950526,
      stop : 42964498,
      direction : "-",
      ID : "ENSG00000266967.7",
      gene_id : "ENSG00000266967.7",
      gene_type : "protein_coding",
      gene_name : "AARSD1",
      gene_level : 2,
      hgnc_id : "HGNC:28417",
      havana_gene : "OTTHUMG00000153515.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42950526,
      stop : 42980528,
      direction : "-",
      ID : "ENSG00000108825.18",
      gene_id : "ENSG00000108825.18",
      gene_type : "protein_coding",
      gene_name : "PTGES3L-AARSD1",
      gene_level : 1,
      hgnc_id : "HGNC:43946",
      havana_gene : "OTTHUMG00000180905.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42968088,
      stop : 42980433,
      direction : "-",
      ID : "ENSG00000267060.7",
      gene_id : "ENSG00000267060.7",
      gene_type : "protein_coding",
      gene_name : "PTGES3L",
      gene_level : 2,
      hgnc_id : "HGNC:43943",
      havana_gene : "OTTHUMG00000180906.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42980565,
      stop : 42993690,
      direction : "+",
      ID : "ENSG00000198863.7",
      gene_id : "ENSG00000198863.7",
      gene_type : "protein_coding",
      gene_name : "RUNDC1",
      gene_level : 1,
      hgnc_id : "HGNC:25418",
      havana_gene : "OTTHUMG00000180659.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 42998273,
      stop : 43002959,
      direction : "+",
      ID : "ENSG00000131469.15",
      gene_id : "ENSG00000131469.15",
      gene_type : "protein_coding",
      gene_name : "RPL27",
      gene_level : 2,
      hgnc_id : "HGNC:10328",
      havana_gene : "OTTHUMG00000180660.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43006740,
      stop : 43014456,
      direction : "+",
      ID : "ENSG00000068079.8",
      gene_id : "ENSG00000068079.8",
      gene_type : "protein_coding",
      gene_name : "IFI35",
      gene_level : 2,
      hgnc_id : "HGNC:5399",
      havana_gene : "OTTHUMG00000167720.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43014607,
      stop : 43025123,
      direction : "-",
      ID : "ENSG00000108828.16",
      gene_id : "ENSG00000108828.16",
      gene_type : "protein_coding",
      gene_name : "VAT1",
      gene_level : 1,
      hgnc_id : "HGNC:16919",
      havana_gene : "OTTHUMG00000180816.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43025231,
      stop : 43032041,
      direction : "+",
      ID : "ENSG00000108830.10",
      gene_id : "ENSG00000108830.10",
      gene_type : "protein_coding",
      gene_name : "RND2",
      gene_level : 2,
      hgnc_id : "HGNC:18315",
      havana_gene : "OTTHUMG00000180817.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43044295,
      stop : 43170245,
      direction : "-",
      ID : "ENSG00000012048.23",
      gene_id : "ENSG00000012048.23",
      gene_type : "protein_coding",
      gene_name : "BRCA1",
      gene_level : 2,
      hgnc_id : "HGNC:1100",
      havana_gene : "OTTHUMG00000157426.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43170481,
      stop : 43211689,
      direction : "+",
      ID : "ENSG00000188554.15",
      gene_id : "ENSG00000188554.15",
      gene_type : "protein_coding",
      gene_name : "NBR1",
      gene_level : 1,
      hgnc_id : "HGNC:6746",
      havana_gene : "OTTHUMG00000180878.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43211835,
      stop : 43220041,
      direction : "+",
      ID : "ENSG00000184988.8",
      gene_id : "ENSG00000184988.8",
      gene_type : "protein_coding",
      gene_name : "TMEM106A",
      gene_level : 2,
      hgnc_id : "HGNC:28288",
      havana_gene : "OTTHUMG00000180879.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43216941,
      stop : 43305397,
      direction : "-",
      ID : "ENSG00000236383.8",
      gene_id : "ENSG00000236383.8",
      gene_type : "protein_coding",
      gene_name : "CCDC200",
      gene_level : 2,
      hgnc_id : "HGNC:43658",
      havana_gene : "OTTHUMG00000132641.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43398993,
      stop : 43401137,
      direction : "+",
      ID : "ENSG00000175906.5",
      gene_id : "ENSG00000175906.5",
      gene_type : "protein_coding",
      gene_name : "ARL4D",
      gene_level : 2,
      hgnc_id : "HGNC:656",
      havana_gene : "OTTHUMG00000180881.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43483865,
      stop : 43610338,
      direction : "+",
      ID : "ENSG00000067596.12",
      gene_id : "ENSG00000067596.12",
      gene_type : "protein_coding",
      gene_name : "DHX8",
      gene_level : 1,
      hgnc_id : "HGNC:2749",
      havana_gene : "OTTHUMG00000180883.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43527844,
      stop : 43579620,
      direction : "-",
      ID : "ENSG00000175832.13",
      gene_id : "ENSG00000175832.13",
      gene_type : "protein_coding",
      gene_name : "ETV4",
      gene_level : 1,
      hgnc_id : "HGNC:3493",
      havana_gene : "OTTHUMG00000180884.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43640389,
      stop : 43661922,
      direction : "-",
      ID : "ENSG00000005102.14",
      gene_id : "ENSG00000005102.14",
      gene_type : "protein_coding",
      gene_name : "MEOX1",
      gene_level : 2,
      hgnc_id : "HGNC:7013",
      havana_gene : "OTTHUMG00000170513.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43753738,
      stop : 43758791,
      direction : "-",
      ID : "ENSG00000167941.3",
      gene_id : "ENSG00000167941.3",
      gene_type : "protein_coding",
      gene_name : "SOST",
      gene_level : 2,
      hgnc_id : "HGNC:13771",
      havana_gene : "OTTHUMG00000180888.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43766125,
      stop : 43778977,
      direction : "-",
      ID : "ENSG00000108861.9",
      gene_id : "ENSG00000108861.9",
      gene_type : "protein_coding",
      gene_name : "DUSP3",
      gene_level : 1,
      hgnc_id : "HGNC:3069",
      havana_gene : "OTTHUMG00000180889.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43780435,
      stop : 43787620,
      direction : "+",
      ID : "ENSG00000231256.8",
      gene_id : "ENSG00000231256.8",
      gene_type : "protein_coding",
      gene_name : "CFAP97D1",
      gene_level : 2,
      hgnc_id : "HGNC:37241",
      havana_gene : "OTTHUMG00000180890.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43800799,
      stop : 43833170,
      direction : "-",
      ID : "ENSG00000161647.19",
      gene_id : "ENSG00000161647.19",
      gene_type : "protein_coding",
      gene_name : "MPP3",
      gene_level : 2,
      hgnc_id : "HGNC:7221",
      havana_gene : "OTTHUMG00000133838.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43847148,
      stop : 43863639,
      direction : "+",
      ID : "ENSG00000161649.13",
      gene_id : "ENSG00000161649.13",
      gene_type : "protein_coding",
      gene_name : "CD300LG",
      gene_level : 2,
      hgnc_id : "HGNC:30455",
      havana_gene : "OTTHUMG00000181796.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43875357,
      stop : 43909711,
      direction : "-",
      ID : "ENSG00000108852.15",
      gene_id : "ENSG00000108852.15",
      gene_type : "protein_coding",
      gene_name : "MPP2",
      gene_level : 1,
      hgnc_id : "HGNC:7220",
      havana_gene : "OTTHUMG00000133840.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43940804,
      stop : 43942476,
      direction : "-",
      ID : "ENSG00000108849.8",
      gene_id : "ENSG00000108849.8",
      gene_type : "protein_coding",
      gene_name : "PPY",
      gene_level : 1,
      hgnc_id : "HGNC:9327",
      havana_gene : "OTTHUMG00000181800.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 43952738,
      stop : 44004469,
      direction : "-",
      ID : "ENSG00000131096.10",
      gene_id : "ENSG00000131096.10",
      gene_type : "protein_coding",
      gene_name : "PYY",
      gene_level : 2,
      hgnc_id : "HGNC:9748",
      havana_gene : "OTTHUMG00000181801.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44004622,
      stop : 44009068,
      direction : "+",
      ID : "ENSG00000161653.11",
      gene_id : "ENSG00000161653.11",
      gene_type : "protein_coding",
      gene_name : "NAGS",
      gene_level : 2,
      hgnc_id : "HGNC:17996",
      havana_gene : "OTTHUMG00000181802.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44011188,
      stop : 44023946,
      direction : "-",
      ID : "ENSG00000091947.10",
      gene_id : "ENSG00000091947.10",
      gene_type : "protein_coding",
      gene_name : "TMEM101",
      gene_level : 1,
      hgnc_id : "HGNC:28653",
      havana_gene : "OTTHUMG00000181803.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44034328,
      stop : 44067619,
      direction : "-",
      ID : "ENSG00000161654.10",
      gene_id : "ENSG00000161654.10",
      gene_type : "protein_coding",
      gene_name : "LSM12",
      gene_level : 1,
      hgnc_id : "HGNC:26407",
      havana_gene : "OTTHUMG00000181804.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44070735,
      stop : 44076344,
      direction : "+",
      ID : "ENSG00000141349.9",
      gene_id : "ENSG00000141349.9",
      gene_type : "protein_coding",
      gene_name : "G6PC3",
      gene_level : 2,
      hgnc_id : "HGNC:24861",
      havana_gene : "OTTHUMG00000181805.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44076746,
      stop : 44123702,
      direction : "-",
      ID : "ENSG00000108840.15",
      gene_id : "ENSG00000108840.15",
      gene_type : "protein_coding",
      gene_name : "HDAC5",
      gene_level : 1,
      hgnc_id : "HGNC:14068",
      havana_gene : "OTTHUMG00000181806.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44141906,
      stop : 44162476,
      direction : "+",
      ID : "ENSG00000125319.15",
      gene_id : "ENSG00000125319.15",
      gene_type : "protein_coding",
      gene_name : "HROB",
      gene_level : 1,
      hgnc_id : "HGNC:28460",
      havana_gene : "OTTHUMG00000181808.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44170447,
      stop : 44179084,
      direction : "+",
      ID : "ENSG00000161664.7",
      gene_id : "ENSG00000161664.7",
      gene_type : "protein_coding",
      gene_name : "ASB16",
      gene_level : 2,
      hgnc_id : "HGNC:19768",
      havana_gene : "OTTHUMG00000181809.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44186970,
      stop : 44191929,
      direction : "+",
      ID : "ENSG00000168591.16",
      gene_id : "ENSG00000168591.16",
      gene_type : "protein_coding",
      gene_name : "TMUB2",
      gene_level : 1,
      hgnc_id : "HGNC:28459",
      havana_gene : "OTTHUMG00000181811.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44191805,
      stop : 44200113,
      direction : "-",
      ID : "ENSG00000087152.15",
      gene_id : "ENSG00000087152.15",
      gene_type : "protein_coding",
      gene_name : "ATXN7L3",
      gene_level : 2,
      hgnc_id : "HGNC:25416",
      havana_gene : "OTTHUMG00000181812.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44205033,
      stop : 44221626,
      direction : "-",
      ID : "ENSG00000108312.15",
      gene_id : "ENSG00000108312.15",
      gene_type : "protein_coding",
      gene_name : "UBTF",
      gene_level : 1,
      hgnc_id : "HGNC:12511",
      havana_gene : "OTTHUMG00000167585.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44248390,
      stop : 44268141,
      direction : "-",
      ID : "ENSG00000004939.15",
      gene_id : "ENSG00000004939.15",
      gene_type : "protein_coding",
      gene_name : "SLC4A1",
      gene_level : 2,
      hgnc_id : "HGNC:11027",
      havana_gene : "OTTHUMG00000156843.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44308413,
      stop : 44318670,
      direction : "+",
      ID : "ENSG00000108309.14",
      gene_id : "ENSG00000108309.14",
      gene_type : "protein_coding",
      gene_name : "RUNDC3A",
      gene_level : 2,
      hgnc_id : "HGNC:16984",
      havana_gene : "OTTHUMG00000169259.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44319625,
      stop : 44324870,
      direction : "-",
      ID : "ENSG00000013306.16",
      gene_id : "ENSG00000013306.16",
      gene_type : "protein_coding",
      gene_name : "SLC25A39",
      gene_level : 1,
      hgnc_id : "HGNC:24279",
      havana_gene : "OTTHUMG00000132628.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44345246,
      stop : 44353106,
      direction : "+",
      ID : "ENSG00000030582.18",
      gene_id : "ENSG00000030582.18",
      gene_type : "protein_coding",
      gene_name : "GRN",
      gene_level : 1,
      hgnc_id : "HGNC:4601",
      havana_gene : "OTTHUMG00000181816.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44353215,
      stop : 44363853,
      direction : "-",
      ID : "ENSG00000161682.15",
      gene_id : "ENSG00000161682.15",
      gene_type : "protein_coding",
      gene_name : "FAM171A2",
      gene_level : 2,
      hgnc_id : "HGNC:30480",
      havana_gene : "OTTHUMG00000132421.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44372180,
      stop : 44389649,
      direction : "-",
      ID : "ENSG00000005961.19",
      gene_id : "ENSG00000005961.19",
      gene_type : "protein_coding",
      gene_name : "ITGA2B",
      gene_level : 2,
      hgnc_id : "HGNC:6138",
      havana_gene : "OTTHUMG00000177935.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44395281,
      stop : 44503430,
      direction : "-",
      ID : "ENSG00000186566.13",
      gene_id : "ENSG00000186566.13",
      gene_type : "protein_coding",
      gene_name : "GPATCH8",
      gene_level : 2,
      hgnc_id : "HGNC:29066",
      havana_gene : "OTTHUMG00000181818.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44557484,
      stop : 44561262,
      direction : "+",
      ID : "ENSG00000180340.7",
      gene_id : "ENSG00000180340.7",
      gene_type : "protein_coding",
      gene_name : "FZD2",
      gene_level : 2,
      hgnc_id : "HGNC:4040",
      havana_gene : "OTTHUMG00000181819.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44656404,
      stop : 44690308,
      direction : "+",
      ID : "ENSG00000180336.18",
      gene_id : "ENSG00000180336.18",
      gene_type : "protein_coding",
      gene_name : "MEIOC",
      gene_level : 1,
      hgnc_id : "HGNC:26670",
      havana_gene : "OTTHUMG00000153039.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44673069,
      stop : 44689779,
      direction : "-",
      ID : "ENSG00000180329.14",
      gene_id : "ENSG00000180329.14",
      gene_type : "protein_coding",
      gene_name : "CCDC43",
      gene_level : 1,
      hgnc_id : "HGNC:26472",
      havana_gene : "OTTHUMG00000181822.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44708608,
      stop : 44752264,
      direction : "+",
      ID : "ENSG00000161692.18",
      gene_id : "ENSG00000161692.18",
      gene_type : "protein_coding",
      gene_name : "DBF4B",
      gene_level : 2,
      hgnc_id : "HGNC:17883",
      havana_gene : "OTTHUMG00000165717.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44758988,
      stop : 44781846,
      direction : "+",
      ID : "ENSG00000073670.14",
      gene_id : "ENSG00000073670.14",
      gene_type : "protein_coding",
      gene_name : "ADAM11",
      gene_level : 2,
      hgnc_id : "HGNC:189",
      havana_gene : "OTTHUMG00000179038.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44798448,
      stop : 44830816,
      direction : "-",
      ID : "ENSG00000182963.11",
      gene_id : "ENSG00000182963.11",
      gene_type : "protein_coding",
      gene_name : "GJC1",
      gene_level : 1,
      hgnc_id : "HGNC:4280",
      havana_gene : "OTTHUMG00000179861.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44846353,
      stop : 44850476,
      direction : "+",
      ID : "ENSG00000131097.7",
      gene_id : "ENSG00000131097.7",
      gene_type : "protein_coding",
      gene_name : "HIGD1B",
      gene_level : 1,
      hgnc_id : "HGNC:24318",
      havana_gene : "OTTHUMG00000179864.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44849948,
      stop : 44899445,
      direction : "-",
      ID : "ENSG00000108883.13",
      gene_id : "ENSG00000108883.13",
      gene_type : "protein_coding",
      gene_name : "EFTUD2",
      gene_level : 2,
      hgnc_id : "HGNC:30858",
      havana_gene : "OTTHUMG00000179865.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44899142,
      stop : 44905390,
      direction : "+",
      ID : "ENSG00000167131.17",
      gene_id : "ENSG00000167131.17",
      gene_type : "protein_coding",
      gene_name : "CCDC103",
      gene_level : 1,
      hgnc_id : "HGNC:32700",
      havana_gene : "OTTHUMG00000154264.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44899712,
      stop : 44905390,
      direction : "+",
      ID : "ENSG00000214447.4",
      gene_id : "ENSG00000214447.4",
      gene_type : "protein_coding",
      gene_name : "FAM187A",
      gene_level : 2,
      hgnc_id : "HGNC:35153",
      havana_gene : "OTTHUMG00000154266.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44903159,
      stop : 44916937,
      direction : "-",
      ID : "ENSG00000131095.13",
      gene_id : "ENSG00000131095.13",
      gene_type : "protein_coding",
      gene_name : "GFAP",
      gene_level : 1,
      hgnc_id : "HGNC:4235",
      havana_gene : "OTTHUMG00000179866.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44924709,
      stop : 44947773,
      direction : "-",
      ID : "ENSG00000186185.14",
      gene_id : "ENSG00000186185.14",
      gene_type : "protein_coding",
      gene_name : "KIF18B",
      gene_level : 1,
      hgnc_id : "HGNC:27102",
      havana_gene : "OTTHUMG00000179867.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44957992,
      stop : 45109016,
      direction : "+",
      ID : "ENSG00000136448.13",
      gene_id : "ENSG00000136448.13",
      gene_type : "protein_coding",
      gene_name : "NMT1",
      gene_level : 1,
      hgnc_id : "HGNC:7857",
      havana_gene : "OTTHUMG00000180003.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 44959693,
      stop : 44968303,
      direction : "-",
      ID : "ENSG00000131094.4",
      gene_id : "ENSG00000131094.4",
      gene_type : "protein_coding",
      gene_name : "C1QL1",
      gene_level : 2,
      hgnc_id : "HGNC:24182",
      havana_gene : "OTTHUMG00000162944.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45023340,
      stop : 45061109,
      direction : "-",
      ID : "ENSG00000172992.12",
      gene_id : "ENSG00000172992.12",
      gene_type : "protein_coding",
      gene_name : "DCAKD",
      gene_level : 2,
      hgnc_id : "HGNC:26238",
      havana_gene : "OTTHUMG00000179947.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45108959,
      stop : 45133354,
      direction : "-",
      ID : "ENSG00000161714.12",
      gene_id : "ENSG00000161714.12",
      gene_type : "protein_coding",
      gene_name : "PLCD3",
      gene_level : 1,
      hgnc_id : "HGNC:9061",
      havana_gene : "OTTHUMG00000168029.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45132600,
      stop : 45144181,
      direction : "+",
      ID : "ENSG00000181513.15",
      gene_id : "ENSG00000181513.15",
      gene_type : "protein_coding",
      gene_name : "ACBD4",
      gene_level : 2,
      hgnc_id : "HGNC:23337",
      havana_gene : "OTTHUMG00000180111.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45148475,
      stop : 45152099,
      direction : "+",
      ID : "ENSG00000186834.4",
      gene_id : "ENSG00000186834.4",
      gene_type : "protein_coding",
      gene_name : "HEXIM1",
      gene_level : 2,
      hgnc_id : "HGNC:24953",
      havana_gene : "OTTHUMG00000180112.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45160700,
      stop : 45170040,
      direction : "+",
      ID : "ENSG00000168517.10",
      gene_id : "ENSG00000168517.10",
      gene_type : "protein_coding",
      gene_name : "HEXIM2",
      gene_level : 1,
      hgnc_id : "HGNC:28591",
      havana_gene : "OTTHUMG00000180193.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45221444,
      stop : 45247319,
      direction : "+",
      ID : "ENSG00000184922.14",
      gene_id : "ENSG00000184922.14",
      gene_type : "protein_coding",
      gene_name : "FMNL1",
      gene_level : 2,
      hgnc_id : "HGNC:1212",
      havana_gene : "OTTHUMG00000180196.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45254393,
      stop : 45262094,
      direction : "-",
      ID : "ENSG00000184361.13",
      gene_id : "ENSG00000184361.13",
      gene_type : "protein_coding",
      gene_name : "SPATA32",
      gene_level : 2,
      hgnc_id : "HGNC:26349",
      havana_gene : "OTTHUMG00000180363.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45263119,
      stop : 45317029,
      direction : "-",
      ID : "ENSG00000006062.18",
      gene_id : "ENSG00000006062.18",
      gene_type : "protein_coding",
      gene_name : "MAP3K14",
      gene_level : 2,
      hgnc_id : "HGNC:6853",
      havana_gene : "OTTHUMG00000180364.13",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45393902,
      stop : 45434421,
      direction : "-",
      ID : "ENSG00000159314.11",
      gene_id : "ENSG00000159314.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP27",
      gene_level : 1,
      hgnc_id : "HGNC:31813",
      havana_gene : "OTTHUMG00000166982.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45435900,
      stop : 45490749,
      direction : "-",
      ID : "ENSG00000225190.11",
      gene_id : "ENSG00000225190.11",
      gene_type : "protein_coding",
      gene_name : "PLEKHM1",
      gene_level : 2,
      hgnc_id : "HGNC:29017",
      havana_gene : "OTTHUMG00000179074.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45620344,
      stop : 45835826,
      direction : "+",
      ID : "ENSG00000263715.7",
      gene_id : "ENSG00000263715.7",
      gene_type : "protein_coding",
      gene_name : "LINC02210-CRHR1",
      gene_level : 2,
      hgnc_id : "HGNC:51483",
      havana_gene : "OTTHUMG00000178270.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45784280,
      stop : 45835828,
      direction : "+",
      ID : "ENSG00000120088.15",
      gene_id : "ENSG00000120088.15",
      gene_type : "protein_coding",
      gene_name : "CRHR1",
      gene_level : 2,
      hgnc_id : "HGNC:2357",
      havana_gene : "OTTHUMG00000178271.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45844881,
      stop : 45847067,
      direction : "+",
      ID : "ENSG00000185294.7",
      gene_id : "ENSG00000185294.7",
      gene_type : "protein_coding",
      gene_name : "SPPL2C",
      gene_level : 2,
      hgnc_id : "HGNC:28902",
      havana_gene : "OTTHUMG00000178247.2",
      tag : "retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45894527,
      stop : 46028334,
      direction : "+",
      ID : "ENSG00000186868.17",
      gene_id : "ENSG00000186868.17",
      gene_type : "protein_coding",
      gene_name : "MAPT",
      gene_level : 2,
      hgnc_id : "HGNC:6893",
      havana_gene : "OTTHUMG00000168833.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 45999250,
      stop : 45999694,
      direction : "+",
      ID : "ENSG00000256762.1",
      gene_id : "ENSG00000256762.1",
      gene_type : "protein_coding",
      gene_name : "STH",
      gene_level : 2,
      hgnc_id : "HGNC:18839",
      havana_gene : "OTTHUMG00000168633.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46029916,
      stop : 46225389,
      direction : "-",
      ID : "ENSG00000120071.15",
      gene_id : "ENSG00000120071.15",
      gene_type : "protein_coding",
      gene_name : "KANSL1",
      gene_level : 1,
      hgnc_id : "HGNC:24565",
      havana_gene : "OTTHUMG00000178026.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46274784,
      stop : 46361797,
      direction : "-",
      ID : "ENSG00000228696.10",
      gene_id : "ENSG00000228696.10",
      gene_type : "protein_coding",
      gene_name : "ARL17B",
      gene_level : 2,
      hgnc_id : "HGNC:32387",
      havana_gene : "OTTHUMG00000178031.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46292733,
      stop : 46337794,
      direction : "+",
      ID : "ENSG00000176681.14",
      gene_id : "ENSG00000176681.14",
      gene_type : "protein_coding",
      gene_name : "LRRC37A",
      gene_level : 2,
      hgnc_id : "HGNC:29069",
      havana_gene : "OTTHUMG00000149841.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46511511,
      stop : 46555650,
      direction : "+",
      ID : "ENSG00000238083.8",
      gene_id : "ENSG00000238083.8",
      gene_type : "protein_coding",
      gene_name : "LRRC37A2",
      gene_level : 2,
      hgnc_id : "HGNC:32404",
      havana_gene : "OTTHUMG00000178032.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46516702,
      stop : 46579691,
      direction : "-",
      ID : "ENSG00000185829.18",
      gene_id : "ENSG00000185829.18",
      gene_type : "protein_coding",
      gene_name : "ARL17A",
      gene_level : 2,
      hgnc_id : "HGNC:24096",
      havana_gene : "OTTHUMG00000132817.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46590669,
      stop : 46757464,
      direction : "+",
      ID : "ENSG00000073969.18",
      gene_id : "ENSG00000073969.18",
      gene_type : "protein_coding",
      gene_name : "NSF",
      gene_level : 2,
      hgnc_id : "HGNC:8016",
      havana_gene : "OTTHUMG00000134315.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46762506,
      stop : 46833154,
      direction : "-",
      ID : "ENSG00000108379.10",
      gene_id : "ENSG00000108379.10",
      gene_type : "protein_coding",
      gene_name : "WNT3",
      gene_level : 2,
      hgnc_id : "HGNC:12782",
      havana_gene : "OTTHUMG00000178076.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46833201,
      stop : 46886730,
      direction : "+",
      ID : "ENSG00000158955.11",
      gene_id : "ENSG00000158955.11",
      gene_type : "protein_coding",
      gene_name : "WNT9B",
      gene_level : 2,
      hgnc_id : "HGNC:12779",
      havana_gene : "OTTHUMG00000178077.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46923075,
      stop : 46975524,
      direction : "+",
      ID : "ENSG00000108433.17",
      gene_id : "ENSG00000108433.17",
      gene_type : "protein_coding",
      gene_name : "GOSR2",
      gene_level : 2,
      hgnc_id : "HGNC:4431",
      havana_gene : "OTTHUMG00000178080.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46923133,
      stop : 47049932,
      direction : "+",
      ID : "ENSG00000262633.2",
      gene_id : "ENSG00000262633.2",
      gene_type : "protein_coding",
      gene_name : "AC005670.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000178081.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 46978156,
      stop : 46979253,
      direction : "-",
      ID : "ENSG00000179673.5",
      gene_id : "ENSG00000179673.5",
      gene_type : "protein_coding",
      gene_name : "RPRML",
      gene_level : 2,
      hgnc_id : "HGNC:32422",
      havana_gene : "OTTHUMG00000178187.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47117703,
      stop : 47189422,
      direction : "-",
      ID : "ENSG00000004897.12",
      gene_id : "ENSG00000004897.12",
      gene_type : "protein_coding",
      gene_name : "CDC27",
      gene_level : 2,
      hgnc_id : "HGNC:1728",
      havana_gene : "OTTHUMG00000166429.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47200446,
      stop : 47223679,
      direction : "+",
      ID : "ENSG00000198336.9",
      gene_id : "ENSG00000198336.9",
      gene_type : "protein_coding",
      gene_name : "MYL4",
      gene_level : 1,
      hgnc_id : "HGNC:7585",
      havana_gene : "OTTHUMG00000178232.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47253827,
      stop : 47313743,
      direction : "+",
      ID : "ENSG00000259207.9",
      gene_id : "ENSG00000259207.9",
      gene_type : "protein_coding",
      gene_name : "ITGB3",
      gene_level : 2,
      hgnc_id : "HGNC:6156",
      havana_gene : "OTTHUMG00000171956.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47253897,
      stop : 47344292,
      direction : "+",
      ID : "ENSG00000259753.1",
      gene_id : "ENSG00000259753.1",
      gene_type : "protein_coding",
      gene_name : "AC068234.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171957.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47323290,
      stop : 47441312,
      direction : "+",
      ID : "ENSG00000178852.16",
      gene_id : "ENSG00000178852.16",
      gene_type : "protein_coding",
      gene_name : "EFCAB13",
      gene_level : 1,
      hgnc_id : "HGNC:26864",
      havana_gene : "OTTHUMG00000164767.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47522942,
      stop : 47624665,
      direction : "+",
      ID : "ENSG00000141279.17",
      gene_id : "ENSG00000141279.17",
      gene_type : "protein_coding",
      gene_name : "NPEPPS",
      gene_level : 2,
      hgnc_id : "HGNC:7900",
      havana_gene : "OTTHUMG00000165471.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47649476,
      stop : 47685505,
      direction : "+",
      ID : "ENSG00000108424.11",
      gene_id : "ENSG00000108424.11",
      gene_type : "protein_coding",
      gene_name : "KPNB1",
      gene_level : 1,
      hgnc_id : "HGNC:6400",
      havana_gene : "OTTHUMG00000036957.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47694081,
      stop : 47712050,
      direction : "+",
      ID : "ENSG00000198933.9",
      gene_id : "ENSG00000198933.9",
      gene_type : "protein_coding",
      gene_name : "TBKBP1",
      gene_level : 2,
      hgnc_id : "HGNC:30140",
      havana_gene : "OTTHUMG00000178286.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47733236,
      stop : 47746122,
      direction : "+",
      ID : "ENSG00000073861.3",
      gene_id : "ENSG00000073861.3",
      gene_type : "protein_coding",
      gene_name : "TBX21",
      gene_level : 2,
      hgnc_id : "HGNC:11599",
      havana_gene : "OTTHUMG00000178287.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47807372,
      stop : 47821834,
      direction : "-",
      ID : "ENSG00000006025.12",
      gene_id : "ENSG00000006025.12",
      gene_type : "protein_coding",
      gene_name : "OSBPL7",
      gene_level : 2,
      hgnc_id : "HGNC:16387",
      havana_gene : "OTTHUMG00000178288.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47823272,
      stop : 47831541,
      direction : "-",
      ID : "ENSG00000159111.13",
      gene_id : "ENSG00000159111.13",
      gene_type : "protein_coding",
      gene_name : "MRPL10",
      gene_level : 2,
      hgnc_id : "HGNC:14055",
      havana_gene : "OTTHUMG00000156302.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47831634,
      stop : 47837719,
      direction : "+",
      ID : "ENSG00000141294.10",
      gene_id : "ENSG00000141294.10",
      gene_type : "protein_coding",
      gene_name : "LRRC46",
      gene_level : 2,
      hgnc_id : "HGNC:25047",
      havana_gene : "OTTHUMG00000178289.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47837692,
      stop : 47841289,
      direction : "-",
      ID : "ENSG00000141295.14",
      gene_id : "ENSG00000141295.14",
      gene_type : "protein_coding",
      gene_name : "SCRN2",
      gene_level : 1,
      hgnc_id : "HGNC:30381",
      havana_gene : "OTTHUMG00000178290.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47844908,
      stop : 47855874,
      direction : "-",
      ID : "ENSG00000189120.5",
      gene_id : "ENSG00000189120.5",
      gene_type : "protein_coding",
      gene_name : "SP6",
      gene_level : 2,
      hgnc_id : "HGNC:14530",
      havana_gene : "OTTHUMG00000132067.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47896150,
      stop : 47928957,
      direction : "+",
      ID : "ENSG00000167182.15",
      gene_id : "ENSG00000167182.15",
      gene_type : "protein_coding",
      gene_name : "SP2",
      gene_level : 2,
      hgnc_id : "HGNC:11207",
      havana_gene : "OTTHUMG00000150196.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47941506,
      stop : 47949308,
      direction : "+",
      ID : "ENSG00000108439.11",
      gene_id : "ENSG00000108439.11",
      gene_type : "protein_coding",
      gene_name : "PNPO",
      gene_level : 1,
      hgnc_id : "HGNC:30260",
      havana_gene : "OTTHUMG00000178295.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47951967,
      stop : 47957883,
      direction : "-",
      ID : "ENSG00000167183.3",
      gene_id : "ENSG00000167183.3",
      gene_type : "protein_coding",
      gene_name : "PRR15L",
      gene_level : 2,
      hgnc_id : "HGNC:28149",
      havana_gene : "OTTHUMG00000178297.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 47967810,
      stop : 47981781,
      direction : "+",
      ID : "ENSG00000108465.15",
      gene_id : "ENSG00000108465.15",
      gene_type : "protein_coding",
      gene_name : "CDK5RAP3",
      gene_level : 1,
      hgnc_id : "HGNC:18673",
      havana_gene : "OTTHUMG00000178682.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48026167,
      stop : 48038030,
      direction : "-",
      ID : "ENSG00000005243.10",
      gene_id : "ENSG00000005243.10",
      gene_type : "protein_coding",
      gene_name : "COPZ2",
      gene_level : 2,
      hgnc_id : "HGNC:19356",
      havana_gene : "OTTHUMG00000178684.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48048329,
      stop : 48061545,
      direction : "+",
      ID : "ENSG00000082641.16",
      gene_id : "ENSG00000082641.16",
      gene_type : "protein_coding",
      gene_name : "NFE2L1",
      gene_level : 1,
      hgnc_id : "HGNC:7781",
      havana_gene : "OTTHUMG00000178706.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48070052,
      stop : 48101478,
      direction : "-",
      ID : "ENSG00000108468.15",
      gene_id : "ENSG00000108468.15",
      gene_type : "protein_coding",
      gene_name : "CBX1",
      gene_level : 2,
      hgnc_id : "HGNC:1551",
      havana_gene : "OTTHUMG00000150417.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48103357,
      stop : 48123601,
      direction : "+",
      ID : "ENSG00000002919.15",
      gene_id : "ENSG00000002919.15",
      gene_type : "protein_coding",
      gene_name : "SNX11",
      gene_level : 2,
      hgnc_id : "HGNC:14975",
      havana_gene : "OTTHUMG00000178822.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48133442,
      stop : 48430275,
      direction : "-",
      ID : "ENSG00000141293.16",
      gene_id : "ENSG00000141293.16",
      gene_type : "protein_coding",
      gene_name : "SKAP1",
      gene_level : 2,
      hgnc_id : "HGNC:15605",
      havana_gene : "OTTHUMG00000178823.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48528526,
      stop : 48531011,
      direction : "-",
      ID : "ENSG00000120094.9",
      gene_id : "ENSG00000120094.9",
      gene_type : "protein_coding",
      gene_name : "HOXB1",
      gene_level : 2,
      hgnc_id : "HGNC:5111",
      havana_gene : "OTTHUMG00000159929.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48540894,
      stop : 48545109,
      direction : "-",
      ID : "ENSG00000173917.11",
      gene_id : "ENSG00000173917.11",
      gene_type : "protein_coding",
      gene_name : "HOXB2",
      gene_level : 2,
      hgnc_id : "HGNC:5113",
      havana_gene : "OTTHUMG00000159930.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48548870,
      stop : 48604912,
      direction : "-",
      ID : "ENSG00000120093.12",
      gene_id : "ENSG00000120093.12",
      gene_type : "protein_coding",
      gene_name : "HOXB3",
      gene_level : 1,
      hgnc_id : "HGNC:5114",
      havana_gene : "OTTHUMG00000159922.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48575507,
      stop : 48578350,
      direction : "-",
      ID : "ENSG00000182742.6",
      gene_id : "ENSG00000182742.6",
      gene_type : "protein_coding",
      gene_name : "HOXB4",
      gene_level : 2,
      hgnc_id : "HGNC:5115",
      havana_gene : "OTTHUMG00000159920.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48591257,
      stop : 48593779,
      direction : "-",
      ID : "ENSG00000120075.6",
      gene_id : "ENSG00000120075.6",
      gene_type : "protein_coding",
      gene_name : "HOXB5",
      gene_level : 2,
      hgnc_id : "HGNC:5116",
      havana_gene : "OTTHUMG00000159913.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48595751,
      stop : 48604992,
      direction : "-",
      ID : "ENSG00000108511.10",
      gene_id : "ENSG00000108511.10",
      gene_type : "protein_coding",
      gene_name : "HOXB6",
      gene_level : 2,
      hgnc_id : "HGNC:5117",
      havana_gene : "OTTHUMG00000159912.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48607232,
      stop : 48633572,
      direction : "-",
      ID : "ENSG00000260027.5",
      gene_id : "ENSG00000260027.5",
      gene_type : "protein_coding",
      gene_name : "HOXB7",
      gene_level : 2,
      hgnc_id : "HGNC:5118",
      havana_gene : "OTTHUMG00000170231.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48611377,
      stop : 48615292,
      direction : "-",
      ID : "ENSG00000120068.7",
      gene_id : "ENSG00000120068.7",
      gene_type : "protein_coding",
      gene_name : "HOXB8",
      gene_level : 2,
      hgnc_id : "HGNC:5119",
      havana_gene : "OTTHUMG00000159904.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48621156,
      stop : 48626358,
      direction : "-",
      ID : "ENSG00000170689.10",
      gene_id : "ENSG00000170689.10",
      gene_type : "protein_coding",
      gene_name : "HOXB9",
      gene_level : 1,
      hgnc_id : "HGNC:5120",
      havana_gene : "OTTHUMG00000159907.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48721719,
      stop : 48722518,
      direction : "-",
      ID : "ENSG00000159182.5",
      gene_id : "ENSG00000159182.5",
      gene_type : "protein_coding",
      gene_name : "PRAC1",
      gene_level : 2,
      hgnc_id : "HGNC:30591",
      havana_gene : "OTTHUMG00000159899.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48723185,
      stop : 48724758,
      direction : "+",
      ID : "ENSG00000229637.4",
      gene_id : "ENSG00000229637.4",
      gene_type : "protein_coding",
      gene_name : "PRAC2",
      gene_level : 2,
      hgnc_id : "HGNC:30143",
      havana_gene : "OTTHUMG00000132085.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48724763,
      stop : 48728750,
      direction : "-",
      ID : "ENSG00000159184.8",
      gene_id : "ENSG00000159184.8",
      gene_type : "protein_coding",
      gene_name : "HOXB13",
      gene_level : 2,
      hgnc_id : "HGNC:5112",
      havana_gene : "OTTHUMG00000159900.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48762235,
      stop : 48817214,
      direction : "-",
      ID : "ENSG00000170703.15",
      gene_id : "ENSG00000170703.15",
      gene_type : "protein_coding",
      gene_name : "TTLL6",
      gene_level : 2,
      hgnc_id : "HGNC:26664",
      havana_gene : "OTTHUMG00000156978.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48831018,
      stop : 48866522,
      direction : "+",
      ID : "ENSG00000136436.15",
      gene_id : "ENSG00000136436.15",
      gene_type : "protein_coding",
      gene_name : "CALCOCO2",
      gene_level : 1,
      hgnc_id : "HGNC:29912",
      havana_gene : "OTTHUMG00000160505.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48892765,
      stop : 48895871,
      direction : "+",
      ID : "ENSG00000159199.14",
      gene_id : "ENSG00000159199.14",
      gene_type : "protein_coding",
      gene_name : "ATP5MC1",
      gene_level : 2,
      hgnc_id : "HGNC:841",
      havana_gene : "OTTHUMG00000160520.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48908407,
      stop : 48929056,
      direction : "+",
      ID : "ENSG00000159202.18",
      gene_id : "ENSG00000159202.18",
      gene_type : "protein_coding",
      gene_name : "UBE2Z",
      gene_level : 2,
      hgnc_id : "HGNC:25847",
      havana_gene : "OTTHUMG00000150521.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48929316,
      stop : 48944842,
      direction : "-",
      ID : "ENSG00000159210.10",
      gene_id : "ENSG00000159210.10",
      gene_type : "protein_coding",
      gene_name : "SNF8",
      gene_level : 2,
      hgnc_id : "HGNC:17028",
      havana_gene : "OTTHUMG00000160569.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48958554,
      stop : 48968596,
      direction : "-",
      ID : "ENSG00000159224.4",
      gene_id : "ENSG00000159224.4",
      gene_type : "protein_coding",
      gene_name : "GIP",
      gene_level : 2,
      hgnc_id : "HGNC:4270",
      havana_gene : "OTTHUMG00000161171.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 48997385,
      stop : 49056145,
      direction : "+",
      ID : "ENSG00000159217.10",
      gene_id : "ENSG00000159217.10",
      gene_type : "protein_coding",
      gene_name : "IGF2BP1",
      gene_level : 2,
      hgnc_id : "HGNC:28866",
      havana_gene : "OTTHUMG00000161173.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49132460,
      stop : 49176840,
      direction : "+",
      ID : "ENSG00000167080.9",
      gene_id : "ENSG00000167080.9",
      gene_type : "protein_coding",
      gene_name : "B4GALNT2",
      gene_level : 2,
      hgnc_id : "HGNC:24136",
      havana_gene : "OTTHUMG00000161307.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49202791,
      stop : 49210574,
      direction : "-",
      ID : "ENSG00000167083.7",
      gene_id : "ENSG00000167083.7",
      gene_type : "protein_coding",
      gene_name : "GNGT2",
      gene_level : 2,
      hgnc_id : "HGNC:4412",
      havana_gene : "OTTHUMG00000161308.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49210411,
      stop : 49223225,
      direction : "+",
      ID : "ENSG00000108798.9",
      gene_id : "ENSG00000108798.9",
      gene_type : "protein_coding",
      gene_name : "ABI3",
      gene_level : 2,
      hgnc_id : "HGNC:29859",
      havana_gene : "OTTHUMG00000161306.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49223366,
      stop : 49230787,
      direction : "-",
      ID : "ENSG00000173868.12",
      gene_id : "ENSG00000173868.12",
      gene_type : "protein_coding",
      gene_name : "PHOSPHO1",
      gene_level : 1,
      hgnc_id : "HGNC:16815",
      havana_gene : "OTTHUMG00000161305.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49289206,
      stop : 49362473,
      direction : "-",
      ID : "ENSG00000198740.9",
      gene_id : "ENSG00000198740.9",
      gene_type : "protein_coding",
      gene_name : "ZNF652",
      gene_level : 2,
      hgnc_id : "HGNC:29147",
      havana_gene : "OTTHUMG00000161322.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49404052,
      stop : 49414901,
      direction : "-",
      ID : "ENSG00000167085.13",
      gene_id : "ENSG00000167085.13",
      gene_type : "protein_coding",
      gene_name : "PHB",
      gene_level : 2,
      hgnc_id : "HGNC:8912",
      havana_gene : "OTTHUMG00000134271.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49495293,
      stop : 49515008,
      direction : "+",
      ID : "ENSG00000064300.9",
      gene_id : "ENSG00000064300.9",
      gene_type : "protein_coding",
      gene_name : "NGFR",
      gene_level : 1,
      hgnc_id : "HGNC:7809",
      havana_gene : "OTTHUMG00000161495.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49575871,
      stop : 49583827,
      direction : "+",
      ID : "ENSG00000182575.8",
      gene_id : "ENSG00000182575.8",
      gene_type : "protein_coding",
      gene_name : "NXPH3",
      gene_level : 1,
      hgnc_id : "HGNC:8077",
      havana_gene : "OTTHUMG00000161491.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49598884,
      stop : 49678163,
      direction : "-",
      ID : "ENSG00000121067.19",
      gene_id : "ENSG00000121067.19",
      gene_type : "protein_coding",
      gene_name : "SPOP",
      gene_level : 2,
      hgnc_id : "HGNC:11254",
      havana_gene : "OTTHUMG00000161496.19",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49700934,
      stop : 49709014,
      direction : "-",
      ID : "ENSG00000121073.15",
      gene_id : "ENSG00000121073.15",
      gene_type : "protein_coding",
      gene_name : "SLC35B1",
      gene_level : 1,
      hgnc_id : "HGNC:20798",
      havana_gene : "OTTHUMG00000161638.13",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49710332,
      stop : 49789180,
      direction : "-",
      ID : "ENSG00000121104.8",
      gene_id : "ENSG00000121104.8",
      gene_type : "protein_coding",
      gene_name : "FAM117A",
      gene_level : 1,
      hgnc_id : "HGNC:24179",
      havana_gene : "OTTHUMG00000161696.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49788648,
      stop : 49835026,
      direction : "+",
      ID : "ENSG00000136504.13",
      gene_id : "ENSG00000136504.13",
      gene_type : "protein_coding",
      gene_name : "KAT7",
      gene_level : 1,
      hgnc_id : "HGNC:17016",
      havana_gene : "OTTHUMG00000161770.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49838309,
      stop : 49848017,
      direction : "-",
      ID : "ENSG00000176358.15",
      gene_id : "ENSG00000176358.15",
      gene_type : "protein_coding",
      gene_name : "TAC4",
      gene_level : 2,
      hgnc_id : "HGNC:16641",
      havana_gene : "OTTHUMG00000161830.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49968970,
      stop : 49974959,
      direction : "+",
      ID : "ENSG00000108813.11",
      gene_id : "ENSG00000108813.11",
      gene_type : "protein_coding",
      gene_name : "DLX4",
      gene_level : 1,
      hgnc_id : "HGNC:2917",
      havana_gene : "OTTHUMG00000161839.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 49990005,
      stop : 49995224,
      direction : "-",
      ID : "ENSG00000064195.7",
      gene_id : "ENSG00000064195.7",
      gene_type : "protein_coding",
      gene_name : "DLX3",
      gene_level : 2,
      hgnc_id : "HGNC:2916",
      havana_gene : "OTTHUMG00000161892.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50055968,
      stop : 50090481,
      direction : "+",
      ID : "ENSG00000005884.18",
      gene_id : "ENSG00000005884.18",
      gene_type : "protein_coding",
      gene_name : "ITGA3",
      gene_level : 2,
      hgnc_id : "HGNC:6139",
      havana_gene : "OTTHUMG00000161890.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50094737,
      stop : 50112152,
      direction : "+",
      ID : "ENSG00000005882.12",
      gene_id : "ENSG00000005882.12",
      gene_type : "protein_coding",
      gene_name : "PDK2",
      gene_level : 1,
      hgnc_id : "HGNC:8810",
      havana_gene : "OTTHUMG00000161948.18",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50110040,
      stop : 50130160,
      direction : "-",
      ID : "ENSG00000167100.15",
      gene_id : "ENSG00000167100.15",
      gene_type : "protein_coding",
      gene_name : "SAMD14",
      gene_level : 2,
      hgnc_id : "HGNC:27312",
      havana_gene : "OTTHUMG00000161992.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50133737,
      stop : 50150677,
      direction : "-",
      ID : "ENSG00000108819.11",
      gene_id : "ENSG00000108819.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R9B",
      gene_level : 2,
      hgnc_id : "HGNC:9298",
      havana_gene : "OTTHUMG00000162008.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50164214,
      stop : 50175928,
      direction : "+",
      ID : "ENSG00000108823.16",
      gene_id : "ENSG00000108823.16",
      gene_type : "protein_coding",
      gene_name : "SGCA",
      gene_level : 1,
      hgnc_id : "HGNC:10805",
      havana_gene : "OTTHUMG00000162024.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50184101,
      stop : 50201632,
      direction : "-",
      ID : "ENSG00000108821.14",
      gene_id : "ENSG00000108821.14",
      gene_type : "protein_coding",
      gene_name : "COL1A1",
      gene_level : 2,
      hgnc_id : "HGNC:2197",
      havana_gene : "OTTHUMG00000148674.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50271406,
      stop : 50281485,
      direction : "+",
      ID : "ENSG00000167105.8",
      gene_id : "ENSG00000167105.8",
      gene_type : "protein_coding",
      gene_name : "TMEM92",
      gene_level : 2,
      hgnc_id : "HGNC:26579",
      havana_gene : "OTTHUMG00000162060.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50346126,
      stop : 50363138,
      direction : "+",
      ID : "ENSG00000015532.10",
      gene_id : "ENSG00000015532.10",
      gene_type : "protein_coding",
      gene_name : "XYLT2",
      gene_level : 2,
      hgnc_id : "HGNC:15517",
      havana_gene : "OTTHUMG00000162057.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50367857,
      stop : 50373207,
      direction : "-",
      ID : "ENSG00000108826.16",
      gene_id : "ENSG00000108826.16",
      gene_type : "protein_coding",
      gene_name : "MRPL27",
      gene_level : 1,
      hgnc_id : "HGNC:14483",
      havana_gene : "OTTHUMG00000162062.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50373220,
      stop : 50381483,
      direction : "+",
      ID : "ENSG00000154920.15",
      gene_id : "ENSG00000154920.15",
      gene_type : "protein_coding",
      gene_name : "EME1",
      gene_level : 1,
      hgnc_id : "HGNC:24965",
      havana_gene : "OTTHUMG00000164974.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50375059,
      stop : 50397523,
      direction : "-",
      ID : "ENSG00000108829.10",
      gene_id : "ENSG00000108829.10",
      gene_type : "protein_coding",
      gene_name : "LRRC59",
      gene_level : 2,
      hgnc_id : "HGNC:28817",
      havana_gene : "OTTHUMG00000162079.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50426158,
      stop : 50474845,
      direction : "+",
      ID : "ENSG00000167107.13",
      gene_id : "ENSG00000167107.13",
      gene_type : "protein_coding",
      gene_name : "ACSF2",
      gene_level : 2,
      hgnc_id : "HGNC:26101",
      havana_gene : "OTTHUMG00000162128.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50464496,
      stop : 50468906,
      direction : "-",
      ID : "ENSG00000136457.10",
      gene_id : "ENSG00000136457.10",
      gene_type : "protein_coding",
      gene_name : "CHAD",
      gene_level : 2,
      hgnc_id : "HGNC:1909",
      havana_gene : "OTTHUMG00000162129.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50478860,
      stop : 50485974,
      direction : "+",
      ID : "ENSG00000136444.10",
      gene_id : "ENSG00000136444.10",
      gene_type : "protein_coding",
      gene_name : "RSAD1",
      gene_level : 1,
      hgnc_id : "HGNC:25634",
      havana_gene : "OTTHUMG00000162126.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50508384,
      stop : 50531501,
      direction : "+",
      ID : "ENSG00000136449.15",
      gene_id : "ENSG00000136449.15",
      gene_type : "protein_coding",
      gene_name : "MYCBPAP",
      gene_level : 1,
      hgnc_id : "HGNC:19677",
      havana_gene : "OTTHUMG00000157184.23",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50532682,
      stop : 50543750,
      direction : "+",
      ID : "ENSG00000049283.18",
      gene_id : "ENSG00000049283.18",
      gene_type : "protein_coding",
      gene_name : "EPN3",
      gene_level : 2,
      hgnc_id : "HGNC:18235",
      havana_gene : "OTTHUMG00000162155.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50543058,
      stop : 50555852,
      direction : "+",
      ID : "ENSG00000006282.21",
      gene_id : "ENSG00000006282.21",
      gene_type : "protein_coding",
      gene_name : "SPATA20",
      gene_level : 2,
      hgnc_id : "HGNC:26125",
      havana_gene : "OTTHUMG00000162162.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50560715,
      stop : 50627474,
      direction : "+",
      ID : "ENSG00000006283.18",
      gene_id : "ENSG00000006283.18",
      gene_type : "protein_coding",
      gene_name : "CACNA1G",
      gene_level : 2,
      hgnc_id : "HGNC:1394",
      havana_gene : "OTTHUMG00000162180.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50634777,
      stop : 50692253,
      direction : "+",
      ID : "ENSG00000108846.16",
      gene_id : "ENSG00000108846.16",
      gene_type : "protein_coding",
      gene_name : "ABCC3",
      gene_level : 1,
      hgnc_id : "HGNC:54",
      havana_gene : "OTTHUMG00000162245.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50693198,
      stop : 50707914,
      direction : "-",
      ID : "ENSG00000154945.7",
      gene_id : "ENSG00000154945.7",
      gene_type : "protein_coding",
      gene_name : "ANKRD40",
      gene_level : 2,
      hgnc_id : "HGNC:28233",
      havana_gene : "OTTHUMG00000162255.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50719565,
      stop : 50756219,
      direction : "+",
      ID : "ENSG00000108848.16",
      gene_id : "ENSG00000108848.16",
      gene_type : "protein_coding",
      gene_name : "LUC7L3",
      gene_level : 1,
      hgnc_id : "HGNC:24309",
      havana_gene : "OTTHUMG00000162257.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50761029,
      stop : 50767557,
      direction : "-",
      ID : "ENSG00000167117.10",
      gene_id : "ENSG00000167117.10",
      gene_type : "protein_coding",
      gene_name : "ANKRD40CL",
      gene_level : 2,
      hgnc_id : "HGNC:26080",
      havana_gene : "OTTHUMG00000132429.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50834650,
      stop : 50842353,
      direction : "+",
      ID : "ENSG00000173714.8",
      gene_id : "ENSG00000173714.8",
      gene_type : "protein_coding",
      gene_name : "WFIKKN2",
      gene_level : 2,
      hgnc_id : "HGNC:30916",
      havana_gene : "OTTHUMG00000162274.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50862223,
      stop : 50867978,
      direction : "-",
      ID : "ENSG00000141232.5",
      gene_id : "ENSG00000141232.5",
      gene_type : "protein_coding",
      gene_name : "TOB1",
      gene_level : 1,
      hgnc_id : "HGNC:11979",
      havana_gene : "OTTHUMG00000162277.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 50962174,
      stop : 51120868,
      direction : "-",
      ID : "ENSG00000008294.21",
      gene_id : "ENSG00000008294.21",
      gene_type : "protein_coding",
      gene_name : "SPAG9",
      gene_level : 1,
      hgnc_id : "HGNC:14524",
      havana_gene : "OTTHUMG00000162316.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 51153559,
      stop : 51162428,
      direction : "+",
      ID : "ENSG00000239672.8",
      gene_id : "ENSG00000239672.8",
      gene_type : "protein_coding",
      gene_name : "NME1",
      gene_level : 2,
      hgnc_id : "HGNC:7849",
      havana_gene : "OTTHUMG00000137474.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 51153590,
      stop : 51171744,
      direction : "+",
      ID : "ENSG00000011052.21",
      gene_id : "ENSG00000011052.21",
      gene_type : "protein_coding",
      gene_name : "NME1-NME2",
      gene_level : 2,
      hgnc_id : "HGNC:33531",
      havana_gene : "OTTHUMG00000137475.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 51165435,
      stop : 51171744,
      direction : "+",
      ID : "ENSG00000243678.12",
      gene_id : "ENSG00000243678.12",
      gene_type : "protein_coding",
      gene_name : "NME2",
      gene_level : 2,
      hgnc_id : "HGNC:7850",
      havana_gene : "OTTHUMG00000154062.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 51177425,
      stop : 51260163,
      direction : "-",
      ID : "ENSG00000011258.16",
      gene_id : "ENSG00000011258.16",
      gene_type : "protein_coding",
      gene_name : "MBTD1",
      gene_level : 1,
      hgnc_id : "HGNC:19866",
      havana_gene : "OTTHUMG00000150442.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 51260546,
      stop : 51297936,
      direction : "+",
      ID : "ENSG00000011260.14",
      gene_id : "ENSG00000011260.14",
      gene_type : "protein_coding",
      gene_name : "UTP18",
      gene_level : 2,
      hgnc_id : "HGNC:24274",
      havana_gene : "OTTHUMG00000162370.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 51630313,
      stop : 52160017,
      direction : "-",
      ID : "ENSG00000154975.14",
      gene_id : "ENSG00000154975.14",
      gene_type : "protein_coding",
      gene_name : "CA10",
      gene_level : 1,
      hgnc_id : "HGNC:1369",
      havana_gene : "OTTHUMG00000177544.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 53822927,
      stop : 53825193,
      direction : "+",
      ID : "ENSG00000141200.8",
      gene_id : "ENSG00000141200.8",
      gene_type : "protein_coding",
      gene_name : "KIF2B",
      gene_level : 2,
      hgnc_id : "HGNC:29443",
      havana_gene : "OTTHUMG00000177756.2",
      tag : "retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 54899387,
      stop : 54961956,
      direction : "+",
      ID : "ENSG00000141198.16",
      gene_id : "ENSG00000141198.16",
      gene_type : "protein_coding",
      gene_name : "TOM1L1",
      gene_level : 1,
      hgnc_id : "HGNC:11983",
      havana_gene : "OTTHUMG00000177816.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 54951902,
      stop : 54968703,
      direction : "-",
      ID : "ENSG00000166260.13",
      gene_id : "ENSG00000166260.13",
      gene_type : "protein_coding",
      gene_name : "COX11",
      gene_level : 1,
      hgnc_id : "HGNC:2261",
      havana_gene : "OTTHUMG00000177838.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 54968727,
      stop : 55173632,
      direction : "+",
      ID : "ENSG00000166263.13",
      gene_id : "ENSG00000166263.13",
      gene_type : "protein_coding",
      gene_name : "STXBP4",
      gene_level : 1,
      hgnc_id : "HGNC:19694",
      havana_gene : "OTTHUMG00000074043.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 55264960,
      stop : 55325187,
      direction : "+",
      ID : "ENSG00000108924.14",
      gene_id : "ENSG00000108924.14",
      gene_type : "protein_coding",
      gene_name : "HLF",
      gene_level : 1,
      hgnc_id : "HGNC:4977",
      havana_gene : "OTTHUMG00000177840.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 55392622,
      stop : 55421924,
      direction : "-",
      ID : "ENSG00000108960.9",
      gene_id : "ENSG00000108960.9",
      gene_type : "protein_coding",
      gene_name : "MMD",
      gene_level : 1,
      hgnc_id : "HGNC:7153",
      havana_gene : "OTTHUMG00000177845.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 55448433,
      stop : 55511444,
      direction : "-",
      ID : "ENSG00000261873.2",
      gene_id : "ENSG00000261873.2",
      gene_type : "protein_coding",
      gene_name : "SMIM36",
      gene_level : 2,
      hgnc_id : "HGNC:53654",
      havana_gene : "OTTHUMG00000177855.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 55719627,
      stop : 55732121,
      direction : "-",
      ID : "ENSG00000166292.12",
      gene_id : "ENSG00000166292.12",
      gene_type : "protein_coding",
      gene_name : "TMEM100",
      gene_level : 2,
      hgnc_id : "HGNC:25607",
      havana_gene : "OTTHUMG00000177858.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 55751051,
      stop : 55842830,
      direction : "+",
      ID : "ENSG00000141179.14",
      gene_id : "ENSG00000141179.14",
      gene_type : "protein_coding",
      gene_name : "PCTP",
      gene_level : 1,
      hgnc_id : "HGNC:8752",
      havana_gene : "OTTHUMG00000177859.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 55882301,
      stop : 56511659,
      direction : "+",
      ID : "ENSG00000153930.12",
      gene_id : "ENSG00000153930.12",
      gene_type : "protein_coding",
      gene_name : "ANKFN1",
      gene_level : 1,
      hgnc_id : "HGNC:26766",
      havana_gene : "OTTHUMG00000155010.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 56593699,
      stop : 56595611,
      direction : "+",
      ID : "ENSG00000183691.6",
      gene_id : "ENSG00000183691.6",
      gene_type : "protein_coding",
      gene_name : "NOG",
      gene_level : 2,
      hgnc_id : "HGNC:7866",
      havana_gene : "OTTHUMG00000151770.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 56791913,
      stop : 56838773,
      direction : "-",
      ID : "ENSG00000214226.9",
      gene_id : "ENSG00000214226.9",
      gene_type : "protein_coding",
      gene_name : "C17orf67",
      gene_level : 2,
      hgnc_id : "HGNC:27900",
      havana_gene : "OTTHUMG00000132083.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 56834107,
      stop : 56869567,
      direction : "+",
      ID : "ENSG00000153933.10",
      gene_id : "ENSG00000153933.10",
      gene_type : "protein_coding",
      gene_name : "DGKE",
      gene_level : 1,
      hgnc_id : "HGNC:2852",
      havana_gene : "OTTHUMG00000178121.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 56836387,
      stop : 56914080,
      direction : "-",
      ID : "ENSG00000121060.18",
      gene_id : "ENSG00000121060.18",
      gene_type : "protein_coding",
      gene_name : "TRIM25",
      gene_level : 1,
      hgnc_id : "HGNC:12932",
      havana_gene : "OTTHUMG00000178124.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 56938199,
      stop : 56961050,
      direction : "-",
      ID : "ENSG00000121058.5",
      gene_id : "ENSG00000121058.5",
      gene_type : "protein_coding",
      gene_name : "COIL",
      gene_level : 1,
      hgnc_id : "HGNC:2184",
      havana_gene : "OTTHUMG00000178126.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 56978129,
      stop : 57006768,
      direction : "+",
      ID : "ENSG00000121064.13",
      gene_id : "ENSG00000121064.13",
      gene_type : "protein_coding",
      gene_name : "SCPEP1",
      gene_level : 1,
      hgnc_id : "HGNC:29507",
      havana_gene : "OTTHUMG00000178129.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57085092,
      stop : 57121346,
      direction : "+",
      ID : "ENSG00000121057.13",
      gene_id : "ENSG00000121057.13",
      gene_type : "protein_coding",
      gene_name : "AKAP1",
      gene_level : 2,
      hgnc_id : "HGNC:367",
      havana_gene : "OTTHUMG00000140369.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57255851,
      stop : 57684689,
      direction : "+",
      ID : "ENSG00000153944.12",
      gene_id : "ENSG00000153944.12",
      gene_type : "protein_coding",
      gene_name : "MSI2",
      gene_level : 2,
      hgnc_id : "HGNC:18585",
      havana_gene : "OTTHUMG00000178398.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57744495,
      stop : 57745299,
      direction : "-",
      ID : "ENSG00000166329.3",
      gene_id : "ENSG00000166329.3",
      gene_type : "protein_coding",
      gene_name : "CCDC182",
      gene_level : 2,
      hgnc_id : "HGNC:49392",
      havana_gene : "OTTHUMG00000132063.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57834781,
      stop : 57850056,
      direction : "-",
      ID : "ENSG00000181610.13",
      gene_id : "ENSG00000181610.13",
      gene_type : "protein_coding",
      gene_name : "MRPS23",
      gene_level : 2,
      hgnc_id : "HGNC:14509",
      havana_gene : "OTTHUMG00000178774.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57861243,
      stop : 57955412,
      direction : "-",
      ID : "ENSG00000180891.13",
      gene_id : "ENSG00000180891.13",
      gene_type : "protein_coding",
      gene_name : "CUEDC1",
      gene_level : 1,
      hgnc_id : "HGNC:31350",
      havana_gene : "OTTHUMG00000178775.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57971547,
      stop : 57988259,
      direction : "-",
      ID : "ENSG00000136451.9",
      gene_id : "ENSG00000136451.9",
      gene_type : "protein_coding",
      gene_name : "VEZF1",
      gene_level : 1,
      hgnc_id : "HGNC:12949",
      havana_gene : "OTTHUMG00000178777.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 57989038,
      stop : 58007246,
      direction : "-",
      ID : "ENSG00000266086.3",
      gene_id : "ENSG00000266086.3",
      gene_type : "protein_coding",
      gene_name : "AC015813.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178779.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58000919,
      stop : 58007346,
      direction : "-",
      ID : "ENSG00000136450.13",
      gene_id : "ENSG00000136450.13",
      gene_type : "protein_coding",
      gene_name : "SRSF1",
      gene_level : 1,
      hgnc_id : "HGNC:10780",
      havana_gene : "OTTHUMG00000178781.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58083419,
      stop : 58095542,
      direction : "+",
      ID : "ENSG00000264364.3",
      gene_id : "ENSG00000264364.3",
      gene_type : "protein_coding",
      gene_name : "DYNLL2",
      gene_level : 2,
      hgnc_id : "HGNC:24596",
      havana_gene : "OTTHUMG00000178783.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58148449,
      stop : 58159555,
      direction : "+",
      ID : "ENSG00000141194.6",
      gene_id : "ENSG00000141194.6",
      gene_type : "protein_coding",
      gene_name : "OR4D1",
      gene_level : 2,
      hgnc_id : "HGNC:8293",
      havana_gene : "OTTHUMG00000178799.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58166982,
      stop : 58171411,
      direction : "+",
      ID : "ENSG00000255713.2",
      gene_id : "ENSG00000255713.2",
      gene_type : "protein_coding",
      gene_name : "OR4D2",
      gene_level : 2,
      hgnc_id : "HGNC:8294",
      havana_gene : "OTTHUMG00000178801.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58192726,
      stop : 58205174,
      direction : "+",
      ID : "ENSG00000121053.6",
      gene_id : "ENSG00000121053.6",
      gene_type : "protein_coding",
      gene_name : "EPX",
      gene_level : 2,
      hgnc_id : "HGNC:3423",
      havana_gene : "OTTHUMG00000178802.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58205441,
      stop : 58219605,
      direction : "-",
      ID : "ENSG00000011143.19",
      gene_id : "ENSG00000011143.19",
      gene_type : "protein_coding",
      gene_name : "MKS1",
      gene_level : 1,
      hgnc_id : "HGNC:7121",
      havana_gene : "OTTHUMG00000133714.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58218548,
      stop : 58268518,
      direction : "+",
      ID : "ENSG00000167419.11",
      gene_id : "ENSG00000167419.11",
      gene_type : "protein_coding",
      gene_name : "LPO",
      gene_level : 1,
      hgnc_id : "HGNC:6678",
      havana_gene : "OTTHUMG00000178921.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58269855,
      stop : 58280935,
      direction : "-",
      ID : "ENSG00000005381.8",
      gene_id : "ENSG00000005381.8",
      gene_type : "protein_coding",
      gene_name : "MPO",
      gene_level : 2,
      hgnc_id : "HGNC:7218",
      havana_gene : "OTTHUMG00000178922.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58301228,
      stop : 58328795,
      direction : "-",
      ID : "ENSG00000005379.17",
      gene_id : "ENSG00000005379.17",
      gene_type : "protein_coding",
      gene_name : "TSPOAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16831",
      havana_gene : "OTTHUMG00000178923.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58345175,
      stop : 58353093,
      direction : "-",
      ID : "ENSG00000213246.7",
      gene_id : "ENSG00000213246.7",
      gene_type : "protein_coding",
      gene_name : "SUPT4H1",
      gene_level : 1,
      hgnc_id : "HGNC:11467",
      havana_gene : "OTTHUMG00000178926.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58345206,
      stop : 58417595,
      direction : "-",
      ID : "ENSG00000285897.1",
      gene_id : "ENSG00000285897.1",
      gene_type : "protein_coding",
      gene_name : "AC004687.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179077.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58353676,
      stop : 58417595,
      direction : "-",
      ID : "ENSG00000108375.13",
      gene_id : "ENSG00000108375.13",
      gene_type : "protein_coding",
      gene_name : "RNF43",
      gene_level : 2,
      hgnc_id : "HGNC:18505",
      havana_gene : "OTTHUMG00000193347.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58420167,
      stop : 58488408,
      direction : "-",
      ID : "ENSG00000176160.11",
      gene_id : "ENSG00000176160.11",
      gene_type : "protein_coding",
      gene_name : "HSF5",
      gene_level : 2,
      hgnc_id : "HGNC:26862",
      havana_gene : "OTTHUMG00000179078.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58489529,
      stop : 58517905,
      direction : "-",
      ID : "ENSG00000108389.9",
      gene_id : "ENSG00000108389.9",
      gene_type : "protein_coding",
      gene_name : "MTMR4",
      gene_level : 2,
      hgnc_id : "HGNC:7452",
      havana_gene : "OTTHUMG00000179079.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58520250,
      stop : 58544368,
      direction : "-",
      ID : "ENSG00000108387.15",
      gene_id : "ENSG00000108387.15",
      gene_type : "protein_coding",
      gene_name : "SEPTIN4",
      gene_level : 2,
      hgnc_id : "HGNC:9165",
      havana_gene : "OTTHUMG00000179243.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58556678,
      stop : 58692055,
      direction : "-",
      ID : "ENSG00000121101.16",
      gene_id : "ENSG00000121101.16",
      gene_type : "protein_coding",
      gene_name : "TEX14",
      gene_level : 2,
      hgnc_id : "HGNC:11737",
      havana_gene : "OTTHUMG00000179245.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58660424,
      stop : 58692018,
      direction : "-",
      ID : "ENSG00000266826.2",
      gene_id : "ENSG00000266826.2",
      gene_type : "protein_coding",
      gene_name : "IGBP1P2",
      gene_level : 2,
      hgnc_id : "HGNC:43611",
      havana_gene : "OTTHUMG00000179246.2",
      tag : "ncRNA_host, overlapping_locus, retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58692573,
      stop : 58735611,
      direction : "+",
      ID : "ENSG00000108384.15",
      gene_id : "ENSG00000108384.15",
      gene_type : "protein_coding",
      gene_name : "RAD51C",
      gene_level : 1,
      hgnc_id : "HGNC:9820",
      havana_gene : "OTTHUMG00000141292.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58755854,
      stop : 58985179,
      direction : "+",
      ID : "ENSG00000175175.6",
      gene_id : "ENSG00000175175.6",
      gene_type : "protein_coding",
      gene_name : "PPM1E",
      gene_level : 2,
      hgnc_id : "HGNC:19322",
      havana_gene : "OTTHUMG00000179248.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 58982638,
      stop : 59106921,
      direction : "-",
      ID : "ENSG00000108395.14",
      gene_id : "ENSG00000108395.14",
      gene_type : "protein_coding",
      gene_name : "TRIM37",
      gene_level : 1,
      hgnc_id : "HGNC:7523",
      havana_gene : "OTTHUMG00000179360.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59109857,
      stop : 59155260,
      direction : "-",
      ID : "ENSG00000182628.13",
      gene_id : "ENSG00000182628.13",
      gene_type : "protein_coding",
      gene_name : "SKA2",
      gene_level : 1,
      hgnc_id : "HGNC:28006",
      havana_gene : "OTTHUMG00000179361.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59155732,
      stop : 59206709,
      direction : "+",
      ID : "ENSG00000068489.13",
      gene_id : "ENSG00000068489.13",
      gene_type : "protein_coding",
      gene_name : "PRR11",
      gene_level : 1,
      hgnc_id : "HGNC:25619",
      havana_gene : "OTTHUMG00000179362.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59197566,
      stop : 59215226,
      direction : "+",
      ID : "ENSG00000265303.1",
      gene_id : "ENSG00000265303.1",
      gene_type : "protein_coding",
      gene_name : "AC099850.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179375.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59209400,
      stop : 59215239,
      direction : "+",
      ID : "ENSG00000167447.13",
      gene_id : "ENSG00000167447.13",
      gene_type : "protein_coding",
      gene_name : "SMG8",
      gene_level : 2,
      hgnc_id : "HGNC:25551",
      havana_gene : "OTTHUMG00000179365.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59220467,
      stop : 59275970,
      direction : "+",
      ID : "ENSG00000153982.11",
      gene_id : "ENSG00000153982.11",
      gene_type : "protein_coding",
      gene_name : "GDPD1",
      gene_level : 2,
      hgnc_id : "HGNC:20883",
      havana_gene : "OTTHUMG00000179376.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59331655,
      stop : 59401729,
      direction : "+",
      ID : "ENSG00000175155.11",
      gene_id : "ENSG00000175155.11",
      gene_type : "protein_coding",
      gene_name : "YPEL2",
      gene_level : 2,
      hgnc_id : "HGNC:18326",
      havana_gene : "OTTHUMG00000179378.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59565558,
      stop : 59608345,
      direction : "+",
      ID : "ENSG00000108406.10",
      gene_id : "ENSG00000108406.10",
      gene_type : "protein_coding",
      gene_name : "DHX40",
      gene_level : 1,
      hgnc_id : "HGNC:18018",
      havana_gene : "OTTHUMG00000179401.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59619689,
      stop : 59696956,
      direction : "+",
      ID : "ENSG00000141367.12",
      gene_id : "ENSG00000141367.12",
      gene_type : "protein_coding",
      gene_name : "CLTC",
      gene_level : 1,
      hgnc_id : "HGNC:2092",
      havana_gene : "OTTHUMG00000134279.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59674636,
      stop : 59707626,
      direction : "-",
      ID : "ENSG00000141378.15",
      gene_id : "ENSG00000141378.15",
      gene_type : "protein_coding",
      gene_name : "PTRH2",
      gene_level : 2,
      hgnc_id : "HGNC:24265",
      havana_gene : "OTTHUMG00000154532.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59707192,
      stop : 59842255,
      direction : "+",
      ID : "ENSG00000062716.13",
      gene_id : "ENSG00000062716.13",
      gene_type : "protein_coding",
      gene_name : "VMP1",
      gene_level : 2,
      hgnc_id : "HGNC:29559",
      havana_gene : "OTTHUMG00000179882.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59859479,
      stop : 59892945,
      direction : "-",
      ID : "ENSG00000108423.15",
      gene_id : "ENSG00000108423.15",
      gene_type : "protein_coding",
      gene_name : "TUBD1",
      gene_level : 1,
      hgnc_id : "HGNC:16811",
      havana_gene : "OTTHUMG00000179885.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59893046,
      stop : 59950574,
      direction : "+",
      ID : "ENSG00000108443.14",
      gene_id : "ENSG00000108443.14",
      gene_type : "protein_coding",
      gene_name : "RPS6KB1",
      gene_level : 1,
      hgnc_id : "HGNC:10436",
      havana_gene : "OTTHUMG00000150642.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59940908,
      stop : 59973101,
      direction : "+",
      ID : "ENSG00000267318.1",
      gene_id : "ENSG00000267318.1",
      gene_type : "protein_coding",
      gene_name : "AC005702.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179976.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 59952240,
      stop : 59964761,
      direction : "-",
      ID : "ENSG00000189050.16",
      gene_id : "ENSG00000189050.16",
      gene_type : "protein_coding",
      gene_name : "RNFT1",
      gene_level : 2,
      hgnc_id : "HGNC:30206",
      havana_gene : "OTTHUMG00000148658.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60041008,
      stop : 60078922,
      direction : "-",
      ID : "ENSG00000068097.15",
      gene_id : "ENSG00000068097.15",
      gene_type : "protein_coding",
      gene_name : "HEATR6",
      gene_level : 2,
      hgnc_id : "HGNC:24076",
      havana_gene : "OTTHUMG00000179981.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60149942,
      stop : 60170899,
      direction : "+",
      ID : "ENSG00000167434.10",
      gene_id : "ENSG00000167434.10",
      gene_type : "protein_coding",
      gene_name : "CA4",
      gene_level : 2,
      hgnc_id : "HGNC:1375",
      havana_gene : "OTTHUMG00000179987.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60177327,
      stop : 60422470,
      direction : "-",
      ID : "ENSG00000170832.13",
      gene_id : "ENSG00000170832.13",
      gene_type : "protein_coding",
      gene_name : "USP32",
      gene_level : 1,
      hgnc_id : "HGNC:19143",
      havana_gene : "OTTHUMG00000180001.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60392429,
      stop : 60431426,
      direction : "+",
      ID : "ENSG00000141371.13",
      gene_id : "ENSG00000141371.13",
      gene_type : "protein_coding",
      gene_name : "C17orf64",
      gene_level : 1,
      hgnc_id : "HGNC:26990",
      havana_gene : "OTTHUMG00000157171.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60443158,
      stop : 60526242,
      direction : "-",
      ID : "ENSG00000062725.10",
      gene_id : "ENSG00000062725.10",
      gene_type : "protein_coding",
      gene_name : "APPBP2",
      gene_level : 2,
      hgnc_id : "HGNC:622",
      havana_gene : "OTTHUMG00000180048.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60600183,
      stop : 60666280,
      direction : "+",
      ID : "ENSG00000170836.12",
      gene_id : "ENSG00000170836.12",
      gene_type : "protein_coding",
      gene_name : "PPM1D",
      gene_level : 1,
      hgnc_id : "HGNC:9277",
      havana_gene : "OTTHUMG00000180052.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 60677453,
      stop : 61392838,
      direction : "+",
      ID : "ENSG00000141376.23",
      gene_id : "ENSG00000141376.23",
      gene_type : "protein_coding",
      gene_name : "BCAS3",
      gene_level : 1,
      hgnc_id : "HGNC:14347",
      havana_gene : "OTTHUMG00000180064.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 61399843,
      stop : 61409466,
      direction : "+",
      ID : "ENSG00000121068.14",
      gene_id : "ENSG00000121068.14",
      gene_type : "protein_coding",
      gene_name : "TBX2",
      gene_level : 2,
      hgnc_id : "HGNC:11597",
      havana_gene : "OTTHUMG00000156986.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 61452404,
      stop : 61485110,
      direction : "+",
      ID : "ENSG00000121075.11",
      gene_id : "ENSG00000121075.11",
      gene_type : "protein_coding",
      gene_name : "TBX4",
      gene_level : 2,
      hgnc_id : "HGNC:11603",
      havana_gene : "OTTHUMG00000180078.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 61590421,
      stop : 61591219,
      direction : "-",
      ID : "ENSG00000253506.3",
      gene_id : "ENSG00000253506.3",
      gene_type : "protein_coding",
      gene_name : "NACA2",
      gene_level : 2,
      hgnc_id : "HGNC:23290",
      havana_gene : "OTTHUMG00000132321.4",
      tag : "retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 61679139,
      stop : 61863528,
      direction : "-",
      ID : "ENSG00000136492.9",
      gene_id : "ENSG00000136492.9",
      gene_type : "protein_coding",
      gene_name : "BRIP1",
      gene_level : 1,
      hgnc_id : "HGNC:20473",
      havana_gene : "OTTHUMG00000179233.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 61865367,
      stop : 61928016,
      direction : "-",
      ID : "ENSG00000108506.13",
      gene_id : "ENSG00000108506.13",
      gene_type : "protein_coding",
      gene_name : "INTS2",
      gene_level : 1,
      hgnc_id : "HGNC:29241",
      havana_gene : "OTTHUMG00000179234.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 61942605,
      stop : 62065278,
      direction : "-",
      ID : "ENSG00000108510.10",
      gene_id : "ENSG00000108510.10",
      gene_type : "protein_coding",
      gene_name : "MED13",
      gene_level : 2,
      hgnc_id : "HGNC:22474",
      havana_gene : "OTTHUMG00000179251.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 62343941,
      stop : 62416480,
      direction : "+",
      ID : "ENSG00000172421.10",
      gene_id : "ENSG00000172421.10",
      gene_type : "protein_coding",
      gene_name : "EFCAB3",
      gene_level : 2,
      hgnc_id : "HGNC:26379",
      havana_gene : "OTTHUMG00000179175.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 62423875,
      stop : 62453385,
      direction : "+",
      ID : "ENSG00000087995.16",
      gene_id : "ENSG00000087995.16",
      gene_type : "protein_coding",
      gene_name : "METTL2A",
      gene_level : 2,
      hgnc_id : "HGNC:25755",
      havana_gene : "OTTHUMG00000164527.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 62458658,
      stop : 62615481,
      direction : "+",
      ID : "ENSG00000146872.18",
      gene_id : "ENSG00000146872.18",
      gene_type : "protein_coding",
      gene_name : "TLK2",
      gene_level : 1,
      hgnc_id : "HGNC:11842",
      havana_gene : "OTTHUMG00000179176.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 62627670,
      stop : 62693597,
      direction : "+",
      ID : "ENSG00000011028.14",
      gene_id : "ENSG00000011028.14",
      gene_type : "protein_coding",
      gene_name : "MRC2",
      gene_level : 2,
      hgnc_id : "HGNC:16875",
      havana_gene : "OTTHUMG00000179178.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 62701314,
      stop : 62808344,
      direction : "-",
      ID : "ENSG00000173838.12",
      gene_id : "ENSG00000173838.12",
      gene_type : "protein_coding",
      gene_name : "MARCHF10",
      gene_level : 2,
      hgnc_id : "HGNC:26655",
      havana_gene : "OTTHUMG00000179192.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63009556,
      stop : 63427699,
      direction : "+",
      ID : "ENSG00000170921.15",
      gene_id : "ENSG00000170921.15",
      gene_type : "protein_coding",
      gene_name : "TANC2",
      gene_level : 2,
      hgnc_id : "HGNC:30212",
      havana_gene : "OTTHUMG00000179103.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63432304,
      stop : 63446354,
      direction : "-",
      ID : "ENSG00000008283.16",
      gene_id : "ENSG00000008283.16",
      gene_type : "protein_coding",
      gene_name : "CYB561",
      gene_level : 2,
      hgnc_id : "HGNC:2571",
      havana_gene : "OTTHUMG00000179116.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63477061,
      stop : 63498380,
      direction : "+",
      ID : "ENSG00000159640.17",
      gene_id : "ENSG00000159640.17",
      gene_type : "protein_coding",
      gene_name : "ACE",
      gene_level : 2,
      hgnc_id : "HGNC:2707",
      havana_gene : "OTTHUMG00000154927.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63484823,
      stop : 63521848,
      direction : "+",
      ID : "ENSG00000264813.6",
      gene_id : "ENSG00000264813.6",
      gene_type : "protein_coding",
      gene_name : "AC113554.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178900.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63523334,
      stop : 63548977,
      direction : "+",
      ID : "ENSG00000173826.15",
      gene_id : "ENSG00000173826.15",
      gene_type : "protein_coding",
      gene_name : "KCNH6",
      gene_level : 2,
      hgnc_id : "HGNC:18862",
      havana_gene : "OTTHUMG00000178901.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63550477,
      stop : 63594279,
      direction : "+",
      ID : "ENSG00000136485.15",
      gene_id : "ENSG00000136485.15",
      gene_type : "protein_coding",
      gene_name : "DCAF7",
      gene_level : 2,
      hgnc_id : "HGNC:30915",
      havana_gene : "OTTHUMG00000178902.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63600882,
      stop : 63608365,
      direction : "+",
      ID : "ENSG00000136463.8",
      gene_id : "ENSG00000136463.8",
      gene_type : "protein_coding",
      gene_name : "TACO1",
      gene_level : 2,
      hgnc_id : "HGNC:24316",
      havana_gene : "OTTHUMG00000178904.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63622415,
      stop : 63696305,
      direction : "+",
      ID : "ENSG00000198909.8",
      gene_id : "ENSG00000198909.8",
      gene_type : "protein_coding",
      gene_name : "MAP3K3",
      gene_level : 2,
      hgnc_id : "HGNC:6855",
      havana_gene : "OTTHUMG00000178905.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63682336,
      stop : 63741986,
      direction : "-",
      ID : "ENSG00000266173.7",
      gene_id : "ENSG00000266173.7",
      gene_type : "protein_coding",
      gene_name : "STRADA",
      gene_level : 1,
      hgnc_id : "HGNC:30172",
      havana_gene : "OTTHUMG00000178908.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63695888,
      stop : 63701172,
      direction : "-",
      ID : "ENSG00000136490.9",
      gene_id : "ENSG00000136490.9",
      gene_type : "protein_coding",
      gene_name : "LIMD2",
      gene_level : 2,
      hgnc_id : "HGNC:28142",
      havana_gene : "OTTHUMG00000178907.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63702845,
      stop : 63752097,
      direction : "-",
      ID : "ENSG00000125695.12",
      gene_id : "ENSG00000125695.12",
      gene_type : "protein_coding",
      gene_name : "AC046185.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179010.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63745255,
      stop : 63776351,
      direction : "-",
      ID : "ENSG00000108588.14",
      gene_id : "ENSG00000108588.14",
      gene_type : "protein_coding",
      gene_name : "CCDC47",
      gene_level : 2,
      hgnc_id : "HGNC:24856",
      havana_gene : "OTTHUMG00000178933.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63773603,
      stop : 63819317,
      direction : "+",
      ID : "ENSG00000198231.13",
      gene_id : "ENSG00000198231.13",
      gene_type : "protein_coding",
      gene_name : "DDX42",
      gene_level : 2,
      hgnc_id : "HGNC:18676",
      havana_gene : "OTTHUMG00000179011.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63819433,
      stop : 63830012,
      direction : "-",
      ID : "ENSG00000108592.17",
      gene_id : "ENSG00000108592.17",
      gene_type : "protein_coding",
      gene_name : "FTSJ3",
      gene_level : 2,
      hgnc_id : "HGNC:17136",
      havana_gene : "OTTHUMG00000179012.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63827152,
      stop : 63832026,
      direction : "+",
      ID : "ENSG00000087191.13",
      gene_id : "ENSG00000087191.13",
      gene_type : "protein_coding",
      gene_name : "PSMC5",
      gene_level : 2,
      hgnc_id : "HGNC:9552",
      havana_gene : "OTTHUMG00000179013.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63832081,
      stop : 63843065,
      direction : "-",
      ID : "ENSG00000108604.16",
      gene_id : "ENSG00000108604.16",
      gene_type : "protein_coding",
      gene_name : "SMARCD2",
      gene_level : 1,
      hgnc_id : "HGNC:11107",
      havana_gene : "OTTHUMG00000179045.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63872012,
      stop : 63873766,
      direction : "-",
      ID : "ENSG00000213218.11",
      gene_id : "ENSG00000213218.11",
      gene_type : "protein_coding",
      gene_name : "CSH2",
      gene_level : 2,
      hgnc_id : "HGNC:2441",
      havana_gene : "OTTHUMG00000172283.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63880215,
      stop : 63881944,
      direction : "-",
      ID : "ENSG00000136487.18",
      gene_id : "ENSG00000136487.18",
      gene_type : "protein_coding",
      gene_name : "GH2",
      gene_level : 2,
      hgnc_id : "HGNC:4262",
      havana_gene : "OTTHUMG00000172284.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63894909,
      stop : 63896661,
      direction : "-",
      ID : "ENSG00000136488.15",
      gene_id : "ENSG00000136488.15",
      gene_type : "protein_coding",
      gene_name : "CSH1",
      gene_level : 2,
      hgnc_id : "HGNC:2440",
      havana_gene : "OTTHUMG00000171947.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63909597,
      stop : 63918838,
      direction : "-",
      ID : "ENSG00000204414.13",
      gene_id : "ENSG00000204414.13",
      gene_type : "protein_coding",
      gene_name : "CSHL1",
      gene_level : 2,
      hgnc_id : "HGNC:2442",
      havana_gene : "OTTHUMG00000172287.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63917200,
      stop : 63918839,
      direction : "-",
      ID : "ENSG00000259384.7",
      gene_id : "ENSG00000259384.7",
      gene_type : "protein_coding",
      gene_name : "GH1",
      gene_level : 2,
      hgnc_id : "HGNC:4261",
      havana_gene : "OTTHUMG00000193348.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63917203,
      stop : 63931385,
      direction : "-",
      ID : "ENSG00000285947.1",
      gene_id : "ENSG00000285947.1",
      gene_type : "protein_coding",
      gene_name : "AC127029.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172293.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63928740,
      stop : 63932336,
      direction : "-",
      ID : "ENSG00000007312.13",
      gene_id : "ENSG00000007312.13",
      gene_type : "protein_coding",
      gene_name : "CD79B",
      gene_level : 2,
      hgnc_id : "HGNC:1699",
      havana_gene : "OTTHUMG00000172294.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63938554,
      stop : 63972918,
      direction : "-",
      ID : "ENSG00000007314.12",
      gene_id : "ENSG00000007314.12",
      gene_type : "protein_coding",
      gene_name : "SCN4A",
      gene_level : 2,
      hgnc_id : "HGNC:10591",
      havana_gene : "OTTHUMG00000179046.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 63998351,
      stop : 64004305,
      direction : "+",
      ID : "ENSG00000224383.8",
      gene_id : "ENSG00000224383.8",
      gene_type : "protein_coding",
      gene_name : "PRR29",
      gene_level : 2,
      hgnc_id : "HGNC:25673",
      havana_gene : "OTTHUMG00000178594.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64002594,
      stop : 64020634,
      direction : "-",
      ID : "ENSG00000108622.11",
      gene_id : "ENSG00000108622.11",
      gene_type : "protein_coding",
      gene_name : "ICAM2",
      gene_level : 2,
      hgnc_id : "HGNC:5345",
      havana_gene : "OTTHUMG00000178865.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64039080,
      stop : 64130819,
      direction : "-",
      ID : "ENSG00000178607.17",
      gene_id : "ENSG00000178607.17",
      gene_type : "protein_coding",
      gene_name : "ERN1",
      gene_level : 2,
      hgnc_id : "HGNC:3449",
      havana_gene : "OTTHUMG00000178879.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64147227,
      stop : 64263260,
      direction : "-",
      ID : "ENSG00000136478.8",
      gene_id : "ENSG00000136478.8",
      gene_type : "protein_coding",
      gene_name : "TEX2",
      gene_level : 2,
      hgnc_id : "HGNC:30884",
      havana_gene : "OTTHUMG00000178881.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64319415,
      stop : 64413776,
      direction : "-",
      ID : "ENSG00000261371.6",
      gene_id : "ENSG00000261371.6",
      gene_type : "protein_coding",
      gene_name : "PECAM1",
      gene_level : 2,
      hgnc_id : "HGNC:8823",
      havana_gene : "OTTHUMG00000175829.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64449037,
      stop : 64468643,
      direction : "+",
      ID : "ENSG00000271605.6",
      gene_id : "ENSG00000271605.6",
      gene_type : "protein_coding",
      gene_name : "MILR1",
      gene_level : 2,
      hgnc_id : "HGNC:27570",
      havana_gene : "OTTHUMG00000185198.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64477785,
      stop : 64497054,
      direction : "-",
      ID : "ENSG00000256525.8",
      gene_id : "ENSG00000256525.8",
      gene_type : "protein_coding",
      gene_name : "POLG2",
      gene_level : 1,
      hgnc_id : "HGNC:9180",
      havana_gene : "OTTHUMG00000178899.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64498254,
      stop : 64508199,
      direction : "-",
      ID : "ENSG00000108654.16",
      gene_id : "ENSG00000108654.16",
      gene_type : "protein_coding",
      gene_name : "DDX5",
      gene_level : 1,
      hgnc_id : "HGNC:2746",
      havana_gene : "OTTHUMG00000178936.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64506865,
      stop : 64542461,
      direction : "+",
      ID : "ENSG00000258890.7",
      gene_id : "ENSG00000258890.7",
      gene_type : "protein_coding",
      gene_name : "CEP95",
      gene_level : 1,
      hgnc_id : "HGNC:25141",
      havana_gene : "OTTHUMG00000179174.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64542282,
      stop : 64662307,
      direction : "-",
      ID : "ENSG00000108854.16",
      gene_id : "ENSG00000108854.16",
      gene_type : "protein_coding",
      gene_name : "SMURF2",
      gene_level : 2,
      hgnc_id : "HGNC:16809",
      havana_gene : "OTTHUMG00000179189.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 64854312,
      stop : 64919480,
      direction : "-",
      ID : "ENSG00000176809.10",
      gene_id : "ENSG00000176809.10",
      gene_type : "protein_coding",
      gene_name : "LRRC37A3",
      gene_level : 2,
      hgnc_id : "HGNC:32427",
      havana_gene : "OTTHUMG00000132307.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 65009289,
      stop : 65056740,
      direction : "-",
      ID : "ENSG00000120063.10",
      gene_id : "ENSG00000120063.10",
      gene_type : "protein_coding",
      gene_name : "GNA13",
      gene_level : 1,
      hgnc_id : "HGNC:4381",
      havana_gene : "OTTHUMG00000179316.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 65100812,
      stop : 65227703,
      direction : "+",
      ID : "ENSG00000108370.17",
      gene_id : "ENSG00000108370.17",
      gene_type : "protein_coding",
      gene_name : "RGS9",
      gene_level : 2,
      hgnc_id : "HGNC:10004",
      havana_gene : "OTTHUMG00000179349.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 65528563,
      stop : 65561648,
      direction : "-",
      ID : "ENSG00000168646.13",
      gene_id : "ENSG00000168646.13",
      gene_type : "protein_coding",
      gene_name : "AXIN2",
      gene_level : 1,
      hgnc_id : "HGNC:904",
      havana_gene : "OTTHUMG00000179353.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 65538102,
      stop : 65641033,
      direction : "-",
      ID : "ENSG00000266076.1",
      gene_id : "ENSG00000266076.1",
      gene_type : "protein_coding",
      gene_name : "AC004805.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179524.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 65635537,
      stop : 66192133,
      direction : "-",
      ID : "ENSG00000154240.17",
      gene_id : "ENSG00000154240.17",
      gene_type : "protein_coding",
      gene_name : "CEP112",
      gene_level : 2,
      hgnc_id : "HGNC:28514",
      havana_gene : "OTTHUMG00000179474.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 66212033,
      stop : 66256525,
      direction : "-",
      ID : "ENSG00000091583.11",
      gene_id : "ENSG00000091583.11",
      gene_type : "protein_coding",
      gene_name : "APOH",
      gene_level : 1,
      hgnc_id : "HGNC:616",
      havana_gene : "OTTHUMG00000179530.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 66302613,
      stop : 66810743,
      direction : "+",
      ID : "ENSG00000154229.12",
      gene_id : "ENSG00000154229.12",
      gene_type : "protein_coding",
      gene_name : "PRKCA",
      gene_level : 2,
      hgnc_id : "HGNC:9393",
      havana_gene : "OTTHUMG00000179533.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 66835117,
      stop : 66894751,
      direction : "+",
      ID : "ENSG00000075429.9",
      gene_id : "ENSG00000075429.9",
      gene_type : "protein_coding",
      gene_name : "CACNG5",
      gene_level : 2,
      hgnc_id : "HGNC:1409",
      havana_gene : "OTTHUMG00000166468.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 66964707,
      stop : 67033398,
      direction : "+",
      ID : "ENSG00000075461.6",
      gene_id : "ENSG00000075461.6",
      gene_type : "protein_coding",
      gene_name : "CACNG4",
      gene_level : 2,
      hgnc_id : "HGNC:1408",
      havana_gene : "OTTHUMG00000179550.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67044554,
      stop : 67056797,
      direction : "+",
      ID : "ENSG00000108878.5",
      gene_id : "ENSG00000108878.5",
      gene_type : "protein_coding",
      gene_name : "CACNG1",
      gene_level : 2,
      hgnc_id : "HGNC:1405",
      havana_gene : "OTTHUMG00000179553.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67070444,
      stop : 67245989,
      direction : "-",
      ID : "ENSG00000198265.12",
      gene_id : "ENSG00000198265.12",
      gene_type : "protein_coding",
      gene_name : "HELZ",
      gene_level : 1,
      hgnc_id : "HGNC:16878",
      havana_gene : "OTTHUMG00000179555.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67337916,
      stop : 67366605,
      direction : "-",
      ID : "ENSG00000197170.10",
      gene_id : "ENSG00000197170.10",
      gene_type : "protein_coding",
      gene_name : "PSMD12",
      gene_level : 2,
      hgnc_id : "HGNC:9557",
      havana_gene : "OTTHUMG00000140376.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67377281,
      stop : 67697261,
      direction : "+",
      ID : "ENSG00000154217.15",
      gene_id : "ENSG00000154217.15",
      gene_type : "protein_coding",
      gene_name : "PITPNC1",
      gene_level : 1,
      hgnc_id : "HGNC:21045",
      havana_gene : "OTTHUMG00000179602.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67717931,
      stop : 67744531,
      direction : "+",
      ID : "ENSG00000130935.10",
      gene_id : "ENSG00000130935.10",
      gene_type : "protein_coding",
      gene_name : "NOL11",
      gene_level : 1,
      hgnc_id : "HGNC:24557",
      havana_gene : "OTTHUMG00000179777.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67825503,
      stop : 67984378,
      direction : "+",
      ID : "ENSG00000171634.18",
      gene_id : "ENSG00000171634.18",
      gene_type : "protein_coding",
      gene_name : "BPTF",
      gene_level : 1,
      hgnc_id : "HGNC:3581",
      havana_gene : "OTTHUMG00000132254.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 67991099,
      stop : 67996469,
      direction : "-",
      ID : "ENSG00000186665.10",
      gene_id : "ENSG00000186665.10",
      gene_type : "protein_coding",
      gene_name : "C17orf58",
      gene_level : 2,
      hgnc_id : "HGNC:27568",
      havana_gene : "OTTHUMG00000179782.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68035636,
      stop : 68047364,
      direction : "+",
      ID : "ENSG00000182481.10",
      gene_id : "ENSG00000182481.10",
      gene_type : "protein_coding",
      gene_name : "KPNA2",
      gene_level : 2,
      hgnc_id : "HGNC:6395",
      havana_gene : "OTTHUMG00000179784.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68205481,
      stop : 68257712,
      direction : "+",
      ID : "ENSG00000196704.14",
      gene_id : "ENSG00000196704.14",
      gene_type : "protein_coding",
      gene_name : "AMZ2",
      gene_level : 2,
      hgnc_id : "HGNC:28041",
      havana_gene : "OTTHUMG00000179802.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68259182,
      stop : 68422731,
      direction : "+",
      ID : "ENSG00000141337.13",
      gene_id : "ENSG00000141337.13",
      gene_type : "protein_coding",
      gene_name : "ARSG",
      gene_level : 2,
      hgnc_id : "HGNC:24102",
      havana_gene : "OTTHUMG00000179810.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68267026,
      stop : 68291267,
      direction : "-",
      ID : "ENSG00000108932.12",
      gene_id : "ENSG00000108932.12",
      gene_type : "protein_coding",
      gene_name : "SLC16A6",
      gene_level : 2,
      hgnc_id : "HGNC:10927",
      havana_gene : "OTTHUMG00000179812.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68420948,
      stop : 68457513,
      direction : "-",
      ID : "ENSG00000070540.13",
      gene_id : "ENSG00000070540.13",
      gene_type : "protein_coding",
      gene_name : "WIPI1",
      gene_level : 2,
      hgnc_id : "HGNC:25471",
      havana_gene : "OTTHUMG00000179873.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68511780,
      stop : 68551319,
      direction : "+",
      ID : "ENSG00000108946.15",
      gene_id : "ENSG00000108946.15",
      gene_type : "protein_coding",
      gene_name : "PRKAR1A",
      gene_level : 1,
      hgnc_id : "HGNC:9388",
      havana_gene : "OTTHUMG00000180128.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68535113,
      stop : 68601367,
      direction : "-",
      ID : "ENSG00000108950.12",
      gene_id : "ENSG00000108950.12",
      gene_type : "protein_coding",
      gene_name : "FAM20A",
      gene_level : 2,
      hgnc_id : "HGNC:23015",
      havana_gene : "OTTHUMG00000180152.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68867289,
      stop : 68955392,
      direction : "-",
      ID : "ENSG00000141338.14",
      gene_id : "ENSG00000141338.14",
      gene_type : "protein_coding",
      gene_name : "ABCA8",
      gene_level : 2,
      hgnc_id : "HGNC:38",
      havana_gene : "OTTHUMG00000180192.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 68974488,
      stop : 69060949,
      direction : "-",
      ID : "ENSG00000154258.17",
      gene_id : "ENSG00000154258.17",
      gene_type : "protein_coding",
      gene_name : "ABCA9",
      gene_level : 2,
      hgnc_id : "HGNC:39",
      havana_gene : "OTTHUMG00000140371.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 69078702,
      stop : 69141895,
      direction : "-",
      ID : "ENSG00000154262.13",
      gene_id : "ENSG00000154262.13",
      gene_type : "protein_coding",
      gene_name : "ABCA6",
      gene_level : 2,
      hgnc_id : "HGNC:36",
      havana_gene : "OTTHUMG00000180258.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 69147214,
      stop : 69244846,
      direction : "-",
      ID : "ENSG00000154263.17",
      gene_id : "ENSG00000154263.17",
      gene_type : "protein_coding",
      gene_name : "ABCA10",
      gene_level : 2,
      hgnc_id : "HGNC:30",
      havana_gene : "OTTHUMG00000164716.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 69244311,
      stop : 69327244,
      direction : "-",
      ID : "ENSG00000154265.16",
      gene_id : "ENSG00000154265.16",
      gene_type : "protein_coding",
      gene_name : "ABCA5",
      gene_level : 2,
      hgnc_id : "HGNC:35",
      havana_gene : "OTTHUMG00000180303.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 69414697,
      stop : 69553865,
      direction : "+",
      ID : "ENSG00000108984.15",
      gene_id : "ENSG00000108984.15",
      gene_type : "protein_coding",
      gene_name : "MAP2K6",
      gene_level : 1,
      hgnc_id : "HGNC:6846",
      havana_gene : "OTTHUMG00000180311.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 70053429,
      stop : 70135608,
      direction : "+",
      ID : "ENSG00000153822.14",
      gene_id : "ENSG00000153822.14",
      gene_type : "protein_coding",
      gene_name : "KCNJ16",
      gene_level : 2,
      hgnc_id : "HGNC:6262",
      havana_gene : "OTTHUMG00000180349.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 70168673,
      stop : 70180044,
      direction : "+",
      ID : "ENSG00000123700.5",
      gene_id : "ENSG00000123700.5",
      gene_type : "protein_coding",
      gene_name : "KCNJ2",
      gene_level : 2,
      hgnc_id : "HGNC:6263",
      havana_gene : "OTTHUMG00000180351.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 72121020,
      stop : 72126416,
      direction : "+",
      ID : "ENSG00000125398.8",
      gene_id : "ENSG00000125398.8",
      gene_type : "protein_coding",
      gene_name : "SOX9",
      gene_level : 2,
      hgnc_id : "HGNC:11204",
      havana_gene : "OTTHUMG00000166300.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 72645949,
      stop : 73092712,
      direction : "-",
      ID : "ENSG00000133195.11",
      gene_id : "ENSG00000133195.11",
      gene_type : "protein_coding",
      gene_name : "SLC39A11",
      gene_level : 1,
      hgnc_id : "HGNC:14463",
      havana_gene : "OTTHUMG00000178306.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73165010,
      stop : 73176633,
      direction : "+",
      ID : "ENSG00000180616.9",
      gene_id : "ENSG00000180616.9",
      gene_type : "protein_coding",
      gene_name : "SSTR2",
      gene_level : 1,
      hgnc_id : "HGNC:11331",
      havana_gene : "OTTHUMG00000178343.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73192632,
      stop : 73208507,
      direction : "+",
      ID : "ENSG00000166685.12",
      gene_id : "ENSG00000166685.12",
      gene_type : "protein_coding",
      gene_name : "COG1",
      gene_level : 2,
      hgnc_id : "HGNC:6545",
      havana_gene : "OTTHUMG00000178344.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73207353,
      stop : 73236753,
      direction : "-",
      ID : "ENSG00000133193.12",
      gene_id : "ENSG00000133193.12",
      gene_type : "protein_coding",
      gene_name : "FAM104A",
      gene_level : 1,
      hgnc_id : "HGNC:25918",
      havana_gene : "OTTHUMG00000150564.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73232233,
      stop : 73248947,
      direction : "+",
      ID : "ENSG00000141219.15",
      gene_id : "ENSG00000141219.15",
      gene_type : "protein_coding",
      gene_name : "C17orf80",
      gene_level : 2,
      hgnc_id : "HGNC:29601",
      havana_gene : "OTTHUMG00000178417.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73248449,
      stop : 73262352,
      direction : "-",
      ID : "ENSG00000187959.9",
      gene_id : "ENSG00000187959.9",
      gene_type : "protein_coding",
      gene_name : "CPSF4L",
      gene_level : 2,
      hgnc_id : "HGNC:33632",
      havana_gene : "OTTHUMG00000132640.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73283624,
      stop : 73312005,
      direction : "-",
      ID : "ENSG00000179604.10",
      gene_id : "ENSG00000179604.10",
      gene_type : "protein_coding",
      gene_name : "CDC42EP4",
      gene_level : 1,
      hgnc_id : "HGNC:17147",
      havana_gene : "OTTHUMG00000178419.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 73334384,
      stop : 73644445,
      direction : "-",
      ID : "ENSG00000069188.17",
      gene_id : "ENSG00000069188.17",
      gene_type : "protein_coding",
      gene_name : "SDK2",
      gene_level : 2,
      hgnc_id : "HGNC:19308",
      havana_gene : "OTTHUMG00000152726.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74203582,
      stop : 74210655,
      direction : "+",
      ID : "ENSG00000172809.13",
      gene_id : "ENSG00000172809.13",
      gene_type : "protein_coding",
      gene_name : "RPL38",
      gene_level : 2,
      hgnc_id : "HGNC:10349",
      havana_gene : "OTTHUMG00000166016.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74213571,
      stop : 74262020,
      direction : "+",
      ID : "ENSG00000141540.11",
      gene_id : "ENSG00000141540.11",
      gene_type : "protein_coding",
      gene_name : "TTYH2",
      gene_level : 1,
      hgnc_id : "HGNC:13877",
      havana_gene : "OTTHUMG00000166018.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74274234,
      stop : 74314884,
      direction : "+",
      ID : "ENSG00000171595.14",
      gene_id : "ENSG00000171595.14",
      gene_type : "protein_coding",
      gene_name : "DNAI2",
      gene_level : 2,
      hgnc_id : "HGNC:18744",
      havana_gene : "OTTHUMG00000178578.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74326210,
      stop : 74355820,
      direction : "+",
      ID : "ENSG00000196169.15",
      gene_id : "ENSG00000196169.15",
      gene_type : "protein_coding",
      gene_name : "KIF19",
      gene_level : 2,
      hgnc_id : "HGNC:26735",
      havana_gene : "OTTHUMG00000150694.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74356416,
      stop : 74361868,
      direction : "-",
      ID : "ENSG00000204347.4",
      gene_id : "ENSG00000204347.4",
      gene_type : "protein_coding",
      gene_name : "BTBD17",
      gene_level : 2,
      hgnc_id : "HGNC:33758",
      havana_gene : "OTTHUMG00000178580.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74367407,
      stop : 74372622,
      direction : "+",
      ID : "ENSG00000257008.6",
      gene_id : "ENSG00000257008.6",
      gene_type : "protein_coding",
      gene_name : "GPR142",
      gene_level : 2,
      hgnc_id : "HGNC:20088",
      havana_gene : "OTTHUMG00000178581.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74424851,
      stop : 74451653,
      direction : "+",
      ID : "ENSG00000170412.18",
      gene_id : "ENSG00000170412.18",
      gene_type : "protein_coding",
      gene_name : "GPRC5C",
      gene_level : 1,
      hgnc_id : "HGNC:13309",
      havana_gene : "OTTHUMG00000067613.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74466399,
      stop : 74484794,
      direction : "+",
      ID : "ENSG00000167851.15",
      gene_id : "ENSG00000167851.15",
      gene_type : "protein_coding",
      gene_name : "CD300A",
      gene_level : 1,
      hgnc_id : "HGNC:19319",
      havana_gene : "OTTHUMG00000067612.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74521174,
      stop : 74531475,
      direction : "-",
      ID : "ENSG00000178789.9",
      gene_id : "ENSG00000178789.9",
      gene_type : "protein_coding",
      gene_name : "CD300LB",
      gene_level : 2,
      hgnc_id : "HGNC:30811",
      havana_gene : "OTTHUMG00000067606.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74541073,
      stop : 74546115,
      direction : "-",
      ID : "ENSG00000167850.4",
      gene_id : "ENSG00000167850.4",
      gene_type : "protein_coding",
      gene_name : "CD300C",
      gene_level : 2,
      hgnc_id : "HGNC:19320",
      havana_gene : "OTTHUMG00000067608.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74579365,
      stop : 74592283,
      direction : "-",
      ID : "ENSG00000204345.1",
      gene_id : "ENSG00000204345.1",
      gene_type : "protein_coding",
      gene_name : "CD300LD",
      gene_level : 2,
      hgnc_id : "HGNC:16848",
      havana_gene : "OTTHUMG00000067614.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74609885,
      stop : 74623738,
      direction : "-",
      ID : "ENSG00000186407.7",
      gene_id : "ENSG00000186407.7",
      gene_type : "protein_coding",
      gene_name : "CD300E",
      gene_level : 1,
      hgnc_id : "HGNC:28874",
      havana_gene : "OTTHUMG00000067605.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74670578,
      stop : 74747335,
      direction : "+",
      ID : "ENSG00000172794.20",
      gene_id : "ENSG00000172794.20",
      gene_type : "protein_coding",
      gene_name : "RAB37",
      gene_level : 1,
      hgnc_id : "HGNC:30268",
      havana_gene : "OTTHUMG00000134282.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74694311,
      stop : 74712978,
      direction : "-",
      ID : "ENSG00000186074.19",
      gene_id : "ENSG00000186074.19",
      gene_type : "protein_coding",
      gene_name : "CD300LF",
      gene_level : 2,
      hgnc_id : "HGNC:29883",
      havana_gene : "OTTHUMG00000067609.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74748628,
      stop : 74769353,
      direction : "+",
      ID : "ENSG00000109062.12",
      gene_id : "ENSG00000109062.12",
      gene_type : "protein_coding",
      gene_name : "SLC9A3R1",
      gene_level : 2,
      hgnc_id : "HGNC:11075",
      havana_gene : "OTTHUMG00000178863.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74770529,
      stop : 74776367,
      direction : "-",
      ID : "ENSG00000109065.12",
      gene_id : "ENSG00000109065.12",
      gene_type : "protein_coding",
      gene_name : "NAT9",
      gene_level : 1,
      hgnc_id : "HGNC:23133",
      havana_gene : "OTTHUMG00000178870.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74776499,
      stop : 74839753,
      direction : "+",
      ID : "ENSG00000109066.14",
      gene_id : "ENSG00000109066.14",
      gene_type : "protein_coding",
      gene_name : "TMEM104",
      gene_level : 1,
      hgnc_id : "HGNC:25984",
      havana_gene : "OTTHUMG00000179025.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74842023,
      stop : 74861504,
      direction : "-",
      ID : "ENSG00000161509.14",
      gene_id : "ENSG00000161509.14",
      gene_type : "protein_coding",
      gene_name : "GRIN2C",
      gene_level : 2,
      hgnc_id : "HGNC:4587",
      havana_gene : "OTTHUMG00000044524.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74862497,
      stop : 74873031,
      direction : "-",
      ID : "ENSG00000161513.12",
      gene_id : "ENSG00000161513.12",
      gene_type : "protein_coding",
      gene_name : "FDXR",
      gene_level : 1,
      hgnc_id : "HGNC:3642",
      havana_gene : "OTTHUMG00000179026.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74877302,
      stop : 74893781,
      direction : "-",
      ID : "ENSG00000172782.12",
      gene_id : "ENSG00000172782.12",
      gene_type : "protein_coding",
      gene_name : "FADS6",
      gene_level : 2,
      hgnc_id : "HGNC:30459",
      havana_gene : "OTTHUMG00000179188.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74916083,
      stop : 74923256,
      direction : "-",
      ID : "ENSG00000182040.9",
      gene_id : "ENSG00000182040.9",
      gene_type : "protein_coding",
      gene_name : "USH1G",
      gene_level : 2,
      hgnc_id : "HGNC:16356",
      havana_gene : "OTTHUMG00000178864.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74922950,
      stop : 74933912,
      direction : "+",
      ID : "ENSG00000183034.13",
      gene_id : "ENSG00000183034.13",
      gene_type : "protein_coding",
      gene_name : "OTOP2",
      gene_level : 2,
      hgnc_id : "HGNC:19657",
      havana_gene : "OTTHUMG00000179215.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74935898,
      stop : 74949992,
      direction : "+",
      ID : "ENSG00000182938.7",
      gene_id : "ENSG00000182938.7",
      gene_type : "protein_coding",
      gene_name : "OTOP3",
      gene_level : 2,
      hgnc_id : "HGNC:19658",
      havana_gene : "OTTHUMG00000179216.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74950742,
      stop : 74973166,
      direction : "-",
      ID : "ENSG00000167861.16",
      gene_id : "ENSG00000167861.16",
      gene_type : "protein_coding",
      gene_name : "HID1",
      gene_level : 1,
      hgnc_id : "HGNC:15736",
      havana_gene : "OTTHUMG00000166490.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 74987632,
      stop : 75005800,
      direction : "+",
      ID : "ENSG00000109089.7",
      gene_id : "ENSG00000109089.7",
      gene_type : "protein_coding",
      gene_name : "CDR2L",
      gene_level : 2,
      hgnc_id : "HGNC:29999",
      havana_gene : "OTTHUMG00000150435.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75012670,
      stop : 75021261,
      direction : "+",
      ID : "ENSG00000167862.10",
      gene_id : "ENSG00000167862.10",
      gene_type : "protein_coding",
      gene_name : "MRPL58",
      gene_level : 2,
      hgnc_id : "HGNC:5359",
      havana_gene : "OTTHUMG00000179218.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75032575,
      stop : 75065889,
      direction : "+",
      ID : "ENSG00000180901.11",
      gene_id : "ENSG00000180901.11",
      gene_type : "protein_coding",
      gene_name : "KCTD2",
      gene_level : 2,
      hgnc_id : "HGNC:21294",
      havana_gene : "OTTHUMG00000179276.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75038863,
      stop : 75046985,
      direction : "-",
      ID : "ENSG00000167863.12",
      gene_id : "ENSG00000167863.12",
      gene_type : "protein_coding",
      gene_name : "ATP5PD",
      gene_level : 2,
      hgnc_id : "HGNC:845",
      havana_gene : "OTTHUMG00000179219.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75087727,
      stop : 75106162,
      direction : "+",
      ID : "ENSG00000170190.16",
      gene_id : "ENSG00000170190.16",
      gene_type : "protein_coding",
      gene_name : "SLC16A5",
      gene_level : 1,
      hgnc_id : "HGNC:10926",
      havana_gene : "OTTHUMG00000179277.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75109952,
      stop : 75130272,
      direction : "+",
      ID : "ENSG00000125449.7",
      gene_id : "ENSG00000125449.7",
      gene_type : "protein_coding",
      gene_name : "ARMC7",
      gene_level : 1,
      hgnc_id : "HGNC:26168",
      havana_gene : "OTTHUMG00000179345.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75130225,
      stop : 75131757,
      direction : "-",
      ID : "ENSG00000125458.7",
      gene_id : "ENSG00000125458.7",
      gene_type : "protein_coding",
      gene_name : "NT5C",
      gene_level : 2,
      hgnc_id : "HGNC:17144",
      havana_gene : "OTTHUMG00000179346.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75135248,
      stop : 75168281,
      direction : "-",
      ID : "ENSG00000189159.16",
      gene_id : "ENSG00000189159.16",
      gene_type : "protein_coding",
      gene_name : "JPT1",
      gene_level : 2,
      hgnc_id : "HGNC:14569",
      havana_gene : "OTTHUMG00000154521.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75165586,
      stop : 75182959,
      direction : "-",
      ID : "ENSG00000188612.12",
      gene_id : "ENSG00000188612.12",
      gene_type : "protein_coding",
      gene_name : "SUMO2",
      gene_level : 1,
      hgnc_id : "HGNC:11125",
      havana_gene : "OTTHUMG00000179481.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75205659,
      stop : 75235758,
      direction : "+",
      ID : "ENSG00000125450.11",
      gene_id : "ENSG00000125450.11",
      gene_type : "protein_coding",
      gene_name : "NUP85",
      gene_level : 1,
      hgnc_id : "HGNC:8734",
      havana_gene : "OTTHUMG00000179482.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75236599,
      stop : 75262363,
      direction : "-",
      ID : "ENSG00000125447.18",
      gene_id : "ENSG00000125447.18",
      gene_type : "protein_coding",
      gene_name : "GGA3",
      gene_level : 1,
      hgnc_id : "HGNC:17079",
      havana_gene : "OTTHUMG00000179483.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75261674,
      stop : 75266376,
      direction : "+",
      ID : "ENSG00000125445.11",
      gene_id : "ENSG00000125445.11",
      gene_type : "protein_coding",
      gene_name : "MRPS7",
      gene_level : 2,
      hgnc_id : "HGNC:14499",
      havana_gene : "OTTHUMG00000179484.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75266228,
      stop : 75271231,
      direction : "-",
      ID : "ENSG00000125457.15",
      gene_id : "ENSG00000125457.15",
      gene_type : "protein_coding",
      gene_name : "MIF4GD",
      gene_level : 1,
      hgnc_id : "HGNC:24030",
      havana_gene : "OTTHUMG00000179485.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75272981,
      stop : 75289510,
      direction : "-",
      ID : "ENSG00000125454.12",
      gene_id : "ENSG00000125454.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A19",
      gene_level : 1,
      hgnc_id : "HGNC:14409",
      havana_gene : "OTTHUMG00000179607.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75318076,
      stop : 75405709,
      direction : "-",
      ID : "ENSG00000177885.15",
      gene_id : "ENSG00000177885.15",
      gene_type : "protein_coding",
      gene_name : "GRB2",
      gene_level : 1,
      hgnc_id : "HGNC:4566",
      havana_gene : "OTTHUMG00000134332.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75441159,
      stop : 75500452,
      direction : "+",
      ID : "ENSG00000177728.17",
      gene_id : "ENSG00000177728.17",
      gene_type : "protein_coding",
      gene_name : "TMEM94",
      gene_level : 1,
      hgnc_id : "HGNC:28983",
      havana_gene : "OTTHUMG00000179611.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75500261,
      stop : 75515537,
      direction : "-",
      ID : "ENSG00000177303.10",
      gene_id : "ENSG00000177303.10",
      gene_type : "protein_coding",
      gene_name : "CASKIN2",
      gene_level : 2,
      hgnc_id : "HGNC:18200",
      havana_gene : "OTTHUMG00000179683.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75515944,
      stop : 75524735,
      direction : "+",
      ID : "ENSG00000182173.14",
      gene_id : "ENSG00000182173.14",
      gene_type : "protein_coding",
      gene_name : "TSEN54",
      gene_level : 2,
      hgnc_id : "HGNC:27561",
      havana_gene : "OTTHUMG00000179684.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75525080,
      stop : 75575209,
      direction : "+",
      ID : "ENSG00000073350.14",
      gene_id : "ENSG00000073350.14",
      gene_type : "protein_coding",
      gene_name : "LLGL2",
      gene_level : 2,
      hgnc_id : "HGNC:6629",
      havana_gene : "OTTHUMG00000179685.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75588058,
      stop : 75626849,
      direction : "+",
      ID : "ENSG00000266714.9",
      gene_id : "ENSG00000266714.9",
      gene_type : "protein_coding",
      gene_name : "MYO15B",
      gene_level : 2,
      hgnc_id : "HGNC:14083",
      havana_gene : "OTTHUMG00000179794.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75626845,
      stop : 75667189,
      direction : "-",
      ID : "ENSG00000108469.15",
      gene_id : "ENSG00000108469.15",
      gene_type : "protein_coding",
      gene_name : "RECQL5",
      gene_level : 1,
      hgnc_id : "HGNC:9950",
      havana_gene : "OTTHUMG00000179795.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75633434,
      stop : 75641404,
      direction : "+",
      ID : "ENSG00000204323.5",
      gene_id : "ENSG00000204323.5",
      gene_type : "protein_coding",
      gene_name : "SMIM5",
      gene_level : 2,
      hgnc_id : "HGNC:40030",
      havana_gene : "OTTHUMG00000167882.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75646243,
      stop : 75647975,
      direction : "+",
      ID : "ENSG00000259120.3",
      gene_id : "ENSG00000259120.3",
      gene_type : "protein_coding",
      gene_name : "SMIM6",
      gene_level : 2,
      hgnc_id : "HGNC:40032",
      havana_gene : "OTTHUMG00000179796.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75667251,
      stop : 75708062,
      direction : "+",
      ID : "ENSG00000161526.15",
      gene_id : "ENSG00000161526.15",
      gene_type : "protein_coding",
      gene_name : "SAP30BP",
      gene_level : 2,
      hgnc_id : "HGNC:30785",
      havana_gene : "OTTHUMG00000179798.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75721328,
      stop : 75757818,
      direction : "+",
      ID : "ENSG00000132470.14",
      gene_id : "ENSG00000132470.14",
      gene_type : "protein_coding",
      gene_name : "ITGB4",
      gene_level : 1,
      hgnc_id : "HGNC:6158",
      havana_gene : "OTTHUMG00000179814.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75751594,
      stop : 75765236,
      direction : "-",
      ID : "ENSG00000108479.12",
      gene_id : "ENSG00000108479.12",
      gene_type : "protein_coding",
      gene_name : "GALK1",
      gene_level : 2,
      hgnc_id : "HGNC:4118",
      havana_gene : "OTTHUMG00000179832.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75776434,
      stop : 75785893,
      direction : "-",
      ID : "ENSG00000132475.10",
      gene_id : "ENSG00000132475.10",
      gene_type : "protein_coding",
      gene_name : "H3-3B",
      gene_level : 2,
      hgnc_id : "HGNC:4765",
      havana_gene : "OTTHUMG00000179842.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75784806,
      stop : 75825799,
      direction : "+",
      ID : "ENSG00000132478.10",
      gene_id : "ENSG00000132478.10",
      gene_type : "protein_coding",
      gene_name : "UNK",
      gene_level : 1,
      hgnc_id : "HGNC:29369",
      havana_gene : "OTTHUMG00000179892.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75827225,
      stop : 75844552,
      direction : "-",
      ID : "ENSG00000092929.12",
      gene_id : "ENSG00000092929.12",
      gene_type : "protein_coding",
      gene_name : "UNC13D",
      gene_level : 2,
      hgnc_id : "HGNC:23147",
      havana_gene : "OTTHUMG00000179895.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75845699,
      stop : 75856507,
      direction : "-",
      ID : "ENSG00000132471.12",
      gene_id : "ENSG00000132471.12",
      gene_type : "protein_coding",
      gene_name : "WBP2",
      gene_level : 1,
      hgnc_id : "HGNC:12738",
      havana_gene : "OTTHUMG00000179896.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75874164,
      stop : 75878581,
      direction : "-",
      ID : "ENSG00000132481.7",
      gene_id : "ENSG00000132481.7",
      gene_type : "protein_coding",
      gene_name : "TRIM47",
      gene_level : 2,
      hgnc_id : "HGNC:19020",
      havana_gene : "OTTHUMG00000179916.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75880335,
      stop : 75896951,
      direction : "-",
      ID : "ENSG00000141569.12",
      gene_id : "ENSG00000141569.12",
      gene_type : "protein_coding",
      gene_name : "TRIM65",
      gene_level : 1,
      hgnc_id : "HGNC:27316",
      havana_gene : "OTTHUMG00000132127.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75898644,
      stop : 75905093,
      direction : "-",
      ID : "ENSG00000204316.13",
      gene_id : "ENSG00000204316.13",
      gene_type : "protein_coding",
      gene_name : "MRPL38",
      gene_level : 2,
      hgnc_id : "HGNC:14033",
      havana_gene : "OTTHUMG00000152977.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75898645,
      stop : 75930129,
      direction : "-",
      ID : "ENSG00000267426.5",
      gene_id : "ENSG00000267426.5",
      gene_type : "protein_coding",
      gene_name : "AC087289.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180026.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75909574,
      stop : 75941140,
      direction : "-",
      ID : "ENSG00000188878.19",
      gene_id : "ENSG00000188878.19",
      gene_type : "protein_coding",
      gene_name : "FBF1",
      gene_level : 2,
      hgnc_id : "HGNC:24674",
      havana_gene : "OTTHUMG00000179919.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75941507,
      stop : 75979177,
      direction : "-",
      ID : "ENSG00000161533.12",
      gene_id : "ENSG00000161533.12",
      gene_type : "protein_coding",
      gene_name : "ACOX1",
      gene_level : 2,
      hgnc_id : "HGNC:119",
      havana_gene : "OTTHUMG00000180027.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75979231,
      stop : 76005999,
      direction : "+",
      ID : "ENSG00000261408.7",
      gene_id : "ENSG00000261408.7",
      gene_type : "protein_coding",
      gene_name : "TEN1-CDK3",
      gene_level : 2,
      hgnc_id : "HGNC:44420",
      havana_gene : "OTTHUMG00000170136.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 75979240,
      stop : 76000586,
      direction : "+",
      ID : "ENSG00000257949.7",
      gene_id : "ENSG00000257949.7",
      gene_type : "protein_coding",
      gene_name : "TEN1",
      gene_level : 1,
      hgnc_id : "HGNC:37242",
      havana_gene : "OTTHUMG00000132686.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76000906,
      stop : 76005999,
      direction : "+",
      ID : "ENSG00000250506.8",
      gene_id : "ENSG00000250506.8",
      gene_type : "protein_coding",
      gene_name : "CDK3",
      gene_level : 2,
      hgnc_id : "HGNC:1772",
      havana_gene : "OTTHUMG00000154861.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76004502,
      stop : 76027306,
      direction : "-",
      ID : "ENSG00000167880.8",
      gene_id : "ENSG00000167880.8",
      gene_type : "protein_coding",
      gene_name : "EVPL",
      gene_level : 2,
      hgnc_id : "HGNC:3503",
      havana_gene : "OTTHUMG00000180053.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76038775,
      stop : 76072517,
      direction : "-",
      ID : "ENSG00000167881.15",
      gene_id : "ENSG00000167881.15",
      gene_type : "protein_coding",
      gene_name : "SRP68",
      gene_level : 1,
      hgnc_id : "HGNC:11302",
      havana_gene : "OTTHUMG00000180054.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76071961,
      stop : 76083666,
      direction : "+",
      ID : "ENSG00000186919.13",
      gene_id : "ENSG00000186919.13",
      gene_type : "protein_coding",
      gene_name : "ZACN",
      gene_level : 2,
      hgnc_id : "HGNC:29504",
      havana_gene : "OTTHUMG00000157186.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76074781,
      stop : 76077537,
      direction : "+",
      ID : "ENSG00000182687.4",
      gene_id : "ENSG00000182687.4",
      gene_type : "protein_coding",
      gene_name : "GALR2",
      gene_level : 2,
      hgnc_id : "HGNC:4133",
      havana_gene : "OTTHUMG00000167479.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76081016,
      stop : 76121576,
      direction : "-",
      ID : "ENSG00000182473.22",
      gene_id : "ENSG00000182473.22",
      gene_type : "protein_coding",
      gene_name : "EXOC7",
      gene_level : 1,
      hgnc_id : "HGNC:23214",
      havana_gene : "OTTHUMG00000150720.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76136333,
      stop : 76141245,
      direction : "-",
      ID : "ENSG00000129654.8",
      gene_id : "ENSG00000129654.8",
      gene_type : "protein_coding",
      gene_name : "FOXJ1",
      gene_level : 2,
      hgnc_id : "HGNC:3816",
      havana_gene : "OTTHUMG00000180120.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76142465,
      stop : 76240493,
      direction : "-",
      ID : "ENSG00000141576.16",
      gene_id : "ENSG00000141576.16",
      gene_type : "protein_coding",
      gene_name : "RNF157",
      gene_level : 2,
      hgnc_id : "HGNC:29402",
      havana_gene : "OTTHUMG00000132627.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76265348,
      stop : 76271298,
      direction : "+",
      ID : "ENSG00000185262.9",
      gene_id : "ENSG00000185262.9",
      gene_type : "protein_coding",
      gene_name : "UBALD2",
      gene_level : 2,
      hgnc_id : "HGNC:28438",
      havana_gene : "OTTHUMG00000132666.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76274049,
      stop : 76307998,
      direction : "-",
      ID : "ENSG00000129646.15",
      gene_id : "ENSG00000129646.15",
      gene_type : "protein_coding",
      gene_name : "QRICH2",
      gene_level : 2,
      hgnc_id : "HGNC:25326",
      havana_gene : "OTTHUMG00000167578.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76309478,
      stop : 76384521,
      direction : "-",
      ID : "ENSG00000161542.17",
      gene_id : "ENSG00000161542.17",
      gene_type : "protein_coding",
      gene_name : "PRPSAP1",
      gene_level : 2,
      hgnc_id : "HGNC:9466",
      havana_gene : "OTTHUMG00000155969.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76376584,
      stop : 76387860,
      direction : "+",
      ID : "ENSG00000176170.14",
      gene_id : "ENSG00000176170.14",
      gene_type : "protein_coding",
      gene_name : "SPHK1",
      gene_level : 2,
      hgnc_id : "HGNC:11240",
      havana_gene : "OTTHUMG00000180177.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76389456,
      stop : 76453152,
      direction : "-",
      ID : "ENSG00000175931.13",
      gene_id : "ENSG00000175931.13",
      gene_type : "protein_coding",
      gene_name : "UBE2O",
      gene_level : 1,
      hgnc_id : "HGNC:29554",
      havana_gene : "OTTHUMG00000180178.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76453351,
      stop : 76470117,
      direction : "+",
      ID : "ENSG00000129673.10",
      gene_id : "ENSG00000129673.10",
      gene_type : "protein_coding",
      gene_name : "AANAT",
      gene_level : 2,
      hgnc_id : "HGNC:19",
      havana_gene : "OTTHUMG00000180179.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76470891,
      stop : 76501790,
      direction : "-",
      ID : "ENSG00000129667.13",
      gene_id : "ENSG00000129667.13",
      gene_type : "protein_coding",
      gene_name : "RHBDF2",
      gene_level : 1,
      hgnc_id : "HGNC:20788",
      havana_gene : "OTTHUMG00000180180.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76527356,
      stop : 76551175,
      direction : "-",
      ID : "ENSG00000161544.10",
      gene_id : "ENSG00000161544.10",
      gene_type : "protein_coding",
      gene_name : "CYGB",
      gene_level : 1,
      hgnc_id : "HGNC:16505",
      havana_gene : "OTTHUMG00000180289.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76527586,
      stop : 76553578,
      direction : "+",
      ID : "ENSG00000214140.11",
      gene_id : "ENSG00000214140.11",
      gene_type : "protein_coding",
      gene_name : "PRCD",
      gene_level : 2,
      hgnc_id : "HGNC:32528",
      havana_gene : "OTTHUMG00000132200.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76563710,
      stop : 76570544,
      direction : "-",
      ID : "ENSG00000284526.1",
      gene_id : "ENSG00000284526.1",
      gene_type : "protein_coding",
      gene_name : "AC015802.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180301.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76565377,
      stop : 76586956,
      direction : "-",
      ID : "ENSG00000070731.11",
      gene_id : "ENSG00000070731.11",
      gene_type : "protein_coding",
      gene_name : "ST6GALNAC2",
      gene_level : 2,
      hgnc_id : "HGNC:10867",
      havana_gene : "OTTHUMG00000191877.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76624761,
      stop : 76643786,
      direction : "-",
      ID : "ENSG00000070526.15",
      gene_id : "ENSG00000070526.15",
      gene_type : "protein_coding",
      gene_name : "ST6GALNAC1",
      gene_level : 2,
      hgnc_id : "HGNC:23614",
      havana_gene : "OTTHUMG00000180369.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76672551,
      stop : 76711016,
      direction : "-",
      ID : "ENSG00000182534.13",
      gene_id : "ENSG00000182534.13",
      gene_type : "protein_coding",
      gene_name : "MXRA7",
      gene_level : 2,
      hgnc_id : "HGNC:7541",
      havana_gene : "OTTHUMG00000180370.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76712832,
      stop : 76726799,
      direction : "-",
      ID : "ENSG00000070495.15",
      gene_id : "ENSG00000070495.15",
      gene_type : "protein_coding",
      gene_name : "JMJD6",
      gene_level : 1,
      hgnc_id : "HGNC:19355",
      havana_gene : "OTTHUMG00000169267.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76726830,
      stop : 76733936,
      direction : "+",
      ID : "ENSG00000181038.14",
      gene_id : "ENSG00000181038.14",
      gene_type : "protein_coding",
      gene_name : "METTL23",
      gene_level : 2,
      hgnc_id : "HGNC:26988",
      havana_gene : "OTTHUMG00000180371.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76732978,
      stop : 76738522,
      direction : "+",
      ID : "ENSG00000267168.1",
      gene_id : "ENSG00000267168.1",
      gene_type : "protein_coding",
      gene_name : "AC005837.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180483.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76734115,
      stop : 76737333,
      direction : "-",
      ID : "ENSG00000161547.17",
      gene_id : "ENSG00000161547.17",
      gene_type : "protein_coding",
      gene_name : "SRSF2",
      gene_level : 2,
      hgnc_id : "HGNC:10783",
      havana_gene : "OTTHUMG00000177547.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76735865,
      stop : 76781449,
      direction : "+",
      ID : "ENSG00000092931.11",
      gene_id : "ENSG00000092931.11",
      gene_type : "protein_coding",
      gene_name : "MFSD11",
      gene_level : 2,
      hgnc_id : "HGNC:25458",
      havana_gene : "OTTHUMG00000180484.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 76868404,
      stop : 76950393,
      direction : "+",
      ID : "ENSG00000167889.13",
      gene_id : "ENSG00000167889.13",
      gene_type : "protein_coding",
      gene_name : "MGAT5B",
      gene_level : 2,
      hgnc_id : "HGNC:24140",
      havana_gene : "OTTHUMG00000177278.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 77088749,
      stop : 77217101,
      direction : "+",
      ID : "ENSG00000129657.16",
      gene_id : "ENSG00000129657.16",
      gene_type : "protein_coding",
      gene_name : "SEC14L1",
      gene_level : 1,
      hgnc_id : "HGNC:10698",
      havana_gene : "OTTHUMG00000177311.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 77280569,
      stop : 77500596,
      direction : "+",
      ID : "ENSG00000184640.20",
      gene_id : "ENSG00000184640.20",
      gene_type : "protein_coding",
      gene_name : "SEPTIN9",
      gene_level : 1,
      hgnc_id : "HGNC:7323",
      havana_gene : "OTTHUMG00000177327.18",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 77959240,
      stop : 78108835,
      direction : "+",
      ID : "ENSG00000078687.17",
      gene_id : "ENSG00000078687.17",
      gene_type : "protein_coding",
      gene_name : "TNRC6C",
      gene_level : 2,
      hgnc_id : "HGNC:29318",
      havana_gene : "OTTHUMG00000132642.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78107397,
      stop : 78132407,
      direction : "-",
      ID : "ENSG00000141524.17",
      gene_id : "ENSG00000141524.17",
      gene_type : "protein_coding",
      gene_name : "TMC6",
      gene_level : 2,
      hgnc_id : "HGNC:18021",
      havana_gene : "OTTHUMG00000177466.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78130770,
      stop : 78142968,
      direction : "+",
      ID : "ENSG00000167895.15",
      gene_id : "ENSG00000167895.15",
      gene_type : "protein_coding",
      gene_name : "TMC8",
      gene_level : 1,
      hgnc_id : "HGNC:20474",
      havana_gene : "OTTHUMG00000177436.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78146353,
      stop : 78166177,
      direction : "+",
      ID : "ENSG00000187997.11",
      gene_id : "ENSG00000187997.11",
      gene_type : "protein_coding",
      gene_name : "C17orf99",
      gene_level : 2,
      hgnc_id : "HGNC:34490",
      havana_gene : "OTTHUMG00000153871.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78168581,
      stop : 78173527,
      direction : "+",
      ID : "ENSG00000108639.8",
      gene_id : "ENSG00000108639.8",
      gene_type : "protein_coding",
      gene_name : "SYNGR2",
      gene_level : 1,
      hgnc_id : "HGNC:11499",
      havana_gene : "OTTHUMG00000177457.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78174091,
      stop : 78187233,
      direction : "-",
      ID : "ENSG00000167900.12",
      gene_id : "ENSG00000167900.12",
      gene_type : "protein_coding",
      gene_name : "TK1",
      gene_level : 2,
      hgnc_id : "HGNC:11830",
      havana_gene : "OTTHUMG00000150674.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78187317,
      stop : 78207701,
      direction : "+",
      ID : "ENSG00000183077.15",
      gene_id : "ENSG00000183077.15",
      gene_type : "protein_coding",
      gene_name : "AFMID",
      gene_level : 1,
      hgnc_id : "HGNC:20910",
      havana_gene : "OTTHUMG00000153957.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78214186,
      stop : 78225636,
      direction : "+",
      ID : "ENSG00000089685.15",
      gene_id : "ENSG00000089685.15",
      gene_type : "protein_coding",
      gene_name : "BIRC5",
      gene_level : 2,
      hgnc_id : "HGNC:593",
      havana_gene : "OTTHUMG00000177505.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78231310,
      stop : 78240987,
      direction : "+",
      ID : "ENSG00000204278.12",
      gene_id : "ENSG00000204278.12",
      gene_type : "protein_coding",
      gene_name : "TMEM235",
      gene_level : 2,
      hgnc_id : "HGNC:27563",
      havana_gene : "OTTHUMG00000170345.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78356778,
      stop : 78360077,
      direction : "-",
      ID : "ENSG00000184557.4",
      gene_id : "ENSG00000184557.4",
      gene_type : "protein_coding",
      gene_name : "SOCS3",
      gene_level : 2,
      hgnc_id : "HGNC:19391",
      havana_gene : "OTTHUMG00000177513.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78378649,
      stop : 78425114,
      direction : "+",
      ID : "ENSG00000087157.19",
      gene_id : "ENSG00000087157.19",
      gene_type : "protein_coding",
      gene_name : "PGS1",
      gene_level : 1,
      hgnc_id : "HGNC:30029",
      havana_gene : "OTTHUMG00000177514.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78423697,
      stop : 78577396,
      direction : "-",
      ID : "ENSG00000187775.17",
      gene_id : "ENSG00000187775.17",
      gene_type : "protein_coding",
      gene_name : "DNAH17",
      gene_level : 1,
      hgnc_id : "HGNC:2946",
      havana_gene : "OTTHUMG00000150216.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78674048,
      stop : 78782297,
      direction : "-",
      ID : "ENSG00000108669.16",
      gene_id : "ENSG00000108669.16",
      gene_type : "protein_coding",
      gene_name : "CYTH1",
      gene_level : 1,
      hgnc_id : "HGNC:9501",
      havana_gene : "OTTHUMG00000150253.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78787381,
      stop : 78841441,
      direction : "-",
      ID : "ENSG00000055483.19",
      gene_id : "ENSG00000055483.19",
      gene_type : "protein_coding",
      gene_name : "USP36",
      gene_level : 1,
      hgnc_id : "HGNC:20062",
      havana_gene : "OTTHUMG00000177542.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78852977,
      stop : 78925387,
      direction : "-",
      ID : "ENSG00000035862.12",
      gene_id : "ENSG00000035862.12",
      gene_type : "protein_coding",
      gene_name : "TIMP2",
      gene_level : 2,
      hgnc_id : "HGNC:11821",
      havana_gene : "OTTHUMG00000154517.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78870910,
      stop : 78903217,
      direction : "-",
      ID : "ENSG00000178404.10",
      gene_id : "ENSG00000178404.10",
      gene_type : "protein_coding",
      gene_name : "CEP295NL",
      gene_level : 1,
      hgnc_id : "HGNC:44659",
      havana_gene : "OTTHUMG00000177628.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78971238,
      stop : 78979947,
      direction : "-",
      ID : "ENSG00000108679.13",
      gene_id : "ENSG00000108679.13",
      gene_type : "protein_coding",
      gene_name : "LGALS3BP",
      gene_level : 1,
      hgnc_id : "HGNC:6564",
      havana_gene : "OTTHUMG00000177572.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 78991716,
      stop : 79009867,
      direction : "-",
      ID : "ENSG00000171302.17",
      gene_id : "ENSG00000171302.17",
      gene_type : "protein_coding",
      gene_name : "CANT1",
      gene_level : 2,
      hgnc_id : "HGNC:19721",
      havana_gene : "OTTHUMG00000177570.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79022814,
      stop : 79049788,
      direction : "+",
      ID : "ENSG00000173918.15",
      gene_id : "ENSG00000173918.15",
      gene_type : "protein_coding",
      gene_name : "C1QTNF1",
      gene_level : 1,
      hgnc_id : "HGNC:14324",
      havana_gene : "OTTHUMG00000177533.7",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79074824,
      stop : 79088599,
      direction : "+",
      ID : "ENSG00000167280.17",
      gene_id : "ENSG00000167280.17",
      gene_type : "protein_coding",
      gene_name : "ENGASE",
      gene_level : 2,
      hgnc_id : "HGNC:24622",
      havana_gene : "OTTHUMG00000167714.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79089345,
      stop : 79516148,
      direction : "-",
      ID : "ENSG00000167281.19",
      gene_id : "ENSG00000167281.19",
      gene_type : "protein_coding",
      gene_name : "RBFOX3",
      gene_level : 1,
      hgnc_id : "HGNC:27097",
      havana_gene : "OTTHUMG00000150183.10",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79730943,
      stop : 79742219,
      direction : "+",
      ID : "ENSG00000182156.10",
      gene_id : "ENSG00000182156.10",
      gene_type : "protein_coding",
      gene_name : "ENPP7",
      gene_level : 2,
      hgnc_id : "HGNC:23764",
      havana_gene : "OTTHUMG00000177462.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79778148,
      stop : 79787983,
      direction : "+",
      ID : "ENSG00000173894.11",
      gene_id : "ENSG00000173894.11",
      gene_type : "protein_coding",
      gene_name : "CBX2",
      gene_level : 2,
      hgnc_id : "HGNC:1552",
      havana_gene : "OTTHUMG00000177463.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79792132,
      stop : 79801683,
      direction : "-",
      ID : "ENSG00000141570.11",
      gene_id : "ENSG00000141570.11",
      gene_type : "protein_coding",
      gene_name : "CBX8",
      gene_level : 2,
      hgnc_id : "HGNC:15962",
      havana_gene : "OTTHUMG00000150416.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79833156,
      stop : 79839440,
      direction : "-",
      ID : "ENSG00000141582.15",
      gene_id : "ENSG00000141582.15",
      gene_type : "protein_coding",
      gene_name : "CBX4",
      gene_level : 2,
      hgnc_id : "HGNC:1554",
      havana_gene : "OTTHUMG00000150415.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 79932343,
      stop : 80035872,
      direction : "-",
      ID : "ENSG00000167291.16",
      gene_id : "ENSG00000167291.16",
      gene_type : "protein_coding",
      gene_name : "TBC1D16",
      gene_level : 1,
      hgnc_id : "HGNC:28356",
      havana_gene : "OTTHUMG00000177489.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80036632,
      stop : 80100613,
      direction : "+",
      ID : "ENSG00000141519.15",
      gene_id : "ENSG00000141519.15",
      gene_type : "protein_coding",
      gene_name : "CCDC40",
      gene_level : 2,
      hgnc_id : "HGNC:26090",
      havana_gene : "OTTHUMG00000132707.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80101556,
      stop : 80119881,
      direction : "+",
      ID : "ENSG00000171298.13",
      gene_id : "ENSG00000171298.13",
      gene_type : "protein_coding",
      gene_name : "GAA",
      gene_level : 2,
      hgnc_id : "HGNC:4065",
      havana_gene : "OTTHUMG00000177537.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80134369,
      stop : 80147151,
      direction : "-",
      ID : "ENSG00000141543.12",
      gene_id : "ENSG00000141543.12",
      gene_type : "protein_coding",
      gene_name : "EIF4A3",
      gene_level : 2,
      hgnc_id : "HGNC:18683",
      havana_gene : "OTTHUMG00000177538.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80169992,
      stop : 80209331,
      direction : "+",
      ID : "ENSG00000141527.18",
      gene_id : "ENSG00000141527.18",
      gene_type : "protein_coding",
      gene_name : "CARD14",
      gene_level : 2,
      hgnc_id : "HGNC:16446",
      havana_gene : "OTTHUMG00000177549.12",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80206716,
      stop : 80220923,
      direction : "-",
      ID : "ENSG00000181523.13",
      gene_id : "ENSG00000181523.13",
      gene_type : "protein_coding",
      gene_name : "SGSH",
      gene_level : 2,
      hgnc_id : "HGNC:10818",
      havana_gene : "OTTHUMG00000177569.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80219699,
      stop : 80253500,
      direction : "+",
      ID : "ENSG00000181045.15",
      gene_id : "ENSG00000181045.15",
      gene_type : "protein_coding",
      gene_name : "SLC26A11",
      gene_level : 1,
      hgnc_id : "HGNC:14471",
      havana_gene : "OTTHUMG00000133419.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80260866,
      stop : 80398786,
      direction : "+",
      ID : "ENSG00000173821.19",
      gene_id : "ENSG00000173821.19",
      gene_type : "protein_coding",
      gene_name : "RNF213",
      gene_level : 1,
      hgnc_id : "HGNC:14539",
      havana_gene : "OTTHUMG00000161415.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80415165,
      stop : 80438086,
      direction : "+",
      ID : "ENSG00000173818.17",
      gene_id : "ENSG00000173818.17",
      gene_type : "protein_coding",
      gene_name : "ENDOV",
      gene_level : 1,
      hgnc_id : "HGNC:26640",
      havana_gene : "OTTHUMG00000164638.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80466834,
      stop : 80477843,
      direction : "-",
      ID : "ENSG00000171246.6",
      gene_id : "ENSG00000171246.6",
      gene_type : "protein_coding",
      gene_name : "NPTX1",
      gene_level : 2,
      hgnc_id : "HGNC:7952",
      havana_gene : "OTTHUMG00000177607.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80544819,
      stop : 80966371,
      direction : "+",
      ID : "ENSG00000141564.15",
      gene_id : "ENSG00000141564.15",
      gene_type : "protein_coding",
      gene_name : "RPTOR",
      gene_level : 1,
      hgnc_id : "HGNC:30287",
      havana_gene : "OTTHUMG00000177622.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 80991598,
      stop : 81009517,
      direction : "+",
      ID : "ENSG00000176108.9",
      gene_id : "ENSG00000176108.9",
      gene_type : "protein_coding",
      gene_name : "CHMP6",
      gene_level : 2,
      hgnc_id : "HGNC:25675",
      havana_gene : "OTTHUMG00000177645.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81035122,
      stop : 81117432,
      direction : "+",
      ID : "ENSG00000175866.15",
      gene_id : "ENSG00000175866.15",
      gene_type : "protein_coding",
      gene_name : "BAIAP2",
      gene_level : 1,
      hgnc_id : "HGNC:947",
      havana_gene : "OTTHUMG00000177698.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81110487,
      stop : 81166221,
      direction : "-",
      ID : "ENSG00000181409.14",
      gene_id : "ENSG00000181409.14",
      gene_type : "protein_coding",
      gene_name : "AATK",
      gene_level : 1,
      hgnc_id : "HGNC:21",
      havana_gene : "OTTHUMG00000132717.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81165507,
      stop : 81183166,
      direction : "+",
      ID : "ENSG00000225180.8",
      gene_id : "ENSG00000225180.8",
      gene_type : "protein_coding",
      gene_name : "PVALEF",
      gene_level : 2,
      hgnc_id : "HGNC:40053",
      havana_gene : "OTTHUMG00000150182.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81189593,
      stop : 81222999,
      direction : "-",
      ID : "ENSG00000141577.14",
      gene_id : "ENSG00000141577.14",
      gene_type : "protein_coding",
      gene_name : "CEP131",
      gene_level : 2,
      hgnc_id : "HGNC:29511",
      havana_gene : "OTTHUMG00000132728.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81228277,
      stop : 81239091,
      direction : "-",
      ID : "ENSG00000167302.11",
      gene_id : "ENSG00000167302.11",
      gene_type : "protein_coding",
      gene_name : "TEPSIN",
      gene_level : 2,
      hgnc_id : "HGNC:26458",
      havana_gene : "OTTHUMG00000177866.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81239305,
      stop : 81241310,
      direction : "+",
      ID : "ENSG00000224877.4",
      gene_id : "ENSG00000224877.4",
      gene_type : "protein_coding",
      gene_name : "NDUFAF8",
      gene_level : 1,
      hgnc_id : "HGNC:33551",
      havana_gene : "OTTHUMG00000177867.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81244811,
      stop : 81295547,
      direction : "-",
      ID : "ENSG00000157637.13",
      gene_id : "ENSG00000157637.13",
      gene_type : "protein_coding",
      gene_name : "SLC38A10",
      gene_level : 1,
      hgnc_id : "HGNC:28237",
      havana_gene : "OTTHUMG00000168049.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81395457,
      stop : 81466332,
      direction : "+",
      ID : "ENSG00000266074.10",
      gene_id : "ENSG00000266074.10",
      gene_type : "protein_coding",
      gene_name : "BAHCC1",
      gene_level : 2,
      hgnc_id : "HGNC:29279",
      havana_gene : "OTTHUMG00000184171.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81509413,
      stop : 81523847,
      direction : "-",
      ID : "ENSG00000184009.13",
      gene_id : "ENSG00000184009.13",
      gene_type : "protein_coding",
      gene_name : "ACTG1",
      gene_level : 2,
      hgnc_id : "HGNC:144",
      havana_gene : "OTTHUMG00000177955.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81528377,
      stop : 81537130,
      direction : "+",
      ID : "ENSG00000186765.12",
      gene_id : "ENSG00000186765.12",
      gene_type : "protein_coding",
      gene_name : "FSCN2",
      gene_level : 2,
      hgnc_id : "HGNC:3960",
      havana_gene : "OTTHUMG00000167477.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81539885,
      stop : 81553961,
      direction : "-",
      ID : "ENSG00000185504.17",
      gene_id : "ENSG00000185504.17",
      gene_type : "protein_coding",
      gene_name : "FAAP100",
      gene_level : 1,
      hgnc_id : "HGNC:26171",
      havana_gene : "OTTHUMG00000167764.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81556887,
      stop : 81648465,
      direction : "-",
      ID : "ENSG00000182446.14",
      gene_id : "ENSG00000182446.14",
      gene_type : "protein_coding",
      gene_name : "NPLOC4",
      gene_level : 1,
      hgnc_id : "HGNC:18261",
      havana_gene : "OTTHUMG00000177990.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81637171,
      stop : 81648749,
      direction : "+",
      ID : "ENSG00000182612.10",
      gene_id : "ENSG00000182612.10",
      gene_type : "protein_coding",
      gene_name : "TSPAN10",
      gene_level : 2,
      hgnc_id : "HGNC:29942",
      havana_gene : "OTTHUMG00000178037.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81650459,
      stop : 81663112,
      direction : "-",
      ID : "ENSG00000185527.12",
      gene_id : "ENSG00000185527.12",
      gene_type : "protein_coding",
      gene_name : "PDE6G",
      gene_level : 1,
      hgnc_id : "HGNC:8789",
      havana_gene : "OTTHUMG00000178038.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81665036,
      stop : 81666635,
      direction : "-",
      ID : "ENSG00000204237.5",
      gene_id : "ENSG00000204237.5",
      gene_type : "protein_coding",
      gene_name : "OXLD1",
      gene_level : 1,
      hgnc_id : "HGNC:27901",
      havana_gene : "OTTHUMG00000178063.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81666737,
      stop : 81673904,
      direction : "+",
      ID : "ENSG00000185298.13",
      gene_id : "ENSG00000185298.13",
      gene_type : "protein_coding",
      gene_name : "CCDC137",
      gene_level : 2,
      hgnc_id : "HGNC:33451",
      havana_gene : "OTTHUMG00000178064.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81681187,
      stop : 81683797,
      direction : "-",
      ID : "ENSG00000214087.9",
      gene_id : "ENSG00000214087.9",
      gene_type : "protein_coding",
      gene_name : "ARL16",
      gene_level : 1,
      hgnc_id : "HGNC:27902",
      havana_gene : "OTTHUMG00000178103.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81683326,
      stop : 81703138,
      direction : "+",
      ID : "ENSG00000185359.14",
      gene_id : "ENSG00000185359.14",
      gene_type : "protein_coding",
      gene_name : "HGS",
      gene_level : 1,
      hgnc_id : "HGNC:4897",
      havana_gene : "OTTHUMG00000178109.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81703367,
      stop : 81707517,
      direction : "+",
      ID : "ENSG00000262814.8",
      gene_id : "ENSG00000262814.8",
      gene_type : "protein_coding",
      gene_name : "MRPL12",
      gene_level : 2,
      hgnc_id : "HGNC:10378",
      havana_gene : "OTTHUMG00000178171.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81703371,
      stop : 81720539,
      direction : "+",
      ID : "ENSG00000262660.1",
      gene_id : "ENSG00000262660.1",
      gene_type : "protein_coding",
      gene_name : "AC139530.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178172.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81712236,
      stop : 81721016,
      direction : "+",
      ID : "ENSG00000183048.12",
      gene_id : "ENSG00000183048.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A10",
      gene_level : 2,
      hgnc_id : "HGNC:10980",
      havana_gene : "OTTHUMG00000178173.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81804132,
      stop : 81814008,
      direction : "+",
      ID : "ENSG00000215644.10",
      gene_id : "ENSG00000215644.10",
      gene_type : "protein_coding",
      gene_name : "GCGR",
      gene_level : 2,
      hgnc_id : "HGNC:4192",
      havana_gene : "OTTHUMG00000177914.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81822361,
      stop : 81833302,
      direction : "-",
      ID : "ENSG00000225663.8",
      gene_id : "ENSG00000225663.8",
      gene_type : "protein_coding",
      gene_name : "MCRIP1",
      gene_level : 1,
      hgnc_id : "HGNC:28007",
      havana_gene : "OTTHUMG00000177915.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81833492,
      stop : 81835050,
      direction : "-",
      ID : "ENSG00000182676.5",
      gene_id : "ENSG00000182676.5",
      gene_type : "protein_coding",
      gene_name : "PPP1R27",
      gene_level : 2,
      hgnc_id : "HGNC:16813",
      havana_gene : "OTTHUMG00000177916.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81843159,
      stop : 81860856,
      direction : "-",
      ID : "ENSG00000185624.16",
      gene_id : "ENSG00000185624.16",
      gene_type : "protein_coding",
      gene_name : "P4HB",
      gene_level : 1,
      hgnc_id : "HGNC:8548",
      havana_gene : "OTTHUMG00000150269.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81867721,
      stop : 81871378,
      direction : "-",
      ID : "ENSG00000141522.12",
      gene_id : "ENSG00000141522.12",
      gene_type : "protein_coding",
      gene_name : "ARHGDIA",
      gene_level : 2,
      hgnc_id : "HGNC:678",
      havana_gene : "OTTHUMG00000178352.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81887835,
      stop : 81891586,
      direction : "-",
      ID : "ENSG00000183684.8",
      gene_id : "ENSG00000183684.8",
      gene_type : "protein_coding",
      gene_name : "ALYREF",
      gene_level : 2,
      hgnc_id : "HGNC:19071",
      havana_gene : "OTTHUMG00000160470.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81890790,
      stop : 81900991,
      direction : "+",
      ID : "ENSG00000141552.18",
      gene_id : "ENSG00000141552.18",
      gene_type : "protein_coding",
      gene_name : "ANAPC11",
      gene_level : 2,
      hgnc_id : "HGNC:14452",
      havana_gene : "OTTHUMG00000177982.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81900745,
      stop : 81902905,
      direction : "+",
      ID : "ENSG00000183979.8",
      gene_id : "ENSG00000183979.8",
      gene_type : "protein_coding",
      gene_name : "NPB",
      gene_level : 2,
      hgnc_id : "HGNC:30099",
      havana_gene : "OTTHUMG00000177983.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81900958,
      stop : 81911432,
      direction : "-",
      ID : "ENSG00000185813.11",
      gene_id : "ENSG00000185813.11",
      gene_type : "protein_coding",
      gene_name : "PCYT2",
      gene_level : 1,
      hgnc_id : "HGNC:8756",
      havana_gene : "OTTHUMG00000177956.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81911939,
      stop : 81921323,
      direction : "-",
      ID : "ENSG00000187531.14",
      gene_id : "ENSG00000187531.14",
      gene_type : "protein_coding",
      gene_name : "SIRT7",
      gene_level : 2,
      hgnc_id : "HGNC:14935",
      havana_gene : "OTTHUMG00000177957.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81918270,
      stop : 81927735,
      direction : "-",
      ID : "ENSG00000197063.11",
      gene_id : "ENSG00000197063.11",
      gene_type : "protein_coding",
      gene_name : "MAFG",
      gene_level : 2,
      hgnc_id : "HGNC:6781",
      havana_gene : "OTTHUMG00000177958.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81932384,
      stop : 81942412,
      direction : "-",
      ID : "ENSG00000183010.17",
      gene_id : "ENSG00000183010.17",
      gene_type : "protein_coding",
      gene_name : "PYCR1",
      gene_level : 1,
      hgnc_id : "HGNC:9721",
      havana_gene : "OTTHUMG00000178436.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81939645,
      stop : 81947233,
      direction : "-",
      ID : "ENSG00000185105.5",
      gene_id : "ENSG00000185105.5",
      gene_type : "protein_coding",
      gene_name : "MYADML2",
      gene_level : 2,
      hgnc_id : "HGNC:34548",
      havana_gene : "OTTHUMG00000154388.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81952507,
      stop : 81961840,
      direction : "-",
      ID : "ENSG00000185269.12",
      gene_id : "ENSG00000185269.12",
      gene_type : "protein_coding",
      gene_name : "NOTUM",
      gene_level : 2,
      hgnc_id : "HGNC:27106",
      havana_gene : "OTTHUMG00000154416.8",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 81976807,
      stop : 82017406,
      direction : "+",
      ID : "ENSG00000169696.16",
      gene_id : "ENSG00000169696.16",
      gene_type : "protein_coding",
      gene_name : "ASPSCR1",
      gene_level : 2,
      hgnc_id : "HGNC:13825",
      havana_gene : "OTTHUMG00000178438.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82018702,
      stop : 82024107,
      direction : "-",
      ID : "ENSG00000169689.15",
      gene_id : "ENSG00000169689.15",
      gene_type : "protein_coding",
      gene_name : "CENPX",
      gene_level : 2,
      hgnc_id : "HGNC:11422",
      havana_gene : "OTTHUMG00000132129.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82023305,
      stop : 82031151,
      direction : "+",
      ID : "ENSG00000169683.8",
      gene_id : "ENSG00000169683.8",
      gene_type : "protein_coding",
      gene_name : "LRRC45",
      gene_level : 2,
      hgnc_id : "HGNC:28302",
      havana_gene : "OTTHUMG00000178454.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82031678,
      stop : 82034204,
      direction : "+",
      ID : "ENSG00000169750.9",
      gene_id : "ENSG00000169750.9",
      gene_type : "protein_coding",
      gene_name : "RAC3",
      gene_level : 2,
      hgnc_id : "HGNC:9803",
      havana_gene : "OTTHUMG00000178455.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82035136,
      stop : 82037709,
      direction : "-",
      ID : "ENSG00000169738.8",
      gene_id : "ENSG00000169738.8",
      gene_type : "protein_coding",
      gene_name : "DCXR",
      gene_level : 2,
      hgnc_id : "HGNC:18985",
      havana_gene : "OTTHUMG00000178483.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82047902,
      stop : 82051831,
      direction : "-",
      ID : "ENSG00000169733.12",
      gene_id : "ENSG00000169733.12",
      gene_type : "protein_coding",
      gene_name : "RFNG",
      gene_level : 1,
      hgnc_id : "HGNC:9974",
      havana_gene : "OTTHUMG00000178512.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82050691,
      stop : 82057470,
      direction : "+",
      ID : "ENSG00000169727.12",
      gene_id : "ENSG00000169727.12",
      gene_type : "protein_coding",
      gene_name : "GPS1",
      gene_level : 1,
      hgnc_id : "HGNC:4549",
      havana_gene : "OTTHUMG00000178484.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82057506,
      stop : 82065887,
      direction : "-",
      ID : "ENSG00000169718.18",
      gene_id : "ENSG00000169718.18",
      gene_type : "protein_coding",
      gene_name : "DUS1L",
      gene_level : 1,
      hgnc_id : "HGNC:30086",
      havana_gene : "OTTHUMG00000178525.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82078338,
      stop : 82098294,
      direction : "-",
      ID : "ENSG00000169710.9",
      gene_id : "ENSG00000169710.9",
      gene_type : "protein_coding",
      gene_name : "FASN",
      gene_level : 2,
      hgnc_id : "HGNC:3594",
      havana_gene : "OTTHUMG00000178527.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82101460,
      stop : 82212830,
      direction : "-",
      ID : "ENSG00000176155.19",
      gene_id : "ENSG00000176155.19",
      gene_type : "protein_coding",
      gene_name : "CCDC57",
      gene_level : 1,
      hgnc_id : "HGNC:27564",
      havana_gene : "OTTHUMG00000140396.9",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82217934,
      stop : 82261129,
      direction : "+",
      ID : "ENSG00000141526.18",
      gene_id : "ENSG00000141526.18",
      gene_type : "protein_coding",
      gene_name : "SLC16A3",
      gene_level : 1,
      hgnc_id : "HGNC:10924",
      havana_gene : "OTTHUMG00000178832.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82239023,
      stop : 82273731,
      direction : "-",
      ID : "ENSG00000141551.14",
      gene_id : "ENSG00000141551.14",
      gene_type : "protein_coding",
      gene_name : "CSNK1D",
      gene_level : 1,
      hgnc_id : "HGNC:2452",
      havana_gene : "OTTHUMG00000178601.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82314868,
      stop : 82317608,
      direction : "-",
      ID : "ENSG00000173762.8",
      gene_id : "ENSG00000173762.8",
      gene_type : "protein_coding",
      gene_name : "CD7",
      gene_level : 1,
      hgnc_id : "HGNC:1695",
      havana_gene : "OTTHUMG00000178662.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82321024,
      stop : 82334074,
      direction : "-",
      ID : "ENSG00000141574.8",
      gene_id : "ENSG00000141574.8",
      gene_type : "protein_coding",
      gene_name : "SECTM1",
      gene_level : 2,
      hgnc_id : "HGNC:10707",
      havana_gene : "OTTHUMG00000178668.3",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82359247,
      stop : 82363775,
      direction : "+",
      ID : "ENSG00000182459.5",
      gene_id : "ENSG00000182459.5",
      gene_type : "protein_coding",
      gene_name : "TEX19",
      gene_level : 2,
      hgnc_id : "HGNC:33802",
      havana_gene : "OTTHUMG00000132857.2",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82371400,
      stop : 82375586,
      direction : "+",
      ID : "ENSG00000181408.4",
      gene_id : "ENSG00000181408.4",
      gene_type : "protein_coding",
      gene_name : "UTS2R",
      gene_level : 2,
      hgnc_id : "HGNC:4468",
      havana_gene : "OTTHUMG00000178835.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82389210,
      stop : 82418637,
      direction : "-",
      ID : "ENSG00000181396.13",
      gene_id : "ENSG00000181396.13",
      gene_type : "protein_coding",
      gene_name : "OGFOD3",
      gene_level : 1,
      hgnc_id : "HGNC:26174",
      havana_gene : "OTTHUMG00000178679.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82418318,
      stop : 82442645,
      direction : "+",
      ID : "ENSG00000169660.17",
      gene_id : "ENSG00000169660.17",
      gene_type : "protein_coding",
      gene_name : "HEXD",
      gene_level : 2,
      hgnc_id : "HGNC:26307",
      havana_gene : "OTTHUMG00000178836.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82442586,
      stop : 82450829,
      direction : "-",
      ID : "ENSG00000178927.18",
      gene_id : "ENSG00000178927.18",
      gene_type : "protein_coding",
      gene_name : "CYBC1",
      gene_level : 1,
      hgnc_id : "HGNC:28672",
      havana_gene : "OTTHUMG00000178770.6",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82458180,
      stop : 82490537,
      direction : "+",
      ID : "ENSG00000141562.18",
      gene_id : "ENSG00000141562.18",
      gene_type : "protein_coding",
      gene_name : "NARF",
      gene_level : 1,
      hgnc_id : "HGNC:29916",
      havana_gene : "OTTHUMG00000178844.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82519713,
      stop : 82644662,
      direction : "+",
      ID : "ENSG00000141568.21",
      gene_id : "ENSG00000141568.21",
      gene_type : "protein_coding",
      gene_name : "FOXK2",
      gene_level : 1,
      hgnc_id : "HGNC:6036",
      havana_gene : "OTTHUMG00000140374.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82614562,
      stop : 82648553,
      direction : "-",
      ID : "ENSG00000141580.16",
      gene_id : "ENSG00000141580.16",
      gene_type : "protein_coding",
      gene_name : "WDR45B",
      gene_level : 2,
      hgnc_id : "HGNC:25072",
      havana_gene : "OTTHUMG00000150146.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82654973,
      stop : 82698698,
      direction : "-",
      ID : "ENSG00000141542.11",
      gene_id : "ENSG00000141542.11",
      gene_type : "protein_coding",
      gene_name : "RAB40B",
      gene_level : 1,
      hgnc_id : "HGNC:18284",
      havana_gene : "OTTHUMG00000177806.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82716706,
      stop : 82730328,
      direction : "+",
      ID : "ENSG00000141560.15",
      gene_id : "ENSG00000141560.15",
      gene_type : "protein_coding",
      gene_name : "FN3KRP",
      gene_level : 2,
      hgnc_id : "HGNC:25700",
      havana_gene : "OTTHUMG00000177846.5",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82735615,
      stop : 82751196,
      direction : "+",
      ID : "ENSG00000167363.14",
      gene_id : "ENSG00000167363.14",
      gene_type : "protein_coding",
      gene_name : "FN3K",
      gene_level : 1,
      hgnc_id : "HGNC:24822",
      havana_gene : "OTTHUMG00000177847.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82752065,
      stop : 82945914,
      direction : "+",
      ID : "ENSG00000141556.21",
      gene_id : "ENSG00000141556.21",
      gene_type : "protein_coding",
      gene_name : "TBCD",
      gene_level : 2,
      hgnc_id : "HGNC:11581",
      havana_gene : "OTTHUMG00000177878.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82829434,
      stop : 82840022,
      direction : "-",
      ID : "ENSG00000141579.7",
      gene_id : "ENSG00000141579.7",
      gene_type : "protein_coding",
      gene_name : "ZNF750",
      gene_level : 2,
      hgnc_id : "HGNC:25843",
      havana_gene : "OTTHUMG00000177822.4",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 82942155,
      stop : 83051810,
      direction : "-",
      ID : "ENSG00000175711.8",
      gene_id : "ENSG00000175711.8",
      gene_type : "protein_coding",
      gene_name : "B3GNTL1",
      gene_level : 1,
      hgnc_id : "HGNC:21727",
      havana_gene : "OTTHUMG00000177788.1",
      tag : null
    },
    {
      chromosome : 17,
      annotation : "HAVANA",
      type : "gene",
      start : 83079609,
      stop : 83095122,
      direction : "+",
      ID : "ENSG00000176845.13",
      gene_id : "ENSG00000176845.13",
      gene_type : "protein_coding",
      gene_name : "METRNL",
      gene_level : 2,
      hgnc_id : "HGNC:27584",
      havana_gene : "OTTHUMG00000177771.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47390,
      stop : 49557,
      direction : "-",
      ID : "ENSG00000173213.9",
      gene_id : "ENSG00000173213.9",
      gene_type : "protein_coding",
      gene_name : "TUBB8B",
      gene_level : 2,
      hgnc_id : "HGNC:24983",
      havana_gene : "OTTHUMG00000163448.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 158383,
      stop : 214629,
      direction : "+",
      ID : "ENSG00000101557.15",
      gene_id : "ENSG00000101557.15",
      gene_type : "protein_coding",
      gene_name : "USP14",
      gene_level : 1,
      hgnc_id : "HGNC:12612",
      havana_gene : "OTTHUMG00000178040.10",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 214520,
      stop : 268050,
      direction : "-",
      ID : "ENSG00000079134.12",
      gene_id : "ENSG00000079134.12",
      gene_type : "protein_coding",
      gene_name : "THOC1",
      gene_level : 2,
      hgnc_id : "HGNC:19070",
      havana_gene : "OTTHUMG00000178051.12",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 316737,
      stop : 500722,
      direction : "-",
      ID : "ENSG00000158270.12",
      gene_id : "ENSG00000158270.12",
      gene_type : "protein_coding",
      gene_name : "COLEC12",
      gene_level : 2,
      hgnc_id : "HGNC:16016",
      havana_gene : "OTTHUMG00000178145.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 580380,
      stop : 582114,
      direction : "+",
      ID : "ENSG00000177143.5",
      gene_id : "ENSG00000177143.5",
      gene_type : "protein_coding",
      gene_name : "CETN1",
      gene_level : 2,
      hgnc_id : "HGNC:1866",
      havana_gene : "OTTHUMG00000131471.3",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 596988,
      stop : 650334,
      direction : "+",
      ID : "ENSG00000079101.16",
      gene_id : "ENSG00000079101.16",
      gene_type : "protein_coding",
      gene_name : "CLUL1",
      gene_level : 1,
      hgnc_id : "HGNC:2096",
      havana_gene : "OTTHUMG00000178252.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 657653,
      stop : 673578,
      direction : "+",
      ID : "ENSG00000176890.16",
      gene_id : "ENSG00000176890.16",
      gene_type : "protein_coding",
      gene_name : "TYMS",
      gene_level : 1,
      hgnc_id : "HGNC:12441",
      havana_gene : "OTTHUMG00000131473.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 670318,
      stop : 712662,
      direction : "-",
      ID : "ENSG00000132199.20",
      gene_id : "ENSG00000132199.20",
      gene_type : "protein_coding",
      gene_name : "ENOSF1",
      gene_level : 2,
      hgnc_id : "HGNC:30365",
      havana_gene : "OTTHUMG00000131470.12",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 721588,
      stop : 812546,
      direction : "-",
      ID : "ENSG00000176105.14",
      gene_id : "ENSG00000176105.14",
      gene_type : "protein_coding",
      gene_name : "YES1",
      gene_level : 2,
      hgnc_id : "HGNC:12841",
      havana_gene : "OTTHUMG00000131472.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 904871,
      stop : 912172,
      direction : "+",
      ID : "ENSG00000141433.13",
      gene_id : "ENSG00000141433.13",
      gene_type : "protein_coding",
      gene_name : "ADCYAP1",
      gene_level : 2,
      hgnc_id : "HGNC:241",
      havana_gene : "OTTHUMG00000131479.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 2537525,
      stop : 2571509,
      direction : "-",
      ID : "ENSG00000101574.15",
      gene_id : "ENSG00000101574.15",
      gene_type : "protein_coding",
      gene_name : "METTL4",
      gene_level : 1,
      hgnc_id : "HGNC:24726",
      havana_gene : "OTTHUMG00000131482.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 2571557,
      stop : 2616635,
      direction : "+",
      ID : "ENSG00000080986.13",
      gene_id : "ENSG00000080986.13",
      gene_type : "protein_coding",
      gene_name : "NDC80",
      gene_level : 1,
      hgnc_id : "HGNC:16909",
      havana_gene : "OTTHUMG00000131483.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 2655726,
      stop : 2805017,
      direction : "+",
      ID : "ENSG00000101596.16",
      gene_id : "ENSG00000101596.16",
      gene_type : "protein_coding",
      gene_name : "SMCHD1",
      gene_level : 1,
      hgnc_id : "HGNC:29090",
      havana_gene : "OTTHUMG00000178235.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 2847006,
      stop : 2916003,
      direction : "+",
      ID : "ENSG00000132205.11",
      gene_id : "ENSG00000132205.11",
      gene_type : "protein_coding",
      gene_name : "EMILIN2",
      gene_level : 2,
      hgnc_id : "HGNC:19881",
      havana_gene : "OTTHUMG00000128525.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 2916994,
      stop : 3013144,
      direction : "-",
      ID : "ENSG00000101577.10",
      gene_id : "ENSG00000101577.10",
      gene_type : "protein_coding",
      gene_name : "LPIN2",
      gene_level : 1,
      hgnc_id : "HGNC:14450",
      havana_gene : "OTTHUMG00000131508.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 3066807,
      stop : 3219968,
      direction : "-",
      ID : "ENSG00000101605.13",
      gene_id : "ENSG00000101605.13",
      gene_type : "protein_coding",
      gene_name : "MYOM1",
      gene_level : 2,
      hgnc_id : "HGNC:7613",
      havana_gene : "OTTHUMG00000178209.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 3247481,
      stop : 3256236,
      direction : "+",
      ID : "ENSG00000101608.13",
      gene_id : "ENSG00000101608.13",
      gene_type : "protein_coding",
      gene_name : "MYL12A",
      gene_level : 2,
      hgnc_id : "HGNC:16701",
      havana_gene : "OTTHUMG00000131509.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 3261479,
      stop : 3278461,
      direction : "+",
      ID : "ENSG00000118680.14",
      gene_id : "ENSG00000118680.14",
      gene_type : "protein_coding",
      gene_name : "MYL12B",
      gene_level : 2,
      hgnc_id : "HGNC:29827",
      havana_gene : "OTTHUMG00000131510.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 3411608,
      stop : 3459978,
      direction : "+",
      ID : "ENSG00000177426.22",
      gene_id : "ENSG00000177426.22",
      gene_type : "protein_coding",
      gene_name : "TGIF1",
      gene_level : 1,
      hgnc_id : "HGNC:11776",
      havana_gene : "OTTHUMG00000131511.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 3496032,
      stop : 4455307,
      direction : "-",
      ID : "ENSG00000170579.17",
      gene_id : "ENSG00000170579.17",
      gene_type : "protein_coding",
      gene_name : "DLGAP1",
      gene_level : 1,
      hgnc_id : "HGNC:2905",
      havana_gene : "OTTHUMG00000131537.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 5142911,
      stop : 5197503,
      direction : "-",
      ID : "ENSG00000231824.4",
      gene_id : "ENSG00000231824.4",
      gene_type : "protein_coding",
      gene_name : "AKAIN1",
      gene_level : 2,
      hgnc_id : "HGNC:28285",
      havana_gene : "OTTHUMG00000178457.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 5289019,
      stop : 5297053,
      direction : "-",
      ID : "ENSG00000198081.11",
      gene_id : "ENSG00000198081.11",
      gene_type : "protein_coding",
      gene_name : "ZBTB14",
      gene_level : 2,
      hgnc_id : "HGNC:12860",
      havana_gene : "OTTHUMG00000131563.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 5392381,
      stop : 5630700,
      direction : "-",
      ID : "ENSG00000082397.18",
      gene_id : "ENSG00000082397.18",
      gene_type : "protein_coding",
      gene_name : "EPB41L3",
      gene_level : 2,
      hgnc_id : "HGNC:3380",
      havana_gene : "OTTHUMG00000131562.12",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 5882072,
      stop : 5895955,
      direction : "-",
      ID : "ENSG00000206432.4",
      gene_id : "ENSG00000206432.4",
      gene_type : "protein_coding",
      gene_name : "TMEM200C",
      gene_level : 2,
      hgnc_id : "HGNC:37208",
      havana_gene : "OTTHUMG00000178423.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 5954706,
      stop : 6415237,
      direction : "-",
      ID : "ENSG00000154655.16",
      gene_id : "ENSG00000154655.16",
      gene_type : "protein_coding",
      gene_name : "L3MBTL4",
      gene_level : 2,
      hgnc_id : "HGNC:26677",
      havana_gene : "OTTHUMG00000178980.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 6729716,
      stop : 6915716,
      direction : "+",
      ID : "ENSG00000088756.13",
      gene_id : "ENSG00000088756.13",
      gene_type : "protein_coding",
      gene_name : "ARHGAP28",
      gene_level : 1,
      hgnc_id : "HGNC:25509",
      havana_gene : "OTTHUMG00000167698.10",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 6941742,
      stop : 7117797,
      direction : "-",
      ID : "ENSG00000101680.15",
      gene_id : "ENSG00000101680.15",
      gene_type : "protein_coding",
      gene_name : "LAMA1",
      gene_level : 2,
      hgnc_id : "HGNC:6481",
      havana_gene : "OTTHUMG00000133478.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 7231125,
      stop : 7232047,
      direction : "+",
      ID : "ENSG00000206422.2",
      gene_id : "ENSG00000206422.2",
      gene_type : "protein_coding",
      gene_name : "LRRC30",
      gene_level : 2,
      hgnc_id : "HGNC:30219",
      havana_gene : "OTTHUMG00000178479.1",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 7566782,
      stop : 8406861,
      direction : "+",
      ID : "ENSG00000173482.17",
      gene_id : "ENSG00000173482.17",
      gene_type : "protein_coding",
      gene_name : "PTPRM",
      gene_level : 2,
      hgnc_id : "HGNC:9675",
      havana_gene : "OTTHUMG00000131575.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 8609437,
      stop : 8639382,
      direction : "+",
      ID : "ENSG00000206418.4",
      gene_id : "ENSG00000206418.4",
      gene_type : "protein_coding",
      gene_name : "RAB12",
      gene_level : 2,
      hgnc_id : "HGNC:31332",
      havana_gene : "OTTHUMG00000178949.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 8705661,
      stop : 8832778,
      direction : "+",
      ID : "ENSG00000168502.17",
      gene_id : "ENSG00000168502.17",
      gene_type : "protein_coding",
      gene_name : "MTCL1",
      gene_level : 1,
      hgnc_id : "HGNC:29121",
      havana_gene : "OTTHUMG00000131594.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9102630,
      stop : 9134345,
      direction : "+",
      ID : "ENSG00000178127.13",
      gene_id : "ENSG00000178127.13",
      gene_type : "protein_coding",
      gene_name : "NDUFV2",
      gene_level : 2,
      hgnc_id : "HGNC:7717",
      havana_gene : "OTTHUMG00000131593.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9136228,
      stop : 9285985,
      direction : "+",
      ID : "ENSG00000101745.17",
      gene_id : "ENSG00000101745.17",
      gene_type : "protein_coding",
      gene_name : "ANKRD12",
      gene_level : 1,
      hgnc_id : "HGNC:29135",
      havana_gene : "OTTHUMG00000131595.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9334767,
      stop : 9402420,
      direction : "+",
      ID : "ENSG00000128791.12",
      gene_id : "ENSG00000128791.12",
      gene_type : "protein_coding",
      gene_name : "TWSG1",
      gene_level : 2,
      hgnc_id : "HGNC:12429",
      havana_gene : "OTTHUMG00000131597.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9475009,
      stop : 9538114,
      direction : "+",
      ID : "ENSG00000017797.13",
      gene_id : "ENSG00000017797.13",
      gene_type : "protein_coding",
      gene_name : "RALBP1",
      gene_level : 2,
      hgnc_id : "HGNC:9841",
      havana_gene : "OTTHUMG00000131596.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9546791,
      stop : 9615240,
      direction : "-",
      ID : "ENSG00000154845.16",
      gene_id : "ENSG00000154845.16",
      gene_type : "protein_coding",
      gene_name : "PPP4R1",
      gene_level : 2,
      hgnc_id : "HGNC:9320",
      havana_gene : "OTTHUMG00000137466.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9708275,
      stop : 9862551,
      direction : "+",
      ID : "ENSG00000168461.13",
      gene_id : "ENSG00000168461.13",
      gene_type : "protein_coding",
      gene_name : "RAB31",
      gene_level : 2,
      hgnc_id : "HGNC:9771",
      havana_gene : "OTTHUMG00000178513.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9885726,
      stop : 9889275,
      direction : "+",
      ID : "ENSG00000168454.12",
      gene_id : "ENSG00000168454.12",
      gene_type : "protein_coding",
      gene_name : "TXNDC2",
      gene_level : 2,
      hgnc_id : "HGNC:16470",
      havana_gene : "OTTHUMG00000131602.6",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 9914016,
      stop : 9960021,
      direction : "+",
      ID : "ENSG00000101558.14",
      gene_id : "ENSG00000101558.14",
      gene_type : "protein_coding",
      gene_name : "VAPA",
      gene_level : 2,
      hgnc_id : "HGNC:12648",
      havana_gene : "OTTHUMG00000131603.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 10454635,
      stop : 10489949,
      direction : "+",
      ID : "ENSG00000154856.13",
      gene_id : "ENSG00000154856.13",
      gene_type : "protein_coding",
      gene_name : "APCDD1",
      gene_level : 2,
      hgnc_id : "HGNC:15718",
      havana_gene : "OTTHUMG00000131635.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 10525905,
      stop : 10552764,
      direction : "+",
      ID : "ENSG00000134265.13",
      gene_id : "ENSG00000134265.13",
      gene_type : "protein_coding",
      gene_name : "NAPG",
      gene_level : 1,
      hgnc_id : "HGNC:7642",
      havana_gene : "OTTHUMG00000179119.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 10666483,
      stop : 11149569,
      direction : "-",
      ID : "ENSG00000154864.13",
      gene_id : "ENSG00000154864.13",
      gene_type : "protein_coding",
      gene_name : "PIEZO2",
      gene_level : 1,
      hgnc_id : "HGNC:26270",
      havana_gene : "OTTHUMG00000178507.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 11609596,
      stop : 11610612,
      direction : "+",
      ID : "ENSG00000236396.8",
      gene_id : "ENSG00000236396.8",
      gene_type : "protein_coding",
      gene_name : "SLC35G4",
      gene_level : 2,
      hgnc_id : "HGNC:31043",
      havana_gene : "OTTHUMG00000180598.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 11689264,
      stop : 11885685,
      direction : "+",
      ID : "ENSG00000141404.17",
      gene_id : "ENSG00000141404.17",
      gene_type : "protein_coding",
      gene_name : "GNAL",
      gene_level : 1,
      hgnc_id : "HGNC:4388",
      havana_gene : "OTTHUMG00000131660.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 11851413,
      stop : 11854444,
      direction : "+",
      ID : "ENSG00000255112.3",
      gene_id : "ENSG00000255112.3",
      gene_type : "protein_coding",
      gene_name : "CHMP1B",
      gene_level : 2,
      hgnc_id : "HGNC:24287",
      havana_gene : "OTTHUMG00000165820.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 11882622,
      stop : 11908366,
      direction : "-",
      ID : "ENSG00000154889.17",
      gene_id : "ENSG00000154889.17",
      gene_type : "protein_coding",
      gene_name : "MPPE1",
      gene_level : 1,
      hgnc_id : "HGNC:15988",
      havana_gene : "OTTHUMG00000131661.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 11981025,
      stop : 12030877,
      direction : "+",
      ID : "ENSG00000141401.12",
      gene_id : "ENSG00000141401.12",
      gene_type : "protein_coding",
      gene_name : "IMPA2",
      gene_level : 2,
      hgnc_id : "HGNC:6051",
      havana_gene : "OTTHUMG00000131693.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12093843,
      stop : 12129764,
      direction : "+",
      ID : "ENSG00000181626.12",
      gene_id : "ENSG00000181626.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD62",
      gene_level : 2,
      hgnc_id : "HGNC:35241",
      havana_gene : "OTTHUMG00000180673.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12254361,
      stop : 12277595,
      direction : "+",
      ID : "ENSG00000176194.18",
      gene_id : "ENSG00000176194.18",
      gene_type : "protein_coding",
      gene_name : "CIDEA",
      gene_level : 2,
      hgnc_id : "HGNC:1976",
      havana_gene : "OTTHUMG00000131691.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12307669,
      stop : 12344320,
      direction : "+",
      ID : "ENSG00000176014.13",
      gene_id : "ENSG00000176014.13",
      gene_type : "protein_coding",
      gene_name : "TUBB6",
      gene_level : 1,
      hgnc_id : "HGNC:20776",
      havana_gene : "OTTHUMG00000131692.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12328944,
      stop : 12377227,
      direction : "-",
      ID : "ENSG00000141385.10",
      gene_id : "ENSG00000141385.10",
      gene_type : "protein_coding",
      gene_name : "AFG3L2",
      gene_level : 2,
      hgnc_id : "HGNC:315",
      havana_gene : "OTTHUMG00000131695.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12407896,
      stop : 12432238,
      direction : "+",
      ID : "ENSG00000141391.14",
      gene_id : "ENSG00000141391.14",
      gene_type : "protein_coding",
      gene_name : "PRELID3A",
      gene_level : 2,
      hgnc_id : "HGNC:24639",
      havana_gene : "OTTHUMG00000131694.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12446512,
      stop : 12658134,
      direction : "-",
      ID : "ENSG00000134278.15",
      gene_id : "ENSG00000134278.15",
      gene_type : "protein_coding",
      gene_name : "SPIRE1",
      gene_level : 2,
      hgnc_id : "HGNC:30622",
      havana_gene : "OTTHUMG00000153940.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12658043,
      stop : 12725740,
      direction : "+",
      ID : "ENSG00000128789.21",
      gene_id : "ENSG00000128789.21",
      gene_type : "protein_coding",
      gene_name : "PSMG2",
      gene_level : 2,
      hgnc_id : "HGNC:24929",
      havana_gene : "OTTHUMG00000131703.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12661833,
      stop : 12702777,
      direction : "-",
      ID : "ENSG00000101624.11",
      gene_id : "ENSG00000101624.11",
      gene_type : "protein_coding",
      gene_name : "CEP76",
      gene_level : 1,
      hgnc_id : "HGNC:25727",
      havana_gene : "OTTHUMG00000131701.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12785478,
      stop : 12929643,
      direction : "-",
      ID : "ENSG00000175354.20",
      gene_id : "ENSG00000175354.20",
      gene_type : "protein_coding",
      gene_name : "PTPN2",
      gene_level : 1,
      hgnc_id : "HGNC:9650",
      havana_gene : "OTTHUMG00000131702.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12947133,
      stop : 12987536,
      direction : "+",
      ID : "ENSG00000085415.16",
      gene_id : "ENSG00000085415.16",
      gene_type : "protein_coding",
      gene_name : "SEH1L",
      gene_level : 2,
      hgnc_id : "HGNC:30379",
      havana_gene : "OTTHUMG00000181909.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 12991362,
      stop : 13125052,
      direction : "+",
      ID : "ENSG00000101639.18",
      gene_id : "ENSG00000101639.18",
      gene_type : "protein_coding",
      gene_name : "CEP192",
      gene_level : 2,
      hgnc_id : "HGNC:25515",
      havana_gene : "OTTHUMG00000160693.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 13217498,
      stop : 13652755,
      direction : "+",
      ID : "ENSG00000168675.19",
      gene_id : "ENSG00000168675.19",
      gene_type : "protein_coding",
      gene_name : "LDLRAD4",
      gene_level : 1,
      hgnc_id : "HGNC:1224",
      havana_gene : "OTTHUMG00000181925.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 13663347,
      stop : 13726663,
      direction : "-",
      ID : "ENSG00000177150.13",
      gene_id : "ENSG00000177150.13",
      gene_type : "protein_coding",
      gene_name : "FAM210A",
      gene_level : 2,
      hgnc_id : "HGNC:28346",
      havana_gene : "OTTHUMG00000131719.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 13726660,
      stop : 13764556,
      direction : "+",
      ID : "ENSG00000101654.18",
      gene_id : "ENSG00000101654.18",
      gene_type : "protein_coding",
      gene_name : "RNMT",
      gene_level : 2,
      hgnc_id : "HGNC:10075",
      havana_gene : "OTTHUMG00000131718.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 13824149,
      stop : 13827323,
      direction : "+",
      ID : "ENSG00000176136.6",
      gene_id : "ENSG00000176136.6",
      gene_type : "protein_coding",
      gene_name : "MC5R",
      gene_level : 2,
      hgnc_id : "HGNC:6933",
      havana_gene : "OTTHUMG00000131720.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 13882044,
      stop : 13915707,
      direction : "-",
      ID : "ENSG00000185231.5",
      gene_id : "ENSG00000185231.5",
      gene_type : "protein_coding",
      gene_name : "MC2R",
      gene_level : 2,
      hgnc_id : "HGNC:6930",
      havana_gene : "OTTHUMG00000131721.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 14057457,
      stop : 14132490,
      direction : "-",
      ID : "ENSG00000175322.12",
      gene_id : "ENSG00000175322.12",
      gene_type : "protein_coding",
      gene_name : "ZNF519",
      gene_level : 1,
      hgnc_id : "HGNC:30574",
      havana_gene : "OTTHUMG00000182055.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 14507339,
      stop : 14543585,
      direction : "-",
      ID : "ENSG00000183206.17",
      gene_id : "ENSG00000183206.17",
      gene_type : "protein_coding",
      gene_name : "POTEC",
      gene_level : 2,
      hgnc_id : "HGNC:33894",
      havana_gene : "OTTHUMG00000162963.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 14728272,
      stop : 14854038,
      direction : "+",
      ID : "ENSG00000180777.14",
      gene_id : "ENSG00000180777.14",
      gene_type : "protein_coding",
      gene_name : "ANKRD30B",
      gene_level : 2,
      hgnc_id : "HGNC:24165",
      havana_gene : "OTTHUMG00000178841.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 20946906,
      stop : 21111813,
      direction : "-",
      ID : "ENSG00000067900.8",
      gene_id : "ENSG00000067900.8",
      gene_type : "protein_coding",
      gene_name : "ROCK1",
      gene_level : 2,
      hgnc_id : "HGNC:10251",
      havana_gene : "OTTHUMG00000131723.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 21242242,
      stop : 21525417,
      direction : "+",
      ID : "ENSG00000141449.15",
      gene_id : "ENSG00000141449.15",
      gene_type : "protein_coding",
      gene_name : "GREB1L",
      gene_level : 1,
      hgnc_id : "HGNC:31042",
      havana_gene : "OTTHUMG00000178892.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 21529284,
      stop : 21600884,
      direction : "-",
      ID : "ENSG00000141446.11",
      gene_id : "ENSG00000141446.11",
      gene_type : "protein_coding",
      gene_name : "ESCO1",
      gene_level : 2,
      hgnc_id : "HGNC:24645",
      havana_gene : "OTTHUMG00000178919.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 21612314,
      stop : 21633524,
      direction : "+",
      ID : "ENSG00000167088.11",
      gene_id : "ENSG00000167088.11",
      gene_type : "protein_coding",
      gene_name : "SNRPD1",
      gene_level : 1,
      hgnc_id : "HGNC:11158",
      havana_gene : "OTTHUMG00000178934.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 21650901,
      stop : 21704780,
      direction : "-",
      ID : "ENSG00000158201.10",
      gene_id : "ENSG00000158201.10",
      gene_type : "protein_coding",
      gene_name : "ABHD3",
      gene_level : 1,
      hgnc_id : "HGNC:18718",
      havana_gene : "OTTHUMG00000179099.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 21704957,
      stop : 21870953,
      direction : "+",
      ID : "ENSG00000101752.12",
      gene_id : "ENSG00000101752.12",
      gene_type : "protein_coding",
      gene_name : "MIB1",
      gene_level : 2,
      hgnc_id : "HGNC:21086",
      havana_gene : "OTTHUMG00000131753.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 22169589,
      stop : 22202528,
      direction : "+",
      ID : "ENSG00000141448.11",
      gene_id : "ENSG00000141448.11",
      gene_type : "protein_coding",
      gene_name : "GATA6",
      gene_level : 2,
      hgnc_id : "HGNC:4174",
      havana_gene : "OTTHUMG00000131767.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 22413599,
      stop : 22417915,
      direction : "-",
      ID : "ENSG00000212710.5",
      gene_id : "ENSG00000212710.5",
      gene_type : "protein_coding",
      gene_name : "CTAGE1",
      gene_level : 2,
      hgnc_id : "HGNC:24346",
      havana_gene : "OTTHUMG00000165867.4",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 22798261,
      stop : 23026488,
      direction : "+",
      ID : "ENSG00000101773.19",
      gene_id : "ENSG00000101773.19",
      gene_type : "protein_coding",
      gene_name : "RBBP8",
      gene_level : 1,
      hgnc_id : "HGNC:9891",
      havana_gene : "OTTHUMG00000131769.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23134564,
      stop : 23260467,
      direction : "+",
      ID : "ENSG00000134508.12",
      gene_id : "ENSG00000134508.12",
      gene_type : "protein_coding",
      gene_name : "CABLES1",
      gene_level : 2,
      hgnc_id : "HGNC:25097",
      havana_gene : "OTTHUMG00000179186.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23197144,
      stop : 23437961,
      direction : "-",
      ID : "ENSG00000134490.14",
      gene_id : "ENSG00000134490.14",
      gene_type : "protein_coding",
      gene_name : "TMEM241",
      gene_level : 2,
      hgnc_id : "HGNC:31723",
      havana_gene : "OTTHUMG00000131771.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23453287,
      stop : 23486603,
      direction : "+",
      ID : "ENSG00000101782.15",
      gene_id : "ENSG00000101782.15",
      gene_type : "protein_coding",
      gene_name : "RIOK3",
      gene_level : 1,
      hgnc_id : "HGNC:11451",
      havana_gene : "OTTHUMG00000131813.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23503470,
      stop : 23531822,
      direction : "+",
      ID : "ENSG00000141452.10",
      gene_id : "ENSG00000141452.10",
      gene_type : "protein_coding",
      gene_name : "RMC1",
      gene_level : 1,
      hgnc_id : "HGNC:24326",
      havana_gene : "OTTHUMG00000179239.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23506184,
      stop : 23586506,
      direction : "-",
      ID : "ENSG00000141458.13",
      gene_id : "ENSG00000141458.13",
      gene_type : "protein_coding",
      gene_name : "NPC1",
      gene_level : 1,
      hgnc_id : "HGNC:7897",
      havana_gene : "OTTHUMG00000131873.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23598926,
      stop : 23662911,
      direction : "-",
      ID : "ENSG00000154065.17",
      gene_id : "ENSG00000154065.17",
      gene_type : "protein_coding",
      gene_name : "ANKRD29",
      gene_level : 2,
      hgnc_id : "HGNC:27110",
      havana_gene : "OTTHUMG00000131875.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23689453,
      stop : 23956222,
      direction : "+",
      ID : "ENSG00000053747.17",
      gene_id : "ENSG00000053747.17",
      gene_type : "protein_coding",
      gene_name : "LAMA3",
      gene_level : 1,
      hgnc_id : "HGNC:6483",
      havana_gene : "OTTHUMG00000131874.11",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 23992773,
      stop : 24135610,
      direction : "+",
      ID : "ENSG00000168234.13",
      gene_id : "ENSG00000168234.13",
      gene_type : "protein_coding",
      gene_name : "TTC39C",
      gene_level : 1,
      hgnc_id : "HGNC:26595",
      havana_gene : "OTTHUMG00000179403.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 24138987,
      stop : 24161600,
      direction : "+",
      ID : "ENSG00000154040.21",
      gene_id : "ENSG00000154040.21",
      gene_type : "protein_coding",
      gene_name : "CABYR",
      gene_level : 2,
      hgnc_id : "HGNC:15569",
      havana_gene : "OTTHUMG00000037365.11",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 24162045,
      stop : 24397880,
      direction : "-",
      ID : "ENSG00000141447.18",
      gene_id : "ENSG00000141447.18",
      gene_type : "protein_coding",
      gene_name : "OSBPL1A",
      gene_level : 1,
      hgnc_id : "HGNC:16398",
      havana_gene : "OTTHUMG00000131944.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 24426634,
      stop : 24453531,
      direction : "+",
      ID : "ENSG00000154059.11",
      gene_id : "ENSG00000154059.11",
      gene_type : "protein_coding",
      gene_name : "IMPACT",
      gene_level : 2,
      hgnc_id : "HGNC:20387",
      havana_gene : "OTTHUMG00000131943.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 24460637,
      stop : 24479961,
      direction : "+",
      ID : "ENSG00000134489.7",
      gene_id : "ENSG00000134489.7",
      gene_type : "protein_coding",
      gene_name : "HRH4",
      gene_level : 2,
      hgnc_id : "HGNC:17383",
      havana_gene : "OTTHUMG00000131945.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 25061924,
      stop : 25352190,
      direction : "-",
      ID : "ENSG00000198795.11",
      gene_id : "ENSG00000198795.11",
      gene_type : "protein_coding",
      gene_name : "ZNF521",
      gene_level : 2,
      hgnc_id : "HGNC:24605",
      havana_gene : "OTTHUMG00000179511.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 26016253,
      stop : 26091217,
      direction : "-",
      ID : "ENSG00000141380.14",
      gene_id : "ENSG00000141380.14",
      gene_type : "protein_coding",
      gene_name : "SS18",
      gene_level : 2,
      hgnc_id : "HGNC:11340",
      havana_gene : "OTTHUMG00000179425.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 26133852,
      stop : 26193355,
      direction : "+",
      ID : "ENSG00000154611.15",
      gene_id : "ENSG00000154611.15",
      gene_type : "protein_coding",
      gene_name : "PSMA8",
      gene_level : 2,
      hgnc_id : "HGNC:22985",
      havana_gene : "OTTHUMG00000179426.1",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 26226445,
      stop : 26391685,
      direction : "+",
      ID : "ENSG00000141384.13",
      gene_id : "ENSG00000141384.13",
      gene_type : "protein_coding",
      gene_name : "TAF4B",
      gene_level : 1,
      hgnc_id : "HGNC:11538",
      havana_gene : "OTTHUMG00000179429.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 26454910,
      stop : 26657401,
      direction : "-",
      ID : "ENSG00000134504.14",
      gene_id : "ENSG00000134504.14",
      gene_type : "protein_coding",
      gene_name : "KCTD1",
      gene_level : 2,
      hgnc_id : "HGNC:18249",
      havana_gene : "OTTHUMG00000131947.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 26852043,
      stop : 26865771,
      direction : "-",
      ID : "ENSG00000171885.18",
      gene_id : "ENSG00000171885.18",
      gene_type : "protein_coding",
      gene_name : "AQP4",
      gene_level : 2,
      hgnc_id : "HGNC:637",
      havana_gene : "OTTHUMG00000131955.9",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 26906481,
      stop : 27185308,
      direction : "-",
      ID : "ENSG00000154080.14",
      gene_id : "ENSG00000154080.14",
      gene_type : "protein_coding",
      gene_name : "CHST9",
      gene_level : 2,
      hgnc_id : "HGNC:19898",
      havana_gene : "OTTHUMG00000179469.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 27932879,
      stop : 28177946,
      direction : "-",
      ID : "ENSG00000170558.10",
      gene_id : "ENSG00000170558.10",
      gene_type : "protein_coding",
      gene_name : "CDH2",
      gene_level : 1,
      hgnc_id : "HGNC:1759",
      havana_gene : "OTTHUMG00000059940.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 30989365,
      stop : 31042815,
      direction : "-",
      ID : "ENSG00000134762.17",
      gene_id : "ENSG00000134762.17",
      gene_type : "protein_coding",
      gene_name : "DSC3",
      gene_level : 2,
      hgnc_id : "HGNC:3037",
      havana_gene : "OTTHUMG00000179622.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31058840,
      stop : 31102522,
      direction : "-",
      ID : "ENSG00000134755.17",
      gene_id : "ENSG00000134755.17",
      gene_type : "protein_coding",
      gene_name : "DSC2",
      gene_level : 2,
      hgnc_id : "HGNC:3036",
      havana_gene : "OTTHUMG00000131981.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31129236,
      stop : 31162856,
      direction : "-",
      ID : "ENSG00000134765.10",
      gene_id : "ENSG00000134765.10",
      gene_type : "protein_coding",
      gene_name : "DSC1",
      gene_level : 2,
      hgnc_id : "HGNC:3035",
      havana_gene : "OTTHUMG00000131982.1",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31318160,
      stop : 31359246,
      direction : "+",
      ID : "ENSG00000134760.6",
      gene_id : "ENSG00000134760.6",
      gene_type : "protein_coding",
      gene_name : "DSG1",
      gene_level : 2,
      hgnc_id : "HGNC:3048",
      havana_gene : "OTTHUMG00000131983.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31376777,
      stop : 31414912,
      direction : "+",
      ID : "ENSG00000175065.12",
      gene_id : "ENSG00000175065.12",
      gene_type : "protein_coding",
      gene_name : "DSG4",
      gene_level : 2,
      hgnc_id : "HGNC:21307",
      havana_gene : "OTTHUMG00000131979.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31447741,
      stop : 31478702,
      direction : "+",
      ID : "ENSG00000134757.5",
      gene_id : "ENSG00000134757.5",
      gene_type : "protein_coding",
      gene_name : "DSG3",
      gene_level : 2,
      hgnc_id : "HGNC:3050",
      havana_gene : "OTTHUMG00000131985.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31498177,
      stop : 31549008,
      direction : "+",
      ID : "ENSG00000046604.13",
      gene_id : "ENSG00000046604.13",
      gene_type : "protein_coding",
      gene_name : "DSG2",
      gene_level : 2,
      hgnc_id : "HGNC:3049",
      havana_gene : "OTTHUMG00000179649.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31557009,
      stop : 31598833,
      direction : "+",
      ID : "ENSG00000118271.12",
      gene_id : "ENSG00000118271.12",
      gene_type : "protein_coding",
      gene_name : "TTR",
      gene_level : 2,
      hgnc_id : "HGNC:12405",
      havana_gene : "OTTHUMG00000131984.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31622247,
      stop : 31685836,
      direction : "-",
      ID : "ENSG00000118276.11",
      gene_id : "ENSG00000118276.11",
      gene_type : "protein_coding",
      gene_name : "B4GALT6",
      gene_level : 1,
      hgnc_id : "HGNC:929",
      havana_gene : "OTTHUMG00000131980.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31759584,
      stop : 31760880,
      direction : "-",
      ID : "ENSG00000141437.10",
      gene_id : "ENSG00000141437.10",
      gene_type : "protein_coding",
      gene_name : "SLC25A52",
      gene_level : 2,
      hgnc_id : "HGNC:23324",
      havana_gene : "OTTHUMG00000179617.4",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 31829197,
      stop : 31953136,
      direction : "-",
      ID : "ENSG00000153339.15",
      gene_id : "ENSG00000153339.15",
      gene_type : "protein_coding",
      gene_name : "TRAPPC8",
      gene_level : 1,
      hgnc_id : "HGNC:29169",
      havana_gene : "OTTHUMG00000132267.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 32018825,
      stop : 32073219,
      direction : "+",
      ID : "ENSG00000101695.9",
      gene_id : "ENSG00000101695.9",
      gene_type : "protein_coding",
      gene_name : "RNF125",
      gene_level : 2,
      hgnc_id : "HGNC:21150",
      havana_gene : "OTTHUMG00000132266.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 32091874,
      stop : 32131561,
      direction : "+",
      ID : "ENSG00000134758.14",
      gene_id : "ENSG00000134758.14",
      gene_type : "protein_coding",
      gene_name : "RNF138",
      gene_level : 2,
      hgnc_id : "HGNC:17765",
      havana_gene : "OTTHUMG00000132265.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 32124877,
      stop : 32470882,
      direction : "-",
      ID : "ENSG00000141441.16",
      gene_id : "ENSG00000141441.16",
      gene_type : "protein_coding",
      gene_name : "GAREM1",
      gene_level : 1,
      hgnc_id : "HGNC:26136",
      havana_gene : "OTTHUMG00000132273.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 32185069,
      stop : 32220404,
      direction : "+",
      ID : "ENSG00000141434.12",
      gene_id : "ENSG00000141434.12",
      gene_type : "protein_coding",
      gene_name : "MEP1B",
      gene_level : 1,
      hgnc_id : "HGNC:7020",
      havana_gene : "OTTHUMG00000179708.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 32672673,
      stop : 32773023,
      direction : "-",
      ID : "ENSG00000197705.10",
      gene_id : "ENSG00000197705.10",
      gene_type : "protein_coding",
      gene_name : "KLHL14",
      gene_level : 2,
      hgnc_id : "HGNC:29266",
      havana_gene : "OTTHUMG00000179819.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 32937402,
      stop : 33441101,
      direction : "-",
      ID : "ENSG00000166960.16",
      gene_id : "ENSG00000166960.16",
      gene_type : "protein_coding",
      gene_name : "CCDC178",
      gene_level : 2,
      hgnc_id : "HGNC:29588",
      havana_gene : "OTTHUMG00000132279.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 33578219,
      stop : 33751195,
      direction : "+",
      ID : "ENSG00000141431.13",
      gene_id : "ENSG00000141431.13",
      gene_type : "protein_coding",
      gene_name : "ASXL3",
      gene_level : 2,
      hgnc_id : "HGNC:29357",
      havana_gene : "OTTHUMG00000178395.15",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 33851100,
      stop : 34224952,
      direction : "-",
      ID : "ENSG00000101746.16",
      gene_id : "ENSG00000101746.16",
      gene_type : "protein_coding",
      gene_name : "NOL4",
      gene_level : 1,
      hgnc_id : "HGNC:7870",
      havana_gene : "OTTHUMG00000132291.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 34493290,
      stop : 34891844,
      direction : "+",
      ID : "ENSG00000134769.22",
      gene_id : "ENSG00000134769.22",
      gene_type : "protein_coding",
      gene_name : "DTNA",
      gene_level : 1,
      hgnc_id : "HGNC:3057",
      havana_gene : "OTTHUMG00000132309.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 34976928,
      stop : 35143470,
      direction : "+",
      ID : "ENSG00000166974.13",
      gene_id : "ENSG00000166974.13",
      gene_type : "protein_coding",
      gene_name : "MAPRE2",
      gene_level : 2,
      hgnc_id : "HGNC:6891",
      havana_gene : "OTTHUMG00000132551.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35241030,
      stop : 35267133,
      direction : "+",
      ID : "ENSG00000186812.13",
      gene_id : "ENSG00000186812.13",
      gene_type : "protein_coding",
      gene_name : "ZNF397",
      gene_level : 1,
      hgnc_id : "HGNC:18818",
      havana_gene : "OTTHUMG00000178532.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35251058,
      stop : 35290245,
      direction : "-",
      ID : "ENSG00000186814.14",
      gene_id : "ENSG00000186814.14",
      gene_type : "protein_coding",
      gene_name : "ZSCAN30",
      gene_level : 1,
      hgnc_id : "HGNC:33517",
      havana_gene : "OTTHUMG00000178569.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35332227,
      stop : 35345482,
      direction : "-",
      ID : "ENSG00000172466.16",
      gene_id : "ENSG00000172466.16",
      gene_type : "protein_coding",
      gene_name : "ZNF24",
      gene_level : 1,
      hgnc_id : "HGNC:13032",
      havana_gene : "OTTHUMG00000132565.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35366694,
      stop : 35377337,
      direction : "-",
      ID : "ENSG00000186496.12",
      gene_id : "ENSG00000186496.12",
      gene_type : "protein_coding",
      gene_name : "ZNF396",
      gene_level : 2,
      hgnc_id : "HGNC:18824",
      havana_gene : "OTTHUMG00000132562.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35443871,
      stop : 35497940,
      direction : "-",
      ID : "ENSG00000267140.1",
      gene_id : "ENSG00000267140.1",
      gene_type : "protein_coding",
      gene_name : "AC007998.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178687.1",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35452230,
      stop : 35497979,
      direction : "-",
      ID : "ENSG00000153391.16",
      gene_id : "ENSG00000153391.16",
      gene_type : "protein_coding",
      gene_name : "INO80C",
      gene_level : 1,
      hgnc_id : "HGNC:26994",
      havana_gene : "OTTHUMG00000132564.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35581117,
      stop : 35711834,
      direction : "+",
      ID : "ENSG00000141429.13",
      gene_id : "ENSG00000141429.13",
      gene_type : "protein_coding",
      gene_name : "GALNT1",
      gene_level : 2,
      hgnc_id : "HGNC:4123",
      havana_gene : "OTTHUMG00000132567.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35972625,
      stop : 35979286,
      direction : "+",
      ID : "ENSG00000141428.17",
      gene_id : "ENSG00000141428.17",
      gene_type : "protein_coding",
      gene_name : "C18orf21",
      gene_level : 1,
      hgnc_id : "HGNC:28802",
      havana_gene : "OTTHUMG00000128531.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 35984387,
      stop : 36067576,
      direction : "-",
      ID : "ENSG00000141425.18",
      gene_id : "ENSG00000141425.18",
      gene_type : "protein_coding",
      gene_name : "RPRD1A",
      gene_level : 2,
      hgnc_id : "HGNC:25560",
      havana_gene : "OTTHUMG00000132591.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 36108531,
      stop : 36129385,
      direction : "-",
      ID : "ENSG00000141424.13",
      gene_id : "ENSG00000141424.13",
      gene_type : "protein_coding",
      gene_name : "SLC39A6",
      gene_level : 1,
      hgnc_id : "HGNC:18607",
      havana_gene : "OTTHUMG00000178965.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 36129444,
      stop : 36180557,
      direction : "+",
      ID : "ENSG00000134759.14",
      gene_id : "ENSG00000134759.14",
      gene_type : "protein_coding",
      gene_name : "ELP2",
      gene_level : 1,
      hgnc_id : "HGNC:18248",
      havana_gene : "OTTHUMG00000132589.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 36187497,
      stop : 36272157,
      direction : "+",
      ID : "ENSG00000075643.6",
      gene_id : "ENSG00000075643.6",
      gene_type : "protein_coding",
      gene_name : "MOCOS",
      gene_level : 2,
      hgnc_id : "HGNC:18234",
      havana_gene : "OTTHUMG00000132590.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 36297714,
      stop : 36780055,
      direction : "+",
      ID : "ENSG00000134775.15",
      gene_id : "ENSG00000134775.15",
      gene_type : "protein_coding",
      gene_name : "FHOD3",
      gene_level : 1,
      hgnc_id : "HGNC:26178",
      havana_gene : "OTTHUMG00000182381.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 36777647,
      stop : 36829216,
      direction : "-",
      ID : "ENSG00000134779.15",
      gene_id : "ENSG00000134779.15",
      gene_type : "protein_coding",
      gene_name : "TPGS2",
      gene_level : 1,
      hgnc_id : "HGNC:24561",
      havana_gene : "OTTHUMG00000178075.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 36829106,
      stop : 37232172,
      direction : "+",
      ID : "ENSG00000150477.15",
      gene_id : "ENSG00000150477.15",
      gene_type : "protein_coding",
      gene_name : "KIAA1328",
      gene_level : 1,
      hgnc_id : "HGNC:29248",
      havana_gene : "OTTHUMG00000178087.9",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 37243040,
      stop : 37565827,
      direction : "-",
      ID : "ENSG00000101489.20",
      gene_id : "ENSG00000101489.20",
      gene_type : "protein_coding",
      gene_name : "CELF4",
      gene_level : 1,
      hgnc_id : "HGNC:14015",
      havana_gene : "OTTHUMG00000178178.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 41955234,
      stop : 42087830,
      direction : "+",
      ID : "ENSG00000078142.13",
      gene_id : "ENSG00000078142.13",
      gene_type : "protein_coding",
      gene_name : "PIK3C3",
      gene_level : 2,
      hgnc_id : "HGNC:8974",
      havana_gene : "OTTHUMG00000132593.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 42743227,
      stop : 43115691,
      direction : "-",
      ID : "ENSG00000152214.14",
      gene_id : "ENSG00000152214.14",
      gene_type : "protein_coding",
      gene_name : "RIT2",
      gene_level : 2,
      hgnc_id : "HGNC:10017",
      havana_gene : "OTTHUMG00000132611.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 43267892,
      stop : 43277535,
      direction : "-",
      ID : "ENSG00000132872.12",
      gene_id : "ENSG00000132872.12",
      gene_type : "protein_coding",
      gene_name : "SYT4",
      gene_level : 2,
      hgnc_id : "HGNC:11512",
      havana_gene : "OTTHUMG00000132610.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 44680173,
      stop : 45068510,
      direction : "+",
      ID : "ENSG00000152217.20",
      gene_id : "ENSG00000152217.20",
      gene_type : "protein_coding",
      gene_name : "SETBP1",
      gene_level : 2,
      hgnc_id : "HGNC:15573",
      havana_gene : "OTTHUMG00000132613.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 45212995,
      stop : 45683688,
      direction : "+",
      ID : "ENSG00000132874.15",
      gene_id : "ENSG00000132874.15",
      gene_type : "protein_coding",
      gene_name : "SLC14A2",
      gene_level : 2,
      hgnc_id : "HGNC:10919",
      havana_gene : "OTTHUMG00000132616.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 45687025,
      stop : 45752520,
      direction : "+",
      ID : "ENSG00000141469.18",
      gene_id : "ENSG00000141469.18",
      gene_type : "protein_coding",
      gene_name : "SLC14A1",
      gene_level : 1,
      hgnc_id : "HGNC:10918",
      havana_gene : "OTTHUMG00000132617.18",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 45825675,
      stop : 45844094,
      direction : "+",
      ID : "ENSG00000197046.12",
      gene_id : "ENSG00000197046.12",
      gene_type : "protein_coding",
      gene_name : "SIGLEC15",
      gene_level : 2,
      hgnc_id : "HGNC:27596",
      havana_gene : "OTTHUMG00000170870.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 45847609,
      stop : 45967329,
      direction : "-",
      ID : "ENSG00000152223.15",
      gene_id : "ENSG00000152223.15",
      gene_type : "protein_coding",
      gene_name : "EPG5",
      gene_level : 2,
      hgnc_id : "HGNC:29331",
      havana_gene : "OTTHUMG00000132626.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 45983536,
      stop : 46072272,
      direction : "-",
      ID : "ENSG00000152229.18",
      gene_id : "ENSG00000152229.18",
      gene_type : "protein_coding",
      gene_name : "PSTPIP2",
      gene_level : 2,
      hgnc_id : "HGNC:9581",
      havana_gene : "OTTHUMG00000152674.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46080248,
      stop : 46104334,
      direction : "-",
      ID : "ENSG00000152234.16",
      gene_id : "ENSG00000152234.16",
      gene_type : "protein_coding",
      gene_name : "ATP5F1A",
      gene_level : 1,
      hgnc_id : "HGNC:823",
      havana_gene : "OTTHUMG00000132637.10",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46104378,
      stop : 46128333,
      direction : "+",
      ID : "ENSG00000152240.13",
      gene_id : "ENSG00000152240.13",
      gene_type : "protein_coding",
      gene_name : "HAUS1",
      gene_level : 2,
      hgnc_id : "HGNC:25174",
      havana_gene : "OTTHUMG00000132638.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46173553,
      stop : 46266992,
      direction : "+",
      ID : "ENSG00000152242.11",
      gene_id : "ENSG00000152242.11",
      gene_type : "protein_coding",
      gene_name : "C18orf25",
      gene_level : 2,
      hgnc_id : "HGNC:28172",
      havana_gene : "OTTHUMG00000179190.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46326809,
      stop : 46463140,
      direction : "+",
      ID : "ENSG00000141622.14",
      gene_id : "ENSG00000141622.14",
      gene_type : "protein_coding",
      gene_name : "RNF165",
      gene_level : 2,
      hgnc_id : "HGNC:31696",
      havana_gene : "OTTHUMG00000179230.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46476972,
      stop : 46657220,
      direction : "-",
      ID : "ENSG00000167210.17",
      gene_id : "ENSG00000167210.17",
      gene_type : "protein_coding",
      gene_name : "LOXHD1",
      gene_level : 1,
      hgnc_id : "HGNC:26521",
      havana_gene : "OTTHUMG00000132644.11",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46667821,
      stop : 46759257,
      direction : "-",
      ID : "ENSG00000101638.14",
      gene_id : "ENSG00000101638.14",
      gene_type : "protein_coding",
      gene_name : "ST8SIA5",
      gene_level : 2,
      hgnc_id : "HGNC:17827",
      havana_gene : "OTTHUMG00000132643.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46803218,
      stop : 46920160,
      direction : "-",
      ID : "ENSG00000078043.16",
      gene_id : "ENSG00000078043.16",
      gene_type : "protein_coding",
      gene_name : "PIAS2",
      gene_level : 1,
      hgnc_id : "HGNC:17311",
      havana_gene : "OTTHUMG00000179301.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46917492,
      stop : 47102243,
      direction : "+",
      ID : "ENSG00000167216.17",
      gene_id : "ENSG00000167216.17",
      gene_type : "protein_coding",
      gene_name : "KATNAL2",
      gene_level : 1,
      hgnc_id : "HGNC:25387",
      havana_gene : "OTTHUMG00000179408.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46962768,
      stop : 46964408,
      direction : "-",
      ID : "ENSG00000288616.1",
      gene_id : "ENSG00000288616.1",
      gene_type : "protein_coding",
      gene_name : "AC090373.2",
      gene_level : 2,
      hgnc_id : "tag=retrogene",
      havana_gene : "OTTHUMG00000180382.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 46968695,
      stop : 46969912,
      direction : "-",
      ID : "ENSG00000275553.4",
      gene_id : "ENSG00000275553.4",
      gene_type : "protein_coding",
      gene_name : "ELOA3CP",
      gene_level : 2,
      hgnc_id : "HGNC:52410",
      havana_gene : "OTTHUMG00000188256.3",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47022287,
      stop : 47023927,
      direction : "-",
      ID : "ENSG00000288607.1",
      gene_id : "ENSG00000288607.1",
      gene_type : "protein_coding",
      gene_name : "AC012254.6",
      gene_level : 2,
      hgnc_id : "tag=retrogene",
      havana_gene : "OTTHUMG00000188257.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47028202,
      stop : 47029842,
      direction : "-",
      ID : "ENSG00000288631.1",
      gene_id : "ENSG00000288631.1",
      gene_type : "protein_coding",
      gene_name : "AC012254.7",
      gene_level : 2,
      hgnc_id : "tag=retrogene",
      havana_gene : "OTTHUMG00000132651.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47032572,
      stop : 47035621,
      direction : "-",
      ID : "ENSG00000206181.6",
      gene_id : "ENSG00000206181.6",
      gene_type : "protein_coding",
      gene_name : "ELOA2",
      gene_level : 2,
      hgnc_id : "HGNC:30771",
      havana_gene : "OTTHUMG00000132649.1",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47107408,
      stop : 47150500,
      direction : "-",
      ID : "ENSG00000167220.12",
      gene_id : "ENSG00000167220.12",
      gene_type : "protein_coding",
      gene_name : "HDHD2",
      gene_level : 2,
      hgnc_id : "HGNC:25364",
      havana_gene : "OTTHUMG00000179411.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47108188,
      stop : 47176345,
      direction : "-",
      ID : "ENSG00000267228.7",
      gene_id : "ENSG00000267228.7",
      gene_type : "protein_coding",
      gene_name : "AC012254.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180304.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47152834,
      stop : 47176364,
      direction : "-",
      ID : "ENSG00000134049.6",
      gene_id : "ENSG00000134049.6",
      gene_type : "protein_coding",
      gene_name : "IER3IP1",
      gene_level : 2,
      hgnc_id : "HGNC:18550",
      havana_gene : "OTTHUMG00000132650.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47206169,
      stop : 47251660,
      direction : "-",
      ID : "ENSG00000215474.8",
      gene_id : "ENSG00000215474.8",
      gene_type : "protein_coding",
      gene_name : "SKOR2",
      gene_level : 2,
      hgnc_id : "HGNC:32695",
      havana_gene : "OTTHUMG00000180309.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 47808957,
      stop : 47931146,
      direction : "-",
      ID : "ENSG00000175387.16",
      gene_id : "ENSG00000175387.16",
      gene_type : "protein_coding",
      gene_name : "SMAD2",
      gene_level : 1,
      hgnc_id : "HGNC:6768",
      havana_gene : "OTTHUMG00000132652.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 48026672,
      stop : 48410752,
      direction : "-",
      ID : "ENSG00000184828.10",
      gene_id : "ENSG00000184828.10",
      gene_type : "protein_coding",
      gene_name : "ZBTB7C",
      gene_level : 2,
      hgnc_id : "HGNC:31700",
      havana_gene : "OTTHUMG00000180322.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 48539031,
      stop : 48863217,
      direction : "+",
      ID : "ENSG00000134030.14",
      gene_id : "ENSG00000134030.14",
      gene_type : "protein_coding",
      gene_name : "CTIF",
      gene_level : 2,
      hgnc_id : "HGNC:23925",
      havana_gene : "OTTHUMG00000132656.15",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 48919853,
      stop : 48952052,
      direction : "-",
      ID : "ENSG00000101665.9",
      gene_id : "ENSG00000101665.9",
      gene_type : "protein_coding",
      gene_name : "SMAD7",
      gene_level : 2,
      hgnc_id : "HGNC:6773",
      havana_gene : "OTTHUMG00000132655.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49036387,
      stop : 49461347,
      direction : "-",
      ID : "ENSG00000141627.14",
      gene_id : "ENSG00000141627.14",
      gene_type : "protein_coding",
      gene_name : "DYM",
      gene_level : 1,
      hgnc_id : "HGNC:21317",
      havana_gene : "OTTHUMG00000132659.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49477243,
      stop : 49487252,
      direction : "-",
      ID : "ENSG00000177576.12",
      gene_id : "ENSG00000177576.12",
      gene_type : "protein_coding",
      gene_name : "C18orf32",
      gene_level : 2,
      hgnc_id : "HGNC:31690",
      havana_gene : "OTTHUMG00000179688.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49481681,
      stop : 49492479,
      direction : "-",
      ID : "ENSG00000215472.10",
      gene_id : "ENSG00000215472.10",
      gene_type : "protein_coding",
      gene_name : "RPL17-C18orf32",
      gene_level : 1,
      hgnc_id : "HGNC:44661",
      havana_gene : "OTTHUMG00000179689.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49488453,
      stop : 49492523,
      direction : "-",
      ID : "ENSG00000265681.7",
      gene_id : "ENSG00000265681.7",
      gene_type : "protein_coding",
      gene_name : "RPL17",
      gene_level : 2,
      hgnc_id : "HGNC:10307",
      havana_gene : "OTTHUMG00000179680.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49560699,
      stop : 49599185,
      direction : "+",
      ID : "ENSG00000101670.12",
      gene_id : "ENSG00000101670.12",
      gene_type : "protein_coding",
      gene_name : "LIPG",
      gene_level : 1,
      hgnc_id : "HGNC:6623",
      havana_gene : "OTTHUMG00000179658.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49782164,
      stop : 49813953,
      direction : "-",
      ID : "ENSG00000167315.18",
      gene_id : "ENSG00000167315.18",
      gene_type : "protein_coding",
      gene_name : "ACAA2",
      gene_level : 1,
      hgnc_id : "HGNC:83",
      havana_gene : "OTTHUMG00000132667.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49795793,
      stop : 49837623,
      direction : "-",
      ID : "ENSG00000266997.2",
      gene_id : "ENSG00000266997.2",
      gene_type : "protein_coding",
      gene_name : "AC090227.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179848.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 49822789,
      stop : 50195147,
      direction : "-",
      ID : "ENSG00000167306.20",
      gene_id : "ENSG00000167306.20",
      gene_type : "protein_coding",
      gene_name : "MYO5B",
      gene_level : 2,
      hgnc_id : "HGNC:7603",
      havana_gene : "OTTHUMG00000179843.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50227193,
      stop : 50266495,
      direction : "-",
      ID : "ENSG00000172361.6",
      gene_id : "ENSG00000172361.6",
      gene_type : "protein_coding",
      gene_name : "CFAP53",
      gene_level : 2,
      hgnc_id : "HGNC:26530",
      havana_gene : "OTTHUMG00000132668.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50266882,
      stop : 50281774,
      direction : "-",
      ID : "ENSG00000141644.17",
      gene_id : "ENSG00000141644.17",
      gene_type : "protein_coding",
      gene_name : "MBD1",
      gene_level : 1,
      hgnc_id : "HGNC:6916",
      havana_gene : "OTTHUMG00000132669.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50282343,
      stop : 50287839,
      direction : "-",
      ID : "ENSG00000154832.16",
      gene_id : "ENSG00000154832.16",
      gene_type : "protein_coding",
      gene_name : "CXXC1",
      gene_level : 2,
      hgnc_id : "HGNC:24343",
      havana_gene : "OTTHUMG00000132670.12",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50375040,
      stop : 50394168,
      direction : "+",
      ID : "ENSG00000154839.10",
      gene_id : "ENSG00000154839.10",
      gene_type : "protein_coding",
      gene_name : "SKA1",
      gene_level : 2,
      hgnc_id : "HGNC:28109",
      havana_gene : "OTTHUMG00000132685.8",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50560087,
      stop : 50731826,
      direction : "+",
      ID : "ENSG00000141639.12",
      gene_id : "ENSG00000141639.12",
      gene_type : "protein_coding",
      gene_name : "MAPK4",
      gene_level : 1,
      hgnc_id : "HGNC:6878",
      havana_gene : "OTTHUMG00000179853.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50795120,
      stop : 50825402,
      direction : "-",
      ID : "ENSG00000134042.14",
      gene_id : "ENSG00000134042.14",
      gene_type : "protein_coding",
      gene_name : "MRO",
      gene_level : 2,
      hgnc_id : "HGNC:24121",
      havana_gene : "OTTHUMG00000132692.14",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50879080,
      stop : 50954257,
      direction : "+",
      ID : "ENSG00000082212.13",
      gene_id : "ENSG00000082212.13",
      gene_type : "protein_coding",
      gene_name : "ME2",
      gene_level : 2,
      hgnc_id : "HGNC:6984",
      havana_gene : "OTTHUMG00000132694.10",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50967991,
      stop : 50988121,
      direction : "+",
      ID : "ENSG00000141642.9",
      gene_id : "ENSG00000141642.9",
      gene_type : "protein_coding",
      gene_name : "ELAC1",
      gene_level : 2,
      hgnc_id : "HGNC:14197",
      havana_gene : "OTTHUMG00000132695.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 50968019,
      stop : 51058144,
      direction : "+",
      ID : "ENSG00000267699.2",
      gene_id : "ENSG00000267699.2",
      gene_type : "protein_coding",
      gene_name : "AC091551.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180063.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 51028394,
      stop : 51085045,
      direction : "+",
      ID : "ENSG00000141646.14",
      gene_id : "ENSG00000141646.14",
      gene_type : "protein_coding",
      gene_name : "SMAD4",
      gene_level : 1,
      hgnc_id : "HGNC:6770",
      havana_gene : "OTTHUMG00000132696.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 51174550,
      stop : 51218333,
      direction : "-",
      ID : "ENSG00000176624.12",
      gene_id : "ENSG00000176624.12",
      gene_type : "protein_coding",
      gene_name : "MEX3C",
      gene_level : 2,
      hgnc_id : "HGNC:28040",
      havana_gene : "OTTHUMG00000132693.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 52340197,
      stop : 53535903,
      direction : "+",
      ID : "ENSG00000187323.12",
      gene_id : "ENSG00000187323.12",
      gene_type : "protein_coding",
      gene_name : "DCC",
      gene_level : 1,
      hgnc_id : "HGNC:2701",
      havana_gene : "OTTHUMG00000132698.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54151606,
      stop : 54224669,
      direction : "-",
      ID : "ENSG00000134046.12",
      gene_id : "ENSG00000134046.12",
      gene_type : "protein_coding",
      gene_name : "MBD2",
      gene_level : 1,
      hgnc_id : "HGNC:6917",
      havana_gene : "OTTHUMG00000132705.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54269517,
      stop : 54321266,
      direction : "+",
      ID : "ENSG00000101751.11",
      gene_id : "ENSG00000101751.11",
      gene_type : "protein_coding",
      gene_name : "POLI",
      gene_level : 1,
      hgnc_id : "HGNC:9182",
      havana_gene : "OTTHUMG00000132704.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54324358,
      stop : 54357964,
      direction : "-",
      ID : "ENSG00000174448.8",
      gene_id : "ENSG00000174448.8",
      gene_type : "protein_coding",
      gene_name : "STARD6",
      gene_level : 1,
      hgnc_id : "HGNC:18066",
      havana_gene : "OTTHUMG00000132702.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54357906,
      stop : 54385218,
      direction : "+",
      ID : "ENSG00000166845.15",
      gene_id : "ENSG00000166845.15",
      gene_type : "protein_coding",
      gene_name : "C18orf54",
      gene_level : 2,
      hgnc_id : "HGNC:13796",
      havana_gene : "OTTHUMG00000132703.9",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54587757,
      stop : 54599493,
      direction : "+",
      ID : "ENSG00000178690.4",
      gene_id : "ENSG00000178690.4",
      gene_type : "protein_coding",
      gene_name : "DYNAP",
      gene_level : 1,
      hgnc_id : "HGNC:26808",
      havana_gene : "OTTHUMG00000132709.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54717860,
      stop : 54895516,
      direction : "+",
      ID : "ENSG00000041353.10",
      gene_id : "ENSG00000041353.10",
      gene_type : "protein_coding",
      gene_name : "RAB27B",
      gene_level : 1,
      hgnc_id : "HGNC:9767",
      havana_gene : "OTTHUMG00000132710.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 54901509,
      stop : 54959461,
      direction : "-",
      ID : "ENSG00000166510.14",
      gene_id : "ENSG00000166510.14",
      gene_type : "protein_coding",
      gene_name : "CCDC68",
      gene_level : 2,
      hgnc_id : "HGNC:24350",
      havana_gene : "OTTHUMG00000132708.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 55222185,
      stop : 55664787,
      direction : "-",
      ID : "ENSG00000196628.20",
      gene_id : "ENSG00000196628.20",
      gene_type : "protein_coding",
      gene_name : "TCF4",
      gene_level : 1,
      hgnc_id : "HGNC:11634",
      havana_gene : "OTTHUMG00000132713.34",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 56597209,
      stop : 56651600,
      direction : "-",
      ID : "ENSG00000091164.13",
      gene_id : "ENSG00000091164.13",
      gene_type : "protein_coding",
      gene_name : "TXNL1",
      gene_level : 2,
      hgnc_id : "HGNC:12436",
      havana_gene : "OTTHUMG00000132722.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 56651343,
      stop : 57029811,
      direction : "+",
      ID : "ENSG00000091157.14",
      gene_id : "ENSG00000091157.14",
      gene_type : "protein_coding",
      gene_name : "WDR7",
      gene_level : 1,
      hgnc_id : "HGNC:13490",
      havana_gene : "OTTHUMG00000132721.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 57147087,
      stop : 57150410,
      direction : "+",
      ID : "ENSG00000228075.5",
      gene_id : "ENSG00000228075.5",
      gene_type : "protein_coding",
      gene_name : "BOD1L2",
      gene_level : 2,
      hgnc_id : "HGNC:28505",
      havana_gene : "OTTHUMG00000180124.2",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 57352557,
      stop : 57371731,
      direction : "+",
      ID : "ENSG00000177511.6",
      gene_id : "ENSG00000177511.6",
      gene_type : "protein_coding",
      gene_name : "ST8SIA3",
      gene_level : 2,
      hgnc_id : "HGNC:14269",
      havana_gene : "OTTHUMG00000180101.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 57435374,
      stop : 57491298,
      direction : "+",
      ID : "ENSG00000119547.6",
      gene_id : "ENSG00000119547.6",
      gene_type : "protein_coding",
      gene_name : "ONECUT2",
      gene_level : 2,
      hgnc_id : "HGNC:8139",
      havana_gene : "OTTHUMG00000159776.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 57544377,
      stop : 57586702,
      direction : "-",
      ID : "ENSG00000066926.12",
      gene_id : "ENSG00000066926.12",
      gene_type : "protein_coding",
      gene_name : "FECH",
      gene_level : 1,
      hgnc_id : "HGNC:3647",
      havana_gene : "OTTHUMG00000132740.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 57600656,
      stop : 57622213,
      direction : "-",
      ID : "ENSG00000134440.12",
      gene_id : "ENSG00000134440.12",
      gene_type : "protein_coding",
      gene_name : "NARS1",
      gene_level : 2,
      hgnc_id : "HGNC:7643",
      havana_gene : "OTTHUMG00000180125.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 57646426,
      stop : 57803315,
      direction : "-",
      ID : "ENSG00000081923.15",
      gene_id : "ENSG00000081923.15",
      gene_type : "protein_coding",
      gene_name : "ATP8B1",
      gene_level : 2,
      hgnc_id : "HGNC:3706",
      havana_gene : "OTTHUMG00000180255.9",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 58044226,
      stop : 58401540,
      direction : "+",
      ID : "ENSG00000049759.20",
      gene_id : "ENSG00000049759.20",
      gene_type : "protein_coding",
      gene_name : "NEDD4L",
      gene_level : 1,
      hgnc_id : "HGNC:7728",
      havana_gene : "OTTHUMG00000179875.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 58481247,
      stop : 58629091,
      direction : "-",
      ID : "ENSG00000198796.7",
      gene_id : "ENSG00000198796.7",
      gene_type : "protein_coding",
      gene_name : "ALPK2",
      gene_level : 2,
      hgnc_id : "HGNC:20565",
      havana_gene : "OTTHUMG00000132755.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 58671465,
      stop : 58754477,
      direction : "+",
      ID : "ENSG00000172175.15",
      gene_id : "ENSG00000172175.15",
      gene_type : "protein_coding",
      gene_name : "MALT1",
      gene_level : 2,
      hgnc_id : "HGNC:6819",
      havana_gene : "OTTHUMG00000132761.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 58862600,
      stop : 58986480,
      direction : "+",
      ID : "ENSG00000074657.14",
      gene_id : "ENSG00000074657.14",
      gene_type : "protein_coding",
      gene_name : "ZNF532",
      gene_level : 1,
      hgnc_id : "HGNC:30940",
      havana_gene : "OTTHUMG00000132759.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59139866,
      stop : 59158832,
      direction : "+",
      ID : "ENSG00000166562.9",
      gene_id : "ENSG00000166562.9",
      gene_type : "protein_coding",
      gene_name : "SEC11C",
      gene_level : 1,
      hgnc_id : "HGNC:23400",
      havana_gene : "OTTHUMG00000132762.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59220158,
      stop : 59230774,
      direction : "+",
      ID : "ENSG00000134443.10",
      gene_id : "ENSG00000134443.10",
      gene_type : "protein_coding",
      gene_name : "GRP",
      gene_level : 1,
      hgnc_id : "HGNC:4605",
      havana_gene : "OTTHUMG00000132760.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59267035,
      stop : 59274086,
      direction : "-",
      ID : "ENSG00000134438.10",
      gene_id : "ENSG00000134438.10",
      gene_type : "protein_coding",
      gene_name : "RAX",
      gene_level : 2,
      hgnc_id : "HGNC:18662",
      havana_gene : "OTTHUMG00000132757.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59275156,
      stop : 59318649,
      direction : "-",
      ID : "ENSG00000166569.8",
      gene_id : "ENSG00000166569.8",
      gene_type : "protein_coding",
      gene_name : "CPLX4",
      gene_level : 2,
      hgnc_id : "HGNC:24330",
      havana_gene : "OTTHUMG00000132756.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59327823,
      stop : 59359265,
      direction : "-",
      ID : "ENSG00000074695.6",
      gene_id : "ENSG00000074695.6",
      gene_type : "protein_coding",
      gene_name : "LMAN1",
      gene_level : 2,
      hgnc_id : "HGNC:6631",
      havana_gene : "OTTHUMG00000132758.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59430939,
      stop : 59697662,
      direction : "-",
      ID : "ENSG00000183287.14",
      gene_id : "ENSG00000183287.14",
      gene_type : "protein_coding",
      gene_name : "CCBE1",
      gene_level : 2,
      hgnc_id : "HGNC:29426",
      havana_gene : "OTTHUMG00000180087.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 59899996,
      stop : 59904305,
      direction : "+",
      ID : "ENSG00000141682.12",
      gene_id : "ENSG00000141682.12",
      gene_type : "protein_coding",
      gene_name : "PMAIP1",
      gene_level : 2,
      hgnc_id : "HGNC:9108",
      havana_gene : "OTTHUMG00000132765.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 60371062,
      stop : 60372775,
      direction : "-",
      ID : "ENSG00000166603.5",
      gene_id : "ENSG00000166603.5",
      gene_type : "protein_coding",
      gene_name : "MC4R",
      gene_level : 2,
      hgnc_id : "HGNC:6932",
      havana_gene : "OTTHUMG00000132766.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 61333430,
      stop : 61555779,
      direction : "+",
      ID : "ENSG00000101542.10",
      gene_id : "ENSG00000101542.10",
      gene_type : "protein_coding",
      gene_name : "CDH20",
      gene_level : 2,
      hgnc_id : "HGNC:1760",
      havana_gene : "OTTHUMG00000132768.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 61808067,
      stop : 61894247,
      direction : "-",
      ID : "ENSG00000176641.11",
      gene_id : "ENSG00000176641.11",
      gene_type : "protein_coding",
      gene_name : "RNF152",
      gene_level : 1,
      hgnc_id : "HGNC:26811",
      havana_gene : "OTTHUMG00000132774.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 61905255,
      stop : 62187118,
      direction : "-",
      ID : "ENSG00000197563.11",
      gene_id : "ENSG00000197563.11",
      gene_type : "protein_coding",
      gene_name : "PIGN",
      gene_level : 1,
      hgnc_id : "HGNC:8967",
      havana_gene : "OTTHUMG00000180098.21",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 62187255,
      stop : 62310249,
      direction : "+",
      ID : "ENSG00000134444.15",
      gene_id : "ENSG00000134444.15",
      gene_type : "protein_coding",
      gene_name : "RELCH",
      gene_level : 2,
      hgnc_id : "HGNC:29289",
      havana_gene : "OTTHUMG00000132780.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 62325287,
      stop : 62391288,
      direction : "+",
      ID : "ENSG00000141655.17",
      gene_id : "ENSG00000141655.17",
      gene_type : "protein_coding",
      gene_name : "TNFRSF11A",
      gene_level : 2,
      hgnc_id : "HGNC:11908",
      havana_gene : "OTTHUMG00000132779.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 62523025,
      stop : 62587709,
      direction : "+",
      ID : "ENSG00000141664.10",
      gene_id : "ENSG00000141664.10",
      gene_type : "protein_coding",
      gene_name : "ZCCHC2",
      gene_level : 2,
      hgnc_id : "HGNC:22916",
      havana_gene : "OTTHUMG00000180165.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 62715541,
      stop : 62980433,
      direction : "+",
      ID : "ENSG00000081913.14",
      gene_id : "ENSG00000081913.14",
      gene_type : "protein_coding",
      gene_name : "PHLPP1",
      gene_level : 1,
      hgnc_id : "HGNC:20610",
      havana_gene : "OTTHUMG00000150629.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63123346,
      stop : 63320128,
      direction : "-",
      ID : "ENSG00000171791.14",
      gene_id : "ENSG00000171791.14",
      gene_type : "protein_coding",
      gene_name : "BCL2",
      gene_level : 2,
      hgnc_id : "HGNC:990",
      havana_gene : "OTTHUMG00000132791.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63327726,
      stop : 63367228,
      direction : "-",
      ID : "ENSG00000119537.18",
      gene_id : "ENSG00000119537.18",
      gene_type : "protein_coding",
      gene_name : "KDSR",
      gene_level : 2,
      hgnc_id : "HGNC:4021",
      havana_gene : "OTTHUMG00000132792.9",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63389190,
      stop : 63422483,
      direction : "-",
      ID : "ENSG00000119541.10",
      gene_id : "ENSG00000119541.10",
      gene_type : "protein_coding",
      gene_name : "VPS4B",
      gene_level : 2,
      hgnc_id : "HGNC:10895",
      havana_gene : "OTTHUMG00000132790.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63476958,
      stop : 63505085,
      direction : "+",
      ID : "ENSG00000206075.14",
      gene_id : "ENSG00000206075.14",
      gene_type : "protein_coding",
      gene_name : "SERPINB5",
      gene_level : 2,
      hgnc_id : "HGNC:8949",
      havana_gene : "OTTHUMG00000141307.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63542369,
      stop : 63569329,
      direction : "+",
      ID : "ENSG00000166634.7",
      gene_id : "ENSG00000166634.7",
      gene_type : "protein_coding",
      gene_name : "SERPINB12",
      gene_level : 1,
      hgnc_id : "HGNC:14220",
      havana_gene : "OTTHUMG00000132789.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63586989,
      stop : 63604639,
      direction : "+",
      ID : "ENSG00000197641.12",
      gene_id : "ENSG00000197641.12",
      gene_type : "protein_coding",
      gene_name : "SERPINB13",
      gene_level : 2,
      hgnc_id : "HGNC:8944",
      havana_gene : "OTTHUMG00000060406.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63637259,
      stop : 63644256,
      direction : "-",
      ID : "ENSG00000206073.11",
      gene_id : "ENSG00000206073.11",
      gene_type : "protein_coding",
      gene_name : "SERPINB4",
      gene_level : 2,
      hgnc_id : "HGNC:10570",
      havana_gene : "OTTHUMG00000060405.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63647579,
      stop : 63726432,
      direction : "+",
      ID : "ENSG00000206072.13",
      gene_id : "ENSG00000206072.13",
      gene_type : "protein_coding",
      gene_name : "SERPINB11",
      gene_level : 2,
      hgnc_id : "HGNC:14221",
      havana_gene : "OTTHUMG00000060404.10",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63655197,
      stop : 63661893,
      direction : "-",
      ID : "ENSG00000057149.16",
      gene_id : "ENSG00000057149.16",
      gene_type : "protein_coding",
      gene_name : "SERPINB3",
      gene_level : 2,
      hgnc_id : "HGNC:10569",
      havana_gene : "OTTHUMG00000060403.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63752935,
      stop : 63805376,
      direction : "+",
      ID : "ENSG00000166396.13",
      gene_id : "ENSG00000166396.13",
      gene_type : "protein_coding",
      gene_name : "SERPINB7",
      gene_level : 2,
      hgnc_id : "HGNC:13902",
      havana_gene : "OTTHUMG00000060591.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63871692,
      stop : 63903888,
      direction : "+",
      ID : "ENSG00000197632.9",
      gene_id : "ENSG00000197632.9",
      gene_type : "protein_coding",
      gene_name : "SERPINB2",
      gene_level : 2,
      hgnc_id : "HGNC:8584",
      havana_gene : "OTTHUMG00000060592.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63897174,
      stop : 63936111,
      direction : "+",
      ID : "ENSG00000242550.6",
      gene_id : "ENSG00000242550.6",
      gene_type : "protein_coding",
      gene_name : "SERPINB10",
      gene_level : 2,
      hgnc_id : "HGNC:8942",
      havana_gene : "OTTHUMG00000060594.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63949301,
      stop : 63981774,
      direction : "+",
      ID : "ENSG00000221887.6",
      gene_id : "ENSG00000221887.6",
      gene_type : "protein_coding",
      gene_name : "HMSD",
      gene_level : 1,
      hgnc_id : "HGNC:23037",
      havana_gene : "OTTHUMG00000060593.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 63970029,
      stop : 64019779,
      direction : "+",
      ID : "ENSG00000166401.15",
      gene_id : "ENSG00000166401.15",
      gene_type : "protein_coding",
      gene_name : "SERPINB8",
      gene_level : 1,
      hgnc_id : "HGNC:8952",
      havana_gene : "OTTHUMG00000060596.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 65750252,
      stop : 65890337,
      direction : "+",
      ID : "ENSG00000081138.14",
      gene_id : "ENSG00000081138.14",
      gene_type : "protein_coding",
      gene_name : "CDH7",
      gene_level : 2,
      hgnc_id : "HGNC:1766",
      havana_gene : "OTTHUMG00000132800.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 66501083,
      stop : 66604138,
      direction : "-",
      ID : "ENSG00000071991.9",
      gene_id : "ENSG00000071991.9",
      gene_type : "protein_coding",
      gene_name : "CDH19",
      gene_level : 1,
      hgnc_id : "HGNC:1758",
      havana_gene : "OTTHUMG00000132802.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 67506587,
      stop : 67516720,
      direction : "-",
      ID : "ENSG00000171451.14",
      gene_id : "ENSG00000171451.14",
      gene_type : "protein_coding",
      gene_name : "DSEL",
      gene_level : 2,
      hgnc_id : "HGNC:18144",
      havana_gene : "OTTHUMG00000132804.3",
      tag : "retrogene"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 68673688,
      stop : 68715108,
      direction : "-",
      ID : "ENSG00000166479.10",
      gene_id : "ENSG00000166479.10",
      gene_type : "protein_coding",
      gene_name : "TMX3",
      gene_level : 2,
      hgnc_id : "HGNC:24718",
      havana_gene : "OTTHUMG00000172713.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 68715209,
      stop : 69055189,
      direction : "+",
      ID : "ENSG00000150636.17",
      gene_id : "ENSG00000150636.17",
      gene_type : "protein_coding",
      gene_name : "CCDC102B",
      gene_level : 1,
      hgnc_id : "HGNC:26295",
      havana_gene : "OTTHUMG00000132808.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 69400888,
      stop : 69849087,
      direction : "+",
      ID : "ENSG00000206052.11",
      gene_id : "ENSG00000206052.11",
      gene_type : "protein_coding",
      gene_name : "DOK6",
      gene_level : 2,
      hgnc_id : "HGNC:28301",
      havana_gene : "OTTHUMG00000178688.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 69831158,
      stop : 69961803,
      direction : "-",
      ID : "ENSG00000150637.9",
      gene_id : "ENSG00000150637.9",
      gene_type : "protein_coding",
      gene_name : "CD226",
      gene_level : 2,
      hgnc_id : "HGNC:16961",
      havana_gene : "OTTHUMG00000132809.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 70003031,
      stop : 70205726,
      direction : "-",
      ID : "ENSG00000176225.15",
      gene_id : "ENSG00000176225.15",
      gene_type : "protein_coding",
      gene_name : "RTTN",
      gene_level : 2,
      hgnc_id : "HGNC:18654",
      havana_gene : "OTTHUMG00000178694.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 70289045,
      stop : 70330199,
      direction : "+",
      ID : "ENSG00000170677.6",
      gene_id : "ENSG00000170677.6",
      gene_type : "protein_coding",
      gene_name : "SOCS6",
      gene_level : 2,
      hgnc_id : "HGNC:16833",
      havana_gene : "OTTHUMG00000132816.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 72536680,
      stop : 72638521,
      direction : "-",
      ID : "ENSG00000141668.10",
      gene_id : "ENSG00000141668.10",
      gene_type : "protein_coding",
      gene_name : "CBLN2",
      gene_level : 1,
      hgnc_id : "HGNC:1544",
      havana_gene : "OTTHUMG00000132825.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 72742314,
      stop : 72868146,
      direction : "-",
      ID : "ENSG00000166342.19",
      gene_id : "ENSG00000166342.19",
      gene_type : "protein_coding",
      gene_name : "NETO1",
      gene_level : 2,
      hgnc_id : "HGNC:13823",
      havana_gene : "OTTHUMG00000132834.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74073353,
      stop : 74147843,
      direction : "-",
      ID : "ENSG00000141665.13",
      gene_id : "ENSG00000141665.13",
      gene_type : "protein_coding",
      gene_name : "FBXO15",
      gene_level : 1,
      hgnc_id : "HGNC:13617",
      havana_gene : "OTTHUMG00000132842.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74148523,
      stop : 74160531,
      direction : "+",
      ID : "ENSG00000075336.12",
      gene_id : "ENSG00000075336.12",
      gene_type : "protein_coding",
      gene_name : "TIMM21",
      gene_level : 2,
      hgnc_id : "HGNC:25010",
      havana_gene : "OTTHUMG00000132844.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74250846,
      stop : 74291973,
      direction : "-",
      ID : "ENSG00000166347.19",
      gene_id : "ENSG00000166347.19",
      gene_type : "protein_coding",
      gene_name : "CYB5A",
      gene_level : 1,
      hgnc_id : "HGNC:2570",
      havana_gene : "OTTHUMG00000132843.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74315839,
      stop : 74359189,
      direction : "+",
      ID : "ENSG00000206043.7",
      gene_id : "ENSG00000206043.7",
      gene_type : "protein_coding",
      gene_name : "C18orf63",
      gene_level : 2,
      hgnc_id : "HGNC:40037",
      havana_gene : "OTTHUMG00000178987.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74434775,
      stop : 74457944,
      direction : "-",
      ID : "ENSG00000187773.9",
      gene_id : "ENSG00000187773.9",
      gene_type : "protein_coding",
      gene_name : "DIPK1C",
      gene_level : 2,
      hgnc_id : "HGNC:31729",
      havana_gene : "OTTHUMG00000156984.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74495816,
      stop : 74523454,
      direction : "+",
      ID : "ENSG00000133313.15",
      gene_id : "ENSG00000133313.15",
      gene_type : "protein_coding",
      gene_name : "CNDP2",
      gene_level : 1,
      hgnc_id : "HGNC:24437",
      havana_gene : "OTTHUMG00000132853.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74534500,
      stop : 74587212,
      direction : "+",
      ID : "ENSG00000150656.15",
      gene_id : "ENSG00000150656.15",
      gene_type : "protein_coding",
      gene_name : "CNDP1",
      gene_level : 1,
      hgnc_id : "HGNC:20675",
      havana_gene : "OTTHUMG00000132852.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 74597870,
      stop : 75065671,
      direction : "+",
      ID : "ENSG00000215421.9",
      gene_id : "ENSG00000215421.9",
      gene_type : "protein_coding",
      gene_name : "ZNF407",
      gene_level : 1,
      hgnc_id : "HGNC:19904",
      havana_gene : "OTTHUMG00000179122.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 75195113,
      stop : 75209139,
      direction : "-",
      ID : "ENSG00000180011.7",
      gene_id : "ENSG00000180011.7",
      gene_type : "protein_coding",
      gene_name : "ZADH2",
      gene_level : 1,
      hgnc_id : "HGNC:28697",
      havana_gene : "OTTHUMG00000132858.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 75210755,
      stop : 75289950,
      direction : "+",
      ID : "ENSG00000179981.11",
      gene_id : "ENSG00000179981.11",
      gene_type : "protein_coding",
      gene_name : "TSHZ1",
      gene_level : 2,
      hgnc_id : "HGNC:10669",
      havana_gene : "OTTHUMG00000132859.6",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 75409476,
      stop : 75427703,
      direction : "-",
      ID : "ENSG00000206026.7",
      gene_id : "ENSG00000206026.7",
      gene_type : "protein_coding",
      gene_name : "SMIM21",
      gene_level : 1,
      hgnc_id : "HGNC:27598",
      havana_gene : "OTTHUMG00000179126.1",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 76357682,
      stop : 76495242,
      direction : "-",
      ID : "ENSG00000101493.11",
      gene_id : "ENSG00000101493.11",
      gene_type : "protein_coding",
      gene_name : "ZNF516",
      gene_level : 1,
      hgnc_id : "HGNC:28990",
      havana_gene : "OTTHUMG00000165995.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 76822557,
      stop : 76972901,
      direction : "+",
      ID : "ENSG00000130856.17",
      gene_id : "ENSG00000130856.17",
      gene_type : "protein_coding",
      gene_name : "ZNF236",
      gene_level : 2,
      hgnc_id : "HGNC:13028",
      havana_gene : "OTTHUMG00000179331.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 76978827,
      stop : 77133683,
      direction : "-",
      ID : "ENSG00000197971.16",
      gene_id : "ENSG00000197971.16",
      gene_type : "protein_coding",
      gene_name : "MBP",
      gene_level : 1,
      hgnc_id : "HGNC:6925",
      havana_gene : "OTTHUMG00000132874.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 77249848,
      stop : 77277900,
      direction : "+",
      ID : "ENSG00000166573.6",
      gene_id : "ENSG00000166573.6",
      gene_type : "protein_coding",
      gene_name : "GALR1",
      gene_level : 2,
      hgnc_id : "HGNC:4132",
      havana_gene : "OTTHUMG00000132875.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 78980275,
      stop : 79002677,
      direction : "+",
      ID : "ENSG00000256463.8",
      gene_id : "ENSG00000256463.8",
      gene_type : "protein_coding",
      gene_name : "SALL3",
      gene_level : 1,
      hgnc_id : "HGNC:10527",
      havana_gene : "OTTHUMG00000132896.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79069285,
      stop : 79378287,
      direction : "+",
      ID : "ENSG00000166377.20",
      gene_id : "ENSG00000166377.20",
      gene_type : "protein_coding",
      gene_name : "ATP9B",
      gene_level : 1,
      hgnc_id : "HGNC:13541",
      havana_gene : "OTTHUMG00000132898.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79395856,
      stop : 79529325,
      direction : "+",
      ID : "ENSG00000131196.18",
      gene_id : "ENSG00000131196.18",
      gene_type : "protein_coding",
      gene_name : "NFATC1",
      gene_level : 1,
      hgnc_id : "HGNC:7775",
      havana_gene : "OTTHUMG00000132897.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79679803,
      stop : 79754510,
      direction : "+",
      ID : "ENSG00000060069.17",
      gene_id : "ENSG00000060069.17",
      gene_type : "protein_coding",
      gene_name : "CTDP1",
      gene_level : 1,
      hgnc_id : "HGNC:2498",
      havana_gene : "OTTHUMG00000132920.4",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79863668,
      stop : 79900184,
      direction : "+",
      ID : "ENSG00000178342.4",
      gene_id : "ENSG00000178342.4",
      gene_type : "protein_coding",
      gene_name : "KCNG2",
      gene_level : 1,
      hgnc_id : "HGNC:6249",
      havana_gene : "OTTHUMG00000044541.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79902420,
      stop : 79951657,
      direction : "-",
      ID : "ENSG00000122490.19",
      gene_id : "ENSG00000122490.19",
      gene_type : "protein_coding",
      gene_name : "SLC66A2",
      gene_level : 1,
      hgnc_id : "HGNC:26188",
      havana_gene : "OTTHUMG00000132921.7",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79964582,
      stop : 79970822,
      direction : "+",
      ID : "ENSG00000226742.4",
      gene_id : "ENSG00000226742.4",
      gene_type : "protein_coding",
      gene_name : "HSBP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:37243",
      havana_gene : "OTTHUMG00000180375.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 79970813,
      stop : 80033949,
      direction : "-",
      ID : "ENSG00000141759.15",
      gene_id : "ENSG00000141759.15",
      gene_type : "protein_coding",
      gene_name : "TXNL4A",
      gene_level : 1,
      hgnc_id : "HGNC:30551",
      havana_gene : "OTTHUMG00000180376.3",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 80034346,
      stop : 80097088,
      direction : "+",
      ID : "ENSG00000267127.7",
      gene_id : "ENSG00000267127.7",
      gene_type : "protein_coding",
      gene_name : "AC090360.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180377.2",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 80034389,
      stop : 80050651,
      direction : "+",
      ID : "ENSG00000101546.13",
      gene_id : "ENSG00000101546.13",
      gene_type : "protein_coding",
      gene_name : "RBFA",
      gene_level : 2,
      hgnc_id : "HGNC:26120",
      havana_gene : "OTTHUMG00000132923.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 80109262,
      stop : 80147523,
      direction : "+",
      ID : "ENSG00000101544.9",
      gene_id : "ENSG00000101544.9",
      gene_type : "protein_coding",
      gene_name : "ADNP2",
      gene_level : 1,
      hgnc_id : "HGNC:23803",
      havana_gene : "OTTHUMG00000172535.5",
      tag : null
    },
    {
      chromosome : 18,
      annotation : "HAVANA",
      type : "gene",
      start : 80157232,
      stop : 80247514,
      direction : "-",
      ID : "ENSG00000178184.16",
      gene_id : "ENSG00000178184.16",
      gene_type : "protein_coding",
      gene_name : "PARD6G",
      gene_level : 1,
      hgnc_id : "HGNC:16076",
      havana_gene : "OTTHUMG00000132922.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 107104,
      stop : 117102,
      direction : "+",
      ID : "ENSG00000176695.8",
      gene_id : "ENSG00000176695.8",
      gene_type : "protein_coding",
      gene_name : "OR4F17",
      gene_level : 2,
      hgnc_id : "HGNC:15381",
      havana_gene : "OTTHUMG00000180454.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 281040,
      stop : 291403,
      direction : "-",
      ID : "ENSG00000141934.10",
      gene_id : "ENSG00000141934.10",
      gene_type : "protein_coding",
      gene_name : "PLPP2",
      gene_level : 1,
      hgnc_id : "HGNC:9230",
      havana_gene : "OTTHUMG00000180530.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 301444,
      stop : 344815,
      direction : "-",
      ID : "ENSG00000105556.11",
      gene_id : "ENSG00000105556.11",
      gene_type : "protein_coding",
      gene_name : "MIER2",
      gene_level : 2,
      hgnc_id : "HGNC:29210",
      havana_gene : "OTTHUMG00000180532.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 361747,
      stop : 376026,
      direction : "-",
      ID : "ENSG00000105549.11",
      gene_id : "ENSG00000105549.11",
      gene_type : "protein_coding",
      gene_name : "THEG",
      gene_level : 1,
      hgnc_id : "HGNC:13706",
      havana_gene : "OTTHUMG00000165491.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 405445,
      stop : 409147,
      direction : "-",
      ID : "ENSG00000183186.8",
      gene_id : "ENSG00000183186.8",
      gene_type : "protein_coding",
      gene_name : "C2CD4C",
      gene_level : 2,
      hgnc_id : "HGNC:29417",
      havana_gene : "OTTHUMG00000180534.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 416583,
      stop : 460996,
      direction : "-",
      ID : "ENSG00000129946.10",
      gene_id : "ENSG00000129946.10",
      gene_type : "protein_coding",
      gene_name : "SHC2",
      gene_level : 2,
      hgnc_id : "HGNC:29869",
      havana_gene : "OTTHUMG00000180545.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 463346,
      stop : 474983,
      direction : "-",
      ID : "ENSG00000181781.10",
      gene_id : "ENSG00000181781.10",
      gene_type : "protein_coding",
      gene_name : "ODF3L2",
      gene_level : 2,
      hgnc_id : "HGNC:26841",
      havana_gene : "OTTHUMG00000180547.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 489176,
      stop : 505343,
      direction : "+",
      ID : "ENSG00000099866.16",
      gene_id : "ENSG00000099866.16",
      gene_type : "protein_coding",
      gene_name : "MADCAM1",
      gene_level : 2,
      hgnc_id : "HGNC:6765",
      havana_gene : "OTTHUMG00000180548.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 507497,
      stop : 519654,
      direction : "+",
      ID : "ENSG00000141933.9",
      gene_id : "ENSG00000141933.9",
      gene_type : "protein_coding",
      gene_name : "TPGS1",
      gene_level : 2,
      hgnc_id : "HGNC:25058",
      havana_gene : "OTTHUMG00000180557.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 531760,
      stop : 542092,
      direction : "+",
      ID : "ENSG00000099804.9",
      gene_id : "ENSG00000099804.9",
      gene_type : "protein_coding",
      gene_name : "CDC34",
      gene_level : 2,
      hgnc_id : "HGNC:1734",
      havana_gene : "OTTHUMG00000180558.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 544034,
      stop : 549924,
      direction : "+",
      ID : "ENSG00000197540.8",
      gene_id : "ENSG00000197540.8",
      gene_type : "protein_coding",
      gene_name : "GZMM",
      gene_level : 2,
      hgnc_id : "HGNC:4712",
      havana_gene : "OTTHUMG00000180559.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 571277,
      stop : 583494,
      direction : "+",
      ID : "ENSG00000172270.22",
      gene_id : "ENSG00000172270.22",
      gene_type : "protein_coding",
      gene_name : "BSG",
      gene_level : 1,
      hgnc_id : "HGNC:1116",
      havana_gene : "OTTHUMG00000177718.19",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 589881,
      stop : 617159,
      direction : "+",
      ID : "ENSG00000099822.3",
      gene_id : "ENSG00000099822.3",
      gene_type : "protein_coding",
      gene_name : "HCN2",
      gene_level : 2,
      hgnc_id : "HGNC:4846",
      havana_gene : "OTTHUMG00000180590.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 617221,
      stop : 633537,
      direction : "-",
      ID : "ENSG00000099821.14",
      gene_id : "ENSG00000099821.14",
      gene_type : "protein_coding",
      gene_name : "POLRMT",
      gene_level : 2,
      hgnc_id : "HGNC:9200",
      havana_gene : "OTTHUMG00000180611.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 639879,
      stop : 644371,
      direction : "+",
      ID : "ENSG00000070388.11",
      gene_id : "ENSG00000070388.11",
      gene_type : "protein_coding",
      gene_name : "FGF22",
      gene_level : 2,
      hgnc_id : "HGNC:3679",
      havana_gene : "OTTHUMG00000180591.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 647526,
      stop : 663233,
      direction : "-",
      ID : "ENSG00000070423.18",
      gene_id : "ENSG00000070423.18",
      gene_type : "protein_coding",
      gene_name : "RNF126",
      gene_level : 2,
      hgnc_id : "HGNC:21151",
      havana_gene : "OTTHUMG00000180592.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 676392,
      stop : 683392,
      direction : "+",
      ID : "ENSG00000070404.10",
      gene_id : "ENSG00000070404.10",
      gene_type : "protein_coding",
      gene_name : "FSTL3",
      gene_level : 2,
      hgnc_id : "HGNC:3973",
      havana_gene : "OTTHUMG00000180593.15",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 685546,
      stop : 695498,
      direction : "-",
      ID : "ENSG00000185198.12",
      gene_id : "ENSG00000185198.12",
      gene_type : "protein_coding",
      gene_name : "PRSS57",
      gene_level : 2,
      hgnc_id : "HGNC:31397",
      havana_gene : "OTTHUMG00000180662.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 708935,
      stop : 748329,
      direction : "+",
      ID : "ENSG00000099864.18",
      gene_id : "ENSG00000099864.18",
      gene_type : "protein_coding",
      gene_name : "PALM",
      gene_level : 2,
      hgnc_id : "HGNC:8594",
      havana_gene : "OTTHUMG00000181785.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 751112,
      stop : 764318,
      direction : "+",
      ID : "ENSG00000099812.9",
      gene_id : "ENSG00000099812.9",
      gene_type : "protein_coding",
      gene_name : "MISP",
      gene_level : 2,
      hgnc_id : "HGNC:27000",
      havana_gene : "OTTHUMG00000181786.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 797075,
      stop : 812327,
      direction : "+",
      ID : "ENSG00000011304.22",
      gene_id : "ENSG00000011304.22",
      gene_type : "protein_coding",
      gene_name : "PTBP1",
      gene_level : 2,
      hgnc_id : "HGNC:9583",
      havana_gene : "OTTHUMG00000181789.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 812488,
      stop : 821955,
      direction : "-",
      ID : "ENSG00000129951.19",
      gene_id : "ENSG00000129951.19",
      gene_type : "protein_coding",
      gene_name : "PLPPR3",
      gene_level : 2,
      hgnc_id : "HGNC:23497",
      havana_gene : "OTTHUMG00000164523.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 825097,
      stop : 832018,
      direction : "+",
      ID : "ENSG00000172232.10",
      gene_id : "ENSG00000172232.10",
      gene_type : "protein_coding",
      gene_name : "AZU1",
      gene_level : 2,
      hgnc_id : "HGNC:913",
      havana_gene : "OTTHUMG00000187023.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 840999,
      stop : 848175,
      direction : "+",
      ID : "ENSG00000196415.10",
      gene_id : "ENSG00000196415.10",
      gene_type : "protein_coding",
      gene_name : "PRTN3",
      gene_level : 2,
      hgnc_id : "HGNC:9495",
      havana_gene : "OTTHUMG00000181838.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 851014,
      stop : 856247,
      direction : "+",
      ID : "ENSG00000197561.7",
      gene_id : "ENSG00000197561.7",
      gene_type : "protein_coding",
      gene_name : "ELANE",
      gene_level : 2,
      hgnc_id : "HGNC:3309",
      havana_gene : "OTTHUMG00000181839.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 859664,
      stop : 863641,
      direction : "+",
      ID : "ENSG00000197766.8",
      gene_id : "ENSG00000197766.8",
      gene_type : "protein_coding",
      gene_name : "CFD",
      gene_level : 2,
      hgnc_id : "HGNC:2771",
      havana_gene : "OTTHUMG00000181840.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 867630,
      stop : 893218,
      direction : "-",
      ID : "ENSG00000175221.15",
      gene_id : "ENSG00000175221.15",
      gene_type : "protein_coding",
      gene_name : "MED16",
      gene_level : 1,
      hgnc_id : "HGNC:17556",
      havana_gene : "OTTHUMG00000181841.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 896503,
      stop : 913245,
      direction : "-",
      ID : "ENSG00000198858.10",
      gene_id : "ENSG00000198858.10",
      gene_type : "protein_coding",
      gene_name : "R3HDM4",
      gene_level : 2,
      hgnc_id : "HGNC:28270",
      havana_gene : "OTTHUMG00000181899.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 917287,
      stop : 921005,
      direction : "+",
      ID : "ENSG00000116014.10",
      gene_id : "ENSG00000116014.10",
      gene_type : "protein_coding",
      gene_name : "KISS1R",
      gene_level : 2,
      hgnc_id : "HGNC:4510",
      havana_gene : "OTTHUMG00000181900.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 925781,
      stop : 975939,
      direction : "+",
      ID : "ENSG00000116017.11",
      gene_id : "ENSG00000116017.11",
      gene_type : "protein_coding",
      gene_name : "ARID3A",
      gene_level : 1,
      hgnc_id : "HGNC:3031",
      havana_gene : "OTTHUMG00000182018.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 984332,
      stop : 998438,
      direction : "+",
      ID : "ENSG00000065268.11",
      gene_id : "ENSG00000065268.11",
      gene_type : "protein_coding",
      gene_name : "WDR18",
      gene_level : 2,
      hgnc_id : "HGNC:17956",
      havana_gene : "OTTHUMG00000181903.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1000419,
      stop : 1009732,
      direction : "+",
      ID : "ENSG00000116032.5",
      gene_id : "ENSG00000116032.5",
      gene_type : "protein_coding",
      gene_name : "GRIN3B",
      gene_level : 2,
      hgnc_id : "HGNC:16768",
      havana_gene : "OTTHUMG00000181904.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1009648,
      stop : 1021179,
      direction : "-",
      ID : "ENSG00000182087.14",
      gene_id : "ENSG00000182087.14",
      gene_type : "protein_coding",
      gene_name : "TMEM259",
      gene_level : 2,
      hgnc_id : "HGNC:17039",
      havana_gene : "OTTHUMG00000181905.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1026586,
      stop : 1039068,
      direction : "+",
      ID : "ENSG00000064666.15",
      gene_id : "ENSG00000064666.15",
      gene_type : "protein_coding",
      gene_name : "CNN2",
      gene_level : 2,
      hgnc_id : "HGNC:2156",
      havana_gene : "OTTHUMG00000172729.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1039997,
      stop : 1065572,
      direction : "+",
      ID : "ENSG00000064687.13",
      gene_id : "ENSG00000064687.13",
      gene_type : "protein_coding",
      gene_name : "ABCA7",
      gene_level : 2,
      hgnc_id : "HGNC:37",
      havana_gene : "OTTHUMG00000167547.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1065923,
      stop : 1086628,
      direction : "+",
      ID : "ENSG00000180448.11",
      gene_id : "ENSG00000180448.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP45",
      gene_level : 1,
      hgnc_id : "HGNC:17102",
      havana_gene : "OTTHUMG00000181871.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1086574,
      stop : 1095380,
      direction : "-",
      ID : "ENSG00000099817.12",
      gene_id : "ENSG00000099817.12",
      gene_type : "protein_coding",
      gene_name : "POLR2E",
      gene_level : 2,
      hgnc_id : "HGNC:9192",
      havana_gene : "OTTHUMG00000181873.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1103926,
      stop : 1106791,
      direction : "+",
      ID : "ENSG00000167468.18",
      gene_id : "ENSG00000167468.18",
      gene_type : "protein_coding",
      gene_name : "GPX4",
      gene_level : 1,
      hgnc_id : "HGNC:4556",
      havana_gene : "OTTHUMG00000181874.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1107637,
      stop : 1174268,
      direction : "-",
      ID : "ENSG00000064932.16",
      gene_id : "ENSG00000064932.16",
      gene_type : "protein_coding",
      gene_name : "SBNO2",
      gene_level : 1,
      hgnc_id : "HGNC:29158",
      havana_gene : "OTTHUMG00000181875.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1177558,
      stop : 1228431,
      direction : "+",
      ID : "ENSG00000118046.16",
      gene_id : "ENSG00000118046.16",
      gene_type : "protein_coding",
      gene_name : "STK11",
      gene_level : 1,
      hgnc_id : "HGNC:11389",
      havana_gene : "OTTHUMG00000180118.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1228287,
      stop : 1238027,
      direction : "-",
      ID : "ENSG00000099625.13",
      gene_id : "ENSG00000099625.13",
      gene_type : "protein_coding",
      gene_name : "CBARP",
      gene_level : 2,
      hgnc_id : "HGNC:28617",
      havana_gene : "OTTHUMG00000180141.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1241746,
      stop : 1244825,
      direction : "+",
      ID : "ENSG00000099624.8",
      gene_id : "ENSG00000099624.8",
      gene_type : "protein_coding",
      gene_name : "ATP5F1D",
      gene_level : 2,
      hgnc_id : "HGNC:837",
      havana_gene : "OTTHUMG00000180143.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1248553,
      stop : 1259140,
      direction : "+",
      ID : "ENSG00000167470.12",
      gene_id : "ENSG00000167470.12",
      gene_type : "protein_coding",
      gene_name : "MIDN",
      gene_level : 2,
      hgnc_id : "HGNC:16298",
      havana_gene : "OTTHUMG00000180144.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1259384,
      stop : 1274880,
      direction : "+",
      ID : "ENSG00000099622.14",
      gene_id : "ENSG00000099622.14",
      gene_type : "protein_coding",
      gene_name : "CIRBP",
      gene_level : 2,
      hgnc_id : "HGNC:1982",
      havana_gene : "OTTHUMG00000180145.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1275530,
      stop : 1279244,
      direction : "+",
      ID : "ENSG00000228300.14",
      gene_id : "ENSG00000228300.14",
      gene_type : "protein_coding",
      gene_name : "FAM174C",
      gene_level : 2,
      hgnc_id : "HGNC:26073",
      havana_gene : "OTTHUMG00000153928.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1285873,
      stop : 1301431,
      direction : "+",
      ID : "ENSG00000099617.4",
      gene_id : "ENSG00000099617.4",
      gene_type : "protein_coding",
      gene_name : "EFNA2",
      gene_level : 2,
      hgnc_id : "HGNC:3222",
      havana_gene : "OTTHUMG00000180148.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1354711,
      stop : 1378431,
      direction : "+",
      ID : "ENSG00000160953.17",
      gene_id : "ENSG00000160953.17",
      gene_type : "protein_coding",
      gene_name : "PWWP3A",
      gene_level : 1,
      hgnc_id : "HGNC:29641",
      havana_gene : "OTTHUMG00000180055.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1383527,
      stop : 1395589,
      direction : "+",
      ID : "ENSG00000115286.20",
      gene_id : "ENSG00000115286.20",
      gene_type : "protein_coding",
      gene_name : "NDUFS7",
      gene_level : 2,
      hgnc_id : "HGNC:7714",
      havana_gene : "OTTHUMG00000168077.14",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1397026,
      stop : 1401570,
      direction : "-",
      ID : "ENSG00000130005.13",
      gene_id : "ENSG00000130005.13",
      gene_type : "protein_coding",
      gene_name : "GAMT",
      gene_level : 2,
      hgnc_id : "HGNC:4136",
      havana_gene : "OTTHUMG00000180095.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1407569,
      stop : 1435687,
      direction : "+",
      ID : "ENSG00000071626.17",
      gene_id : "ENSG00000071626.17",
      gene_type : "protein_coding",
      gene_name : "DAZAP1",
      gene_level : 1,
      hgnc_id : "HGNC:2683",
      havana_gene : "OTTHUMG00000180058.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1438358,
      stop : 1440495,
      direction : "+",
      ID : "ENSG00000115268.10",
      gene_id : "ENSG00000115268.10",
      gene_type : "protein_coding",
      gene_name : "RPS15",
      gene_level : 1,
      hgnc_id : "HGNC:10388",
      havana_gene : "OTTHUMG00000140099.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1446302,
      stop : 1473244,
      direction : "+",
      ID : "ENSG00000115266.12",
      gene_id : "ENSG00000115266.12",
      gene_type : "protein_coding",
      gene_name : "APC2",
      gene_level : 2,
      hgnc_id : "HGNC:24036",
      havana_gene : "OTTHUMG00000180059.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1461143,
      stop : 1479219,
      direction : "-",
      ID : "ENSG00000119559.17",
      gene_id : "ENSG00000119559.17",
      gene_type : "protein_coding",
      gene_name : "C19orf25",
      gene_level : 1,
      hgnc_id : "HGNC:26711",
      havana_gene : "OTTHUMG00000180092.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1481428,
      stop : 1490752,
      direction : "-",
      ID : "ENSG00000115257.15",
      gene_id : "ENSG00000115257.15",
      gene_type : "protein_coding",
      gene_name : "PCSK4",
      gene_level : 2,
      hgnc_id : "HGNC:8746",
      havana_gene : "OTTHUMG00000128541.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1491166,
      stop : 1497927,
      direction : "+",
      ID : "ENSG00000115255.12",
      gene_id : "ENSG00000115255.12",
      gene_type : "protein_coding",
      gene_name : "REEP6",
      gene_level : 2,
      hgnc_id : "HGNC:30078",
      havana_gene : "OTTHUMG00000180072.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1505022,
      stop : 1513604,
      direction : "-",
      ID : "ENSG00000185761.11",
      gene_id : "ENSG00000185761.11",
      gene_type : "protein_coding",
      gene_name : "ADAMTSL5",
      gene_level : 2,
      hgnc_id : "HGNC:27912",
      havana_gene : "OTTHUMG00000180093.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1508023,
      stop : 1536046,
      direction : "+",
      ID : "ENSG00000185988.15",
      gene_id : "ENSG00000185988.15",
      gene_type : "protein_coding",
      gene_name : "PLK5",
      gene_level : 1,
      hgnc_id : "HGNC:27001",
      havana_gene : "OTTHUMG00000180073.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1554669,
      stop : 1568058,
      direction : "-",
      ID : "ENSG00000181588.16",
      gene_id : "ENSG00000181588.16",
      gene_type : "protein_coding",
      gene_name : "MEX3D",
      gene_level : 2,
      hgnc_id : "HGNC:16734",
      havana_gene : "OTTHUMG00000150369.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1573596,
      stop : 1592865,
      direction : "-",
      ID : "ENSG00000071655.18",
      gene_id : "ENSG00000071655.18",
      gene_type : "protein_coding",
      gene_name : "MBD3",
      gene_level : 2,
      hgnc_id : "HGNC:6918",
      havana_gene : "OTTHUMG00000180081.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1578339,
      stop : 1605445,
      direction : "-",
      ID : "ENSG00000267059.2",
      gene_id : "ENSG00000267059.2",
      gene_type : "protein_coding",
      gene_name : "AC005943.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180082.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1597169,
      stop : 1605473,
      direction : "-",
      ID : "ENSG00000127540.12",
      gene_id : "ENSG00000127540.12",
      gene_type : "protein_coding",
      gene_name : "UQCR11",
      gene_level : 2,
      hgnc_id : "HGNC:30862",
      havana_gene : "OTTHUMG00000180084.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1609290,
      stop : 1652615,
      direction : "-",
      ID : "ENSG00000071564.17",
      gene_id : "ENSG00000071564.17",
      gene_type : "protein_coding",
      gene_name : "TCF3",
      gene_level : 1,
      hgnc_id : "HGNC:11633",
      havana_gene : "OTTHUMG00000180031.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1753506,
      stop : 1780988,
      direction : "+",
      ID : "ENSG00000205922.5",
      gene_id : "ENSG00000205922.5",
      gene_type : "protein_coding",
      gene_name : "ONECUT3",
      gene_level : 2,
      hgnc_id : "HGNC:13399",
      havana_gene : "OTTHUMG00000172429.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1782075,
      stop : 1812276,
      direction : "-",
      ID : "ENSG00000130270.16",
      gene_id : "ENSG00000130270.16",
      gene_type : "protein_coding",
      gene_name : "ATP8B3",
      gene_level : 2,
      hgnc_id : "HGNC:13535",
      havana_gene : "OTTHUMG00000166189.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1815248,
      stop : 1848483,
      direction : "-",
      ID : "ENSG00000079313.15",
      gene_id : "ENSG00000079313.15",
      gene_type : "protein_coding",
      gene_name : "REXO1",
      gene_level : 2,
      hgnc_id : "HGNC:24616",
      havana_gene : "OTTHUMG00000179991.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1852399,
      stop : 1863579,
      direction : "-",
      ID : "ENSG00000129911.9",
      gene_id : "ENSG00000129911.9",
      gene_type : "protein_coding",
      gene_name : "KLF16",
      gene_level : 2,
      hgnc_id : "HGNC:16857",
      havana_gene : "OTTHUMG00000179994.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1876810,
      stop : 1885496,
      direction : "-",
      ID : "ENSG00000129968.17",
      gene_id : "ENSG00000129968.17",
      gene_type : "protein_coding",
      gene_name : "ABHD17A",
      gene_level : 2,
      hgnc_id : "HGNC:28756",
      havana_gene : "OTTHUMG00000171872.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1905372,
      stop : 1926013,
      direction : "+",
      ID : "ENSG00000227500.10",
      gene_id : "ENSG00000227500.10",
      gene_type : "protein_coding",
      gene_name : "SCAMP4",
      gene_level : 2,
      hgnc_id : "HGNC:30385",
      havana_gene : "OTTHUMG00000154590.31",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1905399,
      stop : 1913447,
      direction : "+",
      ID : "ENSG00000213638.6",
      gene_id : "ENSG00000213638.6",
      gene_type : "protein_coding",
      gene_name : "ADAT3",
      gene_level : 2,
      hgnc_id : "HGNC:25151",
      havana_gene : "OTTHUMG00000154591.34",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1941172,
      stop : 1981338,
      direction : "+",
      ID : "ENSG00000133275.16",
      gene_id : "ENSG00000133275.16",
      gene_type : "protein_coding",
      gene_name : "CSNK1G2",
      gene_level : 1,
      hgnc_id : "HGNC:2455",
      havana_gene : "OTTHUMG00000180016.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 1985438,
      stop : 2034881,
      direction : "-",
      ID : "ENSG00000133243.10",
      gene_id : "ENSG00000133243.10",
      gene_type : "protein_coding",
      gene_name : "BTBD2",
      gene_level : 2,
      hgnc_id : "HGNC:15504",
      havana_gene : "OTTHUMG00000180017.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2037465,
      stop : 2051244,
      direction : "-",
      ID : "ENSG00000099875.16",
      gene_id : "ENSG00000099875.16",
      gene_type : "protein_coding",
      gene_name : "MKNK2",
      gene_level : 1,
      hgnc_id : "HGNC:7111",
      havana_gene : "OTTHUMG00000180020.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2071036,
      stop : 2096673,
      direction : "-",
      ID : "ENSG00000172081.14",
      gene_id : "ENSG00000172081.14",
      gene_type : "protein_coding",
      gene_name : "MOB3A",
      gene_level : 2,
      hgnc_id : "HGNC:29802",
      havana_gene : "OTTHUMG00000180353.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2096429,
      stop : 2099593,
      direction : "+",
      ID : "ENSG00000099840.14",
      gene_id : "ENSG00000099840.14",
      gene_type : "protein_coding",
      gene_name : "IZUMO4",
      gene_level : 2,
      hgnc_id : "HGNC:26950",
      havana_gene : "OTTHUMG00000141290.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2100988,
      stop : 2164468,
      direction : "-",
      ID : "ENSG00000065000.19",
      gene_id : "ENSG00000065000.19",
      gene_type : "protein_coding",
      gene_name : "AP3D1",
      gene_level : 2,
      hgnc_id : "HGNC:568",
      havana_gene : "OTTHUMG00000180354.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2163933,
      stop : 2232578,
      direction : "+",
      ID : "ENSG00000104885.18",
      gene_id : "ENSG00000104885.18",
      gene_type : "protein_coding",
      gene_name : "DOT1L",
      gene_level : 1,
      hgnc_id : "HGNC:24948",
      havana_gene : "OTTHUMG00000150431.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2230084,
      stop : 2237704,
      direction : "-",
      ID : "ENSG00000104886.12",
      gene_id : "ENSG00000104886.12",
      gene_type : "protein_coding",
      gene_name : "PLEKHJ1",
      gene_level : 2,
      hgnc_id : "HGNC:18211",
      havana_gene : "OTTHUMG00000180425.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2236824,
      stop : 2248655,
      direction : "+",
      ID : "ENSG00000104897.10",
      gene_id : "ENSG00000104897.10",
      gene_type : "protein_coding",
      gene_name : "SF3A2",
      gene_level : 2,
      hgnc_id : "HGNC:10766",
      havana_gene : "OTTHUMG00000180414.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2249309,
      stop : 2252073,
      direction : "+",
      ID : "ENSG00000104899.8",
      gene_id : "ENSG00000104899.8",
      gene_type : "protein_coding",
      gene_name : "AMH",
      gene_level : 1,
      hgnc_id : "HGNC:464",
      havana_gene : "OTTHUMG00000180415.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2252252,
      stop : 2269759,
      direction : "-",
      ID : "ENSG00000167476.10",
      gene_id : "ENSG00000167476.10",
      gene_type : "protein_coding",
      gene_name : "JSRP1",
      gene_level : 2,
      hgnc_id : "HGNC:24963",
      havana_gene : "OTTHUMG00000180413.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2269509,
      stop : 2273490,
      direction : "+",
      ID : "ENSG00000104904.12",
      gene_id : "ENSG00000104904.12",
      gene_type : "protein_coding",
      gene_name : "OAZ1",
      gene_level : 1,
      hgnc_id : "HGNC:8095",
      havana_gene : "OTTHUMG00000178459.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2269525,
      stop : 2341172,
      direction : "+",
      ID : "ENSG00000273734.1",
      gene_id : "ENSG00000273734.1",
      gene_type : "protein_coding",
      gene_name : "AC005258.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186732.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2274631,
      stop : 2282175,
      direction : "-",
      ID : "ENSG00000188305.6",
      gene_id : "ENSG00000188305.6",
      gene_type : "protein_coding",
      gene_name : "PEAK3",
      gene_level : 2,
      hgnc_id : "HGNC:24793",
      havana_gene : "OTTHUMG00000178460.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2289784,
      stop : 2292024,
      direction : "-",
      ID : "ENSG00000220008.3",
      gene_id : "ENSG00000220008.3",
      gene_type : "protein_coding",
      gene_name : "LINGO3",
      gene_level : 2,
      hgnc_id : "HGNC:21206",
      havana_gene : "OTTHUMG00000180418.2",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2321520,
      stop : 2328611,
      direction : "-",
      ID : "ENSG00000130332.15",
      gene_id : "ENSG00000130332.15",
      gene_type : "protein_coding",
      gene_name : "LSM7",
      gene_level : 2,
      hgnc_id : "HGNC:20470",
      havana_gene : "OTTHUMG00000180441.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2328615,
      stop : 2355095,
      direction : "+",
      ID : "ENSG00000005206.17",
      gene_id : "ENSG00000005206.17",
      gene_type : "protein_coding",
      gene_name : "SPPL2B",
      gene_level : 2,
      hgnc_id : "HGNC:30627",
      havana_gene : "OTTHUMG00000180443.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2360238,
      stop : 2426239,
      direction : "+",
      ID : "ENSG00000178297.14",
      gene_id : "ENSG00000178297.14",
      gene_type : "protein_coding",
      gene_name : "TMPRSS9",
      gene_level : 2,
      hgnc_id : "HGNC:30079",
      havana_gene : "OTTHUMG00000180431.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2425625,
      stop : 2427586,
      direction : "-",
      ID : "ENSG00000099800.8",
      gene_id : "ENSG00000099800.8",
      gene_type : "protein_coding",
      gene_name : "TIMM13",
      gene_level : 2,
      hgnc_id : "HGNC:11816",
      havana_gene : "OTTHUMG00000180432.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2427638,
      stop : 2456959,
      direction : "-",
      ID : "ENSG00000176619.13",
      gene_id : "ENSG00000176619.13",
      gene_type : "protein_coding",
      gene_name : "LMNB2",
      gene_level : 2,
      hgnc_id : "HGNC:6638",
      havana_gene : "OTTHUMG00000150626.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2476122,
      stop : 2478259,
      direction : "+",
      ID : "ENSG00000099860.9",
      gene_id : "ENSG00000099860.9",
      gene_type : "protein_coding",
      gene_name : "GADD45B",
      gene_level : 2,
      hgnc_id : "HGNC:4096",
      havana_gene : "OTTHUMG00000180434.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2511219,
      stop : 2702694,
      direction : "-",
      ID : "ENSG00000176533.13",
      gene_id : "ENSG00000176533.13",
      gene_type : "protein_coding",
      gene_name : "GNG7",
      gene_level : 2,
      hgnc_id : "HGNC:4410",
      havana_gene : "OTTHUMG00000180435.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2714567,
      stop : 2721372,
      direction : "-",
      ID : "ENSG00000176490.5",
      gene_id : "ENSG00000176490.5",
      gene_type : "protein_coding",
      gene_name : "DIRAS1",
      gene_level : 2,
      hgnc_id : "HGNC:19127",
      havana_gene : "OTTHUMG00000180439.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2717769,
      stop : 2740048,
      direction : "-",
      ID : "ENSG00000267001.1",
      gene_id : "ENSG00000267001.1",
      gene_type : "protein_coding",
      gene_name : "AC006538.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180473.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2732204,
      stop : 2740028,
      direction : "-",
      ID : "ENSG00000141873.11",
      gene_id : "ENSG00000141873.11",
      gene_type : "protein_coding",
      gene_name : "SLC39A3",
      gene_level : 1,
      hgnc_id : "HGNC:17128",
      havana_gene : "OTTHUMG00000180440.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2754715,
      stop : 2783362,
      direction : "-",
      ID : "ENSG00000104969.11",
      gene_id : "ENSG00000104969.11",
      gene_type : "protein_coding",
      gene_name : "SGTA",
      gene_level : 2,
      hgnc_id : "HGNC:10819",
      havana_gene : "OTTHUMG00000180474.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2785503,
      stop : 2815807,
      direction : "+",
      ID : "ENSG00000172009.15",
      gene_id : "ENSG00000172009.15",
      gene_type : "protein_coding",
      gene_name : "THOP1",
      gene_level : 1,
      hgnc_id : "HGNC:11793",
      havana_gene : "OTTHUMG00000180492.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2819868,
      stop : 2836735,
      direction : "+",
      ID : "ENSG00000172006.12",
      gene_id : "ENSG00000172006.12",
      gene_type : "protein_coding",
      gene_name : "ZNF554",
      gene_level : 2,
      hgnc_id : "HGNC:26629",
      havana_gene : "OTTHUMG00000180493.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2841437,
      stop : 2860471,
      direction : "+",
      ID : "ENSG00000186300.12",
      gene_id : "ENSG00000186300.12",
      gene_type : "protein_coding",
      gene_name : "ZNF555",
      gene_level : 1,
      hgnc_id : "HGNC:28382",
      havana_gene : "OTTHUMG00000180500.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2867335,
      stop : 2883445,
      direction : "+",
      ID : "ENSG00000172000.7",
      gene_id : "ENSG00000172000.7",
      gene_type : "protein_coding",
      gene_name : "ZNF556",
      gene_level : 1,
      hgnc_id : "HGNC:25669",
      havana_gene : "OTTHUMG00000180501.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2900898,
      stop : 2918473,
      direction : "+",
      ID : "ENSG00000171970.13",
      gene_id : "ENSG00000171970.13",
      gene_type : "protein_coding",
      gene_name : "ZNF57",
      gene_level : 1,
      hgnc_id : "HGNC:13125",
      havana_gene : "OTTHUMG00000164485.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2933218,
      stop : 2944971,
      direction : "-",
      ID : "ENSG00000175691.9",
      gene_id : "ENSG00000175691.9",
      gene_type : "protein_coding",
      gene_name : "ZNF77",
      gene_level : 2,
      hgnc_id : "HGNC:13150",
      havana_gene : "OTTHUMG00000180566.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2977538,
      stop : 2995179,
      direction : "+",
      ID : "ENSG00000104953.20",
      gene_id : "ENSG00000104953.20",
      gene_type : "protein_coding",
      gene_name : "TLE6",
      gene_level : 2,
      hgnc_id : "HGNC:30788",
      havana_gene : "OTTHUMG00000156793.13",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 2997639,
      stop : 3047635,
      direction : "-",
      ID : "ENSG00000065717.15",
      gene_id : "ENSG00000065717.15",
      gene_type : "protein_coding",
      gene_name : "TLE2",
      gene_level : 2,
      hgnc_id : "HGNC:11838",
      havana_gene : "OTTHUMG00000180613.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3052910,
      stop : 3063107,
      direction : "-",
      ID : "ENSG00000104964.15",
      gene_id : "ENSG00000104964.15",
      gene_type : "protein_coding",
      gene_name : "TLE5",
      gene_level : 2,
      hgnc_id : "HGNC:307",
      havana_gene : "OTTHUMG00000180567.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3094362,
      stop : 3123999,
      direction : "+",
      ID : "ENSG00000088256.9",
      gene_id : "ENSG00000088256.9",
      gene_type : "protein_coding",
      gene_name : "GNA11",
      gene_level : 2,
      hgnc_id : "HGNC:4379",
      havana_gene : "OTTHUMG00000180631.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3136033,
      stop : 3163749,
      direction : "+",
      ID : "ENSG00000060558.4",
      gene_id : "ENSG00000060558.4",
      gene_type : "protein_coding",
      gene_name : "GNA15",
      gene_level : 2,
      hgnc_id : "HGNC:4383",
      havana_gene : "OTTHUMG00000180637.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3172346,
      stop : 3180332,
      direction : "+",
      ID : "ENSG00000125910.6",
      gene_id : "ENSG00000125910.6",
      gene_type : "protein_coding",
      gene_name : "S1PR4",
      gene_level : 2,
      hgnc_id : "HGNC:3170",
      havana_gene : "OTTHUMG00000180672.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3185563,
      stop : 3209575,
      direction : "+",
      ID : "ENSG00000125912.11",
      gene_id : "ENSG00000125912.11",
      gene_type : "protein_coding",
      gene_name : "NCLN",
      gene_level : 2,
      hgnc_id : "HGNC:26923",
      havana_gene : "OTTHUMG00000180687.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3224661,
      stop : 3297076,
      direction : "+",
      ID : "ENSG00000161082.13",
      gene_id : "ENSG00000161082.13",
      gene_type : "protein_coding",
      gene_name : "CELF5",
      gene_level : 2,
      hgnc_id : "HGNC:14058",
      havana_gene : "OTTHUMG00000180693.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3314403,
      stop : 3469217,
      direction : "+",
      ID : "ENSG00000141905.19",
      gene_id : "ENSG00000141905.19",
      gene_type : "protein_coding",
      gene_name : "NFIC",
      gene_level : 2,
      hgnc_id : "HGNC:7786",
      havana_gene : "OTTHUMG00000180731.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3473986,
      stop : 3480525,
      direction : "-",
      ID : "ENSG00000095932.7",
      gene_id : "ENSG00000095932.7",
      gene_type : "protein_coding",
      gene_name : "SMIM24",
      gene_level : 2,
      hgnc_id : "HGNC:37244",
      havana_gene : "OTTHUMG00000180761.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3482804,
      stop : 3483446,
      direction : "-",
      ID : "ENSG00000284638.1",
      gene_id : "ENSG00000284638.1",
      gene_type : "protein_coding",
      gene_name : "AC005551.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000180762.5",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3490821,
      stop : 3500674,
      direction : "-",
      ID : "ENSG00000129932.10",
      gene_id : "ENSG00000129932.10",
      gene_type : "protein_coding",
      gene_name : "DOHH",
      gene_level : 2,
      hgnc_id : "HGNC:28662",
      havana_gene : "OTTHUMG00000192247.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3506311,
      stop : 3538334,
      direction : "+",
      ID : "ENSG00000105325.15",
      gene_id : "ENSG00000105325.15",
      gene_type : "protein_coding",
      gene_name : "FZR1",
      gene_level : 2,
      hgnc_id : "HGNC:24824",
      havana_gene : "OTTHUMG00000180747.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3538261,
      stop : 3574290,
      direction : "-",
      ID : "ENSG00000161091.13",
      gene_id : "ENSG00000161091.13",
      gene_type : "protein_coding",
      gene_name : "MFSD12",
      gene_level : 2,
      hgnc_id : "HGNC:28299",
      havana_gene : "OTTHUMG00000180766.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3539154,
      stop : 3544030,
      direction : "+",
      ID : "ENSG00000183397.5",
      gene_id : "ENSG00000183397.5",
      gene_type : "protein_coding",
      gene_name : "C19orf71",
      gene_level : 2,
      hgnc_id : "HGNC:34496",
      havana_gene : "OTTHUMG00000180764.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3572777,
      stop : 3579088,
      direction : "+",
      ID : "ENSG00000064961.19",
      gene_id : "ENSG00000064961.19",
      gene_type : "protein_coding",
      gene_name : "HMG20B",
      gene_level : 1,
      hgnc_id : "HGNC:5002",
      havana_gene : "OTTHUMG00000150437.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3585478,
      stop : 3593541,
      direction : "+",
      ID : "ENSG00000179855.9",
      gene_id : "ENSG00000179855.9",
      gene_type : "protein_coding",
      gene_name : "GIPC3",
      gene_level : 2,
      hgnc_id : "HGNC:18183",
      havana_gene : "OTTHUMG00000167425.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3594507,
      stop : 3606875,
      direction : "-",
      ID : "ENSG00000006638.13",
      gene_id : "ENSG00000006638.13",
      gene_type : "protein_coding",
      gene_name : "TBXA2R",
      gene_level : 2,
      hgnc_id : "HGNC:11608",
      havana_gene : "OTTHUMG00000180806.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3610645,
      stop : 3626815,
      direction : "-",
      ID : "ENSG00000105298.14",
      gene_id : "ENSG00000105298.14",
      gene_type : "protein_coding",
      gene_name : "CACTIN",
      gene_level : 1,
      hgnc_id : "HGNC:29938",
      havana_gene : "OTTHUMG00000180808.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3630183,
      stop : 3700468,
      direction : "-",
      ID : "ENSG00000186111.11",
      gene_id : "ENSG00000186111.11",
      gene_type : "protein_coding",
      gene_name : "PIP5K1C",
      gene_level : 1,
      hgnc_id : "HGNC:8996",
      havana_gene : "OTTHUMG00000180870.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3708362,
      stop : 3750813,
      direction : "+",
      ID : "ENSG00000105289.15",
      gene_id : "ENSG00000105289.15",
      gene_type : "protein_coding",
      gene_name : "TJP3",
      gene_level : 2,
      hgnc_id : "HGNC:11829",
      havana_gene : "OTTHUMG00000180872.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3750772,
      stop : 3761692,
      direction : "-",
      ID : "ENSG00000011132.12",
      gene_id : "ENSG00000011132.12",
      gene_type : "protein_coding",
      gene_name : "APBA3",
      gene_level : 2,
      hgnc_id : "HGNC:580",
      havana_gene : "OTTHUMG00000180915.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3762682,
      stop : 3768575,
      direction : "+",
      ID : "ENSG00000183617.5",
      gene_id : "ENSG00000183617.5",
      gene_type : "protein_coding",
      gene_name : "MRPL54",
      gene_level : 2,
      hgnc_id : "HGNC:16685",
      havana_gene : "OTTHUMG00000180873.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3769089,
      stop : 3772228,
      direction : "-",
      ID : "ENSG00000173976.16",
      gene_id : "ENSG00000173976.16",
      gene_type : "protein_coding",
      gene_name : "RAX2",
      gene_level : 2,
      hgnc_id : "HGNC:18286",
      havana_gene : "OTTHUMG00000171148.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3777970,
      stop : 3802129,
      direction : "-",
      ID : "ENSG00000007264.15",
      gene_id : "ENSG00000007264.15",
      gene_type : "protein_coding",
      gene_name : "MATK",
      gene_level : 1,
      hgnc_id : "HGNC:6906",
      havana_gene : "OTTHUMG00000180916.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3804024,
      stop : 3869038,
      direction : "-",
      ID : "ENSG00000105278.12",
      gene_id : "ENSG00000105278.12",
      gene_type : "protein_coding",
      gene_name : "ZFR2",
      gene_level : 2,
      hgnc_id : "HGNC:29189",
      havana_gene : "OTTHUMG00000180918.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3879864,
      stop : 3928082,
      direction : "+",
      ID : "ENSG00000167654.18",
      gene_id : "ENSG00000167654.18",
      gene_type : "protein_coding",
      gene_name : "ATCAY",
      gene_level : 2,
      hgnc_id : "HGNC:779",
      havana_gene : "OTTHUMG00000181836.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3933103,
      stop : 3942416,
      direction : "+",
      ID : "ENSG00000077009.13",
      gene_id : "ENSG00000077009.13",
      gene_type : "protein_coding",
      gene_name : "NMRK2",
      gene_level : 1,
      hgnc_id : "HGNC:17871",
      havana_gene : "OTTHUMG00000181758.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3958453,
      stop : 3971123,
      direction : "-",
      ID : "ENSG00000167657.14",
      gene_id : "ENSG00000167657.14",
      gene_type : "protein_coding",
      gene_name : "DAPK3",
      gene_level : 2,
      hgnc_id : "HGNC:2676",
      havana_gene : "OTTHUMG00000181825.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 3976056,
      stop : 3985463,
      direction : "-",
      ID : "ENSG00000167658.16",
      gene_id : "ENSG00000167658.16",
      gene_type : "protein_coding",
      gene_name : "EEF2",
      gene_level : 1,
      hgnc_id : "HGNC:3214",
      havana_gene : "OTTHUMG00000181790.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4007736,
      stop : 4039386,
      direction : "+",
      ID : "ENSG00000105229.7",
      gene_id : "ENSG00000105229.7",
      gene_type : "protein_coding",
      gene_name : "PIAS4",
      gene_level : 2,
      hgnc_id : "HGNC:17002",
      havana_gene : "OTTHUMG00000181759.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4043303,
      stop : 4066899,
      direction : "-",
      ID : "ENSG00000178951.9",
      gene_id : "ENSG00000178951.9",
      gene_type : "protein_coding",
      gene_name : "ZBTB7A",
      gene_level : 2,
      hgnc_id : "HGNC:18078",
      havana_gene : "OTTHUMG00000181792.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4090321,
      stop : 4124122,
      direction : "-",
      ID : "ENSG00000126934.14",
      gene_id : "ENSG00000126934.14",
      gene_type : "protein_coding",
      gene_name : "MAP2K2",
      gene_level : 2,
      hgnc_id : "HGNC:6842",
      havana_gene : "OTTHUMG00000134286.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4153631,
      stop : 4173054,
      direction : "+",
      ID : "ENSG00000060566.14",
      gene_id : "ENSG00000060566.14",
      gene_type : "protein_coding",
      gene_name : "CREB3L3",
      gene_level : 1,
      hgnc_id : "HGNC:18855",
      havana_gene : "OTTHUMG00000181846.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4174109,
      stop : 4182566,
      direction : "-",
      ID : "ENSG00000077463.15",
      gene_id : "ENSG00000077463.15",
      gene_type : "protein_coding",
      gene_name : "SIRT6",
      gene_level : 2,
      hgnc_id : "HGNC:14934",
      havana_gene : "OTTHUMG00000181847.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4183354,
      stop : 4224814,
      direction : "+",
      ID : "ENSG00000089847.12",
      gene_id : "ENSG00000089847.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD24",
      gene_level : 2,
      hgnc_id : "HGNC:29424",
      havana_gene : "OTTHUMG00000181865.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4229523,
      stop : 4237528,
      direction : "+",
      ID : "ENSG00000105246.6",
      gene_id : "ENSG00000105246.6",
      gene_type : "protein_coding",
      gene_name : "EBI3",
      gene_level : 2,
      hgnc_id : "HGNC:3129",
      havana_gene : "OTTHUMG00000181866.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4247080,
      stop : 4269088,
      direction : "+",
      ID : "ENSG00000105248.16",
      gene_id : "ENSG00000105248.16",
      gene_type : "protein_coding",
      gene_name : "YJU2",
      gene_level : 1,
      hgnc_id : "HGNC:25518",
      havana_gene : "OTTHUMG00000181867.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4279266,
      stop : 4290722,
      direction : "+",
      ID : "ENSG00000105251.11",
      gene_id : "ENSG00000105251.11",
      gene_type : "protein_coding",
      gene_name : "SHD",
      gene_level : 2,
      hgnc_id : "HGNC:30633",
      havana_gene : "OTTHUMG00000181879.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4292232,
      stop : 4302431,
      direction : "-",
      ID : "ENSG00000167664.8",
      gene_id : "ENSG00000167664.8",
      gene_type : "protein_coding",
      gene_name : "TMIGD2",
      gene_level : 2,
      hgnc_id : "HGNC:28324",
      havana_gene : "OTTHUMG00000181880.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4304598,
      stop : 4323843,
      direction : "+",
      ID : "ENSG00000105255.11",
      gene_id : "ENSG00000105255.11",
      gene_type : "protein_coding",
      gene_name : "FSD1",
      gene_level : 2,
      hgnc_id : "HGNC:13745",
      havana_gene : "OTTHUMG00000181881.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4324043,
      stop : 4342786,
      direction : "-",
      ID : "ENSG00000178078.12",
      gene_id : "ENSG00000178078.12",
      gene_type : "protein_coding",
      gene_name : "STAP2",
      gene_level : 2,
      hgnc_id : "HGNC:30430",
      havana_gene : "OTTHUMG00000181884.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4343527,
      stop : 4360086,
      direction : "+",
      ID : "ENSG00000008382.16",
      gene_id : "ENSG00000008382.16",
      gene_type : "protein_coding",
      gene_name : "MPND",
      gene_level : 2,
      hgnc_id : "HGNC:25934",
      havana_gene : "OTTHUMG00000181914.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4360370,
      stop : 4400547,
      direction : "-",
      ID : "ENSG00000141985.9",
      gene_id : "ENSG00000141985.9",
      gene_type : "protein_coding",
      gene_name : "SH3GL1",
      gene_level : 1,
      hgnc_id : "HGNC:10830",
      havana_gene : "OTTHUMG00000181918.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4402640,
      stop : 4445018,
      direction : "+",
      ID : "ENSG00000167670.16",
      gene_id : "ENSG00000167670.16",
      gene_type : "protein_coding",
      gene_name : "CHAF1A",
      gene_level : 1,
      hgnc_id : "HGNC:1910",
      havana_gene : "OTTHUMG00000181922.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4444999,
      stop : 4457794,
      direction : "-",
      ID : "ENSG00000167671.12",
      gene_id : "ENSG00000167671.12",
      gene_type : "protein_coding",
      gene_name : "UBXN6",
      gene_level : 1,
      hgnc_id : "HGNC:14928",
      havana_gene : "OTTHUMG00000181954.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4472297,
      stop : 4502208,
      direction : "+",
      ID : "ENSG00000167674.15",
      gene_id : "ENSG00000167674.15",
      gene_type : "protein_coding",
      gene_name : "HDGFL2",
      gene_level : 2,
      hgnc_id : "HGNC:14680",
      havana_gene : "OTTHUMG00000182007.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4502180,
      stop : 4518465,
      direction : "-",
      ID : "ENSG00000167676.4",
      gene_id : "ENSG00000167676.4",
      gene_type : "protein_coding",
      gene_name : "PLIN4",
      gene_level : 2,
      hgnc_id : "HGNC:29393",
      havana_gene : "OTTHUMG00000167571.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4522531,
      stop : 4535224,
      direction : "-",
      ID : "ENSG00000214456.8",
      gene_id : "ENSG00000214456.8",
      gene_type : "protein_coding",
      gene_name : "PLIN5",
      gene_level : 2,
      hgnc_id : "HGNC:33196",
      havana_gene : "OTTHUMG00000182008.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4528427,
      stop : 4540067,
      direction : "-",
      ID : "ENSG00000267385.1",
      gene_id : "ENSG00000267385.1",
      gene_type : "protein_coding",
      gene_name : "AC011498.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182009.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4536402,
      stop : 4540036,
      direction : "-",
      ID : "ENSG00000171236.10",
      gene_id : "ENSG00000171236.10",
      gene_type : "protein_coding",
      gene_name : "LRG1",
      gene_level : 2,
      hgnc_id : "HGNC:29480",
      havana_gene : "OTTHUMG00000182010.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4542593,
      stop : 4581776,
      direction : "-",
      ID : "ENSG00000167680.17",
      gene_id : "ENSG00000167680.17",
      gene_type : "protein_coding",
      gene_name : "SEMA6B",
      gene_level : 2,
      hgnc_id : "HGNC:10739",
      havana_gene : "OTTHUMG00000182011.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4639516,
      stop : 4655568,
      direction : "+",
      ID : "ENSG00000185361.9",
      gene_id : "ENSG00000185361.9",
      gene_type : "protein_coding",
      gene_name : "TNFAIP8L1",
      gene_level : 2,
      hgnc_id : "HGNC:28279",
      havana_gene : "OTTHUMG00000182013.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4641374,
      stop : 4670362,
      direction : "-",
      ID : "ENSG00000074842.8",
      gene_id : "ENSG00000074842.8",
      gene_type : "protein_coding",
      gene_name : "MYDGF",
      gene_level : 2,
      hgnc_id : "HGNC:16948",
      havana_gene : "OTTHUMG00000182039.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4675224,
      stop : 4724673,
      direction : "-",
      ID : "ENSG00000142002.18",
      gene_id : "ENSG00000142002.18",
      gene_type : "protein_coding",
      gene_name : "DPP9",
      gene_level : 1,
      hgnc_id : "HGNC:18648",
      havana_gene : "OTTHUMG00000182040.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4791734,
      stop : 4801273,
      direction : "+",
      ID : "ENSG00000141965.5",
      gene_id : "ENSG00000141965.5",
      gene_type : "protein_coding",
      gene_name : "FEM1A",
      gene_level : 2,
      hgnc_id : "HGNC:16934",
      havana_gene : "OTTHUMG00000182048.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4815932,
      stop : 4831712,
      direction : "-",
      ID : "ENSG00000127666.10",
      gene_id : "ENSG00000127666.10",
      gene_type : "protein_coding",
      gene_name : "TICAM1",
      gene_level : 2,
      hgnc_id : "HGNC:18348",
      havana_gene : "OTTHUMG00000180248.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4838341,
      stop : 4867694,
      direction : "-",
      ID : "ENSG00000105355.9",
      gene_id : "ENSG00000105355.9",
      gene_type : "protein_coding",
      gene_name : "PLIN3",
      gene_level : 1,
      hgnc_id : "HGNC:16893",
      havana_gene : "OTTHUMG00000180249.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4890437,
      stop : 4902896,
      direction : "-",
      ID : "ENSG00000205784.4",
      gene_id : "ENSG00000205784.4",
      gene_type : "protein_coding",
      gene_name : "ARRDC5",
      gene_level : 2,
      hgnc_id : "HGNC:31407",
      havana_gene : "OTTHUMG00000180250.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4903080,
      stop : 4962154,
      direction : "+",
      ID : "ENSG00000276043.5",
      gene_id : "ENSG00000276043.5",
      gene_type : "protein_coding",
      gene_name : "UHRF1",
      gene_level : 2,
      hgnc_id : "HGNC:12556",
      havana_gene : "OTTHUMG00000180251.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 4969113,
      stop : 5153598,
      direction : "+",
      ID : "ENSG00000127663.15",
      gene_id : "ENSG00000127663.15",
      gene_type : "protein_coding",
      gene_name : "KDM4B",
      gene_level : 2,
      hgnc_id : "HGNC:29136",
      havana_gene : "OTTHUMG00000180281.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5158495,
      stop : 5340803,
      direction : "-",
      ID : "ENSG00000105426.17",
      gene_id : "ENSG00000105426.17",
      gene_type : "protein_coding",
      gene_name : "PTPRS",
      gene_level : 2,
      hgnc_id : "HGNC:9681",
      havana_gene : "OTTHUMG00000180325.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5455417,
      stop : 5456856,
      direction : "+",
      ID : "ENSG00000105428.6",
      gene_id : "ENSG00000105428.6",
      gene_type : "protein_coding",
      gene_name : "ZNRF4",
      gene_level : 2,
      hgnc_id : "HGNC:17726",
      havana_gene : "OTTHUMG00000180356.2",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5558167,
      stop : 5578349,
      direction : "-",
      ID : "ENSG00000223573.7",
      gene_id : "ENSG00000223573.7",
      gene_type : "protein_coding",
      gene_name : "TINCR",
      gene_level : 2,
      hgnc_id : "HGNC:14607",
      havana_gene : "OTTHUMG00000150390.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5586999,
      stop : 5624046,
      direction : "-",
      ID : "ENSG00000130254.12",
      gene_id : "ENSG00000130254.12",
      gene_type : "protein_coding",
      gene_name : "SAFB2",
      gene_level : 1,
      hgnc_id : "HGNC:21605",
      havana_gene : "OTTHUMG00000180374.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5623035,
      stop : 5668478,
      direction : "+",
      ID : "ENSG00000160633.13",
      gene_id : "ENSG00000160633.13",
      gene_type : "protein_coding",
      gene_name : "SAFB",
      gene_level : 2,
      hgnc_id : "HGNC:10520",
      havana_gene : "OTTHUMG00000180502.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5674947,
      stop : 5691875,
      direction : "+",
      ID : "ENSG00000130255.13",
      gene_id : "ENSG00000130255.13",
      gene_type : "protein_coding",
      gene_name : "RPL36",
      gene_level : 2,
      hgnc_id : "HGNC:13631",
      havana_gene : "OTTHUMG00000178585.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5678421,
      stop : 5680516,
      direction : "-",
      ID : "ENSG00000174917.9",
      gene_id : "ENSG00000174917.9",
      gene_type : "protein_coding",
      gene_name : "MICOS13",
      gene_level : 2,
      hgnc_id : "HGNC:33702",
      havana_gene : "OTTHUMG00000180503.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5680604,
      stop : 5688523,
      direction : "+",
      ID : "ENSG00000167733.14",
      gene_id : "ENSG00000167733.14",
      gene_type : "protein_coding",
      gene_name : "HSD11B1L",
      gene_level : 2,
      hgnc_id : "HGNC:30419",
      havana_gene : "OTTHUMG00000178586.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5691834,
      stop : 5720572,
      direction : "-",
      ID : "ENSG00000196365.12",
      gene_id : "ENSG00000196365.12",
      gene_type : "protein_coding",
      gene_name : "LONP1",
      gene_level : 1,
      hgnc_id : "HGNC:9479",
      havana_gene : "OTTHUMG00000180504.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5720637,
      stop : 5778734,
      direction : "+",
      ID : "ENSG00000174898.16",
      gene_id : "ENSG00000174898.16",
      gene_type : "protein_coding",
      gene_name : "CATSPERD",
      gene_level : 1,
      hgnc_id : "HGNC:28598",
      havana_gene : "OTTHUMG00000143036.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5782960,
      stop : 5784746,
      direction : "-",
      ID : "ENSG00000212123.4",
      gene_id : "ENSG00000212123.4",
      gene_type : "protein_coding",
      gene_name : "PRR22",
      gene_level : 2,
      hgnc_id : "HGNC:28354",
      havana_gene : "OTTHUMG00000180553.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5784005,
      stop : 5785619,
      direction : "-",
      ID : "ENSG00000267157.1",
      gene_id : "ENSG00000267157.1",
      gene_type : "protein_coding",
      gene_name : "AC011499.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180554.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5784832,
      stop : 5791225,
      direction : "-",
      ID : "ENSG00000141994.16",
      gene_id : "ENSG00000141994.16",
      gene_type : "protein_coding",
      gene_name : "DUS3L",
      gene_level : 2,
      hgnc_id : "HGNC:26920",
      havana_gene : "OTTHUMG00000162311.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5823802,
      stop : 5828324,
      direction : "+",
      ID : "ENSG00000171119.2",
      gene_id : "ENSG00000171119.2",
      gene_type : "protein_coding",
      gene_name : "NRTN",
      gene_level : 2,
      hgnc_id : "HGNC:8007",
      havana_gene : "OTTHUMG00000180555.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5830408,
      stop : 5839722,
      direction : "-",
      ID : "ENSG00000156413.15",
      gene_id : "ENSG00000156413.15",
      gene_type : "protein_coding",
      gene_name : "FUT6",
      gene_level : 2,
      hgnc_id : "HGNC:4017",
      havana_gene : "OTTHUMG00000167335.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5842888,
      stop : 5851474,
      direction : "-",
      ID : "ENSG00000171124.13",
      gene_id : "ENSG00000171124.13",
      gene_type : "protein_coding",
      gene_name : "FUT3",
      gene_level : 2,
      hgnc_id : "HGNC:4014",
      havana_gene : "OTTHUMG00000180614.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5865826,
      stop : 5870540,
      direction : "-",
      ID : "ENSG00000130383.7",
      gene_id : "ENSG00000130383.7",
      gene_type : "protein_coding",
      gene_name : "FUT5",
      gene_level : 2,
      hgnc_id : "HGNC:4016",
      havana_gene : "OTTHUMG00000180616.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5866171,
      stop : 5903787,
      direction : "-",
      ID : "ENSG00000267740.5",
      gene_id : "ENSG00000267740.5",
      gene_type : "protein_coding",
      gene_name : "AC024592.3",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180627.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5891276,
      stop : 5904006,
      direction : "-",
      ID : "ENSG00000174886.14",
      gene_id : "ENSG00000174886.14",
      gene_type : "protein_coding",
      gene_name : "NDUFA11",
      gene_level : 2,
      hgnc_id : "HGNC:20371",
      havana_gene : "OTTHUMG00000180617.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5904841,
      stop : 5914707,
      direction : "+",
      ID : "ENSG00000267314.1",
      gene_id : "ENSG00000267314.1",
      gene_type : "protein_coding",
      gene_name : "AC104532.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180629.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5904872,
      stop : 5910853,
      direction : "+",
      ID : "ENSG00000187650.4",
      gene_id : "ENSG00000187650.4",
      gene_type : "protein_coding",
      gene_name : "VMAC",
      gene_level : 2,
      hgnc_id : "HGNC:33803",
      havana_gene : "OTTHUMG00000180618.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5912339,
      stop : 5916211,
      direction : "+",
      ID : "ENSG00000105519.18",
      gene_id : "ENSG00000105519.18",
      gene_type : "protein_coding",
      gene_name : "CAPS",
      gene_level : 2,
      hgnc_id : "HGNC:1487",
      havana_gene : "OTTHUMG00000180619.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5916139,
      stop : 5978142,
      direction : "-",
      ID : "ENSG00000031823.14",
      gene_id : "ENSG00000031823.14",
      gene_type : "protein_coding",
      gene_name : "RANBP3",
      gene_level : 2,
      hgnc_id : "HGNC:9850",
      havana_gene : "OTTHUMG00000180636.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 5993164,
      stop : 6199572,
      direction : "-",
      ID : "ENSG00000087903.13",
      gene_id : "ENSG00000087903.13",
      gene_type : "protein_coding",
      gene_name : "RFX2",
      gene_level : 1,
      hgnc_id : "HGNC:9983",
      havana_gene : "OTTHUMG00000180711.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6135247,
      stop : 6193094,
      direction : "+",
      ID : "ENSG00000130377.14",
      gene_id : "ENSG00000130377.14",
      gene_type : "protein_coding",
      gene_name : "ACSBG2",
      gene_level : 2,
      hgnc_id : "HGNC:24174",
      havana_gene : "OTTHUMG00000180754.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6210381,
      stop : 6279975,
      direction : "-",
      ID : "ENSG00000130382.9",
      gene_id : "ENSG00000130382.9",
      gene_type : "protein_coding",
      gene_name : "MLLT1",
      gene_level : 2,
      hgnc_id : "HGNC:7134",
      havana_gene : "OTTHUMG00000180757.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6306142,
      stop : 6333612,
      direction : "-",
      ID : "ENSG00000167769.5",
      gene_id : "ENSG00000167769.5",
      gene_type : "protein_coding",
      gene_name : "ACER1",
      gene_level : 2,
      hgnc_id : "HGNC:18356",
      havana_gene : "OTTHUMG00000180777.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6361531,
      stop : 6370242,
      direction : "+",
      ID : "ENSG00000125656.11",
      gene_id : "ENSG00000125656.11",
      gene_type : "protein_coding",
      gene_name : "CLPP",
      gene_level : 1,
      hgnc_id : "HGNC:2084",
      havana_gene : "OTTHUMG00000180779.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6372794,
      stop : 6375250,
      direction : "+",
      ID : "ENSG00000125652.8",
      gene_id : "ENSG00000125652.8",
      gene_type : "protein_coding",
      gene_name : "ALKBH7",
      gene_level : 2,
      hgnc_id : "HGNC:21306",
      havana_gene : "OTTHUMG00000180792.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6375148,
      stop : 6379058,
      direction : "-",
      ID : "ENSG00000125650.4",
      gene_id : "ENSG00000125650.4",
      gene_type : "protein_coding",
      gene_name : "PSPN",
      gene_level : 2,
      hgnc_id : "HGNC:9579",
      havana_gene : "OTTHUMG00000168086.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6379572,
      stop : 6393981,
      direction : "-",
      ID : "ENSG00000125651.14",
      gene_id : "ENSG00000125651.14",
      gene_type : "protein_coding",
      gene_name : "GTF2F1",
      gene_level : 1,
      hgnc_id : "HGNC:4652",
      havana_gene : "OTTHUMG00000168087.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6413102,
      stop : 6424811,
      direction : "-",
      ID : "ENSG00000088247.18",
      gene_id : "ENSG00000088247.18",
      gene_type : "protein_coding",
      gene_name : "KHSRP",
      gene_level : 1,
      hgnc_id : "HGNC:6316",
      havana_gene : "OTTHUMG00000180850.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6426037,
      stop : 6433779,
      direction : "-",
      ID : "ENSG00000181240.14",
      gene_id : "ENSG00000181240.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A41",
      gene_level : 2,
      hgnc_id : "HGNC:28533",
      havana_gene : "OTTHUMG00000180851.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6436079,
      stop : 6465203,
      direction : "-",
      ID : "ENSG00000125648.15",
      gene_id : "ENSG00000125648.15",
      gene_type : "protein_coding",
      gene_name : "SLC25A23",
      gene_level : 1,
      hgnc_id : "HGNC:19375",
      havana_gene : "OTTHUMG00000180852.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6463777,
      stop : 6467221,
      direction : "+",
      ID : "ENSG00000130545.16",
      gene_id : "ENSG00000130545.16",
      gene_type : "protein_coding",
      gene_name : "CRB3",
      gene_level : 2,
      hgnc_id : "HGNC:20237",
      havana_gene : "OTTHUMG00000181828.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6467207,
      stop : 6482557,
      direction : "-",
      ID : "ENSG00000205744.10",
      gene_id : "ENSG00000205744.10",
      gene_type : "protein_coding",
      gene_name : "DENND1C",
      gene_level : 2,
      hgnc_id : "HGNC:26225",
      havana_gene : "OTTHUMG00000180853.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6494319,
      stop : 6502848,
      direction : "-",
      ID : "ENSG00000104833.12",
      gene_id : "ENSG00000104833.12",
      gene_type : "protein_coding",
      gene_name : "TUBB4A",
      gene_level : 1,
      hgnc_id : "HGNC:20774",
      havana_gene : "OTTHUMG00000181829.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6531026,
      stop : 6535924,
      direction : "+",
      ID : "ENSG00000125657.5",
      gene_id : "ENSG00000125657.5",
      gene_type : "protein_coding",
      gene_name : "TNFSF9",
      gene_level : 2,
      hgnc_id : "HGNC:11939",
      havana_gene : "OTTHUMG00000181831.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6583183,
      stop : 6604103,
      direction : "-",
      ID : "ENSG00000125726.11",
      gene_id : "ENSG00000125726.11",
      gene_type : "protein_coding",
      gene_name : "CD70",
      gene_level : 1,
      hgnc_id : "HGNC:11937",
      havana_gene : "OTTHUMG00000181834.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6661253,
      stop : 6670588,
      direction : "-",
      ID : "ENSG00000125735.11",
      gene_id : "ENSG00000125735.11",
      gene_type : "protein_coding",
      gene_name : "TNFSF14",
      gene_level : 2,
      hgnc_id : "HGNC:11930",
      havana_gene : "OTTHUMG00000181835.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6677704,
      stop : 6730562,
      direction : "-",
      ID : "ENSG00000125730.17",
      gene_id : "ENSG00000125730.17",
      gene_type : "protein_coding",
      gene_name : "C3",
      gene_level : 2,
      hgnc_id : "HGNC:1318",
      havana_gene : "OTTHUMG00000150335.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6729914,
      stop : 6737603,
      direction : "-",
      ID : "ENSG00000125734.15",
      gene_id : "ENSG00000125734.15",
      gene_type : "protein_coding",
      gene_name : "GPR108",
      gene_level : 1,
      hgnc_id : "HGNC:17829",
      havana_gene : "OTTHUMG00000170129.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6737925,
      stop : 6751530,
      direction : "+",
      ID : "ENSG00000125733.18",
      gene_id : "ENSG00000125733.18",
      gene_type : "protein_coding",
      gene_name : "TRIP10",
      gene_level : 1,
      hgnc_id : "HGNC:12304",
      havana_gene : "OTTHUMG00000150255.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6752160,
      stop : 6767463,
      direction : "-",
      ID : "ENSG00000125731.13",
      gene_id : "ENSG00000125731.13",
      gene_type : "protein_coding",
      gene_name : "SH2D3A",
      gene_level : 2,
      hgnc_id : "HGNC:16885",
      havana_gene : "OTTHUMG00000181868.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6772708,
      stop : 6857366,
      direction : "+",
      ID : "ENSG00000141968.8",
      gene_id : "ENSG00000141968.8",
      gene_type : "protein_coding",
      gene_name : "VAV1",
      gene_level : 2,
      hgnc_id : "HGNC:12657",
      havana_gene : "OTTHUMG00000181965.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 6887566,
      stop : 6940459,
      direction : "+",
      ID : "ENSG00000174837.15",
      gene_id : "ENSG00000174837.15",
      gene_type : "protein_coding",
      gene_name : "ADGRE1",
      gene_level : 1,
      hgnc_id : "HGNC:3336",
      havana_gene : "OTTHUMG00000181966.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7018969,
      stop : 7021432,
      direction : "-",
      ID : "ENSG00000196589.7",
      gene_id : "ENSG00000196589.7",
      gene_type : "protein_coding",
      gene_name : "MBD3L2B",
      gene_level : 2,
      hgnc_id : "HGNC:53435",
      havana_gene : "OTTHUMG00000181972.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7030578,
      stop : 7033011,
      direction : "+",
      ID : "ENSG00000237247.6",
      gene_id : "ENSG00000237247.6",
      gene_type : "protein_coding",
      gene_name : "MBD3L5",
      gene_level : 2,
      hgnc_id : "HGNC:37204",
      havana_gene : "OTTHUMG00000181973.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7037748,
      stop : 7040179,
      direction : "-",
      ID : "ENSG00000205718.9",
      gene_id : "ENSG00000205718.9",
      gene_type : "protein_coding",
      gene_name : "MBD3L4",
      gene_level : 2,
      hgnc_id : "HGNC:37206",
      havana_gene : "OTTHUMG00000181974.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7049321,
      stop : 7051735,
      direction : "+",
      ID : "ENSG00000230522.5",
      gene_id : "ENSG00000230522.5",
      gene_type : "protein_coding",
      gene_name : "MBD3L2",
      gene_level : 2,
      hgnc_id : "HGNC:18532",
      havana_gene : "OTTHUMG00000181975.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7056209,
      stop : 7058640,
      direction : "-",
      ID : "ENSG00000182315.9",
      gene_id : "ENSG00000182315.9",
      gene_type : "protein_coding",
      gene_name : "MBD3L3",
      gene_level : 2,
      hgnc_id : "HGNC:37205",
      havana_gene : "OTTHUMG00000181976.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7069703,
      stop : 7087968,
      direction : "+",
      ID : "ENSG00000130544.12",
      gene_id : "ENSG00000130544.12",
      gene_type : "protein_coding",
      gene_name : "ZNF557",
      gene_level : 2,
      hgnc_id : "HGNC:28632",
      havana_gene : "OTTHUMG00000181977.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7112255,
      stop : 7294414,
      direction : "-",
      ID : "ENSG00000171105.14",
      gene_id : "ENSG00000171105.14",
      gene_type : "protein_coding",
      gene_name : "INSR",
      gene_level : 1,
      hgnc_id : "HGNC:6091",
      havana_gene : "OTTHUMG00000181992.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7348937,
      stop : 7472485,
      direction : "+",
      ID : "ENSG00000104880.19",
      gene_id : "ENSG00000104880.19",
      gene_type : "protein_coding",
      gene_name : "ARHGEF18",
      gene_level : 2,
      hgnc_id : "HGNC:17090",
      havana_gene : "OTTHUMG00000177342.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7476875,
      stop : 7497449,
      direction : "-",
      ID : "ENSG00000104883.8",
      gene_id : "ENSG00000104883.8",
      gene_type : "protein_coding",
      gene_name : "PEX11G",
      gene_level : 2,
      hgnc_id : "HGNC:20208",
      havana_gene : "OTTHUMG00000182044.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7492976,
      stop : 7508450,
      direction : "+",
      ID : "ENSG00000198723.11",
      gene_id : "ENSG00000198723.11",
      gene_type : "protein_coding",
      gene_name : "TEX45",
      gene_level : 2,
      hgnc_id : "HGNC:24745",
      havana_gene : "OTTHUMG00000157183.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7507052,
      stop : 7519622,
      direction : "+",
      ID : "ENSG00000267952.1",
      gene_id : "ENSG00000267952.1",
      gene_type : "protein_coding",
      gene_name : "AC008878.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000150187.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7515292,
      stop : 7521025,
      direction : "+",
      ID : "ENSG00000198816.7",
      gene_id : "ENSG00000198816.7",
      gene_type : "protein_coding",
      gene_name : "ZNF358",
      gene_level : 2,
      hgnc_id : "HGNC:16838",
      havana_gene : "OTTHUMG00000182582.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7522624,
      stop : 7534009,
      direction : "+",
      ID : "ENSG00000090674.16",
      gene_id : "ENSG00000090674.16",
      gene_type : "protein_coding",
      gene_name : "MCOLN1",
      gene_level : 2,
      hgnc_id : "HGNC:13356",
      havana_gene : "OTTHUMG00000182046.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7533595,
      stop : 7540059,
      direction : "+",
      ID : "ENSG00000268614.1",
      gene_id : "ENSG00000268614.1",
      gene_type : "protein_coding",
      gene_name : "AC008878.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182093.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7534004,
      stop : 7561764,
      direction : "+",
      ID : "ENSG00000032444.17",
      gene_id : "ENSG00000032444.17",
      gene_type : "protein_coding",
      gene_name : "PNPLA6",
      gene_level : 1,
      hgnc_id : "HGNC:16268",
      havana_gene : "OTTHUMG00000182094.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7595863,
      stop : 7618304,
      direction : "+",
      ID : "ENSG00000076826.10",
      gene_id : "ENSG00000076826.10",
      gene_type : "protein_coding",
      gene_name : "CAMSAP3",
      gene_level : 2,
      hgnc_id : "HGNC:29307",
      havana_gene : "OTTHUMG00000182096.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7619525,
      stop : 7629545,
      direction : "-",
      ID : "ENSG00000076924.12",
      gene_id : "ENSG00000076924.12",
      gene_type : "protein_coding",
      gene_name : "XAB2",
      gene_level : 2,
      hgnc_id : "HGNC:14089",
      havana_gene : "OTTHUMG00000182404.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7629793,
      stop : 7631956,
      direction : "+",
      ID : "ENSG00000229833.10",
      gene_id : "ENSG00000229833.10",
      gene_type : "protein_coding",
      gene_name : "PET100",
      gene_level : 2,
      hgnc_id : "HGNC:40038",
      havana_gene : "OTTHUMG00000182394.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7629796,
      stop : 7643048,
      direction : "+",
      ID : "ENSG00000268400.5",
      gene_id : "ENSG00000268400.5",
      gene_type : "protein_coding",
      gene_name : "AC008763.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182395.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7631611,
      stop : 7633719,
      direction : "-",
      ID : "ENSG00000174788.10",
      gene_id : "ENSG00000174788.10",
      gene_type : "protein_coding",
      gene_name : "PCP2",
      gene_level : 2,
      hgnc_id : "HGNC:30209",
      havana_gene : "OTTHUMG00000182405.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7636881,
      stop : 7647873,
      direction : "+",
      ID : "ENSG00000076944.16",
      gene_id : "ENSG00000076944.16",
      gene_type : "protein_coding",
      gene_name : "STXBP2",
      gene_level : 1,
      hgnc_id : "HGNC:11445",
      havana_gene : "OTTHUMG00000182396.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7669049,
      stop : 7670455,
      direction : "+",
      ID : "ENSG00000104918.8",
      gene_id : "ENSG00000104918.8",
      gene_type : "protein_coding",
      gene_name : "RETN",
      gene_level : 2,
      hgnc_id : "HGNC:20389",
      havana_gene : "OTTHUMG00000182503.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7676628,
      stop : 7679826,
      direction : "+",
      ID : "ENSG00000183019.7",
      gene_id : "ENSG00000183019.7",
      gene_type : "protein_coding",
      gene_name : "MCEMP1",
      gene_level : 1,
      hgnc_id : "HGNC:27291",
      havana_gene : "OTTHUMG00000182440.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7678501,
      stop : 7682854,
      direction : "+",
      ID : "ENSG00000269711.1",
      gene_id : "ENSG00000269711.1",
      gene_type : "protein_coding",
      gene_name : "AC008763.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182441.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7680833,
      stop : 7687703,
      direction : "+",
      ID : "ENSG00000181029.9",
      gene_id : "ENSG00000181029.9",
      gene_type : "protein_coding",
      gene_name : "TRAPPC5",
      gene_level : 2,
      hgnc_id : "HGNC:23067",
      havana_gene : "OTTHUMG00000182589.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7688758,
      stop : 7702146,
      direction : "-",
      ID : "ENSG00000104921.15",
      gene_id : "ENSG00000104921.15",
      gene_type : "protein_coding",
      gene_name : "FCER2",
      gene_level : 2,
      hgnc_id : "HGNC:3612",
      havana_gene : "OTTHUMG00000182517.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7728958,
      stop : 7733906,
      direction : "-",
      ID : "ENSG00000182566.14",
      gene_id : "ENSG00000182566.14",
      gene_type : "protein_coding",
      gene_name : "CLEC4G",
      gene_level : 2,
      hgnc_id : "HGNC:24591",
      havana_gene : "OTTHUMG00000182519.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7728958,
      stop : 7745662,
      direction : "-",
      ID : "ENSG00000288669.1",
      gene_id : "ENSG00000288669.1",
      gene_type : "protein_coding",
      gene_name : "AC008763.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7739993,
      stop : 7747564,
      direction : "-",
      ID : "ENSG00000090659.18",
      gene_id : "ENSG00000090659.18",
      gene_type : "protein_coding",
      gene_name : "CD209",
      gene_level : 1,
      hgnc_id : "HGNC:1641",
      havana_gene : "OTTHUMG00000182530.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7763210,
      stop : 7769605,
      direction : "+",
      ID : "ENSG00000104938.18",
      gene_id : "ENSG00000104938.18",
      gene_type : "protein_coding",
      gene_name : "CLEC4M",
      gene_level : 2,
      hgnc_id : "HGNC:13523",
      havana_gene : "OTTHUMG00000182432.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7830233,
      stop : 7864976,
      direction : "+",
      ID : "ENSG00000142459.8",
      gene_id : "ENSG00000142459.8",
      gene_type : "protein_coding",
      gene_name : "EVI5L",
      gene_level : 2,
      hgnc_id : "HGNC:30464",
      havana_gene : "OTTHUMG00000182454.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7868719,
      stop : 7874390,
      direction : "-",
      ID : "ENSG00000183248.12",
      gene_id : "ENSG00000183248.12",
      gene_type : "protein_coding",
      gene_name : "PRR36",
      gene_level : 2,
      hgnc_id : "HGNC:26172",
      havana_gene : "OTTHUMG00000182504.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7888505,
      stop : 7902021,
      direction : "+",
      ID : "ENSG00000171017.11",
      gene_id : "ENSG00000171017.11",
      gene_type : "protein_coding",
      gene_name : "LRRC8E",
      gene_level : 2,
      hgnc_id : "HGNC:26272",
      havana_gene : "OTTHUMG00000182455.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7903843,
      stop : 7914478,
      direction : "+",
      ID : "ENSG00000076984.18",
      gene_id : "ENSG00000076984.18",
      gene_type : "protein_coding",
      gene_name : "MAP2K7",
      gene_level : 2,
      hgnc_id : "HGNC:6847",
      havana_gene : "OTTHUMG00000137368.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7914830,
      stop : 7919097,
      direction : "+",
      ID : "ENSG00000260001.7",
      gene_id : "ENSG00000260001.7",
      gene_type : "protein_coding",
      gene_name : "TGFBR3L",
      gene_level : 2,
      hgnc_id : "HGNC:44152",
      havana_gene : "OTTHUMG00000175717.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7920338,
      stop : 7923250,
      direction : "+",
      ID : "ENSG00000104976.12",
      gene_id : "ENSG00000104976.12",
      gene_type : "protein_coding",
      gene_name : "SNAPC2",
      gene_level : 2,
      hgnc_id : "HGNC:11135",
      havana_gene : "OTTHUMG00000182456.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7924491,
      stop : 7926135,
      direction : "-",
      ID : "ENSG00000178531.6",
      gene_id : "ENSG00000178531.6",
      gene_type : "protein_coding",
      gene_name : "CTXN1",
      gene_level : 2,
      hgnc_id : "HGNC:31108",
      havana_gene : "OTTHUMG00000182480.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7926718,
      stop : 7943667,
      direction : "-",
      ID : "ENSG00000104980.8",
      gene_id : "ENSG00000104980.8",
      gene_type : "protein_coding",
      gene_name : "TIMM44",
      gene_level : 2,
      hgnc_id : "HGNC:17316",
      havana_gene : "OTTHUMG00000182478.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 7958573,
      stop : 8005659,
      direction : "-",
      ID : "ENSG00000066044.15",
      gene_id : "ENSG00000066044.15",
      gene_type : "protein_coding",
      gene_name : "ELAVL1",
      gene_level : 1,
      hgnc_id : "HGNC:3312",
      havana_gene : "OTTHUMG00000182470.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8052318,
      stop : 8062660,
      direction : "+",
      ID : "ENSG00000131142.14",
      gene_id : "ENSG00000131142.14",
      gene_type : "protein_coding",
      gene_name : "CCL25",
      gene_level : 2,
      hgnc_id : "HGNC:10624",
      havana_gene : "OTTHUMG00000141287.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8065402,
      stop : 8149592,
      direction : "-",
      ID : "ENSG00000142449.13",
      gene_id : "ENSG00000142449.13",
      gene_type : "protein_coding",
      gene_name : "FBN3",
      gene_level : 1,
      hgnc_id : "HGNC:18794",
      havana_gene : "OTTHUMG00000182462.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8206736,
      stop : 8262421,
      direction : "+",
      ID : "ENSG00000090661.12",
      gene_id : "ENSG00000090661.12",
      gene_type : "protein_coding",
      gene_name : "CERS4",
      gene_level : 1,
      hgnc_id : "HGNC:23747",
      havana_gene : "OTTHUMG00000172570.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8302127,
      stop : 8308358,
      direction : "-",
      ID : "ENSG00000167775.11",
      gene_id : "ENSG00000167775.11",
      gene_type : "protein_coding",
      gene_name : "CD320",
      gene_level : 2,
      hgnc_id : "HGNC:16692",
      havana_gene : "OTTHUMG00000182457.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8308283,
      stop : 8321379,
      direction : "-",
      ID : "ENSG00000167774.2",
      gene_id : "ENSG00000167774.2",
      gene_type : "protein_coding",
      gene_name : "AC010323.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182458.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8308768,
      stop : 8321375,
      direction : "-",
      ID : "ENSG00000267855.6",
      gene_id : "ENSG00000267855.6",
      gene_type : "protein_coding",
      gene_name : "NDUFA7",
      gene_level : 2,
      hgnc_id : "HGNC:7691",
      havana_gene : "OTTHUMG00000182459.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8321158,
      stop : 8323340,
      direction : "+",
      ID : "ENSG00000233927.5",
      gene_id : "ENSG00000233927.5",
      gene_type : "protein_coding",
      gene_name : "RPS28",
      gene_level : 2,
      hgnc_id : "HGNC:10418",
      havana_gene : "OTTHUMG00000182460.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8322584,
      stop : 8343262,
      direction : "-",
      ID : "ENSG00000186994.11",
      gene_id : "ENSG00000186994.11",
      gene_type : "protein_coding",
      gene_name : "KANK3",
      gene_level : 2,
      hgnc_id : "HGNC:24796",
      havana_gene : "OTTHUMG00000182461.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8363289,
      stop : 8374370,
      direction : "+",
      ID : "ENSG00000167772.12",
      gene_id : "ENSG00000167772.12",
      gene_type : "protein_coding",
      gene_name : "ANGPTL4",
      gene_level : 2,
      hgnc_id : "HGNC:16039",
      havana_gene : "OTTHUMG00000182273.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8389981,
      stop : 8404434,
      direction : "+",
      ID : "ENSG00000185236.12",
      gene_id : "ENSG00000185236.12",
      gene_type : "protein_coding",
      gene_name : "RAB11B",
      gene_level : 1,
      hgnc_id : "HGNC:9761",
      havana_gene : "OTTHUMG00000182278.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8413270,
      stop : 8439017,
      direction : "+",
      ID : "ENSG00000099785.11",
      gene_id : "ENSG00000099785.11",
      gene_type : "protein_coding",
      gene_name : "MARCHF2",
      gene_level : 2,
      hgnc_id : "HGNC:28038",
      havana_gene : "OTTHUMG00000182282.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8444767,
      stop : 8489114,
      direction : "+",
      ID : "ENSG00000099783.12",
      gene_id : "ENSG00000099783.12",
      gene_type : "protein_coding",
      gene_name : "HNRNPM",
      gene_level : 1,
      hgnc_id : "HGNC:5046",
      havana_gene : "OTTHUMG00000182383.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8490056,
      stop : 8502640,
      direction : "-",
      ID : "ENSG00000133246.12",
      gene_id : "ENSG00000133246.12",
      gene_type : "protein_coding",
      gene_name : "PRAM1",
      gene_level : 2,
      hgnc_id : "HGNC:30091",
      havana_gene : "OTTHUMG00000167924.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8509678,
      stop : 8514167,
      direction : "-",
      ID : "ENSG00000133250.14",
      gene_id : "ENSG00000133250.14",
      gene_type : "protein_coding",
      gene_name : "ZNF414",
      gene_level : 2,
      hgnc_id : "HGNC:20630",
      havana_gene : "OTTHUMG00000182240.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8520778,
      stop : 8577577,
      direction : "-",
      ID : "ENSG00000142347.19",
      gene_id : "ENSG00000142347.19",
      gene_type : "protein_coding",
      gene_name : "MYO1F",
      gene_level : 2,
      hgnc_id : "HGNC:7600",
      havana_gene : "OTTHUMG00000156005.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8580240,
      stop : 8610735,
      direction : "-",
      ID : "ENSG00000142303.14",
      gene_id : "ENSG00000142303.14",
      gene_type : "protein_coding",
      gene_name : "ADAMTS10",
      gene_level : 1,
      hgnc_id : "HGNC:13201",
      havana_gene : "OTTHUMG00000182216.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8630635,
      stop : 8677708,
      direction : "+",
      ID : "ENSG00000268480.3",
      gene_id : "ENSG00000268480.3",
      gene_type : "protein_coding",
      gene_name : "NFILZ",
      gene_level : 2,
      hgnc_id : "HGNC:52681",
      havana_gene : "OTTHUMG00000182192.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8697400,
      stop : 8698795,
      direction : "-",
      ID : "ENSG00000181786.5",
      gene_id : "ENSG00000181786.5",
      gene_type : "protein_coding",
      gene_name : "ACTL9",
      gene_level : 2,
      hgnc_id : "HGNC:28494",
      havana_gene : "OTTHUMG00000182194.3",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8721634,
      stop : 8732160,
      direction : "+",
      ID : "ENSG00000181733.4",
      gene_id : "ENSG00000181733.4",
      gene_type : "protein_coding",
      gene_name : "OR2Z1",
      gene_level : 2,
      hgnc_id : "HGNC:15391",
      havana_gene : "OTTHUMG00000182195.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8806170,
      stop : 8832314,
      direction : "-",
      ID : "ENSG00000167785.9",
      gene_id : "ENSG00000167785.9",
      gene_type : "protein_coding",
      gene_name : "ZNF558",
      gene_level : 2,
      hgnc_id : "HGNC:26422",
      havana_gene : "OTTHUMG00000182196.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8832398,
      stop : 8843340,
      direction : "+",
      ID : "ENSG00000170948.3",
      gene_id : "ENSG00000170948.3",
      gene_type : "protein_coding",
      gene_name : "MBD3L1",
      gene_level : 2,
      hgnc_id : "HGNC:15774",
      havana_gene : "OTTHUMG00000182198.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 8848844,
      stop : 8981342,
      direction : "-",
      ID : "ENSG00000181143.15",
      gene_id : "ENSG00000181143.15",
      gene_type : "protein_coding",
      gene_name : "MUC16",
      gene_level : 2,
      hgnc_id : "HGNC:15582",
      havana_gene : "OTTHUMG00000169191.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9087061,
      stop : 9095669,
      direction : "+",
      ID : "ENSG00000170929.6",
      gene_id : "ENSG00000170929.6",
      gene_type : "protein_coding",
      gene_name : "OR1M1",
      gene_level : 2,
      hgnc_id : "HGNC:8220",
      havana_gene : "OTTHUMG00000179930.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9100407,
      stop : 9107475,
      direction : "-",
      ID : "ENSG00000170923.3",
      gene_id : "ENSG00000170923.3",
      gene_type : "protein_coding",
      gene_name : "OR7G2",
      gene_level : 2,
      hgnc_id : "HGNC:8466",
      havana_gene : "OTTHUMG00000179931.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9114828,
      stop : 9115763,
      direction : "-",
      ID : "ENSG00000161807.3",
      gene_id : "ENSG00000161807.3",
      gene_type : "protein_coding",
      gene_name : "OR7G1",
      gene_level : 2,
      hgnc_id : "HGNC:8465",
      havana_gene : "OTTHUMG00000168067.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9126012,
      stop : 9126950,
      direction : "-",
      ID : "ENSG00000170920.2",
      gene_id : "ENSG00000170920.2",
      gene_type : "protein_coding",
      gene_name : "OR7G3",
      gene_level : 2,
      hgnc_id : "HGNC:8467",
      havana_gene : "OTTHUMG00000165520.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9140397,
      stop : 9163424,
      direction : "+",
      ID : "ENSG00000130803.15",
      gene_id : "ENSG00000130803.15",
      gene_type : "protein_coding",
      gene_name : "ZNF317",
      gene_level : 2,
      hgnc_id : "HGNC:13507",
      havana_gene : "OTTHUMG00000179932.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9178979,
      stop : 9188818,
      direction : "+",
      ID : "ENSG00000188000.6",
      gene_id : "ENSG00000188000.6",
      gene_type : "protein_coding",
      gene_name : "OR7D2",
      gene_level : 2,
      hgnc_id : "HGNC:8378",
      havana_gene : "OTTHUMG00000179934.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9210276,
      stop : 9219589,
      direction : "-",
      ID : "ENSG00000174667.4",
      gene_id : "ENSG00000174667.4",
      gene_type : "protein_coding",
      gene_name : "OR7D4",
      gene_level : 2,
      hgnc_id : "HGNC:8380",
      havana_gene : "OTTHUMG00000179936.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9247344,
      stop : 9252625,
      direction : "+",
      ID : "ENSG00000237521.4",
      gene_id : "ENSG00000237521.4",
      gene_type : "protein_coding",
      gene_name : "OR7E24",
      gene_level : 2,
      hgnc_id : "HGNC:8396",
      havana_gene : "OTTHUMG00000179938.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9291140,
      stop : 9309838,
      direction : "-",
      ID : "ENSG00000196110.8",
      gene_id : "ENSG00000196110.8",
      gene_type : "protein_coding",
      gene_name : "ZNF699",
      gene_level : 2,
      hgnc_id : "HGNC:24750",
      havana_gene : "OTTHUMG00000179941.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9323772,
      stop : 9351162,
      direction : "+",
      ID : "ENSG00000188321.14",
      gene_id : "ENSG00000188321.14",
      gene_type : "protein_coding",
      gene_name : "ZNF559",
      gene_level : 1,
      hgnc_id : "HGNC:28197",
      havana_gene : "OTTHUMG00000179942.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9324174,
      stop : 9382617,
      direction : "+",
      ID : "ENSG00000270011.7",
      gene_id : "ENSG00000270011.7",
      gene_type : "protein_coding",
      gene_name : "ZNF559-ZNF177",
      gene_level : 2,
      hgnc_id : "HGNC:42964",
      havana_gene : "OTTHUMG00000183958.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9363020,
      stop : 9382617,
      direction : "+",
      ID : "ENSG00000188629.13",
      gene_id : "ENSG00000188629.13",
      gene_type : "protein_coding",
      gene_name : "ZNF177",
      gene_level : 1,
      hgnc_id : "HGNC:12966",
      havana_gene : "OTTHUMG00000179943.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9412461,
      stop : 9435571,
      direction : "-",
      ID : "ENSG00000174652.19",
      gene_id : "ENSG00000174652.19",
      gene_type : "protein_coding",
      gene_name : "ZNF266",
      gene_level : 2,
      hgnc_id : "HGNC:13059",
      havana_gene : "OTTHUMG00000179945.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9466355,
      stop : 9498616,
      direction : "-",
      ID : "ENSG00000198028.4",
      gene_id : "ENSG00000198028.4",
      gene_type : "protein_coding",
      gene_name : "ZNF560",
      gene_level : 2,
      hgnc_id : "HGNC:26484",
      havana_gene : "OTTHUMG00000180130.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9523223,
      stop : 9538645,
      direction : "-",
      ID : "ENSG00000130818.12",
      gene_id : "ENSG00000130818.12",
      gene_type : "protein_coding",
      gene_name : "ZNF426",
      gene_level : 1,
      hgnc_id : "HGNC:20725",
      havana_gene : "OTTHUMG00000180132.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9560329,
      stop : 9584504,
      direction : "-",
      ID : "ENSG00000197961.12",
      gene_id : "ENSG00000197961.12",
      gene_type : "protein_coding",
      gene_name : "ZNF121",
      gene_level : 2,
      hgnc_id : "HGNC:12904",
      havana_gene : "OTTHUMG00000180134.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9604680,
      stop : 9621236,
      direction : "-",
      ID : "ENSG00000171469.11",
      gene_id : "ENSG00000171469.11",
      gene_type : "protein_coding",
      gene_name : "ZNF561",
      gene_level : 1,
      hgnc_id : "HGNC:28684",
      havana_gene : "OTTHUMG00000157054.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9641807,
      stop : 9675100,
      direction : "-",
      ID : "ENSG00000171466.10",
      gene_id : "ENSG00000171466.10",
      gene_type : "protein_coding",
      gene_name : "ZNF562",
      gene_level : 1,
      hgnc_id : "HGNC:25950",
      havana_gene : "OTTHUMG00000180205.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9751993,
      stop : 9793180,
      direction : "-",
      ID : "ENSG00000196605.7",
      gene_id : "ENSG00000196605.7",
      gene_type : "protein_coding",
      gene_name : "ZNF846",
      gene_level : 1,
      hgnc_id : "HGNC:27260",
      havana_gene : "OTTHUMG00000180208.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9810267,
      stop : 9827816,
      direction : "-",
      ID : "ENSG00000127452.9",
      gene_id : "ENSG00000127452.9",
      gene_type : "protein_coding",
      gene_name : "FBXL12",
      gene_level : 1,
      hgnc_id : "HGNC:13611",
      havana_gene : "OTTHUMG00000180212.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9827892,
      stop : 9830115,
      direction : "+",
      ID : "ENSG00000198258.11",
      gene_id : "ENSG00000198258.11",
      gene_type : "protein_coding",
      gene_name : "UBL5",
      gene_level : 2,
      hgnc_id : "HGNC:13736",
      havana_gene : "OTTHUMG00000180214.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9835257,
      stop : 9849689,
      direction : "+",
      ID : "ENSG00000127445.14",
      gene_id : "ENSG00000127445.14",
      gene_type : "protein_coding",
      gene_name : "PIN1",
      gene_level : 2,
      hgnc_id : "HGNC:8988",
      havana_gene : "OTTHUMG00000180388.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9853718,
      stop : 9936552,
      direction : "-",
      ID : "ENSG00000105088.8",
      gene_id : "ENSG00000105088.8",
      gene_type : "protein_coding",
      gene_name : "OLFM2",
      gene_level : 2,
      hgnc_id : "HGNC:17189",
      havana_gene : "OTTHUMG00000180390.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 9959561,
      stop : 10010504,
      direction : "-",
      ID : "ENSG00000080573.7",
      gene_id : "ENSG00000080573.7",
      gene_type : "protein_coding",
      gene_name : "COL5A3",
      gene_level : 2,
      hgnc_id : "HGNC:14864",
      havana_gene : "OTTHUMG00000150019.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10013249,
      stop : 10022279,
      direction : "+",
      ID : "ENSG00000080511.5",
      gene_id : "ENSG00000080511.5",
      gene_type : "protein_coding",
      gene_name : "RDH8",
      gene_level : 2,
      hgnc_id : "HGNC:14423",
      havana_gene : "OTTHUMG00000180392.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10086122,
      stop : 10093252,
      direction : "+",
      ID : "ENSG00000130813.18",
      gene_id : "ENSG00000130813.18",
      gene_type : "protein_coding",
      gene_name : "SHFL",
      gene_level : 2,
      hgnc_id : "HGNC:25649",
      havana_gene : "OTTHUMG00000180393.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10092338,
      stop : 10102796,
      direction : "-",
      ID : "ENSG00000130812.10",
      gene_id : "ENSG00000130812.10",
      gene_type : "protein_coding",
      gene_name : "ANGPTL6",
      gene_level : 2,
      hgnc_id : "HGNC:23140",
      havana_gene : "OTTHUMG00000180395.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10106223,
      stop : 10114780,
      direction : "+",
      ID : "ENSG00000243207.6",
      gene_id : "ENSG00000243207.6",
      gene_type : "protein_coding",
      gene_name : "PPAN-P2RY11",
      gene_level : 1,
      hgnc_id : "HGNC:33526",
      havana_gene : "OTTHUMG00000150165.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10106362,
      stop : 10112012,
      direction : "+",
      ID : "ENSG00000130810.20",
      gene_id : "ENSG00000130810.20",
      gene_type : "protein_coding",
      gene_name : "PPAN",
      gene_level : 2,
      hgnc_id : "HGNC:9227",
      havana_gene : "OTTHUMG00000156826.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10111693,
      stop : 10115372,
      direction : "+",
      ID : "ENSG00000244165.2",
      gene_id : "ENSG00000244165.2",
      gene_type : "protein_coding",
      gene_name : "P2RY11",
      gene_level : 2,
      hgnc_id : "HGNC:8540",
      havana_gene : "OTTHUMG00000150166.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10115014,
      stop : 10119918,
      direction : "-",
      ID : "ENSG00000130811.12",
      gene_id : "ENSG00000130811.12",
      gene_type : "protein_coding",
      gene_name : "EIF3G",
      gene_level : 1,
      hgnc_id : "HGNC:3274",
      havana_gene : "OTTHUMG00000180396.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10133342,
      stop : 10231286,
      direction : "-",
      ID : "ENSG00000130816.17",
      gene_id : "ENSG00000130816.17",
      gene_type : "protein_coding",
      gene_name : "DNMT1",
      gene_level : 1,
      hgnc_id : "HGNC:2976",
      havana_gene : "OTTHUMG00000180397.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10221433,
      stop : 10231331,
      direction : "-",
      ID : "ENSG00000267534.4",
      gene_id : "ENSG00000267534.4",
      gene_type : "protein_coding",
      gene_name : "S1PR2",
      gene_level : 2,
      hgnc_id : "HGNC:3169",
      havana_gene : "OTTHUMG00000180399.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10251901,
      stop : 10260055,
      direction : "+",
      ID : "ENSG00000105364.14",
      gene_id : "ENSG00000105364.14",
      gene_type : "protein_coding",
      gene_name : "MRPL4",
      gene_level : 2,
      hgnc_id : "HGNC:14276",
      havana_gene : "OTTHUMG00000180400.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10271093,
      stop : 10286615,
      direction : "+",
      ID : "ENSG00000090339.9",
      gene_id : "ENSG00000090339.9",
      gene_type : "protein_coding",
      gene_name : "ICAM1",
      gene_level : 2,
      hgnc_id : "HGNC:5344",
      havana_gene : "OTTHUMG00000180403.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10286955,
      stop : 10288522,
      direction : "+",
      ID : "ENSG00000105371.10",
      gene_id : "ENSG00000105371.10",
      gene_type : "protein_coding",
      gene_name : "ICAM4",
      gene_level : 2,
      hgnc_id : "HGNC:5347",
      havana_gene : "OTTHUMG00000180405.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10289952,
      stop : 10296778,
      direction : "+",
      ID : "ENSG00000105376.5",
      gene_id : "ENSG00000105376.5",
      gene_type : "protein_coding",
      gene_name : "ICAM5",
      gene_level : 2,
      hgnc_id : "HGNC:5348",
      havana_gene : "OTTHUMG00000180406.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10304803,
      stop : 10309880,
      direction : "-",
      ID : "ENSG00000220201.7",
      gene_id : "ENSG00000220201.7",
      gene_type : "protein_coding",
      gene_name : "ZGLP1",
      gene_level : 2,
      hgnc_id : "HGNC:37245",
      havana_gene : "OTTHUMG00000152114.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10305427,
      stop : 10316009,
      direction : "-",
      ID : "ENSG00000167807.15",
      gene_id : "ENSG00000167807.15",
      gene_type : "protein_coding",
      gene_name : "AC011511.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180407.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10310045,
      stop : 10316015,
      direction : "-",
      ID : "ENSG00000267673.6",
      gene_id : "ENSG00000267673.6",
      gene_type : "protein_coding",
      gene_name : "FDX2",
      gene_level : 2,
      hgnc_id : "HGNC:30546",
      havana_gene : "OTTHUMG00000141299.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10315471,
      stop : 10320678,
      direction : "-",
      ID : "ENSG00000267303.1",
      gene_id : "ENSG00000267303.1",
      gene_type : "protein_coding",
      gene_name : "AC011511.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180408.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10316212,
      stop : 10333638,
      direction : "-",
      ID : "ENSG00000161847.14",
      gene_id : "ENSG00000161847.14",
      gene_type : "protein_coding",
      gene_name : "RAVER1",
      gene_level : 2,
      hgnc_id : "HGNC:30296",
      havana_gene : "OTTHUMG00000180409.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10333776,
      stop : 10339661,
      direction : "-",
      ID : "ENSG00000076662.10",
      gene_id : "ENSG00000076662.10",
      gene_type : "protein_coding",
      gene_name : "ICAM3",
      gene_level : 1,
      hgnc_id : "HGNC:5346",
      havana_gene : "OTTHUMG00000180410.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10350529,
      stop : 10380572,
      direction : "-",
      ID : "ENSG00000105397.14",
      gene_id : "ENSG00000105397.14",
      gene_type : "protein_coding",
      gene_name : "TYK2",
      gene_level : 1,
      hgnc_id : "HGNC:12440",
      havana_gene : "OTTHUMG00000166373.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10391133,
      stop : 10420121,
      direction : "-",
      ID : "ENSG00000105401.9",
      gene_id : "ENSG00000105401.9",
      gene_type : "protein_coding",
      gene_name : "CDC37",
      gene_level : 1,
      hgnc_id : "HGNC:1735",
      havana_gene : "OTTHUMG00000180578.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10416773,
      stop : 10469630,
      direction : "+",
      ID : "ENSG00000065989.16",
      gene_id : "ENSG00000065989.16",
      gene_type : "protein_coding",
      gene_name : "PDE4A",
      gene_level : 1,
      hgnc_id : "HGNC:8780",
      havana_gene : "OTTHUMG00000180411.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10486125,
      stop : 10503558,
      direction : "-",
      ID : "ENSG00000079999.14",
      gene_id : "ENSG00000079999.14",
      gene_type : "protein_coding",
      gene_name : "KEAP1",
      gene_level : 1,
      hgnc_id : "HGNC:23177",
      havana_gene : "OTTHUMG00000180579.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10512742,
      stop : 10517931,
      direction : "-",
      ID : "ENSG00000180739.14",
      gene_id : "ENSG00000180739.14",
      gene_type : "protein_coding",
      gene_name : "S1PR5",
      gene_level : 1,
      hgnc_id : "HGNC:14299",
      havana_gene : "OTTHUMG00000180581.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10543895,
      stop : 10553418,
      direction : "+",
      ID : "ENSG00000130734.10",
      gene_id : "ENSG00000130734.10",
      gene_type : "protein_coding",
      gene_name : "ATG4D",
      gene_level : 1,
      hgnc_id : "HGNC:20789",
      havana_gene : "OTTHUMG00000180582.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10553085,
      stop : 10566031,
      direction : "-",
      ID : "ENSG00000129347.21",
      gene_id : "ENSG00000129347.21",
      gene_type : "protein_coding",
      gene_name : "KRI1",
      gene_level : 2,
      hgnc_id : "HGNC:25769",
      havana_gene : "OTTHUMG00000150343.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10566460,
      stop : 10569059,
      direction : "-",
      ID : "ENSG00000129355.7",
      gene_id : "ENSG00000129355.7",
      gene_type : "protein_coding",
      gene_name : "CDKN2D",
      gene_level : 2,
      hgnc_id : "HGNC:1790",
      havana_gene : "OTTHUMG00000180583.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10572671,
      stop : 10587315,
      direction : "-",
      ID : "ENSG00000129354.12",
      gene_id : "ENSG00000129354.12",
      gene_type : "protein_coding",
      gene_name : "AP1M2",
      gene_level : 1,
      hgnc_id : "HGNC:558",
      havana_gene : "OTTHUMG00000180584.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10602457,
      stop : 10644557,
      direction : "+",
      ID : "ENSG00000129353.15",
      gene_id : "ENSG00000129353.15",
      gene_type : "protein_coding",
      gene_name : "SLC44A2",
      gene_level : 1,
      hgnc_id : "HGNC:17292",
      havana_gene : "OTTHUMG00000180585.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10654261,
      stop : 10692417,
      direction : "+",
      ID : "ENSG00000129351.17",
      gene_id : "ENSG00000129351.17",
      gene_type : "protein_coding",
      gene_name : "ILF3",
      gene_level : 2,
      hgnc_id : "HGNC:6038",
      havana_gene : "OTTHUMG00000180587.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10701430,
      stop : 10713437,
      direction : "+",
      ID : "ENSG00000213339.9",
      gene_id : "ENSG00000213339.9",
      gene_type : "protein_coding",
      gene_name : "QTRT1",
      gene_level : 2,
      hgnc_id : "HGNC:23797",
      havana_gene : "OTTHUMG00000180588.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10718079,
      stop : 10833488,
      direction : "+",
      ID : "ENSG00000079805.18",
      gene_id : "ENSG00000079805.18",
      gene_type : "protein_coding",
      gene_name : "DNM2",
      gene_level : 2,
      hgnc_id : "HGNC:2974",
      havana_gene : "OTTHUMG00000180694.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10832067,
      stop : 10836318,
      direction : "-",
      ID : "ENSG00000099203.7",
      gene_id : "ENSG00000099203.7",
      gene_type : "protein_coding",
      gene_name : "TMED1",
      gene_level : 1,
      hgnc_id : "HGNC:17291",
      havana_gene : "OTTHUMG00000180696.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10836575,
      stop : 10869790,
      direction : "+",
      ID : "ENSG00000214212.9",
      gene_id : "ENSG00000214212.9",
      gene_type : "protein_coding",
      gene_name : "C19orf38",
      gene_level : 2,
      hgnc_id : "HGNC:34073",
      havana_gene : "OTTHUMG00000180697.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10871553,
      stop : 10923075,
      direction : "+",
      ID : "ENSG00000142453.12",
      gene_id : "ENSG00000142453.12",
      gene_type : "protein_coding",
      gene_name : "CARM1",
      gene_level : 2,
      hgnc_id : "HGNC:23393",
      havana_gene : "OTTHUMG00000180699.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10922185,
      stop : 10928681,
      direction : "-",
      ID : "ENSG00000130733.11",
      gene_id : "ENSG00000130733.11",
      gene_type : "protein_coding",
      gene_name : "YIPF2",
      gene_level : 1,
      hgnc_id : "HGNC:28476",
      havana_gene : "OTTHUMG00000180796.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10928811,
      stop : 10933535,
      direction : "+",
      ID : "ENSG00000142444.7",
      gene_id : "ENSG00000142444.7",
      gene_type : "protein_coding",
      gene_name : "TIMM29",
      gene_level : 2,
      hgnc_id : "HGNC:25152",
      havana_gene : "OTTHUMG00000180700.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 10960932,
      stop : 11079426,
      direction : "+",
      ID : "ENSG00000127616.19",
      gene_id : "ENSG00000127616.19",
      gene_type : "protein_coding",
      gene_name : "SMARCA4",
      gene_level : 1,
      hgnc_id : "HGNC:11100",
      havana_gene : "OTTHUMG00000169272.16",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11089462,
      stop : 11133820,
      direction : "+",
      ID : "ENSG00000130164.14",
      gene_id : "ENSG00000130164.14",
      gene_type : "protein_coding",
      gene_name : "LDLR",
      gene_level : 1,
      hgnc_id : "HGNC:6547",
      havana_gene : "OTTHUMG00000171935.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11131520,
      stop : 11155808,
      direction : "-",
      ID : "ENSG00000161888.11",
      gene_id : "ENSG00000161888.11",
      gene_type : "protein_coding",
      gene_name : "SPC24",
      gene_level : 1,
      hgnc_id : "HGNC:26913",
      havana_gene : "OTTHUMG00000180798.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11164270,
      stop : 11197791,
      direction : "-",
      ID : "ENSG00000197256.11",
      gene_id : "ENSG00000197256.11",
      gene_type : "protein_coding",
      gene_name : "KANK2",
      gene_level : 1,
      hgnc_id : "HGNC:29300",
      havana_gene : "OTTHUMG00000180799.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11199295,
      stop : 11262524,
      direction : "-",
      ID : "ENSG00000130158.14",
      gene_id : "ENSG00000130158.14",
      gene_type : "protein_coding",
      gene_name : "DOCK6",
      gene_level : 2,
      hgnc_id : "HGNC:19189",
      havana_gene : "OTTHUMG00000180826.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11237450,
      stop : 11241943,
      direction : "+",
      ID : "ENSG00000130173.13",
      gene_id : "ENSG00000130173.13",
      gene_type : "protein_coding",
      gene_name : "ANGPTL8",
      gene_level : 2,
      hgnc_id : "HGNC:24933",
      havana_gene : "OTTHUMG00000180829.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11296139,
      stop : 11326996,
      direction : "+",
      ID : "ENSG00000130167.14",
      gene_id : "ENSG00000130167.14",
      gene_type : "protein_coding",
      gene_name : "TSPAN16",
      gene_level : 1,
      hgnc_id : "HGNC:30725",
      havana_gene : "OTTHUMG00000180833.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11322068,
      stop : 11346270,
      direction : "-",
      ID : "ENSG00000105514.8",
      gene_id : "ENSG00000105514.8",
      gene_type : "protein_coding",
      gene_name : "RAB3D",
      gene_level : 2,
      hgnc_id : "HGNC:9779",
      havana_gene : "OTTHUMG00000180835.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11342776,
      stop : 11346518,
      direction : "-",
      ID : "ENSG00000105518.14",
      gene_id : "ENSG00000105518.14",
      gene_type : "protein_coding",
      gene_name : "TMEM205",
      gene_level : 1,
      hgnc_id : "HGNC:29631",
      havana_gene : "OTTHUMG00000182021.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11344684,
      stop : 11354944,
      direction : "+",
      ID : "ENSG00000183401.12",
      gene_id : "ENSG00000183401.12",
      gene_type : "protein_coding",
      gene_name : "CCDC159",
      gene_level : 2,
      hgnc_id : "HGNC:26996",
      havana_gene : "OTTHUMG00000182022.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11355386,
      stop : 11365698,
      direction : "+",
      ID : "ENSG00000105520.10",
      gene_id : "ENSG00000105520.10",
      gene_type : "protein_coding",
      gene_name : "PLPPR2",
      gene_level : 1,
      hgnc_id : "HGNC:29566",
      havana_gene : "OTTHUMG00000182023.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11374666,
      stop : 11376951,
      direction : "+",
      ID : "ENSG00000173928.4",
      gene_id : "ENSG00000173928.4",
      gene_type : "protein_coding",
      gene_name : "SWSAP1",
      gene_level : 2,
      hgnc_id : "HGNC:26638",
      havana_gene : "OTTHUMG00000182025.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11377207,
      stop : 11384342,
      direction : "-",
      ID : "ENSG00000187266.14",
      gene_id : "ENSG00000187266.14",
      gene_type : "protein_coding",
      gene_name : "EPOR",
      gene_level : 2,
      hgnc_id : "HGNC:3416",
      havana_gene : "OTTHUMG00000182027.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11384341,
      stop : 11419328,
      direction : "-",
      ID : "ENSG00000205517.13",
      gene_id : "ENSG00000205517.13",
      gene_type : "protein_coding",
      gene_name : "RGL3",
      gene_level : 1,
      hgnc_id : "HGNC:30282",
      havana_gene : "OTTHUMG00000172898.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11420604,
      stop : 11435782,
      direction : "-",
      ID : "ENSG00000198003.12",
      gene_id : "ENSG00000198003.12",
      gene_type : "protein_coding",
      gene_name : "CCDC151",
      gene_level : 1,
      hgnc_id : "HGNC:28303",
      havana_gene : "OTTHUMG00000182028.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11435284,
      stop : 11450968,
      direction : "+",
      ID : "ENSG00000130175.10",
      gene_id : "ENSG00000130175.10",
      gene_type : "protein_coding",
      gene_name : "PRKCSH",
      gene_level : 2,
      hgnc_id : "HGNC:9411",
      havana_gene : "OTTHUMG00000182029.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11451326,
      stop : 11481046,
      direction : "-",
      ID : "ENSG00000196361.10",
      gene_id : "ENSG00000196361.10",
      gene_type : "protein_coding",
      gene_name : "ELAVL3",
      gene_level : 2,
      hgnc_id : "HGNC:3314",
      havana_gene : "OTTHUMG00000182030.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11466240,
      stop : 11505698,
      direction : "-",
      ID : "ENSG00000267477.1",
      gene_id : "ENSG00000267477.1",
      gene_type : "protein_coding",
      gene_name : "AC008481.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000182031.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11483427,
      stop : 11505839,
      direction : "-",
      ID : "ENSG00000161914.10",
      gene_id : "ENSG00000161914.10",
      gene_type : "protein_coding",
      gene_name : "ZNF653",
      gene_level : 2,
      hgnc_id : "HGNC:25196",
      havana_gene : "OTTHUMG00000182032.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11505929,
      stop : 11529172,
      direction : "-",
      ID : "ENSG00000130159.14",
      gene_id : "ENSG00000130159.14",
      gene_type : "protein_coding",
      gene_name : "ECSIT",
      gene_level : 1,
      hgnc_id : "HGNC:29548",
      havana_gene : "OTTHUMG00000178590.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11538767,
      stop : 11550323,
      direction : "+",
      ID : "ENSG00000130176.8",
      gene_id : "ENSG00000130176.8",
      gene_type : "protein_coding",
      gene_name : "CNN1",
      gene_level : 1,
      hgnc_id : "HGNC:2155",
      havana_gene : "OTTHUMG00000182033.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11551147,
      stop : 11559236,
      direction : "-",
      ID : "ENSG00000130165.10",
      gene_id : "ENSG00000130165.10",
      gene_type : "protein_coding",
      gene_name : "ELOF1",
      gene_level : 1,
      hgnc_id : "HGNC:28691",
      havana_gene : "OTTHUMG00000182034.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11559374,
      stop : 11619161,
      direction : "+",
      ID : "ENSG00000198551.10",
      gene_id : "ENSG00000198551.10",
      gene_type : "protein_coding",
      gene_name : "ZNF627",
      gene_level : 1,
      hgnc_id : "HGNC:30570",
      havana_gene : "OTTHUMG00000182035.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11574660,
      stop : 11579008,
      direction : "-",
      ID : "ENSG00000102575.13",
      gene_id : "ENSG00000102575.13",
      gene_type : "protein_coding",
      gene_name : "ACP5",
      gene_level : 2,
      hgnc_id : "HGNC:124",
      havana_gene : "OTTHUMG00000182036.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11721265,
      stop : 11739009,
      direction : "-",
      ID : "ENSG00000197933.13",
      gene_id : "ENSG00000197933.13",
      gene_type : "protein_coding",
      gene_name : "ZNF823",
      gene_level : 1,
      hgnc_id : "HGNC:30936",
      havana_gene : "OTTHUMG00000156528.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11767000,
      stop : 11784078,
      direction : "+",
      ID : "ENSG00000197044.11",
      gene_id : "ENSG00000197044.11",
      gene_type : "protein_coding",
      gene_name : "ZNF441",
      gene_level : 2,
      hgnc_id : "HGNC:20875",
      havana_gene : "OTTHUMG00000154449.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11797667,
      stop : 11809622,
      direction : "+",
      ID : "ENSG00000177599.13",
      gene_id : "ENSG00000177599.13",
      gene_type : "protein_coding",
      gene_name : "ZNF491",
      gene_level : 2,
      hgnc_id : "HGNC:23706",
      havana_gene : "OTTHUMG00000156529.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11814273,
      stop : 11835216,
      direction : "+",
      ID : "ENSG00000171295.13",
      gene_id : "ENSG00000171295.13",
      gene_type : "protein_coding",
      gene_name : "ZNF440",
      gene_level : 1,
      hgnc_id : "HGNC:20874",
      havana_gene : "OTTHUMG00000156403.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11848726,
      stop : 11883750,
      direction : "+",
      ID : "ENSG00000171291.8",
      gene_id : "ENSG00000171291.8",
      gene_type : "protein_coding",
      gene_name : "ZNF439",
      gene_level : 1,
      hgnc_id : "HGNC:20873",
      havana_gene : "OTTHUMG00000156527.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11887782,
      stop : 11914329,
      direction : "+",
      ID : "ENSG00000198429.10",
      gene_id : "ENSG00000198429.10",
      gene_type : "protein_coding",
      gene_name : "ZNF69",
      gene_level : 2,
      hgnc_id : "HGNC:13138",
      havana_gene : "OTTHUMG00000156526.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11925068,
      stop : 11950773,
      direction : "+",
      ID : "ENSG00000196757.8",
      gene_id : "ENSG00000196757.8",
      gene_type : "protein_coding",
      gene_name : "ZNF700",
      gene_level : 2,
      hgnc_id : "HGNC:25292",
      havana_gene : "OTTHUMG00000156421.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11925075,
      stop : 11979290,
      direction : "+",
      ID : "ENSG00000267179.1",
      gene_id : "ENSG00000267179.1",
      gene_type : "protein_coding",
      gene_name : "AC008770.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182304.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11965037,
      stop : 11980617,
      direction : "+",
      ID : "ENSG00000197054.12",
      gene_id : "ENSG00000197054.12",
      gene_type : "protein_coding",
      gene_name : "ZNF763",
      gene_level : 1,
      hgnc_id : "HGNC:27614",
      havana_gene : "OTTHUMG00000156430.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 11987641,
      stop : 12078106,
      direction : "+",
      ID : "ENSG00000286098.1",
      gene_id : "ENSG00000286098.1",
      gene_type : "protein_coding",
      gene_name : "AC008770.4",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193446.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12014732,
      stop : 12035741,
      direction : "-",
      ID : "ENSG00000197647.11",
      gene_id : "ENSG00000197647.11",
      gene_type : "protein_coding",
      gene_name : "ZNF433",
      gene_level : 1,
      hgnc_id : "HGNC:20811",
      havana_gene : "OTTHUMG00000156427.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12017888,
      stop : 12052967,
      direction : "-",
      ID : "ENSG00000257355.1",
      gene_id : "ENSG00000257355.1",
      gene_type : "protein_coding",
      gene_name : "AC008770.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000169369.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12043805,
      stop : 12052961,
      direction : "-",
      ID : "ENSG00000257446.4",
      gene_id : "ENSG00000257446.4",
      gene_type : "protein_coding",
      gene_name : "ZNF878",
      gene_level : 2,
      hgnc_id : "HGNC:37246",
      havana_gene : "OTTHUMG00000169370.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12064731,
      stop : 12081565,
      direction : "+",
      ID : "ENSG00000223547.10",
      gene_id : "ENSG00000223547.10",
      gene_type : "protein_coding",
      gene_name : "ZNF844",
      gene_level : 1,
      hgnc_id : "HGNC:25932",
      havana_gene : "OTTHUMG00000156405.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12075327,
      stop : 12113325,
      direction : "+",
      ID : "ENSG00000286132.1",
      gene_id : "ENSG00000286132.1",
      gene_type : "protein_coding",
      gene_name : "AC022415.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193447.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12092843,
      stop : 12140355,
      direction : "-",
      ID : "ENSG00000132010.16",
      gene_id : "ENSG00000132010.16",
      gene_type : "protein_coding",
      gene_name : "ZNF20",
      gene_level : 2,
      hgnc_id : "HGNC:12992",
      havana_gene : "OTTHUMG00000156409.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12132117,
      stop : 12156731,
      direction : "-",
      ID : "ENSG00000213297.8",
      gene_id : "ENSG00000213297.8",
      gene_type : "protein_coding",
      gene_name : "ZNF625-ZNF20",
      gene_level : 2,
      hgnc_id : "HGNC:48368",
      havana_gene : "OTTHUMG00000170135.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12142090,
      stop : 12156734,
      direction : "-",
      ID : "ENSG00000257591.6",
      gene_id : "ENSG00000257591.6",
      gene_type : "protein_coding",
      gene_name : "ZNF625",
      gene_level : 2,
      hgnc_id : "HGNC:30571",
      havana_gene : "OTTHUMG00000156407.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12163064,
      stop : 12189871,
      direction : "+",
      ID : "ENSG00000196646.12",
      gene_id : "ENSG00000196646.12",
      gene_type : "protein_coding",
      gene_name : "ZNF136",
      gene_level : 1,
      hgnc_id : "HGNC:12920",
      havana_gene : "OTTHUMG00000156429.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12224686,
      stop : 12294883,
      direction : "-",
      ID : "ENSG00000197857.15",
      gene_id : "ENSG00000197857.15",
      gene_type : "protein_coding",
      gene_name : "ZNF44",
      gene_level : 2,
      hgnc_id : "HGNC:13110",
      havana_gene : "OTTHUMG00000156424.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12317477,
      stop : 12333720,
      direction : "-",
      ID : "ENSG00000188868.14",
      gene_id : "ENSG00000188868.14",
      gene_type : "protein_coding",
      gene_name : "ZNF563",
      gene_level : 2,
      hgnc_id : "HGNC:30498",
      havana_gene : "OTTHUMG00000156413.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12345944,
      stop : 12365905,
      direction : "-",
      ID : "ENSG00000198342.10",
      gene_id : "ENSG00000198342.10",
      gene_type : "protein_coding",
      gene_name : "ZNF442",
      gene_level : 2,
      hgnc_id : "HGNC:20877",
      havana_gene : "OTTHUMG00000156411.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12390016,
      stop : 12401271,
      direction : "-",
      ID : "ENSG00000196466.10",
      gene_id : "ENSG00000196466.10",
      gene_type : "protein_coding",
      gene_name : "ZNF799",
      gene_level : 2,
      hgnc_id : "HGNC:28071",
      havana_gene : "OTTHUMG00000156408.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12391949,
      stop : 12441082,
      direction : "-",
      ID : "ENSG00000268870.1",
      gene_id : "ENSG00000268870.1",
      gene_type : "protein_coding",
      gene_name : "AC008758.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182410.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12429706,
      stop : 12441021,
      direction : "-",
      ID : "ENSG00000180855.16",
      gene_id : "ENSG00000180855.16",
      gene_type : "protein_coding",
      gene_name : "ZNF443",
      gene_level : 2,
      hgnc_id : "HGNC:20878",
      havana_gene : "OTTHUMG00000156404.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12433103,
      stop : 12484816,
      direction : "-",
      ID : "ENSG00000269755.1",
      gene_id : "ENSG00000269755.1",
      gene_type : "protein_coding",
      gene_name : "AC008758.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182413.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12461184,
      stop : 12513854,
      direction : "-",
      ID : "ENSG00000242852.7",
      gene_id : "ENSG00000242852.7",
      gene_type : "protein_coding",
      gene_name : "ZNF709",
      gene_level : 2,
      hgnc_id : "HGNC:20629",
      havana_gene : "OTTHUMG00000156406.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12461559,
      stop : 12551474,
      direction : "-",
      ID : "ENSG00000196826.7",
      gene_id : "ENSG00000196826.7",
      gene_type : "protein_coding",
      gene_name : "AC008758.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162246.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12525373,
      stop : 12551542,
      direction : "-",
      ID : "ENSG00000249709.8",
      gene_id : "ENSG00000249709.8",
      gene_type : "protein_coding",
      gene_name : "ZNF564",
      gene_level : 2,
      hgnc_id : "HGNC:31106",
      havana_gene : "OTTHUMG00000156418.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12525720,
      stop : 12580975,
      direction : "-",
      ID : "ENSG00000269693.1",
      gene_id : "ENSG00000269693.1",
      gene_type : "protein_coding",
      gene_name : "AC010422.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182414.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12576100,
      stop : 12640098,
      direction : "-",
      ID : "ENSG00000188033.10",
      gene_id : "ENSG00000188033.10",
      gene_type : "protein_coding",
      gene_name : "ZNF490",
      gene_level : 1,
      hgnc_id : "HGNC:23705",
      havana_gene : "OTTHUMG00000156398.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12610918,
      stop : 12633840,
      direction : "+",
      ID : "ENSG00000173875.14",
      gene_id : "ENSG00000173875.14",
      gene_type : "protein_coding",
      gene_name : "ZNF791",
      gene_level : 1,
      hgnc_id : "HGNC:26895",
      havana_gene : "OTTHUMG00000156426.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12643831,
      stop : 12648397,
      direction : "-",
      ID : "ENSG00000269242.1",
      gene_id : "ENSG00000269242.1",
      gene_type : "protein_coding",
      gene_name : "AC010422.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182615.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12646511,
      stop : 12666742,
      direction : "-",
      ID : "ENSG00000104774.13",
      gene_id : "ENSG00000104774.13",
      gene_type : "protein_coding",
      gene_name : "MAN2B1",
      gene_level : 1,
      hgnc_id : "HGNC:6826",
      havana_gene : "OTTHUMG00000156397.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12664828,
      stop : 12669397,
      direction : "-",
      ID : "ENSG00000269590.1",
      gene_id : "ENSG00000269590.1",
      gene_type : "protein_coding",
      gene_name : "AC010422.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182616.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12666802,
      stop : 12675832,
      direction : "+",
      ID : "ENSG00000123154.12",
      gene_id : "ENSG00000123154.12",
      gene_type : "protein_coding",
      gene_name : "WDR83",
      gene_level : 2,
      hgnc_id : "HGNC:32672",
      havana_gene : "OTTHUMG00000169356.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12668071,
      stop : 12681834,
      direction : "-",
      ID : "ENSG00000285589.1",
      gene_id : "ENSG00000285589.1",
      gene_type : "protein_coding",
      gene_name : "AC010422.8",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182617.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12668073,
      stop : 12669415,
      direction : "-",
      ID : "ENSG00000105583.11",
      gene_id : "ENSG00000105583.11",
      gene_type : "protein_coding",
      gene_name : "WDR83OS",
      gene_level : 2,
      hgnc_id : "HGNC:30203",
      havana_gene : "OTTHUMG00000193390.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12675717,
      stop : 12681880,
      direction : "-",
      ID : "ENSG00000095059.16",
      gene_id : "ENSG00000095059.16",
      gene_type : "protein_coding",
      gene_name : "DHPS",
      gene_level : 2,
      hgnc_id : "HGNC:2869",
      havana_gene : "OTTHUMG00000182618.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12687998,
      stop : 12688422,
      direction : "+",
      ID : "ENSG00000283980.1",
      gene_id : "ENSG00000283980.1",
      gene_type : "protein_coding",
      gene_name : "GNG14",
      gene_level : 2,
      hgnc_id : "HGNC:53439",
      havana_gene : "OTTHUMG00000192021.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12688053,
      stop : 12696631,
      direction : "-",
      ID : "ENSG00000132004.13",
      gene_id : "ENSG00000132004.13",
      gene_type : "protein_coding",
      gene_name : "FBXW9",
      gene_level : 1,
      hgnc_id : "HGNC:28136",
      havana_gene : "OTTHUMG00000150152.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12699194,
      stop : 12724011,
      direction : "-",
      ID : "ENSG00000105576.15",
      gene_id : "ENSG00000105576.15",
      gene_type : "protein_coding",
      gene_name : "TNPO2",
      gene_level : 2,
      hgnc_id : "HGNC:19998",
      havana_gene : "OTTHUMG00000180333.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12730640,
      stop : 12734684,
      direction : "-",
      ID : "ENSG00000123144.11",
      gene_id : "ENSG00000123144.11",
      gene_type : "protein_coding",
      gene_name : "TRIR",
      gene_level : 1,
      hgnc_id : "HGNC:28424",
      havana_gene : "OTTHUMG00000180347.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12737139,
      stop : 12748323,
      direction : "+",
      ID : "ENSG00000198356.12",
      gene_id : "ENSG00000198356.12",
      gene_type : "protein_coding",
      gene_name : "GET3",
      gene_level : 2,
      hgnc_id : "HGNC:752",
      havana_gene : "OTTHUMG00000180355.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12751702,
      stop : 12758458,
      direction : "+",
      ID : "ENSG00000039987.7",
      gene_id : "ENSG00000039987.7",
      gene_type : "protein_coding",
      gene_name : "BEST2",
      gene_level : 2,
      hgnc_id : "HGNC:17107",
      havana_gene : "OTTHUMG00000169293.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12763003,
      stop : 12872740,
      direction : "-",
      ID : "ENSG00000095066.12",
      gene_id : "ENSG00000095066.12",
      gene_type : "protein_coding",
      gene_name : "HOOK2",
      gene_level : 2,
      hgnc_id : "HGNC:19885",
      havana_gene : "OTTHUMG00000180372.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12791486,
      stop : 12793315,
      direction : "+",
      ID : "ENSG00000171223.6",
      gene_id : "ENSG00000171223.6",
      gene_type : "protein_coding",
      gene_name : "JUNB",
      gene_level : 2,
      hgnc_id : "HGNC:6205",
      havana_gene : "OTTHUMG00000180373.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12796820,
      stop : 12801800,
      direction : "-",
      ID : "ENSG00000167815.12",
      gene_id : "ENSG00000167815.12",
      gene_type : "protein_coding",
      gene_name : "PRDX2",
      gene_level : 1,
      hgnc_id : "HGNC:9353",
      havana_gene : "OTTHUMG00000134285.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12802031,
      stop : 12813581,
      direction : "+",
      ID : "ENSG00000284491.2",
      gene_id : "ENSG00000284491.2",
      gene_type : "protein_coding",
      gene_name : "THSD8",
      gene_level : 2,
      hgnc_id : "HGNC:53785",
      havana_gene : "OTTHUMG00000191900.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12806584,
      stop : 12813640,
      direction : "+",
      ID : "ENSG00000104889.7",
      gene_id : "ENSG00000104889.7",
      gene_type : "protein_coding",
      gene_name : "RNASEH2A",
      gene_level : 2,
      hgnc_id : "HGNC:18518",
      havana_gene : "OTTHUMG00000180481.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12825478,
      stop : 12835428,
      direction : "-",
      ID : "ENSG00000132026.15",
      gene_id : "ENSG00000132026.15",
      gene_type : "protein_coding",
      gene_name : "RTBDN",
      gene_level : 1,
      hgnc_id : "HGNC:30310",
      havana_gene : "OTTHUMG00000180482.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12833951,
      stop : 12874952,
      direction : "+",
      ID : "ENSG00000105613.10",
      gene_id : "ENSG00000105613.10",
      gene_type : "protein_coding",
      gene_name : "MAST1",
      gene_level : 2,
      hgnc_id : "HGNC:19034",
      havana_gene : "OTTHUMG00000180514.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12875209,
      stop : 12881466,
      direction : "-",
      ID : "ENSG00000105612.9",
      gene_id : "ENSG00000105612.9",
      gene_type : "protein_coding",
      gene_name : "DNASE2",
      gene_level : 2,
      hgnc_id : "HGNC:2960",
      havana_gene : "OTTHUMG00000180535.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12884422,
      stop : 12887201,
      direction : "-",
      ID : "ENSG00000105610.6",
      gene_id : "ENSG00000105610.6",
      gene_type : "protein_coding",
      gene_name : "KLF1",
      gene_level : 2,
      hgnc_id : "HGNC:6345",
      havana_gene : "OTTHUMG00000180536.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12891160,
      stop : 12914207,
      direction : "+",
      ID : "ENSG00000105607.13",
      gene_id : "ENSG00000105607.13",
      gene_type : "protein_coding",
      gene_name : "GCDH",
      gene_level : 1,
      hgnc_id : "HGNC:4189",
      havana_gene : "OTTHUMG00000180561.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12898786,
      stop : 12919293,
      direction : "-",
      ID : "ENSG00000161860.8",
      gene_id : "ENSG00000161860.8",
      gene_type : "protein_coding",
      gene_name : "SYCE2",
      gene_level : 1,
      hgnc_id : "HGNC:27411",
      havana_gene : "OTTHUMG00000180562.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12922479,
      stop : 12934037,
      direction : "-",
      ID : "ENSG00000179115.11",
      gene_id : "ENSG00000179115.11",
      gene_type : "protein_coding",
      gene_name : "FARSA",
      gene_level : 2,
      hgnc_id : "HGNC:3592",
      havana_gene : "OTTHUMG00000180569.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12938578,
      stop : 12944489,
      direction : "+",
      ID : "ENSG00000179218.15",
      gene_id : "ENSG00000179218.15",
      gene_type : "protein_coding",
      gene_name : "CALR",
      gene_level : 2,
      hgnc_id : "HGNC:1455",
      havana_gene : "OTTHUMG00000180574.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12945855,
      stop : 12953642,
      direction : "+",
      ID : "ENSG00000179262.10",
      gene_id : "ENSG00000179262.10",
      gene_type : "protein_coding",
      gene_name : "RAD23A",
      gene_level : 2,
      hgnc_id : "HGNC:9812",
      havana_gene : "OTTHUMG00000180723.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12953119,
      stop : 12957223,
      direction : "-",
      ID : "ENSG00000179271.3",
      gene_id : "ENSG00000179271.3",
      gene_type : "protein_coding",
      gene_name : "GADD45GIP1",
      gene_level : 2,
      hgnc_id : "HGNC:29996",
      havana_gene : "OTTHUMG00000180724.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12965159,
      stop : 12974760,
      direction : "+",
      ID : "ENSG00000179284.6",
      gene_id : "ENSG00000179284.6",
      gene_type : "protein_coding",
      gene_name : "DAND5",
      gene_level : 1,
      hgnc_id : "HGNC:26780",
      havana_gene : "OTTHUMG00000180725.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 12995475,
      stop : 13098796,
      direction : "+",
      ID : "ENSG00000008441.18",
      gene_id : "ENSG00000008441.18",
      gene_type : "protein_coding",
      gene_name : "NFIX",
      gene_level : 1,
      hgnc_id : "HGNC:7788",
      havana_gene : "OTTHUMG00000180726.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13099033,
      stop : 13103161,
      direction : "-",
      ID : "ENSG00000104903.5",
      gene_id : "ENSG00000104903.5",
      gene_type : "protein_coding",
      gene_name : "LYL1",
      gene_level : 1,
      hgnc_id : "HGNC:6734",
      havana_gene : "OTTHUMG00000180736.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13104902,
      stop : 13117567,
      direction : "-",
      ID : "ENSG00000104907.13",
      gene_id : "ENSG00000104907.13",
      gene_type : "protein_coding",
      gene_name : "TRMT1",
      gene_level : 2,
      hgnc_id : "HGNC:25980",
      havana_gene : "OTTHUMG00000180730.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13116862,
      stop : 13141147,
      direction : "+",
      ID : "ENSG00000160877.6",
      gene_id : "ENSG00000160877.6",
      gene_type : "protein_coding",
      gene_name : "NACC1",
      gene_level : 2,
      hgnc_id : "HGNC:20967",
      havana_gene : "OTTHUMG00000180748.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13144058,
      stop : 13150383,
      direction : "-",
      ID : "ENSG00000104915.15",
      gene_id : "ENSG00000104915.15",
      gene_type : "protein_coding",
      gene_name : "STX10",
      gene_level : 2,
      hgnc_id : "HGNC:11428",
      havana_gene : "OTTHUMG00000180759.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13150411,
      stop : 13154911,
      direction : "+",
      ID : "ENSG00000160888.7",
      gene_id : "ENSG00000160888.7",
      gene_type : "protein_coding",
      gene_name : "IER2",
      gene_level : 2,
      hgnc_id : "HGNC:28871",
      havana_gene : "OTTHUMG00000180790.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13206442,
      stop : 13633025,
      direction : "-",
      ID : "ENSG00000141837.22",
      gene_id : "ENSG00000141837.22",
      gene_type : "protein_coding",
      gene_name : "CACNA1A",
      gene_level : 1,
      hgnc_id : "HGNC:1388",
      havana_gene : "OTTHUMG00000044590.18",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13731760,
      stop : 13763296,
      direction : "+",
      ID : "ENSG00000104957.14",
      gene_id : "ENSG00000104957.14",
      gene_type : "protein_coding",
      gene_name : "CCDC130",
      gene_level : 2,
      hgnc_id : "HGNC:28118",
      havana_gene : "OTTHUMG00000180837.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13764522,
      stop : 13774282,
      direction : "+",
      ID : "ENSG00000037757.14",
      gene_id : "ENSG00000037757.14",
      gene_type : "protein_coding",
      gene_name : "MRI1",
      gene_level : 1,
      hgnc_id : "HGNC:28469",
      havana_gene : "OTTHUMG00000180867.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13774456,
      stop : 13778773,
      direction : "+",
      ID : "ENSG00000104979.9",
      gene_id : "ENSG00000104979.9",
      gene_type : "protein_coding",
      gene_name : "C19orf53",
      gene_level : 1,
      hgnc_id : "HGNC:24991",
      havana_gene : "OTTHUMG00000180914.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13795460,
      stop : 13832230,
      direction : "+",
      ID : "ENSG00000132003.9",
      gene_id : "ENSG00000132003.9",
      gene_type : "protein_coding",
      gene_name : "ZSWIM4",
      gene_level : 2,
      hgnc_id : "HGNC:25704",
      havana_gene : "OTTHUMG00000181752.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13862063,
      stop : 13880757,
      direction : "+",
      ID : "ENSG00000187556.7",
      gene_id : "ENSG00000187556.7",
      gene_type : "protein_coding",
      gene_name : "NANOS3",
      gene_level : 1,
      hgnc_id : "HGNC:22048",
      havana_gene : "OTTHUMG00000181850.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13882348,
      stop : 13906452,
      direction : "-",
      ID : "ENSG00000132016.11",
      gene_id : "ENSG00000132016.11",
      gene_type : "protein_coding",
      gene_name : "BRME1",
      gene_level : 1,
      hgnc_id : "HGNC:28153",
      havana_gene : "OTTHUMG00000181851.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13906201,
      stop : 13930879,
      direction : "+",
      ID : "ENSG00000132024.18",
      gene_id : "ENSG00000132024.18",
      gene_type : "protein_coding",
      gene_name : "CC2D1A",
      gene_level : 2,
      hgnc_id : "HGNC:30237",
      havana_gene : "OTTHUMG00000181852.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13931187,
      stop : 13953392,
      direction : "-",
      ID : "ENSG00000132000.13",
      gene_id : "ENSG00000132000.13",
      gene_type : "protein_coding",
      gene_name : "PODNL1",
      gene_level : 1,
      hgnc_id : "HGNC:26275",
      havana_gene : "OTTHUMG00000181853.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13952492,
      stop : 13961449,
      direction : "+",
      ID : "ENSG00000132017.10",
      gene_id : "ENSG00000132017.10",
      gene_type : "protein_coding",
      gene_name : "DCAF15",
      gene_level : 2,
      hgnc_id : "HGNC:25095",
      havana_gene : "OTTHUMG00000181882.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 13961530,
      stop : 14007039,
      direction : "-",
      ID : "ENSG00000132005.9",
      gene_id : "ENSG00000132005.9",
      gene_type : "protein_coding",
      gene_name : "RFX1",
      gene_level : 1,
      hgnc_id : "HGNC:9982",
      havana_gene : "OTTHUMG00000181979.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14028148,
      stop : 14031551,
      direction : "+",
      ID : "ENSG00000171136.7",
      gene_id : "ENSG00000171136.7",
      gene_type : "protein_coding",
      gene_name : "RLN3",
      gene_level : 1,
      hgnc_id : "HGNC:17135",
      havana_gene : "OTTHUMG00000181986.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14031762,
      stop : 14053218,
      direction : "+",
      ID : "ENSG00000104998.4",
      gene_id : "ENSG00000104998.4",
      gene_type : "protein_coding",
      gene_name : "IL27RA",
      gene_level : 2,
      hgnc_id : "HGNC:17290",
      havana_gene : "OTTHUMG00000181990.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14053363,
      stop : 14062076,
      direction : "-",
      ID : "ENSG00000187867.10",
      gene_id : "ENSG00000187867.10",
      gene_type : "protein_coding",
      gene_name : "PALM3",
      gene_level : 2,
      hgnc_id : "HGNC:33274",
      havana_gene : "OTTHUMG00000181991.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14072536,
      stop : 14075062,
      direction : "+",
      ID : "ENSG00000141854.9",
      gene_id : "ENSG00000141854.9",
      gene_type : "protein_coding",
      gene_name : "MISP3",
      gene_level : 2,
      hgnc_id : "HGNC:26963",
      havana_gene : "OTTHUMG00000181994.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14081624,
      stop : 14085875,
      direction : "-",
      ID : "ENSG00000188032.10",
      gene_id : "ENSG00000188032.10",
      gene_type : "protein_coding",
      gene_name : "C19orf67",
      gene_level : 1,
      hgnc_id : "HGNC:34354",
      havana_gene : "OTTHUMG00000169303.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14087851,
      stop : 14091036,
      direction : "-",
      ID : "ENSG00000141858.12",
      gene_id : "ENSG00000141858.12",
      gene_type : "protein_coding",
      gene_name : "SAMD1",
      gene_level : 2,
      hgnc_id : "HGNC:17958",
      havana_gene : "OTTHUMG00000166628.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14091688,
      stop : 14118084,
      direction : "-",
      ID : "ENSG00000072062.15",
      gene_id : "ENSG00000072062.15",
      gene_type : "protein_coding",
      gene_name : "PRKACA",
      gene_level : 1,
      hgnc_id : "HGNC:9380",
      havana_gene : "OTTHUMG00000182051.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14119512,
      stop : 14136613,
      direction : "-",
      ID : "ENSG00000105011.9",
      gene_id : "ENSG00000105011.9",
      gene_type : "protein_coding",
      gene_name : "ASF1B",
      gene_level : 2,
      hgnc_id : "HGNC:20996",
      havana_gene : "OTTHUMG00000150401.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14147743,
      stop : 14206187,
      direction : "-",
      ID : "ENSG00000072071.16",
      gene_id : "ENSG00000072071.16",
      gene_type : "protein_coding",
      gene_name : "ADGRL1",
      gene_level : 1,
      hgnc_id : "HGNC:20973",
      havana_gene : "OTTHUMG00000182138.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14380501,
      stop : 14408725,
      direction : "+",
      ID : "ENSG00000123146.20",
      gene_id : "ENSG00000123146.20",
      gene_type : "protein_coding",
      gene_name : "ADGRE5",
      gene_level : 1,
      hgnc_id : "HGNC:1711",
      havana_gene : "OTTHUMG00000182166.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14408798,
      stop : 14419383,
      direction : "-",
      ID : "ENSG00000123136.15",
      gene_id : "ENSG00000123136.15",
      gene_type : "protein_coding",
      gene_name : "DDX39A",
      gene_level : 1,
      hgnc_id : "HGNC:17821",
      havana_gene : "OTTHUMG00000182181.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14433053,
      stop : 14471867,
      direction : "+",
      ID : "ENSG00000123143.13",
      gene_id : "ENSG00000123143.13",
      gene_type : "protein_coding",
      gene_name : "PKN1",
      gene_level : 1,
      hgnc_id : "HGNC:9405",
      havana_gene : "OTTHUMG00000039611.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14472466,
      stop : 14475354,
      direction : "-",
      ID : "ENSG00000160951.4",
      gene_id : "ENSG00000160951.4",
      gene_type : "protein_coding",
      gene_name : "PTGER1",
      gene_level : 2,
      hgnc_id : "HGNC:9593",
      havana_gene : "OTTHUMG00000039610.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14477760,
      stop : 14496149,
      direction : "-",
      ID : "ENSG00000123159.16",
      gene_id : "ENSG00000123159.16",
      gene_type : "protein_coding",
      gene_name : "GIPC1",
      gene_level : 2,
      hgnc_id : "HGNC:1226",
      havana_gene : "OTTHUMG00000182248.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14514769,
      stop : 14560391,
      direction : "-",
      ID : "ENSG00000132002.9",
      gene_id : "ENSG00000132002.9",
      gene_type : "protein_coding",
      gene_name : "DNAJB1",
      gene_level : 1,
      hgnc_id : "HGNC:5270",
      havana_gene : "OTTHUMG00000183289.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14517085,
      stop : 14565980,
      direction : "+",
      ID : "ENSG00000099797.15",
      gene_id : "ENSG00000099797.15",
      gene_type : "protein_coding",
      gene_name : "TECR",
      gene_level : 2,
      hgnc_id : "HGNC:4551",
      havana_gene : "OTTHUMG00000183290.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14566078,
      stop : 14572066,
      direction : "-",
      ID : "ENSG00000099795.7",
      gene_id : "ENSG00000099795.7",
      gene_type : "protein_coding",
      gene_name : "NDUFB7",
      gene_level : 2,
      hgnc_id : "HGNC:7702",
      havana_gene : "OTTHUMG00000183291.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14583084,
      stop : 14612035,
      direction : "+",
      ID : "ENSG00000187912.12",
      gene_id : "ENSG00000187912.12",
      gene_type : "protein_coding",
      gene_name : "CLEC17A",
      gene_level : 2,
      hgnc_id : "HGNC:34520",
      havana_gene : "OTTHUMG00000169312.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14619117,
      stop : 14690027,
      direction : "-",
      ID : "ENSG00000131355.15",
      gene_id : "ENSG00000131355.15",
      gene_type : "protein_coding",
      gene_name : "ADGRE3",
      gene_level : 1,
      hgnc_id : "HGNC:23647",
      havana_gene : "OTTHUMG00000183406.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14689801,
      stop : 14733746,
      direction : "+",
      ID : "ENSG00000160961.12",
      gene_id : "ENSG00000160961.12",
      gene_type : "protein_coding",
      gene_name : "ZNF333",
      gene_level : 1,
      hgnc_id : "HGNC:15624",
      havana_gene : "OTTHUMG00000183407.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14732392,
      stop : 14778560,
      direction : "-",
      ID : "ENSG00000127507.18",
      gene_id : "ENSG00000127507.18",
      gene_type : "protein_coding",
      gene_name : "ADGRE2",
      gene_level : 1,
      hgnc_id : "HGNC:3337",
      havana_gene : "OTTHUMG00000183408.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14789260,
      stop : 14835376,
      direction : "-",
      ID : "ENSG00000127530.4",
      gene_id : "ENSG00000127530.4",
      gene_type : "protein_coding",
      gene_name : "OR7C1",
      gene_level : 2,
      hgnc_id : "HGNC:8373",
      havana_gene : "OTTHUMG00000183411.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14826241,
      stop : 14835185,
      direction : "-",
      ID : "ENSG00000188269.10",
      gene_id : "ENSG00000188269.10",
      gene_type : "protein_coding",
      gene_name : "OR7A5",
      gene_level : 2,
      hgnc_id : "HGNC:8368",
      havana_gene : "OTTHUMG00000183410.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14840466,
      stop : 14848922,
      direction : "-",
      ID : "ENSG00000127515.3",
      gene_id : "ENSG00000127515.3",
      gene_type : "protein_coding",
      gene_name : "OR7A10",
      gene_level : 2,
      hgnc_id : "HGNC:8356",
      havana_gene : "OTTHUMG00000183412.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14878203,
      stop : 14886132,
      direction : "-",
      ID : "ENSG00000185385.4",
      gene_id : "ENSG00000185385.4",
      gene_type : "protein_coding",
      gene_name : "OR7A17",
      gene_level : 2,
      hgnc_id : "HGNC:8363",
      havana_gene : "OTTHUMG00000183415.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14941489,
      stop : 14942448,
      direction : "+",
      ID : "ENSG00000127529.7",
      gene_id : "ENSG00000127529.7",
      gene_type : "protein_coding",
      gene_name : "OR7C2",
      gene_level : 2,
      hgnc_id : "HGNC:8374",
      havana_gene : "OTTHUMG00000183350.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 14950034,
      stop : 15022990,
      direction : "-",
      ID : "ENSG00000105143.12",
      gene_id : "ENSG00000105143.12",
      gene_type : "protein_coding",
      gene_name : "SLC1A6",
      gene_level : 1,
      hgnc_id : "HGNC:10944",
      havana_gene : "OTTHUMG00000183351.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15010726,
      stop : 15023276,
      direction : "+",
      ID : "ENSG00000160994.4",
      gene_id : "ENSG00000160994.4",
      gene_type : "protein_coding",
      gene_name : "CCDC105",
      gene_level : 2,
      hgnc_id : "HGNC:26866",
      havana_gene : "OTTHUMG00000183352.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15049480,
      stop : 15058293,
      direction : "+",
      ID : "ENSG00000105141.6",
      gene_id : "ENSG00000105141.6",
      gene_type : "protein_coding",
      gene_name : "CASP14",
      gene_level : 2,
      hgnc_id : "HGNC:1502",
      havana_gene : "OTTHUMG00000183205.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15082211,
      stop : 15092970,
      direction : "+",
      ID : "ENSG00000094661.3",
      gene_id : "ENSG00000094661.3",
      gene_type : "protein_coding",
      gene_name : "OR1I1",
      gene_level : 2,
      hgnc_id : "HGNC:8207",
      havana_gene : "OTTHUMG00000183206.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15107401,
      stop : 15114985,
      direction : "+",
      ID : "ENSG00000105137.13",
      gene_id : "ENSG00000105137.13",
      gene_type : "protein_coding",
      gene_name : "SYDE1",
      gene_level : 2,
      hgnc_id : "HGNC:25824",
      havana_gene : "OTTHUMG00000183207.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15114984,
      stop : 15125786,
      direction : "-",
      ID : "ENSG00000105135.16",
      gene_id : "ENSG00000105135.16",
      gene_type : "protein_coding",
      gene_name : "ILVBL",
      gene_level : 2,
      hgnc_id : "HGNC:6041",
      havana_gene : "OTTHUMG00000165630.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15159038,
      stop : 15200995,
      direction : "-",
      ID : "ENSG00000074181.9",
      gene_id : "ENSG00000074181.9",
      gene_type : "protein_coding",
      gene_name : "NOTCH3",
      gene_level : 2,
      hgnc_id : "HGNC:7883",
      havana_gene : "OTTHUMG00000183217.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15226919,
      stop : 15233435,
      direction : "-",
      ID : "ENSG00000105131.8",
      gene_id : "ENSG00000105131.8",
      gene_type : "protein_coding",
      gene_name : "EPHX3",
      gene_level : 2,
      hgnc_id : "HGNC:23760",
      havana_gene : "OTTHUMG00000183251.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15235519,
      stop : 15332545,
      direction : "-",
      ID : "ENSG00000141867.19",
      gene_id : "ENSG00000141867.19",
      gene_type : "protein_coding",
      gene_name : "BRD4",
      gene_level : 2,
      hgnc_id : "HGNC:13575",
      havana_gene : "OTTHUMG00000183252.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15353385,
      stop : 15379815,
      direction : "-",
      ID : "ENSG00000105127.10",
      gene_id : "ENSG00000105127.10",
      gene_type : "protein_coding",
      gene_name : "AKAP8",
      gene_level : 2,
      hgnc_id : "HGNC:378",
      havana_gene : "OTTHUMG00000182444.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15380050,
      stop : 15419141,
      direction : "-",
      ID : "ENSG00000011243.19",
      gene_id : "ENSG00000011243.19",
      gene_type : "protein_coding",
      gene_name : "AKAP8L",
      gene_level : 1,
      hgnc_id : "HGNC:29857",
      havana_gene : "OTTHUMG00000182446.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15419978,
      stop : 15449956,
      direction : "-",
      ID : "ENSG00000011451.21",
      gene_id : "ENSG00000011451.21",
      gene_type : "protein_coding",
      gene_name : "WIZ",
      gene_level : 1,
      hgnc_id : "HGNC:30917",
      havana_gene : "OTTHUMG00000182448.13",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15451624,
      stop : 15464544,
      direction : "-",
      ID : "ENSG00000105122.13",
      gene_id : "ENSG00000105122.13",
      gene_type : "protein_coding",
      gene_name : "RASAL3",
      gene_level : 2,
      hgnc_id : "HGNC:26129",
      havana_gene : "OTTHUMG00000182450.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15468645,
      stop : 15498956,
      direction : "-",
      ID : "ENSG00000161031.13",
      gene_id : "ENSG00000161031.13",
      gene_type : "protein_coding",
      gene_name : "PGLYRP2",
      gene_level : 2,
      hgnc_id : "HGNC:30013",
      havana_gene : "OTTHUMG00000150690.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15508525,
      stop : 15552317,
      direction : "+",
      ID : "ENSG00000171954.13",
      gene_id : "ENSG00000171954.13",
      gene_type : "protein_coding",
      gene_name : "CYP4F22",
      gene_level : 2,
      hgnc_id : "HGNC:26820",
      havana_gene : "OTTHUMG00000182451.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15615218,
      stop : 15630639,
      direction : "+",
      ID : "ENSG00000186526.13",
      gene_id : "ENSG00000186526.13",
      gene_type : "protein_coding",
      gene_name : "CYP4F8",
      gene_level : 2,
      hgnc_id : "HGNC:2648",
      havana_gene : "OTTHUMG00000182386.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15640897,
      stop : 15662825,
      direction : "+",
      ID : "ENSG00000186529.16",
      gene_id : "ENSG00000186529.16",
      gene_type : "protein_coding",
      gene_name : "CYP4F3",
      gene_level : 2,
      hgnc_id : "HGNC:2646",
      havana_gene : "OTTHUMG00000182374.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15673018,
      stop : 15697174,
      direction : "+",
      ID : "ENSG00000186204.15",
      gene_id : "ENSG00000186204.15",
      gene_type : "protein_coding",
      gene_name : "CYP4F12",
      gene_level : 2,
      hgnc_id : "HGNC:18857",
      havana_gene : "OTTHUMG00000164477.14",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15728024,
      stop : 15729052,
      direction : "+",
      ID : "ENSG00000171942.5",
      gene_id : "ENSG00000171942.5",
      gene_type : "protein_coding",
      gene_name : "OR10H2",
      gene_level : 2,
      hgnc_id : "HGNC:8173",
      havana_gene : "OTTHUMG00000182389.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15737985,
      stop : 15742343,
      direction : "+",
      ID : "ENSG00000171936.3",
      gene_id : "ENSG00000171936.3",
      gene_type : "protein_coding",
      gene_name : "OR10H3",
      gene_level : 2,
      hgnc_id : "HGNC:8174",
      havana_gene : "OTTHUMG00000182390.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15787661,
      stop : 15800357,
      direction : "+",
      ID : "ENSG00000172519.10",
      gene_id : "ENSG00000172519.10",
      gene_type : "protein_coding",
      gene_name : "OR10H5",
      gene_level : 2,
      hgnc_id : "HGNC:15389",
      havana_gene : "OTTHUMG00000182284.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15804549,
      stop : 15815664,
      direction : "-",
      ID : "ENSG00000186723.4",
      gene_id : "ENSG00000186723.4",
      gene_type : "protein_coding",
      gene_name : "OR10H1",
      gene_level : 2,
      hgnc_id : "HGNC:8172",
      havana_gene : "OTTHUMG00000182285.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15878023,
      stop : 15898077,
      direction : "-",
      ID : "ENSG00000186115.13",
      gene_id : "ENSG00000186115.13",
      gene_type : "protein_coding",
      gene_name : "CYP4F2",
      gene_level : 2,
      hgnc_id : "HGNC:2645",
      havana_gene : "OTTHUMG00000185995.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15912367,
      stop : 15934867,
      direction : "-",
      ID : "ENSG00000171903.16",
      gene_id : "ENSG00000171903.16",
      gene_type : "protein_coding",
      gene_name : "CYP4F11",
      gene_level : 2,
      hgnc_id : "HGNC:13265",
      havana_gene : "OTTHUMG00000182294.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 15944299,
      stop : 15950350,
      direction : "+",
      ID : "ENSG00000176231.2",
      gene_id : "ENSG00000176231.2",
      gene_type : "protein_coding",
      gene_name : "OR10H4",
      gene_level : 2,
      hgnc_id : "HGNC:15388",
      havana_gene : "OTTHUMG00000182268.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16067021,
      stop : 16103002,
      direction : "+",
      ID : "ENSG00000167460.17",
      gene_id : "ENSG00000167460.17",
      gene_type : "protein_coding",
      gene_name : "TPM4",
      gene_level : 1,
      hgnc_id : "HGNC:12013",
      havana_gene : "OTTHUMG00000182134.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16111889,
      stop : 16134234,
      direction : "+",
      ID : "ENSG00000167461.12",
      gene_id : "ENSG00000167461.12",
      gene_type : "protein_coding",
      gene_name : "RAB8A",
      gene_level : 2,
      hgnc_id : "HGNC:7007",
      havana_gene : "OTTHUMG00000182238.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16134028,
      stop : 16158575,
      direction : "+",
      ID : "ENSG00000196684.12",
      gene_id : "ENSG00000196684.12",
      gene_type : "protein_coding",
      gene_name : "HSH2D",
      gene_level : 2,
      hgnc_id : "HGNC:24920",
      havana_gene : "OTTHUMG00000182256.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16161368,
      stop : 16173525,
      direction : "-",
      ID : "ENSG00000141977.9",
      gene_id : "ENSG00000141977.9",
      gene_type : "protein_coding",
      gene_name : "CIB3",
      gene_level : 1,
      hgnc_id : "HGNC:24580",
      havana_gene : "OTTHUMG00000182281.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16185380,
      stop : 16192046,
      direction : "+",
      ID : "ENSG00000105058.12",
      gene_id : "ENSG00000105058.12",
      gene_type : "protein_coding",
      gene_name : "FAM32A",
      gene_level : 1,
      hgnc_id : "HGNC:24563",
      havana_gene : "OTTHUMG00000182279.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16197854,
      stop : 16245906,
      direction : "+",
      ID : "ENSG00000072958.9",
      gene_id : "ENSG00000072958.9",
      gene_type : "protein_coding",
      gene_name : "AP1M1",
      gene_level : 1,
      hgnc_id : "HGNC:13667",
      havana_gene : "OTTHUMG00000182323.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16324826,
      stop : 16328685,
      direction : "+",
      ID : "ENSG00000127528.6",
      gene_id : "ENSG00000127528.6",
      gene_type : "protein_coding",
      gene_name : "KLF2",
      gene_level : 2,
      hgnc_id : "HGNC:6347",
      havana_gene : "OTTHUMG00000182330.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16355239,
      stop : 16472085,
      direction : "-",
      ID : "ENSG00000127527.14",
      gene_id : "ENSG00000127527.14",
      gene_type : "protein_coding",
      gene_name : "EPS15L1",
      gene_level : 1,
      hgnc_id : "HGNC:24634",
      havana_gene : "OTTHUMG00000182361.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16479061,
      stop : 16496167,
      direction : "-",
      ID : "ENSG00000269058.6",
      gene_id : "ENSG00000269058.6",
      gene_type : "protein_coding",
      gene_name : "CALR3",
      gene_level : 1,
      hgnc_id : "HGNC:20407",
      havana_gene : "OTTHUMG00000152571.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16479067,
      stop : 16628204,
      direction : "-",
      ID : "ENSG00000141979.4",
      gene_id : "ENSG00000141979.4",
      gene_type : "protein_coding",
      gene_name : "AC008764.1",
      gene_level : 1,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000182419.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16496394,
      stop : 16521352,
      direction : "+",
      ID : "ENSG00000105072.9",
      gene_id : "ENSG00000105072.9",
      gene_type : "protein_coding",
      gene_name : "C19orf44",
      gene_level : 1,
      hgnc_id : "HGNC:26141",
      havana_gene : "OTTHUMG00000182439.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16517894,
      stop : 16542437,
      direction : "-",
      ID : "ENSG00000085872.15",
      gene_id : "ENSG00000085872.15",
      gene_type : "protein_coding",
      gene_name : "CHERP",
      gene_level : 1,
      hgnc_id : "HGNC:16930",
      havana_gene : "OTTHUMG00000169304.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16549831,
      stop : 16572415,
      direction : "-",
      ID : "ENSG00000127526.15",
      gene_id : "ENSG00000127526.15",
      gene_type : "protein_coding",
      gene_name : "SLC35E1",
      gene_level : 1,
      hgnc_id : "HGNC:20803",
      havana_gene : "OTTHUMG00000152575.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16574907,
      stop : 16629062,
      direction : "-",
      ID : "ENSG00000105085.11",
      gene_id : "ENSG00000105085.11",
      gene_type : "protein_coding",
      gene_name : "MED26",
      gene_level : 2,
      hgnc_id : "HGNC:2376",
      havana_gene : "OTTHUMG00000182433.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16577642,
      stop : 16660115,
      direction : "-",
      ID : "ENSG00000268790.5",
      gene_id : "ENSG00000268790.5",
      gene_type : "protein_coding",
      gene_name : "AC008764.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182632.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16630751,
      stop : 16660442,
      direction : "-",
      ID : "ENSG00000214046.9",
      gene_id : "ENSG00000214046.9",
      gene_type : "protein_coding",
      gene_name : "SMIM7",
      gene_level : 2,
      hgnc_id : "HGNC:28419",
      havana_gene : "OTTHUMG00000149895.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16661139,
      stop : 16690023,
      direction : "+",
      ID : "ENSG00000072954.7",
      gene_id : "ENSG00000072954.7",
      gene_type : "protein_coding",
      gene_name : "TMEM38A",
      gene_level : 2,
      hgnc_id : "HGNC:28462",
      havana_gene : "OTTHUMG00000182639.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16719847,
      stop : 16817963,
      direction : "+",
      ID : "ENSG00000188039.16",
      gene_id : "ENSG00000188039.16",
      gene_type : "protein_coding",
      gene_name : "NWD1",
      gene_level : 2,
      hgnc_id : "HGNC:27619",
      havana_gene : "OTTHUMG00000164507.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16829398,
      stop : 16880353,
      direction : "+",
      ID : "ENSG00000127511.10",
      gene_id : "ENSG00000127511.10",
      gene_type : "protein_coding",
      gene_name : "SIN3B",
      gene_level : 1,
      hgnc_id : "HGNC:19354",
      havana_gene : "OTTHUMG00000182642.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16888999,
      stop : 16892606,
      direction : "+",
      ID : "ENSG00000127533.4",
      gene_id : "ENSG00000127533.4",
      gene_type : "protein_coding",
      gene_name : "F2RL3",
      gene_level : 1,
      hgnc_id : "HGNC:3540",
      havana_gene : "OTTHUMG00000182647.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 16892951,
      stop : 17026815,
      direction : "-",
      ID : "ENSG00000160111.14",
      gene_id : "ENSG00000160111.14",
      gene_type : "protein_coding",
      gene_name : "CPAMD8",
      gene_level : 2,
      hgnc_id : "HGNC:23228",
      havana_gene : "OTTHUMG00000133549.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17049729,
      stop : 17075625,
      direction : "-",
      ID : "ENSG00000131351.15",
      gene_id : "ENSG00000131351.15",
      gene_type : "protein_coding",
      gene_name : "HAUS8",
      gene_level : 2,
      hgnc_id : "HGNC:30532",
      havana_gene : "OTTHUMG00000182672.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17075781,
      stop : 17214537,
      direction : "+",
      ID : "ENSG00000099331.13",
      gene_id : "ENSG00000099331.13",
      gene_type : "protein_coding",
      gene_name : "MYO9B",
      gene_level : 2,
      hgnc_id : "HGNC:7609",
      havana_gene : "OTTHUMG00000182707.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17215346,
      stop : 17219829,
      direction : "+",
      ID : "ENSG00000053501.13",
      gene_id : "ENSG00000053501.13",
      gene_type : "protein_coding",
      gene_name : "USE1",
      gene_level : 2,
      hgnc_id : "HGNC:30882",
      havana_gene : "OTTHUMG00000182723.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17226213,
      stop : 17229219,
      direction : "+",
      ID : "ENSG00000099330.9",
      gene_id : "ENSG00000099330.9",
      gene_type : "protein_coding",
      gene_name : "OCEL1",
      gene_level : 2,
      hgnc_id : "HGNC:26221",
      havana_gene : "OTTHUMG00000182726.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17231883,
      stop : 17245919,
      direction : "-",
      ID : "ENSG00000160113.6",
      gene_id : "ENSG00000160113.6",
      gene_type : "protein_coding",
      gene_name : "NR2F6",
      gene_level : 2,
      hgnc_id : "HGNC:7977",
      havana_gene : "OTTHUMG00000182728.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17235940,
      stop : 17255448,
      direction : "-",
      ID : "ENSG00000269095.1",
      gene_id : "ENSG00000269095.1",
      gene_type : "protein_coding",
      gene_name : "AC010646.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182729.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17249171,
      stop : 17282786,
      direction : "-",
      ID : "ENSG00000130307.12",
      gene_id : "ENSG00000130307.12",
      gene_type : "protein_coding",
      gene_name : "USHBP1",
      gene_level : 2,
      hgnc_id : "HGNC:24058",
      havana_gene : "OTTHUMG00000182730.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17267376,
      stop : 17281249,
      direction : "+",
      ID : "ENSG00000105393.16",
      gene_id : "ENSG00000105393.16",
      gene_type : "protein_coding",
      gene_name : "BABAM1",
      gene_level : 1,
      hgnc_id : "HGNC:25008",
      havana_gene : "OTTHUMG00000182755.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17267418,
      stop : 17282966,
      direction : "+",
      ID : "ENSG00000269307.1",
      gene_id : "ENSG00000269307.1",
      gene_type : "protein_coding",
      gene_name : "AC010463.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182756.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17281645,
      stop : 17287646,
      direction : "+",
      ID : "ENSG00000160117.16",
      gene_id : "ENSG00000160117.16",
      gene_type : "protein_coding",
      gene_name : "ANKLE1",
      gene_level : 1,
      hgnc_id : "HGNC:26812",
      havana_gene : "OTTHUMG00000150839.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17292131,
      stop : 17310236,
      direction : "-",
      ID : "ENSG00000127220.6",
      gene_id : "ENSG00000127220.6",
      gene_type : "protein_coding",
      gene_name : "ABHD8",
      gene_level : 1,
      hgnc_id : "HGNC:23759",
      havana_gene : "OTTHUMG00000182663.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17292609,
      stop : 17306843,
      direction : "+",
      ID : "ENSG00000130312.7",
      gene_id : "ENSG00000130312.7",
      gene_type : "protein_coding",
      gene_name : "MRPL34",
      gene_level : 2,
      hgnc_id : "HGNC:14488",
      havana_gene : "OTTHUMG00000182764.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17309518,
      stop : 17323298,
      direction : "+",
      ID : "ENSG00000130311.11",
      gene_id : "ENSG00000130311.11",
      gene_type : "protein_coding",
      gene_name : "DDA1",
      gene_level : 2,
      hgnc_id : "HGNC:28360",
      havana_gene : "OTTHUMG00000182765.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17323223,
      stop : 17334855,
      direction : "-",
      ID : "ENSG00000074855.11",
      gene_id : "ENSG00000074855.11",
      gene_type : "protein_coding",
      gene_name : "ANO8",
      gene_level : 2,
      hgnc_id : "HGNC:29329",
      havana_gene : "OTTHUMG00000182665.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17334920,
      stop : 17342731,
      direction : "+",
      ID : "ENSG00000130299.17",
      gene_id : "ENSG00000130299.17",
      gene_type : "protein_coding",
      gene_name : "GTPBP3",
      gene_level : 1,
      hgnc_id : "HGNC:14880",
      havana_gene : "OTTHUMG00000182766.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17351450,
      stop : 17377342,
      direction : "-",
      ID : "ENSG00000130300.9",
      gene_id : "ENSG00000130300.9",
      gene_type : "protein_coding",
      gene_name : "PLVAP",
      gene_level : 2,
      hgnc_id : "HGNC:13635",
      havana_gene : "OTTHUMG00000182784.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17390509,
      stop : 17394158,
      direction : "-",
      ID : "ENSG00000269720.2",
      gene_id : "ENSG00000269720.2",
      gene_type : "protein_coding",
      gene_name : "CCDC194",
      gene_level : 2,
      hgnc_id : "HGNC:53438",
      havana_gene : "OTTHUMG00000191663.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17402939,
      stop : 17405630,
      direction : "-",
      ID : "ENSG00000130303.14",
      gene_id : "ENSG00000130303.14",
      gene_type : "protein_coding",
      gene_name : "BST2",
      gene_level : 1,
      hgnc_id : "HGNC:1119",
      havana_gene : "OTTHUMG00000191770.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17405722,
      stop : 17433724,
      direction : "+",
      ID : "ENSG00000141971.13",
      gene_id : "ENSG00000141971.13",
      gene_type : "protein_coding",
      gene_name : "MVB12A",
      gene_level : 1,
      hgnc_id : "HGNC:25153",
      havana_gene : "OTTHUMG00000166252.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17435509,
      stop : 17448668,
      direction : "-",
      ID : "ENSG00000188051.7",
      gene_id : "ENSG00000188051.7",
      gene_type : "protein_coding",
      gene_name : "TMEM221",
      gene_level : 2,
      hgnc_id : "HGNC:21943",
      havana_gene : "OTTHUMG00000182858.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17436611,
      stop : 17460804,
      direction : "-",
      ID : "ENSG00000269035.1",
      gene_id : "ENSG00000269035.1",
      gene_type : "protein_coding",
      gene_name : "AC010319.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182859.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17455425,
      stop : 17460926,
      direction : "-",
      ID : "ENSG00000171773.3",
      gene_id : "ENSG00000171773.3",
      gene_type : "protein_coding",
      gene_name : "NXNL1",
      gene_level : 2,
      hgnc_id : "HGNC:25179",
      havana_gene : "OTTHUMG00000182798.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17468769,
      stop : 17506168,
      direction : "+",
      ID : "ENSG00000130304.17",
      gene_id : "ENSG00000130304.17",
      gene_type : "protein_coding",
      gene_name : "SLC27A1",
      gene_level : 1,
      hgnc_id : "HGNC:10995",
      havana_gene : "OTTHUMG00000182878.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17511636,
      stop : 17521288,
      direction : "+",
      ID : "ENSG00000130313.7",
      gene_id : "ENSG00000130313.7",
      gene_type : "protein_coding",
      gene_name : "PGLS",
      gene_level : 1,
      hgnc_id : "HGNC:8903",
      havana_gene : "OTTHUMG00000182879.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17523301,
      stop : 17553839,
      direction : "+",
      ID : "ENSG00000167483.19",
      gene_id : "ENSG00000167483.19",
      gene_type : "protein_coding",
      gene_name : "NIBAN3",
      gene_level : 1,
      hgnc_id : "HGNC:24130",
      havana_gene : "OTTHUMG00000182892.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17555649,
      stop : 17583162,
      direction : "+",
      ID : "ENSG00000130309.11",
      gene_id : "ENSG00000130309.11",
      gene_type : "protein_coding",
      gene_name : "COLGALT1",
      gene_level : 1,
      hgnc_id : "HGNC:26182",
      havana_gene : "OTTHUMG00000182893.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17601328,
      stop : 17688365,
      direction : "-",
      ID : "ENSG00000130477.15",
      gene_id : "ENSG00000130477.15",
      gene_type : "protein_coding",
      gene_name : "UNC13A",
      gene_level : 2,
      hgnc_id : "HGNC:23150",
      havana_gene : "OTTHUMG00000163877.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17719242,
      stop : 17734513,
      direction : "+",
      ID : "ENSG00000130479.11",
      gene_id : "ENSG00000130479.11",
      gene_type : "protein_coding",
      gene_name : "MAP1S",
      gene_level : 1,
      hgnc_id : "HGNC:15715",
      havana_gene : "OTTHUMG00000183292.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17747718,
      stop : 17788568,
      direction : "+",
      ID : "ENSG00000130475.14",
      gene_id : "ENSG00000130475.14",
      gene_type : "protein_coding",
      gene_name : "FCHO1",
      gene_level : 1,
      hgnc_id : "HGNC:29002",
      havana_gene : "OTTHUMG00000183293.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17794828,
      stop : 17813576,
      direction : "+",
      ID : "ENSG00000179913.11",
      gene_id : "ENSG00000179913.11",
      gene_type : "protein_coding",
      gene_name : "B3GNT3",
      gene_level : 2,
      hgnc_id : "HGNC:13528",
      havana_gene : "OTTHUMG00000183490.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17816512,
      stop : 17821574,
      direction : "-",
      ID : "ENSG00000248099.4",
      gene_id : "ENSG00000248099.4",
      gene_type : "protein_coding",
      gene_name : "INSL3",
      gene_level : 1,
      hgnc_id : "HGNC:6086",
      havana_gene : "OTTHUMG00000183481.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17824780,
      stop : 17848071,
      direction : "-",
      ID : "ENSG00000105639.20",
      gene_id : "ENSG00000105639.20",
      gene_type : "protein_coding",
      gene_name : "JAK3",
      gene_level : 2,
      hgnc_id : "HGNC:6193",
      havana_gene : "OTTHUMG00000165648.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17859910,
      stop : 17864153,
      direction : "+",
      ID : "ENSG00000105640.13",
      gene_id : "ENSG00000105640.13",
      gene_type : "protein_coding",
      gene_name : "RPL18A",
      gene_level : 1,
      hgnc_id : "HGNC:10311",
      havana_gene : "OTTHUMG00000183445.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17871945,
      stop : 17895174,
      direction : "+",
      ID : "ENSG00000105641.4",
      gene_id : "ENSG00000105641.4",
      gene_type : "protein_coding",
      gene_name : "SLC5A5",
      gene_level : 2,
      hgnc_id : "HGNC:11040",
      havana_gene : "OTTHUMG00000183447.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17933015,
      stop : 17943991,
      direction : "+",
      ID : "ENSG00000007080.11",
      gene_id : "ENSG00000007080.11",
      gene_type : "protein_coding",
      gene_name : "CCDC124",
      gene_level : 2,
      hgnc_id : "HGNC:25171",
      havana_gene : "OTTHUMG00000183405.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 17951293,
      stop : 18000080,
      direction : "+",
      ID : "ENSG00000105642.15",
      gene_id : "ENSG00000105642.15",
      gene_type : "protein_coding",
      gene_name : "KCNN1",
      gene_level : 2,
      hgnc_id : "HGNC:6290",
      havana_gene : "OTTHUMG00000183482.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18001132,
      stop : 18014102,
      direction : "+",
      ID : "ENSG00000105643.10",
      gene_id : "ENSG00000105643.10",
      gene_type : "protein_coding",
      gene_name : "ARRDC2",
      gene_level : 2,
      hgnc_id : "HGNC:25225",
      havana_gene : "OTTHUMG00000183483.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18058995,
      stop : 18098944,
      direction : "-",
      ID : "ENSG00000096996.16",
      gene_id : "ENSG00000096996.16",
      gene_type : "protein_coding",
      gene_name : "IL12RB1",
      gene_level : 2,
      hgnc_id : "HGNC:5971",
      havana_gene : "OTTHUMG00000183417.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18097793,
      stop : 18151692,
      direction : "+",
      ID : "ENSG00000099308.10",
      gene_id : "ENSG00000099308.10",
      gene_type : "protein_coding",
      gene_name : "MAST3",
      gene_level : 2,
      hgnc_id : "HGNC:19036",
      havana_gene : "OTTHUMG00000183418.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18153158,
      stop : 18178117,
      direction : "+",
      ID : "ENSG00000268173.3",
      gene_id : "ENSG00000268173.3",
      gene_type : "protein_coding",
      gene_name : "AC007192.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000150640.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18153163,
      stop : 18170532,
      direction : "+",
      ID : "ENSG00000105647.19",
      gene_id : "ENSG00000105647.19",
      gene_type : "protein_coding",
      gene_name : "PIK3R2",
      gene_level : 2,
      hgnc_id : "HGNC:8980",
      havana_gene : "OTTHUMG00000183383.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18173162,
      stop : 18178117,
      direction : "+",
      ID : "ENSG00000216490.4",
      gene_id : "ENSG00000216490.4",
      gene_type : "protein_coding",
      gene_name : "IFI30",
      gene_level : 2,
      hgnc_id : "HGNC:5398",
      havana_gene : "OTTHUMG00000183373.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18193218,
      stop : 18196948,
      direction : "+",
      ID : "ENSG00000254858.10",
      gene_id : "ENSG00000254858.10",
      gene_type : "protein_coding",
      gene_name : "MPV17L2",
      gene_level : 2,
      hgnc_id : "HGNC:28177",
      havana_gene : "OTTHUMG00000165628.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18196784,
      stop : 18204042,
      direction : "-",
      ID : "ENSG00000105649.10",
      gene_id : "ENSG00000105649.10",
      gene_type : "protein_coding",
      gene_name : "RAB3A",
      gene_level : 2,
      hgnc_id : "HGNC:9777",
      havana_gene : "OTTHUMG00000137378.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18207961,
      stop : 18255419,
      direction : "-",
      ID : "ENSG00000285188.1",
      gene_id : "ENSG00000285188.1",
      gene_type : "protein_coding",
      gene_name : "AC008397.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192476.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18208652,
      stop : 18248200,
      direction : "-",
      ID : "ENSG00000105650.22",
      gene_id : "ENSG00000105650.22",
      gene_type : "protein_coding",
      gene_name : "PDE4C",
      gene_level : 2,
      hgnc_id : "HGNC:8782",
      havana_gene : "OTTHUMG00000183353.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18249950,
      stop : 18255419,
      direction : "-",
      ID : "ENSG00000284797.1",
      gene_id : "ENSG00000284797.1",
      gene_type : "protein_coding",
      gene_name : "AC008397.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192481.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18257097,
      stop : 18274509,
      direction : "-",
      ID : "ENSG00000130518.17",
      gene_id : "ENSG00000130518.17",
      gene_type : "protein_coding",
      gene_name : "IQCN",
      gene_level : 2,
      hgnc_id : "HGNC:29350",
      havana_gene : "OTTHUMG00000183354.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18279694,
      stop : 18281622,
      direction : "-",
      ID : "ENSG00000130522.6",
      gene_id : "ENSG00000130522.6",
      gene_type : "protein_coding",
      gene_name : "JUND",
      gene_level : 2,
      hgnc_id : "HGNC:6206",
      havana_gene : "OTTHUMG00000183355.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18306236,
      stop : 18323112,
      direction : "-",
      ID : "ENSG00000130520.11",
      gene_id : "ENSG00000130520.11",
      gene_type : "protein_coding",
      gene_name : "LSM4",
      gene_level : 2,
      hgnc_id : "HGNC:17259",
      havana_gene : "OTTHUMG00000183357.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18340598,
      stop : 18369950,
      direction : "+",
      ID : "ENSG00000130517.14",
      gene_id : "ENSG00000130517.14",
      gene_type : "protein_coding",
      gene_name : "PGPEP1",
      gene_level : 1,
      hgnc_id : "HGNC:13568",
      havana_gene : "OTTHUMG00000183358.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18374731,
      stop : 18389176,
      direction : "+",
      ID : "ENSG00000130513.6",
      gene_id : "ENSG00000130513.6",
      gene_type : "protein_coding",
      gene_name : "GDF15",
      gene_level : 2,
      hgnc_id : "HGNC:30142",
      havana_gene : "OTTHUMG00000183360.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18391137,
      stop : 18397622,
      direction : "-",
      ID : "ENSG00000175489.10",
      gene_id : "ENSG00000175489.10",
      gene_type : "protein_coding",
      gene_name : "LRRC25",
      gene_level : 2,
      hgnc_id : "HGNC:29806",
      havana_gene : "OTTHUMG00000183361.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18418864,
      stop : 18434562,
      direction : "+",
      ID : "ENSG00000130511.16",
      gene_id : "ENSG00000130511.16",
      gene_type : "protein_coding",
      gene_name : "SSBP4",
      gene_level : 2,
      hgnc_id : "HGNC:15676",
      havana_gene : "OTTHUMG00000183362.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18434388,
      stop : 18438167,
      direction : "-",
      ID : "ENSG00000105655.19",
      gene_id : "ENSG00000105655.19",
      gene_type : "protein_coding",
      gene_name : "ISYNA1",
      gene_level : 1,
      hgnc_id : "HGNC:29821",
      havana_gene : "OTTHUMG00000179027.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18442663,
      stop : 18522116,
      direction : "-",
      ID : "ENSG00000105656.13",
      gene_id : "ENSG00000105656.13",
      gene_type : "protein_coding",
      gene_name : "ELL",
      gene_level : 2,
      hgnc_id : "HGNC:23114",
      havana_gene : "OTTHUMG00000183364.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18531751,
      stop : 18544077,
      direction : "-",
      ID : "ENSG00000105701.16",
      gene_id : "ENSG00000105701.16",
      gene_type : "protein_coding",
      gene_name : "FKBP8",
      gene_level : 1,
      hgnc_id : "HGNC:3724",
      havana_gene : "OTTHUMG00000183368.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18557762,
      stop : 18569387,
      direction : "+",
      ID : "ENSG00000105700.11",
      gene_id : "ENSG00000105700.11",
      gene_type : "protein_coding",
      gene_name : "KXD1",
      gene_level : 1,
      hgnc_id : "HGNC:28420",
      havana_gene : "OTTHUMG00000183107.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18571730,
      stop : 18577550,
      direction : "+",
      ID : "ENSG00000221983.8",
      gene_id : "ENSG00000221983.8",
      gene_type : "protein_coding",
      gene_name : "UBA52",
      gene_level : 2,
      hgnc_id : "HGNC:12458",
      havana_gene : "OTTHUMG00000183110.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18572220,
      stop : 18607741,
      direction : "-",
      ID : "ENSG00000006016.11",
      gene_id : "ENSG00000006016.11",
      gene_type : "protein_coding",
      gene_name : "CRLF1",
      gene_level : 2,
      hgnc_id : "HGNC:2364",
      havana_gene : "OTTHUMG00000183111.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18588685,
      stop : 18592337,
      direction : "+",
      ID : "ENSG00000006015.18",
      gene_id : "ENSG00000006015.18",
      gene_type : "protein_coding",
      gene_name : "REX1BD",
      gene_level : 1,
      hgnc_id : "HGNC:26098",
      havana_gene : "OTTHUMG00000183112.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18607430,
      stop : 18621039,
      direction : "+",
      ID : "ENSG00000105696.9",
      gene_id : "ENSG00000105696.9",
      gene_type : "protein_coding",
      gene_name : "TMEM59L",
      gene_level : 2,
      hgnc_id : "HGNC:13237",
      havana_gene : "OTTHUMG00000183113.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18637025,
      stop : 18671721,
      direction : "+",
      ID : "ENSG00000167487.12",
      gene_id : "ENSG00000167487.12",
      gene_type : "protein_coding",
      gene_name : "KLHL26",
      gene_level : 1,
      hgnc_id : "HGNC:25623",
      havana_gene : "OTTHUMG00000183114.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18683678,
      stop : 18782333,
      direction : "+",
      ID : "ENSG00000105662.16",
      gene_id : "ENSG00000105662.16",
      gene_type : "protein_coding",
      gene_name : "CRTC1",
      gene_level : 1,
      hgnc_id : "HGNC:16062",
      havana_gene : "OTTHUMG00000183115.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18782773,
      stop : 18791305,
      direction : "-",
      ID : "ENSG00000105664.11",
      gene_id : "ENSG00000105664.11",
      gene_type : "protein_coding",
      gene_name : "COMP",
      gene_level : 2,
      hgnc_id : "HGNC:2227",
      havana_gene : "OTTHUMG00000169318.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18831959,
      stop : 18868230,
      direction : "+",
      ID : "ENSG00000005007.13",
      gene_id : "ENSG00000005007.13",
      gene_type : "protein_coding",
      gene_name : "UPF1",
      gene_level : 2,
      hgnc_id : "HGNC:9962",
      havana_gene : "OTTHUMG00000183025.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18868545,
      stop : 18896158,
      direction : "-",
      ID : "ENSG00000130283.9",
      gene_id : "ENSG00000130283.9",
      gene_type : "protein_coding",
      gene_name : "GDF1",
      gene_level : 2,
      hgnc_id : "HGNC:4214",
      havana_gene : "OTTHUMG00000183278.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18868545,
      stop : 18896727,
      direction : "-",
      ID : "ENSG00000223802.8",
      gene_id : "ENSG00000223802.8",
      gene_type : "protein_coding",
      gene_name : "CERS1",
      gene_level : 1,
      hgnc_id : "HGNC:14253",
      havana_gene : "OTTHUMG00000183049.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18899514,
      stop : 18919387,
      direction : "-",
      ID : "ENSG00000105669.14",
      gene_id : "ENSG00000105669.14",
      gene_type : "protein_coding",
      gene_name : "COPE",
      gene_level : 2,
      hgnc_id : "HGNC:2234",
      havana_gene : "OTTHUMG00000183052.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18907013,
      stop : 18934397,
      direction : "-",
      ID : "ENSG00000268193.5",
      gene_id : "ENSG00000268193.5",
      gene_type : "protein_coding",
      gene_name : "AC002985.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182999.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18919705,
      stop : 18929189,
      direction : "+",
      ID : "ENSG00000105671.12",
      gene_id : "ENSG00000105671.12",
      gene_type : "protein_coding",
      gene_name : "DDX49",
      gene_level : 2,
      hgnc_id : "HGNC:18684",
      havana_gene : "OTTHUMG00000182994.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18929201,
      stop : 18941261,
      direction : "-",
      ID : "ENSG00000051128.19",
      gene_id : "ENSG00000051128.19",
      gene_type : "protein_coding",
      gene_name : "HOMER3",
      gene_level : 2,
      hgnc_id : "HGNC:17514",
      havana_gene : "OTTHUMG00000182995.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 18990888,
      stop : 19034023,
      direction : "-",
      ID : "ENSG00000064607.17",
      gene_id : "ENSG00000064607.17",
      gene_type : "protein_coding",
      gene_name : "SUGP2",
      gene_level : 2,
      hgnc_id : "HGNC:18641",
      havana_gene : "OTTHUMG00000182997.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19033575,
      stop : 19060311,
      direction : "+",
      ID : "ENSG00000105676.14",
      gene_id : "ENSG00000105676.14",
      gene_type : "protein_coding",
      gene_name : "ARMC6",
      gene_level : 1,
      hgnc_id : "HGNC:25049",
      havana_gene : "OTTHUMG00000169271.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19063994,
      stop : 19113030,
      direction : "+",
      ID : "ENSG00000181035.14",
      gene_id : "ENSG00000181035.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A42",
      gene_level : 2,
      hgnc_id : "HGNC:28380",
      havana_gene : "OTTHUMG00000183280.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19119169,
      stop : 19138513,
      direction : "-",
      ID : "ENSG00000064545.15",
      gene_id : "ENSG00000064545.15",
      gene_type : "protein_coding",
      gene_name : "TMEM161A",
      gene_level : 2,
      hgnc_id : "HGNC:26020",
      havana_gene : "OTTHUMG00000182217.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19145567,
      stop : 19192131,
      direction : "-",
      ID : "ENSG00000213999.17",
      gene_id : "ENSG00000213999.17",
      gene_type : "protein_coding",
      gene_name : "MEF2B",
      gene_level : 1,
      hgnc_id : "HGNC:6995",
      havana_gene : "OTTHUMG00000161595.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19145569,
      stop : 19192158,
      direction : "-",
      ID : "ENSG00000064489.23",
      gene_id : "ENSG00000064489.23",
      gene_type : "protein_coding",
      gene_name : "BORCS8-MEF2B",
      gene_level : 2,
      hgnc_id : "HGNC:39979",
      havana_gene : "OTTHUMG00000154572.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19176903,
      stop : 19192591,
      direction : "-",
      ID : "ENSG00000254901.8",
      gene_id : "ENSG00000254901.8",
      gene_type : "protein_coding",
      gene_name : "BORCS8",
      gene_level : 2,
      hgnc_id : "HGNC:37247",
      havana_gene : "OTTHUMG00000166546.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19192229,
      stop : 19201869,
      direction : "+",
      ID : "ENSG00000064490.14",
      gene_id : "ENSG00000064490.14",
      gene_type : "protein_coding",
      gene_name : "RFXANK",
      gene_level : 1,
      hgnc_id : "HGNC:9987",
      havana_gene : "OTTHUMG00000169224.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19201409,
      stop : 19203414,
      direction : "-",
      ID : "ENSG00000184162.15",
      gene_id : "ENSG00000184162.15",
      gene_type : "protein_coding",
      gene_name : "NR2C2AP",
      gene_level : 2,
      hgnc_id : "HGNC:30763",
      havana_gene : "OTTHUMG00000169225.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19211958,
      stop : 19252233,
      direction : "+",
      ID : "ENSG00000130287.14",
      gene_id : "ENSG00000130287.14",
      gene_type : "protein_coding",
      gene_name : "NCAN",
      gene_level : 1,
      hgnc_id : "HGNC:2465",
      havana_gene : "OTTHUMG00000182218.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19254756,
      stop : 19262804,
      direction : "-",
      ID : "ENSG00000187664.9",
      gene_id : "ENSG00000187664.9",
      gene_type : "protein_coding",
      gene_name : "HAPLN4",
      gene_level : 2,
      hgnc_id : "HGNC:31357",
      havana_gene : "OTTHUMG00000182221.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19264364,
      stop : 19273391,
      direction : "-",
      ID : "ENSG00000213996.13",
      gene_id : "ENSG00000213996.13",
      gene_type : "protein_coding",
      gene_name : "TM6SF2",
      gene_level : 2,
      hgnc_id : "HGNC:11861",
      havana_gene : "OTTHUMG00000182222.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19276018,
      stop : 19320509,
      direction : "-",
      ID : "ENSG00000105705.16",
      gene_id : "ENSG00000105705.16",
      gene_type : "protein_coding",
      gene_name : "SUGP1",
      gene_level : 2,
      hgnc_id : "HGNC:18643",
      havana_gene : "OTTHUMG00000182223.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19320829,
      stop : 19358754,
      direction : "+",
      ID : "ENSG00000129933.21",
      gene_id : "ENSG00000129933.21",
      gene_type : "protein_coding",
      gene_name : "MAU2",
      gene_level : 2,
      hgnc_id : "HGNC:29140",
      havana_gene : "OTTHUMG00000150188.14",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19385826,
      stop : 19508931,
      direction : "+",
      ID : "ENSG00000167491.17",
      gene_id : "ENSG00000167491.17",
      gene_type : "protein_coding",
      gene_name : "GATAD2A",
      gene_level : 1,
      hgnc_id : "HGNC:29989",
      havana_gene : "OTTHUMG00000152541.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19512418,
      stop : 19515548,
      direction : "-",
      ID : "ENSG00000178093.14",
      gene_id : "ENSG00000178093.14",
      gene_type : "protein_coding",
      gene_name : "TSSK6",
      gene_level : 2,
      hgnc_id : "HGNC:30410",
      havana_gene : "OTTHUMG00000182146.5",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19515736,
      stop : 19529054,
      direction : "+",
      ID : "ENSG00000186010.19",
      gene_id : "ENSG00000186010.19",
      gene_type : "protein_coding",
      gene_name : "NDUFA13",
      gene_level : 1,
      hgnc_id : "HGNC:17194",
      havana_gene : "OTTHUMG00000162211.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19516227,
      stop : 19536076,
      direction : "+",
      ID : "ENSG00000258674.5",
      gene_id : "ENSG00000258674.5",
      gene_type : "protein_coding",
      gene_name : "AC011448.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171813.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19528861,
      stop : 19537581,
      direction : "+",
      ID : "ENSG00000250067.12",
      gene_id : "ENSG00000250067.12",
      gene_type : "protein_coding",
      gene_name : "YJEFN3",
      gene_level : 2,
      hgnc_id : "HGNC:24785",
      havana_gene : "OTTHUMG00000162251.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19538248,
      stop : 19546659,
      direction : "+",
      ID : "ENSG00000160161.9",
      gene_id : "ENSG00000160161.9",
      gene_type : "protein_coding",
      gene_name : "CILP2",
      gene_level : 2,
      hgnc_id : "HGNC:24213",
      havana_gene : "OTTHUMG00000182148.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19561707,
      stop : 19618693,
      direction : "-",
      ID : "ENSG00000105717.14",
      gene_id : "ENSG00000105717.14",
      gene_type : "protein_coding",
      gene_name : "PBX4",
      gene_level : 2,
      hgnc_id : "HGNC:13403",
      havana_gene : "OTTHUMG00000172310.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19623655,
      stop : 19628930,
      direction : "-",
      ID : "ENSG00000064547.14",
      gene_id : "ENSG00000064547.14",
      gene_type : "protein_coding",
      gene_name : "LPAR2",
      gene_level : 2,
      hgnc_id : "HGNC:3168",
      havana_gene : "OTTHUMG00000182328.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19629476,
      stop : 19643657,
      direction : "-",
      ID : "ENSG00000089639.11",
      gene_id : "ENSG00000089639.11",
      gene_type : "protein_coding",
      gene_name : "GMIP",
      gene_level : 2,
      hgnc_id : "HGNC:24852",
      havana_gene : "OTTHUMG00000182329.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19645198,
      stop : 19663676,
      direction : "-",
      ID : "ENSG00000105726.17",
      gene_id : "ENSG00000105726.17",
      gene_type : "protein_coding",
      gene_name : "ATP13A1",
      gene_level : 2,
      hgnc_id : "HGNC:24215",
      havana_gene : "OTTHUMG00000153016.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19668796,
      stop : 19683509,
      direction : "+",
      ID : "ENSG00000181896.12",
      gene_id : "ENSG00000181896.12",
      gene_type : "protein_coding",
      gene_name : "ZNF101",
      gene_level : 2,
      hgnc_id : "HGNC:12881",
      havana_gene : "OTTHUMG00000167736.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19710472,
      stop : 19733112,
      direction : "-",
      ID : "ENSG00000105708.9",
      gene_id : "ENSG00000105708.9",
      gene_type : "protein_coding",
      gene_name : "ZNF14",
      gene_level : 2,
      hgnc_id : "HGNC:12924",
      havana_gene : "OTTHUMG00000182362.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19785839,
      stop : 19821751,
      direction : "-",
      ID : "ENSG00000081665.14",
      gene_id : "ENSG00000081665.14",
      gene_type : "protein_coding",
      gene_name : "ZNF506",
      gene_level : 1,
      hgnc_id : "HGNC:23780",
      havana_gene : "OTTHUMG00000182367.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19865882,
      stop : 19894674,
      direction : "+",
      ID : "ENSG00000256771.4",
      gene_id : "ENSG00000256771.4",
      gene_type : "protein_coding",
      gene_name : "ZNF253",
      gene_level : 1,
      hgnc_id : "HGNC:13497",
      havana_gene : "OTTHUMG00000182369.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19900913,
      stop : 19963464,
      direction : "+",
      ID : "ENSG00000184635.16",
      gene_id : "ENSG00000184635.16",
      gene_type : "protein_coding",
      gene_name : "ZNF93",
      gene_level : 1,
      hgnc_id : "HGNC:13169",
      havana_gene : "OTTHUMG00000182371.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 19997058,
      stop : 20039505,
      direction : "-",
      ID : "ENSG00000197124.12",
      gene_id : "ENSG00000197124.12",
      gene_type : "protein_coding",
      gene_name : "ZNF682",
      gene_level : 1,
      hgnc_id : "HGNC:28857",
      havana_gene : "OTTHUMG00000182650.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 20077994,
      stop : 20127076,
      direction : "+",
      ID : "ENSG00000213988.11",
      gene_id : "ENSG00000213988.11",
      gene_type : "protein_coding",
      gene_name : "ZNF90",
      gene_level : 2,
      hgnc_id : "HGNC:13165",
      havana_gene : "OTTHUMG00000158057.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 20167214,
      stop : 20200488,
      direction : "+",
      ID : "ENSG00000256229.8",
      gene_id : "ENSG00000256229.8",
      gene_type : "protein_coding",
      gene_name : "ZNF486",
      gene_level : 1,
      hgnc_id : "HGNC:20807",
      havana_gene : "OTTHUMG00000179731.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 20535825,
      stop : 20565809,
      direction : "-",
      ID : "ENSG00000237440.9",
      gene_id : "ENSG00000237440.9",
      gene_type : "protein_coding",
      gene_name : "ZNF737",
      gene_level : 1,
      hgnc_id : "HGNC:32468",
      havana_gene : "OTTHUMG00000179732.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 20619939,
      stop : 20661596,
      direction : "-",
      ID : "ENSG00000188171.16",
      gene_id : "ENSG00000188171.16",
      gene_type : "protein_coding",
      gene_name : "ZNF626",
      gene_level : 2,
      hgnc_id : "HGNC:30461",
      havana_gene : "OTTHUMG00000179733.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 20776304,
      stop : 20809995,
      direction : "+",
      ID : "ENSG00000160229.13",
      gene_id : "ENSG00000160229.13",
      gene_type : "protein_coding",
      gene_name : "ZNF66",
      gene_level : 1,
      hgnc_id : "HGNC:13135",
      havana_gene : "OTTHUMG00000167735.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 20923222,
      stop : 20950697,
      direction : "+",
      ID : "ENSG00000105750.15",
      gene_id : "ENSG00000105750.15",
      gene_type : "protein_coding",
      gene_name : "ZNF85",
      gene_level : 1,
      hgnc_id : "HGNC:13160",
      havana_gene : "OTTHUMG00000182747.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21020634,
      stop : 21060050,
      direction : "+",
      ID : "ENSG00000118620.13",
      gene_id : "ENSG00000118620.13",
      gene_type : "protein_coding",
      gene_name : "ZNF430",
      gene_level : 1,
      hgnc_id : "HGNC:20808",
      havana_gene : "OTTHUMG00000182771.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21082159,
      stop : 21125270,
      direction : "+",
      ID : "ENSG00000160352.16",
      gene_id : "ENSG00000160352.16",
      gene_type : "protein_coding",
      gene_name : "ZNF714",
      gene_level : 1,
      hgnc_id : "HGNC:27124",
      havana_gene : "OTTHUMG00000182833.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21142024,
      stop : 21196053,
      direction : "+",
      ID : "ENSG00000196705.8",
      gene_id : "ENSG00000196705.8",
      gene_type : "protein_coding",
      gene_name : "ZNF431",
      gene_level : 1,
      hgnc_id : "HGNC:20809",
      havana_gene : "OTTHUMG00000182835.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21291160,
      stop : 21329425,
      direction : "-",
      ID : "ENSG00000182141.10",
      gene_id : "ENSG00000182141.10",
      gene_type : "protein_coding",
      gene_name : "ZNF708",
      gene_level : 2,
      hgnc_id : "HGNC:12945",
      havana_gene : "OTTHUMG00000182841.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21358930,
      stop : 21379302,
      direction : "+",
      ID : "ENSG00000172687.13",
      gene_id : "ENSG00000172687.13",
      gene_type : "protein_coding",
      gene_name : "ZNF738",
      gene_level : 1,
      hgnc_id : "HGNC:32469",
      havana_gene : "OTTHUMG00000141298.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21397119,
      stop : 21427577,
      direction : "+",
      ID : "ENSG00000196268.12",
      gene_id : "ENSG00000196268.12",
      gene_type : "protein_coding",
      gene_name : "ZNF493",
      gene_level : 1,
      hgnc_id : "HGNC:23708",
      havana_gene : "OTTHUMG00000141297.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21405159,
      stop : 21491266,
      direction : "+",
      ID : "ENSG00000269237.1",
      gene_id : "ENSG00000269237.1",
      gene_type : "protein_coding",
      gene_name : "AC010615.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182845.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21496682,
      stop : 21556270,
      direction : "+",
      ID : "ENSG00000197013.10",
      gene_id : "ENSG00000197013.10",
      gene_type : "protein_coding",
      gene_name : "ZNF429",
      gene_level : 1,
      hgnc_id : "HGNC:20817",
      havana_gene : "OTTHUMG00000182848.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21722771,
      stop : 21767579,
      direction : "-",
      ID : "ENSG00000197020.11",
      gene_id : "ENSG00000197020.11",
      gene_type : "protein_coding",
      gene_name : "ZNF100",
      gene_level : 1,
      hgnc_id : "HGNC:12880",
      havana_gene : "OTTHUMG00000182872.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21804946,
      stop : 21852125,
      direction : "-",
      ID : "ENSG00000198521.12",
      gene_id : "ENSG00000198521.12",
      gene_type : "protein_coding",
      gene_name : "ZNF43",
      gene_level : 1,
      hgnc_id : "HGNC:13109",
      havana_gene : "OTTHUMG00000128543.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 21932958,
      stop : 22010949,
      direction : "-",
      ID : "ENSG00000160321.15",
      gene_id : "ENSG00000160321.15",
      gene_type : "protein_coding",
      gene_name : "ZNF208",
      gene_level : 2,
      hgnc_id : "HGNC:12999",
      havana_gene : "OTTHUMG00000182913.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22052430,
      stop : 22091480,
      direction : "+",
      ID : "ENSG00000197134.13",
      gene_id : "ENSG00000197134.13",
      gene_type : "protein_coding",
      gene_name : "ZNF257",
      gene_level : 1,
      hgnc_id : "HGNC:13498",
      havana_gene : "OTTHUMG00000182927.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22179089,
      stop : 22215801,
      direction : "-",
      ID : "ENSG00000196109.9",
      gene_id : "ENSG00000196109.9",
      gene_type : "protein_coding",
      gene_name : "ZNF676",
      gene_level : 2,
      hgnc_id : "HGNC:20429",
      havana_gene : "OTTHUMG00000182934.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22286441,
      stop : 22317176,
      direction : "+",
      ID : "ENSG00000196350.9",
      gene_id : "ENSG00000196350.9",
      gene_type : "protein_coding",
      gene_name : "ZNF729",
      gene_level : 2,
      hgnc_id : "HGNC:32464",
      havana_gene : "OTTHUMG00000182938.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22391019,
      stop : 22532485,
      direction : "-",
      ID : "ENSG00000197360.9",
      gene_id : "ENSG00000197360.9",
      gene_type : "protein_coding",
      gene_name : "ZNF98",
      gene_level : 1,
      hgnc_id : "HGNC:13174",
      havana_gene : "OTTHUMG00000182940.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22634324,
      stop : 22667671,
      direction : "+",
      ID : "ENSG00000229676.3",
      gene_id : "ENSG00000229676.3",
      gene_type : "protein_coding",
      gene_name : "ZNF492",
      gene_level : 2,
      hgnc_id : "HGNC:23707",
      havana_gene : "OTTHUMG00000182987.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22752183,
      stop : 22784151,
      direction : "-",
      ID : "ENSG00000213973.9",
      gene_id : "ENSG00000213973.9",
      gene_type : "protein_coding",
      gene_name : "ZNF99",
      gene_level : 2,
      hgnc_id : "HGNC:13175",
      havana_gene : "OTTHUMG00000182992.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22832291,
      stop : 22858667,
      direction : "+",
      ID : "ENSG00000268696.3",
      gene_id : "ENSG00000268696.3",
      gene_type : "protein_coding",
      gene_name : "ZNF723",
      gene_level : 2,
      hgnc_id : "HGNC:32286",
      havana_gene : "OTTHUMG00000183120.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 22974883,
      stop : 23003176,
      direction : "-",
      ID : "ENSG00000269067.2",
      gene_id : "ENSG00000269067.2",
      gene_type : "protein_coding",
      gene_name : "ZNF728",
      gene_level : 1,
      hgnc_id : "HGNC:32463",
      havana_gene : "OTTHUMG00000183124.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23075210,
      stop : 23147221,
      direction : "+",
      ID : "ENSG00000183850.14",
      gene_id : "ENSG00000183850.14",
      gene_type : "protein_coding",
      gene_name : "ZNF730",
      gene_level : 2,
      hgnc_id : "HGNC:32470",
      havana_gene : "OTTHUMG00000183227.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23221599,
      stop : 23250394,
      direction : "-",
      ID : "ENSG00000196081.10",
      gene_id : "ENSG00000196081.10",
      gene_type : "protein_coding",
      gene_name : "ZNF724",
      gene_level : 2,
      hgnc_id : "HGNC:32460",
      havana_gene : "OTTHUMG00000191860.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23222755,
      stop : 23274221,
      direction : "-",
      ID : "ENSG00000283201.1",
      gene_id : "ENSG00000283201.1",
      gene_type : "protein_coding",
      gene_name : "AC092329.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183231.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23304991,
      stop : 23395471,
      direction : "-",
      ID : "ENSG00000167232.14",
      gene_id : "ENSG00000167232.14",
      gene_type : "protein_coding",
      gene_name : "ZNF91",
      gene_level : 1,
      hgnc_id : "HGNC:13166",
      havana_gene : "OTTHUMG00000183268.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23525631,
      stop : 23687220,
      direction : "-",
      ID : "ENSG00000197372.10",
      gene_id : "ENSG00000197372.10",
      gene_type : "protein_coding",
      gene_name : "ZNF675",
      gene_level : 1,
      hgnc_id : "HGNC:30768",
      havana_gene : "OTTHUMG00000183384.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23739195,
      stop : 23758891,
      direction : "-",
      ID : "ENSG00000196172.9",
      gene_id : "ENSG00000196172.9",
      gene_type : "protein_coding",
      gene_name : "ZNF681",
      gene_level : 2,
      hgnc_id : "HGNC:26457",
      havana_gene : "OTTHUMG00000150831.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 23914876,
      stop : 23945159,
      direction : "+",
      ID : "ENSG00000213967.11",
      gene_id : "ENSG00000213967.11",
      gene_type : "protein_coding",
      gene_name : "ZNF726",
      gene_level : 1,
      hgnc_id : "HGNC:32462",
      havana_gene : "OTTHUMG00000167681.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 24033405,
      stop : 24129968,
      direction : "+",
      ID : "ENSG00000213096.11",
      gene_id : "ENSG00000213096.11",
      gene_type : "protein_coding",
      gene_name : "ZNF254",
      gene_level : 2,
      hgnc_id : "HGNC:13047",
      havana_gene : "OTTHUMG00000183394.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29205320,
      stop : 29213151,
      direction : "-",
      ID : "ENSG00000169021.6",
      gene_id : "ENSG00000169021.6",
      gene_type : "protein_coding",
      gene_name : "UQCRFS1",
      gene_level : 2,
      hgnc_id : "HGNC:12587",
      havana_gene : "OTTHUMG00000181997.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29526499,
      stop : 29564479,
      direction : "+",
      ID : "ENSG00000187135.7",
      gene_id : "ENSG00000187135.7",
      gene_type : "protein_coding",
      gene_name : "VSTM2B",
      gene_level : 2,
      hgnc_id : "HGNC:33595",
      havana_gene : "OTTHUMG00000182002.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29606283,
      stop : 29617237,
      direction : "+",
      ID : "ENSG00000105171.10",
      gene_id : "ENSG00000105171.10",
      gene_type : "protein_coding",
      gene_name : "POP4",
      gene_level : 2,
      hgnc_id : "HGNC:30081",
      havana_gene : "OTTHUMG00000182020.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29665459,
      stop : 29675477,
      direction : "+",
      ID : "ENSG00000166289.6",
      gene_id : "ENSG00000166289.6",
      gene_type : "protein_coding",
      gene_name : "PLEKHF1",
      gene_level : 2,
      hgnc_id : "HGNC:20764",
      havana_gene : "OTTHUMG00000182097.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29698886,
      stop : 29715789,
      direction : "-",
      ID : "ENSG00000131943.18",
      gene_id : "ENSG00000131943.18",
      gene_type : "protein_coding",
      gene_name : "C19orf12",
      gene_level : 1,
      hgnc_id : "HGNC:25443",
      havana_gene : "OTTHUMG00000149838.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29811991,
      stop : 29824312,
      direction : "+",
      ID : "ENSG00000105173.14",
      gene_id : "ENSG00000105173.14",
      gene_type : "protein_coding",
      gene_name : "CCNE1",
      gene_level : 1,
      hgnc_id : "HGNC:1589",
      havana_gene : "OTTHUMG00000177626.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 29923644,
      stop : 30016612,
      direction : "+",
      ID : "ENSG00000105176.18",
      gene_id : "ENSG00000105176.18",
      gene_type : "protein_coding",
      gene_name : "URI1",
      gene_level : 1,
      hgnc_id : "HGNC:13236",
      havana_gene : "OTTHUMG00000177923.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 30228290,
      stop : 30713538,
      direction : "+",
      ID : "ENSG00000198597.9",
      gene_id : "ENSG00000198597.9",
      gene_type : "protein_coding",
      gene_name : "ZNF536",
      gene_level : 2,
      hgnc_id : "HGNC:29025",
      havana_gene : "OTTHUMG00000182112.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 31149979,
      stop : 31349436,
      direction : "-",
      ID : "ENSG00000121297.8",
      gene_id : "ENSG00000121297.8",
      gene_type : "protein_coding",
      gene_name : "TSHZ3",
      gene_level : 2,
      hgnc_id : "HGNC:30700",
      havana_gene : "OTTHUMG00000150184.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32345594,
      stop : 32387667,
      direction : "+",
      ID : "ENSG00000168813.17",
      gene_id : "ENSG00000168813.17",
      gene_type : "protein_coding",
      gene_name : "ZNF507",
      gene_level : 2,
      hgnc_id : "HGNC:23783",
      havana_gene : "OTTHUMG00000180220.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32405543,
      stop : 32485895,
      direction : "+",
      ID : "ENSG00000178904.19",
      gene_id : "ENSG00000178904.19",
      gene_type : "protein_coding",
      gene_name : "DPY19L3",
      gene_level : 2,
      hgnc_id : "HGNC:27120",
      havana_gene : "OTTHUMG00000180222.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32581190,
      stop : 32587453,
      direction : "+",
      ID : "ENSG00000105185.12",
      gene_id : "ENSG00000105185.12",
      gene_type : "protein_coding",
      gene_name : "PDCD5",
      gene_level : 2,
      hgnc_id : "HGNC:8764",
      havana_gene : "OTTHUMG00000180224.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32597006,
      stop : 32676597,
      direction : "-",
      ID : "ENSG00000105186.16",
      gene_id : "ENSG00000105186.16",
      gene_type : "protein_coding",
      gene_name : "ANKRD27",
      gene_level : 1,
      hgnc_id : "HGNC:25310",
      havana_gene : "OTTHUMG00000180225.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32675848,
      stop : 32678300,
      direction : "+",
      ID : "ENSG00000186326.4",
      gene_id : "ENSG00000186326.4",
      gene_type : "protein_coding",
      gene_name : "RGS9BP",
      gene_level : 2,
      hgnc_id : "HGNC:30304",
      havana_gene : "OTTHUMG00000180227.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32691961,
      stop : 32713796,
      direction : "+",
      ID : "ENSG00000213965.3",
      gene_id : "ENSG00000213965.3",
      gene_type : "protein_coding",
      gene_name : "NUDT19",
      gene_level : 1,
      hgnc_id : "HGNC:32036",
      havana_gene : "OTTHUMG00000180228.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32719753,
      stop : 32829580,
      direction : "+",
      ID : "ENSG00000173809.18",
      gene_id : "ENSG00000173809.18",
      gene_type : "protein_coding",
      gene_name : "TDRD12",
      gene_level : 2,
      hgnc_id : "HGNC:25044",
      havana_gene : "OTTHUMG00000177230.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32830509,
      stop : 32869767,
      direction : "-",
      ID : "ENSG00000021488.13",
      gene_id : "ENSG00000021488.13",
      gene_type : "protein_coding",
      gene_name : "SLC7A9",
      gene_level : 2,
      hgnc_id : "HGNC:11067",
      havana_gene : "OTTHUMG00000180287.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32875925,
      stop : 32971991,
      direction : "-",
      ID : "ENSG00000121289.18",
      gene_id : "ENSG00000121289.18",
      gene_type : "protein_coding",
      gene_name : "CEP89",
      gene_level : 2,
      hgnc_id : "HGNC:25907",
      havana_gene : "OTTHUMG00000180424.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32972209,
      stop : 32978229,
      direction : "+",
      ID : "ENSG00000131944.10",
      gene_id : "ENSG00000131944.10",
      gene_type : "protein_coding",
      gene_name : "FAAP24",
      gene_level : 1,
      hgnc_id : "HGNC:28467",
      havana_gene : "OTTHUMG00000180339.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 32978592,
      stop : 33064888,
      direction : "-",
      ID : "ENSG00000131941.8",
      gene_id : "ENSG00000131941.8",
      gene_type : "protein_coding",
      gene_name : "RHPN2",
      gene_level : 2,
      hgnc_id : "HGNC:19974",
      havana_gene : "OTTHUMG00000180340.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33080899,
      stop : 33130542,
      direction : "+",
      ID : "ENSG00000076650.7",
      gene_id : "ENSG00000076650.7",
      gene_type : "protein_coding",
      gene_name : "GPATCH1",
      gene_level : 2,
      hgnc_id : "HGNC:24658",
      havana_gene : "OTTHUMG00000180341.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33132090,
      stop : 33175799,
      direction : "+",
      ID : "ENSG00000166359.11",
      gene_id : "ENSG00000166359.11",
      gene_type : "protein_coding",
      gene_name : "WDR88",
      gene_level : 2,
      hgnc_id : "HGNC:26999",
      havana_gene : "OTTHUMG00000180342.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33177603,
      stop : 33208864,
      direction : "+",
      ID : "ENSG00000130881.14",
      gene_id : "ENSG00000130881.14",
      gene_type : "protein_coding",
      gene_name : "LRP3",
      gene_level : 2,
      hgnc_id : "HGNC:6695",
      havana_gene : "OTTHUMG00000180343.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33208664,
      stop : 33225850,
      direction : "-",
      ID : "ENSG00000130876.11",
      gene_id : "ENSG00000130876.11",
      gene_type : "protein_coding",
      gene_name : "SLC7A10",
      gene_level : 2,
      hgnc_id : "HGNC:11058",
      havana_gene : "OTTHUMG00000180344.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33299934,
      stop : 33302534,
      direction : "-",
      ID : "ENSG00000245848.3",
      gene_id : "ENSG00000245848.3",
      gene_type : "protein_coding",
      gene_name : "CEBPA",
      gene_level : 2,
      hgnc_id : "HGNC:1833",
      havana_gene : "OTTHUMG00000161461.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33373685,
      stop : 33382686,
      direction : "+",
      ID : "ENSG00000153879.9",
      gene_id : "ENSG00000153879.9",
      gene_type : "protein_coding",
      gene_name : "CEBPG",
      gene_level : 2,
      hgnc_id : "HGNC:1837",
      havana_gene : "OTTHUMG00000180469.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33386950,
      stop : 33521791,
      direction : "-",
      ID : "ENSG00000124299.15",
      gene_id : "ENSG00000124299.15",
      gene_type : "protein_coding",
      gene_name : "PEPD",
      gene_level : 1,
      hgnc_id : "HGNC:8840",
      havana_gene : "OTTHUMG00000180470.17",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33621953,
      stop : 33773509,
      direction : "+",
      ID : "ENSG00000124302.13",
      gene_id : "ENSG00000124302.13",
      gene_type : "protein_coding",
      gene_name : "CHST8",
      gene_level : 2,
      hgnc_id : "HGNC:15993",
      havana_gene : "OTTHUMG00000180472.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 33795933,
      stop : 33815763,
      direction : "+",
      ID : "ENSG00000153885.14",
      gene_id : "ENSG00000153885.14",
      gene_type : "protein_coding",
      gene_name : "KCTD15",
      gene_level : 2,
      hgnc_id : "HGNC:23297",
      havana_gene : "OTTHUMG00000180475.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34172504,
      stop : 34229288,
      direction : "+",
      ID : "ENSG00000257103.9",
      gene_id : "ENSG00000257103.9",
      gene_type : "protein_coding",
      gene_name : "LSM14A",
      gene_level : 1,
      hgnc_id : "HGNC:24489",
      havana_gene : "OTTHUMG00000180491.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34254552,
      stop : 34355566,
      direction : "+",
      ID : "ENSG00000166398.14",
      gene_id : "ENSG00000166398.14",
      gene_type : "protein_coding",
      gene_name : "GARRE1",
      gene_level : 2,
      hgnc_id : "HGNC:29016",
      havana_gene : "OTTHUMG00000180505.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34359480,
      stop : 34402413,
      direction : "+",
      ID : "ENSG00000105220.17",
      gene_id : "ENSG00000105220.17",
      gene_type : "protein_coding",
      gene_name : "GPI",
      gene_level : 2,
      hgnc_id : "HGNC:4458",
      havana_gene : "OTTHUMG00000182087.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34396315,
      stop : 34409364,
      direction : "+",
      ID : "ENSG00000266953.6",
      gene_id : "ENSG00000266953.6",
      gene_type : "protein_coding",
      gene_name : "AC092073.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182250.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34404399,
      stop : 34426168,
      direction : "+",
      ID : "ENSG00000126249.8",
      gene_id : "ENSG00000126249.8",
      gene_type : "protein_coding",
      gene_name : "PDCD2L",
      gene_level : 1,
      hgnc_id : "HGNC:28194",
      havana_gene : "OTTHUMG00000182089.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34428352,
      stop : 34471251,
      direction : "+",
      ID : "ENSG00000126261.13",
      gene_id : "ENSG00000126261.13",
      gene_type : "protein_coding",
      gene_name : "UBA2",
      gene_level : 2,
      hgnc_id : "HGNC:30661",
      havana_gene : "OTTHUMG00000182090.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34481758,
      stop : 34512304,
      direction : "+",
      ID : "ENSG00000142279.13",
      gene_id : "ENSG00000142279.13",
      gene_type : "protein_coding",
      gene_name : "WTIP",
      gene_level : 2,
      hgnc_id : "HGNC:20964",
      havana_gene : "OTTHUMG00000182099.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34593329,
      stop : 34675699,
      direction : "-",
      ID : "ENSG00000205209.7",
      gene_id : "ENSG00000205209.7",
      gene_type : "protein_coding",
      gene_name : "SCGB2B2",
      gene_level : 2,
      hgnc_id : "HGNC:27616",
      havana_gene : "OTTHUMG00000182463.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34677639,
      stop : 34686397,
      direction : "+",
      ID : "ENSG00000089335.21",
      gene_id : "ENSG00000089335.21",
      gene_type : "protein_coding",
      gene_name : "ZNF302",
      gene_level : 1,
      hgnc_id : "HGNC:13848",
      havana_gene : "OTTHUMG00000163329.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34734155,
      stop : 34745378,
      direction : "+",
      ID : "ENSG00000197841.15",
      gene_id : "ENSG00000197841.15",
      gene_type : "protein_coding",
      gene_name : "ZNF181",
      gene_level : 1,
      hgnc_id : "HGNC:12971",
      havana_gene : "OTTHUMG00000157508.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34758073,
      stop : 34773229,
      direction : "-",
      ID : "ENSG00000153896.19",
      gene_id : "ENSG00000153896.19",
      gene_type : "protein_coding",
      gene_name : "ZNF599",
      gene_level : 2,
      hgnc_id : "HGNC:26408",
      havana_gene : "OTTHUMG00000182346.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34926903,
      stop : 34945170,
      direction : "+",
      ID : "ENSG00000168661.15",
      gene_id : "ENSG00000168661.15",
      gene_type : "protein_coding",
      gene_name : "ZNF30",
      gene_level : 2,
      hgnc_id : "HGNC:13090",
      havana_gene : "OTTHUMG00000182960.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34956354,
      stop : 34964229,
      direction : "-",
      ID : "ENSG00000180884.10",
      gene_id : "ENSG00000180884.10",
      gene_type : "protein_coding",
      gene_name : "ZNF792",
      gene_level : 2,
      hgnc_id : "HGNC:24751",
      havana_gene : "OTTHUMG00000150339.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 34994784,
      stop : 35026471,
      direction : "+",
      ID : "ENSG00000089351.15",
      gene_id : "ENSG00000089351.15",
      gene_type : "protein_coding",
      gene_name : "GRAMD1A",
      gene_level : 1,
      hgnc_id : "HGNC:29305",
      havana_gene : "OTTHUMG00000182464.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35030470,
      stop : 35040449,
      direction : "+",
      ID : "ENSG00000105711.13",
      gene_id : "ENSG00000105711.13",
      gene_type : "protein_coding",
      gene_name : "SCN1B",
      gene_level : 2,
      hgnc_id : "HGNC:10586",
      havana_gene : "OTTHUMG00000182472.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35040506,
      stop : 35066573,
      direction : "+",
      ID : "ENSG00000105707.15",
      gene_id : "ENSG00000105707.15",
      gene_type : "protein_coding",
      gene_name : "HPN",
      gene_level : 1,
      hgnc_id : "HGNC:5155",
      havana_gene : "OTTHUMG00000182474.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35106510,
      stop : 35124297,
      direction : "+",
      ID : "ENSG00000285526.1",
      gene_id : "ENSG00000285526.1",
      gene_type : "protein_coding",
      gene_name : "AC020907.6",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193383.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35115879,
      stop : 35124324,
      direction : "+",
      ID : "ENSG00000089356.18",
      gene_id : "ENSG00000089356.18",
      gene_type : "protein_coding",
      gene_name : "FXYD3",
      gene_level : 2,
      hgnc_id : "HGNC:4027",
      havana_gene : "OTTHUMG00000184625.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35124513,
      stop : 35142451,
      direction : "-",
      ID : "ENSG00000153902.14",
      gene_id : "ENSG00000153902.14",
      gene_type : "protein_coding",
      gene_name : "LGI4",
      gene_level : 2,
      hgnc_id : "HGNC:18712",
      havana_gene : "OTTHUMG00000044558.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35138824,
      stop : 35143109,
      direction : "+",
      ID : "ENSG00000266964.6",
      gene_id : "ENSG00000266964.6",
      gene_type : "protein_coding",
      gene_name : "FXYD1",
      gene_level : 2,
      hgnc_id : "HGNC:4025",
      havana_gene : "OTTHUMG00000182359.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35143250,
      stop : 35154302,
      direction : "+",
      ID : "ENSG00000221946.8",
      gene_id : "ENSG00000221946.8",
      gene_type : "protein_coding",
      gene_name : "FXYD7",
      gene_level : 2,
      hgnc_id : "HGNC:4034",
      havana_gene : "OTTHUMG00000182348.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35154730,
      stop : 35169881,
      direction : "+",
      ID : "ENSG00000089327.15",
      gene_id : "ENSG00000089327.15",
      gene_type : "protein_coding",
      gene_name : "FXYD5",
      gene_level : 1,
      hgnc_id : "HGNC:4029",
      havana_gene : "OTTHUMG00000048092.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35224800,
      stop : 35228729,
      direction : "-",
      ID : "ENSG00000177558.3",
      gene_id : "ENSG00000177558.3",
      gene_type : "protein_coding",
      gene_name : "FAM187B",
      gene_level : 2,
      hgnc_id : "HGNC:26366",
      havana_gene : "OTTHUMG00000164450.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35248330,
      stop : 35267964,
      direction : "+",
      ID : "ENSG00000105699.17",
      gene_id : "ENSG00000105699.17",
      gene_type : "protein_coding",
      gene_name : "LSR",
      gene_level : 1,
      hgnc_id : "HGNC:29572",
      havana_gene : "OTTHUMG00000183142.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35268962,
      stop : 35279821,
      direction : "+",
      ID : "ENSG00000105698.16",
      gene_id : "ENSG00000105698.16",
      gene_type : "protein_coding",
      gene_name : "USF2",
      gene_level : 2,
      hgnc_id : "HGNC:12594",
      havana_gene : "OTTHUMG00000183182.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35280716,
      stop : 35285143,
      direction : "+",
      ID : "ENSG00000105697.9",
      gene_id : "ENSG00000105697.9",
      gene_type : "protein_coding",
      gene_name : "HAMP",
      gene_level : 2,
      hgnc_id : "HGNC:15598",
      havana_gene : "OTTHUMG00000183295.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35292125,
      stop : 35313807,
      direction : "+",
      ID : "ENSG00000105695.15",
      gene_id : "ENSG00000105695.15",
      gene_type : "protein_coding",
      gene_name : "MAG",
      gene_level : 2,
      hgnc_id : "HGNC:6783",
      havana_gene : "OTTHUMG00000183296.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35319261,
      stop : 35347361,
      direction : "+",
      ID : "ENSG00000012124.17",
      gene_id : "ENSG00000012124.17",
      gene_type : "protein_coding",
      gene_name : "CD22",
      gene_level : 1,
      hgnc_id : "HGNC:1643",
      havana_gene : "OTTHUMG00000183298.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35351552,
      stop : 35353862,
      direction : "+",
      ID : "ENSG00000126266.3",
      gene_id : "ENSG00000126266.3",
      gene_type : "protein_coding",
      gene_name : "FFAR1",
      gene_level : 2,
      hgnc_id : "HGNC:4498",
      havana_gene : "OTTHUMG00000188261.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35358460,
      stop : 35360489,
      direction : "+",
      ID : "ENSG00000185897.7",
      gene_id : "ENSG00000185897.7",
      gene_type : "protein_coding",
      gene_name : "FFAR3",
      gene_level : 2,
      hgnc_id : "HGNC:4499",
      havana_gene : "OTTHUMG00000172514.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35370929,
      stop : 35372962,
      direction : "+",
      ID : "ENSG00000126251.6",
      gene_id : "ENSG00000126251.6",
      gene_type : "protein_coding",
      gene_name : "GPR42",
      gene_level : 2,
      hgnc_id : "HGNC:4500",
      havana_gene : "OTTHUMG00000157124.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35443907,
      stop : 35451767,
      direction : "+",
      ID : "ENSG00000126262.5",
      gene_id : "ENSG00000126262.5",
      gene_type : "protein_coding",
      gene_name : "FFAR2",
      gene_level : 2,
      hgnc_id : "HGNC:4501",
      havana_gene : "OTTHUMG00000183303.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35487324,
      stop : 35495558,
      direction : "-",
      ID : "ENSG00000188508.11",
      gene_id : "ENSG00000188508.11",
      gene_type : "protein_coding",
      gene_name : "KRTDAP",
      gene_level : 2,
      hgnc_id : "HGNC:16313",
      havana_gene : "OTTHUMG00000155449.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35497220,
      stop : 35513658,
      direction : "-",
      ID : "ENSG00000161249.21",
      gene_id : "ENSG00000161249.21",
      gene_type : "protein_coding",
      gene_name : "DMKN",
      gene_level : 2,
      hgnc_id : "HGNC:25063",
      havana_gene : "OTTHUMG00000048101.18",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35523367,
      stop : 35528351,
      direction : "-",
      ID : "ENSG00000189001.11",
      gene_id : "ENSG00000189001.11",
      gene_type : "protein_coding",
      gene_name : "SBSN",
      gene_level : 2,
      hgnc_id : "HGNC:24950",
      havana_gene : "OTTHUMG00000048102.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35533455,
      stop : 35545319,
      direction : "+",
      ID : "ENSG00000105679.9",
      gene_id : "ENSG00000105679.9",
      gene_type : "protein_coding",
      gene_name : "GAPDHS",
      gene_level : 2,
      hgnc_id : "HGNC:24864",
      havana_gene : "OTTHUMG00000182298.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35545600,
      stop : 35547526,
      direction : "+",
      ID : "ENSG00000105677.12",
      gene_id : "ENSG00000105677.12",
      gene_type : "protein_coding",
      gene_name : "TMEM147",
      gene_level : 2,
      hgnc_id : "HGNC:30414",
      havana_gene : "OTTHUMG00000048105.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35550031,
      stop : 35563658,
      direction : "-",
      ID : "ENSG00000105675.9",
      gene_id : "ENSG00000105675.9",
      gene_type : "protein_coding",
      gene_name : "ATP4A",
      gene_level : 2,
      hgnc_id : "HGNC:819",
      havana_gene : "OTTHUMG00000048106.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35586161,
      stop : 35587296,
      direction : "+",
      ID : "ENSG00000283758.2",
      gene_id : "ENSG00000283758.2",
      gene_type : "protein_coding",
      gene_name : "PMIS2",
      gene_level : 2,
      hgnc_id : "HGNC:53649",
      havana_gene : "OTTHUMG00000191909.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35612735,
      stop : 35625355,
      direction : "+",
      ID : "ENSG00000249115.9",
      gene_id : "ENSG00000249115.9",
      gene_type : "protein_coding",
      gene_name : "HAUS5",
      gene_level : 2,
      hgnc_id : "HGNC:29130",
      havana_gene : "OTTHUMG00000048110.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35629030,
      stop : 35637686,
      direction : "+",
      ID : "ENSG00000126254.12",
      gene_id : "ENSG00000126254.12",
      gene_type : "protein_coding",
      gene_name : "RBM42",
      gene_level : 2,
      hgnc_id : "HGNC:28117",
      havana_gene : "OTTHUMG00000182063.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35641745,
      stop : 35644871,
      direction : "+",
      ID : "ENSG00000105672.14",
      gene_id : "ENSG00000105672.14",
      gene_type : "protein_coding",
      gene_name : "ETV2",
      gene_level : 2,
      hgnc_id : "HGNC:3491",
      havana_gene : "OTTHUMG00000150545.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35648323,
      stop : 35658782,
      direction : "+",
      ID : "ENSG00000126267.11",
      gene_id : "ENSG00000126267.11",
      gene_type : "protein_coding",
      gene_name : "COX6B1",
      gene_level : 1,
      hgnc_id : "HGNC:2280",
      havana_gene : "OTTHUMG00000048112.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35666516,
      stop : 35678483,
      direction : "+",
      ID : "ENSG00000105668.7",
      gene_id : "ENSG00000105668.7",
      gene_type : "protein_coding",
      gene_name : "UPK1A",
      gene_level : 2,
      hgnc_id : "HGNC:12577",
      havana_gene : "OTTHUMG00000048115.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35704558,
      stop : 35717038,
      direction : "+",
      ID : "ENSG00000011590.14",
      gene_id : "ENSG00000011590.14",
      gene_type : "protein_coding",
      gene_name : "ZBTB32",
      gene_level : 1,
      hgnc_id : "HGNC:16763",
      havana_gene : "OTTHUMG00000048118.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35717973,
      stop : 35738878,
      direction : "+",
      ID : "ENSG00000272333.7",
      gene_id : "ENSG00000272333.7",
      gene_type : "protein_coding",
      gene_name : "KMT2B",
      gene_level : 2,
      hgnc_id : "HGNC:15840",
      havana_gene : "OTTHUMG00000048119.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35738801,
      stop : 35742453,
      direction : "-",
      ID : "ENSG00000126246.10",
      gene_id : "ENSG00000126246.10",
      gene_type : "protein_coding",
      gene_name : "IGFLR1",
      gene_level : 1,
      hgnc_id : "HGNC:23620",
      havana_gene : "OTTHUMG00000182064.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35739252,
      stop : 35745432,
      direction : "-",
      ID : "ENSG00000267120.3",
      gene_id : "ENSG00000267120.3",
      gene_type : "protein_coding",
      gene_name : "AD000671.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182065.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35742464,
      stop : 35745445,
      direction : "-",
      ID : "ENSG00000161265.15",
      gene_id : "ENSG00000161265.15",
      gene_type : "protein_coding",
      gene_name : "U2AF1L4",
      gene_level : 2,
      hgnc_id : "HGNC:23020",
      havana_gene : "OTTHUMG00000182066.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35745600,
      stop : 35747519,
      direction : "+",
      ID : "ENSG00000205155.8",
      gene_id : "ENSG00000205155.8",
      gene_type : "protein_coding",
      gene_name : "PSENEN",
      gene_level : 2,
      hgnc_id : "HGNC:30100",
      havana_gene : "OTTHUMG00000182067.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35745678,
      stop : 35754519,
      direction : "+",
      ID : "ENSG00000188223.9",
      gene_id : "ENSG00000188223.9",
      gene_type : "protein_coding",
      gene_name : "AD000671.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182068.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35748361,
      stop : 35754519,
      direction : "+",
      ID : "ENSG00000267796.8",
      gene_id : "ENSG00000267796.8",
      gene_type : "protein_coding",
      gene_name : "LIN37",
      gene_level : 1,
      hgnc_id : "HGNC:33234",
      havana_gene : "OTTHUMG00000182070.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35754566,
      stop : 35758079,
      direction : "-",
      ID : "ENSG00000004776.13",
      gene_id : "ENSG00000004776.13",
      gene_type : "protein_coding",
      gene_name : "HSPB6",
      gene_level : 2,
      hgnc_id : "HGNC:26511",
      havana_gene : "OTTHUMG00000048122.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35758143,
      stop : 35771028,
      direction : "+",
      ID : "ENSG00000167595.15",
      gene_id : "ENSG00000167595.15",
      gene_type : "protein_coding",
      gene_name : "PROSER3",
      gene_level : 2,
      hgnc_id : "HGNC:25204",
      havana_gene : "OTTHUMG00000168103.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35774532,
      stop : 35788822,
      direction : "+",
      ID : "ENSG00000004777.18",
      gene_id : "ENSG00000004777.18",
      gene_type : "protein_coding",
      gene_name : "ARHGAP33",
      gene_level : 1,
      hgnc_id : "HGNC:23085",
      havana_gene : "OTTHUMG00000182071.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35799988,
      stop : 35813299,
      direction : "-",
      ID : "ENSG00000250799.11",
      gene_id : "ENSG00000250799.11",
      gene_type : "protein_coding",
      gene_name : "PRODH2",
      gene_level : 1,
      hgnc_id : "HGNC:17325",
      havana_gene : "OTTHUMG00000180688.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35825372,
      stop : 35869287,
      direction : "-",
      ID : "ENSG00000161270.20",
      gene_id : "ENSG00000161270.20",
      gene_type : "protein_coding",
      gene_name : "NPHS1",
      gene_level : 2,
      hgnc_id : "HGNC:7908",
      havana_gene : "OTTHUMG00000180689.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35855861,
      stop : 35867136,
      direction : "+",
      ID : "ENSG00000126259.20",
      gene_id : "ENSG00000126259.20",
      gene_type : "protein_coding",
      gene_name : "KIRREL2",
      gene_level : 2,
      hgnc_id : "HGNC:18816",
      havana_gene : "OTTHUMG00000180691.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35867899,
      stop : 35879792,
      direction : "+",
      ID : "ENSG00000105290.13",
      gene_id : "ENSG00000105290.13",
      gene_type : "protein_coding",
      gene_name : "APLP1",
      gene_level : 2,
      hgnc_id : "HGNC:597",
      havana_gene : "OTTHUMG00000180692.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35887653,
      stop : 35902303,
      direction : "-",
      ID : "ENSG00000167604.15",
      gene_id : "ENSG00000167604.15",
      gene_type : "protein_coding",
      gene_name : "NFKBID",
      gene_level : 1,
      hgnc_id : "HGNC:15671",
      havana_gene : "OTTHUMG00000180760.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35902529,
      stop : 35904377,
      direction : "+",
      ID : "ENSG00000126264.10",
      gene_id : "ENSG00000126264.10",
      gene_type : "protein_coding",
      gene_name : "HCST",
      gene_level : 2,
      hgnc_id : "HGNC:16977",
      havana_gene : "OTTHUMG00000048132.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35904401,
      stop : 35908295,
      direction : "-",
      ID : "ENSG00000011600.12",
      gene_id : "ENSG00000011600.12",
      gene_type : "protein_coding",
      gene_name : "TYROBP",
      gene_level : 2,
      hgnc_id : "HGNC:12449",
      havana_gene : "OTTHUMG00000181739.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35935358,
      stop : 35946624,
      direction : "+",
      ID : "ENSG00000126243.9",
      gene_id : "ENSG00000126243.9",
      gene_type : "protein_coding",
      gene_name : "LRFN3",
      gene_level : 2,
      hgnc_id : "HGNC:28370",
      havana_gene : "OTTHUMG00000181740.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 35995188,
      stop : 35996312,
      direction : "+",
      ID : "ENSG00000205138.4",
      gene_id : "ENSG00000205138.4",
      gene_type : "protein_coding",
      gene_name : "SDHAF1",
      gene_level : 2,
      hgnc_id : "HGNC:33867",
      havana_gene : "OTTHUMG00000181745.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36003307,
      stop : 36008813,
      direction : "-",
      ID : "ENSG00000181392.17",
      gene_id : "ENSG00000181392.17",
      gene_type : "protein_coding",
      gene_name : "SYNE4",
      gene_level : 1,
      hgnc_id : "HGNC:26703",
      havana_gene : "OTTHUMG00000048135.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36009120,
      stop : 36014239,
      direction : "-",
      ID : "ENSG00000239382.10",
      gene_id : "ENSG00000239382.10",
      gene_type : "protein_coding",
      gene_name : "ALKBH6",
      gene_level : 2,
      hgnc_id : "HGNC:28243",
      havana_gene : "OTTHUMG00000048137.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36014660,
      stop : 36033343,
      direction : "-",
      ID : "ENSG00000105270.15",
      gene_id : "ENSG00000105270.15",
      gene_type : "protein_coding",
      gene_name : "CLIP3",
      gene_level : 2,
      hgnc_id : "HGNC:24314",
      havana_gene : "OTTHUMG00000181747.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36034984,
      stop : 36054739,
      direction : "-",
      ID : "ENSG00000161277.11",
      gene_id : "ENSG00000161277.11",
      gene_type : "protein_coding",
      gene_name : "THAP8",
      gene_level : 1,
      hgnc_id : "HGNC:23191",
      havana_gene : "OTTHUMG00000048138.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36054649,
      stop : 36105108,
      direction : "+",
      ID : "ENSG00000075702.19",
      gene_id : "ENSG00000075702.19",
      gene_type : "protein_coding",
      gene_name : "WDR62",
      gene_level : 2,
      hgnc_id : "HGNC:24502",
      havana_gene : "OTTHUMG00000048139.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36111151,
      stop : 36113711,
      direction : "+",
      ID : "ENSG00000105261.7",
      gene_id : "ENSG00000105261.7",
      gene_type : "protein_coding",
      gene_name : "OVOL3",
      gene_level : 2,
      hgnc_id : "HGNC:14186",
      havana_gene : "OTTHUMG00000181748.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36113709,
      stop : 36115213,
      direction : "-",
      ID : "ENSG00000105258.9",
      gene_id : "ENSG00000105258.9",
      gene_type : "protein_coding",
      gene_name : "POLR2I",
      gene_level : 2,
      hgnc_id : "HGNC:9196",
      havana_gene : "OTTHUMG00000181749.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36114289,
      stop : 36125947,
      direction : "+",
      ID : "ENSG00000105254.12",
      gene_id : "ENSG00000105254.12",
      gene_type : "protein_coding",
      gene_name : "TBCB",
      gene_level : 1,
      hgnc_id : "HGNC:1989",
      havana_gene : "OTTHUMG00000048143.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36139953,
      stop : 36150353,
      direction : "+",
      ID : "ENSG00000126247.11",
      gene_id : "ENSG00000126247.11",
      gene_type : "protein_coding",
      gene_name : "CAPNS1",
      gene_level : 2,
      hgnc_id : "HGNC:1481",
      havana_gene : "OTTHUMG00000160811.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36150922,
      stop : 36152449,
      direction : "-",
      ID : "ENSG00000161281.11",
      gene_id : "ENSG00000161281.11",
      gene_type : "protein_coding",
      gene_name : "COX7A1",
      gene_level : 2,
      hgnc_id : "HGNC:2287",
      havana_gene : "OTTHUMG00000048144.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36182276,
      stop : 36246257,
      direction : "-",
      ID : "ENSG00000196357.12",
      gene_id : "ENSG00000196357.12",
      gene_type : "protein_coding",
      gene_name : "ZNF565",
      gene_level : 2,
      hgnc_id : "HGNC:26726",
      havana_gene : "OTTHUMG00000180508.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36214602,
      stop : 36238771,
      direction : "+",
      ID : "ENSG00000167635.12",
      gene_id : "ENSG00000167635.12",
      gene_type : "protein_coding",
      gene_name : "ZNF146",
      gene_level : 2,
      hgnc_id : "HGNC:12931",
      havana_gene : "OTTHUMG00000180511.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36334453,
      stop : 36379201,
      direction : "-",
      ID : "ENSG00000142065.14",
      gene_id : "ENSG00000142065.14",
      gene_type : "protein_coding",
      gene_name : "ZFP14",
      gene_level : 1,
      hgnc_id : "HGNC:29312",
      havana_gene : "OTTHUMG00000180675.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36383120,
      stop : 36418644,
      direction : "-",
      ID : "ENSG00000181007.9",
      gene_id : "ENSG00000181007.9",
      gene_type : "protein_coding",
      gene_name : "ZFP82",
      gene_level : 2,
      hgnc_id : "HGNC:28682",
      havana_gene : "OTTHUMG00000048146.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36445119,
      stop : 36489902,
      direction : "-",
      ID : "ENSG00000186017.14",
      gene_id : "ENSG00000186017.14",
      gene_type : "protein_coding",
      gene_name : "ZNF566",
      gene_level : 1,
      hgnc_id : "HGNC:25919",
      havana_gene : "OTTHUMG00000048148.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36510687,
      stop : 36528271,
      direction : "-",
      ID : "ENSG00000254004.7",
      gene_id : "ENSG00000254004.7",
      gene_type : "protein_coding",
      gene_name : "ZNF260",
      gene_level : 2,
      hgnc_id : "HGNC:13499",
      havana_gene : "OTTHUMG00000048155.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36534774,
      stop : 36605276,
      direction : "-",
      ID : "ENSG00000186020.13",
      gene_id : "ENSG00000186020.13",
      gene_type : "protein_coding",
      gene_name : "ZNF529",
      gene_level : 2,
      hgnc_id : "HGNC:29328",
      havana_gene : "OTTHUMG00000180714.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36604817,
      stop : 36634114,
      direction : "+",
      ID : "ENSG00000161298.18",
      gene_id : "ENSG00000161298.18",
      gene_type : "protein_coding",
      gene_name : "ZNF382",
      gene_level : 1,
      hgnc_id : "HGNC:17409",
      havana_gene : "OTTHUMG00000048153.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36636618,
      stop : 36666853,
      direction : "-",
      ID : "ENSG00000197808.12",
      gene_id : "ENSG00000197808.12",
      gene_type : "protein_coding",
      gene_name : "ZNF461",
      gene_level : 1,
      hgnc_id : "HGNC:21629",
      havana_gene : "OTTHUMG00000180832.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36687612,
      stop : 36727701,
      direction : "+",
      ID : "ENSG00000189042.13",
      gene_id : "ENSG00000189042.13",
      gene_type : "protein_coding",
      gene_name : "ZNF567",
      gene_level : 2,
      hgnc_id : "HGNC:28696",
      havana_gene : "OTTHUMG00000180898.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36714383,
      stop : 36772825,
      direction : "-",
      ID : "ENSG00000267041.6",
      gene_id : "ENSG00000267041.6",
      gene_type : "protein_coding",
      gene_name : "ZNF850",
      gene_level : 2,
      hgnc_id : "HGNC:27994",
      havana_gene : "OTTHUMG00000180899.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36817428,
      stop : 36850787,
      direction : "-",
      ID : "ENSG00000197863.9",
      gene_id : "ENSG00000197863.9",
      gene_type : "protein_coding",
      gene_name : "ZNF790",
      gene_level : 2,
      hgnc_id : "HGNC:33114",
      havana_gene : "OTTHUMG00000165616.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36850361,
      stop : 36913029,
      direction : "+",
      ID : "ENSG00000251247.11",
      gene_id : "ENSG00000251247.11",
      gene_type : "protein_coding",
      gene_name : "ZNF345",
      gene_level : 2,
      hgnc_id : "HGNC:16367",
      havana_gene : "OTTHUMG00000048162.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36888124,
      stop : 36916291,
      direction : "-",
      ID : "ENSG00000185869.15",
      gene_id : "ENSG00000185869.15",
      gene_type : "protein_coding",
      gene_name : "ZNF829",
      gene_level : 2,
      hgnc_id : "HGNC:34032",
      havana_gene : "OTTHUMG00000048161.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 36916329,
      stop : 36998700,
      direction : "+",
      ID : "ENSG00000198453.13",
      gene_id : "ENSG00000198453.13",
      gene_type : "protein_coding",
      gene_name : "ZNF568",
      gene_level : 2,
      hgnc_id : "HGNC:25392",
      havana_gene : "OTTHUMG00000048160.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37007857,
      stop : 37130368,
      direction : "+",
      ID : "ENSG00000197050.11",
      gene_id : "ENSG00000197050.11",
      gene_type : "protein_coding",
      gene_name : "ZNF420",
      gene_level : 1,
      hgnc_id : "HGNC:20649",
      havana_gene : "OTTHUMG00000048168.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37093019,
      stop : 37210512,
      direction : "-",
      ID : "ENSG00000267360.6",
      gene_id : "ENSG00000267360.6",
      gene_type : "protein_coding",
      gene_name : "AC012309.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000181859.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37106734,
      stop : 37172741,
      direction : "-",
      ID : "ENSG00000196967.11",
      gene_id : "ENSG00000196967.11",
      gene_type : "protein_coding",
      gene_name : "ZNF585A",
      gene_level : 2,
      hgnc_id : "HGNC:26305",
      havana_gene : "OTTHUMG00000181857.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37181579,
      stop : 37218153,
      direction : "-",
      ID : "ENSG00000245680.11",
      gene_id : "ENSG00000245680.11",
      gene_type : "protein_coding",
      gene_name : "ZNF585B",
      gene_level : 2,
      hgnc_id : "HGNC:30948",
      havana_gene : "OTTHUMG00000048165.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37217926,
      stop : 37248738,
      direction : "+",
      ID : "ENSG00000188283.11",
      gene_id : "ENSG00000188283.11",
      gene_type : "protein_coding",
      gene_name : "ZNF383",
      gene_level : 2,
      hgnc_id : "HGNC:18609",
      havana_gene : "OTTHUMG00000181890.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37312837,
      stop : 37369365,
      direction : "+",
      ID : "ENSG00000181666.18",
      gene_id : "ENSG00000181666.18",
      gene_type : "protein_coding",
      gene_name : "ZNF875",
      gene_level : 1,
      hgnc_id : "HGNC:4928",
      havana_gene : "OTTHUMG00000181937.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37371061,
      stop : 37393066,
      direction : "+",
      ID : "ENSG00000189164.15",
      gene_id : "ENSG00000189164.15",
      gene_type : "protein_coding",
      gene_name : "ZNF527",
      gene_level : 1,
      hgnc_id : "HGNC:29385",
      havana_gene : "OTTHUMG00000048173.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37411155,
      stop : 37469275,
      direction : "-",
      ID : "ENSG00000196437.12",
      gene_id : "ENSG00000196437.12",
      gene_type : "protein_coding",
      gene_name : "ZNF569",
      gene_level : 1,
      hgnc_id : "HGNC:24737",
      havana_gene : "OTTHUMG00000048172.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37467585,
      stop : 37488652,
      direction : "+",
      ID : "ENSG00000171827.11",
      gene_id : "ENSG00000171827.11",
      gene_type : "protein_coding",
      gene_name : "ZNF570",
      gene_level : 2,
      hgnc_id : "HGNC:26416",
      havana_gene : "OTTHUMG00000048176.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37506939,
      stop : 37548762,
      direction : "+",
      ID : "ENSG00000188227.13",
      gene_id : "ENSG00000188227.13",
      gene_type : "protein_coding",
      gene_name : "ZNF793",
      gene_level : 1,
      hgnc_id : "HGNC:33115",
      havana_gene : "OTTHUMG00000182003.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37551406,
      stop : 37614179,
      direction : "+",
      ID : "ENSG00000171817.17",
      gene_id : "ENSG00000171817.17",
      gene_type : "protein_coding",
      gene_name : "ZNF540",
      gene_level : 1,
      hgnc_id : "HGNC:25331",
      havana_gene : "OTTHUMG00000182053.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37554782,
      stop : 37594792,
      direction : "-",
      ID : "ENSG00000180479.14",
      gene_id : "ENSG00000180479.14",
      gene_type : "protein_coding",
      gene_name : "ZNF571",
      gene_level : 1,
      hgnc_id : "HGNC:25000",
      havana_gene : "OTTHUMG00000182016.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37613749,
      stop : 37692337,
      direction : "-",
      ID : "ENSG00000120784.16",
      gene_id : "ENSG00000120784.16",
      gene_type : "protein_coding",
      gene_name : "ZFP30",
      gene_level : 2,
      hgnc_id : "HGNC:29555",
      havana_gene : "OTTHUMG00000048177.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37667751,
      stop : 37692315,
      direction : "-",
      ID : "ENSG00000196381.11",
      gene_id : "ENSG00000196381.11",
      gene_type : "protein_coding",
      gene_name : "ZNF781",
      gene_level : 1,
      hgnc_id : "HGNC:26745",
      havana_gene : "OTTHUMG00000182106.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37689865,
      stop : 37719188,
      direction : "-",
      ID : "ENSG00000267552.6",
      gene_id : "ENSG00000267552.6",
      gene_type : "protein_coding",
      gene_name : "AC093227.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182107.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37696371,
      stop : 37719761,
      direction : "-",
      ID : "ENSG00000198182.13",
      gene_id : "ENSG00000198182.13",
      gene_type : "protein_coding",
      gene_name : "ZNF607",
      gene_level : 1,
      hgnc_id : "HGNC:28192",
      havana_gene : "OTTHUMG00000182108.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37735833,
      stop : 37817300,
      direction : "-",
      ID : "ENSG00000189144.15",
      gene_id : "ENSG00000189144.15",
      gene_type : "protein_coding",
      gene_name : "ZNF573",
      gene_level : 1,
      hgnc_id : "HGNC:26420",
      havana_gene : "OTTHUMG00000048183.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37884823,
      stop : 37906677,
      direction : "-",
      ID : "ENSG00000171804.11",
      gene_id : "ENSG00000171804.11",
      gene_type : "protein_coding",
      gene_name : "WDR87",
      gene_level : 2,
      hgnc_id : "HGNC:29934",
      havana_gene : "OTTHUMG00000048187.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 37907208,
      stop : 38208369,
      direction : "+",
      ID : "ENSG00000105738.11",
      gene_id : "ENSG00000105738.11",
      gene_type : "protein_coding",
      gene_name : "SIPA1L3",
      gene_level : 2,
      hgnc_id : "HGNC:23801",
      havana_gene : "OTTHUMG00000073727.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38211006,
      stop : 38229714,
      direction : "-",
      ID : "ENSG00000011332.20",
      gene_id : "ENSG00000011332.20",
      gene_type : "protein_coding",
      gene_name : "DPF1",
      gene_level : 1,
      hgnc_id : "HGNC:20225",
      havana_gene : "OTTHUMG00000157164.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38244035,
      stop : 38292615,
      direction : "+",
      ID : "ENSG00000167642.13",
      gene_id : "ENSG00000167642.13",
      gene_type : "protein_coding",
      gene_name : "SPINT2",
      gene_level : 1,
      hgnc_id : "HGNC:11247",
      havana_gene : "OTTHUMG00000181891.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38251237,
      stop : 38256532,
      direction : "-",
      ID : "ENSG00000167641.11",
      gene_id : "ENSG00000167641.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R14A",
      gene_level : 2,
      hgnc_id : "HGNC:14871",
      havana_gene : "OTTHUMG00000181892.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38289151,
      stop : 38304910,
      direction : "+",
      ID : "ENSG00000267748.4",
      gene_id : "ENSG00000267748.4",
      gene_type : "protein_coding",
      gene_name : "AC011479.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000181893.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38303558,
      stop : 38317273,
      direction : "-",
      ID : "ENSG00000167645.17",
      gene_id : "ENSG00000167645.17",
      gene_type : "protein_coding",
      gene_name : "YIF1B",
      gene_level : 1,
      hgnc_id : "HGNC:30511",
      havana_gene : "OTTHUMG00000182324.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38304164,
      stop : 38305006,
      direction : "+",
      ID : "ENSG00000167644.12",
      gene_id : "ENSG00000167644.12",
      gene_type : "protein_coding",
      gene_name : "C19orf33",
      gene_level : 2,
      hgnc_id : "HGNC:16668",
      havana_gene : "OTTHUMG00000181894.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38319845,
      stop : 38332076,
      direction : "+",
      ID : "ENSG00000099337.5",
      gene_id : "ENSG00000099337.5",
      gene_type : "protein_coding",
      gene_name : "KCNK6",
      gene_level : 2,
      hgnc_id : "HGNC:6281",
      havana_gene : "OTTHUMG00000182325.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38335775,
      stop : 38370943,
      direction : "+",
      ID : "ENSG00000099338.23",
      gene_id : "ENSG00000099338.23",
      gene_type : "protein_coding",
      gene_name : "CATSPERG",
      gene_level : 1,
      hgnc_id : "HGNC:25243",
      havana_gene : "OTTHUMG00000153223.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38374550,
      stop : 38383824,
      direction : "+",
      ID : "ENSG00000099341.12",
      gene_id : "ENSG00000099341.12",
      gene_type : "protein_coding",
      gene_name : "PSMD8",
      gene_level : 1,
      hgnc_id : "HGNC:9566",
      havana_gene : "OTTHUMG00000150691.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38384267,
      stop : 38388082,
      direction : "-",
      ID : "ENSG00000179168.15",
      gene_id : "ENSG00000179168.15",
      gene_type : "protein_coding",
      gene_name : "GGN",
      gene_level : 1,
      hgnc_id : "HGNC:18869",
      havana_gene : "OTTHUMG00000182080.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38388421,
      stop : 38399587,
      direction : "+",
      ID : "ENSG00000188766.12",
      gene_id : "ENSG00000188766.12",
      gene_type : "protein_coding",
      gene_name : "SPRED3",
      gene_level : 2,
      hgnc_id : "HGNC:31041",
      havana_gene : "OTTHUMG00000182082.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38403135,
      stop : 38409088,
      direction : "+",
      ID : "ENSG00000130244.12",
      gene_id : "ENSG00000130244.12",
      gene_type : "protein_coding",
      gene_name : "FAM98C",
      gene_level : 2,
      hgnc_id : "HGNC:27119",
      havana_gene : "OTTHUMG00000182084.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38409051,
      stop : 38426305,
      direction : "-",
      ID : "ENSG00000171777.16",
      gene_id : "ENSG00000171777.16",
      gene_type : "protein_coding",
      gene_name : "RASGRP4",
      gene_level : 2,
      hgnc_id : "HGNC:18958",
      havana_gene : "OTTHUMG00000182327.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38433691,
      stop : 38587564,
      direction : "+",
      ID : "ENSG00000196218.13",
      gene_id : "ENSG00000196218.13",
      gene_type : "protein_coding",
      gene_name : "RYR1",
      gene_level : 1,
      hgnc_id : "HGNC:10483",
      havana_gene : "OTTHUMG00000182403.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38587641,
      stop : 38618882,
      direction : "-",
      ID : "ENSG00000104814.13",
      gene_id : "ENSG00000104814.13",
      gene_type : "protein_coding",
      gene_name : "MAP4K1",
      gene_level : 2,
      hgnc_id : "HGNC:6863",
      havana_gene : "OTTHUMG00000180863.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38619082,
      stop : 38636955,
      direction : "+",
      ID : "ENSG00000178982.10",
      gene_id : "ENSG00000178982.10",
      gene_type : "protein_coding",
      gene_name : "EIF3K",
      gene_level : 1,
      hgnc_id : "HGNC:24656",
      havana_gene : "OTTHUMG00000180865.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38647649,
      stop : 38731589,
      direction : "+",
      ID : "ENSG00000130402.13",
      gene_id : "ENSG00000130402.13",
      gene_type : "protein_coding",
      gene_name : "ACTN4",
      gene_level : 1,
      hgnc_id : "HGNC:166",
      havana_gene : "OTTHUMG00000137382.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38730187,
      stop : 38769904,
      direction : "-",
      ID : "ENSG00000182472.9",
      gene_id : "ENSG00000182472.9",
      gene_type : "protein_coding",
      gene_name : "CAPN12",
      gene_level : 2,
      hgnc_id : "HGNC:13249",
      havana_gene : "OTTHUMG00000182525.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38770971,
      stop : 38773492,
      direction : "-",
      ID : "ENSG00000205076.4",
      gene_id : "ENSG00000205076.4",
      gene_type : "protein_coding",
      gene_name : "LGALS7",
      gene_level : 2,
      hgnc_id : "HGNC:6568",
      havana_gene : "OTTHUMG00000182606.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38789200,
      stop : 38791754,
      direction : "+",
      ID : "ENSG00000178934.5",
      gene_id : "ENSG00000178934.5",
      gene_type : "protein_coding",
      gene_name : "LGALS7B",
      gene_level : 2,
      hgnc_id : "HGNC:34447",
      havana_gene : "OTTHUMG00000182607.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38801671,
      stop : 38812945,
      direction : "-",
      ID : "ENSG00000171747.9",
      gene_id : "ENSG00000171747.9",
      gene_type : "protein_coding",
      gene_name : "LGALS4",
      gene_level : 2,
      hgnc_id : "HGNC:6565",
      havana_gene : "OTTHUMG00000182608.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38815422,
      stop : 38831841,
      direction : "-",
      ID : "ENSG00000104823.9",
      gene_id : "ENSG00000104823.9",
      gene_type : "protein_coding",
      gene_name : "ECH1",
      gene_level : 1,
      hgnc_id : "HGNC:3149",
      havana_gene : "OTTHUMG00000182609.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38817471,
      stop : 38840178,
      direction : "-",
      ID : "ENSG00000268083.5",
      gene_id : "ENSG00000268083.5",
      gene_type : "protein_coding",
      gene_name : "AC008982.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182610.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38836370,
      stop : 38852347,
      direction : "-",
      ID : "ENSG00000104824.18",
      gene_id : "ENSG00000104824.18",
      gene_type : "protein_coding",
      gene_name : "HNRNPL",
      gene_level : 2,
      hgnc_id : "HGNC:5045",
      havana_gene : "OTTHUMG00000182612.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38867830,
      stop : 38878275,
      direction : "-",
      ID : "ENSG00000187994.14",
      gene_id : "ENSG00000187994.14",
      gene_type : "protein_coding",
      gene_name : "RINL",
      gene_level : 2,
      hgnc_id : "HGNC:24795",
      havana_gene : "OTTHUMG00000182299.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38878555,
      stop : 38899862,
      direction : "-",
      ID : "ENSG00000068903.20",
      gene_id : "ENSG00000068903.20",
      gene_type : "protein_coding",
      gene_name : "SIRT2",
      gene_level : 2,
      hgnc_id : "HGNC:10886",
      havana_gene : "OTTHUMG00000150480.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38899700,
      stop : 38908893,
      direction : "+",
      ID : "ENSG00000104825.17",
      gene_id : "ENSG00000104825.17",
      gene_type : "protein_coding",
      gene_name : "NFKBIB",
      gene_level : 2,
      hgnc_id : "HGNC:7798",
      havana_gene : "OTTHUMG00000177631.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38908980,
      stop : 38912158,
      direction : "-",
      ID : "ENSG00000262484.1",
      gene_id : "ENSG00000262484.1",
      gene_type : "protein_coding",
      gene_name : "CCER2",
      gene_level : 2,
      hgnc_id : "HGNC:44662",
      havana_gene : "OTTHUMG00000177374.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38915266,
      stop : 38930763,
      direction : "-",
      ID : "ENSG00000104835.15",
      gene_id : "ENSG00000104835.15",
      gene_type : "protein_coding",
      gene_name : "SARS2",
      gene_level : 2,
      hgnc_id : "HGNC:17697",
      havana_gene : "OTTHUMG00000182691.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38915404,
      stop : 38949855,
      direction : "-",
      ID : "ENSG00000269547.1",
      gene_id : "ENSG00000269547.1",
      gene_type : "protein_coding",
      gene_name : "AC011455.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182716.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38930944,
      stop : 38933168,
      direction : "+",
      ID : "ENSG00000128626.12",
      gene_id : "ENSG00000128626.12",
      gene_type : "protein_coding",
      gene_name : "MRPS12",
      gene_level : 2,
      hgnc_id : "HGNC:10380",
      havana_gene : "OTTHUMG00000182692.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38941401,
      stop : 38975742,
      direction : "-",
      ID : "ENSG00000269190.6",
      gene_id : "ENSG00000269190.6",
      gene_type : "protein_coding",
      gene_name : "FBXO17",
      gene_level : 2,
      hgnc_id : "HGNC:18754",
      havana_gene : "OTTHUMG00000182718.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 38990714,
      stop : 39032785,
      direction : "-",
      ID : "ENSG00000161243.9",
      gene_id : "ENSG00000161243.9",
      gene_type : "protein_coding",
      gene_name : "FBXO27",
      gene_level : 2,
      hgnc_id : "HGNC:18753",
      havana_gene : "OTTHUMG00000182719.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39083913,
      stop : 39111493,
      direction : "+",
      ID : "ENSG00000183760.11",
      gene_id : "ENSG00000183760.11",
      gene_type : "protein_coding",
      gene_name : "ACP7",
      gene_level : 1,
      hgnc_id : "HGNC:33781",
      havana_gene : "OTTHUMG00000182799.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39125770,
      stop : 39182816,
      direction : "+",
      ID : "ENSG00000130669.17",
      gene_id : "ENSG00000130669.17",
      gene_type : "protein_coding",
      gene_name : "PAK4",
      gene_level : 2,
      hgnc_id : "HGNC:16059",
      havana_gene : "OTTHUMG00000182800.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39196964,
      stop : 39201884,
      direction : "+",
      ID : "ENSG00000188505.5",
      gene_id : "ENSG00000188505.5",
      gene_type : "protein_coding",
      gene_name : "NCCRP1",
      gene_level : 2,
      hgnc_id : "HGNC:33739",
      havana_gene : "OTTHUMG00000182802.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39202825,
      stop : 39204263,
      direction : "-",
      ID : "ENSG00000179751.7",
      gene_id : "ENSG00000179751.7",
      gene_type : "protein_coding",
      gene_name : "SYCN",
      gene_level : 2,
      hgnc_id : "HGNC:18442",
      havana_gene : "OTTHUMG00000182803.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39243553,
      stop : 39245129,
      direction : "-",
      ID : "ENSG00000197110.9",
      gene_id : "ENSG00000197110.9",
      gene_type : "protein_coding",
      gene_name : "IFNL3",
      gene_level : 2,
      hgnc_id : "HGNC:18365",
      havana_gene : "OTTHUMG00000182805.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39268396,
      stop : 39270188,
      direction : "+",
      ID : "ENSG00000183709.8",
      gene_id : "ENSG00000183709.8",
      gene_type : "protein_coding",
      gene_name : "IFNL2",
      gene_level : 2,
      hgnc_id : "HGNC:18364",
      havana_gene : "OTTHUMG00000182806.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39296407,
      stop : 39298673,
      direction : "+",
      ID : "ENSG00000182393.3",
      gene_id : "ENSG00000182393.3",
      gene_type : "protein_coding",
      gene_name : "IFNL1",
      gene_level : 2,
      hgnc_id : "HGNC:18363",
      havana_gene : "OTTHUMG00000182807.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39306566,
      stop : 39320863,
      direction : "-",
      ID : "ENSG00000128011.5",
      gene_id : "ENSG00000128011.5",
      gene_type : "protein_coding",
      gene_name : "LRFN1",
      gene_level : 2,
      hgnc_id : "HGNC:29290",
      havana_gene : "OTTHUMG00000182808.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39328353,
      stop : 39342372,
      direction : "-",
      ID : "ENSG00000130755.13",
      gene_id : "ENSG00000130755.13",
      gene_type : "protein_coding",
      gene_name : "GMFG",
      gene_level : 2,
      hgnc_id : "HGNC:4374",
      havana_gene : "OTTHUMG00000182811.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39342396,
      stop : 39385710,
      direction : "+",
      ID : "ENSG00000179134.15",
      gene_id : "ENSG00000179134.15",
      gene_type : "protein_coding",
      gene_name : "SAMD4B",
      gene_level : 1,
      hgnc_id : "HGNC:25492",
      havana_gene : "OTTHUMG00000182967.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39385629,
      stop : 39391154,
      direction : "-",
      ID : "ENSG00000006712.15",
      gene_id : "ENSG00000006712.15",
      gene_type : "protein_coding",
      gene_name : "PAF1",
      gene_level : 2,
      hgnc_id : "HGNC:25459",
      havana_gene : "OTTHUMG00000182968.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39391303,
      stop : 39400641,
      direction : "+",
      ID : "ENSG00000063322.15",
      gene_id : "ENSG00000063322.15",
      gene_type : "protein_coding",
      gene_name : "MED29",
      gene_level : 1,
      hgnc_id : "HGNC:23074",
      havana_gene : "OTTHUMG00000182969.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39406847,
      stop : 39409412,
      direction : "+",
      ID : "ENSG00000128016.7",
      gene_id : "ENSG00000128016.7",
      gene_type : "protein_coding",
      gene_name : "ZFP36",
      gene_level : 1,
      hgnc_id : "HGNC:12862",
      havana_gene : "OTTHUMG00000182970.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39412669,
      stop : 39428415,
      direction : "+",
      ID : "ENSG00000090924.15",
      gene_id : "ENSG00000090924.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHG2",
      gene_level : 1,
      hgnc_id : "HGNC:29515",
      havana_gene : "OTTHUMG00000152570.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39433137,
      stop : 39435949,
      direction : "-",
      ID : "ENSG00000105193.9",
      gene_id : "ENSG00000105193.9",
      gene_type : "protein_coding",
      gene_name : "RPS16",
      gene_level : 2,
      hgnc_id : "HGNC:10396",
      havana_gene : "OTTHUMG00000182972.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39436156,
      stop : 39476670,
      direction : "+",
      ID : "ENSG00000196235.14",
      gene_id : "ENSG00000196235.14",
      gene_type : "protein_coding",
      gene_name : "SUPT5H",
      gene_level : 2,
      hgnc_id : "HGNC:11469",
      havana_gene : "OTTHUMG00000182973.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39480412,
      stop : 39493785,
      direction : "+",
      ID : "ENSG00000105197.11",
      gene_id : "ENSG00000105197.11",
      gene_type : "protein_coding",
      gene_name : "TIMM50",
      gene_level : 2,
      hgnc_id : "HGNC:23656",
      havana_gene : "OTTHUMG00000183066.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39498895,
      stop : 39508481,
      direction : "+",
      ID : "ENSG00000090932.11",
      gene_id : "ENSG00000090932.11",
      gene_type : "protein_coding",
      gene_name : "DLL3",
      gene_level : 2,
      hgnc_id : "HGNC:2909",
      havana_gene : "OTTHUMG00000183067.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39515113,
      stop : 39520686,
      direction : "+",
      ID : "ENSG00000186838.13",
      gene_id : "ENSG00000186838.13",
      gene_type : "protein_coding",
      gene_name : "SELENOV",
      gene_level : 2,
      hgnc_id : "HGNC:30399",
      havana_gene : "OTTHUMG00000166446.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39530987,
      stop : 39532852,
      direction : "-",
      ID : "ENSG00000176401.6",
      gene_id : "ENSG00000176401.6",
      gene_type : "protein_coding",
      gene_name : "EID2B",
      gene_level : 2,
      hgnc_id : "HGNC:26796",
      havana_gene : "OTTHUMG00000183068.2",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39538707,
      stop : 39540161,
      direction : "-",
      ID : "ENSG00000176396.11",
      gene_id : "ENSG00000176396.11",
      gene_type : "protein_coding",
      gene_name : "EID2",
      gene_level : 2,
      hgnc_id : "HGNC:28292",
      havana_gene : "OTTHUMG00000074073.4",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39602501,
      stop : 39607474,
      direction : "+",
      ID : "ENSG00000105198.11",
      gene_id : "ENSG00000105198.11",
      gene_type : "protein_coding",
      gene_name : "LGALS13",
      gene_level : 2,
      hgnc_id : "HGNC:15449",
      havana_gene : "OTTHUMG00000183073.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39655913,
      stop : 39660647,
      direction : "+",
      ID : "ENSG00000249861.4",
      gene_id : "ENSG00000249861.4",
      gene_type : "protein_coding",
      gene_name : "LGALS16",
      gene_level : 2,
      hgnc_id : "HGNC:40039",
      havana_gene : "OTTHUMG00000183083.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39704481,
      stop : 39709444,
      direction : "+",
      ID : "ENSG00000006659.13",
      gene_id : "ENSG00000006659.13",
      gene_type : "protein_coding",
      gene_name : "LGALS14",
      gene_level : 2,
      hgnc_id : "HGNC:30054",
      havana_gene : "OTTHUMG00000183143.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39731255,
      stop : 39738029,
      direction : "-",
      ID : "ENSG00000105205.7",
      gene_id : "ENSG00000105205.7",
      gene_type : "protein_coding",
      gene_name : "CLC",
      gene_level : 2,
      hgnc_id : "HGNC:2014",
      havana_gene : "OTTHUMG00000183144.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39776595,
      stop : 39786291,
      direction : "+",
      ID : "ENSG00000213921.8",
      gene_id : "ENSG00000213921.8",
      gene_type : "protein_coding",
      gene_name : "LEUTX",
      gene_level : 1,
      hgnc_id : "HGNC:31953",
      havana_gene : "OTTHUMG00000170877.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39825350,
      stop : 39834201,
      direction : "-",
      ID : "ENSG00000105204.14",
      gene_id : "ENSG00000105204.14",
      gene_type : "protein_coding",
      gene_name : "DYRK1B",
      gene_level : 2,
      hgnc_id : "HGNC:3092",
      havana_gene : "OTTHUMG00000182584.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39834458,
      stop : 39846379,
      direction : "-",
      ID : "ENSG00000105202.9",
      gene_id : "ENSG00000105202.9",
      gene_type : "protein_coding",
      gene_name : "FBL",
      gene_level : 2,
      hgnc_id : "HGNC:3599",
      havana_gene : "OTTHUMG00000182581.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39863323,
      stop : 39934626,
      direction : "-",
      ID : "ENSG00000275395.6",
      gene_id : "ENSG00000275395.6",
      gene_type : "protein_coding",
      gene_name : "FCGBP",
      gene_level : 2,
      hgnc_id : "HGNC:13572",
      havana_gene : "OTTHUMG00000182580.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39971165,
      stop : 39981764,
      direction : "+",
      ID : "ENSG00000013275.8",
      gene_id : "ENSG00000013275.8",
      gene_type : "protein_coding",
      gene_name : "PSMC4",
      gene_level : 2,
      hgnc_id : "HGNC:9551",
      havana_gene : "OTTHUMG00000182577.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 39984134,
      stop : 40021038,
      direction : "+",
      ID : "ENSG00000187187.14",
      gene_id : "ENSG00000187187.14",
      gene_type : "protein_coding",
      gene_name : "ZNF546",
      gene_level : 2,
      hgnc_id : "HGNC:28671",
      havana_gene : "OTTHUMG00000182578.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40028260,
      stop : 40056231,
      direction : "-",
      ID : "ENSG00000128000.17",
      gene_id : "ENSG00000128000.17",
      gene_type : "protein_coding",
      gene_name : "ZNF780B",
      gene_level : 1,
      hgnc_id : "HGNC:33109",
      havana_gene : "OTTHUMG00000155118.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40069152,
      stop : 40090938,
      direction : "-",
      ID : "ENSG00000197782.14",
      gene_id : "ENSG00000197782.14",
      gene_type : "protein_coding",
      gene_name : "ZNF780A",
      gene_level : 2,
      hgnc_id : "HGNC:27603",
      havana_gene : "OTTHUMG00000155119.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40191426,
      stop : 40215575,
      direction : "+",
      ID : "ENSG00000130758.8",
      gene_id : "ENSG00000130758.8",
      gene_type : "protein_coding",
      gene_name : "MAP3K10",
      gene_level : 2,
      hgnc_id : "HGNC:6849",
      havana_gene : "OTTHUMG00000182591.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40216058,
      stop : 40218399,
      direction : "-",
      ID : "ENSG00000174521.7",
      gene_id : "ENSG00000174521.7",
      gene_type : "protein_coding",
      gene_name : "TTC9B",
      gene_level : 2,
      hgnc_id : "HGNC:26395",
      havana_gene : "OTTHUMG00000182600.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40222208,
      stop : 40226697,
      direction : "-",
      ID : "ENSG00000105219.10",
      gene_id : "ENSG00000105219.10",
      gene_type : "protein_coding",
      gene_name : "CCNP",
      gene_level : 2,
      hgnc_id : "HGNC:25805",
      havana_gene : "OTTHUMG00000160481.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40230317,
      stop : 40285536,
      direction : "-",
      ID : "ENSG00000105221.18",
      gene_id : "ENSG00000105221.18",
      gene_type : "protein_coding",
      gene_name : "AKT2",
      gene_level : 1,
      hgnc_id : "HGNC:392",
      havana_gene : "OTTHUMG00000137375.23",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40319536,
      stop : 40348527,
      direction : "-",
      ID : "ENSG00000160392.13",
      gene_id : "ENSG00000160392.13",
      gene_type : "protein_coding",
      gene_name : "C19orf47",
      gene_level : 2,
      hgnc_id : "HGNC:26723",
      havana_gene : "OTTHUMG00000179028.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40348456,
      stop : 40380439,
      direction : "+",
      ID : "ENSG00000105223.20",
      gene_id : "ENSG00000105223.20",
      gene_type : "protein_coding",
      gene_name : "PLD3",
      gene_level : 2,
      hgnc_id : "HGNC:17158",
      havana_gene : "OTTHUMG00000152736.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40379271,
      stop : 40390181,
      direction : "-",
      ID : "ENSG00000160396.9",
      gene_id : "ENSG00000160396.9",
      gene_type : "protein_coding",
      gene_name : "HIPK4",
      gene_level : 2,
      hgnc_id : "HGNC:19007",
      havana_gene : "OTTHUMG00000182598.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40393766,
      stop : 40414793,
      direction : "-",
      ID : "ENSG00000105227.16",
      gene_id : "ENSG00000105227.16",
      gene_type : "protein_coding",
      gene_name : "PRX",
      gene_level : 2,
      hgnc_id : "HGNC:13797",
      havana_gene : "OTTHUMG00000182597.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40421589,
      stop : 40425992,
      direction : "-",
      ID : "ENSG00000197019.5",
      gene_id : "ENSG00000197019.5",
      gene_type : "protein_coding",
      gene_name : "SERTAD1",
      gene_level : 2,
      hgnc_id : "HGNC:17932",
      havana_gene : "OTTHUMG00000182594.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40440844,
      stop : 40444335,
      direction : "-",
      ID : "ENSG00000167565.13",
      gene_id : "ENSG00000167565.13",
      gene_type : "protein_coding",
      gene_name : "SERTAD3",
      gene_level : 2,
      hgnc_id : "HGNC:17931",
      havana_gene : "OTTHUMG00000182595.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40447765,
      stop : 40465764,
      direction : "-",
      ID : "ENSG00000090013.11",
      gene_id : "ENSG00000090013.11",
      gene_type : "protein_coding",
      gene_name : "BLVRB",
      gene_level : 1,
      hgnc_id : "HGNC:1063",
      havana_gene : "OTTHUMG00000182593.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40466241,
      stop : 40576464,
      direction : "+",
      ID : "ENSG00000160460.16",
      gene_id : "ENSG00000160460.16",
      gene_type : "protein_coding",
      gene_name : "SPTBN4",
      gene_level : 2,
      hgnc_id : "HGNC:14896",
      havana_gene : "OTTHUMG00000182592.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40576853,
      stop : 40591399,
      direction : "+",
      ID : "ENSG00000160410.15",
      gene_id : "ENSG00000160410.15",
      gene_type : "protein_coding",
      gene_name : "SHKBP1",
      gene_level : 1,
      hgnc_id : "HGNC:19214",
      havana_gene : "OTTHUMG00000182602.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40592883,
      stop : 40629818,
      direction : "+",
      ID : "ENSG00000090006.18",
      gene_id : "ENSG00000090006.18",
      gene_type : "protein_coding",
      gene_name : "LTBP4",
      gene_level : 2,
      hgnc_id : "HGNC:6717",
      havana_gene : "OTTHUMG00000182635.12",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40665905,
      stop : 40690972,
      direction : "-",
      ID : "ENSG00000105245.9",
      gene_id : "ENSG00000105245.9",
      gene_type : "protein_coding",
      gene_name : "NUMBL",
      gene_level : 1,
      hgnc_id : "HGNC:8061",
      havana_gene : "OTTHUMG00000182627.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40691514,
      stop : 40725784,
      direction : "-",
      ID : "ENSG00000123815.13",
      gene_id : "ENSG00000123815.13",
      gene_type : "protein_coding",
      gene_name : "COQ8B",
      gene_level : 2,
      hgnc_id : "HGNC:19041",
      havana_gene : "OTTHUMG00000182620.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40717112,
      stop : 40740860,
      direction : "+",
      ID : "ENSG00000086544.3",
      gene_id : "ENSG00000086544.3",
      gene_type : "protein_coding",
      gene_name : "ITPKC",
      gene_level : 2,
      hgnc_id : "HGNC:14897",
      havana_gene : "OTTHUMG00000182688.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40740856,
      stop : 40751553,
      direction : "-",
      ID : "ENSG00000188493.15",
      gene_id : "ENSG00000188493.15",
      gene_type : "protein_coding",
      gene_name : "C19orf54",
      gene_level : 1,
      hgnc_id : "HGNC:24758",
      havana_gene : "OTTHUMG00000150174.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40750637,
      stop : 40765389,
      direction : "+",
      ID : "ENSG00000077312.9",
      gene_id : "ENSG00000077312.9",
      gene_type : "protein_coding",
      gene_name : "SNRPA",
      gene_level : 2,
      hgnc_id : "HGNC:11151",
      havana_gene : "OTTHUMG00000182689.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40771648,
      stop : 40777490,
      direction : "+",
      ID : "ENSG00000261857.7",
      gene_id : "ENSG00000261857.7",
      gene_type : "protein_coding",
      gene_name : "MIA",
      gene_level : 1,
      hgnc_id : "HGNC:7076",
      havana_gene : "OTTHUMG00000182693.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40771648,
      stop : 40796943,
      direction : "+",
      ID : "ENSG00000268975.2",
      gene_id : "ENSG00000268975.2",
      gene_type : "protein_coding",
      gene_name : "MIA-RAB4B",
      gene_level : 2,
      hgnc_id : "HGNC:48352",
      havana_gene : "OTTHUMG00000182782.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40778216,
      stop : 40796942,
      direction : "+",
      ID : "ENSG00000167578.18",
      gene_id : "ENSG00000167578.18",
      gene_type : "protein_coding",
      gene_name : "RAB4B",
      gene_level : 2,
      hgnc_id : "HGNC:9782",
      havana_gene : "OTTHUMG00000182694.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40778242,
      stop : 40808418,
      direction : "+",
      ID : "ENSG00000171570.11",
      gene_id : "ENSG00000171570.11",
      gene_type : "protein_coding",
      gene_name : "RAB4B-EGLN2",
      gene_level : 2,
      hgnc_id : "HGNC:44465",
      havana_gene : "OTTHUMG00000182702.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40798996,
      stop : 40808434,
      direction : "+",
      ID : "ENSG00000269858.6",
      gene_id : "ENSG00000269858.6",
      gene_type : "protein_coding",
      gene_name : "EGLN2",
      gene_level : 1,
      hgnc_id : "HGNC:14660",
      havana_gene : "OTTHUMG00000182703.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40801297,
      stop : 40898282,
      direction : "+",
      ID : "ENSG00000268797.1",
      gene_id : "ENSG00000268797.1",
      gene_type : "protein_coding",
      gene_name : "AC008537.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182828.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40843541,
      stop : 40850447,
      direction : "-",
      ID : "ENSG00000255974.8",
      gene_id : "ENSG00000255974.8",
      gene_type : "protein_coding",
      gene_name : "CYP2A6",
      gene_level : 2,
      hgnc_id : "HGNC:2610",
      havana_gene : "OTTHUMG00000182713.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40875439,
      stop : 40882752,
      direction : "-",
      ID : "ENSG00000198077.11",
      gene_id : "ENSG00000198077.11",
      gene_type : "protein_coding",
      gene_name : "CYP2A7",
      gene_level : 2,
      hgnc_id : "HGNC:2611",
      havana_gene : "OTTHUMG00000182715.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 40991282,
      stop : 41018398,
      direction : "+",
      ID : "ENSG00000197408.10",
      gene_id : "ENSG00000197408.10",
      gene_type : "protein_coding",
      gene_name : "CYP2B6",
      gene_level : 2,
      hgnc_id : "HGNC:2615",
      havana_gene : "OTTHUMG00000182714.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41088451,
      stop : 41096195,
      direction : "+",
      ID : "ENSG00000197838.5",
      gene_id : "ENSG00000197838.5",
      gene_type : "protein_coding",
      gene_name : "CYP2A13",
      gene_level : 2,
      hgnc_id : "HGNC:2608",
      havana_gene : "OTTHUMG00000182762.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41114432,
      stop : 41128381,
      direction : "+",
      ID : "ENSG00000197446.9",
      gene_id : "ENSG00000197446.9",
      gene_type : "protein_coding",
      gene_name : "CYP2F1",
      gene_level : 2,
      hgnc_id : "HGNC:2632",
      havana_gene : "OTTHUMG00000167412.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41193210,
      stop : 41207539,
      direction : "+",
      ID : "ENSG00000167600.14",
      gene_id : "ENSG00000167600.14",
      gene_type : "protein_coding",
      gene_name : "CYP2S1",
      gene_level : 1,
      hgnc_id : "HGNC:15654",
      havana_gene : "OTTHUMG00000182721.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41219223,
      stop : 41261766,
      direction : "+",
      ID : "ENSG00000167601.12",
      gene_id : "ENSG00000167601.12",
      gene_type : "protein_coding",
      gene_name : "AXL",
      gene_level : 1,
      hgnc_id : "HGNC:905",
      havana_gene : "OTTHUMG00000182727.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41262496,
      stop : 41307787,
      direction : "+",
      ID : "ENSG00000105323.17",
      gene_id : "ENSG00000105323.17",
      gene_type : "protein_coding",
      gene_name : "HNRNPUL1",
      gene_level : 1,
      hgnc_id : "HGNC:17011",
      havana_gene : "OTTHUMG00000182740.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41301587,
      stop : 41353922,
      direction : "-",
      ID : "ENSG00000105329.11",
      gene_id : "ENSG00000105329.11",
      gene_type : "protein_coding",
      gene_name : "TGFB1",
      gene_level : 1,
      hgnc_id : "HGNC:11766",
      havana_gene : "OTTHUMG00000182760.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41310172,
      stop : 41324873,
      direction : "+",
      ID : "ENSG00000142039.4",
      gene_id : "ENSG00000142039.4",
      gene_type : "protein_coding",
      gene_name : "CCDC97",
      gene_level : 1,
      hgnc_id : "HGNC:28289",
      havana_gene : "OTTHUMG00000182722.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41350853,
      stop : 41425001,
      direction : "+",
      ID : "ENSG00000255730.5",
      gene_id : "ENSG00000255730.5",
      gene_type : "protein_coding",
      gene_name : "AC011462.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168134.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41350911,
      stop : 41384083,
      direction : "+",
      ID : "ENSG00000142046.15",
      gene_id : "ENSG00000142046.15",
      gene_type : "protein_coding",
      gene_name : "TMEM91",
      gene_level : 1,
      hgnc_id : "HGNC:32393",
      havana_gene : "OTTHUMG00000168127.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41354417,
      stop : 41364165,
      direction : "-",
      ID : "ENSG00000123810.9",
      gene_id : "ENSG00000123810.9",
      gene_type : "protein_coding",
      gene_name : "B9D2",
      gene_level : 2,
      hgnc_id : "HGNC:28636",
      havana_gene : "OTTHUMG00000182758.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41386374,
      stop : 41397359,
      direction : "-",
      ID : "ENSG00000077348.9",
      gene_id : "ENSG00000077348.9",
      gene_type : "protein_coding",
      gene_name : "EXOSC5",
      gene_level : 1,
      hgnc_id : "HGNC:24662",
      havana_gene : "OTTHUMG00000182759.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41397808,
      stop : 41425002,
      direction : "+",
      ID : "ENSG00000248098.12",
      gene_id : "ENSG00000248098.12",
      gene_type : "protein_coding",
      gene_name : "BCKDHA",
      gene_level : 1,
      hgnc_id : "HGNC:986",
      havana_gene : "OTTHUMG00000168128.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41425359,
      stop : 41428730,
      direction : "-",
      ID : "ENSG00000177191.2",
      gene_id : "ENSG00000177191.2",
      gene_type : "protein_coding",
      gene_name : "B3GNT8",
      gene_level : 2,
      hgnc_id : "HGNC:24139",
      havana_gene : "OTTHUMG00000182749.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41431318,
      stop : 41440717,
      direction : "-",
      ID : "ENSG00000105341.19",
      gene_id : "ENSG00000105341.19",
      gene_type : "protein_coding",
      gene_name : "DMAC2",
      gene_level : 1,
      hgnc_id : "HGNC:25496",
      havana_gene : "OTTHUMG00000182342.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41443156,
      stop : 41444765,
      direction : "+",
      ID : "ENSG00000204978.3",
      gene_id : "ENSG00000204978.3",
      gene_type : "protein_coding",
      gene_name : "ERICH4",
      gene_level : 2,
      hgnc_id : "HGNC:34497",
      havana_gene : "OTTHUMG00000187130.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41549518,
      stop : 41586844,
      direction : "+",
      ID : "ENSG00000007129.18",
      gene_id : "ENSG00000007129.18",
      gene_type : "protein_coding",
      gene_name : "CEACAM21",
      gene_level : 2,
      hgnc_id : "HGNC:28834",
      havana_gene : "OTTHUMG00000151062.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41618971,
      stop : 41627074,
      direction : "-",
      ID : "ENSG00000105352.10",
      gene_id : "ENSG00000105352.10",
      gene_type : "protein_coding",
      gene_name : "CEACAM4",
      gene_level : 2,
      hgnc_id : "HGNC:1816",
      havana_gene : "OTTHUMG00000151065.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41673303,
      stop : 41706976,
      direction : "-",
      ID : "ENSG00000007306.15",
      gene_id : "ENSG00000007306.15",
      gene_type : "protein_coding",
      gene_name : "CEACAM7",
      gene_level : 2,
      hgnc_id : "HGNC:1819",
      havana_gene : "OTTHUMG00000151063.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41708585,
      stop : 41730433,
      direction : "+",
      ID : "ENSG00000105388.16",
      gene_id : "ENSG00000105388.16",
      gene_type : "protein_coding",
      gene_name : "CEACAM5",
      gene_level : 1,
      hgnc_id : "HGNC:1817",
      havana_gene : "OTTHUMG00000151061.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41708657,
      stop : 41756737,
      direction : "+",
      ID : "ENSG00000267881.2",
      gene_id : "ENSG00000267881.2",
      gene_type : "protein_coding",
      gene_name : "AC243967.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182656.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41750977,
      stop : 41772211,
      direction : "+",
      ID : "ENSG00000086548.9",
      gene_id : "ENSG00000086548.9",
      gene_type : "protein_coding",
      gene_name : "CEACAM6",
      gene_level : 2,
      hgnc_id : "HGNC:1818",
      havana_gene : "OTTHUMG00000151064.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41796587,
      stop : 41811554,
      direction : "+",
      ID : "ENSG00000170956.17",
      gene_id : "ENSG00000170956.17",
      gene_type : "protein_coding",
      gene_name : "CEACAM3",
      gene_level : 2,
      hgnc_id : "HGNC:1815",
      havana_gene : "OTTHUMG00000150142.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41837074,
      stop : 41844697,
      direction : "-",
      ID : "ENSG00000273111.6",
      gene_id : "ENSG00000273111.6",
      gene_type : "protein_coding",
      gene_name : "LYPD4",
      gene_level : 2,
      hgnc_id : "HGNC:28659",
      havana_gene : "OTTHUMG00000182674.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41844743,
      stop : 41852333,
      direction : "+",
      ID : "ENSG00000142025.16",
      gene_id : "ENSG00000142025.16",
      gene_type : "protein_coding",
      gene_name : "DMRTC2",
      gene_level : 2,
      hgnc_id : "HGNC:13911",
      havana_gene : "OTTHUMG00000182675.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41860255,
      stop : 41872925,
      direction : "+",
      ID : "ENSG00000105372.8",
      gene_id : "ENSG00000105372.8",
      gene_type : "protein_coding",
      gene_name : "RPS19",
      gene_level : 2,
      hgnc_id : "HGNC:10402",
      havana_gene : "OTTHUMG00000182676.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41877279,
      stop : 41881372,
      direction : "+",
      ID : "ENSG00000105369.10",
      gene_id : "ENSG00000105369.10",
      gene_type : "protein_coding",
      gene_name : "CD79A",
      gene_level : 2,
      hgnc_id : "HGNC:1698",
      havana_gene : "OTTHUMG00000182678.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41883173,
      stop : 41930150,
      direction : "+",
      ID : "ENSG00000076928.18",
      gene_id : "ENSG00000076928.18",
      gene_type : "protein_coding",
      gene_name : "ARHGEF1",
      gene_level : 1,
      hgnc_id : "HGNC:681",
      havana_gene : "OTTHUMG00000182679.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41907705,
      stop : 41928516,
      direction : "-",
      ID : "ENSG00000268041.2",
      gene_id : "ENSG00000268041.2",
      gene_type : "protein_coding",
      gene_name : "ERFL",
      gene_level : 2,
      hgnc_id : "HGNC:53894",
      havana_gene : "OTTHUMG00000182736.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41956681,
      stop : 41959321,
      direction : "-",
      ID : "ENSG00000105404.11",
      gene_id : "ENSG00000105404.11",
      gene_type : "protein_coding",
      gene_name : "RABAC1",
      gene_level : 1,
      hgnc_id : "HGNC:9794",
      havana_gene : "OTTHUMG00000182737.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41956879,
      stop : 41994232,
      direction : "-",
      ID : "ENSG00000285505.1",
      gene_id : "ENSG00000285505.1",
      gene_type : "protein_coding",
      gene_name : "AC010616.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192534.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41966582,
      stop : 41997497,
      direction : "-",
      ID : "ENSG00000105409.19",
      gene_id : "ENSG00000105409.19",
      gene_type : "protein_coding",
      gene_name : "ATP1A3",
      gene_level : 1,
      hgnc_id : "HGNC:801",
      havana_gene : "OTTHUMG00000137384.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 41998321,
      stop : 42069498,
      direction : "-",
      ID : "ENSG00000105737.9",
      gene_id : "ENSG00000105737.9",
      gene_type : "protein_coding",
      gene_name : "GRIK5",
      gene_level : 2,
      hgnc_id : "HGNC:4583",
      havana_gene : "OTTHUMG00000044573.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42068477,
      stop : 42081552,
      direction : "+",
      ID : "ENSG00000105732.13",
      gene_id : "ENSG00000105732.13",
      gene_type : "protein_coding",
      gene_name : "ZNF574",
      gene_level : 2,
      hgnc_id : "HGNC:26166",
      havana_gene : "OTTHUMG00000182751.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42086110,
      stop : 42196585,
      direction : "-",
      ID : "ENSG00000028277.21",
      gene_id : "ENSG00000028277.21",
      gene_type : "protein_coding",
      gene_name : "POU2F2",
      gene_level : 2,
      hgnc_id : "HGNC:9213",
      havana_gene : "OTTHUMG00000165991.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42198598,
      stop : 42220140,
      direction : "-",
      ID : "ENSG00000160570.14",
      gene_id : "ENSG00000160570.14",
      gene_type : "protein_coding",
      gene_name : "DEDD2",
      gene_level : 2,
      hgnc_id : "HGNC:24450",
      havana_gene : "OTTHUMG00000182763.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42215133,
      stop : 42232149,
      direction : "-",
      ID : "ENSG00000288671.1",
      gene_id : "ENSG00000288671.1",
      gene_type : "protein_coding",
      gene_name : "AC006486.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42220312,
      stop : 42228201,
      direction : "+",
      ID : "ENSG00000167625.11",
      gene_id : "ENSG00000167625.11",
      gene_type : "protein_coding",
      gene_name : "ZNF526",
      gene_level : 2,
      hgnc_id : "HGNC:29415",
      havana_gene : "OTTHUMG00000182785.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42226225,
      stop : 42242625,
      direction : "-",
      ID : "ENSG00000105723.13",
      gene_id : "ENSG00000105723.13",
      gene_type : "protein_coding",
      gene_name : "GSK3A",
      gene_level : 2,
      hgnc_id : "HGNC:4616",
      havana_gene : "OTTHUMG00000150722.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42234583,
      stop : 42255132,
      direction : "-",
      ID : "ENSG00000268643.2",
      gene_id : "ENSG00000268643.2",
      gene_type : "protein_coding",
      gene_name : "AC006486.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182786.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42247569,
      stop : 42255128,
      direction : "-",
      ID : "ENSG00000105722.10",
      gene_id : "ENSG00000105722.10",
      gene_type : "protein_coding",
      gene_name : "ERF",
      gene_level : 2,
      hgnc_id : "HGNC:3444",
      havana_gene : "OTTHUMG00000182788.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42268537,
      stop : 42295797,
      direction : "+",
      ID : "ENSG00000079432.8",
      gene_id : "ENSG00000079432.8",
      gene_type : "protein_coding",
      gene_name : "CIC",
      gene_level : 1,
      hgnc_id : "HGNC:14214",
      havana_gene : "OTTHUMG00000182794.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42297033,
      stop : 42303546,
      direction : "-",
      ID : "ENSG00000079462.8",
      gene_id : "ENSG00000079462.8",
      gene_type : "protein_coding",
      gene_name : "PAFAH1B3",
      gene_level : 2,
      hgnc_id : "HGNC:8576",
      havana_gene : "OTTHUMG00000182795.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42302098,
      stop : 42310814,
      direction : "+",
      ID : "ENSG00000188368.11",
      gene_id : "ENSG00000188368.11",
      gene_type : "protein_coding",
      gene_name : "PRR19",
      gene_level : 2,
      hgnc_id : "HGNC:33728",
      havana_gene : "OTTHUMG00000182796.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42313309,
      stop : 42325064,
      direction : "+",
      ID : "ENSG00000167619.13",
      gene_id : "ENSG00000167619.13",
      gene_type : "protein_coding",
      gene_name : "TMEM145",
      gene_level : 1,
      hgnc_id : "HGNC:26912",
      havana_gene : "OTTHUMG00000177694.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42325609,
      stop : 42378769,
      direction : "+",
      ID : "ENSG00000105429.13",
      gene_id : "ENSG00000105429.13",
      gene_type : "protein_coding",
      gene_name : "MEGF8",
      gene_level : 2,
      hgnc_id : "HGNC:3233",
      havana_gene : "OTTHUMG00000150342.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42387019,
      stop : 42390297,
      direction : "-",
      ID : "ENSG00000105427.10",
      gene_id : "ENSG00000105427.10",
      gene_type : "protein_coding",
      gene_name : "CNFN",
      gene_level : 2,
      hgnc_id : "HGNC:30183",
      havana_gene : "OTTHUMG00000182813.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42401514,
      stop : 42427388,
      direction : "-",
      ID : "ENSG00000079435.10",
      gene_id : "ENSG00000079435.10",
      gene_type : "protein_coding",
      gene_name : "LIPE",
      gene_level : 1,
      hgnc_id : "HGNC:6621",
      havana_gene : "OTTHUMG00000182814.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42428278,
      stop : 42442946,
      direction : "-",
      ID : "ENSG00000189377.9",
      gene_id : "ENSG00000189377.9",
      gene_type : "protein_coding",
      gene_name : "CXCL17",
      gene_level : 2,
      hgnc_id : "HGNC:19232",
      havana_gene : "OTTHUMG00000182817.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42507304,
      stop : 42561234,
      direction : "-",
      ID : "ENSG00000079385.23",
      gene_id : "ENSG00000079385.23",
      gene_type : "protein_coding",
      gene_name : "CEACAM1",
      gene_level : 2,
      hgnc_id : "HGNC:1814",
      havana_gene : "OTTHUMG00000151078.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42580243,
      stop : 42595055,
      direction : "-",
      ID : "ENSG00000124469.12",
      gene_id : "ENSG00000124469.12",
      gene_type : "protein_coding",
      gene_name : "CEACAM8",
      gene_level : 2,
      hgnc_id : "HGNC:1820",
      havana_gene : "OTTHUMG00000151124.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42721638,
      stop : 42740481,
      direction : "-",
      ID : "ENSG00000221826.10",
      gene_id : "ENSG00000221826.10",
      gene_type : "protein_coding",
      gene_name : "PSG3",
      gene_level : 2,
      hgnc_id : "HGNC:9520",
      havana_gene : "OTTHUMG00000151120.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42752686,
      stop : 42855691,
      direction : "-",
      ID : "ENSG00000124467.19",
      gene_id : "ENSG00000124467.19",
      gene_type : "protein_coding",
      gene_name : "PSG8",
      gene_level : 1,
      hgnc_id : "HGNC:9525",
      havana_gene : "OTTHUMG00000151118.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42866464,
      stop : 42879822,
      direction : "-",
      ID : "ENSG00000231924.10",
      gene_id : "ENSG00000231924.10",
      gene_type : "protein_coding",
      gene_name : "PSG1",
      gene_level : 2,
      hgnc_id : "HGNC:9514",
      havana_gene : "OTTHUMG00000151123.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42902086,
      stop : 42919563,
      direction : "-",
      ID : "ENSG00000170848.16",
      gene_id : "ENSG00000170848.16",
      gene_type : "protein_coding",
      gene_name : "PSG6",
      gene_level : 1,
      hgnc_id : "HGNC:9523",
      havana_gene : "OTTHUMG00000151127.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 42924132,
      stop : 42937207,
      direction : "-",
      ID : "ENSG00000221878.13",
      gene_id : "ENSG00000221878.13",
      gene_type : "protein_coding",
      gene_name : "PSG7",
      gene_level : 2,
      hgnc_id : "HGNC:9524",
      havana_gene : "OTTHUMG00000151125.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43007656,
      stop : 43026474,
      direction : "-",
      ID : "ENSG00000243130.8",
      gene_id : "ENSG00000243130.8",
      gene_type : "protein_coding",
      gene_name : "PSG11",
      gene_level : 1,
      hgnc_id : "HGNC:9516",
      havana_gene : "OTTHUMG00000151546.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43064209,
      stop : 43083045,
      direction : "-",
      ID : "ENSG00000242221.9",
      gene_id : "ENSG00000242221.9",
      gene_type : "protein_coding",
      gene_name : "PSG2",
      gene_level : 2,
      hgnc_id : "HGNC:9519",
      havana_gene : "OTTHUMG00000151547.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43166256,
      stop : 43186536,
      direction : "-",
      ID : "ENSG00000204941.14",
      gene_id : "ENSG00000204941.14",
      gene_type : "protein_coding",
      gene_name : "PSG5",
      gene_level : 2,
      hgnc_id : "HGNC:9522",
      havana_gene : "OTTHUMG00000151539.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43192702,
      stop : 43207299,
      direction : "-",
      ID : "ENSG00000243137.8",
      gene_id : "ENSG00000243137.8",
      gene_type : "protein_coding",
      gene_name : "PSG4",
      gene_level : 1,
      hgnc_id : "HGNC:9521",
      havana_gene : "OTTHUMG00000151544.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43211791,
      stop : 43269530,
      direction : "-",
      ID : "ENSG00000183668.18",
      gene_id : "ENSG00000183668.18",
      gene_type : "protein_coding",
      gene_name : "PSG9",
      gene_level : 2,
      hgnc_id : "HGNC:9526",
      havana_gene : "OTTHUMG00000182826.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43353686,
      stop : 43363172,
      direction : "+",
      ID : "ENSG00000204936.10",
      gene_id : "ENSG00000204936.10",
      gene_type : "protein_coding",
      gene_name : "CD177",
      gene_level : 2,
      hgnc_id : "HGNC:30072",
      havana_gene : "OTTHUMG00000185320.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43401496,
      stop : 43418597,
      direction : "+",
      ID : "ENSG00000131126.19",
      gene_id : "ENSG00000131126.19",
      gene_type : "protein_coding",
      gene_name : "TEX101",
      gene_level : 2,
      hgnc_id : "HGNC:30722",
      havana_gene : "OTTHUMG00000182695.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43460787,
      stop : 43465608,
      direction : "-",
      ID : "ENSG00000124466.9",
      gene_id : "ENSG00000124466.9",
      gene_type : "protein_coding",
      gene_name : "LYPD3",
      gene_level : 2,
      hgnc_id : "HGNC:24880",
      havana_gene : "OTTHUMG00000182696.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43474954,
      stop : 43504935,
      direction : "-",
      ID : "ENSG00000176531.10",
      gene_id : "ENSG00000176531.10",
      gene_type : "protein_coding",
      gene_name : "PHLDB3",
      gene_level : 1,
      hgnc_id : "HGNC:30499",
      havana_gene : "OTTHUMG00000150693.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43506719,
      stop : 43527230,
      direction : "-",
      ID : "ENSG00000105755.8",
      gene_id : "ENSG00000105755.8",
      gene_type : "protein_coding",
      gene_name : "ETHE1",
      gene_level : 2,
      hgnc_id : "HGNC:23287",
      havana_gene : "OTTHUMG00000182697.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43525497,
      stop : 43536130,
      direction : "+",
      ID : "ENSG00000176472.10",
      gene_id : "ENSG00000176472.10",
      gene_type : "protein_coding",
      gene_name : "ZNF575",
      gene_level : 1,
      hgnc_id : "HGNC:27606",
      havana_gene : "OTTHUMG00000182698.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43543311,
      stop : 43580473,
      direction : "-",
      ID : "ENSG00000073050.12",
      gene_id : "ENSG00000073050.12",
      gene_type : "protein_coding",
      gene_name : "XRCC1",
      gene_level : 1,
      hgnc_id : "HGNC:12828",
      havana_gene : "OTTHUMG00000182699.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43554692,
      stop : 43593036,
      direction : "-",
      ID : "ENSG00000268361.1",
      gene_id : "ENSG00000268361.1",
      gene_type : "protein_coding",
      gene_name : "L34079.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182700.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43575801,
      stop : 43583964,
      direction : "+",
      ID : "ENSG00000234465.11",
      gene_id : "ENSG00000234465.11",
      gene_type : "protein_coding",
      gene_name : "PINLYP",
      gene_level : 1,
      hgnc_id : "HGNC:44206",
      havana_gene : "OTTHUMG00000175560.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43584369,
      stop : 43596135,
      direction : "-",
      ID : "ENSG00000167378.8",
      gene_id : "ENSG00000167378.8",
      gene_type : "protein_coding",
      gene_name : "IRGQ",
      gene_level : 2,
      hgnc_id : "HGNC:24868",
      havana_gene : "OTTHUMG00000182701.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43596392,
      stop : 43601157,
      direction : "+",
      ID : "ENSG00000124444.16",
      gene_id : "ENSG00000124444.16",
      gene_type : "protein_coding",
      gene_name : "ZNF576",
      gene_level : 2,
      hgnc_id : "HGNC:28357",
      havana_gene : "OTTHUMG00000165479.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43596617,
      stop : 43614498,
      direction : "+",
      ID : "ENSG00000226763.5",
      gene_id : "ENSG00000226763.5",
      gene_type : "protein_coding",
      gene_name : "SRRM5",
      gene_level : 2,
      hgnc_id : "HGNC:37248",
      havana_gene : "OTTHUMG00000165480.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43607224,
      stop : 43619629,
      direction : "-",
      ID : "ENSG00000131116.12",
      gene_id : "ENSG00000131116.12",
      gene_type : "protein_coding",
      gene_name : "ZNF428",
      gene_level : 2,
      hgnc_id : "HGNC:20804",
      havana_gene : "OTTHUMG00000182734.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43622368,
      stop : 43639850,
      direction : "-",
      ID : "ENSG00000105767.3",
      gene_id : "ENSG00000105767.3",
      gene_type : "protein_coding",
      gene_name : "CADM4",
      gene_level : 2,
      hgnc_id : "HGNC:30825",
      havana_gene : "OTTHUMG00000182735.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43646095,
      stop : 43670547,
      direction : "-",
      ID : "ENSG00000011422.12",
      gene_id : "ENSG00000011422.12",
      gene_type : "protein_coding",
      gene_name : "PLAUR",
      gene_level : 1,
      hgnc_id : "HGNC:9053",
      havana_gene : "OTTHUMG00000182778.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43716076,
      stop : 43720021,
      direction : "+",
      ID : "ENSG00000124449.7",
      gene_id : "ENSG00000124449.7",
      gene_type : "protein_coding",
      gene_name : "IRGC",
      gene_level : 2,
      hgnc_id : "HGNC:28835",
      havana_gene : "OTTHUMG00000154587.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43727983,
      stop : 43754962,
      direction : "-",
      ID : "ENSG00000105771.14",
      gene_id : "ENSG00000105771.14",
      gene_type : "protein_coding",
      gene_name : "SMG9",
      gene_level : 2,
      hgnc_id : "HGNC:25763",
      havana_gene : "OTTHUMG00000150337.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43766533,
      stop : 43781257,
      direction : "-",
      ID : "ENSG00000104783.14",
      gene_id : "ENSG00000104783.14",
      gene_type : "protein_coding",
      gene_name : "KCNN4",
      gene_level : 2,
      hgnc_id : "HGNC:6293",
      havana_gene : "OTTHUMG00000182779.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43785874,
      stop : 43827206,
      direction : "-",
      ID : "ENSG00000159871.15",
      gene_id : "ENSG00000159871.15",
      gene_type : "protein_coding",
      gene_name : "LYPD5",
      gene_level : 2,
      hgnc_id : "HGNC:26397",
      havana_gene : "OTTHUMG00000182781.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43827321,
      stop : 43852017,
      direction : "+",
      ID : "ENSG00000167637.18",
      gene_id : "ENSG00000167637.18",
      gene_type : "protein_coding",
      gene_name : "ZNF283",
      gene_level : 1,
      hgnc_id : "HGNC:13077",
      havana_gene : "OTTHUMG00000182186.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43872365,
      stop : 43901385,
      direction : "-",
      ID : "ENSG00000176222.9",
      gene_id : "ENSG00000176222.9",
      gene_type : "protein_coding",
      gene_name : "ZNF404",
      gene_level : 2,
      hgnc_id : "HGNC:19417",
      havana_gene : "OTTHUMG00000182206.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43912624,
      stop : 43935282,
      direction : "-",
      ID : "ENSG00000124459.12",
      gene_id : "ENSG00000124459.12",
      gene_type : "protein_coding",
      gene_name : "ZNF45",
      gene_level : 2,
      hgnc_id : "HGNC:13111",
      havana_gene : "OTTHUMG00000182189.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43951223,
      stop : 43967709,
      direction : "+",
      ID : "ENSG00000159905.15",
      gene_id : "ENSG00000159905.15",
      gene_type : "protein_coding",
      gene_name : "ZNF221",
      gene_level : 2,
      hgnc_id : "HGNC:13014",
      havana_gene : "OTTHUMG00000182214.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 43967862,
      stop : 43998326,
      direction : "+",
      ID : "ENSG00000204920.11",
      gene_id : "ENSG00000204920.11",
      gene_type : "protein_coding",
      gene_name : "ZNF155",
      gene_level : 1,
      hgnc_id : "HGNC:12940",
      havana_gene : "OTTHUMG00000182215.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44002957,
      stop : 44013924,
      direction : "+",
      ID : "ENSG00000159882.13",
      gene_id : "ENSG00000159882.13",
      gene_type : "protein_coding",
      gene_name : "ZNF230",
      gene_level : 2,
      hgnc_id : "HGNC:13024",
      havana_gene : "OTTHUMG00000182307.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44025342,
      stop : 44033110,
      direction : "+",
      ID : "ENSG00000159885.14",
      gene_id : "ENSG00000159885.14",
      gene_type : "protein_coding",
      gene_name : "ZNF222",
      gene_level : 1,
      hgnc_id : "HGNC:13015",
      havana_gene : "OTTHUMG00000182309.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44025354,
      stop : 44087318,
      direction : "+",
      ID : "ENSG00000267022.1",
      gene_id : "ENSG00000267022.1",
      gene_type : "protein_coding",
      gene_name : "AC067968.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182310.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44051367,
      stop : 44067999,
      direction : "+",
      ID : "ENSG00000178386.13",
      gene_id : "ENSG00000178386.13",
      gene_type : "protein_coding",
      gene_name : "ZNF223",
      gene_level : 2,
      hgnc_id : "HGNC:13016",
      havana_gene : "OTTHUMG00000182311.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44072159,
      stop : 44089613,
      direction : "+",
      ID : "ENSG00000186026.7",
      gene_id : "ENSG00000186026.7",
      gene_type : "protein_coding",
      gene_name : "ZNF284",
      gene_level : 2,
      hgnc_id : "HGNC:13078",
      havana_gene : "OTTHUMG00000182312.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44094339,
      stop : 44109886,
      direction : "+",
      ID : "ENSG00000267680.5",
      gene_id : "ENSG00000267680.5",
      gene_type : "protein_coding",
      gene_name : "ZNF224",
      gene_level : 2,
      hgnc_id : "HGNC:13017",
      havana_gene : "OTTHUMG00000182313.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44112181,
      stop : 44134822,
      direction : "+",
      ID : "ENSG00000256294.8",
      gene_id : "ENSG00000256294.8",
      gene_type : "protein_coding",
      gene_name : "ZNF225",
      gene_level : 2,
      hgnc_id : "HGNC:13018",
      havana_gene : "OTTHUMG00000182336.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44141554,
      stop : 44160313,
      direction : "+",
      ID : "ENSG00000263002.8",
      gene_id : "ENSG00000263002.8",
      gene_type : "protein_coding",
      gene_name : "ZNF234",
      gene_level : 2,
      hgnc_id : "HGNC:13027",
      havana_gene : "OTTHUMG00000182337.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44165073,
      stop : 44178381,
      direction : "+",
      ID : "ENSG00000167380.16",
      gene_id : "ENSG00000167380.16",
      gene_type : "protein_coding",
      gene_name : "ZNF226",
      gene_level : 2,
      hgnc_id : "HGNC:13019",
      havana_gene : "OTTHUMG00000182351.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44207547,
      stop : 44237268,
      direction : "+",
      ID : "ENSG00000131115.16",
      gene_id : "ENSG00000131115.16",
      gene_type : "protein_coding",
      gene_name : "ZNF227",
      gene_level : 1,
      hgnc_id : "HGNC:13020",
      havana_gene : "OTTHUMG00000182352.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44228729,
      stop : 44305046,
      direction : "-",
      ID : "ENSG00000159917.17",
      gene_id : "ENSG00000159917.17",
      gene_type : "protein_coding",
      gene_name : "ZNF235",
      gene_level : 2,
      hgnc_id : "HGNC:12866",
      havana_gene : "OTTHUMG00000182353.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44259880,
      stop : 44275317,
      direction : "+",
      ID : "ENSG00000159915.12",
      gene_id : "ENSG00000159915.12",
      gene_type : "protein_coding",
      gene_name : "ZNF233",
      gene_level : 1,
      hgnc_id : "HGNC:30946",
      havana_gene : "OTTHUMG00000182354.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44326555,
      stop : 44367217,
      direction : "-",
      ID : "ENSG00000062370.17",
      gene_id : "ENSG00000062370.17",
      gene_type : "protein_coding",
      gene_name : "ZNF112",
      gene_level : 2,
      hgnc_id : "HGNC:12892",
      havana_gene : "OTTHUMG00000182357.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44329695,
      stop : 44401608,
      direction : "-",
      ID : "ENSG00000267173.1",
      gene_id : "ENSG00000267173.1",
      gene_type : "protein_coding",
      gene_name : "AC245748.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182375.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44382298,
      stop : 44401608,
      direction : "-",
      ID : "ENSG00000267508.6",
      gene_id : "ENSG00000267508.6",
      gene_type : "protein_coding",
      gene_name : "ZNF285",
      gene_level : 2,
      hgnc_id : "HGNC:13079",
      havana_gene : "OTTHUMG00000178848.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44417519,
      stop : 44448578,
      direction : "-",
      ID : "ENSG00000278318.5",
      gene_id : "ENSG00000278318.5",
      gene_type : "protein_coding",
      gene_name : "ZNF229",
      gene_level : 2,
      hgnc_id : "HGNC:13022",
      havana_gene : "OTTHUMG00000182377.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44474428,
      stop : 44500524,
      direction : "-",
      ID : "ENSG00000167384.10",
      gene_id : "ENSG00000167384.10",
      gene_type : "protein_coding",
      gene_name : "ZNF180",
      gene_level : 1,
      hgnc_id : "HGNC:12970",
      havana_gene : "OTTHUMG00000180495.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44501677,
      stop : 44529788,
      direction : "-",
      ID : "ENSG00000273777.5",
      gene_id : "ENSG00000273777.5",
      gene_type : "protein_coding",
      gene_name : "CEACAM20",
      gene_level : 2,
      hgnc_id : "HGNC:24879",
      havana_gene : "OTTHUMG00000151532.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44613563,
      stop : 44636781,
      direction : "+",
      ID : "ENSG00000216588.9",
      gene_id : "ENSG00000216588.9",
      gene_type : "protein_coding",
      gene_name : "IGSF23",
      gene_level : 1,
      hgnc_id : "HGNC:40040",
      havana_gene : "OTTHUMG00000151531.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44643798,
      stop : 44666162,
      direction : "+",
      ID : "ENSG00000073008.15",
      gene_id : "ENSG00000073008.15",
      gene_type : "protein_coding",
      gene_name : "PVR",
      gene_level : 2,
      hgnc_id : "HGNC:9705",
      havana_gene : "OTTHUMG00000151527.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44662278,
      stop : 44684359,
      direction : "+",
      ID : "ENSG00000186567.13",
      gene_id : "ENSG00000186567.13",
      gene_type : "protein_coding",
      gene_name : "CEACAM19",
      gene_level : 2,
      hgnc_id : "HGNC:31951",
      havana_gene : "OTTHUMG00000151528.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44699151,
      stop : 44710718,
      direction : "+",
      ID : "ENSG00000213892.12",
      gene_id : "ENSG00000213892.12",
      gene_type : "protein_coding",
      gene_name : "CEACAM16",
      gene_level : 1,
      hgnc_id : "HGNC:31948",
      havana_gene : "OTTHUMG00000151519.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44747705,
      stop : 44760044,
      direction : "+",
      ID : "ENSG00000069399.15",
      gene_id : "ENSG00000069399.15",
      gene_type : "protein_coding",
      gene_name : "BCL3",
      gene_level : 1,
      hgnc_id : "HGNC:998",
      havana_gene : "OTTHUMG00000151517.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44777869,
      stop : 44800652,
      direction : "+",
      ID : "ENSG00000142273.13",
      gene_id : "ENSG00000142273.13",
      gene_type : "protein_coding",
      gene_name : "CBLC",
      gene_level : 2,
      hgnc_id : "HGNC:15961",
      havana_gene : "OTTHUMG00000150715.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44809071,
      stop : 44821421,
      direction : "+",
      ID : "ENSG00000187244.12",
      gene_id : "ENSG00000187244.12",
      gene_type : "protein_coding",
      gene_name : "BCAM",
      gene_level : 1,
      hgnc_id : "HGNC:6722",
      havana_gene : "OTTHUMG00000180838.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44846175,
      stop : 44889223,
      direction : "+",
      ID : "ENSG00000130202.10",
      gene_id : "ENSG00000130202.10",
      gene_type : "protein_coding",
      gene_name : "NECTIN2",
      gene_level : 1,
      hgnc_id : "HGNC:9707",
      havana_gene : "OTTHUMG00000180839.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44890569,
      stop : 44903689,
      direction : "+",
      ID : "ENSG00000130204.13",
      gene_id : "ENSG00000130204.13",
      gene_type : "protein_coding",
      gene_name : "TOMM40",
      gene_level : 2,
      hgnc_id : "HGNC:18001",
      havana_gene : "OTTHUMG00000180842.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44905791,
      stop : 44909393,
      direction : "+",
      ID : "ENSG00000130203.10",
      gene_id : "ENSG00000130203.10",
      gene_type : "protein_coding",
      gene_name : "APOE",
      gene_level : 2,
      hgnc_id : "HGNC:613",
      havana_gene : "OTTHUMG00000128901.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44914247,
      stop : 44919349,
      direction : "+",
      ID : "ENSG00000130208.9",
      gene_id : "ENSG00000130208.9",
      gene_type : "protein_coding",
      gene_name : "APOC1",
      gene_level : 2,
      hgnc_id : "HGNC:607",
      havana_gene : "OTTHUMG00000180844.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44942237,
      stop : 44945496,
      direction : "+",
      ID : "ENSG00000267467.4",
      gene_id : "ENSG00000267467.4",
      gene_type : "protein_coding",
      gene_name : "APOC4",
      gene_level : 2,
      hgnc_id : "HGNC:611",
      havana_gene : "OTTHUMG00000180845.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44942238,
      stop : 44949565,
      direction : "+",
      ID : "ENSG00000224916.9",
      gene_id : "ENSG00000224916.9",
      gene_type : "protein_coding",
      gene_name : "APOC4-APOC2",
      gene_level : 1,
      hgnc_id : "HGNC:44426",
      havana_gene : "OTTHUMG00000180846.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44946035,
      stop : 44949565,
      direction : "+",
      ID : "ENSG00000234906.11",
      gene_id : "ENSG00000234906.11",
      gene_type : "protein_coding",
      gene_name : "APOC2",
      gene_level : 2,
      hgnc_id : "HGNC:609",
      havana_gene : "OTTHUMG00000180847.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 44954585,
      stop : 44993341,
      direction : "+",
      ID : "ENSG00000104853.16",
      gene_id : "ENSG00000104853.16",
      gene_type : "protein_coding",
      gene_name : "CLPTM1",
      gene_level : 1,
      hgnc_id : "HGNC:2087",
      havana_gene : "OTTHUMG00000180849.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45001449,
      stop : 45038198,
      direction : "+",
      ID : "ENSG00000104856.14",
      gene_id : "ENSG00000104856.14",
      gene_type : "protein_coding",
      gene_name : "RELB",
      gene_level : 2,
      hgnc_id : "HGNC:9956",
      havana_gene : "OTTHUMG00000162116.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45039045,
      stop : 45070956,
      direction : "+",
      ID : "ENSG00000104859.15",
      gene_id : "ENSG00000104859.15",
      gene_type : "protein_coding",
      gene_name : "CLASRP",
      gene_level : 2,
      hgnc_id : "HGNC:17731",
      havana_gene : "OTTHUMG00000150189.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45071500,
      stop : 45076587,
      direction : "-",
      ID : "ENSG00000170684.9",
      gene_id : "ENSG00000170684.9",
      gene_type : "protein_coding",
      gene_name : "ZNF296",
      gene_level : 2,
      hgnc_id : "HGNC:15981",
      havana_gene : "OTTHUMG00000181766.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45079195,
      stop : 45091518,
      direction : "+",
      ID : "ENSG00000142252.11",
      gene_id : "ENSG00000142252.11",
      gene_type : "protein_coding",
      gene_name : "GEMIN7",
      gene_level : 2,
      hgnc_id : "HGNC:20045",
      havana_gene : "OTTHUMG00000181768.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45079288,
      stop : 45305284,
      direction : "+",
      ID : "ENSG00000007047.15",
      gene_id : "ENSG00000007047.15",
      gene_type : "protein_coding",
      gene_name : "MARK4",
      gene_level : 2,
      hgnc_id : "HGNC:13538",
      havana_gene : "OTTHUMG00000181769.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45091396,
      stop : 45148077,
      direction : "+",
      ID : "ENSG00000104866.11",
      gene_id : "ENSG00000104866.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R37",
      gene_level : 1,
      hgnc_id : "HGNC:27607",
      havana_gene : "OTTHUMG00000168143.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45149750,
      stop : 45160815,
      direction : "-",
      ID : "ENSG00000179846.10",
      gene_id : "ENSG00000179846.10",
      gene_type : "protein_coding",
      gene_name : "NKPD1",
      gene_level : 2,
      hgnc_id : "HGNC:24739",
      havana_gene : "OTTHUMG00000160521.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45162928,
      stop : 45178237,
      direction : "-",
      ID : "ENSG00000007255.10",
      gene_id : "ENSG00000007255.10",
      gene_type : "protein_coding",
      gene_name : "TRAPPC6A",
      gene_level : 1,
      hgnc_id : "HGNC:23069",
      havana_gene : "OTTHUMG00000181775.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45178784,
      stop : 45216933,
      direction : "+",
      ID : "ENSG00000189114.8",
      gene_id : "ENSG00000189114.8",
      gene_type : "protein_coding",
      gene_name : "BLOC1S3",
      gene_level : 1,
      hgnc_id : "HGNC:20914",
      havana_gene : "OTTHUMG00000181776.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45212370,
      stop : 45245407,
      direction : "-",
      ID : "ENSG00000283632.4",
      gene_id : "ENSG00000283632.4",
      gene_type : "protein_coding",
      gene_name : "EXOC3L2",
      gene_level : 2,
      hgnc_id : "HGNC:30162",
      havana_gene : "OTTHUMG00000155018.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45306413,
      stop : 45322875,
      direction : "-",
      ID : "ENSG00000104879.5",
      gene_id : "ENSG00000104879.5",
      gene_type : "protein_coding",
      gene_name : "CKM",
      gene_level : 2,
      hgnc_id : "HGNC:1994",
      havana_gene : "OTTHUMG00000181782.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45333434,
      stop : 45351520,
      direction : "+",
      ID : "ENSG00000104892.17",
      gene_id : "ENSG00000104892.17",
      gene_type : "protein_coding",
      gene_name : "KLC3",
      gene_level : 1,
      hgnc_id : "HGNC:20717",
      havana_gene : "OTTHUMG00000143722.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45349837,
      stop : 45370918,
      direction : "-",
      ID : "ENSG00000104884.16",
      gene_id : "ENSG00000104884.16",
      gene_type : "protein_coding",
      gene_name : "ERCC2",
      gene_level : 2,
      hgnc_id : "HGNC:3434",
      havana_gene : "OTTHUMG00000048190.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45379638,
      stop : 45406349,
      direction : "-",
      ID : "ENSG00000104881.16",
      gene_id : "ENSG00000104881.16",
      gene_type : "protein_coding",
      gene_name : "PPP1R13L",
      gene_level : 2,
      hgnc_id : "HGNC:18838",
      havana_gene : "OTTHUMG00000181784.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45406644,
      stop : 45410737,
      direction : "+",
      ID : "ENSG00000117877.11",
      gene_id : "ENSG00000117877.11",
      gene_type : "protein_coding",
      gene_name : "POLR1G",
      gene_level : 2,
      hgnc_id : "HGNC:24219",
      havana_gene : "OTTHUMG00000182120.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45407334,
      stop : 45478828,
      direction : "-",
      ID : "ENSG00000012061.16",
      gene_id : "ENSG00000012061.16",
      gene_type : "protein_coding",
      gene_name : "ERCC1",
      gene_level : 1,
      hgnc_id : "HGNC:3433",
      havana_gene : "OTTHUMG00000182121.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45467995,
      stop : 45475179,
      direction : "+",
      ID : "ENSG00000125740.14",
      gene_id : "ENSG00000125740.14",
      gene_type : "protein_coding",
      gene_name : "FOSB",
      gene_level : 1,
      hgnc_id : "HGNC:3797",
      havana_gene : "OTTHUMG00000182122.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45485294,
      stop : 45497055,
      direction : "-",
      ID : "ENSG00000125744.12",
      gene_id : "ENSG00000125744.12",
      gene_type : "protein_coding",
      gene_name : "RTN2",
      gene_level : 2,
      hgnc_id : "HGNC:10468",
      havana_gene : "OTTHUMG00000182123.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45488777,
      stop : 45502510,
      direction : "+",
      ID : "ENSG00000213889.10",
      gene_id : "ENSG00000213889.10",
      gene_type : "protein_coding",
      gene_name : "PPM1N",
      gene_level : 1,
      hgnc_id : "HGNC:26845",
      havana_gene : "OTTHUMG00000140397.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45506579,
      stop : 45526983,
      direction : "+",
      ID : "ENSG00000125753.14",
      gene_id : "ENSG00000125753.14",
      gene_type : "protein_coding",
      gene_name : "VASP",
      gene_level : 2,
      hgnc_id : "HGNC:12652",
      havana_gene : "OTTHUMG00000182124.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45527427,
      stop : 45602212,
      direction : "-",
      ID : "ENSG00000125741.5",
      gene_id : "ENSG00000125741.5",
      gene_type : "protein_coding",
      gene_name : "OPA3",
      gene_level : 2,
      hgnc_id : "HGNC:8142",
      havana_gene : "OTTHUMG00000182125.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45589764,
      stop : 45602212,
      direction : "-",
      ID : "ENSG00000177464.5",
      gene_id : "ENSG00000177464.5",
      gene_type : "protein_coding",
      gene_name : "GPR4",
      gene_level : 2,
      hgnc_id : "HGNC:4497",
      havana_gene : "OTTHUMG00000182126.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45606994,
      stop : 45645602,
      direction : "-",
      ID : "ENSG00000125746.18",
      gene_id : "ENSG00000125746.18",
      gene_type : "protein_coding",
      gene_name : "EML2",
      gene_level : 1,
      hgnc_id : "HGNC:18035",
      havana_gene : "OTTHUMG00000182127.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45668221,
      stop : 45683722,
      direction : "+",
      ID : "ENSG00000010310.9",
      gene_id : "ENSG00000010310.9",
      gene_type : "protein_coding",
      gene_name : "GIPR",
      gene_level : 1,
      hgnc_id : "HGNC:4271",
      havana_gene : "OTTHUMG00000182129.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45687460,
      stop : 45692569,
      direction : "-",
      ID : "ENSG00000125743.11",
      gene_id : "ENSG00000125743.11",
      gene_type : "protein_coding",
      gene_name : "SNRPD2",
      gene_level : 1,
      hgnc_id : "HGNC:11159",
      havana_gene : "OTTHUMG00000182130.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45692403,
      stop : 45703989,
      direction : "+",
      ID : "ENSG00000011478.13",
      gene_id : "ENSG00000011478.13",
      gene_type : "protein_coding",
      gene_name : "QPCTL",
      gene_level : 2,
      hgnc_id : "HGNC:25952",
      havana_gene : "OTTHUMG00000182131.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45710629,
      stop : 45730896,
      direction : "-",
      ID : "ENSG00000177051.6",
      gene_id : "ENSG00000177051.6",
      gene_type : "protein_coding",
      gene_name : "FBXO46",
      gene_level : 2,
      hgnc_id : "HGNC:25069",
      havana_gene : "OTTHUMG00000182132.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45733439,
      stop : 45764541,
      direction : "+",
      ID : "ENSG00000237452.3",
      gene_id : "ENSG00000237452.3",
      gene_type : "protein_coding",
      gene_name : "MEIOSIN",
      gene_level : 1,
      hgnc_id : "HGNC:44318",
      havana_gene : "OTTHUMG00000156178.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45764785,
      stop : 45769252,
      direction : "-",
      ID : "ENSG00000177045.10",
      gene_id : "ENSG00000177045.10",
      gene_type : "protein_coding",
      gene_name : "SIX5",
      gene_level : 1,
      hgnc_id : "HGNC:10891",
      havana_gene : "OTTHUMG00000172208.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45769709,
      stop : 45782552,
      direction : "-",
      ID : "ENSG00000104936.19",
      gene_id : "ENSG00000104936.19",
      gene_type : "protein_coding",
      gene_name : "DMPK",
      gene_level : 1,
      hgnc_id : "HGNC:2933",
      havana_gene : "OTTHUMG00000182334.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45779437,
      stop : 45785973,
      direction : "-",
      ID : "ENSG00000268434.5",
      gene_id : "ENSG00000268434.5",
      gene_type : "protein_coding",
      gene_name : "AC011530.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182481.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45782947,
      stop : 45792845,
      direction : "-",
      ID : "ENSG00000185800.12",
      gene_id : "ENSG00000185800.12",
      gene_type : "protein_coding",
      gene_name : "DMWD",
      gene_level : 1,
      hgnc_id : "HGNC:2936",
      havana_gene : "OTTHUMG00000169044.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45795713,
      stop : 45815308,
      direction : "-",
      ID : "ENSG00000104941.8",
      gene_id : "ENSG00000104941.8",
      gene_type : "protein_coding",
      gene_name : "RSPH6A",
      gene_level : 1,
      hgnc_id : "HGNC:14241",
      havana_gene : "OTTHUMG00000182482.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45815410,
      stop : 45863194,
      direction : "-",
      ID : "ENSG00000125755.19",
      gene_id : "ENSG00000125755.19",
      gene_type : "protein_coding",
      gene_name : "SYMPK",
      gene_level : 2,
      hgnc_id : "HGNC:22935",
      havana_gene : "OTTHUMG00000150151.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45863989,
      stop : 45873797,
      direction : "+",
      ID : "ENSG00000170608.3",
      gene_id : "ENSG00000170608.3",
      gene_type : "protein_coding",
      gene_name : "FOXA3",
      gene_level : 1,
      hgnc_id : "HGNC:5023",
      havana_gene : "OTTHUMG00000182484.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45883608,
      stop : 45886141,
      direction : "-",
      ID : "ENSG00000170604.5",
      gene_id : "ENSG00000170604.5",
      gene_type : "protein_coding",
      gene_name : "IRF2BP1",
      gene_level : 2,
      hgnc_id : "HGNC:21728",
      havana_gene : "OTTHUMG00000182485.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45890023,
      stop : 45902613,
      direction : "-",
      ID : "ENSG00000176182.6",
      gene_id : "ENSG00000176182.6",
      gene_type : "protein_coding",
      gene_name : "MYPOP",
      gene_level : 2,
      hgnc_id : "HGNC:20178",
      havana_gene : "OTTHUMG00000182486.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45913214,
      stop : 45914778,
      direction : "-",
      ID : "ENSG00000188425.4",
      gene_id : "ENSG00000188425.4",
      gene_type : "protein_coding",
      gene_name : "NANOS2",
      gene_level : 2,
      hgnc_id : "HGNC:23292",
      havana_gene : "OTTHUMG00000182487.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45933734,
      stop : 45974044,
      direction : "-",
      ID : "ENSG00000104967.8",
      gene_id : "ENSG00000104967.8",
      gene_type : "protein_coding",
      gene_name : "NOVA2",
      gene_level : 1,
      hgnc_id : "HGNC:7887",
      havana_gene : "OTTHUMG00000177499.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 45995461,
      stop : 46021318,
      direction : "+",
      ID : "ENSG00000104983.8",
      gene_id : "ENSG00000104983.8",
      gene_type : "protein_coding",
      gene_name : "CCDC61",
      gene_level : 1,
      hgnc_id : "HGNC:33629",
      havana_gene : "OTTHUMG00000182488.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46019153,
      stop : 46023053,
      direction : "-",
      ID : "ENSG00000008438.5",
      gene_id : "ENSG00000008438.5",
      gene_type : "protein_coding",
      gene_name : "PGLYRP1",
      gene_level : 2,
      hgnc_id : "HGNC:8904",
      havana_gene : "OTTHUMG00000182489.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46039748,
      stop : 46077118,
      direction : "-",
      ID : "ENSG00000204869.8",
      gene_id : "ENSG00000204869.8",
      gene_type : "protein_coding",
      gene_name : "IGFL4",
      gene_level : 2,
      hgnc_id : "HGNC:32931",
      havana_gene : "OTTHUMG00000182491.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46120067,
      stop : 46124688,
      direction : "-",
      ID : "ENSG00000188624.3",
      gene_id : "ENSG00000188624.3",
      gene_type : "protein_coding",
      gene_name : "IGFL3",
      gene_level : 2,
      hgnc_id : "HGNC:32930",
      havana_gene : "OTTHUMG00000172904.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46143106,
      stop : 46161299,
      direction : "+",
      ID : "ENSG00000204866.8",
      gene_id : "ENSG00000204866.8",
      gene_type : "protein_coding",
      gene_name : "IGFL2",
      gene_level : 2,
      hgnc_id : "HGNC:32929",
      havana_gene : "OTTHUMG00000182492.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46229742,
      stop : 46231243,
      direction : "+",
      ID : "ENSG00000188293.6",
      gene_id : "ENSG00000188293.6",
      gene_type : "protein_coding",
      gene_name : "IGFL1",
      gene_level : 2,
      hgnc_id : "HGNC:24093",
      havana_gene : "OTTHUMG00000182501.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46297042,
      stop : 46343433,
      direction : "+",
      ID : "ENSG00000124440.16",
      gene_id : "ENSG00000124440.16",
      gene_type : "protein_coding",
      gene_name : "HIF3A",
      gene_level : 2,
      hgnc_id : "HGNC:15825",
      havana_gene : "OTTHUMG00000141296.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46347087,
      stop : 46392981,
      direction : "+",
      ID : "ENSG00000011485.15",
      gene_id : "ENSG00000011485.15",
      gene_type : "protein_coding",
      gene_name : "PPP5C",
      gene_level : 1,
      hgnc_id : "HGNC:9322",
      havana_gene : "OTTHUMG00000134287.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46410329,
      stop : 46413564,
      direction : "-",
      ID : "ENSG00000169515.8",
      gene_id : "ENSG00000169515.8",
      gene_type : "protein_coding",
      gene_name : "CCDC8",
      gene_level : 2,
      hgnc_id : "HGNC:25367",
      havana_gene : "OTTHUMG00000162348.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46424697,
      stop : 46428951,
      direction : "-",
      ID : "ENSG00000277531.2",
      gene_id : "ENSG00000277531.2",
      gene_type : "protein_coding",
      gene_name : "PNMA8C",
      gene_level : 2,
      hgnc_id : "HGNC:53427",
      havana_gene : "OTTHUMG00000186767.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46466491,
      stop : 46471563,
      direction : "-",
      ID : "ENSG00000182013.18",
      gene_id : "ENSG00000182013.18",
      gene_type : "protein_coding",
      gene_name : "PNMA8A",
      gene_level : 2,
      hgnc_id : "HGNC:25578",
      havana_gene : "OTTHUMG00000169421.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46486906,
      stop : 46495879,
      direction : "-",
      ID : "ENSG00000204851.7",
      gene_id : "ENSG00000204851.7",
      gene_type : "protein_coding",
      gene_name : "PNMA8B",
      gene_level : 2,
      hgnc_id : "HGNC:29206",
      havana_gene : "OTTHUMG00000183426.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46601074,
      stop : 46610782,
      direction : "+",
      ID : "ENSG00000160014.17",
      gene_id : "ENSG00000160014.17",
      gene_type : "protein_coding",
      gene_name : "CALM3",
      gene_level : 2,
      hgnc_id : "HGNC:1449",
      havana_gene : "OTTHUMG00000133517.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46620468,
      stop : 46625089,
      direction : "-",
      ID : "ENSG00000160013.9",
      gene_id : "ENSG00000160013.9",
      gene_type : "protein_coding",
      gene_name : "PTGIR",
      gene_level : 1,
      hgnc_id : "HGNC:9602",
      havana_gene : "OTTHUMG00000183429.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46634076,
      stop : 46634685,
      direction : "-",
      ID : "ENSG00000167414.4",
      gene_id : "ENSG00000167414.4",
      gene_type : "protein_coding",
      gene_name : "GNG8",
      gene_level : 2,
      hgnc_id : "HGNC:19664",
      havana_gene : "OTTHUMG00000183430.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46647551,
      stop : 46661182,
      direction : "-",
      ID : "ENSG00000197380.11",
      gene_id : "ENSG00000197380.11",
      gene_type : "protein_coding",
      gene_name : "DACT3",
      gene_level : 1,
      hgnc_id : "HGNC:30745",
      havana_gene : "OTTHUMG00000153070.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46674275,
      stop : 46717127,
      direction : "-",
      ID : "ENSG00000105287.13",
      gene_id : "ENSG00000105287.13",
      gene_type : "protein_coding",
      gene_name : "PRKD2",
      gene_level : 1,
      hgnc_id : "HGNC:17293",
      havana_gene : "OTTHUMG00000183431.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46719511,
      stop : 46746994,
      direction : "-",
      ID : "ENSG00000090372.15",
      gene_id : "ENSG00000090372.15",
      gene_type : "protein_coding",
      gene_name : "STRN4",
      gene_level : 1,
      hgnc_id : "HGNC:15721",
      havana_gene : "OTTHUMG00000183432.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46746046,
      stop : 46776988,
      direction : "+",
      ID : "ENSG00000181027.11",
      gene_id : "ENSG00000181027.11",
      gene_type : "protein_coding",
      gene_name : "FKRP",
      gene_level : 2,
      hgnc_id : "HGNC:17997",
      havana_gene : "OTTHUMG00000183177.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46774883,
      stop : 46788594,
      direction : "-",
      ID : "ENSG00000105281.12",
      gene_id : "ENSG00000105281.12",
      gene_type : "protein_coding",
      gene_name : "SLC1A5",
      gene_level : 2,
      hgnc_id : "HGNC:10943",
      havana_gene : "OTTHUMG00000183434.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46838136,
      stop : 46850846,
      direction : "-",
      ID : "ENSG00000042753.12",
      gene_id : "ENSG00000042753.12",
      gene_type : "protein_coding",
      gene_name : "AP2S1",
      gene_level : 1,
      hgnc_id : "HGNC:565",
      havana_gene : "OTTHUMG00000183437.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 46860997,
      stop : 47005077,
      direction : "+",
      ID : "ENSG00000160007.19",
      gene_id : "ENSG00000160007.19",
      gene_type : "protein_coding",
      gene_name : "ARHGAP35",
      gene_level : 2,
      hgnc_id : "HGNC:4591",
      havana_gene : "OTTHUMG00000183438.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47019837,
      stop : 47045775,
      direction : "+",
      ID : "ENSG00000130751.10",
      gene_id : "ENSG00000130751.10",
      gene_type : "protein_coding",
      gene_name : "NPAS1",
      gene_level : 1,
      hgnc_id : "HGNC:7894",
      havana_gene : "OTTHUMG00000183440.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47045909,
      stop : 47048624,
      direction : "-",
      ID : "ENSG00000130748.7",
      gene_id : "ENSG00000130748.7",
      gene_type : "protein_coding",
      gene_name : "TMEM160",
      gene_level : 2,
      hgnc_id : "HGNC:26042",
      havana_gene : "OTTHUMG00000183441.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47064187,
      stop : 47113776,
      direction : "-",
      ID : "ENSG00000130749.10",
      gene_id : "ENSG00000130749.10",
      gene_type : "protein_coding",
      gene_name : "ZC3H4",
      gene_level : 1,
      hgnc_id : "HGNC:17808",
      havana_gene : "OTTHUMG00000183442.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47113274,
      stop : 47210636,
      direction : "+",
      ID : "ENSG00000142230.13",
      gene_id : "ENSG00000142230.13",
      gene_type : "protein_coding",
      gene_name : "SAE1",
      gene_level : 1,
      hgnc_id : "HGNC:30660",
      havana_gene : "OTTHUMG00000183464.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47220822,
      stop : 47232766,
      direction : "-",
      ID : "ENSG00000105327.18",
      gene_id : "ENSG00000105327.18",
      gene_type : "protein_coding",
      gene_name : "BBC3",
      gene_level : 2,
      hgnc_id : "HGNC:17868",
      havana_gene : "OTTHUMG00000183489.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47255980,
      stop : 47273701,
      direction : "+",
      ID : "ENSG00000105321.14",
      gene_id : "ENSG00000105321.14",
      gene_type : "protein_coding",
      gene_name : "CCDC9",
      gene_level : 2,
      hgnc_id : "HGNC:24560",
      havana_gene : "OTTHUMG00000183503.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47274885,
      stop : 47275723,
      direction : "+",
      ID : "ENSG00000257704.4",
      gene_id : "ENSG00000257704.4",
      gene_type : "protein_coding",
      gene_name : "INAFM1",
      gene_level : 2,
      hgnc_id : "HGNC:27406",
      havana_gene : "OTTHUMG00000170128.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47290023,
      stop : 47322066,
      direction : "+",
      ID : "ENSG00000197405.8",
      gene_id : "ENSG00000197405.8",
      gene_type : "protein_coding",
      gene_name : "C5AR1",
      gene_level : 2,
      hgnc_id : "HGNC:1338",
      havana_gene : "OTTHUMG00000183504.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47332175,
      stop : 47347329,
      direction : "+",
      ID : "ENSG00000134830.6",
      gene_id : "ENSG00000134830.6",
      gene_type : "protein_coding",
      gene_name : "C5AR2",
      gene_level : 2,
      hgnc_id : "HGNC:4527",
      havana_gene : "OTTHUMG00000183505.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47349315,
      stop : 47382704,
      direction : "+",
      ID : "ENSG00000134815.19",
      gene_id : "ENSG00000134815.19",
      gene_type : "protein_coding",
      gene_name : "DHX34",
      gene_level : 2,
      hgnc_id : "HGNC:16719",
      havana_gene : "OTTHUMG00000149959.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47403124,
      stop : 47419527,
      direction : "-",
      ID : "ENSG00000105419.18",
      gene_id : "ENSG00000105419.18",
      gene_type : "protein_coding",
      gene_name : "MEIS3",
      gene_level : 1,
      hgnc_id : "HGNC:29537",
      havana_gene : "OTTHUMG00000172280.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47428017,
      stop : 47471893,
      direction : "-",
      ID : "ENSG00000118160.14",
      gene_id : "ENSG00000118160.14",
      gene_type : "protein_coding",
      gene_name : "SLC8A2",
      gene_level : 1,
      hgnc_id : "HGNC:11069",
      havana_gene : "OTTHUMG00000183529.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47475150,
      stop : 47484265,
      direction : "-",
      ID : "ENSG00000118162.14",
      gene_id : "ENSG00000118162.14",
      gene_type : "protein_coding",
      gene_name : "KPTN",
      gene_level : 2,
      hgnc_id : "HGNC:6404",
      havana_gene : "OTTHUMG00000183443.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47487637,
      stop : 47515091,
      direction : "-",
      ID : "ENSG00000105402.8",
      gene_id : "ENSG00000105402.8",
      gene_type : "protein_coding",
      gene_name : "NAPA",
      gene_level : 2,
      hgnc_id : "HGNC:7641",
      havana_gene : "OTTHUMG00000183294.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47520685,
      stop : 47555856,
      direction : "-",
      ID : "ENSG00000118156.12",
      gene_id : "ENSG00000118156.12",
      gene_type : "protein_coding",
      gene_name : "ZNF541",
      gene_level : 1,
      hgnc_id : "HGNC:25294",
      havana_gene : "OTTHUMG00000141262.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47608196,
      stop : 47703277,
      direction : "+",
      ID : "ENSG00000063169.11",
      gene_id : "ENSG00000063169.11",
      gene_type : "protein_coding",
      gene_name : "BICRA",
      gene_level : 2,
      hgnc_id : "HGNC:4332",
      havana_gene : "OTTHUMG00000183263.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47713422,
      stop : 47743134,
      direction : "+",
      ID : "ENSG00000024422.12",
      gene_id : "ENSG00000024422.12",
      gene_type : "protein_coding",
      gene_name : "EHD2",
      gene_level : 2,
      hgnc_id : "HGNC:3243",
      havana_gene : "OTTHUMG00000183266.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47745546,
      stop : 47757058,
      direction : "+",
      ID : "ENSG00000105373.19",
      gene_id : "ENSG00000105373.19",
      gene_type : "protein_coding",
      gene_name : "NOP53",
      gene_level : 2,
      hgnc_id : "HGNC:4333",
      havana_gene : "OTTHUMG00000183059.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47778585,
      stop : 47784686,
      direction : "+",
      ID : "ENSG00000178980.15",
      gene_id : "ENSG00000178980.15",
      gene_type : "protein_coding",
      gene_name : "SELENOW",
      gene_level : 2,
      hgnc_id : "HGNC:10752",
      havana_gene : "OTTHUMG00000183061.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47801243,
      stop : 47819051,
      direction : "-",
      ID : "ENSG00000178928.8",
      gene_id : "ENSG00000178928.8",
      gene_type : "protein_coding",
      gene_name : "TPRX1",
      gene_level : 2,
      hgnc_id : "HGNC:32174",
      havana_gene : "OTTHUMG00000170628.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47819779,
      stop : 47843330,
      direction : "+",
      ID : "ENSG00000105392.16",
      gene_id : "ENSG00000105392.16",
      gene_type : "protein_coding",
      gene_name : "CRX",
      gene_level : 2,
      hgnc_id : "HGNC:2383",
      havana_gene : "OTTHUMG00000170610.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47870467,
      stop : 47886315,
      direction : "-",
      ID : "ENSG00000105398.4",
      gene_id : "ENSG00000105398.4",
      gene_type : "protein_coding",
      gene_name : "SULT2A1",
      gene_level : 2,
      hgnc_id : "HGNC:11458",
      havana_gene : "OTTHUMG00000162469.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47968046,
      stop : 47992170,
      direction : "-",
      ID : "ENSG00000188334.3",
      gene_id : "ENSG00000188334.3",
      gene_type : "protein_coding",
      gene_name : "BSPH1",
      gene_level : 2,
      hgnc_id : "HGNC:33906",
      havana_gene : "OTTHUMG00000183137.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 47994632,
      stop : 48025154,
      direction : "+",
      ID : "ENSG00000169393.9",
      gene_id : "ENSG00000169393.9",
      gene_type : "protein_coding",
      gene_name : "ELSPBP1",
      gene_level : 1,
      hgnc_id : "HGNC:14417",
      havana_gene : "OTTHUMG00000183138.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48029383,
      stop : 48044079,
      direction : "-",
      ID : "ENSG00000105507.3",
      gene_id : "ENSG00000105507.3",
      gene_type : "protein_coding",
      gene_name : "CABP5",
      gene_level : 2,
      hgnc_id : "HGNC:13714",
      havana_gene : "OTTHUMG00000183139.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48047843,
      stop : 48110817,
      direction : "-",
      ID : "ENSG00000105499.14",
      gene_id : "ENSG00000105499.14",
      gene_type : "protein_coding",
      gene_name : "PLA2G4C",
      gene_level : 2,
      hgnc_id : "HGNC:9037",
      havana_gene : "OTTHUMG00000183185.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48115445,
      stop : 48170603,
      direction : "-",
      ID : "ENSG00000105486.14",
      gene_id : "ENSG00000105486.14",
      gene_type : "protein_coding",
      gene_name : "LIG1",
      gene_level : 2,
      hgnc_id : "HGNC:6598",
      havana_gene : "OTTHUMG00000183187.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48170680,
      stop : 48197620,
      direction : "+",
      ID : "ENSG00000185453.13",
      gene_id : "ENSG00000185453.13",
      gene_type : "protein_coding",
      gene_name : "ZSWIM9",
      gene_level : 2,
      hgnc_id : "HGNC:34495",
      havana_gene : "OTTHUMG00000183190.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48180770,
      stop : 48255946,
      direction : "-",
      ID : "ENSG00000105483.18",
      gene_id : "ENSG00000105483.18",
      gene_type : "protein_coding",
      gene_name : "CARD8",
      gene_level : 2,
      hgnc_id : "HGNC:17057",
      havana_gene : "OTTHUMG00000165047.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48270081,
      stop : 48287608,
      direction : "+",
      ID : "ENSG00000178150.10",
      gene_id : "ENSG00000178150.10",
      gene_type : "protein_coding",
      gene_name : "ZNF114",
      gene_level : 2,
      hgnc_id : "HGNC:12894",
      havana_gene : "OTTHUMG00000183191.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48296457,
      stop : 48321971,
      direction : "-",
      ID : "ENSG00000105479.16",
      gene_id : "ENSG00000105479.16",
      gene_type : "protein_coding",
      gene_name : "CCDC114",
      gene_level : 2,
      hgnc_id : "HGNC:26560",
      havana_gene : "OTTHUMG00000156161.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48321509,
      stop : 48330553,
      direction : "+",
      ID : "ENSG00000142227.11",
      gene_id : "ENSG00000142227.11",
      gene_type : "protein_coding",
      gene_name : "EMP3",
      gene_level : 1,
      hgnc_id : "HGNC:3335",
      havana_gene : "OTTHUMG00000183196.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48332356,
      stop : 48364059,
      direction : "-",
      ID : "ENSG00000161558.11",
      gene_id : "ENSG00000161558.11",
      gene_type : "protein_coding",
      gene_name : "TMEM143",
      gene_level : 1,
      hgnc_id : "HGNC:25603",
      havana_gene : "OTTHUMG00000183197.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48364367,
      stop : 48376377,
      direction : "+",
      ID : "ENSG00000105467.9",
      gene_id : "ENSG00000105467.9",
      gene_type : "protein_coding",
      gene_name : "SYNGR4",
      gene_level : 1,
      hgnc_id : "HGNC:11502",
      havana_gene : "OTTHUMG00000183214.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48382575,
      stop : 48391551,
      direction : "-",
      ID : "ENSG00000105438.9",
      gene_id : "ENSG00000105438.9",
      gene_type : "protein_coding",
      gene_name : "KDELR1",
      gene_level : 1,
      hgnc_id : "HGNC:6304",
      havana_gene : "OTTHUMG00000183215.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48393668,
      stop : 48444931,
      direction : "+",
      ID : "ENSG00000105464.4",
      gene_id : "ENSG00000105464.4",
      gene_type : "protein_coding",
      gene_name : "GRIN2D",
      gene_level : 2,
      hgnc_id : "HGNC:4588",
      havana_gene : "OTTHUMG00000183304.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48445841,
      stop : 48457022,
      direction : "+",
      ID : "ENSG00000105447.13",
      gene_id : "ENSG00000105447.13",
      gene_type : "protein_coding",
      gene_name : "GRWD1",
      gene_level : 1,
      hgnc_id : "HGNC:21270",
      havana_gene : "OTTHUMG00000183305.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48455574,
      stop : 48466980,
      direction : "+",
      ID : "ENSG00000182324.7",
      gene_id : "ENSG00000182324.7",
      gene_type : "protein_coding",
      gene_name : "KCNJ14",
      gene_level : 2,
      hgnc_id : "HGNC:6260",
      havana_gene : "OTTHUMG00000183307.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48465837,
      stop : 48472431,
      direction : "+",
      ID : "ENSG00000268465.1",
      gene_id : "ENSG00000268465.1",
      gene_type : "protein_coding",
      gene_name : "AC008403.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183309.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48469208,
      stop : 48482314,
      direction : "+",
      ID : "ENSG00000105443.15",
      gene_id : "ENSG00000105443.15",
      gene_type : "protein_coding",
      gene_name : "CYTH2",
      gene_level : 1,
      hgnc_id : "HGNC:9502",
      havana_gene : "OTTHUMG00000150245.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48485271,
      stop : 48513935,
      direction : "-",
      ID : "ENSG00000142235.12",
      gene_id : "ENSG00000142235.12",
      gene_type : "protein_coding",
      gene_name : "LMTK3",
      gene_level : 2,
      hgnc_id : "HGNC:19295",
      havana_gene : "OTTHUMG00000183312.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48552172,
      stop : 48599425,
      direction : "+",
      ID : "ENSG00000088002.12",
      gene_id : "ENSG00000088002.12",
      gene_type : "protein_coding",
      gene_name : "SULT2B1",
      gene_level : 2,
      hgnc_id : "HGNC:11459",
      havana_gene : "OTTHUMG00000183314.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48599961,
      stop : 48615076,
      direction : "-",
      ID : "ENSG00000105523.4",
      gene_id : "ENSG00000105523.4",
      gene_type : "protein_coding",
      gene_name : "FAM83E",
      gene_level : 2,
      hgnc_id : "HGNC:25972",
      havana_gene : "OTTHUMG00000183315.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48606742,
      stop : 48607714,
      direction : "+",
      ID : "ENSG00000177202.3",
      gene_id : "ENSG00000177202.3",
      gene_type : "protein_coding",
      gene_name : "SPACA4",
      gene_level : 2,
      hgnc_id : "HGNC:16441",
      havana_gene : "OTTHUMG00000183316.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48615328,
      stop : 48619184,
      direction : "-",
      ID : "ENSG00000063177.13",
      gene_id : "ENSG00000063177.13",
      gene_type : "protein_coding",
      gene_name : "RPL18",
      gene_level : 1,
      hgnc_id : "HGNC:10310",
      havana_gene : "OTTHUMG00000169760.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48619291,
      stop : 48630717,
      direction : "+",
      ID : "ENSG00000063176.16",
      gene_id : "ENSG00000063176.16",
      gene_type : "protein_coding",
      gene_name : "SPHK2",
      gene_level : 1,
      hgnc_id : "HGNC:18859",
      havana_gene : "OTTHUMG00000183318.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48630030,
      stop : 48637379,
      direction : "-",
      ID : "ENSG00000105516.11",
      gene_id : "ENSG00000105516.11",
      gene_type : "protein_coding",
      gene_name : "DBP",
      gene_level : 1,
      hgnc_id : "HGNC:2697",
      havana_gene : "OTTHUMG00000183319.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48637946,
      stop : 48646187,
      direction : "-",
      ID : "ENSG00000063180.9",
      gene_id : "ENSG00000063180.9",
      gene_type : "protein_coding",
      gene_name : "CA11",
      gene_level : 2,
      hgnc_id : "HGNC:1370",
      havana_gene : "OTTHUMG00000183320.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48661407,
      stop : 48673081,
      direction : "-",
      ID : "ENSG00000142233.14",
      gene_id : "ENSG00000142233.14",
      gene_type : "protein_coding",
      gene_name : "NTN5",
      gene_level : 1,
      hgnc_id : "HGNC:25208",
      havana_gene : "OTTHUMG00000183321.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48695971,
      stop : 48705951,
      direction : "+",
      ID : "ENSG00000176920.13",
      gene_id : "ENSG00000176920.13",
      gene_type : "protein_coding",
      gene_name : "FUT2",
      gene_level : 2,
      hgnc_id : "HGNC:4013",
      havana_gene : "OTTHUMG00000164427.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48712725,
      stop : 48719725,
      direction : "-",
      ID : "ENSG00000176909.12",
      gene_id : "ENSG00000176909.12",
      gene_type : "protein_coding",
      gene_name : "MAMSTR",
      gene_level : 2,
      hgnc_id : "HGNC:26689",
      havana_gene : "OTTHUMG00000183322.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48720585,
      stop : 48740610,
      direction : "-",
      ID : "ENSG00000105538.10",
      gene_id : "ENSG00000105538.10",
      gene_type : "protein_coding",
      gene_name : "RASIP1",
      gene_level : 1,
      hgnc_id : "HGNC:24716",
      havana_gene : "OTTHUMG00000183323.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48740852,
      stop : 48746909,
      direction : "-",
      ID : "ENSG00000182264.9",
      gene_id : "ENSG00000182264.9",
      gene_type : "protein_coding",
      gene_name : "IZUMO1",
      gene_level : 2,
      hgnc_id : "HGNC:28539",
      havana_gene : "OTTHUMG00000183324.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48748011,
      stop : 48755390,
      direction : "-",
      ID : "ENSG00000174951.12",
      gene_id : "ENSG00000174951.12",
      gene_type : "protein_coding",
      gene_name : "FUT1",
      gene_level : 2,
      hgnc_id : "HGNC:4012",
      havana_gene : "OTTHUMG00000183325.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48755524,
      stop : 48758333,
      direction : "+",
      ID : "ENSG00000105550.10",
      gene_id : "ENSG00000105550.10",
      gene_type : "protein_coding",
      gene_name : "FGF21",
      gene_level : 2,
      hgnc_id : "HGNC:3678",
      havana_gene : "OTTHUMG00000183326.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48795062,
      stop : 48811029,
      direction : "-",
      ID : "ENSG00000105552.15",
      gene_id : "ENSG00000105552.15",
      gene_type : "protein_coding",
      gene_name : "BCAT2",
      gene_level : 1,
      hgnc_id : "HGNC:977",
      havana_gene : "OTTHUMG00000183327.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48813018,
      stop : 48836510,
      direction : "-",
      ID : "ENSG00000087076.9",
      gene_id : "ENSG00000087076.9",
      gene_type : "protein_coding",
      gene_name : "HSD17B14",
      gene_level : 1,
      hgnc_id : "HGNC:23238",
      havana_gene : "OTTHUMG00000183328.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48837097,
      stop : 48868617,
      direction : "-",
      ID : "ENSG00000105559.12",
      gene_id : "ENSG00000105559.12",
      gene_type : "protein_coding",
      gene_name : "PLEKHA4",
      gene_level : 1,
      hgnc_id : "HGNC:14339",
      havana_gene : "OTTHUMG00000183329.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48872421,
      stop : 48876058,
      direction : "+",
      ID : "ENSG00000087074.8",
      gene_id : "ENSG00000087074.8",
      gene_type : "protein_coding",
      gene_name : "PPP1R15A",
      gene_level : 2,
      hgnc_id : "HGNC:14375",
      havana_gene : "OTTHUMG00000183330.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48880967,
      stop : 48898744,
      direction : "-",
      ID : "ENSG00000104804.8",
      gene_id : "ENSG00000104804.8",
      gene_type : "protein_coding",
      gene_name : "TULP2",
      gene_level : 1,
      hgnc_id : "HGNC:12424",
      havana_gene : "OTTHUMG00000164406.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48900312,
      stop : 48923372,
      direction : "+",
      ID : "ENSG00000104805.16",
      gene_id : "ENSG00000104805.16",
      gene_type : "protein_coding",
      gene_name : "NUCB1",
      gene_level : 2,
      hgnc_id : "HGNC:8043",
      havana_gene : "OTTHUMG00000152514.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48933699,
      stop : 48944969,
      direction : "+",
      ID : "ENSG00000104808.8",
      gene_id : "ENSG00000104808.8",
      gene_type : "protein_coding",
      gene_name : "DHDH",
      gene_level : 1,
      hgnc_id : "HGNC:17887",
      havana_gene : "OTTHUMG00000165029.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48954815,
      stop : 48961798,
      direction : "+",
      ID : "ENSG00000087088.20",
      gene_id : "ENSG00000087088.20",
      gene_type : "protein_coding",
      gene_name : "BAX",
      gene_level : 2,
      hgnc_id : "HGNC:959",
      havana_gene : "OTTHUMG00000160476.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48965309,
      stop : 48966879,
      direction : "+",
      ID : "ENSG00000087086.15",
      gene_id : "ENSG00000087086.15",
      gene_type : "protein_coding",
      gene_name : "FTL",
      gene_level : 2,
      hgnc_id : "HGNC:3999",
      havana_gene : "OTTHUMG00000183332.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48968130,
      stop : 48993310,
      direction : "-",
      ID : "ENSG00000104812.15",
      gene_id : "ENSG00000104812.15",
      gene_type : "protein_coding",
      gene_name : "GYS1",
      gene_level : 1,
      hgnc_id : "HGNC:4706",
      havana_gene : "OTTHUMG00000150723.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 48993562,
      stop : 49015970,
      direction : "+",
      ID : "ENSG00000183207.14",
      gene_id : "ENSG00000183207.14",
      gene_type : "protein_coding",
      gene_name : "RUVBL2",
      gene_level : 2,
      hgnc_id : "HGNC:10475",
      havana_gene : "OTTHUMG00000183333.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49015980,
      stop : 49017091,
      direction : "-",
      ID : "ENSG00000104826.15",
      gene_id : "ENSG00000104826.15",
      gene_type : "protein_coding",
      gene_name : "LHB",
      gene_level : 2,
      hgnc_id : "HGNC:6584",
      havana_gene : "OTTHUMG00000183334.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49017496,
      stop : 49020523,
      direction : "-",
      ID : "ENSG00000268655.2",
      gene_id : "ENSG00000268655.2",
      gene_type : "protein_coding",
      gene_name : "AC008687.4",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000183335.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49022869,
      stop : 49024333,
      direction : "-",
      ID : "ENSG00000104827.12",
      gene_id : "ENSG00000104827.12",
      gene_type : "protein_coding",
      gene_name : "CGB3",
      gene_level : 2,
      hgnc_id : "HGNC:1886",
      havana_gene : "OTTHUMG00000180605.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49022953,
      stop : 49036895,
      direction : "-",
      ID : "ENSG00000267335.2",
      gene_id : "ENSG00000267335.2",
      gene_type : "protein_coding",
      gene_name : "AC008687.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180606.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49031890,
      stop : 49033238,
      direction : "+",
      ID : "ENSG00000104818.15",
      gene_id : "ENSG00000104818.15",
      gene_type : "protein_coding",
      gene_name : "CGB2",
      gene_level : 2,
      hgnc_id : "HGNC:16722",
      havana_gene : "OTTHUMG00000150185.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49035569,
      stop : 49036895,
      direction : "-",
      ID : "ENSG00000267631.5",
      gene_id : "ENSG00000267631.5",
      gene_type : "protein_coding",
      gene_name : "CGB1",
      gene_level : 2,
      hgnc_id : "HGNC:16721",
      havana_gene : "OTTHUMG00000150186.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49043848,
      stop : 49045311,
      direction : "+",
      ID : "ENSG00000189052.7",
      gene_id : "ENSG00000189052.7",
      gene_type : "protein_coding",
      gene_name : "CGB5",
      gene_level : 2,
      hgnc_id : "HGNC:16452",
      havana_gene : "OTTHUMG00000183337.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49047638,
      stop : 49049106,
      direction : "-",
      ID : "ENSG00000213030.5",
      gene_id : "ENSG00000213030.5",
      gene_type : "protein_coding",
      gene_name : "CGB8",
      gene_level : 2,
      hgnc_id : "HGNC:16453",
      havana_gene : "OTTHUMG00000180609.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49054275,
      stop : 49058860,
      direction : "-",
      ID : "ENSG00000196337.12",
      gene_id : "ENSG00000196337.12",
      gene_type : "protein_coding",
      gene_name : "CGB7",
      gene_level : 2,
      hgnc_id : "HGNC:16451",
      havana_gene : "OTTHUMG00000183339.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49055793,
      stop : 49065076,
      direction : "-",
      ID : "ENSG00000283663.1",
      gene_id : "ENSG00000283663.1",
      gene_type : "protein_coding",
      gene_name : "AC008687.8",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191727.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49061066,
      stop : 49065054,
      direction : "-",
      ID : "ENSG00000225950.8",
      gene_id : "ENSG00000225950.8",
      gene_type : "protein_coding",
      gene_name : "NTF4",
      gene_level : 2,
      hgnc_id : "HGNC:8024",
      havana_gene : "OTTHUMG00000191728.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49067418,
      stop : 49072941,
      direction : "-",
      ID : "ENSG00000104848.1",
      gene_id : "ENSG00000104848.1",
      gene_type : "protein_coding",
      gene_name : "KCNA7",
      gene_level : 2,
      hgnc_id : "HGNC:6226",
      havana_gene : "OTTHUMG00000183343.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49085419,
      stop : 49108605,
      direction : "+",
      ID : "ENSG00000104852.15",
      gene_id : "ENSG00000104852.15",
      gene_type : "protein_coding",
      gene_name : "SNRNP70",
      gene_level : 2,
      hgnc_id : "HGNC:11150",
      havana_gene : "OTTHUMG00000183344.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49114324,
      stop : 49118460,
      direction : "+",
      ID : "ENSG00000104863.12",
      gene_id : "ENSG00000104863.12",
      gene_type : "protein_coding",
      gene_name : "LIN7B",
      gene_level : 1,
      hgnc_id : "HGNC:17788",
      havana_gene : "OTTHUMG00000134288.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49118402,
      stop : 49119143,
      direction : "-",
      ID : "ENSG00000221916.4",
      gene_id : "ENSG00000221916.4",
      gene_type : "protein_coding",
      gene_name : "C19orf73",
      gene_level : 2,
      hgnc_id : "HGNC:25534",
      havana_gene : "OTTHUMG00000183345.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49119544,
      stop : 49151026,
      direction : "+",
      ID : "ENSG00000177380.14",
      gene_id : "ENSG00000177380.14",
      gene_type : "protein_coding",
      gene_name : "PPFIA3",
      gene_level : 2,
      hgnc_id : "HGNC:9247",
      havana_gene : "OTTHUMG00000183213.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49151198,
      stop : 49155396,
      direction : "-",
      ID : "ENSG00000130528.12",
      gene_id : "ENSG00000130528.12",
      gene_type : "protein_coding",
      gene_name : "HRC",
      gene_level : 1,
      hgnc_id : "HGNC:5178",
      havana_gene : "OTTHUMG00000183203.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49157741,
      stop : 49211836,
      direction : "+",
      ID : "ENSG00000130529.16",
      gene_id : "ENSG00000130529.16",
      gene_type : "protein_coding",
      gene_name : "TRPM4",
      gene_level : 1,
      hgnc_id : "HGNC:17993",
      havana_gene : "OTTHUMG00000183184.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49289638,
      stop : 49325215,
      direction : "-",
      ID : "ENSG00000063127.16",
      gene_id : "ENSG00000063127.16",
      gene_type : "protein_coding",
      gene_name : "SLC6A16",
      gene_level : 1,
      hgnc_id : "HGNC:13622",
      havana_gene : "OTTHUMG00000183179.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49335171,
      stop : 49343335,
      direction : "+",
      ID : "ENSG00000104894.12",
      gene_id : "ENSG00000104894.12",
      gene_type : "protein_coding",
      gene_name : "CD37",
      gene_level : 1,
      hgnc_id : "HGNC:1666",
      havana_gene : "OTTHUMG00000183183.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49340595,
      stop : 49362457,
      direction : "-",
      ID : "ENSG00000074219.14",
      gene_id : "ENSG00000074219.14",
      gene_type : "protein_coding",
      gene_name : "TEAD2",
      gene_level : 1,
      hgnc_id : "HGNC:11715",
      havana_gene : "OTTHUMG00000183174.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49361783,
      stop : 49375116,
      direction : "+",
      ID : "ENSG00000104901.7",
      gene_id : "ENSG00000104901.7",
      gene_type : "protein_coding",
      gene_name : "DKKL1",
      gene_level : 1,
      hgnc_id : "HGNC:16528",
      havana_gene : "OTTHUMG00000183171.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49388219,
      stop : 49417990,
      direction : "+",
      ID : "ENSG00000161609.10",
      gene_id : "ENSG00000161609.10",
      gene_type : "protein_coding",
      gene_name : "KASH5",
      gene_level : 1,
      hgnc_id : "HGNC:26520",
      havana_gene : "OTTHUMG00000183170.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49422419,
      stop : 49423441,
      direction : "-",
      ID : "ENSG00000142538.2",
      gene_id : "ENSG00000142538.2",
      gene_type : "protein_coding",
      gene_name : "PTH2",
      gene_level : 2,
      hgnc_id : "HGNC:30828",
      havana_gene : "OTTHUMG00000183165.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49423749,
      stop : 49428987,
      direction : "+",
      ID : "ENSG00000261949.7",
      gene_id : "ENSG00000261949.7",
      gene_type : "protein_coding",
      gene_name : "GFY",
      gene_level : 2,
      hgnc_id : "HGNC:44663",
      havana_gene : "OTTHUMG00000177824.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49429401,
      stop : 49442360,
      direction : "-",
      ID : "ENSG00000104888.10",
      gene_id : "ENSG00000104888.10",
      gene_type : "protein_coding",
      gene_name : "SLC17A7",
      gene_level : 1,
      hgnc_id : "HGNC:16704",
      havana_gene : "OTTHUMG00000183166.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49446298,
      stop : 49453497,
      direction : "-",
      ID : "ENSG00000104872.11",
      gene_id : "ENSG00000104872.11",
      gene_type : "protein_coding",
      gene_name : "PIH1D1",
      gene_level : 2,
      hgnc_id : "HGNC:26075",
      havana_gene : "OTTHUMG00000183167.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49453225,
      stop : 49471050,
      direction : "+",
      ID : "ENSG00000161618.10",
      gene_id : "ENSG00000161618.10",
      gene_type : "protein_coding",
      gene_name : "ALDH16A1",
      gene_level : 1,
      hgnc_id : "HGNC:28114",
      havana_gene : "OTTHUMG00000183163.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49462752,
      stop : 49486231,
      direction : "+",
      ID : "ENSG00000269469.1",
      gene_id : "ENSG00000269469.1",
      gene_type : "protein_coding",
      gene_name : "AC010619.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183164.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49474207,
      stop : 49486231,
      direction : "+",
      ID : "ENSG00000090554.13",
      gene_id : "ENSG00000090554.13",
      gene_type : "protein_coding",
      gene_name : "FLT3LG",
      gene_level : 1,
      hgnc_id : "HGNC:3766",
      havana_gene : "OTTHUMG00000186490.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49487510,
      stop : 49493057,
      direction : "+",
      ID : "ENSG00000142541.18",
      gene_id : "ENSG00000142541.18",
      gene_type : "protein_coding",
      gene_name : "RPL13A",
      gene_level : 2,
      hgnc_id : "HGNC:10304",
      havana_gene : "OTTHUMG00000134289.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49496365,
      stop : 49499708,
      direction : "+",
      ID : "ENSG00000142534.7",
      gene_id : "ENSG00000142534.7",
      gene_type : "protein_coding",
      gene_name : "RPS11",
      gene_level : 2,
      hgnc_id : "HGNC:10384",
      havana_gene : "OTTHUMG00000183156.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49506816,
      stop : 49526428,
      direction : "+",
      ID : "ENSG00000104870.13",
      gene_id : "ENSG00000104870.13",
      gene_type : "protein_coding",
      gene_name : "FCGRT",
      gene_level : 1,
      hgnc_id : "HGNC:3621",
      havana_gene : "OTTHUMG00000183155.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49528003,
      stop : 49546962,
      direction : "+",
      ID : "ENSG00000142552.8",
      gene_id : "ENSG00000142552.8",
      gene_type : "protein_coding",
      gene_name : "RCN3",
      gene_level : 1,
      hgnc_id : "HGNC:21145",
      havana_gene : "OTTHUMG00000183154.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49555468,
      stop : 49590262,
      direction : "-",
      ID : "ENSG00000142546.14",
      gene_id : "ENSG00000142546.14",
      gene_type : "protein_coding",
      gene_name : "NOSIP",
      gene_level : 2,
      hgnc_id : "HGNC:17946",
      havana_gene : "OTTHUMG00000183169.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49580646,
      stop : 49591004,
      direction : "+",
      ID : "ENSG00000126460.11",
      gene_id : "ENSG00000126460.11",
      gene_type : "protein_coding",
      gene_name : "PRRG2",
      gene_level : 2,
      hgnc_id : "HGNC:9470",
      havana_gene : "OTTHUMG00000183153.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49591182,
      stop : 49626439,
      direction : "+",
      ID : "ENSG00000126464.14",
      gene_id : "ENSG00000126464.14",
      gene_type : "protein_coding",
      gene_name : "PRR12",
      gene_level : 1,
      hgnc_id : "HGNC:29217",
      havana_gene : "OTTHUMG00000183275.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49635292,
      stop : 49640143,
      direction : "-",
      ID : "ENSG00000126458.4",
      gene_id : "ENSG00000126458.4",
      gene_type : "protein_coding",
      gene_name : "RRAS",
      gene_level : 2,
      hgnc_id : "HGNC:10447",
      havana_gene : "OTTHUMG00000183247.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49642209,
      stop : 49658642,
      direction : "+",
      ID : "ENSG00000126461.15",
      gene_id : "ENSG00000126461.15",
      gene_type : "protein_coding",
      gene_name : "SCAF1",
      gene_level : 2,
      hgnc_id : "HGNC:30403",
      havana_gene : "OTTHUMG00000183238.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49659569,
      stop : 49665875,
      direction : "-",
      ID : "ENSG00000126456.16",
      gene_id : "ENSG00000126456.16",
      gene_type : "protein_coding",
      gene_name : "IRF3",
      gene_level : 1,
      hgnc_id : "HGNC:6118",
      havana_gene : "OTTHUMG00000183287.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49665142,
      stop : 49673916,
      direction : "+",
      ID : "ENSG00000126453.10",
      gene_id : "ENSG00000126453.10",
      gene_type : "protein_coding",
      gene_name : "BCL2L12",
      gene_level : 1,
      hgnc_id : "HGNC:13787",
      havana_gene : "OTTHUMG00000183239.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49675786,
      stop : 49689029,
      direction : "+",
      ID : "ENSG00000126457.22",
      gene_id : "ENSG00000126457.22",
      gene_type : "protein_coding",
      gene_name : "PRMT1",
      gene_level : 2,
      hgnc_id : "HGNC:5187",
      havana_gene : "OTTHUMG00000167568.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49688664,
      stop : 49690575,
      direction : "+",
      ID : "ENSG00000224420.3",
      gene_id : "ENSG00000224420.3",
      gene_type : "protein_coding",
      gene_name : "ADM5",
      gene_level : 2,
      hgnc_id : "HGNC:27293",
      havana_gene : "OTTHUMG00000183240.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49690898,
      stop : 49713731,
      direction : "+",
      ID : "ENSG00000169169.15",
      gene_id : "ENSG00000169169.15",
      gene_type : "protein_coding",
      gene_name : "CPT1C",
      gene_level : 2,
      hgnc_id : "HGNC:18540",
      havana_gene : "OTTHUMG00000183267.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49739753,
      stop : 49763306,
      direction : "-",
      ID : "ENSG00000126467.11",
      gene_id : "ENSG00000126467.11",
      gene_type : "protein_coding",
      gene_name : "TSKS",
      gene_level : 2,
      hgnc_id : "HGNC:30719",
      havana_gene : "OTTHUMG00000183249.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49767001,
      stop : 49807114,
      direction : "+",
      ID : "ENSG00000196961.13",
      gene_id : "ENSG00000196961.13",
      gene_type : "protein_coding",
      gene_name : "AP2A1",
      gene_level : 2,
      hgnc_id : "HGNC:561",
      havana_gene : "OTTHUMG00000183253.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49806866,
      stop : 49817376,
      direction : "-",
      ID : "ENSG00000010361.14",
      gene_id : "ENSG00000010361.14",
      gene_type : "protein_coding",
      gene_name : "FUZ",
      gene_level : 1,
      hgnc_id : "HGNC:26219",
      havana_gene : "OTTHUMG00000167281.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49818282,
      stop : 49840383,
      direction : "+",
      ID : "ENSG00000104973.19",
      gene_id : "ENSG00000104973.19",
      gene_type : "protein_coding",
      gene_name : "MED25",
      gene_level : 2,
      hgnc_id : "HGNC:28845",
      havana_gene : "OTTHUMG00000183161.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49850735,
      stop : 49860744,
      direction : "+",
      ID : "ENSG00000104960.15",
      gene_id : "ENSG00000104960.15",
      gene_type : "protein_coding",
      gene_name : "PTOV1",
      gene_level : 2,
      hgnc_id : "HGNC:9632",
      havana_gene : "OTTHUMG00000183162.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49859882,
      stop : 49878351,
      direction : "-",
      ID : "ENSG00000039650.12",
      gene_id : "ENSG00000039650.12",
      gene_type : "protein_coding",
      gene_name : "PNKP",
      gene_level : 2,
      hgnc_id : "HGNC:9154",
      havana_gene : "OTTHUMG00000183261.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49869033,
      stop : 49878459,
      direction : "-",
      ID : "ENSG00000204673.11",
      gene_id : "ENSG00000204673.11",
      gene_type : "protein_coding",
      gene_name : "AKT1S1",
      gene_level : 2,
      hgnc_id : "HGNC:28426",
      havana_gene : "OTTHUMG00000150246.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49877425,
      stop : 49888750,
      direction : "+",
      ID : "ENSG00000104946.13",
      gene_id : "ENSG00000104946.13",
      gene_type : "protein_coding",
      gene_name : "TBC1D17",
      gene_level : 1,
      hgnc_id : "HGNC:25699",
      havana_gene : "OTTHUMG00000183376.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49889654,
      stop : 49929539,
      direction : "-",
      ID : "ENSG00000104951.16",
      gene_id : "ENSG00000104951.16",
      gene_type : "protein_coding",
      gene_name : "IL4I1",
      gene_level : 2,
      hgnc_id : "HGNC:19094",
      havana_gene : "OTTHUMG00000183377.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49906825,
      stop : 49929763,
      direction : "-",
      ID : "ENSG00000213024.12",
      gene_id : "ENSG00000213024.12",
      gene_type : "protein_coding",
      gene_name : "NUP62",
      gene_level : 2,
      hgnc_id : "HGNC:8066",
      havana_gene : "OTTHUMG00000183077.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49909501,
      stop : 49958391,
      direction : "-",
      ID : "ENSG00000269179.1",
      gene_id : "ENSG00000269179.1",
      gene_type : "protein_coding",
      gene_name : "AC011452.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000183078.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49928702,
      stop : 49933935,
      direction : "+",
      ID : "ENSG00000169136.12",
      gene_id : "ENSG00000169136.12",
      gene_type : "protein_coding",
      gene_name : "ATF5",
      gene_level : 2,
      hgnc_id : "HGNC:790",
      havana_gene : "OTTHUMG00000183065.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49948985,
      stop : 49961172,
      direction : "-",
      ID : "ENSG00000161640.15",
      gene_id : "ENSG00000161640.15",
      gene_type : "protein_coding",
      gene_name : "SIGLEC11",
      gene_level : 2,
      hgnc_id : "HGNC:15622",
      havana_gene : "OTTHUMG00000157077.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 49976468,
      stop : 50025946,
      direction : "-",
      ID : "ENSG00000105053.11",
      gene_id : "ENSG00000105053.11",
      gene_type : "protein_coding",
      gene_name : "VRK3",
      gene_level : 1,
      hgnc_id : "HGNC:18996",
      havana_gene : "OTTHUMG00000183053.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50025714,
      stop : 50053414,
      direction : "+",
      ID : "ENSG00000142528.16",
      gene_id : "ENSG00000142528.16",
      gene_type : "protein_coding",
      gene_name : "ZNF473",
      gene_level : 1,
      hgnc_id : "HGNC:23239",
      havana_gene : "OTTHUMG00000183054.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50152548,
      stop : 50163195,
      direction : "-",
      ID : "ENSG00000161652.12",
      gene_id : "ENSG00000161652.12",
      gene_type : "protein_coding",
      gene_name : "IZUMO2",
      gene_level : 2,
      hgnc_id : "HGNC:28518",
      havana_gene : "OTTHUMG00000074063.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50188186,
      stop : 50310542,
      direction : "+",
      ID : "ENSG00000105357.19",
      gene_id : "ENSG00000105357.19",
      gene_type : "protein_coding",
      gene_name : "MYH14",
      gene_level : 2,
      hgnc_id : "HGNC:23212",
      havana_gene : "OTTHUMG00000183034.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50311937,
      stop : 50333515,
      direction : "-",
      ID : "ENSG00000131398.15",
      gene_id : "ENSG00000131398.15",
      gene_type : "protein_coding",
      gene_name : "KCNC3",
      gene_level : 2,
      hgnc_id : "HGNC:6235",
      havana_gene : "OTTHUMG00000044580.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50329653,
      stop : 50383388,
      direction : "+",
      ID : "ENSG00000131408.15",
      gene_id : "ENSG00000131408.15",
      gene_type : "protein_coding",
      gene_name : "NR1H2",
      gene_level : 2,
      hgnc_id : "HGNC:7965",
      havana_gene : "OTTHUMG00000183036.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50358477,
      stop : 50365830,
      direction : "-",
      ID : "ENSG00000131400.8",
      gene_id : "ENSG00000131400.8",
      gene_type : "protein_coding",
      gene_name : "NAPSA",
      gene_level : 2,
      hgnc_id : "HGNC:13395",
      havana_gene : "OTTHUMG00000183035.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50384204,
      stop : 50418018,
      direction : "+",
      ID : "ENSG00000062822.15",
      gene_id : "ENSG00000062822.15",
      gene_type : "protein_coding",
      gene_name : "POLD1",
      gene_level : 1,
      hgnc_id : "HGNC:9175",
      havana_gene : "OTTHUMG00000183037.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50415799,
      stop : 50428409,
      direction : "+",
      ID : "ENSG00000142539.9",
      gene_id : "ENSG00000142539.9",
      gene_type : "protein_coding",
      gene_name : "AC020909.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183038.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50418938,
      stop : 50431314,
      direction : "+",
      ID : "ENSG00000269404.7",
      gene_id : "ENSG00000269404.7",
      gene_type : "protein_coding",
      gene_name : "SPIB",
      gene_level : 1,
      hgnc_id : "HGNC:11242",
      havana_gene : "OTTHUMG00000183039.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50432892,
      stop : 50466321,
      direction : "+",
      ID : "ENSG00000086967.10",
      gene_id : "ENSG00000086967.10",
      gene_type : "protein_coding",
      gene_name : "MYBPC2",
      gene_level : 2,
      hgnc_id : "HGNC:7550",
      havana_gene : "OTTHUMG00000183040.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50466785,
      stop : 50476848,
      direction : "-",
      ID : "ENSG00000142530.11",
      gene_id : "ENSG00000142530.11",
      gene_type : "protein_coding",
      gene_name : "FAM71E1",
      gene_level : 2,
      hgnc_id : "HGNC:25107",
      havana_gene : "OTTHUMG00000183041.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50476400,
      stop : 50490871,
      direction : "+",
      ID : "ENSG00000161671.17",
      gene_id : "ENSG00000161671.17",
      gene_type : "protein_coding",
      gene_name : "EMC10",
      gene_level : 2,
      hgnc_id : "HGNC:27609",
      havana_gene : "OTTHUMG00000183042.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50505998,
      stop : 50511220,
      direction : "-",
      ID : "ENSG00000161677.12",
      gene_id : "ENSG00000161677.12",
      gene_type : "protein_coding",
      gene_name : "JOSD2",
      gene_level : 1,
      hgnc_id : "HGNC:28853",
      havana_gene : "OTTHUMG00000183062.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50511600,
      stop : 50514690,
      direction : "-",
      ID : "ENSG00000204653.10",
      gene_id : "ENSG00000204653.10",
      gene_type : "protein_coding",
      gene_name : "ASPDH",
      gene_level : 1,
      hgnc_id : "HGNC:33856",
      havana_gene : "OTTHUMG00000183057.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50516892,
      stop : 50568435,
      direction : "-",
      ID : "ENSG00000131409.13",
      gene_id : "ENSG00000131409.13",
      gene_type : "protein_coding",
      gene_name : "LRRC4B",
      gene_level : 2,
      hgnc_id : "HGNC:25042",
      havana_gene : "OTTHUMG00000183063.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50621307,
      stop : 50639881,
      direction : "-",
      ID : "ENSG00000213023.11",
      gene_id : "ENSG00000213023.11",
      gene_type : "protein_coding",
      gene_name : "SYT3",
      gene_level : 2,
      hgnc_id : "HGNC:11511",
      havana_gene : "OTTHUMG00000183064.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50649445,
      stop : 50659310,
      direction : "+",
      ID : "ENSG00000235034.7",
      gene_id : "ENSG00000235034.7",
      gene_type : "protein_coding",
      gene_name : "C19orf81",
      gene_level : 2,
      hgnc_id : "HGNC:40041",
      havana_gene : "OTTHUMG00000154593.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50659255,
      stop : 50719802,
      direction : "-",
      ID : "ENSG00000161681.16",
      gene_id : "ENSG00000161681.16",
      gene_type : "protein_coding",
      gene_name : "SHANK1",
      gene_level : 1,
      hgnc_id : "HGNC:15474",
      havana_gene : "OTTHUMG00000137380.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50723364,
      stop : 50725718,
      direction : "+",
      ID : "ENSG00000105472.13",
      gene_id : "ENSG00000105472.13",
      gene_type : "protein_coding",
      gene_name : "CLEC11A",
      gene_level : 2,
      hgnc_id : "HGNC:10576",
      havana_gene : "OTTHUMG00000182866.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50770464,
      stop : 50771732,
      direction : "+",
      ID : "ENSG00000142511.4",
      gene_id : "ENSG00000142511.4",
      gene_type : "protein_coding",
      gene_name : "GPR32",
      gene_level : 2,
      hgnc_id : "HGNC:4487",
      havana_gene : "OTTHUMG00000183079.1",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50776141,
      stop : 50793142,
      direction : "-",
      ID : "ENSG00000261341.7",
      gene_id : "ENSG00000261341.7",
      gene_type : "protein_coding",
      gene_name : "AC010325.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176604.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50790415,
      stop : 50795219,
      direction : "+",
      ID : "ENSG00000142513.6",
      gene_id : "ENSG00000142513.6",
      gene_type : "protein_coding",
      gene_name : "ACP4",
      gene_level : 2,
      hgnc_id : "HGNC:14376",
      havana_gene : "OTTHUMG00000182961.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50819146,
      stop : 50823787,
      direction : "-",
      ID : "ENSG00000167748.11",
      gene_id : "ENSG00000167748.11",
      gene_type : "protein_coding",
      gene_name : "KLK1",
      gene_level : 2,
      hgnc_id : "HGNC:6357",
      havana_gene : "OTTHUMG00000182876.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50825289,
      stop : 50837213,
      direction : "-",
      ID : "ENSG00000174562.13",
      gene_id : "ENSG00000174562.13",
      gene_type : "protein_coding",
      gene_name : "KLK15",
      gene_level : 1,
      hgnc_id : "HGNC:20453",
      havana_gene : "OTTHUMG00000183116.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50854915,
      stop : 50860764,
      direction : "+",
      ID : "ENSG00000142515.15",
      gene_id : "ENSG00000142515.15",
      gene_type : "protein_coding",
      gene_name : "KLK3",
      gene_level : 2,
      hgnc_id : "HGNC:6364",
      havana_gene : "OTTHUMG00000182867.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50861568,
      stop : 50880567,
      direction : "+",
      ID : "ENSG00000167751.13",
      gene_id : "ENSG00000167751.13",
      gene_type : "protein_coding",
      gene_name : "KLK2",
      gene_level : 1,
      hgnc_id : "HGNC:6363",
      havana_gene : "OTTHUMG00000182963.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50906352,
      stop : 50910738,
      direction : "-",
      ID : "ENSG00000167749.11",
      gene_id : "ENSG00000167749.11",
      gene_type : "protein_coding",
      gene_name : "KLK4",
      gene_level : 2,
      hgnc_id : "HGNC:6365",
      havana_gene : "OTTHUMG00000182964.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50943303,
      stop : 50953093,
      direction : "-",
      ID : "ENSG00000167754.13",
      gene_id : "ENSG00000167754.13",
      gene_type : "protein_coding",
      gene_name : "KLK5",
      gene_level : 2,
      hgnc_id : "HGNC:6366",
      havana_gene : "OTTHUMG00000183097.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50958631,
      stop : 50969673,
      direction : "-",
      ID : "ENSG00000167755.15",
      gene_id : "ENSG00000167755.15",
      gene_type : "protein_coding",
      gene_name : "KLK6",
      gene_level : 2,
      hgnc_id : "HGNC:6367",
      havana_gene : "OTTHUMG00000183098.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50976468,
      stop : 50984099,
      direction : "-",
      ID : "ENSG00000169035.12",
      gene_id : "ENSG00000169035.12",
      gene_type : "protein_coding",
      gene_name : "KLK7",
      gene_level : 2,
      hgnc_id : "HGNC:6368",
      havana_gene : "OTTHUMG00000182917.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50996007,
      stop : 51002711,
      direction : "-",
      ID : "ENSG00000129455.15",
      gene_id : "ENSG00000129455.15",
      gene_type : "protein_coding",
      gene_name : "KLK8",
      gene_level : 2,
      hgnc_id : "HGNC:6369",
      havana_gene : "OTTHUMG00000183086.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 50996018,
      stop : 51009581,
      direction : "-",
      ID : "ENSG00000269741.5",
      gene_id : "ENSG00000269741.5",
      gene_type : "protein_coding",
      gene_name : "AC011473.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183088.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51002508,
      stop : 51009634,
      direction : "-",
      ID : "ENSG00000213022.6",
      gene_id : "ENSG00000213022.6",
      gene_type : "protein_coding",
      gene_name : "KLK9",
      gene_level : 2,
      hgnc_id : "HGNC:6370",
      havana_gene : "OTTHUMG00000183087.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51012739,
      stop : 51020175,
      direction : "-",
      ID : "ENSG00000129451.12",
      gene_id : "ENSG00000129451.12",
      gene_type : "protein_coding",
      gene_name : "KLK10",
      gene_level : 2,
      hgnc_id : "HGNC:6358",
      havana_gene : "OTTHUMG00000182916.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51022216,
      stop : 51028039,
      direction : "-",
      ID : "ENSG00000167757.14",
      gene_id : "ENSG00000167757.14",
      gene_type : "protein_coding",
      gene_name : "KLK11",
      gene_level : 1,
      hgnc_id : "HGNC:6359",
      havana_gene : "OTTHUMG00000182915.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51029092,
      stop : 51035230,
      direction : "-",
      ID : "ENSG00000186474.15",
      gene_id : "ENSG00000186474.15",
      gene_type : "protein_coding",
      gene_name : "KLK12",
      gene_level : 2,
      hgnc_id : "HGNC:6360",
      havana_gene : "OTTHUMG00000165806.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51055626,
      stop : 51065114,
      direction : "-",
      ID : "ENSG00000167759.13",
      gene_id : "ENSG00000167759.13",
      gene_type : "protein_coding",
      gene_name : "KLK13",
      gene_level : 2,
      hgnc_id : "HGNC:6361",
      havana_gene : "OTTHUMG00000182912.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51077495,
      stop : 51084245,
      direction : "-",
      ID : "ENSG00000129437.11",
      gene_id : "ENSG00000129437.11",
      gene_type : "protein_coding",
      gene_name : "KLK14",
      gene_level : 2,
      hgnc_id : "HGNC:6362",
      havana_gene : "OTTHUMG00000143721.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51097606,
      stop : 51108409,
      direction : "-",
      ID : "ENSG00000142544.7",
      gene_id : "ENSG00000142544.7",
      gene_type : "protein_coding",
      gene_name : "CTU1",
      gene_level : 2,
      hgnc_id : "HGNC:29590",
      havana_gene : "OTTHUMG00000182910.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51124906,
      stop : 51136651,
      direction : "+",
      ID : "ENSG00000129450.9",
      gene_id : "ENSG00000129450.9",
      gene_type : "protein_coding",
      gene_name : "SIGLEC9",
      gene_level : 1,
      hgnc_id : "HGNC:10878",
      havana_gene : "OTTHUMG00000182894.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51142299,
      stop : 51153526,
      direction : "+",
      ID : "ENSG00000168995.13",
      gene_id : "ENSG00000168995.13",
      gene_type : "protein_coding",
      gene_name : "SIGLEC7",
      gene_level : 2,
      hgnc_id : "HGNC:10876",
      havana_gene : "OTTHUMG00000182895.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51225064,
      stop : 51243860,
      direction : "+",
      ID : "ENSG00000105383.15",
      gene_id : "ENSG00000105383.15",
      gene_type : "protein_coding",
      gene_name : "CD33",
      gene_level : 2,
      hgnc_id : "HGNC:1659",
      havana_gene : "OTTHUMG00000182891.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51246348,
      stop : 51269330,
      direction : "+",
      ID : "ENSG00000179213.13",
      gene_id : "ENSG00000179213.13",
      gene_type : "protein_coding",
      gene_name : "SIGLECL1",
      gene_level : 1,
      hgnc_id : "HGNC:26856",
      havana_gene : "OTTHUMG00000182881.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51311848,
      stop : 51330354,
      direction : "+",
      ID : "ENSG00000142549.9",
      gene_id : "ENSG00000142549.9",
      gene_type : "protein_coding",
      gene_name : "IGLON5",
      gene_level : 2,
      hgnc_id : "HGNC:34550",
      havana_gene : "OTTHUMG00000154422.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51331536,
      stop : 51342124,
      direction : "-",
      ID : "ENSG00000186806.5",
      gene_id : "ENSG00000186806.5",
      gene_type : "protein_coding",
      gene_name : "VSIG10L",
      gene_level : 1,
      hgnc_id : "HGNC:27111",
      havana_gene : "OTTHUMG00000182975.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51345169,
      stop : 51366388,
      direction : "-",
      ID : "ENSG00000105379.10",
      gene_id : "ENSG00000105379.10",
      gene_type : "protein_coding",
      gene_name : "ETFB",
      gene_level : 2,
      hgnc_id : "HGNC:3482",
      havana_gene : "OTTHUMG00000182903.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51350373,
      stop : 51368099,
      direction : "-",
      ID : "ENSG00000269403.1",
      gene_id : "ENSG00000269403.1",
      gene_type : "protein_coding",
      gene_name : "AC008750.7",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182911.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51367098,
      stop : 51369003,
      direction : "-",
      ID : "ENSG00000160318.6",
      gene_id : "ENSG00000160318.6",
      gene_type : "protein_coding",
      gene_name : "CLDND2",
      gene_level : 2,
      hgnc_id : "HGNC:28511",
      havana_gene : "OTTHUMG00000182901.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51371606,
      stop : 51372701,
      direction : "-",
      ID : "ENSG00000105374.10",
      gene_id : "ENSG00000105374.10",
      gene_type : "protein_coding",
      gene_name : "NKG7",
      gene_level : 2,
      hgnc_id : "HGNC:7830",
      havana_gene : "OTTHUMG00000182898.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51379909,
      stop : 51387974,
      direction : "-",
      ID : "ENSG00000105370.8",
      gene_id : "ENSG00000105370.8",
      gene_type : "protein_coding",
      gene_name : "LIM2",
      gene_level : 2,
      hgnc_id : "HGNC:6610",
      havana_gene : "OTTHUMG00000182896.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51388289,
      stop : 51390591,
      direction : "-",
      ID : "ENSG00000262874.2",
      gene_id : "ENSG00000262874.2",
      gene_type : "protein_coding",
      gene_name : "C19orf84",
      gene_level : 2,
      hgnc_id : "HGNC:27112",
      havana_gene : "OTTHUMG00000177322.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51410020,
      stop : 51417803,
      direction : "-",
      ID : "ENSG00000142512.15",
      gene_id : "ENSG00000142512.15",
      gene_type : "protein_coding",
      gene_name : "SIGLEC10",
      gene_level : 1,
      hgnc_id : "HGNC:15620",
      havana_gene : "OTTHUMG00000165521.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51450847,
      stop : 51458456,
      direction : "-",
      ID : "ENSG00000105366.15",
      gene_id : "ENSG00000105366.15",
      gene_type : "protein_coding",
      gene_name : "SIGLEC8",
      gene_level : 1,
      hgnc_id : "HGNC:10877",
      havana_gene : "OTTHUMG00000182776.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51478622,
      stop : 51490952,
      direction : "+",
      ID : "ENSG00000213822.6",
      gene_id : "ENSG00000213822.6",
      gene_type : "protein_coding",
      gene_name : "CEACAM18",
      gene_level : 2,
      hgnc_id : "HGNC:31949",
      havana_gene : "OTTHUMG00000151557.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51491227,
      stop : 51501800,
      direction : "-",
      ID : "ENSG00000254521.7",
      gene_id : "ENSG00000254521.7",
      gene_type : "protein_coding",
      gene_name : "SIGLEC12",
      gene_level : 2,
      hgnc_id : "HGNC:15482",
      havana_gene : "OTTHUMG00000165524.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51517819,
      stop : 51531856,
      direction : "-",
      ID : "ENSG00000105492.16",
      gene_id : "ENSG00000105492.16",
      gene_type : "protein_coding",
      gene_name : "SIGLEC6",
      gene_level : 1,
      hgnc_id : "HGNC:10875",
      havana_gene : "OTTHUMG00000133571.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51571283,
      stop : 51592510,
      direction : "+",
      ID : "ENSG00000105497.8",
      gene_id : "ENSG00000105497.8",
      gene_type : "protein_coding",
      gene_name : "ZNF175",
      gene_level : 1,
      hgnc_id : "HGNC:12964",
      havana_gene : "OTTHUMG00000167771.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51611927,
      stop : 51645545,
      direction : "-",
      ID : "ENSG00000105501.12",
      gene_id : "ENSG00000105501.12",
      gene_type : "protein_coding",
      gene_name : "SIGLEC5",
      gene_level : 1,
      hgnc_id : "HGNC:10874",
      havana_gene : "OTTHUMG00000165510.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51612091,
      stop : 51646889,
      direction : "-",
      ID : "ENSG00000268500.5",
      gene_id : "ENSG00000268500.5",
      gene_type : "protein_coding",
      gene_name : "AC018755.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000188645.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51642553,
      stop : 51646801,
      direction : "-",
      ID : "ENSG00000254415.3",
      gene_id : "ENSG00000254415.3",
      gene_type : "protein_coding",
      gene_name : "SIGLEC14",
      gene_level : 2,
      hgnc_id : "HGNC:32926",
      havana_gene : "OTTHUMG00000165511.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51689128,
      stop : 51712387,
      direction : "+",
      ID : "ENSG00000182310.15",
      gene_id : "ENSG00000182310.15",
      gene_type : "protein_coding",
      gene_name : "SPACA6",
      gene_level : 2,
      hgnc_id : "HGNC:27113",
      havana_gene : "OTTHUMG00000177373.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51713112,
      stop : 51723991,
      direction : "-",
      ID : "ENSG00000105509.11",
      gene_id : "ENSG00000105509.11",
      gene_type : "protein_coding",
      gene_name : "HAS1",
      gene_level : 1,
      hgnc_id : "HGNC:4818",
      havana_gene : "OTTHUMG00000183499.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51745172,
      stop : 51804110,
      direction : "-",
      ID : "ENSG00000171051.9",
      gene_id : "ENSG00000171051.9",
      gene_type : "protein_coding",
      gene_name : "FPR1",
      gene_level : 2,
      hgnc_id : "HGNC:3826",
      havana_gene : "OTTHUMG00000183500.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51752026,
      stop : 51770531,
      direction : "+",
      ID : "ENSG00000171049.9",
      gene_id : "ENSG00000171049.9",
      gene_type : "protein_coding",
      gene_name : "FPR2",
      gene_level : 2,
      hgnc_id : "HGNC:3827",
      havana_gene : "OTTHUMG00000183501.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51795157,
      stop : 51826190,
      direction : "+",
      ID : "ENSG00000187474.5",
      gene_id : "ENSG00000187474.5",
      gene_type : "protein_coding",
      gene_name : "FPR3",
      gene_level : 2,
      hgnc_id : "HGNC:3828",
      havana_gene : "OTTHUMG00000183502.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51804816,
      stop : 51890950,
      direction : "-",
      ID : "ENSG00000161551.14",
      gene_id : "ENSG00000161551.14",
      gene_type : "protein_coding",
      gene_name : "ZNF577",
      gene_level : 2,
      hgnc_id : "HGNC:28673",
      havana_gene : "OTTHUMG00000157045.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51889235,
      stop : 51905040,
      direction : "-",
      ID : "ENSG00000198093.11",
      gene_id : "ENSG00000198093.11",
      gene_type : "protein_coding",
      gene_name : "ZNF649",
      gene_level : 2,
      hgnc_id : "HGNC:25741",
      havana_gene : "OTTHUMG00000182423.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51927147,
      stop : 51948759,
      direction : "+",
      ID : "ENSG00000176024.18",
      gene_id : "ENSG00000176024.18",
      gene_type : "protein_coding",
      gene_name : "ZNF613",
      gene_level : 2,
      hgnc_id : "HGNC:25827",
      havana_gene : "OTTHUMG00000182424.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51964340,
      stop : 51986856,
      direction : "-",
      ID : "ENSG00000256683.7",
      gene_id : "ENSG00000256683.7",
      gene_type : "protein_coding",
      gene_name : "ZNF350",
      gene_level : 1,
      hgnc_id : "HGNC:16656",
      havana_gene : "OTTHUMG00000182538.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 51991332,
      stop : 52008230,
      direction : "-",
      ID : "ENSG00000197619.14",
      gene_id : "ENSG00000197619.14",
      gene_type : "protein_coding",
      gene_name : "ZNF615",
      gene_level : 2,
      hgnc_id : "HGNC:24740",
      havana_gene : "OTTHUMG00000182550.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52012765,
      stop : 52030240,
      direction : "-",
      ID : "ENSG00000142556.19",
      gene_id : "ENSG00000142556.19",
      gene_type : "protein_coding",
      gene_name : "ZNF614",
      gene_level : 2,
      hgnc_id : "HGNC:24722",
      havana_gene : "OTTHUMG00000182551.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52031378,
      stop : 52095738,
      direction : "-",
      ID : "ENSG00000256087.7",
      gene_id : "ENSG00000256087.7",
      gene_type : "protein_coding",
      gene_name : "ZNF432",
      gene_level : 2,
      hgnc_id : "HGNC:20810",
      havana_gene : "OTTHUMG00000182552.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52064466,
      stop : 52095765,
      direction : "-",
      ID : "ENSG00000197608.11",
      gene_id : "ENSG00000197608.11",
      gene_type : "protein_coding",
      gene_name : "ZNF841",
      gene_level : 1,
      hgnc_id : "HGNC:27611",
      havana_gene : "OTTHUMG00000182558.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52113091,
      stop : 52139938,
      direction : "-",
      ID : "ENSG00000204611.7",
      gene_id : "ENSG00000204611.7",
      gene_type : "protein_coding",
      gene_name : "ZNF616",
      gene_level : 2,
      hgnc_id : "HGNC:28062",
      havana_gene : "OTTHUMG00000182566.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52153864,
      stop : 52171643,
      direction : "-",
      ID : "ENSG00000196267.12",
      gene_id : "ENSG00000196267.12",
      gene_type : "protein_coding",
      gene_name : "ZNF836",
      gene_level : 2,
      hgnc_id : "HGNC:34333",
      havana_gene : "OTTHUMG00000182567.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52190048,
      stop : 52229518,
      direction : "+",
      ID : "ENSG00000105568.18",
      gene_id : "ENSG00000105568.18",
      gene_type : "protein_coding",
      gene_name : "PPP2R1A",
      gene_level : 1,
      hgnc_id : "HGNC:9302",
      havana_gene : "OTTHUMG00000137367.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52269587,
      stop : 52296046,
      direction : "+",
      ID : "ENSG00000196214.11",
      gene_id : "ENSG00000196214.11",
      gene_type : "protein_coding",
      gene_name : "ZNF766",
      gene_level : 1,
      hgnc_id : "HGNC:28063",
      havana_gene : "OTTHUMG00000182629.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52297169,
      stop : 52325922,
      direction : "+",
      ID : "ENSG00000198464.14",
      gene_id : "ENSG00000198464.14",
      gene_type : "protein_coding",
      gene_name : "ZNF480",
      gene_level : 1,
      hgnc_id : "HGNC:23305",
      havana_gene : "OTTHUMG00000157507.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52336243,
      stop : 52367778,
      direction : "+",
      ID : "ENSG00000167554.15",
      gene_id : "ENSG00000167554.15",
      gene_type : "protein_coding",
      gene_name : "ZNF610",
      gene_level : 2,
      hgnc_id : "HGNC:26687",
      havana_gene : "OTTHUMG00000182645.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52369917,
      stop : 52385795,
      direction : "+",
      ID : "ENSG00000221923.9",
      gene_id : "ENSG00000221923.9",
      gene_type : "protein_coding",
      gene_name : "ZNF880",
      gene_level : 2,
      hgnc_id : "HGNC:37249",
      havana_gene : "OTTHUMG00000167972.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52397849,
      stop : 52418412,
      direction : "+",
      ID : "ENSG00000167555.14",
      gene_id : "ENSG00000167555.14",
      gene_type : "protein_coding",
      gene_name : "ZNF528",
      gene_level : 1,
      hgnc_id : "HGNC:29384",
      havana_gene : "OTTHUMG00000156494.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52429187,
      stop : 52452315,
      direction : "+",
      ID : "ENSG00000198633.10",
      gene_id : "ENSG00000198633.10",
      gene_type : "protein_coding",
      gene_name : "ZNF534",
      gene_level : 1,
      hgnc_id : "HGNC:26337",
      havana_gene : "OTTHUMG00000156493.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52453553,
      stop : 52516882,
      direction : "+",
      ID : "ENSG00000258405.11",
      gene_id : "ENSG00000258405.11",
      gene_type : "protein_coding",
      gene_name : "ZNF578",
      gene_level : 2,
      hgnc_id : "HGNC:26449",
      havana_gene : "OTTHUMG00000156468.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52527652,
      stop : 52564464,
      direction : "+",
      ID : "ENSG00000198482.14",
      gene_id : "ENSG00000198482.14",
      gene_type : "protein_coding",
      gene_name : "ZNF808",
      gene_level : 2,
      hgnc_id : "HGNC:33230",
      havana_gene : "OTTHUMG00000158230.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52555457,
      stop : 52587174,
      direction : "+",
      ID : "ENSG00000167562.13",
      gene_id : "ENSG00000167562.13",
      gene_type : "protein_coding",
      gene_name : "ZNF701",
      gene_level : 1,
      hgnc_id : "HGNC:25597",
      havana_gene : "OTTHUMG00000182754.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52594060,
      stop : 52690496,
      direction : "-",
      ID : "ENSG00000167766.19",
      gene_id : "ENSG00000167766.19",
      gene_type : "protein_coding",
      gene_name : "ZNF83",
      gene_level : 1,
      hgnc_id : "HGNC:13158",
      havana_gene : "OTTHUMG00000182761.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52650447,
      stop : 52690533,
      direction : "-",
      ID : "ENSG00000269825.2",
      gene_id : "ENSG00000269825.2",
      gene_type : "protein_coding",
      gene_name : "AC022150.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52702813,
      stop : 52735073,
      direction : "-",
      ID : "ENSG00000213020.10",
      gene_id : "ENSG00000213020.10",
      gene_type : "protein_coding",
      gene_name : "ZNF611",
      gene_level : 2,
      hgnc_id : "HGNC:28766",
      havana_gene : "OTTHUMG00000154908.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52749942,
      stop : 52786807,
      direction : "-",
      ID : "ENSG00000189190.10",
      gene_id : "ENSG00000189190.10",
      gene_type : "protein_coding",
      gene_name : "ZNF600",
      gene_level : 2,
      hgnc_id : "HGNC:30951",
      havana_gene : "OTTHUMG00000182686.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52797408,
      stop : 52857600,
      direction : "-",
      ID : "ENSG00000198538.11",
      gene_id : "ENSG00000198538.11",
      gene_type : "protein_coding",
      gene_name : "ZNF28",
      gene_level : 1,
      hgnc_id : "HGNC:13073",
      havana_gene : "OTTHUMG00000154564.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52838010,
      stop : 52857649,
      direction : "-",
      ID : "ENSG00000204604.13",
      gene_id : "ENSG00000204604.13",
      gene_type : "protein_coding",
      gene_name : "ZNF468",
      gene_level : 2,
      hgnc_id : "HGNC:33105",
      havana_gene : "OTTHUMG00000182687.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52860851,
      stop : 52897693,
      direction : "-",
      ID : "ENSG00000182986.14",
      gene_id : "ENSG00000182986.14",
      gene_type : "protein_coding",
      gene_name : "ZNF320",
      gene_level : 2,
      hgnc_id : "HGNC:13842",
      havana_gene : "OTTHUMG00000182797.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52904417,
      stop : 52923481,
      direction : "-",
      ID : "ENSG00000213793.5",
      gene_id : "ENSG00000213793.5",
      gene_type : "protein_coding",
      gene_name : "ZNF888",
      gene_level : 2,
      hgnc_id : "HGNC:38695",
      havana_gene : "OTTHUMG00000182819.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52928475,
      stop : 52962823,
      direction : "-",
      ID : "ENSG00000221874.4",
      gene_id : "ENSG00000221874.4",
      gene_type : "protein_coding",
      gene_name : "ZNF816-ZNF321P",
      gene_level : 2,
      hgnc_id : "HGNC:38879",
      havana_gene : "OTTHUMG00000167759.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 52949379,
      stop : 52962911,
      direction : "-",
      ID : "ENSG00000180257.14",
      gene_id : "ENSG00000180257.14",
      gene_type : "protein_coding",
      gene_name : "ZNF816",
      gene_level : 1,
      hgnc_id : "HGNC:26995",
      havana_gene : "OTTHUMG00000167761.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53013921,
      stop : 53016122,
      direction : "+",
      ID : "ENSG00000269526.1",
      gene_id : "ENSG00000269526.1",
      gene_type : "protein_coding",
      gene_name : "ERVV-1",
      gene_level : 2,
      hgnc_id : "HGNC:26501",
      havana_gene : "OTTHUMG00000182942.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53044740,
      stop : 53051680,
      direction : "+",
      ID : "ENSG00000268964.3",
      gene_id : "ENSG00000268964.3",
      gene_type : "protein_coding",
      gene_name : "ERVV-2",
      gene_level : 2,
      hgnc_id : "HGNC:39051",
      havana_gene : "OTTHUMG00000182943.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53066606,
      stop : 53103436,
      direction : "-",
      ID : "ENSG00000170949.17",
      gene_id : "ENSG00000170949.17",
      gene_type : "protein_coding",
      gene_name : "ZNF160",
      gene_level : 1,
      hgnc_id : "HGNC:12948",
      havana_gene : "OTTHUMG00000182854.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53107879,
      stop : 53133077,
      direction : "-",
      ID : "ENSG00000170954.11",
      gene_id : "ENSG00000170954.11",
      gene_type : "protein_coding",
      gene_name : "ZNF415",
      gene_level : 2,
      hgnc_id : "HGNC:20636",
      havana_gene : "OTTHUMG00000182865.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53124072,
      stop : 53159075,
      direction : "-",
      ID : "ENSG00000197937.13",
      gene_id : "ENSG00000197937.13",
      gene_type : "protein_coding",
      gene_name : "ZNF347",
      gene_level : 2,
      hgnc_id : "HGNC:16447",
      havana_gene : "OTTHUMG00000182883.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53159213,
      stop : 53193386,
      direction : "-",
      ID : "ENSG00000197497.11",
      gene_id : "ENSG00000197497.11",
      gene_type : "protein_coding",
      gene_name : "ZNF665",
      gene_level : 2,
      hgnc_id : "HGNC:25885",
      havana_gene : "OTTHUMG00000182885.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53235381,
      stop : 53254898,
      direction : "-",
      ID : "ENSG00000197928.11",
      gene_id : "ENSG00000197928.11",
      gene_type : "protein_coding",
      gene_name : "ZNF677",
      gene_level : 1,
      hgnc_id : "HGNC:28730",
      havana_gene : "OTTHUMG00000182890.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53258292,
      stop : 53261837,
      direction : "+",
      ID : "ENSG00000196131.6",
      gene_id : "ENSG00000196131.6",
      gene_type : "protein_coding",
      gene_name : "VN1R2",
      gene_level : 2,
      hgnc_id : "HGNC:19872",
      havana_gene : "OTTHUMG00000182906.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53266676,
      stop : 53267723,
      direction : "-",
      ID : "ENSG00000228567.3",
      gene_id : "ENSG00000228567.3",
      gene_type : "protein_coding",
      gene_name : "VN1R4",
      gene_level : 2,
      hgnc_id : "HGNC:19871",
      havana_gene : "OTTHUMG00000182907.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53333749,
      stop : 53356906,
      direction : "+",
      ID : "ENSG00000213799.13",
      gene_id : "ENSG00000213799.13",
      gene_type : "protein_coding",
      gene_name : "ZNF845",
      gene_level : 2,
      hgnc_id : "HGNC:25112",
      havana_gene : "OTTHUMG00000182920.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53365693,
      stop : 53392217,
      direction : "+",
      ID : "ENSG00000203326.12",
      gene_id : "ENSG00000203326.12",
      gene_type : "protein_coding",
      gene_name : "ZNF525",
      gene_level : 1,
      hgnc_id : "HGNC:29423",
      havana_gene : "OTTHUMG00000158277.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53389793,
      stop : 53430413,
      direction : "+",
      ID : "ENSG00000196417.13",
      gene_id : "ENSG00000196417.13",
      gene_type : "protein_coding",
      gene_name : "ZNF765",
      gene_level : 2,
      hgnc_id : "HGNC:25092",
      havana_gene : "OTTHUMG00000163079.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53431984,
      stop : 53461862,
      direction : "+",
      ID : "ENSG00000160336.16",
      gene_id : "ENSG00000160336.16",
      gene_type : "protein_coding",
      gene_name : "ZNF761",
      gene_level : 2,
      hgnc_id : "HGNC:23179",
      havana_gene : "OTTHUMG00000156999.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53467733,
      stop : 53496255,
      direction : "+",
      ID : "ENSG00000198346.11",
      gene_id : "ENSG00000198346.11",
      gene_type : "protein_coding",
      gene_name : "ZNF813",
      gene_level : 1,
      hgnc_id : "HGNC:33257",
      havana_gene : "OTTHUMG00000158309.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53519527,
      stop : 53580269,
      direction : "+",
      ID : "ENSG00000130844.19",
      gene_id : "ENSG00000130844.19",
      gene_type : "protein_coding",
      gene_name : "ZNF331",
      gene_level : 2,
      hgnc_id : "HGNC:15489",
      havana_gene : "OTTHUMG00000163019.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53632056,
      stop : 53637009,
      direction : "+",
      ID : "ENSG00000204595.1",
      gene_id : "ENSG00000204595.1",
      gene_type : "protein_coding",
      gene_name : "DPRX",
      gene_level : 2,
      hgnc_id : "HGNC:32166",
      havana_gene : "OTTHUMG00000170632.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53793741,
      stop : 53824394,
      direction : "-",
      ID : "ENSG00000142405.22",
      gene_id : "ENSG00000142405.22",
      gene_type : "protein_coding",
      gene_name : "NLRP12",
      gene_level : 2,
      hgnc_id : "HGNC:22938",
      havana_gene : "OTTHUMG00000060776.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53864763,
      stop : 53876435,
      direction : "+",
      ID : "ENSG00000179820.16",
      gene_id : "ENSG00000179820.16",
      gene_type : "protein_coding",
      gene_name : "MYADM",
      gene_level : 2,
      hgnc_id : "HGNC:7544",
      havana_gene : "OTTHUMG00000060775.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53879190,
      stop : 53907652,
      direction : "+",
      ID : "ENSG00000126583.11",
      gene_id : "ENSG00000126583.11",
      gene_type : "protein_coding",
      gene_name : "PRKCG",
      gene_level : 1,
      hgnc_id : "HGNC:9402",
      havana_gene : "OTTHUMG00000064846.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53909278,
      stop : 53943950,
      direction : "+",
      ID : "ENSG00000105605.8",
      gene_id : "ENSG00000105605.8",
      gene_type : "protein_coding",
      gene_name : "CACNG7",
      gene_level : 2,
      hgnc_id : "HGNC:13626",
      havana_gene : "OTTHUMG00000064852.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53962937,
      stop : 53990215,
      direction : "+",
      ID : "ENSG00000142408.7",
      gene_id : "ENSG00000142408.7",
      gene_type : "protein_coding",
      gene_name : "CACNG8",
      gene_level : 2,
      hgnc_id : "HGNC:13628",
      havana_gene : "OTTHUMG00000064908.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 53991637,
      stop : 54012666,
      direction : "+",
      ID : "ENSG00000130433.8",
      gene_id : "ENSG00000130433.8",
      gene_type : "protein_coding",
      gene_name : "CACNG6",
      gene_level : 2,
      hgnc_id : "HGNC:13625",
      havana_gene : "OTTHUMG00000064907.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54040825,
      stop : 54063953,
      direction : "-",
      ID : "ENSG00000189068.11",
      gene_id : "ENSG00000189068.11",
      gene_type : "protein_coding",
      gene_name : "VSTM1",
      gene_level : 2,
      hgnc_id : "HGNC:29455",
      havana_gene : "OTTHUMG00000064906.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54069895,
      stop : 54081365,
      direction : "-",
      ID : "ENSG00000248385.8",
      gene_id : "ENSG00000248385.8",
      gene_type : "protein_coding",
      gene_name : "TARM1",
      gene_level : 2,
      hgnc_id : "HGNC:37250",
      havana_gene : "OTTHUMG00000064912.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54094668,
      stop : 54102692,
      direction : "-",
      ID : "ENSG00000170909.13",
      gene_id : "ENSG00000170909.13",
      gene_type : "protein_coding",
      gene_name : "OSCAR",
      gene_level : 2,
      hgnc_id : "HGNC:29960",
      havana_gene : "OTTHUMG00000064966.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54102728,
      stop : 54109257,
      direction : "+",
      ID : "ENSG00000170906.16",
      gene_id : "ENSG00000170906.16",
      gene_type : "protein_coding",
      gene_name : "NDUFA3",
      gene_level : 2,
      hgnc_id : "HGNC:7686",
      havana_gene : "OTTHUMG00000064972.15",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54107020,
      stop : 54115657,
      direction : "-",
      ID : "ENSG00000105619.14",
      gene_id : "ENSG00000105619.14",
      gene_type : "protein_coding",
      gene_name : "TFPT",
      gene_level : 1,
      hgnc_id : "HGNC:13630",
      havana_gene : "OTTHUMG00000065906.9",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54115410,
      stop : 54131719,
      direction : "+",
      ID : "ENSG00000105618.14",
      gene_id : "ENSG00000105618.14",
      gene_type : "protein_coding",
      gene_name : "PRPF31",
      gene_level : 2,
      hgnc_id : "HGNC:15446",
      havana_gene : "OTTHUMG00000066040.14",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54137749,
      stop : 54155681,
      direction : "+",
      ID : "ENSG00000088038.19",
      gene_id : "ENSG00000088038.19",
      gene_type : "protein_coding",
      gene_name : "CNOT3",
      gene_level : 1,
      hgnc_id : "HGNC:7879",
      havana_gene : "OTTHUMG00000066468.15",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54155161,
      stop : 54159721,
      direction : "-",
      ID : "ENSG00000105617.4",
      gene_id : "ENSG00000105617.4",
      gene_type : "protein_coding",
      gene_name : "LENG1",
      gene_level : 2,
      hgnc_id : "HGNC:15502",
      havana_gene : "OTTHUMG00000066486.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54160108,
      stop : 54173250,
      direction : "-",
      ID : "ENSG00000167608.12",
      gene_id : "ENSG00000167608.12",
      gene_type : "protein_coding",
      gene_name : "TMC4",
      gene_level : 1,
      hgnc_id : "HGNC:22998",
      havana_gene : "OTTHUMG00000066485.28",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54173412,
      stop : 54189882,
      direction : "-",
      ID : "ENSG00000125505.17",
      gene_id : "ENSG00000125505.17",
      gene_type : "protein_coding",
      gene_name : "MBOAT7",
      gene_level : 1,
      hgnc_id : "HGNC:15505",
      havana_gene : "OTTHUMG00000066516.11",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54189938,
      stop : 54194536,
      direction : "+",
      ID : "ENSG00000170892.13",
      gene_id : "ENSG00000170892.13",
      gene_type : "protein_coding",
      gene_name : "TSEN34",
      gene_level : 2,
      hgnc_id : "HGNC:15506",
      havana_gene : "OTTHUMG00000066515.32",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54200809,
      stop : 54249003,
      direction : "+",
      ID : "ENSG00000170889.14",
      gene_id : "ENSG00000170889.14",
      gene_type : "protein_coding",
      gene_name : "RPS9",
      gene_level : 2,
      hgnc_id : "HGNC:10442",
      havana_gene : "OTTHUMG00000066618.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54216278,
      stop : 54223506,
      direction : "-",
      ID : "ENSG00000204577.11",
      gene_id : "ENSG00000204577.11",
      gene_type : "protein_coding",
      gene_name : "LILRB3",
      gene_level : 2,
      hgnc_id : "HGNC:6607",
      havana_gene : "OTTHUMG00000066626.10",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54236592,
      stop : 54242791,
      direction : "-",
      ID : "ENSG00000244482.10",
      gene_id : "ENSG00000244482.10",
      gene_type : "protein_coding",
      gene_name : "LILRA6",
      gene_level : 2,
      hgnc_id : "HGNC:15495",
      havana_gene : "OTTHUMG00000066635.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54249421,
      stop : 54257301,
      direction : "-",
      ID : "ENSG00000105609.17",
      gene_id : "ENSG00000105609.17",
      gene_type : "protein_coding",
      gene_name : "LILRB5",
      gene_level : 2,
      hgnc_id : "HGNC:6609",
      havana_gene : "OTTHUMG00000066636.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54273812,
      stop : 54281184,
      direction : "-",
      ID : "ENSG00000131042.15",
      gene_id : "ENSG00000131042.15",
      gene_type : "protein_coding",
      gene_name : "LILRB2",
      gene_level : 2,
      hgnc_id : "HGNC:6606",
      havana_gene : "OTTHUMG00000064896.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54307070,
      stop : 54313166,
      direction : "-",
      ID : "ENSG00000187116.14",
      gene_id : "ENSG00000187116.14",
      gene_type : "protein_coding",
      gene_name : "LILRA5",
      gene_level : 2,
      hgnc_id : "HGNC:16309",
      havana_gene : "OTTHUMG00000065357.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54333185,
      stop : 54339162,
      direction : "-",
      ID : "ENSG00000239961.3",
      gene_id : "ENSG00000239961.3",
      gene_type : "protein_coding",
      gene_name : "LILRA4",
      gene_level : 2,
      hgnc_id : "HGNC:15503",
      havana_gene : "OTTHUMG00000065355.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54351384,
      stop : 54370558,
      direction : "-",
      ID : "ENSG00000167613.16",
      gene_id : "ENSG00000167613.16",
      gene_type : "protein_coding",
      gene_name : "LAIR1",
      gene_level : 2,
      hgnc_id : "HGNC:6477",
      havana_gene : "OTTHUMG00000065545.13",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54415219,
      stop : 54436904,
      direction : "+",
      ID : "ENSG00000167614.14",
      gene_id : "ENSG00000167614.14",
      gene_type : "protein_coding",
      gene_name : "TTYH1",
      gene_level : 2,
      hgnc_id : "HGNC:13476",
      havana_gene : "OTTHUMG00000065544.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54448887,
      stop : 54462016,
      direction : "+",
      ID : "ENSG00000167615.17",
      gene_id : "ENSG00000167615.17",
      gene_type : "protein_coding",
      gene_name : "LENG8",
      gene_level : 1,
      hgnc_id : "HGNC:15500",
      havana_gene : "OTTHUMG00000065548.14",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54461732,
      stop : 54463778,
      direction : "-",
      ID : "ENSG00000275183.2",
      gene_id : "ENSG00000275183.2",
      gene_type : "protein_coding",
      gene_name : "LENG9",
      gene_level : 2,
      hgnc_id : "HGNC:16306",
      havana_gene : "OTTHUMG00000188273.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54465026,
      stop : 54473296,
      direction : "-",
      ID : "ENSG00000167617.3",
      gene_id : "ENSG00000167617.3",
      gene_type : "protein_coding",
      gene_name : "CDC42EP5",
      gene_level : 2,
      hgnc_id : "HGNC:17408",
      havana_gene : "OTTHUMG00000065699.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54497879,
      stop : 54510687,
      direction : "+",
      ID : "ENSG00000167618.10",
      gene_id : "ENSG00000167618.10",
      gene_type : "protein_coding",
      gene_name : "LAIR2",
      gene_level : 2,
      hgnc_id : "HGNC:6478",
      havana_gene : "OTTHUMG00000065697.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54572920,
      stop : 54590287,
      direction : "+",
      ID : "ENSG00000239998.6",
      gene_id : "ENSG00000239998.6",
      gene_type : "protein_coding",
      gene_name : "LILRA2",
      gene_level : 1,
      hgnc_id : "HGNC:6603",
      havana_gene : "OTTHUMG00000065703.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54593582,
      stop : 54602381,
      direction : "+",
      ID : "ENSG00000104974.12",
      gene_id : "ENSG00000104974.12",
      gene_type : "protein_coding",
      gene_name : "LILRA1",
      gene_level : 2,
      hgnc_id : "HGNC:6602",
      havana_gene : "OTTHUMG00000065701.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54617158,
      stop : 54637528,
      direction : "+",
      ID : "ENSG00000104972.15",
      gene_id : "ENSG00000104972.15",
      gene_type : "protein_coding",
      gene_name : "LILRB1",
      gene_level : 2,
      hgnc_id : "HGNC:6605",
      havana_gene : "OTTHUMG00000065695.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54643889,
      stop : 54670359,
      direction : "+",
      ID : "ENSG00000186818.12",
      gene_id : "ENSG00000186818.12",
      gene_type : "protein_coding",
      gene_name : "LILRB4",
      gene_level : 2,
      hgnc_id : "HGNC:6608",
      havana_gene : "OTTHUMG00000065879.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54724479,
      stop : 54736536,
      direction : "+",
      ID : "ENSG00000242019.1",
      gene_id : "ENSG00000242019.1",
      gene_type : "protein_coding",
      gene_name : "KIR3DL3",
      gene_level : 2,
      hgnc_id : "HGNC:16312",
      havana_gene : "OTTHUMG00000065884.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54738513,
      stop : 54753052,
      direction : "+",
      ID : "ENSG00000243772.8",
      gene_id : "ENSG00000243772.8",
      gene_type : "protein_coding",
      gene_name : "KIR2DL3",
      gene_level : 2,
      hgnc_id : "HGNC:6331",
      havana_gene : "OTTHUMG00000065887.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54769793,
      stop : 54784322,
      direction : "+",
      ID : "ENSG00000125498.20",
      gene_id : "ENSG00000125498.20",
      gene_type : "protein_coding",
      gene_name : "KIR2DL1",
      gene_level : 2,
      hgnc_id : "HGNC:6329",
      havana_gene : "OTTHUMG00000065885.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54803535,
      stop : 54814517,
      direction : "+",
      ID : "ENSG00000189013.14",
      gene_id : "ENSG00000189013.14",
      gene_type : "protein_coding",
      gene_name : "KIR2DL4",
      gene_level : 2,
      hgnc_id : "HGNC:6332",
      havana_gene : "OTTHUMG00000065880.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54816468,
      stop : 54830778,
      direction : "+",
      ID : "ENSG00000167633.18",
      gene_id : "ENSG00000167633.18",
      gene_type : "protein_coding",
      gene_name : "KIR3DL1",
      gene_level : 2,
      hgnc_id : "HGNC:6338",
      havana_gene : "OTTHUMG00000065933.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54850443,
      stop : 54867207,
      direction : "+",
      ID : "ENSG00000240403.5",
      gene_id : "ENSG00000240403.5",
      gene_type : "protein_coding",
      gene_name : "KIR3DL2",
      gene_level : 2,
      hgnc_id : "HGNC:6339",
      havana_gene : "OTTHUMG00000065935.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54874235,
      stop : 54891420,
      direction : "+",
      ID : "ENSG00000186431.19",
      gene_id : "ENSG00000186431.19",
      gene_type : "protein_coding",
      gene_name : "FCAR",
      gene_level : 2,
      hgnc_id : "HGNC:3608",
      havana_gene : "OTTHUMG00000065936.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54906148,
      stop : 54916140,
      direction : "+",
      ID : "ENSG00000189430.13",
      gene_id : "ENSG00000189430.13",
      gene_type : "protein_coding",
      gene_name : "NCR1",
      gene_level : 1,
      hgnc_id : "HGNC:6731",
      havana_gene : "OTTHUMG00000183212.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54923509,
      stop : 54966312,
      direction : "-",
      ID : "ENSG00000167634.12",
      gene_id : "ENSG00000167634.12",
      gene_type : "protein_coding",
      gene_name : "NLRP7",
      gene_level : 2,
      hgnc_id : "HGNC:22947",
      havana_gene : "OTTHUMG00000180428.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 54953130,
      stop : 55001142,
      direction : "+",
      ID : "ENSG00000022556.16",
      gene_id : "ENSG00000022556.16",
      gene_type : "protein_coding",
      gene_name : "NLRP2",
      gene_level : 2,
      hgnc_id : "HGNC:22948",
      havana_gene : "OTTHUMG00000167763.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55013705,
      stop : 55038264,
      direction : "-",
      ID : "ENSG00000088053.11",
      gene_id : "ENSG00000088053.11",
      gene_type : "protein_coding",
      gene_name : "GP6",
      gene_level : 2,
      hgnc_id : "HGNC:14388",
      havana_gene : "OTTHUMG00000159709.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55039108,
      stop : 55071291,
      direction : "-",
      ID : "ENSG00000160439.16",
      gene_id : "ENSG00000160439.16",
      gene_type : "protein_coding",
      gene_name : "RDH13",
      gene_level : 2,
      hgnc_id : "HGNC:19978",
      havana_gene : "OTTHUMG00000180478.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55072020,
      stop : 55087923,
      direction : "+",
      ID : "ENSG00000131037.15",
      gene_id : "ENSG00000131037.15",
      gene_type : "protein_coding",
      gene_name : "EPS8L1",
      gene_level : 1,
      hgnc_id : "HGNC:21295",
      havana_gene : "OTTHUMG00000180513.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55090914,
      stop : 55117637,
      direction : "-",
      ID : "ENSG00000125503.13",
      gene_id : "ENSG00000125503.13",
      gene_type : "protein_coding",
      gene_name : "PPP1R12C",
      gene_level : 2,
      hgnc_id : "HGNC:14947",
      havana_gene : "OTTHUMG00000180540.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55132698,
      stop : 55149206,
      direction : "-",
      ID : "ENSG00000105048.17",
      gene_id : "ENSG00000105048.17",
      gene_type : "protein_coding",
      gene_name : "TNNT1",
      gene_level : 2,
      hgnc_id : "HGNC:11948",
      havana_gene : "OTTHUMG00000180542.8",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55151767,
      stop : 55157773,
      direction : "-",
      ID : "ENSG00000129991.13",
      gene_id : "ENSG00000129991.13",
      gene_type : "protein_coding",
      gene_name : "TNNI3",
      gene_level : 2,
      hgnc_id : "HGNC:11947",
      havana_gene : "OTTHUMG00000180589.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55154757,
      stop : 55160671,
      direction : "-",
      ID : "ENSG00000267110.1",
      gene_id : "ENSG00000267110.1",
      gene_type : "protein_coding",
      gene_name : "AC010327.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180667.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55158661,
      stop : 55166722,
      direction : "-",
      ID : "ENSG00000167646.14",
      gene_id : "ENSG00000167646.14",
      gene_type : "protein_coding",
      gene_name : "DNAAF3",
      gene_level : 2,
      hgnc_id : "HGNC:30492",
      havana_gene : "OTTHUMG00000128547.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55171196,
      stop : 55180289,
      direction : "-",
      ID : "ENSG00000129990.15",
      gene_id : "ENSG00000129990.15",
      gene_type : "protein_coding",
      gene_name : "SYT5",
      gene_level : 2,
      hgnc_id : "HGNC:11513",
      havana_gene : "OTTHUMG00000180669.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55181247,
      stop : 55209506,
      direction : "-",
      ID : "ENSG00000080031.10",
      gene_id : "ENSG00000080031.10",
      gene_type : "protein_coding",
      gene_name : "PTPRH",
      gene_level : 2,
      hgnc_id : "HGNC:9672",
      havana_gene : "OTTHUMG00000180701.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55226638,
      stop : 55228784,
      direction : "-",
      ID : "ENSG00000180089.6",
      gene_id : "ENSG00000180089.6",
      gene_type : "protein_coding",
      gene_name : "TMEM86B",
      gene_level : 2,
      hgnc_id : "HGNC:28448",
      havana_gene : "OTTHUMG00000187285.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55229779,
      stop : 55259017,
      direction : "-",
      ID : "ENSG00000105063.19",
      gene_id : "ENSG00000105063.19",
      gene_type : "protein_coding",
      gene_name : "PPP6R1",
      gene_level : 2,
      hgnc_id : "HGNC:29195",
      havana_gene : "OTTHUMG00000180704.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55262223,
      stop : 55280381,
      direction : "-",
      ID : "ENSG00000133265.11",
      gene_id : "ENSG00000133265.11",
      gene_type : "protein_coding",
      gene_name : "HSPBP1",
      gene_level : 1,
      hgnc_id : "HGNC:24989",
      havana_gene : "OTTHUMG00000180705.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55282072,
      stop : 55312562,
      direction : "+",
      ID : "ENSG00000160469.17",
      gene_id : "ENSG00000160469.17",
      gene_type : "protein_coding",
      gene_name : "BRSK1",
      gene_level : 1,
      hgnc_id : "HGNC:18994",
      havana_gene : "OTTHUMG00000180735.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55312801,
      stop : 55334048,
      direction : "-",
      ID : "ENSG00000180061.10",
      gene_id : "ENSG00000180061.10",
      gene_type : "protein_coding",
      gene_name : "TMEM150B",
      gene_level : 2,
      hgnc_id : "HGNC:34415",
      havana_gene : "OTTHUMG00000180709.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55339853,
      stop : 55348121,
      direction : "+",
      ID : "ENSG00000133247.14",
      gene_id : "ENSG00000133247.14",
      gene_type : "protein_coding",
      gene_name : "KMT5C",
      gene_level : 2,
      hgnc_id : "HGNC:28405",
      havana_gene : "OTTHUMG00000150483.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55349306,
      stop : 55354719,
      direction : "-",
      ID : "ENSG00000160471.13",
      gene_id : "ENSG00000160471.13",
      gene_type : "protein_coding",
      gene_name : "COX6B2",
      gene_level : 2,
      hgnc_id : "HGNC:24380",
      havana_gene : "OTTHUMG00000180774.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55352301,
      stop : 55359516,
      direction : "-",
      ID : "ENSG00000267706.3",
      gene_id : "ENSG00000267706.3",
      gene_type : "protein_coding",
      gene_name : "AC020922.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180784.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55354908,
      stop : 55363260,
      direction : "-",
      ID : "ENSG00000180043.11",
      gene_id : "ENSG00000180043.11",
      gene_type : "protein_coding",
      gene_name : "FAM71E2",
      gene_level : 2,
      hgnc_id : "HGNC:25278",
      havana_gene : "OTTHUMG00000170357.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55364382,
      stop : 55370463,
      direction : "-",
      ID : "ENSG00000095752.7",
      gene_id : "ENSG00000095752.7",
      gene_type : "protein_coding",
      gene_name : "IL11",
      gene_level : 2,
      hgnc_id : "HGNC:5966",
      havana_gene : "OTTHUMG00000180789.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55376826,
      stop : 55378246,
      direction : "+",
      ID : "ENSG00000160472.5",
      gene_id : "ENSG00000160472.5",
      gene_type : "protein_coding",
      gene_name : "TMEM190",
      gene_level : 2,
      hgnc_id : "HGNC:29632",
      havana_gene : "OTTHUMG00000180794.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55379244,
      stop : 55384292,
      direction : "-",
      ID : "ENSG00000233493.4",
      gene_id : "ENSG00000233493.4",
      gene_type : "protein_coding",
      gene_name : "TMEM238",
      gene_level : 2,
      hgnc_id : "HGNC:40042",
      havana_gene : "OTTHUMG00000180795.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55385932,
      stop : 55403250,
      direction : "+",
      ID : "ENSG00000108107.15",
      gene_id : "ENSG00000108107.15",
      gene_type : "protein_coding",
      gene_name : "RPL28",
      gene_level : 1,
      hgnc_id : "HGNC:10330",
      havana_gene : "OTTHUMG00000171991.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55399745,
      stop : 55407788,
      direction : "-",
      ID : "ENSG00000108106.14",
      gene_id : "ENSG00000108106.14",
      gene_type : "protein_coding",
      gene_name : "UBE2S",
      gene_level : 1,
      hgnc_id : "HGNC:17895",
      havana_gene : "OTTHUMG00000180811.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55428740,
      stop : 55443277,
      direction : "-",
      ID : "ENSG00000187902.12",
      gene_id : "ENSG00000187902.12",
      gene_type : "protein_coding",
      gene_name : "SHISA7",
      gene_level : 2,
      hgnc_id : "HGNC:35409",
      havana_gene : "OTTHUMG00000154240.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55452985,
      stop : 55462343,
      direction : "-",
      ID : "ENSG00000063241.8",
      gene_id : "ENSG00000063241.8",
      gene_type : "protein_coding",
      gene_name : "ISOC2",
      gene_level : 2,
      hgnc_id : "HGNC:26278",
      havana_gene : "OTTHUMG00000180830.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55463002,
      stop : 55464707,
      direction : "-",
      ID : "ENSG00000283567.1",
      gene_id : "ENSG00000283567.1",
      gene_type : "protein_coding",
      gene_name : "C19orf85",
      gene_level : 2,
      hgnc_id : "HGNC:53653",
      havana_gene : "OTTHUMG00000191751.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55476617,
      stop : 55484487,
      direction : "+",
      ID : "ENSG00000197483.10",
      gene_id : "ENSG00000197483.10",
      gene_type : "protein_coding",
      gene_name : "ZNF628",
      gene_level : 2,
      hgnc_id : "HGNC:28054",
      havana_gene : "OTTHUMG00000150396.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55485188,
      stop : 55487568,
      direction : "+",
      ID : "ENSG00000090971.5",
      gene_id : "ENSG00000090971.5",
      gene_type : "protein_coding",
      gene_name : "NAT14",
      gene_level : 2,
      hgnc_id : "HGNC:28918",
      havana_gene : "OTTHUMG00000180854.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55488404,
      stop : 55519099,
      direction : "+",
      ID : "ENSG00000179954.16",
      gene_id : "ENSG00000179954.16",
      gene_type : "protein_coding",
      gene_name : "SSC5D",
      gene_level : 1,
      hgnc_id : "HGNC:26641",
      havana_gene : "OTTHUMG00000180855.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55528611,
      stop : 55537133,
      direction : "-",
      ID : "ENSG00000187550.9",
      gene_id : "ENSG00000187550.9",
      gene_type : "protein_coding",
      gene_name : "SBK2",
      gene_level : 2,
      hgnc_id : "HGNC:34416",
      havana_gene : "OTTHUMG00000155830.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55540656,
      stop : 55545543,
      direction : "-",
      ID : "ENSG00000231274.5",
      gene_id : "ENSG00000231274.5",
      gene_type : "protein_coding",
      gene_name : "SBK3",
      gene_level : 1,
      hgnc_id : "HGNC:44121",
      havana_gene : "OTTHUMG00000155831.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55576774,
      stop : 55580848,
      direction : "-",
      ID : "ENSG00000218891.5",
      gene_id : "ENSG00000218891.5",
      gene_type : "protein_coding",
      gene_name : "ZNF579",
      gene_level : 2,
      hgnc_id : "HGNC:26646",
      havana_gene : "OTTHUMG00000180857.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55591376,
      stop : 55601970,
      direction : "-",
      ID : "ENSG00000179943.8",
      gene_id : "ENSG00000179943.8",
      gene_type : "protein_coding",
      gene_name : "FIZ1",
      gene_level : 1,
      hgnc_id : "HGNC:25917",
      havana_gene : "OTTHUMG00000180858.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55600022,
      stop : 55603138,
      direction : "+",
      ID : "ENSG00000171443.7",
      gene_id : "ENSG00000171443.7",
      gene_type : "protein_coding",
      gene_name : "ZNF524",
      gene_level : 2,
      hgnc_id : "HGNC:28322",
      havana_gene : "OTTHUMG00000180859.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55605647,
      stop : 55617269,
      direction : "+",
      ID : "ENSG00000261221.4",
      gene_id : "ENSG00000261221.4",
      gene_type : "protein_coding",
      gene_name : "ZNF865",
      gene_level : 2,
      hgnc_id : "HGNC:38705",
      havana_gene : "OTTHUMG00000177108.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55620741,
      stop : 55624566,
      direction : "-",
      ID : "ENSG00000179922.6",
      gene_id : "ENSG00000179922.6",
      gene_type : "protein_coding",
      gene_name : "ZNF784",
      gene_level : 2,
      hgnc_id : "HGNC:33111",
      havana_gene : "OTTHUMG00000180860.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55635016,
      stop : 55643470,
      direction : "+",
      ID : "ENSG00000213015.9",
      gene_id : "ENSG00000213015.9",
      gene_type : "protein_coding",
      gene_name : "ZNF580",
      gene_level : 2,
      hgnc_id : "HGNC:29473",
      havana_gene : "OTTHUMG00000180868.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55635459,
      stop : 55645623,
      direction : "+",
      ID : "ENSG00000171425.10",
      gene_id : "ENSG00000171425.10",
      gene_type : "protein_coding",
      gene_name : "ZNF581",
      gene_level : 2,
      hgnc_id : "HGNC:25017",
      havana_gene : "OTTHUMG00000180869.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55641062,
      stop : 55653161,
      direction : "+",
      ID : "ENSG00000173581.8",
      gene_id : "ENSG00000173581.8",
      gene_type : "protein_coding",
      gene_name : "CCDC106",
      gene_level : 2,
      hgnc_id : "HGNC:30181",
      havana_gene : "OTTHUMG00000180907.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55654146,
      stop : 55674716,
      direction : "+",
      ID : "ENSG00000063244.13",
      gene_id : "ENSG00000063244.13",
      gene_type : "protein_coding",
      gene_name : "U2AF2",
      gene_level : 2,
      hgnc_id : "HGNC:23156",
      havana_gene : "OTTHUMG00000180908.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55675226,
      stop : 55709858,
      direction : "+",
      ID : "ENSG00000063245.15",
      gene_id : "ENSG00000063245.15",
      gene_type : "protein_coding",
      gene_name : "EPN1",
      gene_level : 2,
      hgnc_id : "HGNC:21604",
      havana_gene : "OTTHUMG00000180911.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55708438,
      stop : 55738402,
      direction : "-",
      ID : "ENSG00000185792.10",
      gene_id : "ENSG00000185792.10",
      gene_type : "protein_coding",
      gene_name : "NLRP9",
      gene_level : 2,
      hgnc_id : "HGNC:22941",
      havana_gene : "OTTHUMG00000180920.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55759014,
      stop : 55763175,
      direction : "+",
      ID : "ENSG00000223638.3",
      gene_id : "ENSG00000223638.3",
      gene_type : "protein_coding",
      gene_name : "RFPL4A",
      gene_level : 2,
      hgnc_id : "HGNC:16449",
      havana_gene : "OTTHUMG00000165449.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55769118,
      stop : 55773420,
      direction : "+",
      ID : "ENSG00000229292.2",
      gene_id : "ENSG00000229292.2",
      gene_type : "protein_coding",
      gene_name : "RFPL4AL1",
      gene_level : 2,
      hgnc_id : "HGNC:45147",
      havana_gene : "OTTHUMG00000165450.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55785397,
      stop : 55836800,
      direction : "-",
      ID : "ENSG00000179873.14",
      gene_id : "ENSG00000179873.14",
      gene_type : "protein_coding",
      gene_name : "NLRP11",
      gene_level : 2,
      hgnc_id : "HGNC:22945",
      havana_gene : "OTTHUMG00000180921.7",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55836540,
      stop : 55881855,
      direction : "+",
      ID : "ENSG00000160505.16",
      gene_id : "ENSG00000160505.16",
      gene_type : "protein_coding",
      gene_name : "NLRP4",
      gene_level : 1,
      hgnc_id : "HGNC:22943",
      havana_gene : "OTTHUMG00000181734.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55891699,
      stop : 55932336,
      direction : "-",
      ID : "ENSG00000173572.11",
      gene_id : "ENSG00000173572.11",
      gene_type : "protein_coding",
      gene_name : "NLRP13",
      gene_level : 2,
      hgnc_id : "HGNC:22937",
      havana_gene : "OTTHUMG00000167839.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55947832,
      stop : 55988629,
      direction : "+",
      ID : "ENSG00000179709.8",
      gene_id : "ENSG00000179709.8",
      gene_type : "protein_coding",
      gene_name : "NLRP8",
      gene_level : 2,
      hgnc_id : "HGNC:22940",
      havana_gene : "OTTHUMG00000181754.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 55999726,
      stop : 56061810,
      direction : "+",
      ID : "ENSG00000171487.15",
      gene_id : "ENSG00000171487.15",
      gene_type : "protein_coding",
      gene_name : "NLRP5",
      gene_level : 2,
      hgnc_id : "HGNC:21269",
      havana_gene : "OTTHUMG00000149887.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56087366,
      stop : 56121295,
      direction : "-",
      ID : "ENSG00000142409.6",
      gene_id : "ENSG00000142409.6",
      gene_type : "protein_coding",
      gene_name : "ZNF787",
      gene_level : 2,
      hgnc_id : "HGNC:26998",
      havana_gene : "OTTHUMG00000181760.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56132599,
      stop : 56160893,
      direction : "+",
      ID : "ENSG00000167685.15",
      gene_id : "ENSG00000167685.15",
      gene_type : "protein_coding",
      gene_name : "ZNF444",
      gene_level : 2,
      hgnc_id : "HGNC:16052",
      havana_gene : "OTTHUMG00000181761.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56176008,
      stop : 56185775,
      direction : "+",
      ID : "ENSG00000197487.9",
      gene_id : "ENSG00000197487.9",
      gene_type : "protein_coding",
      gene_name : "GALP",
      gene_level : 2,
      hgnc_id : "HGNC:24840",
      havana_gene : "OTTHUMG00000181826.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56189570,
      stop : 56197920,
      direction : "-",
      ID : "ENSG00000197213.10",
      gene_id : "ENSG00000197213.10",
      gene_type : "protein_coding",
      gene_name : "ZSCAN5B",
      gene_level : 2,
      hgnc_id : "HGNC:34246",
      havana_gene : "OTTHUMG00000181827.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56202273,
      stop : 56209200,
      direction : "+",
      ID : "ENSG00000204532.8",
      gene_id : "ENSG00000204532.8",
      gene_type : "protein_coding",
      gene_name : "ZSCAN5C",
      gene_level : 2,
      hgnc_id : "HGNC:34294",
      havana_gene : "OTTHUMG00000167475.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56219670,
      stop : 56368383,
      direction : "-",
      ID : "ENSG00000131848.9",
      gene_id : "ENSG00000131848.9",
      gene_type : "protein_coding",
      gene_name : "ZSCAN5A",
      gene_level : 1,
      hgnc_id : "HGNC:23710",
      havana_gene : "OTTHUMG00000181883.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56272748,
      stop : 56310454,
      direction : "+",
      ID : "ENSG00000267710.9",
      gene_id : "ENSG00000267710.9",
      gene_type : "protein_coding",
      gene_name : "EDDM13",
      gene_level : 2,
      hgnc_id : "HGNC:53168",
      havana_gene : "OTTHUMG00000182076.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56375846,
      stop : 56393545,
      direction : "-",
      ID : "ENSG00000018869.17",
      gene_id : "ENSG00000018869.17",
      gene_type : "protein_coding",
      gene_name : "ZNF582",
      gene_level : 2,
      hgnc_id : "HGNC:26421",
      havana_gene : "OTTHUMG00000181939.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56397966,
      stop : 56436035,
      direction : "+",
      ID : "ENSG00000198440.9",
      gene_id : "ENSG00000198440.9",
      gene_type : "protein_coding",
      gene_name : "ZNF583",
      gene_level : 2,
      hgnc_id : "HGNC:26427",
      havana_gene : "OTTHUMG00000168874.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56439325,
      stop : 56478065,
      direction : "-",
      ID : "ENSG00000198046.12",
      gene_id : "ENSG00000198046.12",
      gene_type : "protein_coding",
      gene_name : "ZNF667",
      gene_level : 1,
      hgnc_id : "HGNC:28854",
      havana_gene : "OTTHUMG00000181941.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56507850,
      stop : 56530221,
      direction : "+",
      ID : "ENSG00000196263.8",
      gene_id : "ENSG00000196263.8",
      gene_type : "protein_coding",
      gene_name : "ZNF471",
      gene_level : 1,
      hgnc_id : "HGNC:23226",
      havana_gene : "OTTHUMG00000181943.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56538948,
      stop : 56556808,
      direction : "+",
      ID : "ENSG00000196867.8",
      gene_id : "ENSG00000196867.8",
      gene_type : "protein_coding",
      gene_name : "ZFP28",
      gene_level : 2,
      hgnc_id : "HGNC:17801",
      havana_gene : "OTTHUMG00000181944.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56567468,
      stop : 56588911,
      direction : "+",
      ID : "ENSG00000197016.12",
      gene_id : "ENSG00000197016.12",
      gene_type : "protein_coding",
      gene_name : "ZNF470",
      gene_level : 1,
      hgnc_id : "HGNC:22220",
      havana_gene : "OTTHUMG00000182141.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56595300,
      stop : 56626481,
      direction : "+",
      ID : "ENSG00000197951.10",
      gene_id : "ENSG00000197951.10",
      gene_type : "protein_coding",
      gene_name : "ZNF71",
      gene_level : 2,
      hgnc_id : "HGNC:13141",
      havana_gene : "OTTHUMG00000182157.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56643159,
      stop : 56657247,
      direction : "+",
      ID : "ENSG00000268182.6",
      gene_id : "ENSG00000268182.6",
      gene_type : "protein_coding",
      gene_name : "SMIM17",
      gene_level : 2,
      hgnc_id : "HGNC:27114",
      havana_gene : "OTTHUMG00000177861.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56661980,
      stop : 56671783,
      direction : "-",
      ID : "ENSG00000127903.14",
      gene_id : "ENSG00000127903.14",
      gene_type : "protein_coding",
      gene_name : "ZNF835",
      gene_level : 2,
      hgnc_id : "HGNC:34332",
      havana_gene : "OTTHUMG00000182158.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56774547,
      stop : 56840729,
      direction : "-",
      ID : "ENSG00000269699.6",
      gene_id : "ENSG00000269699.6",
      gene_type : "protein_coding",
      gene_name : "ZIM2",
      gene_level : 2,
      hgnc_id : "HGNC:12875",
      havana_gene : "OTTHUMG00000171953.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 56810077,
      stop : 56840728,
      direction : "-",
      ID : "ENSG00000198300.14",
      gene_id : "ENSG00000198300.14",
      gene_type : "protein_coding",
      gene_name : "PEG3",
      gene_level : 1,
      hgnc_id : "HGNC:8826",
      havana_gene : "OTTHUMG00000171954.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57119138,
      stop : 57131926,
      direction : "+",
      ID : "ENSG00000131864.10",
      gene_id : "ENSG00000131864.10",
      gene_type : "protein_coding",
      gene_name : "USP29",
      gene_level : 2,
      hgnc_id : "HGNC:18563",
      havana_gene : "OTTHUMG00000183101.2",
      tag : "retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57134096,
      stop : 57145202,
      direction : "-",
      ID : "ENSG00000141946.1",
      gene_id : "ENSG00000141946.1",
      gene_type : "protein_coding",
      gene_name : "ZIM3",
      gene_level : 2,
      hgnc_id : "HGNC:16366",
      havana_gene : "OTTHUMG00000183102.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57154021,
      stop : 57167485,
      direction : "-",
      ID : "ENSG00000258873.3",
      gene_id : "ENSG00000258873.3",
      gene_type : "protein_coding",
      gene_name : "DUXA",
      gene_level : 2,
      hgnc_id : "HGNC:32179",
      havana_gene : "OTTHUMG00000170714.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57191500,
      stop : 57222846,
      direction : "+",
      ID : "ENSG00000083844.10",
      gene_id : "ENSG00000083844.10",
      gene_type : "protein_coding",
      gene_name : "ZNF264",
      gene_level : 1,
      hgnc_id : "HGNC:13057",
      havana_gene : "OTTHUMG00000183104.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57230802,
      stop : 57235548,
      direction : "+",
      ID : "ENSG00000105146.13",
      gene_id : "ENSG00000105146.13",
      gene_type : "protein_coding",
      gene_name : "AURKC",
      gene_level : 1,
      hgnc_id : "HGNC:11391",
      havana_gene : "OTTHUMG00000183106.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57240632,
      stop : 57262728,
      direction : "+",
      ID : "ENSG00000204524.7",
      gene_id : "ENSG00000204524.7",
      gene_type : "protein_coding",
      gene_name : "ZNF805",
      gene_level : 2,
      hgnc_id : "HGNC:23272",
      havana_gene : "OTTHUMG00000183219.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57280051,
      stop : 57294069,
      direction : "+",
      ID : "ENSG00000197714.9",
      gene_id : "ENSG00000197714.9",
      gene_type : "protein_coding",
      gene_name : "ZNF460",
      gene_level : 1,
      hgnc_id : "HGNC:21628",
      havana_gene : "OTTHUMG00000183222.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57320472,
      stop : 57330770,
      direction : "+",
      ID : "ENSG00000178229.8",
      gene_id : "ENSG00000178229.8",
      gene_type : "protein_coding",
      gene_name : "ZNF543",
      gene_level : 2,
      hgnc_id : "HGNC:25281",
      havana_gene : "OTTHUMG00000183243.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57351271,
      stop : 57359898,
      direction : "+",
      ID : "ENSG00000131845.15",
      gene_id : "ENSG00000131845.15",
      gene_type : "protein_coding",
      gene_name : "ZNF304",
      gene_level : 1,
      hgnc_id : "HGNC:13505",
      havana_gene : "OTTHUMG00000183245.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57363477,
      stop : 57379565,
      direction : "+",
      ID : "ENSG00000152433.15",
      gene_id : "ENSG00000152433.15",
      gene_type : "protein_coding",
      gene_name : "ZNF547",
      gene_level : 2,
      hgnc_id : "HGNC:26432",
      havana_gene : "OTTHUMG00000183246.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57363551,
      stop : 57365405,
      direction : "+",
      ID : "ENSG00000256060.3",
      gene_id : "ENSG00000256060.3",
      gene_type : "protein_coding",
      gene_name : "TRAPPC2B",
      gene_level : 1,
      hgnc_id : "HGNC:10710",
      havana_gene : "OTTHUMG00000183279.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57363566,
      stop : 57398584,
      direction : "+",
      ID : "ENSG00000268133.1",
      gene_id : "ENSG00000268133.1",
      gene_type : "protein_coding",
      gene_name : "AC003002.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183282.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57389850,
      stop : 57402992,
      direction : "+",
      ID : "ENSG00000188785.12",
      gene_id : "ENSG00000188785.12",
      gene_type : "protein_coding",
      gene_name : "ZNF548",
      gene_level : 1,
      hgnc_id : "HGNC:26561",
      havana_gene : "OTTHUMG00000183281.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57389884,
      stop : 57419994,
      direction : "+",
      ID : "ENSG00000269533.5",
      gene_id : "ENSG00000269533.5",
      gene_type : "protein_coding",
      gene_name : "AC003002.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183372.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57394183,
      stop : 57438457,
      direction : "+",
      ID : "ENSG00000268533.1",
      gene_id : "ENSG00000268533.1",
      gene_type : "protein_coding",
      gene_name : "AC003002.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183378.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57411161,
      stop : 57421934,
      direction : "+",
      ID : "ENSG00000186272.13",
      gene_id : "ENSG00000186272.13",
      gene_type : "protein_coding",
      gene_name : "ZNF17",
      gene_level : 2,
      hgnc_id : "HGNC:12958",
      havana_gene : "OTTHUMG00000183371.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57435325,
      stop : 57447101,
      direction : "+",
      ID : "ENSG00000186230.7",
      gene_id : "ENSG00000186230.7",
      gene_type : "protein_coding",
      gene_name : "ZNF749",
      gene_level : 1,
      hgnc_id : "HGNC:32783",
      havana_gene : "OTTHUMG00000150372.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57437970,
      stop : 57477536,
      direction : "-",
      ID : "ENSG00000268163.1",
      gene_id : "ENSG00000268163.1",
      gene_type : "protein_coding",
      gene_name : "AC004076.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183399.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57454790,
      stop : 57457142,
      direction : "-",
      ID : "ENSG00000178201.4",
      gene_id : "ENSG00000178201.4",
      gene_type : "protein_coding",
      gene_name : "VN1R1",
      gene_level : 2,
      hgnc_id : "HGNC:13548",
      havana_gene : "OTTHUMG00000183400.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57466663,
      stop : 57477570,
      direction : "-",
      ID : "ENSG00000197128.12",
      gene_id : "ENSG00000197128.12",
      gene_type : "protein_coding",
      gene_name : "ZNF772",
      gene_level : 1,
      hgnc_id : "HGNC:33106",
      havana_gene : "OTTHUMG00000168007.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57487711,
      stop : 57496098,
      direction : "+",
      ID : "ENSG00000105136.21",
      gene_id : "ENSG00000105136.21",
      gene_type : "protein_coding",
      gene_name : "ZNF419",
      gene_level : 2,
      hgnc_id : "HGNC:20648",
      havana_gene : "OTTHUMG00000037073.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57487718,
      stop : 57517559,
      direction : "+",
      ID : "ENSG00000268107.6",
      gene_id : "ENSG00000268107.6",
      gene_type : "protein_coding",
      gene_name : "AC003005.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183404.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57499915,
      stop : 57518404,
      direction : "+",
      ID : "ENSG00000152439.13",
      gene_id : "ENSG00000152439.13",
      gene_type : "protein_coding",
      gene_name : "ZNF773",
      gene_level : 2,
      hgnc_id : "HGNC:30487",
      havana_gene : "OTTHUMG00000183403.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57527325,
      stop : 57557542,
      direction : "+",
      ID : "ENSG00000121406.9",
      gene_id : "ENSG00000121406.9",
      gene_type : "protein_coding",
      gene_name : "ZNF549",
      gene_level : 1,
      hgnc_id : "HGNC:26632",
      havana_gene : "OTTHUMG00000183465.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57535257,
      stop : 57559863,
      direction : "-",
      ID : "ENSG00000251369.9",
      gene_id : "ENSG00000251369.9",
      gene_type : "protein_coding",
      gene_name : "ZNF550",
      gene_level : 1,
      hgnc_id : "HGNC:28643",
      havana_gene : "OTTHUMG00000133709.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57571566,
      stop : 57578911,
      direction : "-",
      ID : "ENSG00000083817.9",
      gene_id : "ENSG00000083817.9",
      gene_type : "protein_coding",
      gene_name : "ZNF416",
      gene_level : 2,
      hgnc_id : "HGNC:20645",
      havana_gene : "OTTHUMG00000183467.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57578456,
      stop : 57593890,
      direction : "+",
      ID : "ENSG00000171649.12",
      gene_id : "ENSG00000171649.12",
      gene_type : "protein_coding",
      gene_name : "ZIK1",
      gene_level : 1,
      hgnc_id : "HGNC:33104",
      havana_gene : "OTTHUMG00000183468.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57599885,
      stop : 57612722,
      direction : "+",
      ID : "ENSG00000183647.10",
      gene_id : "ENSG00000183647.10",
      gene_type : "protein_coding",
      gene_name : "ZNF530",
      gene_level : 2,
      hgnc_id : "HGNC:29297",
      havana_gene : "OTTHUMG00000183469.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57614233,
      stop : 57624724,
      direction : "+",
      ID : "ENSG00000213762.12",
      gene_id : "ENSG00000213762.12",
      gene_type : "protein_coding",
      gene_name : "ZNF134",
      gene_level : 2,
      hgnc_id : "HGNC:12918",
      havana_gene : "OTTHUMG00000183471.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57630395,
      stop : 57644041,
      direction : "+",
      ID : "ENSG00000121417.14",
      gene_id : "ENSG00000121417.14",
      gene_type : "protein_coding",
      gene_name : "ZNF211",
      gene_level : 2,
      hgnc_id : "HGNC:13003",
      havana_gene : "OTTHUMG00000168012.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57668935,
      stop : 57679152,
      direction : "+",
      ID : "ENSG00000180532.10",
      gene_id : "ENSG00000180532.10",
      gene_type : "protein_coding",
      gene_name : "ZSCAN4",
      gene_level : 2,
      hgnc_id : "HGNC:23709",
      havana_gene : "OTTHUMG00000183474.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57681969,
      stop : 57717301,
      direction : "+",
      ID : "ENSG00000204519.11",
      gene_id : "ENSG00000204519.11",
      gene_type : "protein_coding",
      gene_name : "ZNF551",
      gene_level : 1,
      hgnc_id : "HGNC:25108",
      havana_gene : "OTTHUMG00000183470.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57682045,
      stop : 57753575,
      direction : "+",
      ID : "ENSG00000269026.2",
      gene_id : "ENSG00000269026.2",
      gene_type : "protein_coding",
      gene_name : "AC003006.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183475.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57697367,
      stop : 57709194,
      direction : "-",
      ID : "ENSG00000179909.15",
      gene_id : "ENSG00000179909.15",
      gene_type : "protein_coding",
      gene_name : "ZNF154",
      gene_level : 2,
      hgnc_id : "HGNC:12939",
      havana_gene : "OTTHUMG00000140375.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57719751,
      stop : 57727624,
      direction : "-",
      ID : "ENSG00000083814.13",
      gene_id : "ENSG00000083814.13",
      gene_type : "protein_coding",
      gene_name : "ZNF671",
      gene_level : 2,
      hgnc_id : "HGNC:26279",
      havana_gene : "OTTHUMG00000183476.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57746815,
      stop : 57758148,
      direction : "+",
      ID : "ENSG00000152443.13",
      gene_id : "ENSG00000152443.13",
      gene_type : "protein_coding",
      gene_name : "ZNF776",
      gene_level : 1,
      hgnc_id : "HGNC:26765",
      havana_gene : "OTTHUMG00000156943.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57769655,
      stop : 57819939,
      direction : "+",
      ID : "ENSG00000083828.16",
      gene_id : "ENSG00000083828.16",
      gene_type : "protein_coding",
      gene_name : "ZNF586",
      gene_level : 1,
      hgnc_id : "HGNC:25949",
      havana_gene : "OTTHUMG00000183477.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57803841,
      stop : 57814913,
      direction : "-",
      ID : "ENSG00000178935.5",
      gene_id : "ENSG00000178935.5",
      gene_type : "protein_coding",
      gene_name : "ZNF552",
      gene_level : 1,
      hgnc_id : "HGNC:26135",
      havana_gene : "OTTHUMG00000183478.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57819719,
      stop : 57858941,
      direction : "+",
      ID : "ENSG00000268750.7",
      gene_id : "ENSG00000268750.7",
      gene_type : "protein_coding",
      gene_name : "AC010522.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183527.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57819721,
      stop : 57846238,
      direction : "+",
      ID : "ENSG00000269343.9",
      gene_id : "ENSG00000269343.9",
      gene_type : "protein_coding",
      gene_name : "ZNF587B",
      gene_level : 2,
      hgnc_id : "HGNC:37142",
      havana_gene : "OTTHUMG00000183479.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57848731,
      stop : 57889074,
      direction : "-",
      ID : "ENSG00000204514.10",
      gene_id : "ENSG00000204514.10",
      gene_type : "protein_coding",
      gene_name : "ZNF814",
      gene_level : 1,
      hgnc_id : "HGNC:33258",
      havana_gene : "OTTHUMG00000183519.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57849859,
      stop : 57865117,
      direction : "+",
      ID : "ENSG00000198466.12",
      gene_id : "ENSG00000198466.12",
      gene_type : "protein_coding",
      gene_name : "ZNF587",
      gene_level : 1,
      hgnc_id : "HGNC:30955",
      havana_gene : "OTTHUMG00000154901.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57876765,
      stop : 57916591,
      direction : "-",
      ID : "ENSG00000269476.1",
      gene_id : "ENSG00000269476.1",
      gene_type : "protein_coding",
      gene_name : "AC010326.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183521.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57900296,
      stop : 57916610,
      direction : "-",
      ID : "ENSG00000173480.11",
      gene_id : "ENSG00000173480.11",
      gene_type : "protein_coding",
      gene_name : "ZNF417",
      gene_level : 2,
      hgnc_id : "HGNC:20646",
      havana_gene : "OTTHUMG00000183488.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57921882,
      stop : 57935402,
      direction : "-",
      ID : "ENSG00000196724.13",
      gene_id : "ENSG00000196724.13",
      gene_type : "protein_coding",
      gene_name : "ZNF418",
      gene_level : 1,
      hgnc_id : "HGNC:20647",
      havana_gene : "OTTHUMG00000183448.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57940833,
      stop : 57947706,
      direction : "-",
      ID : "ENSG00000152454.4",
      gene_id : "ENSG00000152454.4",
      gene_type : "protein_coding",
      gene_name : "ZNF256",
      gene_level : 2,
      hgnc_id : "HGNC:13049",
      havana_gene : "OTTHUMG00000183449.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57958437,
      stop : 57974534,
      direction : "-",
      ID : "ENSG00000177025.3",
      gene_id : "ENSG00000177025.3",
      gene_type : "protein_coding",
      gene_name : "C19orf18",
      gene_level : 2,
      hgnc_id : "HGNC:28642",
      havana_gene : "OTTHUMG00000183450.1",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 57977053,
      stop : 58003349,
      direction : "-",
      ID : "ENSG00000166704.11",
      gene_id : "ENSG00000166704.11",
      gene_type : "protein_coding",
      gene_name : "ZNF606",
      gene_level : 2,
      hgnc_id : "HGNC:25879",
      havana_gene : "OTTHUMG00000169804.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58034025,
      stop : 58054631,
      direction : "+",
      ID : "ENSG00000152467.10",
      gene_id : "ENSG00000152467.10",
      gene_type : "protein_coding",
      gene_name : "ZSCAN1",
      gene_level : 2,
      hgnc_id : "HGNC:23712",
      havana_gene : "OTTHUMG00000183381.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58059239,
      stop : 58086310,
      direction : "+",
      ID : "ENSG00000176293.20",
      gene_id : "ENSG00000176293.20",
      gene_type : "protein_coding",
      gene_name : "ZNF135",
      gene_level : 1,
      hgnc_id : "HGNC:12919",
      havana_gene : "OTTHUMG00000160719.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58083838,
      stop : 58118427,
      direction : "-",
      ID : "ENSG00000121413.13",
      gene_id : "ENSG00000121413.13",
      gene_type : "protein_coding",
      gene_name : "ZSCAN18",
      gene_level : 2,
      hgnc_id : "HGNC:21037",
      havana_gene : "OTTHUMG00000183451.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58126248,
      stop : 58155110,
      direction : "-",
      ID : "ENSG00000181894.15",
      gene_id : "ENSG00000181894.15",
      gene_type : "protein_coding",
      gene_name : "ZNF329",
      gene_level : 2,
      hgnc_id : "HGNC:14209",
      havana_gene : "OTTHUMG00000183453.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58183029,
      stop : 58213562,
      direction : "+",
      ID : "ENSG00000171606.18",
      gene_id : "ENSG00000171606.18",
      gene_type : "protein_coding",
      gene_name : "ZNF274",
      gene_level : 2,
      hgnc_id : "HGNC:13068",
      havana_gene : "OTTHUMG00000183456.6",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58228594,
      stop : 58277495,
      direction : "+",
      ID : "ENSG00000198131.14",
      gene_id : "ENSG00000198131.14",
      gene_type : "protein_coding",
      gene_name : "ZNF544",
      gene_level : 1,
      hgnc_id : "HGNC:16759",
      havana_gene : "OTTHUMG00000183458.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58228914,
      stop : 58315183,
      direction : "+",
      ID : "ENSG00000283515.1",
      gene_id : "ENSG00000283515.1",
      gene_type : "protein_coding",
      gene_name : "AC020915.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000183459.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58278955,
      stop : 58302791,
      direction : "+",
      ID : "ENSG00000278129.2",
      gene_id : "ENSG00000278129.2",
      gene_type : "protein_coding",
      gene_name : "ZNF8",
      gene_level : 2,
      hgnc_id : "HGNC:13154",
      havana_gene : "OTTHUMG00000182073.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58305319,
      stop : 58315663,
      direction : "+",
      ID : "ENSG00000142396.10",
      gene_id : "ENSG00000142396.10",
      gene_type : "protein_coding",
      gene_name : "ERVK3-1",
      gene_level : 2,
      hgnc_id : "HGNC:30466",
      havana_gene : "OTTHUMG00000150367.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58326994,
      stop : 58342332,
      direction : "+",
      ID : "ENSG00000182318.6",
      gene_id : "ENSG00000182318.6",
      gene_type : "protein_coding",
      gene_name : "ZSCAN22",
      gene_level : 2,
      hgnc_id : "HGNC:4929",
      havana_gene : "OTTHUMG00000183463.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58345178,
      stop : 58353492,
      direction : "-",
      ID : "ENSG00000121410.12",
      gene_id : "ENSG00000121410.12",
      gene_type : "protein_coding",
      gene_name : "A1BG",
      gene_level : 1,
      hgnc_id : "HGNC:5",
      havana_gene : "OTTHUMG00000183507.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58354357,
      stop : 58362848,
      direction : "-",
      ID : "ENSG00000174586.11",
      gene_id : "ENSG00000174586.11",
      gene_type : "protein_coding",
      gene_name : "ZNF497",
      gene_level : 2,
      hgnc_id : "HGNC:23714",
      havana_gene : "OTTHUMG00000183510.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58367618,
      stop : 58381030,
      direction : "-",
      ID : "ENSG00000152475.7",
      gene_id : "ENSG00000152475.7",
      gene_type : "protein_coding",
      gene_name : "ZNF837",
      gene_level : 2,
      hgnc_id : "HGNC:25164",
      havana_gene : "OTTHUMG00000183517.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58386400,
      stop : 58394806,
      direction : "+",
      ID : "ENSG00000083845.9",
      gene_id : "ENSG00000083845.9",
      gene_type : "protein_coding",
      gene_name : "RPS5",
      gene_level : 2,
      hgnc_id : "HGNC:10426",
      havana_gene : "OTTHUMG00000183530.5",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58396090,
      stop : 58397079,
      direction : "+",
      ID : "ENSG00000269855.2",
      gene_id : "ENSG00000269855.2",
      gene_type : "protein_coding",
      gene_name : "RNF225",
      gene_level : 2,
      hgnc_id : "HGNC:51249",
      havana_gene : "OTTHUMG00000189258.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58401504,
      stop : 58418327,
      direction : "+",
      ID : "ENSG00000171574.18",
      gene_id : "ENSG00000171574.18",
      gene_type : "protein_coding",
      gene_name : "ZNF584",
      gene_level : 1,
      hgnc_id : "HGNC:27318",
      havana_gene : "OTTHUMG00000183533.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58432814,
      stop : 58440153,
      direction : "-",
      ID : "ENSG00000131849.12",
      gene_id : "ENSG00000131849.12",
      gene_type : "protein_coding",
      gene_name : "ZNF132",
      gene_level : 2,
      hgnc_id : "HGNC:12916",
      havana_gene : "OTTHUMG00000183537.2",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58451611,
      stop : 58457833,
      direction : "+",
      ID : "ENSG00000249471.8",
      gene_id : "ENSG00000249471.8",
      gene_type : "protein_coding",
      gene_name : "ZNF324B",
      gene_level : 2,
      hgnc_id : "HGNC:33107",
      havana_gene : "OTTHUMG00000183539.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58467045,
      stop : 58475436,
      direction : "+",
      ID : "ENSG00000083812.12",
      gene_id : "ENSG00000083812.12",
      gene_type : "protein_coding",
      gene_name : "ZNF324",
      gene_level : 2,
      hgnc_id : "HGNC:14096",
      havana_gene : "OTTHUMG00000183540.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58474017,
      stop : 58481230,
      direction : "+",
      ID : "ENSG00000083838.16",
      gene_id : "ENSG00000083838.16",
      gene_type : "protein_coding",
      gene_name : "ZNF446",
      gene_level : 2,
      hgnc_id : "HGNC:21036",
      havana_gene : "OTTHUMG00000183541.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58479512,
      stop : 58512413,
      direction : "-",
      ID : "ENSG00000083807.10",
      gene_id : "ENSG00000083807.10",
      gene_type : "protein_coding",
      gene_name : "SLC27A5",
      gene_level : 1,
      hgnc_id : "HGNC:10999",
      havana_gene : "OTTHUMG00000183543.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58513530,
      stop : 58538911,
      direction : "-",
      ID : "ENSG00000119574.13",
      gene_id : "ENSG00000119574.13",
      gene_type : "protein_coding",
      gene_name : "ZBTB45",
      gene_level : 2,
      hgnc_id : "HGNC:23715",
      havana_gene : "OTTHUMG00000183545.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58544064,
      stop : 58550722,
      direction : "+",
      ID : "ENSG00000130726.12",
      gene_id : "ENSG00000130726.12",
      gene_type : "protein_coding",
      gene_name : "TRIM28",
      gene_level : 1,
      hgnc_id : "HGNC:16384",
      havana_gene : "OTTHUMG00000183546.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58551566,
      stop : 58555105,
      direction : "-",
      ID : "ENSG00000130724.9",
      gene_id : "ENSG00000130724.9",
      gene_type : "protein_coding",
      gene_name : "CHMP2A",
      gene_level : 2,
      hgnc_id : "HGNC:30216",
      havana_gene : "OTTHUMG00000183547.4",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58555712,
      stop : 58558954,
      direction : "-",
      ID : "ENSG00000130725.8",
      gene_id : "ENSG00000130725.8",
      gene_type : "protein_coding",
      gene_name : "UBE2M",
      gene_level : 2,
      hgnc_id : "HGNC:12491",
      havana_gene : "OTTHUMG00000183548.3",
      tag : null
    },
    {
      chromosome : 19,
      annotation : "HAVANA",
      type : "gene",
      start : 58561931,
      stop : 58573575,
      direction : "-",
      ID : "ENSG00000099326.9",
      gene_id : "ENSG00000099326.9",
      gene_type : "protein_coding",
      gene_name : "MZF1",
      gene_level : 2,
      hgnc_id : "HGNC:13108",
      havana_gene : "OTTHUMG00000183550.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38814,
      stop : 46870,
      direction : "-",
      ID : "ENSG00000184731.6",
      gene_id : "ENSG00000184731.6",
      gene_type : "protein_coding",
      gene_name : "FAM110C",
      gene_level : 2,
      hgnc_id : "HGNC:33340",
      havana_gene : "OTTHUMG00000151321.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 217730,
      stop : 266398,
      direction : "-",
      ID : "ENSG00000035115.22",
      gene_id : "ENSG00000035115.22",
      gene_type : "protein_coding",
      gene_name : "SH3YL1",
      gene_level : 2,
      hgnc_id : "HGNC:29546",
      havana_gene : "OTTHUMG00000151359.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 264140,
      stop : 278283,
      direction : "+",
      ID : "ENSG00000143727.16",
      gene_id : "ENSG00000143727.16",
      gene_type : "protein_coding",
      gene_name : "ACP1",
      gene_level : 2,
      hgnc_id : "HGNC:122",
      havana_gene : "OTTHUMG00000086933.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 279558,
      stop : 288851,
      direction : "-",
      ID : "ENSG00000189292.16",
      gene_id : "ENSG00000189292.16",
      gene_type : "protein_coding",
      gene_name : "ALKAL2",
      gene_level : 2,
      hgnc_id : "HGNC:27683",
      havana_gene : "OTTHUMG00000151366.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 663877,
      stop : 677406,
      direction : "-",
      ID : "ENSG00000151353.15",
      gene_id : "ENSG00000151353.15",
      gene_type : "protein_coding",
      gene_name : "TMEM18",
      gene_level : 1,
      hgnc_id : "HGNC:25257",
      havana_gene : "OTTHUMG00000151381.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 950849,
      stop : 1367613,
      direction : "+",
      ID : "ENSG00000172554.12",
      gene_id : "ENSG00000172554.12",
      gene_type : "protein_coding",
      gene_name : "SNTG2",
      gene_level : 2,
      hgnc_id : "HGNC:13741",
      havana_gene : "OTTHUMG00000151370.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 1374066,
      stop : 1543711,
      direction : "+",
      ID : "ENSG00000115705.22",
      gene_id : "ENSG00000115705.22",
      gene_type : "protein_coding",
      gene_name : "TPO",
      gene_level : 2,
      hgnc_id : "HGNC:12015",
      havana_gene : "OTTHUMG00000090271.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 1631887,
      stop : 1744852,
      direction : "-",
      ID : "ENSG00000130508.11",
      gene_id : "ENSG00000130508.11",
      gene_type : "protein_coding",
      gene_name : "PXDN",
      gene_level : 2,
      hgnc_id : "HGNC:14966",
      havana_gene : "OTTHUMG00000059697.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 1789113,
      stop : 2331664,
      direction : "-",
      ID : "ENSG00000186487.20",
      gene_id : "ENSG00000186487.20",
      gene_type : "protein_coding",
      gene_name : "MYT1L",
      gene_level : 1,
      hgnc_id : "HGNC:7623",
      havana_gene : "OTTHUMG00000151407.13",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3188925,
      stop : 3377830,
      direction : "-",
      ID : "ENSG00000032389.13",
      gene_id : "ENSG00000032389.13",
      gene_type : "protein_coding",
      gene_name : "EIPR1",
      gene_level : 1,
      hgnc_id : "HGNC:12383",
      havana_gene : "OTTHUMG00000090329.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3379675,
      stop : 3485094,
      direction : "+",
      ID : "ENSG00000171853.16",
      gene_id : "ENSG00000171853.16",
      gene_type : "protein_coding",
      gene_name : "TRAPPC12",
      gene_level : 1,
      hgnc_id : "HGNC:24284",
      havana_gene : "OTTHUMG00000090328.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3497366,
      stop : 3519531,
      direction : "-",
      ID : "ENSG00000182551.14",
      gene_id : "ENSG00000182551.14",
      gene_type : "protein_coding",
      gene_name : "ADI1",
      gene_level : 2,
      hgnc_id : "HGNC:30576",
      havana_gene : "OTTHUMG00000112441.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3532008,
      stop : 3558333,
      direction : "-",
      ID : "ENSG00000286905.1",
      gene_id : "ENSG00000286905.1",
      gene_type : "protein_coding",
      gene_name : "AC108488.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167878.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3541430,
      stop : 3558333,
      direction : "-",
      ID : "ENSG00000171865.10",
      gene_id : "ENSG00000171865.10",
      gene_type : "protein_coding",
      gene_name : "RNASEH1",
      gene_level : 2,
      hgnc_id : "HGNC:18466",
      havana_gene : "OTTHUMG00000090279.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3575260,
      stop : 3580920,
      direction : "+",
      ID : "ENSG00000171863.15",
      gene_id : "ENSG00000171863.15",
      gene_type : "protein_coding",
      gene_name : "RPS7",
      gene_level : 2,
      hgnc_id : "HGNC:10440",
      havana_gene : "OTTHUMG00000090305.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3594832,
      stop : 3644644,
      direction : "+",
      ID : "ENSG00000118004.18",
      gene_id : "ENSG00000118004.18",
      gene_type : "protein_coding",
      gene_name : "COLEC11",
      gene_level : 2,
      hgnc_id : "HGNC:17213",
      havana_gene : "OTTHUMG00000090304.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3658200,
      stop : 3702671,
      direction : "+",
      ID : "ENSG00000151360.10",
      gene_id : "ENSG00000151360.10",
      gene_type : "protein_coding",
      gene_name : "ALLC",
      gene_level : 2,
      hgnc_id : "HGNC:17377",
      havana_gene : "OTTHUMG00000151485.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 3703575,
      stop : 3848008,
      direction : "+",
      ID : "ENSG00000214866.9",
      gene_id : "ENSG00000214866.9",
      gene_type : "protein_coding",
      gene_name : "DCDC2C",
      gene_level : 1,
      hgnc_id : "HGNC:32696",
      havana_gene : "OTTHUMG00000151490.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 5692384,
      stop : 5701385,
      direction : "+",
      ID : "ENSG00000176887.7",
      gene_id : "ENSG00000176887.7",
      gene_type : "protein_coding",
      gene_name : "SOX11",
      gene_level : 2,
      hgnc_id : "HGNC:11191",
      havana_gene : "OTTHUMG00000090333.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 6840570,
      stop : 6866635,
      direction : "-",
      ID : "ENSG00000134326.12",
      gene_id : "ENSG00000134326.12",
      gene_type : "protein_coding",
      gene_name : "CMPK2",
      gene_level : 2,
      hgnc_id : "HGNC:27015",
      havana_gene : "OTTHUMG00000151629.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 6865557,
      stop : 6898239,
      direction : "+",
      ID : "ENSG00000134321.13",
      gene_id : "ENSG00000134321.13",
      gene_type : "protein_coding",
      gene_name : "RSAD2",
      gene_level : 2,
      hgnc_id : "HGNC:30908",
      havana_gene : "OTTHUMG00000090352.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 6917412,
      stop : 7068286,
      direction : "+",
      ID : "ENSG00000151692.15",
      gene_id : "ENSG00000151692.15",
      gene_type : "protein_coding",
      gene_name : "RNF144A",
      gene_level : 2,
      hgnc_id : "HGNC:20457",
      havana_gene : "OTTHUMG00000090353.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 8678845,
      stop : 8684461,
      direction : "+",
      ID : "ENSG00000115738.10",
      gene_id : "ENSG00000115738.10",
      gene_type : "protein_coding",
      gene_name : "ID2",
      gene_level : 2,
      hgnc_id : "HGNC:5361",
      havana_gene : "OTTHUMG00000112454.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 8721081,
      stop : 8837630,
      direction : "-",
      ID : "ENSG00000134313.16",
      gene_id : "ENSG00000134313.16",
      gene_type : "protein_coding",
      gene_name : "KIDINS220",
      gene_level : 2,
      hgnc_id : "HGNC:29508",
      havana_gene : "OTTHUMG00000151658.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 8852690,
      stop : 9003709,
      direction : "-",
      ID : "ENSG00000143797.12",
      gene_id : "ENSG00000143797.12",
      gene_type : "protein_coding",
      gene_name : "MBOAT2",
      gene_level : 2,
      hgnc_id : "HGNC:25193",
      havana_gene : "OTTHUMG00000090363.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9206765,
      stop : 9405683,
      direction : "+",
      ID : "ENSG00000151693.11",
      gene_id : "ENSG00000151693.11",
      gene_type : "protein_coding",
      gene_name : "ASAP2",
      gene_level : 2,
      hgnc_id : "HGNC:2721",
      havana_gene : "OTTHUMG00000117485.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9403475,
      stop : 9423528,
      direction : "-",
      ID : "ENSG00000119185.13",
      gene_id : "ENSG00000119185.13",
      gene_type : "protein_coding",
      gene_name : "ITGB1BP1",
      gene_level : 1,
      hgnc_id : "HGNC:23927",
      havana_gene : "OTTHUMG00000090414.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9423651,
      stop : 9473101,
      direction : "+",
      ID : "ENSG00000119203.14",
      gene_id : "ENSG00000119203.14",
      gene_type : "protein_coding",
      gene_name : "CPSF3",
      gene_level : 2,
      hgnc_id : "HGNC:2326",
      havana_gene : "OTTHUMG00000090415.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9473658,
      stop : 9496543,
      direction : "+",
      ID : "ENSG00000134330.19",
      gene_id : "ENSG00000134330.19",
      gene_type : "protein_coding",
      gene_name : "IAH1",
      gene_level : 1,
      hgnc_id : "HGNC:27696",
      havana_gene : "OTTHUMG00000159076.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9488486,
      stop : 9556732,
      direction : "-",
      ID : "ENSG00000151694.14",
      gene_id : "ENSG00000151694.14",
      gene_type : "protein_coding",
      gene_name : "ADAM17",
      gene_level : 1,
      hgnc_id : "HGNC:195",
      havana_gene : "OTTHUMG00000090425.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9583967,
      stop : 9630997,
      direction : "-",
      ID : "ENSG00000134308.14",
      gene_id : "ENSG00000134308.14",
      gene_type : "protein_coding",
      gene_name : "YWHAQ",
      gene_level : 1,
      hgnc_id : "HGNC:12854",
      havana_gene : "OTTHUMG00000013848.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9843443,
      stop : 9934416,
      direction : "+",
      ID : "ENSG00000115750.17",
      gene_id : "ENSG00000115750.17",
      gene_type : "protein_coding",
      gene_name : "TAF1B",
      gene_level : 2,
      hgnc_id : "HGNC:11533",
      havana_gene : "OTTHUMG00000151673.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 9951693,
      stop : 10002277,
      direction : "+",
      ID : "ENSG00000134317.18",
      gene_id : "ENSG00000134317.18",
      gene_type : "protein_coding",
      gene_name : "GRHL1",
      gene_level : 2,
      hgnc_id : "HGNC:17923",
      havana_gene : "OTTHUMG00000151704.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10042849,
      stop : 10054836,
      direction : "+",
      ID : "ENSG00000172059.11",
      gene_id : "ENSG00000172059.11",
      gene_type : "protein_coding",
      gene_name : "KLF11",
      gene_level : 1,
      hgnc_id : "HGNC:11811",
      havana_gene : "OTTHUMG00000119004.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10056780,
      stop : 10080944,
      direction : "-",
      ID : "ENSG00000205795.4",
      gene_id : "ENSG00000205795.4",
      gene_type : "protein_coding",
      gene_name : "CYS1",
      gene_level : 2,
      hgnc_id : "HGNC:18525",
      havana_gene : "OTTHUMG00000151703.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10120698,
      stop : 10211725,
      direction : "+",
      ID : "ENSG00000171848.16",
      gene_id : "ENSG00000171848.16",
      gene_type : "protein_coding",
      gene_name : "RRM2",
      gene_level : 2,
      hgnc_id : "HGNC:10452",
      havana_gene : "OTTHUMG00000185555.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10302889,
      stop : 10427617,
      direction : "+",
      ID : "ENSG00000115756.13",
      gene_id : "ENSG00000115756.13",
      gene_type : "protein_coding",
      gene_name : "HPCAL1",
      gene_level : 2,
      hgnc_id : "HGNC:5145",
      havana_gene : "OTTHUMG00000090451.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10439968,
      stop : 10448327,
      direction : "-",
      ID : "ENSG00000115758.13",
      gene_id : "ENSG00000115758.13",
      gene_type : "protein_coding",
      gene_name : "ODC1",
      gene_level : 2,
      hgnc_id : "HGNC:8109",
      havana_gene : "OTTHUMG00000090450.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10570754,
      stop : 10689987,
      direction : "-",
      ID : "ENSG00000115761.16",
      gene_id : "ENSG00000115761.16",
      gene_type : "protein_coding",
      gene_name : "NOL10",
      gene_level : 2,
      hgnc_id : "HGNC:25862",
      havana_gene : "OTTHUMG00000119023.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10721100,
      stop : 10785110,
      direction : "+",
      ID : "ENSG00000143882.12",
      gene_id : "ENSG00000143882.12",
      gene_type : "protein_coding",
      gene_name : "ATP6V1C2",
      gene_level : 2,
      hgnc_id : "HGNC:18264",
      havana_gene : "OTTHUMG00000090459.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10783391,
      stop : 10837977,
      direction : "-",
      ID : "ENSG00000143870.13",
      gene_id : "ENSG00000143870.13",
      gene_type : "protein_coding",
      gene_name : "PDIA6",
      gene_level : 1,
      hgnc_id : "HGNC:30168",
      havana_gene : "OTTHUMG00000090479.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 10911934,
      stop : 10914225,
      direction : "+",
      ID : "ENSG00000162975.5",
      gene_id : "ENSG00000162975.5",
      gene_type : "protein_coding",
      gene_name : "KCNF1",
      gene_level : 2,
      hgnc_id : "HGNC:6246",
      havana_gene : "OTTHUMG00000119054.2",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11133128,
      stop : 11151317,
      direction : "+",
      ID : "ENSG00000150873.12",
      gene_id : "ENSG00000150873.12",
      gene_type : "protein_coding",
      gene_name : "C2orf50",
      gene_level : 2,
      hgnc_id : "HGNC:26324",
      havana_gene : "OTTHUMG00000119057.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11155198,
      stop : 11178870,
      direction : "+",
      ID : "ENSG00000162976.13",
      gene_id : "ENSG00000162976.13",
      gene_type : "protein_coding",
      gene_name : "SLC66A3",
      gene_level : 1,
      hgnc_id : "HGNC:28503",
      havana_gene : "OTTHUMG00000119055.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11179759,
      stop : 11348330,
      direction : "-",
      ID : "ENSG00000134318.14",
      gene_id : "ENSG00000134318.14",
      gene_type : "protein_coding",
      gene_name : "ROCK2",
      gene_level : 1,
      hgnc_id : "HGNC:10252",
      havana_gene : "OTTHUMG00000149916.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11444375,
      stop : 11466177,
      direction : "-",
      ID : "ENSG00000169016.17",
      gene_id : "ENSG00000169016.17",
      gene_type : "protein_coding",
      gene_name : "E2F6",
      gene_level : 2,
      hgnc_id : "HGNC:3120",
      havana_gene : "OTTHUMG00000090565.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11482341,
      stop : 11642788,
      direction : "+",
      ID : "ENSG00000196208.14",
      gene_id : "ENSG00000196208.14",
      gene_type : "protein_coding",
      gene_name : "GREB1",
      gene_level : 2,
      hgnc_id : "HGNC:24885",
      havana_gene : "OTTHUMG00000141276.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11658178,
      stop : 11670195,
      direction : "-",
      ID : "ENSG00000169006.7",
      gene_id : "ENSG00000169006.7",
      gene_type : "protein_coding",
      gene_name : "NTSR2",
      gene_level : 2,
      hgnc_id : "HGNC:8040",
      havana_gene : "OTTHUMG00000119083.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 11677595,
      stop : 11827409,
      direction : "+",
      ID : "ENSG00000134324.12",
      gene_id : "ENSG00000134324.12",
      gene_type : "protein_coding",
      gene_name : "LPIN1",
      gene_level : 1,
      hgnc_id : "HGNC:13345",
      havana_gene : "OTTHUMG00000119082.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 12716889,
      stop : 12742734,
      direction : "+",
      ID : "ENSG00000071575.11",
      gene_id : "ENSG00000071575.11",
      gene_type : "protein_coding",
      gene_name : "TRIB2",
      gene_level : 1,
      hgnc_id : "HGNC:30809",
      havana_gene : "OTTHUMG00000090575.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 14632700,
      stop : 14650814,
      direction : "+",
      ID : "ENSG00000162981.14",
      gene_id : "ENSG00000162981.14",
      gene_type : "protein_coding",
      gene_name : "LRATD1",
      gene_level : 2,
      hgnc_id : "HGNC:20743",
      havana_gene : "OTTHUMG00000119093.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 15166914,
      stop : 15561334,
      direction : "-",
      ID : "ENSG00000151779.13",
      gene_id : "ENSG00000151779.13",
      gene_type : "protein_coding",
      gene_name : "NBAS",
      gene_level : 1,
      hgnc_id : "HGNC:15625",
      havana_gene : "OTTHUMG00000121153.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 15591178,
      stop : 15634346,
      direction : "+",
      ID : "ENSG00000079785.16",
      gene_id : "ENSG00000079785.16",
      gene_type : "protein_coding",
      gene_name : "DDX1",
      gene_level : 2,
      hgnc_id : "HGNC:2734",
      havana_gene : "OTTHUMG00000090593.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 15940550,
      stop : 15947007,
      direction : "+",
      ID : "ENSG00000134323.12",
      gene_id : "ENSG00000134323.12",
      gene_type : "protein_coding",
      gene_name : "MYCN",
      gene_level : 2,
      hgnc_id : "HGNC:7559",
      havana_gene : "OTTHUMG00000039579.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 16549459,
      stop : 16666331,
      direction : "-",
      ID : "ENSG00000197872.11",
      gene_id : "ENSG00000197872.11",
      gene_type : "protein_coding",
      gene_name : "CYRIA",
      gene_level : 2,
      hgnc_id : "HGNC:25373",
      havana_gene : "OTTHUMG00000090615.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 17510584,
      stop : 17518439,
      direction : "-",
      ID : "ENSG00000214842.5",
      gene_id : "ENSG00000214842.5",
      gene_type : "protein_coding",
      gene_name : "RAD51AP2",
      gene_level : 2,
      hgnc_id : "HGNC:34417",
      havana_gene : "OTTHUMG00000151761.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 17539126,
      stop : 17657018,
      direction : "+",
      ID : "ENSG00000163032.12",
      gene_id : "ENSG00000163032.12",
      gene_type : "protein_coding",
      gene_name : "VSNL1",
      gene_level : 2,
      hgnc_id : "HGNC:12722",
      havana_gene : "OTTHUMG00000090645.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 17663812,
      stop : 17800242,
      direction : "-",
      ID : "ENSG00000163029.16",
      gene_id : "ENSG00000163029.16",
      gene_type : "protein_coding",
      gene_name : "SMC6",
      gene_level : 2,
      hgnc_id : "HGNC:20466",
      havana_gene : "OTTHUMG00000090675.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 17753858,
      stop : 17788946,
      direction : "+",
      ID : "ENSG00000178295.15",
      gene_id : "ENSG00000178295.15",
      gene_type : "protein_coding",
      gene_name : "GEN1",
      gene_level : 2,
      hgnc_id : "HGNC:26881",
      havana_gene : "OTTHUMG00000121173.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 17816460,
      stop : 17817798,
      direction : "+",
      ID : "ENSG00000151379.4",
      gene_id : "ENSG00000151379.4",
      gene_type : "protein_coding",
      gene_name : "MSGN1",
      gene_level : 2,
      hgnc_id : "HGNC:14907",
      havana_gene : "OTTHUMG00000159089.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 17877847,
      stop : 18361616,
      direction : "+",
      ID : "ENSG00000170745.12",
      gene_id : "ENSG00000170745.12",
      gene_type : "protein_coding",
      gene_name : "KCNS3",
      gene_level : 2,
      hgnc_id : "HGNC:6302",
      havana_gene : "OTTHUMG00000044150.7",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 18554723,
      stop : 18560679,
      direction : "-",
      ID : "ENSG00000240857.2",
      gene_id : "ENSG00000240857.2",
      gene_type : "protein_coding",
      gene_name : "RDH14",
      gene_level : 2,
      hgnc_id : "HGNC:19979",
      havana_gene : "OTTHUMG00000090705.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 18555545,
      stop : 18589564,
      direction : "-",
      ID : "ENSG00000250741.6",
      gene_id : "ENSG00000250741.6",
      gene_type : "protein_coding",
      gene_name : "NT5C1B-RDH14",
      gene_level : 1,
      hgnc_id : "HGNC:38831",
      havana_gene : "OTTHUMG00000161546.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 18562872,
      stop : 18589572,
      direction : "-",
      ID : "ENSG00000185013.16",
      gene_id : "ENSG00000185013.16",
      gene_type : "protein_coding",
      gene_name : "NT5C1B",
      gene_level : 2,
      hgnc_id : "HGNC:17818",
      havana_gene : "OTTHUMG00000151765.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 19351485,
      stop : 19358623,
      direction : "-",
      ID : "ENSG00000143867.7",
      gene_id : "ENSG00000143867.7",
      gene_type : "protein_coding",
      gene_name : "OSR1",
      gene_level : 2,
      hgnc_id : "HGNC:8111",
      havana_gene : "OTTHUMG00000088793.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 19896631,
      stop : 19901983,
      direction : "-",
      ID : "ENSG00000183891.6",
      gene_id : "ENSG00000183891.6",
      gene_type : "protein_coding",
      gene_name : "TTC32",
      gene_level : 1,
      hgnc_id : "HGNC:32954",
      havana_gene : "OTTHUMG00000151776.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 19910263,
      stop : 19990105,
      direction : "-",
      ID : "ENSG00000118965.16",
      gene_id : "ENSG00000118965.16",
      gene_type : "protein_coding",
      gene_name : "WDR35",
      gene_level : 2,
      hgnc_id : "HGNC:29250",
      havana_gene : "OTTHUMG00000090737.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 19992052,
      stop : 20012668,
      direction : "-",
      ID : "ENSG00000132031.13",
      gene_id : "ENSG00000132031.13",
      gene_type : "protein_coding",
      gene_name : "MATN3",
      gene_level : 2,
      hgnc_id : "HGNC:6909",
      havana_gene : "OTTHUMG00000151788.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20032650,
      stop : 20051628,
      direction : "-",
      ID : "ENSG00000068697.7",
      gene_id : "ENSG00000068697.7",
      gene_type : "protein_coding",
      gene_name : "LAPTM4A",
      gene_level : 2,
      hgnc_id : "HGNC:6924",
      havana_gene : "OTTHUMG00000090750.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20200797,
      stop : 20225433,
      direction : "-",
      ID : "ENSG00000115884.11",
      gene_id : "ENSG00000115884.11",
      gene_type : "protein_coding",
      gene_name : "SDC1",
      gene_level : 2,
      hgnc_id : "HGNC:10658",
      havana_gene : "OTTHUMG00000090751.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20248691,
      stop : 20352234,
      direction : "-",
      ID : "ENSG00000055917.16",
      gene_id : "ENSG00000055917.16",
      gene_type : "protein_coding",
      gene_name : "PUM2",
      gene_level : 2,
      hgnc_id : "HGNC:14958",
      havana_gene : "OTTHUMG00000122098.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20447074,
      stop : 20449440,
      direction : "+",
      ID : "ENSG00000143878.10",
      gene_id : "ENSG00000143878.10",
      gene_type : "protein_coding",
      gene_name : "RHOB",
      gene_level : 2,
      hgnc_id : "HGNC:668",
      havana_gene : "OTTHUMG00000090755.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20560448,
      stop : 20651130,
      direction : "-",
      ID : "ENSG00000118960.13",
      gene_id : "ENSG00000118960.13",
      gene_type : "protein_coding",
      gene_name : "HS1BP3",
      gene_level : 1,
      hgnc_id : "HGNC:24979",
      havana_gene : "OTTHUMG00000122099.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20667144,
      stop : 20679243,
      direction : "+",
      ID : "ENSG00000143869.7",
      gene_id : "ENSG00000143869.7",
      gene_type : "protein_coding",
      gene_name : "GDF7",
      gene_level : 2,
      hgnc_id : "HGNC:4222",
      havana_gene : "OTTHUMG00000090781.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 20684014,
      stop : 20823130,
      direction : "-",
      ID : "ENSG00000118961.15",
      gene_id : "ENSG00000118961.15",
      gene_type : "protein_coding",
      gene_name : "LDAH",
      gene_level : 1,
      hgnc_id : "HGNC:26145",
      havana_gene : "OTTHUMG00000122097.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 21001429,
      stop : 21044073,
      direction : "-",
      ID : "ENSG00000084674.15",
      gene_id : "ENSG00000084674.15",
      gene_type : "protein_coding",
      gene_name : "APOB",
      gene_level : 2,
      hgnc_id : "HGNC:603",
      havana_gene : "OTTHUMG00000090785.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 21123968,
      stop : 21144368,
      direction : "+",
      ID : "ENSG00000218819.6",
      gene_id : "ENSG00000218819.6",
      gene_type : "protein_coding",
      gene_name : "TDRD15",
      gene_level : 1,
      hgnc_id : "HGNC:45037",
      havana_gene : "OTTHUMG00000151795.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 23385179,
      stop : 23708611,
      direction : "+",
      ID : "ENSG00000119771.15",
      gene_id : "ENSG00000119771.15",
      gene_type : "protein_coding",
      gene_name : "KLHL29",
      gene_level : 2,
      hgnc_id : "HGNC:29404",
      havana_gene : "OTTHUMG00000151899.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 23748664,
      stop : 23927123,
      direction : "-",
      ID : "ENSG00000119778.15",
      gene_id : "ENSG00000119778.15",
      gene_type : "protein_coding",
      gene_name : "ATAD2B",
      gene_level : 1,
      hgnc_id : "HGNC:29230",
      havana_gene : "OTTHUMG00000151902.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 23927285,
      stop : 24004909,
      direction : "+",
      ID : "ENSG00000173960.14",
      gene_id : "ENSG00000173960.14",
      gene_type : "protein_coding",
      gene_name : "UBXN2A",
      gene_level : 2,
      hgnc_id : "HGNC:27265",
      havana_gene : "OTTHUMG00000125497.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24010081,
      stop : 24063321,
      direction : "+",
      ID : "ENSG00000205639.12",
      gene_id : "ENSG00000205639.12",
      gene_type : "protein_coding",
      gene_name : "MFSD2B",
      gene_level : 2,
      hgnc_id : "HGNC:37207",
      havana_gene : "OTTHUMG00000090819.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24029347,
      stop : 24049575,
      direction : "-",
      ID : "ENSG00000163026.12",
      gene_id : "ENSG00000163026.12",
      gene_type : "protein_coding",
      gene_name : "WDCP",
      gene_level : 1,
      hgnc_id : "HGNC:26157",
      havana_gene : "OTTHUMG00000125498.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24049701,
      stop : 24063681,
      direction : "+",
      ID : "ENSG00000119782.14",
      gene_id : "ENSG00000119782.14",
      gene_type : "protein_coding",
      gene_name : "FKBP1B",
      gene_level : 2,
      hgnc_id : "HGNC:3712",
      havana_gene : "OTTHUMG00000151889.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24067586,
      stop : 24076373,
      direction : "-",
      ID : "ENSG00000115128.7",
      gene_id : "ENSG00000115128.7",
      gene_type : "protein_coding",
      gene_name : "SF3B6",
      gene_level : 1,
      hgnc_id : "HGNC:30096",
      havana_gene : "OTTHUMG00000125499.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24076526,
      stop : 24169640,
      direction : "+",
      ID : "ENSG00000219626.9",
      gene_id : "ENSG00000219626.9",
      gene_type : "protein_coding",
      gene_name : "FAM228B",
      gene_level : 1,
      hgnc_id : "HGNC:24736",
      havana_gene : "OTTHUMG00000151901.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24077433,
      stop : 24085861,
      direction : "-",
      ID : "ENSG00000115129.14",
      gene_id : "ENSG00000115129.14",
      gene_type : "protein_coding",
      gene_name : "TP53I3",
      gene_level : 2,
      hgnc_id : "HGNC:19373",
      havana_gene : "OTTHUMG00000090817.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24114809,
      stop : 24123464,
      direction : "-",
      ID : "ENSG00000176732.7",
      gene_id : "ENSG00000176732.7",
      gene_type : "protein_coding",
      gene_name : "PFN4",
      gene_level : 2,
      hgnc_id : "HGNC:31103",
      havana_gene : "OTTHUMG00000090816.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24124366,
      stop : 24190436,
      direction : "+",
      ID : "ENSG00000276087.2",
      gene_id : "ENSG00000276087.2",
      gene_type : "protein_coding",
      gene_name : "AC008073.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000178849.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24175053,
      stop : 24200849,
      direction : "+",
      ID : "ENSG00000186453.13",
      gene_id : "ENSG00000186453.13",
      gene_type : "protein_coding",
      gene_name : "FAM228A",
      gene_level : 1,
      hgnc_id : "HGNC:34418",
      havana_gene : "OTTHUMG00000151903.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24202864,
      stop : 24360536,
      direction : "-",
      ID : "ENSG00000198399.15",
      gene_id : "ENSG00000198399.15",
      gene_type : "protein_coding",
      gene_name : "ITSN2",
      gene_level : 1,
      hgnc_id : "HGNC:6184",
      havana_gene : "OTTHUMG00000090818.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24491914,
      stop : 24770702,
      direction : "+",
      ID : "ENSG00000084676.15",
      gene_id : "ENSG00000084676.15",
      gene_type : "protein_coding",
      gene_name : "NCOA1",
      gene_level : 2,
      hgnc_id : "HGNC:7668",
      havana_gene : "OTTHUMG00000125523.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24789728,
      stop : 24793391,
      direction : "-",
      ID : "ENSG00000184924.6",
      gene_id : "ENSG00000184924.6",
      gene_type : "protein_coding",
      gene_name : "PTRHD1",
      gene_level : 2,
      hgnc_id : "HGNC:33782",
      havana_gene : "OTTHUMG00000151978.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24793136,
      stop : 24822376,
      direction : "+",
      ID : "ENSG00000138092.11",
      gene_id : "ENSG00000138092.11",
      gene_type : "protein_coding",
      gene_name : "CENPO",
      gene_level : 1,
      hgnc_id : "HGNC:28152",
      havana_gene : "OTTHUMG00000125525.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24819169,
      stop : 24920237,
      direction : "-",
      ID : "ENSG00000138031.15",
      gene_id : "ENSG00000138031.15",
      gene_type : "protein_coding",
      gene_name : "ADCY3",
      gene_level : 1,
      hgnc_id : "HGNC:234",
      havana_gene : "OTTHUMG00000094765.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 24943636,
      stop : 24972094,
      direction : "-",
      ID : "ENSG00000115137.12",
      gene_id : "ENSG00000115137.12",
      gene_type : "protein_coding",
      gene_name : "DNAJC27",
      gene_level : 2,
      hgnc_id : "HGNC:30290",
      havana_gene : "OTTHUMG00000125524.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 25042076,
      stop : 25159135,
      direction : "+",
      ID : "ENSG00000084710.14",
      gene_id : "ENSG00000084710.14",
      gene_type : "protein_coding",
      gene_name : "EFR3B",
      gene_level : 2,
      hgnc_id : "HGNC:29155",
      havana_gene : "OTTHUMG00000151988.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 25160853,
      stop : 25168903,
      direction : "-",
      ID : "ENSG00000115138.11",
      gene_id : "ENSG00000115138.11",
      gene_type : "protein_coding",
      gene_name : "POMC",
      gene_level : 2,
      hgnc_id : "HGNC:9201",
      havana_gene : "OTTHUMG00000094764.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 25227855,
      stop : 25342590,
      direction : "-",
      ID : "ENSG00000119772.17",
      gene_id : "ENSG00000119772.17",
      gene_type : "protein_coding",
      gene_name : "DNMT3A",
      gene_level : 2,
      hgnc_id : "HGNC:2978",
      havana_gene : "OTTHUMG00000094777.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 25377198,
      stop : 25673647,
      direction : "-",
      ID : "ENSG00000138101.19",
      gene_id : "ENSG00000138101.19",
      gene_type : "protein_coding",
      gene_name : "DTNB",
      gene_level : 1,
      hgnc_id : "HGNC:3058",
      havana_gene : "OTTHUMG00000152129.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 25733753,
      stop : 25878487,
      direction : "-",
      ID : "ENSG00000143970.17",
      gene_id : "ENSG00000143970.17",
      gene_type : "protein_coding",
      gene_name : "ASXL2",
      gene_level : 2,
      hgnc_id : "HGNC:23805",
      havana_gene : "OTTHUMG00000152176.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 25926598,
      stop : 25982749,
      direction : "-",
      ID : "ENSG00000084731.15",
      gene_id : "ENSG00000084731.15",
      gene_type : "protein_coding",
      gene_name : "KIF3C",
      gene_level : 1,
      hgnc_id : "HGNC:6321",
      havana_gene : "OTTHUMG00000094797.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26034084,
      stop : 26137454,
      direction : "+",
      ID : "ENSG00000084733.11",
      gene_id : "ENSG00000084733.11",
      gene_type : "protein_coding",
      gene_name : "RAB10",
      gene_level : 2,
      hgnc_id : "HGNC:9759",
      havana_gene : "OTTHUMG00000094796.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26173088,
      stop : 26189663,
      direction : "+",
      ID : "ENSG00000157833.13",
      gene_id : "ENSG00000157833.13",
      gene_type : "protein_coding",
      gene_name : "GAREM2",
      gene_level : 1,
      hgnc_id : "HGNC:27172",
      havana_gene : "OTTHUMG00000151935.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26190635,
      stop : 26244672,
      direction : "-",
      ID : "ENSG00000084754.12",
      gene_id : "ENSG00000084754.12",
      gene_type : "protein_coding",
      gene_name : "HADHA",
      gene_level : 2,
      hgnc_id : "HGNC:4801",
      havana_gene : "OTTHUMG00000096979.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26243170,
      stop : 26290465,
      direction : "+",
      ID : "ENSG00000138029.14",
      gene_id : "ENSG00000138029.14",
      gene_type : "protein_coding",
      gene_name : "HADHB",
      gene_level : 2,
      hgnc_id : "HGNC:4803",
      havana_gene : "OTTHUMG00000096978.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26308173,
      stop : 26346817,
      direction : "-",
      ID : "ENSG00000173567.15",
      gene_id : "ENSG00000173567.15",
      gene_type : "protein_coding",
      gene_name : "ADGRF3",
      gene_level : 2,
      hgnc_id : "HGNC:18989",
      havana_gene : "OTTHUMG00000150225.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26308547,
      stop : 26395891,
      direction : "+",
      ID : "ENSG00000138018.18",
      gene_id : "ENSG00000138018.18",
      gene_type : "protein_coding",
      gene_name : "SELENOI",
      gene_level : 2,
      hgnc_id : "HGNC:29361",
      havana_gene : "OTTHUMG00000151931.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26401920,
      stop : 26456711,
      direction : "+",
      ID : "ENSG00000157856.12",
      gene_id : "ENSG00000157856.12",
      gene_type : "protein_coding",
      gene_name : "DRC1",
      gene_level : 2,
      hgnc_id : "HGNC:24245",
      havana_gene : "OTTHUMG00000125531.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26457203,
      stop : 26558756,
      direction : "-",
      ID : "ENSG00000115155.19",
      gene_id : "ENSG00000115155.19",
      gene_type : "protein_coding",
      gene_name : "OTOF",
      gene_level : 2,
      hgnc_id : "HGNC:8515",
      havana_gene : "OTTHUMG00000096977.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26562585,
      stop : 26579532,
      direction : "+",
      ID : "ENSG00000173557.15",
      gene_id : "ENSG00000173557.15",
      gene_type : "protein_coding",
      gene_name : "FAM166C",
      gene_level : 1,
      hgnc_id : "HGNC:27938",
      havana_gene : "OTTHUMG00000151994.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26581205,
      stop : 26641366,
      direction : "-",
      ID : "ENSG00000157884.11",
      gene_id : "ENSG00000157884.11",
      gene_type : "protein_coding",
      gene_name : "CIB4",
      gene_level : 2,
      hgnc_id : "HGNC:33703",
      havana_gene : "OTTHUMG00000151993.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26692690,
      stop : 26733420,
      direction : "+",
      ID : "ENSG00000171303.7",
      gene_id : "ENSG00000171303.7",
      gene_type : "protein_coding",
      gene_name : "KCNK3",
      gene_level : 2,
      hgnc_id : "HGNC:6278",
      havana_gene : "OTTHUMG00000125530.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26764284,
      stop : 26781231,
      direction : "+",
      ID : "ENSG00000213699.9",
      gene_id : "ENSG00000213699.9",
      gene_type : "protein_coding",
      gene_name : "SLC35F6",
      gene_level : 2,
      hgnc_id : "HGNC:26055",
      havana_gene : "OTTHUMG00000128407.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26764289,
      stop : 26801067,
      direction : "+",
      ID : "ENSG00000115163.15",
      gene_id : "ENSG00000115163.15",
      gene_type : "protein_coding",
      gene_name : "CENPA",
      gene_level : 2,
      hgnc_id : "HGNC:1851",
      havana_gene : "OTTHUMG00000097073.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26847747,
      stop : 26950351,
      direction : "+",
      ID : "ENSG00000157851.17",
      gene_id : "ENSG00000157851.17",
      gene_type : "protein_coding",
      gene_name : "DPYSL5",
      gene_level : 2,
      hgnc_id : "HGNC:20637",
      havana_gene : "OTTHUMG00000097071.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 26970637,
      stop : 27027219,
      direction : "+",
      ID : "ENSG00000084764.12",
      gene_id : "ENSG00000084764.12",
      gene_type : "protein_coding",
      gene_name : "MAPRE3",
      gene_level : 1,
      hgnc_id : "HGNC:6892",
      havana_gene : "OTTHUMG00000097067.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27032910,
      stop : 27041694,
      direction : "+",
      ID : "ENSG00000119777.20",
      gene_id : "ENSG00000119777.20",
      gene_type : "protein_coding",
      gene_name : "TMEM214",
      gene_level : 2,
      hgnc_id : "HGNC:25983",
      havana_gene : "OTTHUMG00000151999.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27042364,
      stop : 27070622,
      direction : "+",
      ID : "ENSG00000084693.16",
      gene_id : "ENSG00000084693.16",
      gene_type : "protein_coding",
      gene_name : "AGBL5",
      gene_level : 1,
      hgnc_id : "HGNC:26147",
      havana_gene : "OTTHUMG00000128406.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27070472,
      stop : 27071654,
      direction : "-",
      ID : "ENSG00000228474.6",
      gene_id : "ENSG00000228474.6",
      gene_type : "protein_coding",
      gene_name : "OST4",
      gene_level : 1,
      hgnc_id : "HGNC:32483",
      havana_gene : "OTTHUMG00000151990.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27078615,
      stop : 27086403,
      direction : "+",
      ID : "ENSG00000138080.14",
      gene_id : "ENSG00000138080.14",
      gene_type : "protein_coding",
      gene_name : "EMILIN1",
      gene_level : 1,
      hgnc_id : "HGNC:19880",
      havana_gene : "OTTHUMG00000097069.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27086747,
      stop : 27100762,
      direction : "+",
      ID : "ENSG00000138030.13",
      gene_id : "ENSG00000138030.13",
      gene_type : "protein_coding",
      gene_name : "KHK",
      gene_level : 2,
      hgnc_id : "HGNC:6315",
      havana_gene : "OTTHUMG00000097077.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27098889,
      stop : 27119128,
      direction : "-",
      ID : "ENSG00000138028.16",
      gene_id : "ENSG00000138028.16",
      gene_type : "protein_coding",
      gene_name : "CGREF1",
      gene_level : 2,
      hgnc_id : "HGNC:16962",
      havana_gene : "OTTHUMG00000152009.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27123789,
      stop : 27130812,
      direction : "+",
      ID : "ENSG00000143994.14",
      gene_id : "ENSG00000143994.14",
      gene_type : "protein_coding",
      gene_name : "ABHD1",
      gene_level : 2,
      hgnc_id : "HGNC:17553",
      havana_gene : "OTTHUMG00000097072.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27130756,
      stop : 27134666,
      direction : "-",
      ID : "ENSG00000138073.14",
      gene_id : "ENSG00000138073.14",
      gene_type : "protein_coding",
      gene_name : "PREB",
      gene_level : 1,
      hgnc_id : "HGNC:9356",
      havana_gene : "OTTHUMG00000097076.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27136848,
      stop : 27139410,
      direction : "-",
      ID : "ENSG00000186143.11",
      gene_id : "ENSG00000186143.11",
      gene_type : "protein_coding",
      gene_name : "PRR30",
      gene_level : 1,
      hgnc_id : "HGNC:28677",
      havana_gene : "OTTHUMG00000128408.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27149004,
      stop : 27156974,
      direction : "+",
      ID : "ENSG00000163792.6",
      gene_id : "ENSG00000163792.6",
      gene_type : "protein_coding",
      gene_name : "TCF23",
      gene_level : 2,
      hgnc_id : "HGNC:18602",
      havana_gene : "OTTHUMG00000152031.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27199587,
      stop : 27212958,
      direction : "-",
      ID : "ENSG00000138074.15",
      gene_id : "ENSG00000138074.15",
      gene_type : "protein_coding",
      gene_name : "SLC5A6",
      gene_level : 2,
      hgnc_id : "HGNC:11041",
      havana_gene : "OTTHUMG00000097075.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27212027,
      stop : 27217178,
      direction : "+",
      ID : "ENSG00000138085.17",
      gene_id : "ENSG00000138085.17",
      gene_type : "protein_coding",
      gene_name : "ATRAID",
      gene_level : 2,
      hgnc_id : "HGNC:24090",
      havana_gene : "OTTHUMG00000128405.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27217369,
      stop : 27243943,
      direction : "+",
      ID : "ENSG00000084774.14",
      gene_id : "ENSG00000084774.14",
      gene_type : "protein_coding",
      gene_name : "CAD",
      gene_level : 1,
      hgnc_id : "HGNC:1424",
      havana_gene : "OTTHUMG00000097070.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27253684,
      stop : 27275817,
      direction : "-",
      ID : "ENSG00000115194.11",
      gene_id : "ENSG00000115194.11",
      gene_type : "protein_coding",
      gene_name : "SLC30A3",
      gene_level : 1,
      hgnc_id : "HGNC:11014",
      havana_gene : "OTTHUMG00000128409.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27275433,
      stop : 27281499,
      direction : "+",
      ID : "ENSG00000163793.13",
      gene_id : "ENSG00000163793.13",
      gene_type : "protein_coding",
      gene_name : "DNAJC5G",
      gene_level : 2,
      hgnc_id : "HGNC:24844",
      havana_gene : "OTTHUMG00000097079.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27282429,
      stop : 27307439,
      direction : "+",
      ID : "ENSG00000138100.14",
      gene_id : "ENSG00000138100.14",
      gene_type : "protein_coding",
      gene_name : "TRIM54",
      gene_level : 2,
      hgnc_id : "HGNC:16008",
      havana_gene : "OTTHUMG00000097078.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27307400,
      stop : 27308445,
      direction : "-",
      ID : "ENSG00000163794.6",
      gene_id : "ENSG00000163794.6",
      gene_type : "protein_coding",
      gene_name : "UCN",
      gene_level : 2,
      hgnc_id : "HGNC:12516",
      havana_gene : "OTTHUMG00000097068.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27309492,
      stop : 27325680,
      direction : "-",
      ID : "ENSG00000115204.15",
      gene_id : "ENSG00000115204.15",
      gene_type : "protein_coding",
      gene_name : "MPV17",
      gene_level : 1,
      hgnc_id : "HGNC:7224",
      havana_gene : "OTTHUMG00000097074.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27325849,
      stop : 27357034,
      direction : "-",
      ID : "ENSG00000115207.13",
      gene_id : "ENSG00000115207.13",
      gene_type : "protein_coding",
      gene_name : "GTF3C2",
      gene_level : 1,
      hgnc_id : "HGNC:4665",
      havana_gene : "OTTHUMG00000097785.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27364352,
      stop : 27370457,
      direction : "-",
      ID : "ENSG00000115211.16",
      gene_id : "ENSG00000115211.16",
      gene_type : "protein_coding",
      gene_name : "EIF2B4",
      gene_level : 2,
      hgnc_id : "HGNC:3260",
      havana_gene : "OTTHUMG00000151927.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27370496,
      stop : 27377535,
      direction : "+",
      ID : "ENSG00000115234.11",
      gene_id : "ENSG00000115234.11",
      gene_type : "protein_coding",
      gene_name : "SNX17",
      gene_level : 2,
      hgnc_id : "HGNC:14979",
      havana_gene : "OTTHUMG00000097781.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27377235,
      stop : 27380790,
      direction : "-",
      ID : "ENSG00000163795.14",
      gene_id : "ENSG00000163795.14",
      gene_type : "protein_coding",
      gene_name : "ZNF513",
      gene_level : 2,
      hgnc_id : "HGNC:26498",
      havana_gene : "OTTHUMG00000097783.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27381195,
      stop : 27409591,
      direction : "-",
      ID : "ENSG00000115241.11",
      gene_id : "ENSG00000115241.11",
      gene_type : "protein_coding",
      gene_name : "PPM1G",
      gene_level : 2,
      hgnc_id : "HGNC:9278",
      havana_gene : "OTTHUMG00000097788.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27427790,
      stop : 27442259,
      direction : "+",
      ID : "ENSG00000115216.14",
      gene_id : "ENSG00000115216.14",
      gene_type : "protein_coding",
      gene_name : "NRBP1",
      gene_level : 2,
      hgnc_id : "HGNC:7993",
      havana_gene : "OTTHUMG00000097789.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27442366,
      stop : 27446481,
      direction : "+",
      ID : "ENSG00000157992.12",
      gene_id : "ENSG00000157992.12",
      gene_type : "protein_coding",
      gene_name : "KRTCAP3",
      gene_level : 2,
      hgnc_id : "HGNC:28943",
      havana_gene : "OTTHUMG00000097782.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27444377,
      stop : 27489805,
      direction : "-",
      ID : "ENSG00000138002.16",
      gene_id : "ENSG00000138002.16",
      gene_type : "protein_coding",
      gene_name : "IFT172",
      gene_level : 2,
      hgnc_id : "HGNC:30391",
      havana_gene : "OTTHUMG00000128425.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27491883,
      stop : 27495200,
      direction : "-",
      ID : "ENSG00000115226.10",
      gene_id : "ENSG00000115226.10",
      gene_type : "protein_coding",
      gene_name : "FNDC4",
      gene_level : 2,
      hgnc_id : "HGNC:20239",
      havana_gene : "OTTHUMG00000097787.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27496839,
      stop : 27523684,
      direction : "+",
      ID : "ENSG00000084734.9",
      gene_id : "ENSG00000084734.9",
      gene_type : "protein_coding",
      gene_name : "GCKR",
      gene_level : 1,
      hgnc_id : "HGNC:4196",
      havana_gene : "OTTHUMG00000128426.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27537386,
      stop : 27582721,
      direction : "+",
      ID : "ENSG00000221843.4",
      gene_id : "ENSG00000221843.4",
      gene_type : "protein_coding",
      gene_name : "C2orf16",
      gene_level : 2,
      hgnc_id : "HGNC:25275",
      havana_gene : "OTTHUMG00000159099.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27582969,
      stop : 27623217,
      direction : "+",
      ID : "ENSG00000243943.10",
      gene_id : "ENSG00000243943.10",
      gene_type : "protein_coding",
      gene_name : "ZNF512",
      gene_level : 2,
      hgnc_id : "HGNC:29380",
      havana_gene : "OTTHUMG00000097786.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27625638,
      stop : 27629012,
      direction : "-",
      ID : "ENSG00000176714.10",
      gene_id : "ENSG00000176714.10",
      gene_type : "protein_coding",
      gene_name : "CCDC121",
      gene_level : 2,
      hgnc_id : "HGNC:25833",
      havana_gene : "OTTHUMG00000128427.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27628247,
      stop : 27651511,
      direction : "+",
      ID : "ENSG00000198522.14",
      gene_id : "ENSG00000198522.14",
      gene_type : "protein_coding",
      gene_name : "GPN1",
      gene_level : 2,
      hgnc_id : "HGNC:17030",
      havana_gene : "OTTHUMG00000097784.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27650809,
      stop : 27663840,
      direction : "-",
      ID : "ENSG00000119760.16",
      gene_id : "ENSG00000119760.16",
      gene_type : "protein_coding",
      gene_name : "SUPT7L",
      gene_level : 2,
      hgnc_id : "HGNC:30632",
      havana_gene : "OTTHUMG00000151947.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27663471,
      stop : 27694976,
      direction : "+",
      ID : "ENSG00000163798.13",
      gene_id : "ENSG00000163798.13",
      gene_type : "protein_coding",
      gene_name : "SLC4A1AP",
      gene_level : 2,
      hgnc_id : "HGNC:13813",
      havana_gene : "OTTHUMG00000151944.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27771717,
      stop : 27988087,
      direction : "+",
      ID : "ENSG00000243147.8",
      gene_id : "ENSG00000243147.8",
      gene_type : "protein_coding",
      gene_name : "MRPL33",
      gene_level : 2,
      hgnc_id : "HGNC:14487",
      havana_gene : "OTTHUMG00000097795.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27781379,
      stop : 27890681,
      direction : "-",
      ID : "ENSG00000171174.15",
      gene_id : "ENSG00000171174.15",
      gene_type : "protein_coding",
      gene_name : "RBKS",
      gene_level : 2,
      hgnc_id : "HGNC:30325",
      havana_gene : "OTTHUMG00000097833.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 27889941,
      stop : 28338901,
      direction : "+",
      ID : "ENSG00000158019.21",
      gene_id : "ENSG00000158019.21",
      gene_type : "protein_coding",
      gene_name : "BABAM2",
      gene_level : 2,
      hgnc_id : "HGNC:1106",
      havana_gene : "OTTHUMG00000097831.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28392448,
      stop : 28417317,
      direction : "+",
      ID : "ENSG00000075426.12",
      gene_id : "ENSG00000075426.12",
      gene_type : "protein_coding",
      gene_name : "FOSL2",
      gene_level : 1,
      hgnc_id : "HGNC:3798",
      havana_gene : "OTTHUMG00000097832.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28457145,
      stop : 28644142,
      direction : "+",
      ID : "ENSG00000163803.13",
      gene_id : "ENSG00000163803.13",
      gene_type : "protein_coding",
      gene_name : "PLB1",
      gene_level : 1,
      hgnc_id : "HGNC:30041",
      havana_gene : "OTTHUMG00000152014.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28751640,
      stop : 28802940,
      direction : "+",
      ID : "ENSG00000213639.10",
      gene_id : "ENSG00000213639.10",
      gene_type : "protein_coding",
      gene_name : "PPP1CB",
      gene_level : 2,
      hgnc_id : "HGNC:9282",
      havana_gene : "OTTHUMG00000152011.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28782517,
      stop : 28850611,
      direction : "+",
      ID : "ENSG00000163806.16",
      gene_id : "ENSG00000163806.16",
      gene_type : "protein_coding",
      gene_name : "SPDYA",
      gene_level : 1,
      hgnc_id : "HGNC:30613",
      havana_gene : "OTTHUMG00000074041.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28849821,
      stop : 28870309,
      direction : "-",
      ID : "ENSG00000171103.11",
      gene_id : "ENSG00000171103.11",
      gene_type : "protein_coding",
      gene_name : "TRMT61B",
      gene_level : 2,
      hgnc_id : "HGNC:26070",
      havana_gene : "OTTHUMG00000128433.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28894667,
      stop : 28948219,
      direction : "+",
      ID : "ENSG00000163811.12",
      gene_id : "ENSG00000163811.12",
      gene_type : "protein_coding",
      gene_name : "WDR43",
      gene_level : 1,
      hgnc_id : "HGNC:28945",
      havana_gene : "OTTHUMG00000152015.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 28956611,
      stop : 29052230,
      direction : "+",
      ID : "ENSG00000189350.13",
      gene_id : "ENSG00000189350.13",
      gene_type : "protein_coding",
      gene_name : "TOGARAM2",
      gene_level : 2,
      hgnc_id : "HGNC:33715",
      havana_gene : "OTTHUMG00000128432.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 29060976,
      stop : 29074523,
      direction : "-",
      ID : "ENSG00000179270.7",
      gene_id : "ENSG00000179270.7",
      gene_type : "protein_coding",
      gene_name : "PCARE",
      gene_level : 1,
      hgnc_id : "HGNC:34383",
      havana_gene : "OTTHUMG00000152024.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 29097705,
      stop : 29189643,
      direction : "+",
      ID : "ENSG00000115295.20",
      gene_id : "ENSG00000115295.20",
      gene_type : "protein_coding",
      gene_name : "CLIP4",
      gene_level : 1,
      hgnc_id : "HGNC:26108",
      havana_gene : "OTTHUMG00000097837.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 29192774,
      stop : 29921586,
      direction : "-",
      ID : "ENSG00000171094.18",
      gene_id : "ENSG00000171094.18",
      gene_type : "protein_coding",
      gene_name : "ALK",
      gene_level : 1,
      hgnc_id : "HGNC:427",
      havana_gene : "OTTHUMG00000152034.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 30146941,
      stop : 30160533,
      direction : "+",
      ID : "ENSG00000119801.13",
      gene_id : "ENSG00000119801.13",
      gene_type : "protein_coding",
      gene_name : "YPEL5",
      gene_level : 2,
      hgnc_id : "HGNC:18329",
      havana_gene : "OTTHUMG00000097839.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 30231534,
      stop : 30323730,
      direction : "+",
      ID : "ENSG00000213626.13",
      gene_id : "ENSG00000213626.13",
      gene_type : "protein_coding",
      gene_name : "LBH",
      gene_level : 1,
      hgnc_id : "HGNC:29532",
      havana_gene : "OTTHUMG00000152051.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 30447226,
      stop : 30644225,
      direction : "+",
      ID : "ENSG00000172954.14",
      gene_id : "ENSG00000172954.14",
      gene_type : "protein_coding",
      gene_name : "LCLAT1",
      gene_level : 2,
      hgnc_id : "HGNC:26756",
      havana_gene : "OTTHUMG00000099349.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 30722771,
      stop : 30820542,
      direction : "-",
      ID : "ENSG00000162949.16",
      gene_id : "ENSG00000162949.16",
      gene_type : "protein_coding",
      gene_name : "CAPN13",
      gene_level : 2,
      hgnc_id : "HGNC:16663",
      havana_gene : "OTTHUMG00000152053.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 30910467,
      stop : 31155202,
      direction : "-",
      ID : "ENSG00000158089.15",
      gene_id : "ENSG00000158089.15",
      gene_type : "protein_coding",
      gene_name : "GALNT14",
      gene_level : 2,
      hgnc_id : "HGNC:22946",
      havana_gene : "OTTHUMG00000074077.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 31173056,
      stop : 31233858,
      direction : "-",
      ID : "ENSG00000214711.10",
      gene_id : "ENSG00000214711.10",
      gene_type : "protein_coding",
      gene_name : "CAPN14",
      gene_level : 2,
      hgnc_id : "HGNC:16664",
      havana_gene : "OTTHUMG00000152039.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 31234152,
      stop : 31269451,
      direction : "+",
      ID : "ENSG00000013016.16",
      gene_id : "ENSG00000013016.16",
      gene_type : "protein_coding",
      gene_name : "EHD3",
      gene_level : 2,
      hgnc_id : "HGNC:3244",
      havana_gene : "OTTHUMG00000099365.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 31334321,
      stop : 31414742,
      direction : "-",
      ID : "ENSG00000158125.10",
      gene_id : "ENSG00000158125.10",
      gene_type : "protein_coding",
      gene_name : "XDH",
      gene_level : 2,
      hgnc_id : "HGNC:12805",
      havana_gene : "OTTHUMG00000099385.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 31522480,
      stop : 31580938,
      direction : "-",
      ID : "ENSG00000277893.2",
      gene_id : "ENSG00000277893.2",
      gene_type : "protein_coding",
      gene_name : "SRD5A2",
      gene_level : 2,
      hgnc_id : "HGNC:11285",
      havana_gene : "OTTHUMG00000152057.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 31865060,
      stop : 32011230,
      direction : "-",
      ID : "ENSG00000162959.14",
      gene_id : "ENSG00000162959.14",
      gene_type : "protein_coding",
      gene_name : "MEMO1",
      gene_level : 1,
      hgnc_id : "HGNC:14014",
      havana_gene : "OTTHUMG00000128453.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 31867809,
      stop : 32039805,
      direction : "-",
      ID : "ENSG00000162961.14",
      gene_id : "ENSG00000162961.14",
      gene_type : "protein_coding",
      gene_name : "DPY30",
      gene_level : 2,
      hgnc_id : "HGNC:24590",
      havana_gene : "OTTHUMG00000128457.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32063556,
      stop : 32157637,
      direction : "+",
      ID : "ENSG00000021574.13",
      gene_id : "ENSG00000021574.13",
      gene_type : "protein_coding",
      gene_name : "SPAST",
      gene_level : 2,
      hgnc_id : "HGNC:11233",
      havana_gene : "OTTHUMG00000128455.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32165841,
      stop : 32224379,
      direction : "+",
      ID : "ENSG00000152683.14",
      gene_id : "ENSG00000152683.14",
      gene_type : "protein_coding",
      gene_name : "SLC30A6",
      gene_level : 2,
      hgnc_id : "HGNC:19305",
      havana_gene : "OTTHUMG00000128456.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32224453,
      stop : 32265732,
      direction : "-",
      ID : "ENSG00000091106.19",
      gene_id : "ENSG00000091106.19",
      gene_type : "protein_coding",
      gene_name : "NLRC4",
      gene_level : 2,
      hgnc_id : "HGNC:16412",
      havana_gene : "OTTHUMG00000152107.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32277904,
      stop : 32316594,
      direction : "+",
      ID : "ENSG00000119820.11",
      gene_id : "ENSG00000119820.11",
      gene_type : "protein_coding",
      gene_name : "YIPF4",
      gene_level : 2,
      hgnc_id : "HGNC:28145",
      havana_gene : "OTTHUMG00000128452.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32357028,
      stop : 32618899,
      direction : "+",
      ID : "ENSG00000115760.14",
      gene_id : "ENSG00000115760.14",
      gene_type : "protein_coding",
      gene_name : "BIRC6",
      gene_level : 1,
      hgnc_id : "HGNC:13516",
      havana_gene : "OTTHUMG00000150528.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32628032,
      stop : 32821051,
      direction : "+",
      ID : "ENSG00000018699.13",
      gene_id : "ENSG00000018699.13",
      gene_type : "protein_coding",
      gene_name : "TTC27",
      gene_level : 1,
      hgnc_id : "HGNC:25986",
      havana_gene : "OTTHUMG00000152134.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 32946953,
      stop : 33399509,
      direction : "+",
      ID : "ENSG00000049323.16",
      gene_id : "ENSG00000049323.16",
      gene_type : "protein_coding",
      gene_name : "LTBP1",
      gene_level : 1,
      hgnc_id : "HGNC:6714",
      havana_gene : "OTTHUMG00000152118.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 33436324,
      stop : 33564750,
      direction : "+",
      ID : "ENSG00000152689.18",
      gene_id : "ENSG00000152689.18",
      gene_type : "protein_coding",
      gene_name : "RASGRP3",
      gene_level : 2,
      hgnc_id : "HGNC:14545",
      havana_gene : "OTTHUMG00000152124.20",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 33583660,
      stop : 33599382,
      direction : "-",
      ID : "ENSG00000119812.19",
      gene_id : "ENSG00000119812.19",
      gene_type : "protein_coding",
      gene_name : "FAM98A",
      gene_level : 2,
      hgnc_id : "HGNC:24520",
      havana_gene : "OTTHUMG00000152152.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 36355778,
      stop : 36551135,
      direction : "+",
      ID : "ENSG00000150938.10",
      gene_id : "ENSG00000150938.10",
      gene_type : "protein_coding",
      gene_name : "CRIM1",
      gene_level : 1,
      hgnc_id : "HGNC:2359",
      havana_gene : "OTTHUMG00000099419.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 36531805,
      stop : 36646087,
      direction : "-",
      ID : "ENSG00000171055.15",
      gene_id : "ENSG00000171055.15",
      gene_type : "protein_coding",
      gene_name : "FEZ2",
      gene_level : 2,
      hgnc_id : "HGNC:3660",
      havana_gene : "OTTHUMG00000152148.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 36696690,
      stop : 36814792,
      direction : "+",
      ID : "ENSG00000205221.12",
      gene_id : "ENSG00000205221.12",
      gene_type : "protein_coding",
      gene_name : "VIT",
      gene_level : 1,
      hgnc_id : "HGNC:12697",
      havana_gene : "OTTHUMG00000152149.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 36837698,
      stop : 36966536,
      direction : "-",
      ID : "ENSG00000115808.12",
      gene_id : "ENSG00000115808.12",
      gene_type : "protein_coding",
      gene_name : "STRN",
      gene_level : 2,
      hgnc_id : "HGNC:11424",
      havana_gene : "OTTHUMG00000100959.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 36968383,
      stop : 37084372,
      direction : "-",
      ID : "ENSG00000008869.12",
      gene_id : "ENSG00000008869.12",
      gene_type : "protein_coding",
      gene_name : "HEATR5B",
      gene_level : 1,
      hgnc_id : "HGNC:29273",
      havana_gene : "OTTHUMG00000152158.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37084451,
      stop : 37099244,
      direction : "+",
      ID : "ENSG00000152133.16",
      gene_id : "ENSG00000152133.16",
      gene_type : "protein_coding",
      gene_name : "GPATCH11",
      gene_level : 2,
      hgnc_id : "HGNC:26768",
      havana_gene : "OTTHUMG00000128469.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37099210,
      stop : 37157522,
      direction : "-",
      ID : "ENSG00000055332.19",
      gene_id : "ENSG00000055332.19",
      gene_type : "protein_coding",
      gene_name : "EIF2AK2",
      gene_level : 2,
      hgnc_id : "HGNC:9437",
      havana_gene : "OTTHUMG00000100962.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37167820,
      stop : 37196598,
      direction : "-",
      ID : "ENSG00000138068.10",
      gene_id : "ENSG00000138068.10",
      gene_type : "protein_coding",
      gene_name : "SULT6B1",
      gene_level : 2,
      hgnc_id : "HGNC:33433",
      havana_gene : "OTTHUMG00000152160.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37196488,
      stop : 37216193,
      direction : "+",
      ID : "ENSG00000218739.10",
      gene_id : "ENSG00000218739.10",
      gene_type : "protein_coding",
      gene_name : "CEBPZOS",
      gene_level : 1,
      hgnc_id : "HGNC:49288",
      havana_gene : "OTTHUMG00000152162.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37201612,
      stop : 37231596,
      direction : "-",
      ID : "ENSG00000115816.15",
      gene_id : "ENSG00000115816.15",
      gene_type : "protein_coding",
      gene_name : "CEBPZ",
      gene_level : 1,
      hgnc_id : "HGNC:24218",
      havana_gene : "OTTHUMG00000100960.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37231631,
      stop : 37253403,
      direction : "+",
      ID : "ENSG00000003509.16",
      gene_id : "ENSG00000003509.16",
      gene_type : "protein_coding",
      gene_name : "NDUFAF7",
      gene_level : 1,
      hgnc_id : "HGNC:28816",
      havana_gene : "OTTHUMG00000128468.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37250502,
      stop : 37324833,
      direction : "-",
      ID : "ENSG00000115825.11",
      gene_id : "ENSG00000115825.11",
      gene_type : "protein_coding",
      gene_name : "PRKD3",
      gene_level : 2,
      hgnc_id : "HGNC:9408",
      havana_gene : "OTTHUMG00000100961.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37342827,
      stop : 37373322,
      direction : "+",
      ID : "ENSG00000115828.17",
      gene_id : "ENSG00000115828.17",
      gene_type : "protein_coding",
      gene_name : "QPCT",
      gene_level : 2,
      hgnc_id : "HGNC:9753",
      havana_gene : "OTTHUMG00000100963.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37641882,
      stop : 37738468,
      direction : "-",
      ID : "ENSG00000163171.8",
      gene_id : "ENSG00000163171.8",
      gene_type : "protein_coding",
      gene_name : "CDC42EP3",
      gene_level : 2,
      hgnc_id : "HGNC:16943",
      havana_gene : "OTTHUMG00000100971.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 37923187,
      stop : 38067142,
      direction : "+",
      ID : "ENSG00000115841.21",
      gene_id : "ENSG00000115841.21",
      gene_type : "protein_coding",
      gene_name : "RMDN2",
      gene_level : 2,
      hgnc_id : "HGNC:26567",
      havana_gene : "OTTHUMG00000128487.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38066973,
      stop : 38109902,
      direction : "-",
      ID : "ENSG00000138061.12",
      gene_id : "ENSG00000138061.12",
      gene_type : "protein_coding",
      gene_name : "CYP1B1",
      gene_level : 1,
      hgnc_id : "HGNC:2597",
      havana_gene : "OTTHUMG00000100970.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38293954,
      stop : 38377285,
      direction : "-",
      ID : "ENSG00000119787.14",
      gene_id : "ENSG00000119787.14",
      gene_type : "protein_coding",
      gene_name : "ATL2",
      gene_level : 2,
      hgnc_id : "HGNC:24047",
      havana_gene : "OTTHUMG00000102074.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38561969,
      stop : 38603586,
      direction : "-",
      ID : "ENSG00000143889.16",
      gene_id : "ENSG00000143889.16",
      gene_type : "protein_coding",
      gene_name : "HNRNPLL",
      gene_level : 1,
      hgnc_id : "HGNC:25127",
      havana_gene : "OTTHUMG00000102075.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38666081,
      stop : 38741237,
      direction : "+",
      ID : "ENSG00000143891.17",
      gene_id : "ENSG00000143891.17",
      gene_type : "protein_coding",
      gene_name : "GALM",
      gene_level : 1,
      hgnc_id : "HGNC:24063",
      havana_gene : "OTTHUMG00000102077.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38743599,
      stop : 38751494,
      direction : "-",
      ID : "ENSG00000115875.19",
      gene_id : "ENSG00000115875.19",
      gene_type : "protein_coding",
      gene_name : "SRSF7",
      gene_level : 2,
      hgnc_id : "HGNC:10789",
      havana_gene : "OTTHUMG00000102076.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38751534,
      stop : 38785002,
      direction : "+",
      ID : "ENSG00000152147.11",
      gene_id : "ENSG00000152147.11",
      gene_type : "protein_coding",
      gene_name : "GEMIN6",
      gene_level : 1,
      hgnc_id : "HGNC:20044",
      havana_gene : "OTTHUMG00000128588.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38797729,
      stop : 38875934,
      direction : "-",
      ID : "ENSG00000163214.21",
      gene_id : "ENSG00000163214.21",
      gene_type : "protein_coding",
      gene_name : "DHX57",
      gene_level : 1,
      hgnc_id : "HGNC:20086",
      havana_gene : "OTTHUMG00000102103.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38875962,
      stop : 38929072,
      direction : "+",
      ID : "ENSG00000188010.15",
      gene_id : "ENSG00000188010.15",
      gene_type : "protein_coding",
      gene_name : "MORN2",
      gene_level : 1,
      hgnc_id : "HGNC:30166",
      havana_gene : "OTTHUMG00000128589.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38889875,
      stop : 38975454,
      direction : "+",
      ID : "ENSG00000214694.12",
      gene_id : "ENSG00000214694.12",
      gene_type : "protein_coding",
      gene_name : "ARHGEF33",
      gene_level : 1,
      hgnc_id : "HGNC:37252",
      havana_gene : "OTTHUMG00000153540.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 38981549,
      stop : 39124345,
      direction : "-",
      ID : "ENSG00000115904.14",
      gene_id : "ENSG00000115904.14",
      gene_type : "protein_coding",
      gene_name : "SOS1",
      gene_level : 1,
      hgnc_id : "HGNC:11187",
      havana_gene : "OTTHUMG00000102109.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 39175646,
      stop : 39229588,
      direction : "-",
      ID : "ENSG00000205111.8",
      gene_id : "ENSG00000205111.8",
      gene_type : "protein_coding",
      gene_name : "CDKL4",
      gene_level : 1,
      hgnc_id : "HGNC:19287",
      havana_gene : "OTTHUMG00000133574.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 39249266,
      stop : 39437301,
      direction : "-",
      ID : "ENSG00000011566.15",
      gene_id : "ENSG00000011566.15",
      gene_type : "protein_coding",
      gene_name : "MAP4K3",
      gene_level : 2,
      hgnc_id : "HGNC:6865",
      havana_gene : "OTTHUMG00000102127.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 39664982,
      stop : 39717963,
      direction : "+",
      ID : "ENSG00000152154.11",
      gene_id : "ENSG00000152154.11",
      gene_type : "protein_coding",
      gene_name : "TMEM178A",
      gene_level : 2,
      hgnc_id : "HGNC:28517",
      havana_gene : "OTTHUMG00000128591.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 39736060,
      stop : 39779267,
      direction : "-",
      ID : "ENSG00000138050.15",
      gene_id : "ENSG00000138050.15",
      gene_type : "protein_coding",
      gene_name : "THUMPD2",
      gene_level : 2,
      hgnc_id : "HGNC:14890",
      havana_gene : "OTTHUMG00000102149.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 40097270,
      stop : 40611053,
      direction : "-",
      ID : "ENSG00000183023.18",
      gene_id : "ENSG00000183023.18",
      gene_type : "protein_coding",
      gene_name : "SLC8A1",
      gene_level : 2,
      hgnc_id : "HGNC:11068",
      havana_gene : "OTTHUMG00000102183.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42048021,
      stop : 42058517,
      direction : "+",
      ID : "ENSG00000162878.13",
      gene_id : "ENSG00000162878.13",
      gene_type : "protein_coding",
      gene_name : "PKDCC",
      gene_level : 2,
      hgnc_id : "HGNC:25123",
      havana_gene : "OTTHUMG00000152303.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42169353,
      stop : 42332548,
      direction : "+",
      ID : "ENSG00000143924.19",
      gene_id : "ENSG00000143924.19",
      gene_type : "protein_coding",
      gene_name : "EML4",
      gene_level : 2,
      hgnc_id : "HGNC:1316",
      havana_gene : "OTTHUMG00000128603.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42333546,
      stop : 42425088,
      direction : "-",
      ID : "ENSG00000115944.15",
      gene_id : "ENSG00000115944.15",
      gene_type : "protein_coding",
      gene_name : "COX7A2L",
      gene_level : 1,
      hgnc_id : "HGNC:2289",
      havana_gene : "OTTHUMG00000128605.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42442017,
      stop : 42493982,
      direction : "-",
      ID : "ENSG00000171126.8",
      gene_id : "ENSG00000171126.8",
      gene_type : "protein_coding",
      gene_name : "KCNG3",
      gene_level : 2,
      hgnc_id : "HGNC:18306",
      havana_gene : "OTTHUMG00000128604.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42494569,
      stop : 42756947,
      direction : "+",
      ID : "ENSG00000057935.14",
      gene_id : "ENSG00000057935.14",
      gene_type : "protein_coding",
      gene_name : "MTA3",
      gene_level : 1,
      hgnc_id : "HGNC:23784",
      havana_gene : "OTTHUMG00000150452.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42762481,
      stop : 42764261,
      direction : "-",
      ID : "ENSG00000162881.6",
      gene_id : "ENSG00000162881.6",
      gene_type : "protein_coding",
      gene_name : "OXER1",
      gene_level : 2,
      hgnc_id : "HGNC:24884",
      havana_gene : "OTTHUMG00000128643.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 42767089,
      stop : 42792593,
      direction : "-",
      ID : "ENSG00000162882.15",
      gene_id : "ENSG00000162882.15",
      gene_type : "protein_coding",
      gene_name : "HAAO",
      gene_level : 1,
      hgnc_id : "HGNC:4796",
      havana_gene : "OTTHUMG00000152348.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43222402,
      stop : 43226606,
      direction : "-",
      ID : "ENSG00000152518.8",
      gene_id : "ENSG00000152518.8",
      gene_type : "protein_coding",
      gene_name : "ZFP36L2",
      gene_level : 2,
      hgnc_id : "HGNC:1108",
      havana_gene : "OTTHUMG00000128642.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43230851,
      stop : 43596038,
      direction : "-",
      ID : "ENSG00000115970.19",
      gene_id : "ENSG00000115970.19",
      gene_type : "protein_coding",
      gene_name : "THADA",
      gene_level : 2,
      hgnc_id : "HGNC:19217",
      havana_gene : "OTTHUMG00000152398.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43637260,
      stop : 43767987,
      direction : "+",
      ID : "ENSG00000152527.14",
      gene_id : "ENSG00000152527.14",
      gene_type : "protein_coding",
      gene_name : "PLEKHH2",
      gene_level : 2,
      hgnc_id : "HGNC:30506",
      havana_gene : "OTTHUMG00000128657.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43675151,
      stop : 43676429,
      direction : "-",
      ID : "ENSG00000223658.8",
      gene_id : "ENSG00000223658.8",
      gene_type : "protein_coding",
      gene_name : "C1GALT1C1L",
      gene_level : 2,
      hgnc_id : "HGNC:51617",
      havana_gene : "OTTHUMG00000152807.4",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43774039,
      stop : 43810010,
      direction : "+",
      ID : "ENSG00000138036.18",
      gene_id : "ENSG00000138036.18",
      gene_type : "protein_coding",
      gene_name : "DYNC2LI1",
      gene_level : 1,
      hgnc_id : "HGNC:24595",
      havana_gene : "OTTHUMG00000128656.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43812472,
      stop : 43838865,
      direction : "-",
      ID : "ENSG00000138075.14",
      gene_id : "ENSG00000138075.14",
      gene_type : "protein_coding",
      gene_name : "ABCG5",
      gene_level : 1,
      hgnc_id : "HGNC:13886",
      havana_gene : "OTTHUMG00000128758.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43831942,
      stop : 43882988,
      direction : "+",
      ID : "ENSG00000143921.9",
      gene_id : "ENSG00000143921.9",
      gene_type : "protein_coding",
      gene_name : "ABCG8",
      gene_level : 2,
      hgnc_id : "HGNC:13887",
      havana_gene : "OTTHUMG00000128756.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 43886224,
      stop : 43995989,
      direction : "-",
      ID : "ENSG00000138095.19",
      gene_id : "ENSG00000138095.19",
      gene_type : "protein_coding",
      gene_name : "LRPPRC",
      gene_level : 1,
      hgnc_id : "HGNC:15714",
      havana_gene : "OTTHUMG00000152782.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 44167969,
      stop : 44244384,
      direction : "+",
      ID : "ENSG00000138032.21",
      gene_id : "ENSG00000138032.21",
      gene_type : "protein_coding",
      gene_name : "PPM1B",
      gene_level : 2,
      hgnc_id : "HGNC:9276",
      havana_gene : "OTTHUMG00000128757.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 44168851,
      stop : 44320310,
      direction : "+",
      ID : "ENSG00000285542.1",
      gene_id : "ENSG00000285542.1",
      gene_type : "protein_coding",
      gene_name : "AC013717.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193405.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 44275458,
      stop : 44321494,
      direction : "+",
      ID : "ENSG00000138079.14",
      gene_id : "ENSG00000138079.14",
      gene_type : "protein_coding",
      gene_name : "SLC3A1",
      gene_level : 1,
      hgnc_id : "HGNC:11025",
      havana_gene : "OTTHUMG00000128759.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 44316281,
      stop : 44361862,
      direction : "-",
      ID : "ENSG00000138078.16",
      gene_id : "ENSG00000138078.16",
      gene_type : "protein_coding",
      gene_name : "PREPL",
      gene_level : 1,
      hgnc_id : "HGNC:30228",
      havana_gene : "OTTHUMG00000152791.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 44361947,
      stop : 44772592,
      direction : "+",
      ID : "ENSG00000143919.15",
      gene_id : "ENSG00000143919.15",
      gene_type : "protein_coding",
      gene_name : "CAMKMT",
      gene_level : 2,
      hgnc_id : "HGNC:26276",
      havana_gene : "OTTHUMG00000128761.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 44941702,
      stop : 44946071,
      direction : "+",
      ID : "ENSG00000138083.5",
      gene_id : "ENSG00000138083.5",
      gene_type : "protein_coding",
      gene_name : "SIX3",
      gene_level : 2,
      hgnc_id : "HGNC:10889",
      havana_gene : "OTTHUMG00000152424.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 45005182,
      stop : 45009452,
      direction : "-",
      ID : "ENSG00000170577.8",
      gene_id : "ENSG00000170577.8",
      gene_type : "protein_coding",
      gene_name : "SIX2",
      gene_level : 2,
      hgnc_id : "HGNC:10888",
      havana_gene : "OTTHUMG00000152421.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 45388680,
      stop : 45612165,
      direction : "-",
      ID : "ENSG00000068784.13",
      gene_id : "ENSG00000068784.13",
      gene_type : "protein_coding",
      gene_name : "SRBD1",
      gene_level : 2,
      hgnc_id : "HGNC:25521",
      havana_gene : "OTTHUMG00000128814.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 45651345,
      stop : 46187990,
      direction : "+",
      ID : "ENSG00000171132.14",
      gene_id : "ENSG00000171132.14",
      gene_type : "protein_coding",
      gene_name : "PRKCE",
      gene_level : 1,
      hgnc_id : "HGNC:9401",
      havana_gene : "OTTHUMG00000128817.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46293667,
      stop : 46386697,
      direction : "+",
      ID : "ENSG00000116016.14",
      gene_id : "ENSG00000116016.14",
      gene_type : "protein_coding",
      gene_name : "EPAS1",
      gene_level : 1,
      hgnc_id : "HGNC:3374",
      havana_gene : "OTTHUMG00000128818.25",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46479565,
      stop : 46484425,
      direction : "+",
      ID : "ENSG00000284701.1",
      gene_id : "ENSG00000284701.1",
      gene_type : "protein_coding",
      gene_name : "TMEM247",
      gene_level : 2,
      hgnc_id : "HGNC:42967",
      havana_gene : "OTTHUMG00000192351.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46490750,
      stop : 46542577,
      direction : "-",
      ID : "ENSG00000250565.7",
      gene_id : "ENSG00000250565.7",
      gene_type : "protein_coding",
      gene_name : "ATP6V1E2",
      gene_level : 2,
      hgnc_id : "HGNC:18125",
      havana_gene : "OTTHUMG00000128819.3",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46541806,
      stop : 46584688,
      direction : "+",
      ID : "ENSG00000119729.12",
      gene_id : "ENSG00000119729.12",
      gene_type : "protein_coding",
      gene_name : "RHOQ",
      gene_level : 2,
      hgnc_id : "HGNC:17736",
      havana_gene : "OTTHUMG00000150653.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46580937,
      stop : 46617055,
      direction : "-",
      ID : "ENSG00000151665.13",
      gene_id : "ENSG00000151665.13",
      gene_type : "protein_coding",
      gene_name : "PIGF",
      gene_level : 2,
      hgnc_id : "HGNC:8962",
      havana_gene : "OTTHUMG00000128816.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46616416,
      stop : 46630176,
      direction : "+",
      ID : "ENSG00000119878.6",
      gene_id : "ENSG00000119878.6",
      gene_type : "protein_coding",
      gene_name : "CRIPT",
      gene_level : 2,
      hgnc_id : "HGNC:14312",
      havana_gene : "OTTHUMG00000128815.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46698952,
      stop : 46780245,
      direction : "+",
      ID : "ENSG00000171150.9",
      gene_id : "ENSG00000171150.9",
      gene_type : "protein_coding",
      gene_name : "SOCS5",
      gene_level : 2,
      hgnc_id : "HGNC:16852",
      havana_gene : "OTTHUMG00000128852.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46901870,
      stop : 46941855,
      direction : "-",
      ID : "ENSG00000180398.13",
      gene_id : "ENSG00000180398.13",
      gene_type : "protein_coding",
      gene_name : "MCFD2",
      gene_level : 1,
      hgnc_id : "HGNC:18451",
      havana_gene : "OTTHUMG00000153100.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 46916157,
      stop : 47076137,
      direction : "+",
      ID : "ENSG00000068724.17",
      gene_id : "ENSG00000068724.17",
      gene_type : "protein_coding",
      gene_name : "TTC7A",
      gene_level : 1,
      hgnc_id : "HGNC:19750",
      havana_gene : "OTTHUMG00000153121.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47045538,
      stop : 47155308,
      direction : "-",
      ID : "ENSG00000239605.11",
      gene_id : "ENSG00000239605.11",
      gene_type : "protein_coding",
      gene_name : "STPG4",
      gene_level : 2,
      hgnc_id : "HGNC:26850",
      havana_gene : "OTTHUMG00000128851.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47065941,
      stop : 47176511,
      direction : "-",
      ID : "ENSG00000273269.3",
      gene_id : "ENSG00000273269.3",
      gene_type : "protein_coding",
      gene_name : "AC073283.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185936.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47160083,
      stop : 47176921,
      direction : "-",
      ID : "ENSG00000143933.19",
      gene_id : "ENSG00000143933.19",
      gene_type : "protein_coding",
      gene_name : "CALM2",
      gene_level : 2,
      hgnc_id : "HGNC:1445",
      havana_gene : "OTTHUMG00000128850.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47345158,
      stop : 47387601,
      direction : "+",
      ID : "ENSG00000119888.11",
      gene_id : "ENSG00000119888.11",
      gene_type : "protein_coding",
      gene_name : "EPCAM",
      gene_level : 1,
      hgnc_id : "HGNC:11529",
      havana_gene : "OTTHUMG00000128853.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47403067,
      stop : 47663146,
      direction : "+",
      ID : "ENSG00000095002.15",
      gene_id : "ENSG00000095002.15",
      gene_type : "protein_coding",
      gene_name : "MSH2",
      gene_level : 1,
      hgnc_id : "HGNC:7325",
      havana_gene : "OTTHUMG00000128861.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47509290,
      stop : 47570985,
      direction : "-",
      ID : "ENSG00000184261.5",
      gene_id : "ENSG00000184261.5",
      gene_type : "protein_coding",
      gene_name : "KCNK12",
      gene_level : 2,
      hgnc_id : "HGNC:6274",
      havana_gene : "OTTHUMG00000129131.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47695530,
      stop : 47810063,
      direction : "+",
      ID : "ENSG00000116062.17",
      gene_id : "ENSG00000116062.17",
      gene_type : "protein_coding",
      gene_name : "MSH6",
      gene_level : 2,
      hgnc_id : "HGNC:7329",
      havana_gene : "OTTHUMG00000129129.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 47789316,
      stop : 47906498,
      direction : "-",
      ID : "ENSG00000138081.21",
      gene_id : "ENSG00000138081.21",
      gene_type : "protein_coding",
      gene_name : "FBXO11",
      gene_level : 2,
      hgnc_id : "HGNC:13590",
      havana_gene : "OTTHUMG00000129130.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48314637,
      stop : 48379295,
      direction : "+",
      ID : "ENSG00000170802.16",
      gene_id : "ENSG00000170802.16",
      gene_type : "protein_coding",
      gene_name : "FOXN2",
      gene_level : 2,
      hgnc_id : "HGNC:5281",
      havana_gene : "OTTHUMG00000129168.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48440598,
      stop : 48515391,
      direction : "+",
      ID : "ENSG00000162869.16",
      gene_id : "ENSG00000162869.16",
      gene_type : "protein_coding",
      gene_name : "PPP1R21",
      gene_level : 2,
      hgnc_id : "HGNC:30595",
      havana_gene : "OTTHUMG00000129167.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48529383,
      stop : 48598513,
      direction : "+",
      ID : "ENSG00000243244.7",
      gene_id : "ENSG00000243244.7",
      gene_type : "protein_coding",
      gene_name : "STON1",
      gene_level : 2,
      hgnc_id : "HGNC:17003",
      havana_gene : "OTTHUMG00000129169.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48529925,
      stop : 48776517,
      direction : "+",
      ID : "ENSG00000068781.21",
      gene_id : "ENSG00000068781.21",
      gene_type : "protein_coding",
      gene_name : "STON1-GTF2A1L",
      gene_level : 1,
      hgnc_id : "HGNC:30651",
      havana_gene : "OTTHUMG00000152037.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48617798,
      stop : 48733148,
      direction : "+",
      ID : "ENSG00000242441.8",
      gene_id : "ENSG00000242441.8",
      gene_type : "protein_coding",
      gene_name : "GTF2A1L",
      gene_level : 2,
      hgnc_id : "HGNC:30727",
      havana_gene : "OTTHUMG00000152038.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48632291,
      stop : 48755724,
      direction : "-",
      ID : "ENSG00000279956.1",
      gene_id : "ENSG00000279956.1",
      gene_type : "protein_coding",
      gene_name : "AC073082.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189455.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48686774,
      stop : 48755730,
      direction : "-",
      ID : "ENSG00000138039.15",
      gene_id : "ENSG00000138039.15",
      gene_type : "protein_coding",
      gene_name : "LHCGR",
      gene_level : 1,
      hgnc_id : "HGNC:6585",
      havana_gene : "OTTHUMG00000129257.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 48962157,
      stop : 49154527,
      direction : "-",
      ID : "ENSG00000170820.12",
      gene_id : "ENSG00000170820.12",
      gene_type : "protein_coding",
      gene_name : "FSHR",
      gene_level : 2,
      hgnc_id : "HGNC:3969",
      havana_gene : "OTTHUMG00000129259.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 49918503,
      stop : 51225575,
      direction : "-",
      ID : "ENSG00000179915.24",
      gene_id : "ENSG00000179915.24",
      gene_type : "protein_coding",
      gene_name : "NRXN1",
      gene_level : 1,
      hgnc_id : "HGNC:8008",
      havana_gene : "OTTHUMG00000129263.23",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 53532672,
      stop : 53860160,
      direction : "-",
      ID : "ENSG00000115239.24",
      gene_id : "ENSG00000115239.24",
      gene_type : "protein_coding",
      gene_name : "ASB3",
      gene_level : 2,
      hgnc_id : "HGNC:16013",
      havana_gene : "OTTHUMG00000184778.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 53767804,
      stop : 53775196,
      direction : "+",
      ID : "ENSG00000143942.5",
      gene_id : "ENSG00000143942.5",
      gene_type : "protein_coding",
      gene_name : "CHAC2",
      gene_level : 2,
      hgnc_id : "HGNC:32363",
      havana_gene : "OTTHUMG00000151824.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 53787044,
      stop : 53818819,
      direction : "+",
      ID : "ENSG00000068912.14",
      gene_id : "ENSG00000068912.14",
      gene_type : "protein_coding",
      gene_name : "ERLEC1",
      gene_level : 1,
      hgnc_id : "HGNC:25222",
      havana_gene : "OTTHUMG00000129281.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 53852912,
      stop : 53859967,
      direction : "-",
      ID : "ENSG00000119737.6",
      gene_id : "ENSG00000119737.6",
      gene_type : "protein_coding",
      gene_name : "GPR75",
      gene_level : 2,
      hgnc_id : "HGNC:4526",
      havana_gene : "OTTHUMG00000129280.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 53864069,
      stop : 53970993,
      direction : "-",
      ID : "ENSG00000068878.15",
      gene_id : "ENSG00000068878.15",
      gene_type : "protein_coding",
      gene_name : "PSME4",
      gene_level : 2,
      hgnc_id : "HGNC:20635",
      havana_gene : "OTTHUMG00000151852.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 53970838,
      stop : 54305300,
      direction : "+",
      ID : "ENSG00000170634.13",
      gene_id : "ENSG00000170634.13",
      gene_type : "protein_coding",
      gene_name : "ACYP2",
      gene_level : 1,
      hgnc_id : "HGNC:180",
      havana_gene : "OTTHUMG00000129287.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 54253178,
      stop : 54256229,
      direction : "-",
      ID : "ENSG00000178021.11",
      gene_id : "ENSG00000178021.11",
      gene_type : "protein_coding",
      gene_name : "TSPYL6",
      gene_level : 2,
      hgnc_id : "HGNC:14521",
      havana_gene : "OTTHUMG00000151823.4",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 54330034,
      stop : 54383742,
      direction : "+",
      ID : "ENSG00000177994.16",
      gene_id : "ENSG00000177994.16",
      gene_type : "protein_coding",
      gene_name : "C2orf73",
      gene_level : 1,
      hgnc_id : "HGNC:26861",
      havana_gene : "OTTHUMG00000151826.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 54456317,
      stop : 54671446,
      direction : "+",
      ID : "ENSG00000115306.16",
      gene_id : "ENSG00000115306.16",
      gene_type : "protein_coding",
      gene_name : "SPTBN1",
      gene_level : 2,
      hgnc_id : "HGNC:11275",
      havana_gene : "OTTHUMG00000133746.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 54723499,
      stop : 54972025,
      direction : "+",
      ID : "ENSG00000214595.12",
      gene_id : "ENSG00000214595.12",
      gene_type : "protein_coding",
      gene_name : "EML6",
      gene_level : 1,
      hgnc_id : "HGNC:35412",
      havana_gene : "OTTHUMG00000152035.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 54972187,
      stop : 55112621,
      direction : "-",
      ID : "ENSG00000115310.18",
      gene_id : "ENSG00000115310.18",
      gene_type : "protein_coding",
      gene_name : "RTN4",
      gene_level : 2,
      hgnc_id : "HGNC:14085",
      havana_gene : "OTTHUMG00000129337.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55172547,
      stop : 55232563,
      direction : "-",
      ID : "ENSG00000162994.16",
      gene_id : "ENSG00000162994.16",
      gene_type : "protein_coding",
      gene_name : "CLHC1",
      gene_level : 1,
      hgnc_id : "HGNC:26453",
      havana_gene : "OTTHUMG00000151918.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55231903,
      stop : 55235853,
      direction : "+",
      ID : "ENSG00000143947.15",
      gene_id : "ENSG00000143947.15",
      gene_type : "protein_coding",
      gene_name : "RPS27A",
      gene_level : 2,
      hgnc_id : "HGNC:10417",
      havana_gene : "OTTHUMG00000151919.18",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55236595,
      stop : 55269347,
      direction : "-",
      ID : "ENSG00000085760.15",
      gene_id : "ENSG00000085760.15",
      gene_type : "protein_coding",
      gene_name : "MTIF2",
      gene_level : 1,
      hgnc_id : "HGNC:7441",
      havana_gene : "OTTHUMG00000129338.24",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55287842,
      stop : 55419895,
      direction : "-",
      ID : "ENSG00000115355.17",
      gene_id : "ENSG00000115355.17",
      gene_type : "protein_coding",
      gene_name : "CCDC88A",
      gene_level : 1,
      hgnc_id : "HGNC:25523",
      havana_gene : "OTTHUMG00000151915.19",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55519604,
      stop : 55545079,
      direction : "+",
      ID : "ENSG00000163001.12",
      gene_id : "ENSG00000163001.12",
      gene_type : "protein_coding",
      gene_name : "CFAP36",
      gene_level : 2,
      hgnc_id : "HGNC:30540",
      havana_gene : "OTTHUMG00000129339.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55547292,
      stop : 55618880,
      direction : "-",
      ID : "ENSG00000275052.5",
      gene_id : "ENSG00000275052.5",
      gene_type : "protein_coding",
      gene_name : "PPP4R3B",
      gene_level : 2,
      hgnc_id : "HGNC:29267",
      havana_gene : "OTTHUMG00000129336.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55634061,
      stop : 55693863,
      direction : "-",
      ID : "ENSG00000138035.15",
      gene_id : "ENSG00000138035.15",
      gene_type : "protein_coding",
      gene_name : "PNPT1",
      gene_level : 2,
      hgnc_id : "HGNC:23166",
      havana_gene : "OTTHUMG00000129335.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 55865967,
      stop : 55924139,
      direction : "-",
      ID : "ENSG00000115380.20",
      gene_id : "ENSG00000115380.20",
      gene_type : "protein_coding",
      gene_name : "EFEMP1",
      gene_level : 2,
      hgnc_id : "HGNC:3218",
      havana_gene : "OTTHUMG00000129343.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 56183990,
      stop : 56386172,
      direction : "+",
      ID : "ENSG00000055813.6",
      gene_id : "ENSG00000055813.6",
      gene_type : "protein_coding",
      gene_name : "CCDC85A",
      gene_level : 2,
      hgnc_id : "HGNC:29400",
      havana_gene : "OTTHUMG00000152033.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 57907629,
      stop : 58159920,
      direction : "+",
      ID : "ENSG00000028116.18",
      gene_id : "ENSG00000028116.18",
      gene_type : "protein_coding",
      gene_name : "VRK2",
      gene_level : 1,
      hgnc_id : "HGNC:12719",
      havana_gene : "OTTHUMG00000129348.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 58159243,
      stop : 58241372,
      direction : "-",
      ID : "ENSG00000115392.12",
      gene_id : "ENSG00000115392.12",
      gene_type : "protein_coding",
      gene_name : "FANCL",
      gene_level : 1,
      hgnc_id : "HGNC:20748",
      havana_gene : "OTTHUMG00000129349.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 60450520,
      stop : 60554467,
      direction : "-",
      ID : "ENSG00000119866.22",
      gene_id : "ENSG00000119866.22",
      gene_type : "protein_coding",
      gene_name : "BCL11A",
      gene_level : 1,
      hgnc_id : "HGNC:13221",
      havana_gene : "OTTHUMG00000129420.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 60756253,
      stop : 60802086,
      direction : "+",
      ID : "ENSG00000115421.13",
      gene_id : "ENSG00000115421.13",
      gene_type : "protein_coding",
      gene_name : "PAPOLG",
      gene_level : 2,
      hgnc_id : "HGNC:14982",
      havana_gene : "OTTHUMG00000129419.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 60881521,
      stop : 60931612,
      direction : "+",
      ID : "ENSG00000162924.15",
      gene_id : "ENSG00000162924.15",
      gene_type : "protein_coding",
      gene_name : "REL",
      gene_level : 2,
      hgnc_id : "HGNC:9954",
      havana_gene : "OTTHUMG00000129418.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 60940222,
      stop : 61018259,
      direction : "-",
      ID : "ENSG00000162927.14",
      gene_id : "ENSG00000162927.14",
      gene_type : "protein_coding",
      gene_name : "PUS10",
      gene_level : 2,
      hgnc_id : "HGNC:26505",
      havana_gene : "OTTHUMG00000129423.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61017225,
      stop : 61051990,
      direction : "+",
      ID : "ENSG00000162928.9",
      gene_id : "ENSG00000162928.9",
      gene_type : "protein_coding",
      gene_name : "PEX13",
      gene_level : 1,
      hgnc_id : "HGNC:8855",
      havana_gene : "OTTHUMG00000129422.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61065871,
      stop : 61138034,
      direction : "+",
      ID : "ENSG00000162929.14",
      gene_id : "ENSG00000162929.14",
      gene_type : "protein_coding",
      gene_name : "KIAA1841",
      gene_level : 1,
      hgnc_id : "HGNC:29387",
      havana_gene : "OTTHUMG00000187089.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61145068,
      stop : 61164828,
      direction : "+",
      ID : "ENSG00000237651.7",
      gene_id : "ENSG00000237651.7",
      gene_type : "protein_coding",
      gene_name : "C2orf74",
      gene_level : 2,
      hgnc_id : "HGNC:34439",
      havana_gene : "OTTHUMG00000187090.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61187463,
      stop : 61471087,
      direction : "-",
      ID : "ENSG00000115464.15",
      gene_id : "ENSG00000115464.15",
      gene_type : "protein_coding",
      gene_name : "USP34",
      gene_level : 2,
      hgnc_id : "HGNC:20066",
      havana_gene : "OTTHUMG00000152265.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61476032,
      stop : 61538741,
      direction : "-",
      ID : "ENSG00000082898.19",
      gene_id : "ENSG00000082898.19",
      gene_type : "protein_coding",
      gene_name : "XPO1",
      gene_level : 2,
      hgnc_id : "HGNC:12825",
      havana_gene : "OTTHUMG00000152316.24",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61824848,
      stop : 61854143,
      direction : "-",
      ID : "ENSG00000170264.13",
      gene_id : "ENSG00000170264.13",
      gene_type : "protein_coding",
      gene_name : "FAM161A",
      gene_level : 2,
      hgnc_id : "HGNC:25808",
      havana_gene : "OTTHUMG00000152165.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61868085,
      stop : 61888671,
      direction : "-",
      ID : "ENSG00000115484.15",
      gene_id : "ENSG00000115484.15",
      gene_type : "protein_coding",
      gene_name : "CCT4",
      gene_level : 2,
      hgnc_id : "HGNC:1617",
      havana_gene : "OTTHUMG00000152166.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 61888724,
      stop : 62147247,
      direction : "+",
      ID : "ENSG00000173163.10",
      gene_id : "ENSG00000173163.10",
      gene_type : "protein_coding",
      gene_name : "COMMD1",
      gene_level : 2,
      hgnc_id : "HGNC:23024",
      havana_gene : "OTTHUMG00000129445.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 62196115,
      stop : 62224731,
      direction : "+",
      ID : "ENSG00000170340.11",
      gene_id : "ENSG00000170340.11",
      gene_type : "protein_coding",
      gene_name : "B3GNT2",
      gene_level : 2,
      hgnc_id : "HGNC:15629",
      havana_gene : "OTTHUMG00000129444.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 62500218,
      stop : 62511894,
      direction : "-",
      ID : "ENSG00000186889.10",
      gene_id : "ENSG00000186889.10",
      gene_type : "protein_coding",
      gene_name : "TMEM17",
      gene_level : 2,
      hgnc_id : "HGNC:26623",
      havana_gene : "OTTHUMG00000129455.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 62673851,
      stop : 63046487,
      direction : "+",
      ID : "ENSG00000115504.15",
      gene_id : "ENSG00000115504.15",
      gene_type : "protein_coding",
      gene_name : "EHBP1",
      gene_level : 2,
      hgnc_id : "HGNC:29144",
      havana_gene : "OTTHUMG00000129453.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 63050057,
      stop : 63057836,
      direction : "+",
      ID : "ENSG00000115507.10",
      gene_id : "ENSG00000115507.10",
      gene_type : "protein_coding",
      gene_name : "OTX1",
      gene_level : 1,
      hgnc_id : "HGNC:8521",
      havana_gene : "OTTHUMG00000129454.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 63119559,
      stop : 63827843,
      direction : "-",
      ID : "ENSG00000143951.16",
      gene_id : "ENSG00000143951.16",
      gene_type : "protein_coding",
      gene_name : "WDPCP",
      gene_level : 1,
      hgnc_id : "HGNC:28027",
      havana_gene : "OTTHUMG00000152566.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 63588609,
      stop : 63607197,
      direction : "+",
      ID : "ENSG00000014641.21",
      gene_id : "ENSG00000014641.21",
      gene_type : "protein_coding",
      gene_name : "MDH1",
      gene_level : 1,
      hgnc_id : "HGNC:6970",
      havana_gene : "OTTHUMG00000129512.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 63840952,
      stop : 63891562,
      direction : "+",
      ID : "ENSG00000169764.16",
      gene_id : "ENSG00000169764.16",
      gene_type : "protein_coding",
      gene_name : "UGP2",
      gene_level : 1,
      hgnc_id : "HGNC:12527",
      havana_gene : "OTTHUMG00000129513.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 63892146,
      stop : 64019428,
      direction : "-",
      ID : "ENSG00000143952.20",
      gene_id : "ENSG00000143952.20",
      gene_type : "protein_coding",
      gene_name : "VPS54",
      gene_level : 1,
      hgnc_id : "HGNC:18652",
      havana_gene : "OTTHUMG00000152627.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 64092652,
      stop : 64144420,
      direction : "-",
      ID : "ENSG00000197329.12",
      gene_id : "ENSG00000197329.12",
      gene_type : "protein_coding",
      gene_name : "PELI1",
      gene_level : 2,
      hgnc_id : "HGNC:8827",
      havana_gene : "OTTHUMG00000129511.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 64453969,
      stop : 64461381,
      direction : "+",
      ID : "ENSG00000119862.13",
      gene_id : "ENSG00000119862.13",
      gene_type : "protein_coding",
      gene_name : "LGALSL",
      gene_level : 1,
      hgnc_id : "HGNC:25012",
      havana_gene : "OTTHUMG00000129541.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 64524305,
      stop : 64593005,
      direction : "+",
      ID : "ENSG00000119844.15",
      gene_id : "ENSG00000119844.15",
      gene_type : "protein_coding",
      gene_name : "AFTPH",
      gene_level : 2,
      hgnc_id : "HGNC:25951",
      havana_gene : "OTTHUMG00000129539.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 64631621,
      stop : 64751005,
      direction : "-",
      ID : "ENSG00000179833.4",
      gene_id : "ENSG00000179833.4",
      gene_type : "protein_coding",
      gene_name : "SERTAD2",
      gene_level : 2,
      hgnc_id : "HGNC:30784",
      havana_gene : "OTTHUMG00000152678.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 64988477,
      stop : 65023865,
      direction : "+",
      ID : "ENSG00000115902.11",
      gene_id : "ENSG00000115902.11",
      gene_type : "protein_coding",
      gene_name : "SLC1A4",
      gene_level : 1,
      hgnc_id : "HGNC:10942",
      havana_gene : "OTTHUMG00000129537.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 65056366,
      stop : 65087004,
      direction : "+",
      ID : "ENSG00000011523.14",
      gene_id : "ENSG00000011523.14",
      gene_type : "protein_coding",
      gene_name : "CEP68",
      gene_level : 1,
      hgnc_id : "HGNC:29076",
      havana_gene : "OTTHUMG00000129538.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 65070696,
      stop : 65130331,
      direction : "-",
      ID : "ENSG00000138069.18",
      gene_id : "ENSG00000138069.18",
      gene_type : "protein_coding",
      gene_name : "RAB1A",
      gene_level : 2,
      hgnc_id : "HGNC:9758",
      havana_gene : "OTTHUMG00000152725.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 65227788,
      stop : 65271253,
      direction : "+",
      ID : "ENSG00000138071.14",
      gene_id : "ENSG00000138071.14",
      gene_type : "protein_coding",
      gene_name : "ACTR2",
      gene_level : 2,
      hgnc_id : "HGNC:169",
      havana_gene : "OTTHUMG00000129540.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 65310851,
      stop : 65432637,
      direction : "-",
      ID : "ENSG00000198369.10",
      gene_id : "ENSG00000198369.10",
      gene_type : "protein_coding",
      gene_name : "SPRED2",
      gene_level : 1,
      hgnc_id : "HGNC:17722",
      havana_gene : "OTTHUMG00000152737.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 66433452,
      stop : 66573869,
      direction : "+",
      ID : "ENSG00000143995.20",
      gene_id : "ENSG00000143995.20",
      gene_type : "protein_coding",
      gene_name : "MEIS1",
      gene_level : 1,
      hgnc_id : "HGNC:7000",
      havana_gene : "OTTHUMG00000150714.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 67397322,
      stop : 67412089,
      direction : "+",
      ID : "ENSG00000143971.9",
      gene_id : "ENSG00000143971.9",
      gene_type : "protein_coding",
      gene_name : "ETAA1",
      gene_level : 2,
      hgnc_id : "HGNC:24648",
      havana_gene : "OTTHUMG00000129545.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68041130,
      stop : 68110948,
      direction : "-",
      ID : "ENSG00000197223.12",
      gene_id : "ENSG00000197223.12",
      gene_type : "protein_coding",
      gene_name : "C1D",
      gene_level : 1,
      hgnc_id : "HGNC:29911",
      havana_gene : "OTTHUMG00000129564.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68122936,
      stop : 68157549,
      direction : "-",
      ID : "ENSG00000243667.7",
      gene_id : "ENSG00000243667.7",
      gene_type : "protein_coding",
      gene_name : "WDR92",
      gene_level : 1,
      hgnc_id : "HGNC:25176",
      havana_gene : "OTTHUMG00000152561.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68131238,
      stop : 68261230,
      direction : "-",
      ID : "ENSG00000273398.6",
      gene_id : "ENSG00000273398.6",
      gene_type : "protein_coding",
      gene_name : "AC017083.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185937.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68157888,
      stop : 68176238,
      direction : "+",
      ID : "ENSG00000115946.8",
      gene_id : "ENSG00000115946.8",
      gene_type : "protein_coding",
      gene_name : "PNO1",
      gene_level : 2,
      hgnc_id : "HGNC:32790",
      havana_gene : "OTTHUMG00000129563.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68178857,
      stop : 68256237,
      direction : "-",
      ID : "ENSG00000221823.11",
      gene_id : "ENSG00000221823.11",
      gene_type : "protein_coding",
      gene_name : "PPP3R1",
      gene_level : 2,
      hgnc_id : "HGNC:9317",
      havana_gene : "OTTHUMG00000129561.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68284171,
      stop : 68320051,
      direction : "-",
      ID : "ENSG00000119865.9",
      gene_id : "ENSG00000119865.9",
      gene_type : "protein_coding",
      gene_name : "CNRIP1",
      gene_level : 1,
      hgnc_id : "HGNC:24546",
      havana_gene : "OTTHUMG00000129565.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68365282,
      stop : 68397453,
      direction : "+",
      ID : "ENSG00000115956.10",
      gene_id : "ENSG00000115956.10",
      gene_type : "protein_coding",
      gene_name : "PLEK",
      gene_level : 2,
      hgnc_id : "HGNC:9070",
      havana_gene : "OTTHUMG00000129562.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68459422,
      stop : 68467294,
      direction : "-",
      ID : "ENSG00000204923.4",
      gene_id : "ENSG00000204923.4",
      gene_type : "protein_coding",
      gene_name : "FBXO48",
      gene_level : 2,
      hgnc_id : "HGNC:33857",
      havana_gene : "OTTHUMG00000152585.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68467572,
      stop : 68655862,
      direction : "+",
      ID : "ENSG00000169621.10",
      gene_id : "ENSG00000169621.10",
      gene_type : "protein_coding",
      gene_name : "APLF",
      gene_level : 2,
      hgnc_id : "HGNC:28724",
      havana_gene : "OTTHUMG00000129566.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68643579,
      stop : 68658251,
      direction : "+",
      ID : "ENSG00000169618.7",
      gene_id : "ENSG00000169618.7",
      gene_type : "protein_coding",
      gene_name : "PROKR1",
      gene_level : 2,
      hgnc_id : "HGNC:4524",
      havana_gene : "OTTHUMG00000129567.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68679601,
      stop : 68826833,
      direction : "+",
      ID : "ENSG00000163219.12",
      gene_id : "ENSG00000163219.12",
      gene_type : "protein_coding",
      gene_name : "ARHGAP25",
      gene_level : 1,
      hgnc_id : "HGNC:28951",
      havana_gene : "OTTHUMG00000152621.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68860909,
      stop : 68871397,
      direction : "-",
      ID : "ENSG00000163217.2",
      gene_id : "ENSG00000163217.2",
      gene_type : "protein_coding",
      gene_name : "BMP10",
      gene_level : 2,
      hgnc_id : "HGNC:20869",
      havana_gene : "OTTHUMG00000129573.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68945232,
      stop : 68952893,
      direction : "-",
      ID : "ENSG00000183607.10",
      gene_id : "ENSG00000183607.10",
      gene_type : "protein_coding",
      gene_name : "GKN2",
      gene_level : 2,
      hgnc_id : "HGNC:24588",
      havana_gene : "OTTHUMG00000152655.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 68974573,
      stop : 68980980,
      direction : "+",
      ID : "ENSG00000169605.7",
      gene_id : "ENSG00000169605.7",
      gene_type : "protein_coding",
      gene_name : "GKN1",
      gene_level : 2,
      hgnc_id : "HGNC:23217",
      havana_gene : "OTTHUMG00000129574.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69013176,
      stop : 69249327,
      direction : "+",
      ID : "ENSG00000169604.21",
      gene_id : "ENSG00000169604.21",
      gene_type : "protein_coding",
      gene_name : "ANTXR1",
      gene_level : 1,
      hgnc_id : "HGNC:21014",
      havana_gene : "OTTHUMG00000129575.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69319780,
      stop : 69387250,
      direction : "-",
      ID : "ENSG00000198380.13",
      gene_id : "ENSG00000198380.13",
      gene_type : "protein_coding",
      gene_name : "GFPT1",
      gene_level : 2,
      hgnc_id : "HGNC:4241",
      havana_gene : "OTTHUMG00000152666.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69396113,
      stop : 69437628,
      direction : "-",
      ID : "ENSG00000169599.13",
      gene_id : "ENSG00000169599.13",
      gene_type : "protein_coding",
      gene_name : "NFU1",
      gene_level : 2,
      hgnc_id : "HGNC:16287",
      havana_gene : "OTTHUMG00000152668.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69457997,
      stop : 69674349,
      direction : "-",
      ID : "ENSG00000115977.21",
      gene_id : "ENSG00000115977.21",
      gene_type : "protein_coding",
      gene_name : "AAK1",
      gene_level : 1,
      hgnc_id : "HGNC:19679",
      havana_gene : "OTTHUMG00000129648.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69644425,
      stop : 69827112,
      direction : "+",
      ID : "ENSG00000196975.16",
      gene_id : "ENSG00000196975.16",
      gene_type : "protein_coding",
      gene_name : "ANXA4",
      gene_level : 2,
      hgnc_id : "HGNC:542",
      havana_gene : "OTTHUMG00000129649.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69829660,
      stop : 69881384,
      direction : "+",
      ID : "ENSG00000087338.5",
      gene_id : "ENSG00000087338.5",
      gene_type : "protein_coding",
      gene_name : "GMCL1",
      gene_level : 2,
      hgnc_id : "HGNC:23843",
      havana_gene : "OTTHUMG00000129643.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69893956,
      stop : 69905575,
      direction : "+",
      ID : "ENSG00000124380.11",
      gene_id : "ENSG00000124380.11",
      gene_type : "protein_coding",
      gene_name : "SNRNP27",
      gene_level : 2,
      hgnc_id : "HGNC:30240",
      havana_gene : "OTTHUMG00000152689.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69897688,
      stop : 69942945,
      direction : "+",
      ID : "ENSG00000059728.11",
      gene_id : "ENSG00000059728.11",
      gene_type : "protein_coding",
      gene_name : "MXD1",
      gene_level : 1,
      hgnc_id : "HGNC:6761",
      havana_gene : "OTTHUMG00000129646.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 69960089,
      stop : 69962265,
      direction : "-",
      ID : "ENSG00000244617.2",
      gene_id : "ENSG00000244617.2",
      gene_type : "protein_coding",
      gene_name : "ASPRV1",
      gene_level : 2,
      hgnc_id : "HGNC:26321",
      havana_gene : "OTTHUMG00000129647.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70087477,
      stop : 70089203,
      direction : "+",
      ID : "ENSG00000169564.7",
      gene_id : "ENSG00000169564.7",
      gene_type : "protein_coding",
      gene_name : "PCBP1",
      gene_level : 2,
      hgnc_id : "HGNC:8647",
      havana_gene : "OTTHUMG00000129645.2",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70149885,
      stop : 70248615,
      direction : "-",
      ID : "ENSG00000115998.8",
      gene_id : "ENSG00000115998.8",
      gene_type : "protein_coding",
      gene_name : "C2orf42",
      gene_level : 1,
      hgnc_id : "HGNC:26056",
      havana_gene : "OTTHUMG00000129642.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70209444,
      stop : 70248660,
      direction : "-",
      ID : "ENSG00000116001.17",
      gene_id : "ENSG00000116001.17",
      gene_type : "protein_coding",
      gene_name : "TIA1",
      gene_level : 2,
      hgnc_id : "HGNC:11802",
      havana_gene : "OTTHUMG00000129644.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70257386,
      stop : 70281185,
      direction : "+",
      ID : "ENSG00000116005.12",
      gene_id : "ENSG00000116005.12",
      gene_type : "protein_coding",
      gene_name : "PCYOX1",
      gene_level : 1,
      hgnc_id : "HGNC:20588",
      havana_gene : "OTTHUMG00000129671.22",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70281362,
      stop : 70293740,
      direction : "-",
      ID : "ENSG00000143977.14",
      gene_id : "ENSG00000143977.14",
      gene_type : "protein_coding",
      gene_name : "SNRPG",
      gene_level : 1,
      hgnc_id : "HGNC:11163",
      havana_gene : "OTTHUMG00000129670.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70295975,
      stop : 70302090,
      direction : "-",
      ID : "ENSG00000035141.8",
      gene_id : "ENSG00000035141.8",
      gene_type : "protein_coding",
      gene_name : "FAM136A",
      gene_level : 1,
      hgnc_id : "HGNC:25911",
      havana_gene : "OTTHUMG00000129668.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70447284,
      stop : 70554193,
      direction : "-",
      ID : "ENSG00000163235.16",
      gene_id : "ENSG00000163235.16",
      gene_type : "protein_coding",
      gene_name : "TGFA",
      gene_level : 2,
      hgnc_id : "HGNC:11765",
      havana_gene : "OTTHUMG00000129669.40",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70607618,
      stop : 70768225,
      direction : "-",
      ID : "ENSG00000075340.23",
      gene_id : "ENSG00000075340.23",
      gene_type : "protein_coding",
      gene_name : "ADD2",
      gene_level : 1,
      hgnc_id : "HGNC:244",
      havana_gene : "OTTHUMG00000129710.15",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70777310,
      stop : 70790643,
      direction : "-",
      ID : "ENSG00000183733.6",
      gene_id : "ENSG00000183733.6",
      gene_type : "protein_coding",
      gene_name : "FIGLA",
      gene_level : 2,
      hgnc_id : "HGNC:24669",
      havana_gene : "OTTHUMG00000153440.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70808643,
      stop : 70820599,
      direction : "-",
      ID : "ENSG00000152672.8",
      gene_id : "ENSG00000152672.8",
      gene_type : "protein_coding",
      gene_name : "CLEC4F",
      gene_level : 1,
      hgnc_id : "HGNC:25357",
      havana_gene : "OTTHUMG00000129713.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70830211,
      stop : 70835816,
      direction : "-",
      ID : "ENSG00000116031.9",
      gene_id : "ENSG00000116031.9",
      gene_type : "protein_coding",
      gene_name : "CD207",
      gene_level : 2,
      hgnc_id : "HGNC:17935",
      havana_gene : "OTTHUMG00000153176.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70900576,
      stop : 70965373,
      direction : "+",
      ID : "ENSG00000116035.4",
      gene_id : "ENSG00000116035.4",
      gene_type : "protein_coding",
      gene_name : "VAX2",
      gene_level : 2,
      hgnc_id : "HGNC:12661",
      havana_gene : "OTTHUMG00000129714.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70935900,
      stop : 70965431,
      direction : "+",
      ID : "ENSG00000116039.13",
      gene_id : "ENSG00000116039.13",
      gene_type : "protein_coding",
      gene_name : "ATP6V1B1",
      gene_level : 2,
      hgnc_id : "HGNC:853",
      havana_gene : "OTTHUMG00000129711.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70939318,
      stop : 70995336,
      direction : "-",
      ID : "ENSG00000258881.6",
      gene_id : "ENSG00000258881.6",
      gene_type : "protein_coding",
      gene_name : "AC007040.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000129708.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70978380,
      stop : 70985499,
      direction : "+",
      ID : "ENSG00000144031.12",
      gene_id : "ENSG00000144031.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD53",
      gene_level : 1,
      hgnc_id : "HGNC:25691",
      havana_gene : "OTTHUMG00000129712.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 70985942,
      stop : 70994873,
      direction : "-",
      ID : "ENSG00000144043.12",
      gene_id : "ENSG00000144043.12",
      gene_type : "protein_coding",
      gene_name : "TEX261",
      gene_level : 2,
      hgnc_id : "HGNC:30712",
      havana_gene : "OTTHUMG00000170601.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 71064344,
      stop : 71079808,
      direction : "+",
      ID : "ENSG00000124357.13",
      gene_id : "ENSG00000124357.13",
      gene_type : "protein_coding",
      gene_name : "NAGK",
      gene_level : 1,
      hgnc_id : "HGNC:17174",
      havana_gene : "OTTHUMG00000153239.26",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 71109684,
      stop : 71130239,
      direction : "-",
      ID : "ENSG00000124370.11",
      gene_id : "ENSG00000124370.11",
      gene_type : "protein_coding",
      gene_name : "MCEE",
      gene_level : 2,
      hgnc_id : "HGNC:16732",
      havana_gene : "OTTHUMG00000129709.23",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 71130632,
      stop : 71150101,
      direction : "+",
      ID : "ENSG00000124383.9",
      gene_id : "ENSG00000124383.9",
      gene_type : "protein_coding",
      gene_name : "MPHOSPH10",
      gene_level : 2,
      hgnc_id : "HGNC:7213",
      havana_gene : "OTTHUMG00000129715.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 71182738,
      stop : 71227103,
      direction : "-",
      ID : "ENSG00000124374.9",
      gene_id : "ENSG00000124374.9",
      gene_type : "protein_coding",
      gene_name : "PAIP2B",
      gene_level : 2,
      hgnc_id : "HGNC:29200",
      havana_gene : "OTTHUMG00000153284.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 71276561,
      stop : 71435069,
      direction : "+",
      ID : "ENSG00000075292.19",
      gene_id : "ENSG00000075292.19",
      gene_type : "protein_coding",
      gene_name : "ZNF638",
      gene_level : 1,
      hgnc_id : "HGNC:17894",
      havana_gene : "OTTHUMG00000129735.21",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 71453722,
      stop : 71686768,
      direction : "+",
      ID : "ENSG00000135636.14",
      gene_id : "ENSG00000135636.14",
      gene_type : "protein_coding",
      gene_name : "DYSF",
      gene_level : 2,
      hgnc_id : "HGNC:3097",
      havana_gene : "OTTHUMG00000129757.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 72129238,
      stop : 72147862,
      direction : "-",
      ID : "ENSG00000003137.9",
      gene_id : "ENSG00000003137.9",
      gene_type : "protein_coding",
      gene_name : "CYP26B1",
      gene_level : 1,
      hgnc_id : "HGNC:20581",
      havana_gene : "OTTHUMG00000129756.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 72175984,
      stop : 72826041,
      direction : "-",
      ID : "ENSG00000144036.16",
      gene_id : "ENSG00000144036.16",
      gene_type : "protein_coding",
      gene_name : "EXOC6B",
      gene_level : 2,
      hgnc_id : "HGNC:17085",
      havana_gene : "OTTHUMG00000152723.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 72887382,
      stop : 72892158,
      direction : "+",
      ID : "ENSG00000116096.6",
      gene_id : "ENSG00000116096.6",
      gene_type : "protein_coding",
      gene_name : "SPR",
      gene_level : 1,
      hgnc_id : "HGNC:11257",
      havana_gene : "OTTHUMG00000129777.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 72916260,
      stop : 72936071,
      direction : "+",
      ID : "ENSG00000135638.14",
      gene_id : "ENSG00000135638.14",
      gene_type : "protein_coding",
      gene_name : "EMX1",
      gene_level : 2,
      hgnc_id : "HGNC:3340",
      havana_gene : "OTTHUMG00000129778.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 72942036,
      stop : 73075619,
      direction : "-",
      ID : "ENSG00000144040.13",
      gene_id : "ENSG00000144040.13",
      gene_type : "protein_coding",
      gene_name : "SFXN5",
      gene_level : 1,
      hgnc_id : "HGNC:16073",
      havana_gene : "OTTHUMG00000129775.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73073382,
      stop : 73156721,
      direction : "-",
      ID : "ENSG00000135631.17",
      gene_id : "ENSG00000135631.17",
      gene_type : "protein_coding",
      gene_name : "RAB11FIP5",
      gene_level : 1,
      hgnc_id : "HGNC:24845",
      havana_gene : "OTTHUMG00000129779.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73202574,
      stop : 73212513,
      direction : "+",
      ID : "ENSG00000214513.4",
      gene_id : "ENSG00000214513.4",
      gene_type : "protein_coding",
      gene_name : "NOTO",
      gene_level : 2,
      hgnc_id : "HGNC:31839",
      havana_gene : "OTTHUMG00000164128.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73214222,
      stop : 73227221,
      direction : "+",
      ID : "ENSG00000135632.12",
      gene_id : "ENSG00000135632.12",
      gene_type : "protein_coding",
      gene_name : "SMYD5",
      gene_level : 1,
      hgnc_id : "HGNC:16258",
      havana_gene : "OTTHUMG00000150482.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73228010,
      stop : 73233239,
      direction : "-",
      ID : "ENSG00000135617.4",
      gene_id : "ENSG00000135617.4",
      gene_type : "protein_coding",
      gene_name : "PRADC1",
      gene_level : 2,
      hgnc_id : "HGNC:16047",
      havana_gene : "OTTHUMG00000129773.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73233420,
      stop : 73253021,
      direction : "+",
      ID : "ENSG00000135624.16",
      gene_id : "ENSG00000135624.16",
      gene_type : "protein_coding",
      gene_name : "CCT7",
      gene_level : 2,
      hgnc_id : "HGNC:1622",
      havana_gene : "OTTHUMG00000152765.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73254682,
      stop : 73284478,
      direction : "-",
      ID : "ENSG00000163013.12",
      gene_id : "ENSG00000163013.12",
      gene_type : "protein_coding",
      gene_name : "FBXO41",
      gene_level : 2,
      hgnc_id : "HGNC:29409",
      havana_gene : "OTTHUMG00000164127.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73290929,
      stop : 73293701,
      direction : "-",
      ID : "ENSG00000135625.8",
      gene_id : "ENSG00000135625.8",
      gene_type : "protein_coding",
      gene_name : "EGR4",
      gene_level : 2,
      hgnc_id : "HGNC:3241",
      havana_gene : "OTTHUMG00000129774.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73385758,
      stop : 73625166,
      direction : "+",
      ID : "ENSG00000116127.19",
      gene_id : "ENSG00000116127.19",
      gene_type : "protein_coding",
      gene_name : "ALMS1",
      gene_level : 1,
      hgnc_id : "HGNC:428",
      havana_gene : "OTTHUMG00000152812.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73640723,
      stop : 73642422,
      direction : "-",
      ID : "ENSG00000144035.4",
      gene_id : "ENSG00000144035.4",
      gene_type : "protein_coding",
      gene_name : "NAT8",
      gene_level : 2,
      hgnc_id : "HGNC:18069",
      havana_gene : "OTTHUMG00000129818.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73729104,
      stop : 73737400,
      direction : "-",
      ID : "ENSG00000144034.16",
      gene_id : "ENSG00000144034.16",
      gene_type : "protein_coding",
      gene_name : "TPRKB",
      gene_level : 2,
      hgnc_id : "HGNC:24259",
      havana_gene : "OTTHUMG00000129815.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73762184,
      stop : 73780157,
      direction : "-",
      ID : "ENSG00000144048.10",
      gene_id : "ENSG00000144048.10",
      gene_type : "protein_coding",
      gene_name : "DUSP11",
      gene_level : 1,
      hgnc_id : "HGNC:3066",
      havana_gene : "OTTHUMG00000129816.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73784189,
      stop : 73817147,
      direction : "+",
      ID : "ENSG00000187833.7",
      gene_id : "ENSG00000187833.7",
      gene_type : "protein_coding",
      gene_name : "C2orf78",
      gene_level : 1,
      hgnc_id : "HGNC:34349",
      havana_gene : "OTTHUMG00000152819.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73828916,
      stop : 73873659,
      direction : "+",
      ID : "ENSG00000124356.16",
      gene_id : "ENSG00000124356.16",
      gene_type : "protein_coding",
      gene_name : "STAMBP",
      gene_level : 1,
      hgnc_id : "HGNC:16950",
      havana_gene : "OTTHUMG00000129817.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73892314,
      stop : 73919865,
      direction : "+",
      ID : "ENSG00000163017.14",
      gene_id : "ENSG00000163017.14",
      gene_type : "protein_coding",
      gene_name : "ACTG2",
      gene_level : 1,
      hgnc_id : "HGNC:145",
      havana_gene : "OTTHUMG00000129813.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73926826,
      stop : 73958961,
      direction : "+",
      ID : "ENSG00000114956.20",
      gene_id : "ENSG00000114956.20",
      gene_type : "protein_coding",
      gene_name : "DGUOK",
      gene_level : 2,
      hgnc_id : "HGNC:2858",
      havana_gene : "OTTHUMG00000129819.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 73984910,
      stop : 74108176,
      direction : "+",
      ID : "ENSG00000187605.16",
      gene_id : "ENSG00000187605.16",
      gene_type : "protein_coding",
      gene_name : "TET3",
      gene_level : 2,
      hgnc_id : "HGNC:28313",
      havana_gene : "OTTHUMG00000152823.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74135400,
      stop : 74147912,
      direction : "-",
      ID : "ENSG00000163170.12",
      gene_id : "ENSG00000163170.12",
      gene_type : "protein_coding",
      gene_name : "BOLA3",
      gene_level : 1,
      hgnc_id : "HGNC:24415",
      havana_gene : "OTTHUMG00000152834.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74152528,
      stop : 74178898,
      direction : "-",
      ID : "ENSG00000114978.18",
      gene_id : "ENSG00000114978.18",
      gene_type : "protein_coding",
      gene_name : "MOB1A",
      gene_level : 2,
      hgnc_id : "HGNC:16015",
      havana_gene : "OTTHUMG00000152833.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74186172,
      stop : 74217565,
      direction : "+",
      ID : "ENSG00000065911.13",
      gene_id : "ENSG00000065911.13",
      gene_type : "protein_coding",
      gene_name : "MTHFD2",
      gene_level : 2,
      hgnc_id : "HGNC:7434",
      havana_gene : "OTTHUMG00000129814.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74211604,
      stop : 74363377,
      direction : "-",
      ID : "ENSG00000264324.1",
      gene_id : "ENSG00000264324.1",
      gene_type : "protein_coding",
      gene_name : "AC006030.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179354.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74216242,
      stop : 74343414,
      direction : "-",
      ID : "ENSG00000188687.17",
      gene_id : "ENSG00000188687.17",
      gene_type : "protein_coding",
      gene_name : "SLC4A5",
      gene_level : 1,
      hgnc_id : "HGNC:18168",
      havana_gene : "OTTHUMG00000090263.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74361154,
      stop : 74392087,
      direction : "-",
      ID : "ENSG00000204843.13",
      gene_id : "ENSG00000204843.13",
      gene_type : "protein_coding",
      gene_name : "DCTN1",
      gene_level : 1,
      hgnc_id : "HGNC:2711",
      havana_gene : "OTTHUMG00000129963.31",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74393836,
      stop : 74421662,
      direction : "-",
      ID : "ENSG00000159239.13",
      gene_id : "ENSG00000159239.13",
      gene_type : "protein_coding",
      gene_name : "AC005041.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191871.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74414176,
      stop : 74421591,
      direction : "-",
      ID : "ENSG00000284308.1",
      gene_id : "ENSG00000284308.1",
      gene_type : "protein_coding",
      gene_name : "C2orf81",
      gene_level : 2,
      hgnc_id : "HGNC:34350",
      havana_gene : "OTTHUMG00000164184.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74421678,
      stop : 74425755,
      direction : "+",
      ID : "ENSG00000005448.17",
      gene_id : "ENSG00000005448.17",
      gene_type : "protein_coding",
      gene_name : "WDR54",
      gene_level : 1,
      hgnc_id : "HGNC:25770",
      havana_gene : "OTTHUMG00000129951.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74425835,
      stop : 74442422,
      direction : "-",
      ID : "ENSG00000114993.17",
      gene_id : "ENSG00000114993.17",
      gene_type : "protein_coding",
      gene_name : "RTKN",
      gene_level : 1,
      hgnc_id : "HGNC:10466",
      havana_gene : "OTTHUMG00000129955.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74455087,
      stop : 74457944,
      direction : "+",
      ID : "ENSG00000115274.15",
      gene_id : "ENSG00000115274.15",
      gene_type : "protein_coding",
      gene_name : "INO80B",
      gene_level : 2,
      hgnc_id : "HGNC:13324",
      havana_gene : "OTTHUMG00000129959.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74455088,
      stop : 74460884,
      direction : "+",
      ID : "ENSG00000274049.4",
      gene_id : "ENSG00000274049.4",
      gene_type : "protein_coding",
      gene_name : "INO80B-WBP1",
      gene_level : 2,
      hgnc_id : "HGNC:49199",
      havana_gene : "OTTHUMG00000187278.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74458400,
      stop : 74460891,
      direction : "+",
      ID : "ENSG00000239779.7",
      gene_id : "ENSG00000239779.7",
      gene_type : "protein_coding",
      gene_name : "WBP1",
      gene_level : 1,
      hgnc_id : "HGNC:12737",
      havana_gene : "OTTHUMG00000129958.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74461057,
      stop : 74465410,
      direction : "-",
      ID : "ENSG00000115275.14",
      gene_id : "ENSG00000115275.14",
      gene_type : "protein_coding",
      gene_name : "MOGS",
      gene_level : 1,
      hgnc_id : "HGNC:24862",
      havana_gene : "OTTHUMG00000152886.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74471982,
      stop : 74472687,
      direction : "-",
      ID : "ENSG00000204822.7",
      gene_id : "ENSG00000204822.7",
      gene_type : "protein_coding",
      gene_name : "MRPL53",
      gene_level : 1,
      hgnc_id : "HGNC:16684",
      havana_gene : "OTTHUMG00000129961.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74471986,
      stop : 74483408,
      direction : "-",
      ID : "ENSG00000135637.14",
      gene_id : "ENSG00000135637.14",
      gene_type : "protein_coding",
      gene_name : "CCDC142",
      gene_level : 2,
      hgnc_id : "HGNC:25889",
      havana_gene : "OTTHUMG00000129962.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74483073,
      stop : 74494559,
      direction : "+",
      ID : "ENSG00000115282.21",
      gene_id : "ENSG00000115282.21",
      gene_type : "protein_coding",
      gene_name : "TTC31",
      gene_level : 2,
      hgnc_id : "HGNC:25759",
      havana_gene : "OTTHUMG00000152887.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74497517,
      stop : 74503316,
      direction : "-",
      ID : "ENSG00000179528.16",
      gene_id : "ENSG00000179528.16",
      gene_type : "protein_coding",
      gene_name : "LBX2",
      gene_level : 1,
      hgnc_id : "HGNC:15525",
      havana_gene : "OTTHUMG00000170595.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74505043,
      stop : 74507695,
      direction : "-",
      ID : "ENSG00000115289.14",
      gene_id : "ENSG00000115289.14",
      gene_type : "protein_coding",
      gene_name : "PCGF1",
      gene_level : 2,
      hgnc_id : "HGNC:17615",
      havana_gene : "OTTHUMG00000129954.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74513463,
      stop : 74517148,
      direction : "+",
      ID : "ENSG00000115297.11",
      gene_id : "ENSG00000115297.11",
      gene_type : "protein_coding",
      gene_name : "TLX2",
      gene_level : 2,
      hgnc_id : "HGNC:5057",
      havana_gene : "OTTHUMG00000129960.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74518131,
      stop : 74526281,
      direction : "-",
      ID : "ENSG00000144045.14",
      gene_id : "ENSG00000144045.14",
      gene_type : "protein_coding",
      gene_name : "DQX1",
      gene_level : 1,
      hgnc_id : "HGNC:20410",
      havana_gene : "OTTHUMG00000129965.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74526645,
      stop : 74529760,
      direction : "-",
      ID : "ENSG00000115307.17",
      gene_id : "ENSG00000115307.17",
      gene_type : "protein_coding",
      gene_name : "AUP1",
      gene_level : 2,
      hgnc_id : "HGNC:891",
      havana_gene : "OTTHUMG00000129964.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74529725,
      stop : 74533332,
      direction : "+",
      ID : "ENSG00000115317.12",
      gene_id : "ENSG00000115317.12",
      gene_type : "protein_coding",
      gene_name : "HTRA2",
      gene_level : 2,
      hgnc_id : "HGNC:14348",
      havana_gene : "OTTHUMG00000129957.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74532258,
      stop : 74555690,
      direction : "-",
      ID : "ENSG00000115318.12",
      gene_id : "ENSG00000115318.12",
      gene_type : "protein_coding",
      gene_name : "LOXL3",
      gene_level : 2,
      hgnc_id : "HGNC:13869",
      havana_gene : "OTTHUMG00000129953.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74549026,
      stop : 74557551,
      direction : "+",
      ID : "ENSG00000115325.14",
      gene_id : "ENSG00000115325.14",
      gene_type : "protein_coding",
      gene_name : "DOK1",
      gene_level : 2,
      hgnc_id : "HGNC:2990",
      havana_gene : "OTTHUMG00000129956.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74557883,
      stop : 74648338,
      direction : "-",
      ID : "ENSG00000159374.17",
      gene_id : "ENSG00000159374.17",
      gene_type : "protein_coding",
      gene_name : "M1AP",
      gene_level : 1,
      hgnc_id : "HGNC:25183",
      havana_gene : "OTTHUMG00000152918.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74654228,
      stop : 74683853,
      direction : "+",
      ID : "ENSG00000135622.13",
      gene_id : "ENSG00000135622.13",
      gene_type : "protein_coding",
      gene_name : "SEMA4F",
      gene_level : 2,
      hgnc_id : "HGNC:10734",
      havana_gene : "OTTHUMG00000129952.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74834127,
      stop : 74893359,
      direction : "+",
      ID : "ENSG00000159399.10",
      gene_id : "ENSG00000159399.10",
      gene_type : "protein_coding",
      gene_name : "HK2",
      gene_level : 1,
      hgnc_id : "HGNC:4923",
      havana_gene : "OTTHUMG00000129972.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 74958643,
      stop : 74970128,
      direction : "+",
      ID : "ENSG00000115350.12",
      gene_id : "ENSG00000115350.12",
      gene_type : "protein_coding",
      gene_name : "POLE4",
      gene_level : 2,
      hgnc_id : "HGNC:18755",
      havana_gene : "OTTHUMG00000129971.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 75046463,
      stop : 75199520,
      direction : "-",
      ID : "ENSG00000115353.11",
      gene_id : "ENSG00000115353.11",
      gene_type : "protein_coding",
      gene_name : "TACR1",
      gene_level : 2,
      hgnc_id : "HGNC:11526",
      havana_gene : "OTTHUMG00000129973.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 75469302,
      stop : 75569722,
      direction : "-",
      ID : "ENSG00000115363.14",
      gene_id : "ENSG00000115363.14",
      gene_type : "protein_coding",
      gene_name : "EVA1A",
      gene_level : 1,
      hgnc_id : "HGNC:25816",
      havana_gene : "OTTHUMG00000129991.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 75646783,
      stop : 75690851,
      direction : "+",
      ID : "ENSG00000115364.14",
      gene_id : "ENSG00000115364.14",
      gene_type : "protein_coding",
      gene_name : "MRPL19",
      gene_level : 1,
      hgnc_id : "HGNC:14052",
      havana_gene : "OTTHUMG00000129990.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 75652000,
      stop : 75710985,
      direction : "-",
      ID : "ENSG00000005436.14",
      gene_id : "ENSG00000005436.14",
      gene_type : "protein_coding",
      gene_name : "GCFC2",
      gene_level : 1,
      hgnc_id : "HGNC:1317",
      havana_gene : "OTTHUMG00000129989.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 76747685,
      stop : 77593319,
      direction : "-",
      ID : "ENSG00000176204.14",
      gene_id : "ENSG00000176204.14",
      gene_type : "protein_coding",
      gene_name : "LRRTM4",
      gene_level : 1,
      hgnc_id : "HGNC:19411",
      havana_gene : "OTTHUMG00000152842.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 79025686,
      stop : 79028505,
      direction : "+",
      ID : "ENSG00000143954.13",
      gene_id : "ENSG00000143954.13",
      gene_type : "protein_coding",
      gene_name : "REG3G",
      gene_level : 1,
      hgnc_id : "HGNC:29595",
      havana_gene : "OTTHUMG00000130018.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 79085023,
      stop : 79088019,
      direction : "-",
      ID : "ENSG00000172023.8",
      gene_id : "ENSG00000172023.8",
      gene_type : "protein_coding",
      gene_name : "REG1B",
      gene_level : 2,
      hgnc_id : "HGNC:9952",
      havana_gene : "OTTHUMG00000130019.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 79120362,
      stop : 79123409,
      direction : "+",
      ID : "ENSG00000115386.6",
      gene_id : "ENSG00000115386.6",
      gene_type : "protein_coding",
      gene_name : "REG1A",
      gene_level : 2,
      hgnc_id : "HGNC:9951",
      havana_gene : "OTTHUMG00000130016.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 79157003,
      stop : 79159753,
      direction : "-",
      ID : "ENSG00000172016.16",
      gene_id : "ENSG00000172016.16",
      gene_type : "protein_coding",
      gene_name : "REG3A",
      gene_level : 2,
      hgnc_id : "HGNC:8601",
      havana_gene : "OTTHUMG00000130017.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 79185231,
      stop : 80648861,
      direction : "+",
      ID : "ENSG00000066032.19",
      gene_id : "ENSG00000066032.19",
      gene_type : "protein_coding",
      gene_name : "CTNNA2",
      gene_level : 1,
      hgnc_id : "HGNC:2510",
      havana_gene : "OTTHUMG00000152903.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 80288351,
      stop : 80304752,
      direction : "-",
      ID : "ENSG00000162951.11",
      gene_id : "ENSG00000162951.11",
      gene_type : "protein_coding",
      gene_name : "LRRTM1",
      gene_level : 2,
      hgnc_id : "HGNC:19408",
      havana_gene : "OTTHUMG00000130021.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 84423528,
      stop : 84460045,
      direction : "-",
      ID : "ENSG00000163541.12",
      gene_id : "ENSG00000163541.12",
      gene_type : "protein_coding",
      gene_name : "SUCLG1",
      gene_level : 2,
      hgnc_id : "HGNC:11449",
      havana_gene : "OTTHUMG00000130023.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 84516455,
      stop : 84819589,
      direction : "+",
      ID : "ENSG00000115423.19",
      gene_id : "ENSG00000115423.19",
      gene_type : "protein_coding",
      gene_name : "DNAH6",
      gene_level : 2,
      hgnc_id : "HGNC:2951",
      havana_gene : "OTTHUMG00000128957.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 84821650,
      stop : 84907008,
      direction : "-",
      ID : "ENSG00000186854.11",
      gene_id : "ENSG00000186854.11",
      gene_type : "protein_coding",
      gene_name : "TRABD2A",
      gene_level : 1,
      hgnc_id : "HGNC:27013",
      havana_gene : "OTTHUMG00000152922.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 84905656,
      stop : 84906671,
      direction : "+",
      ID : "ENSG00000034510.6",
      gene_id : "ENSG00000034510.6",
      gene_type : "protein_coding",
      gene_name : "TMSB10",
      gene_level : 2,
      hgnc_id : "HGNC:11879",
      havana_gene : "OTTHUMG00000130027.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 84971093,
      stop : 85059472,
      direction : "+",
      ID : "ENSG00000176407.18",
      gene_id : "ENSG00000176407.18",
      gene_type : "protein_coding",
      gene_name : "KCMF1",
      gene_level : 1,
      hgnc_id : "HGNC:20589",
      havana_gene : "OTTHUMG00000153004.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85133392,
      stop : 85310387,
      direction : "+",
      ID : "ENSG00000152284.5",
      gene_id : "ENSG00000152284.5",
      gene_type : "protein_coding",
      gene_name : "TCF7L1",
      gene_level : 1,
      hgnc_id : "HGNC:11640",
      havana_gene : "OTTHUMG00000130026.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85318020,
      stop : 85328296,
      direction : "-",
      ID : "ENSG00000152291.14",
      gene_id : "ENSG00000152291.14",
      gene_type : "protein_coding",
      gene_name : "TGOLN2",
      gene_level : 1,
      hgnc_id : "HGNC:15450",
      havana_gene : "OTTHUMG00000153017.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85341955,
      stop : 85354531,
      direction : "-",
      ID : "ENSG00000042445.14",
      gene_id : "ENSG00000042445.14",
      gene_type : "protein_coding",
      gene_name : "RETSAT",
      gene_level : 1,
      hgnc_id : "HGNC:25991",
      havana_gene : "OTTHUMG00000154611.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85354394,
      stop : 85391752,
      direction : "+",
      ID : "ENSG00000115459.18",
      gene_id : "ENSG00000115459.18",
      gene_type : "protein_coding",
      gene_name : "ELMOD3",
      gene_level : 1,
      hgnc_id : "HGNC:26158",
      havana_gene : "OTTHUMG00000130170.17",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85394753,
      stop : 85418432,
      direction : "-",
      ID : "ENSG00000042493.16",
      gene_id : "ENSG00000042493.16",
      gene_type : "protein_coding",
      gene_name : "CAPG",
      gene_level : 1,
      hgnc_id : "HGNC:1474",
      havana_gene : "OTTHUMG00000130183.23",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85418931,
      stop : 85437029,
      direction : "+",
      ID : "ENSG00000152292.17",
      gene_id : "ENSG00000152292.17",
      gene_type : "protein_coding",
      gene_name : "SH2D6",
      gene_level : 2,
      hgnc_id : "HGNC:30439",
      havana_gene : "OTTHUMG00000130176.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85539168,
      stop : 85545281,
      direction : "+",
      ID : "ENSG00000168906.13",
      gene_id : "ENSG00000168906.13",
      gene_type : "protein_coding",
      gene_name : "MAT2A",
      gene_level : 1,
      hgnc_id : "HGNC:6904",
      havana_gene : "OTTHUMG00000130174.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85544720,
      stop : 85561547,
      direction : "-",
      ID : "ENSG00000115486.12",
      gene_id : "ENSG00000115486.12",
      gene_type : "protein_coding",
      gene_name : "GGCX",
      gene_level : 2,
      hgnc_id : "HGNC:4247",
      havana_gene : "OTTHUMG00000130173.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85561562,
      stop : 85582031,
      direction : "+",
      ID : "ENSG00000118640.11",
      gene_id : "ENSG00000118640.11",
      gene_type : "protein_coding",
      gene_name : "VAMP8",
      gene_level : 1,
      hgnc_id : "HGNC:12647",
      havana_gene : "OTTHUMG00000130180.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85584431,
      stop : 85593406,
      direction : "+",
      ID : "ENSG00000168899.5",
      gene_id : "ENSG00000168899.5",
      gene_type : "protein_coding",
      gene_name : "VAMP5",
      gene_level : 2,
      hgnc_id : "HGNC:12646",
      havana_gene : "OTTHUMG00000130169.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85595725,
      stop : 85597708,
      direction : "+",
      ID : "ENSG00000168894.10",
      gene_id : "ENSG00000168894.10",
      gene_type : "protein_coding",
      gene_name : "RNF181",
      gene_level : 1,
      hgnc_id : "HGNC:28037",
      havana_gene : "OTTHUMG00000130182.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85598547,
      stop : 85603196,
      direction : "-",
      ID : "ENSG00000168890.14",
      gene_id : "ENSG00000168890.14",
      gene_type : "protein_coding",
      gene_name : "TMEM150A",
      gene_level : 2,
      hgnc_id : "HGNC:24677",
      havana_gene : "OTTHUMG00000130168.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85602856,
      stop : 85649283,
      direction : "+",
      ID : "ENSG00000168883.20",
      gene_id : "ENSG00000168883.20",
      gene_type : "protein_coding",
      gene_name : "USP39",
      gene_level : 1,
      hgnc_id : "HGNC:20071",
      havana_gene : "OTTHUMG00000153090.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85605254,
      stop : 85612066,
      direction : "-",
      ID : "ENSG00000168887.11",
      gene_id : "ENSG00000168887.11",
      gene_type : "protein_coding",
      gene_name : "C2orf68",
      gene_level : 2,
      hgnc_id : "HGNC:34353",
      havana_gene : "OTTHUMG00000153088.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85657314,
      stop : 85668741,
      direction : "-",
      ID : "ENSG00000168878.19",
      gene_id : "ENSG00000168878.19",
      gene_type : "protein_coding",
      gene_name : "SFTPB",
      gene_level : 2,
      hgnc_id : "HGNC:10801",
      havana_gene : "OTTHUMG00000130181.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85685175,
      stop : 85698852,
      direction : "+",
      ID : "ENSG00000115523.17",
      gene_id : "ENSG00000115523.17",
      gene_type : "protein_coding",
      gene_name : "GNLY",
      gene_level : 1,
      hgnc_id : "HGNC:4414",
      havana_gene : "OTTHUMG00000130179.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85751344,
      stop : 85791383,
      direction : "+",
      ID : "ENSG00000168874.13",
      gene_id : "ENSG00000168874.13",
      gene_type : "protein_coding",
      gene_name : "ATOH8",
      gene_level : 1,
      hgnc_id : "HGNC:24126",
      havana_gene : "OTTHUMG00000130178.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 85837120,
      stop : 85905199,
      direction : "-",
      ID : "ENSG00000115525.18",
      gene_id : "ENSG00000115525.18",
      gene_type : "protein_coding",
      gene_name : "ST3GAL5",
      gene_level : 1,
      hgnc_id : "HGNC:10872",
      havana_gene : "OTTHUMG00000130171.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86020216,
      stop : 86106155,
      direction : "-",
      ID : "ENSG00000068654.16",
      gene_id : "ENSG00000068654.16",
      gene_type : "protein_coding",
      gene_name : "POLR1A",
      gene_level : 1,
      hgnc_id : "HGNC:17264",
      havana_gene : "OTTHUMG00000153165.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86106223,
      stop : 86142157,
      direction : "+",
      ID : "ENSG00000132300.19",
      gene_id : "ENSG00000132300.19",
      gene_type : "protein_coding",
      gene_name : "PTCD3",
      gene_level : 2,
      hgnc_id : "HGNC:24717",
      havana_gene : "OTTHUMG00000153168.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86143932,
      stop : 86195472,
      direction : "-",
      ID : "ENSG00000132305.21",
      gene_id : "ENSG00000132305.21",
      gene_type : "protein_coding",
      gene_name : "IMMT",
      gene_level : 2,
      hgnc_id : "HGNC:6047",
      havana_gene : "OTTHUMG00000153170.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86199355,
      stop : 86213790,
      direction : "+",
      ID : "ENSG00000132313.15",
      gene_id : "ENSG00000132313.15",
      gene_type : "protein_coding",
      gene_name : "MRPL35",
      gene_level : 2,
      hgnc_id : "HGNC:14489",
      havana_gene : "OTTHUMG00000037385.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86213993,
      stop : 86338083,
      direction : "-",
      ID : "ENSG00000068615.19",
      gene_id : "ENSG00000068615.19",
      gene_type : "protein_coding",
      gene_name : "REEP1",
      gene_level : 2,
      hgnc_id : "HGNC:25786",
      havana_gene : "OTTHUMG00000130205.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86440647,
      stop : 86492716,
      direction : "+",
      ID : "ENSG00000115548.17",
      gene_id : "ENSG00000115548.17",
      gene_type : "protein_coding",
      gene_name : "KDM3A",
      gene_level : 1,
      hgnc_id : "HGNC:20815",
      havana_gene : "OTTHUMG00000130204.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86503430,
      stop : 86563479,
      direction : "-",
      ID : "ENSG00000115561.16",
      gene_id : "ENSG00000115561.16",
      gene_type : "protein_coding",
      gene_name : "CHMP3",
      gene_level : 1,
      hgnc_id : "HGNC:29865",
      havana_gene : "OTTHUMG00000153189.27",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86505668,
      stop : 86721122,
      direction : "-",
      ID : "ENSG00000249884.8",
      gene_id : "ENSG00000249884.8",
      gene_type : "protein_coding",
      gene_name : "RNF103-CHMP3",
      gene_level : 2,
      hgnc_id : "HGNC:38847",
      havana_gene : "OTTHUMG00000160822.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86603398,
      stop : 86623866,
      direction : "-",
      ID : "ENSG00000239305.7",
      gene_id : "ENSG00000239305.7",
      gene_type : "protein_coding",
      gene_name : "RNF103",
      gene_level : 2,
      hgnc_id : "HGNC:12859",
      havana_gene : "OTTHUMG00000153197.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86720291,
      stop : 86778041,
      direction : "+",
      ID : "ENSG00000153561.13",
      gene_id : "ENSG00000153561.13",
      gene_type : "protein_coding",
      gene_name : "RMND5A",
      gene_level : 2,
      hgnc_id : "HGNC:25850",
      havana_gene : "OTTHUMG00000130262.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86784610,
      stop : 86808396,
      direction : "-",
      ID : "ENSG00000153563.16",
      gene_id : "ENSG00000153563.16",
      gene_type : "protein_coding",
      gene_name : "CD8A",
      gene_level : 2,
      hgnc_id : "HGNC:1706",
      havana_gene : "OTTHUMG00000130265.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86815339,
      stop : 86861924,
      direction : "-",
      ID : "ENSG00000172116.23",
      gene_id : "ENSG00000172116.23",
      gene_type : "protein_coding",
      gene_name : "CD8B",
      gene_level : 2,
      hgnc_id : "HGNC:1707",
      havana_gene : "OTTHUMG00000130264.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 86907953,
      stop : 87013976,
      direction : "+",
      ID : "ENSG00000187627.17",
      gene_id : "ENSG00000187627.17",
      gene_type : "protein_coding",
      gene_name : "RGPD1",
      gene_level : 2,
      hgnc_id : "HGNC:32414",
      havana_gene : "OTTHUMG00000153248.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 87002559,
      stop : 87021852,
      direction : "-",
      ID : "ENSG00000183281.15",
      gene_id : "ENSG00000183281.15",
      gene_type : "protein_coding",
      gene_name : "PLGLB1",
      gene_level : 2,
      hgnc_id : "HGNC:9072",
      havana_gene : "OTTHUMG00000154612.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 87748087,
      stop : 87759476,
      direction : "+",
      ID : "ENSG00000125551.19",
      gene_id : "ENSG00000125551.19",
      gene_type : "protein_coding",
      gene_name : "PLGLB2",
      gene_level : 2,
      hgnc_id : "HGNC:9073",
      havana_gene : "OTTHUMG00000153273.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 87755960,
      stop : 87825952,
      direction : "-",
      ID : "ENSG00000185304.15",
      gene_id : "ENSG00000185304.15",
      gene_type : "protein_coding",
      gene_name : "RGPD2",
      gene_level : 2,
      hgnc_id : "HGNC:32415",
      havana_gene : "OTTHUMG00000153276.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88027205,
      stop : 88064252,
      direction : "-",
      ID : "ENSG00000172086.9",
      gene_id : "ENSG00000172086.9",
      gene_type : "protein_coding",
      gene_name : "KRCC1",
      gene_level : 2,
      hgnc_id : "HGNC:28039",
      havana_gene : "OTTHUMG00000130315.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88067825,
      stop : 88113384,
      direction : "+",
      ID : "ENSG00000115593.15",
      gene_id : "ENSG00000115593.15",
      gene_type : "protein_coding",
      gene_name : "SMYD1",
      gene_level : 1,
      hgnc_id : "HGNC:20986",
      havana_gene : "OTTHUMG00000155045.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88122982,
      stop : 88128062,
      direction : "-",
      ID : "ENSG00000163586.10",
      gene_id : "ENSG00000163586.10",
      gene_type : "protein_coding",
      gene_name : "FABP1",
      gene_level : 2,
      hgnc_id : "HGNC:3555",
      havana_gene : "OTTHUMG00000130312.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88170295,
      stop : 88186636,
      direction : "+",
      ID : "ENSG00000144115.18",
      gene_id : "ENSG00000144115.18",
      gene_type : "protein_coding",
      gene_name : "THNSL2",
      gene_level : 1,
      hgnc_id : "HGNC:25602",
      havana_gene : "OTTHUMG00000130314.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88446787,
      stop : 88452693,
      direction : "-",
      ID : "ENSG00000214336.5",
      gene_id : "ENSG00000214336.5",
      gene_type : "protein_coding",
      gene_name : "FOXI3",
      gene_level : 2,
      hgnc_id : "HGNC:35123",
      havana_gene : "OTTHUMG00000155048.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88524649,
      stop : 88529585,
      direction : "+",
      ID : "ENSG00000172073.4",
      gene_id : "ENSG00000172073.4",
      gene_type : "protein_coding",
      gene_name : "TEX37",
      gene_level : 2,
      hgnc_id : "HGNC:26341",
      havana_gene : "OTTHUMG00000130332.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88556741,
      stop : 88627464,
      direction : "-",
      ID : "ENSG00000172071.14",
      gene_id : "ENSG00000172071.14",
      gene_type : "protein_coding",
      gene_name : "EIF2AK3",
      gene_level : 1,
      hgnc_id : "HGNC:3255",
      havana_gene : "OTTHUMG00000155046.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 88691673,
      stop : 88750929,
      direction : "+",
      ID : "ENSG00000153574.9",
      gene_id : "ENSG00000153574.9",
      gene_type : "protein_coding",
      gene_name : "RPIA",
      gene_level : 2,
      hgnc_id : "HGNC:10297",
      havana_gene : "OTTHUMG00000130333.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 94588522,
      stop : 94604573,
      direction : "+",
      ID : "ENSG00000259916.1",
      gene_id : "ENSG00000259916.1",
      gene_type : "protein_coding",
      gene_name : "AL845331.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000175552.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 94871430,
      stop : 94876823,
      direction : "+",
      ID : "ENSG00000163060.8",
      gene_id : "ENSG00000163060.8",
      gene_type : "protein_coding",
      gene_name : "TEKT4",
      gene_level : 2,
      hgnc_id : "HGNC:31012",
      havana_gene : "OTTHUMG00000130396.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95025677,
      stop : 95053992,
      direction : "+",
      ID : "ENSG00000172005.11",
      gene_id : "ENSG00000172005.11",
      gene_type : "protein_coding",
      gene_name : "MAL",
      gene_level : 2,
      hgnc_id : "HGNC:6817",
      havana_gene : "OTTHUMG00000132011.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95085369,
      stop : 95149434,
      direction : "-",
      ID : "ENSG00000144029.12",
      gene_id : "ENSG00000144029.12",
      gene_type : "protein_coding",
      gene_name : "MRPS5",
      gene_level : 2,
      hgnc_id : "HGNC:14498",
      havana_gene : "OTTHUMG00000130394.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95145000,
      stop : 95165413,
      direction : "-",
      ID : "ENSG00000144026.12",
      gene_id : "ENSG00000144026.12",
      gene_type : "protein_coding",
      gene_name : "ZNF514",
      gene_level : 2,
      hgnc_id : "HGNC:25894",
      havana_gene : "OTTHUMG00000130391.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95165432,
      stop : 95184317,
      direction : "+",
      ID : "ENSG00000275111.5",
      gene_id : "ENSG00000275111.5",
      gene_type : "protein_coding",
      gene_name : "ZNF2",
      gene_level : 2,
      hgnc_id : "HGNC:12991",
      havana_gene : "OTTHUMG00000155150.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95207535,
      stop : 95259774,
      direction : "+",
      ID : "ENSG00000233757.6",
      gene_id : "ENSG00000233757.6",
      gene_type : "protein_coding",
      gene_name : "AC092835.1",
      gene_level : 1,
      hgnc_id : "havana_gene=OTTHUMG00000155176.5",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95274449,
      stop : 95291308,
      direction : "+",
      ID : "ENSG00000155066.16",
      gene_id : "ENSG00000155066.16",
      gene_type : "protein_coding",
      gene_name : "PROM2",
      gene_level : 2,
      hgnc_id : "HGNC:20685",
      havana_gene : "OTTHUMG00000130393.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95297327,
      stop : 95386077,
      direction : "+",
      ID : "ENSG00000115041.13",
      gene_id : "ENSG00000115041.13",
      gene_type : "protein_coding",
      gene_name : "KCNIP3",
      gene_level : 2,
      hgnc_id : "HGNC:15523",
      havana_gene : "OTTHUMG00000130392.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95402708,
      stop : 95416616,
      direction : "+",
      ID : "ENSG00000115042.10",
      gene_id : "ENSG00000115042.10",
      gene_type : "protein_coding",
      gene_name : "FAHD2A",
      gene_level : 2,
      hgnc_id : "HGNC:24252",
      havana_gene : "OTTHUMG00000130397.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95477164,
      stop : 95484731,
      direction : "-",
      ID : "ENSG00000144010.10",
      gene_id : "ENSG00000144010.10",
      gene_type : "protein_coding",
      gene_name : "TRIM43B",
      gene_level : 2,
      hgnc_id : "HGNC:37146",
      havana_gene : "OTTHUMG00000155170.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95592001,
      stop : 95599778,
      direction : "+",
      ID : "ENSG00000144015.5",
      gene_id : "ENSG00000144015.5",
      gene_type : "protein_coding",
      gene_name : "TRIM43",
      gene_level : 2,
      hgnc_id : "HGNC:19015",
      havana_gene : "OTTHUMG00000130401.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 95836919,
      stop : 95991831,
      direction : "-",
      ID : "ENSG00000174501.14",
      gene_id : "ENSG00000174501.14",
      gene_type : "protein_coding",
      gene_name : "ANKRD36C",
      gene_level : 2,
      hgnc_id : "HGNC:32946",
      havana_gene : "OTTHUMG00000155211.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96021946,
      stop : 96039451,
      direction : "-",
      ID : "ENSG00000186281.12",
      gene_id : "ENSG00000186281.12",
      gene_type : "protein_coding",
      gene_name : "GPAT2",
      gene_level : 1,
      hgnc_id : "HGNC:27168",
      havana_gene : "OTTHUMG00000155208.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96112876,
      stop : 96116571,
      direction : "-",
      ID : "ENSG00000274286.2",
      gene_id : "ENSG00000274286.2",
      gene_type : "protein_coding",
      gene_name : "ADRA2B",
      gene_level : 2,
      hgnc_id : "HGNC:282",
      havana_gene : "OTTHUMG00000188276.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96123850,
      stop : 96138436,
      direction : "-",
      ID : "ENSG00000188886.3",
      gene_id : "ENSG00000188886.3",
      gene_type : "protein_coding",
      gene_name : "ASTL",
      gene_level : 2,
      hgnc_id : "HGNC:31704",
      havana_gene : "OTTHUMG00000155212.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96143169,
      stop : 96145440,
      direction : "-",
      ID : "ENSG00000158050.5",
      gene_id : "ENSG00000158050.5",
      gene_type : "protein_coding",
      gene_name : "DUSP2",
      gene_level : 2,
      hgnc_id : "HGNC:3068",
      havana_gene : "OTTHUMG00000130456.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96184859,
      stop : 96208827,
      direction : "-",
      ID : "ENSG00000084090.14",
      gene_id : "ENSG00000084090.14",
      gene_type : "protein_coding",
      gene_name : "STARD7",
      gene_level : 1,
      hgnc_id : "HGNC:18063",
      havana_gene : "OTTHUMG00000130457.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96248514,
      stop : 96265997,
      direction : "-",
      ID : "ENSG00000135956.9",
      gene_id : "ENSG00000135956.9",
      gene_type : "protein_coding",
      gene_name : "TMEM127",
      gene_level : 1,
      hgnc_id : "HGNC:26038",
      havana_gene : "OTTHUMG00000130454.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96266159,
      stop : 96274173,
      direction : "+",
      ID : "ENSG00000144021.3",
      gene_id : "ENSG00000144021.3",
      gene_type : "protein_coding",
      gene_name : "CIAO1",
      gene_level : 2,
      hgnc_id : "HGNC:14280",
      havana_gene : "OTTHUMG00000130452.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96274338,
      stop : 96321271,
      direction : "-",
      ID : "ENSG00000144028.15",
      gene_id : "ENSG00000144028.15",
      gene_type : "protein_coding",
      gene_name : "SNRNP200",
      gene_level : 2,
      hgnc_id : "HGNC:30859",
      havana_gene : "OTTHUMG00000130455.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96325317,
      stop : 96330517,
      direction : "+",
      ID : "ENSG00000198885.10",
      gene_id : "ENSG00000198885.10",
      gene_type : "protein_coding",
      gene_name : "ITPRIPL1",
      gene_level : 2,
      hgnc_id : "HGNC:29371",
      havana_gene : "OTTHUMG00000155230.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96335766,
      stop : 96377091,
      direction : "+",
      ID : "ENSG00000121152.10",
      gene_id : "ENSG00000121152.10",
      gene_type : "protein_coding",
      gene_name : "NCAPH",
      gene_level : 1,
      hgnc_id : "HGNC:1112",
      havana_gene : "OTTHUMG00000130451.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96497646,
      stop : 96508109,
      direction : "-",
      ID : "ENSG00000163121.10",
      gene_id : "ENSG00000163121.10",
      gene_type : "protein_coding",
      gene_name : "NEURL3",
      gene_level : 2,
      hgnc_id : "HGNC:25162",
      havana_gene : "OTTHUMG00000128645.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96536743,
      stop : 96552634,
      direction : "+",
      ID : "ENSG00000196843.17",
      gene_id : "ENSG00000196843.17",
      gene_type : "protein_coding",
      gene_name : "ARID5A",
      gene_level : 1,
      hgnc_id : "HGNC:17361",
      havana_gene : "OTTHUMG00000155229.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96593170,
      stop : 96642787,
      direction : "-",
      ID : "ENSG00000114982.19",
      gene_id : "ENSG00000114982.19",
      gene_type : "protein_coding",
      gene_name : "KANSL3",
      gene_level : 1,
      hgnc_id : "HGNC:25473",
      havana_gene : "OTTHUMG00000155249.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96642737,
      stop : 96704887,
      direction : "+",
      ID : "ENSG00000249715.13",
      gene_id : "ENSG00000249715.13",
      gene_type : "protein_coding",
      gene_name : "FER1L5",
      gene_level : 1,
      hgnc_id : "HGNC:19044",
      havana_gene : "OTTHUMG00000154929.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96705929,
      stop : 96740064,
      direction : "-",
      ID : "ENSG00000114988.12",
      gene_id : "ENSG00000114988.12",
      gene_type : "protein_coding",
      gene_name : "LMAN2L",
      gene_level : 2,
      hgnc_id : "HGNC:19263",
      havana_gene : "OTTHUMG00000130453.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96760902,
      stop : 96811874,
      direction : "+",
      ID : "ENSG00000158158.12",
      gene_id : "ENSG00000158158.12",
      gene_type : "protein_coding",
      gene_name : "CNNM4",
      gene_level : 2,
      hgnc_id : "HGNC:105",
      havana_gene : "OTTHUMG00000130532.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96816245,
      stop : 96835382,
      direction : "+",
      ID : "ENSG00000168763.16",
      gene_id : "ENSG00000168763.16",
      gene_type : "protein_coding",
      gene_name : "CNNM3",
      gene_level : 2,
      hgnc_id : "HGNC:104",
      havana_gene : "OTTHUMG00000130531.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96824526,
      stop : 96857934,
      direction : "-",
      ID : "ENSG00000163126.15",
      gene_id : "ENSG00000163126.15",
      gene_type : "protein_coding",
      gene_name : "ANKRD23",
      gene_level : 2,
      hgnc_id : "HGNC:24470",
      havana_gene : "OTTHUMG00000130534.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96836611,
      stop : 96858016,
      direction : "-",
      ID : "ENSG00000213337.9",
      gene_id : "ENSG00000213337.9",
      gene_type : "protein_coding",
      gene_name : "ANKRD39",
      gene_level : 2,
      hgnc_id : "HGNC:28640",
      havana_gene : "OTTHUMG00000130530.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96859718,
      stop : 96870757,
      direction : "-",
      ID : "ENSG00000168758.11",
      gene_id : "ENSG00000168758.11",
      gene_type : "protein_coding",
      gene_name : "SEMA4C",
      gene_level : 2,
      hgnc_id : "HGNC:10731",
      havana_gene : "OTTHUMG00000130535.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 96875882,
      stop : 96986580,
      direction : "-",
      ID : "ENSG00000168754.15",
      gene_id : "ENSG00000168754.15",
      gene_type : "protein_coding",
      gene_name : "FAM178B",
      gene_level : 2,
      hgnc_id : "HGNC:28036",
      havana_gene : "OTTHUMG00000155257.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97083583,
      stop : 97094882,
      direction : "-",
      ID : "ENSG00000144199.12",
      gene_id : "ENSG00000144199.12",
      gene_type : "protein_coding",
      gene_name : "FAHD2B",
      gene_level : 2,
      hgnc_id : "HGNC:25318",
      havana_gene : "OTTHUMG00000130533.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97113153,
      stop : 97264521,
      direction : "+",
      ID : "ENSG00000135976.20",
      gene_id : "ENSG00000135976.20",
      gene_type : "protein_coding",
      gene_name : "ANKRD36",
      gene_level : 1,
      hgnc_id : "HGNC:24079",
      havana_gene : "OTTHUMG00000155256.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97492663,
      stop : 97589965,
      direction : "-",
      ID : "ENSG00000196912.12",
      gene_id : "ENSG00000196912.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD36B",
      gene_level : 2,
      hgnc_id : "HGNC:29333",
      havana_gene : "OTTHUMG00000130547.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97646062,
      stop : 97648383,
      direction : "+",
      ID : "ENSG00000135940.7",
      gene_id : "ENSG00000135940.7",
      gene_type : "protein_coding",
      gene_name : "COX5B",
      gene_level : 2,
      hgnc_id : "HGNC:2269",
      havana_gene : "OTTHUMG00000130548.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97655939,
      stop : 97664044,
      direction : "-",
      ID : "ENSG00000115073.8",
      gene_id : "ENSG00000115073.8",
      gene_type : "protein_coding",
      gene_name : "ACTR1B",
      gene_level : 2,
      hgnc_id : "HGNC:168",
      havana_gene : "OTTHUMG00000130549.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97664217,
      stop : 97703064,
      direction : "+",
      ID : "ENSG00000228486.10",
      gene_id : "ENSG00000228486.10",
      gene_type : "protein_coding",
      gene_name : "C2orf92",
      gene_level : 1,
      hgnc_id : "HGNC:49272",
      havana_gene : "OTTHUMG00000153062.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97713576,
      stop : 97739862,
      direction : "+",
      ID : "ENSG00000115085.14",
      gene_id : "ENSG00000115085.14",
      gene_type : "protein_coding",
      gene_name : "ZAP70",
      gene_level : 2,
      hgnc_id : "HGNC:12858",
      havana_gene : "OTTHUMG00000153060.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 97756333,
      stop : 97995948,
      direction : "-",
      ID : "ENSG00000075568.17",
      gene_id : "ENSG00000075568.17",
      gene_type : "protein_coding",
      gene_name : "TMEM131",
      gene_level : 1,
      hgnc_id : "HGNC:30366",
      havana_gene : "OTTHUMG00000153061.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98087116,
      stop : 98313299,
      direction : "+",
      ID : "ENSG00000168658.19",
      gene_id : "ENSG00000168658.19",
      gene_type : "protein_coding",
      gene_name : "VWA3B",
      gene_level : 2,
      hgnc_id : "HGNC:28385",
      havana_gene : "OTTHUMG00000153104.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98346188,
      stop : 98398601,
      direction : "+",
      ID : "ENSG00000144191.12",
      gene_id : "ENSG00000144191.12",
      gene_type : "protein_coding",
      gene_name : "CNGA3",
      gene_level : 1,
      hgnc_id : "HGNC:2150",
      havana_gene : "OTTHUMG00000130561.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98444854,
      stop : 98594392,
      direction : "+",
      ID : "ENSG00000040933.16",
      gene_id : "ENSG00000040933.16",
      gene_type : "protein_coding",
      gene_name : "INPP4A",
      gene_level : 2,
      hgnc_id : "HGNC:6074",
      havana_gene : "OTTHUMG00000153106.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98599314,
      stop : 98608515,
      direction : "-",
      ID : "ENSG00000183513.9",
      gene_id : "ENSG00000183513.9",
      gene_type : "protein_coding",
      gene_name : "COA5",
      gene_level : 2,
      hgnc_id : "HGNC:33848",
      havana_gene : "OTTHUMG00000153101.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98608579,
      stop : 98618515,
      direction : "+",
      ID : "ENSG00000115446.12",
      gene_id : "ENSG00000115446.12",
      gene_type : "protein_coding",
      gene_name : "UNC50",
      gene_level : 1,
      hgnc_id : "HGNC:16046",
      havana_gene : "OTTHUMG00000130562.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98619106,
      stop : 98731132,
      direction : "-",
      ID : "ENSG00000071073.13",
      gene_id : "ENSG00000071073.13",
      gene_type : "protein_coding",
      gene_name : "MGAT4A",
      gene_level : 2,
      hgnc_id : "HGNC:7047",
      havana_gene : "OTTHUMG00000130563.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98793846,
      stop : 98936259,
      direction : "-",
      ID : "ENSG00000196872.12",
      gene_id : "ENSG00000196872.12",
      gene_type : "protein_coding",
      gene_name : "CRACDL",
      gene_level : 1,
      hgnc_id : "HGNC:33454",
      havana_gene : "OTTHUMG00000153171.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 98997261,
      stop : 99154964,
      direction : "-",
      ID : "ENSG00000135951.16",
      gene_id : "ENSG00000135951.16",
      gene_type : "protein_coding",
      gene_name : "TSGA10",
      gene_level : 2,
      hgnc_id : "HGNC:14927",
      havana_gene : "OTTHUMG00000130637.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99141485,
      stop : 99322741,
      direction : "+",
      ID : "ENSG00000241962.9",
      gene_id : "ENSG00000241962.9",
      gene_type : "protein_coding",
      gene_name : "AC079447.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186049.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99141707,
      stop : 99151669,
      direction : "+",
      ID : "ENSG00000273045.7",
      gene_id : "ENSG00000273045.7",
      gene_type : "protein_coding",
      gene_name : "C2orf15",
      gene_level : 2,
      hgnc_id : "HGNC:28436",
      havana_gene : "OTTHUMG00000130635.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99154955,
      stop : 99163157,
      direction : "+",
      ID : "ENSG00000144182.17",
      gene_id : "ENSG00000144182.17",
      gene_type : "protein_coding",
      gene_name : "LIPT1",
      gene_level : 2,
      hgnc_id : "HGNC:29569",
      havana_gene : "OTTHUMG00000130640.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99154998,
      stop : 99195298,
      direction : "+",
      ID : "ENSG00000273155.1",
      gene_id : "ENSG00000273155.1",
      gene_type : "protein_coding",
      gene_name : "AC092587.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186443.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99161427,
      stop : 99181058,
      direction : "-",
      ID : "ENSG00000158411.11",
      gene_id : "ENSG00000158411.11",
      gene_type : "protein_coding",
      gene_name : "MITD1",
      gene_level : 2,
      hgnc_id : "HGNC:25207",
      havana_gene : "OTTHUMG00000130638.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99181152,
      stop : 99199561,
      direction : "+",
      ID : "ENSG00000185414.20",
      gene_id : "ENSG00000185414.20",
      gene_type : "protein_coding",
      gene_name : "MRPL30",
      gene_level : 2,
      hgnc_id : "HGNC:14036",
      havana_gene : "OTTHUMG00000130642.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99242246,
      stop : 99255282,
      direction : "-",
      ID : "ENSG00000185674.9",
      gene_id : "ENSG00000185674.9",
      gene_type : "protein_coding",
      gene_name : "LYG2",
      gene_level : 2,
      hgnc_id : "HGNC:29615",
      havana_gene : "OTTHUMG00000130643.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99284238,
      stop : 99304742,
      direction : "-",
      ID : "ENSG00000144214.10",
      gene_id : "ENSG00000144214.10",
      gene_type : "protein_coding",
      gene_name : "LYG1",
      gene_level : 2,
      hgnc_id : "HGNC:27014",
      havana_gene : "OTTHUMG00000130639.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99318982,
      stop : 99340702,
      direction : "-",
      ID : "ENSG00000115514.12",
      gene_id : "ENSG00000115514.12",
      gene_type : "protein_coding",
      gene_name : "TXNDC9",
      gene_level : 1,
      hgnc_id : "HGNC:24110",
      havana_gene : "OTTHUMG00000130641.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99337371,
      stop : 99401326,
      direction : "+",
      ID : "ENSG00000158417.11",
      gene_id : "ENSG00000158417.11",
      gene_type : "protein_coding",
      gene_name : "EIF5B",
      gene_level : 2,
      hgnc_id : "HGNC:30793",
      havana_gene : "OTTHUMG00000153242.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99400475,
      stop : 99490035,
      direction : "-",
      ID : "ENSG00000135945.10",
      gene_id : "ENSG00000135945.10",
      gene_type : "protein_coding",
      gene_name : "REV1",
      gene_level : 2,
      hgnc_id : "HGNC:14060",
      havana_gene : "OTTHUMG00000130636.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 99545419,
      stop : 100192428,
      direction : "-",
      ID : "ENSG00000144218.20",
      gene_id : "ENSG00000144218.20",
      gene_type : "protein_coding",
      gene_name : "AFF3",
      gene_level : 2,
      hgnc_id : "HGNC:6473",
      havana_gene : "OTTHUMG00000153011.13",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 100271875,
      stop : 100322501,
      direction : "-",
      ID : "ENSG00000170500.13",
      gene_id : "ENSG00000170500.13",
      gene_type : "protein_coding",
      gene_name : "LONRF2",
      gene_level : 2,
      hgnc_id : "HGNC:24788",
      havana_gene : "OTTHUMG00000130668.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 100391860,
      stop : 100417668,
      direction : "-",
      ID : "ENSG00000115526.11",
      gene_id : "ENSG00000115526.11",
      gene_type : "protein_coding",
      gene_name : "CHST10",
      gene_level : 2,
      hgnc_id : "HGNC:19650",
      havana_gene : "OTTHUMG00000130669.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 100470482,
      stop : 100483280,
      direction : "+",
      ID : "ENSG00000204640.1",
      gene_id : "ENSG00000204640.1",
      gene_type : "protein_coding",
      gene_name : "NMS",
      gene_level : 2,
      hgnc_id : "HGNC:32203",
      havana_gene : "OTTHUMG00000153142.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 100562993,
      stop : 100576739,
      direction : "+",
      ID : "ENSG00000115539.14",
      gene_id : "ENSG00000115539.14",
      gene_type : "protein_coding",
      gene_name : "PDCL3",
      gene_level : 1,
      hgnc_id : "HGNC:28860",
      havana_gene : "OTTHUMG00000153141.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 100820139,
      stop : 100996829,
      direction : "+",
      ID : "ENSG00000170485.17",
      gene_id : "ENSG00000170485.17",
      gene_type : "protein_coding",
      gene_name : "NPAS2",
      gene_level : 1,
      hgnc_id : "HGNC:7895",
      havana_gene : "OTTHUMG00000130675.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101002229,
      stop : 101024032,
      direction : "+",
      ID : "ENSG00000071082.11",
      gene_id : "ENSG00000071082.11",
      gene_type : "protein_coding",
      gene_name : "RPL31",
      gene_level : 1,
      hgnc_id : "HGNC:10334",
      havana_gene : "OTTHUMG00000130687.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101007228,
      stop : 101252866,
      direction : "-",
      ID : "ENSG00000204634.13",
      gene_id : "ENSG00000204634.13",
      gene_type : "protein_coding",
      gene_name : "TBC1D8",
      gene_level : 2,
      hgnc_id : "HGNC:17791",
      havana_gene : "OTTHUMG00000153040.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101252886,
      stop : 101270316,
      direction : "+",
      ID : "ENSG00000158435.8",
      gene_id : "ENSG00000158435.8",
      gene_type : "protein_coding",
      gene_name : "CNOT11",
      gene_level : 2,
      hgnc_id : "HGNC:25217",
      havana_gene : "OTTHUMG00000130686.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101271219,
      stop : 101308701,
      direction : "-",
      ID : "ENSG00000163162.9",
      gene_id : "ENSG00000163162.9",
      gene_type : "protein_coding",
      gene_name : "RNF149",
      gene_level : 1,
      hgnc_id : "HGNC:23137",
      havana_gene : "OTTHUMG00000130685.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101345550,
      stop : 101387503,
      direction : "-",
      ID : "ENSG00000175874.10",
      gene_id : "ENSG00000175874.10",
      gene_type : "protein_coding",
      gene_name : "CREG2",
      gene_level : 2,
      hgnc_id : "HGNC:14272",
      havana_gene : "OTTHUMG00000130692.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101397359,
      stop : 101475112,
      direction : "-",
      ID : "ENSG00000196460.14",
      gene_id : "ENSG00000196460.14",
      gene_type : "protein_coding",
      gene_name : "RFX8",
      gene_level : 2,
      hgnc_id : "HGNC:37253",
      havana_gene : "OTTHUMG00000130693.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101696850,
      stop : 101894689,
      direction : "+",
      ID : "ENSG00000071054.16",
      gene_id : "ENSG00000071054.16",
      gene_type : "protein_coding",
      gene_name : "MAP4K4",
      gene_level : 2,
      hgnc_id : "HGNC:6866",
      havana_gene : "OTTHUMG00000155394.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 101991960,
      stop : 102028544,
      direction : "+",
      ID : "ENSG00000115590.14",
      gene_id : "ENSG00000115590.14",
      gene_type : "protein_coding",
      gene_name : "IL1R2",
      gene_level : 2,
      hgnc_id : "HGNC:5994",
      havana_gene : "OTTHUMG00000130695.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102064544,
      stop : 102179874,
      direction : "+",
      ID : "ENSG00000115594.12",
      gene_id : "ENSG00000115594.12",
      gene_type : "protein_coding",
      gene_name : "IL1R1",
      gene_level : 1,
      hgnc_id : "HGNC:5993",
      havana_gene : "OTTHUMG00000130783.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102187006,
      stop : 102240002,
      direction : "+",
      ID : "ENSG00000115598.10",
      gene_id : "ENSG00000115598.10",
      gene_type : "protein_coding",
      gene_name : "IL1RL2",
      gene_level : 2,
      hgnc_id : "HGNC:5999",
      havana_gene : "OTTHUMG00000130776.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102311502,
      stop : 102352037,
      direction : "+",
      ID : "ENSG00000115602.17",
      gene_id : "ENSG00000115602.17",
      gene_type : "protein_coding",
      gene_name : "IL1RL1",
      gene_level : 2,
      hgnc_id : "HGNC:5998",
      havana_gene : "OTTHUMG00000130782.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102311529,
      stop : 102398777,
      direction : "+",
      ID : "ENSG00000115604.12",
      gene_id : "ENSG00000115604.12",
      gene_type : "protein_coding",
      gene_name : "IL18R1",
      gene_level : 2,
      hgnc_id : "HGNC:5988",
      havana_gene : "OTTHUMG00000130780.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102418689,
      stop : 102452565,
      direction : "+",
      ID : "ENSG00000115607.9",
      gene_id : "ENSG00000115607.9",
      gene_type : "protein_coding",
      gene_name : "IL18RAP",
      gene_level : 1,
      hgnc_id : "HGNC:5989",
      havana_gene : "OTTHUMG00000130777.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102473226,
      stop : 102533972,
      direction : "+",
      ID : "ENSG00000180251.5",
      gene_id : "ENSG00000180251.5",
      gene_type : "protein_coding",
      gene_name : "SLC9A4",
      gene_level : 2,
      hgnc_id : "HGNC:11077",
      havana_gene : "OTTHUMG00000153093.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102619553,
      stop : 102711355,
      direction : "+",
      ID : "ENSG00000115616.3",
      gene_id : "ENSG00000115616.3",
      gene_type : "protein_coding",
      gene_name : "SLC9A2",
      gene_level : 2,
      hgnc_id : "HGNC:11072",
      havana_gene : "OTTHUMG00000130778.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102714630,
      stop : 102736888,
      direction : "-",
      ID : "ENSG00000135953.11",
      gene_id : "ENSG00000135953.11",
      gene_type : "protein_coding",
      gene_name : "MFSD9",
      gene_level : 1,
      hgnc_id : "HGNC:28158",
      havana_gene : "OTTHUMG00000130781.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 102736905,
      stop : 103019900,
      direction : "+",
      ID : "ENSG00000170417.16",
      gene_id : "ENSG00000170417.16",
      gene_type : "protein_coding",
      gene_name : "TMEM182",
      gene_level : 1,
      hgnc_id : "HGNC:26391",
      havana_gene : "OTTHUMG00000130779.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 104853287,
      stop : 104858574,
      direction : "+",
      ID : "ENSG00000198914.5",
      gene_id : "ENSG00000198914.5",
      gene_type : "protein_coding",
      gene_name : "POU3F3",
      gene_level : 2,
      hgnc_id : "HGNC:9216",
      havana_gene : "OTTHUMG00000153067.5",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 105038069,
      stop : 105099960,
      direction : "+",
      ID : "ENSG00000135972.9",
      gene_id : "ENSG00000135972.9",
      gene_type : "protein_coding",
      gene_name : "MRPS9",
      gene_level : 2,
      hgnc_id : "HGNC:14501",
      havana_gene : "OTTHUMG00000130807.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 105241743,
      stop : 105243467,
      direction : "+",
      ID : "ENSG00000135973.3",
      gene_id : "ENSG00000135973.3",
      gene_type : "protein_coding",
      gene_name : "GPR45",
      gene_level : 2,
      hgnc_id : "HGNC:4503",
      havana_gene : "OTTHUMG00000130805.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 105264391,
      stop : 105329735,
      direction : "-",
      ID : "ENSG00000135966.13",
      gene_id : "ENSG00000135966.13",
      gene_type : "protein_coding",
      gene_name : "TGFBRAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16836",
      havana_gene : "OTTHUMG00000130809.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 105337532,
      stop : 105349211,
      direction : "+",
      ID : "ENSG00000135974.10",
      gene_id : "ENSG00000135974.10",
      gene_type : "protein_coding",
      gene_name : "C2orf49",
      gene_level : 2,
      hgnc_id : "HGNC:28772",
      havana_gene : "OTTHUMG00000130808.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 105357712,
      stop : 105438513,
      direction : "-",
      ID : "ENSG00000115641.19",
      gene_id : "ENSG00000115641.19",
      gene_type : "protein_coding",
      gene_name : "FHL2",
      gene_level : 2,
      hgnc_id : "HGNC:3703",
      havana_gene : "OTTHUMG00000153120.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 105744912,
      stop : 105894274,
      direction : "+",
      ID : "ENSG00000071051.14",
      gene_id : "ENSG00000071051.14",
      gene_type : "protein_coding",
      gene_name : "NCK2",
      gene_level : 2,
      hgnc_id : "HGNC:7665",
      havana_gene : "OTTHUMG00000153116.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 106063246,
      stop : 106078155,
      direction : "+",
      ID : "ENSG00000119147.10",
      gene_id : "ENSG00000119147.10",
      gene_type : "protein_coding",
      gene_name : "ECRG4",
      gene_level : 1,
      hgnc_id : "HGNC:24642",
      havana_gene : "OTTHUMG00000130921.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 106093308,
      stop : 106194301,
      direction : "-",
      ID : "ENSG00000115652.15",
      gene_id : "ENSG00000115652.15",
      gene_type : "protein_coding",
      gene_name : "UXS1",
      gene_level : 2,
      hgnc_id : "HGNC:17729",
      havana_gene : "OTTHUMG00000153150.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 106391290,
      stop : 106468413,
      direction : "-",
      ID : "ENSG00000153165.19",
      gene_id : "ENSG00000153165.19",
      gene_type : "protein_coding",
      gene_name : "RGPD3",
      gene_level : 2,
      hgnc_id : "HGNC:32416",
      havana_gene : "OTTHUMG00000153182.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 106487364,
      stop : 106544297,
      direction : "+",
      ID : "ENSG00000254126.8",
      gene_id : "ENSG00000254126.8",
      gene_type : "protein_coding",
      gene_name : "CD8B2",
      gene_level : 2,
      hgnc_id : "HGNC:1708",
      havana_gene : "OTTHUMG00000153183.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 106801600,
      stop : 106887108,
      direction : "-",
      ID : "ENSG00000144057.15",
      gene_id : "ENSG00000144057.15",
      gene_type : "protein_coding",
      gene_name : "ST6GAL2",
      gene_level : 2,
      hgnc_id : "HGNC:10861",
      havana_gene : "OTTHUMG00000130923.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 107826892,
      stop : 107892544,
      direction : "+",
      ID : "ENSG00000196862.10",
      gene_id : "ENSG00000196862.10",
      gene_type : "protein_coding",
      gene_name : "RGPD4",
      gene_level : 2,
      hgnc_id : "HGNC:32417",
      havana_gene : "OTTHUMG00000153208.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 107986523,
      stop : 108013994,
      direction : "+",
      ID : "ENSG00000115665.9",
      gene_id : "ENSG00000115665.9",
      gene_type : "protein_coding",
      gene_name : "SLC5A7",
      gene_level : 2,
      hgnc_id : "HGNC:14025",
      havana_gene : "OTTHUMG00000130959.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108239971,
      stop : 108265351,
      direction : "+",
      ID : "ENSG00000196228.4",
      gene_id : "ENSG00000196228.4",
      gene_type : "protein_coding",
      gene_name : "SULT1C3",
      gene_level : 2,
      hgnc_id : "HGNC:33543",
      havana_gene : "OTTHUMG00000153227.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108288639,
      stop : 108309915,
      direction : "+",
      ID : "ENSG00000198203.10",
      gene_id : "ENSG00000198203.10",
      gene_type : "protein_coding",
      gene_name : "SULT1C2",
      gene_level : 1,
      hgnc_id : "HGNC:11456",
      havana_gene : "OTTHUMG00000153215.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108377911,
      stop : 108388989,
      direction : "+",
      ID : "ENSG00000198075.10",
      gene_id : "ENSG00000198075.10",
      gene_type : "protein_coding",
      gene_name : "SULT1C4",
      gene_level : 2,
      hgnc_id : "HGNC:11457",
      havana_gene : "OTTHUMG00000130958.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108449191,
      stop : 108509415,
      direction : "+",
      ID : "ENSG00000135968.21",
      gene_id : "ENSG00000135968.21",
      gene_type : "protein_coding",
      gene_name : "GCC2",
      gene_level : 2,
      hgnc_id : "HGNC:23218",
      havana_gene : "OTTHUMG00000153214.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108534355,
      stop : 108687246,
      direction : "+",
      ID : "ENSG00000169756.16",
      gene_id : "ENSG00000169756.16",
      gene_type : "protein_coding",
      gene_name : "LIMS1",
      gene_level : 2,
      hgnc_id : "HGNC:6616",
      havana_gene : "OTTHUMG00000130983.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108719482,
      stop : 108785809,
      direction : "+",
      ID : "ENSG00000153201.16",
      gene_id : "ENSG00000153201.16",
      gene_type : "protein_coding",
      gene_name : "RANBP2",
      gene_level : 2,
      hgnc_id : "HGNC:9848",
      havana_gene : "OTTHUMG00000130981.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108786757,
      stop : 108885477,
      direction : "+",
      ID : "ENSG00000163006.12",
      gene_id : "ENSG00000163006.12",
      gene_type : "protein_coding",
      gene_name : "CCDC138",
      gene_level : 1,
      hgnc_id : "HGNC:26531",
      havana_gene : "OTTHUMG00000130980.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 108894471,
      stop : 108989372,
      direction : "-",
      ID : "ENSG00000135960.10",
      gene_id : "ENSG00000135960.10",
      gene_type : "protein_coding",
      gene_name : "EDAR",
      gene_level : 2,
      hgnc_id : "HGNC:2895",
      havana_gene : "OTTHUMG00000130982.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 109129205,
      stop : 109504634,
      direction : "+",
      ID : "ENSG00000172985.11",
      gene_id : "ENSG00000172985.11",
      gene_type : "protein_coding",
      gene_name : "SH3RF3",
      gene_level : 2,
      hgnc_id : "HGNC:24699",
      havana_gene : "OTTHUMG00000153439.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 109542799,
      stop : 109614143,
      direction : "-",
      ID : "ENSG00000186522.15",
      gene_id : "ENSG00000186522.15",
      gene_type : "protein_coding",
      gene_name : "SEPTIN10",
      gene_level : 1,
      hgnc_id : "HGNC:14349",
      havana_gene : "OTTHUMG00000154957.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 109614364,
      stop : 109618990,
      direction : "+",
      ID : "ENSG00000198142.5",
      gene_id : "ENSG00000198142.5",
      gene_type : "protein_coding",
      gene_name : "SOWAHC",
      gene_level : 2,
      hgnc_id : "HGNC:26149",
      havana_gene : "OTTHUMG00000153219.2",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 109792758,
      stop : 109857705,
      direction : "+",
      ID : "ENSG00000015568.13",
      gene_id : "ENSG00000015568.13",
      gene_type : "protein_coding",
      gene_name : "RGPD5",
      gene_level : 2,
      hgnc_id : "HGNC:32418",
      havana_gene : "OTTHUMG00000130985.18",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 109898428,
      stop : 109924868,
      direction : "+",
      ID : "ENSG00000256977.12",
      gene_id : "ENSG00000256977.12",
      gene_type : "protein_coding",
      gene_name : "LIMS3",
      gene_level : 2,
      hgnc_id : "HGNC:30047",
      havana_gene : "OTTHUMG00000191772.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 109898432,
      stop : 109968557,
      direction : "+",
      ID : "ENSG00000284337.1",
      gene_id : "ENSG00000284337.1",
      gene_type : "protein_coding",
      gene_name : "AC013271.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000131197.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110083870,
      stop : 110116022,
      direction : "-",
      ID : "ENSG00000144063.4",
      gene_id : "ENSG00000144063.4",
      gene_type : "protein_coding",
      gene_name : "MALL",
      gene_level : 1,
      hgnc_id : "HGNC:6818",
      havana_gene : "OTTHUMG00000131196.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110122311,
      stop : 110205066,
      direction : "-",
      ID : "ENSG00000144061.14",
      gene_id : "ENSG00000144061.14",
      gene_type : "protein_coding",
      gene_name : "NPHP1",
      gene_level : 1,
      hgnc_id : "HGNC:7905",
      havana_gene : "OTTHUMG00000131195.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110211529,
      stop : 110245420,
      direction : "-",
      ID : "ENSG00000175701.11",
      gene_id : "ENSG00000175701.11",
      gene_type : "protein_coding",
      gene_name : "MTLN",
      gene_level : 2,
      hgnc_id : "HGNC:27339",
      havana_gene : "OTTHUMG00000131194.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110402934,
      stop : 110473075,
      direction : "-",
      ID : "ENSG00000257207.5",
      gene_id : "ENSG00000257207.5",
      gene_type : "protein_coding",
      gene_name : "AC112229.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167881.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110446640,
      stop : 110473075,
      direction : "-",
      ID : "ENSG00000256671.6",
      gene_id : "ENSG00000256671.6",
      gene_type : "protein_coding",
      gene_name : "LIMS4",
      gene_level : 1,
      hgnc_id : "HGNC:39941",
      havana_gene : "OTTHUMG00000169984.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110513802,
      stop : 110577222,
      direction : "-",
      ID : "ENSG00000183054.12",
      gene_id : "ENSG00000183054.12",
      gene_type : "protein_coding",
      gene_name : "RGPD6",
      gene_level : 2,
      hgnc_id : "HGNC:32419",
      havana_gene : "OTTHUMG00000153196.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110637528,
      stop : 110678063,
      direction : "-",
      ID : "ENSG00000169679.15",
      gene_id : "ENSG00000169679.15",
      gene_type : "protein_coding",
      gene_name : "BUB1",
      gene_level : 2,
      hgnc_id : "HGNC:1148",
      havana_gene : "OTTHUMG00000153638.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 110732539,
      stop : 111120610,
      direction : "+",
      ID : "ENSG00000153093.20",
      gene_id : "ENSG00000153093.20",
      gene_type : "protein_coding",
      gene_name : "ACOXL",
      gene_level : 1,
      hgnc_id : "HGNC:25621",
      havana_gene : "OTTHUMG00000131257.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 111119378,
      stop : 111168445,
      direction : "+",
      ID : "ENSG00000153094.24",
      gene_id : "ENSG00000153094.24",
      gene_type : "protein_coding",
      gene_name : "BCL2L11",
      gene_level : 2,
      hgnc_id : "HGNC:994",
      havana_gene : "OTTHUMG00000131256.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 111611639,
      stop : 111884690,
      direction : "-",
      ID : "ENSG00000153107.13",
      gene_id : "ENSG00000153107.13",
      gene_type : "protein_coding",
      gene_name : "ANAPC1",
      gene_level : 2,
      hgnc_id : "HGNC:19988",
      havana_gene : "OTTHUMG00000192458.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 111898607,
      stop : 112029561,
      direction : "+",
      ID : "ENSG00000153208.17",
      gene_id : "ENSG00000153208.17",
      gene_type : "protein_coding",
      gene_name : "MERTK",
      gene_level : 2,
      hgnc_id : "HGNC:7027",
      havana_gene : "OTTHUMG00000131278.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112055269,
      stop : 112119318,
      direction : "+",
      ID : "ENSG00000153214.11",
      gene_id : "ENSG00000153214.11",
      gene_type : "protein_coding",
      gene_name : "TMEM87B",
      gene_level : 2,
      hgnc_id : "HGNC:25913",
      havana_gene : "OTTHUMG00000153266.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112138385,
      stop : 112188218,
      direction : "+",
      ID : "ENSG00000144152.13",
      gene_id : "ENSG00000144152.13",
      gene_type : "protein_coding",
      gene_name : "FBLN7",
      gene_level : 1,
      hgnc_id : "HGNC:26740",
      havana_gene : "OTTHUMG00000153267.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112211529,
      stop : 112255136,
      direction : "-",
      ID : "ENSG00000144161.13",
      gene_id : "ENSG00000144161.13",
      gene_type : "protein_coding",
      gene_name : "ZC3H8",
      gene_level : 2,
      hgnc_id : "HGNC:30941",
      havana_gene : "OTTHUMG00000153270.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112275597,
      stop : 112340063,
      direction : "+",
      ID : "ENSG00000188177.14",
      gene_id : "ENSG00000188177.14",
      gene_type : "protein_coding",
      gene_name : "ZC3H6",
      gene_level : 2,
      hgnc_id : "HGNC:24762",
      havana_gene : "OTTHUMG00000153286.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112368369,
      stop : 112434488,
      direction : "-",
      ID : "ENSG00000169629.12",
      gene_id : "ENSG00000169629.12",
      gene_type : "protein_coding",
      gene_name : "RGPD8",
      gene_level : 1,
      hgnc_id : "HGNC:9849",
      havana_gene : "OTTHUMG00000153289.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112482156,
      stop : 112541739,
      direction : "+",
      ID : "ENSG00000114999.8",
      gene_id : "ENSG00000114999.8",
      gene_type : "protein_coding",
      gene_name : "TTL",
      gene_level : 2,
      hgnc_id : "HGNC:21586",
      havana_gene : "OTTHUMG00000131316.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112541915,
      stop : 112579818,
      direction : "+",
      ID : "ENSG00000125630.16",
      gene_id : "ENSG00000125630.16",
      gene_type : "protein_coding",
      gene_name : "POLR1B",
      gene_level : 1,
      hgnc_id : "HGNC:20454",
      havana_gene : "OTTHUMG00000131314.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112584240,
      stop : 112589275,
      direction : "+",
      ID : "ENSG00000125611.15",
      gene_id : "ENSG00000125611.15",
      gene_type : "protein_coding",
      gene_name : "CHCHD5",
      gene_level : 2,
      hgnc_id : "HGNC:17840",
      havana_gene : "OTTHUMG00000131312.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112645939,
      stop : 112663825,
      direction : "+",
      ID : "ENSG00000144136.11",
      gene_id : "ENSG00000144136.11",
      gene_type : "protein_coding",
      gene_name : "SLC20A1",
      gene_level : 1,
      hgnc_id : "HGNC:10946",
      havana_gene : "OTTHUMG00000131317.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112721486,
      stop : 112742879,
      direction : "+",
      ID : "ENSG00000144130.11",
      gene_id : "ENSG00000144130.11",
      gene_type : "protein_coding",
      gene_name : "NT5DC4",
      gene_level : 1,
      hgnc_id : "HGNC:27678",
      havana_gene : "OTTHUMG00000153308.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112736349,
      stop : 112764664,
      direction : "-",
      ID : "ENSG00000169607.13",
      gene_id : "ENSG00000169607.13",
      gene_type : "protein_coding",
      gene_name : "CKAP2L",
      gene_level : 2,
      hgnc_id : "HGNC:26877",
      havana_gene : "OTTHUMG00000131313.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112773925,
      stop : 112784493,
      direction : "-",
      ID : "ENSG00000115008.6",
      gene_id : "ENSG00000115008.6",
      gene_type : "protein_coding",
      gene_name : "IL1A",
      gene_level : 2,
      hgnc_id : "HGNC:5991",
      havana_gene : "OTTHUMG00000131315.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112829751,
      stop : 112836816,
      direction : "-",
      ID : "ENSG00000125538.12",
      gene_id : "ENSG00000125538.12",
      gene_type : "protein_coding",
      gene_name : "IL1B",
      gene_level : 2,
      hgnc_id : "HGNC:5992",
      havana_gene : "OTTHUMG00000131344.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112912971,
      stop : 112918882,
      direction : "+",
      ID : "ENSG00000125571.9",
      gene_id : "ENSG00000125571.9",
      gene_type : "protein_coding",
      gene_name : "IL37",
      gene_level : 2,
      hgnc_id : "HGNC:15563",
      havana_gene : "OTTHUMG00000131345.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 112973203,
      stop : 112985658,
      direction : "+",
      ID : "ENSG00000136688.11",
      gene_id : "ENSG00000136688.11",
      gene_type : "protein_coding",
      gene_name : "IL36G",
      gene_level : 2,
      hgnc_id : "HGNC:15741",
      havana_gene : "OTTHUMG00000131336.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113005459,
      stop : 113008044,
      direction : "+",
      ID : "ENSG00000136694.9",
      gene_id : "ENSG00000136694.9",
      gene_type : "protein_coding",
      gene_name : "IL36A",
      gene_level : 2,
      hgnc_id : "HGNC:15562",
      havana_gene : "OTTHUMG00000153320.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113022089,
      stop : 113052867,
      direction : "-",
      ID : "ENSG00000136696.11",
      gene_id : "ENSG00000136696.11",
      gene_type : "protein_coding",
      gene_name : "IL36B",
      gene_level : 2,
      hgnc_id : "HGNC:15564",
      havana_gene : "OTTHUMG00000131338.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113058638,
      stop : 113065382,
      direction : "+",
      ID : "ENSG00000136695.15",
      gene_id : "ENSG00000136695.15",
      gene_type : "protein_coding",
      gene_name : "IL36RN",
      gene_level : 2,
      hgnc_id : "HGNC:15561",
      havana_gene : "OTTHUMG00000131337.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113067970,
      stop : 113075843,
      direction : "+",
      ID : "ENSG00000136697.13",
      gene_id : "ENSG00000136697.13",
      gene_type : "protein_coding",
      gene_name : "IL1F10",
      gene_level : 2,
      hgnc_id : "HGNC:15552",
      havana_gene : "OTTHUMG00000131339.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113107214,
      stop : 113134016,
      direction : "+",
      ID : "ENSG00000136689.19",
      gene_id : "ENSG00000136689.19",
      gene_type : "protein_coding",
      gene_name : "IL1RN",
      gene_level : 1,
      hgnc_id : "HGNC:6000",
      havana_gene : "OTTHUMG00000131341.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113157325,
      stop : 113209396,
      direction : "+",
      ID : "ENSG00000125637.16",
      gene_id : "ENSG00000125637.16",
      gene_type : "protein_coding",
      gene_name : "PSD4",
      gene_level : 1,
      hgnc_id : "HGNC:19096",
      havana_gene : "OTTHUMG00000153339.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113215997,
      stop : 113278921,
      direction : "-",
      ID : "ENSG00000125618.18",
      gene_id : "ENSG00000125618.18",
      gene_type : "protein_coding",
      gene_name : "PAX8",
      gene_level : 1,
      hgnc_id : "HGNC:8622",
      havana_gene : "OTTHUMG00000128529.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113437691,
      stop : 113496204,
      direction : "+",
      ID : "ENSG00000136682.15",
      gene_id : "ENSG00000136682.15",
      gene_type : "protein_coding",
      gene_name : "CBWD2",
      gene_level : 2,
      hgnc_id : "HGNC:17907",
      havana_gene : "OTTHUMG00000131360.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113498665,
      stop : 113501155,
      direction : "+",
      ID : "ENSG00000184492.6",
      gene_id : "ENSG00000184492.6",
      gene_type : "protein_coding",
      gene_name : "FOXD4L1",
      gene_level : 2,
      hgnc_id : "HGNC:18521",
      havana_gene : "OTTHUMG00000131359.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113627229,
      stop : 113643396,
      direction : "+",
      ID : "ENSG00000144134.18",
      gene_id : "ENSG00000144134.18",
      gene_type : "protein_coding",
      gene_name : "RABL2A",
      gene_level : 2,
      hgnc_id : "HGNC:9799",
      havana_gene : "OTTHUMG00000047828.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113705011,
      stop : 113756693,
      direction : "-",
      ID : "ENSG00000115084.15",
      gene_id : "ENSG00000115084.15",
      gene_type : "protein_coding",
      gene_name : "SLC35F5",
      gene_level : 1,
      hgnc_id : "HGNC:23617",
      havana_gene : "OTTHUMG00000131361.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 113890063,
      stop : 113962596,
      direction : "+",
      ID : "ENSG00000115091.12",
      gene_id : "ENSG00000115091.12",
      gene_type : "protein_coding",
      gene_name : "ACTR3",
      gene_level : 2,
      hgnc_id : "HGNC:170",
      havana_gene : "OTTHUMG00000153497.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 114442299,
      stop : 115845780,
      direction : "+",
      ID : "ENSG00000175497.17",
      gene_id : "ENSG00000175497.17",
      gene_type : "protein_coding",
      gene_name : "DPP10",
      gene_level : 2,
      hgnc_id : "HGNC:20823",
      havana_gene : "OTTHUMG00000153294.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 117814691,
      stop : 117832377,
      direction : "+",
      ID : "ENSG00000088205.13",
      gene_id : "ENSG00000088205.13",
      gene_type : "protein_coding",
      gene_name : "DDX18",
      gene_level : 2,
      hgnc_id : "HGNC:2741",
      havana_gene : "OTTHUMG00000058521.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 117915478,
      stop : 118014133,
      direction : "-",
      ID : "ENSG00000125633.11",
      gene_id : "ENSG00000125633.11",
      gene_type : "protein_coding",
      gene_name : "CCDC93",
      gene_level : 2,
      hgnc_id : "HGNC:25611",
      havana_gene : "OTTHUMG00000058517.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 118088452,
      stop : 118110997,
      direction : "+",
      ID : "ENSG00000125629.15",
      gene_id : "ENSG00000125629.15",
      gene_type : "protein_coding",
      gene_name : "INSIG2",
      gene_level : 2,
      hgnc_id : "HGNC:20452",
      havana_gene : "OTTHUMG00000058518.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 118842171,
      stop : 118847648,
      direction : "-",
      ID : "ENSG00000163064.7",
      gene_id : "ENSG00000163064.7",
      gene_type : "protein_coding",
      gene_name : "EN1",
      gene_level : 2,
      hgnc_id : "HGNC:3342",
      havana_gene : "OTTHUMG00000131401.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 118942194,
      stop : 118994660,
      direction : "+",
      ID : "ENSG00000019169.11",
      gene_id : "ENSG00000019169.11",
      gene_type : "protein_coding",
      gene_name : "MARCO",
      gene_level : 2,
      hgnc_id : "HGNC:6895",
      havana_gene : "OTTHUMG00000131400.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119156243,
      stop : 119158751,
      direction : "-",
      ID : "ENSG00000144119.4",
      gene_id : "ENSG00000144119.4",
      gene_type : "protein_coding",
      gene_name : "C1QL2",
      gene_level : 2,
      hgnc_id : "HGNC:24181",
      havana_gene : "OTTHUMG00000153271.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119223831,
      stop : 119265652,
      direction : "+",
      ID : "ENSG00000115107.20",
      gene_id : "ENSG00000115107.20",
      gene_type : "protein_coding",
      gene_name : "STEAP3",
      gene_level : 2,
      hgnc_id : "HGNC:24592",
      havana_gene : "OTTHUMG00000131402.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119302225,
      stop : 119366834,
      direction : "-",
      ID : "ENSG00000186132.15",
      gene_id : "ENSG00000186132.15",
      gene_type : "protein_coding",
      gene_name : "C2orf76",
      gene_level : 1,
      hgnc_id : "HGNC:27017",
      havana_gene : "OTTHUMG00000153298.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119366921,
      stop : 119372560,
      direction : "+",
      ID : "ENSG00000155368.16",
      gene_id : "ENSG00000155368.16",
      gene_type : "protein_coding",
      gene_name : "DBI",
      gene_level : 1,
      hgnc_id : "HGNC:2690",
      havana_gene : "OTTHUMG00000131403.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119429901,
      stop : 119438504,
      direction : "+",
      ID : "ENSG00000171227.7",
      gene_id : "ENSG00000171227.7",
      gene_type : "protein_coding",
      gene_name : "TMEM37",
      gene_level : 1,
      hgnc_id : "HGNC:18216",
      havana_gene : "OTTHUMG00000153304.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119439843,
      stop : 119525301,
      direction : "-",
      ID : "ENSG00000080293.10",
      gene_id : "ENSG00000080293.10",
      gene_type : "protein_coding",
      gene_name : "SCTR",
      gene_level : 2,
      hgnc_id : "HGNC:10608",
      havana_gene : "OTTHUMG00000131407.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119544432,
      stop : 119662251,
      direction : "+",
      ID : "ENSG00000163075.13",
      gene_id : "ENSG00000163075.13",
      gene_type : "protein_coding",
      gene_name : "CFAP221",
      gene_level : 1,
      hgnc_id : "HGNC:33720",
      havana_gene : "OTTHUMG00000153310.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119679167,
      stop : 119686507,
      direction : "+",
      ID : "ENSG00000144120.13",
      gene_id : "ENSG00000144120.13",
      gene_type : "protein_coding",
      gene_name : "TMEM177",
      gene_level : 1,
      hgnc_id : "HGNC:28143",
      havana_gene : "OTTHUMG00000153312.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 119759922,
      stop : 119984899,
      direction : "+",
      ID : "ENSG00000088179.9",
      gene_id : "ENSG00000088179.9",
      gene_type : "protein_coding",
      gene_name : "PTPN4",
      gene_level : 1,
      hgnc_id : "HGNC:9656",
      havana_gene : "OTTHUMG00000131436.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 120013077,
      stop : 120179119,
      direction : "+",
      ID : "ENSG00000115109.14",
      gene_id : "ENSG00000115109.14",
      gene_type : "protein_coding",
      gene_name : "EPB41L5",
      gene_level : 2,
      hgnc_id : "HGNC:19819",
      havana_gene : "OTTHUMG00000131433.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 120217479,
      stop : 120223400,
      direction : "-",
      ID : "ENSG00000226479.4",
      gene_id : "ENSG00000226479.4",
      gene_type : "protein_coding",
      gene_name : "TMEM185B",
      gene_level : 2,
      hgnc_id : "HGNC:18896",
      havana_gene : "OTTHUMG00000154402.5",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 120240064,
      stop : 120294710,
      direction : "+",
      ID : "ENSG00000144118.14",
      gene_id : "ENSG00000144118.14",
      gene_type : "protein_coding",
      gene_name : "RALB",
      gene_level : 1,
      hgnc_id : "HGNC:9840",
      havana_gene : "OTTHUMG00000131435.22",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 120346136,
      stop : 120351803,
      direction : "+",
      ID : "ENSG00000163083.6",
      gene_id : "ENSG00000163083.6",
      gene_type : "protein_coding",
      gene_name : "INHBB",
      gene_level : 2,
      hgnc_id : "HGNC:6067",
      havana_gene : "OTTHUMG00000131437.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 120735623,
      stop : 120992653,
      direction : "+",
      ID : "ENSG00000074047.22",
      gene_id : "ENSG00000074047.22",
      gene_type : "protein_coding",
      gene_name : "GLI2",
      gene_level : 2,
      hgnc_id : "HGNC:4318",
      havana_gene : "OTTHUMG00000153741.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 121216587,
      stop : 121285202,
      direction : "-",
      ID : "ENSG00000115112.8",
      gene_id : "ENSG00000115112.8",
      gene_type : "protein_coding",
      gene_name : "TFCP2L1",
      gene_level : 2,
      hgnc_id : "HGNC:17925",
      havana_gene : "OTTHUMG00000131443.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 121337776,
      stop : 121649476,
      direction : "-",
      ID : "ENSG00000074054.20",
      gene_id : "ENSG00000074054.20",
      gene_type : "protein_coding",
      gene_name : "CLASP1",
      gene_level : 2,
      hgnc_id : "HGNC:17088",
      havana_gene : "OTTHUMG00000153331.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 121726945,
      stop : 121736911,
      direction : "-",
      ID : "ENSG00000155438.12",
      gene_id : "ENSG00000155438.12",
      gene_type : "protein_coding",
      gene_name : "NIFK",
      gene_level : 2,
      hgnc_id : "HGNC:17838",
      havana_gene : "OTTHUMG00000131442.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 121737103,
      stop : 121767853,
      direction : "+",
      ID : "ENSG00000211460.12",
      gene_id : "ENSG00000211460.12",
      gene_type : "protein_coding",
      gene_name : "TSN",
      gene_level : 1,
      hgnc_id : "HGNC:12379",
      havana_gene : "OTTHUMG00000153334.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 124025287,
      stop : 124915287,
      direction : "+",
      ID : "ENSG00000155052.14",
      gene_id : "ENSG00000155052.14",
      gene_type : "protein_coding",
      gene_name : "CNTNAP5",
      gene_level : 2,
      hgnc_id : "HGNC:18748",
      havana_gene : "OTTHUMG00000153356.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 126656133,
      stop : 126696667,
      direction : "+",
      ID : "ENSG00000136732.16",
      gene_id : "ENSG00000136732.16",
      gene_type : "protein_coding",
      gene_name : "GYPC",
      gene_level : 1,
      hgnc_id : "HGNC:4704",
      havana_gene : "OTTHUMG00000131464.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 126898864,
      stop : 126902097,
      direction : "+",
      ID : "ENSG00000237524.10",
      gene_id : "ENSG00000237524.10",
      gene_type : "protein_coding",
      gene_name : "TEX51",
      gene_level : 1,
      hgnc_id : "HGNC:52387",
      havana_gene : "OTTHUMG00000153376.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127048027,
      stop : 127107288,
      direction : "-",
      ID : "ENSG00000136717.15",
      gene_id : "ENSG00000136717.15",
      gene_type : "protein_coding",
      gene_name : "BIN1",
      gene_level : 2,
      hgnc_id : "HGNC:1052",
      havana_gene : "OTTHUMG00000131465.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127183832,
      stop : 127220313,
      direction : "-",
      ID : "ENSG00000186684.14",
      gene_id : "ENSG00000186684.14",
      gene_type : "protein_coding",
      gene_name : "CYP27C1",
      gene_level : 2,
      hgnc_id : "HGNC:33480",
      havana_gene : "OTTHUMG00000153400.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127257290,
      stop : 127294166,
      direction : "-",
      ID : "ENSG00000163161.14",
      gene_id : "ENSG00000163161.14",
      gene_type : "protein_coding",
      gene_name : "ERCC3",
      gene_level : 2,
      hgnc_id : "HGNC:3435",
      havana_gene : "OTTHUMG00000131530.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127298730,
      stop : 127388465,
      direction : "-",
      ID : "ENSG00000169967.16",
      gene_id : "ENSG00000169967.16",
      gene_type : "protein_coding",
      gene_name : "MAP3K2",
      gene_level : 2,
      hgnc_id : "HGNC:6854",
      havana_gene : "OTTHUMG00000153397.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127418427,
      stop : 127429242,
      direction : "+",
      ID : "ENSG00000115718.18",
      gene_id : "ENSG00000115718.18",
      gene_type : "protein_coding",
      gene_name : "PROC",
      gene_level : 2,
      hgnc_id : "HGNC:9451",
      havana_gene : "OTTHUMG00000131528.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127436207,
      stop : 127526886,
      direction : "-",
      ID : "ENSG00000163166.15",
      gene_id : "ENSG00000163166.15",
      gene_type : "protein_coding",
      gene_name : "IWS1",
      gene_level : 1,
      hgnc_id : "HGNC:25467",
      havana_gene : "OTTHUMG00000131527.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127535802,
      stop : 127637729,
      direction : "+",
      ID : "ENSG00000169994.18",
      gene_id : "ENSG00000169994.18",
      gene_type : "protein_coding",
      gene_name : "MYO7B",
      gene_level : 2,
      hgnc_id : "HGNC:7607",
      havana_gene : "OTTHUMG00000153419.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127638381,
      stop : 127681786,
      direction : "-",
      ID : "ENSG00000072163.20",
      gene_id : "ENSG00000072163.20",
      gene_type : "protein_coding",
      gene_name : "LIMS2",
      gene_level : 1,
      hgnc_id : "HGNC:16084",
      havana_gene : "OTTHUMG00000131529.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127645864,
      stop : 127652639,
      direction : "+",
      ID : "ENSG00000144230.16",
      gene_id : "ENSG00000144230.16",
      gene_type : "protein_coding",
      gene_name : "GPR17",
      gene_level : 2,
      hgnc_id : "HGNC:4471",
      havana_gene : "OTTHUMG00000131533.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127701027,
      stop : 127811187,
      direction : "-",
      ID : "ENSG00000136709.12",
      gene_id : "ENSG00000136709.12",
      gene_type : "protein_coding",
      gene_name : "WDR33",
      gene_level : 2,
      hgnc_id : "HGNC:25651",
      havana_gene : "OTTHUMG00000131534.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127701497,
      stop : 127705242,
      direction : "+",
      ID : "ENSG00000173349.6",
      gene_id : "ENSG00000173349.6",
      gene_type : "protein_coding",
      gene_name : "SFT2D3",
      gene_level : 2,
      hgnc_id : "HGNC:28767",
      havana_gene : "OTTHUMG00000131532.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127843553,
      stop : 127858155,
      direction : "-",
      ID : "ENSG00000144231.11",
      gene_id : "ENSG00000144231.11",
      gene_type : "protein_coding",
      gene_name : "POLR2D",
      gene_level : 1,
      hgnc_id : "HGNC:9191",
      havana_gene : "OTTHUMG00000131531.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127861630,
      stop : 127885967,
      direction : "-",
      ID : "ENSG00000144233.11",
      gene_id : "ENSG00000144233.11",
      gene_type : "protein_coding",
      gene_name : "AMMECR1L",
      gene_level : 2,
      hgnc_id : "HGNC:28658",
      havana_gene : "OTTHUMG00000131535.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 127941217,
      stop : 128028120,
      direction : "-",
      ID : "ENSG00000136715.19",
      gene_id : "ENSG00000136715.19",
      gene_type : "protein_coding",
      gene_name : "SAP130",
      gene_level : 1,
      hgnc_id : "HGNC:29813",
      havana_gene : "OTTHUMG00000131571.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 128091200,
      stop : 128195677,
      direction : "+",
      ID : "ENSG00000136731.13",
      gene_id : "ENSG00000136731.13",
      gene_type : "protein_coding",
      gene_name : "UGGT1",
      gene_level : 1,
      hgnc_id : "HGNC:15663",
      havana_gene : "OTTHUMG00000131570.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 128236716,
      stop : 128318868,
      direction : "-",
      ID : "ENSG00000136720.7",
      gene_id : "ENSG00000136720.7",
      gene_type : "protein_coding",
      gene_name : "HS6ST1",
      gene_level : 1,
      hgnc_id : "HGNC:5201",
      havana_gene : "OTTHUMG00000153542.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 129979666,
      stop : 129982738,
      direction : "+",
      ID : "ENSG00000222014.6",
      gene_id : "ENSG00000222014.6",
      gene_type : "protein_coding",
      gene_name : "RAB6C",
      gene_level : 2,
      hgnc_id : "HGNC:16525",
      havana_gene : "OTTHUMG00000153487.4",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130073535,
      stop : 130129222,
      direction : "-",
      ID : "ENSG00000196604.13",
      gene_id : "ENSG00000196604.13",
      gene_type : "protein_coding",
      gene_name : "POTEF",
      gene_level : 2,
      hgnc_id : "HGNC:33905",
      havana_gene : "OTTHUMG00000153628.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130139287,
      stop : 130145134,
      direction : "-",
      ID : "ENSG00000152076.19",
      gene_id : "ENSG00000152076.19",
      gene_type : "protein_coding",
      gene_name : "CCDC74B",
      gene_level : 2,
      hgnc_id : "HGNC:25267",
      havana_gene : "OTTHUMG00000131629.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130151392,
      stop : 130182750,
      direction : "-",
      ID : "ENSG00000136699.20",
      gene_id : "ENSG00000136699.20",
      gene_type : "protein_coding",
      gene_name : "SMPD4",
      gene_level : 1,
      hgnc_id : "HGNC:32949",
      havana_gene : "OTTHUMG00000131624.18",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130181737,
      stop : 130190729,
      direction : "+",
      ID : "ENSG00000152082.15",
      gene_id : "ENSG00000152082.15",
      gene_type : "protein_coding",
      gene_name : "MZT2B",
      gene_level : 1,
      hgnc_id : "HGNC:25886",
      havana_gene : "OTTHUMG00000131625.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130191745,
      stop : 130198439,
      direction : "-",
      ID : "ENSG00000152086.9",
      gene_id : "ENSG00000152086.9",
      gene_type : "protein_coding",
      gene_name : "TUBA3E",
      gene_level : 2,
      hgnc_id : "HGNC:20765",
      havana_gene : "OTTHUMG00000131626.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130337933,
      stop : 130342699,
      direction : "-",
      ID : "ENSG00000136710.10",
      gene_id : "ENSG00000136710.10",
      gene_type : "protein_coding",
      gene_name : "CCDC115",
      gene_level : 2,
      hgnc_id : "HGNC:28178",
      havana_gene : "OTTHUMG00000131631.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130342877,
      stop : 130347967,
      direction : "+",
      ID : "ENSG00000136718.10",
      gene_id : "ENSG00000136718.10",
      gene_type : "protein_coding",
      gene_name : "IMP4",
      gene_level : 2,
      hgnc_id : "HGNC:30856",
      havana_gene : "OTTHUMG00000131627.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130356045,
      stop : 130375405,
      direction : "+",
      ID : "ENSG00000072135.13",
      gene_id : "ENSG00000072135.13",
      gene_type : "protein_coding",
      gene_name : "PTPN18",
      gene_level : 2,
      hgnc_id : "HGNC:9649",
      havana_gene : "OTTHUMG00000131630.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130459455,
      stop : 130509707,
      direction : "-",
      ID : "ENSG00000196834.13",
      gene_id : "ENSG00000196834.13",
      gene_type : "protein_coding",
      gene_name : "POTEI",
      gene_level : 1,
      hgnc_id : "HGNC:37093",
      havana_gene : "OTTHUMG00000153925.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130521197,
      stop : 130528604,
      direction : "+",
      ID : "ENSG00000152093.8",
      gene_id : "ENSG00000152093.8",
      gene_type : "protein_coding",
      gene_name : "CFC1B",
      gene_level : 2,
      hgnc_id : "HGNC:33983",
      havana_gene : "OTTHUMG00000153959.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130592165,
      stop : 130599575,
      direction : "-",
      ID : "ENSG00000136698.10",
      gene_id : "ENSG00000136698.10",
      gene_type : "protein_coding",
      gene_name : "CFC1",
      gene_level : 2,
      hgnc_id : "HGNC:18292",
      havana_gene : "OTTHUMG00000131628.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130611440,
      stop : 130658037,
      direction : "+",
      ID : "ENSG00000222038.4",
      gene_id : "ENSG00000222038.4",
      gene_type : "protein_coding",
      gene_name : "POTEJ",
      gene_level : 1,
      hgnc_id : "HGNC:37094",
      havana_gene : "OTTHUMG00000154050.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130729070,
      stop : 130730336,
      direction : "+",
      ID : "ENSG00000173302.5",
      gene_id : "ENSG00000173302.5",
      gene_type : "protein_coding",
      gene_name : "GPR148",
      gene_level : 2,
      hgnc_id : "HGNC:23623",
      havana_gene : "OTTHUMG00000131655.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130755540,
      stop : 130768134,
      direction : "+",
      ID : "ENSG00000178171.11",
      gene_id : "ENSG00000178171.11",
      gene_type : "protein_coding",
      gene_name : "AMER3",
      gene_level : 2,
      hgnc_id : "HGNC:26771",
      havana_gene : "OTTHUMG00000131637.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 130836914,
      stop : 131047263,
      direction : "+",
      ID : "ENSG00000136002.20",
      gene_id : "ENSG00000136002.20",
      gene_type : "protein_coding",
      gene_name : "ARHGEF4",
      gene_level : 1,
      hgnc_id : "HGNC:684",
      havana_gene : "OTTHUMG00000191895.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131035092,
      stop : 131035262,
      direction : "+",
      ID : "ENSG00000284479.1",
      gene_id : "ENSG00000284479.1",
      gene_type : "protein_coding",
      gene_name : "SMIM39",
      gene_level : 2,
      hgnc_id : "HGNC:54076",
      havana_gene : "OTTHUMG00000131657.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131047876,
      stop : 131093460,
      direction : "-",
      ID : "ENSG00000152102.18",
      gene_id : "ENSG00000152102.18",
      gene_type : "protein_coding",
      gene_name : "FAM168B",
      gene_level : 2,
      hgnc_id : "HGNC:27016",
      havana_gene : "OTTHUMG00000153473.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131104847,
      stop : 131353709,
      direction : "+",
      ID : "ENSG00000115762.16",
      gene_id : "ENSG00000115762.16",
      gene_type : "protein_coding",
      gene_name : "PLEKHB2",
      gene_level : 1,
      hgnc_id : "HGNC:19236",
      havana_gene : "OTTHUMG00000131656.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131218067,
      stop : 131265278,
      direction : "+",
      ID : "ENSG00000188219.14",
      gene_id : "ENSG00000188219.14",
      gene_type : "protein_coding",
      gene_name : "POTEE",
      gene_level : 2,
      hgnc_id : "HGNC:33895",
      havana_gene : "OTTHUMG00000186974.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131361111,
      stop : 131364142,
      direction : "-",
      ID : "ENSG00000233087.7",
      gene_id : "ENSG00000233087.7",
      gene_type : "protein_coding",
      gene_name : "RAB6D",
      gene_level : 2,
      hgnc_id : "HGNC:30272",
      havana_gene : "OTTHUMG00000153556.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131464900,
      stop : 131492743,
      direction : "-",
      ID : "ENSG00000173272.16",
      gene_id : "ENSG00000173272.16",
      gene_type : "protein_coding",
      gene_name : "MZT2A",
      gene_level : 2,
      hgnc_id : "HGNC:33187",
      havana_gene : "OTTHUMG00000153606.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131476119,
      stop : 131482934,
      direction : "+",
      ID : "ENSG00000075886.11",
      gene_id : "ENSG00000075886.11",
      gene_type : "protein_coding",
      gene_name : "TUBA3D",
      gene_level : 2,
      hgnc_id : "HGNC:24071",
      havana_gene : "OTTHUMG00000153600.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 131527675,
      stop : 131533666,
      direction : "+",
      ID : "ENSG00000163040.15",
      gene_id : "ENSG00000163040.15",
      gene_type : "protein_coding",
      gene_name : "CCDC74A",
      gene_level : 1,
      hgnc_id : "HGNC:25197",
      havana_gene : "OTTHUMG00000131667.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 132147591,
      stop : 132257969,
      direction : "-",
      ID : "ENSG00000163046.16",
      gene_id : "ENSG00000163046.16",
      gene_type : "protein_coding",
      gene_name : "ANKRD30BL",
      gene_level : 1,
      hgnc_id : "HGNC:35167",
      havana_gene : "OTTHUMG00000153491.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 132416805,
      stop : 132646582,
      direction : "+",
      ID : "ENSG00000183840.7",
      gene_id : "ENSG00000183840.7",
      gene_type : "protein_coding",
      gene_name : "GPR39",
      gene_level : 2,
      hgnc_id : "HGNC:4496",
      havana_gene : "OTTHUMG00000131679.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 132643286,
      stop : 132671579,
      direction : "-",
      ID : "ENSG00000150551.11",
      gene_id : "ENSG00000150551.11",
      gene_type : "protein_coding",
      gene_name : "LYPD1",
      gene_level : 2,
      hgnc_id : "HGNC:28431",
      havana_gene : "OTTHUMG00000153609.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 132671788,
      stop : 133568463,
      direction : "-",
      ID : "ENSG00000176771.17",
      gene_id : "ENSG00000176771.17",
      gene_type : "protein_coding",
      gene_name : "NCKAP5",
      gene_level : 1,
      hgnc_id : "HGNC:29847",
      havana_gene : "OTTHUMG00000153573.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 134119983,
      stop : 134454621,
      direction : "+",
      ID : "ENSG00000152127.9",
      gene_id : "ENSG00000152127.9",
      gene_type : "protein_coding",
      gene_name : "MGAT5",
      gene_level : 1,
      hgnc_id : "HGNC:7049",
      havana_gene : "OTTHUMG00000131681.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 134455759,
      stop : 134719000,
      direction : "-",
      ID : "ENSG00000152128.13",
      gene_id : "ENSG00000152128.13",
      gene_type : "protein_coding",
      gene_name : "TMEM163",
      gene_level : 2,
      hgnc_id : "HGNC:25380",
      havana_gene : "OTTHUMG00000131713.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 134838616,
      stop : 134902034,
      direction : "+",
      ID : "ENSG00000153086.14",
      gene_id : "ENSG00000153086.14",
      gene_type : "protein_coding",
      gene_name : "ACMSD",
      gene_level : 2,
      hgnc_id : "HGNC:19288",
      havana_gene : "OTTHUMG00000131711.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 134918235,
      stop : 134959342,
      direction : "+",
      ID : "ENSG00000082258.13",
      gene_id : "ENSG00000082258.13",
      gene_type : "protein_coding",
      gene_name : "CCNT2",
      gene_level : 1,
      hgnc_id : "HGNC:1600",
      havana_gene : "OTTHUMG00000131712.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 134964485,
      stop : 135047468,
      direction : "-",
      ID : "ENSG00000176601.13",
      gene_id : "ENSG00000176601.13",
      gene_type : "protein_coding",
      gene_name : "MAP3K19",
      gene_level : 1,
      hgnc_id : "HGNC:26249",
      havana_gene : "OTTHUMG00000074083.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135052292,
      stop : 135176394,
      direction : "+",
      ID : "ENSG00000115839.18",
      gene_id : "ENSG00000115839.18",
      gene_type : "protein_coding",
      gene_name : "RAB3GAP1",
      gene_level : 2,
      hgnc_id : "HGNC:17063",
      havana_gene : "OTTHUMG00000154889.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135136916,
      stop : 135531218,
      direction : "-",
      ID : "ENSG00000121988.18",
      gene_id : "ENSG00000121988.18",
      gene_type : "protein_coding",
      gene_name : "ZRANB3",
      gene_level : 2,
      hgnc_id : "HGNC:25249",
      havana_gene : "OTTHUMG00000150475.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135531455,
      stop : 135725270,
      direction : "+",
      ID : "ENSG00000048991.16",
      gene_id : "ENSG00000048991.16",
      gene_type : "protein_coding",
      gene_name : "R3HDM1",
      gene_level : 1,
      hgnc_id : "HGNC:9757",
      havana_gene : "OTTHUMG00000131740.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135741734,
      stop : 135785056,
      direction : "+",
      ID : "ENSG00000144224.17",
      gene_id : "ENSG00000144224.17",
      gene_type : "protein_coding",
      gene_name : "UBXN4",
      gene_level : 2,
      hgnc_id : "HGNC:14860",
      havana_gene : "OTTHUMG00000153577.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135787850,
      stop : 135837184,
      direction : "-",
      ID : "ENSG00000115850.10",
      gene_id : "ENSG00000115850.10",
      gene_type : "protein_coding",
      gene_name : "LCT",
      gene_level : 2,
      hgnc_id : "HGNC:6530",
      havana_gene : "OTTHUMG00000131738.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135839626,
      stop : 135876443,
      direction : "-",
      ID : "ENSG00000076003.5",
      gene_id : "ENSG00000076003.5",
      gene_type : "protein_coding",
      gene_name : "MCM6",
      gene_level : 2,
      hgnc_id : "HGNC:6949",
      havana_gene : "OTTHUMG00000131739.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 135905881,
      stop : 135986100,
      direction : "-",
      ID : "ENSG00000115866.11",
      gene_id : "ENSG00000115866.11",
      gene_type : "protein_coding",
      gene_name : "DARS1",
      gene_level : 2,
      hgnc_id : "HGNC:2678",
      havana_gene : "OTTHUMG00000131741.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 136114349,
      stop : 136118149,
      direction : "-",
      ID : "ENSG00000121966.7",
      gene_id : "ENSG00000121966.7",
      gene_type : "protein_coding",
      gene_name : "CXCR4",
      gene_level : 2,
      hgnc_id : "HGNC:2561",
      havana_gene : "OTTHUMG00000153583.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 136765545,
      stop : 137677718,
      direction : "+",
      ID : "ENSG00000144229.12",
      gene_id : "ENSG00000144229.12",
      gene_type : "protein_coding",
      gene_name : "THSD7B",
      gene_level : 2,
      hgnc_id : "HGNC:29348",
      havana_gene : "OTTHUMG00000153590.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 137964020,
      stop : 138016364,
      direction : "+",
      ID : "ENSG00000150540.14",
      gene_id : "ENSG00000150540.14",
      gene_type : "protein_coding",
      gene_name : "HNMT",
      gene_level : 2,
      hgnc_id : "HGNC:5028",
      havana_gene : "OTTHUMG00000131751.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 138501770,
      stop : 138573547,
      direction : "+",
      ID : "ENSG00000144228.9",
      gene_id : "ENSG00000144228.9",
      gene_type : "protein_coding",
      gene_name : "SPOPL",
      gene_level : 2,
      hgnc_id : "HGNC:27934",
      havana_gene : "OTTHUMG00000153635.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 138669157,
      stop : 138780390,
      direction : "-",
      ID : "ENSG00000144227.5",
      gene_id : "ENSG00000144227.5",
      gene_type : "protein_coding",
      gene_name : "NXPH2",
      gene_level : 2,
      hgnc_id : "HGNC:8076",
      havana_gene : "OTTHUMG00000153636.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 140231423,
      stop : 142131016,
      direction : "-",
      ID : "ENSG00000168702.18",
      gene_id : "ENSG00000168702.18",
      gene_type : "protein_coding",
      gene_name : "LRP1B",
      gene_level : 1,
      hgnc_id : "HGNC:6693",
      havana_gene : "OTTHUMG00000131799.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 142877657,
      stop : 143055833,
      direction : "+",
      ID : "ENSG00000115919.15",
      gene_id : "ENSG00000115919.15",
      gene_type : "protein_coding",
      gene_name : "KYNU",
      gene_level : 1,
      hgnc_id : "HGNC:6469",
      havana_gene : "OTTHUMG00000131829.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 143091362,
      stop : 143768352,
      direction : "+",
      ID : "ENSG00000075884.14",
      gene_id : "ENSG00000075884.14",
      gene_type : "protein_coding",
      gene_name : "ARHGAP15",
      gene_level : 2,
      hgnc_id : "HGNC:21030",
      havana_gene : "OTTHUMG00000192163.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 143938068,
      stop : 144332568,
      direction : "-",
      ID : "ENSG00000121964.14",
      gene_id : "ENSG00000121964.14",
      gene_type : "protein_coding",
      gene_name : "GTDC1",
      gene_level : 2,
      hgnc_id : "HGNC:20887",
      havana_gene : "OTTHUMG00000131835.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 144364364,
      stop : 144521057,
      direction : "-",
      ID : "ENSG00000169554.22",
      gene_id : "ENSG00000169554.22",
      gene_type : "protein_coding",
      gene_name : "ZEB2",
      gene_level : 1,
      hgnc_id : "HGNC:14881",
      havana_gene : "OTTHUMG00000187624.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 147844517,
      stop : 147930826,
      direction : "+",
      ID : "ENSG00000121989.15",
      gene_id : "ENSG00000121989.15",
      gene_type : "protein_coding",
      gene_name : "ACVR2A",
      gene_level : 2,
      hgnc_id : "HGNC:173",
      havana_gene : "OTTHUMG00000150603.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 147930396,
      stop : 148021604,
      direction : "-",
      ID : "ENSG00000115947.14",
      gene_id : "ENSG00000115947.14",
      gene_type : "protein_coding",
      gene_name : "ORC4",
      gene_level : 2,
      hgnc_id : "HGNC:8490",
      havana_gene : "OTTHUMG00000131849.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 148021011,
      stop : 148516971,
      direction : "+",
      ID : "ENSG00000204406.14",
      gene_id : "ENSG00000204406.14",
      gene_type : "protein_coding",
      gene_name : "MBD5",
      gene_level : 1,
      hgnc_id : "HGNC:20444",
      havana_gene : "OTTHUMG00000150440.15",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 148644440,
      stop : 148787569,
      direction : "+",
      ID : "ENSG00000135999.12",
      gene_id : "ENSG00000135999.12",
      gene_type : "protein_coding",
      gene_name : "EPC2",
      gene_level : 1,
      hgnc_id : "HGNC:24543",
      havana_gene : "OTTHUMG00000153739.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 148875227,
      stop : 149026759,
      direction : "+",
      ID : "ENSG00000168280.18",
      gene_id : "ENSG00000168280.18",
      gene_type : "protein_coding",
      gene_name : "KIF5C",
      gene_level : 2,
      hgnc_id : "HGNC:6325",
      havana_gene : "OTTHUMG00000153779.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 149038107,
      stop : 149215262,
      direction : "+",
      ID : "ENSG00000150556.17",
      gene_id : "ENSG00000150556.17",
      gene_type : "protein_coding",
      gene_name : "LYPD6B",
      gene_level : 1,
      hgnc_id : "HGNC:27018",
      havana_gene : "OTTHUMG00000153743.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 149329985,
      stop : 149474138,
      direction : "+",
      ID : "ENSG00000187123.15",
      gene_id : "ENSG00000187123.15",
      gene_type : "protein_coding",
      gene_name : "LYPD6",
      gene_level : 2,
      hgnc_id : "HGNC:28751",
      havana_gene : "OTTHUMG00000131852.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 149569637,
      stop : 149587778,
      direction : "-",
      ID : "ENSG00000168288.13",
      gene_id : "ENSG00000168288.13",
      gene_type : "protein_coding",
      gene_name : "MMADHC",
      gene_level : 2,
      hgnc_id : "HGNC:25221",
      havana_gene : "OTTHUMG00000155558.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 150468195,
      stop : 150539011,
      direction : "-",
      ID : "ENSG00000115963.14",
      gene_id : "ENSG00000115963.14",
      gene_type : "protein_coding",
      gene_name : "RND3",
      gene_level : 2,
      hgnc_id : "HGNC:671",
      havana_gene : "OTTHUMG00000131859.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151247940,
      stop : 151261863,
      direction : "-",
      ID : "ENSG00000184898.7",
      gene_id : "ENSG00000184898.7",
      gene_type : "protein_coding",
      gene_name : "RBM43",
      gene_level : 2,
      hgnc_id : "HGNC:24790",
      havana_gene : "OTTHUMG00000131866.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151270470,
      stop : 151289894,
      direction : "-",
      ID : "ENSG00000123609.11",
      gene_id : "ENSG00000123609.11",
      gene_type : "protein_coding",
      gene_name : "NMI",
      gene_level : 2,
      hgnc_id : "HGNC:7854",
      havana_gene : "OTTHUMG00000131867.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151357592,
      stop : 151380046,
      direction : "+",
      ID : "ENSG00000123610.5",
      gene_id : "ENSG00000123610.5",
      gene_type : "protein_coding",
      gene_name : "TNFAIP6",
      gene_level : 2,
      hgnc_id : "HGNC:11898",
      havana_gene : "OTTHUMG00000131884.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151409883,
      stop : 151508013,
      direction : "+",
      ID : "ENSG00000080345.18",
      gene_id : "ENSG00000080345.18",
      gene_type : "protein_coding",
      gene_name : "RIF1",
      gene_level : 2,
      hgnc_id : "HGNC:23207",
      havana_gene : "OTTHUMG00000131886.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151485336,
      stop : 151734487,
      direction : "-",
      ID : "ENSG00000183091.20",
      gene_id : "ENSG00000183091.20",
      gene_type : "protein_coding",
      gene_name : "NEB",
      gene_level : 1,
      hgnc_id : "HGNC:7720",
      havana_gene : "OTTHUMG00000153784.16",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151788984,
      stop : 151828492,
      direction : "-",
      ID : "ENSG00000162980.17",
      gene_id : "ENSG00000162980.17",
      gene_type : "protein_coding",
      gene_name : "ARL5A",
      gene_level : 1,
      hgnc_id : "HGNC:696",
      havana_gene : "OTTHUMG00000131887.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151802651,
      stop : 151973949,
      direction : "-",
      ID : "ENSG00000283228.1",
      gene_id : "ENSG00000283228.1",
      gene_type : "protein_coding",
      gene_name : "AC068547.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191700.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 151832771,
      stop : 152099167,
      direction : "-",
      ID : "ENSG00000182389.20",
      gene_id : "ENSG00000182389.20",
      gene_type : "protein_coding",
      gene_name : "CACNB4",
      gene_level : 1,
      hgnc_id : "HGNC:1404",
      havana_gene : "OTTHUMG00000155091.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 152116801,
      stop : 152175763,
      direction : "-",
      ID : "ENSG00000115145.10",
      gene_id : "ENSG00000115145.10",
      gene_type : "protein_coding",
      gene_name : "STAM2",
      gene_level : 2,
      hgnc_id : "HGNC:11358",
      havana_gene : "OTTHUMG00000131885.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 152335174,
      stop : 152649826,
      direction : "+",
      ID : "ENSG00000157827.20",
      gene_id : "ENSG00000157827.20",
      gene_type : "protein_coding",
      gene_name : "FMNL2",
      gene_level : 1,
      hgnc_id : "HGNC:18267",
      havana_gene : "OTTHUMG00000154035.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 152651593,
      stop : 152717997,
      direction : "-",
      ID : "ENSG00000196504.19",
      gene_id : "ENSG00000196504.19",
      gene_type : "protein_coding",
      gene_name : "PRPF40A",
      gene_level : 2,
      hgnc_id : "HGNC:16463",
      havana_gene : "OTTHUMG00000154031.15",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 152717893,
      stop : 152762396,
      direction : "+",
      ID : "ENSG00000177917.11",
      gene_id : "ENSG00000177917.11",
      gene_type : "protein_coding",
      gene_name : "ARL6IP6",
      gene_level : 2,
      hgnc_id : "HGNC:24048",
      havana_gene : "OTTHUMG00000131901.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 153477338,
      stop : 153478762,
      direction : "-",
      ID : "ENSG00000177519.4",
      gene_id : "ENSG00000177519.4",
      gene_type : "protein_coding",
      gene_name : "RPRM",
      gene_level : 2,
      hgnc_id : "HGNC:24201",
      havana_gene : "OTTHUMG00000131905.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 153871922,
      stop : 154453979,
      direction : "+",
      ID : "ENSG00000144278.15",
      gene_id : "ENSG00000144278.15",
      gene_type : "protein_coding",
      gene_name : "GALNT13",
      gene_level : 1,
      hgnc_id : "HGNC:23242",
      havana_gene : "OTTHUMG00000131917.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 154697855,
      stop : 154858354,
      direction : "+",
      ID : "ENSG00000162989.5",
      gene_id : "ENSG00000162989.5",
      gene_type : "protein_coding",
      gene_name : "KCNJ3",
      gene_level : 2,
      hgnc_id : "HGNC:6264",
      havana_gene : "OTTHUMG00000131937.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 156324437,
      stop : 156342348,
      direction : "-",
      ID : "ENSG00000153234.15",
      gene_id : "ENSG00000153234.15",
      gene_type : "protein_coding",
      gene_name : "NR4A2",
      gene_level : 1,
      hgnc_id : "HGNC:7981",
      havana_gene : "OTTHUMG00000131950.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 156435290,
      stop : 156613735,
      direction : "+",
      ID : "ENSG00000115159.16",
      gene_id : "ENSG00000115159.16",
      gene_type : "protein_coding",
      gene_name : "GPD2",
      gene_level : 2,
      hgnc_id : "HGNC:4456",
      havana_gene : "OTTHUMG00000131951.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 157257705,
      stop : 157318491,
      direction : "+",
      ID : "ENSG00000136542.9",
      gene_id : "ENSG00000136542.9",
      gene_type : "protein_coding",
      gene_name : "GALNT5",
      gene_level : 1,
      hgnc_id : "HGNC:4127",
      havana_gene : "OTTHUMG00000131965.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 157318631,
      stop : 157327713,
      direction : "-",
      ID : "ENSG00000136541.15",
      gene_id : "ENSG00000136541.15",
      gene_type : "protein_coding",
      gene_name : "ERMN",
      gene_level : 2,
      hgnc_id : "HGNC:29208",
      havana_gene : "OTTHUMG00000153843.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 157414619,
      stop : 157488961,
      direction : "-",
      ID : "ENSG00000115165.10",
      gene_id : "ENSG00000115165.10",
      gene_type : "protein_coding",
      gene_name : "CYTIP",
      gene_level : 1,
      hgnc_id : "HGNC:9506",
      havana_gene : "OTTHUMG00000154551.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 157526767,
      stop : 157628864,
      direction : "-",
      ID : "ENSG00000123612.16",
      gene_id : "ENSG00000123612.16",
      gene_type : "protein_coding",
      gene_name : "ACVR1C",
      gene_level : 2,
      hgnc_id : "HGNC:18123",
      havana_gene : "OTTHUMG00000131964.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 157736444,
      stop : 157876330,
      direction : "-",
      ID : "ENSG00000115170.15",
      gene_id : "ENSG00000115170.15",
      gene_type : "protein_coding",
      gene_name : "ACVR1",
      gene_level : 2,
      hgnc_id : "HGNC:171",
      havana_gene : "OTTHUMG00000131967.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 157876702,
      stop : 158136154,
      direction : "+",
      ID : "ENSG00000007001.13",
      gene_id : "ENSG00000007001.13",
      gene_type : "protein_coding",
      gene_name : "UPP2",
      gene_level : 2,
      hgnc_id : "HGNC:23061",
      havana_gene : "OTTHUMG00000131969.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 158171073,
      stop : 158456753,
      direction : "-",
      ID : "ENSG00000153237.18",
      gene_id : "ENSG00000153237.18",
      gene_type : "protein_coding",
      gene_name : "CCDC148",
      gene_level : 2,
      hgnc_id : "HGNC:25191",
      havana_gene : "OTTHUMG00000153973.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 158456952,
      stop : 158682879,
      direction : "+",
      ID : "ENSG00000144283.22",
      gene_id : "ENSG00000144283.22",
      gene_type : "protein_coding",
      gene_name : "PKP4",
      gene_level : 2,
      hgnc_id : "HGNC:9026",
      havana_gene : "OTTHUMG00000153969.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 158795317,
      stop : 158862781,
      direction : "+",
      ID : "ENSG00000163331.12",
      gene_id : "ENSG00000163331.12",
      gene_type : "protein_coding",
      gene_name : "DAPL1",
      gene_level : 1,
      hgnc_id : "HGNC:21490",
      havana_gene : "OTTHUMG00000153970.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 158968640,
      stop : 159232659,
      direction : "+",
      ID : "ENSG00000115183.15",
      gene_id : "ENSG00000115183.15",
      gene_type : "protein_coding",
      gene_name : "TANC1",
      gene_level : 2,
      hgnc_id : "HGNC:29364",
      havana_gene : "OTTHUMG00000153945.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159235798,
      stop : 159286703,
      direction : "-",
      ID : "ENSG00000196151.11",
      gene_id : "ENSG00000196151.11",
      gene_type : "protein_coding",
      gene_name : "WDSUB1",
      gene_level : 1,
      hgnc_id : "HGNC:26697",
      havana_gene : "OTTHUMG00000132028.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159318979,
      stop : 159616569,
      direction : "-",
      ID : "ENSG00000123636.18",
      gene_id : "ENSG00000123636.18",
      gene_type : "protein_coding",
      gene_name : "BAZ2B",
      gene_level : 1,
      hgnc_id : "HGNC:963",
      havana_gene : "OTTHUMG00000132027.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159712457,
      stop : 159771027,
      direction : "+",
      ID : "ENSG00000136536.15",
      gene_id : "ENSG00000136536.15",
      gene_type : "protein_coding",
      gene_name : "MARCHF7",
      gene_level : 1,
      hgnc_id : "HGNC:17393",
      havana_gene : "OTTHUMG00000132029.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159768628,
      stop : 159798255,
      direction : "-",
      ID : "ENSG00000241399.7",
      gene_id : "ENSG00000241399.7",
      gene_type : "protein_coding",
      gene_name : "CD302",
      gene_level : 2,
      hgnc_id : "HGNC:30843",
      havana_gene : "OTTHUMG00000154080.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159771851,
      stop : 159904710,
      direction : "-",
      ID : "ENSG00000248672.5",
      gene_id : "ENSG00000248672.5",
      gene_type : "protein_coding",
      gene_name : "LY75-CD302",
      gene_level : 1,
      hgnc_id : "HGNC:38828",
      havana_gene : "OTTHUMG00000161661.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159803355,
      stop : 159904756,
      direction : "-",
      ID : "ENSG00000054219.11",
      gene_id : "ENSG00000054219.11",
      gene_type : "protein_coding",
      gene_name : "LY75",
      gene_level : 2,
      hgnc_id : "HGNC:6729",
      havana_gene : "OTTHUMG00000132025.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 159932006,
      stop : 160062615,
      direction : "-",
      ID : "ENSG00000153246.13",
      gene_id : "ENSG00000153246.13",
      gene_type : "protein_coding",
      gene_name : "PLA2R1",
      gene_level : 2,
      hgnc_id : "HGNC:9042",
      havana_gene : "OTTHUMG00000154087.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 160099667,
      stop : 160200313,
      direction : "-",
      ID : "ENSG00000115221.12",
      gene_id : "ENSG00000115221.12",
      gene_type : "protein_coding",
      gene_name : "ITGB6",
      gene_level : 1,
      hgnc_id : "HGNC:6161",
      havana_gene : "OTTHUMG00000132026.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 160272151,
      stop : 160493807,
      direction : "-",
      ID : "ENSG00000153250.20",
      gene_id : "ENSG00000153250.20",
      gene_type : "protein_coding",
      gene_name : "RBMS1",
      gene_level : 2,
      hgnc_id : "HGNC:9907",
      havana_gene : "OTTHUMG00000132031.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 161136908,
      stop : 161236230,
      direction : "+",
      ID : "ENSG00000136560.14",
      gene_id : "ENSG00000136560.14",
      gene_type : "protein_coding",
      gene_name : "TANK",
      gene_level : 1,
      hgnc_id : "HGNC:11562",
      havana_gene : "OTTHUMG00000132037.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 161308425,
      stop : 161411717,
      direction : "+",
      ID : "ENSG00000115233.12",
      gene_id : "ENSG00000115233.12",
      gene_type : "protein_coding",
      gene_name : "PSMD14",
      gene_level : 2,
      hgnc_id : "HGNC:16889",
      havana_gene : "OTTHUMG00000153882.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 161416297,
      stop : 161425870,
      direction : "+",
      ID : "ENSG00000136535.15",
      gene_id : "ENSG00000136535.15",
      gene_type : "protein_coding",
      gene_name : "TBR1",
      gene_level : 2,
      hgnc_id : "HGNC:11590",
      havana_gene : "OTTHUMG00000153888.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 161424332,
      stop : 161985282,
      direction : "+",
      ID : "ENSG00000144290.17",
      gene_id : "ENSG00000144290.17",
      gene_type : "protein_coding",
      gene_name : "SLC4A10",
      gene_level : 2,
      hgnc_id : "HGNC:13811",
      havana_gene : "OTTHUMG00000153938.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 161992245,
      stop : 162074394,
      direction : "-",
      ID : "ENSG00000197635.11",
      gene_id : "ENSG00000197635.11",
      gene_type : "protein_coding",
      gene_name : "DPP4",
      gene_level : 2,
      hgnc_id : "HGNC:3009",
      havana_gene : "OTTHUMG00000132056.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 162142882,
      stop : 162152404,
      direction : "-",
      ID : "ENSG00000115263.15",
      gene_id : "ENSG00000115263.15",
      gene_type : "protein_coding",
      gene_name : "GCG",
      gene_level : 2,
      hgnc_id : "HGNC:4191",
      havana_gene : "OTTHUMG00000153892.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 162170684,
      stop : 162245151,
      direction : "-",
      ID : "ENSG00000078098.14",
      gene_id : "ENSG00000078098.14",
      gene_type : "protein_coding",
      gene_name : "FAP",
      gene_level : 2,
      hgnc_id : "HGNC:3590",
      havana_gene : "OTTHUMG00000153890.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 162267074,
      stop : 162318684,
      direction : "-",
      ID : "ENSG00000115267.9",
      gene_id : "ENSG00000115267.9",
      gene_type : "protein_coding",
      gene_name : "IFIH1",
      gene_level : 2,
      hgnc_id : "HGNC:18873",
      havana_gene : "OTTHUMG00000132055.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 162318840,
      stop : 162371595,
      direction : "+",
      ID : "ENSG00000115271.11",
      gene_id : "ENSG00000115271.11",
      gene_type : "protein_coding",
      gene_name : "GCA",
      gene_level : 1,
      hgnc_id : "HGNC:15990",
      havana_gene : "OTTHUMG00000132057.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 162371407,
      stop : 162838767,
      direction : "-",
      ID : "ENSG00000184611.12",
      gene_id : "ENSG00000184611.12",
      gene_type : "protein_coding",
      gene_name : "KCNH7",
      gene_level : 2,
      hgnc_id : "HGNC:18863",
      havana_gene : "OTTHUMG00000132069.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 163593396,
      stop : 163736012,
      direction : "-",
      ID : "ENSG00000182263.14",
      gene_id : "ENSG00000182263.14",
      gene_type : "protein_coding",
      gene_name : "FIGN",
      gene_level : 2,
      hgnc_id : "HGNC:13285",
      havana_gene : "OTTHUMG00000074059.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 164492417,
      stop : 164621482,
      direction : "-",
      ID : "ENSG00000115290.10",
      gene_id : "ENSG00000115290.10",
      gene_type : "protein_coding",
      gene_name : "GRB14",
      gene_level : 1,
      hgnc_id : "HGNC:4565",
      havana_gene : "OTTHUMG00000132135.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 164653624,
      stop : 164843679,
      direction : "-",
      ID : "ENSG00000082438.18",
      gene_id : "ENSG00000082438.18",
      gene_type : "protein_coding",
      gene_name : "COBLL1",
      gene_level : 2,
      hgnc_id : "HGNC:23571",
      havana_gene : "OTTHUMG00000074019.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 164896186,
      stop : 164955525,
      direction : "-",
      ID : "ENSG00000169507.9",
      gene_id : "ENSG00000169507.9",
      gene_type : "protein_coding",
      gene_name : "SLC38A11",
      gene_level : 1,
      hgnc_id : "HGNC:26836",
      havana_gene : "OTTHUMG00000132144.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 165087526,
      stop : 165204050,
      direction : "-",
      ID : "ENSG00000153253.19",
      gene_id : "ENSG00000153253.19",
      gene_type : "protein_coding",
      gene_name : "SCN3A",
      gene_level : 2,
      hgnc_id : "HGNC:10590",
      havana_gene : "OTTHUMG00000044171.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 165194993,
      stop : 165392310,
      direction : "+",
      ID : "ENSG00000136531.18",
      gene_id : "ENSG00000136531.18",
      gene_type : "protein_coding",
      gene_name : "SCN2A",
      gene_level : 2,
      hgnc_id : "HGNC:10588",
      havana_gene : "OTTHUMG00000044172.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 165469647,
      stop : 165689407,
      direction : "+",
      ID : "ENSG00000178662.16",
      gene_id : "ENSG00000178662.16",
      gene_type : "protein_coding",
      gene_name : "CSRNP3",
      gene_level : 1,
      hgnc_id : "HGNC:30729",
      havana_gene : "OTTHUMG00000132145.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 165747588,
      stop : 165794659,
      direction : "-",
      ID : "ENSG00000115339.14",
      gene_id : "ENSG00000115339.14",
      gene_type : "protein_coding",
      gene_name : "GALNT3",
      gene_level : 2,
      hgnc_id : "HGNC:4125",
      havana_gene : "OTTHUMG00000132157.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 165857475,
      stop : 165953851,
      direction : "-",
      ID : "ENSG00000123607.16",
      gene_id : "ENSG00000123607.16",
      gene_type : "protein_coding",
      gene_name : "TTC21B",
      gene_level : 1,
      hgnc_id : "HGNC:25660",
      havana_gene : "OTTHUMG00000154083.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 165984641,
      stop : 166149214,
      direction : "-",
      ID : "ENSG00000144285.22",
      gene_id : "ENSG00000144285.22",
      gene_type : "protein_coding",
      gene_name : "SCN1A",
      gene_level : 1,
      hgnc_id : "HGNC:10585",
      havana_gene : "OTTHUMG00000044173.20",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 166195185,
      stop : 166376001,
      direction : "-",
      ID : "ENSG00000169432.18",
      gene_id : "ENSG00000169432.18",
      gene_type : "protein_coding",
      gene_name : "SCN9A",
      gene_level : 2,
      hgnc_id : "HGNC:10597",
      havana_gene : "OTTHUMG00000154044.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 166403573,
      stop : 166611482,
      direction : "-",
      ID : "ENSG00000136546.16",
      gene_id : "ENSG00000136546.16",
      gene_type : "protein_coding",
      gene_name : "SCN7A",
      gene_level : 2,
      hgnc_id : "HGNC:10594",
      havana_gene : "OTTHUMG00000154078.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 166888480,
      stop : 167259753,
      direction : "+",
      ID : "ENSG00000163092.21",
      gene_id : "ENSG00000163092.21",
      gene_type : "protein_coding",
      gene_name : "XIRP2",
      gene_level : 1,
      hgnc_id : "HGNC:14303",
      havana_gene : "OTTHUMG00000154027.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 167868948,
      stop : 167874041,
      direction : "+",
      ID : "ENSG00000172318.5",
      gene_id : "ENSG00000172318.5",
      gene_type : "protein_coding",
      gene_name : "B3GALT1",
      gene_level : 2,
      hgnc_id : "HGNC:916",
      havana_gene : "OTTHUMG00000132163.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 167954020,
      stop : 168247595,
      direction : "-",
      ID : "ENSG00000198648.11",
      gene_id : "ENSG00000198648.11",
      gene_type : "protein_coding",
      gene_name : "STK39",
      gene_level : 2,
      hgnc_id : "HGNC:17717",
      havana_gene : "OTTHUMG00000133745.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 168456249,
      stop : 168775134,
      direction : "+",
      ID : "ENSG00000172292.15",
      gene_id : "ENSG00000172292.15",
      gene_type : "protein_coding",
      gene_name : "CERS6",
      gene_level : 2,
      hgnc_id : "HGNC:23826",
      havana_gene : "OTTHUMG00000132183.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 168786539,
      stop : 168865514,
      direction : "+",
      ID : "ENSG00000163072.16",
      gene_id : "ENSG00000163072.16",
      gene_type : "protein_coding",
      gene_name : "NOSTRIN",
      gene_level : 1,
      hgnc_id : "HGNC:20203",
      havana_gene : "OTTHUMG00000153990.20",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 168834132,
      stop : 168913371,
      direction : "-",
      ID : "ENSG00000152253.9",
      gene_id : "ENSG00000152253.9",
      gene_type : "protein_coding",
      gene_name : "SPC25",
      gene_level : 2,
      hgnc_id : "HGNC:24031",
      havana_gene : "OTTHUMG00000132181.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 168901291,
      stop : 168910000,
      direction : "+",
      ID : "ENSG00000152254.11",
      gene_id : "ENSG00000152254.11",
      gene_type : "protein_coding",
      gene_name : "G6PC2",
      gene_level : 2,
      hgnc_id : "HGNC:28906",
      havana_gene : "OTTHUMG00000132182.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 168915498,
      stop : 169031324,
      direction : "-",
      ID : "ENSG00000073734.10",
      gene_id : "ENSG00000073734.10",
      gene_type : "protein_coding",
      gene_name : "ABCB11",
      gene_level : 2,
      hgnc_id : "HGNC:42",
      havana_gene : "OTTHUMG00000154039.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169064789,
      stop : 169096167,
      direction : "+",
      ID : "ENSG00000073737.17",
      gene_id : "ENSG00000073737.17",
      gene_type : "protein_coding",
      gene_name : "DHRS9",
      gene_level : 2,
      hgnc_id : "HGNC:16888",
      havana_gene : "OTTHUMG00000132180.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169127109,
      stop : 169362534,
      direction : "-",
      ID : "ENSG00000081479.15",
      gene_id : "ENSG00000081479.15",
      gene_type : "protein_coding",
      gene_name : "LRP2",
      gene_level : 1,
      hgnc_id : "HGNC:6694",
      havana_gene : "OTTHUMG00000132179.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169479480,
      stop : 169506655,
      direction : "+",
      ID : "ENSG00000163093.12",
      gene_id : "ENSG00000163093.12",
      gene_type : "protein_coding",
      gene_name : "BBS5",
      gene_level : 2,
      hgnc_id : "HGNC:970",
      havana_gene : "OTTHUMG00000132207.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169479480,
      stop : 169525922,
      direction : "+",
      ID : "ENSG00000251569.1",
      gene_id : "ENSG00000251569.1",
      gene_type : "protein_coding",
      gene_name : "AC093899.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162280.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169509702,
      stop : 169526258,
      direction : "+",
      ID : "ENSG00000239474.7",
      gene_id : "ENSG00000239474.7",
      gene_type : "protein_coding",
      gene_name : "KLHL41",
      gene_level : 2,
      hgnc_id : "HGNC:16905",
      havana_gene : "OTTHUMG00000132205.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169528508,
      stop : 169573875,
      direction : "-",
      ID : "ENSG00000138399.18",
      gene_id : "ENSG00000138399.18",
      gene_type : "protein_coding",
      gene_name : "FASTKD1",
      gene_level : 1,
      hgnc_id : "HGNC:26150",
      havana_gene : "OTTHUMG00000154953.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169584342,
      stop : 169641406,
      direction : "+",
      ID : "ENSG00000138398.17",
      gene_id : "ENSG00000138398.17",
      gene_type : "protein_coding",
      gene_name : "PPIG",
      gene_level : 1,
      hgnc_id : "HGNC:14650",
      havana_gene : "OTTHUMG00000132206.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169645425,
      stop : 169694405,
      direction : "-",
      ID : "ENSG00000154479.13",
      gene_id : "ENSG00000154479.13",
      gene_type : "protein_coding",
      gene_name : "CCDC173",
      gene_level : 2,
      hgnc_id : "HGNC:25064",
      havana_gene : "OTTHUMG00000154116.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169694454,
      stop : 169701708,
      direction : "+",
      ID : "ENSG00000144362.12",
      gene_id : "ENSG00000144362.12",
      gene_type : "protein_coding",
      gene_name : "PHOSPHO2",
      gene_level : 2,
      hgnc_id : "HGNC:28316",
      havana_gene : "OTTHUMG00000153981.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169694488,
      stop : 169776989,
      direction : "+",
      ID : "ENSG00000213160.10",
      gene_id : "ENSG00000213160.10",
      gene_type : "protein_coding",
      gene_name : "KLHL23",
      gene_level : 2,
      hgnc_id : "HGNC:27506",
      havana_gene : "OTTHUMG00000132213.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169791933,
      stop : 169812064,
      direction : "+",
      ID : "ENSG00000138385.16",
      gene_id : "ENSG00000138385.16",
      gene_type : "protein_coding",
      gene_name : "SSB",
      gene_level : 1,
      hgnc_id : "HGNC:11316",
      havana_gene : "OTTHUMG00000132212.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169810081,
      stop : 169824931,
      direction : "-",
      ID : "ENSG00000138382.15",
      gene_id : "ENSG00000138382.15",
      gene_type : "protein_coding",
      gene_name : "METTL5",
      gene_level : 1,
      hgnc_id : "HGNC:25006",
      havana_gene : "OTTHUMG00000154117.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 169827454,
      stop : 170084131,
      direction : "+",
      ID : "ENSG00000144357.18",
      gene_id : "ENSG00000144357.18",
      gene_type : "protein_coding",
      gene_name : "UBR3",
      gene_level : 2,
      hgnc_id : "HGNC:30467",
      havana_gene : "OTTHUMG00000132229.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 170178145,
      stop : 170655171,
      direction : "+",
      ID : "ENSG00000071909.19",
      gene_id : "ENSG00000071909.19",
      gene_type : "protein_coding",
      gene_name : "MYO3B",
      gene_level : 2,
      hgnc_id : "HGNC:15576",
      havana_gene : "OTTHUMG00000154002.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 170715337,
      stop : 170718078,
      direction : "+",
      ID : "ENSG00000204335.4",
      gene_id : "ENSG00000204335.4",
      gene_type : "protein_coding",
      gene_name : "SP5",
      gene_level : 2,
      hgnc_id : "HGNC:14529",
      havana_gene : "OTTHUMG00000154053.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 170783786,
      stop : 170798971,
      direction : "+",
      ID : "ENSG00000204334.7",
      gene_id : "ENSG00000204334.7",
      gene_type : "protein_coding",
      gene_name : "ERICH2",
      gene_level : 1,
      hgnc_id : "HGNC:44395",
      havana_gene : "OTTHUMG00000154074.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 170813213,
      stop : 170861151,
      direction : "+",
      ID : "ENSG00000128683.14",
      gene_id : "ENSG00000128683.14",
      gene_type : "protein_coding",
      gene_name : "GAD1",
      gene_level : 2,
      hgnc_id : "HGNC:4092",
      havana_gene : "OTTHUMG00000044175.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 170928464,
      stop : 170967130,
      direction : "+",
      ID : "ENSG00000115806.13",
      gene_id : "ENSG00000115806.13",
      gene_type : "protein_coding",
      gene_name : "GORASP2",
      gene_level : 2,
      hgnc_id : "HGNC:17500",
      havana_gene : "OTTHUMG00000154072.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 170990823,
      stop : 171231314,
      direction : "-",
      ID : "ENSG00000198586.14",
      gene_id : "ENSG00000198586.14",
      gene_type : "protein_coding",
      gene_name : "TLK1",
      gene_level : 2,
      hgnc_id : "HGNC:11841",
      havana_gene : "OTTHUMG00000132243.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171317405,
      stop : 171434802,
      direction : "-",
      ID : "ENSG00000123600.20",
      gene_id : "ENSG00000123600.20",
      gene_type : "protein_coding",
      gene_name : "METTL8",
      gene_level : 1,
      hgnc_id : "HGNC:25856",
      havana_gene : "OTTHUMG00000132261.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171434217,
      stop : 171485052,
      direction : "+",
      ID : "ENSG00000115827.14",
      gene_id : "ENSG00000115827.14",
      gene_type : "protein_coding",
      gene_name : "DCAF17",
      gene_level : 2,
      hgnc_id : "HGNC:25784",
      havana_gene : "OTTHUMG00000132259.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171522247,
      stop : 171558129,
      direction : "+",
      ID : "ENSG00000071967.12",
      gene_id : "ENSG00000071967.12",
      gene_type : "protein_coding",
      gene_name : "CYBRD1",
      gene_level : 1,
      hgnc_id : "HGNC:20797",
      havana_gene : "OTTHUMG00000132260.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171687409,
      stop : 171750158,
      direction : "+",
      ID : "ENSG00000077380.16",
      gene_id : "ENSG00000077380.16",
      gene_type : "protein_coding",
      gene_name : "DYNC1I2",
      gene_level : 1,
      hgnc_id : "HGNC:2964",
      havana_gene : "OTTHUMG00000154061.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171783405,
      stop : 171999859,
      direction : "-",
      ID : "ENSG00000115840.14",
      gene_id : "ENSG00000115840.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A12",
      gene_level : 2,
      hgnc_id : "HGNC:10982",
      havana_gene : "OTTHUMG00000134290.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171922448,
      stop : 171983686,
      direction : "+",
      ID : "ENSG00000128708.13",
      gene_id : "ENSG00000128708.13",
      gene_type : "protein_coding",
      gene_name : "HAT1",
      gene_level : 2,
      hgnc_id : "HGNC:4821",
      havana_gene : "OTTHUMG00000132282.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 171999943,
      stop : 172082430,
      direction : "+",
      ID : "ENSG00000172878.14",
      gene_id : "ENSG00000172878.14",
      gene_type : "protein_coding",
      gene_name : "METAP1D",
      gene_level : 2,
      hgnc_id : "HGNC:32583",
      havana_gene : "OTTHUMG00000132283.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 172084740,
      stop : 172089677,
      direction : "+",
      ID : "ENSG00000144355.15",
      gene_id : "ENSG00000144355.15",
      gene_type : "protein_coding",
      gene_name : "DLX1",
      gene_level : 1,
      hgnc_id : "HGNC:2914",
      havana_gene : "OTTHUMG00000073951.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 172099438,
      stop : 172102900,
      direction : "-",
      ID : "ENSG00000115844.11",
      gene_id : "ENSG00000115844.11",
      gene_type : "protein_coding",
      gene_name : "DLX2",
      gene_level : 2,
      hgnc_id : "HGNC:2915",
      havana_gene : "OTTHUMG00000132276.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 172427354,
      stop : 172506459,
      direction : "+",
      ID : "ENSG00000091409.15",
      gene_id : "ENSG00000091409.15",
      gene_type : "protein_coding",
      gene_name : "ITGA6",
      gene_level : 2,
      hgnc_id : "HGNC:6142",
      havana_gene : "OTTHUMG00000132277.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 172555373,
      stop : 172608669,
      direction : "+",
      ID : "ENSG00000152256.14",
      gene_id : "ENSG00000152256.14",
      gene_type : "protein_coding",
      gene_name : "PDK1",
      gene_level : 1,
      hgnc_id : "HGNC:8809",
      havana_gene : "OTTHUMG00000132285.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 172735274,
      stop : 173052893,
      direction : "+",
      ID : "ENSG00000091428.18",
      gene_id : "ENSG00000091428.18",
      gene_type : "protein_coding",
      gene_name : "RAPGEF4",
      gene_level : 2,
      hgnc_id : "HGNC:16626",
      havana_gene : "OTTHUMG00000133677.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 173075435,
      stop : 173268015,
      direction : "+",
      ID : "ENSG00000091436.17",
      gene_id : "ENSG00000091436.17",
      gene_type : "protein_coding",
      gene_name : "MAP3K20",
      gene_level : 2,
      hgnc_id : "HGNC:17797",
      havana_gene : "OTTHUMG00000132297.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 173354820,
      stop : 173368997,
      direction : "+",
      ID : "ENSG00000144354.14",
      gene_id : "ENSG00000144354.14",
      gene_type : "protein_coding",
      gene_name : "CDCA7",
      gene_level : 2,
      hgnc_id : "HGNC:14628",
      havana_gene : "OTTHUMG00000132296.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 173880850,
      stop : 173965702,
      direction : "-",
      ID : "ENSG00000172845.17",
      gene_id : "ENSG00000172845.17",
      gene_type : "protein_coding",
      gene_name : "SP3",
      gene_level : 2,
      hgnc_id : "HGNC:11208",
      havana_gene : "OTTHUMG00000132333.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174072447,
      stop : 174248599,
      direction : "-",
      ID : "ENSG00000138430.16",
      gene_id : "ENSG00000138430.16",
      gene_type : "protein_coding",
      gene_name : "OLA1",
      gene_level : 1,
      hgnc_id : "HGNC:28833",
      havana_gene : "OTTHUMG00000132335.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174334954,
      stop : 174338500,
      direction : "+",
      ID : "ENSG00000217236.2",
      gene_id : "ENSG00000217236.2",
      gene_type : "protein_coding",
      gene_name : "SP9",
      gene_level : 1,
      hgnc_id : "HGNC:30690",
      havana_gene : "OTTHUMG00000150371.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174348022,
      stop : 174395712,
      direction : "-",
      ID : "ENSG00000138433.16",
      gene_id : "ENSG00000138433.16",
      gene_type : "protein_coding",
      gene_name : "CIR1",
      gene_level : 1,
      hgnc_id : "HGNC:24217",
      havana_gene : "OTTHUMG00000132338.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174395730,
      stop : 174429575,
      direction : "+",
      ID : "ENSG00000144306.15",
      gene_id : "ENSG00000144306.15",
      gene_type : "protein_coding",
      gene_name : "SCRN3",
      gene_level : 1,
      hgnc_id : "HGNC:30382",
      havana_gene : "OTTHUMG00000132332.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174431571,
      stop : 174487094,
      direction : "-",
      ID : "ENSG00000163328.14",
      gene_id : "ENSG00000163328.14",
      gene_type : "protein_coding",
      gene_name : "GPR155",
      gene_level : 2,
      hgnc_id : "HGNC:22951",
      havana_gene : "OTTHUMG00000132336.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174559572,
      stop : 174682916,
      direction : "-",
      ID : "ENSG00000115935.18",
      gene_id : "ENSG00000115935.18",
      gene_type : "protein_coding",
      gene_name : "WIPF1",
      gene_level : 1,
      hgnc_id : "HGNC:12736",
      havana_gene : "OTTHUMG00000132334.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174747592,
      stop : 174787935,
      direction : "-",
      ID : "ENSG00000138435.16",
      gene_id : "ENSG00000138435.16",
      gene_type : "protein_coding",
      gene_name : "CHRNA1",
      gene_level : 1,
      hgnc_id : "HGNC:1955",
      havana_gene : "OTTHUMG00000132357.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 174798809,
      stop : 175005381,
      direction : "-",
      ID : "ENSG00000128656.15",
      gene_id : "ENSG00000128656.15",
      gene_type : "protein_coding",
      gene_name : "CHN1",
      gene_level : 2,
      hgnc_id : "HGNC:1943",
      havana_gene : "OTTHUMG00000154225.36",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 175072250,
      stop : 175168382,
      direction : "-",
      ID : "ENSG00000115966.17",
      gene_id : "ENSG00000115966.17",
      gene_type : "protein_coding",
      gene_name : "ATF2",
      gene_level : 1,
      hgnc_id : "HGNC:784",
      havana_gene : "OTTHUMG00000132424.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 175176258,
      stop : 175181710,
      direction : "-",
      ID : "ENSG00000154518.10",
      gene_id : "ENSG00000154518.10",
      gene_type : "protein_coding",
      gene_name : "ATP5MC3",
      gene_level : 2,
      hgnc_id : "HGNC:843",
      havana_gene : "OTTHUMG00000132425.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 175923882,
      stop : 176002839,
      direction : "-",
      ID : "ENSG00000144320.14",
      gene_id : "ENSG00000144320.14",
      gene_type : "protein_coding",
      gene_name : "LNPK",
      gene_level : 2,
      hgnc_id : "HGNC:21610",
      havana_gene : "OTTHUMG00000154112.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176077472,
      stop : 176083913,
      direction : "-",
      ID : "ENSG00000174279.4",
      gene_id : "ENSG00000174279.4",
      gene_type : "protein_coding",
      gene_name : "EVX2",
      gene_level : 2,
      hgnc_id : "HGNC:3507",
      havana_gene : "OTTHUMG00000154173.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176092721,
      stop : 176095944,
      direction : "+",
      ID : "ENSG00000128714.6",
      gene_id : "ENSG00000128714.6",
      gene_type : "protein_coding",
      gene_name : "HOXD13",
      gene_level : 1,
      hgnc_id : "HGNC:5136",
      havana_gene : "OTTHUMG00000132431.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176099795,
      stop : 176102489,
      direction : "+",
      ID : "ENSG00000170178.7",
      gene_id : "ENSG00000170178.7",
      gene_type : "protein_coding",
      gene_name : "HOXD12",
      gene_level : 2,
      hgnc_id : "HGNC:5135",
      havana_gene : "OTTHUMG00000150358.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176104216,
      stop : 176109754,
      direction : "+",
      ID : "ENSG00000128713.14",
      gene_id : "ENSG00000128713.14",
      gene_type : "protein_coding",
      gene_name : "HOXD11",
      gene_level : 1,
      hgnc_id : "HGNC:5134",
      havana_gene : "OTTHUMG00000132510.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176108790,
      stop : 176119937,
      direction : "+",
      ID : "ENSG00000128710.6",
      gene_id : "ENSG00000128710.6",
      gene_type : "protein_coding",
      gene_name : "HOXD10",
      gene_level : 1,
      hgnc_id : "HGNC:5133",
      havana_gene : "OTTHUMG00000132511.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176122719,
      stop : 176124937,
      direction : "+",
      ID : "ENSG00000128709.13",
      gene_id : "ENSG00000128709.13",
      gene_type : "protein_coding",
      gene_name : "HOXD9",
      gene_level : 2,
      hgnc_id : "HGNC:5140",
      havana_gene : "OTTHUMG00000132516.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176129694,
      stop : 176132695,
      direction : "+",
      ID : "ENSG00000175879.9",
      gene_id : "ENSG00000175879.9",
      gene_type : "protein_coding",
      gene_name : "HOXD8",
      gene_level : 1,
      hgnc_id : "HGNC:5139",
      havana_gene : "OTTHUMG00000132513.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176136612,
      stop : 176173102,
      direction : "+",
      ID : "ENSG00000128652.11",
      gene_id : "ENSG00000128652.11",
      gene_type : "protein_coding",
      gene_name : "HOXD3",
      gene_level : 2,
      hgnc_id : "HGNC:5137",
      havana_gene : "OTTHUMG00000187566.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176151550,
      stop : 176153226,
      direction : "+",
      ID : "ENSG00000170166.6",
      gene_id : "ENSG00000170166.6",
      gene_type : "protein_coding",
      gene_name : "HOXD4",
      gene_level : 2,
      hgnc_id : "HGNC:5138",
      havana_gene : "OTTHUMG00000132515.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176188668,
      stop : 176190907,
      direction : "+",
      ID : "ENSG00000128645.15",
      gene_id : "ENSG00000128645.15",
      gene_type : "protein_coding",
      gene_name : "HOXD1",
      gene_level : 2,
      hgnc_id : "HGNC:5132",
      havana_gene : "OTTHUMG00000132512.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 176269395,
      stop : 176338025,
      direction : "+",
      ID : "ENSG00000128654.14",
      gene_id : "ENSG00000128654.14",
      gene_type : "protein_coding",
      gene_name : "MTX2",
      gene_level : 2,
      hgnc_id : "HGNC:7506",
      havana_gene : "OTTHUMG00000132514.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177212563,
      stop : 177223958,
      direction : "+",
      ID : "ENSG00000170144.21",
      gene_id : "ENSG00000170144.21",
      gene_type : "protein_coding",
      gene_name : "HNRNPA3",
      gene_level : 2,
      hgnc_id : "HGNC:24941",
      havana_gene : "OTTHUMG00000132529.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177227595,
      stop : 177392697,
      direction : "-",
      ID : "ENSG00000116044.16",
      gene_id : "ENSG00000116044.16",
      gene_type : "protein_coding",
      gene_name : "NFE2L2",
      gene_level : 1,
      hgnc_id : "HGNC:7782",
      havana_gene : "OTTHUMG00000133620.18",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177392746,
      stop : 177567024,
      direction : "+",
      ID : "ENSG00000018510.18",
      gene_id : "ENSG00000018510.18",
      gene_type : "protein_coding",
      gene_name : "AGPS",
      gene_level : 2,
      hgnc_id : "HGNC:327",
      havana_gene : "OTTHUMG00000132530.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177548998,
      stop : 177552796,
      direction : "-",
      ID : "ENSG00000196659.10",
      gene_id : "ENSG00000196659.10",
      gene_type : "protein_coding",
      gene_name : "TTC30B",
      gene_level : 2,
      hgnc_id : "HGNC:26425",
      havana_gene : "OTTHUMG00000154166.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177612999,
      stop : 177618742,
      direction : "-",
      ID : "ENSG00000197557.7",
      gene_id : "ENSG00000197557.7",
      gene_type : "protein_coding",
      gene_name : "TTC30A",
      gene_level : 2,
      hgnc_id : "HGNC:25853",
      havana_gene : "OTTHUMG00000132528.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177623244,
      stop : 178072777,
      direction : "-",
      ID : "ENSG00000128655.18",
      gene_id : "ENSG00000128655.18",
      gene_type : "protein_coding",
      gene_name : "PDE11A",
      gene_level : 2,
      hgnc_id : "HGNC:8773",
      havana_gene : "OTTHUMG00000154188.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 177628069,
      stop : 178108339,
      direction : "-",
      ID : "ENSG00000284741.1",
      gene_id : "ENSG00000284741.1",
      gene_type : "protein_coding",
      gene_name : "PDE11A",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192246.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178112424,
      stop : 178139011,
      direction : "+",
      ID : "ENSG00000155636.15",
      gene_id : "ENSG00000155636.15",
      gene_type : "protein_coding",
      gene_name : "RBM45",
      gene_level : 2,
      hgnc_id : "HGNC:24468",
      havana_gene : "OTTHUMG00000154202.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178194481,
      stop : 178402893,
      direction : "+",
      ID : "ENSG00000079156.17",
      gene_id : "ENSG00000079156.17",
      gene_type : "protein_coding",
      gene_name : "OSBPL6",
      gene_level : 2,
      hgnc_id : "HGNC:16388",
      havana_gene : "OTTHUMG00000132579.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178431292,
      stop : 178451512,
      direction : "-",
      ID : "ENSG00000180228.14",
      gene_id : "ENSG00000180228.14",
      gene_type : "protein_coding",
      gene_name : "PRKRA",
      gene_level : 2,
      hgnc_id : "HGNC:9438",
      havana_gene : "OTTHUMG00000132576.27",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178451346,
      stop : 178462102,
      direction : "+",
      ID : "ENSG00000204311.15",
      gene_id : "ENSG00000204311.15",
      gene_type : "protein_coding",
      gene_name : "PJVK",
      gene_level : 1,
      hgnc_id : "HGNC:29502",
      havana_gene : "OTTHUMG00000154425.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178463664,
      stop : 178478600,
      direction : "-",
      ID : "ENSG00000079150.18",
      gene_id : "ENSG00000079150.18",
      gene_type : "protein_coding",
      gene_name : "FKBP7",
      gene_level : 2,
      hgnc_id : "HGNC:3723",
      havana_gene : "OTTHUMG00000132577.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178480457,
      stop : 178516463,
      direction : "+",
      ID : "ENSG00000116095.11",
      gene_id : "ENSG00000116095.11",
      gene_type : "protein_coding",
      gene_name : "PLEKHA3",
      gene_level : 1,
      hgnc_id : "HGNC:14338",
      havana_gene : "OTTHUMG00000154446.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178525989,
      stop : 178830802,
      direction : "-",
      ID : "ENSG00000155657.28",
      gene_id : "ENSG00000155657.28",
      gene_type : "protein_coding",
      gene_name : "TTN",
      gene_level : 1,
      hgnc_id : "HGNC:12403",
      havana_gene : "OTTHUMG00000154448.23",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 178829757,
      stop : 179050086,
      direction : "-",
      ID : "ENSG00000163492.15",
      gene_id : "ENSG00000163492.15",
      gene_type : "protein_coding",
      gene_name : "CCDC141",
      gene_level : 2,
      hgnc_id : "HGNC:26821",
      havana_gene : "OTTHUMG00000132578.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 179101678,
      stop : 179264832,
      direction : "-",
      ID : "ENSG00000187231.14",
      gene_id : "ENSG00000187231.14",
      gene_type : "protein_coding",
      gene_name : "SESTD1",
      gene_level : 2,
      hgnc_id : "HGNC:18379",
      havana_gene : "OTTHUMG00000154554.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 179441982,
      stop : 179861612,
      direction : "-",
      ID : "ENSG00000144331.20",
      gene_id : "ENSG00000144331.20",
      gene_type : "protein_coding",
      gene_name : "ZNF385B",
      gene_level : 2,
      hgnc_id : "HGNC:26332",
      havana_gene : "OTTHUMG00000154559.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 179944876,
      stop : 180007297,
      direction : "-",
      ID : "ENSG00000163510.14",
      gene_id : "ENSG00000163510.14",
      gene_type : "protein_coding",
      gene_name : "CWC22",
      gene_level : 2,
      hgnc_id : "HGNC:29322",
      havana_gene : "OTTHUMG00000154244.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 180967248,
      stop : 181076585,
      direction : "+",
      ID : "ENSG00000170035.16",
      gene_id : "ENSG00000170035.16",
      gene_type : "protein_coding",
      gene_name : "UBE2E3",
      gene_level : 1,
      hgnc_id : "HGNC:12479",
      havana_gene : "OTTHUMG00000132585.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 181457202,
      stop : 181538940,
      direction : "+",
      ID : "ENSG00000115232.14",
      gene_id : "ENSG00000115232.14",
      gene_type : "protein_coding",
      gene_name : "ITGA4",
      gene_level : 1,
      hgnc_id : "HGNC:6140",
      havana_gene : "OTTHUMG00000154212.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 181536672,
      stop : 181680665,
      direction : "-",
      ID : "ENSG00000188452.14",
      gene_id : "ENSG00000188452.14",
      gene_type : "protein_coding",
      gene_name : "CERKL",
      gene_level : 2,
      hgnc_id : "HGNC:21699",
      havana_gene : "OTTHUMG00000154315.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 181673088,
      stop : 181680547,
      direction : "-",
      ID : "ENSG00000162992.4",
      gene_id : "ENSG00000162992.4",
      gene_type : "protein_coding",
      gene_name : "NEUROD1",
      gene_level : 2,
      hgnc_id : "HGNC:7762",
      havana_gene : "OTTHUMG00000132583.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 181891730,
      stop : 181930738,
      direction : "+",
      ID : "ENSG00000138434.17",
      gene_id : "ENSG00000138434.17",
      gene_type : "protein_coding",
      gene_name : "ITPRID2",
      gene_level : 1,
      hgnc_id : "HGNC:11319",
      havana_gene : "OTTHUMG00000132584.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 181954241,
      stop : 182131398,
      direction : "+",
      ID : "ENSG00000150722.10",
      gene_id : "ENSG00000150722.10",
      gene_type : "protein_coding",
      gene_name : "PPP1R1C",
      gene_level : 1,
      hgnc_id : "HGNC:14940",
      havana_gene : "OTTHUMG00000154326.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 182140036,
      stop : 182523192,
      direction : "-",
      ID : "ENSG00000115252.18",
      gene_id : "ENSG00000115252.18",
      gene_type : "protein_coding",
      gene_name : "PDE1A",
      gene_level : 2,
      hgnc_id : "HGNC:8774",
      havana_gene : "OTTHUMG00000132596.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 182716255,
      stop : 182794464,
      direction : "+",
      ID : "ENSG00000077232.19",
      gene_id : "ENSG00000077232.19",
      gene_type : "protein_coding",
      gene_name : "DNAJC10",
      gene_level : 2,
      hgnc_id : "HGNC:24637",
      havana_gene : "OTTHUMG00000154209.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 182833275,
      stop : 182866637,
      direction : "-",
      ID : "ENSG00000162998.5",
      gene_id : "ENSG00000162998.5",
      gene_type : "protein_coding",
      gene_name : "FRZB",
      gene_level : 2,
      hgnc_id : "HGNC:3959",
      havana_gene : "OTTHUMG00000132597.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 182909115,
      stop : 183038858,
      direction : "-",
      ID : "ENSG00000061676.15",
      gene_id : "ENSG00000061676.15",
      gene_type : "protein_coding",
      gene_name : "NCKAP1",
      gene_level : 2,
      hgnc_id : "HGNC:7666",
      havana_gene : "OTTHUMG00000132623.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 183078559,
      stop : 183100008,
      direction : "+",
      ID : "ENSG00000162999.13",
      gene_id : "ENSG00000162999.13",
      gene_type : "protein_coding",
      gene_name : "DUSP19",
      gene_level : 2,
      hgnc_id : "HGNC:18894",
      havana_gene : "OTTHUMG00000132622.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 183117513,
      stop : 183161680,
      direction : "+",
      ID : "ENSG00000163002.13",
      gene_id : "ENSG00000163002.13",
      gene_type : "protein_coding",
      gene_name : "NUP35",
      gene_level : 1,
      hgnc_id : "HGNC:29797",
      havana_gene : "OTTHUMG00000132621.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 184598529,
      stop : 184939492,
      direction : "+",
      ID : "ENSG00000170396.9",
      gene_id : "ENSG00000170396.9",
      gene_type : "protein_coding",
      gene_name : "ZNF804A",
      gene_level : 2,
      hgnc_id : "HGNC:21711",
      havana_gene : "OTTHUMG00000132625.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 185738804,
      stop : 185833290,
      direction : "+",
      ID : "ENSG00000188738.15",
      gene_id : "ENSG00000188738.15",
      gene_type : "protein_coding",
      gene_name : "FSIP2",
      gene_level : 2,
      hgnc_id : "HGNC:21675",
      havana_gene : "OTTHUMG00000153874.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 186486253,
      stop : 186509361,
      direction : "+",
      ID : "ENSG00000065548.18",
      gene_id : "ENSG00000065548.18",
      gene_type : "protein_coding",
      gene_name : "ZC3H15",
      gene_level : 1,
      hgnc_id : "HGNC:29528",
      havana_gene : "OTTHUMG00000154251.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 186590056,
      stop : 186680901,
      direction : "+",
      ID : "ENSG00000138448.12",
      gene_id : "ENSG00000138448.12",
      gene_type : "protein_coding",
      gene_name : "ITGAV",
      gene_level : 2,
      hgnc_id : "HGNC:6150",
      havana_gene : "OTTHUMG00000132635.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 186694060,
      stop : 186765959,
      direction : "+",
      ID : "ENSG00000144369.13",
      gene_id : "ENSG00000144369.13",
      gene_type : "protein_coding",
      gene_name : "FAM171B",
      gene_level : 2,
      hgnc_id : "HGNC:29412",
      havana_gene : "OTTHUMG00000154278.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 186827475,
      stop : 186849208,
      direction : "-",
      ID : "ENSG00000163012.4",
      gene_id : "ENSG00000163012.4",
      gene_type : "protein_coding",
      gene_name : "ZSWIM2",
      gene_level : 2,
      hgnc_id : "HGNC:30990",
      havana_gene : "OTTHUMG00000154259.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 187341964,
      stop : 187448460,
      direction : "-",
      ID : "ENSG00000064989.13",
      gene_id : "ENSG00000064989.13",
      gene_type : "protein_coding",
      gene_name : "CALCRL",
      gene_level : 2,
      hgnc_id : "HGNC:16709",
      havana_gene : "OTTHUMG00000132636.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 187464230,
      stop : 187565760,
      direction : "-",
      ID : "ENSG00000003436.16",
      gene_id : "ENSG00000003436.16",
      gene_type : "protein_coding",
      gene_name : "TFPI",
      gene_level : 2,
      hgnc_id : "HGNC:11760",
      havana_gene : "OTTHUMG00000132634.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 188291669,
      stop : 188595931,
      direction : "+",
      ID : "ENSG00000144366.16",
      gene_id : "ENSG00000144366.16",
      gene_type : "protein_coding",
      gene_name : "GULP1",
      gene_level : 1,
      hgnc_id : "HGNC:18649",
      havana_gene : "OTTHUMG00000132647.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 188974373,
      stop : 189012746,
      direction : "+",
      ID : "ENSG00000168542.16",
      gene_id : "ENSG00000168542.16",
      gene_type : "protein_coding",
      gene_name : "COL3A1",
      gene_level : 2,
      hgnc_id : "HGNC:2201",
      havana_gene : "OTTHUMG00000132648.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189031898,
      stop : 189225312,
      direction : "-",
      ID : "ENSG00000204262.14",
      gene_id : "ENSG00000204262.14",
      gene_type : "protein_coding",
      gene_name : "COL5A2",
      gene_level : 2,
      hgnc_id : "HGNC:2210",
      havana_gene : "OTTHUMG00000149842.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189441446,
      stop : 189475552,
      direction : "+",
      ID : "ENSG00000115368.10",
      gene_id : "ENSG00000115368.10",
      gene_type : "protein_coding",
      gene_name : "WDR75",
      gene_level : 2,
      hgnc_id : "HGNC:25725",
      havana_gene : "OTTHUMG00000132660.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189560590,
      stop : 189583758,
      direction : "-",
      ID : "ENSG00000138449.11",
      gene_id : "ENSG00000138449.11",
      gene_type : "protein_coding",
      gene_name : "SLC40A1",
      gene_level : 2,
      hgnc_id : "HGNC:10909",
      havana_gene : "OTTHUMG00000132662.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189661385,
      stop : 189670831,
      direction : "+",
      ID : "ENSG00000138381.10",
      gene_id : "ENSG00000138381.10",
      gene_type : "protein_coding",
      gene_name : "ASNSD1",
      gene_level : 2,
      hgnc_id : "HGNC:24910",
      havana_gene : "OTTHUMG00000193522.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189661452,
      stop : 189666437,
      direction : "+",
      ID : "ENSG00000286053.2",
      gene_id : "ENSG00000286053.2",
      gene_type : "protein_coding",
      gene_name : "ASDURF",
      gene_level : 2,
      hgnc_id : "HGNC:53619",
      havana_gene : "OTTHUMG00000132665.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189661519,
      stop : 189667881,
      direction : "+",
      ID : "ENSG00000286165.1",
      gene_id : "ENSG00000286165.1",
      gene_type : "protein_coding",
      gene_name : "AC012488.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193523.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189674290,
      stop : 189761193,
      direction : "+",
      ID : "ENSG00000151687.14",
      gene_id : "ENSG00000151687.14",
      gene_type : "protein_coding",
      gene_name : "ANKAR",
      gene_level : 2,
      hgnc_id : "HGNC:26350",
      havana_gene : "OTTHUMG00000154398.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189746660,
      stop : 189763227,
      direction : "-",
      ID : "ENSG00000128694.12",
      gene_id : "ENSG00000128694.12",
      gene_type : "protein_coding",
      gene_name : "OSGEPL1",
      gene_level : 2,
      hgnc_id : "HGNC:23075",
      havana_gene : "OTTHUMG00000164096.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189770267,
      stop : 189784364,
      direction : "-",
      ID : "ENSG00000128699.14",
      gene_id : "ENSG00000128699.14",
      gene_type : "protein_coding",
      gene_name : "ORMDL1",
      gene_level : 2,
      hgnc_id : "HGNC:16036",
      havana_gene : "OTTHUMG00000132661.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189784085,
      stop : 189877629,
      direction : "+",
      ID : "ENSG00000064933.18",
      gene_id : "ENSG00000064933.18",
      gene_type : "protein_coding",
      gene_name : "PMS1",
      gene_level : 1,
      hgnc_id : "HGNC:9121",
      havana_gene : "OTTHUMG00000132664.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 189879609,
      stop : 190203484,
      direction : "+",
      ID : "ENSG00000187699.10",
      gene_id : "ENSG00000187699.10",
      gene_type : "protein_coding",
      gene_name : "C2orf88",
      gene_level : 2,
      hgnc_id : "HGNC:28191",
      havana_gene : "OTTHUMG00000154361.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190055700,
      stop : 190062729,
      direction : "-",
      ID : "ENSG00000138379.5",
      gene_id : "ENSG00000138379.5",
      gene_type : "protein_coding",
      gene_name : "MSTN",
      gene_level : 2,
      hgnc_id : "HGNC:4223",
      havana_gene : "OTTHUMG00000132663.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190189735,
      stop : 190344193,
      direction : "-",
      ID : "ENSG00000198130.16",
      gene_id : "ENSG00000198130.16",
      gene_type : "protein_coding",
      gene_name : "HIBCH",
      gene_level : 1,
      hgnc_id : "HGNC:4908",
      havana_gene : "OTTHUMG00000132673.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190343570,
      stop : 190371665,
      direction : "+",
      ID : "ENSG00000151689.13",
      gene_id : "ENSG00000151689.13",
      gene_type : "protein_coding",
      gene_name : "INPP1",
      gene_level : 2,
      hgnc_id : "HGNC:6071",
      havana_gene : "OTTHUMG00000132672.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190408355,
      stop : 190509205,
      direction : "+",
      ID : "ENSG00000151690.15",
      gene_id : "ENSG00000151690.15",
      gene_type : "protein_coding",
      gene_name : "MFSD6",
      gene_level : 1,
      hgnc_id : "HGNC:24711",
      havana_gene : "OTTHUMG00000132671.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190504338,
      stop : 190534722,
      direction : "-",
      ID : "ENSG00000189362.12",
      gene_id : "ENSG00000189362.12",
      gene_type : "protein_coding",
      gene_name : "NEMP2",
      gene_level : 1,
      hgnc_id : "HGNC:33700",
      havana_gene : "OTTHUMG00000154454.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190646746,
      stop : 190692766,
      direction : "+",
      ID : "ENSG00000138386.17",
      gene_id : "ENSG00000138386.17",
      gene_type : "protein_coding",
      gene_name : "NAB1",
      gene_level : 1,
      hgnc_id : "HGNC:7626",
      havana_gene : "OTTHUMG00000132689.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190880821,
      stop : 190965552,
      direction : "+",
      ID : "ENSG00000115419.13",
      gene_id : "ENSG00000115419.13",
      gene_type : "protein_coding",
      gene_name : "GLS",
      gene_level : 1,
      hgnc_id : "HGNC:4331",
      havana_gene : "OTTHUMG00000132701.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 190908460,
      stop : 191020960,
      direction : "-",
      ID : "ENSG00000115415.20",
      gene_id : "ENSG00000115415.20",
      gene_type : "protein_coding",
      gene_name : "STAT1",
      gene_level : 1,
      hgnc_id : "HGNC:11362",
      havana_gene : "OTTHUMG00000132699.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 191029576,
      stop : 191151596,
      direction : "-",
      ID : "ENSG00000138378.19",
      gene_id : "ENSG00000138378.19",
      gene_type : "protein_coding",
      gene_name : "STAT4",
      gene_level : 1,
      hgnc_id : "HGNC:11365",
      havana_gene : "OTTHUMG00000132700.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 191245185,
      stop : 191425389,
      direction : "+",
      ID : "ENSG00000128641.19",
      gene_id : "ENSG00000128641.19",
      gene_type : "protein_coding",
      gene_name : "MYO1B",
      gene_level : 1,
      hgnc_id : "HGNC:7596",
      havana_gene : "OTTHUMG00000132718.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 191678068,
      stop : 191741097,
      direction : "+",
      ID : "ENSG00000173559.15",
      gene_id : "ENSG00000173559.15",
      gene_type : "protein_coding",
      gene_name : "NABP1",
      gene_level : 2,
      hgnc_id : "HGNC:26232",
      havana_gene : "OTTHUMG00000132720.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 191834310,
      stop : 191847088,
      direction : "-",
      ID : "ENSG00000168497.5",
      gene_id : "ENSG00000168497.5",
      gene_type : "protein_coding",
      gene_name : "CAVIN2",
      gene_level : 2,
      hgnc_id : "HGNC:10690",
      havana_gene : "OTTHUMG00000154309.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 191949043,
      stop : 192194933,
      direction : "-",
      ID : "ENSG00000144339.12",
      gene_id : "ENSG00000144339.12",
      gene_type : "protein_coding",
      gene_name : "TMEFF2",
      gene_level : 1,
      hgnc_id : "HGNC:11867",
      havana_gene : "OTTHUMG00000132723.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 195575977,
      stop : 195737702,
      direction : "+",
      ID : "ENSG00000196950.14",
      gene_id : "ENSG00000196950.14",
      gene_type : "protein_coding",
      gene_name : "SLC39A10",
      gene_level : 2,
      hgnc_id : "HGNC:20861",
      havana_gene : "OTTHUMG00000154380.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 195737703,
      stop : 196068837,
      direction : "-",
      ID : "ENSG00000118997.14",
      gene_id : "ENSG00000118997.14",
      gene_type : "protein_coding",
      gene_name : "DNAH7",
      gene_level : 2,
      hgnc_id : "HGNC:18661",
      havana_gene : "OTTHUMG00000154438.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196133583,
      stop : 196176503,
      direction : "-",
      ID : "ENSG00000081320.11",
      gene_id : "ENSG00000081320.11",
      gene_type : "protein_coding",
      gene_name : "STK17B",
      gene_level : 2,
      hgnc_id : "HGNC:11396",
      havana_gene : "OTTHUMG00000132735.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196189099,
      stop : 196593684,
      direction : "-",
      ID : "ENSG00000138411.13",
      gene_id : "ENSG00000138411.13",
      gene_type : "protein_coding",
      gene_name : "HECW2",
      gene_level : 1,
      hgnc_id : "HGNC:29853",
      havana_gene : "OTTHUMG00000154435.13",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196639554,
      stop : 196763490,
      direction : "+",
      ID : "ENSG00000144395.18",
      gene_id : "ENSG00000144395.18",
      gene_type : "protein_coding",
      gene_name : "CCDC150",
      gene_level : 2,
      hgnc_id : "HGNC:26834",
      havana_gene : "OTTHUMG00000154475.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196763035,
      stop : 196799725,
      direction : "-",
      ID : "ENSG00000119041.11",
      gene_id : "ENSG00000119041.11",
      gene_type : "protein_coding",
      gene_name : "GTF3C3",
      gene_level : 1,
      hgnc_id : "HGNC:4666",
      havana_gene : "OTTHUMG00000154633.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196804417,
      stop : 196809355,
      direction : "-",
      ID : "ENSG00000187944.5",
      gene_id : "ENSG00000187944.5",
      gene_type : "protein_coding",
      gene_name : "C2orf66",
      gene_level : 2,
      hgnc_id : "HGNC:33809",
      havana_gene : "OTTHUMG00000132742.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196833004,
      stop : 196927796,
      direction : "-",
      ID : "ENSG00000197121.15",
      gene_id : "ENSG00000197121.15",
      gene_type : "protein_coding",
      gene_name : "PGAP1",
      gene_level : 1,
      hgnc_id : "HGNC:25712",
      havana_gene : "OTTHUMG00000132743.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 196967017,
      stop : 197311173,
      direction : "-",
      ID : "ENSG00000065413.20",
      gene_id : "ENSG00000065413.20",
      gene_type : "protein_coding",
      gene_name : "ANKRD44",
      gene_level : 1,
      hgnc_id : "HGNC:25259",
      havana_gene : "OTTHUMG00000154411.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197388515,
      stop : 197435079,
      direction : "-",
      ID : "ENSG00000115524.17",
      gene_id : "ENSG00000115524.17",
      gene_type : "protein_coding",
      gene_name : "SF3B1",
      gene_level : 2,
      hgnc_id : "HGNC:10768",
      havana_gene : "OTTHUMG00000154447.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197453423,
      stop : 197475308,
      direction : "+",
      ID : "ENSG00000115520.8",
      gene_id : "ENSG00000115520.8",
      gene_type : "protein_coding",
      gene_name : "COQ10B",
      gene_level : 1,
      hgnc_id : "HGNC:25819",
      havana_gene : "OTTHUMG00000132745.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197486584,
      stop : 197516737,
      direction : "-",
      ID : "ENSG00000144381.18",
      gene_id : "ENSG00000144381.18",
      gene_type : "protein_coding",
      gene_name : "HSPD1",
      gene_level : 2,
      hgnc_id : "HGNC:5261",
      havana_gene : "OTTHUMG00000154463.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197500140,
      stop : 197503449,
      direction : "+",
      ID : "ENSG00000115541.11",
      gene_id : "ENSG00000115541.11",
      gene_type : "protein_coding",
      gene_name : "HSPE1",
      gene_level : 1,
      hgnc_id : "HGNC:5269",
      havana_gene : "OTTHUMG00000132749.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197500413,
      stop : 197550726,
      direction : "+",
      ID : "ENSG00000270757.1",
      gene_id : "ENSG00000270757.1",
      gene_type : "protein_coding",
      gene_name : "HSPE1-MOB4",
      gene_level : 2,
      hgnc_id : "HGNC:49184",
      havana_gene : "OTTHUMG00000184877.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197515571,
      stop : 197553699,
      direction : "+",
      ID : "ENSG00000115540.15",
      gene_id : "ENSG00000115540.15",
      gene_type : "protein_coding",
      gene_name : "MOB4",
      gene_level : 2,
      hgnc_id : "HGNC:17261",
      havana_gene : "OTTHUMG00000132748.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197568224,
      stop : 197676045,
      direction : "-",
      ID : "ENSG00000162944.11",
      gene_id : "ENSG00000162944.11",
      gene_type : "protein_coding",
      gene_name : "RFTN2",
      gene_level : 1,
      hgnc_id : "HGNC:26402",
      havana_gene : "OTTHUMG00000132746.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197705369,
      stop : 197708395,
      direction : "+",
      ID : "ENSG00000247626.5",
      gene_id : "ENSG00000247626.5",
      gene_type : "protein_coding",
      gene_name : "MARS2",
      gene_level : 2,
      hgnc_id : "HGNC:25133",
      havana_gene : "OTTHUMG00000154487.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197726879,
      stop : 197786762,
      direction : "-",
      ID : "ENSG00000152430.18",
      gene_id : "ENSG00000152430.18",
      gene_type : "protein_coding",
      gene_name : "BOLL",
      gene_level : 1,
      hgnc_id : "HGNC:14273",
      havana_gene : "OTTHUMG00000132747.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 197804593,
      stop : 198572581,
      direction : "+",
      ID : "ENSG00000115896.16",
      gene_id : "ENSG00000115896.16",
      gene_type : "protein_coding",
      gene_name : "PLCL1",
      gene_level : 2,
      hgnc_id : "HGNC:9063",
      havana_gene : "OTTHUMG00000132750.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 199269500,
      stop : 199471266,
      direction : "-",
      ID : "ENSG00000119042.17",
      gene_id : "ENSG00000119042.17",
      gene_type : "protein_coding",
      gene_name : "SATB2",
      gene_level : 2,
      hgnc_id : "HGNC:21637",
      havana_gene : "OTTHUMG00000132767.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 199760544,
      stop : 199851192,
      direction : "-",
      ID : "ENSG00000226124.8",
      gene_id : "ENSG00000226124.8",
      gene_type : "protein_coding",
      gene_name : "FTCDNL1",
      gene_level : 1,
      hgnc_id : "HGNC:48661",
      havana_gene : "OTTHUMG00000154481.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 199911293,
      stop : 199955935,
      direction : "+",
      ID : "ENSG00000178074.6",
      gene_id : "ENSG00000178074.6",
      gene_type : "protein_coding",
      gene_name : "C2orf69",
      gene_level : 2,
      hgnc_id : "HGNC:26799",
      havana_gene : "OTTHUMG00000154480.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 199928913,
      stop : 199955736,
      direction : "-",
      ID : "ENSG00000162971.11",
      gene_id : "ENSG00000162971.11",
      gene_type : "protein_coding",
      gene_name : "TYW5",
      gene_level : 2,
      hgnc_id : "HGNC:26754",
      havana_gene : "OTTHUMG00000132770.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 199955317,
      stop : 200008540,
      direction : "+",
      ID : "ENSG00000162972.10",
      gene_id : "ENSG00000162972.10",
      gene_type : "protein_coding",
      gene_name : "MAIP1",
      gene_level : 2,
      hgnc_id : "HGNC:26198",
      havana_gene : "OTTHUMG00000132771.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200305881,
      stop : 200482264,
      direction : "+",
      ID : "ENSG00000196141.14",
      gene_id : "ENSG00000196141.14",
      gene_type : "protein_coding",
      gene_name : "SPATS2L",
      gene_level : 1,
      hgnc_id : "HGNC:24574",
      havana_gene : "OTTHUMG00000154589.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200488958,
      stop : 200519784,
      direction : "-",
      ID : "ENSG00000155729.13",
      gene_id : "ENSG00000155729.13",
      gene_type : "protein_coding",
      gene_name : "KCTD18",
      gene_level : 2,
      hgnc_id : "HGNC:26446",
      havana_gene : "OTTHUMG00000132781.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200510008,
      stop : 200584096,
      direction : "+",
      ID : "ENSG00000163535.18",
      gene_id : "ENSG00000163535.18",
      gene_type : "protein_coding",
      gene_name : "SGO2",
      gene_level : 2,
      hgnc_id : "HGNC:30812",
      havana_gene : "OTTHUMG00000154535.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200586014,
      stop : 200677064,
      direction : "+",
      ID : "ENSG00000138356.14",
      gene_id : "ENSG00000138356.14",
      gene_type : "protein_coding",
      gene_name : "AOX1",
      gene_level : 1,
      hgnc_id : "HGNC:553",
      havana_gene : "OTTHUMG00000154536.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200810594,
      stop : 200827338,
      direction : "+",
      ID : "ENSG00000082153.18",
      gene_id : "ENSG00000082153.18",
      gene_type : "protein_coding",
      gene_name : "BZW1",
      gene_level : 1,
      hgnc_id : "HGNC:18380",
      havana_gene : "OTTHUMG00000154560.20",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200853009,
      stop : 200864744,
      direction : "-",
      ID : "ENSG00000013441.16",
      gene_id : "ENSG00000013441.16",
      gene_type : "protein_coding",
      gene_name : "CLK1",
      gene_level : 2,
      hgnc_id : "HGNC:2068",
      havana_gene : "OTTHUMG00000132784.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200870907,
      stop : 200889303,
      direction : "-",
      ID : "ENSG00000240344.9",
      gene_id : "ENSG00000240344.9",
      gene_type : "protein_coding",
      gene_name : "PPIL3",
      gene_level : 1,
      hgnc_id : "HGNC:9262",
      havana_gene : "OTTHUMG00000132782.26",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200889327,
      stop : 200903938,
      direction : "+",
      ID : "ENSG00000196290.16",
      gene_id : "ENSG00000196290.16",
      gene_type : "protein_coding",
      gene_name : "NIF3L1",
      gene_level : 1,
      hgnc_id : "HGNC:13390",
      havana_gene : "OTTHUMG00000154588.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200908977,
      stop : 200963680,
      direction : "-",
      ID : "ENSG00000115942.9",
      gene_id : "ENSG00000115942.9",
      gene_type : "protein_coding",
      gene_name : "ORC2",
      gene_level : 2,
      hgnc_id : "HGNC:8488",
      havana_gene : "OTTHUMG00000132783.25",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 200973718,
      stop : 201071671,
      direction : "-",
      ID : "ENSG00000155744.9",
      gene_id : "ENSG00000155744.9",
      gene_type : "protein_coding",
      gene_name : "FAM126B",
      gene_level : 2,
      hgnc_id : "HGNC:28593",
      havana_gene : "OTTHUMG00000132823.15",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201071433,
      stop : 201085750,
      direction : "+",
      ID : "ENSG00000119013.9",
      gene_id : "ENSG00000119013.9",
      gene_type : "protein_coding",
      gene_name : "NDUFB3",
      gene_level : 2,
      hgnc_id : "HGNC:7698",
      havana_gene : "OTTHUMG00000132820.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201116154,
      stop : 201176687,
      direction : "+",
      ID : "ENSG00000003402.20",
      gene_id : "ENSG00000003402.20",
      gene_type : "protein_coding",
      gene_name : "CFLAR",
      gene_level : 1,
      hgnc_id : "HGNC:1876",
      havana_gene : "OTTHUMG00000132819.20",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201182898,
      stop : 201229406,
      direction : "+",
      ID : "ENSG00000003400.15",
      gene_id : "ENSG00000003400.15",
      gene_type : "protein_coding",
      gene_name : "CASP10",
      gene_level : 2,
      hgnc_id : "HGNC:1500",
      havana_gene : "OTTHUMG00000132818.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201233443,
      stop : 201287711,
      direction : "+",
      ID : "ENSG00000064012.22",
      gene_id : "ENSG00000064012.22",
      gene_type : "protein_coding",
      gene_name : "CASP8",
      gene_level : 1,
      hgnc_id : "HGNC:1509",
      havana_gene : "OTTHUMG00000132821.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201288271,
      stop : 201357398,
      direction : "-",
      ID : "ENSG00000155749.13",
      gene_id : "ENSG00000155749.13",
      gene_type : "protein_coding",
      gene_name : "FLACC1",
      gene_level : 1,
      hgnc_id : "HGNC:14439",
      havana_gene : "OTTHUMG00000132824.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201377207,
      stop : 201451500,
      direction : "-",
      ID : "ENSG00000115993.13",
      gene_id : "ENSG00000115993.13",
      gene_type : "protein_coding",
      gene_name : "TRAK2",
      gene_level : 2,
      hgnc_id : "HGNC:13206",
      havana_gene : "OTTHUMG00000132822.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201387858,
      stop : 201480846,
      direction : "+",
      ID : "ENSG00000082146.13",
      gene_id : "ENSG00000082146.13",
      gene_type : "protein_coding",
      gene_name : "STRADB",
      gene_level : 2,
      hgnc_id : "HGNC:13205",
      havana_gene : "OTTHUMG00000132831.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201487421,
      stop : 201619178,
      direction : "-",
      ID : "ENSG00000155754.15",
      gene_id : "ENSG00000155754.15",
      gene_type : "protein_coding",
      gene_name : "C2CD6",
      gene_level : 1,
      hgnc_id : "HGNC:14438",
      havana_gene : "OTTHUMG00000132830.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201620184,
      stop : 201643570,
      direction : "-",
      ID : "ENSG00000155755.19",
      gene_id : "ENSG00000155755.19",
      gene_type : "protein_coding",
      gene_name : "TMEM237",
      gene_level : 2,
      hgnc_id : "HGNC:14432",
      havana_gene : "OTTHUMG00000154526.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201644870,
      stop : 201698694,
      direction : "-",
      ID : "ENSG00000082126.18",
      gene_id : "ENSG00000082126.18",
      gene_type : "protein_coding",
      gene_name : "MPP4",
      gene_level : 1,
      hgnc_id : "HGNC:13680",
      havana_gene : "OTTHUMG00000154525.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201700267,
      stop : 201782112,
      direction : "-",
      ID : "ENSG00000003393.16",
      gene_id : "ENSG00000003393.16",
      gene_type : "protein_coding",
      gene_name : "ALS2",
      gene_level : 2,
      hgnc_id : "HGNC:443",
      havana_gene : "OTTHUMG00000154507.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 201790461,
      stop : 201895550,
      direction : "+",
      ID : "ENSG00000138395.17",
      gene_id : "ENSG00000138395.17",
      gene_type : "protein_coding",
      gene_name : "CDK15",
      gene_level : 1,
      hgnc_id : "HGNC:14434",
      havana_gene : "OTTHUMG00000132838.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202033855,
      stop : 202038441,
      direction : "+",
      ID : "ENSG00000155760.3",
      gene_id : "ENSG00000155760.3",
      gene_type : "protein_coding",
      gene_name : "FZD7",
      gene_level : 2,
      hgnc_id : "HGNC:4045",
      havana_gene : "OTTHUMG00000132841.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202073255,
      stop : 202205188,
      direction : "+",
      ID : "ENSG00000182329.14",
      gene_id : "ENSG00000182329.14",
      gene_type : "protein_coding",
      gene_name : "KIAA2012",
      gene_level : 2,
      hgnc_id : "HGNC:51250",
      havana_gene : "OTTHUMG00000154580.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202206182,
      stop : 202238599,
      direction : "-",
      ID : "ENSG00000116030.17",
      gene_id : "ENSG00000116030.17",
      gene_type : "protein_coding",
      gene_name : "SUMO1",
      gene_level : 1,
      hgnc_id : "HGNC:12502",
      havana_gene : "OTTHUMG00000132839.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202265736,
      stop : 202303661,
      direction : "+",
      ID : "ENSG00000055044.11",
      gene_id : "ENSG00000055044.11",
      gene_type : "protein_coding",
      gene_name : "NOP58",
      gene_level : 2,
      hgnc_id : "HGNC:29926",
      havana_gene : "OTTHUMG00000132840.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202376327,
      stop : 202567751,
      direction : "+",
      ID : "ENSG00000204217.15",
      gene_id : "ENSG00000204217.15",
      gene_type : "protein_coding",
      gene_name : "BMPR2",
      gene_level : 1,
      hgnc_id : "HGNC:1078",
      havana_gene : "OTTHUMG00000133617.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202634969,
      stop : 202769757,
      direction : "+",
      ID : "ENSG00000138439.12",
      gene_id : "ENSG00000138439.12",
      gene_type : "protein_coding",
      gene_name : "FAM117B",
      gene_level : 2,
      hgnc_id : "HGNC:14440",
      havana_gene : "OTTHUMG00000154550.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202773150,
      stop : 202871766,
      direction : "-",
      ID : "ENSG00000163596.17",
      gene_id : "ENSG00000163596.17",
      gene_type : "protein_coding",
      gene_name : "ICA1L",
      gene_level : 1,
      hgnc_id : "HGNC:14442",
      havana_gene : "OTTHUMG00000132856.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202874261,
      stop : 203014798,
      direction : "-",
      ID : "ENSG00000138442.10",
      gene_id : "ENSG00000138442.10",
      gene_type : "protein_coding",
      gene_name : "WDR12",
      gene_level : 2,
      hgnc_id : "HGNC:14098",
      havana_gene : "OTTHUMG00000132855.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 202912214,
      stop : 202988263,
      direction : "+",
      ID : "ENSG00000138380.18",
      gene_id : "ENSG00000138380.18",
      gene_type : "protein_coding",
      gene_name : "CARF",
      gene_level : 1,
      hgnc_id : "HGNC:14435",
      havana_gene : "OTTHUMG00000154528.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203014879,
      stop : 203226378,
      direction : "+",
      ID : "ENSG00000144426.18",
      gene_id : "ENSG00000144426.18",
      gene_type : "protein_coding",
      gene_name : "NBEAL1",
      gene_level : 2,
      hgnc_id : "HGNC:20681",
      havana_gene : "OTTHUMG00000154129.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203238977,
      stop : 203306026,
      direction : "+",
      ID : "ENSG00000119004.16",
      gene_id : "ENSG00000119004.16",
      gene_type : "protein_coding",
      gene_name : "CYP20A1",
      gene_level : 1,
      hgnc_id : "HGNC:20576",
      havana_gene : "OTTHUMG00000132854.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203328280,
      stop : 203447728,
      direction : "+",
      ID : "ENSG00000138443.17",
      gene_id : "ENSG00000138443.17",
      gene_type : "protein_coding",
      gene_name : "ABI2",
      gene_level : 1,
      hgnc_id : "HGNC:24011",
      havana_gene : "OTTHUMG00000132879.16",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203394345,
      stop : 203535335,
      direction : "-",
      ID : "ENSG00000173166.18",
      gene_id : "ENSG00000173166.18",
      gene_type : "protein_coding",
      gene_name : "RAPH1",
      gene_level : 2,
      hgnc_id : "HGNC:14436",
      havana_gene : "OTTHUMG00000132876.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203706475,
      stop : 203738912,
      direction : "+",
      ID : "ENSG00000178562.18",
      gene_id : "ENSG00000178562.18",
      gene_type : "protein_coding",
      gene_name : "CD28",
      gene_level : 1,
      hgnc_id : "HGNC:1653",
      havana_gene : "OTTHUMG00000132878.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203867771,
      stop : 203873965,
      direction : "+",
      ID : "ENSG00000163599.17",
      gene_id : "ENSG00000163599.17",
      gene_type : "protein_coding",
      gene_name : "CTLA4",
      gene_level : 2,
      hgnc_id : "HGNC:2505",
      havana_gene : "OTTHUMG00000132877.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 203936763,
      stop : 203961577,
      direction : "+",
      ID : "ENSG00000163600.13",
      gene_id : "ENSG00000163600.13",
      gene_type : "protein_coding",
      gene_name : "ICOS",
      gene_level : 2,
      hgnc_id : "HGNC:5351",
      havana_gene : "OTTHUMG00000132880.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 204545475,
      stop : 205620162,
      direction : "+",
      ID : "ENSG00000116117.18",
      gene_id : "ENSG00000116117.18",
      gene_type : "protein_coding",
      gene_name : "PARD3B",
      gene_level : 1,
      hgnc_id : "HGNC:14446",
      havana_gene : "OTTHUMG00000154562.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 205681990,
      stop : 205798133,
      direction : "+",
      ID : "ENSG00000118257.17",
      gene_id : "ENSG00000118257.17",
      gene_type : "protein_coding",
      gene_name : "NRP2",
      gene_level : 2,
      hgnc_id : "HGNC:8005",
      havana_gene : "OTTHUMG00000132893.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 205993721,
      stop : 206086303,
      direction : "-",
      ID : "ENSG00000114933.16",
      gene_id : "ENSG00000114933.16",
      gene_type : "protein_coding",
      gene_name : "INO80D",
      gene_level : 2,
      hgnc_id : "HGNC:25997",
      havana_gene : "OTTHUMG00000154649.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206114817,
      stop : 206159509,
      direction : "-",
      ID : "ENSG00000023228.14",
      gene_id : "ENSG00000023228.14",
      gene_type : "protein_coding",
      gene_name : "NDUFS1",
      gene_level : 2,
      hgnc_id : "HGNC:7707",
      havana_gene : "OTTHUMG00000132892.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206159585,
      stop : 206162928,
      direction : "+",
      ID : "ENSG00000114942.14",
      gene_id : "ENSG00000114942.14",
      gene_type : "protein_coding",
      gene_name : "EEF1B2",
      gene_level : 2,
      hgnc_id : "HGNC:3208",
      havana_gene : "OTTHUMG00000132891.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206175316,
      stop : 206218047,
      direction : "-",
      ID : "ENSG00000183671.12",
      gene_id : "ENSG00000183671.12",
      gene_type : "protein_coding",
      gene_name : "GPR1",
      gene_level : 2,
      hgnc_id : "HGNC:4463",
      havana_gene : "OTTHUMG00000132894.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206274663,
      stop : 206314427,
      direction : "+",
      ID : "ENSG00000204186.10",
      gene_id : "ENSG00000204186.10",
      gene_type : "protein_coding",
      gene_name : "ZDBF2",
      gene_level : 2,
      hgnc_id : "HGNC:29313",
      havana_gene : "OTTHUMG00000154648.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206443532,
      stop : 206621127,
      direction : "+",
      ID : "ENSG00000114948.13",
      gene_id : "ENSG00000114948.13",
      gene_type : "protein_coding",
      gene_name : "ADAM23",
      gene_level : 2,
      hgnc_id : "HGNC:202",
      havana_gene : "OTTHUMG00000132919.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206642487,
      stop : 206649365,
      direction : "+",
      ID : "ENSG00000235118.9",
      gene_id : "ENSG00000235118.9",
      gene_type : "protein_coding",
      gene_name : "FAM237A",
      gene_level : 1,
      hgnc_id : "HGNC:52388",
      havana_gene : "OTTHUMG00000154723.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206651621,
      stop : 206721570,
      direction : "-",
      ID : "ENSG00000232125.5",
      gene_id : "ENSG00000232125.5",
      gene_type : "protein_coding",
      gene_name : "DYTN",
      gene_level : 2,
      hgnc_id : "HGNC:23279",
      havana_gene : "OTTHUMG00000154729.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206737763,
      stop : 206765328,
      direction : "-",
      ID : "ENSG00000138400.13",
      gene_id : "ENSG00000138400.13",
      gene_type : "protein_coding",
      gene_name : "MDH1B",
      gene_level : 1,
      hgnc_id : "HGNC:17836",
      havana_gene : "OTTHUMG00000132918.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206765357,
      stop : 206796189,
      direction : "+",
      ID : "ENSG00000118246.14",
      gene_id : "ENSG00000118246.14",
      gene_type : "protein_coding",
      gene_name : "FASTKD2",
      gene_level : 2,
      hgnc_id : "HGNC:29160",
      havana_gene : "OTTHUMG00000132917.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 206939518,
      stop : 206969474,
      direction : "+",
      ID : "ENSG00000144410.5",
      gene_id : "ENSG00000144410.5",
      gene_type : "protein_coding",
      gene_name : "CPO",
      gene_level : 2,
      hgnc_id : "HGNC:21011",
      havana_gene : "OTTHUMG00000088987.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 207074137,
      stop : 207167267,
      direction : "-",
      ID : "ENSG00000118263.15",
      gene_id : "ENSG00000118263.15",
      gene_type : "protein_coding",
      gene_name : "KLF7",
      gene_level : 2,
      hgnc_id : "HGNC:6350",
      havana_gene : "OTTHUMG00000132935.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 207529737,
      stop : 207605988,
      direction : "+",
      ID : "ENSG00000118260.15",
      gene_id : "ENSG00000118260.15",
      gene_type : "protein_coding",
      gene_name : "CREB1",
      gene_level : 1,
      hgnc_id : "HGNC:2345",
      havana_gene : "OTTHUMG00000132936.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 207580631,
      stop : 207625928,
      direction : "-",
      ID : "ENSG00000144401.14",
      gene_id : "ENSG00000144401.14",
      gene_type : "protein_coding",
      gene_name : "METTL21A",
      gene_level : 1,
      hgnc_id : "HGNC:30476",
      havana_gene : "OTTHUMG00000132934.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 207711540,
      stop : 207761839,
      direction : "+",
      ID : "ENSG00000163249.13",
      gene_id : "ENSG00000163249.13",
      gene_type : "protein_coding",
      gene_name : "CCNYL1",
      gene_level : 1,
      hgnc_id : "HGNC:26868",
      havana_gene : "OTTHUMG00000132946.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 207762598,
      stop : 207769906,
      direction : "-",
      ID : "ENSG00000163251.4",
      gene_id : "ENSG00000163251.4",
      gene_type : "protein_coding",
      gene_name : "FZD5",
      gene_level : 2,
      hgnc_id : "HGNC:4043",
      havana_gene : "OTTHUMG00000154790.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 207821288,
      stop : 208025527,
      direction : "-",
      ID : "ENSG00000178385.15",
      gene_id : "ENSG00000178385.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHM3",
      gene_level : 2,
      hgnc_id : "HGNC:34006",
      havana_gene : "OTTHUMG00000154781.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208121607,
      stop : 208124524,
      direction : "-",
      ID : "ENSG00000118231.5",
      gene_id : "ENSG00000118231.5",
      gene_type : "protein_coding",
      gene_name : "CRYGD",
      gene_level : 2,
      hgnc_id : "HGNC:2411",
      havana_gene : "OTTHUMG00000132944.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208128137,
      stop : 208129828,
      direction : "-",
      ID : "ENSG00000163254.5",
      gene_id : "ENSG00000163254.5",
      gene_type : "protein_coding",
      gene_name : "CRYGC",
      gene_level : 2,
      hgnc_id : "HGNC:2410",
      havana_gene : "OTTHUMG00000132942.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208142573,
      stop : 208146158,
      direction : "-",
      ID : "ENSG00000182187.4",
      gene_id : "ENSG00000182187.4",
      gene_type : "protein_coding",
      gene_name : "CRYGB",
      gene_level : 2,
      hgnc_id : "HGNC:2409",
      havana_gene : "OTTHUMG00000132941.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208160740,
      stop : 208163589,
      direction : "-",
      ID : "ENSG00000168582.5",
      gene_id : "ENSG00000168582.5",
      gene_type : "protein_coding",
      gene_name : "CRYGA",
      gene_level : 2,
      hgnc_id : "HGNC:2408",
      havana_gene : "OTTHUMG00000154796.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208165343,
      stop : 208190030,
      direction : "-",
      ID : "ENSG00000188674.11",
      gene_id : "ENSG00000188674.11",
      gene_type : "protein_coding",
      gene_name : "C2orf80",
      gene_level : 1,
      hgnc_id : "HGNC:34352",
      havana_gene : "OTTHUMG00000154751.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208236229,
      stop : 208266074,
      direction : "-",
      ID : "ENSG00000138413.14",
      gene_id : "ENSG00000138413.14",
      gene_type : "protein_coding",
      gene_name : "IDH1",
      gene_level : 2,
      hgnc_id : "HGNC:5382",
      havana_gene : "OTTHUMG00000132943.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208266255,
      stop : 208358746,
      direction : "+",
      ID : "ENSG00000115020.17",
      gene_id : "ENSG00000115020.17",
      gene_type : "protein_coding",
      gene_name : "PIKFYVE",
      gene_level : 1,
      hgnc_id : "HGNC:23785",
      havana_gene : "OTTHUMG00000132945.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 208359714,
      stop : 208854503,
      direction : "+",
      ID : "ENSG00000144407.9",
      gene_id : "ENSG00000144407.9",
      gene_type : "protein_coding",
      gene_name : "PTH2R",
      gene_level : 2,
      hgnc_id : "HGNC:9609",
      havana_gene : "OTTHUMG00000132960.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 209424058,
      stop : 209734118,
      direction : "+",
      ID : "ENSG00000078018.20",
      gene_id : "ENSG00000078018.20",
      gene_type : "protein_coding",
      gene_name : "MAP2",
      gene_level : 1,
      hgnc_id : "HGNC:6839",
      havana_gene : "OTTHUMG00000132962.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 209771832,
      stop : 209999300,
      direction : "+",
      ID : "ENSG00000144406.19",
      gene_id : "ENSG00000144406.19",
      gene_type : "protein_coding",
      gene_name : "UNC80",
      gene_level : 2,
      hgnc_id : "HGNC:26582",
      havana_gene : "OTTHUMG00000132963.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 210002565,
      stop : 210022260,
      direction : "+",
      ID : "ENSG00000197713.15",
      gene_id : "ENSG00000197713.15",
      gene_type : "protein_coding",
      gene_name : "RPE",
      gene_level : 1,
      hgnc_id : "HGNC:10293",
      havana_gene : "OTTHUMG00000154690.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 210021421,
      stop : 210171409,
      direction : "-",
      ID : "ENSG00000144445.17",
      gene_id : "ENSG00000144445.17",
      gene_type : "protein_coding",
      gene_name : "KANSL1L",
      gene_level : 1,
      hgnc_id : "HGNC:26310",
      havana_gene : "OTTHUMG00000154697.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 210187126,
      stop : 210225447,
      direction : "-",
      ID : "ENSG00000115361.8",
      gene_id : "ENSG00000115361.8",
      gene_type : "protein_coding",
      gene_name : "ACADL",
      gene_level : 2,
      hgnc_id : "HGNC:88",
      havana_gene : "OTTHUMG00000132989.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 210290150,
      stop : 210315174,
      direction : "-",
      ID : "ENSG00000168530.16",
      gene_id : "ENSG00000168530.16",
      gene_type : "protein_coding",
      gene_name : "MYL1",
      gene_level : 2,
      hgnc_id : "HGNC:7582",
      havana_gene : "OTTHUMG00000132992.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 210431249,
      stop : 210477652,
      direction : "-",
      ID : "ENSG00000115365.12",
      gene_id : "ENSG00000115365.12",
      gene_type : "protein_coding",
      gene_name : "LANCL1",
      gene_level : 1,
      hgnc_id : "HGNC:6508",
      havana_gene : "OTTHUMG00000132991.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 210477682,
      stop : 210679107,
      direction : "+",
      ID : "ENSG00000021826.17",
      gene_id : "ENSG00000021826.17",
      gene_type : "protein_coding",
      gene_name : "CPS1",
      gene_level : 2,
      hgnc_id : "HGNC:2323",
      havana_gene : "OTTHUMG00000132994.16",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 211375717,
      stop : 212538841,
      direction : "-",
      ID : "ENSG00000178568.15",
      gene_id : "ENSG00000178568.15",
      gene_type : "protein_coding",
      gene_name : "ERBB4",
      gene_level : 2,
      hgnc_id : "HGNC:3432",
      havana_gene : "OTTHUMG00000133012.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 212999691,
      stop : 213152427,
      direction : "-",
      ID : "ENSG00000030419.16",
      gene_id : "ENSG00000030419.16",
      gene_type : "protein_coding",
      gene_name : "IKZF2",
      gene_level : 2,
      hgnc_id : "HGNC:13177",
      havana_gene : "OTTHUMG00000133005.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 213284379,
      stop : 214410501,
      direction : "+",
      ID : "ENSG00000144451.19",
      gene_id : "ENSG00000144451.19",
      gene_type : "protein_coding",
      gene_name : "SPAG16",
      gene_level : 2,
      hgnc_id : "HGNC:23225",
      havana_gene : "OTTHUMG00000133015.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 214411054,
      stop : 214578976,
      direction : "+",
      ID : "ENSG00000174453.10",
      gene_id : "ENSG00000174453.10",
      gene_type : "protein_coding",
      gene_name : "VWC2L",
      gene_level : 2,
      hgnc_id : "HGNC:37203",
      havana_gene : "OTTHUMG00000154811.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 214725646,
      stop : 214809683,
      direction : "-",
      ID : "ENSG00000138376.11",
      gene_id : "ENSG00000138376.11",
      gene_type : "protein_coding",
      gene_name : "BARD1",
      gene_level : 2,
      hgnc_id : "HGNC:952",
      havana_gene : "OTTHUMG00000133016.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 214931542,
      stop : 215138626,
      direction : "-",
      ID : "ENSG00000144452.15",
      gene_id : "ENSG00000144452.15",
      gene_type : "protein_coding",
      gene_name : "ABCA12",
      gene_level : 2,
      hgnc_id : "HGNC:14637",
      havana_gene : "OTTHUMG00000154801.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 215311956,
      stop : 215349773,
      direction : "+",
      ID : "ENSG00000138363.15",
      gene_id : "ENSG00000138363.15",
      gene_type : "protein_coding",
      gene_name : "ATIC",
      gene_level : 2,
      hgnc_id : "HGNC:794",
      havana_gene : "OTTHUMG00000133023.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 215360440,
      stop : 215436073,
      direction : "-",
      ID : "ENSG00000115414.21",
      gene_id : "ENSG00000115414.21",
      gene_type : "protein_coding",
      gene_name : "FN1",
      gene_level : 2,
      hgnc_id : "HGNC:3778",
      havana_gene : "OTTHUMG00000133054.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 215942584,
      stop : 216034096,
      direction : "-",
      ID : "ENSG00000118242.16",
      gene_id : "ENSG00000118242.16",
      gene_type : "protein_coding",
      gene_name : "MREG",
      gene_level : 2,
      hgnc_id : "HGNC:25478",
      havana_gene : "OTTHUMG00000154828.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 215996329,
      stop : 216082955,
      direction : "-",
      ID : "ENSG00000115425.14",
      gene_id : "ENSG00000115425.14",
      gene_type : "protein_coding",
      gene_name : "PECR",
      gene_level : 1,
      hgnc_id : "HGNC:18281",
      havana_gene : "OTTHUMG00000154825.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216081866,
      stop : 216102783,
      direction : "+",
      ID : "ENSG00000163449.11",
      gene_id : "ENSG00000163449.11",
      gene_type : "protein_coding",
      gene_name : "TMEM169",
      gene_level : 2,
      hgnc_id : "HGNC:25130",
      havana_gene : "OTTHUMG00000133053.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216107464,
      stop : 216206303,
      direction : "+",
      ID : "ENSG00000079246.16",
      gene_id : "ENSG00000079246.16",
      gene_type : "protein_coding",
      gene_name : "XRCC5",
      gene_level : 2,
      hgnc_id : "HGNC:12833",
      havana_gene : "OTTHUMG00000133059.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216257865,
      stop : 216372483,
      direction : "-",
      ID : "ENSG00000144583.5",
      gene_id : "ENSG00000144583.5",
      gene_type : "protein_coding",
      gene_name : "MARCHF4",
      gene_level : 2,
      hgnc_id : "HGNC:29269",
      havana_gene : "OTTHUMG00000154824.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216412414,
      stop : 216483053,
      direction : "+",
      ID : "ENSG00000138375.13",
      gene_id : "ENSG00000138375.13",
      gene_type : "protein_coding",
      gene_name : "SMARCAL1",
      gene_level : 1,
      hgnc_id : "HGNC:11102",
      havana_gene : "OTTHUMG00000133055.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216498825,
      stop : 216579180,
      direction : "+",
      ID : "ENSG00000197756.10",
      gene_id : "ENSG00000197756.10",
      gene_type : "protein_coding",
      gene_name : "RPL37A",
      gene_level : 2,
      hgnc_id : "HGNC:10348",
      havana_gene : "OTTHUMG00000133052.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216632828,
      stop : 216664436,
      direction : "+",
      ID : "ENSG00000115457.10",
      gene_id : "ENSG00000115457.10",
      gene_type : "protein_coding",
      gene_name : "IGFBP2",
      gene_level : 1,
      hgnc_id : "HGNC:5471",
      havana_gene : "OTTHUMG00000155341.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216672105,
      stop : 216695549,
      direction : "-",
      ID : "ENSG00000115461.5",
      gene_id : "ENSG00000115461.5",
      gene_type : "protein_coding",
      gene_name : "IGFBP5",
      gene_level : 2,
      hgnc_id : "HGNC:5474",
      havana_gene : "OTTHUMG00000133058.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 216859458,
      stop : 216860064,
      direction : "-",
      ID : "ENSG00000118245.2",
      gene_id : "ENSG00000118245.2",
      gene_type : "protein_coding",
      gene_name : "TNP1",
      gene_level : 2,
      hgnc_id : "HGNC:11951",
      havana_gene : "OTTHUMG00000133057.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 217799588,
      stop : 218033982,
      direction : "-",
      ID : "ENSG00000079308.19",
      gene_id : "ENSG00000079308.19",
      gene_type : "protein_coding",
      gene_name : "TNS1",
      gene_level : 1,
      hgnc_id : "HGNC:11973",
      havana_gene : "OTTHUMG00000133056.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218034960,
      stop : 218090581,
      direction : "+",
      ID : "ENSG00000188282.12",
      gene_id : "ENSG00000188282.12",
      gene_type : "protein_coding",
      gene_name : "RUFY4",
      gene_level : 1,
      hgnc_id : "HGNC:24804",
      havana_gene : "OTTHUMG00000155235.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218125289,
      stop : 218137251,
      direction : "+",
      ID : "ENSG00000180871.8",
      gene_id : "ENSG00000180871.8",
      gene_type : "protein_coding",
      gene_name : "CXCR2",
      gene_level : 2,
      hgnc_id : "HGNC:6027",
      havana_gene : "OTTHUMG00000133107.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218162841,
      stop : 218166962,
      direction : "-",
      ID : "ENSG00000163464.8",
      gene_id : "ENSG00000163464.8",
      gene_type : "protein_coding",
      gene_name : "CXCR1",
      gene_level : 2,
      hgnc_id : "HGNC:6026",
      havana_gene : "OTTHUMG00000133108.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218217141,
      stop : 218254356,
      direction : "+",
      ID : "ENSG00000163466.16",
      gene_id : "ENSG00000163466.16",
      gene_type : "protein_coding",
      gene_name : "ARPC2",
      gene_level : 1,
      hgnc_id : "HGNC:705",
      havana_gene : "OTTHUMG00000133618.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218259496,
      stop : 218263861,
      direction : "+",
      ID : "ENSG00000179921.15",
      gene_id : "ENSG00000179921.15",
      gene_type : "protein_coding",
      gene_name : "GPBAR1",
      gene_level : 2,
      hgnc_id : "HGNC:19680",
      havana_gene : "OTTHUMG00000155203.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218264129,
      stop : 218270178,
      direction : "-",
      ID : "ENSG00000127837.10",
      gene_id : "ENSG00000127837.10",
      gene_type : "protein_coding",
      gene_name : "AAMP",
      gene_level : 1,
      hgnc_id : "HGNC:18",
      havana_gene : "OTTHUMG00000155202.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218270392,
      stop : 218346793,
      direction : "+",
      ID : "ENSG00000127838.14",
      gene_id : "ENSG00000127838.14",
      gene_type : "protein_coding",
      gene_name : "PNKD",
      gene_level : 2,
      hgnc_id : "HGNC:9153",
      havana_gene : "OTTHUMG00000133110.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218274197,
      stop : 218292586,
      direction : "-",
      ID : "ENSG00000135926.15",
      gene_id : "ENSG00000135926.15",
      gene_type : "protein_coding",
      gene_name : "TMBIM1",
      gene_level : 2,
      hgnc_id : "HGNC:23410",
      havana_gene : "OTTHUMG00000133105.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218356857,
      stop : 218368099,
      direction : "+",
      ID : "ENSG00000158428.4",
      gene_id : "ENSG00000158428.4",
      gene_type : "protein_coding",
      gene_name : "CATIP",
      gene_level : 2,
      hgnc_id : "HGNC:25062",
      havana_gene : "OTTHUMG00000133106.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218382029,
      stop : 218396894,
      direction : "+",
      ID : "ENSG00000018280.17",
      gene_id : "ENSG00000018280.17",
      gene_type : "protein_coding",
      gene_name : "SLC11A1",
      gene_level : 2,
      hgnc_id : "HGNC:10907",
      havana_gene : "OTTHUMG00000086747.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218398256,
      stop : 218405941,
      direction : "+",
      ID : "ENSG00000144579.8",
      gene_id : "ENSG00000144579.8",
      gene_type : "protein_coding",
      gene_name : "CTDSP1",
      gene_level : 1,
      hgnc_id : "HGNC:21614",
      havana_gene : "OTTHUMG00000133109.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218419121,
      stop : 218453295,
      direction : "+",
      ID : "ENSG00000127831.11",
      gene_id : "ENSG00000127831.11",
      gene_type : "protein_coding",
      gene_name : "VIL1",
      gene_level : 1,
      hgnc_id : "HGNC:12690",
      havana_gene : "OTTHUMG00000133112.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218450251,
      stop : 218568351,
      direction : "-",
      ID : "ENSG00000135913.11",
      gene_id : "ENSG00000135913.11",
      gene_type : "protein_coding",
      gene_name : "USP37",
      gene_level : 1,
      hgnc_id : "HGNC:20063",
      havana_gene : "OTTHUMG00000133113.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218568580,
      stop : 218597080,
      direction : "+",
      ID : "ENSG00000144580.14",
      gene_id : "ENSG00000144580.14",
      gene_type : "protein_coding",
      gene_name : "CNOT9",
      gene_level : 1,
      hgnc_id : "HGNC:10445",
      havana_gene : "OTTHUMG00000154750.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218607855,
      stop : 218637184,
      direction : "+",
      ID : "ENSG00000115556.14",
      gene_id : "ENSG00000115556.14",
      gene_type : "protein_coding",
      gene_name : "PLCD4",
      gene_level : 1,
      hgnc_id : "HGNC:9062",
      havana_gene : "OTTHUMG00000154743.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218633329,
      stop : 218659655,
      direction : "-",
      ID : "ENSG00000115568.16",
      gene_id : "ENSG00000115568.16",
      gene_type : "protein_coding",
      gene_name : "ZNF142",
      gene_level : 1,
      hgnc_id : "HGNC:12927",
      havana_gene : "OTTHUMG00000154736.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218658764,
      stop : 218663443,
      direction : "+",
      ID : "ENSG00000074582.15",
      gene_id : "ENSG00000074582.15",
      gene_type : "protein_coding",
      gene_name : "BCS1L",
      gene_level : 1,
      hgnc_id : "HGNC:1020",
      havana_gene : "OTTHUMG00000133114.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218663892,
      stop : 218672002,
      direction : "-",
      ID : "ENSG00000163481.8",
      gene_id : "ENSG00000163481.8",
      gene_type : "protein_coding",
      gene_name : "RNF25",
      gene_level : 2,
      hgnc_id : "HGNC:14662",
      havana_gene : "OTTHUMG00000133077.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218672069,
      stop : 218702716,
      direction : "+",
      ID : "ENSG00000163482.12",
      gene_id : "ENSG00000163482.12",
      gene_type : "protein_coding",
      gene_name : "STK36",
      gene_level : 1,
      hgnc_id : "HGNC:17209",
      havana_gene : "OTTHUMG00000133079.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218710835,
      stop : 218755416,
      direction : "+",
      ID : "ENSG00000135912.11",
      gene_id : "ENSG00000135912.11",
      gene_type : "protein_coding",
      gene_name : "TTLL4",
      gene_level : 2,
      hgnc_id : "HGNC:28976",
      havana_gene : "OTTHUMG00000133081.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218781749,
      stop : 218815293,
      direction : "+",
      ID : "ENSG00000135929.9",
      gene_id : "ENSG00000135929.9",
      gene_type : "protein_coding",
      gene_name : "CYP27A1",
      gene_level : 1,
      hgnc_id : "HGNC:2605",
      havana_gene : "OTTHUMG00000048238.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218822383,
      stop : 218832086,
      direction : "-",
      ID : "ENSG00000115592.11",
      gene_id : "ENSG00000115592.11",
      gene_type : "protein_coding",
      gene_name : "PRKAG3",
      gene_level : 2,
      hgnc_id : "HGNC:9387",
      havana_gene : "OTTHUMG00000133078.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218859805,
      stop : 218874233,
      direction : "+",
      ID : "ENSG00000115596.4",
      gene_id : "ENSG00000115596.4",
      gene_type : "protein_coding",
      gene_name : "WNT6",
      gene_level : 2,
      hgnc_id : "HGNC:12785",
      havana_gene : "OTTHUMG00000133082.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218880852,
      stop : 218899581,
      direction : "+",
      ID : "ENSG00000135925.9",
      gene_id : "ENSG00000135925.9",
      gene_type : "protein_coding",
      gene_name : "WNT10A",
      gene_level : 1,
      hgnc_id : "HGNC:13829",
      havana_gene : "OTTHUMG00000133085.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218959666,
      stop : 218962155,
      direction : "+",
      ID : "ENSG00000171450.6",
      gene_id : "ENSG00000171450.6",
      gene_type : "protein_coding",
      gene_name : "CDK5R2",
      gene_level : 2,
      hgnc_id : "HGNC:1776",
      havana_gene : "OTTHUMG00000133083.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218981087,
      stop : 218985184,
      direction : "-",
      ID : "ENSG00000163497.3",
      gene_id : "ENSG00000163497.3",
      gene_type : "protein_coding",
      gene_name : "FEV",
      gene_level : 2,
      hgnc_id : "HGNC:18562",
      havana_gene : "OTTHUMG00000133080.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 218990189,
      stop : 218993422,
      direction : "-",
      ID : "ENSG00000163499.12",
      gene_id : "ENSG00000163499.12",
      gene_type : "protein_coding",
      gene_name : "CRYBA2",
      gene_level : 2,
      hgnc_id : "HGNC:2395",
      havana_gene : "OTTHUMG00000133084.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219002846,
      stop : 219041527,
      direction : "-",
      ID : "ENSG00000181378.14",
      gene_id : "ENSG00000181378.14",
      gene_type : "protein_coding",
      gene_name : "CFAP65",
      gene_level : 2,
      hgnc_id : "HGNC:25325",
      havana_gene : "OTTHUMG00000133013.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219054424,
      stop : 219060921,
      direction : "-",
      ID : "ENSG00000163501.7",
      gene_id : "ENSG00000163501.7",
      gene_type : "protein_coding",
      gene_name : "IHH",
      gene_level : 2,
      hgnc_id : "HGNC:5956",
      havana_gene : "OTTHUMG00000154631.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219069357,
      stop : 219160865,
      direction : "-",
      ID : "ENSG00000187736.13",
      gene_id : "ENSG00000187736.13",
      gene_type : "protein_coding",
      gene_name : "NHEJ1",
      gene_level : 2,
      hgnc_id : "HGNC:25737",
      havana_gene : "OTTHUMG00000133127.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219075329,
      stop : 219170827,
      direction : "-",
      ID : "ENSG00000280537.2",
      gene_id : "ENSG00000280537.2",
      gene_type : "protein_coding",
      gene_name : "AC068946.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189759.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219161465,
      stop : 219170095,
      direction : "-",
      ID : "ENSG00000213901.11",
      gene_id : "ENSG00000213901.11",
      gene_type : "protein_coding",
      gene_name : "SLC23A3",
      gene_level : 1,
      hgnc_id : "HGNC:20601",
      havana_gene : "OTTHUMG00000154616.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219171897,
      stop : 219178106,
      direction : "-",
      ID : "ENSG00000115649.16",
      gene_id : "ENSG00000115649.16",
      gene_type : "protein_coding",
      gene_name : "CNPPD1",
      gene_level : 2,
      hgnc_id : "HGNC:25220",
      havana_gene : "OTTHUMG00000133132.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219176225,
      stop : 219185475,
      direction : "+",
      ID : "ENSG00000144567.11",
      gene_id : "ENSG00000144567.11",
      gene_type : "protein_coding",
      gene_name : "RETREG2",
      gene_level : 1,
      hgnc_id : "HGNC:28450",
      havana_gene : "OTTHUMG00000154577.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219195237,
      stop : 219209651,
      direction : "+",
      ID : "ENSG00000158552.13",
      gene_id : "ENSG00000158552.13",
      gene_type : "protein_coding",
      gene_name : "ZFAND2B",
      gene_level : 2,
      hgnc_id : "HGNC:25206",
      havana_gene : "OTTHUMG00000133135.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219209772,
      stop : 219218994,
      direction : "-",
      ID : "ENSG00000115657.14",
      gene_id : "ENSG00000115657.14",
      gene_type : "protein_coding",
      gene_name : "ABCB6",
      gene_level : 2,
      hgnc_id : "HGNC:47",
      havana_gene : "OTTHUMG00000133131.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219209772,
      stop : 219222738,
      direction : "-",
      ID : "ENSG00000284820.1",
      gene_id : "ENSG00000284820.1",
      gene_type : "protein_coding",
      gene_name : "AC068946.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192415.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219219380,
      stop : 219229717,
      direction : "-",
      ID : "ENSG00000198925.12",
      gene_id : "ENSG00000198925.12",
      gene_type : "protein_coding",
      gene_name : "ATG9A",
      gene_level : 1,
      hgnc_id : "HGNC:22408",
      havana_gene : "OTTHUMG00000154557.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219229783,
      stop : 219236679,
      direction : "+",
      ID : "ENSG00000163516.14",
      gene_id : "ENSG00000163516.14",
      gene_type : "protein_coding",
      gene_name : "ANKZF1",
      gene_level : 1,
      hgnc_id : "HGNC:25527",
      havana_gene : "OTTHUMG00000154533.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219236598,
      stop : 219245478,
      direction : "-",
      ID : "ENSG00000163521.16",
      gene_id : "ENSG00000163521.16",
      gene_type : "protein_coding",
      gene_name : "GLB1L",
      gene_level : 2,
      hgnc_id : "HGNC:28129",
      havana_gene : "OTTHUMG00000133133.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219245455,
      stop : 219250337,
      direction : "+",
      ID : "ENSG00000115661.14",
      gene_id : "ENSG00000115661.14",
      gene_type : "protein_coding",
      gene_name : "STK16",
      gene_level : 1,
      hgnc_id : "HGNC:11394",
      havana_gene : "OTTHUMG00000154520.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219249710,
      stop : 219278170,
      direction : "-",
      ID : "ENSG00000127824.14",
      gene_id : "ENSG00000127824.14",
      gene_type : "protein_coding",
      gene_name : "TUBA4A",
      gene_level : 1,
      hgnc_id : "HGNC:12407",
      havana_gene : "OTTHUMG00000133126.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219253243,
      stop : 219272197,
      direction : "+",
      ID : "ENSG00000243910.8",
      gene_id : "ENSG00000243910.8",
      gene_type : "protein_coding",
      gene_name : "TUBA4B",
      gene_level : 2,
      hgnc_id : "HGNC:18637",
      havana_gene : "OTTHUMG00000154516.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219279342,
      stop : 219286898,
      direction : "+",
      ID : "ENSG00000135924.16",
      gene_id : "ENSG00000135924.16",
      gene_type : "protein_coding",
      gene_name : "DNAJB2",
      gene_level : 1,
      hgnc_id : "HGNC:5228",
      havana_gene : "OTTHUMG00000133134.22",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219289623,
      stop : 219309648,
      direction : "-",
      ID : "ENSG00000054356.14",
      gene_id : "ENSG00000054356.14",
      gene_type : "protein_coding",
      gene_name : "PTPRN",
      gene_level : 1,
      hgnc_id : "HGNC:9676",
      havana_gene : "OTTHUMG00000133129.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219327407,
      stop : 219333177,
      direction : "-",
      ID : "ENSG00000182698.12",
      gene_id : "ENSG00000182698.12",
      gene_type : "protein_coding",
      gene_name : "RESP18",
      gene_level : 2,
      hgnc_id : "HGNC:33762",
      havana_gene : "OTTHUMG00000150223.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219372043,
      stop : 219400022,
      direction : "-",
      ID : "ENSG00000123992.20",
      gene_id : "ENSG00000123992.20",
      gene_type : "protein_coding",
      gene_name : "DNPEP",
      gene_level : 1,
      hgnc_id : "HGNC:2981",
      havana_gene : "OTTHUMG00000058919.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219418377,
      stop : 219426734,
      direction : "+",
      ID : "ENSG00000175084.12",
      gene_id : "ENSG00000175084.12",
      gene_type : "protein_coding",
      gene_name : "DES",
      gene_level : 2,
      hgnc_id : "HGNC:2770",
      havana_gene : "OTTHUMG00000058924.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219434843,
      stop : 219493629,
      direction : "+",
      ID : "ENSG00000072195.15",
      gene_id : "ENSG00000072195.15",
      gene_type : "protein_coding",
      gene_name : "SPEG",
      gene_level : 1,
      hgnc_id : "HGNC:16901",
      havana_gene : "OTTHUMG00000193740.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219491867,
      stop : 219498244,
      direction : "+",
      ID : "ENSG00000286143.1",
      gene_id : "ENSG00000286143.1",
      gene_type : "protein_coding",
      gene_name : "AC053503.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193741.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219496125,
      stop : 219498287,
      direction : "+",
      ID : "ENSG00000286095.1",
      gene_id : "ENSG00000286095.1",
      gene_type : "protein_coding",
      gene_name : "SPEGNB",
      gene_level : 2,
      hgnc_id : "HGNC:51251",
      havana_gene : "OTTHUMG00000193747.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219498884,
      stop : 219506989,
      direction : "+",
      ID : "ENSG00000144591.19",
      gene_id : "ENSG00000144591.19",
      gene_type : "protein_coding",
      gene_name : "GMPPA",
      gene_level : 2,
      hgnc_id : "HGNC:22923",
      havana_gene : "OTTHUMG00000058922.23",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219514170,
      stop : 219538772,
      direction : "+",
      ID : "ENSG00000072182.13",
      gene_id : "ENSG00000072182.13",
      gene_type : "protein_coding",
      gene_name : "ASIC4",
      gene_level : 2,
      hgnc_id : "HGNC:21263",
      havana_gene : "OTTHUMG00000058928.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219538948,
      stop : 219543809,
      direction : "-",
      ID : "ENSG00000123989.14",
      gene_id : "ENSG00000123989.14",
      gene_type : "protein_coding",
      gene_name : "CHPF",
      gene_level : 2,
      hgnc_id : "HGNC:24291",
      havana_gene : "OTTHUMG00000058929.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219543663,
      stop : 219550595,
      direction : "+",
      ID : "ENSG00000188760.11",
      gene_id : "ENSG00000188760.11",
      gene_type : "protein_coding",
      gene_name : "TMEM198",
      gene_level : 1,
      hgnc_id : "HGNC:33704",
      havana_gene : "OTTHUMG00000059156.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219550728,
      stop : 219571859,
      direction : "-",
      ID : "ENSG00000124006.15",
      gene_id : "ENSG00000124006.15",
      gene_type : "protein_coding",
      gene_name : "OBSL1",
      gene_level : 2,
      hgnc_id : "HGNC:29092",
      havana_gene : "OTTHUMG00000059157.13",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219569162,
      stop : 219575711,
      direction : "+",
      ID : "ENSG00000123999.5",
      gene_id : "ENSG00000123999.5",
      gene_type : "protein_coding",
      gene_name : "INHA",
      gene_level : 2,
      hgnc_id : "HGNC:6065",
      havana_gene : "OTTHUMG00000059237.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219597857,
      stop : 219616451,
      direction : "+",
      ID : "ENSG00000144589.22",
      gene_id : "ENSG00000144589.22",
      gene_type : "protein_coding",
      gene_name : "STK11IP",
      gene_level : 2,
      hgnc_id : "HGNC:19184",
      havana_gene : "OTTHUMG00000059239.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 219627394,
      stop : 219641980,
      direction : "+",
      ID : "ENSG00000114923.17",
      gene_id : "ENSG00000114923.17",
      gene_type : "protein_coding",
      gene_name : "SLC4A3",
      gene_level : 1,
      hgnc_id : "HGNC:11029",
      havana_gene : "OTTHUMG00000059238.21",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 221418027,
      stop : 221574202,
      direction : "-",
      ID : "ENSG00000116106.12",
      gene_id : "ENSG00000116106.12",
      gene_type : "protein_coding",
      gene_name : "EPHA4",
      gene_level : 1,
      hgnc_id : "HGNC:3388",
      havana_gene : "OTTHUMG00000133142.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 222199887,
      stop : 222298998,
      direction : "-",
      ID : "ENSG00000135903.20",
      gene_id : "ENSG00000135903.20",
      gene_type : "protein_coding",
      gene_name : "PAX3",
      gene_level : 1,
      hgnc_id : "HGNC:8617",
      havana_gene : "OTTHUMG00000133157.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 222317242,
      stop : 222320208,
      direction : "-",
      ID : "ENSG00000288658.1",
      gene_id : "ENSG00000288658.1",
      gene_type : "protein_coding",
      gene_name : "AC010980.1",
      gene_level : 2,
      hgnc_id : null,
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 222424543,
      stop : 222562621,
      direction : "+",
      ID : "ENSG00000163082.10",
      gene_id : "ENSG00000163082.10",
      gene_type : "protein_coding",
      gene_name : "SGPP2",
      gene_level : 2,
      hgnc_id : "HGNC:19953",
      havana_gene : "OTTHUMG00000133156.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 222566899,
      stop : 222656092,
      direction : "-",
      ID : "ENSG00000116120.11",
      gene_id : "ENSG00000116120.11",
      gene_type : "protein_coding",
      gene_name : "FARSB",
      gene_level : 2,
      hgnc_id : "HGNC:17800",
      havana_gene : "OTTHUMG00000133155.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 222671658,
      stop : 222709930,
      direction : "+",
      ID : "ENSG00000124003.13",
      gene_id : "ENSG00000124003.13",
      gene_type : "protein_coding",
      gene_name : "MOGAT1",
      gene_level : 2,
      hgnc_id : "HGNC:18210",
      havana_gene : "OTTHUMG00000153394.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 222860942,
      stop : 222944639,
      direction : "+",
      ID : "ENSG00000123983.15",
      gene_id : "ENSG00000123983.15",
      gene_type : "protein_coding",
      gene_name : "ACSL3",
      gene_level : 1,
      hgnc_id : "HGNC:3570",
      havana_gene : "OTTHUMG00000133160.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223051814,
      stop : 223198399,
      direction : "+",
      ID : "ENSG00000152049.6",
      gene_id : "ENSG00000152049.6",
      gene_type : "protein_coding",
      gene_name : "KCNE4",
      gene_level : 2,
      hgnc_id : "HGNC:6244",
      havana_gene : "OTTHUMG00000133161.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223596940,
      stop : 223602361,
      direction : "-",
      ID : "ENSG00000171951.5",
      gene_id : "ENSG00000171951.5",
      gene_type : "protein_coding",
      gene_name : "SCG2",
      gene_level : 2,
      hgnc_id : "HGNC:10575",
      havana_gene : "OTTHUMG00000133166.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223751686,
      stop : 223838027,
      direction : "-",
      ID : "ENSG00000152056.17",
      gene_id : "ENSG00000152056.17",
      gene_type : "protein_coding",
      gene_name : "AP1S3",
      gene_level : 1,
      hgnc_id : "HGNC:18971",
      havana_gene : "OTTHUMG00000133165.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223757258,
      stop : 223945299,
      direction : "-",
      ID : "ENSG00000286239.1",
      gene_id : "ENSG00000286239.1",
      gene_type : "protein_coding",
      gene_name : "AC093884.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193449.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223855716,
      stop : 223945357,
      direction : "-",
      ID : "ENSG00000085449.15",
      gene_id : "ENSG00000085449.15",
      gene_type : "protein_coding",
      gene_name : "WDFY1",
      gene_level : 1,
      hgnc_id : "HGNC:20451",
      havana_gene : "OTTHUMG00000153370.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223957463,
      stop : 223967714,
      direction : "+",
      ID : "ENSG00000135900.4",
      gene_id : "ENSG00000135900.4",
      gene_type : "protein_coding",
      gene_name : "MRPL44",
      gene_level : 2,
      hgnc_id : "HGNC:16650",
      havana_gene : "OTTHUMG00000133164.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 223975045,
      stop : 224039318,
      direction : "-",
      ID : "ENSG00000135919.14",
      gene_id : "ENSG00000135919.14",
      gene_type : "protein_coding",
      gene_name : "SERPINE2",
      gene_level : 1,
      hgnc_id : "HGNC:8951",
      havana_gene : "OTTHUMG00000133163.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 224378698,
      stop : 224402107,
      direction : "-",
      ID : "ENSG00000124019.10",
      gene_id : "ENSG00000124019.10",
      gene_type : "protein_coding",
      gene_name : "FAM124B",
      gene_level : 2,
      hgnc_id : "HGNC:26224",
      havana_gene : "OTTHUMG00000133168.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 224470150,
      stop : 224585397,
      direction : "-",
      ID : "ENSG00000036257.13",
      gene_id : "ENSG00000036257.13",
      gene_type : "protein_coding",
      gene_name : "CUL3",
      gene_level : 1,
      hgnc_id : "HGNC:2553",
      havana_gene : "OTTHUMG00000133167.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 224703764,
      stop : 224716365,
      direction : "-",
      ID : "ENSG00000283428.1",
      gene_id : "ENSG00000283428.1",
      gene_type : "protein_coding",
      gene_name : "CCDC195",
      gene_level : 2,
      hgnc_id : "HGNC:53441",
      havana_gene : "OTTHUMG00000191764.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 224765090,
      stop : 225042468,
      direction : "-",
      ID : "ENSG00000135905.20",
      gene_id : "ENSG00000135905.20",
      gene_type : "protein_coding",
      gene_name : "DOCK10",
      gene_level : 1,
      hgnc_id : "HGNC:23479",
      havana_gene : "OTTHUMG00000153428.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 225399710,
      stop : 225654018,
      direction : "+",
      ID : "ENSG00000144460.12",
      gene_id : "ENSG00000144460.12",
      gene_type : "protein_coding",
      gene_name : "NYAP2",
      gene_level : 2,
      hgnc_id : "HGNC:29291",
      havana_gene : "OTTHUMG00000153450.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 226731312,
      stop : 226799820,
      direction : "-",
      ID : "ENSG00000169047.6",
      gene_id : "ENSG00000169047.6",
      gene_type : "protein_coding",
      gene_name : "IRS1",
      gene_level : 2,
      hgnc_id : "HGNC:6125",
      havana_gene : "OTTHUMG00000133179.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 226835581,
      stop : 226999215,
      direction : "+",
      ID : "ENSG00000144468.17",
      gene_id : "ENSG00000144468.17",
      gene_type : "protein_coding",
      gene_name : "RHBDD1",
      gene_level : 2,
      hgnc_id : "HGNC:23081",
      havana_gene : "OTTHUMG00000133178.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227002714,
      stop : 227164453,
      direction : "-",
      ID : "ENSG00000081052.13",
      gene_id : "ENSG00000081052.13",
      gene_type : "protein_coding",
      gene_name : "COL4A4",
      gene_level : 2,
      hgnc_id : "HGNC:2206",
      havana_gene : "OTTHUMG00000149892.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227164624,
      stop : 227314792,
      direction : "+",
      ID : "ENSG00000169031.20",
      gene_id : "ENSG00000169031.20",
      gene_type : "protein_coding",
      gene_name : "COL4A3",
      gene_level : 1,
      hgnc_id : "HGNC:2204",
      havana_gene : "OTTHUMG00000149891.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227325151,
      stop : 227357836,
      direction : "+",
      ID : "ENSG00000168958.20",
      gene_id : "ENSG00000168958.20",
      gene_type : "protein_coding",
      gene_name : "MFF",
      gene_level : 1,
      hgnc_id : "HGNC:24858",
      havana_gene : "OTTHUMG00000133180.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227362038,
      stop : 227381995,
      direction : "-",
      ID : "ENSG00000168955.4",
      gene_id : "ENSG00000168955.4",
      gene_type : "protein_coding",
      gene_name : "TM4SF20",
      gene_level : 2,
      hgnc_id : "HGNC:26230",
      havana_gene : "OTTHUMG00000133187.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227387683,
      stop : 227387949,
      direction : "-",
      ID : "ENSG00000284629.1",
      gene_id : "ENSG00000284629.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR1",
      gene_level : 2,
      hgnc_id : "HGNC:34218",
      havana_gene : "OTTHUMG00000192261.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227472152,
      stop : 227561217,
      direction : "+",
      ID : "ENSG00000173744.18",
      gene_id : "ENSG00000173744.18",
      gene_type : "protein_coding",
      gene_name : "AGFG1",
      gene_level : 1,
      hgnc_id : "HGNC:5175",
      havana_gene : "OTTHUMG00000133186.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227598893,
      stop : 227599255,
      direction : "+",
      ID : "ENSG00000284643.1",
      gene_id : "ENSG00000284643.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR2",
      gene_level : 2,
      hgnc_id : "HGNC:34220",
      havana_gene : "OTTHUMG00000192253.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227614538,
      stop : 227614840,
      direction : "-",
      ID : "ENSG00000284704.1",
      gene_id : "ENSG00000284704.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR3",
      gene_level : 2,
      hgnc_id : "HGNC:34222",
      havana_gene : "OTTHUMG00000192255.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227616998,
      stop : 227618655,
      direction : "+",
      ID : "ENSG00000284631.1",
      gene_id : "ENSG00000284631.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR4",
      gene_level : 2,
      hgnc_id : "HGNC:34223",
      havana_gene : "OTTHUMG00000192256.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227666804,
      stop : 227667061,
      direction : "+",
      ID : "ENSG00000284667.1",
      gene_id : "ENSG00000284667.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR5",
      gene_level : 2,
      hgnc_id : "HGNC:34224",
      havana_gene : "OTTHUMG00000192257.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227683763,
      stop : 227718028,
      direction : "-",
      ID : "ENSG00000135917.16",
      gene_id : "ENSG00000135917.16",
      gene_type : "protein_coding",
      gene_name : "SLC19A3",
      gene_level : 2,
      hgnc_id : "HGNC:16266",
      havana_gene : "OTTHUMG00000133185.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227724440,
      stop : 227724757,
      direction : "-",
      ID : "ENSG00000284725.1",
      gene_id : "ENSG00000284725.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR6",
      gene_level : 2,
      hgnc_id : "HGNC:34225",
      havana_gene : "OTTHUMG00000192258.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227728335,
      stop : 227728625,
      direction : "+",
      ID : "ENSG00000284718.1",
      gene_id : "ENSG00000284718.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR7",
      gene_level : 2,
      hgnc_id : "HGNC:34226",
      havana_gene : "OTTHUMG00000192259.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227745845,
      stop : 227746681,
      direction : "+",
      ID : "ENSG00000284635.1",
      gene_id : "ENSG00000284635.1",
      gene_type : "protein_coding",
      gene_name : "SCYGR8",
      gene_level : 2,
      hgnc_id : "HGNC:34227",
      havana_gene : "OTTHUMG00000192260.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227805739,
      stop : 227817564,
      direction : "+",
      ID : "ENSG00000115009.13",
      gene_id : "ENSG00000115009.13",
      gene_type : "protein_coding",
      gene_name : "CCL20",
      gene_level : 2,
      hgnc_id : "HGNC:10619",
      havana_gene : "OTTHUMG00000133189.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227871054,
      stop : 227924344,
      direction : "+",
      ID : "ENSG00000123977.10",
      gene_id : "ENSG00000123977.10",
      gene_type : "protein_coding",
      gene_name : "DAW1",
      gene_level : 1,
      hgnc_id : "HGNC:26383",
      havana_gene : "OTTHUMG00000133190.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 227979955,
      stop : 228181687,
      direction : "-",
      ID : "ENSG00000153820.13",
      gene_id : "ENSG00000153820.13",
      gene_type : "protein_coding",
      gene_name : "SPHKAP",
      gene_level : 2,
      hgnc_id : "HGNC:30619",
      havana_gene : "OTTHUMG00000153584.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 228850526,
      stop : 229271287,
      direction : "-",
      ID : "ENSG00000153823.19",
      gene_id : "ENSG00000153823.19",
      gene_type : "protein_coding",
      gene_name : "PID1",
      gene_level : 2,
      hgnc_id : "HGNC:26084",
      havana_gene : "OTTHUMG00000133191.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 229357629,
      stop : 229714555,
      direction : "-",
      ID : "ENSG00000187957.8",
      gene_id : "ENSG00000187957.8",
      gene_type : "protein_coding",
      gene_name : "DNER",
      gene_level : 2,
      hgnc_id : "HGNC:24456",
      havana_gene : "OTTHUMG00000153637.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 229763837,
      stop : 229923239,
      direction : "-",
      ID : "ENSG00000153827.14",
      gene_id : "ENSG00000153827.14",
      gene_type : "protein_coding",
      gene_name : "TRIP12",
      gene_level : 1,
      hgnc_id : "HGNC:12306",
      havana_gene : "OTTHUMG00000153623.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 229922302,
      stop : 230013119,
      direction : "+",
      ID : "ENSG00000153832.12",
      gene_id : "ENSG00000153832.12",
      gene_type : "protein_coding",
      gene_name : "FBXO36",
      gene_level : 1,
      hgnc_id : "HGNC:27020",
      havana_gene : "OTTHUMG00000133206.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230034982,
      stop : 230068993,
      direction : "-",
      ID : "ENSG00000163053.11",
      gene_id : "ENSG00000163053.11",
      gene_type : "protein_coding",
      gene_name : "SLC16A14",
      gene_level : 1,
      hgnc_id : "HGNC:26417",
      havana_gene : "OTTHUMG00000133205.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230165186,
      stop : 230225729,
      direction : "-",
      ID : "ENSG00000135899.19",
      gene_id : "ENSG00000135899.19",
      gene_type : "protein_coding",
      gene_name : "SP110",
      gene_level : 2,
      hgnc_id : "HGNC:5401",
      havana_gene : "OTTHUMG00000133204.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230203110,
      stop : 230313215,
      direction : "+",
      ID : "ENSG00000079263.19",
      gene_id : "ENSG00000079263.19",
      gene_type : "protein_coding",
      gene_name : "SP140",
      gene_level : 1,
      hgnc_id : "HGNC:17133",
      havana_gene : "OTTHUMG00000153670.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230327184,
      stop : 230403732,
      direction : "+",
      ID : "ENSG00000185404.17",
      gene_id : "ENSG00000185404.17",
      gene_type : "protein_coding",
      gene_name : "SP140L",
      gene_level : 2,
      hgnc_id : "HGNC:25105",
      havana_gene : "OTTHUMG00000153730.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230415942,
      stop : 230545606,
      direction : "+",
      ID : "ENSG00000067066.17",
      gene_id : "ENSG00000067066.17",
      gene_type : "protein_coding",
      gene_name : "SP100",
      gene_level : 2,
      hgnc_id : "HGNC:11206",
      havana_gene : "OTTHUMG00000133203.18",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230712842,
      stop : 230821075,
      direction : "+",
      ID : "ENSG00000135932.11",
      gene_id : "ENSG00000135932.11",
      gene_type : "protein_coding",
      gene_name : "CAB39",
      gene_level : 2,
      hgnc_id : "HGNC:20292",
      havana_gene : "OTTHUMG00000133220.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230864639,
      stop : 230879248,
      direction : "+",
      ID : "ENSG00000135916.16",
      gene_id : "ENSG00000135916.16",
      gene_type : "protein_coding",
      gene_name : "ITM2C",
      gene_level : 1,
      hgnc_id : "HGNC:6175",
      havana_gene : "OTTHUMG00000133219.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230907318,
      stop : 230961066,
      direction : "-",
      ID : "ENSG00000135898.10",
      gene_id : "ENSG00000135898.10",
      gene_type : "protein_coding",
      gene_name : "GPR55",
      gene_level : 2,
      hgnc_id : "HGNC:4511",
      havana_gene : "OTTHUMG00000133224.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 230990324,
      stop : 231025055,
      direction : "+",
      ID : "ENSG00000173699.17",
      gene_id : "ENSG00000173699.17",
      gene_type : "protein_coding",
      gene_name : "SPATA3",
      gene_level : 1,
      hgnc_id : "HGNC:17884",
      havana_gene : "OTTHUMG00000133221.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231037523,
      stop : 231049719,
      direction : "+",
      ID : "ENSG00000204128.6",
      gene_id : "ENSG00000204128.6",
      gene_type : "protein_coding",
      gene_name : "C2orf72",
      gene_level : 1,
      hgnc_id : "HGNC:27418",
      havana_gene : "OTTHUMG00000153996.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231056845,
      stop : 231173116,
      direction : "+",
      ID : "ENSG00000173692.14",
      gene_id : "ENSG00000173692.14",
      gene_type : "protein_coding",
      gene_name : "PSMD1",
      gene_level : 1,
      hgnc_id : "HGNC:9554",
      havana_gene : "OTTHUMG00000133223.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231108230,
      stop : 231125042,
      direction : "-",
      ID : "ENSG00000135914.6",
      gene_id : "ENSG00000135914.6",
      gene_type : "protein_coding",
      gene_name : "HTR2B",
      gene_level : 2,
      hgnc_id : "HGNC:5294",
      havana_gene : "OTTHUMG00000133222.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231198546,
      stop : 231376848,
      direction : "+",
      ID : "ENSG00000135931.18",
      gene_id : "ENSG00000135931.18",
      gene_type : "protein_coding",
      gene_name : "ARMC9",
      gene_level : 1,
      hgnc_id : "HGNC:20730",
      havana_gene : "OTTHUMG00000133229.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231395710,
      stop : 231401164,
      direction : "+",
      ID : "ENSG00000156966.7",
      gene_id : "ENSG00000156966.7",
      gene_type : "protein_coding",
      gene_name : "B3GNT7",
      gene_level : 1,
      hgnc_id : "HGNC:18811",
      havana_gene : "OTTHUMG00000153880.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231453531,
      stop : 231483641,
      direction : "-",
      ID : "ENSG00000115053.17",
      gene_id : "ENSG00000115053.17",
      gene_type : "protein_coding",
      gene_name : "NCL",
      gene_level : 1,
      hgnc_id : "HGNC:7667",
      havana_gene : "OTTHUMG00000153866.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231523187,
      stop : 231530445,
      direction : "-",
      ID : "ENSG00000171596.7",
      gene_id : "ENSG00000171596.7",
      gene_type : "protein_coding",
      gene_name : "NMUR1",
      gene_level : 2,
      hgnc_id : "HGNC:4518",
      havana_gene : "OTTHUMG00000133225.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231592864,
      stop : 231594276,
      direction : "+",
      ID : "ENSG00000177673.4",
      gene_id : "ENSG00000177673.4",
      gene_type : "protein_coding",
      gene_name : "TEX44",
      gene_level : 2,
      hgnc_id : "HGNC:28563",
      havana_gene : "OTTHUMG00000133226.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231706895,
      stop : 231713551,
      direction : "+",
      ID : "ENSG00000187514.17",
      gene_id : "ENSG00000187514.17",
      gene_type : "protein_coding",
      gene_name : "PTMA",
      gene_level : 1,
      hgnc_id : "HGNC:9623",
      havana_gene : "OTTHUMG00000153810.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231732433,
      stop : 231786272,
      direction : "-",
      ID : "ENSG00000156973.14",
      gene_id : "ENSG00000156973.14",
      gene_type : "protein_coding",
      gene_name : "PDE6D",
      gene_level : 1,
      hgnc_id : "HGNC:8788",
      havana_gene : "OTTHUMG00000153785.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231781671,
      stop : 231809254,
      direction : "+",
      ID : "ENSG00000144524.18",
      gene_id : "ENSG00000144524.18",
      gene_type : "protein_coding",
      gene_name : "COPS7B",
      gene_level : 1,
      hgnc_id : "HGNC:16760",
      havana_gene : "OTTHUMG00000133228.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231921809,
      stop : 231926396,
      direction : "-",
      ID : "ENSG00000163273.4",
      gene_id : "ENSG00000163273.4",
      gene_type : "protein_coding",
      gene_name : "NPPC",
      gene_level : 2,
      hgnc_id : "HGNC:7941",
      havana_gene : "OTTHUMG00000133232.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 231961245,
      stop : 232344350,
      direction : "+",
      ID : "ENSG00000144535.20",
      gene_id : "ENSG00000144535.20",
      gene_type : "protein_coding",
      gene_name : "DIS3L2",
      gene_level : 1,
      hgnc_id : "HGNC:28648",
      havana_gene : "OTTHUMG00000153385.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232378724,
      stop : 232382889,
      direction : "+",
      ID : "ENSG00000163283.7",
      gene_id : "ENSG00000163283.7",
      gene_type : "protein_coding",
      gene_name : "ALPP",
      gene_level : 2,
      hgnc_id : "HGNC:439",
      havana_gene : "OTTHUMG00000133255.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232406844,
      stop : 232410714,
      direction : "+",
      ID : "ENSG00000163286.9",
      gene_id : "ENSG00000163286.9",
      gene_type : "protein_coding",
      gene_name : "ALPG",
      gene_level : 2,
      hgnc_id : "HGNC:441",
      havana_gene : "OTTHUMG00000133257.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232456125,
      stop : 232460753,
      direction : "+",
      ID : "ENSG00000163295.5",
      gene_id : "ENSG00000163295.5",
      gene_type : "protein_coding",
      gene_name : "ALPI",
      gene_level : 2,
      hgnc_id : "HGNC:437",
      havana_gene : "OTTHUMG00000133258.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232479827,
      stop : 232487834,
      direction : "-",
      ID : "ENSG00000171551.12",
      gene_id : "ENSG00000171551.12",
      gene_type : "protein_coding",
      gene_name : "ECEL1",
      gene_level : 2,
      hgnc_id : "HGNC:3147",
      havana_gene : "OTTHUMG00000133262.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232520388,
      stop : 232525716,
      direction : "+",
      ID : "ENSG00000237412.7",
      gene_id : "ENSG00000237412.7",
      gene_type : "protein_coding",
      gene_name : "PRSS56",
      gene_level : 2,
      hgnc_id : "HGNC:39433",
      havana_gene : "OTTHUMG00000153326.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232525993,
      stop : 232536667,
      direction : "+",
      ID : "ENSG00000135902.10",
      gene_id : "ENSG00000135902.10",
      gene_type : "protein_coding",
      gene_name : "CHRND",
      gene_level : 2,
      hgnc_id : "HGNC:1965",
      havana_gene : "OTTHUMG00000133261.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232539692,
      stop : 232548115,
      direction : "+",
      ID : "ENSG00000196811.13",
      gene_id : "ENSG00000196811.13",
      gene_type : "protein_coding",
      gene_name : "CHRNG",
      gene_level : 2,
      hgnc_id : "HGNC:1967",
      havana_gene : "OTTHUMG00000153327.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232543883,
      stop : 232550557,
      direction : "-",
      ID : "ENSG00000221944.9",
      gene_id : "ENSG00000221944.9",
      gene_type : "protein_coding",
      gene_name : "TIGD1",
      gene_level : 2,
      hgnc_id : "HGNC:14523",
      havana_gene : "OTTHUMG00000133260.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232550674,
      stop : 232583644,
      direction : "+",
      ID : "ENSG00000135930.14",
      gene_id : "ENSG00000135930.14",
      gene_type : "protein_coding",
      gene_name : "EIF4E2",
      gene_level : 1,
      hgnc_id : "HGNC:3293",
      havana_gene : "OTTHUMG00000133256.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232606057,
      stop : 232682780,
      direction : "+",
      ID : "ENSG00000115468.12",
      gene_id : "ENSG00000115468.12",
      gene_type : "protein_coding",
      gene_name : "EFHD1",
      gene_level : 1,
      hgnc_id : "HGNC:29556",
      havana_gene : "OTTHUMG00000133263.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232697299,
      stop : 232860605,
      direction : "+",
      ID : "ENSG00000204120.16",
      gene_id : "ENSG00000204120.16",
      gene_type : "protein_coding",
      gene_name : "GIGYF2",
      gene_level : 1,
      hgnc_id : "HGNC:11960",
      havana_gene : "OTTHUMG00000153237.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232765802,
      stop : 232776565,
      direction : "-",
      ID : "ENSG00000115474.7",
      gene_id : "ENSG00000115474.7",
      gene_type : "protein_coding",
      gene_name : "KCNJ13",
      gene_level : 1,
      hgnc_id : "HGNC:6259",
      havana_gene : "OTTHUMG00000153292.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232857270,
      stop : 232878708,
      direction : "+",
      ID : "ENSG00000182600.9",
      gene_id : "ENSG00000182600.9",
      gene_type : "protein_coding",
      gene_name : "SNORC",
      gene_level : 1,
      hgnc_id : "HGNC:33763",
      havana_gene : "OTTHUMG00000133273.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 232878701,
      stop : 233013256,
      direction : "-",
      ID : "ENSG00000066248.15",
      gene_id : "ENSG00000066248.15",
      gene_type : "protein_coding",
      gene_name : "NGEF",
      gene_level : 1,
      hgnc_id : "HGNC:7807",
      havana_gene : "OTTHUMG00000133272.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233032672,
      stop : 233035057,
      direction : "+",
      ID : "ENSG00000115488.3",
      gene_id : "ENSG00000115488.3",
      gene_type : "protein_coding",
      gene_name : "NEU2",
      gene_level : 2,
      hgnc_id : "HGNC:7759",
      havana_gene : "OTTHUMG00000133274.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233059967,
      stop : 233207903,
      direction : "+",
      ID : "ENSG00000168918.14",
      gene_id : "ENSG00000168918.14",
      gene_type : "protein_coding",
      gene_name : "INPP5D",
      gene_level : 1,
      hgnc_id : "HGNC:6079",
      havana_gene : "OTTHUMG00000133688.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233210051,
      stop : 233295674,
      direction : "+",
      ID : "ENSG00000085978.22",
      gene_id : "ENSG00000085978.22",
      gene_type : "protein_coding",
      gene_name : "ATG16L1",
      gene_level : 2,
      hgnc_id : "HGNC:21498",
      havana_gene : "OTTHUMG00000133619.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233307816,
      stop : 233347055,
      direction : "+",
      ID : "ENSG00000130561.17",
      gene_id : "ENSG00000130561.17",
      gene_type : "protein_coding",
      gene_name : "SAG",
      gene_level : 2,
      hgnc_id : "HGNC:10521",
      havana_gene : "OTTHUMG00000153213.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233354494,
      stop : 233472104,
      direction : "+",
      ID : "ENSG00000077044.11",
      gene_id : "ENSG00000077044.11",
      gene_type : "protein_coding",
      gene_name : "DGKD",
      gene_level : 1,
      hgnc_id : "HGNC:2851",
      havana_gene : "OTTHUMG00000133290.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233475520,
      stop : 233566782,
      direction : "-",
      ID : "ENSG00000085982.14",
      gene_id : "ENSG00000085982.14",
      gene_type : "protein_coding",
      gene_name : "USP40",
      gene_level : 1,
      hgnc_id : "HGNC:20069",
      havana_gene : "OTTHUMG00000153199.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233617645,
      stop : 233773310,
      direction : "+",
      ID : "ENSG00000242366.3",
      gene_id : "ENSG00000242366.3",
      gene_type : "protein_coding",
      gene_name : "UGT1A8",
      gene_level : 2,
      hgnc_id : "HGNC:12540",
      havana_gene : "OTTHUMG00000059123.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233636454,
      stop : 233773305,
      direction : "+",
      ID : "ENSG00000242515.5",
      gene_id : "ENSG00000242515.5",
      gene_type : "protein_coding",
      gene_name : "UGT1A10",
      gene_level : 2,
      hgnc_id : "HGNC:12531",
      havana_gene : "OTTHUMG00000059121.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233671898,
      stop : 233773300,
      direction : "+",
      ID : "ENSG00000241119.2",
      gene_id : "ENSG00000241119.2",
      gene_type : "protein_coding",
      gene_name : "UGT1A9",
      gene_level : 2,
      hgnc_id : "HGNC:12541",
      havana_gene : "OTTHUMG00000059124.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233681938,
      stop : 233773299,
      direction : "+",
      ID : "ENSG00000244122.2",
      gene_id : "ENSG00000244122.2",
      gene_type : "protein_coding",
      gene_name : "UGT1A7",
      gene_level : 2,
      hgnc_id : "HGNC:12539",
      havana_gene : "OTTHUMG00000059004.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233691607,
      stop : 233773300,
      direction : "+",
      ID : "ENSG00000167165.19",
      gene_id : "ENSG00000167165.19",
      gene_type : "protein_coding",
      gene_name : "UGT1A6",
      gene_level : 2,
      hgnc_id : "HGNC:12538",
      havana_gene : "OTTHUMG00000059122.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233712992,
      stop : 233773299,
      direction : "+",
      ID : "ENSG00000240224.1",
      gene_id : "ENSG00000240224.1",
      gene_type : "protein_coding",
      gene_name : "UGT1A5",
      gene_level : 2,
      hgnc_id : "HGNC:12537",
      havana_gene : "OTTHUMG00000059120.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233718736,
      stop : 233773300,
      direction : "+",
      ID : "ENSG00000244474.6",
      gene_id : "ENSG00000244474.6",
      gene_type : "protein_coding",
      gene_name : "UGT1A4",
      gene_level : 2,
      hgnc_id : "HGNC:12536",
      havana_gene : "OTTHUMG00000059119.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233729108,
      stop : 233773299,
      direction : "+",
      ID : "ENSG00000243135.6",
      gene_id : "ENSG00000243135.6",
      gene_type : "protein_coding",
      gene_name : "UGT1A3",
      gene_level : 2,
      hgnc_id : "HGNC:12535",
      havana_gene : "OTTHUMG00000059118.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233760270,
      stop : 233773300,
      direction : "+",
      ID : "ENSG00000241635.8",
      gene_id : "ENSG00000241635.8",
      gene_type : "protein_coding",
      gene_name : "UGT1A1",
      gene_level : 2,
      hgnc_id : "HGNC:12530",
      havana_gene : "OTTHUMG00000059117.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233775679,
      stop : 233833423,
      direction : "+",
      ID : "ENSG00000185038.14",
      gene_id : "ENSG00000185038.14",
      gene_type : "protein_coding",
      gene_name : "MROH2A",
      gene_level : 1,
      hgnc_id : "HGNC:27936",
      havana_gene : "OTTHUMG00000059037.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233833416,
      stop : 233854566,
      direction : "-",
      ID : "ENSG00000123485.12",
      gene_id : "ENSG00000123485.12",
      gene_type : "protein_coding",
      gene_name : "HJURP",
      gene_level : 2,
      hgnc_id : "HGNC:25444",
      havana_gene : "OTTHUMG00000059125.12",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 233917373,
      stop : 234019522,
      direction : "+",
      ID : "ENSG00000144481.17",
      gene_id : "ENSG00000144481.17",
      gene_type : "protein_coding",
      gene_name : "TRPM8",
      gene_level : 1,
      hgnc_id : "HGNC:17961",
      havana_gene : "OTTHUMG00000059129.11",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 234050679,
      stop : 234077134,
      direction : "+",
      ID : "ENSG00000072080.11",
      gene_id : "ENSG00000072080.11",
      gene_type : "protein_coding",
      gene_name : "SPP2",
      gene_level : 1,
      hgnc_id : "HGNC:11256",
      havana_gene : "OTTHUMG00000059208.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 234493041,
      stop : 234497081,
      direction : "-",
      ID : "ENSG00000188042.8",
      gene_id : "ENSG00000188042.8",
      gene_type : "protein_coding",
      gene_name : "ARL4C",
      gene_level : 2,
      hgnc_id : "HGNC:698",
      havana_gene : "OTTHUMG00000133291.3",
      tag : "retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 234952017,
      stop : 235055714,
      direction : "+",
      ID : "ENSG00000130147.16",
      gene_id : "ENSG00000130147.16",
      gene_type : "protein_coding",
      gene_name : "SH3BP4",
      gene_level : 1,
      hgnc_id : "HGNC:10826",
      havana_gene : "OTTHUMG00000133292.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 235494043,
      stop : 236131800,
      direction : "+",
      ID : "ENSG00000157985.19",
      gene_id : "ENSG00000157985.19",
      gene_type : "protein_coding",
      gene_name : "AGAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16922",
      havana_gene : "OTTHUMG00000133293.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 236165236,
      stop : 236168386,
      direction : "-",
      ID : "ENSG00000168505.7",
      gene_id : "ENSG00000168505.7",
      gene_type : "protein_coding",
      gene_name : "GBX2",
      gene_level : 2,
      hgnc_id : "HGNC:4186",
      havana_gene : "OTTHUMG00000133294.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 236194872,
      stop : 236264409,
      direction : "-",
      ID : "ENSG00000182177.14",
      gene_id : "ENSG00000182177.14",
      gene_type : "protein_coding",
      gene_name : "ASB18",
      gene_level : 1,
      hgnc_id : "HGNC:19770",
      havana_gene : "OTTHUMG00000153086.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 236324147,
      stop : 236507535,
      direction : "-",
      ID : "ENSG00000132321.17",
      gene_id : "ENSG00000132321.17",
      gene_type : "protein_coding",
      gene_name : "IQCA1",
      gene_level : 1,
      hgnc_id : "HGNC:26195",
      havana_gene : "OTTHUMG00000153058.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 236567787,
      stop : 236582354,
      direction : "+",
      ID : "ENSG00000144476.6",
      gene_id : "ENSG00000144476.6",
      gene_type : "protein_coding",
      gene_name : "ACKR3",
      gene_level : 2,
      hgnc_id : "HGNC:23692",
      havana_gene : "OTTHUMG00000133295.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237085882,
      stop : 237100474,
      direction : "+",
      ID : "ENSG00000198612.11",
      gene_id : "ENSG00000198612.11",
      gene_type : "protein_coding",
      gene_name : "COPS8",
      gene_level : 2,
      hgnc_id : "HGNC:24335",
      havana_gene : "OTTHUMG00000133297.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237324003,
      stop : 237414207,
      direction : "-",
      ID : "ENSG00000163359.16",
      gene_id : "ENSG00000163359.16",
      gene_type : "protein_coding",
      gene_name : "COL6A3",
      gene_level : 2,
      hgnc_id : "HGNC:2213",
      havana_gene : "OTTHUMG00000150020.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237485428,
      stop : 237555322,
      direction : "+",
      ID : "ENSG00000115648.14",
      gene_id : "ENSG00000115648.14",
      gene_type : "protein_coding",
      gene_name : "MLPH",
      gene_level : 1,
      hgnc_id : "HGNC:29643",
      havana_gene : "OTTHUMG00000133298.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237566574,
      stop : 237567175,
      direction : "+",
      ID : "ENSG00000071677.1",
      gene_id : "ENSG00000071677.1",
      gene_type : "protein_coding",
      gene_name : "PRLH",
      gene_level : 2,
      hgnc_id : "HGNC:17945",
      havana_gene : "OTTHUMG00000133296.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237574322,
      stop : 237601614,
      direction : "-",
      ID : "ENSG00000124839.13",
      gene_id : "ENSG00000124839.13",
      gene_type : "protein_coding",
      gene_name : "RAB17",
      gene_level : 1,
      hgnc_id : "HGNC:16523",
      havana_gene : "OTTHUMG00000133299.6",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237627587,
      stop : 237813682,
      direction : "+",
      ID : "ENSG00000124831.19",
      gene_id : "ENSG00000124831.19",
      gene_type : "protein_coding",
      gene_name : "LRRFIP1",
      gene_level : 1,
      hgnc_id : "HGNC:6702",
      havana_gene : "OTTHUMG00000133339.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237798389,
      stop : 237842808,
      direction : "+",
      ID : "ENSG00000177483.12",
      gene_id : "ENSG00000177483.12",
      gene_type : "protein_coding",
      gene_name : "RBM44",
      gene_level : 1,
      hgnc_id : "HGNC:24756",
      havana_gene : "OTTHUMG00000152937.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237858893,
      stop : 237912106,
      direction : "+",
      ID : "ENSG00000132329.11",
      gene_id : "ENSG00000132329.11",
      gene_type : "protein_coding",
      gene_name : "RAMP1",
      gene_level : 1,
      hgnc_id : "HGNC:9843",
      havana_gene : "OTTHUMG00000133337.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237966827,
      stop : 238042782,
      direction : "+",
      ID : "ENSG00000184182.19",
      gene_id : "ENSG00000184182.19",
      gene_type : "protein_coding",
      gene_name : "UBE2F",
      gene_level : 2,
      hgnc_id : "HGNC:12480",
      havana_gene : "OTTHUMG00000133341.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 237967014,
      stop : 238099412,
      direction : "+",
      ID : "ENSG00000258984.5",
      gene_id : "ENSG00000258984.5",
      gene_type : "protein_coding",
      gene_name : "UBE2F-SCLY",
      gene_level : 2,
      hgnc_id : "HGNC:48339",
      havana_gene : "OTTHUMG00000170602.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238060924,
      stop : 238099413,
      direction : "+",
      ID : "ENSG00000132330.18",
      gene_id : "ENSG00000132330.18",
      gene_type : "protein_coding",
      gene_name : "SCLY",
      gene_level : 1,
      hgnc_id : "HGNC:18161",
      havana_gene : "OTTHUMG00000133336.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238100340,
      stop : 238133287,
      direction : "+",
      ID : "ENSG00000144488.15",
      gene_id : "ENSG00000144488.15",
      gene_type : "protein_coding",
      gene_name : "ESPNL",
      gene_level : 2,
      hgnc_id : "HGNC:27937",
      havana_gene : "OTTHUMG00000133335.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238138668,
      stop : 238152947,
      direction : "+",
      ID : "ENSG00000168427.9",
      gene_id : "ENSG00000168427.9",
      gene_type : "protein_coding",
      gene_name : "KLHL30",
      gene_level : 2,
      hgnc_id : "HGNC:24770",
      havana_gene : "OTTHUMG00000152905.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238158970,
      stop : 238168900,
      direction : "+",
      ID : "ENSG00000178752.16",
      gene_id : "ENSG00000178752.16",
      gene_type : "protein_coding",
      gene_name : "ERFE",
      gene_level : 1,
      hgnc_id : "HGNC:26727",
      havana_gene : "OTTHUMG00000152901.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238170402,
      stop : 238203708,
      direction : "-",
      ID : "ENSG00000132323.9",
      gene_id : "ENSG00000132323.9",
      gene_type : "protein_coding",
      gene_name : "ILKAP",
      gene_level : 1,
      hgnc_id : "HGNC:15566",
      havana_gene : "OTTHUMG00000133334.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238238267,
      stop : 238240662,
      direction : "-",
      ID : "ENSG00000144485.11",
      gene_id : "ENSG00000144485.11",
      gene_type : "protein_coding",
      gene_name : "HES6",
      gene_level : 2,
      hgnc_id : "HGNC:18254",
      havana_gene : "OTTHUMG00000133340.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238244044,
      stop : 238290102,
      direction : "-",
      ID : "ENSG00000132326.12",
      gene_id : "ENSG00000132326.12",
      gene_type : "protein_coding",
      gene_name : "PER2",
      gene_level : 2,
      hgnc_id : "HGNC:8846",
      havana_gene : "OTTHUMG00000152884.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238320441,
      stop : 238400897,
      direction : "+",
      ID : "ENSG00000204104.12",
      gene_id : "ENSG00000204104.12",
      gene_type : "protein_coding",
      gene_name : "TRAF3IP1",
      gene_level : 2,
      hgnc_id : "HGNC:17861",
      havana_gene : "OTTHUMG00000152872.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238426742,
      stop : 238452250,
      direction : "+",
      ID : "ENSG00000065802.12",
      gene_id : "ENSG00000065802.12",
      gene_type : "protein_coding",
      gene_name : "ASB1",
      gene_level : 1,
      hgnc_id : "HGNC:16011",
      havana_gene : "OTTHUMG00000152866.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 238848032,
      stop : 238910534,
      direction : "+",
      ID : "ENSG00000233608.4",
      gene_id : "ENSG00000233608.4",
      gene_type : "protein_coding",
      gene_name : "TWIST2",
      gene_level : 2,
      hgnc_id : "HGNC:20670",
      havana_gene : "OTTHUMG00000152836.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 239048168,
      stop : 239401654,
      direction : "-",
      ID : "ENSG00000068024.17",
      gene_id : "ENSG00000068024.17",
      gene_type : "protein_coding",
      gene_name : "HDAC4",
      gene_level : 2,
      hgnc_id : "HGNC:14063",
      havana_gene : "OTTHUMG00000133344.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 239892450,
      stop : 240025743,
      direction : "-",
      ID : "ENSG00000130414.13",
      gene_id : "ENSG00000130414.13",
      gene_type : "protein_coding",
      gene_name : "NDUFA10",
      gene_level : 1,
      hgnc_id : "HGNC:7684",
      havana_gene : "OTTHUMG00000133350.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240028965,
      stop : 240030456,
      direction : "-",
      ID : "ENSG00000182083.7",
      gene_id : "ENSG00000182083.7",
      gene_type : "protein_coding",
      gene_name : "OR6B2",
      gene_level : 2,
      hgnc_id : "HGNC:15041",
      havana_gene : "OTTHUMG00000152400.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240045077,
      stop : 240047027,
      direction : "-",
      ID : "ENSG00000178586.5",
      gene_id : "ENSG00000178586.5",
      gene_type : "protein_coding",
      gene_name : "OR6B3",
      gene_level : 2,
      hgnc_id : "HGNC:15042",
      havana_gene : "OTTHUMG00000152399.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240126563,
      stop : 240136807,
      direction : "-",
      ID : "ENSG00000172428.11",
      gene_id : "ENSG00000172428.11",
      gene_type : "protein_coding",
      gene_name : "COPS9",
      gene_level : 2,
      hgnc_id : "HGNC:21314",
      havana_gene : "OTTHUMG00000133352.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240139026,
      stop : 240144562,
      direction : "-",
      ID : "ENSG00000178602.8",
      gene_id : "ENSG00000178602.8",
      gene_type : "protein_coding",
      gene_name : "OTOS",
      gene_level : 2,
      hgnc_id : "HGNC:22644",
      havana_gene : "OTTHUMG00000133351.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240435663,
      stop : 240468076,
      direction : "+",
      ID : "ENSG00000063660.9",
      gene_id : "ENSG00000063660.9",
      gene_type : "protein_coding",
      gene_name : "GPC1",
      gene_level : 1,
      hgnc_id : "HGNC:4449",
      havana_gene : "OTTHUMG00000133349.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240479422,
      stop : 240569209,
      direction : "-",
      ID : "ENSG00000144504.15",
      gene_id : "ENSG00000144504.15",
      gene_type : "protein_coding",
      gene_name : "ANKMY1",
      gene_level : 1,
      hgnc_id : "HGNC:20987",
      havana_gene : "OTTHUMG00000133355.9",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240560054,
      stop : 240565256,
      direction : "+",
      ID : "ENSG00000188542.10",
      gene_id : "ENSG00000188542.10",
      gene_type : "protein_coding",
      gene_name : "DUSP28",
      gene_level : 1,
      hgnc_id : "HGNC:33237",
      havana_gene : "OTTHUMG00000152310.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240565804,
      stop : 240581372,
      direction : "+",
      ID : "ENSG00000142327.13",
      gene_id : "ENSG00000142327.13",
      gene_type : "protein_coding",
      gene_name : "RNPEPL1",
      gene_level : 1,
      hgnc_id : "HGNC:10079",
      havana_gene : "OTTHUMG00000133357.8",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240586734,
      stop : 240617705,
      direction : "+",
      ID : "ENSG00000142330.20",
      gene_id : "ENSG00000142330.20",
      gene_type : "protein_coding",
      gene_name : "CAPN10",
      gene_level : 1,
      hgnc_id : "HGNC:1477",
      havana_gene : "OTTHUMG00000133358.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240605430,
      stop : 240631259,
      direction : "+",
      ID : "ENSG00000178623.12",
      gene_id : "ENSG00000178623.12",
      gene_type : "protein_coding",
      gene_name : "GPR35",
      gene_level : 2,
      hgnc_id : "HGNC:4492",
      havana_gene : "OTTHUMG00000133356.5",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240676418,
      stop : 240682906,
      direction : "-",
      ID : "ENSG00000185176.13",
      gene_id : "ENSG00000185176.13",
      gene_type : "protein_coding",
      gene_name : "AQP12B",
      gene_level : 2,
      hgnc_id : "HGNC:6096",
      havana_gene : "OTTHUMG00000152263.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240691851,
      stop : 240698483,
      direction : "+",
      ID : "ENSG00000184945.14",
      gene_id : "ENSG00000184945.14",
      gene_type : "protein_coding",
      gene_name : "AQP12A",
      gene_level : 2,
      hgnc_id : "HGNC:19941",
      havana_gene : "OTTHUMG00000183906.2",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240713761,
      stop : 240824293,
      direction : "-",
      ID : "ENSG00000130294.18",
      gene_id : "ENSG00000130294.18",
      gene_type : "protein_coding",
      gene_name : "KIF1A",
      gene_level : 2,
      hgnc_id : "HGNC:888",
      havana_gene : "OTTHUMG00000151940.14",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240868824,
      stop : 240880502,
      direction : "+",
      ID : "ENSG00000172482.5",
      gene_id : "ENSG00000172482.5",
      gene_type : "protein_coding",
      gene_name : "AGXT",
      gene_level : 2,
      hgnc_id : "HGNC:341",
      havana_gene : "OTTHUMG00000133354.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240886048,
      stop : 240896889,
      direction : "-",
      ID : "ENSG00000172478.18",
      gene_id : "ENSG00000172478.18",
      gene_type : "protein_coding",
      gene_name : "MAB21L4",
      gene_level : 2,
      hgnc_id : "HGNC:26216",
      havana_gene : "OTTHUMG00000151906.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240906330,
      stop : 240993311,
      direction : "+",
      ID : "ENSG00000226321.5",
      gene_id : "ENSG00000226321.5",
      gene_type : "protein_coding",
      gene_name : "CROCC2",
      gene_level : 1,
      hgnc_id : "HGNC:51677",
      havana_gene : "OTTHUMG00000151855.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 240998618,
      stop : 241095568,
      direction : "+",
      ID : "ENSG00000162804.14",
      gene_id : "ENSG00000162804.14",
      gene_type : "protein_coding",
      gene_name : "SNED1",
      gene_level : 1,
      hgnc_id : "HGNC:24696",
      havana_gene : "OTTHUMG00000151803.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241072169,
      stop : 241102332,
      direction : "-",
      ID : "ENSG00000122085.17",
      gene_id : "ENSG00000122085.17",
      gene_type : "protein_coding",
      gene_name : "MTERF4",
      gene_level : 1,
      hgnc_id : "HGNC:28785",
      havana_gene : "OTTHUMG00000133393.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241106099,
      stop : 241150264,
      direction : "-",
      ID : "ENSG00000115687.14",
      gene_id : "ENSG00000115687.14",
      gene_type : "protein_coding",
      gene_name : "PASK",
      gene_level : 2,
      hgnc_id : "HGNC:17270",
      havana_gene : "OTTHUMG00000133392.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241149576,
      stop : 241183652,
      direction : "+",
      ID : "ENSG00000115685.15",
      gene_id : "ENSG00000115685.15",
      gene_type : "protein_coding",
      gene_name : "PPP1R7",
      gene_level : 1,
      hgnc_id : "HGNC:9295",
      havana_gene : "OTTHUMG00000133390.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241188509,
      stop : 241225377,
      direction : "+",
      ID : "ENSG00000146205.14",
      gene_id : "ENSG00000146205.14",
      gene_type : "protein_coding",
      gene_name : "ANO7",
      gene_level : 2,
      hgnc_id : "HGNC:31677",
      havana_gene : "OTTHUMG00000151702.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241227264,
      stop : 241317061,
      direction : "-",
      ID : "ENSG00000115677.17",
      gene_id : "ENSG00000115677.17",
      gene_type : "protein_coding",
      gene_name : "HDLBP",
      gene_level : 1,
      hgnc_id : "HGNC:4857",
      havana_gene : "OTTHUMG00000133391.10",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241315100,
      stop : 241354027,
      direction : "+",
      ID : "ENSG00000168385.18",
      gene_id : "ENSG00000168385.18",
      gene_type : "protein_coding",
      gene_name : "SEPTIN2",
      gene_level : 1,
      hgnc_id : "HGNC:7729",
      havana_gene : "OTTHUMG00000133394.13",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241356285,
      stop : 241494841,
      direction : "+",
      ID : "ENSG00000006607.14",
      gene_id : "ENSG00000006607.14",
      gene_type : "protein_coding",
      gene_name : "FARP2",
      gene_level : 1,
      hgnc_id : "HGNC:16460",
      havana_gene : "OTTHUMG00000151574.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241492670,
      stop : 241509730,
      direction : "-",
      ID : "ENSG00000115694.15",
      gene_id : "ENSG00000115694.15",
      gene_type : "protein_coding",
      gene_name : "STK25",
      gene_level : 1,
      hgnc_id : "HGNC:11404",
      havana_gene : "OTTHUMG00000133408.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241551424,
      stop : 241574131,
      direction : "+",
      ID : "ENSG00000176720.6",
      gene_id : "ENSG00000176720.6",
      gene_type : "protein_coding",
      gene_name : "BOK",
      gene_level : 2,
      hgnc_id : "HGNC:1087",
      havana_gene : "OTTHUMG00000133411.5",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241584405,
      stop : 241637158,
      direction : "-",
      ID : "ENSG00000176946.12",
      gene_id : "ENSG00000176946.12",
      gene_type : "protein_coding",
      gene_name : "THAP4",
      gene_level : 1,
      hgnc_id : "HGNC:23187",
      havana_gene : "OTTHUMG00000133410.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241637213,
      stop : 241673857,
      direction : "+",
      ID : "ENSG00000168397.17",
      gene_id : "ENSG00000168397.17",
      gene_type : "protein_coding",
      gene_name : "ATG4B",
      gene_level : 1,
      hgnc_id : "HGNC:20790",
      havana_gene : "OTTHUMG00000151514.17",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241675747,
      stop : 241686944,
      direction : "-",
      ID : "ENSG00000168393.13",
      gene_id : "ENSG00000168393.13",
      gene_type : "protein_coding",
      gene_name : "DTYMK",
      gene_level : 1,
      hgnc_id : "HGNC:3061",
      havana_gene : "OTTHUMG00000133409.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241687085,
      stop : 241729478,
      direction : "+",
      ID : "ENSG00000168395.16",
      gene_id : "ENSG00000168395.16",
      gene_type : "protein_coding",
      gene_name : "ING5",
      gene_level : 2,
      hgnc_id : "HGNC:19421",
      havana_gene : "OTTHUMG00000151501.4",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241734602,
      stop : 241768816,
      direction : "+",
      ID : "ENSG00000180902.18",
      gene_id : "ENSG00000180902.18",
      gene_type : "protein_coding",
      gene_name : "D2HGDH",
      gene_level : 1,
      hgnc_id : "HGNC:28358",
      havana_gene : "OTTHUMG00000151474.15",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241776822,
      stop : 241804287,
      direction : "+",
      ID : "ENSG00000154252.12",
      gene_id : "ENSG00000154252.12",
      gene_type : "protein_coding",
      gene_name : "GAL3ST2",
      gene_level : 2,
      hgnc_id : "HGNC:24869",
      havana_gene : "OTTHUMG00000151473.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241809065,
      stop : 241817413,
      direction : "+",
      ID : "ENSG00000204099.12",
      gene_id : "ENSG00000204099.12",
      gene_type : "protein_coding",
      gene_name : "NEU4",
      gene_level : 2,
      hgnc_id : "HGNC:21328",
      havana_gene : "OTTHUMG00000133412.7",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241849884,
      stop : 241858894,
      direction : "-",
      ID : "ENSG00000188389.11",
      gene_id : "ENSG00000188389.11",
      gene_type : "protein_coding",
      gene_name : "PDCD1",
      gene_level : 2,
      hgnc_id : "HGNC:8760",
      havana_gene : "OTTHUMG00000151342.3",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241869600,
      stop : 241873823,
      direction : "+",
      ID : "ENSG00000188011.5",
      gene_id : "ENSG00000188011.5",
      gene_type : "protein_coding",
      gene_name : "RTP5",
      gene_level : 2,
      hgnc_id : "HGNC:26585",
      havana_gene : "OTTHUMG00000151341.1",
      tag : null
    },
    {
      chromosome : 2,
      annotation : "HAVANA",
      type : "gene",
      start : 241893988,
      stop : 241902551,
      direction : "-",
      ID : "ENSG00000216921.9",
      gene_id : "ENSG00000216921.9",
      gene_type : "protein_coding",
      gene_name : "FAM240C",
      gene_level : 1,
      hgnc_id : "HGNC:54200",
      havana_gene : "OTTHUMG00000151374.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 87250,
      stop : 97094,
      direction : "+",
      ID : "ENSG00000178591.7",
      gene_id : "ENSG00000178591.7",
      gene_type : "protein_coding",
      gene_name : "DEFB125",
      gene_level : 2,
      hgnc_id : "HGNC:18105",
      havana_gene : "OTTHUMG00000031614.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 142590,
      stop : 145751,
      direction : "+",
      ID : "ENSG00000125788.6",
      gene_id : "ENSG00000125788.6",
      gene_type : "protein_coding",
      gene_name : "DEFB126",
      gene_level : 2,
      hgnc_id : "HGNC:15900",
      havana_gene : "OTTHUMG00000031616.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 157454,
      stop : 159163,
      direction : "+",
      ID : "ENSG00000088782.5",
      gene_id : "ENSG00000088782.5",
      gene_type : "protein_coding",
      gene_name : "DEFB127",
      gene_level : 2,
      hgnc_id : "HGNC:16206",
      havana_gene : "OTTHUMG00000031617.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 187853,
      stop : 189711,
      direction : "-",
      ID : "ENSG00000185982.7",
      gene_id : "ENSG00000185982.7",
      gene_type : "protein_coding",
      gene_name : "DEFB128",
      gene_level : 2,
      hgnc_id : "HGNC:18106",
      havana_gene : "OTTHUMG00000043057.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 227258,
      stop : 229886,
      direction : "+",
      ID : "ENSG00000125903.4",
      gene_id : "ENSG00000125903.4",
      gene_type : "protein_coding",
      gene_name : "DEFB129",
      gene_level : 2,
      hgnc_id : "HGNC:16218",
      havana_gene : "OTTHUMG00000031618.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 257724,
      stop : 261096,
      direction : "+",
      ID : "ENSG00000186458.5",
      gene_id : "ENSG00000186458.5",
      gene_type : "protein_coding",
      gene_name : "DEFB132",
      gene_level : 2,
      hgnc_id : "HGNC:33806",
      havana_gene : "OTTHUMG00000043061.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 270863,
      stop : 290778,
      direction : "-",
      ID : "ENSG00000196476.12",
      gene_id : "ENSG00000196476.12",
      gene_type : "protein_coding",
      gene_name : "C20orf96",
      gene_level : 2,
      hgnc_id : "HGNC:16227",
      havana_gene : "OTTHUMG00000031626.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 297570,
      stop : 300321,
      direction : "+",
      ID : "ENSG00000247315.4",
      gene_id : "ENSG00000247315.4",
      gene_type : "protein_coding",
      gene_name : "ZCCHC3",
      gene_level : 2,
      hgnc_id : "HGNC:16230",
      havana_gene : "OTTHUMG00000188280.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 325552,
      stop : 330224,
      direction : "+",
      ID : "ENSG00000177732.9",
      gene_id : "ENSG00000177732.9",
      gene_type : "protein_coding",
      gene_name : "SOX12",
      gene_level : 2,
      hgnc_id : "HGNC:11198",
      havana_gene : "OTTHUMG00000031623.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 346782,
      stop : 359660,
      direction : "+",
      ID : "ENSG00000125841.13",
      gene_id : "ENSG00000125841.13",
      gene_type : "protein_coding",
      gene_name : "NRSN2",
      gene_level : 1,
      hgnc_id : "HGNC:16229",
      havana_gene : "OTTHUMG00000031628.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 362835,
      stop : 397559,
      direction : "+",
      ID : "ENSG00000101255.11",
      gene_id : "ENSG00000101255.11",
      gene_type : "protein_coding",
      gene_name : "TRIB3",
      gene_level : 2,
      hgnc_id : "HGNC:16228",
      havana_gene : "OTTHUMG00000031627.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 407498,
      stop : 432139,
      direction : "+",
      ID : "ENSG00000125826.21",
      gene_id : "ENSG00000125826.21",
      gene_type : "protein_coding",
      gene_name : "RBCK1",
      gene_level : 1,
      hgnc_id : "HGNC:15864",
      havana_gene : "OTTHUMG00000031634.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 423596,
      stop : 462566,
      direction : "-",
      ID : "ENSG00000125875.15",
      gene_id : "ENSG00000125875.15",
      gene_type : "protein_coding",
      gene_name : "TBC1D20",
      gene_level : 2,
      hgnc_id : "HGNC:16133",
      havana_gene : "OTTHUMG00000031637.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 472498,
      stop : 543835,
      direction : "-",
      ID : "ENSG00000101266.19",
      gene_id : "ENSG00000101266.19",
      gene_type : "protein_coding",
      gene_name : "CSNK2A1",
      gene_level : 2,
      hgnc_id : "HGNC:2457",
      havana_gene : "OTTHUMG00000031636.13",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 603797,
      stop : 610398,
      direction : "-",
      ID : "ENSG00000125878.6",
      gene_id : "ENSG00000125878.6",
      gene_type : "protein_coding",
      gene_name : "TCF15",
      gene_level : 2,
      hgnc_id : "HGNC:11627",
      havana_gene : "OTTHUMG00000031640.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 646615,
      stop : 653200,
      direction : "-",
      ID : "ENSG00000271303.2",
      gene_id : "ENSG00000271303.2",
      gene_type : "protein_coding",
      gene_name : "SRXN1",
      gene_level : 2,
      hgnc_id : "HGNC:16132",
      havana_gene : "OTTHUMG00000031644.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 646626,
      stop : 675800,
      direction : "-",
      ID : "ENSG00000270299.1",
      gene_id : "ENSG00000270299.1",
      gene_type : "protein_coding",
      gene_name : "AL121758.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000184659.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 661596,
      stop : 675802,
      direction : "-",
      ID : "ENSG00000215397.4",
      gene_id : "ENSG00000215397.4",
      gene_type : "protein_coding",
      gene_name : "SCRT2",
      gene_level : 2,
      hgnc_id : "HGNC:15952",
      havana_gene : "OTTHUMG00000130829.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 760080,
      stop : 776015,
      direction : "-",
      ID : "ENSG00000101276.18",
      gene_id : "ENSG00000101276.18",
      gene_type : "protein_coding",
      gene_name : "SLC52A3",
      gene_level : 1,
      hgnc_id : "HGNC:16187",
      havana_gene : "OTTHUMG00000031647.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 833715,
      stop : 857463,
      direction : "+",
      ID : "ENSG00000125898.13",
      gene_id : "ENSG00000125898.13",
      gene_type : "protein_coding",
      gene_name : "FAM110A",
      gene_level : 2,
      hgnc_id : "HGNC:16188",
      havana_gene : "OTTHUMG00000031649.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 869900,
      stop : 916334,
      direction : "-",
      ID : "ENSG00000101280.8",
      gene_id : "ENSG00000101280.8",
      gene_type : "protein_coding",
      gene_name : "ANGPT4",
      gene_level : 2,
      hgnc_id : "HGNC:487",
      havana_gene : "OTTHUMG00000031652.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 958452,
      stop : 1002311,
      direction : "-",
      ID : "ENSG00000101282.9",
      gene_id : "ENSG00000101282.9",
      gene_type : "protein_coding",
      gene_name : "RSPO4",
      gene_level : 2,
      hgnc_id : "HGNC:16175",
      havana_gene : "OTTHUMG00000031651.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1113240,
      stop : 1189415,
      direction : "+",
      ID : "ENSG00000125818.18",
      gene_id : "ENSG00000125818.18",
      gene_type : "protein_coding",
      gene_name : "PSMF1",
      gene_level : 2,
      hgnc_id : "HGNC:9571",
      havana_gene : "OTTHUMG00000031656.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1180561,
      stop : 1185415,
      direction : "-",
      ID : "ENSG00000125895.5",
      gene_id : "ENSG00000125895.5",
      gene_type : "protein_coding",
      gene_name : "TMEM74B",
      gene_level : 2,
      hgnc_id : "HGNC:15893",
      havana_gene : "OTTHUMG00000031655.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1203454,
      stop : 1208279,
      direction : "+",
      ID : "ENSG00000215595.2",
      gene_id : "ENSG00000215595.2",
      gene_type : "protein_coding",
      gene_name : "C20orf202",
      gene_level : 2,
      hgnc_id : "HGNC:37254",
      havana_gene : "OTTHUMG00000129375.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1226056,
      stop : 1296421,
      direction : "+",
      ID : "ENSG00000244588.5",
      gene_id : "ENSG00000244588.5",
      gene_type : "protein_coding",
      gene_name : "RAD21L1",
      gene_level : 2,
      hgnc_id : "HGNC:16271",
      havana_gene : "OTTHUMG00000031664.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1266280,
      stop : 1309328,
      direction : "+",
      ID : "ENSG00000101298.15",
      gene_id : "ENSG00000101298.15",
      gene_type : "protein_coding",
      gene_name : "SNPH",
      gene_level : 2,
      hgnc_id : "HGNC:15931",
      havana_gene : "OTTHUMG00000031662.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1309909,
      stop : 1329139,
      direction : "-",
      ID : "ENSG00000125775.15",
      gene_id : "ENSG00000125775.15",
      gene_type : "protein_coding",
      gene_name : "SDCBP2",
      gene_level : 2,
      hgnc_id : "HGNC:15756",
      havana_gene : "OTTHUMG00000031661.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1317571,
      stop : 1393096,
      direction : "-",
      ID : "ENSG00000274322.1",
      gene_id : "ENSG00000274322.1",
      gene_type : "protein_coding",
      gene_name : "AL136531.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000186553.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1368977,
      stop : 1393164,
      direction : "-",
      ID : "ENSG00000088832.18",
      gene_id : "ENSG00000088832.18",
      gene_type : "protein_coding",
      gene_name : "FKBP1A",
      gene_level : 2,
      hgnc_id : "HGNC:3711",
      havana_gene : "OTTHUMG00000031666.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1442162,
      stop : 1473842,
      direction : "-",
      ID : "ENSG00000088833.18",
      gene_id : "ENSG00000088833.18",
      gene_type : "protein_coding",
      gene_name : "NSFL1C",
      gene_level : 2,
      hgnc_id : "HGNC:15912",
      havana_gene : "OTTHUMG00000031665.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1470741,
      stop : 1491587,
      direction : "-",
      ID : "ENSG00000196209.13",
      gene_id : "ENSG00000196209.13",
      gene_type : "protein_coding",
      gene_name : "SIRPB2",
      gene_level : 2,
      hgnc_id : "HGNC:16247",
      havana_gene : "OTTHUMG00000031670.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1534251,
      stop : 1557705,
      direction : "-",
      ID : "ENSG00000125900.13",
      gene_id : "ENSG00000125900.13",
      gene_type : "protein_coding",
      gene_name : "SIRPD",
      gene_level : 1,
      hgnc_id : "HGNC:16248",
      havana_gene : "OTTHUMG00000031674.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1540144,
      stop : 1620009,
      direction : "-",
      ID : "ENSG00000260861.6",
      gene_id : "ENSG00000260861.6",
      gene_type : "protein_coding",
      gene_name : "AL049634.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000172944.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1561385,
      stop : 1620061,
      direction : "-",
      ID : "ENSG00000101307.16",
      gene_id : "ENSG00000101307.16",
      gene_type : "protein_coding",
      gene_name : "SIRPB1",
      gene_level : 1,
      hgnc_id : "HGNC:15928",
      havana_gene : "OTTHUMG00000031676.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1629152,
      stop : 1657779,
      direction : "-",
      ID : "ENSG00000089012.14",
      gene_id : "ENSG00000089012.14",
      gene_type : "protein_coding",
      gene_name : "SIRPG",
      gene_level : 2,
      hgnc_id : "HGNC:15757",
      havana_gene : "OTTHUMG00000031680.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1894167,
      stop : 1940592,
      direction : "+",
      ID : "ENSG00000198053.12",
      gene_id : "ENSG00000198053.12",
      gene_type : "protein_coding",
      gene_name : "SIRPA",
      gene_level : 2,
      hgnc_id : "HGNC:9662",
      havana_gene : "OTTHUMG00000031682.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 1978757,
      stop : 1994285,
      direction : "-",
      ID : "ENSG00000101327.9",
      gene_id : "ENSG00000101327.9",
      gene_type : "protein_coding",
      gene_name : "PDYN",
      gene_level : 2,
      hgnc_id : "HGNC:8820",
      havana_gene : "OTTHUMG00000031683.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2101827,
      stop : 2177038,
      direction : "+",
      ID : "ENSG00000125834.13",
      gene_id : "ENSG00000125834.13",
      gene_type : "protein_coding",
      gene_name : "STK35",
      gene_level : 2,
      hgnc_id : "HGNC:16254",
      havana_gene : "OTTHUMG00000031688.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2207328,
      stop : 2341059,
      direction : "+",
      ID : "ENSG00000286022.1",
      gene_id : "ENSG00000286022.1",
      gene_type : "protein_coding",
      gene_name : "AL121899.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193450.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2296001,
      stop : 2341079,
      direction : "+",
      ID : "ENSG00000125780.12",
      gene_id : "ENSG00000125780.12",
      gene_type : "protein_coding",
      gene_name : "TGM3",
      gene_level : 2,
      hgnc_id : "HGNC:11779",
      havana_gene : "OTTHUMG00000031690.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2380901,
      stop : 2432753,
      direction : "+",
      ID : "ENSG00000166948.10",
      gene_id : "ENSG00000166948.10",
      gene_type : "protein_coding",
      gene_name : "TGM6",
      gene_level : 2,
      hgnc_id : "HGNC:16255",
      havana_gene : "OTTHUMG00000031692.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2461634,
      stop : 2470853,
      direction : "-",
      ID : "ENSG00000125835.19",
      gene_id : "ENSG00000125835.19",
      gene_type : "protein_coding",
      gene_name : "SNRPB",
      gene_level : 2,
      hgnc_id : "HGNC:11153",
      havana_gene : "OTTHUMG00000031694.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2467212,
      stop : 2508907,
      direction : "-",
      ID : "ENSG00000256566.1",
      gene_id : "ENSG00000256566.1",
      gene_type : "protein_coding",
      gene_name : "AL049650.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168016.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2481817,
      stop : 2524702,
      direction : "-",
      ID : "ENSG00000088876.13",
      gene_id : "ENSG00000088876.13",
      gene_type : "protein_coding",
      gene_name : "ZNF343",
      gene_level : 2,
      hgnc_id : "HGNC:16017",
      havana_gene : "OTTHUMG00000031701.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2536573,
      stop : 2643580,
      direction : "+",
      ID : "ENSG00000149488.14",
      gene_id : "ENSG00000149488.14",
      gene_type : "protein_coding",
      gene_name : "TMC2",
      gene_level : 2,
      hgnc_id : "HGNC:16527",
      havana_gene : "OTTHUMG00000031698.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2652593,
      stop : 2658393,
      direction : "+",
      ID : "ENSG00000101361.17",
      gene_id : "ENSG00000101361.17",
      gene_type : "protein_coding",
      gene_name : "NOP56",
      gene_level : 2,
      hgnc_id : "HGNC:15911",
      havana_gene : "OTTHUMG00000031703.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2658395,
      stop : 2664219,
      direction : "-",
      ID : "ENSG00000101365.21",
      gene_id : "ENSG00000101365.21",
      gene_type : "protein_coding",
      gene_name : "IDH3B",
      gene_level : 2,
      hgnc_id : "HGNC:5385",
      havana_gene : "OTTHUMG00000031699.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2692874,
      stop : 2760108,
      direction : "+",
      ID : "ENSG00000088881.21",
      gene_id : "ENSG00000088881.21",
      gene_type : "protein_coding",
      gene_name : "EBF4",
      gene_level : 2,
      hgnc_id : "HGNC:29278",
      havana_gene : "OTTHUMG00000031709.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2794074,
      stop : 2800627,
      direction : "-",
      ID : "ENSG00000088882.8",
      gene_id : "ENSG00000088882.8",
      gene_type : "protein_coding",
      gene_name : "CPXM1",
      gene_level : 2,
      hgnc_id : "HGNC:15771",
      havana_gene : "OTTHUMG00000031706.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2814968,
      stop : 2818066,
      direction : "+",
      ID : "ENSG00000241690.3",
      gene_id : "ENSG00000241690.3",
      gene_type : "protein_coding",
      gene_name : "AL035460.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171821.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2814987,
      stop : 2815833,
      direction : "+",
      ID : "ENSG00000258713.3",
      gene_id : "ENSG00000258713.3",
      gene_type : "protein_coding",
      gene_name : "C20orf141",
      gene_level : 2,
      hgnc_id : "HGNC:16134",
      havana_gene : "OTTHUMG00000031707.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2816302,
      stop : 2820284,
      direction : "+",
      ID : "ENSG00000198326.10",
      gene_id : "ENSG00000198326.10",
      gene_type : "protein_coding",
      gene_name : "TMEM239",
      gene_level : 2,
      hgnc_id : "HGNC:40044",
      havana_gene : "OTTHUMG00000031713.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2835314,
      stop : 2841190,
      direction : "-",
      ID : "ENSG00000132635.17",
      gene_id : "ENSG00000132635.17",
      gene_type : "protein_coding",
      gene_name : "PCED1A",
      gene_level : 2,
      hgnc_id : "HGNC:16212",
      havana_gene : "OTTHUMG00000031716.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2840703,
      stop : 2866732,
      direction : "+",
      ID : "ENSG00000215305.10",
      gene_id : "ENSG00000215305.10",
      gene_type : "protein_coding",
      gene_name : "VPS16",
      gene_level : 2,
      hgnc_id : "HGNC:14584",
      havana_gene : "OTTHUMG00000031714.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 2864184,
      stop : 3039076,
      direction : "+",
      ID : "ENSG00000132670.20",
      gene_id : "ENSG00000132670.20",
      gene_type : "protein_coding",
      gene_name : "PTPRA",
      gene_level : 2,
      hgnc_id : "HGNC:9664",
      havana_gene : "OTTHUMG00000031718.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3043622,
      stop : 3045747,
      direction : "+",
      ID : "ENSG00000125787.11",
      gene_id : "ENSG00000125787.11",
      gene_type : "protein_coding",
      gene_name : "GNRH2",
      gene_level : 2,
      hgnc_id : "HGNC:4420",
      havana_gene : "OTTHUMG00000031723.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3046052,
      stop : 3048250,
      direction : "+",
      ID : "ENSG00000125901.6",
      gene_id : "ENSG00000125901.6",
      gene_type : "protein_coding",
      gene_name : "MRPS26",
      gene_level : 2,
      hgnc_id : "HGNC:14045",
      havana_gene : "OTTHUMG00000031721.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3071620,
      stop : 3072517,
      direction : "+",
      ID : "ENSG00000101405.3",
      gene_id : "ENSG00000101405.3",
      gene_type : "protein_coding",
      gene_name : "OXT",
      gene_level : 2,
      hgnc_id : "HGNC:8528",
      havana_gene : "OTTHUMG00000031724.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3082556,
      stop : 3084724,
      direction : "-",
      ID : "ENSG00000101200.5",
      gene_id : "ENSG00000101200.5",
      gene_type : "protein_coding",
      gene_name : "AVP",
      gene_level : 2,
      hgnc_id : "HGNC:894",
      havana_gene : "OTTHUMG00000031733.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3107573,
      stop : 3160196,
      direction : "-",
      ID : "ENSG00000185019.17",
      gene_id : "ENSG00000185019.17",
      gene_type : "protein_coding",
      gene_name : "UBOX5",
      gene_level : 2,
      hgnc_id : "HGNC:17777",
      havana_gene : "OTTHUMG00000031731.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3146519,
      stop : 3159865,
      direction : "-",
      ID : "ENSG00000215251.4",
      gene_id : "ENSG00000215251.4",
      gene_type : "protein_coding",
      gene_name : "FASTKD5",
      gene_level : 2,
      hgnc_id : "HGNC:25790",
      havana_gene : "OTTHUMG00000031727.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3162617,
      stop : 3173592,
      direction : "-",
      ID : "ENSG00000088899.15",
      gene_id : "ENSG00000088899.15",
      gene_type : "protein_coding",
      gene_name : "LZTS3",
      gene_level : 2,
      hgnc_id : "HGNC:30139",
      havana_gene : "OTTHUMG00000031735.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3190350,
      stop : 3204685,
      direction : "-",
      ID : "ENSG00000198171.13",
      gene_id : "ENSG00000198171.13",
      gene_type : "protein_coding",
      gene_name : "DDRGK1",
      gene_level : 2,
      hgnc_id : "HGNC:16110",
      havana_gene : "OTTHUMG00000031732.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3208868,
      stop : 3223870,
      direction : "+",
      ID : "ENSG00000125877.13",
      gene_id : "ENSG00000125877.13",
      gene_type : "protein_coding",
      gene_name : "ITPA",
      gene_level : 2,
      hgnc_id : "HGNC:6176",
      havana_gene : "OTTHUMG00000031738.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3227417,
      stop : 3239559,
      direction : "-",
      ID : "ENSG00000088836.14",
      gene_id : "ENSG00000088836.14",
      gene_type : "protein_coding",
      gene_name : "SLC4A11",
      gene_level : 2,
      hgnc_id : "HGNC:16438",
      havana_gene : "OTTHUMG00000031740.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3249306,
      stop : 3407669,
      direction : "-",
      ID : "ENSG00000088854.13",
      gene_id : "ENSG00000088854.13",
      gene_type : "protein_coding",
      gene_name : "C20orf194",
      gene_level : 2,
      hgnc_id : "HGNC:17721",
      havana_gene : "OTTHUMG00000031742.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3471018,
      stop : 3651118,
      direction : "+",
      ID : "ENSG00000088812.18",
      gene_id : "ENSG00000088812.18",
      gene_type : "protein_coding",
      gene_name : "ATRN",
      gene_level : 2,
      hgnc_id : "HGNC:885",
      havana_gene : "OTTHUMG00000031746.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3659248,
      stop : 3663399,
      direction : "-",
      ID : "ENSG00000125861.16",
      gene_id : "ENSG00000125861.16",
      gene_type : "protein_coding",
      gene_name : "GFRA4",
      gene_level : 2,
      hgnc_id : "HGNC:13821",
      havana_gene : "OTTHUMG00000031748.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3667965,
      stop : 3682246,
      direction : "-",
      ID : "ENSG00000149451.18",
      gene_id : "ENSG00000149451.18",
      gene_type : "protein_coding",
      gene_name : "ADAM33",
      gene_level : 2,
      hgnc_id : "HGNC:15478",
      havana_gene : "OTTHUMG00000031758.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3686970,
      stop : 3712600,
      direction : "-",
      ID : "ENSG00000088827.13",
      gene_id : "ENSG00000088827.13",
      gene_type : "protein_coding",
      gene_name : "SIGLEC1",
      gene_level : 2,
      hgnc_id : "HGNC:11127",
      havana_gene : "OTTHUMG00000031757.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3732685,
      stop : 3753111,
      direction : "+",
      ID : "ENSG00000132622.11",
      gene_id : "ENSG00000132622.11",
      gene_type : "protein_coding",
      gene_name : "HSPA12B",
      gene_level : 2,
      hgnc_id : "HGNC:16193",
      havana_gene : "OTTHUMG00000031755.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3753508,
      stop : 3767781,
      direction : "-",
      ID : "ENSG00000101220.18",
      gene_id : "ENSG00000101220.18",
      gene_type : "protein_coding",
      gene_name : "C20orf27",
      gene_level : 2,
      hgnc_id : "HGNC:15873",
      havana_gene : "OTTHUMG00000031753.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3777504,
      stop : 3781448,
      direction : "-",
      ID : "ENSG00000101222.12",
      gene_id : "ENSG00000101222.12",
      gene_type : "protein_coding",
      gene_name : "SPEF1",
      gene_level : 2,
      hgnc_id : "HGNC:15874",
      havana_gene : "OTTHUMG00000031756.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3783851,
      stop : 3786740,
      direction : "-",
      ID : "ENSG00000125817.8",
      gene_id : "ENSG00000125817.8",
      gene_type : "protein_coding",
      gene_name : "CENPB",
      gene_level : 2,
      hgnc_id : "HGNC:1852",
      havana_gene : "OTTHUMG00000031761.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3786772,
      stop : 3806121,
      direction : "+",
      ID : "ENSG00000101224.18",
      gene_id : "ENSG00000101224.18",
      gene_type : "protein_coding",
      gene_name : "CDC25B",
      gene_level : 2,
      hgnc_id : "HGNC:1726",
      havana_gene : "OTTHUMG00000031764.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3820524,
      stop : 3828838,
      direction : "+",
      ID : "ENSG00000125843.11",
      gene_id : "ENSG00000125843.11",
      gene_type : "protein_coding",
      gene_name : "AP5S1",
      gene_level : 2,
      hgnc_id : "HGNC:15875",
      havana_gene : "OTTHUMG00000031760.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3846799,
      stop : 3876123,
      direction : "+",
      ID : "ENSG00000088888.18",
      gene_id : "ENSG00000088888.18",
      gene_type : "protein_coding",
      gene_name : "MAVS",
      gene_level : 2,
      hgnc_id : "HGNC:29233",
      havana_gene : "OTTHUMG00000031765.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3888839,
      stop : 3929887,
      direction : "+",
      ID : "ENSG00000125779.23",
      gene_id : "ENSG00000125779.23",
      gene_type : "protein_coding",
      gene_name : "PANK2",
      gene_level : 2,
      hgnc_id : "HGNC:15894",
      havana_gene : "OTTHUMG00000031768.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 3927309,
      stop : 4015558,
      direction : "-",
      ID : "ENSG00000101236.17",
      gene_id : "ENSG00000101236.17",
      gene_type : "protein_coding",
      gene_name : "RNF24",
      gene_level : 2,
      hgnc_id : "HGNC:13779",
      havana_gene : "OTTHUMG00000031770.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 4120980,
      stop : 4187747,
      direction : "+",
      ID : "ENSG00000088826.18",
      gene_id : "ENSG00000088826.18",
      gene_type : "protein_coding",
      gene_name : "SMOX",
      gene_level : 2,
      hgnc_id : "HGNC:15862",
      havana_gene : "OTTHUMG00000031777.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 4220630,
      stop : 4249287,
      direction : "-",
      ID : "ENSG00000171873.8",
      gene_id : "ENSG00000171873.8",
      gene_type : "protein_coding",
      gene_name : "ADRA1D",
      gene_level : 2,
      hgnc_id : "HGNC:280",
      havana_gene : "OTTHUMG00000031779.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 4686350,
      stop : 4701590,
      direction : "+",
      ID : "ENSG00000171867.18",
      gene_id : "ENSG00000171867.18",
      gene_type : "protein_coding",
      gene_name : "PRNP",
      gene_level : 2,
      hgnc_id : "HGNC:9449",
      havana_gene : "OTTHUMG00000031786.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 4721909,
      stop : 4728460,
      direction : "+",
      ID : "ENSG00000171864.5",
      gene_id : "ENSG00000171864.5",
      gene_type : "protein_coding",
      gene_name : "PRND",
      gene_level : 2,
      hgnc_id : "HGNC:15748",
      havana_gene : "OTTHUMG00000031789.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 4780023,
      stop : 4823608,
      direction : "-",
      ID : "ENSG00000101265.16",
      gene_id : "ENSG00000101265.16",
      gene_type : "protein_coding",
      gene_name : "RASSF2",
      gene_level : 2,
      hgnc_id : "HGNC:9883",
      havana_gene : "OTTHUMG00000031790.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 4852356,
      stop : 5010293,
      direction : "-",
      ID : "ENSG00000089057.15",
      gene_id : "ENSG00000089057.15",
      gene_type : "protein_coding",
      gene_name : "SLC23A2",
      gene_level : 2,
      hgnc_id : "HGNC:10973",
      havana_gene : "OTTHUMG00000031793.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5068232,
      stop : 5113103,
      direction : "-",
      ID : "ENSG00000089063.15",
      gene_id : "ENSG00000089063.15",
      gene_type : "protein_coding",
      gene_name : "TMEM230",
      gene_level : 2,
      hgnc_id : "HGNC:15876",
      havana_gene : "OTTHUMG00000031796.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5114953,
      stop : 5126626,
      direction : "-",
      ID : "ENSG00000132646.11",
      gene_id : "ENSG00000132646.11",
      gene_type : "protein_coding",
      gene_name : "PCNA",
      gene_level : 2,
      hgnc_id : "HGNC:8729",
      havana_gene : "OTTHUMG00000031798.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5126879,
      stop : 5197887,
      direction : "+",
      ID : "ENSG00000101290.14",
      gene_id : "ENSG00000101290.14",
      gene_type : "protein_coding",
      gene_name : "CDS2",
      gene_level : 2,
      hgnc_id : "HGNC:1801",
      havana_gene : "OTTHUMG00000031801.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5299218,
      stop : 5316954,
      direction : "-",
      ID : "ENSG00000101292.8",
      gene_id : "ENSG00000101292.8",
      gene_type : "protein_coding",
      gene_name : "PROKR2",
      gene_level : 2,
      hgnc_id : "HGNC:15836",
      havana_gene : "OTTHUMG00000031800.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5544439,
      stop : 5611006,
      direction : "-",
      ID : "ENSG00000125772.14",
      gene_id : "ENSG00000125772.14",
      gene_type : "protein_coding",
      gene_name : "GPCPD1",
      gene_level : 2,
      hgnc_id : "HGNC:26957",
      havana_gene : "OTTHUMG00000031806.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5750393,
      stop : 5864395,
      direction : "+",
      ID : "ENSG00000171984.15",
      gene_id : "ENSG00000171984.15",
      gene_type : "protein_coding",
      gene_name : "SHLD1",
      gene_level : 2,
      hgnc_id : "HGNC:26318",
      havana_gene : "OTTHUMG00000031813.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5911510,
      stop : 5925353,
      direction : "+",
      ID : "ENSG00000089199.10",
      gene_id : "ENSG00000089199.10",
      gene_type : "protein_coding",
      gene_name : "CHGB",
      gene_level : 2,
      hgnc_id : "HGNC:1930",
      havana_gene : "OTTHUMG00000031821.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5937228,
      stop : 5950558,
      direction : "-",
      ID : "ENSG00000089195.15",
      gene_id : "ENSG00000089195.15",
      gene_type : "protein_coding",
      gene_name : "TRMT6",
      gene_level : 2,
      hgnc_id : "HGNC:20900",
      havana_gene : "OTTHUMG00000031816.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5950652,
      stop : 5998977,
      direction : "+",
      ID : "ENSG00000125885.13",
      gene_id : "ENSG00000125885.13",
      gene_type : "protein_coding",
      gene_name : "MCM8",
      gene_level : 2,
      hgnc_id : "HGNC:16147",
      havana_gene : "OTTHUMG00000031822.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 5950949,
      stop : 6039856,
      direction : "+",
      ID : "ENSG00000286235.1",
      gene_id : "ENSG00000286235.1",
      gene_type : "protein_coding",
      gene_name : "AL035461.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193451.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 6006093,
      stop : 6040053,
      direction : "+",
      ID : "ENSG00000088766.12",
      gene_id : "ENSG00000088766.12",
      gene_type : "protein_coding",
      gene_name : "CRLS1",
      gene_level : 2,
      hgnc_id : "HGNC:16148",
      havana_gene : "OTTHUMG00000031823.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 6040546,
      stop : 6054060,
      direction : "-",
      ID : "ENSG00000125872.8",
      gene_id : "ENSG00000125872.8",
      gene_type : "protein_coding",
      gene_name : "LRRN4",
      gene_level : 2,
      hgnc_id : "HGNC:16208",
      havana_gene : "OTTHUMG00000031825.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 6074845,
      stop : 6123030,
      direction : "-",
      ID : "ENSG00000101311.16",
      gene_id : "ENSG00000101311.16",
      gene_type : "protein_coding",
      gene_name : "FERMT1",
      gene_level : 2,
      hgnc_id : "HGNC:15889",
      havana_gene : "OTTHUMG00000031826.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 6767686,
      stop : 6780246,
      direction : "+",
      ID : "ENSG00000125845.7",
      gene_id : "ENSG00000125845.7",
      gene_type : "protein_coding",
      gene_name : "BMP2",
      gene_level : 2,
      hgnc_id : "HGNC:1069",
      havana_gene : "OTTHUMG00000031833.4",
      tag : "retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 7882985,
      stop : 7940458,
      direction : "-",
      ID : "ENSG00000101323.5",
      gene_id : "ENSG00000101323.5",
      gene_type : "protein_coding",
      gene_name : "HAO1",
      gene_level : 2,
      hgnc_id : "HGNC:4809",
      havana_gene : "OTTHUMG00000031841.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 7977346,
      stop : 8019805,
      direction : "-",
      ID : "ENSG00000125827.9",
      gene_id : "ENSG00000125827.9",
      gene_type : "protein_coding",
      gene_name : "TMX4",
      gene_level : 1,
      hgnc_id : "HGNC:25237",
      havana_gene : "OTTHUMG00000031843.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 8077251,
      stop : 8968360,
      direction : "+",
      ID : "ENSG00000182621.18",
      gene_id : "ENSG00000182621.18",
      gene_type : "protein_coding",
      gene_name : "PLCB1",
      gene_level : 2,
      hgnc_id : "HGNC:15917",
      havana_gene : "OTTHUMG00000031849.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 9068763,
      stop : 9481242,
      direction : "+",
      ID : "ENSG00000101333.18",
      gene_id : "ENSG00000101333.18",
      gene_type : "protein_coding",
      gene_name : "PLCB4",
      gene_level : 2,
      hgnc_id : "HGNC:9059",
      havana_gene : "OTTHUMG00000031853.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 9514358,
      stop : 9530524,
      direction : "+",
      ID : "ENSG00000125869.10",
      gene_id : "ENSG00000125869.10",
      gene_type : "protein_coding",
      gene_name : "LAMP5",
      gene_level : 2,
      hgnc_id : "HGNC:16097",
      havana_gene : "OTTHUMG00000031851.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 9537370,
      stop : 9839076,
      direction : "-",
      ID : "ENSG00000101349.17",
      gene_id : "ENSG00000101349.17",
      gene_type : "protein_coding",
      gene_name : "PAK5",
      gene_level : 2,
      hgnc_id : "HGNC:15916",
      havana_gene : "OTTHUMG00000031857.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 9986126,
      stop : 10058303,
      direction : "+",
      ID : "ENSG00000132623.16",
      gene_id : "ENSG00000132623.16",
      gene_type : "protein_coding",
      gene_name : "ANKEF1",
      gene_level : 2,
      hgnc_id : "HGNC:15803",
      havana_gene : "OTTHUMG00000031860.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 10218830,
      stop : 10307418,
      direction : "+",
      ID : "ENSG00000132639.13",
      gene_id : "ENSG00000132639.13",
      gene_type : "protein_coding",
      gene_name : "SNAP25",
      gene_level : 2,
      hgnc_id : "HGNC:11132",
      havana_gene : "OTTHUMG00000031863.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 10401009,
      stop : 10434222,
      direction : "-",
      ID : "ENSG00000125863.20",
      gene_id : "ENSG00000125863.20",
      gene_type : "protein_coding",
      gene_name : "MKKS",
      gene_level : 2,
      hgnc_id : "HGNC:7108",
      havana_gene : "OTTHUMG00000192571.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 10413520,
      stop : 10431922,
      direction : "-",
      ID : "ENSG00000285508.1",
      gene_id : "ENSG00000285508.1",
      gene_type : "protein_coding",
      gene_name : "AL034430.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192621.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 10420546,
      stop : 10420737,
      direction : "-",
      ID : "ENSG00000285723.1",
      gene_id : "ENSG00000285723.1",
      gene_type : "protein_coding",
      gene_name : "AL034430.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000031868.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 10435305,
      stop : 10636829,
      direction : "+",
      ID : "ENSG00000149346.15",
      gene_id : "ENSG00000149346.15",
      gene_type : "protein_coding",
      gene_name : "SLX4IP",
      gene_level : 2,
      hgnc_id : "HGNC:16225",
      havana_gene : "OTTHUMG00000031873.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 10637684,
      stop : 10673999,
      direction : "-",
      ID : "ENSG00000101384.12",
      gene_id : "ENSG00000101384.12",
      gene_type : "protein_coding",
      gene_name : "JAG1",
      gene_level : 2,
      hgnc_id : "HGNC:6188",
      havana_gene : "OTTHUMG00000031872.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 11890723,
      stop : 11926609,
      direction : "+",
      ID : "ENSG00000132640.15",
      gene_id : "ENSG00000132640.15",
      gene_type : "protein_coding",
      gene_name : "BTBD3",
      gene_level : 2,
      hgnc_id : "HGNC:15854",
      havana_gene : "OTTHUMG00000031889.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13008972,
      stop : 13169103,
      direction : "+",
      ID : "ENSG00000172296.13",
      gene_id : "ENSG00000172296.13",
      gene_type : "protein_coding",
      gene_name : "SPTLC3",
      gene_level : 2,
      hgnc_id : "HGNC:16253",
      havana_gene : "OTTHUMG00000031899.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13221274,
      stop : 13300651,
      direction : "+",
      ID : "ENSG00000101230.6",
      gene_id : "ENSG00000101230.6",
      gene_type : "protein_coding",
      gene_name : "ISM1",
      gene_level : 2,
      hgnc_id : "HGNC:16213",
      havana_gene : "OTTHUMG00000031902.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13389392,
      stop : 13638932,
      direction : "-",
      ID : "ENSG00000089123.16",
      gene_id : "ENSG00000089123.16",
      gene_type : "protein_coding",
      gene_name : "TASP1",
      gene_level : 2,
      hgnc_id : "HGNC:15859",
      havana_gene : "OTTHUMG00000031904.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13714322,
      stop : 13784919,
      direction : "-",
      ID : "ENSG00000089048.15",
      gene_id : "ENSG00000089048.15",
      gene_type : "protein_coding",
      gene_name : "ESF1",
      gene_level : 2,
      hgnc_id : "HGNC:15898",
      havana_gene : "OTTHUMG00000031906.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13785007,
      stop : 13821580,
      direction : "+",
      ID : "ENSG00000101247.18",
      gene_id : "ENSG00000101247.18",
      gene_type : "protein_coding",
      gene_name : "NDUFAF5",
      gene_level : 2,
      hgnc_id : "HGNC:15899",
      havana_gene : "OTTHUMG00000031909.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13849247,
      stop : 13996443,
      direction : "-",
      ID : "ENSG00000101251.13",
      gene_id : "ENSG00000101251.13",
      gene_type : "protein_coding",
      gene_name : "SEL1L2",
      gene_level : 2,
      hgnc_id : "HGNC:15897",
      havana_gene : "OTTHUMG00000031910.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 13995369,
      stop : 16053197,
      direction : "+",
      ID : "ENSG00000172264.17",
      gene_id : "ENSG00000172264.17",
      gene_type : "protein_coding",
      gene_name : "MACROD2",
      gene_level : 1,
      hgnc_id : "HGNC:16126",
      havana_gene : "OTTHUMG00000031919.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 14322985,
      stop : 14337614,
      direction : "-",
      ID : "ENSG00000125848.10",
      gene_id : "ENSG00000125848.10",
      gene_type : "protein_coding",
      gene_name : "FLRT3",
      gene_level : 2,
      hgnc_id : "HGNC:3762",
      havana_gene : "OTTHUMG00000031914.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 16272104,
      stop : 16573448,
      direction : "-",
      ID : "ENSG00000089177.19",
      gene_id : "ENSG00000089177.19",
      gene_type : "protein_coding",
      gene_name : "KIF16B",
      gene_level : 2,
      hgnc_id : "HGNC:15869",
      havana_gene : "OTTHUMG00000031927.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 16729961,
      stop : 16742564,
      direction : "+",
      ID : "ENSG00000125870.11",
      gene_id : "ENSG00000125870.11",
      gene_type : "protein_coding",
      gene_name : "SNRPB2",
      gene_level : 2,
      hgnc_id : "HGNC:11155",
      havana_gene : "OTTHUMG00000031933.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 16748358,
      stop : 16770062,
      direction : "+",
      ID : "ENSG00000125879.5",
      gene_id : "ENSG00000125879.5",
      gene_type : "protein_coding",
      gene_name : "OTOR",
      gene_level : 2,
      hgnc_id : "HGNC:8517",
      havana_gene : "OTTHUMG00000031931.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17226107,
      stop : 17484578,
      direction : "+",
      ID : "ENSG00000125851.10",
      gene_id : "ENSG00000125851.10",
      gene_type : "protein_coding",
      gene_name : "PCSK2",
      gene_level : 2,
      hgnc_id : "HGNC:8744",
      havana_gene : "OTTHUMG00000031941.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17493905,
      stop : 17569220,
      direction : "-",
      ID : "ENSG00000125864.14",
      gene_id : "ENSG00000125864.14",
      gene_type : "protein_coding",
      gene_name : "BFSP1",
      gene_level : 2,
      hgnc_id : "HGNC:1040",
      havana_gene : "OTTHUMG00000031940.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17570075,
      stop : 17609919,
      direction : "+",
      ID : "ENSG00000125868.16",
      gene_id : "ENSG00000125868.16",
      gene_type : "protein_coding",
      gene_name : "DSTN",
      gene_level : 2,
      hgnc_id : "HGNC:15750",
      havana_gene : "OTTHUMG00000031947.10",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17613678,
      stop : 17682295,
      direction : "-",
      ID : "ENSG00000125844.16",
      gene_id : "ENSG00000125844.16",
      gene_type : "protein_coding",
      gene_name : "RRBP1",
      gene_level : 2,
      hgnc_id : "HGNC:10448",
      havana_gene : "OTTHUMG00000031945.13",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17693672,
      stop : 17735871,
      direction : "+",
      ID : "ENSG00000125888.15",
      gene_id : "ENSG00000125888.15",
      gene_type : "protein_coding",
      gene_name : "BANF2",
      gene_level : 2,
      hgnc_id : "HGNC:16172",
      havana_gene : "OTTHUMG00000031949.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17941597,
      stop : 17968980,
      direction : "-",
      ID : "ENSG00000089006.17",
      gene_id : "ENSG00000089006.17",
      gene_type : "protein_coding",
      gene_name : "SNX5",
      gene_level : 2,
      hgnc_id : "HGNC:14969",
      havana_gene : "OTTHUMG00000031953.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17956979,
      stop : 18059188,
      direction : "-",
      ID : "ENSG00000125850.11",
      gene_id : "ENSG00000125850.11",
      gene_type : "protein_coding",
      gene_name : "OVOL2",
      gene_level : 2,
      hgnc_id : "HGNC:15804",
      havana_gene : "OTTHUMG00000031960.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 17969018,
      stop : 17991122,
      direction : "+",
      ID : "ENSG00000125871.14",
      gene_id : "ENSG00000125871.14",
      gene_type : "protein_coding",
      gene_name : "MGME1",
      gene_level : 2,
      hgnc_id : "HGNC:16205",
      havana_gene : "OTTHUMG00000031955.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18137228,
      stop : 18188387,
      direction : "+",
      ID : "ENSG00000149474.14",
      gene_id : "ENSG00000149474.14",
      gene_type : "protein_coding",
      gene_name : "KAT14",
      gene_level : 1,
      hgnc_id : "HGNC:15904",
      havana_gene : "",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18137863,
      stop : 18143169,
      direction : "+",
      ID : "ENSG00000232838.4",
      gene_id : "ENSG00000232838.4",
      gene_type : "protein_coding",
      gene_name : "PET117",
      gene_level : 2,
      hgnc_id : "HGNC:40045",
      havana_gene : "OTTHUMG00000186019.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18288283,
      stop : 18316996,
      direction : "+",
      ID : "ENSG00000125846.15",
      gene_id : "ENSG00000125846.15",
      gene_type : "protein_coding",
      gene_name : "ZNF133",
      gene_level : 2,
      hgnc_id : "HGNC:12917",
      havana_gene : "OTTHUMG00000031965.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18383367,
      stop : 18467281,
      direction : "-",
      ID : "ENSG00000089091.16",
      gene_id : "ENSG00000089091.16",
      gene_type : "protein_coding",
      gene_name : "DZANK1",
      gene_level : 2,
      hgnc_id : "HGNC:15858",
      havana_gene : "OTTHUMG00000031968.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18467389,
      stop : 18484646,
      direction : "+",
      ID : "ENSG00000132664.12",
      gene_id : "ENSG00000132664.12",
      gene_type : "protein_coding",
      gene_name : "POLR3F",
      gene_level : 2,
      hgnc_id : "HGNC:15763",
      havana_gene : "OTTHUMG00000031971.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18486540,
      stop : 18497225,
      direction : "-",
      ID : "ENSG00000089050.16",
      gene_id : "ENSG00000089050.16",
      gene_type : "protein_coding",
      gene_name : "RBBP9",
      gene_level : 2,
      hgnc_id : "HGNC:9892",
      havana_gene : "OTTHUMG00000031972.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18507520,
      stop : 18561415,
      direction : "+",
      ID : "ENSG00000101310.17",
      gene_id : "ENSG00000101310.17",
      gene_type : "protein_coding",
      gene_name : "SEC23B",
      gene_level : 2,
      hgnc_id : "HGNC:10702",
      havana_gene : "OTTHUMG00000031976.13",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18567347,
      stop : 18569563,
      direction : "+",
      ID : "ENSG00000232388.5",
      gene_id : "ENSG00000232388.5",
      gene_type : "protein_coding",
      gene_name : "SMIM26",
      gene_level : 1,
      hgnc_id : "HGNC:43430",
      havana_gene : "OTTHUMG00000031978.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18567453,
      stop : 18744216,
      direction : "+",
      ID : "ENSG00000284776.1",
      gene_id : "ENSG00000284776.1",
      gene_type : "protein_coding",
      gene_name : "AL121900.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192413.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18587942,
      stop : 18766644,
      direction : "+",
      ID : "ENSG00000125821.13",
      gene_id : "ENSG00000125821.13",
      gene_type : "protein_coding",
      gene_name : "DTD1",
      gene_level : 2,
      hgnc_id : "HGNC:16219",
      havana_gene : "OTTHUMG00000031980.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 18813783,
      stop : 18814378,
      direction : "+",
      ID : "ENSG00000132631.6",
      gene_id : "ENSG00000132631.6",
      gene_type : "protein_coding",
      gene_name : "SCP2D1",
      gene_level : 2,
      hgnc_id : "HGNC:16211",
      havana_gene : "OTTHUMG00000031983.2",
      tag : "retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 19212642,
      stop : 19722926,
      direction : "+",
      ID : "ENSG00000185052.13",
      gene_id : "ENSG00000185052.13",
      gene_type : "protein_coding",
      gene_name : "SLC24A3",
      gene_level : 2,
      hgnc_id : "HGNC:10977",
      havana_gene : "OTTHUMG00000031993.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 19757606,
      stop : 20002457,
      direction : "+",
      ID : "ENSG00000132669.14",
      gene_id : "ENSG00000132669.14",
      gene_type : "protein_coding",
      gene_name : "RIN2",
      gene_level : 2,
      hgnc_id : "HGNC:18750",
      havana_gene : "OTTHUMG00000031996.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 20017310,
      stop : 20033655,
      direction : "+",
      ID : "ENSG00000173418.12",
      gene_id : "ENSG00000173418.12",
      gene_type : "protein_coding",
      gene_name : "NAA20",
      gene_level : 1,
      hgnc_id : "HGNC:15908",
      havana_gene : "OTTHUMG00000031998.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 20034368,
      stop : 20056046,
      direction : "-",
      ID : "ENSG00000101343.15",
      gene_id : "ENSG00000101343.15",
      gene_type : "protein_coding",
      gene_name : "CRNKL1",
      gene_level : 2,
      hgnc_id : "HGNC:15762",
      havana_gene : "OTTHUMG00000032000.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 20052514,
      stop : 20360703,
      direction : "+",
      ID : "ENSG00000089101.19",
      gene_id : "ENSG00000089101.19",
      gene_type : "protein_coding",
      gene_name : "CFAP61",
      gene_level : 1,
      hgnc_id : "HGNC:15872",
      havana_gene : "OTTHUMG00000032006.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 20368104,
      stop : 20370949,
      direction : "+",
      ID : "ENSG00000173404.5",
      gene_id : "ENSG00000173404.5",
      gene_type : "protein_coding",
      gene_name : "INSM1",
      gene_level : 2,
      hgnc_id : "HGNC:6090",
      havana_gene : "OTTHUMG00000032004.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 20389530,
      stop : 20712644,
      direction : "-",
      ID : "ENSG00000188559.15",
      gene_id : "ENSG00000188559.15",
      gene_type : "protein_coding",
      gene_name : "RALGAPA2",
      gene_level : 2,
      hgnc_id : "HGNC:16207",
      havana_gene : "OTTHUMG00000032010.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 21125983,
      stop : 21246622,
      direction : "+",
      ID : "ENSG00000088970.16",
      gene_id : "ENSG00000088970.16",
      gene_type : "protein_coding",
      gene_name : "KIZ",
      gene_level : 2,
      hgnc_id : "HGNC:15865",
      havana_gene : "OTTHUMG00000032020.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 21303331,
      stop : 21389825,
      direction : "+",
      ID : "ENSG00000088930.8",
      gene_id : "ENSG00000088930.8",
      gene_type : "protein_coding",
      gene_name : "XRN2",
      gene_level : 2,
      hgnc_id : "HGNC:12836",
      havana_gene : "OTTHUMG00000032025.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 21395365,
      stop : 21397526,
      direction : "-",
      ID : "ENSG00000125816.5",
      gene_id : "ENSG00000125816.5",
      gene_type : "protein_coding",
      gene_name : "NKX2-4",
      gene_level : 2,
      hgnc_id : "HGNC:7837",
      havana_gene : "OTTHUMG00000032022.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 21511017,
      stop : 21514064,
      direction : "-",
      ID : "ENSG00000125820.6",
      gene_id : "ENSG00000125820.6",
      gene_type : "protein_coding",
      gene_name : "NKX2-2",
      gene_level : 2,
      hgnc_id : "HGNC:7835",
      havana_gene : "OTTHUMG00000170524.22",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 21705659,
      stop : 21718486,
      direction : "+",
      ID : "ENSG00000125813.13",
      gene_id : "ENSG00000125813.13",
      gene_type : "protein_coding",
      gene_name : "PAX1",
      gene_level : 2,
      hgnc_id : "HGNC:8615",
      havana_gene : "OTTHUMG00000032034.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 22580998,
      stop : 22585455,
      direction : "-",
      ID : "ENSG00000125798.15",
      gene_id : "ENSG00000125798.15",
      gene_type : "protein_coding",
      gene_name : "FOXA2",
      gene_level : 2,
      hgnc_id : "HGNC:5022",
      havana_gene : "OTTHUMG00000191876.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23035312,
      stop : 23039237,
      direction : "+",
      ID : "ENSG00000132671.6",
      gene_id : "ENSG00000132671.6",
      gene_type : "protein_coding",
      gene_name : "SSTR4",
      gene_level : 2,
      hgnc_id : "HGNC:11333",
      havana_gene : "OTTHUMG00000032054.1",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23045633,
      stop : 23049672,
      direction : "-",
      ID : "ENSG00000178726.7",
      gene_id : "ENSG00000178726.7",
      gene_type : "protein_coding",
      gene_name : "THBD",
      gene_level : 2,
      hgnc_id : "HGNC:11784",
      havana_gene : "OTTHUMG00000032053.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23079360,
      stop : 23086324,
      direction : "-",
      ID : "ENSG00000125810.10",
      gene_id : "ENSG00000125810.10",
      gene_type : "protein_coding",
      gene_name : "CD93",
      gene_level : 2,
      hgnc_id : "HGNC:15855",
      havana_gene : "OTTHUMG00000032058.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23350791,
      stop : 23354771,
      direction : "+",
      ID : "ENSG00000132661.4",
      gene_id : "ENSG00000132661.4",
      gene_type : "protein_coding",
      gene_name : "NXT1",
      gene_level : 2,
      hgnc_id : "HGNC:15913",
      havana_gene : "OTTHUMG00000032059.3",
      tag : "retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23362182,
      stop : 23373062,
      direction : "+",
      ID : "ENSG00000125812.16",
      gene_id : "ENSG00000125812.16",
      gene_type : "protein_coding",
      gene_name : "GZF1",
      gene_level : 2,
      hgnc_id : "HGNC:15808",
      havana_gene : "OTTHUMG00000032069.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23374519,
      stop : 23421519,
      direction : "-",
      ID : "ENSG00000125814.17",
      gene_id : "ENSG00000125814.17",
      gene_type : "protein_coding",
      gene_name : "NAPB",
      gene_level : 2,
      hgnc_id : "HGNC:15751",
      havana_gene : "OTTHUMG00000032062.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23439685,
      stop : 23444930,
      direction : "+",
      ID : "ENSG00000125823.12",
      gene_id : "ENSG00000125823.12",
      gene_type : "protein_coding",
      gene_name : "CSTL1",
      gene_level : 2,
      hgnc_id : "HGNC:15958",
      havana_gene : "OTTHUMG00000032068.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23450403,
      stop : 23452876,
      direction : "-",
      ID : "ENSG00000125831.10",
      gene_id : "ENSG00000125831.10",
      gene_type : "protein_coding",
      gene_name : "CST11",
      gene_level : 2,
      hgnc_id : "HGNC:15959",
      havana_gene : "OTTHUMG00000032060.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23491101,
      stop : 23496010,
      direction : "+",
      ID : "ENSG00000125815.9",
      gene_id : "ENSG00000125815.9",
      gene_type : "protein_coding",
      gene_name : "CST8",
      gene_level : 2,
      hgnc_id : "HGNC:2480",
      havana_gene : "OTTHUMG00000032071.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23564732,
      stop : 23568484,
      direction : "-",
      ID : "ENSG00000101435.5",
      gene_id : "ENSG00000101435.5",
      gene_type : "protein_coding",
      gene_name : "CST9L",
      gene_level : 2,
      hgnc_id : "HGNC:16233",
      havana_gene : "OTTHUMG00000032073.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23602410,
      stop : 23605917,
      direction : "-",
      ID : "ENSG00000173335.5",
      gene_id : "ENSG00000173335.5",
      gene_type : "protein_coding",
      gene_name : "CST9",
      gene_level : 2,
      hgnc_id : "HGNC:13261",
      havana_gene : "OTTHUMG00000032076.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23626706,
      stop : 23638473,
      direction : "-",
      ID : "ENSG00000101439.9",
      gene_id : "ENSG00000101439.9",
      gene_type : "protein_coding",
      gene_name : "CST3",
      gene_level : 2,
      hgnc_id : "HGNC:2475",
      havana_gene : "OTTHUMG00000032080.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23685640,
      stop : 23689038,
      direction : "-",
      ID : "ENSG00000101441.5",
      gene_id : "ENSG00000101441.5",
      gene_type : "protein_coding",
      gene_name : "CST4",
      gene_level : 2,
      hgnc_id : "HGNC:2476",
      havana_gene : "OTTHUMG00000032083.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23747562,
      stop : 23751268,
      direction : "-",
      ID : "ENSG00000170373.9",
      gene_id : "ENSG00000170373.9",
      gene_type : "protein_coding",
      gene_name : "CST1",
      gene_level : 2,
      hgnc_id : "HGNC:2473",
      havana_gene : "OTTHUMG00000032085.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23823769,
      stop : 23826729,
      direction : "-",
      ID : "ENSG00000170369.4",
      gene_id : "ENSG00000170369.4",
      gene_type : "protein_coding",
      gene_name : "CST2",
      gene_level : 2,
      hgnc_id : "HGNC:2474",
      havana_gene : "OTTHUMG00000032086.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23875934,
      stop : 23879748,
      direction : "-",
      ID : "ENSG00000170367.5",
      gene_id : "ENSG00000170367.5",
      gene_type : "protein_coding",
      gene_name : "CST5",
      gene_level : 2,
      hgnc_id : "HGNC:2477",
      havana_gene : "OTTHUMG00000032089.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 23985050,
      stop : 23988779,
      direction : "-",
      ID : "ENSG00000149435.12",
      gene_id : "ENSG00000149435.12",
      gene_type : "protein_coding",
      gene_name : "GGTLC1",
      gene_level : 2,
      hgnc_id : "HGNC:16437",
      havana_gene : "OTTHUMG00000032095.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 24469629,
      stop : 24666616,
      direction : "+",
      ID : "ENSG00000101463.6",
      gene_id : "ENSG00000101463.6",
      gene_type : "protein_coding",
      gene_name : "SYNDIG1",
      gene_level : 2,
      hgnc_id : "HGNC:15885",
      havana_gene : "OTTHUMG00000032104.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 24949269,
      stop : 24959928,
      direction : "+",
      ID : "ENSG00000077984.6",
      gene_id : "ENSG00000077984.6",
      gene_type : "protein_coding",
      gene_name : "CST7",
      gene_level : 2,
      hgnc_id : "HGNC:2479",
      havana_gene : "OTTHUMG00000032108.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 24962925,
      stop : 24992751,
      direction : "-",
      ID : "ENSG00000101474.12",
      gene_id : "ENSG00000101474.12",
      gene_type : "protein_coding",
      gene_name : "APMAP",
      gene_level : 2,
      hgnc_id : "HGNC:13238",
      havana_gene : "OTTHUMG00000032107.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25006230,
      stop : 25058980,
      direction : "-",
      ID : "ENSG00000154930.15",
      gene_id : "ENSG00000154930.15",
      gene_type : "protein_coding",
      gene_name : "ACSS1",
      gene_level : 2,
      hgnc_id : "HGNC:16091",
      havana_gene : "OTTHUMG00000032112.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25070885,
      stop : 25082141,
      direction : "-",
      ID : "ENSG00000100987.15",
      gene_id : "ENSG00000100987.15",
      gene_type : "protein_coding",
      gene_name : "VSX1",
      gene_level : 1,
      hgnc_id : "HGNC:12723",
      havana_gene : "OTTHUMG00000032111.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25195693,
      stop : 25228075,
      direction : "+",
      ID : "ENSG00000197586.13",
      gene_id : "ENSG00000197586.13",
      gene_type : "protein_coding",
      gene_name : "ENTPD6",
      gene_level : 2,
      hgnc_id : "HGNC:3368",
      havana_gene : "OTTHUMG00000032116.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25248085,
      stop : 25298012,
      direction : "+",
      ID : "ENSG00000100994.12",
      gene_id : "ENSG00000100994.12",
      gene_type : "protein_coding",
      gene_name : "PYGB",
      gene_level : 2,
      hgnc_id : "HGNC:9723",
      havana_gene : "OTTHUMG00000032117.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25294742,
      stop : 25390835,
      direction : "-",
      ID : "ENSG00000100997.20",
      gene_id : "ENSG00000100997.20",
      gene_type : "protein_coding",
      gene_name : "ABHD12",
      gene_level : 2,
      hgnc_id : "HGNC:15868",
      havana_gene : "OTTHUMG00000032121.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25407673,
      stop : 25452628,
      direction : "+",
      ID : "ENSG00000101003.10",
      gene_id : "ENSG00000101003.10",
      gene_type : "protein_coding",
      gene_name : "GINS1",
      gene_level : 2,
      hgnc_id : "HGNC:28980",
      havana_gene : "OTTHUMG00000032124.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25452697,
      stop : 25585531,
      direction : "-",
      ID : "ENSG00000101004.15",
      gene_id : "ENSG00000101004.15",
      gene_type : "protein_coding",
      gene_name : "NINL",
      gene_level : 2,
      hgnc_id : "HGNC:29163",
      havana_gene : "OTTHUMG00000032127.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25612935,
      stop : 25624014,
      direction : "-",
      ID : "ENSG00000170191.5",
      gene_id : "ENSG00000170191.5",
      gene_type : "protein_coding",
      gene_name : "NANP",
      gene_level : 2,
      hgnc_id : "HGNC:16140",
      havana_gene : "OTTHUMG00000032132.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 25673195,
      stop : 25696853,
      direction : "-",
      ID : "ENSG00000130684.14",
      gene_id : "ENSG00000130684.14",
      gene_type : "protein_coding",
      gene_name : "ZNF337",
      gene_level : 2,
      hgnc_id : "HGNC:15809",
      havana_gene : "OTTHUMG00000032131.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31257664,
      stop : 31259632,
      direction : "+",
      ID : "ENSG00000215547.1",
      gene_id : "ENSG00000215547.1",
      gene_type : "protein_coding",
      gene_name : "DEFB115",
      gene_level : 2,
      hgnc_id : "HGNC:18096",
      havana_gene : "OTTHUMG00000159284.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31303212,
      stop : 31308585,
      direction : "-",
      ID : "ENSG00000215545.1",
      gene_id : "ENSG00000215545.1",
      gene_type : "protein_coding",
      gene_name : "DEFB116",
      gene_level : 2,
      hgnc_id : "HGNC:18097",
      havana_gene : "OTTHUMG00000159285.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31368601,
      stop : 31373923,
      direction : "+",
      ID : "ENSG00000131068.4",
      gene_id : "ENSG00000131068.4",
      gene_type : "protein_coding",
      gene_name : "DEFB118",
      gene_level : 2,
      hgnc_id : "HGNC:16196",
      havana_gene : "OTTHUMG00000032161.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31377164,
      stop : 31390590,
      direction : "-",
      ID : "ENSG00000180483.7",
      gene_id : "ENSG00000180483.7",
      gene_type : "protein_coding",
      gene_name : "DEFB119",
      gene_level : 2,
      hgnc_id : "HGNC:18099",
      havana_gene : "OTTHUMG00000032172.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31404845,
      stop : 31412838,
      direction : "-",
      ID : "ENSG00000204548.4",
      gene_id : "ENSG00000204548.4",
      gene_type : "protein_coding",
      gene_name : "DEFB121",
      gene_level : 2,
      hgnc_id : "HGNC:18101",
      havana_gene : "OTTHUMG00000032171.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31440632,
      stop : 31450257,
      direction : "+",
      ID : "ENSG00000180424.7",
      gene_id : "ENSG00000180424.7",
      gene_type : "protein_coding",
      gene_name : "DEFB123",
      gene_level : 2,
      hgnc_id : "HGNC:18103",
      havana_gene : "OTTHUMG00000032170.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31465506,
      stop : 31476757,
      direction : "-",
      ID : "ENSG00000180383.3",
      gene_id : "ENSG00000180383.3",
      gene_type : "protein_coding",
      gene_name : "DEFB124",
      gene_level : 2,
      hgnc_id : "HGNC:18104",
      havana_gene : "OTTHUMG00000159287.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31475288,
      stop : 31484895,
      direction : "+",
      ID : "ENSG00000088320.4",
      gene_id : "ENSG00000088320.4",
      gene_type : "protein_coding",
      gene_name : "REM1",
      gene_level : 2,
      hgnc_id : "HGNC:15922",
      havana_gene : "OTTHUMG00000032168.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31514410,
      stop : 31577923,
      direction : "+",
      ID : "ENSG00000101294.18",
      gene_id : "ENSG00000101294.18",
      gene_type : "protein_coding",
      gene_name : "HM13",
      gene_level : 2,
      hgnc_id : "HGNC:16435",
      havana_gene : "OTTHUMG00000032175.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31547412,
      stop : 31548081,
      direction : "+",
      ID : "ENSG00000101898.6",
      gene_id : "ENSG00000101898.6",
      gene_type : "protein_coding",
      gene_name : "MCTS2P",
      gene_level : 2,
      hgnc_id : "HGNC:49760",
      havana_gene : "OTTHUMG00000032177.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31605283,
      stop : 31606515,
      direction : "+",
      ID : "ENSG00000125968.9",
      gene_id : "ENSG00000125968.9",
      gene_type : "protein_coding",
      gene_name : "ID1",
      gene_level : 2,
      hgnc_id : "HGNC:5360",
      havana_gene : "OTTHUMG00000032181.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31637912,
      stop : 31645006,
      direction : "+",
      ID : "ENSG00000131055.5",
      gene_id : "ENSG00000131055.5",
      gene_type : "protein_coding",
      gene_name : "COX4I2",
      gene_level : 2,
      hgnc_id : "HGNC:16232",
      havana_gene : "OTTHUMG00000032180.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31664452,
      stop : 31723989,
      direction : "-",
      ID : "ENSG00000171552.14",
      gene_id : "ENSG00000171552.14",
      gene_type : "protein_coding",
      gene_name : "BCL2L1",
      gene_level : 2,
      hgnc_id : "HGNC:992",
      havana_gene : "OTTHUMG00000032192.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31739271,
      stop : 31801805,
      direction : "+",
      ID : "ENSG00000088325.16",
      gene_id : "ENSG00000088325.16",
      gene_type : "protein_coding",
      gene_name : "TPX2",
      gene_level : 2,
      hgnc_id : "HGNC:1249",
      havana_gene : "OTTHUMG00000032190.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31819308,
      stop : 31834689,
      direction : "+",
      ID : "ENSG00000101306.11",
      gene_id : "ENSG00000101306.11",
      gene_type : "protein_coding",
      gene_name : "MYLK2",
      gene_level : 2,
      hgnc_id : "HGNC:16243",
      havana_gene : "OTTHUMG00000032194.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31844303,
      stop : 31845604,
      direction : "-",
      ID : "ENSG00000179772.8",
      gene_id : "ENSG00000179772.8",
      gene_type : "protein_coding",
      gene_name : "FOXS1",
      gene_level : 2,
      hgnc_id : "HGNC:3735",
      havana_gene : "OTTHUMG00000032183.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31847637,
      stop : 31870747,
      direction : "-",
      ID : "ENSG00000149599.15",
      gene_id : "ENSG00000149599.15",
      gene_type : "protein_coding",
      gene_name : "DUSP15",
      gene_level : 2,
      hgnc_id : "HGNC:16236",
      havana_gene : "OTTHUMG00000032182.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31870702,
      stop : 31944963,
      direction : "+",
      ID : "ENSG00000131044.17",
      gene_id : "ENSG00000131044.17",
      gene_type : "protein_coding",
      gene_name : "TTLL9",
      gene_level : 2,
      hgnc_id : "HGNC:16118",
      havana_gene : "OTTHUMG00000186843.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31944337,
      stop : 31952046,
      direction : "-",
      ID : "ENSG00000088356.6",
      gene_id : "ENSG00000088356.6",
      gene_type : "protein_coding",
      gene_name : "PDRG1",
      gene_level : 2,
      hgnc_id : "HGNC:16119",
      havana_gene : "OTTHUMG00000032196.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 31968151,
      stop : 32003387,
      direction : "+",
      ID : "ENSG00000260903.3",
      gene_id : "ENSG00000260903.3",
      gene_type : "protein_coding",
      gene_name : "XKR7",
      gene_level : 2,
      hgnc_id : "HGNC:23062",
      havana_gene : "OTTHUMG00000032198.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32010438,
      stop : 32032180,
      direction : "+",
      ID : "ENSG00000101331.17",
      gene_id : "ENSG00000101331.17",
      gene_type : "protein_coding",
      gene_name : "CCM2L",
      gene_level : 2,
      hgnc_id : "HGNC:16153",
      havana_gene : "OTTHUMG00000032197.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32052197,
      stop : 32101856,
      direction : "+",
      ID : "ENSG00000101336.18",
      gene_id : "ENSG00000101336.18",
      gene_type : "protein_coding",
      gene_name : "HCK",
      gene_level : 2,
      hgnc_id : "HGNC:4840",
      havana_gene : "OTTHUMG00000032204.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32109714,
      stop : 32167258,
      direction : "+",
      ID : "ENSG00000101337.16",
      gene_id : "ENSG00000101337.16",
      gene_type : "protein_coding",
      gene_name : "TM9SF4",
      gene_level : 2,
      hgnc_id : "HGNC:30797",
      havana_gene : "OTTHUMG00000032206.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32192504,
      stop : 32207743,
      direction : "-",
      ID : "ENSG00000126003.7",
      gene_id : "ENSG00000126003.7",
      gene_type : "protein_coding",
      gene_name : "PLAGL2",
      gene_level : 2,
      hgnc_id : "HGNC:9047",
      havana_gene : "OTTHUMG00000032210.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32207880,
      stop : 32238658,
      direction : "+",
      ID : "ENSG00000101346.14",
      gene_id : "ENSG00000101346.14",
      gene_type : "protein_coding",
      gene_name : "POFUT1",
      gene_level : 2,
      hgnc_id : "HGNC:14988",
      havana_gene : "OTTHUMG00000133268.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32277651,
      stop : 32335011,
      direction : "+",
      ID : "ENSG00000101350.8",
      gene_id : "ENSG00000101350.8",
      gene_type : "protein_coding",
      gene_name : "KIF3B",
      gene_level : 2,
      hgnc_id : "HGNC:6320",
      havana_gene : "OTTHUMG00000032214.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32358330,
      stop : 32439319,
      direction : "+",
      ID : "ENSG00000171456.20",
      gene_id : "ENSG00000171456.20",
      gene_type : "protein_coding",
      gene_name : "ASXL1",
      gene_level : 1,
      hgnc_id : "HGNC:18318",
      havana_gene : "OTTHUMG00000032218.10",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32443059,
      stop : 32585074,
      direction : "-",
      ID : "ENSG00000197183.14",
      gene_id : "ENSG00000197183.14",
      gene_type : "protein_coding",
      gene_name : "NOL4L",
      gene_level : 2,
      hgnc_id : "HGNC:16106",
      havana_gene : "OTTHUMG00000032219.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32631625,
      stop : 32673941,
      direction : "-",
      ID : "ENSG00000198547.10",
      gene_id : "ENSG00000198547.10",
      gene_type : "protein_coding",
      gene_name : "C20orf203",
      gene_level : 2,
      hgnc_id : "HGNC:26592",
      havana_gene : "OTTHUMG00000032224.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32632183,
      stop : 32743567,
      direction : "-",
      ID : "ENSG00000285382.1",
      gene_id : "ENSG00000285382.1",
      gene_type : "protein_coding",
      gene_name : "FO393400.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192400.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32702699,
      stop : 32743467,
      direction : "-",
      ID : "ENSG00000149600.12",
      gene_id : "ENSG00000149600.12",
      gene_type : "protein_coding",
      gene_name : "COMMD7",
      gene_level : 2,
      hgnc_id : "HGNC:16223",
      havana_gene : "OTTHUMG00000032229.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32762385,
      stop : 32809356,
      direction : "+",
      ID : "ENSG00000088305.18",
      gene_id : "ENSG00000088305.18",
      gene_type : "protein_coding",
      gene_name : "DNMT3B",
      gene_level : 2,
      hgnc_id : "HGNC:2979",
      havana_gene : "OTTHUMG00000032226.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32819954,
      stop : 32850405,
      direction : "+",
      ID : "ENSG00000101367.9",
      gene_id : "ENSG00000101367.9",
      gene_type : "protein_coding",
      gene_name : "MAPRE1",
      gene_level : 2,
      hgnc_id : "HGNC:6890",
      havana_gene : "OTTHUMG00000032228.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32858923,
      stop : 32961609,
      direction : "+",
      ID : "ENSG00000215529.12",
      gene_id : "ENSG00000215529.12",
      gene_type : "protein_coding",
      gene_name : "EFCAB8",
      gene_level : 1,
      hgnc_id : "HGNC:34532",
      havana_gene : "OTTHUMG00000153693.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 32983773,
      stop : 33004433,
      direction : "-",
      ID : "ENSG00000167098.12",
      gene_id : "ENSG00000167098.12",
      gene_type : "protein_coding",
      gene_name : "SUN5",
      gene_level : 2,
      hgnc_id : "HGNC:16252",
      havana_gene : "OTTHUMG00000032239.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33007704,
      stop : 33023703,
      direction : "+",
      ID : "ENSG00000078898.7",
      gene_id : "ENSG00000078898.7",
      gene_type : "protein_coding",
      gene_name : "BPIFB2",
      gene_level : 2,
      hgnc_id : "HGNC:16177",
      havana_gene : "OTTHUMG00000032232.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33031648,
      stop : 33044047,
      direction : "+",
      ID : "ENSG00000167104.11",
      gene_id : "ENSG00000167104.11",
      gene_type : "protein_coding",
      gene_name : "BPIFB6",
      gene_level : 2,
      hgnc_id : "HGNC:16504",
      havana_gene : "OTTHUMG00000032238.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33055424,
      stop : 33073628,
      direction : "+",
      ID : "ENSG00000186190.7",
      gene_id : "ENSG00000186190.7",
      gene_type : "protein_coding",
      gene_name : "BPIFB3",
      gene_level : 2,
      hgnc_id : "HGNC:16178",
      havana_gene : "OTTHUMG00000032234.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33079644,
      stop : 33111751,
      direction : "+",
      ID : "ENSG00000186191.8",
      gene_id : "ENSG00000186191.8",
      gene_type : "protein_coding",
      gene_name : "BPIFB4",
      gene_level : 2,
      hgnc_id : "HGNC:16179",
      havana_gene : "OTTHUMG00000032235.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33161768,
      stop : 33181412,
      direction : "+",
      ID : "ENSG00000131050.11",
      gene_id : "ENSG00000131050.11",
      gene_type : "protein_coding",
      gene_name : "BPIFA2",
      gene_level : 2,
      hgnc_id : "HGNC:16203",
      havana_gene : "OTTHUMG00000032244.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33217310,
      stop : 33227806,
      direction : "+",
      ID : "ENSG00000131059.12",
      gene_id : "ENSG00000131059.12",
      gene_type : "protein_coding",
      gene_name : "BPIFA3",
      gene_level : 2,
      hgnc_id : "HGNC:16204",
      havana_gene : "OTTHUMG00000032245.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33235995,
      stop : 33243311,
      direction : "+",
      ID : "ENSG00000198183.12",
      gene_id : "ENSG00000198183.12",
      gene_type : "protein_coding",
      gene_name : "BPIFA1",
      gene_level : 2,
      hgnc_id : "HGNC:15749",
      havana_gene : "OTTHUMG00000032243.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33273480,
      stop : 33309871,
      direction : "+",
      ID : "ENSG00000125999.11",
      gene_id : "ENSG00000125999.11",
      gene_type : "protein_coding",
      gene_name : "BPIFB1",
      gene_level : 2,
      hgnc_id : "HGNC:16108",
      havana_gene : "OTTHUMG00000032252.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33358839,
      stop : 33401561,
      direction : "-",
      ID : "ENSG00000101391.21",
      gene_id : "ENSG00000101391.21",
      gene_type : "protein_coding",
      gene_name : "CDK5RAP1",
      gene_level : 2,
      hgnc_id : "HGNC:15880",
      havana_gene : "OTTHUMG00000032256.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33407957,
      stop : 33443763,
      direction : "-",
      ID : "ENSG00000101400.6",
      gene_id : "ENSG00000101400.6",
      gene_type : "protein_coding",
      gene_name : "SNTA1",
      gene_level : 2,
      hgnc_id : "HGNC:11167",
      havana_gene : "OTTHUMG00000032259.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33490075,
      stop : 33650036,
      direction : "+",
      ID : "ENSG00000078699.22",
      gene_id : "ENSG00000078699.22",
      gene_type : "protein_coding",
      gene_name : "CBFA2T2",
      gene_level : 2,
      hgnc_id : "HGNC:1536",
      havana_gene : "OTTHUMG00000032261.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33657087,
      stop : 33674463,
      direction : "-",
      ID : "ENSG00000125967.17",
      gene_id : "ENSG00000125967.17",
      gene_type : "protein_coding",
      gene_name : "NECAB3",
      gene_level : 2,
      hgnc_id : "HGNC:15851",
      havana_gene : "OTTHUMG00000032264.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33662327,
      stop : 33665619,
      direction : "+",
      ID : "ENSG00000149609.6",
      gene_id : "ENSG00000149609.6",
      gene_type : "protein_coding",
      gene_name : "C20orf144",
      gene_level : 2,
      hgnc_id : "HGNC:16137",
      havana_gene : "OTTHUMG00000032263.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33666943,
      stop : 33668525,
      direction : "+",
      ID : "ENSG00000288649.1",
      gene_id : "ENSG00000288649.1",
      gene_type : "protein_coding",
      gene_name : "ACTL10",
      gene_level : 2,
      hgnc_id : "HGNC:16127",
      havana_gene : "",
      tag : "retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33675477,
      stop : 33686385,
      direction : "-",
      ID : "ENSG00000101412.13",
      gene_id : "ENSG00000101412.13",
      gene_type : "protein_coding",
      gene_name : "E2F1",
      gene_level : 2,
      hgnc_id : "HGNC:3113",
      havana_gene : "OTTHUMG00000032265.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33702758,
      stop : 33720319,
      direction : "-",
      ID : "ENSG00000101417.12",
      gene_id : "ENSG00000101417.12",
      gene_type : "protein_coding",
      gene_name : "PXMP4",
      gene_level : 2,
      hgnc_id : "HGNC:15920",
      havana_gene : "OTTHUMG00000032273.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33731657,
      stop : 33792269,
      direction : "+",
      ID : "ENSG00000131061.14",
      gene_id : "ENSG00000131061.14",
      gene_type : "protein_coding",
      gene_name : "ZNF341",
      gene_level : 2,
      hgnc_id : "HGNC:15992",
      havana_gene : "OTTHUMG00000032275.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33811348,
      stop : 33854366,
      direction : "+",
      ID : "ENSG00000101421.4",
      gene_id : "ENSG00000101421.4",
      gene_type : "protein_coding",
      gene_name : "CHMP4B",
      gene_level : 2,
      hgnc_id : "HGNC:16171",
      havana_gene : "OTTHUMG00000032272.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 33993646,
      stop : 34108308,
      direction : "+",
      ID : "ENSG00000125970.12",
      gene_id : "ENSG00000125970.12",
      gene_type : "protein_coding",
      gene_name : "RALY",
      gene_level : 2,
      hgnc_id : "HGNC:15921",
      havana_gene : "OTTHUMG00000032283.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34088309,
      stop : 34112243,
      direction : "-",
      ID : "ENSG00000125977.7",
      gene_id : "ENSG00000125977.7",
      gene_type : "protein_coding",
      gene_name : "EIF2S2",
      gene_level : 2,
      hgnc_id : "HGNC:3266",
      havana_gene : "OTTHUMG00000032287.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34194569,
      stop : 34269344,
      direction : "+",
      ID : "ENSG00000101440.9",
      gene_id : "ENSG00000101440.9",
      gene_type : "protein_coding",
      gene_name : "ASIP",
      gene_level : 2,
      hgnc_id : "HGNC:745",
      havana_gene : "OTTHUMG00000032289.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34280268,
      stop : 34311802,
      direction : "-",
      ID : "ENSG00000101444.13",
      gene_id : "ENSG00000101444.13",
      gene_type : "protein_coding",
      gene_name : "AHCY",
      gene_level : 2,
      hgnc_id : "HGNC:343",
      havana_gene : "OTTHUMG00000140098.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34363241,
      stop : 34540748,
      direction : "+",
      ID : "ENSG00000078747.16",
      gene_id : "ENSG00000078747.16",
      gene_type : "protein_coding",
      gene_name : "ITCH",
      gene_level : 2,
      hgnc_id : "HGNC:13890",
      havana_gene : "OTTHUMG00000032300.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34516414,
      stop : 34540958,
      direction : "+",
      ID : "ENSG00000125971.17",
      gene_id : "ENSG00000125971.17",
      gene_type : "protein_coding",
      gene_name : "DYNLRB1",
      gene_level : 1,
      hgnc_id : "HGNC:15468",
      havana_gene : "OTTHUMG00000032302.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34546854,
      stop : 34560345,
      direction : "+",
      ID : "ENSG00000101460.13",
      gene_id : "ENSG00000101460.13",
      gene_type : "protein_coding",
      gene_name : "MAP1LC3A",
      gene_level : 2,
      hgnc_id : "HGNC:6838",
      havana_gene : "OTTHUMG00000032306.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34560542,
      stop : 34698790,
      direction : "-",
      ID : "ENSG00000101464.11",
      gene_id : "ENSG00000101464.11",
      gene_type : "protein_coding",
      gene_name : "PIGU",
      gene_level : 2,
      hgnc_id : "HGNC:15791",
      havana_gene : "OTTHUMG00000032304.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34689097,
      stop : 34825651,
      direction : "-",
      ID : "ENSG00000198646.14",
      gene_id : "ENSG00000198646.14",
      gene_type : "protein_coding",
      gene_name : "NCOA6",
      gene_level : 2,
      hgnc_id : "HGNC:15936",
      havana_gene : "OTTHUMG00000032311.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34704339,
      stop : 34713439,
      direction : "+",
      ID : "ENSG00000078804.13",
      gene_id : "ENSG00000078804.13",
      gene_type : "protein_coding",
      gene_name : "TP53INP2",
      gene_level : 2,
      hgnc_id : "HGNC:16104",
      havana_gene : "OTTHUMG00000032310.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34844720,
      stop : 34872856,
      direction : "-",
      ID : "ENSG00000131067.17",
      gene_id : "ENSG00000131067.17",
      gene_type : "protein_coding",
      gene_name : "GGT7",
      gene_level : 1,
      hgnc_id : "HGNC:4259",
      havana_gene : "OTTHUMG00000032314.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34872146,
      stop : 34927962,
      direction : "+",
      ID : "ENSG00000131069.20",
      gene_id : "ENSG00000131069.20",
      gene_type : "protein_coding",
      gene_name : "ACSS2",
      gene_level : 2,
      hgnc_id : "HGNC:15814",
      havana_gene : "OTTHUMG00000032317.9",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34928432,
      stop : 34956027,
      direction : "-",
      ID : "ENSG00000100983.12",
      gene_id : "ENSG00000100983.12",
      gene_type : "protein_coding",
      gene_name : "GSS",
      gene_level : 2,
      hgnc_id : "HGNC:4624",
      havana_gene : "OTTHUMG00000032315.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 34955810,
      stop : 35002437,
      direction : "+",
      ID : "ENSG00000078814.17",
      gene_id : "ENSG00000078814.17",
      gene_type : "protein_coding",
      gene_name : "MYH7B",
      gene_level : 1,
      hgnc_id : "HGNC:15906",
      havana_gene : "OTTHUMG00000032320.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35002404,
      stop : 35092807,
      direction : "-",
      ID : "ENSG00000100991.12",
      gene_id : "ENSG00000100991.12",
      gene_type : "protein_coding",
      gene_name : "TRPC4AP",
      gene_level : 2,
      hgnc_id : "HGNC:16181",
      havana_gene : "OTTHUMG00000032319.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35115364,
      stop : 35147336,
      direction : "-",
      ID : "ENSG00000088298.13",
      gene_id : "ENSG00000088298.13",
      gene_type : "protein_coding",
      gene_name : "EDEM2",
      gene_level : 2,
      hgnc_id : "HGNC:15877",
      havana_gene : "OTTHUMG00000032322.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35172072,
      stop : 35216240,
      direction : "+",
      ID : "ENSG00000101000.6",
      gene_id : "ENSG00000101000.6",
      gene_type : "protein_coding",
      gene_name : "PROCR",
      gene_level : 2,
      hgnc_id : "HGNC:9452",
      havana_gene : "OTTHUMG00000032323.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35201745,
      stop : 35278131,
      direction : "-",
      ID : "ENSG00000126005.17",
      gene_id : "ENSG00000126005.17",
      gene_type : "protein_coding",
      gene_name : "MMP24OS",
      gene_level : 1,
      hgnc_id : "HGNC:44421",
      havana_gene : "OTTHUMG00000032333.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35226690,
      stop : 35276998,
      direction : "+",
      ID : "ENSG00000125966.10",
      gene_id : "ENSG00000125966.10",
      gene_type : "protein_coding",
      gene_name : "MMP24",
      gene_level : 2,
      hgnc_id : "HGNC:7172",
      havana_gene : "OTTHUMG00000032330.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35267885,
      stop : 35280043,
      direction : "-",
      ID : "ENSG00000261582.1",
      gene_id : "ENSG00000261582.1",
      gene_type : "protein_coding",
      gene_name : "AL121753.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000176080.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35278907,
      stop : 35284985,
      direction : "-",
      ID : "ENSG00000242372.9",
      gene_id : "ENSG00000242372.9",
      gene_type : "protein_coding",
      gene_name : "EIF6",
      gene_level : 2,
      hgnc_id : "HGNC:6159",
      havana_gene : "OTTHUMG00000032328.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35285731,
      stop : 35292425,
      direction : "-",
      ID : "ENSG00000125998.8",
      gene_id : "ENSG00000125998.8",
      gene_type : "protein_coding",
      gene_name : "FAM83C",
      gene_level : 2,
      hgnc_id : "HGNC:16121",
      havana_gene : "OTTHUMG00000032332.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35302566,
      stop : 35412031,
      direction : "-",
      ID : "ENSG00000101019.22",
      gene_id : "ENSG00000101019.22",
      gene_type : "protein_coding",
      gene_name : "UQCC1",
      gene_level : 1,
      hgnc_id : "HGNC:15891",
      havana_gene : "OTTHUMG00000032335.13",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35433347,
      stop : 35454746,
      direction : "-",
      ID : "ENSG00000125965.9",
      gene_id : "ENSG00000125965.9",
      gene_type : "protein_coding",
      gene_name : "GDF5",
      gene_level : 2,
      hgnc_id : "HGNC:4220",
      havana_gene : "OTTHUMG00000032341.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35455164,
      stop : 35519280,
      direction : "+",
      ID : "ENSG00000126001.16",
      gene_id : "ENSG00000126001.16",
      gene_type : "protein_coding",
      gene_name : "CEP250",
      gene_level : 1,
      hgnc_id : "HGNC:1859",
      havana_gene : "OTTHUMG00000032343.40",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35523186,
      stop : 35529652,
      direction : "-",
      ID : "ENSG00000125975.14",
      gene_id : "ENSG00000125975.14",
      gene_type : "protein_coding",
      gene_name : "C20orf173",
      gene_level : 2,
      hgnc_id : "HGNC:16166",
      havana_gene : "OTTHUMG00000032340.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35542038,
      stop : 35557634,
      direction : "+",
      ID : "ENSG00000125991.20",
      gene_id : "ENSG00000125991.20",
      gene_type : "protein_coding",
      gene_name : "ERGIC3",
      gene_level : 1,
      hgnc_id : "HGNC:15927",
      havana_gene : "OTTHUMG00000032346.10",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35615829,
      stop : 35621094,
      direction : "+",
      ID : "ENSG00000061656.11",
      gene_id : "ENSG00000061656.11",
      gene_type : "protein_coding",
      gene_name : "SPAG4",
      gene_level : 2,
      hgnc_id : "HGNC:11214",
      havana_gene : "OTTHUMG00000032352.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35626031,
      stop : 35664956,
      direction : "-",
      ID : "ENSG00000214078.13",
      gene_id : "ENSG00000214078.13",
      gene_type : "protein_coding",
      gene_name : "CPNE1",
      gene_level : 1,
      hgnc_id : "HGNC:2314",
      havana_gene : "OTTHUMG00000032356.33",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35632340,
      stop : 35674544,
      direction : "-",
      ID : "ENSG00000272897.5",
      gene_id : "ENSG00000272897.5",
      gene_type : "protein_coding",
      gene_name : "AL109827.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000186060.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35648925,
      stop : 35664956,
      direction : "-",
      ID : "ENSG00000244462.8",
      gene_id : "ENSG00000244462.8",
      gene_type : "protein_coding",
      gene_name : "RBM12",
      gene_level : 2,
      hgnc_id : "HGNC:9898",
      havana_gene : "OTTHUMG00000032350.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35668052,
      stop : 35699355,
      direction : "-",
      ID : "ENSG00000244005.13",
      gene_id : "ENSG00000244005.13",
      gene_type : "protein_coding",
      gene_name : "NFS1",
      gene_level : 2,
      hgnc_id : "HGNC:15910",
      havana_gene : "OTTHUMG00000032361.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35699272,
      stop : 35700984,
      direction : "+",
      ID : "ENSG00000125995.16",
      gene_id : "ENSG00000125995.16",
      gene_type : "protein_coding",
      gene_name : "ROMO1",
      gene_level : 2,
      hgnc_id : "HGNC:16185",
      havana_gene : "OTTHUMG00000032360.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35701347,
      stop : 35742312,
      direction : "-",
      ID : "ENSG00000131051.24",
      gene_id : "ENSG00000131051.24",
      gene_type : "protein_coding",
      gene_name : "RBM39",
      gene_level : 1,
      hgnc_id : "HGNC:15923",
      havana_gene : "OTTHUMG00000032358.21",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35771974,
      stop : 35950370,
      direction : "+",
      ID : "ENSG00000025293.17",
      gene_id : "ENSG00000025293.17",
      gene_type : "protein_coding",
      gene_name : "PHF20",
      gene_level : 2,
      hgnc_id : "HGNC:16098",
      havana_gene : "OTTHUMG00000032367.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35953617,
      stop : 35959472,
      direction : "-",
      ID : "ENSG00000171222.11",
      gene_id : "ENSG00000171222.11",
      gene_type : "protein_coding",
      gene_name : "SCAND1",
      gene_level : 2,
      hgnc_id : "HGNC:10566",
      havana_gene : "OTTHUMG00000032370.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 35954564,
      stop : 36030700,
      direction : "+",
      ID : "ENSG00000149646.12",
      gene_id : "ENSG00000149646.12",
      gene_type : "protein_coding",
      gene_name : "CNBD2",
      gene_level : 2,
      hgnc_id : "HGNC:16145",
      havana_gene : "OTTHUMG00000032371.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36091504,
      stop : 36232799,
      direction : "+",
      ID : "ENSG00000088367.23",
      gene_id : "ENSG00000088367.23",
      gene_type : "protein_coding",
      gene_name : "EPB41L1",
      gene_level : 2,
      hgnc_id : "HGNC:3378",
      havana_gene : "OTTHUMG00000032378.14",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36236131,
      stop : 36270918,
      direction : "+",
      ID : "ENSG00000131043.13",
      gene_id : "ENSG00000131043.13",
      gene_type : "protein_coding",
      gene_name : "AAR2",
      gene_level : 1,
      hgnc_id : "HGNC:15886",
      havana_gene : "OTTHUMG00000032380.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36306336,
      stop : 36528637,
      direction : "+",
      ID : "ENSG00000080845.18",
      gene_id : "ENSG00000080845.18",
      gene_type : "protein_coding",
      gene_name : "DLGAP4",
      gene_level : 2,
      hgnc_id : "HGNC:24476",
      havana_gene : "OTTHUMG00000032390.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36541497,
      stop : 36551447,
      direction : "+",
      ID : "ENSG00000101335.10",
      gene_id : "ENSG00000101335.10",
      gene_type : "protein_coding",
      gene_name : "MYL9",
      gene_level : 2,
      hgnc_id : "HGNC:15754",
      havana_gene : "OTTHUMG00000032387.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36573488,
      stop : 36593950,
      direction : "+",
      ID : "ENSG00000118707.11",
      gene_id : "ENSG00000118707.11",
      gene_type : "protein_coding",
      gene_name : "TGIF2",
      gene_level : 2,
      hgnc_id : "HGNC:15764",
      havana_gene : "OTTHUMG00000172332.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36574553,
      stop : 36612384,
      direction : "+",
      ID : "ENSG00000259399.1",
      gene_id : "ENSG00000259399.1",
      gene_type : "protein_coding",
      gene_name : "TGIF2-RAB5IF",
      gene_level : 1,
      hgnc_id : "HGNC:44664",
      havana_gene : "OTTHUMG00000032382.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36605779,
      stop : 36612557,
      direction : "+",
      ID : "ENSG00000101084.18",
      gene_id : "ENSG00000101084.18",
      gene_type : "protein_coding",
      gene_name : "RAB5IF",
      gene_level : 1,
      hgnc_id : "HGNC:15870",
      havana_gene : "OTTHUMG00000032384.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36612318,
      stop : 36646196,
      direction : "-",
      ID : "ENSG00000101082.14",
      gene_id : "ENSG00000101082.14",
      gene_type : "protein_coding",
      gene_name : "SLA2",
      gene_level : 2,
      hgnc_id : "HGNC:17329",
      havana_gene : "OTTHUMG00000032393.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36651766,
      stop : 36746090,
      direction : "-",
      ID : "ENSG00000101079.21",
      gene_id : "ENSG00000101079.21",
      gene_type : "protein_coding",
      gene_name : "NDRG3",
      gene_level : 1,
      hgnc_id : "HGNC:14462",
      havana_gene : "OTTHUMG00000032398.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36751791,
      stop : 36773818,
      direction : "-",
      ID : "ENSG00000149636.16",
      gene_id : "ENSG00000149636.16",
      gene_type : "protein_coding",
      gene_name : "DSN1",
      gene_level : 2,
      hgnc_id : "HGNC:16165",
      havana_gene : "OTTHUMG00000032396.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36777447,
      stop : 36863538,
      direction : "-",
      ID : "ENSG00000149639.15",
      gene_id : "ENSG00000149639.15",
      gene_type : "protein_coding",
      gene_name : "SOGA1",
      gene_level : 1,
      hgnc_id : "HGNC:16111",
      havana_gene : "OTTHUMG00000032395.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36876121,
      stop : 36894235,
      direction : "+",
      ID : "ENSG00000101342.10",
      gene_id : "ENSG00000101342.10",
      gene_type : "protein_coding",
      gene_name : "TLDC2",
      gene_level : 1,
      hgnc_id : "HGNC:16112",
      havana_gene : "OTTHUMG00000032400.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36890229,
      stop : 36951843,
      direction : "-",
      ID : "ENSG00000101347.10",
      gene_id : "ENSG00000101347.10",
      gene_type : "protein_coding",
      gene_name : "SAMHD1",
      gene_level : 2,
      hgnc_id : "HGNC:15925",
      havana_gene : "OTTHUMG00000032402.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 36996349,
      stop : 37095997,
      direction : "-",
      ID : "ENSG00000080839.12",
      gene_id : "ENSG00000080839.12",
      gene_type : "protein_coding",
      gene_name : "RBL1",
      gene_level : 2,
      hgnc_id : "HGNC:9893",
      havana_gene : "OTTHUMG00000032406.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37101226,
      stop : 37179588,
      direction : "-",
      ID : "ENSG00000101353.15",
      gene_id : "ENSG00000101353.15",
      gene_type : "protein_coding",
      gene_name : "MROH8",
      gene_level : 2,
      hgnc_id : "HGNC:16125",
      havana_gene : "OTTHUMG00000032407.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37178410,
      stop : 37241619,
      direction : "+",
      ID : "ENSG00000118705.17",
      gene_id : "ENSG00000118705.17",
      gene_type : "protein_coding",
      gene_name : "RPN2",
      gene_level : 1,
      hgnc_id : "HGNC:10382",
      havana_gene : "OTTHUMG00000032409.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37251086,
      stop : 37261814,
      direction : "-",
      ID : "ENSG00000118702.10",
      gene_id : "ENSG00000118702.10",
      gene_type : "protein_coding",
      gene_name : "GHRH",
      gene_level : 2,
      hgnc_id : "HGNC:4265",
      havana_gene : "OTTHUMG00000032413.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37289638,
      stop : 37317260,
      direction : "+",
      ID : "ENSG00000101363.12",
      gene_id : "ENSG00000101363.12",
      gene_type : "protein_coding",
      gene_name : "MANBAL",
      gene_level : 2,
      hgnc_id : "HGNC:15799",
      havana_gene : "OTTHUMG00000032414.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37344685,
      stop : 37406050,
      direction : "+",
      ID : "ENSG00000197122.12",
      gene_id : "ENSG00000197122.12",
      gene_type : "protein_coding",
      gene_name : "SRC",
      gene_level : 2,
      hgnc_id : "HGNC:11283",
      havana_gene : "OTTHUMG00000032417.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37492472,
      stop : 37527931,
      direction : "-",
      ID : "ENSG00000166619.15",
      gene_id : "ENSG00000166619.15",
      gene_type : "protein_coding",
      gene_name : "BLCAP",
      gene_level : 2,
      hgnc_id : "HGNC:1055",
      havana_gene : "OTTHUMG00000032419.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37521206,
      stop : 37523690,
      direction : "+",
      ID : "ENSG00000053438.11",
      gene_id : "ENSG00000053438.11",
      gene_type : "protein_coding",
      gene_name : "NNAT",
      gene_level : 2,
      hgnc_id : "HGNC:7860",
      havana_gene : "OTTHUMG00000032420.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37693955,
      stop : 37872129,
      direction : "+",
      ID : "ENSG00000132792.19",
      gene_id : "ENSG00000132792.19",
      gene_type : "protein_coding",
      gene_name : "CTNNBL1",
      gene_level : 1,
      hgnc_id : "HGNC:15879",
      havana_gene : "OTTHUMG00000032428.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37903111,
      stop : 37945350,
      direction : "+",
      ID : "ENSG00000132821.12",
      gene_id : "ENSG00000132821.12",
      gene_type : "protein_coding",
      gene_name : "VSTM2L",
      gene_level : 2,
      hgnc_id : "HGNC:16096",
      havana_gene : "OTTHUMG00000032430.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 37983007,
      stop : 38033461,
      direction : "-",
      ID : "ENSG00000101407.13",
      gene_id : "ENSG00000101407.13",
      gene_type : "protein_coding",
      gene_name : "TTI1",
      gene_level : 2,
      hgnc_id : "HGNC:29029",
      havana_gene : "OTTHUMG00000032433.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38033725,
      stop : 38127780,
      direction : "+",
      ID : "ENSG00000101413.12",
      gene_id : "ENSG00000101413.12",
      gene_type : "protein_coding",
      gene_name : "RPRD1B",
      gene_level : 2,
      hgnc_id : "HGNC:16209",
      havana_gene : "OTTHUMG00000032434.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38127385,
      stop : 38166578,
      direction : "-",
      ID : "ENSG00000198959.12",
      gene_id : "ENSG00000198959.12",
      gene_type : "protein_coding",
      gene_name : "TGM2",
      gene_level : 2,
      hgnc_id : "HGNC:11778",
      havana_gene : "OTTHUMG00000032437.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38210503,
      stop : 38260772,
      direction : "-",
      ID : "ENSG00000149633.12",
      gene_id : "ENSG00000149633.12",
      gene_type : "protein_coding",
      gene_name : "KIAA1755",
      gene_level : 2,
      hgnc_id : "HGNC:29372",
      havana_gene : "OTTHUMG00000032436.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38304150,
      stop : 38337505,
      direction : "+",
      ID : "ENSG00000101425.14",
      gene_id : "ENSG00000101425.14",
      gene_type : "protein_coding",
      gene_name : "BPI",
      gene_level : 2,
      hgnc_id : "HGNC:1095",
      havana_gene : "OTTHUMG00000032441.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38346482,
      stop : 38377013,
      direction : "+",
      ID : "ENSG00000129988.6",
      gene_id : "ENSG00000129988.6",
      gene_type : "protein_coding",
      gene_name : "LBP",
      gene_level : 2,
      hgnc_id : "HGNC:6517",
      havana_gene : "OTTHUMG00000032447.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38472816,
      stop : 38578859,
      direction : "+",
      ID : "ENSG00000170471.15",
      gene_id : "ENSG00000170471.15",
      gene_type : "protein_coding",
      gene_name : "RALGAPB",
      gene_level : 2,
      hgnc_id : "HGNC:29221",
      havana_gene : "OTTHUMG00000140270.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38581195,
      stop : 38588463,
      direction : "+",
      ID : "ENSG00000182035.12",
      gene_id : "ENSG00000182035.12",
      gene_type : "protein_coding",
      gene_name : "ADIG",
      gene_level : 1,
      hgnc_id : "HGNC:28606",
      havana_gene : "OTTHUMG00000032451.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38601934,
      stop : 38651035,
      direction : "+",
      ID : "ENSG00000124143.10",
      gene_id : "ENSG00000124143.10",
      gene_type : "protein_coding",
      gene_name : "ARHGAP40",
      gene_level : 2,
      hgnc_id : "HGNC:16226",
      havana_gene : "OTTHUMG00000032453.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38724486,
      stop : 38729372,
      direction : "+",
      ID : "ENSG00000101438.4",
      gene_id : "ENSG00000101438.4",
      gene_type : "protein_coding",
      gene_name : "SLC32A1",
      gene_level : 2,
      hgnc_id : "HGNC:11018",
      havana_gene : "OTTHUMG00000032457.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38748460,
      stop : 38772520,
      direction : "+",
      ID : "ENSG00000101442.10",
      gene_id : "ENSG00000101442.10",
      gene_type : "protein_coding",
      gene_name : "ACTR5",
      gene_level : 2,
      hgnc_id : "HGNC:14671",
      havana_gene : "OTTHUMG00000032456.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38805697,
      stop : 38923024,
      direction : "+",
      ID : "ENSG00000101445.10",
      gene_id : "ENSG00000101445.10",
      gene_type : "protein_coding",
      gene_name : "PPP1R16B",
      gene_level : 2,
      hgnc_id : "HGNC:15850",
      havana_gene : "OTTHUMG00000032465.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38926312,
      stop : 38953106,
      direction : "+",
      ID : "ENSG00000101447.15",
      gene_id : "ENSG00000101447.15",
      gene_type : "protein_coding",
      gene_name : "FAM83D",
      gene_level : 2,
      hgnc_id : "HGNC:16122",
      havana_gene : "OTTHUMG00000032462.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 38962299,
      stop : 39039723,
      direction : "+",
      ID : "ENSG00000101452.15",
      gene_id : "ENSG00000101452.15",
      gene_type : "protein_coding",
      gene_name : "DHX35",
      gene_level : 2,
      hgnc_id : "HGNC:15861",
      havana_gene : "OTTHUMG00000032463.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 40685848,
      stop : 40689236,
      direction : "-",
      ID : "ENSG00000204103.4",
      gene_id : "ENSG00000204103.4",
      gene_type : "protein_coding",
      gene_name : "MAFB",
      gene_level : 2,
      hgnc_id : "HGNC:6408",
      havana_gene : "OTTHUMG00000033052.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 41028822,
      stop : 41124487,
      direction : "+",
      ID : "ENSG00000198900.7",
      gene_id : "ENSG00000198900.7",
      gene_type : "protein_coding",
      gene_name : "TOP1",
      gene_level : 2,
      hgnc_id : "HGNC:11986",
      havana_gene : "OTTHUMG00000033057.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 41136960,
      stop : 41196801,
      direction : "+",
      ID : "ENSG00000124181.14",
      gene_id : "ENSG00000124181.14",
      gene_type : "protein_coding",
      gene_name : "PLCG1",
      gene_level : 2,
      hgnc_id : "HGNC:9065",
      havana_gene : "OTTHUMG00000033082.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 41178448,
      stop : 41317672,
      direction : "-",
      ID : "ENSG00000174306.21",
      gene_id : "ENSG00000174306.21",
      gene_type : "protein_coding",
      gene_name : "ZHX3",
      gene_level : 1,
      hgnc_id : "HGNC:15935",
      havana_gene : "OTTHUMG00000032481.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 41340821,
      stop : 41360582,
      direction : "+",
      ID : "ENSG00000132793.12",
      gene_id : "ENSG00000132793.12",
      gene_type : "protein_coding",
      gene_name : "LPIN3",
      gene_level : 2,
      hgnc_id : "HGNC:14451",
      havana_gene : "OTTHUMG00000033056.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 41359962,
      stop : 41366818,
      direction : "-",
      ID : "ENSG00000183798.5",
      gene_id : "ENSG00000183798.5",
      gene_type : "protein_coding",
      gene_name : "EMILIN3",
      gene_level : 2,
      hgnc_id : "HGNC:16123",
      havana_gene : "OTTHUMG00000046304.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 41402083,
      stop : 41618384,
      direction : "-",
      ID : "ENSG00000124177.16",
      gene_id : "ENSG00000124177.16",
      gene_type : "protein_coding",
      gene_name : "CHD6",
      gene_level : 2,
      hgnc_id : "HGNC:19057",
      havana_gene : "OTTHUMG00000032487.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 42072752,
      stop : 43189970,
      direction : "-",
      ID : "ENSG00000196090.12",
      gene_id : "ENSG00000196090.12",
      gene_type : "protein_coding",
      gene_name : "PTPRT",
      gene_level : 2,
      hgnc_id : "HGNC:9682",
      havana_gene : "OTTHUMG00000033040.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43457893,
      stop : 43466046,
      direction : "+",
      ID : "ENSG00000124193.16",
      gene_id : "ENSG00000124193.16",
      gene_type : "protein_coding",
      gene_name : "SRSF6",
      gene_level : 2,
      hgnc_id : "HGNC:10788",
      havana_gene : "OTTHUMG00000032502.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43458054,
      stop : 43541881,
      direction : "+",
      ID : "ENSG00000288000.1",
      gene_id : "ENSG00000288000.1",
      gene_type : "protein_coding",
      gene_name : "AL031681.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193823.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43489442,
      stop : 43550954,
      direction : "+",
      ID : "ENSG00000185513.17",
      gene_id : "ENSG00000185513.17",
      gene_type : "protein_coding",
      gene_name : "L3MBTL1",
      gene_level : 2,
      hgnc_id : "HGNC:15905",
      havana_gene : "OTTHUMG00000032503.23",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43540171,
      stop : 43569498,
      direction : "+",
      ID : "ENSG00000277611.1",
      gene_id : "ENSG00000277611.1",
      gene_type : "protein_coding",
      gene_name : "Z98752.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000187507.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43558968,
      stop : 43588237,
      direction : "+",
      ID : "ENSG00000101049.17",
      gene_id : "ENSG00000101049.17",
      gene_type : "protein_coding",
      gene_name : "SGK2",
      gene_level : 2,
      hgnc_id : "HGNC:13900",
      havana_gene : "OTTHUMG00000033054.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43590937,
      stop : 43647299,
      direction : "+",
      ID : "ENSG00000101052.13",
      gene_id : "ENSG00000101052.13",
      gene_type : "protein_coding",
      gene_name : "IFT52",
      gene_level : 2,
      hgnc_id : "HGNC:15901",
      havana_gene : "OTTHUMG00000032513.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43667019,
      stop : 43716495,
      direction : "+",
      ID : "ENSG00000101057.16",
      gene_id : "ENSG00000101057.16",
      gene_type : "protein_coding",
      gene_name : "MYBL2",
      gene_level : 2,
      hgnc_id : "HGNC:7548",
      havana_gene : "OTTHUMG00000033062.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43726164,
      stop : 43727002,
      direction : "-",
      ID : "ENSG00000124196.6",
      gene_id : "ENSG00000124196.6",
      gene_type : "protein_coding",
      gene_name : "GTSF1L",
      gene_level : 2,
      hgnc_id : "HGNC:16198",
      havana_gene : "OTTHUMG00000032510.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 43914852,
      stop : 44069616,
      direction : "+",
      ID : "ENSG00000124191.18",
      gene_id : "ENSG00000124191.18",
      gene_type : "protein_coding",
      gene_name : "TOX2",
      gene_level : 2,
      hgnc_id : "HGNC:16095",
      havana_gene : "OTTHUMG00000032517.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44106590,
      stop : 44187188,
      direction : "-",
      ID : "ENSG00000149596.7",
      gene_id : "ENSG00000149596.7",
      gene_type : "protein_coding",
      gene_name : "JPH2",
      gene_level : 2,
      hgnc_id : "HGNC:14202",
      havana_gene : "OTTHUMG00000033037.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44195939,
      stop : 44210771,
      direction : "-",
      ID : "ENSG00000132823.11",
      gene_id : "ENSG00000132823.11",
      gene_type : "protein_coding",
      gene_name : "OSER1",
      gene_level : 2,
      hgnc_id : "HGNC:16105",
      havana_gene : "OTTHUMG00000032518.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44247099,
      stop : 44280947,
      direction : "+",
      ID : "ENSG00000124194.17",
      gene_id : "ENSG00000124194.17",
      gene_type : "protein_coding",
      gene_name : "GDAP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:4213",
      havana_gene : "OTTHUMG00000032530.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44302840,
      stop : 44311202,
      direction : "-",
      ID : "ENSG00000197296.6",
      gene_id : "ENSG00000197296.6",
      gene_type : "protein_coding",
      gene_name : "FITM2",
      gene_level : 2,
      hgnc_id : "HGNC:16135",
      havana_gene : "OTTHUMG00000032522.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44337043,
      stop : 44351238,
      direction : "+",
      ID : "ENSG00000101074.5",
      gene_id : "ENSG00000101074.5",
      gene_type : "protein_coding",
      gene_name : "R3HDML",
      gene_level : 2,
      hgnc_id : "HGNC:16249",
      havana_gene : "OTTHUMG00000032524.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44355700,
      stop : 44434596,
      direction : "+",
      ID : "ENSG00000101076.17",
      gene_id : "ENSG00000101076.17",
      gene_type : "protein_coding",
      gene_name : "HNF4A",
      gene_level : 1,
      hgnc_id : "HGNC:5024",
      havana_gene : "OTTHUMG00000032531.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44475874,
      stop : 44494603,
      direction : "+",
      ID : "ENSG00000124120.11",
      gene_id : "ENSG00000124120.11",
      gene_type : "protein_coding",
      gene_name : "TTPAL",
      gene_level : 1,
      hgnc_id : "HGNC:16114",
      havana_gene : "OTTHUMG00000032536.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44496221,
      stop : 44522085,
      direction : "-",
      ID : "ENSG00000132824.14",
      gene_id : "ENSG00000132824.14",
      gene_type : "protein_coding",
      gene_name : "SERINC3",
      gene_level : 2,
      hgnc_id : "HGNC:11699",
      havana_gene : "OTTHUMG00000033087.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44531785,
      stop : 44624247,
      direction : "+",
      ID : "ENSG00000168734.14",
      gene_id : "ENSG00000168734.14",
      gene_type : "protein_coding",
      gene_name : "PKIG",
      gene_level : 1,
      hgnc_id : "HGNC:9019",
      havana_gene : "OTTHUMG00000033065.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44619522,
      stop : 44652233,
      direction : "-",
      ID : "ENSG00000196839.13",
      gene_id : "ENSG00000196839.13",
      gene_type : "protein_coding",
      gene_name : "ADA",
      gene_level : 1,
      hgnc_id : "HGNC:186",
      havana_gene : "OTTHUMG00000033081.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44714844,
      stop : 44728509,
      direction : "+",
      ID : "ENSG00000064205.11",
      gene_id : "ENSG00000064205.11",
      gene_type : "protein_coding",
      gene_name : "CCN5",
      gene_level : 2,
      hgnc_id : "HGNC:12770",
      havana_gene : "OTTHUMG00000033071.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44745865,
      stop : 44752313,
      direction : "+",
      ID : "ENSG00000124249.7",
      gene_id : "ENSG00000124249.7",
      gene_type : "protein_coding",
      gene_name : "KCNK15",
      gene_level : 2,
      hgnc_id : "HGNC:13814",
      havana_gene : "OTTHUMG00000032544.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44751808,
      stop : 44810546,
      direction : "-",
      ID : "ENSG00000101098.13",
      gene_id : "ENSG00000101098.13",
      gene_type : "protein_coding",
      gene_name : "RIMS4",
      gene_level : 2,
      hgnc_id : "HGNC:16183",
      havana_gene : "OTTHUMG00000032546.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44885702,
      stop : 44908532,
      direction : "+",
      ID : "ENSG00000166913.13",
      gene_id : "ENSG00000166913.13",
      gene_type : "protein_coding",
      gene_name : "YWHAB",
      gene_level : 2,
      hgnc_id : "HGNC:12849",
      havana_gene : "OTTHUMG00000032549.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44910060,
      stop : 44959035,
      direction : "+",
      ID : "ENSG00000101104.13",
      gene_id : "ENSG00000101104.13",
      gene_type : "protein_coding",
      gene_name : "PABPC1L",
      gene_level : 2,
      hgnc_id : "HGNC:15797",
      havana_gene : "OTTHUMG00000032553.12",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44942130,
      stop : 44960397,
      direction : "-",
      ID : "ENSG00000025772.8",
      gene_id : "ENSG00000025772.8",
      gene_type : "protein_coding",
      gene_name : "TOMM34",
      gene_level : 2,
      hgnc_id : "HGNC:15746",
      havana_gene : "OTTHUMG00000032552.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 44966479,
      stop : 45080021,
      direction : "+",
      ID : "ENSG00000101109.12",
      gene_id : "ENSG00000101109.12",
      gene_type : "protein_coding",
      gene_name : "STK4",
      gene_level : 2,
      hgnc_id : "HGNC:11408",
      havana_gene : "OTTHUMG00000033059.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45091214,
      stop : 45101127,
      direction : "-",
      ID : "ENSG00000124134.9",
      gene_id : "ENSG00000124134.9",
      gene_type : "protein_coding",
      gene_name : "KCNS1",
      gene_level : 2,
      hgnc_id : "HGNC:6300",
      havana_gene : "OTTHUMG00000033079.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45109452,
      stop : 45115172,
      direction : "-",
      ID : "ENSG00000175121.11",
      gene_id : "ENSG00000175121.11",
      gene_type : "protein_coding",
      gene_name : "WFDC5",
      gene_level : 2,
      hgnc_id : "HGNC:20477",
      havana_gene : "OTTHUMG00000046411.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45123425,
      stop : 45124465,
      direction : "-",
      ID : "ENSG00000168703.5",
      gene_id : "ENSG00000168703.5",
      gene_type : "protein_coding",
      gene_name : "WFDC12",
      gene_level : 2,
      hgnc_id : "HGNC:16115",
      havana_gene : "OTTHUMG00000046412.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45174902,
      stop : 45176544,
      direction : "+",
      ID : "ENSG00000124102.5",
      gene_id : "ENSG00000124102.5",
      gene_type : "protein_coding",
      gene_name : "PI3",
      gene_level : 2,
      hgnc_id : "HGNC:8947",
      havana_gene : "OTTHUMG00000032567.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45207033,
      stop : 45209768,
      direction : "+",
      ID : "ENSG00000124233.12",
      gene_id : "ENSG00000124233.12",
      gene_type : "protein_coding",
      gene_name : "SEMG1",
      gene_level : 2,
      hgnc_id : "HGNC:10742",
      havana_gene : "OTTHUMG00000032565.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45221373,
      stop : 45224458,
      direction : "+",
      ID : "ENSG00000124157.7",
      gene_id : "ENSG00000124157.7",
      gene_type : "protein_coding",
      gene_name : "SEMG2",
      gene_level : 2,
      hgnc_id : "HGNC:10743",
      havana_gene : "OTTHUMG00000032566.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45252239,
      stop : 45254564,
      direction : "-",
      ID : "ENSG00000124107.5",
      gene_id : "ENSG00000124107.5",
      gene_type : "protein_coding",
      gene_name : "SLPI",
      gene_level : 2,
      hgnc_id : "HGNC:11092",
      havana_gene : "OTTHUMG00000033075.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45293445,
      stop : 45308529,
      direction : "-",
      ID : "ENSG00000124159.16",
      gene_id : "ENSG00000124159.16",
      gene_type : "protein_coding",
      gene_name : "MATN4",
      gene_level : 2,
      hgnc_id : "HGNC:6910",
      havana_gene : "OTTHUMG00000033043.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45306840,
      stop : 45317824,
      direction : "+",
      ID : "ENSG00000124232.11",
      gene_id : "ENSG00000124232.11",
      gene_type : "protein_coding",
      gene_name : "RBPJL",
      gene_level : 2,
      hgnc_id : "HGNC:13761",
      havana_gene : "OTTHUMG00000033055.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45325288,
      stop : 45348424,
      direction : "-",
      ID : "ENSG00000124145.6",
      gene_id : "ENSG00000124145.6",
      gene_type : "protein_coding",
      gene_name : "SDC4",
      gene_level : 2,
      hgnc_id : "HGNC:10661",
      havana_gene : "OTTHUMG00000033083.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45361937,
      stop : 45376798,
      direction : "+",
      ID : "ENSG00000204070.10",
      gene_id : "ENSG00000204070.10",
      gene_type : "protein_coding",
      gene_name : "SYS1",
      gene_level : 1,
      hgnc_id : "HGNC:16162",
      havana_gene : "OTTHUMG00000032579.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45363200,
      stop : 45410610,
      direction : "+",
      ID : "ENSG00000254806.5",
      gene_id : "ENSG00000254806.5",
      gene_type : "protein_coding",
      gene_name : "SYS1-DBNDD2",
      gene_level : 2,
      hgnc_id : "HGNC:33535",
      havana_gene : "OTTHUMG00000166214.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45372557,
      stop : 45407889,
      direction : "-",
      ID : "ENSG00000124251.11",
      gene_id : "ENSG00000124251.11",
      gene_type : "protein_coding",
      gene_name : "TP53TG5",
      gene_level : 2,
      hgnc_id : "HGNC:15856",
      havana_gene : "OTTHUMG00000032582.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45406057,
      stop : 45410610,
      direction : "+",
      ID : "ENSG00000244274.8",
      gene_id : "ENSG00000244274.8",
      gene_type : "protein_coding",
      gene_name : "DBNDD2",
      gene_level : 2,
      hgnc_id : "HGNC:15881",
      havana_gene : "OTTHUMG00000032576.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45416084,
      stop : 45456934,
      direction : "+",
      ID : "ENSG00000124155.18",
      gene_id : "ENSG00000124155.18",
      gene_type : "protein_coding",
      gene_name : "PIGT",
      gene_level : 2,
      hgnc_id : "HGNC:14938",
      havana_gene : "OTTHUMG00000032574.24",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45469753,
      stop : 45481532,
      direction : "+",
      ID : "ENSG00000101443.18",
      gene_id : "ENSG00000101443.18",
      gene_type : "protein_coding",
      gene_name : "WFDC2",
      gene_level : 1,
      hgnc_id : "HGNC:15939",
      havana_gene : "OTTHUMG00000032594.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45512461,
      stop : 45515622,
      direction : "-",
      ID : "ENSG00000101446.8",
      gene_id : "ENSG00000101446.8",
      gene_type : "protein_coding",
      gene_name : "SPINT3",
      gene_level : 2,
      hgnc_id : "HGNC:11248",
      havana_gene : "OTTHUMG00000032585.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45534196,
      stop : 45539482,
      direction : "-",
      ID : "ENSG00000243543.9",
      gene_id : "ENSG00000243543.9",
      gene_type : "protein_coding",
      gene_name : "WFDC6",
      gene_level : 2,
      hgnc_id : "HGNC:16164",
      havana_gene : "OTTHUMG00000046354.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45534196,
      stop : 45547662,
      direction : "-",
      ID : "ENSG00000249139.2",
      gene_id : "ENSG00000249139.2",
      gene_type : "protein_coding",
      gene_name : "EPPIN-WFDC6",
      gene_level : 1,
      hgnc_id : "HGNC:38825",
      havana_gene : "OTTHUMG00000161548.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45540626,
      stop : 45547752,
      direction : "-",
      ID : "ENSG00000101448.14",
      gene_id : "ENSG00000101448.14",
      gene_type : "protein_coding",
      gene_name : "EPPIN",
      gene_level : 2,
      hgnc_id : "HGNC:15932",
      havana_gene : "OTTHUMG00000032588.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45551153,
      stop : 45579326,
      direction : "-",
      ID : "ENSG00000158901.12",
      gene_id : "ENSG00000158901.12",
      gene_type : "protein_coding",
      gene_name : "WFDC8",
      gene_level : 2,
      hgnc_id : "HGNC:16163",
      havana_gene : "OTTHUMG00000046342.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45607939,
      stop : 45631284,
      direction : "-",
      ID : "ENSG00000180205.4",
      gene_id : "ENSG00000180205.4",
      gene_type : "protein_coding",
      gene_name : "WFDC9",
      gene_level : 2,
      hgnc_id : "HGNC:20380",
      havana_gene : "OTTHUMG00000046332.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45629739,
      stop : 45631196,
      direction : "+",
      ID : "ENSG00000180305.5",
      gene_id : "ENSG00000180305.5",
      gene_type : "protein_coding",
      gene_name : "WFDC10A",
      gene_level : 2,
      hgnc_id : "HGNC:16139",
      havana_gene : "OTTHUMG00000046331.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45648563,
      stop : 45670270,
      direction : "-",
      ID : "ENSG00000180083.11",
      gene_id : "ENSG00000180083.11",
      gene_type : "protein_coding",
      gene_name : "WFDC11",
      gene_level : 2,
      hgnc_id : "HGNC:20478",
      havana_gene : "OTTHUMG00000046330.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45684653,
      stop : 45705019,
      direction : "-",
      ID : "ENSG00000182931.9",
      gene_id : "ENSG00000182931.9",
      gene_type : "protein_coding",
      gene_name : "WFDC10B",
      gene_level : 2,
      hgnc_id : "HGNC:20479",
      havana_gene : "OTTHUMG00000130227.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45702038,
      stop : 45708817,
      direction : "+",
      ID : "ENSG00000168634.5",
      gene_id : "ENSG00000168634.5",
      gene_type : "protein_coding",
      gene_name : "WFDC13",
      gene_level : 2,
      hgnc_id : "HGNC:16131",
      havana_gene : "OTTHUMG00000046333.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45722347,
      stop : 45725830,
      direction : "+",
      ID : "ENSG00000149651.4",
      gene_id : "ENSG00000149651.4",
      gene_type : "protein_coding",
      gene_name : "SPINT4",
      gene_level : 2,
      hgnc_id : "HGNC:16130",
      havana_gene : "OTTHUMG00000130153.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45747944,
      stop : 45791932,
      direction : "-",
      ID : "ENSG00000124116.19",
      gene_id : "ENSG00000124116.19",
      gene_type : "protein_coding",
      gene_name : "WFDC3",
      gene_level : 1,
      hgnc_id : "HGNC:15957",
      havana_gene : "OTTHUMG00000032614.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45791954,
      stop : 45811427,
      direction : "+",
      ID : "ENSG00000101457.13",
      gene_id : "ENSG00000101457.13",
      gene_type : "protein_coding",
      gene_name : "DNTTIP1",
      gene_level : 1,
      hgnc_id : "HGNC:16160",
      havana_gene : "OTTHUMG00000032610.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45812576,
      stop : 45816957,
      direction : "+",
      ID : "ENSG00000175063.17",
      gene_id : "ENSG00000175063.17",
      gene_type : "protein_coding",
      gene_name : "UBE2C",
      gene_level : 2,
      hgnc_id : "HGNC:15937",
      havana_gene : "OTTHUMG00000033038.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45823214,
      stop : 45833745,
      direction : "-",
      ID : "ENSG00000101470.10",
      gene_id : "ENSG00000101470.10",
      gene_type : "protein_coding",
      gene_name : "TNNC2",
      gene_level : 2,
      hgnc_id : "HGNC:11944",
      havana_gene : "OTTHUMG00000032623.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45833799,
      stop : 45843276,
      direction : "+",
      ID : "ENSG00000124104.19",
      gene_id : "ENSG00000124104.19",
      gene_type : "protein_coding",
      gene_name : "SNX21",
      gene_level : 2,
      hgnc_id : "HGNC:16154",
      havana_gene : "OTTHUMG00000032624.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45841721,
      stop : 45857405,
      direction : "-",
      ID : "ENSG00000101473.17",
      gene_id : "ENSG00000101473.17",
      gene_type : "protein_coding",
      gene_name : "ACOT8",
      gene_level : 1,
      hgnc_id : "HGNC:15919",
      havana_gene : "OTTHUMG00000033045.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45857614,
      stop : 45879122,
      direction : "+",
      ID : "ENSG00000132801.7",
      gene_id : "ENSG00000132801.7",
      gene_type : "protein_coding",
      gene_name : "ZSWIM3",
      gene_level : 2,
      hgnc_id : "HGNC:16157",
      havana_gene : "OTTHUMG00000032627.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45881227,
      stop : 45885266,
      direction : "+",
      ID : "ENSG00000168612.5",
      gene_id : "ENSG00000168612.5",
      gene_type : "protein_coding",
      gene_name : "ZSWIM1",
      gene_level : 2,
      hgnc_id : "HGNC:16155",
      havana_gene : "OTTHUMG00000074023.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45886489,
      stop : 45887635,
      direction : "-",
      ID : "ENSG00000149634.4",
      gene_id : "ENSG00000149634.4",
      gene_type : "protein_coding",
      gene_name : "SPATA25",
      gene_level : 2,
      hgnc_id : "HGNC:16158",
      havana_gene : "OTTHUMG00000032628.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45888625,
      stop : 45891208,
      direction : "-",
      ID : "ENSG00000124257.7",
      gene_id : "ENSG00000124257.7",
      gene_type : "protein_coding",
      gene_name : "NEURL2",
      gene_level : 1,
      hgnc_id : "HGNC:16156",
      havana_gene : "OTTHUMG00000032626.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45890144,
      stop : 45898824,
      direction : "+",
      ID : "ENSG00000064601.20",
      gene_id : "ENSG00000064601.20",
      gene_type : "protein_coding",
      gene_name : "CTSA",
      gene_level : 2,
      hgnc_id : "HGNC:9251",
      havana_gene : "OTTHUMG00000033078.16",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45898621,
      stop : 45912155,
      direction : "-",
      ID : "ENSG00000100979.15",
      gene_id : "ENSG00000100979.15",
      gene_type : "protein_coding",
      gene_name : "PLTP",
      gene_level : 2,
      hgnc_id : "HGNC:9093",
      havana_gene : "OTTHUMG00000033047.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45934683,
      stop : 45948023,
      direction : "+",
      ID : "ENSG00000100982.12",
      gene_id : "ENSG00000100982.12",
      gene_type : "protein_coding",
      gene_name : "PCIF1",
      gene_level : 2,
      hgnc_id : "HGNC:16200",
      havana_gene : "OTTHUMG00000032635.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 45948660,
      stop : 45972203,
      direction : "-",
      ID : "ENSG00000198026.8",
      gene_id : "ENSG00000198026.8",
      gene_type : "protein_coding",
      gene_name : "ZNF335",
      gene_level : 2,
      hgnc_id : "HGNC:15807",
      havana_gene : "OTTHUMG00000032637.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46008908,
      stop : 46016561,
      direction : "+",
      ID : "ENSG00000100985.7",
      gene_id : "ENSG00000100985.7",
      gene_type : "protein_coding",
      gene_name : "MMP9",
      gene_level : 2,
      hgnc_id : "HGNC:7176",
      havana_gene : "OTTHUMG00000033044.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46021690,
      stop : 46060150,
      direction : "+",
      ID : "ENSG00000124140.14",
      gene_id : "ENSG00000124140.14",
      gene_type : "protein_coding",
      gene_name : "SLC12A5",
      gene_level : 1,
      hgnc_id : "HGNC:13818",
      havana_gene : "OTTHUMG00000032638.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46060991,
      stop : 46089962,
      direction : "-",
      ID : "ENSG00000124160.12",
      gene_id : "ENSG00000124160.12",
      gene_type : "protein_coding",
      gene_name : "NCOA5",
      gene_level : 2,
      hgnc_id : "HGNC:15909",
      havana_gene : "OTTHUMG00000032639.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46118278,
      stop : 46129863,
      direction : "+",
      ID : "ENSG00000101017.14",
      gene_id : "ENSG00000101017.14",
      gene_type : "protein_coding",
      gene_name : "CD40",
      gene_level : 2,
      hgnc_id : "HGNC:11919",
      havana_gene : "OTTHUMG00000033053.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46173739,
      stop : 46308498,
      direction : "-",
      ID : "ENSG00000149654.11",
      gene_id : "ENSG00000149654.11",
      gene_type : "protein_coding",
      gene_name : "CDH22",
      gene_level : 2,
      hgnc_id : "HGNC:13251",
      havana_gene : "OTTHUMG00000033073.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46345980,
      stop : 46364458,
      direction : "-",
      ID : "ENSG00000080189.15",
      gene_id : "ENSG00000080189.15",
      gene_type : "protein_coding",
      gene_name : "SLC35C2",
      gene_level : 2,
      hgnc_id : "HGNC:17117",
      havana_gene : "OTTHUMG00000033050.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46366050,
      stop : 46432985,
      direction : "-",
      ID : "ENSG00000062598.18",
      gene_id : "ENSG00000062598.18",
      gene_type : "protein_coding",
      gene_name : "ELMO2",
      gene_level : 2,
      hgnc_id : "HGNC:17233",
      havana_gene : "OTTHUMG00000033070.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46499630,
      stop : 46513559,
      direction : "-",
      ID : "ENSG00000198185.11",
      gene_id : "ENSG00000198185.11",
      gene_type : "protein_coding",
      gene_name : "ZNF334",
      gene_level : 2,
      hgnc_id : "HGNC:15806",
      havana_gene : "OTTHUMG00000032654.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46540946,
      stop : 46550654,
      direction : "-",
      ID : "ENSG00000149635.3",
      gene_id : "ENSG00000149635.3",
      gene_type : "protein_coding",
      gene_name : "OCSTAMP",
      gene_level : 2,
      hgnc_id : "HGNC:16116",
      havana_gene : "OTTHUMG00000032652.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46557823,
      stop : 46684467,
      direction : "-",
      ID : "ENSG00000158296.14",
      gene_id : "ENSG00000158296.14",
      gene_type : "protein_coding",
      gene_name : "SLC13A3",
      gene_level : 1,
      hgnc_id : "HGNC:14430",
      havana_gene : "OTTHUMG00000033042.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46684365,
      stop : 46689444,
      direction : "-",
      ID : "ENSG00000172315.6",
      gene_id : "ENSG00000172315.6",
      gene_type : "protein_coding",
      gene_name : "TP53RK",
      gene_level : 2,
      hgnc_id : "HGNC:16197",
      havana_gene : "OTTHUMG00000085887.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46709649,
      stop : 46736347,
      direction : "+",
      ID : "ENSG00000197496.6",
      gene_id : "ENSG00000197496.6",
      gene_type : "protein_coding",
      gene_name : "SLC2A10",
      gene_level : 2,
      hgnc_id : "HGNC:13444",
      havana_gene : "OTTHUMG00000032657.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 46894624,
      stop : 47188844,
      direction : "+",
      ID : "ENSG00000064655.19",
      gene_id : "ENSG00000064655.19",
      gene_type : "protein_coding",
      gene_name : "EYA2",
      gene_level : 2,
      hgnc_id : "HGNC:3520",
      havana_gene : "OTTHUMG00000033041.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 47209214,
      stop : 47356889,
      direction : "-",
      ID : "ENSG00000101040.19",
      gene_id : "ENSG00000101040.19",
      gene_type : "protein_coding",
      gene_name : "ZMYND8",
      gene_level : 1,
      hgnc_id : "HGNC:9397",
      havana_gene : "OTTHUMG00000032667.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 47501887,
      stop : 47656877,
      direction : "+",
      ID : "ENSG00000124151.19",
      gene_id : "ENSG00000124151.19",
      gene_type : "protein_coding",
      gene_name : "NCOA3",
      gene_level : 2,
      hgnc_id : "HGNC:7670",
      havana_gene : "OTTHUMG00000033061.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 47656348,
      stop : 47786616,
      direction : "-",
      ID : "ENSG00000196562.14",
      gene_id : "ENSG00000196562.14",
      gene_type : "protein_coding",
      gene_name : "SULF2",
      gene_level : 2,
      hgnc_id : "HGNC:20392",
      havana_gene : "OTTHUMG00000032675.9",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 48624252,
      stop : 48827999,
      direction : "-",
      ID : "ENSG00000124126.14",
      gene_id : "ENSG00000124126.14",
      gene_type : "protein_coding",
      gene_name : "PREX1",
      gene_level : 2,
      hgnc_id : "HGNC:32594",
      havana_gene : "OTTHUMG00000032685.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 48921711,
      stop : 49036693,
      direction : "+",
      ID : "ENSG00000124198.10",
      gene_id : "ENSG00000124198.10",
      gene_type : "protein_coding",
      gene_name : "ARFGEF2",
      gene_level : 2,
      hgnc_id : "HGNC:15853",
      havana_gene : "OTTHUMG00000032687.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49046246,
      stop : 49096960,
      direction : "+",
      ID : "ENSG00000124207.17",
      gene_id : "ENSG00000124207.17",
      gene_type : "protein_coding",
      gene_name : "CSE1L",
      gene_level : 2,
      hgnc_id : "HGNC:2431",
      havana_gene : "OTTHUMG00000033046.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49113339,
      stop : 49188367,
      direction : "-",
      ID : "ENSG00000124214.21",
      gene_id : "ENSG00000124214.21",
      gene_type : "protein_coding",
      gene_name : "STAU1",
      gene_level : 2,
      hgnc_id : "HGNC:11370",
      havana_gene : "OTTHUMG00000032691.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49219347,
      stop : 49244077,
      direction : "+",
      ID : "ENSG00000124228.15",
      gene_id : "ENSG00000124228.15",
      gene_type : "protein_coding",
      gene_name : "DDX27",
      gene_level : 2,
      hgnc_id : "HGNC:15837",
      havana_gene : "OTTHUMG00000033072.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49237946,
      stop : 49278426,
      direction : "-",
      ID : "ENSG00000124201.15",
      gene_id : "ENSG00000124201.15",
      gene_type : "protein_coding",
      gene_name : "ZNFX1",
      gene_level : 2,
      hgnc_id : "HGNC:29271",
      havana_gene : "OTTHUMG00000032696.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49293394,
      stop : 49484297,
      direction : "-",
      ID : "ENSG00000158445.10",
      gene_id : "ENSG00000158445.10",
      gene_type : "protein_coding",
      gene_name : "KCNB1",
      gene_level : 2,
      hgnc_id : "HGNC:6231",
      havana_gene : "OTTHUMG00000033051.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49503874,
      stop : 49568137,
      direction : "-",
      ID : "ENSG00000124212.6",
      gene_id : "ENSG00000124212.6",
      gene_type : "protein_coding",
      gene_name : "PTGIS",
      gene_level : 2,
      hgnc_id : "HGNC:9603",
      havana_gene : "OTTHUMG00000033077.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49632945,
      stop : 49713878,
      direction : "-",
      ID : "ENSG00000158470.5",
      gene_id : "ENSG00000158470.5",
      gene_type : "protein_coding",
      gene_name : "B4GALT5",
      gene_level : 2,
      hgnc_id : "HGNC:928",
      havana_gene : "OTTHUMG00000033086.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49812713,
      stop : 49892242,
      direction : "+",
      ID : "ENSG00000197818.12",
      gene_id : "ENSG00000197818.12",
      gene_type : "protein_coding",
      gene_name : "SLC9A8",
      gene_level : 2,
      hgnc_id : "HGNC:20728",
      havana_gene : "OTTHUMG00000032710.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49903391,
      stop : 49915529,
      direction : "-",
      ID : "ENSG00000158480.11",
      gene_id : "ENSG00000158480.11",
      gene_type : "protein_coding",
      gene_name : "SPATA2",
      gene_level : 2,
      hgnc_id : "HGNC:14681",
      havana_gene : "OTTHUMG00000032704.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49936336,
      stop : 49953885,
      direction : "+",
      ID : "ENSG00000124226.11",
      gene_id : "ENSG00000124226.11",
      gene_type : "protein_coding",
      gene_name : "RNF114",
      gene_level : 2,
      hgnc_id : "HGNC:13094",
      havana_gene : "OTTHUMG00000032709.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 49982980,
      stop : 49988886,
      direction : "+",
      ID : "ENSG00000124216.4",
      gene_id : "ENSG00000124216.4",
      gene_type : "protein_coding",
      gene_name : "SNAI1",
      gene_level : 2,
      hgnc_id : "HGNC:11128",
      havana_gene : "OTTHUMG00000033048.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50081124,
      stop : 50115959,
      direction : "-",
      ID : "ENSG00000244687.12",
      gene_id : "ENSG00000244687.12",
      gene_type : "protein_coding",
      gene_name : "UBE2V1",
      gene_level : 2,
      hgnc_id : "HGNC:12494",
      havana_gene : "OTTHUMG00000152626.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50081124,
      stop : 50153637,
      direction : "-",
      ID : "ENSG00000124208.16",
      gene_id : "ENSG00000124208.16",
      gene_type : "protein_coding",
      gene_name : "PEDS1-UBE2V1",
      gene_level : 2,
      hgnc_id : "HGNC:33521",
      havana_gene : "OTTHUMG00000033085.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50118254,
      stop : 50153734,
      direction : "-",
      ID : "ENSG00000240849.11",
      gene_id : "ENSG00000240849.11",
      gene_type : "protein_coding",
      gene_name : "PEDS1",
      gene_level : 2,
      hgnc_id : "HGNC:16735",
      havana_gene : "OTTHUMG00000152625.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50190830,
      stop : 50192668,
      direction : "+",
      ID : "ENSG00000172216.6",
      gene_id : "ENSG00000172216.6",
      gene_type : "protein_coding",
      gene_name : "CEBPB",
      gene_level : 2,
      hgnc_id : "HGNC:1834",
      havana_gene : "OTTHUMG00000032715.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50510321,
      stop : 50585241,
      direction : "+",
      ID : "ENSG00000196396.10",
      gene_id : "ENSG00000196396.10",
      gene_type : "protein_coding",
      gene_name : "PTPN1",
      gene_level : 2,
      hgnc_id : "HGNC:9642",
      havana_gene : "OTTHUMG00000032729.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50586108,
      stop : 50691542,
      direction : "-",
      ID : "ENSG00000042062.13",
      gene_id : "ENSG00000042062.13",
      gene_type : "protein_coding",
      gene_name : "RIPOR3",
      gene_level : 2,
      hgnc_id : "HGNC:16168",
      havana_gene : "OTTHUMG00000032724.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50731580,
      stop : 50756795,
      direction : "+",
      ID : "ENSG00000124171.9",
      gene_id : "ENSG00000124171.9",
      gene_type : "protein_coding",
      gene_name : "PARD6B",
      gene_level : 1,
      hgnc_id : "HGNC:16245",
      havana_gene : "OTTHUMG00000032732.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50794894,
      stop : 50882676,
      direction : "+",
      ID : "ENSG00000124243.18",
      gene_id : "ENSG00000124243.18",
      gene_type : "protein_coding",
      gene_name : "BCAS4",
      gene_level : 2,
      hgnc_id : "HGNC:14367",
      havana_gene : "OTTHUMG00000032735.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50888916,
      stop : 50931437,
      direction : "-",
      ID : "ENSG00000101126.18",
      gene_id : "ENSG00000101126.18",
      gene_type : "protein_coding",
      gene_name : "ADNP",
      gene_level : 2,
      hgnc_id : "HGNC:15766",
      havana_gene : "OTTHUMG00000032737.28",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50934867,
      stop : 50958555,
      direction : "-",
      ID : "ENSG00000000419.13",
      gene_id : "ENSG00000000419.13",
      gene_type : "protein_coding",
      gene_name : "DPM1",
      gene_level : 2,
      hgnc_id : "HGNC:3005",
      havana_gene : "OTTHUMG00000032742.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 50958818,
      stop : 50963929,
      direction : "+",
      ID : "ENSG00000124217.5",
      gene_id : "ENSG00000124217.5",
      gene_type : "protein_coding",
      gene_name : "MOCS3",
      gene_level : 2,
      hgnc_id : "HGNC:15765",
      havana_gene : "OTTHUMG00000032741.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 51003656,
      stop : 51023107,
      direction : "-",
      ID : "ENSG00000026559.14",
      gene_id : "ENSG00000026559.14",
      gene_type : "protein_coding",
      gene_name : "KCNG1",
      gene_level : 2,
      hgnc_id : "HGNC:6248",
      havana_gene : "OTTHUMG00000032745.9",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 51386957,
      stop : 51562831,
      direction : "-",
      ID : "ENSG00000101096.20",
      gene_id : "ENSG00000101096.20",
      gene_type : "protein_coding",
      gene_name : "NFATC2",
      gene_level : 2,
      hgnc_id : "HGNC:7776",
      havana_gene : "OTTHUMG00000032747.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 51596514,
      stop : 51768390,
      direction : "-",
      ID : "ENSG00000054793.14",
      gene_id : "ENSG00000054793.14",
      gene_type : "protein_coding",
      gene_name : "ATP9A",
      gene_level : 1,
      hgnc_id : "HGNC:13540",
      havana_gene : "OTTHUMG00000032751.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 51782331,
      stop : 51802521,
      direction : "-",
      ID : "ENSG00000101115.13",
      gene_id : "ENSG00000101115.13",
      gene_type : "protein_coding",
      gene_name : "SALL4",
      gene_level : 1,
      hgnc_id : "HGNC:15924",
      havana_gene : "OTTHUMG00000032752.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 52051663,
      stop : 52204308,
      direction : "-",
      ID : "ENSG00000020256.20",
      gene_id : "ENSG00000020256.20",
      gene_type : "protein_coding",
      gene_name : "ZFP64",
      gene_level : 2,
      hgnc_id : "HGNC:15940",
      havana_gene : "OTTHUMG00000032756.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 52972358,
      stop : 53495330,
      direction : "+",
      ID : "ENSG00000182463.16",
      gene_id : "ENSG00000182463.16",
      gene_type : "protein_coding",
      gene_name : "TSHZ2",
      gene_level : 2,
      hgnc_id : "HGNC:13010",
      havana_gene : "OTTHUMG00000033058.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 53567071,
      stop : 53609907,
      direction : "-",
      ID : "ENSG00000171940.14",
      gene_id : "ENSG00000171940.14",
      gene_type : "protein_coding",
      gene_name : "ZNF217",
      gene_level : 1,
      hgnc_id : "HGNC:13009",
      havana_gene : "OTTHUMG00000032764.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 53936777,
      stop : 54070594,
      direction : "-",
      ID : "ENSG00000064787.13",
      gene_id : "ENSG00000064787.13",
      gene_type : "protein_coding",
      gene_name : "BCAS1",
      gene_level : 2,
      hgnc_id : "HGNC:974",
      havana_gene : "OTTHUMG00000032772.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 54153446,
      stop : 54173986,
      direction : "-",
      ID : "ENSG00000019186.10",
      gene_id : "ENSG00000019186.10",
      gene_type : "protein_coding",
      gene_name : "CYP24A1",
      gene_level : 1,
      hgnc_id : "HGNC:2602",
      havana_gene : "OTTHUMG00000032773.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 54208087,
      stop : 54228052,
      direction : "+",
      ID : "ENSG00000101132.10",
      gene_id : "ENSG00000101132.10",
      gene_type : "protein_coding",
      gene_name : "PFDN4",
      gene_level : 2,
      hgnc_id : "HGNC:8868",
      havana_gene : "OTTHUMG00000032775.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 54475593,
      stop : 54651169,
      direction : "+",
      ID : "ENSG00000101134.12",
      gene_id : "ENSG00000101134.12",
      gene_type : "protein_coding",
      gene_name : "DOK5",
      gene_level : 2,
      hgnc_id : "HGNC:16173",
      havana_gene : "OTTHUMG00000032778.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 55997357,
      stop : 56005519,
      direction : "-",
      ID : "ENSG00000054803.4",
      gene_id : "ENSG00000054803.4",
      gene_type : "protein_coding",
      gene_name : "CBLN4",
      gene_level : 2,
      hgnc_id : "HGNC:16231",
      havana_gene : "OTTHUMG00000032782.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56248732,
      stop : 56249815,
      direction : "+",
      ID : "ENSG00000124089.4",
      gene_id : "ENSG00000124089.4",
      gene_type : "protein_coding",
      gene_name : "MC3R",
      gene_level : 2,
      hgnc_id : "HGNC:6931",
      havana_gene : "OTTHUMG00000032785.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56358974,
      stop : 56368663,
      direction : "+",
      ID : "ENSG00000124098.10",
      gene_id : "ENSG00000124098.10",
      gene_type : "protein_coding",
      gene_name : "FAM210B",
      gene_level : 2,
      hgnc_id : "HGNC:16102",
      havana_gene : "OTTHUMG00000032793.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56369389,
      stop : 56392337,
      direction : "-",
      ID : "ENSG00000087586.18",
      gene_id : "ENSG00000087586.18",
      gene_type : "protein_coding",
      gene_name : "AURKA",
      gene_level : 2,
      hgnc_id : "HGNC:11393",
      havana_gene : "OTTHUMG00000032796.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56392371,
      stop : 56406362,
      direction : "+",
      ID : "ENSG00000101138.12",
      gene_id : "ENSG00000101138.12",
      gene_type : "protein_coding",
      gene_name : "CSTF1",
      gene_level : 2,
      hgnc_id : "HGNC:2483",
      havana_gene : "OTTHUMG00000032791.9",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56412112,
      stop : 56460387,
      direction : "+",
      ID : "ENSG00000087589.17",
      gene_id : "ENSG00000087589.17",
      gene_type : "protein_coding",
      gene_name : "CASS4",
      gene_level : 2,
      hgnc_id : "HGNC:15878",
      havana_gene : "OTTHUMG00000032788.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56468585,
      stop : 56519449,
      direction : "+",
      ID : "ENSG00000022277.13",
      gene_id : "ENSG00000022277.13",
      gene_type : "protein_coding",
      gene_name : "RTF2",
      gene_level : 1,
      hgnc_id : "HGNC:15890",
      havana_gene : "OTTHUMG00000032801.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56491492,
      stop : 56525925,
      direction : "-",
      ID : "ENSG00000124091.9",
      gene_id : "ENSG00000124091.9",
      gene_type : "protein_coding",
      gene_name : "GCNT7",
      gene_level : 1,
      hgnc_id : "HGNC:16099",
      havana_gene : "OTTHUMG00000032798.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56517187,
      stop : 56526152,
      direction : "+",
      ID : "ENSG00000124103.10",
      gene_id : "ENSG00000124103.10",
      gene_type : "protein_coding",
      gene_name : "FAM209A",
      gene_level : 2,
      hgnc_id : "HGNC:16100",
      havana_gene : "OTTHUMG00000032799.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56533246,
      stop : 56536520,
      direction : "+",
      ID : "ENSG00000213714.1",
      gene_id : "ENSG00000213714.1",
      gene_type : "protein_coding",
      gene_name : "FAM209B",
      gene_level : 2,
      hgnc_id : "HGNC:16101",
      havana_gene : "OTTHUMG00000032800.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 56629306,
      stop : 56639283,
      direction : "+",
      ID : "ENSG00000087510.7",
      gene_id : "ENSG00000087510.7",
      gene_type : "protein_coding",
      gene_name : "TFAP2C",
      gene_level : 2,
      hgnc_id : "HGNC:11744",
      havana_gene : "OTTHUMG00000032805.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57168753,
      stop : 57266641,
      direction : "-",
      ID : "ENSG00000101144.13",
      gene_id : "ENSG00000101144.13",
      gene_type : "protein_coding",
      gene_name : "BMP7",
      gene_level : 1,
      hgnc_id : "HGNC:1074",
      havana_gene : "OTTHUMG00000032812.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57329803,
      stop : 57343994,
      direction : "+",
      ID : "ENSG00000054796.13",
      gene_id : "ENSG00000054796.13",
      gene_type : "protein_coding",
      gene_name : "SPO11",
      gene_level : 1,
      hgnc_id : "HGNC:11250",
      havana_gene : "OTTHUMG00000032817.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57351223,
      stop : 57379211,
      direction : "+",
      ID : "ENSG00000101146.13",
      gene_id : "ENSG00000101146.13",
      gene_type : "protein_coding",
      gene_name : "RAE1",
      gene_level : 2,
      hgnc_id : "HGNC:9828",
      havana_gene : "OTTHUMG00000032819.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57358447,
      stop : 57359498,
      direction : "-",
      ID : "ENSG00000256222.3",
      gene_id : "ENSG00000256222.3",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L3",
      gene_level : 2,
      hgnc_id : "HGNC:37157",
      havana_gene : "OTTHUMG00000184962.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57391396,
      stop : 57409333,
      direction : "+",
      ID : "ENSG00000132819.17",
      gene_id : "ENSG00000132819.17",
      gene_type : "protein_coding",
      gene_name : "RBM38",
      gene_level : 2,
      hgnc_id : "HGNC:15818",
      havana_gene : "OTTHUMG00000032820.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57495966,
      stop : 57525652,
      direction : "-",
      ID : "ENSG00000124092.12",
      gene_id : "ENSG00000124092.12",
      gene_type : "protein_coding",
      gene_name : "CTCFL",
      gene_level : 1,
      hgnc_id : "HGNC:16234",
      havana_gene : "OTTHUMG00000032829.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57561080,
      stop : 57568121,
      direction : "+",
      ID : "ENSG00000124253.11",
      gene_id : "ENSG00000124253.11",
      gene_type : "protein_coding",
      gene_name : "PCK1",
      gene_level : 2,
      hgnc_id : "HGNC:8724",
      havana_gene : "OTTHUMG00000032825.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57603846,
      stop : 57620576,
      direction : "-",
      ID : "ENSG00000124256.15",
      gene_id : "ENSG00000124256.15",
      gene_type : "protein_coding",
      gene_name : "ZBP1",
      gene_level : 2,
      hgnc_id : "HGNC:16176",
      havana_gene : "OTTHUMG00000032824.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 57648392,
      stop : 57711536,
      direction : "-",
      ID : "ENSG00000124225.16",
      gene_id : "ENSG00000124225.16",
      gene_type : "protein_coding",
      gene_name : "PMEPA1",
      gene_level : 1,
      hgnc_id : "HGNC:14107",
      havana_gene : "OTTHUMG00000032831.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58150902,
      stop : 58161150,
      direction : "+",
      ID : "ENSG00000124237.6",
      gene_id : "ENSG00000124237.6",
      gene_type : "protein_coding",
      gene_name : "C20orf85",
      gene_level : 2,
      hgnc_id : "HGNC:16216",
      havana_gene : "OTTHUMG00000032836.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58218495,
      stop : 58228653,
      direction : "-",
      ID : "ENSG00000124227.5",
      gene_id : "ENSG00000124227.5",
      gene_type : "protein_coding",
      gene_name : "ANKRD60",
      gene_level : 2,
      hgnc_id : "HGNC:16217",
      havana_gene : "OTTHUMG00000032837.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58309715,
      stop : 58367507,
      direction : "+",
      ID : "ENSG00000124209.4",
      gene_id : "ENSG00000124209.4",
      gene_type : "protein_coding",
      gene_name : "RAB22A",
      gene_level : 2,
      hgnc_id : "HGNC:9764",
      havana_gene : "OTTHUMG00000032844.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58389229,
      stop : 58451101,
      direction : "+",
      ID : "ENSG00000124164.16",
      gene_id : "ENSG00000124164.16",
      gene_type : "protein_coding",
      gene_name : "VAPB",
      gene_level : 2,
      hgnc_id : "HGNC:12649",
      havana_gene : "OTTHUMG00000032840.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58459101,
      stop : 58515399,
      direction : "-",
      ID : "ENSG00000198768.11",
      gene_id : "ENSG00000198768.11",
      gene_type : "protein_coding",
      gene_name : "APCDD1L",
      gene_level : 2,
      hgnc_id : "HGNC:26892",
      havana_gene : "OTTHUMG00000032845.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58651253,
      stop : 58679526,
      direction : "+",
      ID : "ENSG00000124222.22",
      gene_id : "ENSG00000124222.22",
      gene_type : "protein_coding",
      gene_name : "STX16",
      gene_level : 2,
      hgnc_id : "HGNC:11431",
      havana_gene : "OTTHUMG00000033084.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58651434,
      stop : 58715410,
      direction : "+",
      ID : "ENSG00000254995.4",
      gene_id : "ENSG00000254995.4",
      gene_type : "protein_coding",
      gene_name : "STX16-NPEPL1",
      gene_level : 2,
      hgnc_id : "HGNC:41993",
      havana_gene : "OTTHUMG00000167390.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58689131,
      stop : 58719238,
      direction : "+",
      ID : "ENSG00000215440.12",
      gene_id : "ENSG00000215440.12",
      gene_type : "protein_coding",
      gene_name : "NPEPL1",
      gene_level : 2,
      hgnc_id : "HGNC:16244",
      havana_gene : "OTTHUMG00000033060.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58839718,
      stop : 58911192,
      direction : "+",
      ID : "ENSG00000087460.28",
      gene_id : "ENSG00000087460.28",
      gene_type : "protein_coding",
      gene_name : "GNAS",
      gene_level : 2,
      hgnc_id : "HGNC:4392",
      havana_gene : "OTTHUMG00000033069.23",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58981208,
      stop : 58995133,
      direction : "+",
      ID : "ENSG00000101158.15",
      gene_id : "ENSG00000101158.15",
      gene_type : "protein_coding",
      gene_name : "NELFCD",
      gene_level : 2,
      hgnc_id : "HGNC:15934",
      havana_gene : "OTTHUMG00000032861.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 58985686,
      stop : 59008238,
      direction : "-",
      ID : "ENSG00000101160.15",
      gene_id : "ENSG00000101160.15",
      gene_type : "protein_coding",
      gene_name : "CTSZ",
      gene_level : 2,
      hgnc_id : "HGNC:2547",
      havana_gene : "OTTHUMG00000032858.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59019429,
      stop : 59026654,
      direction : "+",
      ID : "ENSG00000101162.4",
      gene_id : "ENSG00000101162.4",
      gene_type : "protein_coding",
      gene_name : "TUBB1",
      gene_level : 2,
      hgnc_id : "HGNC:16257",
      havana_gene : "OTTHUMG00000032860.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59025475,
      stop : 59032345,
      direction : "-",
      ID : "ENSG00000124172.10",
      gene_id : "ENSG00000124172.10",
      gene_type : "protein_coding",
      gene_name : "ATP5F1E",
      gene_level : 2,
      hgnc_id : "HGNC:838",
      havana_gene : "OTTHUMG00000032854.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59033145,
      stop : 59042809,
      direction : "-",
      ID : "ENSG00000101166.16",
      gene_id : "ENSG00000101166.16",
      gene_type : "protein_coding",
      gene_name : "PRELID3B",
      gene_level : 2,
      hgnc_id : "HGNC:15892",
      havana_gene : "OTTHUMG00000032856.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59123381,
      stop : 59259113,
      direction : "+",
      ID : "ENSG00000124203.6",
      gene_id : "ENSG00000124203.6",
      gene_type : "protein_coding",
      gene_name : "ZNF831",
      gene_level : 1,
      hgnc_id : "HGNC:16167",
      havana_gene : "OTTHUMG00000032864.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59300443,
      stop : 59325992,
      direction : "+",
      ID : "ENSG00000124205.18",
      gene_id : "ENSG00000124205.18",
      gene_type : "protein_coding",
      gene_name : "EDN3",
      gene_level : 2,
      hgnc_id : "HGNC:3178",
      havana_gene : "OTTHUMG00000032867.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59577509,
      stop : 59847711,
      direction : "+",
      ID : "ENSG00000087495.17",
      gene_id : "ENSG00000087495.17",
      gene_type : "protein_coding",
      gene_name : "PHACTR3",
      gene_level : 2,
      hgnc_id : "HGNC:15833",
      havana_gene : "OTTHUMG00000032869.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59863564,
      stop : 59933655,
      direction : "-",
      ID : "ENSG00000196074.13",
      gene_id : "ENSG00000196074.13",
      gene_type : "protein_coding",
      gene_name : "SYCP2",
      gene_level : 2,
      hgnc_id : "HGNC:11490",
      havana_gene : "OTTHUMG00000032872.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59933764,
      stop : 59948680,
      direction : "+",
      ID : "ENSG00000196227.11",
      gene_id : "ENSG00000196227.11",
      gene_type : "protein_coding",
      gene_name : "FAM217B",
      gene_level : 2,
      hgnc_id : "HGNC:16170",
      havana_gene : "OTTHUMG00000032873.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59936663,
      stop : 59940305,
      direction : "-",
      ID : "ENSG00000132825.7",
      gene_id : "ENSG00000132825.7",
      gene_type : "protein_coding",
      gene_name : "PPP1R3D",
      gene_level : 2,
      hgnc_id : "HGNC:9294",
      havana_gene : "OTTHUMG00000032876.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 59958423,
      stop : 60034011,
      direction : "+",
      ID : "ENSG00000124215.17",
      gene_id : "ENSG00000124215.17",
      gene_type : "protein_coding",
      gene_name : "CDH26",
      gene_level : 2,
      hgnc_id : "HGNC:15902",
      havana_gene : "OTTHUMG00000032874.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 61252261,
      stop : 61940617,
      direction : "+",
      ID : "ENSG00000179242.16",
      gene_id : "ENSG00000179242.16",
      gene_type : "protein_coding",
      gene_name : "CDH4",
      gene_level : 2,
      hgnc_id : "HGNC:1763",
      havana_gene : "OTTHUMG00000032890.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 61953469,
      stop : 62065810,
      direction : "-",
      ID : "ENSG00000130699.18",
      gene_id : "ENSG00000130699.18",
      gene_type : "protein_coding",
      gene_name : "TAF4",
      gene_level : 2,
      hgnc_id : "HGNC:11537",
      havana_gene : "OTTHUMG00000032893.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62122461,
      stop : 62135374,
      direction : "+",
      ID : "ENSG00000149657.20",
      gene_id : "ENSG00000149657.20",
      gene_type : "protein_coding",
      gene_name : "LSM14B",
      gene_level : 2,
      hgnc_id : "HGNC:15887",
      havana_gene : "OTTHUMG00000032901.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62136733,
      stop : 62143440,
      direction : "-",
      ID : "ENSG00000101182.15",
      gene_id : "ENSG00000101182.15",
      gene_type : "protein_coding",
      gene_name : "PSMA7",
      gene_level : 2,
      hgnc_id : "HGNC:9536",
      havana_gene : "OTTHUMG00000032895.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62143769,
      stop : 62182514,
      direction : "+",
      ID : "ENSG00000184402.15",
      gene_id : "ENSG00000184402.15",
      gene_type : "protein_coding",
      gene_name : "SS18L1",
      gene_level : 2,
      hgnc_id : "HGNC:15592",
      havana_gene : "OTTHUMG00000032902.6",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62183028,
      stop : 62203568,
      direction : "+",
      ID : "ENSG00000101181.18",
      gene_id : "ENSG00000101181.18",
      gene_type : "protein_coding",
      gene_name : "MTG2",
      gene_level : 2,
      hgnc_id : "HGNC:16239",
      havana_gene : "OTTHUMG00000032897.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62214960,
      stop : 62220278,
      direction : "-",
      ID : "ENSG00000101180.16",
      gene_id : "ENSG00000101180.16",
      gene_type : "protein_coding",
      gene_name : "HRH3",
      gene_level : 2,
      hgnc_id : "HGNC:5184",
      havana_gene : "OTTHUMG00000032899.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62231922,
      stop : 62296213,
      direction : "+",
      ID : "ENSG00000130703.17",
      gene_id : "ENSG00000130703.17",
      gene_type : "protein_coding",
      gene_name : "OSBPL2",
      gene_level : 2,
      hgnc_id : "HGNC:15761",
      havana_gene : "OTTHUMG00000032909.15",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62302093,
      stop : 62308862,
      direction : "+",
      ID : "ENSG00000130706.13",
      gene_id : "ENSG00000130706.13",
      gene_type : "protein_coding",
      gene_name : "ADRM1",
      gene_level : 2,
      hgnc_id : "HGNC:15759",
      havana_gene : "OTTHUMG00000032904.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62307955,
      stop : 62367312,
      direction : "-",
      ID : "ENSG00000130702.15",
      gene_id : "ENSG00000130702.15",
      gene_type : "protein_coding",
      gene_name : "LAMA5",
      gene_level : 2,
      hgnc_id : "HGNC:6485",
      havana_gene : "OTTHUMG00000032908.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62387103,
      stop : 62388520,
      direction : "+",
      ID : "ENSG00000171858.18",
      gene_id : "ENSG00000171858.18",
      gene_type : "protein_coding",
      gene_name : "RPS21",
      gene_level : 2,
      hgnc_id : "HGNC:10409",
      havana_gene : "OTTHUMG00000032915.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62388632,
      stop : 62407285,
      direction : "-",
      ID : "ENSG00000149679.11",
      gene_id : "ENSG00000149679.11",
      gene_type : "protein_coding",
      gene_name : "CABLES2",
      gene_level : 2,
      hgnc_id : "HGNC:16143",
      havana_gene : "OTTHUMG00000032912.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62410237,
      stop : 62427539,
      direction : "-",
      ID : "ENSG00000130701.4",
      gene_id : "ENSG00000130701.4",
      gene_type : "protein_coding",
      gene_name : "RBBP8NL",
      gene_level : 2,
      hgnc_id : "HGNC:16144",
      havana_gene : "OTTHUMG00000032913.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62463497,
      stop : 62475995,
      direction : "-",
      ID : "ENSG00000130700.7",
      gene_id : "ENSG00000130700.7",
      gene_type : "protein_coding",
      gene_name : "GATA5",
      gene_level : 2,
      hgnc_id : "HGNC:15802",
      havana_gene : "OTTHUMG00000032919.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62642503,
      stop : 62685785,
      direction : "+",
      ID : "ENSG00000101187.16",
      gene_id : "ENSG00000101187.16",
      gene_type : "protein_coding",
      gene_name : "SLCO4A1",
      gene_level : 2,
      hgnc_id : "HGNC:10953",
      havana_gene : "OTTHUMG00000032923.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62708836,
      stop : 62762771,
      direction : "+",
      ID : "ENSG00000101188.5",
      gene_id : "ENSG00000101188.5",
      gene_type : "protein_coding",
      gene_name : "NTSR1",
      gene_level : 2,
      hgnc_id : "HGNC:8039",
      havana_gene : "OTTHUMG00000032932.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62796473,
      stop : 62801729,
      direction : "+",
      ID : "ENSG00000101189.7",
      gene_id : "ENSG00000101189.7",
      gene_type : "protein_coding",
      gene_name : "MRGBP",
      gene_level : 2,
      hgnc_id : "HGNC:15866",
      havana_gene : "OTTHUMG00000032940.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62804835,
      stop : 62814000,
      direction : "+",
      ID : "ENSG00000060491.17",
      gene_id : "ENSG00000060491.17",
      gene_type : "protein_coding",
      gene_name : "OGFR",
      gene_level : 2,
      hgnc_id : "HGNC:15768",
      havana_gene : "OTTHUMG00000032937.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62816244,
      stop : 62841159,
      direction : "+",
      ID : "ENSG00000092758.18",
      gene_id : "ENSG00000092758.18",
      gene_type : "protein_coding",
      gene_name : "COL9A3",
      gene_level : 2,
      hgnc_id : "HGNC:2219",
      havana_gene : "OTTHUMG00000032938.7",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62841005,
      stop : 62861822,
      direction : "-",
      ID : "ENSG00000101190.13",
      gene_id : "ENSG00000101190.13",
      gene_type : "protein_coding",
      gene_name : "TCFL5",
      gene_level : 2,
      hgnc_id : "HGNC:11646",
      havana_gene : "OTTHUMG00000032939.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62877738,
      stop : 62937952,
      direction : "-",
      ID : "ENSG00000101191.17",
      gene_id : "ENSG00000101191.17",
      gene_type : "protein_coding",
      gene_name : "DIDO1",
      gene_level : 2,
      hgnc_id : "HGNC:2680",
      havana_gene : "OTTHUMG00000032945.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62938147,
      stop : 62948475,
      direction : "+",
      ID : "ENSG00000101193.8",
      gene_id : "ENSG00000101193.8",
      gene_type : "protein_coding",
      gene_name : "GID8",
      gene_level : 2,
      hgnc_id : "HGNC:15857",
      havana_gene : "OTTHUMG00000032949.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 62952707,
      stop : 62969585,
      direction : "+",
      ID : "ENSG00000101194.18",
      gene_id : "ENSG00000101194.18",
      gene_type : "protein_coding",
      gene_name : "SLC17A9",
      gene_level : 2,
      hgnc_id : "HGNC:16192",
      havana_gene : "OTTHUMG00000032951.9",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63005927,
      stop : 63007035,
      direction : "-",
      ID : "ENSG00000125533.6",
      gene_id : "ENSG00000125533.6",
      gene_type : "protein_coding",
      gene_name : "BHLHE23",
      gene_level : 2,
      hgnc_id : "HGNC:16093",
      havana_gene : "OTTHUMG00000032948.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63195429,
      stop : 63216139,
      direction : "-",
      ID : "ENSG00000149658.18",
      gene_id : "ENSG00000149658.18",
      gene_type : "protein_coding",
      gene_name : "YTHDF1",
      gene_level : 1,
      hgnc_id : "HGNC:15867",
      havana_gene : "OTTHUMG00000032955.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63235883,
      stop : 63240495,
      direction : "+",
      ID : "ENSG00000101197.13",
      gene_id : "ENSG00000101197.13",
      gene_type : "protein_coding",
      gene_name : "BIRC7",
      gene_level : 2,
      hgnc_id : "HGNC:13702",
      havana_gene : "OTTHUMG00000032957.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63240784,
      stop : 63272694,
      direction : "-",
      ID : "ENSG00000101198.15",
      gene_id : "ENSG00000101198.15",
      gene_type : "protein_coding",
      gene_name : "NKAIN4",
      gene_level : 1,
      hgnc_id : "HGNC:16191",
      havana_gene : "OTTHUMG00000032959.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63272785,
      stop : 63289790,
      direction : "+",
      ID : "ENSG00000101199.13",
      gene_id : "ENSG00000101199.13",
      gene_type : "protein_coding",
      gene_name : "ARFGAP1",
      gene_level : 1,
      hgnc_id : "HGNC:15852",
      havana_gene : "OTTHUMG00000032965.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63293186,
      stop : 63334851,
      direction : "+",
      ID : "ENSG00000101203.16",
      gene_id : "ENSG00000101203.16",
      gene_type : "protein_coding",
      gene_name : "COL20A1",
      gene_level : 2,
      hgnc_id : "HGNC:14670",
      havana_gene : "OTTHUMG00000032964.18",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63343223,
      stop : 63378401,
      direction : "-",
      ID : "ENSG00000101204.18",
      gene_id : "ENSG00000101204.18",
      gene_type : "protein_coding",
      gene_name : "CHRNA4",
      gene_level : 2,
      hgnc_id : "HGNC:1958",
      havana_gene : "OTTHUMG00000033080.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63400208,
      stop : 63472677,
      direction : "-",
      ID : "ENSG00000075043.19",
      gene_id : "ENSG00000075043.19",
      gene_type : "protein_coding",
      gene_name : "KCNQ2",
      gene_level : 2,
      hgnc_id : "HGNC:6296",
      havana_gene : "OTTHUMG00000033049.15",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63488013,
      stop : 63499239,
      direction : "-",
      ID : "ENSG00000101210.13",
      gene_id : "ENSG00000101210.13",
      gene_type : "protein_coding",
      gene_name : "EEF1A2",
      gene_level : 2,
      hgnc_id : "HGNC:3192",
      havana_gene : "OTTHUMG00000033076.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63520765,
      stop : 63522206,
      direction : "+",
      ID : "ENSG00000125534.10",
      gene_id : "ENSG00000125534.10",
      gene_type : "protein_coding",
      gene_name : "PPDPF",
      gene_level : 2,
      hgnc_id : "HGNC:16142",
      havana_gene : "OTTHUMG00000032978.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63528001,
      stop : 63537376,
      direction : "-",
      ID : "ENSG00000101213.7",
      gene_id : "ENSG00000101213.7",
      gene_type : "protein_coding",
      gene_name : "PTK6",
      gene_level : 2,
      hgnc_id : "HGNC:9617",
      havana_gene : "OTTHUMG00000033039.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63540810,
      stop : 63547504,
      direction : "-",
      ID : "ENSG00000125508.3",
      gene_id : "ENSG00000125508.3",
      gene_type : "protein_coding",
      gene_name : "SRMS",
      gene_level : 2,
      hgnc_id : "HGNC:11298",
      havana_gene : "OTTHUMG00000032977.1",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63547891,
      stop : 63556695,
      direction : "+",
      ID : "ENSG00000125531.7",
      gene_id : "ENSG00000125531.7",
      gene_type : "protein_coding",
      gene_name : "FNDC11",
      gene_level : 2,
      hgnc_id : "HGNC:28764",
      havana_gene : "OTTHUMG00000032980.5",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63558086,
      stop : 63574239,
      direction : "-",
      ID : "ENSG00000130589.16",
      gene_id : "ENSG00000130589.16",
      gene_type : "protein_coding",
      gene_name : "HELZ2",
      gene_level : 2,
      hgnc_id : "HGNC:30021",
      havana_gene : "OTTHUMG00000032969.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63587602,
      stop : 63627101,
      direction : "-",
      ID : "ENSG00000101216.11",
      gene_id : "ENSG00000101216.11",
      gene_type : "protein_coding",
      gene_name : "GMEB2",
      gene_level : 2,
      hgnc_id : "HGNC:4371",
      havana_gene : "OTTHUMG00000032988.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63639705,
      stop : 63657682,
      direction : "-",
      ID : "ENSG00000197457.10",
      gene_id : "ENSG00000197457.10",
      gene_type : "protein_coding",
      gene_name : "STMN3",
      gene_level : 2,
      hgnc_id : "HGNC:15926",
      havana_gene : "OTTHUMG00000032985.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63657810,
      stop : 63696253,
      direction : "+",
      ID : "ENSG00000258366.9",
      gene_id : "ENSG00000258366.9",
      gene_type : "protein_coding",
      gene_name : "RTEL1",
      gene_level : 1,
      hgnc_id : "HGNC:15888",
      havana_gene : "OTTHUMG00000032992.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63659300,
      stop : 63698684,
      direction : "+",
      ID : "ENSG00000026036.22",
      gene_id : "ENSG00000026036.22",
      gene_type : "protein_coding",
      gene_name : "RTEL1-TNFRSF6B",
      gene_level : 2,
      hgnc_id : "HGNC:44095",
      havana_gene : "OTTHUMG00000170363.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63696652,
      stop : 63698684,
      direction : "+",
      ID : "ENSG00000243509.6",
      gene_id : "ENSG00000243509.6",
      gene_type : "protein_coding",
      gene_name : "TNFRSF6B",
      gene_level : 2,
      hgnc_id : "HGNC:11921",
      havana_gene : "OTTHUMG00000143724.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63698642,
      stop : 63708025,
      direction : "-",
      ID : "ENSG00000101246.20",
      gene_id : "ENSG00000101246.20",
      gene_type : "protein_coding",
      gene_name : "ARFRP1",
      gene_level : 2,
      hgnc_id : "HGNC:662",
      havana_gene : "OTTHUMG00000032993.9",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63707465,
      stop : 63736142,
      direction : "+",
      ID : "ENSG00000197114.12",
      gene_id : "ENSG00000197114.12",
      gene_type : "protein_coding",
      gene_name : "ZGPAT",
      gene_level : 2,
      hgnc_id : "HGNC:15948",
      havana_gene : "OTTHUMG00000032998.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63708864,
      stop : 63739103,
      direction : "+",
      ID : "ENSG00000273154.3",
      gene_id : "ENSG00000273154.3",
      gene_type : "protein_coding",
      gene_name : "AL121845.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186489.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63736283,
      stop : 63739103,
      direction : "+",
      ID : "ENSG00000203896.10",
      gene_id : "ENSG00000203896.10",
      gene_type : "protein_coding",
      gene_name : "LIME1",
      gene_level : 2,
      hgnc_id : "HGNC:26016",
      havana_gene : "OTTHUMG00000032999.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63738270,
      stop : 63740398,
      direction : "+",
      ID : "ENSG00000273047.1",
      gene_id : "ENSG00000273047.1",
      gene_type : "protein_coding",
      gene_name : "AL121845.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186435.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63739776,
      stop : 63744050,
      direction : "+",
      ID : "ENSG00000125520.14",
      gene_id : "ENSG00000125520.14",
      gene_type : "protein_coding",
      gene_name : "SLC2A4RG",
      gene_level : 2,
      hgnc_id : "HGNC:15930",
      havana_gene : "OTTHUMG00000032997.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63743668,
      stop : 63832038,
      direction : "-",
      ID : "ENSG00000130584.12",
      gene_id : "ENSG00000130584.12",
      gene_type : "protein_coding",
      gene_name : "ZBTB46",
      gene_level : 2,
      hgnc_id : "HGNC:16094",
      havana_gene : "OTTHUMG00000033001.4",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63861498,
      stop : 63862988,
      direction : "+",
      ID : "ENSG00000183260.7",
      gene_id : "ENSG00000183260.7",
      gene_type : "protein_coding",
      gene_name : "ABHD16B",
      gene_level : 2,
      hgnc_id : "HGNC:16128",
      havana_gene : "OTTHUMG00000033010.2",
      tag : "retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63865228,
      stop : 63891545,
      direction : "+",
      ID : "ENSG00000101150.18",
      gene_id : "ENSG00000101150.18",
      gene_type : "protein_coding",
      gene_name : "TPD52L2",
      gene_level : 2,
      hgnc_id : "HGNC:12007",
      havana_gene : "OTTHUMG00000033009.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63895126,
      stop : 63936031,
      direction : "+",
      ID : "ENSG00000101152.11",
      gene_id : "ENSG00000101152.11",
      gene_type : "protein_coding",
      gene_name : "DNAJC5",
      gene_level : 2,
      hgnc_id : "HGNC:16235",
      havana_gene : "OTTHUMG00000033007.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63939829,
      stop : 63956416,
      direction : "-",
      ID : "ENSG00000198276.16",
      gene_id : "ENSG00000198276.16",
      gene_type : "protein_coding",
      gene_name : "UCKL1",
      gene_level : 2,
      hgnc_id : "HGNC:15938",
      havana_gene : "OTTHUMG00000033003.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63956704,
      stop : 63969930,
      direction : "-",
      ID : "ENSG00000196700.9",
      gene_id : "ENSG00000196700.9",
      gene_type : "protein_coding",
      gene_name : "ZNF512B",
      gene_level : 2,
      hgnc_id : "HGNC:29212",
      havana_gene : "OTTHUMG00000033008.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63974116,
      stop : 63980008,
      direction : "-",
      ID : "ENSG00000130590.14",
      gene_id : "ENSG00000130590.14",
      gene_type : "protein_coding",
      gene_name : "SAMD10",
      gene_level : 2,
      hgnc_id : "HGNC:16129",
      havana_gene : "OTTHUMG00000033011.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 63981132,
      stop : 64033100,
      direction : "+",
      ID : "ENSG00000101161.8",
      gene_id : "ENSG00000101161.8",
      gene_type : "protein_coding",
      gene_name : "PRPF6",
      gene_level : 2,
      hgnc_id : "HGNC:15860",
      havana_gene : "OTTHUMG00000033018.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64034344,
      stop : 64039962,
      direction : "+",
      ID : "ENSG00000196421.8",
      gene_id : "ENSG00000196421.8",
      gene_type : "protein_coding",
      gene_name : "C20orf204",
      gene_level : 2,
      hgnc_id : "HGNC:27655",
      havana_gene : "OTTHUMG00000033015.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64047582,
      stop : 64049639,
      direction : "-",
      ID : "ENSG00000203883.7",
      gene_id : "ENSG00000203883.7",
      gene_type : "protein_coding",
      gene_name : "SOX18",
      gene_level : 2,
      hgnc_id : "HGNC:11194",
      havana_gene : "OTTHUMG00000033017.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64049836,
      stop : 64072347,
      direction : "+",
      ID : "ENSG00000171703.17",
      gene_id : "ENSG00000171703.17",
      gene_type : "protein_coding",
      gene_name : "TCEA2",
      gene_level : 2,
      hgnc_id : "HGNC:11614",
      havana_gene : "OTTHUMG00000033026.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64073181,
      stop : 64079988,
      direction : "-",
      ID : "ENSG00000171700.14",
      gene_id : "ENSG00000171700.14",
      gene_type : "protein_coding",
      gene_name : "RGS19",
      gene_level : 2,
      hgnc_id : "HGNC:13735",
      havana_gene : "OTTHUMG00000033024.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64080082,
      stop : 64100643,
      direction : "+",
      ID : "ENSG00000125510.18",
      gene_id : "ENSG00000125510.18",
      gene_type : "protein_coding",
      gene_name : "OPRL1",
      gene_level : 2,
      hgnc_id : "HGNC:8155",
      havana_gene : "OTTHUMG00000033027.3",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64083380,
      stop : 64084359,
      direction : "-",
      ID : "ENSG00000171695.10",
      gene_id : "ENSG00000171695.10",
      gene_type : "protein_coding",
      gene_name : "LKAAEAR1",
      gene_level : 2,
      hgnc_id : "HGNC:33718",
      havana_gene : "OTTHUMG00000033021.2",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64102394,
      stop : 64242253,
      direction : "+",
      ID : "ENSG00000196132.14",
      gene_id : "ENSG00000196132.14",
      gene_type : "protein_coding",
      gene_name : "MYT1",
      gene_level : 2,
      hgnc_id : "HGNC:7622",
      havana_gene : "OTTHUMG00000149988.8",
      tag : null
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64105820,
      stop : 64107171,
      direction : "-",
      ID : "ENSG00000125522.3",
      gene_id : "ENSG00000125522.3",
      gene_type : "protein_coding",
      gene_name : "NPBWR2",
      gene_level : 2,
      hgnc_id : "HGNC:4530",
      havana_gene : "OTTHUMG00000033032.1",
      tag : "retrogene"
    },
    {
      chromosome : 20,
      annotation : "HAVANA",
      type : "gene",
      start : 64255695,
      stop : 64287821,
      direction : "+",
      ID : "ENSG00000203880.12",
      gene_id : "ENSG00000203880.12",
      gene_type : "protein_coding",
      gene_name : "PCMTD2",
      gene_level : 2,
      hgnc_id : "HGNC:15882",
      havana_gene : "OTTHUMG00000033029.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5011799,
      stop : 5017145,
      direction : "+",
      ID : "ENSG00000279493.1",
      gene_id : "ENSG00000279493.1",
      gene_type : "protein_coding",
      gene_name : "FP565260.4",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000189354.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5022493,
      stop : 5040666,
      direction : "+",
      ID : "ENSG00000277117.5",
      gene_id : "ENSG00000277117.5",
      gene_type : "protein_coding",
      gene_name : "FP565260.3",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000189355.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5079294,
      stop : 5128413,
      direction : "-",
      ID : "ENSG00000280071.4",
      gene_id : "ENSG00000280071.4",
      gene_type : "protein_coding",
      gene_name : "GATD3B",
      gene_level : 2,
      hgnc_id : "HGNC:53816",
      havana_gene : "OTTHUMG00000189357.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5116343,
      stop : 5133805,
      direction : "-",
      ID : "ENSG00000276612.3",
      gene_id : "ENSG00000276612.3",
      gene_type : "protein_coding",
      gene_name : "FP565260.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189358.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5130871,
      stop : 5154658,
      direction : "-",
      ID : "ENSG00000275464.5",
      gene_id : "ENSG00000275464.5",
      gene_type : "protein_coding",
      gene_name : "FP565260.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189361.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5155499,
      stop : 5165472,
      direction : "-",
      ID : "ENSG00000280433.1",
      gene_id : "ENSG00000280433.1",
      gene_type : "protein_coding",
      gene_name : "FP565260.6",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000189362.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 5972924,
      stop : 5973383,
      direction : "-",
      ID : "ENSG00000274559.3",
      gene_id : "ENSG00000274559.3",
      gene_type : "protein_coding",
      gene_name : "CU639417.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000189387.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 6111131,
      stop : 6123778,
      direction : "+",
      ID : "ENSG00000275993.3",
      gene_id : "ENSG00000275993.3",
      gene_type : "protein_coding",
      gene_name : "SIK1B",
      gene_level : 2,
      hgnc_id : "HGNC:52389",
      havana_gene : "OTTHUMG00000189394.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 6444869,
      stop : 6468040,
      direction : "-",
      ID : "ENSG00000274276.4",
      gene_id : "ENSG00000274276.4",
      gene_type : "protein_coding",
      gene_name : "CBSL",
      gene_level : 2,
      hgnc_id : "HGNC:51829",
      havana_gene : "OTTHUMG00000189375.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 6484623,
      stop : 6499261,
      direction : "-",
      ID : "ENSG00000275895.7",
      gene_id : "ENSG00000275895.7",
      gene_type : "protein_coding",
      gene_name : "U2AF1L5",
      gene_level : 2,
      hgnc_id : "HGNC:51830",
      havana_gene : "OTTHUMG00000189373.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 6560714,
      stop : 6564489,
      direction : "+",
      ID : "ENSG00000276076.4",
      gene_id : "ENSG00000276076.4",
      gene_type : "protein_coding",
      gene_name : "CRYAA2",
      gene_level : 2,
      hgnc_id : "HGNC:51901",
      havana_gene : "OTTHUMG00000189395.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 7744962,
      stop : 7777853,
      direction : "+",
      ID : "ENSG00000273590.4",
      gene_id : "ENSG00000273590.4",
      gene_type : "protein_coding",
      gene_name : "SMIM11B",
      gene_level : 2,
      hgnc_id : "HGNC:51846",
      havana_gene : "OTTHUMG00000189412.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 7768884,
      stop : 7770591,
      direction : "-",
      ID : "ENSG00000277277.3",
      gene_id : "ENSG00000277277.3",
      gene_type : "protein_coding",
      gene_name : "FAM243B",
      gene_level : 2,
      hgnc_id : "HGNC:53888",
      havana_gene : "OTTHUMG00000189500.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 7784482,
      stop : 7793954,
      direction : "-",
      ID : "ENSG00000278961.2",
      gene_id : "ENSG00000278961.2",
      gene_type : "protein_coding",
      gene_name : "SMIM34B",
      gene_level : 2,
      hgnc_id : "HGNC:53650",
      havana_gene : "OTTHUMG00000189413.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 7816675,
      stop : 7829926,
      direction : "-",
      ID : "ENSG00000276289.4",
      gene_id : "ENSG00000276289.4",
      gene_type : "protein_coding",
      gene_name : "KCNE1B",
      gene_level : 2,
      hgnc_id : "HGNC:52280",
      havana_gene : "OTTHUMG00000189416.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 10521553,
      stop : 10606140,
      direction : "+",
      ID : "ENSG00000274391.5",
      gene_id : "ENSG00000274391.5",
      gene_type : "protein_coding",
      gene_name : "TPTE",
      gene_level : 2,
      hgnc_id : "HGNC:12023",
      havana_gene : "OTTHUMG00000074127.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 13609858,
      stop : 13641585,
      direction : "+",
      ID : "ENSG00000166351.10",
      gene_id : "ENSG00000166351.10",
      gene_type : "protein_coding",
      gene_name : "POTED",
      gene_level : 2,
      hgnc_id : "HGNC:23822",
      havana_gene : "OTTHUMG00000074197.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 14108813,
      stop : 14210955,
      direction : "-",
      ID : "ENSG00000188992.12",
      gene_id : "ENSG00000188992.12",
      gene_type : "protein_coding",
      gene_name : "LIPI",
      gene_level : 2,
      hgnc_id : "HGNC:18821",
      havana_gene : "OTTHUMG00000074258.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 14216130,
      stop : 14228372,
      direction : "+",
      ID : "ENSG00000185272.14",
      gene_id : "ENSG00000185272.14",
      gene_type : "protein_coding",
      gene_name : "RBM11",
      gene_level : 2,
      hgnc_id : "HGNC:9897",
      havana_gene : "OTTHUMG00000074263.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 14371115,
      stop : 14383484,
      direction : "-",
      ID : "ENSG00000155304.6",
      gene_id : "ENSG00000155304.6",
      gene_type : "protein_coding",
      gene_name : "HSPA13",
      gene_level : 2,
      hgnc_id : "HGNC:11375",
      havana_gene : "OTTHUMG00000074261.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 14485228,
      stop : 14658821,
      direction : "-",
      ID : "ENSG00000155307.19",
      gene_id : "ENSG00000155307.19",
      gene_type : "protein_coding",
      gene_name : "SAMSN1",
      gene_level : 2,
      hgnc_id : "HGNC:10528",
      havana_gene : "OTTHUMG00000074317.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 14961235,
      stop : 15065936,
      direction : "-",
      ID : "ENSG00000180530.11",
      gene_id : "ENSG00000180530.11",
      gene_type : "protein_coding",
      gene_name : "NRIP1",
      gene_level : 2,
      hgnc_id : "HGNC:8001",
      havana_gene : "OTTHUMG00000074323.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 15730025,
      stop : 15880069,
      direction : "+",
      ID : "ENSG00000155313.15",
      gene_id : "ENSG00000155313.15",
      gene_type : "protein_coding",
      gene_name : "USP25",
      gene_level : 2,
      hgnc_id : "HGNC:12624",
      havana_gene : "OTTHUMG00000074343.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 17513043,
      stop : 17593579,
      direction : "+",
      ID : "ENSG00000154639.19",
      gene_id : "ENSG00000154639.19",
      gene_type : "protein_coding",
      gene_name : "CXADR",
      gene_level : 2,
      hgnc_id : "HGNC:2559",
      havana_gene : "OTTHUMG00000074508.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 17593653,
      stop : 17612945,
      direction : "-",
      ID : "ENSG00000154640.15",
      gene_id : "ENSG00000154640.15",
      gene_type : "protein_coding",
      gene_name : "BTG3",
      gene_level : 2,
      hgnc_id : "HGNC:1132",
      havana_gene : "OTTHUMG00000074501.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 17788974,
      stop : 17819386,
      direction : "-",
      ID : "ENSG00000154642.11",
      gene_id : "ENSG00000154642.11",
      gene_type : "protein_coding",
      gene_name : "C21orf91",
      gene_level : 1,
      hgnc_id : "HGNC:16459",
      havana_gene : "OTTHUMG00000074509.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 17901263,
      stop : 18267373,
      direction : "+",
      ID : "ENSG00000154645.14",
      gene_id : "ENSG00000154645.14",
      gene_type : "protein_coding",
      gene_name : "CHODL",
      gene_level : 2,
      hgnc_id : "HGNC:17807",
      havana_gene : "OTTHUMG00000074519.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 18269116,
      stop : 18485879,
      direction : "-",
      ID : "ENSG00000154646.9",
      gene_id : "ENSG00000154646.9",
      gene_type : "protein_coding",
      gene_name : "TMPRSS15",
      gene_level : 2,
      hgnc_id : "HGNC:9490",
      havana_gene : "OTTHUMG00000074518.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 20998409,
      stop : 21543329,
      direction : "+",
      ID : "ENSG00000154654.15",
      gene_id : "ENSG00000154654.15",
      gene_type : "protein_coding",
      gene_name : "NCAM2",
      gene_level : 2,
      hgnc_id : "HGNC:7657",
      havana_gene : "OTTHUMG00000078121.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 25585656,
      stop : 25607517,
      direction : "-",
      ID : "ENSG00000154719.14",
      gene_id : "ENSG00000154719.14",
      gene_type : "protein_coding",
      gene_name : "MRPL39",
      gene_level : 2,
      hgnc_id : "HGNC:14027",
      havana_gene : "OTTHUMG00000078371.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 25639258,
      stop : 25717562,
      direction : "+",
      ID : "ENSG00000154721.15",
      gene_id : "ENSG00000154721.15",
      gene_type : "protein_coding",
      gene_name : "JAM2",
      gene_level : 2,
      hgnc_id : "HGNC:14686",
      havana_gene : "OTTHUMG00000078441.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 25716503,
      stop : 25735673,
      direction : "-",
      ID : "ENSG00000154723.13",
      gene_id : "ENSG00000154723.13",
      gene_type : "protein_coding",
      gene_name : "ATP5PF",
      gene_level : 1,
      hgnc_id : "HGNC:847",
      havana_gene : "OTTHUMG00000078442.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 25734570,
      stop : 25772460,
      direction : "+",
      ID : "ENSG00000154727.11",
      gene_id : "ENSG00000154727.11",
      gene_type : "protein_coding",
      gene_name : "GABPA",
      gene_level : 1,
      hgnc_id : "HGNC:4071",
      havana_gene : "OTTHUMG00000078443.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 25880550,
      stop : 26171128,
      direction : "-",
      ID : "ENSG00000142192.21",
      gene_id : "ENSG00000142192.21",
      gene_type : "protein_coding",
      gene_name : "APP",
      gene_level : 1,
      hgnc_id : "HGNC:620",
      havana_gene : "OTTHUMG00000078438.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 26466209,
      stop : 26573286,
      direction : "-",
      ID : "ENSG00000166265.13",
      gene_id : "ENSG00000166265.13",
      gene_type : "protein_coding",
      gene_name : "CYYR1",
      gene_level : 1,
      hgnc_id : "HGNC:16274",
      havana_gene : "OTTHUMG00000078689.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 26835755,
      stop : 26845409,
      direction : "-",
      ID : "ENSG00000154734.16",
      gene_id : "ENSG00000154734.16",
      gene_type : "protein_coding",
      gene_name : "ADAMTS1",
      gene_level : 2,
      hgnc_id : "HGNC:217",
      havana_gene : "OTTHUMG00000078688.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 26917922,
      stop : 26967088,
      direction : "-",
      ID : "ENSG00000154736.6",
      gene_id : "ENSG00000154736.6",
      gene_type : "protein_coding",
      gene_name : "ADAMTS5",
      gene_level : 2,
      hgnc_id : "HGNC:221",
      havana_gene : "OTTHUMG00000078686.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 28872191,
      stop : 28885371,
      direction : "-",
      ID : "ENSG00000156239.12",
      gene_id : "ENSG00000156239.12",
      gene_type : "protein_coding",
      gene_name : "N6AMT1",
      gene_level : 2,
      hgnc_id : "HGNC:16021",
      havana_gene : "OTTHUMG00000078750.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 28928144,
      stop : 28992956,
      direction : "-",
      ID : "ENSG00000198862.14",
      gene_id : "ENSG00000198862.14",
      gene_type : "protein_coding",
      gene_name : "LTN1",
      gene_level : 1,
      hgnc_id : "HGNC:13082",
      havana_gene : "OTTHUMG00000078803.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 29004384,
      stop : 29019360,
      direction : "-",
      ID : "ENSG00000156253.7",
      gene_id : "ENSG00000156253.7",
      gene_type : "protein_coding",
      gene_name : "RWDD2B",
      gene_level : 2,
      hgnc_id : "HGNC:1302",
      havana_gene : "OTTHUMG00000078805.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 29024629,
      stop : 29054488,
      direction : "+",
      ID : "ENSG00000156256.15",
      gene_id : "ENSG00000156256.15",
      gene_type : "protein_coding",
      gene_name : "USP16",
      gene_level : 2,
      hgnc_id : "HGNC:12614",
      havana_gene : "OTTHUMG00000078802.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 29055805,
      stop : 29073797,
      direction : "-",
      ID : "ENSG00000156261.13",
      gene_id : "ENSG00000156261.13",
      gene_type : "protein_coding",
      gene_name : "CCT8",
      gene_level : 2,
      hgnc_id : "HGNC:1623",
      havana_gene : "OTTHUMG00000044595.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 29077471,
      stop : 29175889,
      direction : "+",
      ID : "ENSG00000156265.16",
      gene_id : "ENSG00000156265.16",
      gene_type : "protein_coding",
      gene_name : "MAP3K7CL",
      gene_level : 2,
      hgnc_id : "HGNC:16457",
      havana_gene : "OTTHUMG00000078806.8",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 29194071,
      stop : 29630751,
      direction : "+",
      ID : "ENSG00000156273.16",
      gene_id : "ENSG00000156273.16",
      gene_type : "protein_coding",
      gene_name : "BACH1",
      gene_level : 2,
      hgnc_id : "HGNC:935",
      havana_gene : "OTTHUMG00000078878.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 29536933,
      stop : 29940033,
      direction : "-",
      ID : "ENSG00000171189.17",
      gene_id : "ENSG00000171189.17",
      gene_type : "protein_coding",
      gene_name : "GRIK1",
      gene_level : 2,
      hgnc_id : "HGNC:4579",
      havana_gene : "OTTHUMG00000078879.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30165565,
      stop : 30166805,
      direction : "-",
      ID : "ENSG00000156282.5",
      gene_id : "ENSG00000156282.5",
      gene_type : "protein_coding",
      gene_name : "CLDN17",
      gene_level : 2,
      hgnc_id : "HGNC:2038",
      havana_gene : "OTTHUMG00000081873.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30214006,
      stop : 30216097,
      direction : "-",
      ID : "ENSG00000156284.6",
      gene_id : "ENSG00000156284.6",
      gene_type : "protein_coding",
      gene_name : "CLDN8",
      gene_level : 2,
      hgnc_id : "HGNC:2050",
      havana_gene : "OTTHUMG00000081872.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30281309,
      stop : 30282950,
      direction : "-",
      ID : "ENSG00000188694.6",
      gene_id : "ENSG00000188694.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP24-1",
      gene_level : 2,
      hgnc_id : "HGNC:33902",
      havana_gene : "OTTHUMG00000125483.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30289145,
      stop : 30289514,
      direction : "-",
      ID : "ENSG00000232263.1",
      gene_id : "ENSG00000232263.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP25-1",
      gene_level : 2,
      hgnc_id : "HGNC:34003",
      havana_gene : "OTTHUMG00000125482.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30319124,
      stop : 30320315,
      direction : "-",
      ID : "ENSG00000197683.5",
      gene_id : "ENSG00000197683.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP26-1",
      gene_level : 2,
      hgnc_id : "HGNC:33760",
      havana_gene : "OTTHUMG00000057766.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30337013,
      stop : 30337694,
      direction : "-",
      ID : "ENSG00000206107.2",
      gene_id : "ENSG00000206107.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP27-1",
      gene_level : 1,
      hgnc_id : "HGNC:33864",
      havana_gene : "OTTHUMG00000059577.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30348399,
      stop : 30348606,
      direction : "-",
      ID : "ENSG00000186980.7",
      gene_id : "ENSG00000186980.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP23-1",
      gene_level : 2,
      hgnc_id : "HGNC:18928",
      havana_gene : "OTTHUMG00000057792.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30371390,
      stop : 30372271,
      direction : "-",
      ID : "ENSG00000182816.9",
      gene_id : "ENSG00000182816.9",
      gene_type : "protein_coding",
      gene_name : "KRTAP13-2",
      gene_level : 2,
      hgnc_id : "HGNC:18923",
      havana_gene : "OTTHUMG00000057793.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30396031,
      stop : 30396822,
      direction : "+",
      ID : "ENSG00000198390.5",
      gene_id : "ENSG00000198390.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP13-1",
      gene_level : 2,
      hgnc_id : "HGNC:18924",
      havana_gene : "OTTHUMG00000057800.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30425265,
      stop : 30425968,
      direction : "-",
      ID : "ENSG00000240432.3",
      gene_id : "ENSG00000240432.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP13-3",
      gene_level : 2,
      hgnc_id : "HGNC:18925",
      havana_gene : "OTTHUMG00000057776.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30430230,
      stop : 30431026,
      direction : "+",
      ID : "ENSG00000186971.3",
      gene_id : "ENSG00000186971.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP13-4",
      gene_level : 2,
      hgnc_id : "HGNC:18926",
      havana_gene : "OTTHUMG00000057770.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30440275,
      stop : 30440945,
      direction : "+",
      ID : "ENSG00000186970.4",
      gene_id : "ENSG00000186970.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP15-1",
      gene_level : 2,
      hgnc_id : "HGNC:18927",
      havana_gene : "OTTHUMG00000057784.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30479706,
      stop : 30480367,
      direction : "-",
      ID : "ENSG00000184351.8",
      gene_id : "ENSG00000184351.8",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-1",
      gene_level : 2,
      hgnc_id : "HGNC:18936",
      havana_gene : "OTTHUMG00000057768.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30487043,
      stop : 30487436,
      direction : "-",
      ID : "ENSG00000186965.5",
      gene_id : "ENSG00000186965.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-2",
      gene_level : 2,
      hgnc_id : "HGNC:18937",
      havana_gene : "OTTHUMG00000057772.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30491462,
      stop : 30492013,
      direction : "-",
      ID : "ENSG00000244025.5",
      gene_id : "ENSG00000244025.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-3",
      gene_level : 2,
      hgnc_id : "HGNC:18938",
      havana_gene : "OTTHUMG00000057782.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30496824,
      stop : 30497165,
      direction : "-",
      ID : "ENSG00000186967.7",
      gene_id : "ENSG00000186967.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-4",
      gene_level : 2,
      hgnc_id : "HGNC:18939",
      havana_gene : "OTTHUMG00000057767.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30501657,
      stop : 30502141,
      direction : "-",
      ID : "ENSG00000186977.3",
      gene_id : "ENSG00000186977.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-5",
      gene_level : 2,
      hgnc_id : "HGNC:18940",
      havana_gene : "OTTHUMG00000057774.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30541535,
      stop : 30541864,
      direction : "-",
      ID : "ENSG00000186925.6",
      gene_id : "ENSG00000186925.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-6",
      gene_level : 2,
      hgnc_id : "HGNC:18941",
      havana_gene : "OTTHUMG00000057779.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30560875,
      stop : 30561314,
      direction : "-",
      ID : "ENSG00000244362.3",
      gene_id : "ENSG00000244362.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-7",
      gene_level : 2,
      hgnc_id : "HGNC:18942",
      havana_gene : "OTTHUMG00000057785.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30590105,
      stop : 30590397,
      direction : "-",
      ID : "ENSG00000206106.2",
      gene_id : "ENSG00000206106.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP22-2",
      gene_level : 2,
      hgnc_id : "HGNC:37091",
      havana_gene : "OTTHUMG00000065630.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30592440,
      stop : 30593075,
      direction : "+",
      ID : "ENSG00000212938.3",
      gene_id : "ENSG00000212938.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP6-3",
      gene_level : 2,
      hgnc_id : "HGNC:18933",
      havana_gene : "OTTHUMG00000057791.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30598590,
      stop : 30598902,
      direction : "-",
      ID : "ENSG00000186930.4",
      gene_id : "ENSG00000186930.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP6-2",
      gene_level : 2,
      hgnc_id : "HGNC:18932",
      havana_gene : "OTTHUMG00000057794.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30601087,
      stop : 30601382,
      direction : "+",
      ID : "ENSG00000186924.3",
      gene_id : "ENSG00000186924.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP22-1",
      gene_level : 2,
      hgnc_id : "HGNC:18947",
      havana_gene : "OTTHUMG00000057778.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30613431,
      stop : 30613930,
      direction : "-",
      ID : "ENSG00000184724.5",
      gene_id : "ENSG00000184724.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP6-1",
      gene_level : 2,
      hgnc_id : "HGNC:18931",
      havana_gene : "OTTHUMG00000057788.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30616425,
      stop : 30616699,
      direction : "+",
      ID : "ENSG00000244624.3",
      gene_id : "ENSG00000244624.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP20-1",
      gene_level : 2,
      hgnc_id : "HGNC:18943",
      havana_gene : "OTTHUMG00000057801.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30620627,
      stop : 30620850,
      direction : "+",
      ID : "ENSG00000206105.2",
      gene_id : "ENSG00000206105.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP20-4",
      gene_level : 1,
      hgnc_id : "HGNC:34002",
      havana_gene : "OTTHUMG00000125519.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30635206,
      stop : 30635619,
      direction : "+",
      ID : "ENSG00000184032.3",
      gene_id : "ENSG00000184032.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP20-2",
      gene_level : 2,
      hgnc_id : "HGNC:18944",
      havana_gene : "OTTHUMG00000057786.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30642864,
      stop : 30643136,
      direction : "+",
      ID : "ENSG00000206104.2",
      gene_id : "ENSG00000206104.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP20-3",
      gene_level : 2,
      hgnc_id : "HGNC:34001",
      havana_gene : "OTTHUMG00000057798.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30718525,
      stop : 30718777,
      direction : "-",
      ID : "ENSG00000231068.1",
      gene_id : "ENSG00000231068.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP21-3",
      gene_level : 2,
      hgnc_id : "HGNC:34216",
      havana_gene : "OTTHUMG00000125533.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30746794,
      stop : 30747259,
      direction : "-",
      ID : "ENSG00000187026.3",
      gene_id : "ENSG00000187026.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP21-2",
      gene_level : 2,
      hgnc_id : "HGNC:18946",
      havana_gene : "OTTHUMG00000057769.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30755015,
      stop : 30755428,
      direction : "-",
      ID : "ENSG00000187005.5",
      gene_id : "ENSG00000187005.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP21-1",
      gene_level : 2,
      hgnc_id : "HGNC:18945",
      havana_gene : "OTTHUMG00000057777.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30812697,
      stop : 30813274,
      direction : "-",
      ID : "ENSG00000183640.6",
      gene_id : "ENSG00000183640.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP8-1",
      gene_level : 2,
      hgnc_id : "HGNC:18935",
      havana_gene : "OTTHUMG00000057771.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30829039,
      stop : 30829759,
      direction : "-",
      ID : "ENSG00000274749.1",
      gene_id : "ENSG00000274749.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP7-1",
      gene_level : 2,
      hgnc_id : "HGNC:18934",
      havana_gene : "OTTHUMG00000188305.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 30880644,
      stop : 30881580,
      direction : "-",
      ID : "ENSG00000182591.6",
      gene_id : "ENSG00000182591.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP11-1",
      gene_level : 2,
      hgnc_id : "HGNC:18922",
      havana_gene : "OTTHUMG00000057773.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 31038159,
      stop : 31038476,
      direction : "-",
      ID : "ENSG00000206102.2",
      gene_id : "ENSG00000206102.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP19-8",
      gene_level : 1,
      hgnc_id : "HGNC:33898",
      havana_gene : "OTTHUMG00000057787.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 31118416,
      stop : 31559977,
      direction : "-",
      ID : "ENSG00000156299.13",
      gene_id : "ENSG00000156299.13",
      gene_type : "protein_coding",
      gene_name : "TIAM1",
      gene_level : 1,
      hgnc_id : "HGNC:11805",
      havana_gene : "OTTHUMG00000084869.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 31659666,
      stop : 31668931,
      direction : "+",
      ID : "ENSG00000142168.15",
      gene_id : "ENSG00000142168.15",
      gene_type : "protein_coding",
      gene_name : "SOD1",
      gene_level : 2,
      hgnc_id : "HGNC:11179",
      havana_gene : "OTTHUMG00000084878.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 31671000,
      stop : 31732118,
      direction : "-",
      ID : "ENSG00000156304.15",
      gene_id : "ENSG00000156304.15",
      gene_type : "protein_coding",
      gene_name : "SCAF4",
      gene_level : 2,
      hgnc_id : "HGNC:19304",
      havana_gene : "OTTHUMG00000084903.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 31873020,
      stop : 32044633,
      direction : "+",
      ID : "ENSG00000142149.9",
      gene_id : "ENSG00000142149.9",
      gene_type : "protein_coding",
      gene_name : "HUNK",
      gene_level : 2,
      hgnc_id : "HGNC:13326",
      havana_gene : "OTTHUMG00000085019.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32268228,
      stop : 32279049,
      direction : "-",
      ID : "ENSG00000159055.4",
      gene_id : "ENSG00000159055.4",
      gene_type : "protein_coding",
      gene_name : "MIS18A",
      gene_level : 2,
      hgnc_id : "HGNC:1286",
      havana_gene : "OTTHUMG00000085308.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32291813,
      stop : 32314784,
      direction : "+",
      ID : "ENSG00000170262.13",
      gene_id : "ENSG00000170262.13",
      gene_type : "protein_coding",
      gene_name : "MRAP",
      gene_level : 2,
      hgnc_id : "HGNC:1304",
      havana_gene : "OTTHUMG00000085309.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32311018,
      stop : 32393012,
      direction : "-",
      ID : "ENSG00000142207.7",
      gene_id : "ENSG00000142207.7",
      gene_type : "protein_coding",
      gene_name : "URB1",
      gene_level : 1,
      hgnc_id : "HGNC:17344",
      havana_gene : "OTTHUMG00000064919.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32402511,
      stop : 32612865,
      direction : "-",
      ID : "ENSG00000265590.10",
      gene_id : "ENSG00000265590.10",
      gene_type : "protein_coding",
      gene_name : "CFAP298-TCP10L",
      gene_level : 2,
      hgnc_id : "HGNC:54636",
      havana_gene : "OTTHUMG00000064928.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32412006,
      stop : 32515397,
      direction : "+",
      ID : "ENSG00000166979.13",
      gene_id : "ENSG00000166979.13",
      gene_type : "protein_coding",
      gene_name : "EVA1C",
      gene_level : 2,
      hgnc_id : "HGNC:13239",
      havana_gene : "OTTHUMG00000064922.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32497967,
      stop : 32587373,
      direction : "-",
      ID : "ENSG00000242220.9",
      gene_id : "ENSG00000242220.9",
      gene_type : "protein_coding",
      gene_name : "TCP10L",
      gene_level : 1,
      hgnc_id : "HGNC:11657",
      havana_gene : "OTTHUMG00000064901.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32592079,
      stop : 32612603,
      direction : "-",
      ID : "ENSG00000159079.19",
      gene_id : "ENSG00000159079.19",
      gene_type : "protein_coding",
      gene_name : "CFAP298",
      gene_level : 1,
      hgnc_id : "HGNC:1301",
      havana_gene : "OTTHUMG00000179510.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32628759,
      stop : 32728040,
      direction : "-",
      ID : "ENSG00000159082.18",
      gene_id : "ENSG00000159082.18",
      gene_type : "protein_coding",
      gene_name : "SYNJ1",
      gene_level : 1,
      hgnc_id : "HGNC:11503",
      havana_gene : "OTTHUMG00000064926.17",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32733899,
      stop : 32771792,
      direction : "-",
      ID : "ENSG00000159086.15",
      gene_id : "ENSG00000159086.15",
      gene_type : "protein_coding",
      gene_name : "PAXBP1",
      gene_level : 1,
      hgnc_id : "HGNC:13579",
      havana_gene : "OTTHUMG00000064980.9",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 32790673,
      stop : 32813743,
      direction : "-",
      ID : "ENSG00000205929.11",
      gene_id : "ENSG00000205929.11",
      gene_type : "protein_coding",
      gene_name : "C21orf62",
      gene_level : 1,
      hgnc_id : "HGNC:1305",
      havana_gene : "OTTHUMG00000163477.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33025935,
      stop : 33029196,
      direction : "+",
      ID : "ENSG00000205927.5",
      gene_id : "ENSG00000205927.5",
      gene_type : "protein_coding",
      gene_name : "OLIG2",
      gene_level : 2,
      hgnc_id : "HGNC:9398",
      havana_gene : "OTTHUMG00000065032.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33070141,
      stop : 33072413,
      direction : "+",
      ID : "ENSG00000184221.13",
      gene_id : "ENSG00000184221.13",
      gene_type : "protein_coding",
      gene_name : "OLIG1",
      gene_level : 2,
      hgnc_id : "HGNC:16983",
      havana_gene : "OTTHUMG00000065064.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33229901,
      stop : 33265675,
      direction : "+",
      ID : "ENSG00000159110.20",
      gene_id : "ENSG00000159110.20",
      gene_type : "protein_coding",
      gene_name : "IFNAR2",
      gene_level : 2,
      hgnc_id : "HGNC:5433",
      havana_gene : "OTTHUMG00000065127.39",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33229901,
      stop : 33297160,
      direction : "+",
      ID : "ENSG00000249624.9",
      gene_id : "ENSG00000249624.9",
      gene_type : "protein_coding",
      gene_name : "AP000295.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162031.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33266367,
      stop : 33310187,
      direction : "+",
      ID : "ENSG00000243646.10",
      gene_id : "ENSG00000243646.10",
      gene_type : "protein_coding",
      gene_name : "IL10RB",
      gene_level : 2,
      hgnc_id : "HGNC:5965",
      havana_gene : "OTTHUMG00000065128.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33324429,
      stop : 33359864,
      direction : "+",
      ID : "ENSG00000142166.13",
      gene_id : "ENSG00000142166.13",
      gene_type : "protein_coding",
      gene_name : "IFNAR1",
      gene_level : 2,
      hgnc_id : "HGNC:5432",
      havana_gene : "OTTHUMG00000065126.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33403413,
      stop : 33479348,
      direction : "+",
      ID : "ENSG00000159128.15",
      gene_id : "ENSG00000159128.15",
      gene_type : "protein_coding",
      gene_name : "IFNGR2",
      gene_level : 2,
      hgnc_id : "HGNC:5440",
      havana_gene : "OTTHUMG00000065188.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33432485,
      stop : 33479974,
      direction : "-",
      ID : "ENSG00000142188.17",
      gene_id : "ENSG00000142188.17",
      gene_type : "protein_coding",
      gene_name : "TMEM50B",
      gene_level : 2,
      hgnc_id : "HGNC:1280",
      havana_gene : "OTTHUMG00000065286.13",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33485530,
      stop : 33491716,
      direction : "-",
      ID : "ENSG00000177692.12",
      gene_id : "ENSG00000177692.12",
      gene_type : "protein_coding",
      gene_name : "DNAJC28",
      gene_level : 2,
      hgnc_id : "HGNC:1297",
      havana_gene : "OTTHUMG00000065531.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33503931,
      stop : 33543491,
      direction : "-",
      ID : "ENSG00000159131.17",
      gene_id : "ENSG00000159131.17",
      gene_type : "protein_coding",
      gene_name : "GART",
      gene_level : 2,
      hgnc_id : "HGNC:4163",
      havana_gene : "OTTHUMG00000065628.26",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33543038,
      stop : 33577481,
      direction : "+",
      ID : "ENSG00000159140.21",
      gene_id : "ENSG00000159140.21",
      gene_type : "protein_coding",
      gene_name : "SON",
      gene_level : 1,
      hgnc_id : "HGNC:11183",
      havana_gene : "OTTHUMG00000065806.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33559542,
      stop : 33588706,
      direction : "-",
      ID : "ENSG00000159147.18",
      gene_id : "ENSG00000159147.18",
      gene_type : "protein_coding",
      gene_name : "DONSON",
      gene_level : 1,
      hgnc_id : "HGNC:2993",
      havana_gene : "OTTHUMG00000065904.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33584687,
      stop : 33931607,
      direction : "-",
      ID : "ENSG00000249209.2",
      gene_id : "ENSG00000249209.2",
      gene_type : "protein_coding",
      gene_name : "AP000311.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000162259.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33589341,
      stop : 33643926,
      direction : "-",
      ID : "ENSG00000205758.12",
      gene_id : "ENSG00000205758.12",
      gene_type : "protein_coding",
      gene_name : "CRYZL1",
      gene_level : 1,
      hgnc_id : "HGNC:2420",
      havana_gene : "OTTHUMG00000065954.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33642400,
      stop : 33899861,
      direction : "+",
      ID : "ENSG00000205726.15",
      gene_id : "ENSG00000205726.15",
      gene_type : "protein_coding",
      gene_name : "ITSN1",
      gene_level : 1,
      hgnc_id : "HGNC:6183",
      havana_gene : "OTTHUMG00000065284.34",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 33903453,
      stop : 33915814,
      direction : "-",
      ID : "ENSG00000241837.7",
      gene_id : "ENSG00000241837.7",
      gene_type : "protein_coding",
      gene_name : "ATP5PO",
      gene_level : 1,
      hgnc_id : "HGNC:850",
      havana_gene : "OTTHUMG00000065186.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34073224,
      stop : 34143034,
      direction : "+",
      ID : "ENSG00000243927.6",
      gene_id : "ENSG00000243927.6",
      gene_type : "protein_coding",
      gene_name : "MRPS6",
      gene_level : 2,
      hgnc_id : "HGNC:14051",
      havana_gene : "OTTHUMG00000065820.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34073578,
      stop : 34106260,
      direction : "+",
      ID : "ENSG00000198743.7",
      gene_id : "ENSG00000198743.7",
      gene_type : "protein_coding",
      gene_name : "SLC5A3",
      gene_level : 2,
      hgnc_id : "HGNC:11038",
      havana_gene : "OTTHUMG00000065821.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34364006,
      stop : 34371381,
      direction : "+",
      ID : "ENSG00000159197.4",
      gene_id : "ENSG00000159197.4",
      gene_type : "protein_coding",
      gene_name : "KCNE2",
      gene_level : 2,
      hgnc_id : "HGNC:6242",
      havana_gene : "OTTHUMG00000086189.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34375480,
      stop : 34416961,
      direction : "+",
      ID : "ENSG00000205670.12",
      gene_id : "ENSG00000205670.12",
      gene_type : "protein_coding",
      gene_name : "SMIM11A",
      gene_level : 1,
      hgnc_id : "HGNC:1293",
      havana_gene : "OTTHUMG00000086193.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34400112,
      stop : 34401072,
      direction : "-",
      ID : "ENSG00000222018.2",
      gene_id : "ENSG00000222018.2",
      gene_type : "protein_coding",
      gene_name : "FAM243A",
      gene_level : 2,
      hgnc_id : "HGNC:39602",
      havana_gene : "OTTHUMG00000154291.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34418715,
      stop : 34423951,
      direction : "-",
      ID : "ENSG00000243627.5",
      gene_id : "ENSG00000243627.5",
      gene_type : "protein_coding",
      gene_name : "SMIM34A",
      gene_level : 1,
      hgnc_id : "HGNC:39601",
      havana_gene : "OTTHUMG00000153030.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34446688,
      stop : 34512210,
      direction : "-",
      ID : "ENSG00000180509.12",
      gene_id : "ENSG00000180509.12",
      gene_type : "protein_coding",
      gene_name : "KCNE1",
      gene_level : 2,
      hgnc_id : "HGNC:6240",
      havana_gene : "OTTHUMG00000086236.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34513142,
      stop : 34615113,
      direction : "-",
      ID : "ENSG00000159200.18",
      gene_id : "ENSG00000159200.18",
      gene_type : "protein_coding",
      gene_name : "RCAN1",
      gene_level : 1,
      hgnc_id : "HGNC:3040",
      havana_gene : "OTTHUMG00000086235.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34668994,
      stop : 34718227,
      direction : "+",
      ID : "ENSG00000159212.13",
      gene_id : "ENSG00000159212.13",
      gene_type : "protein_coding",
      gene_name : "CLIC6",
      gene_level : 2,
      hgnc_id : "HGNC:2065",
      havana_gene : "OTTHUMG00000086237.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 34787801,
      stop : 36004667,
      direction : "-",
      ID : "ENSG00000159216.19",
      gene_id : "ENSG00000159216.19",
      gene_type : "protein_coding",
      gene_name : "RUNX1",
      gene_level : 1,
      hgnc_id : "HGNC:10471",
      havana_gene : "OTTHUMG00000086299.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36034541,
      stop : 36079389,
      direction : "-",
      ID : "ENSG00000185917.14",
      gene_id : "ENSG00000185917.14",
      gene_type : "protein_coding",
      gene_name : "SETD4",
      gene_level : 2,
      hgnc_id : "HGNC:1258",
      havana_gene : "OTTHUMG00000086483.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36069941,
      stop : 36073166,
      direction : "+",
      ID : "ENSG00000159228.13",
      gene_id : "ENSG00000159228.13",
      gene_type : "protein_coding",
      gene_name : "CBR1",
      gene_level : 1,
      hgnc_id : "HGNC:1548",
      havana_gene : "OTTHUMG00000086618.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36135079,
      stop : 36146562,
      direction : "+",
      ID : "ENSG00000159231.6",
      gene_id : "ENSG00000159231.6",
      gene_type : "protein_coding",
      gene_name : "CBR3",
      gene_level : 2,
      hgnc_id : "HGNC:1549",
      havana_gene : "OTTHUMG00000086617.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36156782,
      stop : 36294274,
      direction : "+",
      ID : "ENSG00000142197.12",
      gene_id : "ENSG00000142197.12",
      gene_type : "protein_coding",
      gene_name : "DOP1B",
      gene_level : 2,
      hgnc_id : "HGNC:1291",
      havana_gene : "OTTHUMG00000086619.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36320189,
      stop : 36386148,
      direction : "+",
      ID : "ENSG00000159256.13",
      gene_id : "ENSG00000159256.13",
      gene_type : "protein_coding",
      gene_name : "MORC3",
      gene_level : 1,
      hgnc_id : "HGNC:23572",
      havana_gene : "OTTHUMG00000086620.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36385392,
      stop : 36419015,
      direction : "+",
      ID : "ENSG00000159259.8",
      gene_id : "ENSG00000159259.8",
      gene_type : "protein_coding",
      gene_name : "CHAF1B",
      gene_level : 2,
      hgnc_id : "HGNC:1911",
      havana_gene : "OTTHUMG00000086606.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36460621,
      stop : 36576569,
      direction : "-",
      ID : "ENSG00000159261.12",
      gene_id : "ENSG00000159261.12",
      gene_type : "protein_coding",
      gene_name : "CLDN14",
      gene_level : 2,
      hgnc_id : "HGNC:2035",
      havana_gene : "OTTHUMG00000086638.2",
      tag : "retrogene"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36699115,
      stop : 36749917,
      direction : "+",
      ID : "ENSG00000159263.16",
      gene_id : "ENSG00000159263.16",
      gene_type : "protein_coding",
      gene_name : "SIM2",
      gene_level : 2,
      hgnc_id : "HGNC:10883",
      havana_gene : "OTTHUMG00000086637.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 36748626,
      stop : 36990236,
      direction : "-",
      ID : "ENSG00000159267.16",
      gene_id : "ENSG00000159267.16",
      gene_type : "protein_coding",
      gene_name : "HLCS",
      gene_level : 2,
      hgnc_id : "HGNC:4976",
      havana_gene : "OTTHUMG00000086636.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 37006150,
      stop : 37019662,
      direction : "+",
      ID : "ENSG00000183145.9",
      gene_id : "ENSG00000183145.9",
      gene_type : "protein_coding",
      gene_name : "RIPPLY3",
      gene_level : 2,
      hgnc_id : "HGNC:3047",
      havana_gene : "OTTHUMG00000086639.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 37062846,
      stop : 37073170,
      direction : "-",
      ID : "ENSG00000185808.14",
      gene_id : "ENSG00000185808.14",
      gene_type : "protein_coding",
      gene_name : "PIGP",
      gene_level : 2,
      hgnc_id : "HGNC:3046",
      havana_gene : "OTTHUMG00000086653.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 37073226,
      stop : 37203112,
      direction : "+",
      ID : "ENSG00000182670.13",
      gene_id : "ENSG00000182670.13",
      gene_type : "protein_coding",
      gene_name : "TTC3",
      gene_level : 1,
      hgnc_id : "HGNC:12393",
      havana_gene : "OTTHUMG00000086654.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 37223420,
      stop : 37267919,
      direction : "-",
      ID : "ENSG00000157538.14",
      gene_id : "ENSG00000157538.14",
      gene_type : "protein_coding",
      gene_name : "VPS26C",
      gene_level : 1,
      hgnc_id : "HGNC:3044",
      havana_gene : "OTTHUMG00000086659.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 37365573,
      stop : 37526358,
      direction : "+",
      ID : "ENSG00000157540.22",
      gene_id : "ENSG00000157540.22",
      gene_type : "protein_coding",
      gene_name : "DYRK1A",
      gene_level : 2,
      hgnc_id : "HGNC:3091",
      havana_gene : "OTTHUMG00000086657.9",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 37607373,
      stop : 38121345,
      direction : "-",
      ID : "ENSG00000157542.11",
      gene_id : "ENSG00000157542.11",
      gene_type : "protein_coding",
      gene_name : "KCNJ6",
      gene_level : 2,
      hgnc_id : "HGNC:6267",
      havana_gene : "OTTHUMG00000086667.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 38155549,
      stop : 38307357,
      direction : "+",
      ID : "ENSG00000157551.19",
      gene_id : "ENSG00000157551.19",
      gene_type : "protein_coding",
      gene_name : "KCNJ15",
      gene_level : 2,
      hgnc_id : "HGNC:6261",
      havana_gene : "OTTHUMG00000090609.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 38380027,
      stop : 38661780,
      direction : "-",
      ID : "ENSG00000157554.19",
      gene_id : "ENSG00000157554.19",
      gene_type : "protein_coding",
      gene_name : "ERG",
      gene_level : 2,
      hgnc_id : "HGNC:3446",
      havana_gene : "OTTHUMG00000090767.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 38805183,
      stop : 38824955,
      direction : "+",
      ID : "ENSG00000157557.13",
      gene_id : "ENSG00000157557.13",
      gene_type : "protein_coding",
      gene_name : "ETS2",
      gene_level : 2,
      hgnc_id : "HGNC:3489",
      havana_gene : "OTTHUMG00000090769.8",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39174769,
      stop : 39183488,
      direction : "-",
      ID : "ENSG00000183527.12",
      gene_id : "ENSG00000183527.12",
      gene_type : "protein_coding",
      gene_name : "PSMG1",
      gene_level : 2,
      hgnc_id : "HGNC:3043",
      havana_gene : "OTTHUMG00000066034.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39184176,
      stop : 39321559,
      direction : "-",
      ID : "ENSG00000185658.14",
      gene_id : "ENSG00000185658.14",
      gene_type : "protein_coding",
      gene_name : "BRWD1",
      gene_level : 1,
      hgnc_id : "HGNC:12760",
      havana_gene : "OTTHUMG00000066030.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39342315,
      stop : 39349647,
      direction : "-",
      ID : "ENSG00000205581.11",
      gene_id : "ENSG00000205581.11",
      gene_type : "protein_coding",
      gene_name : "HMGN1",
      gene_level : 2,
      hgnc_id : "HGNC:4984",
      havana_gene : "OTTHUMG00000066178.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39377698,
      stop : 39428528,
      direction : "+",
      ID : "ENSG00000182093.16",
      gene_id : "ENSG00000182093.16",
      gene_type : "protein_coding",
      gene_name : "GET1",
      gene_level : 1,
      hgnc_id : "HGNC:12790",
      havana_gene : "OTTHUMG00000066250.22",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39380332,
      stop : 39515506,
      direction : "+",
      ID : "ENSG00000285815.1",
      gene_id : "ENSG00000285815.1",
      gene_type : "protein_coding",
      gene_name : "GET1-SH3BGR",
      gene_level : 2,
      hgnc_id : "HGNC:54635",
      havana_gene : "OTTHUMG00000192633.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39405728,
      stop : 39445805,
      direction : "-",
      ID : "ENSG00000157578.14",
      gene_id : "ENSG00000157578.14",
      gene_type : "protein_coding",
      gene_name : "LCA5L",
      gene_level : 2,
      hgnc_id : "HGNC:1255",
      havana_gene : "OTTHUMG00000066280.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39445855,
      stop : 39515506,
      direction : "+",
      ID : "ENSG00000185437.14",
      gene_id : "ENSG00000185437.14",
      gene_type : "protein_coding",
      gene_name : "SH3BGR",
      gene_level : 1,
      hgnc_id : "HGNC:10822",
      havana_gene : "OTTHUMG00000074113.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39556442,
      stop : 39673137,
      direction : "+",
      ID : "ENSG00000183778.17",
      gene_id : "ENSG00000183778.17",
      gene_type : "protein_coding",
      gene_name : "B3GALT5",
      gene_level : 2,
      hgnc_id : "HGNC:920",
      havana_gene : "OTTHUMG00000086725.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39745407,
      stop : 39802096,
      direction : "+",
      ID : "ENSG00000183067.5",
      gene_id : "ENSG00000183067.5",
      gene_type : "protein_coding",
      gene_name : "IGSF5",
      gene_level : 2,
      hgnc_id : "HGNC:5952",
      havana_gene : "OTTHUMG00000086724.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 39867438,
      stop : 39929397,
      direction : "+",
      ID : "ENSG00000183036.11",
      gene_id : "ENSG00000183036.11",
      gene_type : "protein_coding",
      gene_name : "PCP4",
      gene_level : 2,
      hgnc_id : "HGNC:8742",
      havana_gene : "OTTHUMG00000086731.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 40010999,
      stop : 40847158,
      direction : "-",
      ID : "ENSG00000171587.15",
      gene_id : "ENSG00000171587.15",
      gene_type : "protein_coding",
      gene_name : "DSCAM",
      gene_level : 1,
      hgnc_id : "HGNC:3039",
      havana_gene : "OTTHUMG00000086732.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41167801,
      stop : 41282530,
      direction : "+",
      ID : "ENSG00000182240.16",
      gene_id : "ENSG00000182240.16",
      gene_type : "protein_coding",
      gene_name : "BACE2",
      gene_level : 2,
      hgnc_id : "HGNC:934",
      havana_gene : "OTTHUMG00000086742.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41304212,
      stop : 41357727,
      direction : "+",
      ID : "ENSG00000183844.17",
      gene_id : "ENSG00000183844.17",
      gene_type : "protein_coding",
      gene_name : "FAM3B",
      gene_level : 2,
      hgnc_id : "HGNC:1253",
      havana_gene : "OTTHUMG00000086752.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41361999,
      stop : 41409393,
      direction : "+",
      ID : "ENSG00000183486.14",
      gene_id : "ENSG00000183486.14",
      gene_type : "protein_coding",
      gene_name : "MX2",
      gene_level : 1,
      hgnc_id : "HGNC:7533",
      havana_gene : "OTTHUMG00000086753.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41420020,
      stop : 41470071,
      direction : "+",
      ID : "ENSG00000157601.15",
      gene_id : "ENSG00000157601.15",
      gene_type : "protein_coding",
      gene_name : "MX1",
      gene_level : 2,
      hgnc_id : "HGNC:7532",
      havana_gene : "OTTHUMG00000086755.8",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41464300,
      stop : 41531116,
      direction : "-",
      ID : "ENSG00000184012.14",
      gene_id : "ENSG00000184012.14",
      gene_type : "protein_coding",
      gene_name : "TMPRSS2",
      gene_level : 2,
      hgnc_id : "HGNC:11876",
      havana_gene : "OTTHUMG00000086762.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41739369,
      stop : 41767089,
      direction : "-",
      ID : "ENSG00000183421.12",
      gene_id : "ENSG00000183421.12",
      gene_type : "protein_coding",
      gene_name : "RIPK4",
      gene_level : 2,
      hgnc_id : "HGNC:496",
      havana_gene : "OTTHUMG00000086770.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41798225,
      stop : 41879482,
      direction : "-",
      ID : "ENSG00000141956.14",
      gene_id : "ENSG00000141956.14",
      gene_type : "protein_coding",
      gene_name : "PRDM15",
      gene_level : 2,
      hgnc_id : "HGNC:13999",
      havana_gene : "OTTHUMG00000086781.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41885112,
      stop : 41954018,
      direction : "-",
      ID : "ENSG00000157617.17",
      gene_id : "ENSG00000157617.17",
      gene_type : "protein_coding",
      gene_name : "C2CD2",
      gene_level : 2,
      hgnc_id : "HGNC:1266",
      havana_gene : "OTTHUMG00000086779.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 41986831,
      stop : 42010387,
      direction : "-",
      ID : "ENSG00000173276.14",
      gene_id : "ENSG00000173276.14",
      gene_type : "protein_coding",
      gene_name : "ZBTB21",
      gene_level : 1,
      hgnc_id : "HGNC:13083",
      havana_gene : "OTTHUMG00000086789.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42062959,
      stop : 42143453,
      direction : "+",
      ID : "ENSG00000177398.18",
      gene_id : "ENSG00000177398.18",
      gene_type : "protein_coding",
      gene_name : "UMODL1",
      gene_level : 2,
      hgnc_id : "HGNC:12560",
      havana_gene : "OTTHUMG00000086788.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42199689,
      stop : 42297244,
      direction : "+",
      ID : "ENSG00000160179.19",
      gene_id : "ENSG00000160179.19",
      gene_type : "protein_coding",
      gene_name : "ABCG1",
      gene_level : 1,
      hgnc_id : "HGNC:73",
      havana_gene : "OTTHUMG00000086791.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42311667,
      stop : 42315651,
      direction : "-",
      ID : "ENSG00000160180.16",
      gene_id : "ENSG00000160180.16",
      gene_type : "protein_coding",
      gene_name : "TFF3",
      gene_level : 2,
      hgnc_id : "HGNC:11757",
      havana_gene : "OTTHUMG00000086798.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42346357,
      stop : 42350997,
      direction : "-",
      ID : "ENSG00000160181.9",
      gene_id : "ENSG00000160181.9",
      gene_type : "protein_coding",
      gene_name : "TFF2",
      gene_level : 2,
      hgnc_id : "HGNC:11756",
      havana_gene : "OTTHUMG00000086797.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42362282,
      stop : 42366535,
      direction : "-",
      ID : "ENSG00000160182.3",
      gene_id : "ENSG00000160182.3",
      gene_type : "protein_coding",
      gene_name : "TFF1",
      gene_level : 2,
      hgnc_id : "HGNC:11755",
      havana_gene : "OTTHUMG00000086799.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42371887,
      stop : 42396091,
      direction : "-",
      ID : "ENSG00000160183.17",
      gene_id : "ENSG00000160183.17",
      gene_type : "protein_coding",
      gene_name : "TMPRSS3",
      gene_level : 2,
      hgnc_id : "HGNC:11877",
      havana_gene : "OTTHUMG00000086796.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42403447,
      stop : 42447684,
      direction : "+",
      ID : "ENSG00000160185.15",
      gene_id : "ENSG00000160185.15",
      gene_type : "protein_coding",
      gene_name : "UBASH3A",
      gene_level : 2,
      hgnc_id : "HGNC:12462",
      havana_gene : "OTTHUMG00000086805.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42472486,
      stop : 42496246,
      direction : "-",
      ID : "ENSG00000160188.10",
      gene_id : "ENSG00000160188.10",
      gene_type : "protein_coding",
      gene_name : "RSPH1",
      gene_level : 2,
      hgnc_id : "HGNC:12371",
      havana_gene : "OTTHUMG00000086804.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42496008,
      stop : 42581440,
      direction : "+",
      ID : "ENSG00000160190.14",
      gene_id : "ENSG00000160190.14",
      gene_type : "protein_coding",
      gene_name : "SLC37A1",
      gene_level : 2,
      hgnc_id : "HGNC:11024",
      havana_gene : "OTTHUMG00000086803.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42653621,
      stop : 42775509,
      direction : "+",
      ID : "ENSG00000160191.18",
      gene_id : "ENSG00000160191.18",
      gene_type : "protein_coding",
      gene_name : "PDE9A",
      gene_level : 2,
      hgnc_id : "HGNC:8795",
      havana_gene : "OTTHUMG00000086825.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42843094,
      stop : 42879568,
      direction : "-",
      ID : "ENSG00000160193.12",
      gene_id : "ENSG00000160193.12",
      gene_type : "protein_coding",
      gene_name : "WDR4",
      gene_level : 2,
      hgnc_id : "HGNC:12756",
      havana_gene : "OTTHUMG00000086826.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42879644,
      stop : 42913304,
      direction : "+",
      ID : "ENSG00000160194.18",
      gene_id : "ENSG00000160194.18",
      gene_type : "protein_coding",
      gene_name : "NDUFV3",
      gene_level : 2,
      hgnc_id : "HGNC:7719",
      havana_gene : "OTTHUMG00000086823.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42916803,
      stop : 42925646,
      direction : "-",
      ID : "ENSG00000233056.3",
      gene_id : "ENSG00000233056.3",
      gene_type : "protein_coding",
      gene_name : "ERVH48-1",
      gene_level : 2,
      hgnc_id : "HGNC:17216",
      havana_gene : "OTTHUMG00000086835.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 42974510,
      stop : 43033931,
      direction : "+",
      ID : "ENSG00000160199.15",
      gene_id : "ENSG00000160199.15",
      gene_type : "protein_coding",
      gene_name : "PKNOX1",
      gene_level : 1,
      hgnc_id : "HGNC:9022",
      havana_gene : "OTTHUMG00000086833.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43053191,
      stop : 43076943,
      direction : "-",
      ID : "ENSG00000160200.18",
      gene_id : "ENSG00000160200.18",
      gene_type : "protein_coding",
      gene_name : "CBS",
      gene_level : 2,
      hgnc_id : "HGNC:1550",
      havana_gene : "OTTHUMG00000086834.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43092956,
      stop : 43107570,
      direction : "-",
      ID : "ENSG00000160201.12",
      gene_id : "ENSG00000160201.12",
      gene_type : "protein_coding",
      gene_name : "U2AF1",
      gene_level : 2,
      hgnc_id : "HGNC:12453",
      havana_gene : "OTTHUMG00000086836.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43169008,
      stop : 43172805,
      direction : "+",
      ID : "ENSG00000160202.7",
      gene_id : "ENSG00000160202.7",
      gene_type : "protein_coding",
      gene_name : "CRYAA",
      gene_level : 2,
      hgnc_id : "HGNC:2388",
      havana_gene : "OTTHUMG00000086842.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43414483,
      stop : 43427131,
      direction : "-",
      ID : "ENSG00000142178.9",
      gene_id : "ENSG00000142178.9",
      gene_type : "protein_coding",
      gene_name : "SIK1",
      gene_level : 2,
      hgnc_id : "HGNC:11142",
      havana_gene : "OTTHUMG00000086874.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43529186,
      stop : 43659488,
      direction : "-",
      ID : "ENSG00000160207.9",
      gene_id : "ENSG00000160207.9",
      gene_type : "protein_coding",
      gene_name : "HSF2BP",
      gene_level : 1,
      hgnc_id : "HGNC:5226",
      havana_gene : "OTTHUMG00000086863.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43565182,
      stop : 43565648,
      direction : "+",
      ID : "ENSG00000234289.6",
      gene_id : "ENSG00000234289.6",
      gene_type : "protein_coding",
      gene_name : "H2BS1",
      gene_level : 2,
      hgnc_id : "HGNC:4762",
      havana_gene : "OTTHUMG00000086869.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43659560,
      stop : 43696079,
      direction : "+",
      ID : "ENSG00000160208.13",
      gene_id : "ENSG00000160208.13",
      gene_type : "protein_coding",
      gene_name : "RRP1B",
      gene_level : 2,
      hgnc_id : "HGNC:23818",
      havana_gene : "OTTHUMG00000086872.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43719094,
      stop : 43762307,
      direction : "+",
      ID : "ENSG00000160209.19",
      gene_id : "ENSG00000160209.19",
      gene_type : "protein_coding",
      gene_name : "PDXK",
      gene_level : 2,
      hgnc_id : "HGNC:8819",
      havana_gene : "OTTHUMG00000086870.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43772511,
      stop : 43776330,
      direction : "-",
      ID : "ENSG00000160213.9",
      gene_id : "ENSG00000160213.9",
      gene_type : "protein_coding",
      gene_name : "CSTB",
      gene_level : 2,
      hgnc_id : "HGNC:2482",
      havana_gene : "OTTHUMG00000086886.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43789513,
      stop : 43805293,
      direction : "+",
      ID : "ENSG00000160214.13",
      gene_id : "ENSG00000160214.13",
      gene_type : "protein_coding",
      gene_name : "RRP1",
      gene_level : 2,
      hgnc_id : "HGNC:18785",
      havana_gene : "OTTHUMG00000086884.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43865223,
      stop : 43987592,
      direction : "+",
      ID : "ENSG00000160216.21",
      gene_id : "ENSG00000160216.21",
      gene_type : "protein_coding",
      gene_name : "AGPAT3",
      gene_level : 2,
      hgnc_id : "HGNC:326",
      havana_gene : "OTTHUMG00000086892.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 43939919,
      stop : 43959673,
      direction : "+",
      ID : "ENSG00000288593.1",
      gene_id : "ENSG00000288593.1",
      gene_type : "protein_coding",
      gene_name : "AP001054.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000196021.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44012309,
      stop : 44106552,
      direction : "+",
      ID : "ENSG00000160218.13",
      gene_id : "ENSG00000160218.13",
      gene_type : "protein_coding",
      gene_name : "TRAPPC10",
      gene_level : 1,
      hgnc_id : "HGNC:11868",
      havana_gene : "OTTHUMG00000086894.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44107373,
      stop : 44131181,
      direction : "+",
      ID : "ENSG00000241945.8",
      gene_id : "ENSG00000241945.8",
      gene_type : "protein_coding",
      gene_name : "PWP2",
      gene_level : 2,
      hgnc_id : "HGNC:9711",
      havana_gene : "OTTHUMG00000086893.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44133610,
      stop : 44210114,
      direction : "+",
      ID : "ENSG00000160221.18",
      gene_id : "ENSG00000160221.18",
      gene_type : "protein_coding",
      gene_name : "GATD3A",
      gene_level : 1,
      hgnc_id : "HGNC:1273",
      havana_gene : "OTTHUMG00000086916.9",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44217014,
      stop : 44240966,
      direction : "-",
      ID : "ENSG00000160223.17",
      gene_id : "ENSG00000160223.17",
      gene_type : "protein_coding",
      gene_name : "ICOSLG",
      gene_level : 2,
      hgnc_id : "HGNC:17087",
      havana_gene : "OTTHUMG00000086920.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44246339,
      stop : 44262216,
      direction : "-",
      ID : "ENSG00000142182.9",
      gene_id : "ENSG00000142182.9",
      gene_type : "protein_coding",
      gene_name : "DNMT3L",
      gene_level : 2,
      hgnc_id : "HGNC:2980",
      havana_gene : "OTTHUMG00000086914.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44285838,
      stop : 44298648,
      direction : "+",
      ID : "ENSG00000160224.17",
      gene_id : "ENSG00000160224.17",
      gene_type : "protein_coding",
      gene_name : "AIRE",
      gene_level : 2,
      hgnc_id : "HGNC:360",
      havana_gene : "OTTHUMG00000086921.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44300051,
      stop : 44327376,
      direction : "+",
      ID : "ENSG00000141959.17",
      gene_id : "ENSG00000141959.17",
      gene_type : "protein_coding",
      gene_name : "PFKL",
      gene_level : 2,
      hgnc_id : "HGNC:8876",
      havana_gene : "OTTHUMG00000086910.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44328944,
      stop : 44339402,
      direction : "-",
      ID : "ENSG00000160226.16",
      gene_id : "ENSG00000160226.16",
      gene_type : "protein_coding",
      gene_name : "CFAP410",
      gene_level : 2,
      hgnc_id : "HGNC:1260",
      havana_gene : "OTTHUMG00000086909.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44350163,
      stop : 44443081,
      direction : "+",
      ID : "ENSG00000142185.16",
      gene_id : "ENSG00000142185.16",
      gene_type : "protein_coding",
      gene_name : "TRPM2",
      gene_level : 1,
      hgnc_id : "HGNC:12339",
      havana_gene : "OTTHUMG00000040840.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44455510,
      stop : 44462196,
      direction : "+",
      ID : "ENSG00000160233.8",
      gene_id : "ENSG00000160233.8",
      gene_type : "protein_coding",
      gene_name : "LRRC3",
      gene_level : 2,
      hgnc_id : "HGNC:14965",
      havana_gene : "OTTHUMG00000040847.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44497893,
      stop : 44711572,
      direction : "-",
      ID : "ENSG00000175894.18",
      gene_id : "ENSG00000175894.18",
      gene_type : "protein_coding",
      gene_name : "TSPEAR",
      gene_level : 1,
      hgnc_id : "HGNC:1268",
      havana_gene : "OTTHUMG00000041215.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44538981,
      stop : 44540195,
      direction : "-",
      ID : "ENSG00000215455.4",
      gene_id : "ENSG00000215455.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-1",
      gene_level : 2,
      hgnc_id : "HGNC:22966",
      havana_gene : "OTTHUMG00000057627.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44550357,
      stop : 44551505,
      direction : "-",
      ID : "ENSG00000205445.3",
      gene_id : "ENSG00000205445.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-2",
      gene_level : 2,
      hgnc_id : "HGNC:22967",
      havana_gene : "OTTHUMG00000057625.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44557790,
      stop : 44558795,
      direction : "-",
      ID : "ENSG00000212935.2",
      gene_id : "ENSG00000212935.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-3",
      gene_level : 2,
      hgnc_id : "HGNC:22968",
      havana_gene : "OTTHUMG00000057628.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44573724,
      stop : 44638284,
      direction : "+",
      ID : "ENSG00000215454.6",
      gene_id : "ENSG00000215454.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-4",
      gene_level : 2,
      hgnc_id : "HGNC:20521",
      havana_gene : "OTTHUMG00000057641.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44579455,
      stop : 44580604,
      direction : "-",
      ID : "ENSG00000241123.1",
      gene_id : "ENSG00000241123.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-5",
      gene_level : 2,
      hgnc_id : "HGNC:22969",
      havana_gene : "OTTHUMG00000057638.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44591268,
      stop : 44592505,
      direction : "-",
      ID : "ENSG00000188155.11",
      gene_id : "ENSG00000188155.11",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-6",
      gene_level : 2,
      hgnc_id : "HGNC:20523",
      havana_gene : "OTTHUMG00000057634.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44600597,
      stop : 44602174,
      direction : "+",
      ID : "ENSG00000272804.3",
      gene_id : "ENSG00000272804.3",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-7",
      gene_level : 2,
      hgnc_id : "HGNC:22970",
      havana_gene : "OTTHUMG00000188307.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44612079,
      stop : 44612954,
      direction : "+",
      ID : "ENSG00000187766.1",
      gene_id : "ENSG00000187766.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-8",
      gene_level : 2,
      hgnc_id : "HGNC:20525",
      havana_gene : "OTTHUMG00000057632.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44627093,
      stop : 44628378,
      direction : "+",
      ID : "ENSG00000221837.6",
      gene_id : "ENSG00000221837.6",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-9",
      gene_level : 2,
      hgnc_id : "HGNC:22971",
      havana_gene : "OTTHUMG00000057637.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44637356,
      stop : 44638455,
      direction : "+",
      ID : "ENSG00000221859.2",
      gene_id : "ENSG00000221859.2",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-10",
      gene_level : 2,
      hgnc_id : "HGNC:22972",
      havana_gene : "OTTHUMG00000057631.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44646414,
      stop : 44647650,
      direction : "+",
      ID : "ENSG00000243489.4",
      gene_id : "ENSG00000243489.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-11",
      gene_level : 2,
      hgnc_id : "HGNC:20528",
      havana_gene : "OTTHUMG00000057626.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44654213,
      stop : 44654659,
      direction : "-",
      ID : "ENSG00000212933.1",
      gene_id : "ENSG00000212933.1",
      gene_type : "protein_coding",
      gene_name : "KRTAP12-4",
      gene_level : 2,
      hgnc_id : "HGNC:20532",
      havana_gene : "OTTHUMG00000057633.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44657932,
      stop : 44658341,
      direction : "+",
      ID : "ENSG00000205439.10",
      gene_id : "ENSG00000205439.10",
      gene_type : "protein_coding",
      gene_name : "KRTAP12-3",
      gene_level : 2,
      hgnc_id : "HGNC:20531",
      havana_gene : "OTTHUMG00000057630.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44666189,
      stop : 44666927,
      direction : "-",
      ID : "ENSG00000221864.4",
      gene_id : "ENSG00000221864.4",
      gene_type : "protein_coding",
      gene_name : "KRTAP12-2",
      gene_level : 2,
      hgnc_id : "HGNC:20530",
      havana_gene : "OTTHUMG00000057636.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44681576,
      stop : 44682163,
      direction : "-",
      ID : "ENSG00000187175.5",
      gene_id : "ENSG00000187175.5",
      gene_type : "protein_coding",
      gene_name : "KRTAP12-1",
      gene_level : 2,
      hgnc_id : "HGNC:20529",
      havana_gene : "OTTHUMG00000057639.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44697172,
      stop : 44698044,
      direction : "+",
      ID : "ENSG00000189169.7",
      gene_id : "ENSG00000189169.7",
      gene_type : "protein_coding",
      gene_name : "KRTAP10-12",
      gene_level : 2,
      hgnc_id : "HGNC:20533",
      havana_gene : "OTTHUMG00000057629.1",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44768580,
      stop : 44801826,
      direction : "-",
      ID : "ENSG00000184787.19",
      gene_id : "ENSG00000184787.19",
      gene_type : "protein_coding",
      gene_name : "UBE2G2",
      gene_level : 2,
      hgnc_id : "HGNC:12483",
      havana_gene : "OTTHUMG00000089179.7",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44805617,
      stop : 44818779,
      direction : "-",
      ID : "ENSG00000184900.16",
      gene_id : "ENSG00000184900.16",
      gene_type : "protein_coding",
      gene_name : "SUMO3",
      gene_level : 1,
      hgnc_id : "HGNC:11124",
      havana_gene : "OTTHUMG00000090256.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44849585,
      stop : 44873903,
      direction : "-",
      ID : "ENSG00000183255.12",
      gene_id : "ENSG00000183255.12",
      gene_type : "protein_coding",
      gene_name : "PTTG1IP",
      gene_level : 1,
      hgnc_id : "HGNC:13524",
      havana_gene : "OTTHUMG00000090254.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44885953,
      stop : 44931989,
      direction : "-",
      ID : "ENSG00000160255.18",
      gene_id : "ENSG00000160255.18",
      gene_type : "protein_coding",
      gene_name : "ITGB2",
      gene_level : 1,
      hgnc_id : "HGNC:6155",
      havana_gene : "OTTHUMG00000090257.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 44940012,
      stop : 44976989,
      direction : "+",
      ID : "ENSG00000160256.13",
      gene_id : "ENSG00000160256.13",
      gene_type : "protein_coding",
      gene_name : "FAM207A",
      gene_level : 2,
      hgnc_id : "HGNC:15811",
      havana_gene : "OTTHUMG00000090293.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 45073853,
      stop : 45226560,
      direction : "+",
      ID : "ENSG00000197381.16",
      gene_id : "ENSG00000197381.16",
      gene_type : "protein_coding",
      gene_name : "ADARB1",
      gene_level : 2,
      hgnc_id : "HGNC:226",
      havana_gene : "OTTHUMG00000090295.8",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 45263928,
      stop : 45287898,
      direction : "-",
      ID : "ENSG00000186866.17",
      gene_id : "ENSG00000186866.17",
      gene_type : "protein_coding",
      gene_name : "POFUT2",
      gene_level : 1,
      hgnc_id : "HGNC:14683",
      havana_gene : "OTTHUMG00000084874.6",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 45405165,
      stop : 45513720,
      direction : "+",
      ID : "ENSG00000182871.16",
      gene_id : "ENSG00000182871.16",
      gene_type : "protein_coding",
      gene_name : "COL18A1",
      gene_level : 1,
      hgnc_id : "HGNC:2195",
      havana_gene : "OTTHUMG00000090407.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 45493572,
      stop : 45573365,
      direction : "-",
      ID : "ENSG00000173638.19",
      gene_id : "ENSG00000173638.19",
      gene_type : "protein_coding",
      gene_name : "SLC19A1",
      gene_level : 1,
      hgnc_id : "HGNC:10937",
      havana_gene : "OTTHUMG00000090397.9",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 45643694,
      stop : 45942454,
      direction : "+",
      ID : "ENSG00000183570.17",
      gene_id : "ENSG00000183570.17",
      gene_type : "protein_coding",
      gene_name : "PCBP3",
      gene_level : 2,
      hgnc_id : "HGNC:8651",
      havana_gene : "OTTHUMG00000090399.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 45981769,
      stop : 46005050,
      direction : "+",
      ID : "ENSG00000142156.15",
      gene_id : "ENSG00000142156.15",
      gene_type : "protein_coding",
      gene_name : "COL6A1",
      gene_level : 2,
      hgnc_id : "HGNC:2211",
      havana_gene : "OTTHUMG00000090440.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46098112,
      stop : 46132848,
      direction : "+",
      ID : "ENSG00000142173.16",
      gene_id : "ENSG00000142173.16",
      gene_type : "protein_coding",
      gene_name : "COL6A2",
      gene_level : 2,
      hgnc_id : "HGNC:2212",
      havana_gene : "OTTHUMG00000090489.8",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46136262,
      stop : 46155579,
      direction : "-",
      ID : "ENSG00000160282.14",
      gene_id : "ENSG00000160282.14",
      gene_type : "protein_coding",
      gene_name : "FTCD",
      gene_level : 2,
      hgnc_id : "HGNC:3974",
      havana_gene : "OTTHUMG00000090488.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46161148,
      stop : 46184476,
      direction : "-",
      ID : "ENSG00000160284.15",
      gene_id : "ENSG00000160284.15",
      gene_type : "protein_coding",
      gene_name : "SPATC1L",
      gene_level : 2,
      hgnc_id : "HGNC:1298",
      havana_gene : "OTTHUMG00000090487.4",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46188141,
      stop : 46228824,
      direction : "-",
      ID : "ENSG00000160285.15",
      gene_id : "ENSG00000160285.15",
      gene_type : "protein_coding",
      gene_name : "LSS",
      gene_level : 1,
      hgnc_id : "HGNC:6708",
      havana_gene : "OTTHUMG00000090633.10",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46235133,
      stop : 46286297,
      direction : "-",
      ID : "ENSG00000160294.11",
      gene_id : "ENSG00000160294.11",
      gene_type : "protein_coding",
      gene_name : "MCM3AP",
      gene_level : 2,
      hgnc_id : "HGNC:6946",
      havana_gene : "OTTHUMG00000090630.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46286342,
      stop : 46297751,
      direction : "+",
      ID : "ENSG00000182362.14",
      gene_id : "ENSG00000182362.14",
      gene_type : "protein_coding",
      gene_name : "YBEY",
      gene_level : 2,
      hgnc_id : "HGNC:1299",
      havana_gene : "OTTHUMG00000090632.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46300181,
      stop : 46323875,
      direction : "-",
      ID : "ENSG00000160298.18",
      gene_id : "ENSG00000160298.18",
      gene_type : "protein_coding",
      gene_name : "C21orf58",
      gene_level : 1,
      hgnc_id : "HGNC:1300",
      havana_gene : "OTTHUMG00000090634.5",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46324141,
      stop : 46445769,
      direction : "+",
      ID : "ENSG00000160299.17",
      gene_id : "ENSG00000160299.17",
      gene_type : "protein_coding",
      gene_name : "PCNT",
      gene_level : 2,
      hgnc_id : "HGNC:16068",
      havana_gene : "OTTHUMG00000090665.2",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46326288,
      stop : 46326491,
      direction : "+",
      ID : "ENSG00000286224.1",
      gene_id : "ENSG00000286224.1",
      gene_type : "protein_coding",
      gene_name : "AP000471.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193512.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46458891,
      stop : 46570015,
      direction : "+",
      ID : "ENSG00000160305.18",
      gene_id : "ENSG00000160305.18",
      gene_type : "protein_coding",
      gene_name : "DIP2A",
      gene_level : 2,
      hgnc_id : "HGNC:17217",
      havana_gene : "OTTHUMG00000090717.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46598604,
      stop : 46605208,
      direction : "-",
      ID : "ENSG00000160307.10",
      gene_id : "ENSG00000160307.10",
      gene_type : "protein_coding",
      gene_name : "S100B",
      gene_level : 1,
      hgnc_id : "HGNC:10500",
      havana_gene : "OTTHUMG00000090715.3",
      tag : null
    },
    {
      chromosome : 21,
      annotation : "HAVANA",
      type : "gene",
      start : 46635595,
      stop : 46665124,
      direction : "+",
      ID : "ENSG00000160310.18",
      gene_id : "ENSG00000160310.18",
      gene_type : "protein_coding",
      gene_name : "PRMT2",
      gene_level : 1,
      hgnc_id : "HGNC:5186",
      havana_gene : "OTTHUMG00000048806.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 15528192,
      stop : 15529139,
      direction : "+",
      ID : "ENSG00000130538.6",
      gene_id : "ENSG00000130538.6",
      gene_type : "protein_coding",
      gene_name : "OR11H1",
      gene_level : 2,
      hgnc_id : "HGNC:15404",
      havana_gene : "OTTHUMG00000030069.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 15690026,
      stop : 15721631,
      direction : "+",
      ID : "ENSG00000198062.15",
      gene_id : "ENSG00000198062.15",
      gene_type : "protein_coding",
      gene_name : "POTEH",
      gene_level : 1,
      hgnc_id : "HGNC:133",
      havana_gene : "OTTHUMG00000140314.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 16590751,
      stop : 16592810,
      direction : "-",
      ID : "ENSG00000198445.4",
      gene_id : "ENSG00000198445.4",
      gene_type : "protein_coding",
      gene_name : "CCT8L2",
      gene_level : 2,
      hgnc_id : "HGNC:15553",
      havana_gene : "OTTHUMG00000141302.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 16783412,
      stop : 16821699,
      direction : "-",
      ID : "ENSG00000172967.7",
      gene_id : "ENSG00000172967.7",
      gene_type : "protein_coding",
      gene_name : "XKR3",
      gene_level : 2,
      hgnc_id : "HGNC:28778",
      havana_gene : "OTTHUMG00000143726.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 16961936,
      stop : 17008222,
      direction : "-",
      ID : "ENSG00000215568.9",
      gene_id : "ENSG00000215568.9",
      gene_type : "protein_coding",
      gene_name : "GAB4",
      gene_level : 2,
      hgnc_id : "HGNC:18325",
      havana_gene : "OTTHUMG00000149992.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17084954,
      stop : 17115694,
      direction : "+",
      ID : "ENSG00000177663.14",
      gene_id : "ENSG00000177663.14",
      gene_type : "protein_coding",
      gene_name : "IL17RA",
      gene_level : 1,
      hgnc_id : "HGNC:5985",
      havana_gene : "OTTHUMG00000150026.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17116297,
      stop : 17121367,
      direction : "-",
      ID : "ENSG00000183307.4",
      gene_id : "ENSG00000183307.4",
      gene_type : "protein_coding",
      gene_name : "TMEM121B",
      gene_level : 1,
      hgnc_id : "HGNC:1844",
      havana_gene : "OTTHUMG00000030471.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17137511,
      stop : 17165287,
      direction : "-",
      ID : "ENSG00000069998.12",
      gene_id : "ENSG00000069998.12",
      gene_type : "protein_coding",
      gene_name : "HDHD5",
      gene_level : 1,
      hgnc_id : "HGNC:1843",
      havana_gene : "OTTHUMG00000150071.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17178790,
      stop : 17258235,
      direction : "-",
      ID : "ENSG00000093072.18",
      gene_id : "ENSG00000093072.18",
      gene_type : "protein_coding",
      gene_name : "ADA2",
      gene_level : 1,
      hgnc_id : "HGNC:1839",
      havana_gene : "OTTHUMG00000030726.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17359949,
      stop : 17558149,
      direction : "+",
      ID : "ENSG00000099954.18",
      gene_id : "ENSG00000099954.18",
      gene_type : "protein_coding",
      gene_name : "CECR2",
      gene_level : 1,
      hgnc_id : "HGNC:1840",
      havana_gene : "OTTHUMG00000150072.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17563450,
      stop : 17590995,
      direction : "+",
      ID : "ENSG00000182902.14",
      gene_id : "ENSG00000182902.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A18",
      gene_level : 2,
      hgnc_id : "HGNC:10988",
      havana_gene : "OTTHUMG00000150089.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17592136,
      stop : 17628749,
      direction : "-",
      ID : "ENSG00000131100.13",
      gene_id : "ENSG00000131100.13",
      gene_type : "protein_coding",
      gene_name : "ATP6V1E1",
      gene_level : 2,
      hgnc_id : "HGNC:857",
      havana_gene : "OTTHUMG00000059320.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17628855,
      stop : 17730855,
      direction : "+",
      ID : "ENSG00000099968.18",
      gene_id : "ENSG00000099968.18",
      gene_type : "protein_coding",
      gene_name : "BCL2L13",
      gene_level : 1,
      hgnc_id : "HGNC:17164",
      havana_gene : "OTTHUMG00000150088.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17734138,
      stop : 17774770,
      direction : "-",
      ID : "ENSG00000015475.19",
      gene_id : "ENSG00000015475.19",
      gene_type : "protein_coding",
      gene_name : "BID",
      gene_level : 2,
      hgnc_id : "HGNC:1050",
      havana_gene : "OTTHUMG00000150087.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 17787649,
      stop : 18024561,
      direction : "-",
      ID : "ENSG00000243156.9",
      gene_id : "ENSG00000243156.9",
      gene_type : "protein_coding",
      gene_name : "MICAL3",
      gene_level : 1,
      hgnc_id : "HGNC:24694",
      havana_gene : "OTTHUMG00000150067.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18077923,
      stop : 18105396,
      direction : "+",
      ID : "ENSG00000215193.14",
      gene_id : "ENSG00000215193.14",
      gene_type : "protein_coding",
      gene_name : "PEX26",
      gene_level : 1,
      hgnc_id : "HGNC:22965",
      havana_gene : "OTTHUMG00000149970.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18077989,
      stop : 18131720,
      direction : "+",
      ID : "ENSG00000288683.1",
      gene_id : "ENSG00000288683.1",
      gene_type : "protein_coding",
      gene_name : "AC016027.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000149970.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18110100,
      stop : 18146683,
      direction : "+",
      ID : "ENSG00000183785.16",
      gene_id : "ENSG00000183785.16",
      gene_type : "protein_coding",
      gene_name : "TUBA8",
      gene_level : 1,
      hgnc_id : "HGNC:12410",
      havana_gene : "OTTHUMG00000150097.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18150170,
      stop : 18177397,
      direction : "+",
      ID : "ENSG00000184979.10",
      gene_id : "ENSG00000184979.10",
      gene_type : "protein_coding",
      gene_name : "USP18",
      gene_level : 2,
      hgnc_id : "HGNC:12616",
      havana_gene : "OTTHUMG00000150104.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18516344,
      stop : 18518161,
      direction : "-",
      ID : "ENSG00000274252.1",
      gene_id : "ENSG00000274252.1",
      gene_type : "protein_coding",
      gene_name : "GGTLC3",
      gene_level : 2,
      hgnc_id : "HGNC:33426",
      havana_gene : "OTTHUMG00000188352.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18527802,
      stop : 18530573,
      direction : "+",
      ID : "ENSG00000278558.5",
      gene_id : "ENSG00000278558.5",
      gene_type : "protein_coding",
      gene_name : "TMEM191B",
      gene_level : 2,
      hgnc_id : "HGNC:33600",
      havana_gene : "OTTHUMG00000188353.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18605815,
      stop : 18611919,
      direction : "-",
      ID : "ENSG00000275793.1",
      gene_id : "ENSG00000275793.1",
      gene_type : "protein_coding",
      gene_name : "RIMBP3",
      gene_level : 2,
      hgnc_id : "HGNC:29344",
      havana_gene : "OTTHUMG00000188355.1",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18633984,
      stop : 18634682,
      direction : "+",
      ID : "ENSG00000286175.1",
      gene_id : "ENSG00000286175.1",
      gene_type : "protein_coding",
      gene_name : "FAM246B",
      gene_level : 2,
      hgnc_id : "HGNC:54843",
      havana_gene : "OTTHUMG00000193513.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18906028,
      stop : 18914238,
      direction : "+",
      ID : "ENSG00000183628.14",
      gene_id : "ENSG00000183628.14",
      gene_type : "protein_coding",
      gene_name : "DGCR6",
      gene_level : 2,
      hgnc_id : "HGNC:2846",
      havana_gene : "OTTHUMG00000150162.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18906238,
      stop : 18947732,
      direction : "+",
      ID : "ENSG00000283809.1",
      gene_id : "ENSG00000283809.1",
      gene_type : "protein_coding",
      gene_name : "AC007326.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192094.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 18912777,
      stop : 18936553,
      direction : "-",
      ID : "ENSG00000100033.17",
      gene_id : "ENSG00000100033.17",
      gene_type : "protein_coding",
      gene_name : "PRODH",
      gene_level : 2,
      hgnc_id : "HGNC:9453",
      havana_gene : "OTTHUMG00000150163.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19036282,
      stop : 19122454,
      direction : "-",
      ID : "ENSG00000070413.20",
      gene_id : "ENSG00000070413.20",
      gene_type : "protein_coding",
      gene_name : "DGCR2",
      gene_level : 2,
      hgnc_id : "HGNC:2845",
      havana_gene : "OTTHUMG00000150141.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19130279,
      stop : 19144684,
      direction : "-",
      ID : "ENSG00000100056.12",
      gene_id : "ENSG00000100056.12",
      gene_type : "protein_coding",
      gene_name : "ESS2",
      gene_level : 2,
      hgnc_id : "HGNC:16817",
      havana_gene : "OTTHUMG00000150119.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19131308,
      stop : 19132622,
      direction : "+",
      ID : "ENSG00000206203.5",
      gene_id : "ENSG00000206203.5",
      gene_type : "protein_coding",
      gene_name : "TSSK2",
      gene_level : 2,
      hgnc_id : "HGNC:11401",
      havana_gene : "OTTHUMG00000150118.2",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19146993,
      stop : 19150292,
      direction : "-",
      ID : "ENSG00000063515.3",
      gene_id : "ENSG00000063515.3",
      gene_type : "protein_coding",
      gene_name : "GSC2",
      gene_level : 2,
      hgnc_id : "HGNC:4613",
      havana_gene : "OTTHUMG00000150122.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19175581,
      stop : 19178739,
      direction : "-",
      ID : "ENSG00000100075.10",
      gene_id : "ENSG00000100075.10",
      gene_type : "protein_coding",
      gene_name : "SLC25A1",
      gene_level : 2,
      hgnc_id : "HGNC:10979",
      havana_gene : "OTTHUMG00000150123.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19179473,
      stop : 19291719,
      direction : "-",
      ID : "ENSG00000070371.16",
      gene_id : "ENSG00000070371.16",
      gene_type : "protein_coding",
      gene_name : "CLTCL1",
      gene_level : 2,
      hgnc_id : "HGNC:2093",
      havana_gene : "OTTHUMG00000150109.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19330698,
      stop : 19447450,
      direction : "-",
      ID : "ENSG00000100084.14",
      gene_id : "ENSG00000100084.14",
      gene_type : "protein_coding",
      gene_name : "HIRA",
      gene_level : 2,
      hgnc_id : "HGNC:4916",
      havana_gene : "OTTHUMG00000150134.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19351368,
      stop : 19447711,
      direction : "-",
      ID : "ENSG00000242259.9",
      gene_id : "ENSG00000242259.9",
      gene_type : "protein_coding",
      gene_name : "C22orf39",
      gene_level : 2,
      hgnc_id : "HGNC:27012",
      havana_gene : "OTTHUMG00000150137.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19432545,
      stop : 19436075,
      direction : "+",
      ID : "ENSG00000185608.9",
      gene_id : "ENSG00000185608.9",
      gene_type : "protein_coding",
      gene_name : "MRPL40",
      gene_level : 2,
      hgnc_id : "HGNC:14491",
      havana_gene : "OTTHUMG00000150136.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19449911,
      stop : 19479202,
      direction : "-",
      ID : "ENSG00000070010.19",
      gene_id : "ENSG00000070010.19",
      gene_type : "protein_coding",
      gene_name : "UFD1",
      gene_level : 1,
      hgnc_id : "HGNC:12520",
      havana_gene : "OTTHUMG00000150130.16",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19479457,
      stop : 19520612,
      direction : "+",
      ID : "ENSG00000093009.11",
      gene_id : "ENSG00000093009.11",
      gene_type : "protein_coding",
      gene_name : "CDC45",
      gene_level : 1,
      hgnc_id : "HGNC:1739",
      havana_gene : "OTTHUMG00000150386.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19523024,
      stop : 19527545,
      direction : "-",
      ID : "ENSG00000184113.9",
      gene_id : "ENSG00000184113.9",
      gene_type : "protein_coding",
      gene_name : "CLDN5",
      gene_level : 2,
      hgnc_id : "HGNC:2047",
      havana_gene : "OTTHUMG00000150441.5",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19714503,
      stop : 19724224,
      direction : "+",
      ID : "ENSG00000184702.20",
      gene_id : "ENSG00000184702.20",
      gene_type : "protein_coding",
      gene_name : "SEPTIN5",
      gene_level : 2,
      hgnc_id : "HGNC:9164",
      havana_gene : "OTTHUMG00000150399.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19717220,
      stop : 19724772,
      direction : "+",
      ID : "ENSG00000284874.1",
      gene_id : "ENSG00000284874.1",
      gene_type : "protein_coding",
      gene_name : "AC000093.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192396.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19723539,
      stop : 19724771,
      direction : "+",
      ID : "ENSG00000203618.6",
      gene_id : "ENSG00000203618.6",
      gene_type : "protein_coding",
      gene_name : "GP1BB",
      gene_level : 2,
      hgnc_id : "HGNC:4440",
      havana_gene : "OTTHUMG00000150397.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19756703,
      stop : 19783593,
      direction : "+",
      ID : "ENSG00000184058.15",
      gene_id : "ENSG00000184058.15",
      gene_type : "protein_coding",
      gene_name : "TBX1",
      gene_level : 2,
      hgnc_id : "HGNC:11592",
      havana_gene : "OTTHUMG00000150421.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19783223,
      stop : 19854939,
      direction : "-",
      ID : "ENSG00000185838.14",
      gene_id : "ENSG00000185838.14",
      gene_type : "protein_coding",
      gene_name : "GNB1L",
      gene_level : 2,
      hgnc_id : "HGNC:4397",
      havana_gene : "OTTHUMG00000150279.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19846138,
      stop : 19854896,
      direction : "-",
      ID : "ENSG00000215012.9",
      gene_id : "ENSG00000215012.9",
      gene_type : "protein_coding",
      gene_name : "RTL10",
      gene_level : 2,
      hgnc_id : "HGNC:26112",
      havana_gene : "OTTHUMG00000030314.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19875517,
      stop : 19941820,
      direction : "-",
      ID : "ENSG00000184470.21",
      gene_id : "ENSG00000184470.21",
      gene_type : "protein_coding",
      gene_name : "TXNRD2",
      gene_level : 2,
      hgnc_id : "HGNC:18155",
      havana_gene : "OTTHUMG00000149975.8",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19941371,
      stop : 19969975,
      direction : "+",
      ID : "ENSG00000093010.15",
      gene_id : "ENSG00000093010.15",
      gene_type : "protein_coding",
      gene_name : "COMT",
      gene_level : 1,
      hgnc_id : "HGNC:2228",
      havana_gene : "OTTHUMG00000150529.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 19969896,
      stop : 20016823,
      direction : "-",
      ID : "ENSG00000099889.14",
      gene_id : "ENSG00000099889.14",
      gene_type : "protein_coding",
      gene_name : "ARVCF",
      gene_level : 1,
      hgnc_id : "HGNC:728",
      havana_gene : "OTTHUMG00000030426.10",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20017014,
      stop : 20067164,
      direction : "+",
      ID : "ENSG00000183597.16",
      gene_id : "ENSG00000183597.16",
      gene_type : "protein_coding",
      gene_name : "TANGO2",
      gene_level : 2,
      hgnc_id : "HGNC:25439",
      havana_gene : "OTTHUMG00000150510.26",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20080232,
      stop : 20111877,
      direction : "+",
      ID : "ENSG00000128191.16",
      gene_id : "ENSG00000128191.16",
      gene_type : "protein_coding",
      gene_name : "DGCR8",
      gene_level : 2,
      hgnc_id : "HGNC:2847",
      havana_gene : "OTTHUMG00000150503.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20111875,
      stop : 20117392,
      direction : "-",
      ID : "ENSG00000099899.15",
      gene_id : "ENSG00000099899.15",
      gene_type : "protein_coding",
      gene_name : "TRMT2A",
      gene_level : 2,
      hgnc_id : "HGNC:24974",
      havana_gene : "OTTHUMG00000150454.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20115938,
      stop : 20127355,
      direction : "+",
      ID : "ENSG00000099901.17",
      gene_id : "ENSG00000099901.17",
      gene_type : "protein_coding",
      gene_name : "RANBP1",
      gene_level : 1,
      hgnc_id : "HGNC:9847",
      havana_gene : "OTTHUMG00000150490.35",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20129456,
      stop : 20148007,
      direction : "+",
      ID : "ENSG00000099904.16",
      gene_id : "ENSG00000099904.16",
      gene_type : "protein_coding",
      gene_name : "ZDHHC8",
      gene_level : 1,
      hgnc_id : "HGNC:18474",
      havana_gene : "OTTHUMG00000150499.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20148416,
      stop : 20151055,
      direction : "-",
      ID : "ENSG00000234409.7",
      gene_id : "ENSG00000234409.7",
      gene_type : "protein_coding",
      gene_name : "CCDC188",
      gene_level : 1,
      hgnc_id : "HGNC:51899",
      havana_gene : "OTTHUMG00000150751.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20241415,
      stop : 20283246,
      direction : "-",
      ID : "ENSG00000040608.14",
      gene_id : "ENSG00000040608.14",
      gene_type : "protein_coding",
      gene_name : "RTN4R",
      gene_level : 1,
      hgnc_id : "HGNC:18601",
      havana_gene : "OTTHUMG00000150572.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20314238,
      stop : 20320080,
      direction : "-",
      ID : "ENSG00000128185.10",
      gene_id : "ENSG00000128185.10",
      gene_type : "protein_coding",
      gene_name : "DGCR6L",
      gene_level : 2,
      hgnc_id : "HGNC:18551",
      havana_gene : "OTTHUMG00000150583.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20350578,
      stop : 20377251,
      direction : "-",
      ID : "ENSG00000161133.17",
      gene_id : "ENSG00000161133.17",
      gene_type : "protein_coding",
      gene_name : "USP41",
      gene_level : 2,
      hgnc_id : "HGNC:20070",
      havana_gene : "OTTHUMG00000151317.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20394115,
      stop : 20408461,
      direction : "+",
      ID : "ENSG00000185252.19",
      gene_id : "ENSG00000185252.19",
      gene_type : "protein_coding",
      gene_name : "ZNF74",
      gene_level : 1,
      hgnc_id : "HGNC:13144",
      havana_gene : "OTTHUMG00000150687.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20424584,
      stop : 20437826,
      direction : "-",
      ID : "ENSG00000244486.9",
      gene_id : "ENSG00000244486.9",
      gene_type : "protein_coding",
      gene_name : "SCARF2",
      gene_level : 2,
      hgnc_id : "HGNC:19869",
      havana_gene : "OTTHUMG00000150779.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20429241,
      stop : 20446620,
      direction : "-",
      ID : "ENSG00000277971.1",
      gene_id : "ENSG00000277971.1",
      gene_type : "protein_coding",
      gene_name : "AC007731.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000150778.43",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20441519,
      stop : 20495844,
      direction : "-",
      ID : "ENSG00000099910.17",
      gene_id : "ENSG00000099910.17",
      gene_type : "protein_coding",
      gene_name : "KLHL22",
      gene_level : 1,
      hgnc_id : "HGNC:25888",
      havana_gene : "OTTHUMG00000188269.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20495913,
      stop : 20587632,
      direction : "+",
      ID : "ENSG00000099917.17",
      gene_id : "ENSG00000099917.17",
      gene_type : "protein_coding",
      gene_name : "MED15",
      gene_level : 2,
      hgnc_id : "HGNC:14248",
      havana_gene : "OTTHUMG00000150810.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20707691,
      stop : 20859417,
      direction : "-",
      ID : "ENSG00000241973.11",
      gene_id : "ENSG00000241973.11",
      gene_type : "protein_coding",
      gene_name : "PI4KA",
      gene_level : 1,
      hgnc_id : "HGNC:8983",
      havana_gene : "OTTHUMG00000167440.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20774113,
      stop : 20787720,
      direction : "+",
      ID : "ENSG00000099937.11",
      gene_id : "ENSG00000099937.11",
      gene_type : "protein_coding",
      gene_name : "SERPIND1",
      gene_level : 2,
      hgnc_id : "HGNC:4838",
      havana_gene : "OTTHUMG00000150755.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20859007,
      stop : 20891214,
      direction : "+",
      ID : "ENSG00000099940.12",
      gene_id : "ENSG00000099940.12",
      gene_type : "protein_coding",
      gene_name : "SNAP29",
      gene_level : 1,
      hgnc_id : "HGNC:11133",
      havana_gene : "OTTHUMG00000150765.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20917407,
      stop : 20953747,
      direction : "+",
      ID : "ENSG00000099942.13",
      gene_id : "ENSG00000099942.13",
      gene_type : "protein_coding",
      gene_name : "CRKL",
      gene_level : 2,
      hgnc_id : "HGNC:2363",
      havana_gene : "OTTHUMG00000150807.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20965108,
      stop : 20981360,
      direction : "+",
      ID : "ENSG00000183773.15",
      gene_id : "ENSG00000183773.15",
      gene_type : "protein_coding",
      gene_name : "AIFM3",
      gene_level : 2,
      hgnc_id : "HGNC:26398",
      havana_gene : "OTTHUMG00000150804.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20982269,
      stop : 20999032,
      direction : "+",
      ID : "ENSG00000099949.21",
      gene_id : "ENSG00000099949.21",
      gene_type : "protein_coding",
      gene_name : "LZTR1",
      gene_level : 2,
      hgnc_id : "HGNC:6742",
      havana_gene : "OTTHUMG00000150878.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 20999104,
      stop : 21002196,
      direction : "-",
      ID : "ENSG00000184436.12",
      gene_id : "ENSG00000184436.12",
      gene_type : "protein_coding",
      gene_name : "THAP7",
      gene_level : 2,
      hgnc_id : "HGNC:23190",
      havana_gene : "OTTHUMG00000150879.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21009808,
      stop : 21028830,
      direction : "+",
      ID : "ENSG00000099957.16",
      gene_id : "ENSG00000099957.16",
      gene_type : "protein_coding",
      gene_name : "P2RX6",
      gene_level : 2,
      hgnc_id : "HGNC:8538",
      havana_gene : "OTTHUMG00000150689.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21028718,
      stop : 21032840,
      direction : "-",
      ID : "ENSG00000099960.13",
      gene_id : "ENSG00000099960.13",
      gene_type : "protein_coding",
      gene_name : "SLC7A4",
      gene_level : 2,
      hgnc_id : "HGNC:11062",
      havana_gene : "OTTHUMG00000150896.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21045960,
      stop : 21064168,
      direction : "+",
      ID : "ENSG00000187905.10",
      gene_id : "ENSG00000187905.10",
      gene_type : "protein_coding",
      gene_name : "LRRC74B",
      gene_level : 2,
      hgnc_id : "HGNC:34301",
      havana_gene : "OTTHUMG00000150897.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21207973,
      stop : 21227637,
      direction : "-",
      ID : "ENSG00000133475.17",
      gene_id : "ENSG00000133475.17",
      gene_type : "protein_coding",
      gene_name : "GGT2",
      gene_level : 1,
      hgnc_id : "HGNC:4251",
      havana_gene : "OTTHUMG00000150617.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21360601,
      stop : 21361299,
      direction : "-",
      ID : "ENSG00000286102.1",
      gene_id : "ENSG00000286102.1",
      gene_type : "protein_coding",
      gene_name : "FAM246A",
      gene_level : 2,
      hgnc_id : "HGNC:54844",
      havana_gene : "OTTHUMG00000193515.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21383374,
      stop : 21389478,
      direction : "+",
      ID : "ENSG00000274600.1",
      gene_id : "ENSG00000274600.1",
      gene_type : "protein_coding",
      gene_name : "RIMBP3B",
      gene_level : 2,
      hgnc_id : "HGNC:33891",
      havana_gene : "OTTHUMG00000150819.2",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21417371,
      stop : 21451463,
      direction : "+",
      ID : "ENSG00000169635.10",
      gene_id : "ENSG00000169635.10",
      gene_type : "protein_coding",
      gene_name : "HIC2",
      gene_level : 2,
      hgnc_id : "HGNC:18595",
      havana_gene : "OTTHUMG00000150781.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21466423,
      stop : 21471269,
      direction : "+",
      ID : "ENSG00000206140.11",
      gene_id : "ENSG00000206140.11",
      gene_type : "protein_coding",
      gene_name : "TMEM191C",
      gene_level : 1,
      hgnc_id : "HGNC:33601",
      havana_gene : "OTTHUMG00000150780.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21545678,
      stop : 21551461,
      direction : "-",
      ID : "ENSG00000183246.7",
      gene_id : "ENSG00000183246.7",
      gene_type : "protein_coding",
      gene_name : "RIMBP3C",
      gene_level : 2,
      hgnc_id : "HGNC:33892",
      havana_gene : "OTTHUMG00000150825.1",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21549447,
      stop : 21624034,
      direction : "+",
      ID : "ENSG00000185651.15",
      gene_id : "ENSG00000185651.15",
      gene_type : "protein_coding",
      gene_name : "UBE2L3",
      gene_level : 2,
      hgnc_id : "HGNC:12488",
      havana_gene : "OTTHUMG00000150823.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21628089,
      stop : 21630064,
      direction : "-",
      ID : "ENSG00000161179.14",
      gene_id : "ENSG00000161179.14",
      gene_type : "protein_coding",
      gene_name : "YDJC",
      gene_level : 2,
      hgnc_id : "HGNC:27158",
      havana_gene : "OTTHUMG00000150822.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21632716,
      stop : 21637329,
      direction : "+",
      ID : "ENSG00000161180.11",
      gene_id : "ENSG00000161180.11",
      gene_type : "protein_coding",
      gene_name : "CCDC116",
      gene_level : 2,
      hgnc_id : "HGNC:26688",
      havana_gene : "OTTHUMG00000150821.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21642302,
      stop : 21644299,
      direction : "+",
      ID : "ENSG00000128228.5",
      gene_id : "ENSG00000128228.5",
      gene_type : "protein_coding",
      gene_name : "SDF2L1",
      gene_level : 2,
      hgnc_id : "HGNC:10676",
      havana_gene : "OTTHUMG00000150820.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21666000,
      stop : 21700015,
      direction : "+",
      ID : "ENSG00000100023.20",
      gene_id : "ENSG00000100023.20",
      gene_type : "protein_coding",
      gene_name : "PPIL2",
      gene_level : 2,
      hgnc_id : "HGNC:9261",
      havana_gene : "OTTHUMG00000191763.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21697536,
      stop : 21735794,
      direction : "-",
      ID : "ENSG00000100027.17",
      gene_id : "ENSG00000100027.17",
      gene_type : "protein_coding",
      gene_name : "YPEL1",
      gene_level : 2,
      hgnc_id : "HGNC:12845",
      havana_gene : "OTTHUMG00000150830.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21759657,
      stop : 21867680,
      direction : "-",
      ID : "ENSG00000100030.15",
      gene_id : "ENSG00000100030.15",
      gene_type : "protein_coding",
      gene_name : "MAPK1",
      gene_level : 1,
      hgnc_id : "HGNC:6871",
      havana_gene : "OTTHUMG00000030508.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21919425,
      stop : 21952848,
      direction : "-",
      ID : "ENSG00000100034.14",
      gene_id : "ENSG00000100034.14",
      gene_type : "protein_coding",
      gene_name : "PPM1F",
      gene_level : 1,
      hgnc_id : "HGNC:19388",
      havana_gene : "OTTHUMG00000150835.13",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 21957025,
      stop : 21982813,
      direction : "-",
      ID : "ENSG00000100038.20",
      gene_id : "ENSG00000100038.20",
      gene_type : "protein_coding",
      gene_name : "TOP3B",
      gene_level : 2,
      hgnc_id : "HGNC:11993",
      havana_gene : "OTTHUMG00000167438.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 22244780,
      stop : 22245515,
      direction : "+",
      ID : "ENSG00000169575.5",
      gene_id : "ENSG00000169575.5",
      gene_type : "protein_coding",
      gene_name : "VPREB1",
      gene_level : 2,
      hgnc_id : "HGNC:12709",
      havana_gene : "OTTHUMG00000151042.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 22484421,
      stop : 22508742,
      direction : "-",
      ID : "ENSG00000275004.4",
      gene_id : "ENSG00000275004.4",
      gene_type : "protein_coding",
      gene_name : "ZNF280B",
      gene_level : 2,
      hgnc_id : "HGNC:23022",
      havana_gene : "OTTHUMG00000151066.6",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 22513736,
      stop : 22520270,
      direction : "-",
      ID : "ENSG00000169548.3",
      gene_id : "ENSG00000169548.3",
      gene_type : "protein_coding",
      gene_name : "ZNF280A",
      gene_level : 2,
      hgnc_id : "HGNC:18597",
      havana_gene : "OTTHUMG00000030545.4",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 22547701,
      stop : 22559361,
      direction : "-",
      ID : "ENSG00000185686.18",
      gene_id : "ENSG00000185686.18",
      gene_type : "protein_coding",
      gene_name : "PRAME",
      gene_level : 2,
      hgnc_id : "HGNC:9336",
      havana_gene : "OTTHUMG00000151172.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 22644475,
      stop : 22647903,
      direction : "+",
      ID : "ENSG00000100121.13",
      gene_id : "ENSG00000100121.13",
      gene_type : "protein_coding",
      gene_name : "GGTLC2",
      gene_level : 2,
      hgnc_id : "HGNC:18596",
      havana_gene : "OTTHUMG00000151177.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 22887780,
      stop : 22896111,
      direction : "+",
      ID : "ENSG00000254709.8",
      gene_id : "ENSG00000254709.8",
      gene_type : "protein_coding",
      gene_name : "IGLL5",
      gene_level : 2,
      hgnc_id : "HGNC:38476",
      havana_gene : "OTTHUMG00000165670.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23059415,
      stop : 23145021,
      direction : "-",
      ID : "ENSG00000100218.12",
      gene_id : "ENSG00000100218.12",
      gene_type : "protein_coding",
      gene_name : "RSPH14",
      gene_level : 1,
      hgnc_id : "HGNC:13437",
      havana_gene : "OTTHUMG00000150602.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23070519,
      stop : 23125032,
      direction : "+",
      ID : "ENSG00000128266.9",
      gene_id : "ENSG00000128266.9",
      gene_type : "protein_coding",
      gene_name : "GNAZ",
      gene_level : 2,
      hgnc_id : "HGNC:4395",
      havana_gene : "OTTHUMG00000150611.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23145326,
      stop : 23164350,
      direction : "+",
      ID : "ENSG00000100228.13",
      gene_id : "ENSG00000100228.13",
      gene_type : "protein_coding",
      gene_name : "RAB36",
      gene_level : 2,
      hgnc_id : "HGNC:9775",
      havana_gene : "OTTHUMG00000150601.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23179704,
      stop : 23318037,
      direction : "+",
      ID : "ENSG00000186716.21",
      gene_id : "ENSG00000186716.21",
      gene_type : "protein_coding",
      gene_name : "BCR",
      gene_level : 2,
      hgnc_id : "HGNC:1014",
      havana_gene : "OTTHUMG00000150655.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23573125,
      stop : 23580302,
      direction : "-",
      ID : "ENSG00000128322.7",
      gene_id : "ENSG00000128322.7",
      gene_type : "protein_coding",
      gene_name : "IGLL1",
      gene_level : 2,
      hgnc_id : "HGNC:5870",
      havana_gene : "OTTHUMG00000150673.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23608452,
      stop : 23632321,
      direction : "-",
      ID : "ENSG00000189269.12",
      gene_id : "ENSG00000189269.12",
      gene_type : "protein_coding",
      gene_name : "DRICH1",
      gene_level : 2,
      hgnc_id : "HGNC:28031",
      havana_gene : "OTTHUMG00000186352.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23688136,
      stop : 23699176,
      direction : "+",
      ID : "ENSG00000159496.14",
      gene_id : "ENSG00000159496.14",
      gene_type : "protein_coding",
      gene_name : "RGL4",
      gene_level : 1,
      hgnc_id : "HGNC:31911",
      havana_gene : "OTTHUMG00000150711.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23738682,
      stop : 23751112,
      direction : "-",
      ID : "ENSG00000187792.5",
      gene_id : "ENSG00000187792.5",
      gene_type : "protein_coding",
      gene_name : "ZNF70",
      gene_level : 2,
      hgnc_id : "HGNC:13140",
      havana_gene : "OTTHUMG00000150739.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23752743,
      stop : 23754425,
      direction : "-",
      ID : "ENSG00000128218.8",
      gene_id : "ENSG00000128218.8",
      gene_type : "protein_coding",
      gene_name : "VPREB3",
      gene_level : 1,
      hgnc_id : "HGNC:12710",
      havana_gene : "OTTHUMG00000150738.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23762990,
      stop : 23765863,
      direction : "+",
      ID : "ENSG00000169314.15",
      gene_id : "ENSG00000169314.15",
      gene_type : "protein_coding",
      gene_name : "C22orf15",
      gene_level : 2,
      hgnc_id : "HGNC:15558",
      havana_gene : "OTTHUMG00000150740.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23765834,
      stop : 23767972,
      direction : "-",
      ID : "ENSG00000250479.9",
      gene_id : "ENSG00000250479.9",
      gene_type : "protein_coding",
      gene_name : "CHCHD10",
      gene_level : 1,
      hgnc_id : "HGNC:15559",
      havana_gene : "OTTHUMG00000150736.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23768226,
      stop : 23784316,
      direction : "+",
      ID : "ENSG00000099953.10",
      gene_id : "ENSG00000099953.10",
      gene_type : "protein_coding",
      gene_name : "MMP11",
      gene_level : 2,
      hgnc_id : "HGNC:7157",
      havana_gene : "OTTHUMG00000150742.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23786931,
      stop : 23838009,
      direction : "+",
      ID : "ENSG00000099956.20",
      gene_id : "ENSG00000099956.20",
      gene_type : "protein_coding",
      gene_name : "SMARCB1",
      gene_level : 1,
      hgnc_id : "HGNC:11103",
      havana_gene : "OTTHUMG00000150737.11",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23834503,
      stop : 23839128,
      direction : "-",
      ID : "ENSG00000099958.15",
      gene_id : "ENSG00000099958.15",
      gene_type : "protein_coding",
      gene_name : "DERL3",
      gene_level : 1,
      hgnc_id : "HGNC:14236",
      havana_gene : "OTTHUMG00000150743.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23856703,
      stop : 23886309,
      direction : "+",
      ID : "ENSG00000133460.19",
      gene_id : "ENSG00000133460.19",
      gene_type : "protein_coding",
      gene_name : "SLC2A11",
      gene_level : 1,
      hgnc_id : "HGNC:14239",
      havana_gene : "OTTHUMG00000166469.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23862188,
      stop : 23895223,
      direction : "+",
      ID : "ENSG00000251357.4",
      gene_id : "ENSG00000251357.4",
      gene_type : "protein_coding",
      gene_name : "AP000350.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000150787.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23894383,
      stop : 23895227,
      direction : "+",
      ID : "ENSG00000240972.2",
      gene_id : "ENSG00000240972.2",
      gene_type : "protein_coding",
      gene_name : "MIF",
      gene_level : 2,
      hgnc_id : "HGNC:7097",
      havana_gene : "OTTHUMG00000150773.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23957414,
      stop : 23961195,
      direction : "-",
      ID : "ENSG00000133433.11",
      gene_id : "ENSG00000133433.11",
      gene_type : "protein_coding",
      gene_name : "GSTT2B",
      gene_level : 2,
      hgnc_id : "HGNC:33437",
      havana_gene : "OTTHUMG00000150774.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23966888,
      stop : 23972556,
      direction : "+",
      ID : "ENSG00000099974.8",
      gene_id : "ENSG00000099974.8",
      gene_type : "protein_coding",
      gene_name : "DDTL",
      gene_level : 2,
      hgnc_id : "HGNC:33446",
      havana_gene : "OTTHUMG00000150800.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23971365,
      stop : 23979828,
      direction : "-",
      ID : "ENSG00000099977.14",
      gene_id : "ENSG00000099977.14",
      gene_type : "protein_coding",
      gene_name : "DDT",
      gene_level : 2,
      hgnc_id : "HGNC:2732",
      havana_gene : "OTTHUMG00000193422.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23971378,
      stop : 23980469,
      direction : "-",
      ID : "ENSG00000285762.1",
      gene_id : "ENSG00000285762.1",
      gene_type : "protein_coding",
      gene_name : "AC253536.7",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000150798.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 23998401,
      stop : 24005453,
      direction : "-",
      ID : "ENSG00000276950.5",
      gene_id : "ENSG00000276950.5",
      gene_type : "protein_coding",
      gene_name : "GSTT4",
      gene_level : 2,
      hgnc_id : "HGNC:26930",
      havana_gene : "OTTHUMG00000150811.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24011192,
      stop : 24178628,
      direction : "+",
      ID : "ENSG00000099991.18",
      gene_id : "ENSG00000099991.18",
      gene_type : "protein_coding",
      gene_name : "CABIN1",
      gene_level : 1,
      hgnc_id : "HGNC:24187",
      havana_gene : "OTTHUMG00000150797.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24181487,
      stop : 24189106,
      direction : "+",
      ID : "ENSG00000099994.11",
      gene_id : "ENSG00000099994.11",
      gene_type : "protein_coding",
      gene_name : "SUSD2",
      gene_level : 2,
      hgnc_id : "HGNC:30667",
      havana_gene : "OTTHUMG00000150792.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24219654,
      stop : 24245108,
      direction : "-",
      ID : "ENSG00000099998.19",
      gene_id : "ENSG00000099998.19",
      gene_type : "protein_coding",
      gene_name : "GGT5",
      gene_level : 2,
      hgnc_id : "HGNC:4260",
      havana_gene : "OTTHUMG00000150796.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24270817,
      stop : 24417739,
      direction : "+",
      ID : "ENSG00000100014.20",
      gene_id : "ENSG00000100014.20",
      gene_type : "protein_coding",
      gene_name : "SPECC1L",
      gene_level : 2,
      hgnc_id : "HGNC:29022",
      havana_gene : "OTTHUMG00000171450.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24270898,
      stop : 24442356,
      direction : "+",
      ID : "ENSG00000258555.6",
      gene_id : "ENSG00000258555.6",
      gene_type : "protein_coding",
      gene_name : "SPECC1L-ADORA2A",
      gene_level : 2,
      hgnc_id : "HGNC:49185",
      havana_gene : "OTTHUMG00000150762.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24417879,
      stop : 24442357,
      direction : "+",
      ID : "ENSG00000128271.22",
      gene_id : "ENSG00000128271.22",
      gene_type : "protein_coding",
      gene_name : "ADORA2A",
      gene_level : 2,
      hgnc_id : "HGNC:263",
      havana_gene : "OTTHUMG00000150761.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24494107,
      stop : 24528390,
      direction : "+",
      ID : "ENSG00000100024.15",
      gene_id : "ENSG00000100024.15",
      gene_type : "protein_coding",
      gene_name : "UPB1",
      gene_level : 2,
      hgnc_id : "HGNC:16297",
      havana_gene : "OTTHUMG00000150749.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24540423,
      stop : 24555935,
      direction : "-",
      ID : "ENSG00000138867.17",
      gene_id : "ENSG00000138867.17",
      gene_type : "protein_coding",
      gene_name : "GUCD1",
      gene_level : 1,
      hgnc_id : "HGNC:14237",
      havana_gene : "OTTHUMG00000150728.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24555958,
      stop : 24582052,
      direction : "+",
      ID : "ENSG00000100028.12",
      gene_id : "ENSG00000100028.12",
      gene_type : "protein_coding",
      gene_name : "SNRPD3",
      gene_level : 2,
      hgnc_id : "HGNC:11160",
      havana_gene : "OTTHUMG00000150727.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24556007,
      stop : 24628987,
      direction : "+",
      ID : "ENSG00000286070.2",
      gene_id : "ENSG00000286070.2",
      gene_type : "protein_coding",
      gene_name : "AP000356.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193456.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24585620,
      stop : 24593208,
      direction : "-",
      ID : "ENSG00000178026.13",
      gene_id : "ENSG00000178026.13",
      gene_type : "protein_coding",
      gene_name : "LRRC75B",
      gene_level : 2,
      hgnc_id : "HGNC:33155",
      havana_gene : "OTTHUMG00000150729.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24594811,
      stop : 24629005,
      direction : "+",
      ID : "ENSG00000100031.19",
      gene_id : "ENSG00000100031.19",
      gene_type : "protein_coding",
      gene_name : "GGT1",
      gene_level : 2,
      hgnc_id : "HGNC:4250",
      havana_gene : "OTTHUMG00000030859.34",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24719034,
      stop : 24774720,
      direction : "-",
      ID : "ENSG00000184571.13",
      gene_id : "ENSG00000184571.13",
      gene_type : "protein_coding",
      gene_name : "PIWIL3",
      gene_level : 1,
      hgnc_id : "HGNC:18443",
      havana_gene : "OTTHUMG00000150788.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24806169,
      stop : 24927578,
      direction : "+",
      ID : "ENSG00000167037.19",
      gene_id : "ENSG00000167037.19",
      gene_type : "protein_coding",
      gene_name : "SGSM1",
      gene_level : 2,
      hgnc_id : "HGNC:29410",
      havana_gene : "OTTHUMG00000150837.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24934954,
      stop : 24946695,
      direction : "-",
      ID : "ENSG00000206069.6",
      gene_id : "ENSG00000206069.6",
      gene_type : "protein_coding",
      gene_name : "TMEM211",
      gene_level : 2,
      hgnc_id : "HGNC:33725",
      havana_gene : "OTTHUMG00000150790.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 24952730,
      stop : 25197448,
      direction : "+",
      ID : "ENSG00000197077.13",
      gene_id : "ENSG00000197077.13",
      gene_type : "protein_coding",
      gene_name : "KIAA1671",
      gene_level : 2,
      hgnc_id : "HGNC:29345",
      havana_gene : "OTTHUMG00000150841.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 25199858,
      stop : 25207359,
      direction : "+",
      ID : "ENSG00000100053.10",
      gene_id : "ENSG00000100053.10",
      gene_type : "protein_coding",
      gene_name : "CRYBB3",
      gene_level : 1,
      hgnc_id : "HGNC:2400",
      havana_gene : "OTTHUMG00000150869.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 25212564,
      stop : 25231870,
      direction : "+",
      ID : "ENSG00000244752.3",
      gene_id : "ENSG00000244752.3",
      gene_type : "protein_coding",
      gene_name : "CRYBB2",
      gene_level : 2,
      hgnc_id : "HGNC:2398",
      havana_gene : "OTTHUMG00000150905.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 25564675,
      stop : 25729294,
      direction : "+",
      ID : "ENSG00000100077.15",
      gene_id : "ENSG00000100077.15",
      gene_type : "protein_coding",
      gene_name : "GRK3",
      gene_level : 2,
      hgnc_id : "HGNC:290",
      havana_gene : "OTTHUMG00000150280.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 25742144,
      stop : 26031045,
      direction : "+",
      ID : "ENSG00000133454.16",
      gene_id : "ENSG00000133454.16",
      gene_type : "protein_coding",
      gene_name : "MYO18B",
      gene_level : 1,
      hgnc_id : "HGNC:18150",
      havana_gene : "OTTHUMG00000151129.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26169462,
      stop : 26383597,
      direction : "+",
      ID : "ENSG00000100095.19",
      gene_id : "ENSG00000100095.19",
      gene_type : "protein_coding",
      gene_name : "SEZ6L",
      gene_level : 2,
      hgnc_id : "HGNC:10763",
      havana_gene : "OTTHUMG00000150870.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26429260,
      stop : 26445015,
      direction : "+",
      ID : "ENSG00000128203.7",
      gene_id : "ENSG00000128203.7",
      gene_type : "protein_coding",
      gene_name : "ASPHD2",
      gene_level : 2,
      hgnc_id : "HGNC:30437",
      havana_gene : "OTTHUMG00000150884.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26443423,
      stop : 26483837,
      direction : "-",
      ID : "ENSG00000100099.21",
      gene_id : "ENSG00000100099.21",
      gene_type : "protein_coding",
      gene_name : "HPS4",
      gene_level : 2,
      hgnc_id : "HGNC:15844",
      havana_gene : "OTTHUMG00000030459.8",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26483877,
      stop : 26494658,
      direction : "+",
      ID : "ENSG00000100104.13",
      gene_id : "ENSG00000100104.13",
      gene_type : "protein_coding",
      gene_name : "SRRD",
      gene_level : 2,
      hgnc_id : "HGNC:33910",
      havana_gene : "OTTHUMG00000150885.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26491225,
      stop : 26512505,
      direction : "-",
      ID : "ENSG00000100109.17",
      gene_id : "ENSG00000100109.17",
      gene_type : "protein_coding",
      gene_name : "TFIP11",
      gene_level : 1,
      hgnc_id : "HGNC:17165",
      havana_gene : "OTTHUMG00000150883.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26521996,
      stop : 26596717,
      direction : "-",
      ID : "ENSG00000128294.16",
      gene_id : "ENSG00000128294.16",
      gene_type : "protein_coding",
      gene_name : "TPST2",
      gene_level : 2,
      hgnc_id : "HGNC:12021",
      havana_gene : "OTTHUMG00000150987.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26599278,
      stop : 26618027,
      direction : "-",
      ID : "ENSG00000100122.7",
      gene_id : "ENSG00000100122.7",
      gene_type : "protein_coding",
      gene_name : "CRYBB1",
      gene_level : 2,
      hgnc_id : "HGNC:2397",
      havana_gene : "OTTHUMG00000150980.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 26621963,
      stop : 26630669,
      direction : "+",
      ID : "ENSG00000196431.4",
      gene_id : "ENSG00000196431.4",
      gene_type : "protein_coding",
      gene_name : "CRYBA4",
      gene_level : 2,
      hgnc_id : "HGNC:2396",
      havana_gene : "OTTHUMG00000150983.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 27748277,
      stop : 27801756,
      direction : "-",
      ID : "ENSG00000169184.6",
      gene_id : "ENSG00000169184.6",
      gene_type : "protein_coding",
      gene_name : "MN1",
      gene_level : 2,
      hgnc_id : "HGNC:7180",
      havana_gene : "OTTHUMG00000150975.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 27851669,
      stop : 27920134,
      direction : "-",
      ID : "ENSG00000180957.18",
      gene_id : "ENSG00000180957.18",
      gene_type : "protein_coding",
      gene_name : "PITPNB",
      gene_level : 2,
      hgnc_id : "HGNC:9002",
      havana_gene : "OTTHUMG00000150976.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 27978014,
      stop : 28679865,
      direction : "-",
      ID : "ENSG00000100154.14",
      gene_id : "ENSG00000100154.14",
      gene_type : "protein_coding",
      gene_name : "TTC28",
      gene_level : 1,
      hgnc_id : "HGNC:29179",
      havana_gene : "OTTHUMG00000151006.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 28687743,
      stop : 28742422,
      direction : "-",
      ID : "ENSG00000183765.23",
      gene_id : "ENSG00000183765.23",
      gene_type : "protein_coding",
      gene_name : "CHEK2",
      gene_level : 1,
      hgnc_id : "HGNC:16627",
      havana_gene : "OTTHUMG00000151023.24",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 28742039,
      stop : 28757515,
      direction : "+",
      ID : "ENSG00000100209.11",
      gene_id : "ENSG00000100209.11",
      gene_type : "protein_coding",
      gene_name : "HSCB",
      gene_level : 2,
      hgnc_id : "HGNC:28913",
      havana_gene : "OTTHUMG00000151092.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 28772674,
      stop : 28789301,
      direction : "+",
      ID : "ENSG00000159873.10",
      gene_id : "ENSG00000159873.10",
      gene_type : "protein_coding",
      gene_name : "CCDC117",
      gene_level : 2,
      hgnc_id : "HGNC:26599",
      havana_gene : "OTTHUMG00000151091.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 28794555,
      stop : 28800597,
      direction : "-",
      ID : "ENSG00000100219.16",
      gene_id : "ENSG00000100219.16",
      gene_type : "protein_coding",
      gene_name : "XBP1",
      gene_level : 1,
      hgnc_id : "HGNC:12801",
      havana_gene : "OTTHUMG00000151094.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 28883572,
      stop : 29057488,
      direction : "+",
      ID : "ENSG00000183579.16",
      gene_id : "ENSG00000183579.16",
      gene_type : "protein_coding",
      gene_name : "ZNRF3",
      gene_level : 2,
      hgnc_id : "HGNC:18126",
      havana_gene : "OTTHUMG00000151009.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29058672,
      stop : 29061844,
      direction : "-",
      ID : "ENSG00000100249.4",
      gene_id : "ENSG00000100249.4",
      gene_type : "protein_coding",
      gene_name : "C22orf31",
      gene_level : 2,
      hgnc_id : "HGNC:26931",
      havana_gene : "OTTHUMG00000151011.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29073035,
      stop : 29168333,
      direction : "+",
      ID : "ENSG00000183762.13",
      gene_id : "ENSG00000183762.13",
      gene_type : "protein_coding",
      gene_name : "KREMEN1",
      gene_level : 2,
      hgnc_id : "HGNC:17550",
      havana_gene : "OTTHUMG00000030987.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29205896,
      stop : 29259597,
      direction : "+",
      ID : "ENSG00000186998.16",
      gene_id : "ENSG00000186998.16",
      gene_type : "protein_coding",
      gene_name : "EMID1",
      gene_level : 2,
      hgnc_id : "HGNC:18036",
      havana_gene : "OTTHUMG00000151013.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29259872,
      stop : 29268209,
      direction : "-",
      ID : "ENSG00000100263.14",
      gene_id : "ENSG00000100263.14",
      gene_type : "protein_coding",
      gene_name : "RHBDD3",
      gene_level : 1,
      hgnc_id : "HGNC:1308",
      havana_gene : "OTTHUMG00000151032.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29268009,
      stop : 29300525,
      direction : "+",
      ID : "ENSG00000182944.18",
      gene_id : "ENSG00000182944.18",
      gene_type : "protein_coding",
      gene_name : "EWSR1",
      gene_level : 1,
      hgnc_id : "HGNC:3508",
      havana_gene : "OTTHUMG00000151107.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29306582,
      stop : 29312785,
      direction : "+",
      ID : "ENSG00000185340.15",
      gene_id : "ENSG00000185340.15",
      gene_type : "protein_coding",
      gene_name : "GAS2L1",
      gene_level : 1,
      hgnc_id : "HGNC:16955",
      havana_gene : "OTTHUMG00000151108.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29312933,
      stop : 29319679,
      direction : "-",
      ID : "ENSG00000100276.10",
      gene_id : "ENSG00000100276.10",
      gene_type : "protein_coding",
      gene_name : "RASL10A",
      gene_level : 2,
      hgnc_id : "HGNC:16954",
      havana_gene : "OTTHUMG00000151106.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29327680,
      stop : 29388583,
      direction : "-",
      ID : "ENSG00000100280.17",
      gene_id : "ENSG00000100280.17",
      gene_type : "protein_coding",
      gene_name : "AP1B1",
      gene_level : 2,
      hgnc_id : "HGNC:554",
      havana_gene : "OTTHUMG00000151109.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29438583,
      stop : 29442455,
      direction : "+",
      ID : "ENSG00000128250.5",
      gene_id : "ENSG00000128250.5",
      gene_type : "protein_coding",
      gene_name : "RFPL1",
      gene_level : 2,
      hgnc_id : "HGNC:9977",
      havana_gene : "OTTHUMG00000150516.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29480218,
      stop : 29491390,
      direction : "+",
      ID : "ENSG00000100285.10",
      gene_id : "ENSG00000100285.10",
      gene_type : "protein_coding",
      gene_name : "NEFH",
      gene_level : 2,
      hgnc_id : "HGNC:7737",
      havana_gene : "OTTHUMG00000151155.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29505879,
      stop : 29555216,
      direction : "-",
      ID : "ENSG00000100296.14",
      gene_id : "ENSG00000100296.14",
      gene_type : "protein_coding",
      gene_name : "THOC5",
      gene_level : 2,
      hgnc_id : "HGNC:19074",
      havana_gene : "OTTHUMG00000151291.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29554808,
      stop : 29581327,
      direction : "-",
      ID : "ENSG00000184117.12",
      gene_id : "ENSG00000184117.12",
      gene_type : "protein_coding",
      gene_name : "NIPSNAP1",
      gene_level : 1,
      hgnc_id : "HGNC:7827",
      havana_gene : "OTTHUMG00000151294.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29603556,
      stop : 29698598,
      direction : "+",
      ID : "ENSG00000186575.19",
      gene_id : "ENSG00000186575.19",
      gene_type : "protein_coding",
      gene_name : "NF2",
      gene_level : 2,
      hgnc_id : "HGNC:7773",
      havana_gene : "OTTHUMG00000030727.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29720003,
      stop : 29731833,
      direction : "+",
      ID : "ENSG00000100314.4",
      gene_id : "ENSG00000100314.4",
      gene_type : "protein_coding",
      gene_name : "CABP7",
      gene_level : 2,
      hgnc_id : "HGNC:20834",
      havana_gene : "OTTHUMG00000151282.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29730956,
      stop : 29767011,
      direction : "-",
      ID : "ENSG00000100319.13",
      gene_id : "ENSG00000100319.13",
      gene_type : "protein_coding",
      gene_name : "ZMAT5",
      gene_level : 2,
      hgnc_id : "HGNC:28046",
      havana_gene : "OTTHUMG00000151292.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29767369,
      stop : 29770413,
      direction : "+",
      ID : "ENSG00000184076.13",
      gene_id : "ENSG00000184076.13",
      gene_type : "protein_coding",
      gene_name : "UQCR10",
      gene_level : 2,
      hgnc_id : "HGNC:30863",
      havana_gene : "OTTHUMG00000151283.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29788609,
      stop : 29838304,
      direction : "-",
      ID : "ENSG00000100325.15",
      gene_id : "ENSG00000100325.15",
      gene_type : "protein_coding",
      gene_name : "ASCC2",
      gene_level : 1,
      hgnc_id : "HGNC:24103",
      havana_gene : "OTTHUMG00000067658.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 29883169,
      stop : 30030868,
      direction : "+",
      ID : "ENSG00000100330.16",
      gene_id : "ENSG00000100330.16",
      gene_type : "protein_coding",
      gene_name : "MTMR3",
      gene_level : 1,
      hgnc_id : "HGNC:7451",
      havana_gene : "OTTHUMG00000151278.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30080464,
      stop : 30177075,
      direction : "+",
      ID : "ENSG00000176635.18",
      gene_id : "ENSG00000176635.18",
      gene_type : "protein_coding",
      gene_name : "HORMAD2",
      gene_level : 2,
      hgnc_id : "HGNC:28383",
      havana_gene : "OTTHUMG00000150881.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30240453,
      stop : 30246759,
      direction : "-",
      ID : "ENSG00000128342.5",
      gene_id : "ENSG00000128342.5",
      gene_type : "protein_coding",
      gene_name : "LIF",
      gene_level : 2,
      hgnc_id : "HGNC:6596",
      havana_gene : "OTTHUMG00000150910.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30262829,
      stop : 30266851,
      direction : "-",
      ID : "ENSG00000099985.4",
      gene_id : "ENSG00000099985.4",
      gene_type : "protein_coding",
      gene_name : "OSM",
      gene_level : 1,
      hgnc_id : "HGNC:8506",
      havana_gene : "OTTHUMG00000150913.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30285117,
      stop : 30289622,
      direction : "-",
      ID : "ENSG00000239282.8",
      gene_id : "ENSG00000239282.8",
      gene_type : "protein_coding",
      gene_name : "CASTOR1",
      gene_level : 2,
      hgnc_id : "HGNC:34423",
      havana_gene : "OTTHUMG00000150929.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30285238,
      stop : 30299482,
      direction : "-",
      ID : "ENSG00000248751.6",
      gene_id : "ENSG00000248751.6",
      gene_type : "protein_coding",
      gene_name : "AC004997.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162144.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30291990,
      stop : 30326947,
      direction : "-",
      ID : "ENSG00000099992.16",
      gene_id : "ENSG00000099992.16",
      gene_type : "protein_coding",
      gene_name : "TBC1D10A",
      gene_level : 1,
      hgnc_id : "HGNC:23609",
      havana_gene : "OTTHUMG00000150924.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30331988,
      stop : 30356919,
      direction : "-",
      ID : "ENSG00000099995.19",
      gene_id : "ENSG00000099995.19",
      gene_type : "protein_coding",
      gene_name : "SF3A1",
      gene_level : 2,
      hgnc_id : "HGNC:10765",
      havana_gene : "OTTHUMG00000151005.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30356635,
      stop : 30378658,
      direction : "+",
      ID : "ENSG00000187860.10",
      gene_id : "ENSG00000187860.10",
      gene_type : "protein_coding",
      gene_name : "CCDC157",
      gene_level : 2,
      hgnc_id : "HGNC:33854",
      havana_gene : "OTTHUMG00000151007.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30368811,
      stop : 30421771,
      direction : "-",
      ID : "ENSG00000099999.15",
      gene_id : "ENSG00000099999.15",
      gene_type : "protein_coding",
      gene_name : "RNF215",
      gene_level : 2,
      hgnc_id : "HGNC:33434",
      havana_gene : "OTTHUMG00000151016.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30396941,
      stop : 30425303,
      direction : "+",
      ID : "ENSG00000100003.18",
      gene_id : "ENSG00000100003.18",
      gene_type : "protein_coding",
      gene_name : "SEC14L2",
      gene_level : 2,
      hgnc_id : "HGNC:10699",
      havana_gene : "OTTHUMG00000151024.28",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30409255,
      stop : 30428990,
      direction : "+",
      ID : "ENSG00000249590.7",
      gene_id : "ENSG00000249590.7",
      gene_type : "protein_coding",
      gene_name : "AC004832.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000160853.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30425623,
      stop : 30429054,
      direction : "+",
      ID : "ENSG00000242114.6",
      gene_id : "ENSG00000242114.6",
      gene_type : "protein_coding",
      gene_name : "MTFP1",
      gene_level : 2,
      hgnc_id : "HGNC:26945",
      havana_gene : "OTTHUMG00000151057.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30447959,
      stop : 30472017,
      direction : "-",
      ID : "ENSG00000100012.12",
      gene_id : "ENSG00000100012.12",
      gene_type : "protein_coding",
      gene_name : "SEC14L3",
      gene_level : 1,
      hgnc_id : "HGNC:18655",
      havana_gene : "OTTHUMG00000151259.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30488902,
      stop : 30505711,
      direction : "-",
      ID : "ENSG00000133488.15",
      gene_id : "ENSG00000133488.15",
      gene_type : "protein_coding",
      gene_name : "SEC14L4",
      gene_level : 1,
      hgnc_id : "HGNC:20627",
      havana_gene : "OTTHUMG00000151258.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30522799,
      stop : 30546682,
      direction : "-",
      ID : "ENSG00000214491.8",
      gene_id : "ENSG00000214491.8",
      gene_type : "protein_coding",
      gene_name : "SEC14L6",
      gene_level : 1,
      hgnc_id : "HGNC:40047",
      havana_gene : "OTTHUMG00000151267.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30554635,
      stop : 30574665,
      direction : "-",
      ID : "ENSG00000128242.13",
      gene_id : "ENSG00000128242.13",
      gene_type : "protein_coding",
      gene_name : "GAL3ST1",
      gene_level : 1,
      hgnc_id : "HGNC:24240",
      havana_gene : "OTTHUMG00000151200.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30576625,
      stop : 30607083,
      direction : "-",
      ID : "ENSG00000100029.18",
      gene_id : "ENSG00000100029.18",
      gene_type : "protein_coding",
      gene_name : "PES1",
      gene_level : 1,
      hgnc_id : "HGNC:8848",
      havana_gene : "OTTHUMG00000151077.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30607003,
      stop : 30627271,
      direction : "+",
      ID : "ENSG00000185339.9",
      gene_id : "ENSG00000185339.9",
      gene_type : "protein_coding",
      gene_name : "TCN2",
      gene_level : 1,
      hgnc_id : "HGNC:11653",
      havana_gene : "OTTHUMG00000151095.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30635781,
      stop : 30669016,
      direction : "+",
      ID : "ENSG00000100036.13",
      gene_id : "ENSG00000100036.13",
      gene_type : "protein_coding",
      gene_name : "SLC35E4",
      gene_level : 2,
      hgnc_id : "HGNC:17058",
      havana_gene : "OTTHUMG00000151110.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30652051,
      stop : 30667887,
      direction : "-",
      ID : "ENSG00000167065.14",
      gene_id : "ENSG00000167065.14",
      gene_type : "protein_coding",
      gene_name : "DUSP18",
      gene_level : 1,
      hgnc_id : "HGNC:18484",
      havana_gene : "OTTHUMG00000151115.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30693782,
      stop : 30907824,
      direction : "+",
      ID : "ENSG00000184792.16",
      gene_id : "ENSG00000184792.16",
      gene_type : "protein_coding",
      gene_name : "OSBP2",
      gene_level : 1,
      hgnc_id : "HGNC:8504",
      havana_gene : "OTTHUMG00000151153.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30925130,
      stop : 30968774,
      direction : "-",
      ID : "ENSG00000133422.14",
      gene_id : "ENSG00000133422.14",
      gene_type : "protein_coding",
      gene_name : "MORC2",
      gene_level : 2,
      hgnc_id : "HGNC:23573",
      havana_gene : "OTTHUMG00000151193.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 30969245,
      stop : 30979395,
      direction : "+",
      ID : "ENSG00000253352.10",
      gene_id : "ENSG00000253352.10",
      gene_type : "protein_coding",
      gene_name : "TUG1",
      gene_level : 2,
      hgnc_id : "HGNC:26066",
      havana_gene : "OTTHUMG00000030444.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31064105,
      stop : 31104757,
      direction : "+",
      ID : "ENSG00000183963.19",
      gene_id : "ENSG00000183963.19",
      gene_type : "protein_coding",
      gene_name : "SMTN",
      gene_level : 1,
      hgnc_id : "HGNC:11126",
      havana_gene : "OTTHUMG00000151203.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31104772,
      stop : 31120069,
      direction : "-",
      ID : "ENSG00000198832.10",
      gene_id : "ENSG00000198832.10",
      gene_type : "protein_coding",
      gene_name : "SELENOM",
      gene_level : 2,
      hgnc_id : "HGNC:30397",
      havana_gene : "OTTHUMG00000151207.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31122731,
      stop : 31134697,
      direction : "+",
      ID : "ENSG00000185133.14",
      gene_id : "ENSG00000185133.14",
      gene_type : "protein_coding",
      gene_name : "INPP5J",
      gene_level : 2,
      hgnc_id : "HGNC:8956",
      havana_gene : "OTTHUMG00000151206.12",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31134807,
      stop : 31140508,
      direction : "-",
      ID : "ENSG00000100078.4",
      gene_id : "ENSG00000100078.4",
      gene_type : "protein_coding",
      gene_name : "PLA2G3",
      gene_level : 2,
      hgnc_id : "HGNC:17934",
      havana_gene : "OTTHUMG00000151255.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31160182,
      stop : 31207019,
      direction : "+",
      ID : "ENSG00000138942.16",
      gene_id : "ENSG00000138942.16",
      gene_type : "protein_coding",
      gene_name : "RNF185",
      gene_level : 2,
      hgnc_id : "HGNC:26783",
      havana_gene : "OTTHUMG00000151253.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31212239,
      stop : 31280080,
      direction : "+",
      ID : "ENSG00000182541.18",
      gene_id : "ENSG00000182541.18",
      gene_type : "protein_coding",
      gene_name : "LIMK2",
      gene_level : 2,
      hgnc_id : "HGNC:6614",
      havana_gene : "OTTHUMG00000151251.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31281594,
      stop : 31292534,
      direction : "-",
      ID : "ENSG00000100100.13",
      gene_id : "ENSG00000100100.13",
      gene_type : "protein_coding",
      gene_name : "PIK3IP1",
      gene_level : 2,
      hgnc_id : "HGNC:24942",
      havana_gene : "OTTHUMG00000151256.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31325804,
      stop : 31346346,
      direction : "-",
      ID : "ENSG00000100105.18",
      gene_id : "ENSG00000100105.18",
      gene_type : "protein_coding",
      gene_name : "PATZ1",
      gene_level : 2,
      hgnc_id : "HGNC:13071",
      havana_gene : "OTTHUMG00000151254.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31399604,
      stop : 31530634,
      direction : "+",
      ID : "ENSG00000185721.13",
      gene_id : "ENSG00000185721.13",
      gene_type : "protein_coding",
      gene_name : "DRG1",
      gene_level : 2,
      hgnc_id : "HGNC:3029",
      havana_gene : "OTTHUMG00000030792.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31436977,
      stop : 31496108,
      direction : "-",
      ID : "ENSG00000184708.18",
      gene_id : "ENSG00000184708.18",
      gene_type : "protein_coding",
      gene_name : "EIF4ENIF1",
      gene_level : 1,
      hgnc_id : "HGNC:16687",
      havana_gene : "OTTHUMG00000030793.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31488688,
      stop : 31618588,
      direction : "+",
      ID : "ENSG00000198089.16",
      gene_id : "ENSG00000198089.16",
      gene_type : "protein_coding",
      gene_name : "SFI1",
      gene_level : 1,
      hgnc_id : "HGNC:29064",
      havana_gene : "OTTHUMG00000030249.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31618491,
      stop : 31662432,
      direction : "-",
      ID : "ENSG00000241878.11",
      gene_id : "ENSG00000241878.11",
      gene_type : "protein_coding",
      gene_name : "PISD",
      gene_level : 1,
      hgnc_id : "HGNC:8999",
      havana_gene : "OTTHUMG00000030252.28",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31676256,
      stop : 31750140,
      direction : "-",
      ID : "ENSG00000183530.14",
      gene_id : "ENSG00000183530.14",
      gene_type : "protein_coding",
      gene_name : "PRR14L",
      gene_level : 2,
      hgnc_id : "HGNC:28738",
      havana_gene : "OTTHUMG00000030139.16",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31753867,
      stop : 31908033,
      direction : "+",
      ID : "ENSG00000100150.20",
      gene_id : "ENSG00000100150.20",
      gene_type : "protein_coding",
      gene_name : "DEPDC5",
      gene_level : 2,
      hgnc_id : "HGNC:18423",
      havana_gene : "OTTHUMG00000030926.30",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31754899,
      stop : 31956243,
      direction : "+",
      ID : "ENSG00000285404.1",
      gene_id : "ENSG00000285404.1",
      gene_type : "protein_coding",
      gene_name : "Z82190.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192528.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 31944522,
      stop : 31957603,
      direction : "+",
      ID : "ENSG00000128245.15",
      gene_id : "ENSG00000128245.15",
      gene_type : "protein_coding",
      gene_name : "YWHAH",
      gene_level : 1,
      hgnc_id : "HGNC:12853",
      havana_gene : "OTTHUMG00000030833.10",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32043261,
      stop : 32113029,
      direction : "+",
      ID : "ENSG00000100170.10",
      gene_id : "ENSG00000100170.10",
      gene_type : "protein_coding",
      gene_name : "SLC5A1",
      gene_level : 2,
      hgnc_id : "HGNC:11036",
      havana_gene : "OTTHUMG00000030768.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32149006,
      stop : 32159322,
      direction : "-",
      ID : "ENSG00000205856.4",
      gene_id : "ENSG00000205856.4",
      gene_type : "protein_coding",
      gene_name : "C22orf42",
      gene_level : 2,
      hgnc_id : "HGNC:27160",
      havana_gene : "OTTHUMG00000030380.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32190435,
      stop : 32205001,
      direction : "-",
      ID : "ENSG00000128253.15",
      gene_id : "ENSG00000128253.15",
      gene_type : "protein_coding",
      gene_name : "RFPL2",
      gene_level : 2,
      hgnc_id : "HGNC:9979",
      havana_gene : "OTTHUMG00000030374.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32218464,
      stop : 32255347,
      direction : "-",
      ID : "ENSG00000100191.6",
      gene_id : "ENSG00000100191.6",
      gene_type : "protein_coding",
      gene_name : "SLC5A4",
      gene_level : 2,
      hgnc_id : "HGNC:11039",
      havana_gene : "OTTHUMG00000150007.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32354885,
      stop : 32361161,
      direction : "+",
      ID : "ENSG00000128276.10",
      gene_id : "ENSG00000128276.10",
      gene_type : "protein_coding",
      gene_name : "RFPL3",
      gene_level : 2,
      hgnc_id : "HGNC:9980",
      havana_gene : "OTTHUMG00000030290.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32387582,
      stop : 32412248,
      direction : "-",
      ID : "ENSG00000100220.12",
      gene_id : "ENSG00000100220.12",
      gene_type : "protein_coding",
      gene_name : "RTCB",
      gene_level : 2,
      hgnc_id : "HGNC:26935",
      havana_gene : "OTTHUMG00000030300.8",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32413847,
      stop : 32464484,
      direction : "-",
      ID : "ENSG00000184459.8",
      gene_id : "ENSG00000184459.8",
      gene_type : "protein_coding",
      gene_name : "BPIFC",
      gene_level : 2,
      hgnc_id : "HGNC:16503",
      havana_gene : "OTTHUMG00000058273.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32474676,
      stop : 32498829,
      direction : "+",
      ID : "ENSG00000100225.18",
      gene_id : "ENSG00000100225.18",
      gene_type : "protein_coding",
      gene_name : "FBXO7",
      gene_level : 1,
      hgnc_id : "HGNC:13586",
      havana_gene : "OTTHUMG00000030674.12",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32507820,
      stop : 33058381,
      direction : "-",
      ID : "ENSG00000185666.15",
      gene_id : "ENSG00000185666.15",
      gene_type : "protein_coding",
      gene_name : "SYN3",
      gene_level : 2,
      hgnc_id : "HGNC:11496",
      havana_gene : "OTTHUMG00000031004.25",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 32801705,
      stop : 32863041,
      direction : "+",
      ID : "ENSG00000100234.12",
      gene_id : "ENSG00000100234.12",
      gene_type : "protein_coding",
      gene_name : "TIMP3",
      gene_level : 2,
      hgnc_id : "HGNC:11822",
      havana_gene : "OTTHUMG00000030784.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 33162226,
      stop : 33922841,
      direction : "-",
      ID : "ENSG00000133424.22",
      gene_id : "ENSG00000133424.22",
      gene_type : "protein_coding",
      gene_name : "LARGE1",
      gene_level : 2,
      hgnc_id : "HGNC:6511",
      havana_gene : "OTTHUMG00000150914.20",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35066136,
      stop : 35087387,
      direction : "+",
      ID : "ENSG00000175329.13",
      gene_id : "ENSG00000175329.13",
      gene_type : "protein_coding",
      gene_name : "ISX",
      gene_level : 2,
      hgnc_id : "HGNC:28084",
      havana_gene : "OTTHUMG00000150962.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35257452,
      stop : 35295807,
      direction : "+",
      ID : "ENSG00000100281.14",
      gene_id : "ENSG00000100281.14",
      gene_type : "protein_coding",
      gene_name : "HMGXB4",
      gene_level : 2,
      hgnc_id : "HGNC:5003",
      havana_gene : "OTTHUMG00000150439.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35299275,
      stop : 35347992,
      direction : "+",
      ID : "ENSG00000100284.22",
      gene_id : "ENSG00000100284.22",
      gene_type : "protein_coding",
      gene_name : "TOM1",
      gene_level : 2,
      hgnc_id : "HGNC:11982",
      havana_gene : "OTTHUMG00000150958.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35380361,
      stop : 35394214,
      direction : "+",
      ID : "ENSG00000100292.18",
      gene_id : "ENSG00000100292.18",
      gene_type : "protein_coding",
      gene_name : "HMOX1",
      gene_level : 2,
      hgnc_id : "HGNC:5013",
      havana_gene : "OTTHUMG00000150960.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35400134,
      stop : 35425431,
      direction : "+",
      ID : "ENSG00000100297.16",
      gene_id : "ENSG00000100297.16",
      gene_type : "protein_coding",
      gene_name : "MCM5",
      gene_level : 1,
      hgnc_id : "HGNC:6948",
      havana_gene : "OTTHUMG00000150961.19",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35540831,
      stop : 35553999,
      direction : "+",
      ID : "ENSG00000100302.7",
      gene_id : "ENSG00000100302.7",
      gene_type : "protein_coding",
      gene_name : "RASD2",
      gene_level : 2,
      hgnc_id : "HGNC:18229",
      havana_gene : "OTTHUMG00000150607.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35606764,
      stop : 35637951,
      direction : "-",
      ID : "ENSG00000198125.13",
      gene_id : "ENSG00000198125.13",
      gene_type : "protein_coding",
      gene_name : "MB",
      gene_level : 1,
      hgnc_id : "HGNC:6915",
      havana_gene : "OTTHUMG00000150606.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35648446,
      stop : 35668404,
      direction : "+",
      ID : "ENSG00000221963.6",
      gene_id : "ENSG00000221963.6",
      gene_type : "protein_coding",
      gene_name : "APOL6",
      gene_level : 2,
      hgnc_id : "HGNC:14870",
      havana_gene : "OTTHUMG00000150615.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35717872,
      stop : 35729483,
      direction : "+",
      ID : "ENSG00000128313.2",
      gene_id : "ENSG00000128313.2",
      gene_type : "protein_coding",
      gene_name : "APOL5",
      gene_level : 2,
      hgnc_id : "HGNC:14869",
      havana_gene : "OTTHUMG00000150588.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 35738736,
      stop : 36028824,
      direction : "-",
      ID : "ENSG00000100320.23",
      gene_id : "ENSG00000100320.23",
      gene_type : "protein_coding",
      gene_name : "RBFOX2",
      gene_level : 1,
      hgnc_id : "HGNC:9906",
      havana_gene : "OTTHUMG00000150585.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36140330,
      stop : 36166177,
      direction : "-",
      ID : "ENSG00000128284.19",
      gene_id : "ENSG00000128284.19",
      gene_type : "protein_coding",
      gene_name : "APOL3",
      gene_level : 1,
      hgnc_id : "HGNC:14868",
      havana_gene : "OTTHUMG00000150632.19",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36189124,
      stop : 36204840,
      direction : "-",
      ID : "ENSG00000100336.17",
      gene_id : "ENSG00000100336.17",
      gene_type : "protein_coding",
      gene_name : "APOL4",
      gene_level : 1,
      hgnc_id : "HGNC:14867",
      havana_gene : "OTTHUMG00000150630.23",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36226209,
      stop : 36239954,
      direction : "-",
      ID : "ENSG00000128335.14",
      gene_id : "ENSG00000128335.14",
      gene_type : "protein_coding",
      gene_name : "APOL2",
      gene_level : 2,
      hgnc_id : "HGNC:619",
      havana_gene : "OTTHUMG00000150634.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36253071,
      stop : 36267530,
      direction : "+",
      ID : "ENSG00000100342.21",
      gene_id : "ENSG00000100342.21",
      gene_type : "protein_coding",
      gene_name : "APOL1",
      gene_level : 2,
      hgnc_id : "HGNC:618",
      havana_gene : "OTTHUMG00000030427.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36281280,
      stop : 36387967,
      direction : "-",
      ID : "ENSG00000100345.22",
      gene_id : "ENSG00000100345.22",
      gene_type : "protein_coding",
      gene_name : "MYH9",
      gene_level : 1,
      hgnc_id : "HGNC:7579",
      havana_gene : "OTTHUMG00000030429.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36467046,
      stop : 36481640,
      direction : "-",
      ID : "ENSG00000100348.10",
      gene_id : "ENSG00000100348.10",
      gene_type : "protein_coding",
      gene_name : "TXN2",
      gene_level : 2,
      hgnc_id : "HGNC:17772",
      havana_gene : "OTTHUMG00000150596.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36487190,
      stop : 36507043,
      direction : "-",
      ID : "ENSG00000100350.15",
      gene_id : "ENSG00000100350.15",
      gene_type : "protein_coding",
      gene_name : "FOXRED2",
      gene_level : 2,
      hgnc_id : "HGNC:26264",
      havana_gene : "OTTHUMG00000044614.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36510855,
      stop : 36529184,
      direction : "-",
      ID : "ENSG00000100353.18",
      gene_id : "ENSG00000100353.18",
      gene_type : "protein_coding",
      gene_name : "EIF3D",
      gene_level : 1,
      hgnc_id : "HGNC:3278",
      havana_gene : "OTTHUMG00000150599.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36560857,
      stop : 36703752,
      direction : "-",
      ID : "ENSG00000166862.7",
      gene_id : "ENSG00000166862.7",
      gene_type : "protein_coding",
      gene_name : "CACNG2",
      gene_level : 2,
      hgnc_id : "HGNC:1406",
      havana_gene : "OTTHUMG00000030612.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36758202,
      stop : 36776256,
      direction : "-",
      ID : "ENSG00000100360.15",
      gene_id : "ENSG00000100360.15",
      gene_type : "protein_coding",
      gene_name : "IFT27",
      gene_level : 2,
      hgnc_id : "HGNC:18626",
      havana_gene : "OTTHUMG00000150544.20",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36800684,
      stop : 36819479,
      direction : "-",
      ID : "ENSG00000100362.13",
      gene_id : "ENSG00000100362.13",
      gene_type : "protein_coding",
      gene_name : "PVALB",
      gene_level : 2,
      hgnc_id : "HGNC:9704",
      havana_gene : "OTTHUMG00000150547.15",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36860988,
      stop : 36878017,
      direction : "+",
      ID : "ENSG00000100365.16",
      gene_id : "ENSG00000100365.16",
      gene_type : "protein_coding",
      gene_name : "NCF4",
      gene_level : 2,
      hgnc_id : "HGNC:7662",
      havana_gene : "OTTHUMG00000150548.8",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36913628,
      stop : 36940439,
      direction : "+",
      ID : "ENSG00000100368.14",
      gene_id : "ENSG00000100368.14",
      gene_type : "protein_coding",
      gene_name : "CSF2RB",
      gene_level : 2,
      hgnc_id : "HGNC:2436",
      havana_gene : "OTTHUMG00000150546.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 36991120,
      stop : 37007851,
      direction : "-",
      ID : "ENSG00000185264.12",
      gene_id : "ENSG00000185264.12",
      gene_type : "protein_coding",
      gene_name : "TEX33",
      gene_level : 2,
      hgnc_id : "HGNC:28568",
      havana_gene : "OTTHUMG00000150531.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37010859,
      stop : 37020183,
      direction : "-",
      ID : "ENSG00000128311.14",
      gene_id : "ENSG00000128311.14",
      gene_type : "protein_coding",
      gene_name : "TST",
      gene_level : 2,
      hgnc_id : "HGNC:12388",
      havana_gene : "OTTHUMG00000150533.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37019635,
      stop : 37029821,
      direction : "+",
      ID : "ENSG00000128309.17",
      gene_id : "ENSG00000128309.17",
      gene_type : "protein_coding",
      gene_name : "MPST",
      gene_level : 1,
      hgnc_id : "HGNC:7223",
      havana_gene : "OTTHUMG00000150543.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37051736,
      stop : 37063390,
      direction : "+",
      ID : "ENSG00000100379.17",
      gene_id : "ENSG00000100379.17",
      gene_type : "protein_coding",
      gene_name : "KCTD17",
      gene_level : 1,
      hgnc_id : "HGNC:25705",
      havana_gene : "OTTHUMG00000150532.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37065436,
      stop : 37109713,
      direction : "-",
      ID : "ENSG00000187045.19",
      gene_id : "ENSG00000187045.19",
      gene_type : "protein_coding",
      gene_name : "TMPRSS6",
      gene_level : 1,
      hgnc_id : "HGNC:16517",
      havana_gene : "OTTHUMG00000150541.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37125843,
      stop : 37175054,
      direction : "-",
      ID : "ENSG00000100385.14",
      gene_id : "ENSG00000100385.14",
      gene_type : "protein_coding",
      gene_name : "IL2RB",
      gene_level : 2,
      hgnc_id : "HGNC:6009",
      havana_gene : "OTTHUMG00000150534.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37180166,
      stop : 37199385,
      direction : "-",
      ID : "ENSG00000133466.14",
      gene_id : "ENSG00000133466.14",
      gene_type : "protein_coding",
      gene_name : "C1QTNF6",
      gene_level : 2,
      hgnc_id : "HGNC:14343",
      havana_gene : "OTTHUMG00000150538.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37204237,
      stop : 37212477,
      direction : "-",
      ID : "ENSG00000278195.2",
      gene_id : "ENSG00000278195.2",
      gene_type : "protein_coding",
      gene_name : "SSTR3",
      gene_level : 2,
      hgnc_id : "HGNC:11332",
      havana_gene : "OTTHUMG00000150537.4",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37225270,
      stop : 37244448,
      direction : "-",
      ID : "ENSG00000128340.15",
      gene_id : "ENSG00000128340.15",
      gene_type : "protein_coding",
      gene_name : "RAC2",
      gene_level : 1,
      hgnc_id : "HGNC:9802",
      havana_gene : "OTTHUMG00000150540.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37282027,
      stop : 37315341,
      direction : "+",
      ID : "ENSG00000100055.21",
      gene_id : "ENSG00000100055.21",
      gene_type : "protein_coding",
      gene_name : "CYTH4",
      gene_level : 1,
      hgnc_id : "HGNC:9505",
      havana_gene : "OTTHUMG00000150562.21",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37367960,
      stop : 37427479,
      direction : "-",
      ID : "ENSG00000166897.16",
      gene_id : "ENSG00000166897.16",
      gene_type : "protein_coding",
      gene_name : "ELFN2",
      gene_level : 2,
      hgnc_id : "HGNC:29396",
      havana_gene : "OTTHUMG00000150558.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37469063,
      stop : 37486393,
      direction : "-",
      ID : "ENSG00000100060.18",
      gene_id : "ENSG00000100060.18",
      gene_type : "protein_coding",
      gene_name : "MFNG",
      gene_level : 2,
      hgnc_id : "HGNC:7038",
      havana_gene : "OTTHUMG00000150560.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37490362,
      stop : 37519542,
      direction : "-",
      ID : "ENSG00000100065.15",
      gene_id : "ENSG00000100065.15",
      gene_type : "protein_coding",
      gene_name : "CARD10",
      gene_level : 2,
      hgnc_id : "HGNC:16422",
      havana_gene : "OTTHUMG00000150592.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37560480,
      stop : 37569405,
      direction : "+",
      ID : "ENSG00000128283.7",
      gene_id : "ENSG00000128283.7",
      gene_type : "protein_coding",
      gene_name : "CDC42EP1",
      gene_level : 2,
      hgnc_id : "HGNC:17014",
      havana_gene : "OTTHUMG00000150591.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37570248,
      stop : 37582616,
      direction : "-",
      ID : "ENSG00000100079.7",
      gene_id : "ENSG00000100079.7",
      gene_type : "protein_coding",
      gene_name : "LGALS2",
      gene_level : 2,
      hgnc_id : "HGNC:6562",
      havana_gene : "OTTHUMG00000150590.22",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37608725,
      stop : 37633564,
      direction : "+",
      ID : "ENSG00000100083.19",
      gene_id : "ENSG00000100083.19",
      gene_type : "protein_coding",
      gene_name : "GGA1",
      gene_level : 2,
      hgnc_id : "HGNC:17842",
      havana_gene : "OTTHUMG00000030985.28",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37634654,
      stop : 37656117,
      direction : "+",
      ID : "ENSG00000100092.24",
      gene_id : "ENSG00000100092.24",
      gene_type : "protein_coding",
      gene_name : "SH3BP1",
      gene_level : 2,
      hgnc_id : "HGNC:10824",
      havana_gene : "OTTHUMG00000030996.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37639693,
      stop : 37666932,
      direction : "+",
      ID : "ENSG00000285304.1",
      gene_id : "ENSG00000285304.1",
      gene_type : "protein_coding",
      gene_name : "Z83844.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192478.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37658723,
      stop : 37666932,
      direction : "+",
      ID : "ENSG00000241360.2",
      gene_id : "ENSG00000241360.2",
      gene_type : "protein_coding",
      gene_name : "PDXP",
      gene_level : 2,
      hgnc_id : "HGNC:30259",
      havana_gene : "OTTHUMG00000044618.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37675636,
      stop : 37679802,
      direction : "+",
      ID : "ENSG00000100097.12",
      gene_id : "ENSG00000100097.12",
      gene_type : "protein_coding",
      gene_name : "LGALS1",
      gene_level : 2,
      hgnc_id : "HGNC:6561",
      havana_gene : "OTTHUMG00000150661.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37681673,
      stop : 37693476,
      direction : "+",
      ID : "ENSG00000273899.5",
      gene_id : "ENSG00000273899.5",
      gene_type : "protein_coding",
      gene_name : "NOL12",
      gene_level : 2,
      hgnc_id : "HGNC:28585",
      havana_gene : "OTTHUMG00000150660.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37686414,
      stop : 37726503,
      direction : "+",
      ID : "ENSG00000100101.15",
      gene_id : "ENSG00000100101.15",
      gene_type : "protein_coding",
      gene_name : "Z83844.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000188619.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37697048,
      stop : 37776556,
      direction : "+",
      ID : "ENSG00000100106.22",
      gene_id : "ENSG00000100106.22",
      gene_type : "protein_coding",
      gene_name : "TRIOBP",
      gene_level : 2,
      hgnc_id : "HGNC:17009",
      havana_gene : "OTTHUMG00000150657.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37805093,
      stop : 37807436,
      direction : "+",
      ID : "ENSG00000189060.5",
      gene_id : "ENSG00000189060.5",
      gene_type : "protein_coding",
      gene_name : "H1-0",
      gene_level : 2,
      hgnc_id : "HGNC:4714",
      havana_gene : "OTTHUMG00000150659.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37807905,
      stop : 37817176,
      direction : "+",
      ID : "ENSG00000100116.17",
      gene_id : "ENSG00000100116.17",
      gene_type : "protein_coding",
      gene_name : "GCAT",
      gene_level : 1,
      hgnc_id : "HGNC:4188",
      havana_gene : "OTTHUMG00000150664.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37823382,
      stop : 37825485,
      direction : "+",
      ID : "ENSG00000128310.3",
      gene_id : "ENSG00000128310.3",
      gene_type : "protein_coding",
      gene_name : "GALR3",
      gene_level : 2,
      hgnc_id : "HGNC:4134",
      havana_gene : "OTTHUMG00000150658.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37830855,
      stop : 37849327,
      direction : "-",
      ID : "ENSG00000100124.15",
      gene_id : "ENSG00000100124.15",
      gene_type : "protein_coding",
      gene_name : "ANKRD54",
      gene_level : 2,
      hgnc_id : "HGNC:25185",
      havana_gene : "OTTHUMG00000150663.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37848868,
      stop : 37889407,
      direction : "+",
      ID : "ENSG00000100129.18",
      gene_id : "ENSG00000100129.18",
      gene_type : "protein_coding",
      gene_name : "EIF3L",
      gene_level : 1,
      hgnc_id : "HGNC:18138",
      havana_gene : "OTTHUMG00000150671.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37905657,
      stop : 37942822,
      direction : "+",
      ID : "ENSG00000100139.14",
      gene_id : "ENSG00000100139.14",
      gene_type : "protein_coding",
      gene_name : "MICALL1",
      gene_level : 2,
      hgnc_id : "HGNC:29804",
      havana_gene : "OTTHUMG00000150670.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37943050,
      stop : 37953669,
      direction : "-",
      ID : "ENSG00000128346.11",
      gene_id : "ENSG00000128346.11",
      gene_type : "protein_coding",
      gene_name : "C22orf23",
      gene_level : 2,
      hgnc_id : "HGNC:18589",
      havana_gene : "OTTHUMG00000150672.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37952607,
      stop : 38041915,
      direction : "+",
      ID : "ENSG00000100142.16",
      gene_id : "ENSG00000100142.16",
      gene_type : "protein_coding",
      gene_name : "POLR2F",
      gene_level : 1,
      hgnc_id : "HGNC:9193",
      havana_gene : "OTTHUMG00000151160.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 37970686,
      stop : 37987422,
      direction : "-",
      ID : "ENSG00000100146.18",
      gene_id : "ENSG00000100146.18",
      gene_type : "protein_coding",
      gene_name : "SOX10",
      gene_level : 1,
      hgnc_id : "HGNC:11190",
      havana_gene : "OTTHUMG00000149913.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38056311,
      stop : 38075701,
      direction : "+",
      ID : "ENSG00000100151.16",
      gene_id : "ENSG00000100151.16",
      gene_type : "protein_coding",
      gene_name : "PICK1",
      gene_level : 2,
      hgnc_id : "HGNC:9394",
      havana_gene : "OTTHUMG00000151159.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38078134,
      stop : 38084093,
      direction : "-",
      ID : "ENSG00000100156.11",
      gene_id : "ENSG00000100156.11",
      gene_type : "protein_coding",
      gene_name : "SLC16A8",
      gene_level : 2,
      hgnc_id : "HGNC:16270",
      havana_gene : "OTTHUMG00000151196.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38084652,
      stop : 38111015,
      direction : "-",
      ID : "ENSG00000128298.18",
      gene_id : "ENSG00000128298.18",
      gene_type : "protein_coding",
      gene_name : "BAIAP2L2",
      gene_level : 1,
      hgnc_id : "HGNC:26203",
      havana_gene : "OTTHUMG00000151197.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38111495,
      stop : 38214778,
      direction : "-",
      ID : "ENSG00000184381.20",
      gene_id : "ENSG00000184381.20",
      gene_type : "protein_coding",
      gene_name : "PLA2G6",
      gene_level : 1,
      hgnc_id : "HGNC:9039",
      havana_gene : "OTTHUMG00000151246.10",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38200767,
      stop : 38216507,
      direction : "+",
      ID : "ENSG00000185022.12",
      gene_id : "ENSG00000185022.12",
      gene_type : "protein_coding",
      gene_name : "MAFF",
      gene_level : 2,
      hgnc_id : "HGNC:6780",
      havana_gene : "OTTHUMG00000151163.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38219291,
      stop : 38273010,
      direction : "-",
      ID : "ENSG00000198792.13",
      gene_id : "ENSG00000198792.13",
      gene_type : "protein_coding",
      gene_name : "TMEM184B",
      gene_level : 1,
      hgnc_id : "HGNC:1310",
      havana_gene : "OTTHUMG00000030557.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38290691,
      stop : 38318084,
      direction : "-",
      ID : "ENSG00000213923.13",
      gene_id : "ENSG00000213923.13",
      gene_type : "protein_coding",
      gene_name : "CSNK1E",
      gene_level : 1,
      hgnc_id : "HGNC:2453",
      havana_gene : "OTTHUMG00000151135.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38291918,
      stop : 38398522,
      direction : "-",
      ID : "ENSG00000283900.1",
      gene_id : "ENSG00000283900.1",
      gene_type : "protein_coding",
      gene_name : "TPTEP2-CSNK1E",
      gene_level : 2,
      hgnc_id : "HGNC:53829",
      havana_gene : "OTTHUMG00000192148.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38426327,
      stop : 38455199,
      direction : "-",
      ID : "ENSG00000168135.4",
      gene_id : "ENSG00000168135.4",
      gene_type : "protein_coding",
      gene_name : "KCNJ4",
      gene_level : 2,
      hgnc_id : "HGNC:6265",
      havana_gene : "OTTHUMG00000151131.1",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38468078,
      stop : 38483447,
      direction : "+",
      ID : "ENSG00000100196.11",
      gene_id : "ENSG00000100196.11",
      gene_type : "protein_coding",
      gene_name : "KDELR3",
      gene_level : 2,
      hgnc_id : "HGNC:6306",
      havana_gene : "OTTHUMG00000153520.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38483438,
      stop : 38507660,
      direction : "-",
      ID : "ENSG00000100201.23",
      gene_id : "ENSG00000100201.23",
      gene_type : "protein_coding",
      gene_name : "DDX17",
      gene_level : 2,
      hgnc_id : "HGNC:2740",
      havana_gene : "OTTHUMG00000151136.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38518948,
      stop : 38570204,
      direction : "-",
      ID : "ENSG00000100206.10",
      gene_id : "ENSG00000100206.10",
      gene_type : "protein_coding",
      gene_name : "DMC1",
      gene_level : 2,
      hgnc_id : "HGNC:2927",
      havana_gene : "OTTHUMG00000151088.18",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38578120,
      stop : 38656629,
      direction : "-",
      ID : "ENSG00000184949.17",
      gene_id : "ENSG00000184949.17",
      gene_type : "protein_coding",
      gene_name : "FAM227A",
      gene_level : 1,
      hgnc_id : "HGNC:44197",
      havana_gene : "OTTHUMG00000151133.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38656636,
      stop : 38673854,
      direction : "+",
      ID : "ENSG00000100211.10",
      gene_id : "ENSG00000100211.10",
      gene_type : "protein_coding",
      gene_name : "CBY1",
      gene_level : 2,
      hgnc_id : "HGNC:1307",
      havana_gene : "OTTHUMG00000150990.20",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38681957,
      stop : 38685421,
      direction : "+",
      ID : "ENSG00000100216.6",
      gene_id : "ENSG00000100216.6",
      gene_type : "protein_coding",
      gene_name : "TOMM22",
      gene_level : 2,
      hgnc_id : "HGNC:18002",
      havana_gene : "OTTHUMG00000150991.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38685543,
      stop : 38701556,
      direction : "-",
      ID : "ENSG00000100221.10",
      gene_id : "ENSG00000100221.10",
      gene_type : "protein_coding",
      gene_name : "JOSD1",
      gene_level : 1,
      hgnc_id : "HGNC:28953",
      havana_gene : "OTTHUMG00000151030.18",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38705742,
      stop : 38738299,
      direction : "+",
      ID : "ENSG00000100226.16",
      gene_id : "ENSG00000100226.16",
      gene_type : "protein_coding",
      gene_name : "GTPBP1",
      gene_level : 1,
      hgnc_id : "HGNC:4669",
      havana_gene : "OTTHUMG00000151002.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38734725,
      stop : 38794143,
      direction : "-",
      ID : "ENSG00000100242.15",
      gene_id : "ENSG00000100242.15",
      gene_type : "protein_coding",
      gene_name : "SUN2",
      gene_level : 1,
      hgnc_id : "HGNC:14210",
      havana_gene : "OTTHUMG00000151031.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38778508,
      stop : 38794198,
      direction : "-",
      ID : "ENSG00000100246.13",
      gene_id : "ENSG00000100246.13",
      gene_type : "protein_coding",
      gene_name : "DNAL4",
      gene_level : 2,
      hgnc_id : "HGNC:2955",
      havana_gene : "OTTHUMG00000151025.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38818452,
      stop : 38844028,
      direction : "-",
      ID : "ENSG00000221890.6",
      gene_id : "ENSG00000221890.6",
      gene_type : "protein_coding",
      gene_name : "NPTXR",
      gene_level : 2,
      hgnc_id : "HGNC:7954",
      havana_gene : "OTTHUMG00000150458.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38861422,
      stop : 38872249,
      direction : "-",
      ID : "ENSG00000183741.12",
      gene_id : "ENSG00000183741.12",
      gene_type : "protein_coding",
      gene_name : "CBX6",
      gene_level : 2,
      hgnc_id : "HGNC:1556",
      havana_gene : "OTTHUMG00000150456.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38952741,
      stop : 38992778,
      direction : "+",
      ID : "ENSG00000128383.13",
      gene_id : "ENSG00000128383.13",
      gene_type : "protein_coding",
      gene_name : "APOBEC3A",
      gene_level : 2,
      hgnc_id : "HGNC:17343",
      havana_gene : "OTTHUMG00000151004.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 38982347,
      stop : 38992804,
      direction : "+",
      ID : "ENSG00000179750.16",
      gene_id : "ENSG00000179750.16",
      gene_type : "protein_coding",
      gene_name : "APOBEC3B",
      gene_level : 1,
      hgnc_id : "HGNC:17352",
      havana_gene : "OTTHUMG00000151085.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39014257,
      stop : 39020352,
      direction : "+",
      ID : "ENSG00000244509.4",
      gene_id : "ENSG00000244509.4",
      gene_type : "protein_coding",
      gene_name : "APOBEC3C",
      gene_level : 2,
      hgnc_id : "HGNC:17353",
      havana_gene : "OTTHUMG00000151087.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39014363,
      stop : 39033276,
      direction : "+",
      ID : "ENSG00000284554.2",
      gene_id : "ENSG00000284554.2",
      gene_type : "protein_coding",
      gene_name : "AL022318.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000151084.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39021113,
      stop : 39033277,
      direction : "+",
      ID : "ENSG00000243811.12",
      gene_id : "ENSG00000243811.12",
      gene_type : "protein_coding",
      gene_name : "APOBEC3D",
      gene_level : 2,
      hgnc_id : "HGNC:17354",
      havana_gene : "OTTHUMG00000192151.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39040604,
      stop : 39055972,
      direction : "+",
      ID : "ENSG00000128394.17",
      gene_id : "ENSG00000128394.17",
      gene_type : "protein_coding",
      gene_name : "APOBEC3F",
      gene_level : 1,
      hgnc_id : "HGNC:17356",
      havana_gene : "OTTHUMG00000151080.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39077067,
      stop : 39087743,
      direction : "+",
      ID : "ENSG00000239713.9",
      gene_id : "ENSG00000239713.9",
      gene_type : "protein_coding",
      gene_name : "APOBEC3G",
      gene_level : 2,
      hgnc_id : "HGNC:17357",
      havana_gene : "OTTHUMG00000151081.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39097224,
      stop : 39104067,
      direction : "+",
      ID : "ENSG00000100298.16",
      gene_id : "ENSG00000100298.16",
      gene_type : "protein_coding",
      gene_name : "APOBEC3H",
      gene_level : 1,
      hgnc_id : "HGNC:24100",
      havana_gene : "OTTHUMG00000151082.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39120167,
      stop : 39152680,
      direction : "-",
      ID : "ENSG00000100307.13",
      gene_id : "ENSG00000100307.13",
      gene_type : "protein_coding",
      gene_name : "CBX7",
      gene_level : 2,
      hgnc_id : "HGNC:1557",
      havana_gene : "OTTHUMG00000150418.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39223359,
      stop : 39244982,
      direction : "-",
      ID : "ENSG00000100311.17",
      gene_id : "ENSG00000100311.17",
      gene_type : "protein_coding",
      gene_name : "PDGFB",
      gene_level : 1,
      hgnc_id : "HGNC:8800",
      havana_gene : "OTTHUMG00000151029.16",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39312882,
      stop : 39320389,
      direction : "-",
      ID : "ENSG00000100316.16",
      gene_id : "ENSG00000100316.16",
      gene_type : "protein_coding",
      gene_name : "RPL3",
      gene_level : 1,
      hgnc_id : "HGNC:10332",
      havana_gene : "OTTHUMG00000151079.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39349925,
      stop : 39385575,
      direction : "+",
      ID : "ENSG00000100321.15",
      gene_id : "ENSG00000100321.15",
      gene_type : "protein_coding",
      gene_name : "SYNGR1",
      gene_level : 1,
      hgnc_id : "HGNC:11498",
      havana_gene : "OTTHUMG00000030978.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39399778,
      stop : 39437060,
      direction : "+",
      ID : "ENSG00000100324.14",
      gene_id : "ENSG00000100324.14",
      gene_type : "protein_coding",
      gene_name : "TAB1",
      gene_level : 1,
      hgnc_id : "HGNC:18157",
      havana_gene : "OTTHUMG00000151102.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39457012,
      stop : 39492194,
      direction : "+",
      ID : "ENSG00000128268.12",
      gene_id : "ENSG00000128268.12",
      gene_type : "protein_coding",
      gene_name : "MGAT3",
      gene_level : 1,
      hgnc_id : "HGNC:7046",
      havana_gene : "OTTHUMG00000030185.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39499432,
      stop : 39518132,
      direction : "+",
      ID : "ENSG00000100335.15",
      gene_id : "ENSG00000100335.15",
      gene_type : "protein_coding",
      gene_name : "MIEF1",
      gene_level : 1,
      hgnc_id : "HGNC:25979",
      havana_gene : "OTTHUMG00000151105.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39504231,
      stop : 39504443,
      direction : "+",
      ID : "ENSG00000285025.1",
      gene_id : "ENSG00000285025.1",
      gene_type : "protein_coding",
      gene_name : "AL022312.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192565.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39519695,
      stop : 39522683,
      direction : "+",
      ID : "ENSG00000128272.16",
      gene_id : "ENSG00000128272.16",
      gene_type : "protein_coding",
      gene_name : "ATF4",
      gene_level : 2,
      hgnc_id : "HGNC:786",
      havana_gene : "OTTHUMG00000151099.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39529093,
      stop : 39532761,
      direction : "-",
      ID : "ENSG00000187051.9",
      gene_id : "ENSG00000187051.9",
      gene_type : "protein_coding",
      gene_name : "RPS19BP1",
      gene_level : 2,
      hgnc_id : "HGNC:28749",
      havana_gene : "OTTHUMG00000151101.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39570753,
      stop : 39689735,
      direction : "+",
      ID : "ENSG00000100346.18",
      gene_id : "ENSG00000100346.18",
      gene_type : "protein_coding",
      gene_name : "CACNA1I",
      gene_level : 2,
      hgnc_id : "HGNC:1396",
      havana_gene : "OTTHUMG00000151096.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39743044,
      stop : 39893864,
      direction : "-",
      ID : "ENSG00000176177.10",
      gene_id : "ENSG00000176177.10",
      gene_type : "protein_coding",
      gene_name : "ENTHD1",
      gene_level : 2,
      hgnc_id : "HGNC:26352",
      havana_gene : "OTTHUMG00000151098.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39901084,
      stop : 39973721,
      direction : "+",
      ID : "ENSG00000100351.17",
      gene_id : "ENSG00000100351.17",
      gene_type : "protein_coding",
      gene_name : "GRAP2",
      gene_level : 2,
      hgnc_id : "HGNC:4563",
      havana_gene : "OTTHUMG00000151097.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39960397,
      stop : 39964718,
      direction : "+",
      ID : "ENSG00000225528.3",
      gene_id : "ENSG00000225528.3",
      gene_type : "protein_coding",
      gene_name : "Z82206.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus,retrogene",
      havana_gene : "OTTHUMG00000151104.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 39994954,
      stop : 40043534,
      direction : "+",
      ID : "ENSG00000133477.17",
      gene_id : "ENSG00000133477.17",
      gene_type : "protein_coding",
      gene_name : "FAM83F",
      gene_level : 2,
      hgnc_id : "HGNC:25148",
      havana_gene : "OTTHUMG00000150688.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40044817,
      stop : 40335808,
      direction : "+",
      ID : "ENSG00000100354.21",
      gene_id : "ENSG00000100354.21",
      gene_type : "protein_coding",
      gene_name : "TNRC6B",
      gene_level : 2,
      hgnc_id : "HGNC:29190",
      havana_gene : "OTTHUMG00000151114.10",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40346461,
      stop : 40390463,
      direction : "+",
      ID : "ENSG00000239900.14",
      gene_id : "ENSG00000239900.14",
      gene_type : "protein_coding",
      gene_name : "ADSL",
      gene_level : 2,
      hgnc_id : "HGNC:291",
      havana_gene : "OTTHUMG00000166425.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40346529,
      stop : 40410054,
      direction : "+",
      ID : "ENSG00000284431.1",
      gene_id : "ENSG00000284431.1",
      gene_type : "protein_coding",
      gene_name : "AL022238.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189298.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40370591,
      stop : 40410289,
      direction : "+",
      ID : "ENSG00000100359.21",
      gene_id : "ENSG00000100359.21",
      gene_type : "protein_coding",
      gene_name : "SGSM3",
      gene_level : 2,
      hgnc_id : "HGNC:25228",
      havana_gene : "OTTHUMG00000151141.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40410281,
      stop : 40636719,
      direction : "-",
      ID : "ENSG00000196588.20",
      gene_id : "ENSG00000196588.20",
      gene_type : "protein_coding",
      gene_name : "MRTFA",
      gene_level : 1,
      hgnc_id : "HGNC:14334",
      havana_gene : "OTTHUMG00000151146.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40678750,
      stop : 40682814,
      direction : "+",
      ID : "ENSG00000128285.4",
      gene_id : "ENSG00000128285.4",
      gene_type : "protein_coding",
      gene_name : "MCHR1",
      gene_level : 1,
      hgnc_id : "HGNC:4479",
      havana_gene : "OTTHUMG00000150256.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40769630,
      stop : 40819399,
      direction : "-",
      ID : "ENSG00000100372.15",
      gene_id : "ENSG00000100372.15",
      gene_type : "protein_coding",
      gene_name : "SLC25A17",
      gene_level : 2,
      hgnc_id : "HGNC:10987",
      havana_gene : "OTTHUMG00000151139.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40824535,
      stop : 40856639,
      direction : "-",
      ID : "ENSG00000100380.14",
      gene_id : "ENSG00000100380.14",
      gene_type : "protein_coding",
      gene_name : "ST13",
      gene_level : 2,
      hgnc_id : "HGNC:11343",
      havana_gene : "OTTHUMG00000151201.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40857077,
      stop : 40932815,
      direction : "+",
      ID : "ENSG00000196236.13",
      gene_id : "ENSG00000196236.13",
      gene_type : "protein_coding",
      gene_name : "XPNPEP3",
      gene_level : 2,
      hgnc_id : "HGNC:28052",
      havana_gene : "OTTHUMG00000151312.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40859549,
      stop : 40862113,
      direction : "-",
      ID : "ENSG00000172404.5",
      gene_id : "ENSG00000172404.5",
      gene_type : "protein_coding",
      gene_name : "DNAJB7",
      gene_level : 2,
      hgnc_id : "HGNC:24986",
      havana_gene : "OTTHUMG00000151202.2",
      tag : "retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 40951347,
      stop : 40973309,
      direction : "+",
      ID : "ENSG00000100387.9",
      gene_id : "ENSG00000100387.9",
      gene_type : "protein_coding",
      gene_name : "RBX1",
      gene_level : 2,
      hgnc_id : "HGNC:9928",
      havana_gene : "OTTHUMG00000151298.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41092592,
      stop : 41180077,
      direction : "+",
      ID : "ENSG00000100393.14",
      gene_id : "ENSG00000100393.14",
      gene_type : "protein_coding",
      gene_name : "EP300",
      gene_level : 2,
      hgnc_id : "HGNC:3373",
      havana_gene : "OTTHUMG00000150937.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41205282,
      stop : 41231271,
      direction : "+",
      ID : "ENSG00000100395.15",
      gene_id : "ENSG00000100395.15",
      gene_type : "protein_coding",
      gene_name : "L3MBTL2",
      gene_level : 2,
      hgnc_id : "HGNC:18594",
      havana_gene : "OTTHUMG00000150942.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41229510,
      stop : 41240931,
      direction : "-",
      ID : "ENSG00000100399.16",
      gene_id : "ENSG00000100399.16",
      gene_type : "protein_coding",
      gene_name : "CHADL",
      gene_level : 2,
      hgnc_id : "HGNC:25165",
      havana_gene : "OTTHUMG00000150936.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41244779,
      stop : 41286187,
      direction : "-",
      ID : "ENSG00000100401.20",
      gene_id : "ENSG00000100401.20",
      gene_type : "protein_coding",
      gene_name : "RANGAP1",
      gene_level : 2,
      hgnc_id : "HGNC:9854",
      havana_gene : "OTTHUMG00000150940.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41301525,
      stop : 41360147,
      direction : "+",
      ID : "ENSG00000100403.12",
      gene_id : "ENSG00000100403.12",
      gene_type : "protein_coding",
      gene_name : "ZC3H7B",
      gene_level : 2,
      hgnc_id : "HGNC:30869",
      havana_gene : "OTTHUMG00000150969.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41367333,
      stop : 41399326,
      direction : "+",
      ID : "ENSG00000167074.15",
      gene_id : "ENSG00000167074.15",
      gene_type : "protein_coding",
      gene_name : "TEF",
      gene_level : 1,
      hgnc_id : "HGNC:11722",
      havana_gene : "OTTHUMG00000150968.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41433494,
      stop : 41446801,
      direction : "-",
      ID : "ENSG00000183864.5",
      gene_id : "ENSG00000183864.5",
      gene_type : "protein_coding",
      gene_name : "TOB2",
      gene_level : 2,
      hgnc_id : "HGNC:11980",
      havana_gene : "OTTHUMG00000150970.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41447830,
      stop : 41529273,
      direction : "+",
      ID : "ENSG00000100412.17",
      gene_id : "ENSG00000100412.17",
      gene_type : "protein_coding",
      gene_name : "ACO2",
      gene_level : 1,
      hgnc_id : "HGNC:118",
      havana_gene : "OTTHUMG00000030544.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41459717,
      stop : 41468692,
      direction : "-",
      ID : "ENSG00000100410.8",
      gene_id : "ENSG00000100410.8",
      gene_type : "protein_coding",
      gene_name : "PHF5A",
      gene_level : 2,
      hgnc_id : "HGNC:18000",
      havana_gene : "OTTHUMG00000150966.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41525799,
      stop : 41544606,
      direction : "-",
      ID : "ENSG00000100413.17",
      gene_id : "ENSG00000100413.17",
      gene_type : "protein_coding",
      gene_name : "POLR3H",
      gene_level : 2,
      hgnc_id : "HGNC:30349",
      havana_gene : "OTTHUMG00000150971.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41561010,
      stop : 41577741,
      direction : "+",
      ID : "ENSG00000172346.15",
      gene_id : "ENSG00000172346.15",
      gene_type : "protein_coding",
      gene_name : "CSDC2",
      gene_level : 1,
      hgnc_id : "HGNC:30359",
      havana_gene : "OTTHUMG00000150967.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41576900,
      stop : 41589871,
      direction : "-",
      ID : "ENSG00000100417.12",
      gene_id : "ENSG00000100417.12",
      gene_type : "protein_coding",
      gene_name : "PMM1",
      gene_level : 2,
      hgnc_id : "HGNC:9114",
      havana_gene : "OTTHUMG00000150972.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41598028,
      stop : 41621043,
      direction : "-",
      ID : "ENSG00000100418.8",
      gene_id : "ENSG00000100418.8",
      gene_type : "protein_coding",
      gene_name : "DESI1",
      gene_level : 1,
      hgnc_id : "HGNC:24577",
      havana_gene : "OTTHUMG00000044632.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41621163,
      stop : 41664048,
      direction : "+",
      ID : "ENSG00000196419.13",
      gene_id : "ENSG00000196419.13",
      gene_type : "protein_coding",
      gene_name : "XRCC6",
      gene_level : 2,
      hgnc_id : "HGNC:4055",
      havana_gene : "OTTHUMG00000151190.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41673933,
      stop : 41690504,
      direction : "-",
      ID : "ENSG00000100138.15",
      gene_id : "ENSG00000100138.15",
      gene_type : "protein_coding",
      gene_name : "SNU13",
      gene_level : 2,
      hgnc_id : "HGNC:7819",
      havana_gene : "OTTHUMG00000151189.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41699503,
      stop : 41799456,
      direction : "+",
      ID : "ENSG00000167077.13",
      gene_id : "ENSG00000167077.13",
      gene_type : "protein_coding",
      gene_name : "MEI1",
      gene_level : 1,
      hgnc_id : "HGNC:28613",
      havana_gene : "OTTHUMG00000030083.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41800679,
      stop : 41832164,
      direction : "+",
      ID : "ENSG00000100147.14",
      gene_id : "ENSG00000100147.14",
      gene_type : "protein_coding",
      gene_name : "CCDC134",
      gene_level : 1,
      hgnc_id : "HGNC:26185",
      havana_gene : "OTTHUMG00000151262.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41833079,
      stop : 41907307,
      direction : "+",
      ID : "ENSG00000198911.12",
      gene_id : "ENSG00000198911.12",
      gene_type : "protein_coding",
      gene_name : "SREBF2",
      gene_level : 1,
      hgnc_id : "HGNC:11290",
      havana_gene : "OTTHUMG00000151261.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41909554,
      stop : 41914667,
      direction : "-",
      ID : "ENSG00000234965.2",
      gene_id : "ENSG00000234965.2",
      gene_type : "protein_coding",
      gene_name : "SHISA8",
      gene_level : 2,
      hgnc_id : "HGNC:18351",
      havana_gene : "OTTHUMG00000151273.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41922032,
      stop : 41926806,
      direction : "-",
      ID : "ENSG00000159958.7",
      gene_id : "ENSG00000159958.7",
      gene_type : "protein_coding",
      gene_name : "TNFRSF13C",
      gene_level : 2,
      hgnc_id : "HGNC:17755",
      havana_gene : "OTTHUMG00000151271.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41938737,
      stop : 41947152,
      direction : "-",
      ID : "ENSG00000100162.15",
      gene_id : "ENSG00000100162.15",
      gene_type : "protein_coding",
      gene_name : "CENPM",
      gene_level : 1,
      hgnc_id : "HGNC:18352",
      havana_gene : "OTTHUMG00000151277.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41952174,
      stop : 41958933,
      direction : "+",
      ID : "ENSG00000205704.7",
      gene_id : "ENSG00000205704.7",
      gene_type : "protein_coding",
      gene_name : "LINC00634",
      gene_level : 1,
      hgnc_id : "HGNC:27930",
      havana_gene : "OTTHUMG00000151274.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41969475,
      stop : 41998221,
      direction : "+",
      ID : "ENSG00000100167.20",
      gene_id : "ENSG00000100167.20",
      gene_type : "protein_coding",
      gene_name : "SEPTIN3",
      gene_level : 1,
      hgnc_id : "HGNC:10750",
      havana_gene : "OTTHUMG00000030494.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 41998725,
      stop : 42058456,
      direction : "+",
      ID : "ENSG00000183066.14",
      gene_id : "ENSG00000183066.14",
      gene_type : "protein_coding",
      gene_name : "WBP2NL",
      gene_level : 2,
      hgnc_id : "HGNC:28389",
      havana_gene : "OTTHUMG00000151270.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42058334,
      stop : 42070842,
      direction : "-",
      ID : "ENSG00000198951.12",
      gene_id : "ENSG00000198951.12",
      gene_type : "protein_coding",
      gene_name : "NAGA",
      gene_level : 2,
      hgnc_id : "HGNC:7631",
      havana_gene : "OTTHUMG00000151276.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42074248,
      stop : 42079438,
      direction : "+",
      ID : "ENSG00000177096.9",
      gene_id : "ENSG00000177096.9",
      gene_type : "protein_coding",
      gene_name : "PHETA2",
      gene_level : 2,
      hgnc_id : "HGNC:27161",
      havana_gene : "OTTHUMG00000151285.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42079691,
      stop : 42084284,
      direction : "+",
      ID : "ENSG00000183172.9",
      gene_id : "ENSG00000183172.9",
      gene_type : "protein_coding",
      gene_name : "SMDT1",
      gene_level : 2,
      hgnc_id : "HGNC:25055",
      havana_gene : "OTTHUMG00000151286.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42085526,
      stop : 42090884,
      direction : "-",
      ID : "ENSG00000184983.11",
      gene_id : "ENSG00000184983.11",
      gene_type : "protein_coding",
      gene_name : "NDUFA6",
      gene_level : 2,
      hgnc_id : "HGNC:7690",
      havana_gene : "OTTHUMG00000151287.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42126499,
      stop : 42130865,
      direction : "-",
      ID : "ENSG00000100197.23",
      gene_id : "ENSG00000100197.23",
      gene_type : "protein_coding",
      gene_name : "CYP2D6",
      gene_level : 2,
      hgnc_id : "HGNC:2625",
      havana_gene : "OTTHUMG00000150918.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42160013,
      stop : 42343616,
      direction : "-",
      ID : "ENSG00000100207.20",
      gene_id : "ENSG00000100207.20",
      gene_type : "protein_coding",
      gene_name : "TCF20",
      gene_level : 2,
      hgnc_id : "HGNC:11631",
      havana_gene : "OTTHUMG00000150920.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42380407,
      stop : 42432403,
      direction : "-",
      ID : "ENSG00000235568.7",
      gene_id : "ENSG00000235568.7",
      gene_type : "protein_coding",
      gene_name : "NFAM1",
      gene_level : 2,
      hgnc_id : "HGNC:29872",
      havana_gene : "OTTHUMG00000150923.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42508344,
      stop : 42519796,
      direction : "-",
      ID : "ENSG00000189306.11",
      gene_id : "ENSG00000189306.11",
      gene_type : "protein_coding",
      gene_name : "RRP7A",
      gene_level : 2,
      hgnc_id : "HGNC:24286",
      havana_gene : "OTTHUMG00000150891.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42553617,
      stop : 42574382,
      direction : "+",
      ID : "ENSG00000183569.18",
      gene_id : "ENSG00000183569.18",
      gene_type : "protein_coding",
      gene_name : "SERHL2",
      gene_level : 2,
      hgnc_id : "HGNC:29446",
      havana_gene : "OTTHUMG00000150892.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42583721,
      stop : 42614962,
      direction : "-",
      ID : "ENSG00000100227.18",
      gene_id : "ENSG00000100227.18",
      gene_type : "protein_coding",
      gene_name : "POLDIP3",
      gene_level : 2,
      hgnc_id : "HGNC:23782",
      havana_gene : "OTTHUMG00000150887.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42617840,
      stop : 42649392,
      direction : "-",
      ID : "ENSG00000100243.21",
      gene_id : "ENSG00000100243.21",
      gene_type : "protein_coding",
      gene_name : "CYB5R3",
      gene_level : 2,
      hgnc_id : "HGNC:2873",
      havana_gene : "OTTHUMG00000150745.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42639803,
      stop : 42640601,
      direction : "-",
      ID : "ENSG00000249222.1",
      gene_id : "ENSG00000249222.1",
      gene_type : "protein_coding",
      gene_name : "ATP5MGL",
      gene_level : 2,
      hgnc_id : "HGNC:13213",
      havana_gene : "OTTHUMG00000150890.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42692121,
      stop : 42721298,
      direction : "-",
      ID : "ENSG00000128274.17",
      gene_id : "ENSG00000128274.17",
      gene_type : "protein_coding",
      gene_name : "A4GALT",
      gene_level : 2,
      hgnc_id : "HGNC:18149",
      havana_gene : "OTTHUMG00000150744.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42796502,
      stop : 42858106,
      direction : "-",
      ID : "ENSG00000242247.11",
      gene_id : "ENSG00000242247.11",
      gene_type : "protein_coding",
      gene_name : "ARFGAP3",
      gene_level : 2,
      hgnc_id : "HGNC:661",
      havana_gene : "OTTHUMG00000150718.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 42835412,
      stop : 43015149,
      direction : "-",
      ID : "ENSG00000100266.19",
      gene_id : "ENSG00000100266.19",
      gene_type : "protein_coding",
      gene_name : "PACSIN2",
      gene_level : 2,
      hgnc_id : "HGNC:8571",
      havana_gene : "OTTHUMG00000150701.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43039516,
      stop : 43089419,
      direction : "-",
      ID : "ENSG00000100271.17",
      gene_id : "ENSG00000100271.17",
      gene_type : "protein_coding",
      gene_name : "TTLL1",
      gene_level : 2,
      hgnc_id : "HGNC:1312",
      havana_gene : "OTTHUMG00000150699.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43110750,
      stop : 43129712,
      direction : "+",
      ID : "ENSG00000100290.3",
      gene_id : "ENSG00000100290.3",
      gene_type : "protein_coding",
      gene_name : "BIK",
      gene_level : 2,
      hgnc_id : "HGNC:1051",
      havana_gene : "OTTHUMG00000150703.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43132209,
      stop : 43143398,
      direction : "-",
      ID : "ENSG00000100294.13",
      gene_id : "ENSG00000100294.13",
      gene_type : "protein_coding",
      gene_name : "MCAT",
      gene_level : 2,
      hgnc_id : "HGNC:29622",
      havana_gene : "OTTHUMG00000150704.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43151547,
      stop : 43163242,
      direction : "+",
      ID : "ENSG00000100300.18",
      gene_id : "ENSG00000100300.18",
      gene_type : "protein_coding",
      gene_name : "TSPO",
      gene_level : 2,
      hgnc_id : "HGNC:1158",
      havana_gene : "OTTHUMG00000150573.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43166622,
      stop : 43187134,
      direction : "-",
      ID : "ENSG00000100304.13",
      gene_id : "ENSG00000100304.13",
      gene_type : "protein_coding",
      gene_name : "TTLL12",
      gene_level : 2,
      hgnc_id : "HGNC:28974",
      havana_gene : "OTTHUMG00000150682.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43197280,
      stop : 43343372,
      direction : "-",
      ID : "ENSG00000159307.19",
      gene_id : "ENSG00000159307.19",
      gene_type : "protein_coding",
      gene_name : "SCUBE1",
      gene_level : 2,
      hgnc_id : "HGNC:13441",
      havana_gene : "OTTHUMG00000150679.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43411196,
      stop : 43507848,
      direction : "+",
      ID : "ENSG00000186732.14",
      gene_id : "ENSG00000186732.14",
      gene_type : "protein_coding",
      gene_name : "MPPED1",
      gene_level : 2,
      hgnc_id : "HGNC:1306",
      havana_gene : "OTTHUMG00000150566.9",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43528744,
      stop : 43812337,
      direction : "-",
      ID : "ENSG00000186976.15",
      gene_id : "ENSG00000186976.15",
      gene_type : "protein_coding",
      gene_name : "EFCAB6",
      gene_level : 2,
      hgnc_id : "HGNC:24204",
      havana_gene : "OTTHUMG00000150522.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43824509,
      stop : 43862513,
      direction : "-",
      ID : "ENSG00000130540.14",
      gene_id : "ENSG00000130540.14",
      gene_type : "protein_coding",
      gene_name : "SULT4A1",
      gene_level : 2,
      hgnc_id : "HGNC:14903",
      havana_gene : "OTTHUMG00000141314.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43879678,
      stop : 43892013,
      direction : "-",
      ID : "ENSG00000100341.12",
      gene_id : "ENSG00000100341.12",
      gene_type : "protein_coding",
      gene_name : "PNPLA5",
      gene_level : 2,
      hgnc_id : "HGNC:24888",
      havana_gene : "OTTHUMG00000030779.10",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43923792,
      stop : 43964488,
      direction : "+",
      ID : "ENSG00000100344.11",
      gene_id : "ENSG00000100344.11",
      gene_type : "protein_coding",
      gene_name : "PNPLA3",
      gene_level : 2,
      hgnc_id : "HGNC:18590",
      havana_gene : "OTTHUMG00000150555.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43955442,
      stop : 44010531,
      direction : "+",
      ID : "ENSG00000100347.15",
      gene_id : "ENSG00000100347.15",
      gene_type : "protein_coding",
      gene_name : "SAMM50",
      gene_level : 2,
      hgnc_id : "HGNC:24276",
      havana_gene : "OTTHUMG00000150557.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 43999211,
      stop : 44172939,
      direction : "+",
      ID : "ENSG00000188677.15",
      gene_id : "ENSG00000188677.15",
      gene_type : "protein_coding",
      gene_name : "PARVB",
      gene_level : 1,
      hgnc_id : "HGNC:14653",
      havana_gene : "OTTHUMG00000150665.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44172956,
      stop : 44219533,
      direction : "+",
      ID : "ENSG00000138964.17",
      gene_id : "ENSG00000138964.17",
      gene_type : "protein_coding",
      gene_name : "PARVG",
      gene_level : 2,
      hgnc_id : "HGNC:14654",
      havana_gene : "OTTHUMG00000150473.10",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44243665,
      stop : 44312951,
      direction : "-",
      ID : "ENSG00000138944.8",
      gene_id : "ENSG00000138944.8",
      gene_type : "protein_coding",
      gene_name : "SHISAL1",
      gene_level : 1,
      hgnc_id : "HGNC:29335",
      havana_gene : "OTTHUMG00000030991.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44492583,
      stop : 44498233,
      direction : "-",
      ID : "ENSG00000188636.4",
      gene_id : "ENSG00000188636.4",
      gene_type : "protein_coding",
      gene_name : "RTL6",
      gene_level : 2,
      hgnc_id : "HGNC:13343",
      havana_gene : "OTTHUMG00000150465.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44668547,
      stop : 44737681,
      direction : "+",
      ID : "ENSG00000186654.21",
      gene_id : "ENSG00000186654.21",
      gene_type : "protein_coding",
      gene_name : "PRR5",
      gene_level : 1,
      hgnc_id : "HGNC:31682",
      havana_gene : "OTTHUMG00000150460.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44702233,
      stop : 44862706,
      direction : "+",
      ID : "ENSG00000248405.10",
      gene_id : "ENSG00000248405.10",
      gene_type : "protein_coding",
      gene_name : "PRR5-ARHGAP8",
      gene_level : 2,
      hgnc_id : "HGNC:34512",
      havana_gene : "OTTHUMG00000160954.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44752558,
      stop : 44862788,
      direction : "+",
      ID : "ENSG00000241484.10",
      gene_id : "ENSG00000241484.10",
      gene_type : "protein_coding",
      gene_name : "ARHGAP8",
      gene_level : 1,
      hgnc_id : "HGNC:677",
      havana_gene : "OTTHUMG00000030234.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 44881162,
      stop : 45010005,
      direction : "-",
      ID : "ENSG00000056487.16",
      gene_id : "ENSG00000056487.16",
      gene_type : "protein_coding",
      gene_name : "PHF21B",
      gene_level : 2,
      hgnc_id : "HGNC:25161",
      havana_gene : "OTTHUMG00000151199.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45163925,
      stop : 45188017,
      direction : "+",
      ID : "ENSG00000093000.19",
      gene_id : "ENSG00000093000.19",
      gene_type : "protein_coding",
      gene_name : "NUP50",
      gene_level : 2,
      hgnc_id : "HGNC:8065",
      havana_gene : "OTTHUMG00000151265.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45192244,
      stop : 45240894,
      direction : "-",
      ID : "ENSG00000100364.19",
      gene_id : "ENSG00000100364.19",
      gene_type : "protein_coding",
      gene_name : "KIAA0930",
      gene_level : 1,
      hgnc_id : "HGNC:1314",
      havana_gene : "OTTHUMG00000151263.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45284949,
      stop : 45295874,
      direction : "+",
      ID : "ENSG00000100373.10",
      gene_id : "ENSG00000100373.10",
      gene_type : "protein_coding",
      gene_name : "UPK3A",
      gene_level : 1,
      hgnc_id : "HGNC:12580",
      havana_gene : "OTTHUMG00000151339.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45308968,
      stop : 45341955,
      direction : "+",
      ID : "ENSG00000100376.12",
      gene_id : "ENSG00000100376.12",
      gene_type : "protein_coding",
      gene_name : "FAM118A",
      gene_level : 1,
      hgnc_id : "HGNC:1313",
      havana_gene : "OTTHUMG00000151338.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45344063,
      stop : 45413619,
      direction : "-",
      ID : "ENSG00000077935.17",
      gene_id : "ENSG00000077935.17",
      gene_type : "protein_coding",
      gene_name : "SMC1B",
      gene_level : 2,
      hgnc_id : "HGNC:11112",
      havana_gene : "OTTHUMG00000151334.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45413693,
      stop : 45432509,
      direction : "+",
      ID : "ENSG00000128408.9",
      gene_id : "ENSG00000128408.9",
      gene_type : "protein_coding",
      gene_name : "RIBC2",
      gene_level : 2,
      hgnc_id : "HGNC:13241",
      havana_gene : "OTTHUMG00000151332.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45502238,
      stop : 45601135,
      direction : "+",
      ID : "ENSG00000077942.19",
      gene_id : "ENSG00000077942.19",
      gene_type : "protein_coding",
      gene_name : "FBLN1",
      gene_level : 2,
      hgnc_id : "HGNC:3600",
      havana_gene : "OTTHUMG00000151340.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45671798,
      stop : 45845307,
      direction : "+",
      ID : "ENSG00000130638.17",
      gene_id : "ENSG00000130638.17",
      gene_type : "protein_coding",
      gene_name : "ATXN10",
      gene_level : 1,
      hgnc_id : "HGNC:10549",
      havana_gene : "OTTHUMG00000150451.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 45920366,
      stop : 45977162,
      direction : "-",
      ID : "ENSG00000188064.10",
      gene_id : "ENSG00000188064.10",
      gene_type : "protein_coding",
      gene_name : "WNT7B",
      gene_level : 1,
      hgnc_id : "HGNC:12787",
      havana_gene : "OTTHUMG00000154636.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46150521,
      stop : 46243756,
      direction : "+",
      ID : "ENSG00000186951.16",
      gene_id : "ENSG00000186951.16",
      gene_type : "protein_coding",
      gene_name : "PPARA",
      gene_level : 2,
      hgnc_id : "HGNC:9232",
      havana_gene : "OTTHUMG00000150443.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46244011,
      stop : 46250311,
      direction : "-",
      ID : "ENSG00000205643.11",
      gene_id : "ENSG00000205643.11",
      gene_type : "protein_coding",
      gene_name : "CDPF1",
      gene_level : 1,
      hgnc_id : "HGNC:33710",
      havana_gene : "OTTHUMG00000030672.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46255663,
      stop : 46263343,
      direction : "-",
      ID : "ENSG00000130943.7",
      gene_id : "ENSG00000130943.7",
      gene_type : "protein_coding",
      gene_name : "PKDREJ",
      gene_level : 2,
      hgnc_id : "HGNC:9015",
      havana_gene : "OTTHUMG00000150493.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46267961,
      stop : 46294008,
      direction : "+",
      ID : "ENSG00000075234.17",
      gene_id : "ENSG00000075234.17",
      gene_type : "protein_coding",
      gene_name : "TTC38",
      gene_level : 1,
      hgnc_id : "HGNC:26082",
      havana_gene : "OTTHUMG00000150494.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46296870,
      stop : 46330810,
      direction : "+",
      ID : "ENSG00000075218.19",
      gene_id : "ENSG00000075218.19",
      gene_type : "protein_coding",
      gene_name : "GTSE1",
      gene_level : 2,
      hgnc_id : "HGNC:13698",
      havana_gene : "OTTHUMG00000150486.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46330875,
      stop : 46357340,
      direction : "+",
      ID : "ENSG00000100416.15",
      gene_id : "ENSG00000100416.15",
      gene_type : "protein_coding",
      gene_name : "TRMU",
      gene_level : 2,
      hgnc_id : "HGNC:25481",
      havana_gene : "OTTHUMG00000150424.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46360834,
      stop : 46537620,
      direction : "-",
      ID : "ENSG00000075275.18",
      gene_id : "ENSG00000075275.18",
      gene_type : "protein_coding",
      gene_name : "CELSR1",
      gene_level : 1,
      hgnc_id : "HGNC:1850",
      havana_gene : "OTTHUMG00000150423.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46576012,
      stop : 46679790,
      direction : "+",
      ID : "ENSG00000075240.17",
      gene_id : "ENSG00000075240.17",
      gene_type : "protein_coding",
      gene_name : "GRAMD4",
      gene_level : 2,
      hgnc_id : "HGNC:29113",
      havana_gene : "OTTHUMG00000150402.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46684410,
      stop : 46738252,
      direction : "-",
      ID : "ENSG00000100422.14",
      gene_id : "ENSG00000100422.14",
      gene_type : "protein_coding",
      gene_name : "CERK",
      gene_level : 2,
      hgnc_id : "HGNC:19256",
      havana_gene : "OTTHUMG00000150395.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 46762617,
      stop : 47175699,
      direction : "+",
      ID : "ENSG00000054611.14",
      gene_id : "ENSG00000054611.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D22A",
      gene_level : 2,
      hgnc_id : "HGNC:1309",
      havana_gene : "OTTHUMG00000150332.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 48489553,
      stop : 48850912,
      direction : "+",
      ID : "ENSG00000219438.9",
      gene_id : "ENSG00000219438.9",
      gene_type : "protein_coding",
      gene_name : "TAFA5",
      gene_level : 1,
      hgnc_id : "HGNC:21592",
      havana_gene : "OTTHUMG00000150308.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 49773283,
      stop : 49827512,
      direction : "-",
      ID : "ENSG00000100425.18",
      gene_id : "ENSG00000100425.18",
      gene_type : "protein_coding",
      gene_name : "BRD1",
      gene_level : 2,
      hgnc_id : "HGNC:1102",
      havana_gene : "OTTHUMG00000150288.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 49853844,
      stop : 49890080,
      direction : "+",
      ID : "ENSG00000100426.7",
      gene_id : "ENSG00000100426.7",
      gene_type : "protein_coding",
      gene_name : "ZBED4",
      gene_level : 2,
      hgnc_id : "HGNC:20721",
      havana_gene : "OTTHUMG00000150291.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 49900229,
      stop : 49918438,
      direction : "-",
      ID : "ENSG00000182858.14",
      gene_id : "ENSG00000182858.14",
      gene_type : "protein_coding",
      gene_name : "ALG12",
      gene_level : 1,
      hgnc_id : "HGNC:19358",
      havana_gene : "OTTHUMG00000150289.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 49918167,
      stop : 49927540,
      direction : "+",
      ID : "ENSG00000184164.15",
      gene_id : "ENSG00000184164.15",
      gene_type : "protein_coding",
      gene_name : "CRELD2",
      gene_level : 2,
      hgnc_id : "HGNC:28150",
      havana_gene : "OTTHUMG00000150292.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 49960768,
      stop : 49964072,
      direction : "+",
      ID : "ENSG00000198355.5",
      gene_id : "ENSG00000198355.5",
      gene_type : "protein_coding",
      gene_name : "PIM3",
      gene_level : 2,
      hgnc_id : "HGNC:19310",
      havana_gene : "OTTHUMG00000150290.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 49994513,
      stop : 50012659,
      direction : "-",
      ID : "ENSG00000188263.10",
      gene_id : "ENSG00000188263.10",
      gene_type : "protein_coding",
      gene_name : "IL17REL",
      gene_level : 2,
      hgnc_id : "HGNC:33808",
      havana_gene : "OTTHUMG00000150242.1",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50015123,
      stop : 50056935,
      direction : "-",
      ID : "ENSG00000138892.11",
      gene_id : "ENSG00000138892.11",
      gene_type : "protein_coding",
      gene_name : "TTLL8",
      gene_level : 1,
      hgnc_id : "HGNC:34000",
      havana_gene : "OTTHUMG00000150241.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50059391,
      stop : 50085426,
      direction : "-",
      ID : "ENSG00000100427.16",
      gene_id : "ENSG00000100427.16",
      gene_type : "protein_coding",
      gene_name : "MLC1",
      gene_level : 2,
      hgnc_id : "HGNC:17082",
      havana_gene : "OTTHUMG00000150236.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50089879,
      stop : 50161690,
      direction : "+",
      ID : "ENSG00000073146.16",
      gene_id : "ENSG00000073146.16",
      gene_type : "protein_coding",
      gene_name : "MOV10L1",
      gene_level : 2,
      hgnc_id : "HGNC:7201",
      havana_gene : "OTTHUMG00000044648.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50170731,
      stop : 50180295,
      direction : "+",
      ID : "ENSG00000073150.14",
      gene_id : "ENSG00000073150.14",
      gene_type : "protein_coding",
      gene_name : "PANX2",
      gene_level : 2,
      hgnc_id : "HGNC:8600",
      havana_gene : "OTTHUMG00000044649.5",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50185913,
      stop : 50199598,
      direction : "+",
      ID : "ENSG00000170638.10",
      gene_id : "ENSG00000170638.10",
      gene_type : "protein_coding",
      gene_name : "TRABD",
      gene_level : 1,
      hgnc_id : "HGNC:28805",
      havana_gene : "OTTHUMG00000044644.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50200979,
      stop : 50217616,
      direction : "+",
      ID : "ENSG00000073169.14",
      gene_id : "ENSG00000073169.14",
      gene_type : "protein_coding",
      gene_name : "SELENOO",
      gene_level : 2,
      hgnc_id : "HGNC:30395",
      havana_gene : "OTTHUMG00000044645.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50217689,
      stop : 50245023,
      direction : "-",
      ID : "ENSG00000128159.12",
      gene_id : "ENSG00000128159.12",
      gene_type : "protein_coding",
      gene_name : "TUBGCP6",
      gene_level : 1,
      hgnc_id : "HGNC:18127",
      havana_gene : "OTTHUMG00000030150.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50245183,
      stop : 50251405,
      direction : "-",
      ID : "ENSG00000100429.18",
      gene_id : "ENSG00000100429.18",
      gene_type : "protein_coding",
      gene_name : "HDAC10",
      gene_level : 2,
      hgnc_id : "HGNC:18128",
      havana_gene : "OTTHUMG00000044647.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50245450,
      stop : 50261716,
      direction : "-",
      ID : "ENSG00000188130.14",
      gene_id : "ENSG00000188130.14",
      gene_type : "protein_coding",
      gene_name : "MAPK12",
      gene_level : 2,
      hgnc_id : "HGNC:6874",
      havana_gene : "OTTHUMG00000030145.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50263713,
      stop : 50270767,
      direction : "-",
      ID : "ENSG00000185386.15",
      gene_id : "ENSG00000185386.15",
      gene_type : "protein_coding",
      gene_name : "MAPK11",
      gene_level : 2,
      hgnc_id : "HGNC:6873",
      havana_gene : "OTTHUMG00000150226.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50274979,
      stop : 50307646,
      direction : "-",
      ID : "ENSG00000196576.16",
      gene_id : "ENSG00000196576.16",
      gene_type : "protein_coding",
      gene_name : "PLXNB2",
      gene_level : 2,
      hgnc_id : "HGNC:9104",
      havana_gene : "OTTHUMG00000150219.10",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50309030,
      stop : 50327012,
      direction : "-",
      ID : "ENSG00000205593.12",
      gene_id : "ENSG00000205593.12",
      gene_type : "protein_coding",
      gene_name : "DENND6B",
      gene_level : 1,
      hgnc_id : "HGNC:32690",
      havana_gene : "OTTHUMG00000150210.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50343304,
      stop : 50445090,
      direction : "+",
      ID : "ENSG00000100239.16",
      gene_id : "ENSG00000100239.16",
      gene_type : "protein_coding",
      gene_name : "PPP6R2",
      gene_level : 2,
      hgnc_id : "HGNC:19253",
      havana_gene : "OTTHUMG00000150199.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50445000,
      stop : 50475035,
      direction : "-",
      ID : "ENSG00000100241.21",
      gene_id : "ENSG00000100241.21",
      gene_type : "protein_coding",
      gene_name : "SBF1",
      gene_level : 2,
      hgnc_id : "HGNC:10542",
      havana_gene : "OTTHUMG00000150204.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50481543,
      stop : 50486440,
      direction : "+",
      ID : "ENSG00000128165.9",
      gene_id : "ENSG00000128165.9",
      gene_type : "protein_coding",
      gene_name : "ADM2",
      gene_level : 2,
      hgnc_id : "HGNC:28898",
      havana_gene : "OTTHUMG00000150202.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50486784,
      stop : 50490648,
      direction : "+",
      ID : "ENSG00000100253.13",
      gene_id : "ENSG00000100253.13",
      gene_type : "protein_coding",
      gene_name : "MIOX",
      gene_level : 2,
      hgnc_id : "HGNC:14522",
      havana_gene : "OTTHUMG00000150207.2",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50502949,
      stop : 50507702,
      direction : "-",
      ID : "ENSG00000100258.18",
      gene_id : "ENSG00000100258.18",
      gene_type : "protein_coding",
      gene_name : "LMF2",
      gene_level : 2,
      hgnc_id : "HGNC:25096",
      havana_gene : "OTTHUMG00000150206.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50508224,
      stop : 50524780,
      direction : "+",
      ID : "ENSG00000025770.19",
      gene_id : "ENSG00000025770.19",
      gene_type : "protein_coding",
      gene_name : "NCAPH2",
      gene_level : 2,
      hgnc_id : "HGNC:25071",
      havana_gene : "OTTHUMG00000150205.7",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50523568,
      stop : 50526461,
      direction : "-",
      ID : "ENSG00000284194.3",
      gene_id : "ENSG00000284194.3",
      gene_type : "protein_coding",
      gene_name : "SCO2",
      gene_level : 2,
      hgnc_id : "HGNC:10604",
      havana_gene : "OTTHUMG00000191637.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50525752,
      stop : 50530032,
      direction : "-",
      ID : "ENSG00000025708.14",
      gene_id : "ENSG00000025708.14",
      gene_type : "protein_coding",
      gene_name : "TYMP",
      gene_level : 1,
      hgnc_id : "HGNC:3148",
      havana_gene : "OTTHUMG00000150249.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50529710,
      stop : 50532580,
      direction : "-",
      ID : "ENSG00000177989.13",
      gene_id : "ENSG00000177989.13",
      gene_type : "protein_coding",
      gene_name : "ODF3B",
      gene_level : 1,
      hgnc_id : "HGNC:34388",
      havana_gene : "OTTHUMG00000150334.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50545899,
      stop : 50551023,
      direction : "+",
      ID : "ENSG00000130487.9",
      gene_id : "ENSG00000130487.9",
      gene_type : "protein_coding",
      gene_name : "KLHDC7B",
      gene_level : 2,
      hgnc_id : "HGNC:25145",
      havana_gene : "OTTHUMG00000150250.6",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50551112,
      stop : 50562919,
      direction : "-",
      ID : "ENSG00000217442.4",
      gene_id : "ENSG00000217442.4",
      gene_type : "protein_coding",
      gene_name : "SYCE3",
      gene_level : 1,
      hgnc_id : "HGNC:35245",
      havana_gene : "OTTHUMG00000150273.3",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50568861,
      stop : 50578465,
      direction : "-",
      ID : "ENSG00000205560.13",
      gene_id : "ENSG00000205560.13",
      gene_type : "protein_coding",
      gene_name : "CPT1B",
      gene_level : 2,
      hgnc_id : "HGNC:2329",
      havana_gene : "OTTHUMG00000137390.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50568869,
      stop : 50582965,
      direction : "-",
      ID : "ENSG00000254413.8",
      gene_id : "ENSG00000254413.8",
      gene_type : "protein_coding",
      gene_name : "CHKB-CPT1B",
      gene_level : 2,
      hgnc_id : "HGNC:41998",
      havana_gene : "OTTHUMG00000166282.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50578959,
      stop : 50601455,
      direction : "-",
      ID : "ENSG00000100288.20",
      gene_id : "ENSG00000100288.20",
      gene_type : "protein_coding",
      gene_name : "CHKB",
      gene_level : 2,
      hgnc_id : "HGNC:1938",
      havana_gene : "OTTHUMG00000150275.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50600793,
      stop : 50613981,
      direction : "+",
      ID : "ENSG00000008735.14",
      gene_id : "ENSG00000008735.14",
      gene_type : "protein_coding",
      gene_name : "MAPK8IP2",
      gene_level : 2,
      hgnc_id : "HGNC:6883",
      havana_gene : "OTTHUMG00000150181.8",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50622754,
      stop : 50628173,
      direction : "-",
      ID : "ENSG00000100299.18",
      gene_id : "ENSG00000100299.18",
      gene_type : "protein_coding",
      gene_name : "ARSA",
      gene_level : 2,
      hgnc_id : "HGNC:713",
      havana_gene : "OTTHUMG00000150180.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50674415,
      stop : 50733298,
      direction : "+",
      ID : "ENSG00000251322.9",
      gene_id : "ENSG00000251322.9",
      gene_type : "protein_coding",
      gene_name : "SHANK3",
      gene_level : 2,
      hgnc_id : "HGNC:14294",
      havana_gene : "OTTHUMG00000150169.5",
      tag : "reference_genome_error"
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50738196,
      stop : 50745339,
      direction : "+",
      ID : "ENSG00000100312.11",
      gene_id : "ENSG00000100312.11",
      gene_type : "protein_coding",
      gene_name : "ACR",
      gene_level : 1,
      hgnc_id : "HGNC:126",
      havana_gene : "OTTHUMG00000150155.4",
      tag : null
    },
    {
      chromosome : 22,
      annotation : "HAVANA",
      type : "gene",
      start : 50767501,
      stop : 50783662,
      direction : "-",
      ID : "ENSG00000079974.18",
      gene_id : "ENSG00000079974.18",
      gene_type : "protein_coding",
      gene_name : "RABL2B",
      gene_level : 2,
      hgnc_id : "HGNC:9800",
      havana_gene : "OTTHUMG00000150156.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196763,
      stop : 409417,
      direction : "+",
      ID : "ENSG00000134121.10",
      gene_id : "ENSG00000134121.10",
      gene_type : "protein_coding",
      gene_name : "CHL1",
      gene_level : 2,
      hgnc_id : "HGNC:1939",
      havana_gene : "OTTHUMG00000090601.12",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 1092658,
      stop : 1404217,
      direction : "+",
      ID : "ENSG00000134115.13",
      gene_id : "ENSG00000134115.13",
      gene_type : "protein_coding",
      gene_name : "CNTN6",
      gene_level : 2,
      hgnc_id : "HGNC:2176",
      havana_gene : "OTTHUMG00000119030.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 2098813,
      stop : 3057959,
      direction : "+",
      ID : "ENSG00000144619.15",
      gene_id : "ENSG00000144619.15",
      gene_type : "protein_coding",
      gene_name : "CNTN4",
      gene_level : 1,
      hgnc_id : "HGNC:2174",
      havana_gene : "OTTHUMG00000119031.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 3066324,
      stop : 3126613,
      direction : "-",
      ID : "ENSG00000091181.20",
      gene_id : "ENSG00000091181.20",
      gene_type : "protein_coding",
      gene_name : "IL5RA",
      gene_level : 1,
      hgnc_id : "HGNC:6017",
      havana_gene : "OTTHUMG00000090245.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 3126933,
      stop : 3150879,
      direction : "+",
      ID : "ENSG00000072756.17",
      gene_id : "ENSG00000072756.17",
      gene_type : "protein_coding",
      gene_name : "TRNT1",
      gene_level : 2,
      hgnc_id : "HGNC:17341",
      havana_gene : "OTTHUMG00000090259.12",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 3144628,
      stop : 3179727,
      direction : "-",
      ID : "ENSG00000113851.15",
      gene_id : "ENSG00000113851.15",
      gene_type : "protein_coding",
      gene_name : "CRBN",
      gene_level : 2,
      hgnc_id : "HGNC:30185",
      havana_gene : "OTTHUMG00000090261.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 3700814,
      stop : 4467273,
      direction : "-",
      ID : "ENSG00000144455.14",
      gene_id : "ENSG00000144455.14",
      gene_type : "protein_coding",
      gene_name : "SUMF1",
      gene_level : 1,
      hgnc_id : "HGNC:20376",
      havana_gene : "OTTHUMG00000090269.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 3799431,
      stop : 3849834,
      direction : "+",
      ID : "ENSG00000175928.6",
      gene_id : "ENSG00000175928.6",
      gene_type : "protein_coding",
      gene_name : "LRRN1",
      gene_level : 1,
      hgnc_id : "HGNC:20980",
      havana_gene : "OTTHUMG00000154934.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 4303304,
      stop : 4317567,
      direction : "+",
      ID : "ENSG00000170364.12",
      gene_id : "ENSG00000170364.12",
      gene_type : "protein_coding",
      gene_name : "SETMAR",
      gene_level : 1,
      hgnc_id : "HGNC:10762",
      havana_gene : "OTTHUMG00000090265.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 4493345,
      stop : 4847840,
      direction : "+",
      ID : "ENSG00000150995.20",
      gene_id : "ENSG00000150995.20",
      gene_type : "protein_coding",
      gene_name : "ITPR1",
      gene_level : 2,
      hgnc_id : "HGNC:6180",
      havana_gene : "OTTHUMG00000154996.16",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 4979437,
      stop : 4985323,
      direction : "+",
      ID : "ENSG00000134107.5",
      gene_id : "ENSG00000134107.5",
      gene_type : "protein_coding",
      gene_name : "BHLHE40",
      gene_level : 2,
      hgnc_id : "HGNC:1046",
      havana_gene : "OTTHUMG00000119035.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 5122249,
      stop : 5180911,
      direction : "+",
      ID : "ENSG00000134108.14",
      gene_id : "ENSG00000134108.14",
      gene_type : "protein_coding",
      gene_name : "ARL8B",
      gene_level : 2,
      hgnc_id : "HGNC:25564",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 5187646,
      stop : 5219958,
      direction : "+",
      ID : "ENSG00000134109.11",
      gene_id : "ENSG00000134109.11",
      gene_type : "protein_coding",
      gene_name : "EDEM1",
      gene_level : 2,
      hgnc_id : "HGNC:18967",
      havana_gene : "OTTHUMG00000154896.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 6770001,
      stop : 7741533,
      direction : "+",
      ID : "ENSG00000196277.16",
      gene_id : "ENSG00000196277.16",
      gene_type : "protein_coding",
      gene_name : "GRM7",
      gene_level : 1,
      hgnc_id : "HGNC:4599",
      havana_gene : "OTTHUMG00000125549.16",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 8501807,
      stop : 8574668,
      direction : "+",
      ID : "ENSG00000071282.12",
      gene_id : "ENSG00000071282.12",
      gene_type : "protein_coding",
      gene_name : "LMCD1",
      gene_level : 1,
      hgnc_id : "HGNC:6633",
      havana_gene : "OTTHUMG00000154971.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 8619400,
      stop : 8745040,
      direction : "-",
      ID : "ENSG00000125046.15",
      gene_id : "ENSG00000125046.15",
      gene_type : "protein_coding",
      gene_name : "SSUH2",
      gene_level : 2,
      hgnc_id : "HGNC:24809",
      havana_gene : "OTTHUMG00000122075.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 8733802,
      stop : 8841808,
      direction : "+",
      ID : "ENSG00000182533.7",
      gene_id : "ENSG00000182533.7",
      gene_type : "protein_coding",
      gene_name : "CAV3",
      gene_level : 2,
      hgnc_id : "HGNC:1529",
      havana_gene : "OTTHUMG00000090519.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 8750381,
      stop : 8769628,
      direction : "-",
      ID : "ENSG00000180914.11",
      gene_id : "ENSG00000180914.11",
      gene_type : "protein_coding",
      gene_name : "OXTR",
      gene_level : 2,
      hgnc_id : "HGNC:8529",
      havana_gene : "OTTHUMG00000090537.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 8775402,
      stop : 8963773,
      direction : "-",
      ID : "ENSG00000070950.10",
      gene_id : "ENSG00000070950.10",
      gene_type : "protein_coding",
      gene_name : "RAD18",
      gene_level : 2,
      hgnc_id : "HGNC:18278",
      havana_gene : "OTTHUMG00000090545.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 8980591,
      stop : 9363053,
      direction : "-",
      ID : "ENSG00000196220.16",
      gene_id : "ENSG00000196220.16",
      gene_type : "protein_coding",
      gene_name : "SRGAP3",
      gene_level : 2,
      hgnc_id : "HGNC:19744",
      havana_gene : "OTTHUMG00000090589.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9362971,
      stop : 9386791,
      direction : "+",
      ID : "ENSG00000134077.16",
      gene_id : "ENSG00000134077.16",
      gene_type : "protein_coding",
      gene_name : "THUMPD3",
      gene_level : 1,
      hgnc_id : "HGNC:24493",
      havana_gene : "OTTHUMG00000097031.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9397615,
      stop : 9479240,
      direction : "+",
      ID : "ENSG00000168137.18",
      gene_id : "ENSG00000168137.18",
      gene_type : "protein_coding",
      gene_name : "SETD5",
      gene_level : 1,
      hgnc_id : "HGNC:25566",
      havana_gene : "OTTHUMG00000150491.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9498361,
      stop : 9553822,
      direction : "-",
      ID : "ENSG00000156959.9",
      gene_id : "ENSG00000156959.9",
      gene_type : "protein_coding",
      gene_name : "LHFPL4",
      gene_level : 2,
      hgnc_id : "HGNC:29568",
      havana_gene : "OTTHUMG00000155066.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9649433,
      stop : 9702393,
      direction : "+",
      ID : "ENSG00000163719.20",
      gene_id : "ENSG00000163719.20",
      gene_type : "protein_coding",
      gene_name : "MTMR14",
      gene_level : 1,
      hgnc_id : "HGNC:26190",
      havana_gene : "OTTHUMG00000155111.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9703826,
      stop : 9729908,
      direction : "+",
      ID : "ENSG00000144550.13",
      gene_id : "ENSG00000144550.13",
      gene_type : "protein_coding",
      gene_name : "CPNE9",
      gene_level : 2,
      hgnc_id : "HGNC:24336",
      havana_gene : "OTTHUMG00000128418.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9731729,
      stop : 9748015,
      direction : "+",
      ID : "ENSG00000156983.16",
      gene_id : "ENSG00000156983.16",
      gene_type : "protein_coding",
      gene_name : "BRPF1",
      gene_level : 1,
      hgnc_id : "HGNC:14255",
      havana_gene : "OTTHUMG00000097033.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9749944,
      stop : 9788219,
      direction : "+",
      ID : "ENSG00000114026.22",
      gene_id : "ENSG00000114026.22",
      gene_type : "protein_coding",
      gene_name : "OGG1",
      gene_level : 1,
      hgnc_id : "HGNC:8125",
      havana_gene : "OTTHUMG00000097091.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9757347,
      stop : 9769992,
      direction : "-",
      ID : "ENSG00000134072.11",
      gene_id : "ENSG00000134072.11",
      gene_type : "protein_coding",
      gene_name : "CAMK1",
      gene_level : 2,
      hgnc_id : "HGNC:1459",
      havana_gene : "OTTHUMG00000128419.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9779860,
      stop : 9793011,
      direction : "-",
      ID : "ENSG00000171148.13",
      gene_id : "ENSG00000171148.13",
      gene_type : "protein_coding",
      gene_name : "TADA3",
      gene_level : 2,
      hgnc_id : "HGNC:19422",
      havana_gene : "OTTHUMG00000128440.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9792495,
      stop : 9807101,
      direction : "+",
      ID : "ENSG00000241553.13",
      gene_id : "ENSG00000241553.13",
      gene_type : "protein_coding",
      gene_name : "ARPC4",
      gene_level : 1,
      hgnc_id : "HGNC:707",
      havana_gene : "OTTHUMG00000133768.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9793082,
      stop : 9835401,
      direction : "+",
      ID : "ENSG00000250151.9",
      gene_id : "ENSG00000250151.9",
      gene_type : "protein_coding",
      gene_name : "ARPC4-TTLL3",
      gene_level : 1,
      hgnc_id : "HGNC:38830",
      havana_gene : "OTTHUMG00000161408.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9808086,
      stop : 9855138,
      direction : "+",
      ID : "ENSG00000214021.16",
      gene_id : "ENSG00000214021.16",
      gene_type : "protein_coding",
      gene_name : "TTLL3",
      gene_level : 1,
      hgnc_id : "HGNC:24483",
      havana_gene : "OTTHUMG00000128439.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9837849,
      stop : 9844602,
      direction : "-",
      ID : "ENSG00000156990.14",
      gene_id : "ENSG00000156990.14",
      gene_type : "protein_coding",
      gene_name : "RPUSD3",
      gene_level : 1,
      hgnc_id : "HGNC:28437",
      havana_gene : "OTTHUMG00000128441.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9866711,
      stop : 9880255,
      direction : "-",
      ID : "ENSG00000187288.12",
      gene_id : "ENSG00000187288.12",
      gene_type : "protein_coding",
      gene_name : "CIDEC",
      gene_level : 2,
      hgnc_id : "HGNC:24229",
      havana_gene : "OTTHUMG00000128522.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9890574,
      stop : 9894349,
      direction : "+",
      ID : "ENSG00000171135.15",
      gene_id : "ENSG00000171135.15",
      gene_type : "protein_coding",
      gene_name : "JAGN1",
      gene_level : 2,
      hgnc_id : "HGNC:26926",
      havana_gene : "OTTHUMG00000128523.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9902612,
      stop : 9916402,
      direction : "+",
      ID : "ENSG00000163701.19",
      gene_id : "ENSG00000163701.19",
      gene_type : "protein_coding",
      gene_name : "IL17RE",
      gene_level : 2,
      hgnc_id : "HGNC:18439",
      havana_gene : "OTTHUMG00000128649.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9917074,
      stop : 9933630,
      direction : "+",
      ID : "ENSG00000163702.20",
      gene_id : "ENSG00000163702.20",
      gene_type : "protein_coding",
      gene_name : "IL17RC",
      gene_level : 2,
      hgnc_id : "HGNC:18358",
      havana_gene : "OTTHUMG00000128648.43",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9929852,
      stop : 9945358,
      direction : "+",
      ID : "ENSG00000288550.1",
      gene_id : "ENSG00000288550.1",
      gene_type : "protein_coding",
      gene_name : "AC018809.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000128653.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9933816,
      stop : 9945406,
      direction : "+",
      ID : "ENSG00000163703.19",
      gene_id : "ENSG00000163703.19",
      gene_type : "protein_coding",
      gene_name : "CRELD1",
      gene_level : 1,
      hgnc_id : "HGNC:14630",
      havana_gene : "OTTHUMG00000195945.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9945542,
      stop : 9952408,
      direction : "-",
      ID : "ENSG00000163704.12",
      gene_id : "ENSG00000163704.12",
      gene_type : "protein_coding",
      gene_name : "PRRT3",
      gene_level : 2,
      hgnc_id : "HGNC:26591",
      havana_gene : "OTTHUMG00000155285.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 9962537,
      stop : 10011116,
      direction : "-",
      ID : "ENSG00000125037.12",
      gene_id : "ENSG00000125037.12",
      gene_type : "protein_coding",
      gene_name : "EMC3",
      gene_level : 2,
      hgnc_id : "HGNC:23999",
      havana_gene : "OTTHUMG00000128652.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10026414,
      stop : 10101932,
      direction : "+",
      ID : "ENSG00000144554.12",
      gene_id : "ENSG00000144554.12",
      gene_type : "protein_coding",
      gene_name : "FANCD2",
      gene_level : 2,
      hgnc_id : "HGNC:3585",
      havana_gene : "OTTHUMG00000128670.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10081317,
      stop : 10108255,
      direction : "-",
      ID : "ENSG00000163705.13",
      gene_id : "ENSG00000163705.13",
      gene_type : "protein_coding",
      gene_name : "FANCD2OS",
      gene_level : 1,
      hgnc_id : "HGNC:28623",
      havana_gene : "OTTHUMG00000128669.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10115675,
      stop : 10127190,
      direction : "+",
      ID : "ENSG00000254999.4",
      gene_id : "ENSG00000254999.4",
      gene_type : "protein_coding",
      gene_name : "BRK1",
      gene_level : 2,
      hgnc_id : "HGNC:23057",
      havana_gene : "OTTHUMG00000155400.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10141778,
      stop : 10153667,
      direction : "+",
      ID : "ENSG00000134086.8",
      gene_id : "ENSG00000134086.8",
      gene_type : "protein_coding",
      gene_name : "VHL",
      gene_level : 2,
      hgnc_id : "HGNC:12687",
      havana_gene : "OTTHUMG00000128668.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10164919,
      stop : 10243745,
      direction : "+",
      ID : "ENSG00000134070.5",
      gene_id : "ENSG00000134070.5",
      gene_type : "protein_coding",
      gene_name : "IRAK2",
      gene_level : 2,
      hgnc_id : "HGNC:6113",
      havana_gene : "OTTHUMG00000155358.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10248023,
      stop : 10281218,
      direction : "+",
      ID : "ENSG00000157014.11",
      gene_id : "ENSG00000157014.11",
      gene_type : "protein_coding",
      gene_name : "TATDN2",
      gene_level : 2,
      hgnc_id : "HGNC:28988",
      havana_gene : "OTTHUMG00000155361.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10249372,
      stop : 10285796,
      direction : "+",
      ID : "ENSG00000272410.5",
      gene_id : "ENSG00000272410.5",
      gene_type : "protein_coding",
      gene_name : "AC022384.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185357.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10285666,
      stop : 10292947,
      direction : "-",
      ID : "ENSG00000157017.16",
      gene_id : "ENSG00000157017.16",
      gene_type : "protein_coding",
      gene_name : "GHRL",
      gene_level : 2,
      hgnc_id : "HGNC:18129",
      havana_gene : "OTTHUMG00000155360.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10293131,
      stop : 10321112,
      direction : "-",
      ID : "ENSG00000157020.18",
      gene_id : "ENSG00000157020.18",
      gene_type : "protein_coding",
      gene_name : "SEC13",
      gene_level : 1,
      hgnc_id : "HGNC:10697",
      havana_gene : "OTTHUMG00000128671.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10324023,
      stop : 10708007,
      direction : "-",
      ID : "ENSG00000157087.20",
      gene_id : "ENSG00000157087.20",
      gene_type : "protein_coding",
      gene_name : "ATP2B2",
      gene_level : 2,
      hgnc_id : "HGNC:815",
      havana_gene : "OTTHUMG00000128679.20",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10816201,
      stop : 10940714,
      direction : "+",
      ID : "ENSG00000132164.10",
      gene_id : "ENSG00000132164.10",
      gene_type : "protein_coding",
      gene_name : "SLC6A11",
      gene_level : 2,
      hgnc_id : "HGNC:11044",
      havana_gene : "OTTHUMG00000129718.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 10992186,
      stop : 11039247,
      direction : "+",
      ID : "ENSG00000157103.12",
      gene_id : "ENSG00000157103.12",
      gene_type : "protein_coding",
      gene_name : "SLC6A1",
      gene_level : 2,
      hgnc_id : "HGNC:11042",
      havana_gene : "OTTHUMG00000044208.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 11137093,
      stop : 11263557,
      direction : "+",
      ID : "ENSG00000196639.7",
      gene_id : "ENSG00000196639.7",
      gene_type : "protein_coding",
      gene_name : "HRH1",
      gene_level : 2,
      hgnc_id : "HGNC:5182",
      havana_gene : "OTTHUMG00000129719.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 11272309,
      stop : 11557665,
      direction : "+",
      ID : "ENSG00000197548.12",
      gene_id : "ENSG00000197548.12",
      gene_type : "protein_coding",
      gene_name : "ATG7",
      gene_level : 1,
      hgnc_id : "HGNC:16935",
      havana_gene : "OTTHUMG00000129740.21",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 11556069,
      stop : 11771350,
      direction : "-",
      ID : "ENSG00000144560.15",
      gene_id : "ENSG00000144560.15",
      gene_type : "protein_coding",
      gene_name : "VGLL4",
      gene_level : 1,
      hgnc_id : "HGNC:28966",
      havana_gene : "OTTHUMG00000129739.21",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 11790442,
      stop : 11846919,
      direction : "-",
      ID : "ENSG00000144559.10",
      gene_id : "ENSG00000144559.10",
      gene_type : "protein_coding",
      gene_name : "TAMM41",
      gene_level : 2,
      hgnc_id : "HGNC:25187",
      havana_gene : "OTTHUMG00000129741.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12004388,
      stop : 12192032,
      direction : "+",
      ID : "ENSG00000157152.17",
      gene_id : "ENSG00000157152.17",
      gene_type : "protein_coding",
      gene_name : "SYN2",
      gene_level : 2,
      hgnc_id : "HGNC:11495",
      havana_gene : "OTTHUMG00000155335.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12153068,
      stop : 12158912,
      direction : "-",
      ID : "ENSG00000157150.5",
      gene_id : "ENSG00000157150.5",
      gene_type : "protein_coding",
      gene_name : "TIMP4",
      gene_level : 2,
      hgnc_id : "HGNC:11823",
      havana_gene : "OTTHUMG00000129763.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12287368,
      stop : 12434356,
      direction : "+",
      ID : "ENSG00000132170.23",
      gene_id : "ENSG00000132170.23",
      gene_type : "protein_coding",
      gene_name : "PPARG",
      gene_level : 1,
      hgnc_id : "HGNC:9236",
      havana_gene : "OTTHUMG00000129764.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12484421,
      stop : 12541549,
      direction : "+",
      ID : "ENSG00000154743.19",
      gene_id : "ENSG00000154743.19",
      gene_type : "protein_coding",
      gene_name : "TSEN2",
      gene_level : 1,
      hgnc_id : "HGNC:28422",
      havana_gene : "OTTHUMG00000129765.22",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12514934,
      stop : 12561059,
      direction : "-",
      ID : "ENSG00000225526.5",
      gene_id : "ENSG00000225526.5",
      gene_type : "protein_coding",
      gene_name : "MKRN2OS",
      gene_level : 1,
      hgnc_id : "HGNC:40375",
      havana_gene : "OTTHUMG00000155368.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12557057,
      stop : 12586208,
      direction : "+",
      ID : "ENSG00000075975.17",
      gene_id : "ENSG00000075975.17",
      gene_type : "protein_coding",
      gene_name : "MKRN2",
      gene_level : 1,
      hgnc_id : "HGNC:7113",
      havana_gene : "OTTHUMG00000155371.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12583601,
      stop : 12664125,
      direction : "-",
      ID : "ENSG00000132155.13",
      gene_id : "ENSG00000132155.13",
      gene_type : "protein_coding",
      gene_name : "RAF1",
      gene_level : 2,
      hgnc_id : "HGNC:9829",
      havana_gene : "OTTHUMG00000129789.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12733528,
      stop : 12769457,
      direction : "-",
      ID : "ENSG00000088726.16",
      gene_id : "ENSG00000088726.16",
      gene_type : "protein_coding",
      gene_name : "TMEM40",
      gene_level : 2,
      hgnc_id : "HGNC:25620",
      havana_gene : "OTTHUMG00000129801.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12796472,
      stop : 12871916,
      direction : "+",
      ID : "ENSG00000144712.12",
      gene_id : "ENSG00000144712.12",
      gene_type : "protein_coding",
      gene_name : "CAND2",
      gene_level : 1,
      hgnc_id : "HGNC:30689",
      havana_gene : "OTTHUMG00000155397.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12834485,
      stop : 12841582,
      direction : "-",
      ID : "ENSG00000144713.13",
      gene_id : "ENSG00000144713.13",
      gene_type : "protein_coding",
      gene_name : "RPL32",
      gene_level : 2,
      hgnc_id : "HGNC:10336",
      havana_gene : "OTTHUMG00000129804.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 12897043,
      stop : 13283281,
      direction : "-",
      ID : "ENSG00000144711.16",
      gene_id : "ENSG00000144711.16",
      gene_type : "protein_coding",
      gene_name : "IQSEC1",
      gene_level : 1,
      hgnc_id : "HGNC:29112",
      havana_gene : "OTTHUMG00000155398.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 13316235,
      stop : 13420322,
      direction : "-",
      ID : "ENSG00000132182.12",
      gene_id : "ENSG00000132182.12",
      gene_type : "protein_coding",
      gene_name : "NUP210",
      gene_level : 2,
      hgnc_id : "HGNC:30052",
      havana_gene : "OTTHUMG00000157268.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 13479724,
      stop : 13506424,
      direction : "+",
      ID : "ENSG00000163517.15",
      gene_id : "ENSG00000163517.15",
      gene_type : "protein_coding",
      gene_name : "HDAC11",
      gene_level : 1,
      hgnc_id : "HGNC:19086",
      havana_gene : "OTTHUMG00000129800.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 13549125,
      stop : 13638422,
      direction : "+",
      ID : "ENSG00000163520.14",
      gene_id : "ENSG00000163520.14",
      gene_type : "protein_coding",
      gene_name : "FBLN2",
      gene_level : 1,
      hgnc_id : "HGNC:3601",
      havana_gene : "OTTHUMG00000155437.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 13816258,
      stop : 13880071,
      direction : "-",
      ID : "ENSG00000154764.6",
      gene_id : "ENSG00000154764.6",
      gene_type : "protein_coding",
      gene_name : "WNT7A",
      gene_level : 1,
      hgnc_id : "HGNC:12786",
      havana_gene : "OTTHUMG00000129803.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14112077,
      stop : 14124870,
      direction : "-",
      ID : "ENSG00000163528.13",
      gene_id : "ENSG00000163528.13",
      gene_type : "protein_coding",
      gene_name : "CHCHD4",
      gene_level : 2,
      hgnc_id : "HGNC:26467",
      havana_gene : "OTTHUMG00000129805.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14125015,
      stop : 14143680,
      direction : "+",
      ID : "ENSG00000170876.8",
      gene_id : "ENSG00000170876.8",
      gene_type : "protein_coding",
      gene_name : "TMEM43",
      gene_level : 2,
      hgnc_id : "HGNC:28472",
      havana_gene : "OTTHUMG00000129802.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14135217,
      stop : 14148252,
      direction : "+",
      ID : "ENSG00000268279.4",
      gene_id : "ENSG00000268279.4",
      gene_type : "protein_coding",
      gene_name : "AC090004.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000182442.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14145147,
      stop : 14178621,
      direction : "-",
      ID : "ENSG00000154767.15",
      gene_id : "ENSG00000154767.15",
      gene_type : "protein_coding",
      gene_name : "XPC",
      gene_level : 1,
      hgnc_id : "HGNC:12816",
      havana_gene : "OTTHUMG00000155526.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14178817,
      stop : 14201122,
      direction : "+",
      ID : "ENSG00000170860.4",
      gene_id : "ENSG00000170860.4",
      gene_type : "protein_coding",
      gene_name : "LSM3",
      gene_level : 2,
      hgnc_id : "HGNC:17874",
      havana_gene : "OTTHUMG00000129838.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14402576,
      stop : 14489349,
      direction : "+",
      ID : "ENSG00000131389.17",
      gene_id : "ENSG00000131389.17",
      gene_type : "protein_coding",
      gene_name : "SLC6A6",
      gene_level : 1,
      hgnc_id : "HGNC:11052",
      havana_gene : "OTTHUMG00000155525.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14489107,
      stop : 14556075,
      direction : "-",
      ID : "ENSG00000144596.13",
      gene_id : "ENSG00000144596.13",
      gene_type : "protein_coding",
      gene_name : "GRIP2",
      gene_level : 2,
      hgnc_id : "HGNC:23841",
      havana_gene : "OTTHUMG00000155544.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14651746,
      stop : 14672659,
      direction : "+",
      ID : "ENSG00000154781.16",
      gene_id : "ENSG00000154781.16",
      gene_type : "protein_coding",
      gene_name : "CCDC174",
      gene_level : 2,
      hgnc_id : "HGNC:28033",
      havana_gene : "OTTHUMG00000129837.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14675141,
      stop : 14773036,
      direction : "+",
      ID : "ENSG00000131379.10",
      gene_id : "ENSG00000131379.10",
      gene_type : "protein_coding",
      gene_name : "C3orf20",
      gene_level : 2,
      hgnc_id : "HGNC:25320",
      havana_gene : "OTTHUMG00000155545.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14810853,
      stop : 14934571,
      direction : "+",
      ID : "ENSG00000154783.12",
      gene_id : "ENSG00000154783.12",
      gene_type : "protein_coding",
      gene_name : "FGD5",
      gene_level : 2,
      hgnc_id : "HGNC:19117",
      havana_gene : "OTTHUMG00000155556.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 14947584,
      stop : 15053600,
      direction : "+",
      ID : "ENSG00000177463.15",
      gene_id : "ENSG00000177463.15",
      gene_type : "protein_coding",
      gene_name : "NR2C2",
      gene_level : 1,
      hgnc_id : "HGNC:7972",
      havana_gene : "OTTHUMG00000129839.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15042460,
      stop : 15065317,
      direction : "-",
      ID : "ENSG00000131368.8",
      gene_id : "ENSG00000131368.8",
      gene_type : "protein_coding",
      gene_name : "MRPS25",
      gene_level : 1,
      hgnc_id : "HGNC:14511",
      havana_gene : "OTTHUMG00000129836.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15070073,
      stop : 15099163,
      direction : "-",
      ID : "ENSG00000131381.12",
      gene_id : "ENSG00000131381.12",
      gene_type : "protein_coding",
      gene_name : "RBSN",
      gene_level : 2,
      hgnc_id : "HGNC:20759",
      havana_gene : "OTTHUMG00000129860.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15206152,
      stop : 15252916,
      direction : "+",
      ID : "ENSG00000131375.10",
      gene_id : "ENSG00000131375.10",
      gene_type : "protein_coding",
      gene_name : "CAPN7",
      gene_level : 2,
      hgnc_id : "HGNC:1484",
      havana_gene : "OTTHUMG00000129863.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15254353,
      stop : 15341368,
      direction : "-",
      ID : "ENSG00000131370.16",
      gene_id : "ENSG00000131370.16",
      gene_type : "protein_coding",
      gene_name : "SH3BP5",
      gene_level : 2,
      hgnc_id : "HGNC:10827",
      havana_gene : "OTTHUMG00000129859.18",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15381275,
      stop : 15440566,
      direction : "-",
      ID : "ENSG00000206562.12",
      gene_id : "ENSG00000206562.12",
      gene_type : "protein_coding",
      gene_name : "METTL6",
      gene_level : 1,
      hgnc_id : "HGNC:28343",
      havana_gene : "OTTHUMG00000156431.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15427598,
      stop : 15450635,
      direction : "+",
      ID : "ENSG00000144597.14",
      gene_id : "ENSG00000144597.14",
      gene_type : "protein_coding",
      gene_name : "EAF1",
      gene_level : 2,
      hgnc_id : "HGNC:20907",
      havana_gene : "OTTHUMG00000162544.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15450133,
      stop : 15521751,
      direction : "-",
      ID : "ENSG00000206561.14",
      gene_id : "ENSG00000206561.14",
      gene_type : "protein_coding",
      gene_name : "COLQ",
      gene_level : 1,
      hgnc_id : "HGNC:2226",
      havana_gene : "OTTHUMG00000156233.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15560699,
      stop : 15601852,
      direction : "-",
      ID : "ENSG00000131373.15",
      gene_id : "ENSG00000131373.15",
      gene_type : "protein_coding",
      gene_name : "HACL1",
      gene_level : 1,
      hgnc_id : "HGNC:17856",
      havana_gene : "OTTHUMG00000129862.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15601341,
      stop : 15722311,
      direction : "+",
      ID : "ENSG00000169814.16",
      gene_id : "ENSG00000169814.16",
      gene_type : "protein_coding",
      gene_name : "BTD",
      gene_level : 1,
      hgnc_id : "HGNC:1122",
      havana_gene : "OTTHUMG00000129861.19",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 15667236,
      stop : 15859771,
      direction : "-",
      ID : "ENSG00000206560.11",
      gene_id : "ENSG00000206560.11",
      gene_type : "protein_coding",
      gene_name : "ANKRD28",
      gene_level : 1,
      hgnc_id : "HGNC:29024",
      havana_gene : "OTTHUMG00000155379.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 16174680,
      stop : 16231992,
      direction : "+",
      ID : "ENSG00000131386.19",
      gene_id : "ENSG00000131386.19",
      gene_type : "protein_coding",
      gene_name : "GALNT15",
      gene_level : 1,
      hgnc_id : "HGNC:21531",
      havana_gene : "OTTHUMG00000156893.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 16257061,
      stop : 16264969,
      direction : "-",
      ID : "ENSG00000154813.10",
      gene_id : "ENSG00000154813.10",
      gene_type : "protein_coding",
      gene_name : "DPH3",
      gene_level : 2,
      hgnc_id : "HGNC:27717",
      havana_gene : "OTTHUMG00000129866.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 16265160,
      stop : 16350299,
      direction : "+",
      ID : "ENSG00000154814.14",
      gene_id : "ENSG00000154814.14",
      gene_type : "protein_coding",
      gene_name : "OXNAD1",
      gene_level : 2,
      hgnc_id : "HGNC:25128",
      havana_gene : "OTTHUMG00000129867.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 16313574,
      stop : 16514026,
      direction : "-",
      ID : "ENSG00000131378.14",
      gene_id : "ENSG00000131378.14",
      gene_type : "protein_coding",
      gene_name : "RFTN1",
      gene_level : 1,
      hgnc_id : "HGNC:30278",
      havana_gene : "OTTHUMG00000156973.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 16586792,
      stop : 16670306,
      direction : "-",
      ID : "ENSG00000092345.14",
      gene_id : "ENSG00000092345.14",
      gene_type : "protein_coding",
      gene_name : "DAZL",
      gene_level : 2,
      hgnc_id : "HGNC:2685",
      havana_gene : "OTTHUMG00000157050.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 16802651,
      stop : 17090604,
      direction : "+",
      ID : "ENSG00000154822.18",
      gene_id : "ENSG00000154822.18",
      gene_type : "protein_coding",
      gene_name : "PLCL2",
      gene_level : 2,
      hgnc_id : "HGNC:9064",
      havana_gene : "OTTHUMG00000155467.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 17157162,
      stop : 18444817,
      direction : "-",
      ID : "ENSG00000131374.14",
      gene_id : "ENSG00000131374.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D5",
      gene_level : 2,
      hgnc_id : "HGNC:19166",
      havana_gene : "OTTHUMG00000155488.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 18345377,
      stop : 18445588,
      direction : "-",
      ID : "ENSG00000182568.17",
      gene_id : "ENSG00000182568.17",
      gene_type : "protein_coding",
      gene_name : "SATB1",
      gene_level : 1,
      hgnc_id : "HGNC:10541",
      havana_gene : "OTTHUMG00000129890.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 19148510,
      stop : 19535642,
      direction : "+",
      ID : "ENSG00000183960.9",
      gene_id : "ENSG00000183960.9",
      gene_type : "protein_coding",
      gene_name : "KCNH8",
      gene_level : 2,
      hgnc_id : "HGNC:18864",
      havana_gene : "OTTHUMG00000129891.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 19879472,
      stop : 19947025,
      direction : "-",
      ID : "ENSG00000163576.18",
      gene_id : "ENSG00000163576.18",
      gene_type : "protein_coding",
      gene_name : "EFHB",
      gene_level : 1,
      hgnc_id : "HGNC:26330",
      havana_gene : "OTTHUMG00000150505.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 19947097,
      stop : 19985175,
      direction : "+",
      ID : "ENSG00000144566.11",
      gene_id : "ENSG00000144566.11",
      gene_type : "protein_coding",
      gene_name : "RAB5A",
      gene_level : 1,
      hgnc_id : "HGNC:9783",
      havana_gene : "OTTHUMG00000129889.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 19979961,
      stop : 20012267,
      direction : "-",
      ID : "ENSG00000183977.14",
      gene_id : "ENSG00000183977.14",
      gene_type : "protein_coding",
      gene_name : "PP2D1",
      gene_level : 2,
      hgnc_id : "HGNC:28406",
      havana_gene : "OTTHUMG00000155393.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 20040446,
      stop : 20154404,
      direction : "+",
      ID : "ENSG00000114166.8",
      gene_id : "ENSG00000114166.8",
      gene_type : "protein_coding",
      gene_name : "KAT2B",
      gene_level : 2,
      hgnc_id : "HGNC:8638",
      havana_gene : "OTTHUMG00000130481.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 20160593,
      stop : 20186206,
      direction : "-",
      ID : "ENSG00000129810.15",
      gene_id : "ENSG00000129810.15",
      gene_type : "protein_coding",
      gene_name : "SGO1",
      gene_level : 2,
      hgnc_id : "HGNC:25088",
      havana_gene : "OTTHUMG00000130479.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 21412218,
      stop : 22373321,
      direction : "-",
      ID : "ENSG00000151789.12",
      gene_id : "ENSG00000151789.12",
      gene_type : "protein_coding",
      gene_name : "ZNF385D",
      gene_level : 1,
      hgnc_id : "HGNC:26191",
      havana_gene : "OTTHUMG00000130484.12",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 23203020,
      stop : 23591794,
      direction : "+",
      ID : "ENSG00000182247.10",
      gene_id : "ENSG00000182247.10",
      gene_type : "protein_coding",
      gene_name : "UBE2E2",
      gene_level : 2,
      hgnc_id : "HGNC:12478",
      havana_gene : "OTTHUMG00000130482.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 23805955,
      stop : 23891640,
      direction : "+",
      ID : "ENSG00000170142.12",
      gene_id : "ENSG00000170142.12",
      gene_type : "protein_coding",
      gene_name : "UBE2E1",
      gene_level : 1,
      hgnc_id : "HGNC:12477",
      havana_gene : "OTTHUMG00000130483.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 23889951,
      stop : 23946591,
      direction : "-",
      ID : "ENSG00000197885.11",
      gene_id : "ENSG00000197885.11",
      gene_type : "protein_coding",
      gene_name : "NKIRAS1",
      gene_level : 2,
      hgnc_id : "HGNC:17899",
      havana_gene : "OTTHUMG00000155605.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 23916591,
      stop : 23924374,
      direction : "+",
      ID : "ENSG00000174748.22",
      gene_id : "ENSG00000174748.22",
      gene_type : "protein_coding",
      gene_name : "RPL15",
      gene_level : 1,
      hgnc_id : "HGNC:10306",
      havana_gene : "OTTHUMG00000130485.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 23945286,
      stop : 23980617,
      direction : "+",
      ID : "ENSG00000174738.13",
      gene_id : "ENSG00000174738.13",
      gene_type : "protein_coding",
      gene_name : "NR1D2",
      gene_level : 2,
      hgnc_id : "HGNC:7963",
      havana_gene : "OTTHUMG00000155659.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 24117153,
      stop : 24495756,
      direction : "-",
      ID : "ENSG00000151090.20",
      gene_id : "ENSG00000151090.20",
      gene_type : "protein_coding",
      gene_name : "THRB",
      gene_level : 1,
      hgnc_id : "HGNC:11799",
      havana_gene : "OTTHUMG00000130478.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 25174332,
      stop : 25597932,
      direction : "+",
      ID : "ENSG00000077092.19",
      gene_id : "ENSG00000077092.19",
      gene_type : "protein_coding",
      gene_name : "RARB",
      gene_level : 1,
      hgnc_id : "HGNC:9865",
      havana_gene : "OTTHUMG00000130480.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 25597905,
      stop : 25664907,
      direction : "-",
      ID : "ENSG00000077097.15",
      gene_id : "ENSG00000077097.15",
      gene_type : "protein_coding",
      gene_name : "TOP2B",
      gene_level : 2,
      hgnc_id : "HGNC:11990",
      havana_gene : "OTTHUMG00000155596.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 25718944,
      stop : 25790039,
      direction : "-",
      ID : "ENSG00000151092.18",
      gene_id : "ENSG00000151092.18",
      gene_type : "protein_coding",
      gene_name : "NGLY1",
      gene_level : 1,
      hgnc_id : "HGNC:17646",
      havana_gene : "OTTHUMG00000155600.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 25782917,
      stop : 25794534,
      direction : "+",
      ID : "ENSG00000151093.8",
      gene_id : "ENSG00000151093.8",
      gene_type : "protein_coding",
      gene_name : "OXSM",
      gene_level : 1,
      hgnc_id : "HGNC:26063",
      havana_gene : "OTTHUMG00000130477.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 26622806,
      stop : 26717537,
      direction : "+",
      ID : "ENSG00000179796.12",
      gene_id : "ENSG00000179796.12",
      gene_type : "protein_coding",
      gene_name : "LRRC3B",
      gene_level : 2,
      hgnc_id : "HGNC:28105",
      havana_gene : "OTTHUMG00000130572.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 27110085,
      stop : 27369460,
      direction : "-",
      ID : "ENSG00000163491.16",
      gene_id : "ENSG00000163491.16",
      gene_type : "protein_coding",
      gene_name : "NEK10",
      gene_level : 1,
      hgnc_id : "HGNC:18592",
      havana_gene : "OTTHUMG00000130571.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 27372721,
      stop : 27484420,
      direction : "-",
      ID : "ENSG00000033867.16",
      gene_id : "ENSG00000033867.16",
      gene_type : "protein_coding",
      gene_name : "SLC4A7",
      gene_level : 2,
      hgnc_id : "HGNC:11033",
      havana_gene : "OTTHUMG00000155679.15",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 27715949,
      stop : 27722711,
      direction : "-",
      ID : "ENSG00000163508.13",
      gene_id : "ENSG00000163508.13",
      gene_type : "protein_coding",
      gene_name : "EOMES",
      gene_level : 2,
      hgnc_id : "HGNC:3372",
      havana_gene : "OTTHUMG00000130570.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 28241584,
      stop : 28325142,
      direction : "+",
      ID : "ENSG00000187118.14",
      gene_id : "ENSG00000187118.14",
      gene_type : "protein_coding",
      gene_name : "CMC1",
      gene_level : 2,
      hgnc_id : "HGNC:28783",
      havana_gene : "OTTHUMG00000155660.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 28315003,
      stop : 28349050,
      direction : "-",
      ID : "ENSG00000163512.14",
      gene_id : "ENSG00000163512.14",
      gene_type : "protein_coding",
      gene_name : "AZI2",
      gene_level : 1,
      hgnc_id : "HGNC:24002",
      havana_gene : "OTTHUMG00000130573.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 28348721,
      stop : 28538122,
      direction : "+",
      ID : "ENSG00000206559.8",
      gene_id : "ENSG00000206559.8",
      gene_type : "protein_coding",
      gene_name : "ZCWPW2",
      gene_level : 1,
      hgnc_id : "HGNC:23574",
      havana_gene : "OTTHUMG00000155705.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 28349178,
      stop : 29767537,
      direction : "+",
      ID : "ENSG00000283563.1",
      gene_id : "ENSG00000283563.1",
      gene_type : "protein_coding",
      gene_name : "AC098650.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191752.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 28574791,
      stop : 30010391,
      direction : "+",
      ID : "ENSG00000144642.22",
      gene_id : "ENSG00000144642.22",
      gene_type : "protein_coding",
      gene_name : "RBMS3",
      gene_level : 2,
      hgnc_id : "HGNC:13427",
      havana_gene : "OTTHUMG00000155699.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 30606601,
      stop : 30694142,
      direction : "+",
      ID : "ENSG00000163513.19",
      gene_id : "ENSG00000163513.19",
      gene_type : "protein_coding",
      gene_name : "TGFBR2",
      gene_level : 2,
      hgnc_id : "HGNC:11773",
      havana_gene : "OTTHUMG00000130569.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 30726200,
      stop : 30894765,
      direction : "-",
      ID : "ENSG00000144644.14",
      gene_id : "ENSG00000144644.14",
      gene_type : "protein_coding",
      gene_name : "GADL1",
      gene_level : 2,
      hgnc_id : "HGNC:27949",
      havana_gene : "OTTHUMG00000130621.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 31532638,
      stop : 31637616,
      direction : "+",
      ID : "ENSG00000163527.10",
      gene_id : "ENSG00000163527.10",
      gene_type : "protein_coding",
      gene_name : "STT3B",
      gene_level : 2,
      hgnc_id : "HGNC:30611",
      havana_gene : "OTTHUMG00000130673.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 31657912,
      stop : 32077580,
      direction : "-",
      ID : "ENSG00000144645.15",
      gene_id : "ENSG00000144645.15",
      gene_type : "protein_coding",
      gene_name : "OSBPL10",
      gene_level : 2,
      hgnc_id : "HGNC:16395",
      havana_gene : "OTTHUMG00000130672.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 31981750,
      stop : 31991723,
      direction : "+",
      ID : "ENSG00000197385.6",
      gene_id : "ENSG00000197385.6",
      gene_type : "protein_coding",
      gene_name : "ZNF860",
      gene_level : 2,
      hgnc_id : "HGNC:34513",
      havana_gene : "OTTHUMG00000155838.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32105689,
      stop : 32168709,
      direction : "+",
      ID : "ENSG00000152642.11",
      gene_id : "ENSG00000152642.11",
      gene_type : "protein_coding",
      gene_name : "GPD1L",
      gene_level : 2,
      hgnc_id : "HGNC:28956",
      havana_gene : "OTTHUMG00000155846.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32238679,
      stop : 32370321,
      direction : "+",
      ID : "ENSG00000170293.9",
      gene_id : "ENSG00000170293.9",
      gene_type : "protein_coding",
      gene_name : "CMTM8",
      gene_level : 2,
      hgnc_id : "HGNC:19179",
      havana_gene : "OTTHUMG00000130753.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32391698,
      stop : 32483067,
      direction : "+",
      ID : "ENSG00000153551.14",
      gene_id : "ENSG00000153551.14",
      gene_type : "protein_coding",
      gene_name : "CMTM7",
      gene_level : 1,
      hgnc_id : "HGNC:19178",
      havana_gene : "OTTHUMG00000155869.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32481312,
      stop : 32502852,
      direction : "-",
      ID : "ENSG00000091317.8",
      gene_id : "ENSG00000091317.8",
      gene_type : "protein_coding",
      gene_name : "CMTM6",
      gene_level : 2,
      hgnc_id : "HGNC:19177",
      havana_gene : "OTTHUMG00000130747.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32525974,
      stop : 32570858,
      direction : "-",
      ID : "ENSG00000144635.9",
      gene_id : "ENSG00000144635.9",
      gene_type : "protein_coding",
      gene_name : "DYNC1LI1",
      gene_level : 1,
      hgnc_id : "HGNC:18745",
      havana_gene : "OTTHUMG00000130750.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32685145,
      stop : 32773875,
      direction : "+",
      ID : "ENSG00000182973.19",
      gene_id : "ENSG00000182973.19",
      gene_type : "protein_coding",
      gene_name : "CNOT10",
      gene_level : 1,
      hgnc_id : "HGNC:23817",
      havana_gene : "OTTHUMG00000130748.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32817997,
      stop : 32897824,
      direction : "+",
      ID : "ENSG00000206557.6",
      gene_id : "ENSG00000206557.6",
      gene_type : "protein_coding",
      gene_name : "TRIM71",
      gene_level : 2,
      hgnc_id : "HGNC:32669",
      havana_gene : "OTTHUMG00000155778.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32951644,
      stop : 32956349,
      direction : "+",
      ID : "ENSG00000183813.7",
      gene_id : "ENSG00000183813.7",
      gene_type : "protein_coding",
      gene_name : "CCR4",
      gene_level : 2,
      hgnc_id : "HGNC:1605",
      havana_gene : "OTTHUMG00000130752.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 32996609,
      stop : 33097202,
      direction : "-",
      ID : "ENSG00000170266.16",
      gene_id : "ENSG00000170266.16",
      gene_type : "protein_coding",
      gene_name : "GLB1",
      gene_level : 1,
      hgnc_id : "HGNC:4298",
      havana_gene : "OTTHUMG00000155781.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33090421,
      stop : 33097146,
      direction : "-",
      ID : "ENSG00000188167.9",
      gene_id : "ENSG00000188167.9",
      gene_type : "protein_coding",
      gene_name : "TMPPE",
      gene_level : 1,
      hgnc_id : "HGNC:33865",
      havana_gene : "OTTHUMG00000155779.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33114014,
      stop : 33147773,
      direction : "+",
      ID : "ENSG00000170275.15",
      gene_id : "ENSG00000170275.15",
      gene_type : "protein_coding",
      gene_name : "CRTAP",
      gene_level : 2,
      hgnc_id : "HGNC:2379",
      havana_gene : "OTTHUMG00000130746.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33150043,
      stop : 33218810,
      direction : "-",
      ID : "ENSG00000173705.9",
      gene_id : "ENSG00000173705.9",
      gene_type : "protein_coding",
      gene_name : "SUSD5",
      gene_level : 2,
      hgnc_id : "HGNC:29061",
      havana_gene : "OTTHUMG00000155829.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33277025,
      stop : 33403662,
      direction : "+",
      ID : "ENSG00000153558.16",
      gene_id : "ENSG00000153558.16",
      gene_type : "protein_coding",
      gene_name : "FBXL2",
      gene_level : 2,
      hgnc_id : "HGNC:13598",
      havana_gene : "OTTHUMG00000130745.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33388336,
      stop : 33441371,
      direction : "-",
      ID : "ENSG00000153560.12",
      gene_id : "ENSG00000153560.12",
      gene_type : "protein_coding",
      gene_name : "UBP1",
      gene_level : 2,
      hgnc_id : "HGNC:12507",
      havana_gene : "OTTHUMG00000130749.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33496245,
      stop : 33718356,
      direction : "-",
      ID : "ENSG00000163539.17",
      gene_id : "ENSG00000163539.17",
      gene_type : "protein_coding",
      gene_name : "CLASP2",
      gene_level : 1,
      hgnc_id : "HGNC:17078",
      havana_gene : "OTTHUMG00000156489.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 33798571,
      stop : 33869707,
      direction : "+",
      ID : "ENSG00000170248.15",
      gene_id : "ENSG00000170248.15",
      gene_type : "protein_coding",
      gene_name : "PDCD6IP",
      gene_level : 2,
      hgnc_id : "HGNC:8766",
      havana_gene : "OTTHUMG00000130751.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 35638945,
      stop : 35794496,
      direction : "+",
      ID : "ENSG00000172995.16",
      gene_id : "ENSG00000172995.16",
      gene_type : "protein_coding",
      gene_name : "ARPP21",
      gene_level : 2,
      hgnc_id : "HGNC:16968",
      havana_gene : "OTTHUMG00000130795.16",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 36380503,
      stop : 36548007,
      direction : "+",
      ID : "ENSG00000144681.11",
      gene_id : "ENSG00000144681.11",
      gene_type : "protein_coding",
      gene_name : "STAC",
      gene_level : 2,
      hgnc_id : "HGNC:11353",
      havana_gene : "OTTHUMG00000130798.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 36712422,
      stop : 36764349,
      direction : "-",
      ID : "ENSG00000163673.7",
      gene_id : "ENSG00000163673.7",
      gene_type : "protein_coding",
      gene_name : "DCLK3",
      gene_level : 2,
      hgnc_id : "HGNC:19005",
      havana_gene : "OTTHUMG00000155805.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 36826819,
      stop : 36945057,
      direction : "-",
      ID : "ENSG00000168016.15",
      gene_id : "ENSG00000168016.15",
      gene_type : "protein_coding",
      gene_name : "TRANK1",
      gene_level : 1,
      hgnc_id : "HGNC:29011",
      havana_gene : "OTTHUMG00000155848.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 36985043,
      stop : 36993131,
      direction : "-",
      ID : "ENSG00000178567.8",
      gene_id : "ENSG00000178567.8",
      gene_type : "protein_coding",
      gene_name : "EPM2AIP1",
      gene_level : 2,
      hgnc_id : "HGNC:19735",
      havana_gene : "OTTHUMG00000185486.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 36993350,
      stop : 37050846,
      direction : "+",
      ID : "ENSG00000076242.16",
      gene_id : "ENSG00000076242.16",
      gene_type : "protein_coding",
      gene_name : "MLH1",
      gene_level : 1,
      hgnc_id : "HGNC:7127",
      havana_gene : "OTTHUMG00000130797.25",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 37052626,
      stop : 37183689,
      direction : "-",
      ID : "ENSG00000093167.18",
      gene_id : "ENSG00000093167.18",
      gene_type : "protein_coding",
      gene_name : "LRRFIP2",
      gene_level : 1,
      hgnc_id : "HGNC:6703",
      havana_gene : "OTTHUMG00000130796.34",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 37243177,
      stop : 37366751,
      direction : "+",
      ID : "ENSG00000144674.16",
      gene_id : "ENSG00000144674.16",
      gene_type : "protein_coding",
      gene_name : "GOLGA4",
      gene_level : 2,
      hgnc_id : "HGNC:4427",
      havana_gene : "OTTHUMG00000130799.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 37452115,
      stop : 37823507,
      direction : "+",
      ID : "ENSG00000144668.12",
      gene_id : "ENSG00000144668.12",
      gene_type : "protein_coding",
      gene_name : "ITGA9",
      gene_level : 2,
      hgnc_id : "HGNC:6145",
      havana_gene : "OTTHUMG00000130815.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 37861880,
      stop : 37984469,
      direction : "+",
      ID : "ENSG00000144677.15",
      gene_id : "ENSG00000144677.15",
      gene_type : "protein_coding",
      gene_name : "CTDSPL",
      gene_level : 1,
      hgnc_id : "HGNC:16890",
      havana_gene : "OTTHUMG00000155942.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 37988059,
      stop : 38007188,
      direction : "+",
      ID : "ENSG00000136059.14",
      gene_id : "ENSG00000136059.14",
      gene_type : "protein_coding",
      gene_name : "VILL",
      gene_level : 2,
      hgnc_id : "HGNC:30906",
      havana_gene : "OTTHUMG00000130814.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38007496,
      stop : 38029642,
      direction : "-",
      ID : "ENSG00000187091.14",
      gene_id : "ENSG00000187091.14",
      gene_type : "protein_coding",
      gene_name : "PLCD1",
      gene_level : 1,
      hgnc_id : "HGNC:9060",
      havana_gene : "OTTHUMG00000130813.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38039205,
      stop : 38124025,
      direction : "+",
      ID : "ENSG00000008226.20",
      gene_id : "ENSG00000008226.20",
      gene_type : "protein_coding",
      gene_name : "DLEC1",
      gene_level : 2,
      hgnc_id : "HGNC:2899",
      havana_gene : "OTTHUMG00000131085.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38103129,
      stop : 38137242,
      direction : "-",
      ID : "ENSG00000060971.19",
      gene_id : "ENSG00000060971.19",
      gene_type : "protein_coding",
      gene_name : "ACAA1",
      gene_level : 2,
      hgnc_id : "HGNC:82",
      havana_gene : "OTTHUMG00000131087.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38138478,
      stop : 38143022,
      direction : "+",
      ID : "ENSG00000172936.16",
      gene_id : "ENSG00000172936.16",
      gene_type : "protein_coding",
      gene_name : "MYD88",
      gene_level : 1,
      hgnc_id : "HGNC:7562",
      havana_gene : "OTTHUMG00000131083.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38165089,
      stop : 38255484,
      direction : "+",
      ID : "ENSG00000172939.9",
      gene_id : "ENSG00000172939.9",
      gene_type : "protein_coding",
      gene_name : "OXSR1",
      gene_level : 1,
      hgnc_id : "HGNC:8508",
      havana_gene : "OTTHUMG00000131084.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38265812,
      stop : 38278757,
      direction : "+",
      ID : "ENSG00000172940.13",
      gene_id : "ENSG00000172940.13",
      gene_type : "protein_coding",
      gene_name : "SLC22A13",
      gene_level : 2,
      hgnc_id : "HGNC:8494",
      havana_gene : "OTTHUMG00000131086.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38282294,
      stop : 38318575,
      direction : "+",
      ID : "ENSG00000144671.10",
      gene_id : "ENSG00000144671.10",
      gene_type : "protein_coding",
      gene_name : "SLC22A14",
      gene_level : 1,
      hgnc_id : "HGNC:8495",
      havana_gene : "OTTHUMG00000131082.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38346760,
      stop : 38421348,
      direction : "+",
      ID : "ENSG00000093217.11",
      gene_id : "ENSG00000093217.11",
      gene_type : "protein_coding",
      gene_name : "XYLB",
      gene_level : 1,
      hgnc_id : "HGNC:12839",
      havana_gene : "OTTHUMG00000131294.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38453890,
      stop : 38493142,
      direction : "+",
      ID : "ENSG00000114739.14",
      gene_id : "ENSG00000114739.14",
      gene_type : "protein_coding",
      gene_name : "ACVR2B",
      gene_level : 2,
      hgnc_id : "HGNC:174",
      havana_gene : "OTTHUMG00000131291.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38496127,
      stop : 38542161,
      direction : "+",
      ID : "ENSG00000157036.13",
      gene_id : "ENSG00000157036.13",
      gene_type : "protein_coding",
      gene_name : "EXOG",
      gene_level : 1,
      hgnc_id : "HGNC:3347",
      havana_gene : "OTTHUMG00000131295.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38548057,
      stop : 38649687,
      direction : "-",
      ID : "ENSG00000183873.18",
      gene_id : "ENSG00000183873.18",
      gene_type : "protein_coding",
      gene_name : "SCN5A",
      gene_level : 1,
      hgnc_id : "HGNC:10593",
      havana_gene : "OTTHUMG00000156166.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38696802,
      stop : 38816286,
      direction : "-",
      ID : "ENSG00000185313.9",
      gene_id : "ENSG00000185313.9",
      gene_type : "protein_coding",
      gene_name : "SCN10A",
      gene_level : 2,
      hgnc_id : "HGNC:10582",
      havana_gene : "OTTHUMG00000048245.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 38845764,
      stop : 39052157,
      direction : "-",
      ID : "ENSG00000168356.13",
      gene_id : "ENSG00000168356.13",
      gene_type : "protein_coding",
      gene_name : "SCN11A",
      gene_level : 2,
      hgnc_id : "HGNC:10583",
      havana_gene : "OTTHUMG00000048246.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39052013,
      stop : 39096671,
      direction : "+",
      ID : "ENSG00000114742.14",
      gene_id : "ENSG00000114742.14",
      gene_type : "protein_coding",
      gene_name : "WDR48",
      gene_level : 1,
      hgnc_id : "HGNC:30914",
      havana_gene : "OTTHUMG00000155972.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39096599,
      stop : 39107863,
      direction : "-",
      ID : "ENSG00000114745.14",
      gene_id : "ENSG00000114745.14",
      gene_type : "protein_coding",
      gene_name : "GORASP1",
      gene_level : 1,
      hgnc_id : "HGNC:16769",
      havana_gene : "OTTHUMG00000131292.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39107704,
      stop : 39138903,
      direction : "+",
      ID : "ENSG00000168026.18",
      gene_id : "ENSG00000168026.18",
      gene_type : "protein_coding",
      gene_name : "TTC21A",
      gene_level : 2,
      hgnc_id : "HGNC:30761",
      havana_gene : "OTTHUMG00000155973.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39141855,
      stop : 39154562,
      direction : "-",
      ID : "ENSG00000144655.15",
      gene_id : "ENSG00000144655.15",
      gene_type : "protein_coding",
      gene_name : "CSRNP1",
      gene_level : 2,
      hgnc_id : "HGNC:14300",
      havana_gene : "OTTHUMG00000131293.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39183210,
      stop : 39192596,
      direction : "-",
      ID : "ENSG00000168334.9",
      gene_id : "ENSG00000168334.9",
      gene_type : "protein_coding",
      gene_name : "XIRP1",
      gene_level : 2,
      hgnc_id : "HGNC:14301",
      havana_gene : "OTTHUMG00000131297.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39263495,
      stop : 39281735,
      direction : "-",
      ID : "ENSG00000168329.14",
      gene_id : "ENSG00000168329.14",
      gene_type : "protein_coding",
      gene_name : "CX3CR1",
      gene_level : 2,
      hgnc_id : "HGNC:2558",
      havana_gene : "OTTHUMG00000156249.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39329709,
      stop : 39333680,
      direction : "+",
      ID : "ENSG00000179934.7",
      gene_id : "ENSG00000179934.7",
      gene_type : "protein_coding",
      gene_name : "CCR8",
      gene_level : 2,
      hgnc_id : "HGNC:1609",
      havana_gene : "OTTHUMG00000131290.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39383370,
      stop : 39397351,
      direction : "+",
      ID : "ENSG00000144659.13",
      gene_id : "ENSG00000144659.13",
      gene_type : "protein_coding",
      gene_name : "SLC25A38",
      gene_level : 2,
      hgnc_id : "HGNC:26054",
      havana_gene : "OTTHUMG00000131289.12",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39406716,
      stop : 39412542,
      direction : "+",
      ID : "ENSG00000168028.14",
      gene_id : "ENSG00000168028.14",
      gene_type : "protein_coding",
      gene_name : "RPSA",
      gene_level : 2,
      hgnc_id : "HGNC:6502",
      havana_gene : "OTTHUMG00000131296.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39467198,
      stop : 39529479,
      direction : "+",
      ID : "ENSG00000168314.17",
      gene_id : "ENSG00000168314.17",
      gene_type : "protein_coding",
      gene_name : "MOBP",
      gene_level : 1,
      hgnc_id : "HGNC:7189",
      havana_gene : "OTTHUMG00000131347.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 39808914,
      stop : 40260321,
      direction : "+",
      ID : "ENSG00000170011.14",
      gene_id : "ENSG00000170011.14",
      gene_type : "protein_coding",
      gene_name : "MYRIP",
      gene_level : 2,
      hgnc_id : "HGNC:19156",
      havana_gene : "OTTHUMG00000131392.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 40309707,
      stop : 40312424,
      direction : "+",
      ID : "ENSG00000114784.4",
      gene_id : "ENSG00000114784.4",
      gene_type : "protein_coding",
      gene_name : "EIF1B",
      gene_level : 2,
      hgnc_id : "HGNC:30792",
      havana_gene : "OTTHUMG00000131388.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 40387184,
      stop : 40428744,
      direction : "+",
      ID : "ENSG00000168032.10",
      gene_id : "ENSG00000168032.10",
      gene_type : "protein_coding",
      gene_name : "ENTPD3",
      gene_level : 1,
      hgnc_id : "HGNC:3365",
      havana_gene : "OTTHUMG00000131390.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 40457292,
      stop : 40468587,
      direction : "+",
      ID : "ENSG00000188846.14",
      gene_id : "ENSG00000188846.14",
      gene_type : "protein_coding",
      gene_name : "RPL14",
      gene_level : 2,
      hgnc_id : "HGNC:10305",
      havana_gene : "OTTHUMG00000156046.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 40477113,
      stop : 40491053,
      direction : "+",
      ID : "ENSG00000177873.14",
      gene_id : "ENSG00000177873.14",
      gene_type : "protein_coding",
      gene_name : "ZNF619",
      gene_level : 2,
      hgnc_id : "HGNC:26910",
      havana_gene : "OTTHUMG00000131391.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 40477131,
      stop : 40518736,
      direction : "+",
      ID : "ENSG00000177842.12",
      gene_id : "ENSG00000177842.12",
      gene_type : "protein_coding",
      gene_name : "ZNF620",
      gene_level : 1,
      hgnc_id : "HGNC:28742",
      havana_gene : "OTTHUMG00000156044.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 40524878,
      stop : 40574685,
      direction : "+",
      ID : "ENSG00000172888.12",
      gene_id : "ENSG00000172888.12",
      gene_type : "protein_coding",
      gene_name : "ZNF621",
      gene_level : 2,
      hgnc_id : "HGNC:24787",
      havana_gene : "OTTHUMG00000131389.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 41194741,
      stop : 41260096,
      direction : "+",
      ID : "ENSG00000168036.18",
      gene_id : "ENSG00000168036.18",
      gene_type : "protein_coding",
      gene_name : "CTNNB1",
      gene_level : 1,
      hgnc_id : "HGNC:2514",
      havana_gene : "OTTHUMG00000131393.16",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 41246599,
      stop : 41962130,
      direction : "-",
      ID : "ENSG00000168038.11",
      gene_id : "ENSG00000168038.11",
      gene_type : "protein_coding",
      gene_name : "ULK4",
      gene_level : 1,
      hgnc_id : "HGNC:15784",
      havana_gene : "OTTHUMG00000156210.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42013802,
      stop : 42225890,
      direction : "+",
      ID : "ENSG00000182606.17",
      gene_id : "ENSG00000182606.17",
      gene_type : "protein_coding",
      gene_name : "TRAK1",
      gene_level : 1,
      hgnc_id : "HGNC:29947",
      havana_gene : "OTTHUMG00000131795.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42257825,
      stop : 42266185,
      direction : "-",
      ID : "ENSG00000187094.12",
      gene_id : "ENSG00000187094.12",
      gene_type : "protein_coding",
      gene_name : "CCK",
      gene_level : 2,
      hgnc_id : "HGNC:1569",
      havana_gene : "OTTHUMG00000131796.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42397083,
      stop : 42410610,
      direction : "-",
      ID : "ENSG00000157093.9",
      gene_id : "ENSG00000157093.9",
      gene_type : "protein_coding",
      gene_name : "LYZL4",
      gene_level : 2,
      hgnc_id : "HGNC:28387",
      havana_gene : "OTTHUMG00000131793.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42489299,
      stop : 42537573,
      direction : "+",
      ID : "ENSG00000114812.13",
      gene_id : "ENSG00000114812.13",
      gene_type : "protein_coding",
      gene_name : "VIPR1",
      gene_level : 1,
      hgnc_id : "HGNC:12694",
      havana_gene : "OTTHUMG00000131792.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42547969,
      stop : 42601080,
      direction : "-",
      ID : "ENSG00000093183.14",
      gene_id : "ENSG00000093183.14",
      gene_type : "protein_coding",
      gene_name : "SEC22C",
      gene_level : 1,
      hgnc_id : "HGNC:16828",
      havana_gene : "OTTHUMG00000131797.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42581840,
      stop : 42596934,
      direction : "+",
      ID : "ENSG00000008324.12",
      gene_id : "ENSG00000008324.12",
      gene_type : "protein_coding",
      gene_name : "SS18L2",
      gene_level : 2,
      hgnc_id : "HGNC:15593",
      havana_gene : "OTTHUMG00000131794.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42600655,
      stop : 42648735,
      direction : "+",
      ID : "ENSG00000114857.18",
      gene_id : "ENSG00000114857.18",
      gene_type : "protein_coding",
      gene_name : "NKTR",
      gene_level : 2,
      hgnc_id : "HGNC:7833",
      havana_gene : "OTTHUMG00000133037.22",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42653697,
      stop : 42667580,
      direction : "+",
      ID : "ENSG00000114853.15",
      gene_id : "ENSG00000114853.15",
      gene_type : "protein_coding",
      gene_name : "ZBTB47",
      gene_level : 2,
      hgnc_id : "HGNC:26955",
      havana_gene : "OTTHUMG00000156207.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42685537,
      stop : 42692544,
      direction : "+",
      ID : "ENSG00000157119.12",
      gene_id : "ENSG00000157119.12",
      gene_type : "protein_coding",
      gene_name : "KLHL40",
      gene_level : 2,
      hgnc_id : "HGNC:30372",
      havana_gene : "OTTHUMG00000133045.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42692663,
      stop : 42702824,
      direction : "-",
      ID : "ENSG00000010282.15",
      gene_id : "ENSG00000010282.15",
      gene_type : "protein_coding",
      gene_name : "HHATL",
      gene_level : 1,
      hgnc_id : "HGNC:13242",
      havana_gene : "OTTHUMG00000133043.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42705756,
      stop : 42773253,
      direction : "-",
      ID : "ENSG00000244607.7",
      gene_id : "ENSG00000244607.7",
      gene_type : "protein_coding",
      gene_name : "CCDC13",
      gene_level : 2,
      hgnc_id : "HGNC:26358",
      havana_gene : "OTTHUMG00000193425.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42705756,
      stop : 42804518,
      direction : "-",
      ID : "ENSG00000280571.2",
      gene_id : "ENSG00000280571.2",
      gene_type : "protein_coding",
      gene_name : "AC006059.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000156277.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42782908,
      stop : 42804490,
      direction : "-",
      ID : "ENSG00000181061.14",
      gene_id : "ENSG00000181061.14",
      gene_type : "protein_coding",
      gene_name : "HIGD1A",
      gene_level : 2,
      hgnc_id : "HGNC:29527",
      havana_gene : "OTTHUMG00000190394.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42804752,
      stop : 42887974,
      direction : "+",
      ID : "ENSG00000144648.16",
      gene_id : "ENSG00000144648.16",
      gene_type : "protein_coding",
      gene_name : "ACKR2",
      gene_level : 2,
      hgnc_id : "HGNC:1565",
      havana_gene : "OTTHUMG00000186377.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42809446,
      stop : 43055871,
      direction : "+",
      ID : "ENSG00000273291.5",
      gene_id : "ENSG00000273291.5",
      gene_type : "protein_coding",
      gene_name : "AC092042.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000156448.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42809483,
      stop : 42942792,
      direction : "+",
      ID : "ENSG00000240747.8",
      gene_id : "ENSG00000240747.8",
      gene_type : "protein_coding",
      gene_name : "KRBOX1",
      gene_level : 2,
      hgnc_id : "HGNC:38708",
      havana_gene : "OTTHUMG00000186062.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42856005,
      stop : 42875898,
      direction : "-",
      ID : "ENSG00000180432.6",
      gene_id : "ENSG00000180432.6",
      gene_type : "protein_coding",
      gene_name : "CYP8B1",
      gene_level : 1,
      hgnc_id : "HGNC:2653",
      havana_gene : "OTTHUMG00000133047.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42906142,
      stop : 42919334,
      direction : "+",
      ID : "ENSG00000182983.15",
      gene_id : "ENSG00000182983.15",
      gene_type : "protein_coding",
      gene_name : "ZNF662",
      gene_level : 2,
      hgnc_id : "HGNC:31930",
      havana_gene : "OTTHUMG00000133041.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 42979267,
      stop : 43060211,
      direction : "+",
      ID : "ENSG00000144649.9",
      gene_id : "ENSG00000144649.9",
      gene_type : "protein_coding",
      gene_name : "GASK1A",
      gene_level : 2,
      hgnc_id : "HGNC:24485",
      havana_gene : "OTTHUMG00000156449.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 43079232,
      stop : 43106079,
      direction : "-",
      ID : "ENSG00000144647.6",
      gene_id : "ENSG00000144647.6",
      gene_type : "protein_coding",
      gene_name : "POMGNT2",
      gene_level : 2,
      hgnc_id : "HGNC:25902",
      havana_gene : "OTTHUMG00000133038.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 43286512,
      stop : 43424764,
      direction : "+",
      ID : "ENSG00000163788.14",
      gene_id : "ENSG00000163788.14",
      gene_type : "protein_coding",
      gene_name : "SNRK",
      gene_level : 1,
      hgnc_id : "HGNC:30598",
      havana_gene : "OTTHUMG00000156491.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 43354859,
      stop : 43691594,
      direction : "-",
      ID : "ENSG00000160746.13",
      gene_id : "ENSG00000160746.13",
      gene_type : "protein_coding",
      gene_name : "ANO10",
      gene_level : 1,
      hgnc_id : "HGNC:25519",
      havana_gene : "OTTHUMG00000133044.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 43690108,
      stop : 43734371,
      direction : "+",
      ID : "ENSG00000011198.10",
      gene_id : "ENSG00000011198.10",
      gene_type : "protein_coding",
      gene_name : "ABHD5",
      gene_level : 1,
      hgnc_id : "HGNC:21396",
      havana_gene : "OTTHUMG00000133039.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44241886,
      stop : 44332098,
      direction : "+",
      ID : "ENSG00000173769.4",
      gene_id : "ENSG00000173769.4",
      gene_type : "protein_coding",
      gene_name : "TOPAZ1",
      gene_level : 2,
      hgnc_id : "HGNC:24746",
      havana_gene : "OTTHUMG00000156172.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44338119,
      stop : 44409451,
      direction : "+",
      ID : "ENSG00000179152.20",
      gene_id : "ENSG00000179152.20",
      gene_type : "protein_coding",
      gene_name : "TCAIM",
      gene_level : 2,
      hgnc_id : "HGNC:25241",
      havana_gene : "OTTHUMG00000133049.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44431705,
      stop : 44477670,
      direction : "-",
      ID : "ENSG00000185219.17",
      gene_id : "ENSG00000185219.17",
      gene_type : "protein_coding",
      gene_name : "ZNF445",
      gene_level : 2,
      hgnc_id : "HGNC:21018",
      havana_gene : "OTTHUMG00000133042.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44494847,
      stop : 44510636,
      direction : "-",
      ID : "ENSG00000178917.17",
      gene_id : "ENSG00000178917.17",
      gene_type : "protein_coding",
      gene_name : "ZNF852",
      gene_level : 2,
      hgnc_id : "HGNC:27713",
      havana_gene : "OTTHUMG00000156453.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44555193,
      stop : 44594173,
      direction : "+",
      ID : "ENSG00000196345.13",
      gene_id : "ENSG00000196345.13",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN7",
      gene_level : 1,
      hgnc_id : "HGNC:12955",
      havana_gene : "OTTHUMG00000186378.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44578223,
      stop : 44599694,
      direction : "+",
      ID : "ENSG00000144792.9",
      gene_id : "ENSG00000144792.9",
      gene_type : "protein_coding",
      gene_name : "ZNF660",
      gene_level : 2,
      hgnc_id : "HGNC:26720",
      havana_gene : "OTTHUMG00000133097.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44584888,
      stop : 44648471,
      direction : "+",
      ID : "ENSG00000186448.15",
      gene_id : "ENSG00000186448.15",
      gene_type : "protein_coding",
      gene_name : "ZNF197",
      gene_level : 2,
      hgnc_id : "HGNC:12988",
      havana_gene : "OTTHUMG00000133089.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44648732,
      stop : 44660791,
      direction : "+",
      ID : "ENSG00000169981.11",
      gene_id : "ENSG00000169981.11",
      gene_type : "protein_coding",
      gene_name : "ZNF35",
      gene_level : 1,
      hgnc_id : "HGNC:13099",
      havana_gene : "OTTHUMG00000133091.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44712643,
      stop : 44723831,
      direction : "+",
      ID : "ENSG00000196653.12",
      gene_id : "ENSG00000196653.12",
      gene_type : "protein_coding",
      gene_name : "ZNF502",
      gene_level : 2,
      hgnc_id : "HGNC:23718",
      havana_gene : "OTTHUMG00000133086.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44729596,
      stop : 44737083,
      direction : "+",
      ID : "ENSG00000186446.12",
      gene_id : "ENSG00000186446.12",
      gene_type : "protein_coding",
      gene_name : "ZNF501",
      gene_level : 2,
      hgnc_id : "HGNC:23717",
      havana_gene : "OTTHUMG00000133048.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44737661,
      stop : 44761619,
      direction : "-",
      ID : "ENSG00000163807.6",
      gene_id : "ENSG00000163807.6",
      gene_type : "protein_coding",
      gene_name : "KIAA1143",
      gene_level : 2,
      hgnc_id : "HGNC:29198",
      havana_gene : "OTTHUMG00000133088.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44761721,
      stop : 44873376,
      direction : "+",
      ID : "ENSG00000163808.17",
      gene_id : "ENSG00000163808.17",
      gene_type : "protein_coding",
      gene_name : "KIF15",
      gene_level : 2,
      hgnc_id : "HGNC:17273",
      havana_gene : "OTTHUMG00000156307.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44861904,
      stop : 44865670,
      direction : "+",
      ID : "ENSG00000169964.8",
      gene_id : "ENSG00000169964.8",
      gene_type : "protein_coding",
      gene_name : "TMEM42",
      gene_level : 2,
      hgnc_id : "HGNC:28444",
      havana_gene : "OTTHUMG00000133092.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44874608,
      stop : 44914990,
      direction : "+",
      ID : "ENSG00000163810.12",
      gene_id : "ENSG00000163810.12",
      gene_type : "protein_coding",
      gene_name : "TGM4",
      gene_level : 2,
      hgnc_id : "HGNC:11780",
      havana_gene : "OTTHUMG00000133096.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44915257,
      stop : 44976185,
      direction : "-",
      ID : "ENSG00000163812.15",
      gene_id : "ENSG00000163812.15",
      gene_type : "protein_coding",
      gene_name : "ZDHHC3",
      gene_level : 1,
      hgnc_id : "HGNC:18470",
      havana_gene : "OTTHUMG00000133093.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 44975241,
      stop : 45036066,
      direction : "+",
      ID : "ENSG00000075914.13",
      gene_id : "ENSG00000075914.13",
      gene_type : "protein_coding",
      gene_name : "EXOSC7",
      gene_level : 1,
      hgnc_id : "HGNC:28112",
      havana_gene : "OTTHUMG00000133095.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45001548,
      stop : 45036071,
      direction : "+",
      ID : "ENSG00000163815.6",
      gene_id : "ENSG00000163815.6",
      gene_type : "protein_coding",
      gene_name : "CLEC3B",
      gene_level : 2,
      hgnc_id : "HGNC:11891",
      havana_gene : "OTTHUMG00000133087.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45082277,
      stop : 45146422,
      direction : "-",
      ID : "ENSG00000163814.8",
      gene_id : "ENSG00000163814.8",
      gene_type : "protein_coding",
      gene_name : "CDCP1",
      gene_level : 2,
      hgnc_id : "HGNC:24357",
      havana_gene : "OTTHUMG00000133090.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45224466,
      stop : 45226287,
      direction : "-",
      ID : "ENSG00000249992.2",
      gene_id : "ENSG00000249992.2",
      gene_type : "protein_coding",
      gene_name : "TMEM158",
      gene_level : 2,
      hgnc_id : "HGNC:30293",
      havana_gene : "OTTHUMG00000160317.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45388561,
      stop : 45554726,
      direction : "+",
      ID : "ENSG00000011376.12",
      gene_id : "ENSG00000011376.12",
      gene_type : "protein_coding",
      gene_name : "LARS2",
      gene_level : 2,
      hgnc_id : "HGNC:17095",
      havana_gene : "OTTHUMG00000133177.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45555394,
      stop : 45686341,
      direction : "+",
      ID : "ENSG00000144791.10",
      gene_id : "ENSG00000144791.10",
      gene_type : "protein_coding",
      gene_name : "LIMD1",
      gene_level : 1,
      hgnc_id : "HGNC:6612",
      havana_gene : "OTTHUMG00000133453.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45689056,
      stop : 45745409,
      direction : "+",
      ID : "ENSG00000211456.13",
      gene_id : "ENSG00000211456.13",
      gene_type : "protein_coding",
      gene_name : "SACM1L",
      gene_level : 2,
      hgnc_id : "HGNC:17059",
      havana_gene : "OTTHUMG00000156653.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45755449,
      stop : 45796536,
      direction : "-",
      ID : "ENSG00000163817.16",
      gene_id : "ENSG00000163817.16",
      gene_type : "protein_coding",
      gene_name : "SLC6A20",
      gene_level : 1,
      hgnc_id : "HGNC:30927",
      havana_gene : "OTTHUMG00000133446.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45823316,
      stop : 45916042,
      direction : "-",
      ID : "ENSG00000163818.18",
      gene_id : "ENSG00000163818.18",
      gene_type : "protein_coding",
      gene_name : "LZTFL1",
      gene_level : 1,
      hgnc_id : "HGNC:6741",
      havana_gene : "OTTHUMG00000133452.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45886504,
      stop : 45903175,
      direction : "+",
      ID : "ENSG00000173585.16",
      gene_id : "ENSG00000173585.16",
      gene_type : "protein_coding",
      gene_name : "CCR9",
      gene_level : 1,
      hgnc_id : "HGNC:1610",
      havana_gene : "OTTHUMG00000133450.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45917899,
      stop : 45995824,
      direction : "-",
      ID : "ENSG00000163820.15",
      gene_id : "ENSG00000163820.15",
      gene_type : "protein_coding",
      gene_name : "FYCO1",
      gene_level : 2,
      hgnc_id : "HGNC:14673",
      havana_gene : "OTTHUMG00000133447.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 45940933,
      stop : 45948351,
      direction : "+",
      ID : "ENSG00000172215.6",
      gene_id : "ENSG00000172215.6",
      gene_type : "protein_coding",
      gene_name : "CXCR6",
      gene_level : 2,
      hgnc_id : "HGNC:16647",
      havana_gene : "OTTHUMG00000133448.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46017007,
      stop : 46027487,
      direction : "-",
      ID : "ENSG00000173578.8",
      gene_id : "ENSG00000173578.8",
      gene_type : "protein_coding",
      gene_name : "XCR1",
      gene_level : 2,
      hgnc_id : "HGNC:1625",
      havana_gene : "OTTHUMG00000133449.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46163604,
      stop : 46266706,
      direction : "+",
      ID : "ENSG00000183625.15",
      gene_id : "ENSG00000183625.15",
      gene_type : "protein_coding",
      gene_name : "CCR3",
      gene_level : 2,
      hgnc_id : "HGNC:1604",
      havana_gene : "OTTHUMG00000133484.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46201711,
      stop : 46208313,
      direction : "-",
      ID : "ENSG00000163823.4",
      gene_id : "ENSG00000163823.4",
      gene_type : "protein_coding",
      gene_name : "CCR1",
      gene_level : 2,
      hgnc_id : "HGNC:1602",
      havana_gene : "OTTHUMG00000133451.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46353744,
      stop : 46360940,
      direction : "+",
      ID : "ENSG00000121807.6",
      gene_id : "ENSG00000121807.6",
      gene_type : "protein_coding",
      gene_name : "CCR2",
      gene_level : 2,
      hgnc_id : "HGNC:1603",
      havana_gene : "OTTHUMG00000156466.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46370854,
      stop : 46376206,
      direction : "+",
      ID : "ENSG00000160791.13",
      gene_id : "ENSG00000160791.13",
      gene_type : "protein_coding",
      gene_name : "CCR5",
      gene_level : 1,
      hgnc_id : "HGNC:1606",
      havana_gene : "OTTHUMG00000133481.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46407166,
      stop : 46412997,
      direction : "+",
      ID : "ENSG00000121797.10",
      gene_id : "ENSG00000121797.10",
      gene_type : "protein_coding",
      gene_name : "CCRL2",
      gene_level : 2,
      hgnc_id : "HGNC:1612",
      havana_gene : "OTTHUMG00000156318.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46435645,
      stop : 46485234,
      direction : "-",
      ID : "ENSG00000012223.13",
      gene_id : "ENSG00000012223.13",
      gene_type : "protein_coding",
      gene_name : "LTF",
      gene_level : 1,
      hgnc_id : "HGNC:6720",
      havana_gene : "OTTHUMG00000156325.18",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46497976,
      stop : 46500950,
      direction : "+",
      ID : "ENSG00000163825.4",
      gene_id : "ENSG00000163825.4",
      gene_type : "protein_coding",
      gene_name : "RTP3",
      gene_level : 2,
      hgnc_id : "HGNC:15572",
      havana_gene : "OTTHUMG00000133483.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46515385,
      stop : 46580099,
      direction : "-",
      ID : "ENSG00000163827.13",
      gene_id : "ENSG00000163827.13",
      gene_type : "protein_coding",
      gene_name : "LRRC2",
      gene_level : 1,
      hgnc_id : "HGNC:14676",
      havana_gene : "OTTHUMG00000133479.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46574534,
      stop : 46582457,
      direction : "+",
      ID : "ENSG00000241186.10",
      gene_id : "ENSG00000241186.10",
      gene_type : "protein_coding",
      gene_name : "TDGF1",
      gene_level : 2,
      hgnc_id : "HGNC:11701",
      havana_gene : "OTTHUMG00000191980.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46581150,
      stop : 46617226,
      direction : "+",
      ID : "ENSG00000283877.1",
      gene_id : "ENSG00000283877.1",
      gene_type : "protein_coding",
      gene_name : "AC104304.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191662.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46612435,
      stop : 46626543,
      direction : "+",
      ID : "ENSG00000283473.4",
      gene_id : "ENSG00000283473.4",
      gene_type : "protein_coding",
      gene_name : "FAM240A",
      gene_level : 2,
      hgnc_id : "HGNC:52390",
      havana_gene : "OTTHUMG00000133482.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46668995,
      stop : 46693704,
      direction : "-",
      ID : "ENSG00000178038.17",
      gene_id : "ENSG00000178038.17",
      gene_type : "protein_coding",
      gene_name : "ALS2CL",
      gene_level : 2,
      hgnc_id : "HGNC:20605",
      havana_gene : "OTTHUMG00000128673.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46694528,
      stop : 46710886,
      direction : "+",
      ID : "ENSG00000181585.7",
      gene_id : "ENSG00000181585.7",
      gene_type : "protein_coding",
      gene_name : "TMIE",
      gene_level : 2,
      hgnc_id : "HGNC:30800",
      havana_gene : "OTTHUMG00000149909.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46712115,
      stop : 46812574,
      direction : "-",
      ID : "ENSG00000206549.13",
      gene_id : "ENSG00000206549.13",
      gene_type : "protein_coding",
      gene_name : "AC109583.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192149.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46712117,
      stop : 46717869,
      direction : "-",
      ID : "ENSG00000283706.2",
      gene_id : "ENSG00000283706.2",
      gene_type : "protein_coding",
      gene_name : "PRSS50",
      gene_level : 2,
      hgnc_id : "HGNC:17910",
      havana_gene : "OTTHUMG00000164067.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46742092,
      stop : 46750891,
      direction : "-",
      ID : "ENSG00000188086.15",
      gene_id : "ENSG00000188086.15",
      gene_type : "protein_coding",
      gene_name : "PRSS45P",
      gene_level : 2,
      hgnc_id : "HGNC:30717",
      havana_gene : "OTTHUMG00000192150.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46835111,
      stop : 46882172,
      direction : "-",
      ID : "ENSG00000160808.11",
      gene_id : "ENSG00000160808.11",
      gene_type : "protein_coding",
      gene_name : "MYL3",
      gene_level : 2,
      hgnc_id : "HGNC:7584",
      havana_gene : "OTTHUMG00000133516.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46877721,
      stop : 46903799,
      direction : "+",
      ID : "ENSG00000160801.14",
      gene_id : "ENSG00000160801.14",
      gene_type : "protein_coding",
      gene_name : "PTH1R",
      gene_level : 2,
      hgnc_id : "HGNC:9608",
      havana_gene : "OTTHUMG00000133515.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46921726,
      stop : 46982010,
      direction : "-",
      ID : "ENSG00000160799.11",
      gene_id : "ENSG00000160799.11",
      gene_type : "protein_coding",
      gene_name : "CCDC12",
      gene_level : 2,
      hgnc_id : "HGNC:28332",
      havana_gene : "OTTHUMG00000133513.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 46979666,
      stop : 47009704,
      direction : "+",
      ID : "ENSG00000160796.18",
      gene_id : "ENSG00000160796.18",
      gene_type : "protein_coding",
      gene_name : "NBEAL2",
      gene_level : 1,
      hgnc_id : "HGNC:31928",
      havana_gene : "OTTHUMG00000156497.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47016429,
      stop : 47164113,
      direction : "-",
      ID : "ENSG00000181555.21",
      gene_id : "ENSG00000181555.21",
      gene_type : "protein_coding",
      gene_name : "SETD2",
      gene_level : 2,
      hgnc_id : "HGNC:18420",
      havana_gene : "OTTHUMG00000133514.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47228395,
      stop : 47283451,
      direction : "-",
      ID : "ENSG00000088727.13",
      gene_id : "ENSG00000088727.13",
      gene_type : "protein_coding",
      gene_name : "KIF9",
      gene_level : 1,
      hgnc_id : "HGNC:16666",
      havana_gene : "OTTHUMG00000133512.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47282917,
      stop : 47346816,
      direction : "+",
      ID : "ENSG00000114648.12",
      gene_id : "ENSG00000114648.12",
      gene_type : "protein_coding",
      gene_name : "KLHL18",
      gene_level : 2,
      hgnc_id : "HGNC:29120",
      havana_gene : "OTTHUMG00000156522.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47381011,
      stop : 47413435,
      direction : "+",
      ID : "ENSG00000076201.15",
      gene_id : "ENSG00000076201.15",
      gene_type : "protein_coding",
      gene_name : "PTPN23",
      gene_level : 2,
      hgnc_id : "HGNC:14406",
      havana_gene : "OTTHUMG00000133520.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47413681,
      stop : 47477126,
      direction : "-",
      ID : "ENSG00000114650.20",
      gene_id : "ENSG00000114650.20",
      gene_type : "protein_coding",
      gene_name : "SCAP",
      gene_level : 2,
      hgnc_id : "HGNC:30634",
      havana_gene : "OTTHUMG00000125539.16",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47495640,
      stop : 47513712,
      direction : "-",
      ID : "ENSG00000163832.16",
      gene_id : "ENSG00000163832.16",
      gene_type : "protein_coding",
      gene_name : "ELP6",
      gene_level : 1,
      hgnc_id : "HGNC:25976",
      havana_gene : "OTTHUMG00000133521.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47562238,
      stop : 47580792,
      direction : "-",
      ID : "ENSG00000114646.10",
      gene_id : "ENSG00000114646.10",
      gene_type : "protein_coding",
      gene_name : "CSPG5",
      gene_level : 2,
      hgnc_id : "HGNC:2467",
      havana_gene : "OTTHUMG00000133518.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47585269,
      stop : 47782106,
      direction : "-",
      ID : "ENSG00000173473.11",
      gene_id : "ENSG00000173473.11",
      gene_type : "protein_coding",
      gene_name : "SMARCC1",
      gene_level : 2,
      hgnc_id : "HGNC:11104",
      havana_gene : "OTTHUMG00000133519.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47802909,
      stop : 47850195,
      direction : "+",
      ID : "ENSG00000132153.15",
      gene_id : "ENSG00000132153.15",
      gene_type : "protein_coding",
      gene_name : "DHX30",
      gene_level : 1,
      hgnc_id : "HGNC:16716",
      havana_gene : "OTTHUMG00000133522.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 47850690,
      stop : 48089272,
      direction : "-",
      ID : "ENSG00000047849.21",
      gene_id : "ENSG00000047849.21",
      gene_type : "protein_coding",
      gene_name : "MAP4",
      gene_level : 1,
      hgnc_id : "HGNC:6862",
      havana_gene : "OTTHUMG00000156828.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48157146,
      stop : 48188417,
      direction : "-",
      ID : "ENSG00000164045.12",
      gene_id : "ENSG00000164045.12",
      gene_type : "protein_coding",
      gene_name : "CDC25A",
      gene_level : 2,
      hgnc_id : "HGNC:1725",
      havana_gene : "OTTHUMG00000133535.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48223347,
      stop : 48225491,
      direction : "+",
      ID : "ENSG00000164047.6",
      gene_id : "ENSG00000164047.6",
      gene_type : "protein_coding",
      gene_name : "CAMP",
      gene_level : 2,
      hgnc_id : "HGNC:1472",
      havana_gene : "OTTHUMG00000133526.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48241100,
      stop : 48299253,
      direction : "+",
      ID : "ENSG00000164048.14",
      gene_id : "ENSG00000164048.14",
      gene_type : "protein_coding",
      gene_name : "ZNF589",
      gene_level : 1,
      hgnc_id : "HGNC:16747",
      havana_gene : "OTTHUMG00000156833.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48290722,
      stop : 48301685,
      direction : "-",
      ID : "ENSG00000172113.10",
      gene_id : "ENSG00000172113.10",
      gene_type : "protein_coding",
      gene_name : "NME6",
      gene_level : 1,
      hgnc_id : "HGNC:20567",
      havana_gene : "OTTHUMG00000133531.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48306842,
      stop : 48328341,
      direction : "-",
      ID : "ENSG00000229453.2",
      gene_id : "ENSG00000229453.2",
      gene_type : "protein_coding",
      gene_name : "SPINK8",
      gene_level : 2,
      hgnc_id : "HGNC:33160",
      havana_gene : "OTTHUMG00000156832.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48372219,
      stop : 48401259,
      direction : "+",
      ID : "ENSG00000164049.14",
      gene_id : "ENSG00000164049.14",
      gene_type : "protein_coding",
      gene_name : "FBXW12",
      gene_level : 1,
      hgnc_id : "HGNC:20729",
      havana_gene : "OTTHUMG00000133530.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48403854,
      stop : 48430086,
      direction : "-",
      ID : "ENSG00000164050.13",
      gene_id : "ENSG00000164050.13",
      gene_type : "protein_coding",
      gene_name : "PLXNB1",
      gene_level : 2,
      hgnc_id : "HGNC:9103",
      havana_gene : "OTTHUMG00000133527.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48432164,
      stop : 48440456,
      direction : "-",
      ID : "ENSG00000164051.14",
      gene_id : "ENSG00000164051.14",
      gene_type : "protein_coding",
      gene_name : "CCDC51",
      gene_level : 2,
      hgnc_id : "HGNC:25714",
      havana_gene : "OTTHUMG00000133534.27",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48440257,
      stop : 48444208,
      direction : "+",
      ID : "ENSG00000232112.3",
      gene_id : "ENSG00000232112.3",
      gene_type : "protein_coding",
      gene_name : "TMA7",
      gene_level : 2,
      hgnc_id : "HGNC:26932",
      havana_gene : "OTTHUMG00000156588.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48446710,
      stop : 48467645,
      direction : "+",
      ID : "ENSG00000164053.21",
      gene_id : "ENSG00000164053.21",
      gene_type : "protein_coding",
      gene_name : "ATRIP",
      gene_level : 2,
      hgnc_id : "HGNC:33499",
      havana_gene : "OTTHUMG00000133532.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48465811,
      stop : 48467645,
      direction : "+",
      ID : "ENSG00000213689.14",
      gene_id : "ENSG00000213689.14",
      gene_type : "protein_coding",
      gene_name : "TREX1",
      gene_level : 2,
      hgnc_id : "HGNC:12269",
      havana_gene : "OTTHUMG00000156205.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48467798,
      stop : 48504826,
      direction : "-",
      ID : "ENSG00000164054.15",
      gene_id : "ENSG00000164054.15",
      gene_type : "protein_coding",
      gene_name : "SHISA5",
      gene_level : 1,
      hgnc_id : "HGNC:30376",
      havana_gene : "OTTHUMG00000133529.19",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48517684,
      stop : 48562015,
      direction : "-",
      ID : "ENSG00000114268.12",
      gene_id : "ENSG00000114268.12",
      gene_type : "protein_coding",
      gene_name : "PFKFB4",
      gene_level : 1,
      hgnc_id : "HGNC:8875",
      havana_gene : "OTTHUMG00000133528.20",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48561718,
      stop : 48563781,
      direction : "-",
      ID : "ENSG00000145040.4",
      gene_id : "ENSG00000145040.4",
      gene_type : "protein_coding",
      gene_name : "UCN2",
      gene_level : 2,
      hgnc_id : "HGNC:18414",
      havana_gene : "OTTHUMG00000133533.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48564073,
      stop : 48595329,
      direction : "-",
      ID : "ENSG00000114270.18",
      gene_id : "ENSG00000114270.18",
      gene_type : "protein_coding",
      gene_name : "COL7A1",
      gene_level : 2,
      hgnc_id : "HGNC:2214",
      havana_gene : "OTTHUMG00000133541.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48599002,
      stop : 48610976,
      direction : "-",
      ID : "ENSG00000010256.11",
      gene_id : "ENSG00000010256.11",
      gene_type : "protein_coding",
      gene_name : "UQCRC1",
      gene_level : 2,
      hgnc_id : "HGNC:12585",
      havana_gene : "OTTHUMG00000133539.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48620759,
      stop : 48621769,
      direction : "-",
      ID : "ENSG00000183396.4",
      gene_id : "ENSG00000183396.4",
      gene_type : "protein_coding",
      gene_name : "TMEM89",
      gene_level : 2,
      hgnc_id : "HGNC:32372",
      havana_gene : "OTTHUMG00000156647.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48625723,
      stop : 48635493,
      direction : "-",
      ID : "ENSG00000225697.13",
      gene_id : "ENSG00000225697.13",
      gene_type : "protein_coding",
      gene_name : "SLC26A6",
      gene_level : 1,
      hgnc_id : "HGNC:14472",
      havana_gene : "OTTHUMG00000186381.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48636463,
      stop : 48662886,
      direction : "-",
      ID : "ENSG00000008300.17",
      gene_id : "ENSG00000008300.17",
      gene_type : "protein_coding",
      gene_name : "CELSR3",
      gene_level : 2,
      hgnc_id : "HGNC:3230",
      havana_gene : "OTTHUMG00000133544.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48673844,
      stop : 48686364,
      direction : "-",
      ID : "ENSG00000213672.8",
      gene_id : "ENSG00000213672.8",
      gene_type : "protein_coding",
      gene_name : "NCKIPSD",
      gene_level : 1,
      hgnc_id : "HGNC:15486",
      havana_gene : "OTTHUMG00000133542.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48688003,
      stop : 48740353,
      direction : "-",
      ID : "ENSG00000068745.15",
      gene_id : "ENSG00000068745.15",
      gene_type : "protein_coding",
      gene_name : "IP6K2",
      gene_level : 1,
      hgnc_id : "HGNC:17313",
      havana_gene : "OTTHUMG00000133543.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48744597,
      stop : 48847874,
      direction : "-",
      ID : "ENSG00000114302.16",
      gene_id : "ENSG00000114302.16",
      gene_type : "protein_coding",
      gene_name : "PRKAR2A",
      gene_level : 1,
      hgnc_id : "HGNC:9391",
      havana_gene : "OTTHUMG00000133540.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48856926,
      stop : 48898904,
      direction : "-",
      ID : "ENSG00000178537.10",
      gene_id : "ENSG00000178537.10",
      gene_type : "protein_coding",
      gene_name : "SLC25A20",
      gene_level : 1,
      hgnc_id : "HGNC:1421",
      havana_gene : "OTTHUMG00000133538.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48918821,
      stop : 48986382,
      direction : "+",
      ID : "ENSG00000177479.20",
      gene_id : "ENSG00000177479.20",
      gene_type : "protein_coding",
      gene_name : "ARIH2",
      gene_level : 2,
      hgnc_id : "HGNC:690",
      havana_gene : "OTTHUMG00000133547.16",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 48989889,
      stop : 49007153,
      direction : "+",
      ID : "ENSG00000178467.18",
      gene_id : "ENSG00000178467.18",
      gene_type : "protein_coding",
      gene_name : "P4HTM",
      gene_level : 2,
      hgnc_id : "HGNC:28858",
      havana_gene : "OTTHUMG00000074057.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49007062,
      stop : 49015953,
      direction : "+",
      ID : "ENSG00000178252.18",
      gene_id : "ENSG00000178252.18",
      gene_type : "protein_coding",
      gene_name : "WDR6",
      gene_level : 1,
      hgnc_id : "HGNC:12758",
      havana_gene : "OTTHUMG00000133546.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49015488,
      stop : 49022293,
      direction : "-",
      ID : "ENSG00000178149.17",
      gene_id : "ENSG00000178149.17",
      gene_type : "protein_coding",
      gene_name : "DALRD3",
      gene_level : 1,
      hgnc_id : "HGNC:25536",
      havana_gene : "OTTHUMG00000156748.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49020459,
      stop : 49023495,
      direction : "+",
      ID : "ENSG00000178057.15",
      gene_id : "ENSG00000178057.15",
      gene_type : "protein_coding",
      gene_name : "NDUFAF3",
      gene_level : 2,
      hgnc_id : "HGNC:29918",
      havana_gene : "OTTHUMG00000156773.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49024325,
      stop : 49029447,
      direction : "-",
      ID : "ENSG00000178035.13",
      gene_id : "ENSG00000178035.13",
      gene_type : "protein_coding",
      gene_name : "IMPDH2",
      gene_level : 1,
      hgnc_id : "HGNC:6053",
      havana_gene : "OTTHUMG00000156771.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49029707,
      stop : 49094363,
      direction : "-",
      ID : "ENSG00000198218.11",
      gene_id : "ENSG00000198218.11",
      gene_type : "protein_coding",
      gene_name : "QRICH1",
      gene_level : 1,
      hgnc_id : "HGNC:24713",
      havana_gene : "OTTHUMG00000156772.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49095932,
      stop : 49105130,
      direction : "-",
      ID : "ENSG00000172053.18",
      gene_id : "ENSG00000172053.18",
      gene_type : "protein_coding",
      gene_name : "QARS1",
      gene_level : 1,
      hgnc_id : "HGNC:9751",
      havana_gene : "OTTHUMG00000156774.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49108046,
      stop : 49120938,
      direction : "-",
      ID : "ENSG00000172046.19",
      gene_id : "ENSG00000172046.19",
      gene_type : "protein_coding",
      gene_name : "USP19",
      gene_level : 1,
      hgnc_id : "HGNC:12617",
      havana_gene : "OTTHUMG00000133611.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49121114,
      stop : 49133118,
      direction : "-",
      ID : "ENSG00000172037.14",
      gene_id : "ENSG00000172037.14",
      gene_type : "protein_coding",
      gene_name : "LAMB2",
      gene_level : 2,
      hgnc_id : "HGNC:6487",
      havana_gene : "OTTHUMG00000156807.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49162535,
      stop : 49166331,
      direction : "-",
      ID : "ENSG00000177352.10",
      gene_id : "ENSG00000177352.10",
      gene_type : "protein_coding",
      gene_name : "CCDC71",
      gene_level : 2,
      hgnc_id : "HGNC:25760",
      havana_gene : "OTTHUMG00000156815.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49171598,
      stop : 49176486,
      direction : "+",
      ID : "ENSG00000185909.15",
      gene_id : "ENSG00000185909.15",
      gene_type : "protein_coding",
      gene_name : "KLHDC8B",
      gene_level : 2,
      hgnc_id : "HGNC:28557",
      havana_gene : "OTTHUMG00000156814.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49177634,
      stop : 49191858,
      direction : "-",
      ID : "ENSG00000236980.10",
      gene_id : "ENSG00000236980.10",
      gene_type : "protein_coding",
      gene_name : "C3orf84",
      gene_level : 2,
      hgnc_id : "HGNC:44666",
      havana_gene : "OTTHUMG00000156816.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49198428,
      stop : 49258106,
      direction : "+",
      ID : "ENSG00000173421.17",
      gene_id : "ENSG00000173421.17",
      gene_type : "protein_coding",
      gene_name : "IHO1",
      gene_level : 2,
      hgnc_id : "HGNC:27945",
      havana_gene : "OTTHUMG00000155920.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49268596,
      stop : 49277232,
      direction : "-",
      ID : "ENSG00000188315.8",
      gene_id : "ENSG00000188315.8",
      gene_type : "protein_coding",
      gene_name : "C3orf62",
      gene_level : 2,
      hgnc_id : "HGNC:24771",
      havana_gene : "OTTHUMG00000156819.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49277144,
      stop : 49340712,
      direction : "-",
      ID : "ENSG00000114316.13",
      gene_id : "ENSG00000114316.13",
      gene_type : "protein_coding",
      gene_name : "USP4",
      gene_level : 1,
      hgnc_id : "HGNC:12627",
      havana_gene : "OTTHUMG00000156825.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49357176,
      stop : 49358353,
      direction : "-",
      ID : "ENSG00000233276.8",
      gene_id : "ENSG00000233276.8",
      gene_type : "protein_coding",
      gene_name : "GPX1",
      gene_level : 2,
      hgnc_id : "HGNC:4553",
      havana_gene : "OTTHUMG00000156837.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49359139,
      stop : 49412998,
      direction : "-",
      ID : "ENSG00000067560.14",
      gene_id : "ENSG00000067560.14",
      gene_type : "protein_coding",
      gene_name : "RHOA",
      gene_level : 1,
      hgnc_id : "HGNC:667",
      havana_gene : "OTTHUMG00000156838.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49412206,
      stop : 49416475,
      direction : "+",
      ID : "ENSG00000145022.4",
      gene_id : "ENSG00000145022.4",
      gene_type : "protein_coding",
      gene_name : "TCTA",
      gene_level : 2,
      hgnc_id : "HGNC:11692",
      havana_gene : "OTTHUMG00000156846.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49416777,
      stop : 49429314,
      direction : "-",
      ID : "ENSG00000283189.2",
      gene_id : "ENSG00000283189.2",
      gene_type : "protein_coding",
      gene_name : "AC104452.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191676.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49416778,
      stop : 49422685,
      direction : "-",
      ID : "ENSG00000145020.16",
      gene_id : "ENSG00000145020.16",
      gene_type : "protein_coding",
      gene_name : "AMT",
      gene_level : 1,
      hgnc_id : "HGNC:473",
      havana_gene : "OTTHUMG00000156847.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49422333,
      stop : 49429326,
      direction : "-",
      ID : "ENSG00000145029.14",
      gene_id : "ENSG00000145029.14",
      gene_type : "protein_coding",
      gene_name : "NICN1",
      gene_level : 2,
      hgnc_id : "HGNC:18317",
      havana_gene : "OTTHUMG00000156848.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49468703,
      stop : 49535618,
      direction : "+",
      ID : "ENSG00000173402.12",
      gene_id : "ENSG00000173402.12",
      gene_type : "protein_coding",
      gene_name : "DAG1",
      gene_level : 2,
      hgnc_id : "HGNC:2666",
      havana_gene : "OTTHUMG00000156869.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49554477,
      stop : 49671549,
      direction : "+",
      ID : "ENSG00000164061.5",
      gene_id : "ENSG00000164061.5",
      gene_type : "protein_coding",
      gene_name : "BSN",
      gene_level : 1,
      hgnc_id : "HGNC:1117",
      havana_gene : "OTTHUMG00000133750.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49674014,
      stop : 49683971,
      direction : "+",
      ID : "ENSG00000164062.13",
      gene_id : "ENSG00000164062.13",
      gene_type : "protein_coding",
      gene_name : "APEH",
      gene_level : 2,
      hgnc_id : "HGNC:586",
      havana_gene : "OTTHUMG00000156882.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49683947,
      stop : 49689501,
      direction : "-",
      ID : "ENSG00000173531.15",
      gene_id : "ENSG00000173531.15",
      gene_type : "protein_coding",
      gene_name : "MST1",
      gene_level : 1,
      hgnc_id : "HGNC:7380",
      havana_gene : "OTTHUMG00000155918.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49689538,
      stop : 49721529,
      direction : "+",
      ID : "ENSG00000164068.16",
      gene_id : "ENSG00000164068.16",
      gene_type : "protein_coding",
      gene_name : "RNF123",
      gene_level : 2,
      hgnc_id : "HGNC:21148",
      havana_gene : "OTTHUMG00000156891.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49716829,
      stop : 49719684,
      direction : "-",
      ID : "ENSG00000176020.9",
      gene_id : "ENSG00000176020.9",
      gene_type : "protein_coding",
      gene_name : "AMIGO3",
      gene_level : 2,
      hgnc_id : "HGNC:24075",
      havana_gene : "OTTHUMG00000158152.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49716844,
      stop : 49723973,
      direction : "-",
      ID : "ENSG00000173540.14",
      gene_id : "ENSG00000173540.14",
      gene_type : "protein_coding",
      gene_name : "GMPPB",
      gene_level : 2,
      hgnc_id : "HGNC:22932",
      havana_gene : "OTTHUMG00000158151.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49724294,
      stop : 49786542,
      direction : "-",
      ID : "ENSG00000176095.12",
      gene_id : "ENSG00000176095.12",
      gene_type : "protein_coding",
      gene_name : "IP6K1",
      gene_level : 1,
      hgnc_id : "HGNC:18360",
      havana_gene : "OTTHUMG00000158197.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49790732,
      stop : 49799873,
      direction : "-",
      ID : "ENSG00000187492.9",
      gene_id : "ENSG00000187492.9",
      gene_type : "protein_coding",
      gene_name : "CDHR4",
      gene_level : 2,
      hgnc_id : "HGNC:34527",
      havana_gene : "OTTHUMG00000158198.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49803261,
      stop : 49805030,
      direction : "+",
      ID : "ENSG00000185614.7",
      gene_id : "ENSG00000185614.7",
      gene_type : "protein_coding",
      gene_name : "INKA1",
      gene_level : 2,
      hgnc_id : "HGNC:32480",
      havana_gene : "OTTHUMG00000158268.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49805209,
      stop : 49813953,
      direction : "-",
      ID : "ENSG00000182179.13",
      gene_id : "ENSG00000182179.13",
      gene_type : "protein_coding",
      gene_name : "UBA7",
      gene_level : 2,
      hgnc_id : "HGNC:12471",
      havana_gene : "OTTHUMG00000158267.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49828601,
      stop : 49856574,
      direction : "-",
      ID : "ENSG00000183763.9",
      gene_id : "ENSG00000183763.9",
      gene_type : "protein_coding",
      gene_name : "TRAIP",
      gene_level : 2,
      hgnc_id : "HGNC:30764",
      havana_gene : "OTTHUMG00000158269.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49857988,
      stop : 49869935,
      direction : "-",
      ID : "ENSG00000164076.17",
      gene_id : "ENSG00000164076.17",
      gene_type : "protein_coding",
      gene_name : "CAMKV",
      gene_level : 1,
      hgnc_id : "HGNC:28788",
      havana_gene : "OTTHUMG00000158288.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49887002,
      stop : 49903873,
      direction : "-",
      ID : "ENSG00000164078.13",
      gene_id : "ENSG00000164078.13",
      gene_type : "protein_coding",
      gene_name : "MST1R",
      gene_level : 1,
      hgnc_id : "HGNC:7381",
      havana_gene : "OTTHUMG00000156709.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49907160,
      stop : 49930173,
      direction : "-",
      ID : "ENSG00000164077.14",
      gene_id : "ENSG00000164077.14",
      gene_type : "protein_coding",
      gene_name : "MON1A",
      gene_level : 1,
      hgnc_id : "HGNC:28207",
      havana_gene : "OTTHUMG00000156737.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 49940007,
      stop : 50100045,
      direction : "+",
      ID : "ENSG00000004534.15",
      gene_id : "ENSG00000004534.15",
      gene_type : "protein_coding",
      gene_name : "RBM6",
      gene_level : 1,
      hgnc_id : "HGNC:9903",
      havana_gene : "OTTHUMG00000156736.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50088919,
      stop : 50119021,
      direction : "+",
      ID : "ENSG00000003756.17",
      gene_id : "ENSG00000003756.17",
      gene_type : "protein_coding",
      gene_name : "RBM5",
      gene_level : 1,
      hgnc_id : "HGNC:9902",
      havana_gene : "OTTHUMG00000156785.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50155045,
      stop : 50189075,
      direction : "+",
      ID : "ENSG00000001617.12",
      gene_id : "ENSG00000001617.12",
      gene_type : "protein_coding",
      gene_name : "SEMA3F",
      gene_level : 2,
      hgnc_id : "HGNC:10728",
      havana_gene : "OTTHUMG00000156806.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50191610,
      stop : 50197696,
      direction : "+",
      ID : "ENSG00000114349.10",
      gene_id : "ENSG00000114349.10",
      gene_type : "protein_coding",
      gene_name : "GNAT1",
      gene_level : 1,
      hgnc_id : "HGNC:4393",
      havana_gene : "OTTHUMG00000156808.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50205246,
      stop : 50221486,
      direction : "+",
      ID : "ENSG00000188338.15",
      gene_id : "ENSG00000188338.15",
      gene_type : "protein_coding",
      gene_name : "SLC38A3",
      gene_level : 2,
      hgnc_id : "HGNC:18044",
      havana_gene : "OTTHUMG00000156764.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50226292,
      stop : 50259362,
      direction : "+",
      ID : "ENSG00000114353.17",
      gene_id : "ENSG00000114353.17",
      gene_type : "protein_coding",
      gene_name : "GNAI2",
      gene_level : 1,
      hgnc_id : "HGNC:4385",
      havana_gene : "OTTHUMG00000156940.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50267558,
      stop : 50277546,
      direction : "+",
      ID : "ENSG00000012171.20",
      gene_id : "ENSG00000012171.20",
      gene_type : "protein_coding",
      gene_name : "SEMA3B",
      gene_level : 2,
      hgnc_id : "HGNC:10724",
      havana_gene : "OTTHUMG00000156970.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50279087,
      stop : 50288114,
      direction : "+",
      ID : "ENSG00000179564.4",
      gene_id : "ENSG00000179564.4",
      gene_type : "protein_coding",
      gene_name : "LSMEM2",
      gene_level : 2,
      hgnc_id : "HGNC:26781",
      havana_gene : "OTTHUMG00000156938.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50287732,
      stop : 50292918,
      direction : "-",
      ID : "ENSG00000214706.11",
      gene_id : "ENSG00000214706.11",
      gene_type : "protein_coding",
      gene_name : "IFRD2",
      gene_level : 2,
      hgnc_id : "HGNC:5457",
      havana_gene : "OTTHUMG00000156935.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50292831,
      stop : 50299405,
      direction : "-",
      ID : "ENSG00000186792.17",
      gene_id : "ENSG00000186792.17",
      gene_type : "protein_coding",
      gene_name : "HYAL3",
      gene_level : 2,
      hgnc_id : "HGNC:5322",
      havana_gene : "OTTHUMG00000156936.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50296402,
      stop : 50299416,
      direction : "-",
      ID : "ENSG00000243477.6",
      gene_id : "ENSG00000243477.6",
      gene_type : "protein_coding",
      gene_name : "NAA80",
      gene_level : 2,
      hgnc_id : "HGNC:30252",
      havana_gene : "OTTHUMG00000156939.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50299890,
      stop : 50312381,
      direction : "-",
      ID : "ENSG00000114378.17",
      gene_id : "ENSG00000114378.17",
      gene_type : "protein_coding",
      gene_name : "HYAL1",
      gene_level : 2,
      hgnc_id : "HGNC:5320",
      havana_gene : "OTTHUMG00000156941.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50317790,
      stop : 50322782,
      direction : "-",
      ID : "ENSG00000068001.14",
      gene_id : "ENSG00000068001.14",
      gene_type : "protein_coding",
      gene_name : "HYAL2",
      gene_level : 2,
      hgnc_id : "HGNC:5321",
      havana_gene : "OTTHUMG00000156876.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50320027,
      stop : 50328251,
      direction : "-",
      ID : "ENSG00000114383.10",
      gene_id : "ENSG00000114383.10",
      gene_type : "protein_coding",
      gene_name : "TUSC2",
      gene_level : 1,
      hgnc_id : "HGNC:17034",
      havana_gene : "OTTHUMG00000156877.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50329782,
      stop : 50340980,
      direction : "-",
      ID : "ENSG00000068028.17",
      gene_id : "ENSG00000068028.17",
      gene_type : "protein_coding",
      gene_name : "RASSF1",
      gene_level : 2,
      hgnc_id : "HGNC:9882",
      havana_gene : "OTTHUMG00000149958.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50341110,
      stop : 50345732,
      direction : "-",
      ID : "ENSG00000004838.14",
      gene_id : "ENSG00000004838.14",
      gene_type : "protein_coding",
      gene_name : "ZMYND10",
      gene_level : 1,
      hgnc_id : "HGNC:19412",
      havana_gene : "OTTHUMG00000156874.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50347330,
      stop : 50350826,
      direction : "-",
      ID : "ENSG00000114388.14",
      gene_id : "ENSG00000114388.14",
      gene_type : "protein_coding",
      gene_name : "NPRL2",
      gene_level : 2,
      hgnc_id : "HGNC:24969",
      havana_gene : "OTTHUMG00000156864.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50350845,
      stop : 50358460,
      direction : "+",
      ID : "ENSG00000114395.11",
      gene_id : "ENSG00000114395.11",
      gene_type : "protein_coding",
      gene_name : "CYB561D2",
      gene_level : 1,
      hgnc_id : "HGNC:30253",
      havana_gene : "OTTHUMG00000156813.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50350892,
      stop : 50367923,
      direction : "+",
      ID : "ENSG00000272104.1",
      gene_id : "ENSG00000272104.1",
      gene_type : "protein_coding",
      gene_name : "Z84492.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185535.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50354750,
      stop : 50359521,
      direction : "-",
      ID : "ENSG00000126062.4",
      gene_id : "ENSG00000126062.4",
      gene_type : "protein_coding",
      gene_name : "TMEM115",
      gene_level : 2,
      hgnc_id : "HGNC:30055",
      havana_gene : "OTTHUMG00000044212.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50362613,
      stop : 50504244,
      direction : "-",
      ID : "ENSG00000007402.12",
      gene_id : "ENSG00000007402.12",
      gene_type : "protein_coding",
      gene_name : "CACNA2D2",
      gene_level : 2,
      hgnc_id : "HGNC:1400",
      havana_gene : "OTTHUMG00000156887.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50558025,
      stop : 50571027,
      direction : "-",
      ID : "ENSG00000088543.15",
      gene_id : "ENSG00000088543.15",
      gene_type : "protein_coding",
      gene_name : "C3orf18",
      gene_level : 1,
      hgnc_id : "HGNC:24837",
      havana_gene : "OTTHUMG00000156854.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50569152,
      stop : 50596168,
      direction : "+",
      ID : "ENSG00000114735.10",
      gene_id : "ENSG00000114735.10",
      gene_type : "protein_coding",
      gene_name : "HEMK1",
      gene_level : 2,
      hgnc_id : "HGNC:24923",
      havana_gene : "OTTHUMG00000156849.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50606489,
      stop : 50611774,
      direction : "-",
      ID : "ENSG00000114737.16",
      gene_id : "ENSG00000114737.16",
      gene_type : "protein_coding",
      gene_name : "CISH",
      gene_level : 2,
      hgnc_id : "HGNC:1984",
      havana_gene : "OTTHUMG00000156853.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50611520,
      stop : 50649291,
      direction : "+",
      ID : "ENSG00000114738.11",
      gene_id : "ENSG00000114738.11",
      gene_type : "protein_coding",
      gene_name : "MAPKAPK3",
      gene_level : 1,
      hgnc_id : "HGNC:6888",
      havana_gene : "OTTHUMG00000156850.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 50674927,
      stop : 51384198,
      direction : "+",
      ID : "ENSG00000088538.13",
      gene_id : "ENSG00000088538.13",
      gene_type : "protein_coding",
      gene_name : "DOCK3",
      gene_level : 2,
      hgnc_id : "HGNC:2989",
      havana_gene : "OTTHUMG00000156892.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51385291,
      stop : 51389397,
      direction : "+",
      ID : "ENSG00000145050.19",
      gene_id : "ENSG00000145050.19",
      gene_type : "protein_coding",
      gene_name : "MANF",
      gene_level : 2,
      hgnc_id : "HGNC:15461",
      havana_gene : "OTTHUMG00000156897.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51391285,
      stop : 51397908,
      direction : "+",
      ID : "ENSG00000259956.2",
      gene_id : "ENSG00000259956.2",
      gene_type : "protein_coding",
      gene_name : "RBM15B",
      gene_level : 2,
      hgnc_id : "HGNC:24303",
      havana_gene : "OTTHUMG00000156896.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51395867,
      stop : 51500002,
      direction : "-",
      ID : "ENSG00000145041.15",
      gene_id : "ENSG00000145041.15",
      gene_type : "protein_coding",
      gene_name : "DCAF1",
      gene_level : 2,
      hgnc_id : "HGNC:30911",
      havana_gene : "OTTHUMG00000156895.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51541144,
      stop : 51668667,
      direction : "+",
      ID : "ENSG00000164080.13",
      gene_id : "ENSG00000164080.13",
      gene_type : "protein_coding",
      gene_name : "RAD54L2",
      gene_level : 1,
      hgnc_id : "HGNC:29123",
      havana_gene : "OTTHUMG00000152936.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51662693,
      stop : 51704323,
      direction : "+",
      ID : "ENSG00000164081.13",
      gene_id : "ENSG00000164081.13",
      gene_type : "protein_coding",
      gene_name : "TEX264",
      gene_level : 2,
      hgnc_id : "HGNC:30247",
      havana_gene : "OTTHUMG00000156901.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51707068,
      stop : 51718613,
      direction : "+",
      ID : "ENSG00000164082.15",
      gene_id : "ENSG00000164082.15",
      gene_type : "protein_coding",
      gene_name : "GRM2",
      gene_level : 2,
      hgnc_id : "HGNC:4594",
      havana_gene : "OTTHUMG00000156902.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51778561,
      stop : 51779241,
      direction : "-",
      ID : "ENSG00000214686.7",
      gene_id : "ENSG00000214686.7",
      gene_type : "protein_coding",
      gene_name : "IQCF6",
      gene_level : 2,
      hgnc_id : "HGNC:35158",
      havana_gene : "OTTHUMG00000187148.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51798803,
      stop : 51833389,
      direction : "+",
      ID : "ENSG00000285749.2",
      gene_id : "ENSG00000285749.2",
      gene_type : "protein_coding",
      gene_name : "AC097636.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000156910.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51826883,
      stop : 51830856,
      direction : "+",
      ID : "ENSG00000229972.8",
      gene_id : "ENSG00000229972.8",
      gene_type : "protein_coding",
      gene_name : "IQCF3",
      gene_level : 2,
      hgnc_id : "HGNC:31816",
      havana_gene : "OTTHUMG00000193406.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51861615,
      stop : 51863424,
      direction : "+",
      ID : "ENSG00000184345.5",
      gene_id : "ENSG00000184345.5",
      gene_type : "protein_coding",
      gene_name : "IQCF2",
      gene_level : 2,
      hgnc_id : "HGNC:31815",
      havana_gene : "OTTHUMG00000156914.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51873721,
      stop : 51875601,
      direction : "-",
      ID : "ENSG00000214681.4",
      gene_id : "ENSG00000214681.4",
      gene_type : "protein_coding",
      gene_name : "IQCF5",
      gene_level : 2,
      hgnc_id : "HGNC:35159",
      havana_gene : "OTTHUMG00000156913.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51894876,
      stop : 51903353,
      direction : "-",
      ID : "ENSG00000173389.16",
      gene_id : "ENSG00000173389.16",
      gene_type : "protein_coding",
      gene_name : "IQCF1",
      gene_level : 2,
      hgnc_id : "HGNC:28607",
      havana_gene : "OTTHUMG00000156908.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51933429,
      stop : 51941904,
      direction : "-",
      ID : "ENSG00000114767.7",
      gene_id : "ENSG00000114767.7",
      gene_type : "protein_coding",
      gene_name : "RRP9",
      gene_level : 2,
      hgnc_id : "HGNC:16829",
      havana_gene : "OTTHUMG00000156930.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51942345,
      stop : 51948867,
      direction : "+",
      ID : "ENSG00000041880.15",
      gene_id : "ENSG00000041880.15",
      gene_type : "protein_coding",
      gene_name : "PARP3",
      gene_level : 2,
      hgnc_id : "HGNC:273",
      havana_gene : "OTTHUMG00000156931.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51955381,
      stop : 51957499,
      direction : "+",
      ID : "ENSG00000180929.6",
      gene_id : "ENSG00000180929.6",
      gene_type : "protein_coding",
      gene_name : "GPR62",
      gene_level : 2,
      hgnc_id : "HGNC:13301",
      havana_gene : "OTTHUMG00000157367.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51957454,
      stop : 51974016,
      direction : "-",
      ID : "ENSG00000090097.22",
      gene_id : "ENSG00000090097.22",
      gene_type : "protein_coding",
      gene_name : "PCBP4",
      gene_level : 1,
      hgnc_id : "HGNC:8652",
      havana_gene : "OTTHUMG00000157366.34",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51968510,
      stop : 51983409,
      direction : "-",
      ID : "ENSG00000114779.20",
      gene_id : "ENSG00000114779.20",
      gene_type : "protein_coding",
      gene_name : "ABHD14B",
      gene_level : 2,
      hgnc_id : "HGNC:28235",
      havana_gene : "OTTHUMG00000157816.25",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51971426,
      stop : 51981199,
      direction : "+",
      ID : "ENSG00000248487.9",
      gene_id : "ENSG00000248487.9",
      gene_type : "protein_coding",
      gene_name : "ABHD14A",
      gene_level : 2,
      hgnc_id : "HGNC:24538",
      havana_gene : "OTTHUMG00000157818.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51974706,
      stop : 51989183,
      direction : "+",
      ID : "ENSG00000114786.16",
      gene_id : "ENSG00000114786.16",
      gene_type : "protein_coding",
      gene_name : "ABHD14A-ACY1",
      gene_level : 1,
      hgnc_id : "HGNC:38856",
      havana_gene : "OTTHUMG00000166447.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51983340,
      stop : 51989197,
      direction : "+",
      ID : "ENSG00000243989.9",
      gene_id : "ENSG00000243989.9",
      gene_type : "protein_coding",
      gene_name : "ACY1",
      gene_level : 1,
      hgnc_id : "HGNC:177",
      havana_gene : "OTTHUMG00000157815.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 51993522,
      stop : 51995895,
      direction : "-",
      ID : "ENSG00000162244.12",
      gene_id : "ENSG00000162244.12",
      gene_type : "protein_coding",
      gene_name : "RPL29",
      gene_level : 2,
      hgnc_id : "HGNC:10331",
      havana_gene : "OTTHUMG00000155262.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52048919,
      stop : 52056571,
      direction : "-",
      ID : "ENSG00000164086.10",
      gene_id : "ENSG00000164086.10",
      gene_type : "protein_coding",
      gene_name : "DUSP7",
      gene_level : 2,
      hgnc_id : "HGNC:3073",
      havana_gene : "OTTHUMG00000157819.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52075226,
      stop : 52154690,
      direction : "-",
      ID : "ENSG00000164087.8",
      gene_id : "ENSG00000164087.8",
      gene_type : "protein_coding",
      gene_name : "POC1A",
      gene_level : 2,
      hgnc_id : "HGNC:24488",
      havana_gene : "OTTHUMG00000157817.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52198086,
      stop : 52214327,
      direction : "+",
      ID : "ENSG00000023330.15",
      gene_id : "ENSG00000023330.15",
      gene_type : "protein_coding",
      gene_name : "ALAS1",
      gene_level : 1,
      hgnc_id : "HGNC:396",
      havana_gene : "OTTHUMG00000158108.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52221080,
      stop : 52225645,
      direction : "-",
      ID : "ENSG00000239732.4",
      gene_id : "ENSG00000239732.4",
      gene_type : "protein_coding",
      gene_name : "TLR9",
      gene_level : 2,
      hgnc_id : "HGNC:15633",
      havana_gene : "OTTHUMG00000158106.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52221081,
      stop : 52231190,
      direction : "-",
      ID : "ENSG00000173366.11",
      gene_id : "ENSG00000173366.11",
      gene_type : "protein_coding",
      gene_name : "AC097637.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162044.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52228612,
      stop : 52246788,
      direction : "-",
      ID : "ENSG00000247596.10",
      gene_id : "ENSG00000247596.10",
      gene_type : "protein_coding",
      gene_name : "TWF2",
      gene_level : 1,
      hgnc_id : "HGNC:9621",
      havana_gene : "OTTHUMG00000158105.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52245759,
      stop : 52250599,
      direction : "+",
      ID : "ENSG00000164088.18",
      gene_id : "ENSG00000164088.18",
      gene_type : "protein_coding",
      gene_name : "PPM1M",
      gene_level : 1,
      hgnc_id : "HGNC:26506",
      havana_gene : "OTTHUMG00000153046.12",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52254434,
      stop : 52288020,
      direction : "-",
      ID : "ENSG00000164091.12",
      gene_id : "ENSG00000164091.12",
      gene_type : "protein_coding",
      gene_name : "WDR82",
      gene_level : 2,
      hgnc_id : "HGNC:28826",
      havana_gene : "OTTHUMG00000150391.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52287089,
      stop : 52295257,
      direction : "+",
      ID : "ENSG00000168237.18",
      gene_id : "ENSG00000168237.18",
      gene_type : "protein_coding",
      gene_name : "GLYCTK",
      gene_level : 1,
      hgnc_id : "HGNC:24247",
      havana_gene : "OTTHUMG00000158380.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52316319,
      stop : 52400491,
      direction : "+",
      ID : "ENSG00000114841.17",
      gene_id : "ENSG00000114841.17",
      gene_type : "protein_coding",
      gene_name : "DNAH1",
      gene_level : 2,
      hgnc_id : "HGNC:2940",
      havana_gene : "OTTHUMG00000158378.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52401008,
      stop : 52410008,
      direction : "-",
      ID : "ENSG00000163930.10",
      gene_id : "ENSG00000163930.10",
      gene_type : "protein_coding",
      gene_name : "BAP1",
      gene_level : 2,
      hgnc_id : "HGNC:950",
      havana_gene : "OTTHUMG00000158392.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52410660,
      stop : 52423641,
      direction : "+",
      ID : "ENSG00000010318.21",
      gene_id : "ENSG00000010318.21",
      gene_type : "protein_coding",
      gene_name : "PHF7",
      gene_level : 1,
      hgnc_id : "HGNC:18458",
      havana_gene : "OTTHUMG00000158495.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52433035,
      stop : 52445103,
      direction : "-",
      ID : "ENSG00000010319.7",
      gene_id : "ENSG00000010319.7",
      gene_type : "protein_coding",
      gene_name : "SEMA3G",
      gene_level : 2,
      hgnc_id : "HGNC:30400",
      havana_gene : "OTTHUMG00000158570.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52451100,
      stop : 52454041,
      direction : "-",
      ID : "ENSG00000114854.8",
      gene_id : "ENSG00000114854.8",
      gene_type : "protein_coding",
      gene_name : "TNNC1",
      gene_level : 1,
      hgnc_id : "HGNC:11943",
      havana_gene : "OTTHUMG00000158572.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52455118,
      stop : 52493068,
      direction : "+",
      ID : "ENSG00000010322.16",
      gene_id : "ENSG00000010322.16",
      gene_type : "protein_coding",
      gene_name : "NISCH",
      gene_level : 2,
      hgnc_id : "HGNC:18006",
      havana_gene : "OTTHUMG00000158571.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52495338,
      stop : 52524495,
      direction : "+",
      ID : "ENSG00000010327.10",
      gene_id : "ENSG00000010327.10",
      gene_type : "protein_coding",
      gene_name : "STAB1",
      gene_level : 2,
      hgnc_id : "HGNC:18628",
      havana_gene : "OTTHUMG00000158574.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52524385,
      stop : 52535054,
      direction : "-",
      ID : "ENSG00000168268.11",
      gene_id : "ENSG00000168268.11",
      gene_type : "protein_coding",
      gene_name : "NT5DC2",
      gene_level : 2,
      hgnc_id : "HGNC:25717",
      havana_gene : "OTTHUMG00000158626.23",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52534013,
      stop : 52579237,
      direction : "+",
      ID : "ENSG00000168273.8",
      gene_id : "ENSG00000168273.8",
      gene_type : "protein_coding",
      gene_name : "SMIM4",
      gene_level : 1,
      hgnc_id : "HGNC:37257",
      havana_gene : "OTTHUMG00000158726.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52545352,
      stop : 52685917,
      direction : "-",
      ID : "ENSG00000163939.18",
      gene_id : "ENSG00000163939.18",
      gene_type : "protein_coding",
      gene_name : "PBRM1",
      gene_level : 1,
      hgnc_id : "HGNC:30064",
      havana_gene : "OTTHUMG00000152663.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52681156,
      stop : 52694497,
      direction : "+",
      ID : "ENSG00000163938.17",
      gene_id : "ENSG00000163938.17",
      gene_type : "protein_coding",
      gene_name : "GNL3",
      gene_level : 2,
      hgnc_id : "HGNC:29931",
      havana_gene : "OTTHUMG00000158752.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52694486,
      stop : 52706032,
      direction : "-",
      ID : "ENSG00000016864.19",
      gene_id : "ENSG00000016864.19",
      gene_type : "protein_coding",
      gene_name : "GLT8D1",
      gene_level : 2,
      hgnc_id : "HGNC:24870",
      havana_gene : "OTTHUMG00000158759.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52704955,
      stop : 52711148,
      direction : "+",
      ID : "ENSG00000114902.14",
      gene_id : "ENSG00000114902.14",
      gene_type : "protein_coding",
      gene_name : "SPCS1",
      gene_level : 2,
      hgnc_id : "HGNC:23401",
      havana_gene : "OTTHUMG00000154930.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52708444,
      stop : 52770946,
      direction : "-",
      ID : "ENSG00000114904.13",
      gene_id : "ENSG00000114904.13",
      gene_type : "protein_coding",
      gene_name : "NEK4",
      gene_level : 1,
      hgnc_id : "HGNC:11399",
      havana_gene : "OTTHUMG00000158836.18",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52777595,
      stop : 52792068,
      direction : "+",
      ID : "ENSG00000055957.11",
      gene_id : "ENSG00000055957.11",
      gene_type : "protein_coding",
      gene_name : "ITIH1",
      gene_level : 2,
      hgnc_id : "HGNC:6166",
      havana_gene : "OTTHUMG00000150312.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52794768,
      stop : 52809009,
      direction : "+",
      ID : "ENSG00000162267.12",
      gene_id : "ENSG00000162267.12",
      gene_type : "protein_coding",
      gene_name : "ITIH3",
      gene_level : 2,
      hgnc_id : "HGNC:6168",
      havana_gene : "OTTHUMG00000158956.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52812962,
      stop : 52830688,
      direction : "-",
      ID : "ENSG00000055955.17",
      gene_id : "ENSG00000055955.17",
      gene_type : "protein_coding",
      gene_name : "ITIH4",
      gene_level : 2,
      hgnc_id : "HGNC:6169",
      havana_gene : "OTTHUMG00000159023.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52813282,
      stop : 52835729,
      direction : "-",
      ID : "ENSG00000243696.5",
      gene_id : "ENSG00000243696.5",
      gene_type : "protein_coding",
      gene_name : "AC006254.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186063.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52833114,
      stop : 52835019,
      direction : "-",
      ID : "ENSG00000272573.6",
      gene_id : "ENSG00000272573.6",
      gene_type : "protein_coding",
      gene_name : "MUSTN1",
      gene_level : 2,
      hgnc_id : "HGNC:22144",
      havana_gene : "OTTHUMG00000159024.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52833121,
      stop : 52897562,
      direction : "-",
      ID : "ENSG00000248592.7",
      gene_id : "ENSG00000248592.7",
      gene_type : "protein_coding",
      gene_name : "STIMATE-MUSTN1",
      gene_level : 2,
      hgnc_id : "HGNC:38834",
      havana_gene : "OTTHUMG00000160756.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52836219,
      stop : 52897548,
      direction : "-",
      ID : "ENSG00000213533.13",
      gene_id : "ENSG00000213533.13",
      gene_type : "protein_coding",
      gene_name : "STIMATE",
      gene_level : 1,
      hgnc_id : "HGNC:30526",
      havana_gene : "OTTHUMG00000150346.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52903572,
      stop : 53046750,
      direction : "-",
      ID : "ENSG00000163935.14",
      gene_id : "ENSG00000163935.14",
      gene_type : "protein_coding",
      gene_name : "SFMBT1",
      gene_level : 2,
      hgnc_id : "HGNC:20255",
      havana_gene : "OTTHUMG00000159052.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 52969119,
      stop : 53099453,
      direction : "-",
      ID : "ENSG00000272305.5",
      gene_id : "ENSG00000272305.5",
      gene_type : "protein_coding",
      gene_name : "AC096887.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185626.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53088483,
      stop : 53130453,
      direction : "-",
      ID : "ENSG00000163933.10",
      gene_id : "ENSG00000163933.10",
      gene_type : "protein_coding",
      gene_name : "RFT1",
      gene_level : 1,
      hgnc_id : "HGNC:30220",
      havana_gene : "OTTHUMG00000074035.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53156009,
      stop : 53192717,
      direction : "+",
      ID : "ENSG00000163932.15",
      gene_id : "ENSG00000163932.15",
      gene_type : "protein_coding",
      gene_name : "PRKCD",
      gene_level : 2,
      hgnc_id : "HGNC:9399",
      havana_gene : "OTTHUMG00000133659.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53224712,
      stop : 53256052,
      direction : "-",
      ID : "ENSG00000163931.16",
      gene_id : "ENSG00000163931.16",
      gene_type : "protein_coding",
      gene_name : "TKT",
      gene_level : 2,
      hgnc_id : "HGNC:11834",
      havana_gene : "OTTHUMG00000158192.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53283429,
      stop : 53347586,
      direction : "-",
      ID : "ENSG00000272886.6",
      gene_id : "ENSG00000272886.6",
      gene_type : "protein_coding",
      gene_name : "DCP1A",
      gene_level : 2,
      hgnc_id : "HGNC:18714",
      havana_gene : "OTTHUMG00000158193.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53328963,
      stop : 53813733,
      direction : "+",
      ID : "ENSG00000157388.19",
      gene_id : "ENSG00000157388.19",
      gene_type : "protein_coding",
      gene_name : "CACNA1D",
      gene_level : 1,
      hgnc_id : "HGNC:1391",
      havana_gene : "OTTHUMG00000158278.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53812335,
      stop : 53846419,
      direction : "-",
      ID : "ENSG00000016391.11",
      gene_id : "ENSG00000016391.11",
      gene_type : "protein_coding",
      gene_name : "CHDH",
      gene_level : 2,
      hgnc_id : "HGNC:24288",
      havana_gene : "OTTHUMG00000158281.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53846568,
      stop : 53865794,
      direction : "+",
      ID : "ENSG00000056736.10",
      gene_id : "ENSG00000056736.10",
      gene_type : "protein_coding",
      gene_name : "IL17RB",
      gene_level : 1,
      hgnc_id : "HGNC:18015",
      havana_gene : "OTTHUMG00000158280.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53867066,
      stop : 53882152,
      direction : "-",
      ID : "ENSG00000113812.14",
      gene_id : "ENSG00000113812.14",
      gene_type : "protein_coding",
      gene_name : "ACTR8",
      gene_level : 1,
      hgnc_id : "HGNC:14672",
      havana_gene : "OTTHUMG00000158279.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 53884417,
      stop : 53891962,
      direction : "-",
      ID : "ENSG00000113811.11",
      gene_id : "ENSG00000113811.11",
      gene_type : "protein_coding",
      gene_name : "SELENOK",
      gene_level : 2,
      hgnc_id : "HGNC:30394",
      havana_gene : "OTTHUMG00000158656.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 54122547,
      stop : 55074557,
      direction : "+",
      ID : "ENSG00000157445.15",
      gene_id : "ENSG00000157445.15",
      gene_type : "protein_coding",
      gene_name : "CACNA2D3",
      gene_level : 2,
      hgnc_id : "HGNC:15460",
      havana_gene : "OTTHUMG00000158580.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 54918231,
      stop : 54967088,
      direction : "-",
      ID : "ENSG00000144771.8",
      gene_id : "ENSG00000144771.8",
      gene_type : "protein_coding",
      gene_name : "LRTM1",
      gene_level : 2,
      hgnc_id : "HGNC:25023",
      havana_gene : "OTTHUMG00000158578.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 55465715,
      stop : 55490539,
      direction : "-",
      ID : "ENSG00000114251.15",
      gene_id : "ENSG00000114251.15",
      gene_type : "protein_coding",
      gene_name : "WNT5A",
      gene_level : 2,
      hgnc_id : "HGNC:12784",
      havana_gene : "OTTHUMG00000158361.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 55508311,
      stop : 56468467,
      direction : "-",
      ID : "ENSG00000187672.14",
      gene_id : "ENSG00000187672.14",
      gene_type : "protein_coding",
      gene_name : "ERC2",
      gene_level : 2,
      hgnc_id : "HGNC:31922",
      havana_gene : "OTTHUMG00000158390.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 56557161,
      stop : 56621837,
      direction : "+",
      ID : "ENSG00000180376.17",
      gene_id : "ENSG00000180376.17",
      gene_type : "protein_coding",
      gene_name : "CCDC66",
      gene_level : 2,
      hgnc_id : "HGNC:27709",
      havana_gene : "OTTHUMG00000155748.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 56620133,
      stop : 56683237,
      direction : "-",
      ID : "ENSG00000163946.13",
      gene_id : "ENSG00000163946.13",
      gene_type : "protein_coding",
      gene_name : "TASOR",
      gene_level : 2,
      hgnc_id : "HGNC:30314",
      havana_gene : "OTTHUMG00000158827.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 56727418,
      stop : 57079329,
      direction : "-",
      ID : "ENSG00000163947.12",
      gene_id : "ENSG00000163947.12",
      gene_type : "protein_coding",
      gene_name : "ARHGEF3",
      gene_level : 1,
      hgnc_id : "HGNC:683",
      havana_gene : "OTTHUMG00000158857.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57060664,
      stop : 57075432,
      direction : "+",
      ID : "ENSG00000186451.2",
      gene_id : "ENSG00000186451.2",
      gene_type : "protein_coding",
      gene_name : "SPATA12",
      gene_level : 2,
      hgnc_id : "HGNC:23221",
      havana_gene : "OTTHUMG00000158862.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57089982,
      stop : 57170306,
      direction : "-",
      ID : "ENSG00000144730.19",
      gene_id : "ENSG00000144730.19",
      gene_type : "protein_coding",
      gene_name : "IL17RD",
      gene_level : 2,
      hgnc_id : "HGNC:17616",
      havana_gene : "OTTHUMG00000150171.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57197838,
      stop : 57227606,
      direction : "-",
      ID : "ENSG00000163666.10",
      gene_id : "ENSG00000163666.10",
      gene_type : "protein_coding",
      gene_name : "HESX1",
      gene_level : 1,
      hgnc_id : "HGNC:4877",
      havana_gene : "OTTHUMG00000158597.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57227726,
      stop : 57278105,
      direction : "+",
      ID : "ENSG00000157500.12",
      gene_id : "ENSG00000157500.12",
      gene_type : "protein_coding",
      gene_name : "APPL1",
      gene_level : 2,
      hgnc_id : "HGNC:24035",
      havana_gene : "OTTHUMG00000133756.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57268342,
      stop : 57292685,
      direction : "-",
      ID : "ENSG00000239388.9",
      gene_id : "ENSG00000239388.9",
      gene_type : "protein_coding",
      gene_name : "ASB14",
      gene_level : 1,
      hgnc_id : "HGNC:19766",
      havana_gene : "OTTHUMG00000158602.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57293699,
      stop : 57544344,
      direction : "-",
      ID : "ENSG00000174844.14",
      gene_id : "ENSG00000174844.14",
      gene_type : "protein_coding",
      gene_name : "DNAH12",
      gene_level : 1,
      hgnc_id : "HGNC:2943",
      havana_gene : "OTTHUMG00000158598.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57556274,
      stop : 57566848,
      direction : "+",
      ID : "ENSG00000174840.9",
      gene_id : "ENSG00000174840.9",
      gene_type : "protein_coding",
      gene_name : "PDE12",
      gene_level : 2,
      hgnc_id : "HGNC:25386",
      havana_gene : "OTTHUMG00000158599.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57571363,
      stop : 57598220,
      direction : "-",
      ID : "ENSG00000168374.11",
      gene_id : "ENSG00000168374.11",
      gene_type : "protein_coding",
      gene_name : "ARF4",
      gene_level : 1,
      hgnc_id : "HGNC:655",
      havana_gene : "OTTHUMG00000158601.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57625454,
      stop : 57693077,
      direction : "-",
      ID : "ENSG00000174839.13",
      gene_id : "ENSG00000174839.13",
      gene_type : "protein_coding",
      gene_name : "DENND6A",
      gene_level : 2,
      hgnc_id : "HGNC:26635",
      havana_gene : "OTTHUMG00000158639.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 57755450,
      stop : 57930003,
      direction : "+",
      ID : "ENSG00000163681.16",
      gene_id : "ENSG00000163681.16",
      gene_type : "protein_coding",
      gene_name : "SLMAP",
      gene_level : 2,
      hgnc_id : "HGNC:16643",
      havana_gene : "OTTHUMG00000133764.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58008400,
      stop : 58172251,
      direction : "+",
      ID : "ENSG00000136068.15",
      gene_id : "ENSG00000136068.15",
      gene_type : "protein_coding",
      gene_name : "FLNB",
      gene_level : 1,
      hgnc_id : "HGNC:3755",
      havana_gene : "OTTHUMG00000159158.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58192257,
      stop : 58214697,
      direction : "-",
      ID : "ENSG00000163687.14",
      gene_id : "ENSG00000163687.14",
      gene_type : "protein_coding",
      gene_name : "DNASE1L3",
      gene_level : 1,
      hgnc_id : "HGNC:2959",
      havana_gene : "OTTHUMG00000159153.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58237532,
      stop : 58295693,
      direction : "+",
      ID : "ENSG00000163686.15",
      gene_id : "ENSG00000163686.15",
      gene_type : "protein_coding",
      gene_name : "ABHD6",
      gene_level : 2,
      hgnc_id : "HGNC:21398",
      havana_gene : "OTTHUMG00000159150.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58306245,
      stop : 58324695,
      direction : "+",
      ID : "ENSG00000163684.12",
      gene_id : "ENSG00000163684.12",
      gene_type : "protein_coding",
      gene_name : "RPP14",
      gene_level : 2,
      hgnc_id : "HGNC:30327",
      havana_gene : "OTTHUMG00000159152.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58306262,
      stop : 58320193,
      direction : "+",
      ID : "ENSG00000255154.9",
      gene_id : "ENSG00000255154.9",
      gene_type : "protein_coding",
      gene_name : "HTD2",
      gene_level : 2,
      hgnc_id : "HGNC:53111",
      havana_gene : "OTTHUMG00000166318.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58332880,
      stop : 58426127,
      direction : "+",
      ID : "ENSG00000168297.16",
      gene_id : "ENSG00000168297.16",
      gene_type : "protein_coding",
      gene_name : "PXK",
      gene_level : 1,
      hgnc_id : "HGNC:23326",
      havana_gene : "OTTHUMG00000159149.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58427630,
      stop : 58433857,
      direction : "-",
      ID : "ENSG00000168291.13",
      gene_id : "ENSG00000168291.13",
      gene_type : "protein_coding",
      gene_name : "PDHB",
      gene_level : 2,
      hgnc_id : "HGNC:8808",
      havana_gene : "OTTHUMG00000159157.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58492096,
      stop : 58502360,
      direction : "+",
      ID : "ENSG00000168301.13",
      gene_id : "ENSG00000168301.13",
      gene_type : "protein_coding",
      gene_name : "KCTD6",
      gene_level : 1,
      hgnc_id : "HGNC:22235",
      havana_gene : "OTTHUMG00000159161.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58505136,
      stop : 58537283,
      direction : "-",
      ID : "ENSG00000168306.13",
      gene_id : "ENSG00000168306.13",
      gene_type : "protein_coding",
      gene_name : "ACOX2",
      gene_level : 1,
      hgnc_id : "HGNC:120",
      havana_gene : "OTTHUMG00000159154.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58564117,
      stop : 58627610,
      direction : "-",
      ID : "ENSG00000168309.18",
      gene_id : "ENSG00000168309.18",
      gene_type : "protein_coding",
      gene_name : "FAM107A",
      gene_level : 1,
      hgnc_id : "HGNC:30827",
      havana_gene : "OTTHUMG00000159159.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58633946,
      stop : 58666834,
      direction : "-",
      ID : "ENSG00000198643.7",
      gene_id : "ENSG00000198643.7",
      gene_type : "protein_coding",
      gene_name : "FAM3D",
      gene_level : 2,
      hgnc_id : "HGNC:18665",
      havana_gene : "OTTHUMG00000159148.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 58717365,
      stop : 59050084,
      direction : "-",
      ID : "ENSG00000163689.20",
      gene_id : "ENSG00000163689.20",
      gene_type : "protein_coding",
      gene_name : "CFAP20DC",
      gene_level : 1,
      hgnc_id : "HGNC:24763",
      havana_gene : "OTTHUMG00000159151.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 59747277,
      stop : 61251459,
      direction : "-",
      ID : "ENSG00000189283.10",
      gene_id : "ENSG00000189283.10",
      gene_type : "protein_coding",
      gene_name : "FHIT",
      gene_level : 2,
      hgnc_id : "HGNC:3701",
      havana_gene : "OTTHUMG00000158591.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 61561569,
      stop : 62297609,
      direction : "+",
      ID : "ENSG00000144724.20",
      gene_id : "ENSG00000144724.20",
      gene_type : "protein_coding",
      gene_name : "PTPRG",
      gene_level : 2,
      hgnc_id : "HGNC:9671",
      havana_gene : "OTTHUMG00000158660.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 62319015,
      stop : 62336213,
      direction : "+",
      ID : "ENSG00000114405.11",
      gene_id : "ENSG00000114405.11",
      gene_type : "protein_coding",
      gene_name : "C3orf14",
      gene_level : 2,
      hgnc_id : "HGNC:25024",
      havana_gene : "OTTHUMG00000158704.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 62369681,
      stop : 62374324,
      direction : "-",
      ID : "ENSG00000153266.13",
      gene_id : "ENSG00000153266.13",
      gene_type : "protein_coding",
      gene_name : "FEZF2",
      gene_level : 2,
      hgnc_id : "HGNC:13506",
      havana_gene : "OTTHUMG00000158705.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 62398346,
      stop : 62875416,
      direction : "-",
      ID : "ENSG00000163618.18",
      gene_id : "ENSG00000163618.18",
      gene_type : "protein_coding",
      gene_name : "CADPS",
      gene_level : 1,
      hgnc_id : "HGNC:1426",
      havana_gene : "OTTHUMG00000158651.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 63228315,
      stop : 63616924,
      direction : "+",
      ID : "ENSG00000163630.11",
      gene_id : "ENSG00000163630.11",
      gene_type : "protein_coding",
      gene_name : "SYNPR",
      gene_level : 1,
      hgnc_id : "HGNC:16507",
      havana_gene : "OTTHUMG00000158699.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 63652675,
      stop : 63679020,
      direction : "+",
      ID : "ENSG00000188817.8",
      gene_id : "ENSG00000188817.8",
      gene_type : "protein_coding",
      gene_name : "SNTN",
      gene_level : 1,
      hgnc_id : "HGNC:33706",
      havana_gene : "OTTHUMG00000158766.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 63819299,
      stop : 63848636,
      direction : "+",
      ID : "ENSG00000163632.14",
      gene_id : "ENSG00000163632.14",
      gene_type : "protein_coding",
      gene_name : "C3orf49",
      gene_level : 2,
      hgnc_id : "HGNC:25190",
      havana_gene : "OTTHUMG00000158761.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 63833870,
      stop : 63863868,
      direction : "-",
      ID : "ENSG00000163634.12",
      gene_id : "ENSG00000163634.12",
      gene_type : "protein_coding",
      gene_name : "THOC7",
      gene_level : 2,
      hgnc_id : "HGNC:29874",
      havana_gene : "OTTHUMG00000158767.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 63863155,
      stop : 64003462,
      direction : "+",
      ID : "ENSG00000163635.20",
      gene_id : "ENSG00000163635.20",
      gene_type : "protein_coding",
      gene_name : "ATXN7",
      gene_level : 2,
      hgnc_id : "HGNC:10560",
      havana_gene : "OTTHUMG00000192515.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 64010550,
      stop : 64024010,
      direction : "-",
      ID : "ENSG00000163636.11",
      gene_id : "ENSG00000163636.11",
      gene_type : "protein_coding",
      gene_name : "PSMD6",
      gene_level : 2,
      hgnc_id : "HGNC:9564",
      havana_gene : "OTTHUMG00000158765.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 64092236,
      stop : 64445476,
      direction : "-",
      ID : "ENSG00000163637.13",
      gene_id : "ENSG00000163637.13",
      gene_type : "protein_coding",
      gene_name : "PRICKLE2",
      gene_level : 1,
      hgnc_id : "HGNC:20340",
      havana_gene : "OTTHUMG00000158789.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 64515654,
      stop : 64688000,
      direction : "-",
      ID : "ENSG00000163638.13",
      gene_id : "ENSG00000163638.13",
      gene_type : "protein_coding",
      gene_name : "ADAMTS9",
      gene_level : 2,
      hgnc_id : "HGNC:13202",
      havana_gene : "OTTHUMG00000158722.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 65353525,
      stop : 66038834,
      direction : "-",
      ID : "ENSG00000151276.23",
      gene_id : "ENSG00000151276.23",
      gene_type : "protein_coding",
      gene_name : "MAGI1",
      gene_level : 1,
      hgnc_id : "HGNC:946",
      havana_gene : "OTTHUMG00000157554.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 66133610,
      stop : 66388116,
      direction : "+",
      ID : "ENSG00000144741.18",
      gene_id : "ENSG00000144741.18",
      gene_type : "protein_coding",
      gene_name : "SLC25A26",
      gene_level : 1,
      hgnc_id : "HGNC:20661",
      havana_gene : "OTTHUMG00000149917.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 66378797,
      stop : 66501263,
      direction : "-",
      ID : "ENSG00000144749.14",
      gene_id : "ENSG00000144749.14",
      gene_type : "protein_coding",
      gene_name : "LRIG1",
      gene_level : 2,
      hgnc_id : "HGNC:17360",
      havana_gene : "OTTHUMG00000158727.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 66998307,
      stop : 67011210,
      direction : "+",
      ID : "ENSG00000163376.11",
      gene_id : "ENSG00000163376.11",
      gene_type : "protein_coding",
      gene_name : "KBTBD8",
      gene_level : 2,
      hgnc_id : "HGNC:30691",
      havana_gene : "OTTHUMG00000158779.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 67360460,
      stop : 67654612,
      direction : "-",
      ID : "ENSG00000172340.15",
      gene_id : "ENSG00000172340.15",
      gene_type : "protein_coding",
      gene_name : "SUCLG2",
      gene_level : 2,
      hgnc_id : "HGNC:11450",
      havana_gene : "OTTHUMG00000158740.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 68004247,
      stop : 68545621,
      direction : "+",
      ID : "ENSG00000183662.11",
      gene_id : "ENSG00000183662.11",
      gene_type : "protein_coding",
      gene_name : "TAFA1",
      gene_level : 2,
      hgnc_id : "HGNC:21587",
      havana_gene : "OTTHUMG00000158745.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 68731766,
      stop : 68953297,
      direction : "-",
      ID : "ENSG00000163377.16",
      gene_id : "ENSG00000163377.16",
      gene_type : "protein_coding",
      gene_name : "TAFA4",
      gene_level : 2,
      hgnc_id : "HGNC:21591",
      havana_gene : "OTTHUMG00000158744.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 68975217,
      stop : 69013684,
      direction : "-",
      ID : "ENSG00000163378.14",
      gene_id : "ENSG00000163378.14",
      gene_type : "protein_coding",
      gene_name : "EOGT",
      gene_level : 2,
      hgnc_id : "HGNC:28526",
      havana_gene : "OTTHUMG00000156279.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 69019827,
      stop : 69052339,
      direction : "-",
      ID : "ENSG00000144747.17",
      gene_id : "ENSG00000144747.17",
      gene_type : "protein_coding",
      gene_name : "TMF1",
      gene_level : 2,
      hgnc_id : "HGNC:11870",
      havana_gene : "OTTHUMG00000158771.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 69054730,
      stop : 69080408,
      direction : "-",
      ID : "ENSG00000144744.17",
      gene_id : "ENSG00000144744.17",
      gene_type : "protein_coding",
      gene_name : "UBA3",
      gene_level : 2,
      hgnc_id : "HGNC:12470",
      havana_gene : "OTTHUMG00000154325.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 69084937,
      stop : 69106092,
      direction : "+",
      ID : "ENSG00000144746.7",
      gene_id : "ENSG00000144746.7",
      gene_type : "protein_coding",
      gene_name : "ARL6IP5",
      gene_level : 2,
      hgnc_id : "HGNC:16937",
      havana_gene : "OTTHUMG00000158773.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 69106065,
      stop : 69123032,
      direction : "-",
      ID : "ENSG00000163380.16",
      gene_id : "ENSG00000163380.16",
      gene_type : "protein_coding",
      gene_name : "LMOD3",
      gene_level : 2,
      hgnc_id : "HGNC:6649",
      havana_gene : "OTTHUMG00000158774.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 69168782,
      stop : 69542583,
      direction : "-",
      ID : "ENSG00000114541.15",
      gene_id : "ENSG00000114541.15",
      gene_type : "protein_coding",
      gene_name : "FRMD4B",
      gene_level : 2,
      hgnc_id : "HGNC:24886",
      havana_gene : "OTTHUMG00000158772.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 69739464,
      stop : 69968336,
      direction : "+",
      ID : "ENSG00000187098.17",
      gene_id : "ENSG00000187098.17",
      gene_type : "protein_coding",
      gene_name : "MITF",
      gene_level : 2,
      hgnc_id : "HGNC:7105",
      havana_gene : "OTTHUMG00000149921.15",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 70194479,
      stop : 70312638,
      direction : "-",
      ID : "ENSG00000242120.4",
      gene_id : "ENSG00000242120.4",
      gene_type : "protein_coding",
      gene_name : "MDFIC2",
      gene_level : 2,
      hgnc_id : "HGNC:53442",
      havana_gene : "OTTHUMG00000158801.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 70954708,
      stop : 71583989,
      direction : "-",
      ID : "ENSG00000114861.23",
      gene_id : "ENSG00000114861.23",
      gene_type : "protein_coding",
      gene_name : "FOXP1",
      gene_level : 1,
      hgnc_id : "HGNC:3823",
      havana_gene : "OTTHUMG00000158803.19",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 70959226,
      stop : 71754229,
      direction : "-",
      ID : "ENSG00000285708.1",
      gene_id : "ENSG00000285708.1",
      gene_type : "protein_coding",
      gene_name : "AC097634.4",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192624.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 71675414,
      stop : 71754773,
      direction : "-",
      ID : "ENSG00000163412.13",
      gene_id : "ENSG00000163412.13",
      gene_type : "protein_coding",
      gene_name : "EIF4E3",
      gene_level : 2,
      hgnc_id : "HGNC:31837",
      havana_gene : "OTTHUMG00000158797.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 71753855,
      stop : 71756496,
      direction : "+",
      ID : "ENSG00000170837.3",
      gene_id : "ENSG00000170837.3",
      gene_type : "protein_coding",
      gene_name : "GPR27",
      gene_level : 2,
      hgnc_id : "HGNC:4482",
      havana_gene : "OTTHUMG00000158810.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 71771655,
      stop : 71785206,
      direction : "-",
      ID : "ENSG00000163421.9",
      gene_id : "ENSG00000163421.9",
      gene_type : "protein_coding",
      gene_name : "PROK2",
      gene_level : 2,
      hgnc_id : "HGNC:18455",
      havana_gene : "OTTHUMG00000158809.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 72371825,
      stop : 72446623,
      direction : "-",
      ID : "ENSG00000163602.11",
      gene_id : "ENSG00000163602.11",
      gene_type : "protein_coding",
      gene_name : "RYBP",
      gene_level : 2,
      hgnc_id : "HGNC:10480",
      havana_gene : "OTTHUMG00000159190.4",
      tag : "reference_genome_error"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 72749277,
      stop : 72861914,
      direction : "-",
      ID : "ENSG00000144736.14",
      gene_id : "ENSG00000144736.14",
      gene_type : "protein_coding",
      gene_name : "SHQ1",
      gene_level : 1,
      hgnc_id : "HGNC:25543",
      havana_gene : "OTTHUMG00000158814.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 72888046,
      stop : 72998138,
      direction : "+",
      ID : "ENSG00000172986.13",
      gene_id : "ENSG00000172986.13",
      gene_type : "protein_coding",
      gene_name : "GXYLT2",
      gene_level : 2,
      hgnc_id : "HGNC:33383",
      havana_gene : "OTTHUMG00000158815.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 72996803,
      stop : 73069198,
      direction : "+",
      ID : "ENSG00000163605.15",
      gene_id : "ENSG00000163605.15",
      gene_type : "protein_coding",
      gene_name : "PPP4R2",
      gene_level : 2,
      hgnc_id : "HGNC:18296",
      havana_gene : "OTTHUMG00000158816.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 73061659,
      stop : 73063337,
      direction : "+",
      ID : "ENSG00000255423.1",
      gene_id : "ENSG00000255423.1",
      gene_type : "protein_coding",
      gene_name : "EBLN2",
      gene_level : 2,
      hgnc_id : "HGNC:25493",
      havana_gene : "OTTHUMG00000165897.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 73382431,
      stop : 73624941,
      direction : "-",
      ID : "ENSG00000121440.15",
      gene_id : "ENSG00000121440.15",
      gene_type : "protein_coding",
      gene_name : "PDZRN3",
      gene_level : 1,
      hgnc_id : "HGNC:17704",
      havana_gene : "OTTHUMG00000158865.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 74262568,
      stop : 74521140,
      direction : "-",
      ID : "ENSG00000113805.8",
      gene_id : "ENSG00000113805.8",
      gene_type : "protein_coding",
      gene_name : "CNTN3",
      gene_level : 2,
      hgnc_id : "HGNC:2173",
      havana_gene : "OTTHUMG00000158813.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 75664330,
      stop : 75667220,
      direction : "+",
      ID : "ENSG00000172969.7",
      gene_id : "ENSG00000172969.7",
      gene_type : "protein_coding",
      gene_name : "FRG2C",
      gene_level : 1,
      hgnc_id : "HGNC:33626",
      havana_gene : "OTTHUMG00000158963.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 75678660,
      stop : 75785583,
      direction : "-",
      ID : "ENSG00000227124.11",
      gene_id : "ENSG00000227124.11",
      gene_type : "protein_coding",
      gene_name : "ZNF717",
      gene_level : 2,
      hgnc_id : "HGNC:29448",
      havana_gene : "OTTHUMG00000158965.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 75906695,
      stop : 77649964,
      direction : "+",
      ID : "ENSG00000185008.17",
      gene_id : "ENSG00000185008.17",
      gene_type : "protein_coding",
      gene_name : "ROBO2",
      gene_level : 1,
      hgnc_id : "HGNC:10250",
      havana_gene : "OTTHUMG00000158935.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 78597239,
      stop : 79767998,
      direction : "-",
      ID : "ENSG00000169855.20",
      gene_id : "ENSG00000169855.20",
      gene_type : "protein_coding",
      gene_name : "ROBO1",
      gene_level : 1,
      hgnc_id : "HGNC:10249",
      havana_gene : "OTTHUMG00000158843.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 81489703,
      stop : 81761645,
      direction : "-",
      ID : "ENSG00000114480.13",
      gene_id : "ENSG00000114480.13",
      gene_type : "protein_coding",
      gene_name : "GBE1",
      gene_level : 2,
      hgnc_id : "HGNC:4180",
      havana_gene : "OTTHUMG00000158978.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 84958989,
      stop : 86074429,
      direction : "+",
      ID : "ENSG00000175161.14",
      gene_id : "ENSG00000175161.14",
      gene_type : "protein_coding",
      gene_name : "CADM2",
      gene_level : 2,
      hgnc_id : "HGNC:29849",
      havana_gene : "OTTHUMG00000158990.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 86876388,
      stop : 86991149,
      direction : "-",
      ID : "ENSG00000206538.9",
      gene_id : "ENSG00000206538.9",
      gene_type : "protein_coding",
      gene_name : "VGLL3",
      gene_level : 2,
      hgnc_id : "HGNC:24327",
      havana_gene : "OTTHUMG00000158984.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 87227271,
      stop : 87255556,
      direction : "+",
      ID : "ENSG00000083937.10",
      gene_id : "ENSG00000083937.10",
      gene_type : "protein_coding",
      gene_name : "CHMP2B",
      gene_level : 1,
      hgnc_id : "HGNC:24537",
      havana_gene : "OTTHUMG00000158982.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 87259404,
      stop : 87276584,
      direction : "-",
      ID : "ENSG00000064835.11",
      gene_id : "ENSG00000064835.11",
      gene_type : "protein_coding",
      gene_name : "POU1F1",
      gene_level : 2,
      hgnc_id : "HGNC:9210",
      havana_gene : "OTTHUMG00000158992.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 87792706,
      stop : 87993839,
      direction : "+",
      ID : "ENSG00000179097.7",
      gene_id : "ENSG00000179097.7",
      gene_type : "protein_coding",
      gene_name : "HTR1F",
      gene_level : 2,
      hgnc_id : "HGNC:5292",
      havana_gene : "OTTHUMG00000159008.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 88051944,
      stop : 88149885,
      direction : "-",
      ID : "ENSG00000163320.12",
      gene_id : "ENSG00000163320.12",
      gene_type : "protein_coding",
      gene_name : "CGGBP1",
      gene_level : 2,
      hgnc_id : "HGNC:1888",
      havana_gene : "OTTHUMG00000159009.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 88058139,
      stop : 88058216,
      direction : "-",
      ID : "ENSG00000288654.1",
      gene_id : "ENSG00000288654.1",
      gene_type : "protein_coding",
      gene_name : "AC119733.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 88059255,
      stop : 88144660,
      direction : "+",
      ID : "ENSG00000175105.8",
      gene_id : "ENSG00000175105.8",
      gene_type : "protein_coding",
      gene_name : "ZNF654",
      gene_level : 2,
      hgnc_id : "HGNC:25612",
      havana_gene : "OTTHUMG00000159097.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 88149959,
      stop : 88168729,
      direction : "+",
      ID : "ENSG00000179021.10",
      gene_id : "ENSG00000179021.10",
      gene_type : "protein_coding",
      gene_name : "C3orf38",
      gene_level : 1,
      hgnc_id : "HGNC:28384",
      havana_gene : "OTTHUMG00000155752.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 88338416,
      stop : 88467594,
      direction : "+",
      ID : "ENSG00000283434.2",
      gene_id : "ENSG00000283434.2",
      gene_type : "protein_coding",
      gene_name : "CSNKA2IP",
      gene_level : 2,
      hgnc_id : "HGNC:53637",
      havana_gene : "OTTHUMG00000191768.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 89107621,
      stop : 89482134,
      direction : "+",
      ID : "ENSG00000044524.11",
      gene_id : "ENSG00000044524.11",
      gene_type : "protein_coding",
      gene_name : "EPHA3",
      gene_level : 2,
      hgnc_id : "HGNC:3387",
      havana_gene : "OTTHUMG00000159040.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 93873051,
      stop : 93980003,
      direction : "-",
      ID : "ENSG00000184500.16",
      gene_id : "ENSG00000184500.16",
      gene_type : "protein_coding",
      gene_name : "PROS1",
      gene_level : 1,
      hgnc_id : "HGNC:9456",
      havana_gene : "OTTHUMG00000150354.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 93980139,
      stop : 94055678,
      direction : "+",
      ID : "ENSG00000169379.17",
      gene_id : "ENSG00000169379.17",
      gene_type : "protein_coding",
      gene_name : "ARL13B",
      gene_level : 2,
      hgnc_id : "HGNC:25419",
      havana_gene : "OTTHUMG00000159012.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 94014365,
      stop : 94028597,
      direction : "-",
      ID : "ENSG00000178750.3",
      gene_id : "ENSG00000178750.3",
      gene_type : "protein_coding",
      gene_name : "STX19",
      gene_level : 2,
      hgnc_id : "HGNC:19300",
      havana_gene : "OTTHUMG00000159013.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 94047836,
      stop : 94063389,
      direction : "-",
      ID : "ENSG00000178700.9",
      gene_id : "ENSG00000178700.9",
      gene_type : "protein_coding",
      gene_name : "DHFR2",
      gene_level : 2,
      hgnc_id : "HGNC:27309",
      havana_gene : "OTTHUMG00000159014.4",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 94062980,
      stop : 94131832,
      direction : "+",
      ID : "ENSG00000178694.10",
      gene_id : "ENSG00000178694.10",
      gene_type : "protein_coding",
      gene_name : "NSUN3",
      gene_level : 2,
      hgnc_id : "HGNC:26208",
      havana_gene : "OTTHUMG00000159025.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 96617188,
      stop : 96618236,
      direction : "-",
      ID : "ENSG00000269028.3",
      gene_id : "ENSG00000269028.3",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L12",
      gene_level : 2,
      hgnc_id : "HGNC:37169",
      havana_gene : "OTTHUMG00000175726.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 96814581,
      stop : 97752460,
      direction : "+",
      ID : "ENSG00000080224.17",
      gene_id : "ENSG00000080224.17",
      gene_type : "protein_coding",
      gene_name : "EPHA6",
      gene_level : 1,
      hgnc_id : "HGNC:19296",
      havana_gene : "OTTHUMG00000159208.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 97764521,
      stop : 97801229,
      direction : "+",
      ID : "ENSG00000113966.10",
      gene_id : "ENSG00000113966.10",
      gene_type : "protein_coding",
      gene_name : "ARL6",
      gene_level : 1,
      hgnc_id : "HGNC:13210",
      havana_gene : "OTTHUMG00000159189.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 97822011,
      stop : 97944984,
      direction : "+",
      ID : "ENSG00000080200.10",
      gene_id : "ENSG00000080200.10",
      gene_type : "protein_coding",
      gene_name : "CRYBG3",
      gene_level : 2,
      hgnc_id : "HGNC:34427",
      havana_gene : "OTTHUMG00000159187.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 97941818,
      stop : 97972457,
      direction : "-",
      ID : "ENSG00000170854.18",
      gene_id : "ENSG00000170854.18",
      gene_type : "protein_coding",
      gene_name : "RIOX2",
      gene_level : 2,
      hgnc_id : "HGNC:19441",
      havana_gene : "OTTHUMG00000160107.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 97986673,
      stop : 98035304,
      direction : "-",
      ID : "ENSG00000183185.9",
      gene_id : "ENSG00000183185.9",
      gene_type : "protein_coding",
      gene_name : "GABRR3",
      gene_level : 2,
      hgnc_id : "HGNC:17969",
      havana_gene : "OTTHUMG00000159135.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98087173,
      stop : 98088102,
      direction : "+",
      ID : "ENSG00000196578.4",
      gene_id : "ENSG00000196578.4",
      gene_type : "protein_coding",
      gene_name : "OR5AC2",
      gene_level : 2,
      hgnc_id : "HGNC:15431",
      havana_gene : "OTTHUMG00000160083.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98130721,
      stop : 98138548,
      direction : "+",
      ID : "ENSG00000231192.2",
      gene_id : "ENSG00000231192.2",
      gene_type : "protein_coding",
      gene_name : "OR5H1",
      gene_level : 2,
      hgnc_id : "HGNC:8346",
      havana_gene : "OTTHUMG00000160070.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98147479,
      stop : 98156614,
      direction : "+",
      ID : "ENSG00000236032.3",
      gene_id : "ENSG00000236032.3",
      gene_type : "protein_coding",
      gene_name : "OR5H14",
      gene_level : 2,
      hgnc_id : "HGNC:31286",
      havana_gene : "OTTHUMG00000160079.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98166696,
      stop : 98169774,
      direction : "+",
      ID : "ENSG00000233412.5",
      gene_id : "ENSG00000233412.5",
      gene_type : "protein_coding",
      gene_name : "OR5H15",
      gene_level : 2,
      hgnc_id : "HGNC:31287",
      havana_gene : "OTTHUMG00000160076.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98263252,
      stop : 98265356,
      direction : "+",
      ID : "ENSG00000230301.6",
      gene_id : "ENSG00000230301.6",
      gene_type : "protein_coding",
      gene_name : "OR5H6",
      gene_level : 2,
      hgnc_id : "HGNC:14767",
      havana_gene : "OTTHUMG00000160078.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98282888,
      stop : 98283832,
      direction : "+",
      ID : "ENSG00000197938.5",
      gene_id : "ENSG00000197938.5",
      gene_type : "protein_coding",
      gene_name : "OR5H2",
      gene_level : 2,
      hgnc_id : "HGNC:14752",
      havana_gene : "OTTHUMG00000160080.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98353854,
      stop : 98354819,
      direction : "+",
      ID : "ENSG00000196098.2",
      gene_id : "ENSG00000196098.2",
      gene_type : "protein_coding",
      gene_name : "OR5K4",
      gene_level : 2,
      hgnc_id : "HGNC:31291",
      havana_gene : "OTTHUMG00000160081.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98390666,
      stop : 98391631,
      direction : "+",
      ID : "ENSG00000206536.1",
      gene_id : "ENSG00000206536.1",
      gene_type : "protein_coding",
      gene_name : "OR5K3",
      gene_level : 2,
      hgnc_id : "HGNC:31290",
      havana_gene : "OTTHUMG00000160077.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98463201,
      stop : 98472924,
      direction : "+",
      ID : "ENSG00000232382.2",
      gene_id : "ENSG00000232382.2",
      gene_type : "protein_coding",
      gene_name : "OR5K1",
      gene_level : 2,
      hgnc_id : "HGNC:8349",
      havana_gene : "OTTHUMG00000160048.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98497604,
      stop : 98498663,
      direction : "+",
      ID : "ENSG00000231861.2",
      gene_id : "ENSG00000231861.2",
      gene_type : "protein_coding",
      gene_name : "OR5K2",
      gene_level : 2,
      hgnc_id : "HGNC:14774",
      havana_gene : "OTTHUMG00000160049.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98497912,
      stop : 98523066,
      direction : "-",
      ID : "ENSG00000080822.17",
      gene_id : "ENSG00000080822.17",
      gene_type : "protein_coding",
      gene_name : "CLDND1",
      gene_level : 1,
      hgnc_id : "HGNC:1322",
      havana_gene : "OTTHUMG00000160050.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98521133,
      stop : 98585498,
      direction : "-",
      ID : "ENSG00000285635.1",
      gene_id : "ENSG00000285635.1",
      gene_type : "protein_coding",
      gene_name : "AC021660.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160016.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98531978,
      stop : 98534681,
      direction : "+",
      ID : "ENSG00000154165.5",
      gene_id : "ENSG00000154165.5",
      gene_type : "protein_coding",
      gene_name : "GPR15",
      gene_level : 2,
      hgnc_id : "HGNC:4469",
      havana_gene : "OTTHUMG00000160017.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98579446,
      stop : 98593648,
      direction : "-",
      ID : "ENSG00000080819.9",
      gene_id : "ENSG00000080819.9",
      gene_type : "protein_coding",
      gene_name : "CPOX",
      gene_level : 2,
      hgnc_id : "HGNC:2321",
      havana_gene : "OTTHUMG00000193356.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98732236,
      stop : 98821201,
      direction : "+",
      ID : "ENSG00000064225.12",
      gene_id : "ENSG00000064225.12",
      gene_type : "protein_coding",
      gene_name : "ST3GAL6",
      gene_level : 1,
      hgnc_id : "HGNC:18080",
      havana_gene : "OTTHUMG00000159047.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 98795941,
      stop : 98901695,
      direction : "-",
      ID : "ENSG00000057019.16",
      gene_id : "ENSG00000057019.16",
      gene_type : "protein_coding",
      gene_name : "DCBLD2",
      gene_level : 1,
      hgnc_id : "HGNC:24627",
      havana_gene : "OTTHUMG00000151985.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 99638475,
      stop : 99799226,
      direction : "+",
      ID : "ENSG00000144810.16",
      gene_id : "ENSG00000144810.16",
      gene_type : "protein_coding",
      gene_name : "COL8A1",
      gene_level : 2,
      hgnc_id : "HGNC:2215",
      havana_gene : "OTTHUMG00000148669.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 99817837,
      stop : 100181732,
      direction : "+",
      ID : "ENSG00000184220.12",
      gene_id : "ENSG00000184220.12",
      gene_type : "protein_coding",
      gene_name : "CMSS1",
      gene_level : 1,
      hgnc_id : "HGNC:28666",
      havana_gene : "OTTHUMG00000159054.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 99830141,
      stop : 100114513,
      direction : "-",
      ID : "ENSG00000168386.18",
      gene_id : "ENSG00000168386.18",
      gene_type : "protein_coding",
      gene_name : "FILIP1L",
      gene_level : 1,
      hgnc_id : "HGNC:24589",
      havana_gene : "OTTHUMG00000159055.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100260992,
      stop : 100325251,
      direction : "+",
      ID : "ENSG00000036054.13",
      gene_id : "ENSG00000036054.13",
      gene_type : "protein_coding",
      gene_name : "TBC1D23",
      gene_level : 1,
      hgnc_id : "HGNC:25622",
      havana_gene : "OTTHUMG00000159067.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100334739,
      stop : 100361635,
      direction : "+",
      ID : "ENSG00000114021.12",
      gene_id : "ENSG00000114021.12",
      gene_type : "protein_coding",
      gene_name : "NIT2",
      gene_level : 2,
      hgnc_id : "HGNC:29878",
      havana_gene : "OTTHUMG00000159066.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100363431,
      stop : 100401089,
      direction : "-",
      ID : "ENSG00000154174.8",
      gene_id : "ENSG00000154174.8",
      gene_type : "protein_coding",
      gene_name : "TOMM70",
      gene_level : 2,
      hgnc_id : "HGNC:11985",
      havana_gene : "OTTHUMG00000159065.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100401532,
      stop : 100456319,
      direction : "+",
      ID : "ENSG00000206535.8",
      gene_id : "ENSG00000206535.8",
      gene_type : "protein_coding",
      gene_name : "LNP1",
      gene_level : 1,
      hgnc_id : "HGNC:28014",
      havana_gene : "OTTHUMG00000159082.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100492619,
      stop : 100577444,
      direction : "+",
      ID : "ENSG00000181458.10",
      gene_id : "ENSG00000181458.10",
      gene_type : "protein_coding",
      gene_name : "TMEM45A",
      gene_level : 1,
      hgnc_id : "HGNC:25480",
      havana_gene : "OTTHUMG00000150327.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100609601,
      stop : 100695479,
      direction : "+",
      ID : "ENSG00000144820.8",
      gene_id : "ENSG00000144820.8",
      gene_type : "protein_coding",
      gene_name : "ADGRG7",
      gene_level : 1,
      hgnc_id : "HGNC:19241",
      havana_gene : "OTTHUMG00000159083.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100709295,
      stop : 100748964,
      direction : "+",
      ID : "ENSG00000114354.15",
      gene_id : "ENSG00000114354.15",
      gene_type : "protein_coding",
      gene_name : "TFG",
      gene_level : 2,
      hgnc_id : "HGNC:11758",
      havana_gene : "OTTHUMG00000159085.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 100749156,
      stop : 100993515,
      direction : "-",
      ID : "ENSG00000154175.18",
      gene_id : "ENSG00000154175.18",
      gene_type : "protein_coding",
      gene_name : "ABI3BP",
      gene_level : 2,
      hgnc_id : "HGNC:17265",
      havana_gene : "OTTHUMG00000159094.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101222546,
      stop : 101320575,
      direction : "-",
      ID : "ENSG00000081148.12",
      gene_id : "ENSG00000081148.12",
      gene_type : "protein_coding",
      gene_name : "IMPG2",
      gene_level : 2,
      hgnc_id : "HGNC:18362",
      havana_gene : "OTTHUMG00000159091.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101324205,
      stop : 101513241,
      direction : "-",
      ID : "ENSG00000138468.16",
      gene_id : "ENSG00000138468.16",
      gene_type : "protein_coding",
      gene_name : "SENP7",
      gene_level : 2,
      hgnc_id : "HGNC:30402",
      havana_gene : "OTTHUMG00000149927.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101561868,
      stop : 101566446,
      direction : "+",
      ID : "ENSG00000174173.7",
      gene_id : "ENSG00000174173.7",
      gene_type : "protein_coding",
      gene_name : "TRMT10C",
      gene_level : 2,
      hgnc_id : "HGNC:26022",
      havana_gene : "OTTHUMG00000159114.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101574180,
      stop : 101594465,
      direction : "+",
      ID : "ENSG00000081154.12",
      gene_id : "ENSG00000081154.12",
      gene_type : "protein_coding",
      gene_name : "PCNP",
      gene_level : 2,
      hgnc_id : "HGNC:30023",
      havana_gene : "OTTHUMG00000159108.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101648889,
      stop : 101677132,
      direction : "-",
      ID : "ENSG00000066422.5",
      gene_id : "ENSG00000066422.5",
      gene_type : "protein_coding",
      gene_name : "ZBTB11",
      gene_level : 2,
      hgnc_id : "HGNC:16740",
      havana_gene : "OTTHUMG00000159133.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101681091,
      stop : 101686718,
      direction : "-",
      ID : "ENSG00000114391.13",
      gene_id : "ENSG00000114391.13",
      gene_type : "protein_coding",
      gene_name : "RPL24",
      gene_level : 2,
      hgnc_id : "HGNC:10325",
      havana_gene : "OTTHUMG00000159146.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101724593,
      stop : 101770562,
      direction : "+",
      ID : "ENSG00000182504.11",
      gene_id : "ENSG00000182504.11",
      gene_type : "protein_coding",
      gene_name : "CEP97",
      gene_level : 1,
      hgnc_id : "HGNC:26244",
      havana_gene : "OTTHUMG00000159162.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101779202,
      stop : 101828231,
      direction : "+",
      ID : "ENSG00000144815.16",
      gene_id : "ENSG00000144815.16",
      gene_type : "protein_coding",
      gene_name : "NXPE3",
      gene_level : 2,
      hgnc_id : "HGNC:28238",
      havana_gene : "OTTHUMG00000159179.16",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 101827991,
      stop : 101861022,
      direction : "+",
      ID : "ENSG00000144802.11",
      gene_id : "ENSG00000144802.11",
      gene_type : "protein_coding",
      gene_name : "NFKBIZ",
      gene_level : 1,
      hgnc_id : "HGNC:29805",
      havana_gene : "OTTHUMG00000159194.18",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 102099244,
      stop : 102479841,
      direction : "+",
      ID : "ENSG00000170044.8",
      gene_id : "ENSG00000170044.8",
      gene_type : "protein_coding",
      gene_name : "ZPLD1",
      gene_level : 2,
      hgnc_id : "HGNC:27022",
      havana_gene : "OTTHUMG00000159229.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 105366909,
      stop : 105576900,
      direction : "+",
      ID : "ENSG00000170017.12",
      gene_id : "ENSG00000170017.12",
      gene_type : "protein_coding",
      gene_name : "ALCAM",
      gene_level : 1,
      hgnc_id : "HGNC:400",
      havana_gene : "OTTHUMG00000159192.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 105655461,
      stop : 105869552,
      direction : "-",
      ID : "ENSG00000114423.23",
      gene_id : "ENSG00000114423.23",
      gene_type : "protein_coding",
      gene_name : "CBLB",
      gene_level : 1,
      hgnc_id : "HGNC:1542",
      havana_gene : "OTTHUMG00000150654.18",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 107377439,
      stop : 107378635,
      direction : "+",
      ID : "ENSG00000138483.3",
      gene_id : "ENSG00000138483.3",
      gene_type : "protein_coding",
      gene_name : "CCDC54",
      gene_level : 2,
      hgnc_id : "HGNC:30703",
      havana_gene : "OTTHUMG00000159169.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 107522936,
      stop : 107811339,
      direction : "+",
      ID : "ENSG00000114439.19",
      gene_id : "ENSG00000114439.19",
      gene_type : "protein_coding",
      gene_name : "BBX",
      gene_level : 1,
      hgnc_id : "HGNC:14422",
      havana_gene : "OTTHUMG00000150360.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108043091,
      stop : 108091862,
      direction : "-",
      ID : "ENSG00000196776.17",
      gene_id : "ENSG00000196776.17",
      gene_type : "protein_coding",
      gene_name : "CD47",
      gene_level : 2,
      hgnc_id : "HGNC:1682",
      havana_gene : "OTTHUMG00000044216.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108160812,
      stop : 108222435,
      direction : "-",
      ID : "ENSG00000114446.5",
      gene_id : "ENSG00000114446.5",
      gene_type : "protein_coding",
      gene_name : "IFT57",
      gene_level : 1,
      hgnc_id : "HGNC:17367",
      havana_gene : "OTTHUMG00000159223.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108296490,
      stop : 108378285,
      direction : "+",
      ID : "ENSG00000114455.13",
      gene_id : "ENSG00000114455.13",
      gene_type : "protein_coding",
      gene_name : "HHLA2",
      gene_level : 1,
      hgnc_id : "HGNC:4905",
      havana_gene : "OTTHUMG00000159224.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108380368,
      stop : 108529322,
      direction : "-",
      ID : "ENSG00000144821.10",
      gene_id : "ENSG00000144821.10",
      gene_type : "protein_coding",
      gene_name : "MYH15",
      gene_level : 2,
      hgnc_id : "HGNC:31073",
      havana_gene : "OTTHUMG00000159226.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108549864,
      stop : 108589644,
      direction : "-",
      ID : "ENSG00000163507.14",
      gene_id : "ENSG00000163507.14",
      gene_type : "protein_coding",
      gene_name : "CIP2A",
      gene_level : 2,
      hgnc_id : "HGNC:29302",
      havana_gene : "OTTHUMG00000159233.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108589705,
      stop : 108694840,
      direction : "+",
      ID : "ENSG00000198919.13",
      gene_id : "ENSG00000198919.13",
      gene_type : "protein_coding",
      gene_name : "DZIP3",
      gene_level : 2,
      hgnc_id : "HGNC:30938",
      havana_gene : "OTTHUMG00000159232.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108743424,
      stop : 108757384,
      direction : "-",
      ID : "ENSG00000163515.6",
      gene_id : "ENSG00000163515.6",
      gene_type : "protein_coding",
      gene_name : "RETNLB",
      gene_level : 2,
      hgnc_id : "HGNC:20388",
      havana_gene : "OTTHUMG00000159393.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108822770,
      stop : 108855005,
      direction : "+",
      ID : "ENSG00000163519.14",
      gene_id : "ENSG00000163519.14",
      gene_type : "protein_coding",
      gene_name : "TRAT1",
      gene_level : 1,
      hgnc_id : "HGNC:30698",
      havana_gene : "OTTHUMG00000159198.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108907792,
      stop : 108953879,
      direction : "-",
      ID : "ENSG00000138472.11",
      gene_id : "ENSG00000138472.11",
      gene_type : "protein_coding",
      gene_name : "GUCA1C",
      gene_level : 2,
      hgnc_id : "HGNC:4680",
      havana_gene : "OTTHUMG00000159204.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 108958248,
      stop : 109118134,
      direction : "-",
      ID : "ENSG00000114487.10",
      gene_id : "ENSG00000114487.10",
      gene_type : "protein_coding",
      gene_name : "MORC1",
      gene_level : 1,
      hgnc_id : "HGNC:7198",
      havana_gene : "OTTHUMG00000159209.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 109118252,
      stop : 109151401,
      direction : "+",
      ID : "ENSG00000241224.8",
      gene_id : "ENSG00000241224.8",
      gene_type : "protein_coding",
      gene_name : "C3orf85",
      gene_level : 2,
      hgnc_id : "HGNC:53432",
      havana_gene : "OTTHUMG00000159205.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 109293788,
      stop : 109316517,
      direction : "-",
      ID : "ENSG00000163530.4",
      gene_id : "ENSG00000163530.4",
      gene_type : "protein_coding",
      gene_name : "DPPA2",
      gene_level : 2,
      hgnc_id : "HGNC:19197",
      havana_gene : "OTTHUMG00000159227.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 109326141,
      stop : 109337572,
      direction : "-",
      ID : "ENSG00000121570.12",
      gene_id : "ENSG00000121570.12",
      gene_type : "protein_coding",
      gene_name : "DPPA4",
      gene_level : 1,
      hgnc_id : "HGNC:19200",
      havana_gene : "OTTHUMG00000159222.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111070071,
      stop : 111275563,
      direction : "+",
      ID : "ENSG00000177707.11",
      gene_id : "ENSG00000177707.11",
      gene_type : "protein_coding",
      gene_name : "NECTIN3",
      gene_level : 1,
      hgnc_id : "HGNC:17664",
      havana_gene : "OTTHUMG00000159239.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111292719,
      stop : 111665750,
      direction : "+",
      ID : "ENSG00000153283.13",
      gene_id : "ENSG00000153283.13",
      gene_type : "protein_coding",
      gene_name : "CD96",
      gene_level : 2,
      hgnc_id : "HGNC:16892",
      havana_gene : "OTTHUMG00000159275.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111592900,
      stop : 111595346,
      direction : "-",
      ID : "ENSG00000177494.6",
      gene_id : "ENSG00000177494.6",
      gene_type : "protein_coding",
      gene_name : "ZBED2",
      gene_level : 2,
      hgnc_id : "HGNC:20710",
      havana_gene : "OTTHUMG00000074061.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111674676,
      stop : 111846447,
      direction : "+",
      ID : "ENSG00000240891.8",
      gene_id : "ENSG00000240891.8",
      gene_type : "protein_coding",
      gene_name : "PLCXD2",
      gene_level : 1,
      hgnc_id : "HGNC:26462",
      havana_gene : "OTTHUMG00000159279.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111732497,
      stop : 111976517,
      direction : "+",
      ID : "ENSG00000144824.21",
      gene_id : "ENSG00000144824.21",
      gene_type : "protein_coding",
      gene_name : "PHLDB2",
      gene_level : 1,
      hgnc_id : "HGNC:29573",
      havana_gene : "OTTHUMG00000159282.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111979010,
      stop : 111993368,
      direction : "+",
      ID : "ENSG00000144827.9",
      gene_id : "ENSG00000144827.9",
      gene_type : "protein_coding",
      gene_name : "ABHD10",
      gene_level : 2,
      hgnc_id : "HGNC:25656",
      havana_gene : "OTTHUMG00000159280.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 111998739,
      stop : 112013887,
      direction : "+",
      ID : "ENSG00000144834.14",
      gene_id : "ENSG00000144834.14",
      gene_type : "protein_coding",
      gene_name : "TAGLN3",
      gene_level : 1,
      hgnc_id : "HGNC:29868",
      havana_gene : "OTTHUMG00000159281.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112034843,
      stop : 112081269,
      direction : "+",
      ID : "ENSG00000176040.13",
      gene_id : "ENSG00000176040.13",
      gene_type : "protein_coding",
      gene_name : "TMPRSS7",
      gene_level : 1,
      hgnc_id : "HGNC:30846",
      havana_gene : "OTTHUMG00000157148.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112086335,
      stop : 112131004,
      direction : "+",
      ID : "ENSG00000114529.13",
      gene_id : "ENSG00000114529.13",
      gene_type : "protein_coding",
      gene_name : "C3orf52",
      gene_level : 2,
      hgnc_id : "HGNC:26255",
      havana_gene : "OTTHUMG00000159230.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112120839,
      stop : 112133270,
      direction : "-",
      ID : "ENSG00000174500.13",
      gene_id : "ENSG00000174500.13",
      gene_type : "protein_coding",
      gene_name : "GCSAM",
      gene_level : 1,
      hgnc_id : "HGNC:20253",
      havana_gene : "OTTHUMG00000159231.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112140898,
      stop : 112294227,
      direction : "-",
      ID : "ENSG00000172139.15",
      gene_id : "ENSG00000172139.15",
      gene_type : "protein_coding",
      gene_name : "SLC9C1",
      gene_level : 2,
      hgnc_id : "HGNC:31401",
      havana_gene : "OTTHUMG00000159245.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112332347,
      stop : 112362812,
      direction : "+",
      ID : "ENSG00000091972.18",
      gene_id : "ENSG00000091972.18",
      gene_type : "protein_coding",
      gene_name : "CD200",
      gene_level : 1,
      hgnc_id : "HGNC:7203",
      havana_gene : "OTTHUMG00000159248.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112463966,
      stop : 112499472,
      direction : "-",
      ID : "ENSG00000186265.10",
      gene_id : "ENSG00000186265.10",
      gene_type : "protein_coding",
      gene_name : "BTLA",
      gene_level : 2,
      hgnc_id : "HGNC:21087",
      havana_gene : "OTTHUMG00000159255.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112532510,
      stop : 112562046,
      direction : "-",
      ID : "ENSG00000144848.11",
      gene_id : "ENSG00000144848.11",
      gene_type : "protein_coding",
      gene_name : "ATG3",
      gene_level : 2,
      hgnc_id : "HGNC:20962",
      havana_gene : "OTTHUMG00000159260.22",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112561709,
      stop : 112585579,
      direction : "+",
      ID : "ENSG00000138459.9",
      gene_id : "ENSG00000138459.9",
      gene_type : "protein_coding",
      gene_name : "SLC35A5",
      gene_level : 2,
      hgnc_id : "HGNC:20792",
      havana_gene : "OTTHUMG00000159263.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112596797,
      stop : 112649530,
      direction : "-",
      ID : "ENSG00000091986.16",
      gene_id : "ENSG00000091986.16",
      gene_type : "protein_coding",
      gene_name : "CCDC80",
      gene_level : 1,
      hgnc_id : "HGNC:30649",
      havana_gene : "OTTHUMG00000159265.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112815709,
      stop : 112846856,
      direction : "-",
      ID : "ENSG00000206531.10",
      gene_id : "ENSG00000206531.10",
      gene_type : "protein_coding",
      gene_name : "CD200R1L",
      gene_level : 1,
      hgnc_id : "HGNC:24665",
      havana_gene : "OTTHUMG00000159283.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112921205,
      stop : 112975103,
      direction : "-",
      ID : "ENSG00000163606.11",
      gene_id : "ENSG00000163606.11",
      gene_type : "protein_coding",
      gene_name : "CD200R1",
      gene_level : 2,
      hgnc_id : "HGNC:24235",
      havana_gene : "OTTHUMG00000159298.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 112990984,
      stop : 113015060,
      direction : "+",
      ID : "ENSG00000163607.17",
      gene_id : "ENSG00000163607.17",
      gene_type : "protein_coding",
      gene_name : "GTPBP8",
      gene_level : 1,
      hgnc_id : "HGNC:25007",
      havana_gene : "OTTHUMG00000159268.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113002444,
      stop : 113019861,
      direction : "-",
      ID : "ENSG00000163608.15",
      gene_id : "ENSG00000163608.15",
      gene_type : "protein_coding",
      gene_name : "NEPRO",
      gene_level : 1,
      hgnc_id : "HGNC:24496",
      havana_gene : "OTTHUMG00000159286.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113211003,
      stop : 113287459,
      direction : "+",
      ID : "ENSG00000144857.14",
      gene_id : "ENSG00000144857.14",
      gene_type : "protein_coding",
      gene_name : "BOC",
      gene_level : 1,
      hgnc_id : "HGNC:17173",
      havana_gene : "OTTHUMG00000159305.22",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113286930,
      stop : 113441610,
      direction : "-",
      ID : "ENSG00000206530.11",
      gene_id : "ENSG00000206530.11",
      gene_type : "protein_coding",
      gene_name : "CFAP44",
      gene_level : 2,
      hgnc_id : "HGNC:25631",
      havana_gene : "OTTHUMG00000193413.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113361901,
      stop : 113515151,
      direction : "-",
      ID : "ENSG00000285943.1",
      gene_id : "ENSG00000285943.1",
      gene_type : "protein_coding",
      gene_name : "AC112128.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000159259.28",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113442718,
      stop : 113515187,
      direction : "-",
      ID : "ENSG00000163611.11",
      gene_id : "ENSG00000163611.11",
      gene_type : "protein_coding",
      gene_name : "SPICE1",
      gene_level : 2,
      hgnc_id : "HGNC:25083",
      havana_gene : "OTTHUMG00000159261.17",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113532555,
      stop : 113629575,
      direction : "+",
      ID : "ENSG00000072858.11",
      gene_id : "ENSG00000072858.11",
      gene_type : "protein_coding",
      gene_name : "SIDT1",
      gene_level : 2,
      hgnc_id : "HGNC:25967",
      havana_gene : "OTTHUMG00000159299.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113648385,
      stop : 113696646,
      direction : "-",
      ID : "ENSG00000176542.10",
      gene_id : "ENSG00000176542.10",
      gene_type : "protein_coding",
      gene_name : "USF3",
      gene_level : 1,
      hgnc_id : "HGNC:30494",
      havana_gene : "OTTHUMG00000159322.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113716458,
      stop : 113746300,
      direction : "-",
      ID : "ENSG00000121579.13",
      gene_id : "ENSG00000121579.13",
      gene_type : "protein_coding",
      gene_name : "NAA50",
      gene_level : 2,
      hgnc_id : "HGNC:29533",
      havana_gene : "OTTHUMG00000159294.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113747033,
      stop : 113812056,
      direction : "+",
      ID : "ENSG00000114573.10",
      gene_id : "ENSG00000114573.10",
      gene_type : "protein_coding",
      gene_name : "ATP6V1A",
      gene_level : 2,
      hgnc_id : "HGNC:851",
      havana_gene : "OTTHUMG00000159295.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113828182,
      stop : 113947174,
      direction : "+",
      ID : "ENSG00000178075.20",
      gene_id : "ENSG00000178075.20",
      gene_type : "protein_coding",
      gene_name : "GRAMD1C",
      gene_level : 1,
      hgnc_id : "HGNC:25252",
      havana_gene : "OTTHUMG00000159340.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113947901,
      stop : 113965401,
      direction : "+",
      ID : "ENSG00000184307.16",
      gene_id : "ENSG00000184307.16",
      gene_type : "protein_coding",
      gene_name : "ZDHHC23",
      gene_level : 1,
      hgnc_id : "HGNC:28654",
      havana_gene : "OTTHUMG00000159335.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 113964137,
      stop : 114056594,
      direction : "-",
      ID : "ENSG00000163617.11",
      gene_id : "ENSG00000163617.11",
      gene_type : "protein_coding",
      gene_name : "CCDC191",
      gene_level : 2,
      hgnc_id : "HGNC:29272",
      havana_gene : "OTTHUMG00000159337.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 114005833,
      stop : 114088422,
      direction : "+",
      ID : "ENSG00000151576.10",
      gene_id : "ENSG00000151576.10",
      gene_type : "protein_coding",
      gene_name : "QTRT2",
      gene_level : 1,
      hgnc_id : "HGNC:25771",
      havana_gene : "OTTHUMG00000159336.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 114127580,
      stop : 114199407,
      direction : "-",
      ID : "ENSG00000151577.13",
      gene_id : "ENSG00000151577.13",
      gene_type : "protein_coding",
      gene_name : "DRD3",
      gene_level : 2,
      hgnc_id : "HGNC:3024",
      havana_gene : "OTTHUMG00000159334.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 114234631,
      stop : 114237578,
      direction : "-",
      ID : "ENSG00000174255.8",
      gene_id : "ENSG00000174255.8",
      gene_type : "protein_coding",
      gene_name : "ZNF80",
      gene_level : 2,
      hgnc_id : "HGNC:13155",
      havana_gene : "OTTHUMG00000159332.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 114276913,
      stop : 114310288,
      direction : "+",
      ID : "ENSG00000181847.12",
      gene_id : "ENSG00000181847.12",
      gene_type : "protein_coding",
      gene_name : "TIGIT",
      gene_level : 2,
      hgnc_id : "HGNC:26838",
      havana_gene : "OTTHUMG00000159331.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 114314500,
      stop : 115147288,
      direction : "-",
      ID : "ENSG00000181722.17",
      gene_id : "ENSG00000181722.17",
      gene_type : "protein_coding",
      gene_name : "ZBTB20",
      gene_level : 1,
      hgnc_id : "HGNC:13503",
      havana_gene : "OTTHUMG00000159366.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 115623510,
      stop : 115721490,
      direction : "+",
      ID : "ENSG00000172020.13",
      gene_id : "ENSG00000172020.13",
      gene_type : "protein_coding",
      gene_name : "GAP43",
      gene_level : 1,
      hgnc_id : "HGNC:4140",
      havana_gene : "OTTHUMG00000133758.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 115802363,
      stop : 117139389,
      direction : "-",
      ID : "ENSG00000185565.12",
      gene_id : "ENSG00000185565.12",
      gene_type : "protein_coding",
      gene_name : "LSAMP",
      gene_level : 2,
      hgnc_id : "HGNC:6705",
      havana_gene : "OTTHUMG00000159308.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 118900557,
      stop : 119146068,
      direction : "-",
      ID : "ENSG00000144847.13",
      gene_id : "ENSG00000144847.13",
      gene_type : "protein_coding",
      gene_name : "IGSF11",
      gene_level : 1,
      hgnc_id : "HGNC:16669",
      havana_gene : "OTTHUMG00000159387.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119146151,
      stop : 119160042,
      direction : "+",
      ID : "ENSG00000163424.9",
      gene_id : "ENSG00000163424.9",
      gene_type : "protein_coding",
      gene_name : "TEX55",
      gene_level : 1,
      hgnc_id : "HGNC:26553",
      havana_gene : "OTTHUMG00000159349.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119147375,
      stop : 119187807,
      direction : "+",
      ID : "ENSG00000251012.2",
      gene_id : "ENSG00000251012.2",
      gene_type : "protein_coding",
      gene_name : "AC083800.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160109.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119173517,
      stop : 119205143,
      direction : "+",
      ID : "ENSG00000114638.8",
      gene_id : "ENSG00000114638.8",
      gene_type : "protein_coding",
      gene_name : "UPK1B",
      gene_level : 1,
      hgnc_id : "HGNC:12578",
      havana_gene : "OTTHUMG00000159354.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119211732,
      stop : 119240946,
      direction : "-",
      ID : "ENSG00000121578.13",
      gene_id : "ENSG00000121578.13",
      gene_type : "protein_coding",
      gene_name : "B4GALT4",
      gene_level : 1,
      hgnc_id : "HGNC:927",
      havana_gene : "OTTHUMG00000159358.17",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119294383,
      stop : 119420714,
      direction : "+",
      ID : "ENSG00000031081.11",
      gene_id : "ENSG00000031081.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP31",
      gene_level : 2,
      hgnc_id : "HGNC:29216",
      havana_gene : "OTTHUMG00000159362.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119428949,
      stop : 119468830,
      direction : "-",
      ID : "ENSG00000176142.13",
      gene_id : "ENSG00000176142.13",
      gene_type : "protein_coding",
      gene_name : "TMEM39A",
      gene_level : 1,
      hgnc_id : "HGNC:25600",
      havana_gene : "OTTHUMG00000159361.31",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119468963,
      stop : 119494708,
      direction : "+",
      ID : "ENSG00000163389.12",
      gene_id : "ENSG00000163389.12",
      gene_type : "protein_coding",
      gene_name : "POGLUT1",
      gene_level : 2,
      hgnc_id : "HGNC:22954",
      havana_gene : "OTTHUMG00000159379.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119498547,
      stop : 119525090,
      direction : "+",
      ID : "ENSG00000113845.10",
      gene_id : "ENSG00000113845.10",
      gene_type : "protein_coding",
      gene_name : "TIMMDC1",
      gene_level : 1,
      hgnc_id : "HGNC:1321",
      havana_gene : "OTTHUMG00000159388.15",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119524293,
      stop : 119559614,
      direction : "-",
      ID : "ENSG00000121594.12",
      gene_id : "ENSG00000121594.12",
      gene_type : "protein_coding",
      gene_name : "CD80",
      gene_level : 2,
      hgnc_id : "HGNC:1700",
      havana_gene : "OTTHUMG00000159419.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119579268,
      stop : 119589945,
      direction : "+",
      ID : "ENSG00000144843.11",
      gene_id : "ENSG00000144843.11",
      gene_type : "protein_coding",
      gene_name : "ADPRH",
      gene_level : 2,
      hgnc_id : "HGNC:269",
      havana_gene : "OTTHUMG00000159420.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119597875,
      stop : 119629811,
      direction : "+",
      ID : "ENSG00000144837.9",
      gene_id : "ENSG00000144837.9",
      gene_type : "protein_coding",
      gene_name : "PLA1A",
      gene_level : 1,
      hgnc_id : "HGNC:17661",
      havana_gene : "OTTHUMG00000159425.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119636457,
      stop : 119665324,
      direction : "-",
      ID : "ENSG00000121577.14",
      gene_id : "ENSG00000121577.14",
      gene_type : "protein_coding",
      gene_name : "POPDC2",
      gene_level : 1,
      hgnc_id : "HGNC:17648",
      havana_gene : "OTTHUMG00000159438.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119654513,
      stop : 119677454,
      direction : "-",
      ID : "ENSG00000138495.7",
      gene_id : "ENSG00000138495.7",
      gene_type : "protein_coding",
      gene_name : "COX17",
      gene_level : 1,
      hgnc_id : "HGNC:2264",
      havana_gene : "OTTHUMG00000159433.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119703022,
      stop : 119767102,
      direction : "+",
      ID : "ENSG00000183833.16",
      gene_id : "ENSG00000183833.16",
      gene_type : "protein_coding",
      gene_name : "CFAP91",
      gene_level : 2,
      hgnc_id : "HGNC:24010",
      havana_gene : "OTTHUMG00000193414.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119703076,
      stop : 119807570,
      direction : "+",
      ID : "ENSG00000285585.1",
      gene_id : "ENSG00000285585.1",
      gene_type : "protein_coding",
      gene_name : "AC069444.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000159422.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119780484,
      stop : 119818487,
      direction : "+",
      ID : "ENSG00000144852.20",
      gene_id : "ENSG00000144852.20",
      gene_type : "protein_coding",
      gene_name : "NR1I2",
      gene_level : 2,
      hgnc_id : "HGNC:7968",
      havana_gene : "OTTHUMG00000159400.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 119821321,
      stop : 120094994,
      direction : "-",
      ID : "ENSG00000082701.17",
      gene_id : "ENSG00000082701.17",
      gene_type : "protein_coding",
      gene_name : "GSK3B",
      gene_level : 2,
      hgnc_id : "HGNC:4617",
      havana_gene : "OTTHUMG00000133765.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120164645,
      stop : 120285222,
      direction : "-",
      ID : "ENSG00000175697.11",
      gene_id : "ENSG00000175697.11",
      gene_type : "protein_coding",
      gene_name : "GPR156",
      gene_level : 2,
      hgnc_id : "HGNC:20844",
      havana_gene : "OTTHUMG00000159406.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120324509,
      stop : 120349354,
      direction : "-",
      ID : "ENSG00000163428.4",
      gene_id : "ENSG00000163428.4",
      gene_type : "protein_coding",
      gene_name : "LRRC58",
      gene_level : 2,
      hgnc_id : "HGNC:26968",
      havana_gene : "OTTHUMG00000159407.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120392293,
      stop : 120450993,
      direction : "-",
      ID : "ENSG00000163430.12",
      gene_id : "ENSG00000163430.12",
      gene_type : "protein_coding",
      gene_name : "FSTL1",
      gene_level : 2,
      hgnc_id : "HGNC:3972",
      havana_gene : "OTTHUMG00000159440.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120596328,
      stop : 120602507,
      direction : "+",
      ID : "ENSG00000065518.8",
      gene_id : "ENSG00000065518.8",
      gene_type : "protein_coding",
      gene_name : "NDUFB4",
      gene_level : 2,
      hgnc_id : "HGNC:7699",
      havana_gene : "OTTHUMG00000159442.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120628172,
      stop : 120682269,
      direction : "-",
      ID : "ENSG00000113924.12",
      gene_id : "ENSG00000113924.12",
      gene_type : "protein_coding",
      gene_name : "HGD",
      gene_level : 1,
      hgnc_id : "HGNC:4892",
      havana_gene : "OTTHUMG00000159441.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120684938,
      stop : 120742993,
      direction : "-",
      ID : "ENSG00000144840.10",
      gene_id : "ENSG00000144840.10",
      gene_type : "protein_coding",
      gene_name : "RABL3",
      gene_level : 2,
      hgnc_id : "HGNC:18072",
      havana_gene : "OTTHUMG00000159668.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120742637,
      stop : 120783069,
      direction : "+",
      ID : "ENSG00000153767.10",
      gene_id : "ENSG00000153767.10",
      gene_type : "protein_coding",
      gene_name : "GTF2E1",
      gene_level : 2,
      hgnc_id : "HGNC:4650",
      havana_gene : "OTTHUMG00000159667.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 120908072,
      stop : 121424761,
      direction : "+",
      ID : "ENSG00000145087.13",
      gene_id : "ENSG00000145087.13",
      gene_type : "protein_coding",
      gene_name : "STXBP5L",
      gene_level : 2,
      hgnc_id : "HGNC:30757",
      havana_gene : "OTTHUMG00000159426.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121431427,
      stop : 121546641,
      direction : "-",
      ID : "ENSG00000051341.14",
      gene_id : "ENSG00000051341.14",
      gene_type : "protein_coding",
      gene_name : "POLQ",
      gene_level : 2,
      hgnc_id : "HGNC:9186",
      havana_gene : "OTTHUMG00000159396.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121567949,
      stop : 121590622,
      direction : "+",
      ID : "ENSG00000186103.5",
      gene_id : "ENSG00000186103.5",
      gene_type : "protein_coding",
      gene_name : "ARGFX",
      gene_level : 2,
      hgnc_id : "HGNC:30146",
      havana_gene : "OTTHUMG00000159395.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121593379,
      stop : 121630295,
      direction : "+",
      ID : "ENSG00000163833.8",
      gene_id : "ENSG00000163833.8",
      gene_type : "protein_coding",
      gene_name : "FBXO40",
      gene_level : 2,
      hgnc_id : "HGNC:29816",
      havana_gene : "OTTHUMG00000159410.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121631399,
      stop : 121660927,
      direction : "-",
      ID : "ENSG00000180353.11",
      gene_id : "ENSG00000180353.11",
      gene_type : "protein_coding",
      gene_name : "HCLS1",
      gene_level : 2,
      hgnc_id : "HGNC:4844",
      havana_gene : "OTTHUMG00000159409.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121663199,
      stop : 121749767,
      direction : "-",
      ID : "ENSG00000173230.15",
      gene_id : "ENSG00000173230.15",
      gene_type : "protein_coding",
      gene_name : "GOLGB1",
      gene_level : 2,
      hgnc_id : "HGNC:4429",
      havana_gene : "OTTHUMG00000159411.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121769761,
      stop : 121835079,
      direction : "-",
      ID : "ENSG00000173226.17",
      gene_id : "ENSG00000173226.17",
      gene_type : "protein_coding",
      gene_name : "IQCB1",
      gene_level : 2,
      hgnc_id : "HGNC:28949",
      havana_gene : "OTTHUMG00000128677.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121835183,
      stop : 121886526,
      direction : "+",
      ID : "ENSG00000145088.9",
      gene_id : "ENSG00000145088.9",
      gene_type : "protein_coding",
      gene_name : "EAF2",
      gene_level : 1,
      hgnc_id : "HGNC:23115",
      havana_gene : "OTTHUMG00000159424.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121894401,
      stop : 121944188,
      direction : "+",
      ID : "ENSG00000163406.11",
      gene_id : "ENSG00000163406.11",
      gene_type : "protein_coding",
      gene_name : "SLC15A2",
      gene_level : 2,
      hgnc_id : "HGNC:10921",
      havana_gene : "OTTHUMG00000159423.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 121987323,
      stop : 122022247,
      direction : "-",
      ID : "ENSG00000145103.15",
      gene_id : "ENSG00000145103.15",
      gene_type : "protein_coding",
      gene_name : "ILDR1",
      gene_level : 2,
      hgnc_id : "HGNC:28741",
      havana_gene : "OTTHUMG00000159481.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122055362,
      stop : 122121139,
      direction : "+",
      ID : "ENSG00000114013.16",
      gene_id : "ENSG00000114013.16",
      gene_type : "protein_coding",
      gene_name : "CD86",
      gene_level : 2,
      hgnc_id : "HGNC:1705",
      havana_gene : "OTTHUMG00000159482.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122183668,
      stop : 122291629,
      direction : "+",
      ID : "ENSG00000036828.17",
      gene_id : "ENSG00000036828.17",
      gene_type : "protein_coding",
      gene_name : "CASR",
      gene_level : 2,
      hgnc_id : "HGNC:1514",
      havana_gene : "OTTHUMG00000159491.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122325248,
      stop : 122341969,
      direction : "+",
      ID : "ENSG00000121552.4",
      gene_id : "ENSG00000121552.4",
      gene_type : "protein_coding",
      gene_name : "CSTA",
      gene_level : 2,
      hgnc_id : "HGNC:2481",
      havana_gene : "OTTHUMG00000159488.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122359591,
      stop : 122383231,
      direction : "-",
      ID : "ENSG00000160124.9",
      gene_id : "ENSG00000160124.9",
      gene_type : "protein_coding",
      gene_name : "CCDC58",
      gene_level : 2,
      hgnc_id : "HGNC:31136",
      havana_gene : "OTTHUMG00000159490.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122384176,
      stop : 122412334,
      direction : "+",
      ID : "ENSG00000114023.15",
      gene_id : "ENSG00000114023.15",
      gene_type : "protein_coding",
      gene_name : "FAM162A",
      gene_level : 1,
      hgnc_id : "HGNC:17865",
      havana_gene : "OTTHUMG00000159494.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122411846,
      stop : 122416062,
      direction : "-",
      ID : "ENSG00000196981.4",
      gene_id : "ENSG00000196981.4",
      gene_type : "protein_coding",
      gene_name : "WDR5B",
      gene_level : 2,
      hgnc_id : "HGNC:17826",
      havana_gene : "OTTHUMG00000159489.2",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122421902,
      stop : 122514945,
      direction : "-",
      ID : "ENSG00000114030.13",
      gene_id : "ENSG00000114030.13",
      gene_type : "protein_coding",
      gene_name : "KPNA1",
      gene_level : 2,
      hgnc_id : "HGNC:6394",
      havana_gene : "OTTHUMG00000159487.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122527924,
      stop : 122564577,
      direction : "-",
      ID : "ENSG00000138496.16",
      gene_id : "ENSG00000138496.16",
      gene_type : "protein_coding",
      gene_name : "PARP9",
      gene_level : 1,
      hgnc_id : "HGNC:24118",
      havana_gene : "OTTHUMG00000159522.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122564338,
      stop : 122575203,
      direction : "+",
      ID : "ENSG00000163840.10",
      gene_id : "ENSG00000163840.10",
      gene_type : "protein_coding",
      gene_name : "DTX3L",
      gene_level : 1,
      hgnc_id : "HGNC:30323",
      havana_gene : "OTTHUMG00000159524.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122577628,
      stop : 122639047,
      direction : "+",
      ID : "ENSG00000173200.13",
      gene_id : "ENSG00000173200.13",
      gene_type : "protein_coding",
      gene_name : "PARP15",
      gene_level : 2,
      hgnc_id : "HGNC:26876",
      havana_gene : "OTTHUMG00000159523.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122680839,
      stop : 122730840,
      direction : "+",
      ID : "ENSG00000173193.15",
      gene_id : "ENSG00000173193.15",
      gene_type : "protein_coding",
      gene_name : "PARP14",
      gene_level : 2,
      hgnc_id : "HGNC:29232",
      havana_gene : "OTTHUMG00000159552.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122739999,
      stop : 122793831,
      direction : "-",
      ID : "ENSG00000169087.11",
      gene_id : "ENSG00000169087.11",
      gene_type : "protein_coding",
      gene_name : "HSPBAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16389",
      havana_gene : "OTTHUMG00000159550.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122795069,
      stop : 122881139,
      direction : "+",
      ID : "ENSG00000138463.9",
      gene_id : "ENSG00000138463.9",
      gene_type : "protein_coding",
      gene_name : "SLC49A4",
      gene_level : 2,
      hgnc_id : "HGNC:16628",
      havana_gene : "OTTHUMG00000159553.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 122909082,
      stop : 123028605,
      direction : "-",
      ID : "ENSG00000082684.16",
      gene_id : "ENSG00000082684.16",
      gene_type : "protein_coding",
      gene_name : "SEMA5B",
      gene_level : 2,
      hgnc_id : "HGNC:10737",
      havana_gene : "OTTHUMG00000140392.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123067025,
      stop : 123225227,
      direction : "+",
      ID : "ENSG00000065485.20",
      gene_id : "ENSG00000065485.20",
      gene_type : "protein_coding",
      gene_name : "PDIA5",
      gene_level : 1,
      hgnc_id : "HGNC:24811",
      havana_gene : "OTTHUMG00000159558.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123201927,
      stop : 123274136,
      direction : "+",
      ID : "ENSG00000121542.12",
      gene_id : "ENSG00000121542.12",
      gene_type : "protein_coding",
      gene_name : "SEC22A",
      gene_level : 2,
      hgnc_id : "HGNC:20260",
      havana_gene : "OTTHUMG00000159495.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123282296,
      stop : 123449090,
      direction : "-",
      ID : "ENSG00000173175.15",
      gene_id : "ENSG00000173175.15",
      gene_type : "protein_coding",
      gene_name : "ADCY5",
      gene_level : 1,
      hgnc_id : "HGNC:236",
      havana_gene : "OTTHUMG00000159517.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123490820,
      stop : 123585053,
      direction : "-",
      ID : "ENSG00000206527.10",
      gene_id : "ENSG00000206527.10",
      gene_type : "protein_coding",
      gene_name : "HACD2",
      gene_level : 1,
      hgnc_id : "HGNC:9640",
      havana_gene : "OTTHUMG00000159529.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123610049,
      stop : 123884332,
      direction : "-",
      ID : "ENSG00000065534.19",
      gene_id : "ENSG00000065534.19",
      gene_type : "protein_coding",
      gene_name : "MYLK",
      gene_level : 1,
      hgnc_id : "HGNC:7590",
      havana_gene : "OTTHUMG00000141304.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123897305,
      stop : 123961408,
      direction : "-",
      ID : "ENSG00000175455.16",
      gene_id : "ENSG00000175455.16",
      gene_type : "protein_coding",
      gene_name : "CCDC14",
      gene_level : 1,
      hgnc_id : "HGNC:25766",
      havana_gene : "OTTHUMG00000153005.23",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 123968521,
      stop : 123992178,
      direction : "-",
      ID : "ENSG00000065371.17",
      gene_id : "ENSG00000065371.17",
      gene_type : "protein_coding",
      gene_name : "ROPN1",
      gene_level : 1,
      hgnc_id : "HGNC:17692",
      havana_gene : "OTTHUMG00000159556.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 124080023,
      stop : 124726325,
      direction : "+",
      ID : "ENSG00000160145.15",
      gene_id : "ENSG00000160145.15",
      gene_type : "protein_coding",
      gene_name : "KALRN",
      gene_level : 1,
      hgnc_id : "HGNC:4814",
      havana_gene : "OTTHUMG00000125545.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 124730433,
      stop : 124749273,
      direction : "+",
      ID : "ENSG00000114491.14",
      gene_id : "ENSG00000114491.14",
      gene_type : "protein_coding",
      gene_name : "UMPS",
      gene_level : 2,
      hgnc_id : "HGNC:12563",
      havana_gene : "OTTHUMG00000159431.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 124761948,
      stop : 124901418,
      direction : "-",
      ID : "ENSG00000082781.12",
      gene_id : "ENSG00000082781.12",
      gene_type : "protein_coding",
      gene_name : "ITGB5",
      gene_level : 1,
      hgnc_id : "HGNC:6160",
      havana_gene : "OTTHUMG00000159432.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 124905442,
      stop : 124953819,
      direction : "-",
      ID : "ENSG00000173702.7",
      gene_id : "ENSG00000173702.7",
      gene_type : "protein_coding",
      gene_name : "MUC13",
      gene_level : 2,
      hgnc_id : "HGNC:7511",
      havana_gene : "OTTHUMG00000159484.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 124965710,
      stop : 125055997,
      direction : "-",
      ID : "ENSG00000173706.14",
      gene_id : "ENSG00000173706.14",
      gene_type : "protein_coding",
      gene_name : "HEG1",
      gene_level : 1,
      hgnc_id : "HGNC:29227",
      havana_gene : "OTTHUMG00000159486.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 125082636,
      stop : 125212864,
      direction : "-",
      ID : "ENSG00000221955.11",
      gene_id : "ENSG00000221955.11",
      gene_type : "protein_coding",
      gene_name : "SLC12A8",
      gene_level : 1,
      hgnc_id : "HGNC:15595",
      havana_gene : "OTTHUMG00000159483.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 125225669,
      stop : 125375325,
      direction : "-",
      ID : "ENSG00000163848.20",
      gene_id : "ENSG00000163848.20",
      gene_type : "protein_coding",
      gene_name : "ZNF148",
      gene_level : 1,
      hgnc_id : "HGNC:12933",
      havana_gene : "OTTHUMG00000159448.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 125446650,
      stop : 125520202,
      direction : "-",
      ID : "ENSG00000114520.11",
      gene_id : "ENSG00000114520.11",
      gene_type : "protein_coding",
      gene_name : "SNX4",
      gene_level : 2,
      hgnc_id : "HGNC:11175",
      havana_gene : "OTTHUMG00000159575.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 125528858,
      stop : 125595497,
      direction : "-",
      ID : "ENSG00000144909.8",
      gene_id : "ENSG00000144909.8",
      gene_type : "protein_coding",
      gene_name : "OSBPL11",
      gene_level : 2,
      hgnc_id : "HGNC:16397",
      havana_gene : "OTTHUMG00000159571.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 125929275,
      stop : 125937039,
      direction : "-",
      ID : "ENSG00000189366.9",
      gene_id : "ENSG00000189366.9",
      gene_type : "protein_coding",
      gene_name : "ALG1L",
      gene_level : 2,
      hgnc_id : "HGNC:33721",
      havana_gene : "OTTHUMG00000159588.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 125969160,
      stop : 125983454,
      direction : "+",
      ID : "ENSG00000114547.10",
      gene_id : "ENSG00000114547.10",
      gene_type : "protein_coding",
      gene_name : "ROPN1B",
      gene_level : 2,
      hgnc_id : "HGNC:31927",
      havana_gene : "OTTHUMG00000162651.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126006357,
      stop : 126101561,
      direction : "-",
      ID : "ENSG00000114544.17",
      gene_id : "ENSG00000114544.17",
      gene_type : "protein_coding",
      gene_name : "SLC41A3",
      gene_level : 1,
      hgnc_id : "HGNC:31046",
      havana_gene : "OTTHUMG00000162678.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126103562,
      stop : 126197994,
      direction : "-",
      ID : "ENSG00000144908.14",
      gene_id : "ENSG00000144908.14",
      gene_type : "protein_coding",
      gene_name : "ALDH1L1",
      gene_level : 1,
      hgnc_id : "HGNC:3978",
      havana_gene : "OTTHUMG00000125551.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126342635,
      stop : 126357408,
      direction : "-",
      ID : "ENSG00000163884.4",
      gene_id : "ENSG00000163884.4",
      gene_type : "protein_coding",
      gene_name : "KLF15",
      gene_level : 1,
      hgnc_id : "HGNC:14536",
      havana_gene : "OTTHUMG00000162689.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126394909,
      stop : 126436556,
      direction : "+",
      ID : "ENSG00000163885.12",
      gene_id : "ENSG00000163885.12",
      gene_type : "protein_coding",
      gene_name : "CFAP100",
      gene_level : 1,
      hgnc_id : "HGNC:26842",
      havana_gene : "OTTHUMG00000162691.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126437601,
      stop : 126475891,
      direction : "-",
      ID : "ENSG00000070476.15",
      gene_id : "ENSG00000070476.15",
      gene_type : "protein_coding",
      gene_name : "ZXDC",
      gene_level : 2,
      hgnc_id : "HGNC:28160",
      havana_gene : "OTTHUMG00000162754.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126481166,
      stop : 126517773,
      direction : "-",
      ID : "ENSG00000159650.9",
      gene_id : "ENSG00000159650.9",
      gene_type : "protein_coding",
      gene_name : "UROC1",
      gene_level : 2,
      hgnc_id : "HGNC:26444",
      havana_gene : "OTTHUMG00000162753.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126524155,
      stop : 126543291,
      direction : "+",
      ID : "ENSG00000180767.10",
      gene_id : "ENSG00000180767.10",
      gene_type : "protein_coding",
      gene_name : "CHST13",
      gene_level : 2,
      hgnc_id : "HGNC:21755",
      havana_gene : "OTTHUMG00000162721.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126526999,
      stop : 126558965,
      direction : "-",
      ID : "ENSG00000180697.9",
      gene_id : "ENSG00000180697.9",
      gene_type : "protein_coding",
      gene_name : "C3orf22",
      gene_level : 2,
      hgnc_id : "HGNC:28534",
      havana_gene : "OTTHUMG00000162731.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126571779,
      stop : 126655124,
      direction : "-",
      ID : "ENSG00000197763.20",
      gene_id : "ENSG00000197763.20",
      gene_type : "protein_coding",
      gene_name : "TXNRD3",
      gene_level : 1,
      hgnc_id : "HGNC:20667",
      havana_gene : "OTTHUMG00000162733.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126704240,
      stop : 126960420,
      direction : "+",
      ID : "ENSG00000159685.11",
      gene_id : "ENSG00000159685.11",
      gene_type : "protein_coding",
      gene_name : "CHCHD6",
      gene_level : 2,
      hgnc_id : "HGNC:28184",
      havana_gene : "OTTHUMG00000159601.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 126988594,
      stop : 127037392,
      direction : "+",
      ID : "ENSG00000114554.11",
      gene_id : "ENSG00000114554.11",
      gene_type : "protein_coding",
      gene_name : "PLXNA1",
      gene_level : 2,
      hgnc_id : "HGNC:9099",
      havana_gene : "OTTHUMG00000044222.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127193131,
      stop : 127198185,
      direction : "+",
      ID : "ENSG00000214324.5",
      gene_id : "ENSG00000214324.5",
      gene_type : "protein_coding",
      gene_name : "C3orf56",
      gene_level : 2,
      hgnc_id : "HGNC:32481",
      havana_gene : "OTTHUMG00000159593.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127283783,
      stop : 127288046,
      direction : "-",
      ID : "ENSG00000239620.3",
      gene_id : "ENSG00000239620.3",
      gene_type : "protein_coding",
      gene_name : "PRR20G",
      gene_level : 2,
      hgnc_id : "HGNC:53837",
      havana_gene : "OTTHUMG00000159594.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127571232,
      stop : 127598267,
      direction : "-",
      ID : "ENSG00000163870.16",
      gene_id : "ENSG00000163870.16",
      gene_type : "protein_coding",
      gene_name : "TPRA1",
      gene_level : 2,
      hgnc_id : "HGNC:30413",
      havana_gene : "OTTHUMG00000159639.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127598410,
      stop : 127622436,
      direction : "+",
      ID : "ENSG00000073111.14",
      gene_id : "ENSG00000073111.14",
      gene_type : "protein_coding",
      gene_name : "MCM2",
      gene_level : 1,
      hgnc_id : "HGNC:6944",
      havana_gene : "OTTHUMG00000159637.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127629185,
      stop : 127672802,
      direction : "+",
      ID : "ENSG00000114631.11",
      gene_id : "ENSG00000114631.11",
      gene_type : "protein_coding",
      gene_name : "PODXL2",
      gene_level : 2,
      hgnc_id : "HGNC:17936",
      havana_gene : "OTTHUMG00000159642.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127672935,
      stop : 127680926,
      direction : "+",
      ID : "ENSG00000114626.18",
      gene_id : "ENSG00000114626.18",
      gene_type : "protein_coding",
      gene_name : "ABTB1",
      gene_level : 2,
      hgnc_id : "HGNC:18275",
      havana_gene : "OTTHUMG00000159636.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127689062,
      stop : 128052190,
      direction : "-",
      ID : "ENSG00000074416.14",
      gene_id : "ENSG00000074416.14",
      gene_type : "protein_coding",
      gene_name : "MGLL",
      gene_level : 1,
      hgnc_id : "HGNC:17038",
      havana_gene : "OTTHUMG00000159641.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 127915232,
      stop : 127987671,
      direction : "+",
      ID : "ENSG00000187715.13",
      gene_id : "ENSG00000187715.13",
      gene_type : "protein_coding",
      gene_name : "KBTBD12",
      gene_level : 1,
      hgnc_id : "HGNC:25731",
      havana_gene : "OTTHUMG00000150508.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128051641,
      stop : 128071683,
      direction : "+",
      ID : "ENSG00000058262.10",
      gene_id : "ENSG00000058262.10",
      gene_type : "protein_coding",
      gene_name : "SEC61A1",
      gene_level : 1,
      hgnc_id : "HGNC:18276",
      havana_gene : "OTTHUMG00000159624.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128064778,
      stop : 128153914,
      direction : "-",
      ID : "ENSG00000175792.12",
      gene_id : "ENSG00000175792.12",
      gene_type : "protein_coding",
      gene_name : "RUVBL1",
      gene_level : 1,
      hgnc_id : "HGNC:10474",
      havana_gene : "OTTHUMG00000159658.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128153481,
      stop : 128408646,
      direction : "+",
      ID : "ENSG00000132394.11",
      gene_id : "ENSG00000132394.11",
      gene_type : "protein_coding",
      gene_name : "EEFSEC",
      gene_level : 2,
      hgnc_id : "HGNC:24614",
      havana_gene : "OTTHUMG00000159659.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128462439,
      stop : 128467248,
      direction : "-",
      ID : "ENSG00000179407.3",
      gene_id : "ENSG00000179407.3",
      gene_type : "protein_coding",
      gene_name : "DNAJB8",
      gene_level : 2,
      hgnc_id : "HGNC:23699",
      havana_gene : "OTTHUMG00000159690.2",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128479427,
      stop : 128493201,
      direction : "-",
      ID : "ENSG00000179348.12",
      gene_id : "ENSG00000179348.12",
      gene_type : "protein_coding",
      gene_name : "GATA2",
      gene_level : 2,
      hgnc_id : "HGNC:4171",
      havana_gene : "OTTHUMG00000159689.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128619969,
      stop : 128681075,
      direction : "-",
      ID : "ENSG00000163902.12",
      gene_id : "ENSG00000163902.12",
      gene_type : "protein_coding",
      gene_name : "RPN1",
      gene_level : 2,
      hgnc_id : "HGNC:10381",
      havana_gene : "OTTHUMG00000159691.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128693669,
      stop : 128825942,
      direction : "+",
      ID : "ENSG00000075785.14",
      gene_id : "ENSG00000075785.14",
      gene_type : "protein_coding",
      gene_name : "RAB7A",
      gene_level : 1,
      hgnc_id : "HGNC:9788",
      havana_gene : "OTTHUMG00000159812.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128879596,
      stop : 128924003,
      direction : "+",
      ID : "ENSG00000177646.20",
      gene_id : "ENSG00000177646.20",
      gene_type : "protein_coding",
      gene_name : "ACAD9",
      gene_level : 2,
      hgnc_id : "HGNC:21497",
      havana_gene : "OTTHUMG00000159942.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 128909866,
      stop : 129002690,
      direction : "-",
      ID : "ENSG00000114656.12",
      gene_id : "ENSG00000114656.12",
      gene_type : "protein_coding",
      gene_name : "CFAP92",
      gene_level : 1,
      hgnc_id : "HGNC:29231",
      havana_gene : "OTTHUMG00000159946.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129001629,
      stop : 129040742,
      direction : "+",
      ID : "ENSG00000114654.7",
      gene_id : "ENSG00000114654.7",
      gene_type : "protein_coding",
      gene_name : "EFCC1",
      gene_level : 2,
      hgnc_id : "HGNC:25692",
      havana_gene : "OTTHUMG00000158996.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129060779,
      stop : 129062406,
      direction : "+",
      ID : "ENSG00000169704.5",
      gene_id : "ENSG00000169704.5",
      gene_type : "protein_coding",
      gene_name : "GP9",
      gene_level : 2,
      hgnc_id : "HGNC:4444",
      havana_gene : "OTTHUMG00000159944.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129087569,
      stop : 129122801,
      direction : "-",
      ID : "ENSG00000172780.17",
      gene_id : "ENSG00000172780.17",
      gene_type : "protein_coding",
      gene_name : "RAB43",
      gene_level : 2,
      hgnc_id : "HGNC:19983",
      havana_gene : "OTTHUMG00000137364.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129087575,
      stop : 129161036,
      direction : "-",
      ID : "ENSG00000261796.1",
      gene_id : "ENSG00000261796.1",
      gene_type : "protein_coding",
      gene_name : "ISY1-RAB43",
      gene_level : 2,
      hgnc_id : "HGNC:42969",
      havana_gene : "OTTHUMG00000177122.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129127415,
      stop : 129161063,
      direction : "-",
      ID : "ENSG00000240682.10",
      gene_id : "ENSG00000240682.10",
      gene_type : "protein_coding",
      gene_name : "ISY1",
      gene_level : 1,
      hgnc_id : "HGNC:29201",
      havana_gene : "OTTHUMG00000137365.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129167827,
      stop : 129183922,
      direction : "-",
      ID : "ENSG00000169714.17",
      gene_id : "ENSG00000169714.17",
      gene_type : "protein_coding",
      gene_name : "CNBP",
      gene_level : 1,
      hgnc_id : "HGNC:13164",
      havana_gene : "OTTHUMG00000159943.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129249606,
      stop : 129277773,
      direction : "+",
      ID : "ENSG00000181789.14",
      gene_id : "ENSG00000181789.14",
      gene_type : "protein_coding",
      gene_name : "COPG1",
      gene_level : 2,
      hgnc_id : "HGNC:2236",
      havana_gene : "OTTHUMG00000159451.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129278828,
      stop : 129306186,
      direction : "+",
      ID : "ENSG00000183624.14",
      gene_id : "ENSG00000183624.14",
      gene_type : "protein_coding",
      gene_name : "HMCES",
      gene_level : 1,
      hgnc_id : "HGNC:24446",
      havana_gene : "OTTHUMG00000159452.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129314771,
      stop : 129316286,
      direction : "-",
      ID : "ENSG00000184897.6",
      gene_id : "ENSG00000184897.6",
      gene_type : "protein_coding",
      gene_name : "H1-10",
      gene_level : 2,
      hgnc_id : "HGNC:4722",
      havana_gene : "OTTHUMG00000159450.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129401321,
      stop : 129428651,
      direction : "-",
      ID : "ENSG00000172771.12",
      gene_id : "ENSG00000172771.12",
      gene_type : "protein_coding",
      gene_name : "EFCAB12",
      gene_level : 2,
      hgnc_id : "HGNC:28061",
      havana_gene : "OTTHUMG00000159464.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129430947,
      stop : 129440179,
      direction : "-",
      ID : "ENSG00000129071.10",
      gene_id : "ENSG00000129071.10",
      gene_type : "protein_coding",
      gene_name : "MBD4",
      gene_level : 2,
      hgnc_id : "HGNC:6919",
      havana_gene : "OTTHUMG00000159463.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129440036,
      stop : 129520507,
      direction : "+",
      ID : "ENSG00000163913.12",
      gene_id : "ENSG00000163913.12",
      gene_type : "protein_coding",
      gene_name : "IFT122",
      gene_level : 1,
      hgnc_id : "HGNC:13556",
      havana_gene : "OTTHUMG00000159516.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129528639,
      stop : 129535344,
      direction : "+",
      ID : "ENSG00000163914.5",
      gene_id : "ENSG00000163914.5",
      gene_type : "protein_coding",
      gene_name : "RHO",
      gene_level : 2,
      hgnc_id : "HGNC:10012",
      havana_gene : "OTTHUMG00000159542.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129543214,
      stop : 129551467,
      direction : "+",
      ID : "ENSG00000178804.7",
      gene_id : "ENSG00000178804.7",
      gene_type : "protein_coding",
      gene_name : "H1-8",
      gene_level : 1,
      hgnc_id : "HGNC:18463",
      havana_gene : "OTTHUMG00000159541.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129555214,
      stop : 129606676,
      direction : "-",
      ID : "ENSG00000004399.13",
      gene_id : "ENSG00000004399.13",
      gene_type : "protein_coding",
      gene_name : "PLXND1",
      gene_level : 1,
      hgnc_id : "HGNC:9107",
      havana_gene : "OTTHUMG00000159547.15",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129647792,
      stop : 129893606,
      direction : "-",
      ID : "ENSG00000172765.17",
      gene_id : "ENSG00000172765.17",
      gene_type : "protein_coding",
      gene_name : "TMCC1",
      gene_level : 1,
      hgnc_id : "HGNC:29116",
      havana_gene : "OTTHUMG00000159579.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 129974688,
      stop : 129977935,
      direction : "+",
      ID : "ENSG00000170893.4",
      gene_id : "ENSG00000170893.4",
      gene_type : "protein_coding",
      gene_name : "TRH",
      gene_level : 1,
      hgnc_id : "HGNC:12298",
      havana_gene : "OTTHUMG00000159634.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 130081831,
      stop : 130113227,
      direction : "+",
      ID : "ENSG00000251287.8",
      gene_id : "ENSG00000251287.8",
      gene_type : "protein_coding",
      gene_name : "ALG1L2",
      gene_level : 2,
      hgnc_id : "HGNC:37258",
      havana_gene : "OTTHUMG00000159782.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 130345516,
      stop : 130484844,
      direction : "+",
      ID : "ENSG00000172752.14",
      gene_id : "ENSG00000172752.14",
      gene_type : "protein_coding",
      gene_name : "COL6A5",
      gene_level : 1,
      hgnc_id : "HGNC:26674",
      havana_gene : "OTTHUMG00000159712.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 130560334,
      stop : 130678155,
      direction : "+",
      ID : "ENSG00000206384.10",
      gene_id : "ENSG00000206384.10",
      gene_type : "protein_coding",
      gene_name : "COL6A6",
      gene_level : 2,
      hgnc_id : "HGNC:27023",
      havana_gene : "OTTHUMG00000159653.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 130678934,
      stop : 130746829,
      direction : "-",
      ID : "ENSG00000196455.8",
      gene_id : "ENSG00000196455.8",
      gene_type : "protein_coding",
      gene_name : "PIK3R4",
      gene_level : 2,
      hgnc_id : "HGNC:8982",
      havana_gene : "OTTHUMG00000159645.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 130850595,
      stop : 131016712,
      direction : "+",
      ID : "ENSG00000017260.20",
      gene_id : "ENSG00000017260.20",
      gene_type : "protein_coding",
      gene_name : "ATP2C1",
      gene_level : 2,
      hgnc_id : "HGNC:13211",
      havana_gene : "OTTHUMG00000136802.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 131013875,
      stop : 131027649,
      direction : "-",
      ID : "ENSG00000034533.12",
      gene_id : "ENSG00000034533.12",
      gene_type : "protein_coding",
      gene_name : "ASTE1",
      gene_level : 1,
      hgnc_id : "HGNC:25021",
      havana_gene : "OTTHUMG00000159644.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 131026850,
      stop : 131350465,
      direction : "+",
      ID : "ENSG00000114670.14",
      gene_id : "ENSG00000114670.14",
      gene_type : "protein_coding",
      gene_name : "NEK11",
      gene_level : 1,
      hgnc_id : "HGNC:18593",
      havana_gene : "OTTHUMG00000159654.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 131381671,
      stop : 131388830,
      direction : "+",
      ID : "ENSG00000198585.12",
      gene_id : "ENSG00000198585.12",
      gene_type : "protein_coding",
      gene_name : "NUDT16",
      gene_level : 2,
      hgnc_id : "HGNC:26442",
      havana_gene : "OTTHUMG00000159623.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 131462212,
      stop : 131502983,
      direction : "-",
      ID : "ENSG00000114686.9",
      gene_id : "ENSG00000114686.9",
      gene_type : "protein_coding",
      gene_name : "MRPL3",
      gene_level : 1,
      hgnc_id : "HGNC:10379",
      havana_gene : "OTTHUMG00000159607.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 131533555,
      stop : 132285410,
      direction : "-",
      ID : "ENSG00000196353.11",
      gene_id : "ENSG00000196353.11",
      gene_type : "protein_coding",
      gene_name : "CPNE4",
      gene_level : 2,
      hgnc_id : "HGNC:2317",
      havana_gene : "OTTHUMG00000159631.14",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132317369,
      stop : 132368298,
      direction : "+",
      ID : "ENSG00000014257.16",
      gene_id : "ENSG00000014257.16",
      gene_type : "protein_coding",
      gene_name : "ACP3",
      gene_level : 1,
      hgnc_id : "HGNC:125",
      havana_gene : "OTTHUMG00000159650.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132417502,
      stop : 132539032,
      direction : "+",
      ID : "ENSG00000138246.17",
      gene_id : "ENSG00000138246.17",
      gene_type : "protein_coding",
      gene_name : "DNAJC13",
      gene_level : 2,
      hgnc_id : "HGNC:30343",
      havana_gene : "OTTHUMG00000159674.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132558138,
      stop : 132660082,
      direction : "-",
      ID : "ENSG00000240303.8",
      gene_id : "ENSG00000240303.8",
      gene_type : "protein_coding",
      gene_name : "ACAD11",
      gene_level : 2,
      hgnc_id : "HGNC:30211",
      havana_gene : "OTTHUMG00000159780.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132558142,
      stop : 132722459,
      direction : "-",
      ID : "ENSG00000274810.4",
      gene_id : "ENSG00000274810.4",
      gene_type : "protein_coding",
      gene_name : "NPHP3-ACAD11",
      gene_level : 2,
      hgnc_id : "HGNC:48351",
      havana_gene : "OTTHUMG00000187276.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132597270,
      stop : 132618967,
      direction : "+",
      ID : "ENSG00000129048.7",
      gene_id : "ENSG00000129048.7",
      gene_type : "protein_coding",
      gene_name : "ACKR4",
      gene_level : 2,
      hgnc_id : "HGNC:1611",
      havana_gene : "OTTHUMG00000159768.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132654446,
      stop : 132679794,
      direction : "+",
      ID : "ENSG00000081307.14",
      gene_id : "ENSG00000081307.14",
      gene_type : "protein_coding",
      gene_name : "UBA5",
      gene_level : 1,
      hgnc_id : "HGNC:23230",
      havana_gene : "OTTHUMG00000159759.19",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 132680609,
      stop : 132722414,
      direction : "-",
      ID : "ENSG00000113971.20",
      gene_id : "ENSG00000113971.20",
      gene_type : "protein_coding",
      gene_name : "NPHP3",
      gene_level : 1,
      hgnc_id : "HGNC:7907",
      havana_gene : "OTTHUMG00000159713.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133038391,
      stop : 133397775,
      direction : "+",
      ID : "ENSG00000144868.14",
      gene_id : "ENSG00000144868.14",
      gene_type : "protein_coding",
      gene_name : "TMEM108",
      gene_level : 1,
      hgnc_id : "HGNC:28451",
      havana_gene : "OTTHUMG00000159685.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133400056,
      stop : 133475222,
      direction : "+",
      ID : "ENSG00000170819.5",
      gene_id : "ENSG00000170819.5",
      gene_type : "protein_coding",
      gene_name : "BFSP2",
      gene_level : 2,
      hgnc_id : "HGNC:1041",
      havana_gene : "OTTHUMG00000159719.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133573686,
      stop : 133590261,
      direction : "+",
      ID : "ENSG00000091527.16",
      gene_id : "ENSG00000091527.16",
      gene_type : "protein_coding",
      gene_name : "CDV3",
      gene_level : 1,
      hgnc_id : "HGNC:26928",
      havana_gene : "OTTHUMG00000159764.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133598175,
      stop : 133662380,
      direction : "-",
      ID : "ENSG00000163781.14",
      gene_id : "ENSG00000163781.14",
      gene_type : "protein_coding",
      gene_name : "TOPBP1",
      gene_level : 1,
      hgnc_id : "HGNC:17008",
      havana_gene : "OTTHUMG00000159773.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133746040,
      stop : 133796641,
      direction : "+",
      ID : "ENSG00000091513.16",
      gene_id : "ENSG00000091513.16",
      gene_type : "protein_coding",
      gene_name : "TF",
      gene_level : 1,
      hgnc_id : "HGNC:11740",
      havana_gene : "OTTHUMG00000150356.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133784023,
      stop : 133825772,
      direction : "+",
      ID : "ENSG00000144867.13",
      gene_id : "ENSG00000144867.13",
      gene_type : "protein_coding",
      gene_name : "SRPRB",
      gene_level : 2,
      hgnc_id : "HGNC:24085",
      havana_gene : "OTTHUMG00000159753.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133824235,
      stop : 133895882,
      direction : "-",
      ID : "ENSG00000154917.11",
      gene_id : "ENSG00000154917.11",
      gene_type : "protein_coding",
      gene_name : "RAB6B",
      gene_level : 2,
      hgnc_id : "HGNC:14902",
      havana_gene : "OTTHUMG00000159749.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 133932701,
      stop : 134052184,
      direction : "-",
      ID : "ENSG00000174640.15",
      gene_id : "ENSG00000174640.15",
      gene_type : "protein_coding",
      gene_name : "SLCO2A1",
      gene_level : 1,
      hgnc_id : "HGNC:10955",
      havana_gene : "OTTHUMG00000159745.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 134065303,
      stop : 134250859,
      direction : "-",
      ID : "ENSG00000163785.13",
      gene_id : "ENSG00000163785.13",
      gene_type : "protein_coding",
      gene_name : "RYK",
      gene_level : 2,
      hgnc_id : "HGNC:10481",
      havana_gene : "OTTHUMG00000159750.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 134355347,
      stop : 134375479,
      direction : "-",
      ID : "ENSG00000114019.15",
      gene_id : "ENSG00000114019.15",
      gene_type : "protein_coding",
      gene_name : "AMOTL2",
      gene_level : 1,
      hgnc_id : "HGNC:17812",
      havana_gene : "OTTHUMG00000159777.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 134477706,
      stop : 134486716,
      direction : "-",
      ID : "ENSG00000129055.13",
      gene_id : "ENSG00000129055.13",
      gene_type : "protein_coding",
      gene_name : "ANAPC13",
      gene_level : 2,
      hgnc_id : "HGNC:24540",
      havana_gene : "OTTHUMG00000159803.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 134485721,
      stop : 134575017,
      direction : "+",
      ID : "ENSG00000182923.19",
      gene_id : "ENSG00000182923.19",
      gene_type : "protein_coding",
      gene_name : "CEP63",
      gene_level : 2,
      hgnc_id : "HGNC:25815",
      havana_gene : "OTTHUMG00000159725.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 134597801,
      stop : 135260467,
      direction : "+",
      ID : "ENSG00000154928.18",
      gene_id : "ENSG00000154928.18",
      gene_type : "protein_coding",
      gene_name : "EPHB1",
      gene_level : 1,
      hgnc_id : "HGNC:3392",
      havana_gene : "OTTHUMG00000159804.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 134599923,
      stop : 134651636,
      direction : "-",
      ID : "ENSG00000174611.12",
      gene_id : "ENSG00000174611.12",
      gene_type : "protein_coding",
      gene_name : "KY",
      gene_level : 2,
      hgnc_id : "HGNC:26576",
      havana_gene : "OTTHUMG00000159788.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 135965728,
      stop : 136147894,
      direction : "+",
      ID : "ENSG00000073711.11",
      gene_id : "ENSG00000073711.11",
      gene_type : "protein_coding",
      gene_name : "PPP2R3A",
      gene_level : 2,
      hgnc_id : "HGNC:9307",
      havana_gene : "OTTHUMG00000159766.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 136148917,
      stop : 136197241,
      direction : "-",
      ID : "ENSG00000174579.4",
      gene_id : "ENSG00000174579.4",
      gene_type : "protein_coding",
      gene_name : "MSL2",
      gene_level : 2,
      hgnc_id : "HGNC:25544",
      havana_gene : "OTTHUMG00000159793.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 136250340,
      stop : 136337896,
      direction : "+",
      ID : "ENSG00000114054.14",
      gene_id : "ENSG00000114054.14",
      gene_type : "protein_coding",
      gene_name : "PCCB",
      gene_level : 1,
      hgnc_id : "HGNC:8654",
      havana_gene : "OTTHUMG00000159792.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 136336236,
      stop : 136752403,
      direction : "-",
      ID : "ENSG00000118007.13",
      gene_id : "ENSG00000118007.13",
      gene_type : "protein_coding",
      gene_name : "STAG1",
      gene_level : 1,
      hgnc_id : "HGNC:11354",
      havana_gene : "OTTHUMG00000159798.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 136818647,
      stop : 136855888,
      direction : "+",
      ID : "ENSG00000168917.9",
      gene_id : "ENSG00000168917.9",
      gene_type : "protein_coding",
      gene_name : "SLC35G2",
      gene_level : 2,
      hgnc_id : "HGNC:28480",
      havana_gene : "OTTHUMG00000159787.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 136862208,
      stop : 136951606,
      direction : "+",
      ID : "ENSG00000158092.7",
      gene_id : "ENSG00000158092.7",
      gene_type : "protein_coding",
      gene_name : "NCK1",
      gene_level : 1,
      hgnc_id : "HGNC:7664",
      havana_gene : "OTTHUMG00000159781.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 136946230,
      stop : 137011085,
      direction : "+",
      ID : "ENSG00000174564.13",
      gene_id : "ENSG00000174564.13",
      gene_type : "protein_coding",
      gene_name : "IL20RB",
      gene_level : 2,
      hgnc_id : "HGNC:6004",
      havana_gene : "OTTHUMG00000159779.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 137764315,
      stop : 137766334,
      direction : "+",
      ID : "ENSG00000168875.3",
      gene_id : "ENSG00000168875.3",
      gene_type : "protein_coding",
      gene_name : "SOX14",
      gene_level : 2,
      hgnc_id : "HGNC:11193",
      havana_gene : "OTTHUMG00000159757.2",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 137998735,
      stop : 138033655,
      direction : "+",
      ID : "ENSG00000066405.13",
      gene_id : "ENSG00000066405.13",
      gene_type : "protein_coding",
      gene_name : "CLDN18",
      gene_level : 2,
      hgnc_id : "HGNC:2039",
      havana_gene : "OTTHUMG00000159762.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138061990,
      stop : 138115818,
      direction : "-",
      ID : "ENSG00000158163.15",
      gene_id : "ENSG00000158163.15",
      gene_type : "protein_coding",
      gene_name : "DZIP1L",
      gene_level : 2,
      hgnc_id : "HGNC:26551",
      havana_gene : "OTTHUMG00000159819.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138123713,
      stop : 138132390,
      direction : "-",
      ID : "ENSG00000118017.4",
      gene_id : "ENSG00000118017.4",
      gene_type : "protein_coding",
      gene_name : "A4GNT",
      gene_level : 2,
      hgnc_id : "HGNC:17968",
      havana_gene : "OTTHUMG00000159820.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138160988,
      stop : 138174921,
      direction : "-",
      ID : "ENSG00000138231.13",
      gene_id : "ENSG00000138231.13",
      gene_type : "protein_coding",
      gene_name : "DBR1",
      gene_level : 2,
      hgnc_id : "HGNC:15594",
      havana_gene : "OTTHUMG00000159824.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138187248,
      stop : 138298384,
      direction : "+",
      ID : "ENSG00000114098.18",
      gene_id : "ENSG00000114098.18",
      gene_type : "protein_coding",
      gene_name : "ARMC8",
      gene_level : 1,
      hgnc_id : "HGNC:24999",
      havana_gene : "OTTHUMG00000159821.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138261437,
      stop : 138329886,
      direction : "-",
      ID : "ENSG00000181322.15",
      gene_id : "ENSG00000181322.15",
      gene_type : "protein_coding",
      gene_name : "NME9",
      gene_level : 2,
      hgnc_id : "HGNC:21343",
      havana_gene : "OTTHUMG00000159823.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138347648,
      stop : 138405534,
      direction : "+",
      ID : "ENSG00000158186.13",
      gene_id : "ENSG00000158186.13",
      gene_type : "protein_coding",
      gene_name : "MRAS",
      gene_level : 1,
      hgnc_id : "HGNC:7227",
      havana_gene : "OTTHUMG00000159888.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138434586,
      stop : 138481686,
      direction : "+",
      ID : "ENSG00000158220.14",
      gene_id : "ENSG00000158220.14",
      gene_type : "protein_coding",
      gene_name : "ESYT3",
      gene_level : 2,
      hgnc_id : "HGNC:24295",
      havana_gene : "OTTHUMG00000147354.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138494344,
      stop : 138594538,
      direction : "-",
      ID : "ENSG00000114107.9",
      gene_id : "ENSG00000114107.9",
      gene_type : "protein_coding",
      gene_name : "CEP70",
      gene_level : 1,
      hgnc_id : "HGNC:29972",
      havana_gene : "OTTHUMG00000159891.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138608606,
      stop : 138633376,
      direction : "+",
      ID : "ENSG00000158234.12",
      gene_id : "ENSG00000158234.12",
      gene_type : "protein_coding",
      gene_name : "FAIM",
      gene_level : 2,
      hgnc_id : "HGNC:18703",
      havana_gene : "OTTHUMG00000159885.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138652698,
      stop : 138834928,
      direction : "-",
      ID : "ENSG00000051382.9",
      gene_id : "ENSG00000051382.9",
      gene_type : "protein_coding",
      gene_name : "PIK3CB",
      gene_level : 1,
      hgnc_id : "HGNC:8976",
      havana_gene : "OTTHUMG00000159893.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138944224,
      stop : 138947137,
      direction : "-",
      ID : "ENSG00000183770.7",
      gene_id : "ENSG00000183770.7",
      gene_type : "protein_coding",
      gene_name : "FOXL2",
      gene_level : 2,
      hgnc_id : "HGNC:1092",
      havana_gene : "OTTHUMG00000159889.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 138947217,
      stop : 138953990,
      direction : "+",
      ID : "ENSG00000206262.9",
      gene_id : "ENSG00000206262.9",
      gene_type : "protein_coding",
      gene_name : "FOXL2NB",
      gene_level : 2,
      hgnc_id : "HGNC:34428",
      havana_gene : "OTTHUMG00000159886.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139003962,
      stop : 139006268,
      direction : "-",
      ID : "ENSG00000206260.4",
      gene_id : "ENSG00000206260.4",
      gene_type : "protein_coding",
      gene_name : "PRR23A",
      gene_level : 2,
      hgnc_id : "HGNC:37172",
      havana_gene : "OTTHUMG00000160635.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139005806,
      stop : 139357223,
      direction : "+",
      ID : "ENSG00000175110.13",
      gene_id : "ENSG00000175110.13",
      gene_type : "protein_coding",
      gene_name : "MRPS22",
      gene_level : 1,
      hgnc_id : "HGNC:14508",
      havana_gene : "OTTHUMG00000159910.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139019031,
      stop : 139020926,
      direction : "-",
      ID : "ENSG00000184814.5",
      gene_id : "ENSG00000184814.5",
      gene_type : "protein_coding",
      gene_name : "PRR23B",
      gene_level : 2,
      hgnc_id : "HGNC:33764",
      havana_gene : "OTTHUMG00000160633.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139042102,
      stop : 139044892,
      direction : "-",
      ID : "ENSG00000233701.3",
      gene_id : "ENSG00000233701.3",
      gene_type : "protein_coding",
      gene_name : "PRR23C",
      gene_level : 2,
      hgnc_id : "HGNC:37173",
      havana_gene : "OTTHUMG00000160634.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139353946,
      stop : 139389736,
      direction : "-",
      ID : "ENSG00000184432.11",
      gene_id : "ENSG00000184432.11",
      gene_type : "protein_coding",
      gene_name : "COPB2",
      gene_level : 1,
      hgnc_id : "HGNC:2232",
      havana_gene : "OTTHUMG00000159959.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139452884,
      stop : 139480747,
      direction : "-",
      ID : "ENSG00000114113.6",
      gene_id : "ENSG00000114113.6",
      gene_type : "protein_coding",
      gene_name : "RBP2",
      gene_level : 2,
      hgnc_id : "HGNC:9920",
      havana_gene : "OTTHUMG00000159956.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139517434,
      stop : 139539829,
      direction : "-",
      ID : "ENSG00000114115.10",
      gene_id : "ENSG00000114115.10",
      gene_type : "protein_coding",
      gene_name : "RBP1",
      gene_level : 1,
      hgnc_id : "HGNC:9919",
      havana_gene : "OTTHUMG00000155751.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139560180,
      stop : 139678017,
      direction : "-",
      ID : "ENSG00000163864.17",
      gene_id : "ENSG00000163864.17",
      gene_type : "protein_coding",
      gene_name : "NMNAT3",
      gene_level : 1,
      hgnc_id : "HGNC:20989",
      havana_gene : "OTTHUMG00000159951.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 139935185,
      stop : 140577397,
      direction : "+",
      ID : "ENSG00000158258.16",
      gene_id : "ENSG00000158258.16",
      gene_type : "protein_coding",
      gene_name : "CLSTN2",
      gene_level : 2,
      hgnc_id : "HGNC:17448",
      havana_gene : "OTTHUMG00000160139.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 140678064,
      stop : 140701150,
      direction : "+",
      ID : "ENSG00000155890.4",
      gene_id : "ENSG00000155890.4",
      gene_type : "protein_coding",
      gene_name : "TRIM42",
      gene_level : 2,
      hgnc_id : "HGNC:19014",
      havana_gene : "OTTHUMG00000160170.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 140941830,
      stop : 140980995,
      direction : "+",
      ID : "ENSG00000114120.14",
      gene_id : "ENSG00000114120.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A36",
      gene_level : 1,
      hgnc_id : "HGNC:25554",
      havana_gene : "OTTHUMG00000160260.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141051347,
      stop : 141148611,
      direction : "+",
      ID : "ENSG00000175093.5",
      gene_id : "ENSG00000175093.5",
      gene_type : "protein_coding",
      gene_name : "SPSB4",
      gene_level : 1,
      hgnc_id : "HGNC:30630",
      havana_gene : "OTTHUMG00000160223.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141228726,
      stop : 141367753,
      direction : "+",
      ID : "ENSG00000155893.13",
      gene_id : "ENSG00000155893.13",
      gene_type : "protein_coding",
      gene_name : "PXYLP1",
      gene_level : 1,
      hgnc_id : "HGNC:26303",
      havana_gene : "OTTHUMG00000160171.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141324213,
      stop : 141449792,
      direction : "+",
      ID : "ENSG00000177311.11",
      gene_id : "ENSG00000177311.11",
      gene_type : "protein_coding",
      gene_name : "ZBTB38",
      gene_level : 1,
      hgnc_id : "HGNC:26636",
      havana_gene : "OTTHUMG00000160128.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141487027,
      stop : 141615344,
      direction : "+",
      ID : "ENSG00000155903.13",
      gene_id : "ENSG00000155903.13",
      gene_type : "protein_coding",
      gene_name : "RASA2",
      gene_level : 2,
      hgnc_id : "HGNC:9872",
      havana_gene : "OTTHUMG00000160221.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141738249,
      stop : 141747560,
      direction : "+",
      ID : "ENSG00000114125.14",
      gene_id : "ENSG00000114125.14",
      gene_type : "protein_coding",
      gene_name : "RNF7",
      gene_level : 1,
      hgnc_id : "HGNC:10070",
      havana_gene : "OTTHUMG00000141305.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141738474,
      stop : 141807919,
      direction : "+",
      ID : "ENSG00000285558.1",
      gene_id : "ENSG00000285558.1",
      gene_type : "protein_coding",
      gene_name : "AC112504.2",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000159068.3",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141778148,
      stop : 141818490,
      direction : "+",
      ID : "ENSG00000114124.2",
      gene_id : "ENSG00000114124.2",
      gene_type : "protein_coding",
      gene_name : "GRK7",
      gene_level : 2,
      hgnc_id : "HGNC:17031",
      havana_gene : "OTTHUMG00000193431.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141876124,
      stop : 141926549,
      direction : "+",
      ID : "ENSG00000069849.11",
      gene_id : "ENSG00000069849.11",
      gene_type : "protein_coding",
      gene_name : "ATP1B3",
      gene_level : 1,
      hgnc_id : "HGNC:806",
      havana_gene : "OTTHUMG00000159081.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 141944428,
      stop : 142149544,
      direction : "-",
      ID : "ENSG00000114126.18",
      gene_id : "ENSG00000114126.18",
      gene_type : "protein_coding",
      gene_name : "TFDP2",
      gene_level : 2,
      hgnc_id : "HGNC:11751",
      havana_gene : "OTTHUMG00000164975.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142157527,
      stop : 142225592,
      direction : "-",
      ID : "ENSG00000175066.16",
      gene_id : "ENSG00000175066.16",
      gene_type : "protein_coding",
      gene_name : "GK5",
      gene_level : 2,
      hgnc_id : "HGNC:28635",
      havana_gene : "OTTHUMG00000133572.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142306607,
      stop : 142448062,
      direction : "-",
      ID : "ENSG00000114127.11",
      gene_id : "ENSG00000114127.11",
      gene_type : "protein_coding",
      gene_name : "XRN1",
      gene_level : 1,
      hgnc_id : "HGNC:30654",
      havana_gene : "OTTHUMG00000159251.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142449007,
      stop : 142578733,
      direction : "-",
      ID : "ENSG00000175054.16",
      gene_id : "ENSG00000175054.16",
      gene_type : "protein_coding",
      gene_name : "ATR",
      gene_level : 2,
      hgnc_id : "HGNC:882",
      havana_gene : "OTTHUMG00000159234.32",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142596393,
      stop : 142713664,
      direction : "+",
      ID : "ENSG00000120756.13",
      gene_id : "ENSG00000120756.13",
      gene_type : "protein_coding",
      gene_name : "PLS1",
      gene_level : 2,
      hgnc_id : "HGNC:9090",
      havana_gene : "OTTHUMG00000159292.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142724034,
      stop : 142807888,
      direction : "+",
      ID : "ENSG00000144935.15",
      gene_id : "ENSG00000144935.15",
      gene_type : "protein_coding",
      gene_name : "TRPC1",
      gene_level : 2,
      hgnc_id : "HGNC:12333",
      havana_gene : "OTTHUMG00000159301.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142815922,
      stop : 142889206,
      direction : "-",
      ID : "ENSG00000163710.9",
      gene_id : "ENSG00000163710.9",
      gene_type : "protein_coding",
      gene_name : "PCOLCE2",
      gene_level : 1,
      hgnc_id : "HGNC:8739",
      havana_gene : "OTTHUMG00000159312.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142949164,
      stop : 142963674,
      direction : "-",
      ID : "ENSG00000188582.10",
      gene_id : "ENSG00000188582.10",
      gene_type : "protein_coding",
      gene_name : "PAQR9",
      gene_level : 2,
      hgnc_id : "HGNC:30131",
      havana_gene : "OTTHUMG00000159313.3",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 142964497,
      stop : 143060725,
      direction : "+",
      ID : "ENSG00000163714.18",
      gene_id : "ENSG00000163714.18",
      gene_type : "protein_coding",
      gene_name : "U2SURP",
      gene_level : 1,
      hgnc_id : "HGNC:30855",
      havana_gene : "OTTHUMG00000159323.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 143119771,
      stop : 143124014,
      direction : "+",
      ID : "ENSG00000175040.6",
      gene_id : "ENSG00000175040.6",
      gene_type : "protein_coding",
      gene_name : "CHST2",
      gene_level : 2,
      hgnc_id : "HGNC:1970",
      havana_gene : "OTTHUMG00000159351.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 143265222,
      stop : 143848485,
      direction : "-",
      ID : "ENSG00000181804.15",
      gene_id : "ENSG00000181804.15",
      gene_type : "protein_coding",
      gene_name : "SLC9A9",
      gene_level : 2,
      hgnc_id : "HGNC:20653",
      havana_gene : "OTTHUMG00000159373.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 143971823,
      stop : 144048719,
      direction : "+",
      ID : "ENSG00000181744.9",
      gene_id : "ENSG00000181744.9",
      gene_type : "protein_coding",
      gene_name : "DIPK2A",
      gene_level : 1,
      hgnc_id : "HGNC:28490",
      havana_gene : "OTTHUMG00000159380.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 146069440,
      stop : 146163653,
      direction : "-",
      ID : "ENSG00000152952.12",
      gene_id : "ENSG00000152952.12",
      gene_type : "protein_coding",
      gene_name : "PLOD2",
      gene_level : 2,
      hgnc_id : "HGNC:9082",
      havana_gene : "OTTHUMG00000159417.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 146192335,
      stop : 146251179,
      direction : "-",
      ID : "ENSG00000114698.15",
      gene_id : "ENSG00000114698.15",
      gene_type : "protein_coding",
      gene_name : "PLSCR4",
      gene_level : 2,
      hgnc_id : "HGNC:16497",
      havana_gene : "OTTHUMG00000159415.15",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 146391421,
      stop : 146495991,
      direction : "-",
      ID : "ENSG00000163746.12",
      gene_id : "ENSG00000163746.12",
      gene_type : "protein_coding",
      gene_name : "PLSCR2",
      gene_level : 1,
      hgnc_id : "HGNC:16494",
      havana_gene : "OTTHUMG00000159429.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 146515180,
      stop : 146544856,
      direction : "-",
      ID : "ENSG00000188313.13",
      gene_id : "ENSG00000188313.13",
      gene_type : "protein_coding",
      gene_name : "PLSCR1",
      gene_level : 2,
      hgnc_id : "HGNC:9092",
      havana_gene : "OTTHUMG00000159427.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 146576555,
      stop : 146605346,
      direction : "-",
      ID : "ENSG00000231213.7",
      gene_id : "ENSG00000231213.7",
      gene_type : "protein_coding",
      gene_name : "PLSCR5",
      gene_level : 2,
      hgnc_id : "HGNC:19952",
      havana_gene : "OTTHUMG00000159437.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 147386046,
      stop : 147406809,
      direction : "-",
      ID : "ENSG00000174963.18",
      gene_id : "ENSG00000174963.18",
      gene_type : "protein_coding",
      gene_name : "ZIC4",
      gene_level : 1,
      hgnc_id : "HGNC:20393",
      havana_gene : "OTTHUMG00000037281.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 147393422,
      stop : 147510293,
      direction : "+",
      ID : "ENSG00000152977.10",
      gene_id : "ENSG00000152977.10",
      gene_type : "protein_coding",
      gene_name : "ZIC1",
      gene_level : 1,
      hgnc_id : "HGNC:12872",
      havana_gene : "OTTHUMG00000159456.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 148697784,
      stop : 148743008,
      direction : "+",
      ID : "ENSG00000144891.19",
      gene_id : "ENSG00000144891.19",
      gene_type : "protein_coding",
      gene_name : "AGTR1",
      gene_level : 2,
      hgnc_id : "HGNC:336",
      havana_gene : "OTTHUMG00000159503.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 148791102,
      stop : 148860187,
      direction : "+",
      ID : "ENSG00000153002.12",
      gene_id : "ENSG00000153002.12",
      gene_type : "protein_coding",
      gene_name : "CPB1",
      gene_level : 1,
      hgnc_id : "HGNC:2299",
      havana_gene : "OTTHUMG00000159520.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 148865296,
      stop : 148897203,
      direction : "+",
      ID : "ENSG00000163751.4",
      gene_id : "ENSG00000163751.4",
      gene_type : "protein_coding",
      gene_name : "CPA3",
      gene_level : 2,
      hgnc_id : "HGNC:2298",
      havana_gene : "OTTHUMG00000159526.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 148991408,
      stop : 149031775,
      direction : "+",
      ID : "ENSG00000163754.18",
      gene_id : "ENSG00000163754.18",
      gene_type : "protein_coding",
      gene_name : "GYG1",
      gene_level : 1,
      hgnc_id : "HGNC:4699",
      havana_gene : "OTTHUMG00000159533.22",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149030127,
      stop : 149086554,
      direction : "-",
      ID : "ENSG00000071794.16",
      gene_id : "ENSG00000071794.16",
      gene_type : "protein_coding",
      gene_name : "HLTF",
      gene_level : 1,
      hgnc_id : "HGNC:11099",
      havana_gene : "OTTHUMG00000159534.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149129638,
      stop : 149173732,
      direction : "+",
      ID : "ENSG00000163755.9",
      gene_id : "ENSG00000163755.9",
      gene_type : "protein_coding",
      gene_name : "HPS3",
      gene_level : 1,
      hgnc_id : "HGNC:15597",
      havana_gene : "OTTHUMG00000159548.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149162410,
      stop : 149221829,
      direction : "-",
      ID : "ENSG00000047457.14",
      gene_id : "ENSG00000047457.14",
      gene_type : "protein_coding",
      gene_name : "CP",
      gene_level : 1,
      hgnc_id : "HGNC:2295",
      havana_gene : "OTTHUMG00000159563.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149318498,
      stop : 149334414,
      direction : "-",
      ID : "ENSG00000163762.7",
      gene_id : "ENSG00000163762.7",
      gene_type : "protein_coding",
      gene_name : "TM4SF18",
      gene_level : 2,
      hgnc_id : "HGNC:25181",
      havana_gene : "OTTHUMG00000159582.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149369022,
      stop : 149377692,
      direction : "-",
      ID : "ENSG00000169908.12",
      gene_id : "ENSG00000169908.12",
      gene_type : "protein_coding",
      gene_name : "TM4SF1",
      gene_level : 2,
      hgnc_id : "HGNC:11853",
      havana_gene : "OTTHUMG00000159597.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149474697,
      stop : 149503394,
      direction : "+",
      ID : "ENSG00000169903.7",
      gene_id : "ENSG00000169903.7",
      gene_type : "protein_coding",
      gene_name : "TM4SF4",
      gene_level : 1,
      hgnc_id : "HGNC:11856",
      havana_gene : "OTTHUMG00000159619.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149517235,
      stop : 149736714,
      direction : "-",
      ID : "ENSG00000018408.15",
      gene_id : "ENSG00000018408.15",
      gene_type : "protein_coding",
      gene_name : "WWTR1",
      gene_level : 1,
      hgnc_id : "HGNC:24042",
      havana_gene : "OTTHUMG00000159614.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149738472,
      stop : 149752495,
      direction : "-",
      ID : "ENSG00000114744.9",
      gene_id : "ENSG00000114744.9",
      gene_type : "protein_coding",
      gene_name : "COMMD2",
      gene_level : 2,
      hgnc_id : "HGNC:24993",
      havana_gene : "OTTHUMG00000159616.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149761100,
      stop : 149968385,
      direction : "-",
      ID : "ENSG00000206199.11",
      gene_id : "ENSG00000206199.11",
      gene_type : "protein_coding",
      gene_name : "ANKUB1",
      gene_level : 1,
      hgnc_id : "HGNC:29642",
      havana_gene : "OTTHUMG00000159615.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149812770,
      stop : 149962139,
      direction : "+",
      ID : "ENSG00000082996.20",
      gene_id : "ENSG00000082996.20",
      gene_type : "protein_coding",
      gene_name : "RNF13",
      gene_level : 2,
      hgnc_id : "HGNC:10057",
      havana_gene : "OTTHUMG00000150338.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 149964904,
      stop : 150050788,
      direction : "-",
      ID : "ENSG00000070087.14",
      gene_id : "ENSG00000070087.14",
      gene_type : "protein_coding",
      gene_name : "PFN2",
      gene_level : 1,
      hgnc_id : "HGNC:8882",
      havana_gene : "OTTHUMG00000159683.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150408335,
      stop : 150466431,
      direction : "+",
      ID : "ENSG00000196428.12",
      gene_id : "ENSG00000196428.12",
      gene_type : "protein_coding",
      gene_name : "TSC22D2",
      gene_level : 2,
      hgnc_id : "HGNC:29095",
      havana_gene : "OTTHUMG00000159744.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150541998,
      stop : 150603228,
      direction : "-",
      ID : "ENSG00000120742.11",
      gene_id : "ENSG00000120742.11",
      gene_type : "protein_coding",
      gene_name : "SERP1",
      gene_level : 1,
      hgnc_id : "HGNC:10759",
      havana_gene : "OTTHUMG00000159769.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150546678,
      stop : 150586016,
      direction : "+",
      ID : "ENSG00000144895.12",
      gene_id : "ENSG00000144895.12",
      gene_type : "protein_coding",
      gene_name : "EIF2A",
      gene_level : 1,
      hgnc_id : "HGNC:3254",
      havana_gene : "OTTHUMG00000159775.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150602875,
      stop : 150630445,
      direction : "+",
      ID : "ENSG00000198843.13",
      gene_id : "ENSG00000198843.13",
      gene_type : "protein_coding",
      gene_name : "SELENOT",
      gene_level : 1,
      hgnc_id : "HGNC:18136",
      havana_gene : "OTTHUMG00000159825.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150659885,
      stop : 150703971,
      direction : "-",
      ID : "ENSG00000163645.15",
      gene_id : "ENSG00000163645.15",
      gene_type : "protein_coding",
      gene_name : "ERICH6",
      gene_level : 2,
      hgnc_id : "HGNC:28602",
      havana_gene : "OTTHUMG00000133569.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150741125,
      stop : 150763477,
      direction : "-",
      ID : "ENSG00000181788.4",
      gene_id : "ENSG00000181788.4",
      gene_type : "protein_coding",
      gene_name : "SIAH2",
      gene_level : 1,
      hgnc_id : "HGNC:10858",
      havana_gene : "OTTHUMG00000159847.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150870376,
      stop : 150905439,
      direction : "-",
      ID : "ENSG00000214237.11",
      gene_id : "ENSG00000214237.11",
      gene_type : "protein_coding",
      gene_name : "MINDY4B",
      gene_level : 2,
      hgnc_id : "HGNC:35475",
      havana_gene : "OTTHUMG00000159843.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150882997,
      stop : 150941743,
      direction : "-",
      ID : "ENSG00000260234.5",
      gene_id : "ENSG00000260234.5",
      gene_type : "protein_coding",
      gene_name : "AC020636.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000175578.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 150926163,
      stop : 150972727,
      direction : "-",
      ID : "ENSG00000163646.12",
      gene_id : "ENSG00000163646.12",
      gene_type : "protein_coding",
      gene_name : "CLRN1",
      gene_level : 2,
      hgnc_id : "HGNC:12605",
      havana_gene : "OTTHUMG00000140368.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151085697,
      stop : 151437072,
      direction : "+",
      ID : "ENSG00000144893.12",
      gene_id : "ENSG00000144893.12",
      gene_type : "protein_coding",
      gene_name : "MED12L",
      gene_level : 1,
      hgnc_id : "HGNC:16050",
      havana_gene : "OTTHUMG00000159844.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151197832,
      stop : 151203216,
      direction : "-",
      ID : "ENSG00000174946.7",
      gene_id : "ENSG00000174946.7",
      gene_type : "protein_coding",
      gene_name : "GPR171",
      gene_level : 2,
      hgnc_id : "HGNC:30057",
      havana_gene : "OTTHUMG00000159861.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151212117,
      stop : 151278542,
      direction : "-",
      ID : "ENSG00000174944.9",
      gene_id : "ENSG00000174944.9",
      gene_type : "protein_coding",
      gene_name : "P2RY14",
      gene_level : 2,
      hgnc_id : "HGNC:16442",
      havana_gene : "OTTHUMG00000159859.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151294086,
      stop : 151316820,
      direction : "-",
      ID : "ENSG00000138271.6",
      gene_id : "ENSG00000138271.6",
      gene_type : "protein_coding",
      gene_name : "GPR87",
      gene_level : 2,
      hgnc_id : "HGNC:4538",
      havana_gene : "OTTHUMG00000159858.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151326312,
      stop : 151329549,
      direction : "-",
      ID : "ENSG00000181631.7",
      gene_id : "ENSG00000181631.7",
      gene_type : "protein_coding",
      gene_name : "P2RY13",
      gene_level : 2,
      hgnc_id : "HGNC:4537",
      havana_gene : "OTTHUMG00000155745.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151336843,
      stop : 151384753,
      direction : "-",
      ID : "ENSG00000169313.10",
      gene_id : "ENSG00000169313.10",
      gene_type : "protein_coding",
      gene_name : "P2RY12",
      gene_level : 2,
      hgnc_id : "HGNC:18124",
      havana_gene : "OTTHUMG00000159863.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151425384,
      stop : 151458709,
      direction : "-",
      ID : "ENSG00000152580.8",
      gene_id : "ENSG00000152580.8",
      gene_type : "protein_coding",
      gene_name : "IGSF10",
      gene_level : 1,
      hgnc_id : "HGNC:26384",
      havana_gene : "OTTHUMG00000159856.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151733916,
      stop : 151761339,
      direction : "+",
      ID : "ENSG00000197953.6",
      gene_id : "ENSG00000197953.6",
      gene_type : "protein_coding",
      gene_name : "AADACL2",
      gene_level : 2,
      hgnc_id : "HGNC:24427",
      havana_gene : "OTTHUMG00000155914.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151814073,
      stop : 151828488,
      direction : "+",
      ID : "ENSG00000114771.14",
      gene_id : "ENSG00000114771.14",
      gene_type : "protein_coding",
      gene_name : "AADAC",
      gene_level : 2,
      hgnc_id : "HGNC:17",
      havana_gene : "OTTHUMG00000159876.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 151873643,
      stop : 151884619,
      direction : "+",
      ID : "ENSG00000198829.6",
      gene_id : "ENSG00000198829.6",
      gene_type : "protein_coding",
      gene_name : "SUCNR1",
      gene_level : 2,
      hgnc_id : "HGNC:4542",
      havana_gene : "OTTHUMG00000159880.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 152243828,
      stop : 152465780,
      direction : "+",
      ID : "ENSG00000152601.17",
      gene_id : "ENSG00000152601.17",
      gene_type : "protein_coding",
      gene_name : "MBNL1",
      gene_level : 1,
      hgnc_id : "HGNC:6923",
      havana_gene : "OTTHUMG00000159163.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 152835131,
      stop : 152841439,
      direction : "+",
      ID : "ENSG00000169860.7",
      gene_id : "ENSG00000169860.7",
      gene_type : "protein_coding",
      gene_name : "P2RY1",
      gene_level : 2,
      hgnc_id : "HGNC:8539",
      havana_gene : "OTTHUMG00000159694.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 153162226,
      stop : 153170627,
      direction : "+",
      ID : "ENSG00000181467.5",
      gene_id : "ENSG00000181467.5",
      gene_type : "protein_coding",
      gene_name : "RAP2B",
      gene_level : 2,
      hgnc_id : "HGNC:9862",
      havana_gene : "OTTHUMG00000159655.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 154121003,
      stop : 154257827,
      direction : "+",
      ID : "ENSG00000114790.13",
      gene_id : "ENSG00000114790.13",
      gene_type : "protein_coding",
      gene_name : "ARHGEF26",
      gene_level : 2,
      hgnc_id : "HGNC:24490",
      havana_gene : "OTTHUMG00000159098.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 154272546,
      stop : 154324487,
      direction : "-",
      ID : "ENSG00000174953.14",
      gene_id : "ENSG00000174953.14",
      gene_type : "protein_coding",
      gene_name : "DHX36",
      gene_level : 1,
      hgnc_id : "HGNC:14410",
      havana_gene : "OTTHUMG00000159109.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 154334943,
      stop : 154430190,
      direction : "-",
      ID : "ENSG00000174948.6",
      gene_id : "ENSG00000174948.6",
      gene_type : "protein_coding",
      gene_name : "GPR149",
      gene_level : 2,
      hgnc_id : "HGNC:23627",
      havana_gene : "OTTHUMG00000159131.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155024124,
      stop : 155183704,
      direction : "+",
      ID : "ENSG00000196549.13",
      gene_id : "ENSG00000196549.13",
      gene_type : "protein_coding",
      gene_name : "MME",
      gene_level : 1,
      hgnc_id : "HGNC:7154",
      havana_gene : "OTTHUMG00000158455.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155290227,
      stop : 155293683,
      direction : "-",
      ID : "ENSG00000240045.2",
      gene_id : "ENSG00000240045.2",
      gene_type : "protein_coding",
      gene_name : "STRIT1",
      gene_level : 1,
      hgnc_id : "HGNC:52297",
      havana_gene : "OTTHUMG00000158471.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155375580,
      stop : 155745071,
      direction : "-",
      ID : "ENSG00000114805.18",
      gene_id : "ENSG00000114805.18",
      gene_type : "protein_coding",
      gene_name : "PLCH1",
      gene_level : 2,
      hgnc_id : "HGNC:29185",
      havana_gene : "OTTHUMG00000158477.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155762617,
      stop : 155806278,
      direction : "-",
      ID : "ENSG00000174928.16",
      gene_id : "ENSG00000174928.16",
      gene_type : "protein_coding",
      gene_name : "C3orf33",
      gene_level : 2,
      hgnc_id : "HGNC:26434",
      havana_gene : "OTTHUMG00000158496.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155763043,
      stop : 155854442,
      direction : "-",
      ID : "ENSG00000284952.1",
      gene_id : "ENSG00000284952.1",
      gene_type : "protein_coding",
      gene_name : "AC104472.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192576.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155821024,
      stop : 155854456,
      direction : "-",
      ID : "ENSG00000169359.16",
      gene_id : "ENSG00000169359.16",
      gene_type : "protein_coding",
      gene_name : "SLC33A1",
      gene_level : 1,
      hgnc_id : "HGNC:95",
      havana_gene : "OTTHUMG00000158481.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 155870650,
      stop : 155944020,
      direction : "+",
      ID : "ENSG00000163655.16",
      gene_id : "ENSG00000163655.16",
      gene_type : "protein_coding",
      gene_name : "GMPS",
      gene_level : 2,
      hgnc_id : "HGNC:4378",
      havana_gene : "OTTHUMG00000158551.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 156037701,
      stop : 156539138,
      direction : "+",
      ID : "ENSG00000169282.18",
      gene_id : "ENSG00000169282.18",
      gene_type : "protein_coding",
      gene_name : "KCNAB1",
      gene_level : 2,
      hgnc_id : "HGNC:6228",
      havana_gene : "OTTHUMG00000158552.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 156539553,
      stop : 156555149,
      direction : "-",
      ID : "ENSG00000114850.7",
      gene_id : "ENSG00000114850.7",
      gene_type : "protein_coding",
      gene_name : "SSR3",
      gene_level : 1,
      hgnc_id : "HGNC:11325",
      havana_gene : "OTTHUMG00000158632.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 156673235,
      stop : 156706770,
      direction : "+",
      ID : "ENSG00000163659.13",
      gene_id : "ENSG00000163659.13",
      gene_type : "protein_coding",
      gene_name : "TIPARP",
      gene_level : 2,
      hgnc_id : "HGNC:23696",
      havana_gene : "OTTHUMG00000158646.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 156825481,
      stop : 157046129,
      direction : "+",
      ID : "ENSG00000197980.13",
      gene_id : "ENSG00000197980.13",
      gene_type : "protein_coding",
      gene_name : "LEKR1",
      gene_level : 1,
      hgnc_id : "HGNC:33765",
      havana_gene : "OTTHUMG00000160130.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 157146508,
      stop : 157160760,
      direction : "-",
      ID : "ENSG00000163660.12",
      gene_id : "ENSG00000163660.12",
      gene_type : "protein_coding",
      gene_name : "CCNL1",
      gene_level : 2,
      hgnc_id : "HGNC:20569",
      havana_gene : "OTTHUMG00000158713.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 157259742,
      stop : 157533619,
      direction : "-",
      ID : "ENSG00000197415.12",
      gene_id : "ENSG00000197415.12",
      gene_type : "protein_coding",
      gene_name : "VEPH1",
      gene_level : 1,
      hgnc_id : "HGNC:25735",
      havana_gene : "OTTHUMG00000158711.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 157436850,
      stop : 157443633,
      direction : "+",
      ID : "ENSG00000163661.4",
      gene_id : "ENSG00000163661.4",
      gene_type : "protein_coding",
      gene_name : "PTX3",
      gene_level : 2,
      hgnc_id : "HGNC:9692",
      havana_gene : "OTTHUMG00000158750.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158095905,
      stop : 158106420,
      direction : "-",
      ID : "ENSG00000168779.20",
      gene_id : "ENSG00000168779.20",
      gene_type : "protein_coding",
      gene_name : "SHOX2",
      gene_level : 2,
      hgnc_id : "HGNC:10854",
      havana_gene : "OTTHUMG00000158755.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158105855,
      stop : 158545730,
      direction : "+",
      ID : "ENSG00000174891.13",
      gene_id : "ENSG00000174891.13",
      gene_type : "protein_coding",
      gene_name : "RSRC1",
      gene_level : 1,
      hgnc_id : "HGNC:24152",
      havana_gene : "OTTHUMG00000158758.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158571163,
      stop : 158607252,
      direction : "+",
      ID : "ENSG00000178053.20",
      gene_id : "ENSG00000178053.20",
      gene_type : "protein_coding",
      gene_name : "MLF1",
      gene_level : 1,
      hgnc_id : "HGNC:7125",
      havana_gene : "OTTHUMG00000158775.16",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158644527,
      stop : 158695581,
      direction : "+",
      ID : "ENSG00000168827.15",
      gene_id : "ENSG00000168827.15",
      gene_type : "protein_coding",
      gene_name : "GFM1",
      gene_level : 1,
      hgnc_id : "HGNC:13780",
      havana_gene : "OTTHUMG00000158804.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158645822,
      stop : 158672648,
      direction : "-",
      ID : "ENSG00000079257.8",
      gene_id : "ENSG00000079257.8",
      gene_type : "protein_coding",
      gene_name : "LXN",
      gene_level : 2,
      hgnc_id : "HGNC:13347",
      havana_gene : "OTTHUMG00000158807.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158696892,
      stop : 158732489,
      direction : "-",
      ID : "ENSG00000118849.10",
      gene_id : "ENSG00000118849.10",
      gene_type : "protein_coding",
      gene_name : "RARRES1",
      gene_level : 1,
      hgnc_id : "HGNC:9867",
      havana_gene : "OTTHUMG00000158834.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158732198,
      stop : 158829719,
      direction : "+",
      ID : "ENSG00000118855.21",
      gene_id : "ENSG00000118855.21",
      gene_type : "protein_coding",
      gene_name : "MFSD1",
      gene_level : 1,
      hgnc_id : "HGNC:25874",
      havana_gene : "OTTHUMG00000158835.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158962235,
      stop : 159897366,
      direction : "+",
      ID : "ENSG00000283154.2",
      gene_id : "ENSG00000283154.2",
      gene_type : "protein_coding",
      gene_name : "IQCJ-SCHIP1",
      gene_level : 2,
      hgnc_id : "HGNC:38842",
      havana_gene : "OTTHUMG00000162426.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 158962928,
      stop : 159266307,
      direction : "+",
      ID : "ENSG00000214216.11",
      gene_id : "ENSG00000214216.11",
      gene_type : "protein_coding",
      gene_name : "IQCJ",
      gene_level : 1,
      hgnc_id : "HGNC:32406",
      havana_gene : "OTTHUMG00000166440.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 159839861,
      stop : 159897360,
      direction : "+",
      ID : "ENSG00000151967.18",
      gene_id : "ENSG00000151967.18",
      gene_type : "protein_coding",
      gene_name : "SCHIP1",
      gene_level : 1,
      hgnc_id : "HGNC:15678",
      havana_gene : "OTTHUMG00000158934.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 159988835,
      stop : 159996019,
      direction : "+",
      ID : "ENSG00000168811.7",
      gene_id : "ENSG00000168811.7",
      gene_type : "protein_coding",
      gene_name : "IL12A",
      gene_level : 2,
      hgnc_id : "HGNC:5969",
      havana_gene : "OTTHUMG00000158942.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160225422,
      stop : 160228213,
      direction : "+",
      ID : "ENSG00000180044.6",
      gene_id : "ENSG00000180044.6",
      gene_type : "protein_coding",
      gene_name : "C3orf80",
      gene_level : 2,
      hgnc_id : "HGNC:40048",
      havana_gene : "OTTHUMG00000158950.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160227454,
      stop : 160449829,
      direction : "-",
      ID : "ENSG00000248710.1",
      gene_id : "ENSG00000248710.1",
      gene_type : "protein_coding",
      gene_name : "AC079594.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162252.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160256986,
      stop : 160399880,
      direction : "-",
      ID : "ENSG00000068885.15",
      gene_id : "ENSG00000068885.15",
      gene_type : "protein_coding",
      gene_name : "IFT80",
      gene_level : 1,
      hgnc_id : "HGNC:29262",
      havana_gene : "OTTHUMG00000158953.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160399274,
      stop : 160434954,
      direction : "+",
      ID : "ENSG00000113810.16",
      gene_id : "ENSG00000113810.16",
      gene_type : "protein_coding",
      gene_name : "SMC4",
      gene_level : 1,
      hgnc_id : "HGNC:14013",
      havana_gene : "OTTHUMG00000159006.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160432445,
      stop : 160485773,
      direction : "-",
      ID : "ENSG00000213186.8",
      gene_id : "ENSG00000213186.8",
      gene_type : "protein_coding",
      gene_name : "TRIM59",
      gene_level : 2,
      hgnc_id : "HGNC:30834",
      havana_gene : "OTTHUMG00000159034.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160495007,
      stop : 160565571,
      direction : "-",
      ID : "ENSG00000186432.10",
      gene_id : "ENSG00000186432.10",
      gene_type : "protein_coding",
      gene_name : "KPNA4",
      gene_level : 1,
      hgnc_id : "HGNC:6397",
      havana_gene : "OTTHUMG00000159033.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160677160,
      stop : 160678448,
      direction : "+",
      ID : "ENSG00000179674.4",
      gene_id : "ENSG00000179674.4",
      gene_type : "protein_coding",
      gene_name : "ARL14",
      gene_level : 2,
      hgnc_id : "HGNC:22974",
      havana_gene : "OTTHUMG00000159031.2",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 160755602,
      stop : 161078902,
      direction : "+",
      ID : "ENSG00000163590.14",
      gene_id : "ENSG00000163590.14",
      gene_type : "protein_coding",
      gene_name : "PPM1L",
      gene_level : 2,
      hgnc_id : "HGNC:16381",
      havana_gene : "OTTHUMG00000159048.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 161083883,
      stop : 161105411,
      direction : "-",
      ID : "ENSG00000169255.15",
      gene_id : "ENSG00000169255.15",
      gene_type : "protein_coding",
      gene_name : "B3GALNT1",
      gene_level : 1,
      hgnc_id : "HGNC:918",
      havana_gene : "OTTHUMG00000159064.39",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 161104696,
      stop : 161253532,
      direction : "+",
      ID : "ENSG00000169251.13",
      gene_id : "ENSG00000169251.13",
      gene_type : "protein_coding",
      gene_name : "NMD3",
      gene_level : 2,
      hgnc_id : "HGNC:24250",
      havana_gene : "OTTHUMG00000159063.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 161344792,
      stop : 161372880,
      direction : "-",
      ID : "ENSG00000196542.8",
      gene_id : "ENSG00000196542.8",
      gene_type : "protein_coding",
      gene_name : "SPTSSB",
      gene_level : 2,
      hgnc_id : "HGNC:24045",
      havana_gene : "OTTHUMG00000159073.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 161496808,
      stop : 161503942,
      direction : "+",
      ID : "ENSG00000182447.4",
      gene_id : "ENSG00000182447.4",
      gene_type : "protein_coding",
      gene_name : "OTOL1",
      gene_level : 2,
      hgnc_id : "HGNC:34071",
      havana_gene : "OTTHUMG00000159074.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 164978898,
      stop : 165078496,
      direction : "-",
      ID : "ENSG00000090402.8",
      gene_id : "ENSG00000090402.8",
      gene_type : "protein_coding",
      gene_name : "SI",
      gene_level : 2,
      hgnc_id : "HGNC:10856",
      havana_gene : "OTTHUMG00000158065.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 165186720,
      stop : 165197109,
      direction : "-",
      ID : "ENSG00000121871.4",
      gene_id : "ENSG00000121871.4",
      gene_type : "protein_coding",
      gene_name : "SLITRK3",
      gene_level : 2,
      hgnc_id : "HGNC:23501",
      havana_gene : "OTTHUMG00000158072.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 165772904,
      stop : 165837462,
      direction : "-",
      ID : "ENSG00000114200.10",
      gene_id : "ENSG00000114200.10",
      gene_type : "protein_coding",
      gene_name : "BCHE",
      gene_level : 1,
      hgnc_id : "HGNC:983",
      havana_gene : "OTTHUMG00000158131.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 167239843,
      stop : 167407874,
      direction : "-",
      ID : "ENSG00000169064.13",
      gene_id : "ENSG00000169064.13",
      gene_type : "protein_coding",
      gene_name : "ZBBX",
      gene_level : 1,
      hgnc_id : "HGNC:26245",
      havana_gene : "OTTHUMG00000133560.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 167441789,
      stop : 167479004,
      direction : "-",
      ID : "ENSG00000114204.15",
      gene_id : "ENSG00000114204.15",
      gene_type : "protein_coding",
      gene_name : "SERPINI2",
      gene_level : 1,
      hgnc_id : "HGNC:8945",
      havana_gene : "OTTHUMG00000158231.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 167478684,
      stop : 167653983,
      direction : "-",
      ID : "ENSG00000174776.11",
      gene_id : "ENSG00000174776.11",
      gene_type : "protein_coding",
      gene_name : "WDR49",
      gene_level : 1,
      hgnc_id : "HGNC:26587",
      havana_gene : "OTTHUMG00000158290.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 167683298,
      stop : 167734939,
      direction : "-",
      ID : "ENSG00000114209.15",
      gene_id : "ENSG00000114209.15",
      gene_type : "protein_coding",
      gene_name : "PDCD10",
      gene_level : 1,
      hgnc_id : "HGNC:8761",
      havana_gene : "OTTHUMG00000158415.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 167735243,
      stop : 167825569,
      direction : "+",
      ID : "ENSG00000163536.13",
      gene_id : "ENSG00000163536.13",
      gene_type : "protein_coding",
      gene_name : "SERPINI1",
      gene_level : 2,
      hgnc_id : "HGNC:8943",
      havana_gene : "OTTHUMG00000158450.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 168008689,
      stop : 168095924,
      direction : "-",
      ID : "ENSG00000173905.9",
      gene_id : "ENSG00000173905.9",
      gene_type : "protein_coding",
      gene_name : "GOLIM4",
      gene_level : 1,
      hgnc_id : "HGNC:15448",
      havana_gene : "OTTHUMG00000158554.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169083499,
      stop : 169663775,
      direction : "-",
      ID : "ENSG00000085276.19",
      gene_id : "ENSG00000085276.19",
      gene_type : "protein_coding",
      gene_name : "MECOM",
      gene_level : 1,
      hgnc_id : "HGNC:3498",
      havana_gene : "OTTHUMG00000158596.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169766921,
      stop : 169769561,
      direction : "-",
      ID : "ENSG00000184378.3",
      gene_id : "ENSG00000184378.3",
      gene_type : "protein_coding",
      gene_name : "ACTRT3",
      gene_level : 2,
      hgnc_id : "HGNC:24022",
      havana_gene : "OTTHUMG00000184025.2",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169773396,
      stop : 169789716,
      direction : "+",
      ID : "ENSG00000085274.16",
      gene_id : "ENSG00000085274.16",
      gene_type : "protein_coding",
      gene_name : "MYNN",
      gene_level : 2,
      hgnc_id : "HGNC:14955",
      havana_gene : "OTTHUMG00000184027.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169793003,
      stop : 169812986,
      direction : "-",
      ID : "ENSG00000171757.17",
      gene_id : "ENSG00000171757.17",
      gene_type : "protein_coding",
      gene_name : "LRRC34",
      gene_level : 1,
      hgnc_id : "HGNC:28408",
      havana_gene : "OTTHUMG00000164419.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169821922,
      stop : 169837775,
      direction : "+",
      ID : "ENSG00000188306.6",
      gene_id : "ENSG00000188306.6",
      gene_type : "protein_coding",
      gene_name : "LRRIQ4",
      gene_level : 2,
      hgnc_id : "HGNC:34298",
      havana_gene : "OTTHUMG00000164420.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169839172,
      stop : 169869935,
      direction : "-",
      ID : "ENSG00000114248.10",
      gene_id : "ENSG00000114248.10",
      gene_type : "protein_coding",
      gene_name : "LRRC31",
      gene_level : 1,
      hgnc_id : "HGNC:26261",
      havana_gene : "OTTHUMG00000164421.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169911572,
      stop : 169939175,
      direction : "+",
      ID : "ENSG00000187033.9",
      gene_id : "ENSG00000187033.9",
      gene_type : "protein_coding",
      gene_name : "SAMD7",
      gene_level : 2,
      hgnc_id : "HGNC:25394",
      havana_gene : "OTTHUMG00000158730.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 169966635,
      stop : 169998373,
      direction : "+",
      ID : "ENSG00000008952.17",
      gene_id : "ENSG00000008952.17",
      gene_type : "protein_coding",
      gene_name : "SEC62",
      gene_level : 1,
      hgnc_id : "HGNC:11846",
      havana_gene : "OTTHUMG00000158753.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170037995,
      stop : 170085392,
      direction : "+",
      ID : "ENSG00000173890.17",
      gene_id : "ENSG00000173890.17",
      gene_type : "protein_coding",
      gene_name : "GPR160",
      gene_level : 1,
      hgnc_id : "HGNC:23693",
      havana_gene : "OTTHUMG00000158776.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170086732,
      stop : 170181749,
      direction : "-",
      ID : "ENSG00000173889.16",
      gene_id : "ENSG00000173889.16",
      gene_type : "protein_coding",
      gene_name : "PHC3",
      gene_level : 2,
      hgnc_id : "HGNC:15682",
      havana_gene : "OTTHUMG00000158777.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170222424,
      stop : 170305977,
      direction : "+",
      ID : "ENSG00000163558.13",
      gene_id : "ENSG00000163558.13",
      gene_type : "protein_coding",
      gene_name : "PRKCI",
      gene_level : 2,
      hgnc_id : "HGNC:9404",
      havana_gene : "OTTHUMG00000150214.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170357678,
      stop : 170396835,
      direction : "+",
      ID : "ENSG00000136603.14",
      gene_id : "ENSG00000136603.14",
      gene_type : "protein_coding",
      gene_name : "SKIL",
      gene_level : 1,
      hgnc_id : "HGNC:10897",
      havana_gene : "OTTHUMG00000158831.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170418868,
      stop : 170454733,
      direction : "+",
      ID : "ENSG00000013297.12",
      gene_id : "ENSG00000013297.12",
      gene_type : "protein_coding",
      gene_name : "CLDN11",
      gene_level : 1,
      hgnc_id : "HGNC:8514",
      havana_gene : "OTTHUMG00000158940.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170418868,
      stop : 170860380,
      direction : "+",
      ID : "ENSG00000285218.1",
      gene_id : "ENSG00000285218.1",
      gene_type : "protein_coding",
      gene_name : "AC026316.4",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192431.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170459548,
      stop : 170586075,
      direction : "-",
      ID : "ENSG00000013293.6",
      gene_id : "ENSG00000013293.6",
      gene_type : "protein_coding",
      gene_name : "SLC7A14",
      gene_level : 1,
      hgnc_id : "HGNC:29326",
      havana_gene : "OTTHUMG00000158941.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170864875,
      stop : 170870208,
      direction : "-",
      ID : "ENSG00000163584.18",
      gene_id : "ENSG00000163584.18",
      gene_type : "protein_coding",
      gene_name : "RPL22L1",
      gene_level : 2,
      hgnc_id : "HGNC:27610",
      havana_gene : "OTTHUMG00000158957.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170888418,
      stop : 170908644,
      direction : "-",
      ID : "ENSG00000163577.8",
      gene_id : "ENSG00000163577.8",
      gene_type : "protein_coding",
      gene_name : "EIF5A2",
      gene_level : 1,
      hgnc_id : "HGNC:3301",
      havana_gene : "OTTHUMG00000158958.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 170996347,
      stop : 171026743,
      direction : "-",
      ID : "ENSG00000163581.14",
      gene_id : "ENSG00000163581.14",
      gene_type : "protein_coding",
      gene_name : "SLC2A2",
      gene_level : 2,
      hgnc_id : "HGNC:11006",
      havana_gene : "OTTHUMG00000158997.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 171058414,
      stop : 171460408,
      direction : "-",
      ID : "ENSG00000154310.17",
      gene_id : "ENSG00000154310.17",
      gene_type : "protein_coding",
      gene_name : "TNIK",
      gene_level : 1,
      hgnc_id : "HGNC:30765",
      havana_gene : "OTTHUMG00000159036.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 171600404,
      stop : 171810950,
      direction : "-",
      ID : "ENSG00000075651.16",
      gene_id : "ENSG00000075651.16",
      gene_type : "protein_coding",
      gene_name : "PLD1",
      gene_level : 1,
      hgnc_id : "HGNC:9067",
      havana_gene : "OTTHUMG00000156947.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 171843349,
      stop : 171938715,
      direction : "+",
      ID : "ENSG00000186329.9",
      gene_id : "ENSG00000186329.9",
      gene_type : "protein_coding",
      gene_name : "TMEM212",
      gene_level : 2,
      hgnc_id : "HGNC:34295",
      havana_gene : "OTTHUMG00000156839.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 172039578,
      stop : 172401669,
      direction : "+",
      ID : "ENSG00000075420.13",
      gene_id : "ENSG00000075420.13",
      gene_type : "protein_coding",
      gene_name : "FNDC3B",
      gene_level : 2,
      hgnc_id : "HGNC:24670",
      havana_gene : "OTTHUMG00000156761.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 172443291,
      stop : 172448456,
      direction : "-",
      ID : "ENSG00000121853.4",
      gene_id : "ENSG00000121853.4",
      gene_type : "protein_coding",
      gene_name : "GHSR",
      gene_level : 2,
      hgnc_id : "HGNC:4267",
      havana_gene : "OTTHUMG00000156946.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 172505508,
      stop : 172523475,
      direction : "-",
      ID : "ENSG00000121858.11",
      gene_id : "ENSG00000121858.11",
      gene_type : "protein_coding",
      gene_name : "TNFSF10",
      gene_level : 1,
      hgnc_id : "HGNC:11925",
      havana_gene : "OTTHUMG00000156917.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 172630249,
      stop : 172711218,
      direction : "-",
      ID : "ENSG00000144959.11",
      gene_id : "ENSG00000144959.11",
      gene_type : "protein_coding",
      gene_name : "NCEH1",
      gene_level : 1,
      hgnc_id : "HGNC:29260",
      havana_gene : "OTTHUMG00000156872.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 172750682,
      stop : 172821474,
      direction : "+",
      ID : "ENSG00000114346.14",
      gene_id : "ENSG00000114346.14",
      gene_type : "protein_coding",
      gene_name : "ECT2",
      gene_level : 1,
      hgnc_id : "HGNC:3155",
      havana_gene : "OTTHUMG00000156762.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 172889357,
      stop : 173141235,
      direction : "-",
      ID : "ENSG00000144962.7",
      gene_id : "ENSG00000144962.7",
      gene_type : "protein_coding",
      gene_name : "SPATA16",
      gene_level : 2,
      hgnc_id : "HGNC:29935",
      havana_gene : "OTTHUMG00000156865.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 173396284,
      stop : 174286644,
      direction : "+",
      ID : "ENSG00000169760.17",
      gene_id : "ENSG00000169760.17",
      gene_type : "protein_coding",
      gene_name : "NLGN1",
      gene_level : 1,
      hgnc_id : "HGNC:14291",
      havana_gene : "OTTHUMG00000157005.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 174438573,
      stop : 175810548,
      direction : "+",
      ID : "ENSG00000177694.16",
      gene_id : "ENSG00000177694.16",
      gene_type : "protein_coding",
      gene_name : "NAALADL2",
      gene_level : 2,
      hgnc_id : "HGNC:23219",
      havana_gene : "OTTHUMG00000157120.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 177019340,
      stop : 177228000,
      direction : "-",
      ID : "ENSG00000177565.18",
      gene_id : "ENSG00000177565.18",
      gene_type : "protein_coding",
      gene_name : "TBL1XR1",
      gene_level : 2,
      hgnc_id : "HGNC:29529",
      havana_gene : "OTTHUMG00000157140.29",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 178272932,
      stop : 178844429,
      direction : "+",
      ID : "ENSG00000197584.12",
      gene_id : "ENSG00000197584.12",
      gene_type : "protein_coding",
      gene_name : "KCNMB2",
      gene_level : 1,
      hgnc_id : "HGNC:6286",
      havana_gene : "OTTHUMG00000157264.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 178419123,
      stop : 178843300,
      direction : "+",
      ID : "ENSG00000275163.1",
      gene_id : "ENSG00000275163.1",
      gene_type : "protein_coding",
      gene_name : "AC117457.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186539.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 178960121,
      stop : 179072215,
      direction : "-",
      ID : "ENSG00000172667.11",
      gene_id : "ENSG00000172667.11",
      gene_type : "protein_coding",
      gene_name : "ZMAT3",
      gene_level : 2,
      hgnc_id : "HGNC:29983",
      havana_gene : "OTTHUMG00000157290.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179148114,
      stop : 179240093,
      direction : "+",
      ID : "ENSG00000121879.6",
      gene_id : "ENSG00000121879.6",
      gene_type : "protein_coding",
      gene_name : "PIK3CA",
      gene_level : 1,
      hgnc_id : "HGNC:8975",
      havana_gene : "OTTHUMG00000157311.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179236691,
      stop : 179267002,
      direction : "-",
      ID : "ENSG00000171121.16",
      gene_id : "ENSG00000171121.16",
      gene_type : "protein_coding",
      gene_name : "KCNMB3",
      gene_level : 2,
      hgnc_id : "HGNC:6287",
      havana_gene : "OTTHUMG00000157337.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179323031,
      stop : 179338583,
      direction : "+",
      ID : "ENSG00000121864.10",
      gene_id : "ENSG00000121864.10",
      gene_type : "protein_coding",
      gene_name : "ZNF639",
      gene_level : 2,
      hgnc_id : "HGNC:30950",
      havana_gene : "OTTHUMG00000157439.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179347709,
      stop : 179394936,
      direction : "+",
      ID : "ENSG00000171109.19",
      gene_id : "ENSG00000171109.19",
      gene_type : "protein_coding",
      gene_name : "MFN1",
      gene_level : 1,
      hgnc_id : "HGNC:18262",
      havana_gene : "OTTHUMG00000157385.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179396088,
      stop : 179451476,
      direction : "-",
      ID : "ENSG00000114450.11",
      gene_id : "ENSG00000114450.11",
      gene_type : "protein_coding",
      gene_name : "GNB4",
      gene_level : 1,
      hgnc_id : "HGNC:20731",
      havana_gene : "OTTHUMG00000157440.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179562886,
      stop : 179588407,
      direction : "+",
      ID : "ENSG00000136518.17",
      gene_id : "ENSG00000136518.17",
      gene_type : "protein_coding",
      gene_name : "ACTL6A",
      gene_level : 2,
      hgnc_id : "HGNC:24124",
      havana_gene : "OTTHUMG00000157782.9",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179588285,
      stop : 179604649,
      direction : "-",
      ID : "ENSG00000136522.14",
      gene_id : "ENSG00000136522.14",
      gene_type : "protein_coding",
      gene_name : "MRPL47",
      gene_level : 2,
      hgnc_id : "HGNC:16652",
      havana_gene : "OTTHUMG00000157784.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179604690,
      stop : 179627647,
      direction : "+",
      ID : "ENSG00000136521.13",
      gene_id : "ENSG00000136521.13",
      gene_type : "protein_coding",
      gene_name : "NDUFB5",
      gene_level : 2,
      hgnc_id : "HGNC:7700",
      havana_gene : "OTTHUMG00000157480.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179604807,
      stop : 179784179,
      direction : "+",
      ID : "ENSG00000288698.1",
      gene_id : "ENSG00000288698.1",
      gene_type : "protein_coding",
      gene_name : "AC007687.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179653032,
      stop : 179804366,
      direction : "+",
      ID : "ENSG00000058056.10",
      gene_id : "ENSG00000058056.10",
      gene_type : "protein_coding",
      gene_name : "USP13",
      gene_level : 2,
      hgnc_id : "HGNC:12611",
      havana_gene : "OTTHUMG00000157783.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 179794958,
      stop : 180037053,
      direction : "-",
      ID : "ENSG00000114757.19",
      gene_id : "ENSG00000114757.19",
      gene_type : "protein_coding",
      gene_name : "PEX5L",
      gene_level : 2,
      hgnc_id : "HGNC:30024",
      havana_gene : "OTTHUMG00000157363.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 180602163,
      stop : 180617828,
      direction : "+",
      ID : "ENSG00000163728.11",
      gene_id : "ENSG00000163728.11",
      gene_type : "protein_coding",
      gene_name : "TTC14",
      gene_level : 1,
      hgnc_id : "HGNC:24697",
      havana_gene : "OTTHUMG00000157859.13",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 180602858,
      stop : 180684942,
      direction : "-",
      ID : "ENSG00000284862.3",
      gene_id : "ENSG00000284862.3",
      gene_type : "protein_coding",
      gene_name : "CCDC39",
      gene_level : 2,
      hgnc_id : "HGNC:25244",
      havana_gene : "OTTHUMG00000157857.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 180868141,
      stop : 180982753,
      direction : "+",
      ID : "ENSG00000114416.18",
      gene_id : "ENSG00000114416.18",
      gene_type : "protein_coding",
      gene_name : "FXR1",
      gene_level : 2,
      hgnc_id : "HGNC:4023",
      havana_gene : "OTTHUMG00000158138.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 180983709,
      stop : 180989774,
      direction : "-",
      ID : "ENSG00000205981.8",
      gene_id : "ENSG00000205981.8",
      gene_type : "protein_coding",
      gene_name : "DNAJC19",
      gene_level : 2,
      hgnc_id : "HGNC:30528",
      havana_gene : "OTTHUMG00000158180.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 181711925,
      stop : 181714436,
      direction : "+",
      ID : "ENSG00000181449.4",
      gene_id : "ENSG00000181449.4",
      gene_type : "protein_coding",
      gene_name : "SOX2",
      gene_level : 2,
      hgnc_id : "HGNC:11195",
      havana_gene : "OTTHUMG00000158222.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 182793503,
      stop : 182921629,
      direction : "+",
      ID : "ENSG00000058063.16",
      gene_id : "ENSG00000058063.16",
      gene_type : "protein_coding",
      gene_name : "ATP11B",
      gene_level : 1,
      hgnc_id : "HGNC:13553",
      havana_gene : "OTTHUMG00000158295.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 182938074,
      stop : 182985953,
      direction : "-",
      ID : "ENSG00000043093.15",
      gene_id : "ENSG00000043093.15",
      gene_type : "protein_coding",
      gene_name : "DCUN1D1",
      gene_level : 1,
      hgnc_id : "HGNC:18184",
      havana_gene : "OTTHUMG00000158314.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183015218,
      stop : 183116075,
      direction : "-",
      ID : "ENSG00000078070.13",
      gene_id : "ENSG00000078070.13",
      gene_type : "protein_coding",
      gene_name : "MCCC1",
      gene_level : 2,
      hgnc_id : "HGNC:6936",
      havana_gene : "OTTHUMG00000158355.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183122215,
      stop : 183163839,
      direction : "-",
      ID : "ENSG00000078081.8",
      gene_id : "ENSG00000078081.8",
      gene_type : "protein_coding",
      gene_name : "LAMP3",
      gene_level : 1,
      hgnc_id : "HGNC:14582",
      havana_gene : "OTTHUMG00000158387.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183178043,
      stop : 183428778,
      direction : "-",
      ID : "ENSG00000053524.12",
      gene_id : "ENSG00000053524.12",
      gene_type : "protein_coding",
      gene_name : "MCF2L2",
      gene_level : 2,
      hgnc_id : "HGNC:30319",
      havana_gene : "OTTHUMG00000158388.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183253253,
      stop : 183298504,
      direction : "+",
      ID : "ENSG00000176597.12",
      gene_id : "ENSG00000176597.12",
      gene_type : "protein_coding",
      gene_name : "B3GNT5",
      gene_level : 1,
      hgnc_id : "HGNC:15684",
      havana_gene : "OTTHUMG00000158436.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183487551,
      stop : 183555706,
      direction : "-",
      ID : "ENSG00000172578.12",
      gene_id : "ENSG00000172578.12",
      gene_type : "protein_coding",
      gene_name : "KLHL6",
      gene_level : 2,
      hgnc_id : "HGNC:18653",
      havana_gene : "OTTHUMG00000148673.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183635610,
      stop : 183684519,
      direction : "+",
      ID : "ENSG00000114796.16",
      gene_id : "ENSG00000114796.16",
      gene_type : "protein_coding",
      gene_name : "KLHL24",
      gene_level : 2,
      hgnc_id : "HGNC:25947",
      havana_gene : "OTTHUMG00000156911.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183697797,
      stop : 183812624,
      direction : "+",
      ID : "ENSG00000163872.16",
      gene_id : "ENSG00000163872.16",
      gene_type : "protein_coding",
      gene_name : "YEATS2",
      gene_level : 1,
      hgnc_id : "HGNC:25489",
      havana_gene : "OTTHUMG00000156898.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183815568,
      stop : 183884889,
      direction : "-",
      ID : "ENSG00000283765.1",
      gene_id : "ENSG00000283765.1",
      gene_type : "protein_coding",
      gene_name : "AC131160.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000156890.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183815922,
      stop : 183825594,
      direction : "-",
      ID : "ENSG00000180834.8",
      gene_id : "ENSG00000180834.8",
      gene_type : "protein_coding",
      gene_name : "MAP6D1",
      gene_level : 1,
      hgnc_id : "HGNC:25753",
      havana_gene : "OTTHUMG00000156900.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183829271,
      stop : 183884933,
      direction : "-",
      ID : "ENSG00000175193.14",
      gene_id : "ENSG00000175193.14",
      gene_type : "protein_coding",
      gene_name : "PARL",
      gene_level : 1,
      hgnc_id : "HGNC:18253",
      havana_gene : "OTTHUMG00000191959.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 183919934,
      stop : 184017939,
      direction : "-",
      ID : "ENSG00000114770.17",
      gene_id : "ENSG00000114770.17",
      gene_type : "protein_coding",
      gene_name : "ABCC5",
      gene_level : 1,
      hgnc_id : "HGNC:56",
      havana_gene : "OTTHUMG00000156871.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184031544,
      stop : 184039369,
      direction : "+",
      ID : "ENSG00000186090.11",
      gene_id : "ENSG00000186090.11",
      gene_type : "protein_coding",
      gene_name : "HTR3D",
      gene_level : 2,
      hgnc_id : "HGNC:24004",
      havana_gene : "OTTHUMG00000156858.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184053047,
      stop : 184060673,
      direction : "+",
      ID : "ENSG00000178084.2",
      gene_id : "ENSG00000178084.2",
      gene_type : "protein_coding",
      gene_name : "HTR3C",
      gene_level : 2,
      hgnc_id : "HGNC:24003",
      havana_gene : "OTTHUMG00000156862.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184097064,
      stop : 184106995,
      direction : "+",
      ID : "ENSG00000186038.9",
      gene_id : "ENSG00000186038.9",
      gene_type : "protein_coding",
      gene_name : "HTR3E",
      gene_level : 1,
      hgnc_id : "HGNC:24005",
      havana_gene : "OTTHUMG00000156857.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184135038,
      stop : 184146127,
      direction : "+",
      ID : "ENSG00000145191.15",
      gene_id : "ENSG00000145191.15",
      gene_type : "protein_coding",
      gene_name : "EIF2B5",
      gene_level : 1,
      hgnc_id : "HGNC:3261",
      havana_gene : "OTTHUMG00000156840.21",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184155377,
      stop : 184173614,
      direction : "+",
      ID : "ENSG00000161202.20",
      gene_id : "ENSG00000161202.20",
      gene_type : "protein_coding",
      gene_name : "DVL3",
      gene_level : 2,
      hgnc_id : "HGNC:3087",
      havana_gene : "OTTHUMG00000156841.11",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184174689,
      stop : 184184091,
      direction : "+",
      ID : "ENSG00000161203.13",
      gene_id : "ENSG00000161203.13",
      gene_type : "protein_coding",
      gene_name : "AP2M1",
      gene_level : 2,
      hgnc_id : "HGNC:564",
      havana_gene : "OTTHUMG00000156822.19",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184186023,
      stop : 184194012,
      direction : "+",
      ID : "ENSG00000161204.11",
      gene_id : "ENSG00000161204.11",
      gene_type : "protein_coding",
      gene_name : "ABCF3",
      gene_level : 2,
      hgnc_id : "HGNC:72",
      havana_gene : "OTTHUMG00000156824.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184230429,
      stop : 184242329,
      direction : "+",
      ID : "ENSG00000145198.14",
      gene_id : "ENSG00000145198.14",
      gene_type : "protein_coding",
      gene_name : "VWA5B2",
      gene_level : 2,
      hgnc_id : "HGNC:25144",
      havana_gene : "OTTHUMG00000156820.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184242301,
      stop : 184249548,
      direction : "-",
      ID : "ENSG00000214160.10",
      gene_id : "ENSG00000214160.10",
      gene_type : "protein_coding",
      gene_name : "ALG3",
      gene_level : 1,
      hgnc_id : "HGNC:23056",
      havana_gene : "OTTHUMG00000156823.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184249672,
      stop : 184258759,
      direction : "+",
      ID : "ENSG00000284753.2",
      gene_id : "ENSG00000284753.2",
      gene_type : "protein_coding",
      gene_name : "EEF1AKMT4",
      gene_level : 2,
      hgnc_id : "HGNC:53611",
      havana_gene : "OTTHUMG00000192542.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184249695,
      stop : 184293031,
      direction : "+",
      ID : "ENSG00000284917.1",
      gene_id : "ENSG00000284917.1",
      gene_type : "protein_coding",
      gene_name : "EEF1AKMT4-ECE2",
      gene_level : 2,
      hgnc_id : "HGNC:53615",
      havana_gene : "OTTHUMG00000192543.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184259213,
      stop : 184261553,
      direction : "-",
      ID : "ENSG00000163888.4",
      gene_id : "ENSG00000163888.4",
      gene_type : "protein_coding",
      gene_name : "CAMK2N2",
      gene_level : 2,
      hgnc_id : "HGNC:24197",
      havana_gene : "OTTHUMG00000156821.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184276011,
      stop : 184293031,
      direction : "+",
      ID : "ENSG00000145194.19",
      gene_id : "ENSG00000145194.19",
      gene_type : "protein_coding",
      gene_name : "ECE2",
      gene_level : 2,
      hgnc_id : "HGNC:13275",
      havana_gene : "OTTHUMG00000150551.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184299198,
      stop : 184309050,
      direction : "+",
      ID : "ENSG00000175166.17",
      gene_id : "ENSG00000175166.17",
      gene_type : "protein_coding",
      gene_name : "PSMD2",
      gene_level : 1,
      hgnc_id : "HGNC:9559",
      havana_gene : "OTTHUMG00000156796.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184314495,
      stop : 184335358,
      direction : "+",
      ID : "ENSG00000114867.22",
      gene_id : "ENSG00000114867.22",
      gene_type : "protein_coding",
      gene_name : "EIF4G1",
      gene_level : 1,
      hgnc_id : "HGNC:3296",
      havana_gene : "OTTHUMG00000156784.21",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184335926,
      stop : 184348421,
      direction : "+",
      ID : "ENSG00000175182.15",
      gene_id : "ENSG00000175182.15",
      gene_type : "protein_coding",
      gene_name : "FAM131A",
      gene_level : 1,
      hgnc_id : "HGNC:28308",
      havana_gene : "OTTHUMG00000156206.21",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184346185,
      stop : 184361650,
      direction : "-",
      ID : "ENSG00000114859.16",
      gene_id : "ENSG00000114859.16",
      gene_type : "protein_coding",
      gene_name : "CLCN2",
      gene_level : 1,
      hgnc_id : "HGNC:2020",
      havana_gene : "OTTHUMG00000156747.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184361718,
      stop : 184368596,
      direction : "+",
      ID : "ENSG00000163882.9",
      gene_id : "ENSG00000163882.9",
      gene_type : "protein_coding",
      gene_name : "POLR2H",
      gene_level : 1,
      hgnc_id : "HGNC:9195",
      havana_gene : "OTTHUMG00000156746.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184371935,
      stop : 184381968,
      direction : "-",
      ID : "ENSG00000090534.20",
      gene_id : "ENSG00000090534.20",
      gene_type : "protein_coding",
      gene_name : "THPO",
      gene_level : 2,
      hgnc_id : "HGNC:11795",
      havana_gene : "OTTHUMG00000156745.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184380073,
      stop : 184390736,
      direction : "+",
      ID : "ENSG00000090539.15",
      gene_id : "ENSG00000090539.15",
      gene_type : "protein_coding",
      gene_name : "CHRD",
      gene_level : 1,
      hgnc_id : "HGNC:1949",
      havana_gene : "OTTHUMG00000141267.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184561785,
      stop : 184582408,
      direction : "+",
      ID : "ENSG00000182580.3",
      gene_id : "ENSG00000182580.3",
      gene_type : "protein_coding",
      gene_name : "EPHB3",
      gene_level : 2,
      hgnc_id : "HGNC:3394",
      havana_gene : "OTTHUMG00000156710.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184710364,
      stop : 184712064,
      direction : "-",
      ID : "ENSG00000177383.5",
      gene_id : "ENSG00000177383.5",
      gene_type : "protein_coding",
      gene_name : "MAGEF1",
      gene_level : 2,
      hgnc_id : "HGNC:29639",
      havana_gene : "OTTHUMG00000156712.2",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 184812143,
      stop : 185052614,
      direction : "+",
      ID : "ENSG00000156931.16",
      gene_id : "ENSG00000156931.16",
      gene_type : "protein_coding",
      gene_name : "VPS8",
      gene_level : 1,
      hgnc_id : "HGNC:29122",
      havana_gene : "OTTHUMG00000156707.10",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185076838,
      stop : 185153060,
      direction : "-",
      ID : "ENSG00000187068.3",
      gene_id : "ENSG00000187068.3",
      gene_type : "protein_coding",
      gene_name : "C3orf70",
      gene_level : 2,
      hgnc_id : "HGNC:33731",
      havana_gene : "OTTHUMG00000156696.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185190624,
      stop : 185281990,
      direction : "-",
      ID : "ENSG00000113790.11",
      gene_id : "ENSG00000113790.11",
      gene_type : "protein_coding",
      gene_name : "EHHADH",
      gene_level : 1,
      hgnc_id : "HGNC:3247",
      havana_gene : "OTTHUMG00000156698.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185282941,
      stop : 185489094,
      direction : "+",
      ID : "ENSG00000073803.14",
      gene_id : "ENSG00000073803.14",
      gene_type : "protein_coding",
      gene_name : "MAP3K13",
      gene_level : 1,
      hgnc_id : "HGNC:6852",
      havana_gene : "OTTHUMG00000156673.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185476496,
      stop : 185499057,
      direction : "-",
      ID : "ENSG00000163900.11",
      gene_id : "ENSG00000163900.11",
      gene_type : "protein_coding",
      gene_name : "TMEM41A",
      gene_level : 1,
      hgnc_id : "HGNC:30544",
      havana_gene : "OTTHUMG00000156660.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185506262,
      stop : 185552588,
      direction : "-",
      ID : "ENSG00000163898.10",
      gene_id : "ENSG00000163898.10",
      gene_type : "protein_coding",
      gene_name : "LIPH",
      gene_level : 1,
      hgnc_id : "HGNC:18483",
      havana_gene : "OTTHUMG00000156657.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185582496,
      stop : 185633551,
      direction : "+",
      ID : "ENSG00000163904.13",
      gene_id : "ENSG00000163904.13",
      gene_type : "protein_coding",
      gene_name : "SENP2",
      gene_level : 1,
      hgnc_id : "HGNC:23116",
      havana_gene : "OTTHUMG00000156658.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185643130,
      stop : 185825042,
      direction : "-",
      ID : "ENSG00000073792.16",
      gene_id : "ENSG00000073792.16",
      gene_type : "protein_coding",
      gene_name : "IGF2BP2",
      gene_level : 2,
      hgnc_id : "HGNC:28867",
      havana_gene : "OTTHUMG00000074025.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 185914558,
      stop : 185938103,
      direction : "-",
      ID : "ENSG00000136527.18",
      gene_id : "ENSG00000136527.18",
      gene_type : "protein_coding",
      gene_name : "TRA2B",
      gene_level : 2,
      hgnc_id : "HGNC:10781",
      havana_gene : "OTTHUMG00000156641.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186046314,
      stop : 186110318,
      direction : "-",
      ID : "ENSG00000244405.8",
      gene_id : "ENSG00000244405.8",
      gene_type : "protein_coding",
      gene_name : "ETV5",
      gene_level : 2,
      hgnc_id : "HGNC:3494",
      havana_gene : "OTTHUMG00000156639.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186105668,
      stop : 186362234,
      direction : "-",
      ID : "ENSG00000058866.15",
      gene_id : "ENSG00000058866.15",
      gene_type : "protein_coding",
      gene_name : "DGKG",
      gene_level : 2,
      hgnc_id : "HGNC:2853",
      havana_gene : "OTTHUMG00000156617.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186538441,
      stop : 186546702,
      direction : "-",
      ID : "ENSG00000213139.8",
      gene_id : "ENSG00000213139.8",
      gene_type : "protein_coding",
      gene_name : "CRYGS",
      gene_level : 2,
      hgnc_id : "HGNC:2417",
      havana_gene : "OTTHUMG00000156615.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186546067,
      stop : 186570543,
      direction : "-",
      ID : "ENSG00000113838.13",
      gene_id : "ENSG00000113838.13",
      gene_type : "protein_coding",
      gene_name : "TBCCD1",
      gene_level : 1,
      hgnc_id : "HGNC:25546",
      havana_gene : "OTTHUMG00000156613.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186567403,
      stop : 186585800,
      direction : "+",
      ID : "ENSG00000090520.12",
      gene_id : "ENSG00000090520.12",
      gene_type : "protein_coding",
      gene_name : "DNAJB11",
      gene_level : 2,
      hgnc_id : "HGNC:14889",
      havana_gene : "OTTHUMG00000156614.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186581995,
      stop : 186597103,
      direction : "+",
      ID : "ENSG00000283149.1",
      gene_id : "ENSG00000283149.1",
      gene_type : "protein_coding",
      gene_name : "AC068631.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191653.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186613060,
      stop : 186621318,
      direction : "+",
      ID : "ENSG00000145192.13",
      gene_id : "ENSG00000145192.13",
      gene_type : "protein_coding",
      gene_name : "AHSG",
      gene_level : 1,
      hgnc_id : "HGNC:349",
      havana_gene : "OTTHUMG00000156605.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186635969,
      stop : 186653141,
      direction : "+",
      ID : "ENSG00000090512.12",
      gene_id : "ENSG00000090512.12",
      gene_type : "protein_coding",
      gene_name : "FETUB",
      gene_level : 1,
      hgnc_id : "HGNC:3658",
      havana_gene : "OTTHUMG00000156586.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186660216,
      stop : 186678234,
      direction : "+",
      ID : "ENSG00000113905.5",
      gene_id : "ENSG00000113905.5",
      gene_type : "protein_coding",
      gene_name : "HRG",
      gene_level : 1,
      hgnc_id : "HGNC:5181",
      havana_gene : "OTTHUMG00000156578.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186717348,
      stop : 186744410,
      direction : "+",
      ID : "ENSG00000113889.14",
      gene_id : "ENSG00000113889.14",
      gene_type : "protein_coding",
      gene_name : "KNG1",
      gene_level : 2,
      hgnc_id : "HGNC:6383",
      havana_gene : "OTTHUMG00000150348.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186783205,
      stop : 186789897,
      direction : "+",
      ID : "ENSG00000156976.17",
      gene_id : "ENSG00000156976.17",
      gene_type : "protein_coding",
      gene_name : "EIF4A2",
      gene_level : 2,
      hgnc_id : "HGNC:3284",
      havana_gene : "OTTHUMG00000156564.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186789880,
      stop : 186807058,
      direction : "-",
      ID : "ENSG00000163918.12",
      gene_id : "ENSG00000163918.12",
      gene_type : "protein_coding",
      gene_name : "RFC4",
      gene_level : 2,
      hgnc_id : "HGNC:9972",
      havana_gene : "OTTHUMG00000156515.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186842704,
      stop : 186858463,
      direction : "+",
      ID : "ENSG00000181092.10",
      gene_id : "ENSG00000181092.10",
      gene_type : "protein_coding",
      gene_name : "ADIPOQ",
      gene_level : 2,
      hgnc_id : "HGNC:13633",
      havana_gene : "OTTHUMG00000156521.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 186930325,
      stop : 187078553,
      direction : "+",
      ID : "ENSG00000073849.16",
      gene_id : "ENSG00000073849.16",
      gene_type : "protein_coding",
      gene_name : "ST6GAL1",
      gene_level : 1,
      hgnc_id : "HGNC:10860",
      havana_gene : "OTTHUMG00000156500.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187120948,
      stop : 187180908,
      direction : "-",
      ID : "ENSG00000163923.10",
      gene_id : "ENSG00000163923.10",
      gene_type : "protein_coding",
      gene_name : "RPL39L",
      gene_level : 2,
      hgnc_id : "HGNC:17094",
      havana_gene : "OTTHUMG00000156465.3",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187197486,
      stop : 187201462,
      direction : "+",
      ID : "ENSG00000175077.6",
      gene_id : "ENSG00000175077.6",
      gene_type : "protein_coding",
      gene_name : "RTP1",
      gene_level : 2,
      hgnc_id : "HGNC:28580",
      havana_gene : "OTTHUMG00000149886.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187217282,
      stop : 187291980,
      direction : "-",
      ID : "ENSG00000127241.18",
      gene_id : "ENSG00000127241.18",
      gene_type : "protein_coding",
      gene_name : "MASP1",
      gene_level : 1,
      hgnc_id : "HGNC:6901",
      havana_gene : "OTTHUMG00000156461.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187368385,
      stop : 187372076,
      direction : "+",
      ID : "ENSG00000136514.3",
      gene_id : "ENSG00000136514.3",
      gene_type : "protein_coding",
      gene_name : "RTP4",
      gene_level : 2,
      hgnc_id : "HGNC:23992",
      havana_gene : "OTTHUMG00000156459.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187668912,
      stop : 187670394,
      direction : "-",
      ID : "ENSG00000157005.4",
      gene_id : "ENSG00000157005.4",
      gene_type : "protein_coding",
      gene_name : "SST",
      gene_level : 2,
      hgnc_id : "HGNC:11329",
      havana_gene : "OTTHUMG00000156462.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187698259,
      stop : 187702557,
      direction : "-",
      ID : "ENSG00000198471.1",
      gene_id : "ENSG00000198471.1",
      gene_type : "protein_coding",
      gene_name : "RTP2",
      gene_level : 2,
      hgnc_id : "HGNC:32486",
      havana_gene : "OTTHUMG00000156458.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187721377,
      stop : 187745725,
      direction : "-",
      ID : "ENSG00000113916.18",
      gene_id : "ENSG00000113916.18",
      gene_type : "protein_coding",
      gene_name : "BCL6",
      gene_level : 1,
      hgnc_id : "HGNC:1001",
      havana_gene : "OTTHUMG00000156441.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 187743686,
      stop : 187746028,
      direction : "+",
      ID : "ENSG00000285938.1",
      gene_id : "ENSG00000285938.1",
      gene_type : "protein_coding",
      gene_name : "AC072022.2",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000156440.4",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 188153284,
      stop : 188890671,
      direction : "+",
      ID : "ENSG00000145012.13",
      gene_id : "ENSG00000145012.13",
      gene_type : "protein_coding",
      gene_name : "LPP",
      gene_level : 1,
      hgnc_id : "HGNC:6679",
      havana_gene : "OTTHUMG00000156387.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 188947214,
      stop : 189325304,
      direction : "+",
      ID : "ENSG00000188001.10",
      gene_id : "ENSG00000188001.10",
      gene_type : "protein_coding",
      gene_name : "TPRG1",
      gene_level : 1,
      hgnc_id : "HGNC:24759",
      havana_gene : "OTTHUMG00000156321.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 189631389,
      stop : 189897276,
      direction : "+",
      ID : "ENSG00000073282.14",
      gene_id : "ENSG00000073282.14",
      gene_type : "protein_coding",
      gene_name : "TP63",
      gene_level : 2,
      hgnc_id : "HGNC:15979",
      havana_gene : "OTTHUMG00000156313.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 189956728,
      stop : 190122437,
      direction : "-",
      ID : "ENSG00000090530.10",
      gene_id : "ENSG00000090530.10",
      gene_type : "protein_coding",
      gene_name : "P3H2",
      gene_level : 2,
      hgnc_id : "HGNC:19317",
      havana_gene : "OTTHUMG00000156312.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 190305707,
      stop : 190322446,
      direction : "-",
      ID : "ENSG00000163347.6",
      gene_id : "ENSG00000163347.6",
      gene_type : "protein_coding",
      gene_name : "CLDN1",
      gene_level : 2,
      hgnc_id : "HGNC:2032",
      havana_gene : "OTTHUMG00000156214.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 190322541,
      stop : 190412138,
      direction : "+",
      ID : "ENSG00000113946.4",
      gene_id : "ENSG00000113946.4",
      gene_type : "protein_coding",
      gene_name : "CLDN16",
      gene_level : 2,
      hgnc_id : "HGNC:2037",
      havana_gene : "OTTHUMG00000156215.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 190428655,
      stop : 190449901,
      direction : "-",
      ID : "ENSG00000198398.3",
      gene_id : "ENSG00000198398.3",
      gene_type : "protein_coding",
      gene_name : "TMEM207",
      gene_level : 2,
      hgnc_id : "HGNC:33705",
      havana_gene : "OTTHUMG00000156213.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 190514051,
      stop : 190659750,
      direction : "+",
      ID : "ENSG00000196083.10",
      gene_id : "ENSG00000196083.10",
      gene_type : "protein_coding",
      gene_name : "IL1RAP",
      gene_level : 1,
      hgnc_id : "HGNC:5995",
      havana_gene : "OTTHUMG00000156211.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 190852737,
      stop : 190892429,
      direction : "-",
      ID : "ENSG00000205835.9",
      gene_id : "ENSG00000205835.9",
      gene_type : "protein_coding",
      gene_name : "GMNC",
      gene_level : 2,
      hgnc_id : "HGNC:40049",
      havana_gene : "OTTHUMG00000156195.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 191199241,
      stop : 191265615,
      direction : "+",
      ID : "ENSG00000188729.6",
      gene_id : "ENSG00000188729.6",
      gene_type : "protein_coding",
      gene_name : "OSTN",
      gene_level : 2,
      hgnc_id : "HGNC:29961",
      havana_gene : "OTTHUMG00000156190.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 191267168,
      stop : 191330536,
      direction : "-",
      ID : "ENSG00000188958.9",
      gene_id : "ENSG00000188958.9",
      gene_type : "protein_coding",
      gene_name : "UTS2B",
      gene_level : 2,
      hgnc_id : "HGNC:30894",
      havana_gene : "OTTHUMG00000156192.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 191329085,
      stop : 191398659,
      direction : "+",
      ID : "ENSG00000152492.15",
      gene_id : "ENSG00000152492.15",
      gene_type : "protein_coding",
      gene_name : "CCDC50",
      gene_level : 2,
      hgnc_id : "HGNC:18111",
      havana_gene : "OTTHUMG00000156177.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 191461163,
      stop : 191461456,
      direction : "+",
      ID : "ENSG00000253548.1",
      gene_id : "ENSG00000253548.1",
      gene_type : "protein_coding",
      gene_name : "PYDC2",
      gene_level : 2,
      hgnc_id : "HGNC:33512",
      havana_gene : "OTTHUMG00000156167.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 192139390,
      stop : 192767764,
      direction : "-",
      ID : "ENSG00000114279.14",
      gene_id : "ENSG00000114279.14",
      gene_type : "protein_coding",
      gene_name : "FGF12",
      gene_level : 2,
      hgnc_id : "HGNC:3668",
      havana_gene : "OTTHUMG00000156132.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 192796815,
      stop : 192917856,
      direction : "-",
      ID : "ENSG00000180611.7",
      gene_id : "ENSG00000180611.7",
      gene_type : "protein_coding",
      gene_name : "MB21D2",
      gene_level : 2,
      hgnc_id : "HGNC:30438",
      havana_gene : "OTTHUMG00000155768.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 193241128,
      stop : 193277738,
      direction : "+",
      ID : "ENSG00000127252.7",
      gene_id : "ENSG00000127252.7",
      gene_type : "protein_coding",
      gene_name : "PLAAT1",
      gene_level : 2,
      hgnc_id : "HGNC:14922",
      havana_gene : "OTTHUMG00000156104.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 193274789,
      stop : 193378820,
      direction : "-",
      ID : "ENSG00000187527.11",
      gene_id : "ENSG00000187527.11",
      gene_type : "protein_coding",
      gene_name : "ATP13A5",
      gene_level : 2,
      hgnc_id : "HGNC:31789",
      havana_gene : "OTTHUMG00000156101.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 193398967,
      stop : 193593111,
      direction : "-",
      ID : "ENSG00000127249.15",
      gene_id : "ENSG00000127249.15",
      gene_type : "protein_coding",
      gene_name : "ATP13A4",
      gene_level : 2,
      hgnc_id : "HGNC:25422",
      havana_gene : "OTTHUMG00000074067.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 193593144,
      stop : 193697811,
      direction : "+",
      ID : "ENSG00000198836.11",
      gene_id : "ENSG00000198836.11",
      gene_type : "protein_coding",
      gene_name : "OPA1",
      gene_level : 1,
      hgnc_id : "HGNC:8140",
      havana_gene : "OTTHUMG00000149897.21",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194136148,
      stop : 194138732,
      direction : "+",
      ID : "ENSG00000114315.4",
      gene_id : "ENSG00000114315.4",
      gene_type : "protein_coding",
      gene_name : "HES1",
      gene_level : 2,
      hgnc_id : "HGNC:5192",
      havana_gene : "OTTHUMG00000155984.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194339768,
      stop : 194351328,
      direction : "-",
      ID : "ENSG00000178772.7",
      gene_id : "ENSG00000178772.7",
      gene_type : "protein_coding",
      gene_name : "CPN2",
      gene_level : 2,
      hgnc_id : "HGNC:2313",
      havana_gene : "OTTHUMG00000156047.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194355249,
      stop : 194369743,
      direction : "-",
      ID : "ENSG00000172061.9",
      gene_id : "ENSG00000172061.9",
      gene_type : "protein_coding",
      gene_name : "LRRC15",
      gene_level : 2,
      hgnc_id : "HGNC:20818",
      havana_gene : "OTTHUMG00000156048.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194394821,
      stop : 194398354,
      direction : "-",
      ID : "ENSG00000178732.5",
      gene_id : "ENSG00000178732.5",
      gene_type : "protein_coding",
      gene_name : "GP5",
      gene_level : 2,
      hgnc_id : "HGNC:4443",
      havana_gene : "OTTHUMG00000150345.1",
      tag : "retrogene"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194402672,
      stop : 194498364,
      direction : "-",
      ID : "ENSG00000133657.16",
      gene_id : "ENSG00000133657.16",
      gene_type : "protein_coding",
      gene_name : "ATP13A3",
      gene_level : 2,
      hgnc_id : "HGNC:24113",
      havana_gene : "OTTHUMG00000156034.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194587673,
      stop : 194633689,
      direction : "-",
      ID : "ENSG00000145014.18",
      gene_id : "ENSG00000145014.18",
      gene_type : "protein_coding",
      gene_name : "TMEM44",
      gene_level : 1,
      hgnc_id : "HGNC:25120",
      havana_gene : "OTTHUMG00000156023.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194640791,
      stop : 194672463,
      direction : "-",
      ID : "ENSG00000041802.11",
      gene_id : "ENSG00000041802.11",
      gene_type : "protein_coding",
      gene_name : "LSG1",
      gene_level : 1,
      hgnc_id : "HGNC:25652",
      havana_gene : "OTTHUMG00000156021.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 194685883,
      stop : 194689037,
      direction : "+",
      ID : "ENSG00000185112.6",
      gene_id : "ENSG00000185112.6",
      gene_type : "protein_coding",
      gene_name : "FAM43A",
      gene_level : 2,
      hgnc_id : "HGNC:26888",
      havana_gene : "OTTHUMG00000156016.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195068284,
      stop : 195271159,
      direction : "-",
      ID : "ENSG00000173950.16",
      gene_id : "ENSG00000173950.16",
      gene_type : "protein_coding",
      gene_name : "XXYLT1",
      gene_level : 1,
      hgnc_id : "HGNC:26639",
      havana_gene : "OTTHUMG00000155915.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195274745,
      stop : 195443044,
      direction : "-",
      ID : "ENSG00000114331.15",
      gene_id : "ENSG00000114331.15",
      gene_type : "protein_coding",
      gene_name : "ACAP2",
      gene_level : 1,
      hgnc_id : "HGNC:16469",
      havana_gene : "OTTHUMG00000155885.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195514428,
      stop : 195543386,
      direction : "-",
      ID : "ENSG00000184203.8",
      gene_id : "ENSG00000184203.8",
      gene_type : "protein_coding",
      gene_name : "PPP1R2",
      gene_level : 2,
      hgnc_id : "HGNC:9288",
      havana_gene : "OTTHUMG00000155887.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195568705,
      stop : 195584033,
      direction : "-",
      ID : "ENSG00000189058.9",
      gene_id : "ENSG00000189058.9",
      gene_type : "protein_coding",
      gene_name : "APOD",
      gene_level : 2,
      hgnc_id : "HGNC:612",
      havana_gene : "OTTHUMG00000155854.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195720884,
      stop : 195741123,
      direction : "+",
      ID : "ENSG00000176945.17",
      gene_id : "ENSG00000176945.17",
      gene_type : "protein_coding",
      gene_name : "MUC20",
      gene_level : 1,
      hgnc_id : "HGNC:23282",
      havana_gene : "OTTHUMG00000155823.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195746765,
      stop : 195811973,
      direction : "-",
      ID : "ENSG00000145113.22",
      gene_id : "ENSG00000145113.22",
      gene_type : "protein_coding",
      gene_name : "MUC4",
      gene_level : 1,
      hgnc_id : "HGNC:7514",
      havana_gene : "OTTHUMG00000151827.7",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 195863364,
      stop : 195911945,
      direction : "-",
      ID : "ENSG00000061938.20",
      gene_id : "ENSG00000061938.20",
      gene_type : "protein_coding",
      gene_name : "TNK2",
      gene_level : 1,
      hgnc_id : "HGNC:19297",
      havana_gene : "OTTHUMG00000155737.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196027183,
      stop : 196082096,
      direction : "-",
      ID : "ENSG00000072274.13",
      gene_id : "ENSG00000072274.13",
      gene_type : "protein_coding",
      gene_name : "TFRC",
      gene_level : 2,
      hgnc_id : "HGNC:11763",
      havana_gene : "OTTHUMG00000155714.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196197452,
      stop : 196211437,
      direction : "-",
      ID : "ENSG00000163958.14",
      gene_id : "ENSG00000163958.14",
      gene_type : "protein_coding",
      gene_name : "ZDHHC19",
      gene_level : 2,
      hgnc_id : "HGNC:20713",
      havana_gene : "OTTHUMG00000133642.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196211487,
      stop : 196243178,
      direction : "+",
      ID : "ENSG00000163959.10",
      gene_id : "ENSG00000163959.10",
      gene_type : "protein_coding",
      gene_name : "SLC51A",
      gene_level : 1,
      hgnc_id : "HGNC:29955",
      havana_gene : "OTTHUMG00000155684.4",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196214222,
      stop : 196287957,
      direction : "-",
      ID : "ENSG00000161217.12",
      gene_id : "ENSG00000161217.12",
      gene_type : "protein_coding",
      gene_name : "PCYT1A",
      gene_level : 1,
      hgnc_id : "HGNC:8754",
      havana_gene : "OTTHUMG00000155670.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196248230,
      stop : 196318222,
      direction : "-",
      ID : "ENSG00000272741.1",
      gene_id : "ENSG00000272741.1",
      gene_type : "protein_coding",
      gene_name : "AC069257.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000155672.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196291219,
      stop : 196318299,
      direction : "-",
      ID : "ENSG00000213123.11",
      gene_id : "ENSG00000213123.11",
      gene_type : "protein_coding",
      gene_name : "DYNLT2B",
      gene_level : 1,
      hgnc_id : "HGNC:28482",
      havana_gene : "OTTHUMG00000186382.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196316082,
      stop : 196338373,
      direction : "-",
      ID : "ENSG00000273331.1",
      gene_id : "ENSG00000273331.1",
      gene_type : "protein_coding",
      gene_name : "TM4SF19-DYNLT2B",
      gene_level : 2,
      hgnc_id : "HGNC:49190",
      havana_gene : "OTTHUMG00000186464.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196319342,
      stop : 196338503,
      direction : "-",
      ID : "ENSG00000145107.16",
      gene_id : "ENSG00000145107.16",
      gene_type : "protein_coding",
      gene_name : "TM4SF19",
      gene_level : 1,
      hgnc_id : "HGNC:25167",
      havana_gene : "OTTHUMG00000155675.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196347662,
      stop : 196432430,
      direction : "-",
      ID : "ENSG00000163960.12",
      gene_id : "ENSG00000163960.12",
      gene_type : "protein_coding",
      gene_name : "UBXN7",
      gene_level : 2,
      hgnc_id : "HGNC:29119",
      havana_gene : "OTTHUMG00000155639.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196468783,
      stop : 196503768,
      direction : "-",
      ID : "ENSG00000163961.4",
      gene_id : "ENSG00000163961.4",
      gene_type : "protein_coding",
      gene_name : "RNF168",
      gene_level : 2,
      hgnc_id : "HGNC:26661",
      havana_gene : "OTTHUMG00000155582.1",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196506879,
      stop : 196515346,
      direction : "-",
      ID : "ENSG00000214097.5",
      gene_id : "ENSG00000214097.5",
      gene_type : "protein_coding",
      gene_name : "SMCO1",
      gene_level : 2,
      hgnc_id : "HGNC:27407",
      havana_gene : "OTTHUMG00000155581.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196554177,
      stop : 196568674,
      direction : "-",
      ID : "ENSG00000185798.8",
      gene_id : "ENSG00000185798.8",
      gene_type : "protein_coding",
      gene_name : "WDR53",
      gene_level : 1,
      hgnc_id : "HGNC:28786",
      havana_gene : "OTTHUMG00000155572.8",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196568611,
      stop : 196589059,
      direction : "+",
      ID : "ENSG00000174013.8",
      gene_id : "ENSG00000174013.8",
      gene_type : "protein_coding",
      gene_name : "FBXO45",
      gene_level : 2,
      hgnc_id : "HGNC:29148",
      havana_gene : "OTTHUMG00000155571.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196639694,
      stop : 196662004,
      direction : "+",
      ID : "ENSG00000174004.6",
      gene_id : "ENSG00000174004.6",
      gene_type : "protein_coding",
      gene_name : "NRROS",
      gene_level : 2,
      hgnc_id : "HGNC:24613",
      havana_gene : "OTTHUMG00000155569.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196639775,
      stop : 196736007,
      direction : "+",
      ID : "ENSG00000163964.18",
      gene_id : "ENSG00000163964.18",
      gene_type : "protein_coding",
      gene_name : "PIGX",
      gene_level : 2,
      hgnc_id : "HGNC:26046",
      havana_gene : "OTTHUMG00000155535.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196706277,
      stop : 196712250,
      direction : "-",
      ID : "ENSG00000174007.9",
      gene_id : "ENSG00000174007.9",
      gene_type : "protein_coding",
      gene_name : "CEP19",
      gene_level : 1,
      hgnc_id : "HGNC:28209",
      havana_gene : "OTTHUMG00000153933.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196739857,
      stop : 196832647,
      direction : "+",
      ID : "ENSG00000180370.10",
      gene_id : "ENSG00000180370.10",
      gene_type : "protein_coding",
      gene_name : "PAK2",
      gene_level : 2,
      hgnc_id : "HGNC:8591",
      havana_gene : "OTTHUMG00000155534.2",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196867856,
      stop : 196934714,
      direction : "+",
      ID : "ENSG00000119231.11",
      gene_id : "ENSG00000119231.11",
      gene_type : "protein_coding",
      gene_name : "SENP5",
      gene_level : 1,
      hgnc_id : "HGNC:28407",
      havana_gene : "OTTHUMG00000155527.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196935402,
      stop : 196942594,
      direction : "-",
      ID : "ENSG00000114503.11",
      gene_id : "ENSG00000114503.11",
      gene_type : "protein_coding",
      gene_name : "NCBP2",
      gene_level : 1,
      hgnc_id : "HGNC:7659",
      havana_gene : "OTTHUMG00000155520.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196942674,
      stop : 196943543,
      direction : "+",
      ID : "ENSG00000270170.2",
      gene_id : "ENSG00000270170.2",
      gene_type : "protein_coding",
      gene_name : "NCBP2AS2",
      gene_level : 2,
      hgnc_id : "HGNC:25121",
      havana_gene : "OTTHUMG00000184107.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196946356,
      stop : 196969060,
      direction : "-",
      ID : "ENSG00000119227.8",
      gene_id : "ENSG00000119227.8",
      gene_type : "protein_coding",
      gene_name : "PIGZ",
      gene_level : 1,
      hgnc_id : "HGNC:30596",
      havana_gene : "OTTHUMG00000155522.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 196988621,
      stop : 197029817,
      direction : "-",
      ID : "ENSG00000163975.12",
      gene_id : "ENSG00000163975.12",
      gene_type : "protein_coding",
      gene_name : "MELTF",
      gene_level : 2,
      hgnc_id : "HGNC:7037",
      havana_gene : "OTTHUMG00000155518.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197042560,
      stop : 197299330,
      direction : "-",
      ID : "ENSG00000075711.21",
      gene_id : "ENSG00000075711.21",
      gene_type : "protein_coding",
      gene_name : "DLG1",
      gene_level : 2,
      hgnc_id : "HGNC:2900",
      havana_gene : "OTTHUMG00000047972.48",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197509783,
      stop : 197573323,
      direction : "-",
      ID : "ENSG00000161267.12",
      gene_id : "ENSG00000161267.12",
      gene_type : "protein_coding",
      gene_name : "BDH1",
      gene_level : 1,
      hgnc_id : "HGNC:1027",
      havana_gene : "OTTHUMG00000155478.14",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197668867,
      stop : 197749727,
      direction : "-",
      ID : "ENSG00000145016.16",
      gene_id : "ENSG00000145016.16",
      gene_type : "protein_coding",
      gene_name : "RUBCN",
      gene_level : 1,
      hgnc_id : "HGNC:28991",
      havana_gene : "OTTHUMG00000155452.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197737179,
      stop : 197787596,
      direction : "+",
      ID : "ENSG00000122068.13",
      gene_id : "ENSG00000122068.13",
      gene_type : "protein_coding",
      gene_name : "FYTTD1",
      gene_level : 1,
      hgnc_id : "HGNC:25407",
      havana_gene : "OTTHUMG00000155453.12",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197791226,
      stop : 197888436,
      direction : "+",
      ID : "ENSG00000186001.14",
      gene_id : "ENSG00000186001.14",
      gene_type : "protein_coding",
      gene_name : "LRCH3",
      gene_level : 2,
      hgnc_id : "HGNC:28637",
      havana_gene : "OTTHUMG00000155378.5",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197889077,
      stop : 197960142,
      direction : "-",
      ID : "ENSG00000114473.14",
      gene_id : "ENSG00000114473.14",
      gene_type : "protein_coding",
      gene_name : "IQCG",
      gene_level : 1,
      hgnc_id : "HGNC:25251",
      havana_gene : "OTTHUMG00000155408.3",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197950190,
      stop : 197956610,
      direction : "+",
      ID : "ENSG00000182899.17",
      gene_id : "ENSG00000182899.17",
      gene_type : "protein_coding",
      gene_name : "RPL35A",
      gene_level : 2,
      hgnc_id : "HGNC:10345",
      havana_gene : "OTTHUMG00000155386.6",
      tag : null
    },
    {
      chromosome : 3,
      annotation : "HAVANA",
      type : "gene",
      start : 197960200,
      stop : 198043720,
      direction : "+",
      ID : "ENSG00000185621.11",
      gene_id : "ENSG00000185621.11",
      gene_type : "protein_coding",
      gene_name : "LMLN",
      gene_level : 2,
      hgnc_id : "HGNC:15991",
      havana_gene : "OTTHUMG00000155375.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 53286,
      stop : 88208,
      direction : "+",
      ID : "ENSG00000272602.6",
      gene_id : "ENSG00000272602.6",
      gene_type : "protein_coding",
      gene_name : "ZNF595",
      gene_level : 2,
      hgnc_id : "HGNC:27196",
      havana_gene : "OTTHUMG00000159865.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 124501,
      stop : 202303,
      direction : "+",
      ID : "ENSG00000250312.8",
      gene_id : "ENSG00000250312.8",
      gene_type : "protein_coding",
      gene_name : "ZNF718",
      gene_level : 2,
      hgnc_id : "HGNC:26889",
      havana_gene : "OTTHUMG00000159873.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 270675,
      stop : 305474,
      direction : "-",
      ID : "ENSG00000186777.12",
      gene_id : "ENSG00000186777.12",
      gene_type : "protein_coding",
      gene_name : "ZNF732",
      gene_level : 1,
      hgnc_id : "HGNC:37138",
      havana_gene : "OTTHUMG00000159883.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 337814,
      stop : 384868,
      direction : "+",
      ID : "ENSG00000131127.14",
      gene_id : "ENSG00000131127.14",
      gene_type : "protein_coding",
      gene_name : "ZNF141",
      gene_level : 2,
      hgnc_id : "HGNC:12926",
      havana_gene : "OTTHUMG00000159852.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 425815,
      stop : 499156,
      direction : "-",
      ID : "ENSG00000182903.16",
      gene_id : "ENSG00000182903.16",
      gene_type : "protein_coding",
      gene_name : "ZNF721",
      gene_level : 2,
      hgnc_id : "HGNC:29425",
      havana_gene : "OTTHUMG00000112450.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 499210,
      stop : 540200,
      direction : "+",
      ID : "ENSG00000174227.16",
      gene_id : "ENSG00000174227.16",
      gene_type : "protein_coding",
      gene_name : "PIGG",
      gene_level : 1,
      hgnc_id : "HGNC:25985",
      havana_gene : "OTTHUMG00000112457.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 573880,
      stop : 576295,
      direction : "-",
      ID : "ENSG00000273238.3",
      gene_id : "ENSG00000273238.3",
      gene_type : "protein_coding",
      gene_name : "TMEM271",
      gene_level : 2,
      hgnc_id : "HGNC:53639",
      havana_gene : "OTTHUMG00000192218.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 625573,
      stop : 670782,
      direction : "+",
      ID : "ENSG00000133256.13",
      gene_id : "ENSG00000133256.13",
      gene_type : "protein_coding",
      gene_name : "PDE6B",
      gene_level : 1,
      hgnc_id : "HGNC:8786",
      havana_gene : "OTTHUMG00000159909.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 672436,
      stop : 674330,
      direction : "-",
      ID : "ENSG00000169020.10",
      gene_id : "ENSG00000169020.10",
      gene_type : "protein_coding",
      gene_name : "ATP5ME",
      gene_level : 2,
      hgnc_id : "HGNC:846",
      havana_gene : "OTTHUMG00000086929.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 673580,
      stop : 682033,
      direction : "+",
      ID : "ENSG00000215375.6",
      gene_id : "ENSG00000215375.6",
      gene_type : "protein_coding",
      gene_name : "MYL5",
      gene_level : 2,
      hgnc_id : "HGNC:7586",
      havana_gene : "OTTHUMG00000159971.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 681829,
      stop : 689271,
      direction : "-",
      ID : "ENSG00000169026.13",
      gene_id : "ENSG00000169026.13",
      gene_type : "protein_coding",
      gene_name : "SLC49A3",
      gene_level : 1,
      hgnc_id : "HGNC:26177",
      havana_gene : "OTTHUMG00000119001.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 705748,
      stop : 770640,
      direction : "+",
      ID : "ENSG00000185619.18",
      gene_id : "ENSG00000185619.18",
      gene_type : "protein_coding",
      gene_name : "PCGF3",
      gene_level : 2,
      hgnc_id : "HGNC:10066",
      havana_gene : "OTTHUMG00000119000.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 784957,
      stop : 826129,
      direction : "-",
      ID : "ENSG00000168993.15",
      gene_id : "ENSG00000168993.15",
      gene_type : "protein_coding",
      gene_name : "CPLX1",
      gene_level : 1,
      hgnc_id : "HGNC:2309",
      havana_gene : "OTTHUMG00000160005.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 849276,
      stop : 932373,
      direction : "-",
      ID : "ENSG00000178950.17",
      gene_id : "ENSG00000178950.17",
      gene_type : "protein_coding",
      gene_name : "GAK",
      gene_level : 1,
      hgnc_id : "HGNC:4113",
      havana_gene : "OTTHUMG00000088301.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 932387,
      stop : 958656,
      direction : "+",
      ID : "ENSG00000127419.17",
      gene_id : "ENSG00000127419.17",
      gene_type : "protein_coding",
      gene_name : "TMEM175",
      gene_level : 1,
      hgnc_id : "HGNC:28709",
      havana_gene : "OTTHUMG00000118996.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 958887,
      stop : 986895,
      direction : "-",
      ID : "ENSG00000145214.14",
      gene_id : "ENSG00000145214.14",
      gene_type : "protein_coding",
      gene_name : "DGKQ",
      gene_level : 1,
      hgnc_id : "HGNC:2856",
      havana_gene : "OTTHUMG00000088629.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 979073,
      stop : 993440,
      direction : "-",
      ID : "ENSG00000145217.14",
      gene_id : "ENSG00000145217.14",
      gene_type : "protein_coding",
      gene_name : "SLC26A1",
      gene_level : 1,
      hgnc_id : "HGNC:10993",
      havana_gene : "OTTHUMG00000160003.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 986997,
      stop : 1004564,
      direction : "+",
      ID : "ENSG00000127415.13",
      gene_id : "ENSG00000127415.13",
      gene_type : "protein_coding",
      gene_name : "IDUA",
      gene_level : 1,
      hgnc_id : "HGNC:5391",
      havana_gene : "OTTHUMG00000088901.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1009936,
      stop : 1026898,
      direction : "+",
      ID : "ENSG00000127418.15",
      gene_id : "ENSG00000127418.15",
      gene_type : "protein_coding",
      gene_name : "FGFRL1",
      gene_level : 2,
      hgnc_id : "HGNC:3693",
      havana_gene : "OTTHUMG00000118998.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1056250,
      stop : 1113564,
      direction : "-",
      ID : "ENSG00000178222.13",
      gene_id : "ENSG00000178222.13",
      gene_type : "protein_coding",
      gene_name : "RNF212",
      gene_level : 2,
      hgnc_id : "HGNC:27729",
      havana_gene : "OTTHUMG00000118997.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1166932,
      stop : 1208962,
      direction : "-",
      ID : "ENSG00000159674.12",
      gene_id : "ENSG00000159674.12",
      gene_type : "protein_coding",
      gene_name : "SPON2",
      gene_level : 1,
      hgnc_id : "HGNC:11253",
      havana_gene : "OTTHUMG00000089002.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1211445,
      stop : 1249953,
      direction : "-",
      ID : "ENSG00000159692.16",
      gene_id : "ENSG00000159692.16",
      gene_type : "protein_coding",
      gene_name : "CTBP1",
      gene_level : 1,
      hgnc_id : "HGNC:2494",
      havana_gene : "OTTHUMG00000089259.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1289887,
      stop : 1340147,
      direction : "+",
      ID : "ENSG00000090316.16",
      gene_id : "ENSG00000090316.16",
      gene_type : "protein_coding",
      gene_name : "MAEA",
      gene_level : 1,
      hgnc_id : "HGNC:13731",
      havana_gene : "OTTHUMG00000160169.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1345691,
      stop : 1395989,
      direction : "+",
      ID : "ENSG00000163945.19",
      gene_id : "ENSG00000163945.19",
      gene_type : "protein_coding",
      gene_name : "UVSSA",
      gene_level : 1,
      hgnc_id : "HGNC:29304",
      havana_gene : "OTTHUMG00000160167.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1402932,
      stop : 1406442,
      direction : "-",
      ID : "ENSG00000235608.2",
      gene_id : "ENSG00000235608.2",
      gene_type : "protein_coding",
      gene_name : "NKX1-1",
      gene_level : 2,
      hgnc_id : "HGNC:24975",
      havana_gene : "OTTHUMG00000160165.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1617915,
      stop : 1684261,
      direction : "-",
      ID : "ENSG00000174137.13",
      gene_id : "ENSG00000174137.13",
      gene_type : "protein_coding",
      gene_name : "FAM53A",
      gene_level : 1,
      hgnc_id : "HGNC:31860",
      havana_gene : "OTTHUMG00000159855.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1692731,
      stop : 1712344,
      direction : "-",
      ID : "ENSG00000163950.13",
      gene_id : "ENSG00000163950.13",
      gene_type : "protein_coding",
      gene_name : "SLBP",
      gene_level : 1,
      hgnc_id : "HGNC:10904",
      havana_gene : "OTTHUMG00000089349.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1712891,
      stop : 1745171,
      direction : "+",
      ID : "ENSG00000013810.20",
      gene_id : "ENSG00000013810.20",
      gene_type : "protein_coding",
      gene_name : "TACC3",
      gene_level : 1,
      hgnc_id : "HGNC:11524",
      havana_gene : "OTTHUMG00000089535.25",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1715952,
      stop : 1721358,
      direction : "-",
      ID : "ENSG00000168936.11",
      gene_id : "ENSG00000168936.11",
      gene_type : "protein_coding",
      gene_name : "TMEM129",
      gene_level : 1,
      hgnc_id : "HGNC:25137",
      havana_gene : "OTTHUMG00000121150.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1793293,
      stop : 1808872,
      direction : "+",
      ID : "ENSG00000068078.20",
      gene_id : "ENSG00000068078.20",
      gene_type : "protein_coding",
      gene_name : "FGFR3",
      gene_level : 1,
      hgnc_id : "HGNC:3690",
      havana_gene : "OTTHUMG00000121148.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1811479,
      stop : 1856156,
      direction : "-",
      ID : "ENSG00000168924.15",
      gene_id : "ENSG00000168924.15",
      gene_type : "protein_coding",
      gene_name : "LETM1",
      gene_level : 2,
      hgnc_id : "HGNC:6556",
      havana_gene : "OTTHUMG00000121149.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1871393,
      stop : 1982207,
      direction : "+",
      ID : "ENSG00000109685.19",
      gene_id : "ENSG00000109685.19",
      gene_type : "protein_coding",
      gene_name : "NSD2",
      gene_level : 2,
      hgnc_id : "HGNC:12766",
      havana_gene : "OTTHUMG00000121147.15",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 1982717,
      stop : 2041903,
      direction : "-",
      ID : "ENSG00000185049.16",
      gene_id : "ENSG00000185049.16",
      gene_type : "protein_coding",
      gene_name : "NELFA",
      gene_level : 1,
      hgnc_id : "HGNC:12768",
      havana_gene : "OTTHUMG00000089967.25",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2041993,
      stop : 2043970,
      direction : "+",
      ID : "ENSG00000243449.6",
      gene_id : "ENSG00000243449.6",
      gene_type : "protein_coding",
      gene_name : "C4orf48",
      gene_level : 2,
      hgnc_id : "HGNC:34437",
      havana_gene : "OTTHUMG00000154503.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2059327,
      stop : 2069089,
      direction : "+",
      ID : "ENSG00000185818.8",
      gene_id : "ENSG00000185818.8",
      gene_type : "protein_coding",
      gene_name : "NAT8L",
      gene_level : 2,
      hgnc_id : "HGNC:26742",
      havana_gene : "OTTHUMG00000121151.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2071918,
      stop : 2242121,
      direction : "-",
      ID : "ENSG00000130997.16",
      gene_id : "ENSG00000130997.16",
      gene_type : "protein_coding",
      gene_name : "POLN",
      gene_level : 2,
      hgnc_id : "HGNC:18870",
      havana_gene : "OTTHUMG00000090081.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2078998,
      stop : 2242276,
      direction : "-",
      ID : "ENSG00000214367.9",
      gene_id : "ENSG00000214367.9",
      gene_type : "protein_coding",
      gene_name : "HAUS3",
      gene_level : 2,
      hgnc_id : "HGNC:28719",
      havana_gene : "OTTHUMG00000159805.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2247432,
      stop : 2262109,
      direction : "-",
      ID : "ENSG00000123933.17",
      gene_id : "ENSG00000123933.17",
      gene_type : "protein_coding",
      gene_name : "MXD4",
      gene_level : 2,
      hgnc_id : "HGNC:13906",
      havana_gene : "OTTHUMG00000090243.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2269582,
      stop : 2418651,
      direction : "-",
      ID : "ENSG00000159733.14",
      gene_id : "ENSG00000159733.14",
      gene_type : "protein_coding",
      gene_name : "ZFYVE28",
      gene_level : 1,
      hgnc_id : "HGNC:29334",
      havana_gene : "OTTHUMG00000160292.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2418974,
      stop : 2462942,
      direction : "+",
      ID : "ENSG00000206113.11",
      gene_id : "ENSG00000206113.11",
      gene_type : "protein_coding",
      gene_name : "CFAP99",
      gene_level : 2,
      hgnc_id : "HGNC:51180",
      havana_gene : "OTTHUMG00000160515.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2462220,
      stop : 2625320,
      direction : "+",
      ID : "ENSG00000063978.16",
      gene_id : "ENSG00000063978.16",
      gene_type : "protein_coding",
      gene_name : "RNF4",
      gene_level : 1,
      hgnc_id : "HGNC:10067",
      havana_gene : "OTTHUMG00000160516.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2536647,
      stop : 2732573,
      direction : "+",
      ID : "ENSG00000125386.16",
      gene_id : "ENSG00000125386.16",
      gene_type : "protein_coding",
      gene_name : "FAM193A",
      gene_level : 1,
      hgnc_id : "HGNC:16822",
      havana_gene : "OTTHUMG00000160512.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2741648,
      stop : 2756342,
      direction : "-",
      ID : "ENSG00000168884.15",
      gene_id : "ENSG00000168884.15",
      gene_type : "protein_coding",
      gene_name : "TNIP2",
      gene_level : 2,
      hgnc_id : "HGNC:19118",
      havana_gene : "OTTHUMG00000090267.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2793071,
      stop : 2841098,
      direction : "+",
      ID : "ENSG00000087266.17",
      gene_id : "ENSG00000087266.17",
      gene_type : "protein_coding",
      gene_name : "SH3BP2",
      gene_level : 2,
      hgnc_id : "HGNC:10825",
      havana_gene : "OTTHUMG00000160801.18",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2843857,
      stop : 2930076,
      direction : "+",
      ID : "ENSG00000087274.17",
      gene_id : "ENSG00000087274.17",
      gene_type : "protein_coding",
      gene_name : "ADD1",
      gene_level : 1,
      hgnc_id : "HGNC:243",
      havana_gene : "OTTHUMG00000122080.23",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2930561,
      stop : 2934834,
      direction : "-",
      ID : "ENSG00000109736.15",
      gene_id : "ENSG00000109736.15",
      gene_type : "protein_coding",
      gene_name : "MFSD10",
      gene_level : 2,
      hgnc_id : "HGNC:16894",
      havana_gene : "OTTHUMG00000122081.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2937933,
      stop : 2963406,
      direction : "-",
      ID : "ENSG00000087269.16",
      gene_id : "ENSG00000087269.16",
      gene_type : "protein_coding",
      gene_name : "NOP14",
      gene_level : 1,
      hgnc_id : "HGNC:16821",
      havana_gene : "OTTHUMG00000159911.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 2963571,
      stop : 3040760,
      direction : "+",
      ID : "ENSG00000125388.20",
      gene_id : "ENSG00000125388.20",
      gene_type : "protein_coding",
      gene_name : "GRK4",
      gene_level : 2,
      hgnc_id : "HGNC:4543",
      havana_gene : "OTTHUMG00000159914.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3041363,
      stop : 3243960,
      direction : "+",
      ID : "ENSG00000197386.13",
      gene_id : "ENSG00000197386.13",
      gene_type : "protein_coding",
      gene_name : "HTT",
      gene_level : 2,
      hgnc_id : "HGNC:4851",
      havana_gene : "OTTHUMG00000159916.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3244369,
      stop : 3271738,
      direction : "+",
      ID : "ENSG00000188981.11",
      gene_id : "ENSG00000188981.11",
      gene_type : "protein_coding",
      gene_name : "MSANTD1",
      gene_level : 1,
      hgnc_id : "HGNC:33741",
      havana_gene : "OTTHUMG00000159977.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3293028,
      stop : 3439913,
      direction : "+",
      ID : "ENSG00000159788.19",
      gene_id : "ENSG00000159788.19",
      gene_type : "protein_coding",
      gene_name : "RGS12",
      gene_level : 2,
      hgnc_id : "HGNC:9994",
      havana_gene : "OTTHUMG00000090277.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3441968,
      stop : 3449486,
      direction : "+",
      ID : "ENSG00000109758.9",
      gene_id : "ENSG00000109758.9",
      gene_type : "protein_coding",
      gene_name : "HGFAC",
      gene_level : 2,
      hgnc_id : "HGNC:4894",
      havana_gene : "OTTHUMG00000090281.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3463306,
      stop : 3501473,
      direction : "+",
      ID : "ENSG00000175920.18",
      gene_id : "ENSG00000175920.18",
      gene_type : "protein_coding",
      gene_name : "DOK7",
      gene_level : 1,
      hgnc_id : "HGNC:26594",
      havana_gene : "OTTHUMG00000122087.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3503612,
      stop : 3532446,
      direction : "-",
      ID : "ENSG00000163956.13",
      gene_id : "ENSG00000163956.13",
      gene_type : "protein_coding",
      gene_name : "LRPAP1",
      gene_level : 2,
      hgnc_id : "HGNC:6701",
      havana_gene : "OTTHUMG00000090299.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 3766348,
      stop : 3768526,
      direction : "+",
      ID : "ENSG00000184160.8",
      gene_id : "ENSG00000184160.8",
      gene_type : "protein_coding",
      gene_name : "ADRA2C",
      gene_level : 2,
      hgnc_id : "HGNC:283",
      havana_gene : "OTTHUMG00000159830.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4188726,
      stop : 4226929,
      direction : "-",
      ID : "ENSG00000163982.6",
      gene_id : "ENSG00000163982.6",
      gene_type : "protein_coding",
      gene_name : "OTOP1",
      gene_level : 2,
      hgnc_id : "HGNC:19656",
      havana_gene : "OTTHUMG00000090301.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4235542,
      stop : 4248223,
      direction : "-",
      ID : "ENSG00000132406.12",
      gene_id : "ENSG00000132406.12",
      gene_type : "protein_coding",
      gene_name : "TMEM128",
      gene_level : 2,
      hgnc_id : "HGNC:28201",
      havana_gene : "OTTHUMG00000125475.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4267701,
      stop : 4290154,
      direction : "-",
      ID : "ENSG00000145220.14",
      gene_id : "ENSG00000145220.14",
      gene_type : "protein_coding",
      gene_name : "LYAR",
      gene_level : 2,
      hgnc_id : "HGNC:26021",
      havana_gene : "OTTHUMG00000125477.20",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4290251,
      stop : 4321786,
      direction : "+",
      ID : "ENSG00000168826.16",
      gene_id : "ENSG00000168826.16",
      gene_type : "protein_coding",
      gene_name : "ZBTB49",
      gene_level : 2,
      hgnc_id : "HGNC:19883",
      havana_gene : "OTTHUMG00000090325.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4348140,
      stop : 4419058,
      direction : "+",
      ID : "ENSG00000168824.14",
      gene_id : "ENSG00000168824.14",
      gene_type : "protein_coding",
      gene_name : "NSG1",
      gene_level : 1,
      hgnc_id : "HGNC:18790",
      havana_gene : "OTTHUMG00000160002.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4415742,
      stop : 4542346,
      direction : "-",
      ID : "ENSG00000168818.10",
      gene_id : "ENSG00000168818.10",
      gene_type : "protein_coding",
      gene_name : "STX18",
      gene_level : 1,
      hgnc_id : "HGNC:15942",
      havana_gene : "OTTHUMG00000090331.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 4859665,
      stop : 4863936,
      direction : "+",
      ID : "ENSG00000163132.8",
      gene_id : "ENSG00000163132.8",
      gene_type : "protein_coding",
      gene_name : "MSX1",
      gene_level : 2,
      hgnc_id : "HGNC:7391",
      havana_gene : "OTTHUMG00000090335.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 5014586,
      stop : 5019458,
      direction : "-",
      ID : "ENSG00000170891.11",
      gene_id : "ENSG00000170891.11",
      gene_type : "protein_coding",
      gene_name : "CYTL1",
      gene_level : 1,
      hgnc_id : "HGNC:24435",
      havana_gene : "OTTHUMG00000125479.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 5051480,
      stop : 5500994,
      direction : "+",
      ID : "ENSG00000152953.13",
      gene_id : "ENSG00000152953.13",
      gene_type : "protein_coding",
      gene_name : "STK32B",
      gene_level : 2,
      hgnc_id : "HGNC:14217",
      havana_gene : "OTTHUMG00000090423.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 5542772,
      stop : 5709548,
      direction : "-",
      ID : "ENSG00000173040.13",
      gene_id : "ENSG00000173040.13",
      gene_type : "protein_coding",
      gene_name : "EVC2",
      gene_level : 2,
      hgnc_id : "HGNC:19747",
      havana_gene : "OTTHUMG00000125493.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 5711201,
      stop : 5814305,
      direction : "+",
      ID : "ENSG00000072840.13",
      gene_id : "ENSG00000072840.13",
      gene_type : "protein_coding",
      gene_name : "EVC",
      gene_level : 1,
      hgnc_id : "HGNC:3497",
      havana_gene : "OTTHUMG00000090427.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 5748084,
      stop : 5893086,
      direction : "-",
      ID : "ENSG00000072832.15",
      gene_id : "ENSG00000072832.15",
      gene_type : "protein_coding",
      gene_name : "CRMP1",
      gene_level : 1,
      hgnc_id : "HGNC:2365",
      havana_gene : "OTTHUMG00000125489.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 5897373,
      stop : 6200555,
      direction : "-",
      ID : "ENSG00000181215.15",
      gene_id : "ENSG00000181215.15",
      gene_type : "protein_coding",
      gene_name : "C4orf50",
      gene_level : 2,
      hgnc_id : "HGNC:33766",
      havana_gene : "OTTHUMG00000192330.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6026199,
      stop : 6200591,
      direction : "-",
      ID : "ENSG00000152969.20",
      gene_id : "ENSG00000152969.20",
      gene_type : "protein_coding",
      gene_name : "JAKMIP1",
      gene_level : 2,
      hgnc_id : "HGNC:26460",
      havana_gene : "OTTHUMG00000193376.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6064977,
      stop : 6070162,
      direction : "-",
      ID : "ENSG00000284684.1",
      gene_id : "ENSG00000284684.1",
      gene_type : "protein_coding",
      gene_name : "AC092442.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000125491.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6269849,
      stop : 6303265,
      direction : "+",
      ID : "ENSG00000109501.14",
      gene_id : "ENSG00000109501.14",
      gene_type : "protein_coding",
      gene_name : "WFS1",
      gene_level : 2,
      hgnc_id : "HGNC:12762",
      havana_gene : "OTTHUMG00000090431.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6320578,
      stop : 6563600,
      direction : "-",
      ID : "ENSG00000074211.14",
      gene_id : "ENSG00000074211.14",
      gene_type : "protein_coding",
      gene_name : "PPP2R2C",
      gene_level : 2,
      hgnc_id : "HGNC:9306",
      havana_gene : "OTTHUMG00000090445.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6575189,
      stop : 6623362,
      direction : "+",
      ID : "ENSG00000013288.9",
      gene_id : "ENSG00000013288.9",
      gene_type : "protein_coding",
      gene_name : "MAN2B2",
      gene_level : 2,
      hgnc_id : "HGNC:29623",
      havana_gene : "OTTHUMG00000160073.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6640091,
      stop : 6642745,
      direction : "+",
      ID : "ENSG00000179010.15",
      gene_id : "ENSG00000179010.15",
      gene_type : "protein_coding",
      gene_name : "MRFAP1",
      gene_level : 2,
      hgnc_id : "HGNC:24549",
      havana_gene : "OTTHUMG00000125504.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6663396,
      stop : 6676755,
      direction : "+",
      ID : "ENSG00000170846.17",
      gene_id : "ENSG00000170846.17",
      gene_type : "protein_coding",
      gene_name : "AC093323.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000125505.7",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6693878,
      stop : 6697170,
      direction : "+",
      ID : "ENSG00000163993.7",
      gene_id : "ENSG00000163993.7",
      gene_type : "protein_coding",
      gene_name : "S100P",
      gene_level : 2,
      hgnc_id : "HGNC:10504",
      havana_gene : "OTTHUMG00000090491.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6707701,
      stop : 6709865,
      direction : "-",
      ID : "ENSG00000178988.11",
      gene_id : "ENSG00000178988.11",
      gene_type : "protein_coding",
      gene_name : "MRFAP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:28796",
      havana_gene : "OTTHUMG00000125507.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6716174,
      stop : 6717664,
      direction : "+",
      ID : "ENSG00000186222.5",
      gene_id : "ENSG00000186222.5",
      gene_type : "protein_coding",
      gene_name : "BLOC1S4",
      gene_level : 2,
      hgnc_id : "HGNC:24206",
      havana_gene : "OTTHUMG00000125510.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6781375,
      stop : 6884170,
      direction : "+",
      ID : "ENSG00000170871.12",
      gene_id : "ENSG00000170871.12",
      gene_type : "protein_coding",
      gene_name : "KIAA0232",
      gene_level : 2,
      hgnc_id : "HGNC:28992",
      havana_gene : "OTTHUMG00000160072.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 6909242,
      stop : 7033118,
      direction : "+",
      ID : "ENSG00000132405.19",
      gene_id : "ENSG00000132405.19",
      gene_type : "protein_coding",
      gene_name : "TBC1D14",
      gene_level : 1,
      hgnc_id : "HGNC:29246",
      havana_gene : "OTTHUMG00000090493.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7040849,
      stop : 7043001,
      direction : "-",
      ID : "ENSG00000173013.6",
      gene_id : "ENSG00000173013.6",
      gene_type : "protein_coding",
      gene_name : "CCDC96",
      gene_level : 2,
      hgnc_id : "HGNC:26900",
      havana_gene : "OTTHUMG00000125511.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7041899,
      stop : 7057952,
      direction : "+",
      ID : "ENSG00000173011.12",
      gene_id : "ENSG00000173011.12",
      gene_type : "protein_coding",
      gene_name : "TADA2B",
      gene_level : 2,
      hgnc_id : "HGNC:30781",
      havana_gene : "OTTHUMG00000159983.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7058895,
      stop : 7068064,
      direction : "-",
      ID : "ENSG00000109519.13",
      gene_id : "ENSG00000109519.13",
      gene_type : "protein_coding",
      gene_name : "GRPEL1",
      gene_level : 2,
      hgnc_id : "HGNC:19696",
      havana_gene : "OTTHUMG00000090495.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7192538,
      stop : 7742836,
      direction : "+",
      ID : "ENSG00000184985.16",
      gene_id : "ENSG00000184985.16",
      gene_type : "protein_coding",
      gene_name : "SORCS2",
      gene_level : 2,
      hgnc_id : "HGNC:16698",
      havana_gene : "OTTHUMG00000159981.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7430285,
      stop : 7434930,
      direction : "-",
      ID : "ENSG00000178597.7",
      gene_id : "ENSG00000178597.7",
      gene_type : "protein_coding",
      gene_name : "PSAPL1",
      gene_level : 2,
      hgnc_id : "HGNC:33131",
      havana_gene : "OTTHUMG00000160006.3",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7758714,
      stop : 7939926,
      direction : "-",
      ID : "ENSG00000196526.10",
      gene_id : "ENSG00000196526.10",
      gene_type : "protein_coding",
      gene_name : "AFAP1",
      gene_level : 2,
      hgnc_id : "HGNC:24017",
      havana_gene : "OTTHUMG00000125515.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 7965310,
      stop : 8158832,
      direction : "-",
      ID : "ENSG00000163995.21",
      gene_id : "ENSG00000163995.21",
      gene_type : "protein_coding",
      gene_name : "ABLIM2",
      gene_level : 2,
      hgnc_id : "HGNC:19195",
      havana_gene : "OTTHUMG00000057427.26",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8182072,
      stop : 8241803,
      direction : "+",
      ID : "ENSG00000125089.17",
      gene_id : "ENSG00000125089.17",
      gene_type : "protein_coding",
      gene_name : "SH3TC1",
      gene_level : 1,
      hgnc_id : "HGNC:26009",
      havana_gene : "OTTHUMG00000160934.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8269754,
      stop : 8307098,
      direction : "+",
      ID : "ENSG00000170801.10",
      gene_id : "ENSG00000170801.10",
      gene_type : "protein_coding",
      gene_name : "HTRA3",
      gene_level : 2,
      hgnc_id : "HGNC:30406",
      havana_gene : "OTTHUMG00000090561.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8366282,
      stop : 8440723,
      direction : "-",
      ID : "ENSG00000087008.16",
      gene_id : "ENSG00000087008.16",
      gene_type : "protein_coding",
      gene_name : "ACOX3",
      gene_level : 2,
      hgnc_id : "HGNC:121",
      havana_gene : "OTTHUMG00000090509.22",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8436140,
      stop : 8493531,
      direction : "+",
      ID : "ENSG00000155275.19",
      gene_id : "ENSG00000155275.19",
      gene_type : "protein_coding",
      gene_name : "TRMT44",
      gene_level : 1,
      hgnc_id : "HGNC:26653",
      havana_gene : "OTTHUMG00000160935.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8558725,
      stop : 8619761,
      direction : "+",
      ID : "ENSG00000155269.12",
      gene_id : "ENSG00000155269.12",
      gene_type : "protein_coding",
      gene_name : "GPR78",
      gene_level : 2,
      hgnc_id : "HGNC:4528",
      havana_gene : "OTTHUMG00000128483.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8592660,
      stop : 8619759,
      direction : "+",
      ID : "ENSG00000109625.19",
      gene_id : "ENSG00000109625.19",
      gene_type : "protein_coding",
      gene_name : "CPZ",
      gene_level : 1,
      hgnc_id : "HGNC:2333",
      havana_gene : "OTTHUMG00000090513.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 8846076,
      stop : 8871839,
      direction : "-",
      ID : "ENSG00000215612.8",
      gene_id : "ENSG00000215612.8",
      gene_type : "protein_coding",
      gene_name : "HMX1",
      gene_level : 2,
      hgnc_id : "HGNC:5017",
      havana_gene : "OTTHUMG00000160012.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9170409,
      stop : 9176730,
      direction : "+",
      ID : "ENSG00000229924.3",
      gene_id : "ENSG00000229924.3",
      gene_type : "protein_coding",
      gene_name : "FAM90A26",
      gene_level : 1,
      hgnc_id : "HGNC:43746",
      havana_gene : "OTTHUMG00000160151.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9210657,
      stop : 9212249,
      direction : "+",
      ID : "ENSG00000231396.3",
      gene_id : "ENSG00000231396.3",
      gene_type : "protein_coding",
      gene_name : "USP17L10",
      gene_level : 2,
      hgnc_id : "HGNC:44438",
      havana_gene : "OTTHUMG00000160160.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9215405,
      stop : 9216997,
      direction : "+",
      ID : "ENSG00000233136.3",
      gene_id : "ENSG00000233136.3",
      gene_type : "protein_coding",
      gene_name : "USP17L11",
      gene_level : 2,
      hgnc_id : "HGNC:44439",
      havana_gene : "OTTHUMG00000160162.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9220152,
      stop : 9221744,
      direction : "+",
      ID : "ENSG00000227551.1",
      gene_id : "ENSG00000227551.1",
      gene_type : "protein_coding",
      gene_name : "USP17L12",
      gene_level : 2,
      hgnc_id : "HGNC:44440",
      havana_gene : "OTTHUMG00000160148.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9224896,
      stop : 9226488,
      direction : "+",
      ID : "ENSG00000232399.4",
      gene_id : "ENSG00000232399.4",
      gene_type : "protein_coding",
      gene_name : "USP17L13",
      gene_level : 2,
      hgnc_id : "HGNC:44441",
      havana_gene : "OTTHUMG00000160152.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9234385,
      stop : 9236046,
      direction : "+",
      ID : "ENSG00000223569.8",
      gene_id : "ENSG00000223569.8",
      gene_type : "protein_coding",
      gene_name : "USP17L15",
      gene_level : 2,
      hgnc_id : "HGNC:44443",
      havana_gene : "OTTHUMG00000160155.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9243879,
      stop : 9245471,
      direction : "+",
      ID : "ENSG00000249104.3",
      gene_id : "ENSG00000249104.3",
      gene_type : "protein_coding",
      gene_name : "USP17L17",
      gene_level : 2,
      hgnc_id : "HGNC:44445",
      havana_gene : "OTTHUMG00000160158.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9248630,
      stop : 9250222,
      direction : "+",
      ID : "ENSG00000250844.3",
      gene_id : "ENSG00000250844.3",
      gene_type : "protein_coding",
      gene_name : "USP17L18",
      gene_level : 2,
      hgnc_id : "HGNC:44446",
      havana_gene : "OTTHUMG00000160153.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9253378,
      stop : 9254970,
      direction : "+",
      ID : "ENSG00000248920.3",
      gene_id : "ENSG00000248920.3",
      gene_type : "protein_coding",
      gene_name : "USP17L19",
      gene_level : 2,
      hgnc_id : "HGNC:44447",
      havana_gene : "OTTHUMG00000160146.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9258124,
      stop : 9259716,
      direction : "+",
      ID : "ENSG00000250745.3",
      gene_id : "ENSG00000250745.3",
      gene_type : "protein_coding",
      gene_name : "USP17L20",
      gene_level : 2,
      hgnc_id : "HGNC:44448",
      havana_gene : "OTTHUMG00000160150.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9262872,
      stop : 9264464,
      direction : "+",
      ID : "ENSG00000249811.3",
      gene_id : "ENSG00000249811.3",
      gene_type : "protein_coding",
      gene_name : "USP17L21",
      gene_level : 2,
      hgnc_id : "HGNC:44449",
      havana_gene : "OTTHUMG00000160149.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9267619,
      stop : 9269211,
      direction : "+",
      ID : "ENSG00000248933.3",
      gene_id : "ENSG00000248933.3",
      gene_type : "protein_coding",
      gene_name : "USP17L22",
      gene_level : 2,
      hgnc_id : "HGNC:44450",
      havana_gene : "OTTHUMG00000160159.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9272364,
      stop : 9272914,
      direction : "+",
      ID : "ENSG00000250913.2",
      gene_id : "ENSG00000250913.2",
      gene_type : "protein_coding",
      gene_name : "USP17L23",
      gene_level : 2,
      hgnc_id : "HGNC:44451",
      havana_gene : "OTTHUMG00000160156.3",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9325165,
      stop : 9326757,
      direction : "+",
      ID : "ENSG00000232264.5",
      gene_id : "ENSG00000232264.5",
      gene_type : "protein_coding",
      gene_name : "USP17L24",
      gene_level : 2,
      hgnc_id : "HGNC:44453",
      havana_gene : "OTTHUMG00000160201.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9329911,
      stop : 9331503,
      direction : "+",
      ID : "ENSG00000230430.5",
      gene_id : "ENSG00000230430.5",
      gene_type : "protein_coding",
      gene_name : "USP17L25",
      gene_level : 2,
      hgnc_id : "HGNC:44452",
      havana_gene : "OTTHUMG00000160192.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9334658,
      stop : 9336250,
      direction : "+",
      ID : "ENSG00000229579.5",
      gene_id : "ENSG00000229579.5",
      gene_type : "protein_coding",
      gene_name : "USP17L26",
      gene_level : 2,
      hgnc_id : "HGNC:44454",
      havana_gene : "OTTHUMG00000160189.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9339403,
      stop : 9340995,
      direction : "+",
      ID : "ENSG00000227140.3",
      gene_id : "ENSG00000227140.3",
      gene_type : "protein_coding",
      gene_name : "USP17L5",
      gene_level : 2,
      hgnc_id : "HGNC:37177",
      havana_gene : "OTTHUMG00000160182.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9344148,
      stop : 9345740,
      direction : "+",
      ID : "ENSG00000235780.3",
      gene_id : "ENSG00000235780.3",
      gene_type : "protein_coding",
      gene_name : "USP17L27",
      gene_level : 2,
      hgnc_id : "HGNC:44455",
      havana_gene : "OTTHUMG00000160186.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9348893,
      stop : 9350485,
      direction : "+",
      ID : "ENSG00000231051.3",
      gene_id : "ENSG00000231051.3",
      gene_type : "protein_coding",
      gene_name : "USP17L28",
      gene_level : 2,
      hgnc_id : "HGNC:44456",
      havana_gene : "OTTHUMG00000160191.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9353638,
      stop : 9355230,
      direction : "+",
      ID : "ENSG00000231637.3",
      gene_id : "ENSG00000231637.3",
      gene_type : "protein_coding",
      gene_name : "USP17L29",
      gene_level : 2,
      hgnc_id : "HGNC:44457",
      havana_gene : "OTTHUMG00000160183.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9363129,
      stop : 9364721,
      direction : "+",
      ID : "ENSG00000228856.3",
      gene_id : "ENSG00000228856.3",
      gene_type : "protein_coding",
      gene_name : "USP17L30",
      gene_level : 2,
      hgnc_id : "HGNC:44458",
      havana_gene : "OTTHUMG00000160199.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9444534,
      stop : 9450514,
      direction : "+",
      ID : "ENSG00000186146.1",
      gene_id : "ENSG00000186146.1",
      gene_type : "protein_coding",
      gene_name : "DEFB131A",
      gene_level : 2,
      hgnc_id : "HGNC:18108",
      havana_gene : "OTTHUMG00000160187.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9771153,
      stop : 10054936,
      direction : "-",
      ID : "ENSG00000109667.12",
      gene_id : "ENSG00000109667.12",
      gene_type : "protein_coding",
      gene_name : "SLC2A9",
      gene_level : 2,
      hgnc_id : "HGNC:13446",
      havana_gene : "OTTHUMG00000044263.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 9781634,
      stop : 9784009,
      direction : "+",
      ID : "ENSG00000169676.6",
      gene_id : "ENSG00000169676.6",
      gene_type : "protein_coding",
      gene_name : "DRD5",
      gene_level : 2,
      hgnc_id : "HGNC:3026",
      havana_gene : "OTTHUMG00000128489.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 10074339,
      stop : 10116949,
      direction : "-",
      ID : "ENSG00000071127.17",
      gene_id : "ENSG00000071127.17",
      gene_type : "protein_coding",
      gene_name : "WDR1",
      gene_level : 2,
      hgnc_id : "HGNC:12754",
      havana_gene : "OTTHUMG00000160253.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 10439880,
      stop : 10457426,
      direction : "-",
      ID : "ENSG00000178163.8",
      gene_id : "ENSG00000178163.8",
      gene_type : "protein_coding",
      gene_name : "ZNF518B",
      gene_level : 2,
      hgnc_id : "HGNC:29365",
      havana_gene : "OTTHUMG00000160060.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 10486395,
      stop : 10684768,
      direction : "-",
      ID : "ENSG00000109684.15",
      gene_id : "ENSG00000109684.15",
      gene_type : "protein_coding",
      gene_name : "CLNK",
      gene_level : 2,
      hgnc_id : "HGNC:17438",
      havana_gene : "OTTHUMG00000160062.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 11393150,
      stop : 11429564,
      direction : "-",
      ID : "ENSG00000002587.10",
      gene_id : "ENSG00000002587.10",
      gene_type : "protein_coding",
      gene_name : "HS3ST1",
      gene_level : 2,
      hgnc_id : "HGNC:5194",
      havana_gene : "OTTHUMG00000090547.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 13361354,
      stop : 13484365,
      direction : "-",
      ID : "ENSG00000157869.16",
      gene_id : "ENSG00000157869.16",
      gene_type : "protein_coding",
      gene_name : "RAB28",
      gene_level : 1,
      hgnc_id : "HGNC:9768",
      havana_gene : "OTTHUMG00000090543.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 13540830,
      stop : 13544508,
      direction : "-",
      ID : "ENSG00000109705.8",
      gene_id : "ENSG00000109705.8",
      gene_type : "protein_coding",
      gene_name : "NKX3-2",
      gene_level : 2,
      hgnc_id : "HGNC:951",
      havana_gene : "OTTHUMG00000090657.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 13568738,
      stop : 13627725,
      direction : "-",
      ID : "ENSG00000038219.13",
      gene_id : "ENSG00000038219.13",
      gene_type : "protein_coding",
      gene_name : "BOD1L1",
      gene_level : 1,
      hgnc_id : "HGNC:31792",
      havana_gene : "OTTHUMG00000090659.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15002481,
      stop : 15070153,
      direction : "+",
      ID : "ENSG00000137449.17",
      gene_id : "ENSG00000137449.17",
      gene_type : "protein_coding",
      gene_name : "CPEB2",
      gene_level : 2,
      hgnc_id : "HGNC:21745",
      havana_gene : "OTTHUMG00000090669.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15339818,
      stop : 15446167,
      direction : "+",
      ID : "ENSG00000163145.13",
      gene_id : "ENSG00000163145.13",
      gene_type : "protein_coding",
      gene_name : "C1QTNF7",
      gene_level : 1,
      hgnc_id : "HGNC:14342",
      havana_gene : "OTTHUMG00000097095.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15469865,
      stop : 15601552,
      direction : "+",
      ID : "ENSG00000048342.18",
      gene_id : "ENSG00000048342.18",
      gene_type : "protein_coding",
      gene_name : "CC2D2A",
      gene_level : 2,
      hgnc_id : "HGNC:29253",
      havana_gene : "OTTHUMG00000160255.16",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15604381,
      stop : 15681679,
      direction : "-",
      ID : "ENSG00000118564.15",
      gene_id : "ENSG00000118564.15",
      gene_type : "protein_coding",
      gene_name : "FBXL5",
      gene_level : 1,
      hgnc_id : "HGNC:13602",
      havana_gene : "OTTHUMG00000097097.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15681662,
      stop : 15690447,
      direction : "+",
      ID : "ENSG00000237765.8",
      gene_id : "ENSG00000237765.8",
      gene_type : "protein_coding",
      gene_name : "FAM200B",
      gene_level : 2,
      hgnc_id : "HGNC:27740",
      havana_gene : "OTTHUMG00000160279.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15703065,
      stop : 15738313,
      direction : "+",
      ID : "ENSG00000109743.11",
      gene_id : "ENSG00000109743.11",
      gene_type : "protein_coding",
      gene_name : "BST1",
      gene_level : 1,
      hgnc_id : "HGNC:1118",
      havana_gene : "OTTHUMG00000097739.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15778275,
      stop : 15853232,
      direction : "+",
      ID : "ENSG00000004468.13",
      gene_id : "ENSG00000004468.13",
      gene_type : "protein_coding",
      gene_name : "CD38",
      gene_level : 2,
      hgnc_id : "HGNC:1667",
      havana_gene : "OTTHUMG00000048206.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15935577,
      stop : 15938740,
      direction : "-",
      ID : "ENSG00000137440.5",
      gene_id : "ENSG00000137440.5",
      gene_type : "protein_coding",
      gene_name : "FGFBP1",
      gene_level : 2,
      hgnc_id : "HGNC:19695",
      havana_gene : "OTTHUMG00000097745.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15960245,
      stop : 15969309,
      direction : "-",
      ID : "ENSG00000137441.8",
      gene_id : "ENSG00000137441.8",
      gene_type : "protein_coding",
      gene_name : "FGFBP2",
      gene_level : 2,
      hgnc_id : "HGNC:29451",
      havana_gene : "OTTHUMG00000128513.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 15963076,
      stop : 16084378,
      direction : "-",
      ID : "ENSG00000007062.12",
      gene_id : "ENSG00000007062.12",
      gene_type : "protein_coding",
      gene_name : "PROM1",
      gene_level : 1,
      hgnc_id : "HGNC:9454",
      havana_gene : "OTTHUMG00000160180.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 16160505,
      stop : 16227410,
      direction : "-",
      ID : "ENSG00000169762.17",
      gene_id : "ENSG00000169762.17",
      gene_type : "protein_coding",
      gene_name : "TAPT1",
      gene_level : 2,
      hgnc_id : "HGNC:26887",
      havana_gene : "OTTHUMG00000160177.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 16501541,
      stop : 16898678,
      direction : "-",
      ID : "ENSG00000169744.13",
      gene_id : "ENSG00000169744.13",
      gene_type : "protein_coding",
      gene_name : "LDB2",
      gene_level : 1,
      hgnc_id : "HGNC:6533",
      havana_gene : "OTTHUMG00000048212.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17460261,
      stop : 17512206,
      direction : "-",
      ID : "ENSG00000151552.12",
      gene_id : "ENSG00000151552.12",
      gene_type : "protein_coding",
      gene_name : "QDPR",
      gene_level : 2,
      hgnc_id : "HGNC:9752",
      havana_gene : "OTTHUMG00000128537.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17515165,
      stop : 17527104,
      direction : "+",
      ID : "ENSG00000249581.2",
      gene_id : "ENSG00000249581.2",
      gene_type : "protein_coding",
      gene_name : "CLRN2",
      gene_level : 2,
      hgnc_id : "HGNC:33939",
      havana_gene : "OTTHUMG00000160273.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17577198,
      stop : 17607972,
      direction : "+",
      ID : "ENSG00000002549.13",
      gene_id : "ENSG00000002549.13",
      gene_type : "protein_coding",
      gene_name : "LAP3",
      gene_level : 2,
      hgnc_id : "HGNC:18449",
      havana_gene : "OTTHUMG00000048214.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17614641,
      stop : 17634105,
      direction : "+",
      ID : "ENSG00000118579.13",
      gene_id : "ENSG00000118579.13",
      gene_type : "protein_coding",
      gene_name : "MED28",
      gene_level : 1,
      hgnc_id : "HGNC:24628",
      havana_gene : "OTTHUMG00000161980.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17629306,
      stop : 17781621,
      direction : "-",
      ID : "ENSG00000047662.5",
      gene_id : "ENSG00000047662.5",
      gene_type : "protein_coding",
      gene_name : "FAM184B",
      gene_level : 2,
      hgnc_id : "HGNC:29235",
      havana_gene : "OTTHUMG00000160287.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17800655,
      stop : 17810758,
      direction : "-",
      ID : "ENSG00000163257.11",
      gene_id : "ENSG00000163257.11",
      gene_type : "protein_coding",
      gene_name : "DCAF16",
      gene_level : 2,
      hgnc_id : "HGNC:25987",
      havana_gene : "OTTHUMG00000128536.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17810979,
      stop : 17844865,
      direction : "+",
      ID : "ENSG00000109805.10",
      gene_id : "ENSG00000109805.10",
      gene_type : "protein_coding",
      gene_name : "NCAPG",
      gene_level : 2,
      hgnc_id : "HGNC:24304",
      havana_gene : "OTTHUMG00000128539.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 17841199,
      stop : 18021876,
      direction : "-",
      ID : "ENSG00000178177.16",
      gene_id : "ENSG00000178177.16",
      gene_type : "protein_coding",
      gene_name : "LCORL",
      gene_level : 2,
      hgnc_id : "HGNC:30776",
      havana_gene : "OTTHUMG00000128538.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 20251905,
      stop : 20620561,
      direction : "+",
      ID : "ENSG00000145147.20",
      gene_id : "ENSG00000145147.20",
      gene_type : "protein_coding",
      gene_name : "SLIT2",
      gene_level : 2,
      hgnc_id : "HGNC:11086",
      havana_gene : "OTTHUMG00000128551.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 20696282,
      stop : 20752907,
      direction : "+",
      ID : "ENSG00000163138.19",
      gene_id : "ENSG00000163138.19",
      gene_type : "protein_coding",
      gene_name : "PACRGL",
      gene_level : 1,
      hgnc_id : "HGNC:28442",
      havana_gene : "OTTHUMG00000128550.19",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 20728606,
      stop : 21948772,
      direction : "-",
      ID : "ENSG00000185774.16",
      gene_id : "ENSG00000185774.16",
      gene_type : "protein_coding",
      gene_name : "KCNIP4",
      gene_level : 2,
      hgnc_id : "HGNC:30083",
      havana_gene : "OTTHUMG00000128557.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 22345071,
      stop : 22516066,
      direction : "-",
      ID : "ENSG00000152990.14",
      gene_id : "ENSG00000152990.14",
      gene_type : "protein_coding",
      gene_name : "ADGRA3",
      gene_level : 1,
      hgnc_id : "HGNC:13839",
      havana_gene : "OTTHUMG00000160926.13",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 23755041,
      stop : 23904089,
      direction : "-",
      ID : "ENSG00000109819.9",
      gene_id : "ENSG00000109819.9",
      gene_type : "protein_coding",
      gene_name : "PPARGC1A",
      gene_level : 1,
      hgnc_id : "HGNC:9237",
      havana_gene : "OTTHUMG00000097747.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 24517441,
      stop : 24584554,
      direction : "-",
      ID : "ENSG00000109606.13",
      gene_id : "ENSG00000109606.13",
      gene_type : "protein_coding",
      gene_name : "DHX15",
      gene_level : 2,
      hgnc_id : "HGNC:2738",
      havana_gene : "OTTHUMG00000160304.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 24789912,
      stop : 24800842,
      direction : "+",
      ID : "ENSG00000109610.6",
      gene_id : "ENSG00000109610.6",
      gene_type : "protein_coding",
      gene_name : "SOD3",
      gene_level : 2,
      hgnc_id : "HGNC:11181",
      havana_gene : "OTTHUMG00000128565.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 24806117,
      stop : 24980204,
      direction : "-",
      ID : "ENSG00000181982.19",
      gene_id : "ENSG00000181982.19",
      gene_type : "protein_coding",
      gene_name : "CCDC149",
      gene_level : 1,
      hgnc_id : "HGNC:25405",
      havana_gene : "OTTHUMG00000160308.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 24998847,
      stop : 25030946,
      direction : "-",
      ID : "ENSG00000153012.12",
      gene_id : "ENSG00000153012.12",
      gene_type : "protein_coding",
      gene_name : "LGI2",
      gene_level : 2,
      hgnc_id : "HGNC:18710",
      havana_gene : "OTTHUMG00000097749.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25120014,
      stop : 25160550,
      direction : "-",
      ID : "ENSG00000109618.13",
      gene_id : "ENSG00000109618.13",
      gene_type : "protein_coding",
      gene_name : "SEPSECS",
      gene_level : 1,
      hgnc_id : "HGNC:30605",
      havana_gene : "OTTHUMG00000128563.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25160663,
      stop : 25279204,
      direction : "+",
      ID : "ENSG00000038210.14",
      gene_id : "ENSG00000038210.14",
      gene_type : "protein_coding",
      gene_name : "PI4K2B",
      gene_level : 1,
      hgnc_id : "HGNC:18215",
      havana_gene : "OTTHUMG00000128564.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25312774,
      stop : 25370383,
      direction : "+",
      ID : "ENSG00000168228.15",
      gene_id : "ENSG00000168228.15",
      gene_type : "protein_coding",
      gene_name : "ZCCHC4",
      gene_level : 2,
      hgnc_id : "HGNC:22917",
      havana_gene : "OTTHUMG00000160563.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25377263,
      stop : 25418498,
      direction : "+",
      ID : "ENSG00000053900.11",
      gene_id : "ENSG00000053900.11",
      gene_type : "protein_coding",
      gene_name : "ANAPC4",
      gene_level : 2,
      hgnc_id : "HGNC:19990",
      havana_gene : "OTTHUMG00000097753.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25648011,
      stop : 25678748,
      direction : "+",
      ID : "ENSG00000157765.13",
      gene_id : "ENSG00000157765.13",
      gene_type : "protein_coding",
      gene_name : "SLC34A2",
      gene_level : 2,
      hgnc_id : "HGNC:11020",
      havana_gene : "OTTHUMG00000097757.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25747433,
      stop : 25863760,
      direction : "-",
      ID : "ENSG00000091490.11",
      gene_id : "ENSG00000091490.11",
      gene_type : "protein_coding",
      gene_name : "SEL1L3",
      gene_level : 1,
      hgnc_id : "HGNC:29108",
      havana_gene : "OTTHUMG00000160331.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 25861830,
      stop : 25929874,
      direction : "+",
      ID : "ENSG00000250317.8",
      gene_id : "ENSG00000250317.8",
      gene_type : "protein_coding",
      gene_name : "SMIM20",
      gene_level : 2,
      hgnc_id : "HGNC:37260",
      havana_gene : "OTTHUMG00000160330.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 26163455,
      stop : 26435131,
      direction : "+",
      ID : "ENSG00000168214.21",
      gene_id : "ENSG00000168214.21",
      gene_type : "protein_coding",
      gene_name : "RBPJ",
      gene_level : 1,
      hgnc_id : "HGNC:5724",
      havana_gene : "OTTHUMG00000097793.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 26481396,
      stop : 26490484,
      direction : "-",
      ID : "ENSG00000163394.6",
      gene_id : "ENSG00000163394.6",
      gene_type : "protein_coding",
      gene_name : "CCKAR",
      gene_level : 2,
      hgnc_id : "HGNC:1570",
      havana_gene : "OTTHUMG00000128567.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 26576437,
      stop : 26756223,
      direction : "+",
      ID : "ENSG00000109680.11",
      gene_id : "ENSG00000109680.11",
      gene_type : "protein_coding",
      gene_name : "TBC1D19",
      gene_level : 2,
      hgnc_id : "HGNC:25624",
      havana_gene : "OTTHUMG00000097797.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 26857601,
      stop : 27025381,
      direction : "+",
      ID : "ENSG00000109689.19",
      gene_id : "ENSG00000109689.19",
      gene_type : "protein_coding",
      gene_name : "STIM2",
      gene_level : 1,
      hgnc_id : "HGNC:19205",
      havana_gene : "OTTHUMG00000097805.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 30720415,
      stop : 31146805,
      direction : "+",
      ID : "ENSG00000169851.15",
      gene_id : "ENSG00000169851.15",
      gene_type : "protein_coding",
      gene_name : "PCDH7",
      gene_level : 1,
      hgnc_id : "HGNC:8659",
      havana_gene : "OTTHUMG00000160364.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 35948221,
      stop : 36244514,
      direction : "-",
      ID : "ENSG00000047365.12",
      gene_id : "ENSG00000047365.12",
      gene_type : "protein_coding",
      gene_name : "ARAP2",
      gene_level : 2,
      hgnc_id : "HGNC:16924",
      havana_gene : "OTTHUMG00000097811.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 36281616,
      stop : 36347511,
      direction : "+",
      ID : "ENSG00000197057.10",
      gene_id : "ENSG00000197057.10",
      gene_type : "protein_coding",
      gene_name : "DTHD1",
      gene_level : 2,
      hgnc_id : "HGNC:37261",
      havana_gene : "OTTHUMG00000160371.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 37244743,
      stop : 37449463,
      direction : "+",
      ID : "ENSG00000174145.8",
      gene_id : "ENSG00000174145.8",
      gene_type : "protein_coding",
      gene_name : "NWD2",
      gene_level : 2,
      hgnc_id : "HGNC:29229",
      havana_gene : "OTTHUMG00000157134.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 37453925,
      stop : 37623495,
      direction : "+",
      ID : "ENSG00000154274.15",
      gene_id : "ENSG00000154274.15",
      gene_type : "protein_coding",
      gene_name : "C4orf19",
      gene_level : 2,
      hgnc_id : "HGNC:25618",
      havana_gene : "OTTHUMG00000128580.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 37590800,
      stop : 37686376,
      direction : "-",
      ID : "ENSG00000181826.10",
      gene_id : "ENSG00000181826.10",
      gene_type : "protein_coding",
      gene_name : "RELL1",
      gene_level : 2,
      hgnc_id : "HGNC:27379",
      havana_gene : "OTTHUMG00000160389.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 37826660,
      stop : 37862937,
      direction : "+",
      ID : "ENSG00000169299.14",
      gene_id : "ENSG00000169299.14",
      gene_type : "protein_coding",
      gene_name : "PGM2",
      gene_level : 2,
      hgnc_id : "HGNC:8906",
      havana_gene : "OTTHUMG00000097813.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 37891084,
      stop : 38139175,
      direction : "+",
      ID : "ENSG00000065882.16",
      gene_id : "ENSG00000065882.16",
      gene_type : "protein_coding",
      gene_name : "TBC1D1",
      gene_level : 1,
      hgnc_id : "HGNC:11578",
      havana_gene : "OTTHUMG00000150302.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 37960398,
      stop : 37961128,
      direction : "+",
      ID : "ENSG00000250254.2",
      gene_id : "ENSG00000250254.2",
      gene_type : "protein_coding",
      gene_name : "PTTG2",
      gene_level : 2,
      hgnc_id : "HGNC:9691",
      havana_gene : "OTTHUMG00000160424.2",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 38664197,
      stop : 38701517,
      direction : "+",
      ID : "ENSG00000109787.13",
      gene_id : "ENSG00000109787.13",
      gene_type : "protein_coding",
      gene_name : "KLF3",
      gene_level : 2,
      hgnc_id : "HGNC:16516",
      havana_gene : "OTTHUMG00000097821.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 38772238,
      stop : 38782990,
      direction : "-",
      ID : "ENSG00000174123.11",
      gene_id : "ENSG00000174123.11",
      gene_type : "protein_coding",
      gene_name : "TLR10",
      gene_level : 1,
      hgnc_id : "HGNC:15634",
      havana_gene : "OTTHUMG00000128578.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 38790677,
      stop : 38856817,
      direction : "-",
      ID : "ENSG00000174125.8",
      gene_id : "ENSG00000174125.8",
      gene_type : "protein_coding",
      gene_name : "TLR1",
      gene_level : 2,
      hgnc_id : "HGNC:11847",
      havana_gene : "OTTHUMG00000160413.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 38823715,
      stop : 38856817,
      direction : "-",
      ID : "ENSG00000174130.12",
      gene_id : "ENSG00000174130.12",
      gene_type : "protein_coding",
      gene_name : "TLR6",
      gene_level : 2,
      hgnc_id : "HGNC:16711",
      havana_gene : "OTTHUMG00000128579.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 38867677,
      stop : 38945739,
      direction : "+",
      ID : "ENSG00000197712.12",
      gene_id : "ENSG00000197712.12",
      gene_type : "protein_coding",
      gene_name : "FAM114A1",
      gene_level : 2,
      hgnc_id : "HGNC:25087",
      havana_gene : "OTTHUMG00000128583.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 38966744,
      stop : 39032922,
      direction : "-",
      ID : "ENSG00000121895.8",
      gene_id : "ENSG00000121895.8",
      gene_type : "protein_coding",
      gene_name : "TMEM156",
      gene_level : 1,
      hgnc_id : "HGNC:26260",
      havana_gene : "OTTHUMG00000128582.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39045039,
      stop : 39126857,
      direction : "+",
      ID : "ENSG00000109790.17",
      gene_id : "ENSG00000109790.17",
      gene_type : "protein_coding",
      gene_name : "KLHL5",
      gene_level : 1,
      hgnc_id : "HGNC:6356",
      havana_gene : "OTTHUMG00000097819.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39182504,
      stop : 39285810,
      direction : "+",
      ID : "ENSG00000157796.18",
      gene_id : "ENSG00000157796.18",
      gene_type : "protein_coding",
      gene_name : "WDR19",
      gene_level : 2,
      hgnc_id : "HGNC:18340",
      havana_gene : "OTTHUMG00000160466.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39287456,
      stop : 39366375,
      direction : "-",
      ID : "ENSG00000035928.16",
      gene_id : "ENSG00000035928.16",
      gene_type : "protein_coding",
      gene_name : "RFC1",
      gene_level : 2,
      hgnc_id : "HGNC:9969",
      havana_gene : "OTTHUMG00000099363.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39406930,
      stop : 39451533,
      direction : "+",
      ID : "ENSG00000134962.7",
      gene_id : "ENSG00000134962.7",
      gene_type : "protein_coding",
      gene_name : "KLB",
      gene_level : 2,
      hgnc_id : "HGNC:15527",
      havana_gene : "OTTHUMG00000128577.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39452587,
      stop : 39458931,
      direction : "-",
      ID : "ENSG00000163682.17",
      gene_id : "ENSG00000163682.17",
      gene_type : "protein_coding",
      gene_name : "RPL9",
      gene_level : 2,
      hgnc_id : "HGNC:10369",
      havana_gene : "OTTHUMG00000099367.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39459004,
      stop : 39485109,
      direction : "+",
      ID : "ENSG00000121897.15",
      gene_id : "ENSG00000121897.15",
      gene_type : "protein_coding",
      gene_name : "LIAS",
      gene_level : 1,
      hgnc_id : "HGNC:16429",
      havana_gene : "OTTHUMG00000099369.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39498755,
      stop : 39528311,
      direction : "-",
      ID : "ENSG00000109814.12",
      gene_id : "ENSG00000109814.12",
      gene_type : "protein_coding",
      gene_name : "UGDH",
      gene_level : 1,
      hgnc_id : "HGNC:12525",
      havana_gene : "OTTHUMG00000099371.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39546336,
      stop : 39638902,
      direction : "-",
      ID : "ENSG00000163683.12",
      gene_id : "ENSG00000163683.12",
      gene_type : "protein_coding",
      gene_name : "SMIM14",
      gene_level : 1,
      hgnc_id : "HGNC:27321",
      havana_gene : "OTTHUMG00000128581.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39698109,
      stop : 39782792,
      direction : "+",
      ID : "ENSG00000078140.14",
      gene_id : "ENSG00000078140.14",
      gene_type : "protein_coding",
      gene_name : "UBE2K",
      gene_level : 1,
      hgnc_id : "HGNC:4914",
      havana_gene : "OTTHUMG00000160543.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 39822863,
      stop : 39977956,
      direction : "-",
      ID : "ENSG00000121892.15",
      gene_id : "ENSG00000121892.15",
      gene_type : "protein_coding",
      gene_name : "PDS5A",
      gene_level : 2,
      hgnc_id : "HGNC:29088",
      havana_gene : "OTTHUMG00000160582.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 40056850,
      stop : 40158252,
      direction : "+",
      ID : "ENSG00000078177.14",
      gene_id : "ENSG00000078177.14",
      gene_type : "protein_coding",
      gene_name : "N4BP2",
      gene_level : 1,
      hgnc_id : "HGNC:29851",
      havana_gene : "OTTHUMG00000128599.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 40191053,
      stop : 40246967,
      direction : "+",
      ID : "ENSG00000168421.13",
      gene_id : "ENSG00000168421.13",
      gene_type : "protein_coding",
      gene_name : "RHOH",
      gene_level : 2,
      hgnc_id : "HGNC:686",
      havana_gene : "OTTHUMG00000099373.6",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 40335333,
      stop : 40355217,
      direction : "+",
      ID : "ENSG00000174343.6",
      gene_id : "ENSG00000174343.6",
      gene_type : "protein_coding",
      gene_name : "CHRNA9",
      gene_level : 2,
      hgnc_id : "HGNC:14079",
      havana_gene : "OTTHUMG00000099375.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 40423267,
      stop : 40630875,
      direction : "-",
      ID : "ENSG00000163694.15",
      gene_id : "ENSG00000163694.15",
      gene_type : "protein_coding",
      gene_name : "RBM47",
      gene_level : 2,
      hgnc_id : "HGNC:30358",
      havana_gene : "OTTHUMG00000128598.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 40749925,
      stop : 40811184,
      direction : "+",
      ID : "ENSG00000179299.17",
      gene_id : "ENSG00000179299.17",
      gene_type : "protein_coding",
      gene_name : "NSUN7",
      gene_level : 1,
      hgnc_id : "HGNC:25857",
      havana_gene : "OTTHUMG00000128597.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 40810027,
      stop : 41216714,
      direction : "-",
      ID : "ENSG00000163697.17",
      gene_id : "ENSG00000163697.17",
      gene_type : "protein_coding",
      gene_name : "APBB2",
      gene_level : 2,
      hgnc_id : "HGNC:582",
      havana_gene : "OTTHUMG00000160416.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 41256413,
      stop : 41268455,
      direction : "+",
      ID : "ENSG00000154277.13",
      gene_id : "ENSG00000154277.13",
      gene_type : "protein_coding",
      gene_name : "UCHL1",
      gene_level : 1,
      hgnc_id : "HGNC:12513",
      havana_gene : "OTTHUMG00000099377.17",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 41359607,
      stop : 41700044,
      direction : "+",
      ID : "ENSG00000064042.18",
      gene_id : "ENSG00000064042.18",
      gene_type : "protein_coding",
      gene_name : "LIMCH1",
      gene_level : 1,
      hgnc_id : "HGNC:29191",
      havana_gene : "OTTHUMG00000160575.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 41744082,
      stop : 41748725,
      direction : "-",
      ID : "ENSG00000109132.7",
      gene_id : "ENSG00000109132.7",
      gene_type : "protein_coding",
      gene_name : "PHOX2B",
      gene_level : 2,
      hgnc_id : "HGNC:9143",
      havana_gene : "OTTHUMG00000099379.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 41935129,
      stop : 41960803,
      direction : "+",
      ID : "ENSG00000109133.13",
      gene_id : "ENSG00000109133.13",
      gene_type : "protein_coding",
      gene_name : "TMEM33",
      gene_level : 1,
      hgnc_id : "HGNC:25541",
      havana_gene : "OTTHUMG00000099381.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 41981756,
      stop : 41986465,
      direction : "+",
      ID : "ENSG00000182308.7",
      gene_id : "ENSG00000182308.7",
      gene_type : "protein_coding",
      gene_name : "DCAF4L1",
      gene_level : 2,
      hgnc_id : "HGNC:27723",
      havana_gene : "OTTHUMG00000160527.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 41990502,
      stop : 42090461,
      direction : "+",
      ID : "ENSG00000014824.14",
      gene_id : "ENSG00000014824.14",
      gene_type : "protein_coding",
      gene_name : "SLC30A9",
      gene_level : 2,
      hgnc_id : "HGNC:1329",
      havana_gene : "OTTHUMG00000099387.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 42110853,
      stop : 42152878,
      direction : "-",
      ID : "ENSG00000188848.16",
      gene_id : "ENSG00000188848.16",
      gene_type : "protein_coding",
      gene_name : "BEND4",
      gene_level : 2,
      hgnc_id : "HGNC:23815",
      havana_gene : "OTTHUMG00000160531.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 42397488,
      stop : 42402487,
      direction : "+",
      ID : "ENSG00000178343.5",
      gene_id : "ENSG00000178343.5",
      gene_type : "protein_coding",
      gene_name : "SHISA3",
      gene_level : 2,
      hgnc_id : "HGNC:25159",
      havana_gene : "OTTHUMG00000161043.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 42408373,
      stop : 42657105,
      direction : "-",
      ID : "ENSG00000124406.16",
      gene_id : "ENSG00000124406.16",
      gene_type : "protein_coding",
      gene_name : "ATP8A1",
      gene_level : 2,
      hgnc_id : "HGNC:13531",
      havana_gene : "OTTHUMG00000099403.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 42892713,
      stop : 43030658,
      direction : "+",
      ID : "ENSG00000215203.3",
      gene_id : "ENSG00000215203.3",
      gene_type : "protein_coding",
      gene_name : "GRXCR1",
      gene_level : 2,
      hgnc_id : "HGNC:31673",
      havana_gene : "OTTHUMG00000160434.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 44173903,
      stop : 44448809,
      direction : "-",
      ID : "ENSG00000183783.7",
      gene_id : "ENSG00000183783.7",
      gene_type : "protein_coding",
      gene_name : "KCTD8",
      gene_level : 2,
      hgnc_id : "HGNC:22394",
      havana_gene : "OTTHUMG00000099409.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 44622065,
      stop : 44678556,
      direction : "-",
      ID : "ENSG00000177752.14",
      gene_id : "ENSG00000177752.14",
      gene_type : "protein_coding",
      gene_name : "YIPF7",
      gene_level : 1,
      hgnc_id : "HGNC:26825",
      havana_gene : "OTTHUMG00000160467.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 44678420,
      stop : 44700928,
      direction : "+",
      ID : "ENSG00000151806.14",
      gene_id : "ENSG00000151806.14",
      gene_type : "protein_coding",
      gene_name : "GUF1",
      gene_level : 2,
      hgnc_id : "HGNC:25799",
      havana_gene : "OTTHUMG00000128608.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 44682200,
      stop : 44726588,
      direction : "-",
      ID : "ENSG00000163281.12",
      gene_id : "ENSG00000163281.12",
      gene_type : "protein_coding",
      gene_name : "GNPDA2",
      gene_level : 1,
      hgnc_id : "HGNC:21526",
      havana_gene : "OTTHUMG00000099415.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 46035769,
      stop : 46124054,
      direction : "-",
      ID : "ENSG00000163285.8",
      gene_id : "ENSG00000163285.8",
      gene_type : "protein_coding",
      gene_name : "GABRG1",
      gene_level : 2,
      hgnc_id : "HGNC:4086",
      havana_gene : "OTTHUMG00000128609.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 46243548,
      stop : 46475230,
      direction : "-",
      ID : "ENSG00000151834.16",
      gene_id : "ENSG00000151834.16",
      gene_type : "protein_coding",
      gene_name : "GABRA2",
      gene_level : 1,
      hgnc_id : "HGNC:4076",
      havana_gene : "OTTHUMG00000044266.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 46734827,
      stop : 46909245,
      direction : "-",
      ID : "ENSG00000170516.17",
      gene_id : "ENSG00000170516.17",
      gene_type : "protein_coding",
      gene_name : "COX7B2",
      gene_level : 2,
      hgnc_id : "HGNC:24381",
      havana_gene : "OTTHUMG00000099423.5",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 46918900,
      stop : 46993581,
      direction : "-",
      ID : "ENSG00000109158.11",
      gene_id : "ENSG00000109158.11",
      gene_type : "protein_coding",
      gene_name : "GABRA4",
      gene_level : 2,
      hgnc_id : "HGNC:4078",
      havana_gene : "OTTHUMG00000099431.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 46993723,
      stop : 47426447,
      direction : "+",
      ID : "ENSG00000163288.14",
      gene_id : "ENSG00000163288.14",
      gene_type : "protein_coding",
      gene_name : "GABRB1",
      gene_level : 2,
      hgnc_id : "HGNC:4081",
      havana_gene : "OTTHUMG00000044269.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 47450787,
      stop : 47463702,
      direction : "-",
      ID : "ENSG00000169019.11",
      gene_id : "ENSG00000169019.11",
      gene_type : "protein_coding",
      gene_name : "COMMD8",
      gene_level : 2,
      hgnc_id : "HGNC:26036",
      havana_gene : "OTTHUMG00000099435.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 47485275,
      stop : 47593486,
      direction : "+",
      ID : "ENSG00000145246.14",
      gene_id : "ENSG00000145246.14",
      gene_type : "protein_coding",
      gene_name : "ATP10D",
      gene_level : 2,
      hgnc_id : "HGNC:13549",
      havana_gene : "OTTHUMG00000160784.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 47593999,
      stop : 47838106,
      direction : "-",
      ID : "ENSG00000145244.12",
      gene_id : "ENSG00000145244.12",
      gene_type : "protein_coding",
      gene_name : "CORIN",
      gene_level : 1,
      hgnc_id : "HGNC:19012",
      havana_gene : "OTTHUMG00000099441.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 47847233,
      stop : 47914667,
      direction : "-",
      ID : "ENSG00000170448.12",
      gene_id : "ENSG00000170448.12",
      gene_type : "protein_coding",
      gene_name : "NFXL1",
      gene_level : 2,
      hgnc_id : "HGNC:18726",
      havana_gene : "OTTHUMG00000128621.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 47914142,
      stop : 48040173,
      direction : "+",
      ID : "ENSG00000163293.12",
      gene_id : "ENSG00000163293.12",
      gene_type : "protein_coding",
      gene_name : "NIPAL1",
      gene_level : 2,
      hgnc_id : "HGNC:27194",
      havana_gene : "OTTHUMG00000128622.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 47935977,
      stop : 48016681,
      direction : "-",
      ID : "ENSG00000198515.16",
      gene_id : "ENSG00000198515.16",
      gene_type : "protein_coding",
      gene_name : "CNGA1",
      gene_level : 2,
      hgnc_id : "HGNC:2148",
      havana_gene : "OTTHUMG00000160668.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48066393,
      stop : 48134250,
      direction : "-",
      ID : "ENSG00000074966.11",
      gene_id : "ENSG00000074966.11",
      gene_type : "protein_coding",
      gene_name : "TXK",
      gene_level : 1,
      hgnc_id : "HGNC:12434",
      havana_gene : "OTTHUMG00000102065.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48135783,
      stop : 48269838,
      direction : "-",
      ID : "ENSG00000135605.13",
      gene_id : "ENSG00000135605.13",
      gene_type : "protein_coding",
      gene_name : "TEC",
      gene_level : 2,
      hgnc_id : "HGNC:11719",
      havana_gene : "OTTHUMG00000128623.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48341529,
      stop : 48426201,
      direction : "+",
      ID : "ENSG00000109171.15",
      gene_id : "ENSG00000109171.15",
      gene_type : "protein_coding",
      gene_name : "SLAIN2",
      gene_level : 2,
      hgnc_id : "HGNC:29282",
      havana_gene : "OTTHUMG00000161701.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48483343,
      stop : 48489526,
      direction : "+",
      ID : "ENSG00000145248.7",
      gene_id : "ENSG00000145248.7",
      gene_type : "protein_coding",
      gene_name : "SLC10A4",
      gene_level : 2,
      hgnc_id : "HGNC:22980",
      havana_gene : "OTTHUMG00000102092.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48490252,
      stop : 48494389,
      direction : "+",
      ID : "ENSG00000182223.7",
      gene_id : "ENSG00000182223.7",
      gene_type : "protein_coding",
      gene_name : "ZAR1",
      gene_level : 2,
      hgnc_id : "HGNC:20436",
      havana_gene : "OTTHUMG00000102093.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48497357,
      stop : 48780322,
      direction : "-",
      ID : "ENSG00000075539.15",
      gene_id : "ENSG00000075539.15",
      gene_type : "protein_coding",
      gene_name : "FRYL",
      gene_level : 1,
      hgnc_id : "HGNC:29127",
      havana_gene : "OTTHUMG00000160608.18",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48805212,
      stop : 48861817,
      direction : "+",
      ID : "ENSG00000109180.15",
      gene_id : "ENSG00000109180.15",
      gene_type : "protein_coding",
      gene_name : "OCIAD1",
      gene_level : 1,
      hgnc_id : "HGNC:16074",
      havana_gene : "OTTHUMG00000102095.19",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48885019,
      stop : 48906937,
      direction : "-",
      ID : "ENSG00000145247.12",
      gene_id : "ENSG00000145247.12",
      gene_type : "protein_coding",
      gene_name : "OCIAD2",
      gene_level : 2,
      hgnc_id : "HGNC:28685",
      havana_gene : "OTTHUMG00000128626.35",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 48986275,
      stop : 49062081,
      direction : "+",
      ID : "ENSG00000109182.12",
      gene_id : "ENSG00000109182.12",
      gene_type : "protein_coding",
      gene_name : "CWH43",
      gene_level : 1,
      hgnc_id : "HGNC:26133",
      havana_gene : "OTTHUMG00000128627.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 51843000,
      stop : 51916837,
      direction : "+",
      ID : "ENSG00000109184.15",
      gene_id : "ENSG00000109184.15",
      gene_type : "protein_coding",
      gene_name : "DCUN1D4",
      gene_level : 2,
      hgnc_id : "HGNC:28998",
      havana_gene : "OTTHUMG00000128700.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 51993702,
      stop : 52017620,
      direction : "-",
      ID : "ENSG00000188993.3",
      gene_id : "ENSG00000188993.3",
      gene_type : "protein_coding",
      gene_name : "LRRC66",
      gene_level : 2,
      hgnc_id : "HGNC:34299",
      havana_gene : "OTTHUMG00000160623.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 52020706,
      stop : 52038299,
      direction : "-",
      ID : "ENSG00000163069.13",
      gene_id : "ENSG00000163069.13",
      gene_type : "protein_coding",
      gene_name : "SGCB",
      gene_level : 2,
      hgnc_id : "HGNC:10806",
      havana_gene : "OTTHUMG00000128697.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 52051304,
      stop : 52097299,
      direction : "+",
      ID : "ENSG00000163071.11",
      gene_id : "ENSG00000163071.11",
      gene_type : "protein_coding",
      gene_name : "SPATA18",
      gene_level : 1,
      hgnc_id : "HGNC:29579",
      havana_gene : "OTTHUMG00000128698.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 52590960,
      stop : 52659301,
      direction : "-",
      ID : "ENSG00000109189.13",
      gene_id : "ENSG00000109189.13",
      gene_type : "protein_coding",
      gene_name : "USP46",
      gene_level : 2,
      hgnc_id : "HGNC:20075",
      havana_gene : "OTTHUMG00000160640.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 52722618,
      stop : 52751586,
      direction : "-",
      ID : "ENSG00000226887.8",
      gene_id : "ENSG00000226887.8",
      gene_type : "protein_coding",
      gene_name : "ERVMER34-1",
      gene_level : 2,
      hgnc_id : "HGNC:42970",
      havana_gene : "OTTHUMG00000150366.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 52862317,
      stop : 52866835,
      direction : "+",
      ID : "ENSG00000128045.7",
      gene_id : "ENSG00000128045.7",
      gene_type : "protein_coding",
      gene_name : "RASL11B",
      gene_level : 2,
      hgnc_id : "HGNC:23804",
      havana_gene : "OTTHUMG00000102097.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 52872982,
      stop : 53366066,
      direction : "-",
      ID : "ENSG00000184178.16",
      gene_id : "ENSG00000184178.16",
      gene_type : "protein_coding",
      gene_name : "SCFD2",
      gene_level : 1,
      hgnc_id : "HGNC:30676",
      havana_gene : "OTTHUMG00000160588.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 53377641,
      stop : 53460862,
      direction : "+",
      ID : "ENSG00000145216.16",
      gene_id : "ENSG00000145216.16",
      gene_type : "protein_coding",
      gene_name : "FIP1L1",
      gene_level : 1,
      hgnc_id : "HGNC:19124",
      havana_gene : "OTTHUMG00000128701.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 53377839,
      stop : 54295272,
      direction : "+",
      ID : "ENSG00000282278.1",
      gene_id : "ENSG00000282278.1",
      gene_type : "protein_coding",
      gene_name : "AC058822.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000190741.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 53459301,
      stop : 53701405,
      direction : "-",
      ID : "ENSG00000072201.14",
      gene_id : "ENSG00000072201.14",
      gene_type : "protein_coding",
      gene_name : "LNX1",
      gene_level : 2,
      hgnc_id : "HGNC:6657",
      havana_gene : "OTTHUMG00000102099.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 54009789,
      stop : 54064605,
      direction : "-",
      ID : "ENSG00000109220.11",
      gene_id : "ENSG00000109220.11",
      gene_type : "protein_coding",
      gene_name : "CHIC2",
      gene_level : 2,
      hgnc_id : "HGNC:1935",
      havana_gene : "OTTHUMG00000102101.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 54099523,
      stop : 54102498,
      direction : "+",
      ID : "ENSG00000180613.11",
      gene_id : "ENSG00000180613.11",
      gene_type : "protein_coding",
      gene_name : "GSX2",
      gene_level : 1,
      hgnc_id : "HGNC:24959",
      havana_gene : "OTTHUMG00000128696.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 54229280,
      stop : 54298245,
      direction : "+",
      ID : "ENSG00000134853.12",
      gene_id : "ENSG00000134853.12",
      gene_type : "protein_coding",
      gene_name : "PDGFRA",
      gene_level : 2,
      hgnc_id : "HGNC:8803",
      havana_gene : "OTTHUMG00000128699.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 54657918,
      stop : 54740715,
      direction : "+",
      ID : "ENSG00000157404.16",
      gene_id : "ENSG00000157404.16",
      gene_type : "protein_coding",
      gene_name : "KIT",
      gene_level : 1,
      hgnc_id : "HGNC:6342",
      havana_gene : "OTTHUMG00000128713.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55078481,
      stop : 55125595,
      direction : "-",
      ID : "ENSG00000128052.10",
      gene_id : "ENSG00000128052.10",
      gene_type : "protein_coding",
      gene_name : "KDR",
      gene_level : 2,
      hgnc_id : "HGNC:6307",
      havana_gene : "OTTHUMG00000128734.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55346213,
      stop : 55373100,
      direction : "+",
      ID : "ENSG00000128039.13",
      gene_id : "ENSG00000128039.13",
      gene_type : "protein_coding",
      gene_name : "SRD5A3",
      gene_level : 2,
      hgnc_id : "HGNC:25812",
      havana_gene : "OTTHUMG00000128733.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55346228,
      stop : 55388368,
      direction : "+",
      ID : "ENSG00000288695.1",
      gene_id : "ENSG00000288695.1",
      gene_type : "protein_coding",
      gene_name : "AC064824.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55395957,
      stop : 55453397,
      direction : "+",
      ID : "ENSG00000134851.13",
      gene_id : "ENSG00000134851.13",
      gene_type : "protein_coding",
      gene_name : "TMEM165",
      gene_level : 2,
      hgnc_id : "HGNC:30760",
      havana_gene : "OTTHUMG00000128735.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55427903,
      stop : 55546909,
      direction : "-",
      ID : "ENSG00000134852.15",
      gene_id : "ENSG00000134852.15",
      gene_type : "protein_coding",
      gene_name : "CLOCK",
      gene_level : 2,
      hgnc_id : "HGNC:2082",
      havana_gene : "OTTHUMG00000102141.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55556519,
      stop : 55592245,
      direction : "-",
      ID : "ENSG00000163440.12",
      gene_id : "ENSG00000163440.12",
      gene_type : "protein_coding",
      gene_name : "PDCL2",
      gene_level : 2,
      hgnc_id : "HGNC:29524",
      havana_gene : "OTTHUMG00000160674.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55595229,
      stop : 55636698,
      direction : "-",
      ID : "ENSG00000109255.11",
      gene_id : "ENSG00000109255.11",
      gene_type : "protein_coding",
      gene_name : "NMU",
      gene_level : 2,
      hgnc_id : "HGNC:7859",
      havana_gene : "OTTHUMG00000102161.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55819790,
      stop : 55837489,
      direction : "+",
      ID : "ENSG00000250821.3",
      gene_id : "ENSG00000250821.3",
      gene_type : "protein_coding",
      gene_name : "EXOC1L",
      gene_level : 2,
      hgnc_id : "HGNC:53433",
      havana_gene : "OTTHUMG00000160694.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55853648,
      stop : 55905086,
      direction : "+",
      ID : "ENSG00000090989.18",
      gene_id : "ENSG00000090989.18",
      gene_type : "protein_coding",
      gene_name : "EXOC1",
      gene_level : 2,
      hgnc_id : "HGNC:30380",
      havana_gene : "OTTHUMG00000102165.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 55948871,
      stop : 56033361,
      direction : "+",
      ID : "ENSG00000174799.11",
      gene_id : "ENSG00000174799.11",
      gene_type : "protein_coding",
      gene_name : "CEP135",
      gene_level : 2,
      hgnc_id : "HGNC:29086",
      havana_gene : "OTTHUMG00000160748.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56049073,
      stop : 56328625,
      direction : "+",
      ID : "ENSG00000109265.14",
      gene_id : "ENSG00000109265.14",
      gene_type : "protein_coding",
      gene_name : "CRACD",
      gene_level : 2,
      hgnc_id : "HGNC:29219",
      havana_gene : "OTTHUMG00000160749.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56338287,
      stop : 56387508,
      direction : "-",
      ID : "ENSG00000157426.14",
      gene_id : "ENSG00000157426.14",
      gene_type : "protein_coding",
      gene_name : "AASDH",
      gene_level : 1,
      hgnc_id : "HGNC:23993",
      havana_gene : "OTTHUMG00000128841.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56393362,
      stop : 56435615,
      direction : "-",
      ID : "ENSG00000128059.8",
      gene_id : "ENSG00000128059.8",
      gene_type : "protein_coding",
      gene_name : "PPAT",
      gene_level : 2,
      hgnc_id : "HGNC:9238",
      havana_gene : "OTTHUMG00000128842.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56435741,
      stop : 56464578,
      direction : "+",
      ID : "ENSG00000128050.9",
      gene_id : "ENSG00000128050.9",
      gene_type : "protein_coding",
      gene_name : "PAICS",
      gene_level : 1,
      hgnc_id : "HGNC:8587",
      havana_gene : "OTTHUMG00000160957.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56467617,
      stop : 56503681,
      direction : "+",
      ID : "ENSG00000174780.17",
      gene_id : "ENSG00000174780.17",
      gene_type : "protein_coding",
      gene_name : "SRP72",
      gene_level : 2,
      hgnc_id : "HGNC:11303",
      havana_gene : "OTTHUMG00000128843.17",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56505209,
      stop : 56524959,
      direction : "+",
      ID : "ENSG00000196503.5",
      gene_id : "ENSG00000196503.5",
      gene_type : "protein_coding",
      gene_name : "ARL9",
      gene_level : 2,
      hgnc_id : "HGNC:23592",
      havana_gene : "OTTHUMG00000184000.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56530606,
      stop : 56603507,
      direction : "+",
      ID : "ENSG00000249693.3",
      gene_id : "ENSG00000249693.3",
      gene_type : "protein_coding",
      gene_name : "THEGL",
      gene_level : 1,
      hgnc_id : "HGNC:43771",
      havana_gene : "OTTHUMG00000160770.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56647988,
      stop : 56681899,
      direction : "-",
      ID : "ENSG00000171476.22",
      gene_id : "ENSG00000171476.22",
      gene_type : "protein_coding",
      gene_name : "HOPX",
      gene_level : 2,
      hgnc_id : "HGNC:24961",
      havana_gene : "OTTHUMG00000128768.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56809860,
      stop : 56821742,
      direction : "-",
      ID : "ENSG00000128040.11",
      gene_id : "ENSG00000128040.11",
      gene_type : "protein_coding",
      gene_name : "SPINK2",
      gene_level : 2,
      hgnc_id : "HGNC:11245",
      havana_gene : "OTTHUMG00000128769.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56907876,
      stop : 56966808,
      direction : "+",
      ID : "ENSG00000084093.19",
      gene_id : "ENSG00000084093.19",
      gene_type : "protein_coding",
      gene_name : "REST",
      gene_level : 2,
      hgnc_id : "HGNC:9966",
      havana_gene : "OTTHUMG00000128770.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56963350,
      stop : 56977606,
      direction : "-",
      ID : "ENSG00000084092.7",
      gene_id : "ENSG00000084092.7",
      gene_type : "protein_coding",
      gene_name : "NOA1",
      gene_level : 2,
      hgnc_id : "HGNC:28473",
      havana_gene : "OTTHUMG00000128773.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 56977722,
      stop : 57031158,
      direction : "+",
      ID : "ENSG00000047315.17",
      gene_id : "ENSG00000047315.17",
      gene_type : "protein_coding",
      gene_name : "POLR2B",
      gene_level : 2,
      hgnc_id : "HGNC:9188",
      havana_gene : "OTTHUMG00000128771.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 57030773,
      stop : 57110385,
      direction : "-",
      ID : "ENSG00000163453.11",
      gene_id : "ENSG00000163453.11",
      gene_type : "protein_coding",
      gene_name : "IGFBP7",
      gene_level : 2,
      hgnc_id : "HGNC:5476",
      havana_gene : "OTTHUMG00000128772.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 61201258,
      stop : 62078335,
      direction : "+",
      ID : "ENSG00000150471.16",
      gene_id : "ENSG00000150471.16",
      gene_type : "protein_coding",
      gene_name : "ADGRL3",
      gene_level : 2,
      hgnc_id : "HGNC:20974",
      havana_gene : "OTTHUMG00000160690.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 64275257,
      stop : 64409468,
      direction : "-",
      ID : "ENSG00000205678.8",
      gene_id : "ENSG00000205678.8",
      gene_type : "protein_coding",
      gene_name : "TECRL",
      gene_level : 2,
      hgnc_id : "HGNC:27365",
      havana_gene : "OTTHUMG00000160680.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 65319563,
      stop : 65670495,
      direction : "-",
      ID : "ENSG00000145242.14",
      gene_id : "ENSG00000145242.14",
      gene_type : "protein_coding",
      gene_name : "EPHA5",
      gene_level : 2,
      hgnc_id : "HGNC:3389",
      havana_gene : "OTTHUMG00000129273.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 67468762,
      stop : 67545503,
      direction : "-",
      ID : "ENSG00000145241.11",
      gene_id : "ENSG00000145241.11",
      gene_type : "protein_coding",
      gene_name : "CENPC",
      gene_level : 2,
      hgnc_id : "HGNC:1854",
      havana_gene : "OTTHUMG00000160735.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 67558727,
      stop : 67607337,
      direction : "+",
      ID : "ENSG00000035720.8",
      gene_id : "ENSG00000035720.8",
      gene_type : "protein_coding",
      gene_name : "STAP1",
      gene_level : 2,
      hgnc_id : "HGNC:24133",
      havana_gene : "OTTHUMG00000129304.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 67612652,
      stop : 67701155,
      direction : "-",
      ID : "ENSG00000033178.13",
      gene_id : "ENSG00000033178.13",
      gene_type : "protein_coding",
      gene_name : "UBA6",
      gene_level : 2,
      hgnc_id : "HGNC:25581",
      havana_gene : "OTTHUMG00000129299.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 67737118,
      stop : 67754388,
      direction : "-",
      ID : "ENSG00000109163.7",
      gene_id : "ENSG00000109163.7",
      gene_type : "protein_coding",
      gene_name : "GNRHR",
      gene_level : 2,
      hgnc_id : "HGNC:4421",
      havana_gene : "OTTHUMG00000129302.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 67820876,
      stop : 67884002,
      direction : "-",
      ID : "ENSG00000153802.12",
      gene_id : "ENSG00000153802.12",
      gene_type : "protein_coding",
      gene_name : "TMPRSS11D",
      gene_level : 2,
      hgnc_id : "HGNC:24059",
      havana_gene : "OTTHUMG00000129300.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 67909395,
      stop : 67964140,
      direction : "-",
      ID : "ENSG00000187054.16",
      gene_id : "ENSG00000187054.16",
      gene_type : "protein_coding",
      gene_name : "TMPRSS11A",
      gene_level : 2,
      hgnc_id : "HGNC:27954",
      havana_gene : "OTTHUMG00000129303.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68053198,
      stop : 68129869,
      direction : "-",
      ID : "ENSG00000198092.6",
      gene_id : "ENSG00000198092.6",
      gene_type : "protein_coding",
      gene_name : "TMPRSS11F",
      gene_level : 2,
      hgnc_id : "HGNC:29994",
      havana_gene : "OTTHUMG00000129307.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68226653,
      stop : 68245694,
      direction : "-",
      ID : "ENSG00000185873.8",
      gene_id : "ENSG00000185873.8",
      gene_type : "protein_coding",
      gene_name : "TMPRSS11B",
      gene_level : 2,
      hgnc_id : "HGNC:25398",
      havana_gene : "OTTHUMG00000129301.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68310387,
      stop : 68350090,
      direction : "-",
      ID : "ENSG00000083896.13",
      gene_id : "ENSG00000083896.13",
      gene_type : "protein_coding",
      gene_name : "YTHDC1",
      gene_level : 2,
      hgnc_id : "HGNC:30626",
      havana_gene : "OTTHUMG00000129306.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68447463,
      stop : 68497604,
      direction : "+",
      ID : "ENSG00000087128.10",
      gene_id : "ENSG00000087128.10",
      gene_type : "protein_coding",
      gene_name : "TMPRSS11E",
      gene_level : 2,
      hgnc_id : "HGNC:24465",
      havana_gene : "OTTHUMG00000160438.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68537184,
      stop : 68568527,
      direction : "-",
      ID : "ENSG00000197888.2",
      gene_id : "ENSG00000197888.2",
      gene_type : "protein_coding",
      gene_name : "UGT2B17",
      gene_level : 2,
      hgnc_id : "HGNC:12547",
      havana_gene : "OTTHUMG00000129305.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68646597,
      stop : 68670652,
      direction : "-",
      ID : "ENSG00000196620.10",
      gene_id : "ENSG00000196620.10",
      gene_type : "protein_coding",
      gene_name : "UGT2B15",
      gene_level : 2,
      hgnc_id : "HGNC:12546",
      havana_gene : "OTTHUMG00000161507.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68815994,
      stop : 68832023,
      direction : "+",
      ID : "ENSG00000109181.12",
      gene_id : "ENSG00000109181.12",
      gene_type : "protein_coding",
      gene_name : "UGT2B10",
      gene_level : 2,
      hgnc_id : "HGNC:12544",
      havana_gene : "OTTHUMG00000161505.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 68928463,
      stop : 68951804,
      direction : "-",
      ID : "ENSG00000135220.11",
      gene_id : "ENSG00000135220.11",
      gene_type : "protein_coding",
      gene_name : "UGT2A3",
      gene_level : 2,
      hgnc_id : "HGNC:28528",
      havana_gene : "OTTHUMG00000129408.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69051363,
      stop : 69112987,
      direction : "+",
      ID : "ENSG00000171234.14",
      gene_id : "ENSG00000171234.14",
      gene_type : "protein_coding",
      gene_name : "UGT2B7",
      gene_level : 1,
      hgnc_id : "HGNC:12554",
      havana_gene : "OTTHUMG00000129404.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69199951,
      stop : 69214748,
      direction : "-",
      ID : "ENSG00000213759.10",
      gene_id : "ENSG00000213759.10",
      gene_type : "protein_coding",
      gene_name : "UGT2B11",
      gene_level : 2,
      hgnc_id : "HGNC:12545",
      havana_gene : "OTTHUMG00000129395.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69280475,
      stop : 69295050,
      direction : "+",
      ID : "ENSG00000135226.18",
      gene_id : "ENSG00000135226.18",
      gene_type : "protein_coding",
      gene_name : "UGT2B28",
      gene_level : 2,
      hgnc_id : "HGNC:13479",
      havana_gene : "OTTHUMG00000129401.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69480165,
      stop : 69526014,
      direction : "-",
      ID : "ENSG00000156096.14",
      gene_id : "ENSG00000156096.14",
      gene_type : "protein_coding",
      gene_name : "UGT2B4",
      gene_level : 2,
      hgnc_id : "HGNC:12553",
      havana_gene : "OTTHUMG00000058891.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69588417,
      stop : 69639642,
      direction : "-",
      ID : "ENSG00000271271.6",
      gene_id : "ENSG00000271271.6",
      gene_type : "protein_coding",
      gene_name : "UGT2A2",
      gene_level : 2,
      hgnc_id : "HGNC:28183",
      havana_gene : "OTTHUMG00000129398.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69588417,
      stop : 69653249,
      direction : "-",
      ID : "ENSG00000173610.12",
      gene_id : "ENSG00000173610.12",
      gene_type : "protein_coding",
      gene_name : "UGT2A1",
      gene_level : 2,
      hgnc_id : "HGNC:12542",
      havana_gene : "OTTHUMG00000184942.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69721167,
      stop : 69787961,
      direction : "-",
      ID : "ENSG00000173597.9",
      gene_id : "ENSG00000173597.9",
      gene_type : "protein_coding",
      gene_name : "SULT1B1",
      gene_level : 1,
      hgnc_id : "HGNC:17845",
      havana_gene : "OTTHUMG00000129407.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69810780,
      stop : 69847786,
      direction : "-",
      ID : "ENSG00000284695.1",
      gene_id : "ENSG00000284695.1",
      gene_type : "protein_coding",
      gene_name : "AC108941.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192252.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69841212,
      stop : 69860145,
      direction : "-",
      ID : "ENSG00000109193.12",
      gene_id : "ENSG00000109193.12",
      gene_type : "protein_coding",
      gene_name : "SULT1E1",
      gene_level : 2,
      hgnc_id : "HGNC:11377",
      havana_gene : "OTTHUMG00000129403.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69931068,
      stop : 69946574,
      direction : "+",
      ID : "ENSG00000126545.14",
      gene_id : "ENSG00000126545.14",
      gene_type : "protein_coding",
      gene_name : "CSN1S1",
      gene_level : 2,
      hgnc_id : "HGNC:2445",
      havana_gene : "OTTHUMG00000160843.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69955256,
      stop : 69961007,
      direction : "-",
      ID : "ENSG00000135222.6",
      gene_id : "ENSG00000135222.6",
      gene_type : "protein_coding",
      gene_name : "CSN2",
      gene_level : 2,
      hgnc_id : "HGNC:2447",
      havana_gene : "OTTHUMG00000129409.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 69995966,
      stop : 70002570,
      direction : "+",
      ID : "ENSG00000126549.11",
      gene_id : "ENSG00000126549.11",
      gene_type : "protein_coding",
      gene_name : "STATH",
      gene_level : 2,
      hgnc_id : "HGNC:11369",
      havana_gene : "OTTHUMG00000129394.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70028455,
      stop : 70036538,
      direction : "+",
      ID : "ENSG00000205649.9",
      gene_id : "ENSG00000205649.9",
      gene_type : "protein_coding",
      gene_name : "HTN3",
      gene_level : 2,
      hgnc_id : "HGNC:5284",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70050438,
      stop : 70058848,
      direction : "+",
      ID : "ENSG00000126550.10",
      gene_id : "ENSG00000126550.10",
      gene_type : "protein_coding",
      gene_name : "HTN1",
      gene_level : 2,
      hgnc_id : "HGNC:5283",
      havana_gene : "OTTHUMG00000129397.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70133616,
      stop : 70176799,
      direction : "+",
      ID : "ENSG00000187533.14",
      gene_id : "ENSG00000187533.14",
      gene_type : "protein_coding",
      gene_name : "PRR27",
      gene_level : 2,
      hgnc_id : "HGNC:33193",
      havana_gene : "OTTHUMG00000129402.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70196496,
      stop : 70204576,
      direction : "+",
      ID : "ENSG00000109205.16",
      gene_id : "ENSG00000109205.16",
      gene_type : "protein_coding",
      gene_name : "ODAM",
      gene_level : 2,
      hgnc_id : "HGNC:26043",
      havana_gene : "OTTHUMG00000129406.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70226124,
      stop : 70235252,
      direction : "+",
      ID : "ENSG00000181617.6",
      gene_id : "ENSG00000181617.6",
      gene_type : "protein_coding",
      gene_name : "FDCSP",
      gene_level : 2,
      hgnc_id : "HGNC:19215",
      havana_gene : "OTTHUMG00000129393.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70242588,
      stop : 70251428,
      direction : "+",
      ID : "ENSG00000171209.3",
      gene_id : "ENSG00000171209.3",
      gene_type : "protein_coding",
      gene_name : "CSN3",
      gene_level : 2,
      hgnc_id : "HGNC:2446",
      havana_gene : "OTTHUMG00000129399.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70334981,
      stop : 70337116,
      direction : "+",
      ID : "ENSG00000145309.6",
      gene_id : "ENSG00000145309.6",
      gene_type : "protein_coding",
      gene_name : "CABS1",
      gene_level : 2,
      hgnc_id : "HGNC:30710",
      havana_gene : "OTTHUMG00000129405.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70360760,
      stop : 70367158,
      direction : "+",
      ID : "ENSG00000109208.5",
      gene_id : "ENSG00000109208.5",
      gene_type : "protein_coding",
      gene_name : "SMR3A",
      gene_level : 2,
      hgnc_id : "HGNC:19216",
      havana_gene : "OTTHUMG00000160839.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70370093,
      stop : 70390244,
      direction : "+",
      ID : "ENSG00000171201.12",
      gene_id : "ENSG00000171201.12",
      gene_type : "protein_coding",
      gene_name : "SMR3B",
      gene_level : 2,
      hgnc_id : "HGNC:17326",
      havana_gene : "OTTHUMG00000129396.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70397931,
      stop : 70410195,
      direction : "+",
      ID : "ENSG00000171199.11",
      gene_id : "ENSG00000171199.11",
      gene_type : "protein_coding",
      gene_name : "OPRPN",
      gene_level : 1,
      hgnc_id : "HGNC:17279",
      havana_gene : "OTTHUMG00000160845.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70430492,
      stop : 70482997,
      direction : "+",
      ID : "ENSG00000171195.11",
      gene_id : "ENSG00000171195.11",
      gene_type : "protein_coding",
      gene_name : "MUC7",
      gene_level : 2,
      hgnc_id : "HGNC:7518",
      havana_gene : "OTTHUMG00000129916.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70518569,
      stop : 70532743,
      direction : "+",
      ID : "ENSG00000187689.10",
      gene_id : "ENSG00000187689.10",
      gene_type : "protein_coding",
      gene_name : "AMTN",
      gene_level : 2,
      hgnc_id : "HGNC:33188",
      havana_gene : "OTTHUMG00000129906.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70592256,
      stop : 70607288,
      direction : "+",
      ID : "ENSG00000178522.14",
      gene_id : "ENSG00000178522.14",
      gene_type : "protein_coding",
      gene_name : "AMBN",
      gene_level : 2,
      hgnc_id : "HGNC:452",
      havana_gene : "OTTHUMG00000129913.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70628744,
      stop : 70646824,
      direction : "+",
      ID : "ENSG00000132464.13",
      gene_id : "ENSG00000132464.13",
      gene_type : "protein_coding",
      gene_name : "ENAM",
      gene_level : 2,
      hgnc_id : "HGNC:3344",
      havana_gene : "OTTHUMG00000193855.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70655541,
      stop : 70681817,
      direction : "-",
      ID : "ENSG00000132465.12",
      gene_id : "ENSG00000132465.12",
      gene_type : "protein_coding",
      gene_name : "JCHAIN",
      gene_level : 2,
      hgnc_id : "HGNC:5713",
      havana_gene : "OTTHUMG00000129909.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70688532,
      stop : 70690551,
      direction : "+",
      ID : "ENSG00000132467.4",
      gene_id : "ENSG00000132467.4",
      gene_type : "protein_coding",
      gene_name : "UTP3",
      gene_level : 2,
      hgnc_id : "HGNC:24477",
      havana_gene : "OTTHUMG00000129911.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70704204,
      stop : 70808619,
      direction : "+",
      ID : "ENSG00000018189.13",
      gene_id : "ENSG00000018189.13",
      gene_type : "protein_coding",
      gene_name : "RUFY3",
      gene_level : 1,
      hgnc_id : "HGNC:30285",
      havana_gene : "OTTHUMG00000129910.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70815783,
      stop : 70839897,
      direction : "-",
      ID : "ENSG00000132463.14",
      gene_id : "ENSG00000132463.14",
      gene_type : "protein_coding",
      gene_name : "GRSF1",
      gene_level : 1,
      hgnc_id : "HGNC:4610",
      havana_gene : "OTTHUMG00000160846.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70902326,
      stop : 71022449,
      direction : "+",
      ID : "ENSG00000173542.9",
      gene_id : "ENSG00000173542.9",
      gene_type : "protein_coding",
      gene_name : "MOB1B",
      gene_level : 2,
      hgnc_id : "HGNC:29801",
      havana_gene : "OTTHUMG00000160844.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 70992538,
      stop : 71030914,
      direction : "+",
      ID : "ENSG00000156136.10",
      gene_id : "ENSG00000156136.10",
      gene_type : "protein_coding",
      gene_name : "DCK",
      gene_level : 2,
      hgnc_id : "HGNC:2704",
      havana_gene : "OTTHUMG00000129908.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 71062667,
      stop : 71572087,
      direction : "+",
      ID : "ENSG00000080493.18",
      gene_id : "ENSG00000080493.18",
      gene_type : "protein_coding",
      gene_name : "SLC4A4",
      gene_level : 2,
      hgnc_id : "HGNC:11030",
      havana_gene : "OTTHUMG00000129907.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 71741696,
      stop : 71804041,
      direction : "-",
      ID : "ENSG00000145321.13",
      gene_id : "ENSG00000145321.13",
      gene_type : "protein_coding",
      gene_name : "GC",
      gene_level : 2,
      hgnc_id : "HGNC:4187",
      havana_gene : "OTTHUMG00000129915.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 72031804,
      stop : 72148067,
      direction : "+",
      ID : "ENSG00000056291.18",
      gene_id : "ENSG00000056291.18",
      gene_type : "protein_coding",
      gene_name : "NPFFR2",
      gene_level : 2,
      hgnc_id : "HGNC:4525",
      havana_gene : "OTTHUMG00000129918.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 72280969,
      stop : 72569221,
      direction : "-",
      ID : "ENSG00000156140.10",
      gene_id : "ENSG00000156140.10",
      gene_type : "protein_coding",
      gene_name : "ADAMTS3",
      gene_level : 2,
      hgnc_id : "HGNC:219",
      havana_gene : "OTTHUMG00000129912.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73052362,
      stop : 73069755,
      direction : "-",
      ID : "ENSG00000163626.17",
      gene_id : "ENSG00000163626.17",
      gene_type : "protein_coding",
      gene_name : "COX18",
      gene_level : 1,
      hgnc_id : "HGNC:26801",
      havana_gene : "OTTHUMG00000129917.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73073376,
      stop : 73258798,
      direction : "-",
      ID : "ENSG00000132466.19",
      gene_id : "ENSG00000132466.19",
      gene_type : "protein_coding",
      gene_name : "ANKRD17",
      gene_level : 1,
      hgnc_id : "HGNC:23575",
      havana_gene : "OTTHUMG00000160826.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73397114,
      stop : 73421482,
      direction : "+",
      ID : "ENSG00000163631.17",
      gene_id : "ENSG00000163631.17",
      gene_type : "protein_coding",
      gene_name : "ALB",
      gene_level : 1,
      hgnc_id : "HGNC:399",
      havana_gene : "OTTHUMG00000129919.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73431138,
      stop : 73456174,
      direction : "+",
      ID : "ENSG00000081051.8",
      gene_id : "ENSG00000081051.8",
      gene_type : "protein_coding",
      gene_name : "AFP",
      gene_level : 2,
      hgnc_id : "HGNC:317",
      havana_gene : "OTTHUMG00000130011.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73481745,
      stop : 73504001,
      direction : "+",
      ID : "ENSG00000079557.5",
      gene_id : "ENSG00000079557.5",
      gene_type : "protein_coding",
      gene_name : "AFM",
      gene_level : 2,
      hgnc_id : "HGNC:316",
      havana_gene : "OTTHUMG00000130004.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73571550,
      stop : 73620631,
      direction : "-",
      ID : "ENSG00000169435.14",
      gene_id : "ENSG00000169435.14",
      gene_type : "protein_coding",
      gene_name : "RASSF6",
      gene_level : 2,
      hgnc_id : "HGNC:20796",
      havana_gene : "OTTHUMG00000130007.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73740541,
      stop : 73743716,
      direction : "+",
      ID : "ENSG00000169429.11",
      gene_id : "ENSG00000169429.11",
      gene_type : "protein_coding",
      gene_name : "CXCL8",
      gene_level : 2,
      hgnc_id : "HGNC:6025",
      havana_gene : "OTTHUMG00000151316.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73836640,
      stop : 73849064,
      direction : "+",
      ID : "ENSG00000124875.10",
      gene_id : "ENSG00000124875.10",
      gene_type : "protein_coding",
      gene_name : "CXCL6",
      gene_level : 1,
      hgnc_id : "HGNC:10643",
      havana_gene : "OTTHUMG00000130010.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73853296,
      stop : 73854483,
      direction : "+",
      ID : "ENSG00000109272.4",
      gene_id : "ENSG00000109272.4",
      gene_type : "protein_coding",
      gene_name : "PF4V1",
      gene_level : 2,
      hgnc_id : "HGNC:8862",
      havana_gene : "OTTHUMG00000130177.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73869393,
      stop : 73871308,
      direction : "+",
      ID : "ENSG00000163739.5",
      gene_id : "ENSG00000163739.5",
      gene_type : "protein_coding",
      gene_name : "CXCL1",
      gene_level : 2,
      hgnc_id : "HGNC:4602",
      havana_gene : "OTTHUMG00000160866.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73980811,
      stop : 73982027,
      direction : "-",
      ID : "ENSG00000163737.4",
      gene_id : "ENSG00000163737.4",
      gene_type : "protein_coding",
      gene_name : "PF4",
      gene_level : 2,
      hgnc_id : "HGNC:8861",
      havana_gene : "OTTHUMG00000130009.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73986439,
      stop : 73988190,
      direction : "-",
      ID : "ENSG00000163736.4",
      gene_id : "ENSG00000163736.4",
      gene_type : "protein_coding",
      gene_name : "PPBP",
      gene_level : 2,
      hgnc_id : "HGNC:9240",
      havana_gene : "OTTHUMG00000130008.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 73995642,
      stop : 73998677,
      direction : "-",
      ID : "ENSG00000163735.7",
      gene_id : "ENSG00000163735.7",
      gene_type : "protein_coding",
      gene_name : "CXCL5",
      gene_level : 2,
      hgnc_id : "HGNC:10642",
      havana_gene : "OTTHUMG00000160871.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74036589,
      stop : 74038807,
      direction : "-",
      ID : "ENSG00000163734.4",
      gene_id : "ENSG00000163734.4",
      gene_type : "protein_coding",
      gene_name : "CXCL3",
      gene_level : 2,
      hgnc_id : "HGNC:4604",
      havana_gene : "OTTHUMG00000160861.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74097040,
      stop : 74099196,
      direction : "-",
      ID : "ENSG00000081041.9",
      gene_id : "ENSG00000081041.9",
      gene_type : "protein_coding",
      gene_name : "CXCL2",
      gene_level : 2,
      hgnc_id : "HGNC:4603",
      havana_gene : "OTTHUMG00000160865.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74114174,
      stop : 74303099,
      direction : "+",
      ID : "ENSG00000163738.18",
      gene_id : "ENSG00000163738.18",
      gene_type : "protein_coding",
      gene_name : "MTHFD2L",
      gene_level : 1,
      hgnc_id : "HGNC:31865",
      havana_gene : "OTTHUMG00000157135.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74308470,
      stop : 74316789,
      direction : "+",
      ID : "ENSG00000182585.10",
      gene_id : "ENSG00000182585.10",
      gene_type : "protein_coding",
      gene_name : "EPGN",
      gene_level : 2,
      hgnc_id : "HGNC:17470",
      havana_gene : "OTTHUMG00000160869.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74365145,
      stop : 74388749,
      direction : "+",
      ID : "ENSG00000124882.4",
      gene_id : "ENSG00000124882.4",
      gene_type : "protein_coding",
      gene_name : "EREG",
      gene_level : 2,
      hgnc_id : "HGNC:3443",
      havana_gene : "OTTHUMG00000130005.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74445136,
      stop : 74455005,
      direction : "+",
      ID : "ENSG00000109321.11",
      gene_id : "ENSG00000109321.11",
      gene_type : "protein_coding",
      gene_name : "AREG",
      gene_level : 2,
      hgnc_id : "HGNC:651",
      havana_gene : "OTTHUMG00000130006.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74744759,
      stop : 74794523,
      direction : "-",
      ID : "ENSG00000174808.12",
      gene_id : "ENSG00000174808.12",
      gene_type : "protein_coding",
      gene_name : "BTC",
      gene_level : 2,
      hgnc_id : "HGNC:1121",
      havana_gene : "OTTHUMG00000130107.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 74933095,
      stop : 75050115,
      direction : "+",
      ID : "ENSG00000169116.11",
      gene_id : "ENSG00000169116.11",
      gene_type : "protein_coding",
      gene_name : "PARM1",
      gene_level : 2,
      hgnc_id : "HGNC:24536",
      havana_gene : "OTTHUMG00000160827.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75479037,
      stop : 75514764,
      direction : "-",
      ID : "ENSG00000163743.13",
      gene_id : "ENSG00000163743.13",
      gene_type : "protein_coding",
      gene_name : "RCHY1",
      gene_level : 1,
      hgnc_id : "HGNC:17479",
      havana_gene : "OTTHUMG00000130105.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75513946,
      stop : 75550473,
      direction : "+",
      ID : "ENSG00000174796.12",
      gene_id : "ENSG00000174796.12",
      gene_type : "protein_coding",
      gene_name : "THAP6",
      gene_level : 1,
      hgnc_id : "HGNC:23189",
      havana_gene : "OTTHUMG00000130108.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75556048,
      stop : 75565871,
      direction : "+",
      ID : "ENSG00000174792.11",
      gene_id : "ENSG00000174792.11",
      gene_type : "protein_coding",
      gene_name : "ODAPH",
      gene_level : 2,
      hgnc_id : "HGNC:26300",
      havana_gene : "OTTHUMG00000130104.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75576496,
      stop : 75630716,
      direction : "-",
      ID : "ENSG00000138769.11",
      gene_id : "ENSG00000138769.11",
      gene_type : "protein_coding",
      gene_name : "CDKL2",
      gene_level : 1,
      hgnc_id : "HGNC:1782",
      havana_gene : "OTTHUMG00000130103.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75641849,
      stop : 75724589,
      direction : "-",
      ID : "ENSG00000138757.15",
      gene_id : "ENSG00000138757.15",
      gene_type : "protein_coding",
      gene_name : "G3BP2",
      gene_level : 2,
      hgnc_id : "HGNC:30291",
      havana_gene : "OTTHUMG00000130097.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75724577,
      stop : 75814286,
      direction : "+",
      ID : "ENSG00000138768.15",
      gene_id : "ENSG00000138768.15",
      gene_type : "protein_coding",
      gene_name : "USO1",
      gene_level : 2,
      hgnc_id : "HGNC:30904",
      havana_gene : "OTTHUMG00000160952.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75859864,
      stop : 75902571,
      direction : "-",
      ID : "ENSG00000156194.18",
      gene_id : "ENSG00000156194.18",
      gene_type : "protein_coding",
      gene_name : "PPEF2",
      gene_level : 2,
      hgnc_id : "HGNC:9244",
      havana_gene : "OTTHUMG00000160915.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75913660,
      stop : 75941013,
      direction : "-",
      ID : "ENSG00000138744.16",
      gene_id : "ENSG00000138744.16",
      gene_type : "protein_coding",
      gene_name : "NAAA",
      gene_level : 1,
      hgnc_id : "HGNC:736",
      havana_gene : "OTTHUMG00000160855.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 75940950,
      stop : 75990962,
      direction : "-",
      ID : "ENSG00000198301.12",
      gene_id : "ENSG00000198301.12",
      gene_type : "protein_coding",
      gene_name : "SDAD1",
      gene_level : 2,
      hgnc_id : "HGNC:25537",
      havana_gene : "OTTHUMG00000130111.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76001275,
      stop : 76007509,
      direction : "-",
      ID : "ENSG00000138755.6",
      gene_id : "ENSG00000138755.6",
      gene_type : "protein_coding",
      gene_name : "CXCL9",
      gene_level : 2,
      hgnc_id : "HGNC:7098",
      havana_gene : "OTTHUMG00000160889.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76011184,
      stop : 76112802,
      direction : "+",
      ID : "ENSG00000156219.17",
      gene_id : "ENSG00000156219.17",
      gene_type : "protein_coding",
      gene_name : "ART3",
      gene_level : 2,
      hgnc_id : "HGNC:725",
      havana_gene : "OTTHUMG00000130110.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76021118,
      stop : 76023497,
      direction : "-",
      ID : "ENSG00000169245.6",
      gene_id : "ENSG00000169245.6",
      gene_type : "protein_coding",
      gene_name : "CXCL10",
      gene_level : 2,
      hgnc_id : "HGNC:10637",
      havana_gene : "OTTHUMG00000160887.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76033682,
      stop : 76041415,
      direction : "-",
      ID : "ENSG00000169248.13",
      gene_id : "ENSG00000169248.13",
      gene_type : "protein_coding",
      gene_name : "CXCL11",
      gene_level : 1,
      hgnc_id : "HGNC:10638",
      havana_gene : "OTTHUMG00000130101.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76114659,
      stop : 76148444,
      direction : "-",
      ID : "ENSG00000138750.15",
      gene_id : "ENSG00000138750.15",
      gene_type : "protein_coding",
      gene_name : "NUP54",
      gene_level : 1,
      hgnc_id : "HGNC:17359",
      havana_gene : "OTTHUMG00000130098.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76158737,
      stop : 76234536,
      direction : "-",
      ID : "ENSG00000138760.10",
      gene_id : "ENSG00000138760.10",
      gene_type : "protein_coding",
      gene_name : "SCARB2",
      gene_level : 1,
      hgnc_id : "HGNC:1665",
      havana_gene : "OTTHUMG00000130099.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76214040,
      stop : 76283783,
      direction : "+",
      ID : "ENSG00000189157.14",
      gene_id : "ENSG00000189157.14",
      gene_type : "protein_coding",
      gene_name : "FAM47E",
      gene_level : 1,
      hgnc_id : "HGNC:34343",
      havana_gene : "OTTHUMG00000185390.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76251721,
      stop : 76311129,
      direction : "+",
      ID : "ENSG00000272414.6",
      gene_id : "ENSG00000272414.6",
      gene_type : "protein_coding",
      gene_name : "FAM47E-STBD1",
      gene_level : 2,
      hgnc_id : "HGNC:44667",
      havana_gene : "OTTHUMG00000160966.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76306733,
      stop : 76311130,
      direction : "+",
      ID : "ENSG00000118804.9",
      gene_id : "ENSG00000118804.9",
      gene_type : "protein_coding",
      gene_name : "STBD1",
      gene_level : 2,
      hgnc_id : "HGNC:24854",
      havana_gene : "OTTHUMG00000130109.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76312997,
      stop : 76421868,
      direction : "-",
      ID : "ENSG00000163749.17",
      gene_id : "ENSG00000163749.17",
      gene_type : "protein_coding",
      gene_name : "CCDC158",
      gene_level : 1,
      hgnc_id : "HGNC:26374",
      havana_gene : "OTTHUMG00000160916.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76435229,
      stop : 76783253,
      direction : "+",
      ID : "ENSG00000138771.16",
      gene_id : "ENSG00000138771.16",
      gene_type : "protein_coding",
      gene_name : "SHROOM3",
      gene_level : 1,
      hgnc_id : "HGNC:30422",
      havana_gene : "OTTHUMG00000157075.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76894152,
      stop : 76898144,
      direction : "-",
      ID : "ENSG00000186212.4",
      gene_id : "ENSG00000186212.4",
      gene_type : "protein_coding",
      gene_name : "SOWAHB",
      gene_level : 2,
      hgnc_id : "HGNC:32958",
      havana_gene : "OTTHUMG00000160876.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 76949751,
      stop : 77040384,
      direction : "+",
      ID : "ENSG00000138758.12",
      gene_id : "ENSG00000138758.12",
      gene_type : "protein_coding",
      gene_name : "SEPTIN11",
      gene_level : 1,
      hgnc_id : "HGNC:25589",
      havana_gene : "OTTHUMG00000160854.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 77047155,
      stop : 77076309,
      direction : "-",
      ID : "ENSG00000118816.11",
      gene_id : "ENSG00000118816.11",
      gene_type : "protein_coding",
      gene_name : "CCNI",
      gene_level : 1,
      hgnc_id : "HGNC:1595",
      havana_gene : "OTTHUMG00000130106.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 77157207,
      stop : 77433388,
      direction : "+",
      ID : "ENSG00000138764.15",
      gene_id : "ENSG00000138764.15",
      gene_type : "protein_coding",
      gene_name : "CCNG2",
      gene_level : 2,
      hgnc_id : "HGNC:1593",
      havana_gene : "OTTHUMG00000130100.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 77511753,
      stop : 77611834,
      direction : "+",
      ID : "ENSG00000156234.7",
      gene_id : "ENSG00000156234.7",
      gene_type : "protein_coding",
      gene_name : "CXCL13",
      gene_level : 2,
      hgnc_id : "HGNC:10639",
      havana_gene : "OTTHUMG00000130201.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 77713387,
      stop : 77819615,
      direction : "-",
      ID : "ENSG00000138767.13",
      gene_id : "ENSG00000138767.13",
      gene_type : "protein_coding",
      gene_name : "CNOT6L",
      gene_level : 2,
      hgnc_id : "HGNC:18042",
      havana_gene : "OTTHUMG00000160832.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 77862830,
      stop : 77952785,
      direction : "+",
      ID : "ENSG00000169288.18",
      gene_id : "ENSG00000169288.18",
      gene_type : "protein_coding",
      gene_name : "MRPL1",
      gene_level : 2,
      hgnc_id : "HGNC:14275",
      havana_gene : "OTTHUMG00000130200.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 78057323,
      stop : 78544269,
      direction : "+",
      ID : "ENSG00000138759.19",
      gene_id : "ENSG00000138759.19",
      gene_type : "protein_coding",
      gene_name : "FRAS1",
      gene_level : 1,
      hgnc_id : "HGNC:19185",
      havana_gene : "OTTHUMG00000160856.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 78551747,
      stop : 78610451,
      direction : "+",
      ID : "ENSG00000138772.13",
      gene_id : "ENSG00000138772.13",
      gene_type : "protein_coding",
      gene_name : "ANXA3",
      gene_level : 1,
      hgnc_id : "HGNC:541",
      havana_gene : "OTTHUMG00000130198.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 78776342,
      stop : 78916365,
      direction : "+",
      ID : "ENSG00000138756.19",
      gene_id : "ENSG00000138756.19",
      gene_type : "protein_coding",
      gene_name : "BMP2K",
      gene_level : 2,
      hgnc_id : "HGNC:18041",
      havana_gene : "OTTHUMG00000160900.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 78887127,
      stop : 78939438,
      direction : "-",
      ID : "ENSG00000163291.14",
      gene_id : "ENSG00000163291.14",
      gene_type : "protein_coding",
      gene_name : "PAQR3",
      gene_level : 2,
      hgnc_id : "HGNC:30130",
      havana_gene : "OTTHUMG00000161026.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 79225694,
      stop : 79326061,
      direction : "-",
      ID : "ENSG00000156269.5",
      gene_id : "ENSG00000156269.5",
      gene_type : "protein_coding",
      gene_name : "NAA11",
      gene_level : 2,
      hgnc_id : "HGNC:28125",
      havana_gene : "OTTHUMG00000160913.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 79406361,
      stop : 79408228,
      direction : "-",
      ID : "ENSG00000196475.6",
      gene_id : "ENSG00000196475.6",
      gene_type : "protein_coding",
      gene_name : "GK2",
      gene_level : 2,
      hgnc_id : "HGNC:4291",
      havana_gene : "OTTHUMG00000130199.3",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 79901146,
      stop : 80125454,
      direction : "-",
      ID : "ENSG00000163297.18",
      gene_id : "ENSG00000163297.18",
      gene_type : "protein_coding",
      gene_name : "ANTXR2",
      gene_level : 2,
      hgnc_id : "HGNC:21732",
      havana_gene : "OTTHUMG00000151982.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 80183879,
      stop : 80204329,
      direction : "+",
      ID : "ENSG00000152784.16",
      gene_id : "ENSG00000152784.16",
      gene_type : "protein_coding",
      gene_name : "PRDM8",
      gene_level : 2,
      hgnc_id : "HGNC:13993",
      havana_gene : "OTTHUMG00000160885.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 80266599,
      stop : 80336680,
      direction : "+",
      ID : "ENSG00000138675.16",
      gene_id : "ENSG00000138675.16",
      gene_type : "protein_coding",
      gene_name : "FGF5",
      gene_level : 2,
      hgnc_id : "HGNC:3683",
      havana_gene : "OTTHUMG00000130288.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 80335730,
      stop : 80963750,
      direction : "+",
      ID : "ENSG00000197826.12",
      gene_id : "ENSG00000197826.12",
      gene_type : "protein_coding",
      gene_name : "CFAP299",
      gene_level : 2,
      hgnc_id : "HGNC:28554",
      havana_gene : "OTTHUMG00000130289.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 81030708,
      stop : 81057627,
      direction : "+",
      ID : "ENSG00000152785.8",
      gene_id : "ENSG00000152785.8",
      gene_type : "protein_coding",
      gene_name : "BMP3",
      gene_level : 2,
      hgnc_id : "HGNC:1070",
      havana_gene : "OTTHUMG00000130292.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 81087370,
      stop : 81215117,
      direction : "-",
      ID : "ENSG00000138669.9",
      gene_id : "ENSG00000138669.9",
      gene_type : "protein_coding",
      gene_name : "PRKG2",
      gene_level : 2,
      hgnc_id : "HGNC:9416",
      havana_gene : "OTTHUMG00000130296.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 81426393,
      stop : 82044244,
      direction : "-",
      ID : "ENSG00000138670.18",
      gene_id : "ENSG00000138670.18",
      gene_type : "protein_coding",
      gene_name : "RASGEF1B",
      gene_level : 2,
      hgnc_id : "HGNC:24881",
      havana_gene : "OTTHUMG00000160890.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82352498,
      stop : 82374503,
      direction : "-",
      ID : "ENSG00000138668.19",
      gene_id : "ENSG00000138668.19",
      gene_type : "protein_coding",
      gene_name : "HNRNPD",
      gene_level : 1,
      hgnc_id : "HGNC:5036",
      havana_gene : "OTTHUMG00000130290.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82422565,
      stop : 82430462,
      direction : "-",
      ID : "ENSG00000152795.18",
      gene_id : "ENSG00000152795.18",
      gene_type : "protein_coding",
      gene_name : "HNRNPDL",
      gene_level : 2,
      hgnc_id : "HGNC:5037",
      havana_gene : "OTTHUMG00000130299.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82430590,
      stop : 82461177,
      direction : "+",
      ID : "ENSG00000145293.16",
      gene_id : "ENSG00000145293.16",
      gene_type : "protein_coding",
      gene_name : "ENOPH1",
      gene_level : 2,
      hgnc_id : "HGNC:24599",
      havana_gene : "OTTHUMG00000130295.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82483170,
      stop : 82562357,
      direction : "-",
      ID : "ENSG00000249242.8",
      gene_id : "ENSG00000249242.8",
      gene_type : "protein_coding",
      gene_name : "TMEM150C",
      gene_level : 1,
      hgnc_id : "HGNC:37263",
      havana_gene : "OTTHUMG00000161083.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82629539,
      stop : 82798796,
      direction : "-",
      ID : "ENSG00000145284.12",
      gene_id : "ENSG00000145284.12",
      gene_type : "protein_coding",
      gene_name : "SCD5",
      gene_level : 2,
      hgnc_id : "HGNC:21088",
      havana_gene : "OTTHUMG00000130293.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82818509,
      stop : 82901166,
      direction : "-",
      ID : "ENSG00000138674.17",
      gene_id : "ENSG00000138674.17",
      gene_type : "protein_coding",
      gene_name : "SEC31A",
      gene_level : 1,
      hgnc_id : "HGNC:17052",
      havana_gene : "OTTHUMG00000130297.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82900684,
      stop : 82919969,
      direction : "+",
      ID : "ENSG00000168152.13",
      gene_id : "ENSG00000168152.13",
      gene_type : "protein_coding",
      gene_name : "THAP9",
      gene_level : 2,
      hgnc_id : "HGNC:23192",
      havana_gene : "OTTHUMG00000130291.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 82909973,
      stop : 83012926,
      direction : "-",
      ID : "ENSG00000189308.11",
      gene_id : "ENSG00000189308.11",
      gene_type : "protein_coding",
      gene_name : "LIN54",
      gene_level : 2,
      hgnc_id : "HGNC:25397",
      havana_gene : "OTTHUMG00000130287.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83034447,
      stop : 83075818,
      direction : "+",
      ID : "ENSG00000138663.9",
      gene_id : "ENSG00000138663.9",
      gene_type : "protein_coding",
      gene_name : "COPS4",
      gene_level : 1,
      hgnc_id : "HGNC:16702",
      havana_gene : "OTTHUMG00000130298.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83090048,
      stop : 83137075,
      direction : "-",
      ID : "ENSG00000145287.11",
      gene_id : "ENSG00000145287.11",
      gene_type : "protein_coding",
      gene_name : "PLAC8",
      gene_level : 1,
      hgnc_id : "HGNC:19254",
      havana_gene : "OTTHUMG00000130294.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83261536,
      stop : 83284914,
      direction : "-",
      ID : "ENSG00000173085.15",
      gene_id : "ENSG00000173085.15",
      gene_type : "protein_coding",
      gene_name : "COQ2",
      gene_level : 2,
      hgnc_id : "HGNC:25223",
      havana_gene : "OTTHUMG00000160940.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83292461,
      stop : 83335153,
      direction : "-",
      ID : "ENSG00000173083.16",
      gene_id : "ENSG00000173083.16",
      gene_type : "protein_coding",
      gene_name : "HPSE",
      gene_level : 1,
      hgnc_id : "HGNC:5164",
      havana_gene : "OTTHUMG00000130425.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83407343,
      stop : 83455855,
      direction : "-",
      ID : "ENSG00000163312.11",
      gene_id : "ENSG00000163312.11",
      gene_type : "protein_coding",
      gene_name : "HELQ",
      gene_level : 1,
      hgnc_id : "HGNC:18536",
      havana_gene : "OTTHUMG00000130423.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83455932,
      stop : 83469735,
      direction : "+",
      ID : "ENSG00000163319.11",
      gene_id : "ENSG00000163319.11",
      gene_type : "protein_coding",
      gene_name : "MRPS18C",
      gene_level : 1,
      hgnc_id : "HGNC:16633",
      havana_gene : "OTTHUMG00000130430.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83459517,
      stop : 83523348,
      direction : "-",
      ID : "ENSG00000163322.14",
      gene_id : "ENSG00000163322.14",
      gene_type : "protein_coding",
      gene_name : "ABRAXAS1",
      gene_level : 2,
      hgnc_id : "HGNC:25829",
      havana_gene : "OTTHUMG00000130429.18",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 83535914,
      stop : 83605875,
      direction : "+",
      ID : "ENSG00000138678.11",
      gene_id : "ENSG00000138678.11",
      gene_type : "protein_coding",
      gene_name : "GPAT3",
      gene_level : 2,
      hgnc_id : "HGNC:28157",
      havana_gene : "OTTHUMG00000130431.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 84491985,
      stop : 84499292,
      direction : "-",
      ID : "ENSG00000163623.10",
      gene_id : "ENSG00000163623.10",
      gene_type : "protein_coding",
      gene_name : "NKX6-1",
      gene_level : 2,
      hgnc_id : "HGNC:7839",
      havana_gene : "OTTHUMG00000130426.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 84583127,
      stop : 84651334,
      direction : "+",
      ID : "ENSG00000163624.6",
      gene_id : "ENSG00000163624.6",
      gene_type : "protein_coding",
      gene_name : "CDS1",
      gene_level : 2,
      hgnc_id : "HGNC:1800",
      havana_gene : "OTTHUMG00000130428.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 84669597,
      stop : 84966690,
      direction : "-",
      ID : "ENSG00000163625.16",
      gene_id : "ENSG00000163625.16",
      gene_type : "protein_coding",
      gene_name : "WDFY3",
      gene_level : 2,
      hgnc_id : "HGNC:20751",
      havana_gene : "OTTHUMG00000130424.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 85475150,
      stop : 86002668,
      direction : "+",
      ID : "ENSG00000138639.18",
      gene_id : "ENSG00000138639.18",
      gene_type : "protein_coding",
      gene_name : "ARHGAP24",
      gene_level : 2,
      hgnc_id : "HGNC:25361",
      havana_gene : "OTTHUMG00000130427.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 85990007,
      stop : 86594625,
      direction : "-",
      ID : "ENSG00000109339.24",
      gene_id : "ENSG00000109339.24",
      gene_type : "protein_coding",
      gene_name : "MAPK10",
      gene_level : 2,
      hgnc_id : "HGNC:6872",
      havana_gene : "OTTHUMG00000130604.50",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 86594315,
      stop : 86815171,
      direction : "+",
      ID : "ENSG00000163629.13",
      gene_id : "ENSG00000163629.13",
      gene_type : "protein_coding",
      gene_name : "PTPN13",
      gene_level : 1,
      hgnc_id : "HGNC:9646",
      havana_gene : "OTTHUMG00000160968.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 86823468,
      stop : 86849384,
      direction : "-",
      ID : "ENSG00000145283.8",
      gene_id : "ENSG00000145283.8",
      gene_type : "protein_coding",
      gene_name : "SLC10A6",
      gene_level : 2,
      hgnc_id : "HGNC:30603",
      havana_gene : "OTTHUMG00000130596.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 86876205,
      stop : 86892422,
      direction : "-",
      ID : "ENSG00000163633.12",
      gene_id : "ENSG00000163633.12",
      gene_type : "protein_coding",
      gene_name : "C4orf36",
      gene_level : 2,
      hgnc_id : "HGNC:28386",
      havana_gene : "OTTHUMG00000130597.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 86886472,
      stop : 86936178,
      direction : "-",
      ID : "ENSG00000285458.1",
      gene_id : "ENSG00000285458.1",
      gene_type : "protein_coding",
      gene_name : "AC093827.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192455.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 86935002,
      stop : 87141054,
      direction : "+",
      ID : "ENSG00000172493.22",
      gene_id : "ENSG00000172493.22",
      gene_type : "protein_coding",
      gene_name : "AFF1",
      gene_level : 2,
      hgnc_id : "HGNC:7135",
      havana_gene : "OTTHUMG00000130603.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87160103,
      stop : 87240314,
      direction : "-",
      ID : "ENSG00000145332.14",
      gene_id : "ENSG00000145332.14",
      gene_type : "protein_coding",
      gene_name : "KLHL8",
      gene_level : 1,
      hgnc_id : "HGNC:18644",
      havana_gene : "OTTHUMG00000130593.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87303789,
      stop : 87322886,
      direction : "-",
      ID : "ENSG00000170509.12",
      gene_id : "ENSG00000170509.12",
      gene_type : "protein_coding",
      gene_name : "HSD17B13",
      gene_level : 2,
      hgnc_id : "HGNC:18685",
      havana_gene : "OTTHUMG00000130602.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87336515,
      stop : 87391188,
      direction : "-",
      ID : "ENSG00000198189.11",
      gene_id : "ENSG00000198189.11",
      gene_type : "protein_coding",
      gene_name : "HSD17B11",
      gene_level : 2,
      hgnc_id : "HGNC:22960",
      havana_gene : "OTTHUMG00000130594.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87422573,
      stop : 87459455,
      direction : "+",
      ID : "ENSG00000170502.13",
      gene_id : "ENSG00000170502.13",
      gene_type : "protein_coding",
      gene_name : "NUDT9",
      gene_level : 2,
      hgnc_id : "HGNC:8056",
      havana_gene : "OTTHUMG00000130591.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87473335,
      stop : 87531061,
      direction : "-",
      ID : "ENSG00000152583.13",
      gene_id : "ENSG00000152583.13",
      gene_type : "protein_coding",
      gene_name : "SPARCL1",
      gene_level : 1,
      hgnc_id : "HGNC:11220",
      havana_gene : "OTTHUMG00000130605.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87608529,
      stop : 87616873,
      direction : "+",
      ID : "ENSG00000152591.15",
      gene_id : "ENSG00000152591.15",
      gene_type : "protein_coding",
      gene_name : "DSPP",
      gene_level : 2,
      hgnc_id : "HGNC:3054",
      havana_gene : "OTTHUMG00000161061.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87650280,
      stop : 87664361,
      direction : "+",
      ID : "ENSG00000152592.14",
      gene_id : "ENSG00000152592.14",
      gene_type : "protein_coding",
      gene_name : "DMP1",
      gene_level : 2,
      hgnc_id : "HGNC:2932",
      havana_gene : "OTTHUMG00000130598.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87799554,
      stop : 87812435,
      direction : "+",
      ID : "ENSG00000029559.7",
      gene_id : "ENSG00000029559.7",
      gene_type : "protein_coding",
      gene_name : "IBSP",
      gene_level : 2,
      hgnc_id : "HGNC:5341",
      havana_gene : "OTTHUMG00000130600.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87821411,
      stop : 87846817,
      direction : "+",
      ID : "ENSG00000152595.16",
      gene_id : "ENSG00000152595.16",
      gene_type : "protein_coding",
      gene_name : "MEPE",
      gene_level : 1,
      hgnc_id : "HGNC:13361",
      havana_gene : "OTTHUMG00000130592.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 87975650,
      stop : 87983426,
      direction : "+",
      ID : "ENSG00000118785.14",
      gene_id : "ENSG00000118785.14",
      gene_type : "protein_coding",
      gene_name : "SPP1",
      gene_level : 2,
      hgnc_id : "HGNC:11255",
      havana_gene : "OTTHUMG00000130599.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88007635,
      stop : 88077777,
      direction : "+",
      ID : "ENSG00000118762.8",
      gene_id : "ENSG00000118762.8",
      gene_type : "protein_coding",
      gene_name : "PKD2",
      gene_level : 1,
      hgnc_id : "HGNC:9009",
      havana_gene : "OTTHUMG00000160982.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88090150,
      stop : 88231628,
      direction : "-",
      ID : "ENSG00000118777.12",
      gene_id : "ENSG00000118777.12",
      gene_type : "protein_coding",
      gene_name : "ABCG2",
      gene_level : 1,
      hgnc_id : "HGNC:74",
      havana_gene : "OTTHUMG00000130601.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88257620,
      stop : 88284769,
      direction : "-",
      ID : "ENSG00000163644.15",
      gene_id : "ENSG00000163644.15",
      gene_type : "protein_coding",
      gene_name : "PPM1K",
      gene_level : 1,
      hgnc_id : "HGNC:25415",
      havana_gene : "OTTHUMG00000130952.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88378739,
      stop : 88443097,
      direction : "+",
      ID : "ENSG00000138642.15",
      gene_id : "ENSG00000138642.15",
      gene_type : "protein_coding",
      gene_name : "HERC6",
      gene_level : 2,
      hgnc_id : "HGNC:26072",
      havana_gene : "OTTHUMG00000160983.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88457119,
      stop : 88506163,
      direction : "+",
      ID : "ENSG00000138646.9",
      gene_id : "ENSG00000138646.9",
      gene_type : "protein_coding",
      gene_name : "HERC5",
      gene_level : 2,
      hgnc_id : "HGNC:24368",
      havana_gene : "OTTHUMG00000130953.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88520998,
      stop : 88523776,
      direction : "-",
      ID : "ENSG00000145337.5",
      gene_id : "ENSG00000145337.5",
      gene_type : "protein_coding",
      gene_name : "PYURF",
      gene_level : 2,
      hgnc_id : "HGNC:44317",
      havana_gene : "OTTHUMG00000130949.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88520998,
      stop : 88523776,
      direction : "-",
      ID : "ENSG00000255072.2",
      gene_id : "ENSG00000255072.2",
      gene_type : "protein_coding",
      gene_name : "PIGY",
      gene_level : 2,
      hgnc_id : "HGNC:28213",
      havana_gene : "OTTHUMG00000166563.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88523810,
      stop : 88708450,
      direction : "+",
      ID : "ENSG00000287542.1",
      gene_id : "ENSG00000287542.1",
      gene_type : "protein_coding",
      gene_name : "HERC3",
      gene_level : 2,
      hgnc_id : "HGNC:4876",
      havana_gene : "OTTHUMG00000192438.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88592434,
      stop : 88708541,
      direction : "+",
      ID : "ENSG00000138641.18",
      gene_id : "ENSG00000138641.18",
      gene_type : "protein_coding",
      gene_name : "HERC3",
      gene_level : 2,
      hgnc_id : "HGNC:4876",
      havana_gene : "OTTHUMG00000150436.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88695913,
      stop : 88697829,
      direction : "-",
      ID : "ENSG00000177432.8",
      gene_id : "ENSG00000177432.8",
      gene_type : "protein_coding",
      gene_name : "NAP1L5",
      gene_level : 2,
      hgnc_id : "HGNC:19968",
      havana_gene : "OTTHUMG00000130950.3",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 88725955,
      stop : 89111398,
      direction : "-",
      ID : "ENSG00000138640.15",
      gene_id : "ENSG00000138640.15",
      gene_type : "protein_coding",
      gene_name : "FAM13A",
      gene_level : 2,
      hgnc_id : "HGNC:19367",
      havana_gene : "OTTHUMG00000161006.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 89111533,
      stop : 89114901,
      direction : "+",
      ID : "ENSG00000180346.4",
      gene_id : "ENSG00000180346.4",
      gene_type : "protein_coding",
      gene_name : "TIGD2",
      gene_level : 2,
      hgnc_id : "HGNC:18333",
      havana_gene : "OTTHUMG00000130946.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 89236383,
      stop : 89307800,
      direction : "-",
      ID : "ENSG00000185477.5",
      gene_id : "ENSG00000185477.5",
      gene_type : "protein_coding",
      gene_name : "GPRIN3",
      gene_level : 2,
      hgnc_id : "HGNC:27733",
      havana_gene : "OTTHUMG00000161044.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 89700345,
      stop : 89838315,
      direction : "-",
      ID : "ENSG00000145335.17",
      gene_id : "ENSG00000145335.17",
      gene_type : "protein_coding",
      gene_name : "SNCA",
      gene_level : 2,
      hgnc_id : "HGNC:11138",
      havana_gene : "OTTHUMG00000130948.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 89879532,
      stop : 89954629,
      direction : "+",
      ID : "ENSG00000138722.10",
      gene_id : "ENSG00000138722.10",
      gene_type : "protein_coding",
      gene_name : "MMRN1",
      gene_level : 1,
      hgnc_id : "HGNC:7178",
      havana_gene : "OTTHUMG00000130947.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 90127535,
      stop : 91601913,
      direction : "+",
      ID : "ENSG00000184305.15",
      gene_id : "ENSG00000184305.15",
      gene_type : "protein_coding",
      gene_name : "CCSER1",
      gene_level : 1,
      hgnc_id : "HGNC:29349",
      havana_gene : "OTTHUMG00000160950.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 92303966,
      stop : 93810157,
      direction : "+",
      ID : "ENSG00000152208.13",
      gene_id : "ENSG00000152208.13",
      gene_type : "protein_coding",
      gene_name : "GRID2",
      gene_level : 2,
      hgnc_id : "HGNC:4576",
      havana_gene : "OTTHUMG00000130975.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 93828753,
      stop : 93830964,
      direction : "+",
      ID : "ENSG00000172238.6",
      gene_id : "ENSG00000172238.6",
      gene_type : "protein_coding",
      gene_name : "ATOH1",
      gene_level : 2,
      hgnc_id : "HGNC:797",
      havana_gene : "OTTHUMG00000130972.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 94207611,
      stop : 94291292,
      direction : "+",
      ID : "ENSG00000163104.18",
      gene_id : "ENSG00000163104.18",
      gene_type : "protein_coding",
      gene_name : "SMARCAD1",
      gene_level : 1,
      hgnc_id : "HGNC:18398",
      havana_gene : "OTTHUMG00000130971.12",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 94298535,
      stop : 94342876,
      direction : "-",
      ID : "ENSG00000163106.11",
      gene_id : "ENSG00000163106.11",
      gene_type : "protein_coding",
      gene_name : "HPGDS",
      gene_level : 2,
      hgnc_id : "HGNC:17890",
      havana_gene : "OTTHUMG00000130974.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 94451857,
      stop : 94668227,
      direction : "+",
      ID : "ENSG00000163110.15",
      gene_id : "ENSG00000163110.15",
      gene_type : "protein_coding",
      gene_name : "PDLIM5",
      gene_level : 1,
      hgnc_id : "HGNC:17468",
      havana_gene : "OTTHUMG00000130973.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 94757955,
      stop : 95158448,
      direction : "+",
      ID : "ENSG00000138696.11",
      gene_id : "ENSG00000138696.11",
      gene_type : "protein_coding",
      gene_name : "BMPR1B",
      gene_level : 2,
      hgnc_id : "HGNC:1077",
      havana_gene : "OTTHUMG00000130991.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 95162504,
      stop : 95549206,
      direction : "-",
      ID : "ENSG00000182168.15",
      gene_id : "ENSG00000182168.15",
      gene_type : "protein_coding",
      gene_name : "UNC5C",
      gene_level : 1,
      hgnc_id : "HGNC:12569",
      havana_gene : "OTTHUMG00000130989.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 95840093,
      stop : 95841464,
      direction : "+",
      ID : "ENSG00000163114.6",
      gene_id : "ENSG00000163114.6",
      gene_type : "protein_coding",
      gene_name : "PDHA2",
      gene_level : 2,
      hgnc_id : "HGNC:8807",
      havana_gene : "OTTHUMG00000130990.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 97184093,
      stop : 98143476,
      direction : "-",
      ID : "ENSG00000163116.10",
      gene_id : "ENSG00000163116.10",
      gene_type : "protein_coding",
      gene_name : "STPG2",
      gene_level : 2,
      hgnc_id : "HGNC:28712",
      havana_gene : "OTTHUMG00000131009.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 98261384,
      stop : 98443858,
      direction : "+",
      ID : "ENSG00000138698.15",
      gene_id : "ENSG00000138698.15",
      gene_type : "protein_coding",
      gene_name : "RAP1GDS1",
      gene_level : 1,
      hgnc_id : "HGNC:9859",
      havana_gene : "OTTHUMG00000160987.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 98470367,
      stop : 98658611,
      direction : "-",
      ID : "ENSG00000168785.8",
      gene_id : "ENSG00000168785.8",
      gene_type : "protein_coding",
      gene_name : "TSPAN5",
      gene_level : 2,
      hgnc_id : "HGNC:17753",
      havana_gene : "OTTHUMG00000131008.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 98879276,
      stop : 98929133,
      direction : "-",
      ID : "ENSG00000151247.13",
      gene_id : "ENSG00000151247.13",
      gene_type : "protein_coding",
      gene_name : "EIF4E",
      gene_level : 1,
      hgnc_id : "HGNC:3287",
      havana_gene : "OTTHUMG00000161090.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 98995659,
      stop : 99062809,
      direction : "+",
      ID : "ENSG00000164024.12",
      gene_id : "ENSG00000164024.12",
      gene_type : "protein_coding",
      gene_name : "METAP1",
      gene_level : 1,
      hgnc_id : "HGNC:15789",
      havana_gene : "OTTHUMG00000161231.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99070978,
      stop : 99088801,
      direction : "-",
      ID : "ENSG00000197894.11",
      gene_id : "ENSG00000197894.11",
      gene_type : "protein_coding",
      gene_name : "ADH5",
      gene_level : 2,
      hgnc_id : "HGNC:253",
      havana_gene : "OTTHUMG00000161230.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99123657,
      stop : 99157792,
      direction : "-",
      ID : "ENSG00000198099.9",
      gene_id : "ENSG00000198099.9",
      gene_type : "protein_coding",
      gene_name : "ADH4",
      gene_level : 1,
      hgnc_id : "HGNC:252",
      havana_gene : "OTTHUMG00000161227.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99202638,
      stop : 99219537,
      direction : "-",
      ID : "ENSG00000172955.17",
      gene_id : "ENSG00000172955.17",
      gene_type : "protein_coding",
      gene_name : "ADH6",
      gene_level : 1,
      hgnc_id : "HGNC:255",
      havana_gene : "OTTHUMG00000131024.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99276369,
      stop : 99291003,
      direction : "-",
      ID : "ENSG00000187758.8",
      gene_id : "ENSG00000187758.8",
      gene_type : "protein_coding",
      gene_name : "ADH1A",
      gene_level : 2,
      hgnc_id : "HGNC:249",
      havana_gene : "OTTHUMG00000131026.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99304971,
      stop : 99352760,
      direction : "-",
      ID : "ENSG00000196616.14",
      gene_id : "ENSG00000196616.14",
      gene_type : "protein_coding",
      gene_name : "ADH1B",
      gene_level : 2,
      hgnc_id : "HGNC:250",
      havana_gene : "OTTHUMG00000161413.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99336497,
      stop : 99352746,
      direction : "-",
      ID : "ENSG00000248144.6",
      gene_id : "ENSG00000248144.6",
      gene_type : "protein_coding",
      gene_name : "ADH1C",
      gene_level : 2,
      hgnc_id : "HGNC:251",
      havana_gene : "OTTHUMG00000161422.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99412261,
      stop : 99435737,
      direction : "-",
      ID : "ENSG00000196344.11",
      gene_id : "ENSG00000196344.11",
      gene_type : "protein_coding",
      gene_name : "ADH7",
      gene_level : 2,
      hgnc_id : "HGNC:256",
      havana_gene : "OTTHUMG00000159318.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99511012,
      stop : 99542303,
      direction : "+",
      ID : "ENSG00000138813.10",
      gene_id : "ENSG00000138813.10",
      gene_type : "protein_coding",
      gene_name : "C4orf17",
      gene_level : 2,
      hgnc_id : "HGNC:25274",
      havana_gene : "OTTHUMG00000131027.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99546709,
      stop : 99564039,
      direction : "-",
      ID : "ENSG00000145331.14",
      gene_id : "ENSG00000145331.14",
      gene_type : "protein_coding",
      gene_name : "TRMT10A",
      gene_level : 2,
      hgnc_id : "HGNC:28403",
      havana_gene : "OTTHUMG00000131025.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99564081,
      stop : 99623997,
      direction : "+",
      ID : "ENSG00000138823.14",
      gene_id : "ENSG00000138823.14",
      gene_type : "protein_coding",
      gene_name : "MTTP",
      gene_level : 1,
      hgnc_id : "HGNC:7467",
      havana_gene : "OTTHUMG00000131023.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99636529,
      stop : 99654648,
      direction : "-",
      ID : "ENSG00000248713.1",
      gene_id : "ENSG00000248713.1",
      gene_type : "protein_coding",
      gene_name : "C4orf54",
      gene_level : 1,
      hgnc_id : "HGNC:27741",
      havana_gene : "OTTHUMG00000161583.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99816827,
      stop : 99870190,
      direction : "+",
      ID : "ENSG00000070190.13",
      gene_id : "ENSG00000070190.13",
      gene_type : "protein_coding",
      gene_name : "DAPP1",
      gene_level : 2,
      hgnc_id : "HGNC:16500",
      havana_gene : "OTTHUMG00000160974.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99878336,
      stop : 99894428,
      direction : "-",
      ID : "ENSG00000109270.13",
      gene_id : "ENSG00000109270.13",
      gene_type : "protein_coding",
      gene_name : "LAMTOR3",
      gene_level : 2,
      hgnc_id : "HGNC:15606",
      havana_gene : "OTTHUMG00000131050.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99896248,
      stop : 99946618,
      direction : "-",
      ID : "ENSG00000164031.17",
      gene_id : "ENSG00000164031.17",
      gene_type : "protein_coding",
      gene_name : "DNAJB14",
      gene_level : 1,
      hgnc_id : "HGNC:25881",
      havana_gene : "OTTHUMG00000131049.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 99948086,
      stop : 99950355,
      direction : "-",
      ID : "ENSG00000164032.12",
      gene_id : "ENSG00000164032.12",
      gene_type : "protein_coding",
      gene_name : "H2AZ1",
      gene_level : 1,
      hgnc_id : "HGNC:4741",
      havana_gene : "OTTHUMG00000131048.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 100185870,
      stop : 100190782,
      direction : "-",
      ID : "ENSG00000145358.6",
      gene_id : "ENSG00000145358.6",
      gene_type : "protein_coding",
      gene_name : "DDIT4L",
      gene_level : 2,
      hgnc_id : "HGNC:30555",
      havana_gene : "OTTHUMG00000161019.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 100395341,
      stop : 100880126,
      direction : "-",
      ID : "ENSG00000164035.10",
      gene_id : "ENSG00000164035.10",
      gene_type : "protein_coding",
      gene_name : "EMCN",
      gene_level : 2,
      hgnc_id : "HGNC:16041",
      havana_gene : "OTTHUMG00000131051.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 101023409,
      stop : 101348278,
      direction : "-",
      ID : "ENSG00000138814.17",
      gene_id : "ENSG00000138814.17",
      gene_type : "protein_coding",
      gene_name : "PPP3CA",
      gene_level : 1,
      hgnc_id : "HGNC:9314",
      havana_gene : "OTTHUMG00000133839.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 101411286,
      stop : 102074812,
      direction : "+",
      ID : "ENSG00000153064.12",
      gene_id : "ENSG00000153064.12",
      gene_type : "protein_coding",
      gene_name : "BANK1",
      gene_level : 2,
      hgnc_id : "HGNC:18233",
      havana_gene : "OTTHUMG00000160958.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 102251041,
      stop : 102431258,
      direction : "-",
      ID : "ENSG00000138821.13",
      gene_id : "ENSG00000138821.13",
      gene_type : "protein_coding",
      gene_name : "SLC39A8",
      gene_level : 2,
      hgnc_id : "HGNC:20862",
      havana_gene : "OTTHUMG00000131120.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 102501331,
      stop : 102617302,
      direction : "+",
      ID : "ENSG00000109320.13",
      gene_id : "ENSG00000109320.13",
      gene_type : "protein_coding",
      gene_name : "NFKB1",
      gene_level : 1,
      hgnc_id : "HGNC:7794",
      havana_gene : "OTTHUMG00000161080.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 102630770,
      stop : 102760994,
      direction : "-",
      ID : "ENSG00000109323.11",
      gene_id : "ENSG00000109323.11",
      gene_type : "protein_coding",
      gene_name : "MANBA",
      gene_level : 2,
      hgnc_id : "HGNC:6831",
      havana_gene : "OTTHUMG00000131123.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 102794383,
      stop : 102868896,
      direction : "-",
      ID : "ENSG00000109332.20",
      gene_id : "ENSG00000109332.20",
      gene_type : "protein_coding",
      gene_name : "UBE2D3",
      gene_level : 2,
      hgnc_id : "HGNC:12476",
      havana_gene : "OTTHUMG00000131119.17",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 102868974,
      stop : 102892807,
      direction : "+",
      ID : "ENSG00000145354.12",
      gene_id : "ENSG00000145354.12",
      gene_type : "protein_coding",
      gene_name : "CISD2",
      gene_level : 1,
      hgnc_id : "HGNC:24212",
      havana_gene : "OTTHUMG00000161014.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 102885048,
      stop : 103019719,
      direction : "-",
      ID : "ENSG00000164037.17",
      gene_id : "ENSG00000164037.17",
      gene_type : "protein_coding",
      gene_name : "SLC9B1",
      gene_level : 2,
      hgnc_id : "HGNC:24244",
      havana_gene : "OTTHUMG00000161114.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 103019868,
      stop : 103085829,
      direction : "-",
      ID : "ENSG00000164038.16",
      gene_id : "ENSG00000164038.16",
      gene_type : "protein_coding",
      gene_name : "SLC9B2",
      gene_level : 1,
      hgnc_id : "HGNC:25143",
      havana_gene : "OTTHUMG00000131125.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 103077592,
      stop : 103099870,
      direction : "-",
      ID : "ENSG00000164039.15",
      gene_id : "ENSG00000164039.15",
      gene_type : "protein_coding",
      gene_name : "BDH2",
      gene_level : 2,
      hgnc_id : "HGNC:32389",
      havana_gene : "OTTHUMG00000074039.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 103105349,
      stop : 103198445,
      direction : "-",
      ID : "ENSG00000138778.13",
      gene_id : "ENSG00000138778.13",
      gene_type : "protein_coding",
      gene_name : "CENPE",
      gene_level : 2,
      hgnc_id : "HGNC:1856",
      havana_gene : "OTTHUMG00000160980.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 103586031,
      stop : 103719985,
      direction : "-",
      ID : "ENSG00000169836.5",
      gene_id : "ENSG00000169836.5",
      gene_type : "protein_coding",
      gene_name : "TACR3",
      gene_level : 2,
      hgnc_id : "HGNC:11528",
      havana_gene : "OTTHUMG00000131124.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 104468308,
      stop : 104494901,
      direction : "-",
      ID : "ENSG00000168772.11",
      gene_id : "ENSG00000168772.11",
      gene_type : "protein_coding",
      gene_name : "CXXC4",
      gene_level : 2,
      hgnc_id : "HGNC:24593",
      havana_gene : "OTTHUMG00000131121.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 105145875,
      stop : 105279816,
      direction : "+",
      ID : "ENSG00000168769.14",
      gene_id : "ENSG00000168769.14",
      gene_type : "protein_coding",
      gene_name : "TET2",
      gene_level : 2,
      hgnc_id : "HGNC:25941",
      havana_gene : "OTTHUMG00000131213.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 105369077,
      stop : 105474067,
      direction : "-",
      ID : "ENSG00000138777.20",
      gene_id : "ENSG00000138777.20",
      gene_type : "protein_coding",
      gene_name : "PPA2",
      gene_level : 1,
      hgnc_id : "HGNC:28883",
      havana_gene : "OTTHUMG00000128781.12",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 105552620,
      stop : 105708093,
      direction : "+",
      ID : "ENSG00000236699.9",
      gene_id : "ENSG00000236699.9",
      gene_type : "protein_coding",
      gene_name : "ARHGEF38",
      gene_level : 1,
      hgnc_id : "HGNC:25968",
      havana_gene : "OTTHUMG00000154752.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 105682627,
      stop : 105895986,
      direction : "-",
      ID : "ENSG00000138785.15",
      gene_id : "ENSG00000138785.15",
      gene_type : "protein_coding",
      gene_name : "INTS12",
      gene_level : 2,
      hgnc_id : "HGNC:25067",
      havana_gene : "OTTHUMG00000131215.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 105708778,
      stop : 105847725,
      direction : "+",
      ID : "ENSG00000138780.15",
      gene_id : "ENSG00000138780.15",
      gene_type : "protein_coding",
      gene_name : "GSTCD",
      gene_level : 2,
      hgnc_id : "HGNC:25806",
      havana_gene : "OTTHUMG00000131211.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 105894775,
      stop : 106004027,
      direction : "+",
      ID : "ENSG00000168743.13",
      gene_id : "ENSG00000168743.13",
      gene_type : "protein_coding",
      gene_name : "NPNT",
      gene_level : 1,
      hgnc_id : "HGNC:27405",
      havana_gene : "OTTHUMG00000161189.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 106041599,
      stop : 106316683,
      direction : "-",
      ID : "ENSG00000145348.17",
      gene_id : "ENSG00000145348.17",
      gene_type : "protein_coding",
      gene_name : "TBCK",
      gene_level : 2,
      hgnc_id : "HGNC:28261",
      havana_gene : "OTTHUMG00000131214.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 106315544,
      stop : 106349456,
      direction : "+",
      ID : "ENSG00000164022.17",
      gene_id : "ENSG00000164022.17",
      gene_type : "protein_coding",
      gene_name : "AIMP1",
      gene_level : 2,
      hgnc_id : "HGNC:10648",
      havana_gene : "OTTHUMG00000131217.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 106357392,
      stop : 106368778,
      direction : "-",
      ID : "ENSG00000250298.6",
      gene_id : "ENSG00000250298.6",
      gene_type : "protein_coding",
      gene_name : "GIMD1",
      gene_level : 2,
      hgnc_id : "HGNC:44141",
      havana_gene : "OTTHUMG00000161071.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 106921802,
      stop : 107283806,
      direction : "-",
      ID : "ENSG00000155011.9",
      gene_id : "ENSG00000155011.9",
      gene_type : "protein_coding",
      gene_name : "DKK2",
      gene_level : 2,
      hgnc_id : "HGNC:2892",
      havana_gene : "OTTHUMG00000131216.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 107590276,
      stop : 107720234,
      direction : "-",
      ID : "ENSG00000138801.9",
      gene_id : "ENSG00000138801.9",
      gene_type : "protein_coding",
      gene_name : "PAPSS1",
      gene_level : 2,
      hgnc_id : "HGNC:8603",
      havana_gene : "OTTHUMG00000131210.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 107824563,
      stop : 107915047,
      direction : "+",
      ID : "ENSG00000164023.14",
      gene_id : "ENSG00000164023.14",
      gene_type : "protein_coding",
      gene_name : "SGMS2",
      gene_level : 2,
      hgnc_id : "HGNC:28395",
      havana_gene : "OTTHUMG00000131811.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 107931549,
      stop : 107953461,
      direction : "+",
      ID : "ENSG00000155016.18",
      gene_id : "ENSG00000155016.18",
      gene_type : "protein_coding",
      gene_name : "CYP2U1",
      gene_level : 1,
      hgnc_id : "HGNC:20582",
      havana_gene : "OTTHUMG00000161084.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 107989714,
      stop : 108035174,
      direction : "+",
      ID : "ENSG00000138796.17",
      gene_id : "ENSG00000138796.17",
      gene_type : "protein_coding",
      gene_name : "HADH",
      gene_level : 2,
      hgnc_id : "HGNC:4799",
      havana_gene : "OTTHUMG00000131810.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 108047545,
      stop : 108168956,
      direction : "-",
      ID : "ENSG00000138795.10",
      gene_id : "ENSG00000138795.10",
      gene_type : "protein_coding",
      gene_name : "LEF1",
      gene_level : 2,
      hgnc_id : "HGNC:6551",
      havana_gene : "OTTHUMG00000131809.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 108620569,
      stop : 108630412,
      direction : "+",
      ID : "ENSG00000109475.17",
      gene_id : "ENSG00000109475.17",
      gene_type : "protein_coding",
      gene_name : "RPL34",
      gene_level : 2,
      hgnc_id : "HGNC:10340",
      havana_gene : "OTTHUMG00000131839.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 108650585,
      stop : 108667820,
      direction : "+",
      ID : "ENSG00000198856.13",
      gene_id : "ENSG00000198856.13",
      gene_type : "protein_coding",
      gene_name : "OSTC",
      gene_level : 2,
      hgnc_id : "HGNC:24448",
      havana_gene : "OTTHUMG00000161031.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 108742048,
      stop : 108763054,
      direction : "-",
      ID : "ENSG00000164089.9",
      gene_id : "ENSG00000164089.9",
      gene_type : "protein_coding",
      gene_name : "ETNPPL",
      gene_level : 1,
      hgnc_id : "HGNC:14404",
      havana_gene : "OTTHUMG00000161036.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 108808725,
      stop : 109302752,
      direction : "-",
      ID : "ENSG00000188517.16",
      gene_id : "ENSG00000188517.16",
      gene_type : "protein_coding",
      gene_name : "COL25A1",
      gene_level : 2,
      hgnc_id : "HGNC:18603",
      havana_gene : "OTTHUMG00000150039.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109433772,
      stop : 109540896,
      direction : "+",
      ID : "ENSG00000138802.11",
      gene_id : "ENSG00000138802.11",
      gene_type : "protein_coding",
      gene_name : "SEC24B",
      gene_level : 1,
      hgnc_id : "HGNC:10704",
      havana_gene : "OTTHUMG00000161372.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109560209,
      stop : 109688719,
      direction : "+",
      ID : "ENSG00000005059.16",
      gene_id : "ENSG00000005059.16",
      gene_type : "protein_coding",
      gene_name : "MCUB",
      gene_level : 2,
      hgnc_id : "HGNC:26076",
      havana_gene : "OTTHUMG00000161103.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109688622,
      stop : 109703583,
      direction : "-",
      ID : "ENSG00000138794.10",
      gene_id : "ENSG00000138794.10",
      gene_type : "protein_coding",
      gene_name : "CASP6",
      gene_level : 1,
      hgnc_id : "HGNC:1507",
      havana_gene : "OTTHUMG00000131914.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109709989,
      stop : 109730070,
      direction : "-",
      ID : "ENSG00000123739.11",
      gene_id : "ENSG00000123739.11",
      gene_type : "protein_coding",
      gene_name : "PLA2G12A",
      gene_level : 2,
      hgnc_id : "HGNC:18554",
      havana_gene : "OTTHUMG00000131915.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109713916,
      stop : 109801999,
      direction : "-",
      ID : "ENSG00000285330.1",
      gene_id : "ENSG00000285330.1",
      gene_type : "protein_coding",
      gene_name : "AC126283.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192517.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109740694,
      stop : 109801999,
      direction : "-",
      ID : "ENSG00000205403.14",
      gene_id : "ENSG00000205403.14",
      gene_type : "protein_coding",
      gene_name : "CFI",
      gene_level : 2,
      hgnc_id : "HGNC:5394",
      havana_gene : "OTTHUMG00000161109.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109815510,
      stop : 109824740,
      direction : "+",
      ID : "ENSG00000109534.17",
      gene_id : "ENSG00000109534.17",
      gene_type : "protein_coding",
      gene_name : "GAR1",
      gene_level : 2,
      hgnc_id : "HGNC:14264",
      havana_gene : "OTTHUMG00000161108.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109827972,
      stop : 109849123,
      direction : "+",
      ID : "ENSG00000180245.7",
      gene_id : "ENSG00000180245.7",
      gene_type : "protein_coding",
      gene_name : "RRH",
      gene_level : 2,
      hgnc_id : "HGNC:10450",
      havana_gene : "OTTHUMG00000132045.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109848107,
      stop : 109872315,
      direction : "+",
      ID : "ENSG00000183423.12",
      gene_id : "ENSG00000183423.12",
      gene_type : "protein_coding",
      gene_name : "LRIT3",
      gene_level : 2,
      hgnc_id : "HGNC:24783",
      havana_gene : "OTTHUMG00000132043.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 109912883,
      stop : 110013766,
      direction : "+",
      ID : "ENSG00000138798.13",
      gene_id : "ENSG00000138798.13",
      gene_type : "protein_coding",
      gene_name : "EGF",
      gene_level : 1,
      hgnc_id : "HGNC:3229",
      havana_gene : "OTTHUMG00000132044.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 110045846,
      stop : 110199199,
      direction : "-",
      ID : "ENSG00000170522.10",
      gene_id : "ENSG00000170522.10",
      gene_type : "protein_coding",
      gene_name : "ELOVL6",
      gene_level : 2,
      hgnc_id : "HGNC:15829",
      havana_gene : "OTTHUMG00000132547.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 110365733,
      stop : 110565285,
      direction : "+",
      ID : "ENSG00000138792.10",
      gene_id : "ENSG00000138792.10",
      gene_type : "protein_coding",
      gene_name : "ENPEP",
      gene_level : 2,
      hgnc_id : "HGNC:3355",
      havana_gene : "OTTHUMG00000132546.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 110617423,
      stop : 110642123,
      direction : "-",
      ID : "ENSG00000164093.17",
      gene_id : "ENSG00000164093.17",
      gene_type : "protein_coding",
      gene_name : "PITX2",
      gene_level : 2,
      hgnc_id : "HGNC:9005",
      havana_gene : "OTTHUMG00000132837.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112145454,
      stop : 112195256,
      direction : "+",
      ID : "ENSG00000174749.6",
      gene_id : "ENSG00000174749.6",
      gene_type : "protein_coding",
      gene_name : "FAM241A",
      gene_level : 2,
      hgnc_id : "HGNC:26813",
      havana_gene : "OTTHUMG00000132851.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112231740,
      stop : 112273110,
      direction : "+",
      ID : "ENSG00000138660.12",
      gene_id : "ENSG00000138660.12",
      gene_type : "protein_coding",
      gene_name : "AP1AR",
      gene_level : 2,
      hgnc_id : "HGNC:28808",
      havana_gene : "OTTHUMG00000132849.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112274537,
      stop : 112285904,
      direction : "-",
      ID : "ENSG00000145365.11",
      gene_id : "ENSG00000145365.11",
      gene_type : "protein_coding",
      gene_name : "TIFA",
      gene_level : 2,
      hgnc_id : "HGNC:19075",
      havana_gene : "OTTHUMG00000161066.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112285509,
      stop : 112442621,
      direction : "+",
      ID : "ENSG00000073331.18",
      gene_id : "ENSG00000073331.18",
      gene_type : "protein_coding",
      gene_name : "ALPK1",
      gene_level : 2,
      hgnc_id : "HGNC:20917",
      havana_gene : "OTTHUMG00000132911.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112513516,
      stop : 112516180,
      direction : "-",
      ID : "ENSG00000178403.4",
      gene_id : "ENSG00000178403.4",
      gene_type : "protein_coding",
      gene_name : "NEUROG2",
      gene_level : 2,
      hgnc_id : "HGNC:13805",
      havana_gene : "OTTHUMG00000132907.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112539333,
      stop : 112636995,
      direction : "-",
      ID : "ENSG00000138658.16",
      gene_id : "ENSG00000138658.16",
      gene_type : "protein_coding",
      gene_name : "ZGRF1",
      gene_level : 2,
      hgnc_id : "HGNC:25654",
      havana_gene : "OTTHUMG00000132908.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112637107,
      stop : 112657592,
      direction : "+",
      ID : "ENSG00000174720.16",
      gene_id : "ENSG00000174720.16",
      gene_type : "protein_coding",
      gene_name : "LARP7",
      gene_level : 1,
      hgnc_id : "HGNC:24912",
      havana_gene : "OTTHUMG00000132909.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 112818032,
      stop : 113384221,
      direction : "+",
      ID : "ENSG00000145362.20",
      gene_id : "ENSG00000145362.20",
      gene_type : "protein_coding",
      gene_name : "ANK2",
      gene_level : 1,
      hgnc_id : "HGNC:493",
      havana_gene : "OTTHUMG00000132912.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 113451032,
      stop : 113761927,
      direction : "-",
      ID : "ENSG00000145349.17",
      gene_id : "ENSG00000145349.17",
      gene_type : "protein_coding",
      gene_name : "CAMK2D",
      gene_level : 1,
      hgnc_id : "HGNC:1462",
      havana_gene : "OTTHUMG00000132910.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 113900284,
      stop : 113979727,
      direction : "-",
      ID : "ENSG00000180801.14",
      gene_id : "ENSG00000180801.14",
      gene_type : "protein_coding",
      gene_name : "ARSJ",
      gene_level : 2,
      hgnc_id : "HGNC:26286",
      havana_gene : "OTTHUMG00000161067.4",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 114598770,
      stop : 114678225,
      direction : "+",
      ID : "ENSG00000174607.11",
      gene_id : "ENSG00000174607.11",
      gene_type : "protein_coding",
      gene_name : "UGT8",
      gene_level : 2,
      hgnc_id : "HGNC:12555",
      havana_gene : "OTTHUMG00000132915.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 114827763,
      stop : 115113876,
      direction : "-",
      ID : "ENSG00000138653.10",
      gene_id : "ENSG00000138653.10",
      gene_type : "protein_coding",
      gene_name : "NDST4",
      gene_level : 2,
      hgnc_id : "HGNC:20779",
      havana_gene : "OTTHUMG00000132916.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 116298876,
      stop : 116300320,
      direction : "+",
      ID : "ENSG00000270394.4",
      gene_id : "ENSG00000270394.4",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L13",
      gene_level : 2,
      hgnc_id : "HGNC:37170",
      havana_gene : "OTTHUMG00000184994.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 117083554,
      stop : 117085576,
      direction : "-",
      ID : "ENSG00000174599.5",
      gene_id : "ENSG00000174599.5",
      gene_type : "protein_coding",
      gene_name : "TRAM1L1",
      gene_level : 2,
      hgnc_id : "HGNC:28371",
      havana_gene : "OTTHUMG00000132956.1",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 118033618,
      stop : 118258634,
      direction : "+",
      ID : "ENSG00000164100.9",
      gene_id : "ENSG00000164100.9",
      gene_type : "protein_coding",
      gene_name : "NDST3",
      gene_level : 2,
      hgnc_id : "HGNC:7682",
      havana_gene : "OTTHUMG00000132959.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 118280038,
      stop : 118353003,
      direction : "-",
      ID : "ENSG00000164099.3",
      gene_id : "ENSG00000164099.3",
      gene_type : "protein_coding",
      gene_name : "PRSS12",
      gene_level : 2,
      hgnc_id : "HGNC:9477",
      havana_gene : "OTTHUMG00000161166.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 118685392,
      stop : 118715433,
      direction : "+",
      ID : "ENSG00000145388.15",
      gene_id : "ENSG00000145388.15",
      gene_type : "protein_coding",
      gene_name : "METTL14",
      gene_level : 1,
      hgnc_id : "HGNC:29330",
      havana_gene : "OTTHUMG00000161167.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 118722823,
      stop : 118838683,
      direction : "-",
      ID : "ENSG00000150961.15",
      gene_id : "ENSG00000150961.15",
      gene_type : "protein_coding",
      gene_name : "SEC24D",
      gene_level : 1,
      hgnc_id : "HGNC:10706",
      havana_gene : "OTTHUMG00000132957.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 118850688,
      stop : 119061247,
      direction : "+",
      ID : "ENSG00000172403.11",
      gene_id : "ENSG00000172403.11",
      gene_type : "protein_coding",
      gene_name : "SYNPO2",
      gene_level : 1,
      hgnc_id : "HGNC:17732",
      havana_gene : "OTTHUMG00000161165.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 119135832,
      stop : 119187789,
      direction : "+",
      ID : "ENSG00000172399.6",
      gene_id : "ENSG00000172399.6",
      gene_type : "protein_coding",
      gene_name : "MYOZ2",
      gene_level : 2,
      hgnc_id : "HGNC:1330",
      havana_gene : "OTTHUMG00000132968.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 119212587,
      stop : 119295517,
      direction : "+",
      ID : "ENSG00000145390.11",
      gene_id : "ENSG00000145390.11",
      gene_type : "protein_coding",
      gene_name : "USP53",
      gene_level : 2,
      hgnc_id : "HGNC:29255",
      havana_gene : "OTTHUMG00000161331.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 119296419,
      stop : 119304445,
      direction : "-",
      ID : "ENSG00000164096.13",
      gene_id : "ENSG00000164096.13",
      gene_type : "protein_coding",
      gene_name : "C4orf3",
      gene_level : 2,
      hgnc_id : "HGNC:19225",
      havana_gene : "OTTHUMG00000161333.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 119317250,
      stop : 119322138,
      direction : "-",
      ID : "ENSG00000145384.4",
      gene_id : "ENSG00000145384.4",
      gene_type : "protein_coding",
      gene_name : "FABP2",
      gene_level : 2,
      hgnc_id : "HGNC:3556",
      havana_gene : "OTTHUMG00000132972.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 119494397,
      stop : 119628804,
      direction : "-",
      ID : "ENSG00000138735.16",
      gene_id : "ENSG00000138735.16",
      gene_type : "protein_coding",
      gene_name : "PDE5A",
      gene_level : 2,
      hgnc_id : "HGNC:8784",
      havana_gene : "OTTHUMG00000132971.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 120055623,
      stop : 120066858,
      direction : "-",
      ID : "ENSG00000164109.14",
      gene_id : "ENSG00000164109.14",
      gene_type : "protein_coding",
      gene_name : "MAD2L1",
      gene_level : 2,
      hgnc_id : "HGNC:6763",
      havana_gene : "OTTHUMG00000132967.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 120684919,
      stop : 120922870,
      direction : "-",
      ID : "ENSG00000138738.11",
      gene_id : "ENSG00000138738.11",
      gene_type : "protein_coding",
      gene_name : "PRDM5",
      gene_level : 2,
      hgnc_id : "HGNC:9349",
      havana_gene : "OTTHUMG00000132970.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121035613,
      stop : 121073021,
      direction : "-",
      ID : "ENSG00000173376.14",
      gene_id : "ENSG00000173376.14",
      gene_type : "protein_coding",
      gene_name : "NDNF",
      gene_level : 2,
      hgnc_id : "HGNC:26256",
      havana_gene : "OTTHUMG00000132973.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121131408,
      stop : 121227466,
      direction : "-",
      ID : "ENSG00000050730.16",
      gene_id : "ENSG00000050730.16",
      gene_type : "protein_coding",
      gene_name : "TNIP3",
      gene_level : 2,
      hgnc_id : "HGNC:19315",
      havana_gene : "OTTHUMG00000132969.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121328642,
      stop : 121381059,
      direction : "-",
      ID : "ENSG00000186867.11",
      gene_id : "ENSG00000186867.11",
      gene_type : "protein_coding",
      gene_name : "QRFPR",
      gene_level : 1,
      hgnc_id : "HGNC:15565",
      havana_gene : "OTTHUMG00000133036.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121667946,
      stop : 121696995,
      direction : "-",
      ID : "ENSG00000164111.15",
      gene_id : "ENSG00000164111.15",
      gene_type : "protein_coding",
      gene_name : "ANXA5",
      gene_level : 2,
      hgnc_id : "HGNC:543",
      havana_gene : "OTTHUMG00000133034.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121758881,
      stop : 121765427,
      direction : "-",
      ID : "ENSG00000164112.14",
      gene_id : "ENSG00000164112.14",
      gene_type : "protein_coding",
      gene_name : "SMIM43",
      gene_level : 2,
      hgnc_id : "HGNC:55077",
      havana_gene : "OTTHUMG00000192433.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121801318,
      stop : 121817021,
      direction : "+",
      ID : "ENSG00000123737.13",
      gene_id : "ENSG00000123737.13",
      gene_type : "protein_coding",
      gene_name : "EXOSC9",
      gene_level : 1,
      hgnc_id : "HGNC:9137",
      havana_gene : "OTTHUMG00000128783.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121816444,
      stop : 121823883,
      direction : "-",
      ID : "ENSG00000145386.11",
      gene_id : "ENSG00000145386.11",
      gene_type : "protein_coding",
      gene_name : "CCNA2",
      gene_level : 2,
      hgnc_id : "HGNC:1578",
      havana_gene : "OTTHUMG00000133072.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121824329,
      stop : 121870487,
      direction : "-",
      ID : "ENSG00000138686.10",
      gene_id : "ENSG00000138686.10",
      gene_type : "protein_coding",
      gene_name : "BBS7",
      gene_level : 2,
      hgnc_id : "HGNC:18758",
      havana_gene : "OTTHUMG00000133076.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 121874481,
      stop : 121952060,
      direction : "-",
      ID : "ENSG00000138741.11",
      gene_id : "ENSG00000138741.11",
      gene_type : "protein_coding",
      gene_name : "TRPC3",
      gene_level : 1,
      hgnc_id : "HGNC:12335",
      havana_gene : "OTTHUMG00000133069.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122152331,
      stop : 122362758,
      direction : "+",
      ID : "ENSG00000138688.16",
      gene_id : "ENSG00000138688.16",
      gene_type : "protein_coding",
      gene_name : "KIAA1109",
      gene_level : 1,
      hgnc_id : "HGNC:26953",
      havana_gene : "OTTHUMG00000150116.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122378966,
      stop : 122429802,
      direction : "+",
      ID : "ENSG00000164113.11",
      gene_id : "ENSG00000164113.11",
      gene_type : "protein_coding",
      gene_name : "ADAD1",
      gene_level : 1,
      hgnc_id : "HGNC:30713",
      havana_gene : "OTTHUMG00000150128.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122451470,
      stop : 122456725,
      direction : "-",
      ID : "ENSG00000109471.5",
      gene_id : "ENSG00000109471.5",
      gene_type : "protein_coding",
      gene_name : "IL2",
      gene_level : 2,
      hgnc_id : "HGNC:6001",
      havana_gene : "OTTHUMG00000133075.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122610108,
      stop : 122621066,
      direction : "-",
      ID : "ENSG00000138684.9",
      gene_id : "ENSG00000138684.9",
      gene_type : "protein_coding",
      gene_name : "IL21",
      gene_level : 2,
      hgnc_id : "HGNC:6005",
      havana_gene : "OTTHUMG00000133073.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122732702,
      stop : 122744942,
      direction : "+",
      ID : "ENSG00000181004.10",
      gene_id : "ENSG00000181004.10",
      gene_type : "protein_coding",
      gene_name : "BBS12",
      gene_level : 2,
      hgnc_id : "HGNC:26648",
      havana_gene : "OTTHUMG00000133070.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122826708,
      stop : 122898236,
      direction : "+",
      ID : "ENSG00000138685.17",
      gene_id : "ENSG00000138685.17",
      gene_type : "protein_coding",
      gene_name : "FGF2",
      gene_level : 2,
      hgnc_id : "HGNC:3676",
      havana_gene : "OTTHUMG00000039506.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122888697,
      stop : 122922968,
      direction : "-",
      ID : "ENSG00000170917.14",
      gene_id : "ENSG00000170917.14",
      gene_type : "protein_coding",
      gene_name : "NUDT6",
      gene_level : 2,
      hgnc_id : "HGNC:8053",
      havana_gene : "OTTHUMG00000039507.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 122923070,
      stop : 123319433,
      direction : "+",
      ID : "ENSG00000145375.9",
      gene_id : "ENSG00000145375.9",
      gene_type : "protein_coding",
      gene_name : "SPATA5",
      gene_level : 1,
      hgnc_id : "HGNC:18119",
      havana_gene : "OTTHUMG00000133074.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 123396795,
      stop : 123403760,
      direction : "+",
      ID : "ENSG00000164056.11",
      gene_id : "ENSG00000164056.11",
      gene_type : "protein_coding",
      gene_name : "SPRY1",
      gene_level : 2,
      hgnc_id : "HGNC:11269",
      havana_gene : "OTTHUMG00000133071.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 124664048,
      stop : 124712732,
      direction : "-",
      ID : "ENSG00000151458.12",
      gene_id : "ENSG00000151458.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD50",
      gene_level : 2,
      hgnc_id : "HGNC:29223",
      havana_gene : "OTTHUMG00000161398.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 125314918,
      stop : 125492932,
      direction : "+",
      ID : "ENSG00000196159.14",
      gene_id : "ENSG00000196159.14",
      gene_type : "protein_coding",
      gene_name : "FAT4",
      gene_level : 2,
      hgnc_id : "HGNC:23109",
      havana_gene : "OTTHUMG00000133100.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 127623271,
      stop : 127726737,
      direction : "+",
      ID : "ENSG00000164066.13",
      gene_id : "ENSG00000164066.13",
      gene_type : "protein_coding",
      gene_name : "INTU",
      gene_level : 1,
      hgnc_id : "HGNC:29239",
      havana_gene : "OTTHUMG00000161202.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 127730400,
      stop : 127774292,
      direction : "+",
      ID : "ENSG00000151475.6",
      gene_id : "ENSG00000151475.6",
      gene_type : "protein_coding",
      gene_name : "SLC25A31",
      gene_level : 2,
      hgnc_id : "HGNC:25319",
      havana_gene : "OTTHUMG00000133300.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 127781821,
      stop : 127840733,
      direction : "+",
      ID : "ENSG00000164070.12",
      gene_id : "ENSG00000164070.12",
      gene_type : "protein_coding",
      gene_name : "HSPA4L",
      gene_level : 2,
      hgnc_id : "HGNC:17041",
      havana_gene : "OTTHUMG00000133302.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 127880893,
      stop : 127899224,
      direction : "+",
      ID : "ENSG00000142731.11",
      gene_id : "ENSG00000142731.11",
      gene_type : "protein_coding",
      gene_name : "PLK4",
      gene_level : 1,
      hgnc_id : "HGNC:11397",
      havana_gene : "OTTHUMG00000133301.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 127917799,
      stop : 127966034,
      direction : "-",
      ID : "ENSG00000164073.11",
      gene_id : "ENSG00000164073.11",
      gene_type : "protein_coding",
      gene_name : "MFSD8",
      gene_level : 2,
      hgnc_id : "HGNC:28486",
      havana_gene : "OTTHUMG00000133303.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 127965306,
      stop : 128039953,
      direction : "+",
      ID : "ENSG00000164074.16",
      gene_id : "ENSG00000164074.16",
      gene_type : "protein_coding",
      gene_name : "ABHD18",
      gene_level : 2,
      hgnc_id : "HGNC:26111",
      havana_gene : "OTTHUMG00000133304.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 128061286,
      stop : 128222931,
      direction : "+",
      ID : "ENSG00000138709.19",
      gene_id : "ENSG00000138709.19",
      gene_type : "protein_coding",
      gene_name : "LARP1B",
      gene_level : 1,
      hgnc_id : "HGNC:24704",
      havana_gene : "OTTHUMG00000133343.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 128269237,
      stop : 128288829,
      direction : "-",
      ID : "ENSG00000164040.18",
      gene_id : "ENSG00000164040.18",
      gene_type : "protein_coding",
      gene_name : "PGRMC2",
      gene_level : 2,
      hgnc_id : "HGNC:16089",
      havana_gene : "OTTHUMG00000133342.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 128809700,
      stop : 128875224,
      direction : "+",
      ID : "ENSG00000077684.16",
      gene_id : "ENSG00000077684.16",
      gene_type : "protein_coding",
      gene_name : "JADE1",
      gene_level : 2,
      hgnc_id : "HGNC:30027",
      havana_gene : "OTTHUMG00000161176.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 128864921,
      stop : 129093600,
      direction : "-",
      ID : "ENSG00000151466.12",
      gene_id : "ENSG00000151466.12",
      gene_type : "protein_coding",
      gene_name : "SCLT1",
      gene_level : 1,
      hgnc_id : "HGNC:26406",
      havana_gene : "OTTHUMG00000133346.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 129093317,
      stop : 129116640,
      direction : "+",
      ID : "ENSG00000151470.13",
      gene_id : "ENSG00000151470.13",
      gene_type : "protein_coding",
      gene_name : "C4orf33",
      gene_level : 2,
      hgnc_id : "HGNC:27025",
      havana_gene : "OTTHUMG00000133347.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 133149294,
      stop : 133208606,
      direction : "+",
      ID : "ENSG00000138650.9",
      gene_id : "ENSG00000138650.9",
      gene_type : "protein_coding",
      gene_name : "PCDH10",
      gene_level : 1,
      hgnc_id : "HGNC:13404",
      havana_gene : "OTTHUMG00000161301.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 134196333,
      stop : 134201789,
      direction : "-",
      ID : "ENSG00000254535.4",
      gene_id : "ENSG00000254535.4",
      gene_type : "protein_coding",
      gene_name : "PABPC4L",
      gene_level : 2,
      hgnc_id : "HGNC:31955",
      havana_gene : "OTTHUMG00000161292.3",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 137518918,
      stop : 137532494,
      direction : "-",
      ID : "ENSG00000189184.12",
      gene_id : "ENSG00000189184.12",
      gene_type : "protein_coding",
      gene_name : "PCDH18",
      gene_level : 1,
      hgnc_id : "HGNC:14268",
      havana_gene : "OTTHUMG00000161348.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 138164097,
      stop : 138242349,
      direction : "-",
      ID : "ENSG00000151012.13",
      gene_id : "ENSG00000151012.13",
      gene_type : "protein_coding",
      gene_name : "SLC7A11",
      gene_level : 2,
      hgnc_id : "HGNC:11059",
      havana_gene : "OTTHUMG00000133396.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139015781,
      stop : 139045939,
      direction : "+",
      ID : "ENSG00000151014.6",
      gene_id : "ENSG00000151014.6",
      gene_type : "protein_coding",
      gene_name : "NOCT",
      gene_level : 2,
      hgnc_id : "HGNC:14254",
      havana_gene : "OTTHUMG00000161271.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139028112,
      stop : 139177218,
      direction : "-",
      ID : "ENSG00000109381.20",
      gene_id : "ENSG00000109381.20",
      gene_type : "protein_coding",
      gene_name : "ELF2",
      gene_level : 2,
      hgnc_id : "HGNC:3317",
      havana_gene : "OTTHUMG00000133383.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139266165,
      stop : 139280225,
      direction : "-",
      ID : "ENSG00000137463.5",
      gene_id : "ENSG00000137463.5",
      gene_type : "protein_coding",
      gene_name : "MGARP",
      gene_level : 2,
      hgnc_id : "HGNC:29969",
      havana_gene : "OTTHUMG00000161325.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139266880,
      stop : 139302551,
      direction : "-",
      ID : "ENSG00000109390.13",
      gene_id : "ENSG00000109390.13",
      gene_type : "protein_coding",
      gene_name : "NDUFC1",
      gene_level : 2,
      hgnc_id : "HGNC:7705",
      havana_gene : "OTTHUMG00000133387.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139301505,
      stop : 139420033,
      direction : "+",
      ID : "ENSG00000164134.13",
      gene_id : "ENSG00000164134.13",
      gene_type : "protein_coding",
      gene_name : "NAA15",
      gene_level : 2,
      hgnc_id : "HGNC:30782",
      havana_gene : "OTTHUMG00000137363.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139453232,
      stop : 139476609,
      direction : "+",
      ID : "ENSG00000172007.7",
      gene_id : "ENSG00000172007.7",
      gene_type : "protein_coding",
      gene_name : "RAB33B",
      gene_level : 2,
      hgnc_id : "HGNC:16075",
      havana_gene : "OTTHUMG00000133384.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139495941,
      stop : 139606699,
      direction : "-",
      ID : "ENSG00000145391.14",
      gene_id : "ENSG00000145391.14",
      gene_type : "protein_coding",
      gene_name : "SETD7",
      gene_level : 1,
      hgnc_id : "HGNC:30412",
      havana_gene : "OTTHUMG00000133385.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139665768,
      stop : 139740745,
      direction : "+",
      ID : "ENSG00000085871.9",
      gene_id : "ENSG00000085871.9",
      gene_type : "protein_coding",
      gene_name : "MGST2",
      gene_level : 2,
      hgnc_id : "HGNC:7063",
      havana_gene : "OTTHUMG00000133382.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 139716753,
      stop : 140154184,
      direction : "-",
      ID : "ENSG00000196782.12",
      gene_id : "ENSG00000196782.12",
      gene_type : "protein_coding",
      gene_name : "MAML3",
      gene_level : 2,
      hgnc_id : "HGNC:16272",
      havana_gene : "OTTHUMG00000161441.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140257286,
      stop : 140385728,
      direction : "+",
      ID : "ENSG00000153130.18",
      gene_id : "ENSG00000153130.18",
      gene_type : "protein_coding",
      gene_name : "SCOC",
      gene_level : 1,
      hgnc_id : "HGNC:20335",
      havana_gene : "OTTHUMG00000133416.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140388453,
      stop : 140427661,
      direction : "-",
      ID : "ENSG00000153132.13",
      gene_id : "ENSG00000153132.13",
      gene_type : "protein_coding",
      gene_name : "CLGN",
      gene_level : 2,
      hgnc_id : "HGNC:2060",
      havana_gene : "OTTHUMG00000133414.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140442262,
      stop : 140498377,
      direction : "-",
      ID : "ENSG00000205301.12",
      gene_id : "ENSG00000205301.12",
      gene_type : "protein_coding",
      gene_name : "MGAT4D",
      gene_level : 1,
      hgnc_id : "HGNC:43619",
      havana_gene : "OTTHUMG00000161376.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140524168,
      stop : 140553770,
      direction : "+",
      ID : "ENSG00000179387.10",
      gene_id : "ENSG00000179387.10",
      gene_type : "protein_coding",
      gene_name : "ELMOD2",
      gene_level : 2,
      hgnc_id : "HGNC:28111",
      havana_gene : "OTTHUMG00000133417.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140559431,
      stop : 140568961,
      direction : "-",
      ID : "ENSG00000109424.4",
      gene_id : "ENSG00000109424.4",
      gene_type : "protein_coding",
      gene_name : "UCP1",
      gene_level : 2,
      hgnc_id : "HGNC:12517",
      havana_gene : "OTTHUMG00000133415.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140620782,
      stop : 140756385,
      direction : "-",
      ID : "ENSG00000109436.8",
      gene_id : "ENSG00000109436.8",
      gene_type : "protein_coding",
      gene_name : "TBC1D9",
      gene_level : 2,
      hgnc_id : "HGNC:21710",
      havana_gene : "OTTHUMG00000161405.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 140859807,
      stop : 141212877,
      direction : "-",
      ID : "ENSG00000170153.11",
      gene_id : "ENSG00000170153.11",
      gene_type : "protein_coding",
      gene_name : "RNF150",
      gene_level : 1,
      hgnc_id : "HGNC:23138",
      havana_gene : "OTTHUMG00000161380.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 141220887,
      stop : 141234697,
      direction : "+",
      ID : "ENSG00000109445.11",
      gene_id : "ENSG00000109445.11",
      gene_type : "protein_coding",
      gene_name : "ZNF330",
      gene_level : 2,
      hgnc_id : "HGNC:15462",
      havana_gene : "OTTHUMG00000133413.9",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 141636583,
      stop : 141733987,
      direction : "+",
      ID : "ENSG00000164136.17",
      gene_id : "ENSG00000164136.17",
      gene_type : "protein_coding",
      gene_name : "IL15",
      gene_level : 2,
      hgnc_id : "HGNC:5977",
      havana_gene : "OTTHUMG00000133418.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 142023160,
      stop : 142847432,
      direction : "-",
      ID : "ENSG00000109452.12",
      gene_id : "ENSG00000109452.12",
      gene_type : "protein_coding",
      gene_name : "INPP4B",
      gene_level : 2,
      hgnc_id : "HGNC:6075",
      havana_gene : "OTTHUMG00000161341.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 143184917,
      stop : 143223874,
      direction : "+",
      ID : "ENSG00000170185.10",
      gene_id : "ENSG00000170185.10",
      gene_type : "protein_coding",
      gene_name : "USP38",
      gene_level : 2,
      hgnc_id : "HGNC:20067",
      havana_gene : "OTTHUMG00000161420.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 143336762,
      stop : 143474568,
      direction : "+",
      ID : "ENSG00000109458.8",
      gene_id : "ENSG00000109458.8",
      gene_type : "protein_coding",
      gene_name : "GAB1",
      gene_level : 1,
      hgnc_id : "HGNC:4066",
      havana_gene : "OTTHUMG00000161432.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 143513702,
      stop : 143557486,
      direction : "+",
      ID : "ENSG00000153147.6",
      gene_id : "ENSG00000153147.6",
      gene_type : "protein_coding",
      gene_name : "SMARCA5",
      gene_level : 2,
      hgnc_id : "HGNC:11101",
      havana_gene : "OTTHUMG00000161474.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 143577302,
      stop : 143700675,
      direction : "-",
      ID : "ENSG00000183090.5",
      gene_id : "ENSG00000183090.5",
      gene_type : "protein_coding",
      gene_name : "FREM3",
      gene_level : 1,
      hgnc_id : "HGNC:25172",
      havana_gene : "OTTHUMG00000161577.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 143870864,
      stop : 143905563,
      direction : "-",
      ID : "ENSG00000197465.14",
      gene_id : "ENSG00000197465.14",
      gene_type : "protein_coding",
      gene_name : "GYPE",
      gene_level : 2,
      hgnc_id : "HGNC:4705",
      havana_gene : "OTTHUMG00000161402.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 143996104,
      stop : 144019380,
      direction : "-",
      ID : "ENSG00000250361.9",
      gene_id : "ENSG00000250361.9",
      gene_type : "protein_coding",
      gene_name : "GYPB",
      gene_level : 2,
      hgnc_id : "HGNC:4703",
      havana_gene : "OTTHUMG00000161404.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 144109303,
      stop : 144140751,
      direction : "-",
      ID : "ENSG00000170180.22",
      gene_id : "ENSG00000170180.22",
      gene_type : "protein_coding",
      gene_name : "GYPA",
      gene_level : 2,
      hgnc_id : "HGNC:4702",
      havana_gene : "OTTHUMG00000192585.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 144210701,
      stop : 145098174,
      direction : "-",
      ID : "ENSG00000285713.1",
      gene_id : "ENSG00000285713.1",
      gene_type : "protein_coding",
      gene_name : "AC098588.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000161403.12",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 144646156,
      stop : 144745271,
      direction : "+",
      ID : "ENSG00000164161.10",
      gene_id : "ENSG00000164161.10",
      gene_type : "protein_coding",
      gene_name : "HHIP",
      gene_level : 2,
      hgnc_id : "HGNC:14866",
      havana_gene : "OTTHUMG00000161428.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 144831908,
      stop : 145098541,
      direction : "-",
      ID : "ENSG00000164162.14",
      gene_id : "ENSG00000164162.14",
      gene_type : "protein_coding",
      gene_name : "ANAPC10",
      gene_level : 2,
      hgnc_id : "HGNC:24077",
      havana_gene : "OTTHUMG00000161477.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 145098288,
      stop : 145129524,
      direction : "+",
      ID : "ENSG00000164163.11",
      gene_id : "ENSG00000164163.11",
      gene_type : "protein_coding",
      gene_name : "ABCE1",
      gene_level : 2,
      hgnc_id : "HGNC:69",
      havana_gene : "OTTHUMG00000161478.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 145110838,
      stop : 145180589,
      direction : "-",
      ID : "ENSG00000164164.17",
      gene_id : "ENSG00000164164.17",
      gene_type : "protein_coding",
      gene_name : "OTUD4",
      gene_level : 2,
      hgnc_id : "HGNC:24949",
      havana_gene : "OTTHUMG00000161480.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 145481194,
      stop : 145559176,
      direction : "+",
      ID : "ENSG00000170365.10",
      gene_id : "ENSG00000170365.10",
      gene_type : "protein_coding",
      gene_name : "SMAD1",
      gene_level : 1,
      hgnc_id : "HGNC:6767",
      havana_gene : "OTTHUMG00000161592.14",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 145599042,
      stop : 145660033,
      direction : "+",
      ID : "ENSG00000151611.17",
      gene_id : "ENSG00000151611.17",
      gene_type : "protein_coding",
      gene_name : "MMAA",
      gene_level : 2,
      hgnc_id : "HGNC:18871",
      havana_gene : "OTTHUMG00000161369.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 145680146,
      stop : 145771032,
      direction : "+",
      ID : "ENSG00000237136.8",
      gene_id : "ENSG00000237136.8",
      gene_type : "protein_coding",
      gene_name : "C4orf51",
      gene_level : 2,
      hgnc_id : "HGNC:37264",
      havana_gene : "OTTHUMG00000161367.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 145757627,
      stop : 145938823,
      direction : "-",
      ID : "ENSG00000151612.18",
      gene_id : "ENSG00000151612.18",
      gene_type : "protein_coding",
      gene_name : "ZNF827",
      gene_level : 1,
      hgnc_id : "HGNC:27193",
      havana_gene : "OTTHUMG00000161362.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 146175703,
      stop : 146200000,
      direction : "+",
      ID : "ENSG00000164167.12",
      gene_id : "ENSG00000164167.12",
      gene_type : "protein_coding",
      gene_name : "LSM6",
      gene_level : 2,
      hgnc_id : "HGNC:17017",
      havana_gene : "OTTHUMG00000161440.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 146214515,
      stop : 146230878,
      direction : "+",
      ID : "ENSG00000250673.2",
      gene_id : "ENSG00000250673.2",
      gene_type : "protein_coding",
      gene_name : "REELD1",
      gene_level : 2,
      hgnc_id : "HGNC:53638",
      havana_gene : "OTTHUMG00000161438.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 146253975,
      stop : 146521964,
      direction : "-",
      ID : "ENSG00000120519.15",
      gene_id : "ENSG00000120519.15",
      gene_type : "protein_coding",
      gene_name : "SLC10A7",
      gene_level : 2,
      hgnc_id : "HGNC:23088",
      havana_gene : "OTTHUMG00000161437.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 146638893,
      stop : 146642474,
      direction : "+",
      ID : "ENSG00000151615.3",
      gene_id : "ENSG00000151615.3",
      gene_type : "protein_coding",
      gene_name : "POU4F2",
      gene_level : 2,
      hgnc_id : "HGNC:9219",
      havana_gene : "OTTHUMG00000162045.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 146706617,
      stop : 146945882,
      direction : "-",
      ID : "ENSG00000137473.19",
      gene_id : "ENSG00000137473.19",
      gene_type : "protein_coding",
      gene_name : "TTC29",
      gene_level : 2,
      hgnc_id : "HGNC:29936",
      havana_gene : "OTTHUMG00000162047.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 147480917,
      stop : 147544954,
      direction : "+",
      ID : "ENSG00000151617.17",
      gene_id : "ENSG00000151617.17",
      gene_type : "protein_coding",
      gene_name : "EDNRA",
      gene_level : 2,
      hgnc_id : "HGNC:3179",
      havana_gene : "OTTHUMG00000161354.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 147617386,
      stop : 147672044,
      direction : "+",
      ID : "ENSG00000164168.8",
      gene_id : "ENSG00000164168.8",
      gene_type : "protein_coding",
      gene_name : "TMEM184C",
      gene_level : 2,
      hgnc_id : "HGNC:25587",
      havana_gene : "OTTHUMG00000161358.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 147637785,
      stop : 147684163,
      direction : "-",
      ID : "ENSG00000164169.13",
      gene_id : "ENSG00000164169.13",
      gene_type : "protein_coding",
      gene_name : "PRMT9",
      gene_level : 2,
      hgnc_id : "HGNC:25099",
      havana_gene : "OTTHUMG00000161361.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 147732063,
      stop : 148072776,
      direction : "+",
      ID : "ENSG00000071205.12",
      gene_id : "ENSG00000071205.12",
      gene_type : "protein_coding",
      gene_name : "ARHGAP10",
      gene_level : 1,
      hgnc_id : "HGNC:26099",
      havana_gene : "OTTHUMG00000161460.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 148078762,
      stop : 148444698,
      direction : "-",
      ID : "ENSG00000151623.15",
      gene_id : "ENSG00000151623.15",
      gene_type : "protein_coding",
      gene_name : "NR3C2",
      gene_level : 1,
      hgnc_id : "HGNC:7979",
      havana_gene : "OTTHUMG00000161455.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 149351709,
      stop : 149896233,
      direction : "-",
      ID : "ENSG00000234828.9",
      gene_id : "ENSG00000234828.9",
      gene_type : "protein_coding",
      gene_name : "IQCM",
      gene_level : 2,
      hgnc_id : "HGNC:53443",
      havana_gene : "OTTHUMG00000161394.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 150078445,
      stop : 150257438,
      direction : "+",
      ID : "ENSG00000170390.16",
      gene_id : "ENSG00000170390.16",
      gene_type : "protein_coding",
      gene_name : "DCLK2",
      gene_level : 2,
      hgnc_id : "HGNC:19002",
      havana_gene : "OTTHUMG00000161444.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 150264435,
      stop : 151015727,
      direction : "-",
      ID : "ENSG00000198589.14",
      gene_id : "ENSG00000198589.14",
      gene_type : "protein_coding",
      gene_name : "LRBA",
      gene_level : 1,
      hgnc_id : "HGNC:1742",
      havana_gene : "OTTHUMG00000161443.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 150582151,
      stop : 150584693,
      direction : "+",
      ID : "ENSG00000181541.6",
      gene_id : "ENSG00000181541.6",
      gene_type : "protein_coding",
      gene_name : "MAB21L2",
      gene_level : 2,
      hgnc_id : "HGNC:6758",
      havana_gene : "OTTHUMG00000161442.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 151099624,
      stop : 151104642,
      direction : "+",
      ID : "ENSG00000145425.10",
      gene_id : "ENSG00000145425.10",
      gene_type : "protein_coding",
      gene_name : "RPS3A",
      gene_level : 1,
      hgnc_id : "HGNC:10421",
      havana_gene : "OTTHUMG00000161445.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 151102751,
      stop : 151325605,
      direction : "-",
      ID : "ENSG00000109686.19",
      gene_id : "ENSG00000109686.19",
      gene_type : "protein_coding",
      gene_name : "SH3D19",
      gene_level : 2,
      hgnc_id : "HGNC:30418",
      havana_gene : "OTTHUMG00000154051.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 151277171,
      stop : 151291453,
      direction : "+",
      ID : "ENSG00000189099.11",
      gene_id : "ENSG00000189099.11",
      gene_type : "protein_coding",
      gene_name : "PRSS48",
      gene_level : 2,
      hgnc_id : "HGNC:24635",
      havana_gene : "OTTHUMG00000161673.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 151409176,
      stop : 151670503,
      direction : "+",
      ID : "ENSG00000164142.16",
      gene_id : "ENSG00000164142.16",
      gene_type : "protein_coding",
      gene_name : "FAM160A1",
      gene_level : 2,
      hgnc_id : "HGNC:34237",
      havana_gene : "OTTHUMG00000161675.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 151670504,
      stop : 151761007,
      direction : "-",
      ID : "ENSG00000059691.12",
      gene_id : "ENSG00000059691.12",
      gene_type : "protein_coding",
      gene_name : "GATB",
      gene_level : 1,
      hgnc_id : "HGNC:8849",
      havana_gene : "OTTHUMG00000161672.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 152320544,
      stop : 152536092,
      direction : "-",
      ID : "ENSG00000109670.16",
      gene_id : "ENSG00000109670.16",
      gene_type : "protein_coding",
      gene_name : "FBXW7",
      gene_level : 2,
      hgnc_id : "HGNC:16712",
      havana_gene : "OTTHUMG00000185246.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 152618628,
      stop : 152680012,
      direction : "-",
      ID : "ENSG00000170006.12",
      gene_id : "ENSG00000170006.12",
      gene_type : "protein_coding",
      gene_name : "TMEM154",
      gene_level : 2,
      hgnc_id : "HGNC:26489",
      havana_gene : "OTTHUMG00000161463.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 152769354,
      stop : 152779730,
      direction : "-",
      ID : "ENSG00000169989.3",
      gene_id : "ENSG00000169989.3",
      gene_type : "protein_coding",
      gene_name : "TIGD4",
      gene_level : 2,
      hgnc_id : "HGNC:18335",
      havana_gene : "OTTHUMG00000161464.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 152779937,
      stop : 152918463,
      direction : "+",
      ID : "ENSG00000164144.16",
      gene_id : "ENSG00000164144.16",
      gene_type : "protein_coding",
      gene_name : "ARFIP1",
      gene_level : 2,
      hgnc_id : "HGNC:21496",
      havana_gene : "OTTHUMG00000161468.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 152936323,
      stop : 152979671,
      direction : "+",
      ID : "ENSG00000137460.10",
      gene_id : "ENSG00000137460.10",
      gene_type : "protein_coding",
      gene_name : "FHDC1",
      gene_level : 2,
      hgnc_id : "HGNC:29363",
      havana_gene : "OTTHUMG00000161452.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153152163,
      stop : 153339319,
      direction : "+",
      ID : "ENSG00000109654.16",
      gene_id : "ENSG00000109654.16",
      gene_type : "protein_coding",
      gene_name : "TRIM2",
      gene_level : 1,
      hgnc_id : "HGNC:15974",
      havana_gene : "OTTHUMG00000155991.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153152435,
      stop : 153415081,
      direction : "+",
      ID : "ENSG00000288637.1",
      gene_id : "ENSG00000288637.1",
      gene_type : "protein_coding",
      gene_name : "AC013477.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153344649,
      stop : 153415118,
      direction : "+",
      ID : "ENSG00000121211.8",
      gene_id : "ENSG00000121211.8",
      gene_type : "protein_coding",
      gene_name : "MND1",
      gene_level : 1,
      hgnc_id : "HGNC:24839",
      havana_gene : "OTTHUMG00000161523.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153466346,
      stop : 153636711,
      direction : "+",
      ID : "ENSG00000121210.16",
      gene_id : "ENSG00000121210.16",
      gene_type : "protein_coding",
      gene_name : "TMEM131L",
      gene_level : 2,
      hgnc_id : "HGNC:29146",
      havana_gene : "OTTHUMG00000153244.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153684070,
      stop : 153706260,
      direction : "+",
      ID : "ENSG00000137462.9",
      gene_id : "ENSG00000137462.9",
      gene_type : "protein_coding",
      gene_name : "TLR2",
      gene_level : 2,
      hgnc_id : "HGNC:11848",
      havana_gene : "OTTHUMG00000161525.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153710160,
      stop : 153760024,
      direction : "-",
      ID : "ENSG00000145428.15",
      gene_id : "ENSG00000145428.15",
      gene_type : "protein_coding",
      gene_name : "RNF175",
      gene_level : 2,
      hgnc_id : "HGNC:27735",
      havana_gene : "OTTHUMG00000161557.11",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 153780591,
      stop : 153789083,
      direction : "-",
      ID : "ENSG00000145423.5",
      gene_id : "ENSG00000145423.5",
      gene_type : "protein_coding",
      gene_name : "SFRP2",
      gene_level : 2,
      hgnc_id : "HGNC:10777",
      havana_gene : "OTTHUMG00000161559.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154231742,
      stop : 154491799,
      direction : "-",
      ID : "ENSG00000197410.14",
      gene_id : "ENSG00000197410.14",
      gene_type : "protein_coding",
      gene_name : "DCHS2",
      gene_level : 2,
      hgnc_id : "HGNC:23111",
      havana_gene : "OTTHUMG00000161556.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154535005,
      stop : 154550400,
      direction : "-",
      ID : "ENSG00000171566.12",
      gene_id : "ENSG00000171566.12",
      gene_type : "protein_coding",
      gene_name : "PLRG1",
      gene_level : 1,
      hgnc_id : "HGNC:9089",
      havana_gene : "OTTHUMG00000161411.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154563011,
      stop : 154572807,
      direction : "+",
      ID : "ENSG00000171564.12",
      gene_id : "ENSG00000171564.12",
      gene_type : "protein_coding",
      gene_name : "FGB",
      gene_level : 1,
      hgnc_id : "HGNC:3662",
      havana_gene : "OTTHUMG00000150331.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154583128,
      stop : 154590745,
      direction : "-",
      ID : "ENSG00000171560.16",
      gene_id : "ENSG00000171560.16",
      gene_type : "protein_coding",
      gene_name : "FGA",
      gene_level : 2,
      hgnc_id : "HGNC:3661",
      havana_gene : "OTTHUMG00000150330.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154604134,
      stop : 154612967,
      direction : "-",
      ID : "ENSG00000171557.17",
      gene_id : "ENSG00000171557.17",
      gene_type : "protein_coding",
      gene_name : "FGG",
      gene_level : 2,
      hgnc_id : "HGNC:3694",
      havana_gene : "OTTHUMG00000150329.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154626945,
      stop : 154753120,
      direction : "+",
      ID : "ENSG00000121207.12",
      gene_id : "ENSG00000121207.12",
      gene_type : "protein_coding",
      gene_name : "LRAT",
      gene_level : 2,
      hgnc_id : "HGNC:6685",
      havana_gene : "OTTHUMG00000161418.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 154781213,
      stop : 154828813,
      direction : "+",
      ID : "ENSG00000151962.8",
      gene_id : "ENSG00000151962.8",
      gene_type : "protein_coding",
      gene_name : "RBM46",
      gene_level : 1,
      hgnc_id : "HGNC:28401",
      havana_gene : "OTTHUMG00000161543.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155208636,
      stop : 155217078,
      direction : "+",
      ID : "ENSG00000185149.6",
      gene_id : "ENSG00000185149.6",
      gene_type : "protein_coding",
      gene_name : "NPY2R",
      gene_level : 2,
      hgnc_id : "HGNC:7957",
      havana_gene : "OTTHUMG00000161485.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155342658,
      stop : 155376970,
      direction : "-",
      ID : "ENSG00000164114.19",
      gene_id : "ENSG00000164114.19",
      gene_type : "protein_coding",
      gene_name : "MAP9",
      gene_level : 2,
      hgnc_id : "HGNC:26118",
      havana_gene : "OTTHUMG00000133628.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155666726,
      stop : 155737059,
      direction : "+",
      ID : "ENSG00000164116.17",
      gene_id : "ENSG00000164116.17",
      gene_type : "protein_coding",
      gene_name : "GUCY1A1",
      gene_level : 2,
      hgnc_id : "HGNC:4685",
      havana_gene : "OTTHUMG00000161700.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155758992,
      stop : 155807811,
      direction : "+",
      ID : "ENSG00000061918.14",
      gene_id : "ENSG00000061918.14",
      gene_type : "protein_coding",
      gene_name : "GUCY1B1",
      gene_level : 1,
      hgnc_id : "HGNC:4687",
      havana_gene : "OTTHUMG00000161698.19",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155829729,
      stop : 155866277,
      direction : "-",
      ID : "ENSG00000256394.3",
      gene_id : "ENSG00000256394.3",
      gene_type : "protein_coding",
      gene_name : "ASIC5",
      gene_level : 2,
      hgnc_id : "HGNC:17537",
      havana_gene : "OTTHUMG00000161941.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155854738,
      stop : 155920406,
      direction : "+",
      ID : "ENSG00000151790.9",
      gene_id : "ENSG00000151790.9",
      gene_type : "protein_coding",
      gene_name : "TDO2",
      gene_level : 2,
      hgnc_id : "HGNC:11708",
      havana_gene : "OTTHUMG00000161838.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 155921580,
      stop : 155953912,
      direction : "-",
      ID : "ENSG00000256043.5",
      gene_id : "ENSG00000256043.5",
      gene_type : "protein_coding",
      gene_name : "CTSO",
      gene_level : 2,
      hgnc_id : "HGNC:2542",
      havana_gene : "OTTHUMG00000161942.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 156760454,
      stop : 156971799,
      direction : "-",
      ID : "ENSG00000145431.11",
      gene_id : "ENSG00000145431.11",
      gene_type : "protein_coding",
      gene_name : "PDGFC",
      gene_level : 2,
      hgnc_id : "HGNC:8801",
      havana_gene : "OTTHUMG00000161803.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 157076125,
      stop : 157172090,
      direction : "+",
      ID : "ENSG00000109738.11",
      gene_id : "ENSG00000109738.11",
      gene_type : "protein_coding",
      gene_name : "GLRB",
      gene_level : 2,
      hgnc_id : "HGNC:4329",
      havana_gene : "OTTHUMG00000161954.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 157204182,
      stop : 157366075,
      direction : "+",
      ID : "ENSG00000120251.21",
      gene_id : "ENSG00000120251.21",
      gene_type : "protein_coding",
      gene_name : "GRIA2",
      gene_level : 2,
      hgnc_id : "HGNC:4572",
      havana_gene : "OTTHUMG00000133836.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158124474,
      stop : 158173318,
      direction : "-",
      ID : "ENSG00000164125.16",
      gene_id : "ENSG00000164125.16",
      gene_type : "protein_coding",
      gene_name : "GASK1B",
      gene_level : 1,
      hgnc_id : "HGNC:25312",
      havana_gene : "OTTHUMG00000161537.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158201604,
      stop : 158255416,
      direction : "+",
      ID : "ENSG00000164124.11",
      gene_id : "ENSG00000164124.11",
      gene_type : "protein_coding",
      gene_name : "TMEM144",
      gene_level : 2,
      hgnc_id : "HGNC:25633",
      havana_gene : "OTTHUMG00000162013.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158315311,
      stop : 158653372,
      direction : "+",
      ID : "ENSG00000171509.16",
      gene_id : "ENSG00000171509.16",
      gene_type : "protein_coding",
      gene_name : "RXFP1",
      gene_level : 1,
      hgnc_id : "HGNC:19718",
      havana_gene : "OTTHUMG00000149973.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158666675,
      stop : 158672255,
      direction : "-",
      ID : "ENSG00000205208.5",
      gene_id : "ENSG00000205208.5",
      gene_type : "protein_coding",
      gene_name : "C4orf46",
      gene_level : 1,
      hgnc_id : "HGNC:27320",
      havana_gene : "OTTHUMG00000161919.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158672125,
      stop : 158709623,
      direction : "+",
      ID : "ENSG00000171503.12",
      gene_id : "ENSG00000171503.12",
      gene_type : "protein_coding",
      gene_name : "ETFDH",
      gene_level : 1,
      hgnc_id : "HGNC:3483",
      havana_gene : "OTTHUMG00000161684.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158709127,
      stop : 158723396,
      direction : "-",
      ID : "ENSG00000171497.5",
      gene_id : "ENSG00000171497.5",
      gene_type : "protein_coding",
      gene_name : "PPID",
      gene_level : 2,
      hgnc_id : "HGNC:9257",
      havana_gene : "OTTHUMG00000161927.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158769026,
      stop : 158908050,
      direction : "+",
      ID : "ENSG00000052795.13",
      gene_id : "ENSG00000052795.13",
      gene_type : "protein_coding",
      gene_name : "FNIP2",
      gene_level : 2,
      hgnc_id : "HGNC:29280",
      havana_gene : "OTTHUMG00000161983.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 158893134,
      stop : 159038760,
      direction : "-",
      ID : "ENSG00000164123.7",
      gene_id : "ENSG00000164123.7",
      gene_type : "protein_coding",
      gene_name : "C4orf45",
      gene_level : 2,
      hgnc_id : "HGNC:26342",
      havana_gene : "OTTHUMG00000161988.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 159103013,
      stop : 159360174,
      direction : "+",
      ID : "ENSG00000109756.9",
      gene_id : "ENSG00000109756.9",
      gene_type : "protein_coding",
      gene_name : "RAPGEF2",
      gene_level : 1,
      hgnc_id : "HGNC:16854",
      havana_gene : "OTTHUMG00000161451.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 161383897,
      stop : 162164004,
      direction : "-",
      ID : "ENSG00000168843.14",
      gene_id : "ENSG00000168843.14",
      gene_type : "protein_coding",
      gene_name : "FSTL5",
      gene_level : 2,
      hgnc_id : "HGNC:21386",
      havana_gene : "OTTHUMG00000161397.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 163110073,
      stop : 163166890,
      direction : "-",
      ID : "ENSG00000145414.9",
      gene_id : "ENSG00000145414.9",
      gene_type : "protein_coding",
      gene_name : "NAF1",
      gene_level : 2,
      hgnc_id : "HGNC:25126",
      havana_gene : "OTTHUMG00000161370.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 163323962,
      stop : 163344832,
      direction : "-",
      ID : "ENSG00000164128.7",
      gene_id : "ENSG00000164128.7",
      gene_type : "protein_coding",
      gene_name : "NPY1R",
      gene_level : 2,
      hgnc_id : "HGNC:7956",
      havana_gene : "OTTHUMG00000161371.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 163343892,
      stop : 163351934,
      direction : "+",
      ID : "ENSG00000164129.12",
      gene_id : "ENSG00000164129.12",
      gene_type : "protein_coding",
      gene_name : "NPY5R",
      gene_level : 2,
      hgnc_id : "HGNC:7958",
      havana_gene : "OTTHUMG00000161353.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 163471095,
      stop : 163473754,
      direction : "-",
      ID : "ENSG00000151005.5",
      gene_id : "ENSG00000151005.5",
      gene_type : "protein_coding",
      gene_name : "TKTL2",
      gene_level : 2,
      hgnc_id : "HGNC:25313",
      havana_gene : "OTTHUMG00000161527.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 163494442,
      stop : 163520539,
      direction : "+",
      ID : "ENSG00000198498.10",
      gene_id : "ENSG00000198498.10",
      gene_type : "protein_coding",
      gene_name : "TMA16",
      gene_level : 1,
      hgnc_id : "HGNC:25638",
      havana_gene : "OTTHUMG00000161528.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 163524298,
      stop : 164384050,
      direction : "-",
      ID : "ENSG00000145416.13",
      gene_id : "ENSG00000145416.13",
      gene_type : "protein_coding",
      gene_name : "MARCHF1",
      gene_level : 2,
      hgnc_id : "HGNC:26077",
      havana_gene : "OTTHUMG00000161204.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 164754064,
      stop : 164803795,
      direction : "+",
      ID : "ENSG00000248771.5",
      gene_id : "ENSG00000248771.5",
      gene_type : "protein_coding",
      gene_name : "SMIM31",
      gene_level : 2,
      hgnc_id : "HGNC:49638",
      havana_gene : "OTTHUMG00000161261.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 164877178,
      stop : 164898965,
      direction : "+",
      ID : "ENSG00000248329.6",
      gene_id : "ENSG00000248329.6",
      gene_type : "protein_coding",
      gene_name : "APELA",
      gene_level : 2,
      hgnc_id : "HGNC:48925",
      havana_gene : "OTTHUMG00000161255.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 164954446,
      stop : 164977668,
      direction : "-",
      ID : "ENSG00000183439.9",
      gene_id : "ENSG00000183439.9",
      gene_type : "protein_coding",
      gene_name : "TRIM61",
      gene_level : 2,
      hgnc_id : "HGNC:24339",
      havana_gene : "OTTHUMG00000161266.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165016458,
      stop : 165041749,
      direction : "+",
      ID : "ENSG00000176979.14",
      gene_id : "ENSG00000176979.14",
      gene_type : "protein_coding",
      gene_name : "TRIM60",
      gene_level : 2,
      hgnc_id : "HGNC:21162",
      havana_gene : "OTTHUMG00000161262.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165053864,
      stop : 165060554,
      direction : "+",
      ID : "ENSG00000250374.4",
      gene_id : "ENSG00000250374.4",
      gene_type : "protein_coding",
      gene_name : "TRIM75P",
      gene_level : 2,
      hgnc_id : "HGNC:32686",
      havana_gene : "OTTHUMG00000161257.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165070608,
      stop : 165208549,
      direction : "-",
      ID : "ENSG00000170088.14",
      gene_id : "ENSG00000170088.14",
      gene_type : "protein_coding",
      gene_name : "TMEM192",
      gene_level : 2,
      hgnc_id : "HGNC:26775",
      havana_gene : "OTTHUMG00000161254.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165207561,
      stop : 165323156,
      direction : "+",
      ID : "ENSG00000109466.14",
      gene_id : "ENSG00000109466.14",
      gene_type : "protein_coding",
      gene_name : "KLHL2",
      gene_level : 2,
      hgnc_id : "HGNC:6353",
      havana_gene : "OTTHUMG00000161294.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165277812,
      stop : 165279679,
      direction : "-",
      ID : "ENSG00000229894.4",
      gene_id : "ENSG00000229894.4",
      gene_type : "protein_coding",
      gene_name : "GK3P",
      gene_level : 2,
      hgnc_id : "HGNC:4292",
      havana_gene : "OTTHUMG00000161293.2",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165327667,
      stop : 165343164,
      direction : "+",
      ID : "ENSG00000052802.13",
      gene_id : "ENSG00000052802.13",
      gene_type : "protein_coding",
      gene_name : "MSMO1",
      gene_level : 2,
      hgnc_id : "HGNC:10545",
      havana_gene : "OTTHUMG00000161126.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165361194,
      stop : 165498547,
      direction : "+",
      ID : "ENSG00000109472.14",
      gene_id : "ENSG00000109472.14",
      gene_type : "protein_coding",
      gene_name : "CPE",
      gene_level : 2,
      hgnc_id : "HGNC:2303",
      havana_gene : "OTTHUMG00000150252.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 165873237,
      stop : 166104457,
      direction : "+",
      ID : "ENSG00000038295.8",
      gene_id : "ENSG00000038295.8",
      gene_type : "protein_coding",
      gene_name : "TLL1",
      gene_level : 2,
      hgnc_id : "HGNC:11843",
      havana_gene : "OTTHUMG00000161112.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 166733384,
      stop : 167234796,
      direction : "-",
      ID : "ENSG00000196104.11",
      gene_id : "ENSG00000196104.11",
      gene_type : "protein_coding",
      gene_name : "SPOCK3",
      gene_level : 2,
      hgnc_id : "HGNC:13565",
      havana_gene : "OTTHUMG00000161190.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 168092537,
      stop : 168187736,
      direction : "+",
      ID : "ENSG00000109511.12",
      gene_id : "ENSG00000109511.12",
      gene_type : "protein_coding",
      gene_name : "ANXA10",
      gene_level : 2,
      hgnc_id : "HGNC:534",
      havana_gene : "OTTHUMG00000161275.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 168216291,
      stop : 168318883,
      direction : "-",
      ID : "ENSG00000137628.18",
      gene_id : "ENSG00000137628.18",
      gene_type : "protein_coding",
      gene_name : "DDX60",
      gene_level : 2,
      hgnc_id : "HGNC:25942",
      havana_gene : "OTTHUMG00000161350.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 168356735,
      stop : 168537786,
      direction : "-",
      ID : "ENSG00000181381.14",
      gene_id : "ENSG00000181381.14",
      gene_type : "protein_coding",
      gene_name : "DDX60L",
      gene_level : 1,
      hgnc_id : "HGNC:26429",
      havana_gene : "OTTHUMG00000161412.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 168497052,
      stop : 168928457,
      direction : "+",
      ID : "ENSG00000129116.19",
      gene_id : "ENSG00000129116.19",
      gene_type : "protein_coding",
      gene_name : "PALLD",
      gene_level : 1,
      hgnc_id : "HGNC:17068",
      havana_gene : "OTTHUMG00000161097.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 168863770,
      stop : 169010275,
      direction : "-",
      ID : "ENSG00000145439.12",
      gene_id : "ENSG00000145439.12",
      gene_type : "protein_coding",
      gene_name : "CBR4",
      gene_level : 2,
      hgnc_id : "HGNC:25891",
      havana_gene : "OTTHUMG00000161025.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 169094259,
      stop : 169270956,
      direction : "-",
      ID : "ENSG00000154447.15",
      gene_id : "ENSG00000154447.15",
      gene_type : "protein_coding",
      gene_name : "SH3RF1",
      gene_level : 2,
      hgnc_id : "HGNC:17650",
      havana_gene : "OTTHUMG00000161010.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 169392809,
      stop : 169612627,
      direction : "-",
      ID : "ENSG00000137601.17",
      gene_id : "ENSG00000137601.17",
      gene_type : "protein_coding",
      gene_name : "NEK1",
      gene_level : 2,
      hgnc_id : "HGNC:7744",
      havana_gene : "OTTHUMG00000160963.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 169612633,
      stop : 169723673,
      direction : "+",
      ID : "ENSG00000109572.14",
      gene_id : "ENSG00000109572.14",
      gene_type : "protein_coding",
      gene_name : "CLCN3",
      gene_level : 1,
      hgnc_id : "HGNC:2021",
      havana_gene : "OTTHUMG00000160973.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 169729470,
      stop : 169757944,
      direction : "-",
      ID : "ENSG00000056050.7",
      gene_id : "ENSG00000056050.7",
      gene_type : "protein_coding",
      gene_name : "HPF1",
      gene_level : 2,
      hgnc_id : "HGNC:26051",
      havana_gene : "OTTHUMG00000160960.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 169986597,
      stop : 170033031,
      direction : "-",
      ID : "ENSG00000198948.12",
      gene_id : "ENSG00000198948.12",
      gene_type : "protein_coding",
      gene_name : "MFAP3L",
      gene_level : 1,
      hgnc_id : "HGNC:29083",
      havana_gene : "OTTHUMG00000160942.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 170060222,
      stop : 170091699,
      direction : "-",
      ID : "ENSG00000109576.14",
      gene_id : "ENSG00000109576.14",
      gene_type : "protein_coding",
      gene_name : "AADAT",
      gene_level : 1,
      hgnc_id : "HGNC:17929",
      havana_gene : "OTTHUMG00000160912.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 171812254,
      stop : 173041559,
      direction : "+",
      ID : "ENSG00000174473.16",
      gene_id : "ENSG00000174473.16",
      gene_type : "protein_coding",
      gene_name : "GALNTL6",
      gene_level : 2,
      hgnc_id : "HGNC:33844",
      havana_gene : "OTTHUMG00000160807.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 173168811,
      stop : 173323967,
      direction : "+",
      ID : "ENSG00000109586.12",
      gene_id : "ENSG00000109586.12",
      gene_type : "protein_coding",
      gene_name : "GALNT7",
      gene_level : 1,
      hgnc_id : "HGNC:4129",
      havana_gene : "OTTHUMG00000160817.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 173331376,
      stop : 173334432,
      direction : "-",
      ID : "ENSG00000164104.12",
      gene_id : "ENSG00000164104.12",
      gene_type : "protein_coding",
      gene_name : "HMGB2",
      gene_level : 2,
      hgnc_id : "HGNC:5000",
      havana_gene : "OTTHUMG00000160799.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 173369969,
      stop : 173377532,
      direction : "+",
      ID : "ENSG00000164105.4",
      gene_id : "ENSG00000164105.4",
      gene_type : "protein_coding",
      gene_name : "SAP30",
      gene_level : 1,
      hgnc_id : "HGNC:10532",
      havana_gene : "OTTHUMG00000160798.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 173384701,
      stop : 173406380,
      direction : "-",
      ID : "ENSG00000164106.8",
      gene_id : "ENSG00000164106.8",
      gene_type : "protein_coding",
      gene_name : "SCRG1",
      gene_level : 2,
      hgnc_id : "HGNC:17036",
      havana_gene : "OTTHUMG00000161249.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 173524969,
      stop : 173530229,
      direction : "-",
      ID : "ENSG00000164107.9",
      gene_id : "ENSG00000164107.9",
      gene_type : "protein_coding",
      gene_name : "HAND2",
      gene_level : 2,
      hgnc_id : "HGNC:4808",
      havana_gene : "OTTHUMG00000160775.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 174236658,
      stop : 174283667,
      direction : "-",
      ID : "ENSG00000164117.14",
      gene_id : "ENSG00000164117.14",
      gene_type : "protein_coding",
      gene_name : "FBXO8",
      gene_level : 2,
      hgnc_id : "HGNC:13587",
      havana_gene : "OTTHUMG00000160746.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 174283730,
      stop : 174333380,
      direction : "+",
      ID : "ENSG00000164118.13",
      gene_id : "ENSG00000164118.13",
      gene_type : "protein_coding",
      gene_name : "CEP44",
      gene_level : 2,
      hgnc_id : "HGNC:29356",
      havana_gene : "OTTHUMG00000160752.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 174490175,
      stop : 174523154,
      direction : "-",
      ID : "ENSG00000164120.14",
      gene_id : "ENSG00000164120.14",
      gene_type : "protein_coding",
      gene_name : "HPGD",
      gene_level : 1,
      hgnc_id : "HGNC:5154",
      havana_gene : "OTTHUMG00000160772.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 174636920,
      stop : 174829247,
      direction : "-",
      ID : "ENSG00000145451.13",
      gene_id : "ENSG00000145451.13",
      gene_type : "protein_coding",
      gene_name : "GLRA3",
      gene_level : 1,
      hgnc_id : "HGNC:4328",
      havana_gene : "OTTHUMG00000149816.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 174829668,
      stop : 174978180,
      direction : "+",
      ID : "ENSG00000168594.15",
      gene_id : "ENSG00000168594.15",
      gene_type : "protein_coding",
      gene_name : "ADAM29",
      gene_level : 1,
      hgnc_id : "HGNC:207",
      havana_gene : "OTTHUMG00000160764.6",
      tag : "retrogene"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 175632934,
      stop : 176002664,
      direction : "-",
      ID : "ENSG00000150625.16",
      gene_id : "ENSG00000150625.16",
      gene_type : "protein_coding",
      gene_name : "GPM6A",
      gene_level : 2,
      hgnc_id : "HGNC:4460",
      havana_gene : "OTTHUMG00000160760.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 176065841,
      stop : 176182818,
      direction : "+",
      ID : "ENSG00000150627.16",
      gene_id : "ENSG00000150627.16",
      gene_type : "protein_coding",
      gene_name : "WDR17",
      gene_level : 1,
      hgnc_id : "HGNC:16661",
      havana_gene : "OTTHUMG00000160791.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 176184579,
      stop : 176195585,
      direction : "-",
      ID : "ENSG00000150628.7",
      gene_id : "ENSG00000150628.7",
      gene_type : "protein_coding",
      gene_name : "SPATA4",
      gene_level : 2,
      hgnc_id : "HGNC:17333",
      havana_gene : "OTTHUMG00000160788.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 176213673,
      stop : 176277571,
      direction : "-",
      ID : "ENSG00000164122.9",
      gene_id : "ENSG00000164122.9",
      gene_type : "protein_coding",
      gene_name : "ASB5",
      gene_level : 1,
      hgnc_id : "HGNC:17180",
      havana_gene : "OTTHUMG00000160793.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 176319966,
      stop : 176332245,
      direction : "+",
      ID : "ENSG00000129128.13",
      gene_id : "ENSG00000129128.13",
      gene_type : "protein_coding",
      gene_name : "SPCS3",
      gene_level : 2,
      hgnc_id : "HGNC:26212",
      havana_gene : "OTTHUMG00000160789.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 176683538,
      stop : 176792922,
      direction : "-",
      ID : "ENSG00000150630.4",
      gene_id : "ENSG00000150630.4",
      gene_type : "protein_coding",
      gene_name : "VEGFC",
      gene_level : 2,
      hgnc_id : "HGNC:12682",
      havana_gene : "OTTHUMG00000160734.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 177309874,
      stop : 177362936,
      direction : "+",
      ID : "ENSG00000109674.4",
      gene_id : "ENSG00000109674.4",
      gene_type : "protein_coding",
      gene_name : "NEIL3",
      gene_level : 2,
      hgnc_id : "HGNC:24573",
      havana_gene : "OTTHUMG00000160722.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 177430774,
      stop : 177442437,
      direction : "-",
      ID : "ENSG00000038002.9",
      gene_id : "ENSG00000038002.9",
      gene_type : "protein_coding",
      gene_name : "AGA",
      gene_level : 2,
      hgnc_id : "HGNC:318",
      havana_gene : "OTTHUMG00000160723.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 182143987,
      stop : 182803024,
      direction : "+",
      ID : "ENSG00000218336.9",
      gene_id : "ENSG00000218336.9",
      gene_type : "protein_coding",
      gene_name : "TENM3",
      gene_level : 2,
      hgnc_id : "HGNC:29944",
      havana_gene : "OTTHUMG00000160682.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 182890060,
      stop : 182917936,
      direction : "-",
      ID : "ENSG00000129187.15",
      gene_id : "ENSG00000129187.15",
      gene_type : "protein_coding",
      gene_name : "DCTD",
      gene_level : 2,
      hgnc_id : "HGNC:2710",
      havana_gene : "OTTHUMG00000160685.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183099257,
      stop : 183320777,
      direction : "+",
      ID : "ENSG00000151718.16",
      gene_id : "ENSG00000151718.16",
      gene_type : "protein_coding",
      gene_name : "WWC2",
      gene_level : 1,
      hgnc_id : "HGNC:24148",
      havana_gene : "OTTHUMG00000150685.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183318100,
      stop : 183320276,
      direction : "-",
      ID : "ENSG00000177300.7",
      gene_id : "ENSG00000177300.7",
      gene_type : "protein_coding",
      gene_name : "CLDN22",
      gene_level : 2,
      hgnc_id : "HGNC:2044",
      havana_gene : "OTTHUMG00000160627.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183321764,
      stop : 183322426,
      direction : "-",
      ID : "ENSG00000185758.9",
      gene_id : "ENSG00000185758.9",
      gene_type : "protein_coding",
      gene_name : "CLDN24",
      gene_level : 2,
      hgnc_id : "HGNC:37200",
      havana_gene : "OTTHUMG00000160628.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183444635,
      stop : 183449064,
      direction : "+",
      ID : "ENSG00000168564.6",
      gene_id : "ENSG00000168564.6",
      gene_type : "protein_coding",
      gene_name : "CDKN2AIP",
      gene_level : 2,
      hgnc_id : "HGNC:24325",
      havana_gene : "OTTHUMG00000160626.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183505058,
      stop : 183512429,
      direction : "+",
      ID : "ENSG00000168556.7",
      gene_id : "ENSG00000168556.7",
      gene_type : "protein_coding",
      gene_name : "ING2",
      gene_level : 2,
      hgnc_id : "HGNC:6063",
      havana_gene : "OTTHUMG00000150502.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183639635,
      stop : 183659203,
      direction : "-",
      ID : "ENSG00000182552.15",
      gene_id : "ENSG00000182552.15",
      gene_type : "protein_coding",
      gene_name : "RWDD4",
      gene_level : 2,
      hgnc_id : "HGNC:23750",
      havana_gene : "OTTHUMG00000160632.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183659267,
      stop : 183713594,
      direction : "+",
      ID : "ENSG00000168538.16",
      gene_id : "ENSG00000168538.16",
      gene_type : "protein_coding",
      gene_name : "TRAPPC11",
      gene_level : 1,
      hgnc_id : "HGNC:25751",
      havana_gene : "OTTHUMG00000160673.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 183797692,
      stop : 184023526,
      direction : "+",
      ID : "ENSG00000173320.12",
      gene_id : "ENSG00000173320.12",
      gene_type : "protein_coding",
      gene_name : "STOX2",
      gene_level : 1,
      hgnc_id : "HGNC:25450",
      havana_gene : "OTTHUMG00000160618.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 184088706,
      stop : 184221230,
      direction : "-",
      ID : "ENSG00000164303.11",
      gene_id : "ENSG00000164303.11",
      gene_type : "protein_coding",
      gene_name : "ENPP6",
      gene_level : 1,
      hgnc_id : "HGNC:23409",
      havana_gene : "OTTHUMG00000160617.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 184387729,
      stop : 184474550,
      direction : "-",
      ID : "ENSG00000168310.11",
      gene_id : "ENSG00000168310.11",
      gene_type : "protein_coding",
      gene_name : "IRF2",
      gene_level : 1,
      hgnc_id : "HGNC:6117",
      havana_gene : "OTTHUMG00000160606.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 184627696,
      stop : 184649509,
      direction : "-",
      ID : "ENSG00000164305.19",
      gene_id : "ENSG00000164305.19",
      gene_type : "protein_coding",
      gene_name : "CASP3",
      gene_level : 2,
      hgnc_id : "HGNC:1504",
      havana_gene : "OTTHUMG00000133681.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 184649667,
      stop : 184694963,
      direction : "+",
      ID : "ENSG00000164306.11",
      gene_id : "ENSG00000164306.11",
      gene_type : "protein_coding",
      gene_name : "PRIMPOL",
      gene_level : 1,
      hgnc_id : "HGNC:26575",
      havana_gene : "OTTHUMG00000160495.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 184694085,
      stop : 184734130,
      direction : "-",
      ID : "ENSG00000151725.12",
      gene_id : "ENSG00000151725.12",
      gene_type : "protein_coding",
      gene_name : "CENPU",
      gene_level : 2,
      hgnc_id : "HGNC:21348",
      havana_gene : "OTTHUMG00000160499.20",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 184755595,
      stop : 184826818,
      direction : "-",
      ID : "ENSG00000151726.15",
      gene_id : "ENSG00000151726.15",
      gene_type : "protein_coding",
      gene_name : "ACSL1",
      gene_level : 1,
      hgnc_id : "HGNC:3569",
      havana_gene : "OTTHUMG00000160547.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185018841,
      stop : 185020804,
      direction : "+",
      ID : "ENSG00000187821.8",
      gene_id : "ENSG00000187821.8",
      gene_type : "protein_coding",
      gene_name : "HELT",
      gene_level : 2,
      hgnc_id : "HGNC:33783",
      havana_gene : "OTTHUMG00000160484.1",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185143266,
      stop : 185150382,
      direction : "+",
      ID : "ENSG00000151729.11",
      gene_id : "ENSG00000151729.11",
      gene_type : "protein_coding",
      gene_name : "SLC25A4",
      gene_level : 2,
      hgnc_id : "HGNC:10990",
      havana_gene : "OTTHUMG00000134299.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185159665,
      stop : 185209504,
      direction : "-",
      ID : "ENSG00000164323.14",
      gene_id : "ENSG00000164323.14",
      gene_type : "protein_coding",
      gene_name : "CFAP97",
      gene_level : 1,
      hgnc_id : "HGNC:29276",
      havana_gene : "OTTHUMG00000160468.5",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185204237,
      stop : 185370185,
      direction : "+",
      ID : "ENSG00000109762.16",
      gene_id : "ENSG00000109762.16",
      gene_type : "protein_coding",
      gene_name : "SNX25",
      gene_level : 2,
      hgnc_id : "HGNC:21883",
      havana_gene : "OTTHUMG00000160475.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185363872,
      stop : 185395924,
      direction : "-",
      ID : "ENSG00000109771.16",
      gene_id : "ENSG00000109771.16",
      gene_type : "protein_coding",
      gene_name : "LRP2BP",
      gene_level : 2,
      hgnc_id : "HGNC:25434",
      havana_gene : "OTTHUMG00000160460.4",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185396021,
      stop : 185400628,
      direction : "+",
      ID : "ENSG00000186352.9",
      gene_id : "ENSG00000186352.9",
      gene_type : "protein_coding",
      gene_name : "ANKRD37",
      gene_level : 2,
      hgnc_id : "HGNC:29593",
      havana_gene : "OTTHUMG00000160459.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185399537,
      stop : 185425979,
      direction : "-",
      ID : "ENSG00000109775.11",
      gene_id : "ENSG00000109775.11",
      gene_type : "protein_coding",
      gene_name : "UFSP2",
      gene_level : 1,
      hgnc_id : "HGNC:25640",
      havana_gene : "OTTHUMG00000160441.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185426249,
      stop : 185449826,
      direction : "+",
      ID : "ENSG00000205129.8",
      gene_id : "ENSG00000205129.8",
      gene_type : "protein_coding",
      gene_name : "C4orf47",
      gene_level : 2,
      hgnc_id : "HGNC:34346",
      havana_gene : "OTTHUMG00000160458.15",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185445182,
      stop : 185471752,
      direction : "-",
      ID : "ENSG00000168491.10",
      gene_id : "ENSG00000168491.10",
      gene_type : "protein_coding",
      gene_name : "CCDC110",
      gene_level : 1,
      hgnc_id : "HGNC:28504",
      havana_gene : "OTTHUMG00000160415.7",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185500660,
      stop : 185535507,
      direction : "-",
      ID : "ENSG00000154553.16",
      gene_id : "ENSG00000154553.16",
      gene_type : "protein_coding",
      gene_name : "PDLIM3",
      gene_level : 2,
      hgnc_id : "HGNC:20767",
      havana_gene : "OTTHUMG00000160412.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 185585444,
      stop : 185956652,
      direction : "-",
      ID : "ENSG00000154556.18",
      gene_id : "ENSG00000154556.18",
      gene_type : "protein_coding",
      gene_name : "SORBS2",
      gene_level : 1,
      hgnc_id : "HGNC:24098",
      havana_gene : "OTTHUMG00000157215.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186069155,
      stop : 186088073,
      direction : "+",
      ID : "ENSG00000164342.13",
      gene_id : "ENSG00000164342.13",
      gene_type : "protein_coding",
      gene_name : "TLR3",
      gene_level : 1,
      hgnc_id : "HGNC:11849",
      havana_gene : "OTTHUMG00000160345.6",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186104419,
      stop : 186172667,
      direction : "+",
      ID : "ENSG00000109794.13",
      gene_id : "ENSG00000109794.13",
      gene_type : "protein_coding",
      gene_name : "FAM149A",
      gene_level : 1,
      hgnc_id : "HGNC:24527",
      havana_gene : "OTTHUMG00000160565.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186191567,
      stop : 186213463,
      direction : "+",
      ID : "ENSG00000145476.16",
      gene_id : "ENSG00000145476.16",
      gene_type : "protein_coding",
      gene_name : "CYP4V2",
      gene_level : 2,
      hgnc_id : "HGNC:23198",
      havana_gene : "OTTHUMG00000160379.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186208979,
      stop : 186258471,
      direction : "+",
      ID : "ENSG00000164344.16",
      gene_id : "ENSG00000164344.16",
      gene_type : "protein_coding",
      gene_name : "KLKB1",
      gene_level : 1,
      hgnc_id : "HGNC:6371",
      havana_gene : "OTTHUMG00000150347.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186266189,
      stop : 186289681,
      direction : "+",
      ID : "ENSG00000088926.14",
      gene_id : "ENSG00000088926.14",
      gene_type : "protein_coding",
      gene_name : "F11",
      gene_level : 1,
      hgnc_id : "HGNC:3529",
      havana_gene : "OTTHUMG00000150311.8",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186426546,
      stop : 186555328,
      direction : "-",
      ID : "ENSG00000272297.2",
      gene_id : "ENSG00000272297.2",
      gene_type : "protein_coding",
      gene_name : "AC018709.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160316.3",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186533655,
      stop : 186555567,
      direction : "-",
      ID : "ENSG00000168412.6",
      gene_id : "ENSG00000168412.6",
      gene_type : "protein_coding",
      gene_name : "MTNR1A",
      gene_level : 2,
      hgnc_id : "HGNC:7463",
      havana_gene : "OTTHUMG00000185575.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 186587794,
      stop : 186726722,
      direction : "-",
      ID : "ENSG00000083857.14",
      gene_id : "ENSG00000083857.14",
      gene_type : "protein_coding",
      gene_name : "FAT1",
      gene_level : 1,
      hgnc_id : "HGNC:3595",
      havana_gene : "OTTHUMG00000160320.10",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 187995771,
      stop : 188005046,
      direction : "+",
      ID : "ENSG00000179059.10",
      gene_id : "ENSG00000179059.10",
      gene_type : "protein_coding",
      gene_name : "ZFP42",
      gene_level : 2,
      hgnc_id : "HGNC:30949",
      havana_gene : "OTTHUMG00000160235.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 188091273,
      stop : 188109603,
      direction : "-",
      ID : "ENSG00000179046.8",
      gene_id : "ENSG00000179046.8",
      gene_type : "protein_coding",
      gene_name : "TRIML2",
      gene_level : 1,
      hgnc_id : "HGNC:26378",
      havana_gene : "OTTHUMG00000160225.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 188139441,
      stop : 188147743,
      direction : "+",
      ID : "ENSG00000184108.8",
      gene_id : "ENSG00000184108.8",
      gene_type : "protein_coding",
      gene_name : "TRIML1",
      gene_level : 2,
      hgnc_id : "HGNC:26698",
      havana_gene : "OTTHUMG00000160237.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 189940870,
      stop : 189963202,
      direction : "+",
      ID : "ENSG00000109536.12",
      gene_id : "ENSG00000109536.12",
      gene_type : "protein_coding",
      gene_name : "FRG1",
      gene_level : 1,
      hgnc_id : "HGNC:3954",
      havana_gene : "OTTHUMG00000160202.25",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 190024367,
      stop : 190027257,
      direction : "-",
      ID : "ENSG00000205097.7",
      gene_id : "ENSG00000205097.7",
      gene_type : "protein_coding",
      gene_name : "FRG2",
      gene_level : 2,
      hgnc_id : "HGNC:19136",
      havana_gene : "OTTHUMG00000160339.2",
      tag : null
    },
    {
      chromosome : 4,
      annotation : "HAVANA",
      type : "gene",
      start : 190173774,
      stop : 190185942,
      direction : "+",
      ID : "ENSG00000260596.5",
      gene_id : "ENSG00000260596.5",
      gene_type : "protein_coding",
      gene_name : "DUX4",
      gene_level : 2,
      hgnc_id : "HGNC:50800",
      havana_gene : "OTTHUMG00000175568.1",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 92151,
      stop : 189972,
      direction : "+",
      ID : "ENSG00000153404.14",
      gene_id : "ENSG00000153404.14",
      gene_type : "protein_coding",
      gene_name : "PLEKHG4B",
      gene_level : 2,
      hgnc_id : "HGNC:29399",
      havana_gene : "OTTHUMG00000161570.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 191495,
      stop : 196334,
      direction : "+",
      ID : "ENSG00000185028.4",
      gene_id : "ENSG00000185028.4",
      gene_type : "protein_coding",
      gene_name : "LRRC14B",
      gene_level : 1,
      hgnc_id : "HGNC:37268",
      havana_gene : "OTTHUMG00000161578.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 196868,
      stop : 218153,
      direction : "-",
      ID : "ENSG00000164366.4",
      gene_id : "ENSG00000164366.4",
      gene_type : "protein_coding",
      gene_name : "CCDC127",
      gene_level : 2,
      hgnc_id : "HGNC:30520",
      havana_gene : "OTTHUMG00000161586.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 218241,
      stop : 257082,
      direction : "+",
      ID : "ENSG00000073578.17",
      gene_id : "ENSG00000073578.17",
      gene_type : "protein_coding",
      gene_name : "SDHA",
      gene_level : 1,
      hgnc_id : "HGNC:10680",
      havana_gene : "OTTHUMG00000090275.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 218298,
      stop : 314955,
      direction : "+",
      ID : "ENSG00000286001.1",
      gene_id : "ENSG00000286001.1",
      gene_type : "protein_coding",
      gene_name : "AC021087.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193457.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 271621,
      stop : 314974,
      direction : "+",
      ID : "ENSG00000249915.8",
      gene_id : "ENSG00000249915.8",
      gene_type : "protein_coding",
      gene_name : "PDCD6",
      gene_level : 1,
      hgnc_id : "HGNC:8765",
      havana_gene : "OTTHUMG00000090283.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 271670,
      stop : 438291,
      direction : "+",
      ID : "ENSG00000288622.1",
      gene_id : "ENSG00000288622.1",
      gene_type : "protein_coding",
      gene_name : "PDCD6-AHRR",
      gene_level : 2,
      hgnc_id : "HGNC:54724",
      havana_gene : "",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 321759,
      stop : 438291,
      direction : "+",
      ID : "ENSG00000063438.19",
      gene_id : "ENSG00000063438.19",
      gene_type : "protein_coding",
      gene_name : "AHRR",
      gene_level : 1,
      hgnc_id : "HGNC:346",
      havana_gene : "OTTHUMG00000162171.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 443175,
      stop : 471937,
      direction : "+",
      ID : "ENSG00000180104.16",
      gene_id : "ENSG00000180104.16",
      gene_type : "protein_coding",
      gene_name : "EXOC3",
      gene_level : 1,
      hgnc_id : "HGNC:30378",
      havana_gene : "OTTHUMG00000162205.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 470456,
      stop : 524449,
      direction : "-",
      ID : "ENSG00000066230.12",
      gene_id : "ENSG00000066230.12",
      gene_type : "protein_coding",
      gene_name : "SLC9A3",
      gene_level : 2,
      hgnc_id : "HGNC:11073",
      havana_gene : "OTTHUMG00000090315.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 612340,
      stop : 667168,
      direction : "+",
      ID : "ENSG00000112877.8",
      gene_id : "ENSG00000112877.8",
      gene_type : "protein_coding",
      gene_name : "CEP72",
      gene_level : 1,
      hgnc_id : "HGNC:25547",
      havana_gene : "OTTHUMG00000161745.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 659862,
      stop : 693352,
      direction : "-",
      ID : "ENSG00000171368.12",
      gene_id : "ENSG00000171368.12",
      gene_type : "protein_coding",
      gene_name : "TPPP",
      gene_level : 2,
      hgnc_id : "HGNC:24164",
      havana_gene : "OTTHUMG00000131011.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 710355,
      stop : 784729,
      direction : "-",
      ID : "ENSG00000206077.14",
      gene_id : "ENSG00000206077.14",
      gene_type : "protein_coding",
      gene_name : "ZDHHC11B",
      gene_level : 2,
      hgnc_id : "HGNC:32962",
      havana_gene : "OTTHUMG00000162148.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 795606,
      stop : 850986,
      direction : "-",
      ID : "ENSG00000188818.12",
      gene_id : "ENSG00000188818.12",
      gene_type : "protein_coding",
      gene_name : "ZDHHC11",
      gene_level : 2,
      hgnc_id : "HGNC:19158",
      havana_gene : "OTTHUMG00000090319.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 850291,
      stop : 892801,
      direction : "-",
      ID : "ENSG00000028310.18",
      gene_id : "ENSG00000028310.18",
      gene_type : "protein_coding",
      gene_name : "BRD9",
      gene_level : 2,
      hgnc_id : "HGNC:25818",
      havana_gene : "OTTHUMG00000159258.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 892884,
      stop : 919357,
      direction : "+",
      ID : "ENSG00000071539.14",
      gene_id : "ENSG00000071539.14",
      gene_type : "protein_coding",
      gene_name : "TRIP13",
      gene_level : 1,
      hgnc_id : "HGNC:12307",
      havana_gene : "OTTHUMG00000090349.28",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1008802,
      stop : 1038943,
      direction : "+",
      ID : "ENSG00000145506.14",
      gene_id : "ENSG00000145506.14",
      gene_type : "protein_coding",
      gene_name : "NKD2",
      gene_level : 1,
      hgnc_id : "HGNC:17046",
      havana_gene : "OTTHUMG00000090348.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1050384,
      stop : 1112063,
      direction : "-",
      ID : "ENSG00000113504.21",
      gene_id : "ENSG00000113504.21",
      gene_type : "protein_coding",
      gene_name : "SLC12A7",
      gene_level : 2,
      hgnc_id : "HGNC:10915",
      havana_gene : "OTTHUMG00000161931.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1201595,
      stop : 1225111,
      direction : "+",
      ID : "ENSG00000174358.16",
      gene_id : "ENSG00000174358.16",
      gene_type : "protein_coding",
      gene_name : "SLC6A19",
      gene_level : 2,
      hgnc_id : "HGNC:27960",
      havana_gene : "OTTHUMG00000161636.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1225381,
      stop : 1246189,
      direction : "+",
      ID : "ENSG00000164363.10",
      gene_id : "ENSG00000164363.10",
      gene_type : "protein_coding",
      gene_name : "SLC6A18",
      gene_level : 2,
      hgnc_id : "HGNC:26441",
      havana_gene : "OTTHUMG00000090356.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1253147,
      stop : 1295068,
      direction : "-",
      ID : "ENSG00000164362.21",
      gene_id : "ENSG00000164362.21",
      gene_type : "protein_coding",
      gene_name : "TERT",
      gene_level : 2,
      hgnc_id : "HGNC:11730",
      havana_gene : "OTTHUMG00000090357.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1317752,
      stop : 1345099,
      direction : "-",
      ID : "ENSG00000049656.14",
      gene_id : "ENSG00000049656.14",
      gene_type : "protein_coding",
      gene_name : "CLPTM1L",
      gene_level : 2,
      hgnc_id : "HGNC:24308",
      havana_gene : "OTTHUMG00000131015.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1392794,
      stop : 1445440,
      direction : "-",
      ID : "ENSG00000142319.18",
      gene_id : "ENSG00000142319.18",
      gene_type : "protein_coding",
      gene_name : "SLC6A3",
      gene_level : 2,
      hgnc_id : "HGNC:11049",
      havana_gene : "OTTHUMG00000131016.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1456480,
      stop : 1523962,
      direction : "-",
      ID : "ENSG00000153395.10",
      gene_id : "ENSG00000153395.10",
      gene_type : "protein_coding",
      gene_name : "LPCAT1",
      gene_level : 2,
      hgnc_id : "HGNC:25718",
      havana_gene : "OTTHUMG00000131017.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1798385,
      stop : 1801366,
      direction : "-",
      ID : "ENSG00000171421.13",
      gene_id : "ENSG00000171421.13",
      gene_type : "protein_coding",
      gene_name : "MRPL36",
      gene_level : 2,
      hgnc_id : "HGNC:14490",
      havana_gene : "OTTHUMG00000090373.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1801407,
      stop : 1816048,
      direction : "+",
      ID : "ENSG00000145494.12",
      gene_id : "ENSG00000145494.12",
      gene_type : "protein_coding",
      gene_name : "NDUFS6",
      gene_level : 2,
      hgnc_id : "HGNC:7713",
      havana_gene : "OTTHUMG00000090372.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 1877413,
      stop : 1887236,
      direction : "-",
      ID : "ENSG00000113430.10",
      gene_id : "ENSG00000113430.10",
      gene_type : "protein_coding",
      gene_name : "IRX4",
      gene_level : 1,
      hgnc_id : "HGNC:6129",
      havana_gene : "OTTHUMG00000090411.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 2745845,
      stop : 2751677,
      direction : "-",
      ID : "ENSG00000170561.13",
      gene_id : "ENSG00000170561.13",
      gene_type : "protein_coding",
      gene_name : "IRX2",
      gene_level : 1,
      hgnc_id : "HGNC:14359",
      havana_gene : "OTTHUMG00000090377.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 3595832,
      stop : 3601403,
      direction : "+",
      ID : "ENSG00000170549.4",
      gene_id : "ENSG00000170549.4",
      gene_type : "protein_coding",
      gene_name : "IRX1",
      gene_level : 2,
      hgnc_id : "HGNC:14358",
      havana_gene : "OTTHUMG00000161632.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 5140330,
      stop : 5320304,
      direction : "+",
      ID : "ENSG00000145536.15",
      gene_id : "ENSG00000145536.15",
      gene_type : "protein_coding",
      gene_name : "ADAMTS16",
      gene_level : 2,
      hgnc_id : "HGNC:17108",
      havana_gene : "OTTHUMG00000161663.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 5420664,
      stop : 5490220,
      direction : "+",
      ID : "ENSG00000164151.12",
      gene_id : "ENSG00000164151.12",
      gene_type : "protein_coding",
      gene_name : "ICE1",
      gene_level : 2,
      hgnc_id : "HGNC:29154",
      havana_gene : "OTTHUMG00000161639.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 6371874,
      stop : 6378571,
      direction : "-",
      ID : "ENSG00000133398.4",
      gene_id : "ENSG00000133398.4",
      gene_type : "protein_coding",
      gene_name : "MED10",
      gene_level : 2,
      hgnc_id : "HGNC:28760",
      havana_gene : "OTTHUMG00000161682.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 6448859,
      stop : 6496723,
      direction : "+",
      ID : "ENSG00000215218.4",
      gene_id : "ENSG00000215218.4",
      gene_type : "protein_coding",
      gene_name : "UBE2QL1",
      gene_level : 2,
      hgnc_id : "HGNC:37269",
      havana_gene : "OTTHUMG00000161683.2",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 6599239,
      stop : 6633291,
      direction : "-",
      ID : "ENSG00000037474.15",
      gene_id : "ENSG00000037474.15",
      gene_type : "protein_coding",
      gene_name : "NSUN2",
      gene_level : 1,
      hgnc_id : "HGNC:25994",
      havana_gene : "OTTHUMG00000090455.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 6633427,
      stop : 6674386,
      direction : "+",
      ID : "ENSG00000145545.12",
      gene_id : "ENSG00000145545.12",
      gene_type : "protein_coding",
      gene_name : "SRD5A1",
      gene_level : 2,
      hgnc_id : "HGNC:11284",
      havana_gene : "OTTHUMG00000090456.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 6713432,
      stop : 6757044,
      direction : "+",
      ID : "ENSG00000112941.14",
      gene_id : "ENSG00000112941.14",
      gene_type : "protein_coding",
      gene_name : "TENT4A",
      gene_level : 2,
      hgnc_id : "HGNC:16705",
      havana_gene : "OTTHUMG00000090457.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 7396138,
      stop : 7830081,
      direction : "+",
      ID : "ENSG00000078295.17",
      gene_id : "ENSG00000078295.17",
      gene_type : "protein_coding",
      gene_name : "ADCY2",
      gene_level : 2,
      hgnc_id : "HGNC:233",
      havana_gene : "OTTHUMG00000090476.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 7830378,
      stop : 7851151,
      direction : "-",
      ID : "ENSG00000215217.7",
      gene_id : "ENSG00000215217.7",
      gene_type : "protein_coding",
      gene_name : "C5orf49",
      gene_level : 1,
      hgnc_id : "HGNC:27028",
      havana_gene : "OTTHUMG00000161897.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 7851186,
      stop : 7906025,
      direction : "+",
      ID : "ENSG00000124275.15",
      gene_id : "ENSG00000124275.15",
      gene_type : "protein_coding",
      gene_name : "MTRR",
      gene_level : 1,
      hgnc_id : "HGNC:7473",
      havana_gene : "OTTHUMG00000090477.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 7859159,
      stop : 7869037,
      direction : "-",
      ID : "ENSG00000124279.12",
      gene_id : "ENSG00000124279.12",
      gene_type : "protein_coding",
      gene_name : "FASTKD3",
      gene_level : 2,
      hgnc_id : "HGNC:28758",
      havana_gene : "OTTHUMG00000131029.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 9035033,
      stop : 9546075,
      direction : "-",
      ID : "ENSG00000112902.12",
      gene_id : "ENSG00000112902.12",
      gene_type : "protein_coding",
      gene_name : "SEMA5A",
      gene_level : 2,
      hgnc_id : "HGNC:10736",
      havana_gene : "OTTHUMG00000090501.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 9627347,
      stop : 9712378,
      direction : "-",
      ID : "ENSG00000169777.7",
      gene_id : "ENSG00000169777.7",
      gene_type : "protein_coding",
      gene_name : "TAS2R1",
      gene_level : 2,
      hgnc_id : "HGNC:14909",
      havana_gene : "OTTHUMG00000090500.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10225507,
      stop : 10249897,
      direction : "-",
      ID : "ENSG00000150756.14",
      gene_id : "ENSG00000150756.14",
      gene_type : "protein_coding",
      gene_name : "ATPSCKMT",
      gene_level : 2,
      hgnc_id : "HGNC:27029",
      havana_gene : "OTTHUMG00000161771.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10249929,
      stop : 10266389,
      direction : "+",
      ID : "ENSG00000150753.12",
      gene_id : "ENSG00000150753.12",
      gene_type : "protein_coding",
      gene_name : "CCT5",
      gene_level : 2,
      hgnc_id : "HGNC:1618",
      havana_gene : "OTTHUMG00000131042.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10275875,
      stop : 10307902,
      direction : "-",
      ID : "ENSG00000164237.9",
      gene_id : "ENSG00000164237.9",
      gene_type : "protein_coding",
      gene_name : "CMBL",
      gene_level : 2,
      hgnc_id : "HGNC:25090",
      havana_gene : "OTTHUMG00000131043.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10353695,
      stop : 10440388,
      direction : "+",
      ID : "ENSG00000145495.16",
      gene_id : "ENSG00000145495.16",
      gene_type : "protein_coding",
      gene_name : "MARCHF6",
      gene_level : 2,
      hgnc_id : "HGNC:30550",
      havana_gene : "OTTHUMG00000162027.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10441524,
      stop : 10472029,
      direction : "+",
      ID : "ENSG00000145491.12",
      gene_id : "ENSG00000145491.12",
      gene_type : "protein_coding",
      gene_name : "ROPN1L",
      gene_level : 2,
      hgnc_id : "HGNC:24060",
      havana_gene : "OTTHUMG00000090507.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10564070,
      stop : 10657816,
      direction : "+",
      ID : "ENSG00000164236.12",
      gene_id : "ENSG00000164236.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD33B",
      gene_level : 1,
      hgnc_id : "HGNC:35240",
      havana_gene : "OTTHUMG00000162050.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10679230,
      stop : 10761234,
      direction : "-",
      ID : "ENSG00000112977.16",
      gene_id : "ENSG00000112977.16",
      gene_type : "protein_coding",
      gene_name : "DAP",
      gene_level : 1,
      hgnc_id : "HGNC:2672",
      havana_gene : "OTTHUMG00000131041.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 10971836,
      stop : 11904446,
      direction : "-",
      ID : "ENSG00000169862.19",
      gene_id : "ENSG00000169862.19",
      gene_type : "protein_coding",
      gene_name : "CTNND2",
      gene_level : 2,
      hgnc_id : "HGNC:2516",
      havana_gene : "OTTHUMG00000090511.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 13690328,
      stop : 14011818,
      direction : "-",
      ID : "ENSG00000039139.10",
      gene_id : "ENSG00000039139.10",
      gene_type : "protein_coding",
      gene_name : "DNAH5",
      gene_level : 2,
      hgnc_id : "HGNC:2950",
      havana_gene : "OTTHUMG00000090533.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 14143342,
      stop : 14532128,
      direction : "+",
      ID : "ENSG00000038382.20",
      gene_id : "ENSG00000038382.20",
      gene_type : "protein_coding",
      gene_name : "TRIO",
      gene_level : 1,
      hgnc_id : "HGNC:12303",
      havana_gene : "OTTHUMG00000131057.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 14581792,
      stop : 14616180,
      direction : "+",
      ID : "ENSG00000145569.6",
      gene_id : "ENSG00000145569.6",
      gene_type : "protein_coding",
      gene_name : "OTULINL",
      gene_level : 1,
      hgnc_id : "HGNC:25629",
      havana_gene : "OTTHUMG00000131056.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 14664664,
      stop : 14699850,
      direction : "+",
      ID : "ENSG00000154124.5",
      gene_id : "ENSG00000154124.5",
      gene_type : "protein_coding",
      gene_name : "OTULIN",
      gene_level : 2,
      hgnc_id : "HGNC:25118",
      havana_gene : "OTTHUMG00000161762.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 14704800,
      stop : 14871778,
      direction : "-",
      ID : "ENSG00000154122.14",
      gene_id : "ENSG00000154122.14",
      gene_type : "protein_coding",
      gene_name : "ANKH",
      gene_level : 2,
      hgnc_id : "HGNC:15492",
      havana_gene : "OTTHUMG00000090539.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 15500180,
      stop : 15939795,
      direction : "+",
      ID : "ENSG00000183580.10",
      gene_id : "ENSG00000183580.10",
      gene_type : "protein_coding",
      gene_name : "FBXL7",
      gene_level : 2,
      hgnc_id : "HGNC:13604",
      havana_gene : "OTTHUMG00000161798.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 16067139,
      stop : 16180762,
      direction : "-",
      ID : "ENSG00000183654.9",
      gene_id : "ENSG00000183654.9",
      gene_type : "protein_coding",
      gene_name : "MARCHF11",
      gene_level : 1,
      hgnc_id : "HGNC:33609",
      havana_gene : "OTTHUMG00000161789.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 16451519,
      stop : 16465800,
      direction : "-",
      ID : "ENSG00000173545.5",
      gene_id : "ENSG00000173545.5",
      gene_type : "protein_coding",
      gene_name : "ZNF622",
      gene_level : 2,
      hgnc_id : "HGNC:30958",
      havana_gene : "OTTHUMG00000090567.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 16473038,
      stop : 16617038,
      direction : "-",
      ID : "ENSG00000154153.14",
      gene_id : "ENSG00000154153.14",
      gene_type : "protein_coding",
      gene_name : "RETREG1",
      gene_level : 2,
      hgnc_id : "HGNC:25964",
      havana_gene : "OTTHUMG00000161788.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 16661907,
      stop : 16936288,
      direction : "-",
      ID : "ENSG00000145555.15",
      gene_id : "ENSG00000145555.15",
      gene_type : "protein_coding",
      gene_name : "MYO10",
      gene_level : 1,
      hgnc_id : "HGNC:7593",
      havana_gene : "OTTHUMG00000161822.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17065598,
      stop : 17276843,
      direction : "+",
      ID : "ENSG00000176788.9",
      gene_id : "ENSG00000176788.9",
      gene_type : "protein_coding",
      gene_name : "BASP1",
      gene_level : 2,
      hgnc_id : "HGNC:957",
      havana_gene : "OTTHUMG00000131061.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17444010,
      stop : 17486829,
      direction : "+",
      ID : "ENSG00000249662.6",
      gene_id : "ENSG00000249662.6",
      gene_type : "protein_coding",
      gene_name : "LINC02218",
      gene_level : 2,
      hgnc_id : "HGNC:53085",
      havana_gene : "OTTHUMG00000161868.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17490967,
      stop : 17492076,
      direction : "-",
      ID : "ENSG00000268799.4",
      gene_id : "ENSG00000268799.4",
      gene_type : "protein_coding",
      gene_name : "H3Y2",
      gene_level : 2,
      hgnc_id : "HGNC:43734",
      havana_gene : "OTTHUMG00000193380.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17498231,
      stop : 17498827,
      direction : "+",
      ID : "ENSG00000284373.1",
      gene_id : "ENSG00000284373.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L2",
      gene_level : 2,
      hgnc_id : "HGNC:53845",
      havana_gene : "OTTHUMG00000161862.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17518367,
      stop : 17518963,
      direction : "+",
      ID : "ENSG00000284439.1",
      gene_id : "ENSG00000284439.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L3",
      gene_level : 2,
      hgnc_id : "HGNC:53846",
      havana_gene : "OTTHUMG00000161861.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17521801,
      stop : 17522397,
      direction : "+",
      ID : "ENSG00000284283.1",
      gene_id : "ENSG00000284283.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L4",
      gene_level : 2,
      hgnc_id : "HGNC:53847",
      havana_gene : "OTTHUMG00000161863.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17525235,
      stop : 17525831,
      direction : "+",
      ID : "ENSG00000284234.1",
      gene_id : "ENSG00000284234.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L5",
      gene_level : 2,
      hgnc_id : "HGNC:53848",
      havana_gene : "OTTHUMG00000161865.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17528669,
      stop : 17529265,
      direction : "+",
      ID : "ENSG00000284042.1",
      gene_id : "ENSG00000284042.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L6",
      gene_level : 2,
      hgnc_id : "HGNC:53849",
      havana_gene : "OTTHUMG00000161864.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17585162,
      stop : 17585758,
      direction : "-",
      ID : "ENSG00000284465.1",
      gene_id : "ENSG00000284465.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L7",
      gene_level : 2,
      hgnc_id : "HGNC:53850",
      havana_gene : "OTTHUMG00000161858.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17590364,
      stop : 17590960,
      direction : "-",
      ID : "ENSG00000283967.1",
      gene_id : "ENSG00000283967.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L8",
      gene_level : 2,
      hgnc_id : "HGNC:53851",
      havana_gene : "OTTHUMG00000161852.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17593798,
      stop : 17594394,
      direction : "-",
      ID : "ENSG00000283988.1",
      gene_id : "ENSG00000283988.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L9",
      gene_level : 2,
      hgnc_id : "HGNC:53852",
      havana_gene : "OTTHUMG00000161854.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17597232,
      stop : 17597828,
      direction : "-",
      ID : "ENSG00000284356.1",
      gene_id : "ENSG00000284356.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L10",
      gene_level : 2,
      hgnc_id : "HGNC:53853",
      havana_gene : "OTTHUMG00000161857.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17604177,
      stop : 17605377,
      direction : "+",
      ID : "ENSG00000283740.1",
      gene_id : "ENSG00000283740.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L11",
      gene_level : 2,
      hgnc_id : "HGNC:53854",
      havana_gene : "OTTHUMG00000191925.1",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17610496,
      stop : 17611583,
      direction : "+",
      ID : "ENSG00000249156.2",
      gene_id : "ENSG00000249156.2",
      gene_type : "protein_coding",
      gene_name : "TAF11L12",
      gene_level : 2,
      hgnc_id : "HGNC:53855",
      havana_gene : "OTTHUMG00000161851.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17632088,
      stop : 17632684,
      direction : "+",
      ID : "ENSG00000283776.1",
      gene_id : "ENSG00000283776.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L13",
      gene_level : 2,
      hgnc_id : "HGNC:53856",
      havana_gene : "OTTHUMG00000161847.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17634460,
      stop : 17635053,
      direction : "+",
      ID : "ENSG00000250782.1",
      gene_id : "ENSG00000250782.1",
      gene_type : "protein_coding",
      gene_name : "TAF11L14",
      gene_level : 2,
      hgnc_id : "HGNC:53857",
      havana_gene : "OTTHUMG00000161848.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 17654868,
      stop : 17655849,
      direction : "-",
      ID : "ENSG00000269466.4",
      gene_id : "ENSG00000269466.4",
      gene_type : "protein_coding",
      gene_name : "H3Y1",
      gene_level : 2,
      hgnc_id : "HGNC:43735",
      havana_gene : "OTTHUMG00000193381.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 19471296,
      stop : 20575873,
      direction : "-",
      ID : "ENSG00000145526.12",
      gene_id : "ENSG00000145526.12",
      gene_type : "protein_coding",
      gene_name : "CDH18",
      gene_level : 1,
      hgnc_id : "HGNC:1757",
      havana_gene : "OTTHUMG00000090578.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 21750673,
      stop : 22853344,
      direction : "-",
      ID : "ENSG00000154162.15",
      gene_id : "ENSG00000154162.15",
      gene_type : "protein_coding",
      gene_name : "CDH12",
      gene_level : 2,
      hgnc_id : "HGNC:1751",
      havana_gene : "OTTHUMG00000090591.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 23443586,
      stop : 23528093,
      direction : "+",
      ID : "ENSG00000164256.11",
      gene_id : "ENSG00000164256.11",
      gene_type : "protein_coding",
      gene_name : "PRDM9",
      gene_level : 2,
      hgnc_id : "HGNC:13994",
      havana_gene : "OTTHUMG00000161918.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 24487100,
      stop : 24644978,
      direction : "-",
      ID : "ENSG00000040731.10",
      gene_id : "ENSG00000040731.10",
      gene_type : "protein_coding",
      gene_name : "CDH10",
      gene_level : 2,
      hgnc_id : "HGNC:1749",
      havana_gene : "OTTHUMG00000090667.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 26880597,
      stop : 27121150,
      direction : "-",
      ID : "ENSG00000113100.10",
      gene_id : "ENSG00000113100.10",
      gene_type : "protein_coding",
      gene_name : "CDH9",
      gene_level : 2,
      hgnc_id : "HGNC:1768",
      havana_gene : "OTTHUMG00000090671.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 31193686,
      stop : 31329146,
      direction : "+",
      ID : "ENSG00000113361.13",
      gene_id : "ENSG00000113361.13",
      gene_type : "protein_coding",
      gene_name : "CDH6",
      gene_level : 2,
      hgnc_id : "HGNC:1765",
      havana_gene : "OTTHUMG00000090673.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 31400494,
      stop : 31532196,
      direction : "-",
      ID : "ENSG00000113360.17",
      gene_id : "ENSG00000113360.17",
      gene_type : "protein_coding",
      gene_name : "DROSHA",
      gene_level : 1,
      hgnc_id : "HGNC:17904",
      havana_gene : "OTTHUMG00000161976.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 31532287,
      stop : 31555053,
      direction : "+",
      ID : "ENSG00000082213.18",
      gene_id : "ENSG00000082213.18",
      gene_type : "protein_coding",
      gene_name : "C5orf22",
      gene_level : 1,
      hgnc_id : "HGNC:25639",
      havana_gene : "OTTHUMG00000131067.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 31639131,
      stop : 32110932,
      direction : "+",
      ID : "ENSG00000133401.16",
      gene_id : "ENSG00000133401.16",
      gene_type : "protein_coding",
      gene_name : "PDZD2",
      gene_level : 2,
      hgnc_id : "HGNC:18486",
      havana_gene : "OTTHUMG00000161981.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 32124716,
      stop : 32174319,
      direction : "-",
      ID : "ENSG00000113384.14",
      gene_id : "ENSG00000113384.14",
      gene_type : "protein_coding",
      gene_name : "GOLPH3",
      gene_level : 2,
      hgnc_id : "HGNC:15452",
      havana_gene : "OTTHUMG00000090679.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 32226994,
      stop : 32312987,
      direction : "-",
      ID : "ENSG00000150712.11",
      gene_id : "ENSG00000150712.11",
      gene_type : "protein_coding",
      gene_name : "MTMR12",
      gene_level : 2,
      hgnc_id : "HGNC:18191",
      havana_gene : "OTTHUMG00000161978.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 32354350,
      stop : 32444740,
      direction : "-",
      ID : "ENSG00000056097.16",
      gene_id : "ENSG00000056097.16",
      gene_type : "protein_coding",
      gene_name : "ZFR",
      gene_level : 2,
      hgnc_id : "HGNC:17277",
      havana_gene : "OTTHUMG00000161979.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 32531633,
      stop : 32604079,
      direction : "+",
      ID : "ENSG00000113387.12",
      gene_id : "ENSG00000113387.12",
      gene_type : "protein_coding",
      gene_name : "SUB1",
      gene_level : 2,
      hgnc_id : "HGNC:19985",
      havana_gene : "OTTHUMG00000131071.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 32689070,
      stop : 32791724,
      direction : "+",
      ID : "ENSG00000113389.16",
      gene_id : "ENSG00000113389.16",
      gene_type : "protein_coding",
      gene_name : "NPR3",
      gene_level : 1,
      hgnc_id : "HGNC:7945",
      havana_gene : "OTTHUMG00000150316.10",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 33440696,
      stop : 33468091,
      direction : "+",
      ID : "ENSG00000113407.14",
      gene_id : "ENSG00000113407.14",
      gene_type : "protein_coding",
      gene_name : "TARS1",
      gene_level : 1,
      hgnc_id : "HGNC:11572",
      havana_gene : "OTTHUMG00000090683.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 33523535,
      stop : 33892019,
      direction : "-",
      ID : "ENSG00000151388.11",
      gene_id : "ENSG00000151388.11",
      gene_type : "protein_coding",
      gene_name : "ADAMTS12",
      gene_level : 2,
      hgnc_id : "HGNC:14605",
      havana_gene : "OTTHUMG00000162088.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 33936386,
      stop : 33938918,
      direction : "+",
      ID : "ENSG00000182631.7",
      gene_id : "ENSG00000182631.7",
      gene_type : "protein_coding",
      gene_name : "RXFP3",
      gene_level : 2,
      hgnc_id : "HGNC:24883",
      havana_gene : "OTTHUMG00000090685.2",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 33944623,
      stop : 33984693,
      direction : "-",
      ID : "ENSG00000164175.15",
      gene_id : "ENSG00000164175.15",
      gene_type : "protein_coding",
      gene_name : "SLC45A2",
      gene_level : 2,
      hgnc_id : "HGNC:16472",
      havana_gene : "OTTHUMG00000090719.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 33986165,
      stop : 34008104,
      direction : "-",
      ID : "ENSG00000242110.8",
      gene_id : "ENSG00000242110.8",
      gene_type : "protein_coding",
      gene_name : "AMACR",
      gene_level : 1,
      hgnc_id : "HGNC:451",
      havana_gene : "OTTHUMG00000090734.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 33987174,
      stop : 34124528,
      direction : "-",
      ID : "ENSG00000273294.1",
      gene_id : "ENSG00000273294.1",
      gene_type : "protein_coding",
      gene_name : "C1QTNF3-AMACR",
      gene_level : 2,
      hgnc_id : "HGNC:49198",
      havana_gene : "OTTHUMG00000186337.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34017858,
      stop : 34043213,
      direction : "-",
      ID : "ENSG00000082196.21",
      gene_id : "ENSG00000082196.21",
      gene_type : "protein_coding",
      gene_name : "C1QTNF3",
      gene_level : 2,
      hgnc_id : "HGNC:14326",
      havana_gene : "OTTHUMG00000090735.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34656328,
      stop : 34832612,
      direction : "+",
      ID : "ENSG00000039560.14",
      gene_id : "ENSG00000039560.14",
      gene_type : "protein_coding",
      gene_name : "RAI14",
      gene_level : 2,
      hgnc_id : "HGNC:14873",
      havana_gene : "OTTHUMG00000162019.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34838833,
      stop : 34899456,
      direction : "+",
      ID : "ENSG00000205838.14",
      gene_id : "ENSG00000205838.14",
      gene_type : "protein_coding",
      gene_name : "TTC23L",
      gene_level : 2,
      hgnc_id : "HGNC:26355",
      havana_gene : "OTTHUMG00000162020.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34905260,
      stop : 34918989,
      direction : "-",
      ID : "ENSG00000113456.19",
      gene_id : "ENSG00000113456.19",
      gene_type : "protein_coding",
      gene_name : "RAD1",
      gene_level : 2,
      hgnc_id : "HGNC:9806",
      havana_gene : "OTTHUMG00000090783.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34915677,
      stop : 34925996,
      direction : "+",
      ID : "ENSG00000113460.13",
      gene_id : "ENSG00000113460.13",
      gene_type : "protein_coding",
      gene_name : "BRIX1",
      gene_level : 2,
      hgnc_id : "HGNC:24170",
      havana_gene : "OTTHUMG00000162021.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34929559,
      stop : 34958964,
      direction : "+",
      ID : "ENSG00000168724.17",
      gene_id : "ENSG00000168724.17",
      gene_type : "protein_coding",
      gene_name : "DNAJC21",
      gene_level : 2,
      hgnc_id : "HGNC:27030",
      havana_gene : "OTTHUMG00000074103.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 34998101,
      stop : 35048135,
      direction : "-",
      ID : "ENSG00000113492.14",
      gene_id : "ENSG00000113492.14",
      gene_type : "protein_coding",
      gene_name : "AGXT2",
      gene_level : 2,
      hgnc_id : "HGNC:14412",
      havana_gene : "OTTHUMG00000090788.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 35048756,
      stop : 35230487,
      direction : "-",
      ID : "ENSG00000113494.17",
      gene_id : "ENSG00000113494.17",
      gene_type : "protein_coding",
      gene_name : "PRLR",
      gene_level : 2,
      hgnc_id : "HGNC:9446",
      havana_gene : "OTTHUMG00000090789.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 35617844,
      stop : 35814611,
      direction : "+",
      ID : "ENSG00000152582.14",
      gene_id : "ENSG00000152582.14",
      gene_type : "protein_coding",
      gene_name : "SPEF2",
      gene_level : 1,
      hgnc_id : "HGNC:26293",
      havana_gene : "OTTHUMG00000131111.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 35852695,
      stop : 35879603,
      direction : "+",
      ID : "ENSG00000168685.15",
      gene_id : "ENSG00000168685.15",
      gene_type : "protein_coding",
      gene_name : "IL7R",
      gene_level : 1,
      hgnc_id : "HGNC:6024",
      havana_gene : "OTTHUMG00000090791.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 35904288,
      stop : 35938779,
      direction : "-",
      ID : "ENSG00000152611.12",
      gene_id : "ENSG00000152611.12",
      gene_type : "protein_coding",
      gene_name : "CAPSL",
      gene_level : 2,
      hgnc_id : "HGNC:28375",
      havana_gene : "OTTHUMG00000131109.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 35951006,
      stop : 36001028,
      direction : "-",
      ID : "ENSG00000145626.12",
      gene_id : "ENSG00000145626.12",
      gene_type : "protein_coding",
      gene_name : "UGT3A1",
      gene_level : 1,
      hgnc_id : "HGNC:26625",
      havana_gene : "OTTHUMG00000131107.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36035021,
      stop : 36071358,
      direction : "-",
      ID : "ENSG00000168671.10",
      gene_id : "ENSG00000168671.10",
      gene_type : "protein_coding",
      gene_name : "UGT3A2",
      gene_level : 1,
      hgnc_id : "HGNC:27266",
      havana_gene : "OTTHUMG00000131108.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36098407,
      stop : 36151887,
      direction : "-",
      ID : "ENSG00000164187.7",
      gene_id : "ENSG00000164187.7",
      gene_type : "protein_coding",
      gene_name : "LMBRD2",
      gene_level : 2,
      hgnc_id : "HGNC:25287",
      havana_gene : "OTTHUMG00000162150.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36151989,
      stop : 36196849,
      direction : "+",
      ID : "ENSG00000145604.17",
      gene_id : "ENSG00000145604.17",
      gene_type : "protein_coding",
      gene_name : "SKP2",
      gene_level : 2,
      hgnc_id : "HGNC:10901",
      havana_gene : "OTTHUMG00000131106.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36192589,
      stop : 36242279,
      direction : "-",
      ID : "ENSG00000152620.13",
      gene_id : "ENSG00000152620.13",
      gene_type : "protein_coding",
      gene_name : "NADK2",
      gene_level : 1,
      hgnc_id : "HGNC:26404",
      havana_gene : "OTTHUMG00000131105.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36246913,
      stop : 36302114,
      direction : "-",
      ID : "ENSG00000164188.9",
      gene_id : "ENSG00000164188.9",
      gene_type : "protein_coding",
      gene_name : "RANBP3L",
      gene_level : 2,
      hgnc_id : "HGNC:26353",
      havana_gene : "OTTHUMG00000131110.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36596588,
      stop : 36688334,
      direction : "+",
      ID : "ENSG00000079215.15",
      gene_id : "ENSG00000079215.15",
      gene_type : "protein_coding",
      gene_name : "SLC1A3",
      gene_level : 2,
      hgnc_id : "HGNC:10941",
      havana_gene : "OTTHUMG00000090793.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 36876769,
      stop : 37066413,
      direction : "+",
      ID : "ENSG00000164190.19",
      gene_id : "ENSG00000164190.19",
      gene_type : "protein_coding",
      gene_name : "NIPBL",
      gene_level : 1,
      hgnc_id : "HGNC:28862",
      havana_gene : "OTTHUMG00000090795.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 37106228,
      stop : 37249376,
      direction : "-",
      ID : "ENSG00000197603.16",
      gene_id : "ENSG00000197603.16",
      gene_type : "protein_coding",
      gene_name : "CPLANE1",
      gene_level : 2,
      hgnc_id : "HGNC:25801",
      havana_gene : "OTTHUMG00000160492.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 37288137,
      stop : 37371106,
      direction : "-",
      ID : "ENSG00000113569.16",
      gene_id : "ENSG00000113569.16",
      gene_type : "protein_coding",
      gene_name : "NUP155",
      gene_level : 2,
      hgnc_id : "HGNC:8063",
      havana_gene : "OTTHUMG00000090803.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 37379285,
      stop : 37753435,
      direction : "+",
      ID : "ENSG00000082068.9",
      gene_id : "ENSG00000082068.9",
      gene_type : "protein_coding",
      gene_name : "WDR70",
      gene_level : 1,
      hgnc_id : "HGNC:25495",
      havana_gene : "OTTHUMG00000162263.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 37812677,
      stop : 37840041,
      direction : "-",
      ID : "ENSG00000168621.15",
      gene_id : "ENSG00000168621.15",
      gene_type : "protein_coding",
      gene_name : "GDNF",
      gene_level : 2,
      hgnc_id : "HGNC:4232",
      havana_gene : "OTTHUMG00000090809.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 38258409,
      stop : 38465480,
      direction : "+",
      ID : "ENSG00000164318.18",
      gene_id : "ENSG00000164318.18",
      gene_type : "protein_coding",
      gene_name : "EGFLAM",
      gene_level : 2,
      hgnc_id : "HGNC:26810",
      havana_gene : "OTTHUMG00000131139.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 38474668,
      stop : 38608354,
      direction : "-",
      ID : "ENSG00000113594.10",
      gene_id : "ENSG00000113594.10",
      gene_type : "protein_coding",
      gene_name : "LIFR",
      gene_level : 2,
      hgnc_id : "HGNC:6597",
      havana_gene : "OTTHUMG00000131138.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 38845858,
      stop : 38945596,
      direction : "+",
      ID : "ENSG00000145623.13",
      gene_id : "ENSG00000145623.13",
      gene_type : "protein_coding",
      gene_name : "OSMR",
      gene_level : 1,
      hgnc_id : "HGNC:8507",
      havana_gene : "OTTHUMG00000090811.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 38937920,
      stop : 39074399,
      direction : "-",
      ID : "ENSG00000164327.13",
      gene_id : "ENSG00000164327.13",
      gene_type : "protein_coding",
      gene_name : "RICTOR",
      gene_level : 2,
      hgnc_id : "HGNC:28611",
      havana_gene : "OTTHUMG00000162037.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 39105252,
      stop : 39274528,
      direction : "-",
      ID : "ENSG00000082074.19",
      gene_id : "ENSG00000082074.19",
      gene_type : "protein_coding",
      gene_name : "FYB1",
      gene_level : 2,
      hgnc_id : "HGNC:4036",
      havana_gene : "OTTHUMG00000162071.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 39284140,
      stop : 39424868,
      direction : "-",
      ID : "ENSG00000113600.11",
      gene_id : "ENSG00000113600.11",
      gene_type : "protein_coding",
      gene_name : "C9",
      gene_level : 2,
      hgnc_id : "HGNC:1358",
      havana_gene : "OTTHUMG00000094767.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 39371675,
      stop : 39462300,
      direction : "-",
      ID : "ENSG00000153071.15",
      gene_id : "ENSG00000153071.15",
      gene_type : "protein_coding",
      gene_name : "DAB2",
      gene_level : 2,
      hgnc_id : "HGNC:2662",
      havana_gene : "OTTHUMG00000162043.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40512333,
      stop : 40755963,
      direction : "-",
      ID : "ENSG00000113638.14",
      gene_id : "ENSG00000113638.14",
      gene_type : "protein_coding",
      gene_name : "TTC33",
      gene_level : 2,
      hgnc_id : "HGNC:29959",
      havana_gene : "OTTHUMG00000131142.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40679915,
      stop : 40693735,
      direction : "+",
      ID : "ENSG00000171522.6",
      gene_id : "ENSG00000171522.6",
      gene_type : "protein_coding",
      gene_name : "PTGER4",
      gene_level : 2,
      hgnc_id : "HGNC:9596",
      havana_gene : "OTTHUMG00000094769.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40759379,
      stop : 40798374,
      direction : "-",
      ID : "ENSG00000132356.11",
      gene_id : "ENSG00000132356.11",
      gene_type : "protein_coding",
      gene_name : "PRKAA1",
      gene_level : 1,
      hgnc_id : "HGNC:9376",
      havana_gene : "OTTHUMG00000162269.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40825262,
      stop : 40835222,
      direction : "-",
      ID : "ENSG00000145592.14",
      gene_id : "ENSG00000145592.14",
      gene_type : "protein_coding",
      gene_name : "RPL37",
      gene_level : 1,
      hgnc_id : "HGNC:10347",
      havana_gene : "OTTHUMG00000094774.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40841308,
      stop : 40860175,
      direction : "+",
      ID : "ENSG00000132357.14",
      gene_id : "ENSG00000132357.14",
      gene_type : "protein_coding",
      gene_name : "CARD6",
      gene_level : 1,
      hgnc_id : "HGNC:16394",
      havana_gene : "OTTHUMG00000094775.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40909497,
      stop : 40984643,
      direction : "+",
      ID : "ENSG00000112936.19",
      gene_id : "ENSG00000112936.19",
      gene_type : "protein_coding",
      gene_name : "C7",
      gene_level : 1,
      hgnc_id : "HGNC:1346",
      havana_gene : "OTTHUMG00000150340.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 40998017,
      stop : 41071342,
      direction : "-",
      ID : "ENSG00000171495.17",
      gene_id : "ENSG00000171495.17",
      gene_type : "protein_coding",
      gene_name : "MROH2B",
      gene_level : 2,
      hgnc_id : "HGNC:26857",
      havana_gene : "OTTHUMG00000162151.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 41142116,
      stop : 41261438,
      direction : "-",
      ID : "ENSG00000039537.14",
      gene_id : "ENSG00000039537.14",
      gene_type : "protein_coding",
      gene_name : "C6",
      gene_level : 1,
      hgnc_id : "HGNC:1339",
      havana_gene : "OTTHUMG00000094781.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 41306952,
      stop : 41510628,
      direction : "-",
      ID : "ENSG00000182836.10",
      gene_id : "ENSG00000182836.10",
      gene_type : "protein_coding",
      gene_name : "PLCXD3",
      gene_level : 2,
      hgnc_id : "HGNC:31822",
      havana_gene : "OTTHUMG00000162076.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 41730065,
      stop : 41870425,
      direction : "-",
      ID : "ENSG00000083720.13",
      gene_id : "ENSG00000083720.13",
      gene_type : "protein_coding",
      gene_name : "OXCT1",
      gene_level : 2,
      hgnc_id : "HGNC:8527",
      havana_gene : "OTTHUMG00000094783.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 41904188,
      stop : 41921636,
      direction : "+",
      ID : "ENSG00000205765.9",
      gene_id : "ENSG00000205765.9",
      gene_type : "protein_coding",
      gene_name : "C5orf51",
      gene_level : 2,
      hgnc_id : "HGNC:27750",
      havana_gene : "OTTHUMG00000162084.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 41925254,
      stop : 41941743,
      direction : "+",
      ID : "ENSG00000151876.13",
      gene_id : "ENSG00000151876.13",
      gene_type : "protein_coding",
      gene_name : "FBXO4",
      gene_level : 1,
      hgnc_id : "HGNC:13583",
      havana_gene : "OTTHUMG00000094799.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 42423439,
      stop : 42721878,
      direction : "+",
      ID : "ENSG00000112964.14",
      gene_id : "ENSG00000112964.14",
      gene_type : "protein_coding",
      gene_name : "GHR",
      gene_level : 2,
      hgnc_id : "HGNC:4263",
      havana_gene : "OTTHUMG00000094791.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 42756818,
      stop : 42802439,
      direction : "+",
      ID : "ENSG00000198865.10",
      gene_id : "ENSG00000198865.10",
      gene_type : "protein_coding",
      gene_name : "CCDC152",
      gene_level : 2,
      hgnc_id : "HGNC:34438",
      havana_gene : "OTTHUMG00000162141.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 42799880,
      stop : 42887392,
      direction : "-",
      ID : "ENSG00000250722.6",
      gene_id : "ENSG00000250722.6",
      gene_type : "protein_coding",
      gene_name : "SELENOP",
      gene_level : 1,
      hgnc_id : "HGNC:10751",
      havana_gene : "OTTHUMG00000162140.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43039233,
      stop : 43043170,
      direction : "-",
      ID : "ENSG00000177721.5",
      gene_id : "ENSG00000177721.5",
      gene_type : "protein_coding",
      gene_name : "ANXA2R",
      gene_level : 2,
      hgnc_id : "HGNC:33463",
      havana_gene : "OTTHUMG00000162232.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43065176,
      stop : 43192021,
      direction : "+",
      ID : "ENSG00000172262.11",
      gene_id : "ENSG00000172262.11",
      gene_type : "protein_coding",
      gene_name : "ZNF131",
      gene_level : 1,
      hgnc_id : "HGNC:12915",
      havana_gene : "OTTHUMG00000162223.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43192071,
      stop : 43280850,
      direction : "+",
      ID : "ENSG00000177453.7",
      gene_id : "ENSG00000177453.7",
      gene_type : "protein_coding",
      gene_name : "NIM1K",
      gene_level : 2,
      hgnc_id : "HGNC:28646",
      havana_gene : "OTTHUMG00000131147.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43287470,
      stop : 43313512,
      direction : "-",
      ID : "ENSG00000112972.15",
      gene_id : "ENSG00000112972.15",
      gene_type : "protein_coding",
      gene_name : "HMGCS1",
      gene_level : 2,
      hgnc_id : "HGNC:5007",
      havana_gene : "OTTHUMG00000162231.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43376645,
      stop : 43412391,
      direction : "-",
      ID : "ENSG00000151882.11",
      gene_id : "ENSG00000151882.11",
      gene_type : "protein_coding",
      gene_name : "CCL28",
      gene_level : 1,
      hgnc_id : "HGNC:17700",
      havana_gene : "OTTHUMG00000094811.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43444252,
      stop : 43483893,
      direction : "-",
      ID : "ENSG00000151881.15",
      gene_id : "ENSG00000151881.15",
      gene_type : "protein_coding",
      gene_name : "TMEM267",
      gene_level : 2,
      hgnc_id : "HGNC:26139",
      havana_gene : "OTTHUMG00000131150.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43486709,
      stop : 43515148,
      direction : "-",
      ID : "ENSG00000172244.9",
      gene_id : "ENSG00000172244.9",
      gene_type : "protein_coding",
      gene_name : "C5orf34",
      gene_level : 2,
      hgnc_id : "HGNC:24738",
      havana_gene : "OTTHUMG00000131151.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43526267,
      stop : 43557758,
      direction : "-",
      ID : "ENSG00000172239.14",
      gene_id : "ENSG00000172239.14",
      gene_type : "protein_coding",
      gene_name : "PAIP1",
      gene_level : 2,
      hgnc_id : "HGNC:16945",
      havana_gene : "OTTHUMG00000096960.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 43602692,
      stop : 43707405,
      direction : "+",
      ID : "ENSG00000112992.18",
      gene_id : "ENSG00000112992.18",
      gene_type : "protein_coding",
      gene_name : "NNT",
      gene_level : 1,
      hgnc_id : "HGNC:7863",
      havana_gene : "OTTHUMG00000096961.14",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 44300247,
      stop : 44389706,
      direction : "-",
      ID : "ENSG00000070193.5",
      gene_id : "ENSG00000070193.5",
      gene_type : "protein_coding",
      gene_name : "FGF10",
      gene_level : 2,
      hgnc_id : "HGNC:3666",
      havana_gene : "OTTHUMG00000131153.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 44808947,
      stop : 44820428,
      direction : "+",
      ID : "ENSG00000112996.11",
      gene_id : "ENSG00000112996.11",
      gene_type : "protein_coding",
      gene_name : "MRPS30",
      gene_level : 2,
      hgnc_id : "HGNC:8769",
      havana_gene : "OTTHUMG00000096967.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 45254948,
      stop : 45696498,
      direction : "-",
      ID : "ENSG00000164588.8",
      gene_id : "ENSG00000164588.8",
      gene_type : "protein_coding",
      gene_name : "HCN1",
      gene_level : 2,
      hgnc_id : "HGNC:4845",
      havana_gene : "OTTHUMG00000131155.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 50396192,
      stop : 50443248,
      direction : "-",
      ID : "ENSG00000170571.12",
      gene_id : "ENSG00000170571.12",
      gene_type : "protein_coding",
      gene_name : "EMB",
      gene_level : 1,
      hgnc_id : "HGNC:30465",
      havana_gene : "OTTHUMG00000131161.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 50665899,
      stop : 50846519,
      direction : "+",
      ID : "ENSG00000151883.19",
      gene_id : "ENSG00000151883.19",
      gene_type : "protein_coding",
      gene_name : "PARP8",
      gene_level : 1,
      hgnc_id : "HGNC:26124",
      havana_gene : "OTTHUMG00000096969.10",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 51383448,
      stop : 51394730,
      direction : "+",
      ID : "ENSG00000016082.15",
      gene_id : "ENSG00000016082.15",
      gene_type : "protein_coding",
      gene_name : "ISL1",
      gene_level : 2,
      hgnc_id : "HGNC:6132",
      havana_gene : "OTTHUMG00000162281.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 52787916,
      stop : 52804044,
      direction : "+",
      ID : "ENSG00000152684.11",
      gene_id : "ENSG00000152684.11",
      gene_type : "protein_coding",
      gene_name : "PELO",
      gene_level : 2,
      hgnc_id : "HGNC:8829",
      havana_gene : "OTTHUMG00000096973.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 52787916,
      stop : 52959209,
      direction : "+",
      ID : "ENSG00000213949.10",
      gene_id : "ENSG00000213949.10",
      gene_type : "protein_coding",
      gene_name : "ITGA1",
      gene_level : 2,
      hgnc_id : "HGNC:6134",
      havana_gene : "OTTHUMG00000131163.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 52989340,
      stop : 53094779,
      direction : "+",
      ID : "ENSG00000164171.11",
      gene_id : "ENSG00000164171.11",
      gene_type : "protein_coding",
      gene_name : "ITGA2",
      gene_level : 2,
      hgnc_id : "HGNC:6137",
      havana_gene : "OTTHUMG00000131165.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 53095679,
      stop : 53110063,
      direction : "-",
      ID : "ENSG00000164172.20",
      gene_id : "ENSG00000164172.20",
      gene_type : "protein_coding",
      gene_name : "MOCS2",
      gene_level : 1,
      hgnc_id : "HGNC:7193",
      havana_gene : "OTTHUMG00000096981.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 53480626,
      stop : 53487134,
      direction : "+",
      ID : "ENSG00000134363.12",
      gene_id : "ENSG00000134363.12",
      gene_type : "protein_coding",
      gene_name : "FST",
      gene_level : 2,
      hgnc_id : "HGNC:3971",
      havana_gene : "OTTHUMG00000131183.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 53560633,
      stop : 53683338,
      direction : "+",
      ID : "ENSG00000164258.12",
      gene_id : "ENSG00000164258.12",
      gene_type : "protein_coding",
      gene_name : "NDUFS4",
      gene_level : 2,
      hgnc_id : "HGNC:7711",
      havana_gene : "OTTHUMG00000096987.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 53883942,
      stop : 54310582,
      direction : "-",
      ID : "ENSG00000185305.11",
      gene_id : "ENSG00000185305.11",
      gene_type : "protein_coding",
      gene_name : "ARL15",
      gene_level : 2,
      hgnc_id : "HGNC:25945",
      havana_gene : "OTTHUMG00000162287.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 54455699,
      stop : 54456377,
      direction : "+",
      ID : "ENSG00000169271.3",
      gene_id : "ENSG00000169271.3",
      gene_type : "protein_coding",
      gene_name : "HSPB3",
      gene_level : 2,
      hgnc_id : "HGNC:5248",
      havana_gene : "OTTHUMG00000096995.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 54517759,
      stop : 54546586,
      direction : "+",
      ID : "ENSG00000178996.14",
      gene_id : "ENSG00000178996.14",
      gene_type : "protein_coding",
      gene_name : "SNX18",
      gene_level : 2,
      hgnc_id : "HGNC:19245",
      havana_gene : "OTTHUMG00000096994.4",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 54977867,
      stop : 55022671,
      direction : "-",
      ID : "ENSG00000164283.13",
      gene_id : "ENSG00000164283.13",
      gene_type : "protein_coding",
      gene_name : "ESM1",
      gene_level : 2,
      hgnc_id : "HGNC:3466",
      havana_gene : "OTTHUMG00000097010.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55024256,
      stop : 55034570,
      direction : "+",
      ID : "ENSG00000113088.6",
      gene_id : "ENSG00000113088.6",
      gene_type : "protein_coding",
      gene_name : "GZMK",
      gene_level : 2,
      hgnc_id : "HGNC:4711",
      havana_gene : "OTTHUMG00000097009.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55102646,
      stop : 55110252,
      direction : "+",
      ID : "ENSG00000145649.8",
      gene_id : "ENSG00000145649.8",
      gene_type : "protein_coding",
      gene_name : "GZMA",
      gene_level : 2,
      hgnc_id : "HGNC:4708",
      havana_gene : "OTTHUMG00000097011.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55112971,
      stop : 55173177,
      direction : "-",
      ID : "ENSG00000164287.13",
      gene_id : "ENSG00000164287.13",
      gene_type : "protein_coding",
      gene_name : "CDC20B",
      gene_level : 2,
      hgnc_id : "HGNC:24222",
      havana_gene : "OTTHUMG00000131185.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55160167,
      stop : 55167297,
      direction : "+",
      ID : "ENSG00000164294.14",
      gene_id : "ENSG00000164294.14",
      gene_type : "protein_coding",
      gene_name : "GPX8",
      gene_level : 1,
      hgnc_id : "HGNC:33100",
      havana_gene : "OTTHUMG00000162601.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55219564,
      stop : 55227315,
      direction : "-",
      ID : "ENSG00000234602.9",
      gene_id : "ENSG00000234602.9",
      gene_type : "protein_coding",
      gene_name : "MCIDAS",
      gene_level : 2,
      hgnc_id : "HGNC:40050",
      havana_gene : "OTTHUMG00000162600.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55231152,
      stop : 55233608,
      direction : "-",
      ID : "ENSG00000152669.9",
      gene_id : "ENSG00000152669.9",
      gene_type : "protein_coding",
      gene_name : "CCNO",
      gene_level : 2,
      hgnc_id : "HGNC:18576",
      havana_gene : "OTTHUMG00000162598.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55256055,
      stop : 55307694,
      direction : "-",
      ID : "ENSG00000067248.10",
      gene_id : "ENSG00000067248.10",
      gene_type : "protein_coding",
      gene_name : "DHX29",
      gene_level : 2,
      hgnc_id : "HGNC:15815",
      havana_gene : "OTTHUMG00000162313.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55307989,
      stop : 55425579,
      direction : "+",
      ID : "ENSG00000039123.16",
      gene_id : "ENSG00000039123.16",
      gene_type : "protein_coding",
      gene_name : "MTREX",
      gene_level : 2,
      hgnc_id : "HGNC:18734",
      havana_gene : "OTTHUMG00000097019.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55424854,
      stop : 55534969,
      direction : "-",
      ID : "ENSG00000067113.17",
      gene_id : "ENSG00000067113.17",
      gene_type : "protein_coding",
      gene_name : "PLPP1",
      gene_level : 2,
      hgnc_id : "HGNC:9228",
      havana_gene : "OTTHUMG00000162240.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55625845,
      stop : 55773194,
      direction : "-",
      ID : "ENSG00000177058.12",
      gene_id : "ENSG00000177058.12",
      gene_type : "protein_coding",
      gene_name : "SLC38A9",
      gene_level : 1,
      hgnc_id : "HGNC:26907",
      havana_gene : "OTTHUMG00000131189.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55738017,
      stop : 55817157,
      direction : "+",
      ID : "ENSG00000152670.19",
      gene_id : "ENSG00000152670.19",
      gene_type : "protein_coding",
      gene_name : "DDX4",
      gene_level : 2,
      hgnc_id : "HGNC:18700",
      havana_gene : "OTTHUMG00000097044.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55851357,
      stop : 55922854,
      direction : "+",
      ID : "ENSG00000164509.15",
      gene_id : "ENSG00000164509.15",
      gene_type : "protein_coding",
      gene_name : "IL31RA",
      gene_level : 1,
      hgnc_id : "HGNC:18969",
      havana_gene : "OTTHUMG00000097045.12",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 55935095,
      stop : 55995022,
      direction : "-",
      ID : "ENSG00000134352.20",
      gene_id : "ENSG00000134352.20",
      gene_type : "protein_coding",
      gene_name : "IL6ST",
      gene_level : 1,
      hgnc_id : "HGNC:6021",
      havana_gene : "OTTHUMG00000097043.14",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 56099680,
      stop : 56233330,
      direction : "-",
      ID : "ENSG00000164512.18",
      gene_id : "ENSG00000164512.18",
      gene_type : "protein_coding",
      gene_name : "ANKRD55",
      gene_level : 1,
      hgnc_id : "HGNC:25681",
      havana_gene : "OTTHUMG00000162305.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 56815549,
      stop : 56896152,
      direction : "+",
      ID : "ENSG00000095015.6",
      gene_id : "ENSG00000095015.6",
      gene_type : "protein_coding",
      gene_name : "MAP3K1",
      gene_level : 1,
      hgnc_id : "HGNC:6848",
      havana_gene : "OTTHUMG00000059486.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 56909260,
      stop : 56925532,
      direction : "+",
      ID : "ENSG00000155542.12",
      gene_id : "ENSG00000155542.12",
      gene_type : "protein_coding",
      gene_name : "SETD9",
      gene_level : 1,
      hgnc_id : "HGNC:28508",
      havana_gene : "OTTHUMG00000059485.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 56919602,
      stop : 56971675,
      direction : "-",
      ID : "ENSG00000155545.20",
      gene_id : "ENSG00000155545.20",
      gene_type : "protein_coding",
      gene_name : "MIER3",
      gene_level : 1,
      hgnc_id : "HGNC:26678",
      havana_gene : "OTTHUMG00000059589.12",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 57173948,
      stop : 57264679,
      direction : "+",
      ID : "ENSG00000062194.16",
      gene_id : "ENSG00000062194.16",
      gene_type : "protein_coding",
      gene_name : "GPBP1",
      gene_level : 2,
      hgnc_id : "HGNC:29520",
      havana_gene : "OTTHUMG00000162321.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 57480018,
      stop : 57482811,
      direction : "-",
      ID : "ENSG00000169067.4",
      gene_id : "ENSG00000169067.4",
      gene_type : "protein_coding",
      gene_name : "ACTBL2",
      gene_level : 2,
      hgnc_id : "HGNC:17780",
      havana_gene : "OTTHUMG00000162330.2",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 58453982,
      stop : 58460139,
      direction : "-",
      ID : "ENSG00000145632.15",
      gene_id : "ENSG00000145632.15",
      gene_type : "protein_coding",
      gene_name : "PLK2",
      gene_level : 2,
      hgnc_id : "HGNC:19699",
      havana_gene : "OTTHUMG00000097047.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 58491435,
      stop : 58497090,
      direction : "+",
      ID : "ENSG00000175857.8",
      gene_id : "ENSG00000175857.8",
      gene_type : "protein_coding",
      gene_name : "GAPT",
      gene_level : 2,
      hgnc_id : "HGNC:26588",
      havana_gene : "OTTHUMG00000131219.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 58582221,
      stop : 58859394,
      direction : "+",
      ID : "ENSG00000152932.8",
      gene_id : "ENSG00000152932.8",
      gene_type : "protein_coding",
      gene_name : "RAB3C",
      gene_level : 2,
      hgnc_id : "HGNC:30269",
      havana_gene : "OTTHUMG00000097053.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 58969038,
      stop : 60522120,
      direction : "-",
      ID : "ENSG00000113448.19",
      gene_id : "ENSG00000113448.19",
      gene_type : "protein_coding",
      gene_name : "PDE4D",
      gene_level : 2,
      hgnc_id : "HGNC:8783",
      havana_gene : "OTTHUMG00000162218.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 60596912,
      stop : 60700190,
      direction : "-",
      ID : "ENSG00000035499.13",
      gene_id : "ENSG00000035499.13",
      gene_type : "protein_coding",
      gene_name : "DEPDC1B",
      gene_level : 2,
      hgnc_id : "HGNC:24902",
      havana_gene : "OTTHUMG00000097083.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 60751791,
      stop : 60844274,
      direction : "-",
      ID : "ENSG00000164181.14",
      gene_id : "ENSG00000164181.14",
      gene_type : "protein_coding",
      gene_name : "ELOVL7",
      gene_level : 1,
      hgnc_id : "HGNC:26292",
      havana_gene : "OTTHUMG00000162254.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 60866454,
      stop : 60945073,
      direction : "-",
      ID : "ENSG00000049167.15",
      gene_id : "ENSG00000049167.15",
      gene_type : "protein_coding",
      gene_name : "ERCC8",
      gene_level : 2,
      hgnc_id : "HGNC:3439",
      havana_gene : "OTTHUMG00000097741.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 60945177,
      stop : 61154531,
      direction : "+",
      ID : "ENSG00000164182.12",
      gene_id : "ENSG00000164182.12",
      gene_type : "protein_coding",
      gene_name : "NDUFAF2",
      gene_level : 2,
      hgnc_id : "HGNC:28086",
      havana_gene : "OTTHUMG00000131221.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 61157704,
      stop : 61162468,
      direction : "-",
      ID : "ENSG00000188725.8",
      gene_id : "ENSG00000188725.8",
      gene_type : "protein_coding",
      gene_name : "SMIM15",
      gene_level : 2,
      hgnc_id : "HGNC:33861",
      havana_gene : "OTTHUMG00000162241.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 61332258,
      stop : 61546172,
      direction : "+",
      ID : "ENSG00000130449.6",
      gene_id : "ENSG00000130449.6",
      gene_type : "protein_coding",
      gene_name : "ZSWIM6",
      gene_level : 1,
      hgnc_id : "HGNC:29316",
      havana_gene : "OTTHUMG00000162388.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 62306162,
      stop : 62391025,
      direction : "+",
      ID : "ENSG00000068796.19",
      gene_id : "ENSG00000068796.19",
      gene_type : "protein_coding",
      gene_name : "KIF2A",
      gene_level : 1,
      hgnc_id : "HGNC:6318",
      havana_gene : "OTTHUMG00000097755.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 62306206,
      stop : 62537249,
      direction : "+",
      ID : "ENSG00000288643.1",
      gene_id : "ENSG00000288643.1",
      gene_type : "protein_coding",
      gene_name : "AC114982.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 62347284,
      stop : 62403943,
      direction : "-",
      ID : "ENSG00000086189.11",
      gene_id : "ENSG00000086189.11",
      gene_type : "protein_coding",
      gene_name : "DIMT1",
      gene_level : 2,
      hgnc_id : "HGNC:30217",
      havana_gene : "OTTHUMG00000131223.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 62403972,
      stop : 62628582,
      direction : "+",
      ID : "ENSG00000086200.17",
      gene_id : "ENSG00000086200.17",
      gene_type : "protein_coding",
      gene_name : "IPO11",
      gene_level : 1,
      hgnc_id : "HGNC:20628",
      havana_gene : "OTTHUMG00000154400.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 62578819,
      stop : 62581446,
      direction : "+",
      ID : "ENSG00000186105.8",
      gene_id : "ENSG00000186105.8",
      gene_type : "protein_coding",
      gene_name : "LRRC70",
      gene_level : 1,
      hgnc_id : "HGNC:35155",
      havana_gene : "OTTHUMG00000154401.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 63957874,
      stop : 63962507,
      direction : "-",
      ID : "ENSG00000178394.5",
      gene_id : "ENSG00000178394.5",
      gene_type : "protein_coding",
      gene_name : "HTR1A",
      gene_level : 2,
      hgnc_id : "HGNC:5286",
      havana_gene : "OTTHUMG00000162279.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 64165843,
      stop : 64372869,
      direction : "+",
      ID : "ENSG00000164197.12",
      gene_id : "ENSG00000164197.12",
      gene_type : "protein_coding",
      gene_name : "RNF180",
      gene_level : 2,
      hgnc_id : "HGNC:27752",
      havana_gene : "OTTHUMG00000162278.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 64506015,
      stop : 64612319,
      direction : "+",
      ID : "ENSG00000186479.5",
      gene_id : "ENSG00000186479.5",
      gene_type : "protein_coding",
      gene_name : "RGS7BP",
      gene_level : 2,
      hgnc_id : "HGNC:23271",
      havana_gene : "OTTHUMG00000162293.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 64690442,
      stop : 64718190,
      direction : "+",
      ID : "ENSG00000145642.12",
      gene_id : "ENSG00000145642.12",
      gene_type : "protein_coding",
      gene_name : "SHISAL2B",
      gene_level : 2,
      hgnc_id : "HGNC:34236",
      havana_gene : "OTTHUMG00000162292.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 64718148,
      stop : 64768691,
      direction : "-",
      ID : "ENSG00000153006.16",
      gene_id : "ENSG00000153006.16",
      gene_type : "protein_coding",
      gene_name : "SREK1IP1",
      gene_level : 2,
      hgnc_id : "HGNC:26716",
      havana_gene : "OTTHUMG00000162291.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 64768930,
      stop : 65018750,
      direction : "+",
      ID : "ENSG00000153015.16",
      gene_id : "ENSG00000153015.16",
      gene_type : "protein_coding",
      gene_name : "CWC27",
      gene_level : 1,
      hgnc_id : "HGNC:10664",
      havana_gene : "OTTHUMG00000074069.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65148738,
      stop : 65481920,
      direction : "-",
      ID : "ENSG00000049192.15",
      gene_id : "ENSG00000049192.15",
      gene_type : "protein_coding",
      gene_name : "ADAMTS6",
      gene_level : 2,
      hgnc_id : "HGNC:222",
      havana_gene : "OTTHUMG00000074079.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65517766,
      stop : 65563168,
      direction : "-",
      ID : "ENSG00000123219.13",
      gene_id : "ENSG00000123219.13",
      gene_type : "protein_coding",
      gene_name : "CENPK",
      gene_level : 2,
      hgnc_id : "HGNC:29479",
      havana_gene : "OTTHUMG00000131227.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65563236,
      stop : 65587549,
      direction : "+",
      ID : "ENSG00000113593.12",
      gene_id : "ENSG00000113593.12",
      gene_type : "protein_coding",
      gene_name : "PPWD1",
      gene_level : 2,
      hgnc_id : "HGNC:28954",
      havana_gene : "OTTHUMG00000131226.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65589690,
      stop : 65625975,
      direction : "-",
      ID : "ENSG00000113595.15",
      gene_id : "ENSG00000113595.15",
      gene_type : "protein_coding",
      gene_name : "TRIM23",
      gene_level : 1,
      hgnc_id : "HGNC:660",
      havana_gene : "OTTHUMG00000097802.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65625004,
      stop : 65666233,
      direction : "+",
      ID : "ENSG00000113597.18",
      gene_id : "ENSG00000113597.18",
      gene_type : "protein_coding",
      gene_name : "TRAPPC13",
      gene_level : 2,
      hgnc_id : "HGNC:25828",
      havana_gene : "OTTHUMG00000163649.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65625027,
      stop : 65630928,
      direction : "+",
      ID : "ENSG00000253251.3",
      gene_id : "ENSG00000253251.3",
      gene_type : "protein_coding",
      gene_name : "SHLD3",
      gene_level : 1,
      hgnc_id : "HGNC:53826",
      havana_gene : "OTTHUMG00000162694.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65665928,
      stop : 65723035,
      direction : "-",
      ID : "ENSG00000197860.10",
      gene_id : "ENSG00000197860.10",
      gene_type : "protein_coding",
      gene_name : "SGTB",
      gene_level : 2,
      hgnc_id : "HGNC:23567",
      havana_gene : "OTTHUMG00000097801.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65722205,
      stop : 65871725,
      direction : "+",
      ID : "ENSG00000123213.23",
      gene_id : "ENSG00000123213.23",
      gene_type : "protein_coding",
      gene_name : "NLN",
      gene_level : 1,
      hgnc_id : "HGNC:16058",
      havana_gene : "OTTHUMG00000097803.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 65926556,
      stop : 66082546,
      direction : "+",
      ID : "ENSG00000112851.15",
      gene_id : "ENSG00000112851.15",
      gene_type : "protein_coding",
      gene_name : "ERBIN",
      gene_level : 1,
      hgnc_id : "HGNC:15842",
      havana_gene : "OTTHUMG00000097808.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 66139971,
      stop : 66183615,
      direction : "+",
      ID : "ENSG00000153914.16",
      gene_id : "ENSG00000153914.16",
      gene_type : "protein_coding",
      gene_name : "SREK1",
      gene_level : 2,
      hgnc_id : "HGNC:17882",
      havana_gene : "OTTHUMG00000097809.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 66596361,
      stop : 67169595,
      direction : "+",
      ID : "ENSG00000069020.18",
      gene_id : "ENSG00000069020.18",
      gene_type : "protein_coding",
      gene_name : "MAST4",
      gene_level : 1,
      hgnc_id : "HGNC:19037",
      havana_gene : "OTTHUMG00000152471.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 67179613,
      stop : 67196799,
      direction : "-",
      ID : "ENSG00000134061.5",
      gene_id : "ENSG00000134061.5",
      gene_type : "protein_coding",
      gene_name : "CD180",
      gene_level : 2,
      hgnc_id : "HGNC:6726",
      havana_gene : "OTTHUMG00000131229.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 68215756,
      stop : 68301821,
      direction : "+",
      ID : "ENSG00000145675.15",
      gene_id : "ENSG00000145675.15",
      gene_type : "protein_coding",
      gene_name : "PIK3R1",
      gene_level : 1,
      hgnc_id : "HGNC:8979",
      havana_gene : "OTTHUMG00000131251.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69093949,
      stop : 69131069,
      direction : "+",
      ID : "ENSG00000145740.19",
      gene_id : "ENSG00000145740.19",
      gene_type : "protein_coding",
      gene_name : "SLC30A5",
      gene_level : 1,
      hgnc_id : "HGNC:19089",
      havana_gene : "OTTHUMG00000131253.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69167135,
      stop : 69178245,
      direction : "+",
      ID : "ENSG00000134057.15",
      gene_id : "ENSG00000134057.15",
      gene_type : "protein_coding",
      gene_name : "CCNB1",
      gene_level : 1,
      hgnc_id : "HGNC:1579",
      havana_gene : "OTTHUMG00000097817.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69189574,
      stop : 69210357,
      direction : "+",
      ID : "ENSG00000153044.10",
      gene_id : "ENSG00000153044.10",
      gene_type : "protein_coding",
      gene_name : "CENPH",
      gene_level : 2,
      hgnc_id : "HGNC:17268",
      havana_gene : "OTTHUMG00000097816.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69217760,
      stop : 69230158,
      direction : "+",
      ID : "ENSG00000134056.12",
      gene_id : "ENSG00000134056.12",
      gene_type : "protein_coding",
      gene_name : "MRPS36",
      gene_level : 2,
      hgnc_id : "HGNC:16631",
      havana_gene : "OTTHUMG00000162443.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69234795,
      stop : 69277430,
      direction : "+",
      ID : "ENSG00000134058.12",
      gene_id : "ENSG00000134058.12",
      gene_type : "protein_coding",
      gene_name : "CDK7",
      gene_level : 2,
      hgnc_id : "HGNC:1778",
      havana_gene : "OTTHUMG00000099358.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69280175,
      stop : 69332809,
      direction : "-",
      ID : "ENSG00000183323.13",
      gene_id : "ENSG00000183323.13",
      gene_type : "protein_coding",
      gene_name : "CCDC125",
      gene_level : 1,
      hgnc_id : "HGNC:28924",
      havana_gene : "OTTHUMG00000131259.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69350984,
      stop : 69370013,
      direction : "-",
      ID : "ENSG00000085231.14",
      gene_id : "ENSG00000085231.14",
      gene_type : "protein_coding",
      gene_name : "AK6",
      gene_level : 2,
      hgnc_id : "HGNC:49151",
      havana_gene : "OTTHUMG00000187252.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69364743,
      stop : 69370013,
      direction : "-",
      ID : "ENSG00000273841.5",
      gene_id : "ENSG00000273841.5",
      gene_type : "protein_coding",
      gene_name : "TAF9",
      gene_level : 2,
      hgnc_id : "HGNC:11542",
      havana_gene : "OTTHUMG00000099359.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69369293,
      stop : 69414801,
      direction : "+",
      ID : "ENSG00000152942.19",
      gene_id : "ENSG00000152942.19",
      gene_type : "protein_coding",
      gene_name : "RAD17",
      gene_level : 1,
      hgnc_id : "HGNC:9807",
      havana_gene : "OTTHUMG00000099357.12",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69415065,
      stop : 69444330,
      direction : "+",
      ID : "ENSG00000152939.17",
      gene_id : "ENSG00000152939.17",
      gene_type : "protein_coding",
      gene_name : "MARVELD2",
      gene_level : 2,
      hgnc_id : "HGNC:26401",
      havana_gene : "OTTHUMG00000162512.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69492292,
      stop : 69558104,
      direction : "+",
      ID : "ENSG00000197822.12",
      gene_id : "ENSG00000197822.12",
      gene_type : "protein_coding",
      gene_name : "OCLN",
      gene_level : 2,
      hgnc_id : "HGNC:8104",
      havana_gene : "OTTHUMG00000099356.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 69560191,
      stop : 69595221,
      direction : "+",
      ID : "ENSG00000183474.16",
      gene_id : "ENSG00000183474.16",
      gene_type : "protein_coding",
      gene_name : "GTF2H2C",
      gene_level : 2,
      hgnc_id : "HGNC:31394",
      havana_gene : "OTTHUMG00000162365.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 70025247,
      stop : 70043113,
      direction : "+",
      ID : "ENSG00000205572.10",
      gene_id : "ENSG00000205572.10",
      gene_type : "protein_coding",
      gene_name : "SERF1B",
      gene_level : 2,
      hgnc_id : "HGNC:10756",
      havana_gene : "OTTHUMG00000162391.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 70049638,
      stop : 70078522,
      direction : "+",
      ID : "ENSG00000205571.14",
      gene_id : "ENSG00000205571.14",
      gene_type : "protein_coding",
      gene_name : "SMN2",
      gene_level : 2,
      hgnc_id : "HGNC:11118",
      havana_gene : "OTTHUMG00000099389.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 70900669,
      stop : 70918530,
      direction : "+",
      ID : "ENSG00000172058.16",
      gene_id : "ENSG00000172058.16",
      gene_type : "protein_coding",
      gene_name : "SERF1A",
      gene_level : 2,
      hgnc_id : "HGNC:10755",
      havana_gene : "OTTHUMG00000162419.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 70925030,
      stop : 70953942,
      direction : "+",
      ID : "ENSG00000172062.17",
      gene_id : "ENSG00000172062.17",
      gene_type : "protein_coding",
      gene_name : "SMN1",
      gene_level : 2,
      hgnc_id : "HGNC:11117",
      havana_gene : "OTTHUMG00000099361.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 70968166,
      stop : 71025339,
      direction : "-",
      ID : "ENSG00000249437.8",
      gene_id : "ENSG00000249437.8",
      gene_type : "protein_coding",
      gene_name : "NAIP",
      gene_level : 2,
      hgnc_id : "HGNC:7634",
      havana_gene : "OTTHUMG00000163318.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 71032670,
      stop : 71067689,
      direction : "-",
      ID : "ENSG00000145736.14",
      gene_id : "ENSG00000145736.14",
      gene_type : "protein_coding",
      gene_name : "GTF2H2",
      gene_level : 2,
      hgnc_id : "HGNC:4656",
      havana_gene : "OTTHUMG00000164542.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 71455651,
      stop : 71567820,
      direction : "+",
      ID : "ENSG00000145734.19",
      gene_id : "ENSG00000145734.19",
      gene_type : "protein_coding",
      gene_name : "BDP1",
      gene_level : 2,
      hgnc_id : "HGNC:13652",
      havana_gene : "OTTHUMG00000162506.23",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 71587288,
      stop : 71658706,
      direction : "+",
      ID : "ENSG00000131844.16",
      gene_id : "ENSG00000131844.16",
      gene_type : "protein_coding",
      gene_name : "MCCC2",
      gene_level : 1,
      hgnc_id : "HGNC:6937",
      havana_gene : "OTTHUMG00000162505.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 71719275,
      stop : 71721048,
      direction : "+",
      ID : "ENSG00000164326.5",
      gene_id : "ENSG00000164326.5",
      gene_type : "protein_coding",
      gene_name : "CARTPT",
      gene_level : 2,
      hgnc_id : "HGNC:24323",
      havana_gene : "OTTHUMG00000131261.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 72107234,
      stop : 72209565,
      direction : "+",
      ID : "ENSG00000131711.15",
      gene_id : "ENSG00000131711.15",
      gene_type : "protein_coding",
      gene_name : "MAP1B",
      gene_level : 1,
      hgnc_id : "HGNC:6836",
      havana_gene : "OTTHUMG00000100952.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 72219403,
      stop : 72320646,
      direction : "-",
      ID : "ENSG00000113048.17",
      gene_id : "ENSG00000113048.17",
      gene_type : "protein_coding",
      gene_name : "MRPS27",
      gene_level : 2,
      hgnc_id : "HGNC:14512",
      havana_gene : "OTTHUMG00000100951.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 72320367,
      stop : 72368395,
      direction : "+",
      ID : "ENSG00000049883.15",
      gene_id : "ENSG00000049883.15",
      gene_type : "protein_coding",
      gene_name : "PTCD2",
      gene_level : 1,
      hgnc_id : "HGNC:25734",
      havana_gene : "OTTHUMG00000100953.12",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 72439903,
      stop : 72507410,
      direction : "-",
      ID : "ENSG00000178175.12",
      gene_id : "ENSG00000178175.12",
      gene_type : "protein_coding",
      gene_name : "ZNF366",
      gene_level : 1,
      hgnc_id : "HGNC:18316",
      havana_gene : "OTTHUMG00000100965.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 72816312,
      stop : 72916733,
      direction : "+",
      ID : "ENSG00000083312.18",
      gene_id : "ENSG00000083312.18",
      gene_type : "protein_coding",
      gene_name : "TNPO1",
      gene_level : 2,
      hgnc_id : "HGNC:6401",
      havana_gene : "OTTHUMG00000100967.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 72956041,
      stop : 73090522,
      direction : "+",
      ID : "ENSG00000157107.14",
      gene_id : "ENSG00000157107.14",
      gene_type : "protein_coding",
      gene_name : "FCHO2",
      gene_level : 2,
      hgnc_id : "HGNC:25180",
      havana_gene : "OTTHUMG00000162413.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73120569,
      stop : 73131809,
      direction : "+",
      ID : "ENSG00000157111.13",
      gene_id : "ENSG00000157111.13",
      gene_type : "protein_coding",
      gene_name : "TMEM171",
      gene_level : 2,
      hgnc_id : "HGNC:27031",
      havana_gene : "OTTHUMG00000131269.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73173193,
      stop : 73175143,
      direction : "+",
      ID : "ENSG00000164325.8",
      gene_id : "ENSG00000164325.8",
      gene_type : "protein_coding",
      gene_name : "TMEM174",
      gene_level : 2,
      hgnc_id : "HGNC:28187",
      havana_gene : "OTTHUMG00000131268.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73444827,
      stop : 73448777,
      direction : "-",
      ID : "ENSG00000251493.5",
      gene_id : "ENSG00000251493.5",
      gene_type : "protein_coding",
      gene_name : "FOXD1",
      gene_level : 2,
      hgnc_id : "HGNC:3802",
      havana_gene : "OTTHUMG00000162495.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73498408,
      stop : 73505635,
      direction : "+",
      ID : "ENSG00000145741.16",
      gene_id : "ENSG00000145741.16",
      gene_type : "protein_coding",
      gene_name : "BTF3",
      gene_level : 1,
      hgnc_id : "HGNC:1125",
      havana_gene : "OTTHUMG00000102031.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73552190,
      stop : 73565667,
      direction : "-",
      ID : "ENSG00000164331.10",
      gene_id : "ENSG00000164331.10",
      gene_type : "protein_coding",
      gene_name : "ANKRA2",
      gene_level : 1,
      hgnc_id : "HGNC:13208",
      havana_gene : "OTTHUMG00000102030.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73565443,
      stop : 73583380,
      direction : "+",
      ID : "ENSG00000164338.10",
      gene_id : "ENSG00000164338.10",
      gene_type : "protein_coding",
      gene_name : "UTP15",
      gene_level : 1,
      hgnc_id : "HGNC:25758",
      havana_gene : "OTTHUMG00000162453.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 73626158,
      stop : 73941993,
      direction : "+",
      ID : "ENSG00000214944.9",
      gene_id : "ENSG00000214944.9",
      gene_type : "protein_coding",
      gene_name : "ARHGEF28",
      gene_level : 1,
      hgnc_id : "HGNC:30322",
      havana_gene : "OTTHUMG00000162454.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 74627406,
      stop : 74641424,
      direction : "-",
      ID : "ENSG00000171617.15",
      gene_id : "ENSG00000171617.15",
      gene_type : "protein_coding",
      gene_name : "ENC1",
      gene_level : 1,
      hgnc_id : "HGNC:3345",
      havana_gene : "OTTHUMG00000102059.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 74640023,
      stop : 74722647,
      direction : "+",
      ID : "ENSG00000049860.14",
      gene_id : "ENSG00000049860.14",
      gene_type : "protein_coding",
      gene_name : "HEXB",
      gene_level : 2,
      hgnc_id : "HGNC:4879",
      havana_gene : "OTTHUMG00000102057.13",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 74721206,
      stop : 74767147,
      direction : "-",
      ID : "ENSG00000164347.18",
      gene_id : "ENSG00000164347.18",
      gene_type : "protein_coding",
      gene_name : "GFM2",
      gene_level : 1,
      hgnc_id : "HGNC:29682",
      havana_gene : "OTTHUMG00000102058.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 74766991,
      stop : 74780113,
      direction : "+",
      ID : "ENSG00000164346.10",
      gene_id : "ENSG00000164346.10",
      gene_type : "protein_coding",
      gene_name : "NSA2",
      gene_level : 2,
      hgnc_id : "HGNC:30728",
      havana_gene : "OTTHUMG00000131273.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 74777574,
      stop : 74866966,
      direction : "-",
      ID : "ENSG00000198780.12",
      gene_id : "ENSG00000198780.12",
      gene_type : "protein_coding",
      gene_name : "FAM169A",
      gene_level : 1,
      hgnc_id : "HGNC:29138",
      havana_gene : "OTTHUMG00000162930.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75025346,
      stop : 75052558,
      direction : "-",
      ID : "ENSG00000176928.7",
      gene_id : "ENSG00000176928.7",
      gene_type : "protein_coding",
      gene_name : "GCNT4",
      gene_level : 2,
      hgnc_id : "HGNC:17973",
      havana_gene : "OTTHUMG00000131272.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75068275,
      stop : 75236911,
      direction : "-",
      ID : "ENSG00000145700.10",
      gene_id : "ENSG00000145700.10",
      gene_type : "protein_coding",
      gene_name : "ANKRD31",
      gene_level : 2,
      hgnc_id : "HGNC:26853",
      havana_gene : "OTTHUMG00000162649.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75336329,
      stop : 75364001,
      direction : "+",
      ID : "ENSG00000113161.17",
      gene_id : "ENSG00000113161.17",
      gene_type : "protein_coding",
      gene_name : "HMGCR",
      gene_level : 1,
      hgnc_id : "HGNC:5006",
      havana_gene : "OTTHUMG00000102069.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75356345,
      stop : 75512138,
      direction : "-",
      ID : "ENSG00000113163.18",
      gene_id : "ENSG00000113163.18",
      gene_type : "protein_coding",
      gene_name : "CERT1",
      gene_level : 2,
      hgnc_id : "HGNC:2205",
      havana_gene : "OTTHUMG00000102068.10",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75511756,
      stop : 75601144,
      direction : "+",
      ID : "ENSG00000122008.15",
      gene_id : "ENSG00000122008.15",
      gene_type : "protein_coding",
      gene_name : "POLK",
      gene_level : 2,
      hgnc_id : "HGNC:9183",
      havana_gene : "OTTHUMG00000102107.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75611182,
      stop : 75681773,
      direction : "+",
      ID : "ENSG00000189045.15",
      gene_id : "ENSG00000189045.15",
      gene_type : "protein_coding",
      gene_name : "ANKDD1B",
      gene_level : 1,
      hgnc_id : "HGNC:32525",
      havana_gene : "OTTHUMG00000162490.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 75674124,
      stop : 75717448,
      direction : "-",
      ID : "ENSG00000152359.15",
      gene_id : "ENSG00000152359.15",
      gene_type : "protein_coding",
      gene_name : "POC5",
      gene_level : 1,
      hgnc_id : "HGNC:26658",
      havana_gene : "OTTHUMG00000162487.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76083383,
      stop : 76353939,
      direction : "+",
      ID : "ENSG00000122012.14",
      gene_id : "ENSG00000122012.14",
      gene_type : "protein_coding",
      gene_name : "SV2C",
      gene_level : 2,
      hgnc_id : "HGNC:30670",
      havana_gene : "OTTHUMG00000162384.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76403285,
      stop : 76708132,
      direction : "+",
      ID : "ENSG00000145703.16",
      gene_id : "ENSG00000145703.16",
      gene_type : "protein_coding",
      gene_name : "IQGAP2",
      gene_level : 1,
      hgnc_id : "HGNC:6111",
      havana_gene : "OTTHUMG00000162432.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76615482,
      stop : 76623413,
      direction : "-",
      ID : "ENSG00000164220.7",
      gene_id : "ENSG00000164220.7",
      gene_type : "protein_coding",
      gene_name : "F2RL2",
      gene_level : 1,
      hgnc_id : "HGNC:3539",
      havana_gene : "OTTHUMG00000102119.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76716126,
      stop : 76735770,
      direction : "+",
      ID : "ENSG00000181104.7",
      gene_id : "ENSG00000181104.7",
      gene_type : "protein_coding",
      gene_name : "F2R",
      gene_level : 2,
      hgnc_id : "HGNC:3537",
      havana_gene : "OTTHUMG00000131299.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76818933,
      stop : 76835315,
      direction : "+",
      ID : "ENSG00000164251.5",
      gene_id : "ENSG00000164251.5",
      gene_type : "protein_coding",
      gene_name : "F2RL1",
      gene_level : 2,
      hgnc_id : "HGNC:3538",
      havana_gene : "OTTHUMG00000102118.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76850001,
      stop : 76921650,
      direction : "+",
      ID : "ENSG00000171643.14",
      gene_id : "ENSG00000171643.14",
      gene_type : "protein_coding",
      gene_name : "S100Z",
      gene_level : 2,
      hgnc_id : "HGNC:30367",
      havana_gene : "OTTHUMG00000162441.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 76953045,
      stop : 76981158,
      direction : "+",
      ID : "ENSG00000145708.11",
      gene_id : "ENSG00000145708.11",
      gene_type : "protein_coding",
      gene_name : "CRHBP",
      gene_level : 2,
      hgnc_id : "HGNC:2356",
      havana_gene : "OTTHUMG00000102133.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77029251,
      stop : 77065234,
      direction : "+",
      ID : "ENSG00000164252.13",
      gene_id : "ENSG00000164252.13",
      gene_type : "protein_coding",
      gene_name : "AGGF1",
      gene_level : 2,
      hgnc_id : "HGNC:24684",
      havana_gene : "OTTHUMG00000102132.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77030902,
      stop : 77152155,
      direction : "+",
      ID : "ENSG00000285000.1",
      gene_id : "ENSG00000285000.1",
      gene_type : "protein_coding",
      gene_name : "AC008581.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192507.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77072072,
      stop : 77087285,
      direction : "-",
      ID : "ENSG00000132846.6",
      gene_id : "ENSG00000132846.6",
      gene_type : "protein_coding",
      gene_name : "ZBED3",
      gene_level : 2,
      hgnc_id : "HGNC:20711",
      havana_gene : "OTTHUMG00000102131.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77086732,
      stop : 77427124,
      direction : "+",
      ID : "ENSG00000284762.1",
      gene_id : "ENSG00000284762.1",
      gene_type : "protein_coding",
      gene_name : "AC022414.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192508.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77210449,
      stop : 77428256,
      direction : "+",
      ID : "ENSG00000113231.14",
      gene_id : "ENSG00000113231.14",
      gene_type : "protein_coding",
      gene_name : "PDE8B",
      gene_level : 2,
      hgnc_id : "HGNC:8794",
      havana_gene : "OTTHUMG00000102170.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77425970,
      stop : 77620611,
      direction : "-",
      ID : "ENSG00000164253.14",
      gene_id : "ENSG00000164253.14",
      gene_type : "protein_coding",
      gene_name : "WDR41",
      gene_level : 1,
      hgnc_id : "HGNC:25601",
      havana_gene : "OTTHUMG00000102169.14",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77628712,
      stop : 77638713,
      direction : "-",
      ID : "ENSG00000171540.8",
      gene_id : "ENSG00000171540.8",
      gene_type : "protein_coding",
      gene_name : "OTP",
      gene_level : 2,
      hgnc_id : "HGNC:8518",
      havana_gene : "OTTHUMG00000102171.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 77691166,
      stop : 77868780,
      direction : "-",
      ID : "ENSG00000171530.15",
      gene_id : "ENSG00000171530.15",
      gene_type : "protein_coding",
      gene_name : "TBCA",
      gene_level : 2,
      hgnc_id : "HGNC:11579",
      havana_gene : "OTTHUMG00000102173.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 78002326,
      stop : 78294698,
      direction : "-",
      ID : "ENSG00000132842.14",
      gene_id : "ENSG00000132842.14",
      gene_type : "protein_coding",
      gene_name : "AP3B1",
      gene_level : 1,
      hgnc_id : "HGNC:566",
      havana_gene : "OTTHUMG00000106919.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 78360611,
      stop : 78480739,
      direction : "+",
      ID : "ENSG00000085365.18",
      gene_id : "ENSG00000085365.18",
      gene_type : "protein_coding",
      gene_name : "SCAMP1",
      gene_level : 1,
      hgnc_id : "HGNC:10563",
      havana_gene : "OTTHUMG00000162479.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 78485215,
      stop : 78770021,
      direction : "-",
      ID : "ENSG00000145685.14",
      gene_id : "ENSG00000145685.14",
      gene_type : "protein_coding",
      gene_name : "LHFPL2",
      gene_level : 1,
      hgnc_id : "HGNC:6588",
      havana_gene : "OTTHUMG00000107579.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 78777209,
      stop : 78986087,
      direction : "-",
      ID : "ENSG00000113273.17",
      gene_id : "ENSG00000113273.17",
      gene_type : "protein_coding",
      gene_name : "ARSB",
      gene_level : 1,
      hgnc_id : "HGNC:714",
      havana_gene : "OTTHUMG00000108129.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 78997564,
      stop : 79236038,
      direction : "-",
      ID : "ENSG00000132837.15",
      gene_id : "ENSG00000132837.15",
      gene_type : "protein_coding",
      gene_name : "DMGDH",
      gene_level : 1,
      hgnc_id : "HGNC:24475",
      havana_gene : "OTTHUMG00000108159.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79069767,
      stop : 79090069,
      direction : "+",
      ID : "ENSG00000132840.10",
      gene_id : "ENSG00000132840.10",
      gene_type : "protein_coding",
      gene_name : "BHMT2",
      gene_level : 1,
      hgnc_id : "HGNC:1048",
      havana_gene : "OTTHUMG00000108158.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79111809,
      stop : 79132288,
      direction : "+",
      ID : "ENSG00000145692.15",
      gene_id : "ENSG00000145692.15",
      gene_type : "protein_coding",
      gene_name : "BHMT",
      gene_level : 2,
      hgnc_id : "HGNC:1047",
      havana_gene : "OTTHUMG00000108157.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79236131,
      stop : 79327211,
      direction : "+",
      ID : "ENSG00000152409.9",
      gene_id : "ENSG00000152409.9",
      gene_type : "protein_coding",
      gene_name : "JMY",
      gene_level : 2,
      hgnc_id : "HGNC:28916",
      havana_gene : "OTTHUMG00000131301.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79372636,
      stop : 79514134,
      direction : "-",
      ID : "ENSG00000152413.15",
      gene_id : "ENSG00000152413.15",
      gene_type : "protein_coding",
      gene_name : "HOMER1",
      gene_level : 2,
      hgnc_id : "HGNC:17512",
      havana_gene : "OTTHUMG00000134278.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79612120,
      stop : 79686648,
      direction : "+",
      ID : "ENSG00000164329.13",
      gene_id : "ENSG00000164329.13",
      gene_type : "protein_coding",
      gene_name : "TENT2",
      gene_level : 2,
      hgnc_id : "HGNC:26776",
      havana_gene : "OTTHUMG00000108163.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79689836,
      stop : 79800240,
      direction : "+",
      ID : "ENSG00000164309.15",
      gene_id : "ENSG00000164309.15",
      gene_type : "protein_coding",
      gene_name : "CMYA5",
      gene_level : 2,
      hgnc_id : "HGNC:14305",
      havana_gene : "OTTHUMG00000162548.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79976716,
      stop : 79991262,
      direction : "-",
      ID : "ENSG00000177034.17",
      gene_id : "ENSG00000177034.17",
      gene_type : "protein_coding",
      gene_name : "MTX3",
      gene_level : 2,
      hgnc_id : "HGNC:24812",
      havana_gene : "OTTHUMG00000162547.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 79991311,
      stop : 80083287,
      direction : "+",
      ID : "ENSG00000113296.14",
      gene_id : "ENSG00000113296.14",
      gene_type : "protein_coding",
      gene_name : "THBS4",
      gene_level : 1,
      hgnc_id : "HGNC:11788",
      havana_gene : "OTTHUMG00000108173.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80111651,
      stop : 80256048,
      direction : "-",
      ID : "ENSG00000164300.17",
      gene_id : "ENSG00000164300.17",
      gene_type : "protein_coding",
      gene_name : "SERINC5",
      gene_level : 1,
      hgnc_id : "HGNC:18825",
      havana_gene : "OTTHUMG00000162563.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80319625,
      stop : 80321842,
      direction : "+",
      ID : "ENSG00000164299.7",
      gene_id : "ENSG00000164299.7",
      gene_type : "protein_coding",
      gene_name : "SPZ1",
      gene_level : 2,
      hgnc_id : "HGNC:30721",
      havana_gene : "OTTHUMG00000162514.3",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80408013,
      stop : 80483379,
      direction : "+",
      ID : "ENSG00000039319.17",
      gene_id : "ENSG00000039319.17",
      gene_type : "protein_coding",
      gene_name : "ZFYVE16",
      gene_level : 2,
      hgnc_id : "HGNC:20756",
      havana_gene : "OTTHUMG00000108178.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80487969,
      stop : 80542563,
      direction : "+",
      ID : "ENSG00000152380.10",
      gene_id : "ENSG00000152380.10",
      gene_type : "protein_coding",
      gene_name : "FAM151B",
      gene_level : 2,
      hgnc_id : "HGNC:33716",
      havana_gene : "OTTHUMG00000131303.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80556755,
      stop : 80570280,
      direction : "-",
      ID : "ENSG00000189127.8",
      gene_id : "ENSG00000189127.8",
      gene_type : "protein_coding",
      gene_name : "ANKRD34B",
      gene_level : 2,
      hgnc_id : "HGNC:33736",
      havana_gene : "OTTHUMG00000162541.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80626226,
      stop : 80654983,
      direction : "-",
      ID : "ENSG00000228716.7",
      gene_id : "ENSG00000228716.7",
      gene_type : "protein_coding",
      gene_name : "DHFR",
      gene_level : 2,
      hgnc_id : "HGNC:2861",
      havana_gene : "OTTHUMG00000162529.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80654652,
      stop : 80876815,
      direction : "+",
      ID : "ENSG00000113318.11",
      gene_id : "ENSG00000113318.11",
      gene_type : "protein_coding",
      gene_name : "MSH3",
      gene_level : 2,
      hgnc_id : "HGNC:7326",
      havana_gene : "OTTHUMG00000162540.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 80960363,
      stop : 81230162,
      direction : "+",
      ID : "ENSG00000113319.13",
      gene_id : "ENSG00000113319.13",
      gene_type : "protein_coding",
      gene_name : "RASGRF2",
      gene_level : 2,
      hgnc_id : "HGNC:9876",
      havana_gene : "OTTHUMG00000119015.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 81233320,
      stop : 81266398,
      direction : "+",
      ID : "ENSG00000131730.16",
      gene_id : "ENSG00000131730.16",
      gene_type : "protein_coding",
      gene_name : "CKMT2",
      gene_level : 2,
      hgnc_id : "HGNC:1996",
      havana_gene : "OTTHUMG00000119013.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 81301587,
      stop : 81313297,
      direction : "+",
      ID : "ENSG00000131732.12",
      gene_id : "ENSG00000131732.12",
      gene_type : "protein_coding",
      gene_name : "ZCCHC9",
      gene_level : 2,
      hgnc_id : "HGNC:25424",
      havana_gene : "OTTHUMG00000119014.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 81329996,
      stop : 81394179,
      direction : "-",
      ID : "ENSG00000172497.9",
      gene_id : "ENSG00000172497.9",
      gene_type : "protein_coding",
      gene_name : "ACOT12",
      gene_level : 2,
      hgnc_id : "HGNC:24436",
      havana_gene : "OTTHUMG00000131305.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 81413021,
      stop : 81751797,
      direction : "-",
      ID : "ENSG00000145687.16",
      gene_id : "ENSG00000145687.16",
      gene_type : "protein_coding",
      gene_name : "SSBP2",
      gene_level : 2,
      hgnc_id : "HGNC:15831",
      havana_gene : "OTTHUMG00000119039.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 81972023,
      stop : 82276857,
      direction : "+",
      ID : "ENSG00000152348.16",
      gene_id : "ENSG00000152348.16",
      gene_type : "protein_coding",
      gene_name : "ATG10",
      gene_level : 1,
      hgnc_id : "HGNC:20315",
      havana_gene : "OTTHUMG00000119041.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 82273320,
      stop : 82278396,
      direction : "-",
      ID : "ENSG00000186468.13",
      gene_id : "ENSG00000186468.13",
      gene_type : "protein_coding",
      gene_name : "RPS23",
      gene_level : 1,
      hgnc_id : "HGNC:10410",
      havana_gene : "OTTHUMG00000162557.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 83052846,
      stop : 83077863,
      direction : "-",
      ID : "ENSG00000174695.10",
      gene_id : "ENSG00000174695.10",
      gene_type : "protein_coding",
      gene_name : "TMEM167A",
      gene_level : 2,
      hgnc_id : "HGNC:28330",
      havana_gene : "OTTHUMG00000162570.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 83077498,
      stop : 83353787,
      direction : "+",
      ID : "ENSG00000152422.16",
      gene_id : "ENSG00000152422.16",
      gene_type : "protein_coding",
      gene_name : "XRCC4",
      gene_level : 2,
      hgnc_id : "HGNC:12831",
      havana_gene : "OTTHUMG00000131319.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 83471618,
      stop : 83582303,
      direction : "+",
      ID : "ENSG00000038427.16",
      gene_id : "ENSG00000038427.16",
      gene_type : "protein_coding",
      gene_name : "VCAN",
      gene_level : 2,
      hgnc_id : "HGNC:2464",
      havana_gene : "OTTHUMG00000131321.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 83637805,
      stop : 83720855,
      direction : "-",
      ID : "ENSG00000145681.11",
      gene_id : "ENSG00000145681.11",
      gene_type : "protein_coding",
      gene_name : "HAPLN1",
      gene_level : 2,
      hgnc_id : "HGNC:2380",
      havana_gene : "OTTHUMG00000119045.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 83940554,
      stop : 84384880,
      direction : "-",
      ID : "ENSG00000164176.13",
      gene_id : "ENSG00000164176.13",
      gene_type : "protein_coding",
      gene_name : "EDIL3",
      gene_level : 2,
      hgnc_id : "HGNC:3173",
      havana_gene : "OTTHUMG00000119047.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 86617928,
      stop : 86620962,
      direction : "+",
      ID : "ENSG00000127184.13",
      gene_id : "ENSG00000127184.13",
      gene_type : "protein_coding",
      gene_name : "COX7C",
      gene_level : 2,
      hgnc_id : "HGNC:2292",
      havana_gene : "OTTHUMG00000119049.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 87267883,
      stop : 87391931,
      direction : "+",
      ID : "ENSG00000145715.15",
      gene_id : "ENSG00000145715.15",
      gene_type : "protein_coding",
      gene_name : "RASA1",
      gene_level : 2,
      hgnc_id : "HGNC:9871",
      havana_gene : "OTTHUMG00000162605.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 87318416,
      stop : 87412930,
      direction : "-",
      ID : "ENSG00000134480.16",
      gene_id : "ENSG00000134480.16",
      gene_type : "protein_coding",
      gene_name : "CCNH",
      gene_level : 1,
      hgnc_id : "HGNC:1594",
      havana_gene : "OTTHUMG00000119077.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 88189633,
      stop : 88269476,
      direction : "-",
      ID : "ENSG00000164180.14",
      gene_id : "ENSG00000164180.14",
      gene_type : "protein_coding",
      gene_name : "TMEM161B",
      gene_level : 1,
      hgnc_id : "HGNC:28483",
      havana_gene : "OTTHUMG00000131323.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 88717117,
      stop : 88904257,
      direction : "-",
      ID : "ENSG00000081189.16",
      gene_id : "ENSG00000081189.16",
      gene_type : "protein_coding",
      gene_name : "MEF2C",
      gene_level : 2,
      hgnc_id : "HGNC:6996",
      havana_gene : "OTTHUMG00000162634.12",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 90392257,
      stop : 90409766,
      direction : "-",
      ID : "ENSG00000153140.9",
      gene_id : "ENSG00000153140.9",
      gene_type : "protein_coding",
      gene_name : "CETN3",
      gene_level : 1,
      hgnc_id : "HGNC:1868",
      havana_gene : "OTTHUMG00000131326.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 90458209,
      stop : 90474771,
      direction : "-",
      ID : "ENSG00000176055.10",
      gene_id : "ENSG00000176055.10",
      gene_type : "protein_coding",
      gene_name : "MBLAC2",
      gene_level : 2,
      hgnc_id : "HGNC:33711",
      havana_gene : "OTTHUMG00000131327.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 90471748,
      stop : 90514557,
      direction : "+",
      ID : "ENSG00000113356.13",
      gene_id : "ENSG00000113356.13",
      gene_type : "protein_coding",
      gene_name : "POLR3G",
      gene_level : 1,
      hgnc_id : "HGNC:30075",
      havana_gene : "OTTHUMG00000162809.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 90515611,
      stop : 90529584,
      direction : "-",
      ID : "ENSG00000176018.13",
      gene_id : "ENSG00000176018.13",
      gene_type : "protein_coding",
      gene_name : "LYSMD3",
      gene_level : 1,
      hgnc_id : "HGNC:26969",
      havana_gene : "OTTHUMG00000162667.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 90529344,
      stop : 91164437,
      direction : "+",
      ID : "ENSG00000164199.18",
      gene_id : "ENSG00000164199.18",
      gene_type : "protein_coding",
      gene_name : "ADGRV1",
      gene_level : 1,
      hgnc_id : "HGNC:17416",
      havana_gene : "OTTHUMG00000162668.13",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 91368631,
      stop : 91383317,
      direction : "-",
      ID : "ENSG00000113369.9",
      gene_id : "ENSG00000113369.9",
      gene_type : "protein_coding",
      gene_name : "ARRDC3",
      gene_level : 1,
      hgnc_id : "HGNC:29263",
      havana_gene : "OTTHUMG00000162616.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 93583222,
      stop : 93594611,
      direction : "+",
      ID : "ENSG00000175745.14",
      gene_id : "ENSG00000175745.14",
      gene_type : "protein_coding",
      gene_name : "NR2F1",
      gene_level : 1,
      hgnc_id : "HGNC:7975",
      havana_gene : "OTTHUMG00000119079.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 93617725,
      stop : 94111699,
      direction : "-",
      ID : "ENSG00000113391.19",
      gene_id : "ENSG00000113391.19",
      gene_type : "protein_coding",
      gene_name : "FAM172A",
      gene_level : 2,
      hgnc_id : "HGNC:25365",
      havana_gene : "OTTHUMG00000131329.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 93733220,
      stop : 93741600,
      direction : "-",
      ID : "ENSG00000248483.7",
      gene_id : "ENSG00000248483.7",
      gene_type : "protein_coding",
      gene_name : "POU5F2",
      gene_level : 2,
      hgnc_id : "HGNC:26367",
      havana_gene : "OTTHUMG00000162644.8",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 94152966,
      stop : 94618597,
      direction : "-",
      ID : "ENSG00000185261.14",
      gene_id : "ENSG00000185261.14",
      gene_type : "protein_coding",
      gene_name : "KIAA0825",
      gene_level : 2,
      hgnc_id : "HGNC:28532",
      havana_gene : "OTTHUMG00000131331.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 94618669,
      stop : 94739436,
      direction : "+",
      ID : "ENSG00000133302.13",
      gene_id : "ENSG00000133302.13",
      gene_type : "protein_coding",
      gene_name : "SLF1",
      gene_level : 2,
      hgnc_id : "HGNC:25408",
      havana_gene : "OTTHUMG00000121133.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 94703741,
      stop : 95284575,
      direction : "-",
      ID : "ENSG00000175471.19",
      gene_id : "ENSG00000175471.19",
      gene_type : "protein_coding",
      gene_name : "MCTP1",
      gene_level : 1,
      hgnc_id : "HGNC:26183",
      havana_gene : "OTTHUMG00000162742.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95391366,
      stop : 95450454,
      direction : "+",
      ID : "ENSG00000153347.10",
      gene_id : "ENSG00000153347.10",
      gene_type : "protein_coding",
      gene_name : "FAM81B",
      gene_level : 2,
      hgnc_id : "HGNC:26335",
      havana_gene : "OTTHUMG00000162837.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95461755,
      stop : 95554977,
      direction : "-",
      ID : "ENSG00000198677.12",
      gene_id : "ENSG00000198677.12",
      gene_type : "protein_coding",
      gene_name : "TTC37",
      gene_level : 2,
      hgnc_id : "HGNC:23639",
      havana_gene : "OTTHUMG00000121165.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95555101,
      stop : 95605102,
      direction : "+",
      ID : "ENSG00000164291.17",
      gene_id : "ENSG00000164291.17",
      gene_type : "protein_coding",
      gene_name : "ARSK",
      gene_level : 1,
      hgnc_id : "HGNC:25239",
      havana_gene : "OTTHUMG00000121166.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95620087,
      stop : 95622142,
      direction : "+",
      ID : "ENSG00000178015.5",
      gene_id : "ENSG00000178015.5",
      gene_type : "protein_coding",
      gene_name : "GPR150",
      gene_level : 2,
      hgnc_id : "HGNC:23628",
      havana_gene : "OTTHUMG00000121170.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95646754,
      stop : 95684773,
      direction : "+",
      ID : "ENSG00000175449.14",
      gene_id : "ENSG00000175449.14",
      gene_type : "protein_coding",
      gene_name : "RFESD",
      gene_level : 1,
      hgnc_id : "HGNC:29587",
      havana_gene : "OTTHUMG00000121168.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95652181,
      stop : 95698711,
      direction : "-",
      ID : "ENSG00000145757.16",
      gene_id : "ENSG00000145757.16",
      gene_type : "protein_coding",
      gene_name : "SPATA9",
      gene_level : 2,
      hgnc_id : "HGNC:22988",
      havana_gene : "OTTHUMG00000121169.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95713522,
      stop : 95824383,
      direction : "+",
      ID : "ENSG00000164292.13",
      gene_id : "ENSG00000164292.13",
      gene_type : "protein_coding",
      gene_name : "RHOBTB3",
      gene_level : 2,
      hgnc_id : "HGNC:18757",
      havana_gene : "OTTHUMG00000121171.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95751319,
      stop : 95822726,
      direction : "-",
      ID : "ENSG00000173221.14",
      gene_id : "ENSG00000173221.14",
      gene_type : "protein_coding",
      gene_name : "GLRX",
      gene_level : 2,
      hgnc_id : "HGNC:4330",
      havana_gene : "OTTHUMG00000121167.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 95885098,
      stop : 95961851,
      direction : "-",
      ID : "ENSG00000118985.16",
      gene_id : "ENSG00000118985.16",
      gene_type : "protein_coding",
      gene_name : "ELL2",
      gene_level : 2,
      hgnc_id : "HGNC:17064",
      havana_gene : "OTTHUMG00000122085.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 96390333,
      stop : 96434143,
      direction : "-",
      ID : "ENSG00000175426.11",
      gene_id : "ENSG00000175426.11",
      gene_type : "protein_coding",
      gene_name : "PCSK1",
      gene_level : 2,
      hgnc_id : "HGNC:8743",
      havana_gene : "OTTHUMG00000122089.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 96525267,
      stop : 96779595,
      direction : "+",
      ID : "ENSG00000153113.24",
      gene_id : "ENSG00000153113.24",
      gene_type : "protein_coding",
      gene_name : "CAST",
      gene_level : 1,
      hgnc_id : "HGNC:1515",
      havana_gene : "OTTHUMG00000128413.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 96760810,
      stop : 96808100,
      direction : "-",
      ID : "ENSG00000164307.13",
      gene_id : "ENSG00000164307.13",
      gene_type : "protein_coding",
      gene_name : "ERAP1",
      gene_level : 1,
      hgnc_id : "HGNC:18173",
      havana_gene : "OTTHUMG00000128721.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 96875986,
      stop : 96919703,
      direction : "+",
      ID : "ENSG00000164308.17",
      gene_id : "ENSG00000164308.17",
      gene_type : "protein_coding",
      gene_name : "ERAP2",
      gene_level : 1,
      hgnc_id : "HGNC:29499",
      havana_gene : "OTTHUMG00000128718.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 96935394,
      stop : 97037513,
      direction : "+",
      ID : "ENSG00000113441.16",
      gene_id : "ENSG00000113441.16",
      gene_type : "protein_coding",
      gene_name : "LNPEP",
      gene_level : 1,
      hgnc_id : "HGNC:6656",
      havana_gene : "OTTHUMG00000128719.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 97091867,
      stop : 97142753,
      direction : "-",
      ID : "ENSG00000145721.12",
      gene_id : "ENSG00000145721.12",
      gene_type : "protein_coding",
      gene_name : "LIX1",
      gene_level : 2,
      hgnc_id : "HGNC:18581",
      havana_gene : "OTTHUMG00000128720.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 97160867,
      stop : 97183247,
      direction : "-",
      ID : "ENSG00000058729.11",
      gene_id : "ENSG00000058729.11",
      gene_type : "protein_coding",
      gene_name : "RIOK2",
      gene_level : 1,
      hgnc_id : "HGNC:18999",
      havana_gene : "OTTHUMG00000128723.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 98768650,
      stop : 98798643,
      direction : "+",
      ID : "ENSG00000174136.13",
      gene_id : "ENSG00000174136.13",
      gene_type : "protein_coding",
      gene_name : "RGMB",
      gene_level : 2,
      hgnc_id : "HGNC:26896",
      havana_gene : "OTTHUMG00000162745.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 98853985,
      stop : 98929007,
      direction : "-",
      ID : "ENSG00000153922.11",
      gene_id : "ENSG00000153922.11",
      gene_type : "protein_coding",
      gene_name : "CHD1",
      gene_level : 2,
      hgnc_id : "HGNC:1915",
      havana_gene : "OTTHUMG00000162744.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 100535374,
      stop : 100586741,
      direction : "+",
      ID : "ENSG00000174132.9",
      gene_id : "ENSG00000174132.9",
      gene_type : "protein_coding",
      gene_name : "FAM174A",
      gene_level : 1,
      hgnc_id : "HGNC:24943",
      havana_gene : "OTTHUMG00000128726.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 100806933,
      stop : 100903282,
      direction : "-",
      ID : "ENSG00000113532.13",
      gene_id : "ENSG00000113532.13",
      gene_type : "protein_coding",
      gene_name : "ST8SIA4",
      gene_level : 1,
      hgnc_id : "HGNC:10871",
      havana_gene : "OTTHUMG00000128727.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 102233986,
      stop : 102296284,
      direction : "-",
      ID : "ENSG00000173930.9",
      gene_id : "ENSG00000173930.9",
      gene_type : "protein_coding",
      gene_name : "SLCO4C1",
      gene_level : 2,
      hgnc_id : "HGNC:23612",
      havana_gene : "OTTHUMG00000162757.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 102371774,
      stop : 102499016,
      direction : "-",
      ID : "ENSG00000205359.10",
      gene_id : "ENSG00000205359.10",
      gene_type : "protein_coding",
      gene_name : "SLCO6A1",
      gene_level : 2,
      hgnc_id : "HGNC:23613",
      havana_gene : "OTTHUMG00000162759.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 102753981,
      stop : 103031105,
      direction : "+",
      ID : "ENSG00000145730.20",
      gene_id : "ENSG00000145730.20",
      gene_type : "protein_coding",
      gene_name : "PAM",
      gene_level : 1,
      hgnc_id : "HGNC:8596",
      havana_gene : "OTTHUMG00000128729.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 103086000,
      stop : 103120138,
      direction : "-",
      ID : "ENSG00000145723.17",
      gene_id : "ENSG00000145723.17",
      gene_type : "protein_coding",
      gene_name : "GIN1",
      gene_level : 2,
      hgnc_id : "HGNC:25959",
      havana_gene : "OTTHUMG00000162811.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 103120149,
      stop : 103212799,
      direction : "+",
      ID : "ENSG00000145725.20",
      gene_id : "ENSG00000145725.20",
      gene_type : "protein_coding",
      gene_name : "PPIP5K2",
      gene_level : 1,
      hgnc_id : "HGNC:29035",
      havana_gene : "OTTHUMG00000181461.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 103258763,
      stop : 103278660,
      direction : "+",
      ID : "ENSG00000181751.10",
      gene_id : "ENSG00000181751.10",
      gene_type : "protein_coding",
      gene_name : "MACIR",
      gene_level : 2,
      hgnc_id : "HGNC:25052",
      havana_gene : "OTTHUMG00000128738.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 103548855,
      stop : 103562790,
      direction : "-",
      ID : "ENSG00000112874.10",
      gene_id : "ENSG00000112874.10",
      gene_type : "protein_coding",
      gene_name : "NUDT12",
      gene_level : 1,
      hgnc_id : "HGNC:18826",
      havana_gene : "OTTHUMG00000128739.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 107376894,
      stop : 107670937,
      direction : "-",
      ID : "ENSG00000184349.14",
      gene_id : "ENSG00000184349.14",
      gene_type : "protein_coding",
      gene_name : "EFNA5",
      gene_level : 1,
      hgnc_id : "HGNC:3225",
      havana_gene : "OTTHUMG00000128741.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 107859035,
      stop : 108382098,
      direction : "-",
      ID : "ENSG00000145743.17",
      gene_id : "ENSG00000145743.17",
      gene_type : "protein_coding",
      gene_name : "FBXL17",
      gene_level : 2,
      hgnc_id : "HGNC:13615",
      havana_gene : "OTTHUMG00000159785.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 108747841,
      stop : 109196841,
      direction : "+",
      ID : "ENSG00000151422.13",
      gene_id : "ENSG00000151422.13",
      gene_type : "protein_coding",
      gene_name : "FER",
      gene_level : 2,
      hgnc_id : "HGNC:3655",
      havana_gene : "OTTHUMG00000128751.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 109334713,
      stop : 109409974,
      direction : "-",
      ID : "ENSG00000198961.10",
      gene_id : "ENSG00000198961.10",
      gene_type : "protein_coding",
      gene_name : "PJA2",
      gene_level : 2,
      hgnc_id : "HGNC:17481",
      havana_gene : "OTTHUMG00000128750.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 109689927,
      stop : 109869625,
      direction : "+",
      ID : "ENSG00000112893.10",
      gene_id : "ENSG00000112893.10",
      gene_type : "protein_coding",
      gene_name : "MAN2A1",
      gene_level : 1,
      hgnc_id : "HGNC:6824",
      havana_gene : "OTTHUMG00000162834.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 110289233,
      stop : 110738956,
      direction : "-",
      ID : "ENSG00000186952.15",
      gene_id : "ENSG00000186952.15",
      gene_type : "protein_coding",
      gene_name : "TMEM232",
      gene_level : 1,
      hgnc_id : "HGNC:37270",
      havana_gene : "OTTHUMG00000163297.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 110738136,
      stop : 110765161,
      direction : "+",
      ID : "ENSG00000164209.17",
      gene_id : "ENSG00000164209.17",
      gene_type : "protein_coding",
      gene_name : "SLC25A46",
      gene_level : 1,
      hgnc_id : "HGNC:25198",
      havana_gene : "OTTHUMG00000128794.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 111070062,
      stop : 111078026,
      direction : "+",
      ID : "ENSG00000145777.15",
      gene_id : "ENSG00000145777.15",
      gene_type : "protein_coding",
      gene_name : "TSLP",
      gene_level : 1,
      hgnc_id : "HGNC:30743",
      havana_gene : "OTTHUMG00000128791.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 111091716,
      stop : 111130502,
      direction : "+",
      ID : "ENSG00000134987.12",
      gene_id : "ENSG00000134987.12",
      gene_type : "protein_coding",
      gene_name : "WDR36",
      gene_level : 1,
      hgnc_id : "HGNC:30696",
      havana_gene : "OTTHUMG00000128790.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 111223653,
      stop : 111494886,
      direction : "+",
      ID : "ENSG00000152495.11",
      gene_id : "ENSG00000152495.11",
      gene_type : "protein_coding",
      gene_name : "CAMK4",
      gene_level : 2,
      hgnc_id : "HGNC:1464",
      havana_gene : "OTTHUMG00000128792.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 111496033,
      stop : 111512590,
      direction : "-",
      ID : "ENSG00000164211.13",
      gene_id : "ENSG00000164211.13",
      gene_type : "protein_coding",
      gene_name : "STARD4",
      gene_level : 2,
      hgnc_id : "HGNC:18058",
      havana_gene : "OTTHUMG00000128793.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 111662621,
      stop : 111997464,
      direction : "-",
      ID : "ENSG00000134986.14",
      gene_id : "ENSG00000134986.14",
      gene_type : "protein_coding",
      gene_name : "NREP",
      gene_level : 1,
      hgnc_id : "HGNC:16834",
      havana_gene : "OTTHUMG00000128795.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 112142441,
      stop : 112419313,
      direction : "-",
      ID : "ENSG00000129595.14",
      gene_id : "ENSG00000129595.14",
      gene_type : "protein_coding",
      gene_name : "EPB41L4A",
      gene_level : 2,
      hgnc_id : "HGNC:13278",
      havana_gene : "OTTHUMG00000162902.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 112707498,
      stop : 112846239,
      direction : "+",
      ID : "ENSG00000134982.17",
      gene_id : "ENSG00000134982.17",
      gene_type : "protein_coding",
      gene_name : "APC",
      gene_level : 2,
      hgnc_id : "HGNC:583",
      havana_gene : "OTTHUMG00000128806.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 112827213,
      stop : 112867582,
      direction : "+",
      ID : "ENSG00000258864.1",
      gene_id : "ENSG00000258864.1",
      gene_type : "protein_coding",
      gene_name : "AC008575.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000171788.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 112861188,
      stop : 112898371,
      direction : "+",
      ID : "ENSG00000153037.15",
      gene_id : "ENSG00000153037.15",
      gene_type : "protein_coding",
      gene_name : "SRP19",
      gene_level : 1,
      hgnc_id : "HGNC:11300",
      havana_gene : "OTTHUMG00000186064.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 112876385,
      stop : 112922289,
      direction : "-",
      ID : "ENSG00000129625.13",
      gene_id : "ENSG00000129625.13",
      gene_type : "protein_coding",
      gene_name : "REEP5",
      gene_level : 1,
      hgnc_id : "HGNC:30077",
      havana_gene : "OTTHUMG00000128807.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 112976702,
      stop : 113022195,
      direction : "+",
      ID : "ENSG00000172795.17",
      gene_id : "ENSG00000172795.17",
      gene_type : "protein_coding",
      gene_name : "DCP2",
      gene_level : 1,
      hgnc_id : "HGNC:24452",
      havana_gene : "OTTHUMG00000162853.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 113022099,
      stop : 113488823,
      direction : "-",
      ID : "ENSG00000171444.18",
      gene_id : "ENSG00000171444.18",
      gene_type : "protein_coding",
      gene_name : "MCC",
      gene_level : 2,
      hgnc_id : "HGNC:6935",
      havana_gene : "OTTHUMG00000128804.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 113432553,
      stop : 113434989,
      direction : "-",
      ID : "ENSG00000212122.4",
      gene_id : "ENSG00000212122.4",
      gene_type : "protein_coding",
      gene_name : "TSSK1B",
      gene_level : 2,
      hgnc_id : "HGNC:14968",
      havana_gene : "OTTHUMG00000128835.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 113513694,
      stop : 113595285,
      direction : "+",
      ID : "ENSG00000047188.16",
      gene_id : "ENSG00000047188.16",
      gene_type : "protein_coding",
      gene_name : "YTHDC2",
      gene_level : 1,
      hgnc_id : "HGNC:24721",
      havana_gene : "OTTHUMG00000128837.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 114055926,
      stop : 114496500,
      direction : "+",
      ID : "ENSG00000080709.16",
      gene_id : "ENSG00000080709.16",
      gene_type : "protein_coding",
      gene_name : "KCNN2",
      gene_level : 2,
      hgnc_id : "HGNC:6291",
      havana_gene : "OTTHUMG00000128836.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115124762,
      stop : 115180546,
      direction : "-",
      ID : "ENSG00000152503.10",
      gene_id : "ENSG00000152503.10",
      gene_type : "protein_coding",
      gene_name : "TRIM36",
      gene_level : 1,
      hgnc_id : "HGNC:16280",
      havana_gene : "OTTHUMG00000128892.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115204012,
      stop : 115262877,
      direction : "-",
      ID : "ENSG00000164219.10",
      gene_id : "ENSG00000164219.10",
      gene_type : "protein_coding",
      gene_name : "PGGT1B",
      gene_level : 2,
      hgnc_id : "HGNC:8895",
      havana_gene : "OTTHUMG00000128893.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115267190,
      stop : 115296693,
      direction : "-",
      ID : "ENSG00000164221.13",
      gene_id : "ENSG00000164221.13",
      gene_type : "protein_coding",
      gene_name : "CCDC112",
      gene_level : 1,
      hgnc_id : "HGNC:28599",
      havana_gene : "OTTHUMG00000128894.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115520908,
      stop : 115544775,
      direction : "-",
      ID : "ENSG00000145780.8",
      gene_id : "ENSG00000145780.8",
      gene_type : "protein_coding",
      gene_name : "FEM1C",
      gene_level : 2,
      hgnc_id : "HGNC:16933",
      havana_gene : "OTTHUMG00000128895.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115578496,
      stop : 115602479,
      direction : "-",
      ID : "ENSG00000243414.6",
      gene_id : "ENSG00000243414.6",
      gene_type : "protein_coding",
      gene_name : "TICAM2",
      gene_level : 1,
      hgnc_id : "HGNC:21354",
      havana_gene : "OTTHUMG00000162905.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115578642,
      stop : 115626161,
      direction : "-",
      ID : "ENSG00000251201.8",
      gene_id : "ENSG00000251201.8",
      gene_type : "protein_coding",
      gene_name : "TMED7-TICAM2",
      gene_level : 2,
      hgnc_id : "HGNC:33945",
      havana_gene : "OTTHUMG00000162911.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115613210,
      stop : 115632992,
      direction : "-",
      ID : "ENSG00000134970.14",
      gene_id : "ENSG00000134970.14",
      gene_type : "protein_coding",
      gene_name : "TMED7",
      gene_level : 1,
      hgnc_id : "HGNC:24253",
      havana_gene : "OTTHUMG00000132013.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115804733,
      stop : 115816659,
      direction : "-",
      ID : "ENSG00000129596.5",
      gene_id : "ENSG00000129596.5",
      gene_type : "protein_coding",
      gene_name : "CDO1",
      gene_level : 2,
      hgnc_id : "HGNC:1795",
      havana_gene : "OTTHUMG00000128891.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115828200,
      stop : 115841837,
      direction : "-",
      ID : "ENSG00000145782.13",
      gene_id : "ENSG00000145782.13",
      gene_type : "protein_coding",
      gene_name : "ATG12",
      gene_level : 2,
      hgnc_id : "HGNC:588",
      havana_gene : "OTTHUMG00000128889.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115841592,
      stop : 115914081,
      direction : "+",
      ID : "ENSG00000177879.17",
      gene_id : "ENSG00000177879.17",
      gene_type : "protein_coding",
      gene_name : "AP3S1",
      gene_level : 2,
      hgnc_id : "HGNC:2013",
      havana_gene : "OTTHUMG00000128887.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 115962454,
      stop : 116027619,
      direction : "+",
      ID : "ENSG00000172901.20",
      gene_id : "ENSG00000172901.20",
      gene_type : "protein_coding",
      gene_name : "LVRN",
      gene_level : 1,
      hgnc_id : "HGNC:26904",
      havana_gene : "OTTHUMG00000128890.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 116032324,
      stop : 116060118,
      direction : "+",
      ID : "ENSG00000268223.6",
      gene_id : "ENSG00000268223.6",
      gene_type : "protein_coding",
      gene_name : "ARL14EPL",
      gene_level : 2,
      hgnc_id : "HGNC:44201",
      havana_gene : "OTTHUMG00000182725.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 116085016,
      stop : 116412762,
      direction : "+",
      ID : "ENSG00000145781.9",
      gene_id : "ENSG00000145781.9",
      gene_type : "protein_coding",
      gene_name : "COMMD10",
      gene_level : 2,
      hgnc_id : "HGNC:30201",
      havana_gene : "OTTHUMG00000162922.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 116443555,
      stop : 116574823,
      direction : "-",
      ID : "ENSG00000092421.17",
      gene_id : "ENSG00000092421.17",
      gene_type : "protein_coding",
      gene_name : "SEMA6A",
      gene_level : 2,
      hgnc_id : "HGNC:10738",
      havana_gene : "OTTHUMG00000162987.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 118836074,
      stop : 118988547,
      direction : "-",
      ID : "ENSG00000169570.10",
      gene_id : "ENSG00000169570.10",
      gene_type : "protein_coding",
      gene_name : "DTWD2",
      gene_level : 2,
      hgnc_id : "HGNC:19334",
      havana_gene : "OTTHUMG00000162956.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 119037772,
      stop : 119249138,
      direction : "+",
      ID : "ENSG00000172869.14",
      gene_id : "ENSG00000172869.14",
      gene_type : "protein_coding",
      gene_name : "DMXL1",
      gene_level : 2,
      hgnc_id : "HGNC:2937",
      havana_gene : "OTTHUMG00000128898.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 119268692,
      stop : 119399688,
      direction : "+",
      ID : "ENSG00000145779.8",
      gene_id : "ENSG00000145779.8",
      gene_type : "protein_coding",
      gene_name : "TNFAIP8",
      gene_level : 1,
      hgnc_id : "HGNC:17260",
      havana_gene : "OTTHUMG00000162949.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 119452473,
      stop : 119637199,
      direction : "+",
      ID : "ENSG00000133835.17",
      gene_id : "ENSG00000133835.17",
      gene_type : "protein_coding",
      gene_name : "HSD17B4",
      gene_level : 1,
      hgnc_id : "HGNC:5213",
      havana_gene : "OTTHUMG00000128899.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 119629559,
      stop : 119635822,
      direction : "+",
      ID : "ENSG00000164334.15",
      gene_id : "ENSG00000164334.15",
      gene_type : "protein_coding",
      gene_name : "FAM170A",
      gene_level : 2,
      hgnc_id : "HGNC:27963",
      havana_gene : "OTTHUMG00000162946.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 120464300,
      stop : 120687332,
      direction : "+",
      ID : "ENSG00000184838.15",
      gene_id : "ENSG00000184838.15",
      gene_type : "protein_coding",
      gene_name : "PRR16",
      gene_level : 2,
      hgnc_id : "HGNC:29654",
      havana_gene : "OTTHUMG00000128903.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 121851882,
      stop : 121852833,
      direction : "+",
      ID : "ENSG00000181867.3",
      gene_id : "ENSG00000181867.3",
      gene_type : "protein_coding",
      gene_name : "FTMT",
      gene_level : 2,
      hgnc_id : "HGNC:17345",
      havana_gene : "OTTHUMG00000128912.2",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 121961975,
      stop : 122075570,
      direction : "+",
      ID : "ENSG00000151304.6",
      gene_id : "ENSG00000151304.6",
      gene_type : "protein_coding",
      gene_name : "SRFBP1",
      gene_level : 2,
      hgnc_id : "HGNC:26333",
      havana_gene : "OTTHUMG00000162970.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 122063195,
      stop : 122078413,
      direction : "-",
      ID : "ENSG00000113083.15",
      gene_id : "ENSG00000113083.15",
      gene_type : "protein_coding",
      gene_name : "LOX",
      gene_level : 2,
      hgnc_id : "HGNC:6664",
      havana_gene : "OTTHUMG00000128914.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 122129546,
      stop : 122153569,
      direction : "+",
      ID : "ENSG00000164185.6",
      gene_id : "ENSG00000164185.6",
      gene_type : "protein_coding",
      gene_name : "ZNF474",
      gene_level : 2,
      hgnc_id : "HGNC:23245",
      havana_gene : "OTTHUMG00000128911.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 122129622,
      stop : 122183949,
      direction : "+",
      ID : "ENSG00000250803.6",
      gene_id : "ENSG00000250803.6",
      gene_type : "protein_coding",
      gene_name : "AC010255.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162972.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 122311354,
      stop : 122464219,
      direction : "+",
      ID : "ENSG00000064692.20",
      gene_id : "ENSG00000064692.20",
      gene_type : "protein_coding",
      gene_name : "SNCAIP",
      gene_level : 1,
      hgnc_id : "HGNC:11139",
      havana_gene : "OTTHUMG00000128915.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 122775079,
      stop : 122834543,
      direction : "+",
      ID : "ENSG00000205302.7",
      gene_id : "ENSG00000205302.7",
      gene_type : "protein_coding",
      gene_name : "SNX2",
      gene_level : 1,
      hgnc_id : "HGNC:11173",
      havana_gene : "OTTHUMG00000163020.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 122843439,
      stop : 123029354,
      direction : "+",
      ID : "ENSG00000064652.11",
      gene_id : "ENSG00000064652.11",
      gene_type : "protein_coding",
      gene_name : "SNX24",
      gene_level : 2,
      hgnc_id : "HGNC:21533",
      havana_gene : "OTTHUMG00000128913.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 123023250,
      stop : 123036725,
      direction : "-",
      ID : "ENSG00000168938.6",
      gene_id : "ENSG00000168938.6",
      gene_type : "protein_coding",
      gene_name : "PPIC",
      gene_level : 2,
      hgnc_id : "HGNC:9256",
      havana_gene : "OTTHUMG00000128921.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 123089241,
      stop : 123194266,
      direction : "+",
      ID : "ENSG00000061455.11",
      gene_id : "ENSG00000061455.11",
      gene_type : "protein_coding",
      gene_name : "PRDM6",
      gene_level : 2,
      hgnc_id : "HGNC:9350",
      havana_gene : "OTTHUMG00000150469.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 123344890,
      stop : 123423592,
      direction : "-",
      ID : "ENSG00000168944.17",
      gene_id : "ENSG00000168944.17",
      gene_type : "protein_coding",
      gene_name : "CEP120",
      gene_level : 1,
      hgnc_id : "HGNC:26690",
      havana_gene : "OTTHUMG00000128922.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 123512099,
      stop : 123617045,
      direction : "+",
      ID : "ENSG00000151292.17",
      gene_id : "ENSG00000151292.17",
      gene_type : "protein_coding",
      gene_name : "CSNK1G3",
      gene_level : 2,
      hgnc_id : "HGNC:2456",
      havana_gene : "OTTHUMG00000128923.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 124636913,
      stop : 124748807,
      direction : "-",
      ID : "ENSG00000168916.15",
      gene_id : "ENSG00000168916.15",
      gene_type : "protein_coding",
      gene_name : "ZNF608",
      gene_level : 1,
      hgnc_id : "HGNC:29238",
      havana_gene : "OTTHUMG00000162999.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 126360132,
      stop : 126496494,
      direction : "+",
      ID : "ENSG00000155324.10",
      gene_id : "ENSG00000155324.10",
      gene_type : "protein_coding",
      gene_name : "GRAMD2B",
      gene_level : 2,
      hgnc_id : "HGNC:24911",
      havana_gene : "OTTHUMG00000128943.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 126531200,
      stop : 126595362,
      direction : "-",
      ID : "ENSG00000164904.18",
      gene_id : "ENSG00000164904.18",
      gene_type : "protein_coding",
      gene_name : "ALDH7A1",
      gene_level : 1,
      hgnc_id : "HGNC:877",
      havana_gene : "OTTHUMG00000128942.26",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 126600925,
      stop : 126627252,
      direction : "+",
      ID : "ENSG00000164902.14",
      gene_id : "ENSG00000164902.14",
      gene_type : "protein_coding",
      gene_name : "PHAX",
      gene_level : 2,
      hgnc_id : "HGNC:10241",
      havana_gene : "OTTHUMG00000163273.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 126631705,
      stop : 126636284,
      direction : "+",
      ID : "ENSG00000196900.5",
      gene_id : "ENSG00000196900.5",
      gene_type : "protein_coding",
      gene_name : "TEX43",
      gene_level : 2,
      hgnc_id : "HGNC:33767",
      havana_gene : "OTTHUMG00000128944.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 126776623,
      stop : 126837020,
      direction : "+",
      ID : "ENSG00000113368.12",
      gene_id : "ENSG00000113368.12",
      gene_type : "protein_coding",
      gene_name : "LMNB1",
      gene_level : 2,
      hgnc_id : "HGNC:6637",
      havana_gene : "OTTHUMG00000128969.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 126867714,
      stop : 127030558,
      direction : "-",
      ID : "ENSG00000173926.6",
      gene_id : "ENSG00000173926.6",
      gene_type : "protein_coding",
      gene_name : "MARCHF3",
      gene_level : 2,
      hgnc_id : "HGNC:28728",
      havana_gene : "OTTHUMG00000128968.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 127042558,
      stop : 127073492,
      direction : "-",
      ID : "ENSG00000164241.13",
      gene_id : "ENSG00000164241.13",
      gene_type : "protein_coding",
      gene_name : "C5orf63",
      gene_level : 2,
      hgnc_id : "HGNC:40051",
      havana_gene : "OTTHUMG00000163037.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 127290796,
      stop : 127465737,
      direction : "+",
      ID : "ENSG00000145794.17",
      gene_id : "ENSG00000145794.17",
      gene_type : "protein_coding",
      gene_name : "MEGF10",
      gene_level : 1,
      hgnc_id : "HGNC:29634",
      havana_gene : "OTTHUMG00000128984.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 127517640,
      stop : 127555085,
      direction : "+",
      ID : "ENSG00000164244.21",
      gene_id : "ENSG00000164244.21",
      gene_type : "protein_coding",
      gene_name : "PRRC1",
      gene_level : 2,
      hgnc_id : "HGNC:28164",
      havana_gene : "OTTHUMG00000128982.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 127649044,
      stop : 127658630,
      direction : "+",
      ID : "ENSG00000205279.8",
      gene_id : "ENSG00000205279.8",
      gene_type : "protein_coding",
      gene_name : "CTXN3",
      gene_level : 2,
      hgnc_id : "HGNC:31110",
      havana_gene : "OTTHUMG00000163285.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 127703389,
      stop : 127941634,
      direction : "+",
      ID : "ENSG00000230561.5",
      gene_id : "ENSG00000230561.5",
      gene_type : "protein_coding",
      gene_name : "CCDC192",
      gene_level : 1,
      hgnc_id : "HGNC:49566",
      havana_gene : "OTTHUMG00000163284.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 128083766,
      stop : 128189677,
      direction : "+",
      ID : "ENSG00000064651.14",
      gene_id : "ENSG00000064651.14",
      gene_type : "protein_coding",
      gene_name : "SLC12A2",
      gene_level : 2,
      hgnc_id : "HGNC:10911",
      havana_gene : "OTTHUMG00000128983.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 128257909,
      stop : 128659185,
      direction : "-",
      ID : "ENSG00000138829.12",
      gene_id : "ENSG00000138829.12",
      gene_type : "protein_coding",
      gene_name : "FBN2",
      gene_level : 1,
      hgnc_id : "HGNC:3604",
      havana_gene : "OTTHUMG00000163082.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 128538013,
      stop : 129033642,
      direction : "+",
      ID : "ENSG00000113396.13",
      gene_id : "ENSG00000113396.13",
      gene_type : "protein_coding",
      gene_name : "SLC27A6",
      gene_level : 2,
      hgnc_id : "HGNC:11000",
      havana_gene : "OTTHUMG00000128991.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 129094749,
      stop : 129114028,
      direction : "+",
      ID : "ENSG00000066583.12",
      gene_id : "ENSG00000066583.12",
      gene_type : "protein_coding",
      gene_name : "ISOC1",
      gene_level : 1,
      hgnc_id : "HGNC:24254",
      havana_gene : "OTTHUMG00000163144.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 129460281,
      stop : 129738683,
      direction : "+",
      ID : "ENSG00000145808.10",
      gene_id : "ENSG00000145808.10",
      gene_type : "protein_coding",
      gene_name : "ADAMTS19",
      gene_level : 2,
      hgnc_id : "HGNC:17111",
      havana_gene : "OTTHUMG00000128990.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 129748094,
      stop : 129766732,
      direction : "+",
      ID : "ENSG00000186367.7",
      gene_id : "ENSG00000186367.7",
      gene_type : "protein_coding",
      gene_name : "MINAR2",
      gene_level : 1,
      hgnc_id : "HGNC:33914",
      havana_gene : "OTTHUMG00000163041.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 129904465,
      stop : 130186634,
      direction : "+",
      ID : "ENSG00000198108.4",
      gene_id : "ENSG00000198108.4",
      gene_type : "protein_coding",
      gene_name : "CHSY3",
      gene_level : 2,
      hgnc_id : "HGNC:24293",
      havana_gene : "OTTHUMG00000163043.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131155383,
      stop : 131224468,
      direction : "-",
      ID : "ENSG00000169567.13",
      gene_id : "ENSG00000169567.13",
      gene_type : "protein_coding",
      gene_name : "HINT1",
      gene_level : 1,
      hgnc_id : "HGNC:4912",
      havana_gene : "OTTHUMG00000128995.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131170944,
      stop : 131205428,
      direction : "+",
      ID : "ENSG00000186687.16",
      gene_id : "ENSG00000186687.16",
      gene_type : "protein_coding",
      gene_name : "LYRM7",
      gene_level : 1,
      hgnc_id : "HGNC:28072",
      havana_gene : "OTTHUMG00000128994.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131245493,
      stop : 131398447,
      direction : "+",
      ID : "ENSG00000158985.14",
      gene_id : "ENSG00000158985.14",
      gene_type : "protein_coding",
      gene_name : "CDC42SE2",
      gene_level : 1,
      hgnc_id : "HGNC:18547",
      havana_gene : "OTTHUMG00000162692.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131423921,
      stop : 131635231,
      direction : "-",
      ID : "ENSG00000158987.22",
      gene_id : "ENSG00000158987.22",
      gene_type : "protein_coding",
      gene_name : "RAPGEF6",
      gene_level : 1,
      hgnc_id : "HGNC:20655",
      havana_gene : "OTTHUMG00000162683.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131425891,
      stop : 131796983,
      direction : "-",
      ID : "ENSG00000273217.1",
      gene_id : "ENSG00000273217.1",
      gene_type : "protein_coding",
      gene_name : "AC008695.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000162686.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131641714,
      stop : 131797063,
      direction : "-",
      ID : "ENSG00000217128.12",
      gene_id : "ENSG00000217128.12",
      gene_type : "protein_coding",
      gene_name : "FNIP1",
      gene_level : 1,
      hgnc_id : "HGNC:29418",
      havana_gene : "OTTHUMG00000186338.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131806990,
      stop : 131945698,
      direction : "-",
      ID : "ENSG00000239642.6",
      gene_id : "ENSG00000239642.6",
      gene_type : "protein_coding",
      gene_name : "MEIKIN",
      gene_level : 2,
      hgnc_id : "HGNC:51253",
      havana_gene : "OTTHUMG00000059633.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131807143,
      stop : 132011637,
      direction : "-",
      ID : "ENSG00000281938.2",
      gene_id : "ENSG00000281938.2",
      gene_type : "protein_coding",
      gene_name : "AC034228.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191412.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 131949973,
      stop : 132012243,
      direction : "-",
      ID : "ENSG00000164398.15",
      gene_id : "ENSG00000164398.15",
      gene_type : "protein_coding",
      gene_name : "ACSL6",
      gene_level : 1,
      hgnc_id : "HGNC:16496",
      havana_gene : "OTTHUMG00000150692.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132060655,
      stop : 132063204,
      direction : "+",
      ID : "ENSG00000164399.5",
      gene_id : "ENSG00000164399.5",
      gene_type : "protein_coding",
      gene_name : "IL3",
      gene_level : 2,
      hgnc_id : "HGNC:6011",
      havana_gene : "OTTHUMG00000059640.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132073789,
      stop : 132076170,
      direction : "+",
      ID : "ENSG00000164400.6",
      gene_id : "ENSG00000164400.6",
      gene_type : "protein_coding",
      gene_name : "CSF2",
      gene_level : 2,
      hgnc_id : "HGNC:2434",
      havana_gene : "OTTHUMG00000059637.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132190147,
      stop : 132295315,
      direction : "-",
      ID : "ENSG00000072682.20",
      gene_id : "ENSG00000072682.20",
      gene_type : "protein_coding",
      gene_name : "P4HA2",
      gene_level : 1,
      hgnc_id : "HGNC:8547",
      havana_gene : "OTTHUMG00000059647.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132257696,
      stop : 132273454,
      direction : "+",
      ID : "ENSG00000131435.13",
      gene_id : "ENSG00000131435.13",
      gene_type : "protein_coding",
      gene_name : "PDLIM4",
      gene_level : 1,
      hgnc_id : "HGNC:16501",
      havana_gene : "OTTHUMG00000059645.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132294394,
      stop : 132344190,
      direction : "+",
      ID : "ENSG00000197208.6",
      gene_id : "ENSG00000197208.6",
      gene_type : "protein_coding",
      gene_name : "SLC22A4",
      gene_level : 2,
      hgnc_id : "HGNC:10968",
      havana_gene : "OTTHUMG00000059648.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132369710,
      stop : 132395613,
      direction : "+",
      ID : "ENSG00000197375.13",
      gene_id : "ENSG00000197375.13",
      gene_type : "protein_coding",
      gene_name : "SLC22A5",
      gene_level : 2,
      hgnc_id : "HGNC:10969",
      havana_gene : "OTTHUMG00000059634.15",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132410832,
      stop : 132646079,
      direction : "+",
      ID : "ENSG00000283782.2",
      gene_id : "ENSG00000283782.2",
      gene_type : "protein_coding",
      gene_name : "AC116366.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000059495.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132440440,
      stop : 132508719,
      direction : "-",
      ID : "ENSG00000125347.15",
      gene_id : "ENSG00000125347.15",
      gene_type : "protein_coding",
      gene_name : "IRF1",
      gene_level : 2,
      hgnc_id : "HGNC:6116",
      havana_gene : "OTTHUMG00000059497.17",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132541445,
      stop : 132556838,
      direction : "-",
      ID : "ENSG00000113525.10",
      gene_id : "ENSG00000113525.10",
      gene_type : "protein_coding",
      gene_name : "IL5",
      gene_level : 2,
      hgnc_id : "HGNC:6016",
      havana_gene : "OTTHUMG00000059496.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132556019,
      stop : 132646349,
      direction : "+",
      ID : "ENSG00000113522.14",
      gene_id : "ENSG00000113522.14",
      gene_type : "protein_coding",
      gene_name : "RAD50",
      gene_level : 1,
      hgnc_id : "HGNC:9816",
      havana_gene : "OTTHUMG00000059613.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132656263,
      stop : 132661110,
      direction : "+",
      ID : "ENSG00000169194.9",
      gene_id : "ENSG00000169194.9",
      gene_type : "protein_coding",
      gene_name : "IL13",
      gene_level : 2,
      hgnc_id : "HGNC:5973",
      havana_gene : "OTTHUMG00000059723.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132673986,
      stop : 132682678,
      direction : "+",
      ID : "ENSG00000113520.11",
      gene_id : "ENSG00000113520.11",
      gene_type : "protein_coding",
      gene_name : "IL4",
      gene_level : 1,
      hgnc_id : "HGNC:6014",
      havana_gene : "OTTHUMG00000059724.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132692628,
      stop : 132737638,
      direction : "-",
      ID : "ENSG00000131437.16",
      gene_id : "ENSG00000131437.16",
      gene_type : "protein_coding",
      gene_name : "KIF3A",
      gene_level : 2,
      hgnc_id : "HGNC:6319",
      havana_gene : "OTTHUMG00000059725.18",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132747426,
      stop : 132754403,
      direction : "+",
      ID : "ENSG00000205089.8",
      gene_id : "ENSG00000205089.8",
      gene_type : "protein_coding",
      gene_name : "CCNI2",
      gene_level : 1,
      hgnc_id : "HGNC:33869",
      havana_gene : "OTTHUMG00000059737.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132750819,
      stop : 132807241,
      direction : "-",
      ID : "ENSG00000164402.14",
      gene_id : "ENSG00000164402.14",
      gene_type : "protein_coding",
      gene_name : "SEPTIN8",
      gene_level : 1,
      hgnc_id : "HGNC:16511",
      havana_gene : "OTTHUMG00000059735.15",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132813302,
      stop : 132816786,
      direction : "+",
      ID : "ENSG00000198944.6",
      gene_id : "ENSG00000198944.6",
      gene_type : "protein_coding",
      gene_name : "SOWAHA",
      gene_level : 2,
      hgnc_id : "HGNC:27033",
      havana_gene : "OTTHUMG00000059844.3",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132822141,
      stop : 132830659,
      direction : "-",
      ID : "ENSG00000164403.15",
      gene_id : "ENSG00000164403.15",
      gene_type : "protein_coding",
      gene_name : "SHROOM1",
      gene_level : 2,
      hgnc_id : "HGNC:24084",
      havana_gene : "OTTHUMG00000059835.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132861181,
      stop : 132866884,
      direction : "-",
      ID : "ENSG00000164404.8",
      gene_id : "ENSG00000164404.8",
      gene_type : "protein_coding",
      gene_name : "GDF9",
      gene_level : 2,
      hgnc_id : "HGNC:4224",
      havana_gene : "OTTHUMG00000059842.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132866630,
      stop : 132868847,
      direction : "+",
      ID : "ENSG00000164405.11",
      gene_id : "ENSG00000164405.11",
      gene_type : "protein_coding",
      gene_name : "UQCRQ",
      gene_level : 2,
      hgnc_id : "HGNC:29594",
      havana_gene : "OTTHUMG00000059836.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132873444,
      stop : 132875046,
      direction : "+",
      ID : "ENSG00000164406.8",
      gene_id : "ENSG00000164406.8",
      gene_type : "protein_coding",
      gene_name : "LEAP2",
      gene_level : 2,
      hgnc_id : "HGNC:29571",
      havana_gene : "OTTHUMG00000059837.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132875395,
      stop : 132963634,
      direction : "-",
      ID : "ENSG00000072364.13",
      gene_id : "ENSG00000072364.13",
      gene_type : "protein_coding",
      gene_name : "AFF4",
      gene_level : 2,
      hgnc_id : "HGNC:17869",
      havana_gene : "OTTHUMG00000059838.10",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 132996985,
      stop : 133026604,
      direction : "-",
      ID : "ENSG00000155329.12",
      gene_id : "ENSG00000155329.12",
      gene_type : "protein_coding",
      gene_name : "ZCCHC10",
      gene_level : 1,
      hgnc_id : "HGNC:25954",
      havana_gene : "OTTHUMG00000129013.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 133052013,
      stop : 133106449,
      direction : "+",
      ID : "ENSG00000170606.15",
      gene_id : "ENSG00000170606.15",
      gene_type : "protein_coding",
      gene_name : "HSPA4",
      gene_level : 2,
      hgnc_id : "HGNC:5237",
      havana_gene : "OTTHUMG00000129012.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 133196455,
      stop : 133612541,
      direction : "-",
      ID : "ENSG00000053108.17",
      gene_id : "ENSG00000053108.17",
      gene_type : "protein_coding",
      gene_name : "FSTL4",
      gene_level : 2,
      hgnc_id : "HGNC:21389",
      havana_gene : "OTTHUMG00000162729.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 133955510,
      stop : 133968674,
      direction : "-",
      ID : "ENSG00000113583.8",
      gene_id : "ENSG00000113583.8",
      gene_type : "protein_coding",
      gene_name : "C5orf15",
      gene_level : 2,
      hgnc_id : "HGNC:20656",
      havana_gene : "OTTHUMG00000129125.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 133971871,
      stop : 134004975,
      direction : "-",
      ID : "ENSG00000213585.11",
      gene_id : "ENSG00000213585.11",
      gene_type : "protein_coding",
      gene_name : "VDAC1",
      gene_level : 2,
      hgnc_id : "HGNC:12669",
      havana_gene : "OTTHUMG00000129118.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134114681,
      stop : 134151865,
      direction : "+",
      ID : "ENSG00000081059.20",
      gene_id : "ENSG00000081059.20",
      gene_type : "protein_coding",
      gene_name : "TCF7",
      gene_level : 1,
      hgnc_id : "HGNC:11639",
      havana_gene : "OTTHUMG00000129124.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134148935,
      stop : 134176964,
      direction : "-",
      ID : "ENSG00000113558.19",
      gene_id : "ENSG00000113558.19",
      gene_type : "protein_coding",
      gene_name : "SKP1",
      gene_level : 2,
      hgnc_id : "HGNC:10899",
      havana_gene : "OTTHUMG00000129117.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134167170,
      stop : 134226071,
      direction : "-",
      ID : "ENSG00000272772.1",
      gene_id : "ENSG00000272772.1",
      gene_type : "protein_coding",
      gene_name : "AC104109.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186510.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134194332,
      stop : 134226073,
      direction : "-",
      ID : "ENSG00000113575.10",
      gene_id : "ENSG00000113575.10",
      gene_type : "protein_coding",
      gene_name : "PPP2CA",
      gene_level : 1,
      hgnc_id : "HGNC:9299",
      havana_gene : "OTTHUMG00000129119.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134286350,
      stop : 134371047,
      direction : "-",
      ID : "ENSG00000006837.12",
      gene_id : "ENSG00000006837.12",
      gene_type : "protein_coding",
      gene_name : "CDKL3",
      gene_level : 1,
      hgnc_id : "HGNC:15483",
      havana_gene : "OTTHUMG00000186341.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134371469,
      stop : 134392108,
      direction : "+",
      ID : "ENSG00000119048.8",
      gene_id : "ENSG00000119048.8",
      gene_type : "protein_coding",
      gene_name : "UBE2B",
      gene_level : 2,
      hgnc_id : "HGNC:12473",
      havana_gene : "OTTHUMG00000129120.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134402065,
      stop : 134411881,
      direction : "-",
      ID : "ENSG00000237190.4",
      gene_id : "ENSG00000237190.4",
      gene_type : "protein_coding",
      gene_name : "CDKN2AIPNL",
      gene_level : 2,
      hgnc_id : "HGNC:30545",
      havana_gene : "OTTHUMG00000129123.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134524312,
      stop : 134583230,
      direction : "+",
      ID : "ENSG00000043143.21",
      gene_id : "ENSG00000043143.21",
      gene_type : "protein_coding",
      gene_name : "JADE2",
      gene_level : 1,
      hgnc_id : "HGNC:22984",
      havana_gene : "OTTHUMG00000129122.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134601149,
      stop : 134649271,
      direction : "-",
      ID : "ENSG00000152700.14",
      gene_id : "ENSG00000152700.14",
      gene_type : "protein_coding",
      gene_name : "SAR1B",
      gene_level : 2,
      hgnc_id : "HGNC:10535",
      havana_gene : "OTTHUMG00000129114.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134648785,
      stop : 134727909,
      direction : "+",
      ID : "ENSG00000113615.13",
      gene_id : "ENSG00000113615.13",
      gene_type : "protein_coding",
      gene_name : "SEC24A",
      gene_level : 2,
      hgnc_id : "HGNC:10703",
      havana_gene : "OTTHUMG00000163064.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134738495,
      stop : 134752157,
      direction : "+",
      ID : "ENSG00000164615.6",
      gene_id : "ENSG00000164615.6",
      gene_type : "protein_coding",
      gene_name : "CAMLG",
      gene_level : 1,
      hgnc_id : "HGNC:1471",
      havana_gene : "OTTHUMG00000129116.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134758771,
      stop : 134855133,
      direction : "+",
      ID : "ENSG00000145833.16",
      gene_id : "ENSG00000145833.16",
      gene_type : "protein_coding",
      gene_name : "DDX46",
      gene_level : 2,
      hgnc_id : "HGNC:18681",
      havana_gene : "OTTHUMG00000163072.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134845680,
      stop : 134859735,
      direction : "+",
      ID : "ENSG00000181904.9",
      gene_id : "ENSG00000181904.9",
      gene_type : "protein_coding",
      gene_name : "C5orf24",
      gene_level : 1,
      hgnc_id : "HGNC:26746",
      havana_gene : "OTTHUMG00000129121.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134874371,
      stop : 134901635,
      direction : "+",
      ID : "ENSG00000113621.15",
      gene_id : "ENSG00000113621.15",
      gene_type : "protein_coding",
      gene_name : "TXNDC15",
      gene_level : 1,
      hgnc_id : "HGNC:20652",
      havana_gene : "OTTHUMG00000129115.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134905120,
      stop : 135007959,
      direction : "+",
      ID : "ENSG00000132570.15",
      gene_id : "ENSG00000132570.15",
      gene_type : "protein_coding",
      gene_name : "PCBD2",
      gene_level : 2,
      hgnc_id : "HGNC:24474",
      havana_gene : "OTTHUMG00000163070.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 134967907,
      stop : 135011696,
      direction : "+",
      ID : "ENSG00000152705.8",
      gene_id : "ENSG00000152705.8",
      gene_type : "protein_coding",
      gene_name : "CATSPER3",
      gene_level : 2,
      hgnc_id : "HGNC:20819",
      havana_gene : "OTTHUMG00000129137.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135027734,
      stop : 135034813,
      direction : "-",
      ID : "ENSG00000069011.16",
      gene_id : "ENSG00000069011.16",
      gene_type : "protein_coding",
      gene_name : "PITX1",
      gene_level : 2,
      hgnc_id : "HGNC:9004",
      havana_gene : "OTTHUMG00000149983.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135333900,
      stop : 135399914,
      direction : "-",
      ID : "ENSG00000113648.16",
      gene_id : "ENSG00000113648.16",
      gene_type : "protein_coding",
      gene_name : "MACROH2A1",
      gene_level : 1,
      hgnc_id : "HGNC:4740",
      havana_gene : "OTTHUMG00000129141.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135444214,
      stop : 135447348,
      direction : "-",
      ID : "ENSG00000251380.3",
      gene_id : "ENSG00000251380.3",
      gene_type : "protein_coding",
      gene_name : "DCANP1",
      gene_level : 2,
      hgnc_id : "HGNC:24459",
      havana_gene : "OTTHUMG00000163308.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135444226,
      stop : 135452351,
      direction : "-",
      ID : "ENSG00000255833.2",
      gene_id : "ENSG00000255833.2",
      gene_type : "protein_coding",
      gene_name : "TIFAB",
      gene_level : 2,
      hgnc_id : "HGNC:34024",
      havana_gene : "OTTHUMG00000129140.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135534282,
      stop : 135535964,
      direction : "-",
      ID : "ENSG00000181965.6",
      gene_id : "ENSG00000181965.6",
      gene_type : "protein_coding",
      gene_name : "NEUROG1",
      gene_level : 2,
      hgnc_id : "HGNC:7764",
      havana_gene : "OTTHUMG00000129138.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135570679,
      stop : 135579279,
      direction : "-",
      ID : "ENSG00000145824.13",
      gene_id : "ENSG00000145824.13",
      gene_type : "protein_coding",
      gene_name : "CXCL14",
      gene_level : 2,
      hgnc_id : "HGNC:10640",
      havana_gene : "OTTHUMG00000129139.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135579202,
      stop : 135889770,
      direction : "+",
      ID : "ENSG00000145832.14",
      gene_id : "ENSG00000145832.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A48",
      gene_level : 1,
      hgnc_id : "HGNC:30451",
      havana_gene : "OTTHUMG00000157007.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135892246,
      stop : 135895841,
      direction : "-",
      ID : "ENSG00000145839.2",
      gene_id : "ENSG00000145839.2",
      gene_type : "protein_coding",
      gene_name : "IL9",
      gene_level : 2,
      hgnc_id : "HGNC:6029",
      havana_gene : "OTTHUMG00000129147.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 135922279,
      stop : 135954983,
      direction : "-",
      ID : "ENSG00000145826.9",
      gene_id : "ENSG00000145826.9",
      gene_type : "protein_coding",
      gene_name : "LECT2",
      gene_level : 1,
      hgnc_id : "HGNC:6550",
      havana_gene : "OTTHUMG00000129146.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 136028988,
      stop : 136063818,
      direction : "+",
      ID : "ENSG00000120708.17",
      gene_id : "ENSG00000120708.17",
      gene_type : "protein_coding",
      gene_name : "TGFBI",
      gene_level : 1,
      hgnc_id : "HGNC:11771",
      havana_gene : "OTTHUMG00000163213.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 136132845,
      stop : 136188747,
      direction : "+",
      ID : "ENSG00000113658.18",
      gene_id : "ENSG00000113658.18",
      gene_type : "protein_coding",
      gene_name : "SMAD5",
      gene_level : 2,
      hgnc_id : "HGNC:6771",
      havana_gene : "OTTHUMG00000163212.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 136191468,
      stop : 136193162,
      direction : "-",
      ID : "ENSG00000271824.2",
      gene_id : "ENSG00000271824.2",
      gene_type : "protein_coding",
      gene_name : "SMIM32",
      gene_level : 2,
      hgnc_id : "HGNC:53640",
      havana_gene : "OTTHUMG00000185564.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 136212745,
      stop : 136365545,
      direction : "-",
      ID : "ENSG00000069018.19",
      gene_id : "ENSG00000069018.19",
      gene_type : "protein_coding",
      gene_name : "TRPC7",
      gene_level : 1,
      hgnc_id : "HGNC:20754",
      havana_gene : "OTTHUMG00000189265.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 136975298,
      stop : 137598379,
      direction : "-",
      ID : "ENSG00000152377.14",
      gene_id : "ENSG00000152377.14",
      gene_type : "protein_coding",
      gene_name : "SPOCK1",
      gene_level : 2,
      hgnc_id : "HGNC:11251",
      havana_gene : "OTTHUMG00000129157.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 137617500,
      stop : 137736089,
      direction : "-",
      ID : "ENSG00000146021.15",
      gene_id : "ENSG00000146021.15",
      gene_type : "protein_coding",
      gene_name : "KLHL3",
      gene_level : 1,
      hgnc_id : "HGNC:6354",
      havana_gene : "OTTHUMG00000129155.14",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 137745651,
      stop : 137754363,
      direction : "-",
      ID : "ENSG00000177733.7",
      gene_id : "ENSG00000177733.7",
      gene_type : "protein_coding",
      gene_name : "HNRNPA0",
      gene_level : 2,
      hgnc_id : "HGNC:5030",
      havana_gene : "OTTHUMG00000129156.3",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 137867858,
      stop : 137887851,
      direction : "+",
      ID : "ENSG00000120729.10",
      gene_id : "ENSG00000120729.10",
      gene_type : "protein_coding",
      gene_name : "MYOT",
      gene_level : 1,
      hgnc_id : "HGNC:12399",
      havana_gene : "OTTHUMG00000129154.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 137887968,
      stop : 137942747,
      direction : "+",
      ID : "ENSG00000078795.17",
      gene_id : "ENSG00000078795.17",
      gene_type : "protein_coding",
      gene_name : "PKD2L2",
      gene_level : 1,
      hgnc_id : "HGNC:9012",
      havana_gene : "OTTHUMG00000163306.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 137937960,
      stop : 138051961,
      direction : "-",
      ID : "ENSG00000031003.10",
      gene_id : "ENSG00000031003.10",
      gene_type : "protein_coding",
      gene_name : "FAM13B",
      gene_level : 2,
      hgnc_id : "HGNC:1335",
      havana_gene : "OTTHUMG00000129202.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138083990,
      stop : 138092365,
      direction : "+",
      ID : "ENSG00000061492.12",
      gene_id : "ENSG00000061492.12",
      gene_type : "protein_coding",
      gene_name : "WNT8A",
      gene_level : 2,
      hgnc_id : "HGNC:12788",
      havana_gene : "OTTHUMG00000129196.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138115175,
      stop : 138139443,
      direction : "-",
      ID : "ENSG00000112981.5",
      gene_id : "ENSG00000112981.5",
      gene_type : "protein_coding",
      gene_name : "NME5",
      gene_level : 2,
      hgnc_id : "HGNC:7853",
      havana_gene : "OTTHUMG00000129207.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138139770,
      stop : 138178953,
      direction : "-",
      ID : "ENSG00000112983.18",
      gene_id : "ENSG00000112983.18",
      gene_type : "protein_coding",
      gene_name : "BRD8",
      gene_level : 1,
      hgnc_id : "HGNC:19874",
      havana_gene : "OTTHUMG00000129204.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138178719,
      stop : 138187723,
      direction : "+",
      ID : "ENSG00000112984.12",
      gene_id : "ENSG00000112984.12",
      gene_type : "protein_coding",
      gene_name : "KIF20A",
      gene_level : 2,
      hgnc_id : "HGNC:9787",
      havana_gene : "OTTHUMG00000129195.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138187650,
      stop : 138213343,
      direction : "-",
      ID : "ENSG00000094880.11",
      gene_id : "ENSG00000094880.11",
      gene_type : "protein_coding",
      gene_name : "CDC23",
      gene_level : 1,
      hgnc_id : "HGNC:1724",
      havana_gene : "OTTHUMG00000129198.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138252380,
      stop : 138274621,
      direction : "-",
      ID : "ENSG00000146013.11",
      gene_id : "ENSG00000146013.11",
      gene_type : "protein_coding",
      gene_name : "GFRA3",
      gene_level : 2,
      hgnc_id : "HGNC:4245",
      havana_gene : "OTTHUMG00000129200.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138285269,
      stop : 138338355,
      direction : "-",
      ID : "ENSG00000158402.21",
      gene_id : "ENSG00000158402.21",
      gene_type : "protein_coding",
      gene_name : "CDC25C",
      gene_level : 1,
      hgnc_id : "HGNC:1727",
      havana_gene : "OTTHUMG00000129203.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138331935,
      stop : 138349729,
      direction : "+",
      ID : "ENSG00000120709.11",
      gene_id : "ENSG00000120709.11",
      gene_type : "protein_coding",
      gene_name : "FAM53C",
      gene_level : 2,
      hgnc_id : "HGNC:1336",
      havana_gene : "OTTHUMG00000129201.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138352685,
      stop : 138437028,
      direction : "+",
      ID : "ENSG00000120733.14",
      gene_id : "ENSG00000120733.14",
      gene_type : "protein_coding",
      gene_name : "KDM3B",
      gene_level : 2,
      hgnc_id : "HGNC:1337",
      havana_gene : "OTTHUMG00000163469.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138439057,
      stop : 138446969,
      direction : "+",
      ID : "ENSG00000132563.16",
      gene_id : "ENSG00000132563.16",
      gene_type : "protein_coding",
      gene_name : "REEP2",
      gene_level : 1,
      hgnc_id : "HGNC:17975",
      havana_gene : "OTTHUMG00000129205.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138465479,
      stop : 138469303,
      direction : "+",
      ID : "ENSG00000120738.8",
      gene_id : "ENSG00000120738.8",
      gene_type : "protein_coding",
      gene_name : "EGR1",
      gene_level : 2,
      hgnc_id : "HGNC:3238",
      havana_gene : "OTTHUMG00000129197.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138506095,
      stop : 138543236,
      direction : "-",
      ID : "ENSG00000120705.13",
      gene_id : "ENSG00000120705.13",
      gene_type : "protein_coding",
      gene_name : "ETF1",
      gene_level : 1,
      hgnc_id : "HGNC:3477",
      havana_gene : "OTTHUMG00000129199.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138553756,
      stop : 138575675,
      direction : "-",
      ID : "ENSG00000113013.16",
      gene_id : "ENSG00000113013.16",
      gene_type : "protein_coding",
      gene_name : "HSPA9",
      gene_level : 2,
      hgnc_id : "HGNC:5244",
      havana_gene : "OTTHUMG00000129206.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138610967,
      stop : 138935034,
      direction : "+",
      ID : "ENSG00000044115.21",
      gene_id : "ENSG00000044115.21",
      gene_type : "protein_coding",
      gene_name : "CTNNA1",
      gene_level : 1,
      hgnc_id : "HGNC:2509",
      havana_gene : "OTTHUMG00000163502.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138868921,
      stop : 138875368,
      direction : "-",
      ID : "ENSG00000146006.8",
      gene_id : "ENSG00000146006.8",
      gene_type : "protein_coding",
      gene_name : "LRRTM2",
      gene_level : 1,
      hgnc_id : "HGNC:19409",
      havana_gene : "OTTHUMG00000163535.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 138946724,
      stop : 139293557,
      direction : "-",
      ID : "ENSG00000120725.13",
      gene_id : "ENSG00000120725.13",
      gene_type : "protein_coding",
      gene_name : "SIL1",
      gene_level : 2,
      hgnc_id : "HGNC:24624",
      havana_gene : "OTTHUMG00000129226.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139273752,
      stop : 139331671,
      direction : "+",
      ID : "ENSG00000280987.4",
      gene_id : "ENSG00000280987.4",
      gene_type : "protein_coding",
      gene_name : "MATR3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000189583.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139293674,
      stop : 139331677,
      direction : "+",
      ID : "ENSG00000015479.20",
      gene_id : "ENSG00000015479.20",
      gene_type : "protein_coding",
      gene_name : "MATR3",
      gene_level : 1,
      hgnc_id : "HGNC:6912",
      havana_gene : "OTTHUMG00000129229.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139341587,
      stop : 139369720,
      direction : "+",
      ID : "ENSG00000120727.13",
      gene_id : "ENSG00000120727.13",
      gene_type : "protein_coding",
      gene_name : "PAIP2",
      gene_level : 1,
      hgnc_id : "HGNC:17970",
      havana_gene : "OTTHUMG00000129227.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139367196,
      stop : 139384553,
      direction : "-",
      ID : "ENSG00000170482.17",
      gene_id : "ENSG00000170482.17",
      gene_type : "protein_coding",
      gene_name : "SLC23A1",
      gene_level : 2,
      hgnc_id : "HGNC:10974",
      havana_gene : "OTTHUMG00000129228.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139387467,
      stop : 139390081,
      direction : "-",
      ID : "ENSG00000170476.16",
      gene_id : "ENSG00000170476.16",
      gene_type : "protein_coding",
      gene_name : "MZB1",
      gene_level : 1,
      hgnc_id : "HGNC:30125",
      havana_gene : "OTTHUMG00000163390.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139390592,
      stop : 139395104,
      direction : "-",
      ID : "ENSG00000228672.4",
      gene_id : "ENSG00000228672.4",
      gene_type : "protein_coding",
      gene_name : "PROB1",
      gene_level : 2,
      hgnc_id : "HGNC:41906",
      havana_gene : "OTTHUMG00000185568.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139396563,
      stop : 139404089,
      direction : "-",
      ID : "ENSG00000170469.11",
      gene_id : "ENSG00000170469.11",
      gene_type : "protein_coding",
      gene_name : "SPATA24",
      gene_level : 2,
      hgnc_id : "HGNC:27322",
      havana_gene : "OTTHUMG00000163388.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139408588,
      stop : 139444491,
      direction : "-",
      ID : "ENSG00000170464.10",
      gene_id : "ENSG00000170464.10",
      gene_type : "protein_coding",
      gene_name : "DNAJC18",
      gene_level : 1,
      hgnc_id : "HGNC:28429",
      havana_gene : "OTTHUMG00000129225.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139442316,
      stop : 139462707,
      direction : "-",
      ID : "ENSG00000279686.1",
      gene_id : "ENSG00000279686.1",
      gene_type : "protein_coding",
      gene_name : "AC142391.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189234.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139448560,
      stop : 139462743,
      direction : "-",
      ID : "ENSG00000249751.4",
      gene_id : "ENSG00000249751.4",
      gene_type : "protein_coding",
      gene_name : "ECSCR",
      gene_level : 2,
      hgnc_id : "HGNC:35454",
      havana_gene : "OTTHUMG00000163240.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139470778,
      stop : 139474772,
      direction : "+",
      ID : "ENSG00000283288.1",
      gene_id : "ENSG00000283288.1",
      gene_type : "protein_coding",
      gene_name : "SMIM33",
      gene_level : 2,
      hgnc_id : "HGNC:53645",
      havana_gene : "OTTHUMG00000191731.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139475533,
      stop : 139482935,
      direction : "-",
      ID : "ENSG00000184584.13",
      gene_id : "ENSG00000184584.13",
      gene_type : "protein_coding",
      gene_name : "STING1",
      gene_level : 1,
      hgnc_id : "HGNC:27962",
      havana_gene : "OTTHUMG00000129239.22",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139526431,
      stop : 139628434,
      direction : "+",
      ID : "ENSG00000131508.16",
      gene_id : "ENSG00000131508.16",
      gene_type : "protein_coding",
      gene_name : "UBE2D2",
      gene_level : 2,
      hgnc_id : "HGNC:12475",
      havana_gene : "OTTHUMG00000163282.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139647299,
      stop : 139683882,
      direction : "+",
      ID : "ENSG00000171604.12",
      gene_id : "ENSG00000171604.12",
      gene_type : "protein_coding",
      gene_name : "CXXC5",
      gene_level : 2,
      hgnc_id : "HGNC:26943",
      havana_gene : "OTTHUMG00000163331.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139795808,
      stop : 139844466,
      direction : "+",
      ID : "ENSG00000146005.4",
      gene_id : "ENSG00000146005.4",
      gene_type : "protein_coding",
      gene_name : "PSD2",
      gene_level : 2,
      hgnc_id : "HGNC:19092",
      havana_gene : "OTTHUMG00000129240.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 139846779,
      stop : 140043299,
      direction : "-",
      ID : "ENSG00000158458.21",
      gene_id : "ENSG00000158458.21",
      gene_type : "protein_coding",
      gene_name : "NRG2",
      gene_level : 2,
      hgnc_id : "HGNC:7998",
      havana_gene : "OTTHUMG00000129241.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140107777,
      stop : 140125619,
      direction : "+",
      ID : "ENSG00000185129.8",
      gene_id : "ENSG00000185129.8",
      gene_type : "protein_coding",
      gene_name : "PURA",
      gene_level : 1,
      hgnc_id : "HGNC:9701",
      havana_gene : "OTTHUMG00000129242.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140125937,
      stop : 140129392,
      direction : "+",
      ID : "ENSG00000182700.5",
      gene_id : "ENSG00000182700.5",
      gene_type : "protein_coding",
      gene_name : "IGIP",
      gene_level : 2,
      hgnc_id : "HGNC:33847",
      havana_gene : "OTTHUMG00000163359.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140175156,
      stop : 140282052,
      direction : "+",
      ID : "ENSG00000120306.11",
      gene_id : "ENSG00000120306.11",
      gene_type : "protein_coding",
      gene_name : "CYSTM1",
      gene_level : 1,
      hgnc_id : "HGNC:30239",
      havana_gene : "OTTHUMG00000129243.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140245035,
      stop : 140303113,
      direction : "-",
      ID : "ENSG00000113068.10",
      gene_id : "ENSG00000113068.10",
      gene_type : "protein_coding",
      gene_name : "PFDN1",
      gene_level : 2,
      hgnc_id : "HGNC:8866",
      havana_gene : "OTTHUMG00000129249.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140332843,
      stop : 140346603,
      direction : "-",
      ID : "ENSG00000113070.8",
      gene_id : "ENSG00000113070.8",
      gene_type : "protein_coding",
      gene_name : "HBEGF",
      gene_level : 2,
      hgnc_id : "HGNC:3059",
      havana_gene : "OTTHUMG00000129496.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140360194,
      stop : 140375141,
      direction : "+",
      ID : "ENSG00000113073.15",
      gene_id : "ENSG00000113073.15",
      gene_type : "protein_coding",
      gene_name : "SLC4A9",
      gene_level : 2,
      hgnc_id : "HGNC:11035",
      havana_gene : "OTTHUMG00000163352.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140401814,
      stop : 140539856,
      direction : "+",
      ID : "ENSG00000131503.21",
      gene_id : "ENSG00000131503.21",
      gene_type : "protein_coding",
      gene_name : "ANKHD1",
      gene_level : 1,
      hgnc_id : "HGNC:24714",
      havana_gene : "OTTHUMG00000161610.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140401908,
      stop : 140549569,
      direction : "+",
      ID : "ENSG00000254996.5",
      gene_id : "ENSG00000254996.5",
      gene_type : "protein_coding",
      gene_name : "ANKHD1-EIF4EBP3",
      gene_level : 2,
      hgnc_id : "HGNC:33530",
      havana_gene : "OTTHUMG00000166212.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140537340,
      stop : 140558252,
      direction : "-",
      ID : "ENSG00000213523.11",
      gene_id : "ENSG00000213523.11",
      gene_type : "protein_coding",
      gene_name : "SRA1",
      gene_level : 1,
      hgnc_id : "HGNC:11281",
      havana_gene : "OTTHUMG00000163569.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140547662,
      stop : 140549576,
      direction : "+",
      ID : "ENSG00000243056.2",
      gene_id : "ENSG00000243056.2",
      gene_type : "protein_coding",
      gene_name : "EIF4EBP3",
      gene_level : 2,
      hgnc_id : "HGNC:3290",
      havana_gene : "OTTHUMG00000129498.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140558268,
      stop : 140564781,
      direction : "-",
      ID : "ENSG00000113108.20",
      gene_id : "ENSG00000113108.20",
      gene_type : "protein_coding",
      gene_name : "APBB3",
      gene_level : 1,
      hgnc_id : "HGNC:20708",
      havana_gene : "OTTHUMG00000191657.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140564446,
      stop : 140569100,
      direction : "+",
      ID : "ENSG00000176087.16",
      gene_id : "ENSG00000176087.16",
      gene_type : "protein_coding",
      gene_name : "SLC35A4",
      gene_level : 2,
      hgnc_id : "HGNC:20753",
      havana_gene : "OTTHUMG00000129495.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140631728,
      stop : 140633701,
      direction : "-",
      ID : "ENSG00000170458.14",
      gene_id : "ENSG00000170458.14",
      gene_type : "protein_coding",
      gene_name : "CD14",
      gene_level : 1,
      hgnc_id : "HGNC:1628",
      havana_gene : "OTTHUMG00000129507.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140638740,
      stop : 140647771,
      direction : "-",
      ID : "ENSG00000131495.9",
      gene_id : "ENSG00000131495.9",
      gene_type : "protein_coding",
      gene_name : "NDUFA2",
      gene_level : 1,
      hgnc_id : "HGNC:7685",
      havana_gene : "OTTHUMG00000129505.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140639435,
      stop : 140645408,
      direction : "+",
      ID : "ENSG00000113119.13",
      gene_id : "ENSG00000113119.13",
      gene_type : "protein_coding",
      gene_name : "TMCO6",
      gene_level : 1,
      hgnc_id : "HGNC:28814",
      havana_gene : "OTTHUMG00000129497.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140647058,
      stop : 140662480,
      direction : "+",
      ID : "ENSG00000113141.18",
      gene_id : "ENSG00000113141.18",
      gene_type : "protein_coding",
      gene_name : "IK",
      gene_level : 1,
      hgnc_id : "HGNC:5958",
      havana_gene : "OTTHUMG00000163374.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140664676,
      stop : 140674124,
      direction : "+",
      ID : "ENSG00000120314.18",
      gene_id : "ENSG00000120314.18",
      gene_type : "protein_coding",
      gene_name : "WDR55",
      gene_level : 2,
      hgnc_id : "HGNC:25971",
      havana_gene : "OTTHUMG00000129506.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140670794,
      stop : 140673576,
      direction : "-",
      ID : "ENSG00000256453.2",
      gene_id : "ENSG00000256453.2",
      gene_type : "protein_coding",
      gene_name : "DND1",
      gene_level : 2,
      hgnc_id : "HGNC:23799",
      havana_gene : "OTTHUMG00000129499.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140673035,
      stop : 140691537,
      direction : "-",
      ID : "ENSG00000170445.16",
      gene_id : "ENSG00000170445.16",
      gene_type : "protein_coding",
      gene_name : "HARS1",
      gene_level : 2,
      hgnc_id : "HGNC:4816",
      havana_gene : "OTTHUMG00000129502.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140691430,
      stop : 140699305,
      direction : "+",
      ID : "ENSG00000112855.17",
      gene_id : "ENSG00000112855.17",
      gene_type : "protein_coding",
      gene_name : "HARS2",
      gene_level : 2,
      hgnc_id : "HGNC:4817",
      havana_gene : "OTTHUMG00000129500.19",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140698680,
      stop : 140706686,
      direction : "+",
      ID : "ENSG00000146007.11",
      gene_id : "ENSG00000146007.11",
      gene_type : "protein_coding",
      gene_name : "ZMAT2",
      gene_level : 1,
      hgnc_id : "HGNC:26433",
      havana_gene : "OTTHUMG00000129503.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140786136,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204970.10",
      gene_id : "ENSG00000204970.10",
      gene_type : "protein_coding",
      gene_name : "PCDHA1",
      gene_level : 2,
      hgnc_id : "HGNC:8663",
      havana_gene : "OTTHUMG00000163368.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140794852,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204969.7",
      gene_id : "ENSG00000204969.7",
      gene_type : "protein_coding",
      gene_name : "PCDHA2",
      gene_level : 1,
      hgnc_id : "HGNC:8668",
      havana_gene : "OTTHUMG00000163363.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140801028,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000255408.4",
      gene_id : "ENSG00000255408.4",
      gene_type : "protein_coding",
      gene_name : "PCDHA3",
      gene_level : 2,
      hgnc_id : "HGNC:8669",
      havana_gene : "OTTHUMG00000163357.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140806929,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204967.12",
      gene_id : "ENSG00000204967.12",
      gene_type : "protein_coding",
      gene_name : "PCDHA4",
      gene_level : 2,
      hgnc_id : "HGNC:8670",
      havana_gene : "OTTHUMG00000163360.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140821604,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204965.9",
      gene_id : "ENSG00000204965.9",
      gene_type : "protein_coding",
      gene_name : "PCDHA5",
      gene_level : 2,
      hgnc_id : "HGNC:8671",
      havana_gene : "OTTHUMG00000163367.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140827958,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000081842.18",
      gene_id : "ENSG00000081842.18",
      gene_type : "protein_coding",
      gene_name : "PCDHA6",
      gene_level : 2,
      hgnc_id : "HGNC:8672",
      havana_gene : "OTTHUMG00000163353.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140834248,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204963.6",
      gene_id : "ENSG00000204963.6",
      gene_type : "protein_coding",
      gene_name : "PCDHA7",
      gene_level : 2,
      hgnc_id : "HGNC:8673",
      havana_gene : "OTTHUMG00000163371.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140841187,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204962.6",
      gene_id : "ENSG00000204962.6",
      gene_type : "protein_coding",
      gene_name : "PCDHA8",
      gene_level : 2,
      hgnc_id : "HGNC:8674",
      havana_gene : "OTTHUMG00000163354.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140847772,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000204961.7",
      gene_id : "ENSG00000204961.7",
      gene_type : "protein_coding",
      gene_name : "PCDHA9",
      gene_level : 2,
      hgnc_id : "HGNC:8675",
      havana_gene : "OTTHUMG00000163373.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140855883,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000250120.8",
      gene_id : "ENSG00000250120.8",
      gene_type : "protein_coding",
      gene_name : "PCDHA10",
      gene_level : 2,
      hgnc_id : "HGNC:8664",
      havana_gene : "OTTHUMG00000163372.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140868183,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000249158.7",
      gene_id : "ENSG00000249158.7",
      gene_type : "protein_coding",
      gene_name : "PCDHA11",
      gene_level : 2,
      hgnc_id : "HGNC:8665",
      havana_gene : "OTTHUMG00000163369.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140875302,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000251664.5",
      gene_id : "ENSG00000251664.5",
      gene_type : "protein_coding",
      gene_name : "PCDHA12",
      gene_level : 2,
      hgnc_id : "HGNC:8666",
      havana_gene : "OTTHUMG00000163366.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140882124,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000239389.8",
      gene_id : "ENSG00000239389.8",
      gene_type : "protein_coding",
      gene_name : "PCDHA13",
      gene_level : 1,
      hgnc_id : "HGNC:8667",
      havana_gene : "OTTHUMG00000129614.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140926299,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000248383.5",
      gene_id : "ENSG00000248383.5",
      gene_type : "protein_coding",
      gene_name : "PCDHAC1",
      gene_level : 2,
      hgnc_id : "HGNC:8676",
      havana_gene : "OTTHUMG00000129603.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 140966470,
      stop : 141012347,
      direction : "+",
      ID : "ENSG00000243232.6",
      gene_id : "ENSG00000243232.6",
      gene_type : "protein_coding",
      gene_name : "PCDHAC2",
      gene_level : 2,
      hgnc_id : "HGNC:8677",
      havana_gene : "OTTHUMG00000129607.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141051374,
      stop : 141059346,
      direction : "+",
      ID : "ENSG00000171815.6",
      gene_id : "ENSG00000171815.6",
      gene_type : "protein_coding",
      gene_name : "PCDHB1",
      gene_level : 2,
      hgnc_id : "HGNC:8680",
      havana_gene : "OTTHUMG00000129627.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141094606,
      stop : 141098703,
      direction : "+",
      ID : "ENSG00000112852.7",
      gene_id : "ENSG00000112852.7",
      gene_type : "protein_coding",
      gene_name : "PCDHB2",
      gene_level : 2,
      hgnc_id : "HGNC:8687",
      havana_gene : "OTTHUMG00000129606.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141100473,
      stop : 141103827,
      direction : "+",
      ID : "ENSG00000113205.5",
      gene_id : "ENSG00000113205.5",
      gene_type : "protein_coding",
      gene_name : "PCDHB3",
      gene_level : 2,
      hgnc_id : "HGNC:8688",
      havana_gene : "OTTHUMG00000129622.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141121818,
      stop : 141125623,
      direction : "+",
      ID : "ENSG00000081818.4",
      gene_id : "ENSG00000081818.4",
      gene_type : "protein_coding",
      gene_name : "PCDHB4",
      gene_level : 2,
      hgnc_id : "HGNC:8689",
      havana_gene : "OTTHUMG00000129617.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141135206,
      stop : 141138615,
      direction : "+",
      ID : "ENSG00000113209.9",
      gene_id : "ENSG00000113209.9",
      gene_type : "protein_coding",
      gene_name : "PCDHB5",
      gene_level : 2,
      hgnc_id : "HGNC:8690",
      havana_gene : "OTTHUMG00000129616.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141150057,
      stop : 141153287,
      direction : "+",
      ID : "ENSG00000113211.6",
      gene_id : "ENSG00000113211.6",
      gene_type : "protein_coding",
      gene_name : "PCDHB6",
      gene_level : 2,
      hgnc_id : "HGNC:8691",
      havana_gene : "OTTHUMG00000129623.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141172644,
      stop : 141176383,
      direction : "+",
      ID : "ENSG00000113212.7",
      gene_id : "ENSG00000113212.7",
      gene_type : "protein_coding",
      gene_name : "PCDHB7",
      gene_level : 2,
      hgnc_id : "HGNC:8692",
      havana_gene : "OTTHUMG00000129608.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141177790,
      stop : 141180539,
      direction : "+",
      ID : "ENSG00000120322.4",
      gene_id : "ENSG00000120322.4",
      gene_type : "protein_coding",
      gene_name : "PCDHB8",
      gene_level : 2,
      hgnc_id : "HGNC:8693",
      havana_gene : "OTTHUMG00000129621.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141182387,
      stop : 141186226,
      direction : "+",
      ID : "ENSG00000272674.4",
      gene_id : "ENSG00000272674.4",
      gene_type : "protein_coding",
      gene_name : "PCDHB16",
      gene_level : 2,
      hgnc_id : "HGNC:14546",
      havana_gene : "OTTHUMG00000188325.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141187127,
      stop : 141191541,
      direction : "+",
      ID : "ENSG00000177839.7",
      gene_id : "ENSG00000177839.7",
      gene_type : "protein_coding",
      gene_name : "PCDHB9",
      gene_level : 2,
      hgnc_id : "HGNC:8694",
      havana_gene : "OTTHUMG00000188326.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141192353,
      stop : 141195647,
      direction : "+",
      ID : "ENSG00000120324.9",
      gene_id : "ENSG00000120324.9",
      gene_type : "protein_coding",
      gene_name : "PCDHB10",
      gene_level : 2,
      hgnc_id : "HGNC:8681",
      havana_gene : "OTTHUMG00000129626.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141199610,
      stop : 141203779,
      direction : "+",
      ID : "ENSG00000197479.7",
      gene_id : "ENSG00000197479.7",
      gene_type : "protein_coding",
      gene_name : "PCDHB11",
      gene_level : 2,
      hgnc_id : "HGNC:8682",
      havana_gene : "OTTHUMG00000129618.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141208697,
      stop : 141212571,
      direction : "+",
      ID : "ENSG00000120328.6",
      gene_id : "ENSG00000120328.6",
      gene_type : "protein_coding",
      gene_name : "PCDHB12",
      gene_level : 2,
      hgnc_id : "HGNC:8683",
      havana_gene : "OTTHUMG00000129620.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141213919,
      stop : 141218979,
      direction : "+",
      ID : "ENSG00000187372.11",
      gene_id : "ENSG00000187372.11",
      gene_type : "protein_coding",
      gene_name : "PCDHB13",
      gene_level : 2,
      hgnc_id : "HGNC:8684",
      havana_gene : "OTTHUMG00000129615.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141223343,
      stop : 141227759,
      direction : "+",
      ID : "ENSG00000120327.7",
      gene_id : "ENSG00000120327.7",
      gene_type : "protein_coding",
      gene_name : "PCDHB14",
      gene_level : 2,
      hgnc_id : "HGNC:8685",
      havana_gene : "OTTHUMG00000129619.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141223372,
      stop : 141245861,
      direction : "+",
      ID : "ENSG00000279983.1",
      gene_id : "ENSG00000279983.1",
      gene_type : "protein_coding",
      gene_name : "AC244517.10",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189134.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141245395,
      stop : 141249365,
      direction : "+",
      ID : "ENSG00000113248.6",
      gene_id : "ENSG00000113248.6",
      gene_type : "protein_coding",
      gene_name : "PCDHB15",
      gene_level : 2,
      hgnc_id : "HGNC:8686",
      havana_gene : "OTTHUMG00000129609.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141260225,
      stop : 141320784,
      direction : "-",
      ID : "ENSG00000178913.8",
      gene_id : "ENSG00000178913.8",
      gene_type : "protein_coding",
      gene_name : "TAF7",
      gene_level : 2,
      hgnc_id : "HGNC:11541",
      havana_gene : "OTTHUMG00000129628.7",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141302635,
      stop : 141304049,
      direction : "-",
      ID : "ENSG00000120329.7",
      gene_id : "ENSG00000120329.7",
      gene_type : "protein_coding",
      gene_name : "SLC25A2",
      gene_level : 2,
      hgnc_id : "HGNC:22921",
      havana_gene : "OTTHUMG00000129604.5",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141330571,
      stop : 141512981,
      direction : "+",
      ID : "ENSG00000204956.5",
      gene_id : "ENSG00000204956.5",
      gene_type : "protein_coding",
      gene_name : "PCDHGA1",
      gene_level : 2,
      hgnc_id : "HGNC:8696",
      havana_gene : "OTTHUMG00000163678.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141338760,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000081853.15",
      gene_id : "ENSG00000081853.15",
      gene_type : "protein_coding",
      gene_name : "PCDHGA2",
      gene_level : 2,
      hgnc_id : "HGNC:8700",
      havana_gene : "OTTHUMG00000163679.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141343829,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000254245.3",
      gene_id : "ENSG00000254245.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGA3",
      gene_level : 2,
      hgnc_id : "HGNC:8701",
      havana_gene : "OTTHUMG00000163680.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141350102,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000254221.2",
      gene_id : "ENSG00000254221.2",
      gene_type : "protein_coding",
      gene_name : "PCDHGB1",
      gene_level : 2,
      hgnc_id : "HGNC:8708",
      havana_gene : "OTTHUMG00000163681.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141355021,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000262576.3",
      gene_id : "ENSG00000262576.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGA4",
      gene_level : 2,
      hgnc_id : "HGNC:8702",
      havana_gene : "OTTHUMG00000177593.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141360042,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000253910.2",
      gene_id : "ENSG00000253910.2",
      gene_type : "protein_coding",
      gene_name : "PCDHGB2",
      gene_level : 2,
      hgnc_id : "HGNC:8709",
      havana_gene : "OTTHUMG00000163682.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141364232,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000253485.2",
      gene_id : "ENSG00000253485.2",
      gene_type : "protein_coding",
      gene_name : "PCDHGA5",
      gene_level : 2,
      hgnc_id : "HGNC:8703",
      havana_gene : "OTTHUMG00000163683.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141370242,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000262209.3",
      gene_id : "ENSG00000262209.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGB3",
      gene_level : 2,
      hgnc_id : "HGNC:8710",
      havana_gene : "OTTHUMG00000177471.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141373891,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000253731.3",
      gene_id : "ENSG00000253731.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGA6",
      gene_level : 2,
      hgnc_id : "HGNC:8704",
      havana_gene : "OTTHUMG00000163684.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141382739,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000253537.3",
      gene_id : "ENSG00000253537.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGA7",
      gene_level : 2,
      hgnc_id : "HGNC:8705",
      havana_gene : "OTTHUMG00000163685.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141387698,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000253953.3",
      gene_id : "ENSG00000253953.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGB4",
      gene_level : 2,
      hgnc_id : "HGNC:8711",
      havana_gene : "OTTHUMG00000163686.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141390157,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000253767.3",
      gene_id : "ENSG00000253767.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGA8",
      gene_level : 2,
      hgnc_id : "HGNC:8706",
      havana_gene : "OTTHUMG00000164053.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141397987,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000276547.1",
      gene_id : "ENSG00000276547.1",
      gene_type : "protein_coding",
      gene_name : "PCDHGB5",
      gene_level : 2,
      hgnc_id : "HGNC:8712",
      havana_gene : "OTTHUMG00000188231.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141402932,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000261934.2",
      gene_id : "ENSG00000261934.2",
      gene_type : "protein_coding",
      gene_name : "PCDHGA9",
      gene_level : 2,
      hgnc_id : "HGNC:8707",
      havana_gene : "OTTHUMG00000177473.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141408021,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000253305.2",
      gene_id : "ENSG00000253305.2",
      gene_type : "protein_coding",
      gene_name : "PCDHGB6",
      gene_level : 2,
      hgnc_id : "HGNC:8713",
      havana_gene : "OTTHUMG00000163687.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141412987,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000253846.2",
      gene_id : "ENSG00000253846.2",
      gene_type : "protein_coding",
      gene_name : "PCDHGA10",
      gene_level : 2,
      hgnc_id : "HGNC:8697",
      havana_gene : "OTTHUMG00000163688.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141417645,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000254122.3",
      gene_id : "ENSG00000254122.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGB7",
      gene_level : 2,
      hgnc_id : "HGNC:8714",
      havana_gene : "OTTHUMG00000164054.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141421047,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000253873.6",
      gene_id : "ENSG00000253873.6",
      gene_type : "protein_coding",
      gene_name : "PCDHGA11",
      gene_level : 2,
      hgnc_id : "HGNC:8698",
      havana_gene : "OTTHUMG00000164055.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141430507,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000253159.3",
      gene_id : "ENSG00000253159.3",
      gene_type : "protein_coding",
      gene_name : "PCDHGA12",
      gene_level : 2,
      hgnc_id : "HGNC:8699",
      havana_gene : "OTTHUMG00000129611.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141475947,
      stop : 141512977,
      direction : "+",
      ID : "ENSG00000240184.7",
      gene_id : "ENSG00000240184.7",
      gene_type : "protein_coding",
      gene_name : "PCDHGC3",
      gene_level : 2,
      hgnc_id : "HGNC:8716",
      havana_gene : "OTTHUMG00000129613.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141484997,
      stop : 141512979,
      direction : "+",
      ID : "ENSG00000242419.5",
      gene_id : "ENSG00000242419.5",
      gene_type : "protein_coding",
      gene_name : "PCDHGC4",
      gene_level : 2,
      hgnc_id : "HGNC:8717",
      havana_gene : "OTTHUMG00000129625.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141489081,
      stop : 141512975,
      direction : "+",
      ID : "ENSG00000240764.4",
      gene_id : "ENSG00000240764.4",
      gene_type : "protein_coding",
      gene_name : "PCDHGC5",
      gene_level : 2,
      hgnc_id : "HGNC:8718",
      havana_gene : "OTTHUMG00000129624.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141515016,
      stop : 141619055,
      direction : "-",
      ID : "ENSG00000131504.17",
      gene_id : "ENSG00000131504.17",
      gene_type : "protein_coding",
      gene_name : "DIAPH1",
      gene_level : 2,
      hgnc_id : "HGNC:2876",
      havana_gene : "OTTHUMG00000149893.18",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141620876,
      stop : 141636849,
      direction : "-",
      ID : "ENSG00000171720.10",
      gene_id : "ENSG00000171720.10",
      gene_type : "protein_coding",
      gene_name : "HDAC3",
      gene_level : 2,
      hgnc_id : "HGNC:4854",
      havana_gene : "OTTHUMG00000129629.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141636950,
      stop : 141641064,
      direction : "+",
      ID : "ENSG00000164620.9",
      gene_id : "ENSG00000164620.9",
      gene_type : "protein_coding",
      gene_name : "RELL2",
      gene_level : 2,
      hgnc_id : "HGNC:26902",
      havana_gene : "OTTHUMG00000129612.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141639302,
      stop : 141651418,
      direction : "-",
      ID : "ENSG00000197948.11",
      gene_id : "ENSG00000197948.11",
      gene_type : "protein_coding",
      gene_name : "FCHSD1",
      gene_level : 1,
      hgnc_id : "HGNC:25463",
      havana_gene : "OTTHUMG00000163762.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141653401,
      stop : 141682230,
      direction : "-",
      ID : "ENSG00000120318.16",
      gene_id : "ENSG00000120318.16",
      gene_type : "protein_coding",
      gene_name : "ARAP3",
      gene_level : 1,
      hgnc_id : "HGNC:24097",
      havana_gene : "OTTHUMG00000129610.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141853090,
      stop : 141879246,
      direction : "-",
      ID : "ENSG00000156453.14",
      gene_id : "ENSG00000156453.14",
      gene_type : "protein_coding",
      gene_name : "PCDH1",
      gene_level : 1,
      hgnc_id : "HGNC:8655",
      havana_gene : "OTTHUMG00000129661.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141923855,
      stop : 141942047,
      direction : "+",
      ID : "ENSG00000081791.9",
      gene_id : "ENSG00000081791.9",
      gene_type : "protein_coding",
      gene_name : "DELE1",
      gene_level : 1,
      hgnc_id : "HGNC:28969",
      havana_gene : "OTTHUMG00000129662.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141943581,
      stop : 141969741,
      direction : "-",
      ID : "ENSG00000113555.6",
      gene_id : "ENSG00000113555.6",
      gene_type : "protein_coding",
      gene_name : "PCDH12",
      gene_level : 2,
      hgnc_id : "HGNC:8657",
      havana_gene : "OTTHUMG00000129658.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141958328,
      stop : 141990292,
      direction : "+",
      ID : "ENSG00000013561.18",
      gene_id : "ENSG00000013561.18",
      gene_type : "protein_coding",
      gene_name : "RNF14",
      gene_level : 1,
      hgnc_id : "HGNC:10058",
      havana_gene : "OTTHUMG00000129660.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 141991749,
      stop : 142013041,
      direction : "-",
      ID : "ENSG00000113552.16",
      gene_id : "ENSG00000113552.16",
      gene_type : "protein_coding",
      gene_name : "GNPDA1",
      gene_level : 1,
      hgnc_id : "HGNC:4417",
      havana_gene : "OTTHUMG00000129657.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 142108779,
      stop : 142154440,
      direction : "+",
      ID : "ENSG00000131507.11",
      gene_id : "ENSG00000131507.11",
      gene_type : "protein_coding",
      gene_name : "NDFIP1",
      gene_level : 2,
      hgnc_id : "HGNC:17592",
      havana_gene : "OTTHUMG00000129659.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 142310427,
      stop : 142326455,
      direction : "-",
      ID : "ENSG00000187678.10",
      gene_id : "ENSG00000187678.10",
      gene_type : "protein_coding",
      gene_name : "SPRY4",
      gene_level : 2,
      hgnc_id : "HGNC:15533",
      havana_gene : "OTTHUMG00000129663.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 142592178,
      stop : 142698070,
      direction : "-",
      ID : "ENSG00000113578.18",
      gene_id : "ENSG00000113578.18",
      gene_type : "protein_coding",
      gene_name : "FGF1",
      gene_level : 1,
      hgnc_id : "HGNC:3665",
      havana_gene : "OTTHUMG00000059703.10",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 142770377,
      stop : 143229011,
      direction : "+",
      ID : "ENSG00000145819.18",
      gene_id : "ENSG00000145819.18",
      gene_type : "protein_coding",
      gene_name : "ARHGAP26",
      gene_level : 1,
      hgnc_id : "HGNC:17073",
      havana_gene : "OTTHUMG00000059705.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 143277931,
      stop : 143435512,
      direction : "-",
      ID : "ENSG00000113580.15",
      gene_id : "ENSG00000113580.15",
      gene_type : "protein_coding",
      gene_name : "NR3C1",
      gene_level : 2,
      hgnc_id : "HGNC:7978",
      havana_gene : "OTTHUMG00000129677.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 143812161,
      stop : 143820719,
      direction : "+",
      ID : "ENSG00000158497.5",
      gene_id : "ENSG00000158497.5",
      gene_type : "protein_coding",
      gene_name : "HMHB1",
      gene_level : 2,
      hgnc_id : "HGNC:29677",
      havana_gene : "OTTHUMG00000163173.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 144158162,
      stop : 144170714,
      direction : "-",
      ID : "ENSG00000145817.17",
      gene_id : "ENSG00000145817.17",
      gene_type : "protein_coding",
      gene_name : "YIPF5",
      gene_level : 2,
      hgnc_id : "HGNC:24877",
      havana_gene : "OTTHUMG00000129679.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 144170873,
      stop : 144485686,
      direction : "+",
      ID : "ENSG00000183775.11",
      gene_id : "ENSG00000183775.11",
      gene_type : "protein_coding",
      gene_name : "KCTD16",
      gene_level : 2,
      hgnc_id : "HGNC:29244",
      havana_gene : "OTTHUMG00000163172.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 145471799,
      stop : 145835369,
      direction : "-",
      ID : "ENSG00000186314.11",
      gene_id : "ENSG00000186314.11",
      gene_type : "protein_coding",
      gene_name : "PRELID2",
      gene_level : 1,
      hgnc_id : "HGNC:28306",
      havana_gene : "OTTHUMG00000163384.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 145858521,
      stop : 145937126,
      direction : "-",
      ID : "ENSG00000204928.3",
      gene_id : "ENSG00000204928.3",
      gene_type : "protein_coding",
      gene_name : "GRXCR2",
      gene_level : 2,
      hgnc_id : "HGNC:33862",
      havana_gene : "OTTHUMG00000163417.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 145936578,
      stop : 146081791,
      direction : "+",
      ID : "ENSG00000156463.18",
      gene_id : "ENSG00000156463.18",
      gene_type : "protein_coding",
      gene_name : "SH3RF2",
      gene_level : 2,
      hgnc_id : "HGNC:26299",
      havana_gene : "OTTHUMG00000129685.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146084313,
      stop : 146105577,
      direction : "-",
      ID : "ENSG00000173261.9",
      gene_id : "ENSG00000173261.9",
      gene_type : "protein_coding",
      gene_name : "PLAC8L1",
      gene_level : 2,
      hgnc_id : "HGNC:31746",
      havana_gene : "OTTHUMG00000163418.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146110566,
      stop : 146182696,
      direction : "-",
      ID : "ENSG00000133706.19",
      gene_id : "ENSG00000133706.19",
      gene_type : "protein_coding",
      gene_name : "LARS1",
      gene_level : 2,
      hgnc_id : "HGNC:6512",
      havana_gene : "OTTHUMG00000163429.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146203550,
      stop : 146339251,
      direction : "+",
      ID : "ENSG00000275740.1",
      gene_id : "ENSG00000275740.1",
      gene_type : "protein_coding",
      gene_name : "AC091959.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000188625.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146203605,
      stop : 146289223,
      direction : "+",
      ID : "ENSG00000091009.8",
      gene_id : "ENSG00000091009.8",
      gene_type : "protein_coding",
      gene_name : "RBM27",
      gene_level : 2,
      hgnc_id : "HGNC:29243",
      havana_gene : "OTTHUMG00000163436.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146338839,
      stop : 146341728,
      direction : "+",
      ID : "ENSG00000091010.6",
      gene_id : "ENSG00000091010.6",
      gene_type : "protein_coding",
      gene_name : "POU4F3",
      gene_level : 2,
      hgnc_id : "HGNC:9220",
      havana_gene : "OTTHUMG00000129684.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146447311,
      stop : 146511961,
      direction : "+",
      ID : "ENSG00000113649.12",
      gene_id : "ENSG00000113649.12",
      gene_type : "protein_coding",
      gene_name : "TCERG1",
      gene_level : 2,
      hgnc_id : "HGNC:15630",
      havana_gene : "OTTHUMG00000129683.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146513103,
      stop : 146516190,
      direction : "-",
      ID : "ENSG00000173250.2",
      gene_id : "ENSG00000173250.2",
      gene_type : "protein_coding",
      gene_name : "GPR151",
      gene_level : 2,
      hgnc_id : "HGNC:23624",
      havana_gene : "OTTHUMG00000163444.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 146580742,
      stop : 147084784,
      direction : "-",
      ID : "ENSG00000156475.19",
      gene_id : "ENSG00000156475.19",
      gene_type : "protein_coding",
      gene_name : "PPP2R2B",
      gene_level : 1,
      hgnc_id : "HGNC:9305",
      havana_gene : "OTTHUMG00000163381.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 147234963,
      stop : 147387855,
      direction : "+",
      ID : "ENSG00000169302.16",
      gene_id : "ENSG00000169302.16",
      gene_type : "protein_coding",
      gene_name : "STK32A",
      gene_level : 1,
      hgnc_id : "HGNC:28317",
      havana_gene : "OTTHUMG00000163411.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 147390808,
      stop : 147510068,
      direction : "-",
      ID : "ENSG00000113657.13",
      gene_id : "ENSG00000113657.13",
      gene_type : "protein_coding",
      gene_name : "DPYSL3",
      gene_level : 2,
      hgnc_id : "HGNC:3015",
      havana_gene : "OTTHUMG00000163437.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 147585438,
      stop : 147782775,
      direction : "-",
      ID : "ENSG00000176049.16",
      gene_id : "ENSG00000176049.16",
      gene_type : "protein_coding",
      gene_name : "JAKMIP2",
      gene_level : 2,
      hgnc_id : "HGNC:29067",
      havana_gene : "OTTHUMG00000129731.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 147824572,
      stop : 147831671,
      direction : "-",
      ID : "ENSG00000164266.11",
      gene_id : "ENSG00000164266.11",
      gene_type : "protein_coding",
      gene_name : "SPINK1",
      gene_level : 2,
      hgnc_id : "HGNC:11244",
      havana_gene : "OTTHUMG00000129730.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 147870682,
      stop : 147882191,
      direction : "+",
      ID : "ENSG00000164265.9",
      gene_id : "ENSG00000164265.9",
      gene_type : "protein_coding",
      gene_name : "SCGB3A2",
      gene_level : 2,
      hgnc_id : "HGNC:18391",
      havana_gene : "OTTHUMG00000129729.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 147880726,
      stop : 147906538,
      direction : "-",
      ID : "ENSG00000178776.5",
      gene_id : "ENSG00000178776.5",
      gene_type : "protein_coding",
      gene_name : "C5orf46",
      gene_level : 2,
      hgnc_id : "HGNC:33768",
      havana_gene : "OTTHUMG00000163420.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148025683,
      stop : 148137382,
      direction : "+",
      ID : "ENSG00000133710.16",
      gene_id : "ENSG00000133710.16",
      gene_type : "protein_coding",
      gene_name : "SPINK5",
      gene_level : 2,
      hgnc_id : "HGNC:15464",
      havana_gene : "OTTHUMG00000134305.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148169733,
      stop : 148175398,
      direction : "+",
      ID : "ENSG00000196800.6",
      gene_id : "ENSG00000196800.6",
      gene_type : "protein_coding",
      gene_name : "SPINK14",
      gene_level : 2,
      hgnc_id : "HGNC:33825",
      havana_gene : "OTTHUMG00000129732.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148202794,
      stop : 148215137,
      direction : "+",
      ID : "ENSG00000178172.7",
      gene_id : "ENSG00000178172.7",
      gene_type : "protein_coding",
      gene_name : "SPINK6",
      gene_level : 2,
      hgnc_id : "HGNC:29486",
      havana_gene : "OTTHUMG00000163425.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148221650,
      stop : 148243580,
      direction : "+",
      ID : "ENSG00000248109.3",
      gene_id : "ENSG00000248109.3",
      gene_type : "protein_coding",
      gene_name : "MARCOL",
      gene_level : 2,
      hgnc_id : "HGNC:53644",
      havana_gene : "OTTHUMG00000163424.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148268180,
      stop : 148286255,
      direction : "+",
      ID : "ENSG00000214510.10",
      gene_id : "ENSG00000214510.10",
      gene_type : "protein_coding",
      gene_name : "SPINK13",
      gene_level : 2,
      hgnc_id : "HGNC:27200",
      havana_gene : "OTTHUMG00000163426.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148312419,
      stop : 148315922,
      direction : "+",
      ID : "ENSG00000145879.11",
      gene_id : "ENSG00000145879.11",
      gene_type : "protein_coding",
      gene_name : "SPINK7",
      gene_level : 2,
      hgnc_id : "HGNC:24643",
      havana_gene : "OTTHUMG00000163522.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148321203,
      stop : 148339852,
      direction : "+",
      ID : "ENSG00000204909.8",
      gene_id : "ENSG00000204909.8",
      gene_type : "protein_coding",
      gene_name : "SPINK9",
      gene_level : 2,
      hgnc_id : "HGNC:32951",
      havana_gene : "OTTHUMG00000163431.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148383935,
      stop : 148442836,
      direction : "+",
      ID : "ENSG00000145868.17",
      gene_id : "ENSG00000145868.17",
      gene_type : "protein_coding",
      gene_name : "FBXO38",
      gene_level : 2,
      hgnc_id : "HGNC:28844",
      havana_gene : "OTTHUMG00000129929.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148451032,
      stop : 148677235,
      direction : "-",
      ID : "ENSG00000164270.18",
      gene_id : "ENSG00000164270.18",
      gene_type : "protein_coding",
      gene_name : "HTR4",
      gene_level : 1,
      hgnc_id : "HGNC:5299",
      havana_gene : "OTTHUMG00000129931.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148826611,
      stop : 148828623,
      direction : "+",
      ID : "ENSG00000169252.6",
      gene_id : "ENSG00000169252.6",
      gene_type : "protein_coding",
      gene_name : "ADRB2",
      gene_level : 2,
      hgnc_id : "HGNC:286",
      havana_gene : "OTTHUMG00000129933.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 148923639,
      stop : 149063163,
      direction : "-",
      ID : "ENSG00000169247.14",
      gene_id : "ENSG00000169247.14",
      gene_type : "protein_coding",
      gene_name : "SH3TC2",
      gene_level : 1,
      hgnc_id : "HGNC:29427",
      havana_gene : "OTTHUMG00000129930.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149141483,
      stop : 149260542,
      direction : "+",
      ID : "ENSG00000173210.20",
      gene_id : "ENSG00000173210.20",
      gene_type : "protein_coding",
      gene_name : "ABLIM3",
      gene_level : 2,
      hgnc_id : "HGNC:29132",
      havana_gene : "OTTHUMG00000129932.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149271859,
      stop : 149343637,
      direction : "+",
      ID : "ENSG00000157510.14",
      gene_id : "ENSG00000157510.14",
      gene_type : "protein_coding",
      gene_name : "AFAP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:26714",
      havana_gene : "OTTHUMG00000163441.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149345430,
      stop : 149354583,
      direction : "+",
      ID : "ENSG00000164284.15",
      gene_id : "ENSG00000164284.15",
      gene_type : "protein_coding",
      gene_name : "GRPEL2",
      gene_level : 1,
      hgnc_id : "HGNC:21060",
      havana_gene : "OTTHUMG00000130048.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149358037,
      stop : 149369653,
      direction : "+",
      ID : "ENSG00000145882.11",
      gene_id : "ENSG00000145882.11",
      gene_type : "protein_coding",
      gene_name : "PCYOX1L",
      gene_level : 2,
      hgnc_id : "HGNC:28477",
      havana_gene : "OTTHUMG00000130052.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149371324,
      stop : 149404202,
      direction : "-",
      ID : "ENSG00000127743.6",
      gene_id : "ENSG00000127743.6",
      gene_type : "protein_coding",
      gene_name : "IL17B",
      gene_level : 2,
      hgnc_id : "HGNC:5982",
      havana_gene : "OTTHUMG00000130051.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149492982,
      stop : 149551471,
      direction : "-",
      ID : "ENSG00000113712.19",
      gene_id : "ENSG00000113712.19",
      gene_type : "protein_coding",
      gene_name : "CSNK1A1",
      gene_level : 2,
      hgnc_id : "HGNC:2451",
      havana_gene : "OTTHUMG00000163463.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149551947,
      stop : 149634968,
      direction : "+",
      ID : "ENSG00000183111.12",
      gene_id : "ENSG00000183111.12",
      gene_type : "protein_coding",
      gene_name : "ARHGEF37",
      gene_level : 2,
      hgnc_id : "HGNC:34430",
      havana_gene : "OTTHUMG00000163491.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149730298,
      stop : 149855022,
      direction : "+",
      ID : "ENSG00000155846.17",
      gene_id : "ENSG00000155846.17",
      gene_type : "protein_coding",
      gene_name : "PPARGC1B",
      gene_level : 1,
      hgnc_id : "HGNC:30022",
      havana_gene : "OTTHUMG00000130055.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149857953,
      stop : 149944793,
      direction : "-",
      ID : "ENSG00000132915.11",
      gene_id : "ENSG00000132915.11",
      gene_type : "protein_coding",
      gene_name : "PDE6A",
      gene_level : 2,
      hgnc_id : "HGNC:8785",
      havana_gene : "OTTHUMG00000130047.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149960758,
      stop : 149993455,
      direction : "+",
      ID : "ENSG00000155850.8",
      gene_id : "ENSG00000155850.8",
      gene_type : "protein_coding",
      gene_name : "SLC26A2",
      gene_level : 1,
      hgnc_id : "HGNC:10994",
      havana_gene : "OTTHUMG00000130054.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 149993118,
      stop : 150000654,
      direction : "-",
      ID : "ENSG00000164296.7",
      gene_id : "ENSG00000164296.7",
      gene_type : "protein_coding",
      gene_name : "TIGD6",
      gene_level : 2,
      hgnc_id : "HGNC:18332",
      havana_gene : "OTTHUMG00000130045.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150000046,
      stop : 150053142,
      direction : "+",
      ID : "ENSG00000113716.13",
      gene_id : "ENSG00000113716.13",
      gene_type : "protein_coding",
      gene_name : "HMGXB3",
      gene_level : 2,
      hgnc_id : "HGNC:28982",
      havana_gene : "OTTHUMG00000163493.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150053291,
      stop : 150113372,
      direction : "-",
      ID : "ENSG00000182578.14",
      gene_id : "ENSG00000182578.14",
      gene_type : "protein_coding",
      gene_name : "CSF1R",
      gene_level : 2,
      hgnc_id : "HGNC:2433",
      havana_gene : "OTTHUMG00000130050.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150113839,
      stop : 150155872,
      direction : "-",
      ID : "ENSG00000113721.14",
      gene_id : "ENSG00000113721.14",
      gene_type : "protein_coding",
      gene_name : "PDGFRB",
      gene_level : 1,
      hgnc_id : "HGNC:8804",
      havana_gene : "OTTHUMG00000130053.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150166778,
      stop : 150184558,
      direction : "+",
      ID : "ENSG00000113722.17",
      gene_id : "ENSG00000113722.17",
      gene_type : "protein_coding",
      gene_name : "CDX1",
      gene_level : 2,
      hgnc_id : "HGNC:1805",
      havana_gene : "OTTHUMG00000169772.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150190062,
      stop : 150222788,
      direction : "+",
      ID : "ENSG00000011083.9",
      gene_id : "ENSG00000011083.9",
      gene_type : "protein_coding",
      gene_name : "SLC6A7",
      gene_level : 1,
      hgnc_id : "HGNC:11054",
      havana_gene : "OTTHUMG00000130046.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150219491,
      stop : 150290291,
      direction : "-",
      ID : "ENSG00000070808.16",
      gene_id : "ENSG00000070808.16",
      gene_type : "protein_coding",
      gene_name : "CAMK2A",
      gene_level : 2,
      hgnc_id : "HGNC:1460",
      havana_gene : "OTTHUMG00000134281.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150296343,
      stop : 150339307,
      direction : "-",
      ID : "ENSG00000183876.9",
      gene_id : "ENSG00000183876.9",
      gene_type : "protein_coding",
      gene_name : "ARSI",
      gene_level : 2,
      hgnc_id : "HGNC:32521",
      havana_gene : "OTTHUMG00000163479.4",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150357629,
      stop : 150400308,
      direction : "+",
      ID : "ENSG00000070814.22",
      gene_id : "ENSG00000070814.22",
      gene_type : "protein_coding",
      gene_name : "TCOF1",
      gene_level : 1,
      hgnc_id : "HGNC:11654",
      havana_gene : "OTTHUMG00000130081.18",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150400041,
      stop : 150412969,
      direction : "-",
      ID : "ENSG00000019582.16",
      gene_id : "ENSG00000019582.16",
      gene_type : "protein_coding",
      gene_name : "CD74",
      gene_level : 2,
      hgnc_id : "HGNC:1697",
      havana_gene : "OTTHUMG00000163559.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150442635,
      stop : 150449739,
      direction : "-",
      ID : "ENSG00000164587.13",
      gene_id : "ENSG00000164587.13",
      gene_type : "protein_coding",
      gene_name : "RPS14",
      gene_level : 2,
      hgnc_id : "HGNC:10387",
      havana_gene : "OTTHUMG00000130080.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150485818,
      stop : 150558211,
      direction : "+",
      ID : "ENSG00000070614.15",
      gene_id : "ENSG00000070614.15",
      gene_type : "protein_coding",
      gene_name : "NDST1",
      gene_level : 1,
      hgnc_id : "HGNC:7680",
      havana_gene : "OTTHUMG00000163572.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150601080,
      stop : 150659207,
      direction : "+",
      ID : "ENSG00000171992.13",
      gene_id : "ENSG00000171992.13",
      gene_type : "protein_coding",
      gene_name : "SYNPO",
      gene_level : 2,
      hgnc_id : "HGNC:30672",
      havana_gene : "OTTHUMG00000130078.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150660882,
      stop : 150679368,
      direction : "+",
      ID : "ENSG00000164591.14",
      gene_id : "ENSG00000164591.14",
      gene_type : "protein_coding",
      gene_name : "MYOZ3",
      gene_level : 2,
      hgnc_id : "HGNC:18565",
      havana_gene : "OTTHUMG00000130077.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150690792,
      stop : 150701077,
      direction : "-",
      ID : "ENSG00000086589.12",
      gene_id : "ENSG00000086589.12",
      gene_type : "protein_coding",
      gene_name : "RBM22",
      gene_level : 2,
      hgnc_id : "HGNC:25503",
      havana_gene : "OTTHUMG00000163589.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150708440,
      stop : 150759095,
      direction : "-",
      ID : "ENSG00000132912.13",
      gene_id : "ENSG00000132912.13",
      gene_type : "protein_coding",
      gene_name : "DCTN4",
      gene_level : 2,
      hgnc_id : "HGNC:15518",
      havana_gene : "OTTHUMG00000130079.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150778757,
      stop : 150796734,
      direction : "+",
      ID : "ENSG00000256235.3",
      gene_id : "ENSG00000256235.3",
      gene_type : "protein_coding",
      gene_name : "SMIM3",
      gene_level : 2,
      hgnc_id : "HGNC:30248",
      havana_gene : "OTTHUMG00000163646.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150846523,
      stop : 150900736,
      direction : "+",
      ID : "ENSG00000237693.4",
      gene_id : "ENSG00000237693.4",
      gene_type : "protein_coding",
      gene_name : "IRGM",
      gene_level : 2,
      hgnc_id : "HGNC:29597",
      havana_gene : "OTTHUMG00000163647.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 150894392,
      stop : 150904983,
      direction : "-",
      ID : "ENSG00000145908.12",
      gene_id : "ENSG00000145908.12",
      gene_type : "protein_coding",
      gene_name : "ZNF300",
      gene_level : 2,
      hgnc_id : "HGNC:13091",
      havana_gene : "OTTHUMG00000130076.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151020438,
      stop : 151028992,
      direction : "+",
      ID : "ENSG00000211445.12",
      gene_id : "ENSG00000211445.12",
      gene_type : "protein_coding",
      gene_name : "GPX3",
      gene_level : 1,
      hgnc_id : "HGNC:4555",
      havana_gene : "OTTHUMG00000163693.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151029945,
      stop : 151093577,
      direction : "-",
      ID : "ENSG00000145901.16",
      gene_id : "ENSG00000145901.16",
      gene_type : "protein_coding",
      gene_name : "TNIP1",
      gene_level : 1,
      hgnc_id : "HGNC:16903",
      havana_gene : "OTTHUMG00000163722.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151100706,
      stop : 151157785,
      direction : "-",
      ID : "ENSG00000197043.14",
      gene_id : "ENSG00000197043.14",
      gene_type : "protein_coding",
      gene_name : "ANXA6",
      gene_level : 1,
      hgnc_id : "HGNC:544",
      havana_gene : "OTTHUMG00000164179.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151181052,
      stop : 151224093,
      direction : "-",
      ID : "ENSG00000198624.13",
      gene_id : "ENSG00000198624.13",
      gene_type : "protein_coding",
      gene_name : "CCDC69",
      gene_level : 2,
      hgnc_id : "HGNC:24487",
      havana_gene : "OTTHUMG00000130127.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151212150,
      stop : 151270440,
      direction : "+",
      ID : "ENSG00000196743.9",
      gene_id : "ENSG00000196743.9",
      gene_type : "protein_coding",
      gene_name : "GM2A",
      gene_level : 2,
      hgnc_id : "HGNC:4367",
      havana_gene : "OTTHUMG00000130124.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151276358,
      stop : 151303766,
      direction : "-",
      ID : "ENSG00000186334.10",
      gene_id : "ENSG00000186334.10",
      gene_type : "protein_coding",
      gene_name : "SLC36A3",
      gene_level : 2,
      hgnc_id : "HGNC:19659",
      havana_gene : "OTTHUMG00000130128.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151314972,
      stop : 151347590,
      direction : "-",
      ID : "ENSG00000186335.9",
      gene_id : "ENSG00000186335.9",
      gene_type : "protein_coding",
      gene_name : "SLC36A2",
      gene_level : 2,
      hgnc_id : "HGNC:18762",
      havana_gene : "OTTHUMG00000130129.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151437046,
      stop : 151492379,
      direction : "+",
      ID : "ENSG00000123643.13",
      gene_id : "ENSG00000123643.13",
      gene_type : "protein_coding",
      gene_name : "SLC36A1",
      gene_level : 1,
      hgnc_id : "HGNC:18761",
      havana_gene : "OTTHUMG00000130125.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151504093,
      stop : 151568944,
      direction : "-",
      ID : "ENSG00000086570.12",
      gene_id : "ENSG00000086570.12",
      gene_type : "protein_coding",
      gene_name : "FAT2",
      gene_level : 1,
      hgnc_id : "HGNC:3596",
      havana_gene : "OTTHUMG00000130126.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151661096,
      stop : 151686975,
      direction : "-",
      ID : "ENSG00000113140.11",
      gene_id : "ENSG00000113140.11",
      gene_type : "protein_coding",
      gene_name : "SPARC",
      gene_level : 1,
      hgnc_id : "HGNC:11219",
      havana_gene : "OTTHUMG00000130122.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151742316,
      stop : 151772532,
      direction : "-",
      ID : "ENSG00000177556.12",
      gene_id : "ENSG00000177556.12",
      gene_type : "protein_coding",
      gene_name : "ATOX1",
      gene_level : 2,
      hgnc_id : "HGNC:798",
      havana_gene : "OTTHUMG00000163499.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151771045,
      stop : 151812911,
      direction : "+",
      ID : "ENSG00000145907.16",
      gene_id : "ENSG00000145907.16",
      gene_type : "protein_coding",
      gene_name : "G3BP1",
      gene_level : 2,
      hgnc_id : "HGNC:30292",
      havana_gene : "OTTHUMG00000130123.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 151822513,
      stop : 151924851,
      direction : "-",
      ID : "ENSG00000145888.11",
      gene_id : "ENSG00000145888.11",
      gene_type : "protein_coding",
      gene_name : "GLRA1",
      gene_level : 2,
      hgnc_id : "HGNC:4326",
      havana_gene : "OTTHUMG00000130121.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 152391546,
      stop : 152433368,
      direction : "-",
      ID : "ENSG00000132911.5",
      gene_id : "ENSG00000132911.5",
      gene_type : "protein_coding",
      gene_name : "NMUR2",
      gene_level : 2,
      hgnc_id : "HGNC:16454",
      havana_gene : "OTTHUMG00000130131.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 153489615,
      stop : 153813869,
      direction : "+",
      ID : "ENSG00000155511.18",
      gene_id : "ENSG00000155511.18",
      gene_type : "protein_coding",
      gene_name : "GRIA1",
      gene_level : 1,
      hgnc_id : "HGNC:4571",
      havana_gene : "OTTHUMG00000130148.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 153990148,
      stop : 154038936,
      direction : "-",
      ID : "ENSG00000055147.19",
      gene_id : "ENSG00000055147.19",
      gene_type : "protein_coding",
      gene_name : "FAM114A2",
      gene_level : 2,
      hgnc_id : "HGNC:1333",
      havana_gene : "OTTHUMG00000130147.15",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154038959,
      stop : 154220478,
      direction : "+",
      ID : "ENSG00000037749.13",
      gene_id : "ENSG00000037749.13",
      gene_type : "protein_coding",
      gene_name : "MFAP3",
      gene_level : 2,
      hgnc_id : "HGNC:7034",
      havana_gene : "OTTHUMG00000130149.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154190730,
      stop : 154420984,
      direction : "+",
      ID : "ENSG00000164574.16",
      gene_id : "ENSG00000164574.16",
      gene_type : "protein_coding",
      gene_name : "GALNT10",
      gene_level : 2,
      hgnc_id : "HGNC:19873",
      havana_gene : "OTTHUMG00000130145.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154445997,
      stop : 154461053,
      direction : "+",
      ID : "ENSG00000164576.12",
      gene_id : "ENSG00000164576.12",
      gene_type : "protein_coding",
      gene_name : "SAP30L",
      gene_level : 2,
      hgnc_id : "HGNC:25663",
      havana_gene : "OTTHUMG00000130146.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154474972,
      stop : 154478227,
      direction : "-",
      ID : "ENSG00000113196.3",
      gene_id : "ENSG00000113196.3",
      gene_type : "protein_coding",
      gene_name : "HAND1",
      gene_level : 2,
      hgnc_id : "HGNC:4807",
      havana_gene : "OTTHUMG00000130193.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154712843,
      stop : 154817605,
      direction : "+",
      ID : "ENSG00000155506.18",
      gene_id : "ENSG00000155506.18",
      gene_type : "protein_coding",
      gene_name : "LARP1",
      gene_level : 1,
      hgnc_id : "HGNC:29531",
      havana_gene : "OTTHUMG00000130191.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154818492,
      stop : 154859252,
      direction : "-",
      ID : "ENSG00000170271.11",
      gene_id : "ENSG00000170271.11",
      gene_type : "protein_coding",
      gene_name : "FAXDC2",
      gene_level : 1,
      hgnc_id : "HGNC:1334",
      havana_gene : "OTTHUMG00000164141.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154857553,
      stop : 154876792,
      direction : "+",
      ID : "ENSG00000155508.14",
      gene_id : "ENSG00000155508.14",
      gene_type : "protein_coding",
      gene_name : "CNOT8",
      gene_level : 1,
      hgnc_id : "HGNC:9207",
      havana_gene : "OTTHUMG00000130192.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154887411,
      stop : 154938211,
      direction : "-",
      ID : "ENSG00000082516.9",
      gene_id : "ENSG00000082516.9",
      gene_type : "protein_coding",
      gene_name : "GEMIN5",
      gene_level : 2,
      hgnc_id : "HGNC:20043",
      havana_gene : "OTTHUMG00000130189.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 154941073,
      stop : 154969411,
      direction : "+",
      ID : "ENSG00000082515.18",
      gene_id : "ENSG00000082515.18",
      gene_type : "protein_coding",
      gene_name : "MRPL22",
      gene_level : 2,
      hgnc_id : "HGNC:14480",
      havana_gene : "OTTHUMG00000130190.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 155013755,
      stop : 155018141,
      direction : "+",
      ID : "ENSG00000226650.6",
      gene_id : "ENSG00000226650.6",
      gene_type : "protein_coding",
      gene_name : "KIF4B",
      gene_level : 2,
      hgnc_id : "HGNC:6322",
      havana_gene : "OTTHUMG00000164143.2",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 155870344,
      stop : 156767788,
      direction : "+",
      ID : "ENSG00000170624.14",
      gene_id : "ENSG00000170624.14",
      gene_type : "protein_coding",
      gene_name : "SGCD",
      gene_level : 2,
      hgnc_id : "HGNC:10807",
      havana_gene : "OTTHUMG00000163445.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 156850295,
      stop : 156852528,
      direction : "+",
      ID : "ENSG00000231989.5",
      gene_id : "ENSG00000231989.5",
      gene_type : "protein_coding",
      gene_name : "PPP1R2B",
      gene_level : 2,
      hgnc_id : "HGNC:16318",
      havana_gene : "OTTHUMG00000163467.4",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 156919292,
      stop : 156963226,
      direction : "-",
      ID : "ENSG00000145850.9",
      gene_id : "ENSG00000145850.9",
      gene_type : "protein_coding",
      gene_name : "TIMD4",
      gene_level : 2,
      hgnc_id : "HGNC:25132",
      havana_gene : "OTTHUMG00000130244.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157029413,
      stop : 157059119,
      direction : "-",
      ID : "ENSG00000113249.13",
      gene_id : "ENSG00000113249.13",
      gene_type : "protein_coding",
      gene_name : "HAVCR1",
      gene_level : 2,
      hgnc_id : "HGNC:17866",
      havana_gene : "OTTHUMG00000163466.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157085832,
      stop : 157142869,
      direction : "-",
      ID : "ENSG00000135077.9",
      gene_id : "ENSG00000135077.9",
      gene_type : "protein_coding",
      gene_name : "HAVCR2",
      gene_level : 2,
      hgnc_id : "HGNC:18437",
      havana_gene : "OTTHUMG00000130249.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157137424,
      stop : 157159019,
      direction : "-",
      ID : "ENSG00000155868.8",
      gene_id : "ENSG00000155868.8",
      gene_type : "protein_coding",
      gene_name : "MED7",
      gene_level : 2,
      hgnc_id : "HGNC:2378",
      havana_gene : "OTTHUMG00000130243.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157142933,
      stop : 157255185,
      direction : "+",
      ID : "ENSG00000113263.13",
      gene_id : "ENSG00000113263.13",
      gene_type : "protein_coding",
      gene_name : "ITK",
      gene_level : 2,
      hgnc_id : "HGNC:6171",
      havana_gene : "OTTHUMG00000130245.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157161846,
      stop : 157166264,
      direction : "-",
      ID : "ENSG00000170613.4",
      gene_id : "ENSG00000170613.4",
      gene_type : "protein_coding",
      gene_name : "FAM71B",
      gene_level : 2,
      hgnc_id : "HGNC:28397",
      havana_gene : "OTTHUMG00000130246.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157266079,
      stop : 157395595,
      direction : "+",
      ID : "ENSG00000055163.20",
      gene_id : "ENSG00000055163.20",
      gene_type : "protein_coding",
      gene_name : "CYFIP2",
      gene_level : 1,
      hgnc_id : "HGNC:13760",
      havana_gene : "OTTHUMG00000163484.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157341596,
      stop : 157460100,
      direction : "-",
      ID : "ENSG00000285868.1",
      gene_id : "ENSG00000285868.1",
      gene_type : "protein_coding",
      gene_name : "AC008676.3",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193404.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157341598,
      stop : 157345677,
      direction : "-",
      ID : "ENSG00000172568.5",
      gene_id : "ENSG00000172568.5",
      gene_type : "protein_coding",
      gene_name : "FNDC9",
      gene_level : 2,
      hgnc_id : "HGNC:33547",
      havana_gene : "OTTHUMG00000130248.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157395534,
      stop : 157575775,
      direction : "-",
      ID : "ENSG00000135074.16",
      gene_id : "ENSG00000135074.16",
      gene_type : "protein_coding",
      gene_name : "ADAM19",
      gene_level : 2,
      hgnc_id : "HGNC:197",
      havana_gene : "OTTHUMG00000130242.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157460213,
      stop : 157474722,
      direction : "+",
      ID : "ENSG00000172548.15",
      gene_id : "ENSG00000172548.15",
      gene_type : "protein_coding",
      gene_name : "NIPAL4",
      gene_level : 2,
      hgnc_id : "HGNC:28018",
      havana_gene : "OTTHUMG00000163497.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157625679,
      stop : 157671480,
      direction : "-",
      ID : "ENSG00000039600.11",
      gene_id : "ENSG00000039600.11",
      gene_type : "protein_coding",
      gene_name : "SOX30",
      gene_level : 2,
      hgnc_id : "HGNC:30635",
      havana_gene : "OTTHUMG00000130247.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157671533,
      stop : 157680158,
      direction : "+",
      ID : "ENSG00000187658.7",
      gene_id : "ENSG00000187658.7",
      gene_type : "protein_coding",
      gene_name : "C5orf52",
      gene_level : 2,
      hgnc_id : "HGNC:35121",
      havana_gene : "OTTHUMG00000154518.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157731420,
      stop : 157741449,
      direction : "+",
      ID : "ENSG00000113272.14",
      gene_id : "ENSG00000113272.14",
      gene_type : "protein_coding",
      gene_name : "THG1L",
      gene_level : 2,
      hgnc_id : "HGNC:26053",
      havana_gene : "OTTHUMG00000130254.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157743712,
      stop : 157760709,
      direction : "+",
      ID : "ENSG00000155858.6",
      gene_id : "ENSG00000155858.6",
      gene_type : "protein_coding",
      gene_name : "LSM11",
      gene_level : 2,
      hgnc_id : "HGNC:30860",
      havana_gene : "OTTHUMG00000130255.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 157785743,
      stop : 157859145,
      direction : "-",
      ID : "ENSG00000113282.14",
      gene_id : "ENSG00000113282.14",
      gene_type : "protein_coding",
      gene_name : "CLINT1",
      gene_level : 1,
      hgnc_id : "HGNC:23186",
      havana_gene : "OTTHUMG00000163527.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 158695916,
      stop : 159099916,
      direction : "-",
      ID : "ENSG00000164330.17",
      gene_id : "ENSG00000164330.17",
      gene_type : "protein_coding",
      gene_name : "EBF1",
      gene_level : 1,
      hgnc_id : "HGNC:3126",
      havana_gene : "OTTHUMG00000130304.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 159157409,
      stop : 159210053,
      direction : "-",
      ID : "ENSG00000145860.12",
      gene_id : "ENSG00000145860.12",
      gene_type : "protein_coding",
      gene_name : "RNF145",
      gene_level : 1,
      hgnc_id : "HGNC:20853",
      havana_gene : "OTTHUMG00000130306.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 159263290,
      stop : 159286036,
      direction : "+",
      ID : "ENSG00000164332.8",
      gene_id : "ENSG00000164332.8",
      gene_type : "protein_coding",
      gene_name : "UBLCP1",
      gene_level : 2,
      hgnc_id : "HGNC:28110",
      havana_gene : "OTTHUMG00000130305.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 159314780,
      stop : 159330487,
      direction : "-",
      ID : "ENSG00000113302.5",
      gene_id : "ENSG00000113302.5",
      gene_type : "protein_coding",
      gene_name : "IL12B",
      gene_level : 2,
      hgnc_id : "HGNC:5970",
      havana_gene : "OTTHUMG00000130307.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 159865080,
      stop : 159973012,
      direction : "+",
      ID : "ENSG00000170214.5",
      gene_id : "ENSG00000170214.5",
      gene_type : "protein_coding",
      gene_name : "ADRA1B",
      gene_level : 2,
      hgnc_id : "HGNC:278",
      havana_gene : "OTTHUMG00000130327.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160009113,
      stop : 160065543,
      direction : "+",
      ID : "ENSG00000113312.11",
      gene_id : "ENSG00000113312.11",
      gene_type : "protein_coding",
      gene_name : "TTC1",
      gene_level : 1,
      hgnc_id : "HGNC:12391",
      havana_gene : "OTTHUMG00000130326.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160061801,
      stop : 160119450,
      direction : "-",
      ID : "ENSG00000170234.13",
      gene_id : "ENSG00000170234.13",
      gene_type : "protein_coding",
      gene_name : "PWWP2A",
      gene_level : 1,
      hgnc_id : "HGNC:29406",
      havana_gene : "OTTHUMG00000163546.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160187367,
      stop : 160238735,
      direction : "+",
      ID : "ENSG00000170231.16",
      gene_id : "ENSG00000170231.16",
      gene_type : "protein_coding",
      gene_name : "FABP6",
      gene_level : 2,
      hgnc_id : "HGNC:3561",
      havana_gene : "OTTHUMG00000130329.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160249083,
      stop : 160345396,
      direction : "-",
      ID : "ENSG00000135083.16",
      gene_id : "ENSG00000135083.16",
      gene_type : "protein_coding",
      gene_name : "CCNJL",
      gene_level : 1,
      hgnc_id : "HGNC:25876",
      havana_gene : "OTTHUMG00000130325.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160347754,
      stop : 160370641,
      direction : "-",
      ID : "ENSG00000145861.9",
      gene_id : "ENSG00000145861.9",
      gene_type : "protein_coding",
      gene_name : "C1QTNF2",
      gene_level : 2,
      hgnc_id : "HGNC:14325",
      havana_gene : "OTTHUMG00000130323.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160393148,
      stop : 160400054,
      direction : "-",
      ID : "ENSG00000221886.4",
      gene_id : "ENSG00000221886.4",
      gene_type : "protein_coding",
      gene_name : "ZBED8",
      gene_level : 2,
      hgnc_id : "HGNC:30804",
      havana_gene : "OTTHUMG00000163554.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160401641,
      stop : 160421711,
      direction : "-",
      ID : "ENSG00000164609.10",
      gene_id : "ENSG00000164609.10",
      gene_type : "protein_coding",
      gene_name : "SLU7",
      gene_level : 2,
      hgnc_id : "HGNC:16939",
      havana_gene : "OTTHUMG00000130324.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160421855,
      stop : 160428739,
      direction : "+",
      ID : "ENSG00000164611.13",
      gene_id : "ENSG00000164611.13",
      gene_type : "protein_coding",
      gene_name : "PTTG1",
      gene_level : 2,
      hgnc_id : "HGNC:9690",
      havana_gene : "OTTHUMG00000130328.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 160563120,
      stop : 160852214,
      direction : "-",
      ID : "ENSG00000118322.14",
      gene_id : "ENSG00000118322.14",
      gene_type : "protein_coding",
      gene_name : "ATP10B",
      gene_level : 1,
      hgnc_id : "HGNC:13543",
      havana_gene : "OTTHUMG00000163551.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 161288429,
      stop : 161549044,
      direction : "-",
      ID : "ENSG00000145864.14",
      gene_id : "ENSG00000145864.14",
      gene_type : "protein_coding",
      gene_name : "GABRB2",
      gene_level : 2,
      hgnc_id : "HGNC:4082",
      havana_gene : "OTTHUMG00000130349.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 161547063,
      stop : 161702593,
      direction : "+",
      ID : "ENSG00000145863.11",
      gene_id : "ENSG00000145863.11",
      gene_type : "protein_coding",
      gene_name : "GABRA6",
      gene_level : 1,
      hgnc_id : "HGNC:4080",
      havana_gene : "OTTHUMG00000130351.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 161847063,
      stop : 161899981,
      direction : "+",
      ID : "ENSG00000022355.18",
      gene_id : "ENSG00000022355.18",
      gene_type : "protein_coding",
      gene_name : "GABRA1",
      gene_level : 2,
      hgnc_id : "HGNC:4075",
      havana_gene : "OTTHUMG00000163586.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 162000057,
      stop : 162162977,
      direction : "+",
      ID : "ENSG00000113327.17",
      gene_id : "ENSG00000113327.17",
      gene_type : "protein_coding",
      gene_name : "GABRG2",
      gene_level : 2,
      hgnc_id : "HGNC:4087",
      havana_gene : "OTTHUMG00000130350.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 163437569,
      stop : 163446151,
      direction : "+",
      ID : "ENSG00000113328.19",
      gene_id : "ENSG00000113328.19",
      gene_type : "protein_coding",
      gene_name : "CCNG1",
      gene_level : 1,
      hgnc_id : "HGNC:1592",
      havana_gene : "OTTHUMG00000130380.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 163446526,
      stop : 163460102,
      direction : "-",
      ID : "ENSG00000170584.11",
      gene_id : "ENSG00000170584.11",
      gene_type : "protein_coding",
      gene_name : "NUDCD2",
      gene_level : 2,
      hgnc_id : "HGNC:30535",
      havana_gene : "OTTHUMG00000130378.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 163460203,
      stop : 163491941,
      direction : "+",
      ID : "ENSG00000072571.20",
      gene_id : "ENSG00000072571.20",
      gene_type : "protein_coding",
      gene_name : "HMMR",
      gene_level : 2,
      hgnc_id : "HGNC:5012",
      havana_gene : "OTTHUMG00000130381.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 163503114,
      stop : 163519354,
      direction : "+",
      ID : "ENSG00000038274.17",
      gene_id : "ENSG00000038274.17",
      gene_type : "protein_coding",
      gene_name : "MAT2B",
      gene_level : 2,
      hgnc_id : "HGNC:6905",
      havana_gene : "OTTHUMG00000130379.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 167284799,
      stop : 168264157,
      direction : "+",
      ID : "ENSG00000145934.16",
      gene_id : "ENSG00000145934.16",
      gene_type : "protein_coding",
      gene_name : "TENM2",
      gene_level : 1,
      hgnc_id : "HGNC:29943",
      havana_gene : "OTTHUMG00000162928.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 168291645,
      stop : 168472303,
      direction : "+",
      ID : "ENSG00000113645.15",
      gene_id : "ENSG00000113645.15",
      gene_type : "protein_coding",
      gene_name : "WWC1",
      gene_level : 1,
      hgnc_id : "HGNC:29435",
      havana_gene : "OTTHUMG00000130408.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 168486451,
      stop : 168519301,
      direction : "+",
      ID : "ENSG00000113643.9",
      gene_id : "ENSG00000113643.9",
      gene_type : "protein_coding",
      gene_name : "RARS1",
      gene_level : 2,
      hgnc_id : "HGNC:9870",
      havana_gene : "OTTHUMG00000130411.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 168529305,
      stop : 168530634,
      direction : "+",
      ID : "ENSG00000188573.8",
      gene_id : "ENSG00000188573.8",
      gene_type : "protein_coding",
      gene_name : "FBLL1",
      gene_level : 2,
      hgnc_id : "HGNC:35458",
      havana_gene : "OTTHUMG00000157012.5",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 168548495,
      stop : 168579368,
      direction : "-",
      ID : "ENSG00000120137.7",
      gene_id : "ENSG00000120137.7",
      gene_type : "protein_coding",
      gene_name : "PANK3",
      gene_level : 2,
      hgnc_id : "HGNC:19365",
      havana_gene : "OTTHUMG00000130410.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 168661733,
      stop : 169301139,
      direction : "-",
      ID : "ENSG00000184347.15",
      gene_id : "ENSG00000184347.15",
      gene_type : "protein_coding",
      gene_name : "SLIT3",
      gene_level : 2,
      hgnc_id : "HGNC:11087",
      havana_gene : "OTTHUMG00000130409.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 169583636,
      stop : 169604778,
      direction : "+",
      ID : "ENSG00000040275.17",
      gene_id : "ENSG00000040275.17",
      gene_type : "protein_coding",
      gene_name : "SPDL1",
      gene_level : 1,
      hgnc_id : "HGNC:26010",
      havana_gene : "OTTHUMG00000130438.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 169637268,
      stop : 170083382,
      direction : "+",
      ID : "ENSG00000134516.18",
      gene_id : "ENSG00000134516.18",
      gene_type : "protein_coding",
      gene_name : "DOCK2",
      gene_level : 1,
      hgnc_id : "HGNC:2988",
      havana_gene : "OTTHUMG00000130437.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 169861303,
      stop : 169980495,
      direction : "-",
      ID : "ENSG00000204767.4",
      gene_id : "ENSG00000204767.4",
      gene_type : "protein_coding",
      gene_name : "INSYN2B",
      gene_level : 2,
      hgnc_id : "HGNC:37271",
      havana_gene : "OTTHUMG00000163083.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170105897,
      stop : 170109734,
      direction : "+",
      ID : "ENSG00000168269.10",
      gene_id : "ENSG00000168269.10",
      gene_type : "protein_coding",
      gene_name : "FOXI1",
      gene_level : 2,
      hgnc_id : "HGNC:3815",
      havana_gene : "OTTHUMG00000130436.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170232447,
      stop : 170252575,
      direction : "+",
      ID : "ENSG00000234511.10",
      gene_id : "ENSG00000234511.10",
      gene_type : "protein_coding",
      gene_name : "C5orf58",
      gene_level : 1,
      hgnc_id : "HGNC:37272",
      havana_gene : "OTTHUMG00000163122.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170246233,
      stop : 170297815,
      direction : "-",
      ID : "ENSG00000043462.13",
      gene_id : "ENSG00000043462.13",
      gene_type : "protein_coding",
      gene_name : "LCP2",
      gene_level : 2,
      hgnc_id : "HGNC:6529",
      havana_gene : "OTTHUMG00000163121.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170353487,
      stop : 170736632,
      direction : "+",
      ID : "ENSG00000182132.14",
      gene_id : "ENSG00000182132.14",
      gene_type : "protein_coding",
      gene_name : "KCNIP1",
      gene_level : 1,
      hgnc_id : "HGNC:15521",
      havana_gene : "OTTHUMG00000130442.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170374671,
      stop : 170389634,
      direction : "-",
      ID : "ENSG00000145936.9",
      gene_id : "ENSG00000145936.9",
      gene_type : "protein_coding",
      gene_name : "KCNMB1",
      gene_level : 2,
      hgnc_id : "HGNC:6285",
      havana_gene : "OTTHUMG00000130439.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170763350,
      stop : 170814047,
      direction : "+",
      ID : "ENSG00000094755.17",
      gene_id : "ENSG00000094755.17",
      gene_type : "protein_coding",
      gene_name : "GABRP",
      gene_level : 1,
      hgnc_id : "HGNC:4089",
      havana_gene : "OTTHUMG00000130443.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 170861870,
      stop : 171300015,
      direction : "+",
      ID : "ENSG00000204764.14",
      gene_id : "ENSG00000204764.14",
      gene_type : "protein_coding",
      gene_name : "RANBP17",
      gene_level : 1,
      hgnc_id : "HGNC:14428",
      havana_gene : "OTTHUMG00000163203.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 171309248,
      stop : 171312139,
      direction : "+",
      ID : "ENSG00000164438.6",
      gene_id : "ENSG00000164438.6",
      gene_type : "protein_coding",
      gene_name : "TLX3",
      gene_level : 1,
      hgnc_id : "HGNC:13532",
      havana_gene : "OTTHUMG00000163207.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 171387116,
      stop : 171411810,
      direction : "+",
      ID : "ENSG00000181163.14",
      gene_id : "ENSG00000181163.14",
      gene_type : "protein_coding",
      gene_name : "NPM1",
      gene_level : 1,
      hgnc_id : "HGNC:7910",
      havana_gene : "OTTHUMG00000130465.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 171419647,
      stop : 171457626,
      direction : "+",
      ID : "ENSG00000156427.8",
      gene_id : "ENSG00000156427.8",
      gene_type : "protein_coding",
      gene_name : "FGF18",
      gene_level : 2,
      hgnc_id : "HGNC:3674",
      havana_gene : "OTTHUMG00000130464.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 171420016,
      stop : 171436172,
      direction : "+",
      ID : "ENSG00000288639.1",
      gene_id : "ENSG00000288639.1",
      gene_type : "protein_coding",
      gene_name : "AC093246.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 171782432,
      stop : 171796126,
      direction : "+",
      ID : "ENSG00000185662.10",
      gene_id : "ENSG00000185662.10",
      gene_type : "protein_coding",
      gene_name : "SMIM23",
      gene_level : 2,
      hgnc_id : "HGNC:34440",
      havana_gene : "OTTHUMG00000163266.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 171861549,
      stop : 172006873,
      direction : "-",
      ID : "ENSG00000072803.18",
      gene_id : "ENSG00000072803.18",
      gene_type : "protein_coding",
      gene_name : "FBXW11",
      gene_level : 2,
      hgnc_id : "HGNC:13607",
      havana_gene : "OTTHUMG00000163267.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172042079,
      stop : 172188224,
      direction : "-",
      ID : "ENSG00000072786.13",
      gene_id : "ENSG00000072786.13",
      gene_type : "protein_coding",
      gene_name : "STK10",
      gene_level : 1,
      hgnc_id : "HGNC:11388",
      havana_gene : "OTTHUMG00000163265.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172194172,
      stop : 172203454,
      direction : "+",
      ID : "ENSG00000214360.5",
      gene_id : "ENSG00000214360.5",
      gene_type : "protein_coding",
      gene_name : "EFCAB9",
      gene_level : 2,
      hgnc_id : "HGNC:34530",
      havana_gene : "OTTHUMG00000163271.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172209646,
      stop : 172283764,
      direction : "-",
      ID : "ENSG00000168246.6",
      gene_id : "ENSG00000168246.6",
      gene_type : "protein_coding",
      gene_name : "UBTD2",
      gene_level : 2,
      hgnc_id : "HGNC:24463",
      havana_gene : "OTTHUMG00000130519.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172325000,
      stop : 172454525,
      direction : "-",
      ID : "ENSG00000174705.13",
      gene_id : "ENSG00000174705.13",
      gene_type : "protein_coding",
      gene_name : "SH3PXD2B",
      gene_level : 1,
      hgnc_id : "HGNC:29242",
      havana_gene : "OTTHUMG00000163280.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172641263,
      stop : 172691540,
      direction : "+",
      ID : "ENSG00000214357.9",
      gene_id : "ENSG00000214357.9",
      gene_type : "protein_coding",
      gene_name : "NEURL1B",
      gene_level : 1,
      hgnc_id : "HGNC:35422",
      havana_gene : "OTTHUMG00000163281.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172768096,
      stop : 172771195,
      direction : "-",
      ID : "ENSG00000120129.6",
      gene_id : "ENSG00000120129.6",
      gene_type : "protein_coding",
      gene_name : "DUSP1",
      gene_level : 2,
      hgnc_id : "HGNC:3064",
      havana_gene : "OTTHUMG00000130523.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172834251,
      stop : 172952683,
      direction : "+",
      ID : "ENSG00000113719.16",
      gene_id : "ENSG00000113719.16",
      gene_type : "protein_coding",
      gene_name : "ERGIC1",
      gene_level : 1,
      hgnc_id : "HGNC:29205",
      havana_gene : "OTTHUMG00000130520.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172958729,
      stop : 172969771,
      direction : "+",
      ID : "ENSG00000037241.7",
      gene_id : "ENSG00000037241.7",
      gene_type : "protein_coding",
      gene_name : "RPL26L1",
      gene_level : 2,
      hgnc_id : "HGNC:17050",
      havana_gene : "OTTHUMG00000130517.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 172983771,
      stop : 173035445,
      direction : "+",
      ID : "ENSG00000113732.9",
      gene_id : "ENSG00000113732.9",
      gene_type : "protein_coding",
      gene_name : "ATP6V0E1",
      gene_level : 2,
      hgnc_id : "HGNC:863",
      havana_gene : "OTTHUMG00000130518.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173056352,
      stop : 173139284,
      direction : "+",
      ID : "ENSG00000164463.12",
      gene_id : "ENSG00000164463.12",
      gene_type : "protein_coding",
      gene_name : "CREBRF",
      gene_level : 1,
      hgnc_id : "HGNC:24050",
      havana_gene : "OTTHUMG00000163322.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173144442,
      stop : 173164387,
      direction : "+",
      ID : "ENSG00000113734.18",
      gene_id : "ENSG00000113734.18",
      gene_type : "protein_coding",
      gene_name : "BNIP1",
      gene_level : 1,
      hgnc_id : "HGNC:1082",
      havana_gene : "OTTHUMG00000130521.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173232109,
      stop : 173235311,
      direction : "-",
      ID : "ENSG00000183072.10",
      gene_id : "ENSG00000183072.10",
      gene_type : "protein_coding",
      gene_name : "NKX2-5",
      gene_level : 1,
      hgnc_id : "HGNC:2488",
      havana_gene : "OTTHUMG00000130522.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173314723,
      stop : 173328447,
      direction : "-",
      ID : "ENSG00000113739.11",
      gene_id : "ENSG00000113739.11",
      gene_type : "protein_coding",
      gene_name : "STC2",
      gene_level : 1,
      hgnc_id : "HGNC:11374",
      havana_gene : "OTTHUMG00000130542.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173607145,
      stop : 173616659,
      direction : "-",
      ID : "ENSG00000145919.11",
      gene_id : "ENSG00000145919.11",
      gene_type : "protein_coding",
      gene_name : "BOD1",
      gene_level : 1,
      hgnc_id : "HGNC:25114",
      havana_gene : "OTTHUMG00000130540.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173888349,
      stop : 173961980,
      direction : "+",
      ID : "ENSG00000113742.14",
      gene_id : "ENSG00000113742.14",
      gene_type : "protein_coding",
      gene_name : "CPEB4",
      gene_level : 1,
      hgnc_id : "HGNC:21747",
      havana_gene : "OTTHUMG00000130541.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 173973779,
      stop : 174006140,
      direction : "+",
      ID : "ENSG00000185056.10",
      gene_id : "ENSG00000185056.10",
      gene_type : "protein_coding",
      gene_name : "C5orf47",
      gene_level : 2,
      hgnc_id : "HGNC:27026",
      havana_gene : "OTTHUMG00000163349.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 174045706,
      stop : 174243501,
      direction : "+",
      ID : "ENSG00000170091.11",
      gene_id : "ENSG00000170091.11",
      gene_type : "protein_coding",
      gene_name : "NSG2",
      gene_level : 2,
      hgnc_id : "HGNC:24955",
      havana_gene : "OTTHUMG00000130543.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 174724582,
      stop : 174730896,
      direction : "+",
      ID : "ENSG00000120149.9",
      gene_id : "ENSG00000120149.9",
      gene_type : "protein_coding",
      gene_name : "MSX2",
      gene_level : 1,
      hgnc_id : "HGNC:7392",
      havana_gene : "OTTHUMG00000130556.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 175440036,
      stop : 175444182,
      direction : "-",
      ID : "ENSG00000184845.4",
      gene_id : "ENSG00000184845.4",
      gene_type : "protein_coding",
      gene_name : "DRD1",
      gene_level : 2,
      hgnc_id : "HGNC:3020",
      havana_gene : "OTTHUMG00000130557.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 175477062,
      stop : 175529742,
      direction : "+",
      ID : "ENSG00000164466.13",
      gene_id : "ENSG00000164466.13",
      gene_type : "protein_coding",
      gene_name : "SFXN1",
      gene_level : 2,
      hgnc_id : "HGNC:16085",
      havana_gene : "OTTHUMG00000130555.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 175658030,
      stop : 175710756,
      direction : "+",
      ID : "ENSG00000113749.7",
      gene_id : "ENSG00000113749.7",
      gene_type : "protein_coding",
      gene_name : "HRH2",
      gene_level : 2,
      hgnc_id : "HGNC:5183",
      havana_gene : "OTTHUMG00000130660.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 175796310,
      stop : 175884021,
      direction : "+",
      ID : "ENSG00000145920.15",
      gene_id : "ENSG00000145920.15",
      gene_type : "protein_coding",
      gene_name : "CPLX2",
      gene_level : 2,
      hgnc_id : "HGNC:2310",
      havana_gene : "OTTHUMG00000130665.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 175917873,
      stop : 176034680,
      direction : "-",
      ID : "ENSG00000051596.10",
      gene_id : "ENSG00000051596.10",
      gene_type : "protein_coding",
      gene_name : "THOC3",
      gene_level : 2,
      hgnc_id : "HGNC:19072",
      havana_gene : "OTTHUMG00000130658.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176060689,
      stop : 176116015,
      direction : "+",
      ID : "ENSG00000182230.12",
      gene_id : "ENSG00000182230.12",
      gene_type : "protein_coding",
      gene_name : "FAM153B",
      gene_level : 2,
      hgnc_id : "HGNC:27323",
      havana_gene : "OTTHUMG00000163181.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176063748,
      stop : 176126959,
      direction : "+",
      ID : "ENSG00000285476.1",
      gene_id : "ENSG00000285476.1",
      gene_type : "protein_coding",
      gene_name : "AC139491.7",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192424.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176238367,
      stop : 176345991,
      direction : "+",
      ID : "ENSG00000170085.18",
      gene_id : "ENSG00000170085.18",
      gene_type : "protein_coding",
      gene_name : "SIMC1",
      gene_level : 2,
      hgnc_id : "HGNC:24779",
      havana_gene : "OTTHUMG00000130663.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176346062,
      stop : 176361807,
      direction : "-",
      ID : "ENSG00000122203.15",
      gene_id : "ENSG00000122203.15",
      gene_type : "protein_coding",
      gene_name : "KIAA1191",
      gene_level : 2,
      hgnc_id : "HGNC:29209",
      havana_gene : "OTTHUMG00000130656.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176365487,
      stop : 176401865,
      direction : "+",
      ID : "ENSG00000175414.7",
      gene_id : "ENSG00000175414.7",
      gene_type : "protein_coding",
      gene_name : "ARL10",
      gene_level : 2,
      hgnc_id : "HGNC:22042",
      havana_gene : "OTTHUMG00000130655.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176383938,
      stop : 176388927,
      direction : "-",
      ID : "ENSG00000048162.21",
      gene_id : "ENSG00000048162.21",
      gene_type : "protein_coding",
      gene_name : "NOP16",
      gene_level : 1,
      hgnc_id : "HGNC:26934",
      havana_gene : "OTTHUMG00000163186.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176388751,
      stop : 176389761,
      direction : "+",
      ID : "ENSG00000146066.3",
      gene_id : "ENSG00000146066.3",
      gene_type : "protein_coding",
      gene_name : "HIGD2A",
      gene_level : 2,
      hgnc_id : "HGNC:28311",
      havana_gene : "OTTHUMG00000130657.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176392501,
      stop : 176416539,
      direction : "-",
      ID : "ENSG00000175416.16",
      gene_id : "ENSG00000175416.16",
      gene_type : "protein_coding",
      gene_name : "CLTB",
      gene_level : 2,
      hgnc_id : "HGNC:2091",
      havana_gene : "OTTHUMG00000130662.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176447628,
      stop : 176510074,
      direction : "+",
      ID : "ENSG00000113194.13",
      gene_id : "ENSG00000113194.13",
      gene_type : "protein_coding",
      gene_name : "FAF2",
      gene_level : 2,
      hgnc_id : "HGNC:24666",
      havana_gene : "OTTHUMG00000163228.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176526712,
      stop : 176538025,
      direction : "-",
      ID : "ENSG00000146083.12",
      gene_id : "ENSG00000146083.12",
      gene_type : "protein_coding",
      gene_name : "RNF44",
      gene_level : 2,
      hgnc_id : "HGNC:19180",
      havana_gene : "OTTHUMG00000130664.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176542511,
      stop : 176595974,
      direction : "+",
      ID : "ENSG00000074276.10",
      gene_id : "ENSG00000074276.10",
      gene_type : "protein_coding",
      gene_name : "CDHR2",
      gene_level : 2,
      hgnc_id : "HGNC:18231",
      havana_gene : "OTTHUMG00000163229.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176595802,
      stop : 176610156,
      direction : "-",
      ID : "ENSG00000169258.7",
      gene_id : "ENSG00000169258.7",
      gene_type : "protein_coding",
      gene_name : "GPRIN1",
      gene_level : 2,
      hgnc_id : "HGNC:24835",
      havana_gene : "OTTHUMG00000130659.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176620082,
      stop : 176630556,
      direction : "-",
      ID : "ENSG00000074317.11",
      gene_id : "ENSG00000074317.11",
      gene_type : "protein_coding",
      gene_name : "SNCB",
      gene_level : 2,
      hgnc_id : "HGNC:11140",
      havana_gene : "OTTHUMG00000130661.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176630618,
      stop : 176646644,
      direction : "+",
      ID : "ENSG00000175766.13",
      gene_id : "ENSG00000175766.13",
      gene_type : "protein_coding",
      gene_name : "EIF4E1B",
      gene_level : 2,
      hgnc_id : "HGNC:33179",
      havana_gene : "OTTHUMG00000163227.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176647387,
      stop : 176659054,
      direction : "+",
      ID : "ENSG00000048140.18",
      gene_id : "ENSG00000048140.18",
      gene_type : "protein_coding",
      gene_name : "TSPAN17",
      gene_level : 1,
      hgnc_id : "HGNC:13594",
      havana_gene : "OTTHUMG00000163230.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176810519,
      stop : 176880898,
      direction : "+",
      ID : "ENSG00000113763.12",
      gene_id : "ENSG00000113763.12",
      gene_type : "protein_coding",
      gene_name : "UNC5A",
      gene_level : 1,
      hgnc_id : "HGNC:12567",
      havana_gene : "OTTHUMG00000163225.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176880869,
      stop : 176899346,
      direction : "-",
      ID : "ENSG00000160883.11",
      gene_id : "ENSG00000160883.11",
      gene_type : "protein_coding",
      gene_name : "HK3",
      gene_level : 1,
      hgnc_id : "HGNC:4925",
      havana_gene : "OTTHUMG00000130855.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 176905005,
      stop : 177022633,
      direction : "-",
      ID : "ENSG00000087206.17",
      gene_id : "ENSG00000087206.17",
      gene_type : "protein_coding",
      gene_name : "UIMC1",
      gene_level : 2,
      hgnc_id : "HGNC:30298",
      havana_gene : "OTTHUMG00000130852.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177022696,
      stop : 177081189,
      direction : "+",
      ID : "ENSG00000113761.12",
      gene_id : "ENSG00000113761.12",
      gene_type : "protein_coding",
      gene_name : "ZNF346",
      gene_level : 1,
      hgnc_id : "HGNC:16403",
      havana_gene : "OTTHUMG00000130848.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177086905,
      stop : 177098144,
      direction : "+",
      ID : "ENSG00000160867.15",
      gene_id : "ENSG00000160867.15",
      gene_type : "protein_coding",
      gene_name : "FGFR4",
      gene_level : 2,
      hgnc_id : "HGNC:3691",
      havana_gene : "OTTHUMG00000151523.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177133025,
      stop : 177300213,
      direction : "+",
      ID : "ENSG00000165671.21",
      gene_id : "ENSG00000165671.21",
      gene_type : "protein_coding",
      gene_name : "NSD1",
      gene_level : 1,
      hgnc_id : "HGNC:14234",
      havana_gene : "OTTHUMG00000130846.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177301198,
      stop : 177303744,
      direction : "-",
      ID : "ENSG00000169228.14",
      gene_id : "ENSG00000169228.14",
      gene_type : "protein_coding",
      gene_name : "RAB24",
      gene_level : 2,
      hgnc_id : "HGNC:9765",
      havana_gene : "OTTHUMG00000130849.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177301461,
      stop : 177312757,
      direction : "-",
      ID : "ENSG00000213347.10",
      gene_id : "ENSG00000213347.10",
      gene_type : "protein_coding",
      gene_name : "MXD3",
      gene_level : 2,
      hgnc_id : "HGNC:14008",
      havana_gene : "OTTHUMG00000130854.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177303799,
      stop : 177306949,
      direction : "+",
      ID : "ENSG00000169230.10",
      gene_id : "ENSG00000169230.10",
      gene_type : "protein_coding",
      gene_name : "PRELID1",
      gene_level : 1,
      hgnc_id : "HGNC:30255",
      havana_gene : "OTTHUMG00000130847.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177331567,
      stop : 177351668,
      direction : "-",
      ID : "ENSG00000169223.15",
      gene_id : "ENSG00000169223.15",
      gene_type : "protein_coding",
      gene_name : "LMAN2",
      gene_level : 1,
      hgnc_id : "HGNC:16986",
      havana_gene : "OTTHUMG00000130860.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177357924,
      stop : 177372596,
      direction : "+",
      ID : "ENSG00000169220.18",
      gene_id : "ENSG00000169220.18",
      gene_type : "protein_coding",
      gene_name : "RGS14",
      gene_level : 2,
      hgnc_id : "HGNC:9996",
      havana_gene : "OTTHUMG00000163324.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177379235,
      stop : 177398848,
      direction : "+",
      ID : "ENSG00000131183.11",
      gene_id : "ENSG00000131183.11",
      gene_type : "protein_coding",
      gene_name : "SLC34A1",
      gene_level : 1,
      hgnc_id : "HGNC:11019",
      havana_gene : "OTTHUMG00000130857.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177400109,
      stop : 177400661,
      direction : "-",
      ID : "ENSG00000196570.3",
      gene_id : "ENSG00000196570.3",
      gene_type : "protein_coding",
      gene_name : "PFN3",
      gene_level : 2,
      hgnc_id : "HGNC:18627",
      havana_gene : "OTTHUMG00000163408.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177402141,
      stop : 177409564,
      direction : "-",
      ID : "ENSG00000131187.10",
      gene_id : "ENSG00000131187.10",
      gene_type : "protein_coding",
      gene_name : "F12",
      gene_level : 2,
      hgnc_id : "HGNC:3530",
      havana_gene : "OTTHUMG00000163403.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177403204,
      stop : 177442901,
      direction : "+",
      ID : "ENSG00000198055.11",
      gene_id : "ENSG00000198055.11",
      gene_type : "protein_coding",
      gene_name : "GRK6",
      gene_level : 1,
      hgnc_id : "HGNC:4545",
      havana_gene : "OTTHUMG00000163401.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177446445,
      stop : 177456286,
      direction : "+",
      ID : "ENSG00000131188.12",
      gene_id : "ENSG00000131188.12",
      gene_type : "protein_coding",
      gene_name : "PRR7",
      gene_level : 2,
      hgnc_id : "HGNC:28130",
      havana_gene : "OTTHUMG00000130861.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177456608,
      stop : 177474401,
      direction : "-",
      ID : "ENSG00000113758.13",
      gene_id : "ENSG00000113758.13",
      gene_type : "protein_coding",
      gene_name : "DBN1",
      gene_level : 1,
      hgnc_id : "HGNC:2695",
      havana_gene : "OTTHUMG00000130856.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177483394,
      stop : 177497606,
      direction : "-",
      ID : "ENSG00000196923.14",
      gene_id : "ENSG00000196923.14",
      gene_type : "protein_coding",
      gene_name : "PDLIM7",
      gene_level : 2,
      hgnc_id : "HGNC:22958",
      havana_gene : "OTTHUMG00000130853.11",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177501904,
      stop : 177511274,
      direction : "-",
      ID : "ENSG00000146094.16",
      gene_id : "ENSG00000146094.16",
      gene_type : "protein_coding",
      gene_name : "DOK3",
      gene_level : 1,
      hgnc_id : "HGNC:24583",
      havana_gene : "OTTHUMG00000130850.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177511577,
      stop : 177516961,
      direction : "-",
      ID : "ENSG00000183258.12",
      gene_id : "ENSG00000183258.12",
      gene_type : "protein_coding",
      gene_name : "DDX41",
      gene_level : 2,
      hgnc_id : "HGNC:18674",
      havana_gene : "OTTHUMG00000130858.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177519789,
      stop : 177554563,
      direction : "-",
      ID : "ENSG00000146067.16",
      gene_id : "ENSG00000146067.16",
      gene_type : "protein_coding",
      gene_name : "FAM193B",
      gene_level : 1,
      hgnc_id : "HGNC:25524",
      havana_gene : "OTTHUMG00000163396.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177592203,
      stop : 177597242,
      direction : "+",
      ID : "ENSG00000184840.12",
      gene_id : "ENSG00000184840.12",
      gene_type : "protein_coding",
      gene_name : "TMED9",
      gene_level : 2,
      hgnc_id : "HGNC:24878",
      havana_gene : "OTTHUMG00000130859.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177600132,
      stop : 177610330,
      direction : "+",
      ID : "ENSG00000027847.14",
      gene_id : "ENSG00000027847.14",
      gene_type : "protein_coding",
      gene_name : "B4GALT7",
      gene_level : 1,
      hgnc_id : "HGNC:930",
      havana_gene : "OTTHUMG00000130851.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177707981,
      stop : 177783398,
      direction : "-",
      ID : "ENSG00000170074.19",
      gene_id : "ENSG00000170074.19",
      gene_type : "protein_coding",
      gene_name : "FAM153A",
      gene_level : 2,
      hgnc_id : "HGNC:29940",
      havana_gene : "OTTHUMG00000163394.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 177992235,
      stop : 177996242,
      direction : "-",
      ID : "ENSG00000175325.2",
      gene_id : "ENSG00000175325.2",
      gene_type : "protein_coding",
      gene_name : "PROP1",
      gene_level : 2,
      hgnc_id : "HGNC:9455",
      havana_gene : "OTTHUMG00000130887.1",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178113532,
      stop : 178126081,
      direction : "+",
      ID : "ENSG00000145911.6",
      gene_id : "ENSG00000145911.6",
      gene_type : "protein_coding",
      gene_name : "N4BP3",
      gene_level : 2,
      hgnc_id : "HGNC:29852",
      havana_gene : "OTTHUMG00000163456.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178130996,
      stop : 178150568,
      direction : "+",
      ID : "ENSG00000145916.19",
      gene_id : "ENSG00000145916.19",
      gene_type : "protein_coding",
      gene_name : "RMND5B",
      gene_level : 2,
      hgnc_id : "HGNC:26181",
      havana_gene : "OTTHUMG00000130897.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178149463,
      stop : 178153894,
      direction : "-",
      ID : "ENSG00000145912.9",
      gene_id : "ENSG00000145912.9",
      gene_type : "protein_coding",
      gene_name : "NHP2",
      gene_level : 2,
      hgnc_id : "HGNC:14377",
      havana_gene : "OTTHUMG00000130886.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178184505,
      stop : 178187371,
      direction : "-",
      ID : "ENSG00000244234.3",
      gene_id : "ENSG00000244234.3",
      gene_type : "protein_coding",
      gene_name : "GMCL2",
      gene_level : 2,
      hgnc_id : "HGNC:19717",
      havana_gene : "OTTHUMG00000130894.5",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178204533,
      stop : 178211163,
      direction : "+",
      ID : "ENSG00000197451.12",
      gene_id : "ENSG00000197451.12",
      gene_type : "protein_coding",
      gene_name : "HNRNPAB",
      gene_level : 2,
      hgnc_id : "HGNC:5034",
      havana_gene : "OTTHUMG00000163452.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178208471,
      stop : 178232802,
      direction : "-",
      ID : "ENSG00000175309.15",
      gene_id : "ENSG00000175309.15",
      gene_type : "protein_coding",
      gene_name : "PHYKPL",
      gene_level : 1,
      hgnc_id : "HGNC:28249",
      havana_gene : "OTTHUMG00000130892.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178237476,
      stop : 178590393,
      direction : "-",
      ID : "ENSG00000050767.18",
      gene_id : "ENSG00000050767.18",
      gene_type : "protein_coding",
      gene_name : "COL23A1",
      gene_level : 1,
      hgnc_id : "HGNC:22990",
      havana_gene : "OTTHUMG00000130890.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178602664,
      stop : 178630615,
      direction : "-",
      ID : "ENSG00000113240.13",
      gene_id : "ENSG00000113240.13",
      gene_type : "protein_coding",
      gene_name : "CLK4",
      gene_level : 2,
      hgnc_id : "HGNC:13659",
      havana_gene : "OTTHUMG00000130893.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178694605,
      stop : 178697695,
      direction : "-",
      ID : "ENSG00000285891.1",
      gene_id : "ENSG00000285891.1",
      gene_type : "protein_coding",
      gene_name : "MSANTD5",
      gene_level : 2,
      hgnc_id : "HGNC:55184",
      havana_gene : "OTTHUMG00000192652.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178694605,
      stop : 178729335,
      direction : "-",
      ID : "ENSG00000285978.1",
      gene_id : "ENSG00000285978.1",
      gene_type : "protein_coding",
      gene_name : "AC113348.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000130895.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178711512,
      stop : 178730659,
      direction : "-",
      ID : "ENSG00000169131.13",
      gene_id : "ENSG00000169131.13",
      gene_type : "protein_coding",
      gene_name : "ZNF354A",
      gene_level : 2,
      hgnc_id : "HGNC:11628",
      havana_gene : "OTTHUMG00000192653.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178859953,
      stop : 178888122,
      direction : "+",
      ID : "ENSG00000178338.11",
      gene_id : "ENSG00000178338.11",
      gene_type : "protein_coding",
      gene_name : "ZNF354B",
      gene_level : 1,
      hgnc_id : "HGNC:17197",
      havana_gene : "OTTHUMG00000130896.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178895898,
      stop : 178933212,
      direction : "+",
      ID : "ENSG00000198939.8",
      gene_id : "ENSG00000198939.8",
      gene_type : "protein_coding",
      gene_name : "ZFP2",
      gene_level : 2,
      hgnc_id : "HGNC:26138",
      havana_gene : "OTTHUMG00000130885.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178941191,
      stop : 178966433,
      direction : "+",
      ID : "ENSG00000178187.8",
      gene_id : "ENSG00000178187.8",
      gene_type : "protein_coding",
      gene_name : "ZNF454",
      gene_level : 2,
      hgnc_id : "HGNC:21200",
      havana_gene : "OTTHUMG00000130891.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 178977587,
      stop : 178996206,
      direction : "-",
      ID : "ENSG00000113262.16",
      gene_id : "ENSG00000113262.16",
      gene_type : "protein_coding",
      gene_name : "GRM6",
      gene_level : 2,
      hgnc_id : "HGNC:4598",
      havana_gene : "OTTHUMG00000130889.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179023804,
      stop : 179035064,
      direction : "+",
      ID : "ENSG00000234284.7",
      gene_id : "ENSG00000234284.7",
      gene_type : "protein_coding",
      gene_name : "ZNF879",
      gene_level : 1,
      hgnc_id : "HGNC:37273",
      havana_gene : "OTTHUMG00000163596.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179060373,
      stop : 179083977,
      direction : "+",
      ID : "ENSG00000177932.7",
      gene_id : "ENSG00000177932.7",
      gene_type : "protein_coding",
      gene_name : "ZNF354C",
      gene_level : 2,
      hgnc_id : "HGNC:16736",
      havana_gene : "OTTHUMG00000130888.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179110853,
      stop : 179345461,
      direction : "-",
      ID : "ENSG00000087116.16",
      gene_id : "ENSG00000087116.16",
      gene_type : "protein_coding",
      gene_name : "ADAMTS2",
      gene_level : 2,
      hgnc_id : "HGNC:218",
      havana_gene : "OTTHUMG00000130915.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179550554,
      stop : 179610012,
      direction : "+",
      ID : "ENSG00000176783.15",
      gene_id : "ENSG00000176783.15",
      gene_type : "protein_coding",
      gene_name : "RUFY1",
      gene_level : 1,
      hgnc_id : "HGNC:19760",
      havana_gene : "OTTHUMG00000130913.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179614178,
      stop : 179634784,
      direction : "-",
      ID : "ENSG00000169045.17",
      gene_id : "ENSG00000169045.17",
      gene_type : "protein_coding",
      gene_name : "HNRNPH1",
      gene_level : 1,
      hgnc_id : "HGNC:5041",
      havana_gene : "OTTHUMG00000130908.43",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179678560,
      stop : 179681034,
      direction : "-",
      ID : "ENSG00000204659.5",
      gene_id : "ENSG00000204659.5",
      gene_type : "protein_coding",
      gene_name : "CBY3",
      gene_level : 2,
      hgnc_id : "HGNC:33278",
      havana_gene : "OTTHUMG00000163163.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179678628,
      stop : 179731641,
      direction : "+",
      ID : "ENSG00000127022.16",
      gene_id : "ENSG00000127022.16",
      gene_type : "protein_coding",
      gene_name : "CANX",
      gene_level : 1,
      hgnc_id : "HGNC:1473",
      havana_gene : "OTTHUMG00000130910.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179732822,
      stop : 179777283,
      direction : "+",
      ID : "ENSG00000161021.13",
      gene_id : "ENSG00000161021.13",
      gene_type : "protein_coding",
      gene_name : "MAML1",
      gene_level : 2,
      hgnc_id : "HGNC:13632",
      havana_gene : "OTTHUMG00000163237.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179793980,
      stop : 179796647,
      direction : "+",
      ID : "ENSG00000213316.10",
      gene_id : "ENSG00000213316.10",
      gene_type : "protein_coding",
      gene_name : "LTC4S",
      gene_level : 1,
      hgnc_id : "HGNC:6719",
      havana_gene : "OTTHUMG00000150314.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179797597,
      stop : 179806952,
      direction : "-",
      ID : "ENSG00000161013.17",
      gene_id : "ENSG00000161013.17",
      gene_type : "protein_coding",
      gene_name : "MGAT4B",
      gene_level : 1,
      hgnc_id : "HGNC:7048",
      havana_gene : "OTTHUMG00000130912.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179806398,
      stop : 179838078,
      direction : "+",
      ID : "ENSG00000161011.20",
      gene_id : "ENSG00000161011.20",
      gene_type : "protein_coding",
      gene_name : "SQSTM1",
      gene_level : 2,
      hgnc_id : "HGNC:11280",
      havana_gene : "OTTHUMG00000150643.80",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179835133,
      stop : 179862173,
      direction : "-",
      ID : "ENSG00000161010.15",
      gene_id : "ENSG00000161010.15",
      gene_type : "protein_coding",
      gene_name : "MRNIP",
      gene_level : 2,
      hgnc_id : "HGNC:30817",
      havana_gene : "OTTHUMG00000163490.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179862066,
      stop : 179907897,
      direction : "-",
      ID : "ENSG00000197226.13",
      gene_id : "ENSG00000197226.13",
      gene_type : "protein_coding",
      gene_name : "TBC1D9B",
      gene_level : 2,
      hgnc_id : "HGNC:29097",
      havana_gene : "OTTHUMG00000130911.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 179911651,
      stop : 180072113,
      direction : "-",
      ID : "ENSG00000113269.14",
      gene_id : "ENSG00000113269.14",
      gene_type : "protein_coding",
      gene_name : "RNF130",
      gene_level : 1,
      hgnc_id : "HGNC:18280",
      havana_gene : "OTTHUMG00000130909.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180100795,
      stop : 180209211,
      direction : "-",
      ID : "ENSG00000146090.16",
      gene_id : "ENSG00000146090.16",
      gene_type : "protein_coding",
      gene_name : "RASGEF1C",
      gene_level : 2,
      hgnc_id : "HGNC:27400",
      havana_gene : "OTTHUMG00000130914.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180233143,
      stop : 180292099,
      direction : "-",
      ID : "ENSG00000050748.18",
      gene_id : "ENSG00000050748.18",
      gene_type : "protein_coding",
      gene_name : "MAPK9",
      gene_level : 1,
      hgnc_id : "HGNC:6886",
      havana_gene : "OTTHUMG00000130934.9",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180300698,
      stop : 180353336,
      direction : "-",
      ID : "ENSG00000131459.13",
      gene_id : "ENSG00000131459.13",
      gene_type : "protein_coding",
      gene_name : "GFPT2",
      gene_level : 2,
      hgnc_id : "HGNC:4242",
      havana_gene : "OTTHUMG00000163442.6",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180494379,
      stop : 180578358,
      direction : "+",
      ID : "ENSG00000113300.13",
      gene_id : "ENSG00000113300.13",
      gene_type : "protein_coding",
      gene_name : "CNOT6",
      gene_level : 1,
      hgnc_id : "HGNC:14099",
      havana_gene : "OTTHUMG00000130935.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180590105,
      stop : 180591499,
      direction : "-",
      ID : "ENSG00000161055.4",
      gene_id : "ENSG00000161055.4",
      gene_type : "protein_coding",
      gene_name : "SCGB3A1",
      gene_level : 2,
      hgnc_id : "HGNC:18384",
      havana_gene : "OTTHUMG00000130936.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180601506,
      stop : 180649624,
      direction : "-",
      ID : "ENSG00000037280.16",
      gene_id : "ENSG00000037280.16",
      gene_type : "protein_coding",
      gene_name : "FLT4",
      gene_level : 2,
      hgnc_id : "HGNC:3767",
      havana_gene : "OTTHUMG00000130931.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180739042,
      stop : 180740099,
      direction : "-",
      ID : "ENSG00000174339.2",
      gene_id : "ENSG00000174339.2",
      gene_type : "protein_coding",
      gene_name : "OR2Y1",
      gene_level : 2,
      hgnc_id : "HGNC:14837",
      havana_gene : "OTTHUMG00000162237.2",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180784780,
      stop : 180815652,
      direction : "-",
      ID : "ENSG00000131446.17",
      gene_id : "ENSG00000131446.17",
      gene_type : "protein_coding",
      gene_name : "MGAT1",
      gene_level : 1,
      hgnc_id : "HGNC:7044",
      havana_gene : "OTTHUMG00000130937.6",
      tag : "retrogene"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180847611,
      stop : 180861285,
      direction : "-",
      ID : "ENSG00000196670.14",
      gene_id : "ENSG00000196670.14",
      gene_type : "protein_coding",
      gene_name : "ZFP62",
      gene_level : 2,
      hgnc_id : "HGNC:23241",
      havana_gene : "OTTHUMG00000162273.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180899077,
      stop : 180950906,
      direction : "+",
      ID : "ENSG00000113303.12",
      gene_id : "ENSG00000113303.12",
      gene_type : "protein_coding",
      gene_name : "BTNL8",
      gene_level : 2,
      hgnc_id : "HGNC:26131",
      havana_gene : "OTTHUMG00000130932.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 180988846,
      stop : 181006727,
      direction : "+",
      ID : "ENSG00000168903.9",
      gene_id : "ENSG00000168903.9",
      gene_type : "protein_coding",
      gene_name : "BTNL3",
      gene_level : 2,
      hgnc_id : "HGNC:1143",
      havana_gene : "OTTHUMG00000162091.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181040225,
      stop : 181061521,
      direction : "+",
      ID : "ENSG00000165810.17",
      gene_id : "ENSG00000165810.17",
      gene_type : "protein_coding",
      gene_name : "BTNL9",
      gene_level : 1,
      hgnc_id : "HGNC:24176",
      havana_gene : "OTTHUMG00000133152.5",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181123122,
      stop : 181131169,
      direction : "-",
      ID : "ENSG00000185372.3",
      gene_id : "ENSG00000185372.3",
      gene_type : "protein_coding",
      gene_name : "OR2V1",
      gene_level : 2,
      hgnc_id : "HGNC:8280",
      havana_gene : "OTTHUMG00000162118.4",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181147586,
      stop : 181159285,
      direction : "+",
      ID : "ENSG00000182613.3",
      gene_id : "ENSG00000182613.3",
      gene_type : "protein_coding",
      gene_name : "OR2V2",
      gene_level : 2,
      hgnc_id : "HGNC:15341",
      havana_gene : "OTTHUMG00000130933.3",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181193924,
      stop : 181205293,
      direction : "-",
      ID : "ENSG00000146054.18",
      gene_id : "ENSG00000146054.18",
      gene_type : "protein_coding",
      gene_name : "TRIM7",
      gene_level : 2,
      hgnc_id : "HGNC:16278",
      havana_gene : "OTTHUMG00000130963.8",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181222499,
      stop : 181235808,
      direction : "+",
      ID : "ENSG00000146063.20",
      gene_id : "ENSG00000146063.20",
      gene_type : "protein_coding",
      gene_name : "TRIM41",
      gene_level : 1,
      hgnc_id : "HGNC:19013",
      havana_gene : "OTTHUMG00000130965.10",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181236897,
      stop : 181248096,
      direction : "-",
      ID : "ENSG00000204628.12",
      gene_id : "ENSG00000204628.12",
      gene_type : "protein_coding",
      gene_name : "RACK1",
      gene_level : 1,
      hgnc_id : "HGNC:4399",
      havana_gene : "OTTHUMG00000163380.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181254417,
      stop : 181261139,
      direction : "-",
      ID : "ENSG00000183718.5",
      gene_id : "ENSG00000183718.5",
      gene_type : "protein_coding",
      gene_name : "TRIM52",
      gene_level : 1,
      hgnc_id : "HGNC:19024",
      havana_gene : "OTTHUMG00000130964.7",
      tag : null
    },
    {
      chromosome : 5,
      annotation : "HAVANA",
      type : "gene",
      start : 181367268,
      stop : 181368262,
      direction : "+",
      ID : "ENSG00000230178.1",
      gene_id : "ENSG00000230178.1",
      gene_type : "protein_coding",
      gene_name : "OR4F3",
      gene_level : 2,
      hgnc_id : "HGNC:8300",
      havana_gene : "OTTHUMG00000162081.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 291630,
      stop : 351355,
      direction : "+",
      ID : "ENSG00000112679.14",
      gene_id : "ENSG00000112679.14",
      gene_type : "protein_coding",
      gene_name : "DUSP22",
      gene_level : 2,
      hgnc_id : "HGNC:16077",
      havana_gene : "OTTHUMG00000014113.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 391752,
      stop : 411443,
      direction : "+",
      ID : "ENSG00000137265.15",
      gene_id : "ENSG00000137265.15",
      gene_type : "protein_coding",
      gene_name : "IRF4",
      gene_level : 2,
      hgnc_id : "HGNC:6119",
      havana_gene : "OTTHUMG00000016294.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 485154,
      stop : 693139,
      direction : "-",
      ID : "ENSG00000112685.14",
      gene_id : "ENSG00000112685.14",
      gene_type : "protein_coding",
      gene_name : "EXOC2",
      gene_level : 2,
      hgnc_id : "HGNC:24968",
      havana_gene : "OTTHUMG00000137437.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 655939,
      stop : 656963,
      direction : "-",
      ID : "ENSG00000188996.4",
      gene_id : "ENSG00000188996.4",
      gene_type : "protein_coding",
      gene_name : "HUS1B",
      gene_level : 2,
      hgnc_id : "HGNC:16485",
      havana_gene : "OTTHUMG00000090059.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 1312098,
      stop : 1314758,
      direction : "+",
      ID : "ENSG00000164379.7",
      gene_id : "ENSG00000164379.7",
      gene_type : "protein_coding",
      gene_name : "FOXQ1",
      gene_level : 2,
      hgnc_id : "HGNC:20951",
      havana_gene : "OTTHUMG00000016160.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 1389576,
      stop : 1395603,
      direction : "+",
      ID : "ENSG00000137273.6",
      gene_id : "ENSG00000137273.6",
      gene_type : "protein_coding",
      gene_name : "FOXF2",
      gene_level : 2,
      hgnc_id : "HGNC:3810",
      havana_gene : "OTTHUMG00000016243.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 1609915,
      stop : 1613897,
      direction : "+",
      ID : "ENSG00000054598.9",
      gene_id : "ENSG00000054598.9",
      gene_type : "protein_coding",
      gene_name : "FOXC1",
      gene_level : 2,
      hgnc_id : "HGNC:3800",
      havana_gene : "OTTHUMG00000016182.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 1623806,
      stop : 2245605,
      direction : "-",
      ID : "ENSG00000112699.11",
      gene_id : "ENSG00000112699.11",
      gene_type : "protein_coding",
      gene_name : "GMDS",
      gene_level : 1,
      hgnc_id : "HGNC:4369",
      havana_gene : "OTTHUMG00000016143.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 2663629,
      stop : 2750922,
      direction : "-",
      ID : "ENSG00000145949.11",
      gene_id : "ENSG00000145949.11",
      gene_type : "protein_coding",
      gene_name : "MYLK4",
      gene_level : 2,
      hgnc_id : "HGNC:27972",
      havana_gene : "OTTHUMG00000014121.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 2765393,
      stop : 2786952,
      direction : "+",
      ID : "ENSG00000124535.16",
      gene_id : "ENSG00000124535.16",
      gene_type : "protein_coding",
      gene_name : "WRNIP1",
      gene_level : 2,
      hgnc_id : "HGNC:20876",
      havana_gene : "OTTHUMG00000014126.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 2832332,
      stop : 2841959,
      direction : "-",
      ID : "ENSG00000021355.13",
      gene_id : "ENSG00000021355.13",
      gene_type : "protein_coding",
      gene_name : "SERPINB1",
      gene_level : 2,
      hgnc_id : "HGNC:3311",
      havana_gene : "OTTHUMG00000014124.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 2887270,
      stop : 2903309,
      direction : "-",
      ID : "ENSG00000170542.6",
      gene_id : "ENSG00000170542.6",
      gene_type : "protein_coding",
      gene_name : "SERPINB9",
      gene_level : 2,
      hgnc_id : "HGNC:8955",
      havana_gene : "OTTHUMG00000014131.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 2948159,
      stop : 2972165,
      direction : "-",
      ID : "ENSG00000124570.21",
      gene_id : "ENSG00000124570.21",
      gene_type : "protein_coding",
      gene_name : "SERPINB6",
      gene_level : 2,
      hgnc_id : "HGNC:8950",
      havana_gene : "OTTHUMG00000016170.12",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 2987987,
      stop : 3019755,
      direction : "+",
      ID : "ENSG00000124588.22",
      gene_id : "ENSG00000124588.22",
      gene_type : "protein_coding",
      gene_name : "NQO2",
      gene_level : 2,
      hgnc_id : "HGNC:7856",
      havana_gene : "OTTHUMG00000014130.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3063824,
      stop : 3115187,
      direction : "+",
      ID : "ENSG00000137275.16",
      gene_id : "ENSG00000137275.16",
      gene_type : "protein_coding",
      gene_name : "RIPK1",
      gene_level : 2,
      hgnc_id : "HGNC:10019",
      havana_gene : "OTTHUMG00000014134.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3118374,
      stop : 3153578,
      direction : "+",
      ID : "ENSG00000137274.13",
      gene_id : "ENSG00000137274.13",
      gene_type : "protein_coding",
      gene_name : "BPHL",
      gene_level : 1,
      hgnc_id : "HGNC:1094",
      havana_gene : "OTTHUMG00000014140.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3153497,
      stop : 3157544,
      direction : "-",
      ID : "ENSG00000137267.7",
      gene_id : "ENSG00000137267.7",
      gene_type : "protein_coding",
      gene_name : "TUBB2A",
      gene_level : 2,
      hgnc_id : "HGNC:12412",
      havana_gene : "OTTHUMG00000014135.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3223324,
      stop : 3231730,
      direction : "-",
      ID : "ENSG00000137285.11",
      gene_id : "ENSG00000137285.11",
      gene_type : "protein_coding",
      gene_name : "TUBB2B",
      gene_level : 2,
      hgnc_id : "HGNC:30829",
      havana_gene : "OTTHUMG00000014143.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3231403,
      stop : 3303373,
      direction : "+",
      ID : "ENSG00000180822.12",
      gene_id : "ENSG00000180822.12",
      gene_type : "protein_coding",
      gene_name : "PSMG4",
      gene_level : 1,
      hgnc_id : "HGNC:21108",
      havana_gene : "OTTHUMG00000014142.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3268962,
      stop : 3457050,
      direction : "-",
      ID : "ENSG00000137266.15",
      gene_id : "ENSG00000137266.15",
      gene_type : "protein_coding",
      gene_name : "SLC22A23",
      gene_level : 1,
      hgnc_id : "HGNC:21106",
      havana_gene : "OTTHUMG00000014144.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3722614,
      stop : 3751713,
      direction : "-",
      ID : "ENSG00000168994.14",
      gene_id : "ENSG00000168994.14",
      gene_type : "protein_coding",
      gene_name : "PXDC1",
      gene_level : 2,
      hgnc_id : "HGNC:21361",
      havana_gene : "OTTHUMG00000014146.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 3849373,
      stop : 3851320,
      direction : "+",
      ID : "ENSG00000145945.7",
      gene_id : "ENSG00000145945.7",
      gene_type : "protein_coding",
      gene_name : "FAM50B",
      gene_level : 2,
      hgnc_id : "HGNC:18789",
      havana_gene : "OTTHUMG00000014147.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 4021267,
      stop : 4064983,
      direction : "+",
      ID : "ENSG00000112739.17",
      gene_id : "ENSG00000112739.17",
      gene_type : "protein_coding",
      gene_name : "PRPF4B",
      gene_level : 2,
      hgnc_id : "HGNC:17346",
      havana_gene : "OTTHUMG00000014157.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 4049434,
      stop : 4087344,
      direction : "-",
      ID : "ENSG00000145975.15",
      gene_id : "ENSG00000145975.15",
      gene_type : "protein_coding",
      gene_name : "FAM217A",
      gene_level : 2,
      hgnc_id : "HGNC:21362",
      havana_gene : "OTTHUMG00000014159.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 4115693,
      stop : 4135597,
      direction : "-",
      ID : "ENSG00000198721.13",
      gene_id : "ENSG00000198721.13",
      gene_type : "protein_coding",
      gene_name : "ECI2",
      gene_level : 1,
      hgnc_id : "HGNC:14601",
      havana_gene : "OTTHUMG00000014158.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 4706159,
      stop : 4955551,
      direction : "+",
      ID : "ENSG00000153046.18",
      gene_id : "ENSG00000153046.18",
      gene_type : "protein_coding",
      gene_name : "CDYL",
      gene_level : 2,
      hgnc_id : "HGNC:1811",
      havana_gene : "OTTHUMG00000014170.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 4994717,
      stop : 5004063,
      direction : "-",
      ID : "ENSG00000124787.14",
      gene_id : "ENSG00000124787.14",
      gene_type : "protein_coding",
      gene_name : "RPP40",
      gene_level : 1,
      hgnc_id : "HGNC:20992",
      havana_gene : "OTTHUMG00000014168.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 5085341,
      stop : 5089487,
      direction : "+",
      ID : "ENSG00000219607.4",
      gene_id : "ENSG00000219607.4",
      gene_type : "protein_coding",
      gene_name : "PPP1R3G",
      gene_level : 2,
      hgnc_id : "HGNC:14945",
      havana_gene : "OTTHUMG00000014172.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 5103629,
      stop : 5260950,
      direction : "-",
      ID : "ENSG00000214113.11",
      gene_id : "ENSG00000214113.11",
      gene_type : "protein_coding",
      gene_name : "LYRM4",
      gene_level : 1,
      hgnc_id : "HGNC:21365",
      havana_gene : "OTTHUMG00000014173.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 5261044,
      stop : 5829192,
      direction : "+",
      ID : "ENSG00000145982.13",
      gene_id : "ENSG00000145982.13",
      gene_type : "protein_coding",
      gene_name : "FARS2",
      gene_level : 2,
      hgnc_id : "HGNC:21062",
      havana_gene : "OTTHUMG00000014178.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 5997999,
      stop : 6007605,
      direction : "-",
      ID : "ENSG00000124785.9",
      gene_id : "ENSG00000124785.9",
      gene_type : "protein_coding",
      gene_name : "NRN1",
      gene_level : 2,
      hgnc_id : "HGNC:17972",
      havana_gene : "OTTHUMG00000014184.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 6144084,
      stop : 6321013,
      direction : "-",
      ID : "ENSG00000124491.16",
      gene_id : "ENSG00000124491.16",
      gene_type : "protein_coding",
      gene_name : "F13A1",
      gene_level : 1,
      hgnc_id : "HGNC:3531",
      havana_gene : "OTTHUMG00000014186.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 6588108,
      stop : 6654983,
      direction : "+",
      ID : "ENSG00000112799.9",
      gene_id : "ENSG00000112799.9",
      gene_type : "protein_coding",
      gene_name : "LY86",
      gene_level : 2,
      hgnc_id : "HGNC:16837",
      havana_gene : "OTTHUMG00000014190.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7107597,
      stop : 7251980,
      direction : "+",
      ID : "ENSG00000124782.20",
      gene_id : "ENSG00000124782.20",
      gene_type : "protein_coding",
      gene_name : "RREB1",
      gene_level : 2,
      hgnc_id : "HGNC:10449",
      havana_gene : "OTTHUMG00000014201.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7268306,
      stop : 7347446,
      direction : "-",
      ID : "ENSG00000124783.14",
      gene_id : "ENSG00000124783.14",
      gene_type : "protein_coding",
      gene_name : "SSR1",
      gene_level : 1,
      hgnc_id : "HGNC:11323",
      havana_gene : "OTTHUMG00000014202.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7326656,
      stop : 7389742,
      direction : "-",
      ID : "ENSG00000164304.16",
      gene_id : "ENSG00000164304.16",
      gene_type : "protein_coding",
      gene_name : "CAGE1",
      gene_level : 1,
      hgnc_id : "HGNC:21622",
      havana_gene : "OTTHUMG00000014200.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7389793,
      stop : 7418037,
      direction : "+",
      ID : "ENSG00000124784.9",
      gene_id : "ENSG00000124784.9",
      gene_type : "protein_coding",
      gene_name : "RIOK1",
      gene_level : 2,
      hgnc_id : "HGNC:18656",
      havana_gene : "OTTHUMG00000014207.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7541617,
      stop : 7586714,
      direction : "+",
      ID : "ENSG00000096696.14",
      gene_id : "ENSG00000096696.14",
      gene_type : "protein_coding",
      gene_name : "DSP",
      gene_level : 2,
      hgnc_id : "HGNC:3052",
      havana_gene : "OTTHUMG00000014212.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7590198,
      stop : 7611967,
      direction : "+",
      ID : "ENSG00000168566.13",
      gene_id : "ENSG00000168566.13",
      gene_type : "protein_coding",
      gene_name : "SNRNP48",
      gene_level : 2,
      hgnc_id : "HGNC:21368",
      havana_gene : "OTTHUMG00000014213.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7726099,
      stop : 7881728,
      direction : "+",
      ID : "ENSG00000153162.9",
      gene_id : "ENSG00000153162.9",
      gene_type : "protein_coding",
      gene_name : "BMP6",
      gene_level : 2,
      hgnc_id : "HGNC:1073",
      havana_gene : "OTTHUMG00000014217.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7881517,
      stop : 7910788,
      direction : "-",
      ID : "ENSG00000239264.9",
      gene_id : "ENSG00000239264.9",
      gene_type : "protein_coding",
      gene_name : "TXNDC5",
      gene_level : 2,
      hgnc_id : "HGNC:21073",
      havana_gene : "OTTHUMG00000014216.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 7881522,
      stop : 8064364,
      direction : "-",
      ID : "ENSG00000259040.5",
      gene_id : "ENSG00000259040.5",
      gene_type : "protein_coding",
      gene_name : "BLOC1S5-TXNDC5",
      gene_level : 2,
      hgnc_id : "HGNC:42001",
      havana_gene : "OTTHUMG00000171453.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 8013567,
      stop : 8064396,
      direction : "-",
      ID : "ENSG00000188428.20",
      gene_id : "ENSG00000188428.20",
      gene_type : "protein_coding",
      gene_name : "BLOC1S5",
      gene_level : 2,
      hgnc_id : "HGNC:18561",
      havana_gene : "OTTHUMG00000014220.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 8015726,
      stop : 8102530,
      direction : "-",
      ID : "ENSG00000265818.1",
      gene_id : "ENSG00000265818.1",
      gene_type : "protein_coding",
      gene_name : "EEF1E1-BLOC1S5",
      gene_level : 2,
      hgnc_id : "HGNC:49187",
      havana_gene : "OTTHUMG00000179299.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 8073360,
      stop : 8102559,
      direction : "-",
      ID : "ENSG00000124802.12",
      gene_id : "ENSG00000124802.12",
      gene_type : "protein_coding",
      gene_name : "EEF1E1",
      gene_level : 1,
      hgnc_id : "HGNC:3212",
      havana_gene : "OTTHUMG00000014221.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 8411435,
      stop : 8435561,
      direction : "-",
      ID : "ENSG00000124786.12",
      gene_id : "ENSG00000124786.12",
      gene_type : "protein_coding",
      gene_name : "SLC35B3",
      gene_level : 2,
      hgnc_id : "HGNC:21601",
      havana_gene : "OTTHUMG00000014224.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10393186,
      stop : 10419659,
      direction : "-",
      ID : "ENSG00000137203.15",
      gene_id : "ENSG00000137203.15",
      gene_type : "protein_coding",
      gene_name : "TFAP2A",
      gene_level : 1,
      hgnc_id : "HGNC:11742",
      havana_gene : "OTTHUMG00000014235.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10492223,
      stop : 10629368,
      direction : "+",
      ID : "ENSG00000111846.19",
      gene_id : "ENSG00000111846.19",
      gene_type : "protein_coding",
      gene_name : "GCNT2",
      gene_level : 2,
      hgnc_id : "HGNC:4204",
      havana_gene : "OTTHUMG00000014244.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10671418,
      stop : 10694797,
      direction : "-",
      ID : "ENSG00000137434.11",
      gene_id : "ENSG00000137434.11",
      gene_type : "protein_coding",
      gene_name : "C6orf52",
      gene_level : 1,
      hgnc_id : "HGNC:20881",
      havana_gene : "OTTHUMG00000014240.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10694972,
      stop : 10709782,
      direction : "+",
      ID : "ENSG00000111845.5",
      gene_id : "ENSG00000111845.5",
      gene_type : "protein_coding",
      gene_name : "PAK1IP1",
      gene_level : 2,
      hgnc_id : "HGNC:20882",
      havana_gene : "OTTHUMG00000014245.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10722915,
      stop : 10731129,
      direction : "+",
      ID : "ENSG00000111843.14",
      gene_id : "ENSG00000111843.14",
      gene_type : "protein_coding",
      gene_name : "TMEM14C",
      gene_level : 2,
      hgnc_id : "HGNC:20952",
      havana_gene : "OTTHUMG00000014242.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10747759,
      stop : 10852753,
      direction : "+",
      ID : "ENSG00000137210.14",
      gene_id : "ENSG00000137210.14",
      gene_type : "protein_coding",
      gene_name : "TMEM14B",
      gene_level : 2,
      hgnc_id : "HGNC:21384",
      havana_gene : "OTTHUMG00000014246.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10747794,
      stop : 10930423,
      direction : "+",
      ID : "ENSG00000272162.1",
      gene_id : "ENSG00000272162.1",
      gene_type : "protein_coding",
      gene_name : "AL024498.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185388.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10762723,
      stop : 10838553,
      direction : "-",
      ID : "ENSG00000111837.12",
      gene_id : "ENSG00000111837.12",
      gene_type : "protein_coding",
      gene_name : "MAK",
      gene_level : 2,
      hgnc_id : "HGNC:6816",
      havana_gene : "OTTHUMG00000014247.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10873223,
      stop : 10882041,
      direction : "-",
      ID : "ENSG00000124827.7",
      gene_id : "ENSG00000124827.7",
      gene_type : "protein_coding",
      gene_name : "GCM2",
      gene_level : 2,
      hgnc_id : "HGNC:4198",
      havana_gene : "OTTHUMG00000014249.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10886831,
      stop : 10979320,
      direction : "+",
      ID : "ENSG00000153157.13",
      gene_id : "ENSG00000153157.13",
      gene_type : "protein_coding",
      gene_name : "SYCP2L",
      gene_level : 2,
      hgnc_id : "HGNC:21537",
      havana_gene : "OTTHUMG00000014250.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 10980759,
      stop : 11044305,
      direction : "-",
      ID : "ENSG00000197977.4",
      gene_id : "ENSG00000197977.4",
      gene_type : "protein_coding",
      gene_name : "ELOVL2",
      gene_level : 2,
      hgnc_id : "HGNC:14416",
      havana_gene : "OTTHUMG00000014252.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 11093834,
      stop : 11138733,
      direction : "+",
      ID : "ENSG00000224531.6",
      gene_id : "ENSG00000224531.6",
      gene_type : "protein_coding",
      gene_name : "SMIM13",
      gene_level : 2,
      hgnc_id : "HGNC:27356",
      havana_gene : "OTTHUMG00000014253.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 11102489,
      stop : 11111725,
      direction : "-",
      ID : "ENSG00000244476.3",
      gene_id : "ENSG00000244476.3",
      gene_type : "protein_coding",
      gene_name : "ERVFRD-1",
      gene_level : 2,
      hgnc_id : "HGNC:33823",
      havana_gene : "OTTHUMG00000159193.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 11183298,
      stop : 11382348,
      direction : "-",
      ID : "ENSG00000111859.17",
      gene_id : "ENSG00000111859.17",
      gene_type : "protein_coding",
      gene_name : "NEDD9",
      gene_level : 2,
      hgnc_id : "HGNC:7733",
      havana_gene : "OTTHUMG00000014255.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 11537749,
      stop : 11583524,
      direction : "+",
      ID : "ENSG00000205269.6",
      gene_id : "ENSG00000205269.6",
      gene_type : "protein_coding",
      gene_name : "TMEM170B",
      gene_level : 1,
      hgnc_id : "HGNC:34244",
      havana_gene : "OTTHUMG00000014259.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 11712054,
      stop : 11807046,
      direction : "-",
      ID : "ENSG00000111863.13",
      gene_id : "ENSG00000111863.13",
      gene_type : "protein_coding",
      gene_name : "ADTRP",
      gene_level : 2,
      hgnc_id : "HGNC:21214",
      havana_gene : "OTTHUMG00000014260.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 12008762,
      stop : 12164999,
      direction : "+",
      ID : "ENSG00000095951.17",
      gene_id : "ENSG00000095951.17",
      gene_type : "protein_coding",
      gene_name : "HIVEP1",
      gene_level : 1,
      hgnc_id : "HGNC:4920",
      havana_gene : "OTTHUMG00000014265.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 12290361,
      stop : 12297194,
      direction : "+",
      ID : "ENSG00000078401.7",
      gene_id : "ENSG00000078401.7",
      gene_type : "protein_coding",
      gene_name : "EDN1",
      gene_level : 2,
      hgnc_id : "HGNC:3176",
      havana_gene : "OTTHUMG00000014266.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 12716554,
      stop : 13287843,
      direction : "+",
      ID : "ENSG00000112137.18",
      gene_id : "ENSG00000112137.18",
      gene_type : "protein_coding",
      gene_name : "PHACTR1",
      gene_level : 2,
      hgnc_id : "HGNC:20990",
      havana_gene : "OTTHUMG00000014270.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13266542,
      stop : 13328583,
      direction : "-",
      ID : "ENSG00000145979.18",
      gene_id : "ENSG00000145979.18",
      gene_type : "protein_coding",
      gene_name : "TBC1D7",
      gene_level : 2,
      hgnc_id : "HGNC:21066",
      havana_gene : "OTTHUMG00000014272.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13357830,
      stop : 13487662,
      direction : "-",
      ID : "ENSG00000145990.11",
      gene_id : "ENSG00000145990.11",
      gene_type : "protein_coding",
      gene_name : "GFOD1",
      gene_level : 2,
      hgnc_id : "HGNC:21096",
      havana_gene : "OTTHUMG00000014276.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13574227,
      stop : 13615158,
      direction : "+",
      ID : "ENSG00000124523.17",
      gene_id : "ENSG00000124523.17",
      gene_type : "protein_coding",
      gene_name : "SIRT5",
      gene_level : 2,
      hgnc_id : "HGNC:14933",
      havana_gene : "OTTHUMG00000014278.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13615335,
      stop : 13632739,
      direction : "+",
      ID : "ENSG00000225921.7",
      gene_id : "ENSG00000225921.7",
      gene_type : "protein_coding",
      gene_name : "NOL7",
      gene_level : 2,
      hgnc_id : "HGNC:21040",
      havana_gene : "OTTHUMG00000014277.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13621498,
      stop : 13711835,
      direction : "-",
      ID : "ENSG00000010017.13",
      gene_id : "ENSG00000010017.13",
      gene_type : "protein_coding",
      gene_name : "RANBP9",
      gene_level : 2,
      hgnc_id : "HGNC:13727",
      havana_gene : "OTTHUMG00000015642.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13786557,
      stop : 13814568,
      direction : "-",
      ID : "ENSG00000050393.11",
      gene_id : "ENSG00000050393.11",
      gene_type : "protein_coding",
      gene_name : "MCUR1",
      gene_level : 2,
      hgnc_id : "HGNC:21097",
      havana_gene : "OTTHUMG00000014279.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 13924446,
      stop : 13980310,
      direction : "+",
      ID : "ENSG00000180537.13",
      gene_id : "ENSG00000180537.13",
      gene_type : "protein_coding",
      gene_name : "RNF182",
      gene_level : 2,
      hgnc_id : "HGNC:28522",
      havana_gene : "OTTHUMG00000014280.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 14117256,
      stop : 14136918,
      direction : "+",
      ID : "ENSG00000112149.10",
      gene_id : "ENSG00000112149.10",
      gene_type : "protein_coding",
      gene_name : "CD83",
      gene_level : 2,
      hgnc_id : "HGNC:1703",
      havana_gene : "OTTHUMG00000014283.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 15246069,
      stop : 15522042,
      direction : "+",
      ID : "ENSG00000008083.14",
      gene_id : "ENSG00000008083.14",
      gene_type : "protein_coding",
      gene_name : "JARID2",
      gene_level : 2,
      hgnc_id : "HGNC:6196",
      havana_gene : "OTTHUMG00000014293.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 15522807,
      stop : 15663058,
      direction : "-",
      ID : "ENSG00000047579.20",
      gene_id : "ENSG00000047579.20",
      gene_type : "protein_coding",
      gene_name : "DTNBP1",
      gene_level : 2,
      hgnc_id : "HGNC:17328",
      havana_gene : "OTTHUMG00000014295.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 16129086,
      stop : 16148248,
      direction : "+",
      ID : "ENSG00000007944.15",
      gene_id : "ENSG00000007944.15",
      gene_type : "protein_coding",
      gene_name : "MYLIP",
      gene_level : 2,
      hgnc_id : "HGNC:21155",
      havana_gene : "OTTHUMG00000016405.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 16238587,
      stop : 16295549,
      direction : "+",
      ID : "ENSG00000137198.10",
      gene_id : "ENSG00000137198.10",
      gene_type : "protein_coding",
      gene_name : "GMPR",
      gene_level : 2,
      hgnc_id : "HGNC:4376",
      havana_gene : "OTTHUMG00000014302.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 16299112,
      stop : 16761491,
      direction : "-",
      ID : "ENSG00000124788.19",
      gene_id : "ENSG00000124788.19",
      gene_type : "protein_coding",
      gene_name : "ATXN1",
      gene_level : 2,
      hgnc_id : "HGNC:10548",
      havana_gene : "OTTHUMG00000014303.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 17102050,
      stop : 17131378,
      direction : "+",
      ID : "ENSG00000230873.9",
      gene_id : "ENSG00000230873.9",
      gene_type : "protein_coding",
      gene_name : "STMND1",
      gene_level : 2,
      hgnc_id : "HGNC:44668",
      havana_gene : "OTTHUMG00000014304.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 17281361,
      stop : 17293871,
      direction : "+",
      ID : "ENSG00000112183.15",
      gene_id : "ENSG00000112183.15",
      gene_type : "protein_coding",
      gene_name : "RBM24",
      gene_level : 2,
      hgnc_id : "HGNC:21539",
      havana_gene : "OTTHUMG00000014306.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 17393505,
      stop : 17557790,
      direction : "+",
      ID : "ENSG00000112186.12",
      gene_id : "ENSG00000112186.12",
      gene_type : "protein_coding",
      gene_name : "CAP2",
      gene_level : 2,
      hgnc_id : "HGNC:20039",
      havana_gene : "OTTHUMG00000014311.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 17600302,
      stop : 17611715,
      direction : "+",
      ID : "ENSG00000137414.6",
      gene_id : "ENSG00000137414.6",
      gene_type : "protein_coding",
      gene_name : "FAM8A1",
      gene_level : 2,
      hgnc_id : "HGNC:16372",
      havana_gene : "OTTHUMG00000014309.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 17615035,
      stop : 17706925,
      direction : "-",
      ID : "ENSG00000124789.12",
      gene_id : "ENSG00000124789.12",
      gene_type : "protein_coding",
      gene_name : "NUP153",
      gene_level : 2,
      hgnc_id : "HGNC:8062",
      havana_gene : "OTTHUMG00000014312.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 17759183,
      stop : 17987635,
      direction : "-",
      ID : "ENSG00000137177.20",
      gene_id : "ENSG00000137177.20",
      gene_type : "protein_coding",
      gene_name : "KIF13A",
      gene_level : 1,
      hgnc_id : "HGNC:14566",
      havana_gene : "OTTHUMG00000014313.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 18120440,
      stop : 18122677,
      direction : "-",
      ID : "ENSG00000187566.6",
      gene_id : "ENSG00000187566.6",
      gene_type : "protein_coding",
      gene_name : "NHLRC1",
      gene_level : 2,
      hgnc_id : "HGNC:21576",
      havana_gene : "OTTHUMG00000014315.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 18128311,
      stop : 18155077,
      direction : "-",
      ID : "ENSG00000137364.5",
      gene_id : "ENSG00000137364.5",
      gene_type : "protein_coding",
      gene_name : "TPMT",
      gene_level : 2,
      hgnc_id : "HGNC:12014",
      havana_gene : "OTTHUMG00000014317.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 18155329,
      stop : 18223854,
      direction : "+",
      ID : "ENSG00000165097.16",
      gene_id : "ENSG00000165097.16",
      gene_type : "protein_coding",
      gene_name : "KDM1B",
      gene_level : 2,
      hgnc_id : "HGNC:21577",
      havana_gene : "OTTHUMG00000014316.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 18223860,
      stop : 18264548,
      direction : "-",
      ID : "ENSG00000124795.17",
      gene_id : "ENSG00000124795.17",
      gene_type : "protein_coding",
      gene_name : "DEK",
      gene_level : 1,
      hgnc_id : "HGNC:2768",
      havana_gene : "OTTHUMG00000014319.13",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 18387350,
      stop : 18468870,
      direction : "+",
      ID : "ENSG00000137393.10",
      gene_id : "ENSG00000137393.10",
      gene_type : "protein_coding",
      gene_name : "RNF144B",
      gene_level : 2,
      hgnc_id : "HGNC:21578",
      havana_gene : "OTTHUMG00000014322.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 19837370,
      stop : 19842197,
      direction : "+",
      ID : "ENSG00000172201.12",
      gene_id : "ENSG00000172201.12",
      gene_type : "protein_coding",
      gene_name : "ID4",
      gene_level : 2,
      hgnc_id : "HGNC:5363",
      havana_gene : "OTTHUMG00000014333.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 20099684,
      stop : 20212469,
      direction : "-",
      ID : "ENSG00000172197.11",
      gene_id : "ENSG00000172197.11",
      gene_type : "protein_coding",
      gene_name : "MBOAT1",
      gene_level : 2,
      hgnc_id : "HGNC:21579",
      havana_gene : "OTTHUMG00000014334.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 20401879,
      stop : 20493714,
      direction : "+",
      ID : "ENSG00000112242.15",
      gene_id : "ENSG00000112242.15",
      gene_type : "protein_coding",
      gene_name : "E2F3",
      gene_level : 2,
      hgnc_id : "HGNC:3115",
      havana_gene : "OTTHUMG00000016389.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 20534457,
      stop : 21232404,
      direction : "+",
      ID : "ENSG00000145996.11",
      gene_id : "ENSG00000145996.11",
      gene_type : "protein_coding",
      gene_name : "CDKAL1",
      gene_level : 2,
      hgnc_id : "HGNC:21050",
      havana_gene : "OTTHUMG00000014340.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 21593751,
      stop : 21598619,
      direction : "+",
      ID : "ENSG00000124766.7",
      gene_id : "ENSG00000124766.7",
      gene_type : "protein_coding",
      gene_name : "SOX4",
      gene_level : 2,
      hgnc_id : "HGNC:11200",
      havana_gene : "OTTHUMG00000016101.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 22287244,
      stop : 22302826,
      direction : "-",
      ID : "ENSG00000172179.12",
      gene_id : "ENSG00000172179.12",
      gene_type : "protein_coding",
      gene_name : "PRL",
      gene_level : 2,
      hgnc_id : "HGNC:9445",
      havana_gene : "OTTHUMG00000016111.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 22569566,
      stop : 22571666,
      direction : "+",
      ID : "ENSG00000112273.7",
      gene_id : "ENSG00000112273.7",
      gene_type : "protein_coding",
      gene_name : "HDGFL1",
      gene_level : 2,
      hgnc_id : "HGNC:21095",
      havana_gene : "OTTHUMG00000016206.2",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24126186,
      stop : 24154900,
      direction : "+",
      ID : "ENSG00000152954.12",
      gene_id : "ENSG00000152954.12",
      gene_type : "protein_coding",
      gene_name : "NRSN1",
      gene_level : 2,
      hgnc_id : "HGNC:17881",
      havana_gene : "OTTHUMG00000016406.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24171755,
      stop : 24358059,
      direction : "-",
      ID : "ENSG00000146038.12",
      gene_id : "ENSG00000146038.12",
      gene_type : "protein_coding",
      gene_name : "DCDC2",
      gene_level : 2,
      hgnc_id : "HGNC:18141",
      havana_gene : "OTTHUMG00000016275.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24356903,
      stop : 24358285,
      direction : "+",
      ID : "ENSG00000146049.2",
      gene_id : "ENSG00000146049.2",
      gene_type : "protein_coding",
      gene_name : "KAAG1",
      gene_level : 2,
      hgnc_id : "HGNC:21031",
      havana_gene : "OTTHUMG00000014354.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24402908,
      stop : 24426194,
      direction : "+",
      ID : "ENSG00000124532.15",
      gene_id : "ENSG00000124532.15",
      gene_type : "protein_coding",
      gene_name : "MRS2",
      gene_level : 2,
      hgnc_id : "HGNC:13785",
      havana_gene : "OTTHUMG00000014355.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24424565,
      stop : 24495205,
      direction : "-",
      ID : "ENSG00000112293.15",
      gene_id : "ENSG00000112293.15",
      gene_type : "protein_coding",
      gene_name : "GPLD1",
      gene_level : 2,
      hgnc_id : "HGNC:4459",
      havana_gene : "OTTHUMG00000016104.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24494867,
      stop : 24537207,
      direction : "+",
      ID : "ENSG00000112294.14",
      gene_id : "ENSG00000112294.14",
      gene_type : "protein_coding",
      gene_name : "ALDH5A1",
      gene_level : 1,
      hgnc_id : "HGNC:408",
      havana_gene : "OTTHUMG00000014356.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24544104,
      stop : 24646191,
      direction : "-",
      ID : "ENSG00000137261.15",
      gene_id : "ENSG00000137261.15",
      gene_type : "protein_coding",
      gene_name : "KIAA0319",
      gene_level : 2,
      hgnc_id : "HGNC:21580",
      havana_gene : "OTTHUMG00000014358.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24649979,
      stop : 24666930,
      direction : "-",
      ID : "ENSG00000111802.14",
      gene_id : "ENSG00000111802.14",
      gene_type : "protein_coding",
      gene_name : "TDP2",
      gene_level : 2,
      hgnc_id : "HGNC:17768",
      havana_gene : "OTTHUMG00000014360.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24667035,
      stop : 24705065,
      direction : "+",
      ID : "ENSG00000112304.11",
      gene_id : "ENSG00000112304.11",
      gene_type : "protein_coding",
      gene_name : "ACOT13",
      gene_level : 2,
      hgnc_id : "HGNC:20999",
      havana_gene : "OTTHUMG00000014359.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24704861,
      stop : 24719998,
      direction : "-",
      ID : "ENSG00000112308.13",
      gene_id : "ENSG00000112308.13",
      gene_type : "protein_coding",
      gene_name : "C6orf62",
      gene_level : 2,
      hgnc_id : "HGNC:20998",
      havana_gene : "OTTHUMG00000014361.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24774931,
      stop : 24786099,
      direction : "+",
      ID : "ENSG00000112312.10",
      gene_id : "ENSG00000112312.10",
      gene_type : "protein_coding",
      gene_name : "GMNN",
      gene_level : 2,
      hgnc_id : "HGNC:17493",
      havana_gene : "OTTHUMG00000014363.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24797335,
      stop : 24798917,
      direction : "-",
      ID : "ENSG00000260286.4",
      gene_id : "ENSG00000260286.4",
      gene_type : "protein_coding",
      gene_name : "ARMH2",
      gene_level : 2,
      hgnc_id : "HGNC:49394",
      havana_gene : "OTTHUMG00000177257.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24797373,
      stop : 24809798,
      direction : "-",
      ID : "ENSG00000282804.1",
      gene_id : "ENSG00000282804.1",
      gene_type : "protein_coding",
      gene_name : "AL512428.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000014375.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 24804282,
      stop : 25042170,
      direction : "-",
      ID : "ENSG00000111913.20",
      gene_id : "ENSG00000111913.20",
      gene_type : "protein_coding",
      gene_name : "RIPOR2",
      gene_level : 2,
      hgnc_id : "HGNC:13872",
      havana_gene : "OTTHUMG00000191459.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25279078,
      stop : 25620530,
      direction : "+",
      ID : "ENSG00000079691.18",
      gene_id : "ENSG00000079691.18",
      gene_type : "protein_coding",
      gene_name : "CARMIL1",
      gene_level : 1,
      hgnc_id : "HGNC:21581",
      havana_gene : "OTTHUMG00000014393.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25652201,
      stop : 25701783,
      direction : "+",
      ID : "ENSG00000079689.14",
      gene_id : "ENSG00000079689.14",
      gene_type : "protein_coding",
      gene_name : "SCGN",
      gene_level : 2,
      hgnc_id : "HGNC:16941",
      havana_gene : "OTTHUMG00000014409.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25726063,
      stop : 25726562,
      direction : "-",
      ID : "ENSG00000164508.5",
      gene_id : "ENSG00000164508.5",
      gene_type : "protein_coding",
      gene_name : "H2AC1",
      gene_level : 2,
      hgnc_id : "HGNC:18729",
      havana_gene : "OTTHUMG00000014407.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25726777,
      stop : 25727345,
      direction : "+",
      ID : "ENSG00000146047.7",
      gene_id : "ENSG00000146047.7",
      gene_type : "protein_coding",
      gene_name : "H2BC1",
      gene_level : 2,
      hgnc_id : "HGNC:18730",
      havana_gene : "OTTHUMG00000014408.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25754699,
      stop : 25781199,
      direction : "+",
      ID : "ENSG00000146039.11",
      gene_id : "ENSG00000146039.11",
      gene_type : "protein_coding",
      gene_name : "SLC17A4",
      gene_level : 2,
      hgnc_id : "HGNC:10932",
      havana_gene : "OTTHUMG00000014410.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25782915,
      stop : 25832052,
      direction : "-",
      ID : "ENSG00000124568.12",
      gene_id : "ENSG00000124568.12",
      gene_type : "protein_coding",
      gene_name : "SLC17A1",
      gene_level : 2,
      hgnc_id : "HGNC:10929",
      havana_gene : "OTTHUMG00000016297.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25833066,
      stop : 25882286,
      direction : "-",
      ID : "ENSG00000124564.17",
      gene_id : "ENSG00000124564.17",
      gene_type : "protein_coding",
      gene_name : "SLC17A3",
      gene_level : 2,
      hgnc_id : "HGNC:10931",
      havana_gene : "OTTHUMG00000014412.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25912754,
      stop : 25930691,
      direction : "-",
      ID : "ENSG00000112337.11",
      gene_id : "ENSG00000112337.11",
      gene_type : "protein_coding",
      gene_name : "SLC17A2",
      gene_level : 2,
      hgnc_id : "HGNC:10930",
      havana_gene : "OTTHUMG00000014413.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 25962802,
      stop : 25991231,
      direction : "+",
      ID : "ENSG00000112343.11",
      gene_id : "ENSG00000112343.11",
      gene_type : "protein_coding",
      gene_name : "TRIM38",
      gene_level : 2,
      hgnc_id : "HGNC:10059",
      havana_gene : "OTTHUMG00000014414.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26017032,
      stop : 26017787,
      direction : "-",
      ID : "ENSG00000124610.5",
      gene_id : "ENSG00000124610.5",
      gene_type : "protein_coding",
      gene_name : "H1-1",
      gene_level : 2,
      hgnc_id : "HGNC:4715",
      havana_gene : "OTTHUMG00000016413.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26020451,
      stop : 26020958,
      direction : "+",
      ID : "ENSG00000275714.2",
      gene_id : "ENSG00000275714.2",
      gene_type : "protein_coding",
      gene_name : "H3C1",
      gene_level : 2,
      hgnc_id : "HGNC:4766",
      havana_gene : "OTTHUMG00000014418.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26021649,
      stop : 26022050,
      direction : "+",
      ID : "ENSG00000278637.2",
      gene_id : "ENSG00000278637.2",
      gene_type : "protein_coding",
      gene_name : "H4C1",
      gene_level : 2,
      hgnc_id : "HGNC:4781",
      havana_gene : "OTTHUMG00000014419.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26026815,
      stop : 26027252,
      direction : "-",
      ID : "ENSG00000278705.1",
      gene_id : "ENSG00000278705.1",
      gene_type : "protein_coding",
      gene_name : "H4C2",
      gene_level : 2,
      hgnc_id : "HGNC:4789",
      havana_gene : "OTTHUMG00000014417.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26031589,
      stop : 26032099,
      direction : "-",
      ID : "ENSG00000286522.2",
      gene_id : "ENSG00000286522.2",
      gene_type : "protein_coding",
      gene_name : "H3C2",
      gene_level : 2,
      hgnc_id : "HGNC:4776",
      havana_gene : "OTTHUMG00000014415.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26033092,
      stop : 26033618,
      direction : "-",
      ID : "ENSG00000278463.2",
      gene_id : "ENSG00000278463.2",
      gene_type : "protein_coding",
      gene_name : "H2AC4",
      gene_level : 2,
      hgnc_id : "HGNC:4734",
      havana_gene : "OTTHUMG00000014420.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26043227,
      stop : 26043713,
      direction : "-",
      ID : "ENSG00000276410.4",
      gene_id : "ENSG00000276410.4",
      gene_type : "protein_coding",
      gene_name : "H2BC3",
      gene_level : 2,
      hgnc_id : "HGNC:4751",
      havana_gene : "OTTHUMG00000014421.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26045384,
      stop : 26045869,
      direction : "+",
      ID : "ENSG00000287080.2",
      gene_id : "ENSG00000287080.2",
      gene_type : "protein_coding",
      gene_name : "H3C3",
      gene_level : 2,
      hgnc_id : "HGNC:4768",
      havana_gene : "OTTHUMG00000014416.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26055740,
      stop : 26056470,
      direction : "-",
      ID : "ENSG00000187837.4",
      gene_id : "ENSG00000187837.4",
      gene_type : "protein_coding",
      gene_name : "H1-2",
      gene_level : 2,
      hgnc_id : "HGNC:4716",
      havana_gene : "OTTHUMG00000016140.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26087281,
      stop : 26098343,
      direction : "+",
      ID : "ENSG00000010704.19",
      gene_id : "ENSG00000010704.19",
      gene_type : "protein_coding",
      gene_name : "HFE",
      gene_level : 1,
      hgnc_id : "HGNC:4886",
      havana_gene : "OTTHUMG00000016348.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26103933,
      stop : 26104337,
      direction : "+",
      ID : "ENSG00000197061.5",
      gene_id : "ENSG00000197061.5",
      gene_type : "protein_coding",
      gene_name : "H4C3",
      gene_level : 2,
      hgnc_id : "HGNC:4787",
      havana_gene : "OTTHUMG00000014429.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26107412,
      stop : 26108135,
      direction : "-",
      ID : "ENSG00000187475.6",
      gene_id : "ENSG00000187475.6",
      gene_type : "protein_coding",
      gene_name : "H1-6",
      gene_level : 2,
      hgnc_id : "HGNC:4720",
      havana_gene : "OTTHUMG00000014430.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26114873,
      stop : 26123926,
      direction : "-",
      ID : "ENSG00000180596.7",
      gene_id : "ENSG00000180596.7",
      gene_type : "protein_coding",
      gene_name : "H2BC4",
      gene_level : 2,
      hgnc_id : "HGNC:4757",
      havana_gene : "OTTHUMG00000014425.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26124145,
      stop : 26139116,
      direction : "+",
      ID : "ENSG00000180573.10",
      gene_id : "ENSG00000180573.10",
      gene_type : "protein_coding",
      gene_name : "H2AC6",
      gene_level : 2,
      hgnc_id : "HGNC:4733",
      havana_gene : "OTTHUMG00000014428.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26156329,
      stop : 26157115,
      direction : "+",
      ID : "ENSG00000168298.7",
      gene_id : "ENSG00000168298.7",
      gene_type : "protein_coding",
      gene_name : "H1-4",
      gene_level : 2,
      hgnc_id : "HGNC:4718",
      havana_gene : "OTTHUMG00000014422.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26158146,
      stop : 26171349,
      direction : "+",
      ID : "ENSG00000158373.8",
      gene_id : "ENSG00000158373.8",
      gene_type : "protein_coding",
      gene_name : "H2BC5",
      gene_level : 2,
      hgnc_id : "HGNC:4747",
      havana_gene : "OTTHUMG00000014426.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26172059,
      stop : 26184655,
      direction : "+",
      ID : "ENSG00000274290.3",
      gene_id : "ENSG00000274290.3",
      gene_type : "protein_coding",
      gene_name : "H2BC6",
      gene_level : 2,
      hgnc_id : "HGNC:4753",
      havana_gene : "OTTHUMG00000014427.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26188710,
      stop : 26189112,
      direction : "-",
      ID : "ENSG00000277157.2",
      gene_id : "ENSG00000277157.2",
      gene_type : "protein_coding",
      gene_name : "H4C4",
      gene_level : 2,
      hgnc_id : "HGNC:4782",
      havana_gene : "OTTHUMG00000014423.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26195595,
      stop : 26199293,
      direction : "-",
      ID : "ENSG00000282988.2",
      gene_id : "ENSG00000282988.2",
      gene_type : "protein_coding",
      gene_name : "AL031777.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191594.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26196784,
      stop : 26197286,
      direction : "-",
      ID : "ENSG00000197409.8",
      gene_id : "ENSG00000197409.8",
      gene_type : "protein_coding",
      gene_name : "H3C4",
      gene_level : 2,
      hgnc_id : "HGNC:4767",
      havana_gene : "OTTHUMG00000014433.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26198784,
      stop : 26199293,
      direction : "-",
      ID : "ENSG00000196866.3",
      gene_id : "ENSG00000196866.3",
      gene_type : "protein_coding",
      gene_name : "H2AC7",
      gene_level : 2,
      hgnc_id : "HGNC:4729",
      havana_gene : "OTTHUMG00000014437.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26199520,
      stop : 26200715,
      direction : "+",
      ID : "ENSG00000277224.2",
      gene_id : "ENSG00000277224.2",
      gene_type : "protein_coding",
      gene_name : "H2BC7",
      gene_level : 2,
      hgnc_id : "HGNC:4752",
      havana_gene : "OTTHUMG00000014445.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26204552,
      stop : 26206038,
      direction : "+",
      ID : "ENSG00000276966.2",
      gene_id : "ENSG00000276966.2",
      gene_type : "protein_coding",
      gene_name : "H4C5",
      gene_level : 2,
      hgnc_id : "HGNC:4790",
      havana_gene : "OTTHUMG00000014441.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26215159,
      stop : 26216692,
      direction : "-",
      ID : "ENSG00000273802.2",
      gene_id : "ENSG00000273802.2",
      gene_type : "protein_coding",
      gene_name : "H2BC8",
      gene_level : 2,
      hgnc_id : "HGNC:4746",
      havana_gene : "OTTHUMG00000014446.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26216975,
      stop : 26217483,
      direction : "+",
      ID : "ENSG00000277075.2",
      gene_id : "ENSG00000277075.2",
      gene_type : "protein_coding",
      gene_name : "H2AC8",
      gene_level : 2,
      hgnc_id : "HGNC:4724",
      havana_gene : "OTTHUMG00000014440.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26224199,
      stop : 26227473,
      direction : "+",
      ID : "ENSG00000274750.2",
      gene_id : "ENSG00000274750.2",
      gene_type : "protein_coding",
      gene_name : "H3C6",
      gene_level : 2,
      hgnc_id : "HGNC:4769",
      havana_gene : "OTTHUMG00000014434.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26234212,
      stop : 26234987,
      direction : "-",
      ID : "ENSG00000124575.7",
      gene_id : "ENSG00000124575.7",
      gene_type : "protein_coding",
      gene_name : "H1-3",
      gene_level : 2,
      hgnc_id : "HGNC:4717",
      havana_gene : "OTTHUMG00000014432.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26240393,
      stop : 26240793,
      direction : "+",
      ID : "ENSG00000274618.2",
      gene_id : "ENSG00000274618.2",
      gene_type : "protein_coding",
      gene_name : "H4C6",
      gene_level : 2,
      hgnc_id : "HGNC:4783",
      havana_gene : "OTTHUMG00000014443.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26246611,
      stop : 26246996,
      direction : "-",
      ID : "ENSG00000275663.2",
      gene_id : "ENSG00000275663.2",
      gene_type : "protein_coding",
      gene_name : "H4C7",
      gene_level : 2,
      hgnc_id : "HGNC:4792",
      havana_gene : "OTTHUMG00000014444.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26250142,
      stop : 26250635,
      direction : "-",
      ID : "ENSG00000277775.2",
      gene_id : "ENSG00000277775.2",
      gene_type : "protein_coding",
      gene_name : "H3C7",
      gene_level : 2,
      hgnc_id : "HGNC:4773",
      havana_gene : "OTTHUMG00000014435.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26251651,
      stop : 26253710,
      direction : "+",
      ID : "ENSG00000275713.2",
      gene_id : "ENSG00000275713.2",
      gene_type : "protein_coding",
      gene_name : "H2BC9",
      gene_level : 2,
      hgnc_id : "HGNC:4755",
      havana_gene : "OTTHUMG00000014447.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26269405,
      stop : 26271815,
      direction : "-",
      ID : "ENSG00000273983.1",
      gene_id : "ENSG00000273983.1",
      gene_type : "protein_coding",
      gene_name : "H3C8",
      gene_level : 2,
      hgnc_id : "HGNC:4772",
      havana_gene : "OTTHUMG00000014436.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26272931,
      stop : 26273412,
      direction : "+",
      ID : "ENSG00000278588.2",
      gene_id : "ENSG00000278588.2",
      gene_type : "protein_coding",
      gene_name : "H2BC10",
      gene_level : 2,
      hgnc_id : "HGNC:4756",
      havana_gene : "OTTHUMG00000014448.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26277609,
      stop : 26285638,
      direction : "-",
      ID : "ENSG00000158406.5",
      gene_id : "ENSG00000158406.5",
      gene_type : "protein_coding",
      gene_name : "H4C8",
      gene_level : 2,
      hgnc_id : "HGNC:4788",
      havana_gene : "OTTHUMG00000014454.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26365159,
      stop : 26378320,
      direction : "+",
      ID : "ENSG00000186470.14",
      gene_id : "ENSG00000186470.14",
      gene_type : "protein_coding",
      gene_name : "BTN3A2",
      gene_level : 2,
      hgnc_id : "HGNC:1139",
      havana_gene : "OTTHUMG00000014450.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26383096,
      stop : 26394874,
      direction : "+",
      ID : "ENSG00000124508.17",
      gene_id : "ENSG00000124508.17",
      gene_type : "protein_coding",
      gene_name : "BTN2A2",
      gene_level : 1,
      hgnc_id : "HGNC:1137",
      havana_gene : "OTTHUMG00000014452.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26402237,
      stop : 26415208,
      direction : "+",
      ID : "ENSG00000026950.17",
      gene_id : "ENSG00000026950.17",
      gene_type : "protein_coding",
      gene_name : "BTN3A1",
      gene_level : 2,
      hgnc_id : "HGNC:1138",
      havana_gene : "OTTHUMG00000014449.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26440472,
      stop : 26453415,
      direction : "+",
      ID : "ENSG00000111801.16",
      gene_id : "ENSG00000111801.16",
      gene_type : "protein_coding",
      gene_name : "BTN3A3",
      gene_level : 2,
      hgnc_id : "HGNC:1140",
      havana_gene : "OTTHUMG00000014451.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26457904,
      stop : 26476621,
      direction : "+",
      ID : "ENSG00000112763.17",
      gene_id : "ENSG00000112763.17",
      gene_type : "protein_coding",
      gene_name : "BTN2A1",
      gene_level : 1,
      hgnc_id : "HGNC:1136",
      havana_gene : "OTTHUMG00000014457.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26501221,
      stop : 26510422,
      direction : "+",
      ID : "ENSG00000124557.13",
      gene_id : "ENSG00000124557.13",
      gene_type : "protein_coding",
      gene_name : "BTN1A1",
      gene_level : 2,
      hgnc_id : "HGNC:1135",
      havana_gene : "OTTHUMG00000016358.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26538366,
      stop : 26546933,
      direction : "+",
      ID : "ENSG00000182952.5",
      gene_id : "ENSG00000182952.5",
      gene_type : "protein_coding",
      gene_name : "HMGN4",
      gene_level : 2,
      hgnc_id : "HGNC:4989",
      havana_gene : "OTTHUMG00000014458.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26596953,
      stop : 26600739,
      direction : "+",
      ID : "ENSG00000146109.5",
      gene_id : "ENSG00000146109.5",
      gene_type : "protein_coding",
      gene_name : "ABT1",
      gene_level : 2,
      hgnc_id : "HGNC:17369",
      havana_gene : "OTTHUMG00000016319.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 26634383,
      stop : 26659752,
      direction : "-",
      ID : "ENSG00000181315.11",
      gene_id : "ENSG00000181315.11",
      gene_type : "protein_coding",
      gene_name : "ZNF322",
      gene_level : 2,
      hgnc_id : "HGNC:23640",
      havana_gene : "OTTHUMG00000014460.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27125897,
      stop : 27132795,
      direction : "-",
      ID : "ENSG00000124635.9",
      gene_id : "ENSG00000124635.9",
      gene_type : "protein_coding",
      gene_name : "H2BC11",
      gene_level : 2,
      hgnc_id : "HGNC:4761",
      havana_gene : "OTTHUMG00000014470.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27133042,
      stop : 27135291,
      direction : "+",
      ID : "ENSG00000196787.3",
      gene_id : "ENSG00000196787.3",
      gene_type : "protein_coding",
      gene_name : "H2AC11",
      gene_level : 2,
      hgnc_id : "HGNC:4737",
      havana_gene : "OTTHUMG00000014469.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27138588,
      stop : 27139881,
      direction : "+",
      ID : "ENSG00000276180.1",
      gene_id : "ENSG00000276180.1",
      gene_type : "protein_coding",
      gene_name : "H4C9",
      gene_level : 2,
      hgnc_id : "HGNC:4793",
      havana_gene : "OTTHUMG00000014471.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27146361,
      stop : 27146855,
      direction : "-",
      ID : "ENSG00000197903.8",
      gene_id : "ENSG00000197903.8",
      gene_type : "protein_coding",
      gene_name : "H2BC12",
      gene_level : 2,
      hgnc_id : "HGNC:13954",
      havana_gene : "OTTHUMG00000014473.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27147106,
      stop : 27147562,
      direction : "+",
      ID : "ENSG00000274997.2",
      gene_id : "ENSG00000274997.2",
      gene_type : "protein_coding",
      gene_name : "H2AC12",
      gene_level : 2,
      hgnc_id : "HGNC:13671",
      havana_gene : "OTTHUMG00000014468.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27247701,
      stop : 27256624,
      direction : "+",
      ID : "ENSG00000112812.16",
      gene_id : "ENSG00000112812.16",
      gene_type : "protein_coding",
      gene_name : "PRSS16",
      gene_level : 1,
      hgnc_id : "HGNC:9480",
      havana_gene : "OTTHUMG00000016167.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27285903,
      stop : 27312170,
      direction : "-",
      ID : "ENSG00000158553.4",
      gene_id : "ENSG00000158553.4",
      gene_type : "protein_coding",
      gene_name : "POM121L2",
      gene_level : 1,
      hgnc_id : "HGNC:13973",
      havana_gene : "OTTHUMG00000014475.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27374615,
      stop : 27403908,
      direction : "+",
      ID : "ENSG00000124613.9",
      gene_id : "ENSG00000124613.9",
      gene_type : "protein_coding",
      gene_name : "ZNF391",
      gene_level : 2,
      hgnc_id : "HGNC:18779",
      havana_gene : "OTTHUMG00000014477.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27450743,
      stop : 27473118,
      direction : "-",
      ID : "ENSG00000096654.15",
      gene_id : "ENSG00000096654.15",
      gene_type : "protein_coding",
      gene_name : "ZNF184",
      gene_level : 2,
      hgnc_id : "HGNC:12975",
      havana_gene : "OTTHUMG00000014478.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27807444,
      stop : 27807931,
      direction : "-",
      ID : "ENSG00000185130.5",
      gene_id : "ENSG00000185130.5",
      gene_type : "protein_coding",
      gene_name : "H2BC13",
      gene_level : 2,
      hgnc_id : "HGNC:4748",
      havana_gene : "OTTHUMG00000014485.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27808199,
      stop : 27808701,
      direction : "+",
      ID : "ENSG00000196747.4",
      gene_id : "ENSG00000196747.4",
      gene_type : "protein_coding",
      gene_name : "H2AC13",
      gene_level : 2,
      hgnc_id : "HGNC:4725",
      havana_gene : "OTTHUMG00000014484.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27810064,
      stop : 27811300,
      direction : "+",
      ID : "ENSG00000278828.1",
      gene_id : "ENSG00000278828.1",
      gene_type : "protein_coding",
      gene_name : "H3C10",
      gene_level : 2,
      hgnc_id : "HGNC:4775",
      havana_gene : "OTTHUMG00000014483.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27814302,
      stop : 27814777,
      direction : "-",
      ID : "ENSG00000276368.2",
      gene_id : "ENSG00000276368.2",
      gene_type : "protein_coding",
      gene_name : "H2AC14",
      gene_level : 2,
      hgnc_id : "HGNC:4727",
      havana_gene : "OTTHUMG00000014486.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27815022,
      stop : 27815489,
      direction : "+",
      ID : "ENSG00000273703.2",
      gene_id : "ENSG00000273703.2",
      gene_type : "protein_coding",
      gene_name : "H2BC14",
      gene_level : 2,
      hgnc_id : "HGNC:4750",
      havana_gene : "OTTHUMG00000014489.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27824092,
      stop : 27824480,
      direction : "+",
      ID : "ENSG00000197238.5",
      gene_id : "ENSG00000197238.5",
      gene_type : "protein_coding",
      gene_name : "H4C11",
      gene_level : 2,
      hgnc_id : "HGNC:4785",
      havana_gene : "OTTHUMG00000014487.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27831174,
      stop : 27831560,
      direction : "-",
      ID : "ENSG00000273542.2",
      gene_id : "ENSG00000273542.2",
      gene_type : "protein_coding",
      gene_name : "H4C12",
      gene_level : 2,
      hgnc_id : "HGNC:4784",
      havana_gene : "OTTHUMG00000014488.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27837760,
      stop : 27855709,
      direction : "+",
      ID : "ENSG00000233822.5",
      gene_id : "ENSG00000233822.5",
      gene_type : "protein_coding",
      gene_name : "H2BC15",
      gene_level : 2,
      hgnc_id : "HGNC:4749",
      havana_gene : "OTTHUMG00000016397.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27837880,
      stop : 27838375,
      direction : "-",
      ID : "ENSG00000275221.2",
      gene_id : "ENSG00000275221.2",
      gene_type : "protein_coding",
      gene_name : "H2AC15",
      gene_level : 2,
      hgnc_id : "HGNC:4726",
      havana_gene : "OTTHUMG00000016382.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27865317,
      stop : 27865798,
      direction : "+",
      ID : "ENSG00000276903.2",
      gene_id : "ENSG00000276903.2",
      gene_type : "protein_coding",
      gene_name : "H2AC16",
      gene_level : 2,
      hgnc_id : "HGNC:4730",
      havana_gene : "OTTHUMG00000014492.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27866792,
      stop : 27867588,
      direction : "-",
      ID : "ENSG00000184357.5",
      gene_id : "ENSG00000184357.5",
      gene_type : "protein_coding",
      gene_name : "H1-5",
      gene_level : 2,
      hgnc_id : "HGNC:4719",
      havana_gene : "OTTHUMG00000016139.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27871845,
      stop : 27872346,
      direction : "-",
      ID : "ENSG00000275379.2",
      gene_id : "ENSG00000275379.2",
      gene_type : "protein_coding",
      gene_name : "H3C11",
      gene_level : 2,
      hgnc_id : "HGNC:4771",
      havana_gene : "OTTHUMG00000016184.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27873148,
      stop : 27873534,
      direction : "-",
      ID : "ENSG00000275126.2",
      gene_id : "ENSG00000275126.2",
      gene_type : "protein_coding",
      gene_name : "H4C13",
      gene_level : 2,
      hgnc_id : "HGNC:4791",
      havana_gene : "OTTHUMG00000016211.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27890315,
      stop : 27893106,
      direction : "-",
      ID : "ENSG00000197153.5",
      gene_id : "ENSG00000197153.5",
      gene_type : "protein_coding",
      gene_name : "H3C12",
      gene_level : 1,
      hgnc_id : "HGNC:4774",
      havana_gene : "OTTHUMG00000016185.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27892699,
      stop : 27893185,
      direction : "-",
      ID : "ENSG00000278677.2",
      gene_id : "ENSG00000278677.2",
      gene_type : "protein_coding",
      gene_name : "H2AC17",
      gene_level : 2,
      hgnc_id : "HGNC:4735",
      havana_gene : "OTTHUMG00000014494.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27893425,
      stop : 27893891,
      direction : "+",
      ID : "ENSG00000274641.2",
      gene_id : "ENSG00000274641.2",
      gene_type : "protein_coding",
      gene_name : "H2BC17",
      gene_level : 2,
      hgnc_id : "HGNC:4758",
      havana_gene : "OTTHUMG00000014493.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27911185,
      stop : 27912396,
      direction : "-",
      ID : "ENSG00000168131.4",
      gene_id : "ENSG00000168131.4",
      gene_type : "protein_coding",
      gene_name : "OR2B2",
      gene_level : 2,
      hgnc_id : "HGNC:13966",
      havana_gene : "OTTHUMG00000014495.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 27957241,
      stop : 27958182,
      direction : "+",
      ID : "ENSG00000124657.1",
      gene_id : "ENSG00000124657.1",
      gene_type : "protein_coding",
      gene_name : "OR2B6",
      gene_level : 2,
      hgnc_id : "HGNC:8241",
      havana_gene : "OTTHUMG00000014497.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28080568,
      stop : 28089563,
      direction : "+",
      ID : "ENSG00000197279.4",
      gene_id : "ENSG00000197279.4",
      gene_type : "protein_coding",
      gene_name : "ZNF165",
      gene_level : 2,
      hgnc_id : "HGNC:12953",
      havana_gene : "OTTHUMG00000014505.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28124609,
      stop : 28130082,
      direction : "+",
      ID : "ENSG00000196812.5",
      gene_id : "ENSG00000196812.5",
      gene_type : "protein_coding",
      gene_name : "ZSCAN16",
      gene_level : 2,
      hgnc_id : "HGNC:20813",
      havana_gene : "OTTHUMG00000014509.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28141883,
      stop : 28159460,
      direction : "+",
      ID : "ENSG00000198315.11",
      gene_id : "ENSG00000198315.11",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN8",
      gene_level : 2,
      hgnc_id : "HGNC:12983",
      havana_gene : "OTTHUMG00000014510.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28224886,
      stop : 28233487,
      direction : "+",
      ID : "ENSG00000137185.13",
      gene_id : "ENSG00000137185.13",
      gene_type : "protein_coding",
      gene_name : "ZSCAN9",
      gene_level : 1,
      hgnc_id : "HGNC:12984",
      havana_gene : "OTTHUMG00000014515.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28241697,
      stop : 28252269,
      direction : "-",
      ID : "ENSG00000187626.9",
      gene_id : "ENSG00000187626.9",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN4",
      gene_level : 2,
      hgnc_id : "HGNC:13854",
      havana_gene : "OTTHUMG00000014511.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28259297,
      stop : 28260958,
      direction : "+",
      ID : "ENSG00000189134.4",
      gene_id : "ENSG00000189134.4",
      gene_type : "protein_coding",
      gene_name : "NKAPL",
      gene_level : 2,
      hgnc_id : "HGNC:21584",
      havana_gene : "OTTHUMG00000014517.2",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28267058,
      stop : 28278224,
      direction : "+",
      ID : "ENSG00000197062.12",
      gene_id : "ENSG00000197062.12",
      gene_type : "protein_coding",
      gene_name : "ZSCAN26",
      gene_level : 2,
      hgnc_id : "HGNC:12978",
      havana_gene : "OTTHUMG00000014519.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28267121,
      stop : 28281580,
      direction : "+",
      ID : "ENSG00000276302.1",
      gene_id : "ENSG00000276302.1",
      gene_type : "protein_coding",
      gene_name : "AL021997.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000188236.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28281572,
      stop : 28302549,
      direction : "+",
      ID : "ENSG00000137338.5",
      gene_id : "ENSG00000137338.5",
      gene_type : "protein_coding",
      gene_name : "PGBD1",
      gene_level : 2,
      hgnc_id : "HGNC:19398",
      havana_gene : "OTTHUMG00000014520.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28324693,
      stop : 28356271,
      direction : "-",
      ID : "ENSG00000235109.7",
      gene_id : "ENSG00000235109.7",
      gene_type : "protein_coding",
      gene_name : "ZSCAN31",
      gene_level : 1,
      hgnc_id : "HGNC:14097",
      havana_gene : "OTTHUMG00000014518.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28349947,
      stop : 28369172,
      direction : "+",
      ID : "ENSG00000189298.14",
      gene_id : "ENSG00000189298.14",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN3",
      gene_level : 2,
      hgnc_id : "HGNC:13853",
      havana_gene : "OTTHUMG00000014521.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28378955,
      stop : 28399734,
      direction : "-",
      ID : "ENSG00000158691.14",
      gene_id : "ENSG00000158691.14",
      gene_type : "protein_coding",
      gene_name : "ZSCAN12",
      gene_level : 2,
      hgnc_id : "HGNC:13172",
      havana_gene : "OTTHUMG00000014522.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28431930,
      stop : 28443502,
      direction : "-",
      ID : "ENSG00000187987.9",
      gene_id : "ENSG00000187987.9",
      gene_type : "protein_coding",
      gene_name : "ZSCAN23",
      gene_level : 2,
      hgnc_id : "HGNC:21193",
      havana_gene : "OTTHUMG00000016346.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28503296,
      stop : 28528215,
      direction : "-",
      ID : "ENSG00000198704.9",
      gene_id : "ENSG00000198704.9",
      gene_type : "protein_coding",
      gene_name : "GPX6",
      gene_level : 1,
      hgnc_id : "HGNC:4558",
      havana_gene : "OTTHUMG00000044828.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28525881,
      stop : 28534955,
      direction : "+",
      ID : "ENSG00000224586.7",
      gene_id : "ENSG00000224586.7",
      gene_type : "protein_coding",
      gene_name : "GPX5",
      gene_level : 2,
      hgnc_id : "HGNC:4557",
      havana_gene : "OTTHUMG00000016307.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28570535,
      stop : 28616212,
      direction : "-",
      ID : "ENSG00000232040.4",
      gene_id : "ENSG00000232040.4",
      gene_type : "protein_coding",
      gene_name : "ZBED9",
      gene_level : 1,
      hgnc_id : "HGNC:13851",
      havana_gene : "OTTHUMG00000016237.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28903002,
      stop : 28923988,
      direction : "-",
      ID : "ENSG00000204713.11",
      gene_id : "ENSG00000204713.11",
      gene_type : "protein_coding",
      gene_name : "TRIM27",
      gene_level : 2,
      hgnc_id : "HGNC:9975",
      havana_gene : "OTTHUMG00000031215.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 28994785,
      stop : 29005316,
      direction : "-",
      ID : "ENSG00000197935.7",
      gene_id : "ENSG00000197935.7",
      gene_type : "protein_coding",
      gene_name : "ZNF311",
      gene_level : 2,
      hgnc_id : "HGNC:13847",
      havana_gene : "OTTHUMG00000031292.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29044213,
      stop : 29045240,
      direction : "-",
      ID : "ENSG00000204704.2",
      gene_id : "ENSG00000204704.2",
      gene_type : "protein_coding",
      gene_name : "OR2W1",
      gene_level : 2,
      hgnc_id : "HGNC:8281",
      havana_gene : "OTTHUMG00000031048.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29086208,
      stop : 29087313,
      direction : "-",
      ID : "ENSG00000204703.5",
      gene_id : "ENSG00000204703.5",
      gene_type : "protein_coding",
      gene_name : "OR2B3",
      gene_level : 2,
      hgnc_id : "HGNC:8238",
      havana_gene : "OTTHUMG00000031226.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29099657,
      stop : 29102701,
      direction : "+",
      ID : "ENSG00000204702.5",
      gene_id : "ENSG00000204702.5",
      gene_type : "protein_coding",
      gene_name : "OR2J1",
      gene_level : 2,
      hgnc_id : "HGNC:8259",
      havana_gene : "OTTHUMG00000031280.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29108058,
      stop : 29114770,
      direction : "+",
      ID : "ENSG00000204701.3",
      gene_id : "ENSG00000204701.3",
      gene_type : "protein_coding",
      gene_name : "OR2J3",
      gene_level : 2,
      hgnc_id : "HGNC:8261",
      havana_gene : "OTTHUMG00000031092.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29170907,
      stop : 29175811,
      direction : "+",
      ID : "ENSG00000204700.5",
      gene_id : "ENSG00000204700.5",
      gene_type : "protein_coding",
      gene_name : "OR2J2",
      gene_level : 2,
      hgnc_id : "HGNC:8260",
      havana_gene : "OTTHUMG00000031091.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29301701,
      stop : 29313017,
      direction : "+",
      ID : "ENSG00000204695.4",
      gene_id : "ENSG00000204695.4",
      gene_type : "protein_coding",
      gene_name : "OR14J1",
      gene_level : 2,
      hgnc_id : "HGNC:13971",
      havana_gene : "OTTHUMG00000031184.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29353749,
      stop : 29431967,
      direction : "-",
      ID : "ENSG00000243729.4",
      gene_id : "ENSG00000243729.4",
      gene_type : "protein_coding",
      gene_name : "OR5V1",
      gene_level : 2,
      hgnc_id : "HGNC:13972",
      havana_gene : "OTTHUMG00000031199.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29373423,
      stop : 29375291,
      direction : "-",
      ID : "ENSG00000112462.8",
      gene_id : "ENSG00000112462.8",
      gene_type : "protein_coding",
      gene_name : "OR12D3",
      gene_level : 2,
      hgnc_id : "HGNC:13963",
      havana_gene : "OTTHUMG00000031051.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29395631,
      stop : 29398008,
      direction : "+",
      ID : "ENSG00000280236.3",
      gene_id : "ENSG00000280236.3",
      gene_type : "protein_coding",
      gene_name : "OR12D2",
      gene_level : 2,
      hgnc_id : "HGNC:8178",
      havana_gene : "OTTHUMG00000031049.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29425504,
      stop : 29457071,
      direction : "-",
      ID : "ENSG00000204694.12",
      gene_id : "ENSG00000204694.12",
      gene_type : "protein_coding",
      gene_name : "OR11A1",
      gene_level : 2,
      hgnc_id : "HGNC:8176",
      havana_gene : "OTTHUMG00000031225.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29439306,
      stop : 29440977,
      direction : "+",
      ID : "ENSG00000206474.8",
      gene_id : "ENSG00000206474.8",
      gene_type : "protein_coding",
      gene_name : "OR10C1",
      gene_level : 2,
      hgnc_id : "HGNC:8165",
      havana_gene : "OTTHUMG00000031207.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29457181,
      stop : 29464328,
      direction : "+",
      ID : "ENSG00000204688.9",
      gene_id : "ENSG00000204688.9",
      gene_type : "protein_coding",
      gene_name : "OR2H1",
      gene_level : 2,
      hgnc_id : "HGNC:8252",
      havana_gene : "OTTHUMG00000031050.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29486697,
      stop : 29487956,
      direction : "-",
      ID : "ENSG00000204687.4",
      gene_id : "ENSG00000204687.4",
      gene_type : "protein_coding",
      gene_name : "MAS1L",
      gene_level : 2,
      hgnc_id : "HGNC:13961",
      havana_gene : "OTTHUMG00000031089.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29550407,
      stop : 29557721,
      direction : "+",
      ID : "ENSG00000237988.5",
      gene_id : "ENSG00000237988.5",
      gene_type : "protein_coding",
      gene_name : "OR2I1P",
      gene_level : 2,
      hgnc_id : "HGNC:8258",
      havana_gene : "OTTHUMG00000031230.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29555515,
      stop : 29559732,
      direction : "-",
      ID : "ENSG00000213886.4",
      gene_id : "ENSG00000213886.4",
      gene_type : "protein_coding",
      gene_name : "UBD",
      gene_level : 2,
      hgnc_id : "HGNC:18795",
      havana_gene : "OTTHUMG00000031289.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29555629,
      stop : 29633976,
      direction : "-",
      ID : "ENSG00000204681.11",
      gene_id : "ENSG00000204681.11",
      gene_type : "protein_coding",
      gene_name : "GABBR1",
      gene_level : 2,
      hgnc_id : "HGNC:4070",
      havana_gene : "OTTHUMG00000031095.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29585121,
      stop : 29590500,
      direction : "+",
      ID : "ENSG00000204657.4",
      gene_id : "ENSG00000204657.4",
      gene_type : "protein_coding",
      gene_name : "OR2H2",
      gene_level : 2,
      hgnc_id : "HGNC:8253",
      havana_gene : "OTTHUMG00000031052.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29657002,
      stop : 29672372,
      direction : "+",
      ID : "ENSG00000204655.12",
      gene_id : "ENSG00000204655.12",
      gene_type : "protein_coding",
      gene_name : "MOG",
      gene_level : 2,
      hgnc_id : "HGNC:7197",
      havana_gene : "OTTHUMG00000031099.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29672483,
      stop : 29681155,
      direction : "-",
      ID : "ENSG00000204644.10",
      gene_id : "ENSG00000204644.10",
      gene_type : "protein_coding",
      gene_name : "ZFP57",
      gene_level : 2,
      hgnc_id : "HGNC:18791",
      havana_gene : "OTTHUMG00000031158.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29722775,
      stop : 29738528,
      direction : "+",
      ID : "ENSG00000204642.14",
      gene_id : "ENSG00000204642.14",
      gene_type : "protein_coding",
      gene_name : "HLA-F",
      gene_level : 2,
      hgnc_id : "HGNC:4963",
      havana_gene : "OTTHUMG00000031156.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29826967,
      stop : 29831125,
      direction : "+",
      ID : "ENSG00000204632.12",
      gene_id : "ENSG00000204632.12",
      gene_type : "protein_coding",
      gene_name : "HLA-G",
      gene_level : 2,
      hgnc_id : "HGNC:4964",
      havana_gene : "OTTHUMG00000031157.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 29941260,
      stop : 29945884,
      direction : "+",
      ID : "ENSG00000206503.13",
      gene_id : "ENSG00000206503.13",
      gene_type : "protein_coding",
      gene_name : "HLA-A",
      gene_level : 2,
      hgnc_id : "HGNC:4931",
      havana_gene : "OTTHUMG00000130501.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30058899,
      stop : 30064909,
      direction : "+",
      ID : "ENSG00000066379.15",
      gene_id : "ENSG00000066379.15",
      gene_type : "protein_coding",
      gene_name : "POLR1H",
      gene_level : 2,
      hgnc_id : "HGNC:13182",
      havana_gene : "OTTHUMG00000031149.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30066709,
      stop : 30070333,
      direction : "+",
      ID : "ENSG00000204619.8",
      gene_id : "ENSG00000204619.8",
      gene_type : "protein_coding",
      gene_name : "PPP1R11",
      gene_level : 2,
      hgnc_id : "HGNC:9285",
      havana_gene : "OTTHUMG00000031260.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30070266,
      stop : 30075887,
      direction : "-",
      ID : "ENSG00000204618.9",
      gene_id : "ENSG00000204618.9",
      gene_type : "protein_coding",
      gene_name : "RNF39",
      gene_level : 2,
      hgnc_id : "HGNC:18064",
      havana_gene : "OTTHUMG00000031288.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30102897,
      stop : 30113090,
      direction : "-",
      ID : "ENSG00000204616.11",
      gene_id : "ENSG00000204616.11",
      gene_type : "protein_coding",
      gene_name : "TRIM31",
      gene_level : 2,
      hgnc_id : "HGNC:16289",
      havana_gene : "OTTHUMG00000031064.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30136124,
      stop : 30148735,
      direction : "+",
      ID : "ENSG00000204614.9",
      gene_id : "ENSG00000204614.9",
      gene_type : "protein_coding",
      gene_name : "TRIM40",
      gene_level : 2,
      hgnc_id : "HGNC:18736",
      havana_gene : "OTTHUMG00000031083.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30151943,
      stop : 30161211,
      direction : "-",
      ID : "ENSG00000204613.11",
      gene_id : "ENSG00000204613.11",
      gene_type : "protein_coding",
      gene_name : "TRIM10",
      gene_level : 2,
      hgnc_id : "HGNC:10072",
      havana_gene : "OTTHUMG00000031295.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30163206,
      stop : 30172693,
      direction : "+",
      ID : "ENSG00000204610.14",
      gene_id : "ENSG00000204610.14",
      gene_type : "protein_coding",
      gene_name : "TRIM15",
      gene_level : 2,
      hgnc_id : "HGNC:16284",
      havana_gene : "OTTHUMG00000031031.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30184455,
      stop : 30213427,
      direction : "-",
      ID : "ENSG00000234127.9",
      gene_id : "ENSG00000234127.9",
      gene_type : "protein_coding",
      gene_name : "TRIM26",
      gene_level : 2,
      hgnc_id : "HGNC:12962",
      havana_gene : "OTTHUMG00000031041.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30326479,
      stop : 30343729,
      direction : "+",
      ID : "ENSG00000204599.14",
      gene_id : "ENSG00000204599.14",
      gene_type : "protein_coding",
      gene_name : "TRIM39",
      gene_level : 2,
      hgnc_id : "HGNC:10065",
      havana_gene : "OTTHUMG00000031066.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30328907,
      stop : 30346854,
      direction : "+",
      ID : "ENSG00000248167.7",
      gene_id : "ENSG00000248167.7",
      gene_type : "protein_coding",
      gene_name : "TRIM39-RPP21",
      gene_level : 2,
      hgnc_id : "HGNC:38845",
      havana_gene : "OTTHUMG00000161144.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30345131,
      stop : 30346884,
      direction : "+",
      ID : "ENSG00000241370.6",
      gene_id : "ENSG00000241370.6",
      gene_type : "protein_coding",
      gene_name : "RPP21",
      gene_level : 2,
      hgnc_id : "HGNC:21300",
      havana_gene : "OTTHUMG00000031220.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30489509,
      stop : 30494194,
      direction : "+",
      ID : "ENSG00000204592.9",
      gene_id : "ENSG00000204592.9",
      gene_type : "protein_coding",
      gene_name : "HLA-E",
      gene_level : 2,
      hgnc_id : "HGNC:4962",
      havana_gene : "OTTHUMG00000031155.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30541377,
      stop : 30557174,
      direction : "-",
      ID : "ENSG00000204590.12",
      gene_id : "ENSG00000204590.12",
      gene_type : "protein_coding",
      gene_name : "GNL1",
      gene_level : 2,
      hgnc_id : "HGNC:4413",
      havana_gene : "OTTHUMG00000031137.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30557280,
      stop : 30563723,
      direction : "+",
      ID : "ENSG00000204576.12",
      gene_id : "ENSG00000204576.12",
      gene_type : "protein_coding",
      gene_name : "PRR3",
      gene_level : 2,
      hgnc_id : "HGNC:21149",
      havana_gene : "OTTHUMG00000031037.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30571393,
      stop : 30597179,
      direction : "+",
      ID : "ENSG00000204574.14",
      gene_id : "ENSG00000204574.14",
      gene_type : "protein_coding",
      gene_name : "ABCF1",
      gene_level : 1,
      hgnc_id : "HGNC:70",
      havana_gene : "OTTHUMG00000031094.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30600413,
      stop : 30618612,
      direction : "-",
      ID : "ENSG00000204569.10",
      gene_id : "ENSG00000204569.10",
      gene_type : "protein_coding",
      gene_name : "PPP1R10",
      gene_level : 2,
      hgnc_id : "HGNC:9284",
      havana_gene : "OTTHUMG00000031259.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30617840,
      stop : 30626395,
      direction : "+",
      ID : "ENSG00000204568.12",
      gene_id : "ENSG00000204568.12",
      gene_type : "protein_coding",
      gene_name : "MRPS18B",
      gene_level : 2,
      hgnc_id : "HGNC:14516",
      havana_gene : "OTTHUMG00000031268.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30626842,
      stop : 30646823,
      direction : "+",
      ID : "ENSG00000137343.18",
      gene_id : "ENSG00000137343.18",
      gene_type : "protein_coding",
      gene_name : "ATAT1",
      gene_level : 2,
      hgnc_id : "HGNC:21186",
      havana_gene : "OTTHUMG00000031219.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30647039,
      stop : 30653210,
      direction : "+",
      ID : "ENSG00000204564.12",
      gene_id : "ENSG00000204564.12",
      gene_type : "protein_coding",
      gene_name : "C6orf136",
      gene_level : 1,
      hgnc_id : "HGNC:21301",
      havana_gene : "OTTHUMG00000031221.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30653119,
      stop : 30673006,
      direction : "-",
      ID : "ENSG00000204560.10",
      gene_id : "ENSG00000204560.10",
      gene_type : "protein_coding",
      gene_name : "DHX16",
      gene_level : 2,
      hgnc_id : "HGNC:2739",
      havana_gene : "OTTHUMG00000031060.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30676389,
      stop : 30687895,
      direction : "-",
      ID : "ENSG00000146112.12",
      gene_id : "ENSG00000146112.12",
      gene_type : "protein_coding",
      gene_name : "PPP1R18",
      gene_level : 2,
      hgnc_id : "HGNC:29413",
      havana_gene : "OTTHUMG00000031237.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30688047,
      stop : 30691420,
      direction : "-",
      ID : "ENSG00000137404.14",
      gene_id : "ENSG00000137404.14",
      gene_type : "protein_coding",
      gene_name : "NRM",
      gene_level : 2,
      hgnc_id : "HGNC:8003",
      havana_gene : "OTTHUMG00000031223.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30699807,
      stop : 30717447,
      direction : "-",
      ID : "ENSG00000137337.15",
      gene_id : "ENSG00000137337.15",
      gene_type : "protein_coding",
      gene_name : "MDC1",
      gene_level : 2,
      hgnc_id : "HGNC:21163",
      havana_gene : "OTTHUMG00000031075.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30717435,
      stop : 30725538,
      direction : "+",
      ID : "ENSG00000196230.14",
      gene_id : "ENSG00000196230.14",
      gene_type : "protein_coding",
      gene_name : "TUBB",
      gene_level : 2,
      hgnc_id : "HGNC:20778",
      havana_gene : "OTTHUMG00000031059.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30727709,
      stop : 30742732,
      direction : "-",
      ID : "ENSG00000137312.15",
      gene_id : "ENSG00000137312.15",
      gene_type : "protein_coding",
      gene_name : "FLOT1",
      gene_level : 2,
      hgnc_id : "HGNC:3757",
      havana_gene : "OTTHUMG00000031151.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30743199,
      stop : 30744548,
      direction : "-",
      ID : "ENSG00000137331.12",
      gene_id : "ENSG00000137331.12",
      gene_type : "protein_coding",
      gene_name : "IER3",
      gene_level : 2,
      hgnc_id : "HGNC:5392",
      havana_gene : "OTTHUMG00000031265.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30876421,
      stop : 30900156,
      direction : "+",
      ID : "ENSG00000204580.13",
      gene_id : "ENSG00000204580.13",
      gene_type : "protein_coding",
      gene_name : "DDR1",
      gene_level : 1,
      hgnc_id : "HGNC:2730",
      havana_gene : "OTTHUMG00000031236.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30908207,
      stop : 30914106,
      direction : "+",
      ID : "ENSG00000213780.11",
      gene_id : "ENSG00000213780.11",
      gene_type : "protein_coding",
      gene_name : "GTF2H4",
      gene_level : 2,
      hgnc_id : "HGNC:4658",
      havana_gene : "OTTHUMG00000031043.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30914205,
      stop : 30926459,
      direction : "+",
      ID : "ENSG00000137411.19",
      gene_id : "ENSG00000137411.19",
      gene_type : "protein_coding",
      gene_name : "VARS2",
      gene_level : 2,
      hgnc_id : "HGNC:21642",
      havana_gene : "OTTHUMG00000195898.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30931353,
      stop : 30955636,
      direction : "-",
      ID : "ENSG00000196260.5",
      gene_id : "ENSG00000196260.5",
      gene_type : "protein_coding",
      gene_name : "SFTA2",
      gene_level : 2,
      hgnc_id : "HGNC:18386",
      havana_gene : "OTTHUMG00000031183.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30934523,
      stop : 30954221,
      direction : "+",
      ID : "ENSG00000168631.13",
      gene_id : "ENSG00000168631.13",
      gene_type : "protein_coding",
      gene_name : "MUCL3",
      gene_level : 2,
      hgnc_id : "HGNC:21666",
      havana_gene : "OTTHUMG00000031104.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 30983718,
      stop : 30989903,
      direction : "+",
      ID : "ENSG00000204544.5",
      gene_id : "ENSG00000204544.5",
      gene_type : "protein_coding",
      gene_name : "MUC21",
      gene_level : 1,
      hgnc_id : "HGNC:21661",
      havana_gene : "OTTHUMG00000031216.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31010474,
      stop : 31035402,
      direction : "+",
      ID : "ENSG00000261272.1",
      gene_id : "ENSG00000261272.1",
      gene_type : "protein_coding",
      gene_name : "MUC22",
      gene_level : 1,
      hgnc_id : "HGNC:39755",
      havana_gene : "OTTHUMG00000133673.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31111223,
      stop : 31112575,
      direction : "-",
      ID : "ENSG00000204542.3",
      gene_id : "ENSG00000204542.3",
      gene_type : "protein_coding",
      gene_name : "C6orf15",
      gene_level : 2,
      hgnc_id : "HGNC:13927",
      havana_gene : "OTTHUMG00000031111.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31114750,
      stop : 31140092,
      direction : "+",
      ID : "ENSG00000204540.11",
      gene_id : "ENSG00000204540.11",
      gene_type : "protein_coding",
      gene_name : "PSORS1C1",
      gene_level : 1,
      hgnc_id : "HGNC:17202",
      havana_gene : "OTTHUMG00000031077.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31115087,
      stop : 31120446,
      direction : "-",
      ID : "ENSG00000204539.4",
      gene_id : "ENSG00000204539.4",
      gene_type : "protein_coding",
      gene_name : "CDSN",
      gene_level : 2,
      hgnc_id : "HGNC:1802",
      havana_gene : "OTTHUMG00000031150.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31137534,
      stop : 31139066,
      direction : "-",
      ID : "ENSG00000204538.4",
      gene_id : "ENSG00000204538.4",
      gene_type : "protein_coding",
      gene_name : "PSORS1C2",
      gene_level : 2,
      hgnc_id : "HGNC:17199",
      havana_gene : "OTTHUMG00000031081.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31142439,
      stop : 31158238,
      direction : "-",
      ID : "ENSG00000204536.14",
      gene_id : "ENSG00000204536.14",
      gene_type : "protein_coding",
      gene_name : "CCHCR1",
      gene_level : 2,
      hgnc_id : "HGNC:13930",
      havana_gene : "OTTHUMG00000031112.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31158547,
      stop : 31167159,
      direction : "+",
      ID : "ENSG00000137310.12",
      gene_id : "ENSG00000137310.12",
      gene_type : "protein_coding",
      gene_name : "TCF19",
      gene_level : 2,
      hgnc_id : "HGNC:11629",
      havana_gene : "OTTHUMG00000031274.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31164337,
      stop : 31180731,
      direction : "-",
      ID : "ENSG00000204531.20",
      gene_id : "ENSG00000204531.20",
      gene_type : "protein_coding",
      gene_name : "POU5F1",
      gene_level : 1,
      hgnc_id : "HGNC:9221",
      havana_gene : "OTTHUMG00000031206.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31268749,
      stop : 31272130,
      direction : "-",
      ID : "ENSG00000204525.17",
      gene_id : "ENSG00000204525.17",
      gene_type : "protein_coding",
      gene_name : "HLA-C",
      gene_level : 2,
      hgnc_id : "HGNC:4933",
      havana_gene : "OTTHUMG00000031154.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31353872,
      stop : 31357188,
      direction : "-",
      ID : "ENSG00000234745.13",
      gene_id : "ENSG00000234745.13",
      gene_type : "protein_coding",
      gene_name : "HLA-B",
      gene_level : 2,
      hgnc_id : "HGNC:4932",
      havana_gene : "OTTHUMG00000031153.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31399784,
      stop : 31415315,
      direction : "+",
      ID : "ENSG00000204520.14",
      gene_id : "ENSG00000204520.14",
      gene_type : "protein_coding",
      gene_name : "MICA",
      gene_level : 1,
      hgnc_id : "HGNC:7090",
      havana_gene : "OTTHUMG00000031073.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31494881,
      stop : 31511124,
      direction : "+",
      ID : "ENSG00000204516.10",
      gene_id : "ENSG00000204516.10",
      gene_type : "protein_coding",
      gene_name : "MICB",
      gene_level : 2,
      hgnc_id : "HGNC:7091",
      havana_gene : "OTTHUMG00000031074.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31528962,
      stop : 31530232,
      direction : "+",
      ID : "ENSG00000204511.3",
      gene_id : "ENSG00000204511.3",
      gene_type : "protein_coding",
      gene_name : "MCCD1",
      gene_level : 2,
      hgnc_id : "HGNC:20668",
      havana_gene : "OTTHUMG00000134292.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31530219,
      stop : 31542448,
      direction : "-",
      ID : "ENSG00000198563.14",
      gene_id : "ENSG00000198563.14",
      gene_type : "protein_coding",
      gene_name : "DDX39B",
      gene_level : 2,
      hgnc_id : "HGNC:13917",
      havana_gene : "OTTHUMG00000031165.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31530219,
      stop : 31546608,
      direction : "-",
      ID : "ENSG00000254870.5",
      gene_id : "ENSG00000254870.5",
      gene_type : "protein_coding",
      gene_name : "ATP6V1G2-DDX39B",
      gene_level : 2,
      hgnc_id : "HGNC:41999",
      havana_gene : "OTTHUMG00000031200.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31544444,
      stop : 31548427,
      direction : "-",
      ID : "ENSG00000213760.11",
      gene_id : "ENSG00000213760.11",
      gene_type : "protein_coding",
      gene_name : "ATP6V1G2",
      gene_level : 1,
      hgnc_id : "HGNC:862",
      havana_gene : "OTTHUMG00000166618.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31546870,
      stop : 31558829,
      direction : "+",
      ID : "ENSG00000204498.11",
      gene_id : "ENSG00000204498.11",
      gene_type : "protein_coding",
      gene_name : "NFKBIL1",
      gene_level : 2,
      hgnc_id : "HGNC:7800",
      havana_gene : "OTTHUMG00000031038.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31572054,
      stop : 31574324,
      direction : "+",
      ID : "ENSG00000226979.9",
      gene_id : "ENSG00000226979.9",
      gene_type : "protein_coding",
      gene_name : "LTA",
      gene_level : 2,
      hgnc_id : "HGNC:6709",
      havana_gene : "OTTHUMG00000031135.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31575565,
      stop : 31578336,
      direction : "+",
      ID : "ENSG00000232810.4",
      gene_id : "ENSG00000232810.4",
      gene_type : "protein_coding",
      gene_name : "TNF",
      gene_level : 2,
      hgnc_id : "HGNC:11892",
      havana_gene : "OTTHUMG00000031194.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31580525,
      stop : 31582522,
      direction : "-",
      ID : "ENSG00000227507.3",
      gene_id : "ENSG00000227507.3",
      gene_type : "protein_coding",
      gene_name : "LTB",
      gene_level : 2,
      hgnc_id : "HGNC:6711",
      havana_gene : "OTTHUMG00000031136.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31586124,
      stop : 31588909,
      direction : "+",
      ID : "ENSG00000204482.11",
      gene_id : "ENSG00000204482.11",
      gene_type : "protein_coding",
      gene_name : "LST1",
      gene_level : 1,
      hgnc_id : "HGNC:14189",
      havana_gene : "OTTHUMG00000031264.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31588895,
      stop : 31593006,
      direction : "-",
      ID : "ENSG00000204475.10",
      gene_id : "ENSG00000204475.10",
      gene_type : "protein_coding",
      gene_name : "NCR3",
      gene_level : 2,
      hgnc_id : "HGNC:19077",
      havana_gene : "OTTHUMG00000031123.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31615217,
      stop : 31617021,
      direction : "+",
      ID : "ENSG00000204472.13",
      gene_id : "ENSG00000204472.13",
      gene_type : "protein_coding",
      gene_name : "AIF1",
      gene_level : 2,
      hgnc_id : "HGNC:352",
      havana_gene : "OTTHUMG00000031246.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31620715,
      stop : 31637771,
      direction : "+",
      ID : "ENSG00000204469.13",
      gene_id : "ENSG00000204469.13",
      gene_type : "protein_coding",
      gene_name : "PRRC2A",
      gene_level : 2,
      hgnc_id : "HGNC:13918",
      havana_gene : "OTTHUMG00000031168.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31639028,
      stop : 31652705,
      direction : "-",
      ID : "ENSG00000204463.13",
      gene_id : "ENSG00000204463.13",
      gene_type : "protein_coding",
      gene_name : "BAG6",
      gene_level : 2,
      hgnc_id : "HGNC:13919",
      havana_gene : "OTTHUMG00000031171.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31652416,
      stop : 31658210,
      direction : "+",
      ID : "ENSG00000204444.11",
      gene_id : "ENSG00000204444.11",
      gene_type : "protein_coding",
      gene_name : "APOM",
      gene_level : 2,
      hgnc_id : "HGNC:13916",
      havana_gene : "OTTHUMG00000031250.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31658298,
      stop : 31660778,
      direction : "-",
      ID : "ENSG00000204439.4",
      gene_id : "ENSG00000204439.4",
      gene_type : "protein_coding",
      gene_name : "C6orf47",
      gene_level : 2,
      hgnc_id : "HGNC:19076",
      havana_gene : "OTTHUMG00000031172.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31661228,
      stop : 31666283,
      direction : "-",
      ID : "ENSG00000204438.11",
      gene_id : "ENSG00000204438.11",
      gene_type : "protein_coding",
      gene_name : "GPANK1",
      gene_level : 2,
      hgnc_id : "HGNC:13920",
      havana_gene : "OTTHUMG00000031174.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31665227,
      stop : 31670343,
      direction : "+",
      ID : "ENSG00000204435.15",
      gene_id : "ENSG00000204435.15",
      gene_type : "protein_coding",
      gene_name : "CSNK2B",
      gene_level : 1,
      hgnc_id : "HGNC:2460",
      havana_gene : "OTTHUMG00000177888.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31666102,
      stop : 31673546,
      direction : "+",
      ID : "ENSG00000263020.6",
      gene_id : "ENSG00000263020.6",
      gene_type : "protein_coding",
      gene_name : "AL662899.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000031056.16",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31670167,
      stop : 31673776,
      direction : "+",
      ID : "ENSG00000240053.8",
      gene_id : "ENSG00000240053.8",
      gene_type : "protein_coding",
      gene_name : "LY6G5B",
      gene_level : 2,
      hgnc_id : "HGNC:13931",
      havana_gene : "OTTHUMG00000031227.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31676684,
      stop : 31684040,
      direction : "-",
      ID : "ENSG00000204428.12",
      gene_id : "ENSG00000204428.12",
      gene_type : "protein_coding",
      gene_name : "LY6G5C",
      gene_level : 1,
      hgnc_id : "HGNC:13932",
      havana_gene : "OTTHUMG00000031228.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31686955,
      stop : 31703356,
      direction : "-",
      ID : "ENSG00000204427.12",
      gene_id : "ENSG00000204427.12",
      gene_type : "protein_coding",
      gene_name : "ABHD16A",
      gene_level : 1,
      hgnc_id : "HGNC:13921",
      havana_gene : "OTTHUMG00000031177.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31686962,
      stop : 31714072,
      direction : "-",
      ID : "ENSG00000204422.7",
      gene_id : "ENSG00000204422.7",
      gene_type : "protein_coding",
      gene_name : "AL662899.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000031253.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31706866,
      stop : 31710679,
      direction : "+",
      ID : "ENSG00000204424.10",
      gene_id : "ENSG00000204424.10",
      gene_type : "protein_coding",
      gene_name : "LY6G6F",
      gene_level : 2,
      hgnc_id : "HGNC:13933",
      havana_gene : "OTTHUMG00000031252.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31706904,
      stop : 31717918,
      direction : "+",
      ID : "ENSG00000250641.1",
      gene_id : "ENSG00000250641.1",
      gene_type : "protein_coding",
      gene_name : "LY6G6F-LY6G6D",
      gene_level : 1,
      hgnc_id : "HGNC:38821",
      havana_gene : "OTTHUMG00000162247.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31711771,
      stop : 31714065,
      direction : "-",
      ID : "ENSG00000255552.7",
      gene_id : "ENSG00000255552.7",
      gene_type : "protein_coding",
      gene_name : "LY6G6E",
      gene_level : 2,
      hgnc_id : "HGNC:13934",
      havana_gene : "OTTHUMG00000166419.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31715356,
      stop : 31717804,
      direction : "+",
      ID : "ENSG00000244355.7",
      gene_id : "ENSG00000244355.7",
      gene_type : "protein_coding",
      gene_name : "LY6G6D",
      gene_level : 2,
      hgnc_id : "HGNC:13935",
      havana_gene : "OTTHUMG00000137370.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31718594,
      stop : 31726714,
      direction : "+",
      ID : "ENSG00000204420.10",
      gene_id : "ENSG00000204420.10",
      gene_type : "protein_coding",
      gene_name : "MPIG6B",
      gene_level : 2,
      hgnc_id : "HGNC:13937",
      havana_gene : "OTTHUMG00000031130.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31718648,
      stop : 31721746,
      direction : "-",
      ID : "ENSG00000204421.3",
      gene_id : "ENSG00000204421.3",
      gene_type : "protein_coding",
      gene_name : "LY6G6C",
      gene_level : 2,
      hgnc_id : "HGNC:13936",
      havana_gene : "OTTHUMG00000031251.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31727038,
      stop : 31730617,
      direction : "-",
      ID : "ENSG00000213722.10",
      gene_id : "ENSG00000213722.10",
      gene_type : "protein_coding",
      gene_name : "DDAH2",
      gene_level : 2,
      hgnc_id : "HGNC:2716",
      havana_gene : "OTTHUMG00000031212.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31730581,
      stop : 31739763,
      direction : "-",
      ID : "ENSG00000213719.8",
      gene_id : "ENSG00000213719.8",
      gene_type : "protein_coding",
      gene_name : "CLIC1",
      gene_level : 2,
      hgnc_id : "HGNC:2062",
      havana_gene : "OTTHUMG00000031103.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31739677,
      stop : 31762676,
      direction : "+",
      ID : "ENSG00000204410.16",
      gene_id : "ENSG00000204410.16",
      gene_type : "protein_coding",
      gene_name : "MSH5",
      gene_level : 2,
      hgnc_id : "HGNC:7328",
      havana_gene : "OTTHUMG00000167551.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31740020,
      stop : 31764851,
      direction : "+",
      ID : "ENSG00000255152.8",
      gene_id : "ENSG00000255152.8",
      gene_type : "protein_coding",
      gene_name : "MSH5-SAPCD1",
      gene_level : 2,
      hgnc_id : "HGNC:41994",
      havana_gene : "OTTHUMG00000031139.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31762996,
      stop : 31764851,
      direction : "+",
      ID : "ENSG00000228727.9",
      gene_id : "ENSG00000228727.9",
      gene_type : "protein_coding",
      gene_name : "SAPCD1",
      gene_level : 2,
      hgnc_id : "HGNC:13938",
      havana_gene : "OTTHUMG00000031131.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31765590,
      stop : 31777328,
      direction : "-",
      ID : "ENSG00000204396.11",
      gene_id : "ENSG00000204396.11",
      gene_type : "protein_coding",
      gene_name : "VWA7",
      gene_level : 2,
      hgnc_id : "HGNC:13939",
      havana_gene : "OTTHUMG00000031132.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31777518,
      stop : 31795752,
      direction : "-",
      ID : "ENSG00000204394.13",
      gene_id : "ENSG00000204394.13",
      gene_type : "protein_coding",
      gene_name : "VARS1",
      gene_level : 1,
      hgnc_id : "HGNC:12651",
      havana_gene : "OTTHUMG00000031286.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31797396,
      stop : 31806966,
      direction : "-",
      ID : "ENSG00000204392.11",
      gene_id : "ENSG00000204392.11",
      gene_type : "protein_coding",
      gene_name : "LSM2",
      gene_level : 2,
      hgnc_id : "HGNC:13940",
      havana_gene : "OTTHUMG00000031121.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31809619,
      stop : 31815283,
      direction : "-",
      ID : "ENSG00000204390.10",
      gene_id : "ENSG00000204390.10",
      gene_type : "protein_coding",
      gene_name : "HSPA1L",
      gene_level : 2,
      hgnc_id : "HGNC:5234",
      havana_gene : "OTTHUMG00000031208.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31815543,
      stop : 31817946,
      direction : "+",
      ID : "ENSG00000204389.10",
      gene_id : "ENSG00000204389.10",
      gene_type : "protein_coding",
      gene_name : "HSPA1A",
      gene_level : 2,
      hgnc_id : "HGNC:5232",
      havana_gene : "OTTHUMG00000031201.4",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31827738,
      stop : 31830254,
      direction : "+",
      ID : "ENSG00000204388.7",
      gene_id : "ENSG00000204388.7",
      gene_type : "protein_coding",
      gene_name : "HSPA1B",
      gene_level : 2,
      hgnc_id : "HGNC:5233",
      havana_gene : "OTTHUMG00000031202.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31857659,
      stop : 31862905,
      direction : "-",
      ID : "ENSG00000204386.12",
      gene_id : "ENSG00000204386.12",
      gene_type : "protein_coding",
      gene_name : "NEU1",
      gene_level : 2,
      hgnc_id : "HGNC:7758",
      havana_gene : "OTTHUMG00000031284.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31863192,
      stop : 31879046,
      direction : "-",
      ID : "ENSG00000204385.13",
      gene_id : "ENSG00000204385.13",
      gene_type : "protein_coding",
      gene_name : "SLC44A4",
      gene_level : 1,
      hgnc_id : "HGNC:13941",
      havana_gene : "OTTHUMG00000031133.14",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31879759,
      stop : 31897687,
      direction : "-",
      ID : "ENSG00000204371.11",
      gene_id : "ENSG00000204371.11",
      gene_type : "protein_coding",
      gene_name : "EHMT2",
      gene_level : 2,
      hgnc_id : "HGNC:14129",
      havana_gene : "OTTHUMG00000031180.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31897785,
      stop : 31945672,
      direction : "+",
      ID : "ENSG00000166278.15",
      gene_id : "ENSG00000166278.15",
      gene_type : "protein_coding",
      gene_name : "C2",
      gene_level : 1,
      hgnc_id : "HGNC:1248",
      havana_gene : "OTTHUMG00000031190.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31899613,
      stop : 31902086,
      direction : "-",
      ID : "ENSG00000204366.4",
      gene_id : "ENSG00000204366.4",
      gene_type : "protein_coding",
      gene_name : "ZBTB12",
      gene_level : 2,
      hgnc_id : "HGNC:19066",
      havana_gene : "OTTHUMG00000031169.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31927698,
      stop : 31952048,
      direction : "+",
      ID : "ENSG00000244255.5",
      gene_id : "ENSG00000244255.5",
      gene_type : "protein_coding",
      gene_name : "AL645922.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000159600.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31945650,
      stop : 31952084,
      direction : "+",
      ID : "ENSG00000243649.9",
      gene_id : "ENSG00000243649.9",
      gene_type : "protein_coding",
      gene_name : "CFB",
      gene_level : 1,
      hgnc_id : "HGNC:1037",
      havana_gene : "OTTHUMG00000031198.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31952087,
      stop : 31959038,
      direction : "-",
      ID : "ENSG00000204356.14",
      gene_id : "ENSG00000204356.14",
      gene_type : "protein_coding",
      gene_name : "NELFE",
      gene_level : 1,
      hgnc_id : "HGNC:13974",
      havana_gene : "OTTHUMG00000031046.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31959117,
      stop : 31969751,
      direction : "+",
      ID : "ENSG00000204351.12",
      gene_id : "ENSG00000204351.12",
      gene_type : "protein_coding",
      gene_name : "SKIV2L",
      gene_level : 2,
      hgnc_id : "HGNC:10898",
      havana_gene : "OTTHUMG00000031146.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31969810,
      stop : 31972290,
      direction : "-",
      ID : "ENSG00000204348.10",
      gene_id : "ENSG00000204348.10",
      gene_type : "protein_coding",
      gene_name : "DXO",
      gene_level : 2,
      hgnc_id : "HGNC:2992",
      havana_gene : "OTTHUMG00000031272.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31971091,
      stop : 31982821,
      direction : "+",
      ID : "ENSG00000204344.15",
      gene_id : "ENSG00000204344.15",
      gene_type : "protein_coding",
      gene_name : "STK19",
      gene_level : 2,
      hgnc_id : "HGNC:11398",
      havana_gene : "OTTHUMG00000166424.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 31982057,
      stop : 32002681,
      direction : "+",
      ID : "ENSG00000244731.8",
      gene_id : "ENSG00000244731.8",
      gene_type : "protein_coding",
      gene_name : "C4A",
      gene_level : 2,
      hgnc_id : "HGNC:1323",
      havana_gene : "OTTHUMG00000031186.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32014795,
      stop : 32035418,
      direction : "+",
      ID : "ENSG00000224389.9",
      gene_id : "ENSG00000224389.9",
      gene_type : "protein_coding",
      gene_name : "C4B",
      gene_level : 2,
      hgnc_id : "HGNC:1324",
      havana_gene : "OTTHUMG00000031187.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32038327,
      stop : 32041644,
      direction : "+",
      ID : "ENSG00000231852.9",
      gene_id : "ENSG00000231852.9",
      gene_type : "protein_coding",
      gene_name : "CYP21A2",
      gene_level : 2,
      hgnc_id : "HGNC:2600",
      havana_gene : "OTTHUMG00000031069.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32041153,
      stop : 32115334,
      direction : "-",
      ID : "ENSG00000168477.19",
      gene_id : "ENSG00000168477.19",
      gene_type : "protein_coding",
      gene_name : "TNXB",
      gene_level : 1,
      hgnc_id : "HGNC:11976",
      havana_gene : "OTTHUMG00000031088.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32115264,
      stop : 32128253,
      direction : "-",
      ID : "ENSG00000213676.13",
      gene_id : "ENSG00000213676.13",
      gene_type : "protein_coding",
      gene_name : "ATF6B",
      gene_level : 2,
      hgnc_id : "HGNC:2349",
      havana_gene : "OTTHUMG00000192589.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32128707,
      stop : 32130288,
      direction : "-",
      ID : "ENSG00000204315.4",
      gene_id : "ENSG00000204315.4",
      gene_type : "protein_coding",
      gene_name : "FKBPL",
      gene_level : 2,
      hgnc_id : "HGNC:13949",
      havana_gene : "OTTHUMG00000031129.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32148359,
      stop : 32153083,
      direction : "-",
      ID : "ENSG00000204314.12",
      gene_id : "ENSG00000204314.12",
      gene_type : "protein_coding",
      gene_name : "PRRT1",
      gene_level : 1,
      hgnc_id : "HGNC:13943",
      havana_gene : "OTTHUMG00000031144.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32150495,
      stop : 32154373,
      direction : "-",
      ID : "ENSG00000285085.1",
      gene_id : "ENSG00000285085.1",
      gene_type : "protein_coding",
      gene_name : "AL662884.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192426.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32153441,
      stop : 32163678,
      direction : "+",
      ID : "ENSG00000221988.13",
      gene_id : "ENSG00000221988.13",
      gene_type : "protein_coding",
      gene_name : "PPT2",
      gene_level : 2,
      hgnc_id : "HGNC:9326",
      havana_gene : "OTTHUMG00000031257.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32153845,
      stop : 32171978,
      direction : "+",
      ID : "ENSG00000258388.7",
      gene_id : "ENSG00000258388.7",
      gene_type : "protein_coding",
      gene_name : "PPT2-EGFL8",
      gene_level : 2,
      hgnc_id : "HGNC:48343",
      havana_gene : "OTTHUMG00000171245.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32164595,
      stop : 32168281,
      direction : "+",
      ID : "ENSG00000241404.7",
      gene_id : "ENSG00000241404.7",
      gene_type : "protein_coding",
      gene_name : "EGFL8",
      gene_level : 2,
      hgnc_id : "HGNC:13944",
      havana_gene : "OTTHUMG00000031222.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32168212,
      stop : 32178096,
      direction : "-",
      ID : "ENSG00000204310.13",
      gene_id : "ENSG00000204310.13",
      gene_type : "protein_coding",
      gene_name : "AGPAT1",
      gene_level : 2,
      hgnc_id : "HGNC:324",
      havana_gene : "OTTHUMG00000031210.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32178405,
      stop : 32180793,
      direction : "+",
      ID : "ENSG00000204308.8",
      gene_id : "ENSG00000204308.8",
      gene_type : "protein_coding",
      gene_name : "RNF5",
      gene_level : 2,
      hgnc_id : "HGNC:10068",
      havana_gene : "OTTHUMG00000031093.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32180968,
      stop : 32184322,
      direction : "-",
      ID : "ENSG00000204305.15",
      gene_id : "ENSG00000204305.15",
      gene_type : "protein_coding",
      gene_name : "AGER",
      gene_level : 2,
      hgnc_id : "HGNC:320",
      havana_gene : "OTTHUMG00000031120.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32184733,
      stop : 32190202,
      direction : "-",
      ID : "ENSG00000204304.12",
      gene_id : "ENSG00000204304.12",
      gene_type : "protein_coding",
      gene_name : "PBX2",
      gene_level : 2,
      hgnc_id : "HGNC:8633",
      havana_gene : "OTTHUMG00000031116.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32190766,
      stop : 32195523,
      direction : "-",
      ID : "ENSG00000213654.10",
      gene_id : "ENSG00000213654.10",
      gene_type : "protein_coding",
      gene_name : "GPSM3",
      gene_level : 2,
      hgnc_id : "HGNC:13945",
      havana_gene : "OTTHUMG00000031244.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32194843,
      stop : 32224067,
      direction : "-",
      ID : "ENSG00000204301.6",
      gene_id : "ENSG00000204301.6",
      gene_type : "protein_coding",
      gene_name : "NOTCH4",
      gene_level : 2,
      hgnc_id : "HGNC:7884",
      havana_gene : "OTTHUMG00000031044.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32288526,
      stop : 32371912,
      direction : "-",
      ID : "ENSG00000204296.12",
      gene_id : "ENSG00000204296.12",
      gene_type : "protein_coding",
      gene_name : "TSBP1",
      gene_level : 1,
      hgnc_id : "HGNC:13922",
      havana_gene : "OTTHUMG00000031107.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32393963,
      stop : 32407128,
      direction : "-",
      ID : "ENSG00000204290.10",
      gene_id : "ENSG00000204290.10",
      gene_type : "protein_coding",
      gene_name : "BTNL2",
      gene_level : 2,
      hgnc_id : "HGNC:1142",
      havana_gene : "OTTHUMG00000031102.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32439878,
      stop : 32445046,
      direction : "+",
      ID : "ENSG00000204287.14",
      gene_id : "ENSG00000204287.14",
      gene_type : "protein_coding",
      gene_name : "HLA-DRA",
      gene_level : 1,
      hgnc_id : "HGNC:4947",
      havana_gene : "OTTHUMG00000031269.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32517353,
      stop : 32530287,
      direction : "-",
      ID : "ENSG00000198502.6",
      gene_id : "ENSG00000198502.6",
      gene_type : "protein_coding",
      gene_name : "HLA-DRB5",
      gene_level : 2,
      hgnc_id : "HGNC:4953",
      havana_gene : "OTTHUMG00000031027.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32578769,
      stop : 32589848,
      direction : "-",
      ID : "ENSG00000196126.11",
      gene_id : "ENSG00000196126.11",
      gene_type : "protein_coding",
      gene_name : "HLA-DRB1",
      gene_level : 2,
      hgnc_id : "HGNC:4948",
      havana_gene : "OTTHUMG00000031196.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32628179,
      stop : 32647062,
      direction : "+",
      ID : "ENSG00000196735.13",
      gene_id : "ENSG00000196735.13",
      gene_type : "protein_coding",
      gene_name : "HLA-DQA1",
      gene_level : 1,
      hgnc_id : "HGNC:4942",
      havana_gene : "OTTHUMG00000031106.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32659467,
      stop : 32668383,
      direction : "-",
      ID : "ENSG00000179344.16",
      gene_id : "ENSG00000179344.16",
      gene_type : "protein_coding",
      gene_name : "HLA-DQB1",
      gene_level : 1,
      hgnc_id : "HGNC:4944",
      havana_gene : "OTTHUMG00000031124.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32741391,
      stop : 32747198,
      direction : "+",
      ID : "ENSG00000237541.4",
      gene_id : "ENSG00000237541.4",
      gene_type : "protein_coding",
      gene_name : "HLA-DQA2",
      gene_level : 2,
      hgnc_id : "HGNC:4943",
      havana_gene : "OTTHUMG00000031108.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32756098,
      stop : 32763532,
      direction : "-",
      ID : "ENSG00000232629.9",
      gene_id : "ENSG00000232629.9",
      gene_type : "protein_coding",
      gene_name : "HLA-DQB2",
      gene_level : 2,
      hgnc_id : "HGNC:4945",
      havana_gene : "OTTHUMG00000031125.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32812763,
      stop : 32820466,
      direction : "-",
      ID : "ENSG00000241106.8",
      gene_id : "ENSG00000241106.8",
      gene_type : "protein_coding",
      gene_name : "HLA-DOB",
      gene_level : 2,
      hgnc_id : "HGNC:4937",
      havana_gene : "OTTHUMG00000031213.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32813767,
      stop : 32838822,
      direction : "-",
      ID : "ENSG00000250264.1",
      gene_id : "ENSG00000250264.1",
      gene_type : "protein_coding",
      gene_name : "AL669918.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160697.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32821833,
      stop : 32838770,
      direction : "-",
      ID : "ENSG00000204267.16",
      gene_id : "ENSG00000204267.16",
      gene_type : "protein_coding",
      gene_name : "TAP2",
      gene_level : 2,
      hgnc_id : "HGNC:44",
      havana_gene : "OTTHUMG00000031068.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32840717,
      stop : 32844679,
      direction : "-",
      ID : "ENSG00000204264.12",
      gene_id : "ENSG00000204264.12",
      gene_type : "protein_coding",
      gene_name : "PSMB8",
      gene_level : 2,
      hgnc_id : "HGNC:9545",
      havana_gene : "OTTHUMG00000031285.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32844136,
      stop : 32859851,
      direction : "+",
      ID : "ENSG00000240065.8",
      gene_id : "ENSG00000240065.8",
      gene_type : "protein_coding",
      gene_name : "PSMB9",
      gene_level : 2,
      hgnc_id : "HGNC:9546",
      havana_gene : "OTTHUMG00000031287.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32845209,
      stop : 32853816,
      direction : "-",
      ID : "ENSG00000168394.12",
      gene_id : "ENSG00000168394.12",
      gene_type : "protein_coding",
      gene_name : "TAP1",
      gene_level : 2,
      hgnc_id : "HGNC:43",
      havana_gene : "OTTHUMG00000031067.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32934629,
      stop : 32941028,
      direction : "-",
      ID : "ENSG00000242574.9",
      gene_id : "ENSG00000242574.9",
      gene_type : "protein_coding",
      gene_name : "HLA-DMB",
      gene_level : 2,
      hgnc_id : "HGNC:4935",
      havana_gene : "OTTHUMG00000031176.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32937364,
      stop : 32953122,
      direction : "-",
      ID : "ENSG00000248993.1",
      gene_id : "ENSG00000248993.1",
      gene_type : "protein_coding",
      gene_name : "AL645941.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162160.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32948613,
      stop : 32969094,
      direction : "-",
      ID : "ENSG00000204257.15",
      gene_id : "ENSG00000204257.15",
      gene_type : "protein_coding",
      gene_name : "HLA-DMA",
      gene_level : 2,
      hgnc_id : "HGNC:4934",
      havana_gene : "OTTHUMG00000031173.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 32968594,
      stop : 32981505,
      direction : "+",
      ID : "ENSG00000204256.14",
      gene_id : "ENSG00000204256.14",
      gene_type : "protein_coding",
      gene_name : "BRD2",
      gene_level : 1,
      hgnc_id : "HGNC:1103",
      havana_gene : "OTTHUMG00000031241.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33004182,
      stop : 33009591,
      direction : "-",
      ID : "ENSG00000204252.14",
      gene_id : "ENSG00000204252.14",
      gene_type : "protein_coding",
      gene_name : "HLA-DOA",
      gene_level : 2,
      hgnc_id : "HGNC:4936",
      havana_gene : "OTTHUMG00000031211.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33064569,
      stop : 33080775,
      direction : "-",
      ID : "ENSG00000231389.7",
      gene_id : "ENSG00000231389.7",
      gene_type : "protein_coding",
      gene_name : "HLA-DPA1",
      gene_level : 2,
      hgnc_id : "HGNC:4938",
      havana_gene : "OTTHUMG00000031058.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33075990,
      stop : 33089696,
      direction : "+",
      ID : "ENSG00000223865.11",
      gene_id : "ENSG00000223865.11",
      gene_type : "protein_coding",
      gene_name : "HLA-DPB1",
      gene_level : 2,
      hgnc_id : "HGNC:4940",
      havana_gene : "OTTHUMG00000031076.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33162681,
      stop : 33192499,
      direction : "-",
      ID : "ENSG00000204248.11",
      gene_id : "ENSG00000204248.11",
      gene_type : "protein_coding",
      gene_name : "COL11A2",
      gene_level : 2,
      hgnc_id : "HGNC:2187",
      havana_gene : "OTTHUMG00000031036.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33193588,
      stop : 33200665,
      direction : "-",
      ID : "ENSG00000204231.11",
      gene_id : "ENSG00000204231.11",
      gene_type : "protein_coding",
      gene_name : "RXRB",
      gene_level : 2,
      hgnc_id : "HGNC:10478",
      havana_gene : "OTTHUMG00000031298.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33200445,
      stop : 33204439,
      direction : "+",
      ID : "ENSG00000112473.18",
      gene_id : "ENSG00000112473.18",
      gene_type : "protein_coding",
      gene_name : "SLC39A7",
      gene_level : 2,
      hgnc_id : "HGNC:4927",
      havana_gene : "OTTHUMG00000031238.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33204655,
      stop : 33206831,
      direction : "+",
      ID : "ENSG00000204228.4",
      gene_id : "ENSG00000204228.4",
      gene_type : "protein_coding",
      gene_name : "HSD17B8",
      gene_level : 2,
      hgnc_id : "HGNC:3554",
      havana_gene : "OTTHUMG00000031117.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33208500,
      stop : 33212722,
      direction : "+",
      ID : "ENSG00000204227.5",
      gene_id : "ENSG00000204227.5",
      gene_type : "protein_coding",
      gene_name : "RING1",
      gene_level : 2,
      hgnc_id : "HGNC:10018",
      havana_gene : "OTTHUMG00000031278.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33250272,
      stop : 33272047,
      direction : "-",
      ID : "ENSG00000223501.9",
      gene_id : "ENSG00000223501.9",
      gene_type : "protein_coding",
      gene_name : "VPS52",
      gene_level : 2,
      hgnc_id : "HGNC:10518",
      havana_gene : "OTTHUMG00000031276.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33272075,
      stop : 33276511,
      direction : "+",
      ID : "ENSG00000231500.7",
      gene_id : "ENSG00000231500.7",
      gene_type : "protein_coding",
      gene_name : "RPS18",
      gene_level : 2,
      hgnc_id : "HGNC:10401",
      havana_gene : "OTTHUMG00000031053.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33277123,
      stop : 33284832,
      direction : "+",
      ID : "ENSG00000235863.4",
      gene_id : "ENSG00000235863.4",
      gene_type : "protein_coding",
      gene_name : "B3GALT4",
      gene_level : 2,
      hgnc_id : "HGNC:919",
      havana_gene : "OTTHUMG00000031100.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33279108,
      stop : 33289247,
      direction : "-",
      ID : "ENSG00000227057.10",
      gene_id : "ENSG00000227057.10",
      gene_type : "protein_coding",
      gene_name : "WDR46",
      gene_level : 2,
      hgnc_id : "HGNC:13923",
      havana_gene : "OTTHUMG00000031192.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33289302,
      stop : 33298401,
      direction : "+",
      ID : "ENSG00000204220.12",
      gene_id : "ENSG00000204220.12",
      gene_type : "protein_coding",
      gene_name : "PFDN6",
      gene_level : 2,
      hgnc_id : "HGNC:4926",
      havana_gene : "OTTHUMG00000031247.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33291654,
      stop : 33298942,
      direction : "-",
      ID : "ENSG00000237441.10",
      gene_id : "ENSG00000237441.10",
      gene_type : "protein_coding",
      gene_name : "RGL2",
      gene_level : 2,
      hgnc_id : "HGNC:9769",
      havana_gene : "OTTHUMG00000031072.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33299694,
      stop : 33314387,
      direction : "-",
      ID : "ENSG00000231925.12",
      gene_id : "ENSG00000231925.12",
      gene_type : "protein_coding",
      gene_name : "TAPBP",
      gene_level : 1,
      hgnc_id : "HGNC:11566",
      havana_gene : "OTTHUMG00000031090.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33314406,
      stop : 33317942,
      direction : "-",
      ID : "ENSG00000236104.3",
      gene_id : "ENSG00000236104.3",
      gene_type : "protein_coding",
      gene_name : "ZBTB22",
      gene_level : 2,
      hgnc_id : "HGNC:13085",
      havana_gene : "OTTHUMG00000031110.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33318558,
      stop : 33323016,
      direction : "-",
      ID : "ENSG00000204209.13",
      gene_id : "ENSG00000204209.13",
      gene_type : "protein_coding",
      gene_name : "DAXX",
      gene_level : 2,
      hgnc_id : "HGNC:2681",
      havana_gene : "OTTHUMG00000192544.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33321386,
      stop : 33329286,
      direction : "-",
      ID : "ENSG00000285064.2",
      gene_id : "ENSG00000285064.2",
      gene_type : "protein_coding",
      gene_name : "AL662820.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193856.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33323628,
      stop : 33329279,
      direction : "-",
      ID : "ENSG00000286920.2",
      gene_id : "ENSG00000286920.2",
      gene_type : "protein_coding",
      gene_name : "SMIM40",
      gene_level : 2,
      hgnc_id : "HGNC:54073",
      havana_gene : "OTTHUMG00000195939.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33391823,
      stop : 33409896,
      direction : "+",
      ID : "ENSG00000237649.8",
      gene_id : "ENSG00000237649.8",
      gene_type : "protein_coding",
      gene_name : "KIFC1",
      gene_level : 2,
      hgnc_id : "HGNC:6389",
      havana_gene : "OTTHUMG00000031209.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33410399,
      stop : 33416453,
      direction : "+",
      ID : "ENSG00000112511.18",
      gene_id : "ENSG00000112511.18",
      gene_type : "protein_coding",
      gene_name : "PHF1",
      gene_level : 2,
      hgnc_id : "HGNC:8919",
      havana_gene : "OTTHUMG00000031105.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33416442,
      stop : 33418317,
      direction : "-",
      ID : "ENSG00000112514.18",
      gene_id : "ENSG00000112514.18",
      gene_type : "protein_coding",
      gene_name : "CUTA",
      gene_level : 2,
      hgnc_id : "HGNC:21101",
      havana_gene : "OTTHUMG00000031254.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33419661,
      stop : 33453689,
      direction : "+",
      ID : "ENSG00000197283.17",
      gene_id : "ENSG00000197283.17",
      gene_type : "protein_coding",
      gene_name : "SYNGAP1",
      gene_level : 1,
      hgnc_id : "HGNC:11497",
      havana_gene : "OTTHUMG00000031096.20",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33453970,
      stop : 33457544,
      direction : "+",
      ID : "ENSG00000213588.6",
      gene_id : "ENSG00000213588.6",
      gene_type : "protein_coding",
      gene_name : "ZBTB9",
      gene_level : 2,
      hgnc_id : "HGNC:28323",
      havana_gene : "OTTHUMG00000140180.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33572547,
      stop : 33580293,
      direction : "-",
      ID : "ENSG00000030110.13",
      gene_id : "ENSG00000030110.13",
      gene_type : "protein_coding",
      gene_name : "BAK1",
      gene_level : 2,
      hgnc_id : "HGNC:949",
      havana_gene : "OTTHUMG00000014530.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33620365,
      stop : 33696574,
      direction : "+",
      ID : "ENSG00000096433.11",
      gene_id : "ENSG00000096433.11",
      gene_type : "protein_coding",
      gene_name : "ITPR3",
      gene_level : 2,
      hgnc_id : "HGNC:6182",
      havana_gene : "OTTHUMG00000014532.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33694293,
      stop : 33711727,
      direction : "-",
      ID : "ENSG00000137288.10",
      gene_id : "ENSG00000137288.10",
      gene_type : "protein_coding",
      gene_name : "UQCC2",
      gene_level : 2,
      hgnc_id : "HGNC:21237",
      havana_gene : "OTTHUMG00000014534.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33721662,
      stop : 33746905,
      direction : "-",
      ID : "ENSG00000161896.12",
      gene_id : "ENSG00000161896.12",
      gene_type : "protein_coding",
      gene_name : "IP6K3",
      gene_level : 2,
      hgnc_id : "HGNC:17269",
      havana_gene : "OTTHUMG00000014531.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33771202,
      stop : 33789130,
      direction : "-",
      ID : "ENSG00000161904.12",
      gene_id : "ENSG00000161904.12",
      gene_type : "protein_coding",
      gene_name : "LEMD2",
      gene_level : 1,
      hgnc_id : "HGNC:21244",
      havana_gene : "OTTHUMG00000014535.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 33794673,
      stop : 33804003,
      direction : "-",
      ID : "ENSG00000096395.11",
      gene_id : "ENSG00000096395.11",
      gene_type : "protein_coding",
      gene_name : "MLN",
      gene_level : 1,
      hgnc_id : "HGNC:7141",
      havana_gene : "OTTHUMG00000014536.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34018643,
      stop : 34155622,
      direction : "-",
      ID : "ENSG00000124493.14",
      gene_id : "ENSG00000124493.14",
      gene_type : "protein_coding",
      gene_name : "GRM4",
      gene_level : 2,
      hgnc_id : "HGNC:4596",
      havana_gene : "OTTHUMG00000014538.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34236873,
      stop : 34246231,
      direction : "+",
      ID : "ENSG00000137309.20",
      gene_id : "ENSG00000137309.20",
      gene_type : "protein_coding",
      gene_name : "HMGA1",
      gene_level : 2,
      hgnc_id : "HGNC:5010",
      havana_gene : "OTTHUMG00000014539.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34246381,
      stop : 34249108,
      direction : "-",
      ID : "ENSG00000186577.14",
      gene_id : "ENSG00000186577.14",
      gene_type : "protein_coding",
      gene_name : "SMIM29",
      gene_level : 2,
      hgnc_id : "HGNC:1340",
      havana_gene : "OTTHUMG00000159754.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34279679,
      stop : 34392669,
      direction : "-",
      ID : "ENSG00000272325.2",
      gene_id : "ENSG00000272325.2",
      gene_type : "protein_coding",
      gene_name : "NUDT3",
      gene_level : 2,
      hgnc_id : "HGNC:8050",
      havana_gene : "OTTHUMG00000014545.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34284887,
      stop : 34426071,
      direction : "-",
      ID : "ENSG00000270800.3",
      gene_id : "ENSG00000270800.3",
      gene_type : "protein_coding",
      gene_name : "RPS10-NUDT3",
      gene_level : 2,
      hgnc_id : "HGNC:49181",
      havana_gene : "OTTHUMG00000185089.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34417454,
      stop : 34426069,
      direction : "-",
      ID : "ENSG00000124614.16",
      gene_id : "ENSG00000124614.16",
      gene_type : "protein_coding",
      gene_name : "RPS10",
      gene_level : 2,
      hgnc_id : "HGNC:10383",
      havana_gene : "OTTHUMG00000014546.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34466061,
      stop : 34535229,
      direction : "+",
      ID : "ENSG00000124507.11",
      gene_id : "ENSG00000124507.11",
      gene_type : "protein_coding",
      gene_name : "PACSIN1",
      gene_level : 2,
      hgnc_id : "HGNC:8570",
      havana_gene : "OTTHUMG00000014547.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34537802,
      stop : 34556333,
      direction : "-",
      ID : "ENSG00000124664.11",
      gene_id : "ENSG00000124664.11",
      gene_type : "protein_coding",
      gene_name : "SPDEF",
      gene_level : 2,
      hgnc_id : "HGNC:17257",
      havana_gene : "OTTHUMG00000014548.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34587288,
      stop : 34696859,
      direction : "-",
      ID : "ENSG00000196821.10",
      gene_id : "ENSG00000196821.10",
      gene_type : "protein_coding",
      gene_name : "ILRUN",
      gene_level : 2,
      hgnc_id : "HGNC:21215",
      havana_gene : "OTTHUMG00000014553.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34757505,
      stop : 34773857,
      direction : "+",
      ID : "ENSG00000124562.10",
      gene_id : "ENSG00000124562.10",
      gene_type : "protein_coding",
      gene_name : "SNRPC",
      gene_level : 2,
      hgnc_id : "HGNC:11157",
      havana_gene : "OTTHUMG00000014555.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34792015,
      stop : 34883138,
      direction : "+",
      ID : "ENSG00000065060.17",
      gene_id : "ENSG00000065060.17",
      gene_type : "protein_coding",
      gene_name : "UHRF1BP1",
      gene_level : 2,
      hgnc_id : "HGNC:21216",
      havana_gene : "OTTHUMG00000014557.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34877462,
      stop : 34888071,
      direction : "-",
      ID : "ENSG00000064995.18",
      gene_id : "ENSG00000064995.18",
      gene_type : "protein_coding",
      gene_name : "TAF11",
      gene_level : 2,
      hgnc_id : "HGNC:11544",
      havana_gene : "OTTHUMG00000014556.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 34889255,
      stop : 35091406,
      direction : "+",
      ID : "ENSG00000064999.15",
      gene_id : "ENSG00000064999.15",
      gene_type : "protein_coding",
      gene_name : "ANKS1A",
      gene_level : 2,
      hgnc_id : "HGNC:20961",
      havana_gene : "OTTHUMG00000014559.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35118071,
      stop : 35148610,
      direction : "-",
      ID : "ENSG00000124678.20",
      gene_id : "ENSG00000124678.20",
      gene_type : "protein_coding",
      gene_name : "TCP11",
      gene_level : 1,
      hgnc_id : "HGNC:11658",
      havana_gene : "OTTHUMG00000014560.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35213956,
      stop : 35253079,
      direction : "+",
      ID : "ENSG00000146197.9",
      gene_id : "ENSG00000146197.9",
      gene_type : "protein_coding",
      gene_name : "SCUBE3",
      gene_level : 2,
      hgnc_id : "HGNC:13655",
      havana_gene : "OTTHUMG00000014562.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35258909,
      stop : 35295985,
      direction : "+",
      ID : "ENSG00000065029.15",
      gene_id : "ENSG00000065029.15",
      gene_type : "protein_coding",
      gene_name : "ZNF76",
      gene_level : 2,
      hgnc_id : "HGNC:13149",
      havana_gene : "OTTHUMG00000014564.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35297818,
      stop : 35321771,
      direction : "+",
      ID : "ENSG00000023892.11",
      gene_id : "ENSG00000023892.11",
      gene_type : "protein_coding",
      gene_name : "DEF6",
      gene_level : 2,
      hgnc_id : "HGNC:2760",
      havana_gene : "OTTHUMG00000014563.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35342558,
      stop : 35428191,
      direction : "+",
      ID : "ENSG00000112033.14",
      gene_id : "ENSG00000112033.14",
      gene_type : "protein_coding",
      gene_name : "PPARD",
      gene_level : 2,
      hgnc_id : "HGNC:9235",
      havana_gene : "OTTHUMG00000014567.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35452338,
      stop : 35467102,
      direction : "+",
      ID : "ENSG00000112039.5",
      gene_id : "ENSG00000112039.5",
      gene_type : "protein_coding",
      gene_name : "FANCE",
      gene_level : 2,
      hgnc_id : "HGNC:3586",
      havana_gene : "OTTHUMG00000014565.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35468401,
      stop : 35470785,
      direction : "+",
      ID : "ENSG00000198755.11",
      gene_id : "ENSG00000198755.11",
      gene_type : "protein_coding",
      gene_name : "RPL10A",
      gene_level : 2,
      hgnc_id : "HGNC:10299",
      havana_gene : "OTTHUMG00000014566.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35473597,
      stop : 35497079,
      direction : "-",
      ID : "ENSG00000007866.22",
      gene_id : "ENSG00000007866.22",
      gene_type : "protein_coding",
      gene_name : "TEAD3",
      gene_level : 2,
      hgnc_id : "HGNC:11716",
      havana_gene : "OTTHUMG00000014571.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35497874,
      stop : 35512896,
      direction : "-",
      ID : "ENSG00000112041.13",
      gene_id : "ENSG00000112041.13",
      gene_type : "protein_coding",
      gene_name : "TULP1",
      gene_level : 2,
      hgnc_id : "HGNC:12423",
      havana_gene : "OTTHUMG00000014575.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35573585,
      stop : 35728583,
      direction : "-",
      ID : "ENSG00000096060.15",
      gene_id : "ENSG00000096060.15",
      gene_type : "protein_coding",
      gene_name : "FKBP5",
      gene_level : 2,
      hgnc_id : "HGNC:3721",
      havana_gene : "OTTHUMG00000014576.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35737032,
      stop : 35749079,
      direction : "+",
      ID : "ENSG00000157343.9",
      gene_id : "ENSG00000157343.9",
      gene_type : "protein_coding",
      gene_name : "ARMC12",
      gene_level : 2,
      hgnc_id : "HGNC:21099",
      havana_gene : "OTTHUMG00000014577.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35776594,
      stop : 35779552,
      direction : "+",
      ID : "ENSG00000196748.10",
      gene_id : "ENSG00000196748.10",
      gene_type : "protein_coding",
      gene_name : "CLPSL2",
      gene_level : 2,
      hgnc_id : "HGNC:21250",
      havana_gene : "OTTHUMG00000014581.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35781019,
      stop : 35793675,
      direction : "+",
      ID : "ENSG00000204140.10",
      gene_id : "ENSG00000204140.10",
      gene_type : "protein_coding",
      gene_name : "CLPSL1",
      gene_level : 2,
      hgnc_id : "HGNC:21251",
      havana_gene : "OTTHUMG00000014582.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35794982,
      stop : 35797344,
      direction : "-",
      ID : "ENSG00000137392.10",
      gene_id : "ENSG00000137392.10",
      gene_type : "protein_coding",
      gene_name : "CLPS",
      gene_level : 2,
      hgnc_id : "HGNC:2085",
      havana_gene : "OTTHUMG00000014578.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35797206,
      stop : 35845397,
      direction : "+",
      ID : "ENSG00000197753.11",
      gene_id : "ENSG00000197753.11",
      gene_type : "protein_coding",
      gene_name : "LHFPL5",
      gene_level : 2,
      hgnc_id : "HGNC:21253",
      havana_gene : "OTTHUMG00000014584.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35832966,
      stop : 35921342,
      direction : "-",
      ID : "ENSG00000096063.16",
      gene_id : "ENSG00000096063.16",
      gene_type : "protein_coding",
      gene_name : "SRPK1",
      gene_level : 1,
      hgnc_id : "HGNC:11305",
      havana_gene : "OTTHUMG00000014583.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 35943516,
      stop : 36024868,
      direction : "-",
      ID : "ENSG00000112053.14",
      gene_id : "ENSG00000112053.14",
      gene_type : "protein_coding",
      gene_name : "SLC26A8",
      gene_level : 2,
      hgnc_id : "HGNC:14468",
      havana_gene : "OTTHUMG00000014586.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36027677,
      stop : 36111236,
      direction : "+",
      ID : "ENSG00000112062.11",
      gene_id : "ENSG00000112062.11",
      gene_type : "protein_coding",
      gene_name : "MAPK14",
      gene_level : 1,
      hgnc_id : "HGNC:6876",
      havana_gene : "OTTHUMG00000159806.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36127809,
      stop : 36144524,
      direction : "+",
      ID : "ENSG00000156711.17",
      gene_id : "ENSG00000156711.17",
      gene_type : "protein_coding",
      gene_name : "MAPK13",
      gene_level : 2,
      hgnc_id : "HGNC:6875",
      havana_gene : "OTTHUMG00000014587.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36196744,
      stop : 36232790,
      direction : "+",
      ID : "ENSG00000096070.19",
      gene_id : "ENSG00000096070.19",
      gene_type : "protein_coding",
      gene_name : "BRPF3",
      gene_level : 1,
      hgnc_id : "HGNC:14256",
      havana_gene : "OTTHUMG00000014589.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36243203,
      stop : 36313955,
      direction : "+",
      ID : "ENSG00000180316.13",
      gene_id : "ENSG00000180316.13",
      gene_type : "protein_coding",
      gene_name : "PNPLA1",
      gene_level : 1,
      hgnc_id : "HGNC:21246",
      havana_gene : "OTTHUMG00000014590.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36315761,
      stop : 36336888,
      direction : "-",
      ID : "ENSG00000189325.7",
      gene_id : "ENSG00000189325.7",
      gene_type : "protein_coding",
      gene_name : "BNIP5",
      gene_level : 2,
      hgnc_id : "HGNC:33769",
      havana_gene : "OTTHUMG00000014591.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36354091,
      stop : 36387800,
      direction : "-",
      ID : "ENSG00000010030.14",
      gene_id : "ENSG00000010030.14",
      gene_type : "protein_coding",
      gene_name : "ETV7",
      gene_level : 2,
      hgnc_id : "HGNC:18160",
      havana_gene : "OTTHUMG00000014594.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36390551,
      stop : 36442854,
      direction : "-",
      ID : "ENSG00000179165.11",
      gene_id : "ENSG00000179165.11",
      gene_type : "protein_coding",
      gene_name : "PXT1",
      gene_level : 1,
      hgnc_id : "HGNC:18312",
      havana_gene : "OTTHUMG00000159815.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36442767,
      stop : 36491143,
      direction : "+",
      ID : "ENSG00000112078.14",
      gene_id : "ENSG00000112078.14",
      gene_type : "protein_coding",
      gene_name : "KCTD20",
      gene_level : 2,
      hgnc_id : "HGNC:21052",
      havana_gene : "OTTHUMG00000014597.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36493892,
      stop : 36547479,
      direction : "-",
      ID : "ENSG00000112079.9",
      gene_id : "ENSG00000112079.9",
      gene_type : "protein_coding",
      gene_name : "STK38",
      gene_level : 2,
      hgnc_id : "HGNC:17847",
      havana_gene : "OTTHUMG00000014598.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36594353,
      stop : 36605600,
      direction : "+",
      ID : "ENSG00000112081.17",
      gene_id : "ENSG00000112081.17",
      gene_type : "protein_coding",
      gene_name : "SRSF3",
      gene_level : 2,
      hgnc_id : "HGNC:10785",
      havana_gene : "OTTHUMG00000014599.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36676460,
      stop : 36687337,
      direction : "+",
      ID : "ENSG00000124762.14",
      gene_id : "ENSG00000124762.14",
      gene_type : "protein_coding",
      gene_name : "CDKN1A",
      gene_level : 2,
      hgnc_id : "HGNC:1784",
      havana_gene : "OTTHUMG00000014603.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36697826,
      stop : 36733184,
      direction : "+",
      ID : "ENSG00000255587.9",
      gene_id : "ENSG00000255587.9",
      gene_type : "protein_coding",
      gene_name : "RAB44",
      gene_level : 2,
      hgnc_id : "HGNC:21068",
      havana_gene : "OTTHUMG00000016308.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36740775,
      stop : 36839444,
      direction : "-",
      ID : "ENSG00000124772.12",
      gene_id : "ENSG00000124772.12",
      gene_type : "protein_coding",
      gene_name : "CPNE5",
      gene_level : 2,
      hgnc_id : "HGNC:2318",
      havana_gene : "OTTHUMG00000014602.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36854827,
      stop : 36874803,
      direction : "-",
      ID : "ENSG00000137168.8",
      gene_id : "ENSG00000137168.8",
      gene_type : "protein_coding",
      gene_name : "PPIL1",
      gene_level : 2,
      hgnc_id : "HGNC:9260",
      havana_gene : "OTTHUMG00000014612.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36871870,
      stop : 36928964,
      direction : "+",
      ID : "ENSG00000198663.17",
      gene_id : "ENSG00000198663.17",
      gene_type : "protein_coding",
      gene_name : "C6orf89",
      gene_level : 2,
      hgnc_id : "HGNC:21114",
      havana_gene : "OTTHUMG00000014613.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36948263,
      stop : 36964837,
      direction : "+",
      ID : "ENSG00000164530.15",
      gene_id : "ENSG00000164530.15",
      gene_type : "protein_coding",
      gene_name : "PI16",
      gene_level : 2,
      hgnc_id : "HGNC:21245",
      havana_gene : "OTTHUMG00000014611.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 36968141,
      stop : 36986298,
      direction : "-",
      ID : "ENSG00000137409.20",
      gene_id : "ENSG00000137409.20",
      gene_type : "protein_coding",
      gene_name : "MTCH1",
      gene_level : 2,
      hgnc_id : "HGNC:17586",
      havana_gene : "OTTHUMG00000014614.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37005646,
      stop : 37029069,
      direction : "+",
      ID : "ENSG00000146192.15",
      gene_id : "ENSG00000146192.15",
      gene_type : "protein_coding",
      gene_name : "FGD2",
      gene_level : 2,
      hgnc_id : "HGNC:3664",
      havana_gene : "OTTHUMG00000014616.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37170152,
      stop : 37175428,
      direction : "+",
      ID : "ENSG00000137193.14",
      gene_id : "ENSG00000137193.14",
      gene_type : "protein_coding",
      gene_name : "PIM1",
      gene_level : 2,
      hgnc_id : "HGNC:8986",
      havana_gene : "OTTHUMG00000016426.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37212178,
      stop : 37258155,
      direction : "-",
      ID : "ENSG00000172738.12",
      gene_id : "ENSG00000172738.12",
      gene_type : "protein_coding",
      gene_name : "TMEM217",
      gene_level : 2,
      hgnc_id : "HGNC:21238",
      havana_gene : "OTTHUMG00000193508.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37212181,
      stop : 37257637,
      direction : "-",
      ID : "ENSG00000286105.1",
      gene_id : "ENSG00000286105.1",
      gene_type : "protein_coding",
      gene_name : "AL353579.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000014618.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37257772,
      stop : 37332970,
      direction : "+",
      ID : "ENSG00000065491.8",
      gene_id : "ENSG00000065491.8",
      gene_type : "protein_coding",
      gene_name : "TBC1D22B",
      gene_level : 2,
      hgnc_id : "HGNC:21602",
      havana_gene : "OTTHUMG00000014619.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37353979,
      stop : 37394734,
      direction : "+",
      ID : "ENSG00000112130.17",
      gene_id : "ENSG00000112130.17",
      gene_type : "protein_coding",
      gene_name : "RNF8",
      gene_level : 2,
      hgnc_id : "HGNC:10071",
      havana_gene : "OTTHUMG00000014620.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37433219,
      stop : 37482827,
      direction : "+",
      ID : "ENSG00000137200.13",
      gene_id : "ENSG00000137200.13",
      gene_type : "protein_coding",
      gene_name : "CMTR1",
      gene_level : 2,
      hgnc_id : "HGNC:21077",
      havana_gene : "OTTHUMG00000014624.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37482938,
      stop : 37499893,
      direction : "-",
      ID : "ENSG00000198937.9",
      gene_id : "ENSG00000198937.9",
      gene_type : "protein_coding",
      gene_name : "CCDC167",
      gene_level : 2,
      hgnc_id : "HGNC:21239",
      havana_gene : "OTTHUMG00000014625.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37630679,
      stop : 37699306,
      direction : "-",
      ID : "ENSG00000112139.17",
      gene_id : "ENSG00000112139.17",
      gene_type : "protein_coding",
      gene_name : "MDGA1",
      gene_level : 1,
      hgnc_id : "HGNC:19267",
      havana_gene : "OTTHUMG00000014626.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 37819727,
      stop : 38154624,
      direction : "+",
      ID : "ENSG00000156639.12",
      gene_id : "ENSG00000156639.12",
      gene_type : "protein_coding",
      gene_name : "ZFAND3",
      gene_level : 1,
      hgnc_id : "HGNC:18019",
      havana_gene : "OTTHUMG00000014629.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 38168451,
      stop : 38640148,
      direction : "-",
      ID : "ENSG00000183826.18",
      gene_id : "ENSG00000183826.18",
      gene_type : "protein_coding",
      gene_name : "BTBD9",
      gene_level : 1,
      hgnc_id : "HGNC:21228",
      havana_gene : "OTTHUMG00000014634.10",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 38675925,
      stop : 38703145,
      direction : "-",
      ID : "ENSG00000124767.7",
      gene_id : "ENSG00000124767.7",
      gene_type : "protein_coding",
      gene_name : "GLO1",
      gene_level : 2,
      hgnc_id : "HGNC:4323",
      havana_gene : "OTTHUMG00000014636.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 38715311,
      stop : 39030792,
      direction : "+",
      ID : "ENSG00000124721.18",
      gene_id : "ENSG00000124721.18",
      gene_type : "protein_coding",
      gene_name : "DNAH8",
      gene_level : 1,
      hgnc_id : "HGNC:2952",
      havana_gene : "OTTHUMG00000016253.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39048781,
      stop : 39091303,
      direction : "+",
      ID : "ENSG00000112164.6",
      gene_id : "ENSG00000112164.6",
      gene_type : "protein_coding",
      gene_name : "GLP1R",
      gene_level : 2,
      hgnc_id : "HGNC:4324",
      havana_gene : "OTTHUMG00000014638.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39104063,
      stop : 39115186,
      direction : "-",
      ID : "ENSG00000112167.10",
      gene_id : "ENSG00000112167.10",
      gene_type : "protein_coding",
      gene_name : "SAYSD1",
      gene_level : 2,
      hgnc_id : "HGNC:21025",
      havana_gene : "OTTHUMG00000014641.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39188971,
      stop : 39229475,
      direction : "-",
      ID : "ENSG00000164626.9",
      gene_id : "ENSG00000164626.9",
      gene_type : "protein_coding",
      gene_name : "KCNK5",
      gene_level : 2,
      hgnc_id : "HGNC:6280",
      havana_gene : "OTTHUMG00000014642.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39299001,
      stop : 39314461,
      direction : "-",
      ID : "ENSG00000124780.14",
      gene_id : "ENSG00000124780.14",
      gene_type : "protein_coding",
      gene_name : "KCNK17",
      gene_level : 2,
      hgnc_id : "HGNC:14465",
      havana_gene : "OTTHUMG00000014646.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39314698,
      stop : 39322968,
      direction : "-",
      ID : "ENSG00000095981.11",
      gene_id : "ENSG00000095981.11",
      gene_type : "protein_coding",
      gene_name : "KCNK16",
      gene_level : 2,
      hgnc_id : "HGNC:14464",
      havana_gene : "OTTHUMG00000014645.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39329990,
      stop : 39725408,
      direction : "-",
      ID : "ENSG00000164627.18",
      gene_id : "ENSG00000164627.18",
      gene_type : "protein_coding",
      gene_name : "KIF6",
      gene_level : 2,
      hgnc_id : "HGNC:21202",
      havana_gene : "OTTHUMG00000014648.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39792298,
      stop : 39904877,
      direction : "+",
      ID : "ENSG00000146122.17",
      gene_id : "ENSG00000146122.17",
      gene_type : "protein_coding",
      gene_name : "DAAM2",
      gene_level : 2,
      hgnc_id : "HGNC:18143",
      havana_gene : "OTTHUMG00000014653.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 39899578,
      stop : 39934551,
      direction : "-",
      ID : "ENSG00000124615.20",
      gene_id : "ENSG00000124615.20",
      gene_type : "protein_coding",
      gene_name : "MOCS1",
      gene_level : 2,
      hgnc_id : "HGNC:7190",
      havana_gene : "OTTHUMG00000014656.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 40391591,
      stop : 40587364,
      direction : "-",
      ID : "ENSG00000156564.9",
      gene_id : "ENSG00000156564.9",
      gene_type : "protein_coding",
      gene_name : "LRFN2",
      gene_level : 2,
      hgnc_id : "HGNC:21226",
      havana_gene : "OTTHUMG00000014662.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41026895,
      stop : 41039221,
      direction : "-",
      ID : "ENSG00000124602.10",
      gene_id : "ENSG00000124602.10",
      gene_type : "protein_coding",
      gene_name : "UNC5CL",
      gene_level : 2,
      hgnc_id : "HGNC:21203",
      havana_gene : "OTTHUMG00000014665.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41033627,
      stop : 41097787,
      direction : "-",
      ID : "ENSG00000124596.17",
      gene_id : "ENSG00000124596.17",
      gene_type : "protein_coding",
      gene_name : "OARD1",
      gene_level : 1,
      hgnc_id : "HGNC:21257",
      havana_gene : "OTTHUMG00000014667.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41042467,
      stop : 41044337,
      direction : "+",
      ID : "ENSG00000112212.12",
      gene_id : "ENSG00000112212.12",
      gene_type : "protein_coding",
      gene_name : "TSPO2",
      gene_level : 1,
      hgnc_id : "HGNC:21256",
      havana_gene : "OTTHUMG00000014666.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41053202,
      stop : 41064891,
      direction : "+",
      ID : "ENSG00000124701.6",
      gene_id : "ENSG00000124701.6",
      gene_type : "protein_coding",
      gene_name : "APOBEC2",
      gene_level : 2,
      hgnc_id : "HGNC:605",
      havana_gene : "OTTHUMG00000014670.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41072945,
      stop : 41099976,
      direction : "+",
      ID : "ENSG00000001167.14",
      gene_id : "ENSG00000001167.14",
      gene_type : "protein_coding",
      gene_name : "NFYA",
      gene_level : 2,
      hgnc_id : "HGNC:7804",
      havana_gene : "OTTHUMG00000014669.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41149342,
      stop : 41154337,
      direction : "-",
      ID : "ENSG00000161911.11",
      gene_id : "ENSG00000161911.11",
      gene_type : "protein_coding",
      gene_name : "TREML1",
      gene_level : 2,
      hgnc_id : "HGNC:20434",
      havana_gene : "OTTHUMG00000016231.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41158506,
      stop : 41163186,
      direction : "-",
      ID : "ENSG00000095970.17",
      gene_id : "ENSG00000095970.17",
      gene_type : "protein_coding",
      gene_name : "TREM2",
      gene_level : 2,
      hgnc_id : "HGNC:17761",
      havana_gene : "OTTHUMG00000014671.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41189749,
      stop : 41201149,
      direction : "-",
      ID : "ENSG00000112195.9",
      gene_id : "ENSG00000112195.9",
      gene_type : "protein_coding",
      gene_name : "TREML2",
      gene_level : 2,
      hgnc_id : "HGNC:21092",
      havana_gene : "OTTHUMG00000016349.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41228339,
      stop : 41238882,
      direction : "+",
      ID : "ENSG00000188056.12",
      gene_id : "ENSG00000188056.12",
      gene_type : "protein_coding",
      gene_name : "TREML4",
      gene_level : 2,
      hgnc_id : "HGNC:30807",
      havana_gene : "OTTHUMG00000016408.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41267926,
      stop : 41286682,
      direction : "-",
      ID : "ENSG00000124731.13",
      gene_id : "ENSG00000124731.13",
      gene_type : "protein_coding",
      gene_name : "TREM1",
      gene_level : 1,
      hgnc_id : "HGNC:17760",
      havana_gene : "OTTHUMG00000014674.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41335608,
      stop : 41350889,
      direction : "+",
      ID : "ENSG00000096264.14",
      gene_id : "ENSG00000096264.14",
      gene_type : "protein_coding",
      gene_name : "NCR2",
      gene_level : 2,
      hgnc_id : "HGNC:6732",
      havana_gene : "OTTHUMG00000014678.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41546381,
      stop : 41602384,
      direction : "+",
      ID : "ENSG00000137166.17",
      gene_id : "ENSG00000137166.17",
      gene_type : "protein_coding",
      gene_name : "FOXP4",
      gene_level : 2,
      hgnc_id : "HGNC:20842",
      havana_gene : "OTTHUMG00000014679.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41636882,
      stop : 41654244,
      direction : "+",
      ID : "ENSG00000112559.15",
      gene_id : "ENSG00000112559.15",
      gene_type : "protein_coding",
      gene_name : "MDFI",
      gene_level : 2,
      hgnc_id : "HGNC:6967",
      havana_gene : "OTTHUMG00000014681.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41683978,
      stop : 41736259,
      direction : "-",
      ID : "ENSG00000112561.19",
      gene_id : "ENSG00000112561.19",
      gene_type : "protein_coding",
      gene_name : "TFEB",
      gene_level : 2,
      hgnc_id : "HGNC:11753",
      havana_gene : "OTTHUMG00000014684.13",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41736711,
      stop : 41754109,
      direction : "-",
      ID : "ENSG00000096088.16",
      gene_id : "ENSG00000096088.16",
      gene_type : "protein_coding",
      gene_name : "PGC",
      gene_level : 1,
      hgnc_id : "HGNC:8890",
      havana_gene : "OTTHUMG00000014683.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41770176,
      stop : 41786542,
      direction : "-",
      ID : "ENSG00000137218.10",
      gene_id : "ENSG00000137218.10",
      gene_type : "protein_coding",
      gene_name : "FRS3",
      gene_level : 2,
      hgnc_id : "HGNC:16970",
      havana_gene : "OTTHUMG00000014686.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41780349,
      stop : 41790141,
      direction : "+",
      ID : "ENSG00000124593.16",
      gene_id : "ENSG00000124593.16",
      gene_type : "protein_coding",
      gene_name : "AL365205.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000014685.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41780782,
      stop : 41787452,
      direction : "+",
      ID : "ENSG00000278224.7",
      gene_id : "ENSG00000278224.7",
      gene_type : "protein_coding",
      gene_name : "PRICKLE4",
      gene_level : 2,
      hgnc_id : "HGNC:16805",
      havana_gene : "OTTHUMG00000188149.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41787662,
      stop : 41789898,
      direction : "+",
      ID : "ENSG00000214736.8",
      gene_id : "ENSG00000214736.8",
      gene_type : "protein_coding",
      gene_name : "TOMM6",
      gene_level : 2,
      hgnc_id : "HGNC:34528",
      havana_gene : "OTTHUMG00000137505.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41789896,
      stop : 41895361,
      direction : "-",
      ID : "ENSG00000164663.14",
      gene_id : "ENSG00000164663.14",
      gene_type : "protein_coding",
      gene_name : "USP49",
      gene_level : 2,
      hgnc_id : "HGNC:20078",
      havana_gene : "OTTHUMG00000014688.10",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41905354,
      stop : 41921139,
      direction : "-",
      ID : "ENSG00000124641.16",
      gene_id : "ENSG00000124641.16",
      gene_type : "protein_coding",
      gene_name : "MED20",
      gene_level : 2,
      hgnc_id : "HGNC:16840",
      havana_gene : "OTTHUMG00000014689.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41921499,
      stop : 41933046,
      direction : "+",
      ID : "ENSG00000112578.10",
      gene_id : "ENSG00000112578.10",
      gene_type : "protein_coding",
      gene_name : "BYSL",
      gene_level : 2,
      hgnc_id : "HGNC:1157",
      havana_gene : "OTTHUMG00000014687.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 41934934,
      stop : 42050357,
      direction : "-",
      ID : "ENSG00000112576.13",
      gene_id : "ENSG00000112576.13",
      gene_type : "protein_coding",
      gene_name : "CCND3",
      gene_level : 2,
      hgnc_id : "HGNC:1585",
      havana_gene : "OTTHUMG00000014690.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42050513,
      stop : 42087461,
      direction : "+",
      ID : "ENSG00000137413.16",
      gene_id : "ENSG00000137413.16",
      gene_type : "protein_coding",
      gene_name : "TAF8",
      gene_level : 1,
      hgnc_id : "HGNC:17300",
      havana_gene : "OTTHUMG00000014692.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42101119,
      stop : 42142620,
      direction : "-",
      ID : "ENSG00000188112.9",
      gene_id : "ENSG00000188112.9",
      gene_type : "protein_coding",
      gene_name : "C6orf132",
      gene_level : 1,
      hgnc_id : "HGNC:21288",
      havana_gene : "OTTHUMG00000014695.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42155406,
      stop : 42180056,
      direction : "+",
      ID : "ENSG00000287363.3",
      gene_id : "ENSG00000287363.3",
      gene_type : "protein_coding",
      gene_name : "GUCA1ANB",
      gene_level : 2,
      hgnc_id : "HGNC:55126",
      havana_gene : "OTTHUMG00000014693.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42155406,
      stop : 42181338,
      direction : "+",
      ID : "ENSG00000048545.17",
      gene_id : "ENSG00000048545.17",
      gene_type : "protein_coding",
      gene_name : "GUCA1A",
      gene_level : 2,
      hgnc_id : "HGNC:4678",
      havana_gene : "OTTHUMG00000014696.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42183284,
      stop : 42194956,
      direction : "-",
      ID : "ENSG00000112599.9",
      gene_id : "ENSG00000112599.9",
      gene_type : "protein_coding",
      gene_name : "GUCA1B",
      gene_level : 2,
      hgnc_id : "HGNC:4679",
      havana_gene : "OTTHUMG00000014697.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42206807,
      stop : 42217861,
      direction : "-",
      ID : "ENSG00000048544.6",
      gene_id : "ENSG00000048544.6",
      gene_type : "protein_coding",
      gene_name : "MRPS10",
      gene_level : 2,
      hgnc_id : "HGNC:14502",
      havana_gene : "OTTHUMG00000014694.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42224931,
      stop : 42452051,
      direction : "-",
      ID : "ENSG00000124496.12",
      gene_id : "ENSG00000124496.12",
      gene_type : "protein_coding",
      gene_name : "TRERF1",
      gene_level : 2,
      hgnc_id : "HGNC:18273",
      havana_gene : "OTTHUMG00000014698.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42564029,
      stop : 42693505,
      direction : "+",
      ID : "ENSG00000024048.11",
      gene_id : "ENSG00000024048.11",
      gene_type : "protein_coding",
      gene_name : "UBR2",
      gene_level : 2,
      hgnc_id : "HGNC:21289",
      havana_gene : "OTTHUMG00000014703.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42696598,
      stop : 42722597,
      direction : "-",
      ID : "ENSG00000112619.8",
      gene_id : "ENSG00000112619.8",
      gene_type : "protein_coding",
      gene_name : "PRPH2",
      gene_level : 2,
      hgnc_id : "HGNC:9942",
      havana_gene : "OTTHUMG00000014701.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42744498,
      stop : 42746103,
      direction : "-",
      ID : "ENSG00000124659.7",
      gene_id : "ENSG00000124659.7",
      gene_type : "protein_coding",
      gene_name : "TBCC",
      gene_level : 2,
      hgnc_id : "HGNC:11580",
      havana_gene : "OTTHUMG00000014704.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42746958,
      stop : 42868560,
      direction : "+",
      ID : "ENSG00000112624.12",
      gene_id : "ENSG00000112624.12",
      gene_type : "protein_coding",
      gene_name : "BICRAL",
      gene_level : 2,
      hgnc_id : "HGNC:21111",
      havana_gene : "OTTHUMG00000014706.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42879616,
      stop : 42889925,
      direction : "+",
      ID : "ENSG00000146223.16",
      gene_id : "ENSG00000146223.16",
      gene_type : "protein_coding",
      gene_name : "RPL7L1",
      gene_level : 2,
      hgnc_id : "HGNC:21370",
      havana_gene : "OTTHUMG00000014710.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42890265,
      stop : 42890821,
      direction : "-",
      ID : "ENSG00000221821.4",
      gene_id : "ENSG00000221821.4",
      gene_type : "protein_coding",
      gene_name : "C6orf226",
      gene_level : 2,
      hgnc_id : "HGNC:34431",
      havana_gene : "OTTHUMG00000156926.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42915989,
      stop : 42925838,
      direction : "+",
      ID : "ENSG00000171611.10",
      gene_id : "ENSG00000171611.10",
      gene_type : "protein_coding",
      gene_name : "PTCRA",
      gene_level : 2,
      hgnc_id : "HGNC:21290",
      havana_gene : "OTTHUMG00000014709.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42929192,
      stop : 42939294,
      direction : "+",
      ID : "ENSG00000137161.17",
      gene_id : "ENSG00000137161.17",
      gene_type : "protein_coding",
      gene_name : "CNPY3",
      gene_level : 2,
      hgnc_id : "HGNC:11968",
      havana_gene : "OTTHUMG00000014708.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42960754,
      stop : 42963880,
      direction : "+",
      ID : "ENSG00000124713.6",
      gene_id : "ENSG00000124713.6",
      gene_type : "protein_coding",
      gene_name : "GNMT",
      gene_level : 2,
      hgnc_id : "HGNC:4415",
      havana_gene : "OTTHUMG00000014712.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42963865,
      stop : 42979181,
      direction : "-",
      ID : "ENSG00000124587.14",
      gene_id : "ENSG00000124587.14",
      gene_type : "protein_coding",
      gene_name : "PEX6",
      gene_level : 2,
      hgnc_id : "HGNC:8859",
      havana_gene : "OTTHUMG00000014713.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 42984553,
      stop : 43012342,
      direction : "+",
      ID : "ENSG00000112640.16",
      gene_id : "ENSG00000112640.16",
      gene_type : "protein_coding",
      gene_name : "PPP2R5D",
      gene_level : 1,
      hgnc_id : "HGNC:9312",
      havana_gene : "OTTHUMG00000014716.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43011143,
      stop : 43016868,
      direction : "-",
      ID : "ENSG00000124733.5",
      gene_id : "ENSG00000124733.5",
      gene_type : "protein_coding",
      gene_name : "MEA1",
      gene_level : 2,
      hgnc_id : "HGNC:6986",
      havana_gene : "OTTHUMG00000014717.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43014103,
      stop : 43021298,
      direction : "+",
      ID : "ENSG00000124702.18",
      gene_id : "ENSG00000124702.18",
      gene_type : "protein_coding",
      gene_name : "KLHDC3",
      gene_level : 2,
      hgnc_id : "HGNC:20704",
      havana_gene : "OTTHUMG00000014714.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43021623,
      stop : 43034156,
      direction : "+",
      ID : "ENSG00000124541.7",
      gene_id : "ENSG00000124541.7",
      gene_type : "protein_coding",
      gene_name : "RRP36",
      gene_level : 2,
      hgnc_id : "HGNC:21374",
      havana_gene : "OTTHUMG00000014715.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43037617,
      stop : 43053943,
      direction : "-",
      ID : "ENSG00000044090.11",
      gene_id : "ENSG00000044090.11",
      gene_type : "protein_coding",
      gene_name : "CUL7",
      gene_level : 2,
      hgnc_id : "HGNC:21024",
      havana_gene : "OTTHUMG00000014718.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43040777,
      stop : 43075095,
      direction : "+",
      ID : "ENSG00000137171.15",
      gene_id : "ENSG00000137171.15",
      gene_type : "protein_coding",
      gene_name : "KLC4",
      gene_level : 1,
      hgnc_id : "HGNC:21624",
      havana_gene : "OTTHUMG00000014720.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43051066,
      stop : 43058185,
      direction : "-",
      ID : "ENSG00000288564.1",
      gene_id : "ENSG00000288564.1",
      gene_type : "protein_coding",
      gene_name : "AL355385.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000195946.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43054029,
      stop : 43059438,
      direction : "-",
      ID : "ENSG00000112651.12",
      gene_id : "ENSG00000112651.12",
      gene_type : "protein_coding",
      gene_name : "MRPL2",
      gene_level : 1,
      hgnc_id : "HGNC:14056",
      havana_gene : "OTTHUMG00000014719.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43076307,
      stop : 43161719,
      direction : "+",
      ID : "ENSG00000112655.16",
      gene_id : "ENSG00000112655.16",
      gene_type : "protein_coding",
      gene_name : "PTK7",
      gene_level : 2,
      hgnc_id : "HGNC:9618",
      havana_gene : "OTTHUMG00000014721.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43171269,
      stop : 43181506,
      direction : "+",
      ID : "ENSG00000112658.8",
      gene_id : "ENSG00000112658.8",
      gene_type : "protein_coding",
      gene_name : "SRF",
      gene_level : 2,
      hgnc_id : "HGNC:11291",
      havana_gene : "OTTHUMG00000014722.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43182184,
      stop : 43224587,
      direction : "+",
      ID : "ENSG00000112659.14",
      gene_id : "ENSG00000112659.14",
      gene_type : "protein_coding",
      gene_name : "CUL9",
      gene_level : 1,
      hgnc_id : "HGNC:15982",
      havana_gene : "OTTHUMG00000014723.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43225629,
      stop : 43229481,
      direction : "-",
      ID : "ENSG00000112667.13",
      gene_id : "ENSG00000112667.13",
      gene_type : "protein_coding",
      gene_name : "DNPH1",
      gene_level : 2,
      hgnc_id : "HGNC:21218",
      havana_gene : "OTTHUMG00000014724.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43243481,
      stop : 43288258,
      direction : "+",
      ID : "ENSG00000146216.13",
      gene_id : "ENSG00000146216.13",
      gene_type : "protein_coding",
      gene_name : "TTBK1",
      gene_level : 1,
      hgnc_id : "HGNC:19140",
      havana_gene : "OTTHUMG00000014725.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43295694,
      stop : 43305538,
      direction : "+",
      ID : "ENSG00000137204.15",
      gene_id : "ENSG00000137204.15",
      gene_type : "protein_coding",
      gene_name : "SLC22A7",
      gene_level : 2,
      hgnc_id : "HGNC:10971",
      havana_gene : "OTTHUMG00000014726.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43299710,
      stop : 43308826,
      direction : "-",
      ID : "ENSG00000146215.14",
      gene_id : "ENSG00000146215.14",
      gene_type : "protein_coding",
      gene_name : "CRIP3",
      gene_level : 2,
      hgnc_id : "HGNC:17751",
      havana_gene : "OTTHUMG00000014727.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43307134,
      stop : 43369647,
      direction : "-",
      ID : "ENSG00000171467.16",
      gene_id : "ENSG00000171467.16",
      gene_type : "protein_coding",
      gene_name : "ZNF318",
      gene_level : 2,
      hgnc_id : "HGNC:13578",
      havana_gene : "OTTHUMG00000014732.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43427366,
      stop : 43450427,
      direction : "+",
      ID : "ENSG00000124574.15",
      gene_id : "ENSG00000124574.15",
      gene_type : "protein_coding",
      gene_name : "ABCC10",
      gene_level : 2,
      hgnc_id : "HGNC:52",
      havana_gene : "OTTHUMG00000014733.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43450352,
      stop : 43456632,
      direction : "-",
      ID : "ENSG00000171462.15",
      gene_id : "ENSG00000171462.15",
      gene_type : "protein_coding",
      gene_name : "DLK2",
      gene_level : 2,
      hgnc_id : "HGNC:21113",
      havana_gene : "OTTHUMG00000014735.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43477523,
      stop : 43506556,
      direction : "+",
      ID : "ENSG00000137221.14",
      gene_id : "ENSG00000137221.14",
      gene_type : "protein_coding",
      gene_name : "TJAP1",
      gene_level : 2,
      hgnc_id : "HGNC:17949",
      havana_gene : "OTTHUMG00000014736.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43506969,
      stop : 43510686,
      direction : "-",
      ID : "ENSG00000204052.4",
      gene_id : "ENSG00000204052.4",
      gene_type : "protein_coding",
      gene_name : "LRRC73",
      gene_level : 2,
      hgnc_id : "HGNC:21375",
      havana_gene : "OTTHUMG00000014737.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43509702,
      stop : 43562419,
      direction : "+",
      ID : "ENSG00000171453.20",
      gene_id : "ENSG00000171453.20",
      gene_type : "protein_coding",
      gene_name : "POLR1C",
      gene_level : 2,
      hgnc_id : "HGNC:20194",
      havana_gene : "OTTHUMG00000014739.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43511832,
      stop : 43516985,
      direction : "-",
      ID : "ENSG00000137207.12",
      gene_id : "ENSG00000137207.12",
      gene_type : "protein_coding",
      gene_name : "YIPF3",
      gene_level : 1,
      hgnc_id : "HGNC:21023",
      havana_gene : "OTTHUMG00000014738.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43522334,
      stop : 43576038,
      direction : "-",
      ID : "ENSG00000124571.18",
      gene_id : "ENSG00000124571.18",
      gene_type : "protein_coding",
      gene_name : "XPO5",
      gene_level : 2,
      hgnc_id : "HGNC:17675",
      havana_gene : "OTTHUMG00000014742.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43576185,
      stop : 43620523,
      direction : "+",
      ID : "ENSG00000170734.12",
      gene_id : "ENSG00000170734.12",
      gene_type : "protein_coding",
      gene_name : "POLH",
      gene_level : 2,
      hgnc_id : "HGNC:9181",
      havana_gene : "OTTHUMG00000014743.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43605316,
      stop : 43629264,
      direction : "-",
      ID : "ENSG00000172432.19",
      gene_id : "ENSG00000172432.19",
      gene_type : "protein_coding",
      gene_name : "GTPBP2",
      gene_level : 2,
      hgnc_id : "HGNC:4670",
      havana_gene : "OTTHUMG00000014744.13",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43629540,
      stop : 43640941,
      direction : "+",
      ID : "ENSG00000124688.14",
      gene_id : "ENSG00000124688.14",
      gene_type : "protein_coding",
      gene_name : "MAD2L1BP",
      gene_level : 2,
      hgnc_id : "HGNC:21059",
      havana_gene : "OTTHUMG00000014747.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43645036,
      stop : 43672600,
      direction : "+",
      ID : "ENSG00000172426.16",
      gene_id : "ENSG00000172426.16",
      gene_type : "protein_coding",
      gene_name : "RSPH9",
      gene_level : 2,
      hgnc_id : "HGNC:21057",
      havana_gene : "OTTHUMG00000014746.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43671202,
      stop : 43687791,
      direction : "-",
      ID : "ENSG00000096080.12",
      gene_id : "ENSG00000096080.12",
      gene_type : "protein_coding",
      gene_name : "MRPS18A",
      gene_level : 2,
      hgnc_id : "HGNC:14515",
      havana_gene : "OTTHUMG00000014750.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 43770184,
      stop : 43786487,
      direction : "+",
      ID : "ENSG00000112715.25",
      gene_id : "ENSG00000112715.25",
      gene_type : "protein_coding",
      gene_name : "VEGFA",
      gene_level : 2,
      hgnc_id : "HGNC:12680",
      havana_gene : "OTTHUMG00000014745.14",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44113451,
      stop : 44127452,
      direction : "-",
      ID : "ENSG00000180992.7",
      gene_id : "ENSG00000180992.7",
      gene_type : "protein_coding",
      gene_name : "MRPL14",
      gene_level : 2,
      hgnc_id : "HGNC:14279",
      havana_gene : "OTTHUMG00000014756.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44126914,
      stop : 44155519,
      direction : "+",
      ID : "ENSG00000137216.19",
      gene_id : "ENSG00000137216.19",
      gene_type : "protein_coding",
      gene_name : "TMEM63B",
      gene_level : 2,
      hgnc_id : "HGNC:17735",
      havana_gene : "OTTHUMG00000014757.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44158811,
      stop : 44184401,
      direction : "+",
      ID : "ENSG00000137225.13",
      gene_id : "ENSG00000137225.13",
      gene_type : "protein_coding",
      gene_name : "CAPN11",
      gene_level : 1,
      hgnc_id : "HGNC:1478",
      havana_gene : "OTTHUMG00000014758.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44216926,
      stop : 44218234,
      direction : "+",
      ID : "ENSG00000262179.3",
      gene_id : "ENSG00000262179.3",
      gene_type : "protein_coding",
      gene_name : "MYMX",
      gene_level : 2,
      hgnc_id : "HGNC:52391",
      havana_gene : "OTTHUMG00000177883.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44219553,
      stop : 44234142,
      direction : "+",
      ID : "ENSG00000112759.19",
      gene_id : "ENSG00000112759.19",
      gene_type : "protein_coding",
      gene_name : "SLC29A1",
      gene_level : 2,
      hgnc_id : "HGNC:11003",
      havana_gene : "OTTHUMG00000014759.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44246166,
      stop : 44253888,
      direction : "+",
      ID : "ENSG00000096384.20",
      gene_id : "ENSG00000096384.20",
      gene_type : "protein_coding",
      gene_name : "HSP90AB1",
      gene_level : 2,
      hgnc_id : "HGNC:5258",
      havana_gene : "OTTHUMG00000014761.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44254096,
      stop : 44257890,
      direction : "-",
      ID : "ENSG00000157593.19",
      gene_id : "ENSG00000157593.19",
      gene_type : "protein_coding",
      gene_name : "SLC35B2",
      gene_level : 1,
      hgnc_id : "HGNC:16872",
      havana_gene : "OTTHUMG00000014760.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44258166,
      stop : 44265788,
      direction : "-",
      ID : "ENSG00000146232.17",
      gene_id : "ENSG00000146232.17",
      gene_type : "protein_coding",
      gene_name : "NFKBIE",
      gene_level : 2,
      hgnc_id : "HGNC:7799",
      havana_gene : "OTTHUMG00000014762.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44270450,
      stop : 44307506,
      direction : "+",
      ID : "ENSG00000178233.18",
      gene_id : "ENSG00000178233.18",
      gene_type : "protein_coding",
      gene_name : "TMEM151B",
      gene_level : 2,
      hgnc_id : "HGNC:21315",
      havana_gene : "OTTHUMG00000014765.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44273194,
      stop : 44378957,
      direction : "+",
      ID : "ENSG00000272442.2",
      gene_id : "ENSG00000272442.2",
      gene_type : "protein_coding",
      gene_name : "AL353588.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185389.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44278734,
      stop : 44297698,
      direction : "-",
      ID : "ENSG00000146221.10",
      gene_id : "ENSG00000146221.10",
      gene_type : "protein_coding",
      gene_name : "TCTE1",
      gene_level : 2,
      hgnc_id : "HGNC:11693",
      havana_gene : "OTTHUMG00000014763.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44298731,
      stop : 44313347,
      direction : "-",
      ID : "ENSG00000124608.5",
      gene_id : "ENSG00000124608.5",
      gene_type : "protein_coding",
      gene_name : "AARS2",
      gene_level : 2,
      hgnc_id : "HGNC:21022",
      havana_gene : "OTTHUMG00000014766.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44342650,
      stop : 44380179,
      direction : "+",
      ID : "ENSG00000249481.7",
      gene_id : "ENSG00000249481.7",
      gene_type : "protein_coding",
      gene_name : "SPATS1",
      gene_level : 1,
      hgnc_id : "HGNC:22957",
      havana_gene : "OTTHUMG00000014764.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44387706,
      stop : 44450425,
      direction : "+",
      ID : "ENSG00000096401.8",
      gene_id : "ENSG00000096401.8",
      gene_type : "protein_coding",
      gene_name : "CDC5L",
      gene_level : 2,
      hgnc_id : "HGNC:1743",
      havana_gene : "OTTHUMG00000014767.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 44809317,
      stop : 45377953,
      direction : "-",
      ID : "ENSG00000196284.17",
      gene_id : "ENSG00000196284.17",
      gene_type : "protein_coding",
      gene_name : "SUPT3H",
      gene_level : 2,
      hgnc_id : "HGNC:11466",
      havana_gene : "OTTHUMG00000014773.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 45328157,
      stop : 45664349,
      direction : "+",
      ID : "ENSG00000124813.23",
      gene_id : "ENSG00000124813.23",
      gene_type : "protein_coding",
      gene_name : "RUNX2",
      gene_level : 2,
      hgnc_id : "HGNC:10472",
      havana_gene : "OTTHUMG00000014774.10",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 45880827,
      stop : 46080348,
      direction : "-",
      ID : "ENSG00000112782.19",
      gene_id : "ENSG00000112782.19",
      gene_type : "protein_coding",
      gene_name : "CLIC5",
      gene_level : 2,
      hgnc_id : "HGNC:13517",
      havana_gene : "OTTHUMG00000014775.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46129989,
      stop : 46146688,
      direction : "+",
      ID : "ENSG00000001561.7",
      gene_id : "ENSG00000001561.7",
      gene_type : "protein_coding",
      gene_name : "ENPP4",
      gene_level : 2,
      hgnc_id : "HGNC:3359",
      havana_gene : "OTTHUMG00000014779.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46159185,
      stop : 46170980,
      direction : "-",
      ID : "ENSG00000112796.10",
      gene_id : "ENSG00000112796.10",
      gene_type : "protein_coding",
      gene_name : "ENPP5",
      gene_level : 2,
      hgnc_id : "HGNC:13717",
      havana_gene : "OTTHUMG00000014781.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46220736,
      stop : 46491972,
      direction : "-",
      ID : "ENSG00000172348.15",
      gene_id : "ENSG00000172348.15",
      gene_type : "protein_coding",
      gene_name : "RCAN2",
      gene_level : 2,
      hgnc_id : "HGNC:3041",
      havana_gene : "OTTHUMG00000014782.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46549580,
      stop : 46652830,
      direction : "-",
      ID : "ENSG00000146233.8",
      gene_id : "ENSG00000146233.8",
      gene_type : "protein_coding",
      gene_name : "CYP39A1",
      gene_level : 2,
      hgnc_id : "HGNC:17449",
      havana_gene : "OTTHUMG00000014785.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46652915,
      stop : 46678190,
      direction : "+",
      ID : "ENSG00000153291.16",
      gene_id : "ENSG00000153291.16",
      gene_type : "protein_coding",
      gene_name : "SLC25A27",
      gene_level : 2,
      hgnc_id : "HGNC:21065",
      havana_gene : "OTTHUMG00000014786.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46687875,
      stop : 46704319,
      direction : "+",
      ID : "ENSG00000180113.16",
      gene_id : "ENSG00000180113.16",
      gene_type : "protein_coding",
      gene_name : "TDRD6",
      gene_level : 2,
      hgnc_id : "HGNC:21339",
      havana_gene : "OTTHUMG00000014788.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46704201,
      stop : 46735693,
      direction : "-",
      ID : "ENSG00000146070.17",
      gene_id : "ENSG00000146070.17",
      gene_type : "protein_coding",
      gene_name : "PLA2G7",
      gene_level : 2,
      hgnc_id : "HGNC:9040",
      havana_gene : "OTTHUMG00000014789.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46746917,
      stop : 46759506,
      direction : "+",
      ID : "ENSG00000230062.6",
      gene_id : "ENSG00000230062.6",
      gene_type : "protein_coding",
      gene_name : "ANKRD66",
      gene_level : 1,
      hgnc_id : "HGNC:44669",
      havana_gene : "OTTHUMG00000014791.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46793389,
      stop : 46839778,
      direction : "+",
      ID : "ENSG00000112818.11",
      gene_id : "ENSG00000112818.11",
      gene_type : "protein_coding",
      gene_name : "MEP1A",
      gene_level : 2,
      hgnc_id : "HGNC:7015",
      havana_gene : "OTTHUMG00000014790.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46852522,
      stop : 46954943,
      direction : "-",
      ID : "ENSG00000069122.19",
      gene_id : "ENSG00000069122.19",
      gene_type : "protein_coding",
      gene_name : "ADGRF5",
      gene_level : 2,
      hgnc_id : "HGNC:19030",
      havana_gene : "OTTHUMG00000014793.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 46997708,
      stop : 47042350,
      direction : "-",
      ID : "ENSG00000153292.16",
      gene_id : "ENSG00000153292.16",
      gene_type : "protein_coding",
      gene_name : "ADGRF1",
      gene_level : 2,
      hgnc_id : "HGNC:18990",
      havana_gene : "OTTHUMG00000014795.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 47231532,
      stop : 47309905,
      direction : "-",
      ID : "ENSG00000146072.6",
      gene_id : "ENSG00000146072.6",
      gene_type : "protein_coding",
      gene_name : "TNFRSF21",
      gene_level : 2,
      hgnc_id : "HGNC:13469",
      havana_gene : "OTTHUMG00000014796.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 47477789,
      stop : 47627263,
      direction : "+",
      ID : "ENSG00000198087.7",
      gene_id : "ENSG00000198087.7",
      gene_type : "protein_coding",
      gene_name : "CD2AP",
      gene_level : 2,
      hgnc_id : "HGNC:14258",
      havana_gene : "OTTHUMG00000014799.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 47656436,
      stop : 47697797,
      direction : "+",
      ID : "ENSG00000164393.8",
      gene_id : "ENSG00000164393.8",
      gene_type : "protein_coding",
      gene_name : "ADGRF2",
      gene_level : 2,
      hgnc_id : "HGNC:18991",
      havana_gene : "OTTHUMG00000046168.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 47685864,
      stop : 47722021,
      direction : "+",
      ID : "ENSG00000153294.12",
      gene_id : "ENSG00000153294.12",
      gene_type : "protein_coding",
      gene_name : "ADGRF4",
      gene_level : 2,
      hgnc_id : "HGNC:19011",
      havana_gene : "OTTHUMG00000014800.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 47781982,
      stop : 47832780,
      direction : "+",
      ID : "ENSG00000124818.15",
      gene_id : "ENSG00000124818.15",
      gene_type : "protein_coding",
      gene_name : "OPN5",
      gene_level : 2,
      hgnc_id : "HGNC:19992",
      havana_gene : "OTTHUMG00000014803.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 47856673,
      stop : 48111197,
      direction : "-",
      ID : "ENSG00000244694.8",
      gene_id : "ENSG00000244694.8",
      gene_type : "protein_coding",
      gene_name : "PTCHD4",
      gene_level : 2,
      hgnc_id : "HGNC:21345",
      havana_gene : "OTTHUMG00000150404.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49430360,
      stop : 49463253,
      direction : "-",
      ID : "ENSG00000146085.8",
      gene_id : "ENSG00000146085.8",
      gene_type : "protein_coding",
      gene_name : "MMUT",
      gene_level : 2,
      hgnc_id : "HGNC:7526",
      havana_gene : "OTTHUMG00000014814.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49463370,
      stop : 49493107,
      direction : "+",
      ID : "ENSG00000031691.7",
      gene_id : "ENSG00000031691.7",
      gene_type : "protein_coding",
      gene_name : "CENPQ",
      gene_level : 2,
      hgnc_id : "HGNC:21347",
      havana_gene : "OTTHUMG00000014815.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49499923,
      stop : 49528078,
      direction : "+",
      ID : "ENSG00000203972.10",
      gene_id : "ENSG00000203972.10",
      gene_type : "protein_coding",
      gene_name : "GLYATL3",
      gene_level : 2,
      hgnc_id : "HGNC:21349",
      havana_gene : "OTTHUMG00000014818.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49550646,
      stop : 49561907,
      direction : "+",
      ID : "ENSG00000197261.11",
      gene_id : "ENSG00000197261.11",
      gene_type : "protein_coding",
      gene_name : "C6orf141",
      gene_level : 1,
      hgnc_id : "HGNC:21351",
      havana_gene : "OTTHUMG00000014820.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49605175,
      stop : 49636839,
      direction : "-",
      ID : "ENSG00000112077.17",
      gene_id : "ENSG00000112077.17",
      gene_type : "protein_coding",
      gene_name : "RHAG",
      gene_level : 2,
      hgnc_id : "HGNC:10006",
      havana_gene : "OTTHUMG00000016377.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49692358,
      stop : 49713590,
      direction : "-",
      ID : "ENSG00000124490.14",
      gene_id : "ENSG00000124490.14",
      gene_type : "protein_coding",
      gene_name : "CRISP2",
      gene_level : 2,
      hgnc_id : "HGNC:12024",
      havana_gene : "OTTHUMG00000014822.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49727376,
      stop : 49744437,
      direction : "-",
      ID : "ENSG00000096006.12",
      gene_id : "ENSG00000096006.12",
      gene_type : "protein_coding",
      gene_name : "CRISP3",
      gene_level : 2,
      hgnc_id : "HGNC:16904",
      havana_gene : "OTTHUMG00000014823.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49785660,
      stop : 49787285,
      direction : "-",
      ID : "ENSG00000170950.6",
      gene_id : "ENSG00000170950.6",
      gene_type : "protein_coding",
      gene_name : "PGK2",
      gene_level : 2,
      hgnc_id : "HGNC:8898",
      havana_gene : "OTTHUMG00000014824.4",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49834257,
      stop : 49877096,
      direction : "-",
      ID : "ENSG00000124812.15",
      gene_id : "ENSG00000124812.15",
      gene_type : "protein_coding",
      gene_name : "CRISP1",
      gene_level : 2,
      hgnc_id : "HGNC:304",
      havana_gene : "OTTHUMG00000014827.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49946021,
      stop : 49950265,
      direction : "-",
      ID : "ENSG00000214643.6",
      gene_id : "ENSG00000214643.6",
      gene_type : "protein_coding",
      gene_name : "DEFB133",
      gene_level : 2,
      hgnc_id : "HGNC:31331",
      havana_gene : "OTTHUMG00000187384.3",
      tag : "reference_genome_error"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49960249,
      stop : 49964164,
      direction : "-",
      ID : "ENSG00000177684.4",
      gene_id : "ENSG00000177684.4",
      gene_type : "protein_coding",
      gene_name : "DEFB114",
      gene_level : 2,
      hgnc_id : "HGNC:18095",
      havana_gene : "OTTHUMG00000160209.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 49968677,
      stop : 49969625,
      direction : "-",
      ID : "ENSG00000214642.1",
      gene_id : "ENSG00000214642.1",
      gene_type : "protein_coding",
      gene_name : "DEFB113",
      gene_level : 2,
      hgnc_id : "HGNC:18094",
      havana_gene : "OTTHUMG00000160210.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 50009138,
      stop : 50021994,
      direction : "-",
      ID : "ENSG00000203970.4",
      gene_id : "ENSG00000203970.4",
      gene_type : "protein_coding",
      gene_name : "DEFB110",
      gene_level : 2,
      hgnc_id : "HGNC:18091",
      havana_gene : "OTTHUMG00000160208.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 50042099,
      stop : 50049929,
      direction : "-",
      ID : "ENSG00000180872.7",
      gene_id : "ENSG00000180872.7",
      gene_type : "protein_coding",
      gene_name : "DEFB112",
      gene_level : 2,
      hgnc_id : "HGNC:18093",
      havana_gene : "OTTHUMG00000160215.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 50713526,
      stop : 50773033,
      direction : "+",
      ID : "ENSG00000008197.5",
      gene_id : "ENSG00000008197.5",
      gene_type : "protein_coding",
      gene_name : "TFAP2D",
      gene_level : 2,
      hgnc_id : "HGNC:15581",
      havana_gene : "OTTHUMG00000014832.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 50818723,
      stop : 50847619,
      direction : "+",
      ID : "ENSG00000008196.13",
      gene_id : "ENSG00000008196.13",
      gene_type : "protein_coding",
      gene_name : "TFAP2B",
      gene_level : 2,
      hgnc_id : "HGNC:11743",
      havana_gene : "OTTHUMG00000014836.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 51615299,
      stop : 52087613,
      direction : "-",
      ID : "ENSG00000170927.15",
      gene_id : "ENSG00000170927.15",
      gene_type : "protein_coding",
      gene_name : "PKHD1",
      gene_level : 2,
      hgnc_id : "HGNC:9016",
      havana_gene : "OTTHUMG00000014841.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52186375,
      stop : 52190638,
      direction : "+",
      ID : "ENSG00000112115.7",
      gene_id : "ENSG00000112115.7",
      gene_type : "protein_coding",
      gene_name : "IL17A",
      gene_level : 2,
      hgnc_id : "HGNC:5981",
      havana_gene : "OTTHUMG00000014840.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52236681,
      stop : 52244500,
      direction : "-",
      ID : "ENSG00000112116.10",
      gene_id : "ENSG00000112116.10",
      gene_type : "protein_coding",
      gene_name : "IL17F",
      gene_level : 2,
      hgnc_id : "HGNC:16404",
      havana_gene : "OTTHUMG00000014845.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52264014,
      stop : 52284881,
      direction : "-",
      ID : "ENSG00000112118.20",
      gene_id : "ENSG00000112118.20",
      gene_type : "protein_coding",
      gene_name : "MCM3",
      gene_level : 1,
      hgnc_id : "HGNC:6945",
      havana_gene : "OTTHUMG00000014844.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52361421,
      stop : 52407777,
      direction : "+",
      ID : "ENSG00000170915.9",
      gene_id : "ENSG00000170915.9",
      gene_type : "protein_coding",
      gene_name : "PAQR8",
      gene_level : 2,
      hgnc_id : "HGNC:15708",
      havana_gene : "OTTHUMG00000014846.4",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52362123,
      stop : 52529886,
      direction : "+",
      ID : "ENSG00000096093.16",
      gene_id : "ENSG00000096093.16",
      gene_type : "protein_coding",
      gene_name : "EFHC1",
      gene_level : 2,
      hgnc_id : "HGNC:16406",
      havana_gene : "OTTHUMG00000014848.14",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52497408,
      stop : 52577060,
      direction : "-",
      ID : "ENSG00000065308.5",
      gene_id : "ENSG00000065308.5",
      gene_type : "protein_coding",
      gene_name : "TRAM2",
      gene_level : 2,
      hgnc_id : "HGNC:16855",
      havana_gene : "OTTHUMG00000014850.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52671113,
      stop : 52686588,
      direction : "+",
      ID : "ENSG00000096092.6",
      gene_id : "ENSG00000096092.6",
      gene_type : "protein_coding",
      gene_name : "TMEM14A",
      gene_level : 2,
      hgnc_id : "HGNC:21076",
      havana_gene : "OTTHUMG00000014856.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52750087,
      stop : 52763475,
      direction : "-",
      ID : "ENSG00000244067.3",
      gene_id : "ENSG00000244067.3",
      gene_type : "protein_coding",
      gene_name : "GSTA2",
      gene_level : 2,
      hgnc_id : "HGNC:4627",
      havana_gene : "OTTHUMG00000016263.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52791371,
      stop : 52803860,
      direction : "-",
      ID : "ENSG00000243955.6",
      gene_id : "ENSG00000243955.6",
      gene_type : "protein_coding",
      gene_name : "GSTA1",
      gene_level : 2,
      hgnc_id : "HGNC:4626",
      havana_gene : "OTTHUMG00000014861.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52831655,
      stop : 52840843,
      direction : "-",
      ID : "ENSG00000182793.12",
      gene_id : "ENSG00000182793.12",
      gene_type : "protein_coding",
      gene_name : "GSTA5",
      gene_level : 2,
      hgnc_id : "HGNC:19662",
      havana_gene : "OTTHUMG00000014857.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52896639,
      stop : 52909698,
      direction : "-",
      ID : "ENSG00000174156.15",
      gene_id : "ENSG00000174156.15",
      gene_type : "protein_coding",
      gene_name : "GSTA3",
      gene_level : 2,
      hgnc_id : "HGNC:4628",
      havana_gene : "OTTHUMG00000014865.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 52977948,
      stop : 52995304,
      direction : "-",
      ID : "ENSG00000170899.11",
      gene_id : "ENSG00000170899.11",
      gene_type : "protein_coding",
      gene_name : "GSTA4",
      gene_level : 2,
      hgnc_id : "HGNC:4629",
      havana_gene : "OTTHUMG00000014868.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53001279,
      stop : 53061824,
      direction : "-",
      ID : "ENSG00000112144.16",
      gene_id : "ENSG00000112144.16",
      gene_type : "protein_coding",
      gene_name : "CILK1",
      gene_level : 2,
      hgnc_id : "HGNC:21219",
      havana_gene : "OTTHUMG00000014870.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53041266,
      stop : 53041385,
      direction : "-",
      ID : "ENSG00000288614.1",
      gene_id : "ENSG00000288614.1",
      gene_type : "protein_coding",
      gene_name : "AL031178.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53051991,
      stop : 53100873,
      direction : "+",
      ID : "ENSG00000112146.17",
      gene_id : "ENSG00000112146.17",
      gene_type : "protein_coding",
      gene_name : "FBXO9",
      gene_level : 1,
      hgnc_id : "HGNC:13588",
      havana_gene : "OTTHUMG00000014869.9",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53065602,
      stop : 53065673,
      direction : "+",
      ID : "ENSG00000288646.1",
      gene_id : "ENSG00000288646.1",
      gene_type : "protein_coding",
      gene_name : "AL031178.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53126961,
      stop : 53148841,
      direction : "-",
      ID : "ENSG00000137270.11",
      gene_id : "ENSG00000137270.11",
      gene_type : "protein_coding",
      gene_name : "GCM1",
      gene_level : 2,
      hgnc_id : "HGNC:4197",
      havana_gene : "OTTHUMG00000014871.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53267398,
      stop : 53349179,
      direction : "-",
      ID : "ENSG00000012660.14",
      gene_id : "ENSG00000012660.14",
      gene_type : "protein_coding",
      gene_name : "ELOVL5",
      gene_level : 2,
      hgnc_id : "HGNC:21308",
      havana_gene : "OTTHUMG00000016249.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53497341,
      stop : 53616970,
      direction : "-",
      ID : "ENSG00000001084.13",
      gene_id : "ENSG00000001084.13",
      gene_type : "protein_coding",
      gene_name : "GCLC",
      gene_level : 1,
      hgnc_id : "HGNC:4311",
      havana_gene : "OTTHUMG00000160220.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53647916,
      stop : 53665756,
      direction : "-",
      ID : "ENSG00000124743.6",
      gene_id : "ENSG00000124743.6",
      gene_type : "protein_coding",
      gene_name : "KLHL31",
      gene_level : 2,
      hgnc_id : "HGNC:21353",
      havana_gene : "OTTHUMG00000014882.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53794497,
      stop : 53924125,
      direction : "+",
      ID : "ENSG00000137269.15",
      gene_id : "ENSG00000137269.15",
      gene_type : "protein_coding",
      gene_name : "LRRC1",
      gene_level : 2,
      hgnc_id : "HGNC:14307",
      havana_gene : "OTTHUMG00000014885.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 53929982,
      stop : 54266280,
      direction : "+",
      ID : "ENSG00000146147.15",
      gene_id : "ENSG00000146147.15",
      gene_type : "protein_coding",
      gene_name : "MLIP",
      gene_level : 1,
      hgnc_id : "HGNC:21355",
      havana_gene : "OTTHUMG00000014891.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 54307859,
      stop : 54390142,
      direction : "+",
      ID : "ENSG00000137251.16",
      gene_id : "ENSG00000137251.16",
      gene_type : "protein_coding",
      gene_name : "TINAG",
      gene_level : 2,
      hgnc_id : "HGNC:14599",
      havana_gene : "OTTHUMG00000014893.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 54846771,
      stop : 54945099,
      direction : "+",
      ID : "ENSG00000168143.9",
      gene_id : "ENSG00000168143.9",
      gene_type : "protein_coding",
      gene_name : "FAM83B",
      gene_level : 2,
      hgnc_id : "HGNC:21357",
      havana_gene : "OTTHUMG00000014899.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 55106460,
      stop : 55282617,
      direction : "+",
      ID : "ENSG00000137252.10",
      gene_id : "ENSG00000137252.10",
      gene_type : "protein_coding",
      gene_name : "HCRTR2",
      gene_level : 2,
      hgnc_id : "HGNC:4849",
      havana_gene : "OTTHUMG00000016150.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 55327469,
      stop : 55402493,
      direction : "+",
      ID : "ENSG00000187871.2",
      gene_id : "ENSG00000187871.2",
      gene_type : "protein_coding",
      gene_name : "GFRAL",
      gene_level : 2,
      hgnc_id : "HGNC:32789",
      havana_gene : "OTTHUMG00000014900.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 55434373,
      stop : 55579197,
      direction : "-",
      ID : "ENSG00000146151.14",
      gene_id : "ENSG00000146151.14",
      gene_type : "protein_coding",
      gene_name : "HMGCLL1",
      gene_level : 2,
      hgnc_id : "HGNC:21359",
      havana_gene : "OTTHUMG00000014902.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 55753653,
      stop : 55875590,
      direction : "-",
      ID : "ENSG00000112175.8",
      gene_id : "ENSG00000112175.8",
      gene_type : "protein_coding",
      gene_name : "BMP5",
      gene_level : 2,
      hgnc_id : "HGNC:1072",
      havana_gene : "OTTHUMG00000014903.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 56056590,
      stop : 56394094,
      direction : "-",
      ID : "ENSG00000124749.17",
      gene_id : "ENSG00000124749.17",
      gene_type : "protein_coding",
      gene_name : "COL21A1",
      gene_level : 2,
      hgnc_id : "HGNC:17025",
      havana_gene : "OTTHUMG00000014907.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 56457987,
      stop : 56954830,
      direction : "-",
      ID : "ENSG00000151914.21",
      gene_id : "ENSG00000151914.21",
      gene_type : "protein_coding",
      gene_name : "DST",
      gene_level : 1,
      hgnc_id : "HGNC:1090",
      havana_gene : "OTTHUMG00000014913.26",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 56955107,
      stop : 57027346,
      direction : "+",
      ID : "ENSG00000151917.18",
      gene_id : "ENSG00000151917.18",
      gene_type : "protein_coding",
      gene_name : "BEND6",
      gene_level : 2,
      hgnc_id : "HGNC:20871",
      havana_gene : "OTTHUMG00000014914.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 57046532,
      stop : 57055239,
      direction : "+",
      ID : "ENSG00000168116.14",
      gene_id : "ENSG00000168116.14",
      gene_type : "protein_coding",
      gene_name : "KIAA1586",
      gene_level : 2,
      hgnc_id : "HGNC:21360",
      havana_gene : "OTTHUMG00000014915.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 57086844,
      stop : 57170305,
      direction : "+",
      ID : "ENSG00000112200.17",
      gene_id : "ENSG00000112200.17",
      gene_type : "protein_coding",
      gene_name : "ZNF451",
      gene_level : 2,
      hgnc_id : "HGNC:21091",
      havana_gene : "OTTHUMG00000014916.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 57172326,
      stop : 57189833,
      direction : "+",
      ID : "ENSG00000112208.11",
      gene_id : "ENSG00000112208.11",
      gene_type : "protein_coding",
      gene_name : "BAG2",
      gene_level : 2,
      hgnc_id : "HGNC:938",
      havana_gene : "OTTHUMG00000014919.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 57186992,
      stop : 57222307,
      direction : "-",
      ID : "ENSG00000112210.12",
      gene_id : "ENSG00000112210.12",
      gene_type : "protein_coding",
      gene_name : "RAB23",
      gene_level : 2,
      hgnc_id : "HGNC:14263",
      havana_gene : "OTTHUMG00000014918.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 57314805,
      stop : 57646850,
      direction : "+",
      ID : "ENSG00000146143.19",
      gene_id : "ENSG00000146143.19",
      gene_type : "protein_coding",
      gene_name : "PRIM2",
      gene_level : 2,
      hgnc_id : "HGNC:9370",
      havana_gene : "OTTHUMG00000016190.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 61679961,
      stop : 62286225,
      direction : "-",
      ID : "ENSG00000112232.10",
      gene_id : "ENSG00000112232.10",
      gene_type : "protein_coding",
      gene_name : "KHDRBS2",
      gene_level : 2,
      hgnc_id : "HGNC:18114",
      havana_gene : "OTTHUMG00000014936.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 63211446,
      stop : 63213024,
      direction : "+",
      ID : "ENSG00000198225.5",
      gene_id : "ENSG00000198225.5",
      gene_type : "protein_coding",
      gene_name : "FKBP1C",
      gene_level : 2,
      hgnc_id : "HGNC:21376",
      havana_gene : "OTTHUMG00000014940.1",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 63275951,
      stop : 63319983,
      direction : "-",
      ID : "ENSG00000146166.17",
      gene_id : "ENSG00000146166.17",
      gene_type : "protein_coding",
      gene_name : "LGSN",
      gene_level : 2,
      hgnc_id : "HGNC:21016",
      havana_gene : "OTTHUMG00000014946.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 63521746,
      stop : 63583436,
      direction : "+",
      ID : "ENSG00000112245.12",
      gene_id : "ENSG00000112245.12",
      gene_type : "protein_coding",
      gene_name : "PTP4A1",
      gene_level : 2,
      hgnc_id : "HGNC:9634",
      havana_gene : "OTTHUMG00000014949.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 63572472,
      stop : 63583587,
      direction : "+",
      ID : "ENSG00000285976.2",
      gene_id : "ENSG00000285976.2",
      gene_type : "protein_coding",
      gene_name : "AL135905.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193382.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 63635802,
      stop : 63779336,
      direction : "+",
      ID : "ENSG00000118482.12",
      gene_id : "ENSG00000118482.12",
      gene_type : "protein_coding",
      gene_name : "PHF3",
      gene_level : 1,
      hgnc_id : "HGNC:8921",
      havana_gene : "OTTHUMG00000014952.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 63719980,
      stop : 65707226,
      direction : "-",
      ID : "ENSG00000188107.15",
      gene_id : "ENSG00000188107.15",
      gene_type : "protein_coding",
      gene_name : "EYS",
      gene_level : 1,
      hgnc_id : "HGNC:21555",
      havana_gene : "OTTHUMG00000014971.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 68635282,
      stop : 69389506,
      direction : "+",
      ID : "ENSG00000135298.14",
      gene_id : "ENSG00000135298.14",
      gene_type : "protein_coding",
      gene_name : "ADGRB3",
      gene_level : 1,
      hgnc_id : "HGNC:945",
      havana_gene : "OTTHUMG00000014982.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 69672757,
      stop : 69867236,
      direction : "-",
      ID : "ENSG00000168216.13",
      gene_id : "ENSG00000168216.13",
      gene_type : "protein_coding",
      gene_name : "LMBRD1",
      gene_level : 2,
      hgnc_id : "HGNC:23038",
      havana_gene : "OTTHUMG00000014985.32",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 69866556,
      stop : 70212468,
      direction : "+",
      ID : "ENSG00000082293.13",
      gene_id : "ENSG00000082293.13",
      gene_type : "protein_coding",
      gene_name : "COL19A1",
      gene_level : 2,
      hgnc_id : "HGNC:2196",
      havana_gene : "OTTHUMG00000014987.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 70216040,
      stop : 70303084,
      direction : "-",
      ID : "ENSG00000112280.17",
      gene_id : "ENSG00000112280.17",
      gene_type : "protein_coding",
      gene_name : "COL9A1",
      gene_level : 2,
      hgnc_id : "HGNC:2217",
      havana_gene : "OTTHUMG00000014988.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 70412941,
      stop : 70561174,
      direction : "+",
      ID : "ENSG00000082269.17",
      gene_id : "ENSG00000082269.17",
      gene_type : "protein_coding",
      gene_name : "FAM135A",
      gene_level : 1,
      hgnc_id : "HGNC:21084",
      havana_gene : "OTTHUMG00000014991.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 70566917,
      stop : 70589569,
      direction : "+",
      ID : "ENSG00000154079.6",
      gene_id : "ENSG00000154079.6",
      gene_type : "protein_coding",
      gene_name : "SDHAF4",
      gene_level : 2,
      hgnc_id : "HGNC:20957",
      havana_gene : "OTTHUMG00000014992.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 70667776,
      stop : 70862011,
      direction : "+",
      ID : "ENSG00000112305.15",
      gene_id : "ENSG00000112305.15",
      gene_type : "protein_coding",
      gene_name : "SMAP1",
      gene_level : 2,
      hgnc_id : "HGNC:19651",
      havana_gene : "OTTHUMG00000014996.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 70856679,
      stop : 70957060,
      direction : "-",
      ID : "ENSG00000112309.11",
      gene_id : "ENSG00000112309.11",
      gene_type : "protein_coding",
      gene_name : "B3GAT2",
      gene_level : 2,
      hgnc_id : "HGNC:922",
      havana_gene : "OTTHUMG00000014997.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 71288811,
      stop : 71309059,
      direction : "+",
      ID : "ENSG00000119900.9",
      gene_id : "ENSG00000119900.9",
      gene_type : "protein_coding",
      gene_name : "OGFRL1",
      gene_level : 2,
      hgnc_id : "HGNC:21378",
      havana_gene : "OTTHUMG00000015000.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 71886703,
      stop : 72403143,
      direction : "+",
      ID : "ENSG00000079841.18",
      gene_id : "ENSG00000079841.18",
      gene_type : "protein_coding",
      gene_name : "RIMS1",
      gene_level : 1,
      hgnc_id : "HGNC:17282",
      havana_gene : "OTTHUMG00000015009.12",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 72621792,
      stop : 73198853,
      direction : "+",
      ID : "ENSG00000185760.17",
      gene_id : "ENSG00000185760.17",
      gene_type : "protein_coding",
      gene_name : "KCNQ5",
      gene_level : 1,
      hgnc_id : "HGNC:6299",
      havana_gene : "OTTHUMG00000015020.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73209746,
      stop : 73263196,
      direction : "-",
      ID : "ENSG00000243501.5",
      gene_id : "ENSG00000243501.5",
      gene_type : "protein_coding",
      gene_name : "AL365232.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168294.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73223544,
      stop : 73225770,
      direction : "-",
      ID : "ENSG00000256980.5",
      gene_id : "ENSG00000256980.5",
      gene_type : "protein_coding",
      gene_name : "KHDC1L",
      gene_level : 2,
      hgnc_id : "HGNC:37274",
      havana_gene : "OTTHUMG00000132474.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73241314,
      stop : 73310365,
      direction : "-",
      ID : "ENSG00000135314.12",
      gene_id : "ENSG00000135314.12",
      gene_type : "protein_coding",
      gene_name : "KHDC1",
      gene_level : 2,
      hgnc_id : "HGNC:21366",
      havana_gene : "OTTHUMG00000015030.15",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73353063,
      stop : 73354276,
      direction : "-",
      ID : "ENSG00000203909.4",
      gene_id : "ENSG00000203909.4",
      gene_type : "protein_coding",
      gene_name : "DPPA5",
      gene_level : 2,
      hgnc_id : "HGNC:19201",
      havana_gene : "OTTHUMG00000015025.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73362658,
      stop : 73364171,
      direction : "+",
      ID : "ENSG00000203908.4",
      gene_id : "ENSG00000203908.4",
      gene_type : "protein_coding",
      gene_name : "KHDC3L",
      gene_level : 2,
      hgnc_id : "HGNC:33699",
      havana_gene : "OTTHUMG00000015024.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73368555,
      stop : 73395133,
      direction : "-",
      ID : "ENSG00000203907.10",
      gene_id : "ENSG00000203907.10",
      gene_type : "protein_coding",
      gene_name : "OOEP",
      gene_level : 1,
      hgnc_id : "HGNC:21382",
      havana_gene : "OTTHUMG00000150057.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73394828,
      stop : 73417566,
      direction : "+",
      ID : "ENSG00000080007.8",
      gene_id : "ENSG00000080007.8",
      gene_type : "protein_coding",
      gene_name : "DDX43",
      gene_level : 2,
      hgnc_id : "HGNC:18677",
      havana_gene : "OTTHUMG00000015033.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73413515,
      stop : 73452297,
      direction : "-",
      ID : "ENSG00000164430.17",
      gene_id : "ENSG00000164430.17",
      gene_type : "protein_coding",
      gene_name : "CGAS",
      gene_level : 2,
      hgnc_id : "HGNC:21367",
      havana_gene : "OTTHUMG00000015034.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73461578,
      stop : 73509236,
      direction : "+",
      ID : "ENSG00000135297.17",
      gene_id : "ENSG00000135297.17",
      gene_type : "protein_coding",
      gene_name : "MTO1",
      gene_level : 2,
      hgnc_id : "HGNC:19261",
      havana_gene : "OTTHUMG00000015032.16",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73489308,
      stop : 73525587,
      direction : "-",
      ID : "ENSG00000156508.19",
      gene_id : "ENSG00000156508.19",
      gene_type : "protein_coding",
      gene_name : "EEF1A1",
      gene_level : 2,
      hgnc_id : "HGNC:3189",
      havana_gene : "OTTHUMG00000015031.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73593379,
      stop : 73653992,
      direction : "-",
      ID : "ENSG00000119899.13",
      gene_id : "ENSG00000119899.13",
      gene_type : "protein_coding",
      gene_name : "SLC17A5",
      gene_level : 2,
      hgnc_id : "HGNC:10933",
      havana_gene : "OTTHUMG00000015039.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 73695785,
      stop : 73828316,
      direction : "+",
      ID : "ENSG00000156535.15",
      gene_id : "ENSG00000156535.15",
      gene_type : "protein_coding",
      gene_name : "CD109",
      gene_level : 2,
      hgnc_id : "HGNC:21685",
      havana_gene : "OTTHUMG00000015040.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75084326,
      stop : 75206267,
      direction : "-",
      ID : "ENSG00000111799.22",
      gene_id : "ENSG00000111799.22",
      gene_type : "protein_coding",
      gene_name : "COL12A1",
      gene_level : 1,
      hgnc_id : "HGNC:2188",
      havana_gene : "OTTHUMG00000015051.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75237675,
      stop : 75250323,
      direction : "-",
      ID : "ENSG00000112695.11",
      gene_id : "ENSG00000112695.11",
      gene_type : "protein_coding",
      gene_name : "COX7A2",
      gene_level : 1,
      hgnc_id : "HGNC:2288",
      havana_gene : "OTTHUMG00000015049.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75252924,
      stop : 75284948,
      direction : "-",
      ID : "ENSG00000112697.17",
      gene_id : "ENSG00000112697.17",
      gene_type : "protein_coding",
      gene_name : "TMEM30A",
      gene_level : 2,
      hgnc_id : "HGNC:16667",
      havana_gene : "OTTHUMG00000015050.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75291859,
      stop : 75493800,
      direction : "-",
      ID : "ENSG00000118407.15",
      gene_id : "ENSG00000118407.15",
      gene_type : "protein_coding",
      gene_name : "FILIP1",
      gene_level : 2,
      hgnc_id : "HGNC:21015",
      havana_gene : "OTTHUMG00000015056.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75601509,
      stop : 75718281,
      direction : "+",
      ID : "ENSG00000112701.18",
      gene_id : "ENSG00000112701.18",
      gene_type : "protein_coding",
      gene_name : "SENP6",
      gene_level : 2,
      hgnc_id : "HGNC:20944",
      havana_gene : "OTTHUMG00000015060.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75749192,
      stop : 75919537,
      direction : "+",
      ID : "ENSG00000196586.16",
      gene_id : "ENSG00000196586.16",
      gene_type : "protein_coding",
      gene_name : "MYO6",
      gene_level : 2,
      hgnc_id : "HGNC:7605",
      havana_gene : "OTTHUMG00000015061.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 75921114,
      stop : 76072678,
      direction : "-",
      ID : "ENSG00000112706.12",
      gene_id : "ENSG00000112706.12",
      gene_type : "protein_coding",
      gene_name : "IMPG1",
      gene_level : 2,
      hgnc_id : "HGNC:6055",
      havana_gene : "OTTHUMG00000015063.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 77460924,
      stop : 77463491,
      direction : "-",
      ID : "ENSG00000135312.7",
      gene_id : "ENSG00000135312.7",
      gene_type : "protein_coding",
      gene_name : "HTR1B",
      gene_level : 2,
      hgnc_id : "HGNC:5287",
      havana_gene : "OTTHUMG00000015066.2",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 77650274,
      stop : 77927028,
      direction : "+",
      ID : "ENSG00000269964.3",
      gene_id : "ENSG00000269964.3",
      gene_type : "protein_coding",
      gene_name : "MEI4",
      gene_level : 2,
      hgnc_id : "HGNC:43638",
      havana_gene : "OTTHUMG00000153472.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 78867551,
      stop : 78946440,
      direction : "+",
      ID : "ENSG00000146243.14",
      gene_id : "ENSG00000146243.14",
      gene_type : "protein_coding",
      gene_name : "IRAK1BP1",
      gene_level : 2,
      hgnc_id : "HGNC:17368",
      havana_gene : "OTTHUMG00000015070.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 78934419,
      stop : 79078254,
      direction : "-",
      ID : "ENSG00000146247.14",
      gene_id : "ENSG00000146247.14",
      gene_type : "protein_coding",
      gene_name : "PHIP",
      gene_level : 2,
      hgnc_id : "HGNC:15673",
      havana_gene : "OTTHUMG00000015071.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 79201245,
      stop : 79234738,
      direction : "-",
      ID : "ENSG00000118418.14",
      gene_id : "ENSG00000118418.14",
      gene_type : "protein_coding",
      gene_name : "HMGN3",
      gene_level : 2,
      hgnc_id : "HGNC:12312",
      havana_gene : "OTTHUMG00000015073.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 79484991,
      stop : 79537458,
      direction : "-",
      ID : "ENSG00000135338.14",
      gene_id : "ENSG00000135338.14",
      gene_type : "protein_coding",
      gene_name : "LCA5",
      gene_level : 2,
      hgnc_id : "HGNC:31923",
      havana_gene : "OTTHUMG00000015080.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 79631329,
      stop : 79703655,
      direction : "+",
      ID : "ENSG00000198478.8",
      gene_id : "ENSG00000198478.8",
      gene_type : "protein_coding",
      gene_name : "SH3BGRL2",
      gene_level : 2,
      hgnc_id : "HGNC:15567",
      havana_gene : "OTTHUMG00000015081.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 79914814,
      stop : 79947553,
      direction : "-",
      ID : "ENSG00000118402.6",
      gene_id : "ENSG00000118402.6",
      gene_type : "protein_coding",
      gene_name : "ELOVL4",
      gene_level : 2,
      hgnc_id : "HGNC:14415",
      havana_gene : "OTTHUMG00000015087.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 80003887,
      stop : 80042527,
      direction : "+",
      ID : "ENSG00000112742.10",
      gene_id : "ENSG00000112742.10",
      gene_type : "protein_coding",
      gene_name : "TTK",
      gene_level : 1,
      hgnc_id : "HGNC:12401",
      havana_gene : "OTTHUMG00000015088.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 80106647,
      stop : 80346270,
      direction : "+",
      ID : "ENSG00000083123.15",
      gene_id : "ENSG00000083123.15",
      gene_type : "protein_coding",
      gene_name : "BCKDHB",
      gene_level : 2,
      hgnc_id : "HGNC:987",
      havana_gene : "OTTHUMG00000016430.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 81491439,
      stop : 81752774,
      direction : "-",
      ID : "ENSG00000112773.16",
      gene_id : "ENSG00000112773.16",
      gene_type : "protein_coding",
      gene_name : "TENT5A",
      gene_level : 2,
      hgnc_id : "HGNC:18345",
      havana_gene : "OTTHUMG00000015097.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 82169986,
      stop : 82247754,
      direction : "-",
      ID : "ENSG00000005700.15",
      gene_id : "ENSG00000005700.15",
      gene_type : "protein_coding",
      gene_name : "IBTK",
      gene_level : 2,
      hgnc_id : "HGNC:17853",
      havana_gene : "OTTHUMG00000015102.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 82363206,
      stop : 82367420,
      direction : "+",
      ID : "ENSG00000146242.9",
      gene_id : "ENSG00000146242.9",
      gene_type : "protein_coding",
      gene_name : "TPBG",
      gene_level : 2,
      hgnc_id : "HGNC:12004",
      havana_gene : "OTTHUMG00000015103.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 82892390,
      stop : 83065841,
      direction : "-",
      ID : "ENSG00000118420.17",
      gene_id : "ENSG00000118420.17",
      gene_type : "protein_coding",
      gene_name : "UBE3D",
      gene_level : 2,
      hgnc_id : "HGNC:21381",
      havana_gene : "OTTHUMG00000015108.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83067666,
      stop : 83171350,
      direction : "+",
      ID : "ENSG00000083097.14",
      gene_id : "ENSG00000083097.14",
      gene_type : "protein_coding",
      gene_name : "DOP1A",
      gene_level : 2,
      hgnc_id : "HGNC:21194",
      havana_gene : "OTTHUMG00000016365.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83161150,
      stop : 83193936,
      direction : "-",
      ID : "ENSG00000013375.16",
      gene_id : "ENSG00000013375.16",
      gene_type : "protein_coding",
      gene_name : "PGM3",
      gene_level : 1,
      hgnc_id : "HGNC:8907",
      havana_gene : "OTTHUMG00000015110.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83193357,
      stop : 83198935,
      direction : "+",
      ID : "ENSG00000013392.8",
      gene_id : "ENSG00000013392.8",
      gene_type : "protein_coding",
      gene_name : "RWDD2A",
      gene_level : 2,
      hgnc_id : "HGNC:21385",
      havana_gene : "OTTHUMG00000015109.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83210402,
      stop : 83431051,
      direction : "-",
      ID : "ENSG00000065833.9",
      gene_id : "ENSG00000065833.9",
      gene_type : "protein_coding",
      gene_name : "ME1",
      gene_level : 2,
      hgnc_id : "HGNC:6983",
      havana_gene : "OTTHUMG00000015111.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83512534,
      stop : 83525704,
      direction : "+",
      ID : "ENSG00000146250.7",
      gene_id : "ENSG00000146250.7",
      gene_type : "protein_coding",
      gene_name : "PRSS35",
      gene_level : 2,
      hgnc_id : "HGNC:21387",
      havana_gene : "OTTHUMG00000015113.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83552880,
      stop : 83709691,
      direction : "-",
      ID : "ENSG00000065609.14",
      gene_id : "ENSG00000065609.14",
      gene_type : "protein_coding",
      gene_name : "SNAP91",
      gene_level : 2,
      hgnc_id : "HGNC:14986",
      havana_gene : "OTTHUMG00000015114.10",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83853266,
      stop : 83857515,
      direction : "+",
      ID : "ENSG00000203877.8",
      gene_id : "ENSG00000203877.8",
      gene_type : "protein_coding",
      gene_name : "RIPPLY2",
      gene_level : 2,
      hgnc_id : "HGNC:21390",
      havana_gene : "OTTHUMG00000015117.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 83859656,
      stop : 83967423,
      direction : "+",
      ID : "ENSG00000065615.14",
      gene_id : "ENSG00000065615.14",
      gene_type : "protein_coding",
      gene_name : "CYB5R4",
      gene_level : 2,
      hgnc_id : "HGNC:20147",
      havana_gene : "OTTHUMG00000015118.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 84033772,
      stop : 84090881,
      direction : "+",
      ID : "ENSG00000135324.6",
      gene_id : "ENSG00000135324.6",
      gene_type : "protein_coding",
      gene_name : "MRAP2",
      gene_level : 2,
      hgnc_id : "HGNC:21232",
      havana_gene : "OTTHUMG00000015121.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 84124241,
      stop : 84227643,
      direction : "-",
      ID : "ENSG00000135315.12",
      gene_id : "ENSG00000135315.12",
      gene_type : "protein_coding",
      gene_name : "CEP162",
      gene_level : 2,
      hgnc_id : "HGNC:21107",
      havana_gene : "OTTHUMG00000015123.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 84687351,
      stop : 84764598,
      direction : "-",
      ID : "ENSG00000112837.17",
      gene_id : "ENSG00000112837.17",
      gene_type : "protein_coding",
      gene_name : "TBX18",
      gene_level : 2,
      hgnc_id : "HGNC:11595",
      havana_gene : "OTTHUMG00000015129.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 85449584,
      stop : 85495791,
      direction : "+",
      ID : "ENSG00000135318.12",
      gene_id : "ENSG00000135318.12",
      gene_type : "protein_coding",
      gene_name : "NT5E",
      gene_level : 2,
      hgnc_id : "HGNC:8021",
      havana_gene : "OTTHUMG00000015139.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 85505496,
      stop : 85594156,
      direction : "-",
      ID : "ENSG00000135317.13",
      gene_id : "ENSG00000135317.13",
      gene_type : "protein_coding",
      gene_name : "SNX14",
      gene_level : 2,
      hgnc_id : "HGNC:14977",
      havana_gene : "OTTHUMG00000015140.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 85557978,
      stop : 85615234,
      direction : "-",
      ID : "ENSG00000271793.1",
      gene_id : "ENSG00000271793.1",
      gene_type : "protein_coding",
      gene_name : "AL589666.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185329.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 85607779,
      stop : 85644063,
      direction : "-",
      ID : "ENSG00000135316.19",
      gene_id : "ENSG00000135316.19",
      gene_type : "protein_coding",
      gene_name : "SYNCRIP",
      gene_level : 2,
      hgnc_id : "HGNC:16918",
      havana_gene : "OTTHUMG00000015141.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 86937528,
      stop : 87016679,
      direction : "+",
      ID : "ENSG00000168830.8",
      gene_id : "ENSG00000168830.8",
      gene_type : "protein_coding",
      gene_name : "HTR1E",
      gene_level : 2,
      hgnc_id : "HGNC:5291",
      havana_gene : "OTTHUMG00000015154.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87085498,
      stop : 87095106,
      direction : "-",
      ID : "ENSG00000135346.9",
      gene_id : "ENSG00000135346.9",
      gene_type : "protein_coding",
      gene_name : "CGA",
      gene_level : 2,
      hgnc_id : "HGNC:1885",
      havana_gene : "OTTHUMG00000015161.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87152833,
      stop : 87265943,
      direction : "+",
      ID : "ENSG00000188994.13",
      gene_id : "ENSG00000188994.13",
      gene_type : "protein_coding",
      gene_name : "ZNF292",
      gene_level : 1,
      hgnc_id : "HGNC:18410",
      havana_gene : "OTTHUMG00000015164.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87282980,
      stop : 87329278,
      direction : "-",
      ID : "ENSG00000164411.12",
      gene_id : "ENSG00000164411.12",
      gene_type : "protein_coding",
      gene_name : "GJB7",
      gene_level : 2,
      hgnc_id : "HGNC:16690",
      havana_gene : "OTTHUMG00000015166.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87322583,
      stop : 87399749,
      direction : "+",
      ID : "ENSG00000111850.11",
      gene_id : "ENSG00000111850.11",
      gene_type : "protein_coding",
      gene_name : "SMIM8",
      gene_level : 1,
      hgnc_id : "HGNC:21401",
      havana_gene : "OTTHUMG00000015168.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87344813,
      stop : 87365463,
      direction : "+",
      ID : "ENSG00000203872.7",
      gene_id : "ENSG00000203872.7",
      gene_type : "protein_coding",
      gene_name : "C6orf163",
      gene_level : 1,
      hgnc_id : "HGNC:21403",
      havana_gene : "OTTHUMG00000015169.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87407972,
      stop : 87464465,
      direction : "+",
      ID : "ENSG00000272514.6",
      gene_id : "ENSG00000272514.6",
      gene_type : "protein_coding",
      gene_name : "CFAP206",
      gene_level : 2,
      hgnc_id : "HGNC:21405",
      havana_gene : "OTTHUMG00000015173.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87408012,
      stop : 87511634,
      direction : "+",
      ID : "ENSG00000213204.8",
      gene_id : "ENSG00000213204.8",
      gene_type : "protein_coding",
      gene_name : "AL049697.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000185391.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87470623,
      stop : 87512336,
      direction : "+",
      ID : "ENSG00000164414.18",
      gene_id : "ENSG00000164414.18",
      gene_type : "protein_coding",
      gene_name : "SLC35A1",
      gene_level : 2,
      hgnc_id : "HGNC:11021",
      havana_gene : "OTTHUMG00000015177.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87513938,
      stop : 87589987,
      direction : "-",
      ID : "ENSG00000146282.18",
      gene_id : "ENSG00000146282.18",
      gene_type : "protein_coding",
      gene_name : "RARS2",
      gene_level : 2,
      hgnc_id : "HGNC:21406",
      havana_gene : "OTTHUMG00000015178.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87590067,
      stop : 87667453,
      direction : "+",
      ID : "ENSG00000135336.16",
      gene_id : "ENSG00000135336.16",
      gene_type : "protein_coding",
      gene_name : "ORC3",
      gene_level : 2,
      hgnc_id : "HGNC:8489",
      havana_gene : "OTTHUMG00000015179.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 87674860,
      stop : 87702233,
      direction : "-",
      ID : "ENSG00000135334.9",
      gene_id : "ENSG00000135334.9",
      gene_type : "protein_coding",
      gene_name : "AKIRIN2",
      gene_level : 2,
      hgnc_id : "HGNC:21407",
      havana_gene : "OTTHUMG00000015180.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 88047841,
      stop : 88066838,
      direction : "+",
      ID : "ENSG00000118434.9",
      gene_id : "ENSG00000118434.9",
      gene_type : "protein_coding",
      gene_name : "SPACA1",
      gene_level : 2,
      hgnc_id : "HGNC:14967",
      havana_gene : "OTTHUMG00000015183.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 88139864,
      stop : 88166359,
      direction : "-",
      ID : "ENSG00000118432.12",
      gene_id : "ENSG00000118432.12",
      gene_type : "protein_coding",
      gene_name : "CNR1",
      gene_level : 2,
      hgnc_id : "HGNC:2159",
      havana_gene : "OTTHUMG00000015184.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 88609897,
      stop : 88963618,
      direction : "-",
      ID : "ENSG00000111880.16",
      gene_id : "ENSG00000111880.16",
      gene_type : "protein_coding",
      gene_name : "RNGTT",
      gene_level : 2,
      hgnc_id : "HGNC:10073",
      havana_gene : "OTTHUMG00000015190.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89080751,
      stop : 89085160,
      direction : "+",
      ID : "ENSG00000146278.11",
      gene_id : "ENSG00000146278.11",
      gene_type : "protein_coding",
      gene_name : "PNRC1",
      gene_level : 1,
      hgnc_id : "HGNC:17278",
      havana_gene : "OTTHUMG00000015191.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89095959,
      stop : 89118071,
      direction : "-",
      ID : "ENSG00000154548.9",
      gene_id : "ENSG00000154548.9",
      gene_type : "protein_coding",
      gene_name : "SRSF12",
      gene_level : 2,
      hgnc_id : "HGNC:21220",
      havana_gene : "OTTHUMG00000015192.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89146055,
      stop : 89165565,
      direction : "+",
      ID : "ENSG00000146281.6",
      gene_id : "ENSG00000146281.6",
      gene_type : "protein_coding",
      gene_name : "PM20D2",
      gene_level : 2,
      hgnc_id : "HGNC:21408",
      havana_gene : "OTTHUMG00000015193.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89177504,
      stop : 89231278,
      direction : "-",
      ID : "ENSG00000146276.12",
      gene_id : "ENSG00000146276.12",
      gene_type : "protein_coding",
      gene_name : "GABRR1",
      gene_level : 2,
      hgnc_id : "HGNC:4090",
      havana_gene : "OTTHUMG00000015195.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89254464,
      stop : 89315299,
      direction : "-",
      ID : "ENSG00000111886.11",
      gene_id : "ENSG00000111886.11",
      gene_type : "protein_coding",
      gene_name : "GABRR2",
      gene_level : 2,
      hgnc_id : "HGNC:4091",
      havana_gene : "OTTHUMG00000015198.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89326625,
      stop : 89352722,
      direction : "-",
      ID : "ENSG00000198833.7",
      gene_id : "ENSG00000198833.7",
      gene_type : "protein_coding",
      gene_name : "UBE2J1",
      gene_level : 2,
      hgnc_id : "HGNC:17598",
      havana_gene : "OTTHUMG00000016337.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89364616,
      stop : 89412273,
      direction : "-",
      ID : "ENSG00000025039.15",
      gene_id : "ENSG00000025039.15",
      gene_type : "protein_coding",
      gene_name : "RRAGD",
      gene_level : 2,
      hgnc_id : "HGNC:19903",
      havana_gene : "OTTHUMG00000015200.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89433152,
      stop : 89633834,
      direction : "+",
      ID : "ENSG00000135299.17",
      gene_id : "ENSG00000135299.17",
      gene_type : "protein_coding",
      gene_name : "ANKRD6",
      gene_level : 1,
      hgnc_id : "HGNC:17280",
      havana_gene : "OTTHUMG00000015202.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89568144,
      stop : 89638749,
      direction : "-",
      ID : "ENSG00000083099.11",
      gene_id : "ENSG00000083099.11",
      gene_type : "protein_coding",
      gene_name : "LYRM2",
      gene_level : 1,
      hgnc_id : "HGNC:25229",
      havana_gene : "OTTHUMG00000015203.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89642498,
      stop : 89819794,
      direction : "-",
      ID : "ENSG00000112159.12",
      gene_id : "ENSG00000112159.12",
      gene_type : "protein_coding",
      gene_name : "MDN1",
      gene_level : 2,
      hgnc_id : "HGNC:18302",
      havana_gene : "OTTHUMG00000015213.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89829894,
      stop : 89874436,
      direction : "+",
      ID : "ENSG00000118412.13",
      gene_id : "ENSG00000118412.13",
      gene_type : "protein_coding",
      gene_name : "CASP8AP2",
      gene_level : 2,
      hgnc_id : "HGNC:1510",
      havana_gene : "OTTHUMG00000015212.7",
      tag : "ncRNA_host, reference_genome_error"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89894469,
      stop : 89921760,
      direction : "+",
      ID : "ENSG00000135355.4",
      gene_id : "ENSG00000135355.4",
      gene_type : "protein_coding",
      gene_name : "GJA10",
      gene_level : 2,
      hgnc_id : "HGNC:16995",
      havana_gene : "OTTHUMG00000015210.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 89926528,
      stop : 90296908,
      direction : "-",
      ID : "ENSG00000112182.15",
      gene_id : "ENSG00000112182.15",
      gene_type : "protein_coding",
      gene_name : "BACH2",
      gene_level : 2,
      hgnc_id : "HGNC:14078",
      havana_gene : "OTTHUMG00000015216.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 90513573,
      stop : 90587072,
      direction : "-",
      ID : "ENSG00000135341.18",
      gene_id : "ENSG00000135341.18",
      gene_type : "protein_coding",
      gene_name : "MAP3K7",
      gene_level : 2,
      hgnc_id : "HGNC:6859",
      havana_gene : "OTTHUMG00000015217.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 93240020,
      stop : 93419687,
      direction : "-",
      ID : "ENSG00000135333.15",
      gene_id : "ENSG00000135333.15",
      gene_type : "protein_coding",
      gene_name : "EPHA7",
      gene_level : 2,
      hgnc_id : "HGNC:3390",
      havana_gene : "OTTHUMG00000015228.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 95577535,
      stop : 95609452,
      direction : "+",
      ID : "ENSG00000172469.16",
      gene_id : "ENSG00000172469.16",
      gene_type : "protein_coding",
      gene_name : "MANEA",
      gene_level : 2,
      hgnc_id : "HGNC:21072",
      havana_gene : "OTTHUMG00000016296.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 96015974,
      stop : 96215612,
      direction : "+",
      ID : "ENSG00000172461.11",
      gene_id : "ENSG00000172461.11",
      gene_type : "protein_coding",
      gene_name : "FUT9",
      gene_level : 2,
      hgnc_id : "HGNC:4020",
      havana_gene : "OTTHUMG00000015236.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 96521595,
      stop : 96555276,
      direction : "+",
      ID : "ENSG00000014123.10",
      gene_id : "ENSG00000014123.10",
      gene_type : "protein_coding",
      gene_name : "UFL1",
      gene_level : 2,
      hgnc_id : "HGNC:23039",
      havana_gene : "OTTHUMG00000015238.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 96562548,
      stop : 96616636,
      direction : "+",
      ID : "ENSG00000112214.10",
      gene_id : "ENSG00000112214.10",
      gene_type : "protein_coding",
      gene_name : "FHL5",
      gene_level : 2,
      hgnc_id : "HGNC:17371",
      havana_gene : "OTTHUMG00000015239.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 96794125,
      stop : 96837477,
      direction : "-",
      ID : "ENSG00000112218.9",
      gene_id : "ENSG00000112218.9",
      gene_type : "protein_coding",
      gene_name : "GPR63",
      gene_level : 2,
      hgnc_id : "HGNC:13302",
      havana_gene : "OTTHUMG00000015245.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 96889315,
      stop : 96897891,
      direction : "-",
      ID : "ENSG00000123545.6",
      gene_id : "ENSG00000123545.6",
      gene_type : "protein_coding",
      gene_name : "NDUFAF4",
      gene_level : 2,
      hgnc_id : "HGNC:21034",
      havana_gene : "OTTHUMG00000015246.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 96924620,
      stop : 97140754,
      direction : "+",
      ID : "ENSG00000186231.17",
      gene_id : "ENSG00000186231.17",
      gene_type : "protein_coding",
      gene_name : "KLHL32",
      gene_level : 2,
      hgnc_id : "HGNC:21221",
      havana_gene : "OTTHUMG00000015247.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 97142161,
      stop : 97283217,
      direction : "-",
      ID : "ENSG00000146263.11",
      gene_id : "ENSG00000146263.11",
      gene_type : "protein_coding",
      gene_name : "MMS22L",
      gene_level : 1,
      hgnc_id : "HGNC:21475",
      havana_gene : "OTTHUMG00000015248.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 98834574,
      stop : 98839458,
      direction : "+",
      ID : "ENSG00000184486.10",
      gene_id : "ENSG00000184486.10",
      gene_type : "protein_coding",
      gene_name : "POU3F2",
      gene_level : 2,
      hgnc_id : "HGNC:9215",
      havana_gene : "OTTHUMG00000015258.4",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 98868535,
      stop : 98948006,
      direction : "-",
      ID : "ENSG00000112234.9",
      gene_id : "ENSG00000112234.9",
      gene_type : "protein_coding",
      gene_name : "FBXL4",
      gene_level : 2,
      hgnc_id : "HGNC:13601",
      havana_gene : "OTTHUMG00000015259.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99271168,
      stop : 99350062,
      direction : "-",
      ID : "ENSG00000146267.12",
      gene_id : "ENSG00000146267.12",
      gene_type : "protein_coding",
      gene_name : "FAXC",
      gene_level : 2,
      hgnc_id : "HGNC:20742",
      havana_gene : "OTTHUMG00000015261.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99369401,
      stop : 99394195,
      direction : "-",
      ID : "ENSG00000132423.12",
      gene_id : "ENSG00000132423.12",
      gene_type : "protein_coding",
      gene_name : "COQ3",
      gene_level : 2,
      hgnc_id : "HGNC:18175",
      havana_gene : "OTTHUMG00000015264.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99397629,
      stop : 99425331,
      direction : "-",
      ID : "ENSG00000132424.17",
      gene_id : "ENSG00000132424.17",
      gene_type : "protein_coding",
      gene_name : "PNISR",
      gene_level : 2,
      hgnc_id : "HGNC:21222",
      havana_gene : "OTTHUMG00000015262.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99432325,
      stop : 99521728,
      direction : "-",
      ID : "ENSG00000123552.18",
      gene_id : "ENSG00000123552.18",
      gene_type : "protein_coding",
      gene_name : "USP45",
      gene_level : 2,
      hgnc_id : "HGNC:20080",
      havana_gene : "OTTHUMG00000015267.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99520976,
      stop : 99589899,
      direction : "+",
      ID : "ENSG00000279170.3",
      gene_id : "ENSG00000279170.3",
      gene_type : "protein_coding",
      gene_name : "TSTD3",
      gene_level : 2,
      hgnc_id : "HGNC:40910",
      havana_gene : "OTTHUMG00000015265.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99542387,
      stop : 99568825,
      direction : "-",
      ID : "ENSG00000112237.13",
      gene_id : "ENSG00000112237.13",
      gene_type : "protein_coding",
      gene_name : "CCNC",
      gene_level : 1,
      hgnc_id : "HGNC:1581",
      havana_gene : "OTTHUMG00000015268.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99606774,
      stop : 99615578,
      direction : "+",
      ID : "ENSG00000112238.12",
      gene_id : "ENSG00000112238.12",
      gene_type : "protein_coding",
      gene_name : "PRDM13",
      gene_level : 2,
      hgnc_id : "HGNC:13998",
      havana_gene : "OTTHUMG00000015269.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 99918519,
      stop : 99994247,
      direction : "-",
      ID : "ENSG00000152034.11",
      gene_id : "ENSG00000152034.11",
      gene_type : "protein_coding",
      gene_name : "MCHR2",
      gene_level : 2,
      hgnc_id : "HGNC:20867",
      havana_gene : "OTTHUMG00000015270.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 100385009,
      stop : 100464921,
      direction : "-",
      ID : "ENSG00000112246.10",
      gene_id : "ENSG00000112246.10",
      gene_type : "protein_coding",
      gene_name : "SIM1",
      gene_level : 2,
      hgnc_id : "HGNC:10882",
      havana_gene : "OTTHUMG00000015275.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 100508194,
      stop : 100881372,
      direction : "-",
      ID : "ENSG00000112249.14",
      gene_id : "ENSG00000112249.14",
      gene_type : "protein_coding",
      gene_name : "ASCC3",
      gene_level : 2,
      hgnc_id : "HGNC:18697",
      havana_gene : "OTTHUMG00000015279.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 101181257,
      stop : 102070083,
      direction : "+",
      ID : "ENSG00000164418.21",
      gene_id : "ENSG00000164418.21",
      gene_type : "protein_coding",
      gene_name : "GRIK2",
      gene_level : 2,
      hgnc_id : "HGNC:4580",
      havana_gene : "OTTHUMG00000016328.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 104728094,
      stop : 104859919,
      direction : "-",
      ID : "ENSG00000085382.12",
      gene_id : "ENSG00000085382.12",
      gene_type : "protein_coding",
      gene_name : "HACE1",
      gene_level : 2,
      hgnc_id : "HGNC:21033",
      havana_gene : "OTTHUMG00000015287.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 104936616,
      stop : 105083332,
      direction : "+",
      ID : "ENSG00000187772.8",
      gene_id : "ENSG00000187772.8",
      gene_type : "protein_coding",
      gene_name : "LIN28B",
      gene_level : 2,
      hgnc_id : "HGNC:32207",
      havana_gene : "OTTHUMG00000015290.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 105096822,
      stop : 105137157,
      direction : "-",
      ID : "ENSG00000112276.14",
      gene_id : "ENSG00000112276.14",
      gene_type : "protein_coding",
      gene_name : "BVES",
      gene_level : 2,
      hgnc_id : "HGNC:1152",
      havana_gene : "OTTHUMG00000015291.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 105157900,
      stop : 105180014,
      direction : "-",
      ID : "ENSG00000132429.10",
      gene_id : "ENSG00000132429.10",
      gene_type : "protein_coding",
      gene_name : "POPDC3",
      gene_level : 2,
      hgnc_id : "HGNC:17649",
      havana_gene : "OTTHUMG00000015293.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 105273218,
      stop : 105454062,
      direction : "-",
      ID : "ENSG00000085377.15",
      gene_id : "ENSG00000085377.15",
      gene_type : "protein_coding",
      gene_name : "PREP",
      gene_level : 2,
      hgnc_id : "HGNC:9358",
      havana_gene : "OTTHUMG00000015297.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 105993463,
      stop : 106109939,
      direction : "+",
      ID : "ENSG00000057657.17",
      gene_id : "ENSG00000057657.17",
      gene_type : "protein_coding",
      gene_name : "PRDM1",
      gene_level : 1,
      hgnc_id : "HGNC:9346",
      havana_gene : "OTTHUMG00000015299.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 106045423,
      stop : 106325791,
      direction : "-",
      ID : "ENSG00000057663.16",
      gene_id : "ENSG00000057663.16",
      gene_type : "protein_coding",
      gene_name : "ATG5",
      gene_level : 2,
      hgnc_id : "HGNC:589",
      havana_gene : "OTTHUMG00000016193.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 106360717,
      stop : 106572017,
      direction : "+",
      ID : "ENSG00000112297.18",
      gene_id : "ENSG00000112297.18",
      gene_type : "protein_coding",
      gene_name : "CRYBG1",
      gene_level : 2,
      hgnc_id : "HGNC:356",
      havana_gene : "",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 106570771,
      stop : 106629498,
      direction : "-",
      ID : "ENSG00000130347.13",
      gene_id : "ENSG00000130347.13",
      gene_type : "protein_coding",
      gene_name : "RTN4IP1",
      gene_level : 2,
      hgnc_id : "HGNC:18647",
      havana_gene : "OTTHUMG00000015304.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 106629578,
      stop : 106668417,
      direction : "+",
      ID : "ENSG00000130348.11",
      gene_id : "ENSG00000130348.11",
      gene_type : "protein_coding",
      gene_name : "QRSL1",
      gene_level : 2,
      hgnc_id : "HGNC:21020",
      havana_gene : "OTTHUMG00000015301.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 106969831,
      stop : 106975627,
      direction : "-",
      ID : "ENSG00000272398.6",
      gene_id : "ENSG00000272398.6",
      gene_type : "protein_coding",
      gene_name : "CD24",
      gene_level : 2,
      hgnc_id : "HGNC:1645",
      havana_gene : "OTTHUMG00000188439.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 107028199,
      stop : 107051586,
      direction : "+",
      ID : "ENSG00000130349.10",
      gene_id : "ENSG00000130349.10",
      gene_type : "protein_coding",
      gene_name : "MTRES1",
      gene_level : 2,
      hgnc_id : "HGNC:17971",
      havana_gene : "OTTHUMG00000015307.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 107065182,
      stop : 107115515,
      direction : "-",
      ID : "ENSG00000178409.14",
      gene_id : "ENSG00000178409.14",
      gene_type : "protein_coding",
      gene_name : "BEND3",
      gene_level : 2,
      hgnc_id : "HGNC:23040",
      havana_gene : "OTTHUMG00000015308.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 107152562,
      stop : 107459564,
      direction : "-",
      ID : "ENSG00000164494.12",
      gene_id : "ENSG00000164494.12",
      gene_type : "protein_coding",
      gene_name : "PDSS2",
      gene_level : 2,
      hgnc_id : "HGNC:23041",
      havana_gene : "OTTHUMG00000059359.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 107490106,
      stop : 107661306,
      direction : "+",
      ID : "ENSG00000112320.12",
      gene_id : "ENSG00000112320.12",
      gene_type : "protein_coding",
      gene_name : "SOBP",
      gene_level : 2,
      hgnc_id : "HGNC:29256",
      havana_gene : "OTTHUMG00000015312.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 107702154,
      stop : 107824317,
      direction : "-",
      ID : "ENSG00000146285.14",
      gene_id : "ENSG00000146285.14",
      gene_type : "protein_coding",
      gene_name : "SCML4",
      gene_level : 1,
      hgnc_id : "HGNC:21397",
      havana_gene : "OTTHUMG00000015313.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 107867756,
      stop : 107958208,
      direction : "-",
      ID : "ENSG00000025796.14",
      gene_id : "ENSG00000025796.14",
      gene_type : "protein_coding",
      gene_name : "SEC63",
      gene_level : 1,
      hgnc_id : "HGNC:21082",
      havana_gene : "OTTHUMG00000015316.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108041409,
      stop : 108165854,
      direction : "-",
      ID : "ENSG00000081087.15",
      gene_id : "ENSG00000081087.15",
      gene_type : "protein_coding",
      gene_name : "OSTM1",
      gene_level : 2,
      hgnc_id : "HGNC:21652",
      havana_gene : "OTTHUMG00000015317.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108166022,
      stop : 108188805,
      direction : "+",
      ID : "ENSG00000112333.12",
      gene_id : "ENSG00000112333.12",
      gene_type : "protein_coding",
      gene_name : "NR2E1",
      gene_level : 1,
      hgnc_id : "HGNC:7973",
      havana_gene : "OTTHUMG00000015319.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108211222,
      stop : 108261246,
      direction : "-",
      ID : "ENSG00000112335.15",
      gene_id : "ENSG00000112335.15",
      gene_type : "protein_coding",
      gene_name : "SNX3",
      gene_level : 2,
      hgnc_id : "HGNC:11174",
      havana_gene : "OTTHUMG00000015323.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108294991,
      stop : 108526796,
      direction : "+",
      ID : "ENSG00000135537.17",
      gene_id : "ENSG00000135537.17",
      gene_type : "protein_coding",
      gene_name : "AFG1L",
      gene_level : 1,
      hgnc_id : "HGNC:16411",
      havana_gene : "OTTHUMG00000015324.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108559835,
      stop : 108684774,
      direction : "+",
      ID : "ENSG00000118689.15",
      gene_id : "ENSG00000118689.15",
      gene_type : "protein_coding",
      gene_name : "FOXO3",
      gene_level : 2,
      hgnc_id : "HGNC:3821",
      havana_gene : "OTTHUMG00000015327.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108848416,
      stop : 108974476,
      direction : "+",
      ID : "ENSG00000118690.13",
      gene_id : "ENSG00000118690.13",
      gene_type : "protein_coding",
      gene_name : "ARMC2",
      gene_level : 1,
      hgnc_id : "HGNC:23045",
      havana_gene : "OTTHUMG00000015335.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 108986437,
      stop : 109094819,
      direction : "-",
      ID : "ENSG00000080546.13",
      gene_id : "ENSG00000080546.13",
      gene_type : "protein_coding",
      gene_name : "SESN1",
      gene_level : 2,
      hgnc_id : "HGNC:21595",
      havana_gene : "OTTHUMG00000015338.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109095110,
      stop : 109174418,
      direction : "+",
      ID : "ENSG00000183137.15",
      gene_id : "ENSG00000183137.15",
      gene_type : "protein_coding",
      gene_name : "CEP57L1",
      gene_level : 1,
      hgnc_id : "HGNC:21561",
      havana_gene : "OTTHUMG00000015336.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109366514,
      stop : 109382467,
      direction : "-",
      ID : "ENSG00000135535.17",
      gene_id : "ENSG00000135535.17",
      gene_type : "protein_coding",
      gene_name : "CD164",
      gene_level : 2,
      hgnc_id : "HGNC:1632",
      havana_gene : "OTTHUMG00000015339.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109390215,
      stop : 109441171,
      direction : "-",
      ID : "ENSG00000185250.16",
      gene_id : "ENSG00000185250.16",
      gene_type : "protein_coding",
      gene_name : "PPIL6",
      gene_level : 2,
      hgnc_id : "HGNC:21557",
      havana_gene : "OTTHUMG00000036593.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109440724,
      stop : 109443919,
      direction : "+",
      ID : "ENSG00000135587.9",
      gene_id : "ENSG00000135587.9",
      gene_type : "protein_coding",
      gene_name : "SMPD2",
      gene_level : 2,
      hgnc_id : "HGNC:11121",
      havana_gene : "OTTHUMG00000015348.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109444062,
      stop : 109465968,
      direction : "-",
      ID : "ENSG00000135596.18",
      gene_id : "ENSG00000135596.18",
      gene_type : "protein_coding",
      gene_name : "MICAL1",
      gene_level : 1,
      hgnc_id : "HGNC:20619",
      havana_gene : "OTTHUMG00000015350.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109462594,
      stop : 109483219,
      direction : "-",
      ID : "ENSG00000112365.5",
      gene_id : "ENSG00000112365.5",
      gene_type : "protein_coding",
      gene_name : "ZBTB24",
      gene_level : 2,
      hgnc_id : "HGNC:21143",
      havana_gene : "OTTHUMG00000015349.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109492856,
      stop : 109691217,
      direction : "-",
      ID : "ENSG00000155085.15",
      gene_id : "ENSG00000155085.15",
      gene_type : "protein_coding",
      gene_name : "AK9",
      gene_level : 1,
      hgnc_id : "HGNC:33814",
      havana_gene : "OTTHUMG00000157658.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109690609,
      stop : 109878098,
      direction : "+",
      ID : "ENSG00000112367.12",
      gene_id : "ENSG00000112367.12",
      gene_type : "protein_coding",
      gene_name : "FIG4",
      gene_level : 2,
      hgnc_id : "HGNC:16873",
      havana_gene : "OTTHUMG00000015352.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 109978256,
      stop : 109980718,
      direction : "+",
      ID : "ENSG00000146360.8",
      gene_id : "ENSG00000146360.8",
      gene_type : "protein_coding",
      gene_name : "GPR6",
      gene_level : 2,
      hgnc_id : "HGNC:4515",
      havana_gene : "OTTHUMG00000015354.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110099819,
      stop : 110180004,
      direction : "-",
      ID : "ENSG00000112290.13",
      gene_id : "ENSG00000112290.13",
      gene_type : "protein_coding",
      gene_name : "WASF1",
      gene_level : 2,
      hgnc_id : "HGNC:12732",
      havana_gene : "OTTHUMG00000015357.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110180141,
      stop : 110254275,
      direction : "+",
      ID : "ENSG00000168438.15",
      gene_id : "ENSG00000168438.15",
      gene_type : "protein_coding",
      gene_name : "CDC40",
      gene_level : 2,
      hgnc_id : "HGNC:17350",
      havana_gene : "OTTHUMG00000015358.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110245928,
      stop : 110358272,
      direction : "-",
      ID : "ENSG00000053328.8",
      gene_id : "ENSG00000053328.8",
      gene_type : "protein_coding",
      gene_name : "METTL24",
      gene_level : 1,
      hgnc_id : "HGNC:21566",
      havana_gene : "OTTHUMG00000015359.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110391771,
      stop : 110415575,
      direction : "-",
      ID : "ENSG00000203797.12",
      gene_id : "ENSG00000203797.12",
      gene_type : "protein_coding",
      gene_name : "DDO",
      gene_level : 2,
      hgnc_id : "HGNC:2727",
      havana_gene : "OTTHUMG00000015360.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110424687,
      stop : 110476641,
      direction : "-",
      ID : "ENSG00000004809.14",
      gene_id : "ENSG00000004809.14",
      gene_type : "protein_coding",
      gene_name : "SLC22A16",
      gene_level : 2,
      hgnc_id : "HGNC:20302",
      havana_gene : "OTTHUMG00000016171.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110609978,
      stop : 110815958,
      direction : "-",
      ID : "ENSG00000155111.15",
      gene_id : "ENSG00000155111.15",
      gene_type : "protein_coding",
      gene_name : "CDK19",
      gene_level : 2,
      hgnc_id : "HGNC:19338",
      havana_gene : "OTTHUMG00000015365.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110874770,
      stop : 110898879,
      direction : "+",
      ID : "ENSG00000123505.19",
      gene_id : "ENSG00000123505.19",
      gene_type : "protein_coding",
      gene_name : "AMD1",
      gene_level : 2,
      hgnc_id : "HGNC:457",
      havana_gene : "OTTHUMG00000015369.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110958706,
      stop : 110967890,
      direction : "+",
      ID : "ENSG00000155115.7",
      gene_id : "ENSG00000155115.7",
      gene_type : "protein_coding",
      gene_name : "GTF3C6",
      gene_level : 2,
      hgnc_id : "HGNC:20872",
      havana_gene : "OTTHUMG00000015370.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 110982015,
      stop : 111028263,
      direction : "+",
      ID : "ENSG00000197498.13",
      gene_id : "ENSG00000197498.13",
      gene_type : "protein_coding",
      gene_name : "RPF2",
      gene_level : 1,
      hgnc_id : "HGNC:20870",
      havana_gene : "OTTHUMG00000015368.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 111087503,
      stop : 111231194,
      direction : "+",
      ID : "ENSG00000112394.17",
      gene_id : "ENSG00000112394.17",
      gene_type : "protein_coding",
      gene_name : "SLC16A10",
      gene_level : 2,
      hgnc_id : "HGNC:17027",
      havana_gene : "OTTHUMG00000015371.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 111259327,
      stop : 111445354,
      direction : "+",
      ID : "ENSG00000173214.7",
      gene_id : "ENSG00000173214.7",
      gene_type : "protein_coding",
      gene_name : "MFSD4B",
      gene_level : 2,
      hgnc_id : "HGNC:21053",
      havana_gene : "OTTHUMG00000015372.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 111299028,
      stop : 111483715,
      direction : "-",
      ID : "ENSG00000009413.16",
      gene_id : "ENSG00000009413.16",
      gene_type : "protein_coding",
      gene_name : "REV3L",
      gene_level : 2,
      hgnc_id : "HGNC:9968",
      havana_gene : "OTTHUMG00000016318.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 111555381,
      stop : 111606906,
      direction : "-",
      ID : "ENSG00000056972.20",
      gene_id : "ENSG00000056972.20",
      gene_type : "protein_coding",
      gene_name : "TRAF3IP2",
      gene_level : 1,
      hgnc_id : "HGNC:1343",
      havana_gene : "OTTHUMG00000015379.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 111660332,
      stop : 111873452,
      direction : "-",
      ID : "ENSG00000010810.17",
      gene_id : "ENSG00000010810.17",
      gene_type : "protein_coding",
      gene_name : "FYN",
      gene_level : 2,
      hgnc_id : "HGNC:4037",
      havana_gene : "OTTHUMG00000016305.10",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 112054075,
      stop : 112069686,
      direction : "+",
      ID : "ENSG00000112761.21",
      gene_id : "ENSG00000112761.21",
      gene_type : "protein_coding",
      gene_name : "CCN6",
      gene_level : 1,
      hgnc_id : "HGNC:12771",
      havana_gene : "OTTHUMG00000185101.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 112070663,
      stop : 112087529,
      direction : "-",
      ID : "ENSG00000074935.14",
      gene_id : "ENSG00000074935.14",
      gene_type : "protein_coding",
      gene_name : "TUBE1",
      gene_level : 2,
      hgnc_id : "HGNC:20775",
      havana_gene : "OTTHUMG00000015382.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 112087591,
      stop : 112102790,
      direction : "+",
      ID : "ENSG00000203778.8",
      gene_id : "ENSG00000203778.8",
      gene_type : "protein_coding",
      gene_name : "FAM229B",
      gene_level : 2,
      hgnc_id : "HGNC:33858",
      havana_gene : "OTTHUMG00000015383.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 112107931,
      stop : 112254939,
      direction : "-",
      ID : "ENSG00000112769.20",
      gene_id : "ENSG00000112769.20",
      gene_type : "protein_coding",
      gene_name : "LAMA4",
      gene_level : 1,
      hgnc_id : "HGNC:6484",
      havana_gene : "OTTHUMG00000015386.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 112236806,
      stop : 112350094,
      direction : "+",
      ID : "ENSG00000281613.2",
      gene_id : "ENSG00000281613.2",
      gene_type : "protein_coding",
      gene_name : "AL365214.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189714.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 112347330,
      stop : 112351294,
      direction : "+",
      ID : "ENSG00000251258.2",
      gene_id : "ENSG00000251258.2",
      gene_type : "protein_coding",
      gene_name : "RFPL4B",
      gene_level : 2,
      hgnc_id : "HGNC:33264",
      havana_gene : "OTTHUMG00000015390.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 113857345,
      stop : 113863475,
      direction : "+",
      ID : "ENSG00000277443.3",
      gene_id : "ENSG00000277443.3",
      gene_type : "protein_coding",
      gene_name : "MARCKS",
      gene_level : 2,
      hgnc_id : "HGNC:6759",
      havana_gene : "OTTHUMG00000188327.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 113933028,
      stop : 114011308,
      direction : "-",
      ID : "ENSG00000196591.12",
      gene_id : "ENSG00000196591.12",
      gene_type : "protein_coding",
      gene_name : "HDAC2",
      gene_level : 1,
      hgnc_id : "HGNC:4853",
      havana_gene : "OTTHUMG00000015411.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 114055586,
      stop : 114343045,
      direction : "-",
      ID : "ENSG00000249853.8",
      gene_id : "ENSG00000249853.8",
      gene_type : "protein_coding",
      gene_name : "HS3ST5",
      gene_level : 1,
      hgnc_id : "HGNC:19419",
      havana_gene : "OTTHUMG00000015412.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 115931149,
      stop : 116060891,
      direction : "-",
      ID : "ENSG00000111816.8",
      gene_id : "ENSG00000111816.8",
      gene_type : "protein_coding",
      gene_name : "FRK",
      gene_level : 2,
      hgnc_id : "HGNC:3955",
      havana_gene : "OTTHUMG00000015424.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116100851,
      stop : 116249497,
      direction : "+",
      ID : "ENSG00000178425.14",
      gene_id : "ENSG00000178425.14",
      gene_type : "protein_coding",
      gene_name : "NT5DC1",
      gene_level : 2,
      hgnc_id : "HGNC:21556",
      havana_gene : "OTTHUMG00000015428.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116118909,
      stop : 116158747,
      direction : "-",
      ID : "ENSG00000123500.10",
      gene_id : "ENSG00000123500.10",
      gene_type : "protein_coding",
      gene_name : "COL10A1",
      gene_level : 2,
      hgnc_id : "HGNC:2185",
      havana_gene : "OTTHUMG00000015426.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116249964,
      stop : 116254075,
      direction : "-",
      ID : "ENSG00000187189.11",
      gene_id : "ENSG00000187189.11",
      gene_type : "protein_coding",
      gene_name : "TSPYL4",
      gene_level : 2,
      hgnc_id : "HGNC:21559",
      havana_gene : "OTTHUMG00000015429.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116254173,
      stop : 116444861,
      direction : "+",
      ID : "ENSG00000111817.19",
      gene_id : "ENSG00000111817.19",
      gene_type : "protein_coding",
      gene_name : "DSE",
      gene_level : 2,
      hgnc_id : "HGNC:21144",
      havana_gene : "OTTHUMG00000015434.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116267760,
      stop : 116279930,
      direction : "-",
      ID : "ENSG00000189241.8",
      gene_id : "ENSG00000189241.8",
      gene_type : "protein_coding",
      gene_name : "TSPYL1",
      gene_level : 2,
      hgnc_id : "HGNC:12382",
      havana_gene : "OTTHUMG00000015427.2",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116399395,
      stop : 116463696,
      direction : "+",
      ID : "ENSG00000285446.1",
      gene_id : "ENSG00000285446.1",
      gene_type : "protein_coding",
      gene_name : "Z84488.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192618.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116461370,
      stop : 116463771,
      direction : "+",
      ID : "ENSG00000188820.13",
      gene_id : "ENSG00000188820.13",
      gene_type : "protein_coding",
      gene_name : "CALHM6",
      gene_level : 2,
      hgnc_id : "HGNC:33391",
      havana_gene : "OTTHUMG00000015438.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116494989,
      stop : 116545684,
      direction : "-",
      ID : "ENSG00000173626.10",
      gene_id : "ENSG00000173626.10",
      gene_type : "protein_coding",
      gene_name : "TRAPPC3L",
      gene_level : 2,
      hgnc_id : "HGNC:21090",
      havana_gene : "OTTHUMG00000015440.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116511639,
      stop : 116524788,
      direction : "+",
      ID : "ENSG00000178033.6",
      gene_id : "ENSG00000178033.6",
      gene_type : "protein_coding",
      gene_name : "CALHM5",
      gene_level : 2,
      hgnc_id : "HGNC:21568",
      havana_gene : "OTTHUMG00000015442.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116529013,
      stop : 116558868,
      direction : "+",
      ID : "ENSG00000164451.13",
      gene_id : "ENSG00000164451.13",
      gene_type : "protein_coding",
      gene_name : "CALHM4",
      gene_level : 2,
      hgnc_id : "HGNC:21094",
      havana_gene : "OTTHUMG00000015443.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116571409,
      stop : 116597675,
      direction : "+",
      ID : "ENSG00000111832.13",
      gene_id : "ENSG00000111832.13",
      gene_type : "protein_coding",
      gene_name : "RWDD1",
      gene_level : 2,
      hgnc_id : "HGNC:20993",
      havana_gene : "OTTHUMG00000015441.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116616479,
      stop : 116632985,
      direction : "+",
      ID : "ENSG00000111834.13",
      gene_id : "ENSG00000111834.13",
      gene_type : "protein_coding",
      gene_name : "RSPH4A",
      gene_level : 2,
      hgnc_id : "HGNC:21558",
      havana_gene : "OTTHUMG00000015444.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116635618,
      stop : 116668794,
      direction : "-",
      ID : "ENSG00000153975.10",
      gene_id : "ENSG00000153975.10",
      gene_type : "protein_coding",
      gene_name : "ZUP1",
      gene_level : 2,
      hgnc_id : "HGNC:21224",
      havana_gene : "OTTHUMG00000015445.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116681187,
      stop : 116741867,
      direction : "+",
      ID : "ENSG00000196911.11",
      gene_id : "ENSG00000196911.11",
      gene_type : "protein_coding",
      gene_name : "KPNA5",
      gene_level : 2,
      hgnc_id : "HGNC:6398",
      havana_gene : "OTTHUMG00000015448.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116752197,
      stop : 116765719,
      direction : "-",
      ID : "ENSG00000183807.8",
      gene_id : "ENSG00000183807.8",
      gene_type : "protein_coding",
      gene_name : "FAM162B",
      gene_level : 2,
      hgnc_id : "HGNC:21549",
      havana_gene : "OTTHUMG00000015446.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116792085,
      stop : 116829083,
      direction : "-",
      ID : "ENSG00000173612.10",
      gene_id : "ENSG00000173612.10",
      gene_type : "protein_coding",
      gene_name : "GPRC6A",
      gene_level : 2,
      hgnc_id : "HGNC:18510",
      havana_gene : "OTTHUMG00000015447.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 116877212,
      stop : 116932161,
      direction : "+",
      ID : "ENSG00000185002.10",
      gene_id : "ENSG00000185002.10",
      gene_type : "protein_coding",
      gene_name : "RFX6",
      gene_level : 2,
      hgnc_id : "HGNC:21478",
      havana_gene : "OTTHUMG00000015449.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117265558,
      stop : 117273565,
      direction : "+",
      ID : "ENSG00000170162.14",
      gene_id : "ENSG00000170162.14",
      gene_type : "protein_coding",
      gene_name : "VGLL2",
      gene_level : 2,
      hgnc_id : "HGNC:20232",
      havana_gene : "OTTHUMG00000015451.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117287353,
      stop : 117425942,
      direction : "-",
      ID : "ENSG00000047936.11",
      gene_id : "ENSG00000047936.11",
      gene_type : "protein_coding",
      gene_name : "ROS1",
      gene_level : 2,
      hgnc_id : "HGNC:10261",
      havana_gene : "OTTHUMG00000016188.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117318211,
      stop : 117573571,
      direction : "-",
      ID : "ENSG00000282218.1",
      gene_id : "ENSG00000282218.1",
      gene_type : "protein_coding",
      gene_name : "AL132671.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000190739.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117453817,
      stop : 117569858,
      direction : "+",
      ID : "ENSG00000164465.19",
      gene_id : "ENSG00000164465.19",
      gene_type : "protein_coding",
      gene_name : "DCBLD1",
      gene_level : 2,
      hgnc_id : "HGNC:21479",
      havana_gene : "OTTHUMG00000015455.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117560269,
      stop : 117602542,
      direction : "-",
      ID : "ENSG00000047932.14",
      gene_id : "ENSG00000047932.14",
      gene_type : "protein_coding",
      gene_name : "GOPC",
      gene_level : 2,
      hgnc_id : "HGNC:17643",
      havana_gene : "OTTHUMG00000015457.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117675469,
      stop : 117710727,
      direction : "+",
      ID : "ENSG00000153989.8",
      gene_id : "ENSG00000153989.8",
      gene_type : "protein_coding",
      gene_name : "NUS1",
      gene_level : 2,
      hgnc_id : "HGNC:21042",
      havana_gene : "OTTHUMG00000015458.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 117907264,
      stop : 118317676,
      direction : "+",
      ID : "ENSG00000196376.11",
      gene_id : "ENSG00000196376.11",
      gene_type : "protein_coding",
      gene_name : "SLC35F1",
      gene_level : 2,
      hgnc_id : "HGNC:21483",
      havana_gene : "OTTHUMG00000015460.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 118460772,
      stop : 118710075,
      direction : "-",
      ID : "ENSG00000111860.14",
      gene_id : "ENSG00000111860.14",
      gene_type : "protein_coding",
      gene_name : "CEP85L",
      gene_level : 1,
      hgnc_id : "HGNC:21638",
      havana_gene : "OTTHUMG00000015465.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 118548296,
      stop : 118561716,
      direction : "+",
      ID : "ENSG00000198523.6",
      gene_id : "ENSG00000198523.6",
      gene_type : "protein_coding",
      gene_name : "PLN",
      gene_level : 2,
      hgnc_id : "HGNC:9080",
      havana_gene : "OTTHUMG00000015462.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 118813442,
      stop : 118935162,
      direction : "-",
      ID : "ENSG00000111877.18",
      gene_id : "ENSG00000111877.18",
      gene_type : "protein_coding",
      gene_name : "MCM9",
      gene_level : 1,
      hgnc_id : "HGNC:21484",
      havana_gene : "OTTHUMG00000015468.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 118894152,
      stop : 118909171,
      direction : "+",
      ID : "ENSG00000111875.8",
      gene_id : "ENSG00000111875.8",
      gene_type : "protein_coding",
      gene_name : "ASF1A",
      gene_level : 2,
      hgnc_id : "HGNC:20995",
      havana_gene : "OTTHUMG00000015470.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 118959763,
      stop : 119149387,
      direction : "-",
      ID : "ENSG00000111879.20",
      gene_id : "ENSG00000111879.20",
      gene_type : "protein_coding",
      gene_name : "FAM184A",
      gene_level : 1,
      hgnc_id : "HGNC:20991",
      havana_gene : "OTTHUMG00000015471.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 119177205,
      stop : 119349761,
      direction : "-",
      ID : "ENSG00000111885.7",
      gene_id : "ENSG00000111885.7",
      gene_type : "protein_coding",
      gene_name : "MAN1A1",
      gene_level : 2,
      hgnc_id : "HGNC:6821",
      havana_gene : "OTTHUMG00000015472.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 121079494,
      stop : 121334745,
      direction : "-",
      ID : "ENSG00000146350.14",
      gene_id : "ENSG00000146350.14",
      gene_type : "protein_coding",
      gene_name : "TBC1D32",
      gene_level : 2,
      hgnc_id : "HGNC:21485",
      havana_gene : "OTTHUMG00000015474.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 121435595,
      stop : 121449727,
      direction : "+",
      ID : "ENSG00000152661.9",
      gene_id : "ENSG00000152661.9",
      gene_type : "protein_coding",
      gene_name : "GJA1",
      gene_level : 2,
      hgnc_id : "HGNC:4274",
      havana_gene : "OTTHUMG00000015479.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 122399551,
      stop : 122433119,
      direction : "+",
      ID : "ENSG00000025156.13",
      gene_id : "ENSG00000025156.13",
      gene_type : "protein_coding",
      gene_name : "HSF2",
      gene_level : 2,
      hgnc_id : "HGNC:5225",
      havana_gene : "OTTHUMG00000016216.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 122443351,
      stop : 122471807,
      direction : "-",
      ID : "ENSG00000111897.7",
      gene_id : "ENSG00000111897.7",
      gene_type : "protein_coding",
      gene_name : "SERINC1",
      gene_level : 2,
      hgnc_id : "HGNC:13464",
      havana_gene : "OTTHUMG00000015487.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 122471917,
      stop : 122726373,
      direction : "+",
      ID : "ENSG00000135549.15",
      gene_id : "ENSG00000135549.15",
      gene_type : "protein_coding",
      gene_name : "PKIB",
      gene_level : 2,
      hgnc_id : "HGNC:9018",
      havana_gene : "OTTHUMG00000015488.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 122779716,
      stop : 122784074,
      direction : "+",
      ID : "ENSG00000164434.12",
      gene_id : "ENSG00000164434.12",
      gene_type : "protein_coding",
      gene_name : "FABP7",
      gene_level : 2,
      hgnc_id : "HGNC:3562",
      havana_gene : "OTTHUMG00000015489.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 122789049,
      stop : 122809720,
      direction : "+",
      ID : "ENSG00000172594.13",
      gene_id : "ENSG00000172594.13",
      gene_type : "protein_coding",
      gene_name : "SMPDL3A",
      gene_level : 2,
      hgnc_id : "HGNC:17389",
      havana_gene : "OTTHUMG00000015490.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 122996235,
      stop : 123072925,
      direction : "+",
      ID : "ENSG00000146352.13",
      gene_id : "ENSG00000146352.13",
      gene_type : "protein_coding",
      gene_name : "CLVS2",
      gene_level : 2,
      hgnc_id : "HGNC:23046",
      havana_gene : "OTTHUMG00000015495.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 123216339,
      stop : 123637093,
      direction : "-",
      ID : "ENSG00000186439.14",
      gene_id : "ENSG00000186439.14",
      gene_type : "protein_coding",
      gene_name : "TRDN",
      gene_level : 2,
      hgnc_id : "HGNC:12261",
      havana_gene : "OTTHUMG00000015497.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 123803865,
      stop : 124825640,
      direction : "+",
      ID : "ENSG00000188580.15",
      gene_id : "ENSG00000188580.15",
      gene_type : "protein_coding",
      gene_name : "NKAIN2",
      gene_level : 2,
      hgnc_id : "HGNC:16443",
      havana_gene : "OTTHUMG00000015500.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 124962545,
      stop : 125092633,
      direction : "+",
      ID : "ENSG00000146373.16",
      gene_id : "ENSG00000146373.16",
      gene_type : "protein_coding",
      gene_name : "RNF217",
      gene_level : 2,
      hgnc_id : "HGNC:21487",
      havana_gene : "OTTHUMG00000015504.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 125119049,
      stop : 125264407,
      direction : "+",
      ID : "ENSG00000111907.21",
      gene_id : "ENSG00000111907.21",
      gene_type : "protein_coding",
      gene_name : "TPD52L1",
      gene_level : 1,
      hgnc_id : "HGNC:12006",
      havana_gene : "OTTHUMG00000015505.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 125219962,
      stop : 125302078,
      direction : "-",
      ID : "ENSG00000111906.18",
      gene_id : "ENSG00000111906.18",
      gene_type : "protein_coding",
      gene_name : "HDDC2",
      gene_level : 2,
      hgnc_id : "HGNC:21078",
      havana_gene : "OTTHUMG00000015506.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 125747664,
      stop : 125761269,
      direction : "+",
      ID : "ENSG00000135547.9",
      gene_id : "ENSG00000135547.9",
      gene_type : "protein_coding",
      gene_name : "HEY2",
      gene_level : 2,
      hgnc_id : "HGNC:4881",
      havana_gene : "OTTHUMG00000015512.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 125781161,
      stop : 125932034,
      direction : "+",
      ID : "ENSG00000111912.20",
      gene_id : "ENSG00000111912.20",
      gene_type : "protein_coding",
      gene_name : "NCOA7",
      gene_level : 2,
      hgnc_id : "HGNC:21081",
      havana_gene : "OTTHUMG00000015513.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 125956770,
      stop : 125980244,
      direction : "+",
      ID : "ENSG00000111911.7",
      gene_id : "ENSG00000111911.7",
      gene_type : "protein_coding",
      gene_name : "HINT3",
      gene_level : 2,
      hgnc_id : "HGNC:18468",
      havana_gene : "OTTHUMG00000015514.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 125986479,
      stop : 126203817,
      direction : "+",
      ID : "ENSG00000066651.20",
      gene_id : "ENSG00000066651.20",
      gene_type : "protein_coding",
      gene_name : "TRMT11",
      gene_level : 2,
      hgnc_id : "HGNC:21080",
      havana_gene : "OTTHUMG00000015515.14",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 126340115,
      stop : 126348875,
      direction : "+",
      ID : "ENSG00000203760.9",
      gene_id : "ENSG00000203760.9",
      gene_type : "protein_coding",
      gene_name : "CENPW",
      gene_level : 2,
      hgnc_id : "HGNC:21488",
      havana_gene : "OTTHUMG00000015518.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127118671,
      stop : 127199481,
      direction : "+",
      ID : "ENSG00000146374.14",
      gene_id : "ENSG00000146374.14",
      gene_type : "protein_coding",
      gene_name : "RSPO3",
      gene_level : 2,
      hgnc_id : "HGNC:20866",
      havana_gene : "OTTHUMG00000015521.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127266682,
      stop : 127288567,
      direction : "+",
      ID : "ENSG00000118518.16",
      gene_id : "ENSG00000118518.16",
      gene_type : "protein_coding",
      gene_name : "RNF146",
      gene_level : 2,
      hgnc_id : "HGNC:21336",
      havana_gene : "OTTHUMG00000015522.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127288712,
      stop : 127343609,
      direction : "-",
      ID : "ENSG00000093144.19",
      gene_id : "ENSG00000093144.19",
      gene_type : "protein_coding",
      gene_name : "ECHDC1",
      gene_level : 1,
      hgnc_id : "HGNC:21489",
      havana_gene : "OTTHUMG00000015523.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127438406,
      stop : 127459389,
      direction : "-",
      ID : "ENSG00000189367.15",
      gene_id : "ENSG00000189367.15",
      gene_type : "protein_coding",
      gene_name : "KIAA0408",
      gene_level : 1,
      hgnc_id : "HGNC:21636",
      havana_gene : "OTTHUMG00000166439.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127438406,
      stop : 127519001,
      direction : "-",
      ID : "ENSG00000255330.9",
      gene_id : "ENSG00000255330.9",
      gene_type : "protein_coding",
      gene_name : "AL096711.2",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000015528.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127472794,
      stop : 127519191,
      direction : "-",
      ID : "ENSG00000214338.10",
      gene_id : "ENSG00000214338.10",
      gene_type : "protein_coding",
      gene_name : "SOGA3",
      gene_level : 2,
      hgnc_id : "HGNC:21494",
      havana_gene : "OTTHUMG00000166438.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127519455,
      stop : 127591820,
      direction : "+",
      ID : "ENSG00000184530.9",
      gene_id : "ENSG00000184530.9",
      gene_type : "protein_coding",
      gene_name : "C6orf58",
      gene_level : 2,
      hgnc_id : "HGNC:20960",
      havana_gene : "OTTHUMG00000015530.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127708072,
      stop : 127918631,
      direction : "-",
      ID : "ENSG00000172673.11",
      gene_id : "ENSG00000172673.11",
      gene_type : "protein_coding",
      gene_name : "THEMIS",
      gene_level : 2,
      hgnc_id : "HGNC:21569",
      havana_gene : "OTTHUMG00000015534.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 127968785,
      stop : 128520616,
      direction : "-",
      ID : "ENSG00000152894.15",
      gene_id : "ENSG00000152894.15",
      gene_type : "protein_coding",
      gene_name : "PTPRK",
      gene_level : 2,
      hgnc_id : "HGNC:9674",
      havana_gene : "OTTHUMG00000015536.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 128883138,
      stop : 129516566,
      direction : "+",
      ID : "ENSG00000196569.13",
      gene_id : "ENSG00000196569.13",
      gene_type : "protein_coding",
      gene_name : "LAMA2",
      gene_level : 2,
      hgnc_id : "HGNC:6482",
      havana_gene : "OTTHUMG00000015545.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 129576132,
      stop : 129710177,
      direction : "-",
      ID : "ENSG00000146376.11",
      gene_id : "ENSG00000146376.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP18",
      gene_level : 2,
      hgnc_id : "HGNC:21035",
      havana_gene : "OTTHUMG00000015547.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 129831244,
      stop : 129861547,
      direction : "-",
      ID : "ENSG00000203756.8",
      gene_id : "ENSG00000203756.8",
      gene_type : "protein_coding",
      gene_name : "TMEM244",
      gene_level : 2,
      hgnc_id : "HGNC:21571",
      havana_gene : "OTTHUMG00000015553.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 130013699,
      stop : 130141449,
      direction : "+",
      ID : "ENSG00000198945.8",
      gene_id : "ENSG00000198945.8",
      gene_type : "protein_coding",
      gene_name : "L3MBTL3",
      gene_level : 2,
      hgnc_id : "HGNC:23035",
      havana_gene : "OTTHUMG00000015554.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 130144315,
      stop : 130365425,
      direction : "-",
      ID : "ENSG00000164483.17",
      gene_id : "ENSG00000164483.17",
      gene_type : "protein_coding",
      gene_name : "SAMD3",
      gene_level : 1,
      hgnc_id : "HGNC:21574",
      havana_gene : "OTTHUMG00000015556.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 130366017,
      stop : 130443067,
      direction : "+",
      ID : "ENSG00000164484.12",
      gene_id : "ENSG00000164484.12",
      gene_type : "protein_coding",
      gene_name : "TMEM200A",
      gene_level : 2,
      hgnc_id : "HGNC:21075",
      havana_gene : "OTTHUMG00000015557.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 130827406,
      stop : 130837135,
      direction : "+",
      ID : "ENSG00000256162.2",
      gene_id : "ENSG00000256162.2",
      gene_type : "protein_coding",
      gene_name : "SMLR1",
      gene_level : 1,
      hgnc_id : "HGNC:44670",
      havana_gene : "OTTHUMG00000176259.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 130839347,
      stop : 131063322,
      direction : "-",
      ID : "ENSG00000079819.19",
      gene_id : "ENSG00000079819.19",
      gene_type : "protein_coding",
      gene_name : "EPB41L2",
      gene_level : 1,
      hgnc_id : "HGNC:3379",
      havana_gene : "OTTHUMG00000015560.12",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131135467,
      stop : 131283535,
      direction : "+",
      ID : "ENSG00000118507.17",
      gene_id : "ENSG00000118507.17",
      gene_type : "protein_coding",
      gene_name : "AKAP7",
      gene_level : 2,
      hgnc_id : "HGNC:377",
      havana_gene : "OTTHUMG00000015563.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131470832,
      stop : 131584332,
      direction : "+",
      ID : "ENSG00000118520.15",
      gene_id : "ENSG00000118520.15",
      gene_type : "protein_coding",
      gene_name : "ARG1",
      gene_level : 2,
      hgnc_id : "HGNC:663",
      havana_gene : "OTTHUMG00000015566.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131573966,
      stop : 131628242,
      direction : "-",
      ID : "ENSG00000112282.18",
      gene_id : "ENSG00000112282.18",
      gene_type : "protein_coding",
      gene_name : "MED23",
      gene_level : 2,
      hgnc_id : "HGNC:2372",
      havana_gene : "OTTHUMG00000015565.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131628442,
      stop : 131747418,
      direction : "+",
      ID : "ENSG00000154269.15",
      gene_id : "ENSG00000154269.15",
      gene_type : "protein_coding",
      gene_name : "ENPP3",
      gene_level : 2,
      hgnc_id : "HGNC:3358",
      havana_gene : "OTTHUMG00000016292.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131699644,
      stop : 131701401,
      direction : "-",
      ID : "ENSG00000180658.4",
      gene_id : "ENSG00000180658.4",
      gene_type : "protein_coding",
      gene_name : "OR2A4",
      gene_level : 2,
      hgnc_id : "HGNC:14729",
      havana_gene : "OTTHUMG00000016316.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131708441,
      stop : 131711017,
      direction : "-",
      ID : "ENSG00000236761.6",
      gene_id : "ENSG00000236761.6",
      gene_type : "protein_coding",
      gene_name : "CTAGE9",
      gene_level : 2,
      hgnc_id : "HGNC:37275",
      havana_gene : "OTTHUMG00000047966.3",
      tag : "retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131808016,
      stop : 131895155,
      direction : "+",
      ID : "ENSG00000197594.13",
      gene_id : "ENSG00000197594.13",
      gene_type : "protein_coding",
      gene_name : "ENPP1",
      gene_level : 2,
      hgnc_id : "HGNC:3356",
      havana_gene : "OTTHUMG00000015572.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 131948176,
      stop : 131951372,
      direction : "-",
      ID : "ENSG00000118523.6",
      gene_id : "ENSG00000118523.6",
      gene_type : "protein_coding",
      gene_name : "CCN2",
      gene_level : 2,
      hgnc_id : "HGNC:2500",
      havana_gene : "OTTHUMG00000015573.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132296055,
      stop : 132401475,
      direction : "-",
      ID : "ENSG00000079931.15",
      gene_id : "ENSG00000079931.15",
      gene_type : "protein_coding",
      gene_name : "MOXD1",
      gene_level : 1,
      hgnc_id : "HGNC:21063",
      havana_gene : "OTTHUMG00000055853.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132445867,
      stop : 132513198,
      direction : "-",
      ID : "ENSG00000079950.14",
      gene_id : "ENSG00000079950.14",
      gene_type : "protein_coding",
      gene_name : "STX7",
      gene_level : 2,
      hgnc_id : "HGNC:11442",
      havana_gene : "OTTHUMG00000015577.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132538290,
      stop : 132539336,
      direction : "+",
      ID : "ENSG00000237110.2",
      gene_id : "ENSG00000237110.2",
      gene_type : "protein_coding",
      gene_name : "TAAR9",
      gene_level : 2,
      hgnc_id : "HGNC:20977",
      havana_gene : "OTTHUMG00000015578.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132552693,
      stop : 132553721,
      direction : "+",
      ID : "ENSG00000146385.1",
      gene_id : "ENSG00000146385.1",
      gene_type : "protein_coding",
      gene_name : "TAAR8",
      gene_level : 2,
      hgnc_id : "HGNC:14964",
      havana_gene : "OTTHUMG00000015586.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132570322,
      stop : 132571359,
      direction : "+",
      ID : "ENSG00000146383.7",
      gene_id : "ENSG00000146383.7",
      gene_type : "protein_coding",
      gene_name : "TAAR6",
      gene_level : 2,
      hgnc_id : "HGNC:20978",
      havana_gene : "OTTHUMG00000015579.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132588673,
      stop : 132589686,
      direction : "-",
      ID : "ENSG00000135569.4",
      gene_id : "ENSG00000135569.4",
      gene_type : "protein_coding",
      gene_name : "TAAR5",
      gene_level : 2,
      hgnc_id : "HGNC:30236",
      havana_gene : "OTTHUMG00000015581.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132617022,
      stop : 132624275,
      direction : "-",
      ID : "ENSG00000146378.6",
      gene_id : "ENSG00000146378.6",
      gene_type : "protein_coding",
      gene_name : "TAAR2",
      gene_level : 2,
      hgnc_id : "HGNC:4514",
      havana_gene : "OTTHUMG00000015585.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132644898,
      stop : 132646051,
      direction : "-",
      ID : "ENSG00000146399.2",
      gene_id : "ENSG00000146399.2",
      gene_type : "protein_coding",
      gene_name : "TAAR1",
      gene_level : 2,
      hgnc_id : "HGNC:17734",
      havana_gene : "OTTHUMG00000015583.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132680849,
      stop : 132714055,
      direction : "-",
      ID : "ENSG00000112299.8",
      gene_id : "ENSG00000112299.8",
      gene_type : "protein_coding",
      gene_name : "VNN1",
      gene_level : 2,
      hgnc_id : "HGNC:12705",
      havana_gene : "OTTHUMG00000015587.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132722787,
      stop : 132736935,
      direction : "-",
      ID : "ENSG00000093134.15",
      gene_id : "ENSG00000093134.15",
      gene_type : "protein_coding",
      gene_name : "VNN3",
      gene_level : 1,
      hgnc_id : "HGNC:16431",
      havana_gene : "OTTHUMG00000015589.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132743870,
      stop : 132763459,
      direction : "-",
      ID : "ENSG00000112303.14",
      gene_id : "ENSG00000112303.14",
      gene_type : "protein_coding",
      gene_name : "VNN2",
      gene_level : 2,
      hgnc_id : "HGNC:12706",
      havana_gene : "OTTHUMG00000015588.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132769370,
      stop : 132813339,
      direction : "-",
      ID : "ENSG00000146409.12",
      gene_id : "ENSG00000146409.12",
      gene_type : "protein_coding",
      gene_name : "SLC18B1",
      gene_level : 2,
      hgnc_id : "HGNC:21573",
      havana_gene : "OTTHUMG00000015595.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 132814569,
      stop : 132817564,
      direction : "+",
      ID : "ENSG00000112306.8",
      gene_id : "ENSG00000112306.8",
      gene_type : "protein_coding",
      gene_name : "RPS12",
      gene_level : 2,
      hgnc_id : "HGNC:10385",
      havana_gene : "OTTHUMG00000015593.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 133240598,
      stop : 133532128,
      direction : "+",
      ID : "ENSG00000112319.19",
      gene_id : "ENSG00000112319.19",
      gene_type : "protein_coding",
      gene_name : "EYA4",
      gene_level : 1,
      hgnc_id : "HGNC:3522",
      havana_gene : "OTTHUMG00000015602.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 133889113,
      stop : 133895553,
      direction : "+",
      ID : "ENSG00000118526.7",
      gene_id : "ENSG00000118526.7",
      gene_type : "protein_coding",
      gene_name : "TCF21",
      gene_level : 2,
      hgnc_id : "HGNC:11632",
      havana_gene : "OTTHUMG00000015608.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 133952170,
      stop : 133990432,
      direction : "+",
      ID : "ENSG00000028839.10",
      gene_id : "ENSG00000028839.10",
      gene_type : "protein_coding",
      gene_name : "TBPL1",
      gene_level : 2,
      hgnc_id : "HGNC:11589",
      havana_gene : "OTTHUMG00000015609.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 133953304,
      stop : 133980088,
      direction : "+",
      ID : "ENSG00000288529.1",
      gene_id : "ENSG00000288529.1",
      gene_type : "protein_coding",
      gene_name : "AL035699.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000195944.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 133987581,
      stop : 134052624,
      direction : "-",
      ID : "ENSG00000146411.6",
      gene_id : "ENSG00000146411.6",
      gene_type : "protein_coding",
      gene_name : "SLC2A12",
      gene_level : 2,
      hgnc_id : "HGNC:18067",
      havana_gene : "OTTHUMG00000015611.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 134169246,
      stop : 134318112,
      direction : "-",
      ID : "ENSG00000118515.11",
      gene_id : "ENSG00000118515.11",
      gene_type : "protein_coding",
      gene_name : "SGK1",
      gene_level : 2,
      hgnc_id : "HGNC:10810",
      havana_gene : "OTTHUMG00000015613.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 134917393,
      stop : 134950115,
      direction : "-",
      ID : "ENSG00000118514.14",
      gene_id : "ENSG00000118514.14",
      gene_type : "protein_coding",
      gene_name : "ALDH8A1",
      gene_level : 1,
      hgnc_id : "HGNC:15471",
      havana_gene : "OTTHUMG00000015623.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 134960378,
      stop : 135103056,
      direction : "-",
      ID : "ENSG00000112339.15",
      gene_id : "ENSG00000112339.15",
      gene_type : "protein_coding",
      gene_name : "HBS1L",
      gene_level : 1,
      hgnc_id : "HGNC:4834",
      havana_gene : "OTTHUMG00000015626.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 135181308,
      stop : 135219173,
      direction : "+",
      ID : "ENSG00000118513.19",
      gene_id : "ENSG00000118513.19",
      gene_type : "protein_coding",
      gene_name : "MYB",
      gene_level : 1,
      hgnc_id : "HGNC:7545",
      havana_gene : "OTTHUMG00000015629.11",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 135283407,
      stop : 135498434,
      direction : "-",
      ID : "ENSG00000135541.22",
      gene_id : "ENSG00000135541.22",
      gene_type : "protein_coding",
      gene_name : "AHI1",
      gene_level : 1,
      hgnc_id : "HGNC:21575",
      havana_gene : "OTTHUMG00000015631.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 135851701,
      stop : 136195574,
      direction : "+",
      ID : "ENSG00000171408.14",
      gene_id : "ENSG00000171408.14",
      gene_type : "protein_coding",
      gene_name : "PDE7B",
      gene_level : 2,
      hgnc_id : "HGNC:8792",
      havana_gene : "OTTHUMG00000015641.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136231024,
      stop : 136250335,
      direction : "-",
      ID : "ENSG00000146410.12",
      gene_id : "ENSG00000146410.12",
      gene_type : "protein_coding",
      gene_name : "MTFR2",
      gene_level : 2,
      hgnc_id : "HGNC:21115",
      havana_gene : "OTTHUMG00000015643.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136256627,
      stop : 136289851,
      direction : "-",
      ID : "ENSG00000029363.17",
      gene_id : "ENSG00000029363.17",
      gene_type : "protein_coding",
      gene_name : "BCLAF1",
      gene_level : 1,
      hgnc_id : "HGNC:16863",
      havana_gene : "OTTHUMG00000033323.8",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136342281,
      stop : 136550819,
      direction : "-",
      ID : "ENSG00000135525.18",
      gene_id : "ENSG00000135525.18",
      gene_type : "protein_coding",
      gene_name : "MAP7",
      gene_level : 2,
      hgnc_id : "HGNC:6869",
      havana_gene : "OTTHUMG00000015646.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136557046,
      stop : 136792477,
      direction : "-",
      ID : "ENSG00000197442.10",
      gene_id : "ENSG00000197442.10",
      gene_type : "protein_coding",
      gene_name : "MAP3K5",
      gene_level : 2,
      hgnc_id : "HGNC:6857",
      havana_gene : "OTTHUMG00000015647.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136822564,
      stop : 136913934,
      direction : "+",
      ID : "ENSG00000112357.14",
      gene_id : "ENSG00000112357.14",
      gene_type : "protein_coding",
      gene_name : "PEX7",
      gene_level : 2,
      hgnc_id : "HGNC:8860",
      havana_gene : "OTTHUMG00000015650.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136922301,
      stop : 136925660,
      direction : "+",
      ID : "ENSG00000182747.5",
      gene_id : "ENSG00000182747.5",
      gene_type : "protein_coding",
      gene_name : "SLC35D3",
      gene_level : 2,
      hgnc_id : "HGNC:15621",
      havana_gene : "OTTHUMG00000015651.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 136999971,
      stop : 137045180,
      direction : "-",
      ID : "ENSG00000016402.13",
      gene_id : "ENSG00000016402.13",
      gene_type : "protein_coding",
      gene_name : "IL20RA",
      gene_level : 2,
      hgnc_id : "HGNC:6003",
      havana_gene : "OTTHUMG00000015654.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 137143820,
      stop : 137173648,
      direction : "-",
      ID : "ENSG00000164485.15",
      gene_id : "ENSG00000164485.15",
      gene_type : "protein_coding",
      gene_name : "IL22RA2",
      gene_level : 2,
      hgnc_id : "HGNC:14901",
      havana_gene : "OTTHUMG00000015655.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 137197485,
      stop : 137219449,
      direction : "-",
      ID : "ENSG00000027697.15",
      gene_id : "ENSG00000027697.15",
      gene_type : "protein_coding",
      gene_name : "IFNGR1",
      gene_level : 2,
      hgnc_id : "HGNC:5439",
      havana_gene : "OTTHUMG00000015656.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 137492199,
      stop : 137494394,
      direction : "-",
      ID : "ENSG00000177468.7",
      gene_id : "ENSG00000177468.7",
      gene_type : "protein_coding",
      gene_name : "OLIG3",
      gene_level : 2,
      hgnc_id : "HGNC:18003",
      havana_gene : "OTTHUMG00000015657.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 137867214,
      stop : 137883312,
      direction : "+",
      ID : "ENSG00000118503.15",
      gene_id : "ENSG00000118503.15",
      gene_type : "protein_coding",
      gene_name : "TNFAIP3",
      gene_level : 2,
      hgnc_id : "HGNC:11896",
      havana_gene : "OTTHUMG00000015664.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138088505,
      stop : 138107419,
      direction : "-",
      ID : "ENSG00000112378.12",
      gene_id : "ENSG00000112378.12",
      gene_type : "protein_coding",
      gene_name : "PERP",
      gene_level : 2,
      hgnc_id : "HGNC:17637",
      havana_gene : "OTTHUMG00000015668.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138161939,
      stop : 138344663,
      direction : "+",
      ID : "ENSG00000112379.9",
      gene_id : "ENSG00000112379.9",
      gene_type : "protein_coding",
      gene_name : "ARFGEF3",
      gene_level : 2,
      hgnc_id : "HGNC:21213",
      havana_gene : "OTTHUMG00000015670.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138215986,
      stop : 138218491,
      direction : "-",
      ID : "ENSG00000254440.3",
      gene_id : "ENSG00000254440.3",
      gene_type : "protein_coding",
      gene_name : "PBOV1",
      gene_level : 2,
      hgnc_id : "HGNC:21079",
      havana_gene : "OTTHUMG00000167040.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138377905,
      stop : 138383486,
      direction : "+",
      ID : "ENSG00000262543.2",
      gene_id : "ENSG00000262543.2",
      gene_type : "protein_coding",
      gene_name : "SMIM28",
      gene_level : 2,
      hgnc_id : "HGNC:53434",
      havana_gene : "OTTHUMG00000172823.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138403531,
      stop : 138422197,
      direction : "+",
      ID : "ENSG00000051620.11",
      gene_id : "ENSG00000051620.11",
      gene_type : "protein_coding",
      gene_name : "HEBP2",
      gene_level : 2,
      hgnc_id : "HGNC:15716",
      havana_gene : "OTTHUMG00000015671.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138422043,
      stop : 138692571,
      direction : "-",
      ID : "ENSG00000135540.11",
      gene_id : "ENSG00000135540.11",
      gene_type : "protein_coding",
      gene_name : "NHSL1",
      gene_level : 1,
      hgnc_id : "HGNC:21021",
      havana_gene : "OTTHUMG00000016321.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138773769,
      stop : 138793319,
      direction : "+",
      ID : "ENSG00000024862.18",
      gene_id : "ENSG00000024862.18",
      gene_type : "protein_coding",
      gene_name : "CCDC28A",
      gene_level : 2,
      hgnc_id : "HGNC:21098",
      havana_gene : "OTTHUMG00000015683.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138795911,
      stop : 138904070,
      direction : "+",
      ID : "ENSG00000203734.13",
      gene_id : "ENSG00000203734.13",
      gene_type : "protein_coding",
      gene_name : "ECT2L",
      gene_level : 2,
      hgnc_id : "HGNC:21118",
      havana_gene : "OTTHUMG00000015679.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 138903493,
      stop : 138988261,
      direction : "-",
      ID : "ENSG00000135597.19",
      gene_id : "ENSG00000135597.19",
      gene_type : "protein_coding",
      gene_name : "REPS1",
      gene_level : 1,
      hgnc_id : "HGNC:15578",
      havana_gene : "OTTHUMG00000015685.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 139028745,
      stop : 139043302,
      direction : "+",
      ID : "ENSG00000146386.8",
      gene_id : "ENSG00000146386.8",
      gene_type : "protein_coding",
      gene_name : "ABRACL",
      gene_level : 2,
      hgnc_id : "HGNC:21230",
      havana_gene : "OTTHUMG00000015684.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 139135080,
      stop : 139180802,
      direction : "+",
      ID : "ENSG00000112406.5",
      gene_id : "ENSG00000112406.5",
      gene_type : "protein_coding",
      gene_name : "HECA",
      gene_level : 2,
      hgnc_id : "HGNC:21041",
      havana_gene : "OTTHUMG00000015686.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 139240061,
      stop : 139291998,
      direction : "-",
      ID : "ENSG00000164440.15",
      gene_id : "ENSG00000164440.15",
      gene_type : "protein_coding",
      gene_name : "TXLNB",
      gene_level : 2,
      hgnc_id : "HGNC:21617",
      havana_gene : "OTTHUMG00000015688.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 139371807,
      stop : 139374648,
      direction : "-",
      ID : "ENSG00000164442.10",
      gene_id : "ENSG00000164442.10",
      gene_type : "protein_coding",
      gene_name : "CITED2",
      gene_level : 2,
      hgnc_id : "HGNC:1987",
      havana_gene : "OTTHUMG00000015691.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 142058330,
      stop : 142088799,
      direction : "-",
      ID : "ENSG00000135577.4",
      gene_id : "ENSG00000135577.4",
      gene_type : "protein_coding",
      gene_name : "NMBR",
      gene_level : 2,
      hgnc_id : "HGNC:7843",
      havana_gene : "OTTHUMG00000015704.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 142133090,
      stop : 142135151,
      direction : "+",
      ID : "ENSG00000203733.5",
      gene_id : "ENSG00000203733.5",
      gene_type : "protein_coding",
      gene_name : "GJE1",
      gene_level : 2,
      hgnc_id : "HGNC:33251",
      havana_gene : "OTTHUMG00000015706.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 142147162,
      stop : 142224685,
      direction : "+",
      ID : "ENSG00000009844.16",
      gene_id : "ENSG00000009844.16",
      gene_type : "protein_coding",
      gene_name : "VTA1",
      gene_level : 2,
      hgnc_id : "HGNC:20954",
      havana_gene : "OTTHUMG00000015707.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 142301854,
      stop : 142446266,
      direction : "+",
      ID : "ENSG00000112414.15",
      gene_id : "ENSG00000112414.15",
      gene_type : "protein_coding",
      gene_name : "ADGRG6",
      gene_level : 2,
      hgnc_id : "HGNC:13841",
      havana_gene : "OTTHUMG00000015709.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 142751469,
      stop : 142956698,
      direction : "-",
      ID : "ENSG00000010818.10",
      gene_id : "ENSG00000010818.10",
      gene_type : "protein_coding",
      gene_name : "HIVEP2",
      gene_level : 2,
      hgnc_id : "HGNC:4921",
      havana_gene : "OTTHUMG00000015713.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143060496,
      stop : 143341058,
      direction : "+",
      ID : "ENSG00000146416.19",
      gene_id : "ENSG00000146416.19",
      gene_type : "protein_coding",
      gene_name : "AIG1",
      gene_level : 2,
      hgnc_id : "HGNC:21607",
      havana_gene : "OTTHUMG00000015721.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143422832,
      stop : 143450695,
      direction : "-",
      ID : "ENSG00000189007.16",
      gene_id : "ENSG00000189007.16",
      gene_type : "protein_coding",
      gene_name : "ADAT2",
      gene_level : 2,
      hgnc_id : "HGNC:21172",
      havana_gene : "OTTHUMG00000015725.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143450805,
      stop : 143490616,
      direction : "+",
      ID : "ENSG00000034693.15",
      gene_id : "ENSG00000034693.15",
      gene_type : "protein_coding",
      gene_name : "PEX3",
      gene_level : 1,
      hgnc_id : "HGNC:8858",
      havana_gene : "OTTHUMG00000015730.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143494812,
      stop : 143511720,
      direction : "-",
      ID : "ENSG00000001036.14",
      gene_id : "ENSG00000001036.14",
      gene_type : "protein_coding",
      gene_name : "FUCA2",
      gene_level : 2,
      hgnc_id : "HGNC:4008",
      havana_gene : "OTTHUMG00000015728.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143536845,
      stop : 143831185,
      direction : "+",
      ID : "ENSG00000112419.14",
      gene_id : "ENSG00000112419.14",
      gene_type : "protein_coding",
      gene_name : "PHACTR2",
      gene_level : 1,
      hgnc_id : "HGNC:20956",
      havana_gene : "OTTHUMG00000015732.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143807092,
      stop : 143844617,
      direction : "+",
      ID : "ENSG00000257065.1",
      gene_id : "ENSG00000257065.1",
      gene_type : "protein_coding",
      gene_name : "AL049844.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000167907.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143843338,
      stop : 143863812,
      direction : "+",
      ID : "ENSG00000135521.9",
      gene_id : "ENSG00000135521.9",
      gene_type : "protein_coding",
      gene_name : "LTV1",
      gene_level : 2,
      hgnc_id : "HGNC:21173",
      havana_gene : "OTTHUMG00000015733.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143857318,
      stop : 143938471,
      direction : "+",
      ID : "ENSG00000280148.1",
      gene_id : "ENSG00000280148.1",
      gene_type : "protein_coding",
      gene_name : "AL049844.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189261.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143864436,
      stop : 143938343,
      direction : "+",
      ID : "ENSG00000118491.10",
      gene_id : "ENSG00000118491.10",
      gene_type : "protein_coding",
      gene_name : "ZC2HC1B",
      gene_level : 2,
      hgnc_id : "HGNC:21174",
      havana_gene : "OTTHUMG00000015734.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 143940300,
      stop : 144064599,
      direction : "-",
      ID : "ENSG00000118495.20",
      gene_id : "ENSG00000118495.20",
      gene_type : "protein_coding",
      gene_name : "PLAGL1",
      gene_level : 2,
      hgnc_id : "HGNC:9046",
      havana_gene : "OTTHUMG00000015738.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 144094884,
      stop : 144095573,
      direction : "-",
      ID : "ENSG00000169976.7",
      gene_id : "ENSG00000169976.7",
      gene_type : "protein_coding",
      gene_name : "SF3B5",
      gene_level : 2,
      hgnc_id : "HGNC:21083",
      havana_gene : "OTTHUMG00000015737.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 144150517,
      stop : 144191939,
      direction : "+",
      ID : "ENSG00000135604.10",
      gene_id : "ENSG00000135604.10",
      gene_type : "protein_coding",
      gene_name : "STX11",
      gene_level : 2,
      hgnc_id : "HGNC:11429",
      havana_gene : "OTTHUMG00000015739.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 144285701,
      stop : 144853034,
      direction : "+",
      ID : "ENSG00000152818.18",
      gene_id : "ENSG00000152818.18",
      gene_type : "protein_coding",
      gene_name : "UTRN",
      gene_level : 2,
      hgnc_id : "HGNC:12635",
      havana_gene : "OTTHUMG00000015746.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 145382535,
      stop : 145736023,
      direction : "-",
      ID : "ENSG00000112425.16",
      gene_id : "ENSG00000112425.16",
      gene_type : "protein_coding",
      gene_name : "EPM2A",
      gene_level : 2,
      hgnc_id : "HGNC:3413",
      havana_gene : "OTTHUMG00000015747.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 145793502,
      stop : 145814795,
      direction : "-",
      ID : "ENSG00000118496.5",
      gene_id : "ENSG00000118496.5",
      gene_type : "protein_coding",
      gene_name : "FBXO30",
      gene_level : 2,
      hgnc_id : "HGNC:15600",
      havana_gene : "OTTHUMG00000015749.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 145864245,
      stop : 145964423,
      direction : "-",
      ID : "ENSG00000146414.16",
      gene_id : "ENSG00000146414.16",
      gene_type : "protein_coding",
      gene_name : "SHPRH",
      gene_level : 2,
      hgnc_id : "HGNC:19336",
      havana_gene : "OTTHUMG00000015750.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 146027646,
      stop : 146437601,
      direction : "+",
      ID : "ENSG00000152822.14",
      gene_id : "ENSG00000152822.14",
      gene_type : "protein_coding",
      gene_name : "GRM1",
      gene_level : 2,
      hgnc_id : "HGNC:4593",
      havana_gene : "OTTHUMG00000015752.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 146543833,
      stop : 146554953,
      direction : "+",
      ID : "ENSG00000118508.5",
      gene_id : "ENSG00000118508.5",
      gene_type : "protein_coding",
      gene_name : "RAB32",
      gene_level : 2,
      hgnc_id : "HGNC:9772",
      havana_gene : "OTTHUMG00000015755.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 146598967,
      stop : 146815462,
      direction : "+",
      ID : "ENSG00000118492.18",
      gene_id : "ENSG00000118492.18",
      gene_type : "protein_coding",
      gene_name : "ADGB",
      gene_level : 1,
      hgnc_id : "HGNC:21212",
      havana_gene : "OTTHUMG00000015758.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 147204425,
      stop : 147390476,
      direction : "+",
      ID : "ENSG00000164506.14",
      gene_id : "ENSG00000164506.14",
      gene_type : "protein_coding",
      gene_name : "STXBP5",
      gene_level : 2,
      hgnc_id : "HGNC:19665",
      havana_gene : "OTTHUMG00000015766.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 147508690,
      stop : 147737547,
      direction : "+",
      ID : "ENSG00000203727.4",
      gene_id : "ENSG00000203727.4",
      gene_type : "protein_coding",
      gene_name : "SAMD5",
      gene_level : 2,
      hgnc_id : "HGNC:21180",
      havana_gene : "OTTHUMG00000015767.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 148272304,
      stop : 148552048,
      direction : "+",
      ID : "ENSG00000111961.18",
      gene_id : "ENSG00000111961.18",
      gene_type : "protein_coding",
      gene_name : "SASH1",
      gene_level : 2,
      hgnc_id : "HGNC:19182",
      havana_gene : "OTTHUMG00000015773.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 148747030,
      stop : 149076990,
      direction : "+",
      ID : "ENSG00000111962.8",
      gene_id : "ENSG00000111962.8",
      gene_type : "protein_coding",
      gene_name : "UST",
      gene_level : 2,
      hgnc_id : "HGNC:17223",
      havana_gene : "OTTHUMG00000016135.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149218641,
      stop : 149411613,
      direction : "+",
      ID : "ENSG00000055208.19",
      gene_id : "ENSG00000055208.19",
      gene_type : "protein_coding",
      gene_name : "TAB2",
      gene_level : 1,
      hgnc_id : "HGNC:17075",
      havana_gene : "OTTHUMG00000015783.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149400262,
      stop : 149401278,
      direction : "+",
      ID : "ENSG00000177688.7",
      gene_id : "ENSG00000177688.7",
      gene_type : "protein_coding",
      gene_name : "SUMO4",
      gene_level : 2,
      hgnc_id : "HGNC:21181",
      havana_gene : "OTTHUMG00000015785.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149446795,
      stop : 149485014,
      direction : "-",
      ID : "ENSG00000178199.14",
      gene_id : "ENSG00000178199.14",
      gene_type : "protein_coding",
      gene_name : "ZC3H12D",
      gene_level : 1,
      hgnc_id : "HGNC:21175",
      havana_gene : "OTTHUMG00000015786.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149504495,
      stop : 149546043,
      direction : "-",
      ID : "ENSG00000131013.4",
      gene_id : "ENSG00000131013.4",
      gene_type : "protein_coding",
      gene_name : "PPIL4",
      gene_level : 2,
      hgnc_id : "HGNC:15702",
      havana_gene : "OTTHUMG00000015788.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149566294,
      stop : 149591748,
      direction : "+",
      ID : "ENSG00000055211.14",
      gene_id : "ENSG00000055211.14",
      gene_type : "protein_coding",
      gene_name : "GINM1",
      gene_level : 2,
      hgnc_id : "HGNC:21074",
      havana_gene : "OTTHUMG00000015789.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149594873,
      stop : 149648972,
      direction : "-",
      ID : "ENSG00000186625.14",
      gene_id : "ENSG00000186625.14",
      gene_type : "protein_coding",
      gene_name : "KATNA1",
      gene_level : 2,
      hgnc_id : "HGNC:6216",
      havana_gene : "OTTHUMG00000015787.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149658153,
      stop : 149718105,
      direction : "-",
      ID : "ENSG00000131023.13",
      gene_id : "ENSG00000131023.13",
      gene_type : "protein_coding",
      gene_name : "LATS1",
      gene_level : 1,
      hgnc_id : "HGNC:6514",
      havana_gene : "OTTHUMG00000016437.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149724315,
      stop : 149749665,
      direction : "-",
      ID : "ENSG00000120253.14",
      gene_id : "ENSG00000120253.14",
      gene_type : "protein_coding",
      gene_name : "NUP43",
      gene_level : 1,
      hgnc_id : "HGNC:21182",
      havana_gene : "OTTHUMG00000015795.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149749443,
      stop : 149811420,
      direction : "+",
      ID : "ENSG00000120265.18",
      gene_id : "ENSG00000120265.18",
      gene_type : "protein_coding",
      gene_name : "PCMT1",
      gene_level : 1,
      hgnc_id : "HGNC:8728",
      havana_gene : "OTTHUMG00000015794.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149817937,
      stop : 149896011,
      direction : "-",
      ID : "ENSG00000285991.1",
      gene_id : "ENSG00000285991.1",
      gene_type : "protein_coding",
      gene_name : "AL355312.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193392.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149818757,
      stop : 149864359,
      direction : "-",
      ID : "ENSG00000120256.11",
      gene_id : "ENSG00000120256.11",
      gene_type : "protein_coding",
      gene_name : "LRP11",
      gene_level : 2,
      hgnc_id : "HGNC:16936",
      havana_gene : "OTTHUMG00000015801.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149883375,
      stop : 149898102,
      direction : "-",
      ID : "ENSG00000164520.11",
      gene_id : "ENSG00000164520.11",
      gene_type : "protein_coding",
      gene_name : "RAET1E",
      gene_level : 2,
      hgnc_id : "HGNC:16793",
      havana_gene : "OTTHUMG00000015796.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149916878,
      stop : 149923121,
      direction : "-",
      ID : "ENSG00000203722.8",
      gene_id : "ENSG00000203722.8",
      gene_type : "protein_coding",
      gene_name : "RAET1G",
      gene_level : 2,
      hgnc_id : "HGNC:16795",
      havana_gene : "OTTHUMG00000015802.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149942014,
      stop : 149949235,
      direction : "+",
      ID : "ENSG00000131015.5",
      gene_id : "ENSG00000131015.5",
      gene_type : "protein_coding",
      gene_name : "ULBP2",
      gene_level : 2,
      hgnc_id : "HGNC:14894",
      havana_gene : "OTTHUMG00000015803.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 149963943,
      stop : 149973715,
      direction : "+",
      ID : "ENSG00000111981.5",
      gene_id : "ENSG00000111981.5",
      gene_type : "protein_coding",
      gene_name : "ULBP1",
      gene_level : 2,
      hgnc_id : "HGNC:14893",
      havana_gene : "OTTHUMG00000015810.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 150018334,
      stop : 150025532,
      direction : "-",
      ID : "ENSG00000155918.8",
      gene_id : "ENSG00000155918.8",
      gene_type : "protein_coding",
      gene_name : "RAET1L",
      gene_level : 2,
      hgnc_id : "HGNC:16798",
      havana_gene : "OTTHUMG00000015809.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 150061053,
      stop : 150069121,
      direction : "-",
      ID : "ENSG00000131019.11",
      gene_id : "ENSG00000131019.11",
      gene_type : "protein_coding",
      gene_name : "ULBP3",
      gene_level : 2,
      hgnc_id : "HGNC:14895",
      havana_gene : "OTTHUMG00000015811.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 150143044,
      stop : 150250392,
      direction : "+",
      ID : "ENSG00000198729.5",
      gene_id : "ENSG00000198729.5",
      gene_type : "protein_coding",
      gene_name : "PPP1R14C",
      gene_level : 2,
      hgnc_id : "HGNC:14952",
      havana_gene : "OTTHUMG00000015818.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 150368892,
      stop : 150405969,
      direction : "+",
      ID : "ENSG00000009765.15",
      gene_id : "ENSG00000009765.15",
      gene_type : "protein_coding",
      gene_name : "IYD",
      gene_level : 2,
      hgnc_id : "HGNC:21071",
      havana_gene : "OTTHUMG00000016347.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 150599883,
      stop : 150843665,
      direction : "+",
      ID : "ENSG00000120278.16",
      gene_id : "ENSG00000120278.16",
      gene_type : "protein_coding",
      gene_name : "PLEKHG1",
      gene_level : 2,
      hgnc_id : "HGNC:20884",
      havana_gene : "OTTHUMG00000015824.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 150865679,
      stop : 151101887,
      direction : "+",
      ID : "ENSG00000120254.16",
      gene_id : "ENSG00000120254.16",
      gene_type : "protein_coding",
      gene_name : "MTHFD1L",
      gene_level : 2,
      hgnc_id : "HGNC:21055",
      havana_gene : "OTTHUMG00000015828.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 151239967,
      stop : 151358559,
      direction : "+",
      ID : "ENSG00000131016.17",
      gene_id : "ENSG00000131016.17",
      gene_type : "protein_coding",
      gene_name : "AKAP12",
      gene_level : 2,
      hgnc_id : "HGNC:370",
      havana_gene : "OTTHUMG00000015833.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 151364115,
      stop : 151391559,
      direction : "-",
      ID : "ENSG00000181472.5",
      gene_id : "ENSG00000181472.5",
      gene_type : "protein_coding",
      gene_name : "ZBTB2",
      gene_level : 2,
      hgnc_id : "HGNC:20868",
      havana_gene : "OTTHUMG00000015834.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 151404762,
      stop : 151452158,
      direction : "-",
      ID : "ENSG00000155906.19",
      gene_id : "ENSG00000155906.19",
      gene_type : "protein_coding",
      gene_name : "RMND1",
      gene_level : 2,
      hgnc_id : "HGNC:21176",
      havana_gene : "OTTHUMG00000015837.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 151452258,
      stop : 151470101,
      direction : "+",
      ID : "ENSG00000146476.11",
      gene_id : "ENSG00000146476.11",
      gene_type : "protein_coding",
      gene_name : "ARMT1",
      gene_level : 2,
      hgnc_id : "HGNC:17872",
      havana_gene : "OTTHUMG00000015838.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 151494017,
      stop : 151621193,
      direction : "+",
      ID : "ENSG00000120262.10",
      gene_id : "ENSG00000120262.10",
      gene_type : "protein_coding",
      gene_name : "CCDC170",
      gene_level : 2,
      hgnc_id : "HGNC:21177",
      havana_gene : "OTTHUMG00000015839.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 151656691,
      stop : 152129619,
      direction : "+",
      ID : "ENSG00000091831.24",
      gene_id : "ENSG00000091831.24",
      gene_type : "protein_coding",
      gene_name : "ESR1",
      gene_level : 2,
      hgnc_id : "HGNC:3467",
      havana_gene : "OTTHUMG00000016103.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 152121684,
      stop : 152637801,
      direction : "-",
      ID : "ENSG00000131018.24",
      gene_id : "ENSG00000131018.24",
      gene_type : "protein_coding",
      gene_name : "SYNE1",
      gene_level : 1,
      hgnc_id : "HGNC:17089",
      havana_gene : "OTTHUMG00000015841.14",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 152697895,
      stop : 152724567,
      direction : "+",
      ID : "ENSG00000120279.6",
      gene_id : "ENSG00000120279.6",
      gene_type : "protein_coding",
      gene_name : "MYCT1",
      gene_level : 2,
      hgnc_id : "HGNC:23172",
      havana_gene : "OTTHUMG00000015850.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 152750797,
      stop : 152759765,
      direction : "+",
      ID : "ENSG00000146469.13",
      gene_id : "ENSG00000146469.13",
      gene_type : "protein_coding",
      gene_name : "VIP",
      gene_level : 2,
      hgnc_id : "HGNC:12693",
      havana_gene : "OTTHUMG00000015851.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 152970519,
      stop : 152983579,
      direction : "-",
      ID : "ENSG00000112029.10",
      gene_id : "ENSG00000112029.10",
      gene_type : "protein_coding",
      gene_name : "FBXO5",
      gene_level : 2,
      hgnc_id : "HGNC:13584",
      havana_gene : "OTTHUMG00000015854.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 152987362,
      stop : 153002709,
      direction : "-",
      ID : "ENSG00000112031.16",
      gene_id : "ENSG00000112031.16",
      gene_type : "protein_coding",
      gene_name : "MTRF1L",
      gene_level : 2,
      hgnc_id : "HGNC:21051",
      havana_gene : "OTTHUMG00000015857.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 153004459,
      stop : 153131282,
      direction : "-",
      ID : "ENSG00000091844.8",
      gene_id : "ENSG00000091844.8",
      gene_type : "protein_coding",
      gene_name : "RGS17",
      gene_level : 2,
      hgnc_id : "HGNC:14088",
      havana_gene : "OTTHUMG00000015858.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 154010496,
      stop : 154246867,
      direction : "+",
      ID : "ENSG00000112038.18",
      gene_id : "ENSG00000112038.18",
      gene_type : "protein_coding",
      gene_name : "OPRM1",
      gene_level : 1,
      hgnc_id : "HGNC:8156",
      havana_gene : "OTTHUMG00000015870.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 154154496,
      stop : 154356792,
      direction : "-",
      ID : "ENSG00000074706.13",
      gene_id : "ENSG00000074706.13",
      gene_type : "protein_coding",
      gene_name : "IPCEF1",
      gene_level : 1,
      hgnc_id : "HGNC:21204",
      havana_gene : "OTTHUMG00000015872.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 154159828,
      stop : 154510114,
      direction : "-",
      ID : "ENSG00000288520.1",
      gene_id : "ENSG00000288520.1",
      gene_type : "protein_coding",
      gene_name : "AL357075.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000195928.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 154387515,
      stop : 154510685,
      direction : "-",
      ID : "ENSG00000153721.19",
      gene_id : "ENSG00000153721.19",
      gene_type : "protein_coding",
      gene_name : "CNKSR3",
      gene_level : 1,
      hgnc_id : "HGNC:23034",
      havana_gene : "OTTHUMG00000015873.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 154733378,
      stop : 154834244,
      direction : "+",
      ID : "ENSG00000213079.10",
      gene_id : "ENSG00000213079.10",
      gene_type : "protein_coding",
      gene_name : "SCAF8",
      gene_level : 2,
      hgnc_id : "HGNC:20959",
      havana_gene : "OTTHUMG00000015877.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 154832697,
      stop : 155257723,
      direction : "+",
      ID : "ENSG00000146426.18",
      gene_id : "ENSG00000146426.18",
      gene_type : "protein_coding",
      gene_name : "TIAM2",
      gene_level : 1,
      hgnc_id : "HGNC:11806",
      havana_gene : "OTTHUMG00000015880.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 155256134,
      stop : 155314493,
      direction : "-",
      ID : "ENSG00000029639.11",
      gene_id : "ENSG00000029639.11",
      gene_type : "protein_coding",
      gene_name : "TFB1M",
      gene_level : 2,
      hgnc_id : "HGNC:17037",
      havana_gene : "OTTHUMG00000015881.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 155264013,
      stop : 155276548,
      direction : "+",
      ID : "ENSG00000171217.5",
      gene_id : "ENSG00000171217.5",
      gene_type : "protein_coding",
      gene_name : "CLDN20",
      gene_level : 2,
      hgnc_id : "HGNC:2042",
      havana_gene : "OTTHUMG00000015882.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 155395368,
      stop : 155455839,
      direction : "-",
      ID : "ENSG00000074771.4",
      gene_id : "ENSG00000074771.4",
      gene_type : "protein_coding",
      gene_name : "NOX3",
      gene_level : 2,
      hgnc_id : "HGNC:7890",
      havana_gene : "OTTHUMG00000015883.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 156776020,
      stop : 157210779,
      direction : "+",
      ID : "ENSG00000049618.24",
      gene_id : "ENSG00000049618.24",
      gene_type : "protein_coding",
      gene_name : "ARID1B",
      gene_level : 1,
      hgnc_id : "HGNC:18040",
      havana_gene : "OTTHUMG00000015890.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 157289025,
      stop : 157323601,
      direction : "-",
      ID : "ENSG00000215712.11",
      gene_id : "ENSG00000215712.11",
      gene_type : "protein_coding",
      gene_name : "TMEM242",
      gene_level : 2,
      hgnc_id : "HGNC:17206",
      havana_gene : "OTTHUMG00000015893.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 157381133,
      stop : 157678157,
      direction : "+",
      ID : "ENSG00000175048.17",
      gene_id : "ENSG00000175048.17",
      gene_type : "protein_coding",
      gene_name : "ZDHHC14",
      gene_level : 2,
      hgnc_id : "HGNC:20341",
      havana_gene : "OTTHUMG00000015896.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 157700387,
      stop : 157945077,
      direction : "+",
      ID : "ENSG00000130340.17",
      gene_id : "ENSG00000130340.17",
      gene_type : "protein_coding",
      gene_name : "SNX9",
      gene_level : 2,
      hgnc_id : "HGNC:14973",
      havana_gene : "OTTHUMG00000015903.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 157981863,
      stop : 158099176,
      direction : "+",
      ID : "ENSG00000078269.15",
      gene_id : "ENSG00000078269.15",
      gene_type : "protein_coding",
      gene_name : "SYNJ2",
      gene_level : 2,
      hgnc_id : "HGNC:11504",
      havana_gene : "OTTHUMG00000015904.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158109519,
      stop : 158168280,
      direction : "-",
      ID : "ENSG00000122335.17",
      gene_id : "ENSG00000122335.17",
      gene_type : "protein_coding",
      gene_name : "SERAC1",
      gene_level : 2,
      hgnc_id : "HGNC:21061",
      havana_gene : "OTTHUMG00000015905.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158168350,
      stop : 158199344,
      direction : "+",
      ID : "ENSG00000272047.3",
      gene_id : "ENSG00000272047.3",
      gene_type : "protein_coding",
      gene_name : "GTF2H5",
      gene_level : 2,
      hgnc_id : "HGNC:21157",
      havana_gene : "OTTHUMG00000015906.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158232236,
      stop : 158511828,
      direction : "+",
      ID : "ENSG00000130338.13",
      gene_id : "ENSG00000130338.13",
      gene_type : "protein_coding",
      gene_name : "TULP4",
      gene_level : 2,
      hgnc_id : "HGNC:15530",
      havana_gene : "OTTHUMG00000015910.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158536436,
      stop : 158635428,
      direction : "+",
      ID : "ENSG00000146433.9",
      gene_id : "ENSG00000146433.9",
      gene_type : "protein_coding",
      gene_name : "TMEM181",
      gene_level : 2,
      hgnc_id : "HGNC:20958",
      havana_gene : "OTTHUMG00000015913.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158636474,
      stop : 158644743,
      direction : "-",
      ID : "ENSG00000146425.11",
      gene_id : "ENSG00000146425.11",
      gene_type : "protein_coding",
      gene_name : "DYNLT1",
      gene_level : 2,
      hgnc_id : "HGNC:11697",
      havana_gene : "OTTHUMG00000015918.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158650014,
      stop : 158764876,
      direction : "+",
      ID : "ENSG00000164674.17",
      gene_id : "ENSG00000164674.17",
      gene_type : "protein_coding",
      gene_name : "SYTL3",
      gene_level : 2,
      hgnc_id : "HGNC:15587",
      havana_gene : "OTTHUMG00000015916.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158765741,
      stop : 158819368,
      direction : "-",
      ID : "ENSG00000092820.18",
      gene_id : "ENSG00000092820.18",
      gene_type : "protein_coding",
      gene_name : "EZR",
      gene_level : 2,
      hgnc_id : "HGNC:12691",
      havana_gene : "OTTHUMG00000015917.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 158972871,
      stop : 159000202,
      direction : "-",
      ID : "ENSG00000130363.13",
      gene_id : "ENSG00000130363.13",
      gene_type : "protein_coding",
      gene_name : "RSPH3",
      gene_level : 2,
      hgnc_id : "HGNC:21054",
      havana_gene : "OTTHUMG00000015924.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159034468,
      stop : 159045152,
      direction : "-",
      ID : "ENSG00000164691.18",
      gene_id : "ENSG00000164691.18",
      gene_type : "protein_coding",
      gene_name : "TAGAP",
      gene_level : 2,
      hgnc_id : "HGNC:15669",
      havana_gene : "OTTHUMG00000015923.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159169400,
      stop : 159272108,
      direction : "+",
      ID : "ENSG00000164694.17",
      gene_id : "ENSG00000164694.17",
      gene_type : "protein_coding",
      gene_name : "FNDC1",
      gene_level : 2,
      hgnc_id : "HGNC:21184",
      havana_gene : "OTTHUMG00000015927.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159669069,
      stop : 159762529,
      direction : "-",
      ID : "ENSG00000112096.19",
      gene_id : "ENSG00000112096.19",
      gene_type : "protein_coding",
      gene_name : "SOD2",
      gene_level : 1,
      hgnc_id : "HGNC:11180",
      havana_gene : "OTTHUMG00000015940.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159725585,
      stop : 159756319,
      direction : "+",
      ID : "ENSG00000146457.16",
      gene_id : "ENSG00000146457.16",
      gene_type : "protein_coding",
      gene_name : "WTAP",
      gene_level : 2,
      hgnc_id : "HGNC:16846",
      havana_gene : "OTTHUMG00000015933.7",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159762045,
      stop : 159779112,
      direction : "+",
      ID : "ENSG00000120437.9",
      gene_id : "ENSG00000120437.9",
      gene_type : "protein_coding",
      gene_name : "ACAT2",
      gene_level : 2,
      hgnc_id : "HGNC:94",
      havana_gene : "OTTHUMG00000015935.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159778498,
      stop : 159789703,
      direction : "-",
      ID : "ENSG00000120438.12",
      gene_id : "ENSG00000120438.12",
      gene_type : "protein_coding",
      gene_name : "TCP1",
      gene_level : 2,
      hgnc_id : "HGNC:11655",
      havana_gene : "OTTHUMG00000015937.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159789812,
      stop : 159798436,
      direction : "+",
      ID : "ENSG00000112110.10",
      gene_id : "ENSG00000112110.10",
      gene_type : "protein_coding",
      gene_name : "MRPL18",
      gene_level : 2,
      hgnc_id : "HGNC:14477",
      havana_gene : "OTTHUMG00000015942.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159800249,
      stop : 159820704,
      direction : "+",
      ID : "ENSG00000146453.13",
      gene_id : "ENSG00000146453.13",
      gene_type : "protein_coding",
      gene_name : "PNLDC1",
      gene_level : 2,
      hgnc_id : "HGNC:21185",
      havana_gene : "OTTHUMG00000015941.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159890988,
      stop : 159917447,
      direction : "+",
      ID : "ENSG00000130368.7",
      gene_id : "ENSG00000130368.7",
      gene_type : "protein_coding",
      gene_name : "MAS1",
      gene_level : 2,
      hgnc_id : "HGNC:6899",
      havana_gene : "OTTHUMG00000015944.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 159969082,
      stop : 160113507,
      direction : "+",
      ID : "ENSG00000197081.16",
      gene_id : "ENSG00000197081.16",
      gene_type : "protein_coding",
      gene_name : "IGF2R",
      gene_level : 2,
      hgnc_id : "HGNC:5467",
      havana_gene : "OTTHUMG00000015945.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 160121815,
      stop : 160158718,
      direction : "+",
      ID : "ENSG00000175003.15",
      gene_id : "ENSG00000175003.15",
      gene_type : "protein_coding",
      gene_name : "SLC22A1",
      gene_level : 1,
      hgnc_id : "HGNC:10963",
      havana_gene : "OTTHUMG00000015947.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 160171061,
      stop : 160277638,
      direction : "-",
      ID : "ENSG00000112499.13",
      gene_id : "ENSG00000112499.13",
      gene_type : "protein_coding",
      gene_name : "SLC22A2",
      gene_level : 2,
      hgnc_id : "HGNC:10966",
      havana_gene : "OTTHUMG00000015950.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 160348378,
      stop : 160452577,
      direction : "+",
      ID : "ENSG00000146477.6",
      gene_id : "ENSG00000146477.6",
      gene_type : "protein_coding",
      gene_name : "SLC22A3",
      gene_level : 2,
      hgnc_id : "HGNC:10967",
      havana_gene : "OTTHUMG00000015953.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 160531482,
      stop : 160664275,
      direction : "-",
      ID : "ENSG00000198670.12",
      gene_id : "ENSG00000198670.12",
      gene_type : "protein_coding",
      gene_name : "LPA",
      gene_level : 2,
      hgnc_id : "HGNC:6667",
      havana_gene : "OTTHUMG00000015956.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 160702238,
      stop : 160754097,
      direction : "+",
      ID : "ENSG00000122194.19",
      gene_id : "ENSG00000122194.19",
      gene_type : "protein_coding",
      gene_name : "PLG",
      gene_level : 1,
      hgnc_id : "HGNC:9071",
      havana_gene : "OTTHUMG00000015957.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 160991727,
      stop : 161117385,
      direction : "+",
      ID : "ENSG00000085511.20",
      gene_id : "ENSG00000085511.20",
      gene_type : "protein_coding",
      gene_name : "MAP3K4",
      gene_level : 2,
      hgnc_id : "HGNC:6856",
      havana_gene : "OTTHUMG00000015968.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 161129967,
      stop : 161274061,
      direction : "-",
      ID : "ENSG00000026652.15",
      gene_id : "ENSG00000026652.15",
      gene_type : "protein_coding",
      gene_name : "AGPAT4",
      gene_level : 2,
      hgnc_id : "HGNC:20885",
      havana_gene : "OTTHUMG00000015966.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 161347417,
      stop : 162727775,
      direction : "-",
      ID : "ENSG00000185345.23",
      gene_id : "ENSG00000185345.23",
      gene_type : "protein_coding",
      gene_name : "PRKN",
      gene_level : 2,
      hgnc_id : "HGNC:8607",
      havana_gene : "OTTHUMG00000015970.14",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 162727132,
      stop : 163315492,
      direction : "+",
      ID : "ENSG00000112530.11",
      gene_id : "ENSG00000112530.11",
      gene_type : "protein_coding",
      gene_name : "PACRG",
      gene_level : 2,
      hgnc_id : "HGNC:19152",
      havana_gene : "OTTHUMG00000016116.2",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 163414000,
      stop : 163578592,
      direction : "+",
      ID : "ENSG00000112531.17",
      gene_id : "ENSG00000112531.17",
      gene_type : "protein_coding",
      gene_name : "QKI",
      gene_level : 2,
      hgnc_id : "HGNC:21100",
      havana_gene : "OTTHUMG00000015977.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 165279664,
      stop : 165309605,
      direction : "-",
      ID : "ENSG00000112539.15",
      gene_id : "ENSG00000112539.15",
      gene_type : "protein_coding",
      gene_name : "C6orf118",
      gene_level : 2,
      hgnc_id : "HGNC:21233",
      havana_gene : "OTTHUMG00000015984.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 165327287,
      stop : 165988078,
      direction : "-",
      ID : "ENSG00000112541.18",
      gene_id : "ENSG00000112541.18",
      gene_type : "protein_coding",
      gene_name : "PDE10A",
      gene_level : 2,
      hgnc_id : "HGNC:8772",
      havana_gene : "OTTHUMG00000015986.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166157656,
      stop : 166168700,
      direction : "-",
      ID : "ENSG00000164458.10",
      gene_id : "ENSG00000164458.10",
      gene_type : "protein_coding",
      gene_name : "TBXT",
      gene_level : 2,
      hgnc_id : "HGNC:11515",
      havana_gene : "OTTHUMG00000015991.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166305300,
      stop : 166308448,
      direction : "-",
      ID : "ENSG00000176381.6",
      gene_id : "ENSG00000176381.6",
      gene_type : "protein_coding",
      gene_name : "PRR18",
      gene_level : 2,
      hgnc_id : "HGNC:28574",
      havana_gene : "OTTHUMG00000167034.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166319728,
      stop : 166342576,
      direction : "-",
      ID : "ENSG00000198818.10",
      gene_id : "ENSG00000198818.10",
      gene_type : "protein_coding",
      gene_name : "SFT2D1",
      gene_level : 2,
      hgnc_id : "HGNC:21102",
      havana_gene : "OTTHUMG00000016001.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166364919,
      stop : 166383013,
      direction : "-",
      ID : "ENSG00000060762.19",
      gene_id : "ENSG00000060762.19",
      gene_type : "protein_coding",
      gene_name : "MPC1",
      gene_level : 2,
      hgnc_id : "HGNC:21606",
      havana_gene : "OTTHUMG00000015999.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166409364,
      stop : 166906451,
      direction : "-",
      ID : "ENSG00000071242.12",
      gene_id : "ENSG00000071242.12",
      gene_type : "protein_coding",
      gene_name : "RPS6KA2",
      gene_level : 1,
      hgnc_id : "HGNC:10431",
      havana_gene : "OTTHUMG00000016007.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166585604,
      stop : 166587594,
      direction : "-",
      ID : "ENSG00000235272.2",
      gene_id : "ENSG00000235272.2",
      gene_type : "protein_coding",
      gene_name : "RAMACL",
      gene_level : 2,
      hgnc_id : "HGNC:21234",
      havana_gene : "OTTHUMG00000016003.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166858094,
      stop : 166956124,
      direction : "-",
      ID : "ENSG00000249141.1",
      gene_id : "ENSG00000249141.1",
      gene_type : "protein_coding",
      gene_name : "AL159163.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160910.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166922113,
      stop : 166957191,
      direction : "-",
      ID : "ENSG00000026297.16",
      gene_id : "ENSG00000026297.16",
      gene_type : "protein_coding",
      gene_name : "RNASET2",
      gene_level : 2,
      hgnc_id : "HGNC:21686",
      havana_gene : "OTTHUMG00000016009.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 166999317,
      stop : 167094789,
      direction : "+",
      ID : "ENSG00000213066.13",
      gene_id : "ENSG00000213066.13",
      gene_type : "protein_coding",
      gene_name : "CEP43",
      gene_level : 2,
      hgnc_id : "HGNC:17012",
      havana_gene : "OTTHUMG00000016011.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167111807,
      stop : 167139696,
      direction : "+",
      ID : "ENSG00000112486.17",
      gene_id : "ENSG00000112486.17",
      gene_type : "protein_coding",
      gene_name : "CCR6",
      gene_level : 2,
      hgnc_id : "HGNC:1607",
      havana_gene : "OTTHUMG00000016015.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167146414,
      stop : 167196913,
      direction : "+",
      ID : "ENSG00000166984.12",
      gene_id : "ENSG00000166984.12",
      gene_type : "protein_coding",
      gene_name : "TCP10L2",
      gene_level : 2,
      hgnc_id : "HGNC:21254",
      havana_gene : "OTTHUMG00000016014.10",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167155247,
      stop : 167157980,
      direction : "-",
      ID : "ENSG00000120436.4",
      gene_id : "ENSG00000120436.4",
      gene_type : "protein_coding",
      gene_name : "GPR31",
      gene_level : 2,
      hgnc_id : "HGNC:4486",
      havana_gene : "OTTHUMG00000016013.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167271169,
      stop : 167316014,
      direction : "+",
      ID : "ENSG00000112494.10",
      gene_id : "ENSG00000112494.10",
      gene_type : "protein_coding",
      gene_name : "UNC93A",
      gene_level : 2,
      hgnc_id : "HGNC:12570",
      havana_gene : "OTTHUMG00000016021.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167325071,
      stop : 167359503,
      direction : "+",
      ID : "ENSG00000120440.15",
      gene_id : "ENSG00000120440.15",
      gene_type : "protein_coding",
      gene_name : "TTLL2",
      gene_level : 2,
      hgnc_id : "HGNC:21211",
      havana_gene : "OTTHUMG00000016023.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167826922,
      stop : 167972023,
      direction : "+",
      ID : "ENSG00000130396.20",
      gene_id : "ENSG00000130396.20",
      gene_type : "protein_coding",
      gene_name : "AFDN",
      gene_level : 1,
      hgnc_id : "HGNC:7137",
      havana_gene : "OTTHUMG00000016031.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 167996241,
      stop : 168045095,
      direction : "+",
      ID : "ENSG00000125337.19",
      gene_id : "ENSG00000125337.19",
      gene_type : "protein_coding",
      gene_name : "KIF25",
      gene_level : 2,
      hgnc_id : "HGNC:6390",
      havana_gene : "OTTHUMG00000016035.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 168053166,
      stop : 168101511,
      direction : "-",
      ID : "ENSG00000153303.17",
      gene_id : "ENSG00000153303.17",
      gene_type : "protein_coding",
      gene_name : "FRMD1",
      gene_level : 2,
      hgnc_id : "HGNC:21240",
      havana_gene : "OTTHUMG00000016037.9",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 168292830,
      stop : 168319777,
      direction : "-",
      ID : "ENSG00000164488.12",
      gene_id : "ENSG00000164488.12",
      gene_type : "protein_coding",
      gene_name : "DACT2",
      gene_level : 2,
      hgnc_id : "HGNC:21231",
      havana_gene : "OTTHUMG00000016046.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 168441151,
      stop : 168673445,
      direction : "+",
      ID : "ENSG00000112562.19",
      gene_id : "ENSG00000112562.19",
      gene_type : "protein_coding",
      gene_name : "SMOC2",
      gene_level : 2,
      hgnc_id : "HGNC:20323",
      havana_gene : "OTTHUMG00000016050.5",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169215780,
      stop : 169254050,
      direction : "-",
      ID : "ENSG00000186340.17",
      gene_id : "ENSG00000186340.17",
      gene_type : "protein_coding",
      gene_name : "THBS2",
      gene_level : 2,
      hgnc_id : "HGNC:11786",
      havana_gene : "OTTHUMG00000045408.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169419969,
      stop : 169702047,
      direction : "-",
      ID : "ENSG00000285733.1",
      gene_id : "ENSG00000285733.1",
      gene_type : "protein_coding",
      gene_name : "AL031315.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192627.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169457212,
      stop : 169702067,
      direction : "-",
      ID : "ENSG00000184465.16",
      gene_id : "ENSG00000184465.16",
      gene_type : "protein_coding",
      gene_name : "WDR27",
      gene_level : 2,
      hgnc_id : "HGNC:21248",
      havana_gene : "OTTHUMG00000016061.12",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169702190,
      stop : 169704856,
      direction : "+",
      ID : "ENSG00000185127.6",
      gene_id : "ENSG00000185127.6",
      gene_type : "protein_coding",
      gene_name : "C6orf120",
      gene_level : 2,
      hgnc_id : "HGNC:21247",
      havana_gene : "OTTHUMG00000016057.1",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169703902,
      stop : 169725566,
      direction : "-",
      ID : "ENSG00000130024.15",
      gene_id : "ENSG00000130024.15",
      gene_type : "protein_coding",
      gene_name : "PHF10",
      gene_level : 2,
      hgnc_id : "HGNC:18250",
      havana_gene : "OTTHUMG00000016058.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169740109,
      stop : 169751587,
      direction : "-",
      ID : "ENSG00000184786.6",
      gene_id : "ENSG00000184786.6",
      gene_type : "protein_coding",
      gene_name : "DYNLT2",
      gene_level : 2,
      hgnc_id : "HGNC:11695",
      havana_gene : "OTTHUMG00000016068.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 169751622,
      stop : 169781600,
      direction : "+",
      ID : "ENSG00000130023.16",
      gene_id : "ENSG00000130023.16",
      gene_type : "protein_coding",
      gene_name : "ERMARD",
      gene_level : 1,
      hgnc_id : "HGNC:21056",
      havana_gene : "OTTHUMG00000016067.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 170282206,
      stop : 170306565,
      direction : "-",
      ID : "ENSG00000198719.9",
      gene_id : "ENSG00000198719.9",
      gene_type : "protein_coding",
      gene_name : "DLL1",
      gene_level : 2,
      hgnc_id : "HGNC:2908",
      havana_gene : "OTTHUMG00000016078.4",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 170290703,
      stop : 170407067,
      direction : "+",
      ID : "ENSG00000112584.14",
      gene_id : "ENSG00000112584.14",
      gene_type : "protein_coding",
      gene_name : "FAM120B",
      gene_level : 2,
      hgnc_id : "HGNC:21109",
      havana_gene : "OTTHUMG00000016080.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 170535120,
      stop : 170553307,
      direction : "-",
      ID : "ENSG00000008018.9",
      gene_id : "ENSG00000008018.9",
      gene_type : "protein_coding",
      gene_name : "PSMB1",
      gene_level : 2,
      hgnc_id : "HGNC:9537",
      havana_gene : "OTTHUMG00000016087.3",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 170554302,
      stop : 170572870,
      direction : "+",
      ID : "ENSG00000112592.14",
      gene_id : "ENSG00000112592.14",
      gene_type : "protein_coding",
      gene_name : "TBP",
      gene_level : 1,
      hgnc_id : "HGNC:11588",
      havana_gene : "OTTHUMG00000016084.6",
      tag : null
    },
    {
      chromosome : 6,
      annotation : "HAVANA",
      type : "gene",
      start : 170575295,
      stop : 170584692,
      direction : "-",
      ID : "ENSG00000071994.11",
      gene_id : "ENSG00000071994.11",
      gene_type : "protein_coding",
      gene_name : "PDCD2",
      gene_level : 1,
      hgnc_id : "HGNC:8762",
      havana_gene : "OTTHUMG00000016083.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 192571,
      stop : 260772,
      direction : "+",
      ID : "ENSG00000177706.9",
      gene_id : "ENSG00000177706.9",
      gene_type : "protein_coding",
      gene_name : "FAM20C",
      gene_level : 1,
      hgnc_id : "HGNC:22140",
      havana_gene : "OTTHUMG00000151401.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 290170,
      stop : 294422,
      direction : "+",
      ID : "ENSG00000248767.2",
      gene_id : "ENSG00000248767.2",
      gene_type : "protein_coding",
      gene_name : "FOXL3",
      gene_level : 2,
      hgnc_id : "HGNC:54201",
      havana_gene : "OTTHUMG00000160232.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 497258,
      stop : 520296,
      direction : "-",
      ID : "ENSG00000197461.13",
      gene_id : "ENSG00000197461.13",
      gene_type : "protein_coding",
      gene_name : "PDGFA",
      gene_level : 1,
      hgnc_id : "HGNC:8799",
      havana_gene : "OTTHUMG00000151412.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 549197,
      stop : 727650,
      direction : "-",
      ID : "ENSG00000188191.15",
      gene_id : "ENSG00000188191.15",
      gene_type : "protein_coding",
      gene_name : "PRKAR1B",
      gene_level : 1,
      hgnc_id : "HGNC:9390",
      havana_gene : "OTTHUMG00000151411.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 726699,
      stop : 786475,
      direction : "+",
      ID : "ENSG00000164818.16",
      gene_id : "ENSG00000164818.16",
      gene_type : "protein_coding",
      gene_name : "DNAAF5",
      gene_level : 1,
      hgnc_id : "HGNC:26013",
      havana_gene : "OTTHUMG00000151416.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 816615,
      stop : 896435,
      direction : "+",
      ID : "ENSG00000164828.18",
      gene_id : "ENSG00000164828.18",
      gene_type : "protein_coding",
      gene_name : "SUN1",
      gene_level : 1,
      hgnc_id : "HGNC:18587",
      havana_gene : "OTTHUMG00000151426.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 876554,
      stop : 896436,
      direction : "+",
      ID : "ENSG00000239857.7",
      gene_id : "ENSG00000239857.7",
      gene_type : "protein_coding",
      gene_name : "GET4",
      gene_level : 1,
      hgnc_id : "HGNC:21690",
      havana_gene : "OTTHUMG00000112459.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 897900,
      stop : 955407,
      direction : "-",
      ID : "ENSG00000105963.15",
      gene_id : "ENSG00000105963.15",
      gene_type : "protein_coding",
      gene_name : "ADAP1",
      gene_level : 1,
      hgnc_id : "HGNC:16486",
      havana_gene : "OTTHUMG00000023380.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 898778,
      stop : 975549,
      direction : "-",
      ID : "ENSG00000240230.6",
      gene_id : "ENSG00000240230.6",
      gene_type : "protein_coding",
      gene_name : "COX19",
      gene_level : 2,
      hgnc_id : "HGNC:28074",
      havana_gene : "OTTHUMG00000151476.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 983181,
      stop : 989640,
      direction : "+",
      ID : "ENSG00000073067.14",
      gene_id : "ENSG00000073067.14",
      gene_type : "protein_coding",
      gene_name : "CYP2W1",
      gene_level : 2,
      hgnc_id : "HGNC:20243",
      havana_gene : "OTTHUMG00000074071.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 996986,
      stop : 1138260,
      direction : "-",
      ID : "ENSG00000146540.15",
      gene_id : "ENSG00000146540.15",
      gene_type : "protein_coding",
      gene_name : "C7orf50",
      gene_level : 2,
      hgnc_id : "HGNC:22421",
      havana_gene : "OTTHUMG00000151477.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1044546,
      stop : 1059261,
      direction : "+",
      ID : "ENSG00000164849.10",
      gene_id : "ENSG00000164849.10",
      gene_type : "protein_coding",
      gene_name : "GPR146",
      gene_level : 1,
      hgnc_id : "HGNC:21718",
      havana_gene : "OTTHUMG00000023934.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1082208,
      stop : 1093815,
      direction : "+",
      ID : "ENSG00000164850.15",
      gene_id : "ENSG00000164850.15",
      gene_type : "protein_coding",
      gene_name : "GPER1",
      gene_level : 2,
      hgnc_id : "HGNC:4485",
      havana_gene : "OTTHUMG00000023680.5",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1152071,
      stop : 1160759,
      direction : "-",
      ID : "ENSG00000178381.12",
      gene_id : "ENSG00000178381.12",
      gene_type : "protein_coding",
      gene_name : "ZFAND2A",
      gene_level : 1,
      hgnc_id : "HGNC:28073",
      havana_gene : "OTTHUMG00000119019.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1232872,
      stop : 1237326,
      direction : "+",
      ID : "ENSG00000164853.9",
      gene_id : "ENSG00000164853.9",
      gene_type : "protein_coding",
      gene_name : "UNCX",
      gene_level : 2,
      hgnc_id : "HGNC:33194",
      havana_gene : "OTTHUMG00000152022.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1428465,
      stop : 1459470,
      direction : "-",
      ID : "ENSG00000164877.19",
      gene_id : "ENSG00000164877.19",
      gene_type : "protein_coding",
      gene_name : "MICALL2",
      gene_level : 2,
      hgnc_id : "HGNC:29672",
      havana_gene : "OTTHUMG00000119021.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1470277,
      stop : 1504389,
      direction : "-",
      ID : "ENSG00000164880.16",
      gene_id : "ENSG00000164880.16",
      gene_type : "protein_coding",
      gene_name : "INTS1",
      gene_level : 1,
      hgnc_id : "HGNC:24555",
      havana_gene : "OTTHUMG00000151449.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1530702,
      stop : 1543043,
      direction : "+",
      ID : "ENSG00000198517.10",
      gene_id : "ENSG00000198517.10",
      gene_type : "protein_coding",
      gene_name : "MAFK",
      gene_level : 2,
      hgnc_id : "HGNC:6782",
      havana_gene : "OTTHUMG00000151453.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1542235,
      stop : 1560821,
      direction : "-",
      ID : "ENSG00000164855.16",
      gene_id : "ENSG00000164855.16",
      gene_type : "protein_coding",
      gene_name : "TMEM184A",
      gene_level : 2,
      hgnc_id : "HGNC:28797",
      havana_gene : "OTTHUMG00000119025.13",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1567332,
      stop : 1571005,
      direction : "-",
      ID : "ENSG00000157778.9",
      gene_id : "ENSG00000157778.9",
      gene_type : "protein_coding",
      gene_name : "PSMG3",
      gene_level : 1,
      hgnc_id : "HGNC:22420",
      havana_gene : "OTTHUMG00000119043.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1688119,
      stop : 1747954,
      direction : "+",
      ID : "ENSG00000225968.7",
      gene_id : "ENSG00000225968.7",
      gene_type : "protein_coding",
      gene_name : "ELFN1",
      gene_level : 2,
      hgnc_id : "HGNC:33154",
      havana_gene : "OTTHUMG00000151495.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1815793,
      stop : 2233243,
      direction : "-",
      ID : "ENSG00000002822.16",
      gene_id : "ENSG00000002822.16",
      gene_type : "protein_coding",
      gene_name : "MAD1L1",
      gene_level : 1,
      hgnc_id : "HGNC:6762",
      havana_gene : "OTTHUMG00000151493.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 1815804,
      stop : 2242215,
      direction : "-",
      ID : "ENSG00000286192.1",
      gene_id : "ENSG00000286192.1",
      gene_type : "protein_coding",
      gene_name : "AC069288.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193455.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2234195,
      stop : 2242205,
      direction : "-",
      ID : "ENSG00000122687.19",
      gene_id : "ENSG00000122687.19",
      gene_type : "protein_coding",
      gene_name : "MRM2",
      gene_level : 2,
      hgnc_id : "HGNC:16352",
      havana_gene : "OTTHUMG00000023866.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2242226,
      stop : 2251146,
      direction : "+",
      ID : "ENSG00000106268.16",
      gene_id : "ENSG00000106268.16",
      gene_type : "protein_coding",
      gene_name : "NUDT1",
      gene_level : 2,
      hgnc_id : "HGNC:8048",
      havana_gene : "OTTHUMG00000023072.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2251770,
      stop : 2354318,
      direction : "-",
      ID : "ENSG00000106266.11",
      gene_id : "ENSG00000106266.11",
      gene_type : "protein_coding",
      gene_name : "SNX8",
      gene_level : 1,
      hgnc_id : "HGNC:14972",
      havana_gene : "OTTHUMG00000151512.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2354086,
      stop : 2380745,
      direction : "+",
      ID : "ENSG00000106263.18",
      gene_id : "ENSG00000106263.18",
      gene_type : "protein_coding",
      gene_name : "EIF3B",
      gene_level : 2,
      hgnc_id : "HGNC:3280",
      havana_gene : "OTTHUMG00000022839.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2403588,
      stop : 2448484,
      direction : "+",
      ID : "ENSG00000136213.10",
      gene_id : "ENSG00000136213.10",
      gene_type : "protein_coding",
      gene_name : "CHST12",
      gene_level : 2,
      hgnc_id : "HGNC:17423",
      havana_gene : "OTTHUMG00000023849.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2474844,
      stop : 2476894,
      direction : "-",
      ID : "ENSG00000275572.1",
      gene_id : "ENSG00000275572.1",
      gene_type : "protein_coding",
      gene_name : "GRIFIN",
      gene_level : 2,
      hgnc_id : "HGNC:4577",
      havana_gene : "OTTHUMG00000152042.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2512529,
      stop : 2529177,
      direction : "+",
      ID : "ENSG00000106003.13",
      gene_id : "ENSG00000106003.13",
      gene_type : "protein_coding",
      gene_name : "LFNG",
      gene_level : 1,
      hgnc_id : "HGNC:6560",
      havana_gene : "OTTHUMG00000152043.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2537810,
      stop : 2555694,
      direction : "-",
      ID : "ENSG00000106009.16",
      gene_id : "ENSG00000106009.16",
      gene_type : "protein_coding",
      gene_name : "BRAT1",
      gene_level : 2,
      hgnc_id : "HGNC:21701",
      havana_gene : "OTTHUMG00000119091.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2558972,
      stop : 2614733,
      direction : "+",
      ID : "ENSG00000106012.18",
      gene_id : "ENSG00000106012.18",
      gene_type : "protein_coding",
      gene_name : "IQCE",
      gene_level : 1,
      hgnc_id : "HGNC:29171",
      havana_gene : "OTTHUMG00000152047.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2631986,
      stop : 2664802,
      direction : "+",
      ID : "ENSG00000136295.15",
      gene_id : "ENSG00000136295.15",
      gene_type : "protein_coding",
      gene_name : "TTYH3",
      gene_level : 2,
      hgnc_id : "HGNC:22222",
      havana_gene : "OTTHUMG00000152050.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2679522,
      stop : 2775500,
      direction : "+",
      ID : "ENSG00000174945.13",
      gene_id : "ENSG00000174945.13",
      gene_type : "protein_coding",
      gene_name : "AMZ1",
      gene_level : 1,
      hgnc_id : "HGNC:22231",
      havana_gene : "OTTHUMG00000152111.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2728105,
      stop : 2844308,
      direction : "-",
      ID : "ENSG00000146535.14",
      gene_id : "ENSG00000146535.14",
      gene_type : "protein_coding",
      gene_name : "GNA12",
      gene_level : 1,
      hgnc_id : "HGNC:4380",
      havana_gene : "OTTHUMG00000023064.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 2906142,
      stop : 3043867,
      direction : "-",
      ID : "ENSG00000198286.10",
      gene_id : "ENSG00000198286.10",
      gene_type : "protein_coding",
      gene_name : "CARD11",
      gene_level : 2,
      hgnc_id : "HGNC:16393",
      havana_gene : "OTTHUMG00000023023.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 3301252,
      stop : 4269000,
      direction : "+",
      ID : "ENSG00000146555.19",
      gene_id : "ENSG00000146555.19",
      gene_type : "protein_coding",
      gene_name : "SDK1",
      gene_level : 1,
      hgnc_id : "HGNC:19307",
      havana_gene : "OTTHUMG00000151733.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 4682295,
      stop : 4771442,
      direction : "+",
      ID : "ENSG00000164916.11",
      gene_id : "ENSG00000164916.11",
      gene_type : "protein_coding",
      gene_name : "FOXK1",
      gene_level : 2,
      hgnc_id : "HGNC:23480",
      havana_gene : "OTTHUMG00000151739.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 4775615,
      stop : 4794397,
      direction : "+",
      ID : "ENSG00000242802.9",
      gene_id : "ENSG00000242802.9",
      gene_type : "protein_coding",
      gene_name : "AP5Z1",
      gene_level : 2,
      hgnc_id : "HGNC:22197",
      havana_gene : "OTTHUMG00000151754.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 4797055,
      stop : 4883716,
      direction : "-",
      ID : "ENSG00000157927.17",
      gene_id : "ENSG00000157927.17",
      gene_type : "protein_coding",
      gene_name : "RADIL",
      gene_level : 2,
      hgnc_id : "HGNC:22226",
      havana_gene : "OTTHUMG00000151753.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 4857738,
      stop : 4862030,
      direction : "-",
      ID : "ENSG00000218823.2",
      gene_id : "ENSG00000218823.2",
      gene_type : "protein_coding",
      gene_name : "PAPOLB",
      gene_level : 2,
      hgnc_id : "HGNC:15970",
      havana_gene : "OTTHUMG00000151759.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 4905989,
      stop : 4959213,
      direction : "-",
      ID : "ENSG00000136297.15",
      gene_id : "ENSG00000136297.15",
      gene_type : "protein_coding",
      gene_name : "MMD2",
      gene_level : 2,
      hgnc_id : "HGNC:30133",
      havana_gene : "OTTHUMG00000151844.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 4983718,
      stop : 5073221,
      direction : "+",
      ID : "ENSG00000272968.5",
      gene_id : "ENSG00000272968.5",
      gene_type : "protein_coding",
      gene_name : "RBAK-RBAKDN",
      gene_level : 2,
      hgnc_id : "HGNC:42971",
      havana_gene : "OTTHUMG00000186010.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5045821,
      stop : 5069487,
      direction : "+",
      ID : "ENSG00000146587.18",
      gene_id : "ENSG00000146587.18",
      gene_type : "protein_coding",
      gene_name : "RBAK",
      gene_level : 1,
      hgnc_id : "HGNC:17680",
      havana_gene : "OTTHUMG00000121155.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5190196,
      stop : 5233840,
      direction : "+",
      ID : "ENSG00000157954.15",
      gene_id : "ENSG00000157954.15",
      gene_type : "protein_coding",
      gene_name : "WIPI2",
      gene_level : 2,
      hgnc_id : "HGNC:32225",
      havana_gene : "OTTHUMG00000121179.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5274369,
      stop : 5306912,
      direction : "+",
      ID : "ENSG00000164638.11",
      gene_id : "ENSG00000164638.11",
      gene_type : "protein_coding",
      gene_name : "SLC29A4",
      gene_level : 2,
      hgnc_id : "HGNC:23097",
      havana_gene : "OTTHUMG00000023797.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5306790,
      stop : 5425414,
      direction : "-",
      ID : "ENSG00000182095.14",
      gene_id : "ENSG00000182095.14",
      gene_type : "protein_coding",
      gene_name : "TNRC18",
      gene_level : 1,
      hgnc_id : "HGNC:11962",
      havana_gene : "OTTHUMG00000151831.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5431335,
      stop : 5513809,
      direction : "-",
      ID : "ENSG00000155034.19",
      gene_id : "ENSG00000155034.19",
      gene_type : "protein_coding",
      gene_name : "FBXL18",
      gene_level : 2,
      hgnc_id : "HGNC:21874",
      havana_gene : "OTTHUMG00000151832.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5526409,
      stop : 5563902,
      direction : "-",
      ID : "ENSG00000075624.17",
      gene_id : "ENSG00000075624.17",
      gene_type : "protein_coding",
      gene_name : "ACTB",
      gene_level : 2,
      hgnc_id : "HGNC:132",
      havana_gene : "OTTHUMG00000023268.12",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5592816,
      stop : 5606655,
      direction : "+",
      ID : "ENSG00000075618.18",
      gene_id : "ENSG00000075618.18",
      gene_type : "protein_coding",
      gene_name : "FSCN1",
      gene_level : 1,
      hgnc_id : "HGNC:11148",
      havana_gene : "OTTHUMG00000090599.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5620047,
      stop : 5781696,
      direction : "-",
      ID : "ENSG00000011275.19",
      gene_id : "ENSG00000011275.19",
      gene_type : "protein_coding",
      gene_name : "RNF216",
      gene_level : 2,
      hgnc_id : "HGNC:21698",
      havana_gene : "OTTHUMG00000155500.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5879827,
      stop : 5886363,
      direction : "+",
      ID : "ENSG00000122543.11",
      gene_id : "ENSG00000122543.11",
      gene_type : "protein_coding",
      gene_name : "OCM",
      gene_level : 2,
      hgnc_id : "HGNC:8105",
      havana_gene : "OTTHUMG00000155499.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5898725,
      stop : 5926550,
      direction : "+",
      ID : "ENSG00000122674.12",
      gene_id : "ENSG00000122674.12",
      gene_type : "protein_coding",
      gene_name : "CCZ1",
      gene_level : 2,
      hgnc_id : "HGNC:21691",
      havana_gene : "OTTHUMG00000155502.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5925550,
      stop : 5970683,
      direction : "-",
      ID : "ENSG00000155026.16",
      gene_id : "ENSG00000155026.16",
      gene_type : "protein_coding",
      gene_name : "RSPH10B",
      gene_level : 2,
      hgnc_id : "HGNC:27362",
      havana_gene : "OTTHUMG00000152378.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 5970925,
      stop : 6009106,
      direction : "-",
      ID : "ENSG00000122512.16",
      gene_id : "ENSG00000122512.16",
      gene_type : "protein_coding",
      gene_name : "PMS2",
      gene_level : 2,
      hgnc_id : "HGNC:9122",
      havana_gene : "OTTHUMG00000023135.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6009255,
      stop : 6023834,
      direction : "+",
      ID : "ENSG00000106305.10",
      gene_id : "ENSG00000106305.10",
      gene_type : "protein_coding",
      gene_name : "AIMP2",
      gene_level : 1,
      hgnc_id : "HGNC:20609",
      havana_gene : "OTTHUMG00000122077.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6022247,
      stop : 6059175,
      direction : "-",
      ID : "ENSG00000086232.13",
      gene_id : "ENSG00000086232.13",
      gene_type : "protein_coding",
      gene_name : "EIF2AK1",
      gene_level : 1,
      hgnc_id : "HGNC:24921",
      havana_gene : "OTTHUMG00000090689.15",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6031376,
      stop : 6036552,
      direction : "+",
      ID : "ENSG00000157999.6",
      gene_id : "ENSG00000157999.6",
      gene_type : "protein_coding",
      gene_name : "ANKRD61",
      gene_level : 1,
      hgnc_id : "HGNC:22467",
      havana_gene : "OTTHUMG00000154561.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6104884,
      stop : 6161564,
      direction : "+",
      ID : "ENSG00000106346.11",
      gene_id : "ENSG00000106346.11",
      gene_type : "protein_coding",
      gene_name : "USP42",
      gene_level : 1,
      hgnc_id : "HGNC:20068",
      havana_gene : "OTTHUMG00000151888.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6161776,
      stop : 6272644,
      direction : "-",
      ID : "ENSG00000008256.16",
      gene_id : "ENSG00000008256.16",
      gene_type : "protein_coding",
      gene_name : "CYTH3",
      gene_level : 2,
      hgnc_id : "HGNC:9504",
      havana_gene : "OTTHUMG00000023440.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6329411,
      stop : 6348981,
      direction : "-",
      ID : "ENSG00000178397.13",
      gene_id : "ENSG00000178397.13",
      gene_type : "protein_coding",
      gene_name : "FAM220A",
      gene_level : 2,
      hgnc_id : "HGNC:22422",
      havana_gene : "OTTHUMG00000193524.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6331215,
      stop : 6348758,
      direction : "-",
      ID : "ENSG00000286075.2",
      gene_id : "ENSG00000286075.2",
      gene_type : "protein_coding",
      gene_name : "AC009412.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000122091.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6374527,
      stop : 6403967,
      direction : "+",
      ID : "ENSG00000136238.18",
      gene_id : "ENSG00000136238.18",
      gene_type : "protein_coding",
      gene_name : "RAC1",
      gene_level : 2,
      hgnc_id : "HGNC:9801",
      havana_gene : "OTTHUMG00000023540.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6409126,
      stop : 6484190,
      direction : "-",
      ID : "ENSG00000164535.15",
      gene_id : "ENSG00000164535.15",
      gene_type : "protein_coding",
      gene_name : "DAGLB",
      gene_level : 1,
      hgnc_id : "HGNC:28923",
      havana_gene : "OTTHUMG00000125513.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6445953,
      stop : 6484190,
      direction : "-",
      ID : "ENSG00000136240.10",
      gene_id : "ENSG00000136240.10",
      gene_type : "protein_coding",
      gene_name : "KDELR2",
      gene_level : 2,
      hgnc_id : "HGNC:6305",
      havana_gene : "OTTHUMG00000023103.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6497462,
      stop : 6551436,
      direction : "-",
      ID : "ENSG00000215045.8",
      gene_id : "ENSG00000215045.8",
      gene_type : "protein_coding",
      gene_name : "GRID2IP",
      gene_level : 1,
      hgnc_id : "HGNC:18464",
      havana_gene : "OTTHUMG00000155531.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6577434,
      stop : 6589374,
      direction : "+",
      ID : "ENSG00000136247.15",
      gene_id : "ENSG00000136247.15",
      gene_type : "protein_coding",
      gene_name : "ZDHHC4",
      gene_level : 2,
      hgnc_id : "HGNC:18471",
      havana_gene : "OTTHUMG00000023579.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6590021,
      stop : 6608726,
      direction : "+",
      ID : "ENSG00000146576.13",
      gene_id : "ENSG00000146576.13",
      gene_type : "protein_coding",
      gene_name : "C7orf26",
      gene_level : 2,
      hgnc_id : "HGNC:21702",
      havana_gene : "OTTHUMG00000125517.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6615610,
      stop : 6624290,
      direction : "+",
      ID : "ENSG00000236609.4",
      gene_id : "ENSG00000236609.4",
      gene_type : "protein_coding",
      gene_name : "ZNF853",
      gene_level : 1,
      hgnc_id : "HGNC:21767",
      havana_gene : "OTTHUMG00000151853.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6637318,
      stop : 6658279,
      direction : "+",
      ID : "ENSG00000205903.7",
      gene_id : "ENSG00000205903.7",
      gene_type : "protein_coding",
      gene_name : "ZNF316",
      gene_level : 2,
      hgnc_id : "HGNC:13843",
      havana_gene : "OTTHUMG00000151854.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6688433,
      stop : 6706947,
      direction : "-",
      ID : "ENSG00000164631.19",
      gene_id : "ENSG00000164631.19",
      gene_type : "protein_coding",
      gene_name : "ZNF12",
      gene_level : 1,
      hgnc_id : "HGNC:12902",
      havana_gene : "OTTHUMG00000151910.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6754109,
      stop : 6799365,
      direction : "+",
      ID : "ENSG00000169402.15",
      gene_id : "ENSG00000169402.15",
      gene_type : "protein_coding",
      gene_name : "RSPH10B2",
      gene_level : 2,
      hgnc_id : "HGNC:34385",
      havana_gene : "OTTHUMG00000151856.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 6794134,
      stop : 6826770,
      direction : "-",
      ID : "ENSG00000146574.16",
      gene_id : "ENSG00000146574.16",
      gene_type : "protein_coding",
      gene_name : "CCZ1B",
      gene_level : 2,
      hgnc_id : "HGNC:21717",
      havana_gene : "OTTHUMG00000152441.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 7156934,
      stop : 7248616,
      direction : "+",
      ID : "ENSG00000106392.11",
      gene_id : "ENSG00000106392.11",
      gene_type : "protein_coding",
      gene_name : "C1GALT1",
      gene_level : 2,
      hgnc_id : "HGNC:24337",
      havana_gene : "OTTHUMG00000151912.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 7356203,
      stop : 7535873,
      direction : "-",
      ID : "ENSG00000215018.10",
      gene_id : "ENSG00000215018.10",
      gene_type : "protein_coding",
      gene_name : "COL28A1",
      gene_level : 1,
      hgnc_id : "HGNC:22442",
      havana_gene : "OTTHUMG00000150034.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 7566875,
      stop : 7608932,
      direction : "+",
      ID : "ENSG00000164654.16",
      gene_id : "ENSG00000164654.16",
      gene_type : "protein_coding",
      gene_name : "MIOS",
      gene_level : 2,
      hgnc_id : "HGNC:21905",
      havana_gene : "OTTHUMG00000152440.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 7636518,
      stop : 7718607,
      direction : "-",
      ID : "ENSG00000106399.11",
      gene_id : "ENSG00000106399.11",
      gene_type : "protein_coding",
      gene_name : "RPA3",
      gene_level : 2,
      hgnc_id : "HGNC:10291",
      havana_gene : "OTTHUMG00000023748.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 7640711,
      stop : 7968020,
      direction : "+",
      ID : "ENSG00000219545.11",
      gene_id : "ENSG00000219545.11",
      gene_type : "protein_coding",
      gene_name : "UMAD1",
      gene_level : 2,
      hgnc_id : "HGNC:48955",
      havana_gene : "OTTHUMG00000152007.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 7968796,
      stop : 8094272,
      direction : "+",
      ID : "ENSG00000106415.13",
      gene_id : "ENSG00000106415.13",
      gene_type : "protein_coding",
      gene_name : "GLCCI1",
      gene_level : 2,
      hgnc_id : "HGNC:18713",
      havana_gene : "OTTHUMG00000151984.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 8113184,
      stop : 8262687,
      direction : "-",
      ID : "ENSG00000003147.19",
      gene_id : "ENSG00000003147.19",
      gene_type : "protein_coding",
      gene_name : "ICA1",
      gene_level : 2,
      hgnc_id : "HGNC:5343",
      havana_gene : "OTTHUMG00000152008.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 8433609,
      stop : 8752961,
      direction : "+",
      ID : "ENSG00000122584.13",
      gene_id : "ENSG00000122584.13",
      gene_type : "protein_coding",
      gene_name : "NXPH1",
      gene_level : 2,
      hgnc_id : "HGNC:20693",
      havana_gene : "OTTHUMG00000151941.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 10931943,
      stop : 10940153,
      direction : "-",
      ID : "ENSG00000189043.10",
      gene_id : "ENSG00000189043.10",
      gene_type : "protein_coding",
      gene_name : "NDUFA4",
      gene_level : 2,
      hgnc_id : "HGNC:7687",
      havana_gene : "OTTHUMG00000023880.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 10973336,
      stop : 11169623,
      direction : "+",
      ID : "ENSG00000106443.17",
      gene_id : "ENSG00000106443.17",
      gene_type : "protein_coding",
      gene_name : "PHF14",
      gene_level : 2,
      hgnc_id : "HGNC:22203",
      havana_gene : "OTTHUMG00000150463.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 11370365,
      stop : 11832198,
      direction : "-",
      ID : "ENSG00000005108.16",
      gene_id : "ENSG00000005108.16",
      gene_type : "protein_coding",
      gene_name : "THSD7A",
      gene_level : 2,
      hgnc_id : "HGNC:22207",
      havana_gene : "OTTHUMG00000152346.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 12211270,
      stop : 12243367,
      direction : "+",
      ID : "ENSG00000106460.19",
      gene_id : "ENSG00000106460.19",
      gene_type : "protein_coding",
      gene_name : "TMEM106B",
      gene_level : 2,
      hgnc_id : "HGNC:22407",
      havana_gene : "OTTHUMG00000125537.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 12330885,
      stop : 12403941,
      direction : "-",
      ID : "ENSG00000146530.14",
      gene_id : "ENSG00000146530.14",
      gene_type : "protein_coding",
      gene_name : "VWDE",
      gene_level : 2,
      hgnc_id : "HGNC:21897",
      havana_gene : "OTTHUMG00000152315.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 12469621,
      stop : 12542222,
      direction : "+",
      ID : "ENSG00000226690.8",
      gene_id : "ENSG00000226690.8",
      gene_type : "protein_coding",
      gene_name : "AC013470.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000152383.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 12570577,
      stop : 12660182,
      direction : "+",
      ID : "ENSG00000006747.15",
      gene_id : "ENSG00000006747.15",
      gene_type : "protein_coding",
      gene_name : "SCIN",
      gene_level : 1,
      hgnc_id : "HGNC:21695",
      havana_gene : "OTTHUMG00000152385.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 12686856,
      stop : 12690958,
      direction : "+",
      ID : "ENSG00000122644.13",
      gene_id : "ENSG00000122644.13",
      gene_type : "protein_coding",
      gene_name : "ARL4A",
      gene_level : 2,
      hgnc_id : "HGNC:695",
      havana_gene : "OTTHUMG00000023374.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 13891229,
      stop : 13991425,
      direction : "-",
      ID : "ENSG00000006468.14",
      gene_id : "ENSG00000006468.14",
      gene_type : "protein_coding",
      gene_name : "ETV1",
      gene_level : 1,
      hgnc_id : "HGNC:3490",
      havana_gene : "OTTHUMG00000152403.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 14145049,
      stop : 14974777,
      direction : "-",
      ID : "ENSG00000136267.14",
      gene_id : "ENSG00000136267.14",
      gene_type : "protein_coding",
      gene_name : "DGKB",
      gene_level : 2,
      hgnc_id : "HGNC:2850",
      havana_gene : "OTTHUMG00000152477.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 15200317,
      stop : 15562015,
      direction : "-",
      ID : "ENSG00000187546.14",
      gene_id : "ENSG00000187546.14",
      gene_type : "protein_coding",
      gene_name : "AGMO",
      gene_level : 1,
      hgnc_id : "HGNC:33784",
      havana_gene : "OTTHUMG00000152387.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 15611212,
      stop : 15686683,
      direction : "-",
      ID : "ENSG00000106511.6",
      gene_id : "ENSG00000106511.6",
      gene_type : "protein_coding",
      gene_name : "MEOX2",
      gene_level : 2,
      hgnc_id : "HGNC:7014",
      havana_gene : "OTTHUMG00000152390.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16087525,
      stop : 16502504,
      direction : "-",
      ID : "ENSG00000214960.11",
      gene_id : "ENSG00000214960.11",
      gene_type : "protein_coding",
      gene_name : "CRPPA",
      gene_level : 2,
      hgnc_id : "HGNC:37276",
      havana_gene : "OTTHUMG00000152447.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16461481,
      stop : 16530580,
      direction : "-",
      ID : "ENSG00000171243.8",
      gene_id : "ENSG00000171243.8",
      gene_type : "protein_coding",
      gene_name : "SOSTDC1",
      gene_level : 1,
      hgnc_id : "HGNC:21748",
      havana_gene : "OTTHUMG00000090807.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16526825,
      stop : 16581568,
      direction : "+",
      ID : "ENSG00000205858.10",
      gene_id : "ENSG00000205858.10",
      gene_type : "protein_coding",
      gene_name : "LRRC72",
      gene_level : 2,
      hgnc_id : "HGNC:42972",
      havana_gene : "OTTHUMG00000152446.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16599779,
      stop : 16645817,
      direction : "-",
      ID : "ENSG00000106524.9",
      gene_id : "ENSG00000106524.9",
      gene_type : "protein_coding",
      gene_name : "ANKMY2",
      gene_level : 2,
      hgnc_id : "HGNC:25370",
      havana_gene : "OTTHUMG00000090806.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16646131,
      stop : 16706523,
      direction : "+",
      ID : "ENSG00000136261.15",
      gene_id : "ENSG00000136261.15",
      gene_type : "protein_coding",
      gene_name : "BZW2",
      gene_level : 2,
      hgnc_id : "HGNC:18808",
      havana_gene : "OTTHUMG00000130755.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16753755,
      stop : 16784536,
      direction : "+",
      ID : "ENSG00000106537.8",
      gene_id : "ENSG00000106537.8",
      gene_type : "protein_coding",
      gene_name : "TSPAN13",
      gene_level : 2,
      hgnc_id : "HGNC:21643",
      havana_gene : "OTTHUMG00000022968.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16791811,
      stop : 16833433,
      direction : "-",
      ID : "ENSG00000106541.12",
      gene_id : "ENSG00000106541.12",
      gene_type : "protein_coding",
      gene_name : "AGR2",
      gene_level : 1,
      hgnc_id : "HGNC:328",
      havana_gene : "OTTHUMG00000023446.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16859412,
      stop : 16881987,
      direction : "-",
      ID : "ENSG00000173467.9",
      gene_id : "ENSG00000173467.9",
      gene_type : "protein_coding",
      gene_name : "AGR3",
      gene_level : 2,
      hgnc_id : "HGNC:24167",
      havana_gene : "OTTHUMG00000128411.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 16916359,
      stop : 17346152,
      direction : "+",
      ID : "ENSG00000106546.14",
      gene_id : "ENSG00000106546.14",
      gene_type : "protein_coding",
      gene_name : "AHR",
      gene_level : 2,
      hgnc_id : "HGNC:348",
      havana_gene : "OTTHUMG00000149967.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 17299295,
      stop : 17467234,
      direction : "+",
      ID : "ENSG00000283321.1",
      gene_id : "ENSG00000283321.1",
      gene_type : "protein_coding",
      gene_name : "AC019117.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191686.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 17790761,
      stop : 17940501,
      direction : "-",
      ID : "ENSG00000071189.21",
      gene_id : "ENSG00000071189.21",
      gene_type : "protein_coding",
      gene_name : "SNX13",
      gene_level : 1,
      hgnc_id : "HGNC:21335",
      havana_gene : "OTTHUMG00000152730.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 18026770,
      stop : 18027846,
      direction : "-",
      ID : "ENSG00000229937.9",
      gene_id : "ENSG00000229937.9",
      gene_type : "protein_coding",
      gene_name : "PRPS1L1",
      gene_level : 2,
      hgnc_id : "HGNC:9463",
      havana_gene : "OTTHUMG00000152742.2",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 18086949,
      stop : 19002416,
      direction : "+",
      ID : "ENSG00000048052.23",
      gene_id : "ENSG00000048052.23",
      gene_type : "protein_coding",
      gene_name : "HDAC9",
      gene_level : 1,
      hgnc_id : "HGNC:14065",
      havana_gene : "OTTHUMG00000152487.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 19020991,
      stop : 19117636,
      direction : "-",
      ID : "ENSG00000122691.13",
      gene_id : "ENSG00000122691.13",
      gene_type : "protein_coding",
      gene_name : "TWIST1",
      gene_level : 2,
      hgnc_id : "HGNC:12428",
      havana_gene : "OTTHUMG00000090821.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 19144782,
      stop : 19145421,
      direction : "-",
      ID : "ENSG00000146618.3",
      gene_id : "ENSG00000146618.3",
      gene_type : "protein_coding",
      gene_name : "FERD3L",
      gene_level : 2,
      hgnc_id : "HGNC:16660",
      havana_gene : "OTTHUMG00000090823.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 19695461,
      stop : 19709037,
      direction : "-",
      ID : "ENSG00000105849.6",
      gene_id : "ENSG00000105849.6",
      gene_type : "protein_coding",
      gene_name : "POLR1F",
      gene_level : 2,
      hgnc_id : "HGNC:18027",
      havana_gene : "OTTHUMG00000152497.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 19719315,
      stop : 19773617,
      direction : "-",
      ID : "ENSG00000173452.14",
      gene_id : "ENSG00000173452.14",
      gene_type : "protein_coding",
      gene_name : "TMEM196",
      gene_level : 2,
      hgnc_id : "HGNC:22431",
      havana_gene : "OTTHUMG00000152504.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 20134655,
      stop : 20217404,
      direction : "-",
      ID : "ENSG00000183742.13",
      gene_id : "ENSG00000183742.13",
      gene_type : "protein_coding",
      gene_name : "MACC1",
      gene_level : 2,
      hgnc_id : "HGNC:30215",
      havana_gene : "OTTHUMG00000128415.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 20330702,
      stop : 20415754,
      direction : "+",
      ID : "ENSG00000105855.10",
      gene_id : "ENSG00000105855.10",
      gene_type : "protein_coding",
      gene_name : "ITGB8",
      gene_level : 2,
      hgnc_id : "HGNC:6163",
      havana_gene : "OTTHUMG00000023594.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 20615207,
      stop : 20777038,
      direction : "+",
      ID : "ENSG00000004846.16",
      gene_id : "ENSG00000004846.16",
      gene_type : "protein_coding",
      gene_name : "ABCB5",
      gene_level : 1,
      hgnc_id : "HGNC:46",
      havana_gene : "OTTHUMG00000094789.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 20782279,
      stop : 20786886,
      direction : "-",
      ID : "ENSG00000164651.17",
      gene_id : "ENSG00000164651.17",
      gene_type : "protein_coding",
      gene_name : "SP8",
      gene_level : 2,
      hgnc_id : "HGNC:19196",
      havana_gene : "OTTHUMG00000094788.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 21428043,
      stop : 21514822,
      direction : "+",
      ID : "ENSG00000105866.15",
      gene_id : "ENSG00000105866.15",
      gene_type : "protein_coding",
      gene_name : "SP4",
      gene_level : 2,
      hgnc_id : "HGNC:11209",
      havana_gene : "OTTHUMG00000094801.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 21543039,
      stop : 21901839,
      direction : "+",
      ID : "ENSG00000105877.18",
      gene_id : "ENSG00000105877.18",
      gene_type : "protein_coding",
      gene_name : "DNAH11",
      gene_level : 1,
      hgnc_id : "HGNC:2942",
      havana_gene : "OTTHUMG00000152524.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 21900899,
      stop : 21945903,
      direction : "-",
      ID : "ENSG00000164649.20",
      gene_id : "ENSG00000164649.20",
      gene_type : "protein_coding",
      gene_name : "CDCA7L",
      gene_level : 1,
      hgnc_id : "HGNC:30777",
      havana_gene : "OTTHUMG00000128429.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 22118236,
      stop : 22357154,
      direction : "-",
      ID : "ENSG00000136237.19",
      gene_id : "ENSG00000136237.19",
      gene_type : "protein_coding",
      gene_name : "RAPGEF5",
      gene_level : 2,
      hgnc_id : "HGNC:16862",
      havana_gene : "OTTHUMG00000152525.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 22419444,
      stop : 22727613,
      direction : "-",
      ID : "ENSG00000105889.16",
      gene_id : "ENSG00000105889.16",
      gene_type : "protein_coding",
      gene_name : "STEAP1B",
      gene_level : 2,
      hgnc_id : "HGNC:41907",
      havana_gene : "OTTHUMG00000193419.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 22725884,
      stop : 22732002,
      direction : "+",
      ID : "ENSG00000136244.12",
      gene_id : "ENSG00000136244.12",
      gene_type : "protein_coding",
      gene_name : "IL6",
      gene_level : 2,
      hgnc_id : "HGNC:6018",
      havana_gene : "OTTHUMG00000023178.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 22812628,
      stop : 22822852,
      direction : "-",
      ID : "ENSG00000196683.11",
      gene_id : "ENSG00000196683.11",
      gene_type : "protein_coding",
      gene_name : "TOMM7",
      gene_level : 1,
      hgnc_id : "HGNC:21648",
      havana_gene : "OTTHUMG00000094805.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 22889371,
      stop : 23014130,
      direction : "-",
      ID : "ENSG00000122591.13",
      gene_id : "ENSG00000122591.13",
      gene_type : "protein_coding",
      gene_name : "FAM126A",
      gene_level : 1,
      hgnc_id : "HGNC:24587",
      havana_gene : "OTTHUMG00000128435.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23105758,
      stop : 23177914,
      direction : "+",
      ID : "ENSG00000122550.18",
      gene_id : "ENSG00000122550.18",
      gene_type : "protein_coding",
      gene_name : "KLHL7",
      gene_level : 1,
      hgnc_id : "HGNC:15646",
      havana_gene : "OTTHUMG00000094813.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23181841,
      stop : 23201011,
      direction : "+",
      ID : "ENSG00000136243.17",
      gene_id : "ENSG00000136243.17",
      gene_type : "protein_coding",
      gene_name : "NUP42",
      gene_level : 1,
      hgnc_id : "HGNC:17010",
      havana_gene : "OTTHUMG00000096955.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23235967,
      stop : 23275108,
      direction : "+",
      ID : "ENSG00000136235.17",
      gene_id : "ENSG00000136235.17",
      gene_type : "protein_coding",
      gene_name : "GPNMB",
      gene_level : 2,
      hgnc_id : "HGNC:4462",
      havana_gene : "OTTHUMG00000022811.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23298739,
      stop : 23311729,
      direction : "+",
      ID : "ENSG00000156928.5",
      gene_id : "ENSG00000156928.5",
      gene_type : "protein_coding",
      gene_name : "MALSU1",
      gene_level : 1,
      hgnc_id : "HGNC:21721",
      havana_gene : "OTTHUMG00000128443.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23310209,
      stop : 23470491,
      direction : "-",
      ID : "ENSG00000136231.14",
      gene_id : "ENSG00000136231.14",
      gene_type : "protein_coding",
      gene_name : "IGF2BP3",
      gene_level : 2,
      hgnc_id : "HGNC:28868",
      havana_gene : "OTTHUMG00000128445.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23504780,
      stop : 23532041,
      direction : "-",
      ID : "ENSG00000164548.11",
      gene_id : "ENSG00000164548.11",
      gene_type : "protein_coding",
      gene_name : "TRA2A",
      gene_level : 2,
      hgnc_id : "HGNC:16645",
      havana_gene : "OTTHUMG00000128459.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23597382,
      stop : 23644708,
      direction : "+",
      ID : "ENSG00000169193.12",
      gene_id : "ENSG00000169193.12",
      gene_type : "protein_coding",
      gene_name : "CCDC126",
      gene_level : 1,
      hgnc_id : "HGNC:22398",
      havana_gene : "OTTHUMG00000128461.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23680130,
      stop : 23703249,
      direction : "+",
      ID : "ENSG00000188732.11",
      gene_id : "ENSG00000188732.11",
      gene_type : "protein_coding",
      gene_name : "FAM221A",
      gene_level : 1,
      hgnc_id : "HGNC:27977",
      havana_gene : "OTTHUMG00000128463.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 23710203,
      stop : 23832513,
      direction : "+",
      ID : "ENSG00000196335.13",
      gene_id : "ENSG00000196335.13",
      gene_type : "protein_coding",
      gene_name : "STK31",
      gene_level : 2,
      hgnc_id : "HGNC:11407",
      havana_gene : "OTTHUMG00000023053.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 24284188,
      stop : 24291862,
      direction : "+",
      ID : "ENSG00000122585.8",
      gene_id : "ENSG00000122585.8",
      gene_type : "protein_coding",
      gene_name : "NPY",
      gene_level : 2,
      hgnc_id : "HGNC:7955",
      havana_gene : "OTTHUMG00000022973.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 24573268,
      stop : 24694193,
      direction : "+",
      ID : "ENSG00000105926.16",
      gene_id : "ENSG00000105926.16",
      gene_type : "protein_coding",
      gene_name : "MPP6",
      gene_level : 2,
      hgnc_id : "HGNC:18167",
      havana_gene : "OTTHUMG00000023507.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 24698355,
      stop : 24757940,
      direction : "-",
      ID : "ENSG00000105928.16",
      gene_id : "ENSG00000105928.16",
      gene_type : "protein_coding",
      gene_name : "GSDME",
      gene_level : 1,
      hgnc_id : "HGNC:2810",
      havana_gene : "OTTHUMG00000023237.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 24796540,
      stop : 24981634,
      direction : "-",
      ID : "ENSG00000070882.13",
      gene_id : "ENSG00000070882.13",
      gene_type : "protein_coding",
      gene_name : "OSBPL3",
      gene_level : 2,
      hgnc_id : "HGNC:16370",
      havana_gene : "OTTHUMG00000023277.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 25118656,
      stop : 25125260,
      direction : "-",
      ID : "ENSG00000172115.9",
      gene_id : "ENSG00000172115.9",
      gene_type : "protein_coding",
      gene_name : "CYCS",
      gene_level : 2,
      hgnc_id : "HGNC:19986",
      havana_gene : "OTTHUMG00000128495.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 25134692,
      stop : 25180356,
      direction : "-",
      ID : "ENSG00000153790.12",
      gene_id : "ENSG00000153790.12",
      gene_type : "protein_coding",
      gene_name : "C7orf31",
      gene_level : 2,
      hgnc_id : "HGNC:21722",
      havana_gene : "OTTHUMG00000128497.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 25224570,
      stop : 25228486,
      direction : "-",
      ID : "ENSG00000105954.2",
      gene_id : "ENSG00000105954.2",
      gene_type : "protein_coding",
      gene_name : "NPVF",
      gene_level : 2,
      hgnc_id : "HGNC:13782",
      havana_gene : "OTTHUMG00000128509.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 26152198,
      stop : 26187137,
      direction : "+",
      ID : "ENSG00000050344.9",
      gene_id : "ENSG00000050344.9",
      gene_type : "protein_coding",
      gene_name : "NFE2L3",
      gene_level : 2,
      hgnc_id : "HGNC:7783",
      havana_gene : "OTTHUMG00000023882.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 26171151,
      stop : 26201529,
      direction : "-",
      ID : "ENSG00000122566.22",
      gene_id : "ENSG00000122566.22",
      gene_type : "protein_coding",
      gene_name : "HNRNPA2B1",
      gene_level : 2,
      hgnc_id : "HGNC:5033",
      havana_gene : "OTTHUMG00000023471.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 26201162,
      stop : 26213607,
      direction : "+",
      ID : "ENSG00000122565.19",
      gene_id : "ENSG00000122565.19",
      gene_type : "protein_coding",
      gene_name : "CBX3",
      gene_level : 2,
      hgnc_id : "HGNC:1553",
      havana_gene : "OTTHUMG00000022911.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 26291862,
      stop : 26374383,
      direction : "+",
      ID : "ENSG00000086300.16",
      gene_id : "ENSG00000086300.16",
      gene_type : "protein_coding",
      gene_name : "SNX10",
      gene_level : 2,
      hgnc_id : "HGNC:14974",
      havana_gene : "OTTHUMG00000023650.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 26667068,
      stop : 26995239,
      direction : "-",
      ID : "ENSG00000005020.13",
      gene_id : "ENSG00000005020.13",
      gene_type : "protein_coding",
      gene_name : "SKAP2",
      gene_level : 2,
      hgnc_id : "HGNC:15687",
      havana_gene : "OTTHUMG00000023495.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27092993,
      stop : 27096000,
      direction : "-",
      ID : "ENSG00000105991.10",
      gene_id : "ENSG00000105991.10",
      gene_type : "protein_coding",
      gene_name : "HOXA1",
      gene_level : 1,
      hgnc_id : "HGNC:5099",
      havana_gene : "OTTHUMG00000023207.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27100354,
      stop : 27102686,
      direction : "-",
      ID : "ENSG00000105996.7",
      gene_id : "ENSG00000105996.7",
      gene_type : "protein_coding",
      gene_name : "HOXA2",
      gene_level : 2,
      hgnc_id : "HGNC:5103",
      havana_gene : "OTTHUMG00000023208.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27106184,
      stop : 27152581,
      direction : "-",
      ID : "ENSG00000105997.22",
      gene_id : "ENSG00000105997.22",
      gene_type : "protein_coding",
      gene_name : "HOXA3",
      gene_level : 2,
      hgnc_id : "HGNC:5104",
      havana_gene : "OTTHUMG00000023209.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27128507,
      stop : 27130780,
      direction : "-",
      ID : "ENSG00000197576.14",
      gene_id : "ENSG00000197576.14",
      gene_type : "protein_coding",
      gene_name : "HOXA4",
      gene_level : 1,
      hgnc_id : "HGNC:5105",
      havana_gene : "OTTHUMG00000023213.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27141052,
      stop : 27143681,
      direction : "-",
      ID : "ENSG00000106004.5",
      gene_id : "ENSG00000106004.5",
      gene_type : "protein_coding",
      gene_name : "HOXA5",
      gene_level : 2,
      hgnc_id : "HGNC:5106",
      havana_gene : "OTTHUMG00000023214.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27145396,
      stop : 27150603,
      direction : "-",
      ID : "ENSG00000106006.6",
      gene_id : "ENSG00000106006.6",
      gene_type : "protein_coding",
      gene_name : "HOXA6",
      gene_level : 1,
      hgnc_id : "HGNC:5107",
      havana_gene : "OTTHUMG00000023216.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27153716,
      stop : 27157936,
      direction : "-",
      ID : "ENSG00000122592.8",
      gene_id : "ENSG00000122592.8",
      gene_type : "protein_coding",
      gene_name : "HOXA7",
      gene_level : 2,
      hgnc_id : "HGNC:5108",
      havana_gene : "OTTHUMG00000023217.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27162438,
      stop : 27175180,
      direction : "-",
      ID : "ENSG00000078399.19",
      gene_id : "ENSG00000078399.19",
      gene_type : "protein_coding",
      gene_name : "HOXA9",
      gene_level : 1,
      hgnc_id : "HGNC:5109",
      havana_gene : "OTTHUMG00000023220.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27163535,
      stop : 27180013,
      direction : "-",
      ID : "ENSG00000257184.3",
      gene_id : "ENSG00000257184.3",
      gene_type : "protein_coding",
      gene_name : "AC004080.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000170193.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27170592,
      stop : 27180261,
      direction : "-",
      ID : "ENSG00000253293.5",
      gene_id : "ENSG00000253293.5",
      gene_type : "protein_coding",
      gene_name : "HOXA10",
      gene_level : 1,
      hgnc_id : "HGNC:5100",
      havana_gene : "OTTHUMG00000023436.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27181157,
      stop : 27185232,
      direction : "-",
      ID : "ENSG00000005073.6",
      gene_id : "ENSG00000005073.6",
      gene_type : "protein_coding",
      gene_name : "HOXA11",
      gene_level : 1,
      hgnc_id : "HGNC:5101",
      havana_gene : "OTTHUMG00000023437.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27193503,
      stop : 27200091,
      direction : "-",
      ID : "ENSG00000106031.9",
      gene_id : "ENSG00000106031.9",
      gene_type : "protein_coding",
      gene_name : "HOXA13",
      gene_level : 2,
      hgnc_id : "HGNC:5102",
      havana_gene : "OTTHUMG00000023438.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27242700,
      stop : 27250493,
      direction : "+",
      ID : "ENSG00000106038.13",
      gene_id : "ENSG00000106038.13",
      gene_type : "protein_coding",
      gene_name : "EVX1",
      gene_level : 2,
      hgnc_id : "HGNC:3506",
      havana_gene : "OTTHUMG00000023093.12",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27525442,
      stop : 27662883,
      direction : "-",
      ID : "ENSG00000106049.9",
      gene_id : "ENSG00000106049.9",
      gene_type : "protein_coding",
      gene_name : "HIBADH",
      gene_level : 1,
      hgnc_id : "HGNC:4907",
      havana_gene : "OTTHUMG00000097035.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27739331,
      stop : 27844564,
      direction : "+",
      ID : "ENSG00000106052.13",
      gene_id : "ENSG00000106052.13",
      gene_type : "protein_coding",
      gene_name : "TAX1BP1",
      gene_level : 1,
      hgnc_id : "HGNC:11575",
      havana_gene : "OTTHUMG00000023377.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 27830573,
      stop : 28180795,
      direction : "-",
      ID : "ENSG00000153814.13",
      gene_id : "ENSG00000153814.13",
      gene_type : "protein_coding",
      gene_name : "JAZF1",
      gene_level : 1,
      hgnc_id : "HGNC:28917",
      havana_gene : "OTTHUMG00000128545.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 28299321,
      stop : 28825894,
      direction : "+",
      ID : "ENSG00000146592.17",
      gene_id : "ENSG00000146592.17",
      gene_type : "protein_coding",
      gene_name : "CREB5",
      gene_level : 2,
      hgnc_id : "HGNC:16844",
      havana_gene : "OTTHUMG00000097081.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 28953358,
      stop : 28958330,
      direction : "-",
      ID : "ENSG00000255690.3",
      gene_id : "ENSG00000255690.3",
      gene_type : "protein_coding",
      gene_name : "TRIL",
      gene_level : 2,
      hgnc_id : "HGNC:22200",
      havana_gene : "OTTHUMG00000152829.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 28995235,
      stop : 29195451,
      direction : "-",
      ID : "ENSG00000106066.15",
      gene_id : "ENSG00000106066.15",
      gene_type : "protein_coding",
      gene_name : "CPVL",
      gene_level : 1,
      hgnc_id : "HGNC:14399",
      havana_gene : "OTTHUMG00000023669.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 29122340,
      stop : 29514667,
      direction : "+",
      ID : "ENSG00000285162.1",
      gene_id : "ENSG00000285162.1",
      gene_type : "protein_coding",
      gene_name : "AC004593.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192441.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 29146569,
      stop : 29514328,
      direction : "+",
      ID : "ENSG00000106069.23",
      gene_id : "ENSG00000106069.23",
      gene_type : "protein_coding",
      gene_name : "CHN2",
      gene_level : 1,
      hgnc_id : "HGNC:1944",
      havana_gene : "OTTHUMG00000023063.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 29563835,
      stop : 29567293,
      direction : "+",
      ID : "ENSG00000176532.4",
      gene_id : "ENSG00000176532.4",
      gene_type : "protein_coding",
      gene_name : "PRR15",
      gene_level : 2,
      hgnc_id : "HGNC:22310",
      havana_gene : "OTTHUMG00000128555.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 29806486,
      stop : 29917066,
      direction : "+",
      ID : "ENSG00000122574.11",
      gene_id : "ENSG00000122574.11",
      gene_type : "protein_coding",
      gene_name : "WIPF3",
      gene_level : 1,
      hgnc_id : "HGNC:22004",
      havana_gene : "OTTHUMG00000152761.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 29920104,
      stop : 29990289,
      direction : "-",
      ID : "ENSG00000136193.17",
      gene_id : "ENSG00000136193.17",
      gene_type : "protein_coding",
      gene_name : "SCRN1",
      gene_level : 2,
      hgnc_id : "HGNC:22192",
      havana_gene : "OTTHUMG00000097093.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30010587,
      stop : 30026702,
      direction : "-",
      ID : "ENSG00000106080.11",
      gene_id : "ENSG00000106080.11",
      gene_type : "protein_coding",
      gene_name : "FKBP14",
      gene_level : 2,
      hgnc_id : "HGNC:18625",
      havana_gene : "OTTHUMG00000023442.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30027404,
      stop : 30130483,
      direction : "+",
      ID : "ENSG00000106086.20",
      gene_id : "ENSG00000106086.20",
      gene_type : "protein_coding",
      gene_name : "PLEKHA8",
      gene_level : 2,
      hgnc_id : "HGNC:30037",
      havana_gene : "OTTHUMG00000097751.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30134986,
      stop : 30162762,
      direction : "+",
      ID : "ENSG00000180354.16",
      gene_id : "ENSG00000180354.16",
      gene_type : "protein_coding",
      gene_name : "MTURN",
      gene_level : 1,
      hgnc_id : "HGNC:25457",
      havana_gene : "OTTHUMG00000128559.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30284597,
      stop : 30367689,
      direction : "+",
      ID : "ENSG00000180233.11",
      gene_id : "ENSG00000180233.11",
      gene_type : "protein_coding",
      gene_name : "ZNRF2",
      gene_level : 2,
      hgnc_id : "HGNC:22316",
      havana_gene : "OTTHUMG00000097759.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30362400,
      stop : 30412502,
      direction : "+",
      ID : "ENSG00000281593.1",
      gene_id : "ENSG00000281593.1",
      gene_type : "protein_coding",
      gene_name : "AC006978.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189555.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30424527,
      stop : 30478784,
      direction : "-",
      ID : "ENSG00000106100.11",
      gene_id : "ENSG00000106100.11",
      gene_type : "protein_coding",
      gene_name : "NOD1",
      gene_level : 2,
      hgnc_id : "HGNC:16390",
      havana_gene : "OTTHUMG00000023923.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30496621,
      stop : 30504841,
      direction : "-",
      ID : "ENSG00000006625.18",
      gene_id : "ENSG00000006625.18",
      gene_type : "protein_coding",
      gene_name : "GGCT",
      gene_level : 1,
      hgnc_id : "HGNC:21705",
      havana_gene : "OTTHUMG00000128593.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30497077,
      stop : 30550761,
      direction : "-",
      ID : "ENSG00000281039.1",
      gene_id : "ENSG00000281039.1",
      gene_type : "protein_coding",
      gene_name : "AC005154.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189706.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30580533,
      stop : 30634033,
      direction : "+",
      ID : "ENSG00000106105.15",
      gene_id : "ENSG00000106105.15",
      gene_type : "protein_coding",
      gene_name : "GARS1",
      gene_level : 2,
      hgnc_id : "HGNC:4162",
      havana_gene : "OTTHUMG00000152769.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30651942,
      stop : 30700129,
      direction : "-",
      ID : "ENSG00000106113.19",
      gene_id : "ENSG00000106113.19",
      gene_type : "protein_coding",
      gene_name : "CRHR2",
      gene_level : 2,
      hgnc_id : "HGNC:2358",
      havana_gene : "OTTHUMG00000023218.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30697985,
      stop : 30757602,
      direction : "+",
      ID : "ENSG00000241644.2",
      gene_id : "ENSG00000241644.2",
      gene_type : "protein_coding",
      gene_name : "INMT",
      gene_level : 2,
      hgnc_id : "HGNC:6069",
      havana_gene : "OTTHUMG00000167163.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30752137,
      stop : 30892081,
      direction : "+",
      ID : "ENSG00000254959.6",
      gene_id : "ENSG00000254959.6",
      gene_type : "protein_coding",
      gene_name : "INMT-MINDY4",
      gene_level : 2,
      hgnc_id : "HGNC:41995",
      havana_gene : "OTTHUMG00000022897.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30771417,
      stop : 30892387,
      direction : "+",
      ID : "ENSG00000106125.14",
      gene_id : "ENSG00000106125.14",
      gene_type : "protein_coding",
      gene_name : "MINDY4",
      gene_level : 2,
      hgnc_id : "HGNC:21916",
      havana_gene : "OTTHUMG00000152800.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30852273,
      stop : 30923812,
      direction : "+",
      ID : "ENSG00000250424.4",
      gene_id : "ENSG00000250424.4",
      gene_type : "protein_coding",
      gene_name : "AC004691.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000162387.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30911853,
      stop : 30925517,
      direction : "+",
      ID : "ENSG00000240583.14",
      gene_id : "ENSG00000240583.14",
      gene_type : "protein_coding",
      gene_name : "AQP1",
      gene_level : 1,
      hgnc_id : "HGNC:633",
      havana_gene : "OTTHUMG00000023944.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 30938669,
      stop : 30993254,
      direction : "+",
      ID : "ENSG00000106128.19",
      gene_id : "ENSG00000106128.19",
      gene_type : "protein_coding",
      gene_name : "GHRHR",
      gene_level : 1,
      hgnc_id : "HGNC:4266",
      havana_gene : "OTTHUMG00000152801.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 31052308,
      stop : 31111479,
      direction : "+",
      ID : "ENSG00000078549.15",
      gene_id : "ENSG00000078549.15",
      gene_type : "protein_coding",
      gene_name : "ADCYAP1R1",
      gene_level : 2,
      hgnc_id : "HGNC:242",
      havana_gene : "OTTHUMG00000023884.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 31337465,
      stop : 31340726,
      direction : "-",
      ID : "ENSG00000164600.7",
      gene_id : "ENSG00000164600.7",
      gene_type : "protein_coding",
      gene_name : "NEUROD6",
      gene_level : 2,
      hgnc_id : "HGNC:13804",
      havana_gene : "OTTHUMG00000022865.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 31514071,
      stop : 31658720,
      direction : "+",
      ID : "ENSG00000180347.13",
      gene_id : "ENSG00000180347.13",
      gene_type : "protein_coding",
      gene_name : "ITPRID1",
      gene_level : 1,
      hgnc_id : "HGNC:27363",
      havana_gene : "OTTHUMG00000128611.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 31687215,
      stop : 31708455,
      direction : "+",
      ID : "ENSG00000106341.11",
      gene_id : "ENSG00000106341.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R17",
      gene_level : 1,
      hgnc_id : "HGNC:16973",
      havana_gene : "OTTHUMG00000128629.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 31751179,
      stop : 32428131,
      direction : "-",
      ID : "ENSG00000154678.18",
      gene_id : "ENSG00000154678.18",
      gene_type : "protein_coding",
      gene_name : "PDE1C",
      gene_level : 1,
      hgnc_id : "HGNC:8776",
      havana_gene : "OTTHUMG00000023836.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 32485338,
      stop : 32495283,
      direction : "-",
      ID : "ENSG00000106355.10",
      gene_id : "ENSG00000106355.10",
      gene_type : "protein_coding",
      gene_name : "LSM5",
      gene_level : 2,
      hgnc_id : "HGNC:17162",
      havana_gene : "OTTHUMG00000022913.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 32495426,
      stop : 32588726,
      direction : "+",
      ID : "ENSG00000105778.19",
      gene_id : "ENSG00000105778.19",
      gene_type : "protein_coding",
      gene_name : "AVL9",
      gene_level : 1,
      hgnc_id : "HGNC:28994",
      havana_gene : "OTTHUMG00000152929.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 32868172,
      stop : 32894131,
      direction : "-",
      ID : "ENSG00000170852.11",
      gene_id : "ENSG00000170852.11",
      gene_type : "protein_coding",
      gene_name : "KBTBD2",
      gene_level : 2,
      hgnc_id : "HGNC:21751",
      havana_gene : "OTTHUMG00000152984.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 32957404,
      stop : 33006930,
      direction : "+",
      ID : "ENSG00000122642.11",
      gene_id : "ENSG00000122642.11",
      gene_type : "protein_coding",
      gene_name : "FKBP9",
      gene_level : 1,
      hgnc_id : "HGNC:3725",
      havana_gene : "OTTHUMG00000097847.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 33014114,
      stop : 33062797,
      direction : "-",
      ID : "ENSG00000122643.22",
      gene_id : "ENSG00000122643.22",
      gene_type : "protein_coding",
      gene_name : "NT5C3A",
      gene_level : 2,
      hgnc_id : "HGNC:17820",
      havana_gene : "OTTHUMG00000152983.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 33094797,
      stop : 33109404,
      direction : "-",
      ID : "ENSG00000164610.9",
      gene_id : "ENSG00000164610.9",
      gene_type : "protein_coding",
      gene_name : "RP9",
      gene_level : 2,
      hgnc_id : "HGNC:10288",
      havana_gene : "OTTHUMG00000152988.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 33109557,
      stop : 33877180,
      direction : "+",
      ID : "ENSG00000122507.21",
      gene_id : "ENSG00000122507.21",
      gene_type : "protein_coding",
      gene_name : "BBS9",
      gene_level : 1,
      hgnc_id : "HGNC:30000",
      havana_gene : "OTTHUMG00000128659.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 33904308,
      stop : 34156427,
      direction : "+",
      ID : "ENSG00000164619.10",
      gene_id : "ENSG00000164619.10",
      gene_type : "protein_coding",
      gene_name : "BMPER",
      gene_level : 2,
      hgnc_id : "HGNC:24154",
      havana_gene : "OTTHUMG00000128675.24",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 34658218,
      stop : 34878332,
      direction : "+",
      ID : "ENSG00000187258.14",
      gene_id : "ENSG00000187258.14",
      gene_type : "protein_coding",
      gene_name : "NPSR1",
      gene_level : 1,
      hgnc_id : "HGNC:23631",
      havana_gene : "OTTHUMG00000099383.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 34928876,
      stop : 35038271,
      direction : "-",
      ID : "ENSG00000173852.15",
      gene_id : "ENSG00000173852.15",
      gene_type : "protein_coding",
      gene_name : "DPY19L1",
      gene_level : 2,
      hgnc_id : "HGNC:22205",
      havana_gene : "OTTHUMG00000154888.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 35202430,
      stop : 35254100,
      direction : "-",
      ID : "ENSG00000164532.11",
      gene_id : "ENSG00000164532.11",
      gene_type : "protein_coding",
      gene_name : "TBX20",
      gene_level : 2,
      hgnc_id : "HGNC:11598",
      havana_gene : "OTTHUMG00000099411.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 35632659,
      stop : 35697459,
      direction : "-",
      ID : "ENSG00000122557.11",
      gene_id : "ENSG00000122557.11",
      gene_type : "protein_coding",
      gene_name : "HERPUD2",
      gene_level : 1,
      hgnc_id : "HGNC:21915",
      havana_gene : "OTTHUMG00000128687.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 35800932,
      stop : 35907105,
      direction : "+",
      ID : "ENSG00000122545.20",
      gene_id : "ENSG00000122545.20",
      gene_type : "protein_coding",
      gene_name : "SEPTIN7",
      gene_level : 2,
      hgnc_id : "HGNC:1717",
      havana_gene : "OTTHUMG00000155063.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 36153254,
      stop : 36301538,
      direction : "+",
      ID : "ENSG00000122547.11",
      gene_id : "ENSG00000122547.11",
      gene_type : "protein_coding",
      gene_name : "EEPD1",
      gene_level : 2,
      hgnc_id : "HGNC:22223",
      havana_gene : "OTTHUMG00000154904.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 36324152,
      stop : 36390125,
      direction : "-",
      ID : "ENSG00000164542.13",
      gene_id : "ENSG00000164542.13",
      gene_type : "protein_coding",
      gene_name : "KIAA0895",
      gene_level : 1,
      hgnc_id : "HGNC:22206",
      havana_gene : "OTTHUMG00000154939.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 36389821,
      stop : 36453791,
      direction : "+",
      ID : "ENSG00000011426.11",
      gene_id : "ENSG00000011426.11",
      gene_type : "protein_coding",
      gene_name : "ANLN",
      gene_level : 1,
      hgnc_id : "HGNC:14082",
      havana_gene : "OTTHUMG00000023143.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 36512941,
      stop : 36724549,
      direction : "-",
      ID : "ENSG00000136250.12",
      gene_id : "ENSG00000136250.12",
      gene_type : "protein_coding",
      gene_name : "AOAH",
      gene_level : 1,
      hgnc_id : "HGNC:548",
      havana_gene : "OTTHUMG00000023566.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 36852906,
      stop : 37449223,
      direction : "-",
      ID : "ENSG00000155849.16",
      gene_id : "ENSG00000155849.16",
      gene_type : "protein_coding",
      gene_name : "ELMO1",
      gene_level : 1,
      hgnc_id : "HGNC:16286",
      havana_gene : "OTTHUMG00000023701.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 37683796,
      stop : 37833788,
      direction : "+",
      ID : "ENSG00000187037.8",
      gene_id : "ENSG00000187037.8",
      gene_type : "protein_coding",
      gene_name : "GPR141",
      gene_level : 2,
      hgnc_id : "HGNC:19997",
      havana_gene : "OTTHUMG00000102105.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 37683843,
      stop : 37951936,
      direction : "+",
      ID : "ENSG00000086289.12",
      gene_id : "ENSG00000086289.12",
      gene_type : "protein_coding",
      gene_name : "EPDR1",
      gene_level : 1,
      hgnc_id : "HGNC:17572",
      havana_gene : "OTTHUMG00000102187.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 37848597,
      stop : 37900397,
      direction : "+",
      ID : "ENSG00000086288.12",
      gene_id : "ENSG00000086288.12",
      gene_type : "protein_coding",
      gene_name : "NME8",
      gene_level : 2,
      hgnc_id : "HGNC:16473",
      havana_gene : "OTTHUMG00000023716.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 37905932,
      stop : 38025695,
      direction : "-",
      ID : "ENSG00000106483.12",
      gene_id : "ENSG00000106483.12",
      gene_type : "protein_coding",
      gene_name : "SFRP4",
      gene_level : 2,
      hgnc_id : "HGNC:10778",
      havana_gene : "OTTHUMG00000023026.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 38178245,
      stop : 38230670,
      direction : "+",
      ID : "ENSG00000010270.14",
      gene_id : "ENSG00000010270.14",
      gene_type : "protein_coding",
      gene_name : "STARD3NL",
      gene_level : 2,
      hgnc_id : "HGNC:19169",
      havana_gene : "OTTHUMG00000023659.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 38383704,
      stop : 38631420,
      direction : "-",
      ID : "ENSG00000078053.17",
      gene_id : "ENSG00000078053.17",
      gene_type : "protein_coding",
      gene_name : "AMPH",
      gene_level : 2,
      hgnc_id : "HGNC:471",
      havana_gene : "OTTHUMG00000023725.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 38722974,
      stop : 38932394,
      direction : "-",
      ID : "ENSG00000006715.16",
      gene_id : "ENSG00000006715.16",
      gene_type : "protein_coding",
      gene_name : "VPS41",
      gene_level : 1,
      hgnc_id : "HGNC:12713",
      havana_gene : "OTTHUMG00000023629.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 38977909,
      stop : 39493095,
      direction : "+",
      ID : "ENSG00000106536.21",
      gene_id : "ENSG00000106536.21",
      gene_type : "protein_coding",
      gene_name : "POU6F2",
      gene_level : 1,
      hgnc_id : "HGNC:21694",
      havana_gene : "OTTHUMG00000150803.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 39566385,
      stop : 39610320,
      direction : "+",
      ID : "ENSG00000241127.8",
      gene_id : "ENSG00000241127.8",
      gene_type : "protein_coding",
      gene_name : "YAE1",
      gene_level : 1,
      hgnc_id : "HGNC:24857",
      havana_gene : "OTTHUMG00000128689.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 39623565,
      stop : 39708120,
      direction : "+",
      ID : "ENSG00000006451.8",
      gene_id : "ENSG00000006451.8",
      gene_type : "protein_coding",
      gene_name : "RALA",
      gene_level : 2,
      hgnc_id : "HGNC:9839",
      havana_gene : "OTTHUMG00000128775.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 39950121,
      stop : 40099580,
      direction : "+",
      ID : "ENSG00000065883.16",
      gene_id : "ENSG00000065883.16",
      gene_type : "protein_coding",
      gene_name : "CDK13",
      gene_level : 2,
      hgnc_id : "HGNC:1733",
      havana_gene : "OTTHUMG00000023726.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 40126027,
      stop : 40134622,
      direction : "-",
      ID : "ENSG00000168303.9",
      gene_id : "ENSG00000168303.9",
      gene_type : "protein_coding",
      gene_name : "MPLKIP",
      gene_level : 2,
      hgnc_id : "HGNC:16002",
      havana_gene : "OTTHUMG00000128797.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 40135005,
      stop : 40860763,
      direction : "+",
      ID : "ENSG00000175600.16",
      gene_id : "ENSG00000175600.16",
      gene_type : "protein_coding",
      gene_name : "SUGCT",
      gene_level : 1,
      hgnc_id : "HGNC:16001",
      havana_gene : "OTTHUMG00000155094.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 41667168,
      stop : 41705834,
      direction : "-",
      ID : "ENSG00000122641.11",
      gene_id : "ENSG00000122641.11",
      gene_type : "protein_coding",
      gene_name : "INHBA",
      gene_level : 2,
      hgnc_id : "HGNC:6066",
      havana_gene : "OTTHUMG00000023574.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 41960949,
      stop : 42264100,
      direction : "-",
      ID : "ENSG00000106571.15",
      gene_id : "ENSG00000106571.15",
      gene_type : "protein_coding",
      gene_name : "GLI3",
      gene_level : 2,
      hgnc_id : "HGNC:4319",
      havana_gene : "OTTHUMG00000023630.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 42908726,
      stop : 42912305,
      direction : "-",
      ID : "ENSG00000136197.13",
      gene_id : "ENSG00000136197.13",
      gene_type : "protein_coding",
      gene_name : "C7orf25",
      gene_level : 2,
      hgnc_id : "HGNC:21703",
      havana_gene : "OTTHUMG00000128869.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 42909273,
      stop : 42932214,
      direction : "-",
      ID : "ENSG00000256646.8",
      gene_id : "ENSG00000256646.8",
      gene_type : "protein_coding",
      gene_name : "AC010132.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168259.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 42916828,
      stop : 42932185,
      direction : "-",
      ID : "ENSG00000106588.12",
      gene_id : "ENSG00000106588.12",
      gene_type : "protein_coding",
      gene_name : "PSMA2",
      gene_level : 2,
      hgnc_id : "HGNC:9531",
      havana_gene : "OTTHUMG00000023916.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 42932376,
      stop : 42948958,
      direction : "+",
      ID : "ENSG00000106591.4",
      gene_id : "ENSG00000106591.4",
      gene_type : "protein_coding",
      gene_name : "MRPL32",
      gene_level : 2,
      hgnc_id : "HGNC:14035",
      havana_gene : "OTTHUMG00000155180.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43112629,
      stop : 43566001,
      direction : "+",
      ID : "ENSG00000002746.15",
      gene_id : "ENSG00000002746.15",
      gene_type : "protein_coding",
      gene_name : "HECW1",
      gene_level : 1,
      hgnc_id : "HGNC:22195",
      havana_gene : "OTTHUMG00000128917.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43582758,
      stop : 43650713,
      direction : "+",
      ID : "ENSG00000164543.7",
      gene_id : "ENSG00000164543.7",
      gene_type : "protein_coding",
      gene_name : "STK17A",
      gene_level : 2,
      hgnc_id : "HGNC:11395",
      havana_gene : "OTTHUMG00000022825.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43608456,
      stop : 43729717,
      direction : "-",
      ID : "ENSG00000106603.19",
      gene_id : "ENSG00000106603.19",
      gene_type : "protein_coding",
      gene_name : "COA1",
      gene_level : 2,
      hgnc_id : "HGNC:21868",
      havana_gene : "OTTHUMG00000128949.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43758680,
      stop : 43807342,
      direction : "+",
      ID : "ENSG00000106605.11",
      gene_id : "ENSG00000106605.11",
      gene_type : "protein_coding",
      gene_name : "BLVRA",
      gene_level : 2,
      hgnc_id : "HGNC:1062",
      havana_gene : "OTTHUMG00000128953.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43866558,
      stop : 43869893,
      direction : "-",
      ID : "ENSG00000062582.14",
      gene_id : "ENSG00000062582.14",
      gene_type : "protein_coding",
      gene_name : "MRPS24",
      gene_level : 2,
      hgnc_id : "HGNC:14510",
      havana_gene : "OTTHUMG00000023175.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43866558,
      stop : 43906589,
      direction : "-",
      ID : "ENSG00000270617.1",
      gene_id : "ENSG00000270617.1",
      gene_type : "protein_coding",
      gene_name : "URGCP-MRPS24",
      gene_level : 2,
      hgnc_id : "HGNC:49188",
      havana_gene : "OTTHUMG00000185136.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43875894,
      stop : 43926411,
      direction : "-",
      ID : "ENSG00000106608.17",
      gene_id : "ENSG00000106608.17",
      gene_type : "protein_coding",
      gene_name : "URGCP",
      gene_level : 2,
      hgnc_id : "HGNC:30890",
      havana_gene : "OTTHUMG00000155245.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43926436,
      stop : 43956136,
      direction : "+",
      ID : "ENSG00000078967.13",
      gene_id : "ENSG00000078967.13",
      gene_type : "protein_coding",
      gene_name : "UBE2D4",
      gene_level : 2,
      hgnc_id : "HGNC:21647",
      havana_gene : "OTTHUMG00000128971.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 43997897,
      stop : 44010122,
      direction : "+",
      ID : "ENSG00000136206.4",
      gene_id : "ENSG00000136206.4",
      gene_type : "protein_coding",
      gene_name : "SPDYE1",
      gene_level : 2,
      hgnc_id : "HGNC:16408",
      havana_gene : "OTTHUMG00000128985.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44044640,
      stop : 44069456,
      direction : "+",
      ID : "ENSG00000136279.21",
      gene_id : "ENSG00000136279.21",
      gene_type : "protein_coding",
      gene_name : "DBNL",
      gene_level : 1,
      hgnc_id : "HGNC:2696",
      havana_gene : "OTTHUMG00000155350.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44062727,
      stop : 44065567,
      direction : "-",
      ID : "ENSG00000164708.6",
      gene_id : "ENSG00000164708.6",
      gene_type : "protein_coding",
      gene_name : "PGAM2",
      gene_level : 2,
      hgnc_id : "HGNC:8889",
      havana_gene : "OTTHUMG00000155355.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44072062,
      stop : 44082530,
      direction : "-",
      ID : "ENSG00000122678.17",
      gene_id : "ENSG00000122678.17",
      gene_type : "protein_coding",
      gene_name : "POLM",
      gene_level : 1,
      hgnc_id : "HGNC:9185",
      havana_gene : "OTTHUMG00000155353.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44104345,
      stop : 44114562,
      direction : "+",
      ID : "ENSG00000106624.11",
      gene_id : "ENSG00000106624.11",
      gene_type : "protein_coding",
      gene_name : "AEBP1",
      gene_level : 1,
      hgnc_id : "HGNC:303",
      havana_gene : "OTTHUMG00000023362.21",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44114680,
      stop : 44124358,
      direction : "-",
      ID : "ENSG00000106628.12",
      gene_id : "ENSG00000106628.12",
      gene_type : "protein_coding",
      gene_name : "POLD2",
      gene_level : 1,
      hgnc_id : "HGNC:9176",
      havana_gene : "OTTHUMG00000022909.15",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44138864,
      stop : 44141332,
      direction : "-",
      ID : "ENSG00000106631.8",
      gene_id : "ENSG00000106631.8",
      gene_type : "protein_coding",
      gene_name : "MYL7",
      gene_level : 1,
      hgnc_id : "HGNC:21719",
      havana_gene : "OTTHUMG00000023125.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44143213,
      stop : 44198170,
      direction : "-",
      ID : "ENSG00000106633.17",
      gene_id : "ENSG00000106633.17",
      gene_type : "protein_coding",
      gene_name : "GCK",
      gene_level : 2,
      hgnc_id : "HGNC:4195",
      havana_gene : "OTTHUMG00000022903.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44200959,
      stop : 44214294,
      direction : "+",
      ID : "ENSG00000106636.9",
      gene_id : "ENSG00000106636.9",
      gene_type : "protein_coding",
      gene_name : "YKT6",
      gene_level : 1,
      hgnc_id : "HGNC:16959",
      havana_gene : "OTTHUMG00000129089.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44217150,
      stop : 44334577,
      direction : "-",
      ID : "ENSG00000058404.20",
      gene_id : "ENSG00000058404.20",
      gene_type : "protein_coding",
      gene_name : "CAMK2B",
      gene_level : 1,
      hgnc_id : "HGNC:1461",
      havana_gene : "OTTHUMG00000023491.14",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44379119,
      stop : 44490658,
      direction : "-",
      ID : "ENSG00000015676.18",
      gene_id : "ENSG00000015676.18",
      gene_type : "protein_coding",
      gene_name : "NUDCD3",
      gene_level : 1,
      hgnc_id : "HGNC:22208",
      havana_gene : "OTTHUMG00000129174.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44512535,
      stop : 44541330,
      direction : "-",
      ID : "ENSG00000015520.15",
      gene_id : "ENSG00000015520.15",
      gene_type : "protein_coding",
      gene_name : "NPC1L1",
      gene_level : 1,
      hgnc_id : "HGNC:7898",
      havana_gene : "OTTHUMG00000023691.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44565804,
      stop : 44575051,
      direction : "-",
      ID : "ENSG00000136271.11",
      gene_id : "ENSG00000136271.11",
      gene_type : "protein_coding",
      gene_name : "DDX56",
      gene_level : 1,
      hgnc_id : "HGNC:18193",
      havana_gene : "OTTHUMG00000129211.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44577894,
      stop : 44582287,
      direction : "-",
      ID : "ENSG00000158604.15",
      gene_id : "ENSG00000158604.15",
      gene_type : "protein_coding",
      gene_name : "TMED4",
      gene_level : 1,
      hgnc_id : "HGNC:22301",
      havana_gene : "OTTHUMG00000129210.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44606572,
      stop : 44709066,
      direction : "+",
      ID : "ENSG00000105953.15",
      gene_id : "ENSG00000105953.15",
      gene_type : "protein_coding",
      gene_name : "OGDH",
      gene_level : 1,
      hgnc_id : "HGNC:8124",
      havana_gene : "OTTHUMG00000155304.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44748581,
      stop : 44769881,
      direction : "+",
      ID : "ENSG00000122515.15",
      gene_id : "ENSG00000122515.15",
      gene_type : "protein_coding",
      gene_name : "ZMIZ2",
      gene_level : 2,
      hgnc_id : "HGNC:22229",
      havana_gene : "OTTHUMG00000155817.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44796680,
      stop : 44824564,
      direction : "+",
      ID : "ENSG00000196262.15",
      gene_id : "ENSG00000196262.15",
      gene_type : "protein_coding",
      gene_name : "PPIA",
      gene_level : 2,
      hgnc_id : "HGNC:9253",
      havana_gene : "OTTHUMG00000023687.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44826791,
      stop : 44848087,
      direction : "-",
      ID : "ENSG00000105968.19",
      gene_id : "ENSG00000105968.19",
      gene_type : "protein_coding",
      gene_name : "H2AZ2",
      gene_level : 2,
      hgnc_id : "HGNC:20664",
      havana_gene : "OTTHUMG00000129217.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44876299,
      stop : 44885530,
      direction : "-",
      ID : "ENSG00000146676.10",
      gene_id : "ENSG00000146676.10",
      gene_type : "protein_coding",
      gene_name : "PURB",
      gene_level : 2,
      hgnc_id : "HGNC:9702",
      havana_gene : "OTTHUMG00000023578.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44962662,
      stop : 44979088,
      direction : "-",
      ID : "ENSG00000136286.16",
      gene_id : "ENSG00000136286.16",
      gene_type : "protein_coding",
      gene_name : "MYO1G",
      gene_level : 2,
      hgnc_id : "HGNC:13880",
      havana_gene : "OTTHUMG00000155821.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 44999475,
      stop : 45076469,
      direction : "+",
      ID : "ENSG00000136280.17",
      gene_id : "ENSG00000136280.17",
      gene_type : "protein_coding",
      gene_name : "CCM2",
      gene_level : 1,
      hgnc_id : "HGNC:21708",
      havana_gene : "OTTHUMG00000129246.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45080437,
      stop : 45088969,
      direction : "-",
      ID : "ENSG00000136274.9",
      gene_id : "ENSG00000136274.9",
      gene_type : "protein_coding",
      gene_name : "NACAD",
      gene_level : 2,
      hgnc_id : "HGNC:22196",
      havana_gene : "OTTHUMG00000159170.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45100100,
      stop : 45112047,
      direction : "-",
      ID : "ENSG00000136270.14",
      gene_id : "ENSG00000136270.14",
      gene_type : "protein_coding",
      gene_name : "TBRG4",
      gene_level : 1,
      hgnc_id : "HGNC:17443",
      havana_gene : "OTTHUMG00000129247.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45157791,
      stop : 45186302,
      direction : "+",
      ID : "ENSG00000122679.8",
      gene_id : "ENSG00000122679.8",
      gene_type : "protein_coding",
      gene_name : "RAMP3",
      gene_level : 1,
      hgnc_id : "HGNC:9845",
      havana_gene : "OTTHUMG00000023729.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45574140,
      stop : 45723116,
      direction : "+",
      ID : "ENSG00000164742.16",
      gene_id : "ENSG00000164742.16",
      gene_type : "protein_coding",
      gene_name : "ADCY1",
      gene_level : 1,
      hgnc_id : "HGNC:232",
      havana_gene : "OTTHUMG00000155420.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45859994,
      stop : 45873082,
      direction : "-",
      ID : "ENSG00000283247.2",
      gene_id : "ENSG00000283247.2",
      gene_type : "protein_coding",
      gene_name : "CCDC201",
      gene_level : 2,
      hgnc_id : "HGNC:54081",
      havana_gene : "OTTHUMG00000191722.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45888360,
      stop : 45893660,
      direction : "+",
      ID : "ENSG00000146678.10",
      gene_id : "ENSG00000146678.10",
      gene_type : "protein_coding",
      gene_name : "IGFBP1",
      gene_level : 1,
      hgnc_id : "HGNC:5469",
      havana_gene : "OTTHUMG00000152343.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 45912245,
      stop : 45921874,
      direction : "-",
      ID : "ENSG00000146674.15",
      gene_id : "ENSG00000146674.15",
      gene_type : "protein_coding",
      gene_name : "IGFBP3",
      gene_level : 1,
      hgnc_id : "HGNC:5472",
      havana_gene : "OTTHUMG00000023769.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 47275154,
      stop : 47582558,
      direction : "-",
      ID : "ENSG00000136205.17",
      gene_id : "ENSG00000136205.17",
      gene_type : "protein_coding",
      gene_name : "TNS3",
      gene_level : 1,
      hgnc_id : "HGNC:21616",
      havana_gene : "OTTHUMG00000074075.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 47740202,
      stop : 47948466,
      direction : "-",
      ID : "ENSG00000158683.9",
      gene_id : "ENSG00000158683.9",
      gene_type : "protein_coding",
      gene_name : "PKD1L1",
      gene_level : 2,
      hgnc_id : "HGNC:18053",
      havana_gene : "OTTHUMG00000155649.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 47963288,
      stop : 47979615,
      direction : "-",
      ID : "ENSG00000136273.13",
      gene_id : "ENSG00000136273.13",
      gene_type : "protein_coding",
      gene_name : "HUS1",
      gene_level : 2,
      hgnc_id : "HGNC:5309",
      havana_gene : "OTTHUMG00000155645.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 47987148,
      stop : 48029119,
      direction : "-",
      ID : "ENSG00000164744.13",
      gene_id : "ENSG00000164744.13",
      gene_type : "protein_coding",
      gene_name : "SUN3",
      gene_level : 2,
      hgnc_id : "HGNC:22429",
      havana_gene : "OTTHUMG00000155646.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 48035511,
      stop : 48061304,
      direction : "+",
      ID : "ENSG00000164746.14",
      gene_id : "ENSG00000164746.14",
      gene_type : "protein_coding",
      gene_name : "C7orf57",
      gene_level : 1,
      hgnc_id : "HGNC:22247",
      havana_gene : "OTTHUMG00000155808.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 48088628,
      stop : 48108736,
      direction : "+",
      ID : "ENSG00000183696.14",
      gene_id : "ENSG00000183696.14",
      gene_type : "protein_coding",
      gene_name : "UPP1",
      gene_level : 2,
      hgnc_id : "HGNC:12576",
      havana_gene : "OTTHUMG00000129253.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 48171458,
      stop : 48647497,
      direction : "+",
      ID : "ENSG00000179869.15",
      gene_id : "ENSG00000179869.15",
      gene_type : "protein_coding",
      gene_name : "ABCA13",
      gene_level : 1,
      hgnc_id : "HGNC:14638",
      havana_gene : "OTTHUMG00000155840.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 48919765,
      stop : 48927454,
      direction : "+",
      ID : "ENSG00000218305.4",
      gene_id : "ENSG00000218305.4",
      gene_type : "protein_coding",
      gene_name : "CDC14C",
      gene_level : 2,
      hgnc_id : "HGNC:22427",
      havana_gene : "OTTHUMG00000155844.2",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 49773638,
      stop : 49921950,
      direction : "+",
      ID : "ENSG00000188730.5",
      gene_id : "ENSG00000188730.5",
      gene_type : "protein_coding",
      gene_name : "VWC2",
      gene_level : 2,
      hgnc_id : "HGNC:30200",
      havana_gene : "OTTHUMG00000129265.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 49850421,
      stop : 50121329,
      direction : "-",
      ID : "ENSG00000042813.8",
      gene_id : "ENSG00000042813.8",
      gene_type : "protein_coding",
      gene_name : "ZPBP",
      gene_level : 1,
      hgnc_id : "HGNC:15662",
      havana_gene : "OTTHUMG00000023528.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 50095883,
      stop : 50159256,
      direction : "+",
      ID : "ENSG00000164500.7",
      gene_id : "ENSG00000164500.7",
      gene_type : "protein_coding",
      gene_name : "SPATA48",
      gene_level : 2,
      hgnc_id : "HGNC:22564",
      havana_gene : "OTTHUMG00000155883.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 50304068,
      stop : 50405101,
      direction : "+",
      ID : "ENSG00000185811.19",
      gene_id : "ENSG00000185811.19",
      gene_type : "protein_coding",
      gene_name : "IKZF1",
      gene_level : 2,
      hgnc_id : "HGNC:13176",
      havana_gene : "OTTHUMG00000155907.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 50444128,
      stop : 50542535,
      direction : "-",
      ID : "ENSG00000132436.11",
      gene_id : "ENSG00000132436.11",
      gene_type : "protein_coding",
      gene_name : "FIGNL1",
      gene_level : 2,
      hgnc_id : "HGNC:13286",
      havana_gene : "OTTHUMG00000022866.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 50458436,
      stop : 50565405,
      direction : "-",
      ID : "ENSG00000132437.18",
      gene_id : "ENSG00000132437.18",
      gene_type : "protein_coding",
      gene_name : "DDC",
      gene_level : 1,
      hgnc_id : "HGNC:2719",
      havana_gene : "OTTHUMG00000023353.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 50590063,
      stop : 50793462,
      direction : "-",
      ID : "ENSG00000106070.20",
      gene_id : "ENSG00000106070.20",
      gene_type : "protein_coding",
      gene_name : "GRB10",
      gene_level : 2,
      hgnc_id : "HGNC:4564",
      havana_gene : "OTTHUMG00000150622.22",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 51016212,
      stop : 51316818,
      direction : "-",
      ID : "ENSG00000106078.19",
      gene_id : "ENSG00000106078.19",
      gene_type : "protein_coding",
      gene_name : "COBL",
      gene_level : 2,
      hgnc_id : "HGNC:22199",
      havana_gene : "OTTHUMG00000155999.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 53035633,
      stop : 53036925,
      direction : "+",
      ID : "ENSG00000221900.6",
      gene_id : "ENSG00000221900.6",
      gene_type : "protein_coding",
      gene_name : "POM121L12",
      gene_level : 2,
      hgnc_id : "HGNC:25369",
      havana_gene : "OTTHUMG00000155995.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 54542325,
      stop : 54571080,
      direction : "+",
      ID : "ENSG00000170419.11",
      gene_id : "ENSG00000170419.11",
      gene_type : "protein_coding",
      gene_name : "VSTM2A",
      gene_level : 1,
      hgnc_id : "HGNC:28499",
      havana_gene : "OTTHUMG00000129271.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 54752250,
      stop : 54759974,
      direction : "-",
      ID : "ENSG00000132432.14",
      gene_id : "ENSG00000132432.14",
      gene_type : "protein_coding",
      gene_name : "SEC61G",
      gene_level : 2,
      hgnc_id : "HGNC:18277",
      havana_gene : "OTTHUMG00000023430.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55019017,
      stop : 55211628,
      direction : "+",
      ID : "ENSG00000146648.19",
      gene_id : "ENSG00000146648.19",
      gene_type : "protein_coding",
      gene_name : "EGFR",
      gene_level : 1,
      hgnc_id : "HGNC:3236",
      havana_gene : "OTTHUMG00000023661.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55365337,
      stop : 55433737,
      direction : "+",
      ID : "ENSG00000132434.10",
      gene_id : "ENSG00000132434.10",
      gene_type : "protein_coding",
      gene_name : "LANCL2",
      gene_level : 2,
      hgnc_id : "HGNC:6509",
      havana_gene : "OTTHUMG00000023779.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55436056,
      stop : 55572988,
      direction : "-",
      ID : "ENSG00000154978.13",
      gene_id : "ENSG00000154978.13",
      gene_type : "protein_coding",
      gene_name : "VOPP1",
      gene_level : 1,
      hgnc_id : "HGNC:34518",
      havana_gene : "OTTHUMG00000156124.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55793540,
      stop : 55862755,
      direction : "-",
      ID : "ENSG00000154997.9",
      gene_id : "ENSG00000154997.9",
      gene_type : "protein_coding",
      gene_name : "SEPTIN14",
      gene_level : 2,
      hgnc_id : "HGNC:33280",
      havana_gene : "OTTHUMG00000129341.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55887277,
      stop : 55955239,
      direction : "+",
      ID : "ENSG00000249773.3",
      gene_id : "ENSG00000249773.3",
      gene_type : "protein_coding",
      gene_name : "AC092647.5",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160988.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55887456,
      stop : 55942530,
      direction : "+",
      ID : "ENSG00000178665.16",
      gene_id : "ENSG00000178665.16",
      gene_type : "protein_coding",
      gene_name : "ZNF713",
      gene_level : 2,
      hgnc_id : "HGNC:22043",
      havana_gene : "OTTHUMG00000156175.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55951793,
      stop : 56000181,
      direction : "+",
      ID : "ENSG00000146729.10",
      gene_id : "ENSG00000146729.10",
      gene_type : "protein_coding",
      gene_name : "NIPSNAP2",
      gene_level : 1,
      hgnc_id : "HGNC:4179",
      havana_gene : "OTTHUMG00000022932.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 55951877,
      stop : 55956500,
      direction : "+",
      ID : "ENSG00000239789.6",
      gene_id : "ENSG00000239789.6",
      gene_type : "protein_coding",
      gene_name : "MRPS17",
      gene_level : 2,
      hgnc_id : "HGNC:14047",
      havana_gene : "OTTHUMG00000023153.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 56011051,
      stop : 56051604,
      direction : "-",
      ID : "ENSG00000146733.14",
      gene_id : "ENSG00000146733.14",
      gene_type : "protein_coding",
      gene_name : "PSPH",
      gene_level : 2,
      hgnc_id : "HGNC:9577",
      havana_gene : "OTTHUMG00000023441.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 56051685,
      stop : 56063989,
      direction : "+",
      ID : "ENSG00000146731.11",
      gene_id : "ENSG00000146731.11",
      gene_type : "protein_coding",
      gene_name : "CCT6A",
      gene_level : 2,
      hgnc_id : "HGNC:1620",
      havana_gene : "OTTHUMG00000022842.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 56064002,
      stop : 56080670,
      direction : "+",
      ID : "ENSG00000129103.19",
      gene_id : "ENSG00000129103.19",
      gene_type : "protein_coding",
      gene_name : "SUMF2",
      gene_level : 1,
      hgnc_id : "HGNC:20415",
      havana_gene : "OTTHUMG00000129373.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 56080283,
      stop : 56092996,
      direction : "-",
      ID : "ENSG00000164776.10",
      gene_id : "ENSG00000164776.10",
      gene_type : "protein_coding",
      gene_name : "PHKG1",
      gene_level : 2,
      hgnc_id : "HGNC:8930",
      havana_gene : "OTTHUMG00000023869.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 56101573,
      stop : 56106476,
      direction : "-",
      ID : "ENSG00000106153.13",
      gene_id : "ENSG00000106153.13",
      gene_type : "protein_coding",
      gene_name : "CHCHD2",
      gene_level : 2,
      hgnc_id : "HGNC:21645",
      havana_gene : "OTTHUMG00000129429.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 56114681,
      stop : 56116417,
      direction : "-",
      ID : "ENSG00000185290.4",
      gene_id : "ENSG00000185290.4",
      gene_type : "protein_coding",
      gene_name : "NUPR2",
      gene_level : 2,
      hgnc_id : "HGNC:44164",
      havana_gene : "OTTHUMG00000156224.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 57119614,
      stop : 57139864,
      direction : "-",
      ID : "ENSG00000185177.13",
      gene_id : "ENSG00000185177.13",
      gene_type : "protein_coding",
      gene_name : "ZNF479",
      gene_level : 2,
      hgnc_id : "HGNC:23258",
      havana_gene : "OTTHUMG00000156682.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 57450177,
      stop : 57473559,
      direction : "+",
      ID : "ENSG00000182111.9",
      gene_id : "ENSG00000182111.9",
      gene_type : "protein_coding",
      gene_name : "ZNF716",
      gene_level : 2,
      hgnc_id : "HGNC:32458",
      havana_gene : "OTTHUMG00000156689.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 63998874,
      stop : 64016130,
      direction : "+",
      ID : "ENSG00000241149.3",
      gene_id : "ENSG00000241149.3",
      gene_type : "protein_coding",
      gene_name : "ZNF722P",
      gene_level : 2,
      hgnc_id : "HGNC:22571",
      havana_gene : "OTTHUMG00000156485.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64045434,
      stop : 64085339,
      direction : "+",
      ID : "ENSG00000214652.6",
      gene_id : "ENSG00000214652.6",
      gene_type : "protein_coding",
      gene_name : "ZNF727",
      gene_level : 2,
      hgnc_id : "HGNC:22785",
      havana_gene : "OTTHUMG00000156536.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64207090,
      stop : 64220508,
      direction : "+",
      ID : "ENSG00000223614.5",
      gene_id : "ENSG00000223614.5",
      gene_type : "protein_coding",
      gene_name : "ZNF735",
      gene_level : 2,
      hgnc_id : "HGNC:32466",
      havana_gene : "OTTHUMG00000156539.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64228474,
      stop : 64266931,
      direction : "+",
      ID : "ENSG00000197123.9",
      gene_id : "ENSG00000197123.9",
      gene_type : "protein_coding",
      gene_name : "ZNF679",
      gene_level : 2,
      hgnc_id : "HGNC:28650",
      havana_gene : "OTTHUMG00000156486.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64307459,
      stop : 64356634,
      direction : "+",
      ID : "ENSG00000234444.10",
      gene_id : "ENSG00000234444.10",
      gene_type : "protein_coding",
      gene_name : "ZNF736",
      gene_level : 1,
      hgnc_id : "HGNC:32467",
      havana_gene : "OTTHUMG00000156537.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64519878,
      stop : 64563075,
      direction : "-",
      ID : "ENSG00000173041.12",
      gene_id : "ENSG00000173041.12",
      gene_type : "protein_coding",
      gene_name : "ZNF680",
      gene_level : 1,
      hgnc_id : "HGNC:26897",
      havana_gene : "OTTHUMG00000156542.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64666083,
      stop : 64711582,
      direction : "+",
      ID : "ENSG00000196247.11",
      gene_id : "ENSG00000196247.11",
      gene_type : "protein_coding",
      gene_name : "ZNF107",
      gene_level : 2,
      hgnc_id : "HGNC:12887",
      havana_gene : "OTTHUMG00000129433.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64794388,
      stop : 64833681,
      direction : "+",
      ID : "ENSG00000197008.10",
      gene_id : "ENSG00000197008.10",
      gene_type : "protein_coding",
      gene_name : "ZNF138",
      gene_level : 1,
      hgnc_id : "HGNC:12922",
      havana_gene : "OTTHUMG00000156603.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64870172,
      stop : 64930966,
      direction : "+",
      ID : "ENSG00000198039.11",
      gene_id : "ENSG00000198039.11",
      gene_type : "protein_coding",
      gene_name : "ZNF273",
      gene_level : 1,
      hgnc_id : "HGNC:13067",
      havana_gene : "OTTHUMG00000149837.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64971772,
      stop : 65006684,
      direction : "-",
      ID : "ENSG00000152926.15",
      gene_id : "ENSG00000152926.15",
      gene_type : "protein_coding",
      gene_name : "ZNF117",
      gene_level : 2,
      hgnc_id : "HGNC:12897",
      havana_gene : "OTTHUMG00000156631.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 64990356,
      stop : 65006743,
      direction : "-",
      ID : "ENSG00000213462.5",
      gene_id : "ENSG00000213462.5",
      gene_type : "protein_coding",
      gene_name : "ERV3-1",
      gene_level : 2,
      hgnc_id : "HGNC:3454",
      havana_gene : "OTTHUMG00000165023.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 65373799,
      stop : 65401136,
      direction : "+",
      ID : "ENSG00000146757.14",
      gene_id : "ENSG00000146757.14",
      gene_type : "protein_coding",
      gene_name : "ZNF92",
      gene_level : 1,
      hgnc_id : "HGNC:13168",
      havana_gene : "OTTHUMG00000156557.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 65873074,
      stop : 65959563,
      direction : "+",
      ID : "ENSG00000196715.7",
      gene_id : "ENSG00000196715.7",
      gene_type : "protein_coding",
      gene_name : "VKORC1L1",
      gene_level : 2,
      hgnc_id : "HGNC:21492",
      havana_gene : "OTTHUMG00000129449.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 65960684,
      stop : 65982215,
      direction : "-",
      ID : "ENSG00000169919.17",
      gene_id : "ENSG00000169919.17",
      gene_type : "protein_coding",
      gene_name : "GUSB",
      gene_level : 1,
      hgnc_id : "HGNC:4696",
      havana_gene : "OTTHUMG00000023735.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66075800,
      stop : 66094697,
      direction : "+",
      ID : "ENSG00000126522.17",
      gene_id : "ENSG00000126522.17",
      gene_type : "protein_coding",
      gene_name : "ASL",
      gene_level : 1,
      hgnc_id : "HGNC:746",
      havana_gene : "OTTHUMG00000022876.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66087761,
      stop : 66152277,
      direction : "+",
      ID : "ENSG00000249319.2",
      gene_id : "ENSG00000249319.2",
      gene_type : "protein_coding",
      gene_name : "AC068533.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000160818.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66114604,
      stop : 66154568,
      direction : "+",
      ID : "ENSG00000241258.7",
      gene_id : "ENSG00000241258.7",
      gene_type : "protein_coding",
      gene_name : "CRCP",
      gene_level : 1,
      hgnc_id : "HGNC:17888",
      havana_gene : "OTTHUMG00000129519.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66205317,
      stop : 66420543,
      direction : "+",
      ID : "ENSG00000169902.15",
      gene_id : "ENSG00000169902.15",
      gene_type : "protein_coding",
      gene_name : "TPST1",
      gene_level : 2,
      hgnc_id : "HGNC:12020",
      havana_gene : "OTTHUMG00000023871.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66628881,
      stop : 66649067,
      direction : "+",
      ID : "ENSG00000243335.10",
      gene_id : "ENSG00000243335.10",
      gene_type : "protein_coding",
      gene_name : "KCTD7",
      gene_level : 1,
      hgnc_id : "HGNC:21957",
      havana_gene : "OTTHUMG00000129543.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66628958,
      stop : 66811189,
      direction : "+",
      ID : "ENSG00000284461.2",
      gene_id : "ENSG00000284461.2",
      gene_type : "protein_coding",
      gene_name : "AC027644.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192208.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66682164,
      stop : 66811464,
      direction : "+",
      ID : "ENSG00000154710.18",
      gene_id : "ENSG00000154710.18",
      gene_type : "protein_coding",
      gene_name : "RABGEF1",
      gene_level : 2,
      hgnc_id : "HGNC:17676",
      havana_gene : "OTTHUMG00000129547.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66921225,
      stop : 66958551,
      direction : "+",
      ID : "ENSG00000106609.16",
      gene_id : "ENSG00000106609.16",
      gene_type : "protein_coding",
      gene_name : "TMEM248",
      gene_level : 2,
      hgnc_id : "HGNC:25476",
      havana_gene : "OTTHUMG00000129553.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66987680,
      stop : 66995587,
      direction : "-",
      ID : "ENSG00000126524.10",
      gene_id : "ENSG00000126524.10",
      gene_type : "protein_coding",
      gene_name : "SBDS",
      gene_level : 2,
      hgnc_id : "HGNC:19440",
      havana_gene : "OTTHUMG00000023165.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 66995173,
      stop : 67239519,
      direction : "+",
      ID : "ENSG00000198874.13",
      gene_id : "ENSG00000198874.13",
      gene_type : "protein_coding",
      gene_name : "TYW1",
      gene_level : 2,
      hgnc_id : "HGNC:25598",
      havana_gene : "OTTHUMG00000129723.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 67278714,
      stop : 67286664,
      direction : "+",
      ID : "ENSG00000230358.4",
      gene_id : "ENSG00000230358.4",
      gene_type : "protein_coding",
      gene_name : "SPDYE21",
      gene_level : 2,
      hgnc_id : "HGNC:51517",
      havana_gene : "OTTHUMG00000156921.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 69598296,
      stop : 70793506,
      direction : "+",
      ID : "ENSG00000158321.18",
      gene_id : "ENSG00000158321.18",
      gene_type : "protein_coding",
      gene_name : "AUTS2",
      gene_level : 2,
      hgnc_id : "HGNC:14262",
      havana_gene : "OTTHUMG00000023865.12",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 71132144,
      stop : 71713600,
      direction : "+",
      ID : "ENSG00000185274.12",
      gene_id : "ENSG00000185274.12",
      gene_type : "protein_coding",
      gene_name : "GALNT17",
      gene_level : 2,
      hgnc_id : "HGNC:16347",
      havana_gene : "OTTHUMG00000129783.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 71779491,
      stop : 72447151,
      direction : "-",
      ID : "ENSG00000183166.11",
      gene_id : "ENSG00000183166.11",
      gene_type : "protein_coding",
      gene_name : "CALN1",
      gene_level : 2,
      hgnc_id : "HGNC:13248",
      havana_gene : "OTTHUMG00000023787.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 72558744,
      stop : 72828200,
      direction : "-",
      ID : "ENSG00000277149.5",
      gene_id : "ENSG00000277149.5",
      gene_type : "protein_coding",
      gene_name : "TYW1B",
      gene_level : 2,
      hgnc_id : "HGNC:33908",
      havana_gene : "OTTHUMG00000157067.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 72879365,
      stop : 72951440,
      direction : "+",
      ID : "ENSG00000196313.11",
      gene_id : "ENSG00000196313.11",
      gene_type : "protein_coding",
      gene_name : "POM121",
      gene_level : 2,
      hgnc_id : "HGNC:19702",
      havana_gene : "OTTHUMG00000023527.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 72959485,
      stop : 72969466,
      direction : "-",
      ID : "ENSG00000155428.12",
      gene_id : "ENSG00000155428.12",
      gene_type : "protein_coding",
      gene_name : "TRIM74",
      gene_level : 2,
      hgnc_id : "HGNC:17453",
      havana_gene : "OTTHUMG00000129851.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73020338,
      stop : 73029766,
      direction : "-",
      ID : "ENSG00000273520.5",
      gene_id : "ENSG00000273520.5",
      gene_type : "protein_coding",
      gene_name : "SPDYE8",
      gene_level : 2,
      hgnc_id : "HGNC:33771",
      havana_gene : "OTTHUMG00000188238.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73048481,
      stop : 73057911,
      direction : "-",
      ID : "ENSG00000286228.1",
      gene_id : "ENSG00000286228.1",
      gene_type : "protein_coding",
      gene_name : "SPDYE11",
      gene_level : 2,
      hgnc_id : "HGNC:51507",
      havana_gene : "OTTHUMG00000188240.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73076165,
      stop : 73086038,
      direction : "-",
      ID : "ENSG00000262461.6",
      gene_id : "ENSG00000262461.6",
      gene_type : "protein_coding",
      gene_name : "SPDYE9",
      gene_level : 2,
      hgnc_id : "HGNC:45034",
      havana_gene : "OTTHUMG00000150524.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73302516,
      stop : 73308826,
      direction : "-",
      ID : "ENSG00000130305.17",
      gene_id : "ENSG00000130305.17",
      gene_type : "protein_coding",
      gene_name : "NSUN5",
      gene_level : 2,
      hgnc_id : "HGNC:16385",
      havana_gene : "OTTHUMG00000129869.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73312536,
      stop : 73328082,
      direction : "-",
      ID : "ENSG00000146755.11",
      gene_id : "ENSG00000146755.11",
      gene_type : "protein_coding",
      gene_name : "TRIM50",
      gene_level : 2,
      hgnc_id : "HGNC:19017",
      havana_gene : "OTTHUMG00000156805.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73328161,
      stop : 73358637,
      direction : "+",
      ID : "ENSG00000077800.13",
      gene_id : "ENSG00000077800.13",
      gene_type : "protein_coding",
      gene_name : "FKBP6",
      gene_level : 1,
      hgnc_id : "HGNC:3722",
      havana_gene : "OTTHUMG00000150520.13",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73433778,
      stop : 73436120,
      direction : "+",
      ID : "ENSG00000188763.5",
      gene_id : "ENSG00000188763.5",
      gene_type : "protein_coding",
      gene_name : "FZD9",
      gene_level : 2,
      hgnc_id : "HGNC:4047",
      havana_gene : "OTTHUMG00000023051.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73440406,
      stop : 73522293,
      direction : "-",
      ID : "ENSG00000009954.11",
      gene_id : "ENSG00000009954.11",
      gene_type : "protein_coding",
      gene_name : "BAZ1B",
      gene_level : 2,
      hgnc_id : "HGNC:961",
      havana_gene : "OTTHUMG00000023847.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73536356,
      stop : 73557690,
      direction : "-",
      ID : "ENSG00000106635.8",
      gene_id : "ENSG00000106635.8",
      gene_type : "protein_coding",
      gene_name : "BCL7B",
      gene_level : 2,
      hgnc_id : "HGNC:1005",
      havana_gene : "OTTHUMG00000023412.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73567537,
      stop : 73578791,
      direction : "-",
      ID : "ENSG00000106638.17",
      gene_id : "ENSG00000106638.17",
      gene_type : "protein_coding",
      gene_name : "TBL2",
      gene_level : 2,
      hgnc_id : "HGNC:11586",
      havana_gene : "OTTHUMG00000023427.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73593194,
      stop : 73624543,
      direction : "-",
      ID : "ENSG00000009950.16",
      gene_id : "ENSG00000009950.16",
      gene_type : "protein_coding",
      gene_name : "MLXIPL",
      gene_level : 1,
      hgnc_id : "HGNC:12744",
      havana_gene : "OTTHUMG00000129995.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73667831,
      stop : 73672112,
      direction : "+",
      ID : "ENSG00000176428.6",
      gene_id : "ENSG00000176428.6",
      gene_type : "protein_coding",
      gene_name : "VPS37D",
      gene_level : 2,
      hgnc_id : "HGNC:18287",
      havana_gene : "OTTHUMG00000157227.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73680918,
      stop : 73683453,
      direction : "-",
      ID : "ENSG00000176410.8",
      gene_id : "ENSG00000176410.8",
      gene_type : "protein_coding",
      gene_name : "DNAJC30",
      gene_level : 2,
      hgnc_id : "HGNC:16410",
      havana_gene : "OTTHUMG00000023290.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73683025,
      stop : 73705161,
      direction : "+",
      ID : "ENSG00000071462.12",
      gene_id : "ENSG00000071462.12",
      gene_type : "protein_coding",
      gene_name : "BUD23",
      gene_level : 2,
      hgnc_id : "HGNC:16405",
      havana_gene : "OTTHUMG00000023306.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73699206,
      stop : 73719672,
      direction : "-",
      ID : "ENSG00000106089.12",
      gene_id : "ENSG00000106089.12",
      gene_type : "protein_coding",
      gene_name : "STX1A",
      gene_level : 1,
      hgnc_id : "HGNC:11433",
      havana_gene : "OTTHUMG00000137422.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73736094,
      stop : 73738867,
      direction : "-",
      ID : "ENSG00000106077.18",
      gene_id : "ENSG00000106077.18",
      gene_type : "protein_coding",
      gene_name : "ABHD11",
      gene_level : 1,
      hgnc_id : "HGNC:16407",
      havana_gene : "OTTHUMG00000130029.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73768997,
      stop : 73770270,
      direction : "-",
      ID : "ENSG00000165215.6",
      gene_id : "ENSG00000165215.6",
      gene_type : "protein_coding",
      gene_name : "CLDN3",
      gene_level : 2,
      hgnc_id : "HGNC:2045",
      havana_gene : "OTTHUMG00000023424.2",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73799542,
      stop : 73832690,
      direction : "+",
      ID : "ENSG00000189143.10",
      gene_id : "ENSG00000189143.10",
      gene_type : "protein_coding",
      gene_name : "CLDN4",
      gene_level : 1,
      hgnc_id : "HGNC:2046",
      havana_gene : "OTTHUMG00000023425.4",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73834590,
      stop : 73842516,
      direction : "-",
      ID : "ENSG00000165171.11",
      gene_id : "ENSG00000165171.11",
      gene_type : "protein_coding",
      gene_name : "METTL27",
      gene_level : 2,
      hgnc_id : "HGNC:19068",
      havana_gene : "OTTHUMG00000130033.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 73861159,
      stop : 73865890,
      direction : "+",
      ID : "ENSG00000175877.4",
      gene_id : "ENSG00000175877.4",
      gene_type : "protein_coding",
      gene_name : "TMEM270",
      gene_level : 2,
      hgnc_id : "HGNC:23018",
      havana_gene : "OTTHUMG00000157243.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74027789,
      stop : 74069907,
      direction : "+",
      ID : "ENSG00000049540.18",
      gene_id : "ENSG00000049540.18",
      gene_type : "protein_coding",
      gene_name : "ELN",
      gene_level : 2,
      hgnc_id : "HGNC:3327",
      havana_gene : "OTTHUMG00000150229.14",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74082933,
      stop : 74122525,
      direction : "+",
      ID : "ENSG00000106683.15",
      gene_id : "ENSG00000106683.15",
      gene_type : "protein_coding",
      gene_name : "LIMK1",
      gene_level : 1,
      hgnc_id : "HGNC:6613",
      havana_gene : "OTTHUMG00000023448.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74174231,
      stop : 74197122,
      direction : "+",
      ID : "ENSG00000106682.16",
      gene_id : "ENSG00000106682.16",
      gene_type : "protein_coding",
      gene_name : "EIF4H",
      gene_level : 2,
      hgnc_id : "HGNC:12741",
      havana_gene : "OTTHUMG00000023025.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74199652,
      stop : 74229834,
      direction : "+",
      ID : "ENSG00000086730.17",
      gene_id : "ENSG00000086730.17",
      gene_type : "protein_coding",
      gene_name : "LAT2",
      gene_level : 2,
      hgnc_id : "HGNC:12749",
      havana_gene : "OTTHUMG00000130151.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74231499,
      stop : 74254458,
      direction : "-",
      ID : "ENSG00000049541.11",
      gene_id : "ENSG00000049541.11",
      gene_type : "protein_coding",
      gene_name : "RFC2",
      gene_level : 2,
      hgnc_id : "HGNC:9970",
      havana_gene : "OTTHUMG00000023239.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74289407,
      stop : 74405935,
      direction : "+",
      ID : "ENSG00000106665.16",
      gene_id : "ENSG00000106665.16",
      gene_type : "protein_coding",
      gene_name : "CLIP2",
      gene_level : 1,
      hgnc_id : "HGNC:2586",
      havana_gene : "OTTHUMG00000022980.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74453790,
      stop : 74602605,
      direction : "+",
      ID : "ENSG00000006704.11",
      gene_id : "ENSG00000006704.11",
      gene_type : "protein_coding",
      gene_name : "GTF2IRD1",
      gene_level : 1,
      hgnc_id : "HGNC:4661",
      havana_gene : "OTTHUMG00000023782.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74650231,
      stop : 74760692,
      direction : "+",
      ID : "ENSG00000263001.7",
      gene_id : "ENSG00000263001.7",
      gene_type : "protein_coding",
      gene_name : "GTF2I",
      gene_level : 2,
      hgnc_id : "HGNC:4659",
      havana_gene : "OTTHUMG00000156237.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74773962,
      stop : 74789376,
      direction : "+",
      ID : "ENSG00000158517.15",
      gene_id : "ENSG00000158517.15",
      gene_type : "protein_coding",
      gene_name : "NCF1",
      gene_level : 2,
      hgnc_id : "HGNC:7660",
      havana_gene : "OTTHUMG00000149965.14",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74796144,
      stop : 74851551,
      direction : "-",
      ID : "ENSG00000196275.14",
      gene_id : "ENSG00000196275.14",
      gene_type : "protein_coding",
      gene_name : "GTF2IRD2",
      gene_level : 2,
      hgnc_id : "HGNC:30775",
      havana_gene : "OTTHUMG00000181527.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 74964705,
      stop : 75031528,
      direction : "+",
      ID : "ENSG00000274070.2",
      gene_id : "ENSG00000274070.2",
      gene_type : "protein_coding",
      gene_name : "CASTOR2",
      gene_level : 2,
      hgnc_id : "HGNC:37073",
      havana_gene : "OTTHUMG00000181541.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75027122,
      stop : 75074228,
      direction : "-",
      ID : "ENSG00000274523.5",
      gene_id : "ENSG00000274523.5",
      gene_type : "protein_coding",
      gene_name : "RCC1L",
      gene_level : 2,
      hgnc_id : "HGNC:14948",
      havana_gene : "OTTHUMG00000130373.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75092573,
      stop : 75149817,
      direction : "+",
      ID : "ENSG00000174428.18",
      gene_id : "ENSG00000174428.18",
      gene_type : "protein_coding",
      gene_name : "GTF2IRD2B",
      gene_level : 2,
      hgnc_id : "HGNC:33125",
      havana_gene : "OTTHUMG00000181534.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75281243,
      stop : 75287121,
      direction : "+",
      ID : "ENSG00000286038.1",
      gene_id : "ENSG00000286038.1",
      gene_type : "protein_coding",
      gene_name : "SPDYE13",
      gene_level : 2,
      hgnc_id : "HGNC:51509",
      havana_gene : "OTTHUMG00000182946.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75309171,
      stop : 75315049,
      direction : "+",
      ID : "ENSG00000286137.1",
      gene_id : "ENSG00000286137.1",
      gene_type : "protein_coding",
      gene_name : "SPDYE14",
      gene_level : 2,
      hgnc_id : "HGNC:51510",
      havana_gene : "OTTHUMG00000182948.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75337138,
      stop : 75343016,
      direction : "+",
      ID : "ENSG00000286014.1",
      gene_id : "ENSG00000286014.1",
      gene_type : "protein_coding",
      gene_name : "SPDYE15",
      gene_level : 2,
      hgnc_id : "HGNC:51511",
      havana_gene : "OTTHUMG00000182950.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75395063,
      stop : 75410996,
      direction : "+",
      ID : "ENSG00000178809.11",
      gene_id : "ENSG00000178809.11",
      gene_type : "protein_coding",
      gene_name : "TRIM73",
      gene_level : 2,
      hgnc_id : "HGNC:18162",
      havana_gene : "OTTHUMG00000156075.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75416786,
      stop : 75486299,
      direction : "-",
      ID : "ENSG00000272391.6",
      gene_id : "ENSG00000272391.6",
      gene_type : "protein_coding",
      gene_name : "POM121C",
      gene_level : 2,
      hgnc_id : "HGNC:34005",
      havana_gene : "OTTHUMG00000156238.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75493625,
      stop : 75504304,
      direction : "+",
      ID : "ENSG00000170092.14",
      gene_id : "ENSG00000170092.14",
      gene_type : "protein_coding",
      gene_name : "SPDYE5",
      gene_level : 2,
      hgnc_id : "HGNC:35464",
      havana_gene : "OTTHUMG00000156138.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75533298,
      stop : 75738962,
      direction : "-",
      ID : "ENSG00000127946.17",
      gene_id : "ENSG00000127946.17",
      gene_type : "protein_coding",
      gene_name : "HIP1",
      gene_level : 1,
      hgnc_id : "HGNC:4913",
      havana_gene : "OTTHUMG00000156050.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75769533,
      stop : 75789896,
      direction : "-",
      ID : "ENSG00000006606.9",
      gene_id : "ENSG00000006606.9",
      gene_type : "protein_coding",
      gene_name : "CCL26",
      gene_level : 2,
      hgnc_id : "HGNC:10625",
      havana_gene : "OTTHUMG00000130403.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75810825,
      stop : 75823356,
      direction : "-",
      ID : "ENSG00000106178.7",
      gene_id : "ENSG00000106178.7",
      gene_type : "protein_coding",
      gene_name : "CCL24",
      gene_level : 2,
      hgnc_id : "HGNC:10623",
      havana_gene : "OTTHUMG00000156635.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75842602,
      stop : 75888926,
      direction : "+",
      ID : "ENSG00000005486.17",
      gene_id : "ENSG00000005486.17",
      gene_type : "protein_coding",
      gene_name : "RHBDD2",
      gene_level : 1,
      hgnc_id : "HGNC:23082",
      havana_gene : "OTTHUMG00000156435.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75899200,
      stop : 75986855,
      direction : "+",
      ID : "ENSG00000127948.16",
      gene_id : "ENSG00000127948.16",
      gene_type : "protein_coding",
      gene_name : "POR",
      gene_level : 2,
      hgnc_id : "HGNC:9208",
      havana_gene : "OTTHUMG00000130413.34",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75986831,
      stop : 75994656,
      direction : "-",
      ID : "ENSG00000189077.11",
      gene_id : "ENSG00000189077.11",
      gene_type : "protein_coding",
      gene_name : "TMEM120A",
      gene_level : 2,
      hgnc_id : "HGNC:21697",
      havana_gene : "OTTHUMG00000156620.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 75996338,
      stop : 76048004,
      direction : "-",
      ID : "ENSG00000127952.17",
      gene_id : "ENSG00000127952.17",
      gene_type : "protein_coding",
      gene_name : "STYXL1",
      gene_level : 1,
      hgnc_id : "HGNC:18165",
      havana_gene : "OTTHUMG00000130459.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76048051,
      stop : 76067508,
      direction : "+",
      ID : "ENSG00000146701.12",
      gene_id : "ENSG00000146701.12",
      gene_type : "protein_coding",
      gene_name : "MDH2",
      gene_level : 1,
      hgnc_id : "HGNC:6971",
      havana_gene : "OTTHUMG00000023827.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76201896,
      stop : 76287288,
      direction : "+",
      ID : "ENSG00000177679.16",
      gene_id : "ENSG00000177679.16",
      gene_type : "protein_coding",
      gene_name : "SRRM3",
      gene_level : 2,
      hgnc_id : "HGNC:26729",
      havana_gene : "OTTHUMG00000130489.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76302673,
      stop : 76304295,
      direction : "+",
      ID : "ENSG00000106211.10",
      gene_id : "ENSG00000106211.10",
      gene_type : "protein_coding",
      gene_name : "HSPB1",
      gene_level : 2,
      hgnc_id : "HGNC:5246",
      havana_gene : "OTTHUMG00000023228.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76326799,
      stop : 76358991,
      direction : "-",
      ID : "ENSG00000170027.7",
      gene_id : "ENSG00000170027.7",
      gene_type : "protein_coding",
      gene_name : "YWHAG",
      gene_level : 2,
      hgnc_id : "HGNC:12852",
      havana_gene : "OTTHUMG00000022862.4",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76389334,
      stop : 76409697,
      direction : "-",
      ID : "ENSG00000146700.9",
      gene_id : "ENSG00000146700.9",
      gene_type : "protein_coding",
      gene_name : "SSC4D",
      gene_level : 2,
      hgnc_id : "HGNC:14461",
      havana_gene : "OTTHUMG00000022864.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76397518,
      stop : 76442071,
      direction : "+",
      ID : "ENSG00000188372.15",
      gene_id : "ENSG00000188372.15",
      gene_type : "protein_coding",
      gene_name : "ZP3",
      gene_level : 2,
      hgnc_id : "HGNC:13189",
      havana_gene : "OTTHUMG00000130575.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76461676,
      stop : 76505995,
      direction : "+",
      ID : "ENSG00000091073.19",
      gene_id : "ENSG00000091073.19",
      gene_type : "protein_coding",
      gene_name : "DTX2",
      gene_level : 1,
      hgnc_id : "HGNC:15973",
      havana_gene : "OTTHUMG00000162594.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76510525,
      stop : 76516522,
      direction : "+",
      ID : "ENSG00000243566.7",
      gene_id : "ENSG00000243566.7",
      gene_type : "protein_coding",
      gene_name : "UPK3B",
      gene_level : 2,
      hgnc_id : "HGNC:21444",
      havana_gene : "OTTHUMG00000149929.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76531319,
      stop : 76541459,
      direction : "-",
      ID : "ENSG00000185040.13",
      gene_id : "ENSG00000185040.13",
      gene_type : "protein_coding",
      gene_name : "SPDYE16",
      gene_level : 2,
      hgnc_id : "HGNC:51512",
      havana_gene : "OTTHUMG00000155814.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 76609986,
      stop : 76627261,
      direction : "-",
      ID : "ENSG00000146707.14",
      gene_id : "ENSG00000146707.14",
      gene_type : "protein_coding",
      gene_name : "POMZP3",
      gene_level : 2,
      hgnc_id : "HGNC:9203",
      havana_gene : "OTTHUMG00000023514.22",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77022319,
      stop : 77032361,
      direction : "-",
      ID : "ENSG00000186645.10",
      gene_id : "ENSG00000186645.10",
      gene_type : "protein_coding",
      gene_name : "SPDYE17",
      gene_level : 2,
      hgnc_id : "HGNC:51513",
      havana_gene : "OTTHUMG00000155797.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77122434,
      stop : 77329533,
      direction : "+",
      ID : "ENSG00000135205.15",
      gene_id : "ENSG00000135205.15",
      gene_type : "protein_coding",
      gene_name : "CCDC146",
      gene_level : 2,
      hgnc_id : "HGNC:29296",
      havana_gene : "OTTHUMG00000162595.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77193369,
      stop : 77199848,
      direction : "-",
      ID : "ENSG00000127951.8",
      gene_id : "ENSG00000127951.8",
      gene_type : "protein_coding",
      gene_name : "FGL2",
      gene_level : 2,
      hgnc_id : "HGNC:3696",
      havana_gene : "OTTHUMG00000130681.3",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77310751,
      stop : 77416349,
      direction : "-",
      ID : "ENSG00000186088.16",
      gene_id : "ENSG00000186088.16",
      gene_type : "protein_coding",
      gene_name : "GSAP",
      gene_level : 2,
      hgnc_id : "HGNC:28042",
      havana_gene : "OTTHUMG00000150504.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77537295,
      stop : 77640069,
      direction : "+",
      ID : "ENSG00000127947.16",
      gene_id : "ENSG00000127947.16",
      gene_type : "protein_coding",
      gene_name : "PTPN12",
      gene_level : 1,
      hgnc_id : "HGNC:9645",
      havana_gene : "OTTHUMG00000023501.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77696459,
      stop : 77783022,
      direction : "+",
      ID : "ENSG00000187257.16",
      gene_id : "ENSG00000187257.16",
      gene_type : "protein_coding",
      gene_name : "RSBN1L",
      gene_level : 1,
      hgnc_id : "HGNC:24765",
      havana_gene : "OTTHUMG00000155517.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77793728,
      stop : 77798434,
      direction : "-",
      ID : "ENSG00000135211.6",
      gene_id : "ENSG00000135211.6",
      gene_type : "protein_coding",
      gene_name : "TMEM60",
      gene_level : 2,
      hgnc_id : "HGNC:21754",
      havana_gene : "OTTHUMG00000130689.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 77798792,
      stop : 77957503,
      direction : "+",
      ID : "ENSG00000006576.16",
      gene_id : "ENSG00000006576.16",
      gene_type : "protein_coding",
      gene_name : "PHTF2",
      gene_level : 2,
      hgnc_id : "HGNC:13411",
      havana_gene : "OTTHUMG00000155557.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 78017055,
      stop : 79453667,
      direction : "-",
      ID : "ENSG00000187391.22",
      gene_id : "ENSG00000187391.22",
      gene_type : "protein_coding",
      gene_name : "MAGI2",
      gene_level : 1,
      hgnc_id : "HGNC:18957",
      havana_gene : "OTTHUMG00000130697.19",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 79768028,
      stop : 80226181,
      direction : "+",
      ID : "ENSG00000127955.17",
      gene_id : "ENSG00000127955.17",
      gene_type : "protein_coding",
      gene_name : "GNAI1",
      gene_level : 2,
      hgnc_id : "HGNC:4384",
      havana_gene : "OTTHUMG00000023523.17",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 80369575,
      stop : 80679277,
      direction : "+",
      ID : "ENSG00000135218.19",
      gene_id : "ENSG00000135218.19",
      gene_type : "protein_coding",
      gene_name : "CD36",
      gene_level : 1,
      hgnc_id : "HGNC:1663",
      havana_gene : "OTTHUMG00000155383.23",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 80458635,
      stop : 80512064,
      direction : "-",
      ID : "ENSG00000214415.4",
      gene_id : "ENSG00000214415.4",
      gene_type : "protein_coding",
      gene_name : "GNAT3",
      gene_level : 2,
      hgnc_id : "HGNC:22800",
      havana_gene : "OTTHUMG00000155401.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 80742538,
      stop : 80922359,
      direction : "-",
      ID : "ENSG00000075223.14",
      gene_id : "ENSG00000075223.14",
      gene_type : "protein_coding",
      gene_name : "SEMA3C",
      gene_level : 1,
      hgnc_id : "HGNC:10725",
      havana_gene : "OTTHUMG00000023447.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 81699010,
      stop : 81770438,
      direction : "-",
      ID : "ENSG00000019991.18",
      gene_id : "ENSG00000019991.18",
      gene_type : "protein_coding",
      gene_name : "HGF",
      gene_level : 2,
      hgnc_id : "HGNC:4893",
      havana_gene : "OTTHUMG00000023804.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 81946444,
      stop : 82443777,
      direction : "-",
      ID : "ENSG00000153956.16",
      gene_id : "ENSG00000153956.16",
      gene_type : "protein_coding",
      gene_name : "CACNA2D1",
      gene_level : 1,
      hgnc_id : "HGNC:1399",
      havana_gene : "OTTHUMG00000023622.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 82754012,
      stop : 83162930,
      direction : "-",
      ID : "ENSG00000186472.20",
      gene_id : "ENSG00000186472.20",
      gene_type : "protein_coding",
      gene_name : "PCLO",
      gene_level : 1,
      hgnc_id : "HGNC:13406",
      havana_gene : "OTTHUMG00000154853.15",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 83363238,
      stop : 83649139,
      direction : "-",
      ID : "ENSG00000170381.14",
      gene_id : "ENSG00000170381.14",
      gene_type : "protein_coding",
      gene_name : "SEMA3E",
      gene_level : 2,
      hgnc_id : "HGNC:10727",
      havana_gene : "OTTHUMG00000154693.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 83955777,
      stop : 84492724,
      direction : "-",
      ID : "ENSG00000075213.11",
      gene_id : "ENSG00000075213.11",
      gene_type : "protein_coding",
      gene_name : "SEMA3A",
      gene_level : 2,
      hgnc_id : "HGNC:10723",
      havana_gene : "OTTHUMG00000023443.16",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 84995553,
      stop : 85186855,
      direction : "-",
      ID : "ENSG00000153993.13",
      gene_id : "ENSG00000153993.13",
      gene_type : "protein_coding",
      gene_name : "SEMA3D",
      gene_level : 1,
      hgnc_id : "HGNC:10726",
      havana_gene : "OTTHUMG00000154569.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 86643914,
      stop : 86864884,
      direction : "+",
      ID : "ENSG00000198822.10",
      gene_id : "ENSG00000198822.10",
      gene_type : "protein_coding",
      gene_name : "GRM3",
      gene_level : 2,
      hgnc_id : "HGNC:4595",
      havana_gene : "OTTHUMG00000022884.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 86876906,
      stop : 87059654,
      direction : "-",
      ID : "ENSG00000164659.15",
      gene_id : "ENSG00000164659.15",
      gene_type : "protein_coding",
      gene_name : "ELAPOR2",
      gene_level : 1,
      hgnc_id : "HGNC:21945",
      havana_gene : "OTTHUMG00000153995.59",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87152409,
      stop : 87196337,
      direction : "+",
      ID : "ENSG00000135164.19",
      gene_id : "ENSG00000135164.19",
      gene_type : "protein_coding",
      gene_name : "DMTF1",
      gene_level : 1,
      hgnc_id : "HGNC:14603",
      havana_gene : "OTTHUMG00000154135.66",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87196160,
      stop : 87220587,
      direction : "-",
      ID : "ENSG00000135185.12",
      gene_id : "ENSG00000135185.12",
      gene_type : "protein_coding",
      gene_name : "TMEM243",
      gene_level : 2,
      hgnc_id : "HGNC:21707",
      havana_gene : "OTTHUMG00000130823.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87345664,
      stop : 87399794,
      direction : "+",
      ID : "ENSG00000005469.12",
      gene_id : "ENSG00000005469.12",
      gene_type : "protein_coding",
      gene_name : "CROT",
      gene_level : 1,
      hgnc_id : "HGNC:2366",
      havana_gene : "OTTHUMG00000023653.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87401696,
      stop : 87480435,
      direction : "-",
      ID : "ENSG00000005471.19",
      gene_id : "ENSG00000005471.19",
      gene_type : "protein_coding",
      gene_name : "ABCB4",
      gene_level : 2,
      hgnc_id : "HGNC:45",
      havana_gene : "OTTHUMG00000023396.20",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87503017,
      stop : 87713323,
      direction : "-",
      ID : "ENSG00000085563.15",
      gene_id : "ENSG00000085563.15",
      gene_type : "protein_coding",
      gene_name : "ABCB1",
      gene_level : 1,
      hgnc_id : "HGNC:40",
      havana_gene : "OTTHUMG00000023393.27",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87627548,
      stop : 87832296,
      direction : "+",
      ID : "ENSG00000105784.15",
      gene_id : "ENSG00000105784.15",
      gene_type : "protein_coding",
      gene_name : "RUNDC3B",
      gene_level : 2,
      hgnc_id : "HGNC:30286",
      havana_gene : "OTTHUMG00000131035.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87833568,
      stop : 87876360,
      direction : "-",
      ID : "ENSG00000075303.13",
      gene_id : "ENSG00000075303.13",
      gene_type : "protein_coding",
      gene_name : "SLC25A40",
      gene_level : 2,
      hgnc_id : "HGNC:29680",
      havana_gene : "OTTHUMG00000131033.13",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87876216,
      stop : 87909553,
      direction : "+",
      ID : "ENSG00000006634.8",
      gene_id : "ENSG00000006634.8",
      gene_type : "protein_coding",
      gene_name : "DBF4",
      gene_level : 2,
      hgnc_id : "HGNC:17364",
      havana_gene : "OTTHUMG00000131034.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 87934143,
      stop : 88202889,
      direction : "+",
      ID : "ENSG00000008277.14",
      gene_id : "ENSG00000008277.14",
      gene_type : "protein_coding",
      gene_name : "ADAM22",
      gene_level : 1,
      hgnc_id : "HGNC:201",
      havana_gene : "OTTHUMG00000137417.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 88205115,
      stop : 88226993,
      direction : "-",
      ID : "ENSG00000075142.14",
      gene_id : "ENSG00000075142.14",
      gene_type : "protein_coding",
      gene_name : "SRI",
      gene_level : 2,
      hgnc_id : "HGNC:11292",
      havana_gene : "OTTHUMG00000157267.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 88270892,
      stop : 88306894,
      direction : "-",
      ID : "ENSG00000127954.13",
      gene_id : "ENSG00000127954.13",
      gene_type : "protein_coding",
      gene_name : "STEAP4",
      gene_level : 2,
      hgnc_id : "HGNC:21923",
      havana_gene : "OTTHUMG00000153853.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 88759700,
      stop : 89338528,
      direction : "+",
      ID : "ENSG00000182348.7",
      gene_id : "ENSG00000182348.7",
      gene_type : "protein_coding",
      gene_name : "ZNF804B",
      gene_level : 2,
      hgnc_id : "HGNC:21958",
      havana_gene : "OTTHUMG00000131037.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 88794106,
      stop : 88795737,
      direction : "-",
      ID : "ENSG00000164645.3",
      gene_id : "ENSG00000164645.3",
      gene_type : "protein_coding",
      gene_name : "TEX47",
      gene_level : 2,
      hgnc_id : "HGNC:22402",
      havana_gene : "OTTHUMG00000153859.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90154456,
      stop : 90164829,
      direction : "+",
      ID : "ENSG00000164647.9",
      gene_id : "ENSG00000164647.9",
      gene_type : "protein_coding",
      gene_name : "STEAP1",
      gene_level : 2,
      hgnc_id : "HGNC:11378",
      havana_gene : "OTTHUMG00000023006.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90167590,
      stop : 90238137,
      direction : "+",
      ID : "ENSG00000157214.14",
      gene_id : "ENSG00000157214.14",
      gene_type : "protein_coding",
      gene_name : "STEAP2",
      gene_level : 1,
      hgnc_id : "HGNC:17885",
      havana_gene : "OTTHUMG00000023341.13",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90245174,
      stop : 90311063,
      direction : "+",
      ID : "ENSG00000105792.19",
      gene_id : "ENSG00000105792.19",
      gene_type : "protein_coding",
      gene_name : "CFAP69",
      gene_level : 2,
      hgnc_id : "HGNC:26107",
      havana_gene : "OTTHUMG00000023434.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90316503,
      stop : 90321308,
      direction : "-",
      ID : "ENSG00000283267.1",
      gene_id : "ENSG00000283267.1",
      gene_type : "protein_coding",
      gene_name : "FAM237B",
      gene_level : 2,
      hgnc_id : "HGNC:53217",
      havana_gene : "OTTHUMG00000191757.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90335223,
      stop : 90391453,
      direction : "+",
      ID : "ENSG00000105793.16",
      gene_id : "ENSG00000105793.16",
      gene_type : "protein_coding",
      gene_name : "GTPBP10",
      gene_level : 1,
      hgnc_id : "HGNC:25106",
      havana_gene : "OTTHUMG00000023655.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90383721,
      stop : 90513402,
      direction : "+",
      ID : "ENSG00000157224.16",
      gene_id : "ENSG00000157224.16",
      gene_type : "protein_coding",
      gene_name : "CLDN12",
      gene_level : 2,
      hgnc_id : "HGNC:2034",
      havana_gene : "OTTHUMG00000156612.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90466424,
      stop : 91210590,
      direction : "+",
      ID : "ENSG00000058091.17",
      gene_id : "ENSG00000058091.17",
      gene_type : "protein_coding",
      gene_name : "CDK14",
      gene_level : 2,
      hgnc_id : "HGNC:8883",
      havana_gene : "OTTHUMG00000023649.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 90469639,
      stop : 90513397,
      direction : "+",
      ID : "ENSG00000251154.2",
      gene_id : "ENSG00000251154.2",
      gene_type : "protein_coding",
      gene_name : "AC002456.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000022900.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 91264433,
      stop : 91271326,
      direction : "+",
      ID : "ENSG00000157240.4",
      gene_id : "ENSG00000157240.4",
      gene_type : "protein_coding",
      gene_name : "FZD1",
      gene_level : 2,
      hgnc_id : "HGNC:4038",
      havana_gene : "OTTHUMG00000023046.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 91692008,
      stop : 91880702,
      direction : "-",
      ID : "ENSG00000127989.14",
      gene_id : "ENSG00000127989.14",
      gene_type : "protein_coding",
      gene_name : "MTERF1",
      gene_level : 2,
      hgnc_id : "HGNC:21463",
      havana_gene : "OTTHUMG00000156057.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 91940840,
      stop : 92110673,
      direction : "+",
      ID : "ENSG00000127914.19",
      gene_id : "ENSG00000127914.19",
      gene_type : "protein_coding",
      gene_name : "AKAP9",
      gene_level : 1,
      hgnc_id : "HGNC:379",
      havana_gene : "OTTHUMG00000131127.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92112153,
      stop : 92134803,
      direction : "-",
      ID : "ENSG00000001630.17",
      gene_id : "ENSG00000001630.17",
      gene_type : "protein_coding",
      gene_name : "CYP51A1",
      gene_level : 1,
      hgnc_id : "HGNC:2649",
      havana_gene : "OTTHUMG00000193420.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92112159,
      stop : 92179511,
      direction : "-",
      ID : "ENSG00000285772.1",
      gene_id : "ENSG00000285772.1",
      gene_type : "protein_coding",
      gene_name : "AC000120.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000131131.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92131774,
      stop : 92245924,
      direction : "-",
      ID : "ENSG00000285953.1",
      gene_id : "ENSG00000285953.1",
      gene_type : "protein_coding",
      gene_name : "AC000120.3",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000193355.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92141643,
      stop : 92179531,
      direction : "-",
      ID : "ENSG00000240720.10",
      gene_id : "ENSG00000240720.10",
      gene_type : "protein_coding",
      gene_name : "LRRD1",
      gene_level : 2,
      hgnc_id : "HGNC:34300",
      havana_gene : "OTTHUMG00000155861.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92198969,
      stop : 92246166,
      direction : "-",
      ID : "ENSG00000001631.16",
      gene_id : "ENSG00000001631.16",
      gene_type : "protein_coding",
      gene_name : "KRIT1",
      gene_level : 2,
      hgnc_id : "HGNC:1573",
      havana_gene : "OTTHUMG00000131187.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92245974,
      stop : 92401383,
      direction : "+",
      ID : "ENSG00000001629.10",
      gene_id : "ENSG00000001629.10",
      gene_type : "protein_coding",
      gene_name : "ANKIB1",
      gene_level : 2,
      hgnc_id : "HGNC:22215",
      havana_gene : "OTTHUMG00000155859.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92447482,
      stop : 92460075,
      direction : "+",
      ID : "ENSG00000157259.8",
      gene_id : "ENSG00000157259.8",
      gene_type : "protein_coding",
      gene_name : "GATAD1",
      gene_level : 2,
      hgnc_id : "HGNC:29941",
      havana_gene : "OTTHUMG00000131201.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92468380,
      stop : 92477986,
      direction : "-",
      ID : "ENSG00000242950.7",
      gene_id : "ENSG00000242950.7",
      gene_type : "protein_coding",
      gene_name : "ERVW-1",
      gene_level : 2,
      hgnc_id : "HGNC:13525",
      havana_gene : "OTTHUMG00000131249.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92487020,
      stop : 92528520,
      direction : "-",
      ID : "ENSG00000127980.16",
      gene_id : "ENSG00000127980.16",
      gene_type : "protein_coding",
      gene_name : "PEX1",
      gene_level : 1,
      hgnc_id : "HGNC:8850",
      havana_gene : "OTTHUMG00000023926.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92528773,
      stop : 92540481,
      direction : "+",
      ID : "ENSG00000127993.16",
      gene_id : "ENSG00000127993.16",
      gene_type : "protein_coding",
      gene_name : "RBM48",
      gene_level : 1,
      hgnc_id : "HGNC:21785",
      havana_gene : "OTTHUMG00000159535.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92560758,
      stop : 92590393,
      direction : "-",
      ID : "ENSG00000234545.8",
      gene_id : "ENSG00000234545.8",
      gene_type : "protein_coding",
      gene_name : "FAM133B",
      gene_level : 2,
      hgnc_id : "HGNC:28629",
      havana_gene : "OTTHUMG00000155863.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 92604921,
      stop : 92836573,
      direction : "-",
      ID : "ENSG00000105810.10",
      gene_id : "ENSG00000105810.10",
      gene_type : "protein_coding",
      gene_name : "CDK6",
      gene_level : 2,
      hgnc_id : "HGNC:1777",
      havana_gene : "OTTHUMG00000131697.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93099513,
      stop : 93118023,
      direction : "-",
      ID : "ENSG00000205413.8",
      gene_id : "ENSG00000205413.8",
      gene_type : "protein_coding",
      gene_name : "SAMD9",
      gene_level : 2,
      hgnc_id : "HGNC:1348",
      havana_gene : "OTTHUMG00000155809.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93130056,
      stop : 93148385,
      direction : "-",
      ID : "ENSG00000177409.12",
      gene_id : "ENSG00000177409.12",
      gene_type : "protein_coding",
      gene_name : "SAMD9L",
      gene_level : 2,
      hgnc_id : "HGNC:1349",
      havana_gene : "OTTHUMG00000155807.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93188534,
      stop : 93226469,
      direction : "-",
      ID : "ENSG00000188175.10",
      gene_id : "ENSG00000188175.10",
      gene_type : "protein_coding",
      gene_name : "HEPACAM2",
      gene_level : 2,
      hgnc_id : "HGNC:27364",
      havana_gene : "OTTHUMG00000131732.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93232340,
      stop : 93361123,
      direction : "+",
      ID : "ENSG00000004766.17",
      gene_id : "ENSG00000004766.17",
      gene_type : "protein_coding",
      gene_name : "VPS50",
      gene_level : 2,
      hgnc_id : "HGNC:25956",
      havana_gene : "OTTHUMG00000131733.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93424486,
      stop : 93574730,
      direction : "-",
      ID : "ENSG00000004948.16",
      gene_id : "ENSG00000004948.16",
      gene_type : "protein_coding",
      gene_name : "CALCR",
      gene_level : 2,
      hgnc_id : "HGNC:1440",
      havana_gene : "OTTHUMG00000023599.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93591573,
      stop : 93911265,
      direction : "+",
      ID : "ENSG00000127928.13",
      gene_id : "ENSG00000127928.13",
      gene_type : "protein_coding",
      gene_name : "GNGT1",
      gene_level : 2,
      hgnc_id : "HGNC:4411",
      havana_gene : "OTTHUMG00000022908.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93885396,
      stop : 93890753,
      direction : "-",
      ID : "ENSG00000105825.14",
      gene_id : "ENSG00000105825.14",
      gene_type : "protein_coding",
      gene_name : "TFPI2",
      gene_level : 1,
      hgnc_id : "HGNC:11761",
      havana_gene : "OTTHUMG00000022963.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93921735,
      stop : 93928610,
      direction : "+",
      ID : "ENSG00000127920.6",
      gene_id : "ENSG00000127920.6",
      gene_type : "protein_coding",
      gene_name : "GNG11",
      gene_level : 2,
      hgnc_id : "HGNC:4403",
      havana_gene : "OTTHUMG00000023411.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 93962762,
      stop : 94004382,
      direction : "-",
      ID : "ENSG00000105829.13",
      gene_id : "ENSG00000105829.13",
      gene_type : "protein_coding",
      gene_name : "BET1",
      gene_level : 2,
      hgnc_id : "HGNC:14562",
      havana_gene : "OTTHUMG00000023487.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 94394895,
      stop : 94431227,
      direction : "+",
      ID : "ENSG00000164692.18",
      gene_id : "ENSG00000164692.18",
      gene_type : "protein_coding",
      gene_name : "COL1A2",
      gene_level : 2,
      hgnc_id : "HGNC:2198",
      havana_gene : "OTTHUMG00000148675.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 94509219,
      stop : 94557019,
      direction : "+",
      ID : "ENSG00000127995.17",
      gene_id : "ENSG00000127995.17",
      gene_type : "protein_coding",
      gene_name : "CASD1",
      gene_level : 2,
      hgnc_id : "HGNC:16014",
      havana_gene : "OTTHUMG00000023356.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 94524204,
      stop : 94656572,
      direction : "-",
      ID : "ENSG00000127990.19",
      gene_id : "ENSG00000127990.19",
      gene_type : "protein_coding",
      gene_name : "SGCE",
      gene_level : 2,
      hgnc_id : "HGNC:10808",
      havana_gene : "OTTHUMG00000022828.19",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 94656325,
      stop : 94669695,
      direction : "+",
      ID : "ENSG00000242265.6",
      gene_id : "ENSG00000242265.6",
      gene_type : "protein_coding",
      gene_name : "PEG10",
      gene_level : 2,
      hgnc_id : "HGNC:14005",
      havana_gene : "OTTHUMG00000155578.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 94907202,
      stop : 95296415,
      direction : "+",
      ID : "ENSG00000158528.12",
      gene_id : "ENSG00000158528.12",
      gene_type : "protein_coding",
      gene_name : "PPP1R9A",
      gene_level : 1,
      hgnc_id : "HGNC:14946",
      havana_gene : "OTTHUMG00000155566.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 95297676,
      stop : 95324532,
      direction : "-",
      ID : "ENSG00000005421.9",
      gene_id : "ENSG00000005421.9",
      gene_type : "protein_coding",
      gene_name : "PON1",
      gene_level : 2,
      hgnc_id : "HGNC:9204",
      havana_gene : "OTTHUMG00000153894.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 95359872,
      stop : 95396375,
      direction : "-",
      ID : "ENSG00000105852.11",
      gene_id : "ENSG00000105852.11",
      gene_type : "protein_coding",
      gene_name : "PON3",
      gene_level : 2,
      hgnc_id : "HGNC:9206",
      havana_gene : "OTTHUMG00000153917.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 95404862,
      stop : 95435329,
      direction : "-",
      ID : "ENSG00000105854.13",
      gene_id : "ENSG00000105854.13",
      gene_type : "protein_coding",
      gene_name : "PON2",
      gene_level : 2,
      hgnc_id : "HGNC:9205",
      havana_gene : "OTTHUMG00000153948.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 95478444,
      stop : 95540233,
      direction : "+",
      ID : "ENSG00000005981.13",
      gene_id : "ENSG00000005981.13",
      gene_type : "protein_coding",
      gene_name : "ASB4",
      gene_level : 2,
      hgnc_id : "HGNC:16009",
      havana_gene : "OTTHUMG00000153960.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 95583499,
      stop : 95596516,
      direction : "-",
      ID : "ENSG00000004799.8",
      gene_id : "ENSG00000004799.8",
      gene_type : "protein_coding",
      gene_name : "PDK4",
      gene_level : 2,
      hgnc_id : "HGNC:8812",
      havana_gene : "OTTHUMG00000153977.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 95772506,
      stop : 96110322,
      direction : "+",
      ID : "ENSG00000158560.14",
      gene_id : "ENSG00000158560.14",
      gene_type : "protein_coding",
      gene_name : "DYNC1I1",
      gene_level : 1,
      hgnc_id : "HGNC:2963",
      havana_gene : "OTTHUMG00000153983.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 96120220,
      stop : 96322147,
      direction : "-",
      ID : "ENSG00000004864.14",
      gene_id : "ENSG00000004864.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A13",
      gene_level : 2,
      hgnc_id : "HGNC:10983",
      havana_gene : "OTTHUMG00000023074.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 96481626,
      stop : 96709891,
      direction : "-",
      ID : "ENSG00000127922.9",
      gene_id : "ENSG00000127922.9",
      gene_type : "protein_coding",
      gene_name : "SEM1",
      gene_level : 2,
      hgnc_id : "HGNC:10845",
      havana_gene : "OTTHUMG00000150680.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 97005553,
      stop : 97011040,
      direction : "+",
      ID : "ENSG00000006377.11",
      gene_id : "ENSG00000006377.11",
      gene_type : "protein_coding",
      gene_name : "DLX6",
      gene_level : 2,
      hgnc_id : "HGNC:2919",
      havana_gene : "OTTHUMG00000154201.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 97020396,
      stop : 97024950,
      direction : "-",
      ID : "ENSG00000105880.7",
      gene_id : "ENSG00000105880.7",
      gene_type : "protein_coding",
      gene_name : "DLX5",
      gene_level : 2,
      hgnc_id : "HGNC:2918",
      havana_gene : "OTTHUMG00000154200.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 97117698,
      stop : 97181763,
      direction : "+",
      ID : "ENSG00000196636.8",
      gene_id : "ENSG00000196636.8",
      gene_type : "protein_coding",
      gene_name : "SDHAF3",
      gene_level : 1,
      hgnc_id : "HGNC:21752",
      havana_gene : "OTTHUMG00000154064.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 97732084,
      stop : 97740472,
      direction : "+",
      ID : "ENSG00000006128.12",
      gene_id : "ENSG00000006128.12",
      gene_type : "protein_coding",
      gene_name : "TAC1",
      gene_level : 2,
      hgnc_id : "HGNC:11517",
      havana_gene : "OTTHUMG00000154069.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 97851677,
      stop : 97872542,
      direction : "-",
      ID : "ENSG00000070669.17",
      gene_id : "ENSG00000070669.17",
      gene_type : "protein_coding",
      gene_name : "ASNS",
      gene_level : 1,
      hgnc_id : "HGNC:753",
      havana_gene : "OTTHUMG00000022892.14",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 97984684,
      stop : 97991169,
      direction : "-",
      ID : "ENSG00000135175.5",
      gene_id : "ENSG00000135175.5",
      gene_type : "protein_coding",
      gene_name : "OCM2",
      gene_level : 2,
      hgnc_id : "HGNC:34396",
      havana_gene : "OTTHUMG00000154162.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98106862,
      stop : 98209638,
      direction : "+",
      ID : "ENSG00000164715.6",
      gene_id : "ENSG00000164715.6",
      gene_type : "protein_coding",
      gene_name : "LMTK2",
      gene_level : 2,
      hgnc_id : "HGNC:17880",
      havana_gene : "OTTHUMG00000154256.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98211439,
      stop : 98215457,
      direction : "+",
      ID : "ENSG00000180535.4",
      gene_id : "ENSG00000180535.4",
      gene_type : "protein_coding",
      gene_name : "BHLHA15",
      gene_level : 2,
      hgnc_id : "HGNC:22265",
      havana_gene : "OTTHUMG00000154289.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98214624,
      stop : 98252232,
      direction : "-",
      ID : "ENSG00000205356.10",
      gene_id : "ENSG00000205356.10",
      gene_type : "protein_coding",
      gene_name : "TECPR1",
      gene_level : 2,
      hgnc_id : "HGNC:22214",
      havana_gene : "OTTHUMG00000154273.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98252379,
      stop : 98310441,
      direction : "+",
      ID : "ENSG00000164713.10",
      gene_id : "ENSG00000164713.10",
      gene_type : "protein_coding",
      gene_name : "BRI3",
      gene_level : 2,
      hgnc_id : "HGNC:1109",
      havana_gene : "OTTHUMG00000154275.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98291650,
      stop : 98401090,
      direction : "-",
      ID : "ENSG00000006453.14",
      gene_id : "ENSG00000006453.14",
      gene_type : "protein_coding",
      gene_name : "BAIAP2L1",
      gene_level : 2,
      hgnc_id : "HGNC:21649",
      havana_gene : "OTTHUMG00000165117.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98617285,
      stop : 98629869,
      direction : "+",
      ID : "ENSG00000106236.4",
      gene_id : "ENSG00000106236.4",
      gene_type : "protein_coding",
      gene_name : "NPTX2",
      gene_level : 2,
      hgnc_id : "HGNC:7953",
      havana_gene : "OTTHUMG00000154369.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98846488,
      stop : 98870771,
      direction : "-",
      ID : "ENSG00000166448.15",
      gene_id : "ENSG00000166448.15",
      gene_type : "protein_coding",
      gene_name : "TMEM130",
      gene_level : 1,
      hgnc_id : "HGNC:25429",
      havana_gene : "OTTHUMG00000154419.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 98877933,
      stop : 99050831,
      direction : "+",
      ID : "ENSG00000196367.14",
      gene_id : "ENSG00000196367.14",
      gene_type : "protein_coding",
      gene_name : "TRRAP",
      gene_level : 1,
      hgnc_id : "HGNC:12347",
      havana_gene : "OTTHUMG00000150403.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99027440,
      stop : 99144108,
      direction : "-",
      ID : "ENSG00000198742.10",
      gene_id : "ENSG00000198742.10",
      gene_type : "protein_coding",
      gene_name : "SMURF1",
      gene_level : 2,
      hgnc_id : "HGNC:16807",
      havana_gene : "OTTHUMG00000150272.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99173572,
      stop : 99250075,
      direction : "-",
      ID : "ENSG00000185467.8",
      gene_id : "ENSG00000185467.8",
      gene_type : "protein_coding",
      gene_name : "KPNA7",
      gene_level : 2,
      hgnc_id : "HGNC:21839",
      havana_gene : "OTTHUMG00000154412.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99325879,
      stop : 99394653,
      direction : "+",
      ID : "ENSG00000284292.1",
      gene_id : "ENSG00000284292.1",
      gene_type : "protein_coding",
      gene_name : "AC004922.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000154553.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99325898,
      stop : 99366262,
      direction : "+",
      ID : "ENSG00000241685.10",
      gene_id : "ENSG00000241685.10",
      gene_type : "protein_coding",
      gene_name : "ARPC1A",
      gene_level : 2,
      hgnc_id : "HGNC:703",
      havana_gene : "OTTHUMG00000192204.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99374249,
      stop : 99394816,
      direction : "+",
      ID : "ENSG00000130429.15",
      gene_id : "ENSG00000130429.15",
      gene_type : "protein_coding",
      gene_name : "ARPC1B",
      gene_level : 2,
      hgnc_id : "HGNC:704",
      havana_gene : "OTTHUMG00000154552.34",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99392048,
      stop : 99408597,
      direction : "-",
      ID : "ENSG00000106244.13",
      gene_id : "ENSG00000106244.13",
      gene_type : "protein_coding",
      gene_name : "PDAP1",
      gene_level : 2,
      hgnc_id : "HGNC:14634",
      havana_gene : "OTTHUMG00000154629.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99408641,
      stop : 99419616,
      direction : "+",
      ID : "ENSG00000106245.11",
      gene_id : "ENSG00000106245.11",
      gene_type : "protein_coding",
      gene_name : "BUD31",
      gene_level : 1,
      hgnc_id : "HGNC:29629",
      havana_gene : "OTTHUMG00000154602.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99416739,
      stop : 99466163,
      direction : "-",
      ID : "ENSG00000106246.18",
      gene_id : "ENSG00000106246.18",
      gene_type : "protein_coding",
      gene_name : "PTCD1",
      gene_level : 2,
      hgnc_id : "HGNC:22198",
      havana_gene : "OTTHUMG00000154600.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99419749,
      stop : 99466197,
      direction : "-",
      ID : "ENSG00000248919.7",
      gene_id : "ENSG00000248919.7",
      gene_type : "protein_coding",
      gene_name : "ATP5MF-PTCD1",
      gene_level : 1,
      hgnc_id : "HGNC:38844",
      havana_gene : "OTTHUMG00000160779.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99438922,
      stop : 99457373,
      direction : "+",
      ID : "ENSG00000160917.15",
      gene_id : "ENSG00000160917.15",
      gene_type : "protein_coding",
      gene_name : "CPSF4",
      gene_level : 1,
      hgnc_id : "HGNC:2327",
      havana_gene : "OTTHUMG00000154599.24",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99448475,
      stop : 99466186,
      direction : "-",
      ID : "ENSG00000241468.8",
      gene_id : "ENSG00000241468.8",
      gene_type : "protein_coding",
      gene_name : "ATP5MF",
      gene_level : 2,
      hgnc_id : "HGNC:848",
      havana_gene : "OTTHUMG00000154609.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99472890,
      stop : 99503650,
      direction : "+",
      ID : "ENSG00000198556.14",
      gene_id : "ENSG00000198556.14",
      gene_type : "protein_coding",
      gene_name : "ZNF789",
      gene_level : 1,
      hgnc_id : "HGNC:27801",
      havana_gene : "OTTHUMG00000154601.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99473877,
      stop : 99504857,
      direction : "-",
      ID : "ENSG00000160908.15",
      gene_id : "ENSG00000160908.15",
      gene_type : "protein_coding",
      gene_name : "ZNF394",
      gene_level : 1,
      hgnc_id : "HGNC:18832",
      havana_gene : "OTTHUMG00000154660.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99504662,
      stop : 99534700,
      direction : "+",
      ID : "ENSG00000196652.12",
      gene_id : "ENSG00000196652.12",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN5",
      gene_level : 2,
      hgnc_id : "HGNC:12867",
      havana_gene : "OTTHUMG00000156749.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99546300,
      stop : 99558536,
      direction : "-",
      ID : "ENSG00000221909.3",
      gene_id : "ENSG00000221909.3",
      gene_type : "protein_coding",
      gene_name : "FAM200A",
      gene_level : 2,
      hgnc_id : "HGNC:25401",
      havana_gene : "OTTHUMG00000156723.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99558406,
      stop : 99576453,
      direction : "+",
      ID : "ENSG00000197343.11",
      gene_id : "ENSG00000197343.11",
      gene_type : "protein_coding",
      gene_name : "ZNF655",
      gene_level : 1,
      hgnc_id : "HGNC:30899",
      havana_gene : "OTTHUMG00000185968.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99558695,
      stop : 99607810,
      direction : "+",
      ID : "ENSG00000272647.3",
      gene_id : "ENSG00000272647.3",
      gene_type : "protein_coding",
      gene_name : "AC005020.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191587.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99598267,
      stop : 99611045,
      direction : "+",
      ID : "ENSG00000244219.7",
      gene_id : "ENSG00000244219.7",
      gene_type : "protein_coding",
      gene_name : "TMEM225B",
      gene_level : 2,
      hgnc_id : "HGNC:53075",
      havana_gene : "OTTHUMG00000156636.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99616946,
      stop : 99632408,
      direction : "+",
      ID : "ENSG00000197037.11",
      gene_id : "ENSG00000197037.11",
      gene_type : "protein_coding",
      gene_name : "ZSCAN25",
      gene_level : 2,
      hgnc_id : "HGNC:21961",
      havana_gene : "OTTHUMG00000074055.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99648194,
      stop : 99679998,
      direction : "-",
      ID : "ENSG00000106258.15",
      gene_id : "ENSG00000106258.15",
      gene_type : "protein_coding",
      gene_name : "CYP3A5",
      gene_level : 2,
      hgnc_id : "HGNC:2638",
      havana_gene : "OTTHUMG00000156724.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99684957,
      stop : 99735102,
      direction : "-",
      ID : "ENSG00000282301.4",
      gene_id : "ENSG00000282301.4",
      gene_type : "protein_coding",
      gene_name : "CYP3A7-CYP3A51P",
      gene_level : 2,
      hgnc_id : "HGNC:51504",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99705036,
      stop : 99735196,
      direction : "-",
      ID : "ENSG00000160870.15",
      gene_id : "ENSG00000160870.15",
      gene_type : "protein_coding",
      gene_name : "CYP3A7",
      gene_level : 2,
      hgnc_id : "HGNC:2640",
      havana_gene : "OTTHUMG00000156726.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99756960,
      stop : 99784248,
      direction : "-",
      ID : "ENSG00000160868.15",
      gene_id : "ENSG00000160868.15",
      gene_type : "protein_coding",
      gene_name : "CYP3A4",
      gene_level : 1,
      hgnc_id : "HGNC:2637",
      havana_gene : "OTTHUMG00000156651.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99828013,
      stop : 99866102,
      direction : "+",
      ID : "ENSG00000021461.17",
      gene_id : "ENSG00000021461.17",
      gene_type : "protein_coding",
      gene_name : "CYP3A43",
      gene_level : 2,
      hgnc_id : "HGNC:17450",
      havana_gene : "OTTHUMG00000156498.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99875987,
      stop : 99877057,
      direction : "-",
      ID : "ENSG00000244623.1",
      gene_id : "ENSG00000244623.1",
      gene_type : "protein_coding",
      gene_name : "OR2AE1",
      gene_level : 2,
      hgnc_id : "HGNC:15087",
      havana_gene : "OTTHUMG00000156650.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99876958,
      stop : 99919531,
      direction : "-",
      ID : "ENSG00000146833.16",
      gene_id : "ENSG00000146833.16",
      gene_type : "protein_coding",
      gene_name : "TRIM4",
      gene_level : 1,
      hgnc_id : "HGNC:16275",
      havana_gene : "OTTHUMG00000156648.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99923266,
      stop : 99929620,
      direction : "-",
      ID : "ENSG00000176402.6",
      gene_id : "ENSG00000176402.6",
      gene_type : "protein_coding",
      gene_name : "GJC3",
      gene_level : 2,
      hgnc_id : "HGNC:17495",
      havana_gene : "OTTHUMG00000156649.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 99966720,
      stop : 99976042,
      direction : "-",
      ID : "ENSG00000160862.13",
      gene_id : "ENSG00000160862.13",
      gene_type : "protein_coding",
      gene_name : "AZGP1",
      gene_level : 2,
      hgnc_id : "HGNC:910",
      havana_gene : "OTTHUMG00000023066.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100015572,
      stop : 100041689,
      direction : "+",
      ID : "ENSG00000106261.17",
      gene_id : "ENSG00000106261.17",
      gene_type : "protein_coding",
      gene_name : "ZKSCAN1",
      gene_level : 2,
      hgnc_id : "HGNC:13101",
      havana_gene : "OTTHUMG00000156534.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100049774,
      stop : 100065040,
      direction : "+",
      ID : "ENSG00000166529.15",
      gene_id : "ENSG00000166529.15",
      gene_type : "protein_coding",
      gene_name : "ZSCAN21",
      gene_level : 2,
      hgnc_id : "HGNC:13104",
      havana_gene : "OTTHUMG00000154583.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100064033,
      stop : 100082548,
      direction : "-",
      ID : "ENSG00000166526.18",
      gene_id : "ENSG00000166526.18",
      gene_type : "protein_coding",
      gene_name : "ZNF3",
      gene_level : 1,
      hgnc_id : "HGNC:13089",
      havana_gene : "OTTHUMG00000154596.77",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100088969,
      stop : 100092187,
      direction : "+",
      ID : "ENSG00000168090.10",
      gene_id : "ENSG00000168090.10",
      gene_type : "protein_coding",
      gene_name : "COPS6",
      gene_level : 2,
      hgnc_id : "HGNC:21749",
      havana_gene : "OTTHUMG00000154632.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100092728,
      stop : 100101940,
      direction : "-",
      ID : "ENSG00000166508.18",
      gene_id : "ENSG00000166508.18",
      gene_type : "protein_coding",
      gene_name : "MCM7",
      gene_level : 2,
      hgnc_id : "HGNC:6950",
      havana_gene : "OTTHUMG00000154671.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100101549,
      stop : 100110345,
      direction : "+",
      ID : "ENSG00000221838.10",
      gene_id : "ENSG00000221838.10",
      gene_type : "protein_coding",
      gene_name : "AP4M1",
      gene_level : 1,
      hgnc_id : "HGNC:574",
      havana_gene : "OTTHUMG00000154722.108",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100107070,
      stop : 100119841,
      direction : "-",
      ID : "ENSG00000106290.15",
      gene_id : "ENSG00000106290.15",
      gene_type : "protein_coding",
      gene_name : "TAF6",
      gene_level : 1,
      hgnc_id : "HGNC:11540",
      havana_gene : "OTTHUMG00000154771.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100119634,
      stop : 100125508,
      direction : "+",
      ID : "ENSG00000166997.8",
      gene_id : "ENSG00000166997.8",
      gene_type : "protein_coding",
      gene_name : "CNPY4",
      gene_level : 2,
      hgnc_id : "HGNC:28631",
      havana_gene : "OTTHUMG00000154817.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100126785,
      stop : 100128495,
      direction : "+",
      ID : "ENSG00000214309.5",
      gene_id : "ENSG00000214309.5",
      gene_type : "protein_coding",
      gene_name : "MBLAC1",
      gene_level : 2,
      hgnc_id : "HGNC:22180",
      havana_gene : "OTTHUMG00000154846.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100148907,
      stop : 100155944,
      direction : "+",
      ID : "ENSG00000188186.10",
      gene_id : "ENSG00000188186.10",
      gene_type : "protein_coding",
      gene_name : "LAMTOR4",
      gene_level : 2,
      hgnc_id : "HGNC:33772",
      havana_gene : "OTTHUMG00000154854.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100154420,
      stop : 100158723,
      direction : "-",
      ID : "ENSG00000146826.17",
      gene_id : "ENSG00000146826.17",
      gene_type : "protein_coding",
      gene_name : "MAP11",
      gene_level : 2,
      hgnc_id : "HGNC:25604",
      havana_gene : "OTTHUMG00000154862.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100159244,
      stop : 100168617,
      direction : "-",
      ID : "ENSG00000197093.11",
      gene_id : "ENSG00000197093.11",
      gene_type : "protein_coding",
      gene_name : "GAL3ST4",
      gene_level : 2,
      hgnc_id : "HGNC:24145",
      havana_gene : "OTTHUMG00000154885.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100169606,
      stop : 100177381,
      direction : "-",
      ID : "ENSG00000213420.8",
      gene_id : "ENSG00000213420.8",
      gene_type : "protein_coding",
      gene_name : "GPC2",
      gene_level : 2,
      hgnc_id : "HGNC:4450",
      havana_gene : "OTTHUMG00000154894.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100177563,
      stop : 100221488,
      direction : "+",
      ID : "ENSG00000066923.18",
      gene_id : "ENSG00000066923.18",
      gene_type : "protein_coding",
      gene_name : "STAG3",
      gene_level : 2,
      hgnc_id : "HGNC:11356",
      havana_gene : "OTTHUMG00000155183.16",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100218241,
      stop : 100221490,
      direction : "+",
      ID : "ENSG00000213413.2",
      gene_id : "ENSG00000213413.2",
      gene_type : "protein_coding",
      gene_name : "PVRIG",
      gene_level : 2,
      hgnc_id : "HGNC:32190",
      havana_gene : "OTTHUMG00000156798.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100307702,
      stop : 100322196,
      direction : "+",
      ID : "ENSG00000214300.7",
      gene_id : "ENSG00000214300.7",
      gene_type : "protein_coding",
      gene_name : "SPDYE3",
      gene_level : 2,
      hgnc_id : "HGNC:35462",
      havana_gene : "OTTHUMG00000155462.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100352176,
      stop : 100367733,
      direction : "+",
      ID : "ENSG00000121716.20",
      gene_id : "ENSG00000121716.20",
      gene_type : "protein_coding",
      gene_name : "PILRB",
      gene_level : 2,
      hgnc_id : "HGNC:18297",
      havana_gene : "OTTHUMG00000155363.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100367530,
      stop : 100400096,
      direction : "+",
      ID : "ENSG00000085514.16",
      gene_id : "ENSG00000085514.16",
      gene_type : "protein_coding",
      gene_name : "PILRA",
      gene_level : 2,
      hgnc_id : "HGNC:20396",
      havana_gene : "OTTHUMG00000155248.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100400826,
      stop : 100428992,
      direction : "-",
      ID : "ENSG00000078487.17",
      gene_id : "ENSG00000078487.17",
      gene_type : "protein_coding",
      gene_name : "ZCWPW1",
      gene_level : 1,
      hgnc_id : "HGNC:23486",
      havana_gene : "OTTHUMG00000159537.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100428790,
      stop : 100434118,
      direction : "+",
      ID : "ENSG00000146834.14",
      gene_id : "ENSG00000146834.14",
      gene_type : "protein_coding",
      gene_name : "MEPCE",
      gene_level : 1,
      hgnc_id : "HGNC:20247",
      havana_gene : "OTTHUMG00000155255.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100435282,
      stop : 100436497,
      direction : "-",
      ID : "ENSG00000160813.7",
      gene_id : "ENSG00000160813.7",
      gene_type : "protein_coding",
      gene_name : "PPP1R35",
      gene_level : 2,
      hgnc_id : "HGNC:28320",
      havana_gene : "OTTHUMG00000159540.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100456620,
      stop : 100464260,
      direction : "-",
      ID : "ENSG00000185955.5",
      gene_id : "ENSG00000185955.5",
      gene_type : "protein_coding",
      gene_name : "C7orf61",
      gene_level : 2,
      hgnc_id : "HGNC:22135",
      havana_gene : "OTTHUMG00000150234.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100463359,
      stop : 100479232,
      direction : "-",
      ID : "ENSG00000166925.9",
      gene_id : "ENSG00000166925.9",
      gene_type : "protein_coding",
      gene_name : "TSC22D4",
      gene_level : 1,
      hgnc_id : "HGNC:21696",
      havana_gene : "OTTHUMG00000150233.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100483927,
      stop : 100494802,
      direction : "+",
      ID : "ENSG00000166924.9",
      gene_id : "ENSG00000166924.9",
      gene_type : "protein_coding",
      gene_name : "NYAP1",
      gene_level : 2,
      hgnc_id : "HGNC:22009",
      havana_gene : "OTTHUMG00000155290.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100539203,
      stop : 100568220,
      direction : "+",
      ID : "ENSG00000106351.13",
      gene_id : "ENSG00000106351.13",
      gene_type : "protein_coding",
      gene_name : "AGFG2",
      gene_level : 2,
      hgnc_id : "HGNC:5177",
      havana_gene : "OTTHUMG00000156029.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100572228,
      stop : 100573900,
      direction : "-",
      ID : "ENSG00000205307.12",
      gene_id : "ENSG00000205307.12",
      gene_type : "protein_coding",
      gene_name : "SAP25",
      gene_level : 2,
      hgnc_id : "HGNC:41908",
      havana_gene : "OTTHUMG00000187472.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100574011,
      stop : 100586129,
      direction : "-",
      ID : "ENSG00000077454.16",
      gene_id : "ENSG00000077454.16",
      gene_type : "protein_coding",
      gene_name : "LRCH4",
      gene_level : 1,
      hgnc_id : "HGNC:6691",
      havana_gene : "OTTHUMG00000159544.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100583982,
      stop : 100601117,
      direction : "+",
      ID : "ENSG00000106336.13",
      gene_id : "ENSG00000106336.13",
      gene_type : "protein_coding",
      gene_name : "FBXO24",
      gene_level : 1,
      hgnc_id : "HGNC:13595",
      havana_gene : "OTTHUMG00000159543.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100602363,
      stop : 100608175,
      direction : "+",
      ID : "ENSG00000106333.13",
      gene_id : "ENSG00000106333.13",
      gene_type : "protein_coding",
      gene_name : "PCOLCE",
      gene_level : 2,
      hgnc_id : "HGNC:8738",
      havana_gene : "OTTHUMG00000156675.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100612102,
      stop : 100615384,
      direction : "+",
      ID : "ENSG00000106330.12",
      gene_id : "ENSG00000106330.12",
      gene_type : "protein_coding",
      gene_name : "MOSPD3",
      gene_level : 2,
      hgnc_id : "HGNC:25078",
      havana_gene : "OTTHUMG00000159599.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100620416,
      stop : 100642779,
      direction : "-",
      ID : "ENSG00000106327.13",
      gene_id : "ENSG00000106327.13",
      gene_type : "protein_coding",
      gene_name : "TFR2",
      gene_level : 2,
      hgnc_id : "HGNC:11762",
      havana_gene : "OTTHUMG00000159598.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100643097,
      stop : 100656448,
      direction : "-",
      ID : "ENSG00000077080.10",
      gene_id : "ENSG00000077080.10",
      gene_type : "protein_coding",
      gene_name : "ACTL6B",
      gene_level : 1,
      hgnc_id : "HGNC:160",
      havana_gene : "OTTHUMG00000159661.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100673567,
      stop : 100679174,
      direction : "+",
      ID : "ENSG00000172354.10",
      gene_id : "ENSG00000172354.10",
      gene_type : "protein_coding",
      gene_name : "GNB2",
      gene_level : 2,
      hgnc_id : "HGNC:4398",
      havana_gene : "OTTHUMG00000137419.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100679507,
      stop : 100694250,
      direction : "-",
      ID : "ENSG00000146830.11",
      gene_id : "ENSG00000146830.11",
      gene_type : "protein_coding",
      gene_name : "GIGYF1",
      gene_level : 2,
      hgnc_id : "HGNC:9126",
      havana_gene : "OTTHUMG00000157036.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100706121,
      stop : 100707486,
      direction : "+",
      ID : "ENSG00000172336.5",
      gene_id : "ENSG00000172336.5",
      gene_type : "protein_coding",
      gene_name : "POP7",
      gene_level : 2,
      hgnc_id : "HGNC:19949",
      havana_gene : "OTTHUMG00000044311.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100720468,
      stop : 100723700,
      direction : "+",
      ID : "ENSG00000130427.3",
      gene_id : "ENSG00000130427.3",
      gene_type : "protein_coding",
      gene_name : "EPO",
      gene_level : 2,
      hgnc_id : "HGNC:3415",
      havana_gene : "OTTHUMG00000152121.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100733595,
      stop : 100797797,
      direction : "+",
      ID : "ENSG00000146839.19",
      gene_id : "ENSG00000146839.19",
      gene_type : "protein_coding",
      gene_name : "ZAN",
      gene_level : 2,
      hgnc_id : "HGNC:12857",
      havana_gene : "OTTHUMG00000157037.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100802565,
      stop : 100827523,
      direction : "-",
      ID : "ENSG00000196411.10",
      gene_id : "ENSG00000196411.10",
      gene_type : "protein_coding",
      gene_name : "EPHB4",
      gene_level : 2,
      hgnc_id : "HGNC:3395",
      havana_gene : "OTTHUMG00000157040.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100826820,
      stop : 100867010,
      direction : "+",
      ID : "ENSG00000146828.18",
      gene_id : "ENSG00000146828.18",
      gene_type : "protein_coding",
      gene_name : "SLC12A9",
      gene_level : 1,
      hgnc_id : "HGNC:17435",
      havana_gene : "OTTHUMG00000156045.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100867387,
      stop : 100873454,
      direction : "+",
      ID : "ENSG00000087077.14",
      gene_id : "ENSG00000087077.14",
      gene_type : "protein_coding",
      gene_name : "TRIP6",
      gene_level : 2,
      hgnc_id : "HGNC:12311",
      havana_gene : "OTTHUMG00000157029.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100875103,
      stop : 100888664,
      direction : "+",
      ID : "ENSG00000087087.20",
      gene_id : "ENSG00000087087.20",
      gene_type : "protein_coding",
      gene_name : "SRRT",
      gene_level : 1,
      hgnc_id : "HGNC:24101",
      havana_gene : "OTTHUMG00000157031.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100888721,
      stop : 100889715,
      direction : "-",
      ID : "ENSG00000176125.7",
      gene_id : "ENSG00000176125.7",
      gene_type : "protein_coding",
      gene_name : "UFSP1",
      gene_level : 2,
      hgnc_id : "HGNC:33821",
      havana_gene : "OTTHUMG00000159662.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100889994,
      stop : 100896974,
      direction : "-",
      ID : "ENSG00000087085.16",
      gene_id : "ENSG00000087085.16",
      gene_type : "protein_coding",
      gene_name : "ACHE",
      gene_level : 2,
      hgnc_id : "HGNC:108",
      havana_gene : "OTTHUMG00000157033.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100949534,
      stop : 100968347,
      direction : "+",
      ID : "ENSG00000169894.18",
      gene_id : "ENSG00000169894.18",
      gene_type : "protein_coding",
      gene_name : "MUC3A",
      gene_level : 2,
      hgnc_id : "HGNC:7513",
      havana_gene : "OTTHUMG00000157038.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 100969623,
      stop : 101018949,
      direction : "+",
      ID : "ENSG00000205277.9",
      gene_id : "ENSG00000205277.9",
      gene_type : "protein_coding",
      gene_name : "MUC12",
      gene_level : 2,
      hgnc_id : "HGNC:7510",
      havana_gene : "OTTHUMG00000157042.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101020072,
      stop : 101058859,
      direction : "+",
      ID : "ENSG00000169876.14",
      gene_id : "ENSG00000169876.14",
      gene_type : "protein_coding",
      gene_name : "MUC17",
      gene_level : 2,
      hgnc_id : "HGNC:16800",
      havana_gene : "OTTHUMG00000157030.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101085481,
      stop : 101097967,
      direction : "+",
      ID : "ENSG00000169871.13",
      gene_id : "ENSG00000169871.13",
      gene_type : "protein_coding",
      gene_name : "TRIM56",
      gene_level : 2,
      hgnc_id : "HGNC:19028",
      havana_gene : "OTTHUMG00000157032.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101127104,
      stop : 101139247,
      direction : "+",
      ID : "ENSG00000106366.9",
      gene_id : "ENSG00000106366.9",
      gene_type : "protein_coding",
      gene_name : "SERPINE1",
      gene_level : 1,
      hgnc_id : "HGNC:8583",
      havana_gene : "OTTHUMG00000157107.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101154456,
      stop : 101161596,
      direction : "+",
      ID : "ENSG00000106367.15",
      gene_id : "ENSG00000106367.15",
      gene_type : "protein_coding",
      gene_name : "AP1S1",
      gene_level : 1,
      hgnc_id : "HGNC:559",
      havana_gene : "OTTHUMG00000157103.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101162509,
      stop : 101165569,
      direction : "-",
      ID : "ENSG00000128564.7",
      gene_id : "ENSG00000128564.7",
      gene_type : "protein_coding",
      gene_name : "VGF",
      gene_level : 2,
      hgnc_id : "HGNC:12684",
      havana_gene : "OTTHUMG00000157109.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101170496,
      stop : 101180293,
      direction : "-",
      ID : "ENSG00000167011.9",
      gene_id : "ENSG00000167011.9",
      gene_type : "protein_coding",
      gene_name : "NAT16",
      gene_level : 2,
      hgnc_id : "HGNC:22030",
      havana_gene : "OTTHUMG00000157110.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101195007,
      stop : 101201038,
      direction : "-",
      ID : "ENSG00000106384.12",
      gene_id : "ENSG00000106384.12",
      gene_type : "protein_coding",
      gene_name : "MOGAT3",
      gene_level : 2,
      hgnc_id : "HGNC:23249",
      havana_gene : "OTTHUMG00000023328.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101205977,
      stop : 101218420,
      direction : "-",
      ID : "ENSG00000106397.12",
      gene_id : "ENSG00000106397.12",
      gene_type : "protein_coding",
      gene_name : "PLOD3",
      gene_level : 2,
      hgnc_id : "HGNC:9083",
      havana_gene : "OTTHUMG00000157111.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101218165,
      stop : 101224190,
      direction : "+",
      ID : "ENSG00000106400.12",
      gene_id : "ENSG00000106400.12",
      gene_type : "protein_coding",
      gene_name : "ZNHIT1",
      gene_level : 2,
      hgnc_id : "HGNC:21688",
      havana_gene : "OTTHUMG00000157113.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101232092,
      stop : 101238820,
      direction : "-",
      ID : "ENSG00000106404.14",
      gene_id : "ENSG00000106404.14",
      gene_type : "protein_coding",
      gene_name : "CLDN15",
      gene_level : 1,
      hgnc_id : "HGNC:2036",
      havana_gene : "OTTHUMG00000150512.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101239458,
      stop : 101252316,
      direction : "-",
      ID : "ENSG00000214253.9",
      gene_id : "ENSG00000214253.9",
      gene_type : "protein_coding",
      gene_name : "FIS1",
      gene_level : 1,
      hgnc_id : "HGNC:21689",
      havana_gene : "OTTHUMG00000157106.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101310914,
      stop : 101321823,
      direction : "-",
      ID : "ENSG00000128581.17",
      gene_id : "ENSG00000128581.17",
      gene_type : "protein_coding",
      gene_name : "IFT22",
      gene_level : 2,
      hgnc_id : "HGNC:21895",
      havana_gene : "OTTHUMG00000157136.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101362875,
      stop : 101559024,
      direction : "+",
      ID : "ENSG00000160963.14",
      gene_id : "ENSG00000160963.14",
      gene_type : "protein_coding",
      gene_name : "COL26A1",
      gene_level : 2,
      hgnc_id : "HGNC:18038",
      havana_gene : "OTTHUMG00000150033.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101613330,
      stop : 101629296,
      direction : "-",
      ID : "ENSG00000106436.7",
      gene_id : "ENSG00000106436.7",
      gene_type : "protein_coding",
      gene_name : "MYL10",
      gene_level : 2,
      hgnc_id : "HGNC:29825",
      havana_gene : "OTTHUMG00000157137.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 101815904,
      stop : 102283958,
      direction : "+",
      ID : "ENSG00000257923.12",
      gene_id : "ENSG00000257923.12",
      gene_type : "protein_coding",
      gene_name : "CUX1",
      gene_level : 1,
      hgnc_id : "HGNC:2557",
      havana_gene : "OTTHUMG00000157129.14",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102285091,
      stop : 102321711,
      direction : "+",
      ID : "ENSG00000160999.10",
      gene_id : "ENSG00000160999.10",
      gene_type : "protein_coding",
      gene_name : "SH2B2",
      gene_level : 2,
      hgnc_id : "HGNC:17381",
      havana_gene : "OTTHUMG00000150652.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102345746,
      stop : 102356444,
      direction : "-",
      ID : "ENSG00000260097.3",
      gene_id : "ENSG00000260097.3",
      gene_type : "protein_coding",
      gene_name : "SPDYE6",
      gene_level : 2,
      hgnc_id : "HGNC:35465",
      havana_gene : "OTTHUMG00000157126.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102363872,
      stop : 102426676,
      direction : "+",
      ID : "ENSG00000128563.13",
      gene_id : "ENSG00000128563.13",
      gene_type : "protein_coding",
      gene_name : "PRKRIP1",
      gene_level : 1,
      hgnc_id : "HGNC:21894",
      havana_gene : "OTTHUMG00000157717.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102433106,
      stop : 102456825,
      direction : "+",
      ID : "ENSG00000160991.16",
      gene_id : "ENSG00000160991.16",
      gene_type : "protein_coding",
      gene_name : "ORAI2",
      gene_level : 2,
      hgnc_id : "HGNC:21667",
      havana_gene : "OTTHUMG00000157722.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102456238,
      stop : 102464863,
      direction : "-",
      ID : "ENSG00000160993.4",
      gene_id : "ENSG00000160993.4",
      gene_type : "protein_coding",
      gene_name : "ALKBH4",
      gene_level : 2,
      hgnc_id : "HGNC:21900",
      havana_gene : "OTTHUMG00000157720.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102464956,
      stop : 102473168,
      direction : "+",
      ID : "ENSG00000161036.13",
      gene_id : "ENSG00000161036.13",
      gene_type : "protein_coding",
      gene_name : "LRWD1",
      gene_level : 2,
      hgnc_id : "HGNC:21769",
      havana_gene : "OTTHUMG00000157718.17",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102473118,
      stop : 102478907,
      direction : "-",
      ID : "ENSG00000005075.15",
      gene_id : "ENSG00000005075.15",
      gene_type : "protein_coding",
      gene_name : "POLR2J",
      gene_level : 2,
      hgnc_id : "HGNC:9197",
      havana_gene : "OTTHUMG00000150387.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102479976,
      stop : 102517777,
      direction : "-",
      ID : "ENSG00000170667.15",
      gene_id : "ENSG00000170667.15",
      gene_type : "protein_coding",
      gene_name : "RASA4B",
      gene_level : 2,
      hgnc_id : "HGNC:35202",
      havana_gene : "OTTHUMG00000022944.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102537918,
      stop : 102572653,
      direction : "-",
      ID : "ENSG00000168255.20",
      gene_id : "ENSG00000168255.20",
      gene_type : "protein_coding",
      gene_name : "POLR2J3",
      gene_level : 2,
      hgnc_id : "HGNC:33853",
      havana_gene : "OTTHUMG00000150384.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102538417,
      stop : 102543849,
      direction : "-",
      ID : "ENSG00000284981.1",
      gene_id : "ENSG00000284981.1",
      gene_type : "protein_coding",
      gene_name : "UPK3BL2",
      gene_level : 2,
      hgnc_id : "HGNC:53444",
      havana_gene : "OTTHUMG00000192388.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102541501,
      stop : 102592444,
      direction : "-",
      ID : "ENSG00000270249.2",
      gene_id : "ENSG00000270249.2",
      gene_type : "protein_coding",
      gene_name : "AC093668.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000185154.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102551232,
      stop : 102562308,
      direction : "+",
      ID : "ENSG00000205238.9",
      gene_id : "ENSG00000205238.9",
      gene_type : "protein_coding",
      gene_name : "SPDYE2",
      gene_level : 2,
      hgnc_id : "HGNC:33841",
      havana_gene : "OTTHUMG00000150385.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102562133,
      stop : 102572583,
      direction : "-",
      ID : "ENSG00000285437.1",
      gene_id : "ENSG00000285437.1",
      gene_type : "protein_coding",
      gene_name : "POLR2J3",
      gene_level : 2,
      hgnc_id : "HGNC:33853",
      havana_gene : "OTTHUMG00000192387.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102573807,
      stop : 102616756,
      direction : "-",
      ID : "ENSG00000105808.18",
      gene_id : "ENSG00000105808.18",
      gene_type : "protein_coding",
      gene_name : "RASA4",
      gene_level : 2,
      hgnc_id : "HGNC:23181",
      havana_gene : "OTTHUMG00000150383.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102582523,
      stop : 102642869,
      direction : "-",
      ID : "ENSG00000205236.6",
      gene_id : "ENSG00000205236.6",
      gene_type : "protein_coding",
      gene_name : "AC105052.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180800.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102637025,
      stop : 102642791,
      direction : "-",
      ID : "ENSG00000267368.1",
      gene_id : "ENSG00000267368.1",
      gene_type : "protein_coding",
      gene_name : "UPK3BL1",
      gene_level : 2,
      hgnc_id : "HGNC:37278",
      havana_gene : "OTTHUMG00000165036.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102637049,
      stop : 102671641,
      direction : "-",
      ID : "ENSG00000267645.5",
      gene_id : "ENSG00000267645.5",
      gene_type : "protein_coding",
      gene_name : "AC105052.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000180801.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102650325,
      stop : 102661398,
      direction : "+",
      ID : "ENSG00000173678.14",
      gene_id : "ENSG00000173678.14",
      gene_type : "protein_coding",
      gene_name : "SPDYE2B",
      gene_level : 2,
      hgnc_id : "HGNC:48334",
      havana_gene : "OTTHUMG00000158393.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102665368,
      stop : 102671629,
      direction : "-",
      ID : "ENSG00000228049.7",
      gene_id : "ENSG00000228049.7",
      gene_type : "protein_coding",
      gene_name : "POLR2J2",
      gene_level : 2,
      hgnc_id : "HGNC:23208",
      havana_gene : "OTTHUMG00000150388.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102748971,
      stop : 102809225,
      direction : "+",
      ID : "ENSG00000222011.9",
      gene_id : "ENSG00000222011.9",
      gene_type : "protein_coding",
      gene_name : "FAM185A",
      gene_level : 2,
      hgnc_id : "HGNC:22412",
      havana_gene : "OTTHUMG00000154140.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102813230,
      stop : 103074843,
      direction : "-",
      ID : "ENSG00000161040.16",
      gene_id : "ENSG00000161040.16",
      gene_type : "protein_coding",
      gene_name : "FBXL13",
      gene_level : 1,
      hgnc_id : "HGNC:21658",
      havana_gene : "OTTHUMG00000157224.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 102913000,
      stop : 102945111,
      direction : "+",
      ID : "ENSG00000128606.13",
      gene_id : "ENSG00000128606.13",
      gene_type : "protein_coding",
      gene_name : "LRRC17",
      gene_level : 1,
      hgnc_id : "HGNC:16895",
      havana_gene : "OTTHUMG00000157210.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103074881,
      stop : 103099759,
      direction : "+",
      ID : "ENSG00000170632.14",
      gene_id : "ENSG00000170632.14",
      gene_type : "protein_coding",
      gene_name : "ARMC10",
      gene_level : 2,
      hgnc_id : "HGNC:21706",
      havana_gene : "OTTHUMG00000157201.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103099776,
      stop : 103149560,
      direction : "-",
      ID : "ENSG00000161048.12",
      gene_id : "ENSG00000161048.12",
      gene_type : "protein_coding",
      gene_name : "NAPEPLD",
      gene_level : 2,
      hgnc_id : "HGNC:21683",
      havana_gene : "OTTHUMG00000157204.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103297435,
      stop : 103329511,
      direction : "+",
      ID : "ENSG00000105819.14",
      gene_id : "ENSG00000105819.14",
      gene_type : "protein_coding",
      gene_name : "PMPCB",
      gene_level : 2,
      hgnc_id : "HGNC:9119",
      havana_gene : "OTTHUMG00000157205.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103312289,
      stop : 103344830,
      direction : "-",
      ID : "ENSG00000105821.15",
      gene_id : "ENSG00000105821.15",
      gene_type : "protein_coding",
      gene_name : "DNAJC2",
      gene_level : 2,
      hgnc_id : "HGNC:13192",
      havana_gene : "OTTHUMG00000157202.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103328570,
      stop : 103370346,
      direction : "+",
      ID : "ENSG00000161057.13",
      gene_id : "ENSG00000161057.13",
      gene_type : "protein_coding",
      gene_name : "PSMC2",
      gene_level : 2,
      hgnc_id : "HGNC:9548",
      havana_gene : "OTTHUMG00000157206.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103352730,
      stop : 103446207,
      direction : "-",
      ID : "ENSG00000170615.15",
      gene_id : "ENSG00000170615.15",
      gene_type : "protein_coding",
      gene_name : "SLC26A5",
      gene_level : 1,
      hgnc_id : "HGNC:9359",
      havana_gene : "OTTHUMG00000149911.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 103471381,
      stop : 103989658,
      direction : "-",
      ID : "ENSG00000189056.15",
      gene_id : "ENSG00000189056.15",
      gene_type : "protein_coding",
      gene_name : "RELN",
      gene_level : 2,
      hgnc_id : "HGNC:9957",
      havana_gene : "OTTHUMG00000157247.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 104126341,
      stop : 104208047,
      direction : "-",
      ID : "ENSG00000164815.11",
      gene_id : "ENSG00000164815.11",
      gene_type : "protein_coding",
      gene_name : "ORC5",
      gene_level : 2,
      hgnc_id : "HGNC:8491",
      havana_gene : "OTTHUMG00000157275.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 104328700,
      stop : 104907232,
      direction : "+",
      ID : "ENSG00000187416.12",
      gene_id : "ENSG00000187416.12",
      gene_type : "protein_coding",
      gene_name : "LHFPL3",
      gene_level : 2,
      hgnc_id : "HGNC:6589",
      havana_gene : "OTTHUMG00000157273.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105014190,
      stop : 105115019,
      direction : "+",
      ID : "ENSG00000005483.21",
      gene_id : "ENSG00000005483.21",
      gene_type : "protein_coding",
      gene_name : "KMT2E",
      gene_level : 2,
      hgnc_id : "HGNC:18541",
      havana_gene : "OTTHUMG00000157403.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105110704,
      stop : 105399308,
      direction : "-",
      ID : "ENSG00000135250.17",
      gene_id : "ENSG00000135250.17",
      gene_type : "protein_coding",
      gene_name : "SRPK2",
      gene_level : 2,
      hgnc_id : "HGNC:11306",
      havana_gene : "OTTHUMG00000157405.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105439661,
      stop : 105522271,
      direction : "-",
      ID : "ENSG00000091127.14",
      gene_id : "ENSG00000091127.14",
      gene_type : "protein_coding",
      gene_name : "PUS7",
      gene_level : 2,
      hgnc_id : "HGNC:26033",
      havana_gene : "OTTHUMG00000157399.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105532169,
      stop : 105567677,
      direction : "+",
      ID : "ENSG00000135249.8",
      gene_id : "ENSG00000135249.8",
      gene_type : "protein_coding",
      gene_name : "RINT1",
      gene_level : 1,
      hgnc_id : "HGNC:21876",
      havana_gene : "OTTHUMG00000157400.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105565120,
      stop : 105600875,
      direction : "-",
      ID : "ENSG00000185055.11",
      gene_id : "ENSG00000185055.11",
      gene_type : "protein_coding",
      gene_name : "EFCAB10",
      gene_level : 2,
      hgnc_id : "HGNC:34531",
      havana_gene : "OTTHUMG00000157397.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105604772,
      stop : 105876599,
      direction : "-",
      ID : "ENSG00000146776.15",
      gene_id : "ENSG00000146776.15",
      gene_type : "protein_coding",
      gene_name : "ATXN7L1",
      gene_level : 1,
      hgnc_id : "HGNC:22210",
      havana_gene : "OTTHUMG00000157521.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 105876796,
      stop : 106036432,
      direction : "+",
      ID : "ENSG00000128536.16",
      gene_id : "ENSG00000128536.16",
      gene_type : "protein_coding",
      gene_name : "CDHR3",
      gene_level : 2,
      hgnc_id : "HGNC:26308",
      havana_gene : "OTTHUMG00000157520.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 106090505,
      stop : 106112576,
      direction : "-",
      ID : "ENSG00000008282.9",
      gene_id : "ENSG00000008282.9",
      gene_type : "protein_coding",
      gene_name : "SYPL1",
      gene_level : 1,
      hgnc_id : "HGNC:11507",
      havana_gene : "OTTHUMG00000157587.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 106248298,
      stop : 106285966,
      direction : "-",
      ID : "ENSG00000105835.13",
      gene_id : "ENSG00000105835.13",
      gene_type : "protein_coding",
      gene_name : "NAMPT",
      gene_level : 2,
      hgnc_id : "HGNC:30092",
      havana_gene : "OTTHUMG00000140388.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 106654360,
      stop : 106661158,
      direction : "-",
      ID : "ENSG00000253276.4",
      gene_id : "ENSG00000253276.4",
      gene_type : "protein_coding",
      gene_name : "CCDC71L",
      gene_level : 2,
      hgnc_id : "HGNC:26685",
      havana_gene : "OTTHUMG00000164150.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 106865278,
      stop : 106908980,
      direction : "+",
      ID : "ENSG00000105851.11",
      gene_id : "ENSG00000105851.11",
      gene_type : "protein_coding",
      gene_name : "PIK3CG",
      gene_level : 2,
      hgnc_id : "HGNC:8978",
      havana_gene : "OTTHUMG00000157641.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107044705,
      stop : 107161811,
      direction : "+",
      ID : "ENSG00000005249.13",
      gene_id : "ENSG00000005249.13",
      gene_type : "protein_coding",
      gene_name : "PRKAR2B",
      gene_level : 2,
      hgnc_id : "HGNC:9392",
      havana_gene : "OTTHUMG00000137418.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107168961,
      stop : 107202522,
      direction : "+",
      ID : "ENSG00000105856.14",
      gene_id : "ENSG00000105856.14",
      gene_type : "protein_coding",
      gene_name : "HBP1",
      gene_level : 2,
      hgnc_id : "HGNC:23200",
      havana_gene : "OTTHUMG00000157642.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107201372,
      stop : 107564261,
      direction : "-",
      ID : "ENSG00000164597.15",
      gene_id : "ENSG00000164597.15",
      gene_type : "protein_coding",
      gene_name : "COG5",
      gene_level : 2,
      hgnc_id : "HGNC:14857",
      havana_gene : "OTTHUMG00000023895.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107470018,
      stop : 107475684,
      direction : "+",
      ID : "ENSG00000172209.6",
      gene_id : "ENSG00000172209.6",
      gene_type : "protein_coding",
      gene_name : "GPR22",
      gene_level : 2,
      hgnc_id : "HGNC:4477",
      havana_gene : "OTTHUMG00000154902.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107563484,
      stop : 107578523,
      direction : "+",
      ID : "ENSG00000105865.11",
      gene_id : "ENSG00000105865.11",
      gene_type : "protein_coding",
      gene_name : "DUS4L",
      gene_level : 2,
      hgnc_id : "HGNC:21517",
      havana_gene : "OTTHUMG00000154763.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107563971,
      stop : 107623317,
      direction : "+",
      ID : "ENSG00000288558.2",
      gene_id : "ENSG00000288558.2",
      gene_type : "protein_coding",
      gene_name : "DUS4L-BCAP29",
      gene_level : 2,
      hgnc_id : "HGNC:54422",
      havana_gene : "OTTHUMG00000195970.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107580246,
      stop : 107629170,
      direction : "+",
      ID : "ENSG00000075790.12",
      gene_id : "ENSG00000075790.12",
      gene_type : "protein_coding",
      gene_name : "BCAP29",
      gene_level : 1,
      hgnc_id : "HGNC:24131",
      havana_gene : "OTTHUMG00000154770.15",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107660828,
      stop : 107717809,
      direction : "+",
      ID : "ENSG00000091137.14",
      gene_id : "ENSG00000091137.14",
      gene_type : "protein_coding",
      gene_name : "SLC26A4",
      gene_level : 2,
      hgnc_id : "HGNC:8818",
      havana_gene : "OTTHUMG00000154807.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107743949,
      stop : 107761667,
      direction : "+",
      ID : "ENSG00000105879.12",
      gene_id : "ENSG00000105879.12",
      gene_type : "protein_coding",
      gene_name : "CBLL1",
      gene_level : 1,
      hgnc_id : "HGNC:21225",
      havana_gene : "OTTHUMG00000154809.15",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107765467,
      stop : 107803225,
      direction : "-",
      ID : "ENSG00000091138.13",
      gene_id : "ENSG00000091138.13",
      gene_type : "protein_coding",
      gene_name : "SLC26A3",
      gene_level : 2,
      hgnc_id : "HGNC:3018",
      havana_gene : "OTTHUMG00000154812.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107891162,
      stop : 107931730,
      direction : "+",
      ID : "ENSG00000091140.14",
      gene_id : "ENSG00000091140.14",
      gene_type : "protein_coding",
      gene_name : "DLD",
      gene_level : 2,
      hgnc_id : "HGNC:2898",
      havana_gene : "OTTHUMG00000154813.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 107923799,
      stop : 108003213,
      direction : "-",
      ID : "ENSG00000091136.15",
      gene_id : "ENSG00000091136.15",
      gene_type : "protein_coding",
      gene_name : "LAMB1",
      gene_level : 1,
      hgnc_id : "HGNC:6486",
      havana_gene : "OTTHUMG00000149966.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 108023548,
      stop : 108130361,
      direction : "-",
      ID : "ENSG00000091128.13",
      gene_id : "ENSG00000091128.13",
      gene_type : "protein_coding",
      gene_name : "LAMB4",
      gene_level : 2,
      hgnc_id : "HGNC:6491",
      havana_gene : "OTTHUMG00000154874.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 108147623,
      stop : 108456717,
      direction : "-",
      ID : "ENSG00000091129.21",
      gene_id : "ENSG00000091129.21",
      gene_type : "protein_coding",
      gene_name : "NRCAM",
      gene_level : 1,
      hgnc_id : "HGNC:7994",
      havana_gene : "OTTHUMG00000154973.12",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 108470417,
      stop : 108569666,
      direction : "-",
      ID : "ENSG00000135241.17",
      gene_id : "ENSG00000135241.17",
      gene_type : "protein_coding",
      gene_name : "PNPLA8",
      gene_level : 1,
      hgnc_id : "HGNC:28900",
      havana_gene : "OTTHUMG00000154870.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 108554543,
      stop : 108569750,
      direction : "-",
      ID : "ENSG00000177683.14",
      gene_id : "ENSG00000177683.14",
      gene_type : "protein_coding",
      gene_name : "THAP5",
      gene_level : 1,
      hgnc_id : "HGNC:23188",
      havana_gene : "OTTHUMG00000154951.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 108569867,
      stop : 108574850,
      direction : "+",
      ID : "ENSG00000128590.5",
      gene_id : "ENSG00000128590.5",
      gene_type : "protein_coding",
      gene_name : "DNAJB9",
      gene_level : 1,
      hgnc_id : "HGNC:6968",
      havana_gene : "OTTHUMG00000154866.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 110662644,
      stop : 111562517,
      direction : "-",
      ID : "ENSG00000184903.10",
      gene_id : "ENSG00000184903.10",
      gene_type : "protein_coding",
      gene_name : "IMMP2L",
      gene_level : 1,
      hgnc_id : "HGNC:14598",
      havana_gene : "OTTHUMG00000155023.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 111091006,
      stop : 111125454,
      direction : "+",
      ID : "ENSG00000173114.13",
      gene_id : "ENSG00000173114.13",
      gene_type : "protein_coding",
      gene_name : "LRRN3",
      gene_level : 1,
      hgnc_id : "HGNC:17200",
      havana_gene : "OTTHUMG00000155039.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 111726110,
      stop : 112206407,
      direction : "-",
      ID : "ENSG00000128512.23",
      gene_id : "ENSG00000128512.23",
      gene_type : "protein_coding",
      gene_name : "DOCK4",
      gene_level : 1,
      hgnc_id : "HGNC:19192",
      havana_gene : "OTTHUMG00000155077.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112206695,
      stop : 112343934,
      direction : "+",
      ID : "ENSG00000198839.10",
      gene_id : "ENSG00000198839.10",
      gene_type : "protein_coding",
      gene_name : "ZNF277",
      gene_level : 2,
      hgnc_id : "HGNC:13070",
      havana_gene : "OTTHUMG00000150209.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112422887,
      stop : 112481017,
      direction : "+",
      ID : "ENSG00000006652.15",
      gene_id : "ENSG00000006652.15",
      gene_type : "protein_coding",
      gene_name : "IFRD1",
      gene_level : 1,
      hgnc_id : "HGNC:5456",
      havana_gene : "OTTHUMG00000155124.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112450460,
      stop : 112490941,
      direction : "+",
      ID : "ENSG00000288640.1",
      gene_id : "ENSG00000288640.1",
      gene_type : "protein_coding",
      gene_name : "AC005192.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112450487,
      stop : 112450645,
      direction : "+",
      ID : "ENSG00000288634.1",
      gene_id : "ENSG00000288634.1",
      gene_type : "protein_coding",
      gene_name : "AC079741.2",
      gene_level : 2,
      hgnc_id : null,
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112480853,
      stop : 112491062,
      direction : "+",
      ID : "ENSG00000181016.9",
      gene_id : "ENSG00000181016.9",
      gene_type : "protein_coding",
      gene_name : "LSMEM1",
      gene_level : 2,
      hgnc_id : "HGNC:22036",
      havana_gene : "OTTHUMG00000155190.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112762377,
      stop : 112790423,
      direction : "-",
      ID : "ENSG00000146802.13",
      gene_id : "ENSG00000146802.13",
      gene_type : "protein_coding",
      gene_name : "TMEM168",
      gene_level : 1,
      hgnc_id : "HGNC:25826",
      havana_gene : "OTTHUMG00000155188.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 112819147,
      stop : 112939875,
      direction : "-",
      ID : "ENSG00000164603.12",
      gene_id : "ENSG00000164603.12",
      gene_type : "protein_coding",
      gene_name : "BMT2",
      gene_level : 2,
      hgnc_id : "HGNC:26475",
      havana_gene : "OTTHUMG00000155233.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 113078331,
      stop : 113087778,
      direction : "-",
      ID : "ENSG00000164604.14",
      gene_id : "ENSG00000164604.14",
      gene_type : "protein_coding",
      gene_name : "GPR85",
      gene_level : 2,
      hgnc_id : "HGNC:4536",
      havana_gene : "OTTHUMG00000156933.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 113116718,
      stop : 113118560,
      direction : "-",
      ID : "ENSG00000214194.9",
      gene_id : "ENSG00000214194.9",
      gene_type : "protein_coding",
      gene_name : "SMIM30",
      gene_level : 2,
      hgnc_id : "HGNC:48953",
      havana_gene : "OTTHUMG00000154780.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 113876777,
      stop : 114075920,
      direction : "-",
      ID : "ENSG00000154415.8",
      gene_id : "ENSG00000154415.8",
      gene_type : "protein_coding",
      gene_name : "PPP1R3A",
      gene_level : 2,
      hgnc_id : "HGNC:9291",
      havana_gene : "OTTHUMG00000156944.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 114086327,
      stop : 114693772,
      direction : "+",
      ID : "ENSG00000128573.26",
      gene_id : "ENSG00000128573.26",
      gene_type : "protein_coding",
      gene_name : "FOXP2",
      gene_level : 2,
      hgnc_id : "HGNC:13875",
      havana_gene : "OTTHUMG00000023131.19",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 114922359,
      stop : 115019202,
      direction : "+",
      ID : "ENSG00000135272.12",
      gene_id : "ENSG00000135272.12",
      gene_type : "protein_coding",
      gene_name : "MDFIC",
      gene_level : 2,
      hgnc_id : "HGNC:28870",
      havana_gene : "OTTHUMG00000023647.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 115935148,
      stop : 116159896,
      direction : "-",
      ID : "ENSG00000105967.16",
      gene_id : "ENSG00000105967.16",
      gene_type : "protein_coding",
      gene_name : "TFEC",
      gene_level : 2,
      hgnc_id : "HGNC:11754",
      havana_gene : "OTTHUMG00000023518.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116210506,
      stop : 116258783,
      direction : "+",
      ID : "ENSG00000135269.18",
      gene_id : "ENSG00000135269.18",
      gene_type : "protein_coding",
      gene_name : "TES",
      gene_level : 2,
      hgnc_id : "HGNC:14620",
      havana_gene : "OTTHUMG00000023092.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116287380,
      stop : 116508541,
      direction : "+",
      ID : "ENSG00000105971.15",
      gene_id : "ENSG00000105971.15",
      gene_type : "protein_coding",
      gene_name : "CAV2",
      gene_level : 1,
      hgnc_id : "HGNC:1528",
      havana_gene : "OTTHUMG00000023414.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116524994,
      stop : 116561179,
      direction : "+",
      ID : "ENSG00000105974.13",
      gene_id : "ENSG00000105974.13",
      gene_type : "protein_coding",
      gene_name : "CAV1",
      gene_level : 1,
      hgnc_id : "HGNC:1527",
      havana_gene : "OTTHUMG00000023413.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116672196,
      stop : 116798377,
      direction : "+",
      ID : "ENSG00000105976.16",
      gene_id : "ENSG00000105976.16",
      gene_type : "protein_coding",
      gene_name : "MET",
      gene_level : 1,
      hgnc_id : "HGNC:7029",
      havana_gene : "OTTHUMG00000023299.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116811070,
      stop : 116922049,
      direction : "+",
      ID : "ENSG00000198898.14",
      gene_id : "ENSG00000198898.14",
      gene_type : "protein_coding",
      gene_name : "CAPZA2",
      gene_level : 2,
      hgnc_id : "HGNC:1490",
      havana_gene : "OTTHUMG00000023185.15",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116953238,
      stop : 117230176,
      direction : "+",
      ID : "ENSG00000004866.22",
      gene_id : "ENSG00000004866.22",
      gene_type : "protein_coding",
      gene_name : "ST7",
      gene_level : 1,
      hgnc_id : "HGNC:11351",
      havana_gene : "OTTHUMG00000023888.24",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 116954391,
      stop : 117119719,
      direction : "+",
      ID : "ENSG00000288635.1",
      gene_id : "ENSG00000288635.1",
      gene_type : "protein_coding",
      gene_name : "AC106873.8",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000023888.24",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 117275451,
      stop : 117323152,
      direction : "-",
      ID : "ENSG00000105989.10",
      gene_id : "ENSG00000105989.10",
      gene_type : "protein_coding",
      gene_name : "WNT2",
      gene_level : 1,
      hgnc_id : "HGNC:12780",
      havana_gene : "OTTHUMG00000023428.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 117287120,
      stop : 117715971,
      direction : "+",
      ID : "ENSG00000001626.16",
      gene_id : "ENSG00000001626.16",
      gene_type : "protein_coding",
      gene_name : "CFTR",
      gene_level : 1,
      hgnc_id : "HGNC:1884",
      havana_gene : "OTTHUMG00000023076.18",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 117363222,
      stop : 117428123,
      direction : "-",
      ID : "ENSG00000154438.8",
      gene_id : "ENSG00000154438.8",
      gene_type : "protein_coding",
      gene_name : "ASZ1",
      gene_level : 2,
      hgnc_id : "HGNC:1350",
      havana_gene : "OTTHUMG00000064565.11",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 117710651,
      stop : 117874139,
      direction : "-",
      ID : "ENSG00000077063.11",
      gene_id : "ENSG00000077063.11",
      gene_type : "protein_coding",
      gene_name : "CTTNBP2",
      gene_level : 1,
      hgnc_id : "HGNC:15679",
      havana_gene : "OTTHUMG00000022880.13",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 118184144,
      stop : 118204035,
      direction : "+",
      ID : "ENSG00000128534.8",
      gene_id : "ENSG00000128534.8",
      gene_type : "protein_coding",
      gene_name : "LSM8",
      gene_level : 2,
      hgnc_id : "HGNC:20471",
      havana_gene : "OTTHUMG00000156956.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 118214669,
      stop : 118496171,
      direction : "+",
      ID : "ENSG00000106013.15",
      gene_id : "ENSG00000106013.15",
      gene_type : "protein_coding",
      gene_name : "ANKRD7",
      gene_level : 2,
      hgnc_id : "HGNC:18588",
      havana_gene : "OTTHUMG00000156960.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 120273175,
      stop : 120750337,
      direction : "+",
      ID : "ENSG00000184408.10",
      gene_id : "ENSG00000184408.10",
      gene_type : "protein_coding",
      gene_name : "KCND2",
      gene_level : 2,
      hgnc_id : "HGNC:6238",
      havana_gene : "OTTHUMG00000156989.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 120787320,
      stop : 120858402,
      direction : "-",
      ID : "ENSG00000106025.9",
      gene_id : "ENSG00000106025.9",
      gene_type : "protein_coding",
      gene_name : "TSPAN12",
      gene_level : 2,
      hgnc_id : "HGNC:21641",
      havana_gene : "OTTHUMG00000156980.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 120950763,
      stop : 120977216,
      direction : "+",
      ID : "ENSG00000071243.16",
      gene_id : "ENSG00000071243.16",
      gene_type : "protein_coding",
      gene_name : "ING3",
      gene_level : 2,
      hgnc_id : "HGNC:14587",
      havana_gene : "OTTHUMG00000141270.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 120988697,
      stop : 121297442,
      direction : "+",
      ID : "ENSG00000106034.18",
      gene_id : "ENSG00000106034.18",
      gene_type : "protein_coding",
      gene_name : "CPED1",
      gene_level : 1,
      hgnc_id : "HGNC:26159",
      havana_gene : "OTTHUMG00000156982.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 121325367,
      stop : 121341104,
      direction : "+",
      ID : "ENSG00000002745.13",
      gene_id : "ENSG00000002745.13",
      gene_type : "protein_coding",
      gene_name : "WNT16",
      gene_level : 2,
      hgnc_id : "HGNC:16267",
      havana_gene : "OTTHUMG00000156963.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 121348878,
      stop : 121396364,
      direction : "-",
      ID : "ENSG00000196937.11",
      gene_id : "ENSG00000196937.11",
      gene_type : "protein_coding",
      gene_name : "FAM3C",
      gene_level : 2,
      hgnc_id : "HGNC:18664",
      havana_gene : "OTTHUMG00000156979.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 121873089,
      stop : 122062036,
      direction : "+",
      ID : "ENSG00000106278.12",
      gene_id : "ENSG00000106278.12",
      gene_type : "protein_coding",
      gene_name : "PTPRZ1",
      gene_level : 1,
      hgnc_id : "HGNC:9685",
      havana_gene : "OTTHUMG00000157057.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 122064583,
      stop : 122144308,
      direction : "-",
      ID : "ENSG00000008311.16",
      gene_id : "ENSG00000008311.16",
      gene_type : "protein_coding",
      gene_name : "AASS",
      gene_level : 2,
      hgnc_id : "HGNC:17366",
      havana_gene : "OTTHUMG00000157058.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 122301303,
      stop : 122310691,
      direction : "-",
      ID : "ENSG00000128610.12",
      gene_id : "ENSG00000128610.12",
      gene_type : "protein_coding",
      gene_name : "FEZF1",
      gene_level : 2,
      hgnc_id : "HGNC:22788",
      havana_gene : "OTTHUMG00000157091.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 122318411,
      stop : 122886759,
      direction : "-",
      ID : "ENSG00000081803.16",
      gene_id : "ENSG00000081803.16",
      gene_type : "protein_coding",
      gene_name : "CADPS2",
      gene_level : 2,
      hgnc_id : "HGNC:16018",
      havana_gene : "OTTHUMG00000157093.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 122697735,
      stop : 122699117,
      direction : "-",
      ID : "ENSG00000188050.3",
      gene_id : "ENSG00000188050.3",
      gene_type : "protein_coding",
      gene_name : "RNF133",
      gene_level : 2,
      hgnc_id : "HGNC:21154",
      havana_gene : "OTTHUMG00000157092.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 122701668,
      stop : 122702922,
      direction : "-",
      ID : "ENSG00000235631.2",
      gene_id : "ENSG00000235631.2",
      gene_type : "protein_coding",
      gene_name : "RNF148",
      gene_level : 1,
      hgnc_id : "HGNC:22411",
      havana_gene : "OTTHUMG00000157099.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 122994704,
      stop : 122995700,
      direction : "-",
      ID : "ENSG00000128519.3",
      gene_id : "ENSG00000128519.3",
      gene_type : "protein_coding",
      gene_name : "TAS2R16",
      gene_level : 2,
      hgnc_id : "HGNC:14921",
      havana_gene : "OTTHUMG00000157090.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123113531,
      stop : 123199972,
      direction : "-",
      ID : "ENSG00000081800.9",
      gene_id : "ENSG00000081800.9",
      gene_type : "protein_coding",
      gene_name : "SLC13A1",
      gene_level : 2,
      hgnc_id : "HGNC:10916",
      havana_gene : "OTTHUMG00000157087.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123452193,
      stop : 123535077,
      direction : "-",
      ID : "ENSG00000164675.11",
      gene_id : "ENSG00000164675.11",
      gene_type : "protein_coding",
      gene_name : "IQUB",
      gene_level : 2,
      hgnc_id : "HGNC:21995",
      havana_gene : "OTTHUMG00000157347.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123536997,
      stop : 123557904,
      direction : "-",
      ID : "ENSG00000128609.16",
      gene_id : "ENSG00000128609.16",
      gene_type : "protein_coding",
      gene_name : "NDUFA5",
      gene_level : 2,
      hgnc_id : "HGNC:7688",
      havana_gene : "OTTHUMG00000157348.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123567010,
      stop : 123639481,
      direction : "+",
      ID : "ENSG00000146809.13",
      gene_id : "ENSG00000146809.13",
      gene_type : "protein_coding",
      gene_name : "ASB15",
      gene_level : 2,
      hgnc_id : "HGNC:19767",
      havana_gene : "OTTHUMG00000157114.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123655866,
      stop : 123664290,
      direction : "+",
      ID : "ENSG00000170807.12",
      gene_id : "ENSG00000170807.12",
      gene_type : "protein_coding",
      gene_name : "LMOD2",
      gene_level : 2,
      hgnc_id : "HGNC:6648",
      havana_gene : "OTTHUMG00000157149.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123681943,
      stop : 123749003,
      direction : "-",
      ID : "ENSG00000106299.8",
      gene_id : "ENSG00000106299.8",
      gene_type : "protein_coding",
      gene_name : "WASL",
      gene_level : 2,
      hgnc_id : "HGNC:12735",
      havana_gene : "OTTHUMG00000157346.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123828983,
      stop : 123877481,
      direction : "+",
      ID : "ENSG00000106302.10",
      gene_id : "ENSG00000106302.10",
      gene_type : "protein_coding",
      gene_name : "HYAL4",
      gene_level : 2,
      hgnc_id : "HGNC:5323",
      havana_gene : "OTTHUMG00000157349.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 123925237,
      stop : 123971414,
      direction : "+",
      ID : "ENSG00000106304.15",
      gene_id : "ENSG00000106304.15",
      gene_type : "protein_coding",
      gene_name : "SPAM1",
      gene_level : 2,
      hgnc_id : "HGNC:11217",
      havana_gene : "OTTHUMG00000157284.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 124030921,
      stop : 124033067,
      direction : "-",
      ID : "ENSG00000234224.3",
      gene_id : "ENSG00000234224.3",
      gene_type : "protein_coding",
      gene_name : "TMEM229A",
      gene_level : 2,
      hgnc_id : "HGNC:37279",
      havana_gene : "OTTHUMG00000154762.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 124476371,
      stop : 124476955,
      direction : "+",
      ID : "ENSG00000230268.3",
      gene_id : "ENSG00000230268.3",
      gene_type : "protein_coding",
      gene_name : "SSU72P8",
      gene_level : 2,
      hgnc_id : "HGNC:43627",
      havana_gene : "OTTHUMG00000157318.2",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 124743885,
      stop : 124765792,
      direction : "-",
      ID : "ENSG00000170775.3",
      gene_id : "ENSG00000170775.3",
      gene_type : "protein_coding",
      gene_name : "GPR37",
      gene_level : 2,
      hgnc_id : "HGNC:4494",
      havana_gene : "OTTHUMG00000157197.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 124822386,
      stop : 124929983,
      direction : "-",
      ID : "ENSG00000128513.16",
      gene_id : "ENSG00000128513.16",
      gene_type : "protein_coding",
      gene_name : "POT1",
      gene_level : 2,
      hgnc_id : "HGNC:17284",
      havana_gene : "OTTHUMG00000157194.21",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 126438598,
      stop : 127253093,
      direction : "-",
      ID : "ENSG00000179603.18",
      gene_id : "ENSG00000179603.18",
      gene_type : "protein_coding",
      gene_name : "GRM8",
      gene_level : 2,
      hgnc_id : "HGNC:4600",
      havana_gene : "OTTHUMG00000022888.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 127346790,
      stop : 127431924,
      direction : "-",
      ID : "ENSG00000048405.10",
      gene_id : "ENSG00000048405.10",
      gene_type : "protein_coding",
      gene_name : "ZNF800",
      gene_level : 2,
      hgnc_id : "HGNC:27267",
      havana_gene : "OTTHUMG00000023456.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 127580628,
      stop : 127593611,
      direction : "-",
      ID : "ENSG00000179562.3",
      gene_id : "ENSG00000179562.3",
      gene_type : "protein_coding",
      gene_name : "GCC1",
      gene_level : 2,
      hgnc_id : "HGNC:19095",
      havana_gene : "OTTHUMG00000023590.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 127588386,
      stop : 127591700,
      direction : "+",
      ID : "ENSG00000004059.11",
      gene_id : "ENSG00000004059.11",
      gene_type : "protein_coding",
      gene_name : "ARF5",
      gene_level : 2,
      hgnc_id : "HGNC:658",
      havana_gene : "OTTHUMG00000023246.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 127591409,
      stop : 127602144,
      direction : "+",
      ID : "ENSG00000106328.10",
      gene_id : "ENSG00000106328.10",
      gene_type : "protein_coding",
      gene_name : "FSCN3",
      gene_level : 2,
      hgnc_id : "HGNC:3961",
      havana_gene : "OTTHUMG00000022935.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 127610292,
      stop : 127618142,
      direction : "-",
      ID : "ENSG00000106331.17",
      gene_id : "ENSG00000106331.17",
      gene_type : "protein_coding",
      gene_name : "PAX4",
      gene_level : 1,
      hgnc_id : "HGNC:8618",
      havana_gene : "OTTHUMG00000157562.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 127652194,
      stop : 128092609,
      direction : "+",
      ID : "ENSG00000197157.11",
      gene_id : "ENSG00000197157.11",
      gene_type : "protein_coding",
      gene_name : "SND1",
      gene_level : 2,
      hgnc_id : "HGNC:30646",
      havana_gene : "OTTHUMG00000157560.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128027071,
      stop : 128032107,
      direction : "-",
      ID : "ENSG00000128594.8",
      gene_id : "ENSG00000128594.8",
      gene_type : "protein_coding",
      gene_name : "LRRC4",
      gene_level : 1,
      hgnc_id : "HGNC:15586",
      havana_gene : "OTTHUMG00000157563.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128241278,
      stop : 128257629,
      direction : "+",
      ID : "ENSG00000174697.5",
      gene_id : "ENSG00000174697.5",
      gene_type : "protein_coding",
      gene_name : "LEP",
      gene_level : 2,
      hgnc_id : "HGNC:6553",
      havana_gene : "OTTHUMG00000157564.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128297685,
      stop : 128343908,
      direction : "-",
      ID : "ENSG00000106344.8",
      gene_id : "ENSG00000106344.8",
      gene_type : "protein_coding",
      gene_name : "RBM28",
      gene_level : 1,
      hgnc_id : "HGNC:21863",
      havana_gene : "OTTHUMG00000157711.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128350325,
      stop : 128361685,
      direction : "-",
      ID : "ENSG00000224940.9",
      gene_id : "ENSG00000224940.9",
      gene_type : "protein_coding",
      gene_name : "PRRT4",
      gene_level : 2,
      hgnc_id : "HGNC:37280",
      havana_gene : "OTTHUMG00000157714.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128392277,
      stop : 128410252,
      direction : "-",
      ID : "ENSG00000106348.18",
      gene_id : "ENSG00000106348.18",
      gene_type : "protein_coding",
      gene_name : "IMPDH1",
      gene_level : 2,
      hgnc_id : "HGNC:6052",
      havana_gene : "OTTHUMG00000157713.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128455849,
      stop : 128458418,
      direction : "+",
      ID : "ENSG00000135245.10",
      gene_id : "ENSG00000135245.10",
      gene_type : "protein_coding",
      gene_name : "HILPDA",
      gene_level : 2,
      hgnc_id : "HGNC:28859",
      havana_gene : "OTTHUMG00000157712.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128476729,
      stop : 128506602,
      direction : "+",
      ID : "ENSG00000165055.16",
      gene_id : "ENSG00000165055.16",
      gene_type : "protein_coding",
      gene_name : "METTL2B",
      gene_level : 2,
      hgnc_id : "HGNC:18272",
      havana_gene : "OTTHUMG00000143738.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128672288,
      stop : 128687872,
      direction : "+",
      ID : "ENSG00000205085.12",
      gene_id : "ENSG00000205085.12",
      gene_type : "protein_coding",
      gene_name : "FAM71F2",
      gene_level : 2,
      hgnc_id : "HGNC:27998",
      havana_gene : "OTTHUMG00000158275.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128709061,
      stop : 128731743,
      direction : "+",
      ID : "ENSG00000135248.15",
      gene_id : "ENSG00000135248.15",
      gene_type : "protein_coding",
      gene_name : "FAM71F1",
      gene_level : 1,
      hgnc_id : "HGNC:30704",
      havana_gene : "OTTHUMG00000158276.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128739292,
      stop : 128773400,
      direction : "+",
      ID : "ENSG00000128595.17",
      gene_id : "ENSG00000128595.17",
      gene_type : "protein_coding",
      gene_name : "CALU",
      gene_level : 2,
      hgnc_id : "HGNC:1458",
      havana_gene : "OTTHUMG00000158274.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128772485,
      stop : 128775794,
      direction : "-",
      ID : "ENSG00000128617.3",
      gene_id : "ENSG00000128617.3",
      gene_type : "protein_coding",
      gene_name : "OPN1SW",
      gene_level : 2,
      hgnc_id : "HGNC:1012",
      havana_gene : "OTTHUMG00000158311.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128790757,
      stop : 128822132,
      direction : "+",
      ID : "ENSG00000128596.17",
      gene_id : "ENSG00000128596.17",
      gene_type : "protein_coding",
      gene_name : "CCDC136",
      gene_level : 1,
      hgnc_id : "HGNC:22225",
      havana_gene : "OTTHUMG00000158310.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128830406,
      stop : 128859274,
      direction : "+",
      ID : "ENSG00000128591.16",
      gene_id : "ENSG00000128591.16",
      gene_type : "protein_coding",
      gene_name : "FLNC",
      gene_level : 2,
      hgnc_id : "HGNC:3756",
      havana_gene : "OTTHUMG00000023627.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128862042,
      stop : 128910719,
      direction : "-",
      ID : "ENSG00000135253.15",
      gene_id : "ENSG00000135253.15",
      gene_type : "protein_coding",
      gene_name : "KCP",
      gene_level : 2,
      hgnc_id : "HGNC:17585",
      havana_gene : "OTTHUMG00000158363.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128862856,
      stop : 128865847,
      direction : "+",
      ID : "ENSG00000128524.5",
      gene_id : "ENSG00000128524.5",
      gene_type : "protein_coding",
      gene_name : "ATP6V1F",
      gene_level : 1,
      hgnc_id : "HGNC:16832",
      havana_gene : "OTTHUMG00000158365.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128866330,
      stop : 128872047,
      direction : "+",
      ID : "ENSG00000272899.4",
      gene_id : "ENSG00000272899.4",
      gene_type : "protein_coding",
      gene_name : "ATP6V1FNB",
      gene_level : 2,
      hgnc_id : "HGNC:52392",
      havana_gene : "OTTHUMG00000158367.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128937457,
      stop : 128950038,
      direction : "+",
      ID : "ENSG00000128604.20",
      gene_id : "ENSG00000128604.20",
      gene_type : "protein_coding",
      gene_name : "IRF5",
      gene_level : 2,
      hgnc_id : "HGNC:6120",
      havana_gene : "OTTHUMG00000158410.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 128954180,
      stop : 129055173,
      direction : "-",
      ID : "ENSG00000064419.13",
      gene_id : "ENSG00000064419.13",
      gene_type : "protein_coding",
      gene_name : "TNPO3",
      gene_level : 1,
      hgnc_id : "HGNC:17103",
      havana_gene : "OTTHUMG00000158409.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129126518,
      stop : 129130793,
      direction : "+",
      ID : "ENSG00000230626.4",
      gene_id : "ENSG00000230626.4",
      gene_type : "protein_coding",
      gene_name : "AC011005.1",
      gene_level : 2,
      hgnc_id : "tag=retrogene",
      havana_gene : "OTTHUMG00000158418.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129144707,
      stop : 129169699,
      direction : "+",
      ID : "ENSG00000158457.6",
      gene_id : "ENSG00000158457.6",
      gene_type : "protein_coding",
      gene_name : "TSPAN33",
      gene_level : 2,
      hgnc_id : "HGNC:28743",
      havana_gene : "OTTHUMG00000158420.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129188633,
      stop : 129213545,
      direction : "+",
      ID : "ENSG00000128602.11",
      gene_id : "ENSG00000128602.11",
      gene_type : "protein_coding",
      gene_name : "SMO",
      gene_level : 2,
      hgnc_id : "HGNC:11119",
      havana_gene : "OTTHUMG00000158421.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129225023,
      stop : 129430211,
      direction : "+",
      ID : "ENSG00000158467.16",
      gene_id : "ENSG00000158467.16",
      gene_type : "protein_coding",
      gene_name : "AHCYL2",
      gene_level : 1,
      hgnc_id : "HGNC:22204",
      havana_gene : "OTTHUMG00000157677.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129434432,
      stop : 129488399,
      direction : "+",
      ID : "ENSG00000128578.10",
      gene_id : "ENSG00000128578.10",
      gene_type : "protein_coding",
      gene_name : "STRIP2",
      gene_level : 2,
      hgnc_id : "HGNC:22209",
      havana_gene : "OTTHUMG00000157695.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129502531,
      stop : 129512918,
      direction : "+",
      ID : "ENSG00000240204.3",
      gene_id : "ENSG00000240204.3",
      gene_type : "protein_coding",
      gene_name : "SMKR1",
      gene_level : 1,
      hgnc_id : "HGNC:43561",
      havana_gene : "OTTHUMG00000157696.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129611720,
      stop : 129757082,
      direction : "+",
      ID : "ENSG00000106459.15",
      gene_id : "ENSG00000106459.15",
      gene_type : "protein_coding",
      gene_name : "NRF1",
      gene_level : 2,
      hgnc_id : "HGNC:7996",
      havana_gene : "OTTHUMG00000143736.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 129830732,
      stop : 129952960,
      direction : "-",
      ID : "ENSG00000186591.13",
      gene_id : "ENSG00000186591.13",
      gene_type : "protein_coding",
      gene_name : "UBE2H",
      gene_level : 1,
      hgnc_id : "HGNC:12484",
      havana_gene : "OTTHUMG00000157650.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130018287,
      stop : 130051451,
      direction : "-",
      ID : "ENSG00000091732.17",
      gene_id : "ENSG00000091732.17",
      gene_type : "protein_coding",
      gene_name : "ZC3HC1",
      gene_level : 1,
      hgnc_id : "HGNC:29913",
      havana_gene : "OTTHUMG00000157648.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130070534,
      stop : 130135705,
      direction : "+",
      ID : "ENSG00000128607.14",
      gene_id : "ENSG00000128607.14",
      gene_type : "protein_coding",
      gene_name : "KLHDC10",
      gene_level : 2,
      hgnc_id : "HGNC:22194",
      havana_gene : "OTTHUMG00000157654.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130164713,
      stop : 130207770,
      direction : "-",
      ID : "ENSG00000146842.17",
      gene_id : "ENSG00000146842.17",
      gene_type : "protein_coding",
      gene_name : "TMEM209",
      gene_level : 2,
      hgnc_id : "HGNC:21898",
      havana_gene : "OTTHUMG00000157653.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130206344,
      stop : 130216844,
      direction : "+",
      ID : "ENSG00000165120.5",
      gene_id : "ENSG00000165120.5",
      gene_type : "protein_coding",
      gene_name : "SSMEM1",
      gene_level : 2,
      hgnc_id : "HGNC:29580",
      havana_gene : "OTTHUMG00000157844.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130266863,
      stop : 130289798,
      direction : "+",
      ID : "ENSG00000158516.12",
      gene_id : "ENSG00000158516.12",
      gene_type : "protein_coding",
      gene_name : "CPA2",
      gene_level : 2,
      hgnc_id : "HGNC:2297",
      havana_gene : "OTTHUMG00000157019.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130293134,
      stop : 130324180,
      direction : "+",
      ID : "ENSG00000128510.12",
      gene_id : "ENSG00000128510.12",
      gene_type : "protein_coding",
      gene_name : "CPA4",
      gene_level : 1,
      hgnc_id : "HGNC:15740",
      havana_gene : "OTTHUMG00000157825.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130344816,
      stop : 130368730,
      direction : "+",
      ID : "ENSG00000158525.16",
      gene_id : "ENSG00000158525.16",
      gene_type : "protein_coding",
      gene_name : "CPA5",
      gene_level : 1,
      hgnc_id : "HGNC:15722",
      havana_gene : "OTTHUMG00000157824.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130380339,
      stop : 130388114,
      direction : "+",
      ID : "ENSG00000091704.10",
      gene_id : "ENSG00000091704.10",
      gene_type : "protein_coding",
      gene_name : "CPA1",
      gene_level : 2,
      hgnc_id : "HGNC:2296",
      havana_gene : "OTTHUMG00000157826.12",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130393771,
      stop : 130442433,
      direction : "-",
      ID : "ENSG00000106477.20",
      gene_id : "ENSG00000106477.20",
      gene_type : "protein_coding",
      gene_name : "CEP41",
      gene_level : 2,
      hgnc_id : "HGNC:12370",
      havana_gene : "OTTHUMG00000157823.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130486171,
      stop : 130506465,
      direction : "+",
      ID : "ENSG00000106484.16",
      gene_id : "ENSG00000106484.16",
      gene_type : "protein_coding",
      gene_name : "MEST",
      gene_level : 1,
      hgnc_id : "HGNC:7028",
      havana_gene : "OTTHUMG00000156661.29",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130506238,
      stop : 130668748,
      direction : "-",
      ID : "ENSG00000158623.14",
      gene_id : "ENSG00000158623.14",
      gene_type : "protein_coding",
      gene_name : "COPG2",
      gene_level : 2,
      hgnc_id : "HGNC:2237",
      havana_gene : "OTTHUMG00000155364.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130668643,
      stop : 130687432,
      direction : "-",
      ID : "ENSG00000213265.9",
      gene_id : "ENSG00000213265.9",
      gene_type : "protein_coding",
      gene_name : "TSGA13",
      gene_level : 2,
      hgnc_id : "HGNC:12369",
      havana_gene : "OTTHUMG00000154999.39",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 130730697,
      stop : 130734207,
      direction : "-",
      ID : "ENSG00000266265.4",
      gene_id : "ENSG00000266265.4",
      gene_type : "protein_coding",
      gene_name : "KLF14",
      gene_level : 2,
      hgnc_id : "HGNC:23025",
      havana_gene : "OTTHUMG00000188298.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 131110096,
      stop : 131496632,
      direction : "+",
      ID : "ENSG00000128585.18",
      gene_id : "ENSG00000128585.18",
      gene_type : "protein_coding",
      gene_name : "MKLN1",
      gene_level : 1,
      hgnc_id : "HGNC:7109",
      havana_gene : "OTTHUMG00000154880.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 131500262,
      stop : 131558217,
      direction : "-",
      ID : "ENSG00000128567.17",
      gene_id : "ENSG00000128567.17",
      gene_type : "protein_coding",
      gene_name : "PODXL",
      gene_level : 2,
      hgnc_id : "HGNC:9171",
      havana_gene : "OTTHUMG00000154918.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 132123332,
      stop : 132648688,
      direction : "-",
      ID : "ENSG00000221866.9",
      gene_id : "ENSG00000221866.9",
      gene_type : "protein_coding",
      gene_name : "PLXNA4",
      gene_level : 2,
      hgnc_id : "HGNC:9102",
      havana_gene : "OTTHUMG00000155108.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 132784870,
      stop : 133082090,
      direction : "-",
      ID : "ENSG00000106554.13",
      gene_id : "ENSG00000106554.13",
      gene_type : "protein_coding",
      gene_name : "CHCHD3",
      gene_level : 2,
      hgnc_id : "HGNC:21906",
      havana_gene : "OTTHUMG00000155231.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 133253073,
      stop : 134066589,
      direction : "+",
      ID : "ENSG00000131558.15",
      gene_id : "ENSG00000131558.15",
      gene_type : "protein_coding",
      gene_name : "EXOC4",
      gene_level : 2,
      hgnc_id : "HGNC:30389",
      havana_gene : "OTTHUMG00000155259.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134127299,
      stop : 134264591,
      direction : "+",
      ID : "ENSG00000155530.3",
      gene_id : "ENSG00000155530.3",
      gene_type : "protein_coding",
      gene_name : "LRGUK",
      gene_level : 2,
      hgnc_id : "HGNC:21964",
      havana_gene : "OTTHUMG00000155320.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134289332,
      stop : 134316930,
      direction : "-",
      ID : "ENSG00000205060.11",
      gene_id : "ENSG00000205060.11",
      gene_type : "protein_coding",
      gene_name : "SLC35B4",
      gene_level : 2,
      hgnc_id : "HGNC:20584",
      havana_gene : "OTTHUMG00000155321.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134442356,
      stop : 134459284,
      direction : "-",
      ID : "ENSG00000085662.14",
      gene_id : "ENSG00000085662.14",
      gene_type : "protein_coding",
      gene_name : "AKR1B1",
      gene_level : 2,
      hgnc_id : "HGNC:381",
      havana_gene : "OTTHUMG00000155322.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134527567,
      stop : 134541412,
      direction : "+",
      ID : "ENSG00000198074.10",
      gene_id : "ENSG00000198074.10",
      gene_type : "protein_coding",
      gene_name : "AKR1B10",
      gene_level : 2,
      hgnc_id : "HGNC:382",
      havana_gene : "OTTHUMG00000155356.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134549110,
      stop : 134579875,
      direction : "+",
      ID : "ENSG00000227471.9",
      gene_id : "ENSG00000227471.9",
      gene_type : "protein_coding",
      gene_name : "AKR1B15",
      gene_level : 2,
      hgnc_id : "HGNC:37281",
      havana_gene : "OTTHUMG00000155376.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134646811,
      stop : 134679816,
      direction : "+",
      ID : "ENSG00000172331.12",
      gene_id : "ENSG00000172331.12",
      gene_type : "protein_coding",
      gene_name : "BPGM",
      gene_level : 2,
      hgnc_id : "HGNC:1093",
      havana_gene : "OTTHUMG00000155380.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134744252,
      stop : 134970729,
      direction : "+",
      ID : "ENSG00000122786.20",
      gene_id : "ENSG00000122786.20",
      gene_type : "protein_coding",
      gene_name : "CALD1",
      gene_level : 2,
      hgnc_id : "HGNC:1441",
      havana_gene : "OTTHUMG00000155407.10",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 134986508,
      stop : 135147963,
      direction : "+",
      ID : "ENSG00000146856.14",
      gene_id : "ENSG00000146856.14",
      gene_type : "protein_coding",
      gene_name : "AGBL3",
      gene_level : 2,
      hgnc_id : "HGNC:27981",
      havana_gene : "OTTHUMG00000155406.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135092363,
      stop : 135170795,
      direction : "-",
      ID : "ENSG00000122783.17",
      gene_id : "ENSG00000122783.17",
      gene_type : "protein_coding",
      gene_name : "CYREN",
      gene_level : 2,
      hgnc_id : "HGNC:22432",
      havana_gene : "OTTHUMG00000155447.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135148072,
      stop : 135166215,
      direction : "+",
      ID : "ENSG00000146859.6",
      gene_id : "ENSG00000146859.6",
      gene_type : "protein_coding",
      gene_name : "TMEM140",
      gene_level : 2,
      hgnc_id : "HGNC:21870",
      havana_gene : "OTTHUMG00000155413.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135183839,
      stop : 135211534,
      direction : "-",
      ID : "ENSG00000105875.14",
      gene_id : "ENSG00000105875.14",
      gene_type : "protein_coding",
      gene_name : "WDR91",
      gene_level : 1,
      hgnc_id : "HGNC:24997",
      havana_gene : "OTTHUMG00000155414.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135231979,
      stop : 135258492,
      direction : "+",
      ID : "ENSG00000146857.4",
      gene_id : "ENSG00000146857.4",
      gene_type : "protein_coding",
      gene_name : "STRA8",
      gene_level : 2,
      hgnc_id : "HGNC:30653",
      havana_gene : "OTTHUMG00000155415.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135361795,
      stop : 135510127,
      direction : "-",
      ID : "ENSG00000080802.19",
      gene_id : "ENSG00000080802.19",
      gene_type : "protein_coding",
      gene_name : "CNOT4",
      gene_level : 1,
      hgnc_id : "HGNC:7880",
      havana_gene : "OTTHUMG00000155568.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135557917,
      stop : 135648757,
      direction : "+",
      ID : "ENSG00000155561.15",
      gene_id : "ENSG00000155561.15",
      gene_type : "protein_coding",
      gene_name : "NUP205",
      gene_level : 1,
      hgnc_id : "HGNC:18658",
      havana_gene : "OTTHUMG00000155497.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135662496,
      stop : 135693418,
      direction : "+",
      ID : "ENSG00000243317.8",
      gene_id : "ENSG00000243317.8",
      gene_type : "protein_coding",
      gene_name : "STMP1",
      gene_level : 2,
      hgnc_id : "HGNC:41909",
      havana_gene : "OTTHUMG00000155495.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135681237,
      stop : 135729258,
      direction : "-",
      ID : "ENSG00000164707.15",
      gene_id : "ENSG00000164707.15",
      gene_type : "protein_coding",
      gene_name : "SLC13A4",
      gene_level : 2,
      hgnc_id : "HGNC:15827",
      havana_gene : "OTTHUMG00000155539.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135728348,
      stop : 135748813,
      direction : "-",
      ID : "ENSG00000189320.9",
      gene_id : "ENSG00000189320.9",
      gene_type : "protein_coding",
      gene_name : "FAM180A",
      gene_level : 2,
      hgnc_id : "HGNC:33773",
      havana_gene : "OTTHUMG00000155537.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 135926760,
      stop : 135977359,
      direction : "-",
      ID : "ENSG00000105887.11",
      gene_id : "ENSG00000105887.11",
      gene_type : "protein_coding",
      gene_name : "MTPN",
      gene_level : 2,
      hgnc_id : "HGNC:15667",
      havana_gene : "OTTHUMG00000155627.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 136868652,
      stop : 137020255,
      direction : "+",
      ID : "ENSG00000181072.12",
      gene_id : "ENSG00000181072.12",
      gene_type : "protein_coding",
      gene_name : "CHRM2",
      gene_level : 2,
      hgnc_id : "HGNC:1951",
      havana_gene : "OTTHUMG00000155658.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 137227341,
      stop : 137343774,
      direction : "-",
      ID : "ENSG00000105894.12",
      gene_id : "ENSG00000105894.12",
      gene_type : "protein_coding",
      gene_name : "PTN",
      gene_level : 1,
      hgnc_id : "HGNC:9630",
      havana_gene : "OTTHUMG00000155709.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 137381037,
      stop : 137847092,
      direction : "-",
      ID : "ENSG00000157680.16",
      gene_id : "ENSG00000157680.16",
      gene_type : "protein_coding",
      gene_name : "DGKI",
      gene_level : 2,
      hgnc_id : "HGNC:2855",
      havana_gene : "OTTHUMG00000155697.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 137874979,
      stop : 138002086,
      direction : "-",
      ID : "ENSG00000182158.15",
      gene_id : "ENSG00000182158.15",
      gene_type : "protein_coding",
      gene_name : "CREB3L2",
      gene_level : 1,
      hgnc_id : "HGNC:23720",
      havana_gene : "OTTHUMG00000155744.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 138002324,
      stop : 138118305,
      direction : "+",
      ID : "ENSG00000122787.15",
      gene_id : "ENSG00000122787.15",
      gene_type : "protein_coding",
      gene_name : "AKR1D1",
      gene_level : 1,
      hgnc_id : "HGNC:388",
      havana_gene : "OTTHUMG00000155787.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 138460259,
      stop : 138589996,
      direction : "+",
      ID : "ENSG00000122779.18",
      gene_id : "ENSG00000122779.18",
      gene_type : "protein_coding",
      gene_name : "TRIM24",
      gene_level : 2,
      hgnc_id : "HGNC:11812",
      havana_gene : "OTTHUMG00000155820.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 138594285,
      stop : 138701362,
      direction : "-",
      ID : "ENSG00000157703.16",
      gene_id : "ENSG00000157703.16",
      gene_type : "protein_coding",
      gene_name : "SVOPL",
      gene_level : 1,
      hgnc_id : "HGNC:27034",
      havana_gene : "OTTHUMG00000155870.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 138706294,
      stop : 138799560,
      direction : "-",
      ID : "ENSG00000105929.16",
      gene_id : "ENSG00000105929.16",
      gene_type : "protein_coding",
      gene_name : "ATP6V0A4",
      gene_level : 2,
      hgnc_id : "HGNC:866",
      havana_gene : "OTTHUMG00000157122.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 138797952,
      stop : 138838101,
      direction : "+",
      ID : "ENSG00000214128.11",
      gene_id : "ENSG00000214128.11",
      gene_type : "protein_coding",
      gene_name : "TMEM213",
      gene_level : 1,
      hgnc_id : "HGNC:27220",
      havana_gene : "OTTHUMG00000157182.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 138831381,
      stop : 138981389,
      direction : "-",
      ID : "ENSG00000122778.10",
      gene_id : "ENSG00000122778.10",
      gene_type : "protein_coding",
      gene_name : "KIAA1549",
      gene_level : 2,
      hgnc_id : "HGNC:22219",
      havana_gene : "OTTHUMG00000157214.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139025706,
      stop : 139036042,
      direction : "-",
      ID : "ENSG00000146858.8",
      gene_id : "ENSG00000146858.8",
      gene_type : "protein_coding",
      gene_name : "ZC3HAV1L",
      gene_level : 2,
      hgnc_id : "HGNC:22423",
      havana_gene : "OTTHUMG00000157229.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139043515,
      stop : 139132122,
      direction : "-",
      ID : "ENSG00000105939.14",
      gene_id : "ENSG00000105939.14",
      gene_type : "protein_coding",
      gene_name : "ZC3HAV1",
      gene_level : 2,
      hgnc_id : "HGNC:23721",
      havana_gene : "OTTHUMG00000157471.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139133744,
      stop : 139191986,
      direction : "+",
      ID : "ENSG00000105948.13",
      gene_id : "ENSG00000105948.13",
      gene_type : "protein_coding",
      gene_name : "TTC26",
      gene_level : 1,
      hgnc_id : "HGNC:21882",
      havana_gene : "OTTHUMG00000157472.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139230356,
      stop : 139308236,
      direction : "+",
      ID : "ENSG00000157741.15",
      gene_id : "ENSG00000157741.15",
      gene_type : "protein_coding",
      gene_name : "UBN2",
      gene_level : 1,
      hgnc_id : "HGNC:21931",
      havana_gene : "OTTHUMG00000157623.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139339457,
      stop : 139346328,
      direction : "+",
      ID : "ENSG00000164898.13",
      gene_id : "ENSG00000164898.13",
      gene_type : "protein_coding",
      gene_name : "FMC1",
      gene_level : 2,
      hgnc_id : "HGNC:26946",
      havana_gene : "OTTHUMG00000151719.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139340359,
      stop : 139423457,
      direction : "+",
      ID : "ENSG00000146963.18",
      gene_id : "ENSG00000146963.18",
      gene_type : "protein_coding",
      gene_name : "LUC7L2",
      gene_level : 1,
      hgnc_id : "HGNC:21608",
      havana_gene : "OTTHUMG00000185163.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139341360,
      stop : 139422599,
      direction : "+",
      ID : "ENSG00000269955.2",
      gene_id : "ENSG00000269955.2",
      gene_type : "protein_coding",
      gene_name : "FMC1-LUC7L2",
      gene_level : 2,
      hgnc_id : "HGNC:44671",
      havana_gene : "OTTHUMG00000151717.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139452690,
      stop : 139483673,
      direction : "-",
      ID : "ENSG00000188883.5",
      gene_id : "ENSG00000188883.5",
      gene_type : "protein_coding",
      gene_name : "KLRG2",
      gene_level : 2,
      hgnc_id : "HGNC:24778",
      havana_gene : "OTTHUMG00000157705.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139523685,
      stop : 139544985,
      direction : "+",
      ID : "ENSG00000236279.7",
      gene_id : "ENSG00000236279.7",
      gene_type : "protein_coding",
      gene_name : "CLEC2L",
      gene_level : 1,
      hgnc_id : "HGNC:21969",
      havana_gene : "OTTHUMG00000164900.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139561570,
      stop : 139777998,
      direction : "-",
      ID : "ENSG00000064393.16",
      gene_id : "ENSG00000064393.16",
      gene_type : "protein_coding",
      gene_name : "HIPK2",
      gene_level : 2,
      hgnc_id : "HGNC:14402",
      havana_gene : "OTTHUMG00000157704.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 139777051,
      stop : 140020325,
      direction : "+",
      ID : "ENSG00000059377.18",
      gene_id : "ENSG00000059377.18",
      gene_type : "protein_coding",
      gene_name : "TBXAS1",
      gene_level : 1,
      hgnc_id : "HGNC:11609",
      havana_gene : "OTTHUMG00000157302.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140023749,
      stop : 140062951,
      direction : "-",
      ID : "ENSG00000059378.13",
      gene_id : "ENSG00000059378.13",
      gene_type : "protein_coding",
      gene_name : "PARP12",
      gene_level : 1,
      hgnc_id : "HGNC:21919",
      havana_gene : "OTTHUMG00000157315.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140084746,
      stop : 140176983,
      direction : "-",
      ID : "ENSG00000006459.11",
      gene_id : "ENSG00000006459.11",
      gene_type : "protein_coding",
      gene_name : "KDM7A",
      gene_level : 2,
      hgnc_id : "HGNC:22224",
      havana_gene : "OTTHUMG00000157327.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140293693,
      stop : 140404433,
      direction : "-",
      ID : "ENSG00000157800.18",
      gene_id : "ENSG00000157800.18",
      gene_type : "protein_coding",
      gene_name : "SLC37A3",
      gene_level : 1,
      hgnc_id : "HGNC:20651",
      havana_gene : "OTTHUMG00000157343.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140404058,
      stop : 140427974,
      direction : "+",
      ID : "ENSG00000146955.11",
      gene_id : "ENSG00000146955.11",
      gene_type : "protein_coding",
      gene_name : "RAB19",
      gene_level : 2,
      hgnc_id : "HGNC:19982",
      havana_gene : "OTTHUMG00000157410.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140453033,
      stop : 140479536,
      direction : "-",
      ID : "ENSG00000133606.11",
      gene_id : "ENSG00000133606.11",
      gene_type : "protein_coding",
      gene_name : "MKRN1",
      gene_level : 1,
      hgnc_id : "HGNC:7112",
      havana_gene : "OTTHUMG00000157412.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140518420,
      stop : 140673993,
      direction : "-",
      ID : "ENSG00000146966.13",
      gene_id : "ENSG00000146966.13",
      gene_type : "protein_coding",
      gene_name : "DENND2A",
      gene_level : 2,
      hgnc_id : "HGNC:22212",
      havana_gene : "OTTHUMG00000157411.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140672945,
      stop : 140696261,
      direction : "+",
      ID : "ENSG00000133597.11",
      gene_id : "ENSG00000133597.11",
      gene_type : "protein_coding",
      gene_name : "ADCK2",
      gene_level : 2,
      hgnc_id : "HGNC:19039",
      havana_gene : "OTTHUMG00000157409.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140690777,
      stop : 140722790,
      direction : "+",
      ID : "ENSG00000090266.13",
      gene_id : "ENSG00000090266.13",
      gene_type : "protein_coding",
      gene_name : "NDUFB2",
      gene_level : 1,
      hgnc_id : "HGNC:7697",
      havana_gene : "OTTHUMG00000157424.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 140719327,
      stop : 140924929,
      direction : "-",
      ID : "ENSG00000157764.14",
      gene_id : "ENSG00000157764.14",
      gene_type : "protein_coding",
      gene_name : "BRAF",
      gene_level : 2,
      hgnc_id : "HGNC:1097",
      havana_gene : "OTTHUMG00000157457.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141002610,
      stop : 141015228,
      direction : "-",
      ID : "ENSG00000090263.16",
      gene_id : "ENSG00000090263.16",
      gene_type : "protein_coding",
      gene_name : "MRPS33",
      gene_level : 1,
      hgnc_id : "HGNC:16634",
      havana_gene : "OTTHUMG00000157456.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141074064,
      stop : 141480380,
      direction : "+",
      ID : "ENSG00000261115.6",
      gene_id : "ENSG00000261115.6",
      gene_type : "protein_coding",
      gene_name : "TMEM178B",
      gene_level : 2,
      hgnc_id : "HGNC:44112",
      havana_gene : "OTTHUMG00000172737.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141551278,
      stop : 141655244,
      direction : "+",
      ID : "ENSG00000006530.18",
      gene_id : "ENSG00000006530.18",
      gene_type : "protein_coding",
      gene_name : "AGK",
      gene_level : 2,
      hgnc_id : "HGNC:21869",
      havana_gene : "OTTHUMG00000157499.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141656728,
      stop : 141702166,
      direction : "-",
      ID : "ENSG00000257093.7",
      gene_id : "ENSG00000257093.7",
      gene_type : "protein_coding",
      gene_name : "DENND11",
      gene_level : 2,
      hgnc_id : "HGNC:29472",
      havana_gene : "OTTHUMG00000157539.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141708353,
      stop : 141731271,
      direction : "+",
      ID : "ENSG00000214102.7",
      gene_id : "ENSG00000214102.7",
      gene_type : "protein_coding",
      gene_name : "WEE2",
      gene_level : 1,
      hgnc_id : "HGNC:19684",
      havana_gene : "OTTHUMG00000157536.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141738334,
      stop : 141787922,
      direction : "+",
      ID : "ENSG00000106028.11",
      gene_id : "ENSG00000106028.11",
      gene_type : "protein_coding",
      gene_name : "SSBP1",
      gene_level : 2,
      hgnc_id : "HGNC:11317",
      havana_gene : "OTTHUMG00000157572.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141764097,
      stop : 141765197,
      direction : "+",
      ID : "ENSG00000127362.2",
      gene_id : "ENSG00000127362.2",
      gene_type : "protein_coding",
      gene_name : "TAS2R3",
      gene_level : 2,
      hgnc_id : "HGNC:14910",
      havana_gene : "OTTHUMG00000157637.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141776674,
      stop : 141781691,
      direction : "+",
      ID : "ENSG00000127364.4",
      gene_id : "ENSG00000127364.4",
      gene_type : "protein_coding",
      gene_name : "TAS2R4",
      gene_level : 2,
      hgnc_id : "HGNC:14911",
      havana_gene : "OTTHUMG00000157634.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141790217,
      stop : 141791367,
      direction : "+",
      ID : "ENSG00000127366.5",
      gene_id : "ENSG00000127366.5",
      gene_type : "protein_coding",
      gene_name : "TAS2R5",
      gene_level : 2,
      hgnc_id : "HGNC:14912",
      havana_gene : "OTTHUMG00000157632.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141836300,
      stop : 141841487,
      direction : "-",
      ID : "ENSG00000165076.14",
      gene_id : "ENSG00000165076.14",
      gene_type : "protein_coding",
      gene_name : "PRSS37",
      gene_level : 2,
      hgnc_id : "HGNC:29211",
      havana_gene : "OTTHUMG00000157174.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141907813,
      stop : 142106747,
      direction : "+",
      ID : "ENSG00000257335.8",
      gene_id : "ENSG00000257335.8",
      gene_type : "protein_coding",
      gene_name : "MGAM",
      gene_level : 1,
      hgnc_id : "HGNC:7043",
      havana_gene : "OTTHUMG00000158395.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141916399,
      stop : 141920625,
      direction : "+",
      ID : "ENSG00000258083.2",
      gene_id : "ENSG00000258083.2",
      gene_type : "protein_coding",
      gene_name : "OR9A4",
      gene_level : 2,
      hgnc_id : "HGNC:15095",
      havana_gene : "OTTHUMG00000158370.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141927357,
      stop : 141947007,
      direction : "-",
      ID : "ENSG00000258227.7",
      gene_id : "ENSG00000258227.7",
      gene_type : "protein_coding",
      gene_name : "CLEC5A",
      gene_level : 2,
      hgnc_id : "HGNC:2054",
      havana_gene : "OTTHUMG00000157173.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 141972631,
      stop : 141973773,
      direction : "-",
      ID : "ENSG00000257138.1",
      gene_id : "ENSG00000257138.1",
      gene_type : "protein_coding",
      gene_name : "TAS2R38",
      gene_level : 2,
      hgnc_id : "HGNC:9584",
      havana_gene : "OTTHUMG00000158374.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142111749,
      stop : 142222324,
      direction : "+",
      ID : "ENSG00000257743.8",
      gene_id : "ENSG00000257743.8",
      gene_type : "protein_coding",
      gene_name : "MGAM2",
      gene_level : 1,
      hgnc_id : "HGNC:28101",
      havana_gene : "OTTHUMG00000158558.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142252143,
      stop : 142258058,
      direction : "-",
      ID : "ENSG00000258223.6",
      gene_id : "ENSG00000258223.6",
      gene_type : "protein_coding",
      gene_name : "PRSS58",
      gene_level : 2,
      hgnc_id : "HGNC:39125",
      havana_gene : "OTTHUMG00000158565.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142666272,
      stop : 142667718,
      direction : "+",
      ID : "ENSG00000270672.1",
      gene_id : "ENSG00000270672.1",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L6",
      gene_level : 2,
      hgnc_id : "HGNC:37163",
      havana_gene : "OTTHUMG00000184977.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142749468,
      stop : 142753076,
      direction : "+",
      ID : "ENSG00000204983.14",
      gene_id : "ENSG00000204983.14",
      gene_type : "protein_coding",
      gene_name : "PRSS1",
      gene_level : 1,
      hgnc_id : "HGNC:9475",
      havana_gene : "OTTHUMG00000158923.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142760398,
      stop : 142774564,
      direction : "+",
      ID : "ENSG00000275896.6",
      gene_id : "ENSG00000275896.6",
      gene_type : "protein_coding",
      gene_name : "PRSS2",
      gene_level : 2,
      hgnc_id : "HGNC:9483",
      havana_gene : "OTTHUMG00000158904.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142855061,
      stop : 142871094,
      direction : "+",
      ID : "ENSG00000106123.12",
      gene_id : "ENSG00000106123.12",
      gene_type : "protein_coding",
      gene_name : "EPHB6",
      gene_level : 2,
      hgnc_id : "HGNC:3396",
      havana_gene : "OTTHUMG00000155707.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142871208,
      stop : 142885745,
      direction : "-",
      ID : "ENSG00000165125.22",
      gene_id : "ENSG00000165125.22",
      gene_type : "protein_coding",
      gene_name : "TRPV6",
      gene_level : 2,
      hgnc_id : "HGNC:14006",
      havana_gene : "OTTHUMG00000157158.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142908101,
      stop : 142933746,
      direction : "-",
      ID : "ENSG00000127412.7",
      gene_id : "ENSG00000127412.7",
      gene_type : "protein_coding",
      gene_name : "TRPV5",
      gene_level : 2,
      hgnc_id : "HGNC:3145",
      havana_gene : "OTTHUMG00000157157.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142939343,
      stop : 142940868,
      direction : "+",
      ID : "ENSG00000165131.8",
      gene_id : "ENSG00000165131.8",
      gene_type : "protein_coding",
      gene_name : "LLCFC1",
      gene_level : 2,
      hgnc_id : "HGNC:21750",
      havana_gene : "OTTHUMG00000152664.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 142941114,
      stop : 142962363,
      direction : "-",
      ID : "ENSG00000197993.9",
      gene_id : "ENSG00000197993.9",
      gene_type : "protein_coding",
      gene_name : "KEL",
      gene_level : 2,
      hgnc_id : "HGNC:6308",
      havana_gene : "OTTHUMG00000157159.12",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143026158,
      stop : 143027195,
      direction : "-",
      ID : "ENSG00000179468.5",
      gene_id : "ENSG00000179468.5",
      gene_type : "protein_coding",
      gene_name : "OR9A2",
      gene_level : 2,
      hgnc_id : "HGNC:15093",
      havana_gene : "OTTHUMG00000158386.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143052320,
      stop : 143053347,
      direction : "+",
      ID : "ENSG00000225781.1",
      gene_id : "ENSG00000225781.1",
      gene_type : "protein_coding",
      gene_name : "OR6V1",
      gene_level : 2,
      hgnc_id : "HGNC:15090",
      havana_gene : "OTTHUMG00000158385.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143132077,
      stop : 143139739,
      direction : "+",
      ID : "ENSG00000159763.4",
      gene_id : "ENSG00000159763.4",
      gene_type : "protein_coding",
      gene_name : "PIP",
      gene_level : 2,
      hgnc_id : "HGNC:8993",
      havana_gene : "OTTHUMG00000152635.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143183419,
      stop : 143184435,
      direction : "+",
      ID : "ENSG00000236398.2",
      gene_id : "ENSG00000236398.2",
      gene_type : "protein_coding",
      gene_name : "TAS2R39",
      gene_level : 2,
      hgnc_id : "HGNC:18886",
      havana_gene : "OTTHUMG00000152636.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143222037,
      stop : 143223079,
      direction : "+",
      ID : "ENSG00000221937.4",
      gene_id : "ENSG00000221937.4",
      gene_type : "protein_coding",
      gene_name : "TAS2R40",
      gene_level : 2,
      hgnc_id : "HGNC:18885",
      havana_gene : "OTTHUMG00000152638.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143244093,
      stop : 143270854,
      direction : "+",
      ID : "ENSG00000197448.14",
      gene_id : "ENSG00000197448.14",
      gene_type : "protein_coding",
      gene_name : "GSTK1",
      gene_level : 2,
      hgnc_id : "HGNC:16906",
      havana_gene : "OTTHUMG00000152637.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143279957,
      stop : 143288048,
      direction : "+",
      ID : "ENSG00000178826.11",
      gene_id : "ENSG00000178826.11",
      gene_type : "protein_coding",
      gene_name : "TMEM139",
      gene_level : 2,
      hgnc_id : "HGNC:22058",
      havana_gene : "OTTHUMG00000152652.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143288215,
      stop : 143307696,
      direction : "+",
      ID : "ENSG00000106144.20",
      gene_id : "ENSG00000106144.20",
      gene_type : "protein_coding",
      gene_name : "CASP2",
      gene_level : 2,
      hgnc_id : "HGNC:1503",
      havana_gene : "OTTHUMG00000023641.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143316111,
      stop : 143352083,
      direction : "+",
      ID : "ENSG00000188037.13",
      gene_id : "ENSG00000188037.13",
      gene_type : "protein_coding",
      gene_name : "CLCN1",
      gene_level : 2,
      hgnc_id : "HGNC:2019",
      havana_gene : "OTTHUMG00000152695.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143353400,
      stop : 143362770,
      direction : "-",
      ID : "ENSG00000159784.18",
      gene_id : "ENSG00000159784.18",
      gene_type : "protein_coding",
      gene_name : "FAM131B",
      gene_level : 2,
      hgnc_id : "HGNC:22202",
      havana_gene : "OTTHUMG00000152697.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143381295,
      stop : 143391111,
      direction : "+",
      ID : "ENSG00000159840.16",
      gene_id : "ENSG00000159840.16",
      gene_type : "protein_coding",
      gene_name : "ZYX",
      gene_level : 1,
      hgnc_id : "HGNC:13200",
      havana_gene : "OTTHUMG00000023822.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143390289,
      stop : 143408856,
      direction : "-",
      ID : "ENSG00000146904.9",
      gene_id : "ENSG00000146904.9",
      gene_type : "protein_coding",
      gene_name : "EPHA1",
      gene_level : 1,
      hgnc_id : "HGNC:3385",
      havana_gene : "OTTHUMG00000155894.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143443453,
      stop : 143444409,
      direction : "+",
      ID : "ENSG00000185899.1",
      gene_id : "ENSG00000185899.1",
      gene_type : "protein_coding",
      gene_name : "TAS2R60",
      gene_level : 2,
      hgnc_id : "HGNC:20639",
      havana_gene : "OTTHUMG00000154891.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143477873,
      stop : 143478796,
      direction : "+",
      ID : "ENSG00000221855.1",
      gene_id : "ENSG00000221855.1",
      gene_type : "protein_coding",
      gene_name : "TAS2R41",
      gene_level : 2,
      hgnc_id : "HGNC:18883",
      havana_gene : "OTTHUMG00000155892.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143571801,
      stop : 143574387,
      direction : "+",
      ID : "ENSG00000271079.1",
      gene_id : "ENSG00000271079.1",
      gene_type : "protein_coding",
      gene_name : "CTAGE15",
      gene_level : 2,
      hgnc_id : "HGNC:37295",
      havana_gene : "OTTHUMG00000153233.2",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143620952,
      stop : 143730409,
      direction : "+",
      ID : "ENSG00000170379.20",
      gene_id : "ENSG00000170379.20",
      gene_type : "protein_coding",
      gene_name : "TCAF2",
      gene_level : 2,
      hgnc_id : "HGNC:26878",
      havana_gene : "OTTHUMG00000153232.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143639230,
      stop : 143647646,
      direction : "-",
      ID : "ENSG00000283528.2",
      gene_id : "ENSG00000283528.2",
      gene_type : "protein_coding",
      gene_name : "TCAF2C",
      gene_level : 2,
      hgnc_id : "HGNC:53641",
      havana_gene : "OTTHUMG00000191659.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143755089,
      stop : 143757696,
      direction : "-",
      ID : "ENSG00000271321.1",
      gene_id : "ENSG00000271321.1",
      gene_type : "protein_coding",
      gene_name : "CTAGE6",
      gene_level : 2,
      hgnc_id : "HGNC:28644",
      havana_gene : "OTTHUMG00000157770.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143851375,
      stop : 143902198,
      direction : "-",
      ID : "ENSG00000198420.10",
      gene_id : "ENSG00000198420.10",
      gene_type : "protein_coding",
      gene_name : "TCAF1",
      gene_level : 2,
      hgnc_id : "HGNC:22201",
      havana_gene : "OTTHUMG00000157773.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143935166,
      stop : 143936279,
      direction : "+",
      ID : "ENSG00000221910.2",
      gene_id : "ENSG00000221910.2",
      gene_type : "protein_coding",
      gene_name : "OR2F2",
      gene_level : 2,
      hgnc_id : "HGNC:8247",
      havana_gene : "OTTHUMG00000157768.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 143954844,
      stop : 143997312,
      direction : "+",
      ID : "ENSG00000213215.5",
      gene_id : "ENSG00000213215.5",
      gene_type : "protein_coding",
      gene_name : "OR2F1",
      gene_level : 2,
      hgnc_id : "HGNC:8246",
      havana_gene : "OTTHUMG00000157771.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144000320,
      stop : 144008793,
      direction : "+",
      ID : "ENSG00000221813.4",
      gene_id : "ENSG00000221813.4",
      gene_type : "protein_coding",
      gene_name : "OR6B1",
      gene_level : 2,
      hgnc_id : "HGNC:8354",
      havana_gene : "OTTHUMG00000157765.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144048948,
      stop : 144058845,
      direction : "+",
      ID : "ENSG00000221836.3",
      gene_id : "ENSG00000221836.3",
      gene_type : "protein_coding",
      gene_name : "OR2A5",
      gene_level : 2,
      hgnc_id : "HGNC:8232",
      havana_gene : "OTTHUMG00000158006.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144069811,
      stop : 144075870,
      direction : "+",
      ID : "ENSG00000221933.3",
      gene_id : "ENSG00000221933.3",
      gene_type : "protein_coding",
      gene_name : "OR2A25",
      gene_level : 2,
      hgnc_id : "HGNC:19562",
      havana_gene : "OTTHUMG00000158013.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144086278,
      stop : 144098953,
      direction : "+",
      ID : "ENSG00000221858.3",
      gene_id : "ENSG00000221858.3",
      gene_type : "protein_coding",
      gene_name : "OR2A12",
      gene_level : 2,
      hgnc_id : "HGNC:15082",
      havana_gene : "OTTHUMG00000157996.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144109514,
      stop : 144110564,
      direction : "+",
      ID : "ENSG00000221989.2",
      gene_id : "ENSG00000221989.2",
      gene_type : "protein_coding",
      gene_name : "OR2A2",
      gene_level : 2,
      hgnc_id : "HGNC:8230",
      havana_gene : "OTTHUMG00000158001.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144123176,
      stop : 144131188,
      direction : "+",
      ID : "ENSG00000221938.5",
      gene_id : "ENSG00000221938.5",
      gene_type : "protein_coding",
      gene_name : "OR2A14",
      gene_level : 2,
      hgnc_id : "HGNC:15084",
      havana_gene : "OTTHUMG00000158003.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144183466,
      stop : 144186053,
      direction : "+",
      ID : "ENSG00000225932.3",
      gene_id : "ENSG00000225932.3",
      gene_type : "protein_coding",
      gene_name : "CTAGE4",
      gene_level : 2,
      hgnc_id : "HGNC:24772",
      havana_gene : "OTTHUMG00000157997.1",
      tag : "retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144186083,
      stop : 144195833,
      direction : "-",
      ID : "ENSG00000213214.5",
      gene_id : "ENSG00000213214.5",
      gene_type : "protein_coding",
      gene_name : "ARHGEF35",
      gene_level : 2,
      hgnc_id : "HGNC:33846",
      havana_gene : "OTTHUMG00000158010.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144228244,
      stop : 144239605,
      direction : "-",
      ID : "ENSG00000212807.2",
      gene_id : "ENSG00000212807.2",
      gene_type : "protein_coding",
      gene_name : "OR2A42",
      gene_level : 2,
      hgnc_id : "HGNC:31230",
      havana_gene : "OTTHUMG00000157995.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144257663,
      stop : 144264792,
      direction : "-",
      ID : "ENSG00000243896.4",
      gene_id : "ENSG00000243896.4",
      gene_type : "protein_coding",
      gene_name : "OR2A7",
      gene_level : 2,
      hgnc_id : "HGNC:8234",
      havana_gene : "OTTHUMG00000158002.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144266701,
      stop : 144269288,
      direction : "-",
      ID : "ENSG00000244693.1",
      gene_id : "ENSG00000244693.1",
      gene_type : "protein_coding",
      gene_name : "CTAGE8",
      gene_level : 2,
      hgnc_id : "HGNC:37294",
      havana_gene : "OTTHUMG00000158009.1",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144312419,
      stop : 144322737,
      direction : "+",
      ID : "ENSG00000221970.3",
      gene_id : "ENSG00000221970.3",
      gene_type : "protein_coding",
      gene_name : "OR2A1",
      gene_level : 2,
      hgnc_id : "HGNC:8229",
      havana_gene : "OTTHUMG00000158005.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144355288,
      stop : 144380632,
      direction : "+",
      ID : "ENSG00000050327.15",
      gene_id : "ENSG00000050327.15",
      gene_type : "protein_coding",
      gene_name : "ARHGEF5",
      gene_level : 2,
      hgnc_id : "HGNC:13209",
      havana_gene : "OTTHUMG00000158004.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144397240,
      stop : 144410227,
      direction : "-",
      ID : "ENSG00000106410.15",
      gene_id : "ENSG00000106410.15",
      gene_type : "protein_coding",
      gene_name : "NOBOX",
      gene_level : 1,
      hgnc_id : "HGNC:22448",
      havana_gene : "OTTHUMG00000158051.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 144451941,
      stop : 144836395,
      direction : "-",
      ID : "ENSG00000196511.14",
      gene_id : "ENSG00000196511.14",
      gene_type : "protein_coding",
      gene_name : "TPK1",
      gene_level : 2,
      hgnc_id : "HGNC:17358",
      havana_gene : "OTTHUMG00000152774.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 146116002,
      stop : 148420998,
      direction : "+",
      ID : "ENSG00000174469.23",
      gene_id : "ENSG00000174469.23",
      gene_type : "protein_coding",
      gene_name : "CNTNAP2",
      gene_level : 1,
      hgnc_id : "HGNC:13830",
      havana_gene : "OTTHUMG00000152743.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 148590766,
      stop : 148615860,
      direction : "+",
      ID : "ENSG00000170279.3",
      gene_id : "ENSG00000170279.3",
      gene_type : "protein_coding",
      gene_name : "C7orf33",
      gene_level : 2,
      hgnc_id : "HGNC:21724",
      havana_gene : "OTTHUMG00000152756.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 148697914,
      stop : 148801110,
      direction : "+",
      ID : "ENSG00000055130.17",
      gene_id : "ENSG00000055130.17",
      gene_type : "protein_coding",
      gene_name : "CUL1",
      gene_level : 2,
      hgnc_id : "HGNC:2551",
      havana_gene : "OTTHUMG00000152776.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 148807383,
      stop : 148884321,
      direction : "-",
      ID : "ENSG00000106462.11",
      gene_id : "ENSG00000106462.11",
      gene_type : "protein_coding",
      gene_name : "EZH2",
      gene_level : 2,
      hgnc_id : "HGNC:3527",
      havana_gene : "OTTHUMG00000158973.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149003062,
      stop : 149028662,
      direction : "-",
      ID : "ENSG00000155660.11",
      gene_id : "ENSG00000155660.11",
      gene_type : "protein_coding",
      gene_name : "PDIA4",
      gene_level : 1,
      hgnc_id : "HGNC:30167",
      havana_gene : "OTTHUMG00000150248.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149069641,
      stop : 149090782,
      direction : "-",
      ID : "ENSG00000197362.15",
      gene_id : "ENSG00000197362.15",
      gene_type : "protein_coding",
      gene_name : "ZNF786",
      gene_level : 2,
      hgnc_id : "HGNC:21806",
      havana_gene : "OTTHUMG00000158975.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149102784,
      stop : 149126324,
      direction : "-",
      ID : "ENSG00000204947.9",
      gene_id : "ENSG00000204947.9",
      gene_type : "protein_coding",
      gene_name : "ZNF425",
      gene_level : 1,
      hgnc_id : "HGNC:20690",
      havana_gene : "OTTHUMG00000158971.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149126416,
      stop : 149183042,
      direction : "+",
      ID : "ENSG00000197024.9",
      gene_id : "ENSG00000197024.9",
      gene_type : "protein_coding",
      gene_name : "ZNF398",
      gene_level : 2,
      hgnc_id : "HGNC:18373",
      havana_gene : "OTTHUMG00000158970.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149195546,
      stop : 149226238,
      direction : "+",
      ID : "ENSG00000170265.12",
      gene_id : "ENSG00000170265.12",
      gene_type : "protein_coding",
      gene_name : "ZNF282",
      gene_level : 2,
      hgnc_id : "HGNC:13076",
      havana_gene : "OTTHUMG00000158974.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149239651,
      stop : 149255606,
      direction : "+",
      ID : "ENSG00000170260.9",
      gene_id : "ENSG00000170260.9",
      gene_type : "protein_coding",
      gene_name : "ZNF212",
      gene_level : 2,
      hgnc_id : "HGNC:13004",
      havana_gene : "OTTHUMG00000158968.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149262171,
      stop : 149297302,
      direction : "+",
      ID : "ENSG00000204946.10",
      gene_id : "ENSG00000204946.10",
      gene_type : "protein_coding",
      gene_name : "ZNF783",
      gene_level : 2,
      hgnc_id : "HGNC:27222",
      havana_gene : "OTTHUMG00000158969.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149431363,
      stop : 149461062,
      direction : "-",
      ID : "ENSG00000196453.8",
      gene_id : "ENSG00000196453.8",
      gene_type : "protein_coding",
      gene_name : "ZNF777",
      gene_level : 2,
      hgnc_id : "HGNC:22213",
      havana_gene : "OTTHUMG00000158967.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149472696,
      stop : 149497817,
      direction : "-",
      ID : "ENSG00000181220.17",
      gene_id : "ENSG00000181220.17",
      gene_type : "protein_coding",
      gene_name : "ZNF746",
      gene_level : 2,
      hgnc_id : "HGNC:21948",
      havana_gene : "OTTHUMG00000158972.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149714781,
      stop : 149734575,
      direction : "+",
      ID : "ENSG00000133619.17",
      gene_id : "ENSG00000133619.17",
      gene_type : "protein_coding",
      gene_name : "KRBA1",
      gene_level : 1,
      hgnc_id : "HGNC:22228",
      havana_gene : "OTTHUMG00000157886.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149764182,
      stop : 149773588,
      direction : "-",
      ID : "ENSG00000181444.13",
      gene_id : "ENSG00000181444.13",
      gene_type : "protein_coding",
      gene_name : "ZNF467",
      gene_level : 2,
      hgnc_id : "HGNC:23154",
      havana_gene : "OTTHUMG00000157883.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149838375,
      stop : 149867479,
      direction : "+",
      ID : "ENSG00000106479.11",
      gene_id : "ENSG00000106479.11",
      gene_type : "protein_coding",
      gene_name : "ZNF862",
      gene_level : 1,
      hgnc_id : "HGNC:34519",
      havana_gene : "OTTHUMG00000158093.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 149872968,
      stop : 149891204,
      direction : "+",
      ID : "ENSG00000171130.18",
      gene_id : "ENSG00000171130.18",
      gene_type : "protein_coding",
      gene_name : "ATP6V0E2",
      gene_level : 2,
      hgnc_id : "HGNC:21723",
      havana_gene : "OTTHUMG00000158094.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150243916,
      stop : 150323725,
      direction : "-",
      ID : "ENSG00000106526.10",
      gene_id : "ENSG00000106526.10",
      gene_type : "protein_coding",
      gene_name : "ACTR3C",
      gene_level : 2,
      hgnc_id : "HGNC:37282",
      havana_gene : "OTTHUMG00000158323.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150322639,
      stop : 150332721,
      direction : "+",
      ID : "ENSG00000188707.6",
      gene_id : "ENSG00000188707.6",
      gene_type : "protein_coding",
      gene_name : "ZBED6CL",
      gene_level : 2,
      hgnc_id : "HGNC:21720",
      havana_gene : "OTTHUMG00000158328.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150323263,
      stop : 150338156,
      direction : "+",
      ID : "ENSG00000127399.15",
      gene_id : "ENSG00000127399.15",
      gene_type : "protein_coding",
      gene_name : "LRRC61",
      gene_level : 2,
      hgnc_id : "HGNC:21704",
      havana_gene : "OTTHUMG00000158326.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150338317,
      stop : 150341662,
      direction : "-",
      ID : "ENSG00000106538.10",
      gene_id : "ENSG00000106538.10",
      gene_type : "protein_coding",
      gene_name : "RARRES2",
      gene_level : 1,
      hgnc_id : "HGNC:9868",
      havana_gene : "OTTHUMG00000158325.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150368189,
      stop : 150374044,
      direction : "+",
      ID : "ENSG00000214022.11",
      gene_id : "ENSG00000214022.11",
      gene_type : "protein_coding",
      gene_name : "REPIN1",
      gene_level : 1,
      hgnc_id : "HGNC:17922",
      havana_gene : "OTTHUMG00000158330.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150368790,
      stop : 150398630,
      direction : "+",
      ID : "ENSG00000196456.13",
      gene_id : "ENSG00000196456.13",
      gene_type : "protein_coding",
      gene_name : "ZNF775",
      gene_level : 1,
      hgnc_id : "HGNC:28501",
      havana_gene : "OTTHUMG00000191597.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150400702,
      stop : 150412470,
      direction : "+",
      ID : "ENSG00000284691.1",
      gene_id : "ENSG00000284691.1",
      gene_type : "protein_coding",
      gene_name : "AC073111.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000158324.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150450630,
      stop : 150479393,
      direction : "+",
      ID : "ENSG00000171115.4",
      gene_id : "ENSG00000171115.4",
      gene_type : "protein_coding",
      gene_name : "GIMAP8",
      gene_level : 2,
      hgnc_id : "HGNC:21792",
      havana_gene : "OTTHUMG00000158327.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150514872,
      stop : 150521073,
      direction : "+",
      ID : "ENSG00000179144.5",
      gene_id : "ENSG00000179144.5",
      gene_type : "protein_coding",
      gene_name : "GIMAP7",
      gene_level : 2,
      hgnc_id : "HGNC:22404",
      havana_gene : "OTTHUMG00000157626.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150567369,
      stop : 150573953,
      direction : "+",
      ID : "ENSG00000133574.10",
      gene_id : "ENSG00000133574.10",
      gene_type : "protein_coding",
      gene_name : "GIMAP4",
      gene_level : 2,
      hgnc_id : "HGNC:21872",
      havana_gene : "OTTHUMG00000157475.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150625375,
      stop : 150632648,
      direction : "-",
      ID : "ENSG00000133561.15",
      gene_id : "ENSG00000133561.15",
      gene_type : "protein_coding",
      gene_name : "GIMAP6",
      gene_level : 2,
      hgnc_id : "HGNC:21918",
      havana_gene : "OTTHUMG00000159137.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150685697,
      stop : 150693641,
      direction : "+",
      ID : "ENSG00000106560.11",
      gene_id : "ENSG00000106560.11",
      gene_type : "protein_coding",
      gene_name : "GIMAP2",
      gene_level : 2,
      hgnc_id : "HGNC:21789",
      havana_gene : "OTTHUMG00000157488.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150716606,
      stop : 150724284,
      direction : "+",
      ID : "ENSG00000213203.3",
      gene_id : "ENSG00000213203.3",
      gene_type : "protein_coding",
      gene_name : "GIMAP1",
      gene_level : 2,
      hgnc_id : "HGNC:23237",
      havana_gene : "OTTHUMG00000157489.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150716668,
      stop : 150743646,
      direction : "+",
      ID : "ENSG00000281887.3",
      gene_id : "ENSG00000281887.3",
      gene_type : "protein_coding",
      gene_name : "GIMAP1-GIMAP5",
      gene_level : 2,
      hgnc_id : "HGNC:51257",
      havana_gene : "OTTHUMG00000189885.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150722253,
      stop : 150750033,
      direction : "+",
      ID : "ENSG00000196329.12",
      gene_id : "ENSG00000196329.12",
      gene_type : "protein_coding",
      gene_name : "GIMAP5",
      gene_level : 2,
      hgnc_id : "HGNC:18005",
      havana_gene : "OTTHUMG00000157542.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150791285,
      stop : 150801360,
      direction : "-",
      ID : "ENSG00000106565.18",
      gene_id : "ENSG00000106565.18",
      gene_type : "protein_coding",
      gene_name : "TMEM176B",
      gene_level : 1,
      hgnc_id : "HGNC:29596",
      havana_gene : "OTTHUMG00000157577.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150800403,
      stop : 150805118,
      direction : "+",
      ID : "ENSG00000002933.9",
      gene_id : "ENSG00000002933.9",
      gene_type : "protein_coding",
      gene_name : "TMEM176A",
      gene_level : 2,
      hgnc_id : "HGNC:24930",
      havana_gene : "OTTHUMG00000158114.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150824627,
      stop : 150861504,
      direction : "+",
      ID : "ENSG00000002726.21",
      gene_id : "ENSG00000002726.21",
      gene_type : "protein_coding",
      gene_name : "AOC1",
      gene_level : 2,
      hgnc_id : "HGNC:80",
      havana_gene : "OTTHUMG00000158306.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150944961,
      stop : 150978321,
      direction : "-",
      ID : "ENSG00000055118.16",
      gene_id : "ENSG00000055118.16",
      gene_type : "protein_coding",
      gene_name : "KCNH2",
      gene_level : 2,
      hgnc_id : "HGNC:6251",
      havana_gene : "OTTHUMG00000158341.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 150991017,
      stop : 151014588,
      direction : "+",
      ID : "ENSG00000164867.11",
      gene_id : "ENSG00000164867.11",
      gene_type : "protein_coding",
      gene_name : "NOS3",
      gene_level : 1,
      hgnc_id : "HGNC:7876",
      havana_gene : "OTTHUMG00000158343.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151012209,
      stop : 151024499,
      direction : "-",
      ID : "ENSG00000181652.19",
      gene_id : "ENSG00000181652.19",
      gene_type : "protein_coding",
      gene_name : "ATG9B",
      gene_level : 1,
      hgnc_id : "HGNC:21899",
      havana_gene : "OTTHUMG00000158634.9",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151028422,
      stop : 151047782,
      direction : "+",
      ID : "ENSG00000197150.13",
      gene_id : "ENSG00000197150.13",
      gene_type : "protein_coding",
      gene_name : "ABCB8",
      gene_level : 1,
      hgnc_id : "HGNC:49",
      havana_gene : "OTTHUMG00000158686.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151048292,
      stop : 151052756,
      direction : "+",
      ID : "ENSG00000213199.8",
      gene_id : "ENSG00000213199.8",
      gene_type : "protein_coding",
      gene_name : "ASIC3",
      gene_level : 2,
      hgnc_id : "HGNC:101",
      havana_gene : "OTTHUMG00000158685.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151053815,
      stop : 151057897,
      direction : "-",
      ID : "ENSG00000164885.13",
      gene_id : "ENSG00000164885.13",
      gene_type : "protein_coding",
      gene_name : "CDK5",
      gene_level : 2,
      hgnc_id : "HGNC:1774",
      havana_gene : "OTTHUMG00000158414.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151057210,
      stop : 151076526,
      direction : "+",
      ID : "ENSG00000164889.15",
      gene_id : "ENSG00000164889.15",
      gene_type : "protein_coding",
      gene_name : "SLC4A2",
      gene_level : 1,
      hgnc_id : "HGNC:11028",
      havana_gene : "OTTHUMG00000158443.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151061928,
      stop : 151061978,
      direction : "+",
      ID : "ENSG00000288608.1",
      gene_id : "ENSG00000288608.1",
      gene_type : "protein_coding",
      gene_name : "AC010973.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151076593,
      stop : 151080866,
      direction : "-",
      ID : "ENSG00000164896.20",
      gene_id : "ENSG00000164896.20",
      gene_type : "protein_coding",
      gene_name : "FASTK",
      gene_level : 2,
      hgnc_id : "HGNC:24676",
      havana_gene : "OTTHUMG00000158694.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151081085,
      stop : 151083493,
      direction : "-",
      ID : "ENSG00000164897.14",
      gene_id : "ENSG00000164897.14",
      gene_type : "protein_coding",
      gene_name : "TMUB1",
      gene_level : 2,
      hgnc_id : "HGNC:21709",
      havana_gene : "OTTHUMG00000158621.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151085831,
      stop : 151144436,
      direction : "+",
      ID : "ENSG00000133612.19",
      gene_id : "ENSG00000133612.19",
      gene_type : "protein_coding",
      gene_name : "AGAP3",
      gene_level : 1,
      hgnc_id : "HGNC:16923",
      havana_gene : "OTTHUMG00000158724.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151148589,
      stop : 151174745,
      direction : "-",
      ID : "ENSG00000164900.4",
      gene_id : "ENSG00000164900.4",
      gene_type : "protein_coding",
      gene_name : "GBX1",
      gene_level : 2,
      hgnc_id : "HGNC:4185",
      havana_gene : "OTTHUMG00000158751.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151175698,
      stop : 151187832,
      direction : "-",
      ID : "ENSG00000146926.11",
      gene_id : "ENSG00000146926.11",
      gene_type : "protein_coding",
      gene_name : "ASB10",
      gene_level : 2,
      hgnc_id : "HGNC:17185",
      havana_gene : "OTTHUMG00000157013.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151190873,
      stop : 151205496,
      direction : "-",
      ID : "ENSG00000278685.4",
      gene_id : "ENSG00000278685.4",
      gene_type : "protein_coding",
      gene_name : "IQCA1L",
      gene_level : 2,
      hgnc_id : "HGNC:22831",
      havana_gene : "OTTHUMG00000156140.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151207837,
      stop : 151210378,
      direction : "-",
      ID : "ENSG00000285480.1",
      gene_id : "ENSG00000285480.1",
      gene_type : "protein_coding",
      gene_name : "H2BE1",
      gene_level : 2,
      hgnc_id : "HGNC:53833",
      havana_gene : "OTTHUMG00000192397.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151207837,
      stop : 151227166,
      direction : "-",
      ID : "ENSG00000285292.1",
      gene_id : "ENSG00000285292.1",
      gene_type : "protein_coding",
      gene_name : "ABCF2-H2BE1",
      gene_level : 2,
      hgnc_id : "HGNC:54751",
      havana_gene : "OTTHUMG00000154570.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151211484,
      stop : 151227205,
      direction : "-",
      ID : "ENSG00000033050.9",
      gene_id : "ENSG00000033050.9",
      gene_type : "protein_coding",
      gene_name : "ABCF2",
      gene_level : 2,
      hgnc_id : "HGNC:71",
      havana_gene : "OTTHUMG00000192398.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151232489,
      stop : 151238827,
      direction : "+",
      ID : "ENSG00000033100.16",
      gene_id : "ENSG00000033100.16",
      gene_type : "protein_coding",
      gene_name : "CHPF2",
      gene_level : 1,
      hgnc_id : "HGNC:29270",
      havana_gene : "OTTHUMG00000157380.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151238764,
      stop : 151277896,
      direction : "-",
      ID : "ENSG00000082014.17",
      gene_id : "ENSG00000082014.17",
      gene_type : "protein_coding",
      gene_name : "SMARCD3",
      gene_level : 2,
      hgnc_id : "HGNC:11108",
      havana_gene : "OTTHUMG00000157431.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151341772,
      stop : 151378449,
      direction : "+",
      ID : "ENSG00000013374.17",
      gene_id : "ENSG00000013374.17",
      gene_type : "protein_coding",
      gene_name : "NUB1",
      gene_level : 2,
      hgnc_id : "HGNC:17623",
      havana_gene : "OTTHUMG00000157365.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151375909,
      stop : 151410727,
      direction : "-",
      ID : "ENSG00000187260.16",
      gene_id : "ENSG00000187260.16",
      gene_type : "protein_coding",
      gene_name : "WDR86",
      gene_level : 1,
      hgnc_id : "HGNC:28020",
      havana_gene : "OTTHUMG00000150764.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151428832,
      stop : 151440813,
      direction : "-",
      ID : "ENSG00000127377.10",
      gene_id : "ENSG00000127377.10",
      gene_type : "protein_coding",
      gene_name : "CRYGN",
      gene_level : 2,
      hgnc_id : "HGNC:20458",
      havana_gene : "OTTHUMG00000157353.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151466012,
      stop : 151520120,
      direction : "-",
      ID : "ENSG00000106615.10",
      gene_id : "ENSG00000106615.10",
      gene_type : "protein_coding",
      gene_name : "RHEB",
      gene_level : 2,
      hgnc_id : "HGNC:10011",
      havana_gene : "OTTHUMG00000157330.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151556124,
      stop : 151877125,
      direction : "-",
      ID : "ENSG00000106617.15",
      gene_id : "ENSG00000106617.15",
      gene_type : "protein_coding",
      gene_name : "PRKAG2",
      gene_level : 2,
      hgnc_id : "HGNC:9386",
      havana_gene : "OTTHUMG00000157324.26",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 151956379,
      stop : 152019929,
      direction : "+",
      ID : "ENSG00000106648.14",
      gene_id : "ENSG00000106648.14",
      gene_type : "protein_coding",
      gene_name : "GALNTL5",
      gene_level : 1,
      hgnc_id : "HGNC:21725",
      havana_gene : "OTTHUMG00000157306.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 152025674,
      stop : 152122340,
      direction : "+",
      ID : "ENSG00000178234.13",
      gene_id : "ENSG00000178234.13",
      gene_type : "protein_coding",
      gene_name : "GALNT11",
      gene_level : 1,
      hgnc_id : "HGNC:19875",
      havana_gene : "OTTHUMG00000157251.15",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 152134922,
      stop : 152436641,
      direction : "-",
      ID : "ENSG00000055609.20",
      gene_id : "ENSG00000055609.20",
      gene_type : "protein_coding",
      gene_name : "KMT2C",
      gene_level : 1,
      hgnc_id : "HGNC:13726",
      havana_gene : "OTTHUMG00000150553.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 152644776,
      stop : 152676141,
      direction : "-",
      ID : "ENSG00000196584.3",
      gene_id : "ENSG00000196584.3",
      gene_type : "protein_coding",
      gene_name : "XRCC2",
      gene_level : 2,
      hgnc_id : "HGNC:12829",
      havana_gene : "OTTHUMG00000151470.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 152759749,
      stop : 152855378,
      direction : "+",
      ID : "ENSG00000133627.18",
      gene_id : "ENSG00000133627.18",
      gene_type : "protein_coding",
      gene_name : "ACTR3B",
      gene_level : 2,
      hgnc_id : "HGNC:17256",
      havana_gene : "OTTHUMG00000151463.4",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 153887097,
      stop : 154894285,
      direction : "+",
      ID : "ENSG00000130226.17",
      gene_id : "ENSG00000130226.17",
      gene_type : "protein_coding",
      gene_name : "DPP6",
      gene_level : 1,
      hgnc_id : "HGNC:3010",
      havana_gene : "OTTHUMG00000151511.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 154943687,
      stop : 155003124,
      direction : "-",
      ID : "ENSG00000157212.19",
      gene_id : "ENSG00000157212.19",
      gene_type : "protein_coding",
      gene_name : "PAXIP1",
      gene_level : 1,
      hgnc_id : "HGNC:8624",
      havana_gene : "OTTHUMG00000151322.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 155070324,
      stop : 155087392,
      direction : "+",
      ID : "ENSG00000157219.5",
      gene_id : "ENSG00000157219.5",
      gene_type : "protein_coding",
      gene_name : "HTR5A",
      gene_level : 2,
      hgnc_id : "HGNC:5300",
      havana_gene : "OTTHUMG00000151327.2",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 155297776,
      stop : 155310235,
      direction : "+",
      ID : "ENSG00000186480.13",
      gene_id : "ENSG00000186480.13",
      gene_type : "protein_coding",
      gene_name : "INSIG1",
      gene_level : 1,
      hgnc_id : "HGNC:6083",
      havana_gene : "OTTHUMG00000151330.6",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 155458129,
      stop : 155464831,
      direction : "+",
      ID : "ENSG00000164778.4",
      gene_id : "ENSG00000164778.4",
      gene_type : "protein_coding",
      gene_name : "EN2",
      gene_level : 2,
      hgnc_id : "HGNC:3343",
      havana_gene : "OTTHUMG00000151354.1",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 155474206,
      stop : 155555450,
      direction : "-",
      ID : "ENSG00000146910.12",
      gene_id : "ENSG00000146910.12",
      gene_type : "protein_coding",
      gene_name : "CNPY1",
      gene_level : 2,
      hgnc_id : "HGNC:27786",
      havana_gene : "OTTHUMG00000151353.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 155644451,
      stop : 155781485,
      direction : "+",
      ID : "ENSG00000184863.11",
      gene_id : "ENSG00000184863.11",
      gene_type : "protein_coding",
      gene_name : "RBM33",
      gene_level : 1,
      hgnc_id : "HGNC:27223",
      havana_gene : "OTTHUMG00000150260.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 155799980,
      stop : 155812463,
      direction : "-",
      ID : "ENSG00000164690.8",
      gene_id : "ENSG00000164690.8",
      gene_type : "protein_coding",
      gene_name : "SHH",
      gene_level : 2,
      hgnc_id : "HGNC:10848",
      havana_gene : "OTTHUMG00000151349.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 156640281,
      stop : 156677130,
      direction : "+",
      ID : "ENSG00000105982.17",
      gene_id : "ENSG00000105982.17",
      gene_type : "protein_coding",
      gene_name : "RNF32",
      gene_level : 2,
      hgnc_id : "HGNC:17118",
      havana_gene : "OTTHUMG00000151440.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 156668946,
      stop : 156893216,
      direction : "-",
      ID : "ENSG00000105983.22",
      gene_id : "ENSG00000105983.22",
      gene_type : "protein_coding",
      gene_name : "LMBR1",
      gene_level : 2,
      hgnc_id : "HGNC:13243",
      havana_gene : "OTTHUMG00000151510.8",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 156949712,
      stop : 156973176,
      direction : "+",
      ID : "ENSG00000146909.8",
      gene_id : "ENSG00000146909.8",
      gene_type : "protein_coding",
      gene_name : "NOM1",
      gene_level : 2,
      hgnc_id : "HGNC:13244",
      havana_gene : "OTTHUMG00000152639.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 156994051,
      stop : 157010663,
      direction : "-",
      ID : "ENSG00000130675.15",
      gene_id : "ENSG00000130675.15",
      gene_type : "protein_coding",
      gene_name : "MNX1",
      gene_level : 1,
      hgnc_id : "HGNC:4979",
      havana_gene : "OTTHUMG00000157181.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 157138916,
      stop : 157269370,
      direction : "+",
      ID : "ENSG00000009335.18",
      gene_id : "ENSG00000009335.18",
      gene_type : "protein_coding",
      gene_name : "UBE3C",
      gene_level : 2,
      hgnc_id : "HGNC:16803",
      havana_gene : "OTTHUMG00000157239.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 157335381,
      stop : 157417439,
      direction : "+",
      ID : "ENSG00000105993.15",
      gene_id : "ENSG00000105993.15",
      gene_type : "protein_coding",
      gene_name : "DNAJB6",
      gene_level : 2,
      hgnc_id : "HGNC:14888",
      havana_gene : "OTTHUMG00000157242.7",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 157539056,
      stop : 158587823,
      direction : "-",
      ID : "ENSG00000155093.19",
      gene_id : "ENSG00000155093.19",
      gene_type : "protein_coding",
      gene_name : "PTPRN2",
      gene_level : 2,
      hgnc_id : "HGNC:9677",
      havana_gene : "OTTHUMG00000152646.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 158631169,
      stop : 158704804,
      direction : "-",
      ID : "ENSG00000146918.20",
      gene_id : "ENSG00000146918.20",
      gene_type : "protein_coding",
      gene_name : "NCAPG2",
      gene_level : 2,
      hgnc_id : "HGNC:21904",
      havana_gene : "OTTHUMG00000151438.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 158730995,
      stop : 158830253,
      direction : "-",
      ID : "ENSG00000117868.17",
      gene_id : "ENSG00000117868.17",
      gene_type : "protein_coding",
      gene_name : "ESYT2",
      gene_level : 2,
      hgnc_id : "HGNC:22211",
      havana_gene : "OTTHUMG00000151436.3",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 158856558,
      stop : 158956747,
      direction : "+",
      ID : "ENSG00000126870.16",
      gene_id : "ENSG00000126870.16",
      gene_type : "protein_coding",
      gene_name : "DYNC2I1",
      gene_level : 2,
      hgnc_id : "HGNC:21862",
      havana_gene : "OTTHUMG00000151443.5",
      tag : null
    },
    {
      chromosome : 7,
      annotation : "HAVANA",
      type : "gene",
      start : 159028175,
      stop : 159144867,
      direction : "-",
      ID : "ENSG00000106018.14",
      gene_id : "ENSG00000106018.14",
      gene_type : "protein_coding",
      gene_name : "VIPR2",
      gene_level : 1,
      hgnc_id : "HGNC:12695",
      havana_gene : "OTTHUMG00000151446.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 166086,
      stop : 167024,
      direction : "-",
      ID : "ENSG00000176269.4",
      gene_id : "ENSG00000176269.4",
      gene_type : "protein_coding",
      gene_name : "OR4F21",
      gene_level : 2,
      hgnc_id : "HGNC:19583",
      havana_gene : "OTTHUMG00000163908.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 232137,
      stop : 264703,
      direction : "+",
      ID : "ENSG00000172748.14",
      gene_id : "ENSG00000172748.14",
      gene_type : "protein_coding",
      gene_name : "ZNF596",
      gene_level : 1,
      hgnc_id : "HGNC:27268",
      havana_gene : "OTTHUMG00000086931.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 406428,
      stop : 477967,
      direction : "+",
      ID : "ENSG00000147364.17",
      gene_id : "ENSG00000147364.17",
      gene_type : "protein_coding",
      gene_name : "FBXO25",
      gene_level : 2,
      hgnc_id : "HGNC:13596",
      havana_gene : "OTTHUMG00000090341.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 489803,
      stop : 545781,
      direction : "-",
      ID : "ENSG00000180190.13",
      gene_id : "ENSG00000180190.13",
      gene_type : "protein_coding",
      gene_name : "TDRP",
      gene_level : 2,
      hgnc_id : "HGNC:26951",
      havana_gene : "OTTHUMG00000163593.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 614746,
      stop : 738106,
      direction : "-",
      ID : "ENSG00000104714.14",
      gene_id : "ENSG00000104714.14",
      gene_type : "protein_coding",
      gene_name : "ERICH1",
      gene_level : 1,
      hgnc_id : "HGNC:27234",
      havana_gene : "OTTHUMG00000129163.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 737628,
      stop : 1708476,
      direction : "+",
      ID : "ENSG00000198010.13",
      gene_id : "ENSG00000198010.13",
      gene_type : "protein_coding",
      gene_name : "DLGAP2",
      gene_level : 2,
      hgnc_id : "HGNC:2906",
      havana_gene : "OTTHUMG00000163599.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 1755778,
      stop : 1801711,
      direction : "+",
      ID : "ENSG00000182372.10",
      gene_id : "ENSG00000182372.10",
      gene_type : "protein_coding",
      gene_name : "CLN8",
      gene_level : 2,
      hgnc_id : "HGNC:2079",
      havana_gene : "OTTHUMG00000090343.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 1763888,
      stop : 1958627,
      direction : "+",
      ID : "ENSG00000283239.1",
      gene_id : "ENSG00000283239.1",
      gene_type : "protein_coding",
      gene_name : "KBTBD11-OT1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000191735.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 1823926,
      stop : 1958641,
      direction : "+",
      ID : "ENSG00000104728.16",
      gene_id : "ENSG00000104728.16",
      gene_type : "protein_coding",
      gene_name : "ARHGEF10",
      gene_level : 2,
      hgnc_id : "HGNC:14103",
      havana_gene : "OTTHUMG00000163626.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 1973677,
      stop : 2006936,
      direction : "+",
      ID : "ENSG00000176595.4",
      gene_id : "ENSG00000176595.4",
      gene_type : "protein_coding",
      gene_name : "KBTBD11",
      gene_level : 2,
      hgnc_id : "HGNC:29104",
      havana_gene : "OTTHUMG00000163629.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 2045046,
      stop : 2165552,
      direction : "+",
      ID : "ENSG00000036448.10",
      gene_id : "ENSG00000036448.10",
      gene_type : "protein_coding",
      gene_name : "MYOM2",
      gene_level : 2,
      hgnc_id : "HGNC:7614",
      havana_gene : "OTTHUMG00000129175.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 2935353,
      stop : 4994972,
      direction : "-",
      ID : "ENSG00000183117.19",
      gene_id : "ENSG00000183117.19",
      gene_type : "protein_coding",
      gene_name : "CSMD1",
      gene_level : 1,
      hgnc_id : "HGNC:14026",
      havana_gene : "OTTHUMG00000163605.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6406596,
      stop : 6648508,
      direction : "+",
      ID : "ENSG00000147316.13",
      gene_id : "ENSG00000147316.13",
      gene_type : "protein_coding",
      gene_name : "MCPH1",
      gene_level : 2,
      hgnc_id : "HGNC:6954",
      havana_gene : "OTTHUMG00000163618.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6499632,
      stop : 6563409,
      direction : "-",
      ID : "ENSG00000091879.14",
      gene_id : "ENSG00000091879.14",
      gene_type : "protein_coding",
      gene_name : "ANGPT2",
      gene_level : 2,
      hgnc_id : "HGNC:485",
      havana_gene : "OTTHUMG00000090365.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6708642,
      stop : 6761503,
      direction : "+",
      ID : "ENSG00000155189.12",
      gene_id : "ENSG00000155189.12",
      gene_type : "protein_coding",
      gene_name : "AGPAT5",
      gene_level : 1,
      hgnc_id : "HGNC:20886",
      havana_gene : "OTTHUMG00000163656.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6808517,
      stop : 6835524,
      direction : "-",
      ID : "ENSG00000275591.5",
      gene_id : "ENSG00000275591.5",
      gene_type : "protein_coding",
      gene_name : "XKR5",
      gene_level : 2,
      hgnc_id : "HGNC:20782",
      havana_gene : "OTTHUMG00000153652.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6870592,
      stop : 6877936,
      direction : "-",
      ID : "ENSG00000164825.4",
      gene_id : "ENSG00000164825.4",
      gene_type : "protein_coding",
      gene_name : "DEFB1",
      gene_level : 2,
      hgnc_id : "HGNC:2766",
      havana_gene : "OTTHUMG00000090367.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6924697,
      stop : 6926076,
      direction : "-",
      ID : "ENSG00000164822.5",
      gene_id : "ENSG00000164822.5",
      gene_type : "protein_coding",
      gene_name : "DEFA6",
      gene_level : 2,
      hgnc_id : "HGNC:2765",
      havana_gene : "OTTHUMG00000149984.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6935820,
      stop : 6938306,
      direction : "-",
      ID : "ENSG00000164821.5",
      gene_id : "ENSG00000164821.5",
      gene_type : "protein_coding",
      gene_name : "DEFA4",
      gene_level : 2,
      hgnc_id : "HGNC:2763",
      havana_gene : "OTTHUMG00000090382.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6977649,
      stop : 6980080,
      direction : "-",
      ID : "ENSG00000206047.2",
      gene_id : "ENSG00000206047.2",
      gene_type : "protein_coding",
      gene_name : "DEFA1",
      gene_level : 2,
      hgnc_id : "HGNC:2761",
      havana_gene : "OTTHUMG00000154594.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 6996766,
      stop : 6999195,
      direction : "-",
      ID : "ENSG00000240247.7",
      gene_id : "ENSG00000240247.7",
      gene_type : "protein_coding",
      gene_name : "DEFA1B",
      gene_level : 2,
      hgnc_id : "HGNC:33596",
      havana_gene : "OTTHUMG00000149850.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7015869,
      stop : 7018297,
      direction : "-",
      ID : "ENSG00000239839.7",
      gene_id : "ENSG00000239839.7",
      gene_type : "protein_coding",
      gene_name : "DEFA3",
      gene_level : 2,
      hgnc_id : "HGNC:2762",
      havana_gene : "OTTHUMG00000090381.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7055304,
      stop : 7056739,
      direction : "-",
      ID : "ENSG00000164816.8",
      gene_id : "ENSG00000164816.8",
      gene_type : "protein_coding",
      gene_name : "DEFA5",
      gene_level : 2,
      hgnc_id : "HGNC:2764",
      havana_gene : "OTTHUMG00000090383.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7332387,
      stop : 7333979,
      direction : "+",
      ID : "ENSG00000230549.3",
      gene_id : "ENSG00000230549.3",
      gene_type : "protein_coding",
      gene_name : "USP17L1",
      gene_level : 2,
      hgnc_id : "HGNC:37182",
      havana_gene : "OTTHUMG00000150578.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7337115,
      stop : 7338707,
      direction : "+",
      ID : "ENSG00000236125.3",
      gene_id : "ENSG00000236125.3",
      gene_type : "protein_coding",
      gene_name : "USP17L4",
      gene_level : 2,
      hgnc_id : "HGNC:37176",
      havana_gene : "OTTHUMG00000150574.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7355517,
      stop : 7385558,
      direction : "-",
      ID : "ENSG00000215372.6",
      gene_id : "ENSG00000215372.6",
      gene_type : "protein_coding",
      gene_name : "ZNF705G",
      gene_level : 2,
      hgnc_id : "HGNC:37134",
      havana_gene : "OTTHUMG00000165384.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7414855,
      stop : 7416863,
      direction : "-",
      ID : "ENSG00000177257.3",
      gene_id : "ENSG00000177257.3",
      gene_type : "protein_coding",
      gene_name : "DEFB4B",
      gene_level : 2,
      hgnc_id : "HGNC:30193",
      havana_gene : "OTTHUMG00000143857.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7428888,
      stop : 7430348,
      direction : "-",
      ID : "ENSG00000177243.3",
      gene_id : "ENSG00000177243.3",
      gene_type : "protein_coding",
      gene_name : "DEFB103B",
      gene_level : 2,
      hgnc_id : "HGNC:31702",
      havana_gene : "OTTHUMG00000129313.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7442684,
      stop : 7463674,
      direction : "-",
      ID : "ENSG00000164871.17",
      gene_id : "ENSG00000164871.17",
      gene_type : "protein_coding",
      gene_name : "SPAG11B",
      gene_level : 2,
      hgnc_id : "HGNC:14534",
      havana_gene : "OTTHUMG00000129219.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7470308,
      stop : 7475082,
      direction : "-",
      ID : "ENSG00000177023.2",
      gene_id : "ENSG00000177023.2",
      gene_type : "protein_coding",
      gene_name : "DEFB104B",
      gene_level : 2,
      hgnc_id : "HGNC:26165",
      havana_gene : "OTTHUMG00000149986.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7482504,
      stop : 7486400,
      direction : "-",
      ID : "ENSG00000187082.2",
      gene_id : "ENSG00000187082.2",
      gene_type : "protein_coding",
      gene_name : "DEFB106B",
      gene_level : 2,
      hgnc_id : "HGNC:28879",
      havana_gene : "OTTHUMG00000129312.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7487679,
      stop : 7489593,
      direction : "+",
      ID : "ENSG00000186599.8",
      gene_id : "ENSG00000186599.8",
      gene_type : "protein_coding",
      gene_name : "DEFB105B",
      gene_level : 2,
      hgnc_id : "HGNC:29930",
      havana_gene : "OTTHUMG00000129315.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7495911,
      stop : 7509311,
      direction : "+",
      ID : "ENSG00000198129.3",
      gene_id : "ENSG00000198129.3",
      gene_type : "protein_coding",
      gene_name : "DEFB107B",
      gene_level : 2,
      hgnc_id : "HGNC:31918",
      havana_gene : "OTTHUMG00000149987.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7539628,
      stop : 7542450,
      direction : "+",
      ID : "ENSG00000255251.1",
      gene_id : "ENSG00000255251.1",
      gene_type : "protein_coding",
      gene_name : "PRR23D1",
      gene_level : 2,
      hgnc_id : "HGNC:49420",
      havana_gene : "OTTHUMG00000165386.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7556700,
      stop : 7559712,
      direction : "-",
      ID : "ENSG00000285975.1",
      gene_id : "ENSG00000285975.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A7P",
      gene_level : 2,
      hgnc_id : "HGNC:32255",
      havana_gene : "OTTHUMG00000150263.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7571995,
      stop : 7575006,
      direction : "-",
      ID : "ENSG00000285687.1",
      gene_id : "ENSG00000285687.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A22P",
      gene_level : 2,
      hgnc_id : "HGNC:32270",
      havana_gene : "OTTHUMG00000150262.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7579644,
      stop : 7582653,
      direction : "-",
      ID : "ENSG00000285765.1",
      gene_id : "ENSG00000285765.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A23P",
      gene_level : 2,
      hgnc_id : "HGNC:32271",
      havana_gene : "OTTHUMG00000150265.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7715443,
      stop : 7718453,
      direction : "+",
      ID : "ENSG00000285814.1",
      gene_id : "ENSG00000285814.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A14P",
      gene_level : 2,
      hgnc_id : "HGNC:32262",
      havana_gene : "OTTHUMG00000165390.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7723091,
      stop : 7726101,
      direction : "+",
      ID : "ENSG00000285913.1",
      gene_id : "ENSG00000285913.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A18P",
      gene_level : 2,
      hgnc_id : "HGNC:32266",
      havana_gene : "OTTHUMG00000165391.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7730739,
      stop : 7733749,
      direction : "+",
      ID : "ENSG00000285620.1",
      gene_id : "ENSG00000285620.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A16P",
      gene_level : 2,
      hgnc_id : "HGNC:32264",
      havana_gene : "OTTHUMG00000165392.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7738387,
      stop : 7741396,
      direction : "+",
      ID : "ENSG00000285937.1",
      gene_id : "ENSG00000285937.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A8P",
      gene_level : 2,
      hgnc_id : "HGNC:32256",
      havana_gene : "OTTHUMG00000165393.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7746034,
      stop : 7749044,
      direction : "+",
      ID : "ENSG00000285720.1",
      gene_id : "ENSG00000285720.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A17P",
      gene_level : 2,
      hgnc_id : "HGNC:32265",
      havana_gene : "OTTHUMG00000165394.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7753682,
      stop : 7756692,
      direction : "+",
      ID : "ENSG00000285657.1",
      gene_id : "ENSG00000285657.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A19P",
      gene_level : 2,
      hgnc_id : "HGNC:32267",
      havana_gene : "OTTHUMG00000165395.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7761330,
      stop : 7764340,
      direction : "+",
      ID : "ENSG00000285607.1",
      gene_id : "ENSG00000285607.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A9P",
      gene_level : 2,
      hgnc_id : "HGNC:32257",
      havana_gene : "OTTHUMG00000165396.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7768977,
      stop : 7771988,
      direction : "+",
      ID : "ENSG00000285950.1",
      gene_id : "ENSG00000285950.1",
      gene_type : "protein_coding",
      gene_name : "FAM90A10P",
      gene_level : 2,
      hgnc_id : "HGNC:32258",
      havana_gene : "OTTHUMG00000165397.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7778591,
      stop : 7781413,
      direction : "-",
      ID : "ENSG00000255378.1",
      gene_id : "ENSG00000255378.1",
      gene_type : "protein_coding",
      gene_name : "PRR23D2",
      gene_level : 2,
      hgnc_id : "HGNC:49396",
      havana_gene : "OTTHUMG00000165398.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7811720,
      stop : 7815716,
      direction : "-",
      ID : "ENSG00000186572.2",
      gene_id : "ENSG00000186572.2",
      gene_type : "protein_coding",
      gene_name : "DEFB107A",
      gene_level : 2,
      hgnc_id : "HGNC:18086",
      havana_gene : "OTTHUMG00000150013.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7821966,
      stop : 7823889,
      direction : "-",
      ID : "ENSG00000186562.7",
      gene_id : "ENSG00000186562.7",
      gene_type : "protein_coding",
      gene_name : "DEFB105A",
      gene_level : 2,
      hgnc_id : "HGNC:18087",
      havana_gene : "OTTHUMG00000150011.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7825139,
      stop : 7829053,
      direction : "+",
      ID : "ENSG00000186579.3",
      gene_id : "ENSG00000186579.3",
      gene_type : "protein_coding",
      gene_name : "DEFB106A",
      gene_level : 2,
      hgnc_id : "HGNC:18088",
      havana_gene : "OTTHUMG00000150012.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7836436,
      stop : 7841242,
      direction : "+",
      ID : "ENSG00000176782.3",
      gene_id : "ENSG00000176782.3",
      gene_type : "protein_coding",
      gene_name : "DEFB104A",
      gene_level : 2,
      hgnc_id : "HGNC:18115",
      havana_gene : "OTTHUMG00000150014.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7847876,
      stop : 7868867,
      direction : "+",
      ID : "ENSG00000178287.18",
      gene_id : "ENSG00000178287.18",
      gene_type : "protein_coding",
      gene_name : "SPAG11A",
      gene_level : 1,
      hgnc_id : "HGNC:33342",
      havana_gene : "OTTHUMG00000162440.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7881392,
      stop : 7882663,
      direction : "+",
      ID : "ENSG00000176797.4",
      gene_id : "ENSG00000176797.4",
      gene_type : "protein_coding",
      gene_name : "DEFB103A",
      gene_level : 2,
      hgnc_id : "HGNC:15967",
      havana_gene : "OTTHUMG00000143855.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7894677,
      stop : 7896716,
      direction : "+",
      ID : "ENSG00000171711.3",
      gene_id : "ENSG00000171711.3",
      gene_type : "protein_coding",
      gene_name : "DEFB4A",
      gene_level : 2,
      hgnc_id : "HGNC:2767",
      havana_gene : "OTTHUMG00000129314.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7926337,
      stop : 7952413,
      direction : "+",
      ID : "ENSG00000215356.4",
      gene_id : "ENSG00000215356.4",
      gene_type : "protein_coding",
      gene_name : "ZNF705B",
      gene_level : 2,
      hgnc_id : "HGNC:32284",
      havana_gene : "OTTHUMG00000165401.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7971661,
      stop : 7973253,
      direction : "-",
      ID : "ENSG00000237038.5",
      gene_id : "ENSG00000237038.5",
      gene_type : "protein_coding",
      gene_name : "USP17L8",
      gene_level : 2,
      hgnc_id : "HGNC:37181",
      havana_gene : "OTTHUMG00000165405.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 7976393,
      stop : 7977985,
      direction : "-",
      ID : "ENSG00000225327.3",
      gene_id : "ENSG00000225327.3",
      gene_type : "protein_coding",
      gene_name : "USP17L3",
      gene_level : 2,
      hgnc_id : "HGNC:37175",
      havana_gene : "OTTHUMG00000165406.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 8317736,
      stop : 8386439,
      direction : "-",
      ID : "ENSG00000275342.5",
      gene_id : "ENSG00000275342.5",
      gene_type : "protein_coding",
      gene_name : "PRAG1",
      gene_level : 2,
      hgnc_id : "HGNC:25438",
      havana_gene : "OTTHUMG00000163709.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 8701937,
      stop : 8704096,
      direction : "+",
      ID : "ENSG00000253958.2",
      gene_id : "ENSG00000253958.2",
      gene_type : "protein_coding",
      gene_name : "CLDN23",
      gene_level : 2,
      hgnc_id : "HGNC:17591",
      havana_gene : "OTTHUMG00000163674.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 8783354,
      stop : 8893630,
      direction : "-",
      ID : "ENSG00000147324.11",
      gene_id : "ENSG00000147324.11",
      gene_type : "protein_coding",
      gene_name : "MFHAS1",
      gene_level : 2,
      hgnc_id : "HGNC:16982",
      havana_gene : "OTTHUMG00000163676.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 9002147,
      stop : 9116746,
      direction : "+",
      ID : "ENSG00000104626.15",
      gene_id : "ENSG00000104626.15",
      gene_type : "protein_coding",
      gene_name : "ERI1",
      gene_level : 2,
      hgnc_id : "HGNC:23994",
      havana_gene : "OTTHUMG00000129328.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 9136255,
      stop : 9151574,
      direction : "-",
      ID : "ENSG00000173281.5",
      gene_id : "ENSG00000173281.5",
      gene_type : "protein_coding",
      gene_name : "PPP1R3B",
      gene_level : 2,
      hgnc_id : "HGNC:14942",
      havana_gene : "OTTHUMG00000129329.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 9555912,
      stop : 9782346,
      direction : "+",
      ID : "ENSG00000173273.16",
      gene_id : "ENSG00000173273.16",
      gene_type : "protein_coding",
      gene_name : "TNKS",
      gene_level : 1,
      hgnc_id : "HGNC:11941",
      havana_gene : "OTTHUMG00000090481.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10054292,
      stop : 10428891,
      direction : "+",
      ID : "ENSG00000175806.15",
      gene_id : "ENSG00000175806.15",
      gene_type : "protein_coding",
      gene_name : "MSRA",
      gene_level : 1,
      hgnc_id : "HGNC:7377",
      havana_gene : "OTTHUMG00000090517.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10482878,
      stop : 10547585,
      direction : "-",
      ID : "ENSG00000253649.5",
      gene_id : "ENSG00000253649.5",
      gene_type : "protein_coding",
      gene_name : "PRSS51",
      gene_level : 2,
      hgnc_id : "HGNC:37321",
      havana_gene : "OTTHUMG00000163805.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10525532,
      stop : 10554166,
      direction : "+",
      ID : "ENSG00000184647.11",
      gene_id : "ENSG00000184647.11",
      gene_type : "protein_coding",
      gene_name : "PRSS55",
      gene_level : 1,
      hgnc_id : "HGNC:30824",
      havana_gene : "OTTHUMG00000129345.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10606349,
      stop : 10712187,
      direction : "-",
      ID : "ENSG00000183638.6",
      gene_id : "ENSG00000183638.6",
      gene_type : "protein_coding",
      gene_name : "RP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:15946",
      havana_gene : "OTTHUMG00000163806.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10672628,
      stop : 10700590,
      direction : "+",
      ID : "ENSG00000171060.11",
      gene_id : "ENSG00000171060.11",
      gene_type : "protein_coding",
      gene_name : "C8orf74",
      gene_level : 1,
      hgnc_id : "HGNC:32296",
      havana_gene : "OTTHUMG00000163807.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10723768,
      stop : 10730511,
      direction : "-",
      ID : "ENSG00000171056.8",
      gene_id : "ENSG00000171056.8",
      gene_type : "protein_coding",
      gene_name : "SOX7",
      gene_level : 2,
      hgnc_id : "HGNC:18196",
      havana_gene : "OTTHUMG00000090585.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10725399,
      stop : 10839847,
      direction : "-",
      ID : "ENSG00000258724.1",
      gene_id : "ENSG00000258724.1",
      gene_type : "protein_coding",
      gene_name : "PINX1",
      gene_level : 2,
      hgnc_id : "HGNC:30046",
      havana_gene : "OTTHUMG00000171787.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10764961,
      stop : 10839884,
      direction : "-",
      ID : "ENSG00000254093.9",
      gene_id : "ENSG00000254093.9",
      gene_type : "protein_coding",
      gene_name : "PINX1",
      gene_level : 2,
      hgnc_id : "HGNC:30046",
      havana_gene : "OTTHUMG00000163808.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 10896045,
      stop : 11201833,
      direction : "-",
      ID : "ENSG00000171044.11",
      gene_id : "ENSG00000171044.11",
      gene_type : "protein_coding",
      gene_name : "XKR6",
      gene_level : 1,
      hgnc_id : "HGNC:27806",
      havana_gene : "OTTHUMG00000129351.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11284816,
      stop : 11328146,
      direction : "+",
      ID : "ENSG00000104643.10",
      gene_id : "ENSG00000104643.10",
      gene_type : "protein_coding",
      gene_name : "MTMR9",
      gene_level : 1,
      hgnc_id : "HGNC:14596",
      havana_gene : "OTTHUMG00000090647.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11331012,
      stop : 11332360,
      direction : "+",
      ID : "ENSG00000177710.6",
      gene_id : "ENSG00000177710.6",
      gene_type : "protein_coding",
      gene_name : "SLC35G5",
      gene_level : 2,
      hgnc_id : "HGNC:15546",
      havana_gene : "OTTHUMG00000090653.2",
      tag : "retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11421476,
      stop : 11475908,
      direction : "-",
      ID : "ENSG00000154319.16",
      gene_id : "ENSG00000154319.16",
      gene_type : "protein_coding",
      gene_name : "FAM167A",
      gene_level : 1,
      hgnc_id : "HGNC:15549",
      havana_gene : "OTTHUMG00000129361.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11486894,
      stop : 11564599,
      direction : "+",
      ID : "ENSG00000136573.14",
      gene_id : "ENSG00000136573.14",
      gene_type : "protein_coding",
      gene_name : "BLK",
      gene_level : 1,
      hgnc_id : "HGNC:1057",
      havana_gene : "OTTHUMG00000090729.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11676959,
      stop : 11760002,
      direction : "+",
      ID : "ENSG00000136574.18",
      gene_id : "ENSG00000136574.18",
      gene_type : "protein_coding",
      gene_name : "GATA4",
      gene_level : 1,
      hgnc_id : "HGNC:4173",
      havana_gene : "OTTHUMG00000090800.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11769639,
      stop : 11787345,
      direction : "+",
      ID : "ENSG00000154328.16",
      gene_id : "ENSG00000154328.16",
      gene_type : "protein_coding",
      gene_name : "NEIL2",
      gene_level : 2,
      hgnc_id : "HGNC:18956",
      havana_gene : "OTTHUMG00000090753.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11795573,
      stop : 11839304,
      direction : "+",
      ID : "ENSG00000079459.13",
      gene_id : "ENSG00000079459.13",
      gene_type : "protein_coding",
      gene_name : "FDFT1",
      gene_level : 1,
      hgnc_id : "HGNC:3629",
      havana_gene : "OTTHUMG00000090801.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11842524,
      stop : 11869533,
      direction : "-",
      ID : "ENSG00000164733.22",
      gene_id : "ENSG00000164733.22",
      gene_type : "protein_coding",
      gene_name : "CTSB",
      gene_level : 1,
      hgnc_id : "HGNC:2527",
      havana_gene : "OTTHUMG00000090799.10",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11973937,
      stop : 11974599,
      direction : "-",
      ID : "ENSG00000205884.2",
      gene_id : "ENSG00000205884.2",
      gene_type : "protein_coding",
      gene_name : "DEFB136",
      gene_level : 2,
      hgnc_id : "HGNC:34433",
      havana_gene : "OTTHUMG00000158720.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11982321,
      stop : 11984590,
      direction : "+",
      ID : "ENSG00000205883.2",
      gene_id : "ENSG00000205883.2",
      gene_type : "protein_coding",
      gene_name : "DEFB135",
      gene_level : 2,
      hgnc_id : "HGNC:32400",
      havana_gene : "OTTHUMG00000158719.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 11993174,
      stop : 11996312,
      direction : "-",
      ID : "ENSG00000205882.8",
      gene_id : "ENSG00000205882.8",
      gene_type : "protein_coding",
      gene_name : "DEFB134",
      gene_level : 2,
      hgnc_id : "HGNC:32399",
      havana_gene : "OTTHUMG00000158718.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12064389,
      stop : 12071747,
      direction : "-",
      ID : "ENSG00000233050.1",
      gene_id : "ENSG00000233050.1",
      gene_type : "protein_coding",
      gene_name : "DEFB130B",
      gene_level : 2,
      hgnc_id : "HGNC:39814",
      havana_gene : "OTTHUMG00000158721.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12104389,
      stop : 12115516,
      direction : "+",
      ID : "ENSG00000215343.7",
      gene_id : "ENSG00000215343.7",
      gene_type : "protein_coding",
      gene_name : "ZNF705D",
      gene_level : 2,
      hgnc_id : "HGNC:33202",
      havana_gene : "OTTHUMG00000165474.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12132417,
      stop : 12134099,
      direction : "-",
      ID : "ENSG00000226430.7",
      gene_id : "ENSG00000226430.7",
      gene_type : "protein_coding",
      gene_name : "USP17L7",
      gene_level : 2,
      hgnc_id : "HGNC:37180",
      havana_gene : "OTTHUMG00000165294.6",
      tag : "retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12137168,
      stop : 12139077,
      direction : "-",
      ID : "ENSG00000223443.2",
      gene_id : "ENSG00000223443.2",
      gene_type : "protein_coding",
      gene_name : "USP17L2",
      gene_level : 2,
      hgnc_id : "HGNC:34434",
      havana_gene : "OTTHUMG00000165295.4",
      tag : "retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12182096,
      stop : 12194133,
      direction : "-",
      ID : "ENSG00000186523.14",
      gene_id : "ENSG00000186523.14",
      gene_type : "protein_coding",
      gene_name : "FAM86B1",
      gene_level : 2,
      hgnc_id : "HGNC:28268",
      havana_gene : "OTTHUMG00000165298.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12310962,
      stop : 12318316,
      direction : "-",
      ID : "ENSG00000232948.1",
      gene_id : "ENSG00000232948.1",
      gene_type : "protein_coding",
      gene_name : "DEFB130A",
      gene_level : 2,
      hgnc_id : "HGNC:18107",
      havana_gene : "OTTHUMG00000158742.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12425614,
      stop : 12436343,
      direction : "-",
      ID : "ENSG00000145002.12",
      gene_id : "ENSG00000145002.12",
      gene_type : "protein_coding",
      gene_name : "FAM86B2",
      gene_level : 2,
      hgnc_id : "HGNC:32222",
      havana_gene : "OTTHUMG00000165462.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12721906,
      stop : 12756073,
      direction : "-",
      ID : "ENSG00000154359.13",
      gene_id : "ENSG00000154359.13",
      gene_type : "protein_coding",
      gene_name : "LONRF1",
      gene_level : 2,
      hgnc_id : "HGNC:26302",
      havana_gene : "OTTHUMG00000165475.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 12945642,
      stop : 13031503,
      direction : "+",
      ID : "ENSG00000250305.9",
      gene_id : "ENSG00000250305.9",
      gene_type : "protein_coding",
      gene_name : "TRMT9B",
      gene_level : 1,
      hgnc_id : "HGNC:26725",
      havana_gene : "OTTHUMG00000165477.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 13083361,
      stop : 13604610,
      direction : "-",
      ID : "ENSG00000164741.15",
      gene_id : "ENSG00000164741.15",
      gene_type : "protein_coding",
      gene_name : "DLC1",
      gene_level : 1,
      hgnc_id : "HGNC:2897",
      havana_gene : "OTTHUMG00000090825.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 13566869,
      stop : 13568288,
      direction : "+",
      ID : "ENSG00000164743.5",
      gene_id : "ENSG00000164743.5",
      gene_type : "protein_coding",
      gene_name : "C8orf48",
      gene_level : 2,
      hgnc_id : "HGNC:26345",
      havana_gene : "OTTHUMG00000165482.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 14084845,
      stop : 15238431,
      direction : "-",
      ID : "ENSG00000185053.14",
      gene_id : "ENSG00000185053.14",
      gene_type : "protein_coding",
      gene_name : "SGCZ",
      gene_level : 2,
      hgnc_id : "HGNC:14075",
      havana_gene : "OTTHUMG00000090827.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 15417215,
      stop : 15766649,
      direction : "+",
      ID : "ENSG00000104723.21",
      gene_id : "ENSG00000104723.21",
      gene_type : "protein_coding",
      gene_name : "TUSC3",
      gene_level : 2,
      hgnc_id : "HGNC:30242",
      havana_gene : "OTTHUMG00000094803.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 16107878,
      stop : 16567490,
      direction : "-",
      ID : "ENSG00000038945.15",
      gene_id : "ENSG00000038945.15",
      gene_type : "protein_coding",
      gene_name : "MSR1",
      gene_level : 1,
      hgnc_id : "HGNC:7376",
      havana_gene : "OTTHUMG00000094809.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 16992181,
      stop : 17002345,
      direction : "-",
      ID : "ENSG00000078579.9",
      gene_id : "ENSG00000078579.9",
      gene_type : "protein_coding",
      gene_name : "FGF20",
      gene_level : 2,
      hgnc_id : "HGNC:3677",
      havana_gene : "OTTHUMG00000096964.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17027238,
      stop : 17122642,
      direction : "+",
      ID : "ENSG00000155970.12",
      gene_id : "ENSG00000155970.12",
      gene_type : "protein_coding",
      gene_name : "MICU3",
      gene_level : 2,
      hgnc_id : "HGNC:27820",
      havana_gene : "OTTHUMG00000096965.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17156482,
      stop : 17224799,
      direction : "+",
      ID : "ENSG00000104219.13",
      gene_id : "ENSG00000104219.13",
      gene_type : "protein_coding",
      gene_name : "ZDHHC2",
      gene_level : 2,
      hgnc_id : "HGNC:18469",
      havana_gene : "OTTHUMG00000163860.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17224966,
      stop : 17246878,
      direction : "-",
      ID : "ENSG00000198791.12",
      gene_id : "ENSG00000198791.12",
      gene_type : "protein_coding",
      gene_name : "CNOT7",
      gene_level : 1,
      hgnc_id : "HGNC:14101",
      havana_gene : "OTTHUMG00000096971.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17246931,
      stop : 17302427,
      direction : "+",
      ID : "ENSG00000155975.10",
      gene_id : "ENSG00000155975.10",
      gene_type : "protein_coding",
      gene_name : "VPS37A",
      gene_level : 1,
      hgnc_id : "HGNC:24928",
      havana_gene : "OTTHUMG00000130785.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17296794,
      stop : 17413528,
      direction : "-",
      ID : "ENSG00000003987.14",
      gene_id : "ENSG00000003987.14",
      gene_type : "protein_coding",
      gene_name : "MTMR7",
      gene_level : 2,
      hgnc_id : "HGNC:7454",
      havana_gene : "OTTHUMG00000163771.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17497088,
      stop : 17570573,
      direction : "+",
      ID : "ENSG00000003989.18",
      gene_id : "ENSG00000003989.18",
      gene_type : "protein_coding",
      gene_name : "SLC7A2",
      gene_level : 2,
      hgnc_id : "HGNC:11060",
      havana_gene : "OTTHUMG00000130819.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17576433,
      stop : 17644071,
      direction : "+",
      ID : "ENSG00000104213.13",
      gene_id : "ENSG00000104213.13",
      gene_type : "protein_coding",
      gene_name : "PDGFRL",
      gene_level : 1,
      hgnc_id : "HGNC:8805",
      havana_gene : "OTTHUMG00000130818.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17643795,
      stop : 17800917,
      direction : "-",
      ID : "ENSG00000129422.14",
      gene_id : "ENSG00000129422.14",
      gene_type : "protein_coding",
      gene_name : "MTUS1",
      gene_level : 1,
      hgnc_id : "HGNC:29789",
      havana_gene : "OTTHUMG00000163756.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17864380,
      stop : 17910365,
      direction : "-",
      ID : "ENSG00000104760.17",
      gene_id : "ENSG00000104760.17",
      gene_type : "protein_coding",
      gene_name : "FGL1",
      gene_level : 1,
      hgnc_id : "HGNC:3695",
      havana_gene : "OTTHUMG00000096989.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 17922840,
      stop : 18027975,
      direction : "+",
      ID : "ENSG00000078674.18",
      gene_id : "ENSG00000078674.18",
      gene_type : "protein_coding",
      gene_name : "PCM1",
      gene_level : 1,
      hgnc_id : "HGNC:8727",
      havana_gene : "OTTHUMG00000163699.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 18055992,
      stop : 18084998,
      direction : "-",
      ID : "ENSG00000104763.20",
      gene_id : "ENSG00000104763.20",
      gene_type : "protein_coding",
      gene_name : "ASAH1",
      gene_level : 2,
      hgnc_id : "HGNC:735",
      havana_gene : "OTTHUMG00000096997.20",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 18170477,
      stop : 18223689,
      direction : "+",
      ID : "ENSG00000171428.15",
      gene_id : "ENSG00000171428.15",
      gene_type : "protein_coding",
      gene_name : "NAT1",
      gene_level : 2,
      hgnc_id : "HGNC:7645",
      havana_gene : "OTTHUMG00000097001.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 18391282,
      stop : 18401218,
      direction : "+",
      ID : "ENSG00000156006.5",
      gene_id : "ENSG00000156006.5",
      gene_type : "protein_coding",
      gene_name : "NAT2",
      gene_level : 2,
      hgnc_id : "HGNC:7646",
      havana_gene : "OTTHUMG00000130826.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 18527303,
      stop : 19084730,
      direction : "-",
      ID : "ENSG00000156011.17",
      gene_id : "ENSG00000156011.17",
      gene_type : "protein_coding",
      gene_name : "PSD3",
      gene_level : 2,
      hgnc_id : "HGNC:19093",
      havana_gene : "OTTHUMG00000163711.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 19313693,
      stop : 19396218,
      direction : "+",
      ID : "ENSG00000104611.12",
      gene_id : "ENSG00000104611.12",
      gene_type : "protein_coding",
      gene_name : "SH2D4A",
      gene_level : 1,
      hgnc_id : "HGNC:26102",
      havana_gene : "OTTHUMG00000097005.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 19404161,
      stop : 19758029,
      direction : "-",
      ID : "ENSG00000147408.14",
      gene_id : "ENSG00000147408.14",
      gene_type : "protein_coding",
      gene_name : "CSGALNACT1",
      gene_level : 1,
      hgnc_id : "HGNC:24290",
      havana_gene : "OTTHUMG00000130827.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 19817391,
      stop : 19852083,
      direction : "+",
      ID : "ENSG00000104613.12",
      gene_id : "ENSG00000104613.12",
      gene_type : "protein_coding",
      gene_name : "INTS10",
      gene_level : 1,
      hgnc_id : "HGNC:25548",
      havana_gene : "OTTHUMG00000131065.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 19901717,
      stop : 19967259,
      direction : "+",
      ID : "ENSG00000175445.17",
      gene_id : "ENSG00000175445.17",
      gene_type : "protein_coding",
      gene_name : "LPL",
      gene_level : 2,
      hgnc_id : "HGNC:6677",
      havana_gene : "OTTHUMG00000036645.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 20144855,
      stop : 20183206,
      direction : "-",
      ID : "ENSG00000036565.15",
      gene_id : "ENSG00000036565.15",
      gene_type : "protein_coding",
      gene_name : "SLC18A1",
      gene_level : 2,
      hgnc_id : "HGNC:10934",
      havana_gene : "OTTHUMG00000097017.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 20197381,
      stop : 20226819,
      direction : "+",
      ID : "ENSG00000147416.11",
      gene_id : "ENSG00000147416.11",
      gene_type : "protein_coding",
      gene_name : "ATP6V1B2",
      gene_level : 2,
      hgnc_id : "HGNC:854",
      havana_gene : "OTTHUMG00000131073.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 20246165,
      stop : 20303963,
      direction : "-",
      ID : "ENSG00000061337.15",
      gene_id : "ENSG00000061337.15",
      gene_type : "protein_coding",
      gene_name : "LZTS1",
      gene_level : 2,
      hgnc_id : "HGNC:13861",
      havana_gene : "OTTHUMG00000097027.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 21690398,
      stop : 21812357,
      direction : "-",
      ID : "ENSG00000168546.11",
      gene_id : "ENSG00000168546.11",
      gene_type : "protein_coding",
      gene_name : "GFRA2",
      gene_level : 1,
      hgnc_id : "HGNC:4244",
      havana_gene : "OTTHUMG00000163897.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 21908873,
      stop : 21913690,
      direction : "-",
      ID : "ENSG00000147443.13",
      gene_id : "ENSG00000147443.13",
      gene_type : "protein_coding",
      gene_name : "DOK2",
      gene_level : 1,
      hgnc_id : "HGNC:2991",
      havana_gene : "OTTHUMG00000131075.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 21919662,
      stop : 22006585,
      direction : "+",
      ID : "ENSG00000130227.17",
      gene_id : "ENSG00000130227.17",
      gene_type : "protein_coding",
      gene_name : "XPO7",
      gene_level : 2,
      hgnc_id : "HGNC:14108",
      havana_gene : "OTTHUMG00000163789.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22024125,
      stop : 22036897,
      direction : "+",
      ID : "ENSG00000158806.14",
      gene_id : "ENSG00000158806.14",
      gene_type : "protein_coding",
      gene_name : "NPM2",
      gene_level : 2,
      hgnc_id : "HGNC:7930",
      havana_gene : "OTTHUMG00000131129.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22042398,
      stop : 22048809,
      direction : "+",
      ID : "ENSG00000158815.11",
      gene_id : "ENSG00000158815.11",
      gene_type : "protein_coding",
      gene_name : "FGF17",
      gene_level : 1,
      hgnc_id : "HGNC:3673",
      havana_gene : "OTTHUMG00000097051.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22048995,
      stop : 22082527,
      direction : "+",
      ID : "ENSG00000158856.18",
      gene_id : "ENSG00000158856.18",
      gene_type : "protein_coding",
      gene_name : "DMTN",
      gene_level : 1,
      hgnc_id : "HGNC:3382",
      havana_gene : "OTTHUMG00000097087.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22089150,
      stop : 22104911,
      direction : "+",
      ID : "ENSG00000158863.22",
      gene_id : "ENSG00000158863.22",
      gene_type : "protein_coding",
      gene_name : "FAM160B2",
      gene_level : 2,
      hgnc_id : "HGNC:16492",
      havana_gene : "OTTHUMG00000097088.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22106874,
      stop : 22109419,
      direction : "-",
      ID : "ENSG00000275074.2",
      gene_id : "ENSG00000275074.2",
      gene_type : "protein_coding",
      gene_name : "NUDT18",
      gene_level : 2,
      hgnc_id : "HGNC:26194",
      havana_gene : "OTTHUMG00000163774.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22114419,
      stop : 22133384,
      direction : "-",
      ID : "ENSG00000168453.16",
      gene_id : "ENSG00000168453.16",
      gene_type : "protein_coding",
      gene_name : "HR",
      gene_level : 2,
      hgnc_id : "HGNC:5172",
      havana_gene : "OTTHUMG00000097089.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22130604,
      stop : 22130708,
      direction : "-",
      ID : "ENSG00000288677.1",
      gene_id : "ENSG00000288677.1",
      gene_type : "protein_coding",
      gene_name : "AC105206.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22138020,
      stop : 22141951,
      direction : "-",
      ID : "ENSG00000168476.12",
      gene_id : "ENSG00000168476.12",
      gene_type : "protein_coding",
      gene_name : "REEP4",
      gene_level : 1,
      hgnc_id : "HGNC:26176",
      havana_gene : "OTTHUMG00000131491.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22146830,
      stop : 22157084,
      direction : "-",
      ID : "ENSG00000168481.9",
      gene_id : "ENSG00000168481.9",
      gene_type : "protein_coding",
      gene_name : "LGI3",
      gene_level : 2,
      hgnc_id : "HGNC:18711",
      havana_gene : "OTTHUMG00000131599.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22156913,
      stop : 22164479,
      direction : "+",
      ID : "ENSG00000168484.13",
      gene_id : "ENSG00000168484.13",
      gene_type : "protein_coding",
      gene_name : "SFTPC",
      gene_level : 1,
      hgnc_id : "HGNC:10802",
      havana_gene : "OTTHUMG00000163775.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22165140,
      stop : 22212326,
      direction : "+",
      ID : "ENSG00000168487.20",
      gene_id : "ENSG00000168487.20",
      gene_type : "protein_coding",
      gene_name : "BMP1",
      gene_level : 2,
      hgnc_id : "HGNC:1067",
      havana_gene : "OTTHUMG00000097761.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22219703,
      stop : 22232101,
      direction : "-",
      ID : "ENSG00000168490.14",
      gene_id : "ENSG00000168490.14",
      gene_type : "protein_coding",
      gene_name : "PHYHIP",
      gene_level : 1,
      hgnc_id : "HGNC:16865",
      havana_gene : "OTTHUMG00000163776.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22245133,
      stop : 22254601,
      direction : "+",
      ID : "ENSG00000168495.13",
      gene_id : "ENSG00000168495.13",
      gene_type : "protein_coding",
      gene_name : "POLR3D",
      gene_level : 2,
      hgnc_id : "HGNC:1080",
      havana_gene : "OTTHUMG00000163778.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22275316,
      stop : 22357568,
      direction : "+",
      ID : "ENSG00000197181.12",
      gene_id : "ENSG00000197181.12",
      gene_type : "protein_coding",
      gene_name : "PIWIL2",
      gene_level : 1,
      hgnc_id : "HGNC:17644",
      havana_gene : "OTTHUMG00000097767.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22367278,
      stop : 22434129,
      direction : "+",
      ID : "ENSG00000104635.15",
      gene_id : "ENSG00000104635.15",
      gene_type : "protein_coding",
      gene_name : "SLC39A14",
      gene_level : 1,
      hgnc_id : "HGNC:20858",
      havana_gene : "OTTHUMG00000097791.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22440819,
      stop : 22541142,
      direction : "+",
      ID : "ENSG00000120910.15",
      gene_id : "ENSG00000120910.15",
      gene_type : "protein_coding",
      gene_name : "PPP3CC",
      gene_level : 1,
      hgnc_id : "HGNC:9316",
      havana_gene : "OTTHUMG00000163802.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22544986,
      stop : 22575788,
      direction : "+",
      ID : "ENSG00000120896.13",
      gene_id : "ENSG00000120896.13",
      gene_type : "protein_coding",
      gene_name : "SORBS3",
      gene_level : 2,
      hgnc_id : "HGNC:30907",
      havana_gene : "OTTHUMG00000131728.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22578279,
      stop : 22598025,
      direction : "+",
      ID : "ENSG00000120913.23",
      gene_id : "ENSG00000120913.23",
      gene_type : "protein_coding",
      gene_name : "PDLIM2",
      gene_level : 2,
      hgnc_id : "HGNC:13992",
      havana_gene : "OTTHUMG00000164270.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22589274,
      stop : 22602084,
      direction : "+",
      ID : "ENSG00000248235.6",
      gene_id : "ENSG00000248235.6",
      gene_type : "protein_coding",
      gene_name : "AC037459.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000131729.12",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22599599,
      stop : 22604150,
      direction : "+",
      ID : "ENSG00000241852.10",
      gene_id : "ENSG00000241852.10",
      gene_type : "protein_coding",
      gene_name : "C8orf58",
      gene_level : 1,
      hgnc_id : "HGNC:32233",
      havana_gene : "OTTHUMG00000154160.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22604632,
      stop : 22621514,
      direction : "+",
      ID : "ENSG00000158941.16",
      gene_id : "ENSG00000158941.16",
      gene_type : "protein_coding",
      gene_name : "CCAR2",
      gene_level : 2,
      hgnc_id : "HGNC:23360",
      havana_gene : "OTTHUMG00000162249.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22620418,
      stop : 22669148,
      direction : "-",
      ID : "ENSG00000147439.13",
      gene_id : "ENSG00000147439.13",
      gene_type : "protein_coding",
      gene_name : "BIN3",
      gene_level : 2,
      hgnc_id : "HGNC:1054",
      havana_gene : "OTTHUMG00000163844.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22687659,
      stop : 22693480,
      direction : "-",
      ID : "ENSG00000179388.9",
      gene_id : "ENSG00000179388.9",
      gene_type : "protein_coding",
      gene_name : "EGR3",
      gene_level : 1,
      hgnc_id : "HGNC:3240",
      havana_gene : "OTTHUMG00000097825.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22713251,
      stop : 23000000,
      direction : "-",
      ID : "ENSG00000134020.8",
      gene_id : "ENSG00000134020.8",
      gene_type : "protein_coding",
      gene_name : "PEBP4",
      gene_level : 2,
      hgnc_id : "HGNC:28319",
      havana_gene : "OTTHUMG00000163749.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 22987417,
      stop : 23020199,
      direction : "+",
      ID : "ENSG00000008853.17",
      gene_id : "ENSG00000008853.17",
      gene_type : "protein_coding",
      gene_name : "RHOBTB2",
      gene_level : 1,
      hgnc_id : "HGNC:18756",
      havana_gene : "OTTHUMG00000097827.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23020133,
      stop : 23069031,
      direction : "-",
      ID : "ENSG00000120889.13",
      gene_id : "ENSG00000120889.13",
      gene_type : "protein_coding",
      gene_name : "TNFRSF10B",
      gene_level : 2,
      hgnc_id : "HGNC:11905",
      havana_gene : "OTTHUMG00000097826.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23084403,
      stop : 23115536,
      direction : "+",
      ID : "ENSG00000284956.1",
      gene_id : "ENSG00000284956.1",
      gene_type : "protein_coding",
      gene_name : "AC107959.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192450.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23102921,
      stop : 23117445,
      direction : "+",
      ID : "ENSG00000173535.15",
      gene_id : "ENSG00000173535.15",
      gene_type : "protein_coding",
      gene_name : "TNFRSF10C",
      gene_level : 2,
      hgnc_id : "HGNC:11906",
      havana_gene : "OTTHUMG00000097844.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23135588,
      stop : 23164027,
      direction : "-",
      ID : "ENSG00000173530.6",
      gene_id : "ENSG00000173530.6",
      gene_type : "protein_coding",
      gene_name : "TNFRSF10D",
      gene_level : 2,
      hgnc_id : "HGNC:11907",
      havana_gene : "OTTHUMG00000097845.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23190452,
      stop : 23225102,
      direction : "-",
      ID : "ENSG00000104689.10",
      gene_id : "ENSG00000104689.10",
      gene_type : "protein_coding",
      gene_name : "TNFRSF10A",
      gene_level : 2,
      hgnc_id : "HGNC:11904",
      havana_gene : "OTTHUMG00000097843.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23243637,
      stop : 23262000,
      direction : "+",
      ID : "ENSG00000147457.14",
      gene_id : "ENSG00000147457.14",
      gene_type : "protein_coding",
      gene_name : "CHMP7",
      gene_level : 1,
      hgnc_id : "HGNC:28439",
      havana_gene : "OTTHUMG00000131785.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23270120,
      stop : 23296279,
      direction : "+",
      ID : "ENSG00000104679.12",
      gene_id : "ENSG00000104679.12",
      gene_type : "protein_coding",
      gene_name : "R3HCC1",
      gene_level : 1,
      hgnc_id : "HGNC:27329",
      havana_gene : "OTTHUMG00000163786.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23296897,
      stop : 23425328,
      direction : "-",
      ID : "ENSG00000134013.16",
      gene_id : "ENSG00000134013.16",
      gene_type : "protein_coding",
      gene_name : "LOXL2",
      gene_level : 1,
      hgnc_id : "HGNC:6666",
      havana_gene : "OTTHUMG00000163797.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23385783,
      stop : 23457695,
      direction : "-",
      ID : "ENSG00000197217.13",
      gene_id : "ENSG00000197217.13",
      gene_type : "protein_coding",
      gene_name : "ENTPD4",
      gene_level : 1,
      hgnc_id : "HGNC:14573",
      havana_gene : "OTTHUMG00000097852.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23528956,
      stop : 23575463,
      direction : "+",
      ID : "ENSG00000147454.14",
      gene_id : "ENSG00000147454.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A37",
      gene_level : 1,
      hgnc_id : "HGNC:29786",
      havana_gene : "OTTHUMG00000163865.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23678697,
      stop : 23682938,
      direction : "-",
      ID : "ENSG00000167034.10",
      gene_id : "ENSG00000167034.10",
      gene_type : "protein_coding",
      gene_name : "NKX3-1",
      gene_level : 2,
      hgnc_id : "HGNC:7838",
      havana_gene : "OTTHUMG00000097851.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23701740,
      stop : 23706756,
      direction : "-",
      ID : "ENSG00000180053.8",
      gene_id : "ENSG00000180053.8",
      gene_type : "protein_coding",
      gene_name : "NKX2-6",
      gene_level : 2,
      hgnc_id : "HGNC:32940",
      havana_gene : "OTTHUMG00000163867.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 23841929,
      stop : 23854806,
      direction : "-",
      ID : "ENSG00000159167.12",
      gene_id : "ENSG00000159167.12",
      gene_type : "protein_coding",
      gene_name : "STC1",
      gene_level : 1,
      hgnc_id : "HGNC:11373",
      havana_gene : "OTTHUMG00000097853.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 24294069,
      stop : 24359014,
      direction : "+",
      ID : "ENSG00000042980.13",
      gene_id : "ENSG00000042980.13",
      gene_type : "protein_coding",
      gene_name : "ADAM28",
      gene_level : 1,
      hgnc_id : "HGNC:206",
      havana_gene : "OTTHUMG00000163780.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 24384285,
      stop : 24406013,
      direction : "+",
      ID : "ENSG00000134028.14",
      gene_id : "ENSG00000134028.14",
      gene_type : "protein_coding",
      gene_name : "ADAMDEC1",
      gene_level : 2,
      hgnc_id : "HGNC:16299",
      havana_gene : "OTTHUMG00000097858.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 24440930,
      stop : 24526970,
      direction : "+",
      ID : "ENSG00000069206.15",
      gene_id : "ENSG00000069206.15",
      gene_type : "protein_coding",
      gene_name : "ADAM7",
      gene_level : 1,
      hgnc_id : "HGNC:214",
      havana_gene : "OTTHUMG00000097859.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 24913758,
      stop : 24919098,
      direction : "+",
      ID : "ENSG00000104722.14",
      gene_id : "ENSG00000104722.14",
      gene_type : "protein_coding",
      gene_name : "NEFM",
      gene_level : 1,
      hgnc_id : "HGNC:7734",
      havana_gene : "OTTHUMG00000131990.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 24950955,
      stop : 24956721,
      direction : "-",
      ID : "ENSG00000277586.4",
      gene_id : "ENSG00000277586.4",
      gene_type : "protein_coding",
      gene_name : "NEFL",
      gene_level : 2,
      hgnc_id : "HGNC:7739",
      havana_gene : "OTTHUMG00000134284.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 25184689,
      stop : 25418082,
      direction : "+",
      ID : "ENSG00000147459.18",
      gene_id : "ENSG00000147459.18",
      gene_type : "protein_coding",
      gene_name : "DOCK5",
      gene_level : 1,
      hgnc_id : "HGNC:23476",
      havana_gene : "OTTHUMG00000131991.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 25419258,
      stop : 25424654,
      direction : "-",
      ID : "ENSG00000147437.10",
      gene_id : "ENSG00000147437.10",
      gene_type : "protein_coding",
      gene_name : "GNRH1",
      gene_level : 2,
      hgnc_id : "HGNC:4419",
      havana_gene : "OTTHUMG00000163852.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 25427847,
      stop : 25458476,
      direction : "-",
      ID : "ENSG00000104756.16",
      gene_id : "ENSG00000104756.16",
      gene_type : "protein_coding",
      gene_name : "KCTD9",
      gene_level : 2,
      hgnc_id : "HGNC:22401",
      havana_gene : "OTTHUMG00000099428.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 25459199,
      stop : 25507911,
      direction : "+",
      ID : "ENSG00000184661.14",
      gene_id : "ENSG00000184661.14",
      gene_type : "protein_coding",
      gene_name : "CDCA2",
      gene_level : 1,
      hgnc_id : "HGNC:14623",
      havana_gene : "OTTHUMG00000099429.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 25841725,
      stop : 26045413,
      direction : "-",
      ID : "ENSG00000221818.9",
      gene_id : "ENSG00000221818.9",
      gene_type : "protein_coding",
      gene_name : "EBF2",
      gene_level : 2,
      hgnc_id : "HGNC:19090",
      havana_gene : "OTTHUMG00000163838.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 26291508,
      stop : 26372680,
      direction : "+",
      ID : "ENSG00000221914.11",
      gene_id : "ENSG00000221914.11",
      gene_type : "protein_coding",
      gene_name : "PPP2R2A",
      gene_level : 2,
      hgnc_id : "HGNC:9304",
      havana_gene : "OTTHUMG00000163850.17",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 26383054,
      stop : 26505636,
      direction : "+",
      ID : "ENSG00000104765.16",
      gene_id : "ENSG00000104765.16",
      gene_type : "protein_coding",
      gene_name : "BNIP3L",
      gene_level : 1,
      hgnc_id : "HGNC:1085",
      havana_gene : "OTTHUMG00000099433.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 26504701,
      stop : 26514092,
      direction : "-",
      ID : "ENSG00000240694.9",
      gene_id : "ENSG00000240694.9",
      gene_type : "protein_coding",
      gene_name : "PNMA2",
      gene_level : 2,
      hgnc_id : "HGNC:9159",
      havana_gene : "OTTHUMG00000163816.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 26514031,
      stop : 26658178,
      direction : "+",
      ID : "ENSG00000092964.18",
      gene_id : "ENSG00000092964.18",
      gene_type : "protein_coding",
      gene_name : "DPYSL2",
      gene_level : 1,
      hgnc_id : "HGNC:3014",
      havana_gene : "OTTHUMG00000099439.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 26748150,
      stop : 26867278,
      direction : "-",
      ID : "ENSG00000120907.18",
      gene_id : "ENSG00000120907.18",
      gene_type : "protein_coding",
      gene_name : "ADRA1A",
      gene_level : 1,
      hgnc_id : "HGNC:277",
      havana_gene : "OTTHUMG00000099459.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27235323,
      stop : 27258420,
      direction : "-",
      ID : "ENSG00000015592.16",
      gene_id : "ENSG00000015592.16",
      gene_type : "protein_coding",
      gene_name : "STMN4",
      gene_level : 2,
      hgnc_id : "HGNC:16078",
      havana_gene : "OTTHUMG00000099461.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27284886,
      stop : 27311272,
      direction : "-",
      ID : "ENSG00000104228.13",
      gene_id : "ENSG00000104228.13",
      gene_type : "protein_coding",
      gene_name : "TRIM35",
      gene_level : 1,
      hgnc_id : "HGNC:16285",
      havana_gene : "OTTHUMG00000102047.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27311482,
      stop : 27459391,
      direction : "+",
      ID : "ENSG00000120899.18",
      gene_id : "ENSG00000120899.18",
      gene_type : "protein_coding",
      gene_name : "PTK2B",
      gene_level : 1,
      hgnc_id : "HGNC:9612",
      havana_gene : "OTTHUMG00000102082.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27459756,
      stop : 27479883,
      direction : "-",
      ID : "ENSG00000120903.13",
      gene_id : "ENSG00000120903.13",
      gene_type : "protein_coding",
      gene_name : "CHRNA2",
      gene_level : 2,
      hgnc_id : "HGNC:1956",
      havana_gene : "OTTHUMG00000102083.11",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27490781,
      stop : 27545564,
      direction : "+",
      ID : "ENSG00000120915.14",
      gene_id : "ENSG00000120915.14",
      gene_type : "protein_coding",
      gene_name : "EPHX2",
      gene_level : 1,
      hgnc_id : "HGNC:3402",
      havana_gene : "OTTHUMG00000102115.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27596917,
      stop : 27614700,
      direction : "-",
      ID : "ENSG00000120885.22",
      gene_id : "ENSG00000120885.22",
      gene_type : "protein_coding",
      gene_name : "CLU",
      gene_level : 1,
      hgnc_id : "HGNC:2095",
      havana_gene : "OTTHUMG00000102114.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27633868,
      stop : 27676776,
      direction : "+",
      ID : "ENSG00000168077.14",
      gene_id : "ENSG00000168077.14",
      gene_type : "protein_coding",
      gene_name : "SCARA3",
      gene_level : 2,
      hgnc_id : "HGNC:19000",
      havana_gene : "OTTHUMG00000163898.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27733316,
      stop : 27772653,
      direction : "-",
      ID : "ENSG00000147419.19",
      gene_id : "ENSG00000147419.19",
      gene_type : "protein_coding",
      gene_name : "CCDC25",
      gene_level : 2,
      hgnc_id : "HGNC:25591",
      havana_gene : "OTTHUMG00000132173.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27771949,
      stop : 27812640,
      direction : "+",
      ID : "ENSG00000171320.15",
      gene_id : "ENSG00000171320.15",
      gene_type : "protein_coding",
      gene_name : "ESCO2",
      gene_level : 2,
      hgnc_id : "HGNC:27230",
      havana_gene : "OTTHUMG00000163901.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27809624,
      stop : 27838082,
      direction : "-",
      ID : "ENSG00000168078.10",
      gene_id : "ENSG00000168078.10",
      gene_type : "protein_coding",
      gene_name : "PBK",
      gene_level : 1,
      hgnc_id : "HGNC:18282",
      havana_gene : "OTTHUMG00000102113.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 27869883,
      stop : 27992673,
      direction : "-",
      ID : "ENSG00000168079.17",
      gene_id : "ENSG00000168079.17",
      gene_type : "protein_coding",
      gene_name : "SCARA5",
      gene_level : 2,
      hgnc_id : "HGNC:28701",
      havana_gene : "OTTHUMG00000132172.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28021964,
      stop : 28083936,
      direction : "-",
      ID : "ENSG00000189233.12",
      gene_id : "ENSG00000189233.12",
      gene_type : "protein_coding",
      gene_name : "NUGGC",
      gene_level : 2,
      hgnc_id : "HGNC:33550",
      havana_gene : "OTTHUMG00000155970.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28089673,
      stop : 28191156,
      direction : "+",
      ID : "ENSG00000134014.17",
      gene_id : "ENSG00000134014.17",
      gene_type : "protein_coding",
      gene_name : "ELP3",
      gene_level : 1,
      hgnc_id : "HGNC:20696",
      havana_gene : "OTTHUMG00000102124.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28316986,
      stop : 28343355,
      direction : "+",
      ID : "ENSG00000168081.9",
      gene_id : "ENSG00000168081.9",
      gene_type : "protein_coding",
      gene_name : "PNOC",
      gene_level : 2,
      hgnc_id : "HGNC:9163",
      havana_gene : "OTTHUMG00000102125.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28345590,
      stop : 28402701,
      direction : "-",
      ID : "ENSG00000186918.14",
      gene_id : "ENSG00000186918.14",
      gene_type : "protein_coding",
      gene_name : "ZNF395",
      gene_level : 2,
      hgnc_id : "HGNC:18737",
      havana_gene : "OTTHUMG00000102137.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28348287,
      stop : 28490278,
      direction : "-",
      ID : "ENSG00000214050.8",
      gene_id : "ENSG00000214050.8",
      gene_type : "protein_coding",
      gene_name : "FBXO16",
      gene_level : 1,
      hgnc_id : "HGNC:13618",
      havana_gene : "OTTHUMG00000102147.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28494205,
      stop : 28574267,
      direction : "+",
      ID : "ENSG00000104290.11",
      gene_id : "ENSG00000104290.11",
      gene_type : "protein_coding",
      gene_name : "FZD3",
      gene_level : 2,
      hgnc_id : "HGNC:4041",
      havana_gene : "OTTHUMG00000102145.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28600469,
      stop : 28755599,
      direction : "+",
      ID : "ENSG00000012232.9",
      gene_id : "ENSG00000012232.9",
      gene_type : "protein_coding",
      gene_name : "EXTL3",
      gene_level : 1,
      hgnc_id : "HGNC:3518",
      havana_gene : "OTTHUMG00000102146.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28767661,
      stop : 28890242,
      direction : "-",
      ID : "ENSG00000104299.15",
      gene_id : "ENSG00000104299.15",
      gene_type : "protein_coding",
      gene_name : "INTS9",
      gene_level : 1,
      hgnc_id : "HGNC:25592",
      havana_gene : "OTTHUMG00000164030.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 28890395,
      stop : 29064764,
      direction : "+",
      ID : "ENSG00000147421.18",
      gene_id : "ENSG00000147421.18",
      gene_type : "protein_coding",
      gene_name : "HMBOX1",
      gene_level : 1,
      hgnc_id : "HGNC:26137",
      havana_gene : "OTTHUMG00000172138.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 29067278,
      stop : 29263124,
      direction : "-",
      ID : "ENSG00000197892.13",
      gene_id : "ENSG00000197892.13",
      gene_type : "protein_coding",
      gene_name : "KIF13B",
      gene_level : 2,
      hgnc_id : "HGNC:14405",
      havana_gene : "OTTHUMG00000164032.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 29333064,
      stop : 29350684,
      direction : "-",
      ID : "ENSG00000120875.9",
      gene_id : "ENSG00000120875.9",
      gene_type : "protein_coding",
      gene_name : "DUSP4",
      gene_level : 1,
      hgnc_id : "HGNC:3070",
      havana_gene : "OTTHUMG00000133395.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30063003,
      stop : 30083208,
      direction : "-",
      ID : "ENSG00000133872.14",
      gene_id : "ENSG00000133872.14",
      gene_type : "protein_coding",
      gene_name : "SARAF",
      gene_level : 1,
      hgnc_id : "HGNC:28789",
      havana_gene : "OTTHUMG00000133397.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30095408,
      stop : 30177208,
      direction : "+",
      ID : "ENSG00000104660.19",
      gene_id : "ENSG00000104660.19",
      gene_type : "protein_coding",
      gene_name : "LEPROTL1",
      gene_level : 1,
      hgnc_id : "HGNC:6555",
      havana_gene : "OTTHUMG00000163820.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30131671,
      stop : 30144665,
      direction : "-",
      ID : "ENSG00000177669.4",
      gene_id : "ENSG00000177669.4",
      gene_type : "protein_coding",
      gene_name : "MBOAT4",
      gene_level : 2,
      hgnc_id : "HGNC:32311",
      havana_gene : "OTTHUMG00000163824.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30156319,
      stop : 30183639,
      direction : "+",
      ID : "ENSG00000104671.8",
      gene_id : "ENSG00000104671.8",
      gene_type : "protein_coding",
      gene_name : "DCTN6",
      gene_level : 2,
      hgnc_id : "HGNC:16964",
      havana_gene : "OTTHUMG00000163828.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30384511,
      stop : 30572256,
      direction : "+",
      ID : "ENSG00000157110.16",
      gene_id : "ENSG00000157110.16",
      gene_type : "protein_coding",
      gene_name : "RBPMS",
      gene_level : 1,
      hgnc_id : "HGNC:19097",
      havana_gene : "OTTHUMG00000163845.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30578318,
      stop : 30658236,
      direction : "-",
      ID : "ENSG00000197265.9",
      gene_id : "ENSG00000197265.9",
      gene_type : "protein_coding",
      gene_name : "GTF2E2",
      gene_level : 2,
      hgnc_id : "HGNC:4651",
      havana_gene : "OTTHUMG00000163934.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30638580,
      stop : 30646064,
      direction : "+",
      ID : "ENSG00000253457.3",
      gene_id : "ENSG00000253457.3",
      gene_type : "protein_coding",
      gene_name : "SMIM18",
      gene_level : 2,
      hgnc_id : "HGNC:42973",
      havana_gene : "OTTHUMG00000163839.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30678066,
      stop : 30727846,
      direction : "-",
      ID : "ENSG00000104687.14",
      gene_id : "ENSG00000104687.14",
      gene_type : "protein_coding",
      gene_name : "GSR",
      gene_level : 2,
      hgnc_id : "HGNC:4623",
      havana_gene : "OTTHUMG00000163946.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30729131,
      stop : 30767006,
      direction : "+",
      ID : "ENSG00000104691.16",
      gene_id : "ENSG00000104691.16",
      gene_type : "protein_coding",
      gene_name : "UBXN8",
      gene_level : 1,
      hgnc_id : "HGNC:30307",
      havana_gene : "OTTHUMG00000163851.11",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30774457,
      stop : 30814314,
      direction : "-",
      ID : "ENSG00000104695.13",
      gene_id : "ENSG00000104695.13",
      gene_type : "protein_coding",
      gene_name : "PPP2CB",
      gene_level : 2,
      hgnc_id : "HGNC:9300",
      havana_gene : "OTTHUMG00000163949.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30831544,
      stop : 30913008,
      direction : "-",
      ID : "ENSG00000133863.9",
      gene_id : "ENSG00000133863.9",
      gene_type : "protein_coding",
      gene_name : "TEX15",
      gene_level : 2,
      hgnc_id : "HGNC:11738",
      havana_gene : "OTTHUMG00000163881.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 30995802,
      stop : 31033715,
      direction : "-",
      ID : "ENSG00000172733.11",
      gene_id : "ENSG00000172733.11",
      gene_type : "protein_coding",
      gene_name : "PURG",
      gene_level : 1,
      hgnc_id : "HGNC:17930",
      havana_gene : "OTTHUMG00000157357.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 31033788,
      stop : 31176138,
      direction : "+",
      ID : "ENSG00000165392.11",
      gene_id : "ENSG00000165392.11",
      gene_type : "protein_coding",
      gene_name : "WRN",
      gene_level : 2,
      hgnc_id : "HGNC:12791",
      havana_gene : "OTTHUMG00000163894.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 31639222,
      stop : 32855666,
      direction : "+",
      ID : "ENSG00000157168.20",
      gene_id : "ENSG00000157168.20",
      gene_type : "protein_coding",
      gene_name : "NRG1",
      gene_level : 2,
      hgnc_id : "HGNC:7997",
      havana_gene : "OTTHUMG00000163918.29",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 32647202,
      stop : 32647390,
      direction : "+",
      ID : "ENSG00000286131.1",
      gene_id : "ENSG00000286131.1",
      gene_type : "protein_coding",
      gene_name : "AC083977.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193517.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 33370824,
      stop : 33473146,
      direction : "-",
      ID : "ENSG00000172728.16",
      gene_id : "ENSG00000172728.16",
      gene_type : "protein_coding",
      gene_name : "FUT10",
      gene_level : 1,
      hgnc_id : "HGNC:19234",
      havana_gene : "OTTHUMG00000163954.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 33473386,
      stop : 33513185,
      direction : "-",
      ID : "ENSG00000129696.13",
      gene_id : "ENSG00000129696.13",
      gene_type : "protein_coding",
      gene_name : "TTI2",
      gene_level : 1,
      hgnc_id : "HGNC:26262",
      havana_gene : "OTTHUMG00000163956.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 33485182,
      stop : 33501262,
      direction : "+",
      ID : "ENSG00000198042.11",
      gene_id : "ENSG00000198042.11",
      gene_type : "protein_coding",
      gene_name : "MAK16",
      gene_level : 2,
      hgnc_id : "HGNC:13703",
      havana_gene : "OTTHUMG00000163957.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 33547754,
      stop : 33567128,
      direction : "-",
      ID : "ENSG00000133874.2",
      gene_id : "ENSG00000133874.2",
      gene_type : "protein_coding",
      gene_name : "RNF122",
      gene_level : 2,
      hgnc_id : "HGNC:21147",
      havana_gene : "OTTHUMG00000163960.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 33591330,
      stop : 33600023,
      direction : "-",
      ID : "ENSG00000133878.9",
      gene_id : "ENSG00000133878.9",
      gene_type : "protein_coding",
      gene_name : "DUSP26",
      gene_level : 2,
      hgnc_id : "HGNC:28161",
      havana_gene : "OTTHUMG00000163961.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 35235475,
      stop : 35796550,
      direction : "+",
      ID : "ENSG00000156687.11",
      gene_id : "ENSG00000156687.11",
      gene_type : "protein_coding",
      gene_name : "UNC5D",
      gene_level : 1,
      hgnc_id : "HGNC:18634",
      havana_gene : "OTTHUMG00000157145.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 36784324,
      stop : 36936125,
      direction : "+",
      ID : "ENSG00000215262.8",
      gene_id : "ENSG00000215262.8",
      gene_type : "protein_coding",
      gene_name : "KCNU1",
      gene_level : 1,
      hgnc_id : "HGNC:18867",
      havana_gene : "OTTHUMG00000163981.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37695782,
      stop : 37700019,
      direction : "+",
      ID : "ENSG00000183779.7",
      gene_id : "ENSG00000183779.7",
      gene_type : "protein_coding",
      gene_name : "ZNF703",
      gene_level : 2,
      hgnc_id : "HGNC:25883",
      havana_gene : "OTTHUMG00000164001.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37736601,
      stop : 37758422,
      direction : "+",
      ID : "ENSG00000147475.17",
      gene_id : "ENSG00000147475.17",
      gene_type : "protein_coding",
      gene_name : "ERLIN2",
      gene_level : 1,
      hgnc_id : "HGNC:1356",
      havana_gene : "OTTHUMG00000164005.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37762595,
      stop : 37779768,
      direction : "+",
      ID : "ENSG00000147471.12",
      gene_id : "ENSG00000147471.12",
      gene_type : "protein_coding",
      gene_name : "PLPBP",
      gene_level : 1,
      hgnc_id : "HGNC:9457",
      havana_gene : "OTTHUMG00000164024.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37784191,
      stop : 37844896,
      direction : "+",
      ID : "ENSG00000020181.18",
      gene_id : "ENSG00000020181.18",
      gene_type : "protein_coding",
      gene_name : "ADGRA2",
      gene_level : 2,
      hgnc_id : "HGNC:17849",
      havana_gene : "OTTHUMG00000156182.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37843268,
      stop : 37849861,
      direction : "-",
      ID : "ENSG00000104221.13",
      gene_id : "ENSG00000104221.13",
      gene_type : "protein_coding",
      gene_name : "BRF2",
      gene_level : 2,
      hgnc_id : "HGNC:17298",
      havana_gene : "OTTHUMG00000164025.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37858618,
      stop : 37899497,
      direction : "-",
      ID : "ENSG00000156675.16",
      gene_id : "ENSG00000156675.16",
      gene_type : "protein_coding",
      gene_name : "RAB11FIP1",
      gene_level : 2,
      hgnc_id : "HGNC:30265",
      havana_gene : "OTTHUMG00000164026.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37934281,
      stop : 37940124,
      direction : "-",
      ID : "ENSG00000169154.7",
      gene_id : "ENSG00000169154.7",
      gene_type : "protein_coding",
      gene_name : "GOT1L1",
      gene_level : 1,
      hgnc_id : "HGNC:28487",
      havana_gene : "OTTHUMG00000164027.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37934340,
      stop : 37965953,
      direction : "-",
      ID : "ENSG00000285880.1",
      gene_id : "ENSG00000285880.1",
      gene_type : "protein_coding",
      gene_name : "AC144573.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193361.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 37962990,
      stop : 37966599,
      direction : "-",
      ID : "ENSG00000188778.6",
      gene_id : "ENSG00000188778.6",
      gene_type : "protein_coding",
      gene_name : "ADRB3",
      gene_level : 2,
      hgnc_id : "HGNC:288",
      havana_gene : "OTTHUMG00000164028.5",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38030534,
      stop : 38060365,
      direction : "+",
      ID : "ENSG00000187840.5",
      gene_id : "ENSG00000187840.5",
      gene_type : "protein_coding",
      gene_name : "EIF4EBP1",
      gene_level : 2,
      hgnc_id : "HGNC:3288",
      havana_gene : "OTTHUMG00000164012.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38105493,
      stop : 38144076,
      direction : "+",
      ID : "ENSG00000129691.16",
      gene_id : "ENSG00000129691.16",
      gene_type : "protein_coding",
      gene_name : "ASH2L",
      gene_level : 1,
      hgnc_id : "HGNC:744",
      havana_gene : "OTTHUMG00000164016.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38142700,
      stop : 38150992,
      direction : "-",
      ID : "ENSG00000147465.12",
      gene_id : "ENSG00000147465.12",
      gene_type : "protein_coding",
      gene_name : "STAR",
      gene_level : 1,
      hgnc_id : "HGNC:11359",
      havana_gene : "OTTHUMG00000164058.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38163335,
      stop : 38176730,
      direction : "-",
      ID : "ENSG00000175324.10",
      gene_id : "ENSG00000175324.10",
      gene_type : "protein_coding",
      gene_name : "LSM1",
      gene_level : 1,
      hgnc_id : "HGNC:20472",
      havana_gene : "OTTHUMG00000164051.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38176533,
      stop : 38213301,
      direction : "+",
      ID : "ENSG00000156735.11",
      gene_id : "ENSG00000156735.11",
      gene_type : "protein_coding",
      gene_name : "BAG4",
      gene_level : 2,
      hgnc_id : "HGNC:940",
      havana_gene : "OTTHUMG00000164064.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38225218,
      stop : 38275558,
      direction : "+",
      ID : "ENSG00000085788.14",
      gene_id : "ENSG00000085788.14",
      gene_type : "protein_coding",
      gene_name : "DDHD2",
      gene_level : 1,
      hgnc_id : "HGNC:29106",
      havana_gene : "OTTHUMG00000164095.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38263130,
      stop : 38269243,
      direction : "-",
      ID : "ENSG00000147535.17",
      gene_id : "ENSG00000147535.17",
      gene_type : "protein_coding",
      gene_name : "PLPP5",
      gene_level : 1,
      hgnc_id : "HGNC:25026",
      havana_gene : "OTTHUMG00000165104.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38269704,
      stop : 38382272,
      direction : "-",
      ID : "ENSG00000147548.17",
      gene_id : "ENSG00000147548.17",
      gene_type : "protein_coding",
      gene_name : "NSD3",
      gene_level : 2,
      hgnc_id : "HGNC:12767",
      havana_gene : "OTTHUMG00000165115.10",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38386207,
      stop : 38409527,
      direction : "+",
      ID : "ENSG00000165046.13",
      gene_id : "ENSG00000165046.13",
      gene_type : "protein_coding",
      gene_name : "LETM2",
      gene_level : 2,
      hgnc_id : "HGNC:14648",
      havana_gene : "OTTHUMG00000165059.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38400215,
      stop : 38468834,
      direction : "-",
      ID : "ENSG00000077782.21",
      gene_id : "ENSG00000077782.21",
      gene_type : "protein_coding",
      gene_name : "FGFR1",
      gene_level : 1,
      hgnc_id : "HGNC:3688",
      havana_gene : "OTTHUMG00000147366.18",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38728186,
      stop : 38853028,
      direction : "+",
      ID : "ENSG00000147526.20",
      gene_id : "ENSG00000147526.20",
      gene_type : "protein_coding",
      gene_name : "TACC1",
      gene_level : 1,
      hgnc_id : "HGNC:11522",
      havana_gene : "OTTHUMG00000164018.12",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38901235,
      stop : 38973912,
      direction : "+",
      ID : "ENSG00000169499.15",
      gene_id : "ENSG00000169499.15",
      gene_type : "protein_coding",
      gene_name : "PLEKHA2",
      gene_level : 1,
      hgnc_id : "HGNC:14336",
      havana_gene : "OTTHUMG00000164069.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38974228,
      stop : 38988663,
      direction : "+",
      ID : "ENSG00000169495.5",
      gene_id : "ENSG00000169495.5",
      gene_type : "protein_coding",
      gene_name : "HTRA4",
      gene_level : 2,
      hgnc_id : "HGNC:26909",
      havana_gene : "OTTHUMG00000164070.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38988808,
      stop : 38996824,
      direction : "-",
      ID : "ENSG00000169490.17",
      gene_id : "ENSG00000169490.17",
      gene_type : "protein_coding",
      gene_name : "TM2D2",
      gene_level : 2,
      hgnc_id : "HGNC:24127",
      havana_gene : "OTTHUMG00000164098.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 38996754,
      stop : 39105445,
      direction : "+",
      ID : "ENSG00000168615.13",
      gene_id : "ENSG00000168615.13",
      gene_type : "protein_coding",
      gene_name : "ADAM9",
      gene_level : 1,
      hgnc_id : "HGNC:216",
      havana_gene : "OTTHUMG00000159783.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 39106990,
      stop : 39284917,
      direction : "+",
      ID : "ENSG00000197140.15",
      gene_id : "ENSG00000197140.15",
      gene_type : "protein_coding",
      gene_name : "ADAM32",
      gene_level : 1,
      hgnc_id : "HGNC:15479",
      havana_gene : "OTTHUMG00000164071.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 39584489,
      stop : 39730065,
      direction : "+",
      ID : "ENSG00000168619.16",
      gene_id : "ENSG00000168619.16",
      gene_type : "protein_coding",
      gene_name : "ADAM18",
      gene_level : 2,
      hgnc_id : "HGNC:196",
      havana_gene : "OTTHUMG00000164040.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 39743735,
      stop : 39838289,
      direction : "-",
      ID : "ENSG00000104755.15",
      gene_id : "ENSG00000104755.15",
      gene_type : "protein_coding",
      gene_name : "ADAM2",
      gene_level : 1,
      hgnc_id : "HGNC:198",
      havana_gene : "OTTHUMG00000164041.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 39902275,
      stop : 39928790,
      direction : "+",
      ID : "ENSG00000131203.13",
      gene_id : "ENSG00000131203.13",
      gene_type : "protein_coding",
      gene_name : "IDO1",
      gene_level : 2,
      hgnc_id : "HGNC:6059",
      havana_gene : "OTTHUMG00000164057.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 39934614,
      stop : 40016391,
      direction : "+",
      ID : "ENSG00000188676.13",
      gene_id : "ENSG00000188676.13",
      gene_type : "protein_coding",
      gene_name : "IDO2",
      gene_level : 2,
      hgnc_id : "HGNC:27269",
      havana_gene : "OTTHUMG00000141271.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 40153482,
      stop : 40155310,
      direction : "+",
      ID : "ENSG00000176907.5",
      gene_id : "ENSG00000176907.5",
      gene_type : "protein_coding",
      gene_name : "TCIM",
      gene_level : 2,
      hgnc_id : "HGNC:1357",
      havana_gene : "OTTHUMG00000164045.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 40530590,
      stop : 40897833,
      direction : "-",
      ID : "ENSG00000165061.15",
      gene_id : "ENSG00000165061.15",
      gene_type : "protein_coding",
      gene_name : "ZMAT4",
      gene_level : 2,
      hgnc_id : "HGNC:25844",
      havana_gene : "OTTHUMG00000164049.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41261962,
      stop : 41309473,
      direction : "-",
      ID : "ENSG00000104332.12",
      gene_id : "ENSG00000104332.12",
      gene_type : "protein_coding",
      gene_name : "SFRP1",
      gene_level : 1,
      hgnc_id : "HGNC:10776",
      havana_gene : "OTTHUMG00000164074.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41490396,
      stop : 41510980,
      direction : "+",
      ID : "ENSG00000147533.17",
      gene_id : "ENSG00000147533.17",
      gene_type : "protein_coding",
      gene_name : "GOLGA7",
      gene_level : 2,
      hgnc_id : "HGNC:24876",
      havana_gene : "OTTHUMG00000164077.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41529218,
      stop : 41545030,
      direction : "+",
      ID : "ENSG00000147536.12",
      gene_id : "ENSG00000147536.12",
      gene_type : "protein_coding",
      gene_name : "GINS4",
      gene_level : 2,
      hgnc_id : "HGNC:28226",
      havana_gene : "OTTHUMG00000164079.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41577187,
      stop : 41625001,
      direction : "+",
      ID : "ENSG00000158669.11",
      gene_id : "ENSG00000158669.11",
      gene_type : "protein_coding",
      gene_name : "GPAT4",
      gene_level : 1,
      hgnc_id : "HGNC:20880",
      havana_gene : "OTTHUMG00000164082.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41645177,
      stop : 41650817,
      direction : "-",
      ID : "ENSG00000165066.13",
      gene_id : "ENSG00000165066.13",
      gene_type : "protein_coding",
      gene_name : "NKX6-3",
      gene_level : 1,
      hgnc_id : "HGNC:26328",
      havana_gene : "OTTHUMG00000164083.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41653220,
      stop : 41896762,
      direction : "-",
      ID : "ENSG00000029534.21",
      gene_id : "ENSG00000029534.21",
      gene_type : "protein_coding",
      gene_name : "ANK1",
      gene_level : 1,
      hgnc_id : "HGNC:492",
      havana_gene : "OTTHUMG00000150281.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 41929479,
      stop : 42051994,
      direction : "-",
      ID : "ENSG00000083168.11",
      gene_id : "ENSG00000083168.11",
      gene_type : "protein_coding",
      gene_name : "KAT6A",
      gene_level : 1,
      hgnc_id : "HGNC:13013",
      havana_gene : "OTTHUMG00000150453.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42152946,
      stop : 42171673,
      direction : "+",
      ID : "ENSG00000070718.12",
      gene_id : "ENSG00000070718.12",
      gene_type : "protein_coding",
      gene_name : "AP3M2",
      gene_level : 1,
      hgnc_id : "HGNC:570",
      havana_gene : "OTTHUMG00000164060.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42174718,
      stop : 42207709,
      direction : "-",
      ID : "ENSG00000104368.19",
      gene_id : "ENSG00000104368.19",
      gene_type : "protein_coding",
      gene_name : "PLAT",
      gene_level : 1,
      hgnc_id : "HGNC:9051",
      havana_gene : "OTTHUMG00000164072.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42271302,
      stop : 42332460,
      direction : "+",
      ID : "ENSG00000104365.16",
      gene_id : "ENSG00000104365.16",
      gene_type : "protein_coding",
      gene_name : "IKBKB",
      gene_level : 2,
      hgnc_id : "HGNC:5960",
      havana_gene : "OTTHUMG00000164092.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42338454,
      stop : 42371808,
      direction : "+",
      ID : "ENSG00000070501.12",
      gene_id : "ENSG00000070501.12",
      gene_type : "protein_coding",
      gene_name : "POLB",
      gene_level : 1,
      hgnc_id : "HGNC:9174",
      havana_gene : "OTTHUMG00000164093.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42374063,
      stop : 42377229,
      direction : "-",
      ID : "ENSG00000104371.5",
      gene_id : "ENSG00000104371.5",
      gene_type : "protein_coding",
      gene_name : "DKK4",
      gene_level : 2,
      hgnc_id : "HGNC:2894",
      havana_gene : "OTTHUMG00000164167.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42391624,
      stop : 42405937,
      direction : "+",
      ID : "ENSG00000078668.14",
      gene_id : "ENSG00000078668.14",
      gene_type : "protein_coding",
      gene_name : "VDAC3",
      gene_level : 1,
      hgnc_id : "HGNC:12674",
      havana_gene : "OTTHUMG00000164168.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42416475,
      stop : 42541926,
      direction : "-",
      ID : "ENSG00000168575.10",
      gene_id : "ENSG00000168575.10",
      gene_type : "protein_coding",
      gene_name : "SLC20A2",
      gene_level : 2,
      hgnc_id : "HGNC:10947",
      havana_gene : "OTTHUMG00000164169.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42541155,
      stop : 42555195,
      direction : "+",
      ID : "ENSG00000176209.12",
      gene_id : "ENSG00000176209.12",
      gene_type : "protein_coding",
      gene_name : "SMIM19",
      gene_level : 2,
      hgnc_id : "HGNC:25166",
      havana_gene : "OTTHUMG00000157060.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42697366,
      stop : 42737407,
      direction : "+",
      ID : "ENSG00000147432.7",
      gene_id : "ENSG00000147432.7",
      gene_type : "protein_coding",
      gene_name : "CHRNB3",
      gene_level : 1,
      hgnc_id : "HGNC:1963",
      havana_gene : "OTTHUMG00000165262.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42752620,
      stop : 42796392,
      direction : "-",
      ID : "ENSG00000147434.9",
      gene_id : "ENSG00000147434.9",
      gene_type : "protein_coding",
      gene_name : "CHRNA6",
      gene_level : 1,
      hgnc_id : "HGNC:15963",
      havana_gene : "OTTHUMG00000165275.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42836674,
      stop : 42843325,
      direction : "-",
      ID : "ENSG00000131931.8",
      gene_id : "ENSG00000131931.8",
      gene_type : "protein_coding",
      gene_name : "THAP1",
      gene_level : 2,
      hgnc_id : "HGNC:20856",
      havana_gene : "OTTHUMG00000165276.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42849637,
      stop : 42897290,
      direction : "-",
      ID : "ENSG00000120925.16",
      gene_id : "ENSG00000120925.16",
      gene_type : "protein_coding",
      gene_name : "RNF170",
      gene_level : 2,
      hgnc_id : "HGNC:25358",
      havana_gene : "OTTHUMG00000165277.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 42896946,
      stop : 43030535,
      direction : "+",
      ID : "ENSG00000168172.9",
      gene_id : "ENSG00000168172.9",
      gene_type : "protein_coding",
      gene_name : "HOOK3",
      gene_level : 1,
      hgnc_id : "HGNC:23576",
      havana_gene : "OTTHUMG00000165278.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 43018424,
      stop : 43077334,
      direction : "+",
      ID : "ENSG00000254673.1",
      gene_id : "ENSG00000254673.1",
      gene_type : "protein_coding",
      gene_name : "AC110275.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000165287.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 43034194,
      stop : 43085788,
      direction : "+",
      ID : "ENSG00000168522.13",
      gene_id : "ENSG00000168522.13",
      gene_type : "protein_coding",
      gene_name : "FNTA",
      gene_level : 1,
      hgnc_id : "HGNC:3782",
      havana_gene : "OTTHUMG00000165279.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 43093498,
      stop : 43131180,
      direction : "+",
      ID : "ENSG00000185900.11",
      gene_id : "ENSG00000185900.11",
      gene_type : "protein_coding",
      gene_name : "POMK",
      gene_level : 1,
      hgnc_id : "HGNC:26267",
      havana_gene : "OTTHUMG00000164100.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 43140464,
      stop : 43202855,
      direction : "+",
      ID : "ENSG00000165102.15",
      gene_id : "ENSG00000165102.15",
      gene_type : "protein_coding",
      gene_name : "HGSNAT",
      gene_level : 1,
      hgnc_id : "HGNC:26527",
      havana_gene : "OTTHUMG00000164102.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 47260878,
      stop : 47736306,
      direction : "+",
      ID : "ENSG00000164808.17",
      gene_id : "ENSG00000164808.17",
      gene_type : "protein_coding",
      gene_name : "SPIDR",
      gene_level : 1,
      hgnc_id : "HGNC:28971",
      havana_gene : "OTTHUMG00000164176.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 47736913,
      stop : 47738164,
      direction : "-",
      ID : "ENSG00000221869.5",
      gene_id : "ENSG00000221869.5",
      gene_type : "protein_coding",
      gene_name : "CEBPD",
      gene_level : 2,
      hgnc_id : "HGNC:1835",
      havana_gene : "OTTHUMG00000162290.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 47773111,
      stop : 47960178,
      direction : "-",
      ID : "ENSG00000253729.8",
      gene_id : "ENSG00000253729.8",
      gene_type : "protein_coding",
      gene_name : "PRKDC",
      gene_level : 1,
      hgnc_id : "HGNC:9413",
      havana_gene : "OTTHUMG00000164239.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 47960185,
      stop : 47978160,
      direction : "+",
      ID : "ENSG00000104738.18",
      gene_id : "ENSG00000104738.18",
      gene_type : "protein_coding",
      gene_name : "MCM4",
      gene_level : 1,
      hgnc_id : "HGNC:6947",
      havana_gene : "OTTHUMG00000164205.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 48008415,
      stop : 48064708,
      direction : "+",
      ID : "ENSG00000169139.12",
      gene_id : "ENSG00000169139.12",
      gene_type : "protein_coding",
      gene_name : "UBE2V2",
      gene_level : 1,
      hgnc_id : "HGNC:12495",
      havana_gene : "OTTHUMG00000164206.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 48710789,
      stop : 48735311,
      direction : "-",
      ID : "ENSG00000034239.11",
      gene_id : "ENSG00000034239.11",
      gene_type : "protein_coding",
      gene_name : "EFCAB1",
      gene_level : 2,
      hgnc_id : "HGNC:25678",
      havana_gene : "OTTHUMG00000164203.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 48917598,
      stop : 48921740,
      direction : "-",
      ID : "ENSG00000019549.13",
      gene_id : "ENSG00000019549.13",
      gene_type : "protein_coding",
      gene_name : "SNAI2",
      gene_level : 2,
      hgnc_id : "HGNC:11094",
      havana_gene : "OTTHUMG00000149912.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 49054311,
      stop : 49076093,
      direction : "+",
      ID : "ENSG00000168333.14",
      gene_id : "ENSG00000168333.14",
      gene_type : "protein_coding",
      gene_name : "PPDPFL",
      gene_level : 2,
      hgnc_id : "HGNC:31745",
      havana_gene : "OTTHUMG00000164217.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 49909789,
      stop : 50796692,
      direction : "+",
      ID : "ENSG00000147481.17",
      gene_id : "ENSG00000147481.17",
      gene_type : "protein_coding",
      gene_name : "SNTG1",
      gene_level : 2,
      hgnc_id : "HGNC:13740",
      havana_gene : "OTTHUMG00000164257.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 51319577,
      stop : 51809445,
      direction : "-",
      ID : "ENSG00000147485.13",
      gene_id : "ENSG00000147485.13",
      gene_type : "protein_coding",
      gene_name : "PXDNL",
      gene_level : 2,
      hgnc_id : "HGNC:26359",
      havana_gene : "OTTHUMG00000164244.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 51817575,
      stop : 51899186,
      direction : "-",
      ID : "ENSG00000168300.14",
      gene_id : "ENSG00000168300.14",
      gene_type : "protein_coding",
      gene_name : "PCMTD1",
      gene_level : 1,
      hgnc_id : "HGNC:30483",
      havana_gene : "OTTHUMG00000164246.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 52110839,
      stop : 52460959,
      direction : "-",
      ID : "ENSG00000147488.11",
      gene_id : "ENSG00000147488.11",
      gene_type : "protein_coding",
      gene_name : "ST18",
      gene_level : 1,
      hgnc_id : "HGNC:18695",
      havana_gene : "OTTHUMG00000164233.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 52534037,
      stop : 52565430,
      direction : "-",
      ID : "ENSG00000196711.9",
      gene_id : "ENSG00000196711.9",
      gene_type : "protein_coding",
      gene_name : "ALKAL1",
      gene_level : 2,
      hgnc_id : "HGNC:33775",
      havana_gene : "OTTHUMG00000164256.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 52622458,
      stop : 52745843,
      direction : "-",
      ID : "ENSG00000023287.13",
      gene_id : "ENSG00000023287.13",
      gene_type : "protein_coding",
      gene_name : "RB1CC1",
      gene_level : 2,
      hgnc_id : "HGNC:15574",
      havana_gene : "OTTHUMG00000164268.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 52939182,
      stop : 52943734,
      direction : "+",
      ID : "ENSG00000288611.1",
      gene_id : "ENSG00000288611.1",
      gene_type : "protein_coding",
      gene_name : "NPBWR1",
      gene_level : 2,
      hgnc_id : "HGNC:4522",
      havana_gene : "OTTHUMG00000164275.1",
      tag : "retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 53225724,
      stop : 53251637,
      direction : "-",
      ID : "ENSG00000082556.14",
      gene_id : "ENSG00000082556.14",
      gene_type : "protein_coding",
      gene_name : "OPRK1",
      gene_level : 1,
      hgnc_id : "HGNC:8154",
      havana_gene : "OTTHUMG00000164276.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 53715543,
      stop : 53843558,
      direction : "-",
      ID : "ENSG00000047249.18",
      gene_id : "ENSG00000047249.18",
      gene_type : "protein_coding",
      gene_name : "ATP6V1H",
      gene_level : 1,
      hgnc_id : "HGNC:18303",
      havana_gene : "OTTHUMG00000164231.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 53851795,
      stop : 53959303,
      direction : "+",
      ID : "ENSG00000147509.14",
      gene_id : "ENSG00000147509.14",
      gene_type : "protein_coding",
      gene_name : "RGS20",
      gene_level : 2,
      hgnc_id : "HGNC:14600",
      havana_gene : "OTTHUMG00000164750.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 53966552,
      stop : 54022456,
      direction : "-",
      ID : "ENSG00000187735.14",
      gene_id : "ENSG00000187735.14",
      gene_type : "protein_coding",
      gene_name : "TCEA1",
      gene_level : 2,
      hgnc_id : "HGNC:11612",
      havana_gene : "OTTHUMG00000164262.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 54046367,
      stop : 54102017,
      direction : "-",
      ID : "ENSG00000120992.18",
      gene_id : "ENSG00000120992.18",
      gene_type : "protein_coding",
      gene_name : "LYPLA1",
      gene_level : 2,
      hgnc_id : "HGNC:6737",
      havana_gene : "OTTHUMG00000164313.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 54135241,
      stop : 54148514,
      direction : "+",
      ID : "ENSG00000137547.9",
      gene_id : "ENSG00000137547.9",
      gene_type : "protein_coding",
      gene_name : "MRPL15",
      gene_level : 2,
      hgnc_id : "HGNC:14054",
      havana_gene : "OTTHUMG00000164315.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 54457935,
      stop : 54460892,
      direction : "+",
      ID : "ENSG00000164736.6",
      gene_id : "ENSG00000164736.6",
      gene_type : "protein_coding",
      gene_name : "SOX17",
      gene_level : 2,
      hgnc_id : "HGNC:18122",
      havana_gene : "OTTHUMG00000164377.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 54509422,
      stop : 54871720,
      direction : "+",
      ID : "ENSG00000104237.11",
      gene_id : "ENSG00000104237.11",
      gene_type : "protein_coding",
      gene_name : "RP1",
      gene_level : 2,
      hgnc_id : "HGNC:10263",
      havana_gene : "OTTHUMG00000164379.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 55102028,
      stop : 55542054,
      direction : "+",
      ID : "ENSG00000206579.9",
      gene_id : "ENSG00000206579.9",
      gene_type : "protein_coding",
      gene_name : "XKR4",
      gene_level : 2,
      hgnc_id : "HGNC:29394",
      havana_gene : "OTTHUMG00000164288.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 55696424,
      stop : 55773407,
      direction : "-",
      ID : "ENSG00000167904.15",
      gene_id : "ENSG00000167904.15",
      gene_type : "protein_coding",
      gene_name : "TMEM68",
      gene_level : 1,
      hgnc_id : "HGNC:26510",
      havana_gene : "OTTHUMG00000164293.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 55773446,
      stop : 55826445,
      direction : "+",
      ID : "ENSG00000137574.11",
      gene_id : "ENSG00000137574.11",
      gene_type : "protein_coding",
      gene_name : "TGS1",
      gene_level : 2,
      hgnc_id : "HGNC:17843",
      havana_gene : "OTTHUMG00000164294.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 55879835,
      stop : 56014169,
      direction : "+",
      ID : "ENSG00000254087.8",
      gene_id : "ENSG00000254087.8",
      gene_type : "protein_coding",
      gene_name : "LYN",
      gene_level : 2,
      hgnc_id : "HGNC:6735",
      havana_gene : "OTTHUMG00000044345.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56067254,
      stop : 56074510,
      direction : "-",
      ID : "ENSG00000008988.11",
      gene_id : "ENSG00000008988.11",
      gene_type : "protein_coding",
      gene_name : "RPS20",
      gene_level : 1,
      hgnc_id : "HGNC:10405",
      havana_gene : "OTTHUMG00000164297.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56112942,
      stop : 56113982,
      direction : "-",
      ID : "ENSG00000172680.1",
      gene_id : "ENSG00000172680.1",
      gene_type : "protein_coding",
      gene_name : "MOS",
      gene_level : 2,
      hgnc_id : "HGNC:7199",
      havana_gene : "OTTHUMG00000164299.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56160909,
      stop : 56211324,
      direction : "-",
      ID : "ENSG00000181690.8",
      gene_id : "ENSG00000181690.8",
      gene_type : "protein_coding",
      gene_name : "PLAG1",
      gene_level : 2,
      hgnc_id : "HGNC:9045",
      havana_gene : "OTTHUMG00000164310.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56211686,
      stop : 56218809,
      direction : "+",
      ID : "ENSG00000170791.18",
      gene_id : "ENSG00000170791.18",
      gene_type : "protein_coding",
      gene_name : "CHCHD7",
      gene_level : 2,
      hgnc_id : "HGNC:28314",
      havana_gene : "OTTHUMG00000074081.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56300005,
      stop : 56320776,
      direction : "-",
      ID : "ENSG00000170786.13",
      gene_id : "ENSG00000170786.13",
      gene_type : "protein_coding",
      gene_name : "SDR16C5",
      gene_level : 1,
      hgnc_id : "HGNC:30311",
      havana_gene : "OTTHUMG00000164311.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56436674,
      stop : 56446671,
      direction : "-",
      ID : "ENSG00000181195.11",
      gene_id : "ENSG00000181195.11",
      gene_type : "protein_coding",
      gene_name : "PENK",
      gene_level : 1,
      hgnc_id : "HGNC:8831",
      havana_gene : "OTTHUMG00000164409.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 56957931,
      stop : 56993867,
      direction : "-",
      ID : "ENSG00000104331.9",
      gene_id : "ENSG00000104331.9",
      gene_type : "protein_coding",
      gene_name : "BPNT2",
      gene_level : 2,
      hgnc_id : "HGNC:26019",
      havana_gene : "OTTHUMG00000164415.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 57994509,
      stop : 58204279,
      direction : "+",
      ID : "ENSG00000169122.11",
      gene_id : "ENSG00000169122.11",
      gene_type : "protein_coding",
      gene_name : "FAM110B",
      gene_level : 2,
      hgnc_id : "HGNC:28587",
      havana_gene : "OTTHUMG00000164282.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 58411359,
      stop : 58451501,
      direction : "+",
      ID : "ENSG00000215114.10",
      gene_id : "ENSG00000215114.10",
      gene_type : "protein_coding",
      gene_name : "UBXN2B",
      gene_level : 2,
      hgnc_id : "HGNC:27035",
      havana_gene : "OTTHUMG00000164300.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 58490178,
      stop : 58500163,
      direction : "-",
      ID : "ENSG00000167910.4",
      gene_id : "ENSG00000167910.4",
      gene_type : "protein_coding",
      gene_name : "CYP7A1",
      gene_level : 2,
      hgnc_id : "HGNC:2651",
      havana_gene : "OTTHUMG00000164301.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 58552924,
      stop : 58582859,
      direction : "+",
      ID : "ENSG00000137575.12",
      gene_id : "ENSG00000137575.12",
      gene_type : "protein_coding",
      gene_name : "SDCBP",
      gene_level : 2,
      hgnc_id : "HGNC:10662",
      havana_gene : "OTTHUMG00000164303.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 58583508,
      stop : 58659853,
      direction : "-",
      ID : "ENSG00000035681.9",
      gene_id : "ENSG00000035681.9",
      gene_type : "protein_coding",
      gene_name : "NSMAF",
      gene_level : 2,
      hgnc_id : "HGNC:8017",
      havana_gene : "OTTHUMG00000164352.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 58805412,
      stop : 59119147,
      direction : "-",
      ID : "ENSG00000198846.6",
      gene_id : "ENSG00000198846.6",
      gene_type : "protein_coding",
      gene_name : "TOX",
      gene_level : 2,
      hgnc_id : "HGNC:18988",
      havana_gene : "OTTHUMG00000164331.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 60185412,
      stop : 60281400,
      direction : "-",
      ID : "ENSG00000178538.10",
      gene_id : "ENSG00000178538.10",
      gene_type : "protein_coding",
      gene_name : "CA8",
      gene_level : 2,
      hgnc_id : "HGNC:1382",
      havana_gene : "OTTHUMG00000165325.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 60516936,
      stop : 60623644,
      direction : "+",
      ID : "ENSG00000104388.15",
      gene_id : "ENSG00000104388.15",
      gene_type : "protein_coding",
      gene_name : "RAB2A",
      gene_level : 2,
      hgnc_id : "HGNC:9763",
      havana_gene : "OTTHUMG00000134298.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 60678740,
      stop : 60868028,
      direction : "+",
      ID : "ENSG00000171316.12",
      gene_id : "ENSG00000171316.12",
      gene_type : "protein_coding",
      gene_name : "CHD7",
      gene_level : 1,
      hgnc_id : "HGNC:20626",
      havana_gene : "OTTHUMG00000165332.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 61057158,
      stop : 61501645,
      direction : "+",
      ID : "ENSG00000177182.11",
      gene_id : "ENSG00000177182.11",
      gene_type : "protein_coding",
      gene_name : "CLVS1",
      gene_level : 1,
      hgnc_id : "HGNC:23139",
      havana_gene : "OTTHUMG00000164334.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 61500556,
      stop : 61714640,
      direction : "-",
      ID : "ENSG00000198363.18",
      gene_id : "ENSG00000198363.18",
      gene_type : "protein_coding",
      gene_name : "ASPH",
      gene_level : 2,
      hgnc_id : "HGNC:757",
      havana_gene : "OTTHUMG00000164375.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 62248591,
      stop : 63014000,
      direction : "+",
      ID : "ENSG00000185942.13",
      gene_id : "ENSG00000185942.13",
      gene_type : "protein_coding",
      gene_name : "NKAIN3",
      gene_level : 2,
      hgnc_id : "HGNC:26829",
      havana_gene : "OTTHUMG00000164361.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 63014881,
      stop : 63039407,
      direction : "-",
      ID : "ENSG00000137563.13",
      gene_id : "ENSG00000137563.13",
      gene_type : "protein_coding",
      gene_name : "GGH",
      gene_level : 2,
      hgnc_id : "HGNC:4248",
      havana_gene : "OTTHUMG00000164365.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 63048553,
      stop : 63086053,
      direction : "-",
      ID : "ENSG00000137561.5",
      gene_id : "ENSG00000137561.5",
      gene_type : "protein_coding",
      gene_name : "TTPA",
      gene_level : 2,
      hgnc_id : "HGNC:12404",
      havana_gene : "OTTHUMG00000164367.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 63168553,
      stop : 63212786,
      direction : "+",
      ID : "ENSG00000185728.17",
      gene_id : "ENSG00000185728.17",
      gene_type : "protein_coding",
      gene_name : "YTHDF3",
      gene_level : 1,
      hgnc_id : "HGNC:26465",
      havana_gene : "OTTHUMG00000164369.16",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 64580365,
      stop : 64583627,
      direction : "+",
      ID : "ENSG00000180828.3",
      gene_id : "ENSG00000180828.3",
      gene_type : "protein_coding",
      gene_name : "BHLHE22",
      gene_level : 2,
      hgnc_id : "HGNC:11963",
      havana_gene : "OTTHUMG00000164386.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 64587763,
      stop : 64798737,
      direction : "-",
      ID : "ENSG00000172817.4",
      gene_id : "ENSG00000172817.4",
      gene_type : "protein_coding",
      gene_name : "CYP7B1",
      gene_level : 2,
      hgnc_id : "HGNC:2652",
      havana_gene : "OTTHUMG00000164387.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 65602458,
      stop : 65634217,
      direction : "-",
      ID : "ENSG00000104442.10",
      gene_id : "ENSG00000104442.10",
      gene_type : "protein_coding",
      gene_name : "ARMC1",
      gene_level : 1,
      hgnc_id : "HGNC:17684",
      havana_gene : "OTTHUMG00000164374.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 65644734,
      stop : 65771261,
      direction : "+",
      ID : "ENSG00000066855.16",
      gene_id : "ENSG00000066855.16",
      gene_type : "protein_coding",
      gene_name : "MTFR1",
      gene_level : 1,
      hgnc_id : "HGNC:29510",
      havana_gene : "OTTHUMG00000164468.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 65714334,
      stop : 65842322,
      direction : "-",
      ID : "ENSG00000205268.11",
      gene_id : "ENSG00000205268.11",
      gene_type : "protein_coding",
      gene_name : "PDE7A",
      gene_level : 2,
      hgnc_id : "HGNC:8791",
      havana_gene : "OTTHUMG00000164469.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66021553,
      stop : 66101245,
      direction : "+",
      ID : "ENSG00000147570.10",
      gene_id : "ENSG00000147570.10",
      gene_type : "protein_coding",
      gene_name : "DNAJC5B",
      gene_level : 2,
      hgnc_id : "HGNC:24138",
      havana_gene : "OTTHUMG00000164470.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66126896,
      stop : 66175485,
      direction : "+",
      ID : "ENSG00000147573.17",
      gene_id : "ENSG00000147573.17",
      gene_type : "protein_coding",
      gene_name : "TRIM55",
      gene_level : 2,
      hgnc_id : "HGNC:14215",
      havana_gene : "OTTHUMG00000164473.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66176376,
      stop : 66178464,
      direction : "-",
      ID : "ENSG00000147571.5",
      gene_id : "ENSG00000147571.5",
      gene_type : "protein_coding",
      gene_name : "CRH",
      gene_level : 2,
      hgnc_id : "HGNC:2355",
      havana_gene : "OTTHUMG00000164474.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66429014,
      stop : 66430733,
      direction : "+",
      ID : "ENSG00000179041.4",
      gene_id : "ENSG00000179041.4",
      gene_type : "protein_coding",
      gene_name : "RRS1",
      gene_level : 2,
      hgnc_id : "HGNC:17083",
      havana_gene : "OTTHUMG00000164765.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66430185,
      stop : 66445324,
      direction : "+",
      ID : "ENSG00000285655.1",
      gene_id : "ENSG00000285655.1",
      gene_type : "protein_coding",
      gene_name : "AC009879.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000150215.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66432486,
      stop : 66518524,
      direction : "+",
      ID : "ENSG00000285791.1",
      gene_id : "ENSG00000285791.1",
      gene_type : "protein_coding",
      gene_name : "AC009879.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193364.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66432492,
      stop : 66468907,
      direction : "+",
      ID : "ENSG00000147576.17",
      gene_id : "ENSG00000147576.17",
      gene_type : "protein_coding",
      gene_name : "ADHFE1",
      gene_level : 2,
      hgnc_id : "HGNC:16354",
      havana_gene : "OTTHUMG00000193427.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66493520,
      stop : 66518524,
      direction : "+",
      ID : "ENSG00000169085.13",
      gene_id : "ENSG00000169085.13",
      gene_type : "protein_coding",
      gene_name : "VXN",
      gene_level : 1,
      hgnc_id : "HGNC:28498",
      havana_gene : "OTTHUMG00000156998.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66562175,
      stop : 66614247,
      direction : "-",
      ID : "ENSG00000185697.16",
      gene_id : "ENSG00000185697.16",
      gene_type : "protein_coding",
      gene_name : "MYBL1",
      gene_level : 1,
      hgnc_id : "HGNC:7547",
      havana_gene : "OTTHUMG00000164559.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66628487,
      stop : 66667231,
      direction : "-",
      ID : "ENSG00000175073.8",
      gene_id : "ENSG00000175073.8",
      gene_type : "protein_coding",
      gene_name : "VCPIP1",
      gene_level : 2,
      hgnc_id : "HGNC:30897",
      havana_gene : "OTTHUMG00000164560.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66667596,
      stop : 66860472,
      direction : "+",
      ID : "ENSG00000288602.1",
      gene_id : "ENSG00000288602.1",
      gene_type : "protein_coding",
      gene_name : "C8orf44-SGK3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000196011.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66712734,
      stop : 66862022,
      direction : "+",
      ID : "ENSG00000104205.16",
      gene_id : "ENSG00000104205.16",
      gene_type : "protein_coding",
      gene_name : "SGK3",
      gene_level : 1,
      hgnc_id : "HGNC:10812",
      havana_gene : "OTTHUMG00000164561.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66870749,
      stop : 66922048,
      direction : "+",
      ID : "ENSG00000178460.18",
      gene_id : "ENSG00000178460.18",
      gene_type : "protein_coding",
      gene_name : "MCMDC2",
      gene_level : 2,
      hgnc_id : "HGNC:26368",
      havana_gene : "OTTHUMG00000157068.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66946501,
      stop : 66962591,
      direction : "-",
      ID : "ENSG00000261787.2",
      gene_id : "ENSG00000261787.2",
      gene_type : "protein_coding",
      gene_name : "TCF24",
      gene_level : 2,
      hgnc_id : "HGNC:32275",
      havana_gene : "OTTHUMG00000177282.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 66964099,
      stop : 67056604,
      direction : "-",
      ID : "ENSG00000178125.14",
      gene_id : "ENSG00000178125.14",
      gene_type : "protein_coding",
      gene_name : "PPP1R42",
      gene_level : 2,
      hgnc_id : "HGNC:33732",
      havana_gene : "OTTHUMG00000164745.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 67043079,
      stop : 67083783,
      direction : "-",
      ID : "ENSG00000121022.14",
      gene_id : "ENSG00000121022.14",
      gene_type : "protein_coding",
      gene_name : "COPS5",
      gene_level : 1,
      hgnc_id : "HGNC:2240",
      havana_gene : "OTTHUMG00000164563.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 67062417,
      stop : 67196778,
      direction : "+",
      ID : "ENSG00000104218.16",
      gene_id : "ENSG00000104218.16",
      gene_type : "protein_coding",
      gene_name : "CSPP1",
      gene_level : 1,
      hgnc_id : "HGNC:26193",
      havana_gene : "OTTHUMG00000164564.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 67173511,
      stop : 67343781,
      direction : "-",
      ID : "ENSG00000066777.9",
      gene_id : "ENSG00000066777.9",
      gene_type : "protein_coding",
      gene_name : "ARFGEF1",
      gene_level : 1,
      hgnc_id : "HGNC:15772",
      havana_gene : "OTTHUMG00000164626.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 67422038,
      stop : 67746378,
      direction : "-",
      ID : "ENSG00000165078.13",
      gene_id : "ENSG00000165078.13",
      gene_type : "protein_coding",
      gene_name : "CPA6",
      gene_level : 2,
      hgnc_id : "HGNC:17245",
      havana_gene : "OTTHUMG00000164575.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 67952046,
      stop : 68237032,
      direction : "+",
      ID : "ENSG00000046889.19",
      gene_id : "ENSG00000046889.19",
      gene_type : "protein_coding",
      gene_name : "PREX2",
      gene_level : 2,
      hgnc_id : "HGNC:22950",
      havana_gene : "OTTHUMG00000164402.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 68330955,
      stop : 68819023,
      direction : "+",
      ID : "ENSG00000165084.16",
      gene_id : "ENSG00000165084.16",
      gene_type : "protein_coding",
      gene_name : "C8orf34",
      gene_level : 2,
      hgnc_id : "HGNC:30905",
      havana_gene : "OTTHUMG00000164438.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 69466624,
      stop : 69660915,
      direction : "+",
      ID : "ENSG00000137573.14",
      gene_id : "ENSG00000137573.14",
      gene_type : "protein_coding",
      gene_name : "SULF1",
      gene_level : 2,
      hgnc_id : "HGNC:20391",
      havana_gene : "OTTHUMG00000164466.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 69667046,
      stop : 69834978,
      direction : "-",
      ID : "ENSG00000137571.11",
      gene_id : "ENSG00000137571.11",
      gene_type : "protein_coding",
      gene_name : "SLCO5A1",
      gene_level : 1,
      hgnc_id : "HGNC:19046",
      havana_gene : "OTTHUMG00000165121.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 70051651,
      stop : 70071693,
      direction : "-",
      ID : "ENSG00000147596.4",
      gene_id : "ENSG00000147596.4",
      gene_type : "protein_coding",
      gene_name : "PRDM14",
      gene_level : 2,
      hgnc_id : "HGNC:14001",
      havana_gene : "OTTHUMG00000150495.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 70109782,
      stop : 70403808,
      direction : "-",
      ID : "ENSG00000140396.13",
      gene_id : "ENSG00000140396.13",
      gene_type : "protein_coding",
      gene_name : "NCOA2",
      gene_level : 2,
      hgnc_id : "HGNC:7669",
      havana_gene : "OTTHUMG00000164671.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 70573218,
      stop : 70608416,
      direction : "-",
      ID : "ENSG00000067167.8",
      gene_id : "ENSG00000067167.8",
      gene_type : "protein_coding",
      gene_name : "TRAM1",
      gene_level : 2,
      hgnc_id : "HGNC:20568",
      havana_gene : "OTTHUMG00000164428.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 70635318,
      stop : 70669185,
      direction : "-",
      ID : "ENSG00000147592.9",
      gene_id : "ENSG00000147592.9",
      gene_type : "protein_coding",
      gene_name : "LACTB2",
      gene_level : 2,
      hgnc_id : "HGNC:18512",
      havana_gene : "OTTHUMG00000164430.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 70669339,
      stop : 70790371,
      direction : "+",
      ID : "ENSG00000221947.8",
      gene_id : "ENSG00000221947.8",
      gene_type : "protein_coding",
      gene_name : "XKR9",
      gene_level : 2,
      hgnc_id : "HGNC:20937",
      havana_gene : "OTTHUMG00000164431.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 71197433,
      stop : 71592025,
      direction : "-",
      ID : "ENSG00000104313.20",
      gene_id : "ENSG00000104313.20",
      gene_type : "protein_coding",
      gene_name : "EYA1",
      gene_level : 2,
      hgnc_id : "HGNC:3519",
      havana_gene : "OTTHUMG00000149894.17",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 71841560,
      stop : 71844412,
      direction : "-",
      ID : "ENSG00000178860.9",
      gene_id : "ENSG00000178860.9",
      gene_type : "protein_coding",
      gene_name : "MSC",
      gene_level : 2,
      hgnc_id : "HGNC:7321",
      havana_gene : "OTTHUMG00000164489.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 72019917,
      stop : 72075584,
      direction : "-",
      ID : "ENSG00000104321.11",
      gene_id : "ENSG00000104321.11",
      gene_type : "protein_coding",
      gene_name : "TRPA1",
      gene_level : 2,
      hgnc_id : "HGNC:497",
      havana_gene : "OTTHUMG00000164516.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 72537225,
      stop : 72938349,
      direction : "+",
      ID : "ENSG00000182674.6",
      gene_id : "ENSG00000182674.6",
      gene_type : "protein_coding",
      gene_name : "KCNB2",
      gene_level : 2,
      hgnc_id : "HGNC:6232",
      havana_gene : "OTTHUMG00000164498.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73008856,
      stop : 73048123,
      direction : "+",
      ID : "ENSG00000147601.15",
      gene_id : "ENSG00000147601.15",
      gene_type : "protein_coding",
      gene_name : "TERF1",
      gene_level : 1,
      hgnc_id : "HGNC:11728",
      havana_gene : "OTTHUMG00000164522.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73064543,
      stop : 73124088,
      direction : "-",
      ID : "ENSG00000164764.11",
      gene_id : "ENSG00000164764.11",
      gene_type : "protein_coding",
      gene_name : "SBSPON",
      gene_level : 2,
      hgnc_id : "HGNC:30362",
      havana_gene : "OTTHUMG00000157144.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73241329,
      stop : 73259502,
      direction : "-",
      ID : "ENSG00000274443.4",
      gene_id : "ENSG00000274443.4",
      gene_type : "protein_coding",
      gene_name : "C8orf89",
      gene_level : 2,
      hgnc_id : "HGNC:51258",
      havana_gene : "OTTHUMG00000189250.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73290242,
      stop : 73295789,
      direction : "-",
      ID : "ENSG00000147604.14",
      gene_id : "ENSG00000147604.14",
      gene_type : "protein_coding",
      gene_name : "RPL7",
      gene_level : 1,
      hgnc_id : "HGNC:10363",
      havana_gene : "OTTHUMG00000134312.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73294602,
      stop : 73325281,
      direction : "+",
      ID : "ENSG00000121039.10",
      gene_id : "ENSG00000121039.10",
      gene_type : "protein_coding",
      gene_name : "RDH10",
      gene_level : 2,
      hgnc_id : "HGNC:19975",
      havana_gene : "OTTHUMG00000164492.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73420369,
      stop : 73747708,
      direction : "-",
      ID : "ENSG00000040341.18",
      gene_id : "ENSG00000040341.18",
      gene_type : "protein_coding",
      gene_name : "STAU2",
      gene_level : 1,
      hgnc_id : "HGNC:11371",
      havana_gene : "OTTHUMG00000164499.11",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73688691,
      stop : 73878854,
      direction : "-",
      ID : "ENSG00000258677.2",
      gene_id : "ENSG00000258677.2",
      gene_type : "protein_coding",
      gene_name : "AC022826.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000171407.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73780097,
      stop : 73878910,
      direction : "-",
      ID : "ENSG00000104343.21",
      gene_id : "ENSG00000104343.21",
      gene_type : "protein_coding",
      gene_name : "UBE2W",
      gene_level : 2,
      hgnc_id : "HGNC:25616",
      havana_gene : "OTTHUMG00000164517.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73939169,
      stop : 73972287,
      direction : "-",
      ID : "ENSG00000154582.17",
      gene_id : "ENSG00000154582.17",
      gene_type : "protein_coding",
      gene_name : "ELOC",
      gene_level : 1,
      hgnc_id : "HGNC:11617",
      havana_gene : "OTTHUMG00000164501.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73972437,
      stop : 73982783,
      direction : "+",
      ID : "ENSG00000175606.11",
      gene_id : "ENSG00000175606.11",
      gene_type : "protein_coding",
      gene_name : "TMEM70",
      gene_level : 2,
      hgnc_id : "HGNC:26050",
      havana_gene : "OTTHUMG00000164502.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 73991392,
      stop : 74029079,
      direction : "+",
      ID : "ENSG00000154589.7",
      gene_id : "ENSG00000154589.7",
      gene_type : "protein_coding",
      gene_name : "LY96",
      gene_level : 1,
      hgnc_id : "HGNC:17156",
      havana_gene : "OTTHUMG00000164504.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 74234700,
      stop : 74321540,
      direction : "-",
      ID : "ENSG00000104369.5",
      gene_id : "ENSG00000104369.5",
      gene_type : "protein_coding",
      gene_name : "JPH1",
      gene_level : 2,
      hgnc_id : "HGNC:14201",
      havana_gene : "OTTHUMG00000164524.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 74320613,
      stop : 74518007,
      direction : "+",
      ID : "ENSG00000104381.14",
      gene_id : "ENSG00000104381.14",
      gene_type : "protein_coding",
      gene_name : "GDAP1",
      gene_level : 2,
      hgnc_id : "HGNC:15968",
      havana_gene : "OTTHUMG00000164509.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 74824534,
      stop : 74855029,
      direction : "+",
      ID : "ENSG00000137558.9",
      gene_id : "ENSG00000137558.9",
      gene_type : "protein_coding",
      gene_name : "PI15",
      gene_level : 2,
      hgnc_id : "HGNC:8946",
      havana_gene : "OTTHUMG00000164528.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 74984505,
      stop : 75034558,
      direction : "+",
      ID : "ENSG00000121005.9",
      gene_id : "ENSG00000121005.9",
      gene_type : "protein_coding",
      gene_name : "CRISPLD1",
      gene_level : 1,
      hgnc_id : "HGNC:18206",
      havana_gene : "OTTHUMG00000164529.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 75407914,
      stop : 75566834,
      direction : "+",
      ID : "ENSG00000164749.13",
      gene_id : "ENSG00000164749.13",
      gene_type : "protein_coding",
      gene_name : "HNF4G",
      gene_level : 2,
      hgnc_id : "HGNC:5026",
      havana_gene : "OTTHUMG00000149920.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 76681239,
      stop : 76867281,
      direction : "+",
      ID : "ENSG00000091656.19",
      gene_id : "ENSG00000091656.19",
      gene_type : "protein_coding",
      gene_name : "ZFHX4",
      gene_level : 2,
      hgnc_id : "HGNC:30939",
      havana_gene : "OTTHUMG00000164557.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 76980258,
      stop : 77001044,
      direction : "-",
      ID : "ENSG00000164751.15",
      gene_id : "ENSG00000164751.15",
      gene_type : "protein_coding",
      gene_name : "PEX2",
      gene_level : 2,
      hgnc_id : "HGNC:9717",
      havana_gene : "OTTHUMG00000164530.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 78516340,
      stop : 78605267,
      direction : "+",
      ID : "ENSG00000171033.13",
      gene_id : "ENSG00000171033.13",
      gene_type : "protein_coding",
      gene_name : "PKIA",
      gene_level : 2,
      hgnc_id : "HGNC:9017",
      havana_gene : "OTTHUMG00000164618.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 78666089,
      stop : 78719765,
      direction : "+",
      ID : "ENSG00000104427.12",
      gene_id : "ENSG00000104427.12",
      gene_type : "protein_coding",
      gene_name : "ZC2HC1A",
      gene_level : 1,
      hgnc_id : "HGNC:24277",
      havana_gene : "OTTHUMG00000164619.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 78675743,
      stop : 78805523,
      direction : "-",
      ID : "ENSG00000104432.14",
      gene_id : "ENSG00000104432.14",
      gene_type : "protein_coding",
      gene_name : "IL7",
      gene_level : 2,
      hgnc_id : "HGNC:6023",
      havana_gene : "OTTHUMG00000164620.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 79611117,
      stop : 79666158,
      direction : "+",
      ID : "ENSG00000104435.14",
      gene_id : "ENSG00000104435.14",
      gene_type : "protein_coding",
      gene_name : "STMN2",
      gene_level : 1,
      hgnc_id : "HGNC:10577",
      havana_gene : "OTTHUMG00000164610.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 79762371,
      stop : 79767857,
      direction : "-",
      ID : "ENSG00000164683.18",
      gene_id : "ENSG00000164683.18",
      gene_type : "protein_coding",
      gene_name : "HEY1",
      gene_level : 1,
      hgnc_id : "HGNC:4880",
      havana_gene : "OTTHUMG00000164641.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 79918717,
      stop : 80030289,
      direction : "-",
      ID : "ENSG00000147586.10",
      gene_id : "ENSG00000147586.10",
      gene_type : "protein_coding",
      gene_name : "MRPS28",
      gene_level : 1,
      hgnc_id : "HGNC:14513",
      havana_gene : "OTTHUMG00000164642.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 79918860,
      stop : 80080775,
      direction : "-",
      ID : "ENSG00000276418.5",
      gene_id : "ENSG00000276418.5",
      gene_type : "protein_coding",
      gene_name : "AC036214.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186650.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 80034745,
      stop : 80231232,
      direction : "-",
      ID : "ENSG00000076554.15",
      gene_id : "ENSG00000076554.15",
      gene_type : "protein_coding",
      gene_name : "TPD52",
      gene_level : 1,
      hgnc_id : "HGNC:12005",
      havana_gene : "OTTHUMG00000164565.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 80485619,
      stop : 80526265,
      direction : "+",
      ID : "ENSG00000205189.12",
      gene_id : "ENSG00000205189.12",
      gene_type : "protein_coding",
      gene_name : "ZBTB10",
      gene_level : 1,
      hgnc_id : "HGNC:30953",
      havana_gene : "OTTHUMG00000155016.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 80628451,
      stop : 80874781,
      direction : "-",
      ID : "ENSG00000164684.13",
      gene_id : "ENSG00000164684.13",
      gene_type : "protein_coding",
      gene_name : "ZNF704",
      gene_level : 1,
      hgnc_id : "HGNC:32291",
      havana_gene : "OTTHUMG00000164733.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 80967810,
      stop : 81112068,
      direction : "-",
      ID : "ENSG00000076641.4",
      gene_id : "ENSG00000076641.4",
      gene_type : "protein_coding",
      gene_name : "PAG1",
      gene_level : 2,
      hgnc_id : "HGNC:30043",
      havana_gene : "OTTHUMG00000164592.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81280536,
      stop : 81284777,
      direction : "+",
      ID : "ENSG00000164687.11",
      gene_id : "ENSG00000164687.11",
      gene_type : "protein_coding",
      gene_name : "FABP5",
      gene_level : 1,
      hgnc_id : "HGNC:3560",
      havana_gene : "OTTHUMG00000134313.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81440326,
      stop : 81447439,
      direction : "-",
      ID : "ENSG00000147588.7",
      gene_id : "ENSG00000147588.7",
      gene_type : "protein_coding",
      gene_name : "PMP2",
      gene_level : 1,
      hgnc_id : "HGNC:9117",
      havana_gene : "OTTHUMG00000164600.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81458253,
      stop : 81461579,
      direction : "-",
      ID : "ENSG00000205186.4",
      gene_id : "ENSG00000205186.4",
      gene_type : "protein_coding",
      gene_name : "FABP9",
      gene_level : 2,
      hgnc_id : "HGNC:3563",
      havana_gene : "OTTHUMG00000164601.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81478419,
      stop : 81483236,
      direction : "-",
      ID : "ENSG00000170323.9",
      gene_id : "ENSG00000170323.9",
      gene_type : "protein_coding",
      gene_name : "FABP4",
      gene_level : 2,
      hgnc_id : "HGNC:3559",
      havana_gene : "OTTHUMG00000164602.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81524981,
      stop : 81531378,
      direction : "-",
      ID : "ENSG00000197416.4",
      gene_id : "ENSG00000197416.4",
      gene_type : "protein_coding",
      gene_name : "FABP12",
      gene_level : 2,
      hgnc_id : "HGNC:34524",
      havana_gene : "OTTHUMG00000164679.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81656914,
      stop : 81686331,
      direction : "-",
      ID : "ENSG00000133731.10",
      gene_id : "ENSG00000133731.10",
      gene_type : "protein_coding",
      gene_name : "IMPA1",
      gene_level : 2,
      hgnc_id : "HGNC:6050",
      havana_gene : "OTTHUMG00000164682.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81693631,
      stop : 81695058,
      direction : "-",
      ID : "ENSG00000253598.3",
      gene_id : "ENSG00000253598.3",
      gene_type : "protein_coding",
      gene_name : "SLC10A5",
      gene_level : 2,
      hgnc_id : "HGNC:22981",
      havana_gene : "OTTHUMG00000164683.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81701334,
      stop : 81732903,
      direction : "-",
      ID : "ENSG00000104231.11",
      gene_id : "ENSG00000104231.11",
      gene_type : "protein_coding",
      gene_name : "ZFAND1",
      gene_level : 2,
      hgnc_id : "HGNC:25858",
      havana_gene : "OTTHUMG00000164684.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81732448,
      stop : 81759515,
      direction : "+",
      ID : "ENSG00000164695.5",
      gene_id : "ENSG00000164695.5",
      gene_type : "protein_coding",
      gene_name : "CHMP4C",
      gene_level : 2,
      hgnc_id : "HGNC:30599",
      havana_gene : "OTTHUMG00000164726.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 81799581,
      stop : 81842866,
      direction : "-",
      ID : "ENSG00000104497.14",
      gene_id : "ENSG00000104497.14",
      gene_type : "protein_coding",
      gene_name : "SNX16",
      gene_level : 2,
      hgnc_id : "HGNC:14980",
      havana_gene : "OTTHUMG00000164727.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 84182787,
      stop : 84921844,
      direction : "+",
      ID : "ENSG00000184672.12",
      gene_id : "ENSG00000184672.12",
      gene_type : "protein_coding",
      gene_name : "RALYL",
      gene_level : 2,
      hgnc_id : "HGNC:27036",
      havana_gene : "OTTHUMG00000164628.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85107215,
      stop : 85146080,
      direction : "+",
      ID : "ENSG00000133739.16",
      gene_id : "ENSG00000133739.16",
      gene_type : "protein_coding",
      gene_name : "LRRCC1",
      gene_level : 2,
      hgnc_id : "HGNC:29373",
      havana_gene : "OTTHUMG00000164784.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85177154,
      stop : 85217158,
      direction : "+",
      ID : "ENSG00000133740.11",
      gene_id : "ENSG00000133740.11",
      gene_type : "protein_coding",
      gene_name : "E2F5",
      gene_level : 2,
      hgnc_id : "HGNC:3119",
      havana_gene : "OTTHUMG00000164785.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85214048,
      stop : 85220421,
      direction : "-",
      ID : "ENSG00000176731.12",
      gene_id : "ENSG00000176731.12",
      gene_type : "protein_coding",
      gene_name : "RBIS",
      gene_level : 2,
      hgnc_id : "HGNC:32235",
      havana_gene : "OTTHUMG00000164787.10",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85220587,
      stop : 85284073,
      direction : "+",
      ID : "ENSG00000185015.8",
      gene_id : "ENSG00000185015.8",
      gene_type : "protein_coding",
      gene_name : "CA13",
      gene_level : 2,
      hgnc_id : "HGNC:14914",
      havana_gene : "OTTHUMG00000164940.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85327608,
      stop : 85379014,
      direction : "-",
      ID : "ENSG00000133742.14",
      gene_id : "ENSG00000133742.14",
      gene_type : "protein_coding",
      gene_name : "CA1",
      gene_level : 2,
      hgnc_id : "HGNC:1368",
      havana_gene : "OTTHUMG00000164941.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85373436,
      stop : 85449040,
      direction : "+",
      ID : "ENSG00000164879.7",
      gene_id : "ENSG00000164879.7",
      gene_type : "protein_coding",
      gene_name : "CA3",
      gene_level : 2,
      hgnc_id : "HGNC:1374",
      havana_gene : "OTTHUMG00000164942.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85463968,
      stop : 85481493,
      direction : "+",
      ID : "ENSG00000104267.10",
      gene_id : "ENSG00000104267.10",
      gene_type : "protein_coding",
      gene_name : "CA2",
      gene_level : 2,
      hgnc_id : "HGNC:1373",
      havana_gene : "OTTHUMG00000164944.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 85987323,
      stop : 86154225,
      direction : "+",
      ID : "ENSG00000147614.4",
      gene_id : "ENSG00000147614.4",
      gene_type : "protein_coding",
      gene_name : "ATP6V0D2",
      gene_level : 2,
      hgnc_id : "HGNC:18266",
      havana_gene : "OTTHUMG00000163637.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86047109,
      stop : 86088621,
      direction : "-",
      ID : "ENSG00000147613.8",
      gene_id : "ENSG00000147613.8",
      gene_type : "protein_coding",
      gene_name : "PSKH2",
      gene_level : 2,
      hgnc_id : "HGNC:18997",
      havana_gene : "OTTHUMG00000163638.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86214063,
      stop : 86321146,
      direction : "-",
      ID : "ENSG00000164893.9",
      gene_id : "ENSG00000164893.9",
      gene_type : "protein_coding",
      gene_name : "SLC7A13",
      gene_level : 2,
      hgnc_id : "HGNC:23092",
      havana_gene : "OTTHUMG00000163663.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86342547,
      stop : 86478420,
      direction : "+",
      ID : "ENSG00000123124.14",
      gene_id : "ENSG00000123124.14",
      gene_type : "protein_coding",
      gene_name : "WWP1",
      gene_level : 1,
      hgnc_id : "HGNC:17004",
      havana_gene : "OTTHUMG00000163690.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86468257,
      stop : 86514357,
      direction : "-",
      ID : "ENSG00000176623.12",
      gene_id : "ENSG00000176623.12",
      gene_type : "protein_coding",
      gene_name : "RMDN1",
      gene_level : 1,
      hgnc_id : "HGNC:24285",
      havana_gene : "OTTHUMG00000163692.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86514435,
      stop : 86561498,
      direction : "+",
      ID : "ENSG00000085719.13",
      gene_id : "ENSG00000085719.13",
      gene_type : "protein_coding",
      gene_name : "CPNE3",
      gene_level : 2,
      hgnc_id : "HGNC:2316",
      havana_gene : "OTTHUMG00000163725.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86553977,
      stop : 86743675,
      direction : "-",
      ID : "ENSG00000170289.13",
      gene_id : "ENSG00000170289.13",
      gene_type : "protein_coding",
      gene_name : "CNGB3",
      gene_level : 1,
      hgnc_id : "HGNC:2153",
      havana_gene : "OTTHUMG00000163738.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 86866415,
      stop : 87615219,
      direction : "+",
      ID : "ENSG00000176571.12",
      gene_id : "ENSG00000176571.12",
      gene_type : "protein_coding",
      gene_name : "CNBD1",
      gene_level : 2,
      hgnc_id : "HGNC:26663",
      havana_gene : "OTTHUMG00000163743.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 87870747,
      stop : 87874015,
      direction : "-",
      ID : "ENSG00000176566.5",
      gene_id : "ENSG00000176566.5",
      gene_type : "protein_coding",
      gene_name : "DCAF4L2",
      gene_level : 2,
      hgnc_id : "HGNC:26657",
      havana_gene : "OTTHUMG00000163767.2",
      tag : "retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 88032011,
      stop : 88328025,
      direction : "-",
      ID : "ENSG00000156103.16",
      gene_id : "ENSG00000156103.16",
      gene_type : "protein_coding",
      gene_name : "MMP16",
      gene_level : 2,
      hgnc_id : "HGNC:7162",
      havana_gene : "OTTHUMG00000163769.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 89757806,
      stop : 89791064,
      direction : "+",
      ID : "ENSG00000104312.8",
      gene_id : "ENSG00000104312.8",
      gene_type : "protein_coding",
      gene_name : "RIPK2",
      gene_level : 2,
      hgnc_id : "HGNC:10020",
      havana_gene : "OTTHUMG00000163809.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 89901849,
      stop : 89927888,
      direction : "+",
      ID : "ENSG00000164823.11",
      gene_id : "ENSG00000164823.11",
      gene_type : "protein_coding",
      gene_name : "OSGIN2",
      gene_level : 2,
      hgnc_id : "HGNC:1355",
      havana_gene : "OTTHUMG00000163811.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 89933331,
      stop : 90003228,
      direction : "-",
      ID : "ENSG00000104320.14",
      gene_id : "ENSG00000104320.14",
      gene_type : "protein_coding",
      gene_name : "NBN",
      gene_level : 1,
      hgnc_id : "HGNC:7652",
      havana_gene : "OTTHUMG00000153546.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 90001405,
      stop : 90053633,
      direction : "+",
      ID : "ENSG00000104325.7",
      gene_id : "ENSG00000104325.7",
      gene_type : "protein_coding",
      gene_name : "DECR1",
      gene_level : 1,
      hgnc_id : "HGNC:2753",
      havana_gene : "OTTHUMG00000163829.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 90058608,
      stop : 90095475,
      direction : "-",
      ID : "ENSG00000104327.7",
      gene_id : "ENSG00000104327.7",
      gene_type : "protein_coding",
      gene_name : "CALB1",
      gene_level : 1,
      hgnc_id : "HGNC:1434",
      havana_gene : "OTTHUMG00000134314.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 90621995,
      stop : 90791632,
      direction : "-",
      ID : "ENSG00000180694.14",
      gene_id : "ENSG00000180694.14",
      gene_type : "protein_coding",
      gene_name : "TMEM64",
      gene_level : 2,
      hgnc_id : "HGNC:25441",
      havana_gene : "OTTHUMG00000157185.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 90791741,
      stop : 90959393,
      direction : "+",
      ID : "ENSG00000123119.12",
      gene_id : "ENSG00000123119.12",
      gene_type : "protein_coding",
      gene_name : "NECAB1",
      gene_level : 2,
      hgnc_id : "HGNC:20983",
      havana_gene : "OTTHUMG00000164009.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 90958471,
      stop : 90985238,
      direction : "-",
      ID : "ENSG00000253250.3",
      gene_id : "ENSG00000253250.3",
      gene_type : "protein_coding",
      gene_name : "C8orf88",
      gene_level : 1,
      hgnc_id : "HGNC:44672",
      havana_gene : "OTTHUMG00000164011.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 90993802,
      stop : 91040872,
      direction : "-",
      ID : "ENSG00000155099.8",
      gene_id : "ENSG00000155099.8",
      gene_type : "protein_coding",
      gene_name : "PIP4P2",
      gene_level : 2,
      hgnc_id : "HGNC:25452",
      havana_gene : "OTTHUMG00000164019.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 91070196,
      stop : 91087095,
      direction : "+",
      ID : "ENSG00000155100.11",
      gene_id : "ENSG00000155100.11",
      gene_type : "protein_coding",
      gene_name : "OTUD6B",
      gene_level : 1,
      hgnc_id : "HGNC:24281",
      havana_gene : "OTTHUMG00000150758.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 91101832,
      stop : 91219236,
      direction : "+",
      ID : "ENSG00000214954.8",
      gene_id : "ENSG00000214954.8",
      gene_type : "protein_coding",
      gene_name : "LRRC69",
      gene_level : 1,
      hgnc_id : "HGNC:34303",
      havana_gene : "OTTHUMG00000164023.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 91209494,
      stop : 91398155,
      direction : "+",
      ID : "ENSG00000147606.9",
      gene_id : "ENSG00000147606.9",
      gene_type : "protein_coding",
      gene_name : "SLC26A7",
      gene_level : 2,
      hgnc_id : "HGNC:14467",
      havana_gene : "OTTHUMG00000164062.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 91954967,
      stop : 92103286,
      direction : "-",
      ID : "ENSG00000079102.16",
      gene_id : "ENSG00000079102.16",
      gene_type : "protein_coding",
      gene_name : "RUNX1T1",
      gene_level : 2,
      hgnc_id : "HGNC:1535",
      havana_gene : "OTTHUMG00000164066.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 92883532,
      stop : 93017673,
      direction : "-",
      ID : "ENSG00000205133.12",
      gene_id : "ENSG00000205133.12",
      gene_type : "protein_coding",
      gene_name : "TRIQK",
      gene_level : 2,
      hgnc_id : "HGNC:27828",
      havana_gene : "OTTHUMG00000164162.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 93698561,
      stop : 93731527,
      direction : "+",
      ID : "ENSG00000188343.13",
      gene_id : "ENSG00000188343.13",
      gene_type : "protein_coding",
      gene_name : "CIBAR1",
      gene_level : 1,
      hgnc_id : "HGNC:30452",
      havana_gene : "OTTHUMG00000164238.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 93729356,
      stop : 93741017,
      direction : "-",
      ID : "ENSG00000183808.11",
      gene_id : "ENSG00000183808.11",
      gene_type : "protein_coding",
      gene_name : "RBM12B",
      gene_level : 2,
      hgnc_id : "HGNC:32310",
      havana_gene : "OTTHUMG00000164317.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 93754844,
      stop : 93819234,
      direction : "+",
      ID : "ENSG00000164953.16",
      gene_id : "ENSG00000164953.16",
      gene_type : "protein_coding",
      gene_name : "TMEM67",
      gene_level : 2,
      hgnc_id : "HGNC:28396",
      havana_gene : "OTTHUMG00000153119.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 93857807,
      stop : 93926068,
      direction : "+",
      ID : "ENSG00000164951.16",
      gene_id : "ENSG00000164951.16",
      gene_type : "protein_coding",
      gene_name : "PDP1",
      gene_level : 2,
      hgnc_id : "HGNC:9279",
      havana_gene : "OTTHUMG00000164356.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94127162,
      stop : 94217303,
      direction : "-",
      ID : "ENSG00000079112.10",
      gene_id : "ENSG00000079112.10",
      gene_type : "protein_coding",
      gene_name : "CDH17",
      gene_level : 1,
      hgnc_id : "HGNC:1756",
      havana_gene : "OTTHUMG00000164391.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94249253,
      stop : 94262350,
      direction : "-",
      ID : "ENSG00000164949.8",
      gene_id : "ENSG00000164949.8",
      gene_type : "protein_coding",
      gene_name : "GEM",
      gene_level : 2,
      hgnc_id : "HGNC:4234",
      havana_gene : "OTTHUMG00000164392.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94371960,
      stop : 94475115,
      direction : "-",
      ID : "ENSG00000197275.14",
      gene_id : "ENSG00000197275.14",
      gene_type : "protein_coding",
      gene_name : "RAD54B",
      gene_level : 1,
      hgnc_id : "HGNC:17228",
      havana_gene : "OTTHUMG00000133658.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94378377,
      stop : 94436952,
      direction : "-",
      ID : "ENSG00000265817.4",
      gene_id : "ENSG00000265817.4",
      gene_type : "protein_coding",
      gene_name : "FSBP",
      gene_level : 2,
      hgnc_id : "HGNC:43653",
      havana_gene : "OTTHUMG00000178341.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94487689,
      stop : 94553529,
      direction : "-",
      ID : "ENSG00000164944.12",
      gene_id : "ENSG00000164944.12",
      gene_type : "protein_coding",
      gene_name : "VIRMA",
      gene_level : 1,
      hgnc_id : "HGNC:24500",
      havana_gene : "OTTHUMG00000164426.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94641074,
      stop : 94707466,
      direction : "+",
      ID : "ENSG00000104413.18",
      gene_id : "ENSG00000104413.18",
      gene_type : "protein_coding",
      gene_name : "ESRP1",
      gene_level : 1,
      hgnc_id : "HGNC:25966",
      havana_gene : "OTTHUMG00000164587.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94719703,
      stop : 94793836,
      direction : "+",
      ID : "ENSG00000156162.16",
      gene_id : "ENSG00000156162.16",
      gene_type : "protein_coding",
      gene_name : "DPY19L4",
      gene_level : 1,
      hgnc_id : "HGNC:27829",
      havana_gene : "OTTHUMG00000164589.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94813311,
      stop : 94881746,
      direction : "+",
      ID : "ENSG00000164941.14",
      gene_id : "ENSG00000164941.14",
      gene_type : "protein_coding",
      gene_name : "INTS8",
      gene_level : 1,
      hgnc_id : "HGNC:26048",
      havana_gene : "OTTHUMG00000164695.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94879770,
      stop : 94896678,
      direction : "-",
      ID : "ENSG00000175305.18",
      gene_id : "ENSG00000175305.18",
      gene_type : "protein_coding",
      gene_name : "CCNE2",
      gene_level : 2,
      hgnc_id : "HGNC:1590",
      havana_gene : "OTTHUMG00000164696.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94895767,
      stop : 95116455,
      direction : "+",
      ID : "ENSG00000156170.13",
      gene_id : "ENSG00000156170.13",
      gene_type : "protein_coding",
      gene_name : "NDUFAF6",
      gene_level : 1,
      hgnc_id : "HGNC:28625",
      havana_gene : "OTTHUMG00000150173.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 94925972,
      stop : 94949378,
      direction : "-",
      ID : "ENSG00000164938.14",
      gene_id : "ENSG00000164938.14",
      gene_type : "protein_coding",
      gene_name : "TP53INP1",
      gene_level : 2,
      hgnc_id : "HGNC:18022",
      havana_gene : "OTTHUMG00000164697.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 95133785,
      stop : 95156685,
      direction : "+",
      ID : "ENSG00000175895.4",
      gene_id : "ENSG00000175895.4",
      gene_type : "protein_coding",
      gene_name : "PLEKHF2",
      gene_level : 2,
      hgnc_id : "HGNC:20757",
      havana_gene : "OTTHUMG00000164660.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 95244913,
      stop : 95269201,
      direction : "-",
      ID : "ENSG00000156172.6",
      gene_id : "ENSG00000156172.6",
      gene_type : "protein_coding",
      gene_name : "C8orf37",
      gene_level : 2,
      hgnc_id : "HGNC:27232",
      havana_gene : "OTTHUMG00000164663.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 96142333,
      stop : 96160806,
      direction : "-",
      ID : "ENSG00000156466.10",
      gene_id : "ENSG00000156466.10",
      gene_type : "protein_coding",
      gene_name : "GDF6",
      gene_level : 2,
      hgnc_id : "HGNC:4221",
      havana_gene : "OTTHUMG00000164710.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 96222947,
      stop : 96235546,
      direction : "-",
      ID : "ENSG00000156467.10",
      gene_id : "ENSG00000156467.10",
      gene_type : "protein_coding",
      gene_name : "UQCRB",
      gene_level : 1,
      hgnc_id : "HGNC:12582",
      havana_gene : "OTTHUMG00000164711.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 96239398,
      stop : 96261610,
      direction : "-",
      ID : "ENSG00000156469.9",
      gene_id : "ENSG00000156469.9",
      gene_type : "protein_coding",
      gene_name : "MTERF3",
      gene_level : 1,
      hgnc_id : "HGNC:24258",
      havana_gene : "OTTHUMG00000164713.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 96261902,
      stop : 96336995,
      direction : "+",
      ID : "ENSG00000156471.13",
      gene_id : "ENSG00000156471.13",
      gene_type : "protein_coding",
      gene_name : "PTDSS1",
      gene_level : 2,
      hgnc_id : "HGNC:9587",
      havana_gene : "OTTHUMG00000164687.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 96493813,
      stop : 96611790,
      direction : "+",
      ID : "ENSG00000169439.12",
      gene_id : "ENSG00000169439.12",
      gene_type : "protein_coding",
      gene_name : "SDC2",
      gene_level : 1,
      hgnc_id : "HGNC:10659",
      havana_gene : "OTTHUMG00000164689.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 96645242,
      stop : 97149654,
      direction : "+",
      ID : "ENSG00000104324.16",
      gene_id : "ENSG00000104324.16",
      gene_type : "protein_coding",
      gene_name : "CPQ",
      gene_level : 1,
      hgnc_id : "HGNC:16910",
      havana_gene : "OTTHUMG00000164690.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 97273488,
      stop : 97277928,
      direction : "-",
      ID : "ENSG00000180543.5",
      gene_id : "ENSG00000180543.5",
      gene_type : "protein_coding",
      gene_name : "TSPYL5",
      gene_level : 2,
      hgnc_id : "HGNC:29367",
      havana_gene : "OTTHUMG00000164857.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 97644184,
      stop : 97730260,
      direction : "+",
      ID : "ENSG00000147649.10",
      gene_id : "ENSG00000147649.10",
      gene_type : "protein_coding",
      gene_name : "MTDH",
      gene_level : 1,
      hgnc_id : "HGNC:29608",
      havana_gene : "OTTHUMG00000164692.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 97775057,
      stop : 97853013,
      direction : "+",
      ID : "ENSG00000104341.17",
      gene_id : "ENSG00000104341.17",
      gene_type : "protein_coding",
      gene_name : "LAPTM4B",
      gene_level : 2,
      hgnc_id : "HGNC:13646",
      havana_gene : "OTTHUMG00000164740.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 97868840,
      stop : 98036724,
      direction : "+",
      ID : "ENSG00000132561.14",
      gene_id : "ENSG00000132561.14",
      gene_type : "protein_coding",
      gene_name : "MATN2",
      gene_level : 1,
      hgnc_id : "HGNC:6908",
      havana_gene : "OTTHUMG00000164795.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98024851,
      stop : 98046469,
      direction : "-",
      ID : "ENSG00000156482.11",
      gene_id : "ENSG00000156482.11",
      gene_type : "protein_coding",
      gene_name : "RPL30",
      gene_level : 2,
      hgnc_id : "HGNC:10333",
      havana_gene : "OTTHUMG00000164796.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98064522,
      stop : 98093610,
      direction : "+",
      ID : "ENSG00000177459.11",
      gene_id : "ENSG00000177459.11",
      gene_type : "protein_coding",
      gene_name : "ERICH5",
      gene_level : 2,
      hgnc_id : "HGNC:26823",
      havana_gene : "OTTHUMG00000164819.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98102344,
      stop : 98117171,
      direction : "-",
      ID : "ENSG00000132541.11",
      gene_id : "ENSG00000132541.11",
      gene_type : "protein_coding",
      gene_name : "RIDA",
      gene_level : 2,
      hgnc_id : "HGNC:16897",
      havana_gene : "OTTHUMG00000164670.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98117293,
      stop : 98159835,
      direction : "+",
      ID : "ENSG00000104356.11",
      gene_id : "ENSG00000104356.11",
      gene_type : "protein_coding",
      gene_name : "POP1",
      gene_level : 2,
      hgnc_id : "HGNC:30129",
      havana_gene : "OTTHUMG00000164635.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98189826,
      stop : 98294393,
      direction : "-",
      ID : "ENSG00000104361.10",
      gene_id : "ENSG00000104361.10",
      gene_type : "protein_coding",
      gene_name : "NIPAL2",
      gene_level : 2,
      hgnc_id : "HGNC:25854",
      havana_gene : "OTTHUMG00000164668.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98371228,
      stop : 98942827,
      direction : "-",
      ID : "ENSG00000104375.17",
      gene_id : "ENSG00000104375.17",
      gene_type : "protein_coding",
      gene_name : "STK3",
      gene_level : 1,
      hgnc_id : "HGNC:11406",
      havana_gene : "OTTHUMG00000164651.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98426958,
      stop : 98432853,
      direction : "+",
      ID : "ENSG00000156486.8",
      gene_id : "ENSG00000156486.8",
      gene_type : "protein_coding",
      gene_name : "KCNS2",
      gene_level : 2,
      hgnc_id : "HGNC:6301",
      havana_gene : "OTTHUMG00000044337.4",
      tag : "retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 98944403,
      stop : 98952104,
      direction : "+",
      ID : "ENSG00000164920.9",
      gene_id : "ENSG00000164920.9",
      gene_type : "protein_coding",
      gene_name : "OSR2",
      gene_level : 2,
      hgnc_id : "HGNC:15830",
      havana_gene : "OTTHUMG00000164640.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 99013266,
      stop : 99877580,
      direction : "+",
      ID : "ENSG00000132549.19",
      gene_id : "ENSG00000132549.19",
      gene_type : "protein_coding",
      gene_name : "VPS13B",
      gene_level : 2,
      hgnc_id : "HGNC:2183",
      havana_gene : "OTTHUMG00000140383.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 99873200,
      stop : 99893707,
      direction : "-",
      ID : "ENSG00000164919.11",
      gene_id : "ENSG00000164919.11",
      gene_type : "protein_coding",
      gene_name : "COX6C",
      gene_level : 2,
      hgnc_id : "HGNC:2285",
      havana_gene : "OTTHUMG00000164703.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 99960936,
      stop : 100131268,
      direction : "-",
      ID : "ENSG00000132554.20",
      gene_id : "ENSG00000132554.20",
      gene_type : "protein_coding",
      gene_name : "RGS22",
      gene_level : 1,
      hgnc_id : "HGNC:24499",
      havana_gene : "OTTHUMG00000164802.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100133351,
      stop : 100145817,
      direction : "-",
      ID : "ENSG00000156509.14",
      gene_id : "ENSG00000156509.14",
      gene_type : "protein_coding",
      gene_name : "FBXO43",
      gene_level : 2,
      hgnc_id : "HGNC:28521",
      havana_gene : "OTTHUMG00000164803.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100150623,
      stop : 100154003,
      direction : "+",
      ID : "ENSG00000147669.11",
      gene_id : "ENSG00000147669.11",
      gene_type : "protein_coding",
      gene_name : "POLR2K",
      gene_level : 2,
      hgnc_id : "HGNC:9198",
      havana_gene : "OTTHUMG00000164705.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100157906,
      stop : 100259278,
      direction : "+",
      ID : "ENSG00000104450.13",
      gene_id : "ENSG00000104450.13",
      gene_type : "protein_coding",
      gene_name : "SPAG1",
      gene_level : 2,
      hgnc_id : "HGNC:11212",
      havana_gene : "OTTHUMG00000164706.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100257060,
      stop : 100336218,
      direction : "-",
      ID : "ENSG00000034677.13",
      gene_id : "ENSG00000034677.13",
      gene_type : "protein_coding",
      gene_name : "RNF19A",
      gene_level : 2,
      hgnc_id : "HGNC:13432",
      havana_gene : "OTTHUMG00000164707.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100509752,
      stop : 100559784,
      direction : "-",
      ID : "ENSG00000186106.11",
      gene_id : "ENSG00000186106.11",
      gene_type : "protein_coding",
      gene_name : "ANKRD46",
      gene_level : 2,
      hgnc_id : "HGNC:27229",
      havana_gene : "OTTHUMG00000164724.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100572889,
      stop : 100663415,
      direction : "-",
      ID : "ENSG00000174226.9",
      gene_id : "ENSG00000174226.9",
      gene_type : "protein_coding",
      gene_name : "SNX31",
      gene_level : 1,
      hgnc_id : "HGNC:28605",
      havana_gene : "OTTHUMG00000164725.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100685816,
      stop : 100722809,
      direction : "-",
      ID : "ENSG00000070756.17",
      gene_id : "ENSG00000070756.17",
      gene_type : "protein_coding",
      gene_name : "PABPC1",
      gene_level : 2,
      hgnc_id : "HGNC:8554",
      havana_gene : "OTTHUMG00000164779.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 100916523,
      stop : 100953388,
      direction : "-",
      ID : "ENSG00000164924.18",
      gene_id : "ENSG00000164924.18",
      gene_type : "protein_coding",
      gene_name : "YWHAZ",
      gene_level : 1,
      hgnc_id : "HGNC:12855",
      havana_gene : "OTTHUMG00000134291.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 101177878,
      stop : 101206193,
      direction : "-",
      ID : "ENSG00000120963.12",
      gene_id : "ENSG00000120963.12",
      gene_type : "protein_coding",
      gene_name : "ZNF706",
      gene_level : 1,
      hgnc_id : "HGNC:24992",
      havana_gene : "OTTHUMG00000164823.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 101492439,
      stop : 101669726,
      direction : "+",
      ID : "ENSG00000083307.12",
      gene_id : "ENSG00000083307.12",
      gene_type : "protein_coding",
      gene_name : "GRHL2",
      gene_level : 2,
      hgnc_id : "HGNC:2799",
      havana_gene : "OTTHUMG00000149915.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 101686542,
      stop : 102124907,
      direction : "-",
      ID : "ENSG00000104490.18",
      gene_id : "ENSG00000104490.18",
      gene_type : "protein_coding",
      gene_name : "NCALD",
      gene_level : 1,
      hgnc_id : "HGNC:7655",
      havana_gene : "OTTHUMG00000164876.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 102204502,
      stop : 102238961,
      direction : "-",
      ID : "ENSG00000048392.12",
      gene_id : "ENSG00000048392.12",
      gene_type : "protein_coding",
      gene_name : "RRM2B",
      gene_level : 1,
      hgnc_id : "HGNC:17296",
      havana_gene : "OTTHUMG00000164776.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 102252273,
      stop : 102412759,
      direction : "-",
      ID : "ENSG00000104517.13",
      gene_id : "ENSG00000104517.13",
      gene_type : "protein_coding",
      gene_name : "UBR5",
      gene_level : 1,
      hgnc_id : "HGNC:16806",
      havana_gene : "OTTHUMG00000164755.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 102551589,
      stop : 102561018,
      direction : "+",
      ID : "ENSG00000155087.4",
      gene_id : "ENSG00000155087.4",
      gene_type : "protein_coding",
      gene_name : "ODF1",
      gene_level : 2,
      hgnc_id : "HGNC:8113",
      havana_gene : "OTTHUMG00000164719.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 102648784,
      stop : 102655725,
      direction : "-",
      ID : "ENSG00000155090.15",
      gene_id : "ENSG00000155090.15",
      gene_type : "protein_coding",
      gene_name : "KLF10",
      gene_level : 2,
      hgnc_id : "HGNC:11810",
      havana_gene : "OTTHUMG00000164735.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 102826308,
      stop : 102893864,
      direction : "-",
      ID : "ENSG00000155096.14",
      gene_id : "ENSG00000155096.14",
      gene_type : "protein_coding",
      gene_name : "AZIN1",
      gene_level : 1,
      hgnc_id : "HGNC:16432",
      havana_gene : "OTTHUMG00000164766.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103021063,
      stop : 103073051,
      direction : "+",
      ID : "ENSG00000155097.12",
      gene_id : "ENSG00000155097.12",
      gene_type : "protein_coding",
      gene_name : "ATP6V1C1",
      gene_level : 1,
      hgnc_id : "HGNC:856",
      havana_gene : "OTTHUMG00000164761.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103140713,
      stop : 103230305,
      direction : "+",
      ID : "ENSG00000164929.17",
      gene_id : "ENSG00000164929.17",
      gene_type : "protein_coding",
      gene_name : "BAALC",
      gene_level : 2,
      hgnc_id : "HGNC:14333",
      havana_gene : "OTTHUMG00000164782.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103298433,
      stop : 103332866,
      direction : "+",
      ID : "ENSG00000164930.12",
      gene_id : "ENSG00000164930.12",
      gene_type : "protein_coding",
      gene_name : "FZD6",
      gene_level : 2,
      hgnc_id : "HGNC:4044",
      havana_gene : "OTTHUMG00000164840.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103371538,
      stop : 103382989,
      direction : "+",
      ID : "ENSG00000164932.13",
      gene_id : "ENSG00000164932.13",
      gene_type : "protein_coding",
      gene_name : "CTHRC1",
      gene_level : 1,
      hgnc_id : "HGNC:18831",
      havana_gene : "OTTHUMG00000164887.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103398635,
      stop : 103415189,
      direction : "-",
      ID : "ENSG00000164933.12",
      gene_id : "ENSG00000164933.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A32",
      gene_level : 2,
      hgnc_id : "HGNC:29683",
      havana_gene : "OTTHUMG00000164790.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103398658,
      stop : 103501895,
      direction : "-",
      ID : "ENSG00000285982.1",
      gene_id : "ENSG00000285982.1",
      gene_type : "protein_coding",
      gene_name : "AC012213.5",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193366.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103414714,
      stop : 103443453,
      direction : "+",
      ID : "ENSG00000164934.14",
      gene_id : "ENSG00000164934.14",
      gene_type : "protein_coding",
      gene_name : "DCAF13",
      gene_level : 2,
      hgnc_id : "HGNC:24535",
      havana_gene : "OTTHUMG00000164888.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 103500696,
      stop : 104256094,
      direction : "+",
      ID : "ENSG00000176406.23",
      gene_id : "ENSG00000176406.23",
      gene_type : "protein_coding",
      gene_name : "RIMS2",
      gene_level : 1,
      hgnc_id : "HGNC:17283",
      havana_gene : "OTTHUMG00000162097.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 104330324,
      stop : 104467055,
      direction : "-",
      ID : "ENSG00000147647.13",
      gene_id : "ENSG00000147647.13",
      gene_type : "protein_coding",
      gene_name : "DPYS",
      gene_level : 1,
      hgnc_id : "HGNC:3013",
      havana_gene : "OTTHUMG00000164891.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 104339087,
      stop : 104356689,
      direction : "+",
      ID : "ENSG00000164935.6",
      gene_id : "ENSG00000164935.6",
      gene_type : "protein_coding",
      gene_name : "DCSTAMP",
      gene_level : 1,
      hgnc_id : "HGNC:18549",
      havana_gene : "OTTHUMG00000164890.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 104489231,
      stop : 104589258,
      direction : "-",
      ID : "ENSG00000147650.12",
      gene_id : "ENSG00000147650.12",
      gene_type : "protein_coding",
      gene_name : "LRP12",
      gene_level : 2,
      hgnc_id : "HGNC:31708",
      havana_gene : "OTTHUMG00000164892.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 104590733,
      stop : 105804539,
      direction : "+",
      ID : "ENSG00000169946.14",
      gene_id : "ENSG00000169946.14",
      gene_type : "protein_coding",
      gene_name : "ZFPM2",
      gene_level : 2,
      hgnc_id : "HGNC:16700",
      havana_gene : "OTTHUMG00000164818.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 106270144,
      stop : 106752694,
      direction : "+",
      ID : "ENSG00000164830.19",
      gene_id : "ENSG00000164830.19",
      gene_type : "protein_coding",
      gene_name : "OXR1",
      gene_level : 1,
      hgnc_id : "HGNC:15822",
      havana_gene : "OTTHUMG00000167682.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 106759483,
      stop : 106770244,
      direction : "-",
      ID : "ENSG00000174429.4",
      gene_id : "ENSG00000174429.4",
      gene_type : "protein_coding",
      gene_name : "ABRA",
      gene_level : 2,
      hgnc_id : "HGNC:30655",
      havana_gene : "OTTHUMG00000164809.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 107249482,
      stop : 107498055,
      direction : "-",
      ID : "ENSG00000154188.10",
      gene_id : "ENSG00000154188.10",
      gene_type : "protein_coding",
      gene_name : "ANGPT1",
      gene_level : 2,
      hgnc_id : "HGNC:484",
      havana_gene : "OTTHUMG00000164812.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 107899316,
      stop : 108083642,
      direction : "-",
      ID : "ENSG00000147655.12",
      gene_id : "ENSG00000147655.12",
      gene_type : "protein_coding",
      gene_name : "RSPO2",
      gene_level : 1,
      hgnc_id : "HGNC:28583",
      havana_gene : "OTTHUMG00000164893.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 108162787,
      stop : 108443496,
      direction : "-",
      ID : "ENSG00000104408.11",
      gene_id : "ENSG00000104408.11",
      gene_type : "protein_coding",
      gene_name : "EIF3E",
      gene_level : 1,
      hgnc_id : "HGNC:3277",
      havana_gene : "OTTHUMG00000164858.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 108443601,
      stop : 108489196,
      direction : "+",
      ID : "ENSG00000104412.8",
      gene_id : "ENSG00000104412.8",
      gene_type : "protein_coding",
      gene_name : "EMC2",
      gene_level : 2,
      hgnc_id : "HGNC:28963",
      havana_gene : "OTTHUMG00000164873.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 108606850,
      stop : 108787594,
      direction : "-",
      ID : "ENSG00000164841.5",
      gene_id : "ENSG00000164841.5",
      gene_type : "protein_coding",
      gene_name : "TMEM74",
      gene_level : 2,
      hgnc_id : "HGNC:26409",
      havana_gene : "OTTHUMG00000164881.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109086585,
      stop : 109121565,
      direction : "+",
      ID : "ENSG00000174417.3",
      gene_id : "ENSG00000174417.3",
      gene_type : "protein_coding",
      gene_name : "TRHR",
      gene_level : 2,
      hgnc_id : "HGNC:12299",
      havana_gene : "OTTHUMG00000164910.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109240919,
      stop : 109334121,
      direction : "-",
      ID : "ENSG00000120526.12",
      gene_id : "ENSG00000120526.12",
      gene_type : "protein_coding",
      gene_name : "NUDCD1",
      gene_level : 2,
      hgnc_id : "HGNC:24306",
      havana_gene : "OTTHUMG00000164931.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109334324,
      stop : 109345954,
      direction : "+",
      ID : "ENSG00000120533.13",
      gene_id : "ENSG00000120533.13",
      gene_type : "protein_coding",
      gene_name : "ENY2",
      gene_level : 1,
      hgnc_id : "HGNC:24449",
      havana_gene : "OTTHUMG00000164933.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109362461,
      stop : 109537207,
      direction : "+",
      ID : "ENSG00000205038.12",
      gene_id : "ENSG00000205038.12",
      gene_type : "protein_coding",
      gene_name : "PKHD1L1",
      gene_level : 2,
      hgnc_id : "HGNC:20313",
      havana_gene : "OTTHUMG00000164934.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109539711,
      stop : 109565996,
      direction : "+",
      ID : "ENSG00000147654.15",
      gene_id : "ENSG00000147654.15",
      gene_type : "protein_coding",
      gene_name : "EBAG9",
      gene_level : 1,
      hgnc_id : "HGNC:3123",
      havana_gene : "OTTHUMG00000165346.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109573978,
      stop : 109691791,
      direction : "-",
      ID : "ENSG00000147642.17",
      gene_id : "ENSG00000147642.17",
      gene_type : "protein_coding",
      gene_name : "SYBU",
      gene_level : 2,
      hgnc_id : "HGNC:26011",
      havana_gene : "OTTHUMG00000165634.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 109963636,
      stop : 109975771,
      direction : "-",
      ID : "ENSG00000164794.9",
      gene_id : "ENSG00000164794.9",
      gene_type : "protein_coding",
      gene_name : "KCNV1",
      gene_level : 2,
      hgnc_id : "HGNC:18861",
      havana_gene : "OTTHUMG00000165637.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 112222928,
      stop : 113436939,
      direction : "-",
      ID : "ENSG00000164796.18",
      gene_id : "ENSG00000164796.18",
      gene_type : "protein_coding",
      gene_name : "CSMD3",
      gene_level : 2,
      hgnc_id : "HGNC:19291",
      havana_gene : "OTTHUMG00000157027.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 115408496,
      stop : 115809673,
      direction : "-",
      ID : "ENSG00000104447.13",
      gene_id : "ENSG00000104447.13",
      gene_type : "protein_coding",
      gene_name : "TRPS1",
      gene_level : 1,
      hgnc_id : "HGNC:12340",
      havana_gene : "OTTHUMG00000142829.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 116642130,
      stop : 116766925,
      direction : "-",
      ID : "ENSG00000147677.11",
      gene_id : "ENSG00000147677.11",
      gene_type : "protein_coding",
      gene_name : "EIF3H",
      gene_level : 1,
      hgnc_id : "HGNC:3273",
      havana_gene : "OTTHUMG00000164919.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 116766505,
      stop : 116849463,
      direction : "+",
      ID : "ENSG00000147679.12",
      gene_id : "ENSG00000147679.12",
      gene_type : "protein_coding",
      gene_name : "UTP23",
      gene_level : 2,
      hgnc_id : "HGNC:28224",
      havana_gene : "OTTHUMG00000164958.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 116845934,
      stop : 116874776,
      direction : "-",
      ID : "ENSG00000164754.15",
      gene_id : "ENSG00000164754.15",
      gene_type : "protein_coding",
      gene_name : "RAD21",
      gene_level : 1,
      hgnc_id : "HGNC:9811",
      havana_gene : "OTTHUMG00000164959.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 116938207,
      stop : 116944487,
      direction : "+",
      ID : "ENSG00000205002.4",
      gene_id : "ENSG00000205002.4",
      gene_type : "protein_coding",
      gene_name : "AARD",
      gene_level : 2,
      hgnc_id : "HGNC:33842",
      havana_gene : "OTTHUMG00000164961.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 116950273,
      stop : 117176714,
      direction : "+",
      ID : "ENSG00000164756.12",
      gene_id : "ENSG00000164756.12",
      gene_type : "protein_coding",
      gene_name : "SLC30A8",
      gene_level : 2,
      hgnc_id : "HGNC:20303",
      havana_gene : "OTTHUMG00000164962.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 117520713,
      stop : 117540262,
      direction : "+",
      ID : "ENSG00000164758.7",
      gene_id : "ENSG00000164758.7",
      gene_type : "protein_coding",
      gene_name : "MED30",
      gene_level : 2,
      hgnc_id : "HGNC:23032",
      havana_gene : "OTTHUMG00000164920.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 117794490,
      stop : 118111826,
      direction : "-",
      ID : "ENSG00000182197.12",
      gene_id : "ENSG00000182197.12",
      gene_type : "protein_coding",
      gene_name : "EXT1",
      gene_level : 2,
      hgnc_id : "HGNC:3512",
      havana_gene : "OTTHUMG00000059718.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 118189455,
      stop : 118622112,
      direction : "-",
      ID : "ENSG00000177570.15",
      gene_id : "ENSG00000177570.15",
      gene_type : "protein_coding",
      gene_name : "SAMD12",
      gene_level : 2,
      hgnc_id : "HGNC:31750",
      havana_gene : "OTTHUMG00000059817.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 118923557,
      stop : 118951885,
      direction : "-",
      ID : "ENSG00000164761.9",
      gene_id : "ENSG00000164761.9",
      gene_type : "protein_coding",
      gene_name : "TNFRSF11B",
      gene_level : 2,
      hgnc_id : "HGNC:11909",
      havana_gene : "OTTHUMG00000164969.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 118995452,
      stop : 119108455,
      direction : "+",
      ID : "ENSG00000184374.3",
      gene_id : "ENSG00000184374.3",
      gene_type : "protein_coding",
      gene_name : "COLEC10",
      gene_level : 2,
      hgnc_id : "HGNC:2220",
      havana_gene : "OTTHUMG00000164971.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 119165034,
      stop : 119245673,
      direction : "+",
      ID : "ENSG00000147676.14",
      gene_id : "ENSG00000147676.14",
      gene_type : "protein_coding",
      gene_name : "MAL2",
      gene_level : 2,
      hgnc_id : "HGNC:13634",
      havana_gene : "OTTHUMG00000164973.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 119416446,
      stop : 119424434,
      direction : "+",
      ID : "ENSG00000136999.5",
      gene_id : "ENSG00000136999.5",
      gene_type : "protein_coding",
      gene_name : "CCN3",
      gene_level : 2,
      hgnc_id : "HGNC:7885",
      havana_gene : "OTTHUMG00000164984.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 119557086,
      stop : 119673453,
      direction : "-",
      ID : "ENSG00000136960.13",
      gene_id : "ENSG00000136960.13",
      gene_type : "protein_coding",
      gene_name : "ENPP2",
      gene_level : 1,
      hgnc_id : "HGNC:3357",
      havana_gene : "OTTHUMG00000164995.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 119730774,
      stop : 119832841,
      direction : "-",
      ID : "ENSG00000064313.12",
      gene_id : "ENSG00000064313.12",
      gene_type : "protein_coding",
      gene_name : "TAF2",
      gene_level : 1,
      hgnc_id : "HGNC:11536",
      havana_gene : "OTTHUMG00000165009.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 119833976,
      stop : 119855894,
      direction : "-",
      ID : "ENSG00000136982.6",
      gene_id : "ENSG00000136982.6",
      gene_type : "protein_coding",
      gene_name : "DSCC1",
      gene_level : 2,
      hgnc_id : "HGNC:24453",
      havana_gene : "OTTHUMG00000165010.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 119873717,
      stop : 120050918,
      direction : "+",
      ID : "ENSG00000155792.10",
      gene_id : "ENSG00000155792.10",
      gene_type : "protein_coding",
      gene_name : "DEPTOR",
      gene_level : 2,
      hgnc_id : "HGNC:22953",
      havana_gene : "OTTHUMG00000165052.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 120059780,
      stop : 120373573,
      direction : "+",
      ID : "ENSG00000187955.12",
      gene_id : "ENSG00000187955.12",
      gene_type : "protein_coding",
      gene_name : "COL14A1",
      gene_level : 1,
      hgnc_id : "HGNC:2191",
      havana_gene : "OTTHUMG00000149877.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 120380761,
      stop : 120445402,
      direction : "-",
      ID : "ENSG00000172172.8",
      gene_id : "ENSG00000172172.8",
      gene_type : "protein_coding",
      gene_name : "MRPL13",
      gene_level : 1,
      hgnc_id : "HGNC:14278",
      havana_gene : "OTTHUMG00000165039.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 120445400,
      stop : 120542133,
      direction : "+",
      ID : "ENSG00000172167.8",
      gene_id : "ENSG00000172167.8",
      gene_type : "protein_coding",
      gene_name : "MTBP",
      gene_level : 2,
      hgnc_id : "HGNC:7417",
      havana_gene : "OTTHUMG00000165040.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 120535745,
      stop : 120813273,
      direction : "-",
      ID : "ENSG00000172164.15",
      gene_id : "ENSG00000172164.15",
      gene_type : "protein_coding",
      gene_name : "SNTB1",
      gene_level : 2,
      hgnc_id : "HGNC:11168",
      havana_gene : "OTTHUMG00000165041.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 121612116,
      stop : 121641440,
      direction : "-",
      ID : "ENSG00000170961.7",
      gene_id : "ENSG00000170961.7",
      gene_type : "protein_coding",
      gene_name : "HAS2",
      gene_level : 2,
      hgnc_id : "HGNC:4819",
      havana_gene : "OTTHUMG00000164953.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 122781655,
      stop : 122974510,
      direction : "+",
      ID : "ENSG00000178764.8",
      gene_id : "ENSG00000178764.8",
      gene_type : "protein_coding",
      gene_name : "ZHX2",
      gene_level : 2,
      hgnc_id : "HGNC:18513",
      havana_gene : "OTTHUMG00000165077.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123013170,
      stop : 123042302,
      direction : "-",
      ID : "ENSG00000136986.10",
      gene_id : "ENSG00000136986.10",
      gene_type : "protein_coding",
      gene_name : "DERL1",
      gene_level : 2,
      hgnc_id : "HGNC:28454",
      havana_gene : "OTTHUMG00000165080.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123041968,
      stop : 123152153,
      direction : "+",
      ID : "ENSG00000156787.17",
      gene_id : "ENSG00000156787.17",
      gene_type : "protein_coding",
      gene_name : "TBC1D31",
      gene_level : 1,
      hgnc_id : "HGNC:30888",
      havana_gene : "OTTHUMG00000165081.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123178960,
      stop : 123210079,
      direction : "+",
      ID : "ENSG00000147689.16",
      gene_id : "ENSG00000147689.16",
      gene_type : "protein_coding",
      gene_name : "FAM83A",
      gene_level : 2,
      hgnc_id : "HGNC:28210",
      havana_gene : "OTTHUMG00000165083.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123219967,
      stop : 123241377,
      direction : "-",
      ID : "ENSG00000189376.12",
      gene_id : "ENSG00000189376.12",
      gene_type : "protein_coding",
      gene_name : "C8orf76",
      gene_level : 1,
      hgnc_id : "HGNC:25924",
      havana_gene : "OTTHUMG00000172562.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123226189,
      stop : 123274284,
      direction : "-",
      ID : "ENSG00000259305.6",
      gene_id : "ENSG00000259305.6",
      gene_type : "protein_coding",
      gene_name : "ZHX1-C8orf76",
      gene_level : 2,
      hgnc_id : "HGNC:42975",
      havana_gene : "OTTHUMG00000165087.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123248451,
      stop : 123275541,
      direction : "-",
      ID : "ENSG00000165156.15",
      gene_id : "ENSG00000165156.15",
      gene_type : "protein_coding",
      gene_name : "ZHX1",
      gene_level : 1,
      hgnc_id : "HGNC:12871",
      havana_gene : "OTTHUMG00000165088.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123319850,
      stop : 123416350,
      direction : "-",
      ID : "ENSG00000156802.13",
      gene_id : "ENSG00000156802.13",
      gene_type : "protein_coding",
      gene_name : "ATAD2",
      gene_level : 1,
      hgnc_id : "HGNC:30123",
      havana_gene : "OTTHUMG00000165090.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123416726,
      stop : 123470028,
      direction : "+",
      ID : "ENSG00000156795.8",
      gene_id : "ENSG00000156795.8",
      gene_type : "protein_coding",
      gene_name : "NTAQ1",
      gene_level : 1,
      hgnc_id : "HGNC:25490",
      havana_gene : "OTTHUMG00000165093.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123497889,
      stop : 123541206,
      direction : "-",
      ID : "ENSG00000156804.7",
      gene_id : "ENSG00000156804.7",
      gene_type : "protein_coding",
      gene_name : "FBXO32",
      gene_level : 2,
      hgnc_id : "HGNC:16731",
      havana_gene : "OTTHUMG00000164981.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123645527,
      stop : 123652950,
      direction : "-",
      ID : "ENSG00000175946.8",
      gene_id : "ENSG00000175946.8",
      gene_type : "protein_coding",
      gene_name : "KLHL38",
      gene_level : 2,
      hgnc_id : "HGNC:34435",
      havana_gene : "OTTHUMG00000164983.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123680794,
      stop : 123737402,
      direction : "-",
      ID : "ENSG00000104537.17",
      gene_id : "ENSG00000104537.17",
      gene_type : "protein_coding",
      gene_name : "ANXA13",
      gene_level : 1,
      hgnc_id : "HGNC:536",
      havana_gene : "OTTHUMG00000164987.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123768439,
      stop : 123815452,
      direction : "+",
      ID : "ENSG00000176853.16",
      gene_id : "ENSG00000176853.16",
      gene_type : "protein_coding",
      gene_name : "FAM91A1",
      gene_level : 2,
      hgnc_id : "HGNC:26306",
      havana_gene : "OTTHUMG00000133021.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 123851987,
      stop : 124120061,
      direction : "+",
      ID : "ENSG00000214814.7",
      gene_id : "ENSG00000214814.7",
      gene_type : "protein_coding",
      gene_name : "FER1L6",
      gene_level : 2,
      hgnc_id : "HGNC:28065",
      havana_gene : "OTTHUMG00000164998.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124306189,
      stop : 124372701,
      direction : "-",
      ID : "ENSG00000164983.8",
      gene_id : "ENSG00000164983.8",
      gene_type : "protein_coding",
      gene_name : "TMEM65",
      gene_level : 2,
      hgnc_id : "HGNC:25203",
      havana_gene : "OTTHUMG00000165021.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124450820,
      stop : 124462150,
      direction : "+",
      ID : "ENSG00000183665.5",
      gene_id : "ENSG00000183665.5",
      gene_type : "protein_coding",
      gene_name : "TRMT12",
      gene_level : 2,
      hgnc_id : "HGNC:26091",
      havana_gene : "OTTHUMG00000165022.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124474880,
      stop : 124488618,
      direction : "+",
      ID : "ENSG00000170881.5",
      gene_id : "ENSG00000170881.5",
      gene_type : "protein_coding",
      gene_name : "RNF139",
      gene_level : 1,
      hgnc_id : "HGNC:17023",
      havana_gene : "OTTHUMG00000165072.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124488485,
      stop : 124539458,
      direction : "-",
      ID : "ENSG00000147687.19",
      gene_id : "ENSG00000147687.19",
      gene_type : "protein_coding",
      gene_name : "TATDN1",
      gene_level : 1,
      hgnc_id : "HGNC:24220",
      havana_gene : "OTTHUMG00000165068.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124539101,
      stop : 124580648,
      direction : "+",
      ID : "ENSG00000147684.10",
      gene_id : "ENSG00000147684.10",
      gene_type : "protein_coding",
      gene_name : "NDUFB9",
      gene_level : 1,
      hgnc_id : "HGNC:7704",
      havana_gene : "OTTHUMG00000165054.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124550784,
      stop : 124728473,
      direction : "-",
      ID : "ENSG00000170873.19",
      gene_id : "ENSG00000170873.19",
      gene_type : "protein_coding",
      gene_name : "MTSS1",
      gene_level : 1,
      hgnc_id : "HGNC:20443",
      havana_gene : "OTTHUMG00000048189.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124973295,
      stop : 124979389,
      direction : "+",
      ID : "ENSG00000180938.6",
      gene_id : "ENSG00000180938.6",
      gene_type : "protein_coding",
      gene_name : "ZNF572",
      gene_level : 2,
      hgnc_id : "HGNC:26758",
      havana_gene : "OTTHUMG00000164988.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 124998497,
      stop : 125022283,
      direction : "+",
      ID : "ENSG00000104549.12",
      gene_id : "ENSG00000104549.12",
      gene_type : "protein_coding",
      gene_name : "SQLE",
      gene_level : 2,
      hgnc_id : "HGNC:11279",
      havana_gene : "OTTHUMG00000164990.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 125024260,
      stop : 125091819,
      direction : "-",
      ID : "ENSG00000164961.16",
      gene_id : "ENSG00000164961.16",
      gene_type : "protein_coding",
      gene_name : "WASHC5",
      gene_level : 2,
      hgnc_id : "HGNC:28984",
      havana_gene : "OTTHUMG00000164991.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 125091679,
      stop : 125367120,
      direction : "+",
      ID : "ENSG00000156831.8",
      gene_id : "ENSG00000156831.8",
      gene_type : "protein_coding",
      gene_name : "NSMCE2",
      gene_level : 2,
      hgnc_id : "HGNC:26513",
      havana_gene : "OTTHUMG00000164993.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 125430358,
      stop : 125438403,
      direction : "+",
      ID : "ENSG00000173334.4",
      gene_id : "ENSG00000173334.4",
      gene_type : "protein_coding",
      gene_name : "TRIB1",
      gene_level : 1,
      hgnc_id : "HGNC:16891",
      havana_gene : "OTTHUMG00000165007.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 126552443,
      stop : 126558478,
      direction : "-",
      ID : "ENSG00000168672.4",
      gene_id : "ENSG00000168672.4",
      gene_type : "protein_coding",
      gene_name : "LRATD2",
      gene_level : 2,
      hgnc_id : "HGNC:24166",
      havana_gene : "OTTHUMG00000165034.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 127322183,
      stop : 127420066,
      direction : "+",
      ID : "ENSG00000212993.5",
      gene_id : "ENSG00000212993.5",
      gene_type : "protein_coding",
      gene_name : "POU5F1B",
      gene_level : 2,
      hgnc_id : "HGNC:9223",
      havana_gene : "OTTHUMG00000157807.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 127735434,
      stop : 127742951,
      direction : "+",
      ID : "ENSG00000136997.21",
      gene_id : "ENSG00000136997.21",
      gene_type : "protein_coding",
      gene_name : "MYC",
      gene_level : 1,
      hgnc_id : "HGNC:7553",
      havana_gene : "OTTHUMG00000128475.10",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 129748196,
      stop : 129786624,
      direction : "-",
      ID : "ENSG00000147697.9",
      gene_id : "ENSG00000147697.9",
      gene_type : "protein_coding",
      gene_name : "GSDMC",
      gene_level : 2,
      hgnc_id : "HGNC:7151",
      havana_gene : "OTTHUMG00000164851.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 129839593,
      stop : 130017129,
      direction : "-",
      ID : "ENSG00000153310.19",
      gene_id : "ENSG00000153310.19",
      gene_type : "protein_coding",
      gene_name : "CYRIB",
      gene_level : 1,
      hgnc_id : "HGNC:25216",
      havana_gene : "OTTHUMG00000164805.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 130052104,
      stop : 130443674,
      direction : "-",
      ID : "ENSG00000153317.15",
      gene_id : "ENSG00000153317.15",
      gene_type : "protein_coding",
      gene_name : "ASAP1",
      gene_level : 1,
      hgnc_id : "HGNC:2720",
      havana_gene : "OTTHUMG00000164772.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 130780301,
      stop : 131040909,
      direction : "-",
      ID : "ENSG00000155897.10",
      gene_id : "ENSG00000155897.10",
      gene_type : "protein_coding",
      gene_name : "ADCY8",
      gene_level : 2,
      hgnc_id : "HGNC:239",
      havana_gene : "OTTHUMG00000164756.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 131904093,
      stop : 132013642,
      direction : "+",
      ID : "ENSG00000132294.15",
      gene_id : "ENSG00000132294.15",
      gene_type : "protein_coding",
      gene_name : "EFR3A",
      gene_level : 1,
      hgnc_id : "HGNC:28970",
      havana_gene : "OTTHUMG00000150552.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132024216,
      stop : 132059382,
      direction : "-",
      ID : "ENSG00000253117.5",
      gene_id : "ENSG00000253117.5",
      gene_type : "protein_coding",
      gene_name : "OC90",
      gene_level : 2,
      hgnc_id : "HGNC:8100",
      havana_gene : "OTTHUMG00000164672.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132024238,
      stop : 132085655,
      direction : "-",
      ID : "ENSG00000258417.3",
      gene_id : "ENSG00000258417.3",
      gene_type : "protein_coding",
      gene_name : "AC100868.1",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170745.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132061486,
      stop : 132111159,
      direction : "-",
      ID : "ENSG00000132297.12",
      gene_id : "ENSG00000132297.12",
      gene_type : "protein_coding",
      gene_name : "HHLA1",
      gene_level : 1,
      hgnc_id : "HGNC:4904",
      havana_gene : "OTTHUMG00000140390.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132120859,
      stop : 132481095,
      direction : "-",
      ID : "ENSG00000184156.17",
      gene_id : "ENSG00000184156.17",
      gene_type : "protein_coding",
      gene_name : "KCNQ3",
      gene_level : 2,
      hgnc_id : "HGNC:6297",
      havana_gene : "OTTHUMG00000137472.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132570416,
      stop : 132675592,
      direction : "-",
      ID : "ENSG00000129295.9",
      gene_id : "ENSG00000129295.9",
      gene_type : "protein_coding",
      gene_name : "LRRC6",
      gene_level : 1,
      hgnc_id : "HGNC:16725",
      havana_gene : "OTTHUMG00000164646.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132685007,
      stop : 132760712,
      direction : "-",
      ID : "ENSG00000165071.15",
      gene_id : "ENSG00000165071.15",
      gene_type : "protein_coding",
      gene_name : "TMEM71",
      gene_level : 1,
      hgnc_id : "HGNC:26572",
      havana_gene : "OTTHUMG00000164647.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132775358,
      stop : 132848807,
      direction : "+",
      ID : "ENSG00000129292.21",
      gene_id : "ENSG00000129292.21",
      gene_type : "protein_coding",
      gene_name : "PHF20L1",
      gene_level : 1,
      hgnc_id : "HGNC:24280",
      havana_gene : "OTTHUMG00000148656.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 132866958,
      stop : 133134903,
      direction : "+",
      ID : "ENSG00000042832.12",
      gene_id : "ENSG00000042832.12",
      gene_type : "protein_coding",
      gene_name : "TG",
      gene_level : 1,
      hgnc_id : "HGNC:11764",
      havana_gene : "OTTHUMG00000164649.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 133036728,
      stop : 133102912,
      direction : "-",
      ID : "ENSG00000155926.14",
      gene_id : "ENSG00000155926.14",
      gene_type : "protein_coding",
      gene_name : "SLA",
      gene_level : 1,
      hgnc_id : "HGNC:10902",
      havana_gene : "OTTHUMG00000164439.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 133191039,
      stop : 133231690,
      direction : "+",
      ID : "ENSG00000104415.14",
      gene_id : "ENSG00000104415.14",
      gene_type : "protein_coding",
      gene_name : "CCN4",
      gene_level : 1,
      hgnc_id : "HGNC:12769",
      havana_gene : "OTTHUMG00000164440.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 133237175,
      stop : 133302022,
      direction : "-",
      ID : "ENSG00000104419.17",
      gene_id : "ENSG00000104419.17",
      gene_type : "protein_coding",
      gene_name : "NDRG1",
      gene_level : 1,
      hgnc_id : "HGNC:7679",
      havana_gene : "OTTHUMG00000164441.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 133454848,
      stop : 133571940,
      direction : "-",
      ID : "ENSG00000008513.16",
      gene_id : "ENSG00000008513.16",
      gene_type : "protein_coding",
      gene_name : "ST3GAL1",
      gene_level : 2,
      hgnc_id : "HGNC:10862",
      havana_gene : "OTTHUMG00000164534.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 134477788,
      stop : 134713049,
      direction : "-",
      ID : "ENSG00000066827.16",
      gene_id : "ENSG00000066827.16",
      gene_type : "protein_coding",
      gene_name : "ZFAT",
      gene_level : 1,
      hgnc_id : "HGNC:19899",
      havana_gene : "OTTHUMG00000164321.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 135457456,
      stop : 135656722,
      direction : "+",
      ID : "ENSG00000131773.14",
      gene_id : "ENSG00000131773.14",
      gene_type : "protein_coding",
      gene_name : "KHDRBS3",
      gene_level : 2,
      hgnc_id : "HGNC:18117",
      havana_gene : "OTTHUMG00000164164.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 138130023,
      stop : 138497261,
      direction : "-",
      ID : "ENSG00000147724.12",
      gene_id : "ENSG00000147724.12",
      gene_type : "protein_coding",
      gene_name : "FAM135B",
      gene_level : 1,
      hgnc_id : "HGNC:28029",
      havana_gene : "OTTHUMG00000149864.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 138588235,
      stop : 138914041,
      direction : "-",
      ID : "ENSG00000169436.17",
      gene_id : "ENSG00000169436.17",
      gene_type : "protein_coding",
      gene_name : "COL22A1",
      gene_level : 2,
      hgnc_id : "HGNC:22989",
      havana_gene : "OTTHUMG00000150035.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 139600838,
      stop : 139704109,
      direction : "-",
      ID : "ENSG00000169427.8",
      gene_id : "ENSG00000169427.8",
      gene_type : "protein_coding",
      gene_name : "KCNK9",
      gene_level : 1,
      hgnc_id : "HGNC:6283",
      havana_gene : "OTTHUMG00000164186.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 139727725,
      stop : 140458579,
      direction : "-",
      ID : "ENSG00000167632.18",
      gene_id : "ENSG00000167632.18",
      gene_type : "protein_coding",
      gene_name : "TRAPPC9",
      gene_level : 2,
      hgnc_id : "HGNC:30832",
      havana_gene : "OTTHUMG00000164187.10",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 140511311,
      stop : 140517154,
      direction : "+",
      ID : "ENSG00000104472.10",
      gene_id : "ENSG00000104472.10",
      gene_type : "protein_coding",
      gene_name : "CHRAC1",
      gene_level : 2,
      hgnc_id : "HGNC:13544",
      havana_gene : "OTTHUMG00000164207.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 140520156,
      stop : 140635633,
      direction : "-",
      ID : "ENSG00000123908.12",
      gene_id : "ENSG00000123908.12",
      gene_type : "protein_coding",
      gene_name : "AGO2",
      gene_level : 1,
      hgnc_id : "HGNC:3263",
      havana_gene : "OTTHUMG00000164232.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 140657900,
      stop : 141002216,
      direction : "-",
      ID : "ENSG00000169398.19",
      gene_id : "ENSG00000169398.19",
      gene_type : "protein_coding",
      gene_name : "PTK2",
      gene_level : 1,
      hgnc_id : "HGNC:9611",
      havana_gene : "OTTHUMG00000067438.25",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 141117278,
      stop : 141195808,
      direction : "+",
      ID : "ENSG00000105339.11",
      gene_id : "ENSG00000105339.11",
      gene_type : "protein_coding",
      gene_name : "DENND3",
      gene_level : 1,
      hgnc_id : "HGNC:29134",
      havana_gene : "OTTHUMG00000164775.12",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 141207166,
      stop : 141308305,
      direction : "-",
      ID : "ENSG00000022567.10",
      gene_id : "ENSG00000022567.10",
      gene_type : "protein_coding",
      gene_name : "SLC45A4",
      gene_level : 1,
      hgnc_id : "HGNC:29196",
      havana_gene : "OTTHUMG00000164393.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 141356470,
      stop : 141367286,
      direction : "-",
      ID : "ENSG00000204882.4",
      gene_id : "ENSG00000204882.4",
      gene_type : "protein_coding",
      gene_name : "GPR20",
      gene_level : 2,
      hgnc_id : "HGNC:4475",
      havana_gene : "OTTHUMG00000164484.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 141391995,
      stop : 141432454,
      direction : "+",
      ID : "ENSG00000184489.13",
      gene_id : "ENSG00000184489.13",
      gene_type : "protein_coding",
      gene_name : "PTP4A3",
      gene_level : 2,
      hgnc_id : "HGNC:9636",
      havana_gene : "OTTHUMG00000164490.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 141514638,
      stop : 141518737,
      direction : "+",
      ID : "ENSG00000226490.2",
      gene_id : "ENSG00000226490.2",
      gene_type : "protein_coding",
      gene_name : "AC138647.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000156281.3",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142212080,
      stop : 142403182,
      direction : "-",
      ID : "ENSG00000171045.16",
      gene_id : "ENSG00000171045.16",
      gene_type : "protein_coding",
      gene_name : "TSNARE1",
      gene_level : 2,
      hgnc_id : "HGNC:26437",
      havana_gene : "OTTHUMG00000164867.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142449430,
      stop : 142545009,
      direction : "+",
      ID : "ENSG00000181790.11",
      gene_id : "ENSG00000181790.11",
      gene_type : "protein_coding",
      gene_name : "ADGRB1",
      gene_level : 2,
      hgnc_id : "HGNC:943",
      havana_gene : "OTTHUMG00000164732.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142611049,
      stop : 142614479,
      direction : "-",
      ID : "ENSG00000198576.4",
      gene_id : "ENSG00000198576.4",
      gene_type : "protein_coding",
      gene_name : "ARC",
      gene_level : 2,
      hgnc_id : "HGNC:648",
      havana_gene : "OTTHUMG00000134310.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142657460,
      stop : 142681968,
      direction : "-",
      ID : "ENSG00000234616.9",
      gene_id : "ENSG00000234616.9",
      gene_type : "protein_coding",
      gene_name : "JRK",
      gene_level : 2,
      hgnc_id : "HGNC:6199",
      havana_gene : "OTTHUMG00000160911.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142670308,
      stop : 142682725,
      direction : "+",
      ID : "ENSG00000167653.5",
      gene_id : "ENSG00000167653.5",
      gene_type : "protein_coding",
      gene_name : "PSCA",
      gene_level : 2,
      hgnc_id : "HGNC:9500",
      havana_gene : "OTTHUMG00000162077.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142700111,
      stop : 142705127,
      direction : "+",
      ID : "ENSG00000160886.13",
      gene_id : "ENSG00000160886.13",
      gene_type : "protein_coding",
      gene_name : "LY6K",
      gene_level : 1,
      hgnc_id : "HGNC:24225",
      havana_gene : "OTTHUMG00000164720.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142727223,
      stop : 142736927,
      direction : "+",
      ID : "ENSG00000130193.8",
      gene_id : "ENSG00000130193.8",
      gene_type : "protein_coding",
      gene_name : "THEM6",
      gene_level : 2,
      hgnc_id : "HGNC:29656",
      havana_gene : "OTTHUMG00000164673.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142740949,
      stop : 142742406,
      direction : "-",
      ID : "ENSG00000126233.2",
      gene_id : "ENSG00000126233.2",
      gene_type : "protein_coding",
      gene_name : "SLURP1",
      gene_level : 2,
      hgnc_id : "HGNC:18746",
      havana_gene : "OTTHUMG00000164685.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142750150,
      stop : 142752532,
      direction : "-",
      ID : "ENSG00000197353.4",
      gene_id : "ENSG00000197353.4",
      gene_type : "protein_coding",
      gene_name : "LYPD2",
      gene_level : 2,
      hgnc_id : "HGNC:25215",
      havana_gene : "OTTHUMG00000164686.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142764334,
      stop : 142778224,
      direction : "-",
      ID : "ENSG00000284505.1",
      gene_id : "ENSG00000284505.1",
      gene_type : "protein_coding",
      gene_name : "LYNX1-SLURP2",
      gene_level : 2,
      hgnc_id : "HGNC:52291",
      havana_gene : "OTTHUMG00000191911.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142764338,
      stop : 142769828,
      direction : "-",
      ID : "ENSG00000283992.2",
      gene_id : "ENSG00000283992.2",
      gene_type : "protein_coding",
      gene_name : "SLURP2",
      gene_level : 2,
      hgnc_id : "HGNC:25549",
      havana_gene : "OTTHUMG00000164694.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142771197,
      stop : 142777810,
      direction : "-",
      ID : "ENSG00000180155.20",
      gene_id : "ENSG00000180155.20",
      gene_type : "protein_coding",
      gene_name : "LYNX1",
      gene_level : 1,
      hgnc_id : "HGNC:29604",
      havana_gene : "OTTHUMG00000191912.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142784882,
      stop : 142786539,
      direction : "-",
      ID : "ENSG00000167656.5",
      gene_id : "ENSG00000167656.5",
      gene_type : "protein_coding",
      gene_name : "LY6D",
      gene_level : 2,
      hgnc_id : "HGNC:13348",
      havana_gene : "OTTHUMG00000164693.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142834247,
      stop : 142916506,
      direction : "+",
      ID : "ENSG00000104499.7",
      gene_id : "ENSG00000104499.7",
      gene_type : "protein_coding",
      gene_name : "GML",
      gene_level : 2,
      hgnc_id : "HGNC:4375",
      havana_gene : "OTTHUMG00000164656.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142872356,
      stop : 142879846,
      direction : "-",
      ID : "ENSG00000160882.13",
      gene_id : "ENSG00000160882.13",
      gene_type : "protein_coding",
      gene_name : "CYP11B1",
      gene_level : 1,
      hgnc_id : "HGNC:2591",
      havana_gene : "OTTHUMG00000164637.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 142910559,
      stop : 142917843,
      direction : "-",
      ID : "ENSG00000179142.2",
      gene_id : "ENSG00000179142.2",
      gene_type : "protein_coding",
      gene_name : "CYP11B2",
      gene_level : 2,
      hgnc_id : "HGNC:2592",
      havana_gene : "OTTHUMG00000160254.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143017982,
      stop : 143023832,
      direction : "+",
      ID : "ENSG00000160932.11",
      gene_id : "ENSG00000160932.11",
      gene_type : "protein_coding",
      gene_name : "LY6E",
      gene_level : 1,
      hgnc_id : "HGNC:6727",
      havana_gene : "OTTHUMG00000164754.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143080457,
      stop : 143083001,
      direction : "+",
      ID : "ENSG00000261667.1",
      gene_id : "ENSG00000261667.1",
      gene_type : "protein_coding",
      gene_name : "LY6L",
      gene_level : 2,
      hgnc_id : "HGNC:52284",
      havana_gene : "OTTHUMG00000173037.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143157914,
      stop : 143160711,
      direction : "-",
      ID : "ENSG00000176956.13",
      gene_id : "ENSG00000176956.13",
      gene_type : "protein_coding",
      gene_name : "LY6H",
      gene_level : 2,
      hgnc_id : "HGNC:6728",
      havana_gene : "OTTHUMG00000154890.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143213218,
      stop : 143217170,
      direction : "+",
      ID : "ENSG00000277494.2",
      gene_id : "ENSG00000277494.2",
      gene_type : "protein_coding",
      gene_name : "GPIHBP1",
      gene_level : 2,
      hgnc_id : "HGNC:24945",
      havana_gene : "OTTHUMG00000164950.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143246821,
      stop : 143262705,
      direction : "+",
      ID : "ENSG00000181638.20",
      gene_id : "ENSG00000181638.20",
      gene_type : "protein_coding",
      gene_name : "ZFP41",
      gene_level : 1,
      hgnc_id : "HGNC:26786",
      havana_gene : "OTTHUMG00000164951.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143247110,
      stop : 143276403,
      direction : "+",
      ID : "ENSG00000264668.2",
      gene_id : "ENSG00000264668.2",
      gene_type : "protein_coding",
      gene_name : "AC138696.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179773.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143267433,
      stop : 143276931,
      direction : "+",
      ID : "ENSG00000250571.7",
      gene_id : "ENSG00000250571.7",
      gene_type : "protein_coding",
      gene_name : "GLI4",
      gene_level : 1,
      hgnc_id : "HGNC:4320",
      havana_gene : "OTTHUMG00000164952.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143289676,
      stop : 143299952,
      direction : "+",
      ID : "ENSG00000185730.8",
      gene_id : "ENSG00000185730.8",
      gene_type : "protein_coding",
      gene_name : "ZNF696",
      gene_level : 1,
      hgnc_id : "HGNC:25872",
      havana_gene : "OTTHUMG00000164957.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143304384,
      stop : 143359979,
      direction : "-",
      ID : "ENSG00000184428.13",
      gene_id : "ENSG00000184428.13",
      gene_type : "protein_coding",
      gene_name : "TOP1MT",
      gene_level : 1,
      hgnc_id : "HGNC:29787",
      havana_gene : "OTTHUMG00000164979.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143368876,
      stop : 143384221,
      direction : "+",
      ID : "ENSG00000158106.14",
      gene_id : "ENSG00000158106.14",
      gene_type : "protein_coding",
      gene_name : "RHPN1",
      gene_level : 2,
      hgnc_id : "HGNC:19973",
      havana_gene : "OTTHUMG00000165006.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143419182,
      stop : 143430732,
      direction : "-",
      ID : "ENSG00000182759.4",
      gene_id : "ENSG00000182759.4",
      gene_type : "protein_coding",
      gene_name : "MAFA",
      gene_level : 1,
      hgnc_id : "HGNC:23145",
      havana_gene : "OTTHUMG00000165037.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143437659,
      stop : 143541447,
      direction : "-",
      ID : "ENSG00000014164.7",
      gene_id : "ENSG00000014164.7",
      gene_type : "protein_coding",
      gene_name : "ZC3H3",
      gene_level : 1,
      hgnc_id : "HGNC:28972",
      havana_gene : "OTTHUMG00000165127.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143553207,
      stop : 143563062,
      direction : "+",
      ID : "ENSG00000104518.11",
      gene_id : "ENSG00000104518.11",
      gene_type : "protein_coding",
      gene_name : "GSDMD",
      gene_level : 1,
      hgnc_id : "HGNC:25697",
      havana_gene : "OTTHUMG00000165132.8",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143566192,
      stop : 143572772,
      direction : "-",
      ID : "ENSG00000204839.9",
      gene_id : "ENSG00000204839.9",
      gene_type : "protein_coding",
      gene_name : "MROH6",
      gene_level : 1,
      hgnc_id : "HGNC:27814",
      havana_gene : "OTTHUMG00000165164.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143574785,
      stop : 143578649,
      direction : "-",
      ID : "ENSG00000147813.16",
      gene_id : "ENSG00000147813.16",
      gene_type : "protein_coding",
      gene_name : "NAPRT",
      gene_level : 2,
      hgnc_id : "HGNC:30450",
      havana_gene : "OTTHUMG00000156942.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143579697,
      stop : 143599541,
      direction : "-",
      ID : "ENSG00000104529.17",
      gene_id : "ENSG00000104529.17",
      gene_type : "protein_coding",
      gene_name : "EEF1D",
      gene_level : 1,
      hgnc_id : "HGNC:3211",
      havana_gene : "OTTHUMG00000165191.23",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143597831,
      stop : 143603224,
      direction : "+",
      ID : "ENSG00000179886.6",
      gene_id : "ENSG00000179886.6",
      gene_type : "protein_coding",
      gene_name : "TIGD5",
      gene_level : 2,
      hgnc_id : "HGNC:18336",
      havana_gene : "OTTHUMG00000162260.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143603210,
      stop : 143609773,
      direction : "-",
      ID : "ENSG00000104524.14",
      gene_id : "ENSG00000104524.14",
      gene_type : "protein_coding",
      gene_name : "PYCR3",
      gene_level : 1,
      hgnc_id : "HGNC:25846",
      havana_gene : "OTTHUMG00000157010.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143612618,
      stop : 143618048,
      direction : "-",
      ID : "ENSG00000104522.16",
      gene_id : "ENSG00000104522.16",
      gene_type : "protein_coding",
      gene_name : "GFUS",
      gene_level : 2,
      hgnc_id : "HGNC:12390",
      havana_gene : "OTTHUMG00000165159.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143636019,
      stop : 143656418,
      direction : "+",
      ID : "ENSG00000183309.12",
      gene_id : "ENSG00000183309.12",
      gene_type : "protein_coding",
      gene_name : "ZNF623",
      gene_level : 2,
      hgnc_id : "HGNC:29084",
      havana_gene : "OTTHUMG00000165186.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143684452,
      stop : 143713898,
      direction : "+",
      ID : "ENSG00000181135.16",
      gene_id : "ENSG00000181135.16",
      gene_type : "protein_coding",
      gene_name : "ZNF707",
      gene_level : 1,
      hgnc_id : "HGNC:27815",
      havana_gene : "OTTHUMG00000165146.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143706694,
      stop : 143708109,
      direction : "-",
      ID : "ENSG00000255181.3",
      gene_id : "ENSG00000255181.3",
      gene_type : "protein_coding",
      gene_name : "CCDC166",
      gene_level : 2,
      hgnc_id : "HGNC:41910",
      havana_gene : "OTTHUMG00000165148.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143716340,
      stop : 143722458,
      direction : "+",
      ID : "ENSG00000181085.15",
      gene_id : "ENSG00000181085.15",
      gene_type : "protein_coding",
      gene_name : "MAPK15",
      gene_level : 2,
      hgnc_id : "HGNC:24667",
      havana_gene : "OTTHUMG00000146450.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143723933,
      stop : 143738234,
      direction : "-",
      ID : "ENSG00000180921.7",
      gene_id : "ENSG00000180921.7",
      gene_type : "protein_coding",
      gene_name : "FAM83H",
      gene_level : 2,
      hgnc_id : "HGNC:24797",
      havana_gene : "OTTHUMG00000133559.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143734139,
      stop : 143790645,
      direction : "+",
      ID : "ENSG00000203499.12",
      gene_id : "ENSG00000203499.12",
      gene_type : "protein_coding",
      gene_name : "IQANK1",
      gene_level : 2,
      hgnc_id : "HGNC:49576",
      havana_gene : "OTTHUMG00000165153.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143790920,
      stop : 143815773,
      direction : "-",
      ID : "ENSG00000180900.20",
      gene_id : "ENSG00000180900.20",
      gene_type : "protein_coding",
      gene_name : "SCRIB",
      gene_level : 1,
      hgnc_id : "HGNC:30377",
      havana_gene : "OTTHUMG00000165154.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143816344,
      stop : 143829352,
      direction : "-",
      ID : "ENSG00000179950.14",
      gene_id : "ENSG00000179950.14",
      gene_type : "protein_coding",
      gene_name : "PUF60",
      gene_level : 2,
      hgnc_id : "HGNC:17042",
      havana_gene : "OTTHUMG00000165155.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143833583,
      stop : 143840973,
      direction : "-",
      ID : "ENSG00000185189.18",
      gene_id : "ENSG00000185189.18",
      gene_type : "protein_coding",
      gene_name : "NRBP2",
      gene_level : 2,
      hgnc_id : "HGNC:19339",
      havana_gene : "OTTHUMG00000165157.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143857324,
      stop : 143878467,
      direction : "-",
      ID : "ENSG00000261150.3",
      gene_id : "ENSG00000261150.3",
      gene_type : "protein_coding",
      gene_name : "EPPK1",
      gene_level : 2,
      hgnc_id : "HGNC:15577",
      havana_gene : "OTTHUMG00000165206.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143915153,
      stop : 143976734,
      direction : "-",
      ID : "ENSG00000178209.16",
      gene_id : "ENSG00000178209.16",
      gene_type : "protein_coding",
      gene_name : "PLEC",
      gene_level : 2,
      hgnc_id : "HGNC:9069",
      havana_gene : "OTTHUMG00000165291.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143977153,
      stop : 144012772,
      direction : "-",
      ID : "ENSG00000178685.14",
      gene_id : "ENSG00000178685.14",
      gene_type : "protein_coding",
      gene_name : "PARP10",
      gene_level : 1,
      hgnc_id : "HGNC:25895",
      havana_gene : "OTTHUMG00000165408.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 143990056,
      stop : 143993415,
      direction : "+",
      ID : "ENSG00000178719.17",
      gene_id : "ENSG00000178719.17",
      gene_type : "protein_coding",
      gene_name : "GRINA",
      gene_level : 1,
      hgnc_id : "HGNC:4589",
      havana_gene : "OTTHUMG00000165433.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144012280,
      stop : 144047114,
      direction : "+",
      ID : "ENSG00000186583.12",
      gene_id : "ENSG00000186583.12",
      gene_type : "protein_coding",
      gene_name : "SPATC1",
      gene_level : 2,
      hgnc_id : "HGNC:30510",
      havana_gene : "OTTHUMG00000156976.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144051266,
      stop : 144063965,
      direction : "-",
      ID : "ENSG00000178814.17",
      gene_id : "ENSG00000178814.17",
      gene_type : "protein_coding",
      gene_name : "OPLAH",
      gene_level : 2,
      hgnc_id : "HGNC:8149",
      havana_gene : "OTTHUMG00000165435.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144078648,
      stop : 144080648,
      direction : "+",
      ID : "ENSG00000178896.9",
      gene_id : "ENSG00000178896.9",
      gene_type : "protein_coding",
      gene_name : "EXOSC4",
      gene_level : 1,
      hgnc_id : "HGNC:18189",
      havana_gene : "OTTHUMG00000165437.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144082590,
      stop : 144086216,
      direction : "+",
      ID : "ENSG00000197858.11",
      gene_id : "ENSG00000197858.11",
      gene_type : "protein_coding",
      gene_name : "GPAA1",
      gene_level : 2,
      hgnc_id : "HGNC:4446",
      havana_gene : "OTTHUMG00000165438.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144095039,
      stop : 144097525,
      direction : "+",
      ID : "ENSG00000179091.5",
      gene_id : "ENSG00000179091.5",
      gene_type : "protein_coding",
      gene_name : "CYC1",
      gene_level : 2,
      hgnc_id : "HGNC:2579",
      havana_gene : "OTTHUMG00000165242.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144098633,
      stop : 144108124,
      direction : "-",
      ID : "ENSG00000179526.17",
      gene_id : "ENSG00000179526.17",
      gene_type : "protein_coding",
      gene_name : "SHARPIN",
      gene_level : 2,
      hgnc_id : "HGNC:25321",
      havana_gene : "OTTHUMG00000165243.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144104461,
      stop : 144107611,
      direction : "+",
      ID : "ENSG00000179632.10",
      gene_id : "ENSG00000179632.10",
      gene_type : "protein_coding",
      gene_name : "MAF1",
      gene_level : 2,
      hgnc_id : "HGNC:24966",
      havana_gene : "OTTHUMG00000165244.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144107726,
      stop : 144118328,
      direction : "+",
      ID : "ENSG00000179698.14",
      gene_id : "ENSG00000179698.14",
      gene_type : "protein_coding",
      gene_name : "WDR97",
      gene_level : 2,
      hgnc_id : "HGNC:26959",
      havana_gene : "OTTHUMG00000165245.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144137774,
      stop : 144140851,
      direction : "+",
      ID : "ENSG00000235173.7",
      gene_id : "ENSG00000235173.7",
      gene_type : "protein_coding",
      gene_name : "HGH1",
      gene_level : 2,
      hgnc_id : "HGNC:24161",
      havana_gene : "OTTHUMG00000165246.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144148016,
      stop : 144261940,
      direction : "+",
      ID : "ENSG00000179832.17",
      gene_id : "ENSG00000179832.17",
      gene_type : "protein_coding",
      gene_name : "MROH1",
      gene_level : 1,
      hgnc_id : "HGNC:26958",
      havana_gene : "OTTHUMG00000165781.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144262045,
      stop : 144291438,
      direction : "-",
      ID : "ENSG00000261236.8",
      gene_id : "ENSG00000261236.8",
      gene_type : "protein_coding",
      gene_name : "BOP1",
      gene_level : 2,
      hgnc_id : "HGNC:15519",
      havana_gene : "OTTHUMG00000174603.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144266453,
      stop : 144268481,
      direction : "+",
      ID : "ENSG00000260428.3",
      gene_id : "ENSG00000260428.3",
      gene_type : "protein_coding",
      gene_name : "SCX",
      gene_level : 2,
      hgnc_id : "HGNC:32322",
      havana_gene : "OTTHUMG00000175582.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144291591,
      stop : 144314720,
      direction : "+",
      ID : "ENSG00000185122.11",
      gene_id : "ENSG00000185122.11",
      gene_type : "protein_coding",
      gene_name : "HSF1",
      gene_level : 1,
      hgnc_id : "HGNC:5224",
      havana_gene : "OTTHUMG00000174604.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144314584,
      stop : 144326910,
      direction : "-",
      ID : "ENSG00000185000.12",
      gene_id : "ENSG00000185000.12",
      gene_type : "protein_coding",
      gene_name : "DGAT1",
      gene_level : 2,
      hgnc_id : "HGNC:2843",
      havana_gene : "OTTHUMG00000174606.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144330565,
      stop : 144336482,
      direction : "-",
      ID : "ENSG00000261678.3",
      gene_id : "ENSG00000261678.3",
      gene_type : "protein_coding",
      gene_name : "SCRT1",
      gene_level : 2,
      hgnc_id : "HGNC:15950",
      havana_gene : "OTTHUMG00000165229.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144333957,
      stop : 144361286,
      direction : "+",
      ID : "ENSG00000185803.12",
      gene_id : "ENSG00000185803.12",
      gene_type : "protein_coding",
      gene_name : "SLC52A2",
      gene_level : 1,
      hgnc_id : "HGNC:30224",
      havana_gene : "OTTHUMG00000165168.9",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144352219,
      stop : 144354914,
      direction : "-",
      ID : "ENSG00000261587.2",
      gene_id : "ENSG00000261587.2",
      gene_type : "protein_coding",
      gene_name : "TMEM249",
      gene_level : 2,
      hgnc_id : "HGNC:44155",
      havana_gene : "OTTHUMG00000165167.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144353228,
      stop : 144355609,
      direction : "-",
      ID : "ENSG00000271698.1",
      gene_id : "ENSG00000271698.1",
      gene_type : "protein_coding",
      gene_name : "AC233992.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000184228.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144355431,
      stop : 144359376,
      direction : "-",
      ID : "ENSG00000182325.11",
      gene_id : "ENSG00000182325.11",
      gene_type : "protein_coding",
      gene_name : "FBXL6",
      gene_level : 2,
      hgnc_id : "HGNC:13603",
      havana_gene : "OTTHUMG00000165169.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144373101,
      stop : 144393242,
      direction : "+",
      ID : "ENSG00000173137.12",
      gene_id : "ENSG00000173137.12",
      gene_type : "protein_coding",
      gene_name : "ADCK5",
      gene_level : 2,
      hgnc_id : "HGNC:21738",
      havana_gene : "OTTHUMG00000165190.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144393229,
      stop : 144409335,
      direction : "-",
      ID : "ENSG00000071894.17",
      gene_id : "ENSG00000071894.17",
      gene_type : "protein_coding",
      gene_name : "CPSF1",
      gene_level : 2,
      hgnc_id : "HGNC:2324",
      havana_gene : "OTTHUMG00000174612.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144409742,
      stop : 144416844,
      direction : "-",
      ID : "ENSG00000147804.10",
      gene_id : "ENSG00000147804.10",
      gene_type : "protein_coding",
      gene_name : "SLC39A4",
      gene_level : 1,
      hgnc_id : "HGNC:17129",
      havana_gene : "OTTHUMG00000165208.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144423601,
      stop : 144428563,
      direction : "-",
      ID : "ENSG00000160948.14",
      gene_id : "ENSG00000160948.14",
      gene_type : "protein_coding",
      gene_name : "VPS28",
      gene_level : 2,
      hgnc_id : "HGNC:18178",
      havana_gene : "OTTHUMG00000165209.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144428775,
      stop : 144444440,
      direction : "-",
      ID : "ENSG00000160949.17",
      gene_id : "ENSG00000160949.17",
      gene_type : "protein_coding",
      gene_name : "TONSL",
      gene_level : 2,
      hgnc_id : "HGNC:7801",
      havana_gene : "OTTHUMG00000153122.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144449582,
      stop : 144465667,
      direction : "-",
      ID : "ENSG00000187954.13",
      gene_id : "ENSG00000187954.13",
      gene_type : "protein_coding",
      gene_name : "CYHR1",
      gene_level : 1,
      hgnc_id : "HGNC:17806",
      havana_gene : "OTTHUMG00000165171.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144466043,
      stop : 144474202,
      direction : "+",
      ID : "ENSG00000167702.13",
      gene_id : "ENSG00000167702.13",
      gene_type : "protein_coding",
      gene_name : "KIFC2",
      gene_level : 2,
      hgnc_id : "HGNC:29530",
      havana_gene : "OTTHUMG00000165133.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144473412,
      stop : 144475849,
      direction : "-",
      ID : "ENSG00000160973.8",
      gene_id : "ENSG00000160973.8",
      gene_type : "protein_coding",
      gene_name : "FOXH1",
      gene_level : 2,
      hgnc_id : "HGNC:3814",
      havana_gene : "OTTHUMG00000165172.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144477969,
      stop : 144502121,
      direction : "+",
      ID : "ENSG00000160972.9",
      gene_id : "ENSG00000160972.9",
      gene_type : "protein_coding",
      gene_name : "PPP1R16A",
      gene_level : 2,
      hgnc_id : "HGNC:14941",
      havana_gene : "OTTHUMG00000165173.5",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144502973,
      stop : 144507174,
      direction : "+",
      ID : "ENSG00000167701.14",
      gene_id : "ENSG00000167701.14",
      gene_type : "protein_coding",
      gene_name : "GPT",
      gene_level : 2,
      hgnc_id : "HGNC:4552",
      havana_gene : "OTTHUMG00000165176.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144509070,
      stop : 144511213,
      direction : "+",
      ID : "ENSG00000167700.9",
      gene_id : "ENSG00000167700.9",
      gene_type : "protein_coding",
      gene_name : "MFSD3",
      gene_level : 2,
      hgnc_id : "HGNC:25157",
      havana_gene : "OTTHUMG00000165177.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144511288,
      stop : 144517845,
      direction : "-",
      ID : "ENSG00000160957.14",
      gene_id : "ENSG00000160957.14",
      gene_type : "protein_coding",
      gene_name : "RECQL4",
      gene_level : 2,
      hgnc_id : "HGNC:9949",
      havana_gene : "OTTHUMG00000165178.7",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144517992,
      stop : 144525172,
      direction : "+",
      ID : "ENSG00000160959.8",
      gene_id : "ENSG00000160959.8",
      gene_type : "protein_coding",
      gene_name : "LRRC14",
      gene_level : 2,
      hgnc_id : "HGNC:20419",
      havana_gene : "OTTHUMG00000165179.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144522388,
      stop : 144527033,
      direction : "-",
      ID : "ENSG00000254402.7",
      gene_id : "ENSG00000254402.7",
      gene_type : "protein_coding",
      gene_name : "LRRC24",
      gene_level : 2,
      hgnc_id : "HGNC:28947",
      havana_gene : "OTTHUMG00000165180.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144525733,
      stop : 144529132,
      direction : "-",
      ID : "ENSG00000213563.7",
      gene_id : "ENSG00000213563.7",
      gene_type : "protein_coding",
      gene_name : "C8orf82",
      gene_level : 2,
      hgnc_id : "HGNC:33826",
      havana_gene : "OTTHUMG00000165181.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144529179,
      stop : 144605816,
      direction : "-",
      ID : "ENSG00000147799.11",
      gene_id : "ENSG00000147799.11",
      gene_type : "protein_coding",
      gene_name : "ARHGAP39",
      gene_level : 2,
      hgnc_id : "HGNC:29351",
      havana_gene : "OTTHUMG00000165182.1",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144720907,
      stop : 144756417,
      direction : "-",
      ID : "ENSG00000198169.9",
      gene_id : "ENSG00000198169.9",
      gene_type : "protein_coding",
      gene_name : "ZNF251",
      gene_level : 2,
      hgnc_id : "HGNC:13045",
      havana_gene : "OTTHUMG00000165189.4",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144772224,
      stop : 144787345,
      direction : "-",
      ID : "ENSG00000196378.13",
      gene_id : "ENSG00000196378.13",
      gene_type : "protein_coding",
      gene_name : "ZNF34",
      gene_level : 2,
      hgnc_id : "HGNC:13098",
      havana_gene : "OTTHUMG00000165248.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144789765,
      stop : 144792587,
      direction : "-",
      ID : "ENSG00000161016.18",
      gene_id : "ENSG00000161016.18",
      gene_type : "protein_coding",
      gene_name : "RPL8",
      gene_level : 2,
      hgnc_id : "HGNC:10368",
      havana_gene : "OTTHUMG00000165249.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144798876,
      stop : 144811169,
      direction : "+",
      ID : "ENSG00000197363.9",
      gene_id : "ENSG00000197363.9",
      gene_type : "protein_coding",
      gene_name : "ZNF517",
      gene_level : 1,
      hgnc_id : "HGNC:27984",
      havana_gene : "OTTHUMG00000165199.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144827464,
      stop : 144847509,
      direction : "+",
      ID : "ENSG00000147789.15",
      gene_id : "ENSG00000147789.15",
      gene_type : "protein_coding",
      gene_name : "ZNF7",
      gene_level : 1,
      hgnc_id : "HGNC:13139",
      havana_gene : "OTTHUMG00000165200.2",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144841042,
      stop : 144853736,
      direction : "-",
      ID : "ENSG00000170619.10",
      gene_id : "ENSG00000170619.10",
      gene_type : "protein_coding",
      gene_name : "COMMD5",
      gene_level : 1,
      hgnc_id : "HGNC:17902",
      havana_gene : "OTTHUMG00000165251.6",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144876497,
      stop : 144902168,
      direction : "-",
      ID : "ENSG00000196150.14",
      gene_id : "ENSG00000196150.14",
      gene_type : "protein_coding",
      gene_name : "ZNF250",
      gene_level : 1,
      hgnc_id : "HGNC:13044",
      havana_gene : "OTTHUMG00000165252.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 144930358,
      stop : 144950888,
      direction : "-",
      ID : "ENSG00000170631.15",
      gene_id : "ENSG00000170631.15",
      gene_type : "protein_coding",
      gene_name : "ZNF16",
      gene_level : 1,
      hgnc_id : "HGNC:12947",
      havana_gene : "OTTHUMG00000165253.3",
      tag : null
    },
    {
      chromosome : 8,
      annotation : "HAVANA",
      type : "gene",
      start : 145052465,
      stop : 145066685,
      direction : "+",
      ID : "ENSG00000182307.14",
      gene_id : "ENSG00000182307.14",
      gene_type : "protein_coding",
      gene_name : "C8orf33",
      gene_level : 2,
      hgnc_id : "HGNC:26104",
      havana_gene : "OTTHUMG00000165256.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 14475,
      stop : 73865,
      direction : "-",
      ID : "ENSG00000181404.17",
      gene_id : "ENSG00000181404.17",
      gene_type : "protein_coding",
      gene_name : "WASHC1",
      gene_level : 2,
      hgnc_id : "HGNC:24361",
      havana_gene : "OTTHUMG00000019420.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 116231,
      stop : 118417,
      direction : "-",
      ID : "ENSG00000170122.6",
      gene_id : "ENSG00000170122.6",
      gene_type : "protein_coding",
      gene_name : "FOXD4",
      gene_level : 2,
      hgnc_id : "HGNC:3805",
      havana_gene : "OTTHUMG00000021015.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121038,
      stop : 179147,
      direction : "-",
      ID : "ENSG00000172785.18",
      gene_id : "ENSG00000172785.18",
      gene_type : "protein_coding",
      gene_name : "CBWD1",
      gene_level : 2,
      hgnc_id : "HGNC:17134",
      havana_gene : "OTTHUMG00000019425.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 214854,
      stop : 465259,
      direction : "+",
      ID : "ENSG00000107099.16",
      gene_id : "ENSG00000107099.16",
      gene_type : "protein_coding",
      gene_name : "DOCK8",
      gene_level : 1,
      hgnc_id : "HGNC:19191",
      havana_gene : "OTTHUMG00000078789.9",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 470291,
      stop : 746106,
      direction : "+",
      ID : "ENSG00000107104.20",
      gene_id : "ENSG00000107104.20",
      gene_type : "protein_coding",
      gene_name : "KANK1",
      gene_level : 2,
      hgnc_id : "HGNC:19309",
      havana_gene : "OTTHUMG00000019434.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 841690,
      stop : 969090,
      direction : "+",
      ID : "ENSG00000137090.12",
      gene_id : "ENSG00000137090.12",
      gene_type : "protein_coding",
      gene_name : "DMRT1",
      gene_level : 1,
      hgnc_id : "HGNC:2934",
      havana_gene : "OTTHUMG00000019435.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 976655,
      stop : 991732,
      direction : "+",
      ID : "ENSG00000064218.5",
      gene_id : "ENSG00000064218.5",
      gene_type : "protein_coding",
      gene_name : "DMRT3",
      gene_level : 2,
      hgnc_id : "HGNC:13909",
      havana_gene : "OTTHUMG00000019436.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 1049858,
      stop : 1057552,
      direction : "+",
      ID : "ENSG00000173253.15",
      gene_id : "ENSG00000173253.15",
      gene_type : "protein_coding",
      gene_name : "DMRT2",
      gene_level : 2,
      hgnc_id : "HGNC:2935",
      havana_gene : "OTTHUMG00000019437.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 1980290,
      stop : 2193624,
      direction : "+",
      ID : "ENSG00000080503.24",
      gene_id : "ENSG00000080503.24",
      gene_type : "protein_coding",
      gene_name : "SMARCA2",
      gene_level : 2,
      hgnc_id : "HGNC:11098",
      havana_gene : "OTTHUMG00000019445.14",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 2621182,
      stop : 2660056,
      direction : "+",
      ID : "ENSG00000147852.17",
      gene_id : "ENSG00000147852.17",
      gene_type : "protein_coding",
      gene_name : "VLDLR",
      gene_level : 2,
      hgnc_id : "HGNC:12698",
      havana_gene : "OTTHUMG00000019447.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 2717510,
      stop : 2730037,
      direction : "+",
      ID : "ENSG00000168263.9",
      gene_id : "ENSG00000168263.9",
      gene_type : "protein_coding",
      gene_name : "KCNV2",
      gene_level : 2,
      hgnc_id : "HGNC:19698",
      havana_gene : "OTTHUMG00000019449.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 2720469,
      stop : 2844095,
      direction : "-",
      ID : "ENSG00000080608.10",
      gene_id : "ENSG00000080608.10",
      gene_type : "protein_coding",
      gene_name : "PUM3",
      gene_level : 2,
      hgnc_id : "HGNC:29676",
      havana_gene : "OTTHUMG00000019450.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 3218297,
      stop : 3526004,
      direction : "-",
      ID : "ENSG00000080298.15",
      gene_id : "ENSG00000080298.15",
      gene_type : "protein_coding",
      gene_name : "RFX3",
      gene_level : 2,
      hgnc_id : "HGNC:9984",
      havana_gene : "OTTHUMG00000019456.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 3824127,
      stop : 4348392,
      direction : "-",
      ID : "ENSG00000107249.23",
      gene_id : "ENSG00000107249.23",
      gene_type : "protein_coding",
      gene_name : "GLIS3",
      gene_level : 2,
      hgnc_id : "HGNC:28510",
      havana_gene : "OTTHUMG00000019463.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4490468,
      stop : 4587469,
      direction : "+",
      ID : "ENSG00000106688.12",
      gene_id : "ENSG00000106688.12",
      gene_type : "protein_coding",
      gene_name : "SLC1A1",
      gene_level : 2,
      hgnc_id : "HGNC:10939",
      havana_gene : "OTTHUMG00000019468.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4553386,
      stop : 4666674,
      direction : "-",
      ID : "ENSG00000106686.16",
      gene_id : "ENSG00000106686.16",
      gene_type : "protein_coding",
      gene_name : "SPATA6L",
      gene_level : 1,
      hgnc_id : "HGNC:25472",
      havana_gene : "OTTHUMG00000019469.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4662294,
      stop : 4665258,
      direction : "+",
      ID : "ENSG00000205808.7",
      gene_id : "ENSG00000205808.7",
      gene_type : "protein_coding",
      gene_name : "PLPP6",
      gene_level : 2,
      hgnc_id : "HGNC:23682",
      havana_gene : "OTTHUMG00000019466.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4679559,
      stop : 4708399,
      direction : "+",
      ID : "ENSG00000106993.12",
      gene_id : "ENSG00000106993.12",
      gene_type : "protein_coding",
      gene_name : "CDC37L1",
      gene_level : 2,
      hgnc_id : "HGNC:17179",
      havana_gene : "OTTHUMG00000019465.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4709556,
      stop : 4742043,
      direction : "-",
      ID : "ENSG00000147853.17",
      gene_id : "ENSG00000147853.17",
      gene_type : "protein_coding",
      gene_name : "AK3",
      gene_level : 2,
      hgnc_id : "HGNC:17376",
      havana_gene : "OTTHUMG00000019472.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4792944,
      stop : 4885917,
      direction : "+",
      ID : "ENSG00000120158.12",
      gene_id : "ENSG00000120158.12",
      gene_type : "protein_coding",
      gene_name : "RCL1",
      gene_level : 2,
      hgnc_id : "HGNC:17687",
      havana_gene : "OTTHUMG00000019474.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 4984390,
      stop : 5129948,
      direction : "+",
      ID : "ENSG00000096968.14",
      gene_id : "ENSG00000096968.14",
      gene_type : "protein_coding",
      gene_name : "JAK2",
      gene_level : 2,
      hgnc_id : "HGNC:6192",
      havana_gene : "OTTHUMG00000019490.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5123880,
      stop : 5185647,
      direction : "-",
      ID : "ENSG00000120210.8",
      gene_id : "ENSG00000120210.8",
      gene_type : "protein_coding",
      gene_name : "INSL6",
      gene_level : 2,
      hgnc_id : "HGNC:6089",
      havana_gene : "OTTHUMG00000019489.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5231419,
      stop : 5235304,
      direction : "+",
      ID : "ENSG00000120211.4",
      gene_id : "ENSG00000120211.4",
      gene_type : "protein_coding",
      gene_name : "INSL4",
      gene_level : 2,
      hgnc_id : "HGNC:6087",
      havana_gene : "OTTHUMG00000019494.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5299864,
      stop : 5304716,
      direction : "-",
      ID : "ENSG00000107014.9",
      gene_id : "ENSG00000107014.9",
      gene_type : "protein_coding",
      gene_name : "RLN2",
      gene_level : 2,
      hgnc_id : "HGNC:10027",
      havana_gene : "OTTHUMG00000019496.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5334930,
      stop : 5339876,
      direction : "-",
      ID : "ENSG00000107018.8",
      gene_id : "ENSG00000107018.8",
      gene_type : "protein_coding",
      gene_name : "RLN1",
      gene_level : 2,
      hgnc_id : "HGNC:10026",
      havana_gene : "OTTHUMG00000019495.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5357971,
      stop : 5437925,
      direction : "-",
      ID : "ENSG00000107020.10",
      gene_id : "ENSG00000107020.10",
      gene_type : "protein_coding",
      gene_name : "PLGRKT",
      gene_level : 2,
      hgnc_id : "HGNC:23633",
      havana_gene : "OTTHUMG00000019501.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5450503,
      stop : 5470566,
      direction : "+",
      ID : "ENSG00000120217.14",
      gene_id : "ENSG00000120217.14",
      gene_type : "protein_coding",
      gene_name : "CD274",
      gene_level : 2,
      hgnc_id : "HGNC:17635",
      havana_gene : "OTTHUMG00000019503.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5510531,
      stop : 5571282,
      direction : "+",
      ID : "ENSG00000197646.8",
      gene_id : "ENSG00000197646.8",
      gene_type : "protein_coding",
      gene_name : "PDCD1LG2",
      gene_level : 2,
      hgnc_id : "HGNC:18731",
      havana_gene : "OTTHUMG00000019504.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5629025,
      stop : 5776557,
      direction : "+",
      ID : "ENSG00000107036.12",
      gene_id : "ENSG00000107036.12",
      gene_type : "protein_coding",
      gene_name : "RIC1",
      gene_level : 2,
      hgnc_id : "HGNC:17686",
      havana_gene : "OTTHUMG00000019505.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5765076,
      stop : 5833117,
      direction : "-",
      ID : "ENSG00000099219.14",
      gene_id : "ENSG00000099219.14",
      gene_type : "protein_coding",
      gene_name : "ERMP1",
      gene_level : 2,
      hgnc_id : "HGNC:23703",
      havana_gene : "OTTHUMG00000019508.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5881596,
      stop : 6008482,
      direction : "-",
      ID : "ENSG00000183354.12",
      gene_id : "ENSG00000183354.12",
      gene_type : "protein_coding",
      gene_name : "KIAA2026",
      gene_level : 2,
      hgnc_id : "HGNC:23378",
      havana_gene : "OTTHUMG00000019507.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 5890889,
      stop : 5910606,
      direction : "+",
      ID : "ENSG00000120215.10",
      gene_id : "ENSG00000120215.10",
      gene_type : "protein_coding",
      gene_name : "MLANA",
      gene_level : 2,
      hgnc_id : "HGNC:7124",
      havana_gene : "OTTHUMG00000019510.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 6011025,
      stop : 6015625,
      direction : "-",
      ID : "ENSG00000137040.10",
      gene_id : "ENSG00000137040.10",
      gene_type : "protein_coding",
      gene_name : "RANBP6",
      gene_level : 2,
      hgnc_id : "HGNC:9851",
      havana_gene : "OTTHUMG00000019512.5",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 6215786,
      stop : 6257983,
      direction : "+",
      ID : "ENSG00000137033.11",
      gene_id : "ENSG00000137033.11",
      gene_type : "protein_coding",
      gene_name : "IL33",
      gene_level : 2,
      hgnc_id : "HGNC:16028",
      havana_gene : "OTTHUMG00000019516.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 6328375,
      stop : 6331900,
      direction : "+",
      ID : "ENSG00000170777.10",
      gene_id : "ENSG00000170777.10",
      gene_type : "protein_coding",
      gene_name : "TPD52L3",
      gene_level : 2,
      hgnc_id : "HGNC:23382",
      havana_gene : "OTTHUMG00000019518.1",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 6413151,
      stop : 6507054,
      direction : "+",
      ID : "ENSG00000147854.17",
      gene_id : "ENSG00000147854.17",
      gene_type : "protein_coding",
      gene_name : "UHRF2",
      gene_level : 2,
      hgnc_id : "HGNC:12557",
      havana_gene : "OTTHUMG00000019521.9",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 6532467,
      stop : 6645729,
      direction : "-",
      ID : "ENSG00000178445.10",
      gene_id : "ENSG00000178445.10",
      gene_type : "protein_coding",
      gene_name : "GLDC",
      gene_level : 2,
      hgnc_id : "HGNC:4313",
      havana_gene : "OTTHUMG00000019524.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 6720863,
      stop : 7175648,
      direction : "+",
      ID : "ENSG00000107077.19",
      gene_id : "ENSG00000107077.19",
      gene_type : "protein_coding",
      gene_name : "KDM4C",
      gene_level : 2,
      hgnc_id : "HGNC:17071",
      havana_gene : "OTTHUMG00000019536.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 7796500,
      stop : 7888380,
      direction : "-",
      ID : "ENSG00000137038.8",
      gene_id : "ENSG00000137038.8",
      gene_type : "protein_coding",
      gene_name : "DMAC1",
      gene_level : 2,
      hgnc_id : "HGNC:30536",
      havana_gene : "OTTHUMG00000019539.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 8314246,
      stop : 10612723,
      direction : "-",
      ID : "ENSG00000153707.17",
      gene_id : "ENSG00000153707.17",
      gene_type : "protein_coding",
      gene_name : "PTPRD",
      gene_level : 2,
      hgnc_id : "HGNC:9668",
      havana_gene : "OTTHUMG00000021005.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 12685439,
      stop : 12710285,
      direction : "+",
      ID : "ENSG00000107165.13",
      gene_id : "ENSG00000107165.13",
      gene_type : "protein_coding",
      gene_name : "TYRP1",
      gene_level : 2,
      hgnc_id : "HGNC:12450",
      havana_gene : "OTTHUMG00000021034.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 12775020,
      stop : 12823060,
      direction : "+",
      ID : "ENSG00000153714.6",
      gene_id : "ENSG00000153714.6",
      gene_type : "protein_coding",
      gene_name : "LURAP1L",
      gene_level : 2,
      hgnc_id : "HGNC:31452",
      havana_gene : "OTTHUMG00000019557.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 13105706,
      stop : 13279692,
      direction : "-",
      ID : "ENSG00000107186.17",
      gene_id : "ENSG00000107186.17",
      gene_type : "protein_coding",
      gene_name : "MPDZ",
      gene_level : 1,
      hgnc_id : "HGNC:7208",
      havana_gene : "OTTHUMG00000021031.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 14081843,
      stop : 14398983,
      direction : "-",
      ID : "ENSG00000147862.17",
      gene_id : "ENSG00000147862.17",
      gene_type : "protein_coding",
      gene_name : "NFIB",
      gene_level : 1,
      hgnc_id : "HGNC:7785",
      havana_gene : "OTTHUMG00000021027.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 14611071,
      stop : 14693432,
      direction : "-",
      ID : "ENSG00000175893.12",
      gene_id : "ENSG00000175893.12",
      gene_type : "protein_coding",
      gene_name : "ZDHHC21",
      gene_level : 2,
      hgnc_id : "HGNC:20750",
      havana_gene : "OTTHUMG00000019573.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 14719724,
      stop : 14722733,
      direction : "-",
      ID : "ENSG00000147869.5",
      gene_id : "ENSG00000147869.5",
      gene_type : "protein_coding",
      gene_name : "CER1",
      gene_level : 2,
      hgnc_id : "HGNC:1862",
      havana_gene : "OTTHUMG00000021022.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 14737152,
      stop : 14910995,
      direction : "-",
      ID : "ENSG00000164946.20",
      gene_id : "ENSG00000164946.20",
      gene_type : "protein_coding",
      gene_name : "FREM1",
      gene_level : 2,
      hgnc_id : "HGNC:23399",
      havana_gene : "OTTHUMG00000019575.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 15163622,
      stop : 15307360,
      direction : "-",
      ID : "ENSG00000155158.20",
      gene_id : "ENSG00000155158.20",
      gene_type : "protein_coding",
      gene_name : "TTC39B",
      gene_level : 1,
      hgnc_id : "HGNC:23704",
      havana_gene : "OTTHUMG00000019581.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 15422704,
      stop : 15465953,
      direction : "+",
      ID : "ENSG00000164975.15",
      gene_id : "ENSG00000164975.15",
      gene_type : "protein_coding",
      gene_name : "SNAPC3",
      gene_level : 2,
      hgnc_id : "HGNC:11136",
      havana_gene : "OTTHUMG00000019583.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 15464066,
      stop : 15510995,
      direction : "-",
      ID : "ENSG00000164985.15",
      gene_id : "ENSG00000164985.15",
      gene_type : "protein_coding",
      gene_name : "PSIP1",
      gene_level : 2,
      hgnc_id : "HGNC:9527",
      havana_gene : "OTTHUMG00000021021.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 15553043,
      stop : 16061663,
      direction : "+",
      ID : "ENSG00000164989.17",
      gene_id : "ENSG00000164989.17",
      gene_type : "protein_coding",
      gene_name : "CCDC171",
      gene_level : 2,
      hgnc_id : "HGNC:29828",
      havana_gene : "OTTHUMG00000019584.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 16409503,
      stop : 16870843,
      direction : "-",
      ID : "ENSG00000173068.18",
      gene_id : "ENSG00000173068.18",
      gene_type : "protein_coding",
      gene_name : "BNC2",
      gene_level : 2,
      hgnc_id : "HGNC:30988",
      havana_gene : "OTTHUMG00000019593.13",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 17134982,
      stop : 17503923,
      direction : "+",
      ID : "ENSG00000044459.15",
      gene_id : "ENSG00000044459.15",
      gene_type : "protein_coding",
      gene_name : "CNTLN",
      gene_level : 2,
      hgnc_id : "HGNC:23432",
      havana_gene : "OTTHUMG00000019599.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 17579066,
      stop : 17797124,
      direction : "+",
      ID : "ENSG00000107295.10",
      gene_id : "ENSG00000107295.10",
      gene_type : "protein_coding",
      gene_name : "SH3GL2",
      gene_level : 2,
      hgnc_id : "HGNC:10831",
      havana_gene : "OTTHUMG00000019601.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 17906563,
      stop : 18910950,
      direction : "+",
      ID : "ENSG00000178031.18",
      gene_id : "ENSG00000178031.18",
      gene_type : "protein_coding",
      gene_name : "ADAMTSL1",
      gene_level : 1,
      hgnc_id : "HGNC:14632",
      havana_gene : "OTTHUMG00000019604.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 18858906,
      stop : 19049358,
      direction : "-",
      ID : "ENSG00000155875.15",
      gene_id : "ENSG00000155875.15",
      gene_type : "protein_coding",
      gene_name : "SAXO1",
      gene_level : 1,
      hgnc_id : "HGNC:28566",
      havana_gene : "OTTHUMG00000019609.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19049427,
      stop : 19051025,
      direction : "+",
      ID : "ENSG00000155876.6",
      gene_id : "ENSG00000155876.6",
      gene_type : "protein_coding",
      gene_name : "RRAGA",
      gene_level : 2,
      hgnc_id : "HGNC:16963",
      havana_gene : "OTTHUMG00000019621.2",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19053141,
      stop : 19102904,
      direction : "-",
      ID : "ENSG00000147874.11",
      gene_id : "ENSG00000147874.11",
      gene_type : "protein_coding",
      gene_name : "HAUS6",
      gene_level : 2,
      hgnc_id : "HGNC:25948",
      havana_gene : "OTTHUMG00000019622.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19108375,
      stop : 19149290,
      direction : "-",
      ID : "ENSG00000147872.10",
      gene_id : "ENSG00000147872.10",
      gene_type : "protein_coding",
      gene_name : "PLIN2",
      gene_level : 2,
      hgnc_id : "HGNC:248",
      havana_gene : "OTTHUMG00000019624.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19230435,
      stop : 19374281,
      direction : "+",
      ID : "ENSG00000137145.21",
      gene_id : "ENSG00000137145.21",
      gene_type : "protein_coding",
      gene_name : "DENND4C",
      gene_level : 1,
      hgnc_id : "HGNC:26079",
      havana_gene : "OTTHUMG00000019627.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19375715,
      stop : 19380236,
      direction : "-",
      ID : "ENSG00000137154.13",
      gene_id : "ENSG00000137154.13",
      gene_type : "protein_coding",
      gene_name : "RPS6",
      gene_level : 2,
      hgnc_id : "HGNC:10429",
      havana_gene : "OTTHUMG00000019642.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19409009,
      stop : 19452505,
      direction : "+",
      ID : "ENSG00000177076.6",
      gene_id : "ENSG00000177076.6",
      gene_type : "protein_coding",
      gene_name : "ACER2",
      gene_level : 2,
      hgnc_id : "HGNC:23675",
      havana_gene : "OTTHUMG00000019644.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 19507452,
      stop : 19786928,
      direction : "-",
      ID : "ENSG00000155886.11",
      gene_id : "ENSG00000155886.11",
      gene_type : "protein_coding",
      gene_name : "SLC24A2",
      gene_level : 2,
      hgnc_id : "HGNC:10976",
      havana_gene : "OTTHUMG00000019646.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 20341669,
      stop : 20622499,
      direction : "-",
      ID : "ENSG00000171843.17",
      gene_id : "ENSG00000171843.17",
      gene_type : "protein_coding",
      gene_name : "MLLT3",
      gene_level : 2,
      hgnc_id : "HGNC:7136",
      havana_gene : "OTTHUMG00000019650.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 20658309,
      stop : 20995955,
      direction : "+",
      ID : "ENSG00000188352.12",
      gene_id : "ENSG00000188352.12",
      gene_type : "protein_coding",
      gene_name : "FOCAD",
      gene_level : 1,
      hgnc_id : "HGNC:23377",
      havana_gene : "OTTHUMG00000066930.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 20999509,
      stop : 21031640,
      direction : "-",
      ID : "ENSG00000188921.14",
      gene_id : "ENSG00000188921.14",
      gene_type : "protein_coding",
      gene_name : "HACD4",
      gene_level : 2,
      hgnc_id : "HGNC:20920",
      havana_gene : "OTTHUMG00000021016.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21077104,
      stop : 21077942,
      direction : "-",
      ID : "ENSG00000171855.7",
      gene_id : "ENSG00000171855.7",
      gene_type : "protein_coding",
      gene_name : "IFNB1",
      gene_level : 2,
      hgnc_id : "HGNC:5434",
      havana_gene : "OTTHUMG00000019652.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21140214,
      stop : 21142145,
      direction : "-",
      ID : "ENSG00000177047.6",
      gene_id : "ENSG00000177047.6",
      gene_type : "protein_coding",
      gene_name : "IFNW1",
      gene_level : 2,
      hgnc_id : "HGNC:5448",
      havana_gene : "OTTHUMG00000019656.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21165637,
      stop : 21166660,
      direction : "-",
      ID : "ENSG00000137080.4",
      gene_id : "ENSG00000137080.4",
      gene_type : "protein_coding",
      gene_name : "IFNA21",
      gene_level : 2,
      hgnc_id : "HGNC:5424",
      havana_gene : "OTTHUMG00000019653.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21186694,
      stop : 21187671,
      direction : "-",
      ID : "ENSG00000236637.4",
      gene_id : "ENSG00000236637.4",
      gene_type : "protein_coding",
      gene_name : "IFNA4",
      gene_level : 2,
      hgnc_id : "HGNC:5425",
      havana_gene : "OTTHUMG00000019660.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21201469,
      stop : 21202205,
      direction : "-",
      ID : "ENSG00000214042.1",
      gene_id : "ENSG00000214042.1",
      gene_type : "protein_coding",
      gene_name : "IFNA7",
      gene_level : 2,
      hgnc_id : "HGNC:5428",
      havana_gene : "OTTHUMG00000019662.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21206181,
      stop : 21207143,
      direction : "-",
      ID : "ENSG00000186803.3",
      gene_id : "ENSG00000186803.3",
      gene_type : "protein_coding",
      gene_name : "IFNA10",
      gene_level : 2,
      hgnc_id : "HGNC:5418",
      havana_gene : "OTTHUMG00000019658.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21216373,
      stop : 21217311,
      direction : "-",
      ID : "ENSG00000147885.4",
      gene_id : "ENSG00000147885.4",
      gene_type : "protein_coding",
      gene_name : "IFNA16",
      gene_level : 2,
      hgnc_id : "HGNC:5421",
      havana_gene : "OTTHUMG00000019663.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21227243,
      stop : 21228222,
      direction : "-",
      ID : "ENSG00000234829.4",
      gene_id : "ENSG00000234829.4",
      gene_type : "protein_coding",
      gene_name : "IFNA17",
      gene_level : 2,
      hgnc_id : "HGNC:5422",
      havana_gene : "OTTHUMG00000019667.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21239002,
      stop : 21240005,
      direction : "-",
      ID : "ENSG00000228083.3",
      gene_id : "ENSG00000228083.3",
      gene_type : "protein_coding",
      gene_name : "IFNA14",
      gene_level : 2,
      hgnc_id : "HGNC:5420",
      havana_gene : "OTTHUMG00000019665.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21304326,
      stop : 21305312,
      direction : "-",
      ID : "ENSG00000147873.5",
      gene_id : "ENSG00000147873.5",
      gene_type : "protein_coding",
      gene_name : "IFNA5",
      gene_level : 2,
      hgnc_id : "HGNC:5426",
      havana_gene : "OTTHUMG00000019664.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21329665,
      stop : 21335404,
      direction : "-",
      ID : "ENSG00000198642.7",
      gene_id : "ENSG00000198642.7",
      gene_type : "protein_coding",
      gene_name : "KLHL9",
      gene_level : 2,
      hgnc_id : "HGNC:18732",
      havana_gene : "OTTHUMG00000019669.3",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21349835,
      stop : 21351378,
      direction : "-",
      ID : "ENSG00000120235.4",
      gene_id : "ENSG00000120235.4",
      gene_type : "protein_coding",
      gene_name : "IFNA6",
      gene_level : 2,
      hgnc_id : "HGNC:5427",
      havana_gene : "OTTHUMG00000019676.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21367424,
      stop : 21368962,
      direction : "-",
      ID : "ENSG00000233816.3",
      gene_id : "ENSG00000233816.3",
      gene_type : "protein_coding",
      gene_name : "IFNA13",
      gene_level : 2,
      hgnc_id : "HGNC:5419",
      havana_gene : "OTTHUMG00000019675.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21384255,
      stop : 21385398,
      direction : "-",
      ID : "ENSG00000188379.7",
      gene_id : "ENSG00000188379.7",
      gene_type : "protein_coding",
      gene_name : "IFNA2",
      gene_level : 2,
      hgnc_id : "HGNC:5423",
      havana_gene : "OTTHUMG00000019674.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21409117,
      stop : 21410185,
      direction : "+",
      ID : "ENSG00000120242.4",
      gene_id : "ENSG00000120242.4",
      gene_type : "protein_coding",
      gene_name : "IFNA8",
      gene_level : 2,
      hgnc_id : "HGNC:5429",
      havana_gene : "OTTHUMG00000019677.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21440439,
      stop : 21441316,
      direction : "+",
      ID : "ENSG00000197919.6",
      gene_id : "ENSG00000197919.6",
      gene_type : "protein_coding",
      gene_name : "IFNA1",
      gene_level : 2,
      hgnc_id : "HGNC:5417",
      havana_gene : "OTTHUMG00000019673.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21480839,
      stop : 21482313,
      direction : "-",
      ID : "ENSG00000184995.7",
      gene_id : "ENSG00000184995.7",
      gene_type : "protein_coding",
      gene_name : "IFNE",
      gene_level : 2,
      hgnc_id : "HGNC:18163",
      havana_gene : "OTTHUMG00000019672.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21802636,
      stop : 21937651,
      direction : "+",
      ID : "ENSG00000099810.21",
      gene_id : "ENSG00000099810.21",
      gene_type : "protein_coding",
      gene_name : "MTAP",
      gene_level : 1,
      hgnc_id : "HGNC:7413",
      havana_gene : "OTTHUMG00000019690.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21802636,
      stop : 22029594,
      direction : "+",
      ID : "ENSG00000264545.2",
      gene_id : "ENSG00000264545.2",
      gene_type : "protein_coding",
      gene_name : "AL359922.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000179355.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 21967752,
      stop : 21995301,
      direction : "-",
      ID : "ENSG00000147889.18",
      gene_id : "ENSG00000147889.18",
      gene_type : "protein_coding",
      gene_name : "CDKN2A",
      gene_level : 1,
      hgnc_id : "HGNC:1787",
      havana_gene : "OTTHUMG00000019686.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 22002903,
      stop : 22009305,
      direction : "-",
      ID : "ENSG00000147883.12",
      gene_id : "ENSG00000147883.12",
      gene_type : "protein_coding",
      gene_name : "CDKN2B",
      gene_level : 2,
      hgnc_id : "HGNC:1788",
      havana_gene : "OTTHUMG00000019691.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 22446824,
      stop : 22455740,
      direction : "+",
      ID : "ENSG00000176399.4",
      gene_id : "ENSG00000176399.4",
      gene_type : "protein_coding",
      gene_name : "DMRTA1",
      gene_level : 2,
      hgnc_id : "HGNC:13826",
      havana_gene : "OTTHUMG00000019693.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 23690104,
      stop : 23826337,
      direction : "-",
      ID : "ENSG00000107105.15",
      gene_id : "ENSG00000107105.15",
      gene_type : "protein_coding",
      gene_name : "ELAVL2",
      gene_level : 1,
      hgnc_id : "HGNC:3313",
      havana_gene : "OTTHUMG00000019700.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 24542952,
      stop : 24545946,
      direction : "-",
      ID : "ENSG00000205442.13",
      gene_id : "ENSG00000205442.13",
      gene_type : "protein_coding",
      gene_name : "IZUMO3",
      gene_level : 2,
      hgnc_id : "HGNC:31421",
      havana_gene : "OTTHUMG00000019704.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 25676389,
      stop : 25678440,
      direction : "-",
      ID : "ENSG00000198680.5",
      gene_id : "ENSG00000198680.5",
      gene_type : "protein_coding",
      gene_name : "TUSC1",
      gene_level : 2,
      hgnc_id : "HGNC:31010",
      havana_gene : "OTTHUMG00000159591.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 26840685,
      stop : 26892803,
      direction : "-",
      ID : "ENSG00000120159.13",
      gene_id : "ENSG00000120159.13",
      gene_type : "protein_coding",
      gene_name : "CAAP1",
      gene_level : 2,
      hgnc_id : "HGNC:25834",
      havana_gene : "OTTHUMG00000019706.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 26903372,
      stop : 26947242,
      direction : "-",
      ID : "ENSG00000137055.15",
      gene_id : "ENSG00000137055.15",
      gene_type : "protein_coding",
      gene_name : "PLAA",
      gene_level : 1,
      hgnc_id : "HGNC:9043",
      havana_gene : "OTTHUMG00000019708.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 26947039,
      stop : 27066134,
      direction : "+",
      ID : "ENSG00000096872.17",
      gene_id : "ENSG00000096872.17",
      gene_type : "protein_coding",
      gene_name : "IFT74",
      gene_level : 1,
      hgnc_id : "HGNC:21424",
      havana_gene : "OTTHUMG00000021028.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 26993136,
      stop : 27005672,
      direction : "-",
      ID : "ENSG00000184434.8",
      gene_id : "ENSG00000184434.8",
      gene_type : "protein_coding",
      gene_name : "LRRC19",
      gene_level : 2,
      hgnc_id : "HGNC:23379",
      havana_gene : "OTTHUMG00000019710.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 27109141,
      stop : 27230174,
      direction : "+",
      ID : "ENSG00000120156.22",
      gene_id : "ENSG00000120156.22",
      gene_type : "protein_coding",
      gene_name : "TEK",
      gene_level : 1,
      hgnc_id : "HGNC:11724",
      havana_gene : "OTTHUMG00000019712.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 27284654,
      stop : 27297150,
      direction : "-",
      ID : "ENSG00000120160.11",
      gene_id : "ENSG00000120160.11",
      gene_type : "protein_coding",
      gene_name : "EQTN",
      gene_level : 2,
      hgnc_id : "HGNC:1359",
      havana_gene : "OTTHUMG00000021033.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 27325209,
      stop : 27529814,
      direction : "-",
      ID : "ENSG00000120162.10",
      gene_id : "ENSG00000120162.10",
      gene_type : "protein_coding",
      gene_name : "MOB3B",
      gene_level : 2,
      hgnc_id : "HGNC:23825",
      havana_gene : "OTTHUMG00000019717.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 27524290,
      stop : 27526498,
      direction : "+",
      ID : "ENSG00000147896.4",
      gene_id : "ENSG00000147896.4",
      gene_type : "protein_coding",
      gene_name : "IFNK",
      gene_level : 2,
      hgnc_id : "HGNC:21714",
      havana_gene : "OTTHUMG00000019715.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 27535640,
      stop : 27573866,
      direction : "-",
      ID : "ENSG00000147894.17",
      gene_id : "ENSG00000147894.17",
      gene_type : "protein_coding",
      gene_name : "C9orf72",
      gene_level : 2,
      hgnc_id : "HGNC:28337",
      havana_gene : "OTTHUMG00000019716.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 27948078,
      stop : 28670286,
      direction : "-",
      ID : "ENSG00000174482.10",
      gene_id : "ENSG00000174482.10",
      gene_type : "protein_coding",
      gene_name : "LINGO2",
      gene_level : 2,
      hgnc_id : "HGNC:21207",
      havana_gene : "OTTHUMG00000019721.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32384603,
      stop : 32454769,
      direction : "+",
      ID : "ENSG00000122729.19",
      gene_id : "ENSG00000122729.19",
      gene_type : "protein_coding",
      gene_name : "ACO1",
      gene_level : 2,
      hgnc_id : "HGNC:117",
      havana_gene : "OTTHUMG00000019740.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32455302,
      stop : 32526208,
      direction : "-",
      ID : "ENSG00000107201.11",
      gene_id : "ENSG00000107201.11",
      gene_type : "protein_coding",
      gene_name : "DDX58",
      gene_level : 2,
      hgnc_id : "HGNC:19102",
      havana_gene : "OTTHUMG00000019746.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32455323,
      stop : 32552603,
      direction : "-",
      ID : "ENSG00000288684.1",
      gene_id : "ENSG00000288684.1",
      gene_type : "protein_coding",
      gene_name : "AL353671.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32540544,
      stop : 32552586,
      direction : "-",
      ID : "ENSG00000197579.8",
      gene_id : "ENSG00000197579.8",
      gene_type : "protein_coding",
      gene_name : "TOPORS",
      gene_level : 2,
      hgnc_id : "HGNC:21653",
      havana_gene : "OTTHUMG00000019743.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32551144,
      stop : 32568621,
      direction : "+",
      ID : "ENSG00000235453.10",
      gene_id : "ENSG00000235453.10",
      gene_type : "protein_coding",
      gene_name : "SMIM27",
      gene_level : 2,
      hgnc_id : "HGNC:31420",
      havana_gene : "OTTHUMG00000019742.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32553001,
      stop : 32573184,
      direction : "-",
      ID : "ENSG00000165264.11",
      gene_id : "ENSG00000165264.11",
      gene_type : "protein_coding",
      gene_name : "NDUFB6",
      gene_level : 2,
      hgnc_id : "HGNC:7701",
      havana_gene : "OTTHUMG00000019741.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32629454,
      stop : 32635669,
      direction : "-",
      ID : "ENSG00000122728.6",
      gene_id : "ENSG00000122728.6",
      gene_type : "protein_coding",
      gene_name : "TAF1L",
      gene_level : 2,
      hgnc_id : "HGNC:18056",
      havana_gene : "OTTHUMG00000019747.2",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32783540,
      stop : 32789201,
      direction : "+",
      ID : "ENSG00000188133.6",
      gene_id : "ENSG00000188133.6",
      gene_type : "protein_coding",
      gene_name : "TMEM215",
      gene_level : 2,
      hgnc_id : "HGNC:33816",
      havana_gene : "OTTHUMG00000129521.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 32886601,
      stop : 33025130,
      direction : "-",
      ID : "ENSG00000137074.20",
      gene_id : "ENSG00000137074.20",
      gene_type : "protein_coding",
      gene_name : "APTX",
      gene_level : 1,
      hgnc_id : "HGNC:15984",
      havana_gene : "OTTHUMG00000019759.28",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33025273,
      stop : 33039907,
      direction : "+",
      ID : "ENSG00000086061.16",
      gene_id : "ENSG00000086061.16",
      gene_type : "protein_coding",
      gene_name : "DNAJA1",
      gene_level : 2,
      hgnc_id : "HGNC:5229",
      havana_gene : "OTTHUMG00000019760.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33041765,
      stop : 33076674,
      direction : "-",
      ID : "ENSG00000122692.9",
      gene_id : "ENSG00000122692.9",
      gene_type : "protein_coding",
      gene_name : "SMU1",
      gene_level : 2,
      hgnc_id : "HGNC:18247",
      havana_gene : "OTTHUMG00000019757.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33104082,
      stop : 33167356,
      direction : "-",
      ID : "ENSG00000086062.13",
      gene_id : "ENSG00000086062.13",
      gene_type : "protein_coding",
      gene_name : "B4GALT1",
      gene_level : 2,
      hgnc_id : "HGNC:924",
      havana_gene : "OTTHUMG00000019764.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33218365,
      stop : 33248567,
      direction : "+",
      ID : "ENSG00000122711.9",
      gene_id : "ENSG00000122711.9",
      gene_type : "protein_coding",
      gene_name : "SPINK4",
      gene_level : 2,
      hgnc_id : "HGNC:16646",
      havana_gene : "OTTHUMG00000019762.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33247820,
      stop : 33264720,
      direction : "-",
      ID : "ENSG00000107262.26",
      gene_id : "ENSG00000107262.26",
      gene_type : "protein_coding",
      gene_name : "BAG1",
      gene_level : 1,
      hgnc_id : "HGNC:937",
      havana_gene : "OTTHUMG00000019766.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33264879,
      stop : 33282070,
      direction : "+",
      ID : "ENSG00000086065.14",
      gene_id : "ENSG00000086065.14",
      gene_type : "protein_coding",
      gene_name : "CHMP5",
      gene_level : 2,
      hgnc_id : "HGNC:26942",
      havana_gene : "OTTHUMG00000019765.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33290512,
      stop : 33371157,
      direction : "+",
      ID : "ENSG00000086102.19",
      gene_id : "ENSG00000086102.19",
      gene_type : "protein_coding",
      gene_name : "NFX1",
      gene_level : 2,
      hgnc_id : "HGNC:7803",
      havana_gene : "OTTHUMG00000019772.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33383179,
      stop : 33402682,
      direction : "-",
      ID : "ENSG00000165269.13",
      gene_id : "ENSG00000165269.13",
      gene_type : "protein_coding",
      gene_name : "AQP7",
      gene_level : 2,
      hgnc_id : "HGNC:640",
      havana_gene : "OTTHUMG00000019773.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33441156,
      stop : 33447596,
      direction : "-",
      ID : "ENSG00000165272.16",
      gene_id : "ENSG00000165272.16",
      gene_type : "protein_coding",
      gene_name : "AQP3",
      gene_level : 2,
      hgnc_id : "HGNC:636",
      havana_gene : "OTTHUMG00000019769.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33461353,
      stop : 33473930,
      direction : "-",
      ID : "ENSG00000165271.17",
      gene_id : "ENSG00000165271.17",
      gene_type : "protein_coding",
      gene_name : "NOL6",
      gene_level : 2,
      hgnc_id : "HGNC:19910",
      havana_gene : "OTTHUMG00000000394.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33524394,
      stop : 33573009,
      direction : "+",
      ID : "ENSG00000230453.9",
      gene_id : "ENSG00000230453.9",
      gene_type : "protein_coding",
      gene_name : "ANKRD18B",
      gene_level : 2,
      hgnc_id : "HGNC:23644",
      havana_gene : "OTTHUMG00000019776.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33750679,
      stop : 33799231,
      direction : "+",
      ID : "ENSG00000010438.17",
      gene_id : "ENSG00000010438.17",
      gene_type : "protein_coding",
      gene_name : "PRSS3",
      gene_level : 2,
      hgnc_id : "HGNC:9486",
      havana_gene : "OTTHUMG00000019798.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33817160,
      stop : 33920399,
      direction : "+",
      ID : "ENSG00000107341.5",
      gene_id : "ENSG00000107341.5",
      gene_type : "protein_coding",
      gene_name : "UBE2R2",
      gene_level : 2,
      hgnc_id : "HGNC:19907",
      havana_gene : "OTTHUMG00000019797.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 33921693,
      stop : 34048949,
      direction : "-",
      ID : "ENSG00000137073.23",
      gene_id : "ENSG00000137073.23",
      gene_type : "protein_coding",
      gene_name : "UBAP2",
      gene_level : 2,
      hgnc_id : "HGNC:14185",
      havana_gene : "OTTHUMG00000000427.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34086387,
      stop : 34127399,
      direction : "-",
      ID : "ENSG00000198876.13",
      gene_id : "ENSG00000198876.13",
      gene_type : "protein_coding",
      gene_name : "DCAF12",
      gene_level : 2,
      hgnc_id : "HGNC:19911",
      havana_gene : "OTTHUMG00000019806.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34179005,
      stop : 34252523,
      direction : "+",
      ID : "ENSG00000165006.14",
      gene_id : "ENSG00000165006.14",
      gene_type : "protein_coding",
      gene_name : "UBAP1",
      gene_level : 2,
      hgnc_id : "HGNC:12461",
      havana_gene : "OTTHUMG00000000430.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34252381,
      stop : 34311371,
      direction : "-",
      ID : "ENSG00000186638.16",
      gene_id : "ENSG00000186638.16",
      gene_type : "protein_coding",
      gene_name : "KIF24",
      gene_level : 2,
      hgnc_id : "HGNC:19916",
      havana_gene : "OTTHUMG00000019810.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34329506,
      stop : 34343711,
      direction : "+",
      ID : "ENSG00000164978.18",
      gene_id : "ENSG00000164978.18",
      gene_type : "protein_coding",
      gene_name : "NUDT2",
      gene_level : 2,
      hgnc_id : "HGNC:8049",
      havana_gene : "OTTHUMG00000019817.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34366666,
      stop : 34376898,
      direction : "-",
      ID : "ENSG00000164976.9",
      gene_id : "ENSG00000164976.9",
      gene_type : "protein_coding",
      gene_name : "MYORG",
      gene_level : 2,
      hgnc_id : "HGNC:19918",
      havana_gene : "OTTHUMG00000019816.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34379019,
      stop : 34397810,
      direction : "-",
      ID : "ENSG00000164972.13",
      gene_id : "ENSG00000164972.13",
      gene_type : "protein_coding",
      gene_name : "C9orf24",
      gene_level : 2,
      hgnc_id : "HGNC:19919",
      havana_gene : "OTTHUMG00000000437.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34398184,
      stop : 34458570,
      direction : "-",
      ID : "ENSG00000164970.15",
      gene_id : "ENSG00000164970.15",
      gene_type : "protein_coding",
      gene_name : "FAM219A",
      gene_level : 2,
      hgnc_id : "HGNC:19920",
      havana_gene : "OTTHUMG00000019822.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34457414,
      stop : 34520988,
      direction : "+",
      ID : "ENSG00000122735.16",
      gene_id : "ENSG00000122735.16",
      gene_type : "protein_coding",
      gene_name : "DNAI1",
      gene_level : 2,
      hgnc_id : "HGNC:2954",
      havana_gene : "OTTHUMG00000019825.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34521043,
      stop : 34522990,
      direction : "-",
      ID : "ENSG00000168913.7",
      gene_id : "ENSG00000168913.7",
      gene_type : "protein_coding",
      gene_name : "ENHO",
      gene_level : 2,
      hgnc_id : "HGNC:24838",
      havana_gene : "OTTHUMG00000159589.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34551432,
      stop : 34590140,
      direction : "-",
      ID : "ENSG00000122756.15",
      gene_id : "ENSG00000122756.15",
      gene_type : "protein_coding",
      gene_name : "CNTFR",
      gene_level : 2,
      hgnc_id : "HGNC:2170",
      havana_gene : "OTTHUMG00000019821.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34610486,
      stop : 34612104,
      direction : "-",
      ID : "ENSG00000164967.10",
      gene_id : "ENSG00000164967.10",
      gene_type : "protein_coding",
      gene_name : "RPP25L",
      gene_level : 2,
      hgnc_id : "HGNC:19909",
      havana_gene : "OTTHUMG00000000443.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34613545,
      stop : 34620523,
      direction : "-",
      ID : "ENSG00000137100.16",
      gene_id : "ENSG00000137100.16",
      gene_type : "protein_coding",
      gene_name : "DCTN3",
      gene_level : 2,
      hgnc_id : "HGNC:2713",
      havana_gene : "OTTHUMG00000019830.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34621379,
      stop : 34628086,
      direction : "-",
      ID : "ENSG00000205143.3",
      gene_id : "ENSG00000205143.3",
      gene_type : "protein_coding",
      gene_name : "ARID3C",
      gene_level : 2,
      hgnc_id : "HGNC:21209",
      havana_gene : "OTTHUMG00000000445.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34634722,
      stop : 34637844,
      direction : "-",
      ID : "ENSG00000147955.18",
      gene_id : "ENSG00000147955.18",
      gene_type : "protein_coding",
      gene_name : "SIGMAR1",
      gene_level : 2,
      hgnc_id : "HGNC:8157",
      havana_gene : "OTTHUMG00000019829.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34638133,
      stop : 34651035,
      direction : "+",
      ID : "ENSG00000213930.12",
      gene_id : "ENSG00000213930.12",
      gene_type : "protein_coding",
      gene_name : "GALT",
      gene_level : 2,
      hgnc_id : "HGNC:4135",
      havana_gene : "OTTHUMG00000019836.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34646645,
      stop : 34657113,
      direction : "+",
      ID : "ENSG00000258728.1",
      gene_id : "ENSG00000258728.1",
      gene_type : "protein_coding",
      gene_name : "AL162231.3",
      gene_level : 1,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000170834.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34650702,
      stop : 34661902,
      direction : "+",
      ID : "ENSG00000137070.18",
      gene_id : "ENSG00000137070.18",
      gene_type : "protein_coding",
      gene_name : "IL11RA",
      gene_level : 1,
      hgnc_id : "HGNC:5967",
      havana_gene : "OTTHUMG00000019837.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34661880,
      stop : 34664048,
      direction : "-",
      ID : "ENSG00000213927.4",
      gene_id : "ENSG00000213927.4",
      gene_type : "protein_coding",
      gene_name : "CCL27",
      gene_level : 2,
      hgnc_id : "HGNC:10626",
      havana_gene : "OTTHUMG00000019834.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34664163,
      stop : 34666112,
      direction : "-",
      ID : "ENSG00000187186.15",
      gene_id : "ENSG00000187186.15",
      gene_type : "protein_coding",
      gene_name : "AL162231.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000000449.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34689570,
      stop : 34691276,
      direction : "-",
      ID : "ENSG00000172724.12",
      gene_id : "ENSG00000172724.12",
      gene_type : "protein_coding",
      gene_name : "CCL19",
      gene_level : 2,
      hgnc_id : "HGNC:10617",
      havana_gene : "OTTHUMG00000019833.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34709005,
      stop : 34710136,
      direction : "-",
      ID : "ENSG00000137077.8",
      gene_id : "ENSG00000137077.8",
      gene_type : "protein_coding",
      gene_name : "CCL21",
      gene_level : 2,
      hgnc_id : "HGNC:10620",
      havana_gene : "OTTHUMG00000019838.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34723053,
      stop : 34729488,
      direction : "-",
      ID : "ENSG00000205108.6",
      gene_id : "ENSG00000205108.6",
      gene_type : "protein_coding",
      gene_name : "FAM205A",
      gene_level : 2,
      hgnc_id : "HGNC:41911",
      havana_gene : "OTTHUMG00000000448.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34889066,
      stop : 34895764,
      direction : "-",
      ID : "ENSG00000187791.13",
      gene_id : "ENSG00000187791.13",
      gene_type : "protein_coding",
      gene_name : "FAM205C",
      gene_level : 1,
      hgnc_id : "HGNC:42673",
      havana_gene : "OTTHUMG00000019841.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34957608,
      stop : 34982544,
      direction : "+",
      ID : "ENSG00000122733.12",
      gene_id : "ENSG00000122733.12",
      gene_type : "protein_coding",
      gene_name : "PHF24",
      gene_level : 2,
      hgnc_id : "HGNC:29180",
      havana_gene : "OTTHUMG00000019844.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 34989641,
      stop : 34998900,
      direction : "+",
      ID : "ENSG00000137094.15",
      gene_id : "ENSG00000137094.15",
      gene_type : "protein_coding",
      gene_name : "DNAJB5",
      gene_level : 1,
      hgnc_id : "HGNC:14887",
      havana_gene : "OTTHUMG00000019840.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35041095,
      stop : 35045986,
      direction : "+",
      ID : "ENSG00000174038.13",
      gene_id : "ENSG00000174038.13",
      gene_type : "protein_coding",
      gene_name : "C9orf131",
      gene_level : 1,
      hgnc_id : "HGNC:31418",
      havana_gene : "OTTHUMG00000019853.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35053928,
      stop : 35072668,
      direction : "-",
      ID : "ENSG00000165280.18",
      gene_id : "ENSG00000165280.18",
      gene_type : "protein_coding",
      gene_name : "VCP",
      gene_level : 1,
      hgnc_id : "HGNC:12666",
      havana_gene : "OTTHUMG00000019855.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35065339,
      stop : 35074175,
      direction : "-",
      ID : "ENSG00000288699.1",
      gene_id : "ENSG00000288699.1",
      gene_type : "protein_coding",
      gene_name : "AL353795.4",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35073835,
      stop : 35079942,
      direction : "-",
      ID : "ENSG00000221829.10",
      gene_id : "ENSG00000221829.10",
      gene_type : "protein_coding",
      gene_name : "FANCG",
      gene_level : 2,
      hgnc_id : "HGNC:3588",
      havana_gene : "OTTHUMG00000019850.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35088688,
      stop : 35096601,
      direction : "-",
      ID : "ENSG00000165282.14",
      gene_id : "ENSG00000165282.14",
      gene_type : "protein_coding",
      gene_name : "PIGO",
      gene_level : 2,
      hgnc_id : "HGNC:23215",
      havana_gene : "OTTHUMG00000019854.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35099776,
      stop : 35103195,
      direction : "-",
      ID : "ENSG00000165283.16",
      gene_id : "ENSG00000165283.16",
      gene_type : "protein_coding",
      gene_name : "STOML2",
      gene_level : 2,
      hgnc_id : "HGNC:14559",
      havana_gene : "OTTHUMG00000019851.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35104112,
      stop : 35116341,
      direction : "-",
      ID : "ENSG00000005238.20",
      gene_id : "ENSG00000005238.20",
      gene_type : "protein_coding",
      gene_name : "FAM214B",
      gene_level : 2,
      hgnc_id : "HGNC:25666",
      havana_gene : "OTTHUMG00000019847.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35161992,
      stop : 35405338,
      direction : "+",
      ID : "ENSG00000198722.14",
      gene_id : "ENSG00000198722.14",
      gene_type : "protein_coding",
      gene_name : "UNC13B",
      gene_level : 2,
      hgnc_id : "HGNC:12566",
      havana_gene : "OTTHUMG00000019856.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35490111,
      stop : 35561898,
      direction : "+",
      ID : "ENSG00000198853.12",
      gene_id : "ENSG00000198853.12",
      gene_type : "protein_coding",
      gene_name : "RUSC2",
      gene_level : 2,
      hgnc_id : "HGNC:23625",
      havana_gene : "OTTHUMG00000019861.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35561831,
      stop : 35563899,
      direction : "-",
      ID : "ENSG00000215187.12",
      gene_id : "ENSG00000215187.12",
      gene_type : "protein_coding",
      gene_name : "FAM166B",
      gene_level : 2,
      hgnc_id : "HGNC:34242",
      havana_gene : "OTTHUMG00000019858.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35605262,
      stop : 35610041,
      direction : "+",
      ID : "ENSG00000107140.16",
      gene_id : "ENSG00000107140.16",
      gene_type : "protein_coding",
      gene_name : "TESK1",
      gene_level : 2,
      hgnc_id : "HGNC:11731",
      havana_gene : "OTTHUMG00000019863.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35609979,
      stop : 35646810,
      direction : "-",
      ID : "ENSG00000137101.13",
      gene_id : "ENSG00000137101.13",
      gene_type : "protein_coding",
      gene_name : "CD72",
      gene_level : 2,
      hgnc_id : "HGNC:1696",
      havana_gene : "OTTHUMG00000019870.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35649295,
      stop : 35650950,
      direction : "-",
      ID : "ENSG00000137078.9",
      gene_id : "ENSG00000137078.9",
      gene_type : "protein_coding",
      gene_name : "SIT1",
      gene_level : 2,
      hgnc_id : "HGNC:17710",
      havana_gene : "OTTHUMG00000019867.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35658290,
      stop : 35661511,
      direction : "+",
      ID : "ENSG00000159884.12",
      gene_id : "ENSG00000159884.12",
      gene_type : "protein_coding",
      gene_name : "CCDC107",
      gene_level : 2,
      hgnc_id : "HGNC:28465",
      havana_gene : "OTTHUMG00000019868.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35658875,
      stop : 35675866,
      direction : "-",
      ID : "ENSG00000137135.18",
      gene_id : "ENSG00000137135.18",
      gene_type : "protein_coding",
      gene_name : "ARHGEF39",
      gene_level : 2,
      hgnc_id : "HGNC:25909",
      havana_gene : "OTTHUMG00000019869.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35673918,
      stop : 35681159,
      direction : "+",
      ID : "ENSG00000107159.13",
      gene_id : "ENSG00000107159.13",
      gene_type : "protein_coding",
      gene_name : "CA9",
      gene_level : 2,
      hgnc_id : "HGNC:1383",
      havana_gene : "OTTHUMG00000021029.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35681992,
      stop : 35690056,
      direction : "-",
      ID : "ENSG00000198467.16",
      gene_id : "ENSG00000198467.16",
      gene_type : "protein_coding",
      gene_name : "TPM2",
      gene_level : 2,
      hgnc_id : "HGNC:12011",
      havana_gene : "OTTHUMG00000019878.10",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35696948,
      stop : 35732195,
      direction : "-",
      ID : "ENSG00000137076.21",
      gene_id : "ENSG00000137076.21",
      gene_type : "protein_coding",
      gene_name : "TLN1",
      gene_level : 2,
      hgnc_id : "HGNC:11845",
      havana_gene : "OTTHUMG00000019874.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35732598,
      stop : 35736999,
      direction : "+",
      ID : "ENSG00000107175.12",
      gene_id : "ENSG00000107175.12",
      gene_type : "protein_coding",
      gene_name : "CREB3",
      gene_level : 2,
      hgnc_id : "HGNC:2347",
      havana_gene : "OTTHUMG00000019872.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35736866,
      stop : 35749228,
      direction : "-",
      ID : "ENSG00000070610.14",
      gene_id : "ENSG00000070610.14",
      gene_type : "protein_coding",
      gene_name : "GBA2",
      gene_level : 2,
      hgnc_id : "HGNC:18986",
      havana_gene : "OTTHUMG00000021024.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35749287,
      stop : 35758585,
      direction : "+",
      ID : "ENSG00000107185.10",
      gene_id : "ENSG00000107185.10",
      gene_type : "protein_coding",
      gene_name : "RGP1",
      gene_level : 2,
      hgnc_id : "HGNC:21965",
      havana_gene : "OTTHUMG00000019873.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35752990,
      stop : 35756613,
      direction : "-",
      ID : "ENSG00000215183.5",
      gene_id : "ENSG00000215183.5",
      gene_type : "protein_coding",
      gene_name : "MSMP",
      gene_level : 1,
      hgnc_id : "HGNC:29663",
      havana_gene : "OTTHUMG00000019882.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35791591,
      stop : 35809732,
      direction : "+",
      ID : "ENSG00000159899.15",
      gene_id : "ENSG00000159899.15",
      gene_type : "protein_coding",
      gene_name : "NPR2",
      gene_level : 1,
      hgnc_id : "HGNC:7944",
      havana_gene : "OTTHUMG00000019871.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35808045,
      stop : 35812272,
      direction : "-",
      ID : "ENSG00000137098.14",
      gene_id : "ENSG00000137098.14",
      gene_type : "protein_coding",
      gene_name : "SPAG8",
      gene_level : 2,
      hgnc_id : "HGNC:14105",
      havana_gene : "OTTHUMG00000019875.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35812960,
      stop : 35815354,
      direction : "-",
      ID : "ENSG00000137133.11",
      gene_id : "ENSG00000137133.11",
      gene_type : "protein_coding",
      gene_name : "HINT2",
      gene_level : 2,
      hgnc_id : "HGNC:18344",
      havana_gene : "OTTHUMG00000019886.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35812960,
      stop : 35828732,
      direction : "-",
      ID : "ENSG00000285645.1",
      gene_id : "ENSG00000285645.1",
      gene_type : "protein_coding",
      gene_name : "AL133410.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193416.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35814451,
      stop : 35865518,
      direction : "+",
      ID : "ENSG00000137103.20",
      gene_id : "ENSG00000137103.20",
      gene_type : "protein_coding",
      gene_name : "TMEM8B",
      gene_level : 2,
      hgnc_id : "HGNC:21427",
      havana_gene : "OTTHUMG00000019885.10",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35816391,
      stop : 35828747,
      direction : "-",
      ID : "ENSG00000204930.10",
      gene_id : "ENSG00000204930.10",
      gene_type : "protein_coding",
      gene_name : "FAM221B",
      gene_level : 2,
      hgnc_id : "HGNC:30762",
      havana_gene : "OTTHUMG00000019880.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35869263,
      stop : 35870601,
      direction : "-",
      ID : "ENSG00000168828.5",
      gene_id : "ENSG00000168828.5",
      gene_type : "protein_coding",
      gene_name : "OR13J1",
      gene_level : 2,
      hgnc_id : "HGNC:15108",
      havana_gene : "OTTHUMG00000019879.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35906202,
      stop : 35907136,
      direction : "+",
      ID : "ENSG00000196196.3",
      gene_id : "ENSG00000196196.3",
      gene_type : "protein_coding",
      gene_name : "HRCT1",
      gene_level : 2,
      hgnc_id : "HGNC:33872",
      havana_gene : "OTTHUMG00000154146.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35909490,
      stop : 35937153,
      direction : "+",
      ID : "ENSG00000235387.5",
      gene_id : "ENSG00000235387.5",
      gene_type : "protein_coding",
      gene_name : "SPAAR",
      gene_level : 2,
      hgnc_id : "HGNC:27244",
      havana_gene : "OTTHUMG00000019887.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 35957108,
      stop : 35958154,
      direction : "-",
      ID : "ENSG00000278889.4",
      gene_id : "ENSG00000278889.4",
      gene_type : "protein_coding",
      gene_name : "OR2S2",
      gene_level : 2,
      hgnc_id : "HGNC:8276",
      havana_gene : "OTTHUMG00000019891.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36036913,
      stop : 36124455,
      direction : "+",
      ID : "ENSG00000122707.12",
      gene_id : "ENSG00000122707.12",
      gene_type : "protein_coding",
      gene_name : "RECK",
      gene_level : 2,
      hgnc_id : "HGNC:11345",
      havana_gene : "OTTHUMG00000019898.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36136536,
      stop : 36163913,
      direction : "+",
      ID : "ENSG00000122694.16",
      gene_id : "ENSG00000122694.16",
      gene_type : "protein_coding",
      gene_name : "GLIPR2",
      gene_level : 2,
      hgnc_id : "HGNC:18007",
      havana_gene : "OTTHUMG00000019900.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36169388,
      stop : 36171334,
      direction : "+",
      ID : "ENSG00000185972.6",
      gene_id : "ENSG00000185972.6",
      gene_type : "protein_coding",
      gene_name : "CCIN",
      gene_level : 2,
      hgnc_id : "HGNC:1568",
      havana_gene : "OTTHUMG00000019901.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36190856,
      stop : 36304781,
      direction : "+",
      ID : "ENSG00000122705.17",
      gene_id : "ENSG00000122705.17",
      gene_type : "protein_coding",
      gene_name : "CLTA",
      gene_level : 1,
      hgnc_id : "HGNC:2090",
      havana_gene : "OTTHUMG00000019896.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36214441,
      stop : 36277042,
      direction : "-",
      ID : "ENSG00000159921.20",
      gene_id : "ENSG00000159921.20",
      gene_type : "protein_coding",
      gene_name : "GNE",
      gene_level : 1,
      hgnc_id : "HGNC:23657",
      havana_gene : "OTTHUMG00000019899.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36336396,
      stop : 36487548,
      direction : "-",
      ID : "ENSG00000137075.18",
      gene_id : "ENSG00000137075.18",
      gene_type : "protein_coding",
      gene_name : "RNF38",
      gene_level : 2,
      hgnc_id : "HGNC:18052",
      havana_gene : "OTTHUMG00000019905.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36572862,
      stop : 36677683,
      direction : "+",
      ID : "ENSG00000165304.8",
      gene_id : "ENSG00000165304.8",
      gene_type : "protein_coding",
      gene_name : "MELK",
      gene_level : 2,
      hgnc_id : "HGNC:16870",
      havana_gene : "OTTHUMG00000019906.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 36833269,
      stop : 37034268,
      direction : "-",
      ID : "ENSG00000196092.14",
      gene_id : "ENSG00000196092.14",
      gene_type : "protein_coding",
      gene_name : "PAX5",
      gene_level : 2,
      hgnc_id : "HGNC:8619",
      havana_gene : "OTTHUMG00000019907.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37120574,
      stop : 37358149,
      direction : "+",
      ID : "ENSG00000147905.18",
      gene_id : "ENSG00000147905.18",
      gene_type : "protein_coding",
      gene_name : "ZCCHC7",
      gene_level : 2,
      hgnc_id : "HGNC:26209",
      havana_gene : "OTTHUMG00000019915.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37422666,
      stop : 37436990,
      direction : "+",
      ID : "ENSG00000137106.18",
      gene_id : "ENSG00000137106.18",
      gene_type : "protein_coding",
      gene_name : "GRHPR",
      gene_level : 2,
      hgnc_id : "HGNC:4570",
      havana_gene : "OTTHUMG00000019914.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37438102,
      stop : 37465450,
      direction : "-",
      ID : "ENSG00000168795.5",
      gene_id : "ENSG00000168795.5",
      gene_type : "protein_coding",
      gene_name : "ZBTB5",
      gene_level : 2,
      hgnc_id : "HGNC:23836",
      havana_gene : "OTTHUMG00000019918.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37485948,
      stop : 37503697,
      direction : "+",
      ID : "ENSG00000137054.16",
      gene_id : "ENSG00000137054.16",
      gene_type : "protein_coding",
      gene_name : "POLR1E",
      gene_level : 2,
      hgnc_id : "HGNC:17631",
      havana_gene : "OTTHUMG00000019920.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37510892,
      stop : 37576380,
      direction : "-",
      ID : "ENSG00000147912.13",
      gene_id : "ENSG00000147912.13",
      gene_type : "protein_coding",
      gene_name : "FBXO10",
      gene_level : 2,
      hgnc_id : "HGNC:13589",
      havana_gene : "OTTHUMG00000019926.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37512547,
      stop : 37592469,
      direction : "-",
      ID : "ENSG00000256966.6",
      gene_id : "ENSG00000256966.6",
      gene_type : "protein_coding",
      gene_name : "AL513165.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000168942.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37582646,
      stop : 37592604,
      direction : "-",
      ID : "ENSG00000175768.13",
      gene_id : "ENSG00000175768.13",
      gene_type : "protein_coding",
      gene_name : "TOMM5",
      gene_level : 2,
      hgnc_id : "HGNC:31369",
      havana_gene : "OTTHUMG00000019923.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37588413,
      stop : 38068687,
      direction : "-",
      ID : "ENSG00000255872.3",
      gene_id : "ENSG00000255872.3",
      gene_type : "protein_coding",
      gene_name : "AL138752.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000168975.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37650954,
      stop : 37746904,
      direction : "+",
      ID : "ENSG00000070601.10",
      gene_id : "ENSG00000070601.10",
      gene_type : "protein_coding",
      gene_name : "FRMPD1",
      gene_level : 2,
      hgnc_id : "HGNC:29159",
      havana_gene : "OTTHUMG00000019927.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37753803,
      stop : 37778972,
      direction : "+",
      ID : "ENSG00000165275.10",
      gene_id : "ENSG00000165275.10",
      gene_type : "protein_coding",
      gene_name : "TRMT10B",
      gene_level : 2,
      hgnc_id : "HGNC:26454",
      havana_gene : "OTTHUMG00000019933.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37759234,
      stop : 37832117,
      direction : "-",
      ID : "ENSG00000107371.14",
      gene_id : "ENSG00000107371.14",
      gene_type : "protein_coding",
      gene_name : "EXOSC3",
      gene_level : 2,
      hgnc_id : "HGNC:17944",
      havana_gene : "OTTHUMG00000019932.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37800554,
      stop : 37867666,
      direction : "+",
      ID : "ENSG00000122741.16",
      gene_id : "ENSG00000122741.16",
      gene_type : "protein_coding",
      gene_name : "DCAF10",
      gene_level : 2,
      hgnc_id : "HGNC:23686",
      havana_gene : "OTTHUMG00000019934.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37879400,
      stop : 37904353,
      direction : "-",
      ID : "ENSG00000122696.14",
      gene_id : "ENSG00000122696.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A51",
      gene_level : 2,
      hgnc_id : "HGNC:23323",
      havana_gene : "OTTHUMG00000019935.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 37915898,
      stop : 38069227,
      direction : "-",
      ID : "ENSG00000107338.10",
      gene_id : "ENSG00000107338.10",
      gene_type : "protein_coding",
      gene_name : "SHB",
      gene_level : 2,
      hgnc_id : "HGNC:10838",
      havana_gene : "OTTHUMG00000019936.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 38392702,
      stop : 38398661,
      direction : "+",
      ID : "ENSG00000137124.8",
      gene_id : "ENSG00000137124.8",
      gene_type : "protein_coding",
      gene_name : "ALDH1B1",
      gene_level : 2,
      hgnc_id : "HGNC:407",
      havana_gene : "OTTHUMG00000019938.5",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 38406528,
      stop : 38424454,
      direction : "-",
      ID : "ENSG00000137142.5",
      gene_id : "ENSG00000137142.5",
      gene_type : "protein_coding",
      gene_name : "IGFBPL1",
      gene_level : 2,
      hgnc_id : "HGNC:20081",
      havana_gene : "OTTHUMG00000019937.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 38540569,
      stop : 38577207,
      direction : "-",
      ID : "ENSG00000283486.2",
      gene_id : "ENSG00000283486.2",
      gene_type : "protein_coding",
      gene_name : "FAM95C",
      gene_level : 2,
      hgnc_id : "HGNC:45272",
      havana_gene : "OTTHUMG00000186324.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 38571358,
      stop : 38620596,
      direction : "-",
      ID : "ENSG00000180071.20",
      gene_id : "ENSG00000180071.20",
      gene_type : "protein_coding",
      gene_name : "ANKRD18A",
      gene_level : 2,
      hgnc_id : "HGNC:23643",
      havana_gene : "OTTHUMG00000186349.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 38694263,
      stop : 38720428,
      direction : "-",
      ID : "ENSG00000283329.1",
      gene_id : "ENSG00000283329.1",
      gene_type : "protein_coding",
      gene_name : "FAM240B",
      gene_level : 2,
      hgnc_id : "HGNC:53430",
      havana_gene : "OTTHUMG00000191736.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 39072767,
      stop : 39288315,
      direction : "-",
      ID : "ENSG00000106714.17",
      gene_id : "ENSG00000106714.17",
      gene_type : "protein_coding",
      gene_name : "CNTNAP3",
      gene_level : 2,
      hgnc_id : "HGNC:13834",
      havana_gene : "OTTHUMG00000019954.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 39355669,
      stop : 39361962,
      direction : "+",
      ID : "ENSG00000204849.10",
      gene_id : "ENSG00000204849.10",
      gene_type : "protein_coding",
      gene_name : "SPATA31A1",
      gene_level : 2,
      hgnc_id : "HGNC:23394",
      havana_gene : "OTTHUMG00000013156.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 40223285,
      stop : 40266845,
      direction : "+",
      ID : "ENSG00000183148.7",
      gene_id : "ENSG00000183148.7",
      gene_type : "protein_coding",
      gene_name : "ANKRD20A2P",
      gene_level : 2,
      hgnc_id : "HGNC:31979",
      havana_gene : "OTTHUMG00000058641.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 41126435,
      stop : 41128681,
      direction : "-",
      ID : "ENSG00000273514.2",
      gene_id : "ENSG00000273514.2",
      gene_type : "protein_coding",
      gene_name : "FOXD4L6",
      gene_level : 2,
      hgnc_id : "HGNC:31986",
      havana_gene : "OTTHUMG00000188618.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 41131306,
      stop : 41199261,
      direction : "-",
      ID : "ENSG00000215126.10",
      gene_id : "ENSG00000215126.10",
      gene_type : "protein_coding",
      gene_name : "CBWD6",
      gene_level : 2,
      hgnc_id : "HGNC:31978",
      havana_gene : "OTTHUMG00000067194.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 41890314,
      stop : 42129510,
      direction : "-",
      ID : "ENSG00000154529.15",
      gene_id : "ENSG00000154529.15",
      gene_type : "protein_coding",
      gene_name : "CNTNAP3B",
      gene_level : 2,
      hgnc_id : "HGNC:32035",
      havana_gene : "OTTHUMG00000013174.11",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 42183659,
      stop : 42189887,
      direction : "+",
      ID : "ENSG00000185775.10",
      gene_id : "ENSG00000185775.10",
      gene_type : "protein_coding",
      gene_name : "SPATA31A6",
      gene_level : 2,
      hgnc_id : "HGNC:32006",
      havana_gene : "OTTHUMG00000013224.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 60914407,
      stop : 60920653,
      direction : "+",
      ID : "ENSG00000276581.3",
      gene_id : "ENSG00000276581.3",
      gene_type : "protein_coding",
      gene_name : "SPATA31A5",
      gene_level : 2,
      hgnc_id : "HGNC:32005",
      havana_gene : "OTTHUMG00000188283.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 61190003,
      stop : 61196280,
      direction : "+",
      ID : "ENSG00000276040.4",
      gene_id : "ENSG00000276040.4",
      gene_type : "protein_coding",
      gene_name : "SPATA31A7",
      gene_level : 2,
      hgnc_id : "HGNC:32007",
      havana_gene : "OTTHUMG00000188536.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 61330717,
      stop : 61453030,
      direction : "+",
      ID : "ENSG00000283378.1",
      gene_id : "ENSG00000283378.1",
      gene_type : "protein_coding",
      gene_name : "CNTNAP3C",
      gene_level : 2,
      hgnc_id : "HGNC:53878",
      havana_gene : "OTTHUMG00000191808.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 64369394,
      stop : 64413142,
      direction : "+",
      ID : "ENSG00000172014.12",
      gene_id : "ENSG00000172014.12",
      gene_type : "protein_coding",
      gene_name : "ANKRD20A4P",
      gene_level : 2,
      hgnc_id : "HGNC:31982",
      havana_gene : "OTTHUMG00000066855.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 65282101,
      stop : 65285209,
      direction : "-",
      ID : "ENSG00000204779.2",
      gene_id : "ENSG00000204779.2",
      gene_type : "protein_coding",
      gene_name : "FOXD4L5",
      gene_level : 2,
      hgnc_id : "HGNC:18522",
      havana_gene : "OTTHUMG00000013332.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 65668805,
      stop : 65734041,
      direction : "+",
      ID : "ENSG00000147996.16",
      gene_id : "ENSG00000147996.16",
      gene_type : "protein_coding",
      gene_name : "CBWD5",
      gene_level : 2,
      hgnc_id : "HGNC:24584",
      havana_gene : "OTTHUMG00000013336.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 65736555,
      stop : 65738784,
      direction : "+",
      ID : "ENSG00000184659.5",
      gene_id : "ENSG00000184659.5",
      gene_type : "protein_coding",
      gene_name : "FOXD4L4",
      gene_level : 2,
      hgnc_id : "HGNC:23762",
      havana_gene : "OTTHUMG00000013337.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 66106815,
      stop : 66179474,
      direction : "-",
      ID : "ENSG00000276203.5",
      gene_id : "ENSG00000276203.5",
      gene_type : "protein_coding",
      gene_name : "ANKRD20A3P",
      gene_level : 2,
      hgnc_id : "HGNC:31981",
      havana_gene : "OTTHUMG00000188432.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 66856426,
      stop : 66932141,
      direction : "+",
      ID : "ENSG00000274349.4",
      gene_id : "ENSG00000274349.4",
      gene_type : "protein_coding",
      gene_name : "ZNF658",
      gene_level : 2,
      hgnc_id : "HGNC:25226",
      havana_gene : "OTTHUMG00000188361.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 66986304,
      stop : 66992583,
      direction : "-",
      ID : "ENSG00000275969.2",
      gene_id : "ENSG00000275969.2",
      gene_type : "protein_coding",
      gene_name : "SPATA31A3",
      gene_level : 2,
      hgnc_id : "HGNC:32003",
      havana_gene : "OTTHUMG00000188260.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 67832765,
      stop : 67920552,
      direction : "+",
      ID : "ENSG00000260691.6",
      gene_id : "ENSG00000260691.6",
      gene_type : "protein_coding",
      gene_name : "ANKRD20A1",
      gene_level : 2,
      hgnc_id : "HGNC:23665",
      havana_gene : "OTTHUMG00000188594.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 68232003,
      stop : 68300035,
      direction : "+",
      ID : "ENSG00000196873.16",
      gene_id : "ENSG00000196873.16",
      gene_type : "protein_coding",
      gene_name : "CBWD3",
      gene_level : 2,
      hgnc_id : "HGNC:18519",
      havana_gene : "OTTHUMG00000184383.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 68302867,
      stop : 68305084,
      direction : "+",
      ID : "ENSG00000187559.6",
      gene_id : "ENSG00000187559.6",
      gene_type : "protein_coding",
      gene_name : "FOXD4L3",
      gene_level : 2,
      hgnc_id : "HGNC:18523",
      havana_gene : "OTTHUMG00000019959.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 68328308,
      stop : 68531061,
      direction : "+",
      ID : "ENSG00000154330.13",
      gene_id : "ENSG00000154330.13",
      gene_type : "protein_coding",
      gene_name : "PGM5",
      gene_level : 1,
      hgnc_id : "HGNC:8908",
      havana_gene : "OTTHUMG00000019966.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 68536580,
      stop : 68540883,
      direction : "-",
      ID : "ENSG00000181778.5",
      gene_id : "ENSG00000181778.5",
      gene_type : "protein_coding",
      gene_name : "TMEM252",
      gene_level : 2,
      hgnc_id : "HGNC:28537",
      havana_gene : "OTTHUMG00000019967.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 68705240,
      stop : 69009176,
      direction : "+",
      ID : "ENSG00000107242.20",
      gene_id : "ENSG00000107242.20",
      gene_type : "protein_coding",
      gene_name : "PIP5K1B",
      gene_level : 2,
      hgnc_id : "HGNC:8995",
      havana_gene : "OTTHUMG00000019976.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 68780065,
      stop : 68785566,
      direction : "+",
      ID : "ENSG00000187866.10",
      gene_id : "ENSG00000187866.10",
      gene_type : "protein_coding",
      gene_name : "FAM122A",
      gene_level : 2,
      hgnc_id : "HGNC:23490",
      havana_gene : "OTTHUMG00000019971.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69012504,
      stop : 69014113,
      direction : "-",
      ID : "ENSG00000165059.8",
      gene_id : "ENSG00000165059.8",
      gene_type : "protein_coding",
      gene_name : "PRKACG",
      gene_level : 2,
      hgnc_id : "HGNC:9382",
      havana_gene : "OTTHUMG00000019974.2",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69035747,
      stop : 69255187,
      direction : "+",
      ID : "ENSG00000285130.2",
      gene_id : "ENSG00000285130.2",
      gene_type : "protein_coding",
      gene_name : "AL358113.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192581.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69035751,
      stop : 69079076,
      direction : "+",
      ID : "ENSG00000165060.15",
      gene_id : "ENSG00000165060.15",
      gene_type : "protein_coding",
      gene_name : "FXN",
      gene_level : 2,
      hgnc_id : "HGNC:3951",
      havana_gene : "OTTHUMG00000019977.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69121264,
      stop : 69274615,
      direction : "+",
      ID : "ENSG00000119139.21",
      gene_id : "ENSG00000119139.21",
      gene_type : "protein_coding",
      gene_name : "TJP2",
      gene_level : 2,
      hgnc_id : "HGNC:11828",
      havana_gene : "OTTHUMG00000019978.17",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69324567,
      stop : 69392558,
      direction : "+",
      ID : "ENSG00000135063.19",
      gene_id : "ENSG00000135063.19",
      gene_type : "protein_coding",
      gene_name : "FAM189A2",
      gene_level : 2,
      hgnc_id : "HGNC:24820",
      havana_gene : "OTTHUMG00000019979.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69427532,
      stop : 69672371,
      direction : "-",
      ID : "ENSG00000107282.8",
      gene_id : "ENSG00000107282.8",
      gene_type : "protein_coding",
      gene_name : "APBA1",
      gene_level : 2,
      hgnc_id : "HGNC:578",
      havana_gene : "OTTHUMG00000019984.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69709522,
      stop : 69760011,
      direction : "-",
      ID : "ENSG00000188647.13",
      gene_id : "ENSG00000188647.13",
      gene_type : "protein_coding",
      gene_name : "PTAR1",
      gene_level : 1,
      hgnc_id : "HGNC:30449",
      havana_gene : "OTTHUMG00000019982.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 69820817,
      stop : 69906227,
      direction : "+",
      ID : "ENSG00000204711.9",
      gene_id : "ENSG00000204711.9",
      gene_type : "protein_coding",
      gene_name : "C9orf135",
      gene_level : 1,
      hgnc_id : "HGNC:31422",
      havana_gene : "OTTHUMG00000019985.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 70043848,
      stop : 70226972,
      direction : "+",
      ID : "ENSG00000165072.10",
      gene_id : "ENSG00000165072.10",
      gene_type : "protein_coding",
      gene_name : "MAMDC2",
      gene_level : 2,
      hgnc_id : "HGNC:23673",
      havana_gene : "OTTHUMG00000019990.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 70258978,
      stop : 70354873,
      direction : "+",
      ID : "ENSG00000198887.9",
      gene_id : "ENSG00000198887.9",
      gene_type : "protein_coding",
      gene_name : "SMC5",
      gene_level : 2,
      hgnc_id : "HGNC:20465",
      havana_gene : "OTTHUMG00000019992.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 70384597,
      stop : 70414624,
      direction : "-",
      ID : "ENSG00000119138.4",
      gene_id : "ENSG00000119138.4",
      gene_type : "protein_coding",
      gene_name : "KLF9",
      gene_level : 2,
      hgnc_id : "HGNC:1123",
      havana_gene : "OTTHUMG00000019991.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 70529060,
      stop : 71446904,
      direction : "-",
      ID : "ENSG00000083067.24",
      gene_id : "ENSG00000083067.24",
      gene_type : "protein_coding",
      gene_name : "TRPM3",
      gene_level : 1,
      hgnc_id : "HGNC:17992",
      havana_gene : "OTTHUMG00000019997.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 71683366,
      stop : 71816690,
      direction : "-",
      ID : "ENSG00000135048.14",
      gene_id : "ENSG00000135048.14",
      gene_type : "protein_coding",
      gene_name : "CEMIP2",
      gene_level : 1,
      hgnc_id : "HGNC:11869",
      havana_gene : "OTTHUMG00000020000.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 71862452,
      stop : 71911193,
      direction : "-",
      ID : "ENSG00000107362.14",
      gene_id : "ENSG00000107362.14",
      gene_type : "protein_coding",
      gene_name : "ABHD17B",
      gene_level : 2,
      hgnc_id : "HGNC:24278",
      havana_gene : "OTTHUMG00000020001.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 71911510,
      stop : 71986054,
      direction : "+",
      ID : "ENSG00000155621.15",
      gene_id : "ENSG00000155621.15",
      gene_type : "protein_coding",
      gene_name : "C9orf85",
      gene_level : 2,
      hgnc_id : "HGNC:28784",
      havana_gene : "OTTHUMG00000020002.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 72051376,
      stop : 72072721,
      direction : "-",
      ID : "ENSG00000204669.11",
      gene_id : "ENSG00000204669.11",
      gene_type : "protein_coding",
      gene_name : "C9orf57",
      gene_level : 2,
      hgnc_id : "HGNC:27037",
      havana_gene : "OTTHUMG00000020003.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 72114595,
      stop : 72257193,
      direction : "+",
      ID : "ENSG00000119125.17",
      gene_id : "ENSG00000119125.17",
      gene_type : "protein_coding",
      gene_name : "GDA",
      gene_level : 2,
      hgnc_id : "HGNC:4212",
      havana_gene : "OTTHUMG00000020005.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 72351413,
      stop : 72365235,
      direction : "-",
      ID : "ENSG00000107372.13",
      gene_id : "ENSG00000107372.13",
      gene_type : "protein_coding",
      gene_name : "ZFAND5",
      gene_level : 2,
      hgnc_id : "HGNC:13008",
      havana_gene : "OTTHUMG00000020008.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 72521608,
      stop : 72838297,
      direction : "+",
      ID : "ENSG00000165091.18",
      gene_id : "ENSG00000165091.18",
      gene_type : "protein_coding",
      gene_name : "TMC1",
      gene_level : 2,
      hgnc_id : "HGNC:16513",
      havana_gene : "OTTHUMG00000020014.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 72900671,
      stop : 73080442,
      direction : "-",
      ID : "ENSG00000165092.13",
      gene_id : "ENSG00000165092.13",
      gene_type : "protein_coding",
      gene_name : "ALDH1A1",
      gene_level : 2,
      hgnc_id : "HGNC:402",
      havana_gene : "OTTHUMG00000020019.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 73151865,
      stop : 73170393,
      direction : "+",
      ID : "ENSG00000135046.14",
      gene_id : "ENSG00000135046.14",
      gene_type : "protein_coding",
      gene_name : "ANXA1",
      gene_level : 2,
      hgnc_id : "HGNC:533",
      havana_gene : "OTTHUMG00000020016.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 74497335,
      stop : 74693177,
      direction : "+",
      ID : "ENSG00000198963.11",
      gene_id : "ENSG00000198963.11",
      gene_type : "protein_coding",
      gene_name : "RORB",
      gene_level : 2,
      hgnc_id : "HGNC:10259",
      havana_gene : "OTTHUMG00000020026.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 74722495,
      stop : 74888094,
      direction : "-",
      ID : "ENSG00000119121.22",
      gene_id : "ENSG00000119121.22",
      gene_type : "protein_coding",
      gene_name : "TRPM6",
      gene_level : 2,
      hgnc_id : "HGNC:17995",
      havana_gene : "OTTHUMG00000020027.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 74946583,
      stop : 74952912,
      direction : "-",
      ID : "ENSG00000135045.7",
      gene_id : "ENSG00000135045.7",
      gene_type : "protein_coding",
      gene_name : "C9orf40",
      gene_level : 2,
      hgnc_id : "HGNC:23433",
      havana_gene : "OTTHUMG00000020031.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 74980790,
      stop : 75028423,
      direction : "-",
      ID : "ENSG00000156017.13",
      gene_id : "ENSG00000156017.13",
      gene_type : "protein_coding",
      gene_name : "CARNMT1",
      gene_level : 2,
      hgnc_id : "HGNC:23435",
      havana_gene : "OTTHUMG00000020032.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 75060573,
      stop : 75088217,
      direction : "-",
      ID : "ENSG00000106733.21",
      gene_id : "ENSG00000106733.21",
      gene_type : "protein_coding",
      gene_name : "NMRK1",
      gene_level : 2,
      hgnc_id : "HGNC:26057",
      havana_gene : "OTTHUMG00000020034.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 75088514,
      stop : 75147265,
      direction : "+",
      ID : "ENSG00000134996.12",
      gene_id : "ENSG00000134996.12",
      gene_type : "protein_coding",
      gene_name : "OSTF1",
      gene_level : 2,
      hgnc_id : "HGNC:8510",
      havana_gene : "OTTHUMG00000020033.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 75890644,
      stop : 76362975,
      direction : "+",
      ID : "ENSG00000099139.14",
      gene_id : "ENSG00000099139.14",
      gene_type : "protein_coding",
      gene_name : "PCSK5",
      gene_level : 1,
      hgnc_id : "HGNC:8747",
      havana_gene : "OTTHUMG00000020039.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 76385526,
      stop : 76394517,
      direction : "-",
      ID : "ENSG00000135002.12",
      gene_id : "ENSG00000135002.12",
      gene_type : "protein_coding",
      gene_name : "RFK",
      gene_level : 2,
      hgnc_id : "HGNC:30324",
      havana_gene : "OTTHUMG00000020040.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 76419850,
      stop : 76651203,
      direction : "+",
      ID : "ENSG00000187210.14",
      gene_id : "ENSG00000187210.14",
      gene_type : "protein_coding",
      gene_name : "GCNT1",
      gene_level : 2,
      hgnc_id : "HGNC:4203",
      havana_gene : "OTTHUMG00000020044.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 76611376,
      stop : 76906114,
      direction : "-",
      ID : "ENSG00000106772.18",
      gene_id : "ENSG00000106772.18",
      gene_type : "protein_coding",
      gene_name : "PRUNE2",
      gene_level : 2,
      hgnc_id : "HGNC:25209",
      havana_gene : "OTTHUMG00000020047.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 77019655,
      stop : 77020953,
      direction : "+",
      ID : "ENSG00000204612.1",
      gene_id : "ENSG00000204612.1",
      gene_type : "protein_coding",
      gene_name : "FOXB2",
      gene_level : 2,
      hgnc_id : "HGNC:23315",
      havana_gene : "OTTHUMG00000020051.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 77177445,
      stop : 77421537,
      direction : "+",
      ID : "ENSG00000197969.14",
      gene_id : "ENSG00000197969.14",
      gene_type : "protein_coding",
      gene_name : "VPS13A",
      gene_level : 1,
      hgnc_id : "HGNC:1908",
      havana_gene : "OTTHUMG00000020055.10",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 77423079,
      stop : 77648322,
      direction : "-",
      ID : "ENSG00000156049.7",
      gene_id : "ENSG00000156049.7",
      gene_type : "protein_coding",
      gene_name : "GNA14",
      gene_level : 2,
      hgnc_id : "HGNC:4382",
      havana_gene : "OTTHUMG00000020058.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 77716097,
      stop : 78031811,
      direction : "-",
      ID : "ENSG00000156052.11",
      gene_id : "ENSG00000156052.11",
      gene_type : "protein_coding",
      gene_name : "GNAQ",
      gene_level : 2,
      hgnc_id : "HGNC:4390",
      havana_gene : "OTTHUMG00000020059.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 78236062,
      stop : 78279690,
      direction : "+",
      ID : "ENSG00000148019.14",
      gene_id : "ENSG00000148019.14",
      gene_type : "protein_coding",
      gene_name : "CEP78",
      gene_level : 2,
      hgnc_id : "HGNC:25740",
      havana_gene : "OTTHUMG00000020062.14",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 78297125,
      stop : 78330093,
      direction : "+",
      ID : "ENSG00000135069.14",
      gene_id : "ENSG00000135069.14",
      gene_type : "protein_coding",
      gene_name : "PSAT1",
      gene_level : 2,
      hgnc_id : "HGNC:19129",
      havana_gene : "OTTHUMG00000020066.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 79571773,
      stop : 79726882,
      direction : "+",
      ID : "ENSG00000106829.20",
      gene_id : "ENSG00000106829.20",
      gene_type : "protein_coding",
      gene_name : "TLE4",
      gene_level : 1,
      hgnc_id : "HGNC:11840",
      havana_gene : "OTTHUMG00000020072.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 81583683,
      stop : 81689547,
      direction : "-",
      ID : "ENSG00000196781.16",
      gene_id : "ENSG00000196781.16",
      gene_type : "protein_coding",
      gene_name : "TLE1",
      gene_level : 2,
      hgnc_id : "HGNC:11837",
      havana_gene : "OTTHUMG00000021008.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 81928514,
      stop : 81934948,
      direction : "+",
      ID : "ENSG00000189357.8",
      gene_id : "ENSG00000189357.8",
      gene_type : "protein_coding",
      gene_name : "SPATA31D4",
      gene_level : 2,
      hgnc_id : "HGNC:38601",
      havana_gene : "OTTHUMG00000020088.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 81943586,
      stop : 81950038,
      direction : "+",
      ID : "ENSG00000186788.13",
      gene_id : "ENSG00000186788.13",
      gene_type : "protein_coding",
      gene_name : "SPATA31D3",
      gene_level : 2,
      hgnc_id : "HGNC:38603",
      havana_gene : "OTTHUMG00000020084.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 81988772,
      stop : 81995253,
      direction : "+",
      ID : "ENSG00000214929.4",
      gene_id : "ENSG00000214929.4",
      gene_type : "protein_coding",
      gene_name : "SPATA31D1",
      gene_level : 2,
      hgnc_id : "HGNC:37283",
      havana_gene : "OTTHUMG00000169122.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 82979590,
      stop : 83063177,
      direction : "-",
      ID : "ENSG00000165105.10",
      gene_id : "ENSG00000165105.10",
      gene_type : "protein_coding",
      gene_name : "RASEF",
      gene_level : 2,
      hgnc_id : "HGNC:26464",
      havana_gene : "OTTHUMG00000020100.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83242990,
      stop : 83538546,
      direction : "-",
      ID : "ENSG00000172159.16",
      gene_id : "ENSG00000172159.16",
      gene_type : "protein_coding",
      gene_name : "FRMD3",
      gene_level : 2,
      hgnc_id : "HGNC:24125",
      havana_gene : "OTTHUMG00000020103.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83623049,
      stop : 83644130,
      direction : "+",
      ID : "ENSG00000148057.16",
      gene_id : "ENSG00000148057.16",
      gene_type : "protein_coding",
      gene_name : "IDNK",
      gene_level : 1,
      hgnc_id : "HGNC:31367",
      havana_gene : "OTTHUMG00000020105.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83659968,
      stop : 83707958,
      direction : "-",
      ID : "ENSG00000135018.14",
      gene_id : "ENSG00000135018.14",
      gene_type : "protein_coding",
      gene_name : "UBQLN1",
      gene_level : 1,
      hgnc_id : "HGNC:12508",
      havana_gene : "OTTHUMG00000020104.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83739425,
      stop : 83829516,
      direction : "-",
      ID : "ENSG00000165113.13",
      gene_id : "ENSG00000165113.13",
      gene_type : "protein_coding",
      gene_name : "GKAP1",
      gene_level : 2,
      hgnc_id : "HGNC:17496",
      havana_gene : "OTTHUMG00000020106.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83834099,
      stop : 83921465,
      direction : "-",
      ID : "ENSG00000165115.15",
      gene_id : "ENSG00000165115.15",
      gene_type : "protein_coding",
      gene_name : "KIF27",
      gene_level : 2,
      hgnc_id : "HGNC:18632",
      havana_gene : "OTTHUMG00000020109.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83938311,
      stop : 83956986,
      direction : "-",
      ID : "ENSG00000165118.15",
      gene_id : "ENSG00000165118.15",
      gene_type : "protein_coding",
      gene_name : "C9orf64",
      gene_level : 2,
      hgnc_id : "HGNC:28144",
      havana_gene : "OTTHUMG00000020111.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83968083,
      stop : 83980616,
      direction : "-",
      ID : "ENSG00000165119.21",
      gene_id : "ENSG00000165119.21",
      gene_type : "protein_coding",
      gene_name : "HNRNPK",
      gene_level : 2,
      hgnc_id : "HGNC:5044",
      havana_gene : "OTTHUMG00000020107.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 83980798,
      stop : 84004074,
      direction : "+",
      ID : "ENSG00000178966.17",
      gene_id : "ENSG00000178966.17",
      gene_type : "protein_coding",
      gene_name : "RMI1",
      gene_level : 2,
      hgnc_id : "HGNC:25764",
      havana_gene : "OTTHUMG00000020113.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 84275457,
      stop : 84340758,
      direction : "-",
      ID : "ENSG00000197506.8",
      gene_id : "ENSG00000197506.8",
      gene_type : "protein_coding",
      gene_name : "SLC28A3",
      gene_level : 2,
      hgnc_id : "HGNC:16484",
      havana_gene : "OTTHUMG00000020117.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 84668551,
      stop : 85027054,
      direction : "+",
      ID : "ENSG00000148053.17",
      gene_id : "ENSG00000148053.17",
      gene_type : "protein_coding",
      gene_name : "NTRK2",
      gene_level : 2,
      hgnc_id : "HGNC:8032",
      havana_gene : "OTTHUMG00000020120.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 85546539,
      stop : 85742029,
      direction : "-",
      ID : "ENSG00000135049.16",
      gene_id : "ENSG00000135049.16",
      gene_type : "protein_coding",
      gene_name : "AGTPBP1",
      gene_level : 2,
      hgnc_id : "HGNC:17258",
      havana_gene : "OTTHUMG00000020124.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 85941146,
      stop : 86025462,
      direction : "+",
      ID : "ENSG00000135040.16",
      gene_id : "ENSG00000135040.16",
      gene_type : "protein_coding",
      gene_name : "NAA35",
      gene_level : 2,
      hgnc_id : "HGNC:24340",
      havana_gene : "OTTHUMG00000020131.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 86026146,
      stop : 86100173,
      direction : "-",
      ID : "ENSG00000135052.16",
      gene_id : "ENSG00000135052.16",
      gene_type : "protein_coding",
      gene_name : "GOLM1",
      gene_level : 2,
      hgnc_id : "HGNC:15451",
      havana_gene : "OTTHUMG00000020130.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 86220265,
      stop : 86259657,
      direction : "-",
      ID : "ENSG00000187753.13",
      gene_id : "ENSG00000187753.13",
      gene_type : "protein_coding",
      gene_name : "C9orf153",
      gene_level : 1,
      hgnc_id : "HGNC:31456",
      havana_gene : "OTTHUMG00000020134.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 86264546,
      stop : 86283102,
      direction : "-",
      ID : "ENSG00000135070.15",
      gene_id : "ENSG00000135070.15",
      gene_type : "protein_coding",
      gene_name : "ISCA1",
      gene_level : 2,
      hgnc_id : "HGNC:28660",
      havana_gene : "OTTHUMG00000020135.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 86287733,
      stop : 86354454,
      direction : "-",
      ID : "ENSG00000083223.18",
      gene_id : "ENSG00000083223.18",
      gene_type : "protein_coding",
      gene_name : "TUT7",
      gene_level : 2,
      hgnc_id : "HGNC:25817",
      havana_gene : "OTTHUMG00000020137.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 86944362,
      stop : 86947506,
      direction : "-",
      ID : "ENSG00000180447.7",
      gene_id : "ENSG00000180447.7",
      gene_type : "protein_coding",
      gene_name : "GAS1",
      gene_level : 2,
      hgnc_id : "HGNC:4165",
      havana_gene : "OTTHUMG00000020141.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 87497228,
      stop : 87708634,
      direction : "+",
      ID : "ENSG00000196730.13",
      gene_id : "ENSG00000196730.13",
      gene_type : "protein_coding",
      gene_name : "DAPK1",
      gene_level : 1,
      hgnc_id : "HGNC:2674",
      havana_gene : "OTTHUMG00000020150.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 87724051,
      stop : 87731469,
      direction : "+",
      ID : "ENSG00000135047.16",
      gene_id : "ENSG00000135047.16",
      gene_type : "protein_coding",
      gene_name : "CTSL",
      gene_level : 2,
      hgnc_id : "HGNC:2537",
      havana_gene : "OTTHUMG00000020149.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 87882877,
      stop : 87888903,
      direction : "+",
      ID : "ENSG00000177992.10",
      gene_id : "ENSG00000177992.10",
      gene_type : "protein_coding",
      gene_name : "SPATA31E1",
      gene_level : 2,
      hgnc_id : "HGNC:26672",
      havana_gene : "OTTHUMG00000020157.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 87956214,
      stop : 87956883,
      direction : "+",
      ID : "ENSG00000283205.1",
      gene_id : "ENSG00000283205.1",
      gene_type : "protein_coding",
      gene_name : "AL353572.3",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000191732.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 87966441,
      stop : 87974753,
      direction : "-",
      ID : "ENSG00000156345.18",
      gene_id : "ENSG00000156345.18",
      gene_type : "protein_coding",
      gene_name : "CDK20",
      gene_level : 1,
      hgnc_id : "HGNC:21420",
      havana_gene : "OTTHUMG00000020161.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 88388430,
      stop : 88478694,
      direction : "+",
      ID : "ENSG00000106723.17",
      gene_id : "ENSG00000106723.17",
      gene_type : "protein_coding",
      gene_name : "SPIN1",
      gene_level : 2,
      hgnc_id : "HGNC:11243",
      havana_gene : "OTTHUMG00000020168.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 88534033,
      stop : 88584274,
      direction : "+",
      ID : "ENSG00000130045.16",
      gene_id : "ENSG00000130045.16",
      gene_type : "protein_coding",
      gene_name : "NXNL2",
      gene_level : 2,
      hgnc_id : "HGNC:30482",
      havana_gene : "OTTHUMG00000020170.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 88990863,
      stop : 89005155,
      direction : "+",
      ID : "ENSG00000213694.6",
      gene_id : "ENSG00000213694.6",
      gene_type : "protein_coding",
      gene_name : "S1PR3",
      gene_level : 2,
      hgnc_id : "HGNC:3167",
      havana_gene : "OTTHUMG00000020173.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 89005771,
      stop : 89178818,
      direction : "-",
      ID : "ENSG00000148082.10",
      gene_id : "ENSG00000148082.10",
      gene_type : "protein_coding",
      gene_name : "SHC3",
      gene_level : 2,
      hgnc_id : "HGNC:18181",
      havana_gene : "OTTHUMG00000020179.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 89311195,
      stop : 89316703,
      direction : "+",
      ID : "ENSG00000123975.5",
      gene_id : "ENSG00000123975.5",
      gene_type : "protein_coding",
      gene_name : "CKS2",
      gene_level : 2,
      hgnc_id : "HGNC:2000",
      havana_gene : "OTTHUMG00000020180.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 89318500,
      stop : 89359663,
      direction : "+",
      ID : "ENSG00000187742.15",
      gene_id : "ENSG00000187742.15",
      gene_type : "protein_coding",
      gene_name : "SECISBP2",
      gene_level : 2,
      hgnc_id : "HGNC:30972",
      havana_gene : "OTTHUMG00000020182.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 89360787,
      stop : 89498130,
      direction : "-",
      ID : "ENSG00000187764.12",
      gene_id : "ENSG00000187764.12",
      gene_type : "protein_coding",
      gene_name : "SEMA4D",
      gene_level : 2,
      hgnc_id : "HGNC:10732",
      havana_gene : "OTTHUMG00000020185.10",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 89605012,
      stop : 89606555,
      direction : "+",
      ID : "ENSG00000130222.11",
      gene_id : "ENSG00000130222.11",
      gene_type : "protein_coding",
      gene_name : "GADD45G",
      gene_level : 2,
      hgnc_id : "HGNC:4097",
      havana_gene : "OTTHUMG00000020187.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 90609832,
      stop : 90642862,
      direction : "-",
      ID : "ENSG00000165023.7",
      gene_id : "ENSG00000165023.7",
      gene_type : "protein_coding",
      gene_name : "DIRAS2",
      gene_level : 2,
      hgnc_id : "HGNC:19323",
      havana_gene : "OTTHUMG00000020196.3",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 90801787,
      stop : 90898549,
      direction : "+",
      ID : "ENSG00000165025.15",
      gene_id : "ENSG00000165025.15",
      gene_type : "protein_coding",
      gene_name : "SYK",
      gene_level : 2,
      hgnc_id : "HGNC:11491",
      havana_gene : "OTTHUMG00000020200.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 91213815,
      stop : 91361918,
      direction : "-",
      ID : "ENSG00000148090.12",
      gene_id : "ENSG00000148090.12",
      gene_type : "protein_coding",
      gene_name : "AUH",
      gene_level : 2,
      hgnc_id : "HGNC:890",
      havana_gene : "OTTHUMG00000020207.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 91409045,
      stop : 91423832,
      direction : "-",
      ID : "ENSG00000165030.4",
      gene_id : "ENSG00000165030.4",
      gene_type : "protein_coding",
      gene_name : "NFIL3",
      gene_level : 2,
      hgnc_id : "HGNC:7787",
      havana_gene : "OTTHUMG00000020209.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 91563091,
      stop : 91950228,
      direction : "-",
      ID : "ENSG00000169071.15",
      gene_id : "ENSG00000169071.15",
      gene_type : "protein_coding",
      gene_name : "ROR2",
      gene_level : 2,
      hgnc_id : "HGNC:10257",
      havana_gene : "OTTHUMG00000020211.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92000087,
      stop : 92115413,
      direction : "-",
      ID : "ENSG00000090054.15",
      gene_id : "ENSG00000090054.15",
      gene_type : "protein_coding",
      gene_name : "SPTLC1",
      gene_level : 2,
      hgnc_id : "HGNC:11277",
      havana_gene : "OTTHUMG00000021047.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92210207,
      stop : 92293756,
      direction : "-",
      ID : "ENSG00000196305.18",
      gene_id : "ENSG00000196305.18",
      gene_type : "protein_coding",
      gene_name : "IARS1",
      gene_level : 1,
      hgnc_id : "HGNC:5330",
      havana_gene : "OTTHUMG00000020219.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92297358,
      stop : 92325636,
      direction : "-",
      ID : "ENSG00000198000.12",
      gene_id : "ENSG00000198000.12",
      gene_type : "protein_coding",
      gene_name : "NOL8",
      gene_level : 1,
      hgnc_id : "HGNC:23387",
      havana_gene : "OTTHUMG00000020221.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92325953,
      stop : 92620529,
      direction : "+",
      ID : "ENSG00000188312.14",
      gene_id : "ENSG00000188312.14",
      gene_type : "protein_coding",
      gene_name : "CENPP",
      gene_level : 2,
      hgnc_id : "HGNC:32933",
      havana_gene : "OTTHUMG00000020228.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92383268,
      stop : 92404696,
      direction : "-",
      ID : "ENSG00000106809.11",
      gene_id : "ENSG00000106809.11",
      gene_type : "protein_coding",
      gene_name : "OGN",
      gene_level : 2,
      hgnc_id : "HGNC:8126",
      havana_gene : "OTTHUMG00000020224.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92412380,
      stop : 92424471,
      direction : "-",
      ID : "ENSG00000127083.8",
      gene_id : "ENSG00000127083.8",
      gene_type : "protein_coding",
      gene_name : "OMD",
      gene_level : 2,
      hgnc_id : "HGNC:8134",
      havana_gene : "OTTHUMG00000020225.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92456205,
      stop : 92482506,
      direction : "-",
      ID : "ENSG00000106819.13",
      gene_id : "ENSG00000106819.13",
      gene_type : "protein_coding",
      gene_name : "ASPN",
      gene_level : 1,
      hgnc_id : "HGNC:14872",
      havana_gene : "OTTHUMG00000020227.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92493554,
      stop : 92536655,
      direction : "-",
      ID : "ENSG00000106823.12",
      gene_id : "ENSG00000106823.12",
      gene_type : "protein_coding",
      gene_name : "ECM2",
      gene_level : 2,
      hgnc_id : "HGNC:3154",
      havana_gene : "OTTHUMG00000020226.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92613183,
      stop : 92670131,
      direction : "-",
      ID : "ENSG00000127080.10",
      gene_id : "ENSG00000127080.10",
      gene_type : "protein_coding",
      gene_name : "IPPK",
      gene_level : 2,
      hgnc_id : "HGNC:14645",
      havana_gene : "OTTHUMG00000020231.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92711363,
      stop : 92764833,
      direction : "-",
      ID : "ENSG00000185963.14",
      gene_id : "ENSG00000185963.14",
      gene_type : "protein_coding",
      gene_name : "BICD2",
      gene_level : 2,
      hgnc_id : "HGNC:17208",
      havana_gene : "OTTHUMG00000021036.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92844182,
      stop : 92878038,
      direction : "-",
      ID : "ENSG00000127081.14",
      gene_id : "ENSG00000127081.14",
      gene_type : "protein_coding",
      gene_name : "ZNF484",
      gene_level : 2,
      hgnc_id : "HGNC:23385",
      havana_gene : "OTTHUMG00000020236.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 92947523,
      stop : 93036236,
      direction : "+",
      ID : "ENSG00000127084.19",
      gene_id : "ENSG00000127084.19",
      gene_type : "protein_coding",
      gene_name : "FGD3",
      gene_level : 2,
      hgnc_id : "HGNC:16027",
      havana_gene : "OTTHUMG00000021032.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93058688,
      stop : 93085133,
      direction : "+",
      ID : "ENSG00000157303.11",
      gene_id : "ENSG00000157303.11",
      gene_type : "protein_coding",
      gene_name : "SUSD3",
      gene_level : 2,
      hgnc_id : "HGNC:28391",
      havana_gene : "OTTHUMG00000020241.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93096217,
      stop : 93113283,
      direction : "+",
      ID : "ENSG00000165233.18",
      gene_id : "ENSG00000165233.18",
      gene_type : "protein_coding",
      gene_name : "CARD19",
      gene_level : 2,
      hgnc_id : "HGNC:28148",
      havana_gene : "OTTHUMG00000020243.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93121496,
      stop : 93134251,
      direction : "-",
      ID : "ENSG00000131669.10",
      gene_id : "ENSG00000131669.10",
      gene_type : "protein_coding",
      gene_name : "NINJ1",
      gene_level : 2,
      hgnc_id : "HGNC:7824",
      havana_gene : "OTTHUMG00000020242.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93184916,
      stop : 93320572,
      direction : "+",
      ID : "ENSG00000165238.16",
      gene_id : "ENSG00000165238.16",
      gene_type : "protein_coding",
      gene_name : "WNK2",
      gene_level : 1,
      hgnc_id : "HGNC:14542",
      havana_gene : "OTTHUMG00000020247.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93431441,
      stop : 93453581,
      direction : "-",
      ID : "ENSG00000188938.17",
      gene_id : "ENSG00000188938.17",
      gene_type : "protein_coding",
      gene_name : "FAM120AOS",
      gene_level : 2,
      hgnc_id : "HGNC:23389",
      havana_gene : "OTTHUMG00000020251.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93451685,
      stop : 93566112,
      direction : "+",
      ID : "ENSG00000048828.17",
      gene_id : "ENSG00000048828.17",
      gene_type : "protein_coding",
      gene_name : "FAM120A",
      gene_level : 2,
      hgnc_id : "HGNC:13247",
      havana_gene : "OTTHUMG00000020252.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93576584,
      stop : 93679587,
      direction : "+",
      ID : "ENSG00000197724.11",
      gene_id : "ENSG00000197724.11",
      gene_type : "protein_coding",
      gene_name : "PHF2",
      gene_level : 2,
      hgnc_id : "HGNC:8920",
      havana_gene : "OTTHUMG00000020253.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 93951627,
      stop : 93955355,
      direction : "-",
      ID : "ENSG00000131668.14",
      gene_id : "ENSG00000131668.14",
      gene_type : "protein_coding",
      gene_name : "BARX1",
      gene_level : 2,
      hgnc_id : "HGNC:955",
      havana_gene : "OTTHUMG00000020255.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94030794,
      stop : 94109856,
      direction : "+",
      ID : "ENSG00000158079.16",
      gene_id : "ENSG00000158079.16",
      gene_type : "protein_coding",
      gene_name : "PTPDC1",
      gene_level : 1,
      hgnc_id : "HGNC:30184",
      havana_gene : "OTTHUMG00000020258.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94259298,
      stop : 94301829,
      direction : "+",
      ID : "ENSG00000175787.17",
      gene_id : "ENSG00000175787.17",
      gene_type : "protein_coding",
      gene_name : "ZNF169",
      gene_level : 2,
      hgnc_id : "HGNC:12957",
      havana_gene : "OTTHUMG00000020264.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94318196,
      stop : 94328644,
      direction : "-",
      ID : "ENSG00000130950.14",
      gene_id : "ENSG00000130950.14",
      gene_type : "protein_coding",
      gene_name : "NUTM2F",
      gene_level : 2,
      hgnc_id : "HGNC:23450",
      havana_gene : "OTTHUMG00000020260.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94374569,
      stop : 94461042,
      direction : "+",
      ID : "ENSG00000148110.16",
      gene_id : "ENSG00000148110.16",
      gene_type : "protein_coding",
      gene_name : "MFSD14B",
      gene_level : 2,
      hgnc_id : "HGNC:23376",
      havana_gene : "OTTHUMG00000020265.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94558720,
      stop : 94593824,
      direction : "-",
      ID : "ENSG00000130957.5",
      gene_id : "ENSG00000130957.5",
      gene_type : "protein_coding",
      gene_name : "FBP2",
      gene_level : 2,
      hgnc_id : "HGNC:3607",
      havana_gene : "OTTHUMG00000020269.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94603133,
      stop : 94640249,
      direction : "-",
      ID : "ENSG00000165140.11",
      gene_id : "ENSG00000165140.11",
      gene_type : "protein_coding",
      gene_name : "FBP1",
      gene_level : 2,
      hgnc_id : "HGNC:3606",
      havana_gene : "OTTHUMG00000020268.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 94726604,
      stop : 95087159,
      direction : "+",
      ID : "ENSG00000148120.17",
      gene_id : "ENSG00000148120.17",
      gene_type : "protein_coding",
      gene_name : "AOPEP",
      gene_level : 2,
      hgnc_id : "HGNC:1361",
      havana_gene : "OTTHUMG00000020276.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 95099054,
      stop : 95426796,
      direction : "-",
      ID : "ENSG00000158169.13",
      gene_id : "ENSG00000158169.13",
      gene_type : "protein_coding",
      gene_name : "FANCC",
      gene_level : 2,
      hgnc_id : "HGNC:3584",
      havana_gene : "OTTHUMG00000020279.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 95442980,
      stop : 95517057,
      direction : "-",
      ID : "ENSG00000185920.16",
      gene_id : "ENSG00000185920.16",
      gene_type : "protein_coding",
      gene_name : "PTCH1",
      gene_level : 1,
      hgnc_id : "HGNC:9585",
      havana_gene : "OTTHUMG00000020280.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 95871264,
      stop : 96121154,
      direction : "+",
      ID : "ENSG00000182150.18",
      gene_id : "ENSG00000182150.18",
      gene_type : "protein_coding",
      gene_name : "ERCC6L2",
      gene_level : 1,
      hgnc_id : "HGNC:26922",
      havana_gene : "OTTHUMG00000020289.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96235306,
      stop : 96302176,
      direction : "-",
      ID : "ENSG00000130948.10",
      gene_id : "ENSG00000130948.10",
      gene_type : "protein_coding",
      gene_name : "HSD17B3",
      gene_level : 2,
      hgnc_id : "HGNC:5212",
      havana_gene : "OTTHUMG00000020292.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96235331,
      stop : 96352058,
      direction : "-",
      ID : "ENSG00000285269.2",
      gene_id : "ENSG00000285269.2",
      gene_type : "protein_coding",
      gene_name : "AL160269.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192521.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96313444,
      stop : 96383711,
      direction : "-",
      ID : "ENSG00000130958.13",
      gene_id : "ENSG00000130958.13",
      gene_type : "protein_coding",
      gene_name : "SLC35D2",
      gene_level : 2,
      hgnc_id : "HGNC:20799",
      havana_gene : "OTTHUMG00000020293.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96385941,
      stop : 96418370,
      direction : "-",
      ID : "ENSG00000165244.7",
      gene_id : "ENSG00000165244.7",
      gene_type : "protein_coding",
      gene_name : "ZNF367",
      gene_level : 2,
      hgnc_id : "HGNC:18320",
      havana_gene : "OTTHUMG00000020295.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96450169,
      stop : 96491336,
      direction : "+",
      ID : "ENSG00000130956.14",
      gene_id : "ENSG00000130956.14",
      gene_type : "protein_coding",
      gene_name : "HABP4",
      gene_level : 2,
      hgnc_id : "HGNC:17062",
      havana_gene : "OTTHUMG00000020298.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96490241,
      stop : 96619843,
      direction : "-",
      ID : "ENSG00000081377.17",
      gene_id : "ENSG00000081377.17",
      gene_type : "protein_coding",
      gene_name : "CDC14B",
      gene_level : 2,
      hgnc_id : "HGNC:1719",
      havana_gene : "OTTHUMG00000020300.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96639577,
      stop : 96655317,
      direction : "-",
      ID : "ENSG00000158122.12",
      gene_id : "ENSG00000158122.12",
      gene_type : "protein_coding",
      gene_name : "PRXL2C",
      gene_level : 2,
      hgnc_id : "HGNC:16881",
      havana_gene : "OTTHUMG00000020299.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96754553,
      stop : 96778129,
      direction : "-",
      ID : "ENSG00000081386.13",
      gene_id : "ENSG00000081386.13",
      gene_type : "protein_coding",
      gene_name : "ZNF510",
      gene_level : 2,
      hgnc_id : "HGNC:29161",
      havana_gene : "OTTHUMG00000020303.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96816269,
      stop : 96875623,
      direction : "-",
      ID : "ENSG00000196597.13",
      gene_id : "ENSG00000196597.13",
      gene_type : "protein_coding",
      gene_name : "ZNF782",
      gene_level : 2,
      hgnc_id : "HGNC:33110",
      havana_gene : "OTTHUMG00000020310.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 96928310,
      stop : 96940253,
      direction : "+",
      ID : "ENSG00000188152.13",
      gene_id : "ENSG00000188152.13",
      gene_type : "protein_coding",
      gene_name : "NUTM2G",
      gene_level : 2,
      hgnc_id : "HGNC:23449",
      havana_gene : "OTTHUMG00000020305.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97029677,
      stop : 97156556,
      direction : "-",
      ID : "ENSG00000136943.12",
      gene_id : "ENSG00000136943.12",
      gene_type : "protein_coding",
      gene_name : "CTSV",
      gene_level : 2,
      hgnc_id : "HGNC:2538",
      havana_gene : "OTTHUMG00000020314.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97307304,
      stop : 97378751,
      direction : "+",
      ID : "ENSG00000197816.16",
      gene_id : "ENSG00000197816.16",
      gene_type : "protein_coding",
      gene_name : "CCDC180",
      gene_level : 2,
      hgnc_id : "HGNC:29303",
      havana_gene : "OTTHUMG00000167001.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97412096,
      stop : 97496125,
      direction : "+",
      ID : "ENSG00000196116.8",
      gene_id : "ENSG00000196116.8",
      gene_type : "protein_coding",
      gene_name : "TDRD7",
      gene_level : 2,
      hgnc_id : "HGNC:30831",
      havana_gene : "OTTHUMG00000020326.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97501180,
      stop : 97601743,
      direction : "+",
      ID : "ENSG00000136842.14",
      gene_id : "ENSG00000136842.14",
      gene_type : "protein_coding",
      gene_name : "TMOD1",
      gene_level : 1,
      hgnc_id : "HGNC:11871",
      havana_gene : "OTTHUMG00000020325.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97600080,
      stop : 97633368,
      direction : "-",
      ID : "ENSG00000136925.15",
      gene_id : "ENSG00000136925.15",
      gene_type : "protein_coding",
      gene_name : "TSTD2",
      gene_level : 2,
      hgnc_id : "HGNC:30087",
      havana_gene : "OTTHUMG00000020328.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97633668,
      stop : 97673748,
      direction : "+",
      ID : "ENSG00000136937.13",
      gene_id : "ENSG00000136937.13",
      gene_type : "protein_coding",
      gene_name : "NCBP1",
      gene_level : 2,
      hgnc_id : "HGNC:7658",
      havana_gene : "OTTHUMG00000020332.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97674909,
      stop : 97697340,
      direction : "-",
      ID : "ENSG00000136936.11",
      gene_id : "ENSG00000136936.11",
      gene_type : "protein_coding",
      gene_name : "XPA",
      gene_level : 2,
      hgnc_id : "HGNC:12814",
      havana_gene : "OTTHUMG00000020330.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97853226,
      stop : 97856717,
      direction : "+",
      ID : "ENSG00000178919.9",
      gene_id : "ENSG00000178919.9",
      gene_type : "protein_coding",
      gene_name : "FOXE1",
      gene_level : 2,
      hgnc_id : "HGNC:3806",
      havana_gene : "OTTHUMG00000020333.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97904489,
      stop : 97922516,
      direction : "-",
      ID : "ENSG00000136932.14",
      gene_id : "ENSG00000136932.14",
      gene_type : "protein_coding",
      gene_name : "TRMO",
      gene_level : 2,
      hgnc_id : "HGNC:30967",
      havana_gene : "OTTHUMG00000021007.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97926791,
      stop : 97944856,
      direction : "-",
      ID : "ENSG00000136929.13",
      gene_id : "ENSG00000136929.13",
      gene_type : "protein_coding",
      gene_name : "HEMGN",
      gene_level : 2,
      hgnc_id : "HGNC:17509",
      havana_gene : "OTTHUMG00000020336.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 97983341,
      stop : 98015943,
      direction : "+",
      ID : "ENSG00000136938.9",
      gene_id : "ENSG00000136938.9",
      gene_type : "protein_coding",
      gene_name : "ANP32B",
      gene_level : 2,
      hgnc_id : "HGNC:16677",
      havana_gene : "OTTHUMG00000020338.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98056732,
      stop : 98083077,
      direction : "+",
      ID : "ENSG00000095380.11",
      gene_id : "ENSG00000095380.11",
      gene_type : "protein_coding",
      gene_name : "NANS",
      gene_level : 2,
      hgnc_id : "HGNC:19237",
      havana_gene : "OTTHUMG00000020341.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98069275,
      stop : 98119222,
      direction : "-",
      ID : "ENSG00000106785.15",
      gene_id : "ENSG00000106785.15",
      gene_type : "protein_coding",
      gene_name : "TRIM14",
      gene_level : 2,
      hgnc_id : "HGNC:16283",
      havana_gene : "OTTHUMG00000020339.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98120975,
      stop : 98192637,
      direction : "-",
      ID : "ENSG00000106789.13",
      gene_id : "ENSG00000106789.13",
      gene_type : "protein_coding",
      gene_name : "CORO2A",
      gene_level : 2,
      hgnc_id : "HGNC:2255",
      havana_gene : "OTTHUMG00000020340.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98199011,
      stop : 98255649,
      direction : "-",
      ID : "ENSG00000095383.20",
      gene_id : "ENSG00000095383.20",
      gene_type : "protein_coding",
      gene_name : "TBC1D2",
      gene_level : 2,
      hgnc_id : "HGNC:18026",
      havana_gene : "OTTHUMG00000020343.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98288109,
      stop : 98708935,
      direction : "-",
      ID : "ENSG00000136928.7",
      gene_id : "ENSG00000136928.7",
      gene_type : "protein_coding",
      gene_name : "GABBR2",
      gene_level : 2,
      hgnc_id : "HGNC:4507",
      havana_gene : "OTTHUMG00000020345.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98731329,
      stop : 98796965,
      direction : "-",
      ID : "ENSG00000165138.18",
      gene_id : "ENSG00000165138.18",
      gene_type : "protein_coding",
      gene_name : "ANKS6",
      gene_level : 1,
      hgnc_id : "HGNC:26724",
      havana_gene : "OTTHUMG00000020347.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98807670,
      stop : 98850081,
      direction : "+",
      ID : "ENSG00000119514.7",
      gene_id : "ENSG00000119514.7",
      gene_type : "protein_coding",
      gene_name : "GALNT12",
      gene_level : 2,
      hgnc_id : "HGNC:19877",
      havana_gene : "OTTHUMG00000020348.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 98943179,
      stop : 99070792,
      direction : "+",
      ID : "ENSG00000204291.11",
      gene_id : "ENSG00000204291.11",
      gene_type : "protein_coding",
      gene_name : "COL15A1",
      gene_level : 2,
      hgnc_id : "HGNC:2192",
      havana_gene : "OTTHUMG00000020351.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 99104038,
      stop : 99154192,
      direction : "+",
      ID : "ENSG00000106799.13",
      gene_id : "ENSG00000106799.13",
      gene_type : "protein_coding",
      gene_name : "TGFBR1",
      gene_level : 2,
      hgnc_id : "HGNC:11772",
      havana_gene : "OTTHUMG00000020353.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 99216425,
      stop : 99221942,
      direction : "-",
      ID : "ENSG00000119523.10",
      gene_id : "ENSG00000119523.10",
      gene_type : "protein_coding",
      gene_name : "ALG2",
      gene_level : 2,
      hgnc_id : "HGNC:23159",
      havana_gene : "OTTHUMG00000020355.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 99222064,
      stop : 99230615,
      direction : "+",
      ID : "ENSG00000106803.10",
      gene_id : "ENSG00000106803.10",
      gene_type : "protein_coding",
      gene_name : "SEC61B",
      gene_level : 2,
      hgnc_id : "HGNC:16993",
      havana_gene : "OTTHUMG00000020354.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 99821855,
      stop : 99866891,
      direction : "+",
      ID : "ENSG00000119508.18",
      gene_id : "ENSG00000119508.18",
      gene_type : "protein_coding",
      gene_name : "NR4A3",
      gene_level : 2,
      hgnc_id : "HGNC:7982",
      havana_gene : "OTTHUMG00000021030.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 99906654,
      stop : 99974534,
      direction : "+",
      ID : "ENSG00000136874.11",
      gene_id : "ENSG00000136874.11",
      gene_type : "protein_coding",
      gene_name : "STX17",
      gene_level : 1,
      hgnc_id : "HGNC:11432",
      havana_gene : "OTTHUMG00000020359.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 99979185,
      stop : 100099000,
      direction : "-",
      ID : "ENSG00000023318.8",
      gene_id : "ENSG00000023318.8",
      gene_type : "protein_coding",
      gene_name : "ERP44",
      gene_level : 2,
      hgnc_id : "HGNC:18311",
      havana_gene : "OTTHUMG00000020363.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 100099243,
      stop : 100302175,
      direction : "+",
      ID : "ENSG00000119509.13",
      gene_id : "ENSG00000119509.13",
      gene_type : "protein_coding",
      gene_name : "INVS",
      gene_level : 2,
      hgnc_id : "HGNC:17870",
      havana_gene : "OTTHUMG00000020364.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 100302077,
      stop : 100352942,
      direction : "-",
      ID : "ENSG00000136891.14",
      gene_id : "ENSG00000136891.14",
      gene_type : "protein_coding",
      gene_name : "TEX10",
      gene_level : 2,
      hgnc_id : "HGNC:25988",
      havana_gene : "OTTHUMG00000020366.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 100427143,
      stop : 100451734,
      direction : "+",
      ID : "ENSG00000066697.15",
      gene_id : "ENSG00000066697.15",
      gene_type : "protein_coding",
      gene_name : "MSANTD3",
      gene_level : 2,
      hgnc_id : "HGNC:23370",
      havana_gene : "OTTHUMG00000020365.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 100442271,
      stop : 100577636,
      direction : "+",
      ID : "ENSG00000251349.3",
      gene_id : "ENSG00000251349.3",
      gene_type : "protein_coding",
      gene_name : "MSANTD3-TMEFF1",
      gene_level : 2,
      hgnc_id : "HGNC:38838",
      havana_gene : "OTTHUMG00000161540.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 100473149,
      stop : 100577636,
      direction : "+",
      ID : "ENSG00000241697.5",
      gene_id : "ENSG00000241697.5",
      gene_type : "protein_coding",
      gene_name : "TMEFF1",
      gene_level : 2,
      hgnc_id : "HGNC:11866",
      havana_gene : "OTTHUMG00000020367.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 100578079,
      stop : 100588389,
      direction : "+",
      ID : "ENSG00000170681.7",
      gene_id : "ENSG00000170681.7",
      gene_type : "protein_coding",
      gene_name : "CAVIN4",
      gene_level : 2,
      hgnc_id : "HGNC:33742",
      havana_gene : "OTTHUMG00000020368.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101028727,
      stop : 101325135,
      direction : "+",
      ID : "ENSG00000148123.15",
      gene_id : "ENSG00000148123.15",
      gene_type : "protein_coding",
      gene_name : "PLPPR1",
      gene_level : 2,
      hgnc_id : "HGNC:25993",
      havana_gene : "OTTHUMG00000020373.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101354182,
      stop : 101385400,
      direction : "-",
      ID : "ENSG00000136881.12",
      gene_id : "ENSG00000136881.12",
      gene_type : "protein_coding",
      gene_name : "BAAT",
      gene_level : 2,
      hgnc_id : "HGNC:932",
      havana_gene : "OTTHUMG00000020377.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101387633,
      stop : 101398618,
      direction : "-",
      ID : "ENSG00000136897.8",
      gene_id : "ENSG00000136897.8",
      gene_type : "protein_coding",
      gene_name : "MRPL50",
      gene_level : 2,
      hgnc_id : "HGNC:16654",
      havana_gene : "OTTHUMG00000020384.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101398873,
      stop : 101410660,
      direction : "+",
      ID : "ENSG00000136870.10",
      gene_id : "ENSG00000136870.10",
      gene_type : "protein_coding",
      gene_name : "ZNF189",
      gene_level : 2,
      hgnc_id : "HGNC:12980",
      havana_gene : "OTTHUMG00000020383.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101420560,
      stop : 101449664,
      direction : "-",
      ID : "ENSG00000136872.20",
      gene_id : "ENSG00000136872.20",
      gene_type : "protein_coding",
      gene_name : "ALDOB",
      gene_level : 2,
      hgnc_id : "HGNC:417",
      havana_gene : "OTTHUMG00000020378.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101473170,
      stop : 101533537,
      direction : "-",
      ID : "ENSG00000165152.9",
      gene_id : "ENSG00000165152.9",
      gene_type : "protein_coding",
      gene_name : "PGAP4",
      gene_level : 2,
      hgnc_id : "HGNC:28180",
      havana_gene : "OTTHUMG00000020381.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101533853,
      stop : 101563344,
      direction : "+",
      ID : "ENSG00000155827.12",
      gene_id : "ENSG00000155827.12",
      gene_type : "protein_coding",
      gene_name : "RNF20",
      gene_level : 2,
      hgnc_id : "HGNC:10062",
      havana_gene : "OTTHUMG00000020385.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101569352,
      stop : 101738647,
      direction : "-",
      ID : "ENSG00000198785.7",
      gene_id : "ENSG00000198785.7",
      gene_type : "protein_coding",
      gene_name : "GRIN3A",
      gene_level : 2,
      hgnc_id : "HGNC:16767",
      havana_gene : "OTTHUMG00000020387.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 101591604,
      stop : 101595021,
      direction : "-",
      ID : "ENSG00000188386.8",
      gene_id : "ENSG00000188386.8",
      gene_type : "protein_coding",
      gene_name : "PPP3R2",
      gene_level : 2,
      hgnc_id : "HGNC:9318",
      havana_gene : "OTTHUMG00000020386.4",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 102995311,
      stop : 103018488,
      direction : "+",
      ID : "ENSG00000155833.15",
      gene_id : "ENSG00000155833.15",
      gene_type : "protein_coding",
      gene_name : "CYLC2",
      gene_level : 1,
      hgnc_id : "HGNC:2583",
      havana_gene : "OTTHUMG00000020396.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104094260,
      stop : 104141419,
      direction : "+",
      ID : "ENSG00000136824.19",
      gene_id : "ENSG00000136824.19",
      gene_type : "protein_coding",
      gene_name : "SMC2",
      gene_level : 2,
      hgnc_id : "HGNC:14011",
      havana_gene : "OTTHUMG00000020401.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104504263,
      stop : 104505222,
      direction : "+",
      ID : "ENSG00000186881.3",
      gene_id : "ENSG00000186881.3",
      gene_type : "protein_coding",
      gene_name : "OR13F1",
      gene_level : 2,
      hgnc_id : "HGNC:14723",
      havana_gene : "OTTHUMG00000020404.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104526253,
      stop : 104527209,
      direction : "-",
      ID : "ENSG00000148136.5",
      gene_id : "ENSG00000148136.5",
      gene_type : "protein_coding",
      gene_name : "OR13C4",
      gene_level : 2,
      hgnc_id : "HGNC:14722",
      havana_gene : "OTTHUMG00000020407.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104535749,
      stop : 104536856,
      direction : "-",
      ID : "ENSG00000204246.3",
      gene_id : "ENSG00000204246.3",
      gene_type : "protein_coding",
      gene_name : "OR13C3",
      gene_level : 2,
      hgnc_id : "HGNC:14704",
      havana_gene : "OTTHUMG00000020406.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104569168,
      stop : 104570130,
      direction : "+",
      ID : "ENSG00000186943.1",
      gene_id : "ENSG00000186943.1",
      gene_type : "protein_coding",
      gene_name : "OR13C8",
      gene_level : 2,
      hgnc_id : "HGNC:15103",
      havana_gene : "OTTHUMG00000020409.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104598457,
      stop : 104599413,
      direction : "-",
      ID : "ENSG00000277556.1",
      gene_id : "ENSG00000277556.1",
      gene_type : "protein_coding",
      gene_name : "OR13C5",
      gene_level : 2,
      hgnc_id : "HGNC:15100",
      havana_gene : "OTTHUMG00000020408.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104604671,
      stop : 104605627,
      direction : "-",
      ID : "ENSG00000276119.1",
      gene_id : "ENSG00000276119.1",
      gene_type : "protein_coding",
      gene_name : "OR13C2",
      gene_level : 2,
      hgnc_id : "HGNC:14701",
      havana_gene : "OTTHUMG00000020415.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104617248,
      stop : 104618204,
      direction : "-",
      ID : "ENSG00000136839.1",
      gene_id : "ENSG00000136839.1",
      gene_type : "protein_coding",
      gene_name : "OR13C9",
      gene_level : 2,
      hgnc_id : "HGNC:15104",
      havana_gene : "OTTHUMG00000020416.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104694379,
      stop : 104695485,
      direction : "+",
      ID : "ENSG00000179055.7",
      gene_id : "ENSG00000179055.7",
      gene_type : "protein_coding",
      gene_name : "OR13D1",
      gene_level : 2,
      hgnc_id : "HGNC:14695",
      havana_gene : "OTTHUMG00000020412.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104747683,
      stop : 104760120,
      direction : "+",
      ID : "ENSG00000136783.10",
      gene_id : "ENSG00000136783.10",
      gene_type : "protein_coding",
      gene_name : "NIPSNAP3A",
      gene_level : 2,
      hgnc_id : "HGNC:23619",
      havana_gene : "OTTHUMG00000020413.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104764129,
      stop : 104777764,
      direction : "+",
      ID : "ENSG00000165028.12",
      gene_id : "ENSG00000165028.12",
      gene_type : "protein_coding",
      gene_name : "NIPSNAP3B",
      gene_level : 2,
      hgnc_id : "HGNC:23641",
      havana_gene : "OTTHUMG00000020414.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 104781006,
      stop : 104928155,
      direction : "-",
      ID : "ENSG00000165029.17",
      gene_id : "ENSG00000165029.17",
      gene_type : "protein_coding",
      gene_name : "ABCA1",
      gene_level : 2,
      hgnc_id : "HGNC:29",
      havana_gene : "OTTHUMG00000020417.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 105244622,
      stop : 105439171,
      direction : "+",
      ID : "ENSG00000070214.16",
      gene_id : "ENSG00000070214.16",
      gene_type : "protein_coding",
      gene_name : "SLC44A1",
      gene_level : 2,
      hgnc_id : "HGNC:18798",
      havana_gene : "OTTHUMG00000020421.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 105447796,
      stop : 105552433,
      direction : "+",
      ID : "ENSG00000106701.13",
      gene_id : "ENSG00000106701.13",
      gene_type : "protein_coding",
      gene_name : "FSD1L",
      gene_level : 1,
      hgnc_id : "HGNC:13753",
      havana_gene : "OTTHUMG00000020426.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 105558122,
      stop : 105653820,
      direction : "+",
      ID : "ENSG00000106692.15",
      gene_id : "ENSG00000106692.15",
      gene_type : "protein_coding",
      gene_name : "FKTN",
      gene_level : 1,
      hgnc_id : "HGNC:3622",
      havana_gene : "OTTHUMG00000020425.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 105662457,
      stop : 105663124,
      direction : "+",
      ID : "ENSG00000186051.7",
      gene_id : "ENSG00000186051.7",
      gene_type : "protein_coding",
      gene_name : "TAL2",
      gene_level : 2,
      hgnc_id : "HGNC:11557",
      havana_gene : "OTTHUMG00000020424.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 105694541,
      stop : 105776629,
      direction : "+",
      ID : "ENSG00000095209.12",
      gene_id : "ENSG00000095209.12",
      gene_type : "protein_coding",
      gene_name : "TMEM38B",
      gene_level : 2,
      hgnc_id : "HGNC:25535",
      havana_gene : "OTTHUMG00000020429.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 106863166,
      stop : 107013634,
      direction : "+",
      ID : "ENSG00000148143.13",
      gene_id : "ENSG00000148143.13",
      gene_type : "protein_coding",
      gene_name : "ZNF462",
      gene_level : 1,
      hgnc_id : "HGNC:21684",
      havana_gene : "OTTHUMG00000020438.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 107283137,
      stop : 107332192,
      direction : "+",
      ID : "ENSG00000119318.13",
      gene_id : "ENSG00000119318.13",
      gene_type : "protein_coding",
      gene_name : "RAD23B",
      gene_level : 2,
      hgnc_id : "HGNC:9813",
      havana_gene : "OTTHUMG00000020446.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 107484852,
      stop : 107490482,
      direction : "-",
      ID : "ENSG00000136826.15",
      gene_id : "ENSG00000136826.15",
      gene_type : "protein_coding",
      gene_name : "KLF4",
      gene_level : 2,
      hgnc_id : "HGNC:6348",
      havana_gene : "OTTHUMG00000020449.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 108854588,
      stop : 108855986,
      direction : "-",
      ID : "ENSG00000148156.8",
      gene_id : "ENSG00000148156.8",
      gene_type : "protein_coding",
      gene_name : "ACTL7B",
      gene_level : 2,
      hgnc_id : "HGNC:162",
      havana_gene : "OTTHUMG00000020462.3",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 108862266,
      stop : 108863756,
      direction : "+",
      ID : "ENSG00000187003.7",
      gene_id : "ENSG00000187003.7",
      gene_type : "protein_coding",
      gene_name : "ACTL7A",
      gene_level : 2,
      hgnc_id : "HGNC:161",
      havana_gene : "OTTHUMG00000020461.3",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 108866898,
      stop : 108934328,
      direction : "-",
      ID : "ENSG00000070061.16",
      gene_id : "ENSG00000070061.16",
      gene_type : "protein_coding",
      gene_name : "ELP1",
      gene_level : 2,
      hgnc_id : "HGNC:5959",
      havana_gene : "OTTHUMG00000020465.9",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 108934400,
      stop : 108950744,
      direction : "+",
      ID : "ENSG00000119328.12",
      gene_id : "ENSG00000119328.12",
      gene_type : "protein_coding",
      gene_name : "ABITRAM",
      gene_level : 2,
      hgnc_id : "HGNC:1364",
      havana_gene : "OTTHUMG00000020467.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 108942569,
      stop : 109013522,
      direction : "-",
      ID : "ENSG00000119326.15",
      gene_id : "ENSG00000119326.15",
      gene_type : "protein_coding",
      gene_name : "CTNNAL1",
      gene_level : 2,
      hgnc_id : "HGNC:2512",
      havana_gene : "OTTHUMG00000020466.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 109015135,
      stop : 109119947,
      direction : "-",
      ID : "ENSG00000106771.13",
      gene_id : "ENSG00000106771.13",
      gene_type : "protein_coding",
      gene_name : "TMEM245",
      gene_level : 2,
      hgnc_id : "HGNC:1363",
      havana_gene : "OTTHUMG00000020469.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 109130293,
      stop : 109167249,
      direction : "-",
      ID : "ENSG00000260230.5",
      gene_id : "ENSG00000260230.5",
      gene_type : "protein_coding",
      gene_name : "FRRS1L",
      gene_level : 2,
      hgnc_id : "HGNC:1362",
      havana_gene : "OTTHUMG00000020468.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 109171974,
      stop : 109321059,
      direction : "-",
      ID : "ENSG00000095203.15",
      gene_id : "ENSG00000095203.15",
      gene_type : "protein_coding",
      gene_name : "EPB41L4B",
      gene_level : 2,
      hgnc_id : "HGNC:19818",
      havana_gene : "OTTHUMG00000020470.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 109375466,
      stop : 109498313,
      direction : "-",
      ID : "ENSG00000070159.14",
      gene_id : "ENSG00000070159.14",
      gene_type : "protein_coding",
      gene_name : "PTPN3",
      gene_level : 2,
      hgnc_id : "HGNC:9655",
      havana_gene : "OTTHUMG00000020475.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 109498325,
      stop : 110172512,
      direction : "+",
      ID : "ENSG00000157654.19",
      gene_id : "ENSG00000157654.19",
      gene_type : "protein_coding",
      gene_name : "PALM2AKAP2",
      gene_level : 2,
      hgnc_id : "HGNC:33529",
      havana_gene : "OTTHUMG00000156812.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 110190048,
      stop : 110208159,
      direction : "-",
      ID : "ENSG00000188959.10",
      gene_id : "ENSG00000188959.10",
      gene_type : "protein_coding",
      gene_name : "C9orf152",
      gene_level : 2,
      hgnc_id : "HGNC:31455",
      havana_gene : "OTTHUMG00000020478.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 110243810,
      stop : 110256507,
      direction : "-",
      ID : "ENSG00000136810.13",
      gene_id : "ENSG00000136810.13",
      gene_type : "protein_coding",
      gene_name : "TXN",
      gene_level : 2,
      hgnc_id : "HGNC:12435",
      havana_gene : "OTTHUMG00000020480.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 110303476,
      stop : 110337884,
      direction : "-",
      ID : "ENSG00000204193.11",
      gene_id : "ENSG00000204193.11",
      gene_type : "protein_coding",
      gene_name : "TXNDC8",
      gene_level : 1,
      hgnc_id : "HGNC:31454",
      havana_gene : "OTTHUMG00000020481.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 110365248,
      stop : 110579880,
      direction : "-",
      ID : "ENSG00000165124.18",
      gene_id : "ENSG00000165124.18",
      gene_type : "protein_coding",
      gene_name : "SVEP1",
      gene_level : 2,
      hgnc_id : "HGNC:15985",
      havana_gene : "OTTHUMG00000020482.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 110668779,
      stop : 110806558,
      direction : "+",
      ID : "ENSG00000030304.14",
      gene_id : "ENSG00000030304.14",
      gene_type : "protein_coding",
      gene_name : "MUSK",
      gene_level : 1,
      hgnc_id : "HGNC:7525",
      havana_gene : "OTTHUMG00000020485.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 110873263,
      stop : 111038458,
      direction : "-",
      ID : "ENSG00000198121.13",
      gene_id : "ENSG00000198121.13",
      gene_type : "protein_coding",
      gene_name : "LPAR1",
      gene_level : 2,
      hgnc_id : "HGNC:3166",
      havana_gene : "OTTHUMG00000020486.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111327483,
      stop : 111330183,
      direction : "-",
      ID : "ENSG00000171133.3",
      gene_id : "ENSG00000171133.3",
      gene_type : "protein_coding",
      gene_name : "OR2K2",
      gene_level : 2,
      hgnc_id : "HGNC:8264",
      havana_gene : "OTTHUMG00000020488.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111360692,
      stop : 111484745,
      direction : "-",
      ID : "ENSG00000136813.14",
      gene_id : "ENSG00000136813.14",
      gene_type : "protein_coding",
      gene_name : "ECPAS",
      gene_level : 2,
      hgnc_id : "HGNC:29020",
      havana_gene : "OTTHUMG00000020489.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111525159,
      stop : 111577844,
      direction : "+",
      ID : "ENSG00000173258.13",
      gene_id : "ENSG00000173258.13",
      gene_type : "protein_coding",
      gene_name : "ZNF483",
      gene_level : 2,
      hgnc_id : "HGNC:23384",
      havana_gene : "OTTHUMG00000020490.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111549722,
      stop : 111599893,
      direction : "-",
      ID : "ENSG00000106853.20",
      gene_id : "ENSG00000106853.20",
      gene_type : "protein_coding",
      gene_name : "PTGR1",
      gene_level : 2,
      hgnc_id : "HGNC:18429",
      havana_gene : "OTTHUMG00000020493.11",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111631334,
      stop : 111654351,
      direction : "+",
      ID : "ENSG00000059769.20",
      gene_id : "ENSG00000059769.20",
      gene_type : "protein_coding",
      gene_name : "DNAJC25",
      gene_level : 2,
      hgnc_id : "HGNC:34187",
      havana_gene : "OTTHUMG00000020491.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111631386,
      stop : 111670229,
      direction : "+",
      ID : "ENSG00000244115.1",
      gene_id : "ENSG00000244115.1",
      gene_type : "protein_coding",
      gene_name : "DNAJC25-GNG10",
      gene_level : 2,
      hgnc_id : "HGNC:37501",
      havana_gene : "OTTHUMG00000150303.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111661605,
      stop : 111670226,
      direction : "+",
      ID : "ENSG00000242616.4",
      gene_id : "ENSG00000242616.4",
      gene_type : "protein_coding",
      gene_name : "GNG10",
      gene_level : 2,
      hgnc_id : "HGNC:4402",
      havana_gene : "OTTHUMG00000157193.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111686173,
      stop : 111795008,
      direction : "-",
      ID : "ENSG00000165181.16",
      gene_id : "ENSG00000165181.16",
      gene_type : "protein_coding",
      gene_name : "SHOC1",
      gene_level : 1,
      hgnc_id : "HGNC:26535",
      havana_gene : "OTTHUMG00000020495.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 111896814,
      stop : 111935369,
      direction : "+",
      ID : "ENSG00000148154.10",
      gene_id : "ENSG00000148154.10",
      gene_type : "protein_coding",
      gene_name : "UGCG",
      gene_level : 2,
      hgnc_id : "HGNC:12524",
      havana_gene : "OTTHUMG00000020498.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112040783,
      stop : 112175297,
      direction : "-",
      ID : "ENSG00000106868.17",
      gene_id : "ENSG00000106868.17",
      gene_type : "protein_coding",
      gene_name : "SUSD1",
      gene_level : 1,
      hgnc_id : "HGNC:25413",
      havana_gene : "OTTHUMG00000020499.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112217716,
      stop : 112333664,
      direction : "-",
      ID : "ENSG00000119314.16",
      gene_id : "ENSG00000119314.16",
      gene_type : "protein_coding",
      gene_name : "PTBP3",
      gene_level : 2,
      hgnc_id : "HGNC:10253",
      havana_gene : "OTTHUMG00000020503.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112380080,
      stop : 112472405,
      direction : "+",
      ID : "ENSG00000119471.15",
      gene_id : "ENSG00000119471.15",
      gene_type : "protein_coding",
      gene_name : "HSDL2",
      gene_level : 2,
      hgnc_id : "HGNC:18572",
      havana_gene : "OTTHUMG00000020504.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112486827,
      stop : 112669397,
      direction : "+",
      ID : "ENSG00000165185.15",
      gene_id : "ENSG00000165185.15",
      gene_type : "protein_coding",
      gene_name : "KIAA1958",
      gene_level : 2,
      hgnc_id : "HGNC:23427",
      havana_gene : "OTTHUMG00000020508.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112683926,
      stop : 112718149,
      direction : "-",
      ID : "ENSG00000148153.14",
      gene_id : "ENSG00000148153.14",
      gene_type : "protein_coding",
      gene_name : "INIP",
      gene_level : 2,
      hgnc_id : "HGNC:24994",
      havana_gene : "OTTHUMG00000020509.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112750760,
      stop : 112881671,
      direction : "+",
      ID : "ENSG00000148158.17",
      gene_id : "ENSG00000148158.17",
      gene_type : "protein_coding",
      gene_name : "SNX30",
      gene_level : 2,
      hgnc_id : "HGNC:23685",
      havana_gene : "OTTHUMG00000020512.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 112878920,
      stop : 112890876,
      direction : "-",
      ID : "ENSG00000119457.8",
      gene_id : "ENSG00000119457.8",
      gene_type : "protein_coding",
      gene_name : "SLC46A2",
      gene_level : 2,
      hgnc_id : "HGNC:16055",
      havana_gene : "OTTHUMG00000020513.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113038377,
      stop : 113056759,
      direction : "-",
      ID : "ENSG00000136866.14",
      gene_id : "ENSG00000136866.14",
      gene_type : "protein_coding",
      gene_name : "ZFP37",
      gene_level : 2,
      hgnc_id : "HGNC:12863",
      havana_gene : "OTTHUMG00000021019.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113150976,
      stop : 113164140,
      direction : "+",
      ID : "ENSG00000136867.11",
      gene_id : "ENSG00000136867.11",
      gene_type : "protein_coding",
      gene_name : "SLC31A2",
      gene_level : 2,
      hgnc_id : "HGNC:11017",
      havana_gene : "OTTHUMG00000021037.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113161006,
      stop : 113221318,
      direction : "-",
      ID : "ENSG00000119321.9",
      gene_id : "ENSG00000119321.9",
      gene_type : "protein_coding",
      gene_name : "FKBP15",
      gene_level : 2,
      hgnc_id : "HGNC:23397",
      havana_gene : "OTTHUMG00000020518.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113221544,
      stop : 113264492,
      direction : "+",
      ID : "ENSG00000136868.11",
      gene_id : "ENSG00000136868.11",
      gene_type : "protein_coding",
      gene_name : "SLC31A1",
      gene_level : 2,
      hgnc_id : "HGNC:11016",
      havana_gene : "OTTHUMG00000020519.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113255835,
      stop : 113275572,
      direction : "-",
      ID : "ENSG00000176386.9",
      gene_id : "ENSG00000176386.9",
      gene_type : "protein_coding",
      gene_name : "CDC26",
      gene_level : 2,
      hgnc_id : "HGNC:17839",
      havana_gene : "OTTHUMG00000020521.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113275642,
      stop : 113294009,
      direction : "+",
      ID : "ENSG00000136875.13",
      gene_id : "ENSG00000136875.13",
      gene_type : "protein_coding",
      gene_name : "PRPF4",
      gene_level : 2,
      hgnc_id : "HGNC:17349",
      havana_gene : "OTTHUMG00000020517.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113297093,
      stop : 113303376,
      direction : "-",
      ID : "ENSG00000165188.13",
      gene_id : "ENSG00000165188.13",
      gene_type : "protein_coding",
      gene_name : "RNF183",
      gene_level : 2,
      hgnc_id : "HGNC:28721",
      havana_gene : "OTTHUMG00000020520.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113313222,
      stop : 113340298,
      direction : "-",
      ID : "ENSG00000148225.16",
      gene_id : "ENSG00000148225.16",
      gene_type : "protein_coding",
      gene_name : "WDR31",
      gene_level : 2,
      hgnc_id : "HGNC:21421",
      havana_gene : "OTTHUMG00000020525.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113349541,
      stop : 113371233,
      direction : "+",
      ID : "ENSG00000119411.11",
      gene_id : "ENSG00000119411.11",
      gene_type : "protein_coding",
      gene_name : "BSPRY",
      gene_level : 2,
      hgnc_id : "HGNC:18232",
      havana_gene : "OTTHUMG00000021006.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113373419,
      stop : 113376999,
      direction : "-",
      ID : "ENSG00000119431.9",
      gene_id : "ENSG00000119431.9",
      gene_type : "protein_coding",
      gene_name : "HDHD3",
      gene_level : 2,
      hgnc_id : "HGNC:28171",
      havana_gene : "OTTHUMG00000020524.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113386312,
      stop : 113401290,
      direction : "-",
      ID : "ENSG00000148218.16",
      gene_id : "ENSG00000148218.16",
      gene_type : "protein_coding",
      gene_name : "ALAD",
      gene_level : 2,
      hgnc_id : "HGNC:395",
      havana_gene : "OTTHUMG00000020522.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113407235,
      stop : 113410675,
      direction : "-",
      ID : "ENSG00000148229.13",
      gene_id : "ENSG00000148229.13",
      gene_type : "protein_coding",
      gene_name : "POLE3",
      gene_level : 2,
      hgnc_id : "HGNC:13546",
      havana_gene : "OTTHUMG00000020523.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113410054,
      stop : 113429690,
      direction : "+",
      ID : "ENSG00000157653.12",
      gene_id : "ENSG00000157653.12",
      gene_type : "protein_coding",
      gene_name : "C9orf43",
      gene_level : 2,
      hgnc_id : "HGNC:23570",
      havana_gene : "OTTHUMG00000020526.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113444731,
      stop : 113597743,
      direction : "+",
      ID : "ENSG00000138835.22",
      gene_id : "ENSG00000138835.22",
      gene_type : "protein_coding",
      gene_name : "RGS3",
      gene_level : 1,
      hgnc_id : "HGNC:9999",
      havana_gene : "OTTHUMG00000021048.9",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 113876282,
      stop : 114056591,
      direction : "+",
      ID : "ENSG00000157657.14",
      gene_id : "ENSG00000157657.14",
      gene_type : "protein_coding",
      gene_name : "ZNF618",
      gene_level : 2,
      hgnc_id : "HGNC:29416",
      havana_gene : "OTTHUMG00000020532.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114060127,
      stop : 114078328,
      direction : "-",
      ID : "ENSG00000106927.12",
      gene_id : "ENSG00000106927.12",
      gene_type : "protein_coding",
      gene_name : "AMBP",
      gene_level : 2,
      hgnc_id : "HGNC:453",
      havana_gene : "OTTHUMG00000020534.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114086126,
      stop : 114099291,
      direction : "-",
      ID : "ENSG00000136883.14",
      gene_id : "ENSG00000136883.14",
      gene_type : "protein_coding",
      gene_name : "KIF12",
      gene_level : 2,
      hgnc_id : "HGNC:21495",
      havana_gene : "OTTHUMG00000020533.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114155537,
      stop : 114312511,
      direction : "+",
      ID : "ENSG00000196739.15",
      gene_id : "ENSG00000196739.15",
      gene_type : "protein_coding",
      gene_name : "COL27A1",
      gene_level : 2,
      hgnc_id : "HGNC:22986",
      havana_gene : "OTTHUMG00000020537.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114323056,
      stop : 114326475,
      direction : "+",
      ID : "ENSG00000229314.5",
      gene_id : "ENSG00000229314.5",
      gene_type : "protein_coding",
      gene_name : "ORM1",
      gene_level : 2,
      hgnc_id : "HGNC:8498",
      havana_gene : "OTTHUMG00000021012.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114329869,
      stop : 114333251,
      direction : "+",
      ID : "ENSG00000228278.5",
      gene_id : "ENSG00000228278.5",
      gene_type : "protein_coding",
      gene_name : "ORM2",
      gene_level : 2,
      hgnc_id : "HGNC:8499",
      havana_gene : "OTTHUMG00000021014.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114334156,
      stop : 114394405,
      direction : "-",
      ID : "ENSG00000106948.17",
      gene_id : "ENSG00000106948.17",
      gene_type : "protein_coding",
      gene_name : "AKNA",
      gene_level : 2,
      hgnc_id : "HGNC:24108",
      havana_gene : "OTTHUMG00000020538.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114402080,
      stop : 114505473,
      direction : "-",
      ID : "ENSG00000095397.16",
      gene_id : "ENSG00000095397.16",
      gene_type : "protein_coding",
      gene_name : "WHRN",
      gene_level : 2,
      hgnc_id : "HGNC:16361",
      havana_gene : "OTTHUMG00000020539.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114587706,
      stop : 114598915,
      direction : "+",
      ID : "ENSG00000136888.8",
      gene_id : "ENSG00000136888.8",
      gene_type : "protein_coding",
      gene_name : "ATP6V1G1",
      gene_level : 2,
      hgnc_id : "HGNC:864",
      havana_gene : "OTTHUMG00000021023.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114611206,
      stop : 114646422,
      direction : "+",
      ID : "ENSG00000157693.15",
      gene_id : "ENSG00000157693.15",
      gene_type : "protein_coding",
      gene_name : "TMEM268",
      gene_level : 2,
      hgnc_id : "HGNC:24513",
      havana_gene : "OTTHUMG00000020541.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114656304,
      stop : 114662374,
      direction : "-",
      ID : "ENSG00000230054.3",
      gene_id : "ENSG00000230054.3",
      gene_type : "protein_coding",
      gene_name : "TEX53",
      gene_level : 1,
      hgnc_id : "HGNC:53655",
      havana_gene : "OTTHUMG00000020544.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114666434,
      stop : 114682192,
      direction : "-",
      ID : "ENSG00000230601.7",
      gene_id : "ENSG00000230601.7",
      gene_type : "protein_coding",
      gene_name : "TEX48",
      gene_level : 1,
      hgnc_id : "HGNC:52393",
      havana_gene : "OTTHUMG00000020542.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114784652,
      stop : 114806039,
      direction : "-",
      ID : "ENSG00000181634.8",
      gene_id : "ENSG00000181634.8",
      gene_type : "protein_coding",
      gene_name : "TNFSF15",
      gene_level : 2,
      hgnc_id : "HGNC:11931",
      havana_gene : "OTTHUMG00000021011.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 114893343,
      stop : 114930595,
      direction : "-",
      ID : "ENSG00000106952.8",
      gene_id : "ENSG00000106952.8",
      gene_type : "protein_coding",
      gene_name : "TNFSF8",
      gene_level : 2,
      hgnc_id : "HGNC:11938",
      havana_gene : "OTTHUMG00000021025.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 115019575,
      stop : 115118257,
      direction : "-",
      ID : "ENSG00000041982.16",
      gene_id : "ENSG00000041982.16",
      gene_type : "protein_coding",
      gene_name : "TNC",
      gene_level : 1,
      hgnc_id : "HGNC:5318",
      havana_gene : "OTTHUMG00000021010.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 116153791,
      stop : 116402321,
      direction : "+",
      ID : "ENSG00000182752.10",
      gene_id : "ENSG00000182752.10",
      gene_type : "protein_coding",
      gene_name : "PAPPA",
      gene_level : 2,
      hgnc_id : "HGNC:8602",
      havana_gene : "OTTHUMG00000021045.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 116423112,
      stop : 117415070,
      direction : "-",
      ID : "ENSG00000148219.18",
      gene_id : "ENSG00000148219.18",
      gene_type : "protein_coding",
      gene_name : "ASTN2",
      gene_level : 2,
      hgnc_id : "HGNC:17021",
      havana_gene : "OTTHUMG00000021013.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 116687305,
      stop : 116701300,
      direction : "+",
      ID : "ENSG00000119401.11",
      gene_id : "ENSG00000119401.11",
      gene_type : "protein_coding",
      gene_name : "TRIM32",
      gene_level : 2,
      hgnc_id : "HGNC:16380",
      havana_gene : "OTTHUMG00000021026.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 117704157,
      stop : 118072314,
      direction : "+",
      ID : "ENSG00000285082.2",
      gene_id : "ENSG00000285082.2",
      gene_type : "protein_coding",
      gene_name : "AL160272.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192614.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 117704175,
      stop : 117724735,
      direction : "+",
      ID : "ENSG00000136869.16",
      gene_id : "ENSG00000136869.16",
      gene_type : "protein_coding",
      gene_name : "TLR4",
      gene_level : 2,
      hgnc_id : "HGNC:11850",
      havana_gene : "OTTHUMG00000021046.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 119153458,
      stop : 119369435,
      direction : "-",
      ID : "ENSG00000078725.13",
      gene_id : "ENSG00000078725.13",
      gene_type : "protein_coding",
      gene_name : "BRINP1",
      gene_level : 2,
      hgnc_id : "HGNC:2687",
      havana_gene : "OTTHUMG00000021020.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120388869,
      stop : 120580170,
      direction : "-",
      ID : "ENSG00000136861.18",
      gene_id : "ENSG00000136861.18",
      gene_type : "protein_coding",
      gene_name : "CDK5RAP2",
      gene_level : 2,
      hgnc_id : "HGNC:18672",
      havana_gene : "OTTHUMG00000021043.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120600811,
      stop : 120714470,
      direction : "-",
      ID : "ENSG00000106780.9",
      gene_id : "ENSG00000106780.9",
      gene_type : "protein_coding",
      gene_name : "MEGF9",
      gene_level : 2,
      hgnc_id : "HGNC:3234",
      havana_gene : "OTTHUMG00000021039.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120751978,
      stop : 120793416,
      direction : "-",
      ID : "ENSG00000119402.17",
      gene_id : "ENSG00000119402.17",
      gene_type : "protein_coding",
      gene_name : "FBXW2",
      gene_level : 2,
      hgnc_id : "HGNC:13608",
      havana_gene : "OTTHUMG00000020576.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120792403,
      stop : 120799918,
      direction : "+",
      ID : "ENSG00000214654.8",
      gene_id : "ENSG00000214654.8",
      gene_type : "protein_coding",
      gene_name : "B3GNT10",
      gene_level : 2,
      hgnc_id : "HGNC:53652",
      havana_gene : "OTTHUMG00000020574.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120815496,
      stop : 120842951,
      direction : "-",
      ID : "ENSG00000095261.14",
      gene_id : "ENSG00000095261.14",
      gene_type : "protein_coding",
      gene_name : "PSMD5",
      gene_level : 2,
      hgnc_id : "HGNC:9563",
      havana_gene : "OTTHUMG00000020573.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120855651,
      stop : 120894896,
      direction : "-",
      ID : "ENSG00000119403.15",
      gene_id : "ENSG00000119403.15",
      gene_type : "protein_coding",
      gene_name : "PHF19",
      gene_level : 2,
      hgnc_id : "HGNC:24566",
      havana_gene : "OTTHUMG00000020577.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120902393,
      stop : 120929173,
      direction : "-",
      ID : "ENSG00000056558.11",
      gene_id : "ENSG00000056558.11",
      gene_type : "protein_coding",
      gene_name : "TRAF1",
      gene_level : 2,
      hgnc_id : "HGNC:12031",
      havana_gene : "OTTHUMG00000020578.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 120952335,
      stop : 121050275,
      direction : "-",
      ID : "ENSG00000106804.8",
      gene_id : "ENSG00000106804.8",
      gene_type : "protein_coding",
      gene_name : "C5",
      gene_level : 2,
      hgnc_id : "HGNC:1331",
      havana_gene : "OTTHUMG00000020579.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121074753,
      stop : 121177610,
      direction : "+",
      ID : "ENSG00000119397.18",
      gene_id : "ENSG00000119397.18",
      gene_type : "protein_coding",
      gene_name : "CNTRL",
      gene_level : 1,
      hgnc_id : "HGNC:1858",
      havana_gene : "OTTHUMG00000020581.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121178133,
      stop : 121223014,
      direction : "-",
      ID : "ENSG00000119396.11",
      gene_id : "ENSG00000119396.11",
      gene_type : "protein_coding",
      gene_name : "RAB14",
      gene_level : 2,
      hgnc_id : "HGNC:16524",
      havana_gene : "OTTHUMG00000020582.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121207794,
      stop : 121332843,
      direction : "+",
      ID : "ENSG00000148180.21",
      gene_id : "ENSG00000148180.21",
      gene_type : "protein_coding",
      gene_name : "GSN",
      gene_level : 2,
      hgnc_id : "HGNC:4620",
      havana_gene : "OTTHUMG00000020584.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121338987,
      stop : 121370304,
      direction : "-",
      ID : "ENSG00000148175.13",
      gene_id : "ENSG00000148175.13",
      gene_type : "protein_coding",
      gene_name : "STOM",
      gene_level : 2,
      hgnc_id : "HGNC:3383",
      havana_gene : "OTTHUMG00000020590.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121444991,
      stop : 121499844,
      direction : "-",
      ID : "ENSG00000204136.12",
      gene_id : "ENSG00000204136.12",
      gene_type : "protein_coding",
      gene_name : "GGTA1",
      gene_level : 2,
      hgnc_id : "HGNC:4253",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121567057,
      stop : 121785530,
      direction : "+",
      ID : "ENSG00000136848.17",
      gene_id : "ENSG00000136848.17",
      gene_type : "protein_coding",
      gene_name : "DAB2IP",
      gene_level : 2,
      hgnc_id : "HGNC:17294",
      havana_gene : "OTTHUMG00000020595.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 121821928,
      stop : 122093606,
      direction : "-",
      ID : "ENSG00000175764.15",
      gene_id : "ENSG00000175764.15",
      gene_type : "protein_coding",
      gene_name : "TTLL11",
      gene_level : 2,
      hgnc_id : "HGNC:18113",
      havana_gene : "OTTHUMG00000020597.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122144058,
      stop : 122159779,
      direction : "-",
      ID : "ENSG00000119421.7",
      gene_id : "ENSG00000119421.7",
      gene_type : "protein_coding",
      gene_name : "NDUFA8",
      gene_level : 2,
      hgnc_id : "HGNC:7692",
      havana_gene : "OTTHUMG00000020598.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122159908,
      stop : 122200088,
      direction : "+",
      ID : "ENSG00000185681.13",
      gene_id : "ENSG00000185681.13",
      gene_type : "protein_coding",
      gene_name : "MORN5",
      gene_level : 2,
      hgnc_id : "HGNC:17841",
      havana_gene : "OTTHUMG00000020599.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122202577,
      stop : 122229626,
      direction : "-",
      ID : "ENSG00000106852.15",
      gene_id : "ENSG00000106852.15",
      gene_type : "protein_coding",
      gene_name : "LHX6",
      gene_level : 1,
      hgnc_id : "HGNC:21735",
      havana_gene : "OTTHUMG00000020601.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122237622,
      stop : 122264840,
      direction : "-",
      ID : "ENSG00000119446.14",
      gene_id : "ENSG00000119446.14",
      gene_type : "protein_coding",
      gene_name : "RBM18",
      gene_level : 2,
      hgnc_id : "HGNC:28413",
      havana_gene : "OTTHUMG00000020602.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122264603,
      stop : 122331337,
      direction : "+",
      ID : "ENSG00000148187.18",
      gene_id : "ENSG00000148187.18",
      gene_type : "protein_coding",
      gene_name : "MRRF",
      gene_level : 2,
      hgnc_id : "HGNC:7234",
      havana_gene : "OTTHUMG00000020600.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122370530,
      stop : 122395703,
      direction : "+",
      ID : "ENSG00000095303.17",
      gene_id : "ENSG00000095303.17",
      gene_type : "protein_coding",
      gene_name : "PTGS1",
      gene_level : 2,
      hgnc_id : "HGNC:9604",
      havana_gene : "OTTHUMG00000020605.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122476958,
      stop : 122477926,
      direction : "-",
      ID : "ENSG00000136834.3",
      gene_id : "ENSG00000136834.3",
      gene_type : "protein_coding",
      gene_name : "OR1J1",
      gene_level : 2,
      hgnc_id : "HGNC:8208",
      havana_gene : "OTTHUMG00000020603.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122510802,
      stop : 122511743,
      direction : "+",
      ID : "ENSG00000197233.7",
      gene_id : "ENSG00000197233.7",
      gene_type : "protein_coding",
      gene_name : "OR1J2",
      gene_level : 2,
      hgnc_id : "HGNC:8209",
      havana_gene : "OTTHUMG00000020604.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122519141,
      stop : 122520082,
      direction : "+",
      ID : "ENSG00000239590.1",
      gene_id : "ENSG00000239590.1",
      gene_type : "protein_coding",
      gene_name : "OR1J4",
      gene_level : 2,
      hgnc_id : "HGNC:8211",
      havana_gene : "OTTHUMG00000020606.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122526358,
      stop : 122527296,
      direction : "-",
      ID : "ENSG00000171505.5",
      gene_id : "ENSG00000171505.5",
      gene_type : "protein_coding",
      gene_name : "OR1N1",
      gene_level : 2,
      hgnc_id : "HGNC:8221",
      havana_gene : "OTTHUMG00000020608.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122553112,
      stop : 122555173,
      direction : "+",
      ID : "ENSG00000171501.10",
      gene_id : "ENSG00000171501.10",
      gene_type : "protein_coding",
      gene_name : "OR1N2",
      gene_level : 2,
      hgnc_id : "HGNC:15111",
      havana_gene : "OTTHUMG00000020607.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122567117,
      stop : 122583384,
      direction : "-",
      ID : "ENSG00000171496.4",
      gene_id : "ENSG00000171496.4",
      gene_type : "protein_coding",
      gene_name : "OR1L8",
      gene_level : 2,
      hgnc_id : "HGNC:15110",
      havana_gene : "OTTHUMG00000020609.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122614738,
      stop : 122615682,
      direction : "+",
      ID : "ENSG00000165202.3",
      gene_id : "ENSG00000165202.3",
      gene_type : "protein_coding",
      gene_name : "OR1Q1",
      gene_level : 2,
      hgnc_id : "HGNC:8223",
      havana_gene : "OTTHUMG00000020615.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122628579,
      stop : 122629573,
      direction : "-",
      ID : "ENSG00000280094.2",
      gene_id : "ENSG00000280094.2",
      gene_type : "protein_coding",
      gene_name : "OR1B1",
      gene_level : 2,
      hgnc_id : "HGNC:8181",
      havana_gene : "OTTHUMG00000020616.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122661566,
      stop : 122662648,
      direction : "+",
      ID : "ENSG00000173679.2",
      gene_id : "ENSG00000173679.2",
      gene_type : "protein_coding",
      gene_name : "OR1L1",
      gene_level : 2,
      hgnc_id : "HGNC:8213",
      havana_gene : "OTTHUMG00000020618.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122675036,
      stop : 122676153,
      direction : "+",
      ID : "ENSG00000171481.4",
      gene_id : "ENSG00000171481.4",
      gene_type : "protein_coding",
      gene_name : "OR1L3",
      gene_level : 2,
      hgnc_id : "HGNC:8215",
      havana_gene : "OTTHUMG00000020619.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122723990,
      stop : 122724925,
      direction : "+",
      ID : "ENSG00000136939.1",
      gene_id : "ENSG00000136939.1",
      gene_type : "protein_coding",
      gene_name : "OR1L4",
      gene_level : 2,
      hgnc_id : "HGNC:8216",
      havana_gene : "OTTHUMG00000020620.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122742303,
      stop : 122750783,
      direction : "+",
      ID : "ENSG00000171459.4",
      gene_id : "ENSG00000171459.4",
      gene_type : "protein_coding",
      gene_name : "OR1L6",
      gene_level : 2,
      hgnc_id : "HGNC:8218",
      havana_gene : "OTTHUMG00000020621.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122788933,
      stop : 122789895,
      direction : "+",
      ID : "ENSG00000148215.4",
      gene_id : "ENSG00000148215.4",
      gene_type : "protein_coding",
      gene_name : "OR5C1",
      gene_level : 2,
      hgnc_id : "HGNC:8331",
      havana_gene : "OTTHUMG00000020622.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122798389,
      stop : 122828588,
      direction : "-",
      ID : "ENSG00000136940.14",
      gene_id : "ENSG00000136940.14",
      gene_type : "protein_coding",
      gene_name : "PDCL",
      gene_level : 2,
      hgnc_id : "HGNC:8770",
      havana_gene : "OTTHUMG00000020624.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122800123,
      stop : 122801073,
      direction : "+",
      ID : "ENSG00000165204.3",
      gene_id : "ENSG00000165204.3",
      gene_type : "protein_coding",
      gene_name : "OR1K1",
      gene_level : 2,
      hgnc_id : "HGNC:8212",
      havana_gene : "OTTHUMG00000020625.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122844556,
      stop : 122905359,
      direction : "-",
      ID : "ENSG00000056586.16",
      gene_id : "ENSG00000056586.16",
      gene_type : "protein_coding",
      gene_name : "RC3H2",
      gene_level : 2,
      hgnc_id : "HGNC:21461",
      havana_gene : "OTTHUMG00000020632.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122908056,
      stop : 122913323,
      direction : "-",
      ID : "ENSG00000186130.5",
      gene_id : "ENSG00000186130.5",
      gene_type : "protein_coding",
      gene_name : "ZBTB6",
      gene_level : 2,
      hgnc_id : "HGNC:16764",
      havana_gene : "OTTHUMG00000020628.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122915566,
      stop : 122931512,
      direction : "-",
      ID : "ENSG00000171448.9",
      gene_id : "ENSG00000171448.9",
      gene_type : "protein_coding",
      gene_name : "ZBTB26",
      gene_level : 2,
      hgnc_id : "HGNC:23383",
      havana_gene : "OTTHUMG00000020627.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 122940833,
      stop : 123104866,
      direction : "+",
      ID : "ENSG00000011454.18",
      gene_id : "ENSG00000011454.18",
      gene_type : "protein_coding",
      gene_name : "RABGAP1",
      gene_level : 1,
      hgnc_id : "HGNC:17155",
      havana_gene : "OTTHUMG00000020633.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 123033667,
      stop : 123035665,
      direction : "+",
      ID : "ENSG00000188394.8",
      gene_id : "ENSG00000188394.8",
      gene_type : "protein_coding",
      gene_name : "GPR21",
      gene_level : 2,
      hgnc_id : "HGNC:4476",
      havana_gene : "OTTHUMG00000020631.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 123109500,
      stop : 123268586,
      direction : "-",
      ID : "ENSG00000165209.19",
      gene_id : "ENSG00000165209.19",
      gene_type : "protein_coding",
      gene_name : "STRBP",
      gene_level : 2,
      hgnc_id : "HGNC:16462",
      havana_gene : "OTTHUMG00000020636.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 123356170,
      stop : 123380324,
      direction : "+",
      ID : "ENSG00000148204.12",
      gene_id : "ENSG00000148204.12",
      gene_type : "protein_coding",
      gene_name : "CRB2",
      gene_level : 2,
      hgnc_id : "HGNC:18688",
      havana_gene : "OTTHUMG00000020638.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 123379654,
      stop : 123930152,
      direction : "-",
      ID : "ENSG00000119522.16",
      gene_id : "ENSG00000119522.16",
      gene_type : "protein_coding",
      gene_name : "DENND1A",
      gene_level : 2,
      hgnc_id : "HGNC:29324",
      havana_gene : "OTTHUMG00000020643.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124001670,
      stop : 124033301,
      direction : "+",
      ID : "ENSG00000106689.11",
      gene_id : "ENSG00000106689.11",
      gene_type : "protein_coding",
      gene_name : "LHX2",
      gene_level : 2,
      hgnc_id : "HGNC:6594",
      havana_gene : "OTTHUMG00000020647.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124257606,
      stop : 124353307,
      direction : "+",
      ID : "ENSG00000119408.17",
      gene_id : "ENSG00000119408.17",
      gene_type : "protein_coding",
      gene_name : "NEK6",
      gene_level : 2,
      hgnc_id : "HGNC:7749",
      havana_gene : "OTTHUMG00000020650.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124353465,
      stop : 124415444,
      direction : "-",
      ID : "ENSG00000136930.13",
      gene_id : "ENSG00000136930.13",
      gene_type : "protein_coding",
      gene_name : "PSMB7",
      gene_level : 2,
      hgnc_id : "HGNC:9544",
      havana_gene : "OTTHUMG00000021042.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124451425,
      stop : 124478589,
      direction : "+",
      ID : "ENSG00000180264.11",
      gene_id : "ENSG00000180264.11",
      gene_type : "protein_coding",
      gene_name : "ADGRD2",
      gene_level : 2,
      hgnc_id : "HGNC:18651",
      havana_gene : "OTTHUMG00000020652.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124481236,
      stop : 124507420,
      direction : "-",
      ID : "ENSG00000136931.10",
      gene_id : "ENSG00000136931.10",
      gene_type : "protein_coding",
      gene_name : "NR5A1",
      gene_level : 2,
      hgnc_id : "HGNC:7983",
      havana_gene : "OTTHUMG00000020655.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124517275,
      stop : 124771311,
      direction : "-",
      ID : "ENSG00000148200.17",
      gene_id : "ENSG00000148200.17",
      gene_type : "protein_coding",
      gene_name : "NR6A1",
      gene_level : 2,
      hgnc_id : "HGNC:7985",
      havana_gene : "OTTHUMG00000020661.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124777133,
      stop : 124814885,
      direction : "+",
      ID : "ENSG00000185585.20",
      gene_id : "ENSG00000185585.20",
      gene_type : "protein_coding",
      gene_name : "OLFML2A",
      gene_level : 2,
      hgnc_id : "HGNC:27270",
      havana_gene : "OTTHUMG00000020663.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124853417,
      stop : 124857890,
      direction : "+",
      ID : "ENSG00000136918.8",
      gene_id : "ENSG00000136918.8",
      gene_type : "protein_coding",
      gene_name : "WDR38",
      gene_level : 2,
      hgnc_id : "HGNC:23745",
      havana_gene : "OTTHUMG00000020664.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124857880,
      stop : 124861981,
      direction : "-",
      ID : "ENSG00000136942.15",
      gene_id : "ENSG00000136942.15",
      gene_type : "protein_coding",
      gene_name : "RPL35",
      gene_level : 2,
      hgnc_id : "HGNC:10344",
      havana_gene : "OTTHUMG00000020659.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124862130,
      stop : 124877733,
      direction : "+",
      ID : "ENSG00000136950.13",
      gene_id : "ENSG00000136950.13",
      gene_type : "protein_coding",
      gene_name : "ARPC5L",
      gene_level : 2,
      hgnc_id : "HGNC:23366",
      havana_gene : "OTTHUMG00000020660.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124878275,
      stop : 124948492,
      direction : "-",
      ID : "ENSG00000136935.14",
      gene_id : "ENSG00000136935.14",
      gene_type : "protein_coding",
      gene_name : "GOLGA1",
      gene_level : 2,
      hgnc_id : "HGNC:4424",
      havana_gene : "OTTHUMG00000020665.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 124942608,
      stop : 125143528,
      direction : "-",
      ID : "ENSG00000173611.18",
      gene_id : "ENSG00000173611.18",
      gene_type : "protein_coding",
      gene_name : "SCAI",
      gene_level : 2,
      hgnc_id : "HGNC:26709",
      havana_gene : "OTTHUMG00000020667.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 125146573,
      stop : 125189939,
      direction : "-",
      ID : "ENSG00000119414.12",
      gene_id : "ENSG00000119414.12",
      gene_type : "protein_coding",
      gene_name : "PPP6C",
      gene_level : 2,
      hgnc_id : "HGNC:9323",
      havana_gene : "OTTHUMG00000020671.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 125200542,
      stop : 125234161,
      direction : "+",
      ID : "ENSG00000136933.17",
      gene_id : "ENSG00000136933.17",
      gene_type : "protein_coding",
      gene_name : "RABEPK",
      gene_level : 2,
      hgnc_id : "HGNC:16896",
      havana_gene : "OTTHUMG00000020674.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 125234853,
      stop : 125241382,
      direction : "-",
      ID : "ENSG00000044574.9",
      gene_id : "ENSG00000044574.9",
      gene_type : "protein_coding",
      gene_name : "HSPA5",
      gene_level : 2,
      hgnc_id : "HGNC:5238",
      havana_gene : "OTTHUMG00000020672.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 125261794,
      stop : 125367207,
      direction : "+",
      ID : "ENSG00000165219.22",
      gene_id : "ENSG00000165219.22",
      gene_type : "protein_coding",
      gene_name : "GAPVD1",
      gene_level : 1,
      hgnc_id : "HGNC:23375",
      havana_gene : "OTTHUMG00000020678.10",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 125437393,
      stop : 125707234,
      direction : "-",
      ID : "ENSG00000119487.17",
      gene_id : "ENSG00000119487.17",
      gene_type : "protein_coding",
      gene_name : "MAPKAP1",
      gene_level : 1,
      hgnc_id : "HGNC:18752",
      havana_gene : "OTTHUMG00000020683.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 125747345,
      stop : 125967377,
      direction : "+",
      ID : "ENSG00000167081.18",
      gene_id : "ENSG00000167081.18",
      gene_type : "protein_coding",
      gene_name : "PBX3",
      gene_level : 2,
      hgnc_id : "HGNC:8634",
      havana_gene : "OTTHUMG00000020684.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 126326829,
      stop : 126507041,
      direction : "+",
      ID : "ENSG00000196814.15",
      gene_id : "ENSG00000196814.15",
      gene_type : "protein_coding",
      gene_name : "MVB12B",
      gene_level : 2,
      hgnc_id : "HGNC:23368",
      havana_gene : "OTTHUMG00000020687.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 126613928,
      stop : 126701032,
      direction : "+",
      ID : "ENSG00000136944.19",
      gene_id : "ENSG00000136944.19",
      gene_type : "protein_coding",
      gene_name : "LMX1B",
      gene_level : 2,
      hgnc_id : "HGNC:6654",
      havana_gene : "OTTHUMG00000020692.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 126805006,
      stop : 126838210,
      direction : "+",
      ID : "ENSG00000169155.10",
      gene_id : "ENSG00000169155.10",
      gene_type : "protein_coding",
      gene_name : "ZBTB43",
      gene_level : 2,
      hgnc_id : "HGNC:17908",
      havana_gene : "OTTHUMG00000020693.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 126860665,
      stop : 126885878,
      direction : "+",
      ID : "ENSG00000177125.5",
      gene_id : "ENSG00000177125.5",
      gene_type : "protein_coding",
      gene_name : "ZBTB34",
      gene_level : 2,
      hgnc_id : "HGNC:31446",
      havana_gene : "OTTHUMG00000020694.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 126914774,
      stop : 127223166,
      direction : "+",
      ID : "ENSG00000136828.19",
      gene_id : "ENSG00000136828.19",
      gene_type : "protein_coding",
      gene_name : "RALGPS1",
      gene_level : 2,
      hgnc_id : "HGNC:16851",
      havana_gene : "OTTHUMG00000020696.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127087348,
      stop : 127122635,
      direction : "-",
      ID : "ENSG00000136859.10",
      gene_id : "ENSG00000136859.10",
      gene_type : "protein_coding",
      gene_name : "ANGPTL2",
      gene_level : 2,
      hgnc_id : "HGNC:490",
      havana_gene : "OTTHUMG00000020695.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127224265,
      stop : 127393660,
      direction : "+",
      ID : "ENSG00000136895.19",
      gene_id : "ENSG00000136895.19",
      gene_type : "protein_coding",
      gene_name : "GARNL3",
      gene_level : 1,
      hgnc_id : "HGNC:25425",
      havana_gene : "OTTHUMG00000020700.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127397138,
      stop : 127408424,
      direction : "+",
      ID : "ENSG00000136856.18",
      gene_id : "ENSG00000136856.18",
      gene_type : "protein_coding",
      gene_name : "SLC2A8",
      gene_level : 2,
      hgnc_id : "HGNC:13812",
      havana_gene : "OTTHUMG00000020702.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127424374,
      stop : 127445372,
      direction : "+",
      ID : "ENSG00000196152.10",
      gene_id : "ENSG00000196152.10",
      gene_type : "protein_coding",
      gene_name : "ZNF79",
      gene_level : 2,
      hgnc_id : "HGNC:13153",
      havana_gene : "OTTHUMG00000020703.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127447674,
      stop : 127451406,
      direction : "-",
      ID : "ENSG00000197958.13",
      gene_id : "ENSG00000197958.13",
      gene_type : "protein_coding",
      gene_name : "RPL12",
      gene_level : 2,
      hgnc_id : "HGNC:10302",
      havana_gene : "OTTHUMG00000020704.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127451489,
      stop : 127503499,
      direction : "+",
      ID : "ENSG00000148356.15",
      gene_id : "ENSG00000148356.15",
      gene_type : "protein_coding",
      gene_name : "LRSAM1",
      gene_level : 2,
      hgnc_id : "HGNC:25135",
      havana_gene : "OTTHUMG00000020701.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127505339,
      stop : 127578989,
      direction : "-",
      ID : "ENSG00000136830.12",
      gene_id : "ENSG00000136830.12",
      gene_type : "protein_coding",
      gene_name : "NIBAN2",
      gene_level : 2,
      hgnc_id : "HGNC:25282",
      havana_gene : "OTTHUMG00000020705.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127579370,
      stop : 127696027,
      direction : "+",
      ID : "ENSG00000136854.24",
      gene_id : "ENSG00000136854.24",
      gene_type : "protein_coding",
      gene_name : "STXBP1",
      gene_level : 1,
      hgnc_id : "HGNC:11444",
      havana_gene : "OTTHUMG00000020713.13",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127690348,
      stop : 127724873,
      direction : "-",
      ID : "ENSG00000187024.15",
      gene_id : "ENSG00000187024.15",
      gene_type : "protein_coding",
      gene_name : "PTRH1",
      gene_level : 1,
      hgnc_id : "HGNC:27039",
      havana_gene : "OTTHUMG00000020710.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127706988,
      stop : 127716002,
      direction : "+",
      ID : "ENSG00000160401.15",
      gene_id : "ENSG00000160401.15",
      gene_type : "protein_coding",
      gene_name : "CFAP157",
      gene_level : 2,
      hgnc_id : "HGNC:27843",
      havana_gene : "OTTHUMG00000020709.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127716079,
      stop : 127731590,
      direction : "+",
      ID : "ENSG00000167094.16",
      gene_id : "ENSG00000167094.16",
      gene_type : "protein_coding",
      gene_name : "TTC16",
      gene_level : 2,
      hgnc_id : "HGNC:26536",
      havana_gene : "OTTHUMG00000020711.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127731524,
      stop : 127735313,
      direction : "-",
      ID : "ENSG00000160404.18",
      gene_id : "ENSG00000160404.18",
      gene_type : "protein_coding",
      gene_name : "TOR2A",
      gene_level : 2,
      hgnc_id : "HGNC:11996",
      havana_gene : "OTTHUMG00000020706.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127738317,
      stop : 127778710,
      direction : "-",
      ID : "ENSG00000095370.20",
      gene_id : "ENSG00000095370.20",
      gene_type : "protein_coding",
      gene_name : "SH2D3C",
      gene_level : 2,
      hgnc_id : "HGNC:16884",
      havana_gene : "OTTHUMG00000020717.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127785679,
      stop : 127790792,
      direction : "+",
      ID : "ENSG00000136807.14",
      gene_id : "ENSG00000136807.14",
      gene_type : "protein_coding",
      gene_name : "CDK9",
      gene_level : 2,
      hgnc_id : "HGNC:1780",
      havana_gene : "OTTHUMG00000020715.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127794597,
      stop : 127814327,
      direction : "+",
      ID : "ENSG00000136877.15",
      gene_id : "ENSG00000136877.15",
      gene_type : "protein_coding",
      gene_name : "FPGS",
      gene_level : 2,
      hgnc_id : "HGNC:3824",
      havana_gene : "OTTHUMG00000020716.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127815013,
      stop : 127854658,
      direction : "-",
      ID : "ENSG00000106991.14",
      gene_id : "ENSG00000106991.14",
      gene_type : "protein_coding",
      gene_name : "ENG",
      gene_level : 2,
      hgnc_id : "HGNC:3349",
      havana_gene : "OTTHUMG00000020723.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127866486,
      stop : 127877675,
      direction : "-",
      ID : "ENSG00000106992.19",
      gene_id : "ENSG00000106992.19",
      gene_type : "protein_coding",
      gene_name : "AK1",
      gene_level : 2,
      hgnc_id : "HGNC:361",
      havana_gene : "OTTHUMG00000020722.11",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127867850,
      stop : 127906022,
      direction : "-",
      ID : "ENSG00000257524.6",
      gene_id : "ENSG00000257524.6",
      gene_type : "protein_coding",
      gene_name : "AL157935.2",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000169436.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127885321,
      stop : 127905408,
      direction : "-",
      ID : "ENSG00000160408.15",
      gene_id : "ENSG00000160408.15",
      gene_type : "protein_coding",
      gene_name : "ST6GALNAC6",
      gene_level : 1,
      hgnc_id : "HGNC:23364",
      havana_gene : "OTTHUMG00000020718.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127907886,
      stop : 127917041,
      direction : "-",
      ID : "ENSG00000136840.19",
      gene_id : "ENSG00000136840.19",
      gene_type : "protein_coding",
      gene_name : "ST6GALNAC4",
      gene_level : 2,
      hgnc_id : "HGNC:17846",
      havana_gene : "OTTHUMG00000020724.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127920881,
      stop : 127930785,
      direction : "-",
      ID : "ENSG00000167103.12",
      gene_id : "ENSG00000167103.12",
      gene_type : "protein_coding",
      gene_name : "PIP5KL1",
      gene_level : 2,
      hgnc_id : "HGNC:28711",
      havana_gene : "OTTHUMG00000020719.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127935099,
      stop : 127937854,
      direction : "-",
      ID : "ENSG00000136908.18",
      gene_id : "ENSG00000136908.18",
      gene_type : "protein_coding",
      gene_name : "DPM2",
      gene_level : 2,
      hgnc_id : "HGNC:3006",
      havana_gene : "OTTHUMG00000020725.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 127940582,
      stop : 127980989,
      direction : "-",
      ID : "ENSG00000167106.12",
      gene_id : "ENSG00000167106.12",
      gene_type : "protein_coding",
      gene_name : "FAM102A",
      gene_level : 2,
      hgnc_id : "HGNC:31419",
      havana_gene : "OTTHUMG00000020720.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128061233,
      stop : 128068206,
      direction : "-",
      ID : "ENSG00000171169.9",
      gene_id : "ENSG00000171169.9",
      gene_type : "protein_coding",
      gene_name : "NAIF1",
      gene_level : 2,
      hgnc_id : "HGNC:25446",
      havana_gene : "OTTHUMG00000020727.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128068201,
      stop : 128109245,
      direction : "+",
      ID : "ENSG00000148339.12",
      gene_id : "ENSG00000148339.12",
      gene_type : "protein_coding",
      gene_name : "SLC25A25",
      gene_level : 1,
      hgnc_id : "HGNC:20663",
      havana_gene : "OTTHUMG00000020736.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128120693,
      stop : 128128462,
      direction : "-",
      ID : "ENSG00000148334.16",
      gene_id : "ENSG00000148334.16",
      gene_type : "protein_coding",
      gene_name : "PTGES2",
      gene_level : 1,
      hgnc_id : "HGNC:17822",
      havana_gene : "OTTHUMG00000020730.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128149071,
      stop : 128153453,
      direction : "+",
      ID : "ENSG00000148346.12",
      gene_id : "ENSG00000148346.12",
      gene_type : "protein_coding",
      gene_name : "LCN2",
      gene_level : 2,
      hgnc_id : "HGNC:6526",
      havana_gene : "OTTHUMG00000020734.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128160265,
      stop : 128163924,
      direction : "+",
      ID : "ENSG00000171159.5",
      gene_id : "ENSG00000171159.5",
      gene_type : "protein_coding",
      gene_name : "C9orf16",
      gene_level : 2,
      hgnc_id : "HGNC:17823",
      havana_gene : "OTTHUMG00000020731.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128161251,
      stop : 128204383,
      direction : "-",
      ID : "ENSG00000148337.21",
      gene_id : "ENSG00000148337.21",
      gene_type : "protein_coding",
      gene_name : "CIZ1",
      gene_level : 2,
      hgnc_id : "HGNC:16744",
      havana_gene : "OTTHUMG00000020735.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128191655,
      stop : 128255248,
      direction : "+",
      ID : "ENSG00000106976.21",
      gene_id : "ENSG00000106976.21",
      gene_type : "protein_coding",
      gene_name : "DNM1",
      gene_level : 2,
      hgnc_id : "HGNC:2972",
      havana_gene : "OTTHUMG00000020733.13",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128255829,
      stop : 128275995,
      direction : "-",
      ID : "ENSG00000167110.18",
      gene_id : "ENSG00000167110.18",
      gene_type : "protein_coding",
      gene_name : "GOLGA2",
      gene_level : 2,
      hgnc_id : "HGNC:4425",
      havana_gene : "OTTHUMG00000020732.11",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128275379,
      stop : 128316123,
      direction : "+",
      ID : "ENSG00000175854.14",
      gene_id : "ENSG00000175854.14",
      gene_type : "protein_coding",
      gene_name : "SWI5",
      gene_level : 2,
      hgnc_id : "HGNC:31412",
      havana_gene : "OTTHUMG00000020729.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128305159,
      stop : 128322447,
      direction : "-",
      ID : "ENSG00000167112.10",
      gene_id : "ENSG00000167112.10",
      gene_type : "protein_coding",
      gene_name : "TRUB2",
      gene_level : 2,
      hgnc_id : "HGNC:17170",
      havana_gene : "OTTHUMG00000020741.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128322544,
      stop : 128334072,
      direction : "+",
      ID : "ENSG00000167113.11",
      gene_id : "ENSG00000167113.11",
      gene_type : "protein_coding",
      gene_name : "COQ4",
      gene_level : 2,
      hgnc_id : "HGNC:19693",
      havana_gene : "OTTHUMG00000020743.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128340527,
      stop : 128361470,
      direction : "+",
      ID : "ENSG00000167114.13",
      gene_id : "ENSG00000167114.13",
      gene_type : "protein_coding",
      gene_name : "SLC27A4",
      gene_level : 2,
      hgnc_id : "HGNC:10998",
      havana_gene : "OTTHUMG00000020746.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128371361,
      stop : 128392016,
      direction : "+",
      ID : "ENSG00000167118.11",
      gene_id : "ENSG00000167118.11",
      gene_type : "protein_coding",
      gene_name : "URM1",
      gene_level : 2,
      hgnc_id : "HGNC:28378",
      havana_gene : "OTTHUMG00000020742.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128411751,
      stop : 128437351,
      direction : "+",
      ID : "ENSG00000167123.19",
      gene_id : "ENSG00000167123.19",
      gene_type : "protein_coding",
      gene_name : "CERCAM",
      gene_level : 2,
      hgnc_id : "HGNC:23723",
      havana_gene : "OTTHUMG00000020747.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128455186,
      stop : 128501292,
      direction : "+",
      ID : "ENSG00000136811.16",
      gene_id : "ENSG00000136811.16",
      gene_type : "protein_coding",
      gene_name : "ODF2",
      gene_level : 1,
      hgnc_id : "HGNC:8114",
      havana_gene : "OTTHUMG00000020748.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128504719,
      stop : 128542288,
      direction : "+",
      ID : "ENSG00000119392.15",
      gene_id : "ENSG00000119392.15",
      gene_type : "protein_coding",
      gene_name : "GLE1",
      gene_level : 2,
      hgnc_id : "HGNC:4315",
      havana_gene : "OTTHUMG00000020749.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128552558,
      stop : 128633662,
      direction : "+",
      ID : "ENSG00000197694.18",
      gene_id : "ENSG00000197694.18",
      gene_type : "protein_coding",
      gene_name : "SPTAN1",
      gene_level : 2,
      hgnc_id : "HGNC:11273",
      havana_gene : "OTTHUMG00000020754.14",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128633653,
      stop : 128656847,
      direction : "-",
      ID : "ENSG00000119333.12",
      gene_id : "ENSG00000119333.12",
      gene_type : "protein_coding",
      gene_name : "DYNC2I2",
      gene_level : 2,
      hgnc_id : "HGNC:28296",
      havana_gene : "OTTHUMG00000020750.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128683424,
      stop : 128696400,
      direction : "+",
      ID : "ENSG00000119335.17",
      gene_id : "ENSG00000119335.17",
      gene_type : "protein_coding",
      gene_name : "SET",
      gene_level : 2,
      hgnc_id : "HGNC:10760",
      havana_gene : "OTTHUMG00000020755.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128702503,
      stop : 128720916,
      direction : "+",
      ID : "ENSG00000160447.7",
      gene_id : "ENSG00000160447.7",
      gene_type : "protein_coding",
      gene_name : "PKN3",
      gene_level : 2,
      hgnc_id : "HGNC:17999",
      havana_gene : "OTTHUMG00000020757.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128720870,
      stop : 128724127,
      direction : "-",
      ID : "ENSG00000160446.19",
      gene_id : "ENSG00000160446.19",
      gene_type : "protein_coding",
      gene_name : "ZDHHC12",
      gene_level : 1,
      hgnc_id : "HGNC:19159",
      havana_gene : "OTTHUMG00000020756.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128729786,
      stop : 128772414,
      direction : "-",
      ID : "ENSG00000160445.11",
      gene_id : "ENSG00000160445.11",
      gene_type : "protein_coding",
      gene_name : "ZER1",
      gene_level : 2,
      hgnc_id : "HGNC:30960",
      havana_gene : "OTTHUMG00000020759.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128787253,
      stop : 128810430,
      direction : "+",
      ID : "ENSG00000107021.16",
      gene_id : "ENSG00000107021.16",
      gene_type : "protein_coding",
      gene_name : "TBC1D13",
      gene_level : 2,
      hgnc_id : "HGNC:25571",
      havana_gene : "OTTHUMG00000020760.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128818500,
      stop : 128822676,
      direction : "+",
      ID : "ENSG00000167136.7",
      gene_id : "ENSG00000167136.7",
      gene_type : "protein_coding",
      gene_name : "ENDOG",
      gene_level : 2,
      hgnc_id : "HGNC:3346",
      havana_gene : "OTTHUMG00000020763.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128819651,
      stop : 128829794,
      direction : "-",
      ID : "ENSG00000198917.13",
      gene_id : "ENSG00000198917.13",
      gene_type : "protein_coding",
      gene_name : "SPOUT1",
      gene_level : 1,
      hgnc_id : "HGNC:26933",
      havana_gene : "OTTHUMG00000020762.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128819663,
      stop : 128881931,
      direction : "-",
      ID : "ENSG00000286112.1",
      gene_id : "ENSG00000286112.1",
      gene_type : "protein_coding",
      gene_name : "AL441992.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193452.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128832942,
      stop : 128882494,
      direction : "-",
      ID : "ENSG00000171097.14",
      gene_id : "ENSG00000171097.14",
      gene_type : "protein_coding",
      gene_name : "KYAT1",
      gene_level : 2,
      hgnc_id : "HGNC:1564",
      havana_gene : "OTTHUMG00000020767.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128882133,
      stop : 128918039,
      direction : "+",
      ID : "ENSG00000136802.12",
      gene_id : "ENSG00000136802.12",
      gene_type : "protein_coding",
      gene_name : "LRRC8A",
      gene_level : 1,
      hgnc_id : "HGNC:19027",
      havana_gene : "OTTHUMG00000020766.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128920966,
      stop : 128942041,
      direction : "+",
      ID : "ENSG00000175287.19",
      gene_id : "ENSG00000175287.19",
      gene_type : "protein_coding",
      gene_name : "PHYHD1",
      gene_level : 2,
      hgnc_id : "HGNC:23396",
      havana_gene : "OTTHUMG00000020764.20",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128941478,
      stop : 128957021,
      direction : "+",
      ID : "ENSG00000251184.1",
      gene_id : "ENSG00000251184.1",
      gene_type : "protein_coding",
      gene_name : "AL672142.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000166431.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128945530,
      stop : 128947603,
      direction : "-",
      ID : "ENSG00000175283.8",
      gene_id : "ENSG00000175283.8",
      gene_type : "protein_coding",
      gene_name : "DOLK",
      gene_level : 2,
      hgnc_id : "HGNC:23406",
      havana_gene : "OTTHUMG00000020765.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 128947699,
      stop : 129007096,
      direction : "+",
      ID : "ENSG00000095319.14",
      gene_id : "ENSG00000095319.14",
      gene_type : "protein_coding",
      gene_name : "NUP188",
      gene_level : 2,
      hgnc_id : "HGNC:17859",
      havana_gene : "OTTHUMG00000020768.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129007036,
      stop : 129028331,
      direction : "-",
      ID : "ENSG00000148341.18",
      gene_id : "ENSG00000148341.18",
      gene_type : "protein_coding",
      gene_name : "SH3GLB2",
      gene_level : 2,
      hgnc_id : "HGNC:10834",
      havana_gene : "OTTHUMG00000020769.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129036621,
      stop : 129072082,
      direction : "+",
      ID : "ENSG00000148343.18",
      gene_id : "ENSG00000148343.18",
      gene_type : "protein_coding",
      gene_name : "MIGA2",
      gene_level : 2,
      hgnc_id : "HGNC:23621",
      havana_gene : "OTTHUMG00000020770.10",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129081111,
      stop : 129090438,
      direction : "+",
      ID : "ENSG00000167130.18",
      gene_id : "ENSG00000167130.18",
      gene_type : "protein_coding",
      gene_name : "DOLPP1",
      gene_level : 2,
      hgnc_id : "HGNC:29565",
      havana_gene : "OTTHUMG00000020771.9",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129094142,
      stop : 129111189,
      direction : "-",
      ID : "ENSG00000095321.18",
      gene_id : "ENSG00000095321.18",
      gene_type : "protein_coding",
      gene_name : "CRAT",
      gene_level : 1,
      hgnc_id : "HGNC:2342",
      havana_gene : "OTTHUMG00000147343.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129110950,
      stop : 129148946,
      direction : "+",
      ID : "ENSG00000119383.21",
      gene_id : "ENSG00000119383.21",
      gene_type : "protein_coding",
      gene_name : "PTPA",
      gene_level : 1,
      hgnc_id : "HGNC:9308",
      havana_gene : "OTTHUMG00000020774.22",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129139413,
      stop : 129260575,
      direction : "+",
      ID : "ENSG00000235007.3",
      gene_id : "ENSG00000235007.3",
      gene_type : "protein_coding",
      gene_name : "AL158151.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129175552,
      stop : 129178261,
      direction : "-",
      ID : "ENSG00000188483.8",
      gene_id : "ENSG00000188483.8",
      gene_type : "protein_coding",
      gene_name : "IER5L",
      gene_level : 2,
      hgnc_id : "HGNC:23679",
      havana_gene : "OTTHUMG00000020773.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129608884,
      stop : 129636135,
      direction : "+",
      ID : "ENSG00000148335.15",
      gene_id : "ENSG00000148335.15",
      gene_type : "protein_coding",
      gene_name : "NTMT1",
      gene_level : 2,
      hgnc_id : "HGNC:23373",
      havana_gene : "OTTHUMG00000020785.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129612225,
      stop : 129620776,
      direction : "-",
      ID : "ENSG00000179058.7",
      gene_id : "ENSG00000179058.7",
      gene_type : "protein_coding",
      gene_name : "C9orf50",
      gene_level : 2,
      hgnc_id : "HGNC:23677",
      havana_gene : "OTTHUMG00000020786.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129634604,
      stop : 129642169,
      direction : "-",
      ID : "ENSG00000148331.12",
      gene_id : "ENSG00000148331.12",
      gene_type : "protein_coding",
      gene_name : "ASB6",
      gene_level : 2,
      hgnc_id : "HGNC:17181",
      havana_gene : "OTTHUMG00000020787.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129665647,
      stop : 129722674,
      direction : "+",
      ID : "ENSG00000167157.11",
      gene_id : "ENSG00000167157.11",
      gene_type : "protein_coding",
      gene_name : "PRRX2",
      gene_level : 2,
      hgnc_id : "HGNC:21338",
      havana_gene : "OTTHUMG00000020790.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129738331,
      stop : 129753042,
      direction : "-",
      ID : "ENSG00000148344.11",
      gene_id : "ENSG00000148344.11",
      gene_type : "protein_coding",
      gene_name : "PTGES",
      gene_level : 2,
      hgnc_id : "HGNC:9599",
      havana_gene : "OTTHUMG00000020791.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129803157,
      stop : 129811281,
      direction : "+",
      ID : "ENSG00000136816.16",
      gene_id : "ENSG00000136816.16",
      gene_type : "protein_coding",
      gene_name : "TOR1B",
      gene_level : 2,
      hgnc_id : "HGNC:11995",
      havana_gene : "OTTHUMG00000020795.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129812942,
      stop : 129824244,
      direction : "-",
      ID : "ENSG00000136827.12",
      gene_id : "ENSG00000136827.12",
      gene_type : "protein_coding",
      gene_name : "TOR1A",
      gene_level : 2,
      hgnc_id : "HGNC:3098",
      havana_gene : "OTTHUMG00000020794.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129827290,
      stop : 129835863,
      direction : "-",
      ID : "ENSG00000136819.15",
      gene_id : "ENSG00000136819.15",
      gene_type : "protein_coding",
      gene_name : "C9orf78",
      gene_level : 2,
      hgnc_id : "HGNC:24932",
      havana_gene : "OTTHUMG00000020796.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129834698,
      stop : 129881828,
      direction : "+",
      ID : "ENSG00000136878.14",
      gene_id : "ENSG00000136878.14",
      gene_type : "protein_coding",
      gene_name : "USP20",
      gene_level : 2,
      hgnc_id : "HGNC:12619",
      havana_gene : "OTTHUMG00000020793.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 129887187,
      stop : 130043194,
      direction : "-",
      ID : "ENSG00000187239.17",
      gene_id : "ENSG00000187239.17",
      gene_type : "protein_coding",
      gene_name : "FNBP1",
      gene_level : 1,
      hgnc_id : "HGNC:17069",
      havana_gene : "OTTHUMG00000020800.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130053426,
      stop : 130140169,
      direction : "+",
      ID : "ENSG00000148358.20",
      gene_id : "ENSG00000148358.20",
      gene_type : "protein_coding",
      gene_name : "GPR107",
      gene_level : 2,
      hgnc_id : "HGNC:17830",
      havana_gene : "OTTHUMG00000020804.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130172404,
      stop : 130237303,
      direction : "+",
      ID : "ENSG00000107130.10",
      gene_id : "ENSG00000107130.10",
      gene_type : "protein_coding",
      gene_name : "NCS1",
      gene_level : 2,
      hgnc_id : "HGNC:3953",
      havana_gene : "OTTHUMG00000020801.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130265882,
      stop : 130434123,
      direction : "+",
      ID : "ENSG00000148357.16",
      gene_id : "ENSG00000148357.16",
      gene_type : "protein_coding",
      gene_name : "HMCN2",
      gene_level : 1,
      hgnc_id : "HGNC:21293",
      havana_gene : "OTTHUMG00000140096.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130444961,
      stop : 130501274,
      direction : "+",
      ID : "ENSG00000130707.18",
      gene_id : "ENSG00000130707.18",
      gene_type : "protein_coding",
      gene_name : "ASS1",
      gene_level : 2,
      hgnc_id : "HGNC:758",
      havana_gene : "OTTHUMG00000020806.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130578965,
      stop : 130638352,
      direction : "+",
      ID : "ENSG00000107164.16",
      gene_id : "ENSG00000107164.16",
      gene_type : "protein_coding",
      gene_name : "FUBP3",
      gene_level : 2,
      hgnc_id : "HGNC:4005",
      havana_gene : "OTTHUMG00000020809.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130664594,
      stop : 130682986,
      direction : "+",
      ID : "ENSG00000130711.5",
      gene_id : "ENSG00000130711.5",
      gene_type : "protein_coding",
      gene_name : "PRDM12",
      gene_level : 2,
      hgnc_id : "HGNC:13997",
      havana_gene : "OTTHUMG00000020808.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130693721,
      stop : 130704894,
      direction : "+",
      ID : "ENSG00000130713.16",
      gene_id : "ENSG00000130713.16",
      gene_type : "protein_coding",
      gene_name : "EXOSC2",
      gene_level : 2,
      hgnc_id : "HGNC:17097",
      havana_gene : "OTTHUMG00000020811.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130713016,
      stop : 130887675,
      direction : "+",
      ID : "ENSG00000097007.19",
      gene_id : "ENSG00000097007.19",
      gene_type : "protein_coding",
      gene_name : "ABL1",
      gene_level : 2,
      hgnc_id : "HGNC:76",
      havana_gene : "OTTHUMG00000020813.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130713626,
      stop : 130713724,
      direction : "+",
      ID : "ENSG00000288570.1",
      gene_id : "ENSG00000288570.1",
      gene_type : "protein_coding",
      gene_name : "AL359092.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000195921.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130892707,
      stop : 130896812,
      direction : "-",
      ID : "ENSG00000188710.3",
      gene_id : "ENSG00000188710.3",
      gene_type : "protein_coding",
      gene_name : "QRFP",
      gene_level : 2,
      hgnc_id : "HGNC:29982",
      havana_gene : "OTTHUMG00000131663.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 130902438,
      stop : 130939286,
      direction : "-",
      ID : "ENSG00000130720.13",
      gene_id : "ENSG00000130720.13",
      gene_type : "protein_coding",
      gene_name : "FIBCD1",
      gene_level : 1,
      hgnc_id : "HGNC:25922",
      havana_gene : "OTTHUMG00000020814.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131009174,
      stop : 131094473,
      direction : "+",
      ID : "ENSG00000050555.19",
      gene_id : "ENSG00000050555.19",
      gene_type : "protein_coding",
      gene_name : "LAMC3",
      gene_level : 2,
      hgnc_id : "HGNC:6494",
      havana_gene : "OTTHUMG00000020819.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131096476,
      stop : 131123152,
      direction : "+",
      ID : "ENSG00000126878.13",
      gene_id : "ENSG00000126878.13",
      gene_type : "protein_coding",
      gene_name : "AIF1L",
      gene_level : 1,
      hgnc_id : "HGNC:28904",
      havana_gene : "OTTHUMG00000020817.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131125586,
      stop : 131234663,
      direction : "+",
      ID : "ENSG00000126883.17",
      gene_id : "ENSG00000126883.17",
      gene_type : "protein_coding",
      gene_name : "NUP214",
      gene_level : 1,
      hgnc_id : "HGNC:8064",
      havana_gene : "OTTHUMG00000020816.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131258076,
      stop : 131276510,
      direction : "-",
      ID : "ENSG00000126882.13",
      gene_id : "ENSG00000126882.13",
      gene_type : "protein_coding",
      gene_name : "FAM78A",
      gene_level : 2,
      hgnc_id : "HGNC:25465",
      havana_gene : "OTTHUMG00000020821.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131289459,
      stop : 131359022,
      direction : "+",
      ID : "ENSG00000160539.6",
      gene_id : "ENSG00000160539.6",
      gene_type : "protein_coding",
      gene_name : "PLPP7",
      gene_level : 2,
      hgnc_id : "HGNC:28174",
      havana_gene : "OTTHUMG00000020822.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131502789,
      stop : 131523806,
      direction : "+",
      ID : "ENSG00000130714.18",
      gene_id : "ENSG00000130714.18",
      gene_type : "protein_coding",
      gene_name : "POMT1",
      gene_level : 2,
      hgnc_id : "HGNC:9202",
      havana_gene : "OTTHUMG00000020826.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131523801,
      stop : 131531264,
      direction : "-",
      ID : "ENSG00000130717.13",
      gene_id : "ENSG00000130717.13",
      gene_type : "protein_coding",
      gene_name : "UCK1",
      gene_level : 2,
      hgnc_id : "HGNC:14859",
      havana_gene : "OTTHUMG00000020823.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131545514,
      stop : 131558620,
      direction : "+",
      ID : "ENSG00000283526.1",
      gene_id : "ENSG00000283526.1",
      gene_type : "protein_coding",
      gene_name : "PRRT1B",
      gene_level : 2,
      hgnc_id : "HGNC:53642",
      havana_gene : "OTTHUMG00000191656.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131576770,
      stop : 131740074,
      direction : "-",
      ID : "ENSG00000107263.18",
      gene_id : "ENSG00000107263.18",
      gene_type : "protein_coding",
      gene_name : "RAPGEF1",
      gene_level : 2,
      hgnc_id : "HGNC:4568",
      havana_gene : "OTTHUMG00000020829.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 131852928,
      stop : 132079867,
      direction : "-",
      ID : "ENSG00000160563.14",
      gene_id : "ENSG00000160563.14",
      gene_type : "protein_coding",
      gene_name : "MED27",
      gene_level : 2,
      hgnc_id : "HGNC:2377",
      havana_gene : "OTTHUMG00000020833.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132161676,
      stop : 132244526,
      direction : "+",
      ID : "ENSG00000196358.11",
      gene_id : "ENSG00000196358.11",
      gene_type : "protein_coding",
      gene_name : "NTNG2",
      gene_level : 2,
      hgnc_id : "HGNC:14288",
      havana_gene : "OTTHUMG00000020835.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132261356,
      stop : 132354986,
      direction : "-",
      ID : "ENSG00000107290.14",
      gene_id : "ENSG00000107290.14",
      gene_type : "protein_coding",
      gene_name : "SETX",
      gene_level : 2,
      hgnc_id : "HGNC:445",
      havana_gene : "OTTHUMG00000020834.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132375548,
      stop : 132406851,
      direction : "-",
      ID : "ENSG00000125482.13",
      gene_id : "ENSG00000125482.13",
      gene_type : "protein_coding",
      gene_name : "TTF1",
      gene_level : 2,
      hgnc_id : "HGNC:12397",
      havana_gene : "OTTHUMG00000020836.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132410043,
      stop : 132573319,
      direction : "+",
      ID : "ENSG00000188523.9",
      gene_id : "ENSG00000188523.9",
      gene_type : "protein_coding",
      gene_name : "CFAP77",
      gene_level : 1,
      hgnc_id : "HGNC:33776",
      havana_gene : "OTTHUMG00000131684.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132582606,
      stop : 132590252,
      direction : "+",
      ID : "ENSG00000125492.10",
      gene_id : "ENSG00000125492.10",
      gene_type : "protein_coding",
      gene_name : "BARHL1",
      gene_level : 2,
      hgnc_id : "HGNC:953",
      havana_gene : "OTTHUMG00000020839.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132592997,
      stop : 132670401,
      direction : "-",
      ID : "ENSG00000125485.17",
      gene_id : "ENSG00000125485.17",
      gene_type : "protein_coding",
      gene_name : "DDX31",
      gene_level : 2,
      hgnc_id : "HGNC:16715",
      havana_gene : "OTTHUMG00000020843.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132670035,
      stop : 132694953,
      direction : "+",
      ID : "ENSG00000125484.12",
      gene_id : "ENSG00000125484.12",
      gene_type : "protein_coding",
      gene_name : "GTF3C4",
      gene_level : 2,
      hgnc_id : "HGNC:4667",
      havana_gene : "OTTHUMG00000020842.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132725578,
      stop : 132878777,
      direction : "-",
      ID : "ENSG00000165695.10",
      gene_id : "ENSG00000165695.10",
      gene_type : "protein_coding",
      gene_name : "AK8",
      gene_level : 2,
      hgnc_id : "HGNC:26526",
      havana_gene : "OTTHUMG00000021009.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132878027,
      stop : 132890201,
      direction : "+",
      ID : "ENSG00000165698.16",
      gene_id : "ENSG00000165698.16",
      gene_type : "protein_coding",
      gene_name : "SPACA9",
      gene_level : 2,
      hgnc_id : "HGNC:1367",
      havana_gene : "OTTHUMG00000020847.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132891348,
      stop : 132946874,
      direction : "-",
      ID : "ENSG00000165699.15",
      gene_id : "ENSG00000165699.15",
      gene_type : "protein_coding",
      gene_name : "TSC1",
      gene_level : 2,
      hgnc_id : "HGNC:12362",
      havana_gene : "OTTHUMG00000020844.14",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 132944000,
      stop : 132991687,
      direction : "+",
      ID : "ENSG00000165702.15",
      gene_id : "ENSG00000165702.15",
      gene_type : "protein_coding",
      gene_name : "GFI1B",
      gene_level : 2,
      hgnc_id : "HGNC:4238",
      havana_gene : "OTTHUMG00000020848.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133030675,
      stop : 133058503,
      direction : "+",
      ID : "ENSG00000148308.18",
      gene_id : "ENSG00000148308.18",
      gene_type : "protein_coding",
      gene_name : "GTF3C5",
      gene_level : 2,
      hgnc_id : "HGNC:4668",
      havana_gene : "OTTHUMG00000020856.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133061981,
      stop : 133071861,
      direction : "+",
      ID : "ENSG00000170835.17",
      gene_id : "ENSG00000170835.17",
      gene_type : "protein_coding",
      gene_name : "CEL",
      gene_level : 2,
      hgnc_id : "HGNC:1848",
      havana_gene : "OTTHUMG00000020855.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133097720,
      stop : 133149334,
      direction : "-",
      ID : "ENSG00000160271.16",
      gene_id : "ENSG00000160271.16",
      gene_type : "protein_coding",
      gene_name : "RALGDS",
      gene_level : 2,
      hgnc_id : "HGNC:9842",
      havana_gene : "OTTHUMG00000020858.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133098121,
      stop : 133163914,
      direction : "-",
      ID : "ENSG00000285245.1",
      gene_id : "ENSG00000285245.1",
      gene_type : "protein_coding",
      gene_name : "AL162417.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192407.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133152948,
      stop : 133163933,
      direction : "-",
      ID : "ENSG00000148288.13",
      gene_id : "ENSG00000148288.13",
      gene_type : "protein_coding",
      gene_name : "GBGT1",
      gene_level : 2,
      hgnc_id : "HGNC:20460",
      havana_gene : "OTTHUMG00000020853.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133205277,
      stop : 133209250,
      direction : "-",
      ID : "ENSG00000171102.14",
      gene_id : "ENSG00000171102.14",
      gene_type : "protein_coding",
      gene_name : "OBP2B",
      gene_level : 2,
      hgnc_id : "HGNC:23381",
      havana_gene : "OTTHUMG00000020860.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133233278,
      stop : 133276024,
      direction : "-",
      ID : "ENSG00000175164.16",
      gene_id : "ENSG00000175164.16",
      gene_type : "protein_coding",
      gene_name : "ABO",
      gene_level : 2,
      hgnc_id : "HGNC:79",
      havana_gene : "OTTHUMG00000020872.7",
      tag : "reference_genome_error"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133328776,
      stop : 133336188,
      direction : "-",
      ID : "ENSG00000148296.7",
      gene_id : "ENSG00000148296.7",
      gene_type : "protein_coding",
      gene_name : "SURF6",
      gene_level : 2,
      hgnc_id : "HGNC:11478",
      havana_gene : "OTTHUMG00000020871.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133338312,
      stop : 133348131,
      direction : "-",
      ID : "ENSG00000148297.16",
      gene_id : "ENSG00000148297.16",
      gene_type : "protein_coding",
      gene_name : "MED22",
      gene_level : 2,
      hgnc_id : "HGNC:11477",
      havana_gene : "OTTHUMG00000020869.12",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133348218,
      stop : 133351426,
      direction : "+",
      ID : "ENSG00000148303.17",
      gene_id : "ENSG00000148303.17",
      gene_type : "protein_coding",
      gene_name : "RPL7A",
      gene_level : 2,
      hgnc_id : "HGNC:10364",
      havana_gene : "OTTHUMG00000020864.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133351758,
      stop : 133356676,
      direction : "-",
      ID : "ENSG00000148290.10",
      gene_id : "ENSG00000148290.10",
      gene_type : "protein_coding",
      gene_name : "SURF1",
      gene_level : 2,
      hgnc_id : "HGNC:11474",
      havana_gene : "OTTHUMG00000020866.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133356550,
      stop : 133361158,
      direction : "+",
      ID : "ENSG00000148291.10",
      gene_id : "ENSG00000148291.10",
      gene_type : "protein_coding",
      gene_name : "SURF2",
      gene_level : 2,
      hgnc_id : "HGNC:11475",
      havana_gene : "OTTHUMG00000020867.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133361450,
      stop : 133376166,
      direction : "-",
      ID : "ENSG00000148248.14",
      gene_id : "ENSG00000148248.14",
      gene_type : "protein_coding",
      gene_name : "SURF4",
      gene_level : 2,
      hgnc_id : "HGNC:11476",
      havana_gene : "OTTHUMG00000020868.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133376366,
      stop : 133406096,
      direction : "+",
      ID : "ENSG00000198870.8",
      gene_id : "ENSG00000198870.8",
      gene_type : "protein_coding",
      gene_name : "STKLD1",
      gene_level : 2,
      hgnc_id : "HGNC:28669",
      havana_gene : "OTTHUMG00000020862.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133406059,
      stop : 133418096,
      direction : "-",
      ID : "ENSG00000148300.12",
      gene_id : "ENSG00000148300.12",
      gene_type : "protein_coding",
      gene_name : "REXO4",
      gene_level : 2,
      hgnc_id : "HGNC:12820",
      havana_gene : "OTTHUMG00000020870.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133414358,
      stop : 133459402,
      direction : "+",
      ID : "ENSG00000160323.19",
      gene_id : "ENSG00000160323.19",
      gene_type : "protein_coding",
      gene_name : "ADAMTS13",
      gene_level : 2,
      hgnc_id : "HGNC:1366",
      havana_gene : "OTTHUMG00000020876.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133459965,
      stop : 133470848,
      direction : "+",
      ID : "ENSG00000160325.15",
      gene_id : "ENSG00000160325.15",
      gene_type : "protein_coding",
      gene_name : "CACFD1",
      gene_level : 2,
      hgnc_id : "HGNC:1365",
      havana_gene : "OTTHUMG00000020875.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133471094,
      stop : 133479127,
      direction : "-",
      ID : "ENSG00000160326.14",
      gene_id : "ENSG00000160326.14",
      gene_type : "protein_coding",
      gene_name : "SLC2A6",
      gene_level : 2,
      hgnc_id : "HGNC:11011",
      havana_gene : "OTTHUMG00000020874.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133514586,
      stop : 133528612,
      direction : "-",
      ID : "ENSG00000187616.5",
      gene_id : "ENSG00000187616.5",
      gene_type : "protein_coding",
      gene_name : "MYMK",
      gene_level : 2,
      hgnc_id : "HGNC:33778",
      havana_gene : "OTTHUMG00000131685.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133532164,
      stop : 133575519,
      direction : "+",
      ID : "ENSG00000197859.11",
      gene_id : "ENSG00000197859.11",
      gene_type : "protein_coding",
      gene_name : "ADAMTSL2",
      gene_level : 2,
      hgnc_id : "HGNC:14631",
      havana_gene : "OTTHUMG00000131706.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133577081,
      stop : 133609389,
      direction : "-",
      ID : "ENSG00000196990.9",
      gene_id : "ENSG00000196990.9",
      gene_type : "protein_coding",
      gene_name : "FAM163B",
      gene_level : 2,
      hgnc_id : "HGNC:33277",
      havana_gene : "OTTHUMG00000159557.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133636363,
      stop : 133659329,
      direction : "+",
      ID : "ENSG00000123454.12",
      gene_id : "ENSG00000123454.12",
      gene_type : "protein_coding",
      gene_name : "DBH",
      gene_level : 1,
      hgnc_id : "HGNC:2689",
      havana_gene : "OTTHUMG00000020878.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133663560,
      stop : 133739955,
      direction : "-",
      ID : "ENSG00000123453.18",
      gene_id : "ENSG00000123453.18",
      gene_type : "protein_coding",
      gene_name : "SARDH",
      gene_level : 2,
      hgnc_id : "HGNC:10536",
      havana_gene : "OTTHUMG00000020879.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 133761894,
      stop : 133992604,
      direction : "-",
      ID : "ENSG00000160293.17",
      gene_id : "ENSG00000160293.17",
      gene_type : "protein_coding",
      gene_name : "VAV2",
      gene_level : 2,
      hgnc_id : "HGNC:12658",
      havana_gene : "OTTHUMG00000020882.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134025481,
      stop : 134034666,
      direction : "+",
      ID : "ENSG00000235106.10",
      gene_id : "ENSG00000235106.10",
      gene_type : "protein_coding",
      gene_name : "BRD3OS",
      gene_level : 2,
      hgnc_id : "HGNC:24742",
      havana_gene : "OTTHUMG00000020880.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134030305,
      stop : 134068535,
      direction : "-",
      ID : "ENSG00000169925.17",
      gene_id : "ENSG00000169925.17",
      gene_type : "protein_coding",
      gene_name : "BRD3",
      gene_level : 2,
      hgnc_id : "HGNC:1104",
      havana_gene : "OTTHUMG00000021004.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134135365,
      stop : 134159968,
      direction : "+",
      ID : "ENSG00000196363.10",
      gene_id : "ENSG00000196363.10",
      gene_type : "protein_coding",
      gene_name : "WDR5",
      gene_level : 2,
      hgnc_id : "HGNC:12757",
      havana_gene : "OTTHUMG00000131707.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134317098,
      stop : 134440585,
      direction : "+",
      ID : "ENSG00000186350.12",
      gene_id : "ENSG00000186350.12",
      gene_type : "protein_coding",
      gene_name : "RXRA",
      gene_level : 2,
      hgnc_id : "HGNC:10477",
      havana_gene : "OTTHUMG00000020887.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134641803,
      stop : 134844843,
      direction : "+",
      ID : "ENSG00000130635.16",
      gene_id : "ENSG00000130635.16",
      gene_type : "protein_coding",
      gene_name : "COL5A1",
      gene_level : 1,
      hgnc_id : "HGNC:2209",
      havana_gene : "OTTHUMG00000020891.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134880810,
      stop : 134887523,
      direction : "+",
      ID : "ENSG00000160339.16",
      gene_id : "ENSG00000160339.16",
      gene_type : "protein_coding",
      gene_name : "FCN2",
      gene_level : 2,
      hgnc_id : "HGNC:3624",
      havana_gene : "OTTHUMG00000020892.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 134903232,
      stop : 134917912,
      direction : "-",
      ID : "ENSG00000085265.11",
      gene_id : "ENSG00000085265.11",
      gene_type : "protein_coding",
      gene_name : "FCN1",
      gene_level : 2,
      hgnc_id : "HGNC:3623",
      havana_gene : "OTTHUMG00000020895.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135075422,
      stop : 135121180,
      direction : "+",
      ID : "ENSG00000130558.20",
      gene_id : "ENSG00000130558.20",
      gene_type : "protein_coding",
      gene_name : "OLFM1",
      gene_level : 1,
      hgnc_id : "HGNC:17187",
      havana_gene : "OTTHUMG00000020897.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135479079,
      stop : 135488893,
      direction : "+",
      ID : "ENSG00000196422.11",
      gene_id : "ENSG00000196422.11",
      gene_type : "protein_coding",
      gene_name : "PPP1R26",
      gene_level : 2,
      hgnc_id : "HGNC:29089",
      havana_gene : "OTTHUMG00000020904.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135495181,
      stop : 135501734,
      direction : "-",
      ID : "ENSG00000160345.13",
      gene_id : "ENSG00000160345.13",
      gene_type : "protein_coding",
      gene_name : "C9orf116",
      gene_level : 2,
      hgnc_id : "HGNC:28435",
      havana_gene : "OTTHUMG00000020902.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135499984,
      stop : 135504673,
      direction : "+",
      ID : "ENSG00000122140.11",
      gene_id : "ENSG00000122140.11",
      gene_type : "protein_coding",
      gene_name : "MRPS2",
      gene_level : 2,
      hgnc_id : "HGNC:14495",
      havana_gene : "OTTHUMG00000020910.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135521438,
      stop : 135526540,
      direction : "+",
      ID : "ENSG00000160349.10",
      gene_id : "ENSG00000160349.10",
      gene_type : "protein_coding",
      gene_name : "LCN1",
      gene_level : 2,
      hgnc_id : "HGNC:6525",
      havana_gene : "OTTHUMG00000020908.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135546126,
      stop : 135549969,
      direction : "+",
      ID : "ENSG00000122136.14",
      gene_id : "ENSG00000122136.14",
      gene_type : "protein_coding",
      gene_name : "OBP2A",
      gene_level : 2,
      hgnc_id : "HGNC:23380",
      havana_gene : "OTTHUMG00000020909.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135561756,
      stop : 135566955,
      direction : "+",
      ID : "ENSG00000122133.17",
      gene_id : "ENSG00000122133.17",
      gene_type : "protein_coding",
      gene_name : "PAEP",
      gene_level : 2,
      hgnc_id : "HGNC:8573",
      havana_gene : "OTTHUMG00000020914.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135604345,
      stop : 135619893,
      direction : "+",
      ID : "ENSG00000236543.3",
      gene_id : "ENSG00000236543.3",
      gene_type : "protein_coding",
      gene_name : "AL354761.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000153545.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135623648,
      stop : 135639540,
      direction : "-",
      ID : "ENSG00000204007.7",
      gene_id : "ENSG00000204007.7",
      gene_type : "protein_coding",
      gene_name : "GLT6D1",
      gene_level : 2,
      hgnc_id : "HGNC:23671",
      havana_gene : "OTTHUMG00000020911.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135663322,
      stop : 135666422,
      direction : "+",
      ID : "ENSG00000148386.9",
      gene_id : "ENSG00000148386.9",
      gene_type : "protein_coding",
      gene_name : "LCN9",
      gene_level : 2,
      hgnc_id : "HGNC:17442",
      havana_gene : "OTTHUMG00000020916.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135693407,
      stop : 135704498,
      direction : "-",
      ID : "ENSG00000165643.11",
      gene_id : "ENSG00000165643.11",
      gene_type : "protein_coding",
      gene_name : "SOHLH1",
      gene_level : 2,
      hgnc_id : "HGNC:27845",
      havana_gene : "OTTHUMG00000020915.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135702185,
      stop : 135795508,
      direction : "+",
      ID : "ENSG00000107147.14",
      gene_id : "ENSG00000107147.14",
      gene_type : "protein_coding",
      gene_name : "KCNT1",
      gene_level : 1,
      hgnc_id : "HGNC:18865",
      havana_gene : "OTTHUMG00000020917.12",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135808487,
      stop : 135907546,
      direction : "-",
      ID : "ENSG00000130559.19",
      gene_id : "ENSG00000130559.19",
      gene_type : "protein_coding",
      gene_name : "CAMSAP1",
      gene_level : 2,
      hgnc_id : "HGNC:19946",
      havana_gene : "OTTHUMG00000020918.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 135932969,
      stop : 135961373,
      direction : "-",
      ID : "ENSG00000130560.9",
      gene_id : "ENSG00000130560.9",
      gene_type : "protein_coding",
      gene_name : "UBAC1",
      gene_level : 2,
      hgnc_id : "HGNC:30221",
      havana_gene : "OTTHUMG00000020920.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136006537,
      stop : 136095289,
      direction : "-",
      ID : "ENSG00000148411.8",
      gene_id : "ENSG00000148411.8",
      gene_type : "protein_coding",
      gene_name : "NACC2",
      gene_level : 2,
      hgnc_id : "HGNC:23846",
      havana_gene : "OTTHUMG00000020921.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136114581,
      stop : 136118875,
      direction : "-",
      ID : "ENSG00000238227.8",
      gene_id : "ENSG00000238227.8",
      gene_type : "protein_coding",
      gene_name : "TMEM250",
      gene_level : 1,
      hgnc_id : "HGNC:31009",
      havana_gene : "OTTHUMG00000020922.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136196250,
      stop : 136205128,
      direction : "-",
      ID : "ENSG00000107187.17",
      gene_id : "ENSG00000107187.17",
      gene_type : "protein_coding",
      gene_name : "LHX3",
      gene_level : 2,
      hgnc_id : "HGNC:6595",
      havana_gene : "OTTHUMG00000020924.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136206333,
      stop : 136245812,
      direction : "-",
      ID : "ENSG00000165661.17",
      gene_id : "ENSG00000165661.17",
      gene_type : "protein_coding",
      gene_name : "QSOX2",
      gene_level : 1,
      hgnc_id : "HGNC:30249",
      havana_gene : "OTTHUMG00000020923.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136249973,
      stop : 136306901,
      direction : "-",
      ID : "ENSG00000260220.7",
      gene_id : "ENSG00000260220.7",
      gene_type : "protein_coding",
      gene_name : "CCDC187",
      gene_level : 2,
      hgnc_id : "HGNC:30942",
      havana_gene : "OTTHUMG00000188591.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136327476,
      stop : 136359605,
      direction : "+",
      ID : "ENSG00000160360.13",
      gene_id : "ENSG00000160360.13",
      gene_type : "protein_coding",
      gene_name : "GPSM1",
      gene_level : 2,
      hgnc_id : "HGNC:17858",
      havana_gene : "OTTHUMG00000020930.8",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136359480,
      stop : 136363744,
      direction : "-",
      ID : "ENSG00000213221.5",
      gene_id : "ENSG00000213221.5",
      gene_type : "protein_coding",
      gene_name : "DNLZ",
      gene_level : 2,
      hgnc_id : "HGNC:33879",
      havana_gene : "OTTHUMG00000020931.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136361903,
      stop : 136373681,
      direction : "-",
      ID : "ENSG00000187796.15",
      gene_id : "ENSG00000187796.15",
      gene_type : "protein_coding",
      gene_name : "CARD9",
      gene_level : 2,
      hgnc_id : "HGNC:16391",
      havana_gene : "OTTHUMG00000020925.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136375577,
      stop : 136400168,
      direction : "-",
      ID : "ENSG00000165684.4",
      gene_id : "ENSG00000165684.4",
      gene_type : "protein_coding",
      gene_name : "SNAPC4",
      gene_level : 2,
      hgnc_id : "HGNC:11137",
      havana_gene : "OTTHUMG00000020929.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136401922,
      stop : 136410614,
      direction : "-",
      ID : "ENSG00000165689.17",
      gene_id : "ENSG00000165689.17",
      gene_type : "protein_coding",
      gene_name : "ENTR1",
      gene_level : 2,
      hgnc_id : "HGNC:10667",
      havana_gene : "OTTHUMG00000020928.14",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136410641,
      stop : 136423761,
      direction : "+",
      ID : "ENSG00000165688.12",
      gene_id : "ENSG00000165688.12",
      gene_type : "protein_coding",
      gene_name : "PMPCA",
      gene_level : 2,
      hgnc_id : "HGNC:18667",
      havana_gene : "OTTHUMG00000020926.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136428619,
      stop : 136439845,
      direction : "-",
      ID : "ENSG00000148384.14",
      gene_id : "ENSG00000148384.14",
      gene_type : "protein_coding",
      gene_name : "INPP5E",
      gene_level : 2,
      hgnc_id : "HGNC:21474",
      havana_gene : "OTTHUMG00000020927.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136440096,
      stop : 136483759,
      direction : "-",
      ID : "ENSG00000148396.18",
      gene_id : "ENSG00000148396.18",
      gene_type : "protein_coding",
      gene_name : "SEC16A",
      gene_level : 2,
      hgnc_id : "HGNC:29006",
      havana_gene : "OTTHUMG00000020932.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136494433,
      stop : 136546048,
      direction : "-",
      ID : "ENSG00000148400.13",
      gene_id : "ENSG00000148400.13",
      gene_type : "protein_coding",
      gene_name : "NOTCH1",
      gene_level : 2,
      hgnc_id : "HGNC:7881",
      havana_gene : "OTTHUMG00000020935.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136658856,
      stop : 136672678,
      direction : "+",
      ID : "ENSG00000172889.16",
      gene_id : "ENSG00000172889.16",
      gene_type : "protein_coding",
      gene_name : "EGFL7",
      gene_level : 1,
      hgnc_id : "HGNC:20594",
      havana_gene : "OTTHUMG00000020938.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136673143,
      stop : 136687457,
      direction : "-",
      ID : "ENSG00000169692.13",
      gene_id : "ENSG00000169692.13",
      gene_type : "protein_coding",
      gene_name : "AGPAT2",
      gene_level : 2,
      hgnc_id : "HGNC:325",
      havana_gene : "OTTHUMG00000020936.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136712572,
      stop : 136724742,
      direction : "+",
      ID : "ENSG00000165716.11",
      gene_id : "ENSG00000165716.11",
      gene_type : "protein_coding",
      gene_name : "DIPK1B",
      gene_level : 2,
      hgnc_id : "HGNC:28290",
      havana_gene : "OTTHUMG00000020940.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136738167,
      stop : 136743356,
      direction : "-",
      ID : "ENSG00000187922.14",
      gene_id : "ENSG00000187922.14",
      gene_type : "protein_coding",
      gene_name : "LCN10",
      gene_level : 2,
      hgnc_id : "HGNC:20892",
      havana_gene : "OTTHUMG00000150428.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136738167,
      stop : 136748453,
      direction : "-",
      ID : "ENSG00000204003.8",
      gene_id : "ENSG00000204003.8",
      gene_type : "protein_coding",
      gene_name : "AL355987.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000180116.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136744017,
      stop : 136748525,
      direction : "-",
      ID : "ENSG00000267206.6",
      gene_id : "ENSG00000267206.6",
      gene_type : "protein_coding",
      gene_name : "LCN6",
      gene_level : 2,
      hgnc_id : "HGNC:17337",
      havana_gene : "OTTHUMG00000020941.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136754386,
      stop : 136758543,
      direction : "-",
      ID : "ENSG00000204001.10",
      gene_id : "ENSG00000204001.10",
      gene_type : "protein_coding",
      gene_name : "LCN8",
      gene_level : 2,
      hgnc_id : "HGNC:27038",
      havana_gene : "OTTHUMG00000020942.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136759634,
      stop : 136766255,
      direction : "-",
      ID : "ENSG00000177984.7",
      gene_id : "ENSG00000177984.7",
      gene_type : "protein_coding",
      gene_name : "LCN15",
      gene_level : 2,
      hgnc_id : "HGNC:33777",
      havana_gene : "OTTHUMG00000020943.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136791344,
      stop : 136793317,
      direction : "+",
      ID : "ENSG00000244187.8",
      gene_id : "ENSG00000244187.8",
      gene_type : "protein_coding",
      gene_name : "TMEM141",
      gene_level : 2,
      hgnc_id : "HGNC:28211",
      havana_gene : "OTTHUMG00000020945.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136791379,
      stop : 136800595,
      direction : "+",
      ID : "ENSG00000272896.1",
      gene_id : "ENSG00000272896.1",
      gene_type : "protein_coding",
      gene_name : "AL355987.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000186332.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136796338,
      stop : 136807741,
      direction : "+",
      ID : "ENSG00000213213.14",
      gene_id : "ENSG00000213213.14",
      gene_type : "protein_coding",
      gene_name : "CCDC183",
      gene_level : 2,
      hgnc_id : "HGNC:28236",
      havana_gene : "OTTHUMG00000159445.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136807943,
      stop : 136841187,
      direction : "+",
      ID : "ENSG00000196642.19",
      gene_id : "ENSG00000196642.19",
      gene_type : "protein_coding",
      gene_name : "RABL6",
      gene_level : 2,
      hgnc_id : "HGNC:24703",
      havana_gene : "OTTHUMG00000020947.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136844415,
      stop : 136848801,
      direction : "+",
      ID : "ENSG00000232434.2",
      gene_id : "ENSG00000232434.2",
      gene_type : "protein_coding",
      gene_name : "AJM1",
      gene_level : 2,
      hgnc_id : "HGNC:37284",
      havana_gene : "OTTHUMG00000187258.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136848724,
      stop : 136851027,
      direction : "+",
      ID : "ENSG00000054148.18",
      gene_id : "ENSG00000054148.18",
      gene_type : "protein_coding",
      gene_name : "PHPT1",
      gene_level : 2,
      hgnc_id : "HGNC:30033",
      havana_gene : "OTTHUMG00000020950.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136850943,
      stop : 136860799,
      direction : "+",
      ID : "ENSG00000177943.14",
      gene_id : "ENSG00000177943.14",
      gene_type : "protein_coding",
      gene_name : "MAMDC4",
      gene_level : 2,
      hgnc_id : "HGNC:24083",
      havana_gene : "OTTHUMG00000020951.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136862119,
      stop : 136866308,
      direction : "-",
      ID : "ENSG00000107223.13",
      gene_id : "ENSG00000107223.13",
      gene_type : "protein_coding",
      gene_name : "EDF1",
      gene_level : 2,
      hgnc_id : "HGNC:3164",
      havana_gene : "OTTHUMG00000020948.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136881912,
      stop : 136926607,
      direction : "+",
      ID : "ENSG00000127191.18",
      gene_id : "ENSG00000127191.18",
      gene_type : "protein_coding",
      gene_name : "TRAF2",
      gene_level : 2,
      hgnc_id : "HGNC:12032",
      havana_gene : "OTTHUMG00000020952.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136940435,
      stop : 136944738,
      direction : "-",
      ID : "ENSG00000159069.14",
      gene_id : "ENSG00000159069.14",
      gene_type : "protein_coding",
      gene_name : "FBXW5",
      gene_level : 2,
      hgnc_id : "HGNC:13613",
      havana_gene : "OTTHUMG00000020967.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136945185,
      stop : 136946975,
      direction : "+",
      ID : "ENSG00000176919.13",
      gene_id : "ENSG00000176919.13",
      gene_type : "protein_coding",
      gene_name : "C8G",
      gene_level : 2,
      hgnc_id : "HGNC:1354",
      havana_gene : "OTTHUMG00000020955.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136949551,
      stop : 136955497,
      direction : "+",
      ID : "ENSG00000184925.12",
      gene_id : "ENSG00000184925.12",
      gene_type : "protein_coding",
      gene_name : "LCN12",
      gene_level : 2,
      hgnc_id : "HGNC:28733",
      havana_gene : "OTTHUMG00000020968.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136975092,
      stop : 136981742,
      direction : "+",
      ID : "ENSG00000107317.13",
      gene_id : "ENSG00000107317.13",
      gene_type : "protein_coding",
      gene_name : "PTGDS",
      gene_level : 2,
      hgnc_id : "HGNC:9592",
      havana_gene : "OTTHUMG00000020957.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136977518,
      stop : 136985435,
      direction : "+",
      ID : "ENSG00000284341.1",
      gene_id : "ENSG00000284341.1",
      gene_type : "protein_coding",
      gene_name : "AL807752.7",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000191930.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136981904,
      stop : 136986410,
      direction : "+",
      ID : "ENSG00000214402.7",
      gene_id : "ENSG00000214402.7",
      gene_type : "protein_coding",
      gene_name : "LCNL1",
      gene_level : 2,
      hgnc_id : "HGNC:34436",
      havana_gene : "OTTHUMG00000159546.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136992422,
      stop : 136993984,
      direction : "+",
      ID : "ENSG00000148362.11",
      gene_id : "ENSG00000148362.11",
      gene_type : "protein_coding",
      gene_name : "PAXX",
      gene_level : 2,
      hgnc_id : "HGNC:27849",
      havana_gene : "OTTHUMG00000020971.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 136994608,
      stop : 136996568,
      direction : "-",
      ID : "ENSG00000169583.13",
      gene_id : "ENSG00000169583.13",
      gene_type : "protein_coding",
      gene_name : "CLIC3",
      gene_level : 2,
      hgnc_id : "HGNC:2064",
      havana_gene : "OTTHUMG00000020954.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137007234,
      stop : 137028922,
      direction : "-",
      ID : "ENSG00000107331.17",
      gene_id : "ENSG00000107331.17",
      gene_type : "protein_coding",
      gene_name : "ABCA2",
      gene_level : 2,
      hgnc_id : "HGNC:32",
      havana_gene : "OTTHUMG00000020958.6",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137030174,
      stop : 137032088,
      direction : "-",
      ID : "ENSG00000180549.8",
      gene_id : "ENSG00000180549.8",
      gene_type : "protein_coding",
      gene_name : "FUT7",
      gene_level : 2,
      hgnc_id : "HGNC:4018",
      havana_gene : "OTTHUMG00000020964.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137031241,
      stop : 137040436,
      direction : "-",
      ID : "ENSG00000279073.3",
      gene_id : "ENSG00000279073.3",
      gene_type : "protein_coding",
      gene_name : "AL807752.6",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000189401.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137039463,
      stop : 137046179,
      direction : "-",
      ID : "ENSG00000107281.10",
      gene_id : "ENSG00000107281.10",
      gene_type : "protein_coding",
      gene_name : "NPDC1",
      gene_level : 2,
      hgnc_id : "HGNC:7899",
      havana_gene : "OTTHUMG00000020956.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137048107,
      stop : 137054061,
      direction : "-",
      ID : "ENSG00000054179.12",
      gene_id : "ENSG00000054179.12",
      gene_type : "protein_coding",
      gene_name : "ENTPD2",
      gene_level : 2,
      hgnc_id : "HGNC:3364",
      havana_gene : "OTTHUMG00000020953.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137062127,
      stop : 137070557,
      direction : "-",
      ID : "ENSG00000186193.9",
      gene_id : "ENSG00000186193.9",
      gene_type : "protein_coding",
      gene_name : "SAPCD2",
      gene_level : 2,
      hgnc_id : "HGNC:28055",
      havana_gene : "OTTHUMG00000020961.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137077517,
      stop : 137084539,
      direction : "+",
      ID : "ENSG00000197355.11",
      gene_id : "ENSG00000197355.11",
      gene_type : "protein_coding",
      gene_name : "UAP1L1",
      gene_level : 2,
      hgnc_id : "HGNC:28082",
      havana_gene : "OTTHUMG00000020962.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137086985,
      stop : 137109183,
      direction : "+",
      ID : "ENSG00000177239.15",
      gene_id : "ENSG00000177239.15",
      gene_type : "protein_coding",
      gene_name : "MAN1B1",
      gene_level : 1,
      hgnc_id : "HGNC:6823",
      havana_gene : "OTTHUMG00000020978.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137110546,
      stop : 137115177,
      direction : "-",
      ID : "ENSG00000176978.14",
      gene_id : "ENSG00000176978.14",
      gene_type : "protein_coding",
      gene_name : "DPP7",
      gene_level : 2,
      hgnc_id : "HGNC:14892",
      havana_gene : "OTTHUMG00000020977.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137139154,
      stop : 137168756,
      direction : "+",
      ID : "ENSG00000176884.16",
      gene_id : "ENSG00000176884.16",
      gene_type : "protein_coding",
      gene_name : "GRIN1",
      gene_level : 2,
      hgnc_id : "HGNC:4584",
      havana_gene : "OTTHUMG00000020976.7",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137168758,
      stop : 137170051,
      direction : "-",
      ID : "ENSG00000184709.7",
      gene_id : "ENSG00000184709.7",
      gene_type : "protein_coding",
      gene_name : "LRRC26",
      gene_level : 2,
      hgnc_id : "HGNC:31409",
      havana_gene : "OTTHUMG00000020980.1",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137168854,
      stop : 137171984,
      direction : "-",
      ID : "ENSG00000261793.1",
      gene_id : "ENSG00000261793.1",
      gene_type : "protein_coding",
      gene_name : "AL929554.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000176413.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137170858,
      stop : 137172056,
      direction : "-",
      ID : "ENSG00000185863.8",
      gene_id : "ENSG00000185863.8",
      gene_type : "protein_coding",
      gene_name : "TMEM210",
      gene_level : 2,
      hgnc_id : "HGNC:34059",
      havana_gene : "OTTHUMG00000020981.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137174784,
      stop : 137188560,
      direction : "-",
      ID : "ENSG00000176248.9",
      gene_id : "ENSG00000176248.9",
      gene_type : "protein_coding",
      gene_name : "ANAPC2",
      gene_level : 2,
      hgnc_id : "HGNC:19989",
      havana_gene : "OTTHUMG00000020983.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137188660,
      stop : 137190370,
      direction : "+",
      ID : "ENSG00000176101.12",
      gene_id : "ENSG00000176101.12",
      gene_type : "protein_coding",
      gene_name : "SSNA1",
      gene_level : 2,
      hgnc_id : "HGNC:11321",
      havana_gene : "OTTHUMG00000020982.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137191617,
      stop : 137204193,
      direction : "-",
      ID : "ENSG00000176058.13",
      gene_id : "ENSG00000176058.13",
      gene_type : "protein_coding",
      gene_name : "TPRN",
      gene_level : 2,
      hgnc_id : "HGNC:26894",
      havana_gene : "OTTHUMG00000020984.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137204082,
      stop : 137205648,
      direction : "-",
      ID : "ENSG00000187713.7",
      gene_id : "ENSG00000187713.7",
      gene_type : "protein_coding",
      gene_name : "TMEM203",
      gene_level : 2,
      hgnc_id : "HGNC:28217",
      havana_gene : "OTTHUMG00000020985.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137205685,
      stop : 137217009,
      direction : "+",
      ID : "ENSG00000188566.14",
      gene_id : "ENSG00000188566.14",
      gene_type : "protein_coding",
      gene_name : "NDOR1",
      gene_level : 2,
      hgnc_id : "HGNC:29838",
      havana_gene : "OTTHUMG00000020986.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137217452,
      stop : 137219361,
      direction : "+",
      ID : "ENSG00000284976.1",
      gene_id : "ENSG00000284976.1",
      gene_type : "protein_coding",
      gene_name : "BX255925.3",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000192535.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137220247,
      stop : 137221581,
      direction : "-",
      ID : "ENSG00000212864.3",
      gene_id : "ENSG00000212864.3",
      gene_type : "protein_coding",
      gene_name : "RNF208",
      gene_level : 2,
      hgnc_id : "HGNC:25420",
      havana_gene : "OTTHUMG00000131782.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137224635,
      stop : 137226315,
      direction : "+",
      ID : "ENSG00000197191.6",
      gene_id : "ENSG00000197191.6",
      gene_type : "protein_coding",
      gene_name : "CYSRT1",
      gene_level : 2,
      hgnc_id : "HGNC:30529",
      havana_gene : "OTTHUMG00000153383.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137227502,
      stop : 137229640,
      direction : "+",
      ID : "ENSG00000233198.4",
      gene_id : "ENSG00000233198.4",
      gene_type : "protein_coding",
      gene_name : "RNF224",
      gene_level : 2,
      hgnc_id : "HGNC:41912",
      havana_gene : "OTTHUMG00000187399.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137230757,
      stop : 137236555,
      direction : "+",
      ID : "ENSG00000198569.10",
      gene_id : "ENSG00000198569.10",
      gene_type : "protein_coding",
      gene_name : "SLC34A3",
      gene_level : 2,
      hgnc_id : "HGNC:20305",
      havana_gene : "OTTHUMG00000131780.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137241287,
      stop : 137243707,
      direction : "+",
      ID : "ENSG00000188229.6",
      gene_id : "ENSG00000188229.6",
      gene_type : "protein_coding",
      gene_name : "TUBB4B",
      gene_level : 2,
      hgnc_id : "HGNC:20771",
      havana_gene : "OTTHUMG00000131783.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137243584,
      stop : 137247770,
      direction : "-",
      ID : "ENSG00000188163.8",
      gene_id : "ENSG00000188163.8",
      gene_type : "protein_coding",
      gene_name : "FAM166A",
      gene_level : 2,
      hgnc_id : "HGNC:33818",
      havana_gene : "OTTHUMG00000159545.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137251261,
      stop : 137253483,
      direction : "+",
      ID : "ENSG00000197768.10",
      gene_id : "ENSG00000197768.10",
      gene_type : "protein_coding",
      gene_name : "STPG3",
      gene_level : 2,
      hgnc_id : "HGNC:37285",
      havana_gene : "OTTHUMG00000187404.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137255327,
      stop : 137273542,
      direction : "+",
      ID : "ENSG00000188986.9",
      gene_id : "ENSG00000188986.9",
      gene_type : "protein_coding",
      gene_name : "NELFB",
      gene_level : 2,
      hgnc_id : "HGNC:24324",
      havana_gene : "OTTHUMG00000131778.3",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137277726,
      stop : 137282641,
      direction : "+",
      ID : "ENSG00000198113.3",
      gene_id : "ENSG00000198113.3",
      gene_type : "protein_coding",
      gene_name : "TOR4A",
      gene_level : 2,
      hgnc_id : "HGNC:25981",
      havana_gene : "OTTHUMG00000131779.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137299631,
      stop : 137302271,
      direction : "-",
      ID : "ENSG00000198435.4",
      gene_id : "ENSG00000198435.4",
      gene_type : "protein_coding",
      gene_name : "NRARP",
      gene_level : 2,
      hgnc_id : "HGNC:33843",
      havana_gene : "OTTHUMG00000156150.2",
      tag : "retrogene"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137306896,
      stop : 137423211,
      direction : "-",
      ID : "ENSG00000187609.16",
      gene_id : "ENSG00000187609.16",
      gene_type : "protein_coding",
      gene_name : "EXD3",
      gene_level : 2,
      hgnc_id : "HGNC:26023",
      havana_gene : "OTTHUMG00000156149.4",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137423350,
      stop : 137434406,
      direction : "+",
      ID : "ENSG00000188747.8",
      gene_id : "ENSG00000188747.8",
      gene_type : "protein_coding",
      gene_name : "NOXA1",
      gene_level : 2,
      hgnc_id : "HGNC:10668",
      havana_gene : "OTTHUMG00000131781.1",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137434364,
      stop : 137441816,
      direction : "-",
      ID : "ENSG00000188833.10",
      gene_id : "ENSG00000188833.10",
      gene_type : "protein_coding",
      gene_name : "ENTPD8",
      gene_level : 2,
      hgnc_id : "HGNC:24860",
      havana_gene : "OTTHUMG00000131831.5",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137447570,
      stop : 137459334,
      direction : "-",
      ID : "ENSG00000165802.23",
      gene_id : "ENSG00000165802.23",
      gene_type : "protein_coding",
      gene_name : "NSMF",
      gene_level : 2,
      hgnc_id : "HGNC:29843",
      havana_gene : "OTTHUMG00000020989.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137459952,
      stop : 137550402,
      direction : "-",
      ID : "ENSG00000130653.16",
      gene_id : "ENSG00000130653.16",
      gene_type : "protein_coding",
      gene_name : "PNPLA7",
      gene_level : 2,
      hgnc_id : "HGNC:24768",
      havana_gene : "OTTHUMG00000020990.12",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137551879,
      stop : 137552555,
      direction : "+",
      ID : "ENSG00000182154.8",
      gene_id : "ENSG00000182154.8",
      gene_type : "protein_coding",
      gene_name : "MRPL41",
      gene_level : 2,
      hgnc_id : "HGNC:14492",
      havana_gene : "OTTHUMG00000020987.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137554444,
      stop : 137578925,
      direction : "-",
      ID : "ENSG00000148399.13",
      gene_id : "ENSG00000148399.13",
      gene_type : "protein_coding",
      gene_name : "DPH7",
      gene_level : 2,
      hgnc_id : "HGNC:25199",
      havana_gene : "OTTHUMG00000020991.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137582081,
      stop : 137590512,
      direction : "-",
      ID : "ENSG00000165724.6",
      gene_id : "ENSG00000165724.6",
      gene_type : "protein_coding",
      gene_name : "ZMYND19",
      gene_level : 2,
      hgnc_id : "HGNC:21146",
      havana_gene : "OTTHUMG00000020992.2",
      tag : null
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137605685,
      stop : 137615360,
      direction : "+",
      ID : "ENSG00000197070.14",
      gene_id : "ENSG00000197070.14",
      gene_type : "protein_coding",
      gene_name : "ARRDC1",
      gene_level : 2,
      hgnc_id : "HGNC:28633",
      havana_gene : "OTTHUMG00000020993.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137618992,
      stop : 137870016,
      direction : "+",
      ID : "ENSG00000181090.21",
      gene_id : "ENSG00000181090.21",
      gene_type : "protein_coding",
      gene_name : "EHMT1",
      gene_level : 1,
      hgnc_id : "HGNC:24650",
      havana_gene : "OTTHUMG00000020995.15",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : 9,
      annotation : "HAVANA",
      type : "gene",
      start : 137877782,
      stop : 138124624,
      direction : "+",
      ID : "ENSG00000148408.13",
      gene_id : "ENSG00000148408.13",
      gene_type : "protein_coding",
      gene_name : "CACNA1B",
      gene_level : 2,
      hgnc_id : "HGNC:1389",
      havana_gene : "OTTHUMG00000021002.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 276322,
      stop : 303356,
      direction : "+",
      ID : "ENSG00000182378.15",
      gene_id : "ENSG00000182378.15",
      gene_type : "protein_coding",
      gene_name : "PLCXD1",
      gene_level : 2,
      hgnc_id : "HGNC:23148",
      havana_gene : "OTTHUMG00000022693.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 304529,
      stop : 318819,
      direction : "-",
      ID : "ENSG00000178605.13",
      gene_id : "ENSG00000178605.13",
      gene_type : "protein_coding",
      gene_name : "GTPBP6",
      gene_level : 2,
      hgnc_id : "HGNC:30189",
      havana_gene : "OTTHUMG00000022694.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 333933,
      stop : 386955,
      direction : "-",
      ID : "ENSG00000167393.18",
      gene_id : "ENSG00000167393.18",
      gene_type : "protein_coding",
      gene_name : "PPP2R3B",
      gene_level : 2,
      hgnc_id : "HGNC:13417",
      havana_gene : "OTTHUMG00000021052.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 624344,
      stop : 659411,
      direction : "+",
      ID : "ENSG00000185960.14",
      gene_id : "ENSG00000185960.14",
      gene_type : "protein_coding",
      gene_name : "SHOX",
      gene_level : 2,
      hgnc_id : "HGNC:10853",
      havana_gene : "OTTHUMG00000021053.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1187549,
      stop : 1212723,
      direction : "-",
      ID : "ENSG00000205755.12",
      gene_id : "ENSG00000205755.12",
      gene_type : "protein_coding",
      gene_name : "CRLF2",
      gene_level : 2,
      hgnc_id : "HGNC:14281",
      havana_gene : "OTTHUMG00000067432.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1268800,
      stop : 1310381,
      direction : "+",
      ID : "ENSG00000198223.17",
      gene_id : "ENSG00000198223.17",
      gene_type : "protein_coding",
      gene_name : "CSF2RA",
      gene_level : 2,
      hgnc_id : "HGNC:2435",
      havana_gene : "OTTHUMG00000012533.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1336616,
      stop : 1382689,
      direction : "+",
      ID : "ENSG00000185291.12",
      gene_id : "ENSG00000185291.12",
      gene_type : "protein_coding",
      gene_name : "IL3RA",
      gene_level : 2,
      hgnc_id : "HGNC:6012",
      havana_gene : "OTTHUMG00000021059.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1386152,
      stop : 1392113,
      direction : "-",
      ID : "ENSG00000169100.14",
      gene_id : "ENSG00000169100.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A6",
      gene_level : 2,
      hgnc_id : "HGNC:10992",
      havana_gene : "OTTHUMG00000021058.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1403139,
      stop : 1453762,
      direction : "-",
      ID : "ENSG00000169093.16",
      gene_id : "ENSG00000169093.16",
      gene_type : "protein_coding",
      gene_name : "ASMTL",
      gene_level : 2,
      hgnc_id : "HGNC:751",
      havana_gene : "OTTHUMG00000021057.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1462581,
      stop : 1537185,
      direction : "-",
      ID : "ENSG00000182162.11",
      gene_id : "ENSG00000182162.11",
      gene_type : "protein_coding",
      gene_name : "P2RY8",
      gene_level : 2,
      hgnc_id : "HGNC:15524",
      havana_gene : "OTTHUMG00000021060.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1591604,
      stop : 1602520,
      direction : "+",
      ID : "ENSG00000197976.12",
      gene_id : "ENSG00000197976.12",
      gene_type : "protein_coding",
      gene_name : "AKAP17A",
      gene_level : 2,
      hgnc_id : "HGNC:18783",
      havana_gene : "OTTHUMG00000021063.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 1615059,
      stop : 1643081,
      direction : "+",
      ID : "ENSG00000196433.13",
      gene_id : "ENSG00000196433.13",
      gene_type : "protein_coding",
      gene_name : "ASMT",
      gene_level : 2,
      hgnc_id : "HGNC:750",
      havana_gene : "OTTHUMG00000021065.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2219506,
      stop : 2502805,
      direction : "-",
      ID : "ENSG00000169084.15",
      gene_id : "ENSG00000169084.15",
      gene_type : "protein_coding",
      gene_name : "DHRSX",
      gene_level : 2,
      hgnc_id : "HGNC:18399",
      havana_gene : "OTTHUMG00000021068.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2486414,
      stop : 2500976,
      direction : "-",
      ID : "ENSG00000214717.12",
      gene_id : "ENSG00000214717.12",
      gene_type : "protein_coding",
      gene_name : "ZBED1",
      gene_level : 2,
      hgnc_id : "HGNC:447",
      havana_gene : "OTTHUMG00000021069.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2691187,
      stop : 2741309,
      direction : "+",
      ID : "ENSG00000002586.20",
      gene_id : "ENSG00000002586.20",
      gene_type : "protein_coding",
      gene_name : "CD99",
      gene_level : 2,
      hgnc_id : "HGNC:7082",
      havana_gene : "OTTHUMG00000021073.12",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2752040,
      stop : 2816500,
      direction : "+",
      ID : "ENSG00000124343.14",
      gene_id : "ENSG00000124343.14",
      gene_type : "protein_coding",
      gene_name : "XG",
      gene_level : 2,
      hgnc_id : "HGNC:12806",
      havana_gene : "OTTHUMG00000021075.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2828822,
      stop : 2882820,
      direction : "+",
      ID : "ENSG00000056998.20",
      gene_id : "ENSG00000056998.20",
      gene_type : "protein_coding",
      gene_name : "GYG2",
      gene_level : 2,
      hgnc_id : "HGNC:4700",
      havana_gene : "OTTHUMG00000021079.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2903972,
      stop : 2929349,
      direction : "-",
      ID : "ENSG00000006756.16",
      gene_id : "ENSG00000006756.16",
      gene_type : "protein_coding",
      gene_name : "ARSD",
      gene_level : 1,
      hgnc_id : "HGNC:717",
      havana_gene : "OTTHUMG00000021077.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 2934521,
      stop : 2968475,
      direction : "-",
      ID : "ENSG00000157399.16",
      gene_id : "ENSG00000157399.16",
      gene_type : "protein_coding",
      gene_name : "ARSL",
      gene_level : 2,
      hgnc_id : "HGNC:719",
      havana_gene : "OTTHUMG00000137358.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 3006546,
      stop : 3034111,
      direction : "+",
      ID : "ENSG00000205667.3",
      gene_id : "ENSG00000205667.3",
      gene_type : "protein_coding",
      gene_name : "ARSH",
      gene_level : 2,
      hgnc_id : "HGNC:32488",
      havana_gene : "OTTHUMG00000159612.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 3041471,
      stop : 3112727,
      direction : "+",
      ID : "ENSG00000062096.15",
      gene_id : "ENSG00000062096.15",
      gene_type : "protein_coding",
      gene_name : "ARSF",
      gene_level : 2,
      hgnc_id : "HGNC:721",
      havana_gene : "OTTHUMG00000021081.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 3308565,
      stop : 3346652,
      direction : "-",
      ID : "ENSG00000101825.8",
      gene_id : "ENSG00000101825.8",
      gene_type : "protein_coding",
      gene_name : "MXRA5",
      gene_level : 2,
      hgnc_id : "HGNC:7539",
      havana_gene : "OTTHUMG00000021083.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 3604340,
      stop : 3713649,
      direction : "-",
      ID : "ENSG00000183943.6",
      gene_id : "ENSG00000183943.6",
      gene_type : "protein_coding",
      gene_name : "PRKX",
      gene_level : 2,
      hgnc_id : "HGNC:9441",
      havana_gene : "OTTHUMG00000021087.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 5840637,
      stop : 6228867,
      direction : "-",
      ID : "ENSG00000146938.16",
      gene_id : "ENSG00000146938.16",
      gene_type : "protein_coding",
      gene_name : "NLGN4X",
      gene_level : 2,
      hgnc_id : "HGNC:14287",
      havana_gene : "OTTHUMG00000021093.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 6533618,
      stop : 6535118,
      direction : "-",
      ID : "ENSG00000169059.12",
      gene_id : "ENSG00000169059.12",
      gene_type : "protein_coding",
      gene_name : "VCX3A",
      gene_level : 2,
      hgnc_id : "HGNC:18159",
      havana_gene : "OTTHUMG00000021097.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 6667865,
      stop : 7148158,
      direction : "-",
      ID : "ENSG00000130021.15",
      gene_id : "ENSG00000130021.15",
      gene_type : "protein_coding",
      gene_name : "PUDP",
      gene_level : 1,
      hgnc_id : "HGNC:16818",
      havana_gene : "OTTHUMG00000021101.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 7147237,
      stop : 7804358,
      direction : "+",
      ID : "ENSG00000101846.8",
      gene_id : "ENSG00000101846.8",
      gene_type : "protein_coding",
      gene_name : "STS",
      gene_level : 2,
      hgnc_id : "HGNC:11425",
      havana_gene : "OTTHUMG00000021102.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 7842262,
      stop : 7844143,
      direction : "+",
      ID : "ENSG00000182583.12",
      gene_id : "ENSG00000182583.12",
      gene_type : "protein_coding",
      gene_name : "VCX",
      gene_level : 2,
      hgnc_id : "HGNC:12667",
      havana_gene : "OTTHUMG00000028608.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 7898247,
      stop : 7927739,
      direction : "-",
      ID : "ENSG00000006757.12",
      gene_id : "ENSG00000006757.12",
      gene_type : "protein_coding",
      gene_name : "PNPLA4",
      gene_level : 2,
      hgnc_id : "HGNC:24887",
      havana_gene : "OTTHUMG00000021103.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 8169944,
      stop : 8171267,
      direction : "-",
      ID : "ENSG00000177504.10",
      gene_id : "ENSG00000177504.10",
      gene_type : "protein_coding",
      gene_name : "VCX2",
      gene_level : 2,
      hgnc_id : "HGNC:18158",
      havana_gene : "OTTHUMG00000021105.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 8464830,
      stop : 8466510,
      direction : "+",
      ID : "ENSG00000205642.10",
      gene_id : "ENSG00000205642.10",
      gene_type : "protein_coding",
      gene_name : "VCX3B",
      gene_level : 2,
      hgnc_id : "HGNC:31838",
      havana_gene : "OTTHUMG00000021106.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 8528874,
      stop : 8732137,
      direction : "-",
      ID : "ENSG00000011201.12",
      gene_id : "ENSG00000011201.12",
      gene_type : "protein_coding",
      gene_name : "ANOS1",
      gene_level : 2,
      hgnc_id : "HGNC:6211",
      havana_gene : "OTTHUMG00000021107.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 8790795,
      stop : 8801383,
      direction : "-",
      ID : "ENSG00000183304.10",
      gene_id : "ENSG00000183304.10",
      gene_type : "protein_coding",
      gene_name : "FAM9A",
      gene_level : 2,
      hgnc_id : "HGNC:18403",
      havana_gene : "OTTHUMG00000021110.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 9024232,
      stop : 9295682,
      direction : "-",
      ID : "ENSG00000177138.17",
      gene_id : "ENSG00000177138.17",
      gene_type : "protein_coding",
      gene_name : "FAM9B",
      gene_level : 2,
      hgnc_id : "HGNC:18404",
      havana_gene : "OTTHUMG00000021114.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 9463295,
      stop : 9741037,
      direction : "+",
      ID : "ENSG00000101849.17",
      gene_id : "ENSG00000101849.17",
      gene_type : "protein_coding",
      gene_name : "TBL1X",
      gene_level : 2,
      hgnc_id : "HGNC:11585",
      havana_gene : "OTTHUMG00000021117.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 9725346,
      stop : 9786297,
      direction : "-",
      ID : "ENSG00000101850.13",
      gene_id : "ENSG00000101850.13",
      gene_type : "protein_coding",
      gene_name : "GPR143",
      gene_level : 2,
      hgnc_id : "HGNC:20145",
      havana_gene : "OTTHUMG00000021118.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 9786429,
      stop : 9949443,
      direction : "+",
      ID : "ENSG00000146950.13",
      gene_id : "ENSG00000146950.13",
      gene_type : "protein_coding",
      gene_name : "SHROOM2",
      gene_level : 2,
      hgnc_id : "HGNC:630",
      havana_gene : "OTTHUMG00000021121.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 9967358,
      stop : 9968352,
      direction : "+",
      ID : "ENSG00000234469.4",
      gene_id : "ENSG00000234469.4",
      gene_type : "protein_coding",
      gene_name : "CLDN34",
      gene_level : 2,
      hgnc_id : "HGNC:51259",
      havana_gene : "OTTHUMG00000189259.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 10015254,
      stop : 10144474,
      direction : "+",
      ID : "ENSG00000047644.19",
      gene_id : "ENSG00000047644.19",
      gene_type : "protein_coding",
      gene_name : "WWC3",
      gene_level : 2,
      hgnc_id : "HGNC:29237",
      havana_gene : "OTTHUMG00000021123.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 10156975,
      stop : 10237660,
      direction : "+",
      ID : "ENSG00000073464.13",
      gene_id : "ENSG00000073464.13",
      gene_type : "protein_coding",
      gene_name : "CLCN4",
      gene_level : 2,
      hgnc_id : "HGNC:2022",
      havana_gene : "OTTHUMG00000021125.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 10445310,
      stop : 10833654,
      direction : "-",
      ID : "ENSG00000101871.16",
      gene_id : "ENSG00000101871.16",
      gene_type : "protein_coding",
      gene_name : "MID1",
      gene_level : 2,
      hgnc_id : "HGNC:7095",
      havana_gene : "OTTHUMG00000021127.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 11111301,
      stop : 11123086,
      direction : "+",
      ID : "ENSG00000004961.15",
      gene_id : "ENSG00000004961.15",
      gene_type : "protein_coding",
      gene_name : "HCCS",
      gene_level : 2,
      hgnc_id : "HGNC:4837",
      havana_gene : "OTTHUMG00000021128.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 11117651,
      stop : 11665920,
      direction : "-",
      ID : "ENSG00000047648.23",
      gene_id : "ENSG00000047648.23",
      gene_type : "protein_coding",
      gene_name : "ARHGAP6",
      gene_level : 2,
      hgnc_id : "HGNC:676",
      havana_gene : "OTTHUMG00000021134.7",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 11293413,
      stop : 11300761,
      direction : "+",
      ID : "ENSG00000125363.14",
      gene_id : "ENSG00000125363.14",
      gene_type : "protein_coding",
      gene_name : "AMELX",
      gene_level : 2,
      hgnc_id : "HGNC:461",
      havana_gene : "OTTHUMG00000021130.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 11758159,
      stop : 11775772,
      direction : "+",
      ID : "ENSG00000005302.19",
      gene_id : "ENSG00000005302.19",
      gene_type : "protein_coding",
      gene_name : "MSL3",
      gene_level : 2,
      hgnc_id : "HGNC:7370",
      havana_gene : "OTTHUMG00000021132.13",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 11822423,
      stop : 12724523,
      direction : "+",
      ID : "ENSG00000169933.16",
      gene_id : "ENSG00000169933.16",
      gene_type : "protein_coding",
      gene_name : "FRMPD4",
      gene_level : 2,
      hgnc_id : "HGNC:29007",
      havana_gene : "OTTHUMG00000021138.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 12791355,
      stop : 12824222,
      direction : "+",
      ID : "ENSG00000101911.13",
      gene_id : "ENSG00000101911.13",
      gene_type : "protein_coding",
      gene_name : "PRPS2",
      gene_level : 1,
      hgnc_id : "HGNC:9465",
      havana_gene : "OTTHUMG00000021139.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 12867072,
      stop : 12890361,
      direction : "+",
      ID : "ENSG00000196664.5",
      gene_id : "ENSG00000196664.5",
      gene_type : "protein_coding",
      gene_name : "TLR7",
      gene_level : 2,
      hgnc_id : "HGNC:15631",
      havana_gene : "OTTHUMG00000021137.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 12906620,
      stop : 12923169,
      direction : "+",
      ID : "ENSG00000101916.12",
      gene_id : "ENSG00000101916.12",
      gene_type : "protein_coding",
      gene_name : "TLR8",
      gene_level : 1,
      hgnc_id : "HGNC:15632",
      havana_gene : "OTTHUMG00000021145.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 12975110,
      stop : 12977227,
      direction : "+",
      ID : "ENSG00000205542.11",
      gene_id : "ENSG00000205542.11",
      gene_type : "protein_coding",
      gene_name : "TMSB4X",
      gene_level : 1,
      hgnc_id : "HGNC:11881",
      havana_gene : "OTTHUMG00000021144.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13035617,
      stop : 13044682,
      direction : "-",
      ID : "ENSG00000187268.12",
      gene_id : "ENSG00000187268.12",
      gene_type : "protein_coding",
      gene_name : "FAM9C",
      gene_level : 2,
      hgnc_id : "HGNC:18405",
      havana_gene : "OTTHUMG00000021143.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13318236,
      stop : 13320399,
      direction : "-",
      ID : "ENSG00000123594.5",
      gene_id : "ENSG00000123594.5",
      gene_type : "protein_coding",
      gene_name : "ATXN3L",
      gene_level : 2,
      hgnc_id : "HGNC:24173",
      havana_gene : "OTTHUMG00000021146.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13569601,
      stop : 13633575,
      direction : "+",
      ID : "ENSG00000198759.12",
      gene_id : "ENSG00000198759.12",
      gene_type : "protein_coding",
      gene_name : "EGFL6",
      gene_level : 2,
      hgnc_id : "HGNC:3235",
      havana_gene : "OTTHUMG00000021155.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13653189,
      stop : 13681964,
      direction : "+",
      ID : "ENSG00000176896.8",
      gene_id : "ENSG00000176896.8",
      gene_type : "protein_coding",
      gene_name : "TCEANC",
      gene_level : 2,
      hgnc_id : "HGNC:28277",
      havana_gene : "OTTHUMG00000021154.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13689128,
      stop : 13710504,
      direction : "+",
      ID : "ENSG00000123595.8",
      gene_id : "ENSG00000123595.8",
      gene_type : "protein_coding",
      gene_name : "RAB9A",
      gene_level : 2,
      hgnc_id : "HGNC:9792",
      havana_gene : "OTTHUMG00000021156.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13712244,
      stop : 13734635,
      direction : "-",
      ID : "ENSG00000196459.14",
      gene_id : "ENSG00000196459.14",
      gene_type : "protein_coding",
      gene_name : "TRAPPC2",
      gene_level : 1,
      hgnc_id : "HGNC:23068",
      havana_gene : "OTTHUMG00000021157.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13734745,
      stop : 13769357,
      direction : "+",
      ID : "ENSG00000046651.15",
      gene_id : "ENSG00000046651.15",
      gene_type : "protein_coding",
      gene_name : "OFD1",
      gene_level : 2,
      hgnc_id : "HGNC:2567",
      havana_gene : "OTTHUMG00000021159.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 13770939,
      stop : 13938638,
      direction : "-",
      ID : "ENSG00000046653.15",
      gene_id : "ENSG00000046653.15",
      gene_type : "protein_coding",
      gene_name : "GPM6B",
      gene_level : 2,
      hgnc_id : "HGNC:4461",
      havana_gene : "OTTHUMG00000021162.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 14006726,
      stop : 14029893,
      direction : "-",
      ID : "ENSG00000046647.14",
      gene_id : "ENSG00000046647.14",
      gene_type : "protein_coding",
      gene_name : "GEMIN8",
      gene_level : 2,
      hgnc_id : "HGNC:26044",
      havana_gene : "OTTHUMG00000021160.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 14529298,
      stop : 14731812,
      direction : "+",
      ID : "ENSG00000101958.14",
      gene_id : "ENSG00000101958.14",
      gene_type : "protein_coding",
      gene_name : "GLRA2",
      gene_level : 2,
      hgnc_id : "HGNC:4327",
      havana_gene : "OTTHUMG00000021166.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 14835961,
      stop : 14873069,
      direction : "-",
      ID : "ENSG00000181544.15",
      gene_id : "ENSG00000181544.15",
      gene_type : "protein_coding",
      gene_name : "FANCB",
      gene_level : 2,
      hgnc_id : "HGNC:3583",
      havana_gene : "OTTHUMG00000021168.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 14873421,
      stop : 14922327,
      direction : "+",
      ID : "ENSG00000130150.12",
      gene_id : "ENSG00000130150.12",
      gene_type : "protein_coding",
      gene_name : "MOSPD2",
      gene_level : 2,
      hgnc_id : "HGNC:28381",
      havana_gene : "OTTHUMG00000021170.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15235288,
      stop : 15270467,
      direction : "-",
      ID : "ENSG00000102048.16",
      gene_id : "ENSG00000102048.16",
      gene_type : "protein_coding",
      gene_name : "ASB9",
      gene_level : 2,
      hgnc_id : "HGNC:17184",
      havana_gene : "OTTHUMG00000021172.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15281697,
      stop : 15315640,
      direction : "-",
      ID : "ENSG00000165192.14",
      gene_id : "ENSG00000165192.14",
      gene_type : "protein_coding",
      gene_name : "ASB11",
      gene_level : 2,
      hgnc_id : "HGNC:17186",
      havana_gene : "OTTHUMG00000021173.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15319452,
      stop : 15335554,
      direction : "-",
      ID : "ENSG00000165195.16",
      gene_id : "ENSG00000165195.16",
      gene_type : "protein_coding",
      gene_name : "PIGA",
      gene_level : 2,
      hgnc_id : "HGNC:8957",
      havana_gene : "OTTHUMG00000021174.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15345596,
      stop : 15384413,
      direction : "-",
      ID : "ENSG00000165197.5",
      gene_id : "ENSG00000165197.5",
      gene_type : "protein_coding",
      gene_name : "VEGFD",
      gene_level : 2,
      hgnc_id : "HGNC:3708",
      havana_gene : "OTTHUMG00000021175.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15384799,
      stop : 15493564,
      direction : "-",
      ID : "ENSG00000087842.11",
      gene_id : "ENSG00000087842.11",
      gene_type : "protein_coding",
      gene_name : "PIR",
      gene_level : 2,
      hgnc_id : "HGNC:30048",
      havana_gene : "OTTHUMG00000021176.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15464246,
      stop : 15556529,
      direction : "+",
      ID : "ENSG00000102010.15",
      gene_id : "ENSG00000102010.15",
      gene_type : "protein_coding",
      gene_name : "BMX",
      gene_level : 2,
      hgnc_id : "HGNC:1079",
      havana_gene : "OTTHUMG00000021180.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15494566,
      stop : 15607236,
      direction : "-",
      ID : "ENSG00000130234.13",
      gene_id : "ENSG00000130234.13",
      gene_type : "protein_coding",
      gene_name : "ACE2",
      gene_level : 2,
      hgnc_id : "HGNC:13557",
      havana_gene : "OTTHUMG00000193402.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15561047,
      stop : 15675608,
      direction : "-",
      ID : "ENSG00000285602.1",
      gene_id : "ENSG00000285602.1",
      gene_type : "protein_coding",
      gene_name : "AC097625.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000021177.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15627318,
      stop : 15675012,
      direction : "-",
      ID : "ENSG00000147003.7",
      gene_id : "ENSG00000147003.7",
      gene_type : "protein_coding",
      gene_name : "CLTRN",
      gene_level : 2,
      hgnc_id : "HGNC:29437",
      havana_gene : "OTTHUMG00000021181.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15688830,
      stop : 15788411,
      direction : "+",
      ID : "ENSG00000169239.13",
      gene_id : "ENSG00000169239.13",
      gene_type : "protein_coding",
      gene_name : "CA5B",
      gene_level : 2,
      hgnc_id : "HGNC:1378",
      havana_gene : "OTTHUMG00000021183.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15790472,
      stop : 15823260,
      direction : "+",
      ID : "ENSG00000169249.13",
      gene_id : "ENSG00000169249.13",
      gene_type : "protein_coding",
      gene_name : "ZRSR2",
      gene_level : 2,
      hgnc_id : "HGNC:23019",
      havana_gene : "OTTHUMG00000021184.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 15825806,
      stop : 15854931,
      direction : "-",
      ID : "ENSG00000182287.15",
      gene_id : "ENSG00000182287.15",
      gene_type : "protein_coding",
      gene_name : "AP1S2",
      gene_level : 2,
      hgnc_id : "HGNC:560",
      havana_gene : "OTTHUMG00000021186.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16123565,
      stop : 16153518,
      direction : "+",
      ID : "ENSG00000126010.6",
      gene_id : "ENSG00000126010.6",
      gene_type : "protein_coding",
      gene_name : "GRPR",
      gene_level : 2,
      hgnc_id : "HGNC:4609",
      havana_gene : "OTTHUMG00000021189.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16167481,
      stop : 16171464,
      direction : "+",
      ID : "ENSG00000182798.10",
      gene_id : "ENSG00000182798.10",
      gene_type : "protein_coding",
      gene_name : "MAGEB17",
      gene_level : 2,
      hgnc_id : "HGNC:17418",
      havana_gene : "OTTHUMG00000021188.6",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16587999,
      stop : 16712936,
      direction : "-",
      ID : "ENSG00000047230.15",
      gene_id : "ENSG00000047230.15",
      gene_type : "protein_coding",
      gene_name : "CTPS2",
      gene_level : 2,
      hgnc_id : "HGNC:2520",
      havana_gene : "OTTHUMG00000021193.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16650158,
      stop : 16654670,
      direction : "+",
      ID : "ENSG00000169906.5",
      gene_id : "ENSG00000169906.5",
      gene_type : "protein_coding",
      gene_name : "S100G",
      gene_level : 2,
      hgnc_id : "HGNC:1436",
      havana_gene : "OTTHUMG00000021194.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16719612,
      stop : 16765340,
      direction : "+",
      ID : "ENSG00000169895.6",
      gene_id : "ENSG00000169895.6",
      gene_type : "protein_coding",
      gene_name : "SYAP1",
      gene_level : 2,
      hgnc_id : "HGNC:16273",
      havana_gene : "OTTHUMG00000021192.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16786432,
      stop : 16844519,
      direction : "+",
      ID : "ENSG00000086712.13",
      gene_id : "ENSG00000086712.13",
      gene_type : "protein_coding",
      gene_name : "TXLNG",
      gene_level : 2,
      hgnc_id : "HGNC:18578",
      havana_gene : "OTTHUMG00000021196.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16839283,
      stop : 16870362,
      direction : "-",
      ID : "ENSG00000102054.18",
      gene_id : "ENSG00000102054.18",
      gene_type : "protein_coding",
      gene_name : "RBBP7",
      gene_level : 1,
      hgnc_id : "HGNC:9890",
      havana_gene : "OTTHUMG00000021198.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 16946658,
      stop : 17153272,
      direction : "+",
      ID : "ENSG00000169891.18",
      gene_id : "ENSG00000169891.18",
      gene_type : "protein_coding",
      gene_name : "REPS2",
      gene_level : 2,
      hgnc_id : "HGNC:9963",
      havana_gene : "OTTHUMG00000021199.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 17375200,
      stop : 17735994,
      direction : "+",
      ID : "ENSG00000188158.16",
      gene_id : "ENSG00000188158.16",
      gene_type : "protein_coding",
      gene_name : "NHS",
      gene_level : 2,
      hgnc_id : "HGNC:7820",
      havana_gene : "OTTHUMG00000022799.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 17737449,
      stop : 17754988,
      direction : "+",
      ID : "ENSG00000047634.15",
      gene_id : "ENSG00000047634.15",
      gene_type : "protein_coding",
      gene_name : "SCML1",
      gene_level : 2,
      hgnc_id : "HGNC:10580",
      havana_gene : "OTTHUMG00000021206.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 17800049,
      stop : 17861337,
      direction : "-",
      ID : "ENSG00000131831.18",
      gene_id : "ENSG00000131831.18",
      gene_type : "protein_coding",
      gene_name : "RAI2",
      gene_level : 2,
      hgnc_id : "HGNC:9835",
      havana_gene : "OTTHUMG00000021209.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18162931,
      stop : 18220886,
      direction : "-",
      ID : "ENSG00000177324.14",
      gene_id : "ENSG00000177324.14",
      gene_type : "protein_coding",
      gene_name : "BEND2",
      gene_level : 2,
      hgnc_id : "HGNC:28509",
      havana_gene : "OTTHUMG00000021211.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18239313,
      stop : 18354688,
      direction : "-",
      ID : "ENSG00000102098.19",
      gene_id : "ENSG00000102098.19",
      gene_type : "protein_coding",
      gene_name : "SCML2",
      gene_level : 2,
      hgnc_id : "HGNC:10581",
      havana_gene : "OTTHUMG00000021212.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18425583,
      stop : 18653629,
      direction : "+",
      ID : "ENSG00000008086.13",
      gene_id : "ENSG00000008086.13",
      gene_type : "protein_coding",
      gene_name : "CDKL5",
      gene_level : 2,
      hgnc_id : "HGNC:11411",
      havana_gene : "OTTHUMG00000021214.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18639688,
      stop : 18672108,
      direction : "-",
      ID : "ENSG00000102104.9",
      gene_id : "ENSG00000102104.9",
      gene_type : "protein_coding",
      gene_name : "RS1",
      gene_level : 2,
      hgnc_id : "HGNC:10457",
      havana_gene : "OTTHUMG00000021216.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18675909,
      stop : 18827921,
      direction : "+",
      ID : "ENSG00000086717.18",
      gene_id : "ENSG00000086717.18",
      gene_type : "protein_coding",
      gene_name : "PPEF1",
      gene_level : 2,
      hgnc_id : "HGNC:9243",
      havana_gene : "OTTHUMG00000021219.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18892298,
      stop : 18984114,
      direction : "-",
      ID : "ENSG00000044446.12",
      gene_id : "ENSG00000044446.12",
      gene_type : "protein_coding",
      gene_name : "PHKA2",
      gene_level : 2,
      hgnc_id : "HGNC:8926",
      havana_gene : "OTTHUMG00000021222.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 18989307,
      stop : 19122637,
      direction : "-",
      ID : "ENSG00000173698.18",
      gene_id : "ENSG00000173698.18",
      gene_type : "protein_coding",
      gene_name : "ADGRG2",
      gene_level : 2,
      hgnc_id : "HGNC:4516",
      havana_gene : "OTTHUMG00000021223.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 19343893,
      stop : 19361718,
      direction : "+",
      ID : "ENSG00000131828.14",
      gene_id : "ENSG00000131828.14",
      gene_type : "protein_coding",
      gene_name : "PDHA1",
      gene_level : 2,
      hgnc_id : "HGNC:8806",
      havana_gene : "OTTHUMG00000021224.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 19360056,
      stop : 19515261,
      direction : "-",
      ID : "ENSG00000180815.14",
      gene_id : "ENSG00000180815.14",
      gene_type : "protein_coding",
      gene_name : "MAP3K15",
      gene_level : 2,
      hgnc_id : "HGNC:31689",
      havana_gene : "OTTHUMG00000022724.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 19533977,
      stop : 19887600,
      direction : "-",
      ID : "ENSG00000147010.18",
      gene_id : "ENSG00000147010.18",
      gene_type : "protein_coding",
      gene_name : "SH3KBP1",
      gene_level : 2,
      hgnc_id : "HGNC:13867",
      havana_gene : "OTTHUMG00000021227.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 19912860,
      stop : 19970298,
      direction : "-",
      ID : "ENSG00000173681.16",
      gene_id : "ENSG00000173681.16",
      gene_type : "protein_coding",
      gene_name : "BCLAF3",
      gene_level : 2,
      hgnc_id : "HGNC:27413",
      havana_gene : "OTTHUMG00000021226.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 20006713,
      stop : 20116907,
      direction : "-",
      ID : "ENSG00000184368.16",
      gene_id : "ENSG00000184368.16",
      gene_type : "protein_coding",
      gene_name : "MAP7D2",
      gene_level : 2,
      hgnc_id : "HGNC:25899",
      havana_gene : "OTTHUMG00000021228.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 20124525,
      stop : 20141838,
      direction : "-",
      ID : "ENSG00000173674.11",
      gene_id : "ENSG00000173674.11",
      gene_type : "protein_coding",
      gene_name : "EIF1AX",
      gene_level : 2,
      hgnc_id : "HGNC:3250",
      havana_gene : "OTTHUMG00000022704.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 20149911,
      stop : 20267519,
      direction : "-",
      ID : "ENSG00000177189.14",
      gene_id : "ENSG00000177189.14",
      gene_type : "protein_coding",
      gene_name : "RPS6KA3",
      gene_level : 2,
      hgnc_id : "HGNC:10432",
      havana_gene : "OTTHUMG00000021231.12",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 21372801,
      stop : 21654695,
      direction : "+",
      ID : "ENSG00000149970.16",
      gene_id : "ENSG00000149970.16",
      gene_type : "protein_coding",
      gene_name : "CNKSR2",
      gene_level : 2,
      hgnc_id : "HGNC:19701",
      havana_gene : "OTTHUMG00000021233.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 21654690,
      stop : 21658330,
      direction : "-",
      ID : "ENSG00000185915.5",
      gene_id : "ENSG00000185915.5",
      gene_type : "protein_coding",
      gene_name : "KLHL34",
      gene_level : 2,
      hgnc_id : "HGNC:26634",
      havana_gene : "OTTHUMG00000021234.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 21705978,
      stop : 21758116,
      direction : "-",
      ID : "ENSG00000091482.8",
      gene_id : "ENSG00000091482.8",
      gene_type : "protein_coding",
      gene_name : "SMPX",
      gene_level : 2,
      hgnc_id : "HGNC:11122",
      havana_gene : "OTTHUMG00000021235.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 21839617,
      stop : 21885423,
      direction : "+",
      ID : "ENSG00000012174.12",
      gene_id : "ENSG00000012174.12",
      gene_type : "protein_coding",
      gene_name : "MBTPS2",
      gene_level : 2,
      hgnc_id : "HGNC:15455",
      havana_gene : "OTTHUMG00000021237.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 21855987,
      stop : 21858740,
      direction : "+",
      ID : "ENSG00000230797.3",
      gene_id : "ENSG00000230797.3",
      gene_type : "protein_coding",
      gene_name : "YY2",
      gene_level : 2,
      hgnc_id : "HGNC:31684",
      havana_gene : "OTTHUMG00000021236.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 21940709,
      stop : 21994837,
      direction : "+",
      ID : "ENSG00000102172.16",
      gene_id : "ENSG00000102172.16",
      gene_type : "protein_coding",
      gene_name : "SMS",
      gene_level : 2,
      hgnc_id : "HGNC:11123",
      havana_gene : "OTTHUMG00000021239.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 22032325,
      stop : 22251310,
      direction : "+",
      ID : "ENSG00000102174.9",
      gene_id : "ENSG00000102174.9",
      gene_type : "protein_coding",
      gene_name : "PHEX",
      gene_level : 2,
      hgnc_id : "HGNC:8918",
      havana_gene : "OTTHUMG00000021241.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 22272913,
      stop : 22274461,
      direction : "+",
      ID : "ENSG00000175809.6",
      gene_id : "ENSG00000175809.6",
      gene_type : "protein_coding",
      gene_name : "CBLL2",
      gene_level : 2,
      hgnc_id : "HGNC:26371",
      havana_gene : "OTTHUMG00000021242.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 22999960,
      stop : 23003589,
      direction : "+",
      ID : "ENSG00000184735.7",
      gene_id : "ENSG00000184735.7",
      gene_type : "protein_coding",
      gene_name : "DDX53",
      gene_level : 2,
      hgnc_id : "HGNC:20083",
      havana_gene : "OTTHUMG00000021248.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23334849,
      stop : 23404374,
      direction : "+",
      ID : "ENSG00000165186.12",
      gene_id : "ENSG00000165186.12",
      gene_type : "protein_coding",
      gene_name : "PTCHD1",
      gene_level : 2,
      hgnc_id : "HGNC:26392",
      havana_gene : "OTTHUMG00000021251.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23664262,
      stop : 23686397,
      direction : "+",
      ID : "ENSG00000123131.13",
      gene_id : "ENSG00000123131.13",
      gene_type : "protein_coding",
      gene_name : "PRDX4",
      gene_level : 2,
      hgnc_id : "HGNC:17169",
      havana_gene : "OTTHUMG00000021253.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23701055,
      stop : 23766475,
      direction : "-",
      ID : "ENSG00000123130.17",
      gene_id : "ENSG00000123130.17",
      gene_type : "protein_coding",
      gene_name : "ACOT9",
      gene_level : 2,
      hgnc_id : "HGNC:17152",
      havana_gene : "OTTHUMG00000021257.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23783173,
      stop : 23786226,
      direction : "+",
      ID : "ENSG00000130066.16",
      gene_id : "ENSG00000130066.16",
      gene_type : "protein_coding",
      gene_name : "SAT1",
      gene_level : 2,
      hgnc_id : "HGNC:10540",
      havana_gene : "OTTHUMG00000021256.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23833353,
      stop : 23907938,
      direction : "-",
      ID : "ENSG00000184831.14",
      gene_id : "ENSG00000184831.14",
      gene_type : "protein_coding",
      gene_name : "APOO",
      gene_level : 2,
      hgnc_id : "HGNC:28727",
      havana_gene : "OTTHUMG00000021259.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23908006,
      stop : 23939509,
      direction : "+",
      ID : "ENSG00000165182.12",
      gene_id : "ENSG00000165182.12",
      gene_type : "protein_coding",
      gene_name : "CXorf58",
      gene_level : 2,
      hgnc_id : "HGNC:26356",
      havana_gene : "OTTHUMG00000021258.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 23983720,
      stop : 24027186,
      direction : "-",
      ID : "ENSG00000174010.9",
      gene_id : "ENSG00000174010.9",
      gene_type : "protein_coding",
      gene_name : "KLHL15",
      gene_level : 2,
      hgnc_id : "HGNC:29347",
      havana_gene : "OTTHUMG00000021261.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24054946,
      stop : 24078810,
      direction : "+",
      ID : "ENSG00000130741.11",
      gene_id : "ENSG00000130741.11",
      gene_type : "protein_coding",
      gene_name : "EIF2S3",
      gene_level : 2,
      hgnc_id : "HGNC:3267",
      havana_gene : "OTTHUMG00000021262.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24149173,
      stop : 24216255,
      direction : "+",
      ID : "ENSG00000005889.16",
      gene_id : "ENSG00000005889.16",
      gene_type : "protein_coding",
      gene_name : "ZFX",
      gene_level : 2,
      hgnc_id : "HGNC:12869",
      havana_gene : "OTTHUMG00000021264.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24310862,
      stop : 24314079,
      direction : "-",
      ID : "ENSG00000223611.6",
      gene_id : "ENSG00000223611.6",
      gene_type : "protein_coding",
      gene_name : "SUPT20HL2",
      gene_level : 2,
      hgnc_id : "HGNC:31797",
      havana_gene : "OTTHUMG00000021265.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24362325,
      stop : 24365424,
      direction : "+",
      ID : "ENSG00000223731.3",
      gene_id : "ENSG00000223731.3",
      gene_type : "protein_coding",
      gene_name : "SUPT20HL1",
      gene_level : 2,
      hgnc_id : "HGNC:30773",
      havana_gene : "OTTHUMG00000021267.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24465270,
      stop : 24550466,
      direction : "+",
      ID : "ENSG00000067992.16",
      gene_id : "ENSG00000067992.16",
      gene_type : "protein_coding",
      gene_name : "PDK3",
      gene_level : 2,
      hgnc_id : "HGNC:8811",
      havana_gene : "OTTHUMG00000021269.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24558087,
      stop : 24672677,
      direction : "-",
      ID : "ENSG00000102230.14",
      gene_id : "ENSG00000102230.14",
      gene_type : "protein_coding",
      gene_name : "PCYT1B",
      gene_level : 2,
      hgnc_id : "HGNC:8755",
      havana_gene : "OTTHUMG00000021270.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 24693873,
      stop : 24996986,
      direction : "+",
      ID : "ENSG00000101868.13",
      gene_id : "ENSG00000101868.13",
      gene_type : "protein_coding",
      gene_name : "POLA1",
      gene_level : 2,
      hgnc_id : "HGNC:9173",
      havana_gene : "OTTHUMG00000021277.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 25003694,
      stop : 25016420,
      direction : "-",
      ID : "ENSG00000004848.8",
      gene_id : "ENSG00000004848.8",
      gene_type : "protein_coding",
      gene_name : "ARX",
      gene_level : 2,
      hgnc_id : "HGNC:18060",
      havana_gene : "OTTHUMG00000021275.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 26138343,
      stop : 26140736,
      direction : "+",
      ID : "ENSG00000176774.6",
      gene_id : "ENSG00000176774.6",
      gene_type : "protein_coding",
      gene_name : "MAGEB18",
      gene_level : 2,
      hgnc_id : "HGNC:28515",
      havana_gene : "OTTHUMG00000021282.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 26160601,
      stop : 26161824,
      direction : "+",
      ID : "ENSG00000232030.3",
      gene_id : "ENSG00000232030.3",
      gene_type : "protein_coding",
      gene_name : "MAGEB6B",
      gene_level : 2,
      hgnc_id : "HGNC:28824",
      havana_gene : "OTTHUMG00000021284.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 26192440,
      stop : 26195646,
      direction : "+",
      ID : "ENSG00000176746.6",
      gene_id : "ENSG00000176746.6",
      gene_type : "protein_coding",
      gene_name : "MAGEB6",
      gene_level : 2,
      hgnc_id : "HGNC:23796",
      havana_gene : "OTTHUMG00000021285.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 26216169,
      stop : 26218270,
      direction : "+",
      ID : "ENSG00000188408.5",
      gene_id : "ENSG00000188408.5",
      gene_type : "protein_coding",
      gene_name : "MAGEB5",
      gene_level : 2,
      hgnc_id : "HGNC:23795",
      havana_gene : "OTTHUMG00000021288.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 27460207,
      stop : 27463341,
      direction : "-",
      ID : "ENSG00000224960.5",
      gene_id : "ENSG00000224960.5",
      gene_type : "protein_coding",
      gene_name : "PPP4R3C",
      gene_level : 2,
      hgnc_id : "HGNC:33146",
      havana_gene : "OTTHUMG00000021300.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 27590382,
      stop : 27748821,
      direction : "+",
      ID : "ENSG00000189186.10",
      gene_id : "ENSG00000189186.10",
      gene_type : "protein_coding",
      gene_name : "DCAF8L2",
      gene_level : 2,
      hgnc_id : "HGNC:31811",
      havana_gene : "OTTHUMG00000021305.5",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 27807990,
      stop : 27823014,
      direction : "+",
      ID : "ENSG00000177689.10",
      gene_id : "ENSG00000177689.10",
      gene_type : "protein_coding",
      gene_name : "MAGEB10",
      gene_level : 2,
      hgnc_id : "HGNC:25377",
      havana_gene : "OTTHUMG00000046084.1",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 27977992,
      stop : 27981449,
      direction : "-",
      ID : "ENSG00000226372.4",
      gene_id : "ENSG00000226372.4",
      gene_type : "protein_coding",
      gene_name : "DCAF8L1",
      gene_level : 2,
      hgnc_id : "HGNC:31810",
      havana_gene : "OTTHUMG00000021312.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 28587446,
      stop : 29956718,
      direction : "+",
      ID : "ENSG00000169306.10",
      gene_id : "ENSG00000169306.10",
      gene_type : "protein_coding",
      gene_name : "IL1RAPL1",
      gene_level : 2,
      hgnc_id : "HGNC:5996",
      havana_gene : "OTTHUMG00000021317.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30215563,
      stop : 30220089,
      direction : "+",
      ID : "ENSG00000099399.6",
      gene_id : "ENSG00000099399.6",
      gene_type : "protein_coding",
      gene_name : "MAGEB2",
      gene_level : 2,
      hgnc_id : "HGNC:6809",
      havana_gene : "OTTHUMG00000021319.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30230436,
      stop : 30237492,
      direction : "+",
      ID : "ENSG00000198798.5",
      gene_id : "ENSG00000198798.5",
      gene_type : "protein_coding",
      gene_name : "MAGEB3",
      gene_level : 2,
      hgnc_id : "HGNC:6810",
      havana_gene : "OTTHUMG00000021320.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30242000,
      stop : 30244187,
      direction : "+",
      ID : "ENSG00000120289.12",
      gene_id : "ENSG00000120289.12",
      gene_type : "protein_coding",
      gene_name : "MAGEB4",
      gene_level : 2,
      hgnc_id : "HGNC:6811",
      havana_gene : "OTTHUMG00000021321.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30243730,
      stop : 30252040,
      direction : "+",
      ID : "ENSG00000214107.8",
      gene_id : "ENSG00000214107.8",
      gene_type : "protein_coding",
      gene_name : "MAGEB1",
      gene_level : 2,
      hgnc_id : "HGNC:6808",
      havana_gene : "OTTHUMG00000021322.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30304206,
      stop : 30309390,
      direction : "-",
      ID : "ENSG00000169297.8",
      gene_id : "ENSG00000169297.8",
      gene_type : "protein_coding",
      gene_name : "NR0B1",
      gene_level : 2,
      hgnc_id : "HGNC:7960",
      havana_gene : "OTTHUMG00000021323.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30558809,
      stop : 30577766,
      direction : "-",
      ID : "ENSG00000120280.6",
      gene_id : "ENSG00000120280.6",
      gene_type : "protein_coding",
      gene_name : "TASL",
      gene_level : 2,
      hgnc_id : "HGNC:25667",
      havana_gene : "OTTHUMG00000021325.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30653359,
      stop : 30731462,
      direction : "+",
      ID : "ENSG00000198814.13",
      gene_id : "ENSG00000198814.13",
      gene_type : "protein_coding",
      gene_name : "GK",
      gene_level : 1,
      hgnc_id : "HGNC:4289",
      havana_gene : "OTTHUMG00000021328.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 30827442,
      stop : 30975084,
      direction : "-",
      ID : "ENSG00000157625.15",
      gene_id : "ENSG00000157625.15",
      gene_type : "protein_coding",
      gene_name : "TAB3",
      gene_level : 2,
      hgnc_id : "HGNC:30681",
      havana_gene : "OTTHUMG00000021329.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 31071233,
      stop : 31072041,
      direction : "-",
      ID : "ENSG00000132446.7",
      gene_id : "ENSG00000132446.7",
      gene_type : "protein_coding",
      gene_name : "FTHL17",
      gene_level : 2,
      hgnc_id : "HGNC:3987",
      havana_gene : "OTTHUMG00000021332.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 31097677,
      stop : 33339609,
      direction : "-",
      ID : "ENSG00000198947.17",
      gene_id : "ENSG00000198947.17",
      gene_type : "protein_coding",
      gene_name : "DMD",
      gene_level : 1,
      hgnc_id : "HGNC:2928",
      havana_gene : "OTTHUMG00000021336.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 34129756,
      stop : 34132314,
      direction : "-",
      ID : "ENSG00000185448.10",
      gene_id : "ENSG00000185448.10",
      gene_type : "protein_coding",
      gene_name : "FAM47A",
      gene_level : 2,
      hgnc_id : "HGNC:29962",
      havana_gene : "OTTHUMG00000021339.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 34627075,
      stop : 34657285,
      direction : "-",
      ID : "ENSG00000147027.4",
      gene_id : "ENSG00000147027.4",
      gene_type : "protein_coding",
      gene_name : "TMEM47",
      gene_level : 2,
      hgnc_id : "HGNC:18515",
      havana_gene : "OTTHUMG00000021343.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 34942796,
      stop : 34944915,
      direction : "+",
      ID : "ENSG00000189132.6",
      gene_id : "ENSG00000189132.6",
      gene_type : "protein_coding",
      gene_name : "FAM47B",
      gene_level : 2,
      hgnc_id : "HGNC:26659",
      havana_gene : "OTTHUMG00000021345.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 35798342,
      stop : 35803735,
      direction : "+",
      ID : "ENSG00000189023.10",
      gene_id : "ENSG00000189023.10",
      gene_type : "protein_coding",
      gene_name : "MAGEB16",
      gene_level : 2,
      hgnc_id : "HGNC:21188",
      havana_gene : "OTTHUMG00000021348.8",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 35919734,
      stop : 36385317,
      direction : "+",
      ID : "ENSG00000165164.14",
      gene_id : "ENSG00000165164.14",
      gene_type : "protein_coding",
      gene_name : "CFAP47",
      gene_level : 2,
      hgnc_id : "HGNC:26708",
      havana_gene : "OTTHUMG00000021351.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37008366,
      stop : 37011664,
      direction : "+",
      ID : "ENSG00000198173.5",
      gene_id : "ENSG00000198173.5",
      gene_type : "protein_coding",
      gene_name : "FAM47C",
      gene_level : 2,
      hgnc_id : "HGNC:25301",
      havana_gene : "OTTHUMG00000024025.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37349309,
      stop : 37457292,
      direction : "+",
      ID : "ENSG00000130962.18",
      gene_id : "ENSG00000130962.18",
      gene_type : "protein_coding",
      gene_name : "PRRG1",
      gene_level : 1,
      hgnc_id : "HGNC:9469",
      havana_gene : "OTTHUMG00000021360.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37349330,
      stop : 38687674,
      direction : "+",
      ID : "ENSG00000250349.3",
      gene_id : "ENSG00000250349.3",
      gene_type : "protein_coding",
      gene_name : "AF241726.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000161009.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37571569,
      stop : 37684463,
      direction : "+",
      ID : "ENSG00000147036.12",
      gene_id : "ENSG00000147036.12",
      gene_type : "protein_coding",
      gene_name : "LANCL3",
      gene_level : 2,
      hgnc_id : "HGNC:24767",
      havana_gene : "OTTHUMG00000033177.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37685791,
      stop : 37732130,
      direction : "+",
      ID : "ENSG00000047597.7",
      gene_id : "ENSG00000047597.7",
      gene_type : "protein_coding",
      gene_name : "XK",
      gene_level : 2,
      hgnc_id : "HGNC:12811",
      havana_gene : "OTTHUMG00000033171.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37780059,
      stop : 37813461,
      direction : "+",
      ID : "ENSG00000165168.8",
      gene_id : "ENSG00000165168.8",
      gene_type : "protein_coding",
      gene_name : "CYBB",
      gene_level : 2,
      hgnc_id : "HGNC:2578",
      havana_gene : "OTTHUMG00000033175.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37836757,
      stop : 37847571,
      direction : "-",
      ID : "ENSG00000165169.11",
      gene_id : "ENSG00000165169.11",
      gene_type : "protein_coding",
      gene_name : "DYNLT3",
      gene_level : 2,
      hgnc_id : "HGNC:11694",
      havana_gene : "OTTHUMG00000033172.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37990779,
      stop : 37991314,
      direction : "+",
      ID : "ENSG00000187516.7",
      gene_id : "ENSG00000187516.7",
      gene_type : "protein_coding",
      gene_name : "H2AP",
      gene_level : 2,
      hgnc_id : "HGNC:18417",
      havana_gene : "OTTHUMG00000033180.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 37994252,
      stop : 37994918,
      direction : "+",
      ID : "ENSG00000229674.2",
      gene_id : "ENSG00000229674.2",
      gene_type : "protein_coding",
      gene_name : "H2AL1RP",
      gene_level : 2,
      hgnc_id : "HGNC:53960",
      havana_gene : "OTTHUMG00000150277.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 38006553,
      stop : 38128819,
      direction : "+",
      ID : "ENSG00000147041.12",
      gene_id : "ENSG00000147041.12",
      gene_type : "protein_coding",
      gene_name : "SYTL5",
      gene_level : 2,
      hgnc_id : "HGNC:15589",
      havana_gene : "OTTHUMG00000033176.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 38149336,
      stop : 38220924,
      direction : "-",
      ID : "ENSG00000101955.15",
      gene_id : "ENSG00000101955.15",
      gene_type : "protein_coding",
      gene_name : "SRPX",
      gene_level : 2,
      hgnc_id : "HGNC:11309",
      havana_gene : "OTTHUMG00000021362.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 38269163,
      stop : 38327544,
      direction : "-",
      ID : "ENSG00000156313.15",
      gene_id : "ENSG00000156313.15",
      gene_type : "protein_coding",
      gene_name : "RPGR",
      gene_level : 2,
      hgnc_id : "HGNC:10295",
      havana_gene : "OTTHUMG00000021361.16",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 38352586,
      stop : 38421446,
      direction : "+",
      ID : "ENSG00000036473.8",
      gene_id : "ENSG00000036473.8",
      gene_type : "protein_coding",
      gene_name : "OTC",
      gene_level : 2,
      hgnc_id : "HGNC:8512",
      havana_gene : "OTTHUMG00000022727.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 38561542,
      stop : 38688920,
      direction : "+",
      ID : "ENSG00000156298.13",
      gene_id : "ENSG00000156298.13",
      gene_type : "protein_coding",
      gene_name : "TSPAN7",
      gene_level : 2,
      hgnc_id : "HGNC:11854",
      havana_gene : "OTTHUMG00000024090.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 38801432,
      stop : 38806537,
      direction : "+",
      ID : "ENSG00000165175.16",
      gene_id : "ENSG00000165175.16",
      gene_type : "protein_coding",
      gene_name : "MID1IP1",
      gene_level : 2,
      hgnc_id : "HGNC:20715",
      havana_gene : "OTTHUMG00000024092.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 40049815,
      stop : 40177329,
      direction : "-",
      ID : "ENSG00000183337.18",
      gene_id : "ENSG00000183337.18",
      gene_type : "protein_coding",
      gene_name : "BCOR",
      gene_level : 1,
      hgnc_id : "HGNC:20893",
      havana_gene : "OTTHUMG00000024100.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 40579372,
      stop : 40606848,
      direction : "+",
      ID : "ENSG00000182220.15",
      gene_id : "ENSG00000182220.15",
      gene_type : "protein_coding",
      gene_name : "ATP6AP2",
      gene_level : 2,
      hgnc_id : "HGNC:18305",
      havana_gene : "OTTHUMG00000024103.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 40623566,
      stop : 40624136,
      direction : "+",
      ID : "ENSG00000238205.3",
      gene_id : "ENSG00000238205.3",
      gene_type : "protein_coding",
      gene_name : "MPC1L",
      gene_level : 2,
      hgnc_id : "HGNC:44205",
      havana_gene : "OTTHUMG00000024105.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 40626921,
      stop : 40647561,
      direction : "-",
      ID : "ENSG00000185753.13",
      gene_id : "ENSG00000185753.13",
      gene_type : "protein_coding",
      gene_name : "CXorf38",
      gene_level : 2,
      hgnc_id : "HGNC:28589",
      havana_gene : "OTTHUMG00000024104.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 40648305,
      stop : 40735858,
      direction : "-",
      ID : "ENSG00000180182.11",
      gene_id : "ENSG00000180182.11",
      gene_type : "protein_coding",
      gene_name : "MED14",
      gene_level : 2,
      hgnc_id : "HGNC:2370",
      havana_gene : "OTTHUMG00000024107.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 41085445,
      stop : 41236579,
      direction : "+",
      ID : "ENSG00000124486.13",
      gene_id : "ENSG00000124486.13",
      gene_type : "protein_coding",
      gene_name : "USP9X",
      gene_level : 2,
      hgnc_id : "HGNC:12632",
      havana_gene : "OTTHUMG00000021367.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 41333348,
      stop : 41364472,
      direction : "+",
      ID : "ENSG00000215301.11",
      gene_id : "ENSG00000215301.11",
      gene_type : "protein_coding",
      gene_name : "DDX3X",
      gene_level : 2,
      hgnc_id : "HGNC:2745",
      havana_gene : "OTTHUMG00000021369.22",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 41447343,
      stop : 41475710,
      direction : "+",
      ID : "ENSG00000188937.6",
      gene_id : "ENSG00000188937.6",
      gene_type : "protein_coding",
      gene_name : "NYX",
      gene_level : 2,
      hgnc_id : "HGNC:8082",
      havana_gene : "OTTHUMG00000021370.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 41514934,
      stop : 41923554,
      direction : "-",
      ID : "ENSG00000147044.23",
      gene_id : "ENSG00000147044.23",
      gene_type : "protein_coding",
      gene_name : "CASK",
      gene_level : 2,
      hgnc_id : "HGNC:1497",
      havana_gene : "OTTHUMG00000021378.10",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 41688973,
      stop : 41697275,
      direction : "+",
      ID : "ENSG00000171659.15",
      gene_id : "ENSG00000171659.15",
      gene_type : "protein_coding",
      gene_name : "GPR34",
      gene_level : 2,
      hgnc_id : "HGNC:4490",
      havana_gene : "OTTHUMG00000021375.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 41724181,
      stop : 41730130,
      direction : "+",
      ID : "ENSG00000171657.6",
      gene_id : "ENSG00000171657.6",
      gene_type : "protein_coding",
      gene_name : "GPR82",
      gene_level : 2,
      hgnc_id : "HGNC:4533",
      havana_gene : "OTTHUMG00000021373.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 42777366,
      stop : 42778163,
      direction : "-",
      ID : "ENSG00000102055.7",
      gene_id : "ENSG00000102055.7",
      gene_type : "protein_coding",
      gene_name : "PPP1R2C",
      gene_level : 2,
      hgnc_id : "HGNC:16324",
      havana_gene : "OTTHUMG00000021382.6",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 43654907,
      stop : 43746824,
      direction : "+",
      ID : "ENSG00000189221.10",
      gene_id : "ENSG00000189221.10",
      gene_type : "protein_coding",
      gene_name : "MAOA",
      gene_level : 2,
      hgnc_id : "HGNC:6833",
      havana_gene : "OTTHUMG00000021387.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 43766610,
      stop : 43882450,
      direction : "-",
      ID : "ENSG00000069535.14",
      gene_id : "ENSG00000069535.14",
      gene_type : "protein_coding",
      gene_name : "MAOB",
      gene_level : 2,
      hgnc_id : "HGNC:6834",
      havana_gene : "OTTHUMG00000021388.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 43948776,
      stop : 43973395,
      direction : "-",
      ID : "ENSG00000124479.11",
      gene_id : "ENSG00000124479.11",
      gene_type : "protein_coding",
      gene_name : "NDP",
      gene_level : 2,
      hgnc_id : "HGNC:7678",
      havana_gene : "OTTHUMG00000021391.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 44147872,
      stop : 44343672,
      direction : "-",
      ID : "ENSG00000183690.13",
      gene_id : "ENSG00000183690.13",
      gene_type : "protein_coding",
      gene_name : "EFHC2",
      gene_level : 2,
      hgnc_id : "HGNC:26233",
      havana_gene : "OTTHUMG00000021393.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 44523639,
      stop : 44542859,
      direction : "-",
      ID : "ENSG00000069509.6",
      gene_id : "ENSG00000069509.6",
      gene_type : "protein_coding",
      gene_name : "FUNDC1",
      gene_level : 2,
      hgnc_id : "HGNC:28746",
      havana_gene : "OTTHUMG00000021399.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 44844021,
      stop : 44844888,
      direction : "+",
      ID : "ENSG00000189037.8",
      gene_id : "ENSG00000189037.8",
      gene_type : "protein_coding",
      gene_name : "DUSP21",
      gene_level : 2,
      hgnc_id : "HGNC:20476",
      havana_gene : "OTTHUMG00000021401.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 44873188,
      stop : 45112779,
      direction : "+",
      ID : "ENSG00000147050.16",
      gene_id : "ENSG00000147050.16",
      gene_type : "protein_coding",
      gene_name : "KDM6A",
      gene_level : 2,
      hgnc_id : "HGNC:12637",
      havana_gene : "OTTHUMG00000021402.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 45148373,
      stop : 45200901,
      direction : "-",
      ID : "ENSG00000147113.17",
      gene_id : "ENSG00000147113.17",
      gene_type : "protein_coding",
      gene_name : "DIPK2B",
      gene_level : 2,
      hgnc_id : "HGNC:25866",
      havana_gene : "OTTHUMG00000021403.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 46447292,
      stop : 46497422,
      direction : "+",
      ID : "ENSG00000147121.16",
      gene_id : "ENSG00000147121.16",
      gene_type : "protein_coding",
      gene_name : "KRBOX4",
      gene_level : 2,
      hgnc_id : "HGNC:26007",
      havana_gene : "OTTHUMG00000021421.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 46497727,
      stop : 46545457,
      direction : "-",
      ID : "ENSG00000251192.7",
      gene_id : "ENSG00000251192.7",
      gene_type : "protein_coding",
      gene_name : "ZNF674",
      gene_level : 2,
      hgnc_id : "HGNC:17625",
      havana_gene : "OTTHUMG00000021420.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 46573765,
      stop : 46598496,
      direction : "+",
      ID : "ENSG00000147119.4",
      gene_id : "ENSG00000147119.4",
      gene_type : "protein_coding",
      gene_name : "CHST7",
      gene_level : 2,
      hgnc_id : "HGNC:13817",
      havana_gene : "OTTHUMG00000021423.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 46599251,
      stop : 46759118,
      direction : "-",
      ID : "ENSG00000065923.10",
      gene_id : "ENSG00000065923.10",
      gene_type : "protein_coding",
      gene_name : "SLC9A7",
      gene_level : 2,
      hgnc_id : "HGNC:17123",
      havana_gene : "OTTHUMG00000021428.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 46837043,
      stop : 46882358,
      direction : "+",
      ID : "ENSG00000102218.6",
      gene_id : "ENSG00000102218.6",
      gene_type : "protein_coding",
      gene_name : "RP2",
      gene_level : 2,
      hgnc_id : "HGNC:10274",
      havana_gene : "OTTHUMG00000021430.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 46912276,
      stop : 47061242,
      direction : "+",
      ID : "ENSG00000102221.14",
      gene_id : "ENSG00000102221.14",
      gene_type : "protein_coding",
      gene_name : "JADE3",
      gene_level : 2,
      hgnc_id : "HGNC:22982",
      havana_gene : "OTTHUMG00000021431.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47078355,
      stop : 47093314,
      direction : "+",
      ID : "ENSG00000130988.13",
      gene_id : "ENSG00000130988.13",
      gene_type : "protein_coding",
      gene_name : "RGN",
      gene_level : 2,
      hgnc_id : "HGNC:9989",
      havana_gene : "OTTHUMG00000021435.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47142216,
      stop : 47145038,
      direction : "-",
      ID : "ENSG00000147123.11",
      gene_id : "ENSG00000147123.11",
      gene_type : "protein_coding",
      gene_name : "NDUFB11",
      gene_level : 2,
      hgnc_id : "HGNC:20372",
      havana_gene : "OTTHUMG00000021433.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47145221,
      stop : 47186813,
      direction : "+",
      ID : "ENSG00000182872.16",
      gene_id : "ENSG00000182872.16",
      gene_type : "protein_coding",
      gene_name : "RBM10",
      gene_level : 2,
      hgnc_id : "HGNC:9896",
      havana_gene : "OTTHUMG00000021432.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47190861,
      stop : 47215128,
      direction : "+",
      ID : "ENSG00000130985.17",
      gene_id : "ENSG00000130985.17",
      gene_type : "protein_coding",
      gene_name : "UBA1",
      gene_level : 2,
      hgnc_id : "HGNC:12469",
      havana_gene : "OTTHUMG00000021436.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47217860,
      stop : 47229997,
      direction : "+",
      ID : "ENSG00000102225.16",
      gene_id : "ENSG00000102225.16",
      gene_type : "protein_coding",
      gene_name : "CDK16",
      gene_level : 1,
      hgnc_id : "HGNC:8749",
      havana_gene : "OTTHUMG00000021438.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47232866,
      stop : 47248328,
      direction : "+",
      ID : "ENSG00000102226.10",
      gene_id : "ENSG00000102226.10",
      gene_type : "protein_coding",
      gene_name : "USP11",
      gene_level : 1,
      hgnc_id : "HGNC:12609",
      havana_gene : "OTTHUMG00000021437.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47370578,
      stop : 47414498,
      direction : "+",
      ID : "ENSG00000147117.8",
      gene_id : "ENSG00000147117.8",
      gene_type : "protein_coding",
      gene_name : "ZNF157",
      gene_level : 2,
      hgnc_id : "HGNC:12942",
      havana_gene : "OTTHUMG00000021443.1",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47445879,
      stop : 47482946,
      direction : "-",
      ID : "ENSG00000147124.12",
      gene_id : "ENSG00000147124.12",
      gene_type : "protein_coding",
      gene_name : "ZNF41",
      gene_level : 2,
      hgnc_id : "HGNC:13107",
      havana_gene : "OTTHUMG00000021448.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47561205,
      stop : 47571908,
      direction : "+",
      ID : "ENSG00000078061.14",
      gene_id : "ENSG00000078061.14",
      gene_type : "protein_coding",
      gene_name : "ARAF",
      gene_level : 2,
      hgnc_id : "HGNC:646",
      havana_gene : "OTTHUMG00000021446.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47571901,
      stop : 47619857,
      direction : "-",
      ID : "ENSG00000008056.14",
      gene_id : "ENSG00000008056.14",
      gene_type : "protein_coding",
      gene_name : "SYN1",
      gene_level : 2,
      hgnc_id : "HGNC:11494",
      havana_gene : "OTTHUMG00000021454.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47582408,
      stop : 47586789,
      direction : "+",
      ID : "ENSG00000102265.12",
      gene_id : "ENSG00000102265.12",
      gene_type : "protein_coding",
      gene_name : "TIMP1",
      gene_level : 2,
      hgnc_id : "HGNC:11820",
      havana_gene : "OTTHUMG00000021447.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47623172,
      stop : 47630305,
      direction : "-",
      ID : "ENSG00000126759.14",
      gene_id : "ENSG00000126759.14",
      gene_type : "protein_coding",
      gene_name : "CFP",
      gene_level : 2,
      hgnc_id : "HGNC:8864",
      havana_gene : "OTTHUMG00000021451.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47635521,
      stop : 47650604,
      direction : "-",
      ID : "ENSG00000126767.18",
      gene_id : "ENSG00000126767.18",
      gene_type : "protein_coding",
      gene_name : "ELK1",
      gene_level : 2,
      hgnc_id : "HGNC:3321",
      havana_gene : "OTTHUMG00000021452.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47651796,
      stop : 47659180,
      direction : "-",
      ID : "ENSG00000126756.12",
      gene_id : "ENSG00000126756.12",
      gene_type : "protein_coding",
      gene_name : "UXT",
      gene_level : 2,
      hgnc_id : "HGNC:12641",
      havana_gene : "OTTHUMG00000021453.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47836902,
      stop : 48002561,
      direction : "+",
      ID : "ENSG00000197779.15",
      gene_id : "ENSG00000197779.15",
      gene_type : "protein_coding",
      gene_name : "ZNF81",
      gene_level : 2,
      hgnc_id : "HGNC:13156",
      havana_gene : "OTTHUMG00000021462.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47974851,
      stop : 48003989,
      direction : "-",
      ID : "ENSG00000147118.12",
      gene_id : "ENSG00000147118.12",
      gene_type : "protein_coding",
      gene_name : "ZNF182",
      gene_level : 2,
      hgnc_id : "HGNC:13001",
      havana_gene : "OTTHUMG00000021460.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 47983356,
      stop : 48071658,
      direction : "-",
      ID : "ENSG00000221994.12",
      gene_id : "ENSG00000221994.12",
      gene_type : "protein_coding",
      gene_name : "ZNF630",
      gene_level : 1,
      hgnc_id : "HGNC:28855",
      havana_gene : "OTTHUMG00000021463.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48004336,
      stop : 48009729,
      direction : "+",
      ID : "ENSG00000171489.10",
      gene_id : "ENSG00000171489.10",
      gene_type : "protein_coding",
      gene_name : "SPACA5",
      gene_level : 2,
      hgnc_id : "HGNC:31353",
      havana_gene : "OTTHUMG00000021459.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48130657,
      stop : 48132613,
      direction : "+",
      ID : "ENSG00000171478.7",
      gene_id : "ENSG00000171478.7",
      gene_type : "protein_coding",
      gene_name : "SPACA5B",
      gene_level : 2,
      hgnc_id : "HGNC:19142",
      havana_gene : "OTTHUMG00000021465.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48186220,
      stop : 48196795,
      direction : "-",
      ID : "ENSG00000165583.16",
      gene_id : "ENSG00000165583.16",
      gene_type : "protein_coding",
      gene_name : "SSX5",
      gene_level : 2,
      hgnc_id : "HGNC:11339",
      havana_gene : "OTTHUMG00000021471.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48255392,
      stop : 48267444,
      direction : "+",
      ID : "ENSG00000126752.8",
      gene_id : "ENSG00000126752.8",
      gene_type : "protein_coding",
      gene_name : "SSX1",
      gene_level : 2,
      hgnc_id : "HGNC:11335",
      havana_gene : "OTTHUMG00000021488.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48346427,
      stop : 48356707,
      direction : "-",
      ID : "ENSG00000165584.16",
      gene_id : "ENSG00000165584.16",
      gene_type : "protein_coding",
      gene_name : "SSX3",
      gene_level : 2,
      hgnc_id : "HGNC:11337",
      havana_gene : "OTTHUMG00000021489.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48383516,
      stop : 48393347,
      direction : "+",
      ID : "ENSG00000268009.6",
      gene_id : "ENSG00000268009.6",
      gene_type : "protein_coding",
      gene_name : "SSX4",
      gene_level : 2,
      hgnc_id : "HGNC:11338",
      havana_gene : "OTTHUMG00000022698.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48402078,
      stop : 48411910,
      direction : "-",
      ID : "ENSG00000269791.5",
      gene_id : "ENSG00000269791.5",
      gene_type : "protein_coding",
      gene_name : "SSX4B",
      gene_level : 2,
      hgnc_id : "HGNC:16880",
      havana_gene : "OTTHUMG00000021497.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48458537,
      stop : 48470260,
      direction : "-",
      ID : "ENSG00000017483.15",
      gene_id : "ENSG00000017483.15",
      gene_type : "protein_coding",
      gene_name : "SLC38A5",
      gene_level : 2,
      hgnc_id : "HGNC:18070",
      havana_gene : "OTTHUMG00000024117.13",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48476021,
      stop : 48486364,
      direction : "+",
      ID : "ENSG00000068438.15",
      gene_id : "ENSG00000068438.15",
      gene_type : "protein_coding",
      gene_name : "FTSJ1",
      gene_level : 2,
      hgnc_id : "HGNC:13254",
      havana_gene : "OTTHUMG00000024118.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48508962,
      stop : 48520814,
      direction : "+",
      ID : "ENSG00000102312.23",
      gene_id : "ENSG00000102312.23",
      gene_type : "protein_coding",
      gene_name : "PORCN",
      gene_level : 2,
      hgnc_id : "HGNC:17652",
      havana_gene : "OTTHUMG00000024116.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48521799,
      stop : 48528716,
      direction : "+",
      ID : "ENSG00000147155.11",
      gene_id : "ENSG00000147155.11",
      gene_type : "protein_coding",
      gene_name : "EBP",
      gene_level : 2,
      hgnc_id : "HGNC:3133",
      havana_gene : "OTTHUMG00000034482.5",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48521806,
      stop : 48545469,
      direction : "+",
      ID : "ENSG00000286268.1",
      gene_id : "ENSG00000286268.1",
      gene_type : "protein_coding",
      gene_name : "AF196969.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host",
      havana_gene : "OTTHUMG00000193442.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48539714,
      stop : 48562609,
      direction : "+",
      ID : "ENSG00000068354.16",
      gene_id : "ENSG00000068354.16",
      gene_type : "protein_coding",
      gene_name : "TBC1D25",
      gene_level : 2,
      hgnc_id : "HGNC:8092",
      havana_gene : "OTTHUMG00000024123.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48574449,
      stop : 48581162,
      direction : "+",
      ID : "ENSG00000102317.18",
      gene_id : "ENSG00000102317.18",
      gene_type : "protein_coding",
      gene_name : "RBM3",
      gene_level : 2,
      hgnc_id : "HGNC:9900",
      havana_gene : "OTTHUMG00000024121.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48590042,
      stop : 48608869,
      direction : "+",
      ID : "ENSG00000101940.18",
      gene_id : "ENSG00000101940.18",
      gene_type : "protein_coding",
      gene_name : "WDR13",
      gene_level : 2,
      hgnc_id : "HGNC:14352",
      havana_gene : "OTTHUMG00000024119.12",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48676596,
      stop : 48691427,
      direction : "+",
      ID : "ENSG00000015285.11",
      gene_id : "ENSG00000015285.11",
      gene_type : "protein_coding",
      gene_name : "WAS",
      gene_level : 2,
      hgnc_id : "HGNC:12731",
      havana_gene : "OTTHUMG00000034483.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48695554,
      stop : 48709016,
      direction : "+",
      ID : "ENSG00000101945.17",
      gene_id : "ENSG00000101945.17",
      gene_type : "protein_coding",
      gene_name : "SUV39H1",
      gene_level : 2,
      hgnc_id : "HGNC:11479",
      havana_gene : "OTTHUMG00000022701.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48761747,
      stop : 48773648,
      direction : "+",
      ID : "ENSG00000171433.12",
      gene_id : "ENSG00000171433.12",
      gene_type : "protein_coding",
      gene_name : "GLOD5",
      gene_level : 2,
      hgnc_id : "HGNC:33358",
      havana_gene : "OTTHUMG00000024125.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48786562,
      stop : 48794311,
      direction : "+",
      ID : "ENSG00000102145.15",
      gene_id : "ENSG00000102145.15",
      gene_type : "protein_coding",
      gene_name : "GATA1",
      gene_level : 2,
      hgnc_id : "HGNC:4170",
      havana_gene : "OTTHUMG00000021504.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48801377,
      stop : 48824982,
      direction : "+",
      ID : "ENSG00000094631.21",
      gene_id : "ENSG00000094631.21",
      gene_type : "protein_coding",
      gene_name : "HDAC6",
      gene_level : 1,
      hgnc_id : "HGNC:14064",
      havana_gene : "OTTHUMG00000034496.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48826513,
      stop : 48830138,
      direction : "+",
      ID : "ENSG00000187682.2",
      gene_id : "ENSG00000187682.2",
      gene_type : "protein_coding",
      gene_name : "ERAS",
      gene_level : 2,
      hgnc_id : "HGNC:5174",
      havana_gene : "OTTHUMG00000059533.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48831096,
      stop : 48835610,
      direction : "-",
      ID : "ENSG00000102109.9",
      gene_id : "ENSG00000102109.9",
      gene_type : "protein_coding",
      gene_name : "PCSK1N",
      gene_level : 2,
      hgnc_id : "HGNC:17301",
      havana_gene : "OTTHUMG00000034502.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48890197,
      stop : 48903143,
      direction : "+",
      ID : "ENSG00000102103.17",
      gene_id : "ENSG00000102103.17",
      gene_type : "protein_coding",
      gene_name : "PQBP1",
      gene_level : 2,
      hgnc_id : "HGNC:9330",
      havana_gene : "OTTHUMG00000024128.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48893447,
      stop : 48898143,
      direction : "-",
      ID : "ENSG00000126768.12",
      gene_id : "ENSG00000126768.12",
      gene_type : "protein_coding",
      gene_name : "TIMM17B",
      gene_level : 2,
      hgnc_id : "HGNC:17310",
      havana_gene : "OTTHUMG00000034498.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48903180,
      stop : 48911958,
      direction : "-",
      ID : "ENSG00000102100.16",
      gene_id : "ENSG00000102100.16",
      gene_type : "protein_coding",
      gene_name : "SLC35A2",
      gene_level : 2,
      hgnc_id : "HGNC:11022",
      havana_gene : "OTTHUMG00000024129.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48913182,
      stop : 48919024,
      direction : "-",
      ID : "ENSG00000102096.9",
      gene_id : "ENSG00000102096.9",
      gene_type : "protein_coding",
      gene_name : "PIM2",
      gene_level : 2,
      hgnc_id : "HGNC:8987",
      havana_gene : "OTTHUMG00000024132.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48922024,
      stop : 48958386,
      direction : "-",
      ID : "ENSG00000068308.14",
      gene_id : "ENSG00000068308.14",
      gene_type : "protein_coding",
      gene_name : "OTUD5",
      gene_level : 2,
      hgnc_id : "HGNC:25402",
      havana_gene : "OTTHUMG00000024130.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48961378,
      stop : 48971844,
      direction : "-",
      ID : "ENSG00000102057.10",
      gene_id : "ENSG00000102057.10",
      gene_type : "protein_coding",
      gene_name : "KCND1",
      gene_level : 2,
      hgnc_id : "HGNC:6237",
      havana_gene : "OTTHUMG00000024127.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 48973720,
      stop : 49002264,
      direction : "-",
      ID : "ENSG00000068400.13",
      gene_id : "ENSG00000068400.13",
      gene_type : "protein_coding",
      gene_name : "GRIPAP1",
      gene_level : 2,
      hgnc_id : "HGNC:18706",
      havana_gene : "OTTHUMG00000033192.10",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49028726,
      stop : 49043410,
      direction : "-",
      ID : "ENSG00000068323.17",
      gene_id : "ENSG00000068323.17",
      gene_type : "protein_coding",
      gene_name : "TFE3",
      gene_level : 2,
      hgnc_id : "HGNC:11752",
      havana_gene : "OTTHUMG00000022690.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49053572,
      stop : 49069857,
      direction : "+",
      ID : "ENSG00000147144.13",
      gene_id : "ENSG00000147144.13",
      gene_type : "protein_coding",
      gene_name : "CCDC120",
      gene_level : 2,
      hgnc_id : "HGNC:28910",
      havana_gene : "OTTHUMG00000021509.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49071161,
      stop : 49074002,
      direction : "-",
      ID : "ENSG00000243279.4",
      gene_id : "ENSG00000243279.4",
      gene_type : "protein_coding",
      gene_name : "PRAF2",
      gene_level : 2,
      hgnc_id : "HGNC:28911",
      havana_gene : "OTTHUMG00000034499.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49071470,
      stop : 49079887,
      direction : "-",
      ID : "ENSG00000288053.1",
      gene_id : "ENSG00000288053.1",
      gene_type : "protein_coding",
      gene_name : "AC231657.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193820.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49074433,
      stop : 49101170,
      direction : "-",
      ID : "ENSG00000196998.19",
      gene_id : "ENSG00000196998.19",
      gene_type : "protein_coding",
      gene_name : "WDR45",
      gene_level : 2,
      hgnc_id : "HGNC:28912",
      havana_gene : "OTTHUMG00000034500.12",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49113407,
      stop : 49123735,
      direction : "-",
      ID : "ENSG00000068394.11",
      gene_id : "ENSG00000068394.11",
      gene_type : "protein_coding",
      gene_name : "GPKOW",
      gene_level : 2,
      hgnc_id : "HGNC:30677",
      havana_gene : "OTTHUMG00000021511.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49162564,
      stop : 49168483,
      direction : "+",
      ID : "ENSG00000269313.5",
      gene_id : "ENSG00000269313.5",
      gene_type : "protein_coding",
      gene_name : "MAGIX",
      gene_level : 2,
      hgnc_id : "HGNC:30006",
      havana_gene : "OTTHUMG00000188218.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49171898,
      stop : 49175235,
      direction : "+",
      ID : "ENSG00000102007.11",
      gene_id : "ENSG00000102007.11",
      gene_type : "protein_coding",
      gene_name : "PLP2",
      gene_level : 2,
      hgnc_id : "HGNC:9087",
      havana_gene : "OTTHUMG00000021513.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49174802,
      stop : 49186528,
      direction : "-",
      ID : "ENSG00000012211.13",
      gene_id : "ENSG00000012211.13",
      gene_type : "protein_coding",
      gene_name : "PRICKLE3",
      gene_level : 2,
      hgnc_id : "HGNC:6645",
      havana_gene : "OTTHUMG00000024134.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49187815,
      stop : 49200199,
      direction : "-",
      ID : "ENSG00000102003.11",
      gene_id : "ENSG00000102003.11",
      gene_type : "protein_coding",
      gene_name : "SYP",
      gene_level : 1,
      hgnc_id : "HGNC:11506",
      havana_gene : "OTTHUMG00000034557.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49205063,
      stop : 49233371,
      direction : "-",
      ID : "ENSG00000102001.13",
      gene_id : "ENSG00000102001.13",
      gene_type : "protein_coding",
      gene_name : "CACNA1F",
      gene_level : 1,
      hgnc_id : "HGNC:1393",
      havana_gene : "OTTHUMG00000022703.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49235470,
      stop : 49250520,
      direction : "+",
      ID : "ENSG00000101997.13",
      gene_id : "ENSG00000101997.13",
      gene_type : "protein_coding",
      gene_name : "CCDC22",
      gene_level : 2,
      hgnc_id : "HGNC:28909",
      havana_gene : "OTTHUMG00000024141.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49250438,
      stop : 49270477,
      direction : "-",
      ID : "ENSG00000049768.16",
      gene_id : "ENSG00000049768.16",
      gene_type : "protein_coding",
      gene_name : "FOXP3",
      gene_level : 2,
      hgnc_id : "HGNC:6106",
      havana_gene : "OTTHUMG00000024135.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49269793,
      stop : 49301461,
      direction : "+",
      ID : "ENSG00000049769.14",
      gene_id : "ENSG00000049769.14",
      gene_type : "protein_coding",
      gene_name : "PPP1R3F",
      gene_level : 2,
      hgnc_id : "HGNC:14944",
      havana_gene : "OTTHUMG00000024139.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49303669,
      stop : 49319844,
      direction : "+",
      ID : "ENSG00000215274.5",
      gene_id : "ENSG00000215274.5",
      gene_type : "protein_coding",
      gene_name : "GAGE10",
      gene_level : 2,
      hgnc_id : "HGNC:30968",
      havana_gene : "OTTHUMG00000024136.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49322057,
      stop : 49329384,
      direction : "+",
      ID : "ENSG00000224659.2",
      gene_id : "ENSG00000224659.2",
      gene_type : "protein_coding",
      gene_name : "GAGE12J",
      gene_level : 2,
      hgnc_id : "HGNC:17778",
      havana_gene : "OTTHUMG00000024137.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49331616,
      stop : 49338952,
      direction : "+",
      ID : "ENSG00000274274.1",
      gene_id : "ENSG00000274274.1",
      gene_type : "protein_coding",
      gene_name : "GAGE13",
      gene_level : 2,
      hgnc_id : "HGNC:29081",
      havana_gene : "OTTHUMG00000024138.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49341192,
      stop : 49345922,
      direction : "+",
      ID : "ENSG00000275113.1",
      gene_id : "ENSG00000275113.1",
      gene_type : "protein_coding",
      gene_name : "GAGE2E",
      gene_level : 2,
      hgnc_id : "HGNC:31960",
      havana_gene : "OTTHUMG00000067394.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49529869,
      stop : 49529985,
      direction : "+",
      ID : "ENSG00000236737.1",
      gene_id : "ENSG00000236737.1",
      gene_type : "protein_coding",
      gene_name : "GAGE12B",
      gene_level : 2,
      hgnc_id : "HGNC:26779",
      havana_gene : "OTTHUMG00000024142.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49532211,
      stop : 49539538,
      direction : "+",
      ID : "ENSG00000237671.3",
      gene_id : "ENSG00000237671.3",
      gene_type : "protein_coding",
      gene_name : "GAGE12C",
      gene_level : 2,
      hgnc_id : "HGNC:28402",
      havana_gene : "OTTHUMG00000024144.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49541767,
      stop : 49549094,
      direction : "+",
      ID : "ENSG00000227488.2",
      gene_id : "ENSG00000227488.2",
      gene_type : "protein_coding",
      gene_name : "GAGE12D",
      gene_level : 2,
      hgnc_id : "HGNC:31904",
      havana_gene : "OTTHUMG00000024145.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49551278,
      stop : 49568218,
      direction : "+",
      ID : "ENSG00000236362.8",
      gene_id : "ENSG00000236362.8",
      gene_type : "protein_coding",
      gene_name : "GAGE12F",
      gene_level : 2,
      hgnc_id : "HGNC:31906",
      havana_gene : "OTTHUMG00000024147.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49551333,
      stop : 49558649,
      direction : "+",
      ID : "ENSG00000216649.3",
      gene_id : "ENSG00000216649.3",
      gene_type : "protein_coding",
      gene_name : "GAGE12E",
      gene_level : 2,
      hgnc_id : "HGNC:31905",
      havana_gene : "OTTHUMG00000024146.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49570434,
      stop : 49577754,
      direction : "+",
      ID : "ENSG00000215269.5",
      gene_id : "ENSG00000215269.5",
      gene_type : "protein_coding",
      gene_name : "GAGE12G",
      gene_level : 2,
      hgnc_id : "HGNC:31907",
      havana_gene : "OTTHUMG00000024148.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49579983,
      stop : 49587301,
      direction : "+",
      ID : "ENSG00000224902.5",
      gene_id : "ENSG00000224902.5",
      gene_type : "protein_coding",
      gene_name : "GAGE12H",
      gene_level : 2,
      hgnc_id : "HGNC:31908",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49589529,
      stop : 49596827,
      direction : "+",
      ID : "ENSG00000189064.8",
      gene_id : "ENSG00000189064.8",
      gene_type : "protein_coding",
      gene_name : "GAGE2A",
      gene_level : 2,
      hgnc_id : "HGNC:4099",
      havana_gene : "OTTHUMG00000024143.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49599025,
      stop : 49608536,
      direction : "+",
      ID : "ENSG00000205777.18",
      gene_id : "ENSG00000205777.18",
      gene_type : "protein_coding",
      gene_name : "GAGE1",
      gene_level : 2,
      hgnc_id : "HGNC:4098",
      havana_gene : "OTTHUMG00000024150.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49687447,
      stop : 49695984,
      direction : "-",
      ID : "ENSG00000068985.5",
      gene_id : "ENSG00000068985.5",
      gene_type : "protein_coding",
      gene_name : "PAGE1",
      gene_level : 2,
      hgnc_id : "HGNC:4107",
      havana_gene : "OTTHUMG00000033224.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49829260,
      stop : 49834264,
      direction : "+",
      ID : "ENSG00000101951.17",
      gene_id : "ENSG00000101951.17",
      gene_type : "protein_coding",
      gene_name : "PAGE4",
      gene_level : 2,
      hgnc_id : "HGNC:4108",
      havana_gene : "OTTHUMG00000024155.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49879484,
      stop : 49882558,
      direction : "+",
      ID : "ENSG00000273820.2",
      gene_id : "ENSG00000273820.2",
      gene_type : "protein_coding",
      gene_name : "USP27X",
      gene_level : 2,
      hgnc_id : "HGNC:13486",
      havana_gene : "OTTHUMG00000189037.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 49922596,
      stop : 50099235,
      direction : "+",
      ID : "ENSG00000171365.17",
      gene_id : "ENSG00000171365.17",
      gene_type : "protein_coding",
      gene_name : "CLCN5",
      gene_level : 2,
      hgnc_id : "HGNC:2023",
      havana_gene : "OTTHUMG00000021514.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 50190777,
      stop : 50201007,
      direction : "-",
      ID : "ENSG00000147081.15",
      gene_id : "ENSG00000147081.15",
      gene_type : "protein_coding",
      gene_name : "AKAP4",
      gene_level : 2,
      hgnc_id : "HGNC:374",
      havana_gene : "OTTHUMG00000021517.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 50202713,
      stop : 50351914,
      direction : "+",
      ID : "ENSG00000147082.18",
      gene_id : "ENSG00000147082.18",
      gene_type : "protein_coding",
      gene_name : "CCNB3",
      gene_level : 2,
      hgnc_id : "HGNC:18709",
      havana_gene : "OTTHUMG00000021519.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 50365409,
      stop : 50470825,
      direction : "-",
      ID : "ENSG00000274588.2",
      gene_id : "ENSG00000274588.2",
      gene_type : "protein_coding",
      gene_name : "DGKK",
      gene_level : 2,
      hgnc_id : "HGNC:32395",
      havana_gene : "OTTHUMG00000021520.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 50591642,
      stop : 50814302,
      direction : "-",
      ID : "ENSG00000158352.17",
      gene_id : "ENSG00000158352.17",
      gene_type : "protein_coding",
      gene_name : "SHROOM4",
      gene_level : 2,
      hgnc_id : "HGNC:29215",
      havana_gene : "OTTHUMG00000021521.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 50910735,
      stop : 50916641,
      direction : "+",
      ID : "ENSG00000130385.6",
      gene_id : "ENSG00000130385.6",
      gene_type : "protein_coding",
      gene_name : "BMP15",
      gene_level : 2,
      hgnc_id : "HGNC:1068",
      havana_gene : "OTTHUMG00000021525.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51332231,
      stop : 51337525,
      direction : "+",
      ID : "ENSG00000122824.11",
      gene_id : "ENSG00000122824.11",
      gene_type : "protein_coding",
      gene_name : "NUDT10",
      gene_level : 2,
      hgnc_id : "HGNC:17621",
      havana_gene : "OTTHUMG00000021530.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51406948,
      stop : 51408843,
      direction : "+",
      ID : "ENSG00000187690.4",
      gene_id : "ENSG00000187690.4",
      gene_type : "protein_coding",
      gene_name : "EZHIP",
      gene_level : 2,
      hgnc_id : "HGNC:33738",
      havana_gene : "OTTHUMG00000187481.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51490011,
      stop : 51496592,
      direction : "-",
      ID : "ENSG00000196368.5",
      gene_id : "ENSG00000196368.5",
      gene_type : "protein_coding",
      gene_name : "NUDT11",
      gene_level : 2,
      hgnc_id : "HGNC:18011",
      havana_gene : "OTTHUMG00000021531.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51617020,
      stop : 51618912,
      direction : "-",
      ID : "ENSG00000224109.4",
      gene_id : "ENSG00000224109.4",
      gene_type : "protein_coding",
      gene_name : "CENPVL3",
      gene_level : 2,
      hgnc_id : "HGNC:43880",
      havana_gene : "OTTHUMG00000021534.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51681212,
      stop : 51682831,
      direction : "-",
      ID : "ENSG00000283093.1",
      gene_id : "ENSG00000283093.1",
      gene_type : "protein_coding",
      gene_name : "CENPVL2",
      gene_level : 2,
      hgnc_id : "HGNC:43879",
      havana_gene : "OTTHUMG00000191517.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51710512,
      stop : 51712131,
      direction : "+",
      ID : "ENSG00000223591.5",
      gene_id : "ENSG00000223591.5",
      gene_type : "protein_coding",
      gene_name : "CENPVL1",
      gene_level : 2,
      hgnc_id : "HGNC:31851",
      havana_gene : "OTTHUMG00000021539.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51743442,
      stop : 51746232,
      direction : "+",
      ID : "ENSG00000189369.9",
      gene_id : "ENSG00000189369.9",
      gene_type : "protein_coding",
      gene_name : "GSPT2",
      gene_level : 2,
      hgnc_id : "HGNC:4622",
      havana_gene : "OTTHUMG00000021538.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 51803007,
      stop : 51902354,
      direction : "+",
      ID : "ENSG00000179222.18",
      gene_id : "ENSG00000179222.18",
      gene_type : "protein_coding",
      gene_name : "MAGED1",
      gene_level : 2,
      hgnc_id : "HGNC:6813",
      havana_gene : "OTTHUMG00000021540.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52061827,
      stop : 52069248,
      direction : "-",
      ID : "ENSG00000187243.16",
      gene_id : "ENSG00000187243.16",
      gene_type : "protein_coding",
      gene_name : "MAGED4B",
      gene_level : 2,
      hgnc_id : "HGNC:22880",
      havana_gene : "OTTHUMG00000021546.5",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52184823,
      stop : 52192268,
      direction : "+",
      ID : "ENSG00000154545.16",
      gene_id : "ENSG00000154545.16",
      gene_type : "protein_coding",
      gene_name : "MAGED4",
      gene_level : 2,
      hgnc_id : "HGNC:23793",
      havana_gene : "OTTHUMG00000042235.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52369021,
      stop : 52375680,
      direction : "+",
      ID : "ENSG00000155622.7",
      gene_id : "ENSG00000155622.7",
      gene_type : "protein_coding",
      gene_name : "XAGE2",
      gene_level : 2,
      hgnc_id : "HGNC:4112",
      havana_gene : "OTTHUMG00000021549.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52495808,
      stop : 52500812,
      direction : "+",
      ID : "ENSG00000204379.11",
      gene_id : "ENSG00000204379.11",
      gene_type : "protein_coding",
      gene_name : "XAGE1A",
      gene_level : 2,
      hgnc_id : "HGNC:4111",
      havana_gene : "OTTHUMG00000021557.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52512077,
      stop : 52520803,
      direction : "-",
      ID : "ENSG00000204382.11",
      gene_id : "ENSG00000204382.11",
      gene_type : "protein_coding",
      gene_name : "XAGE1B",
      gene_level : 2,
      hgnc_id : "HGNC:25400",
      havana_gene : "OTTHUMG00000163577.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52644061,
      stop : 52654900,
      direction : "-",
      ID : "ENSG00000187754.9",
      gene_id : "ENSG00000187754.9",
      gene_type : "protein_coding",
      gene_name : "SSX7",
      gene_level : 2,
      hgnc_id : "HGNC:19653",
      havana_gene : "OTTHUMG00000021572.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52696896,
      stop : 52707189,
      direction : "-",
      ID : "ENSG00000241476.8",
      gene_id : "ENSG00000241476.8",
      gene_type : "protein_coding",
      gene_name : "SSX2",
      gene_level : 2,
      hgnc_id : "HGNC:11336",
      havana_gene : "OTTHUMG00000022697.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52751132,
      stop : 52790305,
      direction : "+",
      ID : "ENSG00000268447.6",
      gene_id : "ENSG00000268447.6",
      gene_type : "protein_coding",
      gene_name : "SSX2B",
      gene_level : 2,
      hgnc_id : "HGNC:22263",
      havana_gene : "OTTHUMG00000021593.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52796144,
      stop : 52797427,
      direction : "-",
      ID : "ENSG00000204363.5",
      gene_id : "ENSG00000204363.5",
      gene_type : "protein_coding",
      gene_name : "SPANXN5",
      gene_level : 2,
      hgnc_id : "HGNC:33178",
      havana_gene : "OTTHUMG00000021590.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52812204,
      stop : 52818301,
      direction : "+",
      ID : "ENSG00000171405.12",
      gene_id : "ENSG00000171405.12",
      gene_type : "protein_coding",
      gene_name : "XAGE5",
      gene_level : 2,
      hgnc_id : "HGNC:30930",
      havana_gene : "OTTHUMG00000021589.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52862525,
      stop : 52868083,
      direction : "-",
      ID : "ENSG00000171402.15",
      gene_id : "ENSG00000171402.15",
      gene_type : "protein_coding",
      gene_name : "XAGE3",
      gene_level : 2,
      hgnc_id : "HGNC:14618",
      havana_gene : "OTTHUMG00000021587.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52891306,
      stop : 52908560,
      direction : "+",
      ID : "ENSG00000179304.17",
      gene_id : "ENSG00000179304.17",
      gene_type : "protein_coding",
      gene_name : "FAM156B",
      gene_level : 2,
      hgnc_id : "HGNC:31962",
      havana_gene : "OTTHUMG00000188219.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 52926402,
      stop : 52995472,
      direction : "-",
      ID : "ENSG00000268350.7",
      gene_id : "ENSG00000268350.7",
      gene_type : "protein_coding",
      gene_name : "FAM156A",
      gene_level : 2,
      hgnc_id : "HGNC:30114",
      havana_gene : "OTTHUMG00000188220.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53048789,
      stop : 53080615,
      direction : "+",
      ID : "ENSG00000184194.6",
      gene_id : "ENSG00000184194.6",
      gene_type : "protein_coding",
      gene_name : "GPR173",
      gene_level : 2,
      hgnc_id : "HGNC:18186",
      havana_gene : "OTTHUMG00000021596.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53082367,
      stop : 53088540,
      direction : "+",
      ID : "ENSG00000184205.14",
      gene_id : "ENSG00000184205.14",
      gene_type : "protein_coding",
      gene_name : "TSPYL2",
      gene_level : 2,
      hgnc_id : "HGNC:24358",
      havana_gene : "OTTHUMG00000021597.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53094145,
      stop : 53170914,
      direction : "+",
      ID : "ENSG00000232593.7",
      gene_id : "ENSG00000232593.7",
      gene_type : "protein_coding",
      gene_name : "KANTR",
      gene_level : 2,
      hgnc_id : "HGNC:49510",
      havana_gene : "OTTHUMG00000021603.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53191321,
      stop : 53225422,
      direction : "-",
      ID : "ENSG00000126012.12",
      gene_id : "ENSG00000126012.12",
      gene_type : "protein_coding",
      gene_name : "KDM5C",
      gene_level : 2,
      hgnc_id : "HGNC:11114",
      havana_gene : "OTTHUMG00000021606.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53225828,
      stop : 53321350,
      direction : "-",
      ID : "ENSG00000124313.18",
      gene_id : "ENSG00000124313.18",
      gene_type : "protein_coding",
      gene_name : "IQSEC2",
      gene_level : 2,
      hgnc_id : "HGNC:29059",
      havana_gene : "OTTHUMG00000021608.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53374149,
      stop : 53422728,
      direction : "-",
      ID : "ENSG00000072501.19",
      gene_id : "ENSG00000072501.19",
      gene_type : "protein_coding",
      gene_name : "SMC1A",
      gene_level : 2,
      hgnc_id : "HGNC:11111",
      havana_gene : "OTTHUMG00000021614.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53422690,
      stop : 53431120,
      direction : "+",
      ID : "ENSG00000158423.17",
      gene_id : "ENSG00000158423.17",
      gene_type : "protein_coding",
      gene_name : "RIBC1",
      gene_level : 2,
      hgnc_id : "HGNC:26537",
      havana_gene : "OTTHUMG00000021615.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53431258,
      stop : 53434370,
      direction : "-",
      ID : "ENSG00000072506.13",
      gene_id : "ENSG00000072506.13",
      gene_type : "protein_coding",
      gene_name : "HSD17B10",
      gene_level : 2,
      hgnc_id : "HGNC:4800",
      havana_gene : "OTTHUMG00000021612.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53532096,
      stop : 53686728,
      direction : "-",
      ID : "ENSG00000086758.16",
      gene_id : "ENSG00000086758.16",
      gene_type : "protein_coding",
      gene_name : "HUWE1",
      gene_level : 2,
      hgnc_id : "HGNC:30892",
      havana_gene : "OTTHUMG00000021617.10",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 53936676,
      stop : 54048958,
      direction : "-",
      ID : "ENSG00000172943.20",
      gene_id : "ENSG00000172943.20",
      gene_type : "protein_coding",
      gene_name : "PHF8",
      gene_level : 1,
      hgnc_id : "HGNC:20672",
      havana_gene : "OTTHUMG00000021622.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54068324,
      stop : 54183281,
      direction : "-",
      ID : "ENSG00000184083.12",
      gene_id : "ENSG00000184083.12",
      gene_type : "protein_coding",
      gene_name : "FAM120C",
      gene_level : 2,
      hgnc_id : "HGNC:16949",
      havana_gene : "OTTHUMG00000021625.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54192823,
      stop : 54358642,
      direction : "-",
      ID : "ENSG00000196632.10",
      gene_id : "ENSG00000196632.10",
      gene_type : "protein_coding",
      gene_name : "WNK3",
      gene_level : 2,
      hgnc_id : "HGNC:14543",
      havana_gene : "OTTHUMG00000021626.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54440404,
      stop : 54448032,
      direction : "+",
      ID : "ENSG00000158526.8",
      gene_id : "ENSG00000158526.8",
      gene_type : "protein_coding",
      gene_name : "TSR2",
      gene_level : 2,
      hgnc_id : "HGNC:25455",
      havana_gene : "OTTHUMG00000021628.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54445454,
      stop : 54496234,
      direction : "-",
      ID : "ENSG00000102302.8",
      gene_id : "ENSG00000102302.8",
      gene_type : "protein_coding",
      gene_name : "FGD1",
      gene_level : 2,
      hgnc_id : "HGNC:3663",
      havana_gene : "OTTHUMG00000021627.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54530183,
      stop : 54621521,
      direction : "+",
      ID : "ENSG00000130119.17",
      gene_id : "ENSG00000130119.17",
      gene_type : "protein_coding",
      gene_name : "GNL3L",
      gene_level : 2,
      hgnc_id : "HGNC:25553",
      havana_gene : "OTTHUMG00000021629.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54748918,
      stop : 54798255,
      direction : "-",
      ID : "ENSG00000102313.9",
      gene_id : "ENSG00000102313.9",
      gene_type : "protein_coding",
      gene_name : "ITIH6",
      gene_level : 1,
      hgnc_id : "HGNC:28907",
      havana_gene : "OTTHUMG00000021634.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54807599,
      stop : 54816015,
      direction : "+",
      ID : "ENSG00000102316.17",
      gene_id : "ENSG00000102316.17",
      gene_type : "protein_coding",
      gene_name : "MAGED2",
      gene_level : 2,
      hgnc_id : "HGNC:16353",
      havana_gene : "OTTHUMG00000021638.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54920462,
      stop : 54931431,
      direction : "+",
      ID : "ENSG00000067445.21",
      gene_id : "ENSG00000067445.21",
      gene_type : "protein_coding",
      gene_name : "TRO",
      gene_level : 1,
      hgnc_id : "HGNC:12326",
      havana_gene : "OTTHUMG00000021640.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 54932961,
      stop : 54998534,
      direction : "-",
      ID : "ENSG00000158571.11",
      gene_id : "ENSG00000158571.11",
      gene_type : "protein_coding",
      gene_name : "PFKFB1",
      gene_level : 2,
      hgnc_id : "HGNC:8872",
      havana_gene : "OTTHUMG00000021643.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55000363,
      stop : 55009057,
      direction : "+",
      ID : "ENSG00000169188.5",
      gene_id : "ENSG00000169188.5",
      gene_type : "protein_coding",
      gene_name : "APEX2",
      gene_level : 2,
      hgnc_id : "HGNC:17889",
      havana_gene : "OTTHUMG00000021642.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55009055,
      stop : 55030977,
      direction : "-",
      ID : "ENSG00000158578.21",
      gene_id : "ENSG00000158578.21",
      gene_type : "protein_coding",
      gene_name : "ALAS2",
      gene_level : 1,
      hgnc_id : "HGNC:397",
      havana_gene : "OTTHUMG00000021641.10",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55075030,
      stop : 55078909,
      direction : "+",
      ID : "ENSG00000238269.9",
      gene_id : "ENSG00000238269.9",
      gene_type : "protein_coding",
      gene_name : "PAGE2B",
      gene_level : 2,
      hgnc_id : "HGNC:31805",
      havana_gene : "OTTHUMG00000021645.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55089018,
      stop : 55092842,
      direction : "+",
      ID : "ENSG00000234068.7",
      gene_id : "ENSG00000234068.7",
      gene_type : "protein_coding",
      gene_name : "PAGE2",
      gene_level : 2,
      hgnc_id : "HGNC:31804",
      havana_gene : "OTTHUMG00000021648.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55143102,
      stop : 55161310,
      direction : "-",
      ID : "ENSG00000182518.13",
      gene_id : "ENSG00000182518.13",
      gene_type : "protein_coding",
      gene_name : "FAM104B",
      gene_level : 1,
      hgnc_id : "HGNC:25085",
      havana_gene : "OTTHUMG00000021646.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55181392,
      stop : 55182442,
      direction : "-",
      ID : "ENSG00000256045.3",
      gene_id : "ENSG00000256045.3",
      gene_type : "protein_coding",
      gene_name : "MTRNR2L10",
      gene_level : 2,
      hgnc_id : "HGNC:37167",
      havana_gene : "OTTHUMG00000184991.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55220346,
      stop : 55224108,
      direction : "+",
      ID : "ENSG00000158639.13",
      gene_id : "ENSG00000158639.13",
      gene_type : "protein_coding",
      gene_name : "PAGE5",
      gene_level : 2,
      hgnc_id : "HGNC:29992",
      havana_gene : "OTTHUMG00000021650.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55258412,
      stop : 55264846,
      direction : "-",
      ID : "ENSG00000204279.7",
      gene_id : "ENSG00000204279.7",
      gene_type : "protein_coding",
      gene_name : "PAGE3",
      gene_level : 2,
      hgnc_id : "HGNC:4110",
      havana_gene : "OTTHUMG00000021654.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55452127,
      stop : 55453566,
      direction : "+",
      ID : "ENSG00000187601.5",
      gene_id : "ENSG00000187601.5",
      gene_type : "protein_coding",
      gene_name : "MAGEH1",
      gene_level : 2,
      hgnc_id : "HGNC:24092",
      havana_gene : "OTTHUMG00000021655.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55484616,
      stop : 55489202,
      direction : "-",
      ID : "ENSG00000247746.4",
      gene_id : "ENSG00000247746.4",
      gene_type : "protein_coding",
      gene_name : "USP51",
      gene_level : 2,
      hgnc_id : "HGNC:23086",
      havana_gene : "OTTHUMG00000021656.5",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55623400,
      stop : 55626192,
      direction : "+",
      ID : "ENSG00000189299.7",
      gene_id : "ENSG00000189299.7",
      gene_type : "protein_coding",
      gene_name : "FOXR2",
      gene_level : 2,
      hgnc_id : "HGNC:30469",
      havana_gene : "OTTHUMG00000021661.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 55717749,
      stop : 55758774,
      direction : "+",
      ID : "ENSG00000083750.13",
      gene_id : "ENSG00000083750.13",
      gene_type : "protein_coding",
      gene_name : "RRAGB",
      gene_level : 2,
      hgnc_id : "HGNC:19901",
      havana_gene : "OTTHUMG00000021662.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 56232356,
      stop : 56291531,
      direction : "+",
      ID : "ENSG00000102349.18",
      gene_id : "ENSG00000102349.18",
      gene_type : "protein_coding",
      gene_name : "KLF8",
      gene_level : 2,
      hgnc_id : "HGNC:6351",
      havana_gene : "OTTHUMG00000021666.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 56563627,
      stop : 56567868,
      direction : "+",
      ID : "ENSG00000188021.9",
      gene_id : "ENSG00000188021.9",
      gene_type : "protein_coding",
      gene_name : "UBQLN2",
      gene_level : 2,
      hgnc_id : "HGNC:12509",
      havana_gene : "OTTHUMG00000021669.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 56729241,
      stop : 56819179,
      direction : "+",
      ID : "ENSG00000204272.13",
      gene_id : "ENSG00000204272.13",
      gene_type : "protein_coding",
      gene_name : "NBDY",
      gene_level : 2,
      hgnc_id : "HGNC:50713",
      havana_gene : "OTTHUMG00000021676.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 56818298,
      stop : 56995827,
      direction : "-",
      ID : "ENSG00000204271.13",
      gene_id : "ENSG00000204271.13",
      gene_type : "protein_coding",
      gene_name : "SPIN3",
      gene_level : 2,
      hgnc_id : "HGNC:27272",
      havana_gene : "OTTHUMG00000021677.10",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 57118551,
      stop : 57121548,
      direction : "-",
      ID : "ENSG00000186787.10",
      gene_id : "ENSG00000186787.10",
      gene_type : "protein_coding",
      gene_name : "SPIN2B",
      gene_level : 2,
      hgnc_id : "HGNC:33147",
      havana_gene : "OTTHUMG00000021680.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 57134530,
      stop : 57137625,
      direction : "-",
      ID : "ENSG00000147059.8",
      gene_id : "ENSG00000147059.8",
      gene_type : "protein_coding",
      gene_name : "SPIN2A",
      gene_level : 2,
      hgnc_id : "HGNC:20694",
      havana_gene : "OTTHUMG00000022705.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 57286706,
      stop : 57489193,
      direction : "+",
      ID : "ENSG00000165591.7",
      gene_id : "ENSG00000165591.7",
      gene_type : "protein_coding",
      gene_name : "FAAH2",
      gene_level : 2,
      hgnc_id : "HGNC:26440",
      havana_gene : "OTTHUMG00000021684.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 57592011,
      stop : 57597477,
      direction : "+",
      ID : "ENSG00000198455.5",
      gene_id : "ENSG00000198455.5",
      gene_type : "protein_coding",
      gene_name : "ZXDB",
      gene_level : 2,
      hgnc_id : "HGNC:13199",
      havana_gene : "OTTHUMG00000021685.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 57677067,
      stop : 57680260,
      direction : "-",
      ID : "ENSG00000215174.2",
      gene_id : "ENSG00000215174.2",
      gene_type : "protein_coding",
      gene_name : "NLRP2B",
      gene_level : 2,
      hgnc_id : "HGNC:29887",
      havana_gene : "OTTHUMG00000021686.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 57905430,
      stop : 57910458,
      direction : "-",
      ID : "ENSG00000198205.7",
      gene_id : "ENSG00000198205.7",
      gene_type : "protein_coding",
      gene_name : "ZXDA",
      gene_level : 2,
      hgnc_id : "HGNC:13198",
      havana_gene : "OTTHUMG00000021688.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 63347228,
      stop : 63351332,
      direction : "-",
      ID : "ENSG00000186767.7",
      gene_id : "ENSG00000186767.7",
      gene_type : "protein_coding",
      gene_name : "SPIN4",
      gene_level : 2,
      hgnc_id : "HGNC:27040",
      havana_gene : "OTTHUMG00000021696.4",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 63634967,
      stop : 63809274,
      direction : "-",
      ID : "ENSG00000131089.17",
      gene_id : "ENSG00000131089.17",
      gene_type : "protein_coding",
      gene_name : "ARHGEF9",
      gene_level : 2,
      hgnc_id : "HGNC:14561",
      havana_gene : "OTTHUMG00000021700.17",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 63754485,
      stop : 63754664,
      direction : "-",
      ID : "ENSG00000288661.1",
      gene_id : "ENSG00000288661.1",
      gene_type : "protein_coding",
      gene_name : "AL451106.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 64185117,
      stop : 64205708,
      direction : "-",
      ID : "ENSG00000184675.11",
      gene_id : "ENSG00000184675.11",
      gene_type : "protein_coding",
      gene_name : "AMER1",
      gene_level : 2,
      hgnc_id : "HGNC:26837",
      havana_gene : "OTTHUMG00000021703.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 64224194,
      stop : 64230607,
      direction : "-",
      ID : "ENSG00000198881.10",
      gene_id : "ENSG00000198881.10",
      gene_type : "protein_coding",
      gene_name : "ASB12",
      gene_level : 2,
      hgnc_id : "HGNC:19763",
      havana_gene : "OTTHUMG00000021705.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 64268081,
      stop : 64395452,
      direction : "-",
      ID : "ENSG00000102043.16",
      gene_id : "ENSG00000102043.16",
      gene_type : "protein_coding",
      gene_name : "MTMR8",
      gene_level : 2,
      hgnc_id : "HGNC:16825",
      havana_gene : "OTTHUMG00000021707.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 64915802,
      stop : 65034713,
      direction : "-",
      ID : "ENSG00000126970.16",
      gene_id : "ENSG00000126970.16",
      gene_type : "protein_coding",
      gene_name : "ZC4H2",
      gene_level : 2,
      hgnc_id : "HGNC:24931",
      havana_gene : "OTTHUMG00000021712.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 65366638,
      stop : 65507887,
      direction : "+",
      ID : "ENSG00000102053.12",
      gene_id : "ENSG00000102053.12",
      gene_type : "protein_coding",
      gene_name : "ZC3H12B",
      gene_level : 2,
      hgnc_id : "HGNC:17407",
      havana_gene : "OTTHUMG00000021719.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 65438549,
      stop : 65534810,
      direction : "-",
      ID : "ENSG00000001497.18",
      gene_id : "ENSG00000001497.18",
      gene_type : "protein_coding",
      gene_name : "LAS1L",
      gene_level : 2,
      hgnc_id : "HGNC:25726",
      havana_gene : "OTTHUMG00000021720.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 65588377,
      stop : 65741931,
      direction : "+",
      ID : "ENSG00000147065.17",
      gene_id : "ENSG00000147065.17",
      gene_type : "protein_coding",
      gene_name : "MSN",
      gene_level : 2,
      hgnc_id : "HGNC:7373",
      havana_gene : "OTTHUMG00000021723.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 66021738,
      stop : 66040125,
      direction : "-",
      ID : "ENSG00000155659.15",
      gene_id : "ENSG00000155659.15",
      gene_type : "protein_coding",
      gene_name : "VSIG4",
      gene_level : 2,
      hgnc_id : "HGNC:17032",
      havana_gene : "OTTHUMG00000021727.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 66162549,
      stop : 66268867,
      direction : "+",
      ID : "ENSG00000089472.16",
      gene_id : "ENSG00000089472.16",
      gene_type : "protein_coding",
      gene_name : "HEPH",
      gene_level : 1,
      hgnc_id : "HGNC:4866",
      havana_gene : "OTTHUMG00000021732.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 66595637,
      stop : 66639298,
      direction : "-",
      ID : "ENSG00000131080.15",
      gene_id : "ENSG00000131080.15",
      gene_type : "protein_coding",
      gene_name : "EDA2R",
      gene_level : 2,
      hgnc_id : "HGNC:17756",
      havana_gene : "OTTHUMG00000021736.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 67544021,
      stop : 67730619,
      direction : "+",
      ID : "ENSG00000169083.18",
      gene_id : "ENSG00000169083.18",
      gene_type : "protein_coding",
      gene_name : "AR",
      gene_level : 1,
      hgnc_id : "HGNC:644",
      havana_gene : "OTTHUMG00000021740.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 67949349,
      stop : 68433913,
      direction : "-",
      ID : "ENSG00000079482.14",
      gene_id : "ENSG00000079482.14",
      gene_type : "protein_coding",
      gene_name : "OPHN1",
      gene_level : 2,
      hgnc_id : "HGNC:8148",
      havana_gene : "OTTHUMG00000021744.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 68498562,
      stop : 68537282,
      direction : "+",
      ID : "ENSG00000181704.12",
      gene_id : "ENSG00000181704.12",
      gene_type : "protein_coding",
      gene_name : "YIPF6",
      gene_level : 2,
      hgnc_id : "HGNC:28304",
      havana_gene : "OTTHUMG00000021745.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 68647666,
      stop : 68725842,
      direction : "+",
      ID : "ENSG00000130052.13",
      gene_id : "ENSG00000130052.13",
      gene_type : "protein_coding",
      gene_name : "STARD8",
      gene_level : 2,
      hgnc_id : "HGNC:19161",
      havana_gene : "OTTHUMG00000021748.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 68829021,
      stop : 68842160,
      direction : "+",
      ID : "ENSG00000090776.6",
      gene_id : "ENSG00000090776.6",
      gene_type : "protein_coding",
      gene_name : "EFNB1",
      gene_level : 2,
      hgnc_id : "HGNC:3226",
      havana_gene : "OTTHUMG00000021751.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 69160851,
      stop : 69165521,
      direction : "-",
      ID : "ENSG00000181191.12",
      gene_id : "ENSG00000181191.12",
      gene_type : "protein_coding",
      gene_name : "PJA1",
      gene_level : 1,
      hgnc_id : "HGNC:16648",
      havana_gene : "OTTHUMG00000021753.7",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 69504326,
      stop : 69532508,
      direction : "+",
      ID : "ENSG00000130054.5",
      gene_id : "ENSG00000130054.5",
      gene_type : "protein_coding",
      gene_name : "FAM155B",
      gene_level : 2,
      hgnc_id : "HGNC:30701",
      havana_gene : "OTTHUMG00000021756.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 69616067,
      stop : 70039472,
      direction : "+",
      ID : "ENSG00000158813.18",
      gene_id : "ENSG00000158813.18",
      gene_type : "protein_coding",
      gene_name : "EDA",
      gene_level : 2,
      hgnc_id : "HGNC:3157",
      havana_gene : "OTTHUMG00000021764.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70040542,
      stop : 70049938,
      direction : "-",
      ID : "ENSG00000147160.9",
      gene_id : "ENSG00000147160.9",
      gene_type : "protein_coding",
      gene_name : "AWAT2",
      gene_level : 2,
      hgnc_id : "HGNC:23251",
      havana_gene : "OTTHUMG00000021763.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70062457,
      stop : 70064179,
      direction : "+",
      ID : "ENSG00000189401.3",
      gene_id : "ENSG00000189401.3",
      gene_type : "protein_coding",
      gene_name : "OTUD6A",
      gene_level : 2,
      hgnc_id : "HGNC:32312",
      havana_gene : "OTTHUMG00000159996.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70133447,
      stop : 70166324,
      direction : "+",
      ID : "ENSG00000089289.16",
      gene_id : "ENSG00000089289.16",
      gene_type : "protein_coding",
      gene_name : "IGBP1",
      gene_level : 2,
      hgnc_id : "HGNC:5461",
      havana_gene : "OTTHUMG00000021767.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70177483,
      stop : 70205704,
      direction : "+",
      ID : "ENSG00000184210.6",
      gene_id : "ENSG00000184210.6",
      gene_type : "protein_coding",
      gene_name : "DGAT2L6",
      gene_level : 2,
      hgnc_id : "HGNC:23250",
      havana_gene : "OTTHUMG00000021774.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70234655,
      stop : 70240659,
      direction : "+",
      ID : "ENSG00000204195.4",
      gene_id : "ENSG00000204195.4",
      gene_type : "protein_coding",
      gene_name : "AWAT1",
      gene_level : 2,
      hgnc_id : "HGNC:23252",
      havana_gene : "OTTHUMG00000021773.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70258170,
      stop : 70259764,
      direction : "-",
      ID : "ENSG00000186912.6",
      gene_id : "ENSG00000186912.6",
      gene_type : "protein_coding",
      gene_name : "P2RY4",
      gene_level : 2,
      hgnc_id : "HGNC:8542",
      havana_gene : "OTTHUMG00000021769.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70268305,
      stop : 70281840,
      direction : "+",
      ID : "ENSG00000120500.18",
      gene_id : "ENSG00000120500.18",
      gene_type : "protein_coding",
      gene_name : "ARR3",
      gene_level : 2,
      hgnc_id : "HGNC:710",
      havana_gene : "OTTHUMG00000021768.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70282093,
      stop : 70285002,
      direction : "+",
      ID : "ENSG00000147127.8",
      gene_id : "ENSG00000147127.8",
      gene_type : "protein_coding",
      gene_name : "RAB41",
      gene_level : 2,
      hgnc_id : "HGNC:18293",
      havana_gene : "OTTHUMG00000021772.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70286595,
      stop : 70290514,
      direction : "-",
      ID : "ENSG00000120509.11",
      gene_id : "ENSG00000120509.11",
      gene_type : "protein_coding",
      gene_name : "PDZD11",
      gene_level : 2,
      hgnc_id : "HGNC:28034",
      havana_gene : "OTTHUMG00000021771.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70290104,
      stop : 70420886,
      direction : "+",
      ID : "ENSG00000090889.12",
      gene_id : "ENSG00000090889.12",
      gene_type : "protein_coding",
      gene_name : "KIF4A",
      gene_level : 2,
      hgnc_id : "HGNC:13339",
      havana_gene : "OTTHUMG00000021775.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70423031,
      stop : 70433390,
      direction : "+",
      ID : "ENSG00000130055.14",
      gene_id : "ENSG00000130055.14",
      gene_type : "protein_coding",
      gene_name : "GDPD2",
      gene_level : 2,
      hgnc_id : "HGNC:25974",
      havana_gene : "OTTHUMG00000021776.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70444835,
      stop : 70505490,
      direction : "+",
      ID : "ENSG00000082458.12",
      gene_id : "ENSG00000082458.12",
      gene_type : "protein_coding",
      gene_name : "DLG3",
      gene_level : 2,
      hgnc_id : "HGNC:2902",
      havana_gene : "OTTHUMG00000021778.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70528940,
      stop : 70908711,
      direction : "-",
      ID : "ENSG00000120498.14",
      gene_id : "ENSG00000120498.14",
      gene_type : "protein_coding",
      gene_name : "TEX11",
      gene_level : 2,
      hgnc_id : "HGNC:11733",
      havana_gene : "OTTHUMG00000021782.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 70925579,
      stop : 70931125,
      direction : "-",
      ID : "ENSG00000165349.12",
      gene_id : "ENSG00000165349.12",
      gene_type : "protein_coding",
      gene_name : "SLC7A3",
      gene_level : 2,
      hgnc_id : "HGNC:11061",
      havana_gene : "OTTHUMG00000021780.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71056332,
      stop : 71073426,
      direction : "-",
      ID : "ENSG00000147164.12",
      gene_id : "ENSG00000147164.12",
      gene_type : "protein_coding",
      gene_name : "SNX12",
      gene_level : 2,
      hgnc_id : "HGNC:14976",
      havana_gene : "OTTHUMG00000021786.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71095851,
      stop : 71103532,
      direction : "+",
      ID : "ENSG00000184481.17",
      gene_id : "ENSG00000184481.17",
      gene_type : "protein_coding",
      gene_name : "FOXO4",
      gene_level : 2,
      hgnc_id : "HGNC:7139",
      havana_gene : "OTTHUMG00000021789.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71103889,
      stop : 71106788,
      direction : "-",
      ID : "ENSG00000204165.6",
      gene_id : "ENSG00000204165.6",
      gene_type : "protein_coding",
      gene_name : "CXorf65",
      gene_level : 2,
      hgnc_id : "HGNC:33713",
      havana_gene : "OTTHUMG00000021785.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71103987,
      stop : 71111575,
      direction : "-",
      ID : "ENSG00000285171.1",
      gene_id : "ENSG00000285171.1",
      gene_type : "protein_coding",
      gene_name : "AL590764.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000192518.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71107404,
      stop : 71112108,
      direction : "-",
      ID : "ENSG00000147168.13",
      gene_id : "ENSG00000147168.13",
      gene_type : "protein_coding",
      gene_name : "IL2RG",
      gene_level : 1,
      hgnc_id : "HGNC:6010",
      havana_gene : "OTTHUMG00000021787.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71118556,
      stop : 71142454,
      direction : "+",
      ID : "ENSG00000184634.16",
      gene_id : "ENSG00000184634.16",
      gene_type : "protein_coding",
      gene_name : "MED12",
      gene_level : 2,
      hgnc_id : "HGNC:11957",
      havana_gene : "OTTHUMG00000021788.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71144831,
      stop : 71171201,
      direction : "+",
      ID : "ENSG00000196338.14",
      gene_id : "ENSG00000196338.14",
      gene_type : "protein_coding",
      gene_name : "NLGN3",
      gene_level : 2,
      hgnc_id : "HGNC:14289",
      havana_gene : "OTTHUMG00000021790.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71212811,
      stop : 71225516,
      direction : "+",
      ID : "ENSG00000169562.13",
      gene_id : "ENSG00000169562.13",
      gene_type : "protein_coding",
      gene_name : "GJB1",
      gene_level : 2,
      hgnc_id : "HGNC:4283",
      havana_gene : "OTTHUMG00000021797.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71239624,
      stop : 71255146,
      direction : "-",
      ID : "ENSG00000147130.14",
      gene_id : "ENSG00000147130.14",
      gene_type : "protein_coding",
      gene_name : "ZMYM3",
      gene_level : 2,
      hgnc_id : "HGNC:13054",
      havana_gene : "OTTHUMG00000021799.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71254814,
      stop : 71301522,
      direction : "+",
      ID : "ENSG00000147140.17",
      gene_id : "ENSG00000147140.17",
      gene_type : "protein_coding",
      gene_name : "NONO",
      gene_level : 2,
      hgnc_id : "HGNC:7871",
      havana_gene : "OTTHUMG00000021798.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71301750,
      stop : 71305371,
      direction : "+",
      ID : "ENSG00000147166.11",
      gene_id : "ENSG00000147166.11",
      gene_type : "protein_coding",
      gene_name : "ITGB1BP2",
      gene_level : 2,
      hgnc_id : "HGNC:6154",
      havana_gene : "OTTHUMG00000021793.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71366264,
      stop : 71532374,
      direction : "+",
      ID : "ENSG00000147133.16",
      gene_id : "ENSG00000147133.16",
      gene_type : "protein_coding",
      gene_name : "TAF1",
      gene_level : 1,
      hgnc_id : "HGNC:11535",
      havana_gene : "OTTHUMG00000022723.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71533104,
      stop : 71575892,
      direction : "+",
      ID : "ENSG00000147162.14",
      gene_id : "ENSG00000147162.14",
      gene_type : "protein_coding",
      gene_name : "OGT",
      gene_level : 1,
      hgnc_id : "HGNC:8127",
      havana_gene : "OTTHUMG00000033316.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71578411,
      stop : 71613583,
      direction : "+",
      ID : "ENSG00000147174.11",
      gene_id : "ENSG00000147174.11",
      gene_type : "protein_coding",
      gene_name : "GCNA",
      gene_level : 2,
      hgnc_id : "HGNC:15805",
      havana_gene : "OTTHUMG00000033327.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71615916,
      stop : 71618511,
      direction : "-",
      ID : "ENSG00000186810.8",
      gene_id : "ENSG00000186810.8",
      gene_type : "protein_coding",
      gene_name : "CXCR3",
      gene_level : 2,
      hgnc_id : "HGNC:4540",
      havana_gene : "OTTHUMG00000033326.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71667542,
      stop : 71671524,
      direction : "+",
      ID : "ENSG00000283599.2",
      gene_id : "ENSG00000283599.2",
      gene_type : "protein_coding",
      gene_name : "BX276092.9",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000191693.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71714371,
      stop : 71718151,
      direction : "-",
      ID : "ENSG00000215115.6",
      gene_id : "ENSG00000215115.6",
      gene_type : "protein_coding",
      gene_name : "CXorf49",
      gene_level : 2,
      hgnc_id : "HGNC:30891",
      havana_gene : "OTTHUMG00000022702.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71763424,
      stop : 71767204,
      direction : "+",
      ID : "ENSG00000215113.6",
      gene_id : "ENSG00000215113.6",
      gene_type : "protein_coding",
      gene_name : "CXorf49B",
      gene_level : 2,
      hgnc_id : "HGNC:34229",
      havana_gene : "OTTHUMG00000021804.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 71910818,
      stop : 72161750,
      direction : "+",
      ID : "ENSG00000204131.9",
      gene_id : "ENSG00000204131.9",
      gene_type : "protein_coding",
      gene_name : "NHSL2",
      gene_level : 2,
      hgnc_id : "HGNC:33737",
      havana_gene : "OTTHUMG00000021807.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72127110,
      stop : 72131901,
      direction : "-",
      ID : "ENSG00000242732.4",
      gene_id : "ENSG00000242732.4",
      gene_type : "protein_coding",
      gene_name : "RTL5",
      gene_level : 2,
      hgnc_id : "HGNC:29430",
      havana_gene : "OTTHUMG00000021808.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72181353,
      stop : 72302926,
      direction : "+",
      ID : "ENSG00000102309.15",
      gene_id : "ENSG00000102309.15",
      gene_type : "protein_coding",
      gene_name : "PIN4",
      gene_level : 1,
      hgnc_id : "HGNC:8992",
      havana_gene : "OTTHUMG00000021811.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72204657,
      stop : 72239027,
      direction : "-",
      ID : "ENSG00000186871.7",
      gene_id : "ENSG00000186871.7",
      gene_type : "protein_coding",
      gene_name : "ERCC6L",
      gene_level : 1,
      hgnc_id : "HGNC:20794",
      havana_gene : "OTTHUMG00000021810.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72255679,
      stop : 72277248,
      direction : "-",
      ID : "ENSG00000198034.11",
      gene_id : "ENSG00000198034.11",
      gene_type : "protein_coding",
      gene_name : "RPS4X",
      gene_level : 2,
      hgnc_id : "HGNC:10424",
      havana_gene : "OTTHUMG00000021813.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72301638,
      stop : 72307187,
      direction : "-",
      ID : "ENSG00000125931.11",
      gene_id : "ENSG00000125931.11",
      gene_type : "protein_coding",
      gene_name : "CITED1",
      gene_level : 2,
      hgnc_id : "HGNC:1986",
      havana_gene : "OTTHUMG00000021812.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72301691,
      stop : 72572843,
      direction : "-",
      ID : "ENSG00000285547.1",
      gene_id : "ENSG00000285547.1",
      gene_type : "protein_coding",
      gene_name : "AL133500.1",
      gene_level : 2,
      hgnc_id : "tag=ncRNA_host,overlapping_locus",
      havana_gene : "OTTHUMG00000192629.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72329516,
      stop : 72573101,
      direction : "-",
      ID : "ENSG00000147099.21",
      gene_id : "ENSG00000147099.21",
      gene_type : "protein_coding",
      gene_name : "HDAC8",
      gene_level : 2,
      hgnc_id : "HGNC:13315",
      havana_gene : "OTTHUMG00000021814.18",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72578814,
      stop : 72714319,
      direction : "-",
      ID : "ENSG00000067177.15",
      gene_id : "ENSG00000067177.15",
      gene_type : "protein_coding",
      gene_name : "PHKA1",
      gene_level : 2,
      hgnc_id : "HGNC:8925",
      havana_gene : "OTTHUMG00000022696.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72777009,
      stop : 72848802,
      direction : "+",
      ID : "ENSG00000184911.14",
      gene_id : "ENSG00000184911.14",
      gene_type : "protein_coding",
      gene_name : "DMRTC1B",
      gene_level : 2,
      hgnc_id : "HGNC:31686",
      havana_gene : "OTTHUMG00000021818.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72781865,
      stop : 72782660,
      direction : "-",
      ID : "ENSG00000268994.3",
      gene_id : "ENSG00000268994.3",
      gene_type : "protein_coding",
      gene_name : "FAM236B",
      gene_level : 2,
      hgnc_id : "HGNC:52640",
      havana_gene : "OTTHUMG00000188221.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72807425,
      stop : 72808210,
      direction : "-",
      ID : "ENSG00000225396.5",
      gene_id : "ENSG00000225396.5",
      gene_type : "protein_coding",
      gene_name : "FAM236D",
      gene_level : 2,
      hgnc_id : "HGNC:52642",
      havana_gene : "OTTHUMG00000021819.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72872025,
      stop : 72943814,
      direction : "-",
      ID : "ENSG00000269502.5",
      gene_id : "ENSG00000269502.5",
      gene_type : "protein_coding",
      gene_name : "DMRTC1",
      gene_level : 2,
      hgnc_id : "HGNC:13910",
      havana_gene : "OTTHUMG00000021820.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72912615,
      stop : 72913401,
      direction : "+",
      ID : "ENSG00000283594.1",
      gene_id : "ENSG00000283594.1",
      gene_type : "protein_coding",
      gene_name : "FAM236C",
      gene_level : 2,
      hgnc_id : "HGNC:52641",
      havana_gene : "OTTHUMG00000191677.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 72938163,
      stop : 72938958,
      direction : "+",
      ID : "ENSG00000275520.2",
      gene_id : "ENSG00000275520.2",
      gene_type : "protein_coding",
      gene_name : "FAM236A",
      gene_level : 2,
      hgnc_id : "HGNC:44268",
      havana_gene : "OTTHUMG00000188527.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 73002939,
      stop : 73006106,
      direction : "+",
      ID : "ENSG00000184388.6",
      gene_id : "ENSG00000184388.6",
      gene_type : "protein_coding",
      gene_name : "PABPC1L2B",
      gene_level : 2,
      hgnc_id : "HGNC:31852",
      havana_gene : "OTTHUMG00000021823.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 73077276,
      stop : 73079512,
      direction : "-",
      ID : "ENSG00000186288.5",
      gene_id : "ENSG00000186288.5",
      gene_type : "protein_coding",
      gene_name : "PABPC1L2A",
      gene_level : 2,
      hgnc_id : "HGNC:27989",
      havana_gene : "OTTHUMG00000021824.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 73212299,
      stop : 73214851,
      direction : "-",
      ID : "ENSG00000186462.9",
      gene_id : "ENSG00000186462.9",
      gene_type : "protein_coding",
      gene_name : "NAP1L2",
      gene_level : 2,
      hgnc_id : "HGNC:7638",
      havana_gene : "OTTHUMG00000021827.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 73447254,
      stop : 73455245,
      direction : "+",
      ID : "ENSG00000131264.3",
      gene_id : "ENSG00000131264.3",
      gene_type : "protein_coding",
      gene_name : "CDX4",
      gene_level : 2,
      hgnc_id : "HGNC:1808",
      havana_gene : "OTTHUMG00000021831.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 73563200,
      stop : 73687102,
      direction : "+",
      ID : "ENSG00000204116.11",
      gene_id : "ENSG00000204116.11",
      gene_type : "protein_coding",
      gene_name : "CHIC1",
      gene_level : 2,
      hgnc_id : "HGNC:1934",
      havana_gene : "OTTHUMG00000021835.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 74304180,
      stop : 74305034,
      direction : "+",
      ID : "ENSG00000187969.6",
      gene_id : "ENSG00000187969.6",
      gene_type : "protein_coding",
      gene_name : "ZCCHC13",
      gene_level : 2,
      hgnc_id : "HGNC:31749",
      havana_gene : "OTTHUMG00000021851.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 74421493,
      stop : 74533917,
      direction : "+",
      ID : "ENSG00000147100.11",
      gene_id : "ENSG00000147100.11",
      gene_type : "protein_coding",
      gene_name : "SLC16A2",
      gene_level : 1,
      hgnc_id : "HGNC:10923",
      havana_gene : "OTTHUMG00000021857.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 74582976,
      stop : 74614624,
      direction : "-",
      ID : "ENSG00000131263.13",
      gene_id : "ENSG00000131263.13",
      gene_type : "protein_coding",
      gene_name : "RLIM",
      gene_level : 2,
      hgnc_id : "HGNC:13429",
      havana_gene : "OTTHUMG00000021859.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 74732856,
      stop : 74925472,
      direction : "-",
      ID : "ENSG00000050030.16",
      gene_id : "ENSG00000050030.16",
      gene_type : "protein_coding",
      gene_name : "NEXMIF",
      gene_level : 2,
      hgnc_id : "HGNC:29433",
      havana_gene : "OTTHUMG00000021860.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 75051048,
      stop : 75156732,
      direction : "-",
      ID : "ENSG00000131269.19",
      gene_id : "ENSG00000131269.19",
      gene_type : "protein_coding",
      gene_name : "ABCB7",
      gene_level : 1,
      hgnc_id : "HGNC:48",
      havana_gene : "OTTHUMG00000021862.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 75156388,
      stop : 75304885,
      direction : "+",
      ID : "ENSG00000094841.14",
      gene_id : "ENSG00000094841.14",
      gene_type : "protein_coding",
      gene_name : "UPRT",
      gene_level : 2,
      hgnc_id : "HGNC:28334",
      havana_gene : "OTTHUMG00000021864.9",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 75368427,
      stop : 75523502,
      direction : "-",
      ID : "ENSG00000102383.14",
      gene_id : "ENSG00000102383.14",
      gene_type : "protein_coding",
      gene_name : "ZDHHC15",
      gene_level : 2,
      hgnc_id : "HGNC:20342",
      havana_gene : "OTTHUMG00000021866.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 75782987,
      stop : 75785254,
      direction : "-",
      ID : "ENSG00000186675.7",
      gene_id : "ENSG00000186675.7",
      gene_type : "protein_coding",
      gene_name : "MAGEE2",
      gene_level : 2,
      hgnc_id : "HGNC:24935",
      havana_gene : "OTTHUMG00000021870.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 76173040,
      stop : 76178314,
      direction : "+",
      ID : "ENSG00000102390.11",
      gene_id : "ENSG00000102390.11",
      gene_type : "protein_coding",
      gene_name : "PBDC1",
      gene_level : 2,
      hgnc_id : "HGNC:28790",
      havana_gene : "OTTHUMG00000021876.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 76427710,
      stop : 76431342,
      direction : "+",
      ID : "ENSG00000198934.5",
      gene_id : "ENSG00000198934.5",
      gene_type : "protein_coding",
      gene_name : "MAGEE1",
      gene_level : 2,
      hgnc_id : "HGNC:24934",
      havana_gene : "OTTHUMG00000021879.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77447389,
      stop : 77457278,
      direction : "+",
      ID : "ENSG00000196468.8",
      gene_id : "ENSG00000196468.8",
      gene_type : "protein_coding",
      gene_name : "FGF16",
      gene_level : 2,
      hgnc_id : "HGNC:3672",
      havana_gene : "OTTHUMG00000013133.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77504880,
      stop : 77786233,
      direction : "-",
      ID : "ENSG00000085224.23",
      gene_id : "ENSG00000085224.23",
      gene_type : "protein_coding",
      gene_name : "ATRX",
      gene_level : 2,
      hgnc_id : "HGNC:886",
      havana_gene : "OTTHUMG00000022686.12",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77825747,
      stop : 77895593,
      direction : "-",
      ID : "ENSG00000102158.20",
      gene_id : "ENSG00000102158.20",
      gene_type : "protein_coding",
      gene_name : "MAGT1",
      gene_level : 1,
      hgnc_id : "HGNC:28880",
      havana_gene : "OTTHUMG00000021882.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77899440,
      stop : 77907376,
      direction : "+",
      ID : "ENSG00000131174.7",
      gene_id : "ENSG00000131174.7",
      gene_type : "protein_coding",
      gene_name : "COX7B",
      gene_level : 2,
      hgnc_id : "HGNC:2291",
      havana_gene : "OTTHUMG00000022718.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77910656,
      stop : 78050395,
      direction : "+",
      ID : "ENSG00000165240.20",
      gene_id : "ENSG00000165240.20",
      gene_type : "protein_coding",
      gene_name : "ATP7A",
      gene_level : 2,
      hgnc_id : "HGNC:869",
      havana_gene : "OTTHUMG00000021885.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77910739,
      stop : 78129295,
      direction : "+",
      ID : "ENSG00000102144.15",
      gene_id : "ENSG00000102144.15",
      gene_type : "protein_coding",
      gene_name : "PGK1",
      gene_level : 2,
      hgnc_id : "HGNC:8896",
      havana_gene : "OTTHUMG00000021888.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 77967949,
      stop : 77969638,
      direction : "-",
      ID : "ENSG00000226784.3",
      gene_id : "ENSG00000226784.3",
      gene_type : "protein_coding",
      gene_name : "PGAM4",
      gene_level : 2,
      hgnc_id : "HGNC:21731",
      havana_gene : "OTTHUMG00000057865.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 78129748,
      stop : 78139650,
      direction : "-",
      ID : "ENSG00000187325.5",
      gene_id : "ENSG00000187325.5",
      gene_type : "protein_coding",
      gene_name : "TAF9B",
      gene_level : 2,
      hgnc_id : "HGNC:17306",
      havana_gene : "OTTHUMG00000021887.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 78271468,
      stop : 78327691,
      direction : "-",
      ID : "ENSG00000173198.6",
      gene_id : "ENSG00000173198.6",
      gene_type : "protein_coding",
      gene_name : "CYSLTR1",
      gene_level : 2,
      hgnc_id : "HGNC:17451",
      havana_gene : "OTTHUMG00000021889.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 78656068,
      stop : 78659328,
      direction : "-",
      ID : "ENSG00000179300.4",
      gene_id : "ENSG00000179300.4",
      gene_type : "protein_coding",
      gene_name : "RTL3",
      gene_level : 2,
      hgnc_id : "HGNC:22997",
      havana_gene : "OTTHUMG00000021892.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 78747709,
      stop : 78757094,
      direction : "+",
      ID : "ENSG00000147145.12",
      gene_id : "ENSG00000147145.12",
      gene_type : "protein_coding",
      gene_name : "LPAR4",
      gene_level : 2,
      hgnc_id : "HGNC:4478",
      havana_gene : "OTTHUMG00000021895.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 78945332,
      stop : 78963727,
      direction : "+",
      ID : "ENSG00000078589.13",
      gene_id : "ENSG00000078589.13",
      gene_type : "protein_coding",
      gene_name : "P2RY10",
      gene_level : 2,
      hgnc_id : "HGNC:19906",
      havana_gene : "OTTHUMG00000021896.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 79144688,
      stop : 79175318,
      direction : "+",
      ID : "ENSG00000147138.3",
      gene_id : "ENSG00000147138.3",
      gene_type : "protein_coding",
      gene_name : "GPR174",
      gene_level : 2,
      hgnc_id : "HGNC:30245",
      havana_gene : "OTTHUMG00000021898.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 79360384,
      stop : 79367667,
      direction : "-",
      ID : "ENSG00000078596.11",
      gene_id : "ENSG00000078596.11",
      gene_type : "protein_coding",
      gene_name : "ITM2A",
      gene_level : 2,
      hgnc_id : "HGNC:6173",
      havana_gene : "OTTHUMG00000021900.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 80014753,
      stop : 80031774,
      direction : "+",
      ID : "ENSG00000122145.15",
      gene_id : "ENSG00000122145.15",
      gene_type : "protein_coding",
      gene_name : "TBX22",
      gene_level : 2,
      hgnc_id : "HGNC:11600",
      havana_gene : "OTTHUMG00000021901.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 80335504,
      stop : 80445311,
      direction : "+",
      ID : "ENSG00000174016.11",
      gene_id : "ENSG00000174016.11",
      gene_type : "protein_coding",
      gene_name : "TENT5D",
      gene_level : 2,
      hgnc_id : "HGNC:28399",
      havana_gene : "OTTHUMG00000021902.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 80669503,
      stop : 80809877,
      direction : "-",
      ID : "ENSG00000165288.11",
      gene_id : "ENSG00000165288.11",
      gene_type : "protein_coding",
      gene_name : "BRWD3",
      gene_level : 2,
      hgnc_id : "HGNC:17342",
      havana_gene : "OTTHUMG00000021908.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 81113699,
      stop : 81201913,
      direction : "-",
      ID : "ENSG00000198157.11",
      gene_id : "ENSG00000198157.11",
      gene_type : "protein_coding",
      gene_name : "HMGN5",
      gene_level : 2,
      hgnc_id : "HGNC:8013",
      havana_gene : "OTTHUMG00000021911.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 81202102,
      stop : 81298547,
      direction : "+",
      ID : "ENSG00000131171.13",
      gene_id : "ENSG00000131171.13",
      gene_type : "protein_coding",
      gene_name : "SH3BGRL",
      gene_level : 2,
      hgnc_id : "HGNC:10823",
      havana_gene : "OTTHUMG00000021910.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 83508290,
      stop : 83512127,
      direction : "+",
      ID : "ENSG00000196767.9",
      gene_id : "ENSG00000196767.9",
      gene_type : "protein_coding",
      gene_name : "POU3F4",
      gene_level : 2,
      hgnc_id : "HGNC:9217",
      havana_gene : "OTTHUMG00000021919.6",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 83861126,
      stop : 83886699,
      direction : "+",
      ID : "ENSG00000183035.13",
      gene_id : "ENSG00000183035.13",
      gene_type : "protein_coding",
      gene_name : "CYLC1",
      gene_level : 2,
      hgnc_id : "HGNC:2582",
      havana_gene : "OTTHUMG00000021922.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 84058346,
      stop : 84188199,
      direction : "-",
      ID : "ENSG00000072133.11",
      gene_id : "ENSG00000072133.11",
      gene_type : "protein_coding",
      gene_name : "RPS6KA6",
      gene_level : 2,
      hgnc_id : "HGNC:10435",
      havana_gene : "OTTHUMG00000021923.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 84317874,
      stop : 84502479,
      direction : "-",
      ID : "ENSG00000165259.14",
      gene_id : "ENSG00000165259.14",
      gene_type : "protein_coding",
      gene_name : "HDX",
      gene_level : 2,
      hgnc_id : "HGNC:26411",
      havana_gene : "OTTHUMG00000021926.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 85003877,
      stop : 85093316,
      direction : "+",
      ID : "ENSG00000155008.15",
      gene_id : "ENSG00000155008.15",
      gene_type : "protein_coding",
      gene_name : "APOOL",
      gene_level : 2,
      hgnc_id : "HGNC:24009",
      havana_gene : "OTTHUMG00000021930.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 85092284,
      stop : 85243911,
      direction : "-",
      ID : "ENSG00000184788.14",
      gene_id : "ENSG00000184788.14",
      gene_type : "protein_coding",
      gene_name : "SATL1",
      gene_level : 2,
      hgnc_id : "HGNC:27992",
      havana_gene : "OTTHUMG00000021931.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 85243991,
      stop : 85273362,
      direction : "+",
      ID : "ENSG00000147180.17",
      gene_id : "ENSG00000147180.17",
      gene_type : "protein_coding",
      gene_name : "ZNF711",
      gene_level : 2,
      hgnc_id : "HGNC:13128",
      havana_gene : "OTTHUMG00000021933.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 85277396,
      stop : 85379717,
      direction : "-",
      ID : "ENSG00000124429.18",
      gene_id : "ENSG00000124429.18",
      gene_type : "protein_coding",
      gene_name : "POF1B",
      gene_level : 2,
      hgnc_id : "HGNC:13711",
      havana_gene : "OTTHUMG00000021934.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 85861180,
      stop : 86047561,
      direction : "-",
      ID : "ENSG00000188419.14",
      gene_id : "ENSG00000188419.14",
      gene_type : "protein_coding",
      gene_name : "CHM",
      gene_level : 2,
      hgnc_id : "HGNC:1940",
      havana_gene : "OTTHUMG00000021937.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 86148451,
      stop : 86832604,
      direction : "+",
      ID : "ENSG00000126733.21",
      gene_id : "ENSG00000126733.21",
      gene_type : "protein_coding",
      gene_name : "DACH2",
      gene_level : 2,
      hgnc_id : "HGNC:16814",
      havana_gene : "OTTHUMG00000021944.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 87517409,
      stop : 87670050,
      direction : "+",
      ID : "ENSG00000102271.14",
      gene_id : "ENSG00000102271.14",
      gene_type : "protein_coding",
      gene_name : "KLHL4",
      gene_level : 2,
      hgnc_id : "HGNC:6355",
      havana_gene : "OTTHUMG00000021946.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 88747225,
      stop : 88754785,
      direction : "+",
      ID : "ENSG00000147183.10",
      gene_id : "ENSG00000147183.10",
      gene_type : "protein_coding",
      gene_name : "CPXCR1",
      gene_level : 2,
      hgnc_id : "HGNC:2332",
      havana_gene : "OTTHUMG00000021950.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 89921908,
      stop : 89922883,
      direction : "+",
      ID : "ENSG00000153779.11",
      gene_id : "ENSG00000153779.11",
      gene_type : "protein_coding",
      gene_name : "TGIF2LX",
      gene_level : 2,
      hgnc_id : "HGNC:18570",
      havana_gene : "OTTHUMG00000021954.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 91434595,
      stop : 91438584,
      direction : "+",
      ID : "ENSG00000174740.8",
      gene_id : "ENSG00000174740.8",
      gene_type : "protein_coding",
      gene_name : "PABPC5",
      gene_level : 2,
      hgnc_id : "HGNC:13629",
      havana_gene : "OTTHUMG00000021959.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 91779261,
      stop : 92623230,
      direction : "+",
      ID : "ENSG00000102290.22",
      gene_id : "ENSG00000102290.22",
      gene_type : "protein_coding",
      gene_name : "PCDH11X",
      gene_level : 2,
      hgnc_id : "HGNC:8656",
      havana_gene : "OTTHUMG00000021965.8",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 93670930,
      stop : 93673578,
      direction : "-",
      ID : "ENSG00000186310.10",
      gene_id : "ENSG00000186310.10",
      gene_type : "protein_coding",
      gene_name : "NAP1L3",
      gene_level : 2,
      hgnc_id : "HGNC:7639",
      havana_gene : "OTTHUMG00000021974.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 93674013,
      stop : 93712274,
      direction : "+",
      ID : "ENSG00000179083.6",
      gene_id : "ENSG00000179083.6",
      gene_type : "protein_coding",
      gene_name : "FAM133A",
      gene_level : 2,
      hgnc_id : "HGNC:26748",
      havana_gene : "OTTHUMG00000021975.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 96684663,
      stop : 97604997,
      direction : "+",
      ID : "ENSG00000147202.18",
      gene_id : "ENSG00000147202.18",
      gene_type : "protein_coding",
      gene_name : "DIAPH2",
      gene_level : 2,
      hgnc_id : "HGNC:2877",
      havana_gene : "OTTHUMG00000022689.3",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 96883908,
      stop : 96885467,
      direction : "+",
      ID : "ENSG00000204086.4",
      gene_id : "ENSG00000204086.4",
      gene_type : "protein_coding",
      gene_name : "RPA4",
      gene_level : 2,
      hgnc_id : "HGNC:30305",
      havana_gene : "OTTHUMG00000021987.1",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100291644,
      stop : 100410273,
      direction : "-",
      ID : "ENSG00000165194.15",
      gene_id : "ENSG00000165194.15",
      gene_type : "protein_coding",
      gene_name : "PCDH19",
      gene_level : 2,
      hgnc_id : "HGNC:14270",
      havana_gene : "OTTHUMG00000022000.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100584936,
      stop : 100599885,
      direction : "+",
      ID : "ENSG00000000005.6",
      gene_id : "ENSG00000000005.6",
      gene_type : "protein_coding",
      gene_name : "TNMD",
      gene_level : 2,
      hgnc_id : "HGNC:17757",
      havana_gene : "OTTHUMG00000022001.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100627108,
      stop : 100639991,
      direction : "-",
      ID : "ENSG00000000003.15",
      gene_id : "ENSG00000000003.15",
      gene_type : "protein_coding",
      gene_name : "TSPAN6",
      gene_level : 2,
      hgnc_id : "HGNC:11858",
      havana_gene : "OTTHUMG00000022002.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100644195,
      stop : 100675788,
      direction : "+",
      ID : "ENSG00000102359.9",
      gene_id : "ENSG00000102359.9",
      gene_type : "protein_coding",
      gene_name : "SRPX2",
      gene_level : 2,
      hgnc_id : "HGNC:30668",
      havana_gene : "OTTHUMG00000022003.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100674491,
      stop : 100732123,
      direction : "-",
      ID : "ENSG00000102362.15",
      gene_id : "ENSG00000102362.15",
      gene_type : "protein_coding",
      gene_name : "SYTL4",
      gene_level : 2,
      hgnc_id : "HGNC:15588",
      havana_gene : "OTTHUMG00000022004.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100820359,
      stop : 100841520,
      direction : "+",
      ID : "ENSG00000101811.14",
      gene_id : "ENSG00000101811.14",
      gene_type : "protein_coding",
      gene_name : "CSTF2",
      gene_level : 2,
      hgnc_id : "HGNC:2484",
      havana_gene : "OTTHUMG00000022709.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100843324,
      stop : 100874359,
      direction : "-",
      ID : "ENSG00000007952.18",
      gene_id : "ENSG00000007952.18",
      gene_type : "protein_coding",
      gene_name : "NOX1",
      gene_level : 2,
      hgnc_id : "HGNC:7889",
      havana_gene : "OTTHUMG00000022007.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100913445,
      stop : 100929433,
      direction : "-",
      ID : "ENSG00000182489.9",
      gene_id : "ENSG00000182489.9",
      gene_type : "protein_coding",
      gene_name : "XKRX",
      gene_level : 1,
      hgnc_id : "HGNC:29845",
      havana_gene : "OTTHUMG00000022010.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 100969708,
      stop : 100990831,
      direction : "+",
      ID : "ENSG00000174225.15",
      gene_id : "ENSG00000174225.15",
      gene_type : "protein_coding",
      gene_name : "ARL13A",
      gene_level : 1,
      hgnc_id : "HGNC:31709",
      havana_gene : "OTTHUMG00000022013.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101009346,
      stop : 101052116,
      direction : "-",
      ID : "ENSG00000188917.15",
      gene_id : "ENSG00000188917.15",
      gene_type : "protein_coding",
      gene_name : "TRMT2B",
      gene_level : 2,
      hgnc_id : "HGNC:25748",
      havana_gene : "OTTHUMG00000022017.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101078879,
      stop : 101096367,
      direction : "+",
      ID : "ENSG00000126950.8",
      gene_id : "ENSG00000126950.8",
      gene_type : "protein_coding",
      gene_name : "TMEM35A",
      gene_level : 2,
      hgnc_id : "HGNC:25864",
      havana_gene : "OTTHUMG00000022016.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101098218,
      stop : 101163681,
      direction : "+",
      ID : "ENSG00000102384.13",
      gene_id : "ENSG00000102384.13",
      gene_type : "protein_coding",
      gene_name : "CENPI",
      gene_level : 2,
      hgnc_id : "HGNC:3968",
      havana_gene : "OTTHUMG00000022018.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101219769,
      stop : 101264502,
      direction : "+",
      ID : "ENSG00000102385.13",
      gene_id : "ENSG00000102385.13",
      gene_type : "protein_coding",
      gene_name : "DRP2",
      gene_level : 2,
      hgnc_id : "HGNC:3032",
      havana_gene : "OTTHUMG00000022020.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101268253,
      stop : 101293057,
      direction : "-",
      ID : "ENSG00000102387.16",
      gene_id : "ENSG00000102387.16",
      gene_type : "protein_coding",
      gene_name : "TAF7L",
      gene_level : 2,
      hgnc_id : "HGNC:11548",
      havana_gene : "OTTHUMG00000022021.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101345661,
      stop : 101348742,
      direction : "-",
      ID : "ENSG00000126953.8",
      gene_id : "ENSG00000126953.8",
      gene_type : "protein_coding",
      gene_name : "TIMM8A",
      gene_level : 2,
      hgnc_id : "HGNC:11817",
      havana_gene : "OTTHUMG00000022028.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101349447,
      stop : 101390796,
      direction : "-",
      ID : "ENSG00000010671.16",
      gene_id : "ENSG00000010671.16",
      gene_type : "protein_coding",
      gene_name : "BTK",
      gene_level : 2,
      hgnc_id : "HGNC:1133",
      havana_gene : "OTTHUMG00000022022.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101390824,
      stop : 101396155,
      direction : "+",
      ID : "ENSG00000241343.10",
      gene_id : "ENSG00000241343.10",
      gene_type : "protein_coding",
      gene_name : "RPL36A",
      gene_level : 2,
      hgnc_id : "HGNC:10359",
      havana_gene : "OTTHUMG00000022027.7",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101391011,
      stop : 101412297,
      direction : "+",
      ID : "ENSG00000257529.5",
      gene_id : "ENSG00000257529.5",
      gene_type : "protein_coding",
      gene_name : "RPL36A-HNRNPH2",
      gene_level : 1,
      hgnc_id : "HGNC:48349",
      havana_gene : "OTTHUMG00000170052.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101393273,
      stop : 101408012,
      direction : "-",
      ID : "ENSG00000102393.14",
      gene_id : "ENSG00000102393.14",
      gene_type : "protein_coding",
      gene_name : "GLA",
      gene_level : 2,
      hgnc_id : "HGNC:4296",
      havana_gene : "OTTHUMG00000022026.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101408222,
      stop : 101414133,
      direction : "+",
      ID : "ENSG00000126945.9",
      gene_id : "ENSG00000126945.9",
      gene_type : "protein_coding",
      gene_name : "HNRNPH2",
      gene_level : 2,
      hgnc_id : "HGNC:5042",
      havana_gene : "OTTHUMG00000022029.2",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101418287,
      stop : 101533459,
      direction : "+",
      ID : "ENSG00000196440.11",
      gene_id : "ENSG00000196440.11",
      gene_type : "protein_coding",
      gene_name : "ARMCX4",
      gene_level : 2,
      hgnc_id : "HGNC:28615",
      havana_gene : "OTTHUMG00000022030.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101550547,
      stop : 101554700,
      direction : "+",
      ID : "ENSG00000126947.13",
      gene_id : "ENSG00000126947.13",
      gene_type : "protein_coding",
      gene_name : "ARMCX1",
      gene_level : 2,
      hgnc_id : "HGNC:18073",
      havana_gene : "OTTHUMG00000022033.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101615118,
      stop : 101618001,
      direction : "-",
      ID : "ENSG00000198960.11",
      gene_id : "ENSG00000198960.11",
      gene_type : "protein_coding",
      gene_name : "ARMCX6",
      gene_level : 2,
      hgnc_id : "HGNC:26094",
      havana_gene : "OTTHUMG00000022034.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101622797,
      stop : 101627843,
      direction : "+",
      ID : "ENSG00000102401.20",
      gene_id : "ENSG00000102401.20",
      gene_type : "protein_coding",
      gene_name : "ARMCX3",
      gene_level : 2,
      hgnc_id : "HGNC:24065",
      havana_gene : "OTTHUMG00000022035.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101655281,
      stop : 101659850,
      direction : "-",
      ID : "ENSG00000184867.14",
      gene_id : "ENSG00000184867.14",
      gene_type : "protein_coding",
      gene_name : "ARMCX2",
      gene_level : 2,
      hgnc_id : "HGNC:16869",
      havana_gene : "OTTHUMG00000022038.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 101882288,
      stop : 101932079,
      direction : "-",
      ID : "ENSG00000166432.15",
      gene_id : "ENSG00000166432.15",
      gene_type : "protein_coding",
      gene_name : "ZMAT1",
      gene_level : 2,
      hgnc_id : "HGNC:29377",
      havana_gene : "OTTHUMG00000022044.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102125679,
      stop : 102140426,
      direction : "+",
      ID : "ENSG00000184905.9",
      gene_id : "ENSG00000184905.9",
      gene_type : "protein_coding",
      gene_name : "TCEAL2",
      gene_level : 2,
      hgnc_id : "HGNC:29818",
      havana_gene : "OTTHUMG00000022048.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102140476,
      stop : 102142970,
      direction : "-",
      ID : "ENSG00000204071.10",
      gene_id : "ENSG00000204071.10",
      gene_type : "protein_coding",
      gene_name : "TCEAL6",
      gene_level : 2,
      hgnc_id : "HGNC:24553",
      havana_gene : "OTTHUMG00000022050.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102153708,
      stop : 102155977,
      direction : "-",
      ID : "ENSG00000184515.11",
      gene_id : "ENSG00000184515.11",
      gene_type : "protein_coding",
      gene_name : "BEX5",
      gene_level : 2,
      hgnc_id : "HGNC:27990",
      havana_gene : "OTTHUMG00000022049.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102215301,
      stop : 102229532,
      direction : "+",
      ID : "ENSG00000268235.7",
      gene_id : "ENSG00000268235.7",
      gene_type : "protein_coding",
      gene_name : "TCP11X1",
      gene_level : 2,
      hgnc_id : "HGNC:48369",
      havana_gene : "OTTHUMG00000022051.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102247167,
      stop : 102326722,
      direction : "+",
      ID : "ENSG00000269405.7",
      gene_id : "ENSG00000269405.7",
      gene_type : "protein_coding",
      gene_name : "NXF2",
      gene_level : 2,
      hgnc_id : "HGNC:8072",
      havana_gene : "OTTHUMG00000189320.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102360395,
      stop : 102471812,
      direction : "-",
      ID : "ENSG00000284800.1",
      gene_id : "ENSG00000284800.1",
      gene_type : "protein_coding",
      gene_name : "AC235565.2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000152591.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102360396,
      stop : 102439932,
      direction : "-",
      ID : "ENSG00000269437.7",
      gene_id : "ENSG00000269437.7",
      gene_type : "protein_coding",
      gene_name : "NXF2B",
      gene_level : 2,
      hgnc_id : "HGNC:23984",
      havana_gene : "OTTHUMG00000154920.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102456862,
      stop : 102471842,
      direction : "-",
      ID : "ENSG00000215029.11",
      gene_id : "ENSG00000215029.11",
      gene_type : "protein_coding",
      gene_name : "TCP11X2",
      gene_level : 2,
      hgnc_id : "HGNC:48335",
      havana_gene : "OTTHUMG00000192406.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102513682,
      stop : 102516739,
      direction : "-",
      ID : "ENSG00000158164.7",
      gene_id : "ENSG00000158164.7",
      gene_type : "protein_coding",
      gene_name : "TMSB15A",
      gene_level : 2,
      hgnc_id : "HGNC:30744",
      havana_gene : "OTTHUMG00000022054.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102599168,
      stop : 102604159,
      direction : "+",
      ID : "ENSG00000125962.14",
      gene_id : "ENSG00000125962.14",
      gene_type : "protein_coding",
      gene_name : "ARMCX5",
      gene_level : 2,
      hgnc_id : "HGNC:25772",
      havana_gene : "OTTHUMG00000022062.3",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102651092,
      stop : 102659083,
      direction : "+",
      ID : "ENSG00000198932.13",
      gene_id : "ENSG00000198932.13",
      gene_type : "protein_coding",
      gene_name : "GPRASP1",
      gene_level : 2,
      hgnc_id : "HGNC:24834",
      havana_gene : "OTTHUMG00000022061.6",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102712176,
      stop : 102717733,
      direction : "+",
      ID : "ENSG00000158301.18",
      gene_id : "ENSG00000158301.18",
      gene_type : "protein_coding",
      gene_name : "GPRASP2",
      gene_level : 2,
      hgnc_id : "HGNC:25169",
      havana_gene : "OTTHUMG00000185178.1",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102712495,
      stop : 102753530,
      direction : "+",
      ID : "ENSG00000286237.1",
      gene_id : "ENSG00000286237.1",
      gene_type : "protein_coding",
      gene_name : "ARMCX5-GPRASP2",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000193744.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102720688,
      stop : 102753540,
      direction : "+",
      ID : "ENSG00000198908.12",
      gene_id : "ENSG00000198908.12",
      gene_type : "protein_coding",
      gene_name : "BHLHB9",
      gene_level : 2,
      hgnc_id : "HGNC:29353",
      havana_gene : "OTTHUMG00000022060.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 102937272,
      stop : 102938300,
      direction : "+",
      ID : "ENSG00000102128.8",
      gene_id : "ENSG00000102128.8",
      gene_type : "protein_coding",
      gene_name : "RAB40AL",
      gene_level : 2,
      hgnc_id : "HGNC:25410",
      havana_gene : "OTTHUMG00000022084.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103062651,
      stop : 103064171,
      direction : "-",
      ID : "ENSG00000133169.6",
      gene_id : "ENSG00000133169.6",
      gene_type : "protein_coding",
      gene_name : "BEX1",
      gene_level : 2,
      hgnc_id : "HGNC:1036",
      havana_gene : "OTTHUMG00000022708.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103075810,
      stop : 103093143,
      direction : "-",
      ID : "ENSG00000147206.17",
      gene_id : "ENSG00000147206.17",
      gene_type : "protein_coding",
      gene_name : "NXF3",
      gene_level : 2,
      hgnc_id : "HGNC:8073",
      havana_gene : "OTTHUMG00000022088.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103215108,
      stop : 103217246,
      direction : "+",
      ID : "ENSG00000102409.10",
      gene_id : "ENSG00000102409.10",
      gene_type : "protein_coding",
      gene_name : "BEX4",
      gene_level : 2,
      hgnc_id : "HGNC:25475",
      havana_gene : "OTTHUMG00000022091.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103252995,
      stop : 103255192,
      direction : "-",
      ID : "ENSG00000180964.17",
      gene_id : "ENSG00000180964.17",
      gene_type : "protein_coding",
      gene_name : "TCEAL8",
      gene_level : 2,
      hgnc_id : "HGNC:28683",
      havana_gene : "OTTHUMG00000022094.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103273691,
      stop : 103276750,
      direction : "-",
      ID : "ENSG00000204065.3",
      gene_id : "ENSG00000204065.3",
      gene_type : "protein_coding",
      gene_name : "TCEAL5",
      gene_level : 2,
      hgnc_id : "HGNC:22282",
      havana_gene : "OTTHUMG00000022092.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103309346,
      stop : 103311007,
      direction : "-",
      ID : "ENSG00000133134.12",
      gene_id : "ENSG00000133134.12",
      gene_type : "protein_coding",
      gene_name : "BEX2",
      gene_level : 2,
      hgnc_id : "HGNC:30933",
      havana_gene : "OTTHUMG00000022095.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103330229,
      stop : 103332326,
      direction : "+",
      ID : "ENSG00000182916.8",
      gene_id : "ENSG00000182916.8",
      gene_type : "protein_coding",
      gene_name : "TCEAL7",
      gene_level : 2,
      hgnc_id : "HGNC:28336",
      havana_gene : "OTTHUMG00000022096.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103356489,
      stop : 103358462,
      direction : "+",
      ID : "ENSG00000185222.10",
      gene_id : "ENSG00000185222.10",
      gene_type : "protein_coding",
      gene_name : "TCEAL9",
      gene_level : 2,
      hgnc_id : "HGNC:30084",
      havana_gene : "OTTHUMG00000192586.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103376395,
      stop : 103378164,
      direction : "+",
      ID : "ENSG00000166681.14",
      gene_id : "ENSG00000166681.14",
      gene_type : "protein_coding",
      gene_name : "BEX3",
      gene_level : 2,
      hgnc_id : "HGNC:13388",
      havana_gene : "OTTHUMG00000022099.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103499130,
      stop : 103519489,
      direction : "-",
      ID : "ENSG00000172476.4",
      gene_id : "ENSG00000172476.4",
      gene_type : "protein_coding",
      gene_name : "RAB40A",
      gene_level : 2,
      hgnc_id : "HGNC:18283",
      havana_gene : "OTTHUMG00000022100.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103576231,
      stop : 103587729,
      direction : "+",
      ID : "ENSG00000133142.18",
      gene_id : "ENSG00000133142.18",
      gene_type : "protein_coding",
      gene_name : "TCEAL4",
      gene_level : 2,
      hgnc_id : "HGNC:26121",
      havana_gene : "OTTHUMG00000022103.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103607451,
      stop : 103629690,
      direction : "+",
      ID : "ENSG00000196507.11",
      gene_id : "ENSG00000196507.11",
      gene_type : "protein_coding",
      gene_name : "TCEAL3",
      gene_level : 2,
      hgnc_id : "HGNC:28247",
      havana_gene : "OTTHUMG00000022106.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103628704,
      stop : 103630953,
      direction : "+",
      ID : "ENSG00000172465.14",
      gene_id : "ENSG00000172465.14",
      gene_type : "protein_coding",
      gene_name : "TCEAL1",
      gene_level : 2,
      hgnc_id : "HGNC:11616",
      havana_gene : "OTTHUMG00000022699.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103675496,
      stop : 103688158,
      direction : "-",
      ID : "ENSG00000123562.18",
      gene_id : "ENSG00000123562.18",
      gene_type : "protein_coding",
      gene_name : "MORF4L2",
      gene_level : 2,
      hgnc_id : "HGNC:16849",
      havana_gene : "OTTHUMG00000022104.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103710909,
      stop : 103714032,
      direction : "+",
      ID : "ENSG00000179363.7",
      gene_id : "ENSG00000179363.7",
      gene_type : "protein_coding",
      gene_name : "TMEM31",
      gene_level : 2,
      hgnc_id : "HGNC:28601",
      havana_gene : "OTTHUMG00000022109.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103773718,
      stop : 103792619,
      direction : "+",
      ID : "ENSG00000123560.14",
      gene_id : "ENSG00000123560.14",
      gene_type : "protein_coding",
      gene_name : "PLP1",
      gene_level : 2,
      hgnc_id : "HGNC:9086",
      havana_gene : "OTTHUMG00000022111.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103822327,
      stop : 103832257,
      direction : "-",
      ID : "ENSG00000123570.4",
      gene_id : "ENSG00000123570.4",
      gene_type : "protein_coding",
      gene_name : "RAB9B",
      gene_level : 2,
      hgnc_id : "HGNC:14090",
      havana_gene : "OTTHUMG00000022112.2",
      tag : "retrogene, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 103918896,
      stop : 103966712,
      direction : "+",
      ID : "ENSG00000158427.15",
      gene_id : "ENSG00000158427.15",
      gene_type : "protein_coding",
      gene_name : "TMSB15B",
      gene_level : 2,
      hgnc_id : "HGNC:28612",
      havana_gene : "OTTHUMG00000022117.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104011147,
      stop : 104013687,
      direction : "-",
      ID : "ENSG00000123569.9",
      gene_id : "ENSG00000123569.9",
      gene_type : "protein_coding",
      gene_name : "H2BW1",
      gene_level : 2,
      hgnc_id : "HGNC:27252",
      havana_gene : "OTTHUMG00000022120.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104039949,
      stop : 104042454,
      direction : "+",
      ID : "ENSG00000101812.14",
      gene_id : "ENSG00000101812.14",
      gene_type : "protein_coding",
      gene_name : "H2BW2",
      gene_level : 2,
      hgnc_id : "HGNC:27867",
      havana_gene : "OTTHUMG00000022122.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104063871,
      stop : 104076212,
      direction : "-",
      ID : "ENSG00000269226.7",
      gene_id : "ENSG00000269226.7",
      gene_type : "protein_coding",
      gene_name : "TMSB15B",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000188508.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104099214,
      stop : 104157009,
      direction : "-",
      ID : "ENSG00000269743.3",
      gene_id : "ENSG00000269743.3",
      gene_type : "protein_coding",
      gene_name : "SLC25A53",
      gene_level : 2,
      hgnc_id : "HGNC:31894",
      havana_gene : "OTTHUMG00000022124.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104112131,
      stop : 104115842,
      direction : "+",
      ID : "ENSG00000166707.12",
      gene_id : "ENSG00000166707.12",
      gene_type : "protein_coding",
      gene_name : "ZCCHC18",
      gene_level : 2,
      hgnc_id : "HGNC:32459",
      havana_gene : "OTTHUMG00000022123.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104166453,
      stop : 104195902,
      direction : "+",
      ID : "ENSG00000123575.9",
      gene_id : "ENSG00000123575.9",
      gene_type : "protein_coding",
      gene_name : "FAM199X",
      gene_level : 2,
      hgnc_id : "HGNC:25195",
      havana_gene : "OTTHUMG00000022126.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104250038,
      stop : 104254933,
      direction : "-",
      ID : "ENSG00000123576.5",
      gene_id : "ENSG00000123576.5",
      gene_type : "protein_coding",
      gene_name : "ESX1",
      gene_level : 2,
      hgnc_id : "HGNC:14865",
      havana_gene : "OTTHUMG00000022125.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 104566199,
      stop : 105767829,
      direction : "+",
      ID : "ENSG00000189108.13",
      gene_id : "ENSG00000189108.13",
      gene_type : "protein_coding",
      gene_name : "IL1RAPL2",
      gene_level : 2,
      hgnc_id : "HGNC:5997",
      havana_gene : "OTTHUMG00000022141.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 105218929,
      stop : 105220694,
      direction : "-",
      ID : "ENSG00000268629.8",
      gene_id : "ENSG00000268629.8",
      gene_type : "protein_coding",
      gene_name : "TEX13A",
      gene_level : 2,
      hgnc_id : "HGNC:11735",
      havana_gene : "OTTHUMG00000022133.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 105822539,
      stop : 105958610,
      direction : "+",
      ID : "ENSG00000123572.17",
      gene_id : "ENSG00000123572.17",
      gene_type : "protein_coding",
      gene_name : "NRK",
      gene_level : 2,
      hgnc_id : "HGNC:25391",
      havana_gene : "OTTHUMG00000022143.10",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106032435,
      stop : 106038727,
      direction : "-",
      ID : "ENSG00000123561.15",
      gene_id : "ENSG00000123561.15",
      gene_type : "protein_coding",
      gene_name : "SERPINA7",
      gene_level : 2,
      hgnc_id : "HGNC:11583",
      havana_gene : "OTTHUMG00000022144.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106168305,
      stop : 106208956,
      direction : "+",
      ID : "ENSG00000157502.13",
      gene_id : "ENSG00000157502.13",
      gene_type : "protein_coding",
      gene_name : "PWWP3B",
      gene_level : 2,
      hgnc_id : "HGNC:26583",
      havana_gene : "OTTHUMG00000022146.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106611930,
      stop : 106679439,
      direction : "+",
      ID : "ENSG00000147231.14",
      gene_id : "ENSG00000147231.14",
      gene_type : "protein_coding",
      gene_name : "RADX",
      gene_level : 2,
      hgnc_id : "HGNC:25486",
      havana_gene : "OTTHUMG00000022150.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106693794,
      stop : 106797016,
      direction : "+",
      ID : "ENSG00000133135.14",
      gene_id : "ENSG00000133135.14",
      gene_type : "protein_coding",
      gene_name : "RNF128",
      gene_level : 2,
      hgnc_id : "HGNC:21153",
      havana_gene : "OTTHUMG00000022151.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106802673,
      stop : 106876150,
      direction : "+",
      ID : "ENSG00000133138.20",
      gene_id : "ENSG00000133138.20",
      gene_type : "protein_coding",
      gene_name : "TBC1D8B",
      gene_level : 2,
      hgnc_id : "HGNC:24715",
      havana_gene : "OTTHUMG00000022152.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106813871,
      stop : 107000212,
      direction : "-",
      ID : "ENSG00000133131.15",
      gene_id : "ENSG00000133131.15",
      gene_type : "protein_coding",
      gene_name : "MORC4",
      gene_level : 2,
      hgnc_id : "HGNC:23485",
      havana_gene : "OTTHUMG00000022155.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106900063,
      stop : 106903341,
      direction : "-",
      ID : "ENSG00000147223.6",
      gene_id : "ENSG00000147223.6",
      gene_type : "protein_coding",
      gene_name : "RIPPLY1",
      gene_level : 2,
      hgnc_id : "HGNC:25117",
      havana_gene : "OTTHUMG00000022153.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 106900164,
      stop : 106930861,
      direction : "+",
      ID : "ENSG00000165376.12",
      gene_id : "ENSG00000165376.12",
      gene_type : "protein_coding",
      gene_name : "CLDN2",
      gene_level : 2,
      hgnc_id : "HGNC:2041",
      havana_gene : "OTTHUMG00000022154.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107064420,
      stop : 107118823,
      direction : "-",
      ID : "ENSG00000089682.16",
      gene_id : "ENSG00000089682.16",
      gene_type : "protein_coding",
      gene_name : "RBM41",
      gene_level : 2,
      hgnc_id : "HGNC:25617",
      havana_gene : "OTTHUMG00000022156.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107123427,
      stop : 107206433,
      direction : "-",
      ID : "ENSG00000198088.10",
      gene_id : "ENSG00000198088.10",
      gene_type : "protein_coding",
      gene_name : "NUP62CL",
      gene_level : 2,
      hgnc_id : "HGNC:25960",
      havana_gene : "OTTHUMG00000022159.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107206611,
      stop : 107244247,
      direction : "+",
      ID : "ENSG00000080572.13",
      gene_id : "ENSG00000080572.13",
      gene_type : "protein_coding",
      gene_name : "DNAAF6",
      gene_level : 2,
      hgnc_id : "HGNC:28570",
      havana_gene : "OTTHUMG00000022160.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107522450,
      stop : 107605251,
      direction : "+",
      ID : "ENSG00000147234.10",
      gene_id : "ENSG00000147234.10",
      gene_type : "protein_coding",
      gene_name : "FRMPD3",
      gene_level : 2,
      hgnc_id : "HGNC:29382",
      havana_gene : "OTTHUMG00000022165.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107628428,
      stop : 107651993,
      direction : "+",
      ID : "ENSG00000147224.13",
      gene_id : "ENSG00000147224.13",
      gene_type : "protein_coding",
      gene_name : "PRPS1",
      gene_level : 2,
      hgnc_id : "HGNC:9462",
      havana_gene : "OTTHUMG00000022167.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107713221,
      stop : 107777342,
      direction : "-",
      ID : "ENSG00000157514.16",
      gene_id : "ENSG00000157514.16",
      gene_type : "protein_coding",
      gene_name : "TSC22D3",
      gene_level : 2,
      hgnc_id : "HGNC:3051",
      havana_gene : "OTTHUMG00000022168.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107774899,
      stop : 107795829,
      direction : "+",
      ID : "ENSG00000170935.8",
      gene_id : "ENSG00000170935.8",
      gene_type : "protein_coding",
      gene_name : "NCBP2L",
      gene_level : 2,
      hgnc_id : "HGNC:31795",
      havana_gene : "OTTHUMG00000022169.6",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107825755,
      stop : 107931637,
      direction : "+",
      ID : "ENSG00000080561.14",
      gene_id : "ENSG00000080561.14",
      gene_type : "protein_coding",
      gene_name : "MID2",
      gene_level : 2,
      hgnc_id : "HGNC:7096",
      havana_gene : "OTTHUMG00000022171.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 107980864,
      stop : 107982370,
      direction : "-",
      ID : "ENSG00000170925.3",
      gene_id : "ENSG00000170925.3",
      gene_type : "protein_coding",
      gene_name : "TEX13B",
      gene_level : 2,
      hgnc_id : "HGNC:11736",
      havana_gene : "OTTHUMG00000022174.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 108044970,
      stop : 108079184,
      direction : "+",
      ID : "ENSG00000101842.14",
      gene_id : "ENSG00000101842.14",
      gene_type : "protein_coding",
      gene_name : "VSIG1",
      gene_level : 2,
      hgnc_id : "HGNC:28675",
      havana_gene : "OTTHUMG00000022175.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 108084207,
      stop : 108091549,
      direction : "-",
      ID : "ENSG00000101843.19",
      gene_id : "ENSG00000101843.19",
      gene_type : "protein_coding",
      gene_name : "PSMD10",
      gene_level : 2,
      hgnc_id : "HGNC:9555",
      havana_gene : "OTTHUMG00000022177.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 108091668,
      stop : 108154671,
      direction : "+",
      ID : "ENSG00000101844.18",
      gene_id : "ENSG00000101844.18",
      gene_type : "protein_coding",
      gene_name : "ATG4A",
      gene_level : 2,
      hgnc_id : "HGNC:16489",
      havana_gene : "OTTHUMG00000022176.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 108155607,
      stop : 108439497,
      direction : "-",
      ID : "ENSG00000197565.16",
      gene_id : "ENSG00000197565.16",
      gene_type : "protein_coding",
      gene_name : "COL4A6",
      gene_level : 2,
      hgnc_id : "HGNC:2208",
      havana_gene : "OTTHUMG00000022179.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 108439838,
      stop : 108697545,
      direction : "+",
      ID : "ENSG00000188153.14",
      gene_id : "ENSG00000188153.14",
      gene_type : "protein_coding",
      gene_name : "COL4A5",
      gene_level : 1,
      hgnc_id : "HGNC:2207",
      havana_gene : "OTTHUMG00000022182.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 108719946,
      stop : 108736563,
      direction : "-",
      ID : "ENSG00000133124.12",
      gene_id : "ENSG00000133124.12",
      gene_type : "protein_coding",
      gene_name : "IRS4",
      gene_level : 2,
      hgnc_id : "HGNC:6128",
      havana_gene : "OTTHUMG00000022181.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 109372906,
      stop : 109482086,
      direction : "-",
      ID : "ENSG00000101890.5",
      gene_id : "ENSG00000101890.5",
      gene_type : "protein_coding",
      gene_name : "GUCY2F",
      gene_level : 2,
      hgnc_id : "HGNC:4691",
      havana_gene : "OTTHUMG00000022184.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 109535781,
      stop : 109544698,
      direction : "+",
      ID : "ENSG00000101888.12",
      gene_id : "ENSG00000101888.12",
      gene_type : "protein_coding",
      gene_name : "NXT2",
      gene_level : 2,
      hgnc_id : "HGNC:18151",
      havana_gene : "OTTHUMG00000022185.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 109623700,
      stop : 109625172,
      direction : "-",
      ID : "ENSG00000176076.7",
      gene_id : "ENSG00000176076.7",
      gene_type : "protein_coding",
      gene_name : "KCNE5",
      gene_level : 2,
      hgnc_id : "HGNC:6241",
      havana_gene : "OTTHUMG00000022189.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 109624244,
      stop : 109733403,
      direction : "-",
      ID : "ENSG00000068366.20",
      gene_id : "ENSG00000068366.20",
      gene_type : "protein_coding",
      gene_name : "ACSL4",
      gene_level : 2,
      hgnc_id : "HGNC:3571",
      havana_gene : "OTTHUMG00000022190.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 110002631,
      stop : 110182734,
      direction : "+",
      ID : "ENSG00000157600.12",
      gene_id : "ENSG00000157600.12",
      gene_type : "protein_coding",
      gene_name : "TMEM164",
      gene_level : 2,
      hgnc_id : "HGNC:26217",
      havana_gene : "OTTHUMG00000022192.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 110194186,
      stop : 110440318,
      direction : "-",
      ID : "ENSG00000101935.11",
      gene_id : "ENSG00000101935.11",
      gene_type : "protein_coding",
      gene_name : "AMMECR1",
      gene_level : 2,
      hgnc_id : "HGNC:467",
      havana_gene : "OTTHUMG00000022197.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 110358816,
      stop : 110456334,
      direction : "+",
      ID : "ENSG00000243978.8",
      gene_id : "ENSG00000243978.8",
      gene_type : "protein_coding",
      gene_name : "RTL9",
      gene_level : 2,
      hgnc_id : "HGNC:29245",
      havana_gene : "OTTHUMG00000022196.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 110673856,
      stop : 110795819,
      direction : "-",
      ID : "ENSG00000101938.15",
      gene_id : "ENSG00000101938.15",
      gene_type : "protein_coding",
      gene_name : "CHRDL1",
      gene_level : 2,
      hgnc_id : "HGNC:29861",
      havana_gene : "OTTHUMG00000022199.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 110944285,
      stop : 111227361,
      direction : "+",
      ID : "ENSG00000077264.16",
      gene_id : "ENSG00000077264.16",
      gene_type : "protein_coding",
      gene_name : "PAK3",
      gene_level : 2,
      hgnc_id : "HGNC:8592",
      havana_gene : "OTTHUMG00000022202.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 111245099,
      stop : 111270483,
      direction : "-",
      ID : "ENSG00000077274.9",
      gene_id : "ENSG00000077274.9",
      gene_type : "protein_coding",
      gene_name : "CAPN6",
      gene_level : 2,
      hgnc_id : "HGNC:1483",
      havana_gene : "OTTHUMG00000022203.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 111293779,
      stop : 111412429,
      direction : "-",
      ID : "ENSG00000077279.20",
      gene_id : "ENSG00000077279.20",
      gene_type : "protein_coding",
      gene_name : "DCX",
      gene_level : 1,
      hgnc_id : "HGNC:2714",
      havana_gene : "OTTHUMG00000022204.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 111511662,
      stop : 111522399,
      direction : "+",
      ID : "ENSG00000260802.1",
      gene_id : "ENSG00000260802.1",
      gene_type : "protein_coding",
      gene_name : "SERTM2",
      gene_level : 2,
      hgnc_id : "HGNC:48576",
      havana_gene : "OTTHUMG00000173027.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 111665811,
      stop : 111760649,
      direction : "+",
      ID : "ENSG00000101901.12",
      gene_id : "ENSG00000101901.12",
      gene_type : "protein_coding",
      gene_name : "ALG13",
      gene_level : 2,
      hgnc_id : "HGNC:30881",
      havana_gene : "OTTHUMG00000022209.17",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 111768011,
      stop : 112082776,
      direction : "-",
      ID : "ENSG00000072315.4",
      gene_id : "ENSG00000072315.4",
      gene_type : "protein_coding",
      gene_name : "TRPC5",
      gene_level : 2,
      hgnc_id : "HGNC:12337",
      havana_gene : "OTTHUMG00000022212.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 111876051,
      stop : 111903990,
      direction : "+",
      ID : "ENSG00000204025.8",
      gene_id : "ENSG00000204025.8",
      gene_type : "protein_coding",
      gene_name : "TRPC5OS",
      gene_level : 2,
      hgnc_id : "HGNC:40593",
      havana_gene : "OTTHUMG00000022211.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 112454500,
      stop : 112457112,
      direction : "+",
      ID : "ENSG00000187823.3",
      gene_id : "ENSG00000187823.3",
      gene_type : "protein_coding",
      gene_name : "RTL4",
      gene_level : 2,
      hgnc_id : "HGNC:25214",
      havana_gene : "OTTHUMG00000159706.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 112630648,
      stop : 112680054,
      direction : "-",
      ID : "ENSG00000182508.14",
      gene_id : "ENSG00000182508.14",
      gene_type : "protein_coding",
      gene_name : "LHFPL1",
      gene_level : 2,
      hgnc_id : "HGNC:6587",
      havana_gene : "OTTHUMG00000022214.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 112774503,
      stop : 112840889,
      direction : "-",
      ID : "ENSG00000126016.16",
      gene_id : "ENSG00000126016.16",
      gene_type : "protein_coding",
      gene_name : "AMOT",
      gene_level : 2,
      hgnc_id : "HGNC:17810",
      havana_gene : "OTTHUMG00000022216.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 114584078,
      stop : 114910061,
      direction : "+",
      ID : "ENSG00000147246.10",
      gene_id : "ENSG00000147246.10",
      gene_type : "protein_coding",
      gene_name : "HTR2C",
      gene_level : 2,
      hgnc_id : "HGNC:5295",
      havana_gene : "OTTHUMG00000022226.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 115003975,
      stop : 115019977,
      direction : "-",
      ID : "ENSG00000123496.8",
      gene_id : "ENSG00000123496.8",
      gene_type : "protein_coding",
      gene_name : "IL13RA2",
      gene_level : 2,
      hgnc_id : "HGNC:5975",
      havana_gene : "OTTHUMG00000022229.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 115110616,
      stop : 115234096,
      direction : "-",
      ID : "ENSG00000130224.15",
      gene_id : "ENSG00000130224.15",
      gene_type : "protein_coding",
      gene_name : "LRCH2",
      gene_level : 2,
      hgnc_id : "HGNC:29292",
      havana_gene : "OTTHUMG00000022233.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 115189410,
      stop : 115192868,
      direction : "+",
      ID : "ENSG00000175718.10",
      gene_id : "ENSG00000175718.10",
      gene_type : "protein_coding",
      gene_name : "RBMXL3",
      gene_level : 2,
      hgnc_id : "HGNC:26859",
      havana_gene : "OTTHUMG00000022230.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 115289715,
      stop : 115307563,
      direction : "+",
      ID : "ENSG00000102021.11",
      gene_id : "ENSG00000102021.11",
      gene_type : "protein_coding",
      gene_name : "LUZP4",
      gene_level : 2,
      hgnc_id : "HGNC:24971",
      havana_gene : "OTTHUMG00000022234.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 115561174,
      stop : 115650861,
      direction : "+",
      ID : "ENSG00000102024.18",
      gene_id : "ENSG00000102024.18",
      gene_type : "protein_coding",
      gene_name : "PLS3",
      gene_level : 2,
      hgnc_id : "HGNC:9091",
      havana_gene : "OTTHUMG00000022237.10",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 116170744,
      stop : 116174974,
      direction : "+",
      ID : "ENSG00000180772.8",
      gene_id : "ENSG00000180772.8",
      gene_type : "protein_coding",
      gene_name : "AGTR2",
      gene_level : 2,
      hgnc_id : "HGNC:338",
      havana_gene : "OTTHUMG00000022243.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 116436606,
      stop : 116461458,
      direction : "+",
      ID : "ENSG00000268104.3",
      gene_id : "ENSG00000268104.3",
      gene_type : "protein_coding",
      gene_name : "SLC6A14",
      gene_level : 2,
      hgnc_id : "HGNC:11047",
      havana_gene : "OTTHUMG00000022245.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 116461686,
      stop : 116462976,
      direction : "-",
      ID : "ENSG00000204019.5",
      gene_id : "ENSG00000204019.5",
      gene_type : "protein_coding",
      gene_name : "CT83",
      gene_level : 2,
      hgnc_id : "HGNC:33494",
      havana_gene : "OTTHUMG00000022244.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 117897813,
      stop : 118117340,
      direction : "-",
      ID : "ENSG00000003096.14",
      gene_id : "ENSG00000003096.14",
      gene_type : "protein_coding",
      gene_name : "KLHL13",
      gene_level : 2,
      hgnc_id : "HGNC:22931",
      havana_gene : "OTTHUMG00000022252.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 118346073,
      stop : 118449961,
      direction : "+",
      ID : "ENSG00000131725.14",
      gene_id : "ENSG00000131725.14",
      gene_type : "protein_coding",
      gene_name : "WDR44",
      gene_level : 2,
      hgnc_id : "HGNC:30512",
      havana_gene : "OTTHUMG00000022254.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 118495815,
      stop : 118686163,
      direction : "+",
      ID : "ENSG00000147251.16",
      gene_id : "ENSG00000147251.16",
      gene_type : "protein_coding",
      gene_name : "DOCK11",
      gene_level : 2,
      hgnc_id : "HGNC:23483",
      havana_gene : "OTTHUMG00000022256.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 118727133,
      stop : 118794535,
      direction : "+",
      ID : "ENSG00000131724.11",
      gene_id : "ENSG00000131724.11",
      gene_type : "protein_coding",
      gene_name : "IL13RA1",
      gene_level : 2,
      hgnc_id : "HGNC:5974",
      havana_gene : "OTTHUMG00000022258.4",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 118823824,
      stop : 118826968,
      direction : "+",
      ID : "ENSG00000174460.4",
      gene_id : "ENSG00000174460.4",
      gene_type : "protein_coding",
      gene_name : "ZCCHC12",
      gene_level : 2,
      hgnc_id : "HGNC:27273",
      havana_gene : "OTTHUMG00000022261.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 118974614,
      stop : 119018355,
      direction : "+",
      ID : "ENSG00000175556.17",
      gene_id : "ENSG00000175556.17",
      gene_type : "protein_coding",
      gene_name : "LONRF3",
      gene_level : 2,
      hgnc_id : "HGNC:21152",
      havana_gene : "OTTHUMG00000022262.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119073226,
      stop : 119076373,
      direction : "+",
      ID : "ENSG00000277535.2",
      gene_id : "ENSG00000277535.2",
      gene_type : "protein_coding",
      gene_name : "AL772284.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000188075.2",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119078635,
      stop : 119150579,
      direction : "-",
      ID : "ENSG00000250423.2",
      gene_id : "ENSG00000250423.2",
      gene_type : "protein_coding",
      gene_name : "KIAA1210",
      gene_level : 2,
      hgnc_id : "HGNC:29218",
      havana_gene : "OTTHUMG00000162980.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119236245,
      stop : 119244466,
      direction : "+",
      ID : "ENSG00000101856.10",
      gene_id : "ENSG00000101856.10",
      gene_type : "protein_coding",
      gene_name : "PGRMC1",
      gene_level : 2,
      hgnc_id : "HGNC:16090",
      havana_gene : "OTTHUMG00000022268.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119399336,
      stop : 119454478,
      direction : "+",
      ID : "ENSG00000077713.19",
      gene_id : "ENSG00000077713.19",
      gene_type : "protein_coding",
      gene_name : "SLC25A43",
      gene_level : 2,
      hgnc_id : "HGNC:30557",
      havana_gene : "OTTHUMG00000022272.2",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119468422,
      stop : 119471396,
      direction : "+",
      ID : "ENSG00000005022.6",
      gene_id : "ENSG00000005022.6",
      gene_type : "protein_coding",
      gene_name : "SLC25A5",
      gene_level : 2,
      hgnc_id : "HGNC:10991",
      havana_gene : "OTTHUMG00000022715.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119538149,
      stop : 119565409,
      direction : "-",
      ID : "ENSG00000018610.15",
      gene_id : "ENSG00000018610.15",
      gene_type : "protein_coding",
      gene_name : "CXorf56",
      gene_level : 2,
      hgnc_id : "HGNC:26239",
      havana_gene : "OTTHUMG00000022276.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119574536,
      stop : 119591083,
      direction : "+",
      ID : "ENSG00000077721.16",
      gene_id : "ENSG00000077721.16",
      gene_type : "protein_coding",
      gene_name : "UBE2A",
      gene_level : 2,
      hgnc_id : "HGNC:12472",
      havana_gene : "OTTHUMG00000022275.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119588337,
      stop : 119606443,
      direction : "-",
      ID : "ENSG00000186416.17",
      gene_id : "ENSG00000186416.17",
      gene_type : "protein_coding",
      gene_name : "NKRF",
      gene_level : 2,
      hgnc_id : "HGNC:19374",
      havana_gene : "OTTHUMG00000022277.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119615724,
      stop : 119693370,
      direction : "-",
      ID : "ENSG00000125354.24",
      gene_id : "ENSG00000125354.24",
      gene_type : "protein_coding",
      gene_name : "SEPTIN6",
      gene_level : 2,
      hgnc_id : "HGNC:15848",
      havana_gene : "OTTHUMG00000022280.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119758588,
      stop : 119760202,
      direction : "+",
      ID : "ENSG00000187808.5",
      gene_id : "ENSG00000187808.5",
      gene_type : "protein_coding",
      gene_name : "SOWAHD",
      gene_level : 2,
      hgnc_id : "HGNC:32960",
      havana_gene : "OTTHUMG00000159606.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119786504,
      stop : 119791630,
      direction : "-",
      ID : "ENSG00000198918.8",
      gene_id : "ENSG00000198918.8",
      gene_type : "protein_coding",
      gene_name : "RPL39",
      gene_level : 2,
      hgnc_id : "HGNC:10350",
      havana_gene : "OTTHUMG00000022278.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119805311,
      stop : 119852998,
      direction : "-",
      ID : "ENSG00000125351.13",
      gene_id : "ENSG00000125351.13",
      gene_type : "protein_coding",
      gene_name : "UPF3B",
      gene_level : 2,
      hgnc_id : "HGNC:20439",
      havana_gene : "OTTHUMG00000022282.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119870475,
      stop : 119871733,
      direction : "-",
      ID : "ENSG00000125352.6",
      gene_id : "ENSG00000125352.6",
      gene_type : "protein_coding",
      gene_name : "RNF113A",
      gene_level : 2,
      hgnc_id : "HGNC:12974",
      havana_gene : "OTTHUMG00000022283.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119871832,
      stop : 119876662,
      direction : "+",
      ID : "ENSG00000125356.7",
      gene_id : "ENSG00000125356.7",
      gene_type : "protein_coding",
      gene_name : "NDUFA1",
      gene_level : 2,
      hgnc_id : "HGNC:7683",
      havana_gene : "OTTHUMG00000022287.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119895837,
      stop : 119920716,
      direction : "+",
      ID : "ENSG00000186471.13",
      gene_id : "ENSG00000186471.13",
      gene_type : "protein_coding",
      gene_name : "AKAP14",
      gene_level : 2,
      hgnc_id : "HGNC:24061",
      havana_gene : "OTTHUMG00000022285.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 119920672,
      stop : 119943751,
      direction : "-",
      ID : "ENSG00000101882.10",
      gene_id : "ENSG00000101882.10",
      gene_type : "protein_coding",
      gene_name : "NKAP",
      gene_level : 2,
      hgnc_id : "HGNC:29873",
      havana_gene : "OTTHUMG00000022284.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120072264,
      stop : 120077690,
      direction : "-",
      ID : "ENSG00000203989.5",
      gene_id : "ENSG00000203989.5",
      gene_type : "protein_coding",
      gene_name : "RHOXF2B",
      gene_level : 2,
      hgnc_id : "HGNC:33519",
      havana_gene : "OTTHUMG00000022288.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120109051,
      stop : 120115913,
      direction : "-",
      ID : "ENSG00000101883.5",
      gene_id : "ENSG00000101883.5",
      gene_type : "protein_coding",
      gene_name : "RHOXF1",
      gene_level : 2,
      hgnc_id : "HGNC:29993",
      havana_gene : "OTTHUMG00000022290.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120158613,
      stop : 120165630,
      direction : "+",
      ID : "ENSG00000131721.6",
      gene_id : "ENSG00000131721.6",
      gene_type : "protein_coding",
      gene_name : "RHOXF2",
      gene_level : 2,
      hgnc_id : "HGNC:30011",
      havana_gene : "OTTHUMG00000022296.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120250752,
      stop : 120258398,
      direction : "+",
      ID : "ENSG00000177485.7",
      gene_id : "ENSG00000177485.7",
      gene_type : "protein_coding",
      gene_name : "ZBTB33",
      gene_level : 2,
      hgnc_id : "HGNC:16682",
      havana_gene : "OTTHUMG00000171159.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120258650,
      stop : 120311556,
      direction : "-",
      ID : "ENSG00000125355.16",
      gene_id : "ENSG00000125355.16",
      gene_type : "protein_coding",
      gene_name : "TMEM255A",
      gene_level : 2,
      hgnc_id : "HGNC:26086",
      havana_gene : "OTTHUMG00000022298.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120362085,
      stop : 120383249,
      direction : "+",
      ID : "ENSG00000101892.12",
      gene_id : "ENSG00000101892.12",
      gene_type : "protein_coding",
      gene_name : "ATP1B4",
      gene_level : 2,
      hgnc_id : "HGNC:808",
      havana_gene : "OTTHUMG00000022299.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120426148,
      stop : 120469365,
      direction : "-",
      ID : "ENSG00000005893.16",
      gene_id : "ENSG00000005893.16",
      gene_type : "protein_coding",
      gene_name : "LAMP2",
      gene_level : 2,
      hgnc_id : "HGNC:6501",
      havana_gene : "OTTHUMG00000022301.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120505920,
      stop : 120604074,
      direction : "-",
      ID : "ENSG00000158290.19",
      gene_id : "ENSG00000158290.19",
      gene_type : "protein_coding",
      gene_name : "CUL4B",
      gene_level : 2,
      hgnc_id : "HGNC:2555",
      havana_gene : "OTTHUMG00000022302.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120594010,
      stop : 120621159,
      direction : "+",
      ID : "ENSG00000232119.8",
      gene_id : "ENSG00000232119.8",
      gene_type : "protein_coding",
      gene_name : "MCTS1",
      gene_level : 2,
      hgnc_id : "HGNC:23357",
      havana_gene : "OTTHUMG00000022303.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120625674,
      stop : 120630054,
      direction : "-",
      ID : "ENSG00000171155.8",
      gene_id : "ENSG00000171155.8",
      gene_type : "protein_coding",
      gene_name : "C1GALT1C1",
      gene_level : 2,
      hgnc_id : "HGNC:24338",
      havana_gene : "OTTHUMG00000022305.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120872603,
      stop : 120875929,
      direction : "-",
      ID : "ENSG00000236446.3",
      gene_id : "ENSG00000236446.3",
      gene_type : "protein_coding",
      gene_name : "CT47B1",
      gene_level : 2,
      hgnc_id : "HGNC:33293",
      havana_gene : "OTTHUMG00000187483.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120877496,
      stop : 120878924,
      direction : "-",
      ID : "ENSG00000278646.1",
      gene_id : "ENSG00000278646.1",
      gene_type : "protein_coding",
      gene_name : "AC008162.2",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000188842.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120930250,
      stop : 120932301,
      direction : "-",
      ID : "ENSG00000226685.4",
      gene_id : "ENSG00000226685.4",
      gene_type : "protein_coding",
      gene_name : "CT47A12",
      gene_level : 2,
      hgnc_id : "HGNC:33292",
      havana_gene : "OTTHUMG00000188843.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120933840,
      stop : 120937158,
      direction : "-",
      ID : "ENSG00000226929.3",
      gene_id : "ENSG00000226929.3",
      gene_type : "protein_coding",
      gene_name : "CT47A11",
      gene_level : 2,
      hgnc_id : "HGNC:27397",
      havana_gene : "OTTHUMG00000022310.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120938701,
      stop : 120942023,
      direction : "-",
      ID : "ENSG00000224089.3",
      gene_id : "ENSG00000224089.3",
      gene_type : "protein_coding",
      gene_name : "CT47A10",
      gene_level : 2,
      hgnc_id : "HGNC:33291",
      havana_gene : "OTTHUMG00000022309.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120943561,
      stop : 120946883,
      direction : "-",
      ID : "ENSG00000226600.3",
      gene_id : "ENSG00000226600.3",
      gene_type : "protein_coding",
      gene_name : "CT47A9",
      gene_level : 2,
      hgnc_id : "HGNC:33290",
      havana_gene : "OTTHUMG00000022319.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120948422,
      stop : 120951744,
      direction : "-",
      ID : "ENSG00000230347.5",
      gene_id : "ENSG00000230347.5",
      gene_type : "protein_coding",
      gene_name : "CT47A8",
      gene_level : 2,
      hgnc_id : "HGNC:33289",
      havana_gene : "OTTHUMG00000022318.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120953282,
      stop : 120956600,
      direction : "-",
      ID : "ENSG00000228517.3",
      gene_id : "ENSG00000228517.3",
      gene_type : "protein_coding",
      gene_name : "CT47A7",
      gene_level : 2,
      hgnc_id : "HGNC:33288",
      havana_gene : "OTTHUMG00000022317.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120958165,
      stop : 120961487,
      direction : "-",
      ID : "ENSG00000226023.6",
      gene_id : "ENSG00000226023.6",
      gene_type : "protein_coding",
      gene_name : "CT47A6",
      gene_level : 2,
      hgnc_id : "HGNC:33287",
      havana_gene : "OTTHUMG00000022316.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120963026,
      stop : 120966348,
      direction : "-",
      ID : "ENSG00000237957.6",
      gene_id : "ENSG00000237957.6",
      gene_type : "protein_coding",
      gene_name : "CT47A5",
      gene_level : 2,
      hgnc_id : "HGNC:33286",
      havana_gene : "OTTHUMG00000022315.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120967886,
      stop : 120971208,
      direction : "-",
      ID : "ENSG00000230594.3",
      gene_id : "ENSG00000230594.3",
      gene_type : "protein_coding",
      gene_name : "CT47A4",
      gene_level : 2,
      hgnc_id : "HGNC:33285",
      havana_gene : "OTTHUMG00000022314.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120972746,
      stop : 120976068,
      direction : "-",
      ID : "ENSG00000236126.3",
      gene_id : "ENSG00000236126.3",
      gene_type : "protein_coding",
      gene_name : "CT47A3",
      gene_level : 2,
      hgnc_id : "HGNC:33284",
      havana_gene : "OTTHUMG00000022313.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120977606,
      stop : 120980928,
      direction : "-",
      ID : "ENSG00000242362.2",
      gene_id : "ENSG00000242362.2",
      gene_type : "protein_coding",
      gene_name : "CT47A2",
      gene_level : 2,
      hgnc_id : "HGNC:33283",
      havana_gene : "OTTHUMG00000022312.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 120982476,
      stop : 120985788,
      direction : "-",
      ID : "ENSG00000236371.5",
      gene_id : "ENSG00000236371.5",
      gene_type : "protein_coding",
      gene_name : "CT47A1",
      gene_level : 2,
      hgnc_id : "HGNC:33282",
      havana_gene : "OTTHUMG00000022311.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 121047610,
      stop : 121050094,
      direction : "+",
      ID : "ENSG00000182890.5",
      gene_id : "ENSG00000182890.5",
      gene_type : "protein_coding",
      gene_name : "GLUD2",
      gene_level : 2,
      hgnc_id : "HGNC:4336",
      havana_gene : "OTTHUMG00000022320.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 123184153,
      stop : 123490915,
      direction : "+",
      ID : "ENSG00000125675.19",
      gene_id : "ENSG00000125675.19",
      gene_type : "protein_coding",
      gene_name : "GRIA3",
      gene_level : 2,
      hgnc_id : "HGNC:4573",
      havana_gene : "OTTHUMG00000022685.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 123600561,
      stop : 123733056,
      direction : "-",
      ID : "ENSG00000125676.20",
      gene_id : "ENSG00000125676.20",
      gene_type : "protein_coding",
      gene_name : "THOC2",
      gene_level : 1,
      hgnc_id : "HGNC:19073",
      havana_gene : "OTTHUMG00000022334.22",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 123859724,
      stop : 123913976,
      direction : "+",
      ID : "ENSG00000101966.13",
      gene_id : "ENSG00000101966.13",
      gene_type : "protein_coding",
      gene_name : "XIAP",
      gene_level : 2,
      hgnc_id : "HGNC:592",
      havana_gene : "OTTHUMG00000022336.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 123960212,
      stop : 124422664,
      direction : "+",
      ID : "ENSG00000101972.19",
      gene_id : "ENSG00000101972.19",
      gene_type : "protein_coding",
      gene_name : "STAG2",
      gene_level : 2,
      hgnc_id : "HGNC:11355",
      havana_gene : "OTTHUMG00000022725.13",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 124227868,
      stop : 124373197,
      direction : "+",
      ID : "ENSG00000183918.17",
      gene_id : "ENSG00000183918.17",
      gene_type : "protein_coding",
      gene_name : "SH2D1A",
      gene_level : 2,
      hgnc_id : "HGNC:10820",
      havana_gene : "OTTHUMG00000022344.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 124246249,
      stop : 124336863,
      direction : "+",
      ID : "ENSG00000282419.3",
      gene_id : "ENSG00000282419.3",
      gene_type : "protein_coding",
      gene_name : "TEX13D",
      gene_level : 2,
      hgnc_id : "HGNC:52278",
      havana_gene : "OTTHUMG00000190648.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 124375903,
      stop : 124963817,
      direction : "-",
      ID : "ENSG00000009694.13",
      gene_id : "ENSG00000009694.13",
      gene_type : "protein_coding",
      gene_name : "TENM1",
      gene_level : 2,
      hgnc_id : "HGNC:8117",
      havana_gene : "OTTHUMG00000022721.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 125320120,
      stop : 125325214,
      direction : "+",
      ID : "ENSG00000282815.1",
      gene_id : "ENSG00000282815.1",
      gene_type : "protein_coding",
      gene_name : "TEX13C",
      gene_level : 2,
      hgnc_id : "HGNC:52277",
      havana_gene : "OTTHUMG00000191426.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 126163499,
      stop : 126166289,
      direction : "-",
      ID : "ENSG00000198354.7",
      gene_id : "ENSG00000198354.7",
      gene_type : "protein_coding",
      gene_name : "DCAF12L2",
      gene_level : 2,
      hgnc_id : "HGNC:32950",
      havana_gene : "OTTHUMG00000022348.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 126549383,
      stop : 126552814,
      direction : "-",
      ID : "ENSG00000198889.5",
      gene_id : "ENSG00000198889.5",
      gene_type : "protein_coding",
      gene_name : "DCAF12L1",
      gene_level : 2,
      hgnc_id : "HGNC:29395",
      havana_gene : "OTTHUMG00000022353.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 126819729,
      stop : 126821786,
      direction : "+",
      ID : "ENSG00000183631.5",
      gene_id : "ENSG00000183631.5",
      gene_type : "protein_coding",
      gene_name : "PRR32",
      gene_level : 2,
      hgnc_id : "HGNC:34498",
      havana_gene : "OTTHUMG00000022355.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 128050962,
      stop : 128052398,
      direction : "-",
      ID : "ENSG00000123165.8",
      gene_id : "ENSG00000123165.8",
      gene_type : "protein_coding",
      gene_name : "ACTRT1",
      gene_level : 2,
      hgnc_id : "HGNC:24027",
      havana_gene : "OTTHUMG00000022359.1",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129446501,
      stop : 129523500,
      direction : "-",
      ID : "ENSG00000102038.16",
      gene_id : "ENSG00000102038.16",
      gene_type : "protein_coding",
      gene_name : "SMARCA1",
      gene_level : 2,
      hgnc_id : "HGNC:11097",
      havana_gene : "OTTHUMG00000022370.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129539849,
      stop : 129592561,
      direction : "+",
      ID : "ENSG00000122126.17",
      gene_id : "ENSG00000122126.17",
      gene_type : "protein_coding",
      gene_name : "OCRL",
      gene_level : 2,
      hgnc_id : "HGNC:8108",
      havana_gene : "OTTHUMG00000022706.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129645259,
      stop : 129654956,
      direction : "-",
      ID : "ENSG00000171388.12",
      gene_id : "ENSG00000171388.12",
      gene_type : "protein_coding",
      gene_name : "APLN",
      gene_level : 2,
      hgnc_id : "HGNC:16665",
      havana_gene : "OTTHUMG00000022371.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129738949,
      stop : 129769536,
      direction : "+",
      ID : "ENSG00000122121.12",
      gene_id : "ENSG00000122121.12",
      gene_type : "protein_coding",
      gene_name : "XPNPEP2",
      gene_level : 2,
      hgnc_id : "HGNC:12823",
      havana_gene : "OTTHUMG00000022373.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129779949,
      stop : 129795201,
      direction : "+",
      ID : "ENSG00000122122.10",
      gene_id : "ENSG00000122122.10",
      gene_type : "protein_coding",
      gene_name : "SASH3",
      gene_level : 2,
      hgnc_id : "HGNC:15975",
      havana_gene : "OTTHUMG00000022372.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129803288,
      stop : 129843909,
      direction : "-",
      ID : "ENSG00000188706.13",
      gene_id : "ENSG00000188706.13",
      gene_type : "protein_coding",
      gene_name : "ZDHHC9",
      gene_level : 2,
      hgnc_id : "HGNC:18475",
      havana_gene : "OTTHUMG00000022375.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129906121,
      stop : 129929761,
      direction : "+",
      ID : "ENSG00000156697.13",
      gene_id : "ENSG00000156697.13",
      gene_type : "protein_coding",
      gene_name : "UTP14A",
      gene_level : 2,
      hgnc_id : "HGNC:10665",
      havana_gene : "OTTHUMG00000022378.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 129981107,
      stop : 130058071,
      direction : "+",
      ID : "ENSG00000085185.16",
      gene_id : "ENSG00000085185.16",
      gene_type : "protein_coding",
      gene_name : "BCORL1",
      gene_level : 2,
      hgnc_id : "HGNC:25657",
      havana_gene : "OTTHUMG00000022379.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130063955,
      stop : 130110716,
      direction : "-",
      ID : "ENSG00000102034.17",
      gene_id : "ENSG00000102034.17",
      gene_type : "protein_coding",
      gene_name : "ELF4",
      gene_level : 2,
      hgnc_id : "HGNC:3319",
      havana_gene : "OTTHUMG00000022390.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130124666,
      stop : 130165879,
      direction : "-",
      ID : "ENSG00000156709.15",
      gene_id : "ENSG00000156709.15",
      gene_type : "protein_coding",
      gene_name : "AIFM1",
      gene_level : 2,
      hgnc_id : "HGNC:8768",
      havana_gene : "OTTHUMG00000022392.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130171962,
      stop : 130184870,
      direction : "+",
      ID : "ENSG00000134594.5",
      gene_id : "ENSG00000134594.5",
      gene_type : "protein_coding",
      gene_name : "RAB33A",
      gene_level : 2,
      hgnc_id : "HGNC:9773",
      havana_gene : "OTTHUMG00000022391.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130202707,
      stop : 130268899,
      direction : "-",
      ID : "ENSG00000056277.16",
      gene_id : "ENSG00000056277.16",
      gene_type : "protein_coding",
      gene_name : "ZNF280C",
      gene_level : 2,
      hgnc_id : "HGNC:25955",
      havana_gene : "OTTHUMG00000022393.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130339888,
      stop : 130373361,
      direction : "+",
      ID : "ENSG00000102078.16",
      gene_id : "ENSG00000102078.16",
      gene_type : "protein_coding",
      gene_name : "SLC25A14",
      gene_level : 2,
      hgnc_id : "HGNC:10984",
      havana_gene : "OTTHUMG00000022394.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130384345,
      stop : 130385660,
      direction : "-",
      ID : "ENSG00000147262.4",
      gene_id : "ENSG00000147262.4",
      gene_type : "protein_coding",
      gene_name : "GPR119",
      gene_level : 2,
      hgnc_id : "HGNC:19060",
      havana_gene : "OTTHUMG00000022397.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130401987,
      stop : 130413656,
      direction : "+",
      ID : "ENSG00000134597.16",
      gene_id : "ENSG00000134597.16",
      gene_type : "protein_coding",
      gene_name : "RBMX2",
      gene_level : 2,
      hgnc_id : "HGNC:24282",
      havana_gene : "OTTHUMG00000022395.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 130622325,
      stop : 130903317,
      direction : "-",
      ID : "ENSG00000165675.17",
      gene_id : "ENSG00000165675.17",
      gene_type : "protein_coding",
      gene_name : "ENOX2",
      gene_level : 2,
      hgnc_id : "HGNC:2259",
      havana_gene : "OTTHUMG00000022401.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 131058346,
      stop : 131089885,
      direction : "+",
      ID : "ENSG00000147256.12",
      gene_id : "ENSG00000147256.12",
      gene_type : "protein_coding",
      gene_name : "ARHGAP36",
      gene_level : 1,
      hgnc_id : "HGNC:26388",
      havana_gene : "OTTHUMG00000022402.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 131273506,
      stop : 131578899,
      direction : "-",
      ID : "ENSG00000147255.19",
      gene_id : "ENSG00000147255.19",
      gene_type : "protein_coding",
      gene_name : "IGSF1",
      gene_level : 2,
      hgnc_id : "HGNC:5948",
      havana_gene : "OTTHUMG00000022406.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 131543976,
      stop : 131545056,
      direction : "+",
      ID : "ENSG00000171054.8",
      gene_id : "ENSG00000171054.8",
      gene_type : "protein_coding",
      gene_name : "OR13H1",
      gene_level : 2,
      hgnc_id : "HGNC:14755",
      havana_gene : "OTTHUMG00000022411.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 132023302,
      stop : 132075943,
      direction : "+",
      ID : "ENSG00000134602.16",
      gene_id : "ENSG00000134602.16",
      gene_type : "protein_coding",
      gene_name : "STK26",
      gene_level : 1,
      hgnc_id : "HGNC:18174",
      havana_gene : "OTTHUMG00000022420.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 132076990,
      stop : 132128020,
      direction : "-",
      ID : "ENSG00000165694.10",
      gene_id : "ENSG00000165694.10",
      gene_type : "protein_coding",
      gene_name : "FRMD7",
      gene_level : 2,
      hgnc_id : "HGNC:8079",
      havana_gene : "OTTHUMG00000022421.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 132203024,
      stop : 132219480,
      direction : "-",
      ID : "ENSG00000123728.10",
      gene_id : "ENSG00000123728.10",
      gene_type : "protein_coding",
      gene_name : "RAP2C",
      gene_level : 2,
      hgnc_id : "HGNC:21165",
      havana_gene : "OTTHUMG00000022424.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 132369317,
      stop : 132489968,
      direction : "-",
      ID : "ENSG00000076770.14",
      gene_id : "ENSG00000076770.14",
      gene_type : "protein_coding",
      gene_name : "MBNL3",
      gene_level : 2,
      hgnc_id : "HGNC:20564",
      havana_gene : "OTTHUMG00000022426.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 132626016,
      stop : 132961395,
      direction : "-",
      ID : "ENSG00000171004.18",
      gene_id : "ENSG00000171004.18",
      gene_type : "protein_coding",
      gene_name : "HS6ST2",
      gene_level : 2,
      hgnc_id : "HGNC:19133",
      havana_gene : "OTTHUMG00000022430.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 133024631,
      stop : 133097109,
      direction : "-",
      ID : "ENSG00000134588.12",
      gene_id : "ENSG00000134588.12",
      gene_type : "protein_coding",
      gene_name : "USP26",
      gene_level : 2,
      hgnc_id : "HGNC:13485",
      havana_gene : "OTTHUMG00000022429.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 133216662,
      stop : 133218354,
      direction : "-",
      ID : "ENSG00000183434.10",
      gene_id : "ENSG00000183434.10",
      gene_type : "protein_coding",
      gene_name : "TFDP3",
      gene_level : 2,
      hgnc_id : "HGNC:24603",
      havana_gene : "OTTHUMG00000022433.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 133300103,
      stop : 133415489,
      direction : "-",
      ID : "ENSG00000076716.9",
      gene_id : "ENSG00000076716.9",
      gene_type : "protein_coding",
      gene_name : "GPC4",
      gene_level : 2,
      hgnc_id : "HGNC:4452",
      havana_gene : "OTTHUMG00000022434.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 133535745,
      stop : 133985594,
      direction : "-",
      ID : "ENSG00000147257.15",
      gene_id : "ENSG00000147257.15",
      gene_type : "protein_coding",
      gene_name : "GPC3",
      gene_level : 2,
      hgnc_id : "HGNC:4451",
      havana_gene : "OTTHUMG00000022448.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134237047,
      stop : 134246207,
      direction : "+",
      ID : "ENSG00000203952.9",
      gene_id : "ENSG00000203952.9",
      gene_type : "protein_coding",
      gene_name : "CCDC160",
      gene_level : 2,
      hgnc_id : "HGNC:37286",
      havana_gene : "OTTHUMG00000164183.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134373312,
      stop : 134428791,
      direction : "+",
      ID : "ENSG00000156531.17",
      gene_id : "ENSG00000156531.17",
      gene_type : "protein_coding",
      gene_name : "PHF6",
      gene_level : 2,
      hgnc_id : "HGNC:18145",
      havana_gene : "OTTHUMG00000022453.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134460165,
      stop : 134520513,
      direction : "+",
      ID : "ENSG00000165704.15",
      gene_id : "ENSG00000165704.15",
      gene_type : "protein_coding",
      gene_name : "HPRT1",
      gene_level : 2,
      hgnc_id : "HGNC:5157",
      havana_gene : "OTTHUMG00000022452.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134565838,
      stop : 134764322,
      direction : "-",
      ID : "ENSG00000170965.10",
      gene_id : "ENSG00000170965.10",
      gene_type : "protein_coding",
      gene_name : "PLAC1",
      gene_level : 2,
      hgnc_id : "HGNC:9044",
      havana_gene : "OTTHUMG00000022457.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134769566,
      stop : 134797232,
      direction : "-",
      ID : "ENSG00000156504.16",
      gene_id : "ENSG00000156504.16",
      gene_type : "protein_coding",
      gene_name : "FAM122B",
      gene_level : 2,
      hgnc_id : "HGNC:30490",
      havana_gene : "OTTHUMG00000022461.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134796395,
      stop : 134854835,
      direction : "+",
      ID : "ENSG00000156500.15",
      gene_id : "ENSG00000156500.15",
      gene_type : "protein_coding",
      gene_name : "FAM122C",
      gene_level : 2,
      hgnc_id : "HGNC:25202",
      havana_gene : "OTTHUMG00000022716.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134887632,
      stop : 134915257,
      direction : "-",
      ID : "ENSG00000101928.13",
      gene_id : "ENSG00000101928.13",
      gene_type : "protein_coding",
      gene_name : "MOSPD1",
      gene_level : 2,
      hgnc_id : "HGNC:25235",
      havana_gene : "OTTHUMG00000035315.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 134990991,
      stop : 134992473,
      direction : "+",
      ID : "ENSG00000184785.6",
      gene_id : "ENSG00000184785.6",
      gene_type : "protein_coding",
      gene_name : "SMIM10",
      gene_level : 2,
      hgnc_id : "HGNC:41913",
      havana_gene : "OTTHUMG00000187484.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135020513,
      stop : 135022542,
      direction : "-",
      ID : "ENSG00000212747.5",
      gene_id : "ENSG00000212747.5",
      gene_type : "protein_coding",
      gene_name : "RTL8B",
      gene_level : 2,
      hgnc_id : "HGNC:33156",
      havana_gene : "OTTHUMG00000022464.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135032355,
      stop : 135033546,
      direction : "+",
      ID : "ENSG00000134590.14",
      gene_id : "ENSG00000134590.14",
      gene_type : "protein_coding",
      gene_name : "RTL8C",
      gene_level : 2,
      hgnc_id : "HGNC:2569",
      havana_gene : "OTTHUMG00000022465.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135050932,
      stop : 135052196,
      direction : "-",
      ID : "ENSG00000203950.7",
      gene_id : "ENSG00000203950.7",
      gene_type : "protein_coding",
      gene_name : "RTL8A",
      gene_level : 2,
      hgnc_id : "HGNC:24514",
      havana_gene : "OTTHUMG00000022466.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135094985,
      stop : 135098712,
      direction : "-",
      ID : "ENSG00000196972.9",
      gene_id : "ENSG00000196972.9",
      gene_type : "protein_coding",
      gene_name : "SMIM10L2B",
      gene_level : 2,
      hgnc_id : "HGNC:34500",
      havana_gene : "OTTHUMG00000022468.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135118955,
      stop : 135120526,
      direction : "-",
      ID : "ENSG00000224107.5",
      gene_id : "ENSG00000224107.5",
      gene_type : "protein_coding",
      gene_name : "ETDB",
      gene_level : 2,
      hgnc_id : "HGNC:44269",
      havana_gene : "OTTHUMG00000022469.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135156540,
      stop : 135171398,
      direction : "-",
      ID : "ENSG00000169551.13",
      gene_id : "ENSG00000169551.13",
      gene_type : "protein_coding",
      gene_name : "CT55",
      gene_level : 2,
      hgnc_id : "HGNC:26047",
      havana_gene : "OTTHUMG00000022473.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135248920,
      stop : 135344109,
      direction : "-",
      ID : "ENSG00000186376.15",
      gene_id : "ENSG00000186376.15",
      gene_type : "protein_coding",
      gene_name : "ZNF75D",
      gene_level : 2,
      hgnc_id : "HGNC:13145",
      havana_gene : "OTTHUMG00000022482.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135252061,
      stop : 135253583,
      direction : "+",
      ID : "ENSG00000238210.4",
      gene_id : "ENSG00000238210.4",
      gene_type : "protein_coding",
      gene_name : "ETDA",
      gene_level : 2,
      hgnc_id : "HGNC:53449",
      havana_gene : "OTTHUMG00000022476.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135309480,
      stop : 135309659,
      direction : "+",
      ID : "ENSG00000283644.1",
      gene_id : "ENSG00000283644.1",
      gene_type : "protein_coding",
      gene_name : "ETDC",
      gene_level : 2,
      hgnc_id : "HGNC:53450",
      havana_gene : "OTTHUMG00000191754.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135344796,
      stop : 135363413,
      direction : "+",
      ID : "ENSG00000173275.13",
      gene_id : "ENSG00000173275.13",
      gene_type : "protein_coding",
      gene_name : "ZNF449",
      gene_level : 2,
      hgnc_id : "HGNC:21039",
      havana_gene : "OTTHUMG00000022478.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135421944,
      stop : 135428075,
      direction : "+",
      ID : "ENSG00000178947.9",
      gene_id : "ENSG00000178947.9",
      gene_type : "protein_coding",
      gene_name : "SMIM10L2A",
      gene_level : 2,
      hgnc_id : "HGNC:34499",
      havana_gene : "OTTHUMG00000022479.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135520659,
      stop : 135582510,
      direction : "+",
      ID : "ENSG00000165359.16",
      gene_id : "ENSG00000165359.16",
      gene_type : "protein_coding",
      gene_name : "INTS6L",
      gene_level : 2,
      hgnc_id : "HGNC:27334",
      havana_gene : "OTTHUMG00000022484.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135713453,
      stop : 135723539,
      direction : "+",
      ID : "ENSG00000268940.5",
      gene_id : "ENSG00000268940.5",
      gene_type : "protein_coding",
      gene_name : "CT45A1",
      gene_level : 2,
      hgnc_id : "HGNC:33267",
      havana_gene : "OTTHUMG00000188602.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135759846,
      stop : 135768191,
      direction : "-",
      ID : "ENSG00000269096.7",
      gene_id : "ENSG00000269096.7",
      gene_type : "protein_coding",
      gene_name : "CT45A3",
      gene_level : 2,
      hgnc_id : "HGNC:33268",
      havana_gene : "OTTHUMG00000022489.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135777130,
      stop : 135785298,
      direction : "-",
      ID : "ENSG00000228836.8",
      gene_id : "ENSG00000228836.8",
      gene_type : "protein_coding",
      gene_name : "CT45A5",
      gene_level : 2,
      hgnc_id : "HGNC:33270",
      havana_gene : "OTTHUMG00000188603.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135794685,
      stop : 135802787,
      direction : "-",
      ID : "ENSG00000278289.5",
      gene_id : "ENSG00000278289.5",
      gene_type : "protein_coding",
      gene_name : "CT45A6",
      gene_level : 2,
      hgnc_id : "HGNC:33271",
      havana_gene : "OTTHUMG00000188604.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135811668,
      stop : 135820012,
      direction : "-",
      ID : "ENSG00000271449.8",
      gene_id : "ENSG00000271449.8",
      gene_type : "protein_coding",
      gene_name : "CT45A2",
      gene_level : 2,
      hgnc_id : "HGNC:28400",
      havana_gene : "OTTHUMG00000022490.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135829247,
      stop : 135837268,
      direction : "-",
      ID : "ENSG00000273696.4",
      gene_id : "ENSG00000273696.4",
      gene_type : "protein_coding",
      gene_name : "CT45A7",
      gene_level : 2,
      hgnc_id : "HGNC:51260",
      havana_gene : "OTTHUMG00000022491.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135846497,
      stop : 135854538,
      direction : "-",
      ID : "ENSG00000278085.5",
      gene_id : "ENSG00000278085.5",
      gene_type : "protein_coding",
      gene_name : "CT45A8",
      gene_level : 2,
      hgnc_id : "HGNC:51261",
      havana_gene : "OTTHUMG00000188605.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135863418,
      stop : 135871812,
      direction : "-",
      ID : "ENSG00000270946.6",
      gene_id : "ENSG00000270946.6",
      gene_type : "protein_coding",
      gene_name : "CT45A9",
      gene_level : 2,
      hgnc_id : "HGNC:51262",
      havana_gene : "OTTHUMG00000188606.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135881063,
      stop : 135889086,
      direction : "-",
      ID : "ENSG00000269586.7",
      gene_id : "ENSG00000269586.7",
      gene_type : "protein_coding",
      gene_name : "CT45A10",
      gene_level : 2,
      hgnc_id : "HGNC:51263",
      havana_gene : "OTTHUMG00000022494.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135889205,
      stop : 135913061,
      direction : "+",
      ID : "ENSG00000181433.9",
      gene_id : "ENSG00000181433.9",
      gene_type : "protein_coding",
      gene_name : "SAGE1",
      gene_level : 2,
      hgnc_id : "HGNC:30369",
      havana_gene : "OTTHUMG00000022496.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135960588,
      stop : 135974029,
      direction : "-",
      ID : "ENSG00000169446.6",
      gene_id : "ENSG00000169446.6",
      gene_type : "protein_coding",
      gene_name : "MMGT1",
      gene_level : 2,
      hgnc_id : "HGNC:28100",
      havana_gene : "OTTHUMG00000022499.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 135973841,
      stop : 136047269,
      direction : "+",
      ID : "ENSG00000198689.13",
      gene_id : "ENSG00000198689.13",
      gene_type : "protein_coding",
      gene_name : "SLC9A6",
      gene_level : 2,
      hgnc_id : "HGNC:11079",
      havana_gene : "OTTHUMG00000022498.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136146702,
      stop : 136211359,
      direction : "+",
      ID : "ENSG00000022267.19",
      gene_id : "ENSG00000022267.19",
      gene_type : "protein_coding",
      gene_name : "FHL1",
      gene_level : 2,
      hgnc_id : "HGNC:3702",
      havana_gene : "OTTHUMG00000022504.13",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136213220,
      stop : 136256482,
      direction : "-",
      ID : "ENSG00000129680.16",
      gene_id : "ENSG00000129680.16",
      gene_type : "protein_coding",
      gene_name : "MAP7D3",
      gene_level : 1,
      hgnc_id : "HGNC:25742",
      havana_gene : "OTTHUMG00000022507.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136300963,
      stop : 136416890,
      direction : "+",
      ID : "ENSG00000156920.11",
      gene_id : "ENSG00000156920.11",
      gene_type : "protein_coding",
      gene_name : "ADGRG4",
      gene_level : 1,
      hgnc_id : "HGNC:18992",
      havana_gene : "OTTHUMG00000022508.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136487947,
      stop : 136493780,
      direction : "+",
      ID : "ENSG00000102239.5",
      gene_id : "ENSG00000102239.5",
      gene_type : "protein_coding",
      gene_name : "BRS3",
      gene_level : 2,
      hgnc_id : "HGNC:1113",
      havana_gene : "OTTHUMG00000022726.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136497079,
      stop : 136512346,
      direction : "+",
      ID : "ENSG00000102241.12",
      gene_id : "ENSG00000102241.12",
      gene_type : "protein_coding",
      gene_name : "HTATSF1",
      gene_level : 2,
      hgnc_id : "HGNC:5276",
      havana_gene : "OTTHUMG00000022510.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136532215,
      stop : 136556807,
      direction : "+",
      ID : "ENSG00000102243.13",
      gene_id : "ENSG00000102243.13",
      gene_type : "protein_coding",
      gene_name : "VGLL1",
      gene_level : 2,
      hgnc_id : "HGNC:20985",
      havana_gene : "OTTHUMG00000022509.3",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136648158,
      stop : 136660390,
      direction : "+",
      ID : "ENSG00000102245.8",
      gene_id : "ENSG00000102245.8",
      gene_type : "protein_coding",
      gene_name : "CD40LG",
      gene_level : 2,
      hgnc_id : "HGNC:11935",
      havana_gene : "OTTHUMG00000022512.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136665547,
      stop : 136780932,
      direction : "-",
      ID : "ENSG00000129675.16",
      gene_id : "ENSG00000129675.16",
      gene_type : "protein_coding",
      gene_name : "ARHGEF6",
      gene_level : 2,
      hgnc_id : "HGNC:685",
      havana_gene : "OTTHUMG00000022518.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 136848004,
      stop : 136880764,
      direction : "-",
      ID : "ENSG00000147274.14",
      gene_id : "ENSG00000147274.14",
      gene_type : "protein_coding",
      gene_name : "RBMX",
      gene_level : 2,
      hgnc_id : "HGNC:9910",
      havana_gene : "OTTHUMG00000022517.2",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 137023929,
      stop : 137033995,
      direction : "-",
      ID : "ENSG00000165370.3",
      gene_id : "ENSG00000165370.3",
      gene_type : "protein_coding",
      gene_name : "GPR101",
      gene_level : 2,
      hgnc_id : "HGNC:14963",
      havana_gene : "OTTHUMG00000022521.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 137566127,
      stop : 137577691,
      direction : "+",
      ID : "ENSG00000156925.12",
      gene_id : "ENSG00000156925.12",
      gene_type : "protein_coding",
      gene_name : "ZIC3",
      gene_level : 2,
      hgnc_id : "HGNC:12874",
      havana_gene : "OTTHUMG00000022525.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 138614727,
      stop : 139222777,
      direction : "-",
      ID : "ENSG00000129682.16",
      gene_id : "ENSG00000129682.16",
      gene_type : "protein_coding",
      gene_name : "FGF13",
      gene_level : 2,
      hgnc_id : "HGNC:3670",
      havana_gene : "OTTHUMG00000022532.8",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 139530739,
      stop : 139563459,
      direction : "+",
      ID : "ENSG00000101981.12",
      gene_id : "ENSG00000101981.12",
      gene_type : "protein_coding",
      gene_name : "F9",
      gene_level : 2,
      hgnc_id : "HGNC:3551",
      havana_gene : "OTTHUMG00000022536.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 139581770,
      stop : 139708227,
      direction : "-",
      ID : "ENSG00000101977.21",
      gene_id : "ENSG00000101977.21",
      gene_type : "protein_coding",
      gene_name : "MCF2",
      gene_level : 2,
      hgnc_id : "HGNC:6940",
      havana_gene : "OTTHUMG00000022537.6",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 139726346,
      stop : 139945276,
      direction : "-",
      ID : "ENSG00000101974.14",
      gene_id : "ENSG00000101974.14",
      gene_type : "protein_coding",
      gene_name : "ATP11C",
      gene_level : 2,
      hgnc_id : "HGNC:13554",
      havana_gene : "OTTHUMG00000022538.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 139955728,
      stop : 139965521,
      direction : "-",
      ID : "ENSG00000203933.3",
      gene_id : "ENSG00000203933.3",
      gene_type : "protein_coding",
      gene_name : "CXorf66",
      gene_level : 2,
      hgnc_id : "HGNC:33743",
      havana_gene : "OTTHUMG00000022539.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 140091415,
      stop : 140092911,
      direction : "+",
      ID : "ENSG00000230707.2",
      gene_id : "ENSG00000230707.2",
      gene_type : "protein_coding",
      gene_name : "AL589987.1",
      gene_level : 2,
      hgnc_id : "tag=retrogene",
      havana_gene : "OTTHUMG00000022542.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 140502985,
      stop : 140505069,
      direction : "-",
      ID : "ENSG00000134595.9",
      gene_id : "ENSG00000134595.9",
      gene_type : "protein_coding",
      gene_name : "SOX3",
      gene_level : 2,
      hgnc_id : "HGNC:11199",
      havana_gene : "OTTHUMG00000022544.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 140783578,
      stop : 140784366,
      direction : "-",
      ID : "ENSG00000288642.1",
      gene_id : "ENSG00000288642.1",
      gene_type : "protein_coding",
      gene_name : "CDR1",
      gene_level : 2,
      hgnc_id : "HGNC:1798",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141002594,
      stop : 141003706,
      direction : "+",
      ID : "ENSG00000227234.2",
      gene_id : "ENSG00000227234.2",
      gene_type : "protein_coding",
      gene_name : "SPANXB1",
      gene_level : 2,
      hgnc_id : "HGNC:14329",
      havana_gene : "OTTHUMG00000022554.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141111605,
      stop : 141177129,
      direction : "-",
      ID : "ENSG00000182195.9",
      gene_id : "ENSG00000182195.9",
      gene_type : "protein_coding",
      gene_name : "LDOC1",
      gene_level : 2,
      hgnc_id : "HGNC:6548",
      havana_gene : "OTTHUMG00000022558.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141241463,
      stop : 141242517,
      direction : "-",
      ID : "ENSG00000198573.7",
      gene_id : "ENSG00000198573.7",
      gene_type : "protein_coding",
      gene_name : "SPANXC",
      gene_level : 2,
      hgnc_id : "HGNC:14331",
      havana_gene : "OTTHUMG00000022556.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141583674,
      stop : 141585011,
      direction : "-",
      ID : "ENSG00000198021.7",
      gene_id : "ENSG00000198021.7",
      gene_type : "protein_coding",
      gene_name : "SPANXA1",
      gene_level : 2,
      hgnc_id : "HGNC:11218",
      havana_gene : "OTTHUMG00000022564.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141589708,
      stop : 141590762,
      direction : "+",
      ID : "ENSG00000203926.5",
      gene_id : "ENSG00000203926.5",
      gene_type : "protein_coding",
      gene_name : "SPANXA2",
      gene_level : 2,
      hgnc_id : "HGNC:14328",
      havana_gene : "OTTHUMG00000022565.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141697411,
      stop : 141698739,
      direction : "-",
      ID : "ENSG00000196406.4",
      gene_id : "ENSG00000196406.4",
      gene_type : "protein_coding",
      gene_name : "SPANXD",
      gene_level : 2,
      hgnc_id : "HGNC:14332",
      havana_gene : "OTTHUMG00000022563.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141838316,
      stop : 141897832,
      direction : "+",
      ID : "ENSG00000165509.13",
      gene_id : "ENSG00000165509.13",
      gene_type : "protein_coding",
      gene_name : "MAGEC3",
      gene_level : 2,
      hgnc_id : "HGNC:23798",
      havana_gene : "OTTHUMG00000022570.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 141903894,
      stop : 141909374,
      direction : "+",
      ID : "ENSG00000155495.9",
      gene_id : "ENSG00000155495.9",
      gene_type : "protein_coding",
      gene_name : "MAGEC1",
      gene_level : 2,
      hgnc_id : "HGNC:6812",
      havana_gene : "OTTHUMG00000022569.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 142202342,
      stop : 142205290,
      direction : "-",
      ID : "ENSG00000046774.10",
      gene_id : "ENSG00000046774.10",
      gene_type : "protein_coding",
      gene_name : "MAGEC2",
      gene_level : 2,
      hgnc_id : "HGNC:13574",
      havana_gene : "OTTHUMG00000022574.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 143025918,
      stop : 143034702,
      direction : "+",
      ID : "ENSG00000189326.4",
      gene_id : "ENSG00000189326.4",
      gene_type : "protein_coding",
      gene_name : "SPANXN4",
      gene_level : 1,
      hgnc_id : "HGNC:33177",
      havana_gene : "OTTHUMG00000022575.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 143508735,
      stop : 143517475,
      direction : "-",
      ID : "ENSG00000189252.4",
      gene_id : "ENSG00000189252.4",
      gene_type : "protein_coding",
      gene_name : "SPANXN3",
      gene_level : 2,
      hgnc_id : "HGNC:33176",
      havana_gene : "OTTHUMG00000022582.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 143622790,
      stop : 143636101,
      direction : "-",
      ID : "ENSG00000179542.16",
      gene_id : "ENSG00000179542.16",
      gene_type : "protein_coding",
      gene_name : "SLITRK4",
      gene_level : 2,
      hgnc_id : "HGNC:23502",
      havana_gene : "OTTHUMG00000022580.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 143711955,
      stop : 143721423,
      direction : "-",
      ID : "ENSG00000268988.1",
      gene_id : "ENSG00000268988.1",
      gene_type : "protein_coding",
      gene_name : "SPANXN2",
      gene_level : 2,
      hgnc_id : "HGNC:33175",
      havana_gene : "OTTHUMG00000022583.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 145247503,
      stop : 145256208,
      direction : "+",
      ID : "ENSG00000203923.5",
      gene_id : "ENSG00000203923.5",
      gene_type : "protein_coding",
      gene_name : "SPANXN1",
      gene_level : 2,
      hgnc_id : "HGNC:33174",
      havana_gene : "OTTHUMG00000022593.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 145817829,
      stop : 145829856,
      direction : "+",
      ID : "ENSG00000185985.11",
      gene_id : "ENSG00000185985.11",
      gene_type : "protein_coding",
      gene_name : "SLITRK2",
      gene_level : 2,
      hgnc_id : "HGNC:13449",
      havana_gene : "OTTHUMG00000022595.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 146809771,
      stop : 146810411,
      direction : "+",
      ID : "ENSG00000235699.3",
      gene_id : "ENSG00000235699.3",
      gene_type : "protein_coding",
      gene_name : "CXorf51B",
      gene_level : 2,
      hgnc_id : "HGNC:42787",
      havana_gene : "OTTHUMG00000022599.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 146814106,
      stop : 146814726,
      direction : "-",
      ID : "ENSG00000224440.1",
      gene_id : "ENSG00000224440.1",
      gene_type : "protein_coding",
      gene_name : "CXorf51A",
      gene_level : 2,
      hgnc_id : "HGNC:30533",
      havana_gene : "OTTHUMG00000022600.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 147911919,
      stop : 147951125,
      direction : "+",
      ID : "ENSG00000102081.15",
      gene_id : "ENSG00000102081.15",
      gene_type : "protein_coding",
      gene_name : "FMR1",
      gene_level : 2,
      hgnc_id : "HGNC:3775",
      havana_gene : "OTTHUMG00000022606.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 147981337,
      stop : 148026665,
      direction : "+",
      ID : "ENSG00000176988.9",
      gene_id : "ENSG00000176988.9",
      gene_type : "protein_coding",
      gene_name : "FMR1NB",
      gene_level : 2,
      hgnc_id : "HGNC:26372",
      havana_gene : "OTTHUMG00000022608.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 148500617,
      stop : 149000663,
      direction : "+",
      ID : "ENSG00000155966.14",
      gene_id : "ENSG00000155966.14",
      gene_type : "protein_coding",
      gene_name : "AFF2",
      gene_level : 2,
      hgnc_id : "HGNC:3776",
      havana_gene : "OTTHUMG00000022613.6",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149414886,
      stop : 149415495,
      direction : "-",
      ID : "ENSG00000287585.1",
      gene_id : "ENSG00000287585.1",
      gene_type : "protein_coding",
      gene_name : "AC231656.1",
      gene_level : 2,
      hgnc_id : "havana_gene=OTTHUMG00000193808.1",
      havana_gene : "",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149476988,
      stop : 149521096,
      direction : "-",
      ID : "ENSG00000010404.18",
      gene_id : "ENSG00000010404.18",
      gene_type : "protein_coding",
      gene_name : "IDS",
      gene_level : 2,
      hgnc_id : "HGNC:5389",
      havana_gene : "OTTHUMG00000022615.9",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149477104,
      stop : 149540926,
      direction : "-",
      ID : "ENSG00000241489.8",
      gene_id : "ENSG00000241489.8",
      gene_type : "protein_coding",
      gene_name : "AC244197.3",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000022618.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149540355,
      stop : 149550510,
      direction : "+",
      ID : "ENSG00000197620.11",
      gene_id : "ENSG00000197620.11",
      gene_type : "protein_coding",
      gene_name : "EOLA1",
      gene_level : 2,
      hgnc_id : "HGNC:28089",
      havana_gene : "OTTHUMG00000022622.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149548210,
      stop : 149549924,
      direction : "-",
      ID : "ENSG00000283697.3",
      gene_id : "ENSG00000283697.3",
      gene_type : "protein_coding",
      gene_name : "HSFX3",
      gene_level : 2,
      hgnc_id : "HGNC:52395",
      havana_gene : "OTTHUMG00000022623.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149581653,
      stop : 149587453,
      direction : "-",
      ID : "ENSG00000267978.5",
      gene_id : "ENSG00000267978.5",
      gene_type : "protein_coding",
      gene_name : "MAGEA9B",
      gene_level : 2,
      hgnc_id : "HGNC:31909",
      havana_gene : "OTTHUMG00000188533.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149592512,
      stop : 149595314,
      direction : "-",
      ID : "ENSG00000268738.3",
      gene_id : "ENSG00000268738.3",
      gene_type : "protein_coding",
      gene_name : "HSFX2",
      gene_level : 2,
      hgnc_id : "HGNC:32701",
      havana_gene : "OTTHUMG00000188526.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149596556,
      stop : 149631912,
      direction : "-",
      ID : "ENSG00000269556.8",
      gene_id : "ENSG00000269556.8",
      gene_type : "protein_coding",
      gene_name : "TMEM185A",
      gene_level : 2,
      hgnc_id : "HGNC:17125",
      havana_gene : "OTTHUMG00000022625.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149688228,
      stop : 149717268,
      direction : "+",
      ID : "ENSG00000185247.15",
      gene_id : "ENSG00000185247.15",
      gene_type : "protein_coding",
      gene_name : "MAGEA11",
      gene_level : 1,
      hgnc_id : "HGNC:6798",
      havana_gene : "OTTHUMG00000022633.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149774068,
      stop : 149776867,
      direction : "+",
      ID : "ENSG00000171116.7",
      gene_id : "ENSG00000171116.7",
      gene_type : "protein_coding",
      gene_name : "HSFX1",
      gene_level : 2,
      hgnc_id : "HGNC:29603",
      havana_gene : "OTTHUMG00000022626.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149781930,
      stop : 149787737,
      direction : "+",
      ID : "ENSG00000123584.7",
      gene_id : "ENSG00000123584.7",
      gene_type : "protein_coding",
      gene_name : "MAGEA9",
      gene_level : 2,
      hgnc_id : "HGNC:6807",
      havana_gene : "OTTHUMG00000022621.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149881141,
      stop : 149885835,
      direction : "+",
      ID : "ENSG00000156009.10",
      gene_id : "ENSG00000156009.10",
      gene_type : "protein_coding",
      gene_name : "MAGEA8",
      gene_level : 2,
      hgnc_id : "HGNC:6806",
      havana_gene : "OTTHUMG00000022635.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149929527,
      stop : 149938700,
      direction : "-",
      ID : "ENSG00000197021.9",
      gene_id : "ENSG00000197021.9",
      gene_type : "protein_coding",
      gene_name : "EOLA2",
      gene_level : 2,
      hgnc_id : "HGNC:17402",
      havana_gene : "OTTHUMG00000034327.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 149929573,
      stop : 149931287,
      direction : "+",
      ID : "ENSG00000283463.2",
      gene_id : "ENSG00000283463.2",
      gene_type : "protein_coding",
      gene_name : "HSFX4",
      gene_level : 2,
      hgnc_id : "HGNC:52398",
      havana_gene : "OTTHUMG00000034359.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 150361422,
      stop : 150514178,
      direction : "+",
      ID : "ENSG00000013619.14",
      gene_id : "ENSG00000013619.14",
      gene_type : "protein_coding",
      gene_name : "MAMLD1",
      gene_level : 2,
      hgnc_id : "HGNC:2568",
      havana_gene : "OTTHUMG00000024157.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 150568621,
      stop : 150673143,
      direction : "+",
      ID : "ENSG00000171100.15",
      gene_id : "ENSG00000171100.15",
      gene_type : "protein_coding",
      gene_name : "MTM1",
      gene_level : 2,
      hgnc_id : "HGNC:7448",
      havana_gene : "OTTHUMG00000024158.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 150692971,
      stop : 150765108,
      direction : "+",
      ID : "ENSG00000063601.17",
      gene_id : "ENSG00000063601.17",
      gene_type : "protein_coding",
      gene_name : "MTMR1",
      gene_level : 2,
      hgnc_id : "HGNC:7449",
      havana_gene : "OTTHUMG00000024159.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 150766336,
      stop : 150898816,
      direction : "-",
      ID : "ENSG00000102181.21",
      gene_id : "ENSG00000102181.21",
      gene_type : "protein_coding",
      gene_name : "CD99L2",
      gene_level : 2,
      hgnc_id : "HGNC:18237",
      havana_gene : "OTTHUMG00000024247.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 150980509,
      stop : 150990771,
      direction : "+",
      ID : "ENSG00000029993.15",
      gene_id : "ENSG00000029993.15",
      gene_type : "protein_coding",
      gene_name : "HMGB3",
      gene_level : 2,
      hgnc_id : "HGNC:5004",
      havana_gene : "OTTHUMG00000024162.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151176584,
      stop : 151181465,
      direction : "+",
      ID : "ENSG00000102195.10",
      gene_id : "ENSG00000102195.10",
      gene_type : "protein_coding",
      gene_name : "GPR50",
      gene_level : 2,
      hgnc_id : "HGNC:4506",
      havana_gene : "OTTHUMG00000024166.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151396515,
      stop : 151409364,
      direction : "+",
      ID : "ENSG00000160131.14",
      gene_id : "ENSG00000160131.14",
      gene_type : "protein_coding",
      gene_name : "VMA21",
      gene_level : 2,
      hgnc_id : "HGNC:22082",
      havana_gene : "OTTHUMG00000024168.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151563675,
      stop : 151676739,
      direction : "+",
      ID : "ENSG00000166049.11",
      gene_id : "ENSG00000166049.11",
      gene_type : "protein_coding",
      gene_name : "PASD1",
      gene_level : 2,
      hgnc_id : "HGNC:20686",
      havana_gene : "OTTHUMG00000024169.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151694607,
      stop : 151705924,
      direction : "+",
      ID : "ENSG00000130032.17",
      gene_id : "ENSG00000130032.17",
      gene_type : "protein_coding",
      gene_name : "PRRG3",
      gene_level : 2,
      hgnc_id : "HGNC:30798",
      havana_gene : "OTTHUMG00000024170.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151716035,
      stop : 151723194,
      direction : "+",
      ID : "ENSG00000147378.11",
      gene_id : "ENSG00000147378.11",
      gene_type : "protein_coding",
      gene_name : "FATE1",
      gene_level : 2,
      hgnc_id : "HGNC:24683",
      havana_gene : "OTTHUMG00000024172.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151738451,
      stop : 151745304,
      direction : "+",
      ID : "ENSG00000183862.5",
      gene_id : "ENSG00000183862.5",
      gene_type : "protein_coding",
      gene_name : "CNGA2",
      gene_level : 2,
      hgnc_id : "HGNC:2149",
      havana_gene : "OTTHUMG00000024173.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151912509,
      stop : 151925170,
      direction : "+",
      ID : "ENSG00000147381.11",
      gene_id : "ENSG00000147381.11",
      gene_type : "protein_coding",
      gene_name : "MAGEA4",
      gene_level : 2,
      hgnc_id : "HGNC:6802",
      havana_gene : "OTTHUMG00000024174.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 151953124,
      stop : 151974680,
      direction : "-",
      ID : "ENSG00000102287.19",
      gene_id : "ENSG00000102287.19",
      gene_type : "protein_coding",
      gene_name : "GABRE",
      gene_level : 2,
      hgnc_id : "HGNC:4085",
      havana_gene : "OTTHUMG00000024176.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152133310,
      stop : 152138578,
      direction : "-",
      ID : "ENSG00000124260.12",
      gene_id : "ENSG00000124260.12",
      gene_type : "protein_coding",
      gene_name : "MAGEA10",
      gene_level : 2,
      hgnc_id : "HGNC:6797",
      havana_gene : "OTTHUMG00000024180.6",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152166234,
      stop : 152451315,
      direction : "-",
      ID : "ENSG00000011677.13",
      gene_id : "ENSG00000011677.13",
      gene_type : "protein_coding",
      gene_name : "GABRA3",
      gene_level : 2,
      hgnc_id : "HGNC:4077",
      havana_gene : "OTTHUMG00000024183.4",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152637895,
      stop : 152657542,
      direction : "+",
      ID : "ENSG00000268089.3",
      gene_id : "ENSG00000268089.3",
      gene_type : "protein_coding",
      gene_name : "GABRQ",
      gene_level : 2,
      hgnc_id : "HGNC:14454",
      havana_gene : "OTTHUMG00000022649.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152698767,
      stop : 152702347,
      direction : "+",
      ID : "ENSG00000221867.9",
      gene_id : "ENSG00000221867.9",
      gene_type : "protein_coding",
      gene_name : "MAGEA3",
      gene_level : 2,
      hgnc_id : "HGNC:6801",
      havana_gene : "OTTHUMG00000022640.4",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152708261,
      stop : 152714549,
      direction : "-",
      ID : "ENSG00000268902.3",
      gene_id : "ENSG00000268902.3",
      gene_type : "protein_coding",
      gene_name : "CSAG2",
      gene_level : 2,
      hgnc_id : "HGNC:16847",
      havana_gene : "OTTHUMG00000022641.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152714586,
      stop : 152718607,
      direction : "+",
      ID : "ENSG00000183305.13",
      gene_id : "ENSG00000183305.13",
      gene_type : "protein_coding",
      gene_name : "MAGEA2B",
      gene_level : 2,
      hgnc_id : "HGNC:19340",
      havana_gene : "OTTHUMG00000022645.5",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152727484,
      stop : 152733735,
      direction : "-",
      ID : "ENSG00000198930.13",
      gene_id : "ENSG00000198930.13",
      gene_type : "protein_coding",
      gene_name : "CSAG1",
      gene_level : 2,
      hgnc_id : "HGNC:24294",
      havana_gene : "OTTHUMG00000022648.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152733757,
      stop : 152737669,
      direction : "+",
      ID : "ENSG00000213401.10",
      gene_id : "ENSG00000213401.10",
      gene_type : "protein_coding",
      gene_name : "MAGEA12",
      gene_level : 2,
      hgnc_id : "HGNC:6799",
      havana_gene : "OTTHUMG00000022650.5",
      tag : "overlapping_locus, retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152749863,
      stop : 152753884,
      direction : "-",
      ID : "ENSG00000268606.5",
      gene_id : "ENSG00000268606.5",
      gene_type : "protein_coding",
      gene_name : "MAGEA2",
      gene_level : 2,
      hgnc_id : "HGNC:6800",
      havana_gene : "OTTHUMG00000188622.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152753921,
      stop : 152760222,
      direction : "+",
      ID : "ENSG00000268916.6",
      gene_id : "ENSG00000268916.6",
      gene_type : "protein_coding",
      gene_name : "CSAG3",
      gene_level : 2,
      hgnc_id : "HGNC:26237",
      havana_gene : "OTTHUMG00000188381.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152766136,
      stop : 152769747,
      direction : "-",
      ID : "ENSG00000197172.10",
      gene_id : "ENSG00000197172.10",
      gene_type : "protein_coding",
      gene_name : "MAGEA6",
      gene_level : 2,
      hgnc_id : "HGNC:6804",
      havana_gene : "OTTHUMG00000022642.5",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152826994,
      stop : 152830757,
      direction : "-",
      ID : "ENSG00000147400.10",
      gene_id : "ENSG00000147400.10",
      gene_type : "protein_coding",
      gene_name : "CETN2",
      gene_level : 2,
      hgnc_id : "HGNC:1867",
      havana_gene : "OTTHUMG00000024246.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152830967,
      stop : 152869729,
      direction : "+",
      ID : "ENSG00000147383.11",
      gene_id : "ENSG00000147383.11",
      gene_type : "protein_coding",
      gene_name : "NSDHL",
      gene_level : 2,
      hgnc_id : "HGNC:13398",
      havana_gene : "OTTHUMG00000024185.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152914442,
      stop : 152973480,
      direction : "+",
      ID : "ENSG00000147394.18",
      gene_id : "ENSG00000147394.18",
      gene_type : "protein_coding",
      gene_name : "ZNF185",
      gene_level : 1,
      hgnc_id : "HGNC:12976",
      havana_gene : "OTTHUMG00000024187.12",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 152988824,
      stop : 152994116,
      direction : "-",
      ID : "ENSG00000198883.12",
      gene_id : "ENSG00000198883.12",
      gene_type : "protein_coding",
      gene_name : "PNMA5",
      gene_level : 2,
      hgnc_id : "HGNC:18743",
      havana_gene : "OTTHUMG00000024184.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153056409,
      stop : 153060467,
      direction : "+",
      ID : "ENSG00000183837.9",
      gene_id : "ENSG00000183837.9",
      gene_type : "protein_coding",
      gene_name : "PNMA3",
      gene_level : 2,
      hgnc_id : "HGNC:18742",
      havana_gene : "OTTHUMG00000024195.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153072454,
      stop : 153075019,
      direction : "+",
      ID : "ENSG00000235961.6",
      gene_id : "ENSG00000235961.6",
      gene_type : "protein_coding",
      gene_name : "PNMA6A",
      gene_level : 2,
      hgnc_id : "HGNC:28248",
      havana_gene : "OTTHUMG00000186485.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153179284,
      stop : 153183880,
      direction : "+",
      ID : "ENSG00000198681.7",
      gene_id : "ENSG00000198681.7",
      gene_type : "protein_coding",
      gene_name : "MAGEA1",
      gene_level : 2,
      hgnc_id : "HGNC:6796",
      havana_gene : "OTTHUMG00000024192.3",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153271618,
      stop : 153277803,
      direction : "+",
      ID : "ENSG00000278803.2",
      gene_id : "ENSG00000278803.2",
      gene_type : "protein_coding",
      gene_name : "PWWP4",
      gene_level : 2,
      hgnc_id : "HGNC:55197",
      havana_gene : "OTTHUMG00000188639.2",
      tag : "retrogene"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153317680,
      stop : 153321767,
      direction : "-",
      ID : "ENSG00000225110.3",
      gene_id : "ENSG00000225110.3",
      gene_type : "protein_coding",
      gene_name : "PNMA6F",
      gene_level : 2,
      hgnc_id : "HGNC:53119",
      havana_gene : "OTTHUMG00000067448.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153334147,
      stop : 153360110,
      direction : "+",
      ID : "ENSG00000063587.15",
      gene_id : "ENSG00000063587.15",
      gene_type : "protein_coding",
      gene_name : "ZNF275",
      gene_level : 2,
      hgnc_id : "HGNC:13069",
      havana_gene : "OTTHUMG00000067450.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153395639,
      stop : 153401392,
      direction : "-",
      ID : "ENSG00000214897.5",
      gene_id : "ENSG00000214897.5",
      gene_type : "protein_coding",
      gene_name : "PNMA6E",
      gene_level : 2,
      hgnc_id : "HGNC:50767",
      havana_gene : "OTTHUMG00000024197.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153418322,
      stop : 153426481,
      direction : "+",
      ID : "ENSG00000189420.8",
      gene_id : "ENSG00000189420.8",
      gene_type : "protein_coding",
      gene_name : "ZFP92",
      gene_level : 2,
      hgnc_id : "HGNC:12865",
      havana_gene : "OTTHUMG00000024198.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153444720,
      stop : 153470587,
      direction : "-",
      ID : "ENSG00000183479.12",
      gene_id : "ENSG00000183479.12",
      gene_type : "protein_coding",
      gene_name : "TREX2",
      gene_level : 2,
      hgnc_id : "HGNC:12270",
      havana_gene : "OTTHUMG00000159319.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153447666,
      stop : 153495516,
      direction : "-",
      ID : "ENSG00000213397.11",
      gene_id : "ENSG00000213397.11",
      gene_type : "protein_coding",
      gene_name : "HAUS7",
      gene_level : 2,
      hgnc_id : "HGNC:32979",
      havana_gene : "OTTHUMG00000159321.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153494980,
      stop : 153509546,
      direction : "+",
      ID : "ENSG00000182492.16",
      gene_id : "ENSG00000182492.16",
      gene_type : "protein_coding",
      gene_name : "BGN",
      gene_level : 2,
      hgnc_id : "HGNC:1044",
      havana_gene : "OTTHUMG00000024205.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153517676,
      stop : 153582939,
      direction : "+",
      ID : "ENSG00000067842.17",
      gene_id : "ENSG00000067842.17",
      gene_type : "protein_coding",
      gene_name : "ATP2B3",
      gene_level : 2,
      hgnc_id : "HGNC:816",
      havana_gene : "OTTHUMG00000024202.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153587925,
      stop : 153600045,
      direction : "-",
      ID : "ENSG00000262919.8",
      gene_id : "ENSG00000262919.8",
      gene_type : "protein_coding",
      gene_name : "CCNQ",
      gene_level : 2,
      hgnc_id : "HGNC:28434",
      havana_gene : "OTTHUMG00000024206.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153642492,
      stop : 153651326,
      direction : "+",
      ID : "ENSG00000130829.18",
      gene_id : "ENSG00000130829.18",
      gene_type : "protein_coding",
      gene_name : "DUSP9",
      gene_level : 2,
      hgnc_id : "HGNC:3076",
      havana_gene : "OTTHUMG00000024211.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153669733,
      stop : 153689010,
      direction : "-",
      ID : "ENSG00000130822.16",
      gene_id : "ENSG00000130822.16",
      gene_type : "protein_coding",
      gene_name : "PNCK",
      gene_level : 1,
      hgnc_id : "HGNC:13415",
      havana_gene : "OTTHUMG00000024216.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153687926,
      stop : 153696588,
      direction : "+",
      ID : "ENSG00000130821.17",
      gene_id : "ENSG00000130821.17",
      gene_type : "protein_coding",
      gene_name : "SLC6A8",
      gene_level : 2,
      hgnc_id : "HGNC:11055",
      havana_gene : "OTTHUMG00000024208.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153700492,
      stop : 153724565,
      direction : "-",
      ID : "ENSG00000185825.17",
      gene_id : "ENSG00000185825.17",
      gene_type : "protein_coding",
      gene_name : "BCAP31",
      gene_level : 2,
      hgnc_id : "HGNC:16695",
      havana_gene : "OTTHUMG00000024218.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153724856,
      stop : 153744755,
      direction : "+",
      ID : "ENSG00000101986.12",
      gene_id : "ENSG00000101986.12",
      gene_type : "protein_coding",
      gene_name : "ABCD1",
      gene_level : 2,
      hgnc_id : "HGNC:61",
      havana_gene : "OTTHUMG00000024215.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153764196,
      stop : 153779346,
      direction : "+",
      ID : "ENSG00000198753.12",
      gene_id : "ENSG00000198753.12",
      gene_type : "protein_coding",
      gene_name : "PLXNB3",
      gene_level : 2,
      hgnc_id : "HGNC:9105",
      havana_gene : "OTTHUMG00000024217.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153776412,
      stop : 153785732,
      direction : "+",
      ID : "ENSG00000184343.11",
      gene_id : "ENSG00000184343.11",
      gene_type : "protein_coding",
      gene_name : "SRPK3",
      gene_level : 1,
      hgnc_id : "HGNC:11402",
      havana_gene : "OTTHUMG00000024207.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153785766,
      stop : 153794523,
      direction : "-",
      ID : "ENSG00000067829.19",
      gene_id : "ENSG00000067829.19",
      gene_type : "protein_coding",
      gene_name : "IDH3G",
      gene_level : 2,
      hgnc_id : "HGNC:5386",
      havana_gene : "OTTHUMG00000024219.31",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153793516,
      stop : 153798499,
      direction : "+",
      ID : "ENSG00000180879.14",
      gene_id : "ENSG00000180879.14",
      gene_type : "protein_coding",
      gene_name : "SSR4",
      gene_level : 2,
      hgnc_id : "HGNC:11326",
      havana_gene : "OTTHUMG00000024212.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153802166,
      stop : 153830565,
      direction : "-",
      ID : "ENSG00000067840.12",
      gene_id : "ENSG00000067840.12",
      gene_type : "protein_coding",
      gene_name : "PDZD4",
      gene_level : 2,
      hgnc_id : "HGNC:21167",
      havana_gene : "OTTHUMG00000024209.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153861514,
      stop : 153886173,
      direction : "-",
      ID : "ENSG00000198910.14",
      gene_id : "ENSG00000198910.14",
      gene_type : "protein_coding",
      gene_name : "L1CAM",
      gene_level : 1,
      hgnc_id : "HGNC:6470",
      havana_gene : "OTTHUMG00000192414.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153872221,
      stop : 153909223,
      direction : "-",
      ID : "ENSG00000284987.1",
      gene_id : "ENSG00000284987.1",
      gene_type : "protein_coding",
      gene_name : "U52112.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000024221.15",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153902531,
      stop : 153907166,
      direction : "+",
      ID : "ENSG00000126895.15",
      gene_id : "ENSG00000126895.15",
      gene_type : "protein_coding",
      gene_name : "AVPR2",
      gene_level : 2,
      hgnc_id : "HGNC:897",
      havana_gene : "OTTHUMG00000024227.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153907367,
      stop : 153934999,
      direction : "-",
      ID : "ENSG00000089820.16",
      gene_id : "ENSG00000089820.16",
      gene_type : "protein_coding",
      gene_name : "ARHGAP4",
      gene_level : 2,
      hgnc_id : "HGNC:674",
      havana_gene : "OTTHUMG00000024226.47",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153929225,
      stop : 153935080,
      direction : "-",
      ID : "ENSG00000102030.16",
      gene_id : "ENSG00000102030.16",
      gene_type : "protein_coding",
      gene_name : "NAA10",
      gene_level : 1,
      hgnc_id : "HGNC:18704",
      havana_gene : "OTTHUMG00000024225.8",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153935269,
      stop : 153944687,
      direction : "-",
      ID : "ENSG00000102032.13",
      gene_id : "ENSG00000102032.13",
      gene_type : "protein_coding",
      gene_name : "RENBP",
      gene_level : 2,
      hgnc_id : "HGNC:9959",
      havana_gene : "OTTHUMG00000024224.10",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153947557,
      stop : 153971818,
      direction : "-",
      ID : "ENSG00000172534.14",
      gene_id : "ENSG00000172534.14",
      gene_type : "protein_coding",
      gene_name : "HCFC1",
      gene_level : 1,
      hgnc_id : "HGNC:4839",
      havana_gene : "OTTHUMG00000024222.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 153972754,
      stop : 153983194,
      direction : "+",
      ID : "ENSG00000177854.8",
      gene_id : "ENSG00000177854.8",
      gene_type : "protein_coding",
      gene_name : "TMEM187",
      gene_level : 2,
      hgnc_id : "HGNC:13705",
      havana_gene : "OTTHUMG00000024220.7",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154010506,
      stop : 154019902,
      direction : "-",
      ID : "ENSG00000184216.14",
      gene_id : "ENSG00000184216.14",
      gene_type : "protein_coding",
      gene_name : "IRAK1",
      gene_level : 1,
      hgnc_id : "HGNC:6112",
      havana_gene : "OTTHUMG00000024228.46",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154021573,
      stop : 154137103,
      direction : "-",
      ID : "ENSG00000169057.24",
      gene_id : "ENSG00000169057.24",
      gene_type : "protein_coding",
      gene_name : "MECP2",
      gene_level : 2,
      hgnc_id : "HGNC:6990",
      havana_gene : "OTTHUMG00000024229.17",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154144243,
      stop : 154159032,
      direction : "+",
      ID : "ENSG00000102076.10",
      gene_id : "ENSG00000102076.10",
      gene_type : "protein_coding",
      gene_name : "OPN1LW",
      gene_level : 1,
      hgnc_id : "HGNC:9936",
      havana_gene : "OTTHUMG00000034295.7",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154182596,
      stop : 154196861,
      direction : "+",
      ID : "ENSG00000268221.6",
      gene_id : "ENSG00000268221.6",
      gene_type : "protein_coding",
      gene_name : "OPN1MW",
      gene_level : 2,
      hgnc_id : "HGNC:4206",
      havana_gene : "OTTHUMG00000022652.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154219756,
      stop : 154233286,
      direction : "+",
      ID : "ENSG00000166160.9",
      gene_id : "ENSG00000166160.9",
      gene_type : "protein_coding",
      gene_name : "OPN1MW2",
      gene_level : 2,
      hgnc_id : "HGNC:26952",
      havana_gene : "OTTHUMG00000024231.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154257538,
      stop : 154271805,
      direction : "+",
      ID : "ENSG00000269433.3",
      gene_id : "ENSG00000269433.3",
      gene_type : "protein_coding",
      gene_name : "OPN1MW3",
      gene_level : 2,
      hgnc_id : "HGNC:51831",
      havana_gene : "OTTHUMG00000189499.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154271265,
      stop : 154295853,
      direction : "-",
      ID : "ENSG00000278057.4",
      gene_id : "ENSG00000278057.4",
      gene_type : "protein_coding",
      gene_name : "TEX28",
      gene_level : 2,
      hgnc_id : "HGNC:2563",
      havana_gene : "OTTHUMG00000022654.8",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154295795,
      stop : 154330350,
      direction : "+",
      ID : "ENSG00000007350.17",
      gene_id : "ENSG00000007350.17",
      gene_type : "protein_coding",
      gene_name : "TKTL1",
      gene_level : 1,
      hgnc_id : "HGNC:11835",
      havana_gene : "OTTHUMG00000022707.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154348524,
      stop : 154374634,
      direction : "-",
      ID : "ENSG00000196924.19",
      gene_id : "ENSG00000196924.19",
      gene_type : "protein_coding",
      gene_name : "FLNA",
      gene_level : 1,
      hgnc_id : "HGNC:3754",
      havana_gene : "OTTHUMG00000022712.33",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154379273,
      stop : 154381523,
      direction : "+",
      ID : "ENSG00000102119.11",
      gene_id : "ENSG00000102119.11",
      gene_type : "protein_coding",
      gene_name : "EMD",
      gene_level : 2,
      hgnc_id : "HGNC:3331",
      havana_gene : "OTTHUMG00000033186.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154389955,
      stop : 154409168,
      direction : "+",
      ID : "ENSG00000147403.18",
      gene_id : "ENSG00000147403.18",
      gene_type : "protein_coding",
      gene_name : "RPL10",
      gene_level : 1,
      hgnc_id : "HGNC:10298",
      havana_gene : "OTTHUMG00000033189.13",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154401236,
      stop : 154412112,
      direction : "-",
      ID : "ENSG00000013563.14",
      gene_id : "ENSG00000013563.14",
      gene_type : "protein_coding",
      gene_name : "DNASE1L1",
      gene_level : 1,
      hgnc_id : "HGNC:2957",
      havana_gene : "OTTHUMG00000033188.30",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154411524,
      stop : 154421726,
      direction : "+",
      ID : "ENSG00000102125.16",
      gene_id : "ENSG00000102125.16",
      gene_type : "protein_coding",
      gene_name : "TAZ",
      gene_level : 2,
      hgnc_id : "HGNC:11577",
      havana_gene : "OTTHUMG00000033190.38",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154428633,
      stop : 154436516,
      direction : "+",
      ID : "ENSG00000071553.18",
      gene_id : "ENSG00000071553.18",
      gene_type : "protein_coding",
      gene_name : "ATP6AP1",
      gene_level : 1,
      hgnc_id : "HGNC:868",
      havana_gene : "OTTHUMG00000033291.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154436913,
      stop : 154443467,
      direction : "+",
      ID : "ENSG00000203879.12",
      gene_id : "ENSG00000203879.12",
      gene_type : "protein_coding",
      gene_name : "GDI1",
      gene_level : 2,
      hgnc_id : "HGNC:4226",
      havana_gene : "OTTHUMG00000033293.10",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154444141,
      stop : 154450654,
      direction : "+",
      ID : "ENSG00000071859.15",
      gene_id : "ENSG00000071859.15",
      gene_type : "protein_coding",
      gene_name : "FAM50A",
      gene_level : 1,
      hgnc_id : "HGNC:18786",
      havana_gene : "OTTHUMG00000033292.12",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154458281,
      stop : 154477779,
      direction : "+",
      ID : "ENSG00000130827.6",
      gene_id : "ENSG00000130827.6",
      gene_type : "protein_coding",
      gene_name : "PLXNA3",
      gene_level : 2,
      hgnc_id : "HGNC:9101",
      havana_gene : "OTTHUMG00000033290.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154477769,
      stop : 154479257,
      direction : "-",
      ID : "ENSG00000196976.7",
      gene_id : "ENSG00000196976.7",
      gene_type : "protein_coding",
      gene_name : "LAGE3",
      gene_level : 2,
      hgnc_id : "HGNC:26058",
      havana_gene : "OTTHUMG00000033294.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154483717,
      stop : 154486615,
      direction : "-",
      ID : "ENSG00000102178.13",
      gene_id : "ENSG00000102178.13",
      gene_type : "protein_coding",
      gene_name : "UBL4A",
      gene_level : 2,
      hgnc_id : "HGNC:12505",
      havana_gene : "OTTHUMG00000013370.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154487306,
      stop : 154490690,
      direction : "-",
      ID : "ENSG00000126903.16",
      gene_id : "ENSG00000126903.16",
      gene_type : "protein_coding",
      gene_name : "SLC10A3",
      gene_level : 2,
      hgnc_id : "HGNC:22979",
      havana_gene : "OTTHUMG00000013369.9",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154506159,
      stop : 154516242,
      direction : "-",
      ID : "ENSG00000071889.17",
      gene_id : "ENSG00000071889.17",
      gene_type : "protein_coding",
      gene_name : "FAM3A",
      gene_level : 2,
      hgnc_id : "HGNC:13749",
      havana_gene : "OTTHUMG00000013418.20",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154531391,
      stop : 154547572,
      direction : "-",
      ID : "ENSG00000160211.19",
      gene_id : "ENSG00000160211.19",
      gene_type : "protein_coding",
      gene_name : "G6PD",
      gene_level : 1,
      hgnc_id : "HGNC:4057",
      havana_gene : "OTTHUMG00000024237.13",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154541199,
      stop : 154565046,
      direction : "+",
      ID : "ENSG00000269335.6",
      gene_id : "ENSG00000269335.6",
      gene_type : "protein_coding",
      gene_name : "IKBKG",
      gene_level : 2,
      hgnc_id : "HGNC:5961",
      havana_gene : "OTTHUMG00000024234.17",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154585133,
      stop : 154586816,
      direction : "+",
      ID : "ENSG00000268651.4",
      gene_id : "ENSG00000268651.4",
      gene_type : "protein_coding",
      gene_name : "CTAG1A",
      gene_level : 2,
      hgnc_id : "HGNC:24198",
      havana_gene : "OTTHUMG00000024238.4",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154617609,
      stop : 154619282,
      direction : "-",
      ID : "ENSG00000184033.13",
      gene_id : "ENSG00000184033.13",
      gene_type : "protein_coding",
      gene_name : "CTAG1B",
      gene_level : 2,
      hgnc_id : "HGNC:2491",
      havana_gene : "OTTHUMG00000024232.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154651972,
      stop : 154653579,
      direction : "-",
      ID : "ENSG00000126890.13",
      gene_id : "ENSG00000126890.13",
      gene_type : "protein_coding",
      gene_name : "CTAG2",
      gene_level : 2,
      hgnc_id : "HGNC:2492",
      havana_gene : "OTTHUMG00000024239.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154675249,
      stop : 154751583,
      direction : "-",
      ID : "ENSG00000160219.12",
      gene_id : "ENSG00000160219.12",
      gene_type : "protein_coding",
      gene_name : "GAB3",
      gene_level : 1,
      hgnc_id : "HGNC:17515",
      havana_gene : "OTTHUMG00000024245.11",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154762742,
      stop : 154777689,
      direction : "+",
      ID : "ENSG00000130826.18",
      gene_id : "ENSG00000130826.18",
      gene_type : "protein_coding",
      gene_name : "DKC1",
      gene_level : 1,
      hgnc_id : "HGNC:2890",
      havana_gene : "OTTHUMG00000024242.11",
      tag : "ncRNA_host"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154778684,
      stop : 154821007,
      direction : "-",
      ID : "ENSG00000130830.15",
      gene_id : "ENSG00000130830.15",
      gene_type : "protein_coding",
      gene_name : "MPP1",
      gene_level : 2,
      hgnc_id : "HGNC:7219",
      havana_gene : "OTTHUMG00000024244.10",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154823348,
      stop : 154834662,
      direction : "-",
      ID : "ENSG00000203870.5",
      gene_id : "ENSG00000203870.5",
      gene_type : "protein_coding",
      gene_name : "SMIM9",
      gene_level : 1,
      hgnc_id : "HGNC:41915",
      havana_gene : "OTTHUMG00000024243.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154835788,
      stop : 155026940,
      direction : "-",
      ID : "ENSG00000185010.15",
      gene_id : "ENSG00000185010.15",
      gene_type : "protein_coding",
      gene_name : "F8",
      gene_level : 1,
      hgnc_id : "HGNC:3546",
      havana_gene : "OTTHUMG00000022688.16",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154884972,
      stop : 154885558,
      direction : "+",
      ID : "ENSG00000274183.2",
      gene_id : "ENSG00000274183.2",
      gene_type : "protein_coding",
      gene_name : "H2AB1",
      gene_level : 2,
      hgnc_id : "HGNC:22516",
      havana_gene : "OTTHUMG00000034291.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 154886349,
      stop : 154888061,
      direction : "+",
      ID : "ENSG00000277203.1",
      gene_id : "ENSG00000277203.1",
      gene_type : "protein_coding",
      gene_name : "F8A1",
      gene_level : 2,
      hgnc_id : "HGNC:3547",
      havana_gene : "OTTHUMG00000013500.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155025980,
      stop : 155060304,
      direction : "+",
      ID : "ENSG00000165775.18",
      gene_id : "ENSG00000165775.18",
      gene_type : "protein_coding",
      gene_name : "FUNDC2",
      gene_level : 2,
      hgnc_id : "HGNC:24925",
      havana_gene : "OTTHUMG00000013504.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155061622,
      stop : 155065519,
      direction : "-",
      ID : "ENSG00000288258.1",
      gene_id : "ENSG00000288258.1",
      gene_type : "protein_coding",
      gene_name : "BX470111.1",
      gene_level : 2,
      hgnc_id : "tag=overlapping_locus",
      havana_gene : "OTTHUMG00000156241.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155061622,
      stop : 155071136,
      direction : "-",
      ID : "ENSG00000182712.16",
      gene_id : "ENSG00000182712.16",
      gene_type : "protein_coding",
      gene_name : "CMC4",
      gene_level : 2,
      hgnc_id : "HGNC:35428",
      havana_gene : "OTTHUMG00000158504.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155064034,
      stop : 155147937,
      direction : "-",
      ID : "ENSG00000214827.11",
      gene_id : "ENSG00000214827.11",
      gene_type : "protein_coding",
      gene_name : "MTCP1",
      gene_level : 2,
      hgnc_id : "HGNC:7423",
      havana_gene : "OTTHUMG00000195895.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155071420,
      stop : 155123077,
      direction : "+",
      ID : "ENSG00000185515.15",
      gene_id : "ENSG00000185515.15",
      gene_type : "protein_coding",
      gene_name : "BRCC3",
      gene_level : 2,
      hgnc_id : "HGNC:24185",
      havana_gene : "OTTHUMG00000022658.6",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155197007,
      stop : 155239841,
      direction : "+",
      ID : "ENSG00000155959.12",
      gene_id : "ENSG00000155959.12",
      gene_type : "protein_coding",
      gene_name : "VBP1",
      gene_level : 2,
      hgnc_id : "HGNC:12662",
      havana_gene : "OTTHUMG00000022666.5",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155258235,
      stop : 155264491,
      direction : "-",
      ID : "ENSG00000155961.5",
      gene_id : "ENSG00000155961.5",
      gene_type : "protein_coding",
      gene_name : "RAB39B",
      gene_level : 2,
      hgnc_id : "HGNC:16499",
      havana_gene : "OTTHUMG00000022659.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155276211,
      stop : 155334657,
      direction : "-",
      ID : "ENSG00000155962.13",
      gene_id : "ENSG00000155962.13",
      gene_type : "protein_coding",
      gene_name : "CLIC2",
      gene_level : 1,
      hgnc_id : "HGNC:2063",
      havana_gene : "OTTHUMG00000022660.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155380709,
      stop : 155381299,
      direction : "+",
      ID : "ENSG00000277858.2",
      gene_id : "ENSG00000277858.2",
      gene_type : "protein_coding",
      gene_name : "H2AB2",
      gene_level : 2,
      hgnc_id : "HGNC:18298",
      havana_gene : "OTTHUMG00000034292.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155382115,
      stop : 155383230,
      direction : "+",
      ID : "ENSG00000274791.1",
      gene_id : "ENSG00000274791.1",
      gene_type : "protein_coding",
      gene_name : "F8A2",
      gene_level : 2,
      hgnc_id : "HGNC:31849",
      havana_gene : "OTTHUMG00000034293.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155456914,
      stop : 155458620,
      direction : "-",
      ID : "ENSG00000277150.2",
      gene_id : "ENSG00000277150.2",
      gene_type : "protein_coding",
      gene_name : "F8A3",
      gene_level : 2,
      hgnc_id : "HGNC:31850",
      havana_gene : "OTTHUMG00000034289.1",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155459415,
      stop : 155460005,
      direction : "-",
      ID : "ENSG00000277745.1",
      gene_id : "ENSG00000277745.1",
      gene_type : "protein_coding",
      gene_name : "H2AB3",
      gene_level : 2,
      hgnc_id : "HGNC:14455",
      havana_gene : "OTTHUMG00000022670.2",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155489011,
      stop : 155719098,
      direction : "-",
      ID : "ENSG00000185973.12",
      gene_id : "ENSG00000185973.12",
      gene_type : "protein_coding",
      gene_name : "TMLHE",
      gene_level : 2,
      hgnc_id : "HGNC:18308",
      havana_gene : "OTTHUMG00000022674.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155612572,
      stop : 155782459,
      direction : "+",
      ID : "ENSG00000168939.12",
      gene_id : "ENSG00000168939.12",
      gene_type : "protein_coding",
      gene_name : "SPRY3",
      gene_level : 2,
      hgnc_id : "HGNC:11271",
      havana_gene : "OTTHUMG00000022675.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155881345,
      stop : 155943769,
      direction : "+",
      ID : "ENSG00000124333.16",
      gene_id : "ENSG00000124333.16",
      gene_type : "protein_coding",
      gene_name : "VAMP7",
      gene_level : 2,
      hgnc_id : "HGNC:11486",
      havana_gene : "OTTHUMG00000022679.3",
      tag : null
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 155997581,
      stop : 156010817,
      direction : "+",
      ID : "ENSG00000124334.17",
      gene_id : "ENSG00000124334.17",
      gene_type : "protein_coding",
      gene_name : "IL9R",
      gene_level : 2,
      hgnc_id : "HGNC:6030",
      havana_gene : "OTTHUMG00000022720.1",
      tag : "overlapping_locus"
    },
    {
      chromosome : "X",
      annotation : "HAVANA",
      type : "gene",
      start : 156020826,
      stop : 156025710,
      direction : "+",
      ID : "ENSG00000182484.15",
      gene_id : "ENSG00000182484.15",
      gene_type : "protein_coding",
      gene_name : "WASH6P",
      gene_level : 2,
      hgnc_id : "HGNC:31685",
      havana_gene : "OTTHUMG00000022677.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 276322,
      stop : 303356,
      direction : "+",
      ID : "ENSG00000182378.15_PAR_Y",
      gene_id : "ENSG00000182378.15",
      gene_type : "protein_coding",
      gene_name : "PLCXD1",
      gene_level : 2,
      hgnc_id : "HGNC:23148",
      havana_gene : "OTTHUMG00000022693.6",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 304529,
      stop : 318819,
      direction : "-",
      ID : "ENSG00000178605.13_PAR_Y",
      gene_id : "ENSG00000178605.13",
      gene_type : "protein_coding",
      gene_name : "GTPBP6",
      gene_level : 2,
      hgnc_id : "HGNC:30189",
      havana_gene : "OTTHUMG00000022694.3",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 333933,
      stop : 386955,
      direction : "-",
      ID : "ENSG00000167393.18_PAR_Y",
      gene_id : "ENSG00000167393.18",
      gene_type : "protein_coding",
      gene_name : "PPP2R3B",
      gene_level : 2,
      hgnc_id : "HGNC:13417",
      havana_gene : "OTTHUMG00000021052.4",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 624344,
      stop : 659411,
      direction : "+",
      ID : "ENSG00000185960.14_PAR_Y",
      gene_id : "ENSG00000185960.14",
      gene_type : "protein_coding",
      gene_name : "SHOX",
      gene_level : 2,
      hgnc_id : "HGNC:10853",
      havana_gene : "OTTHUMG00000021053.5",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1187549,
      stop : 1212723,
      direction : "-",
      ID : "ENSG00000205755.12_PAR_Y",
      gene_id : "ENSG00000205755.12",
      gene_type : "protein_coding",
      gene_name : "CRLF2",
      gene_level : 2,
      hgnc_id : "HGNC:14281",
      havana_gene : "OTTHUMG00000067432.3",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1268800,
      stop : 1310381,
      direction : "+",
      ID : "ENSG00000198223.17_PAR_Y",
      gene_id : "ENSG00000198223.17",
      gene_type : "protein_coding",
      gene_name : "CSF2RA",
      gene_level : 2,
      hgnc_id : "HGNC:2435",
      havana_gene : "OTTHUMG00000012533.8",
      tag : "ncRNA_host, PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1336616,
      stop : 1382689,
      direction : "+",
      ID : "ENSG00000185291.12_PAR_Y",
      gene_id : "ENSG00000185291.12",
      gene_type : "protein_coding",
      gene_name : "IL3RA",
      gene_level : 2,
      hgnc_id : "HGNC:6012",
      havana_gene : "OTTHUMG00000021059.5",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1386152,
      stop : 1392113,
      direction : "-",
      ID : "ENSG00000169100.14_PAR_Y",
      gene_id : "ENSG00000169100.14",
      gene_type : "protein_coding",
      gene_name : "SLC25A6",
      gene_level : 2,
      hgnc_id : "HGNC:10992",
      havana_gene : "OTTHUMG00000021058.2",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1403139,
      stop : 1453762,
      direction : "-",
      ID : "ENSG00000169093.16_PAR_Y",
      gene_id : "ENSG00000169093.16",
      gene_type : "protein_coding",
      gene_name : "ASMTL",
      gene_level : 2,
      hgnc_id : "HGNC:751",
      havana_gene : "OTTHUMG00000021057.2",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1462581,
      stop : 1537185,
      direction : "-",
      ID : "ENSG00000182162.11_PAR_Y",
      gene_id : "ENSG00000182162.11",
      gene_type : "protein_coding",
      gene_name : "P2RY8",
      gene_level : 2,
      hgnc_id : "HGNC:15524",
      havana_gene : "OTTHUMG00000021060.3",
      tag : "retrogene, PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1591604,
      stop : 1602520,
      direction : "+",
      ID : "ENSG00000197976.12_PAR_Y",
      gene_id : "ENSG00000197976.12",
      gene_type : "protein_coding",
      gene_name : "AKAP17A",
      gene_level : 2,
      hgnc_id : "HGNC:18783",
      havana_gene : "OTTHUMG00000021063.4",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 1615059,
      stop : 1643081,
      direction : "+",
      ID : "ENSG00000196433.13_PAR_Y",
      gene_id : "ENSG00000196433.13",
      gene_type : "protein_coding",
      gene_name : "ASMT",
      gene_level : 2,
      hgnc_id : "HGNC:750",
      havana_gene : "OTTHUMG00000021065.3",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 2219506,
      stop : 2502805,
      direction : "-",
      ID : "ENSG00000169084.15_PAR_Y",
      gene_id : "ENSG00000169084.15",
      gene_type : "protein_coding",
      gene_name : "DHRSX",
      gene_level : 2,
      hgnc_id : "HGNC:18399",
      havana_gene : "OTTHUMG00000021068.6",
      tag : "overlapping_locus, PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 2486414,
      stop : 2500976,
      direction : "-",
      ID : "ENSG00000214717.12_PAR_Y",
      gene_id : "ENSG00000214717.12",
      gene_type : "protein_coding",
      gene_name : "ZBED1",
      gene_level : 2,
      hgnc_id : "HGNC:447",
      havana_gene : "OTTHUMG00000021069.10",
      tag : "overlapping_locus, PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 2691187,
      stop : 2741309,
      direction : "+",
      ID : "ENSG00000002586.20_PAR_Y",
      gene_id : "ENSG00000002586.20",
      gene_type : "protein_coding",
      gene_name : "CD99",
      gene_level : 2,
      hgnc_id : "HGNC:7082",
      havana_gene : "OTTHUMG00000021073.12",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 2786855,
      stop : 2787682,
      direction : "-",
      ID : "ENSG00000184895.8",
      gene_id : "ENSG00000184895.8",
      gene_type : "protein_coding",
      gene_name : "SRY",
      gene_level : 2,
      hgnc_id : "HGNC:11311",
      havana_gene : "OTTHUMG00000036084.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 2841602,
      stop : 2932000,
      direction : "+",
      ID : "ENSG00000129824.16",
      gene_id : "ENSG00000129824.16",
      gene_type : "protein_coding",
      gene_name : "RPS4Y1",
      gene_level : 2,
      hgnc_id : "HGNC:10425",
      havana_gene : "OTTHUMG00000036152.5",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 2935281,
      stop : 2982506,
      direction : "+",
      ID : "ENSG00000067646.12",
      gene_id : "ENSG00000067646.12",
      gene_type : "protein_coding",
      gene_name : "ZFY",
      gene_level : 2,
      hgnc_id : "HGNC:12870",
      havana_gene : "OTTHUMG00000036159.5",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 3579067,
      stop : 3580041,
      direction : "+",
      ID : "ENSG00000176679.9",
      gene_id : "ENSG00000176679.9",
      gene_type : "protein_coding",
      gene_name : "TGIF2LY",
      gene_level : 2,
      hgnc_id : "HGNC:18569",
      havana_gene : "OTTHUMG00000036153.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 5000226,
      stop : 5742224,
      direction : "+",
      ID : "ENSG00000099715.14",
      gene_id : "ENSG00000099715.14",
      gene_type : "protein_coding",
      gene_name : "PCDH11Y",
      gene_level : 2,
      hgnc_id : "HGNC:15813",
      havana_gene : "OTTHUMG00000035105.6",
      tag : "ncRNA_host, overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 6246223,
      stop : 6249019,
      direction : "+",
      ID : "ENSG00000168757.12",
      gene_id : "ENSG00000168757.12",
      gene_type : "protein_coding",
      gene_name : "TSPY2",
      gene_level : 2,
      hgnc_id : "HGNC:23924",
      havana_gene : "OTTHUMG00000040957.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 6865918,
      stop : 6911774,
      direction : "-",
      ID : "ENSG00000099721.14",
      gene_id : "ENSG00000099721.14",
      gene_type : "protein_coding",
      gene_name : "AMELY",
      gene_level : 2,
      hgnc_id : "HGNC:462",
      havana_gene : "OTTHUMG00000035297.4",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 6910686,
      stop : 7101970,
      direction : "+",
      ID : "ENSG00000092377.15",
      gene_id : "ENSG00000092377.15",
      gene_type : "protein_coding",
      gene_name : "TBL1Y",
      gene_level : 2,
      hgnc_id : "HGNC:18502",
      havana_gene : "OTTHUMG00000035299.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 9337464,
      stop : 9340284,
      direction : "+",
      ID : "ENSG00000233803.9",
      gene_id : "ENSG00000233803.9",
      gene_type : "protein_coding",
      gene_name : "TSPY4",
      gene_level : 2,
      hgnc_id : "HGNC:37287",
      havana_gene : "OTTHUMG00000041529.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 9357797,
      stop : 9360599,
      direction : "+",
      ID : "ENSG00000229549.9",
      gene_id : "ENSG00000229549.9",
      gene_type : "protein_coding",
      gene_name : "TSPY8",
      gene_level : 2,
      hgnc_id : "HGNC:37471",
      havana_gene : "OTTHUMG00000041531.1",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 9398421,
      stop : 9401223,
      direction : "+",
      ID : "ENSG00000228927.10",
      gene_id : "ENSG00000228927.10",
      gene_type : "protein_coding",
      gene_name : "TSPY3",
      gene_level : 2,
      hgnc_id : "HGNC:33876",
      havana_gene : "OTTHUMG00000041535.1",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 9466955,
      stop : 9469749,
      direction : "+",
      ID : "ENSG00000258992.7",
      gene_id : "ENSG00000258992.7",
      gene_type : "protein_coding",
      gene_name : "TSPY1",
      gene_level : 2,
      hgnc_id : "HGNC:12381",
      havana_gene : "OTTHUMG00000171452.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 9487313,
      stop : 9489893,
      direction : "+",
      ID : "ENSG00000238074.5",
      gene_id : "ENSG00000238074.5",
      gene_type : "protein_coding",
      gene_name : "TSPY9P",
      gene_level : 2,
      hgnc_id : "HGNC:37472",
      havana_gene : "OTTHUMG00000187491.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 9527880,
      stop : 9530682,
      direction : "+",
      ID : "ENSG00000236424.7",
      gene_id : "ENSG00000236424.7",
      gene_type : "protein_coding",
      gene_name : "TSPY10",
      gene_level : 2,
      hgnc_id : "HGNC:37473",
      havana_gene : "OTTHUMG00000041524.1",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 12537650,
      stop : 12860839,
      direction : "+",
      ID : "ENSG00000114374.13",
      gene_id : "ENSG00000114374.13",
      gene_type : "protein_coding",
      gene_name : "USP9Y",
      gene_level : 2,
      hgnc_id : "HGNC:12633",
      havana_gene : "OTTHUMG00000036469.3",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 12904108,
      stop : 12920478,
      direction : "+",
      ID : "ENSG00000067048.17",
      gene_id : "ENSG00000067048.17",
      gene_type : "protein_coding",
      gene_name : "DDX3Y",
      gene_level : 2,
      hgnc_id : "HGNC:2699",
      havana_gene : "OTTHUMG00000036324.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 13248379,
      stop : 13480673,
      direction : "-",
      ID : "ENSG00000183878.15",
      gene_id : "ENSG00000183878.15",
      gene_type : "protein_coding",
      gene_name : "UTY",
      gene_level : 2,
      hgnc_id : "HGNC:12638",
      havana_gene : "OTTHUMG00000036319.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 13703899,
      stop : 13706024,
      direction : "+",
      ID : "ENSG00000154620.6",
      gene_id : "ENSG00000154620.6",
      gene_type : "protein_coding",
      gene_name : "TMSB4Y",
      gene_level : 2,
      hgnc_id : "HGNC:11882",
      havana_gene : "OTTHUMG00000036366.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 13985772,
      stop : 13986513,
      direction : "-",
      ID : "ENSG00000129864.6",
      gene_id : "ENSG00000129864.6",
      gene_type : "protein_coding",
      gene_name : "VCY",
      gene_level : 2,
      hgnc_id : "HGNC:12668",
      havana_gene : "OTTHUMG00000036401.1",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 14056227,
      stop : 14056958,
      direction : "+",
      ID : "ENSG00000129862.7",
      gene_id : "ENSG00000129862.7",
      gene_type : "protein_coding",
      gene_name : "VCY1B",
      gene_level : 2,
      hgnc_id : "HGNC:31751",
      havana_gene : "OTTHUMG00000036402.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 14522573,
      stop : 14845650,
      direction : "+",
      ID : "ENSG00000165246.14",
      gene_id : "ENSG00000165246.14",
      gene_type : "protein_coding",
      gene_name : "NLGN4Y",
      gene_level : 2,
      hgnc_id : "HGNC:15529",
      havana_gene : "OTTHUMG00000036618.4",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 17878260,
      stop : 17880220,
      direction : "-",
      ID : "ENSG00000129873.8",
      gene_id : "ENSG00000129873.8",
      gene_type : "protein_coding",
      gene_name : "CDY2B",
      gene_level : 2,
      hgnc_id : "HGNC:23921",
      havana_gene : "OTTHUMG00000041652.3",
      tag : "retrogene"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 18025787,
      stop : 18027746,
      direction : "+",
      ID : "ENSG00000182415.11",
      gene_id : "ENSG00000182415.11",
      gene_type : "protein_coding",
      gene_name : "CDY2A",
      gene_level : 2,
      hgnc_id : "HGNC:1810",
      havana_gene : "OTTHUMG00000041657.3",
      tag : "retrogene"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 18546691,
      stop : 18588963,
      direction : "+",
      ID : "ENSG00000172468.14",
      gene_id : "ENSG00000172468.14",
      gene_type : "protein_coding",
      gene_name : "HSFY1",
      gene_level : 2,
      hgnc_id : "HGNC:18568",
      havana_gene : "OTTHUMG00000041980.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 18731440,
      stop : 18773735,
      direction : "-",
      ID : "ENSG00000169953.12",
      gene_id : "ENSG00000169953.12",
      gene_type : "protein_coding",
      gene_name : "HSFY2",
      gene_level : 2,
      hgnc_id : "HGNC:23950",
      havana_gene : "OTTHUMG00000041947.2",
      tag : "overlapping_locus"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 19703865,
      stop : 19744939,
      direction : "-",
      ID : "ENSG00000012817.16",
      gene_id : "ENSG00000012817.16",
      gene_type : "protein_coding",
      gene_name : "KDM5D",
      gene_level : 2,
      hgnc_id : "HGNC:11115",
      havana_gene : "OTTHUMG00000036508.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 20575776,
      stop : 20593154,
      direction : "+",
      ID : "ENSG00000198692.10",
      gene_id : "ENSG00000198692.10",
      gene_type : "protein_coding",
      gene_name : "EIF1AY",
      gene_level : 2,
      hgnc_id : "HGNC:3252",
      havana_gene : "OTTHUMG00000036544.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 20756108,
      stop : 20781032,
      direction : "+",
      ID : "ENSG00000280969.2",
      gene_id : "ENSG00000280969.2",
      gene_type : "protein_coding",
      gene_name : "RPS4Y2",
      gene_level : 2,
      hgnc_id : "HGNC:18501",
      havana_gene : "OTTHUMG00000036540.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 21511338,
      stop : 21549094,
      direction : "+",
      ID : "ENSG00000242875.6",
      gene_id : "ENSG00000242875.6",
      gene_type : "protein_coding",
      gene_name : "RBMY1B",
      gene_level : 2,
      hgnc_id : "HGNC:23914",
      havana_gene : "OTTHUMG00000042045.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 21511372,
      stop : 21549326,
      direction : "+",
      ID : "ENSG00000234414.7",
      gene_id : "ENSG00000234414.7",
      gene_type : "protein_coding",
      gene_name : "RBMY1A1",
      gene_level : 2,
      hgnc_id : "HGNC:9912",
      havana_gene : "OTTHUMG00000043592.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 21880076,
      stop : 21894526,
      direction : "-",
      ID : "ENSG00000244395.6",
      gene_id : "ENSG00000244395.6",
      gene_type : "protein_coding",
      gene_name : "RBMY1D",
      gene_level : 2,
      hgnc_id : "HGNC:23915",
      havana_gene : "OTTHUMG00000043598.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 21903618,
      stop : 21918067,
      direction : "-",
      ID : "ENSG00000242389.8",
      gene_id : "ENSG00000242389.8",
      gene_type : "protein_coding",
      gene_name : "RBMY1E",
      gene_level : 2,
      hgnc_id : "HGNC:23916",
      havana_gene : "OTTHUMG00000043602.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 22071756,
      stop : 22096007,
      direction : "-",
      ID : "ENSG00000169807.10",
      gene_id : "ENSG00000169807.10",
      gene_type : "protein_coding",
      gene_name : "PRY2",
      gene_level : 2,
      hgnc_id : "HGNC:21504",
      havana_gene : "OTTHUMG00000043586.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 22168542,
      stop : 22182982,
      direction : "-",
      ID : "ENSG00000169800.14",
      gene_id : "ENSG00000169800.14",
      gene_type : "protein_coding",
      gene_name : "RBMY1F",
      gene_level : 2,
      hgnc_id : "HGNC:23974",
      havana_gene : "OTTHUMG00000043593.1",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 22403461,
      stop : 22417881,
      direction : "+",
      ID : "ENSG00000226941.8",
      gene_id : "ENSG00000226941.8",
      gene_type : "protein_coding",
      gene_name : "RBMY1J",
      gene_level : 2,
      hgnc_id : "HGNC:23917",
      havana_gene : "OTTHUMG00000043594.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 22490397,
      stop : 22514637,
      direction : "+",
      ID : "ENSG00000169789.10",
      gene_id : "ENSG00000169789.10",
      gene_type : "protein_coding",
      gene_name : "PRY",
      gene_level : 2,
      hgnc_id : "HGNC:14024",
      havana_gene : "OTTHUMG00000043845.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 22973819,
      stop : 23005465,
      direction : "+",
      ID : "ENSG00000183753.10",
      gene_id : "ENSG00000183753.10",
      gene_type : "protein_coding",
      gene_name : "BPY2",
      gene_level : 2,
      hgnc_id : "HGNC:13508",
      havana_gene : "OTTHUMG00000058899.5",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 23129355,
      stop : 23199094,
      direction : "-",
      ID : "ENSG00000188120.15",
      gene_id : "ENSG00000188120.15",
      gene_type : "protein_coding",
      gene_name : "DAZ1",
      gene_level : 2,
      hgnc_id : "HGNC:2682",
      havana_gene : "OTTHUMG00000044053.1",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 23219434,
      stop : 23291356,
      direction : "+",
      ID : "ENSG00000205944.11",
      gene_id : "ENSG00000205944.11",
      gene_type : "protein_coding",
      gene_name : "DAZ2",
      gene_level : 2,
      hgnc_id : "HGNC:15964",
      havana_gene : "OTTHUMG00000044060.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 23681440,
      stop : 23694579,
      direction : "-",
      ID : "ENSG00000169763.15",
      gene_id : "ENSG00000169763.15",
      gene_type : "protein_coding",
      gene_name : "PRYP3",
      gene_level : 2,
      hgnc_id : "HGNC:34020",
      havana_gene : "OTTHUMG00000044998.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 24045229,
      stop : 24048019,
      direction : "-",
      ID : "ENSG00000172352.5",
      gene_id : "ENSG00000172352.5",
      gene_type : "protein_coding",
      gene_name : "CDY1B",
      gene_level : 2,
      hgnc_id : "HGNC:23920",
      havana_gene : "OTTHUMG00000045037.1",
      tag : "retrogene"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 24607560,
      stop : 24639207,
      direction : "+",
      ID : "ENSG00000183795.8",
      gene_id : "ENSG00000183795.8",
      gene_type : "protein_coding",
      gene_name : "BPY2B",
      gene_level : 2,
      hgnc_id : "HGNC:25449",
      havana_gene : "OTTHUMG00000045101.4",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 24763069,
      stop : 24813492,
      direction : "-",
      ID : "ENSG00000187191.14",
      gene_id : "ENSG00000187191.14",
      gene_type : "protein_coding",
      gene_name : "DAZ3",
      gene_level : 2,
      hgnc_id : "HGNC:15965",
      havana_gene : "OTTHUMG00000045099.2",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 24833843,
      stop : 24907040,
      direction : "+",
      ID : "ENSG00000205916.11",
      gene_id : "ENSG00000205916.11",
      gene_type : "protein_coding",
      gene_name : "DAZ4",
      gene_level : 2,
      hgnc_id : "HGNC:15966",
      havana_gene : "OTTHUMG00000045100.7",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 25030901,
      stop : 25062548,
      direction : "-",
      ID : "ENSG00000185894.8",
      gene_id : "ENSG00000185894.8",
      gene_type : "protein_coding",
      gene_name : "BPY2C",
      gene_level : 2,
      hgnc_id : "HGNC:18225",
      havana_gene : "OTTHUMG00000045199.3",
      tag : null
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 25622162,
      stop : 25624902,
      direction : "+",
      ID : "ENSG00000172288.7",
      gene_id : "ENSG00000172288.7",
      gene_type : "protein_coding",
      gene_name : "CDY1",
      gene_level : 2,
      hgnc_id : "HGNC:1809",
      havana_gene : "OTTHUMG00000045274.2",
      tag : "retrogene"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 57067865,
      stop : 57130289,
      direction : "+",
      ID : "ENSG00000124333.16_PAR_Y",
      gene_id : "ENSG00000124333.16",
      gene_type : "protein_coding",
      gene_name : "VAMP7",
      gene_level : 2,
      hgnc_id : "HGNC:11486",
      havana_gene : "OTTHUMG00000022679.3",
      tag : "PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 57184101,
      stop : 57197337,
      direction : "+",
      ID : "ENSG00000124334.17_PAR_Y",
      gene_id : "ENSG00000124334.17",
      gene_type : "protein_coding",
      gene_name : "IL9R",
      gene_level : 2,
      hgnc_id : "HGNC:6030",
      havana_gene : "OTTHUMG00000022720.1",
      tag : "overlapping_locus, PAR"
    },
    {
      chromosome : "Y",
      annotation : "HAVANA",
      type : "gene",
      start : 57207346,
      stop : 57212230,
      direction : "+",
      ID : "ENSG00000182484.15_PAR_Y",
      gene_id : "ENSG00000182484.15",
      gene_type : "protein_coding",
      gene_name : "WASH6P",
      gene_level : 2,
      hgnc_id : "HGNC:31685",
      havana_gene : "OTTHUMG00000022677.5",
      tag : "overlapping_locus, PAR"
    }]
export default havana